webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = {"my":{"country":"Malaysia","language":"malay","lang_code":"ms","flag_rec":"https://i.imgur.com/odFDO6D.png","flag_cir":"https://i.imgur.com/8Z2R6kR.png","flag_squareCurved":"https://i.imgur.com/BTRyse9.png","button_text":"Bahasa Malaysia","prefix":"60"},"iq":{"country":"Iraq","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/k2zXSI1.png","flag_cir":"https://i.imgur.com/dLwKCXA.png","flag_squareCurved":"https://i.imgur.com/uG9Eug2.png","button_text":"العربية","prefix":"964"},"bh":{"country":"Bahrain","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/onLyxKv.png","flag_cir":"https://i.imgur.com/jEpg6KF.png","flag_squareCurved":"https://i.imgur.com/pbgBr0l.png","button_text":"العربية","prefix":"973"},"kw":{"country":"Kuwait","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/7L0VyI8.png","flag_cir":"https://i.imgur.com/8Z2R6kR.png","flag_squareCurved":"https://i.imgur.com/gL0XlFk.png","button_text":"العربية","prefix":"965"},"ae":{"country":"United Arab Emirates","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/SIFFa8L.png","flag_cir":"https://i.imgur.com/VJCTFik.png","flag_squareCurved":"https://i.imgur.com/uXeaKDi.png","button_text":"العربية","prefix":"971"},"gr":{"country":"Greece","language":"greek","lang_code":"el","flag_rec":"https://i.imgur.com/rNFcmpN.png","flag_cir":"https://i.imgur.com/G93tDJZ.png","flag_squareCurved":"https://i.imgur.com/IEg8dMF.png","button_text":"ελληνικά","prefix":"30"},"id":{"country":"Indonesia","language":"indonesian","lang_code":"id","flag_rec":"https://i.imgur.com/Y5dTFap.png","flag_cir":"https://i.imgur.com/u3nSXlY.png","flag_squareCurved":"https://i.imgur.com/fC1VL44.png","button_text":"Bahasa Indonesia","prefix":"62"},"th":{"country":"Thailand","language":"thai","lang_code":"th","flag_rec":"https://i.imgur.com/Gh8KMEt.png","flag_cir":"https://i.imgur.com/sZzwsDT.png","flag_squareCurved":"https://i.imgur.com/AssJH3B.png","button_text":"ไทย","prefix":"66"},"eg":{"country":"Egypt","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/bKjc4fP.png","flag_cir":"https://i.imgur.com/XjiV1Vr.png","flag_squareCurved":"https://i.imgur.com/qUoQSiz.png","button_text":"العربية","prefix":"20"},"tn":{"country":"Tunisia","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/AMfes8z.png","flag_cir":"https://i.imgur.com/MyTnNBM.png","flag_squareCurved":"https://i.imgur.com/YLLkN0D.png","button_text":"العربية","prefix":"216"},"om":{"country":"Oman","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/S7rLPDZ.png","flag_cir":"https://i.imgur.com/FZbdZ8n.png","flag_squareCurved":"https://i.imgur.com/uBEMkTC.png","button_text":"العربية","prefix":"968"},"ke":{"country":"Kenya","language":"english","lang_code":"en","flag_rec":"https://i.imgur.com/2FzHzUS.png","flag_cir":"https://i.imgur.com/ByEmt9o.png","flag_squareCurved":"https://i.imgur.com/uXeaKDi.png","button_text":"English","prefix":"254"},"qa":{"country":"Qatar","language":"arabic","lang_code":"ar","flag_rec":"https://i.imgur.com/ThPQ8Ux.png","flag_cir":"https://i.imgur.com/rQowc20.png","flag_squareCurved":"https://i.imgur.com/GmjxGBX.png","button_text":"العربية","prefix":"974"},"cz":{"country":"Czech Republic","language":"czech","lang_code":"cs","flag_rec":"https://i.imgur.com/VqNojFt.png","flag_cir":"https://i.imgur.com/3N9ABs0.png","flag_squareCurved":"https://i.imgur.com/Bf24Xiv.png","button_text":"Czech","prefix":"420"},"bg":{"country":"Bulgaria","language":"bulgarian","lang_code":"bg","flag_rec":"https://imgur.com/hyVZXKC.jpg","flag_cir":"https://imgur.com/wBZnksp.jpg","flag_squareCurved":"https://imgur.com/UQWT3Qd.jpg","button_text":"Bulgarian","prefix":"359"},"no":{"country":"Norway","language":"norwegian","lang_code":"no","flag_rec":"https://i.imgur.com/nW08K6Z.jpg","flag_cir":"https://i.imgur.com/L0HtywV.jpg","flag_squareCurved":"https://imgur.com/pXreslJ.jpg","button_text":"Norwegian","prefix":"47"},"da":{"country":"Denmark","language":"denmark","lang_code":"da","flag_rec":"https://cdn.grabmobitraffic.com/4468/denmark3.webp","flag_cir":"https://cdn.grabmobitraffic.com/4466/cir-denmark.webp","flag_squareCurved":"https://cdn.grabmobitraffic.com/4467/denmark2.webp","button_text":"Denmark","prefix":""},"sk":{"country":"Slovakia","language":"slovakia","lang_code":"sk","flag_rec":"https://cdn.grabmobitraffic.com/4471/square.webp","flag_cir":"https://cdn.grabmobitraffic.com/4469/icon.webp","flag_squareCurved":"https://cdn.grabmobitraffic.com/4470/radius.webp","button_text":"Slovakia","prefix":"420"},"se":{"country":"Sweden","language":"swedish","lang_code":"se","flag_rec":"https://cdn.grabmobitraffic.com/flags/ser.png","flag_cir":"https://cdn.grabmobitraffic.com/flags/sec.png","flag_squareCurved":"https://cdn.grabmobitraffic.com/flags/ses.png","button_text":"Swedish","prefix":""},"fi":{"country":"Finland","language":"finnish","lang_code":"fi","flag_rec":"https://cdn.grabmobitraffic.com/flags/fir.png","flag_cir":"https://cdn.grabmobitraffic.com/flags/fic.pngp","flag_squareCurved":"https://cdn.grabmobitraffic.com/flags/fis.png","button_text":"Finnish","prefix":""},"ro":{"country":"Romania","language":"romanian","lang_code":"ro","flag_rec":"https://cdn.grabmobitraffic.com/flags/ror.png","flag_cir":"https://cdn.grabmobitraffic.com/flags/roc.png","flag_squareCurved":"https://cdn.grabmobitraffic.com/flags/ros.png","button_text":"Romanian","prefix":""},"jo":{"country":"Jordhan","language":"arabic","lang_code":"ar","flag_rec":"https://cdn.grabmobitraffic.com/flags/jo-rec.jpg","flag_cir":"https://cdn.grabmobitraffic.com/flags/jo-cir.jpg","flag_squareCurved":"https://cdn.grabmobitraffic.com/flags/jo-sq.png","button_text":"العربية","prefix":"962"},"sa":{"country":"Saudi Arabia","language":"arabic","lang_code":"ar","flag_rec":"https://cdn.grabmobitraffic.com/flags/sa-flag.png","flag_cir":"https://cdn.grabmobitraffic.com/flags/sa-round.png","flag_squareCurved":"https://cdn.grabmobitraffic.com/flags/sa-square.png","button_text":"العربية","prefix":"966"},"ps":{"country":"Palestine","language":"arabic","lang_code":"ar","flag_rec":"https://cdn.grabmobitraffic.com/flags/ps-flag.png","flag_cir":"https://cdn.grabmobitraffic.com/flags/ps-round.png","flag_squareCurved":"https://cdn.grabmobitraffic.com/flags/ps-square.png","button_text":"العربية","prefix":"970"}}

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjAyM0Q1ODU3NjhENDExRUFBQjFGOUEwNzRFREYyNDE1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjAyM0Q1ODU4NjhENDExRUFBQjFGOUEwNzRFREYyNDE1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDIzRDU4NTU2OEQ0MTFFQUFCMUY5QTA3NEVERjI0MTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDIzRDU4NTY2OEQ0MTFFQUFCMUY5QTA3NEVERjI0MTUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7loyeVAAAQb0lEQVR42uxdW2wcVxn+57Jrx7ETiJMmTZumatPaCSokrhrEnZL2BbWUpwqhCiF4QVRI8MQDPCCkSn2gD6BKfULi8gJUPFRCFRe1UkuvcZuk5GqHNGluTuNLHK+9l9mZOcwZ7y6zs+fyz+wZ72x8fulo1rvjTTz/d/7/+/9z/vMbADAaDLsxrGAUmq9fe/juH907XPwBaOlbWXC8X336H+eeDV56jeFHrn5T6VZE+U0A2B4J39PSx+IRYjZ0SyLDaA76YfMGOzIoCIrTpdqH+hH2t8xU3dMRHTf13QRA2wdWBAihJZiteVX9CPtblup+qaFXgzXMmPKjlqBQJ8TWj7C/xfWJyZj5RvPz5pvNG+woCH55cvaUfoT9LU+9e2UyonSTZwGiw4oNLf0tcQsAcQvAA0BoBQITsqKfYb9GAFASmf+mBTBibqANCHOOd1E/yv6UsutP8RTf/NmOvWEyIoNbWoa2mH35/66WCPh1grmVqfim2LzwoAmGBceb3zF46wYDVtHoy/+3YciVv+L5MxwL0EYQ4uiIskVztubNa2OaQ//uyAGwVA8BIGWIRowdxl4TQz/uvhaDxf5ZFoD1S8bViqstQM6EENx9F1acaYwFEJKHD5cdDYCcCZL8wc3VNHAbdlgAIJEPiOhmLf1pMAS6JCbjxrbx92srl/Qz7E8X8OLlpSnGhI7qt80CMMf5FWdZP/K8uQDcfW/NlZcEFr6NAxCkydDSny6A59KJyTMN0Z8vV+rT+jnmyAJ48vl5s+4dYSifsFwASG7UkjsApCKATIJvCpTfurnmkbJ+7P0ljg8ljBuQkkB608Vy/bJ+pDmyAK7cMC847lmWLuOT25b5f9VuwBw/AObYRC4epGmZMDC6ITeK9aYnwZ06LLfrvvy7DDBkOgzfszmKbzMbM1V3TtlDD5RvPfG9XDzwQqEAA5s35wYA1T8/C4AAAEbmHfeqjADKOEDrxvMK08GkXNI2nGfaL5+RWwkHZ5Avl0MAEAwHAJ7vz8INkEtntabXNgcgygO0WQAeEMjJpdqcfpZrYAHmrsg12l0auEPHJif0azMbr8+WlQGAzF3TmuYBYF4OgARp4JKA33W4gDg6fJnvSA+AGa3ptTP/INCfcDGow1TM1TydC8gyBLx0BqdVhA9Ydv2z2NDeZJl8Fnmo+r6ybCC5qIlgh1Rw0ZGHcAEeISWs5eZtCCEYBpkaABW9wryGLoAI3AERhYFtIDhbcvSKYIbiIhNABLESeK3qHhG4ACYHAMkvqLUAZ45qjaeNFBArgbE0MAgivA4XADziEBALvSLYJ1L1/BIv7o+DwZQovoWW/yxW9d7ALKOA6Un57Hdxhvj0qrsmiFCwbTFI5gKUuQF/6ghYkG5BiEYQqkikZ9ngbRnOB2MLt+9J7vFx32VKZn0cACz26EMsKZSXdLD7p1+Dr4hD0IjK3nHr1b9+sFi9KogMpLuCWWTBV5oOLuswMJXFcnD3/e7C4lXAWQFiClCSXTq4i0SQses+jQR8DkD6uWhLWEdoWHL9npeJGUMj61er6dLAQitgCpDTwSJv1tWViutFoRQuQE0amBkGijaBZLI3kMynWxY2xg9oJOBdgDQUNEGc+YtGA3Cl4upcQE9dgPyeBcebBlwamFsY4nPQQsquX+k1ETQ2DK9bAGDKwh2fLAMyDcwigcCY+T5kUSGUMhQ07tJRgPD5gMHb/iV1AQCSTOBbc+Up/Yh7NPuR5WBHF6vvg3h9h5kH4JGFTNPBqVG+9fb15/893KM3E1Z68/YEMhU/53i5WBE0tu7QJoEjgY5KIK4GYhaGiHYFtV6/eGlJnxraqxyAi7vvmVOzU4BLAhGeBQBIkElK7QK6WNAxRtefCwAffSdJ8rktYYwdliEIMypF0+hpRaX9/Z+Fo1uhtYGbelwbSEvlSj/+rJLvqvlkhmfqRRxAWBQSB8H1msJkkF4VRNUDUnERNYHV1aNhCYLXMUkgelFI2R+v6wQzMSocfRGMBeClg1s/33B8fXCkykmAqAcMHz5i6pU9chUZvqMKQ4B1nau5ekVQJQDmcQDApIGX6t41kKeBhauBsihAcdCqC0WV5kf+vx0cAFncY0pIQ4dFOL1U07kAlfE9oiYQWxJ+foW5GxhAUhwKAtLQgaYbjqdsRdDXNYKomkDs4dBLdX9JMJG5YSAI/ASBLOsEK/q4mAyjAGkSiBcFCF3BC+dunNHPWJ1gagKxK4E/OXbtPcAV+rZey8rDs00HaxeAm9LJTgYFQG4GYbkAkSVoCU0HK/nLdCZQnSUhZFmifBBFASSB6VCbDl7PEQCiHjC8D1ETuOL604A48k8WBq5pKjh0A1O6VFxq15OtBKLTwFRsDvMXsUqlh0f7b7zcs/MCiGVCTcFRsYXPfxPM0TuS//uIglCsLLtkRsDnuDzAFnAA7qCHR987XNyvxAy++XJPZ1dNQXFo8dB3MksChfc5mIogbwYRrqM3hWYeAdxKkodyNcbh0Ki9gaJNodzYUeXh0etZMAtB2DRw43Bo9G5gVhgoCwEzOTy638UeO5ieg8xflYOknuhwaEgaCsr2BMJaRQNa1PBalXkALifQvQQjsiG9//cunVbmAhA9Apl6ThoFhJ+p7iVY+Onz6R7gS79VdlxMWrF2jaefrmXMSiDuuzA9AkV5AEBygUxMvzmWruSbjE30HAA5dAHoEJDlAtDpYN1LsLsQEJsGVtkjEEMCAQT7AbOyAqnPDMpBiZi1a2+2oaLXtQVAbQghSOW3vlRlOjjtuX/rsUiUJY0egdL+QICoCwAJCdS9BOMgHN2Z6vewh0On7BEIWEvA2xQq9P+Qk8OjjdHeu4A0i0CJnk3yHoEAuE2hHS4Ak0duXfNweHQ/uwCV7fNiPQITrd9gj4nr+EKVh0f3ay/BbnIAKnsEXiy7M0gO0PG+aFdwX/QS7OWZQcbQplwA0exi57aJUCgTCHk5PNoY6s9Tw1T2CIwdDi0i8x33mBhlM37Rz0svQfPAl3tiBegq4MDjT6cHgMIegbHDoQEQy8CtvwNwJ0rktpeg9eiT4aA7jL2jr4cRBd1nqLrwlLJ9e/+hQPEPgXX/wbydWUzSfm4j435uL8GtA9aduXgEgSuwvvB1ADoaoPKP/jtcKwhPJEu4BZ0qmCq6ECjdCpSuMtzLuEdgoijAToCcji9b7SWopuECTQerNOU0RGxZB1jdfUwaYOAtIFGzbu//Wqj4bhi+VHrUI1AGAGwImE0yqLIMRpZMma44BiNsVRNYAwoEMnUMituGQrNOzXsfC6pHIA8AaRTf6iV454bC/X33uAJ3Qclj4eAhGOzBIVG96hEoSgQRVYjqxgVoiUUBinsEigAAkkRP9MDo1kHShkoQ6DrBVCLoEYiapLw8gMgltL74zbmy3hSSJgpYmx6BiZeDZUAAyOnh0beiZNEjkGcBZJk/ViIofJ2Xw6P7TrkKawKT9AhkWQHsYhCTBKo8PJr2ElwPRJAmgTCJoCx6BIryANh0cGa5AKp85xffDRM4NGY3J74UXCfCkK2/Z3sJ3GOvgDt9OLxmsPRNuvncFvh+VHqY9hIcsc1RZX/N3Ax4dDSqhml20KILPuMHUm8f7wXJqx99JbgeRqd9O54DIg3cOBy6q8lpJ4zxmb0EVQKAZRlc6hpeaiRwAquwah0O5GZHEF3ZC2f51GR4VQIiRBq4cTi0TF+Q1ALIzD5Ar2oEaQr36OvhCK0DdRcHAjBQ6xBYibU063R21wNle4HSsce9ZvXfkURuUgAQhBsAEPQS7FU6OHQX//pLOEJG2wBCaB0U7xGgppzObmresancrv42fI9AWXiOah8v6xmwJr0EuzbFdLWvsdLXJJOUO1AOkZRM0llNZ3eG5E387+N7BPqQMg0scgGyXoK5LxFvkkkIyKQLz6DIpArytpaStEcgBgCAdAmtQXsJPnzbxsdyH44xyKRx8GFwBl2l5E3J7M+oRyAWACBJAmWWDl5rMlkNRmGHlT+wZtQjkPMdzJnNA0P2LWW1oEXQIzBRYYiswaBwvHDuxmmtCsWJJHyPwDOQLA2MLg4VAUFbgcxJQKIcAHbtBh0FYIYXUb5f90m5YBpDWnNd6Nwl4DoAbpWgSsI4aeDEfMBOMOv9iOLbXl+veZfu2GCPaTUmS/Q0le3WSJLzgFcBsNohzOeE52irbAtIQ9zM+zEwNEHgmYZ2Ayjf3lA2nenY8/8QzoIIQJC6LoDn91tKj75edLzZ2wftca3iznieKjxUfFXtHKl4/hWO8hOJjVR8fObTQbkqDaKthQAAWt2rZr2pbHpNeL5PIll2/bgLSJWpbS4GGcBfCYzO+uZoKt9uuAB/3c5ySt6qq719sfX8KqThdj0ODwBApoWjHMAQkD9fAATzbMk597nR9REE0FntOenJmyq5WnFPMfSTOBS0GopnDZPxOnptfT5TdRc/88nBwQHLKA5a5if6SaEDwyaKvNXLBGrLBJySHyred3uTAaGtYWZr3svPTc//9dyys8LgZFFASAHAUroVudqRUWiMYmMMNK6FyLXwyPaNOx/bOfLApzYN7NszXHww7/mBEcZaQJbkLanQZlDBbH/j/Ipz5DfTC6++u1Ch5zI4jVFvDDcy4mAQcgJDAILoKHBAUIy8Fx1N0FjfumvzPY/vHHkwAMN4HnMFFABrSd4wMltzT5xact5+Y3blaKNPY1PRDkf5dYZ7RpFCHgDMGBDiVqAQA0MUIFGr0fzd8Lvu2Vgc+fbuzXu/uHVoYvfGwliWewnRZKpgqIrJuzHrs4E5P3xssXrijx/dPHZ6qXYzptx6DAQuY/Z7DBeABgBwAGBGFGgLgBB932KAwIq4lpab+cq2oW0BIB7cu2lgLABHf2z5VSA0dU5J3Ps3KpN/m1k+/s9ryzMRJUYVGgVBHAyuRPk+JhJgAYAFgqglsBhKZ816iwMAi/H94fjhni37Ht2+8cA9gbsYLVq7biWl33C8j86UapPvzFdOPDc1fzzmp6NRlRcDgMdQeD12n4eICBIBoDmsyNWKWIL4LGcpnKd8iwOwtvcC63BbQCb3PrB5cHxspLi/3xabqFm/XKmfOnmzdur5/y68M11ySsBfT/EYCvUYVsGNveczAJDoTKcoAEDCB0wGCHjKthDKtwQg6ADEk7s23f3EHSMTe4YHxvK68PRx1T31wWL1vddmy8d/f2HxQ4HCfQZb9wSDBQwfMfOl+QBDcI3H+yYjTOQpWPTaTAgCK/Z/oGRyOA9kks7ys8vOZEDeTv78+PV3kQoXAYC51sIAiM+Y9SK/T0R5AJBYAVYCyBQoCvtaBgLZ7605mWSQt48RiuXNVCxYeN9HQL4aCGkBkAYImBGdzZbknqRAao2n92zZ+8j2jRMqyCSHvMlmtc9JyMR/5gEDM2SKTwQAGQh4biEOBhY4eO9ZDNdiKLAmbUD96m0btz2+c2TfA5sHxu8bLk7IyGSTvL09Xzn8hwuLJxrkzUswe32EYgnnPY/xGeEo3Ucu/khTwazXIl7AWivgrRfw1g9kAMFaBZk1iP774d/w1O7Nu7+xc+She4eLe7cP2vvomxfL9cmzJefkq9dXTkTIG1bZPnImE47p5vlw3iz3Qd7nCbAA+J8AAwD9C4W7LEdn+wAAAABJRU5ErkJggg=="

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBus_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBus_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyBulgarian_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221f438c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyBulgarian_vue__ = __webpack_require__(1437);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyBulgarian_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221f438c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyBulgarian_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyNorwegian_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3fd5444_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyNorwegian_vue__ = __webpack_require__(1438);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyNorwegian_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3fd5444_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyNorwegian_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEnglish_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca636fec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEnglish_vue__ = __webpack_require__(1550);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca636fec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyArabic_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58d9ac7d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyArabic_vue__ = __webpack_require__(1551);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyArabic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58d9ac7d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyArabic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyMalay_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f8d8d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyMalay_vue__ = __webpack_require__(1552);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyMalay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f8d8d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyMalay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyGreek_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36540972_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyGreek_vue__ = __webpack_require__(1553);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyGreek_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36540972_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyCzech_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64fa6fed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyCzech_vue__ = __webpack_require__(1554);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64fa6fed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySwedish_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5b5ee06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySwedish_vue__ = __webpack_require__(1441);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySwedish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5b5ee06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySwedish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyRomanian_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ff0868_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyRomanian_vue__ = __webpack_require__(1443);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyRomanian_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ff0868_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyRomanian_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobizone_Main_vue__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobizone_Browse_vue__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mobizone_Profile_vue__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobizone_HotPicks_vue__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobizone_Popular_vue__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mobizone_browse_Category_vue__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobizone_browse_Subcategory_vue__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mobizone_DetailPage_vue__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_mobizone_Login_vue__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mobizone_Contact_vue__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mobizone_Feedback_vue__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mobizone_Unsubscription_vue__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mobizone_PrivacyPolicy_vue__ = __webpack_require__(1548);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_mobizone_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_mobizone_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_mobizone_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_mobizone_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_mobizone_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_mobizone_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_mobizone_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_14__components_mobizone_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_mobizone_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_mobizone_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_mobizone_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_mobizone_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_13__components_mobizone_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_mobizone_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobiscope_Horoscope_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mobiscope_Tarot_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobiscope_Zodiac_vue__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobiscope_Profile_vue__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mobiscope_ChineseZodiac_vue__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_authentication_mobiscope_Login_vue__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mobiscope_HoroscopeDetails_vue__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mobiscope_ZodiacDetails_vue__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mobiscope_ElementsDetails_vue__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_ChineseZodiacDetails_vue__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mobiscope_PrivacyPolicy_vue__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mobiscope_Terms_vue__ = __webpack_require__(1445);















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    hash: false,
    history: true,
    routes: [{
        path: '/',
        name: 'Horoscope',
        component: __WEBPACK_IMPORTED_MODULE_3__components_mobiscope_Horoscope_vue__["a" /* default */],
        children: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            path: '/horoscope'
        }, 'path', '/horoscope/:id')]
    },
    // {
    //     path: '/horoscope',
    //     name: 'Horoscope',
    //     component: Horoscope,
    //     children: [{
    //         path: '/horoscope/:id'
    //     }]
    // },
    {
        path: '/horoscope-sign/:sign',
        name: 'HoroscopeDetails',
        component: __WEBPACK_IMPORTED_MODULE_9__components_mobiscope_HoroscopeDetails_vue__["a" /* default */],
        children: [{
            path: '/horoscope-sign/:sign/:id'
        }]
    }, {
        path: '/tarot*',
        name: 'Tarot',
        component: __WEBPACK_IMPORTED_MODULE_4__components_mobiscope_Tarot_vue__["a" /* default */],
        children: [{
            path: '/tarot/:id'
        }]
    }, {
        path: '/zodiac*',
        name: 'Zodiac',
        component: __WEBPACK_IMPORTED_MODULE_5__components_mobiscope_Zodiac_vue__["a" /* default */],
        children: [{
            path: '/zodiac/:id'
        }]
    }, {
        path: '/chinesezodiac',
        name: 'ChineseZodiac',
        component: __WEBPACK_IMPORTED_MODULE_7__components_mobiscope_ChineseZodiac_vue__["a" /* default */],
        children: [{
            path: '/chinesezodiac/:id'
        }]
    }, {
        path: '/zodiac-sign/:zodiac',
        name: 'ZodiacDetails',
        component: __WEBPACK_IMPORTED_MODULE_10__components_mobiscope_ZodiacDetails_vue__["a" /* default */],
        children: [{
            path: '/zodiac-sign/:zodiac/:id'
        }]
    }, {
        path: '/element-sign/:element',
        name: 'ElementsDetails',
        component: __WEBPACK_IMPORTED_MODULE_11__components_mobiscope_ElementsDetails_vue__["a" /* default */],
        children: [{
            path: '/element-sign/:element/:id'
        }]
    }, {
        path: '/chinese-sign/:chinesesign',
        name: 'ChineseZodiacDetails',
        component: __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_ChineseZodiacDetails_vue__["a" /* default */],
        children: [{
            path: '/chinese-sign/:chinesesign/:id'
        }]
    }, {
        path: "/privacy",
        name: "PrivacyPolicy",
        component: __WEBPACK_IMPORTED_MODULE_13__components_mobiscope_PrivacyPolicy_vue__["a" /* default */],
        children: [{
            path: "/privacy/:token"
        }]
    }, {
        path: "/terms",
        name: "Terms",
        component: __WEBPACK_IMPORTED_MODULE_14__components_mobiscope_Terms_vue__["a" /* default */],
        children: [{
            path: "/terms/:token"
        }]
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_8__components_authentication_mobiscope_Login_vue__["a" /* default */],
        children: [{
            path: "/logout"
        }]
    }, {
        path: "/profile",
        name: "Profile",
        component: __WEBPACK_IMPORTED_MODULE_6__components_mobiscope_Profile_vue__["a" /* default */],
        children: [{
            path: "/profile/:token"
        }]
    },
    //if have param id
    {
        path: '/:id',
        name: 'Horoscope',
        component: __WEBPACK_IMPORTED_MODULE_3__components_mobiscope_Horoscope_vue__["a" /* default */]
    }]
}));

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyFinnish_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaab481_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyFinnish_vue__ = __webpack_require__(1442);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyFinnish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaab481_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyFinnish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 452,
	"./bulgarian.json": 453,
	"./czech.json": 454,
	"./denmark.json": 455,
	"./english.json": 456,
	"./finnish.json": 457,
	"./greek.json": 458,
	"./indonesian.json": 459,
	"./malay.json": 460,
	"./norwegian.json": 461,
	"./romanian.json": 462,
	"./slovakia.json": 463,
	"./swedish.json": 464
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobiflix_Home_vue__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobiflix_DetailPage_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mobiflix_Profile_vue__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobiflix_Subcategory_vue__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobiflix_HotPicks_vue__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mobiflix_Popular_vue__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobiflix_Unsubscription_vue__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_authentication_mobiflix_Login_vue__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mobiflix_PrivacyPolicy_vue__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mobiflix_Terms_vue__ = __webpack_require__(1669);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_mobiflix_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_9__components_authentication_mobiflix_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_mobiflix_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_mobiflix_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_6__components_mobiflix_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_7__components_mobiflix_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_5__components_mobiflix_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_10__components_mobiflix_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_11__components_mobiflix_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_8__components_mobiflix_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_mobiflix_Home_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_miximo_Main_vue__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_miximo_Browse_vue__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_miximo_Profile_vue__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_miximo_HotPicks_vue__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_miximo_Popular_vue__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_miximo_browse_Category_vue__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_miximo_browse_Subcategory_vue__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_miximo_DetailPage_vue__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_miximo_Login_vue__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_miximo_Contact_vue__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_miximo_Feedback_vue__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_miximo_PrivacyPolicy_vue__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_miximo_Terms_vue__ = __webpack_require__(1742);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_miximo_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_miximo_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_miximo_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_miximo_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_miximo_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_miximo_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_miximo_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_13__components_miximo_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_14__components_miximo_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_miximo_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_miximo_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_miximo_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_miximo_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: '/:token',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_miximo_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_funplus_Main_vue__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_funplus_Browse_vue__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_funplus_Profile_vue__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_funplus_HotPicks_vue__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_funplus_Popular_vue__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_funplus_browse_Category_vue__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_funplus_browse_Subcategory_vue__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_funplus_DetailPage_vue__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_funplus_Login_vue__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_funplus_Contact_vue__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_funplus_Feedback_vue__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_funplus_PrivacyPolicy_vue__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_funplus_Faq_vue__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_funplus_Unsubscription_vue__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_funplus_Terms_vue__ = __webpack_require__(1938);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_funplus_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_funplus_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_funplus_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_funplus_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_funplus_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_16__components_funplus_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_funplus_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/faq",
    name: "Faq",
    component: __WEBPACK_IMPORTED_MODULE_14__components_funplus_Faq_vue__["a" /* default */],
    children: [{
      path: "/faq/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_funplus_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_13__components_funplus_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_funplus_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_funplus_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_funplus_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_funplus_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_15__components_funplus_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_funplus_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_gamebox_Main_vue__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_gamebox_Profile_vue__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_gamebox_HotPicks_vue__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_gamebox_Popular_vue__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gamebox_Subcategory_vue__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_gamebox_DetailPage_vue__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_authentication_gamebox_Login_vue__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_gamebox_PrivacyPolicy_vue__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_gamebox_Terms_vue__ = __webpack_require__(2015);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_gamebox_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_8__components_authentication_gamebox_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/popular",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_4__components_gamebox_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_5__components_gamebox_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_9__components_gamebox_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_7__components_gamebox_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_10__components_gamebox_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_3__components_gamebox_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_6__components_gamebox_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: "/:token",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_gamebox_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prizeo_Main_vue__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prizeo_Browse_vue__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prizeo_Profile_vue__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prizeo_HotPicks_vue__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_prizeo_Popular_vue__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prizeo_browse_Category_vue__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_prizeo_browse_Subcategory_vue__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_prizeo_DetailPage_vue__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_prizeo_Login_vue__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_prizeo_Contact_vue__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_prizeo_Feedback_vue__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_prizeo_Unsubscription_vue__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_prizeo_PrivacyPolicy_vue__ = __webpack_require__(2083);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_prizeo_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_prizeo_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_prizeo_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_prizeo_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_prizeo_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_prizeo_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_prizeo_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_14__components_prizeo_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_prizeo_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_prizeo_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_prizeo_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_prizeo_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_13__components_prizeo_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_prizeo_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cutemobi_Main_vue__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cutemobi_Browse_vue__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cutemobi_Profile_vue__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cutemobi_HotPicks_vue__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutemobi_Popular_vue__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cutemobi_browse_Category_vue__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cutemobi_browse_Subcategory_vue__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cutemobi_DetailPage_vue__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_cutemobi_Login_vue__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cutemobi_Contact_vue__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_cutemobi_Feedback_vue__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cutemobi_Unsubscription_vue__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_cutemobi_PrivacyPolicy_vue__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_cutemobi_Faq_vue__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_cutemobi_Terms_vue__ = __webpack_require__(2222);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_cutemobi_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_cutemobi_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_cutemobi_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_cutemobi_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_cutemobi_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/faq",
    name: "Faq",
    component: __WEBPACK_IMPORTED_MODULE_15__components_cutemobi_Faq_vue__["a" /* default */],
    children: [{
      path: "/faq/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_16__components_cutemobi_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_cutemobi_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_cutemobi_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_14__components_cutemobi_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_cutemobi_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_cutemobi_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_cutemobi_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_cutemobi_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_13__components_cutemobi_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_cutemobi_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cutehub_Main_vue__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cutehub_Browse_vue__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cutehub_Profile_vue__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cutehub_HotPicks_vue__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutehub_Popular_vue__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cutehub_browse_Category_vue__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cutehub_browse_Subcategory_vue__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cutehub_DetailPage_vue__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_cutehub_Login_vue__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cutehub_Contact_vue__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_cutehub_Feedback_vue__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cutehub_Unsubscription_vue__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_cutehub_PrivacyPolicy_vue__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_cutehub_Terms_vue__ = __webpack_require__(2303);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_2__components_cutehub_Main_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_cutehub_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_cutehub_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_cutehub_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_cutehub_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_cutehub_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_cutehub_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_14__components_cutehub_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_15__components_cutehub_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_cutehub_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_cutehub_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_cutehub_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_cutehub_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_13__components_cutehub_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_cutehub_Main_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Aquarius.svg": 366,
	"./Aries.svg": 367,
	"./Cancer.svg": 368,
	"./Capricorn.svg": 369,
	"./Gemini.svg": 370,
	"./Leo.svg": 371,
	"./Libra.svg": 372,
	"./Pisces.svg": 373,
	"./Sagittarius.svg": 374,
	"./Scorpio.svg": 375,
	"./Taurus.svg": 376,
	"./Virgo.svg": 377
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 480,
	"./bulgarian.json": 481,
	"./czech.json": 482,
	"./denmark.json": 483,
	"./english.json": 484,
	"./finnish.json": 485,
	"./greek.json": 486,
	"./indonesian.json": 487,
	"./malay.json": 488,
	"./norwegian.json": 489,
	"./romanian.json": 490,
	"./slovakia.json": 491,
	"./swedish.json": 492,
	"./thai.json": 493
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_gameknight_Home_vue__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_gameknight_DetailPage_vue__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_gameknight_Profile_vue__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_gameknight_Subcategory_vue__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gameknight_HotPicks_vue__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_gameknight_Popular_vue__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_authentication_gameknight_Login_vue__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_gameknight_PrivacyPolicy_vue__ = __webpack_require__(1803);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_gameknight_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_8__components_authentication_gameknight_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_gameknight_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_gameknight_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_6__components_gameknight_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_7__components_gameknight_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_9__components_gameknight_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_5__components_gameknight_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: '/:token',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_gameknight_Home_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/7QCcUGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAIAcAmcAFE9vXzRoLVVyb3FkdWlkc2NkVktwHAIoAGJGQk1EMDEwMDBhOTkwMTAwMDA5ZDAzMDAwMGUxMDQwMDAwMDUwNTAwMDAzYTA1MDAwMGY4MDUwMDAwNjUwNzAwMDBiYzA4MDAwMDA2MDkwMDAwNmQwOTAwMDBhZDBiMDAwMP/bAEMABgQFBgUEBgYFBgcHBggKEAoKCQkKFA4PDBAXFBgYFxQWFhodJR8aGyMcFhYgLCAjJicpKikZHy0wLSgwJSgpKP/bAEMBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/CABEIAUABQAMAIgABEQECEQH/xAAaAAEAAwEBAQAAAAAAAAAAAAAAAwQFAgEG/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAAABEQIRAAAB+5FgAAAAAAAAAAAAAAAAAAAAAAAAAAB50eLEhTXuCo65AAAAAAAAAAAAAAB4Jp75XsEoAHOVrxJkrdauQAAAAAAAAAAAALVbYOhKAAAA89GVDsZFngAAAAAAAAAAALWjVtQCgAAAAM7RplAWAAAAAAAAAADw15eO5QAAAAAFazWM0WAAAAAAAAAAPPfDa6jklAAAAAAVrNQzxYAAAAAAAAAALBbsEoAAAAACld8MVJHYAAAAAAAAAAuU7JpCUAAAAAADMrzQ2AAAAAAAAAAO+BtqluUAAAAAB57QKnhYAAAAAAAAAAB5sZGgWxKAAAABWzblOwAAAAAAAAAAABPANtXsSgAAACoUuCwAAAAAAAAAAAAD3WyNQnEoAAEeRrZNgAAAAAAAAAAAAAHmvkbZ6JQAAOMbcxLAAAAAAAAAAAAAAJNevYgFAAAZOtAmWKAAAAAAAAAAAJLxR0ZkAoAAAAEWdrDEaVGyMAAAAAAAB1dKd60gFAAAAAAAAArUdcmI0KNcgAAAHRzcszR56KAAAAAAAAAAAA89FGltxJku+KAA61obMAoAAAAAAAAAAAAAAHOTsQJlinfFs0BKAAAAAAAAAAAAAAAABkxXaVn/xAAnEAACAQMEAAYDAQAAAAAAAAABAgMAMEAEERIzECAhIjJQEyMxcP/aAAgBAAABBQL/AAkAmhC1fgr8FGA0ylfoUjLUsSjzMAwkXgc6KKzInNTAaZSuZAm5tkbiROByR6lRxFx15KRscjTjd72oHvyNOPZe1PxyIuu9qOvIT4XtR15CfG9qOvIj672p+ORB13tTkQLu18jepBxfG039wJ+zG0/ZgTdmMh2e+fQH1OPDJuL00m+VGd0uag/rytOfbc1J9cqFtnuOeT5cL8hanfYZgOxjbktiQ8UzoeuxL150XXYf45y/z6aMcntSjZ8yFOItSpzGUiFqjjCXXQPTxlcdULUkIGC8QNOhXDVS1JCBivCDTIVvqC1JDkvCDTKVuJDQG2WRvTw2VUsY4wme6B6dSp8qjkUUKPoGAYOvE+SBdl+imXkvig5P9JKOL+GnHu+k1I8P/8QAFBEBAAAAAAAAAAAAAAAAAAAAgP/aAAgBAhEBPwFIf//EABYRAAMAAAAAAAAAAAAAAAAAAAFwgP/aAAgBAREBPwGEAgP/xAAmEAABAwMDBAIDAAAAAAAAAAABACFAETBQIjFhAhASIEFRMnBx/9oACAEAAAY/Av0Sw7br8kxT4HhO/tQ4CvVaYp5lTtcdcS6XaSq/V+v3iBJGIGIGI6b4xHTIf4gkRzmTHBxNDvf8RKGIpdAl/wBukzObfiN5tQq2SZ4smeLJnjDgWzNfe3zLZc3eVxHZO8FmTw2Wp4rMnvstUnSye5qTS3WmzQLnAP7UCoMDQqnrX5OD59AMKe5OFB7f/8QAJhAAAQMEAQQCAwEAAAAAAAAAAQARITAxQFFBUGFxoSCREIGxcP/aAAgBAAABPyH/AAm6h8Im4A8lA+R+l5vpcBKIMLdBscbFb07oBhHxZA4RWTbg570ccCjEWPBXBCiDC2Zpp7qCaBwj7SscoGALlBCHFUBCRCA3GS6aK7IaMlojs1wl75IN4a/9Mn0RX/pk+mK/9Mk38FcvuyTce0Vzs85ADscAgGtXAEgFMhbjH9PBv+McmZsYJPj/AGoOAThNgicJ5L5AAHYLd64gdccnKcfaqwzZbLePQ1fBpy71aFX1hmQ5tp7AXzTCgITGxqJQFwiSS5kno+n4c8G8NEHH2zwYWhRMhGC3SEPPpGYJMKWu07bZZEEFiGOVZ0bKkL7VR0xsrmH2GObh+1JzYMvIrOjYwz8f2pCT0hFsSTmRuEbrlGF0ETM6QAAYQMczdSEmuEQYWp3sjGYjSELAwywAwOFz/VEEFjBoNIQDe2eMmDtMr7fI4ehCzjIiPvjLuhlnskfDzh0VlcX/AC9oDosn6vx//9oADAMAAAERAhEAABAIIIIIIIIIIIIIIIIIIIIIIIIIIII4YYoIIIIIIIIIIIIIIb0zzz8IIIIIIIIIIIIIIXzzzzywgIIIIIIIIIIIJ/zzzzzy4IIIIIIIIIIIZzzzzzzy4IIIIIIIIIIJZTzzzzzy4IIIIIIIIIIIbTzzzzzywIIIIIIIIIIJLzzzzzzzwIIIIIIIIIIILzzzzzzz4IIIIIIIIIIILXzzzzzyAIIIIIIIIIIIJLzzzzzyIIIIIIIIIIIIIIXzzzzEIIIIIIIIIIIIILnzzzzEIIIIIIIIIIIIIJfzzzz8oIIIIIIIIIIIK/zzzzzx44IIIIIIIIadzzzzzzzzzws4IIIIY9zzzzzzzzzzzzzx8oIK/wA888888888888888fCS888888888888888888C/8QAGhEAAgMBAQAAAAAAAAAAAAAAAREgMEAAUP/aAAgBAhEBPxDauWFQIvEyLRM5D6g8kTPhCJvETeIm1cqFUq1NXqAwnKe//8QAHBEBAAIDAQEBAAAAAAAAAAAAAREwACBAMRBQ/9oACAEBEQE/EO2TJOFdBybl3G193PeQ5D3kLHyk4y13PPwnUveQuo2zi7jk0zk1zk7LeOi8I/HjM//EACsQAQABAgUDAwMFAQAAAAAAAAERACEwMUBBUWFxgZGh8CBQwRBwsdHx4f/aAAgBAAABPxD9iWIZ6JrKx+GVbXdpVD4fzRzwSRUnK2dnz9hvZ9CqEQ82T0oIABwEfShElZpnfkNfDLhdd+rQQQWMALkBmCYoRPRkipKVtw6yxsvYd2IuMmzVpT/iHVKDuQVlHiO+LuLlnh5oE4SHUzAWsd3448UFrnc+Gp5Fd9LY8vBj6n/NTF+71vjmewuocqMD8ox83s1DlSn51sd+o6mYdJjwHz+LqYbyfdj2Oov41DdcCHJaAQAOhjpAhtcmhysZ7HTuz0Oh9i08pyTQyXhD0NPLWVztvoBsIJaXOyerUGWsEuT+8ZYzpQKS1k9DVc0wHuYsluL8tXKWcx2cWUOxXnVwYoKXfbEWCWxXHKx2GsCTs36nOHPpZybGtSGVI1LMjZMEUxC007dRKu+uMdWX3wRD7tfAelwepj/ijLW510MD2wRIO5FCRbMa1Ai0y9jDQ+y8TrAgBVYA3qTym/Q4w9gF9c9KZKCyO2qTye2Kszrv8cYtkYMjnUk+kWn2h7qwVAeTLHigAgIMfOpvwZZ8Ulm90aOAKm+QKh06eygAAAZBo0khuVIeDyfFeKYXHHltfTIqLTpMj+6JCBkBGnAEAjmNSi+4f1U/PB2cMFAJXIDOoV3g5vehpg2NWnAmYlQS89b/AA0iFDMS5gCZTuuR3qSBzv8AGvsTDkcyoP55DJ+rN6d+DmgQd3dfsKoZXt1pff3Hk+mzG49DY+xykPiR9HAbd23otl9kgOyYdn9ZkNg8/wCfZYOaK/T/2Q=="

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 652,
	"./bulgarian.json": 653,
	"./czech.json": 654,
	"./denmark.json": 655,
	"./english.json": 656,
	"./finnish.json": 657,
	"./greek.json": 658,
	"./indonesian.json": 659,
	"./malay.json": 660,
	"./norwegian.json": 661,
	"./romanian.json": 662,
	"./slovakia.json": 663,
	"./swedish.json": 664,
	"./thai.json": 665
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_apps4all_Home_vue__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_apps4all_Browse_vue__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_apps4all_Profile_vue__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_apps4all_HotPicks_vue__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_apps4all_Popular_vue__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_apps4all_browse_Category_vue__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_apps4all_browse_Subcategory_vue__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_apps4all_DetailPage_vue__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_authentication_apps4all_Login_vue__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_apps4all_Contact_vue__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_apps4all_Feedback_vue__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_apps4all_PrivacyPolicy_vue__ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_apps4all_Terms_vue__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_apps4all_Unsubscription_vue__ = __webpack_require__(2390);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_apps4all_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_10__components_authentication_apps4all_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_15__components_apps4all_Unsubscription_vue__["a" /* default */]
  }, {
    path: "/browse",
    name: "Browse",
    component: __WEBPACK_IMPORTED_MODULE_3__components_apps4all_Browse_vue__["a" /* default */],
    children: [{
      path: "/browse/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_5__components_apps4all_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_6__components_apps4all_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/contact",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_11__components_apps4all_Contact_vue__["a" /* default */],
    children: [{
      path: "/contact/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_12__components_apps4all_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_13__components_apps4all_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/terms",
    name: "Terms",
    component: __WEBPACK_IMPORTED_MODULE_14__components_apps4all_Terms_vue__["a" /* default */],
    children: [{
      path: "/terms/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_apps4all_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_9__components_apps4all_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/subcategory/:category/:subcat",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_8__components_apps4all_browse_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:category/:subcat/:token"
    }]
  }, {
    path: "/category/:category",
    name: "Category",
    component: __WEBPACK_IMPORTED_MODULE_7__components_apps4all_browse_Category_vue__["a" /* default */],
    children: [{
      path: "/category/:category/:token"
    }]
  }, {
    path: '/:token',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_apps4all_Home_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 415,
	"./bulgarian.json": 416,
	"./czech.json": 417,
	"./denmark.json": 418,
	"./english.json": 419,
	"./finnish.json": 420,
	"./greek.json": 421,
	"./indonesian.json": 422,
	"./malay.json": 423,
	"./norwegian.json": 424,
	"./romanian.json": 425,
	"./slovakia.json": 426,
	"./swedish.json": 427,
	"./thai.json": 428
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;

/***/ }),
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_games4all_Home_vue__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_games4all_DetailPage_vue__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_games4all_Profile_vue__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_games4all_Subcategory_vue__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_games4all_HotPicks_vue__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_games4all_Popular_vue__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_authentication_games4all_Login_vue__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_games4all_PrivacyPolicy_vue__ = __webpack_require__(1615);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_games4all_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_8__components_authentication_games4all_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_games4all_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_games4all_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_6__components_games4all_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_7__components_games4all_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_5__components_games4all_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_9__components_games4all_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: '/:token',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_games4all_Home_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 549,
	"./bulgarian.json": 550,
	"./czech.json": 551,
	"./denmark.json": 552,
	"./english.json": 553,
	"./finnish.json": 554,
	"./greek.json": 555,
	"./indonesian.json": 556,
	"./malay.json": 557,
	"./norwegian.json": 558,
	"./romanian.json": 559,
	"./slovakia.json": 560,
	"./swedish.json": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_gameonz_Home_vue__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_gameonz_DetailPage_vue__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_gameonz_Profile_vue__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_gameonz_Subcategory_vue__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gameonz_HotPicks_vue__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_gameonz_Popular_vue__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_gameonz_Unsubscription_vue__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_authentication_gameonz_Login_vue__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_gameonz_Feedback_vue__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_gameonz_PrivacyPolicy_vue__ = __webpack_require__(1851);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_gameonz_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_9__components_authentication_gameonz_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_gameonz_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_gameonz_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_6__components_gameonz_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_7__components_gameonz_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_5__components_gameonz_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_10__components_gameonz_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_11__components_gameonz_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_8__components_gameonz_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_gameonz_Home_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 613,
	"./bulgarian.json": 614,
	"./czech.json": 615,
	"./denmark.json": 616,
	"./english.json": 617,
	"./finnish.json": 618,
	"./greek.json": 619,
	"./indonesian.json": 620,
	"./malay.json": 621,
	"./norwegian.json": 622,
	"./romanian.json": 623,
	"./slovakia.json": 624,
	"./swedish.json": 625,
	"./thai.json": 626
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 695,
	"./bulgarian.json": 696,
	"./czech.json": 697,
	"./denmark.json": 698,
	"./english.json": 699,
	"./finnish.json": 700,
	"./greek.json": 701,
	"./indonesian.json": 702,
	"./malay.json": 703,
	"./norwegian.json": 704,
	"./romanian.json": 705,
	"./slovakia.json": 706,
	"./swedish.json": 707,
	"./thai.json": 708
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_fun2win_Home_vue__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fun2win_DetailPage_vue__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_fun2win_Profile_vue__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_fun2win_Subcategory_vue__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fun2win_HotPicks_vue__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fun2win_Popular_vue__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_authentication_fun2win_Login_vue__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_fun2win_Feedback_vue__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_fun2win_PrivacyPolicy_vue__ = __webpack_require__(2140);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_fun2win_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_8__components_authentication_fun2win_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_fun2win_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_fun2win_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_6__components_fun2win_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_7__components_fun2win_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_5__components_fun2win_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: "/feedback",
    name: "Feedback",
    component: __WEBPACK_IMPORTED_MODULE_9__components_fun2win_Feedback_vue__["a" /* default */],
    children: [{
      path: "/feedback/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_10__components_fun2win_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }]
}));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 750,
	"./bulgarian.json": 751,
	"./czech.json": 752,
	"./denmark.json": 753,
	"./english.json": 754,
	"./finnish.json": 755,
	"./greek.json": 756,
	"./indonesian.json": 757,
	"./malay.json": 758,
	"./norwegian.json": 759,
	"./romanian.json": 760,
	"./slovakia.json": 761,
	"./swedish.json": 762,
	"./thai.json": 763
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 788,
	"./bulgarian.json": 789,
	"./czech.json": 790,
	"./denmark.json": 791,
	"./english.json": 792,
	"./finnish.json": 793,
	"./greek.json": 794,
	"./indonesian.json": 795,
	"./malay.json": 796,
	"./norwegian.json": 797,
	"./romanian.json": 798,
	"./slovakia.json": 799,
	"./swedish.json": 800,
	"./thai.json": 801
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 826,
	"./bulgarian.json": 827,
	"./czech.json": 828,
	"./denmark.json": 829,
	"./english.json": 830,
	"./finnish.json": 831,
	"./greek.json": 832,
	"./indonesian.json": 833,
	"./malay.json": 834,
	"./norwegian.json": 835,
	"./romanian.json": 836,
	"./slovakia.json": 837,
	"./swedish.json": 838,
	"./thai.json": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_playmix_Home_vue__ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_playmix_DetailPage_vue__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_playmix_Profile_vue__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_playmix_Subcategory_vue__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_playmix_HotPicks_vue__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_playmix_Popular_vue__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_playmix_Unsubscription_vue__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_authentication_playmix_Login_vue__ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_playmix_PrivacyPolicy_vue__ = __webpack_require__(2433);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  hash: false,
  history: true,
  routes: [{
    path: "/home",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_playmix_Home_vue__["a" /* default */],
    children: [{
      path: "/home/:token"
    }]
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_9__components_authentication_playmix_Login_vue__["a" /* default */],
    children: [{
      path: "/logout"
    }]
  }, {
    path: "/detail/:id",
    name: "DetailPage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_playmix_DetailPage_vue__["a" /* default */],
    children: [{
      path: "/detail/:id/:token"
    }]
  }, {
    path: "/profile",
    name: "Profile",
    component: __WEBPACK_IMPORTED_MODULE_4__components_playmix_Profile_vue__["a" /* default */],
    children: [{
      path: "/profile/:token"
    }]
  }, {
    path: "/hotpicks",
    name: "HotPicks",
    component: __WEBPACK_IMPORTED_MODULE_6__components_playmix_HotPicks_vue__["a" /* default */],
    children: [{
      path: "/hotpicks/:token"
    }]
  }, {
    path: "/popular",
    name: "Popular",
    component: __WEBPACK_IMPORTED_MODULE_7__components_playmix_Popular_vue__["a" /* default */],
    children: [{
      path: "/popular/:token"
    }]
  }, {
    path: "/subcategory/:subcategory",
    name: "Subcategory",
    component: __WEBPACK_IMPORTED_MODULE_5__components_playmix_Subcategory_vue__["a" /* default */],
    children: [{
      path: "/subcategory/:subcategory/:token"
    }]
  }, {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: __WEBPACK_IMPORTED_MODULE_10__components_playmix_PrivacyPolicy_vue__["a" /* default */],
    children: [{
      path: "/privacy/:token"
    }]
  }, {
    path: "/unsubscription",
    name: "Unsubscription",
    component: __WEBPACK_IMPORTED_MODULE_8__components_playmix_Unsubscription_vue__["a" /* default */]
  }, {
    path: '/:token',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_playmix_Home_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Cow.svg": 1344,
	"./Dog.svg": 1345,
	"./Dragon.svg": 1346,
	"./Goat.svg": 1347,
	"./Horse.svg": 1348,
	"./Monkey.svg": 1349,
	"./Ox.svg": 1350,
	"./Pig.svg": 1351,
	"./Rabbit.svg": 1352,
	"./Rat.svg": 1353,
	"./Rooster.svg": 1354,
	"./Snake.svg": 1355,
	"./Tiger.svg": 1356
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;

/***/ }),
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Air.svg": 1420,
	"./Earth.svg": 1421,
	"./Fire.svg": 1422,
	"./Water.svg": 1423
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySlovakian_vue__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db59f6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySlovakian_vue__ = __webpack_require__(1666);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySlovakian_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db59f6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySlovakian_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySKEnglish_vue__ = __webpack_require__(503);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2def12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySKEnglish_vue__ = __webpack_require__(1667);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySKEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2def12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySKEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 522,
	"./bulgarian.json": 523,
	"./czech.json": 524,
	"./denmark.json": 525,
	"./english.json": 526,
	"./finnish.json": 527,
	"./greek.json": 528,
	"./indonesian.json": 529,
	"./malay.json": 530,
	"./norwegian.json": 531,
	"./romanian.json": 532,
	"./slovakia.json": 533,
	"./swedish.json": 534
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 582,
	"./bulgarian.json": 583,
	"./czech.json": 584,
	"./denmark.json": 585,
	"./english.json": 586,
	"./finnish.json": 587,
	"./greek.json": 588,
	"./indonesian.json": 589,
	"./malay.json": 590,
	"./norwegian.json": 591,
	"./romanian.json": 592,
	"./slovakia.json": 593,
	"./swedish.json": 594
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 728,
	"./english.json": 729,
	"./greek.json": 730,
	"./indonesian.json": 731,
	"./malay.json": 732
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 858,
	"./bulgarian.json": 859,
	"./czech.json": 860,
	"./denmark.json": 861,
	"./english.json": 862,
	"./finnish.json": 863,
	"./greek.json": 864,
	"./indonesian.json": 865,
	"./malay.json": 866,
	"./norwegian.json": 867,
	"./romanian.json": 868,
	"./slovakia.json": 869,
	"./swedish.json": 870,
	"./thai.json": 871
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTY5LjQsNDc5LjRjNC43LDIuNSw5LjYtMi45LDYuOC03LjRjLTE1LjYtMjQuMy0zMC4zLTY1LjEtNi44LTExNy42YzM5LjItODcuNiw2My4xLTEzMyw2My4xLTEzMw0KCQkJczEyLjcsNTMsNDcuMSwxMDAuMWMzMy4xLDQ1LjMsNTEuMiwxMDIuMywyMiwxNDkuOGMtMi43LDQuNSwyLjEsOS43LDYuOCw3LjNjMzYuMi0xOC41LDc2LjctNTUuNiw4MS4zLTEyOS40DQoJCQljMS43LTIyLjYtMC44LTU0LjEtMTMuNS05NGMtMTYuMy01MC41LTM2LjMtNzQuMS00Ny44LTg0LjJjLTMuNS0zLTguOC0wLjMtOC42LDQuMmMzLjQsNTQuNS0xNy4xLDY4LjMtMjguOCwzNy4yDQoJCQljLTQuNy0xMi41LTcuNC0zNC03LjQtNjAuMmMwLTQzLjctMTIuNy04OC42LTQwLjYtMTI1LjFjLTcuMy05LjUtMTUuOC0xOC40LTI1LjUtMjUuOWMtMy41LTIuNy04LjYsMC04LjMsNC41DQoJCQljMi4xLDI5LjYsMC4yLDExNC40LTc0LjIsMjE1LjhjLTY3LjUsOTQtNDEuMywxNjYuMi0zMi4xLDE4NS43QzEyMC41LDQ0NC41LDE0NS4zLDQ2Ni41LDE2OS40LDQ3OS40eiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flickity_dist_flickity_min_css__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flickity_dist_flickity_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flickity_dist_flickity_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_granim__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_granim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_granim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_router_mobiscope__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobiscope_Navigation_vue__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_mobiscope_js_mobiscope__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_api_mobiscopeAPI__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_mobiscope_UnsubModal_vue__ = __webpack_require__(1499);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















var proxyurl = "https://cors-anywhere.herokuapp.com/";

var URL = "https://zodiacal.herokuapp.com/";
var currentDate = new Date();
var year = currentDate.getFullYear();

__WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Mobiscope",
  data: function data() {
    return {
      token: "",
      id: this.$route.params.id,
      canvasInstance: {},
      year: year,
      horoscopeData: __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_mobiscope_js_mobiscope__["a" /* default */].horoscopeData,
      tarotData: __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_mobiscope_js_mobiscope__["a" /* default */].tarotData,
      zodiacData: __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_mobiscope_js_mobiscope__["a" /* default */].zodiacData,
      loadingPage: __WEBPACK_IMPORTED_MODULE_12__components_mobiscope_mobiscope_js_mobiscope__["a" /* default */].loadingPage
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["language", "countryCode", "host_mobiscope"]),
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_8__components_mobiscope_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_18__components_mobiscope_UnsubModal_vue__["a" /* default */]
  },
  created: function created() {
    this.fetchTranslateCode(this.countryCode);
    this.fetchToken_mobis(this.id);
    this.getDomain_mobis(this.host_mobiscope);
    // this.getToken();
  },
  mounted: function mounted() {

    this.initPlanets();
    this.initBgCanavs();
    this.initStarbg();

    if (this.$route.name == "Zodiac" || this.$route.name == "ZodiacDetails" || this.$route.name == "ElementsDetails") {
      this.canvasInstance.changeState("zodiac-state");
    } else if (this.$route.name == "Tarot") {
      this.canvasInstance.changeState("tarot-state");
    } else if (this.$route.name == "ChineseZodiac" || this.$route.name == "ChineseZodiacDetails") {
      this.canvasInstance.changeState("chinese-state");
    } else if (this.$route.name == "Login") {
      document.getElementsByClassName("navbar__wrap")[0].classList.add("login");
    } else {
      this.canvasInstance.changeState("default-state");
      document.getElementsByClassName("navbar__wrap")[0].classList.remove("login");
    }

    var lang = this.language;
    var country_code = this.countryCode;

    if (lang != "null" && lang != null) {
      if (lang == "arabic") {
        sessionStorage.setItem("language", lang);
        this.$i18n.locale = lang;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLang(lang);
      } else {
        sessionStorage.setItem("language", lang);
        this.$i18n.locale = lang;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang(lang);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_13__locales_country_list_json___default.a[country_code].language;

        if (sessionStorage.getItem('tokenID') == 'mobis80') {
          sessionStorage.setItem("language", 'english');
          this.$i18n.locale = 'english';
          this.fetchLang('english');
        } else {
          sessionStorage.setItem("language", language);
          this.$i18n.locale = language;
          this.fetchLang(language);
        }

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        sessionStorage.setItem("language", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])(["fetchLang", "fetchTranslateCode", "fetchToken_mobis", "getDomain_mobis"]), {
    initBgCanavs: function initBgCanavs() {
      this.canvasInstance = new __WEBPACK_IMPORTED_MODULE_5_granim___default.a({
        element: "#granim-canvas",
        name: "granim",
        direction: "top-bottom",
        isPausedWhenNotInView: true,
        opacity: [1, 1],
        states: {
          "default-state": {
            gradients: [["#240795", "#571eee"], ["#571eee", "#130361"]],
            transitionSpeed: 5000
          },
          "tarot-state": {
            gradients: [["#3c0a6f", "#f53400"]],
            transitionSpeed: 5000
          },
          "zodiac-state": {
            gradients: [["#161b8f", "#009dcb"]],
            transitionSpeed: 5000
          },
          "chinese-state": {
            gradients: [["#b3001c", "#e24b19"]],
            transitionSpeed: 5000
          }
        }
      });
      this.canvasInstance.changeState("tarot-state");
    },
    initStarbg: function initStarbg() {
      window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

      var starDensity = 0.216;
      var speedCoeff = 0.05;
      var width = void 0;
      var height = void 0;
      var starCount = void 0;
      var circleRadius = void 0;
      var circleCenter = void 0;
      var first = true;
      var giantColor = "180,184,240";
      var starColor = "255,255,255";
      var cometColor = "226,225,224";
      var canva = document.getElementById("universe");
      var stars = [];
      var universe = void 0;
      var img = new Image();
      windowResizeHandler();
      window.addEventListener("resize", windowResizeHandler, false);
      createUniverse();

      function createUniverse() {
        universe = canva.getContext("2d");

        for (var i = 0; i < starCount; i++) {
          stars[i] = new Star();
          stars[i].reset();
        }
        // console.log(stars[i]);
        draw();
      }
      function draw() {
        universe.clearRect(0, 0, width, height);
        var starsLength = stars.length;

        for (var i = 0; i < starsLength; i++) {
          var star = stars[i];
          star.move();
          star.fadeIn();
          star.fadeOut();
          star.draw();
        }
        window.requestAnimationFrame(draw);
      }

      function Star() {
        this.reset = function () {
          this.giant = getProbability(3);
          this.comet = this.giant || first ? false : getProbability(10);
          this.x = getRandInterval(0, width - 10);
          this.y = getRandInterval(0, height);
          this.r = getRandInterval(1.1, 2.6);
          this.dx = getRandInterval(speedCoeff, 6 * speedCoeff) + (this.comet + 1 - 1) * speedCoeff * getRandInterval(50, 120) + speedCoeff * 2;
          this.dy = getRandInterval(speedCoeff, 6 * speedCoeff) - (this.comet + 1 - 1) * speedCoeff * getRandInterval(0, -120);
          this.fadingOut = null;
          this.fadingIn = true;
          this.opacity = 0;
          this.opacityTresh = getRandInterval(0.2, 1 - (this.comet + 1 - 1) * 0.4);
          this.do = getRandInterval(0.0005, 0.002) + (this.comet + 1 - 1) * 0.001;
        };
        this.fadeIn = function () {
          if (this.fadingIn) {
            this.fadingIn = this.opacity > this.opacityTresh ? false : true;
            this.opacity += this.do;
          }
        };
        this.fadeOut = function () {
          if (this.fadingOut) {
            this.fadingOut = this.opacity < 0 ? false : true;
            this.opacity -= this.do / 2;
            if (this.x > width || this.y < 0) {
              this.fadingOut = false;
              this.reset();
            }
          }
        };
        this.draw = function () {
          universe.beginPath();

          if (this.giant) {
            universe.fillStyle = "rgba(" + giantColor + "," + this.opacity + ")";
            universe.arc(this.x, this.y, 2, 0, 2 * Math.PI, false);
          } else if (this.comet) {
            universe.fillStyle = "rgba(" + cometColor + "," + this.opacity + ")";
            universe.arc(this.x, this.y, 1.5, 0, 2 * Math.PI, false);

            //comet tail
            for (var i = 0; i < 30; i++) {
              universe.fillStyle = "rgba(" + cometColor + "," + (this.opacity - this.opacity / 20 * i) + ")";
              universe.rect(this.x - this.dx / 4 * i, this.y - this.dy / 4 * i - 2, 2, 2);
              universe.fill();
            }
          } else {
            universe.fillStyle = "rgba(" + starColor + "," + this.opacity + ")";
            universe.rect(this.x, this.y, this.r, this.r);
          }

          universe.closePath();
          universe.fill();
        };
        this.move = function () {
          this.x += this.dx;
          this.y += this.dy;
          if (this.fadingOut === false) {
            this.reset();
          }
          if (this.x > width - width / 4 || this.y < 0) {
            this.fadingOut = true;
          }
        };
        (function () {
          setTimeout(function () {
            first = false;
          }, 50);
        })();
      }
      function getProbability(percents) {
        return Math.floor(Math.random() * 1000) + 1 < percents * 10;
      }

      function getRandInterval(min, max) {
        return Math.random() * (max - min) + min;
      }

      function windowResizeHandler() {
        width = window.innerWidth;
        height = window.innerHeight;
        starCount = width * starDensity;
        circleRadius = width > height ? height / 2 : width / 2;
        circleCenter = {
          x: width / 2,
          y: height / 2
        };

        canva.setAttribute("width", width);
        canva.setAttribute("height", height);
      }
    },
    initPlanets: function initPlanets() {
      var planetCanvas = document.getElementById("universeElms");
      planetCanvas.setAttribute("width", window.innerWidth);
      // planetCanvas.setAttribute("height", window.innerHeight);
      var planetCanvasCtx = planetCanvas.getContext("2d");

      var img = new Image();
      var img2 = new Image();
      img.src = __webpack_require__(1502);
      img2.src = __webpack_require__(341);
      img.onload = function () {
        // planetCanvasCtx.drawImage(img, 0, 0);
        if (window.innerWidth < 900) {
          planetCanvasCtx.drawImage(img, -300, 300, 550, img.height * (550 / img.width));
          planetCanvasCtx.drawImage(img2, window.innerWidth - img2.width * 0.25, 420, 320, img2.height * (320 / img2.width));
        } else {
          planetCanvasCtx.drawImage(img, -300, 200, 700, img.height * (700 / img.width));
          planetCanvasCtx.drawImage(img2, window.innerWidth - img2.width * 0.25, 350, 400, img2.height * (400 / img2.width));
        }
      };
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      var token = sessionStorage.getItem("tokenID");

      if (this.$route.name == "Zodiac" || this.$route.name == "ZodiacDetails" || this.$route.name == "ElementsDetails") {
        this.canvasInstance.changeState("zodiac-state");
      } else if (this.$route.name == "Tarot") {
        this.canvasInstance.changeState("tarot-state");
      } else if (this.$route.name == "ChineseZodiac" || this.$route.name == "ChineseZodiacDetails") {
        this.canvasInstance.changeState("chinese-state");
      } else if (this.$route.name == "Login") {
        document.getElementsByClassName("navbar__wrap")[0].classList.add("login");
      } else {
        this.canvasInstance.changeState("default-state");
        document.getElementsByClassName("navbar__wrap")[0].classList.remove("login");
      }
    }
  }
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["language", "auth_mobis"]),
  props: ["horoscopeData", "loadingPage"],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["guest_mobis"]))

});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TarotSlider_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var TJO = __webpack_require__(84)();
var proxyurl = "https://cors-anywhere.herokuapp.com/";
var URL = "https://rws-cards-api.herokuapp.com/api/v1/cards";

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component("tarot-silder", __WEBPACK_IMPORTED_MODULE_5__TarotSlider_vue__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tarots: {},
      descTranslate: "",
      meaningTranslate: "",
      meaning: ""
    };
  },

  components: {
    TarotSlider: __WEBPACK_IMPORTED_MODULE_5__TarotSlider_vue__["a" /* default */]
  },
  mounted: function mounted() {},

  props: ["tarotData"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["language", "translateCode", "countryCode"]),
  methods: {
    getTarot: function getTarot(tarot) {
      var _this = this;

      //description and meaning to reset if user click another card
      this.descTranslate = "";
      this.meaningTranslate = "";

      //to get information for each card
      var tar = [];
      var tarotData = this.tarotData.data; //get data from props

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(tarotData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.name_short == tarot) {
            //only for Fortitude card
            if (value.name == "Strength(Fortitude)") {
              value.name = "Fortitude";
            }
            value.image = __webpack_require__(338)("./" + value.name + ".jpg");
            if (value.name == "Fortitude") {
              value.name = "Strength(Fortitude)";
            }
            tar.push(value);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.tarots = tar;

      this.meaning = this.tarots[0].meaning_up + " " + this.tarots[0].meaning_rev;

      TJO.init({
        googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04'
        // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
      });

      var desc = {
        desc: this.tarots[0].desc,
        meaning: " " + this.meaning
      };

      if (this.translateCode != "") {
        TJO.translate(desc, this.translateCode).then(function (data) {
          _this.descTranslate = data.desc;
          _this.meaningTranslate = data.meaning;
        }).catch(function (err) {
          console.log("error ", err);
        });
      }
    }
  }
});

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import "flickity/dist/flickity.min.css";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false
    };
  },

  props: ["major", "getTarot"],
  mounted: function mounted() {
    var flkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(this.$refs.carousel, this.flickityOptions);
    flkty.on("dragStart", function () {
      this.stageDragging = true;
    });
    flkty.on("dragEnd", function () {
      this.stageDragging = false;
    });

    var cardWrapper = document.getElementsByClassName("cardWrapper");
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(cardWrapper).forEach(function (card) {
      card.addEventListener("click", function () {
        flkty.select(card.getAttribute("data-cardindex"));
      });
    });
  },

  methods: {}
});

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Ace of Cups.jpg": 1256,
	"./Ace of Pentacles.jpg": 1257,
	"./Ace of Swords.jpg": 1258,
	"./Ace of Wands.jpg": 1259,
	"./Death.jpg": 1260,
	"./Eight of Cups.jpg": 1261,
	"./Eight of Pentacles.jpg": 1262,
	"./Eight of Swords.jpg": 1263,
	"./Eight of Wands.jpg": 1264,
	"./Five of Cups.jpg": 1265,
	"./Five of Pentacles.jpg": 1266,
	"./Five of Swords.jpg": 1267,
	"./Five of Wands.jpg": 1268,
	"./Fortitude.jpg": 1269,
	"./Four of Cups.jpg": 1270,
	"./Four of Pentacles.jpg": 1271,
	"./Four of Swords.jpg": 1272,
	"./Four of Wands.jpg": 1273,
	"./Justice.jpg": 1274,
	"./King of Cups.jpg": 1275,
	"./King of Pentacles.jpg": 1276,
	"./King of Swords.jpg": 1277,
	"./King of Wands.jpg": 1278,
	"./Knight of Cups.jpg": 1279,
	"./Knight of Pentacles.jpg": 1280,
	"./Knight of Swords.jpg": 1281,
	"./Knight of Wands.jpg": 1282,
	"./Nine of Cups.jpg": 1283,
	"./Nine of Pentacles.jpg": 1284,
	"./Nine of Swords.jpg": 1285,
	"./Nine of Wands.jpg": 1286,
	"./Page of Cups.jpg": 1287,
	"./Page of Pentacles.jpg": 1288,
	"./Page of Swords.jpg": 1289,
	"./Page of Wands.jpg": 1290,
	"./Queen of Cups.jpg": 1291,
	"./Queen of Pentacles.jpg": 1292,
	"./Queen of Swords.jpg": 1293,
	"./Queen of Wands.jpg": 1294,
	"./Seven of Cups.jpg": 1295,
	"./Seven of Pentacles.jpg": 1296,
	"./Seven of Swords.jpg": 1297,
	"./Seven of Wands.jpg": 1298,
	"./Six of Cups.jpg": 1299,
	"./Six of Pentacles.jpg": 1300,
	"./Six of Swords.jpg": 1301,
	"./Six of Wands.jpg": 1302,
	"./Temperance.jpg": 1303,
	"./Ten of Cups.jpg": 1304,
	"./Ten of Pentacles.jpg": 1305,
	"./Ten of Swords.jpg": 1306,
	"./Ten of Wands.jpg": 1307,
	"./The Chariot.jpg": 1308,
	"./The Devil.jpg": 1309,
	"./The Emperor.jpg": 1310,
	"./The Empress.jpg": 1311,
	"./The Fool.jpg": 1312,
	"./The Hanged Man.jpg": 1313,
	"./The Hermit.jpg": 1314,
	"./The Hierophant.jpg": 1315,
	"./The High Priestess.jpg": 1316,
	"./The Last Judgment.jpg": 1317,
	"./The Lovers.jpg": 1318,
	"./The Magician.jpg": 1319,
	"./The Moon.jpg": 1320,
	"./The Star.jpg": 1321,
	"./The Sun.jpg": 1322,
	"./The Tower.jpg": 1323,
	"./The World.jpg": 1324,
	"./Three of Cups.jpg": 1325,
	"./Three of Pentacles.jpg": 1326,
	"./Three of Swords.jpg": 1327,
	"./Three of Wands.jpg": 1328,
	"./Two of Cups.jpg": 1329,
	"./Two of Pentacles.jpg": 1330,
	"./Two of Swords.jpg": 1331,
	"./Two of Wands.jpg": 1332,
	"./Wheel Of Fortune.jpg": 1333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338;

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["language"]),
  mounted: function mounted() {
    console.log(this.$props.horoscopeData.data);
  },

  props: ["zodiacData", "loadingPage", "horoscopeData"]
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["gcid_mobis", "auth_mobis", "is_unsub_mobis"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_mobis"]))
});

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planet-right.a57eecf.png";

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zodiac_json__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zodiac_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zodiac_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var currentDate = new Date();
var year = currentDate.getFullYear();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      current_year: {},
      year: year,
      czodiacs: {}
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["language"]),
  created: function created() {
    //to get zodiac information
    var getzodiac = __webpack_require__(1343);
    var czanimal = getzodiac(this.year);

    var cz = __WEBPACK_IMPORTED_MODULE_1__zodiac_json___default.a.eastern_zodiac;
    this.getCZodiac(cz, czanimal);
  },

  methods: {
    getCZodiac: function getCZodiac(cz, czanimal) {
      var _this = this;

      //get all zodiac
      for (var i = 0; i < cz.length; i++) {
        cz[i].image = __webpack_require__(209)("./" + cz[i].sign_english + ".svg");
      }

      //zodiac of the year
      var ani = czanimal.en;
      czanimal = ani.replace(/^./, ani[0].toUpperCase());

      cz.map(function (value) {
        if (value.sign_english == czanimal) {
          value.image_year = __webpack_require__(344)("./" + value.sign_english + ".svg");
          value.route = value.sign_english.toLowerCase();
          _this.current_year = value;
        }
      });
      this.czodiacs = cz;
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = {"eastern_zodiac":[{"sign_english":"Rat","sign_arabic":"الفأر","sign_greek":"Αρουραίος","sign_malay":"Tikus","sign_thai":"ปีชวด","sign_czech":"Krysa","sign_bulgarian":"Плъх","sign_norwegian":"Rotte","sign_slovakia":"Potkan","sign_denmark":"Rotte","yin-yang":"Yang","direction":"North","season":"Mid-Winter","element":"Water","trine":"1st","personality":{"first_english":"Involving the first and most noticeable situation on the Chinese Zodiac, the Rat symbolizes such character characteristics as mind, creative mind and interest. Rodents have sharp perception aptitudes and with those abilities they're ready to conclude much about other individuals and different circumstances. By and large, Rats are loaded with vitality, loquacious and enchanting yet they tend to end up forceful.","second_english":"Rodents are loaded with a word of wisdom yet they will never impart their issues to other people. They are straightforward people and they appreciate living for the occasion. They're likewise fit for enduring any circumstance.","first_arabic":"يعتبر الأول والأكثر بروزًا في الابراج الصينية ، يرمز الجرذ إلى خصائص الشخصية مثل العقل والإبداع الاهتمام. تتميز القوارض بقدرات إدراك حادة وبهذه القدرات ، تكون على استعداد لاستنتاج الكثير عن الأفراد الآخرين والظروف المختلفة. بشكل عام ،  الفئران مليئة بالحيوية ، ورائعة وساحرة لكنها تميل إلى أن تنتهي بالقوة.","second_arabic":"القوارض مليئة  بكلمة الحكمة لكنها لن تنقل أبداً قضاياهم إلى أشخاص آخرين. إنهم أناس مباشرون وهم يحترمون العيش من اجل هذه الحدث. كما أنها مناسبة لتحمل أي ظرف من الظروف.","first_greek":"Συμπεριλαμβάνοντας την πρώτη και πιο αξιοσημείωτη κατάσταση στο Κινέζικο Ζωδιακό κύκλο, ο αρουραίος συμβολίζει χαρακτηριστικά του χαρακτήρα όπως το μυαλό, το δημιουργικό μυαλό και το ενδιαφέρον. Τα τρωκτικά έχουν ιδιαίτερες ικανότητες αντίληψης και με αυτές τις ικανότητες είναι έτοιμα να αντιληφθούν πολλά, σχετικά με άλλα άτομα και διάφορες περιστάσεις. Σε γενικές γραμμές, οι αρουραίοι είναι γεμάτοι ζωτικότητα, άγριοι και γοητευτικοί, ενώ τείνουν να καταλήγουν και δυνατοί.","second_greek":"Τα τρωκτικά διαθέτουν αρκετή σοφία, όμως ποτέ δεν μεταδίδουν τα προβλήματά τους σε άλλους ανθρώπους. Είναι απλοί άνθρωποι και εκτιμούν ότι ζουν για την περίσταση. Είναι εξίσου κατάλληλοι για τη διαχείρηση οποιουδήποτε περιστατικού.","first_malay":"Melibatkan keadaan pertama dan paling ketara pada Zodiak Cina, Tikus melambangkan sifat watak seperti minda, minda kreatif dan minat. Tikus mempunyai keberanian persepsi yang tajam dan dengan kebolehan mereka bersedia untuk menyimpulkan banyak tentang individu lain dan keadaan yang berbeza. Secara beransur-ansur, tikus dimuatkan dengan daya hidup, cerah dan mempesonakan namun mereka cenderung berakhir dengan kuat.","second_malay":"Tikus sarat dengan kata-kata kebijaksanaan namun mereka tidak akan pernah membahaskan isu mereka kepada orang lain. Mereka adalah orang yang mudah dan mereka menghargai hidup untuk sesuatu kehidupan. Mereka juga boleh hidup sebarang keadaan.","first_thai":"ปีชวดถือเป็นปีนักษัตรลำดับแรกในตำราโหราศาสตร์จีน คนเกิดปีชวดเป็นคนมีความคิดสร้างสรรค์ มีความเฉลียวฉลาด และมีความสามารถในการปรับตัวให้เข้ากับทุกสถานการณ์ นอกจากนี้คนเกิดปีชวดยังเป็นคนมีชีวิตชีวา ช่างพูดจา และมีความน่าเชื่อถือ.","second_thai":"คนเกิดปีชวดมีความฉลาดในการพูดจาและเป็นคนไม่พูดเรื่องส่วนตัวมากนัก เป็นคนตรงไปตรงมาและเข้าใจการใช้ชีวิต และคนเกิดปีนี้สามารถปรับตัวให้รอดในทุกสถานการณ์.","first_czech":"Zapojením první a nejnápadnější situace na čínském zvěrokruhu krysa symbolizuje takové charakterové vlastnosti jako mysl, kreativní mysl a zájem. Hlodavci mají ostré vnímací schopnosti a díky těmto schopnostem jsou schopni učinit závěr o jiných jednotlivcích a různých okolnostech. Celkově jsou krysy nabité vitalitou, upovídané a okouzlující, přesto mají sklon skončit energicky.","second_czech":"Hlodavci jsou nabití slovem moudrosti, přesto své problémy nikdy nepředají jiným lidem. Jsou to přímí lidé a oceňují život pro tuto příležitost. Jsou také způsobilí vydržet jakoukoli okolnost.","first_bulgarian":"Включвайки първата и най-забележима ситуация на китайския зодиак, Плъхът символизира такива характеристики на характера като ум, творчески ум и интерес. Гризачите имат остри способности за възприятие и с тези способности са готови да правят много заключения за други индивиди и различни обстоятелства. Като цяло, Плъховете са заредени с жизненост, приказливи и очарователни, но в крайна сметка са склонни да бъдат силни.","second_bulgarian":"Гризачите са натоварени с дума на мъдрост, но никога няма да предават своите проблеми на други хора. Те са откровени хора и ценят живота за случая. Те също са годни да издържат на всякакви обстоятелства.","first_norwegian":"Ved å involvere den første og mest merkbare situasjonen på den kinesiske dyrekretsen, symboliserer rotten slike karakteregenskaper som sinn, kreativt sinn og interesse. Gnagere har skarpe oppfatningsevner, og med disse evnene er de klare til å konkludere mye om andre individer og forskjellige omstendigheter. I det store og hele er rotter lastet med vitalitet, loquacious og fortryllende, men de har en tendens til å ende opp kraftige.","second_norwegian":" Gnagere er lastet med et visdomsord, men de vil aldri formidle sine problemer til andre mennesker. De er enkle mennesker, og de setter pris på å leve for anledningen. De er også egnet til å tåle enhver omstendighet.","first_slovakia":"Zahrnutím prvej a najviditeľnejšej situácie na čínskom zverokruhu potkan symbolizuje také charakterové vlastnosti, ako je myseľ, tvorivá myseľ a záujem. Hlodavce majú ostré schopnosti vnímania a s týmito schopnosťami sú pripravené uzavrieť veľa informácií o iných jednotlivcoch a rôznych okolnostiach. Celkovo sú potkany nabité vitalitou, temperamentné a očarujúce, napriek tomu majú tendenciu končiť energicky.","second_slovakia":"Hlodavce sú nabité slovom múdrosti, napriek tomu nikdy nebudú rozdávať svoje problémy iným ľuďom. Sú to priami ľudia a cenia si život pre túto príležitosť. Rovnako sú vhodné na vydržanie akýchkoľvek okolností.","first_denmark":"Ved at involvere den første og mest bemærkelsesværdige situation på den kinesiske stjernetegn symboliserer rotten sådanne karakteregenskaber som sind, kreativt sind og interesse. Gnavere har skarp opfattelsesevne, og med disse evner er de klar til at konkludere meget om andre individer og forskellige omstændigheder. I det store og hele er rotter fyldt med vitalitet, rummelige og fortryllende, men de har en tendens til at ende med at blive kraftige.","second_denmark":"Gnavere er fyldt med et visdomsord, men alligevel vil de aldrig formidle deres problemer til andre mennesker. De er ligefremme mennesker, og de sætter pris på at leve for lejligheden. De er ligeledes egnede til at udholde enhver omstændighed.","first_swedish":"Med den första och mest märkbara situationen på den kinesiska zodiaken symboliserar råttan sådana karaktärsegenskaper som sinne, kreativt sinne och intresse. Gnagare har skarp uppfattningsförmåga och med dessa förmågor är de redo att dra slutsatser om andra individer och olika omständigheter. I stort sett är råttor laddade med vitalitet, loquacious och förtrollande men de tenderar att hamna kraftfulla.","second_swedish":"Gnagare är laddade med ett visdomsord men de kommer aldrig att förmedla sina problem till andra människor. De är enkla människor och de uppskattar att leva för tillfället. De är också lämpliga för att uthärda alla omständigheter.","first_finnish":"Kiinalainen horoskooppi havaitsee ensimmäisen ja huomattavimman tilanteen, Rotta symboloi sellaisia ​​luonteenpiirteitä kuin mieli, luova mieli ja kiinnostus. Jyrsijöillä on terävät havaintokyvyt ja näiden kykyjen avulla he ovat valmiita tekemään paljon päätelmiä muista yksilöistä ja erilaisista olosuhteista. Rotat ovat kaiken kaikkiaan täynnä elinvoimaa, välinpitämättömiä ja lumoavia, mutta ne päätyvät lopulta voimakkaiksi.","second_finnish":"Jyrsijät ovat täynnä viisauden sanaa, mutta he eivät koskaan välitä asioita muille ihmisille. He ovat suoraviivaisia ​​ihmisiä ja arvostavat tilaisuuteen elämistä. Ne soveltuvat myös kestämään kaikkia olosuhteita.","first_romanian":"Implicând prima și cea mai vizibilă situație de pe zodiacul chinezesc, șobolanul simbolizează astfel de caracteristici de caracter precum mintea, mintea creativă și interesul. Rozătoarele au aptitudini de percepție ascuțite și, cu aceste abilități, sunt gata să concluzioneze multe despre alți indivizi și circumstanțe diferite. În general, șobolanii sunt încărcați de vitalitate, locuitori și încântători, dar au tendința de a ajunge puternic.","second_romanian":"Rozătoarele sunt încărcate cu un cuvânt de înțelepciune, dar nu vor transmite niciodată problemele lor altor oameni. Sunt oameni simpli și apreciază să trăiască pentru această ocazie. Ele sunt, de asemenea, potrivite pentru a suporta orice circumstanță."},"health":{"english":"By and large Rats appreciate great wellbeing. They're extremely dynamic which helps keep them fit as a fiddle and ready to ward off ailment. They can on occasion be tense, forceful, and loaded with anxious vitality, conditions which can prompt pressure. Customary exercise intended to quiet will profit Rats.","arabic":" إلى حد كبيرالفئران تهتم بالصحة الجيدة. إنها ديناميكية للغاية مما يساعد في الحفاظ على لياقتها بمستوى عالي وجاهزة لدرء المرض. يمكن أن تكون في بعض الأحيان متوترة مندفعة ومحملة بالقلق ، الظروف التي يمكن أن تؤدي إلى الضغط. التمارين المعتادةو التي تهدف إلى تهدئة النفس مفيدة لشخصية الفأر.","greek":"Σε μεγάλο βαθμό οι αρουραίοι εκτιμούν την ευημερία. Είναι εξαιρετικά δυναμικοί, πράγμα που τους βοηθά να διατηρούνται σε καλή κατάσταση και μακριά από ασθένειες. Μπορούν μερικές φορές να βρίσκονται σε ένταση, τεταμένοι, δυναμικοί και φορτωμένοι με ανήσυχη ζωτικότητα, σε συνθήκες που μπορούν να προκαλέσουν πίεση. Οι άσκησεις που προορίζονται για χαλάρωση θα ωφελήσουν τους αρουραίους.","malay":"Oleh kumpulan tikus dan menghargai kesejahteraan yang besar. Mereka sangat dinamik yang membantu menjaga mereka dan bersedia untuk melawan penyakit. Mereka boleh kadang-kadang menjadi tegang, kuat, dan penuh dengan daya hidup yang cemas, keadaan yang boleh memberi tekanan. Latihan biasa yang dimaksudkan untuk diam akan bagi keuntungan untuk tikus.","thai":"คนเกิดปีชวดเป็นคนรักสุขภาพ ซึ่งทำให้พวกเขาแข็งแรงและไม่ค่อยเจ็บป่วยบ่อยนัก แต่บางครั้งพวกเขาก็มักจะมีอาการเครียดและวิตกกังวลซึ่งเสี่ยงต่อเรื่องความดันเช่นกัน แต่การออกกำลังอย่างสม่ำเสมอก็เป็นประโยชน์กับพวกเขาเป็นอย่างมาก.","czech":"Velcí krysy obecně oceňují skvělou pohodu. Jsou extrémně dynamičtí, což jim pomáhá udržovat se v kondici jako housle a připraveni odvrátit onemocnění. Mohou být občas napjatí, energičtí a nabití úzkostlivou vitalitou, což jsou podmínky, které mohou vyvolat tlak. Obvyklé cvičení určené k uklidnění bude pro krysy prospěšné.","bulgarian":"Като цяло Плъховете оценяват страхотното благосъстояние. Те са изключително динамични, което им помага да се държат във форма като цигулка и да са готови да се справят с болестта. Понякога те могат да бъдат напрегнати, силни и заредени с тревожна жизненост, състояния, които могат да предизвикат натиск. Обичайното упражнение, предназначено да успокои, ще спечели на Плъхове.","norwegian":"I det store og hele setter rotter stor pris på velvære. De er ekstremt dynamiske, noe som hjelper til med å holde dem i form som en fele og klare til å avverge sykdom. Noen ganger kan de være anspente, kraftige og lastet med engstelig vitalitet, forhold som kan føre til press. Vanlig trening ment å stille vil tjene rotter.","denmark":"I det store og hele sætter rotter pris på stor trivsel. De er ekstremt dynamiske, hvilket hjælper med at holde dem i form som en violin og klar til at afværge lidelse. De kan til tider være anspændte, kraftige og fyldt med ængstelig vitalitet, forhold der kan fremkalde pres. Almindelig øvelse, der er beregnet til at stille, vil gavne rotter.","slovakia":"Veľkí potkany oceňujú skvelú pohodu. Sú mimoriadne dynamické, čo im pomáha udržiavať ich fit ako husle a pripravené odvrátiť chorobu. Môžu byť občas napätí, rázni a nabití úzkostnou vitalitou, stavmi, ktoré môžu vyvolať tlak. Zvyčajné cvičenie určené na upokojenie potkanov bude prospešné.","swedish":"Råttor uppskattar stort sett välmående. De är extremt dynamiska vilket hjälper till att hålla dem i form som en fiol och redo att avvärja sjukdom. De kan ibland vara spända, kraftfulla och laddade med orolig vitalitet, förhållanden som kan leda till tryck. Vanlig träning avsedd att tysta kommer att tjäna råttor.","finnish":"Rotat arvostavat suurta hyvinvointia. Ne ovat erittäin dynaamisia, mikä auttaa pitämään heidät sopivina viuluna ja valmiina torjumaan vaivat. He voivat toisinaan olla jännittyneitä, voimakkaita ja täynnä ahdistavaa elinvoimaa, olosuhteet, jotka voivat aiheuttaa painostusta. Tavallinen liikunta, joka on tarkoitettu hiljaisuuteen, tuo hyötyä Rotille.","romanian":"În general Șobolanii apreciază bunăstarea extraordinară. Sunt extrem de dinamici, ceea ce le ajută să se mențină în formă de lăutărie și gata să îndepărteze boala. Uneori pot fi tensionate, puternice și încărcate cu vitalitate anxioasă, condiții care pot determina presiune. Exercițiul obișnuit destinat linișterii va profita Șobolanilor."},"carrers":{"first_english":"With great understanding and a sharp point of view, Rats have decision making ability in what they do, which empowers them to avoid superfluous issues. Rodents are wary and careful, so they will in general demonstrate a genuine mentality toward their work.","second_english":"Administrator, director, manager, entrepreneur, broadcaster, writer, musician, stand-up comedian, politician, lawyer, researcher, and racing car driver.","first_arabic":"مع الادراك العالي ووجهة النظر الحادة ، لدى الفئران القدرة على اتخاذ القرارات فيما يقومون به ، والتي تمكنهم من تجنب القضايا الزائدة عن الحاجة. الفئران متحفظة وحذرة ، لذلك  عمومًا يظهرون تفكير فريد تجاه عملهم.","second_arabic":"مديرعام ، مديرتوجيهي ، مدير ، رجل أعمال ، مذيع ، كاتب ، موسيقي ، ممثل كوميدي ، سياسي ، محام ، باحث ، وسائق سيارة سباق.","first_greek":"Με μεγάλη κατανόηση και ξεκάθαρη οπτική γωνία, οι αρουραίοι έχουν τη δυνατότητα λήψης αποφάσεων σε ό, τι κάνουν, γεγονός που τους βοηθά να αποφεύγουν περιττά προβλήματα Τα τρωκτικά είναι επιφυλακτικά και προσεκτικά, έτσι θα επιδείξουν γενικά μια γνήσια νοοτροπία προς την εργασία τους.","second_greek":"Υπεύθυνος, διευθυντής, manager, επιχειρηματίας, ραδιοτηλεοπτικός παραγωγός, συγγραφέας, μουσικός, κωμικός, πολιτικός, δικηγόρος, ερευνητής και οδηγός αγώνων.","first_malay":"Dengan pemahaman yang besar dan sudut pandangan yang tepat, Tikus mempunyai keupayaan membuat keputusan dalam apa jua mereka lakukan, yang memberi mereka kuasa untuk mengelakkan masalah yang besar. Tikus sejenis yang berhati-hati sehingga mereka secara umum akan menunjukkan mentaliti tulen ke arah kerja mereka.","second_malay":"Pentadbir, pengarah, pengurus, usahawan, penyiar, penulis, pemuzik, pelawak, ahli politik, peguam, penyelidik, dan pemandu kereta lumba.","first_thai":"คนเกิดปีชวดมีความสามารถในการตัดสินใจในเรื่องต่างๆ เพราะพวกเขามีทัศนคติที่ดี ซึ่งช่วยให้พวกเขาไม่ต้องกังวลกับเรื่องที่ไม่สำคัญ คนเกิดปีชวดเป็นคนรอบคอบ ซึ่งจะเห็นได้จากการทำงานของพวกเขา.","second_thai":"ผู้บริหาร ผู้อำนวยการ ผู้จัดการ ผู้ประกอบการ ผู้ประกาศข่าว นักเขียน นักดนตรีนักแสดงตลก นักการเมือง ทนายความ นักวิจัย และนักขับรถแข่ง.","first_czech":"Díky velkému porozumění a ostrému úhlu pohledu mají krysy rozhodovací schopnosti v tom, co dělají, což jim umožňuje vyhnout se nadbytečným problémům. Hlodavci jsou opatrní a opatrní, takže obecně prokáží svou práci skutečnou mentalitu.","second_czech":"Správce, režisér, manažer, podnikatel, hlasatel, spisovatel, hudebník, komik, politik, právník, výzkumník a řidič závodního vozu.","first_bulgarian":"С голямо разбиране и остра гледна точка, плъховете имат способността да взимат решения в това, което правят, което им дава възможност да избягват излишни проблеми. Гризачите са предпазливи и внимателни, така че като цяло ще демонстрират истински манталитет към работата си.","second_bulgarian":"Администратор, режисьор, мениджър, предприемач, оператор, писател, музикант, комик, политик, адвокат, изследовател и шофьор на състезателни автомобили.","first_norwegian":"Med stor forståelse og et skarpt synspunkt har rotter beslutningsevne i det de gjør, noe som gir dem mulighet til å unngå overflødige problemer. Gnagere er forsiktige og forsiktige, så de vil generelt vise en ekte mentalitet mot sitt arbeid.","second_norwegian":" Administrator, regissør, leder, gründer, kringkaster, skribent, musiker, stand-up komiker, politiker, advokat, forsker og racerbilfører.","first_slovakia":"S veľkým porozumením a ostrým uhlom pohľadu majú potkany rozhodovacie schopnosti v tom, čo robia, čo im umožňuje vyhnúť sa nadbytočným problémom. Hlodavce sú opatrné a opatrné, takže vo svojej práci vo všeobecnosti preukážu skutočnú mentalitu.","second_slovakia":"Správca, režisér, manažér, podnikateľ, vysielateľ, spisovateľ, hudobník, sólový komik, politik, právnik, výskumník a vodič závodných automobilov.","first_denmark":"Med stor forståelse og et skarpt synspunkt har rotter beslutningsevne i, hvad de gør, hvilket giver dem mulighed for at undgå overflødige problemer. Gnavere er forsigtige og forsigtige, så de vil generelt demonstrere en ægte mentalitet over for deres arbejde.","second_denmark":"Administrator, instruktør, manager, iværksætter, tv-station, forfatter, musiker, stand-up komiker, politiker, advokat, forsker og racerbilchauffør.","first_swedish":"Med stor förståelse och en skarp synvinkel har råttor beslutsförmåga vad de gör, vilket ger dem möjlighet att undvika överflödiga frågor. Gnagare är försiktiga och försiktiga, så de kommer i allmänhet att visa en äkta mentalitet mot sitt arbete.","second_swedish":"Administratör, regissör, ​​chef, entreprenör, sändare, författare, musiker, stand-up komiker, politiker, advokat, forskare och racerförare.","first_finnish":"Rotilla on suurta ymmärrystä ja terävä näkökulma päätöksentekokykyyn, mikä antaa heille mahdollisuuden välttää turhia asioita. Jyrsijät ovat varovaisia ​​ja varovaisia, joten he osoittavat yleensä aitoa mentaliteettia työhönsä.","second_finnish":"Järjestelmänvalvoja, johtaja, johtaja, yrittäjä, lähetystoiminnan harjoittaja, kirjailija, muusikko, stand up -koomikko, poliitikko, asianajaja, tutkija ja kilpa-auton kuljettaja.","first_romanian":"Cu o mare înțelegere și un punct de vedere ascuțit, șobolanii au capacitatea de a lua decizii în ceea ce fac, ceea ce îi împuternicește să evite problemele inutile. Rozătoarele sunt precauți și atenți, astfel încât, în general, vor demonstra o mentalitate autentică față de munca lor.","second_romanian":"Administrator, director, manager, antreprenor, radiodifuzor, scriitor, muzician, stand-up comedian, politician, avocat, cercetător și șofer de mașini de curse."},"lucky":{"numbers":[2,3],"colors_english":["Blue","Gold","Green"],"colors_arabic":["ازرق","ذهبي ","اخضر"],"colors_greek":["Μπλε","Χρυσό","Πράσινο"],"colors_malay":["Biru","Emas","Hijau"],"colors_thai":["สีน้ำเงิน","สีทอง","สีเขียว"],"colors_czech":["Modrý","Zlato","Zelená"],"colors_bulgarian":["Син","Злато","Зелено"],"colors_norwegian":["Blå","Gull","Grønn"],"colors_slovakia":["Modrá","Zlato","zelená"],"colors_denmark":["Blå","Guld","Grøn"],"colors_swedish":["Blå","Guld","Grön"],"colors_finnish":["Sininen","Kulta","Vihreä"],"colors_romanian":["Albastru","Aur","Verde"],"directions_english":["West","Northwest","Southwest"],"directions_arabic":["غرب","شمال غربي","جنوب غربي "],"directions_greek":["δυτικά","Βορειοδυτικά","Νοτιοδυτικά"],"directions_malay":["Barat","Barat laut","Barat daya"],"directions_thai":["ทิศตะวันตก","ทิศตะวันตกเฉียงเหนือ","ทิศตะวันตกเฉียงใต้"],"directions_czech":["Západ","Severozápad","Jihozápadní"],"directions_bulgarian":["Запад","Северозападна","Югозапад"],"directions_norwegian":["Vest","Nordvest","Sørvest"],"directions_slovakia":["Západ","Severozápad","Juhozápad"],"directions_denmark":["Vest","Nord Vest","Sydvest"],"directions_swedish":["Väst","Nordväst","Sydväst"],"directions_finnish":["Länteen","Luoteeseen","Lounaaseen"],"directions_romanian":["Vest","Nord Vest","Sud-Vest"]},"unlucky":{"numbers":[5,9],"colors_english":["Brown","Yellow"],"colors_arabic":["بني","اصفر"],"colors_greek":["Καφέ","Κίτρινο"],"colors_malay":["Perang","Kuning"],"colors_thai":["สีน้ำตาล","สีเหลือง"],"colors_czech":["Hnědý","Žlutá"],"colors_bulgarian":["Кафяво","Жълто"],"colors_norwegian":["brun","Gul"],"colors_slovakia":["Hnedá","žltá"],"colors_denmark":["Brun","Gul"],"colors_swedish":["Brun","Gul"],"colors_finnish":["Ruskea","Keltainen"],"colors_romanian":["Maro","Galben"],"directions_english":["South","Southeast"],"directions_arabic":["جنوب","جنوب شرقي"],"directions_greek":["Νότια","Νοτιοανατολικά"],"directions_malay":["Selatan","Tenggara"],"directions_thai":["ทิศใต้","ทิศตะวันออกเฉียงใต้"],"directions_czech":["Jižní","Jihovýchodní"],"directions_bulgarian":["На юг","Югоизток"],"directions_norwegian":["Sør","Sørøst"],"directions_slovakia":["Juh","Juhovýchod"],"directions_denmark":["Syd","Sydøst"],"directions_swedish":["söder","Sydöst"],"directions_finnish":["Etelään","Kaakko"],"directions_romanian":["Sud","Sud Est"]},"love":{"best_english":["Ox","Dragon","Rabbit"],"worst_english":["Horse","Rooster"],"best_arabic":["ثعلب","تنين","ارنب"],"worst_arabic":["حصان","ديك"],"best_greek":["Βόδι","Δράκος","Λαγός"],"worst_greek":["Αλογο","Κόκορας"],"best_malay":["Lembu","Naga","Arnab"],"worst_malay":["Kuda","Ayam"],"best_thai":["ปีฉลู","ปีมะโรง","ปีเถาะ"],"worst_thai":["ปีมะเมีย","ปีระกา"],"best_czech":["Vůl","Drak","Králičí"],"worst_czech":["Kůň","Kohout"],"best_bulgarian":["Вол","Дракон","Заек"],"best_norwegian":["Okse","Drage","Kanin"],"worst_bulgarian":["Кон","Петел"],"worst_norwegian":["Hest","Hane"],"best_slovakia":["Vôl","drak","Králik"],"worst_slovakia":["Kôň","Kohút"],"best_denmark":["Okse","Trække på","Kanin"],"worst_denmark":["Hest","Hane"],"best_swedish":["Oxe","drake","Kanin"],"worst_swedish":["Häst","Tupp"],"best_finnish":["Härkä","Lohikäärme","Kani"],"worst_finnish":["Hevonen","Kukko"],"best_romanian":["Bou","balaur","Iepure"],"worst_romanian":["Cal","Cocoş"]},"years":[1900,1912,1924,1936,1948,1960,1972,1984,1996,2008,2020,2032],"unicode_symbol":"子"},{"sign_english":"Cow","sign_arabic":"ثعلب","sign_greek":"Βόδι","sign_malay":"Lembu","sign_thai":"ปีฉลู","sign_czech":"Vůl","sign_bulgarian":"Вол","sign_norwegian":"Okse","sign_denmark":"Ko","sign_slovakia":"Krava","sign_swedish":"Ko","sign_finnish":"Lehmä","sign_romanian":"Vacă","yin-yang":"Yin","direction":"North","season":"Late Winter","element":"Earth","trine":"2nd","personality":{"first_english":"Involving the second position on the Chinese Zodiac, Oxen have such character attributes as reliability, quality and assurance. Bulls are tolerant people who accept that the way to progress includes diligent work and conscientious conduct; they don't put stock in taking alternate routes. They describe the individuals who don't buckle down as languid people not deserving of regard.","second_english":"Bulls are fit for believing others and will tune in to their conclusions with a receptive outlook. Notwithstanding, Oxen favor settling on choices that depend without anyone else inquire about. Bulls support solid, deep rooted unions to easygoing colleagues.","first_arabic":"يتضمن الموضع الثاني على البروج الصينية ، الثيران لها سمات شخصية مثل الموثوقية والجودة والضمان. الثيران أناس متسامحون يقبلون أن الطريق إلى التقدم يشمل العمل الدؤوب والسلوك الضميري ؛ انهم لا يضعون الأسهم في اتخاذ طرق بديلة. إنهم يصفون الأفراد الذين لا يستخدمون حزام الأمان كأشخاص ضعفاء لا يستحقون الاهتمام.","second_arabic":"تعد الثيران مثالية من ناحية الايمان بالآخرين وسوف تتوافق مع استنتاجاتهم بنظرة متفهمة. على الرغم من ذلك ، تفضل الثيران الوصول لخياراتها بدون أي شخص آخر يستفسر. الثيران تدعم النقابات الثابتة ذات الجذور العميقة لتسهيل الزملاء.","first_greek":"Καταλαμβάνοντας τη δεύτερη θέση στο κινεζικό ωροσκόπιο, τα βόδια έχουν χαρακτηριστικά όπως η αξιοπιστία, η ποιότητα και η διασφάλιση. Τα βόδια είναι ανεκτικοί άνθρωποι που δέχονται ότι ο δρόμος προς την πρόοδο περιλαμβάνει επιμελή εργασία και συνείδηση συμπεριφοράς. Δεν βασίζονται σε εναλλακτικά δρομολόγια. Περιγράφουν τα άτομα που δεν λυγίζουν όπως άλλοι, μικροί άνθρωποι που δεν αξίζουν τον σεβασμό.","second_greek":"Οι ταύροι έχουν πίστη στους άλλους και συντονίζονται με τα συμπεράσματά τους χρησιμοποιώντας μια δεκτική προοπτική. Παρά ταύτα, ένας ταύρος ορίζει τις επιλογές του, χωρίς να εξαρτάται από τρίτους. Οι ταύροι υποστηρίζουν τους συμπαγείς, βαθιά ριζωμένους δεσμούς, διευκολύνοντας τους φίλους τους.","first_malay":"Melibatkan tempat kedua pada Zodiak Cina, Lembu mempunyai ciri-ciri watak seperti kebolehpercayaan, kualiti dan jaminan. Lembu Jantan adalah orang yang toleransi yang menerima jalan ke arah kemajuan termasuk kerja rajin dan kelakuan yang teliti; mereka tidak meletakkan saham dalam mengambil laluan alternatif. Mereka menggambarkan individu-individu yang tidak menonjol sebagai orang yang tidak berkira.","second_malay":"Lembu Jantan adalah sejenis mempercayai orang lain dan akan menyimpulkan kepada kesimpulan mereka dengan pandangan yang diterima. Walaubagaimanapun,Lembu sejenis ada pilihan sendiri dan tidak bergantung pada sesiapapun. Lembu Jantan menyokong kesatuan yang kuat dan sejenis yang mudah masuk dengan sesiapa sahaja.","first_thai":"ปีฉลูถือเป็นปีนักษัตรลำดับที่สองในตำราโหราศาสตร์จีน คนเกิดปีฉลูเป็นคนที่น่าเชื่อถือและไว้ใจได้ พวกเขามีตวามมานะและมีความสุขุมรอบคอบ และไม่แยแสคนที่ไม่ความกระตือรือร้นในการทำงาน.","second_thai":"คนเกิดปีฉลูค่อนข้างเชื่อใจคนอื่นและกล้าเปิดใจกับสิ่งใหม่ๆ นอกจากนี้พวกเขายังชอบช่วยเหลือคนอื่นและเข้ากับเพื่อนร่วมงานได้ดี.","first_czech":"Oxen má druhou pozici na čínském zvěrokruhu a má takové charakterové vlastnosti jako spolehlivost, kvalitu a jistotu. Býci jsou tolerantní lidé, kteří připouštějí, že cesta k pokroku zahrnuje pilnou práci a svědomité chování; nedávají zásoby alternativním trasám. Popisují jednotlivce, kteří se nepohnou jako malátní lidé, kteří si nezaslouží pozornost.","second_czech":"Býci jsou způsobilí věřit ostatním a naladí se na své závěry s vnímavým výhledem. Bez ohledu na to, Voly upřednostňují vypořádání se s možnostmi, které závisí, aniž by se kdokoli jiný dotazoval. Býci podporují solidní, hluboce zakořeněné odbory přátelským kolegům.","first_bulgarian":" Включвайки втората позиция по китайския зодиак, воловете имат такива характерни качества като надеждност, качество и сигурност. Биковете са толерантни хора, които приемат, че пътят към напредъка включва усърдна работа и добросъвестно поведение; те не правят равносметка за алтернативни маршрути. Те описват хората, които не се закопчават, като отпаднали хора, които не заслужават внимание.","second_bulgarian":"Биковете са годни да вярват на другите и ще се приспособят към своите заключения с възприемчива перспектива. Независимо от това, Oxen предпочитат да се справят с избора, който зависи, без никой друг да попита за това. Биковете поддържат солидни, дълбоко вкоренени синдикати на непринудени колеги. ","first_norwegian":" Ved å involvere den andre posisjonen på den kinesiske dyrekretsen har Oxen slike karakteregenskaper som pålitelighet, kvalitet og forsikring. Okser er tolerante mennesker som aksepterer at veien til fremgang inkluderer flittig arbeid og samvittighetsfull oppførsel; de legger ikke lager i å ta alternative ruter. De beskriver individene som ikke spenner seg ned som sløve mennesker som ikke fortjener respekt.","second_norwegian":" Okser er egnet til å tro på andre og vil innstille seg på konklusjonene med et mottakelig syn. Uansett favoriserer Oxen å ta avgjørelse av valg som er avhengige uten at noen andre spør. Okser støtter solide, dypt forankrede fagforeninger til lettgående kolleger.","first_denmark":"Inddragelse af den anden position på den kinesiske stjernetegn har okser sådanne karakteregenskaber som pålidelighed, kvalitet og sikkerhed. Tyrer er tolerante mennesker, der accepterer, at vejen til fremskridt inkluderer flittigt arbejde og samvittighedsfuld opførsel; de lægger ikke lager i at tage alternative ruter. De beskriver de enkeltpersoner, der ikke spænder ned, som sløve mennesker, der ikke fortjener hensyn.","second_denmark":"Okser er egnet til å tro på andre og vil innstille seg på konklusjonene med et mottakelig syn. Uansett favoriserer Oxen å avgjøre valg som er avhengige uten at noen andre spør. Okser støtter solide, dypt forankrede fagforeninger til lettgående kolleger.","first_slovakia":"Oxen má druhú pozíciu na čínskom zverokruhu a má také charakteristické vlastnosti, ako je spoľahlivosť, kvalita a záruka. Býci sú tolerantní ľudia, ktorí pripúšťajú, že cesta k pokroku zahŕňa usilovnú prácu a svedomité správanie; nekladú zásoby pri alternatívnych trasách. Opisujú jednotlivcov, ktorí sa nepotiahnu, ako lenivých ľudí, ktorí si nezasluhujú pozornosť.","second_slovakia":"Býci sú vhodní na to, aby verili iným, a naladia sa na svoje závery s vnímavým výhľadom. Bez ohľadu na to, voly uprednostňujú vyrovnanie sa s rozhodnutiami, ktoré závisia, bez toho, aby sa o nich niekto pýtal. Býci podporujú pevné a hlboko zakorenené odbory pre ľahkovážnych kolegov.","first_swedish":"Inom den andra positionen på den kinesiska zodiaken har Oxen sådana karaktärsegenskaper som tillförlitlighet, kvalitet och försäkran. Tjurar är toleranta människor som accepterar att vägen till framsteg inkluderar flitigt arbete och samvetsgrannhet. de lägger inte lager i att ta alternativa rutter. De beskriver individerna som inte spänns ner som slöa människor som inte förtjänar hänsyn.","second_swedish":"Tjurar är lämpliga för att tro andra och kommer att anpassa sig till deras slutsatser med en mottaglig syn. Trots föredrar Oxen att man väljer val som är beroende av utan att någon annan frågar om. Tjurar stöder fasta, djupt rotade fackföreningar till lättsam kollegor.","first_finnish":"Ottaen huomioon toisen zodiakin toisen sijan, härillä on sellaiset luonteenpiirteet kuin luotettavuus, laatu ja varmuus. Härät ovat suvaitsevaisia ​​ihmisiä, jotka hyväksyvät sen, että tie edistykseksi sisältää ahkeran työn ja tunnollisen käytöksen; he eivät laita varastoa vaihtoehtoisille reiteille. He kuvailevat ihmisiä, jotka eivät solkeudu, raivokkaiksi ihmisiksi, jotka eivät ansaitse huomiota.","second_finnish":"Taurii sunt potriviți pentru a-i crede pe ceilalți și se vor acorda concluziilor lor cu o perspectivă receptivă. Cu toate acestea, Boii preferă să se decidă pe alegeri care depind fără ca cineva să se întrebe. Taurii susțin uniuni solide, adânc înrădăcinate, colegilor ușor.","first_romanian":"Implicând a doua poziție pe zodiacul chinezesc, Boii au atribute de caracter precum fiabilitatea, calitatea și asigurarea. Taurii sunt oameni toleranți care acceptă că calea către progres include muncă sârguincioasă și conduită conștiincioasă; nu fac stocuri în luarea unor rute alternative. Ei descriu indivizii care nu se învârtesc ca oameni slabi care nu merită respectați.","second_romanian":"Härät soveltuvat uskomaan muita ja sopivat päätelmiinsä vastaanottavaisella näkökulmalla. Siitä huolimatta Härät suostuvat asettamaan valintoja, jotka ovat riippuvaisia ​​ilman, että kukaan muu kysyy. Härät tukevat vankkoja, syvään juurtuneita ammattiliittoja rentoille kollegoille."},"health":{"english":"Ox are resilient people who generally are solid and live since a long time ago, satisfied lives. Notwithstanding, they will in general work excessively, once in a while enabling themselves sufficient opportunity to unwind. Bulls could profit by joining more non-business related action into their lives.","arabic":"الثور هم أشخاص منيعين يتمتعون عمومًا بالصلابة ويعيشون منذ فترة طويلة ، ويشعرون بالرضا. على الرغم من ذلك ، سيعملون بشكل عام بشكل مفرط ، من فترة الى اخرى يسمحوا لأنفسهم بالفرصة الكافية للاسترخاء. يمكن للثور الربح من خلال الانضمام إلى المزيد من الإجراءات غير التجارية في حياتهم.","greek":"Οσοι βρίσκονται στον αστερισμό του βοδιού είναι ανθεκτικοί άνθρωποι, γενικά σταθεροί και ζουν από πολύ καιρό πριν, στρωμένες ζωές. Παρόλα αυτά, γενικά δουλεύουν υπερβολικά, παίρνοντας που και που μία ευκαιρία να χαλαρώσουν. Οι ταύροι θα μπορούσαν να επωφεληθούν με τη συμμετοχή περισσότερων δραστηριοτήτων που δεν σχετίζονται με τις επιχειρήσεις στη ζωή τους.","malay":"Lembu adalah orang yang berdaya tahan dan hidup lebih lama dahulu, dan juga senang berpuas hati dengan kehidupan mereka. Walaubagaimanapun, mereka akan bekerja secara umum secara berlebihan, sekali-sekala membolehkan mereka mempunyai peluang yang cukup untuk berehat.lembu Jantan boleh mendapat keuntungan dengan menyertai aktiviti yang tidak berkaitan dengan perniagaan dalam kehidupan mereka.","thai":"คนเกิดปีฉลูเป็นคนยืดหยุ่นและค่อนข้างพอใจกับชีวิตของพวกเขา แต่บางครั้งพวกเขาก็เป็นคนประเภททำงานอย่างหักโหม แต่ก็สามารถจัดการสิ่งต่างๆได้ดี คนเกิดปีฉลูควรหากิจกรรมพักผ่อนหย่อนใจทำเพื่อสร้างสมดุลให้กับชีวิตพวกเขา.","czech":"Buvoli jsou odolní lidé, kteří jsou obecně solidní a žijí už dávno, spokojenými životy. Bez ohledu na to budou obecně pracovat nadměrně, jednou za čas, což jim umožní dostatek příležitostí k odpočinku. Býci by mohli profitovat tím, že se do svých životů zapojí více akcí, které nesouvisejí s podnikáním.","bulgarian":"Воловете са издръжливи хора, които обикновено са солидни и живеят отдавна, доволни животи. Независимо от това, те като цяло ще работят прекомерно, като от време на време си позволяват достатъчна възможност да се отпуснат. Биковете биха могли да спечелят, като се присъединят към повече не свързани с бизнеса действия в живота си.","norwegian":" Ved å involvere den andre posisjonen på den kinesiske dyrekretsen har Oxen slike karakteregenskaper som pålitelighet, kvalitet og forsikring. Okser er tolerante mennesker som aksepterer at veien til fremgang inkluderer flittig arbeid og samvittighetsfull oppførsel; de legger ikke lager i å ta alternative ruter. De beskriver individene som ikke spenner seg ned som sløve mennesker som ikke fortjener respekt.","denmark":"Ox er modstandsdygtige mennesker, der generelt er solide og lever siden for lang tid siden, tilfredse liv. Ikke desto mindre vil de generelt arbejde for meget, en gang imellem giver de sig selv tilstrækkelig mulighed for at slappe af. Tyrer kunne drage fordel ved at slutte sig til mere ikke-forretningsrelateret handling i deres liv.","slovakia":"Vôl sú odolní ľudia, ktorí sú vo všeobecnosti pevní a žijú už dávno, spokojnými životmi. Napriek tomu budú spravidla pracovať nadmerne, raz za čas a poskytnú si dostatočnú príležitosť na odpočinok. Býci by mohli profitovať tým, že sa do svojich životov zapoja viac nepodnikateľských akcií.","swedish":"Ox är motståndskraftiga människor som i allmänhet är solida och lever sedan för länge sedan, nöjda liv. Trots det kommer de i allmänhet att arbeta överdrivet, en gång i taget och göra det möjligt för sig själva att ha tillräcklig möjlighet att varva ner. Tjurar kunde tjäna pengar genom att gå med i mer icke-affärsrelaterade åtgärder i sina liv.","finnish":"Härkä on kestävä ihminen, joka yleensä on vankka ja elää jo kauan sitten tyydyttävää elämää. Siitä huolimatta he työskentelevät yleensä liikaa, joskus antavat itselleen riittävän mahdollisuuden rentoutua. Sonnit voisivat hyötyä liittämällä enemmän ei-yritystoimintaa heidän elämäänsä.","romanian":"Boii sunt oameni rezistenți, care sunt, în general, solizi și trăiesc de multă vreme, trăind mulțumiți. Cu toate acestea, în general, aceștia vor lucra excesiv, din când în când, oferindu-și posibilitatea de a se relaxa. Taurii ar putea profita alăturând mai multor acțiuni care nu sunt legate de afaceri în viața lor."},"carrers":{"first_english":"As the image of diligent work, Ox individuals consistently buckle down at everything and stick to completing it. Having a genuine and mindful demeanor toward work, they can think of various ways to deal with their undertaking.","second_english":"Farming, fabricating, drug store, mechanics, building, draftsmanship, creativity, governmental issues, land, inside plan, painting, carpentry, or quarry work.","first_arabic":"كصورة للعمل الدؤوب ، يقوم أفراد  ثور بتشمير عن سواعدهم  باستمرار في كل شيء والتمسك به. لديهم سلوك حقيقي وعقلاني تجاه العمل ، يمكنهم التفكير في طرق مختلفة للتعامل مع اي قضية تواجههم.","second_arabic":"العمل في الزراعة أو التصنيع أو تخزين الأدوية أو الميكانيكا أو البناء أو المسودات أو الإبداع أو القضايا الحكومية أو الأرض أو التخطيط الداخلي أو الطلاء أو النجارة أو المحاجر.","first_greek":"Ως εικόνα της επιμελούς δουλειάς, τα βόδια εστιάζουν σταθερά σε κάθε πρόβλημα και εμμένουν μέχρι τη λύση του. Έχοντας μια αυθεντική και προσεκτική συμπεριφορά προς την εργασία, μπορούν να σκεφτούν διάφορους τρόπους να φέρουν σε πέρας αυτό που έχουν αναλάβει.","second_greek":"Γεωργία, κατασκευές, φαρμακείο, μηχανική, οικοδομή, συντάκτης, δημιουργικότητα, κυβερνητικά ζητήματα, κτηματολογικά, εσωτερικό σχέδιο, ζωγραφική, ξυλουργική ή λατομείο.","first_malay":"Sebagai imej pekerja yang rajin, individu yang lahir pada tahun lembu sejenis yang membuat pekerjaan dengan sempurna. Mempunyai sikap yang tulus dan penuh berhati-hati terhadap pekerjaan mereka. Mereka boleh memikirkan pelbagai cara untuk menangani masalah mereka.","second_malay":"Pertanian, fabrik, kedai ubat, mekanik, bangunan, penggambaran, kreativiti, isu-isu kerajaan, tanah, pelan dalam, lukisan, pertukangan, atau kerja kuari.","first_thai":"คนเกิดปีฉลูเป็นคนขยัน พวกเขาพร้อมทุ่มเทความสามารถที่มีอยู่เพื่อให้งานสำเร็จลุล่วงและสำเร็จลุล่วง และเพราะนิสัยที่ชอบจดจ่อกับงาน พวกเขาจึงมีความสามารถในการรับมือกับเรื่องต่างๆได้เป็นอย่างดี.","second_thai":"เกษตรกรรม งานทอผ้า ร้านขายยา เครื่องจักกล งานก่อสร้าง งานเขียนแบบ ความคิดสร้างสรรค์ ปัญหาของรัฐบาล ที่ดิน ออกแบบภายใน งานทาสี งานช่างไม้ หรืองานเหมืองหิน.","first_czech":"Jako obraz pilné práce se jednotlivci Ox neustále na všechno vrhají a drží se toho, aby to dokončili. Když mají skutečné a vědomé vystupování v práci, mohou vymýšlet různé způsoby, jak se vypořádat se svým podnikáním.","second_czech":"Zemědělství, výroba, obchod s drogami, mechanika, budova, kresba, kreativita, vládní záležitosti, půda, vnitřní plán, malířství, tesařství nebo lom.","first_bulgarian":" Като образ на усърдната работа, хората от Вола постоянно се придържат към всичко и се придържат към завършването му. Имайки искрено и внимателно поведение към работата, те могат да измислят различни начини да се справят с начинанието си.","second_bulgarian":"Земеделие, производство, аптека, механика, строителство, чертежи, творчество, държавни въпроси, земя, вътрешен план, боядисване, дърводелство или кариерни работи. ","first_norwegian":" Som et bilde av flittig arbeid spenner Ox-individer konsekvent ned på alt og holder seg til å fullføre det. Når de har en ekte og oppmerksom holdning til arbeid, kan de tenke på forskjellige måter å takle sitt arbeid på","second_norwegian":" Jordbruk, fabrikasjon, apotek, mekanikk, bygning, tegning, kreativitet, statlige spørsmål, land, plan, maling, snekring eller steinbrudd.","first_denmark":"Som billedet af flittigt arbejde spænder Ox-individer konsekvent ned ved alt og holder sig til at fuldføre det. Når de har en ægte og opmærksom opførsel over for arbejde, kan de tænke på forskellige måder at tackle deres arbejde på.","second_denmark":"Landbrug, fabrikation, apotek, mekanik, bygning, tegning, kreativitet, statslige spørgsmål, jord, indvendig plan, maling, tømrerarbejde eller stenbrud.","first_slovakia":"Ako obraz usilovnej práce sa jednotlivci Ox neustále na všetko pripútavajú a držia sa toho, aby to dokončili. Majú skutočné a ohľaduplné vystupovanie v práci a môžu myslieť na rôzne spôsoby, ako sa vyrovnať so svojím záväzkom.","second_slovakia":"Poľnohospodárstvo, výroba, obchod s drogami, mechanika, budova, kreslenie, tvorivosť, vládne záležitosti, pôda, vnútorný plán, maľovanie, stolárstvo alebo kameňolom.","first_swedish":"Som bilden av flitigt arbete spänner Ox-individer konsekvent ner på allt och håller fast vid det. Med en äkta och medveten uppförande mot arbete kan de tänka på olika sätt att hantera sitt åtagande.","second_swedish":"Jordbruk, tillverkning, apotek, mekanik, byggnad, ritning, kreativitet, statliga frågor, mark, plan, målning, snickeri eller stenbrott.","first_finnish":"Huolellisen työn kuvana härkäsi ihmiset tarttuvat jatkuvasti kaikkeen ja pitävät kiinni siitä. Kun heillä on todellinen ja tietoinen käytös työhön, he voivat miettiä erilaisia ​​tapoja käsitellä sitoumustaan.","second_finnish":"Maanviljely, valmistus, huumekauppa, mekaniikka, rakennus, luonnos, luovuus, julkiset asiat, maa, sisäpiirros, maalaus, puusepäntyöt tai louhostyöt.","first_romanian":"Ca imagine a muncii sârguincioase, indivizii cu boi se îndoaie în mod constant de toate și rămân la final. Având un comportament autentic și conștient față de muncă, ei se pot gândi la diferite moduri de a face față angajamentului lor.","second_romanian":"Agricultură, fabricare, farmacie, mecanică, construcție, desen, desen creativ, probleme guvernamentale, terenuri, plan interior, pictură, tâmplărie sau carieră."},"lucky":{"numbers":[1,4],"colors_english":["Green","Yellow","White"],"colors_arabic":["اخضر","اصفر ","Πράσινο"],"colors_greek":["Πράσινο","Κίτρινο","Λευκο"],"directions_english":["North","South"],"directions_arabic":["شمال","جنوب"],"directions_greek":["Βοράς","Νότια"],"colors_malay":["Hijau","Kuning","Putih"],"directions_malay":["Utara","Selatan"],"colors_thai":["สีเขียว","สีเหลือง","สีขาว"],"directions_thai":["ทิศเหนือ","ปีขาล"],"colors_czech":["Zelená","Žlutá","Bílý"],"directions_czech":["Severní","Jižní"],"colors_bulgarian":["Зелено","Жълто","Бял"],"colors_norwegian":["Grønn","Gul","Hvit"],"directions_bulgarian":["север","Югоизток"],"directions_norwegian":["Nord","Sørøst"],"colors_slovakia":["zelená","Gul","biely"],"directions_slovakia":["Sever","Juh"],"colors_denmark":["Grøn","žltá","hvid"],"directions_denmark":["Nord","Syd"]},"unlucky":{"numbers":[5,6],"colors_english":["Blue"],"colors_arabic":["ازرق"],"colors_greek":["Μπλε"],"directions_english":["Southwest"],"directions_arabic":["جنوب غربي"],"directions_greek":["Νοτιοδυτικά"],"colors_malay":["Biru"],"directions_malay":["Barat daya"],"colors_thai":["สีน้ำเงิน"],"directions_thai":["ทิศตะวันตกเฉียงใต้"],"colors_czech":["Modrý"],"directions_czech":["Jihozápadní"],"colors_slovakia":["Modrá"],"directions_slovakia":["Juhozápad"],"colors_denmark":["Blå"],"directions_denmark":["Sydvest"],"colors_bulgarian":["Син"],"colors_norwegian":["Blå"],"directions_bulgarian":["Югозапад"],"directions_norwegian":["Sørvest"]},"love":{"best_english":["Rat","Monkey","Rooster"],"worst_english":["Tiger","Dragon","Horse","Goat"],"best_arabic":["الفأر","القرد","ديك"],"worst_arabic":["نمر","تنين","حصان","الماعز"],"best_greek":["Αρουραίος","Πίθηκος","Κόκορας"],"worst_greek":["Τίγρη","Δράκος","Αλογο","Κατσίκα"],"best_malay":["Tikus","Monyet","Ayam"],"worst_malay":["Harimau","Naga","Kuda","Kambing"],"best_thai":["ปีชวด","ปีวอก","ปีระกา"],"worst_thai":["ปีขาล","ปีมะโรง","ปีมะเมีย","ปีมะแม"],"best_czech":["Krysa","Opice","Kohout"],"worst_czech":["Tygr","Drak","Kůň","Koza"],"best_denmark":["Rotte","Abe","Hane"],"worst_denmark":["Tiger","Trække på","Hest","Ged"],"best_slovakia":["Rat","Opica","Kohút"],"worst_slovakia":["Tiger","drak","Kôň","Koza"],"best_bulgarian":["Плъх","Маймуна","Петел"],"best_norwegian":["Rotte","Ape","Hane"],"worst_bulgarian":["тигър","Дракон","Кон","Козел"],"worst_norwegian":["Tiger","Drage","Hest","Geit"]},"years":[1901,1913,1925,1937,1949,1961,1973,1985,1997,2009,2021,2033],"unicode_symbol":"丑"},{"sign_english":"Tiger","sign_arabic":"نمر ","sign_greek":"Τίγρη","sign_malay":"Harimau","sign_thai":"ปีขาล","sign_czech":"Tygr","sign_bulgarian":"тигър","sign_norwegian":"Tiger","sign_slovakia":"Tiger","sign_denmark":"Tiger","sign_swedish":"Tiger","sign_finnish":"Tiikeri","sign_romanian":"Tigru","yin-yang":"Yang","direction":"East","season":"Early Spring","element":"Wood","trine":"3rd","personality":{"first_english":"Involving the third position on the Chinese Zodiac, the Tiger symbolizes such character characteristics as fortitude, intensity and flightiness. Tigers love to be tested and will acknowledge any demand in the event that it means ensuring a friend or family member or securing their respect. They don't stress over the result since they realize they'll generally arrive on their feet. Try not to give their quiet appearance a chance to trick you however; Tigers will jump when they feel it's fundamental.","second_english":"Destined to lead, Tigers can be obstinate on the off chance that they understand they're not in control. They have a slight propensity to be narrow minded however generally speaking, Tigers are very liberal. They're canny and they're generally on caution. Tigers are beguiling and are popular with others. They are not propelled by cash or power.","first_arabic":"يعتبر المركز الثالث على البروج الصينية ، يرمز النمر إلى خصائص الشخصية مثل الثبات والشدة والطيران. يحب النمور أن يتم اختبارهم وسوف يعترفون بأي طلب في حال كان هذا يعني ضمان وجود صديق أو أحد أفراد أسرته أو تأمين احترامهم. لا يشددون على النتيجة لأنهم يدركون أنهم سيصلون على أقدامهم بشكل عام. حاول ألا تعطي مظهرها الهادئ فرصة لخداعك ؛ سوف النمور القفز عندما يشعرون أنه أمر ضروري للبقاء.","second_arabic":"مقدر للقيادة ، يمكن أن يتمسك النمور بفرصة يعلمون أنهم لا يسيطرون عليها. لديهم ميل طفيف إلى أن تكون ضيقة الأفق ولكن بصفة عامة ، النمور متفتحة للغاية. إنهم ذوو حكمة وهم عمومًا على حذر. النمور فاتنة وتحظى بشعبية مع الآخرين. فهي ليست متاثرة بالمال أوالقوة.","first_greek":"καταλαμβάνοντας την τρίτη θέση στο κινέζικο ωροσκόπιο, η Τίγρη συμβολίζει τέτοια χαρακτηριστικά χαρακτήρα όπως η δύναμη, η ένταση και η τάση για φλερτ. Οι τίγρεις αγαπούν να δοκιμάζονται και θα δεχτούν οποιαδήποτε δοκιμασία σε περίπτωση που αυτό σημαίνει την εξασφάλιση ενός φίλου ή μέλους της οικογένειας ή και την εξασφάλιση του σεβασμού τους. Δεν τονίζουν το αποτέλεσμα αφού συνειδητοποιούν ότι βαζίζονται γενικά στα πόδια τους. Προσπαθήστε να μην δώσετε στην ήσυχη εμφάνιση τους την ευκαιρία να σας ξεγελάσουν εντούτοις. Οι τίγρεις θα κάνουν το άλμα όταν αισθάνονται ότι είναι απαραίτητο.","second_greek":"Προορισμένες να οδηγούν, οι Τίγρεις μπορούν να είναι επιθετικες εάν αντιληφθούν ότι δεν έχουν τον έλεγχο. Έχουν μια μικρή τάση να είναι στενόμυαλες, εντούτοις γενικά μιλώντας, οι τίγρεις είναι πολύ φιλελεύθερες. Είναι γενικά πολύ προσεκτικές. Οι τίγρεις είναι ευχάριστες είναι δημοφιλείς με τους άλλους. Δεν στοχεύουν στα μετρητά ή την εξουσία.","first_malay":"Melibatkan tempat ketiga pada Zodiak Cina, Harimau melambangkan ciri-ciri watak seperti ketabahan,kekuatan dan kesungguhan.Harimau suka diuji dan mereka sejenis yang akan memastikan rakan dan ahli keluarga mereka menghormati permintaan mereka.Mereka tidak cepat stress dengan hasil mereka kerana mereka percaya dengan berdiri di kaki sendiri.Jangan bagi sebarang reaksi yang diam kepada mereka dan peluang untuk mereka menipu anda walaubagaimanapun,harimau akan bertindak sekiranya  mereka berasa tergugat.","second_malay":"Ditakdirkan untuk memimpin, harimau boleh menjadi keras kepala atas peluang yang ada pada mereka jika mereka tidak dikawal.Mereka mempunyai kecenderungan sedikit dan pemikiran yang sempit tetapi secara umumnya, harimau sangat terbuka. Mereka sejenis yang cenderung dan secara amnya sangat berhati-hati. Harimau sejenis yang ada daya tarikan dan popular dengan orang yang berada disekelilingnya.Mereka tidak berminat dengan wang atau kuasa.","first_thai":"ปีขาลถือเป็นปีนักษัตรลำดับที่สามในตำราโหราศาสตร์จีน คนเกิดปีขาลเป็นคนอดทน จริงจัง และกล้าหาญ พวกเขาชอบความท้าทายในชีวิตและเป็นคนกตัญญูและเป็นที่พึ่งของเพื่อนและครอบครัว คนเกิดปีขาลเป็นคนที่ยืดหยัดด้วยลำแข้งของตัวเองและพร้อมจะต่อสู้เพื่อสิ่งที่พวกเขาต้องการ.","second_thai":"คนเกิดปีขาลเป็นคนหัวดื้อถึงแม้พวกเขาจะรู้ว่าโอกาสที่ได้สิ่งนั้นแทบไม่มี พวกเขาค่อนข้างเอาแต่ใจตัวเองและรักอิสระ คนเกิดปีขาลเป็นคนฉลาดหลักแหลม เจ้าเล่ห์และรอบคอบ แต่พวกเขาก็ไม่ได้ยึดติดกับเงินหรืออำนาจ.","first_czech":"Zapojením třetí pozice na čínském zvěrokruhu symbolizuje tygr takové charakterové vlastnosti, jako je statečnost, intenzita a letovost. Tygři rádi testují a uznají jakýkoli požadavek v případě, že to znamená zajistit přítele nebo člena rodiny nebo zajistit jejich respekt. Nestresují se výsledkem, protože si uvědomují, že se obvykle dostanou na nohy. Snažte se však nedat jejich tichému vzhledu šanci vás oklamat; Tygři skočí, až budou mít pocit, že je to zásadní.","second_czech":"Tigers, kteří jsou předurčeni k vedení, mohou být neústupní, pokud pochopí, že nemají kontrolu. Mají mírný sklon k omezenosti, ale obecně řečeno, tygři jsou velmi liberální. Jsou hloupí a jsou obecně opatrní. Tygři jsou okouzlující a jsou oblíbení u ostatních. Nejsou poháněni penězi ani mocí.","first_bulgarian":" Включвайки третата позиция на китайския зодиак, Тигърът символизира такива характеристики на характера като твърдост, интензивност и летливост. Тигрите обичат да бъдат тествани и ще признаят всяко искане, в случай че това означава да се осигури приятел или член на семейството или да се гарантира тяхното уважение. Те не се стресират върху резултата, тъй като осъзнават, че обикновено ще пристигнат на крака. Опитайте се обаче да не давате шанс на тихия им външен вид да ви подмами; Тигрите ще скочат, когато почувстват, че това е основно.","second_bulgarian":"Ved å involvere den tredje posisjonen på den kinesiske dyrekretsen, symboliserer Tiger slike karakteregenskaper som styrke, intensitet og flyktighet. Tigre elsker å bli testet og vil erkjenne ethvert krav i tilfelle det betyr å sikre en venn eller et familiemedlem eller sikre deres respekt. De stresser ikke over resultatet siden de innser at de vanligvis kommer på beina. Prøv å ikke gi det stille utseendet en sjanse til å lure deg; Tigre vil hoppe når de føler at det er grunnleggende. ","first_norwegian":" Предназначени да водят, Тигрите могат да бъдат упорити, когато разберат, че не контролират. Те имат лека склонност да бъдат тесни, но най-общо казано, Тигрите са много либерални. Те са хитри и обикновено са предпазливи. Тигрите са примамливи и са популярни сред другите. Те не се задвижват от пари или енергия.","second_norwegian":"Destinert til å lede, kan tigre være hardnakkende på sjansen for at de forstår at de ikke har kontroll. De har en liten tilbøyelighet til å være trangsynt, men generelt er tigre veldig liberale. De er klissete og er generelt på forsiktighet. Tigre lurer og er populære blant andre. De drives ikke av kontanter eller kraft. ","first_denmark":"Involvering af den tredje position på den kinesiske stjernetegn symboliserer tigeren karakterkarakteristika som styrke, intensitet og flygtighed. Tigre elsker at blive testet og vil anerkende ethvert krav i tilfælde af at det betyder at sikre en ven eller et familiemedlem eller sikre deres respekt. De stresser ikke over resultatet, da de indser, at de generelt kommer på benene. Forsøg ikke at give deres stille udseende en chance for at narre dig dog; Tigre vil hoppe, når de føler, at det er grundlæggende.","second_denmark":"Destinert til å lede, kan tigre være hardnakkende på sjansen for at de forstår at de ikke har kontroll. De har en liten tilbøyelighet til å være trangsynt, men generelt er tigre veldig liberale. De er klissete, og de er generelt på forsiktighet. Tigre lurer og er populære blant andre. De drives ikke av penger eller kraft.","first_slovakia":"Tiger, zapojený do tretej pozície na čínskom zverokruhu, symbolizuje také charakterové vlastnosti, ako je pevnosť, intenzita a letová schopnosť. Tigre sú radi testované a uznajú každú požiadavku v prípade, že to znamená zabezpečiť priateľa alebo člena rodiny alebo zabezpečiť ich rešpekt. Nestresujú sa výsledkom, pretože si uvedomujú, že sa spravidla dostanú na nohy. Snažte sa však nedať ich tichému vzhľadu šancu oklamať vás; Tigre skočia, keď cítia, že je to zásadné.","second_slovakia":"Keď robia svojich nepriateľov, tigre majú tendenciu skočiť na svoju prácu. O chvíľu nato sa cítia vyčerpaní. Napriek tomu, že sa pred časom dobre odrazia, môže po určitom čase táto metodika spôsobiť problémy s ich blahobytom. Tigre si musia vybudovať čoraz upravenejší spôsob riešenia života, aby mohli svoju vitalitu využívať ešte efektívnejšie.","first_swedish":"Implicând cea de-a treia poziție pe zodiacul chinezesc, Tiger simbolizează caracteristici ale caracterului precum forța, intensitatea și volabilitatea. Tigrilor le place să fie testați și vor recunoaște orice cerere în cazul în care aceasta înseamnă asigurarea unui prieten sau membru al familiei sau asigurarea respectului lor. Nu se stresează asupra rezultatului, deoarece își dau seama că vor ajunge în general pe picioare. Încearcă să nu oferi aspectului lor liniștit șansa de a te păcăli; Tigrii vor sări atunci când consideră că este fundamental.","second_swedish":"Tigrarna är avsedda att leda, om de inte förstår att de inte kontrollerar. De har en liten benägenhet att vara trångsynt men generellt sett är tigrarna mycket liberala. De är läskiga och de brukar vara försiktiga. Tigrar lurar och är populära bland andra. De drivs inte av kontanter eller makt.","first_finnish":"Ottaen mukaan kolmannen sijan Kiinan eläinradalla, Tiikeri symboloi sellaisia ​​luonteenpiirteitä kuin lujuus, voimakkuus ja lentävyys. Tiikerit rakastavat testata ja tunnustavat kaikki vaatimukset, jos se tarkoittaa ystävän tai perheenjäsenen varmistamista tai heidän kunnioituksensa turvaamista. He eivät stressaa tulosta, koska he ymmärtävät pääsevänsä yleensä jaloilleen. Yritä olla antamatta heidän hiljaiselle ulkonäöltään mahdollisuutta huijata sinua; Tiikerit hyppäävät, kun he kokevat sen olevan perustavaa laatua.","second_finnish":"Johtamaan tarkoitetut tiikerit voivat olla itsepäisiä, jos he ymmärtävät, etteivät he hallitse. Heillä on pieni taipumus olla kapea-aikaisia, mutta yleisesti ottaen tiikerit ovat hyvin liberaaleja. He ovat karkeita ja ovat yleensä varovaisia. Tiikerit ovat hämmentäviä ja suosittuja muiden keskuudessa. Niitä ei käytetä käteisellä tai voimallar.","first_romanian":"Med den tredje positionen på den kinesiska zodiaken symboliserar Tiger sådana karaktärsegenskaper som styrka, intensitet och flyktighet. Tigrar älskar att testas och kommer att erkänna alla krav i händelse av att det innebär att säkerställa en vän eller familjemedlem eller säkra deras respekt. De stressar inte över resultatet eftersom de inser att de generellt kommer fram på fötterna. Försök att inte ge deras tysta utseende en chans att lura dig dock; Tigrar hoppar när de känner att det är grundläggande.","second_romanian":"Destinate conducerii, Tigrii pot fi obstinați cu șansa că înțeleg că nu au controlul. Au o ușoară înclinație spre a fi îngrijiți, totuși, în general, tigrii sunt foarte liberali. Sunt cani și, în general, sunt precauți. Tigrii sunt amăgitori și sunt populari cu alții. Nu sunt propulsate de bani sau putere."},"health":{"english":"As they do their foes, Tigers tend to jump on their work. A short time later, they're left feeling depleted. In spite of the fact that they'll before long ricochet appropriate back, after some time this methodology can cause issues with their wellbeing. Tigers need to build up an increasingly adjusted way to deal with life so they can use their vitality all the more proficiently.","arabic":"كما يفعلون منافسيهم، تميل النمور الانكباب على عملهم. بعد وقت قصير ، يتملكهم الشعور بالإحباط. على الرغم من حقيقة أنهم سوف يعودون بعد فترة ليست طويلة من الارتداد المناسب ، إلا أنه بعد مرور بعض الوقت ، يمكن لهذه المنهجية أن تتسبب في مشاكل مع صحتهم. يحتاج النمور إلى بناء طريقة معتدلة بشكل متزايد للتعامل مع الحياة حتى يتمكنوا من استخدام حيويتهم بشكل أكثر كفاءة.","greek":"Όπως κάνουν και οι εχθροί τους, οι Τίγρεις τείνουν να εστιάζουν στη δουλειά τους. Λίγο καιρό αργότερα, αυτό αφήνει ένα αίσθημα εξάντλησης. Παρά το γεγονός ότι το γνωρίζουν, μετά από λίγο καιρό, αυτή η μεθοδολογία μπορεί να προκαλέσει προβλήματα με την ευημερία τους. Οι τίγρεις πρέπει να οικοδομήσουν έναν ολοένα και περισσότερο προσαρμοσμένο τρόπο αντιμετώπισης της ζωής, ώστε να μπορούν να αξιοποιήσουν τη ζωτικότητά τους πιο αποτελεσματικά.","malay":"Seperti yang dilakukan oleh musuh mereka,harimau lebih cepat cenderung dan akan bagi kesimpulan terhadap kerja mereka.Dalam masa yang singkat, mereka akan cepat berputus asa. Walaupun hakikatnya,mereka akan hidup lebih lama sebelum pemantauan dilakukan dengan sewajarnya.Selepas beberapa masa, metodologi dilakukan untuk mengenal pasti kesejahteraan kehidupan mereka.Harimau perlu membina cara yang lebih sesuai untuk menangani kehidupan mereka agar menggunakan daya tenaga mereka dengan lebih mahir.","thai":"คนเกิดปีขาลเป็นคนคิดเร็วทำเร็ว และภาคภูมิใจในผลงานของตัวเอง แต่เพราะการเชื่อมั่นในสมรรถภาพและความสามารถของตัวเองมากเกินไป บางครั้งก็ทำให้พวกเขาเจ็บป่วยหรือไม่สบายได้เหมือนกัน ดังนั้นพวกเขาจำเป็นต้องปรับสไตล์การใช้ชีวิตบ้างเพื่อสุขภาพกายและใจที่สมบูรณ์แข็งแรง.","czech":"Jak dělají své nepřátele, tygři mají tendenci skočit na svou práci. Krátce nato se cítí vyčerpaní. I přes to, že se před dlouhou dobou dobře odrazí, může tato metodika po nějaké době způsobit problémy s jejich blahobytem. Tygři si musí vybudovat stále více přizpůsobený způsob, jak se vypořádat se životem, aby mohli svou vitalitu využívat ještě efektivněji.","bulgarian":"Докато правят враговете си, Тигрите са склонни да се справят с работата си. Малко по-късно те се чувстват изчерпани. Въпреки факта, че преди дълго ще рикошетират подходящо обратно, след известно време тази методология може да предизвика проблеми с тяхното благосъстояние. Тигрите трябва да изградят все по-адаптиран начин за справяне с живота, за да могат да използват жизнеността си още по-умело.","norwegian":"Når de gjør fiender, har Tigre en tendens til å hoppe på arbeidet sitt. En kort tid senere blir de igjen utarmede. Til tross for at de snart vil ricochet passe tilbake, kan denne metoden etter en tid forårsake problemer med deres velvære. Tigre må bygge opp en stadig mer justert måte å takle livet på, slik at de kan bruke vitaliteten enda bedre.","denmark":"Når de gør deres fjender, har Tigre en tendens til at springe på deres arbejde. Kort tid senere bliver de udladede. På trods af at de inden længe vil ricochet passende tilbage, kan denne metode efter nogen tid medføre problemer med deres velbefindende. Tigre har brug for at opbygge en stadig mere tilpasset måde at håndtere livet på, så de kan bruge deres vitalitet endnu bedre.","slovakia":"Keď robia svojich nepriateľov, tigre majú tendenciu skočiť na svoju prácu. O chvíľu nato sa cítia vyčerpaní. Napriek tomu, že sa pred časom dobre odrazia, môže po určitom čase táto metodika spôsobiť problémy s ich blahobytom. Tigre si musia vybudovať čoraz upravenejší spôsob riešenia života, aby mohli svoju vitalitu využívať ešte efektívnejšie.","swedish":"När de gör sina fiender tenderar Tigrar att hoppa på sitt arbete. En kort tid senare är de kvar utarmade. Trots det faktum att de snart kommer att ricochet passa tillbaka, efter en tid kan denna metod orsaka problem med deras välbefinnande. Tigrar måste bygga upp ett alltmer anpassat sätt att hantera livet så att de kan använda sin vitalitet ännu bättre.","finnish":"Kun he tekevät vihollisiaan, Tigers pyrkii hyppäämään työhönsä. Pian aikaa myöhemmin heidät on jäljellä tyhjentyneinä. Huolimatta siitä, että he rikostavat ennen pitkää sopivaa takaisin, jonkin ajan kuluttua tämä menetelmä voi aiheuttaa ongelmia heidän hyvinvoinnissaan. Tiikereiden on rakennettava entistä mukautetumpi tapa käsitellä elämää, jotta he voivat käyttää elinvoimaaan entistä taitavammin.","romanian":"În timp ce își fac dușmanii, tigrii tind să-și sară munca. La scurt timp, se simt epuizați. În ciuda faptului că, în scurt timp, vor ricoșa înapoi, după ceva timp această metodologie poate provoca probleme cu starea lor de bine. Tigrii trebuie să construiască un mod din ce în ce mai ajustat de a face față vieții, astfel încât să își poată folosi vitalitatea cu atât mai mult competență."},"carrers":{"first_english":"The Tiger, called 'the king of the signs' in China, is usually the center of attention. They are born with leadership skills and they are respected by others. Tigers are suited to any career as leaders.","second_english":"Advertising agent, office manager, travel agent, actor, writer, artist, pilot, flight attendant, musician, comedian, and chauffeur.","first_arabic":"النمر ، يطلق عليه 'ملك العلامات' في الصين ، عادة ما يكون مركز الاهتمام. إنهم يولدون بمهارات القيادة ويحترمون الآخرين. النمور مناسبة لأي مهنة كقادة.","second_arabic":"وكيل إعلانات ، مدير مكتب ، وكيل سفريات ، ممثل ، كاتب ، فنان ، طيار ، مضيف طيران ، موسيقي ، ممثل كوميدي ، وسائق.","first_greek":"Η Τίγρη, που ονομάζεται «ο βασιλιάς των σημείων» στην Κίνα, είναι συνήθως το κέντρο της προσοχής. Γεννιούνται με δεξιότητες ηγεσίας και γίνονται σεβαστές από άλλους. Οι τίγρεις είναι κατάλληλες για οποιαδήποτε καριέρα ως ηγέτες.","second_greek":"Διαφημιστικός πράκτορας, διευθυντής γραφείου, ταξιδιωτικός πράκτορας, ηθοποιός, συγγραφέας, καλλιτέχνης, πιλότος, αεροσυνοδός, μουσικός, κωμικός και σοφέρ.","first_malay":"Harimau, dipanggil 'Raja' di China, biasanya menjadi pusat perhatian. Mereka dilahirkan dengan kemahiran kepimpinan dan mereka dihormati oleh orang lain. Harimau sesuai dengan kerjaya sebagai Ketua.","second_malay":"Ejen pengiklanan, pengurus pejabat, agent perlancongan, pelakon, penulis, artis, Juruterbang,Pramugari, pemuzik, pelawak, dan pemandu.","first_thai":"ปีขาลถือเป็นราชาแห่งปีนักษัตรตามความเชื่อของคนจีนเพราะเป็นที่สนใจของคนรอบข้าง คนเกิดปีขาลมีทักษะในการเป็นผู้นำและเป็นที่นับถือของคนรอบข้าง และพวกเขาเหมาะกับการเป็นผู้นำขององค์กร.","second_thai":"ตัวแทนบริษัทโฆษณา ผู้จัดการสำนักงาน พนักงานบริษัทท่องเที่ยว นักแสดงนักเขียน ศิลปิน นักบิน พนักงานต้อนรับบนเครื่องบิน นักดนตรี นักแสดงตลก และคนขับรถ.","first_czech":"Tygr, kterému se v Číně říká „král znamení“, je obvykle středem pozornosti. Narodili se s vůdčími schopnostmi a ostatní si je vážili. Tygři jsou vhodní pro jakoukoli kariéru vůdců.","second_czech":"Reklamní agent, vedoucí kanceláře, cestovní agent, herec, spisovatel, umělec, pilot, letuška, hudebník, komik a šofér.","first_bulgarian":" Тигърът, наричан „царят на знаците“ в Китай, обикновено е в центъра на вниманието. Те се раждат с лидерски умения и са уважавани от другите. Тигрите са подходящи за всяка кариера като лидери.","second_bulgarian":" Рекламен агент, офис мениджър, туристически агент, актьор, писател, художник, пилот, стюардеса, музикант, комик и шофьор.","first_norwegian":" Tiger, kalt 'kongen av tegnene' i Kina, er vanligvis sentrum for oppmerksomhet. De er født med lederegenskaper, og de blir respektert av andre. Tigre passer til enhver karriere som ledere.","second_norwegian":" Reklamebyrå, kontorsjef, reisebyrå, skuespiller, skribent, artist, pilot, flyvertinne, musiker, komiker og sjåfør.","first_denmark":"Tiger, kaldet 'kongen af tegnene' i Kina, er normalt centrum for opmærksomhed. De er født med ledelsesevner, og de respekteres af andre. Tigre er velegnet til enhver karriere som ledere.","second_denmark":"Reklameagent, kontorsjef, rejsebureau, skuespiller, skribent, kunstner, pilot, stewardesse, musiker, komiker og chauffør.","first_slovakia":"Tiger, ktorému sa v Číne hovorí „kráľ znamení“, je zvyčajne stredobodom pozornosti. Rodia sa s vodcovskými schopnosťami a ostatní si ich vážia. Tigre sa hodia na akúkoľvek kariéru ako vodcu.","second_slovakia":"Reklamný agent, kancelársky manažér, cestovný agent, herec, spisovateľ, umelec, pilot, letuška, hudobník, komik a šofér.","first_swedish":"Tiger, som kallas 'kungens tecken' i Kina, är vanligtvis centrum för uppmärksamhet. De är födda med ledaregenskaper och de respekteras av andra. Tigrar passar alla karriärer som ledare.","second_swedish":"Reklambyrå, kontorschef, resebyrå, skådespelare, författare, konstnär, pilot, flygvärdinna, musiker, komiker och chaufför.","first_finnish":"Tiikeri, jota kutsutaan '' merkkien kuninkaaksi '' Kiinassa, on yleensä huomion keskipiste. He ovat syntyneet johtamistaidoilla ja muut kunnioittavat heitä. Tiikerit soveltuvat mihin tahansa johtajanuraan.","second_finnish":"Mainostoimisto, toimistopäällikkö, matkatoimisto, näyttelijä, kirjailija, taiteilija, lentäjä, lentoemäntä, muusikko, koomikko ja kuljettaja.","first_romanian":"Tigrul, numit „regele semnelor” în China, este de obicei centrul atenției. Se nasc cu abilități de conducere și sunt respectați de alții. Tigrii se potrivesc oricărei cariere de lideri.","second_romanian":"Agent de publicitate, manager de birou, agent de turism, actor, scriitor, artist, pilot, însoțitor de bord, muzician, comediant și șofer."},"lucky":{"numbers":[1,3,4],"colors_english":["Blue","Gray","Orange"],"colors_arabic":["ازرق","رمادي","برتقال"],"colors_greek":["Μπλε","Γκρί","Πορτοκάλι"],"directions_english":["East","North","South"],"directions_arabic":["شرق","شمال","جنوب"],"directions_greek":["Ανατολή","Βοράς","Νότια"],"colors_malay":["Biru","Kelabu","Jingga"],"directions_malay":["Timur","Utara","Selatan"],"colors_thai":["สีน้ำเงิน","สีเทา","สีส้ม"],"directions_thai":["ทิศตะวันออก","ทิศเหนือ","ทิศใต้"],"colors_czech":["Modrý","Šedá","oranžový"],"directions_czech":["Východní","Severní","Jižní"],"colors_bulgarian":["Син","Сиво","Оранжево"],"colors_norwegian":["Blå","Grå","oransje"],"directions_bulgarian":["изток","север","На юг"],"directions_norwegian":["Øst","Nord","Sør"],"colors_denmark":["Blue","Grå","orange"],"directions_denmark":["Øst","Nord","Syd"],"colors_slovakia":["Blue","Šedá","Oranžová"],"directions_slovakia":["Východ","Sever","Juh"],"colors_swedish":["Blå","grå","portocale"],"directions_swedish":["Öst","Norr","söder"],"colors_finnish":["Sininen","harmaa","Oranssi"],"directions_finnish":["Itään","pohjoinen","Etelään"],"colors_romanian":["Albastru","gri","Orange"],"directions_romanianh":["Est","Nord","Sud"]},"unlucky":{"numbers":[6,7,8],"colors_english":["Brown"],"colors_arabic":["بني "],"colors_greek":["Καφέ"],"directions_english":["Southwest"],"directions_arabic":["جنوب غربي"],"directions_greek":["Νοτιοδυτικά"],"colors_malay":["Perang"],"directions_malay":["Barat daya"],"colors_thai":["สีน้ำตาล"],"directions_thai":["ทิศตะวันตกเฉียงใต้"],"colors_czech":["Hnědý"],"directions_czech":["Jihozápadní"],"colors_bulgarian":["Кафяво"],"colors_norwegian":["brun"],"directions_bulgarian":["Югозапад"],"directions_norwegian":["Sørvest"],"colors_denmark":["Brun"],"colors_slovakia":["Hnedá"],"directions_denmark":["Sydvest"],"directions_slovakia":["Juhozápad"],"colors_swedish":["Brun"],"directions_swedish":["Sydväst"],"colors_finnish":["Ruskea"],"directions_finnish":["Lounaaseen"],"colors_romanian":["Maro"],"directions_romanian":["Sud-Vest"]},"love":{"best_english":["Dragon","Horse","Pig"],"worst_english":["Ox","Tiger","Snake","Monkey"],"best_arabic":["تنين","حصان","خنزير"],"worst_arabic":["ثعلب","نمر","الافعى","القرد"],"best_greek":["Δράκος","Αλογο","Γουρούνι"],"worst_greek":["Βόδι","Τίγρη","Φίδι","Πίθηκος"],"best_malay":["Naga","Kuda","Khinzir"],"worst_malay":["Lembu","Harimau","Ular","Monyet"],"best_thai":["ปีมะโรง","ปีมะเมีย","ปีกุน"],"worst_thai":["ปีฉลู","ปีขาล","ปีมะเส็ง","ปีวอก"],"best_czech":["Drak","Kůň","Prase"],"worst_czech":["Vůl","Tygr","Had","Opice"],"best_bulgarian":["Дракон","Кон","Прасе"],"best_norwegian":["Drage","Hest","Gris"],"worst_bulgarian":["Вол","тигър","Змия","Маймуна"],"worst_norwegian":["Okse","Tiger","Slange","Ape"],"best_denmark":["Trække på","Hest","Svin"],"worst_denmark":["Okse","Tiger","Slange","Abe"],"best_slovakia":["drak","Kôň","Prasa"],"worst_slovakia":["Vôl","Tiger","Had","Opica"],"best_swedish":["drake","Häst","Gris"],"worst_swedish":["Oxe","Tiger","Orm","Apa"],"best_finnish":["Lohikäärme","Hevonen","Sika"],"worst_finnish":["Härkä","Tiikeri","Käärme","Apina"],"best_romanian":["balaur","Cal","Porc"],"worst_romanianh":["Bou","Tigru","Şarpe","Maimuţă"]},"years":[1902,1914,1926,1938,1950,1962,1974,1986,1998,2010,2022,2034],"unicode_symbol":"寅"},{"sign_english":"Rabbit","sign_arabic":"ارنب","sign_greek":"Λαγός","sign_malay":"Arnab","sign_thai":"ปีเถาะ","sign_czech":"Králičí","sign_bulgarian":"Заек","sign_norwegian":"Kanin","sign_denmark":"Kanin","sign_slovakia":"Králik","sign_swedish":"Kanin","sign_finnish":"Kani","sign_romanian":"Iepure","yin-yang":"Yin","direction":"East","season":"Mid-Spring","element":"Wood","trine":"4th","personality":{"first_english":"Possessing the fourth position in the Chinese Zodiac, the Rabbit symbolizes such character characteristics as inventiveness, empathy, and affectability. Hares are amicable, active and incline toward the organization of others. They likewise want to keep away from struggle. In fierce circumstances, Rabbits approach tranquilly and with thought for the other party. Bunnies accept emphatically in loved ones and lacking such bonds can prompt intense subject matters.Their peaceful nature shields Rabbits from winding up unmistakably resentful. Since they're tranquil creatures, Rabbits are effectively exploited. Their touchy nature makes them avoid forceful or focused circumstances. They're by and large preservationist and not keen on going for broke.","second_english":"Tasteful, advanced, expressive, respectful and in vogue, those brought into the world under the Sign of the Rabbit appreciate inclining about social issues and finding out about individuals from different nations. Bunnies are most open to being home, and their homes are constantly perfect and sorted out. Home is additionally where Rabbits like to engage. Bunnies are traditionalist in their embellishing tastes.Hares should work at structure progressively self-assurance and self-esteem so they can have a sense of safety. The craving for staying in sheltered, agreeable conditions shields Rabbits from going out on a limb which here and there makes them pass up great chances.","first_arabic":"يمتلك المركز الرابع في البروج الصينية ، يرمز الأرنب إلى خصائص الشخصية مثل الإبداع والتعاطف الابتكار. الأرانب البرية ودية ونشطة وتميل نحو تنظيم الآخرين. هم كذلك يريدون الابتعاد عن النضال. في الظروف الشديدة ، يقترب الأرانب من الهدوء والتفكير للطرف الآخر. تقبل الأرانب بشكل قاطع من أحبائهم ويمكن أن يؤدي الافتقار إلى مثل هذه الروابط إلى إثارة مشاكل موضوعية شديدة. إن طبيعتها السلمية تساعد الأرانب في إنهاء الاستياء بشكل لا لبس فيه. نظرًا لأنها مخلوقات هادئة ، يتم استغلال الأرانب بشكل فعال. طبيعتهم الحساسة تجعلهم يتجنبون الظروف القوية أو المركزة. انهم إلى حد كبير شخصيات محافظة و حريصين على عدم الانفصال.","second_arabic":"المذاق والمتقدمة والتعبيرية والاحترام والرواج ، أولئك الذين تم إحضارهم إلى العالم تحت إشراف الأرنب يقدرون ميلهم حول القضايا الاجتماعية ومعرفة الأفراد من مختلف الدول. الأرانب هي الأكثر انفتاحا على العودة إلى ديارهم ، ومنازلهم مثالية باستمرار وتسويتها. المنزل هو بالإضافة إلى ذلك حيث الأرانب ترغب في الانخراط. الأرانب تقليدية في أذواقها المزيّنة. يجب أن تعمل هياكلها بشكل تدريجي على ضمان الثقة بالنفس واحترام الذات حتى يتمكنوا من الشعور بالأمان. شغف البقاء في ظروف محمية ، وظروف مقبولة يحمي الأرانب من الخروج على أحد الأطراف التي هنا وهناك يجعلها تفوت فرصا كبيرة.","first_greek":"Διαθέτοντας την τέταρτη θέση στο Κινέζικο ωροσκόπιο, ο λαγός συμβολίζει τέτοια χαρακτηριστικά χαρακτήρα όπως εφευρετικότητα, ενσυναίσθηση και επηρεασμό. Οι λαγοί είναι φιλικοί, ενεργοί και έχουν κλίση προς την οργάνωση άλλων. Παρόλα αυτά, θέλουν να παραμένουν μακριά από τις δυσκολίες. Σε άγριες συνθήκες, οι λαγοί πλησιάζουν ήσυχα και με σκέψη για ττην άλλη πλευρά. Οι λαγοί δέχονται εμφατικά τους αγαπημένους τους και στερούνται τέτοιων δεσμών που μπορούν να προκαλέσουν έντονες αντιθέσεις. Οι ειρηνικές από την φύση τους άμυνες τους προστατεύουν από μπερδεμένες καταστάσεις. Δεδομένου ότι είναι γαλήνια πλάσματα, οι λαγοί τείνουν να εκμεταλλεύονται αποτελεσματικά. Η ευαίσθητη φύση τους τους κάνει να αποφεύγουν έντονες ή εστιασμένες περιστάσεις. Είναι συντηρητικοί και δεν είναι πρόθυμοι να προχωρήσουν σε κόντρες.","second_greek":"Εκλεπτυσμένος, προχωρημένος, εκφραστικός, σεβαστός και στη μόδα, αυτά είναι τα κύρια χαρακτηριστικά του λαγού, ο οποίος εκτιμά και επικεντρώνεται σε κοινωνικά ζητήματα, παίρνοντας πληροφορίες για άτομα από διαφορετικά έθνη. Οι λαγοί είναι πιο ανοιχτοί στο σπίτι τους, και τα σπίτια τους είναι συνεχώς τέλεια και διευθετημένα. Το σπίτι είναι αυτό στο οποίο θέλουν να συμμετάσχουν. Οι λαγοί είναι παραδοσιακοί με τα διακοσμητικά τους γούστα. Η επιθυμία για διαμονή σε προστατευμένες, ευχάριστες συνθήκες προστατεύει τους λαγούς από το να βγουν σε ένα πεδίο που πιθανά εγκυμονεί δυσάρεστες καταστάσεις.","first_malay":"Memiliki tempat keempat dalam Zodiak Cina, Arnab melambangkan ciri-ciri watak seperti keupayaan,simpati,dan kebolehan.Arnab adalah baik hati, aktif dan cenderung kepada organisasi orang lain.Mereka suka menjauhkan diri dari masalah.Dalam keadaan sengit,arnab sejenis yang perwatakan tenang dan berfikir untuk pihak yang lain.Arnab juga seorang yang menerima dengan tegas dengan orang yang mereka sayang dan menerima kekurangan tersebut boleh menyelesaikan masalah yang sengit.Sifat mereka yang damai boleh juga bertukar jadi benci dengan jelas.Oleh kerana mereka sejenis yang tenang arnab dieksploitasi dengan berkesan.Keistimewaan mereka menjadikan mereka dapat mengelakkan keadaan yang teruk atau mereka cepat fokus dengan keadaan yang menimpa mereka. Mereka adalah kumpulan yang besar dan tidak akan mudah berpecah.","second_malay":"Ada citarasa, maju, ekspresif, menghormati dan bergaya,yang membawa maksud tanda seseorang yang lahir tahun Arnab iaitu menghargai dan bersedia untuk masalah sosial dan mencari tahu tentang individu dari negara yang berbeza. Arnab sejenis yang rajin dalam menghias rumah, rumah mereka sentiasa sempurna dan tersusun.Rumah juga tambahan di mana arnab suka terlibat.Arnab sangat tradisional dalam citarasa mereka menghias rumah.Arnab juga bekerja pada struktur secara progresif ada jaminan diri dan harga diri supaya mereka berasa selamat.Hasrat untuk tinggal di dalam keadaan yang terlindung dan menyenangkan dapat melindungi arnab daripada terlepas peluang yang besar.","first_thai":"ปีเถาะถือเป็นปีนักษัตรลำดับที่สี่ในตำราโหราศาสตร์จีน คนเกิดปีเถาะเป็นคนช่างคิดช่างประดิษฐ์ เห็นอกเห็นใจและห่วงใยผู้อื่น พวกเขาเป็นมิตรและสดใสอยู่เสมอ คนเกิดปีเถาะไม่ชอบความยากลำบากและไม่ชอบมีปากมีเสียงกับคนอื่น พวกเขาชอบอยู่กับคนรัก ครอบครัวและเพื่อน ซึ่งช่วยให้พวกเขาคลายความโศกเศร้าเวลามีเรื่องทุกข์ร้อนใจ ด้วยความที่เป็นคนค่อนข้างอ่อนต่อโลก พวกเขามักถูกเอาเปรียบบ่อยครั้ง พวกเขาหลีกเลี่ยงความรุนแรงและไม่ชอบความลำบาก.","second_thai":"คนเกิดปีเถาะเป็นคนมีรสนิยม ชอบเทคโนโลยีใหม่ๆ สนใจแฟชั่น และการสังสรรค์เข้าสังคม พวกเขาให้ความสำคัญกับเรื่องรูปแบบบ้านและการจัดบ้าน และชอบอยู่บ้าน คนเกิดปีเถาะมีรสนิยมในการเลือกเครื่องประดับตกแต่งเป็นอย่างดี จึงเหมาะกับการเรื่องการออกแบบหรือเขียนแบบ ที่ช่วยให้พวกเขาภาคภูมิใจในตัวเอง และรู้สึกมีความสุขในการใช้ชีวิต","first_czech":"Králík, který zaujímá čtvrté místo v čínském zvěrokruhu, symbolizuje takové charakterové charakteristiky jako vynalézavost, empatie a ovlivnitelnost. Zajíci jsou přátelští, aktivní a inklinují k organizaci ostatních. Rovněž se chtějí držet dál od boje. Za prudkých okolností se Králíci blíží klidně a s myšlenkou na druhou stranu. Zajíčci důrazně přijímají blízké a jejich nedostatek může vést k intenzivním tématům. Jejich mírumilovná povaha chrání Králíky před tím, aby se nezaměnitelně rozčilili. Jelikož jsou to klidní tvorové, králíci jsou účinně vykořisťováni. Jejich citlivá povaha je nutí vyhýbat se silným nebo soustředěným okolnostem. Jsou velcí ochránci přírody a nemají zájem jít na mizinu.","second_czech":"Vkusní, pokročilí, expresivní, uctiví a v módě, ti, kteří byli přivedeni na svět ve znamení králíka, oceňují sklon k sociálním problémům a získávání informací o jednotlivcích z různých národů. Zajíčci jsou nejvíce otevření tomu, aby byli doma, a jejich domovy jsou neustále dokonalé a vyřešené. Domov je navíc tam, kde se králíci rádi angažují. Zajíčci jsou ve svém zkrášlovacím vkusu tradicionalisté. Zajíci by měli postupně pracovat na struktuře sebevědomí a sebeúcty, aby měli pocit bezpečí. Touha po pobytu v chráněných a příjemných podmínkách chrání králíky před tím, aby šli ven na končetinu, což jim sem tam dává velkou šanci.","first_bulgarian":" Притежавайки четвъртата позиция в китайския зодиак, Заекът символизира такива характеристики на характера като изобретателност, съпричастност и привързаност. Зайците са приятелски настроени, активни и склонни към организацията на другите. Те също искат да се пазят от борбата. При ожесточени обстоятелства Зайците се приближават спокойно и с мисъл за другата страна. Зайчетата приемат категорично в любимите си хора и липсата на такива връзки може да предизвика интензивни теми. Мирната им природа предпазва зайците от несъмнено огорчение. Тъй като са спокойни същества, зайците са ефективно експлоатирани. Докосващият им характер ги кара да избягват насилствени или фокусирани обстоятелства. Те като цяло са консерватори и не искат да се борят.","second_bulgarian":" Kaninen har den fjerde posisjonen i den kinesiske dyrekretsen og symboliserer karakterkarakteristika som oppfinnsomhet, empati og påvirkbarhet. Harer er vennlige, aktive og tilbøyelige til å organisere andre. De vil også holde seg borte fra kamp. Under voldsomme omstendigheter nærmer kaniner seg rolig og med tanke for den andre parten. Kaniner godtar med ettertrykk hos kjære, og manglende slike bånd kan føre til intense temaer. Deres fredelige natur beskytter kaniner mot åvikle umiskjennelig motbydelig. Siden de er rolige skapninger, utnyttes kaniner effektivt. Deres berørte natur gjør at de unngår sterke eller fokuserte omstendigheter. De er stort sett bevaringsforkjemper og er ikke opptatt av å gå i stykker.","first_norwegian":" Вкусните, напреднали, изразителни, респектиращи и на мода, тези, донесени на света под знака на заека, оценяват склонността към социални проблеми и информирането за индивиди от различни нации. Зайчетата са най-отворени за прибиране и домовете им са постоянно перфектни и подредени. Домът е допълнително там, където Зайците обичат да се занимават. Зайчетата са традиционалисти в своите разкрасяващи вкусове. Зайците трябва да работят в структурата прогресивно самоувереност и самочувствие, така че те могат да имат чувство за безопасност. Жаждата за престой в защитени, приятни условия предпазва Зайците от излизане на крайник, което тук-там ги кара да пропускат големи шансове.","second_norwegian":" Smakfulle, avanserte, uttrykksfulle, respektfulle og på moten, de som føres til verden under Kaninens tegn, setter pris på tilbøyeligheter rundt sosiale problemer og å få vite om enkeltpersoner fra forskjellige nasjoner. Kaniner er mest åpne for å være hjemme, og hjemmene deres er hele tiden perfekte og ordnet ut. Hjem er i tillegg hvor kaniner liker å engasjere seg. Kaniner er tradisjonalistiske i sin utsmykkende smak. Hare bør jobbe med å strukturere gradvis selvsikkerhet og selvtillit, slik at de kan ha en følelse av sikkerhet. Trangen etter å oppholde seg i skjermede, behagelige forhold beskytter kaniner fra å gå ut på et lem som her og der får dem til å passere store sjanser.","first_denmark":"Besidder den fjerde position i den kinesiske stjernetegn symboliserer kaninen sådanne karakteregenskaber som opfindsomhed, empati og påvirkning. Harer er venlige, aktive og tilbøjelige til at organisere andre. De vil ligeledes holde sig væk fra kamp. Under hårde omstændigheder nærmer kaniner sig roligt og med tanke for den anden part. Kaniner accepterer eftertrykkeligt hos kære, og manglende sådanne bånd kan fremkalde intense emner. Deres fredelige natur beskytter kaniner mod at afvikle umiskendeligt vrede. Da de er rolige skabninger, udnyttes kaniner effektivt. Deres rørende natur får dem til at undgå kraftige eller fokuserede omstændigheder. De er stort set bevaringseksperter og ikke ivrige efter at gå i stykker.","second_denmark":"Smakfulle, avanserte, uttrykksfulle, respektfulle og på moten, de som blir brakt til verden under Kaninens tegn, setter pris på tilbøyeligheter rundt sosiale problemer og å få vite om enkeltpersoner fra forskjellige nasjoner. Kaniner er mest åpne for å være hjemme, og hjemmene deres er hele tiden perfekte og ordnet ut. Hjem er i tillegg hvor kaniner liker å engasjere seg. Kaniner er tradisjonalistiske i sin utsmykkende smak. Hare bør jobbe med å strukturere gradvis selvsikkerhet og selvtillit slik at de kan ha en følelse av sikkerhet. Trangen etter å oppholde seg i skjermede, behagelige forhold beskytter kaniner fra å gå ut på et lem som her og der får dem til å passere store sjanser.","first_slovakia":"Králik, ktorý má štvrté miesto v čínskom zverokruhu, symbolizuje také charakterové vlastnosti ako vynaliezavosť, empatia a ovplyvniteľnosť. Zajace sú priateľské, aktívne a inklinujú k organizácii ostatných. Rovnako sa chcú držať ďalej od boja. Za prudkých okolností králiky pristupujú pokojne a s myšlienkou na druhú stranu. Zajačikovia dôrazne prijímajú blízkych a nedostatok takýchto väzieb môže viesť k intenzívnym témam. Ich mierumilovná povaha chráni Králiky pred tým, aby sa neuveriteľne rozčuľovali. Keďže sú to pokojné stvorenia, králiky sú efektívne využívané. Vďaka svojej citlivej povahe sa vyhýbajú silným alebo sústredeným okolnostiam. Sú z veľkej časti pamiatkarmi a nechcú ísť na mizinu.","second_slovakia":"Vkusní, pokročilí, expresívni, úctiví a v móde tí, ktorí boli privedení na svet v znamení králika, oceňujú náklonnosť k sociálnym problémom a zisťovanie informácií o jednotlivcoch z rôznych národov. Zajačiky sú najotvorenejšie byť doma a ich domovy sú neustále dokonalé a usporiadané. Domov je navyše tam, kde sa králiky radi angažujú. Zajačiky majú vo svojich okrášľujúcich chúťkach tradicionalizmus. Zajace by mali pracovať na štruktúre postupne sebavedomie a sebaúcta, aby mali pocit bezpečia. Túžba po pobyte v chránených a príjemných podmienkach chráni Králiky pred výjazdom na končatinu, ktorá im sem-tam dáva veľké šance.","first_swedish":"Med den fjärde positionen i den kinesiska zodiaken symboliserar kaninen sådana karaktärsegenskaper som uppfinningsrikedom, empati och påverkan. Harar är vänliga, aktiva och lutar mot andras organisation. De vill också hålla sig borta från kamp. Under hårda omständigheter närmar sig kaniner lugnt och med tanke på den andra parten. Kaniner accepterar med eftertryck hos nära och kära och att sakna sådana band kan leda till intensiva ämnesområden. Deras fridfulla natur skyddar kaniner från att avveckla omisskännligt motbjudande. Eftersom de är lugna varelser utnyttjas kaniner effektivt. Deras känsliga natur gör att de undviker kraftfulla eller fokuserade omständigheter. De är i stort sett bevarande och inte angelägna om att gå sönder.","second_swedish":"Smakfulla, avancerade, uttrycksfulla, respektfulla och på modet, de som föras till världen under Kaninens tecken uppskattar lutande om sociala frågor och ta reda på om individer från olika nationer. Kaniner är mest öppna för att vara hemma, och deras hem är ständigt perfekta och ordnade. Hem är också där kaniner gillar att engagera sig. Kaniner är traditionella i sin utsmyckande smak. Aktierna bör arbeta med att strukturera gradvis självförtroende och självkänsla så att de kan få en känsla av säkerhet. Lusten efter att stanna i skyddade, behagliga förhållanden skyddar kaniner från att gå ut på en lem som här och där får dem att missa stora chanser.","first_finnish":"Kiinan Zodiacin neljännessä asemassa oleva kani symboloi sellaisia ​​luonteenpiirteitä kuin kekseliäisyys, empatia ja vaikuttavuus. Jänikset ovat ystävällisiä, aktiivisia ja taipuvia muiden järjestäytymiseen. He haluavat myös pysyä poissa kamppailusta. Kovissa olosuhteissa Kanit lähestyvät rauhallisesti ja ajatellen toista osapuolta. Puput hyväksyvät korostetusti rakkaitaan, ja tällaisten siteiden puuttuminen voi saada aikaan kiivaita aiheita, ja heidän rauhallinen luonteensa suojaa Kaneja lopettamasta epäilemättä kaunaa. Koska ne ovat rauhallisia olentoja, kaneja hyödynnetään tehokkaasti. Niiden herkkä luonne saa heidät välttämään voimakkaita tai kohdennettuja olosuhteita. He ovat suurelta osin säilyttäjiä eivätkä halua mennä rikki.","second_finnish":"Herkulliset, edistyneet, ilmeikkäät, kunnioittavat ja muodissa olevat ihmiset, jotka tuodaan maailmaan Kani-merkin alla, arvostavat taipumusta sosiaalisiin kysymyksiin ja oppimista eri kansojen henkilöistä. Puput ovat avoimimpia kotona olemiseen, ja heidän kodinsa ovat jatkuvasti täydellisiä ja järjestettyjä. Koti on myös paikka, jossa kanit haluavat harjoittaa. Puput ovat perinteisiä koristeltuaan makuunsa, ja jänisten tulisi työskennellä rakentamaan asteittain itsevarmuutta ja itsetuntoa, jotta heillä olisi turvallisuuden tunne. Himo pysyä suojaisissa, miellyttävissä olosuhteissa suojaa Kaneja menemästä raajaan, mikä täällä ja siellä saa heidät siirtämään suuria mahdollisuuksia.","first_romanian":"Având a patra poziție în zodiacul chinezesc, iepurele simbolizează caracteristici precum caracterul inventiv, empatia și afectivitatea. Iepurii sunt amiabili, activi și înclinați spre organizarea altora. De asemenea, vor să se țină departe de luptă. În circumstanțe acerbe, iepurii se apropie liniștiți și cu gândul pentru cealaltă parte. Iepurașii acceptă emfatic în cei dragi și lipsa unor astfel de legături poate determina subiecte intense. Natura lor pașnică protejează iepurii de la sfârșitul inconfundabil de resentiment. Deoarece sunt creaturi liniștite, iepurii sunt exploatați în mod eficient. Natura lor sensibilă îi face să evite circumstanțele puternice sau concentrate. Sunt, în general, conservatori și nu sunt dornici să meargă pentru spargere.","second_romanian":"Gustos, avansat, expresiv, respectuos și la modă, cei aduși în lume sub semnul iepurelui apreciază înclinarea cu privire la problemele sociale și află despre indivizi din diferite națiuni. Iepurașii sunt cei mai deschiși să fie acasă, iar casele lor sunt în permanență perfecte și sortate. Acasă este, de asemenea, locul în care iepurilor le place să se angajeze. Iepurașii sunt tradiționalisti în gusturile lor înfrumusețatoare. Iepurii ar trebui să lucreze la structura progresivă a siguranței de sine și a stimei de sine, astfel încât să poată avea un sentiment de siguranță. Pofta de a rămâne în condiții protejate și agreabile îi protejează pe iepuri de ieșirea pe un membru care, ici și colo, îi face să renunțe la șanse mari."},"health":{"english":"Despite the fact that Rabbits don't normally get noticeably annoyed or focused on, they do will in general keep these sentiments inside. When they don't express these emotions, such feeling can make Rabbits become sick. Bunnies could profit by progressively ordinary movement which would decrease their feelings of anxiety and better their wellbeing.","arabic":"على الرغم من حقيقة أن الأرانب لا تكون تحت التركيز او تكون ملحوظة بطبيعتها ، إلا أنها ستبقي بشكل عام هذه المشاعر في الداخل. عندما لا يعبرون عن هذه المشاعر ، فإن هذا الشعور قد يجعل الأرانب يمرضون. يمكن أن تستفيد الأرانب عن طريق الحركة المستديمة التي تقلل من مشاعر القلق وتزيد من رفاهيتهم.","greek":"Παρά το γεγονός ότι οι λαγοί δεν δείχνουν συνήθως έντονα ενοχλημένοι ή επικεντρωμένοι σε κάτι, θα κρατήσουν γενικά αυτά τα συναισθήματα μέσα τους. Όταν δεν εκφράζουν αυτά τα συναισθήματα, κάτι τέτοιο μπορεί να τους κάνει να αρρωσταίνουν. Οι λαγοί θα μπορούσαν να επωφεληθούν από μια προοδευτικά τακτική κίνηση, η οποία θα μείωνε τα συναισθήματα άγχους και θα βελτίωνε την ευημερία τους.","malay":"Walaupun Arnab tidak biasanya berasa tidak normal mereka cepat berasa gentar atau fokus terhadap sesuatu. Mereka akan menyimpan perasaan tersebut dalam diri mereka. Apabila mereka tidak meluahkan perasaan emosi mereka, disebabkan perasaan sedemikian boleh menyebabkan mereka menjadi sakit. Arnab boleh menjadi lebih baik sekiranya mereka mengurangkan perasaan bimbang mereka dan meningkatkan mutu hidup mereka.","thai":"คนเกิดปีเถาะเป็นคนเก็บอารมณ์เก่งแม้ในเวลาที่พวกเขารู้สึกโมโหหรือฉุนเฉียว เพราะเป็นคนไม่แสดงออกทางอารมณ์บ่อยครั้งทำให้พวกเขามีปัญหาและความทุกข์ด้านจิตใจ ด้วยเหตุนี้คนเกิดปีเถาะจึงควรใช้ชีวิตแบบเรียบง่ายเพื่อช่วยคลายความเครียดและเพื่อสุขภาพกายและใจที่ดี.","czech":"Navzdory skutečnosti, že se Králíci obvykle znatelně neobtěžují ani se na ně nezaměřují, obecně tyto pocity udrží uvnitř. Když tyto pocity nevyjádří, může takový pocit způsobit, že Králíci onemocní. Zajíčci by mohli profitovat postupně obyčejným pohybem, který by snižoval jejich pocity úzkosti a zlepšoval jejich pohodu.","bulgarian":"Въпреки факта, че Зайците обикновено не се дразнят значително или не се фокусират върху тях, те като цяло ще запазят тези настроения вътре. Когато не изразяват тези емоции, такова чувство може да накара Зайците да се разболеят. Зайчетата биха могли да се възползват от прогресивно обикновено движение, което би намалило чувството им на безпокойство и ще подобри тяхното благосъстояние.","norwegian":"Til tross for at kaniner normalt ikke blir merkbart irritert eller fokusert på, vil de generelt holde disse følelsene inne. Når de ikke uttrykker disse følelsene, kan en slik følelse få kaniner til å bli syke. Kaniner kunne tjene på gradvis vanlig bevegelse som ville redusere deres følelser av angst og bedre deres velvære.","slovakia":"Napriek tomu, že Králiky sa zvyčajne nijako výrazne neobťažujú alebo sa na nich nesústredia, vo všeobecnosti tieto nálady zachovajú. Keď tieto emócie nedajú najavo, môže z takéhoto pocitu ochorieť na Králiky. Zajačiky by mohli profitovať z postupne bežného pohybu, ktorý zníži ich pocity úzkosti a zlepší pohodu.","denmark":"Til tross for at kaniner normalt ikke blir merkbart irritert eller fokusert på, vil de generelt holde disse følelsene inne. Når de ikke uttrykker disse følelsene, kan en slik følelse få kaniner til å bli syke. Kaniner kunne tjene på gradvis vanlig bevegelse som ville redusere følelsen av angst og bedre deres velvære.","swedish":"Trots det faktum att kaniner normalt inte blir märkbart irriterade eller fokuserade på kommer de i allmänhet att hålla dessa känslor inne. När de inte uttrycker dessa känslor kan en sådan känsla få kaniner att bli sjuka. Kaniner skulle kunna tjäna pengar genom gradvis vanlig rörelse som skulle minska deras känslor av ångest och förbättra deras välbefinnande.","finnish":"Huolimatta siitä, että kanit eivät yleensä ärsytä huomattavasti tai keskittyneet niihin, he yleensä pitävät nämä tunteet sisällä. Kun he eivät ilmaise näitä tunteita, tällainen tunne voi saada Kanit sairastumaan. Puput voisivat hyötyä asteittain tavallisesta liikkeestä, mikä vähentäisi heidän ahdistuksen tunteitaan ja parantaisi hyvinvointiaan.","romanian":"În ciuda faptului că iepurii nu sunt în mod normal deranjați sau concentrați în mod vizibil, ei vor păstra, în general, aceste sentimente înăuntru. Când nu exprimă aceste emoții, un astfel de sentiment poate face Iepurii să se îmbolnăvească. Iepurașii ar putea profita printr-o mișcare progresivă obișnuită, care le-ar diminua sentimentele de anxietate și le-ar îmbunătăți starea de bine."},"carrers":{"first_english":"Scholarly, insightful, and learned, Rabbits can appreciate a good career as well as wealth.. With a couple of apt hands, Rabbits have a present for calligraphy and painting just as fitting and cooking.","second_english":"In the fields of cultivation, breeding, education, religion, health care, medicine, culture, police/judiciary work, and politics.","first_arabic":"هي علمية ، وبصيرة ، ومتعلمة. بهذا يمكن للأرانب تقدير مهنة جيدة وكذلك الثروة .. و لانها تتمتع بالاشياء اليدوية ، الأرانب لديها حرفة للخط والرسم و كذلك مناسبة لفن الطهي.","second_arabic":"في مجالات الزراعة والتربية والتعليم والدين والرعاية الصحية والطب والثقافة والشرطة / العمل القضائي والسياسة.","first_greek":"Μελετημένοι, διορατικοί και φιλομαθείς, οι λαγοί μπορούν να εκτιμήσουν μια καλή καριέρα καθώς και τον πλούτο. Με δύο ικανά χέρια, οι λαγοί έχουν μία κλίση στην καλλιγραφία και τη ζωγραφική, όπως επίσης στη διακόσμηση και το μαγείρεμα.","second_greek":"Στους τομείς της καλλιέργειας, της αναπαραγωγής, της εκπαίδευσης, της θρησκείας, της υγειονομικής περίθαλψης, της ιατρικής, του πολιτισμού, της αστυνομίας / της δικαστικής εργασίας και της πολιτικής.","first_malay":"Ilmuan, berwawasan, dan belajar, Arnab dapat menghargai kerjaya yang baik serta kekayaan. Dengan ada kemahiran tangan, Arnab mempunyai keistimewaan untuk kaligrafi dan lukisan sama seperti pemasangan dan memasak.","second_malay":"Dalam bidang penanaman, pembiakan, pendidikan, agama, penjagaan kesihatan, perubatan, budaya, kerja polis /kerja kehakiman, dan politik.","first_thai":"คนเกิดปีเถาะมักจะมีหน้าที่การงานดีและมีฐานะร่ำรวยเพราะพวกเขาเป็นคนมีความรู้และใฝ่เรียน มีความถนัดในการใช้มือ จึงมีความสามรถในการคัดลายมือ การวาดภาพ การเย็บผ้า และการทำอาหาร.","second_thai":"ในด้านการเพาะปลูก การเพาะพันธุ์ การศึกษา ศาสนา การดูแลสุขภาพ การแพทย์ วัฒนธรรม ตำรวจ /งานยุติธรรม และการเมือง.","first_czech":"Vědci, vhlední a poučení, mohou králíci ocenit dobrou kariéru i bohatství. Králíci mají díky několika šikovným rukám dárek pro kaligrafii a malování stejně dobře jako kování a vaření.","second_czech":" V oblastech pěstování, šlechtění, vzdělávání, náboženství, zdravotní péče, medicíny, kultury, policejní / soudní práce a politiky.","first_bulgarian":" Учени, проницателни и учени, Зайците могат да оценят както добрата кариера, така и богатството .. С няколко подходящи ръце, Зайците имат подарък за калиграфия и рисуване, също толкова подходящ и готвещ.","second_bulgarian":" Lærende, innsiktsfulle og lærte kaniner kan sette pris på en god karriere så vel som rikdom. Med et par treffende hender har kaniner en gave til kalligrafi og maling, like passende og matlaging.","first_norwegian":" В областта на отглеждането, отглеждането, образованието, религията, здравеопазването, медицината, културата, работата на полицията / съдебната система и политиката.","second_norwegian":" Innen dyrking, avl, utdanning, religion, helsevesen, medisin, kultur, politi- / rettsvesen og politikk.","first_denmark":"Videnskabelig, indsigtsfuld og lært kaniner værdsætte en god karriere såvel som rigdom. Med et par passende hænder har kaniner en gave til kalligrafi og maling lige så passende og madlavning.","second_denmark":"Inden for dyrkning, avl, uddannelse, religion, sundhedspleje, medicin, kultur, politi / retsvæsen og politik.","first_slovakia":"Odborne, vhľadne a naučene môžu králiky oceniť dobrú kariéru i bohatstvo. Králiky majú vďaka šikovným rukám darček pre kaligrafiu a maľovanie, ktorý je vhodný aj na varenie.","second_slovakia":"V oblastiach kultivácie, šľachtenia, vzdelávania, náboženstva, zdravotníctva, medicíny, kultúry, polície / súdnictva a politiky.","first_swedishh":"Vetenskapliga, insiktsfulla och lärda kaniner kan uppskatta en bra karriär såväl som rikedom. Med ett par lämpliga händer har kaniner en present för kalligrafi och målning lika passande och matlagning.","second_swedish":"Inom områdena odling, avel, utbildning, religion, hälsovård, medicin, kultur, polis / rättsväsende och politik.","first_finnish":"Tutkijat, oivaltava ja oppinut, Kanit voivat arvostaa sekä hyvää uraa että vaurautta. Kaneilla on parilla osuvalla kädellä lahja kalligrafiaan ja maalaamiseen yhtä lailla kuin sopivaksi ja ruoanlaittoon.","second_finnish":"Viljelyn, jalostuksen, koulutuksen, uskonnon, terveydenhuollon, lääketieteen, kulttuurin, poliisi / oikeuslaitoksen ja politiikan aloilla.","first_romanian":"Savanți, perspicace și învățați, iepurii pot aprecia o carieră bună, precum și bogăție .. Cu câteva mâini potrivite, iepurii au un cadou pentru caligrafie și pictură la fel de potrivit și de gătit.","second_romanian":"În domeniile cultivării, ameliorării, educației, religiei, îngrijirii sănătății, medicinei, culturii, poliției / justiției și politicii."},"lucky":{"numbers":[3,4,6],"colors_english":["Blue","Pink","Purple","Red"],"directions_english":["East","South","Northwest"],"colors_arabic":["ازرق","وردي","بنفسجي","أحمر"],"colors_greek":["Μπλε","Ροζ","Μωβ","Κόκκινο"],"directions_arabic":["شرق","جنوب","شمال غربي"],"directions_greek":["Ανατολή","Νότια","Βορειοδυτικά"],"colors_malay":["Biru","Merah Jambu","Ungu","Merah"],"directions_malay":["Timur","Selatan","Barat laut"],"colors_thai":["สีน้ำเงิน","สีชมพู","สีม่วง","สีแดง"],"directions_thai":["ทิศตะวันออก","ทิศใต้","ทิศตะวันตกเฉียงเหนือ"],"colors_czech":["Modrý","Růžový","Nachový","Červené"],"directions_czech":["Východní","Jižní","Severozápad"],"colors_bulgarian":["Син","Розов","Лилаво","червен"],"colors_norwegian":["Blå","Rosa","Lilla","rød"],"directions_bulgarian":["изток","На юг","Северозападна"],"directions_norwegian":["Øst","Sør","Nordvest"],"colors_denmark":["Blå","Lyserød","Lilla","Rød"],"directions_denmark":["Øst","Syd","Nord Vest"],"colors_slovakia":["Modrá","Ružová","Fialová","Červená"],"directions_slovakia":["Východ","Juh","Severozápad"],"colors_swedish":["Blå","Rosa","Lila","Röd"],"directions_swedish":["Öst","söder","Nordväst"],"colors_finnish":["Sininen","Vaaleanpunainen","Violetti","Punainen"],"directions_finnish":["Itään","Etelään","Luoteeseen"],"colors_romanian":["Albastru","Roz","Violet","roșu"],"directions_romanian":["Est","Sud","Nord Vest"]},"unlucky":{"numbers":[1,7,8],"colors_english":["Dark Brown","Dark Yellow","White"],"directions_english":["North","West","Southwest"],"colors_arabic":["بني غامق","أصفر غامق","ابيض"],"colors_greek":["Σκούρο καφέ","Σκουρο κιτρινο","Λευκο"],"directions_arabic":["شمال","غرب","جنوب غربي"],"directions_greek":["Βοράς","δυτικά","Νοτιοδυτικά"],"colors_malay":["Perang Gelap","Kuning Gelap","Putih"],"directions_malay":["Utara","Barat","Barat daya"],"colors_thai":["สีน้ำตาลเข้ม","สีเหลืองเข้ม","สีขาว"],"directions_thai":["ทิศเหนือ","ทิศตะวันตก","ทิศตะวันตกเฉียงใต้"],"colors_czech":["Tmavě hnědá","Tmavě žlutá","Bílý"],"directions_czech":["Severní","Západ","Jihozápadní"],"colors_bulgarian":["Тъмно кафяво","Тъмно жълто","Бял"],"colors_norwegian":["Mørkebrun","Mørk gul","Hvit"],"directions_bulgarian":["север","Запад","Югозапад"],"directions_norwegian":["Nord","Vest","Sørvest"],"colors_denmark":["Mørkebrun","Mørk gul","White"],"directions_denmark":["Nord","Vest","Sydvest"],"colors_slovakia":["Tmavohnedá","Tmavo žltá","White"],"directions_slovakia":["Sever","Západ","Juhozápad"],"colors_swedish":["Mörkbrun","Mörk gul","Vit"],"directions_swedish":["Norr","Väst","Sydväst"],"colors_finnish":["Tumman ruskea","Tummankeltainen","Valkoinen"],"directions_finnish":["pohjoinen","Länteen","Lounaaseen"],"colors_romanian":["Maro inchis","Galben închis","alb"],"directions_romanian":["Nord","Vest","Sud-Ves"]},"love":{"best_english":["Rat","Goat","Monkey","Dog","Pig"],"worst_english":["Rooster","Snake"],"best_arabic":["الفأر","الماعز","القرد","الكلب","خنزير"],"worst_arabic":["ديك","الافعى"],"best_greek":["Αρουραίος","Κατσίκα","Πίθηκος","Σκύλος","Γουρούνι"],"worst_greek":["Κόκορας","Φίδι"],"best_malay":["Tikus","Kambing","Monyet","Anjing","Khinzir"],"worst_malay":["Ayam","Ular"],"best_thai":["ปีชวด","ปีมะแม","ปีวอก","ปีจอ","ปีกุน"],"worst_thai":["ปีระกา","ปีมะเส็ง"],"best_czech":["Krysa","Koza","Opice","Pes","Prase"],"worst_czech":["Kohout","Had"],"best_bulgarian":["Плъх","Козел","Маймуна","Куче","Прасе"],"best_norwegian":["Rotte","Geit","Ape","Hund","Gris"],"worst_bulgarian":["Петел","Змия"],"worst_norwegian":["Hane","Slange"],"best_denmark":["Rotte","Ged","Abe","Hund","Svin"],"worst_denmark":["Hane","Slange"],"best_slovakia":["Potkan","Koza","Opica","pes","Prasa"],"worst_slovakia":["Kohút","Had"],"best_swedishh":["Råtta","Get","Apa","Hund","Gris"],"worst_swedish":["Tupp","Orm"],"best_finnish":["Rotta","Vuohi","Apina","Koira","Sika"],"worst_finnish":["Kukko","Käärme"],"best_romanian":["Şobolan","Capră","Maimuţă","Câine","Porc"],"worst_romanian":["Cocoş","Şarpe"]},"years":[1903,1915,1927,1939,1951,1963,1975,1987,1999,2011,2023,2035],"unicode_symbol":"卯"},{"sign_english":"Dragon","sign_arabic":"تنين","sign_greek":"Δράκος","sign_malay":"Naga","sign_thai":"ปีมะโรง","sign_czech":"Drak","sign_bulgarian":"Дракон","sign_norwegian":"Drage","sign_denmark":"Trække på","sign_slovakia":"drak","yin-yang":"Yang","direction":"East","season":"Late Spring","element":"Earth","trine":"1st","personality":{"first_english":"Possessing the fifth situation in the Chinese Zodiac, the Dragon is the mightiest of the signs. Mythical serpents symbolize such character qualities as predominance and desire. Mythical serpents like to live by their own principles and whenever left without anyone else, are typically effective. They're driven, unafraid of difficulties, and ready to go out on a limb. They're enthusiastic in everything they accomplish and they get things done in fantastic design. Shockingly, this energy and excitement can leave Dragons feeling depleted and curiously, unfulfilled.","second_english":"While Dragons much of the time help other people, infrequently will they request help. Others are pulled in to Dragons, particularly their beautiful characters, yet where it counts, Dragons want to be distant from everyone else. Maybe that is on the grounds that they're best when working alone. Their inclination to be separated from everyone else can seem to be self-importance or vanity, yet these characteristics aren't pertinent. Winged serpents have emotions that can flare quick!","first_arabic":"تمتلك المركز الخامس في البروج الصينية ، التنين هو الأقوى من العلامات. الثعابين الأسطورية ترمز إلى صفات الشخصية مثل الغلبة والرغبة. الثعابين الأسطورية تحب أن تعيش بمبادئها الخاصة وكلما تركت دون أي شخص آخر ، تكون عادةً فعالة. إنهم مدفوعون ، ولا يخافون من الصعوبات ، ومستعدون للخروج من أحد الأطراف. إنهم متحمسون لكل ما ينجزونه ويقومون بإنجاز الأشياء في تصميم رائع. بشكل مثير للصدمة ، هذه الطاقة والإثارة يمكن أن تترك التنانين تشعر بأنها مستنفدة و لم تتحقق انجازا.","second_arabic":"على الرغم من أن التنانين تسخر كثيرًا من الوقت يساعد الآخرين ، إلا أنهم سيطلبون المساعدة بشكل متكرر. يتم جذب الآخرين إلى للتنانين، وخاصة شخصياتهم الجميلة ، ومع ذلك حيث الامور المهمة، التنانين تريد أن تكون بعيدة عن أي شخص آخر. ربما يكون ذلك على أساس أنهم الأفضل عند العمل بمفردهم. قد يبدو الميل إلى الانفصال عن أي شخص آخر ذا أهمية ذاتية أو الغرور ، ولكن هذه الخصائص ليست وثيقة الصلة بالموضوع. الثعابين المجنحة لها عواطف يمكن أن تشتعل بسرعة!","first_greek":"Κατέχοντας την πέμπτη θέση στον Κινέζικο ωροσκόπιο, ο Δράκος είναι ο ισχυρότερος των σημείων. Τα μυθικά ερπετά συμβολίζουν τέτοιες ιδιότητες χαρακτήρα όπως η κυριαρχία και η επιθυμία. Τα μυθικά ερπετά επιθυμούν να ζουν σύμφωνα με τις δικές τους αρχές και κάθε φορά που μένουν χωρίς κάποιον άλλο, είναι τυπικά αποτελεσματικοί. Τρέφονται, δεν φοβούνται δυσκολίες και είναι έτοιμοι να ανταπεξέλθουν σε μία δυσκολία. Είναι ενθουσιασμένοι σε ό, τι επιτελούν και κάνουν τα πράγματα σε φανταστικό σχεδιασμό. Εντυπωσιακά, αυτή η ενέργεια και ο ενθουσιασμός μπορούν να αφήσουν τους Δράκους να αισθάνονται εξαντλημένοι και περιέργως, ανεκπλήρωτοι.","second_greek":"Ενώ οι δράκοι βοηθούν τους άλλους ανθρώπους πολλές φορές, σπάνια θα ζητήσουν βοήθεια. Άλλοι έλκονται απός Δράκους, ιδιαίτερα από τους ωραίους χαρακτήρες τους, παρόλα αυτά οι Δράκοι θέλουν να απέχουν από όλους τους άλλους. Ίσως αυτό είναι για το λόγο ότι είναι καλύτερα όταν δουλεύουν μόνοι τους. Η κλίση τους να διαχωρίζονται από όλους τους άλλους μπορεί να φαίνεται ότι είναι αυτοσυνειδησία ή ματαιοδοξία, όμως αυτά τα χαρακτηριστικά δεν είναι σχετικά. Τα φτερωτά φίδια έχουν συναισθήματα που μπορούν να πάρουν φωτιά γρήγορα!","first_malay":"Memiliki tempat kelima dalam Zodiak Cina, Naga adalah zodiak yang terkuat. Dalam ular mitos,melambangkan sifat watak seperti kehebatan dan keinginan.Ular mitos suka hidup dengan prinsip mereka sendiri dan apabila ditinggalkan tanpa ada orang lain, biasanya berkesan. Mereka didorong, tidak takut kesulitan, dan bersedia untuk keluarkan anggota badan.Mereka bersemangat dalam segala yang mereka lakukan dan hasilnya sangat menakjubkan. Sungguh mengejutkan, bila tenaga dan kegembiraan ini boleh menyebabkan Naga berasa kecewa dan rasa ingin tahu yang kuat, tidak dapat dipenuhi.","second_malay":"Walaupun Naga banyak membantu orang lain,jarang mereka meminta bantuan.Lain-lain watak Naga iaitu watak yang cantik,tetapi ia dianggap tidak suka bergaul dengan orang lain dan mahu menjauhkan diri dari orang lain.Mungkin itu atas alasan mereka lebih baik apabila bekerja secara bersendirian.Kecenderungan mereka untuk menjauhkan diri dari orang lain boleh menjadi kepentingan diri atau sombong,tetapi ciri-ciri ini tidak berkaitan. Ular bersayap mempunyai emosi yang boleh melancarkan cepat!","first_thai":"ปีมะโรงเป็นปีนักษัตรลำดับที่ห้าของตำราโหราศาสตร์จีน  คนเกิดปีมะโรงเป็นคนที่มีบารมีและอำนาจมากที่สุดในบรรดาปีนักษัตรทั้งหมด พวกเขามีความสันโดษและชอบทำตามกฎเกณฑ์ของพวกเขาเอง คนเกิดปีมะโรงไม่เกรงกลัวอุปสรรคใดๆ และกล้าได้กล้าเสีย พวกเขากระหายความสำเร็จและมักจะทำงานต่างๆได้ดี แต่เพราะการรักความสันโดษและชอบทำอะไรคนเดียวทำให้พวกเขารู้สึกโดดเดี่ยวบ้างในบางเวลา.","second_thai":"คนที่เกิดปีมะโรงชอบช่วยเหลือผู้อื่นแต่ในขณะเดียวกันพวกเขาก็ต้องการความช่วยเหลือเช่นกัน ความสวยและความหล่อบวกกับความมีเสน่ห์ของคนเกิดปีมะโรงเป็นแรงดึงดูดให้คนเข้าหาพวกเขา แต่บ่อยครั้งพวกเขาก็ชอบปลีกตัวอยู่คนเดียวมากกว่า และมีแนวโน้มที่จะทำงานคนเดียวได้ดีกว่าการทำงานกับคนอื่น ด้วยเหตุนี้บางครั้งคนเกิดปีมะโรงจึงถูกมองว่าเป็นคนหยิ่ง และแม้จะดูเป็นคนใจเย็น บางครั้งพวกเขาก็สามารถโกรธเป็นฟืนเป็นไฟได้เช่นเดียวกัน","first_czech":"Drak, který má v čínském zvěrokruhu pátou situaci, je nejmocnějším ze znamení. Mýtičtí hadi symbolizují takové charakterové vlastnosti jako převaha a touha. Mýtičtí hadi rádi žijí podle svých vlastních principů a kdykoli zůstanou bez někoho jiného, jsou obvykle efektivní. Jsou poháněni, nebojí se obtíží a jsou připraveni vyrazit na končetinu. Jsou nadšení ze všeho, čeho dosáhnou, a dělají věci ve fantastickém designu. Šokující je, že tato energie a vzrušení mohou způsobit, že se Draci budou cítit vyčerpaní a zvědaví, nenaplnění.","second_czech":"Zatímco draci většinu času pomáhají ostatním lidem, zřídka požádají o pomoc. Jiní jsou přitahováni k Drakům, zejména jejich krásným postavám, ale tam, kde se to počítá, se Draci chtějí vzdálit všem ostatním. Možná je to z důvodu, že jsou nejlepší, když pracují sami. Jejich sklon oddělit se od všech ostatních se může jevit jako sebevědomí nebo marnost, přesto tyto vlastnosti nejsou relevantní. Okřídlení hadi mají emoce, které mohou rychle vzplanout!","first_bulgarian":"Мислейки за своята отдадена природа, Драконите като цяло са здрави. Те биват тласкани и изпитват вредните ефекти от случайни щамове / мозъчни болки, вероятно в светлината на факта, че излизат на крайник. Митичните змии биха могли да спечелят, като се присъединят към нежните движения в живота си. Йога или разходка би било чудесно, тъй като тези упражнения могат да работят както на психиката, така и на тялото. ","second_bulgarian":" Tenker på deres dedikerte natur, Dragons er lyd generelt. De blir presset og opplever de dårlige effektene av sporadisk belastning / hjernesmerter, sannsynligvis i lys av at de går ut på en lem. Mytiske slanger kunne tjene på å bli en mild bevegelse i livet. Yoga eller spaserturer ville vært bra, da disse øvelsene kan fungere både i deres psykes og i kroppen.","first_norwegian":" Drak, který má v čínském zvěrokruhu pátou situaci, je nejmocnějším ze znamení. Mýtičtí hadi symbolizují takové charakterové vlastnosti jako převaha a touha. Mýtičtí hadi rádi žijí podle svých vlastních principů a kdykoli zůstanou bez někoho jiného, jsou obvykle efektivní. Jsou poháněni, nebojí se obtíží a jsou připraveni vyrazit na končetinu. Jsou nadšení ze všeho, čeho dosáhnou, a dělají věci ve fantastickém designu. Šokující je, že tato energie a vzrušení mohou způsobit, že se Draci budou cítit vyčerpaní a zvědaví, nenaplnění.","second_norwegian":" Притежавайки петата ситуация в китайския Зодиак, Драконът е най-могъщият от знаците. Митичните змии символизират такива качества на характера като преобладаване и желание. Митичните змии обичат да живеят според собствените си принципи и винаги, когато останат без никой друг, обикновено са ефективни. Те са карани, не се страхуват от трудности и са готови да излязат на крайник. Те са ентусиазирани във всичко, което постигат, и правят нещата във фантастичен дизайн. Шокиращо, тази енергия и вълнение могат да оставят Драконите да се чувстват изчерпани и любопитни, неизпълнени.","first_denmark":"Besidder den femte situation i den kinesiske stjernetegn, er dragen den mægtigste af tegnene. Mytiske slanger symboliserer sådanne karakterkvaliteter som overvægt og lyst. Mytiske slanger kan lide at leve efter deres egne principper, og når de efterlades uden nogen anden, er de typisk effektive. De er drevet, bange for vanskeligheder og klar til at gå ud på en lem. De er begejstrede for alt, hvad de udfører, og de får tingene gjort i et fantastisk design. Chockerende nok kan denne energi og spænding efterlade Dragons til at føle sig udtømte og nysgerrig, uopfyldte.","second_denmark":"Mens Dragons mye av tiden hjelper andre mennesker, vil de sjelden be om hjelp. Andre blir dratt inn til Dragons, spesielt de vakre karakterene, men der det teller, vil Dragons være fjernt fra alle andre. Kanskje det er med den begrunnelsen at de er best når de jobber alene. Deres tilbøyelighet til å bli skilt fra alle andre kan synes å være selvtillit eller forfengelighet, men disse egenskapene er ikke relevante. Bevingede slanger har følelser som kan blusse raskt!","first_slovakia":"Drak, ktorý má piatu situáciu v čínskom zverokruhu, je najmocnejším zo znamení. Mýtickí hadi symbolizujú také charakterové vlastnosti ako prevaha a túžba. Mýtickí hadi radi žijú podľa svojich vlastných zásad a vždy, keď zostanú bez niekoho iného, sú zvyčajne účinné. Sú riadení, neboja sa ťažkostí a sú pripravení vyjsť na končatiny. Sú nadšení zo všetkého, čo dokážu, a robia veci vo fantastickom dizajne. Šokujúco môže táto energia a vzrušenie spôsobiť, že sa Draci budú cítiť vyčerpaní a zvedaví, nenaplnení.","second_slovakia":"Aj keď draky väčšinu času pomáhajú iným ľuďom, zriedka požiadajú o pomoc. Iní sú priťahovaní k Drakom, najmä k ich krásnym postavám, ale tam, kde to má význam, chcú byť Draci vzdialení od všetkých ostatných. Možno to je na základe toho, že najlepšie sú, keď pracujú sami. Ich sklon byť oddelený od všetkých ostatných sa môže javiť ako sebestačnosť alebo márnosť, napriek tomu tieto vlastnosti nie sú relevantné. Okrídlení hadi majú emócie, ktoré môžu rýchlo vzplanúť!"},"health":{"english":"Thinking about their dedicated nature, Dragons are sound in general. They do get pushed and experience the ill effects of occasional strain/cerebral pains, likely in light of the fact that they go out on a limb. Mythical serpents could profit by joining gentle movement into their lives. Yoga or strolling would be great as these exercises can work both their psyches and their bodies.","arabic":"عند التفكير في طبيعتها المكرسة ، التنين هي الاساس بشكل عام. إنهم يتعرضون للضغط ويختبرون الآثار السيئة لآلام الإجهاد العرضي / الدماغي ، على الأرجح في ضوء حقيقة خروجهم من أحد الأطراف. يمكن أن تستفيد الثعابين الأسطورية من خلال الانضمام إلى حركة لطيفة في حياتهم. اليوغا أو التمشي ستكون رائعة لأن هذه التمارين يمكن أن تعمل على نفسية وجسدها.","greek":"Σκεπτόμενοι την αφοσιωμένη φύση τους, οι Δράκοι είναι γενικά θορυβώδεις. Παίρνουν ώθηση και βιώνουν τις κακές επιδράσεις των περιστασιακών καταθλιπτικών / εγκεφαλικών πόνων, πιθανόν υπό το φως του γεγονότος ότι βρίσκονται σε ένα όριο. Τα μυθικά φίδια θα μπορούσαν να ωφεληθούν συνδυάζοντας την απαλή κίνηση με τη ζωή τους. Η γιόγκα ή η περιπλάνηση θα ήταν τέλεια καθώς αυτές οι ασκήσεις μπορούν να λειτουργήσουν τόσο στις ψυχές τους όσο και στο σώμα τους.","malay":"Berfikir tentang sifat berdedikasi mereka,Naga berbunyi secara umum. Mereka dapat ditolak dan mengalami masalah kesihatan yang seperti ketegangan/cerebral,mungkin disebabkan oleh fakta bahawa mereka akan keluarkan anggota badan mereka.Ular mitos boleh mendapat keuntungan dengan menyertai pergerakan lembut dalam kehidupan mereka. Yoga atau berjalan-jalan akan menjadi hebat kerana latihan ini boleh berfungsi dengan baik oleh psikologi dan badan mereka.","thai":"คนเกิดปีมะโรงเป็นคนที่ทุ่มเทกับสิ่งที่พวกเขารักและชอบความเสี่ยง ซึ่งบางครั้งทำให้พวกเขาเกิดความเครียดได้ การออกกำลังอย่าง เช่น โยคะ ก็ช่วยให้พวกเขาสงบจิตใจและฟื้นฟูร่างกายได้.","czech":"Když přemýšlíme o své oddané povaze, jsou draci obecně zdraví. Jsou tlačeni a zažívají nepříznivé účinky občasných napětí / bolestí mozku, pravděpodobně ve světle skutečnosti, že jdou ven na končetinu. Mýtičtí hadi mohli profitovat tím, že se do svých životů zapojili jemným pohybem. Jóga nebo procházky by byly skvělé, protože tato cvičení mohou pracovat jak na jejich psychice, tak na jejich tělech.","bulgarian":"Мислейки за своята отдадена природа, Драконите като цяло са здрави. Те биват тласкани и изпитват вредните ефекти от случайни щамове / мозъчни болки, вероятно в светлината на факта, че излизат на крайник. Митичните змии биха могли да спечелят, като се присъединят към нежните движения в живота си. Йога или разходка би било чудесно, тъй като тези упражнения могат да работят както на психиката, така и на тялото.","norwegian":"Mens Dragons mye av tiden hjelper andre mennesker, vil de sjelden be om hjelp. Andre blir dratt inn til Dragons, spesielt de vakre karakterene, men der det teller, vil Dragons være fjernt fra alle andre. Kanskje det er med den begrunnelsen at de er best når de jobber alene. Deres tilbøyelighet til å bli skilt fra alle andre kan synes å være selvbetydende eller forfengelig, men disse egenskapene er ikke relevante. Bevingede slanger har følelser som kan blusse raskt!","denmark":"Når vi tænker på deres dedikerede natur, er Dragons generelt sunde. De bliver skubbet og oplever de dårlige virkninger af lejlighedsvis belastning / cerebrale smerter, sandsynligvis i lyset af det faktum, at de går ud på en lem. Mytiske slanger kunne drage fordel ved at slutte sig til blid bevægelse i deres liv. Yoga eller spadseretur ville være fantastisk, da disse øvelser kan arbejde både deres psykiske og deres kroppe.","slovakia":"Keď vezmeme do úvahy ich oddanú povahu, sú Draci všeobecne zdraví. Dostávajú sa do tlaku a zažívajú nepriaznivé účinky občasných natiahnutí / bolestí mozgu, pravdepodobne vo svetle skutočnosti, že idú von na končatiny. Mýtickí hadi mohli profitovať tým, že sa do svojich životov zapojili jemným pohybom. Jóga alebo prechádzka by boli vynikajúce, pretože tieto cvičenia môžu pôsobiť na psychiku aj na telo."},"carrers":{"first_english":"Dragons like to embrace challenges and take risks. Jobs that allow them to test themselves are good choices.","second_english":"Journalist, teacher, teacher, lawyer, engineer, architect, broker and sales person. ","first_arabic":"تنانين تميل لاحتضان التحديات وتحمل المخاطر. الوظائف التي تسمح لهم باختبار أنفسهم هي خيارات جيدة.","second_arabic":"صحفي ، مدرس ، مدرس ، محامي ، مهندس ، مهندس معماري ، وسيط وموظف مبيعات.","first_greek":"Οι δράκοι επιθυμούν να αντιμετωπίσουν τις προκλήσεις και να αναλάβουν κινδύνους. Οι θέσεις εργασίας που τους επιτρέπουν να δοκιμάζουν οι ίδιοι είναι καλές επιλογές.","second_greek":"Δημοσιογράφος, δάσκαλος, δάσκαλος, δικηγόρος, μηχανικός, αρχιτέκτονας, μεσίτης και πρόσωπο πωλήσεων.","first_malay":"Naga suka menghadapi cabaran dan mengambil risiko. Pekerjaan yang membolehkan mereka menguji diri adalah pilihan yang baik.","second_malay":"Wartawan, guru,peguam, jurutera, arkitek, broker dan orang jualan.","first_thai":"คนเกิดปีมะโรงชอบความท้าทายใหม่ๆ และความกล้าบ้าบิ่น พวกเขาจึงเหมาะกับงานที่ช่วยให้พวกเขาได้พิสูจน์ตัวเอง.","second_thai":"นักข่าว ครู ทนายความ วิศวกร สถาปนิก นายหน้า และพนักงานขาย.","first_czech":"Draci rádi přijímají výzvy a riskují. Práce, které jim umožňují otestovat se, jsou dobrou volbou.","second_czech":"Novinář, učitel, učitel, právník, inženýr, architekt, makléř a obchodník.","first_bulgarian":"Драконите обичат да приемат предизвикателства и да рискуват. Работите, които им позволяват да се тестват, са добър избор. ","second_bulgarian":" Drager liker å omfavne utfordringer og ta risiko. Jobber som lar dem teste seg selv er gode valg.","first_norwegian":" Журналист, учител, учител, адвокат, инженер, архитект, брокер и продавач.","second_norwegian":" Journalist, lærer, lærer, advokat, ingeniør, arkitekt, megler og selger.","first_denmark":"Drager kan lide at omfavne udfordringer og tage risici. Job, der giver dem mulighed for at teste sig selv, er gode valg.","second_denmark":"Journalist, lærer, lærer, advokat, ingeniør, arkitekt, mægler og salgsperson. ","first_slovakia":"Draci radi prijímajú výzvy a riskujú. Pracovné miesta, ktoré im umožňujú testovať sa, sú dobrou voľbou.","second_slovakia":"Novinár, učiteľ, učiteľ, právnik, inžinier, architekt, maklér a pracovník predaja. "},"lucky":{"numbers":[1,6,7],"colors_english":["Gold","Gray","Silver"],"directions_english":["East","North","South"],"colors_arabic":["ذهبي","رمادي","فضي "],"colors_greek":["Χρυσό","Γκρί","Ασημί"],"directions_arabic":["شرق","شمال ","جنوب"],"directions_greek":["Ανατολή","Βοράς","Νότια"],"colors_malay":["Emas","Kelabu","Perak"],"directions_malay":["Timur","Utara","Selatan"],"colors_thai":["สีทอง","สีเทา","สีเงิน"],"directions_thai":["ทิศตะวันออก","ทิศเหนือ","ทิศใต้"],"colors_czech":["Zlato","Šedá","stříbrný"],"directions_czech":["Východní","Severní","Jižní"],"colors_bulgarian":["Злато","Сиво","Сребро"],"colors_norwegian":["Gull","Grå","Sølv"],"directions_bulgarian":["изток","север","На юг"],"directions_norwegian":["Øst","Nord","Sør"],"colors_denmark":["Guld","Grå","Sølv"],"directions_denmark":["Øst","Nord","Syd"],"colors_slovakia":["Zlato","Šedá","Striebro"],"directions_slovakia":["Východ","Sever","Juh"]},"unlucky":{"numbers":[3,8],"colors_english":["Cyan","Green"],"directions_english":["Northwest"],"colors_arabic":["ازرق سماوي","ذهبي"],"colors_greek":["Κυανό","Πράσινο"],"directions_arabic":["شمال غربي"],"directions_greek":["Βορειοδυτικά"],"colors_malay":["Cyan","Hijau"],"directions_malay":["Barat laut"],"colors_thai":["สีน้ำเงินอมเขียว","สีเขียว"],"directions_thai":["ทิศตะวันตกเฉียงเหนือ"],"colors_czech":["Tyrkysová","Zelená"],"directions_czech":["Severozápad"],"colors_bulgarian":["Циан","Зелено"],"colors_norwegian":["Cyan","Grønn"],"directions_bulgarian":["Северозападна"],"directions_norwegian":["Nordvest"],"colors_denmark":["Cyan","Grøn"],"directions_denmark":["Nord Vest"],"colors_slovakia":["Tyrkysový","zelená"],"directions_slovakia":["Severozápad"]},"love":{"best_english":["Rat","Tiger","Snake"],"worst_english":["Ox","Goat","Dog"],"best_arabic":["الفأر","نمر","الافعى"],"worst_arabic":["ثعلب","الماعز","الكلب"],"best_greek":["Αρουραίος","Τίγρη","Φίδι"],"worst_greek":["Βόδι","Κατσίκα","Σκύλος"],"best_malay":["Tikus","Harimau","Ular"],"worst_malay":["Lembu","Kambing","Anjing"],"best_thai":["ปีชวด","ปีขาล","ปีมะเส็ง"],"worst_thai":["ปีฉลู","ปีมะแม","ปีจอ"],"best_czech":["Krysa","Tygr","Had"],"worst_czech":["Vůl","Koza","Pes"],"best_bulgarian":["Плъх","тигър","Змия"],"best_norwegian":["Rotte","Tiger","Slange"],"worst_bulgarian":["Вол","Козел","Куче"],"worst_norwegian":["Okse","Geit","Hund"],"best_denmark":["Rotte","Tiger","Slange"],"worst_denmark":["Okse","Ged","Hund"],"best_slovakia":["Potkan","Tiger","Had"],"worst_slovakia":["Vôl","Koza","pes"]},"years":[1904,1916,1928,1940,1952,1964,1976,1988,2000,2012,2024,2036],"unicode_symbol":"辰"},{"sign_english":"Snake","sign_arabic":"الافعى","sign_greek":"Φίδι","sign_malay":"Ular","sign_thai":"ปีมะเส็ง","sign_czech":"Had","sign_bulgarian":"Змия","sign_norwegian":"Slange","sign_denmark":"Slange","sign_slovakia":"Had","yin-yang":"Yin","direction":"South","season":"Early Summer","element":"Fire","trine":"2nd","personality":{"first_english":"Possessing the sixth situation in the Chinese Zodiac, the Snake symbolizes such character attributes as knowledge, elegance and realism. With regards to basic leadership, Snakes are amazingly expository and subsequently, they don't hop into circumstances. They are viable at getting the things they need, regardless of whether it implies they need to plan and plot end route.","second_english":"Snakes are extremely materialistic signs, liking to encircle themselves with the best that life brings to the table. This is particularly apparent in the home, where rich goods and environment help Snakes look for the harmony they need so as to flourish.","first_arabic":"تملتك الموضع السادس في البروج الصينية ، يرمز الأفعى إلى سمات شخصية مثل المعرفة والأناقة والواقعية. فيما يتعلق بالقيادة الأساسية ، فإن الثعابين تفسيرية بشكل مثير للدهشة ، وبعد ذلك ، لا تقفز إلى للاستنتاج. إنهم قادرون على الحصول على الأشياء التي يحتاجون إليها ، بغض النظر عما إذا كان هذا يعني أنهم بحاجة إلى التخطيط ووضع علامات على الطريق.","second_arabic":"الثعابين هي علامات مادية للغاية ، ترغب في تطويق نفسها بأفضل ما تجلبه الحياة إلى الطاولة. هذا واضح بشكل خاص في المنزل ، حيث تساعد الاجواء الغنية والبيئة الثعابين في البحث عن الانسجام الذي تحتاج إليه لتزدهر.","first_greek":"Κατέχοντας την έκτη κατάσταση στον Κινέζικο ωροσκόπιο, το Φίδι συμβολίζει τέτοια χαρακτηριστικά γνωρίσματα όπως η γνώση, η κομψότητα και ο ρεαλισμός. Όσον αφορά τη βασική ηγεσία, τα φίδια είναι εκπληκτικά ανοικτόμυαλα και έτσι δεν μπλέκουν σε καταστάσεις. Είναι ικανά να πάρουν τα πράγματα που χρειάζονται, ανεξάρτητα από το αν χρειάζεται να σχεδιάσουν και να δρομολογήσουν καθ 'οδόν.","second_greek":"Τα φίδια είναι εξαιρετικά υλιστικά στοιχεία, που αρέσουν να περικυκλώνονται με το καλύτερο που φέρνει η ζωή στο τραπέζι. Αυτό είναι ιδιαίτερα εμφανές στο σπίτι, όπου τα πλούσια αγαθά και το περιβάλλον βοηθούν τα Φίδια να αναζητούν την αρμονία που χρειάζονται για να ευδοκιμήσουν.","first_malay":"Memiliki tempat keenam di Zodiak Cina, Ular melambangkan ciri-ciri watak seperti berpengetahuan, keanggunan dan realisme.Berhubung dengan kepimpinan asas, ular sangat mengkagumkan,mereka tidak melangkah ke dalam keadaan.Mereka berdaya maju untuk mendapatkan perkara yang mereka perlukan, tanpa mengira sama ada ia bermakna mereka perlu merancang sesuatu dengan sempurna.","second_malay":"Ular adalah tanda-tanda yang sangat materialistik, menyukai mengelilingi diri dengan yang terbaik yang membawa kehidupan ke meja. Ini amat jelas di rumah, di mana barangan dan persekitaran yang kaya membantu Ular mencari keharmonian yang mereka perlukan untuk berkembang.","first_thai":"ปีมะเส็งเป็นปีนักษัตรลำดับที่หกของตำราโหราศาสตร์จีน คนเกิดปีมะเส็งเป็นคนมีความรู้ บุคลิกภาพหน้าตาดี และมองโลกตามความเป็นจริง พวกเขามีความเป็นผู้นำและเก่งในเรื่องการอธิบายเรื่องต่างๆ นอกจากนี้พวกเขายังเก่งในเรื่องการวางแผนซึ่งเป็นส่วนสำคัญที่ช่วยให้พวกเขาประสบความสำเร็จ.","second_thai":"คนเกิดปีมะเส็งจัดอยู่ในกลุ่มวัตถุนิยม พวกเขาจะเลือกสิ่งที่ดีที่สุดให้กับตัวเองเสมอ ซึ่งดูได้จากสิ่งของที่พวกเขาเลือกใช้ภายในบ้านที่มักจะมีราคาแพงและบรรยากาศภายในบ้านที่มักจะตกแต่งอย่างหรูหราเพื่อให้รู้ว่าพวกเขามีฐานะดี.","first_czech":"Had, který představuje šestou situaci v čínském zvěrokruhu, symbolizuje takové charakterové atributy jako znalosti, eleganci a realismus. Pokud jde o základní vedení, hadi jsou úžasně vysvětlující a následně nenaskočí do okolností. Jsou životaschopní v získávání věcí, které potřebují, bez ohledu na to, zda z toho vyplývá, že musí plánovat a vytyčit konečnou trasu.","second_czech":"Hadi jsou nesmírně materialistická znamení, která se rádi obklopují tím nejlepším, co život na stůl přináší. To je patrné zejména v domácnosti, kde bohaté zboží a životní prostředí pomáhají hadům hledat harmonii, kterou potřebují, aby mohli vzkvétat.","first_bulgarian":" Притежавайки шестата ситуация в китайския зодиак, Змията символизира такива атрибути на характера като знание, елегантност и реализъм. Що се отнася до основното лидерство, змиите са изумителни и впоследствие те не прескачат обстоятелствата. Те са жизнеспособни да получат нещата, от които се нуждаят, независимо дали това означава, че трябва да планират и планират по пътя.","second_bulgarian":"Змиите са склонни да продължат със съществуването на спокойствие, като се навеждат към тишина над суматохата и разумна оставаща задача под ръка, вместо към прекалено резервиран календар. Змиите стават ефективно изтласкани, когато животът им не е спокоен или съвсем заедно. Много от тези линии на живота могат да съкратят живота на змията! ","first_norwegian":" Med den sjette situasjonen i den kinesiske dyrekretsen, symboliserer slangen slike karakteregenskaper som kunnskap, eleganse og realisme. Når det gjelder grunnleggende ledelse, er slanger utrolig utsatt, og deretter hopper de ikke inn i omstendigheter. De er levedyktige til å få de tingene de trenger, uansett om det innebærer at de trenger å planlegge og planlegge underveis.","second_norwegian":" Slanger skråner mot å fortsette med en tilværelse av ro, lener seg mot stillhet over oppstyr og en fornuftig gjenværende oppgave for hånden i stedet for en kalender som er altfor reservert. Slanger blir effektivt presset når livene deres ikke er rolige eller alle sammen. Mye av dette kan forkortes en slanges liv!","first_denmark":"Besidder den sjette situation i den kinesiske stjernetegn, symboliserer slangen sådanne karakteregenskaber som viden, elegance og realisme. Med hensyn til grundlæggende lederskab er slanger forbløffende eksponerende, og de hopper derefter ikke ind i omstændigheder. De er levedygtige til at få de ting, de har brug for, uanset om det betyder, at de har brug for at planlægge og plot undervejs.","second_denmark":"Slanger er ekstremt materialistiske tegn, der kan lide at omslutte sig med det bedste, livet bringer til bordet. Dette er især tydeligt i hjemmet, hvor rige varer og miljø hjælper Slanger med at lede efter den harmoni, de har brug for for at blomstre.","first_slovakia":"Had, ktorý predstavuje šiestu situáciu v čínskom zverokruhu, symbolizuje také charakterové atribúty ako vedomosti, elegancia a realizmus. Pokiaľ ide o základné vodcovstvo, hady sú úžasne výkladové a následne nenaskočia do okolností. Dokážu získať potrebné veci bez ohľadu na to, či z toho vyplýva, že musia plánovať a plánovať cestu.","second_slovakia":"Hady sú mimoriadne materialistické znamenia, ktoré sa radi obklopia tým najlepším, čo život na stôl prinesie. To je zrejmé najmä v domácnosti, kde bohatý tovar a životné prostredie pomáha hadom hľadať harmóniu, ktorú potrebujú, aby mohli prosperovať."},"health":{"english":"Snakes incline toward carrying on with an existence of tranquility, leaning toward quietness over commotion and a sensible remaining task at hand instead of a calendar that is excessively reserved. Snakes become effectively pushed when their lives aren't serene or all together. A lot of along these lines of life can abbreviate a snake's life!","arabic":"تميل الأفاعي نحو الاستمرار مع وجود الهدوء ، وتميل نحو الهدوء أكثر من الضجة والمهمة المعقولة في متناول اليد بدلا من التقويم الذي يتم الاحتفاظ به بشكل مفرط. تصبح الثعابين مدفوعة بفعالية عندما لا تكون حياتها هادئة أو جميعها معًا. الكثير من هذه الخطوط من الحياة يمكن أن يختصر حياة الثعبان!","greek":"Τα φίδια κλίνουν προς την κατεύθυνση της συνέχισης με την ύπαρξη της ηρεμίας, επιλέγοντας την ησυχία πέρα από την αναταραχή και μία πιο χαλαρή διαχείριση υποχρεώσεων, που δεν θα ορίζεται με αυστηρότητα από ένα ημερολόγιο. Τα φίδια παρακινούνται αποτελεσματικά όταν οι ζωές τους δεν είναι σε ηρεμία.","malay":"Ular cenderung ke arah menjalankan dengan kewujudan ketenangan, menuju ke arah ketenangan atas kesibukan dan tugas yang masih tersisa di tangan bukan kalendar yang berlebihan. Ular menjadi berkesan apabila kehidupan mereka tidak tenang atau bersama-sama. Banyak sepanjang garis kehidupan ini dapat menyingkat kehidupan ular!","thai":"คนเกิดปีมะเส็งชอบใช้ชีวิตเงียบๆ และชอบทำงานที่ใช้สมาธิเพื่อหลีกหนีความวุ่นวายจากโลกภายนอก พวกเขาจะรู้สึกกดดันและเครียดมากเมื่อชีวิตวุ่นวายยุ่งเหยิง","czech":"Hadi jsou vynalézaví a úžasně odhodlaní. Navzdory skutečnosti, že se hadi spoutají, mají tendenci být pracovními kontejnery, protože se ukázalo, že jsou skutečně vyčerpaní. Hadi jsou neuvěřitelní duchovní duchové. Složité problémy je oživují. Jsou ohromujícími řešiteli problémů a vzkvétají v těsných mezních časech.","bulgarian":"Змиите са склонни да продължат със съществуването на спокойствие, като се навеждат към тишина над суматохата и разумна оставаща задача под ръка, вместо към прекалено резервиран календар. Змиите стават ефективно изтласкани, когато животът им не е спокоен или съвсем заедно. Много от тези линии на живота могат да съкратят живота на змията!","norwegian":"Slanger skråner mot å fortsette med en tilværelse av ro, lener seg mot stillhet over oppstyr og en fornuftig gjenværende oppgave for hånden i stedet for en kalender som er altfor reservert. Slanger blir effektivt presset når livene deres ikke er rolige eller alle sammen. Mye av dette kan forkortes en slanges liv!","denmark":"Slanger skråner mod at fortsætte med en eksistens af ro, læner sig mod stilhed over uro og en fornuftig resterende opgave ved hånden i stedet for en kalender, der er alt for reserveret. Slanger bliver effektivt skubbet, når deres liv ikke er rolige eller alle sammen. Meget i denne retning af livet kan forkorte en slanges liv!","slovakia":"Hady inklinujú k pokračovaniu v existencii pokoja, prikláňajú sa k tichu nad rozruchom a rozumnej zostávajúcej úlohe namiesto kalendára, ktorý je nadmerne rezervovaný. Hady sa efektívne tlačia, keď ich život nie je pokojný alebo všetky dohromady. Mnoho z týchto životných línií môže skrátiť život hada!"},"carrers":{"first_english":"Snakes are inventive and amazingly determined. Despite the fact that Snakes buckle down, they tend to be work containers as they turned out to be effectively exhausted. Snakes are incredible masterminds. Complex issues invigorate them. They're astounding issue solvers and flourish under tight cutoff times.","second_english":"Scientist, analyst, investigator, painter, potter, jeweler, astrologer, magician, dietician, and sociologist. ","first_arabic":"الثعابين مبتكرة ومصممة بشكل مثير للدهشة. على الرغم من أن ثعبان ربط حزام الأمان ، فإنها تميل إلى أن تكون حاويات العمل كما تبين أنها استنفدت بفعالية. الثعابين هي العقل المدبر لا يصدق. القضايا المعقدة تنشطهم. إنهم مذهلون في حل المشكلات وتزدهر في أوقات ضيق.","second_arabic":"عالم ، محلل ، باحث ، رسام ، بوتر ، صائغ ، منجم ، ساحر ، اختصاصي تغذية ، وعالم اجتماع.","first_greek":"Τα φίδια είναι εφευρετικά και εκπληκτικά αποφασιστικά. Παρά το γεγονός ότι τα φίδια στρέφονται προς τα κάτω, τείνουν να είναι εργατικά κάτι που ενίοτε τα εξαντλεί. Τα φίδια είναι απίστευτοι εκγέφαλοι. Πολύ σύνθετα ζητήματα τους ερεθίζουν Είναι εκπληκτικοί στην επίλυση ζητημάτων και μεγαλουργούν υπό αυστηρούς χρόνικούς περιορισμούς.","second_greek":"Επιστήμονας, αναλυτής, ερευνητής, ζωγράφος, αγγειοπλάστης, κοσμηματοπώλης, αστρολόγος, μάγος, διαιτολόγος και κοινωνιολόγος.","first_malay":"Ular adalah bersifat inventif dan luar biasa. Walaupun Ular itu turun ke bawah, mereka cenderung menjadi bekas kerja kerana mereka ternyata menjadi letih. Ular adalah haiwan yang luar biasa. Isu kompleks mencergaskan mereka. Mereka mengatasi masalah isu yang mengagumkan dan berkembang di bawah masa yang singkat","second_malay":"Saintis, penganalisis, penyiasat, pelukis, tukang periuk, perhiasan, ahli nujum, ahli silap mata, ahli diet dan sosiologi.","first_thai":"คนเกิดปีมะเส็งเป็นคนช่างคิดช่างทำและมีความมานะทุ่มเทในการทำสิ่งต่างๆ ด้วยเหตุผลนี้เองบ่อยครั้งพวกเขาจึงรู้สึกเหนื่อยหล้ากับสิ่งที่พวกเขากำลังทำอยู่ พวกเขาเก่งในเรื่องการวางแผน การได้แก้ไขปัญหาที่มีความท้าทายช่วยเติมพลังชีวิตให้พวกเขา","second_thai":"นักวิทยาศาสตร์ นักวิเคราะห์ พนักงานสอบสวน นักเขียน จิตรกร ช่างปั้น ช่างทำอัญมณี นักโหราศาสตร์ นักมายากล นักโภชนาการ และนักสังคมวิทยา.","first_czech":"Hadi jsou vynalézaví a úžasně odhodlaní. Navzdory skutečnosti, že se hadi spoutají, mají tendenci být pracovními kontejnery, protože se ukázalo, že jsou skutečně vyčerpaní. Hadi jsou neuvěřitelní duchovní duchové. Složité problémy je oživují. Jsou ohromujícími řešiteli problémů a vzkvétají v těsných mezních časech.","second_czech":"Vědec, analytik, vyšetřovatel, malíř, hrnčíř, klenotník, astrolog, kouzelník, dietolog a sociolog.","first_bulgarian":" Змиите са изобретателни и изумително решени. Въпреки факта, че змиите се закопчават, те обикновено са работни контейнери, тъй като се оказват ефективно изтощени. Змиите са невероятни създатели. Сложните проблеми ги ободряват. Те са изумителни за разрешаване на проблеми и процъфтяват в кратки срокове.","second_bulgarian":" Учен, анализатор, изследовател, художник, грънчар, бижутер, астролог, магьосник, диетолог и социолог.","first_norwegian":" Slanger er oppfinnsomme og utrolig bestemt. Til tross for at slanger spenner seg, pleier de å være arbeidscontainere da de viste seg å være effektivt oppbrukt. Slanger er utrolige hjerner. Komplekse problemer forsterker dem. De er forbløffende problemløsere og blomstrer under stramme avskjæringstider.","second_norwegian":" Forsker, analytiker, etterforsker, maler, pottemaker, gullsmed, astrolog, tryllekunstner, diettist og sosiolog.","first_denmark":"Slanger er opfindsomme og forbløffende bestemt. På trods af at slanger spænder ned, har de en tendens til at være arbejdscontainere, da de viste sig at være effektivt opbrugte. Slanger er utrolige hjerner. Komplekse problemer styrker dem. De er forbløffende problemløsere og blomstrer under stramme cutoff-tider.","second_denmark":"Forsker, analytiker, etterforsker, maler, pottemaker, gullsmed, astrolog, tryllekunstner, diettist og sosiolog.","first_slovakia":"Hady sú vynaliezavé a úžasne odhodlané. Napriek skutočnosti, že hady sa pripútajú, majú tendenciu byť pracovnými kontajnermi, pretože sa ukázali ako efektívne vyčerpané. Hady sú neuveriteľní strojcovia. Zložité problémy ich oživujú. Sú ohromujúci pri riešení problémov a prekvitajú v krátkych medzných časoch.","second_slovakia":"Vedec, analytik, vyšetrovateľ, maliar, hrnčiar, klenotník, astrológ, kúzelník, dietológ a sociológ.s"},"lucky":{"numbers":[2,8,9],"colors_english":["Black","Red","Yellow"],"directions_english":["East","West","Southwest"],"colors_arabic":["اسود","أحمر","اصفر"],"colors_greek":["Μαύρο","Κόκκινο","Κίτρινο"],"directions_arabic":["شرق","غرب","جنوب غربي"],"directions_greek":["Ανατολή","δυτικά","Νοτιοδυτικά"],"colors_malay":["Hitam","Merah","Kuning"],"directions_malay":["Timur","Barat","Barat laut"],"colors_thai":["สีดำ","สีแดง","สีเหลือง"],"directions_thai":["ทิศตะวันออก","ทิศตะวันตก","ทิศตะวันตกเฉียงเหนือ"],"colors_czech":["Černá","Červené","Žlutá"],"directions_czech":["Východní","Západ","Jihozápadní"],"colors_bulgarian":["Черен","червен","Жълто"],"colors_norwegian":["Svart","rød","Gul"],"directions_bulgarian":["изток","Запад","Югозапад"],"directions_norwegian":["Øst","Vest","Sørvest"],"colors_denmark":["Sort","Rød","Gul"],"directions_denmark":["Øst","Vest","Sydvest"],"colors_slovakia":["čierna","Červená","žltá"],"directions_slovakia":["Východ","Západ","Juhozápad"]},"unlucky":{"numbers":[1,6,7],"colors_english":["Brown","Gold","White"],"directions_english":["Northeast","Northwest"],"colors_arabic":["بني","ذهبي","ابيض"],"colors_greek":["Καφέ","Χρυσό","Λευκο"],"directions_arabic":["شمال الشرقي","شمال غربي"],"directions_greek":["Βορειοανατολικός","Βορειοδυτικά"],"colors_malay":["Perang","Emas","Putih"],"directions_malay":["Timur laut","Barat laut"],"colors_thai":["สีน้ำตาล","สีทอง","สีขาว"],"directions_thai":["ภาคตะวันออกเฉียงเหนือ","ทิศตะวันตกเฉียงเหนือ"],"colors_czech":["Hnědý","Zlato","Bílý"],"directions_czech":["Severovýchod","Severozápad"],"colors_bulgarian":["Кафяво","Злато","Бял"],"colors_norwegian":["brun","Gull","Hvit"],"directions_bulgarian":["Североизток","Северозападна"],"directions_norwegian":["Nordøst","Nordvest"],"colors_denmark":["Brun","Guld","hvid"],"directions_denmark":["nordøst","Nord Vest"],"colors_slovakia":["Hnedá","Zlato","biely"],"directions_slovakia":["Severovýchod","Severozápad"]},"love":{"best_english":["Dragon","Rooster"],"worst_english":["Tiger","Rabbit","Goat","Pig"],"best_arabic":["تنين","ديك"],"worst_arabic":["نمر","ارنب","الماعز","خنزير"],"best_greek":["Δράκος","Κόκορας"],"worst_greek":["Τίγρη","Λαγός","Κατσίκα","Γουρούνι"],"best_malay":["Naga","Ayam"],"worst_malay":["Harimau","Arnab","Kambing","Khinzir"],"best_thai":["ปีมะโรง","ปีระกา"],"worst_thai":["ปีขาล","ปีเถาะ","ปีมะแม","ปีกุน"],"best_czech":["Drak","Kohout"],"worst_czech":["Tygr","Králičí","Koza","Prase"],"best_bulgarian":["Дракон","Петел"],"best_norwegian":["Drage","Hane"],"worst_bulgarian":["тигър","Заек","Козел","Прасе"],"worst_norwegian":["Tiger","Kanin","Geit","Gris"],"best_denmark":["Trække på","Hane"],"worst_denmark":["Tiger","Kanin","Ged","Svin"],"best_slovakia":["drak","Kohút"],"worst_slovakia":["Tiger","Králik","Koza","Prasa"]},"years":[1905,1917,1929,1941,1953,1965,1977,1989,2001,2013,2025,2037],"unicode_symbol":"巳"},{"sign_english":"Horse","sign_arabic":"حصان","sign_greek":"Αλογο","sign_malay":"Kuda","sign_thai":"ปีมะเมีย","sign_czech":"Kůň","sign_bulgarian":"Кон","sign_norwegian":"Hest","sign_denmark":"Hest","sign_slovakia":"Kôň","yin-yang":"Yang","direction":"South","season":"Mid-Summer","element":"Fire","trine":"3rd","personality":{"first_english":"Possessing the seventh situation on the Chinese Zodiac, the Horse symbolizes such character qualities as quality, vitality, and an active nature. Incredibly energized, Horses flourish when they're the focal point of consideration. Continuously looking for a decent time, Horses keep the groups content with their funniness and their mind.","second_english":"Steeds are amazingly keen so they're ready to get a handle on new subjects effortlessly. They're additionally fit for performing various tasks anyway they don't generally complete what they start since they're always pursuing the following chance. Steeds are straightforward, cordial and liberal. They're maybe a piece excessively focused on themselves and have been known to pitch fits when circumstances don't go their direction.","first_arabic":"تقعل في المركز السابع على البروج الصينية ، يرمز الحصان إلى صفات الشخصية مثل الجودة والحيوية والطبيعة النشطة. نشط بشكل لا يصدق ، تزدهر الخيول عندما تكون نقطة محورية في الاعتبار. تبحث باستمرار عن وقت لائق ، وتحافظ الخيول على المحتوى للمجموعات من خلال مرحهم وعقلهم.","second_arabic":"تعتبر الاحصنة متشوقة بشكل مثير للدهشة ، لذا فهي مستعدة للتعامل مع الموضوعات الجديدة دون عناء. إنها مناسبة أيضًا لأداء العديد من المهام على أي حال أنها لا تكمل عمومًا ما تبدأ به لأنها تسعى دائمًا للحصول على الفرصة التالية. الاحصنة واضحة وصريحة و متفتحة. ربما تكون شخصيات مركّزة بشكل مفرط على نفسها وقد عُرف عنها أنها تلائمها عندما لا تسير الظروف في اتجاهها.","first_greek":"Καταλαμβάνοντας την έβδομη θέση στο κινέζικο ωροσκόπιο, το άλογο συμβολίζει ιδιότητες χαρακτήρα όπως η ποιότητα, η ζωτικότητα και η ενεργή φύση. Απίστευτα ζωντανά, τα άλογα λάμπουν όταν βρίσκονται στο επίκεντρο των πραγμάτων. Αναζητώντας συνεχώς ένα ποιοτικό χρόνο, τα άλογα κρατούν το ενδιαφέρον των υπολοίπων με τον αστείο χαρακτήρα και το μυαλό τους.","second_greek":"Τα άλογα είναι συνεχώς σε εγρήγορση, έτοιμα να βγάλουν το χέρι τους σε νέα θέματα, χωρίς κόπο. Επιπλέον, είναι κατάλληλοι για την εκτέλεση διαφορετικών καθηκόντων, χωρίς όμως να ολοκληρώνουν γενικά αυτό που ξεκινούν, αφού πάντα ακολουθούν την ακόλουθη ευκαιρία. Τα άλογα είναι απλά, εγκάρδια και φιλελεύθερα. Υπάρχει ίσως ένα κομμάτι που επικεντρώνεται υπερβολικά στον εαυτό τους και είναι γνωστή ι ικανότητά τους να προσαρμόζονται ακόμα και σε δύσκολες καταστάσεις.","first_malay":"Memiliki situasi ketujuh pada Zodiak Cina, Kuda melambangkan sifat watak seperti kualiti, daya hidup, dan sifat aktif. Sangat bertenaga, Kuda akan bertambah baik apabila mereka menjadi tumpuan utama. Terus mencari masa yang baik, Kuda menjaga kandungan kumpulan dengan keseronokan dan fikiran mereka.","second_malay":"Kuda yang digunakan untuk menunggang sangat menakjubkan sehingga mereka bersedia untuk mengendalikan subjek yang terbaru dan mudah. Mereka juga sesuai untuk melakukan pelbagai tugas, tetapi mereka tidak membuat sesuatu dengan lengkap kerana mereka selalu mengejar peluang yang baru di hadapan mereka. Mereka mungkin sekadar memberi tumpuan kepada diri sendiri dan mereka tahu apa yang sesuai dengan keadaan, jika keadaan tidak sesuai dengan haluan mereka.","first_thai":"ปีมะเมียเป็นปีนักษัตรลำดับที่เจ็ดของตำราโหราศาสตร์จีน คนเกิดปีมะเมียเป็นคนมีความสามารถ แข็งแรง และกระฉับกระเฉง นอกจากนี้พวกเขายังเป็นคนเห็นอกเห็นใจผู้อื่น และพวกเขามีความสามารถในการทำให้ผู้อื่นหัวเราะและอารมณ์ดีได้เสมอ.","second_thai":"คนเกิดปีมะเมียมีความกระตือรือร้นในการลองทำหรือเรียนรู้สิ่งใหม่ๆ แต่อย่างไรก็ตามแม้พวกเขาจะเหมาะกับงานหลายๆด้าน พวกเขามักจะทำงานไม่สำเร็จสักเท่าไหร่ คนเกิดปีมะเมียเป็นคนตรงไปตรงมา จริงใจ และรักอิสระ พวกเขาเอาแต่ใจเล็กน้อยและรู้สึกมีอารมณ์เมื่อบางอย่างไม่ได้ดั่งใจ.","first_czech":"Kůň, který má sedmou situaci na čínském zvěrokruhu, symbolizuje takové charakterové vlastnosti, jako je kvalita, vitalita a aktivní povaha. Koně neuvěřitelně pod napětím vzkvétají, když jsou ohniskem pozornosti. Koně neustále hledají slušný čas a udržují skupiny spokojené se svou zábavností a myslí.","second_czech":"Oři jsou neuvěřitelně nadšení, takže jsou připraveni zvládnout nové předměty bez námahy. Jsou navíc způsobilí k provádění různých úkolů, i když obecně nedokončí to, co začnou, protože vždy sledují následující šanci. Oři jsou přímí, srdeční a liberální. Možná jsou kusem příliš soustředěným na sebe a bylo o nich známo, že se hodí, když okolnosti nevycházejí jejich směrem.","first_bulgarian":" Притежавайки седмата ситуация на китайския зодиак, Конят символизира такива качества на характера като качество, жизненост и активен характер. Невероятно енергизирани, конете процъфтяват, когато са фокусна точка за разглеждане. Непрекъснато търсейки прилично време, Конете поддържат групите доволни със своята забавност и ум.","second_bulgarian":" Steeds са невероятно запалени, така че са готови да се справят безпроблемно с нови теми. Освен това са годни за изпълнение на различни задачи, така или иначе обикновено не изпълняват това, което започват, тъй като винаги преследват следния шанс. Steeds са директни, сърдечни и либерални. Те може би са парче, прекалено фокусирано върху себе си и е известно, че се вписва, когато обстоятелствата не вървят в тяхната посока.","first_norwegian":" Med den syvende situasjonen på den kinesiske dyrekretsen, symboliserer hesten slike karakteregenskaper som kvalitet, vitalitet og en aktiv natur. Utrolig energisk, hester blomstrer når de er fokuspunktet for omtanke. Hester holder kontinuerlig på jakt etter en anstendig tid og holder gruppene fornøyde med sin morsomhet og sinn.","second_norwegian":" Steeds er utrolig ivrige, så de er klare til å håndtere nye emner uten problemer. De er også i stand til å utføre forskjellige oppgaver uansett, de fullfører vanligvis ikke det de starter, siden de alltid forfølger følgende sjanse. Steeds er enkle, hjertelige og liberale. De er kanskje et stykke som er altfor fokusert på seg selv og har vært kjent for at de passer når omstendighetene ikke går deres retning.","first_denmark":"Med den syvende situation på den kinesiske stjernetegn symboliserer hesten sådanne karakterkvaliteter som kvalitet, vitalitet og en aktiv natur. Utroligt energisk, heste blomstrer, når de er omdrejningspunktet. Heste holder konstant på udkig efter en anstændig tid og holder grupperne tilfredse med deres sjov og sind.","second_denmark":"Steeds er utroligt ivrige, så de er klar til at håndtere nye motiver uden besvær. De er desuden egnede til at udføre forskellige opgaver alligevel, de fuldender generelt ikke det, de starter, da de altid forfølger følgende chance. Steeds er ligetil, hjertelig og liberal. De er måske et stykke overdrevent fokuseret på sig selv og har været kendt for at tonehøjde, når omstændighederne ikke går deres retning.","first_slovakia":"Kôň, ktorý má siedmu situáciu v čínskom zverokruhu, symbolizuje také charakterové vlastnosti ako kvalita, vitalita a aktívna povaha. Kone je neuveriteľne nabité energiou a prosperuje, keď je stredobodom pozornosti. Kone neustále hľadá dôstojný čas a udržiava skupiny spokojné so svojou zábavnosťou a mysľou.","second_slovakia":"Steeds sú neuveriteľne horliví, takže sú pripravení zvládnuť nové predmety bez námahy. Sú navyše spôsobilí na vykonávanie rôznych úloh, aj keď vo všeobecnosti nedokončia to, čo začnú, pretože vždy sledujú nasledujúcu šancu. Stey sú priame, srdečné a liberálne. Možno sú kusom nadmerne zameraným na seba a bolo o nich známe, že sa hodia, keď okolnosti nejdú ich smerom."},"health":{"english":"Steeds are sound, in all probability since they keep up an inspirational point of view and in light of the fact that they're athletic. Lead Horses to wide, open spaces and watch them run free! Steeds will normally possibly feel sick when they're caught inside.","arabic":"الأحجام سليمة ، في جميع الاحتمالات لأنها تحافظ على وجهة نظر ملهمة وفي ضوء حقيقة أنها رياضية. قيادة الخيول إلى مساحات واسعة ومفتوحة ومشاهدتها تعمل مجانًا! من المحتمل أن تشعر الأشجار بالمرض عادة عندما يتم اصطيادها بالداخل.","greek":"Τα άλογα είναι υγιή, κατά πάσα πιθανότητα επειδή διατηρούν μια πηγή έμπνευσης και με δεδομένο ότι είναι αθλητικά. Δώστε στα Άλογα πλατύς, ανοιχτούς δρόμους να κινηθούν και απολαύστε τα να τρέχουν ελεύθερα! Τα άλογα πιθανότατα δεν αισθάνονται καλά όταν κλείνονται μέσα.","malay":"Kuda adalah bunyi, dengan kebarangkalian semenjak mereka mengekalkan sudut pandang inspirasi dan berdasarkan fakta bahawa mereka adalah olahraga. Ketua Kuda ke ruang yang luas dan terbuka dan melihat mereka berlari dengan bebas!Kuda biasanya akan merasa sakit apabila mereka ditangkap di dalam.","thai":"คนเกิดปีมะเมียเป็นคนแข็งแรงและมีแรงบันดาลใจในการทำสิ่งต่างๆ พวกเขารักอิสระและชอบการทำงานข้างนอก และพวกเขาจะไม่มีความสุขเป็นอย่างมากเมื่อต้องทำงานแต่อยู่ข้างในและเมื่อมีข้อจำกัดในการทำสิ่งต่างๆ มากเกินไป.","czech":"oři jsou s největší pravděpodobností zdraví, protože udržují inspirační úhel pohledu a vzhledem k tomu, že jsou atletičtí. Veďte koně do širokých otevřených prostorů a sledujte, jak běží zdarma! Ořům se obvykle bude možná dělat špatně, když vás chytí uvnitř.","bulgarian":"Steeds са здрави, по всяка вероятност, тъй като поддържат вдъхновяваща гледна точка и в светлината на факта, че са атлетични. Водете конете на широки, отворени пространства и ги гледайте да тичат безплатно! Обикновено на Steeds обикновено им е гадно, когато ги хванат вътре.","norwegian":"Steeds er sunne, etter all sannsynlighet, siden de holder et inspirerende synspunkt og i lys av det faktum at de er atletiske. Led hester til store, åpne områder og se dem løpe fritt! Steeds vil normalt muligens føle seg syke når de blir fanget inne.","denmark":"Steeds er sunde, efter al sandsynlighed, da de holder et inspirerende synspunkt og i lyset af det faktum, at de er atletiske. Før heste til brede, åbne rum og se dem løbe gratis! Steeds vil normalt muligvis føle sig syge, når de bliver fanget inde.","slovakia":"Steeds sú s najväčšou pravdepodobnosťou zdravé, pretože udržiavajú inšpiratívne hľadisko a vzhľadom na to, že sú atletické. Veďte kone do širokých otvorených priestorov a sledujte, ako bežia zadarmo! Keď sa ovečky chytia dovnútra, bude im zvyčajne zle."},"carrers":{"first_english":"Employments including speaking with others pull in Horses most. The Horse sign represents authority, the board, and basic leadership. Ponies abhorrence taking requests. Horses can make it in any profession that requests neither isolation nor contemplation, for they are outgoing individuals and should be encompassed by individuals who support of them and compliment them.","second_english":"Publicist, sales representative, journalist, language instructor, translator, bartender, performer, tour operator, librarian, or pilot. ","first_arabic":"الوظائف اللتي تشمل التحدث مع الآخرين تجذب أكثر الخيول كثيرا. تمثل علامة الحصان السلطة والمجلس والقيادة الأساسية. المهور تبغظ أخذ الطلبات. يمكن للخيول أن تجعلها في أي مهنة لا تطلب العزلة أو التأمل ، لأنهم أفراد اجتماعيون ويجب أن يشملهم الأفراد الذين يدعمونهم ويكملونهم.","second_arabic":"مسؤول أو مندوب مبيعات أو صحفي أو مدرب لغة أو مترجم أو نادل أو مؤد أو مشغل رحلات أو أمين مكتبة أو رائد.","first_greek":"Οι θέσεις εργασίας, συμπεριλαμβανομένης της ομιλίας με άλλους, έλκουν περισσότερο τα άλογα. Το σύμβολο του ίππου αντιπροσωπεύει την εξουσία, το συμβούλιο και τη βασική ηγεσία. Τα άλογα μπορούν να δουλέψουν σε οποιοδήποτε επάγγελμα που δεν ζητά απομόνωση ούτε περισυλλογή, γιατί είναι ανοικτά άτομα και πρέπει να περιβάλλεται από άτομα που τα στηρίζουν και τα επικροτούν.","second_greek":"Δημοσιογράφος, εκπρόσωπος πωλήσεων, δημοσιογράφος, εκπαιδευτής γλωσσών, μεταφραστής, μπάρμαν, εκτελεστής, ταξιδιωτικός πράκτορας, βιβλιοθηκάριος ή πιλότος.","first_malay":"Pekerjaan termasuk bercakap dengan orang lain yang paling menarik pada Kuda. Tanda Kuda mewakili kuasa, lembaga, dan kepimpinan asas. Apabila kuda menghadapi kekecewaan mereka akan membuat permintaan. Kuda boleh membuatnya dalam mana-mana profesion yang tidak meminta pengasingan atau pertimbangan, kerana mereka adalah individu yang senang dan mudah bergaul dengan orang dan harus merangkumi oleh individu yang menyokong mereka dan memuji mereka.","second_malay":"Publisiti, wakil jualan, wartawan, pengajar bahasa, penterjemah, bartender, pelakon, pengendali pelancongan, pustakawan, atau juruterbang.","first_thai":"คนเกิดปีมะเมียมีความสามารถในการเจรจาพูดคุย การบริหารจัดการ และมีความเป็นผู้นำ พวกเขาสามารถทำงานได้ดีไม่ว่าจะทำคนเดียวหรือทำร่วมกับคนอื่น  พวกเขามีความโดดเด่นและชื่นชอบคำชมเชย.","second_thai":"นักประชาสัมพันธ์ ตัวแทนฝ่ายขาย นักข่าว ครูสอนภาษา นักแปล บาร์เทนเดอร์ นักแสดง ผู้ดำเนินการทัวร์ บรรณารักษ์ หรือนักบิน.","first_czech":"Zaměstnání včetně rozhovoru s ostatními přitahuje koně nejvíce. Znamení koně představuje autoritu, představenstvo a základní vedení. Poníci odporují přijímání žádostí. Koně to zvládnou v jakékoli profesi, která nevyžaduje izolaci ani rozjímání, protože jsou odcházejícími jednotlivci a měli by být zahrnuti jednotlivci, kteří je podporují a doplňují.","second_czech":"Publicista, obchodní zástupce, novinář, jazykový instruktor, překladatel, barman, performer, cestovní kancelář, knihovník nebo pilot.","first_bulgarian":" Заниманията, включително говоренето с други, най-много привличат конете. Знакът на коня представлява власт, съвет и основно ръководство. Пони отвращение вземане на молби. Конете могат да се справят във всяка професия, която не изисква нито изолация, нито съзерцание, тъй като те са изходящи индивиди и трябва да бъдат обхванати от хора, които ги подкрепят и им правят комплименти.","second_bulgarian":" Публицист, търговски представител, журналист, езиков инструктор, преводач, барман, изпълнител, туроператор, библиотекар или пилот.","first_norwegian":"Ansettelser, inkludert å snakke med andre, drar mest til hestene. Hesteskiltet representerer autoritet, styret og grunnleggende ledelse. Ponnier avskyr tar forespørsler. Hester kan gjøre det i ethvert yrke som verken krever isolasjon eller kontemplasjon, for de er utadvendte individer og bør omfattes av individer som støtter dem og komplimenterer dem. ","second_norwegian":" Publiser, salgsrepresentant, journalist, språkinstruktør, oversetter, bartender, utøver, turoperatør, bibliotekar eller pilot.","first_denmark":"Beskæftigelser, herunder at tale med andre, trækker mest hestene. Hesteskiltet repræsenterer autoritet, bestyrelse og grundlæggende ledelse. Ponyer afsky tager anmodninger. Heste kan gøre det i ethvert erhverv, der hverken anmoder om isolation eller kontemplation, for de er udadvendte individer og bør være omfattet af enkeltpersoner, der støtter dem og komplimenterer dem.","second_denmark":"Publiser, salgsrepresentant, journalist, språkinstruktør, oversetter, bartender, utøver, turoperatør, bibliotekar eller pilot.","first_slovakia":"Zamestnanie vrátane rozhovorov s ostatnými najviac priťahuje kone. Znamenie Kôň predstavuje autoritu, predstavenstvo a základné vedenie. Poníky ohavné prijímanie žiadostí. Kone môžu robiť v akomkoľvek povolaní, ktoré si nevyžaduje izoláciu ani rozjímanie, pretože sú odchádzajúcimi jednotlivcami a mali by ich zahŕňať jednotlivci, ktorí ich podporujú a dopĺňajú.","second_slovakia":"Publicista, obchodný zástupca, novinár, jazykový inštruktor, prekladateľ, barman, umelec, cestovná kancelária, knihovník alebo pilot. "},"lucky":{"numbers":[2,3,7],"colors_english":["Green","Yellow"],"directions_english":["East","West","Southwest"],"colors_arabic":["اخضر","اصفر"],"colors_greek":["Πράσινο","Κίτρινο"],"directions_arabic":["شرق","غرب","جنوب غربي"],"directions_greek":["Ανατολή","δυτικά","Νοτιοδυτικά"],"colors_malay":["Hijau","Kuning"],"directions_malay":["Timur","Barat","Barat daya"],"colors_thai":["สีเขียว","สีเหลือง"],"directions_thai":["ทิศตะวันออก","ทิศตะวันตก","ทิศตะวันตกเฉียงใต้"],"colors_czech":["Zelená","Žlutá"],"directions_czech":["Východní","Západ","Jihozápadní"],"colors_bulgarian":["Зелено","Жълто"],"colors_norwegian":["Grønn","Gul"],"directions_bulgarian":["изток","Запад","Югозапад"],"directions_norwegian":["Øst","Vest","Sørvest"],"colors_denmark":["Grøn","Gul"],"directions_denmark":["Øst","Vest","Sydvest"],"colors_slovakia":["zelená","žltá"],"directions_slovakia":["Východ","Západ","Juhozápad"]},"unlucky":{"numbers":[1,5,6],"colors_english":["Blue","White"],"directions_english":["North","Northwest"],"colors_arabic":["ازرق","ابيض"],"colors_greek":["Μπλε","Λευκο"],"directions_arabic":["شمال","شمال غربي"],"directions_greek":["Βοράς","Βορειοδυτικά"],"colors_malay":["Biru","Putih"],"directions_malay":["Utara","Barat laut"],"colors_thai":["สีน้ำเงิน","สีขาว"],"directions_thai":["ทิศเหนือ","ทิศตะวันตกเฉียงเหนือ"],"colors_czech":["Modrý","Bílý"],"directions_czech":["Severní"," Severozápad"],"colors_bulgarian":["Син","Бял"],"colors_norwegian":["Blå","Hvit"],"directions_bulgarian":["север","Северозападна"],"directions_norwegian":["Nord","Nordvest"],"colors_denmark":["Blå","hvid"],"directions_denmark":["Nord","Nord Vest"],"colors_slovakia":["Modrá","biely"],"directions_slovakia":["Sever","Severozápad"]},"love":{"best_english":["Goat","Tiger"],"worst_english":["Rat","Ox","Rooster"],"best_arabic":["الماعز","نمر"],"worst_arabic":["الفأر","ثعلب","ديك"],"best_greek":["Κατσίκα","Τίγρη"],"worst_greek":["Αρουραίος","Βόδι","Κόκορας"],"best_malay":["Kambing","Harimau"],"worst_malay":["Tikus","Lembu","Ayam"],"best_thai":["ปีมะแม","ปีขาล"],"worst_thai":["ปีชวด","ปีฉลู","ปีระกา"],"best_czech":["Koza","Tygr"],"worst_czech":["Krysa","Vůl","Kohout"],"best_bulgarian":["Козел","тигър"],"best_norwegian":["Geit","Tiger"],"worst_bulgarian":["Плъх","Вол","Петел"],"worst_norwegian":["Rotte","Okse","Hane"],"best_denmark":["Ged","Tiger"],"worst_denmark":["Rotte","Okse","Hane"],"best_slovakia":["Koza","Tiger"],"worst_slovakia":["Potkan","Vôl","Kohút"]},"years":[1906,1918,1930,1942,1954,1966,1978,1990,2002,2014,2026,2038],"unicode_symbol":"午"},{"sign_english":"Goat","sign_arabic":"الماعز","sign_greek":"Κατσίκα","sign_malay":"Kambing","sign_thai":"ปีมะแม","sign_czech":"Koza","sign_bulgarian":"Козел","sign_norwegian":"Geit","sign_denmark":"Ged","sign_slovakia":"Koza","yin-yang":"Yin","direction":"South","season":"Late Summer","element":"Earth","trine":"4th","personality":{"first_english":"Involving the eighth situation in the Chinese Zodiac, the Goat (or Sheep) symbolizes such character attributes as inventiveness, insight, constancy, and tranquility. Happy with being distant from everyone else to contemplate the operations of their inward personalities, Goats appreciate being a piece of a gathering, yet lean toward the sidelines instead of the middle. Their sustaining character makes Goats phenomenal parental figures. They're very and saved in light of the fact that they invest a lot of energy ingested in their contemplations. ","second_english":"Home and alone is the place Goats feel generally great. There they can communicate aesthetically, regardless of whether it's by painting, cooking or taking part in whatever masterful undertakings they appreciate. Goats incline toward the lounge chair on the grounds that there they can unwind and investigate their brains. They don't need expound goods; just things mirroring their longing for workmanship.","first_arabic":"إشراك الموقف الثامن في البروج الصينية ، يرمز الماعز (أو الخراف) إلى سمات الشخصية مثل الإبداع ، والبصيرة ، والثبات ، والهدوء. سعيد بكونه بعيدًا عن أي شخص آخر للتفكير في عمليات شخصياته الداخلية ، يقدر الماعز كونه قطعة من التجمع ، ولكن يميل نحو الخطوط الجانبية بدلاً من الوسط. طابعها الداعم يجعل الماعز شخصيات أبوية هائلة. إنهم غاية في الحفظ والتوفير في ضوء حقيقة أنهم يستثمرون الكثير من الطاقة المستهلكة في تأملاتهم.","second_arabic":"المنزل وحده هو المكان الذي تشعر فيه الماعز بأنها رائعة بشكل عام. هناك يمكنهم التواصل جمالياً ، بغض النظر عما إذا كان ذلك عن طريق الطلاء أو الطهي أو المشاركة في أي تعهدات بارعة يقدرونها. تميل الماعز نحو كرسي الصالة على أساس أنه يمكنهم الاسترخاء والتحقيق في أدمغتهم. لا يحتاجون إلى شرح البضائع ؛ مجرد أشياء تعكس شوقهم للصنعة.","first_greek":"Καταλαμβάνοντας την όγδοη θέση στο κινέζικο ωροσκόπιο, η κατσίκα συμβολίζει τέτοια χαρακτηριστικά γνωρίσματα όπως η εφευρετικότητα, η διορατικότητα, η σταθερότητα και η ηρεμία. Ευχαριστημένες από το γεγονός ότι είναι απομακρυσμένες από όλους όσους ενδιαφέρονται για τις λειτουργίες των εσωτερικών τους προσωπικοτήτων, οι κατσίκες εκτιμούν να είναι μέρος μιας παρέας, αλλά όχι το επίκεντρο αυτής. Ο διατηρητικός τους χαρακτήρας κάνει τις κατσίκες εκπληκτικά γονικά στοιχεία. Το πολύ φως τους κάνει καλό και το αποζητούν, με δεδομένο ότι επενδύουν πολλή ενέργεια απορροφημένοι στις σκέψεις τους.","second_greek":"Σπίτι και μόνοι είναι ο τόπος που οι κατσίκες αισθάνονται γενικά υπέροχα. Εκεί μπορούν να επικοινωνούν αισθητικά, ανεξάρτητα από το αν γίνεται μέσω της ζωγραφικής, του μαγειρέματος ή της συμμετοχής σε οποιεσδήποτε ασχολίες επιθυμούν. Οι κατσίκες κινούνται προς την άνεση, με το αιτιολογικό ότι μπορούν να χαλαρώσουν και να ερευνήσουν το μυαλό τους. Δεν χρειάζεται να εκθέτουν τα αγαθά τους. Μόνο πράγματα που αντικατοπτρίζουν τη λαχτάρα τους για τη δουλειά.","first_malay":"Melibatkan tempat kelapan dalam Zodiak Cina, kambing, melambangkan ciri-ciri watak seperti kemahiran, pemahaman, kemantapan, dan ketenangan. Mereka berasa gembira apabila jauh dari orang lain untuk merenungi operasi personaliti mereka,Kambing menghargai menjadi sekumpulan yang suka berhimpun, ke arah pinggir bandar dan bukannya pertengahan.Watak-watak yang mengekalkan mereka menjadi kambing fenomena keibubapaan. Mereka sangat selamat memandangkan mereka melabur banyak tenaga yang dikeluarkan dalam pertimbangan mereka.","second_malay":"Rumah dan sendirian adalah tempat Kambing rasa umumnya hebat. Di sana mereka dapat berkomunikasi estetika, tanpa mengira sama ada dengan melukis, memasak atau mengambil bahagian dalam apa-apa usaha yang mereka mahir. Kambing cenderung menuju kerusi rehat dengan alasan bahawa mereka boleh berehat dan menyiasat otak mereka. Mereka tidak perlu menjelaskan barangan, hanya perkara yang mencerminkan kepunyaan mereka untuk kerja-kerja.","first_thai":"ปีมะแมเป็นปีนักษัตรลำดับที่แปดของตำราโหราศาสตร์จีน คนเกิดปีมะแมเป็นคนช่างคิดช่างทำ มีความเห็นอกเห็นใจ มีความซื่อสัตย์ และรักความสงบ พวกเขาชอบการปลีกตัวอยู่คนเดียวและไม่ชอบเป็นจุดสนใจมากนัก เพราะความเป็นคนชอบดูแลคนอื่นพวกเขาจึงเป็นพ่อแม่ที่ดี และพวกเขายังเป็นคนทุ่มเทในการทำงานอีกด้วย.","second_thai":"คนเกิดปีมะเมียชอบใช้ชีวิตคนเดียวและชอบอยู่บ้าน พวกเขาชื่นชอบความสุนทรียะ ไม่ว่าจะเป็นการวาดภาพ การทำอาหาร และชอบเข้าร่วมกิจกรรมต่างๆ ที่ต้องใช้ทักษะ เพื่อฝึกฝนและพัฒนาฝีมือของพวกเขา.","first_czech":"Zapojením osmé situace do čínského zvěrokruhu koza (neboli ovce) symbolizuje takové charakterové atributy jako vynalézavost, vhled, stálost a klid. S radostí, že jsou vzdálení od všech ostatních, aby přemýšleli o operacích svých vnitřních osobností, kozy oceňují, že jsou součástí shromáždění, a přesto se opírají o okraj místo uprostřed. Díky jejich udržujícímu charakteru jsou kozy fenomenálními rodičovskými postavami. Jsou velmi a zachráněni s ohledem na skutečnost, že investují spoustu energie přijaté do svých rozjímání. ","second_czech":"Domov a sama je místo, kde se kozy cítí obecně skvěle. Tam mohou komunikovat esteticky, bez ohledu na to, zda je to malováním, vařením nebo účastí na jakýchkoli mistrovských počinech, které ocení. Kozy se nakloní k lehátku z toho důvodu, že se tam mohou uvolnit a prozkoumat svůj mozek. Nepotřebují vykládat zboží; jen věci odrážející jejich touhu po zpracování.","first_bulgarian":" Включвайки осмата ситуация в китайския зодиак, Козата (или Овцата) символизира такива атрибути на характера като изобретателност, проницателност, постоянство и спокойствие. Щастливи от това, че са отдалечени от всички останали, за да съзерцават операциите на своите вътрешни личности, Козите оценяват, че са част от събиране, но все пак се навеждат към страничните линии вместо към средата. Техният поддържащ характер прави Козите феноменални фигури на родители. Те са много и спасени в светлината на факта, че инвестират много енергия, погълната в своите съзерцания.","second_bulgarian":" Домът и сам е мястото, на което Козите се чувстват като цяло страхотни. Там те могат да общуват естетически, независимо дали е чрез рисуване, готвене или участие в каквито и да било майсторски начинания, които оценяват. Козите се накланят към шезлонга с мотива, че там могат да се отпуснат и да изследват мозъка си. Те не се нуждаят от изложени стоки; просто неща, които отразяват копнежа им за изработка.","first_norwegian":" Geiten (eller sauen) involverer den åttende situasjonen i den kinesiske dyrekretsen, og symboliserer slike karakteregenskaper som oppfinnsomhet, innsikt, konstantitet og ro. Geiter er glade for å være fjernt fra alle andre for å tenke over operasjonene til deres indre personligheter, og setter pris på å være et stykke av en samling, men likevel lene seg mot sidelinjen i stedet for midten. Deres opprettholdende karakter gjør geiter til fenomenale foreldrefigurer. De er veldig og reddet i lys av det faktum at de investerer mye energi inntatt i deres kontemplasjoner.","second_norwegian":" Hjemme og alene er stedet Geiter føler generelt bra. Der kan de kommunisere estetisk, uansett om det er ved å male, lage mat eller ta del i de mesterlige oppgavene de setter pris på. Geiter skråner mot lenestolen med den begrunnelsen at de kan slappe av og undersøke hjernen deres. De trenger ikke utlegge varer; bare ting som speiler deres lengsel etter utførelse.","first_denmark":"Inddragelse af den ottende situation i den kinesiske stjernetegn symboliserer Ged (eller får) sådanne karakteregenskaber som opfindsomhed, indsigt, konstantitet og ro. Geder, der er glade for at være fjernt fra alle andre for at overveje operationerne af deres indre personligheder, sætter pris på at være et stykke af en sammenkomst, men alligevel læne sig mod sidelinjen i stedet for midten. Deres opretholdende karakter gør Geder til fænomenale forældrefigurer. De er meget og reddet i lyset af det faktum, at de investerer meget energi indtaget i deres overvejelser.","second_denmark":"Hjemme og alene er det sted, geder generelt føler sig godt. Der kan de kommunikere æstetisk, uanset om det er ved at male, lave mad eller deltage i de mesterværksomme virksomheder, de værdsætter. Geder skråner mod loungestolen med den begrundelse, at de der kan slappe af og undersøge deres hjerner. De har ikke brug for eksponerede varer; bare ting, der afspejler deres længsel efter håndværk.","first_slovakia":"Koza (alebo ovca), ktorá do čínskeho zverokruhu zahrnula ôsmu situáciu, symbolizuje také charakterové atribúty ako vynaliezavosť, nadhľad, stálosť a pokoj. Kozy, ktoré sú šťastné, že sú vzdialené od všetkých ostatných, aby uvažovali nad činnosťou svojich najskrytejších osobností, oceňujú, že sú časťou zhromaždenia, a napriek tomu sa prikláňajú k postrannej čiare namiesto do stredu. Vďaka ich udržujúcemu charakteru sú kozy fenomenálnymi rodičovskými postavami. Sú veľmi a zachránení vzhľadom na skutočnosť, že investujú veľa energie prijatej do svojich kontemplácií.","second_slovakia":"Doma a osamote je miesto, kde sa kozy cítia všeobecne skvele. Môžu tam esteticky komunikovať bez ohľadu na to, či už maľovaním, varením alebo účasťou na akýchkoľvek majstrovských podnikoch, ktoré ocenia. Kozy sa nakláňajú smerom k lehátku z toho dôvodu, že si tam môžu odpočinúť a preskúmať svoj mozog. Nepotrebujú tovar na splátky; len veci odrážajúce ich túžbu po spracovaní."},"health":{"english":"Maybe in light of the fact that Goats are fundamentally peaceful, they will in general have less medical issues. Their delicate outside shrouds the reality they're normally extremely solid. When they're upbeat, they're solid. At the point when Goats become miserable, particularly because of sentiment, they immediately become debilitated.","arabic":"ربما في ضوء حقيقة أن الماعز سلمية بشكل أساسي ، سيكون لديهم بشكل عام مشكلات طبية أقل. أكواخهم الرقيقة بالخارج تجعلهم واقعيين قويين للغاية. عندما تكون متفائلة ، فهي صلبة. في الوقت الذي تصبح فيه الماعز بائسة ، خاصة بسبب الشعور ، فإنها تضعف على الفور.","greek":"Ίσως το γεγονός ότι οι κατσίκες είναι θεμελιωδώς ειρηνικές, τις κάνει να έχουν γενικά λιγότερα ιατρικά θέματα. Το ευαίσθητο παρουσιαστικό τους σκιάζει την πραγματικότητα, που συνήθως είναι εξαιρετικά σταθερή. Όταν είναι αισιόδοξοι, είναι σταθεροί. Στο σημείο που οι κατσίκες γίνονται μίζερες, κυρίως λόγω του συναισθήματος, εξασθενούν αμέσως.","malay":"Mungkin berdasarkan fakta bahawa kambing pada dasarnya aman, mereka secara amnya mempunyai masalah perubatan yang kurang. Kehidupan mereka yang halus dapat menyelubungi realiti mereka biasanya sangat padat. Apabila mereka yakin, mereka sihat. Pada ketika Kambing menjadi sengsara, terutama kerana perasaan emosi, mereka segera menjadi lemah.","thai":"เพราะพื้นฐานเป็นคนที่จิตใจสงบ จึงช่วยให้คนเกิดปีมะแมไม่ค่อยมีปัญหาด้านสุขภาพมากนัก แม้พวกเขาจะดูอ่อนโยน แต่จริงๆแล้วคนเกิดปีมะแมเป็นคนที่เข้มแข็งมาก แต่บางครั้งพวกเขาก็รู้สึกอ่อนหล้ามากเช่นกันเมื่อต้องประสบกับเหตุการณ์ไม่ดี.","czech":"Možná ve světle skutečnosti, že kozy jsou v zásadě mírumilovné, budou mít obecně méně zdravotních problémů. Jejich delikátní vnějšek zahaluje realitu a obvykle jsou extrémně pevné. Když jsou pozitivní, jsou solidní. V okamžiku, kdy se kozy stanou nešťastnými, zejména kvůli sentimentu, okamžitě oslabnou.","bulgarian":"Може би в светлината на факта, че козите са фундаментално миролюбиви, като цяло те ще имат по-малко медицински проблеми. Деликатното им външно покритие реалността те обикновено са изключително солидни. Когато са оптимистични, те са твърди. В момента, в който Козите стават нещастни, особено заради чувствата, те незабавно стават изтощени.","norwegian":"Kanskje i lys av det faktum at geiter er grunnleggende fredelige, vil de generelt ha mindre medisinske problemer. Deres delikate utside skjuler den virkeligheten at de normalt er ekstremt solide. Når de er positive, er de solide. På det tidspunktet geiter blir elendige, spesielt på grunn av følelser, blir de øyeblikkelig svekkede.","denmark":"Måske i lyset af det faktum, at geder er grundlæggende fredelige, vil de generelt have færre medicinske problemer. Deres sarte udvendige hylster den virkelighed, at de normalt er ekstremt solide. Når de er optimistiske, er de solide. På det tidspunkt, hvor geder bliver elendige, især på grund af stemning, bliver de straks svækkede.","slovakia":"Možno vo svetle skutočnosti, že kozy sú v zásade mierumilovné, budú mať vo všeobecnosti menšie zdravotné problémy. Ich jemný zovňajšok zahaľuje realitu a sú zvyčajne mimoriadne pevné. Keď sú optimistické, sú solídne. V okamihu, keď sa kozy stanú nešťastnými, najmä kvôli sentimentu, okamžite sa oslabia."},"carrers":{"first_english":"Individuals conceived in a time of the Goat like to work in a group. Their best work accomplices are Horses. They are not made a fuss over status and power. Except if asked, they won't ever volunteer for anything and they go about as pioneers.","second_english":"Pediatrician, actor, daycare teacher, interior designer, florist, hair stylist, musician, editor, illustrator, and art history teacher.","first_arabic":"الأفراد الذين تم تصوّرهم في زمن الماعز يحبون العمل في مجموعة. أفضل شركاء العمل هم الخيول. فهي ليست ضجة حول الوضع والسلطة. إلا إذا طُلب منهم ذلك ، فلن يتطوعوا أبدًا لأي شيء وسيعملون كرائد.","second_arabic":"طبيب أطفال ، ممثل ، مدرس رعاية نهارية ، مصمم داخلي ، بائع زهور ، مصفف شعر ، موسيقي ، محرر ، رسام ، ومدرس تاريخ الفن.","first_greek":"Τα άτομα που σχεδιάστηκαν στην εποχή της κατσίκας επιθυμούν να δουλεύουν σε μια ομάδα. Οι καλύτεροι συνεργάτες τους είναι τα Άλογα. Δεν κάνουν φασαρία για την όποια κατάσταση και την εξουσία. Εκτός και εάν ερωτηθούν, δεν θα προσφερθούν ποτέ εθελοντικά και τίθενται ως πρωτοπόροι.","second_greek":"Παιδίατρος, ηθοποιός, δασκάλα, σχεδιαστής εσωτερικών χώρων, ανθοπώλης, κομμωτής, μουσικός, εκδότης, εικονογράφος και καθηγητής ιστορίας της τέχνης.","first_malay":"Individu yang dilahirkan dalam tahun Kambing suka bekerja dalam satu kumpulan. Rakan kerja terbaik mereka adalah Kuda. Mereka tidak membuat kekecohan terhadap status dan kuasa. Kecuali jika ditanya, mereka tidak akan sukarela untuk apa-apa dan mereka pergi sebagai perintis.","second_malay":"Pediatrik, pelakon, guru penjagaan kanak-kanak, pereka dalaman, tukang bunga, stylist rambut, ahli muzik, editor, ilustrator, dan guru sejarah seni.","first_thai":"คนเกิดปีมะแมชอบทำงานร่วมกับคนอื่น โดยเฉพาะกับคนที่เกิดปีมะเมีย พวกเขาไม่ใช่คนจู้จี้จุกจุกและจะไม่อาสาทำสิ่งใดๆ เมื่อไม่มีใครร้องขอ.","second_thai":"กุมารแพทย์ นักแสดง ครูรับเลี้ยงเด็ก นักออกแบบตกแต่งภายใน ช่างจัดดอกไม้ ช่างทำผม นักดนตรี บรรณาธิการ นักวาดภาพประกอบ และอาจารย์สอนประวัติศาสตร์ศิลปะ.","first_czech":"Jednotlivci počatí v době kozy rádi pracují ve skupině. Jejich nejlepšími spolupracovníky jsou Koně. Nedělají rozruch nad stavem a mocí. Pokud nebudou požádáni, nebudou se nikdy dobrovolně dobrovolně angažovat a budou jako průkopníci.","second_czech":"Pediatr, herec, učitel péče o děti, návrhář interiérů, květinář, kadeřník, hudebník, redaktor, ilustrátor a učitel dějin umění.","first_bulgarian":"Хората, заченати по времето на Козата, обичат да работят в група. Най-добрите им съучастници са Конете. Не им се вдига шум за статута и властта. Освен ако не бъдат помолени, те никога няма да се включат доброволно в нещо и се разхождат като пионери. ","second_bulgarian":" Педиатър, актьор, учител в детските градини, интериорен дизайнер, цветар, фризьор, музикант, редактор, илюстратор и учител по история на изкуството.","first_norwegian":"Individer som ble unnfanget i Geitens tid, liker å jobbe i en gruppe. Deres beste medarbeidere er hester. De blir ikke oppstyr over status og makt. Bortsett fra hvis de blir spurt, vil de aldri melde seg frivillig til noe, og de går som pionerer. ","second_norwegian":" Barnelege, skuespiller, barnehagelærer, interiørdesigner, blomsterhandler, frisør, musiker, redaktør, illustratør og kunsthistorielærer.","first_denmark":"Enkeltpersoner, der er undfanget i en tid af Geden, kan lide at arbejde i en gruppe. Deres bedste medarbejdere er heste. De gøres ikke ophidset over status og magt. Bortset fra hvis de bliver bedt om, vil de aldrig melde sig frivilligt til noget, og de går som pionerer.","second_denmark":"Børnelæge, skuespiller, dagplejelærer, indretningsarkitekt, blomsterhandler, frisør, musiker, redaktør, illustrator og kunsthistorielærer.","first_slovakia":"Jednotlivci počatí v čase kozy radi pracujú v skupine. Ich najlepšími spolupracovníkmi sú kone. Nerobí sa z nich rozruch nad postavením a mocou. Ak nebudú požiadaní, nikdy sa do ničoho neprihlásia a idú ako priekopníci.","second_slovakia":"Pediatr, herec, učiteľ starostlivosti o deti, interiérový dizajnér, kvetinárstvo, kaderník, hudobník, redaktor, ilustrátor a učiteľ dejín umenia."},"lucky":{"numbers":[2,7],"colors_english":["Brown","Purple","Red"],"directions_english":["North"],"colors_arabic":["بني","بنفسجي","أحمر"],"colors_greek":["Καφέ","Μωβ","Κόκκινο"],"directions_arabic":["شمال"],"directions_greek":["Βοράς"],"colors_malay":["Perang","Ungu","Merah"],"directions_malay":["Utara"],"colors_thai":["สีน้ำตาล","สีม่วง","สีแดง"],"directions_thai":["ทิศเหนือ"],"colors_czech":["Hnědý","Nachový","Červené"],"directions_czech":["Severní"],"colors_bulgarian":["Кафяво","Лилаво","червен"],"colors_norwegian":["brun","Lilla","rød"],"directions_bulgarian":["север"],"directions_norwegian":["Nord"],"colors_denmark":["Brun","Lilla","Rød"],"directions_denmark":["Nord"],"colors_slovakia":["Hnedá","Fialová","Červená"],"directions_slovakia":["Sever"]},"unlucky":{"numbers":[4,9],"colors_english":["Black","Blue"],"directions_english":["Southwest"],"colors_arabic":["اسود","ازرق"],"colors_greek":["Black","Μπλε"],"directions_arabic":["جنوب غربي"],"directions_greek":["Νοτιοδυτικά"],"colors_malay":["Hitam","Biru"],"directions_malay":["Barat daya"],"colors_thai":["Hitam","สีน้ำเงิน"],"directions_thai":["ทิศตะวันตกเฉียงใต้"],"colors_czech":["Černá","Modrý"],"directions_czech":["Jihozápadní"],"colors_bulgarian":["Черен","Син"],"colors_norwegian":["Svart","Blå"],"directions_bulgarian":["Югозапад"],"directions_norwegian":["Sørvest"],"colors_denmark":["Sort","Blå"],"directions_denmark":["Sydvest"],"colors_slovakia":["čierna","Modrá"],"directions_slovakia":["Juhozápad"]},"love":{"best_english":["Rabbit","Horse","Pig"],"worst_english":["Ox","Dragon","Snake","Dog"],"best_arabic":["ارنب","حصان","خنزير"],"worst_arabic":["ثعلب","تنين","الافعى","الكلب"],"best_greek":["Λαγός","Αλογο","Γουρούνι"],"worst_greek":["Βόδι","Δράκος","Φίδι","Σκύλος"],"best_malay":["Arnab","Kuda","Khinzir"],"worst_malay":["Lembu","Naga","Ular","Anjing"],"best_thai":["ปีเถาะ","ปีมะเมีย","ปีกุน"],"worst_thai":["ปีฉลู","ปีมะโรง","ปีมะเส็ง","ปีจอ"],"best_czech":["Králičí","Kůň","Prase"],"worst_czech":["Vůl","Drak","Had","Pes"],"best_bulgarian":["Заек","Кон","Прасе"],"best_norwegian":["Kanin","Hest","Gris"],"worst_bulgarian":["Вол","Дракон","Змия","Куче"],"worst_norwegian":["Okse","Drage","Slange","Hund"],"best_denmark":["Kanin","Hest","Svin"],"worst_denmark":["Okse","Trække på","Slange","Hund"],"best_slovakia":["Králik","Kôň","Prasa"],"worst_slovakia":["Vôl","drak","Had","pes"]},"years":[1907,1919,1931,1943,1955,1967,1979,1991,2003,2015,2027,2039],"unicode_symbol":"未"},{"sign_english":"Monkey","sign_arabic":"القرد","sign_greek":"Πίθηκος","sign_malay":"Monyet","sign_thai":"ปีวอก","sign_czech":"Opice","sign_bulgarian":"Маймуна","sign_norwegian":"Ape","sign_denmark":"Abe","sign_slovakia":"Opica","yin-yang":"Yang","direction":"West","season":"Early Autumn","element":"Metal","trine":"1st","personality":{"first_english":"Occupying the 9th position on the Chinese Zodiac, the Monkey possesses such character traits as curiosity, mischievousness, and cleverness. Forever playful, Monkeys are the masters of practical jokes. Even though their intentions are always good, this desire to be a prankster has a tendency to create ill will and hurt feelings.","second_english":"Although they are inherently intellectual and creative, Monkeys at times have trouble exhibiting these qualities. When that happens, they appear to others to be confused. But nothing could be further from the truth as Monkeys thrive on being challenged. Monkeys prefer urban life to rural, and their favorite pastime is people-watching.","first_arabic":"يحتل القرد المركز التاسع على البروج الصينية ، ويمتلك سمات شخصية مثل الفضول والخزي والذكاء. لعوب إلى الأبد ، القرود هي سادة النكات العملية. على الرغم من أن نواياهم جيدة دائمًا ، إلا أن هذه الرغبة في أن تكون مخادعًا تميل إلى خلق مشيئة وتؤذي المشاعر.","second_arabic":"على الرغم من أنها بطبيعتها فكرية وخلاقة ، إلا أن القردة تواجه في بعض الأحيان مشكلة في إظهار هذه الصفات. عندما يحدث ذلك ، يبدو للآخرين في حيرة من أمرهم. ولكن لا شيء يمكن أن يكون أبعد عن الحقيقة حيث تزدهر القرود في مواجهة التحديات. تفضل القرود الحياة الحضرية على الريف ، وهواياتهم المفضلة هي مراقبة الناس.","first_greek":"Καταλαμβάνοντας την ένατη θέση στο κινέζικο ωροσκόπιο, ο πίθηκος έχει τέτοια χαρακτηριστικά γνωρίσματα όπως η περιέργεια, η άτακτη συμπεριφορά και η νοημοσύνη. Πάντα παιχνιδιάρικοι, οι πίθηκοι είναι οι δάσκαλοι των πρακτικών αστείων. Παρόλο που οι προθέσεις τους είναι πάντα καλές, αυτή η επιθυμία να κάνουν φάρσες έχει την τάση να δημιουργεί κακή βούληση και να βλάπτει τα συναισθήματα.","second_greek":"Παρόλο που είναι εγγενώς πνευματικοί και δημιουργικοί, οι Πιθήκοι έχουν κατά καιρούς προβλήματα παρουσιάζοντας αυτές τις ιδιότητες. Όταν συμβαίνει αυτό, οδηγούν άλλους στο να μπερδεύονται. Αλλά τίποτα δεν θα μπορούσε να απέχει περισσότερο από την αλήθεια, καθώς οι Πιθήκοι αρέσκονται στο να τους αμφισβητητούν. Οι πίθηκοι προτιμούν την αστική ζωή από την ύπαιθρο και το αγαπημένο τους χόμπι είναι η παρακολούθηση των ανθρώπων.","first_malay":"Menduduki kedudukan ke-9 pada Zodiak Cina, Monyet mempunyai ciri-ciri sifat seperti rasa ingin tahu, kejiwaan, dan kepandaian. Jenis suka bermain selalu, Monyet adalah simbol bergurau. Walaupun niat mereka sentiasa baik, keinginan untuk menjadi penipu mempunyai kecenderungan untuk mencipta kehendak dan perasaan yang sakit.","second_malay":"Walaupun mereka memang bersifat intelektual dan kreatif, Monyet pada masa-masa mengalami masalah mempamerkan sifat-sifat ini. Apabila terjadi, mereka muncul kepada orang lain untuk mengelirukan. Tetapi tidak ada yang lebih jauh dari kebenaran apabila Monyet berkembang maju kerana dicabar. Monyet lebih suka kehidupan bandar ke luar bandar, dan hobi kegemaran mereka adalah menonton orang.","first_thai":"ปีวอกเป็นปีนักษัตรลำดับที่เก้าของตำราโหราศาสตร์จีน คนเกิดปีวอกเป็นคนอยากรู้อยากเห็น ซุกซน และฉลาดหลักแหลม นอกจากนี้พวกเขายังเป็นคนขี้เล่นและมีอารมณ์ขันอีกด้วย ด้วยความที่มีนิสียชอบแกล้งคนอื่นทำให้คนรอบข้างไม่ชอบพวกเขามากนัก.","second_thai":"แม้ว่าคนเกิดปีวอกจะเป็นคนฉลาดและมีความคิดสร้างสรรค์ แต่พวกเขาก็มักจะมีปัญหาในการนำทักษะเหล่านี้ออกมาใช้ในยามคับขัน นอกจากนี้คนเกิดปีวอกยังชอบความท้าทาย ชอบการใช้ชีวิตที่ไม่เร่งรีบ และชอบมองดูผู้คน.","first_czech":"Opice zaujímá 9. pozici na čínském zvěrokruhu a má takové povahové vlastnosti jako zvědavost, zlomyslnost a chytrost. Navždy hraví, opice jsou mistry praktických vtipů. I když jsou jejich úmysly vždy dobré, má tato touha být šprýmařem tendenci vytvářet špatnou vůli a zraňovat city.","second_czech":"I když jsou ze své podstaty intelektuální a kreativní, občas mají opice potíže s vykazováním těchto kvalit. Když k tomu dojde, zdá se ostatním zmatení. Ale nic nemohlo být dále od pravdy, protože Monkeys se daří čelit výzvám. Opice dávají přednost městskému životu před venkovským a jejich oblíbenou zábavou je sledování lidí.","first_bulgarian":" Заемайки 9-та позиция по китайския зодиак, маймуната притежава такива черти на характера като любопитство, палавост и умни умения. Завинаги игриви, маймуните са майстори на практически шеги. Въпреки че намеренията им винаги са добри, това желание да бъдат шегаджии има тенденцията да създава лоша воля и нараняващи чувства.","second_bulgarian":" Въпреки че по своята същност са интелектуални и креативни, понякога маймуните имат проблеми с проявяването на тези качества. Когато това се случи, те изглеждат объркани. Но нищо не може да бъде по-далеч от истината, тъй като маймуните процъфтяват, когато бъдат предизвикани. Маймуните предпочитат градския живот пред селския, а любимото им занимание е гледането на хора.","first_norwegian":" Monkey har den 9. posisjonen på den kinesiske dyrekretsen og har slike karaktertrekk som nysgjerrighet, ondskapsfullhet og kløkt. For alltid leken, er aper mestere i praktiske vitser. Selv om intensjonene deres alltid er gode, har dette ønsket om å være en skøyerhaver en tendens til å skape dårlig vilje og såre følelser.","second_norwegian":" Selv om de iboende er intellektuelle og kreative, har aper til tider problemer med å vise disse egenskapene. Når det skjer, ser de ut til å være forvirret for andre. Men ingenting kan være lengre fra sannheten da Apekatter trives med å bli utfordret. Aper foretrekker byliv fremfor landlige, og deres favoritt tidsfordriv er å se på mennesker.","first_denmark":"I besiddelse af den 9. position på den kinesiske stjernetegn har aben sådanne karaktertræk som nysgerrighed, ondskabsfuldhed og kløgtighed. Aber er altid legende og mestre i praktiske vittigheder. Selv om deres hensigter altid er gode, har dette ønske om at være en skørner en tendens til at skabe dårlig vilje og såre følelser.","second_denmark":"Selvom de iboende er intellektuelle og kreative, har aber til tider problemer med at udvise disse kvaliteter. Når det sker, ser de ud til at være forvirrede for andre. Men intet kunne være længere væk fra sandheden, da aber trives med at blive udfordret. Aber foretrækker byliv frem for landdistrikter, og deres foretrukne tidsfordriv er at se på mennesker.","first_slovakia":"Opica, ktorá zaujíma 9. pozíciu v čínskom zverokruhu, má také charakterové vlastnosti, ako je zvedavosť, zlomyseľnosť a chytrosť. Opice sú vždy hravé a sú majstrami praktických vtipov. Aj keď sú ich úmysly vždy dobré, táto túžba byť vtipkárom má tendenciu vytvárať zlú vôľu a zraňovať city.","second_slovakia":"Aj keď sú vo svojej podstate intelektuálni a kreatívni, niekedy majú problémy s prejavovaním týchto kvalít. Keď sa to stane, zdá sa ostatným zmätený. Ale nič nemohlo byť ďalej od pravdy, pretože Monkeys sa darí výzvam. Opice uprednostňujú mestský život pred vidieckym a ich obľúbenou zábavou je pozorovanie ľudí."},"health":{"english":"Accepting that being wiped out is a misuse of a significant day, Monkeys infrequently feel sick. Their continually dynamic ways of life are likely what enables Monkeys to stay healthy. At the point when Monkeys do turn out to be sick, such sentiments are commonly the consequence of inclination anxious.","arabic":"قبول أن تمحى هو سوء استخدام ليوم كبير ، والقرود تشعر عادة بالمرض. إن أساليب حياتهم الديناميكية المستمرة هي على الأرجح ما يُمكِّن القرود من البقاء بصحة جيدة. في المرحلة التي يتحول فيها القرود إلى حالة مرضية ، عادة ما تكون هذه المشاعر نتيجة للقلق الشديد.","greek":"Αποδεχόμενοι ότι το να μένουν αδρανείς είναι κακή χρήση μιας σημαντικής ημέρας, οι Πίθηκοι σπάνια αισθάνονται άρρωστοι. Ο συνεχώς δυναμικός τρόπος ζωής τους είναι πιθανόν αυτό που επιτρέπει στους πίθηκους να παραμείνουν υγιείς. Συναισθήματα όπως το άγχος, μπορεί να τους φτάσουν στο σημείο να νιώθουν άρρωστοι.","malay":"Menerima bahawa yang dihapuskan adalah disalahguna hari yang penting, monyet jarang merasa sakit. Cara hidup mereka yang dinamik mungkin menjadi salah satu cara mereka dapat hidup sihat. Bila Monyet menjadi sakit, perasaan menjadi sakit boleh menyebabkan kearah cemas.","thai":"บ่อยครั้งที่คนเกิดปีวอกรู้สึกไม่สบายกายและใจเพราะผลจากการชอบแกล้งคนอื่น แต่การใช้ชีวิตอย่างสดใสร่าเริงก็เป็นวิธีที่ช่วยเยียวยาจิตใจพวกเขา.","czech":"Přijetí toho, že je vyhlazeno, je zneužitím významného dne, opicím se zřídka cítí špatně. Jejich neustále dynamické způsoby života jsou pravděpodobně to, co umožňuje opicím zůstat zdravými. V okamžiku, kdy se opice ukáží jako nemocné, jsou tyto nálady obvykle důsledkem úzkosti.","bulgarian":"Приемайки, че унищожаването е злоупотреба със значителен ден, маймуните рядко се разболяват. Техният непрекъснато динамичен начин на живот е вероятно това, което позволява на маймуните да останат здрави. В момента, в който маймуните се оказват болни, подобни настроения обикновено са следствие от тревожност на склонността.","norwegian":"Aper aksepterer at det å bli utslettet er en misbruk av en betydelig dag, og ofte føler seg syk. Deres kontinuerlig dynamiske livsstil er sannsynligvis det som gjør at apekatter kan holde seg sunne. På det tidspunktet når apekatter viser seg å være syke, er slike følelser ofte en konsekvens av engstelig tilbøyelighet.","denmark":"At acceptere, at det at blive udslettet er et misbrug af en vigtig dag, føler sig aber sjældent syge. Deres konstant dynamiske livsformer er sandsynligvis det, der gør det muligt for aber at forblive sunde. På det tidspunkt, hvor aber viser sig at være syge, er sådanne følelser ofte en konsekvens af ængstelig tilbøjelighed.","slovakia":"Ak opice pripustia, že ich vyhladenie je zneužitím významného dňa, zriedka sa cítia choré. Pravdepodobne ich neustále dynamické spôsoby života umožňujú opiciam zostať zdravými. V okamihu, keď sa opice ukážu ako choré, sú tieto nálady zvyčajne dôsledkom úzkosti."},"carrers":{"first_english":"Monkeys buckle down in their professions. They can adjust well to various workplaces.","second_english":"Accounting and banking, science, engineering, stock market trading, air traffic control, film directing, jewelry, and sales. ","first_arabic":"القرود مشبك في مهنهم. يمكن أن تتكيف بشكل جيد مع أماكن العمل المختلفة.","second_arabic":"المحاسبة والمصارف والعلوم والهندسة وتداول سوق الأوراق المالية ومراقبة الحركة الجوية وتوجيه الأفلام والمجوهرات والمبيعات.","first_greek":"Οι πίθηκοι προοδεύουν στα επαγγέλματα τους. Μπορούν να προσαρμοστούν καλά σε διάφορους χώρους εργασίας.","second_greek":"Λογιστική και τραπεζική, επιστήμες, μηχανική, χρηματιστηριακή αγορά, έλεγχος εναέριας κυκλοφορίας, σκηνοθεσία ταινιών, κοσμήματα και πωλήσεις.","first_malay":"Monyet menumpukan sepenuh perhatian terhadap kerjaya mereka.Mereka boleh menyesuaikan diri dengan baik di tempat kerja.","second_malay":"Perakaunan dan perbankan, sains, kejuruteraan, perdagangan pasaran saham, kawalan lalu lintas udara, pengarah filem,penjual barangan kemas dan jualan.","first_thai":"คนเกิดปีวอกเป็นคนทุ่มเทให้กับการทำงาน และปรับตัวเข้ากับเพื่อนร่วมงานได้ง่าย.","second_thai":"การบัญชีและการธนาคาร วิทยาศาสตร์ วิศวกรรม การซื้อขายในตลาดหุ้น การควบคุมการจราจรทางอากาศ กำกับภาพยนตร์ อัญมณี และการขาย.","first_czech":"Opice se ve svých profesích spoutaly. Mohou se dobře přizpůsobit různým pracovištím.","second_czech":"Účetnictví a bankovnictví, věda, strojírenství, obchodování na akciových trzích, řízení letového provozu, filmová režie, klenoty a prodej. ","first_bulgarian":" Маймуните се закопчават в професиите си. Те могат да се адаптират добре към различни работни места.","second_bulgarian":" Счетоводство и банково дело, наука, инженеринг, търговия на фондови борси, контрол на въздушното движение, режисура на филми, бижута и продажби.","first_norwegian":" Aper spenner seg ned i yrkene sine. De kan tilpasse seg godt til forskjellige arbeidsplasser.","second_norwegian":" Regnskap og bank, vitenskap, ingeniørarbeid, aksjemarkedshandel, flytrafikkontroll, filmregissering, smykker og salg.","first_denmark":"Aber spænder ned i deres erhverv. De kan tilpasse sig godt til forskellige arbejdspladser.","second_denmark":"Regnskab og bank, videnskab, teknik, handel på aktiemarkeder, lufttrafikstyring, filmregissering, smykker og salg.","first_slovakia":"Opice sa pripútali k svojim profesiám. Vedia sa dobre prispôsobiť rôznym pracoviskám.","second_slovakia":"Účtovníctvo a bankovníctvo, veda, strojárstvo, obchodovanie na trhoch s akciami, riadenie letovej prevádzky, filmová réžia, klenoty a predaj."},"lucky":{"numbers":[4,9],"colors_english":["Blue","Gold","White"],"directions_english":["North","Northwest","West"],"colors_arabic":["ازرق","ذهبي","ابيض"],"colors_greek":["Μπλε","Χρυσό","Λευκο"],"directions_arabic":["شمال","شمال غربي","غرب"],"directions_greek":["Βοράς","Βορειοδυτικά","West"],"colors_malay":["Biru","Emas","Putih"],"directions_malay":["Utara","Barat laut","Barat"],"colors_thai":["สีน้ำเงิน","สีทอง","สีขาว"],"directions_thai":["ทิศเหนือ","ทิศตะวันตกเฉียงเหนือ","ทิศตะวันตก"],"colors_czech":["Modrý","Zlato","Bílý"],"directions_czech":["Severní","Severozápad","Západ"],"colors_bulgarian":["Син","Злато","Бял"],"colors_norwegian":["Blå","Gull","Hvit"],"directions_bulgarian":["север","Северозападна","Югозапад"],"directions_norwegian":["Nord","Nordvest","Sørvest"],"colors_denmark":["Blå","Guld","hvid"],"directions_denmark":["Nord","Nord Vest","Vest"],"colors_slovakia":["Modrá","Zlato","biely"],"directions_slovakia":["Sever","Severozápad","Západ"]},"unlucky":{"numbers":[2,7],"colors_english":["Red","Pink"],"directions_english":["South","Southeast"],"colors_arabic":["أحمر","وردي"],"colors_greek":["Κόκκινο","Ροζ"],"directions_arabic":["جنوب","جنوب شرقي"],"directions_greek":["Νότια","Νοτιοανατολικά"],"colors_malay":["Merah","Merah Jambu"],"directions_malay":["Selatan","Tenggara"],"colors_thai":["สีแดง","สีชมพู"],"directions_thai":["ทิศใต้","ทิศตะวันออกเฉียงใต้"],"colors_czech":["Červené","Růžový"],"directions_czech":["Jižní","Jihovýchodní"],"colors_bulgarian":["червен","Розов"],"colors_norwegian":["rød","Rosa"],"directions_bulgarian":["На юг","Югоизток"],"directions_norwegian":["Sør","Sørøst"],"colors_denmark":["Rød","Lyserød"],"directions_denmark":["Syd","Sydøst"],"colors_slovakia":["červená","Ružová"],"directions_slovakia":["Juh","Juhovýchod"]},"love":{"best_english":["Ox","Rabbit"],"worst_english":["Tiger","Pig"],"best_arabic":["ثعلب","ارنب"],"worst_arabic":["نمر","خنزير"],"best_greek":["Βόδι","Λαγός"],"worst_greek":["Τίγρη","Γουρούνι"],"best_malay":["Lembu","Arnab"],"worst_malay":["Harimau","Khinzir"],"best_thai":["ปีฉลู","ปีเถาะ"],"worst_thai":["ปีขาล","ปีกุน"],"best_czech":["Vůl","Králičí"],"worst_czech":["Tygr","Prase"],"best_bulgarian":["Вол","Заек"],"best_norwegian":["Okse","Kanin"],"worst_bulgarian":["тигър","Прасе"],"worst_norwegian":["Tiger","Gris"],"best_denmark":["Okse","Kanin"],"worst_denmark":["Tiger","Svin"],"best_slovakia":["Vôl","Králik"],"worst_slovakia":["Tiger","Prasa"]},"years":[1908,1920,1932,1944,1956,1968,1980,1992,2004,2016,2028,2040],"unicode_symbol":"申"},{"sign_english":"Rooster","sign_arabic":"ديك","sign_greek":"Κόκορας","sign_malay":"Ayam","sign_thai":"ปีระกา","sign_czech":"Kohout","sign_bulgarian":"Петел","sign_norwegian":"Hane","sign_denmark":"Hane","sign_slovakia":"Kohút","yin-yang":"Yin","direction":"West","season":"Mid-Autumn","element":"Metal","trine":"2nd","personality":{"first_english":"Involving the tenth situation in the Chinese Zodiac, the Rooster symbolizes such character qualities as certainty, affectedness and inspiration. Those brought into the world under the Chinese Zodiac indication of the Rooster are steadfast, reliable people who are gruff with regards to offering their suppositions. Their obtuseness stems not from being mean yet from being straightforward; a characteristic which Roosters anticipate from others.","second_english":"Chickens are amazingly friendly and favor being simply the focal point of consideration, continually gloating about themselves and their achievements. They consistently look for the immovable consideration of others which can be irritating. Chickens are as glad for their homes as they are of themselves. They're very sorted out people as prove by the way that their homes are constantly flawless.","first_arabic":"إشراك الوضع العاشر في البروج الصينية ، يرمز الديك إلى صفات الشخصية مثل اليقين والتأثير والإلهام. أولئك الذين تم إحضارهم إلى العالم تحت إشارات البروج الصينية من الديك هم أشخاص صامدون وموثوقون يتسمون بالخداع فيما يتعلق بتقديم افتراضاتهم. براعتهم لا تنبع من كونها تعني من كونها واضحة ؛ سمة التي يتوقعها الديوك من الآخرين.","second_arabic":"الدجاج ودود بشكل مثير للدهشة ويفضل أن يكون ببساطة نقطة محورية في الاعتبار ، ويتشمر باستمرار عن أنفسهم وإنجازاتهم. إنهم يبحثون باستمرار عن الاعتبارات غير المنقولة للآخرين التي يمكن أن تكون مزعجة. الدجاج سعيد لبيوتهم كما هم في أنفسهم. لقد تم فرز الأشخاص بشكل كبير كما يثبت بالمناسبة أن منازلهم لا تشوبها شائبة باستمرار.","first_greek":"Καταλαμβάνοντας τη 10η θέση στο κινέζικο ωροσκόπιο, ο Κόκορας συμβολίζει τέτοιες ιδιότητες χαρακτήρα όπως η βεβαιότητα, η ανθεκτικότητα και η έμπνευση. Εκείνοι που έρχονται στον κόσμο κάτω από την κινεζική Ζωδιακή ένδειξη του Κόκορα είναι σταθεροί, αξιόπιστοι άνθρωποι που δεν μοιράζονται τα προβλήματά τους. Η στάση ζωής τους δεν προκύπτει από το να είναι σκληροί αλλά ανοικτόμυαλοι. Ένα χαρακτηριστικό που οι κόκορες αναμένουν και από τους άλλους.","second_greek":"Οι κόκορες είναι απίστευτα φιλικοί και αποζητούν να είναι συνεχώς στο επίκεντρο της προσοχής, μιλώντας συνεχώς για τον εαυτό τους και τα επιτεύγματά τους. Αναζητούν σταθερά την άποψη των άλλων, σε βαθμό που μπορεί να είναι ενοχλητικός. Οι κόκορες είναι ευχαριστημένοι για τα σπίτια τους καθώς και για τους εαυτούς τους. Είναι πολύ διευθετημένοι άνθρωποι, όπως φαίνεται από τα σπίτια τους που είναι είναι πάντα άψογα.","first_malay":"Melibatkan tempat kesepuluh di Zodiak Cina, Ayam melambangkan sifat watak seperti kepastian, pengaruhi dan inspirasi. Mereka yang dilahir pada tahun Zodiak Cina Ayam adalah orang yang teguh, dipercayai dan bersemangat menurut anggapan mereka. Mereka tidak mahu memahami dari menjadi lebih mudah; ciri Ayam jenis yang suka menjangkakan dari orang lain","second_malay":"Ayam amat mesra dan menjadi tumpuan utama, sentiasa merenung tentang diri mereka dan pencapaian mereka. Mereka secara konsisten mencari pertimbangan yang tidak dapat dilakukan orang lain yang boleh menjengkelkan. Ayam berasa gembira untuk rumah mereka kerana mereka anggap rumah itu seperti diri mereka sendiri. Mereka sangat penyusun orangnya sebagai bukti dengan keadaan rumah mereka sentiasa sempurna dan tersusun.","first_thai":"ปีระกาเป็นปีนักษัตรลำดับที่สิบของตำราโหราศาสตร์จีน คนเกิดปีระกาเป็นคนหนักแน่น เป็นห่วงเป็นใยผู้อื่น และเป็นคนที่มีแรงบันดาลใจในการใช้ชีวิต นอกจากนี้ยังเป็นคนไว้เนื้อเชื่อใจได้และเป็นคนตรงไปตรงมา จนบางครั้งถูกมองว่าเป็นคนหยาบคาย.","second_thai":"คนเกิดปีระกามีความเป็นมิตรและขี้เกรงใจ ซึ่งบ่อยครั้งคนรอบตัวก็รำคาญความขี้เกรงใจของพวกเขา คนเกิดปีระกาชอบอยู่บ้านและชอบจัดบ้านให้เป็นระเบียบและสวยงามน่าอยู่.","first_czech":"Zahrnutím desáté situace v čínském zvěrokruhu kohout symbolizuje takové charakterové vlastnosti jako jistotu, afektivitu a inspiraci. Ti, kteří byli přivedeni na svět pod čínským zvěrokruhovým znamením kohouta, jsou vytrvalí a spolehliví lidé, kteří jsou drsní, pokud jde o nabízení svých předpokladů. Jejich tupost nevyplývá z toho, že jsou zlí, ale z toho, že jsou přímočarí; charakteristika, kterou kohouti očekávají od ostatních.","second_czech":"Kuřata jsou neuvěřitelně přátelská a upřednostňují to, že jsou prostě ústředním bodem úvahy, neustále se nadávají o sobě a svých úspěších. Důsledně hledají nehybnou úvahu ostatních, která může být dráždivá. Kuřata jsou ze svých domovů stejně šťastná jako ze sebe samých. Jsou velmi roztříděni, jak dokazují, že jejich domovy jsou neustále bezchybné.","first_bulgarian":" Включвайки десетата ситуация в китайския Зодиак, Петелът символизира такива качества на характера като сигурност, засегнатост и вдъхновение. Тези, донесени на света под китайския зодиакален знак на Петела, са непоклатими, надеждни хора, които са груби по отношение на предлагането на своите предположения. Тъпотата им не произтича от лошостта, а от това, че са прями; характеристика, която Петлите очакват от другите.","second_bulgarian":" Пилетата са невероятно приятелски настроени и предпочитат да бъдат просто фокусна точка на разглеждане, непрекъснато се радват на себе си и своите постижения. Те постоянно търсят неподвижното съображение на другите, което може да бъде дразнещо. Пилетата се радват на домовете си, както и на себе си. Те са много подредени хора, което доказва между другото, че домовете им са постоянно безупречни.","first_norwegian":" Ved å involvere den tiende situasjonen i den kinesiske dyrekretsen, symboliserer hanen slike karakteregenskaper som sikkerhet, påvirkning og inspirasjon. De som blir brakt til verden under den kinesiske dyrekretsen som indikerer Hanen, er standhaftige, pålitelige mennesker som er dystre med hensyn til å tilby sine antagelser. Deres stivhet stammer ikke fra å være ond ennå fra å være rettferdig; en egenskap som haner forventer fra andre.","second_norwegian":" Kyllinger er utrolig vennlige og favoriserer å være rett og slett fokuspunktet, og fortsetter å glede seg over seg selv og sine prestasjoner. De ser kontinuerlig etter andres urokkelige hensyn som kan være irriterende. Kyllinger er like glade for hjemmene som de er for seg selv. De er veldig sorterte ut som bevis for øvrig at hjemmene deres hele tiden er feilfrie.","first_denmark":"Ved at involvere den tiende situation i den kinesiske stjernetegn symboliserer hanen sådanne karakteregenskaber som sikkerhed, påvirkning og inspiration. De, der bringes til verden under den kinesiske stjernetegn på hanen, er standhaftige, pålidelige mennesker, der er dystre med hensyn til at tilbyde deres antagelser. Deres stivhed stammer ikke fra at være ondt endnu fra at være ligetil; et kendetegn, som haner forventer af andre.","second_denmark":"Kyllinger er utroligt venlige og foretrækker at være simpelthen omdrejningspunktet for overvejelse og konstant gløder over sig selv og deres præstationer. De ser konsekvent efter andres faste hensyn, der kan være irriterende. Kyllinger er lige så glade for deres hjem som de er for sig selv. De er meget sorterede mennesker, hvilket bevises forresten, at deres hjem konstant er fejlfri.","first_slovakia":"Zahrnutím desiatej situácie v čínskom zverokruhu kohút symbolizuje také charakterové vlastnosti ako istota, afektivita a inšpirácia. Ľudia privedení na svet pod čínskym znamením kohúta sú vytrvalí a spoľahliví ľudia, ktorí sú drsní, pokiaľ ide o ponúkanie ich predpokladov. Ich tuposť pramení ešte nie z toho, že sú zlí, ale z toho, že sú priami; charakteristika, ktorú kohúti očakávajú od ostatných.","second_slovakia":"Kurčatá sú neuveriteľne priateľské a uprednostňujú to, že sú jednoducho ústredným bodom úvahy a neustále sa tešia zo seba a svojich úspechov. Dôsledne hľadajú nepohyblivé ohľady na ostatných, ktoré môžu byť dráždivé. Kurčatá sú rovnako šťastné za svoje domovy ako samy zo seba. Sú veľmi roztriedení, čo dokazuje aj to, že ich domovy sú neustále bezchybné."},"health":{"english":"Generally speaking, Roosters are dynamic people and their inclination to be dynamic helps keep them healthy. When they do turn out to be sick, they feel better rapidly. They can on occasion in any case, take on something over the top and when that occurs, they'll feel pushed and grumpy.","arabic":"بشكل عام ، فإن الديوك هم أشخاص ديناميكيون وميلهم إلى أن يكون ديناميكيًا يساعد في الحفاظ على صحتهم. عندما يتحول الأمر إلى مرض ، يشعرون بتحسن سريع. يمكنهم في بعض الأحيان على أي حال ، أن يأخذوا شيئًا ما فوق القمة وعندما يحدث ذلك ، سيشعرون بالضيق والغضب.","greek":"Σε γενικές γραμμές, οι κόκορες είναι δυναμικοί άνθρωποι και η τάση τους αυτή τους βοηθάει να μένουν υγιείς. Όταν αρρωστήσουν, γίνονται καλύτερα γρήγορα. Μπορούν σε κάθε περίπτωση, να ωθήσουν τις καταστάσεις πέρα από τα όρια και όταν αυτό συμβεί, αισθάνονται αδικημένοι και γκρινιάρηδες.","malay":"Secara umumnya, Ayam adalah orang yang dinamik dan kecenderungan mereka untuk dinamik membantu menjaga kesihatan mereka. Apabila mereka menjadi sakit, mereka berasa lebih cepat sihat.Apabila mereka mengambil atau berada di atas dan apabila mereka jatuh mereka akan berasa tertekan dan marah.","thai":"คนเกิดปีระกาเป็นคนเป็นคนสดใสร่าเริงและกระฉับกระเฉง ซึ่งช่วยให้พวกเขามีสุขภาพแข็งแรง และในเวลาเจ็บไข้ได้ป่วย พวกเขาก็ฟื้นตัวและหายเป็นปกติได้เร็ว แต่บางครั้งพวกเขาก็รู้สึกเศร้าเมื่อเจอปัญหาที่ยากเกินจะรับมือ.","czech":"Obecně řečeno, kohouti jsou dynamičtí lidé a jejich sklon k dynamice jim pomáhá udržovat zdraví. Když se ukáže, že jsou nemocní, rychle se cítí lépe. Mohou příležitostně v každém případě něco převzít a jakmile k tomu dojde, budou se cítit tlačeni a nevrlí.","bulgarian":"Най-общо казано, петлите са динамични хора и склонността им да бъдат динамични им помага да ги поддържат здрави. Когато се окажат болни, те се чувстват бързо по-добре. Във всеки случай те могат да поемат нещо отгоре и когато това се случи, ще се почувстват избутани и мрънкащи.","norwegian":"Generelt sett er haner dynamiske mennesker, og deres tilbøyelighet til å være dynamisk bidrar til å holde dem sunne. Når de viser seg å være syke, føler de seg raskt bedre. De kan noen ganger i alle fall ta på seg noe over toppen, og når det skjer, vil de føle seg presset og gretten.","denmark":"Generelt er haner dynamiske mennesker, og deres tilbøjelighed til at være dynamisk hjælper med at holde dem sunde. Når de viser sig at være syge, føler de sig hurtigt bedre. De kan under alle omstændigheder under alle omstændigheder påtage sig noget over toppen, og når det sker, vil de føle sig skubbet og grumpy.","slovakia":"Všeobecne možno povedať, že kohúti sú dynamickí ľudia a ich sklon k dynamike pomáha udržiavať ich zdravé. Keď sa ukáže, že sú chorí, rýchlo sa cítia lepšie. V každom prípade môžu občas niečo prevziať a keď k tomu dôjde, budú sa cítiť tlačené a nevrlé."},"carrers":{"first_english":"Roosters are more inspired than different creatures in the Chinese zodiac, making their vocations a need in their lives. Roosters are dedicated, multi-capable, and can manage an assortment of occupations.","second_english":"News broadcaster, sales person, restaurant owner, hairdresser, public relations officer, farmer, athlete, teacher, waiter, journalist, travel writer, dentist, surgeon, soldier, fireman, security guard, and police officer.","first_arabic":"الديكة أكثر إلهامًا من المخلوقات المختلفة في البروج الصينية ، مما يجعل مهنهم ضرورية في حياتهم. الديكة مكرسة ، متعددة القدرات ، ويمكن إدارة مجموعة متنوعة من المهن.","second_arabic":"مذيع الأخبار ، مندوب مبيعات ، صاحب مطعم ، مصفف شعر ، مسؤول علاقات عامة ، مزارع ، رياضي ، معلم ، نادل ، صحفي ، كاتب سفر ، طبيب أسنان ، جراح ، جندي ، رجل إطفاء ، حارس أمن ، وضابط شرطة.","first_greek":"Οι κόκορες είναι πιο εμπνευσμένοι από τα υπόλοιπα πλάσματα του κινεζικού ζωδιακού κύκλου, καθιστώντας τα επαγγέλματα τους μια ανάγκη στη ζωή τους. Οι κόκορες είναι αφοσιωμένοι, πολλαπλά ικανοί και μπορούν να διαχειριστούν μια ποικιλία επαγγελμάτων.","second_greek":"Ραδιοτηλεοπτικός παραγωγός, πωλητής, ιδιοκτήτης εστιατορίου, κομμωτήριο, υπεύθυνος δημοσίων σχέσεων, αγρότης, αθλητής, δάσκαλος, σερβιτόρος, δημοσιογράφος, ταξιδιωτικός συγγραφέας, οδοντίατρος, χειρούργος, στρατιώτης, πυροσβέστης, φύλακας ασφαλείας και αστυνομικός.","first_malay":"Ayam lebih memberi inspirasi daripada makhluk yang berlainan dalam zodiak Cina, membuat panggilan mereka keperluan dalam kehidupan mereka. Ayam berdedikasi, pelbagai fungsi, dan boleh menguruskan pelbagai jenis pekerjaan.","second_malay":"Wartawan berita, orang jualan, pemilik restoran, penandan rambut, pegawai perhubungan awam, petani, atlet, guru, pelayan, wartawan, penulis perjalanan, doktor gigi, pakar bedah, askar, bomba, pengawal keselamatan, dan pegawai polis.","first_thai":"คนเกิดปีระกาเป็นคนมีแรงบันดาลใจ และชอบการเดินทางท่องเที่ยว พวกเขาเป็นคนทุ่มเทให้กับการทำงานและมีความรอบรู้จึงสามารถทำงานได้หลายด้าน.","second_thai":"ผู้ประกาศข่าว พนักงานขาย เจ้าของร้านอาหาร ช่างทำผม เจ้าหน้าที่ประชาสัมพันธ์ ชาวนา นักกีฬา ครู บริกร นักข่าว นักเขียนเรื่องท่องเที่ยว ทันตแพทย์ ศัลยแพทย์ ทหาร เจ้าหน้าที่ดับเพลิง เจ้าหน้าที่รักษาความปลอดภัย และเจ้าหน้าที่ตำรวจ.","first_czech":"Kohouti jsou více inspirováni než různí tvorové v čínském zvěrokruhu, takže jejich povolání jsou v jejich životech potřebou. Kohouti jsou oddaní, mají více schopností a mohou spravovat sortiment povolání.","second_czech":"Vysílatel zpráv, pracovník prodeje, majitel restaurace, kadeřník, pracovník pro styk s veřejností, zemědělec, sportovec, učitel, číšník, novinář, spisovatel cestování, zubař, chirurg, voják, hasič, ostraha a policista.","first_bulgarian":" Петлите са по-вдъхновени от различните същества от китайския зодиак, което прави техните призвания необходимост в живота им. Петлите са специализирани, многофункционални и могат да управляват асортимент от професии.","second_bulgarian":" Новинар, продавач, собственик на ресторант, фризьор, служител за връзки с обществеността, фермер, спортист, учител, сервитьор, журналист, пътешественик, зъболекар, хирург, войник, пожарникар, охрана и полицай.","first_norwegian":"Haner er mer inspirert enn forskjellige skapninger i den kinesiske dyrekretsen, noe som gjør deres kall et behov i livet. Haner er dedikerte, multi-kompatible og kan håndtere et utvalg av yrker. ","second_norwegian":" Nyhetssending, selger, restaurant eier, frisør, PR, bonde, idrettsutøver, lærer, kelner, journalist, reiseskribent, tannlege, kirurg, soldat, brannmann, sikkerhetsvakt og politibetjent.","first_denmark":"Haner er mere inspirerede end forskellige væsner i den kinesiske stjernetegn, hvilket gør deres kald et behov i deres liv. Haner er dedikerede, multi-kompatible og kan styre et udvalg af erhverv.","second_denmark":"Nyhedsudsender, salgsperson, restaurantejer, frisør, PR, landmand, atlet, lærer, tjener, journalist, rejseskribent, tandlæge, kirurg, soldat, brandmand, sikkerhedsvagt og politibetjent.","first_slovakia":"Kohúti sú viac inšpirovaní ako rôzne tvory v čínskom zverokruhu, takže ich povolania sú pre ich život nevyhnutnosťou. Kohúti sú oddaní, majú viac schopností a dokážu riadiť sortiment povolaní.","second_slovakia":"Vysielateľ spravodajstva, predajca, majiteľ reštaurácie, kaderníctvo, pracovník styku s verejnosťou, poľnohospodár, športovec, učiteľ, čašník, novinár, spisovateľ cestovania, zubár, chirurg, vojak, hasič, ochrankár a policajt."},"lucky":{"numbers":[5,7,8],"colors_english":["Brown","Gold","Yellow"],"directions_english":["South","Southeast"],"colors_arabic":["بني","ذهبي","اصفر"],"colors_greek":["Καφέ","Χρυσό","Κίτρινο"],"directions_arabic":["جنوب","جنوب شرقي"],"directions_greek":["Νότια","Νοτιοανατολικά"],"colors_malay":["Perang","Emas","Kuning"],"directions_malay":["Selatan","Tenggara"],"colors_thai":["สีน้ำตาล","สีทอง","สีเหลือง"],"directions_thai":["ทิศใต้","ทิศตะวันออกเฉียงใต้"],"colors_czech":["Hnědý","Zlato","Žlutá"],"directions_czech":["Jižní","Jihovýchodní"],"colors_bulgarian":["Кафяво","Злато","Жълто"],"colors_norwegian":["brun","Gold","Gul"],"directions_bulgarian":["На юг","Югозапад"],"directions_norwegian":["Sør","Sørvest"],"colors_denmark":["Brun","Guld","Gul"],"directions_denmark":["Syd","Sydøst"],"colors_slovakia":["Hnedá","Zlato","žltá"],"directions_slovakia":["Juh","Juhovýchod"]},"unlucky":{"numbers":[1,3,9],"colors_english":["Red"],"directions_english":["East"],"colors_arabic":["أحمر"],"colors_greek":["Κόκκινο"],"directions_arabic":["شرق"],"directions_greek":["Ανατολή"],"colors_malay":["Merah"],"directions_malay":["Timur"],"colors_thai":["สีแดง"],"directions_thai":["ทิศตะวันออก"],"colors_czech":["Červené"],"directions_czech":["Východní"],"colors_bulgarian":["червен"],"colors_norwegian":["rød"],"directions_bulgarian":["изток"],"directions_norwegian":["Øst"],"colors_denmark":["Rød"],"directions_denmark":["Sydøst"],"colors_slovakia":["Červená"],"directions_slovakia":["Juhovýchod"]},"love":{"best_english":["Ox","Snake"],"worst_english":["Rat","Rabbit","Horse","Pig"],"best_arabic":["ثعلب","الافعى"],"worst_arabic":["الفأر","ارنب","حصان","خنزير"],"best_greek":["Βόδι","Φίδι"],"worst_greek":["Αρουραίος","Λαγός","Αλογο","Γουρούνι"],"best_malay":["Lembu","Ular"],"worst_malay":["Tikus","Arnab","Kuda","Khinzir"],"best_thai":["ปีฉลู","ปีมะเส็ง"],"worst_thai":["ปีชวด","ปีเถาะ","ปีมะเมีย","ปีกุน"],"best_czech":["Vůl","Had"],"worst_czech":["Krysa","Králičí","Kůň","Prase"],"best_bulgarian":["Вол","Змия"],"best_norwegian":["Okse","Slange"],"worst_bulgarian":["Плъх","Заек","Кон","Прасе"],"worst_norwegian":["Rotte","Kanin","Hest","Gris"],"best_denmark":["Okse","Slange"],"worst_denmark":["Rotte","Kanin","Hest","Svin"],"best_slovakia":["Vôl","Had"],"worst_slovakia":["Potkan","Králik","Kôň","Prasa"]},"years":[1909,1921,1933,1945,1957,1969,1981,1993,2005,2017,2029,2041],"unicode_symbol":"酉"},{"sign_english":"Dog","sign_arabic":"الكلب","sign_greek":"Σκύλος","sign_malay":"Anjing","sign_thai":"ปีจอ","sign_czech":"Pes","sign_bulgarian":"Куче","sign_norwegian":"Hund","sign_denmark":"Hund","sign_slovakia":"pes","yin-yang":"Yang","direction":"West","season":"Late Autumn","element":"Earth","trine":"3rd","personality":{"first_english":"Involving the eleventh situation in the Chinese Zodiac, the Dog symbolizes character attributes, for example, dedication, similarity and graciousness. Mutts much of the time offer kind words and valuable counsel, continually tuning in and loaning a shoulder when important. Mutts frequently become profoundly engaged with others' lives and are now and then seen as meddling. Guaranteeing others are cheerful is more critical to the Dog than riches, cash or achievement. Canines are resolved people; continually needing to ace another subject before proceeding onward and continually completing what they start. Canines esteem companionships; they're steadfast, genuine, dependable and solid and have solid ethics and morals.","second_english":"A well-kept, sorted out home is significant. Keeping a perfect home and aiding at work stems from the Dog's should be dynamic and included. Pooches burn through cash carefully, passing on extravagance merchandise for reasonable things. Pooches additionally incline toward setting aside cash to cover future costs. Pooches now and again can likewise be touchy, extremist and difficult. At the point when this occurs, the Dog takes off alone so as to make things right again inside its head. Mutts can profit by figuring out how to unwind and being progressively discerning.","first_arabic":"إشراك الموقف الحادي عشر في البروج الصينية ، يرمز الكلب إلى سمات الشخصية ، على سبيل المثال ، التفاني والتشابه والكرم. يغير الكثير من الوقت كلمات لطيفة ونصائح قيمة ، ويضبط باستمرار ويعرّف كتفًا عند أهميته. غثيانًا ما يتورط الأطفال بشكل كبير في حياة الآخرين ويُنظر إليهم الآن وبعد ذلك على أنهم تدخّلون. إن ضمان فرحة الآخرين أمر بالغ الأهمية للكلب أكثر من الثراء أو النقد أو الإنجاز. الأنياب هي حل الناس. تحتاج باستمرار إلى موضوع آخر قبل المتابعة فصاعدًا واستكمال ما يبدأون به باستمرار. الأنياب احترام الرفقة. إنها صامدة وحقيقية ويمكن الاعتماد عليها وقوية ولديها أخلاق وأخلاق متينة.","second_arabic":"يعد المنزل الذي تم الاحتفاظ به جيدًا أمرًا مهمًا. يجب أن تكون المحافظة على منزل مثالي ومساعدة في العمل تنبع من الكلب ديناميكية ومضمنة. تحترق الصناديق من خلال النقود بعناية ، لتمرير البضائع المترفة للأشياء المعقولة. يميل بوخس بالإضافة إلى ذلك نحو تخصيص النقد لتغطية التكاليف المستقبلية. يمكن أن تكون البراش الآن مرارًا وتكرارًا صعبة ومتطرفة. عند حدوث ذلك ، ينطلق الكلب بمفرده لجعل الأمور في نصابها الصحيح داخل رأسه. يمكن للربح الربح من خلال معرفة كيفية الاسترخاء والتمييز التدريجي.","first_greek":"Καταλαμβάνοντας την εντέκατη θέση στο κινέζικο ωροσκόπιο ο σκύλος συμβολίζει ιδιότητες του χαρακτήρα όπως η αφοσίωση, η ομοιότητα και η ευγένεια. Οι σκύλοι για μεγάλο μέρος του χρόνου προσφέρουν καλλα λόγια και πολύτιμες συμβουλές, συντονισμένοι συνεχώς με τα προβλήματα των άλλων και βοηθώντας τους στα δύσκολα. Οι σκύλοι συχνά γίνονται βαθιά αφοσιωμένοι με τη ζωή των άλλων, σε βαθμό ενίοτε παρεμβατικό. Το να φροντίζουν οι άλλοι να είναι χαρούμενοι είναι πιο σημαντικό για τους σκύλους από τα πλούτη, τα μετρητά ή κάποιο επίτευγμα. Στους σκύλους αρέσει η αλλαγή και το να τελειώνουν ο,τι αρχίζουν. Κυνήγούν τη συντροφιά, είναι σταθεροί, γνήσιοι, αξιόπιστοι και σταθεροί και έχουν έντονα ανεπτυγμένη την ηθική.","second_greek":"Ένα καλά διατηρημένο, διευθετημένο σπίτι είναι σημαντικό. Κρατώντας ένα τέλειο σπίτι και βοηθώντας στην εργασία είναι κάτι που γεμίζει ένα σκύλο. Ο σκύλος διαχειρίζεται τα μετρητά με προσοχή, αδιαφορώντας για τα ακριβά πράγμα και εστιάζοντας στα σημαντικά. Ο σκύλος προσανατολίζεται επιπλέον προς την αποταμίευση, για την κάλυψη των μελλοντικών δαπανών. Ο σκύλος, ξανά και ξανά, μπορεί να είναι ευαίσθητος, εξτρεμιστικός και δύσκολος. Στο σημείο που συμβαίνει αυτό, ασχολείται μόνος του για να κάνει τα πράγματα σωστά και πάλι μέσα στο κεφάλι του. Οι σκύλοι μπορούν να επωφεληθούν από την εξεύρεση τρόπων για να χαλαρώσουν και να είναι προοδευτικά διακριτικοί.","first_malay":"Melibatkan kedudukan kesebelas dalam Zodiak Cina, Anjing melambangkan ciri-ciri watak, contohnya, dedikasi, kesamaan dan keikhlasan. Anjing banyak kali menawarkan kata-kata baik dan nasihat berharga, terus menyesuaikan diri dan suka menolong orang lain. Anjing kerap menjadi terlibat dengan kehidupan orang lain dan kini dilihat sebagai orang tengah. Menjamin orang lain ceria adalah lebih penting kepada Anjing daripada kekayaan, wang tunai atau pencapaian. Anjing adalah orang yang menyelesaikan; terus memerlukan subjek yang lain sebelum menyelesaikan apa yang mereka sudah mulakan.Anjing menghargai persahabatan; mereka teguh,original, boleh dipercayai dan kukuh dan mempunyai etika dan moral yang kukuh.","second_malay":"Rumah yang disusun dengan baik dalah sangat penting. Menjaga rumah yang sempurna dan membantu di tempat kerja,Anjing harus dinamik dan lengkap semuanya.Anjing sejenis yang mebakar wang tunai dengan berhati-hati, menyebarkan barangan mewah untuk perkara yang berfaedah.Anjing akan menjadi sensitif dan sukar apabila disentuh atau dikacau. Apabila perkara ini terjadi Anjing akan bersendirian dan memikirkan perkara-perkara yang sepatutnya dilakukan.Anjing boleh mendapat keuntungan dengan berehat memikirkan bagaimana untuk menjadi semakin lebih bijak.","first_thai":"ปีจอเป็นปีนักษัตรลำดับที่สิบเอ็ดของตำราโหราศาสตร์จีน คนเกิดปีจอเป็นคนทุ่มเท หน้าตาดี พูดจาดี และเป็นที่ปรึกษาหรือพึ่งพาให้กับคนรอบข้างได้เสมอ คนเกิดปีจอมักจะมีเรื่องราวให้เข้าไปพัวพันกับชีวิตคนอื่น จนบางครั้งถูกมองว่าจุ้นจ้าน การทำให้คนรอบตัวมีความสุขเป็นสิ่งสำคัญสำหรับคนเกิดปีจอมากกว่าชื่อเสียงเงินทอง พวกเขาเป็นคนมุ่งมั่นในการทำสิ่งต่างๆให้สำเร็จลุล่วง คนเกิดปีจอให้ความสำคัญกับเรื่องมิตรภาพ เป็นคนไว้ใจและพึ่งพาได้.","second_thai":"คนเกิดปีจอให้ความสำคัญกับเรื่องการจัดบ้านมาก ชอบช่วยเหลือเพื่อนร่วมงาน ประหยัดมัธยัสถ์และไม่ฟุ่มเฟือยไปกับสิ่งของหรูหราราคาแพง พวกเขาชอบเก็บหอมรอบริบไว้ใช้ตอนแก่ นอกจากนี้คนเกิดปีจอยังเป็นคนโกรธง่ายและเป็นคนสุดขั้ว บ่อยครั้งก็ยากจะเข้าใจ เวลาเจอปัญหาใดๆพวกเขาเลือกที่จะแก้ไขมันด้วยตัวของพวกเขาเอง.","first_czech":"Zapojením jedenácté situace v čínském zvěrokruhu Pes symbolizuje atributy postavy, například odhodlání, podobnost a laskavost. Mutts většinu času nabízejí laskavá slova a cenné rady, neustále se nalaďují a půjčují si rameno, když je to důležité. Mutti se často hluboce zabývají životy ostatních a jsou tu a tam považováni za vměšování. Zaručit, že ostatní budou veselí, je pro Psa důležitější než bohatství, hotovost nebo úspěch. Špičáky jsou odhodlaní lidé; neustále potřebují eso s jiným subjektem, než budou pokračovat, a neustále dokončují to, co začínají. Psí psi si váží přátelství; jsou vytrvalí, praví, spolehliví a solidní a mají pevnou etiku a morálku.","second_czech":"Dobře udržovaný a vytříděný dům je významný. Udržování dokonalého domova a pomoc při práci vychází ze psů a mělo by být dynamické a zahrnuto. Pooches pečlivě spálil hotovost a předával extravagantní zboží za rozumné věci. Pooches se navíc přiklání k vyčlenění hotovosti na pokrytí budoucích nákladů. Pooches může být občas citlivý, extremistický a obtížný. V okamžiku, kdy k tomu dojde, Pes vzlétne sám, aby napravil věci ve své hlavě. Mutti mohou profitovat z toho, že přijdou na to, jak se uvolnit a budou postupně rozlišovat.","first_bulgarian":" Добре поддържаният, подреден дом е важен. Поддържането на перфектен дом и помагането при работа произтичат от това на Кучето трябва да бъде динамично и включено. Pooches изгарят внимателно пари в брой, предавайки екстравагантни стоки за разумни неща. Pooches допълнително са склонни към заделяне на пари за покриване на бъдещи разходи. Pooches от време на време също могат да бъдат докачливи, екстремистки и трудни. В момента, когато това се случи, Кучето излита само, за да оправи нещата отново в главата си. Мутрите могат да се възползват, като измислят как да се размотават и са прогресивни.","second_bulgarian":" Добре поддържаният, подреден дом е важен. Поддържането на перфектен дом и помагането при работа произтичат от това на Кучето трябва да бъде динамично и включено. Pooches изгарят внимателно пари в брой, предавайки екстравагантни стоки за разумни неща. Pooches допълнително са склонни към заделяне на пари за покриване на бъдещи разходи. Pooches от време на време също могат да бъдат докачливи, екстремистки и трудни. В момента, когато това се случи, Кучето излита само, за да оправи нещата отново в главата си. Мутрите могат да се възползват, като измислят как да се размотават и са прогресивни.","first_norwegian":" Ved å involvere den ellevte situasjonen i den kinesiske dyrekretsen, symboliserer hunden karakteregenskaper, for eksempel dedikasjon, likhet og nådighet. Mutts mye av tiden gir gode ord og verdifulle råd, kontinuerlig innstilling og lån av en skulder når det er viktig. Mutter blir ofte dypt engasjert i andres liv og blir nå og da sett på som å blande seg. Å garantere at andre er muntre er mer avgjørende for hunden enn rikdom, penger eller prestasjoner. Hjørnetenner er resolutte mennesker; kontinuerlig behov for å skaffe seg et annet emne før du fortsetter og fullfører kontinuerlig det de starter. Hjørnetenner respekterer følgesvenn; de er standhaftige, ekte, pålitelige og solide og har solid etikk og moral.","second_norwegian":" Et velstelt, ordnet hjem er viktig. Å holde et perfekt hjem og hjelpe på jobben stammer fra hundens bør være dynamisk og inkludert. Pooches brenner nøye gjennom kontanter og gir ekstravagansvarer til rimelige ting. Pooches heller i retning av å sette av kontanter for å dekke fremtidige kostnader. Pooches kan av og til være berørende, ekstremistiske og vanskelige. På det tidspunktet når dette skjer, tar hunden av seg alene for å gjøre ting rett igjen i hodet. Mutter kan tjene på å finne ut hvordan man kan slappe av og være gradvis kresne.","first_denmark":"Ved at involvere den ellevte situation i den kinesiske stjernetegn symboliserer hunden karakteregenskaber, for eksempel dedikation, lighed og elskværdighed. Mutt meget af tiden tilbyder venlige ord og værdifulde råd, løbende indstillet og lånt en skulder, når det er vigtigt. Mutter bliver ofte dybt engageret i andres liv og ses af og til som blande sig. At garantere andre er munter er mere kritisk for hunden end rigdom, kontanter eller præstationer. Hunde er besluttede mennesker; der konstant har brug for at skaffe sig et andet emne, inden du fortsætter og løbende fuldfører det, de starter. Hunde hjemsøge selskab; de er faste, ægte, pålidelige og solide og har solid etik og moral.","second_denmark":"Et velplejet, ordnet hjem er vigtigt. At holde et perfekt hjem og hjælpe på arbejdspladsen stammer fra hundens bør være dynamisk og inkluderet. Pooches brænder omhyggeligt igennem kontanter og videregiver ekstravagance merchandise til rimelige ting. Pooches hælder desuden mod at afsætte kontanter til dækning af fremtidige omkostninger. Pooches nu og igen kan ligeledes være rørende, ekstremistiske og vanskelige. På det tidspunkt, hvor dette sker, tager hunden afsted alene for at gøre tingene lige inde i hovedet. Mutter kan tjene ved at finde ud af, hvordan man kan slappe af og være gradvis kræsne.","first_slovakia":"Zahŕňajúc jedenástu situáciu v čínskom zverokruhu, Pes symbolizuje atribúty charakteru, napríklad oddanosť, podobnosť a láskavosť. Mutts väčšinu času ponúka láskavé slová a cenné rady, neustále naladenie a požičanie ramena, keď je to dôležité. Mutty sa často hlboko zapájajú do života ostatných a sú občas vnímané ako miešanie. Zaručenie veselosti ostatných je pre Psa dôležitejšie ako bohatstvo, hotovosť alebo úspech. Špičáky sú odhodlaní ľudia; neustále potrebujú eso s iným predmetom skôr, ako pokračujú ďalej a neustále dokončujú to, čo začínajú. Psíkovia si vážia spoločnosť; sú vytrvalí, praví, spoľahliví a solídni a majú solídnu etiku a morálku.","second_slovakia":"Udržiavaný a usporiadaný dom je významný. Udržiavanie dokonalého domova a pomoc v práci vyplývajúce z Psu by malo byť dynamické a zahrnuté. Pooches opatrne spaľuje hotovosť a za rozumné veci odovzdáva extravagantný tovar. Pooches sa navyše prikláňa k vyčleneniu hotovosti na krytie budúcich nákladov. Pooches môže byť niekedy znova dojemný, extrémistický a ťažký. V okamihu, keď k tomu dôjde, pes vzlietne sám, aby si napravil poriadok vo svojej hlave. Mutti môžu profitovať tým, že prídu na to, ako sa uvoľniť a postupne rozlišovať."},"health":{"english":"A cheerful Dog is a solid Dog and it's anything but difficult to tell by the Dog's tragic or discouraged appearance that it's not feeling right. Mutts are flexible, particularly when battling disease.","arabic":"الكلب المبهج هو كلب صلب وليس من الصعب معرفة مظهر الكلب المأساوي أو المحبط أنه لا يشعر بالشعور الصحيح. طفرات مرنة ، وخاصة عندما تقاتل المرض.","greek":"Ένας χαρούμενος σκύλος είναι ένας σταθερός χαρακτήρας και είναι δύσκολο να καταλάβει κανείς από την εμφάνισή του πως αισθάνεται. Οι σκύλοι είναι ευέλικτοι, ιδιαίτερα όταν παλεύουν με κάποια ασθένεια.","malay":"Anjing sejenis yang ceria yang padat dan ia juga sukar untuk diberitahu oleh penampilannya yang tragis atau perasaan yang kurang tepat.Anjing adalah fleksibel, terutamanya apabila melawan penyakit.","thai":"คนเกิดปีจอแม้จะดูสดใสร่าเริง แต่ลึกๆข้างในจิตใจพวกเขากลับซ่อนความทุกข์เอาไว้ และพวกเขามีทัศนคติที่ดี.","czech":"Veselý pes je solidní pes a podle tragického nebo odradeného vzhledu psa je těžké ho poznat, že se necítí dobře. Mutanti jsou flexibilní, zvláště když bojují s chorobami.","bulgarian":"Веселото куче е солидно куче и по трагичния или обезсърчен външен вид на кучето е трудно да се каже, че не се чувства добре. Мутрите са гъвкави, особено при борба с болести.","norwegian":"En munter hund er en solid hund, og det er alt annet enn vanskelig å fortelle av hundens tragiske eller motløse utseende at den ikke føles riktig. Mutter er fleksible, spesielt når du kjemper mot sykdom.","denmark":"En munter hund er en solid hund, og det er alt andet end svært at fortælle ved hundens tragiske eller modløse udseende, at den ikke føles rigtig. Mutter er fleksible, især når de kæmper med sygdomme.","slovakia":"Veselý pes je pevný pes a podľa tragického alebo odradeného vzhľadu psa je ťažké povedať, že sa necíti dobre. Mutanti sú flexibilní, najmä keď bojujú s chorobami."},"carrers":{"first_english":"Because of their steadfast character, Dogs will in general pick a lifelong dependent on the rule of serving others. Canines are viewed as significant workers as they put their central core into their assignments. They are agreeable and kind, and are constantly prepared to mitigate the remaining task at hand of others, which makes them exceptionally famous in their work circle.","second_english":"Police officer, scientist, Ccounselor, interior designer, professor, politician, priest, nurse, clerk, and judge.","first_arabic":"بسبب طابعها الثابت ، ستختار الكلاب بشكل عام مدى الحياة اعتمادًا على قاعدة خدمة الآخرين. يُنظر إلى الأنياب على أنهم عمال مهمون لأنهم يضعون جوهرهم الأساسي في مهامهم. فهي مقبولة ولطيفة ، ومستعدة باستمرار لتخفيف المهمة المتبقية في يد الآخرين ، مما يجعلها مشهورة بشكل استثنائي في دائرة عملها.","second_arabic":"ضابط شرطة ، عالم ، مستشار ، مصمم داخلي ، أستاذ ، سياسي ، كاهن ، ممرضة ، كاتب ، وقاضي.","first_greek":"Λόγω του σταθερού χαρακτήρα τους, οι σκυλοι θα επιλέξουν γενικά μια ζωή βασισμένη στο να υποστηρίζουν άλλους. Οι σκύλοι θεωρούνται σημαντικοί εργαζόμενοι καθώς βάζουν όλο τους το είναι στην εργασία τους. Είναι ευχάριστοι και ευγενικοί και είναι διαρκώς διατεθειμένοι να προχωρούν με τις εργασίες τους, γεγονός που τους καθιστά εξαιρετικά δημοφιλείς στον εργασιακό τους κύκλο.","second_greek":"Αστυνομικός, επιστήμονας, σύμβουλος, εσωτερικός σχεδιαστής, καθηγητής, πολιτικός, ιερέας, νοσοκόμος, υπάλληλος και δικαστής.","first_malay":"Kerana sifat mereka yang mantap, Anjing akan secara umumnya memilih bergantung sepanjang hayat terhadap cara hidup untuk berkhidmat kepada orang lain. Anjing dilihat sebagai pekerja penting kerana mereka meletakkan keutamaan bagi mereka ke dalam tugasan mereka. Mereka sangat mudah setuju dan baik, dan sentiasa bersedia untuk mengurangkan tugas yang selebihnya di tangan orang lain, yang membuat mereka sangat terkenal dalam kalangan kerja mereka.","second_malay":"Pegawai polis, saintis, Kaunselor, pereka dalaman, profesor, ahli politik, imam, jururawat, kerani, dan hakim.","first_thai":"คนเกิดปีจอชอบช่วยเหลือคนอื่นและเป็นที่พึ่งพาให้กับคนรอบข้างได้ และทำงานที่ได้รับมอบหมายได้เป็นอย่างดี พวกเขาสุภาพและเป็นมิตร และช่วยแบ่งเบาภาระเพื่อนร่วมงาน ด้วยเหตุนี้คนเกิดปีจอจึงเป็นที่นิยมในที่ทำงาน.","second_thai":"เจ้าหน้าที่ตำรวจ นักวิทยาศาสตร์ ผู้ให้คำปรึกษา นักออกแบบตกแต่งภายใน ศาสตราจารย์ นักการเมือง นักบวช พยาบาล เสมียน และผู้พิพากษา.","first_czech":"Vzhledem ke své vytrvalé povaze si Psi obecně vyberou celoživotní závislost na pravidlu služby druhým. Špičáky jsou považováni za významné pracovníky, protože do svých úkolů vkládají své centrální jádro. Jsou příjemní a laskaví a jsou neustále připraveni zmírnit zbývající úkol ostatních, což je ve svém pracovním kruhu výjimečně proslavilo.","second_czech":"Policejní důstojník, vědec, Ccounselor, návrhář interiérů, profesor, politik, kněz, zdravotní sestra, úředník a soudce.","first_bulgarian":" Поради непоколебимия си характер, кучетата като цяло ще избират доживотна зависимост от правилото да служат на другите. Кучетата се разглеждат като значими работници, тъй като те влагат централното си ядро в задачите си. Те са приятни и любезни и непрекъснато са подготвени да смекчат оставащата задача на другите, което ги прави изключително известни в техния работен кръг.","second_bulgarian":" Полицейски служител, учен, съветник, интериорен дизайнер, професор, политик, свещеник, медицинска сестра, чиновник и съдия.","first_norwegian":" På grunn av sin standhaftige karakter, vil hunder generelt velge et livslangt avhengig av regelen om å tjene andre. Hjørnetenner blir sett på som viktige arbeidere når de legger sin sentrale kjerne i sine oppgaver. De er hyggelige og snille, og er stadig forberedt på å redusere andres gjenværende oppgave, noe som gjør dem eksepsjonelt berømte i deres arbeidskrets.","second_norwegian":" Politibetjent, forsker, rådgiver, interiørdesigner, professor, politiker, prest, sykepleier, kontorist og dommer.","first_denmark":"På grund af deres standhaftige karakter vælger hunde generelt en livslang afhængighed af reglen om at tjene andre. Hunde betragtes som betydningsfulde arbejdere, da de lægger deres centrale kerne i deres opgaver. De er behagelige og venlige og er konstant rede til at afbøde andres resterende opgave, hvilket gør dem usædvanligt berømte i deres arbejdscirkel.","second_denmark":"Politibetjent, videnskabsmand, rådgiver, indretningsarkitekt, professor, politiker, præst, sygeplejerske, kontorist og dommer.","first_slovakia":"Vzhľadom na svoj vytrvalý charakter si Psy všeobecne vyberú celoživotné závislé od pravidla služby iným. Špičáky sa považujú za významných pracovníkov, pretože do svojich úloh vkladajú svoje ústredné jadro. Sú príjemní a láskaví a sú neustále pripravení zmierniť zostávajúcu úlohu ostatných, čo ich robí výnimočne známymi v ich pracovnom kruhu.","second_slovakia":"Policajt, vedec, Ccounselor, interiérový dizajnér, profesor, politik, kňaz, zdravotná sestra, úradník a sudca."},"lucky":{"numbers":[3,4,9],"colors_english":["Green","Red","Purple"],"directions_english":["East","South","Northeast"],"colors_arabic":["اخضر","شرق","بنفسجي"],"colors_greek":["Πράσινο","Κόκκινο","Μωβ"],"directions_arabic":["شرق","جنوب","شمال الشرقي"],"directions_greek":["Ανατολή","Νότια","Βορειοανατολικός"],"colors_malay":["Hijau","Merah","Ungu"],"directions_malay":["Timur","Selatan","Timur laut"],"colors_thai":["สีเขียว","สีแดง","สีม่วง"],"directions_thai":["ทิศตะวันออก","ทิศใต้","ภาคตะวันออกเฉียงเหนือ"],"colors_czech":["Zelená","Červené","Nachový"],"directions_czech":["Východní","Jižní","Severovýchod"],"colors_bulgarian":["Зелено","червен","Лилаво"],"colors_norwegian":["Grønn","rød","Lilla"],"directions_bulgarian":["изток","На юг","Североизток"],"directions_norwegian":["Øst","Sør","Nordøst"],"colors_denmark":["Grøn","Rød","Lilla"],"directions_denmark":["Øst","Syd","Nordøst"],"colors_slovakia":["zelená","Červená","Fialová"],"directions_slovakia":["Východ","Juh","Severovýchod"]},"unlucky":{"numbers":[1,6,7],"colors_english":["Blue","Gold","White"],"directions_english":["Southeast"],"colors_arabic":["ازرق","ذهبي","ابيض"],"colors_greek":["Μπλε","Χρυσό","Λευκο"],"directions_arabic":["جنوب شرقي"],"directions_greek":["Νοτιοανατολικά"],"colors_malay":["Biru","Emas","Putih"],"directions_malay":["Barat daya"],"colors_thai":["สีน้ำเงิน","สีทอง","สีขาว"],"directions_thai":["ทิศตะวันตกเฉียงใต้"],"colors_czech":["Modrý","Zlato","Bílý"],"directions_czech":["Jihovýchodní"],"colors_bulgarian":["Син","Злато","Бял"],"colors_norwegian":["Blå","Gull","Hvit"],"directions_bulgarian":["Югоизток"],"directions_norwegian":["Sørøst"],"colors_denmark":["Blå","Guld","hvid"],"directions_denmark":["Sydøst"],"colors_slovakia":["Modrá","Zlato","biely"],"directions_slovakia":["Juhovýchod"]},"love":{"best_english":["Rabbit"],"worst_english":["Dragon","Goat","Rooster"],"best_arabic":["ارنب"],"worst_arabic":["تنين","الماعز","ديك"],"best_greek":["Λαγός"],"worst_greek":["Δράκος","Κατσίκα","Κόκορας"],"best_malay":["Arnab"],"worst_malay":["Naga","Kambing","Ayam"],"best_thai":["ปีเถาะ"],"worst_thai":["ปีมะโรง","ปีมะแม","ปีระกา"],"best_czech":["Králičí"],"worst_czech":["Drak","Koza","Kohout"],"best_bulgarian":["Заек"],"best_norwegian":["Kanin"],"worst_bulgarian":["Дракон","Козел","Петел"],"worst_norwegian":["Drage","Geit","Hane"],"best_denmark":["Kanin"],"worst_denmark":["Trække på","Ged","Hane"],"best_slovakia":["Králik"],"worst_slovakia":["drak","Koza","Kohút"]},"years":[1910,1922,1934,1946,1958,1970,1982,1994,2006,2018,2030,2042],"unicode_symbol":"戌"},{"sign_english":"Pig","sign_arabic":"خنزير","sign_greek":"Γουρούνι","sign_malay":"Khinzir","sign_thai":"ปีกุน","sign_czech":"Prase","sign_bulgarian":"Прасе","sign_norwegian":"Gris","sign_denmark":"Svin","sign_slovakia":"Prasa","yin-yang":"Yin","direction":"North","season":"Early Winter","element":"Water","trine":"4th","personality":{"first_english":"Possessing the last position in the Chinese Zodiac, the twelfth, the Pig symbolizes such character attributes as constancy, sympathy, and liberality. Pigs appreciate life and in light of the fact that they are engaging, others appreciate their conversation. Pigs are giving spirits and procure a lot of happiness when they're helping other people, yet in some cases they give excessively. Trustworthiness is the thing that Pigs give and it's what they hope to get consequently.","second_english":"Pigs look for harmony and will do what is important to look after it. This attribute, while praiseworthy, in some cases makes it simple for others to exploit Pigs. Pigs are continually accomplishing for other people, helping in any case they can, yet once in a while will they approach others for assistance. This can overpower and push them, yet Pigs wouldn't fret.With regards to cash, Pigs appreciate spending more than sparing. They float towards name brand things. Frugality happens just every so often, yet Pigs do realize how to discover incredible arrangements.","first_arabic":"امتلاك المركز الأخير في البروج الصيني ، الثاني عشر ، يرمز الخنزير إلى سمات شخصية مثل الثبات والتعاطف والليبرالية. يقدّر الخنازير الحياة وفي ضوء حقيقة مشاركتهم ، يقدّر آخرون محادثتهم. الخنازير تهب الأرواح وتكتسب الكثير من السعادة عندما تساعد الآخرين ، لكنها في بعض الحالات تعطيها بشكل مفرط. الجدارة بالثقة هي الشيء الذي يقدمه الخنازير وهذا ما يأملون في الحصول عليه نتيجة لذلك.","second_arabic":"تبحث الخنازير عن الانسجام وستفعل ما هو مهم للعناية بها. هذه السمة ، رغم أنها جديرة بالثناء ، في بعض الحالات تجعل من السهل على الآخرين استغلال الخنازير. يقوم الخنازير بإنجاز أعماله باستمرار لأشخاص آخرين ، حيث يساعدون في أي حال ، ولكنهم سوف يتواصلون من حين لآخر مع الآخرين للحصول على المساعدة. هذا يمكن أن يتغلب عليه ويدفعه ، لكن الخنازير لن تشعر بالقلق. فيما يتعلق بالنقد ، تقدر الخنازير إنفاقها أكثر من مجرد التوفير. يطفو نحو الأشياء اسم العلامة التجارية. يحدث الإقصاء مرارًا وتكرارًا ، لكن الخنازير تدرك كيفية اكتشاف الترتيبات المدهشة.","first_greek":"Καταλαμβάνοντας την τελευταία θέση στο κινέζικο ωροσκόπιο, ο χοίρος συμβολίζει χαρακτηριστικά γνωρίσματα όπως η σταθερότητα, η συμπάθεια και η φιλελευθερία. Οι χοίροι εκτιμούν τη ζωή, είναι δοτικοί και κάνουν τους άλλους να εκτιμούν τις μεταξύ τους συζήτησεις. Οι χοίροι δίνουν σημασία και προκαλούν μεγάλη ευτυχία, βοηθώντας άλλους ανθρώπους, παρότι σε ορισμένες περιπτώσεις δίνονται υπερβολικά. Η αξιοπιστία είναι το πράγμα που οι Χοίροι κυρίως δίνουν και είναι αυτό που ελπίζουν να πάρουν κατά συνέπεια.","second_greek":"Τα γουρούνια αναζητούν αρμονία και θα φροντίσουν αυτό που είναι σημαντικό. Αυτό το χαρακτηριστικό, αν και αξιέπαινο, σε ορισμένες περιπτώσεις το καθιστά εύκολο για τους άλλους να τα εκμεταλλεύονται. Οι χοίροι συνεχώς ενδιαφέρονται για άλλους ανθρώπους, βοηθώντας σε κάθε περίπτωση που μπορούν, ενώ ανά περιπτώσεις θα ζητήσουν και οι ίδιοι βοήθεια. Αυτό μπορεί να τους κάνει να νιώσουν παράξενα αλλά δεν θα το φοβηθούν. Όσον αφορά τα μετρητά, τα γουρούνια εκτιμούν τις σπατάλες περισσότερο από την εξοικονόμηση. Θα επιλέγουν επώνυμα προϊόντα, σε κάθε ευκαιρία. Η ομορφιά είναι κάτι που τα χαρακτηρίζει.","first_malay":"Memiliki kedudukan terakhir dalam Zodiak Cina, yang kedua belas, Babi melambangkan ciri-ciri watak seperti kesabaran, simpati, dan kemasyhuran. Babi menghargai kehidupan dan berdasarkan fakta bahawa mereka terlibat, orang lain menghargai perbualan mereka. Babi memberi semangat dan mendapatkan banyak kebahagiaan apabila mereka membantu orang lain, namun dalam beberapa kes mereka memberikan berlebihan. Kepercayaan adalah perkara yang diberikan oleh Babi dan itu adalah apa yang mereka harapkan untuk mendapatkan keputusannya.","second_malay":"Babi mencari keharmonian dan akan melakukan apa yang penting untuk menjaganya.Sifat-sifatnya,apabila dipuji, dalam beberapa hal menjadikannya mudah dimempergunakan oleh orang lain.Babi suka berusaha untuk orang lain,dan suka membantu dalam pelbagai hal yang mereka boleh selesaikan, tetapi kadang-kadang mereka akan mendekati orang lain untuk kegunaan mereka sendiri.Dalam keadaan begini apabila mereka terlebih berkuasa akan menyebabkan mereka mendapat susah tetapi mereka tidak bimbang.Mengenai wang tunai, Babi sangat suka berbelanja dengan besar daripada berjimat. Mereka lebih sukakan barangan yang berjenama. Kegigihan yang berlaku hanya sekali sekala,namun Babi menyedari bagaimana menemui perkara yang luar biasa.","first_thai":"ปีกุนเป็นปีนักษัตรลำดับสุดท้ายในตำราโหราศาสตร์จีน คนเกิดปีกุนเป็นคนหนักแน่น โอบอ้อมอารี และเห็นอกเห็นใจผู้อื่น พวกเขาเป็นคนเข้าใจชีวิต และคนรอบตัวชอบพูดคุยด้วย คนเกิดปีกุนชอบช่วยเหลือคนอื่นและมักจะทำให้คนรอบตัวมีความสุขได้เสมอ พวกเขาให้ความสำคัญกับเรื่องของความไว้เนื้อเชื่อใจมากและคาดหวังว่าจะได้รับจากคนอื่นเช่นเดียวกัน.","second_thai":"คนเกิดปีกุนมีความตั้งใจในการทำสิ่งต่างๆ และมักจะหลีกเลี่ยงการมีปากมีเสียง ซึ่งบ่อยครั้งทำให้พวกเขาถูกเอารัดเอาเปรียบ พวกเขาเป็นคนชอบช่วยเหลือคนอื่น แต่ในขณะเดียวกันพวกเขากลับไม่สบายใจเวลาที่ต้องขอความช่วยเหลือจากคนอื่น ในเรื่องของการใช้จ่ายเงิน คนเกิดปีกุนชอบใช้จ่ายมากกว่าการเก็บออม พวกเขาชอบสินค้าราคาแพง แต่อย่างไรก็ตามพวกเขาก็ตระหนักอยู่เสมอว่าการเก็บหอมรอบริมเป็นเรื่องที่ควรทำ.","first_czech":"Prase, které zaujímá poslední pozici v čínském zvěrokruhu, dvanácté, symbolizuje takové charakterové atributy jako stálost, sympatie a liberálnost. Prasata oceňují život a vzhledem k tomu, že jsou poutaví, ostatní oceňují jejich konverzaci. Prasata dávají náladu a získávají hodně štěstí, když pomáhají jiným lidem, přesto v některých případech dávají příliš mnoho. Důvěryhodnost je věc, kterou Prasata dávají a je to, co doufají, že následně získají.","second_czech":"Prasata hledají harmonii a budou dělat to, co je důležité, aby se o ni starali. Tento atribut, i když je chvályhodný, v některých případech usnadňuje ostatním využívat Prasata. Prasata neustále pomáhají ostatním lidem, pomáhají v každém případě, mohou, ale jednou za čas se obrátí o pomoc na ostatní. To je může přemoci a tlačit, ale Prasata by se neobávala. Co se týče hotovosti, Prasata oceňují, že utrácejí víc než šetří. Vznášejí se směrem ke značkovým věcem. Skromnost se děje tak často, ale Prasata si uvědomují, jak objevit neuvěřitelná uspořádání.","first_bulgarian":"Притежавайки последната позиция в китайския Зодиак, дванадесетата, Свинята символизира такива атрибути на характера като постоянство, съчувствие и либералност. Прасетата оценяват живота и в светлината на факта, че се ангажират, другите оценяват разговора им. Прасетата дават дух и доставят много щастие, когато помагат на други хора, но в някои случаи дават прекомерно. Доверието е нещото, което прасетата дават и това е, което те се надяват да получат впоследствие. ","second_bulgarian":" Прасетата търсят хармония и ще направят това, което е важно, за да се грижат за нея. Този атрибут, макар и похвален, в някои случаи улеснява другите да експлоатират прасета. Прасетата непрекъснато се справят за други хора, помагат във всеки случай, когато могат, но от време на време ще се обръщат към други за помощ. Това може да ги преодолее и да ги тласне, но прасетата не се тревожат. Що се отнася до парите, прасетата оценяват харченето повече, отколкото пестенето. Те плуват към неща с маркови марки. Пестеливостта се случва от време на време, но Прасетата осъзнават как да открият невероятни уговорки.","first_norwegian":" Med den siste posisjonen i den kinesiske dyrekretsen, den tolvte, symboliserer grisen slike karakteregenskaper som konstantitet, sympati og liberalitet. Griser setter pris på livet, og i lys av det at de engasjerer, setter andre pris på samtalen deres. Griser gir brennevin og skaffer mye lykke når de hjelper andre mennesker, men i noen tilfeller gir de altfor mye. Pålitelighet er tingen som griser gir, og det er det de håper å få følgelig.","second_norwegian":" Griser ser etter harmoni og vil gjøre det som er viktig for å ivareta det. Denne egenskapen, selv om det er prisverdig, gjør det i noen tilfeller enkelt for andre å utnytte griser. Griser gjør kontinuerlig prestasjoner for andre mennesker, og hjelper i alle fall de kan, men en gang i blant vil de nærme seg andre for å få hjelp. Dette kan overmanne og presse dem, men griser vil ikke bekymre seg. Når det gjelder kontanter, setter griser pris på å bruke mer enn å spare. De flyter mot navnemerke ting. Nøysomhet skjer bare så ofte, men griser skjønner hvordan de skal oppdage utrolige ordninger.","first_denmark":"Besidder den sidste position i den kinesiske stjernetegn, den tolvte, symboliserer grisen sådanne karakteregenskaber som konstantitet, sympati og liberalitet. Grise sætter pris på livet og i lyset af det faktum, at de engagerer sig, sætter andre pris på deres samtale. Grise giver spiritus og skaffer en masse lykke, når de hjælper andre mennesker, men i nogle tilfælde giver de alt for meget. Pålidelighed er den ting, grise giver, og det er hvad de håber at få som følge heraf.","second_denmark":"Grise ser efter harmoni og vil gøre hvad der er vigtigt for at passe på det. Selv om denne egenskab er prisværdig, gør det i nogle tilfælde det nemt for andre at udnytte svin. Svin presterer konstant for andre mennesker og hjælper i hvert fald de kan, men alligevel vil de en gang imellem henvende sig til andre for at få hjælp. Dette kan overmande og skubbe dem, men alligevel ville grise ikke bekymre sig. Med hensyn til kontanter sætter svin pris på at bruge mere end at spare. De svæver mod navne mærke ting. Frugalitet sker lige så ofte, men alligevel er grise klar over, hvordan man opdager utrolige arrangementer.","first_slovakia":"Ošípaná, ktorá má v čínskom zverokruhu poslednú, dvanástu pozíciu, symbolizuje atribúty znakov ako stálosť, sympatie a liberálnosť. Ošípané oceňujú život a vzhľadom na to, že sú pútavé, ostatní oceňujú ich rozhovor. Ošípané dávajú náladu a získavajú veľa šťastia, keď pomáhajú iným ľuďom, napriek tomu v niektorých prípadoch dávajú nadmerné množstvo. Dôveryhodnosť je vec, ktorú Ošípané dávajú a je to, čo dúfajú, že dostanú následne.","second_slovakia":"Ošípané hľadajú harmóniu a urobia to, čo je dôležité pre starostlivosť o ňu. Tento atribút, aj keď je chvályhodný, v niektorých prípadoch uľahčuje iným využívať Ošípané. Ošípané neustále pracujú pre ostatných ľudí, pomáhajú v každom prípade, môžu, napriek tomu raz za čas požiadajú o pomoc ostatných. To ich môže premôcť a zatlačiť, ale ošípané by sa neobávali. Pokiaľ ide o hotovosť, ošípané oceňujú, že trávia viac ako šetrenie. Plávajú smerom k značkovým veciam. Skromnosť sa deje len tak často, ale ošípané si uvedomujú, ako objaviť neuveriteľné dohody.","first_swedish":"Med den sista positionen i den kinesiska zodiaken, den tolfte, symboliserar grisen sådana karaktärsegenskaper som beständighet, sympati och liberalitet. Grisar uppskattar livet och i ljuset av att de engagerar, uppskattar andra deras konversation. Grisar ger sprit och skaffar mycket lycka när de hjälper andra människor, men i vissa fall ger de för mycket. Pålitlighet är det som grisar ger och det är vad de hoppas få följaktligen.","second_swedish":"Grisar letar efter harmoni och kommer att göra det som är viktigt för att ta hand om det. Detta attribut, även om det är prisvärt, gör det i vissa fall enkelt för andra att utnyttja grisar. Grisar presterar ständigt för andra människor och hjälper i alla fall de kan, men då och då kommer de att närma sig andra för hjälp. Detta kan överväldiga och driva dem, men grisar skulle inte oroa sig. När det gäller kontanter uppskattar grisar att spendera mer än att spara. De flyter mot märkesvarumärken. Sparsamhet händer bara så ofta, men ändå inser grisar hur man upptäcker otroliga arrangemang.","first_finnish":"Sian, jolla on viimeinen asema, kahdestoista, Kiinan horoskooppi, symboloi sellaisia ​​luonteen ominaisuuksia kuin vakaus, myötätunto ja vapaus. Siat arvostavat elämää, ja kun otetaan huomioon, että he ovat kiinnostuneita, toiset arvostavat heidän keskusteluaan. Siat antavat henkiä ja hankkivat paljon onnea auttaessaan muita ihmisiä, mutta joissakin tapauksissa ne antavat liikaa. Sikojen antama luotettavuus on asia, jonka he toivovat saavansa.","second_finnish":"Siat etsivät harmoniaa ja tekevät mitä on tärkeää huolehtia siitä. Tämä ominaisuus, vaikka se onkin kiitettävä, tekee joissakin tapauksissa sikojen hyödyntämisen yksinkertaiseksi. Siat tekevät jatkuvasti työtä muille ihmisille, auttavat joka tapauksessa, mutta pystyvät kuitenkin silloin tällöin ottamaan yhteyttä muihin. Tämä voi voittaa ja työntää heitä, mutta siat eivät tuskaile. Käteisen suhteen siat arvostavat enemmän kuin säästämistä. Ne kelluvat kohti nimimerkkiasia. Säästävyyttä tapahtuu vain niin usein, mutta Siat tajuavat kuinka löytää uskomattomia järjestelyjä.","first_romanian":"Având ultima poziție în zodiacul chinezesc, al doisprezecelea, Porcul simbolizează astfel de atribute de caracter precum constanța, simpatia și liberalitatea. Porcii apreciază viața și, în lumina faptului că se angajează, alții apreciază conversația lor. Porcii dau duhuri și procură multă fericire atunci când ajută alți oameni, dar în unele cazuri dau prea mult. Încrederea este ceea ce dau porcii și este ceea ce speră să obțină în consecință. ","second_romanian":"Porcii caută armonie și vor face ceea ce este important să aibă grijă de ea. Acest atribut, deși lăudabil, în unele cazuri simplifică exploatarea porcilor pentru alții. Porcii realizează continuu pentru alți oameni, ajutând în orice caz pot, dar din când în când se vor apropia de alții pentru ajutor. Acest lucru îi poate învinge și împinge, dar porcii nu s-ar supăra. În ceea ce privește numerarul, porcii apreciază cheltuielile mai mult decât economisirea. Ele plutesc spre lucruri de nume. Frugalitatea se întâmplă din când în când, dar porcii își dau seama cum să descopere aranjamente incredibile."},"health":{"english":"Continually looking for the sake of entertainment, Pigs regularly enjoy more than they should. Inordinate eating, drinking and smoking can cause affliction. Pigs aren't extremely dynamic and, joined with their unreasonable practices, cause them to put on weight. Pigs are social and being separated from everyone else makes them despondent. Pigs would profit by embracing a more advantageous way of life.","arabic":"تبحث باستمرار عن الترفيه ، تتمتع الخنازير بانتظام بأكثر مما ينبغي. الأكل المفرط والشرب والتدخين يمكن أن يتسبب في البلاء. الخنازير ليست ديناميكية للغاية ، وانضم إلى ممارساتهم غير المعقولة ، وتسبب لهم في الوزن. الخنازير اجتماعية وتفصلها عن أي شخص آخر يجعلها بائسة. سوف تستفيد الخنازير من خلال تبني أسلوب حياة أكثر فائدة.","greek":"Αναζητώντας συνεχώς τη διασκέδαση, οι χοίροι απολαμβάνουν πράγματα τακτικά περισσότερο από ό, τι πρέπει. Η υπερβολική κατανάλωση φαγητού, ποτού και καπνίσματος μπορεί να προκαλέσει θλίψη. Οι χοίροι δεν είναι εξαιρετικά δυναμικοί και, μαζί με τις αδικαιολόγητες πρακτικές τους, ενίοτε παίρνουν βάρος. Οι χοίροι είναι κοινωνικοί και απομακρύνονται από όλους τους άλλους που μπορεί να τους χαλάσουν τη διάθεση. Οι χοίροι θα ωφεληθούν υιοθετώντας έναν πιο συμφέροντα τρόπο ζωής.","malay":"Secara berterusan suka mencari hiburan,Babi selalu menikmati lebih banyak keseronokan daripada apa yang mereka perlukan.Makan, minum dan merokok yang luar biasa boleh menyebabkan penderitaan.Babi tidak begitu dinamik dan cara mereka tidak berfaedah, menyebabkan mereka akan bertambah gemuk.Babi adalah seorang yang suka bersosial jika dipisahkan dengan orang lain akan menyebabkan mereka sedih. Babi akan mendapat keuntungan dengan membuat cara hidup yang lebih berfaedah.","thai":"คนเกิดปีกุนชอบความบันเทิงปาร์ตี้สังสรรค์ แต่การกิน การดื่มและสูบบุหรี่มากเกินไปมักเป็นสาเหตุทำให้พวกเขาเจ็บป่วย เพราะเป็นคนไม่กระฉับกระเฉงและไม่ชอบการออกกำลังกายทำให้พวกเขาอ้วนง่าย คนเกิดปีกุนจะรู้สึกไม่มีความสุขมากเมื่อต้องอยู่คนเดียว.","czech":"Neustále hledají zábavu, Prasata si pravidelně užívají víc, než by měla. Nadměrné stravování, pití a kouření mohou způsobit utrpení. Prasata nejsou extrémně dynamická a ve spojení se svými nepřiměřenými praktikami způsobují přibírání na váze. Prasata jsou společenská a odloučení od všech ostatních je činí sklíčenými. Prasata by profitovala z výhodnějšího způsobu života.","bulgarian":"Непрекъснато търсейки в името на забавлението, прасетата редовно се радват на повече, отколкото трябва. Прекомерното хранене, пиене и пушене може да причини страдание. Прасетата не са изключително динамични и, заедно с техните неразумни практики, ги карат да напълняват. Прасетата са социални и отделянето от всички останали ги прави унили. Прасетата биха спечелили, възприемайки по-изгоден начин на живот.","norwegian":"Griser som kontinuerlig ser etter underholdningens skyld, gleder seg mer enn de burde. Overordnet spising, drikking og røyking kan forårsake plager. Griser er ikke ekstremt dynamiske, og sammen med deres urimelige praksis får de til å legge seg på. Griser er sosiale og det å være atskilt fra alle andre gjør dem fortvilet. Griser ville tjene på å omfavne en mer fordelaktig livsstil.","denmark":"Grise, der konstant søger underholdningens skyld, nyder regelmæssigt mere, end de burde. Overordnet spisning, drikke og rygning kan forårsage lidelse. Grise er ikke ekstremt dynamiske, og sammen med deres urimelige fremgangsmåder får de dem til at tage på i vægt. Grise er sociale, og det at være adskilt fra alle andre gør dem fortvivlede. Grise ville tjene penge ved at omfavne en mere fordelagtig livsstil.","slovakia":"Neustále hľadajú zábavu, ošípané si pravidelne užívajú viac, ako by mali. Nadmerné stravovanie, pitie a fajčenie môžu spôsobiť trápenie. Ošípané nie sú extrémne dynamické a spolu so svojimi neprimeranými postupmi spôsobujú, že priberajú. Ošípané sú spoločenské a keď sú odlúčené od všetkých ostatných, sú skľúčené. Ošípané by profitovali z prijatia výhodnejšieho spôsobu života.","swedish":"Grisar som ständigt letar efter underhållningens skull njuter mer än de borde. Överdriven äta, dricka och röka kan orsaka plåga. Grisar är inte extremt dynamiska och, tillsammans med deras orimliga metoder, får de att gå upp i vikt. Grisar är sociala och att separeras från alla andra gör dem förtvivlade. Grisar skulle tjäna pengar genom att anamma ett mer fördelaktigt sätt att leva.","finnish":"Siat etsivät jatkuvasti viihteen vuoksi Siat nauttivat säännöllisesti enemmän kuin pitäisi. Liiallinen syöminen, juominen ja tupakointi voivat aiheuttaa kärsimystä. Siat eivät ole erittäin dynaamisia, ja yhdessä kohtuuttomien käytäntöjensä kanssa ne aiheuttavat niiden lihoa. Siat ovat sosiaalisia, ja erillään oleminen kaikista muista tekee niistä epätoivoisia. Siat hyötyisivät omaksumalla edullisemman elämäntavan.","romanian":"În continuă căutare de dragul divertismentului, porcii se bucură în mod regulat mai mult decât ar trebui. Mâncarea, băutul și fumatul excesiv pot provoca suferințe. Porcii nu sunt extrem de dinamici și, alături de practicile lor nerezonabile, îi determină să se îngrașe. Porcii sunt sociali și separarea de toți ceilalți îi face să fie descurajați. Porcii ar profita adoptând un mod de viață mai avantajos."},"carrers":{"first_english":"Pigs are gentle and rarely lose their temper. Even when they do, it’s never a dramatic commotion. They’ll always try to compromise and settle things quickly. Because their goal in life is for everyone to live in harmony, they are suitable for careers related to charity and fundraisers.","second_english":"Veterinarians, foresters, teachers, civil servants, policemen, doctors, breeders, professors, artists.","first_arabic":"الخنازير لطيفة ونادراً ما تفقد أعصابها. حتى عندما يفعلون ذلك ، فهي ليست مجرد ضجة مثيرة. سيحاولون دائمًا تسوية الأمور وتسويتها بسرعة. لأن هدفهم في الحياة هو أن يعيش الجميع في وئام ، فهي مناسبة للمهن المتعلقة بالجمعيات الخيرية وجمع التبرعات.","second_arabic":"الأطباء البيطريين والحراجة والمعلمين وموظفي الخدمة المدنية ورجال الشرطة والأطباء والمربين والأساتذة والفنانين.","first_greek":"Οι χοίροι είναι ήπιοι και σπάνια χάνουν την ψυχραιμία τους. Ακόμη και όταν το κάνουν, δεν θα δημιουργηθεί ποτέ μια δραματική αναταραχή. Θα προσπαθήσουν πάντα να συμβιβαστούν και να διευθετήσουν τα πράγματα γρήγορα. Επειδή ο στόχος τους στη ζωή είναι για όλους να ζουν αρμονικά, είναι κατάλληλοι για επαγγελματική σταδιοδρομία που σχετίζεται με φιλανθρωπικούς σκοπούς και εθελοντές.","second_greek":"Κτηνίατροι, δασοκόμοι, δάσκαλοι, δημόσιοι υπάλληλοι, αστυνομικοί, γιατροί, κτηνοτρόφοι, καθηγητές, καλλιτέχνες.","first_malay":"Babi mempunyai perwatakan yang lembut dan jarang hilang sabar.Walaupun mereka hilang sabar ia tidak pernah menjadi teruk.Mereka sentiasa cuba untuk bertolak ansur dan menyelesaikan perkara tersebut dengan cepat. Kerana matlamat mereka dalam hidup adalah untuk semua orang hidup harmoni, mereka sesuai untuk kerjaya yang berkaitan dengan kerja amal dan pengumpul dana","second_malay":"Doktor haiwan, penjaga hutan, guru, penjawat awam, anggota polis, doktor, penternak, profesor, artis.","first_thai":"คนเกิดปีกุนเป็นคนสุภาพอ่อนโยนและอารมณ์ดี เวลาเจอปัญหาใดๆ พวกเขาจะพยายามแก้ปัญหานั้นให้ได้เร็วที่สุด พวกเขามักชอบทำงานด้านการกุศลและการระดมทุน เพราะเป้าหมายในชีวิตของพวกเขาคือการทำให้ทุกคนมีความสุข.","second_thai":"สัตวแพทย์ นักป่าไม้ ครู ข้าราชการ ตำรวจ หมอ นักผสมพันธุ์ อาจารย์ และศิลปิน.","first_czechh":"Prasata jsou jemná a málokdy ztratí nervy. I když to udělají, nikdy nejde o dramatický rozruch. Vždy se budou snažit dělat kompromisy a urovnat věci rychle. Protože jejich životním cílem je, aby všichni žili v harmonii, a proto jsou vhodné pro kariéru související s charitou a získáváním finančních prostředků.","second_czech":"Veterináři, lesníci, učitelé, úředníci, policisté, lékaři, chovatelé, profesoři, umělci.","first_bulgarian":" Прасетата са нежни и рядко губят самообладание. Дори когато го направят, това никога не е драматична суматоха. Те винаги ще се опитват да направят компромиси и да уредят нещата бързо. Тъй като целта им в живота е всеки да живее в хармония, те са подходящи за кариера, свързана с благотворителност и набиране на средства.","second_bulgarian":" Ветеринарни лекари, лесовъди, учители, държавни служители, полицаи, лекари, животновъди, професори, художници.","first_norwegian":" Griser er milde og mister sjelden humøret. Selv når de gjør det, er det aldri noe dramatisk bråk. De vil alltid prøve å gå på kompromiss og avgjøre ting raskt. Fordi deres mål i livet er at alle skal leve i harmoni, er de egnet for karrierer knyttet til veldedighet og innsamling.","second_norwegian":" Veterinærer, skogbrukere, lærere, tjenestemenn, politimenn, leger, oppdrettere, professorer, kunstnere.","first_denmark":"Grise er blide og mister sjældent deres temperament. Selv når de gør det, er det aldrig en dramatisk ophidselse. De vil altid forsøge at gå på kompromis og afvikle tingene hurtigt. Fordi deres mål i livet er, at alle skal leve i harmoni, er de velegnede til karrierer relateret til velgørenhed og fundraisers.","second_denmark":"Dyrlæger, skovbrugere, lærere, embedsmænd, politibetjente, læger, opdrættere, professorer, kunstnere.","first_slovakia":"Ošípané sú jemné a zriedka strácajú nervy. Aj keď to urobia, nikdy nejde o dramatický rozruch. Vždy sa pokúsia kompromitovať a rýchlo vyriešiť veci. Pretože ich životným cieľom je, aby všetci žili v harmónii, sú preto vhodné pre prácu v charite a v zbierkach peňazí.","second_slovakia":"Veterinári, lesníci, učitelia, štátni zamestnanci, policajti, lekári, chovatelia, profesori, umelci.","first_swedish":"Grisar är skonsamma och tappar sällan sitt humör. Även när de gör det är det aldrig en dramatisk uppståndelse. De kommer alltid att försöka kompromissa och lösa saker snabbt. Eftersom deras mål i livet är att alla ska leva i harmoni, är de lämpliga för karriärer relaterade till välgörenhet och insamlingar.","second_swedish":"Veterinärer, skogsmän, lärare, tjänstemän, poliser, läkare, uppfödare, professorer, konstnärer.","first_finnish":"Siat ovat lempeitä ja menettävät itsensä harvoin. Vaikka he tekevätkin, se ei ole koskaan dramaattinen melu. He yrittävät aina tehdä kompromisseja ja ratkaista asiat nopeasti. Koska heidän elämänsä tavoitteena on, että jokainen elää sopusoinnussa, he soveltuvat hyväntekeväisyyteen ja varainkeruun liittyvään uraan.","second_finnish":"Eläinlääkärit, metsänhoitajat, opettajat, virkamiehet, poliisit, lääkärit, kasvattajat, professorit, taiteilijat.","first_romanian":"Porcii sunt blânzi și rareori își pierd cumpătul. Chiar și atunci când o fac, nu este niciodată o agitație dramatică. Vor încerca întotdeauna să facă compromisuri și să rezolve rapid lucrurile. Deoarece scopul lor în viață este ca toată lumea să trăiască în armonie, sunt potrivite pentru cariere legate de caritate și strângeri de fonduri.","second_romanian":"Veterinari, silvicultori, profesori, funcționari publici, polițiști, medici, crescători, profesori, artiști."},"lucky":{"numbers":[2,5,8],"colors_english":["Brown","Gray","Gold","Yellow"],"directions_english":["East","Southwest"],"colors_arabic":["بني","رمادي","ذهبي","اصفر"],"colors_greek":["Καφέ","Γκρί","Χρυσό","Κίτρινο"],"directions_arabic":["شرق","جنوب غربي"],"directions_greek":["Ανατολή","Νοτιοδυτικά"],"colors_malay":["Perang","Kelabu","Emas","Kuning"],"directions_malay":["Timur","Barat daya"],"colors_thai":["สีน้ำตาล","สีเทา","สีทอง","สีเหลือง"],"directions_thai":["ทิศตะวันออก","ทิศตะวันตกเฉียงใต้"],"colors_czech":["Hnědý","Šedá","Zlato","Žlutá"],"directions_czech":["Východní","Jihozápadní"],"colors_bulgarian":[],"colors_norwegian":[],"directions_bulgarian":[],"directions_norwegian":[],"colors_denmark":["Brun","Grå","Guld","Gul"],"directions_denmark":["Sydøst","Sydvest"],"colors_slovakia":["Hnedá","Šedá","Zlato","žltá"],"directions_slovakia":["Juhovýchod","Juhozápad"],"colors_swedish":["Brun","grå","Guld","Gul"],"directions_swedish":["Öst","Sydväst"],"colors_finnish":["Ruskea","harmaa","Kulta","Keltainen"],"directions_finnish":["Itään","Lounaaseen"],"colors_romanian":["Maro","gri","Aur","Galben"],"directions_romanian":["Est","Sud-Vest"]},"unlucky":{"numbers":[1,7],"colors_english":["Blue","Green","Red"],"directions_english":["Southeast"],"colors_arabic":["ازرق","اخضر","أحمر"],"colors_greek":["Μπλε","Πράσινο","Κόκκινο"],"directions_arabic":["جنوب شرقي"],"directions_greek":["Νοτιοανατολικά"],"colors_malay":["Biru","Hijau","Merah"],"directions_malay":["Timur laut"],"colors_thai":["สีน้ำเงิน","สีเขียว","สีแดง"],"directions_thai":["ภาคตะวันออกเฉียงเหนือ"],"colors_czech":["Modrý","Zelená","Červené"],"directions_czech":["Jihovýchodní"],"colors_bulgarian":[],"colors_norwegian":[],"directions_bulgarian":[],"directions_norwegian":[],"colors_denmark":["Blå","Grøn","Rød"],"directions_denmark":["Sydøst"],"colors_slovakia":["Modrá","zelená","Červená"],"directions_slovakia":["Juhovýchod"],"colors_swedish":["Blå","Grön","Röd"],"directions_swedish":["Sydöst"],"colors_finnish":["Sininen","Vihreä","Punainen"],"directions_finnish":["Kaakko"],"colors_romanian":["Albastru","Verde","roșu"],"directions_romanian":["Sud Est"]},"love":{"best_english":["Goat","Tiger","Rabbit"],"worst_english":["Monkey","Snake"],"best_arabic":["الماعز","نمر","ارنب"],"worst_arabic":["القرد","الافعى"],"best_greek":["Κατσίκα","Τίγρη","Λαγός"],"worst_greek":["Πίθηκος","Φίδι"],"best_malay":["Kambing","Harimau","Arnab"],"worst_malay":["Monyet","Ular"],"best_thai":["ปีมะแม","ปีขาล","ปีเถาะ"],"worst_thai":["ปีวอก","ปีมะเส็ง"],"best_czech":["Koza","Tygr","Králičí"],"worst_czech":["Opice","Had"],"best_bulgarian":[],"best_norwegian":[],"worst_bulgarian":[],"worst_norwegian":[],"best_denmark":["Ged","Tiger","Kanin"],"worst_denmark":["Abe","Slange"],"best_slovakia":["Koza","Tiger","Králik"],"worst_slovakia":["Opica","Had"],"best_swedish":["Get","Tiger","Kanin"],"worst_swedish":["Apa","Orm"],"best_finnish":["Vuohi","Tiikeri","Kani"],"worst_finnish":["Apina","Käärme"],"best_romanian":["Capră","Tigru","Iepure"],"worst_romanian":["Maimuţă","Şarpe"]},"years":[1911,1923,1935,1947,1959,1971,1983,1995,2007,2019,2031,2043],"unicode_symbol":"亥"}],"czodiac_explain":{"year":"is year of the","next_year":"will be a year of the","last_year":"was a year of the","what_is":"The general consensus is that the zodiacs initially had something to do with the love of creatures. A zodiac framework has existed in Chinese culture since the Qin line, over 2,000 years ago."}}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Cow.svg": 1357,
	"./Dog.svg": 1358,
	"./Dragon.svg": 1359,
	"./Goat.svg": 1360,
	"./Horse.svg": 1361,
	"./Monkey.svg": 1362,
	"./Ox.svg": 1363,
	"./Pig.svg": 1364,
	"./Rabbit.svg": 1365,
	"./Rat.svg": 1366,
	"./Rooster.svg": 1367,
	"./Snake.svg": 1368,
	"./Tiger.svg": 1369
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 344;

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobiscope__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api_mobiscopeAPI__ = __webpack_require__(346);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var TJO = __webpack_require__(84)();

var proxyurl = "https://corsanywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false
    };
  },
  created: function created() {
    this.getPrefix(this.countryCode);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["language", "translateCode", "gcid_mobis", "countryCode"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(countryCode) {
      if (countryCode == 'cz') {
        this.msisdn = '+420';
      }
      if (countryCode == 'no') {
        this.msisdn = '+47';
      }
      if (countryCode == 'bg') {
        this.msisdn = '+359';
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      if (this.countryCode == 'cz') {
        var a = this.msisdn;
        this.msisdn = a.replace("+", "");
      }
      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";

          if (this.gcid_mobis != "") {
            gcid = this.gcid_mobis;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + ("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };

          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("tokenID", res.data.contents);
              localStorage.setItem("userTokenID_mobis", response.token);
              localStorage.setItem("userProfile_mobis", res.data.contents);
              localStorage.setItem("mobis_msisdn", response.msisdn);
              localStorage.setItem("mobis_country_code", response.country_code);
              localStorage.setItem("mobis_gateway_code", response.gateway_code);
              localStorage.setItem("mobis_subscription_date", response.subscription_date);
              _this.msisdn = "";
              _this.login_mobis("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_mobiscope__["a" /* default */].push({ name: "Horoscope" }).catch(function (err) {});
              // location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this.countryCode == key) {
                    var status_lang = __webpack_require__(1374)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }).catch(function (err) {
            return console.log(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_mobis"]), {
    emitMethod: function emitMethod() {
      __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__["a" /* default */].$emit("logged-in", "loggedin");
    }
  })
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* unused harmony default export */ var _unused_webpack_default_export = ({
    getStatus: function getStatus(code, verbose) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("?code=" + code + "&verbose=" + verbose).then(function (res) {
            return res.data.status;
        });
    },
    getLogin: function getLogin(msisdn, gcid, verbose) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("?msisdn=" + msisdn + "&gcid=" + gcid + "&verbose=" + verbose).then(function (res) {
            return res.data.status;
        });
    }
});

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"الابراج","tarot":"التنجيم ببطائق التاروت","zodiac_signs":"علامات الابراج","chinese_zodiac":"الابراج الصينية","zodiac_of_the_month":"الابراج لهذا الشهر","read_more":"اقراء المزيد","horoscopes":"الابراج","yesterday":"الامس","today":"اليوم","tomorrow":"غدا","week":"أسبوعيا","month":"شهريا","year":"سنويا","daily_horo":"الابراج اليومية","tarot_cards":"بطائق تاروت للتنجيم","major":"تاروت رئيسي","minor":"تاروت ثانوي","wands":"الصولجانات","cups":"كوؤس","swords":"سيوف","pentacles":"النجمة الخماسية","description":"التفاصيل","meaning":"المعاني","close":"أغلق","by_click":"بالضغط على علامة البرج الخاصة بك ، يمكنك رؤية ملفك الفلكي الكامل للعنصر الذي تنتمي إليه والكواكب التي تتحكم في علامة البرج الخاصة بك","element_signs":"العلامات الرئيسية","air":"الهواء","earth":"الارض","fire":"النار","water":"الماء","mental":"الصفات العقلية","physical":"الصفات الجسدية","favorites":"المفضلة","hates":"المكروهات","ruling_planet":"الكوكب الحاكم","compatibility":"التوافق","element":"العنصر","color":"اللون","astrology":"تفسير علم التنجيم ل ","elem":"عنصر ال","ascendant":"الصاعد","related":"ابراج متعلقة","zodiac_of_the_year":"ابراج السنة","chinese_zodiac_signs":"علامات الابراج الصينية","personality":"الشخصية","health":"الصحة","best_career":"أفضل الوظائف","careers":"وظائف","lucky":"اشياء محظوظة ","unlucky":"اشياء غير محظوظة","numbers":"ارقام","colors":"الوان","directions":"اتجاهات","best_match":"افضل تطابق","worst_match":"اسوء تطابق","login_title":"هل انت مشترك في Mobiscope؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","login":"دخول","logout":"خروج","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","unsubscribe":"إلغاء الاشتراك","profile":"الملف الشخصي"}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Хороскопи","tarot":"Таро","zodiac_signs":"Зодии","chinese_zodiac":"Китайски зодиак","zodiac_of_the_month":"Зодия на месеца","read_more":"Прочетете още","horoscopes":"Хороскопи","yesterday":"Вчера","today":"Днес","tomorrow":"Утре","week":"Седмица","month":"Месец","year":"Година","daily_horo":"Ежедневен хороскоп","tarot_cards":"Карти Таро","major":"Майор Таро","minor":"Непълнолетно Таро","wands":"Пръчки","cups":"Чаши","swords":"Мечове","pentacles":"Пентакли","description":"Описание","meaning":"Значение","close":"Близо","by_click":"Като кликнете върху вашия зодиакален знак, можете да видите пълния си зодиакален профил, елемента, към който принадлежите, и планетите, които управляват вашия зодиакален знак","element_signs":"Признаци на елемента","air":"Въздух","earth":"Земята","fire":"Пожар","water":"Вода","mental":"Психични черти","physical":"Физически черти","favorites":"Любими","hates":"Мрази","ruling_planet":"Управляваща планета","compatibility":"Съвместимост","element":"Елемент","color":"Цвят","astrology":"Тълкуване на астрологията на","elem":"Елементът на","ascendant":"Асцендент","related":"Свързани зодиаци","zodiac_of_the_year":"Зодия на годината","chinese_zodiac_signs":"Китайски зодиакални знаци","personality":"Личност","health":"Здраве","best_career":"The best careers","careers":"Кариери","lucky":"Щастливи неща","unlucky":"Нещастни неща","numbers":"Числа","colors":"Цветове","directions":"Указания","best_match":"Най-добро съвпадение","worst_match":"Най-лошото съвпадение","login_title":"Абонирани ли сте за Mobiscope?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","login":"Плъх","logout":"Излез от профила си","status":"Неактивно","mobile_computer":"Мобилни и компютърни","privacy":"Политика за поверителност"}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Procházet","tarot":"Tarot","zodiac_signs":"Znamení zvěrokruhu","chinese_zodiac":"Čínský zvěrokruh","zodiac_of_the_month":"Zvěrokruh měsíce","read_more":"Přečtěte si více","horoscopes":"Horoskopy","yesterday":"Včera","today":"dnešek","tomorrow":"Zítra","week":"Týden","month":"Měsíc","year":"Rok","daily_horo":"denní horoskop","tarot_cards":"Tarotové karty","major":"hlavní tarot","minor":"Malý tarot","wands":"Hůlky","cups":"Poháry","swords":"Meče","pentacles":"pentagramy","description":"popis","meaning":"Význam","close":"Zavřít","by_click":"Kliknutím na své znamení zvěrokruhu uvidíte celý svůj profil zvěrokruhu, prvek, ke kterému patříte, a planety, které vašemu znamení zvěrokruhu vládnou.","element_signs":"Znaky prvků","air":"Air","earth":"Země","fire":"oheň","water":"Voda","mental":"Mentální vlastnosti","physical":"Fyzické vlastnosti","favorites":"Oblíbené","hates":"Nesnáší","ruling_planet":"Vládnoucí planeta","compatibility":"slučitelnost","element":"Živel","color":"barva","astrology":"Astrologická interpretace ","elem":"prvek","ascendant":"Stoupající","related":"Související zvěrokruhy","zodiac_of_the_year":"Zvěrokruh roku","chinese_zodiac_signs":"Znamení čínského zvěrokruhu","personality":"Osobnost","health":"Zdraví","best_career":"Nejlepší kariéry","careers":"Kariéra","lucky":"věci šťastný","unlucky":"Věci Nešťastný","numbers":"Čísla","colors":"reprezentační dres","directions":"Pokyny","best_match":"Nejlepší shoda","worst_match":"Nejhorší zápas","login_title":"Jste přihlášeni k odběru Mobiscope?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"Zadejte prosím platné číslo!","login":"přihlásit se","logout":"Odhlásit se","status":"Neaktivní","mobile_computer":"Mobilní a počítačové","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky"}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoskop","tarot":"Tarot","zodiac_signs":"Stjernetegn","chinese_zodiac":"Kinesisk stjernetegn","zodiac_of_the_month":"Månedens stjernetegn","read_more":"Læs mere","horoscopes":"Horoskoper","yesterday":"I går","today":"I dag","tomorrow":"I morgen","week":"Uge","month":"Måned","year":"År","daily_horo":"Dagligt horoskop","tarot_cards":"Tarotkort","major":"Major Tarot","minor":"Mindre Tarot","wands":"Tryllestave","cups":"Kopper","swords":"Sværd","pentacles":"Pentakler","description":"Beskrivelse","meaning":"MeaBetyderning","close":"Tæt","by_click":"Ved at klikke på dit stjernetegn kan du se din komplette stjernetegnsprofil det element, du tilhører, og de planeter, der styrer dit stjernetegn","element_signs":"Elementskilt","air":"Luft","earth":"jorden","fire":"Ild","water":"Vand","mental":"Mentale træk","physical":"Fysiske træk","favorites":"Foretrukne","hates":"Hader","ruling_planet":"Herskende planet","compatibility":"Kompatibilitet","element":"Element","color":"Farve","astrology":"Astrologi Fortolkning af The ","elem":"Elementet af","ascendant":"Ascendant","related":"Relaterede stjernetegn","zodiac_of_the_year":"Årets stjernetegn","chinese_zodiac_signs":"Kinesiske stjernetegn","personality":"Personlighed","health":"Sundhed","best_career":"The best careers","careers":"Career","lucky":"Lucky Things","unlucky":"Uheldige ting","numbers":"Tal","colors":"Farver","directions":"Kørselsvejledning","best_match":"Best Matchv","worst_match":"Værste match","login_title":"Abonneret på Mobiscope?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","login":"Log på","logout":"Log ud","status":"Inaktiv","mobile_computer":"Mobil og computer","subscription_date":"Abonnementsdato","privacy":"Fortrolighedspolitik","registered_num":"Registreret nummer","unsubscribe":"Opsige abonnement","profile":"Profil"}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoscope","tarot":"Tarot","zodiac_signs":"Zodiac Signs","chinese_zodiac":"Chinese Zodiac","zodiac_of_the_month":"Zodiac of The Month","read_more":"Read More","horoscopes":"Horoscopes","yesterday":"Yesterday","today":"Today","tomorrow":"Tomorrow","week":"Week","month":"Month","year":"Year","daily_horo":"Daily Horoscope","tarot_cards":"Tarot Cards","major":"Major Tarot","minor":"Minor Tarot","wands":"Wands","cups":"Cups","swords":"Swords","pentacles":"Pentacles","description":"Description","meaning":"Meaning","close":"Close","by_click":"By clicking on your zodiac sign you can see your complete zodiac profile, the element to which you belong and the planets that rule your zodiac sign","element_signs":"Element Signs","air":"Air","earth":"Earth","fire":"Fire","water":"Water","mental":"Mental Traits","physical":"Physical Traits","favorites":"Favorites","hates":"Hates","ruling_planet":"Ruling Planet","compatibility":"Compatibility","element":"Element","color":"Color","astrology":"Astrology Interpretation of The ","elem":"The Element of","ascendant":"Ascendant","related":"Related Zodiacs","zodiac_of_the_year":"Zodiac of the Year","chinese_zodiac_signs":"Chinese Zodiac Signs","personality":"Personality","health":"Health","best_career":"The best careers","careers":"Career","lucky":"Lucky Things","unlucky":"Unlucky Things","numbers":"Numbers","colors":"Colors","directions":"Directions","best_match":"Best Match","worst_match":"Worst Match","login_title":"Subscribed to Mobiscope?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","login":"Login","logout":"Logout","status":"Inactive","mobile_computer":"Mobile and Computer","privacy":"Privacy Policy","terms":"Terms & Conditions","registered_num":"Registered Number","subscription_date":"Subscription Date","unsubscribe":"Unsubscribe","profile":"Profile","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","modal_title":"Cancel Subscription?"}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoskooppi","tarot":"Tarot","zodiac_signs":"Horoskooppi","chinese_zodiac":"Kiinalainen horoskooppi","zodiac_of_the_month":"Kuukauden horoskooppi","read_more":"Lue lisää","horoscopes":"Horoskoopit","yesterday":"Eilen","today":"Tänään","tomorrow":"Huomenna","week":"Viikko","month":"Kuukausi","year":"Vuosi","daily_horo":"päivän horoskooppi","tarot_cards":"Tarot-kortit","major":"Majuri Tarot","minor":"Pieni Tarot","wands":"Sauvat","cups":"Kupit","swords":"Miekat","pentacles":"Pentacles","description":"Kuvaus","meaning":"Tarkoitus","close":"kiinni","by_click":"Napsauttamalla horoskooppiasi näet täydellisen eläinradan profiilisi, elementin, johon kuulut, ja planeetat, jotka hallitsevat horoskooppiasi","element_signs":"Elementtimerkit","air":"Ilmaa","earth":"Maa","fire":"Antaa potkut","water":"Vesi","mental":"Henkiset piirteet","physical":"Fyysiset piirteet","favorites":"Suosikit","hates":"Vihaa","ruling_planet":"Hallitseva planeetta","compatibility":"Yhteensopivuus","element":"Elementti","color":"Väri","astrology":"Astrologian tulkinta ","elem":"Element of","ascendant":"Nouseva","related":"Liittyvät eläinradat","zodiac_of_the_year":"Vuoden horoskooppi","chinese_zodiac_signs":"Kiinan horoskoopit","personality":"Persoonallisuus","health":"Terveys","best_career":"Paras ura","careers":"Ura","lucky":"Lucky Things","unlucky":"Epäonniset asiat","numbers":"Numerot","colors":"Värit","directions":"Directions","best_match":"Paras ottelu","worst_match":"Pahin ottelu","login_title":"Tilattu Mobiscope?","confirmation":"Vahvista sitten matkapuhelinnumerosi ja saat rajoittamattoman pääsyn kaikkiin palveluihimme!","submit":"Lähetä","valid_number":"Lisää kelvollinen numero!","login":"Kirjaudu sisään","logout":"Kirjautua ulos","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","privacy":"Tietosuojakäytäntö","registered_num":"Rekisteröity numero","subscription_date":"Tilauspäivä","unsubscribe":"Lopeta tilaus","profile":"Profiili"}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Ωροσκόπιο","tarot":"Ταρώ","zodiac_signs":"Ζώδια","chinese_zodiac":"Κινέζικο ζώδιο","zodiac_of_the_month":"Ζώδιο του Μήνα","read_more":"Διαβάστε Περισσότερα","horoscopes":"Ωροσκόπια","yesterday":"Εχθές","today":"Σήμερα","tomorrow":"Αύριο","week":"Εβδομάδα","month":"Μήνας","year":"Ετος","daily_horo":"Ημερήσιο Ωροσκόπιο","tarot_cards":"Κάρτες Ταρώ","major":"Μεγάλο Ταρώ","minor":"Μικρό Ταρώ","wands":"Ράβδοι","cups":"Κύπελλα","swords":"Ξίφη","pentacles":"Πεντάλφα","description":"Περιγραφή","meaning":"Εννοια","close":"Κλείσιμο","by_click":"Κάνοντας κλικ στο ζώδιο σας, μπορείτε να δείτε ολόκληρο το ζωδιακό σας προφίλ το στοιχείο στο οποίο ανήκετε και τους πλανήτες που κυβερνούν το ζώδιο σας","element_signs":"Σημεία των Στοιχείων","air":"Αέρας","earth":"Γη","fire":"Φωτιά","water":"Νερό","mental":"Ψυχικά Χαρακτηριστικά","physical":"Φυσικά χαρακτηριστικά","favorites":"Αγαπημένα","hates":"Αρνητικά","ruling_planet":"Κυρίαρχος Πλανήτης","compatibility":"Συμβατότητα","element":"Στοιχείο","color":"Χρώμα","astrology":"Αστρολογική Ερμηνεία του ","elem":"Το Στοιχείο του ","ascendant":"Κυρίαρχο","related":"Σχετικά Ζώδια","zodiac_of_the_year":"Ζώδιο της Χρονιάς","chinese_zodiac_signs":"Κινέζικα Ζωδιακά Σημεία","personality":"Προσωπικότητα","health":"Υγεία","best_career":"Οι καλύτερες σταδιοδρομίες","careers":"Καριέρα","lucky":"Τυχερά Πράγματα","unlucky":"Ατυχή πράγματα","numbers":"Αριθμοί","colors":"Χρωματιστά","directions":"Κατευθύνσεις","best_match":"Καλύτερο ταίριασμα","worst_match":"Χειρότερο ταίριασμα","login_title":"Εγγραφήκατε στο Mobiscope?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","login":"Σύνδεση","logout":"Αποσύνδεση","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","unsub_confirmation":"Είστε βέβαιοι ότι θέλετε να καταργήσετε την εγγραφή σας;","yes":"Ναί","no":"Οχι","modal_title":"Ακύρωση συνδρομής;"}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoskop","tarot":"Tarot","zodiac_signs":"Simbol Zodiak","chinese_zodiac":"Zodiak Cina","zodiac_of_the_month":"Zodiak Bulan Ini","read_more":"Baca Lebih Lanjut","horoscopes":"Horoskop","yesterday":"Semalam","today":"Hari ini","tomorrow":"Esok","week":"Minggu","month":"Bulan","year":"Tahun","daily_horo":"Rutin Horoskop","tarot_cards":"Tarot Kad","major":"Major Tarot","minor":"Minor Tarot","wands":"Wands","cups":"Cups","swords":"Swords","pentacles":"Pentacles","description":"Penerangan ","meaning":"Maksud","close":"Tutup","by_click":"Dengan mengklik tanda zodiak anda, anda dapat melihat profil zodiak lengkap anda elemen yang anda milik dan planet yang memerintah tanda zodiak anda","element_signs":"Tanda-tanda Unsur","air":"Udara","earth":"Bumi","fire":"Api","water":"Air","mental":"Ciri-ciri Mental","physical":"Ciri-ciri Fizikal","favorites":"Kegemaran","hates":"Benci","ruling_planet":"Ruling Planet","compatibility":"Keserasian","element":"Unsur","color":"Warna","astrology":"Tafsiran Astrologi ","elem":"Elemen daripada ","ascendant":"Ascendant","related":"Zodiak Berkaitan","zodiac_of_the_year":"Zodiak Tahunan","chinese_zodiac_signs":"Tanda Zodiak Cina","personality":"Keperibadian","health":"Kesihatan","best_career":"Kerjaya Terbaik","careers":"Kerjaya","lucky":"Bertuah","unlucky":"Tidak Bertuah","numbers":"Nombor","colors":"Warna","directions":"Arah","best_match":"Sepadan","worst_match":"Tidak sepadan","login_title":"Melanggan Mobiscope?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had kepada semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","login":"Log Masuk","logout":"Log Keluar","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer"}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoskoper","tarot":"Tarot","zodiac_signs":"Stjernetegn","chinese_zodiac":"Kinesisk dyrekrets","zodiac_of_the_month":"Månedens dyrekrets","read_more":"Les mer","horoscopes":"Horoskoper","yesterday":"I går","today":"I dag","tomorrow":"I morgen","week":"Uke","month":"Måned","year":"År","daily_horo":"daglig horoskop","tarot_cards":"Tarotkort","major":"Major Tarot","minor":"Mindre Tarot","wands":"Tryllestave","cups":"Kopper","swords":"Sverd","pentacles":"Pentakler","description":"Beskrivelse","meaning":"Betydning","close":"Lukk","by_click":"Ved å klikke på dyrekretsen din kan du se hele dyrekretsen din, elementet du tilhører og planetene som styrer dyrekretsen.","element_signs":"Elementskilt","air":"Luft","earth":"Jord","fire":"Brann","water":"Vann","mental":"Psykiske trekk","physical":"Fysiske trekk","favorites":"Favoritter","hates":"Hater","ruling_planet":"Herskende planet","compatibility":"Kompatibilitet","element":"Element","color":"Farge","astrology":"Astrologi Tolkning av The ","elem":"Elementet av","ascendant":"oppstigende","related":"Relaterte dyrekretser","zodiac_of_the_year":"Årets dyrekrets","chinese_zodiac_signs":"Kinesiske stjernetegn","personality":"Personlighet","health":"Helse","best_career":"The best careers","careers":"Karrierer","lucky":"Heldige ting","unlucky":"Uheldige ting","numbers":"Tall","colors":"Farger","directions":"Veibeskrivelse","best_match":"Beste kamp","worst_match":"Verste kamp","login_title":"Abonnert på Mobiscope?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"Sende inn","valid_number":"Vennligst sett inn gyldig nummer!","login":"Logg Inn","logout":"Logg ut","status":"Inaktiv","mobile_computer":"mobil og datamaskin","privacy":"Personvernregler"}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoscop","tarot":"Tarot","zodiac_signs":"Semne zodiacale","chinese_zodiac":"Zodiac chinezesc","zodiac_of_the_month":"Zodiacul lunii","read_more":"Citeste mai mult","horoscopes":"Horoscop","yesterday":"Ieri","today":"Azi","tomorrow":"Mâine","week":"Săptămână","month":"Lună","year":"An","daily_horo":"Horoscop zilnic","tarot_cards":"Cărți de tarot","major":"Tarot major","minor":"Tarot Minor","wands":"Baghete","cups":"Cupe","swords":"Swords","pentacles":"Pentacolele","description":"Descriere","meaning":"Sens","close":"Închide","by_click":"Făcând clic pe semnul dvs. zodiacal puteți vedea profilul complet al zodiei, elementul de care aparțineți și planetele care vă conduc zodia","element_signs":"Semne de element","air":"Aer","earth":"Pământ","fire":"Foc","water":"Apă","mental":"Trăsături mentale","physical":"Trăsături fizice","favorites":"Favorite","hates":"Urăște","ruling_planet":"Planeta conducătoare","compatibility":"Compatibilitate","element":"Element","color":"Culoare","astrology":"Interpretarea astrologică a ","elem":"Elementul","ascendant":"Ascendent","related":"Zodiacele înrudite","zodiac_of_the_year":"Zodiacul anului","chinese_zodiac_signs":"Zodia chinezeascăs","personality":"Personalitate","health":"Sănătate","best_career":"Cele mai bune cariere","careers":"Carieră","lucky":"Lucruri norocoase","unlucky":"Lucruri ghinioniste","numbers":"Numere","colors":"Culori","directions":"Directii","best_match":"Cea mai buna potrivire","worst_match":"Cel mai prost meci","login_title":"Abonat la Mobiscope?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","login":"Autentificare","logout":"Deconectați-vă","status":"Inactiv","mobile_computer":"Mobile și computer","privacy":"Politica de Confidențialitate","registered_num":"Număr înregistrat","subscription_date":"Data abonamentului","unsubscribe":"Dezabonați-vă","profile":"Profil"}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoskop","tarot":"Tarot","zodiac_signs":"Znamenia zverokruhu","chinese_zodiac":"Zodiak Cina","zodiac_of_the_month":"Zverokruh mesiaca","read_more":"Čítaj viac","horoscopes":"Horoskopy","yesterday":"Včera","today":"Dnes","tomorrow":"Zajtra","week":"Týždeň","month":"Mesiac","year":"Rok","daily_horo":"Denný horoskop","tarot_cards":"Tarotové karty","major":"Major Tarot","minor":"Malý tarot","wands":"Prútiky","cups":"Poháre","swords":"Meče","pentacles":"Pentagramy","description":"Popis","meaning":"Význam","close":"Zavrieť","by_click":"Kliknutím na svoje znamenie zverokruhu môžete vidieť svoj úplný profil zverokruhu, prvok, ku ktorému patríte, a planéty, ktoré vládnu vášmu znameniu zverokruhu.","element_signs":"Znaky prvkov","air":"Vzduch","earth":"Zem","fire":"Oheň","water":"Voda","mental":"Mentálne vlastnosti","physical":"Fyzické vlastnosti","favorites":"Obľúbené","hates":"Neznáša","ruling_planet":"Vládnuca planéta","compatibility":"Kompatibilita","element":"Prvok","color":"Farba","astrology":"Výklad astrológie ","elem":"Prvok z","ascendant":"Predchodca","related":"Súvisiace zverokruhy","zodiac_of_the_year":"Zverokruh roka","chinese_zodiac_signs":"Znamenia čínskeho zverokruhu","personality":"Osobnosť","health":"Zdravie","best_career":"Najlepšie kariéry","careers":"Kariéra","lucky":"Šťastné veci","unlucky":"Smola","numbers":"Čísla","colors":"Farby","directions":"Smery","best_match":"Najlepší zápas","worst_match":"Najhorší zápas","login_title":"Prihlásili ste sa na odber Mobiscope?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","login":"Prihlásiť sa","logout":"Odhlásiť sa","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","registered_num":"Registračné číslo","subscription_date":"Dátum predplatného","unsubscribe":"Odhlásiť sa","profile":"Profil"}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"Horoskop","tarot":"Tarot","zodiac_signs":"Stjärnteckens","chinese_zodiac":"Kinesiskt stjärntecken","zodiac_of_the_month":"Månadens zodiak","read_more":"Läs mer","horoscopes":"Horoskop","yesterday":"I går","today":"I dag","tomorrow":"I morgon","week":"Vecka","month":"Månad","year":"År","daily_horo":"Dagligt Horoskop","tarot_cards":"Tarotkort","major":"Major Tarot","minor":"Mindre Tarot","wands":"Trollstavar","cups":"Koppar","swords":"Svärd","pentacles":"Pentacles","description":"Beskrivning","meaning":"Menande","close":"Stänga","by_click":"Genom att klicka på ditt stjärntecken kan du se din fullständiga zodiakprofil, det element du tillhör och planeterna som styr ditt stjärntecken","element_signs":"Element tecken","air":"Luft","earth":"Jorden","fire":"Brand","water":"Vatten","mental":"Mentala drag","physical":"Fysiska egenskaper","favorites":"Favoriter","hates":"Hatar","ruling_planet":"Härskande planet","compatibility":"Kompatibilitet","element":"Element","color":"Färg","astrology":"Astrologi Tolkning av ","elem":"Elementet av","ascendant":"Uppstigande","related":"Relaterade stjärntecken","zodiac_of_the_year":"Årets stjärntecken","chinese_zodiac_signs":"Kinesiska stjärntecken","personality":"Personlighet","health":"Hälsa","best_career":"De bästa karriärerna","careers":"Karriär","lucky":"Lucky Things","unlucky":"Olyckliga saker","numbers":"Tal","colors":"Färger","directions":"Vägbeskrivning","best_match":"Bästa matchningen","worst_match":"Värsta match","login_title":"Prenumerera på Mobiscope?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","login":"Logga in","logout":"Logga ut","status":"Inaktiv","mobile_computer":"Mobil och beräknar","privacy":"Integritetspolicy","registered_num":"Registrerat nummer","subscription_date":"Prenumerationsdatum","unsubscribe":"Säga upp","profile":"Profil"}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = {"horoscope":"ดูดวง","tarot":"ไพ่ทาโร่ต์","zodiac_signs":"จักราศี","chinese_zodiac":"นักษัตรจีน","zodiac_of_the_month":"ราศีประจำเดือน","read_more":"อ่านต่อ","horoscopes":"ดูดวง","yesterday":"เมื่อวาน","today":"วันนี้","tomorrow":"พรุ่งนี้","week":"สัปดาห์","month":"เดือน","year":"ปี","daily_horo":"ดูดวงรายวัน","tarot_cards":"ไพ่ทาโร่ต์","major":"ไพ่ทาโร่ต์ชุดใหญ่","minor":"ไพ่ทาไร่ต์ชุดเล็ก","wands":"ไม้กายสิทธิ์","cups":"จอก","swords":"ดาบ","pentacles":"เพนทาเคิล","description":"คำอธิบาย ","meaning":"ความหมาย","close":"ปิด","by_click":"คลิกที่สัญลักษณ์จักราศีของคุณเพื่อดูธาตุของคุณและดูดวงดาวประจำราศีของคุณ","element_signs":"สัญลักษณ์ธาตุ","air":"ลม","earth":"ดิน","fire":"ไฟ","water":"น้ำ","mental":"ลักษณะจิตใจ","physical":"ลักษณะร่างกาย","favorites":"รายการโปรด","hates":"สิ่งที่ไม่ชอบ","ruling_planet":"สิ่งที่ไม่ชอบ","compatibility":"เข้ากันได้","element":"ธาตุ","color":"สี","astrology":"ดูโหราศาสตร์ของ ","elem":"ธาตุของ ","ascendant":"อิทธิพล","related":"จักราศีที่เกี่ยวข้อง","zodiac_of_the_year":"จักราศีประจำปี","chinese_zodiac_signs":"นักษัตรจีน","personality":"ลักษณะนิสัย","health":"สุขภาพ","best_career":"การงาน","careers":"การงาน","lucky":"ของมงคล","unlucky":"ของอัปมงคล","numbers":"ตัวเลข","colors":"สี","directions":"ทิศทาง","best_match":"ของคู่กัน","worst_match":"ของต้องห้ามคู่กัน","login_title":"ดูดวงบนมือถือไหม?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"หมายเลขถูกต้อง","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์"}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aztro_js__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aztro_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aztro_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobiscope_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__horoscope_sign_json__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__horoscope_sign_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__horoscope_sign_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "https://cors-anywhere.herokuapp.com/";
var months = ["January", "February", "March", "April", "May", "Jun", "July", "August", "September", "October", "November", "December"];
var DB_API = 'http://cook.grabmobi.com/api/contents/mobiscope_content?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6';
var TJO = __webpack_require__(84)();
var currentDate = new Date();
var year = currentDate.getFullYear();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: {},
      data_desc: {},
      currentDateTranslate: "",
      date_current: [],
      sign: this.$route.params.sign,
      loading: true,
      image: "",
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      horoscopeSlider: {}
    };
  },

  props: ["loadingPage"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["language", "translateCode", "secondLang"]),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.getHorosign();
    this.getImage(this.sign);
    this.getHoroscopeDetails(this.sign);
  },
  updated: function updated() {
    if (this.$route.params.sign != this.sign) {
      this.loading = true;
      this.getHorosign();
      this.getImage(this.$route.params.sign);
      this.getHoroscopeDetails(this.$route.params.sign);

      this.sign = this.$route.params.sign;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var sliderStatus = false;
    var width = window.innerWidth;

    window.addEventListener("resize", function () {
      var width = window.innerWidth;
      if (width <= 991 && !sliderStatus) {
        _this.horoscopeSlider = new __WEBPACK_IMPORTED_MODULE_3_flickity___default.a(_this.$refs.mobileCarousel, _this.flickityOptions);
        _this.horoscopeSlider.resize();
        sliderStatus = true;
      } else if (width >= 991 && sliderStatus) {
        _this.horoscopeSlider.destroy();
        sliderStatus = false;
      }
    });
  },


  methods: {
    intiMobileSlider: function intiMobileSlider(slideIndex) {
      var _this2 = this;

      this.flickityOptions.initialIndex = slideIndex;
      var width = window.innerWidth;
      if (width <= 991) {
        setTimeout(function () {
          _this2.horoscopeSlider = new __WEBPACK_IMPORTED_MODULE_3_flickity___default.a(_this2.$refs.mobileCarousel, _this2.flickityOptions);
          _this2.horoscopeSlider.select(slideIndex);
          _this2.horoscopeSlider.on("staticClick", function (event, pointer, cellElement, cellIndex) {
            _this2.horoscopeSlider.select(cellIndex);
          });
          _this2.horoscopeSlider.on("settle", function (event, index) {
            var sign = document.getElementsByClassName("is-selected")[0].innerText;
            __WEBPACK_IMPORTED_MODULE_5__router_mobiscope_js__["a" /* default */].push({ name: 'HoroscopeDetails', params: { sign: sign } }).catch(function (err) {});
            // this.getSun(document.getElementsByClassName("is-selected")[0].innerText);
          });
        }, 0);
      }
    },
    getHorosign: function getHorosign() {
      var _this3 = this;

      var sign = this.$route.params.sign;
      var si = sign.replace(/^./, sign[0].toUpperCase());
      __WEBPACK_IMPORTED_MODULE_6__horoscope_sign_json___default.a.horoscope.map(function (item) {
        item.icon = __webpack_require__(120)("./" + item.name + ".svg");
      });
      this.data = __WEBPACK_IMPORTED_MODULE_6__horoscope_sign_json___default.a.horoscope;
      this.data.map(function (item) {
        if (item.name == si) {
          var slideIndex = _this3.data.indexOf(item);
          _this3.intiMobileSlider(slideIndex);
        }
      });
    },
    getImage: function getImage(sign) {
      //get image for each horoscope
      var s = "";
      s = sign.replace(/^./, sign[0].toUpperCase());
      this.image = __webpack_require__(378)("./" + s + ".svg");
    },
    getHoroscopeDetails: function getHoroscopeDetails(sign) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mon, horo_date, curr_date, translate;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mon = currentDate.getUTCMonth() + 1;

                mon = '0' + mon;

                horo_date = year + "-" + mon + "-" + currentDate.getUTCDate();
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(DB_API + "&horoscope=" + sign + "&date=2021-06-24").then(function (res) {
                  _this4.data_desc = res.data.data[0].horoscope_description;
                  _this4.loading = false;
                });

              case 5:
                curr_date = months[currentDate.getUTCMonth()] + " " + currentDate.getUTCDate() + ", " + year;

                _this4.date_current['english'] = curr_date;

                if (_this4.secondLang != 'english') {
                  TJO.init({
                    googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04'
                    // yandexApiKey:
                    //   "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
                  });

                  translate = {
                    currentDateTranslate: curr_date
                  };


                  TJO.translate(translate, _this4.translateCode).then(function (data) {
                    _this4.date_current[_this4.secondLang] = data.currentDateTranslate;
                  });
                }
                //Get all horoscope i.e. today's, yesterday's and tomorrow's horoscope

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    getSun: function getSun(sign) {
      this.loading = false;
      //to change sign description without load page
      this.sign = sign;
      this.getImage(sign);
      this.getHoroscopeDetails(sign);
    }
  }
});

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports) {

module.exports = {"horoscope":[{"name":"Aquarius","date":"Jan 20 - Feb 18","icon":"Aquarius.svg"},{"name":"Pisces","date":"Feb 19 - Mar 20","icon":"Pisces.svg"},{"name":"Aries","date":"Mar 21 - Apr 19","icon":"Aries.svg"},{"name":"Taurus","date":"Apr 20 - May 20","icon":"Taurus.svg"},{"name":"Gemini","date":"May 21 - Jun 20","icon":"Gemini.svg"},{"name":"Cancer","date":"Jun 21 - Jul 22","icon":"Cancer.svg"},{"name":"Leo","date":"Jul 23 - Aug 22","icon":"Leo.svg"},{"name":"Virgo","date":"Aug 23 - Sep 22","icon":"Virgo.svg"},{"name":"Libra","date":"Sep 23 - Oct 22","icon":"Libra.svg"},{"name":"Scorpio","date":"Oct 23 - Nov 21","icon":"Scorpio.svg"},{"name":"Sagittarius","date":"Nov 22 - Dec 21","icon":"Sagittarius.svg"},{"name":"Capricorn","date":"Dec 22 - Jan 19","icon":"Capricorn.svg"}]}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Cancer.20e69b5.svg";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Capricorn.40e67ff.svg";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Scorpio.7e20eb2.svg";

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Virgo.e1cd4f6.svg";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Aquarius.svg": 1394,
	"./Aries.svg": 1395,
	"./Cancer.svg": 1396,
	"./Capricorn.svg": 1397,
	"./Gemini.svg": 1398,
	"./Leo.svg": 1399,
	"./Libra.svg": 1400,
	"./Pisces.svg": 1401,
	"./Sagittarius.svg": 1402,
	"./Scorpio.svg": 1403,
	"./Taurus.svg": 1404,
	"./Virgo.svg": 1405
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_json__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var proxyurl = "https://cors-anywhere.herokuapp.com/";
var URL = "https://zodiacal.herokuapp.com/";
var zUrl = "https://aztro.sameerkumar.website/?day=today&sign=";

var TJO = __webpack_require__(84)();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: {},
      zodiacs: {},
      zodiac: "",
      colors: __WEBPACK_IMPORTED_MODULE_3__colors_json___default.a,
      colorCode: "",
      color: "",
      colorTranslate: "",
      compatibility: "",
      compatibility_img: "",
      date: "",
      loading: true
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["language", "translateCode"]),
  mounted: function mounted() {
    this.getZodiacSign(this.$route.params.zodiac);
  },

  methods: {
    getZodiacSign: function getZodiacSign(name) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var zodiac, additional;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                zodiac = {
                  url: zUrl + name,
                  method: 'POST'
                };
                _context.next = 3;
                return _this.$axios(zodiac).then(function (res) {
                  console.log(res);
                  _this.loading = false;
                  // this.data = res.data;
                  _this.color = res.data.color;
                  _this.compatibility = res.data.compatibility;
                  _this.compatibility_img = __webpack_require__(120)("./" + res.data.compatibility + ".svg");
                  _this.date = res.data.date_range;
                }).catch(function (err) {
                  console.error(err);
                });

              case 3:
                //additional details
                additional = {
                  url: proxyurl + URL + name,
                  method: 'GET'
                };
                _context.next = 6;
                return _this.$axios(additional).then(function (res) {
                  _this.loading = false;
                  var zod = res.data[0];

                  var favo = [];
                  var fav = [];
                  var hate = [];
                  var hat = [];

                  //capitalizing the very first letter in each sentence

                  for (var i = 0; i < zod.favorites.length; i++) {
                    favo = zod.favorites[i].trim();
                    fav[i] = favo.replace(/^./, favo[0].toUpperCase());
                  }

                  //capitalizing the very first letter in each sentence
                  for (var _i = 0; _i < zod.hates.length; _i++) {
                    hate = zod.hates[_i].trim();
                    hat[_i] = hate.replace(/^./, hate[0].toUpperCase());
                  }
                  zod.favorites = fav;
                  zod.hates = hat;
                  zod.planet = zod.ruling_planet[0];
                  zod.planet_img = __webpack_require__(1409)("./" + zod.ruling_planet[0] + ".svg");
                  zod.icon = __webpack_require__(120)("./" + zod.name + ".svg");
                  zod.element_img = __webpack_require__(211)("./" + zod.element + ".svg");
                  zod.color = _this.color;
                  zod.colorCode = "<div class=\"circle\" style=\"background: " + _this.getColorCode(_this.color) + "\"></div>";
                  zod.compatibility = _this.compatibility;
                  zod.compatibility_img = _this.compatibility_img;
                  zod.date = _this.date;

                  var test = {};
                  var ar = [];
                  var gr = [];
                  var ms = [];

                  TJO.init({
                    // googleApiKey: 'AIzaSyBm4nfZjFUrt4A6MKWxHxCKIT3L4h8VPH8',
                    googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04'
                    // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
                  });

                  var desc = {
                    favTranslate: zod.favorites.join("/"),
                    hateTranslate: zod.hates.join("/"),
                    mentalTranslate: zod.mental_traits.join("/"),
                    physicalTranslate: zod.physical_traits.join("/"),
                    elemTranslate: zod.element,
                    rltranslate: zod.ruling_planet[0],
                    colorTranslate: zod.color
                  };

                  if (_this.translateCode != "") {
                    TJO.translate(desc, _this.translateCode).then(function (data) {
                      zod.favTranslate = data.favTranslate.split("/");
                      zod.hateTranslate = data.hateTranslate.split("/");
                      zod.mentalTranslate = data.mentalTranslate.split("/");
                      zod.physicalTranslate = data.physicalTranslate.split("/");
                      zod.elemTranslate = data.elemTranslate;
                      zod.rltranslate = data.rltranslate;
                      zod.colorTranslate = data.colorTranslate;
                      // console.log(data.yester) //example
                    });
                  }

                  setTimeout(function () {
                    _this.zodiacs = zod;
                  }, 2000);
                }).catch(function (err) {
                  console.error(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    load_page: function load_page() {
      location.reload();
    },
    getColorCode: function getColorCode(color) {
      var co = this.colors.colors;

      var found = co.find(function (element) {
        return element.name == color;
      });

      return found.hex;
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = {"colors":[{"name":"18th Century Green","hex":"#a59344","rgb":{"r":165,"g":147,"b":68},"luminance":99.69868228818272},{"name":"1975 Earth Red","hex":"#7b463b","rgb":{"r":123,"g":70,"b":59},"luminance":55.55335187907207},{"name":"20000 Leagues Under the Sea","hex":"#191970","rgb":{"r":25,"g":25,"b":112},"luminance":20.83873974116477},{"name":"400XT Film","hex":"#d2d2c0","rgb":{"r":210,"g":210,"b":192},"luminance":140.06127781796081},{"name":"5-Masted Preußen","hex":"#9bafad","rgb":{"r":155,"g":175,"b":173},"luminance":114.40822494034246},{"name":"8Bit Eggplant","hex":"#990066","rgb":{"r":153,"g":0,"b":102},"luminance":47.20167786212689},{"name":"90% Cocoa","hex":"#3d1c02","rgb":{"r":61,"g":28,"b":2},"luminance":24.55310980303717},{"name":"A Certain Shade Of Green","hex":"#d1edee","rgb":{"r":209,"g":237,"b":238},"luminance":154.90437910530483},{"name":"A Dime a Dozen","hex":"#d3dde4","rgb":{"r":211,"g":221,"b":228},"luminance":146.57728512290026},{"name":"A Hint of Incremental Blue","hex":"#456789","rgb":{"r":69,"g":103,"b":137},"luminance":65.76543625644096},{"name":"A Pair of Brown Eyes","hex":"#bfaf92","rgb":{"r":191,"g":175,"b":146},"luminance":118.70503882312663},{"name":"A State of Mint","hex":"#88ffcc","rgb":{"r":136,"g":255,"b":204},"luminance":156.8438766959042},{"name":"Aare River","hex":"#00b89f","rgb":{"r":0,"g":184,"b":159},"luminance":109.51840000657423},{"name":"Aare River Brienz","hex":"#05a3ad","rgb":{"r":5,"g":163,"b":173},"luminance":97.70386926831506},{"name":"Abaddon Black","hex":"#231f20","rgb":{"r":35,"g":31,"b":32},"luminance":21.30621829419759},{"name":"Abaidh White","hex":"#f2f1e6","rgb":{"r":242,"g":241,"b":230},"luminance":161.04682751609855},{"name":"Abalone","hex":"#f8f3f6","rgb":{"r":248,"g":243,"b":246},"luminance":163.19142110111056},{"name":"Abbey","hex":"#4c4f56","rgb":{"r":76,"g":79,"b":86},"luminance":52.563806188288915},{"name":"Abbey Road","hex":"#a79f92","rgb":{"r":167,"g":159,"b":146},"luminance":107.15118344656769},{"name":"Abbey Stone","hex":"#aba798","rgb":{"r":171,"g":167,"b":152},"luminance":111.91121063593226},{"name":"Abbey White","hex":"#ebe5d0","rgb":{"r":235,"g":229,"b":208},"luminance":153.52189452322426},{"name":"Abbot","hex":"#4d3c2d","rgb":{"r":77,"g":60,"b":45},"luminance":42.38895881004864},{"name":"Abduction","hex":"#166461","rgb":{"r":22,"g":100,"b":97},"luminance":60.09358907570756},{"name":"Âbi Blue","hex":"#5ba8ff","rgb":{"r":91,"g":168,"b":255},"luminance":106.3508816935713},{"name":"Abilene Lace","hex":"#eae3d2","rgb":{"r":234,"g":227,"b":210},"luminance":152.3931125641838},{"name":"Abomination","hex":"#77aa77","rgb":{"r":119,"g":170,"b":119},"luminance":106.80865141457409},{"name":"Abra Goldenrod","hex":"#eec400","rgb":{"r":238,"g":196,"b":0},"luminance":135.2811625763173},{"name":"Absence of Light","hex":"#15151c","rgb":{"r":21,"g":21,"b":28},"luminance":14.197522107748238},{"name":"Absinthe Green","hex":"#76b583","rgb":{"r":118,"g":181,"b":131},"luminance":112.94365360213915},{"name":"Absolute Apricot","hex":"#ff9944","rgb":{"r":255,"g":153,"b":68},"luminance":118.0652753776486},{"name":"Absolute Zero","hex":"#0048ba","rgb":{"r":0,"g":72,"b":186},"luminance":47.28483173280835},{"name":"Abstract White","hex":"#ede9dd","rgb":{"r":237,"g":233,"b":221},"luminance":156.08526146308625},{"name":"Abundance","hex":"#629763","rgb":{"r":98,"g":151,"b":99},"luminance":94.03456156647937},{"name":"Abura Green","hex":"#a19361","rgb":{"r":161,"g":147,"b":97},"luminance":99.42552089881148},{"name":"Abyss","hex":"#8f9e9d","rgb":{"r":143,"g":158,"b":157},"luminance":103.68374978269256},{"name":"Abyssal Anchorfish Blue","hex":"#1b2632","rgb":{"r":27,"g":38,"b":50},"luminance":24.39715075577474},{"name":"Abyssal Blue","hex":"#00035b","rgb":{"r":0,"g":3,"b":91},"luminance":10.522404525582544},{"name":"Abyssal Depths","hex":"#10246a","rgb":{"r":16,"g":36,"b":106},"luminance":24.808690735304832},{"name":"Abyssopelagic Water","hex":"#000033","rgb":{"r":0,"g":0,"b":51},"luminance":5.814},{"name":"Acacia","hex":"#dacd65","rgb":{"r":218,"g":205,"b":101},"luminance":137.3381867690119},{"name":"Academic Blue","hex":"#2c3e56","rgb":{"r":44,"g":62,"b":86},"luminance":39.921447719239836},{"name":"Acadia","hex":"#35312c","rgb":{"r":53,"g":49,"b":44},"luminance":33.220443013301306},{"name":"Acai","hex":"#46295a","rgb":{"r":70,"g":41,"b":90},"luminance":33.50452191869032},{"name":"Acai Berry","hex":"#42314b","rgb":{"r":66,"g":49,"b":75},"luminance":35.91439022174816},{"name":"Acai Juice","hex":"#942193","rgb":{"r":148,"g":33,"b":147},"luminance":51.13028172228273},{"name":"Acajou","hex":"#4c2f27","rgb":{"r":76,"g":47,"b":39},"luminance":36.01805121046945},{"name":"Acanthus","hex":"#9899a7","rgb":{"r":152,"g":153,"b":167},"luminance":102.44013797823585},{"name":"Acanthus Leaf","hex":"#90977a","rgb":{"r":144,"g":151,"b":122},"luminance":99.51768369993344},{"name":"Acapulco","hex":"#75aa94","rgb":{"r":117,"g":170,"b":148},"luminance":107.08183213318681},{"name":"Acapulco Cliffs","hex":"#4e9aa8","rgb":{"r":78,"g":154,"b":168},"luminance":95.30222028893135},{"name":"Accolade","hex":"#7c94b2","rgb":{"r":124,"g":148,"b":178},"luminance":96.61177162230283},{"name":"Accursed Black","hex":"#090807","rgb":{"r":9,"g":8,"b":7},"luminance":5.470895813301511},{"name":"Ace","hex":"#c7cce7","rgb":{"r":199,"g":204,"b":231},"luminance":136.2843793726926},{"name":"Aceto Balsamico","hex":"#4e4f48","rgb":{"r":78,"g":79,"b":72},"luminance":52.55227946530959},{"name":"Acid Candy","hex":"#a8c74d","rgb":{"r":168,"g":199,"b":77},"luminance":127.45816598790364},{"name":"Acid Green","hex":"#8ffe09","rgb":{"r":143,"g":254,"b":9},"luminance":155.11101614327717},{"name":"Acid Lime","hex":"#badf30","rgb":{"r":186,"g":223,"b":48},"luminance":142.33036071407952},{"name":"Acini di Pepe","hex":"#ffd8b1","rgb":{"r":255,"g":216,"b":177},"luminance":149.3206716198397},{"name":"Acorn","hex":"#7e5e52","rgb":{"r":126,"g":94,"b":82},"luminance":67.46352395183636},{"name":"Acorn Squash","hex":"#eda740","rgb":{"r":237,"g":167,"b":64},"luminance":121.17954128482249},{"name":"Acoustic White","hex":"#efece1","rgb":{"r":239,"g":236,"b":225},"luminance":157.9737701170672},{"name":"Across the Bay","hex":"#b3e1e8","rgb":{"r":179,"g":225,"b":232},"luminance":144.94067672672153},{"name":"Actinic Light","hex":"#ff44ee","rgb":{"r":255,"g":68,"b":238},"luminance":90.2370905171482},{"name":"Active Volcano","hex":"#bb1133","rgb":{"r":187,"g":17,"b":51},"luminance":57.09331489763053},{"name":"Actor's Star","hex":"#a7a6a3","rgb":{"r":167,"g":166,"b":163},"luminance":111.0564657145184},{"name":"Adana Kebabı","hex":"#661111","rgb":{"r":102,"g":17,"b":17},"luminance":32.147539392619144},{"name":"Adeline","hex":"#ccb0b5","rgb":{"r":204,"g":176,"b":181},"luminance":121.73595736675338},{"name":"Adept","hex":"#293947","rgb":{"r":41,"g":57,"b":71},"luminance":36.541765118833546},{"name":"Adeptus Battlegrey","hex":"#7c8286","rgb":{"r":124,"g":130,"b":134},"luminance":86.20442014189295},{"name":"Adhesion","hex":"#9e9cab","rgb":{"r":158,"g":156,"b":171},"luminance":104.86779192869466},{"name":"Adirondack","hex":"#b0b9c1","rgb":{"r":176,"g":185,"b":193},"luminance":122.66314607493156},{"name":"Admiral Blue","hex":"#50647f","rgb":{"r":80,"g":100,"b":127},"luminance":65.01898864178064},{"name":"Admiralty","hex":"#404e61","rgb":{"r":64,"g":78,"b":97},"luminance":50.84116104103052},{"name":"Adobe","hex":"#bd6c48","rgb":{"r":189,"g":108,"b":72},"luminance":85.32243081980259},{"name":"Adobe Avenue","hex":"#fb9587","rgb":{"r":251,"g":149,"b":135},"luminance":116.27115235517364},{"name":"Adobe Beige","hex":"#dcbfa6","rgb":{"r":220,"g":191,"b":166},"luminance":131.35961276206623},{"name":"Adobe Rose","hex":"#ba9f99","rgb":{"r":186,"g":159,"b":153},"luminance":110.03721756296821},{"name":"Adobe Sand","hex":"#e8dec5","rgb":{"r":232,"g":222,"b":197},"luminance":149.3252148299141},{"name":"Adobe South","hex":"#e5c1a7","rgb":{"r":229,"g":193,"b":167},"luminance":133.7369581155486},{"name":"Adobe White","hex":"#e6dbc4","rgb":{"r":230,"g":219,"b":196},"luminance":147.4938678216827},{"name":"Adorable","hex":"#e3beb0","rgb":{"r":227,"g":190,"b":176},"luminance":132.09182081037414},{"name":"Adriatic Blue","hex":"#5c899b","rgb":{"r":92,"g":137,"b":155},"luminance":86.81091247648534},{"name":"Adriatic Haze","hex":"#96c6cd","rgb":{"r":150,"g":198,"b":205},"luminance":126.75236674713415},{"name":"Adrift","hex":"#4b9099","rgb":{"r":75,"g":144,"b":153},"luminance":89.17447377472995},{"name":"Advantageous","hex":"#20726a","rgb":{"r":32,"g":114,"b":106},"luminance":68.67014201237681},{"name":"Adventure","hex":"#34788c","rgb":{"r":52,"g":120,"b":140},"luminance":73.88000747157515},{"name":"Adventure Island Pink","hex":"#f87858","rgb":{"r":248,"g":120,"b":88},"luminance":102.76650100105579},{"name":"Adventure Isle","hex":"#6f9fb9","rgb":{"r":111,"g":159,"b":185},"luminance":101.27855997199012},{"name":"Aegean Blue","hex":"#4e6e81","rgb":{"r":78,"g":110,"b":129},"luminance":70.21016322442213},{"name":"Aegean Green","hex":"#4c8c72","rgb":{"r":76,"g":140,"b":114},"luminance":86.24864400093487},{"name":"Aegean Mist","hex":"#9cbbe2","rgb":{"r":156,"g":187,"b":226},"luminance":122.01917797215322},{"name":"Aegean Sea","hex":"#508fa2","rgb":{"r":80,"g":143,"b":162},"luminance":89.21504864651477},{"name":"Aegean Sky","hex":"#e48b59","rgb":{"r":228,"g":139,"b":89},"luminance":106.80721206454179},{"name":"Aero","hex":"#7cb9e8","rgb":{"r":124,"g":185,"b":232},"luminance":117.75822903304889},{"name":"Aero Blue","hex":"#c0e8d5","rgb":{"r":192,"g":232,"b":213},"luminance":149.77107812925698},{"name":"Aerobic Fix","hex":"#a2c348","rgb":{"r":162,"g":195,"b":72},"luminance":124.56262414143336},{"name":"Aeronautic","hex":"#2b3448","rgb":{"r":43,"g":52,"b":72},"luminance":34.123134220056635},{"name":"Aerospace Orange","hex":"#ff4f00","rgb":{"r":255,"g":79,"b":0},"luminance":89.23987423792124},{"name":"Aerostatics","hex":"#355376","rgb":{"r":53,"g":83,"b":118},"luminance":52.96998729469358},{"name":"Affair","hex":"#745085","rgb":{"r":116,"g":80,"b":133},"luminance":60.31672819376064},{"name":"Affen Turquoise","hex":"#aaffff","rgb":{"r":170,"g":255,"b":255},"luminance":160.73068476491974},{"name":"Affinity","hex":"#fed2a5","rgb":{"r":254,"g":210,"b":165},"luminance":146.00378048530112},{"name":"Afghan Carpet","hex":"#905e26","rgb":{"r":144,"g":94,"b":38},"luminance":70.12272844092705},{"name":"Afghan Hound","hex":"#e2d7b5","rgb":{"r":226,"g":215,"b":181},"luminance":144.63647346710303},{"name":"Afghan Sand","hex":"#d3a95c","rgb":{"r":211,"g":169,"b":92},"luminance":118.03158591665198},{"name":"Afloat","hex":"#78a3c2","rgb":{"r":120,"g":163,"b":194},"luminance":104.55307559799472},{"name":"African Ambush","hex":"#8e603c","rgb":{"r":142,"g":96,"b":60},"luminance":70.88734208587596},{"name":"African Bubinga","hex":"#c7927a","rgb":{"r":199,"g":146,"b":122},"luminance":105.25509141604503},{"name":"African Mahogany","hex":"#cd4a4a","rgb":{"r":205,"g":74,"b":74},"luminance":75.59830001395534},{"name":"African Mud","hex":"#826c68","rgb":{"r":130,"g":108,"b":104},"luminance":75.3026855563598},{"name":"African Safari","hex":"#b16b40","rgb":{"r":177,"g":107,"b":64},"luminance":82.45632799245912},{"name":"African Sand","hex":"#ccaa88","rgb":{"r":204,"g":170,"b":136},"luminance":117.97851555262083},{"name":"African Violet","hex":"#b085b7","rgb":{"r":176,"g":133,"b":183},"luminance":96.43437904087939},{"name":"After Burn","hex":"#fd8b60","rgb":{"r":253,"g":139,"b":96},"luminance":111.80186668387964},{"name":"After Dark","hex":"#3c3535","rgb":{"r":60,"g":53,"b":53},"luminance":36.417628766848615},{"name":"After Dinner Mint","hex":"#e3f5e5","rgb":{"r":227,"g":245,"b":229},"luminance":161.15527167921005},{"name":"After Eight Filling","hex":"#d6eae8","rgb":{"r":214,"g":234,"b":232},"luminance":153.82108133802728},{"name":"After Midnight","hex":"#38393f","rgb":{"r":56,"g":57,"b":63},"luminance":38.09786530765208},{"name":"After Shock","hex":"#fec65f","rgb":{"r":254,"g":198,"b":95},"luminance":139.260787345182},{"name":"After the Storm","hex":"#33616a","rgb":{"r":51,"g":97,"b":106},"luminance":60.17146149130832},{"name":"After Work Blue","hex":"#24246d","rgb":{"r":36,"g":36,"b":109},"luminance":26.77369223697023},{"name":"After-Party Pink","hex":"#c95efb","rgb":{"r":201,"g":94,"b":251},"luminance":86.45960028244404},{"name":"Aftercare","hex":"#85c0cd","rgb":{"r":133,"g":192,"b":205},"luminance":121.7775135441679},{"name":"Afterglow","hex":"#f3e6c9","rgb":{"r":243,"g":230,"b":201},"luminance":155.02190537146677},{"name":"Afterlife","hex":"#d91fff","rgb":{"r":217,"g":31,"b":255},"luminance":73.3893684262237},{"name":"Afternoon Sky","hex":"#87ceeb","rgb":{"r":135,"g":206,"b":235},"luminance":130.26575685497704},{"name":"Afternoon Stroll","hex":"#d9c5a1","rgb":{"r":217,"g":197,"b":161},"luminance":133.8620608163493},{"name":"Afternoon Tea","hex":"#594e40","rgb":{"r":89,"g":78,"b":64},"luminance":53.45778458746677},{"name":"Agate Green","hex":"#599f99","rgb":{"r":89,"g":159,"b":153},"luminance":98.6073910718664},{"name":"Agate Grey","hex":"#b1b09f","rgb":{"r":177,"g":176,"b":159},"luminance":117.4851699109296},{"name":"Agave Green","hex":"#6b7169","rgb":{"r":107,"g":113,"b":105},"luminance":74.60988212026608},{"name":"Aged Brandy","hex":"#87413f","rgb":{"r":135,"g":65,"b":63},"luminance":56.00641368629132},{"name":"Aged Chocolate","hex":"#5f4947","rgb":{"r":95,"g":73,"b":71},"luminance":52.04387631604702},{"name":"Aged Cotton","hex":"#e0dcda","rgb":{"r":224,"g":220,"b":218},"luminance":147.58233661248215},{"name":"Aged Eucalyptus","hex":"#898253","rgb":{"r":137,"g":130,"b":83},"luminance":87.12469749158387},{"name":"Aged Gouda","hex":"#dd9944","rgb":{"r":221,"g":153,"b":68},"luminance":111.77004726669843},{"name":"Aged Jade","hex":"#6c6956","rgb":{"r":108,"g":105,"b":86},"luminance":70.26923156688139},{"name":"Aged Merlot","hex":"#73343a","rgb":{"r":115,"g":52,"b":58},"luminance":46.451709817831244},{"name":"Aged Mustard Green","hex":"#6e6e30","rgb":{"r":110,"g":110,"b":48},"luminance":72.67035010236292},{"name":"Aged Pewter","hex":"#889999","rgb":{"r":136,"g":153,"b":153},"luminance":100.11892918424566},{"name":"Aged Pink","hex":"#c99f99","rgb":{"r":201,"g":159,"b":153},"luminance":112.37064587337744},{"name":"Aged Plastic Casing","hex":"#fffa86","rgb":{"r":255,"g":250,"b":134},"luminance":166.07895321502963},{"name":"Aged Purple","hex":"#a442a0","rgb":{"r":164,"g":66,"b":160},"luminance":65.10122471966254},{"name":"Aged Teak","hex":"#7a4134","rgb":{"r":122,"g":65,"b":52},"luminance":53.118637906105995},{"name":"Aged Whisky","hex":"#9d7147","rgb":{"r":157,"g":113,"b":71},"luminance":81.66369845898481},{"name":"Ageless","hex":"#ececdf","rgb":{"r":236,"g":236,"b":223},"luminance":157.53307971343668},{"name":"Ageless Beauty","hex":"#e7a995","rgb":{"r":231,"g":169,"b":149},"luminance":122.06672833331776},{"name":"Aggressive Baby Blue","hex":"#6fffff","rgb":{"r":111,"g":255,"b":255},"luminance":156.05183063969483},{"name":"Aggressive Salmon","hex":"#ff7799","rgb":{"r":255,"g":119,"b":153},"luminance":104.8664150145317},{"name":"Agrax Earthshade","hex":"#393121","rgb":{"r":57,"g":49,"b":33},"luminance":33.64411779197071},{"name":"Agrellan Badland","hex":"#ffb347","rgb":{"r":255,"g":179,"b":71},"luminance":130.0736260354112},{"name":"Agrellan Earth","hex":"#a17c59","rgb":{"r":161,"g":124,"b":89},"luminance":87.85441127797738},{"name":"Agrodolce","hex":"#f0e2d3","rgb":{"r":240,"g":226,"b":211},"luminance":152.73276910997194},{"name":"Ahaetulla Prasina","hex":"#00fa92","rgb":{"r":0,"g":250,"b":146},"luminance":147.69084343993705},{"name":"Ahmar Red","hex":"#c22147","rgb":{"r":194,"g":33,"b":71},"luminance":61.688285054781666},{"name":"Ahoy","hex":"#2a3149","rgb":{"r":42,"g":49,"b":73},"luminance":32.469512115213554},{"name":"Ahriman Blue","hex":"#199ebd","rgb":{"r":25,"g":158,"b":189},"luminance":95.5087758114405},{"name":"Ai Indigo","hex":"#274447","rgb":{"r":39,"g":68,"b":71},"luminance":42.36482990642119},{"name":"Aida","hex":"#b4c8b6","rgb":{"r":180,"g":200,"b":182},"luminance":130.80455612859973},{"name":"Aijiro White","hex":"#ecf7f7","rgb":{"r":236,"g":247,"b":247},"luminance":163.68861041929583},{"name":"Aimiru Brown","hex":"#2e372e","rgb":{"r":46,"g":55,"b":46},"luminance":35.482295261158065},{"name":"Air Blue","hex":"#77acc7","rgb":{"r":119,"g":172,"b":199},"luminance":109.42756258365623},{"name":"Air Force Blue","hex":"#5d8aa8","rgb":{"r":93,"g":138,"b":168},"luminance":87.76104140790491},{"name":"Air of Mint","hex":"#d8f2ee","rgb":{"r":216,"g":242,"b":238},"luminance":158.38742815009024},{"name":"Air Superiority Blue","hex":"#72a0c1","rgb":{"r":114,"g":160,"b":193},"luminance":102.30791660472808},{"name":"Airborne","hex":"#a2c2d0","rgb":{"r":162,"g":194,"b":208},"luminance":126.00276850926728},{"name":"Aircraft Blue","hex":"#354f58","rgb":{"r":53,"g":79,"b":88},"luminance":50.022230677969574},{"name":"Aircraft Exterior Grey","hex":"#939498","rgb":{"r":147,"g":148,"b":152},"luminance":98.89168402348095},{"name":"Aircraft Green","hex":"#2a2c1f","rgb":{"r":42,"g":44,"b":31},"luminance":28.935758224038295},{"name":"Aircraft White","hex":"#edf2f8","rgb":{"r":237,"g":242,"b":248},"luminance":161.24580512062943},{"name":"Airflow","hex":"#d9e5e4","rgb":{"r":217,"g":229,"b":228},"luminance":151.50884687700582},{"name":"Airforce","hex":"#364d70","rgb":{"r":54,"g":77,"b":112},"luminance":49.665528699491354},{"name":"Airy","hex":"#dae6e9","rgb":{"r":218,"g":230,"b":233},"luminance":152.2561429565323},{"name":"Airy Blue","hex":"#88ccee","rgb":{"r":136,"g":204,"b":238},"luminance":129.34175591818754},{"name":"Ajo Lily","hex":"#faecd9","rgb":{"r":250,"g":236,"b":217},"luminance":159.34442622194226},{"name":"Akabeni","hex":"#c3272b","rgb":{"r":195,"g":39,"b":43},"luminance":62.829866130686604},{"name":"Akai Red","hex":"#bc012e","rgb":{"r":188,"g":1,"b":46},"luminance":56.45912724263455},{"name":"Akakō Red","hex":"#f07f5e","rgb":{"r":240,"g":127,"b":94},"luminance":104.02828296670093},{"name":"Akaroa","hex":"#beb29a","rgb":{"r":190,"g":178,"b":154},"luminance":120.22027047049926},{"name":"Ake Blood","hex":"#cf3a24","rgb":{"r":207,"g":58,"b":36},"luminance":70.7581541661454},{"name":"Akebi Purple","hex":"#983fb2","rgb":{"r":152,"g":63,"b":178},"luminance":62.0070990209992},{"name":"Akebono Dawn","hex":"#fa7b62","rgb":{"r":250,"g":123,"b":98},"luminance":104.52444922122287},{"name":"Akhdhar Green","hex":"#b0e313","rgb":{"r":176,"g":227,"b":19},"luminance":143.28039968188253},{"name":"Akihabara Arcade","hex":"#601ef9","rgb":{"r":96,"g":30,"b":249},"luminance":44.04312332248929},{"name":"Akira Red","hex":"#e12120","rgb":{"r":225,"g":33,"b":32},"luminance":70.10327503048627},{"name":"Akuma's Fury","hex":"#871646","rgb":{"r":135,"g":22,"b":70},"luminance":43.12522488057308},{"name":"Alabama Crimson","hex":"#a32638","rgb":{"r":163,"g":38,"b":56},"luminance":53.97784972560503},{"name":"Alabaster","hex":"#f3e7db","rgb":{"r":243,"g":231,"b":219},"luminance":155.84892432737544},{"name":"Alabaster Beauty","hex":"#e9e3d2","rgb":{"r":233,"g":227,"b":210},"luminance":152.25606881172257},{"name":"Alabaster Gleam","hex":"#f0debd","rgb":{"r":240,"g":222,"b":189},"luminance":150.31788420543975},{"name":"Aladdin's Feather","hex":"#5500ff","rgb":{"r":85,"g":0,"b":255},"luminance":38.61330243581867},{"name":"Alaitoc Blue","hex":"#8e8c97","rgb":{"r":142,"g":140,"b":151},"luminance":94.08802240455476},{"name":"Alajuela Toad","hex":"#ffae52","rgb":{"r":255,"g":174,"b":82},"luminance":127.80006327463222},{"name":"Alameda Ochre","hex":"#ca9234","rgb":{"r":202,"g":146,"b":52},"luminance":105.0137723920058},{"name":"Alaskan Blue","hex":"#6da9d2","rgb":{"r":109,"g":169,"b":210},"luminance":107.1285773731734},{"name":"Alaskan Cruise","hex":"#34466c","rgb":{"r":52,"g":70,"b":108},"luminance":45.62580134090797},{"name":"Alaskan Ice","hex":"#7e9ec2","rgb":{"r":126,"g":158,"b":194},"luminance":102.51959933593186},{"name":"Alaskan Mist","hex":"#ecf0e5","rgb":{"r":236,"g":240,"b":229},"luminance":159.71216525988243},{"name":"Alaskan Moss","hex":"#05472a","rgb":{"r":5,"g":71,"b":42},"luminance":41.97775956384523},{"name":"Alaskan Skies","hex":"#cddced","rgb":{"r":205,"g":220,"b":237},"luminance":145.47917015504314},{"name":"Alaskan Wind","hex":"#bae3eb","rgb":{"r":186,"g":227,"b":235},"luminance":146.85338639949708},{"name":"Albanian Red","hex":"#cc0001","rgb":{"r":204,"g":0,"b":1},"luminance":60.9961065314828},{"name":"Albeit","hex":"#38546e","rgb":{"r":56,"g":84,"b":110},"luminance":53.562038796147405},{"name":"Albert Green","hex":"#4f5845","rgb":{"r":79,"g":88,"b":69},"luminance":57.34254906262887},{"name":"Albescent White","hex":"#e1dacb","rgb":{"r":225,"g":218,"b":203},"luminance":146.4130286040146},{"name":"Alchemy","hex":"#e7cf8c","rgb":{"r":231,"g":207,"b":140},"luminance":140.6758168343088},{"name":"Aldabra","hex":"#aaa492","rgb":{"r":170,"g":164,"b":146},"luminance":110.12828637548121},{"name":"Alert Tan","hex":"#954e2c","rgb":{"r":149,"g":78,"b":44},"luminance":64.08049354522792},{"name":"Alesan","hex":"#f1ceb3","rgb":{"r":241,"g":206,"b":179},"luminance":142.23584077510142},{"name":"Aleutian","hex":"#9a9eb3","rgb":{"r":154,"g":158,"b":179},"luminance":105.53890025957253},{"name":"Alexandria","hex":"#ff8f73","rgb":{"r":255,"g":143,"b":115},"luminance":114.154560162965},{"name":"Alexandria's Lighthouse","hex":"#fcefc1","rgb":{"r":252,"g":239,"b":193},"luminance":160.75924532355828},{"name":"Alexandrian Sky","hex":"#bcd9dc","rgb":{"r":188,"g":217,"b":220},"luminance":141.47156952900465},{"name":"Alexis Blue","hex":"#416082","rgb":{"r":65,"g":96,"b":130},"luminance":61.423932868223275},{"name":"Alfalfa","hex":"#b7b59f","rgb":{"r":183,"g":181,"b":159},"luminance":120.87566741904675},{"name":"Alga Moss","hex":"#8da98d","rgb":{"r":141,"g":169,"b":141},"luminance":108.9816037962371},{"name":"Algae","hex":"#54ac68","rgb":{"r":84,"g":172,"b":104},"luminance":104.71440917084907},{"name":"Algae Green","hex":"#93dfb8","rgb":{"r":147,"g":223,"b":184},"luminance":139.66721371173693},{"name":"Algal Fuel","hex":"#21c36f","rgb":{"r":33,"g":195,"b":111},"luminance":115.58424473084555},{"name":"Algen Gerne","hex":"#479784","rgb":{"r":71,"g":151,"b":132},"luminance":92.37765159387848},{"name":"Algerian Coral","hex":"#fc5a50","rgb":{"r":252,"g":90,"b":80},"luminance":92.47434457188653},{"name":"Algiers Blue","hex":"#00859c","rgb":{"r":0,"g":133,"b":156},"luminance":80.0709166739085},{"name":"Alhambra","hex":"#008778","rgb":{"r":0,"g":135,"b":120},"luminance":80.41711524918063},{"name":"Alhambra Cream","hex":"#f7f2e1","rgb":{"r":247,"g":242,"b":225},"luminance":162.1466219968828},{"name":"Alibi","hex":"#d4cbc4","rgb":{"r":212,"g":203,"b":196},"luminance":136.80875995710215},{"name":"Alice Blue","hex":"#f0f8ff","rgb":{"r":240,"g":248,"b":255},"luminance":164.88460897245685},{"name":"Alien","hex":"#415764","rgb":{"r":65,"g":87,"b":100},"luminance":55.81865267094862},{"name":"Alien Abduction","hex":"#0cff0c","rgb":{"r":12,"g":255,"b":12},"luminance":149.73424589251454},{"name":"Alien Armpit","hex":"#84de02","rgb":{"r":132,"g":222,"b":2},"luminance":136.15988250582475},{"name":"Alien Breed","hex":"#b9cc81","rgb":{"r":185,"g":204,"b":129},"luminance":132.72377015817474},{"name":"Alien Purple","hex":"#490648","rgb":{"r":73,"g":6,"b":72},"luminance":23.583758754702355},{"name":"Alienator Grey","hex":"#9790a4","rgb":{"r":151,"g":144,"b":164},"luminance":97.63685472709575},{"name":"Align","hex":"#00728d","rgb":{"r":0,"g":114,"b":141},"luminance":68.82145159759418},{"name":"Alizarin","hex":"#e34636","rgb":{"r":227,"g":70,"b":54},"luminance":79.58032775127279},{"name":"Alizarin Crimson","hex":"#e32636","rgb":{"r":227,"g":38,"b":54},"luminance":71.70912146303284},{"name":"All About Olive","hex":"#676c58","rgb":{"r":103,"g":108,"b":88},"luminance":71.19093375564053},{"name":"All Nighter","hex":"#455454","rgb":{"r":69,"g":84,"b":84},"luminance":54.30116758413211},{"name":"All's Ace","hex":"#c68886","rgb":{"r":198,"g":136,"b":134},"luminance":100.55536387483264},{"name":"Allegiance","hex":"#5a6a8c","rgb":{"r":90,"g":106,"b":140},"luminance":69.64515047007939},{"name":"Allegro","hex":"#b28959","rgb":{"r":178,"g":137,"b":89},"luminance":96.96771710729298},{"name":"Alley","hex":"#b8c4d9","rgb":{"r":184,"g":196,"b":217},"luminance":129.90647252542882},{"name":"Alley Cat","hex":"#656874","rgb":{"r":101,"g":104,"b":116},"luminance":69.38092015100405},{"name":"Alliance","hex":"#2b655f","rgb":{"r":43,"g":101,"b":95},"luminance":61.62418127650865},{"name":"Alligator","hex":"#886600","rgb":{"r":136,"g":102,"b":0},"luminance":72.37718405685592},{"name":"Alligator Egg","hex":"#eaeed7","rgb":{"r":234,"g":238,"b":215},"luminance":158.1573510526779},{"name":"Alligator Gladiator","hex":"#444411","rgb":{"r":68,"g":68,"b":17},"luminance":44.83785369528742},{"name":"Allium","hex":"#9569a3","rgb":{"r":149,"g":105,"b":163},"luminance":78.28764621573444},{"name":"Alloy","hex":"#98979a","rgb":{"r":152,"g":151,"b":154},"luminance":101.14470628263251},{"name":"Alloy Orange","hex":"#c46210","rgb":{"r":196,"g":98,"b":16},"luminance":82.14010267828985},{"name":"Allports","hex":"#1f6a7d","rgb":{"r":31,"g":106,"b":125},"luminance":64.5023576700883},{"name":"Allspice","hex":"#f8cdaa","rgb":{"r":248,"g":205,"b":170},"luminance":142.66960338137903},{"name":"Allura Red","hex":"#ed2e38","rgb":{"r":237,"g":46,"b":56},"luminance":76.10143381697877},{"name":"Allure","hex":"#7291b4","rgb":{"r":114,"g":145,"b":180},"luminance":93.95471792837228},{"name":"Alluring Gesture","hex":"#f8dbc2","rgb":{"r":248,"g":219,"b":194},"luminance":150.04502780498925},{"name":"Alluring Light","hex":"#fff7d8","rgb":{"r":255,"g":247,"b":216},"luminance":165.65461515454376},{"name":"Alluring Umber","hex":"#977b4d","rgb":{"r":151,"g":123,"b":77},"luminance":85.60648273349396},{"name":"Alluvial Inca","hex":"#bb934b","rgb":{"r":187,"g":147,"b":75},"luminance":103.17537298212206},{"name":"Allyson","hex":"#cb738b","rgb":{"r":203,"g":115,"b":139},"luminance":92.15284341787832},{"name":"Almond","hex":"#eddcc8","rgb":{"r":237,"g":220,"b":200},"luminance":149.0588620948114},{"name":"Almond Blossom","hex":"#f5bec7","rgb":{"r":245,"g":190,"b":199},"luminance":135.3509900998142},{"name":"Almond Brittle","hex":"#e5d3b9","rgb":{"r":229,"g":211,"b":185},"luminance":143.08606637265558},{"name":"Almond Buff","hex":"#ccb390","rgb":{"r":204,"g":179,"b":144},"luminance":122.59825610913067},{"name":"Almond Cookie","hex":"#eec87c","rgb":{"r":238,"g":200,"b":124},"luminance":138.00948061636925},{"name":"Almond Cream","hex":"#f4c29f","rgb":{"r":244,"g":194,"b":159},"luminance":136.45266100739846},{"name":"Almond Frost","hex":"#9a8678","rgb":{"r":154,"g":134,"b":120},"luminance":92.16538113630303},{"name":"Almond Icing","hex":"#efe3d9","rgb":{"r":239,"g":227,"b":217},"luminance":153.21207252041205},{"name":"Almond Latte","hex":"#d6c0a4","rgb":{"r":214,"g":192,"b":164},"luminance":130.9425073381444},{"name":"Almond Milk","hex":"#d6cebe","rgb":{"r":214,"g":206,"b":190},"luminance":138.51171026306764},{"name":"Almond Oil","hex":"#f4efc1","rgb":{"r":244,"g":239,"b":193},"luminance":159.65209609961278},{"name":"Almond Paste","hex":"#e5dbc5","rgb":{"r":229,"g":219,"b":197},"luminance":147.37202385120455},{"name":"Almond Roca","hex":"#f0e8e0","rgb":{"r":240,"g":232,"b":224},"luminance":156.0373889553398},{"name":"Almond Rose","hex":"#cc8888","rgb":{"r":204,"g":136,"b":136},"luminance":101.65645211200318},{"name":"Almond Silk","hex":"#e1cfb2","rgb":{"r":225,"g":207,"b":178},"luminance":140.36426885072996},{"name":"Almondine","hex":"#fedebc","rgb":{"r":254,"g":222,"b":188},"luminance":152.34455729037384},{"name":"Almost Aloe","hex":"#bfe5b1","rgb":{"r":191,"g":229,"b":177},"luminance":147.43857193421266},{"name":"Almost Apricot","hex":"#e5b39b","rgb":{"r":229,"g":179,"b":155},"luminance":126.6524459692745},{"name":"Almost Aqua","hex":"#98ddc5","rgb":{"r":152,"g":221,"b":197},"luminance":139.2802103566763},{"name":"Almost Mauve","hex":"#e7dcd9","rgb":{"r":231,"g":220,"b":217},"luminance":148.52486325528125},{"name":"Aloe","hex":"#817a60","rgb":{"r":129,"g":122,"b":96},"luminance":82.07349251128527},{"name":"Aloe Cream","hex":"#dbe5b9","rgb":{"r":219,"g":229,"b":185},"luminance":151.0036171421069},{"name":"Aloe Essence","hex":"#ecf1e2","rgb":{"r":236,"g":241,"b":226},"luminance":160.17482286863935},{"name":"Aloe Mist","hex":"#dcf2e3","rgb":{"r":220,"g":242,"b":227},"luminance":158.66952511430793},{"name":"Aloe Plant","hex":"#b8ba87","rgb":{"r":184,"g":186,"b":135},"luminance":123.2246788593908},{"name":"Aloe Vera","hex":"#678779","rgb":{"r":103,"g":135,"b":121},"luminance":86.13071269878125},{"name":"Aloe Vera Tea","hex":"#848b71","rgb":{"r":132,"g":139,"b":113},"luminance":91.54827468062955},{"name":"Aloe Wash","hex":"#d0d3b7","rgb":{"r":208,"g":211,"b":183},"luminance":140.15571467835338},{"name":"Aloeswood","hex":"#6a432d","rgb":{"r":106,"g":67,"b":45},"luminance":50.77003818198288},{"name":"Aloha","hex":"#1db394","rgb":{"r":29,"g":179,"b":148},"luminance":106.77165332615205},{"name":"Aloha Sunset","hex":"#e9aa91","rgb":{"r":233,"g":170,"b":145},"luminance":122.8200956236397},{"name":"Alone in the Dark","hex":"#000066","rgb":{"r":0,"g":0,"b":102},"luminance":11.628},{"name":"Aloof","hex":"#d4e2e6","rgb":{"r":212,"g":226,"b":230},"luminance":149.3476922754416},{"name":"Aloof Lama","hex":"#d6c5a0","rgb":{"r":214,"g":197,"b":160},"luminance":133.41395772931705},{"name":"Alpaca Wool","hex":"#f9ede2","rgb":{"r":249,"g":237,"b":226},"luminance":159.87755082562404},{"name":"Alpha Centauri","hex":"#4d5778","rgb":{"r":77,"g":87,"b":120},"luminance":57.664925994923465},{"name":"Alpha Gold","hex":"#ae8e5f","rgb":{"r":174,"g":142,"b":95},"luminance":98.85283451677043},{"name":"Alpha Tango","hex":"#628fb0","rgb":{"r":98,"g":143,"b":176},"luminance":91.14418676470814},{"name":"Alphabet Blue","hex":"#abcdef","rgb":{"r":171,"g":205,"b":239},"luminance":133.55534950723612},{"name":"Alpine","hex":"#ad8a3b","rgb":{"r":173,"g":138,"b":59},"luminance":96.34777444757093},{"name":"Alpine Alabaster","hex":"#badbe6","rgb":{"r":186,"g":219,"b":230},"luminance":142.50010247364736},{"name":"Alpine Blue","hex":"#dbe4e5","rgb":{"r":219,"g":228,"b":229},"luminance":151.26585699687817},{"name":"Alpine Expedition","hex":"#99eeff","rgb":{"r":153,"g":238,"b":255},"luminance":149.85199146157518},{"name":"Alpine Goat","hex":"#f1f2f8","rgb":{"r":241,"g":242,"b":248},"luminance":161.77498070159055},{"name":"Alpine Green","hex":"#005f56","rgb":{"r":0,"g":95,"b":86},"luminance":56.620258220887685},{"name":"Alpine Haze","hex":"#abbec0","rgb":{"r":171,"g":190,"b":192},"luminance":124.62824754043521},{"name":"Alpine Herbs","hex":"#449955","rgb":{"r":68,"g":153,"b":85},"luminance":92.5921273381274},{"name":"Alpine Landing","hex":"#117b87","rgb":{"r":17,"g":123,"b":135},"luminance":73.99779314276878},{"name":"Alpine Moon","hex":"#ded3e6","rgb":{"r":222,"g":211,"b":230},"luminance":142.94783570589658},{"name":"Alpine Race","hex":"#234162","rgb":{"r":35,"g":65,"b":98},"luminance":41.11123732022669},{"name":"Alpine Salamander","hex":"#051009","rgb":{"r":5,"g":16,"b":9},"luminance":9.565425500206459},{"name":"Alpine Summer","hex":"#a5a99a","rgb":{"r":165,"g":169,"b":154},"luminance":112.17571292396585},{"name":"Altdorf Guard Blue","hex":"#1f56a7","rgb":{"r":31,"g":86,"b":167},"luminance":54.742964196323896},{"name":"Altered Pink","hex":"#efc7be","rgb":{"r":239,"g":199,"b":190},"luminance":138.64020733539024},{"name":"Alto","hex":"#cdc6c5","rgb":{"r":205,"g":198,"b":197},"luminance":133.30387040517616},{"name":"Alu Gobi","hex":"#ddbb00","rgb":{"r":221,"g":187,"b":0},"luminance":128.12364185426512},{"name":"Alucard's Night","hex":"#000055","rgb":{"r":0,"g":0,"b":85},"luminance":9.69},{"name":"Aluminium","hex":"#848789","rgb":{"r":132,"g":135,"b":137},"luminance":89.89669055643817},{"name":"Aluminium Powder","hex":"#a9a0a9","rgb":{"r":169,"g":160,"b":169},"luminance":108.37678310874519},{"name":"Aluminum","hex":"#9f9586","rgb":{"r":159,"g":149,"b":134},"luminance":100.71384823349766},{"name":"Aluminum Foil","hex":"#d2d9db","rgb":{"r":210,"g":217,"b":219},"luminance":144.19186834561788},{"name":"Aluminum Silver","hex":"#8c8d91","rgb":{"r":140,"g":141,"b":145},"luminance":94.2118718049907},{"name":"Aluminum Sky","hex":"#adafaf","rgb":{"r":173,"g":175,"b":175},"luminance":116.73093272136568},{"name":"Alverda","hex":"#a5c970","rgb":{"r":165,"g":201,"b":112},"luminance":128.5219678420775},{"name":"Always Almond","hex":"#ebe5d2","rgb":{"r":235,"g":229,"b":210},"luminance":153.5572751581637},{"name":"Always Apple","hex":"#a0a667","rgb":{"r":160,"g":166,"b":103},"luminance":109.18554633283655},{"name":"Always Blue","hex":"#a2bacb","rgb":{"r":162,"g":186,"b":203},"luminance":121.66552976089817},{"name":"Always Rosey","hex":"#e79db3","rgb":{"r":231,"g":157,"b":179},"luminance":116.96244216841573},{"name":"Alyssa","hex":"#f4e2d6","rgb":{"r":244,"g":226,"b":214},"luminance":153.35236873292828},{"name":"Amalfi Coast","hex":"#297cbf","rgb":{"r":41,"g":124,"b":191},"luminance":76.95767083923472},{"name":"Amaranth","hex":"#e86ead","rgb":{"r":232,"g":110,"b":173},"luminance":96.79959508179773},{"name":"Amaranth Deep Purple","hex":"#9f2b68","rgb":{"r":159,"g":43,"b":104},"luminance":55.11641768112292},{"name":"Amaranth Pink","hex":"#f19cbb","rgb":{"r":241,"g":156,"b":187},"luminance":118.45837998639014},{"name":"Amaranth Purple","hex":"#6a397b","rgb":{"r":106,"g":57,"b":123},"luminance":48.17292601659152},{"name":"Amaranth Red","hex":"#d3212d","rgb":{"r":211,"g":33,"b":45},"luminance":66.1949730870857},{"name":"Amarantha Red","hex":"#cc3311","rgb":{"r":204,"g":51,"b":17},"luminance":67.97419973048598},{"name":"Amaranthine","hex":"#5f4053","rgb":{"r":95,"g":64,"b":83},"luminance":48.03881860537371},{"name":"Amaretto","hex":"#ab6f60","rgb":{"r":171,"g":111,"b":96},"luminance":83.54268625080235},{"name":"Amaretto Sours","hex":"#c09856","rgb":{"r":192,"g":152,"b":86},"luminance":106.54913916123395},{"name":"Amarillo Yellow","hex":"#fbf1c3","rgb":{"r":251,"g":241,"b":195},"luminance":161.6769537998536},{"name":"Amarklor Violet","hex":"#551199","rgb":{"r":85,"g":17,"b":153},"luminance":32.39947576736389},{"name":"Amaya","hex":"#f2c1cb","rgb":{"r":242,"g":193,"b":203},"luminance":136.40411653978776},{"name":"Amazing Amethyst","hex":"#806568","rgb":{"r":128,"g":101,"b":104},"luminance":71.55598569651599},{"name":"Amazing Boulder","hex":"#a9a797","rgb":{"r":169,"g":167,"b":151},"luminance":111.62163140717841},{"name":"Amazing Smoke","hex":"#6680bb","rgb":{"r":102,"g":128,"b":187},"luminance":83.84511687629757},{"name":"Amazon","hex":"#387b54","rgb":{"r":56,"g":123,"b":84},"luminance":74.73316340822191},{"name":"Amazon Depths","hex":"#505338","rgb":{"r":80,"g":83,"b":56},"luminance":54.65032202100917},{"name":"Amazon Green","hex":"#786a4a","rgb":{"r":120,"g":106,"b":74},"luminance":72.31955323423948},{"name":"Amazon Mist","hex":"#ececdc","rgb":{"r":236,"g":236,"b":220},"luminance":157.4782509427889},{"name":"Amazon Queen","hex":"#948f54","rgb":{"r":148,"g":143,"b":84},"luminance":95.37311340729103},{"name":"Amazon River Dolphin","hex":"#e6b2b8","rgb":{"r":230,"g":178,"b":184},"luminance":126.83307798835443},{"name":"Amazon Vine","hex":"#abaa97","rgb":{"r":171,"g":170,"b":151},"luminance":113.43958981325699},{"name":"Amazonian","hex":"#aa6644","rgb":{"r":170,"g":102,"b":68},"luminance":78.92197590025226},{"name":"Amazonite","hex":"#00c4b0","rgb":{"r":0,"g":196,"b":176},"luminance":116.78838469642432},{"name":"Amber","hex":"#ffbf00","rgb":{"r":255,"g":191,"b":0},"luminance":135.58584628935276},{"name":"Amber Brown","hex":"#a66646","rgb":{"r":166,"g":102,"b":70},"luminance":78.17998613456004},{"name":"Amber Dawn","hex":"#f6bc77","rgb":{"r":246,"g":188,"b":119},"luminance":133.31419282281988},{"name":"Amber Gold","hex":"#c19552","rgb":{"r":193,"g":149,"b":82},"luminance":105.20104239977853},{"name":"Amber Green","hex":"#9a803a","rgb":{"r":154,"g":128,"b":58},"luminance":88.37064646136747},{"name":"Amber Romance","hex":"#b18140","rgb":{"r":177,"g":129,"b":64},"luminance":92.67172316300156},{"name":"Amber Tide","hex":"#ffafa3","rgb":{"r":255,"g":175,"b":163},"luminance":129.27109643690656},{"name":"Amber Yellow","hex":"#fab75a","rgb":{"r":250,"g":183,"b":90},"luminance":131.27109865084546},{"name":"Amberglow","hex":"#dc793e","rgb":{"r":220,"g":121,"b":62},"luminance":97.06595568478168},{"name":"Amberlight","hex":"#e2bea2","rgb":{"r":226,"g":190,"b":162},"luminance":131.70517605622035},{"name":"Ambient Glow","hex":"#f8ede0","rgb":{"r":248,"g":237,"b":224},"luminance":159.7019178375764},{"name":"Ambit","hex":"#97653f","rgb":{"r":151,"g":101,"b":63},"luminance":74.86629210799744},{"name":"Ambitious Rose","hex":"#e9687e","rgb":{"r":233,"g":104,"b":126},"luminance":93.73725880886425},{"name":"Ambrosia","hex":"#d2e7ca","rgb":{"r":210,"g":231,"b":202},"luminance":151.19331762019112},{"name":"Ambrosia Coffee Cake","hex":"#eee9d3","rgb":{"r":238,"g":233,"b":211},"luminance":156.0414419345066},{"name":"Ambrosia Ivory","hex":"#fff4eb","rgb":{"r":255,"g":244,"b":235},"luminance":164.45444387124354},{"name":"Ambrosia Salad","hex":"#f4ded3","rgb":{"r":244,"g":222,"b":211},"luminance":151.2709868018319},{"name":"Ameixa","hex":"#6a5acd","rgb":{"r":106,"g":90,"b":205},"luminance":65.89139121311675},{"name":"Amélie's Tutu","hex":"#fea7bd","rgb":{"r":254,"g":167,"b":189},"luminance":125.8638545135179},{"name":"America's Cup","hex":"#34546d","rgb":{"r":52,"g":84,"b":109},"luminance":53.17353330370288},{"name":"American Anthem","hex":"#7595ab","rgb":{"r":117,"g":149,"b":171},"luminance":96.19564799927281},{"name":"American Beauty","hex":"#a73340","rgb":{"r":167,"g":51,"b":64},"luminance":58.675037912216126},{"name":"American Blue","hex":"#3b3b6d","rgb":{"r":59,"g":59,"b":109},"luminance":40.805086031032936},{"name":"American Bronze","hex":"#391802","rgb":{"r":57,"g":24,"b":2},"luminance":22.11306349197234},{"name":"American Brown","hex":"#804040","rgb":{"r":128,"g":64,"b":64},"luminance":54.12330573791664},{"name":"American Gold","hex":"#d3af37","rgb":{"r":211,"g":175,"b":55},"luminance":120.71437547367753},{"name":"American Green","hex":"#34b334","rgb":{"r":52,"g":179,"b":52},"luminance":106.38240840007336},{"name":"American Mahogany","hex":"#52352f","rgb":{"r":82,"g":53,"b":47},"luminance":39.97167508373898},{"name":"American Milking Devon","hex":"#63403a","rgb":{"r":99,"g":64,"b":58},"luminance":48.283458544308935},{"name":"American Orange","hex":"#ff8b00","rgb":{"r":255,"g":139,"b":0},"luminance":111.67236754900469},{"name":"American Pink","hex":"#ff9899","rgb":{"r":255,"g":152,"b":153},"luminance":118.65262561359523},{"name":"American Purple","hex":"#431c53","rgb":{"r":67,"g":28,"b":83},"luminance":27.586094848673305},{"name":"American Red","hex":"#b32134","rgb":{"r":179,"g":33,"b":52},"luminance":57.22651715769535},{"name":"American River","hex":"#626e71","rgb":{"r":98,"g":110,"b":113},"luminance":72.06828725590749},{"name":"American Roast","hex":"#995544","rgb":{"r":153,"g":85,"b":68},"luminance":68.13510503404247},{"name":"American Rose","hex":"#ff033e","rgb":{"r":255,"g":3,"b":62},"luminance":76.59215214367592},{"name":"American Silver","hex":"#cfcfcf","rgb":{"r":207,"g":207,"b":207},"luminance":138.39091781616307},{"name":"American Violet","hex":"#551b8c","rgb":{"r":85,"g":27,"b":140},"luminance":33.93868922041627},{"name":"American Yellow","hex":"#f2b400","rgb":{"r":242,"g":180,"b":0},"luminance":128.0613749887139},{"name":"American Yorkshire","hex":"#efdcd4","rgb":{"r":239,"g":220,"b":212},"luminance":149.55903966327142},{"name":"Americana","hex":"#0477b4","rgb":{"r":4,"g":119,"b":180},"luminance":72.81443830038106},{"name":"Americano","hex":"#463732","rgb":{"r":70,"g":55,"b":50},"luminance":38.89570831081495},{"name":"Amethyst","hex":"#9966cc","rgb":{"r":153,"g":102,"b":204},"luminance":78.85762753849497},{"name":"Amethyst Ganzstar","hex":"#8f00ff","rgb":{"r":143,"g":0,"b":255},"luminance":51.7032489211268},{"name":"Amethyst Gem","hex":"#776985","rgb":{"r":119,"g":105,"b":133},"luminance":72.76514983149558},{"name":"Amethyst Haze","hex":"#a0a0aa","rgb":{"r":160,"g":160,"b":170},"luminance":107.1691018904236},{"name":"Amethyst Ice","hex":"#d0c9c6","rgb":{"r":208,"g":201,"b":198},"luminance":135.27110636421955},{"name":"Amethyst Orchid","hex":"#926aa6","rgb":{"r":146,"g":106,"b":166},"luminance":78.32858211406612},{"name":"Amethyst Paint","hex":"#9c8aa4","rgb":{"r":156,"g":138,"b":164},"luminance":95.32667616150266},{"name":"Amethyst Purple","hex":"#562f7e","rgb":{"r":86,"g":47,"b":126},"luminance":40.35699707609574},{"name":"Amethyst Show","hex":"#bd97cf","rgb":{"r":189,"g":151,"b":207},"luminance":107.73521473501596},{"name":"Amethyst Smoke","hex":"#95879c","rgb":{"r":149,"g":135,"b":156},"luminance":92.63278189712322},{"name":"Amish Bread","hex":"#e6ddbe","rgb":{"r":230,"g":221,"b":190},"luminance":148.41685560946237},{"name":"Amnesia Blue","hex":"#1560bd","rgb":{"r":21,"g":96,"b":189},"luminance":60.65644121608191},{"name":"Amore","hex":"#ae2f48","rgb":{"r":174,"g":47,"b":72},"luminance":59.45779058290007},{"name":"Amour","hex":"#ee5851","rgb":{"r":238,"g":88,"b":81},"luminance":88.41741534335868},{"name":"Amour Frais","hex":"#f5e6ea","rgb":{"r":245,"g":230,"b":234},"luminance":155.9025468072924},{"name":"Amourette","hex":"#c8c5d7","rgb":{"r":200,"g":197,"b":215},"luminance":132.47323662159084},{"name":"Amourette Eternelle","hex":"#e0dfe8","rgb":{"r":224,"g":223,"b":232},"luminance":149.39997684404105},{"name":"Amparo Blue","hex":"#4960a8","rgb":{"r":73,"g":96,"b":168},"luminance":63.39372947697587},{"name":"Amphibian","hex":"#264c47","rgb":{"r":38,"g":76,"b":71},"luminance":46.742255230144806},{"name":"Amphitrite","hex":"#384e47","rgb":{"r":56,"g":78,"b":71},"luminance":49.41894543593579},{"name":"Amphora","hex":"#9f8672","rgb":{"r":159,"g":134,"b":114},"luminance":92.82307720066169},{"name":"Amphystine","hex":"#3f425a","rgb":{"r":63,"g":66,"b":90},"luminance":44.28366214531042},{"name":"Amulet","hex":"#7d9d72","rgb":{"r":125,"g":157,"b":114},"luminance":100.29490476589525},{"name":"Amulet Gem","hex":"#01748e","rgb":{"r":1,"g":116,"b":142},"luminance":69.9904365538607},{"name":"Amygdala Purple","hex":"#69045f","rgb":{"r":105,"g":4,"b":95},"luminance":33.29336313741824},{"name":"Àn Zǐ Purple","hex":"#94568c","rgb":{"r":148,"g":86,"b":140},"luminance":69.00285086864164},{"name":"Anakiwa","hex":"#8cceea","rgb":{"r":140,"g":206,"b":234},"luminance":130.7134218816109},{"name":"Ancestral","hex":"#d0c1c3","rgb":{"r":208,"g":193,"b":195},"luminance":131.13683100105783},{"name":"Ancestral Water","hex":"#d0d0d0","rgb":{"r":208,"g":208,"b":208},"luminance":139.05947297469524},{"name":"Anchor Grey","hex":"#596062","rgb":{"r":89,"g":96,"b":98},"luminance":63.31276971512145},{"name":"Anchor Point","hex":"#435d8b","rgb":{"r":67,"g":93,"b":139},"luminance":60.27100535083183},{"name":"Anchorman","hex":"#2c3641","rgb":{"r":44,"g":54,"b":65},"luminance":35.1105630829242},{"name":"Anchors Away","hex":"#9ebbcd","rgb":{"r":158,"g":187,"b":205},"luminance":121.76697756370565},{"name":"Anchovy","hex":"#756f6b","rgb":{"r":117,"g":111,"b":107},"luminance":74.95355990211539},{"name":"Ancient Bamboo","hex":"#da6304","rgb":{"r":218,"g":99,"b":4},"luminance":87.32709676268873},{"name":"Ancient Brandy","hex":"#aa6611","rgb":{"r":170,"g":102,"b":17},"luminance":78.56424517552497},{"name":"Ancient Bronze","hex":"#9c5221","rgb":{"r":156,"g":82,"b":33},"luminance":67.13193976044488},{"name":"Ancient Chest","hex":"#99522b","rgb":{"r":153,"g":82,"b":43},"luminance":66.58603133540848},{"name":"Ancient Copper","hex":"#9f543e","rgb":{"r":159,"g":84,"b":62},"luminance":68.85769506017465},{"name":"Ancient Doeskin","hex":"#dcc9a8","rgb":{"r":220,"g":201,"b":168},"luminance":136.43584453141338},{"name":"Ancient Earth","hex":"#746550","rgb":{"r":116,"g":101,"b":80},"luminance":69.28998935632765},{"name":"Ancient Ice","hex":"#73fdff","rgb":{"r":115,"g":253,"b":255},"luminance":155.1866948098322},{"name":"Ancient Kingdom","hex":"#d6d8cd","rgb":{"r":214,"g":216,"b":205},"luminance":143.93254100445805},{"name":"Ancient Lavastone","hex":"#483c32","rgb":{"r":72,"g":60,"b":50},"luminance":41.670051403855986},{"name":"Ancient Magenta","hex":"#953d55","rgb":{"r":149,"g":61,"b":85},"luminance":57.97265691686037},{"name":"Ancient Maze","hex":"#959651","rgb":{"r":149,"g":150,"b":81},"luminance":99.11034687155524},{"name":"Ancient Murasaki Purple","hex":"#895b8a","rgb":{"r":137,"g":91,"b":138},"luminance":69.12914784662111},{"name":"Ancient Olive","hex":"#6a5536","rgb":{"r":106,"g":85,"b":54},"luminance":59.42993350997458},{"name":"Ancient Prunus","hex":"#5a3d3f","rgb":{"r":90,"g":61,"b":63},"luminance":45.3637572628194},{"name":"Ancient Red","hex":"#922a31","rgb":{"r":146,"g":42,"b":49},"luminance":50.44496831201304},{"name":"Ancient Royal Banner","hex":"#843f5b","rgb":{"r":132,"g":63,"b":91},"luminance":55.072109647261556},{"name":"Ancient Ruins","hex":"#e0cac0","rgb":{"r":224,"g":202,"b":192},"luminance":137.9299191473699},{"name":"Ancient Scroll","hex":"#f5e6de","rgb":{"r":245,"g":230,"b":222},"luminance":155.67430741455058},{"name":"Ancient Shelter","hex":"#83696e","rgb":{"r":131,"g":105,"b":110},"luminance":74.09679740717543},{"name":"Ancient Yellow","hex":"#eecd00","rgb":{"r":238,"g":205,"b":0},"luminance":139.80179708787722},{"name":"Andorra","hex":"#603535","rgb":{"r":96,"g":53,"b":53},"luminance":42.758855234910115},{"name":"Andouille","hex":"#b58338","rgb":{"r":181,"g":131,"b":56},"luminance":94.24844946204685},{"name":"Andrea Blue","hex":"#4477dd","rgb":{"r":68,"g":119,"b":221},"luminance":76.99071027727955},{"name":"Android Green","hex":"#a4c639","rgb":{"r":164,"g":198,"b":57},"luminance":126.3140387130425},{"name":"Andromeda Blue","hex":"#abcdee","rgb":{"r":171,"g":205,"b":238},"luminance":133.53213953951308},{"name":"Anemone","hex":"#842c48","rgb":{"r":132,"g":44,"b":72},"luminance":47.87671534263811},{"name":"Angel Aura","hex":"#afa8ae","rgb":{"r":175,"g":168,"b":174},"luminance":113.38645411600099},{"name":"Angel Blue","hex":"#83c5cd","rgb":{"r":131,"g":197,"b":205},"luminance":124.30907361089938},{"name":"Angel Face Rose","hex":"#fe83cc","rgb":{"r":254,"g":131,"b":204},"luminance":110.55218252481494},{"name":"Angel Falls","hex":"#a3bdd3","rgb":{"r":163,"g":189,"b":211},"luminance":123.5404360280471},{"name":"Angel Feather","hex":"#f4efee","rgb":{"r":244,"g":239,"b":238},"luminance":160.4395500149511},{"name":"Angel Finger","hex":"#b8acb4","rgb":{"r":184,"g":172,"b":180},"luminance":116.7970887993361},{"name":"Angel Food","hex":"#f0e8d9","rgb":{"r":240,"g":232,"b":217},"luminance":155.90878134345095},{"name":"Angel Green","hex":"#004225","rgb":{"r":0,"g":66,"b":37},"luminance":38.97093901870982},{"name":"Angel Heart","hex":"#a17791","rgb":{"r":161,"g":119,"b":145},"luminance":86.42942687534148},{"name":"Angel in Blue Jeans","hex":"#bbc6d9","rgb":{"r":187,"g":198,"b":217},"luminance":131.32675008923354},{"name":"Angel Kiss","hex":"#cec7dc","rgb":{"r":206,"g":199,"b":220},"luminance":134.4176484134431},{"name":"Angel of Death Victorious","hex":"#c6f0e7","rgb":{"r":198,"g":240,"b":231},"luminance":155.0662141151321},{"name":"Angel Shark","hex":"#e19640","rgb":{"r":225,"g":150,"b":64},"luminance":111.04935722911681},{"name":"Angel Wing","hex":"#f3dfd7","rgb":{"r":243,"g":223,"b":215},"luminance":151.70646508965922},{"name":"Angel's Face","hex":"#eed4c8","rgb":{"r":238,"g":212,"b":200},"luminance":145.1557073628178},{"name":"Angel's Feather","hex":"#f3f1e6","rgb":{"r":243,"g":241,"b":230},"luminance":161.18138893184906},{"name":"Angel's Whisper","hex":"#dbdfd4","rgb":{"r":219,"g":223,"b":212},"luminance":148.34731337641406},{"name":"Angelic Blue","hex":"#bbc6d6","rgb":{"r":187,"g":198,"b":214},"luminance":131.262757326669},{"name":"Angelic Choir","hex":"#e9d9dc","rgb":{"r":233,"g":217,"b":220},"luminance":147.33603405141594},{"name":"Angelic Eyes","hex":"#bbd1e8","rgb":{"r":187,"g":209,"b":232},"luminance":137.3931539851968},{"name":"Angelic Sent","hex":"#e3dfea","rgb":{"r":227,"g":223,"b":234},"luminance":149.84466926120527},{"name":"Angelic Starlet","hex":"#ebe9d8","rgb":{"r":235,"g":233,"b":216},"luminance":155.72353079095015},{"name":"Angélique Grey","hex":"#d8dee7","rgb":{"r":216,"g":222,"b":231},"luminance":147.80497693920864},{"name":"Anger","hex":"#dd0055","rgb":{"r":221,"g":0,"b":85},"luminance":66.78570461558371},{"name":"Angora","hex":"#dfd1bb","rgb":{"r":223,"g":209,"b":187},"luminance":141.24941749260418},{"name":"Angora Blue","hex":"#b9c6d8","rgb":{"r":185,"g":198,"b":216},"luminance":131.05179768702146},{"name":"Angora Goat","hex":"#ede7de","rgb":{"r":237,"g":231,"b":222},"luminance":155.07612982661126},{"name":"Angora Pink","hex":"#ebdfea","rgb":{"r":235,"g":223,"b":234},"luminance":150.94320455721083},{"name":"Angraecum Orchid","hex":"#f4f6ec","rgb":{"r":244,"g":246,"b":236},"luminance":164.00713629595512},{"name":"Angry Flamingo","hex":"#f04e45","rgb":{"r":240,"g":78,"b":69},"luminance":85.48525809752228},{"name":"Angry Gargoyle","hex":"#9799a6","rgb":{"r":151,"g":153,"b":166},"luminance":102.28668387429518},{"name":"Angry Gremlin","hex":"#37503d","rgb":{"r":55,"g":80,"b":61},"luminance":50.23980235828958},{"name":"Angry Hornet","hex":"#ee9911","rgb":{"r":238,"g":153,"b":17},"luminance":114.60280017957675},{"name":"Angry Ocean","hex":"#4e6665","rgb":{"r":78,"g":102,"b":101},"luminance":65.2792750878868},{"name":"Angry Pasta","hex":"#ffcc55","rgb":{"r":255,"g":204,"b":85},"luminance":142.29117902737332},{"name":"Aniline Mauve","hex":"#b9abad","rgb":{"r":185,"g":171,"b":173},"luminance":116.29380309371604},{"name":"Animal Blood","hex":"#a41313","rgb":{"r":164,"g":19,"b":19},"luminance":50.33498049070845},{"name":"Animal Cracker","hex":"#f4e6ce","rgb":{"r":244,"g":230,"b":206},"luminance":155.2474679084976},{"name":"Animal Kingdom","hex":"#bcc09e","rgb":{"r":188,"g":192,"b":158},"luminance":127.22583347732487},{"name":"Animation","hex":"#1d5c83","rgb":{"r":29,"g":92,"b":131},"luminance":56.69781841482086},{"name":"Anise Flower","hex":"#f4e3b5","rgb":{"r":244,"g":227,"b":181},"luminance":153.30895568426521},{"name":"Anita","hex":"#91a0b7","rgb":{"r":145,"g":160,"b":183},"luminance":105.52651547833842},{"name":"Annapolis Blue","hex":"#384a66","rgb":{"r":56,"g":74,"b":102},"luminance":47.983661427615125},{"name":"Annis","hex":"#6b475d","rgb":{"r":107,"g":71,"b":93},"luminance":53.59969012970131},{"name":"Annular","hex":"#e17861","rgb":{"r":225,"g":120,"b":97},"luminance":98.03060026848759},{"name":"Anode","hex":"#89a4cd","rgb":{"r":137,"g":164,"b":205},"luminance":107.19912356451428},{"name":"Anon","hex":"#bdbfc8","rgb":{"r":189,"g":191,"b":200},"luminance":127.60703276073775},{"name":"Anonymous","hex":"#dadcd3","rgb":{"r":218,"g":220,"b":211},"luminance":146.6438803360031},{"name":"Another One Bites the Dust","hex":"#c7bba4","rgb":{"r":199,"g":187,"b":164},"luminance":126.25031793227294},{"name":"Antarctic Blue","hex":"#2b3f5c","rgb":{"r":43,"g":63,"b":92},"luminance":40.532640599891835},{"name":"Antarctic Deep","hex":"#35383f","rgb":{"r":53,"g":56,"b":63},"luminance":37.19243091006556},{"name":"Antarctica","hex":"#c6c5c6","rgb":{"r":198,"g":197,"b":198},"luminance":131.85882719408662},{"name":"Antarctica Lake","hex":"#bfd2d0","rgb":{"r":191,"g":210,"b":208},"luminance":137.9100784025591},{"name":"Antelope","hex":"#b19664","rgb":{"r":177,"g":150,"b":100},"luminance":103.36153263666324},{"name":"Anthill","hex":"#7f684e","rgb":{"r":127,"g":104,"b":78},"luminance":72.4422162623425},{"name":"Anthracite","hex":"#28282d","rgb":{"r":40,"g":40,"b":45},"luminance":26.84527705202537},{"name":"Anti Rainbow Grey","hex":"#bebdbc","rgb":{"r":190,"g":189,"b":188},"luminance":126.4715619141315},{"name":"Anti-Flash White","hex":"#f2f3f4","rgb":{"r":242,"g":243,"b":244},"luminance":162.34489490279637},{"name":"Antigua Blue","hex":"#06b1c4","rgb":{"r":6,"g":177,"b":196},"luminance":106.28958073583694},{"name":"Antigua Sand","hex":"#83c2cd","rgb":{"r":131,"g":194,"b":205},"luminance":122.67259818313134},{"name":"Antilles Blue","hex":"#3b5e8d","rgb":{"r":59,"g":94,"b":141},"luminance":60.11813404456262},{"name":"Antilles Garden","hex":"#8aa277","rgb":{"r":138,"g":162,"b":119},"luminance":104.54404734847412},{"name":"Antiquarian Gold","hex":"#ba8a45","rgb":{"r":186,"g":138,"b":69},"luminance":98.57364246085258},{"name":"Antiquate","hex":"#8d8aa0","rgb":{"r":141,"g":138,"b":160},"luminance":93.12384719823382},{"name":"Antique","hex":"#8b846d","rgb":{"r":139,"g":132,"b":109},"luminance":88.80029534297732},{"name":"Antique Bear","hex":"#9c867b","rgb":{"r":156,"g":134,"b":123},"luminance":92.51681027791652},{"name":"Antique Bourbon","hex":"#926b43","rgb":{"r":146,"g":107,"b":67},"luminance":76.8698981461534},{"name":"Antique Brass","hex":"#6c461f","rgb":{"r":108,"g":70,"b":31},"luminance":52.379867506514366},{"name":"Antique Bronze","hex":"#704a07","rgb":{"r":112,"g":74,"b":7},"luminance":54.853831151524865},{"name":"Antique Brown","hex":"#553f2d","rgb":{"r":85,"g":63,"b":45},"luminance":45.16451578396474},{"name":"Antique China","hex":"#fdf6e7","rgb":{"r":253,"g":246,"b":231},"luminance":165.12990573787656},{"name":"Antique Coin","hex":"#b5b8a8","rgb":{"r":181,"g":184,"b":168},"luminance":122.31677452009598},{"name":"Antique Coral","hex":"#ffc7b0","rgb":{"r":255,"g":199,"b":176},"luminance":140.92956073868956},{"name":"Antique Fuchsia","hex":"#915c83","rgb":{"r":145,"g":92,"b":131},"luminance":70.84569427283495},{"name":"Antique Garnet","hex":"#8e5e5e","rgb":{"r":142,"g":94,"b":94},"luminance":70.44236015353262},{"name":"Antique Gold","hex":"#b59e5f","rgb":{"r":181,"g":158,"b":95},"luminance":107.92578735872164},{"name":"Antique Green","hex":"#29675c","rgb":{"r":41,"g":103,"b":92},"luminance":62.576463195038436},{"name":"Antique Heather","hex":"#cdbacb","rgb":{"r":205,"g":186,"b":203},"luminance":127.33160767460684},{"name":"Antique Honey","hex":"#b39355","rgb":{"r":179,"g":147,"b":85},"luminance":102.00090716263263},{"name":"Antique Lace","hex":"#fdf2db","rgb":{"r":253,"g":242,"b":219},"luminance":162.8653084023728},{"name":"Antique Linen","hex":"#faeedb","rgb":{"r":250,"g":238,"b":219},"luminance":160.40146536737126},{"name":"Antique Marble","hex":"#f1e9d7","rgb":{"r":241,"g":233,"b":215},"luminance":156.5233082387412},{"name":"Antique Mauve","hex":"#bbb0b1","rgb":{"r":187,"g":176,"b":177},"luminance":119.19221701520615},{"name":"Antique Moss","hex":"#7a973b","rgb":{"r":122,"g":151,"b":59},"luminance":96.08538561612791},{"name":"Antique Paper","hex":"#f4f0e8","rgb":{"r":244,"g":240,"b":232},"luminance":160.83920243522724},{"name":"Antique Parchment","hex":"#ead8c1","rgb":{"r":234,"g":216,"b":193},"luminance":146.4770986331993},{"name":"Antique Penny","hex":"#957747","rgb":{"r":149,"g":119,"b":71},"luminance":83.24509622794605},{"name":"Antique Rose","hex":"#997165","rgb":{"r":153,"g":113,"b":101},"luminance":81.39509669507126},{"name":"Antique Rosewood","hex":"#72393f","rgb":{"r":114,"g":57,"b":63},"luminance":48.30053002814772},{"name":"Antique Ruby","hex":"#841b2d","rgb":{"r":132,"g":27,"b":45},"luminance":42.839592960251146},{"name":"Antique Silver","hex":"#918e8c","rgb":{"r":145,"g":142,"b":140},"luminance":95.30092833230954},{"name":"Antique White","hex":"#ece6d5","rgb":{"r":236,"g":230,"b":213},"luminance":154.2614459934821},{"name":"Antique Wicker Basket","hex":"#f3d3a1","rgb":{"r":243,"g":211,"b":161},"luminance":144.7634809404637},{"name":"Antique Windmill","hex":"#b6a38d","rgb":{"r":182,"g":163,"b":141},"luminance":111.24093653417343},{"name":"Antiquity","hex":"#c1a87c","rgb":{"r":193,"g":168,"b":124},"luminance":115.13053374756845},{"name":"Antler","hex":"#957a76","rgb":{"r":149,"g":122,"b":118},"luminance":85.40674973911604},{"name":"Antler Moth","hex":"#864f3e","rgb":{"r":134,"g":79,"b":62},"luminance":61.690324273746526},{"name":"Anubis Black","hex":"#312231","rgb":{"r":49,"g":34,"b":49},"luminance":25.380641461554905},{"name":"Anzac","hex":"#c68e3f","rgb":{"r":198,"g":142,"b":63},"luminance":102.49071784312959},{"name":"Ao","hex":"#00800c","rgb":{"r":0,"g":128,"b":12},"luminance":75.14845254561133},{"name":"Aoife's Green","hex":"#27b692","rgb":{"r":39,"g":182,"b":146},"luminance":108.7497366111753},{"name":"Aotake Bamboo","hex":"#006442","rgb":{"r":0,"g":100,"b":66},"luminance":59.18023805291763},{"name":"Apatite Crystal Green","hex":"#bbff99","rgb":{"r":187,"g":255,"b":153},"luminance":160.7360760937009},{"name":"Apeland","hex":"#8a843b","rgb":{"r":138,"g":132,"b":59},"luminance":88.04295528888157},{"name":"Aphrodite's Pearls","hex":"#eeffff","rgb":{"r":238,"g":255,"b":255},"luminance":168.26970722325512},{"name":"Apium","hex":"#b5d0a2","rgb":{"r":181,"g":208,"b":162},"luminance":134.82346383697458},{"name":"Apnea Dive","hex":"#284fbd","rgb":{"r":40,"g":79,"b":189},"luminance":52.51406330688952},{"name":"Apocyan","hex":"#99ccff","rgb":{"r":153,"g":204,"b":255},"luminance":131.44366250603335},{"name":"Apollo Bay","hex":"#748697","rgb":{"r":116,"g":134,"b":151},"luminance":87.67201729172199},{"name":"Apollo Landing","hex":"#e5e5e1","rgb":{"r":229,"g":229,"b":225},"luminance":153.02203524329428},{"name":"Apollo's White","hex":"#ddffff","rgb":{"r":221,"g":255,"b":255},"luminance":166.1839293253111},{"name":"Appalachian Forest","hex":"#848b80","rgb":{"r":132,"g":139,"b":128},"luminance":91.80450499294682},{"name":"Appalachian Trail","hex":"#cfb989","rgb":{"r":207,"g":185,"b":137},"luminance":125.96642170832669},{"name":"Appaloosa Spots","hex":"#876e52","rgb":{"r":135,"g":110,"b":82},"luminance":76.72029215924557},{"name":"Apparition","hex":"#c2bca9","rgb":{"r":194,"g":188,"b":169},"luminance":126.15197789967463},{"name":"Appetite","hex":"#b1e5aa","rgb":{"r":177,"g":229,"b":170},"luminance":145.75997824505873},{"name":"Appetizing Asparagus","hex":"#66aa00","rgb":{"r":102,"g":170,"b":0},"luminance":104.34640436545956},{"name":"Apple Blossom","hex":"#ddbca0","rgb":{"r":221,"g":188,"b":160},"luminance":129.91373513605095},{"name":"Apple Bob","hex":"#d5e69d","rgb":{"r":213,"g":230,"b":157},"luminance":150.3465080173131},{"name":"Apple Brown Betty","hex":"#9c6757","rgb":{"r":156,"g":103,"b":87},"luminance":77.0036491408037},{"name":"Apple Butter","hex":"#844b4d","rgb":{"r":132,"g":75,"b":77},"luminance":59.7743835852784},{"name":"Apple Cider","hex":"#da995f","rgb":{"r":218,"g":153,"b":95},"luminance":111.49886880592108},{"name":"Apple Cinnamon","hex":"#b0885a","rgb":{"r":176,"g":136,"b":90},"luminance":96.16496867362875},{"name":"Apple Cream","hex":"#b8d7a6","rgb":{"r":184,"g":215,"b":166},"luminance":138.96970913476073},{"name":"Apple Cucumber","hex":"#dbdbbc","rgb":{"r":219,"g":219,"b":188},"luminance":145.8525481230959},{"name":"Apple Custard","hex":"#fddfae","rgb":{"r":253,"g":223,"b":174},"luminance":152.48280987048997},{"name":"Apple Day","hex":"#7e976d","rgb":{"r":126,"g":151,"b":109},"luminance":97.10949243508587},{"name":"Apple Flower","hex":"#edf4eb","rgb":{"r":237,"g":244,"b":235},"luminance":162.02940737100778},{"name":"Apple Green","hex":"#76cd26","rgb":{"r":118,"g":205,"b":38},"luminance":125.47548753840329},{"name":"Apple Hill","hex":"#a69f8d","rgb":{"r":166,"g":159,"b":141},"luminance":106.92500325461768},{"name":"Apple Ice","hex":"#bdd0b1","rgb":{"r":189,"g":208,"b":177},"luminance":136.04439724222382},{"name":"Apple II Beige","hex":"#bfca87","rgb":{"r":191,"g":202,"b":135},"luminance":132.506918525034},{"name":"Apple II Blue","hex":"#93d6bf","rgb":{"r":147,"g":214,"b":191},"luminance":134.85494135922494},{"name":"Apple II Chocolate","hex":"#da680e","rgb":{"r":218,"g":104,"b":14},"luminance":89.3202028882604},{"name":"Apple II Green","hex":"#04650d","rgb":{"r":4,"g":101,"b":13},"luminance":59.317578414834166},{"name":"Apple II Lime","hex":"#25c40d","rgb":{"r":37,"g":196,"b":13},"luminance":115.59216667663947},{"name":"Apple II Magenta","hex":"#dc41f1","rgb":{"r":220,"g":65,"b":241},"luminance":80.85563122627886},{"name":"Apple II Rose","hex":"#ac667b","rgb":{"r":172,"g":102,"b":123},"luminance":80.16452796592766},{"name":"Apple Infusion","hex":"#ddaabb","rgb":{"r":221,"g":170,"b":187},"luminance":121.56864507347278},{"name":"Apple Jack","hex":"#8b974e","rgb":{"r":139,"g":151,"b":78},"luminance":98.30006182093682},{"name":"Apple Martini","hex":"#f9fdd9","rgb":{"r":249,"g":253,"b":217},"luminance":167.95962957210878},{"name":"Apple Seed","hex":"#a77c53","rgb":{"r":167,"g":124,"b":83},"luminance":88.77458463434228},{"name":"Apple Slice","hex":"#f1f0bf","rgb":{"r":241,"g":240,"b":191},"luminance":159.7303382485619},{"name":"Apple Valley","hex":"#ea8386","rgb":{"r":234,"g":131,"b":134},"luminance":105.07971231879158},{"name":"Apple-A-Day","hex":"#903f45","rgb":{"r":144,"g":63,"b":69},"luminance":57.29997777486479},{"name":"Applegate","hex":"#8ac479","rgb":{"r":138,"g":196,"b":121},"luminance":123.00321046216638},{"name":"Applegate Park","hex":"#aead93","rgb":{"r":174,"g":173,"b":147},"luminance":115.32623656826749},{"name":"Applemint","hex":"#cdeacd","rgb":{"r":205,"g":234,"b":205},"luminance":152.2184420134433},{"name":"Applemint Soda","hex":"#f3f5e9","rgb":{"r":243,"g":245,"b":233},"luminance":163.3013585920215},{"name":"Applesauce Cake","hex":"#c2a377","rgb":{"r":194,"g":163,"b":119},"luminance":112.71018655383372},{"name":"Appleton","hex":"#6eb478","rgb":{"r":110,"g":180,"b":120},"luminance":111.50304973407678},{"name":"Approval Green","hex":"#039487","rgb":{"r":3,"g":148,"b":135},"luminance":88.23319151543822},{"name":"Apricot","hex":"#ffb16d","rgb":{"r":255,"g":177,"b":109},"luminance":129.47087588334296},{"name":"Apricot Appeal","hex":"#fec382","rgb":{"r":254,"g":195,"b":130},"luminance":138.16534855382514},{"name":"Apricot Blush","hex":"#feaea5","rgb":{"r":254,"g":174,"b":165},"luminance":128.66150185661598},{"name":"Apricot Brandy","hex":"#c26a5a","rgb":{"r":194,"g":106,"b":90},"luminance":85.68279243815527},{"name":"Apricot Buff","hex":"#cd7e4d","rgb":{"r":205,"g":126,"b":77},"luminance":96.45987638909764},{"name":"Apricot Cream","hex":"#f1bd89","rgb":{"r":241,"g":189,"b":137},"luminance":133.2094991132389},{"name":"Apricot Foam","hex":"#eeded8","rgb":{"r":238,"g":222,"b":216},"luminance":150.50617999271657},{"name":"Apricot Fool","hex":"#ffd2a0","rgb":{"r":255,"g":210,"b":160},"luminance":146.08727023597913},{"name":"Apricot Gelato","hex":"#f5d7af","rgb":{"r":245,"g":215,"b":175},"luminance":147.28204082643612},{"name":"Apricot Glazed Chicken","hex":"#eeaa22","rgb":{"r":238,"g":170,"b":34},"luminance":122.62584442114964},{"name":"Apricot Glow","hex":"#ffce79","rgb":{"r":255,"g":206,"b":121},"luminance":143.61651905334566},{"name":"Apricot Ice","hex":"#fff6e9","rgb":{"r":255,"g":246,"b":233},"luminance":165.4411601536933},{"name":"Apricot Ice Cream","hex":"#f8cc9c","rgb":{"r":248,"g":204,"b":156},"luminance":141.9660989954996},{"name":"Apricot Iced Tea","hex":"#fbbe99","rgb":{"r":251,"g":190,"b":153},"luminance":135.55632285142585},{"name":"Apricot Illusion","hex":"#e2c4a6","rgb":{"r":226,"g":196,"b":166},"luminance":134.7639638627478},{"name":"Apricot Mix","hex":"#b47756","rgb":{"r":180,"g":119,"b":86},"luminance":88.72515102833017},{"name":"Apricot Mousse","hex":"#fcdfaf","rgb":{"r":252,"g":223,"b":175},"luminance":152.34958288423368},{"name":"Apricot Nectar","hex":"#ecaa79","rgb":{"r":236,"g":170,"b":121},"luminance":122.99429511973308},{"name":"Apricot Obsession","hex":"#f8c4b4","rgb":{"r":248,"g":196,"b":180},"luminance":138.4071970961048},{"name":"Apricot Orange","hex":"#c86b3c","rgb":{"r":200,"g":107,"b":60},"luminance":86.99308065012987},{"name":"Apricot Preserves","hex":"#eeb192","rgb":{"r":238,"g":177,"b":146},"luminance":127.02777326632156},{"name":"Apricot Sherbet","hex":"#facd9e","rgb":{"r":250,"g":205,"b":158},"luminance":142.80233495640047},{"name":"Apricot Sorbet","hex":"#e8a760","rgb":{"r":232,"g":167,"b":96},"luminance":120.58762540576042},{"name":"Apricot Tan","hex":"#dd9760","rgb":{"r":221,"g":151,"b":96},"luminance":111.0978089162878},{"name":"Apricot Wash","hex":"#fbac82","rgb":{"r":251,"g":172,"b":130},"luminance":126.67167835392408},{"name":"Apricot White","hex":"#f7f0db","rgb":{"r":247,"g":240,"b":219},"luminance":161.011618105651},{"name":"April Fool's Red","hex":"#1fb57a","rgb":{"r":31,"g":181,"b":122},"luminance":107.55357657465417},{"name":"April Showers","hex":"#dadeb5","rgb":{"r":218,"g":222,"b":181},"luminance":147.1604351583672},{"name":"April Sunshine","hex":"#fbe198","rgb":{"r":251,"g":225,"b":152},"luminance":152.89348452435766},{"name":"April Tears","hex":"#b4cbd4","rgb":{"r":180,"g":203,"b":212},"luminance":132.96626844805414},{"name":"April Wedding","hex":"#c5cfb1","rgb":{"r":197,"g":207,"b":177},"luminance":136.53260480192998},{"name":"Aqua","hex":"#00ffff","rgb":{"r":0,"g":255,"b":255},"luminance":152.48168455588365},{"name":"Aqua Belt","hex":"#7acad0","rgb":{"r":122,"g":202,"b":208},"luminance":126.30398609703495},{"name":"Aqua Bloom","hex":"#96d3d8","rgb":{"r":150,"g":211,"b":216},"luminance":134.00903075912458},{"name":"Aqua Clear","hex":"#8bd0dd","rgb":{"r":139,"g":208,"b":221},"luminance":131.41342234718644},{"name":"Aqua Cyan","hex":"#01f1f1","rgb":{"r":1,"g":241,"b":241},"luminance":144.11045127262628},{"name":"Aqua Deep","hex":"#014b43","rgb":{"r":1,"g":75,"b":67},"luminance":44.683655512950146},{"name":"Aqua Eden","hex":"#85c7a6","rgb":{"r":133,"g":199,"b":166},"luminance":124.83913262274773},{"name":"Aqua Experience","hex":"#038e85","rgb":{"r":3,"g":142,"b":133},"luminance":84.72650216431693},{"name":"Aqua Fiesta","hex":"#8cc3c3","rgb":{"r":140,"g":195,"b":195},"luminance":123.88974422848727},{"name":"Aqua Foam","hex":"#adc3b4","rgb":{"r":173,"g":195,"b":180},"luminance":127.27524957351291},{"name":"Aqua Forest","hex":"#5fa777","rgb":{"r":95,"g":167,"b":119},"luminance":102.95904633396718},{"name":"Aqua Frost","hex":"#a9d1d7","rgb":{"r":169,"g":209,"b":215},"luminance":134.92679700489447},{"name":"Aqua Glass","hex":"#d2e8e0","rgb":{"r":210,"g":232,"b":224},"luminance":152.12085081276663},{"name":"Aqua Green","hex":"#12e193","rgb":{"r":18,"g":225,"b":147},"luminance":133.24264374816343},{"name":"Aqua Grey","hex":"#a5b2aa","rgb":{"r":165,"g":178,"b":170},"luminance":117.16164398385676},{"name":"Aqua Haze","hex":"#d9ddd5","rgb":{"r":217,"g":221,"b":213},"luminance":147.06635829447876},{"name":"Aqua Island","hex":"#a1dad7","rgb":{"r":161,"g":218,"b":215},"luminance":138.90068602062408},{"name":"Aqua Lake","hex":"#30949d","rgb":{"r":48,"g":148,"b":157},"luminance":89.85409108104092},{"name":"Aqua Mist","hex":"#a0c9cb","rgb":{"r":160,"g":201,"b":203},"luminance":129.40305225534672},{"name":"Aqua Nation","hex":"#08787f","rgb":{"r":8,"g":120,"b":127},"luminance":71.95226020077479},{"name":"Aqua Oasis","hex":"#bce8dd","rgb":{"r":188,"g":232,"b":221},"luminance":149.4677504881906},{"name":"Aqua Obscura","hex":"#05696b","rgb":{"r":5,"g":105,"b":107},"luminance":62.84822554376535},{"name":"Aqua Sea","hex":"#6baaae","rgb":{"r":107,"g":170,"b":174},"luminance":106.65394059761692},{"name":"Aqua Sky","hex":"#7bc4c4","rgb":{"r":123,"g":196,"b":196},"luminance":122.83633326096964},{"name":"Aqua Smoke","hex":"#8c9fa0","rgb":{"r":140,"g":159,"b":160},"luminance":103.90383096402172},{"name":"Aqua Sparkle","hex":"#d3e4e6","rgb":{"r":211,"g":228,"b":230},"luminance":150.26571537446588},{"name":"Aqua Splash","hex":"#85ced1","rgb":{"r":133,"g":206,"b":209},"luminance":129.50375534709408},{"name":"Aqua Spring","hex":"#e8f3e8","rgb":{"r":232,"g":243,"b":232},"luminance":160.80382771874554},{"name":"Aqua Squeeze","hex":"#dbe4dc","rgb":{"r":219,"g":228,"b":220},"luminance":151.09216610069495},{"name":"Aqua Tint","hex":"#e5f1ee","rgb":{"r":229,"g":241,"b":238},"luminance":159.49086291697085},{"name":"Aqua Velvet","hex":"#00a29e","rgb":{"r":0,"g":162,"b":158},"luminance":96.7848179209942},{"name":"Aqua Verde","hex":"#56b3c3","rgb":{"r":86,"g":179,"b":195},"luminance":110.43422488069537},{"name":"Aqua Vitale","hex":"#7bbdc7","rgb":{"r":123,"g":189,"b":199},"luminance":119.06112536844257},{"name":"Aqua Whisper","hex":"#bfdfdf","rgb":{"r":191,"g":223,"b":223},"luminance":145.06132415637185},{"name":"Aqua Zing","hex":"#7cd8d6","rgb":{"r":124,"g":216,"b":214},"luminance":134.33542293825556},{"name":"Aquadulce","hex":"#7b9f82","rgb":{"r":123,"g":159,"b":130},"luminance":101.40625729214149},{"name":"Aqualogic","hex":"#57b7c5","rgb":{"r":87,"g":183,"b":197},"luminance":112.78434808961747},{"name":"Aquamarine","hex":"#2ee8bb","rgb":{"r":46,"g":232,"b":187},"luminance":138.52693418970912},{"name":"Aquamarine Blue","hex":"#71d9e2","rgb":{"r":113,"g":217,"b":226},"luminance":134.27864575575668},{"name":"Aquamarine Dream","hex":"#b3c4ba","rgb":{"r":179,"g":196,"b":186},"luminance":128.65096097969885},{"name":"Aquamentus Green","hex":"#00a800","rgb":{"r":0,"g":168,"b":0},"luminance":98.616},{"name":"Aquarelle","hex":"#61aab1","rgb":{"r":97,"g":170,"b":177},"luminance":105.86014260806567},{"name":"Aquarelle Beige","hex":"#e8e0d5","rgb":{"r":232,"g":224,"b":213},"luminance":150.63409007259943},{"name":"Aquarelle Blue","hex":"#bfe0e4","rgb":{"r":191,"g":224,"b":228},"luminance":145.69185320051358},{"name":"Aquarelle Green","hex":"#e2f4e4","rgb":{"r":226,"g":244,"b":228},"luminance":160.48703849220968},{"name":"Aquarelle Lilac","hex":"#edc8ff","rgb":{"r":237,"g":200,"b":255},"luminance":140.17628069327563},{"name":"Aquarelle Mint","hex":"#dbf4d8","rgb":{"r":219,"g":244,"b":216},"luminance":159.4000085351315},{"name":"Aquarelle Orange","hex":"#fbe8e0","rgb":{"r":251,"g":232,"b":224},"luminance":157.57703371049985},{"name":"Aquarelle Pink","hex":"#fbe9de","rgb":{"r":251,"g":233,"b":222},"luminance":158.04794749062702},{"name":"Aquarelle Purple","hex":"#d8e1f1","rgb":{"r":216,"g":225,"b":241},"luminance":149.56510073208923},{"name":"Aquarelle Red","hex":"#fedddd","rgb":{"r":254,"g":221,"b":221},"luminance":152.41924773794156},{"name":"Aquarelle Sky","hex":"#bce4eb","rgb":{"r":188,"g":228,"b":235},"luminance":147.61289896211642},{"name":"Aquarelle Yellow","hex":"#f4eeda","rgb":{"r":244,"g":238,"b":218},"luminance":159.55552724992012},{"name":"Aquarium","hex":"#356b6f","rgb":{"r":53,"g":107,"b":111},"luminance":66.00167881198175},{"name":"Aquarium Blue","hex":"#66cdaa","rgb":{"r":102,"g":205,"b":170},"luminance":125.64324346736676},{"name":"Aquarium Diver","hex":"#0a98ac","rgb":{"r":10,"g":152,"b":172},"luminance":91.40205654141485},{"name":"Aquarius","hex":"#3cadd4","rgb":{"r":60,"g":173,"b":212},"luminance":105.9176162165671},{"name":"Aquatic","hex":"#99c1cc","rgb":{"r":153,"g":193,"b":204},"luminance":124.37234510131262},{"name":"Aquatic Cool","hex":"#41a0b4","rgb":{"r":65,"g":160,"b":180},"luminance":98.08035493920278},{"name":"Aqueduct","hex":"#60b3bc","rgb":{"r":96,"g":179,"b":188},"luminance":111.01164609625422},{"name":"Aquella","hex":"#59b6d9","rgb":{"r":89,"g":182,"b":217},"luminance":112.84333175247883},{"name":"Aqueous","hex":"#388d95","rgb":{"r":56,"g":141,"b":149},"luminance":86.13513813189132},{"name":"Aquifer","hex":"#89acac","rgb":{"r":137,"g":172,"b":172},"luminance":110.70758930172764},{"name":"Arabella","hex":"#82acc4","rgb":{"r":130,"g":172,"b":196},"luminance":110.47108459683012},{"name":"Arabesque","hex":"#d16f52","rgb":{"r":209,"g":111,"b":82},"luminance":90.76312485806116},{"name":"Arabian Bake","hex":"#cd9945","rgb":{"r":205,"g":153,"b":69},"luminance":109.0181943622256},{"name":"Arabian Red","hex":"#a14c3f","rgb":{"r":161,"g":76,"b":63},"luminance":66.02404856565522},{"name":"Arabian Silk","hex":"#786e97","rgb":{"r":120,"g":110,"b":151},"luminance":75.84840865832321},{"name":"Arabian Spice","hex":"#884332","rgb":{"r":136,"g":67,"b":50},"luminance":56.85790303027363},{"name":"Arabic Coffee","hex":"#6f4d3f","rgb":{"r":111,"g":77,"b":63},"luminance":56.53353381843381},{"name":"Aragon","hex":"#b06455","rgb":{"r":176,"g":100,"b":85},"luminance":79.42840471770788},{"name":"Aragon Green","hex":"#47ba87","rgb":{"r":71,"g":186,"b":135},"luminance":112.28638236669661},{"name":"Aragonite White","hex":"#f3f1f3","rgb":{"r":243,"g":241,"b":243},"luminance":161.42909447184542},{"name":"Araigaki Orange","hex":"#ec8254","rgb":{"r":236,"g":130,"b":84},"luminance":104.37525555417817},{"name":"Arapawa","hex":"#274a5d","rgb":{"r":39,"g":74,"b":93},"luminance":46.208669846685694},{"name":"Arathi Highlands","hex":"#93a344","rgb":{"r":147,"g":163,"b":68},"luminance":105.57847069360307},{"name":"Araucana Egg","hex":"#add8e1","rgb":{"r":173,"g":216,"b":225},"luminance":139.3191167535884},{"name":"Arava","hex":"#a18d71","rgb":{"r":161,"g":141,"b":113},"luminance":96.61100110235893},{"name":"Arboretum","hex":"#70ba9f","rgb":{"r":112,"g":186,"b":159},"luminance":115.63177393778925},{"name":"Arc Light","hex":"#ccddff","rgb":{"r":204,"g":221,"b":255},"luminance":146.26917462336348},{"name":"Arcade Fire","hex":"#ee3311","rgb":{"r":238,"g":51,"b":17},"luminance":77.22700341849345},{"name":"Arcade Glow","hex":"#0022cc","rgb":{"r":0,"g":34,"b":204},"luminance":30.645771323300053},{"name":"Arcadia","hex":"#00a28a","rgb":{"r":0,"g":162,"b":138},"luminance":96.38653775294556},{"name":"Arcadian Green","hex":"#a3c893","rgb":{"r":163,"g":200,"b":147},"luminance":128.2142181390192},{"name":"Arcala Green","hex":"#3b6c3f","rgb":{"r":59,"g":108,"b":63},"luminance":66.19545921738137},{"name":"Arcane","hex":"#98687e","rgb":{"r":152,"g":104,"b":126},"luminance":77.45129762631483},{"name":"Arcavia Red","hex":"#6a0002","rgb":{"r":106,"g":0,"b":2},"luminance":31.694820081521204},{"name":"Arctic","hex":"#648589","rgb":{"r":100,"g":133,"b":137},"luminance":85.04712202655655},{"name":"Arctic Blue","hex":"#95d6dc","rgb":{"r":149,"g":214,"b":220},"luminance":135.6233015561854},{"name":"Arctic Cotton","hex":"#e6e3df","rgb":{"r":230,"g":227,"b":223},"luminance":152.08841831316414},{"name":"Arctic Daisy","hex":"#ebe4be","rgb":{"r":235,"g":228,"b":190},"luminance":152.70363689513093},{"name":"Arctic Dawn","hex":"#e3e5e8","rgb":{"r":227,"g":229,"b":232},"luminance":152.89141166854336},{"name":"Arctic Dusk","hex":"#735b6a","rgb":{"r":115,"g":91,"b":106},"luminance":64.66627536823192},{"name":"Arctic Fox","hex":"#e7e7e2","rgb":{"r":231,"g":231,"b":226},"luminance":154.34006889333693},{"name":"Arctic Glow","hex":"#c9d1e9","rgb":{"r":201,"g":209,"b":233},"luminance":139.17093135421635},{"name":"Arctic Grey","hex":"#bbccdd","rgb":{"r":187,"g":204,"b":221},"luminance":134.5384135070724},{"name":"Arctic Ice","hex":"#bfc7d6","rgb":{"r":191,"g":199,"b":214},"luminance":132.29466983215914},{"name":"Arctic Lime","hex":"#d0ff14","rgb":{"r":208,"g":255,"b":20},"luminance":162.10688600118132},{"name":"Arctic Nights","hex":"#345c61","rgb":{"r":52,"g":92,"b":97},"luminance":57.27522748972718},{"name":"Arctic Ocean","hex":"#66c3d0","rgb":{"r":102,"g":195,"b":208},"luminance":120.80820821864711},{"name":"Arctic Paradise","hex":"#b8dff8","rgb":{"r":184,"g":223,"b":248},"luminance":144.77961887296152},{"name":"Arctic Rose","hex":"#b7abb0","rgb":{"r":183,"g":171,"b":176},"luminance":116.06918761669696},{"name":"Arctic Water","hex":"#00fcfc","rgb":{"r":0,"g":252,"b":252},"luminance":150.68778238463793},{"name":"Arctic White","hex":"#e9eae7","rgb":{"r":233,"g":234,"b":231},"luminance":156.25040994826222},{"name":"Ardcoat","hex":"#e2dedf","rgb":{"r":226,"g":222,"b":223},"luminance":148.9773880694651},{"name":"Ardósia","hex":"#232f2c","rgb":{"r":35,"g":47,"b":44},"luminance":29.930409318951853},{"name":"Ares Red","hex":"#dd2200","rgb":{"r":221,"g":34,"b":0},"luminance":69.02721206162103},{"name":"Argan Oil","hex":"#8b593e","rgb":{"r":139,"g":89,"b":62},"luminance":67.1312475230425},{"name":"Argent","hex":"#888888","rgb":{"r":136,"g":136,"b":136},"luminance":90.92350156037766},{"name":"Argyle Purple","hex":"#895c79","rgb":{"r":137,"g":92,"b":121},"luminance":69.17133670097752},{"name":"Argyle Rose","hex":"#c48677","rgb":{"r":196,"g":134,"b":119},"luminance":99.02295762094768},{"name":"Aria","hex":"#e3e4e2","rgb":{"r":227,"g":228,"b":226},"luminance":152.25834204075647},{"name":"Ariel","hex":"#aed7ea","rgb":{"r":174,"g":215,"b":234},"luminance":139.0899553418578},{"name":"Ariel's Delight","hex":"#b2a5d3","rgb":{"r":178,"g":165,"b":211},"luminance":113.10202131261845},{"name":"Arizona Clay","hex":"#ad735a","rgb":{"r":173,"g":115,"b":90},"luminance":85.66139827250078},{"name":"Arizona Tree Frog","hex":"#669264","rgb":{"r":102,"g":146,"b":100},"luminance":91.67835517721726},{"name":"Armada","hex":"#536762","rgb":{"r":83,"g":103,"b":98},"luminance":66.3040692114745},{"name":"Armadillo","hex":"#484a46","rgb":{"r":72,"g":74,"b":70},"luminance":49.132423388227046},{"name":"Armadillo Egg","hex":"#7d4638","rgb":{"r":125,"g":70,"b":56},"luminance":55.91094866839588},{"name":"Armageddon Dunes","hex":"#926a25","rgb":{"r":146,"g":106,"b":37},"luminance":76.12516354005422},{"name":"Armageddon Dust","hex":"#d3a907","rgb":{"r":211,"g":169,"b":7},"luminance":117.5674016638966},{"name":"Armagnac","hex":"#ad916c","rgb":{"r":173,"g":145,"b":108},"luminance":100.35851283274378},{"name":"Armor","hex":"#74857f","rgb":{"r":116,"g":133,"b":127},"luminance":86.64683133848577},{"name":"Armor Wash","hex":"#030303","rgb":{"r":3,"g":3,"b":3},"luminance":2.005665475596566},{"name":"Armored Steel","hex":"#747769","rgb":{"r":116,"g":119,"b":105},"luminance":78.90312012208389},{"name":"Armory","hex":"#6a6b65","rgb":{"r":106,"g":107,"b":101},"luminance":71.28851459386708},{"name":"Army Canvas","hex":"#5b6f61","rgb":{"r":91,"g":111,"b":97},"luminance":71.4705792197041},{"name":"Army Green","hex":"#4b5320","rgb":{"r":75,"g":83,"b":32},"luminance":53.75801679749728},{"name":"Army Issue","hex":"#8a806b","rgb":{"r":138,"g":128,"b":107},"luminance":86.5838457450349},{"name":"Army Issue Green","hex":"#838254","rgb":{"r":131,"g":130,"b":84},"luminance":86.3083219452215},{"name":"Arnica","hex":"#bf8f37","rgb":{"r":191,"g":143,"b":55},"luminance":101.71942912737958},{"name":"Aroma","hex":"#d3c1c5","rgb":{"r":211,"g":193,"b":197},"luminance":131.60332201734118},{"name":"Aroma Garden","hex":"#a1c4a8","rgb":{"r":161,"g":196,"b":168},"luminance":126.17894090932923},{"name":"Aromatic","hex":"#706986","rgb":{"r":112,"g":105,"b":134},"luminance":71.78910463991036},{"name":"Arona","hex":"#879ba3","rgb":{"r":135,"g":155,"b":163},"luminance":101.25657595435469},{"name":"Arousing Alligator","hex":"#776600","rgb":{"r":119,"g":102,"b":0},"luminance":69.64842738353823},{"name":"Arragonite","hex":"#e4e0d4","rgb":{"r":228,"g":224,"b":212},"luminance":150.06867745135892},{"name":"Arraign","hex":"#5c546e","rgb":{"r":92,"g":84,"b":110},"luminance":57.837881427313704},{"name":"Arrow Creek","hex":"#927257","rgb":{"r":146,"g":114,"b":87},"luminance":80.51122383866736},{"name":"Arrow Quiver","hex":"#c7a998","rgb":{"r":199,"g":169,"b":152},"luminance":116.96949941758321},{"name":"Arrow Rock","hex":"#a28440","rgb":{"r":162,"g":132,"b":64},"luminance":91.66919720385904},{"name":"Arrow Shaft","hex":"#5c503a","rgb":{"r":92,"g":80,"b":58},"luminance":54.82381059357329},{"name":"Arrowhead","hex":"#514b40","rgb":{"r":81,"g":75,"b":64},"luminance":50.773932307828986},{"name":"Arrowtown","hex":"#827a67","rgb":{"r":130,"g":122,"b":103},"luminance":82.32445845555256},{"name":"Arrowwood","hex":"#bc8d1f","rgb":{"r":188,"g":141,"b":31},"luminance":100.11320786489661},{"name":"Arsenic","hex":"#3b444b","rgb":{"r":59,"g":68,"b":75},"luminance":44.47015220347238},{"name":"Art and Craft","hex":"#896956","rgb":{"r":137,"g":105,"b":86},"luminance":74.65225388425992},{"name":"Artemesia","hex":"#e3ebea","rgb":{"r":227,"g":235,"b":234},"luminance":156.03581681780628},{"name":"Artemis","hex":"#d2a96e","rgb":{"r":210,"g":169,"b":110},"luminance":118.07231220315794},{"name":"Artemis Silver","hex":"#ddddee","rgb":{"r":221,"g":221,"b":238},"luminance":148.09346438651505},{"name":"Arterial Blood Red","hex":"#711518","rgb":{"r":113,"g":21,"b":24},"luminance":36.06940523490788},{"name":"Artesian Pool","hex":"#a6bee1","rgb":{"r":166,"g":190,"b":225},"luminance":124.7413217662856},{"name":"Artesian Well","hex":"#5eb2aa","rgb":{"r":94,"g":178,"b":170},"luminance":109.92204434052343},{"name":"Artichoke","hex":"#8f9779","rgb":{"r":143,"g":151,"b":121},"luminance":99.37279936682874},{"name":"Artichoke Dip","hex":"#a19676","rgb":{"r":161,"g":150,"b":118},"luminance":101.24782528528698},{"name":"Artichoke Green","hex":"#4b6d41","rgb":{"r":75,"g":109,"b":65},"luminance":68.20273465191846},{"name":"Artichoke Mauve","hex":"#c19aa5","rgb":{"r":193,"g":154,"b":165},"luminance":108.88393983044514},{"name":"Artificial Strawberry","hex":"#ff43a4","rgb":{"r":255,"g":67,"b":164},"luminance":87.8043887399713},{"name":"Artificial Turf","hex":"#41b45c","rgb":{"r":65,"g":180,"b":92},"luminance":107.94328589124939},{"name":"Artillery","hex":"#746f67","rgb":{"r":116,"g":111,"b":103},"luminance":74.74148158151536},{"name":"Artisan Tile","hex":"#845e40","rgb":{"r":132,"g":94,"b":64},"luminance":68.23171054575724},{"name":"Artisans Gold","hex":"#f2ab46","rgb":{"r":242,"g":171,"b":70},"luminance":123.99557529605643},{"name":"Artist's Shadow","hex":"#a1969b","rgb":{"r":161,"g":150,"b":155},"luminance":101.89403672933956},{"name":"Artiste","hex":"#987387","rgb":{"r":152,"g":115,"b":135},"luminance":82.82087797771767},{"name":"Artistic Stone","hex":"#5c6b65","rgb":{"r":92,"g":107,"b":101},"luminance":69.52864690902592},{"name":"Arts & Crafts Gold","hex":"#f5c68b","rgb":{"r":245,"g":198,"b":139},"luminance":138.2963261153383},{"name":"Aruba Blue","hex":"#81d7d3","rgb":{"r":129,"g":215,"b":211},"luminance":134.14178686002361},{"name":"Arylide Yellow","hex":"#e9d66b","rgb":{"r":233,"g":214,"b":107},"luminance":144.1602026115391},{"name":"Asagi Blue","hex":"#48929b","rgb":{"r":72,"g":146,"b":155},"luminance":90.11390840486278},{"name":"Asagi Koi","hex":"#455559","rgb":{"r":69,"g":85,"b":89},"luminance":54.93715047215317},{"name":"Asagi Yellow","hex":"#f7bb7d","rgb":{"r":247,"g":187,"b":125},"luminance":133.06600418589264},{"name":"Asfar Yellow","hex":"#fcef01","rgb":{"r":252,"g":239,"b":1},"luminance":159.24653826378767},{"name":"Ash","hex":"#bebaa7","rgb":{"r":190,"g":186,"b":167},"luminance":124.5412809794407},{"name":"Ash Blue","hex":"#c0c6c9","rgb":{"r":192,"g":198,"b":201},"luminance":131.64046845860128},{"name":"Ash Brown","hex":"#98623c","rgb":{"r":152,"g":98,"b":60},"luminance":73.63115495495097},{"name":"Ash Cherry Blossom","hex":"#e8d3d1","rgb":{"r":232,"g":211,"b":209},"luminance":143.94496916877642},{"name":"Ash Grey","hex":"#c1b5a9","rgb":{"r":193,"g":181,"b":169},"luminance":122.43243693564219},{"name":"Ash Grove","hex":"#b9b3bf","rgb":{"r":185,"g":179,"b":191},"luminance":120.7236167036094},{"name":"Ash Hollow","hex":"#a88e8b","rgb":{"r":168,"g":142,"b":139},"luminance":98.60141406693923},{"name":"Ash in the Air","hex":"#d9dde5","rgb":{"r":217,"g":221,"b":229},"luminance":147.37849725791074},{"name":"Ash Plum","hex":"#e8d3c7","rgb":{"r":232,"g":211,"b":199},"luminance":143.76067080046616},{"name":"Ash Rose","hex":"#b5817d","rgb":{"r":181,"g":129,"b":125},"luminance":94.15891561610084},{"name":"Ash to Ash","hex":"#4e4e4c","rgb":{"r":78,"g":78,"b":76},"luminance":52.108908796865045},{"name":"Ash Tree","hex":"#aabb99","rgb":{"r":170,"g":187,"b":153},"luminance":122.21761585385308},{"name":"Ash Tree Bark","hex":"#cecfd6","rgb":{"r":206,"g":207,"b":214},"luminance":138.39589131545776},{"name":"Ash White","hex":"#e9e4d4","rgb":{"r":233,"g":228,"b":212},"luminance":152.80594886652807},{"name":"Ashberry","hex":"#b495a4","rgb":{"r":180,"g":149,"b":164},"luminance":104.3834717998975},{"name":"Ashen","hex":"#c9bfb2","rgb":{"r":201,"g":191,"b":178},"luminance":128.81722227248963},{"name":"Ashen Brown","hex":"#994444","rgb":{"r":153,"g":68,"b":68},"luminance":61.20595207167355},{"name":"Ashen Plum","hex":"#9b9092","rgb":{"r":155,"g":144,"b":146},"luminance":97.82568448521073},{"name":"Ashen Wind","hex":"#94a9b7","rgb":{"r":148,"g":169,"b":183},"luminance":110.61056801680388},{"name":"Ashenvale Nights","hex":"#104071","rgb":{"r":16,"g":64,"b":113},"luminance":40.00233998155608},{"name":"Ashes to Ashes","hex":"#bbb3a2","rgb":{"r":187,"g":179,"b":162},"luminance":120.44777259044683},{"name":"Ashley Blue","hex":"#8699ab","rgb":{"r":134,"g":153,"b":171},"luminance":100.25625223895015},{"name":"Ashlite","hex":"#a7a49f","rgb":{"r":167,"g":164,"b":159},"luminance":109.95173572527175},{"name":"Ashton Blue","hex":"#4a79ba","rgb":{"r":74,"g":121,"b":186},"luminance":77.3563457060893},{"name":"Ashton Skies","hex":"#7b8eb0","rgb":{"r":123,"g":142,"b":176},"luminance":93.28987694814481},{"name":"Ashwood","hex":"#bcc4bd","rgb":{"r":188,"g":196,"b":189},"luminance":129.84984314199227},{"name":"Asian Fusion","hex":"#ece0cd","rgb":{"r":236,"g":224,"b":205},"luminance":151.0447918334161},{"name":"Asian Violet","hex":"#8b818c","rgb":{"r":139,"g":129,"b":140},"luminance":87.84082792187242},{"name":"Āsmānī Sky","hex":"#88ddbb","rgb":{"r":136,"g":221,"b":187},"luminance":137.61218168825027},{"name":"Aspara","hex":"#70b2cc","rgb":{"r":112,"g":178,"b":204},"luminance":112.15886891369757},{"name":"Asparagus","hex":"#77ab56","rgb":{"r":119,"g":171,"b":86},"luminance":106.9470341150235},{"name":"Asparagus Cream","hex":"#96af54","rgb":{"r":150,"g":175,"b":84},"luminance":112.49732397261722},{"name":"Asparagus Fern","hex":"#b9cb5a","rgb":{"r":185,"g":203,"b":90},"luminance":131.7739000940626},{"name":"Asparagus Green","hex":"#d2cdb4","rgb":{"r":210,"g":205,"b":180},"luminance":137.27405699912856},{"name":"Asparagus Sprig","hex":"#576f44","rgb":{"r":87,"g":111,"b":68},"luminance":70.58473150760014},{"name":"Aspen Gold","hex":"#ffd662","rgb":{"r":255,"g":214,"b":98},"luminance":147.37026678743578},{"name":"Aspen Green","hex":"#7e9b76","rgb":{"r":126,"g":155,"b":118},"luminance":99.39092918873432},{"name":"Aspen Hush","hex":"#6a8d88","rgb":{"r":106,"g":141,"b":136},"luminance":89.97366248519619},{"name":"Aspen Yellow","hex":"#f6df9f","rgb":{"r":246,"g":223,"b":159},"luminance":151.2409157371113},{"name":"Asphalt","hex":"#130a06","rgb":{"r":19,"g":10,"b":6},"luminance":8.197470158530617},{"name":"Asphalt Blue","hex":"#474c55","rgb":{"r":71,"g":76,"b":85},"luminance":50.3467683669965},{"name":"Assassin","hex":"#2d4f83","rgb":{"r":45,"g":79,"b":131},"luminance":50.54222502027389},{"name":"Assateague Sand","hex":"#e1d0b2","rgb":{"r":225,"g":208,"b":178},"luminance":140.87272306944308},{"name":"Assault","hex":"#1c4374","rgb":{"r":28,"g":67,"b":116},"luminance":42.32888849237599},{"name":"Aster","hex":"#867ba9","rgb":{"r":134,"g":123,"b":169},"luminance":84.79060981618187},{"name":"Aster Petal","hex":"#d4dae2","rgb":{"r":212,"g":218,"b":226},"luminance":145.11071427017373},{"name":"Aster Purple","hex":"#7d74a8","rgb":{"r":125,"g":116,"b":168},"luminance":80.00131369546378},{"name":"Astilbe","hex":"#f091a9","rgb":{"r":240,"g":145,"b":169},"luminance":112.98335975266444},{"name":"Astorath Red","hex":"#dd482b","rgb":{"r":221,"g":72,"b":43},"luminance":78.59204502365363},{"name":"Astra","hex":"#edd5a6","rgb":{"r":237,"g":213,"b":166},"luminance":144.95666078521538},{"name":"Astral","hex":"#376f89","rgb":{"r":55,"g":111,"b":137},"luminance":68.99126464995406},{"name":"Astral Aura","hex":"#363151","rgb":{"r":54,"g":49,"b":81},"luminance":34.25303258107229},{"name":"Astral Spirit","hex":"#8ec2e7","rgb":{"r":142,"g":194,"b":231},"luminance":124.35578074219147},{"name":"Astro Arcade Green","hex":"#77ff77","rgb":{"r":119,"g":255,"b":119},"luminance":154.45272138101032},{"name":"Astro Bound","hex":"#899fb9","rgb":{"r":137,"g":159,"b":185},"luminance":104.08556267801985},{"name":"Astro Nautico","hex":"#5383c3","rgb":{"r":83,"g":131,"b":195},"luminance":83.80456430290656},{"name":"Astro Purple","hex":"#6d5acf","rgb":{"r":109,"g":90,"b":207},"luminance":66.40819064693753},{"name":"Astro Sunset","hex":"#937874","rgb":{"r":147,"g":120,"b":116},"luminance":84.07457395074923},{"name":"Astro Zinger","hex":"#797eb5","rgb":{"r":121,"g":126,"b":181},"luminance":84.8826215488188},{"name":"Astrogranite","hex":"#757679","rgb":{"r":117,"g":118,"b":121},"luminance":78.81537591739317},{"name":"Astrogranite Debris","hex":"#3b424c","rgb":{"r":59,"g":66,"b":76},"luminance":43.44205728323648},{"name":"Astrolab Reef","hex":"#2d96ce","rgb":{"r":45,"g":150,"b":206},"luminance":92.11589320524445},{"name":"Astronaut","hex":"#445172","rgb":{"r":68,"g":81,"b":114},"luminance":53.31982228965134},{"name":"Astronaut Blue","hex":"#214559","rgb":{"r":33,"g":69,"b":89},"luminance":42.90445214660129},{"name":"Astronomer","hex":"#e8f2eb","rgb":{"r":232,"g":242,"b":235},"luminance":160.34014606454616},{"name":"Astronomicon Grey","hex":"#6b7c85","rgb":{"r":107,"g":124,"b":133},"luminance":80.94152974215399},{"name":"Astroscopus Grey","hex":"#afb4b6","rgb":{"r":175,"g":180,"b":182},"luminance":119.71808856225529},{"name":"Astroturf","hex":"#67a159","rgb":{"r":103,"g":161,"b":89},"luminance":99.91481158466947},{"name":"Asurmen Blue Wash","hex":"#273e51","rgb":{"r":39,"g":62,"b":81},"luminance":39.316267790826736},{"name":"Aswad Black","hex":"#17181c","rgb":{"r":23,"g":24,"b":28},"luminance":15.998554215928387},{"name":"At The Beach","hex":"#e7d9b9","rgb":{"r":231,"g":217,"b":185},"luminance":146.42651570668477},{"name":"Atelier","hex":"#a3abb8","rgb":{"r":163,"g":171,"b":184},"luminance":113.53779051047276},{"name":"Ateneo Blue","hex":"#003a6c","rgb":{"r":0,"g":58,"b":108},"luminance":36.203804496212825},{"name":"Athena Blue","hex":"#66ddff","rgb":{"r":102,"g":221,"b":255},"luminance":136.39753455616417},{"name":"Athens Grey","hex":"#dcdddd","rgb":{"r":220,"g":221,"b":221},"luminance":147.61720958275833},{"name":"Athonian Camoshade","hex":"#6d8e44","rgb":{"r":109,"g":142,"b":68},"luminance":89.8340475599313},{"name":"Aths Special","hex":"#d5cbb2","rgb":{"r":213,"g":203,"b":178},"luminance":136.62775396675448},{"name":"Atlantic Breeze","hex":"#cbe1ee","rgb":{"r":203,"g":225,"b":238},"luminance":147.86506300678332},{"name":"Atlantic Charter","hex":"#2b2f41","rgb":{"r":43,"g":47,"b":65},"luminance":31.326721341372448},{"name":"Atlantic Deep","hex":"#274e55","rgb":{"r":39,"g":78,"b":85},"luminance":48.23103582756646},{"name":"Atlantic Depths","hex":"#001166","rgb":{"r":0,"g":17,"b":102},"luminance":15.322885661650027},{"name":"Atlantic Fig Snail","hex":"#d7ceb9","rgb":{"r":215,"g":206,"b":185},"luminance":138.56218607181398},{"name":"Atlantic Gull","hex":"#4b8eb0","rgb":{"r":75,"g":142,"b":176},"luminance":88.61903879528371},{"name":"Atlantic Mystique","hex":"#00629a","rgb":{"r":0,"g":98,"b":154},"luminance":60.1452725656805},{"name":"Atlantic Ocean","hex":"#a7d8e4","rgb":{"r":167,"g":216,"b":228},"luminance":138.72670909741927},{"name":"Atlantic Sand","hex":"#dcd5d2","rgb":{"r":220,"g":213,"b":210},"luminance":143.29299690145362},{"name":"Atlantic Wave","hex":"#3d797c","rgb":{"r":61,"g":121,"b":124},"luminance":74.68147257519766},{"name":"Atlantis","hex":"#336172","rgb":{"r":51,"g":97,"b":114},"luminance":60.36122710813623},{"name":"Atlantis Myth","hex":"#006477","rgb":{"r":0,"g":100,"b":119},"luminance":60.247210358654776},{"name":"Atmosphere","hex":"#a89c94","rgb":{"r":168,"g":156,"b":148},"luminance":105.79862660734305},{"name":"Atoll","hex":"#2b797a","rgb":{"r":43,"g":121,"b":122},"luminance":73.50897660830275},{"name":"Atom Blue","hex":"#8f9cac","rgb":{"r":143,"g":156,"b":172},"luminance":102.94690814686955},{"name":"Atomic","hex":"#3d4b52","rgb":{"r":61,"g":75,"b":82},"luminance":48.56178384285322},{"name":"Atomic Pink","hex":"#fb7efd","rgb":{"r":251,"g":126,"b":253},"luminance":109.245552811087},{"name":"Atomic Tangerine","hex":"#ff9966","rgb":{"r":255,"g":153,"b":102},"luminance":118.38296385037839},{"name":"Atrium White","hex":"#f1eee4","rgb":{"r":241,"g":238,"b":228},"luminance":159.32937576291445},{"name":"Attar of Rose","hex":"#994240","rgb":{"r":153,"g":66,"b":64},"luminance":60.390083531983954},{"name":"Attica","hex":"#a1bca9","rgb":{"r":161,"g":188,"b":169},"luminance":121.93026208862179},{"name":"Attitude","hex":"#a48884","rgb":{"r":164,"g":136,"b":132},"luminance":94.89004069974888},{"name":"Attorney","hex":"#3f4258","rgb":{"r":63,"g":66,"b":88},"luminance":44.23139334228574},{"name":"Au Chico","hex":"#9e6759","rgb":{"r":158,"g":103,"b":89},"luminance":77.39690175323557},{"name":"Au Naturel","hex":"#e8cac0","rgb":{"r":232,"g":202,"b":192},"luminance":139.1071437561709},{"name":"Aubergine","hex":"#372528","rgb":{"r":55,"g":37,"b":40},"luminance":27.621487758627335},{"name":"Aubergine Flesh","hex":"#f2e4dd","rgb":{"r":242,"g":228,"b":221},"luminance":154.21573426858882},{"name":"Aubergine Perl","hex":"#5500aa","rgb":{"r":85,"g":0,"b":170},"luminance":31.961017271044422},{"name":"Auburn","hex":"#712f2c","rgb":{"r":113,"g":47,"b":44},"luminance":43.90756820868129},{"name":"Auburn Lights","hex":"#78342f","rgb":{"r":120,"g":52,"b":47},"luminance":47.41093903309657},{"name":"August Morning","hex":"#ffd79d","rgb":{"r":255,"g":215,"b":157},"luminance":148.53060443558422},{"name":"Aumbry","hex":"#7c7469","rgb":{"r":124,"g":116,"b":105},"luminance":78.45018253643518},{"name":"Aunt Violet","hex":"#7c0087","rgb":{"r":124,"g":0,"b":135},"luminance":40.14326688250472},{"name":"Aura","hex":"#b2a8a1","rgb":{"r":178,"g":168,"b":161},"luminance":113.55424279171606},{"name":"Aura Orange","hex":"#b4262a","rgb":{"r":180,"g":38,"b":42},"luminance":58.455752326011506},{"name":"Aureolin","hex":"#fdee00","rgb":{"r":253,"g":238,"b":0},"luminance":158.8717565994661},{"name":"Auric Armour Gold","hex":"#e8bc6d","rgb":{"r":232,"g":188,"b":109},"luminance":130.93804502893724},{"name":"Auricula Purple","hex":"#533552","rgb":{"r":83,"g":53,"b":82},"luminance":40.87985951541419},{"name":"AuroMetalSaurus","hex":"#6e7f80","rgb":{"r":110,"g":127,"b":128},"luminance":82.7782094817229},{"name":"Aurora","hex":"#eddd59","rgb":{"r":237,"g":221,"b":89},"luminance":148.1674748856847},{"name":"Aurora Green","hex":"#6adc99","rgb":{"r":106,"g":220,"b":153},"luminance":134.11141860408455},{"name":"Aurora Pink","hex":"#e881a6","rgb":{"r":232,"g":129,"b":166},"luminance":104.4222674002054},{"name":"Aurora Red","hex":"#b93a32","rgb":{"r":185,"g":58,"b":50},"luminance":65.20252557225065},{"name":"Australian Mint","hex":"#eff8aa","rgb":{"r":239,"g":248,"b":170},"luminance":163.3236991284486},{"name":"Australien","hex":"#cc9911","rgb":{"r":204,"g":153,"b":17},"luminance":108.58307225806423},{"name":"Austrian Ice","hex":"#dee6e7","rgb":{"r":222,"g":230,"b":231},"luminance":152.73250649419722},{"name":"Autumn Avenue","hex":"#e3ad59","rgb":{"r":227,"g":173,"b":89},"luminance":122.56545616934649},{"name":"Autumn Bark","hex":"#9d6f46","rgb":{"r":157,"g":111,"b":70},"luminance":80.70167469142137},{"name":"Autumn Blaze","hex":"#d9922e","rgb":{"r":217,"g":146,"b":46},"luminance":107.62033278614221},{"name":"Autumn Blonde","hex":"#eed0ae","rgb":{"r":238,"g":208,"b":174},"luminance":142.7057474525816},{"name":"Autumn Bloom","hex":"#ffe0cb","rgb":{"r":255,"g":224,"b":203},"luminance":153.74637014576962},{"name":"Autumn Fall","hex":"#67423b","rgb":{"r":103,"g":66,"b":59},"luminance":49.94633969571744},{"name":"Autumn Fern","hex":"#507b49","rgb":{"r":80,"g":123,"b":73},"luminance":76.51409337501163},{"name":"Autumn Festival","hex":"#a28b36","rgb":{"r":162,"g":139,"b":54},"luminance":95.08708550060832},{"name":"Autumn Glaze","hex":"#b3573f","rgb":{"r":179,"g":87,"b":63},"luminance":74.32443290062831},{"name":"Autumn Glory","hex":"#ff8812","rgb":{"r":255,"g":136,"b":18},"luminance":110.41131714185823},{"name":"Autumn Glow","hex":"#e5c382","rgb":{"r":229,"g":195,"b":130},"luminance":134.20188696885},{"name":"Autumn Grey","hex":"#b2aba7","rgb":{"r":178,"g":171,"b":167},"luminance":115.1979550903574},{"name":"Autumn Laurel","hex":"#9d8d66","rgb":{"r":157,"g":141,"b":102},"luminance":95.86048154479508},{"name":"Autumn Leaf","hex":"#b56a4c","rgb":{"r":181,"g":106,"b":76},"luminance":82.91868511379084},{"name":"Autumn Maple","hex":"#c46215","rgb":{"r":196,"g":98,"b":21},"luminance":82.15473649157423},{"name":"Autumn Meadow","hex":"#acb78e","rgb":{"r":172,"g":183,"b":142},"luminance":120.19218680513305},{"name":"Autumn Night","hex":"#3b5861","rgb":{"r":59,"g":88,"b":97},"luminance":55.694044394351536},{"name":"Autumn Pine Green","hex":"#158078","rgb":{"r":21,"g":128,"b":120},"luminance":76.62888970225264},{"name":"Autumn Ridge","hex":"#9b423f","rgb":{"r":155,"g":66,"b":63},"luminance":60.83077110311852},{"name":"Autumn Robin","hex":"#c2452d","rgb":{"r":194,"g":69,"b":45},"luminance":70.93310894779673},{"name":"Autumn Sage","hex":"#aea26e","rgb":{"r":174,"g":162,"b":110},"luminance":109.11839951172304},{"name":"Autumn Sunset","hex":"#f38554","rgb":{"r":243,"g":133,"b":84},"luminance":107.07857146040004},{"name":"Autumn Umber","hex":"#ae704f","rgb":{"r":174,"g":112,"b":79},"luminance":84.32132736146887},{"name":"Autumn Wisteria","hex":"#c9a0dc","rgb":{"r":201,"g":160,"b":220},"luminance":114.28850598813511},{"name":"Autumnal","hex":"#a15325","rgb":{"r":161,"g":83,"b":37},"luminance":68.6213573605186},{"name":"Avagddu Green","hex":"#106b21","rgb":{"r":16,"g":107,"b":33},"luminance":63.10316775725288},{"name":"Avalon","hex":"#799b96","rgb":{"r":121,"g":155,"b":150},"luminance":99.39617832693568},{"name":"Avant-Garde Pink","hex":"#ff77ee","rgb":{"r":255,"g":119,"b":238},"luminance":106.9059729762561},{"name":"Aventurine","hex":"#576e6a","rgb":{"r":87,"g":110,"b":106},"luminance":70.65397458742147},{"name":"Averland Sunset","hex":"#ffaa1d","rgb":{"r":255,"g":170,"b":29},"luminance":125.627519919005},{"name":"Aviva","hex":"#c5b47f","rgb":{"r":197,"g":180,"b":127},"luminance":121.83271930397022},{"name":"Avocado","hex":"#568203","rgb":{"r":86,"g":130,"b":3},"luminance":80.52665931230477},{"name":"Avocado Cream","hex":"#b7bf6b","rgb":{"r":183,"g":191,"b":107},"luminance":125.35135811789195},{"name":"Avocado Green","hex":"#87a922","rgb":{"r":135,"g":169,"b":34},"luminance":107.17085336041697},{"name":"Avocado Pear","hex":"#555337","rgb":{"r":85,"g":83,"b":55},"luminance":55.30796476096367},{"name":"Avocado Peel","hex":"#39373b","rgb":{"r":57,"g":55,"b":59},"luminance":37.12174766898778},{"name":"Avocado Toast","hex":"#90b134","rgb":{"r":144,"g":177,"b":52},"luminance":112.62309941126642},{"name":"Awaken","hex":"#a7a3bb","rgb":{"r":167,"g":163,"b":187},"luminance":110.01188742131461},{"name":"Awakened","hex":"#e3dae9","rgb":{"r":227,"g":218,"b":233},"luminance":147.26704019908868},{"name":"Awakening","hex":"#bb9e9b","rgb":{"r":187,"g":158,"b":155},"luminance":109.72835998501024},{"name":"Awareness","hex":"#e3ebb1","rgb":{"r":227,"g":235,"b":177},"luminance":155.0571470071599},{"name":"Awesome Aura","hex":"#ccc1da","rgb":{"r":204,"g":193,"b":218},"luminance":131.04573476843876},{"name":"Awkward Purple","hex":"#d208cc","rgb":{"r":210,"g":8,"b":204},"luminance":67.12285789505688},{"name":"Axe Handle","hex":"#6b4730","rgb":{"r":107,"g":71,"b":48},"luminance":52.824872569652264},{"name":"Axinite","hex":"#756050","rgb":{"r":117,"g":96,"b":80},"luminance":66.95171837227181},{"name":"Axis","hex":"#bab6cb","rgb":{"r":186,"g":182,"b":203},"luminance":122.64572033299817},{"name":"Axolotl","hex":"#fff0df","rgb":{"r":255,"g":240,"b":223},"luminance":162.1935649432492},{"name":"Ayame Iris","hex":"#763568","rgb":{"r":118,"g":53,"b":104},"luminance":48.51060276887929},{"name":"Ayrshire","hex":"#a07254","rgb":{"r":160,"g":114,"b":84},"luminance":82.8153614977318},{"name":"Azalea","hex":"#d42e5b","rgb":{"r":212,"g":46,"b":91},"luminance":69.67615391222452},{"name":"Azalea Leaf","hex":"#4a6871","rgb":{"r":74,"g":104,"b":113},"luminance":66.19942676488974},{"name":"Azalea Pink","hex":"#f9c0c4","rgb":{"r":249,"g":192,"b":196},"luminance":136.91017987352146},{"name":"Azeitona","hex":"#a5b546","rgb":{"r":165,"g":181,"b":70},"luminance":117.41400101350776},{"name":"Azraq Blue","hex":"#4c6cb3","rgb":{"r":76,"g":108,"b":179},"luminance":70.36929606014259},{"name":"Azshara Vein","hex":"#b13916","rgb":{"r":177,"g":57,"b":22},"luminance":62.66289710825696},{"name":"Aztec","hex":"#293432","rgb":{"r":41,"g":52,"b":50},"luminance":33.383943101437254},{"name":"Aztec Aura","hex":"#ffefbc","rgb":{"r":255,"g":239,"b":188},"luminance":161.10479973607238},{"name":"Aztec Brick","hex":"#9e8352","rgb":{"r":158,"g":131,"b":82},"luminance":90.73224496836832},{"name":"Aztec Glimmer","hex":"#e7b347","rgb":{"r":231,"g":179,"b":71},"luminance":126.00148779280346},{"name":"Aztec Gold","hex":"#c39953","rgb":{"r":195,"g":153,"b":83},"luminance":107.49427049847819},{"name":"Aztec Jade","hex":"#33bb88","rgb":{"r":51,"g":187,"b":136},"luminance":111.90236538161291},{"name":"Azuki Bean","hex":"#96514d","rgb":{"r":150,"g":81,"b":77},"luminance":65.94916976732914},{"name":"Azuki Red","hex":"#672422","rgb":{"r":103,"g":36,"b":34},"luminance":37.550499450739665},{"name":"Azul","hex":"#1d5dec","rgb":{"r":29,"g":93,"b":236},"luminance":61.47510665301849},{"name":"Azul Petróleo","hex":"#36454f","rgb":{"r":54,"g":69,"b":79},"luminance":44.52296442286834},{"name":"Azure","hex":"#007fff","rgb":{"r":0,"g":127,"b":255},"luminance":80.01636270788619},{"name":"Azure Blue","hex":"#4d91c6","rgb":{"r":77,"g":145,"b":198},"luminance":91.01712442172627},{"name":"Azure Dragon","hex":"#053976","rgb":{"r":5,"g":57,"b":118},"luminance":36.09288032285591},{"name":"Azure Hint","hex":"#dddce1","rgb":{"r":221,"g":220,"b":225},"luminance":147.31427745130475},{"name":"Azure Mist","hex":"#f0fff1","rgb":{"r":240,"g":255,"b":241},"luminance":168.25551254268015},{"name":"Azure Radiance","hex":"#007f1f","rgb":{"r":0,"g":127,"b":31},"luminance":74.63271773826811},{"name":"Azure Sky","hex":"#b0e0f6","rgb":{"r":176,"g":224,"b":246},"luminance":144.37744095252555},{"name":"Azure Tide","hex":"#2b9890","rgb":{"r":43,"g":152,"b":144},"luminance":91.6281053007209},{"name":"Azureish White","hex":"#dbe9f4","rgb":{"r":219,"g":233,"b":244},"luminance":154.16808248791318},{"name":"Azuremyst Isle","hex":"#cc81f0","rgb":{"r":204,"g":129,"b":240},"luminance":101.01016951277728},{"name":"B'dazzled Blue","hex":"#2e5894","rgb":{"r":46,"g":88,"b":148},"luminance":56.055144598868},{"name":"Baal Red Wash","hex":"#610023","rgb":{"r":97,"g":0,"b":35},"luminance":29.27616964358555},{"name":"Baba Ganoush","hex":"#eebb88","rgb":{"r":238,"g":187,"b":136},"luminance":131.73320621999602},{"name":"Babbling Brook","hex":"#becfcd","rgb":{"r":190,"g":207,"b":205},"luminance":136.15421433433488},{"name":"Babe","hex":"#dc7b7c","rgb":{"r":220,"g":123,"b":124},"luminance":98.69052283274215},{"name":"Babiana","hex":"#876fa3","rgb":{"r":135,"g":111,"b":163},"luminance":78.86734811060911},{"name":"Baby Barn Owl","hex":"#c3c3b8","rgb":{"r":195,"g":195,"b":184},"luminance":130.1602928162041},{"name":"Baby Bear","hex":"#6f5944","rgb":{"r":111,"g":89,"b":68},"luminance":62.377353855385685},{"name":"Baby Berries","hex":"#9c4a62","rgb":{"r":156,"g":74,"b":98},"luminance":64.70962960796484},{"name":"Baby Blue","hex":"#a2cffe","rgb":{"r":162,"g":207,"b":254},"luminance":133.97435150430846},{"name":"Baby Blue Eyes","hex":"#a1caf1","rgb":{"r":161,"g":202,"b":241},"luminance":130.88918012196424},{"name":"Baby Breath","hex":"#f0d0b0","rgb":{"r":240,"g":208,"b":176},"luminance":143.0366907894614},{"name":"Baby Bunting","hex":"#abcaea","rgb":{"r":171,"g":202,"b":234},"luminance":131.85437836112987},{"name":"Baby Burro","hex":"#8c665c","rgb":{"r":140,"g":102,"b":92},"luminance":73.80483466548787},{"name":"Baby Cake","hex":"#87bea3","rgb":{"r":135,"g":190,"b":163},"luminance":120.0565068998761},{"name":"Baby Chick","hex":"#ffeda2","rgb":{"r":255,"g":237,"b":162},"luminance":159.71369136677043},{"name":"Baby Fish Mouth","hex":"#f3acb9","rgb":{"r":243,"g":172,"b":185},"luminance":126.16480113327964},{"name":"Baby Frog","hex":"#c8ba63","rgb":{"r":200,"g":186,"b":99},"luminance":124.99649163076536},{"name":"Baby Girl","hex":"#ffdfe8","rgb":{"r":255,"g":223,"b":232},"luminance":153.77863482941964},{"name":"Baby Grass","hex":"#8abd7b","rgb":{"r":138,"g":189,"b":123},"luminance":119.1952951126847},{"name":"Baby Green","hex":"#8cff9e","rgb":{"r":140,"g":255,"b":158},"luminance":156.4681787744716},{"name":"Baby Jane","hex":"#d0a7a8","rgb":{"r":208,"g":167,"b":168},"luminance":117.66192591063601},{"name":"Baby Melon","hex":"#ffa468","rgb":{"r":255,"g":164,"b":104},"luminance":123.37500794326215},{"name":"Baby Motive","hex":"#8fcbdc","rgb":{"r":143,"g":203,"b":220},"luminance":129.06010758557423},{"name":"Baby Pink","hex":"#ffb7ce","rgb":{"r":255,"g":183,"b":206},"luminance":133.8060892560574},{"name":"Baby Powder","hex":"#fefefa","rgb":{"r":254,"g":254,"b":250},"luminance":169.73584924817737},{"name":"Baby Purple","hex":"#ca9bf7","rgb":{"r":202,"g":155,"b":247},"luminance":112.77881712892719},{"name":"Baby Seal","hex":"#a1a5a8","rgb":{"r":161,"g":165,"b":168},"luminance":109.84103718556193},{"name":"Baby Shoes","hex":"#005784","rgb":{"r":0,"g":87,"b":132},"luminance":53.23988227823198},{"name":"Baby Steps","hex":"#f5c9da","rgb":{"r":245,"g":201,"b":218},"luminance":141.08454592194002},{"name":"Baby Tears","hex":"#66b9d6","rgb":{"r":102,"g":185,"b":214},"luminance":115.40436233089285},{"name":"Baby Tone","hex":"#dcc2cb","rgb":{"r":220,"g":194,"b":203},"luminance":133.5318667884187},{"name":"Baby Tooth","hex":"#eeffdd","rgb":{"r":238,"g":255,"b":221},"luminance":167.64357161847872},{"name":"Baby's Blanket","hex":"#ffaec1","rgb":{"r":255,"g":174,"b":193},"luminance":129.34279675729914},{"name":"Baby's Booties","hex":"#e8c1c2","rgb":{"r":232,"g":193,"b":194},"luminance":134.66954949430848},{"name":"Baby's Breath","hex":"#d8e4e8","rgb":{"r":216,"g":228,"b":232},"luminance":150.93927472993897},{"name":"Babyccino","hex":"#eeccbb","rgb":{"r":238,"g":204,"b":187},"luminance":140.91866757814594},{"name":"Baca Berry","hex":"#945759","rgb":{"r":148,"g":87,"b":89},"luminance":68.33171724023917},{"name":"Bacchanalia Red","hex":"#8a3a3c","rgb":{"r":138,"g":58,"b":60},"luminance":53.93021750373347},{"name":"Bachelor Blue","hex":"#8faaca","rgb":{"r":143,"g":170,"b":202},"luminance":110.97970054473926},{"name":"Bachelor Button","hex":"#4abbd5","rgb":{"r":74,"g":187,"b":213},"luminance":114.57926846074729},{"name":"Bachimitsu Gold","hex":"#fddea5","rgb":{"r":253,"g":222,"b":165},"luminance":151.84868555572024},{"name":"Back In Black","hex":"#16141c","rgb":{"r":22,"g":20,"b":28},"luminance":13.83063801854419},{"name":"Back To Basics","hex":"#726747","rgb":{"r":114,"g":103,"b":71},"luminance":69.87775578107815},{"name":"Backcountry","hex":"#7c725f","rgb":{"r":124,"g":114,"b":95},"luminance":77.26536999199575},{"name":"Backdrop","hex":"#a7a799","rgb":{"r":167,"g":167,"b":153},"luminance":111.38766850060198},{"name":"Backlight","hex":"#fcf0e5","rgb":{"r":252,"g":240,"b":229},"luminance":161.8827314447097},{"name":"Backwoods","hex":"#4a6546","rgb":{"r":74,"g":101,"b":70},"luminance":63.78235371166542},{"name":"Backyard","hex":"#879877","rgb":{"r":135,"g":152,"b":119},"luminance":98.8650178627405},{"name":"Bacon Strips","hex":"#df3f32","rgb":{"r":223,"g":63,"b":50},"luminance":76.45852921682445},{"name":"Bad Hair Day","hex":"#f1c983","rgb":{"r":241,"g":201,"b":131},"luminance":139.0555860294724},{"name":"Bad Moon Yellow","hex":"#f2e5b4","rgb":{"r":242,"g":229,"b":180},"luminance":154.03341680622424},{"name":"Badab Black Wash","hex":"#0a0908","rgb":{"r":10,"g":9,"b":8},"luminance":6.138561150628052},{"name":"Badlands Orange","hex":"#ff6316","rgb":{"r":255,"g":99,"b":22},"luminance":95.89948309558294},{"name":"Badlands Sunset","hex":"#936a5b","rgb":{"r":147,"g":106,"b":91},"luminance":76.88344014805789},{"name":"Badshahi Brown","hex":"#d3a194","rgb":{"r":211,"g":161,"b":148},"luminance":114.87584321344501},{"name":"Bagpiper","hex":"#1c5544","rgb":{"r":28,"g":85,"b":68},"luminance":51.1829552976379},{"name":"Bahama Blue","hex":"#25597f","rgb":{"r":37,"g":89,"b":127},"luminance":55.3293186475308},{"name":"Bahaman Bliss","hex":"#3fa49b","rgb":{"r":63,"g":164,"b":155},"luminance":99.67240988859456},{"name":"Baharroth Blue","hex":"#58c1cd","rgb":{"r":88,"g":193,"b":205},"luminance":118.63106222655178},{"name":"Bahia","hex":"#a9c01c","rgb":{"r":169,"g":192,"b":28},"luminance":123.55469412774247},{"name":"Bahia Grass","hex":"#c4c5ad","rgb":{"r":196,"g":197,"b":173},"luminance":131.13262149823743},{"name":"Bái Sè White","hex":"#ecefef","rgb":{"r":236,"g":239,"b":239},"luminance":159.38553403932238},{"name":"Baikō Brown","hex":"#887938","rgb":{"r":136,"g":121,"b":56},"luminance":82.09233265658858},{"name":"Bainganī","hex":"#8273fd","rgb":{"r":130,"g":115,"b":253},"luminance":83.06420943462955},{"name":"Baja Blue","hex":"#66a6d9","rgb":{"r":102,"g":166,"b":217},"luminance":105.05731774607611},{"name":"Baja White","hex":"#fff8d1","rgb":{"r":255,"g":248,"b":209},"luminance":166.05225104466365},{"name":"Baked Apple","hex":"#b34646","rgb":{"r":179,"g":70,"b":70},"luminance":67.94531581352757},{"name":"Baked Bean","hex":"#b2754d","rgb":{"r":178,"g":117,"b":77},"luminance":87.32948877097587},{"name":"Baked Bread","hex":"#dacba9","rgb":{"r":218,"g":203,"b":169},"luminance":137.18314692774766},{"name":"Baked Clay","hex":"#9c5642","rgb":{"r":156,"g":86,"b":66},"luminance":69.14264701325803},{"name":"Baked Potato","hex":"#b69e87","rgb":{"r":182,"g":158,"b":135},"luminance":108.6277650511139},{"name":"Baked Salmon","hex":"#df9876","rgb":{"r":223,"g":152,"b":118},"luminance":112.1949232764121},{"name":"Bakelite","hex":"#e6d4a5","rgb":{"r":230,"g":212,"b":165},"luminance":143.42049412827998},{"name":"Bakelite Yellow","hex":"#c6b788","rgb":{"r":198,"g":183,"b":136},"luminance":123.63058707698511},{"name":"Baker-Miller Pink","hex":"#ff92ae","rgb":{"r":255,"g":146,"b":174},"luminance":116.41133847267626},{"name":"Baker's Chocolate","hex":"#5c3317","rgb":{"r":92,"g":51,"b":23},"luminance":40.74050707833667},{"name":"Baklava","hex":"#efb435","rgb":{"r":239,"g":180,"b":53},"luminance":127.69970980781436},{"name":"Bakos Blue","hex":"#273f4b","rgb":{"r":39,"g":63,"b":75},"luminance":39.70737692167539},{"name":"Balanced","hex":"#d7d2d1","rgb":{"r":215,"g":210,"b":209},"luminance":141.05223288200722},{"name":"Balcony Rose","hex":"#e2bcb8","rgb":{"r":226,"g":188,"b":184},"luminance":131.0903687842856},{"name":"Baleine Blue","hex":"#155187","rgb":{"r":21,"g":81,"b":135},"luminance":50.36859289279382},{"name":"Bali Batik","hex":"#6f5937","rgb":{"r":111,"g":89,"b":55},"luminance":62.2105591519639},{"name":"Bali Hai","hex":"#849ca9","rgb":{"r":132,"g":156,"b":169},"luminance":101.55950454782652},{"name":"Bali Sand","hex":"#f6e8d5","rgb":{"r":246,"g":232,"b":213},"luminance":156.67127463578},{"name":"Balinese Sunset","hex":"#f1a177","rgb":{"r":241,"g":161,"b":119},"luminance":119.6165075815207},{"name":"Ball Blue","hex":"#21abcd","rgb":{"r":33,"g":171,"b":205},"luminance":103.53287747377641},{"name":"Ballad Blue","hex":"#c0ceda","rgb":{"r":192,"g":206,"b":218},"luminance":136.14488771892977},{"name":"Ballerina","hex":"#f2cfdc","rgb":{"r":242,"g":207,"b":220},"luminance":143.62842213503563},{"name":"Ballerina Silk","hex":"#f0dee0","rgb":{"r":240,"g":222,"b":224},"luminance":150.94145716800273},{"name":"Ballerina Tears","hex":"#f2bbb1","rgb":{"r":242,"g":187,"b":177},"luminance":133.0115228429477},{"name":"Ballet Blue","hex":"#afc4d9","rgb":{"r":175,"g":196,"b":217},"luminance":128.7898946851033},{"name":"Ballet Shoes","hex":"#edb9bd","rgb":{"r":237,"g":185,"b":189},"luminance":131.4483507313804},{"name":"Ballet Slipper","hex":"#ebced5","rgb":{"r":235,"g":206,"b":213},"luminance":141.9468767990335},{"name":"Ballie Scott Sage","hex":"#b2b29c","rgb":{"r":178,"g":178,"b":156},"luminance":118.60091119380154},{"name":"Ballyhoo","hex":"#58a83b","rgb":{"r":88,"g":168,"b":59},"luminance":102.28722244738098},{"name":"Balor Brown","hex":"#9c6b08","rgb":{"r":156,"g":107,"b":8},"luminance":78.2397914171555},{"name":"Balsa Stone","hex":"#cbbb92","rgb":{"r":203,"g":187,"b":146},"luminance":126.53213783857443},{"name":"Balsam","hex":"#bec4b7","rgb":{"r":190,"g":196,"b":183},"luminance":129.99831478907717},{"name":"Balsam Green","hex":"#576664","rgb":{"r":87,"g":102,"b":100},"luminance":66.26863545448933},{"name":"Balsam Pear","hex":"#b19338","rgb":{"r":177,"g":147,"b":56},"luminance":101.42677608008647},{"name":"Balsamic Reduction","hex":"#434340","rgb":{"r":67,"g":67,"b":64},"luminance":44.736148090777775},{"name":"Balthasar Gold","hex":"#a47552","rgb":{"r":164,"g":117,"b":82},"luminance":84.90417799496089},{"name":"Baltic","hex":"#279d9f","rgb":{"r":39,"g":157,"b":159},"luminance":94.64571875156318},{"name":"Baltic Bream","hex":"#9fbbda","rgb":{"r":159,"g":187,"b":218},"luminance":122.17611037350959},{"name":"Baltic Prince","hex":"#135952","rgb":{"r":19,"g":89,"b":82},"luminance":53.37593009962449},{"name":"Baltic Sea","hex":"#3c3d3e","rgb":{"r":60,"g":61,"b":62},"luminance":40.66867926303975},{"name":"Baltic Trench","hex":"#125761","rgb":{"r":18,"g":87,"b":97},"luminance":52.528925831393124},{"name":"Bambino","hex":"#8edacc","rgb":{"r":142,"g":218,"b":204},"luminance":136.81674040847486},{"name":"Bamboo","hex":"#e3dec6","rgb":{"r":227,"g":222,"b":198},"luminance":148.65388628959553},{"name":"Bamboo Mat","hex":"#e5da9f","rgb":{"r":229,"g":218,"b":159},"luminance":146.26047611367878},{"name":"Bamboo Screen","hex":"#bcab8c","rgb":{"r":188,"g":171,"b":140},"luminance":116.1466860181555},{"name":"Bamboo Shoot","hex":"#a3b6a4","rgb":{"r":163,"g":182,"b":164},"luminance":118.9047481852596},{"name":"Bamboo White","hex":"#c6cfad","rgb":{"r":198,"g":207,"b":173},"luminance":136.59528238193292},{"name":"Banafš Violet","hex":"#5a1991","rgb":{"r":90,"g":25,"b":145},"luminance":34.824483126099665},{"name":"Banafsaji Purple","hex":"#a50b5e","rgb":{"r":165,"g":11,"b":94},"luminance":50.8966377082023},{"name":"Banana","hex":"#fffc79","rgb":{"r":255,"g":252,"b":121},"luminance":166.9882757471314},{"name":"Banana Biscuit","hex":"#ffde7b","rgb":{"r":255,"g":222,"b":123},"luminance":151.62999408098648},{"name":"Banana Blossom","hex":"#933e49","rgb":{"r":147,"g":62,"b":73},"luminance":57.66840667991443},{"name":"Banana Boat","hex":"#fdc838","rgb":{"r":253,"g":200,"b":56},"luminance":139.8069528492771},{"name":"Banana Bread","hex":"#ffcf73","rgb":{"r":255,"g":207,"b":115},"luminance":144.04724643671602},{"name":"Banana Brulee","hex":"#f7eab9","rgb":{"r":247,"g":234,"b":185},"luminance":157.37304048978658},{"name":"Banana Chalk","hex":"#d6d963","rgb":{"r":214,"g":217,"b":99},"luminance":142.9929775653336},{"name":"Banana Clan","hex":"#eedd00","rgb":{"r":238,"g":221,"b":0},"luminance":147.9632548067256},{"name":"Banana Cream","hex":"#fff49c","rgb":{"r":255,"g":244,"b":156},"luminance":163.22938052017471},{"name":"Banana Crepe","hex":"#e7d3ad","rgb":{"r":231,"g":211,"b":173},"luminance":143.1783520438757},{"name":"Banana Farm","hex":"#ffdf38","rgb":{"r":255,"g":223,"b":56},"luminance":151.6216583539436},{"name":"Banana Flash","hex":"#eeff00","rgb":{"r":238,"g":255,"b":0},"luminance":165.73964362517495},{"name":"Banana Mania","hex":"#fbe7b2","rgb":{"r":251,"g":231,"b":178},"luminance":156.3031160086068},{"name":"Banana Mash","hex":"#fafe4b","rgb":{"r":250,"g":254,"b":75},"luminance":167.00562446815974},{"name":"Banana Milkshake","hex":"#ede6cb","rgb":{"r":237,"g":230,"b":203},"luminance":154.22327007621126},{"name":"Banana Palm","hex":"#95a263","rgb":{"r":149,"g":162,"b":99},"luminance":105.61739550377105},{"name":"Banana Peel","hex":"#ffe774","rgb":{"r":255,"g":231,"b":116},"luminance":156.12405519329812},{"name":"Banana Pie","hex":"#f7efd7","rgb":{"r":247,"g":239,"b":215},"luminance":160.4279637656727},{"name":"Banana Powder","hex":"#d0c101","rgb":{"r":208,"g":193,"b":1},"luminance":129.2389590680767},{"name":"Banana Pudding","hex":"#f4efc3","rgb":{"r":244,"g":239,"b":195},"luminance":159.68367695227963},{"name":"Banana Puree","hex":"#b29705","rgb":{"r":178,"g":151,"b":5},"luminance":103.38967043665436},{"name":"Banana Sparkes","hex":"#f6f5d7","rgb":{"r":246,"g":245,"b":215},"luminance":163.38202239230606},{"name":"Banana Split","hex":"#f7eec8","rgb":{"r":247,"g":238,"b":200},"luminance":159.6617425841269},{"name":"Banana Yellow","hex":"#ffe135","rgb":{"r":255,"g":225,"b":53},"luminance":152.62244728086364},{"name":"Banana Yogurt","hex":"#fae7b5","rgb":{"r":250,"g":231,"b":181},"luminance":156.2045801665239},{"name":"Bananarama","hex":"#e4d466","rgb":{"r":228,"g":212,"b":102},"luminance":142.36903140781706},{"name":"Bananas Foster","hex":"#dcbe97","rgb":{"r":220,"g":190,"b":151},"luminance":130.62262857560322},{"name":"Bancroft Village","hex":"#816e54","rgb":{"r":129,"g":110,"b":84},"luminance":75.82022630538634},{"name":"Banded Tulip","hex":"#e0d3bd","rgb":{"r":224,"g":211,"b":189},"luminance":142.44497583628564},{"name":"Bandicoot","hex":"#878466","rgb":{"r":135,"g":132,"b":102},"luminance":88.13803869499252},{"name":"Baneblade Brown","hex":"#937f6d","rgb":{"r":147,"g":127,"b":109},"luminance":87.42897166271601},{"name":"Bangalore","hex":"#bbaa88","rgb":{"r":187,"g":170,"b":136},"luminance":115.43258502260095},{"name":"Bangladesh Green","hex":"#006a4f","rgb":{"r":0,"g":106,"b":79},"luminance":62.870385079145166},{"name":"Banished Brown","hex":"#745e6f","rgb":{"r":116,"g":94,"b":111},"luminance":66.39062626606258},{"name":"Bank Blue","hex":"#3e4652","rgb":{"r":62,"g":70,"b":82},"luminance":46.03727455008604},{"name":"Bank Vault","hex":"#757374","rgb":{"r":117,"g":115,"b":116},"luminance":77.1725954597874},{"name":"Banksia","hex":"#a6b29a","rgb":{"r":166,"g":178,"b":154},"luminance":117.00030464917602},{"name":"Banksia Leaf","hex":"#4b5539","rgb":{"r":75,"g":85,"b":57},"luminance":55.08734567938448},{"name":"Banner Gold","hex":"#a28557","rgb":{"r":162,"g":133,"b":87},"luminance":92.41043019594703},{"name":"Bannister Brown","hex":"#806b5d","rgb":{"r":128,"g":107,"b":93},"luminance":74.31096062493069},{"name":"Banshee","hex":"#daf0e6","rgb":{"r":218,"g":240,"b":230},"luminance":157.42730361662174},{"name":"Banyan Serenity","hex":"#98ab8c","rgb":{"r":152,"g":171,"b":140},"luminance":111.3363571929673},{"name":"Bara Red","hex":"#e9546b","rgb":{"r":233,"g":84,"b":107},"luminance":86.21810109831925},{"name":"Baragon Brown","hex":"#551100","rgb":{"r":85,"g":17,"b":0},"luminance":27.303894703869627},{"name":"Barbados","hex":"#3e6676","rgb":{"r":62,"g":102,"b":118},"luminance":64.10545705320257},{"name":"Barbados Bay","hex":"#006665","rgb":{"r":0,"g":102,"b":101},"luminance":60.97104289742796},{"name":"Barbados Blue","hex":"#2766ac","rgb":{"r":39,"g":102,"b":172},"luminance":64.07299322647569},{"name":"Barbados Cherry","hex":"#aa0a27","rgb":{"r":170,"g":10,"b":39},"luminance":51.360614443365066},{"name":"Barbarian Flesh","hex":"#f78c5a","rgb":{"r":247,"g":140,"b":90},"luminance":110.96434386324283},{"name":"Barbarian Leather","hex":"#a17308","rgb":{"r":161,"g":115,"b":8},"luminance":82.91634392567005},{"name":"Barbarossa","hex":"#a84734","rgb":{"r":168,"g":71,"b":52},"luminance":65.53905199955214},{"name":"Barbecue","hex":"#c26157","rgb":{"r":194,"g":97,"b":87},"luminance":81.88475121168776},{"name":"Barberry","hex":"#ee1133","rgb":{"r":238,"g":17,"b":51},"luminance":72.09308760900728},{"name":"Barberry Bush","hex":"#d2c61f","rgb":{"r":210,"g":198,"b":31},"luminance":132.14974964789},{"name":"Barbie Pink","hex":"#fe46a5","rgb":{"r":254,"g":70,"b":165},"luminance":88.3741993796832},{"name":"Bare","hex":"#817e6d","rgb":{"r":129,"g":126,"b":109},"luminance":84.33566837939922},{"name":"Bare Beige","hex":"#e8d3c9","rgb":{"r":232,"g":211,"b":201},"luminance":143.79682635232254},{"name":"Bare Bone","hex":"#eeddcc","rgb":{"r":238,"g":221,"b":204},"luminance":149.7797259611594},{"name":"Bare Pink","hex":"#f2e1dd","rgb":{"r":242,"g":225,"b":221},"luminance":152.6899584943293},{"name":"Barely Bloomed","hex":"#ddaadd","rgb":{"r":221,"g":170,"b":221},"luminance":122.3078737326424},{"name":"Barely Blue","hex":"#dde0df","rgb":{"r":221,"g":224,"b":223},"luminance":149.33789361377774},{"name":"Barely Brown","hex":"#dd6655","rgb":{"r":221,"g":102,"b":85},"luminance":89.69518502684522},{"name":"Barely Butter","hex":"#f8e9c2","rgb":{"r":248,"g":233,"b":194},"luminance":157.1430653926542},{"name":"Barely Mauve","hex":"#ccbdb9","rgb":{"r":204,"g":189,"b":185},"luminance":128.34971509512593},{"name":"Barely Peach","hex":"#ffe9c7","rgb":{"r":255,"g":233,"b":199},"luminance":158.22218890534916},{"name":"Barely Pink","hex":"#f8d7dd","rgb":{"r":248,"g":215,"b":221},"luminance":148.52931954668074},{"name":"Barely Ripe Apricot","hex":"#ffe3cb","rgb":{"r":255,"g":227,"b":203},"luminance":155.25510680811757},{"name":"Barely Rose","hex":"#ede0e3","rgb":{"r":237,"g":224,"b":227},"luminance":151.5926442707561},{"name":"Barf Green","hex":"#94ac02","rgb":{"r":148,"g":172,"b":2},"luminance":110.23620450650502},{"name":"Barite","hex":"#9e7b5c","rgb":{"r":158,"g":123,"b":92},"luminance":86.9182898416668},{"name":"Baritone","hex":"#708e95","rgb":{"r":112,"g":142,"b":149},"luminance":91.4213304212972},{"name":"Barium","hex":"#f4e1c5","rgb":{"r":244,"g":225,"b":197},"luminance":152.54751825251043},{"name":"Barium Green","hex":"#8fff9f","rgb":{"r":143,"g":255,"b":159},"luminance":156.72368088454277},{"name":"Bark","hex":"#5f5854","rgb":{"r":95,"g":88,"b":84},"luminance":59.72341364155267},{"name":"Bark Sawdust","hex":"#ab9004","rgb":{"r":171,"g":144,"b":4},"luminance":98.78950025685927},{"name":"Barking Prairie Dog","hex":"#c5b497","rgb":{"r":197,"g":180,"b":151},"luminance":122.18805508313814},{"name":"Barley Corn","hex":"#b6935c","rgb":{"r":182,"g":147,"b":92},"luminance":102.55295407251806},{"name":"Barley Groats","hex":"#fbf2db","rgb":{"r":251,"g":242,"b":219},"luminance":162.58841432586763},{"name":"Barley White","hex":"#f7e5b7","rgb":{"r":247,"g":229,"b":183},"luminance":154.78705237196036},{"name":"Barn Door","hex":"#8e5959","rgb":{"r":142,"g":89,"b":89},"luminance":68.08049742033323},{"name":"Barn Red","hex":"#8b4044","rgb":{"r":139,"g":64,"b":68},"luminance":56.55762414564459},{"name":"Barney","hex":"#ac1db8","rgb":{"r":172,"g":29,"b":184},"luminance":58.09143042652677},{"name":"Barney Purple","hex":"#a00498","rgb":{"r":160,"g":4,"b":152},"luminance":50.93562886624646},{"name":"Barnfloor","hex":"#9c9480","rgb":{"r":156,"g":148,"b":128},"luminance":99.67962969433624},{"name":"Barnwood","hex":"#554d44","rgb":{"r":85,"g":77,"b":68},"luminance":52.430576289031954},{"name":"Barnwood Grey","hex":"#9e9589","rgb":{"r":158,"g":149,"b":137},"luminance":100.62556761082145},{"name":"Baroque","hex":"#ddaa22","rgb":{"r":221,"g":170,"b":34},"luminance":119.74765850320414},{"name":"Baroque Blue","hex":"#95b6b5","rgb":{"r":149,"g":182,"b":181},"luminance":117.5757505313064},{"name":"Baroque Rose","hex":"#b35a66","rgb":{"r":179,"g":90,"b":102},"luminance":76.0967589651491},{"name":"Barossa","hex":"#452e39","rgb":{"r":69,"g":46,"b":57},"luminance":34.59725666870135},{"name":"Barrel Stove","hex":"#8e7e67","rgb":{"r":142,"g":126,"b":103},"luminance":86.08678047180065},{"name":"Barren","hex":"#b9aba3","rgb":{"r":185,"g":171,"b":163},"luminance":116.10590888494866},{"name":"Barricade","hex":"#84623e","rgb":{"r":132,"g":98,"b":62},"luminance":70.12075530112321},{"name":"Barrier Reef","hex":"#0084a1","rgb":{"r":0,"g":132,"b":161},"luminance":79.62813304354184},{"name":"Basalt Grey","hex":"#999999","rgb":{"r":153,"g":153,"b":153},"luminance":102.28893925542486},{"name":"Base Camp","hex":"#575c3a","rgb":{"r":87,"g":92,"b":58},"luminance":60.30610855460663},{"name":"Base Sand","hex":"#bb9955","rgb":{"r":187,"g":153,"b":85},"luminance":106.23641273122882},{"name":"Bashful","hex":"#e3eded","rgb":{"r":227,"g":237,"b":237},"luminance":157.1331047679005},{"name":"Bashful Emu","hex":"#b2b0ac","rgb":{"r":178,"g":176,"b":172},"luminance":117.85764418144458},{"name":"Bashful Pansy","hex":"#d9cde5","rgb":{"r":217,"g":205,"b":229},"luminance":139.1827544992554},{"name":"Bashful Rose","hex":"#b88686","rgb":{"r":184,"g":134,"b":134},"luminance":97.19669436765841},{"name":"Basic Coral","hex":"#dbc3b6","rgb":{"r":219,"g":195,"b":182},"luminance":133.49335972249705},{"name":"Basil","hex":"#879f84","rgb":{"r":135,"g":159,"b":132},"luminance":102.79506028015159},{"name":"Basil Icing","hex":"#e2e6db","rgb":{"r":226,"g":230,"b":219},"luminance":153.02694773143716},{"name":"Basil Pesto","hex":"#529d6e","rgb":{"r":82,"g":157,"b":110},"luminance":96.18557690735133},{"name":"Basil Smash","hex":"#b7e1a1","rgb":{"r":183,"g":225,"b":161},"luminance":144.13405229160804},{"name":"Basilisk","hex":"#9ab38d","rgb":{"r":154,"g":179,"b":141},"luminance":115.84016108845843},{"name":"Basilisk Lizard","hex":"#bcecac","rgb":{"r":188,"g":236,"b":172},"luminance":150.78255082071001},{"name":"Basketball","hex":"#ee6730","rgb":{"r":238,"g":103,"b":48},"luminance":93.53879168024355},{"name":"Basketweave Beige","hex":"#caad92","rgb":{"r":202,"g":173,"b":146},"luminance":119.32119150008518},{"name":"Basmati White","hex":"#ebe1c9","rgb":{"r":235,"g":225,"b":201},"luminance":151.34737277534748},{"name":"Bassinet","hex":"#d3c1cb","rgb":{"r":211,"g":193,"b":203},"luminance":131.72177028114982},{"name":"Bastard-amber","hex":"#ffcc88","rgb":{"r":255,"g":204,"b":136},"luminance":142.8049633066022},{"name":"Bastille","hex":"#2c2c32","rgb":{"r":44,"g":44,"b":50},"luminance":29.540750159736973},{"name":"Bastion Grey","hex":"#4d4a4a","rgb":{"r":77,"g":74,"b":74},"luminance":49.880702370756566},{"name":"Bat Wing","hex":"#7e7466","rgb":{"r":126,"g":116,"b":102},"luminance":78.68329634681048},{"name":"Batch Blue","hex":"#87b2c9","rgb":{"r":135,"g":178,"b":201},"luminance":114.33157401610457},{"name":"Bateau","hex":"#1b7598","rgb":{"r":27,"g":117,"b":152},"luminance":71.28981662201132},{"name":"Bath Bubbles","hex":"#e6f2ea","rgb":{"r":230,"g":242,"b":234},"luminance":160.06330245249848},{"name":"Bathing","hex":"#93c9d0","rgb":{"r":147,"g":201,"b":208},"luminance":128.12126022639646},{"name":"Batman","hex":"#656e72","rgb":{"r":101,"g":110,"b":114},"luminance":72.45799139501452},{"name":"Batman's NES Cape","hex":"#940084","rgb":{"r":148,"g":0,"b":132},"luminance":46.740579885149046},{"name":"Baton","hex":"#866f5a","rgb":{"r":134,"g":111,"b":90},"luminance":77.17503874310657},{"name":"Baton Rouge","hex":"#973c6c","rgb":{"r":151,"g":60,"b":108},"luminance":58.570179656545356},{"name":"Battered Sausage","hex":"#ede2d4","rgb":{"r":237,"g":226,"b":212},"luminance":152.3314256383101},{"name":"Battery Charged Blue","hex":"#1dacd4","rgb":{"r":29,"g":172,"b":212},"luminance":104.17776999437068},{"name":"Battle Blue","hex":"#74828f","rgb":{"r":116,"g":130,"b":143},"luminance":85.39292218913697},{"name":"Battle Dress","hex":"#7e8270","rgb":{"r":126,"g":130,"b":112},"luminance":86.05561108957393},{"name":"Battle Harbor","hex":"#9c9c82","rgb":{"r":156,"g":156,"b":130},"luminance":103.83027650931109},{"name":"Battleship Green","hex":"#828f72","rgb":{"r":130,"g":143,"b":114},"luminance":93.41233535781019},{"name":"Battleship Grey","hex":"#6f7476","rgb":{"r":111,"g":116,"b":118},"luminance":76.93494972377638},{"name":"Battletoad","hex":"#11cc55","rgb":{"r":17,"g":204,"b":85},"luminance":120.24689805978365},{"name":"Batu Cave","hex":"#595438","rgb":{"r":89,"g":84,"b":56},"luminance":56.39308149941799},{"name":"Bauhaus Tan","hex":"#ccc4ae","rgb":{"r":204,"g":196,"b":174},"luminance":131.72297300015666},{"name":"Bavarian","hex":"#4d5e42","rgb":{"r":77,"g":94,"b":66},"luminance":60.26010943401945},{"name":"Bavarian Blue","hex":"#1c3382","rgb":{"r":28,"g":51,"b":130},"luminance":34.43757762967657},{"name":"Bavarian Cream","hex":"#fff9dd","rgb":{"r":255,"g":249,"b":221},"luminance":166.76828304566789},{"name":"Bavarian Gentian","hex":"#20006d","rgb":{"r":32,"g":0,"b":109},"luminance":15.682860070790658},{"name":"Bavarian Sweet Mustard","hex":"#4d3113","rgb":{"r":77,"g":49,"b":19},"luminance":36.90610049842708},{"name":"Bay","hex":"#bae5d6","rgb":{"r":186,"g":229,"b":214},"luminance":147.50466006536877},{"name":"Bay Area","hex":"#afa490","rgb":{"r":175,"g":164,"b":144},"luminance":110.79223124840478},{"name":"Bay Brown","hex":"#773300","rgb":{"r":119,"g":51,"b":0},"luminance":46.49980139742534},{"name":"Bay Fog","hex":"#9899b0","rgb":{"r":152,"g":153,"b":176},"luminance":102.63576628544261},{"name":"Bay Isle Pointe","hex":"#214048","rgb":{"r":33,"g":64,"b":72},"luminance":39.69991910571103},{"name":"Bay Leaf","hex":"#86793d","rgb":{"r":134,"g":121,"b":61},"luminance":81.84422521473338},{"name":"Bay of Hope","hex":"#bfc9d0","rgb":{"r":191,"g":201,"b":208},"luminance":133.2089673933403},{"name":"Bay of Many","hex":"#353e64","rgb":{"r":53,"g":62,"b":100},"luminance":41.29903927454003},{"name":"Bay Salt","hex":"#d2cdbc","rgb":{"r":210,"g":205,"b":188},"luminance":137.41334341686036},{"name":"Bay Site","hex":"#325f8a","rgb":{"r":50,"g":95,"b":138},"luminance":59.83923085234301},{"name":"Bay View","hex":"#6a819e","rgb":{"r":106,"g":129,"b":158},"luminance":84.04114771348615},{"name":"Bay Wharf","hex":"#747f89","rgb":{"r":116,"g":127,"b":137},"luminance":83.69262321734216},{"name":"Bay's Water","hex":"#7b9aad","rgb":{"r":123,"g":154,"b":173},"luminance":99.56557345287577},{"name":"Bayberry","hex":"#255958","rgb":{"r":37,"g":89,"b":88},"luminance":54.33564246422416},{"name":"Bayern Blue","hex":"#0098d4","rgb":{"r":0,"g":152,"b":212},"luminance":92.43924707612021},{"name":"Bayou","hex":"#20706f","rgb":{"r":32,"g":112,"b":111},"luminance":67.63093874847516},{"name":"Bayshore","hex":"#89cee0","rgb":{"r":137,"g":206,"b":224},"luminance":130.20055587054918},{"name":"Bayside","hex":"#5fc9bf","rgb":{"r":95,"g":201,"b":191},"luminance":123.29591749121298},{"name":"Bazaar","hex":"#8f7777","rgb":{"r":143,"g":119,"b":119},"luminance":83.01589615248395},{"name":"Bazooka Pink","hex":"#ffa6c9","rgb":{"r":255,"g":166,"b":201},"luminance":125.83042074554149},{"name":"BBQ","hex":"#a35046","rgb":{"r":163,"g":80,"b":70},"luminance":68.14849351966629},{"name":"Be Daring","hex":"#ffc943","rgb":{"r":255,"g":201,"b":67},"luminance":140.68607336193585},{"name":"Be My Valentine","hex":"#ec9dc3","rgb":{"r":236,"g":157,"b":195},"luminance":118.18093025949659},{"name":"Be Spontaneous","hex":"#a5cb66","rgb":{"r":165,"g":203,"b":102},"luminance":129.4932296685815},{"name":"Be Yourself","hex":"#9b983d","rgb":{"r":155,"g":152,"b":61},"luminance":100.78263400507052},{"name":"Beach Bag","hex":"#adb864","rgb":{"r":173,"g":184,"b":100},"luminance":120.29700990880862},{"name":"Beach Ball","hex":"#efc700","rgb":{"r":239,"g":199,"b":0},"luminance":136.93776502484621},{"name":"Beach Boardwalk","hex":"#ceab90","rgb":{"r":206,"g":171,"b":144},"luminance":118.90688803008848},{"name":"Beach Casuarina","hex":"#665a38","rgb":{"r":102,"g":90,"b":56},"luminance":61.3342674204233},{"name":"Beach Cottage","hex":"#94adb0","rgb":{"r":148,"g":173,"b":176},"luminance":112.57623728389574},{"name":"Beach Dune","hex":"#c6bb9c","rgb":{"r":198,"g":187,"b":156},"luminance":125.97769969720831},{"name":"Beach Glass","hex":"#96dfce","rgb":{"r":150,"g":223,"b":206},"luminance":140.34989332735523},{"name":"Beach Grass","hex":"#dcddb8","rgb":{"r":220,"g":221,"b":184},"luminance":146.95610060490856},{"name":"Beach House","hex":"#edd481","rgb":{"r":237,"g":212,"b":129},"luminance":143.9588147387995},{"name":"Beach Party","hex":"#fbd05c","rgb":{"r":251,"g":208,"b":92},"luminance":143.7003262383214},{"name":"Beach Sand","hex":"#fbb995","rgb":{"r":251,"g":185,"b":149},"luminance":133.09301492565262},{"name":"Beach Towel","hex":"#fce3b3","rgb":{"r":252,"g":227,"b":179},"luminance":154.43128549940909},{"name":"Beach Umbrella","hex":"#819aaa","rgb":{"r":129,"g":154,"b":170},"luminance":100.17537045102453},{"name":"Beach Woods","hex":"#cac0b0","rgb":{"r":202,"g":192,"b":176},"luminance":129.43212165455682},{"name":"Beachcomber","hex":"#d9e4e5","rgb":{"r":217,"g":228,"b":229},"luminance":151.00795284023948},{"name":"Beachcombing","hex":"#e4c683","rgb":{"r":228,"g":198,"b":131},"luminance":135.56890873647984},{"name":"Beachside Villa","hex":"#c3b296","rgb":{"r":195,"g":178,"b":150},"luminance":120.8685534826987},{"name":"Beachy Keen","hex":"#e6d0b6","rgb":{"r":230,"g":208,"b":182},"luminance":141.658835305109},{"name":"Beaded Blue","hex":"#494d8b","rgb":{"r":73,"g":77,"b":139},"luminance":52.635190186794226},{"name":"Beagle Brown","hex":"#8d6737","rgb":{"r":141,"g":103,"b":55},"luminance":73.97450034978269},{"name":"Beaming Blue","hex":"#33ffff","rgb":{"r":51,"g":255,"b":255},"luminance":153.24227917255735},{"name":"Beaming Sun","hex":"#fff8df","rgb":{"r":255,"g":248,"b":223},"luminance":166.2887545355969},{"name":"Bean Counter","hex":"#68755d","rgb":{"r":104,"g":117,"b":93},"luminance":76.13257293038244},{"name":"Bean Shoot","hex":"#91923a","rgb":{"r":145,"g":146,"b":58},"luminance":96.27152939992176},{"name":"Bean Sprout","hex":"#f3f9e9","rgb":{"r":243,"g":249,"b":233},"luminance":165.37291816376705},{"name":"Beanstalk","hex":"#31aa74","rgb":{"r":49,"g":170,"b":116},"luminance":101.7230066258366},{"name":"Bear Brown","hex":"#44382b","rgb":{"r":68,"g":56,"b":43},"luminance":38.96136819979504},{"name":"Bear Hug","hex":"#796359","rgb":{"r":121,"g":99,"b":89},"luminance":69.20247196451874},{"name":"Bear in Mind","hex":"#5b4a44","rgb":{"r":91,"g":74,"b":68},"luminance":51.83901068693344},{"name":"Bearsuit","hex":"#7d756d","rgb":{"r":125,"g":117,"b":109},"luminance":79.1713404080037},{"name":"Beastly Flesh","hex":"#680c08","rgb":{"r":104,"g":12,"b":8},"luminance":31.89687909498357},{"name":"Beasty Brown","hex":"#663300","rgb":{"r":102,"g":51,"b":0},"luminance":42.735839444194845},{"name":"Beat Around the Bush","hex":"#6e6a44","rgb":{"r":110,"g":106,"b":68},"luminance":70.80552865419479},{"name":"Beaten Copper","hex":"#73372d","rgb":{"r":115,"g":55,"b":45},"luminance":47.44435003243273},{"name":"Beaten Purple","hex":"#4e0550","rgb":{"r":78,"g":5,"b":80},"luminance":25.2131772888702},{"name":"Beaten Track","hex":"#d1be92","rgb":{"r":209,"g":190,"b":146},"luminance":128.92280138517003},{"name":"Beatnik","hex":"#5f8748","rgb":{"r":95,"g":135,"b":72},"luminance":84.58123499925972},{"name":"Beatrice","hex":"#bebad9","rgb":{"r":190,"g":186,"b":217},"luminance":125.53905315876808},{"name":"Beau Blue","hex":"#bcd4e6","rgb":{"r":188,"g":212,"b":230},"luminance":139.04526773680576},{"name":"Beaujolais","hex":"#80304c","rgb":{"r":128,"g":48,"b":76},"luminance":48.308362174679445},{"name":"Beaumont Brown","hex":"#92774c","rgb":{"r":146,"g":119,"b":76},"luminance":82.82619284380998},{"name":"Beautiful Blue","hex":"#186db6","rgb":{"r":24,"g":109,"b":182},"luminance":67.64465070498923},{"name":"Beauty","hex":"#866b8d","rgb":{"r":134,"g":107,"b":141},"luminance":76.21435765654657},{"name":"Beauty Bush","hex":"#ebb9b3","rgb":{"r":235,"g":185,"b":179},"luminance":130.94445038259545},{"name":"Beauty Patch","hex":"#834f44","rgb":{"r":131,"g":79,"b":68},"luminance":61.194437606697555},{"name":"Beauty Secret","hex":"#c79ea2","rgb":{"r":199,"g":158,"b":162},"luminance":111.72849475849927},{"name":"Beauty Spot","hex":"#604938","rgb":{"r":96,"g":73,"b":56},"luminance":51.97002283047411},{"name":"Beaver","hex":"#926f5b","rgb":{"r":146,"g":111,"b":91},"luminance":79.11211184768106},{"name":"Beaver Fur","hex":"#997867","rgb":{"r":153,"g":120,"b":103},"luminance":84.80834966558422},{"name":"Beaver Kit","hex":"#9f8170","rgb":{"r":159,"g":129,"b":112},"luminance":90.31689340317236},{"name":"Beaver Pelt","hex":"#60564c","rgb":{"r":96,"g":86,"b":76},"luminance":58.71470715246734},{"name":"Bechamel","hex":"#f4eee0","rgb":{"r":244,"g":238,"b":224},"luminance":159.66349510141634},{"name":"Becker Blue","hex":"#607879","rgb":{"r":96,"g":120,"b":121},"luminance":77.3045124944204},{"name":"Beckett","hex":"#85a699","rgb":{"r":133,"g":166,"b":153},"luminance":106.67980604125599},{"name":"Bedbox","hex":"#968775","rgb":{"r":150,"g":135,"b":117},"luminance":92.02822810964035},{"name":"Bedford Brown","hex":"#aa8880","rgb":{"r":170,"g":136,"b":128},"luminance":95.75888255404821},{"name":"Bee Cluster","hex":"#ffaa33","rgb":{"r":255,"g":170,"b":51},"luminance":125.71852178975061},{"name":"Bee Hall","hex":"#f2cc64","rgb":{"r":242,"g":204,"b":100},"luminance":140.37529578953698},{"name":"Bee Master","hex":"#735b3b","rgb":{"r":115,"g":91,"b":59},"luminance":63.882260370152835},{"name":"Bee Pollen","hex":"#ebca70","rgb":{"r":235,"g":202,"b":112},"luminance":138.41959949732552},{"name":"Bee Yellow","hex":"#feff32","rgb":{"r":254,"g":255,"b":50},"luminance":167.9460750985268},{"name":"Beech","hex":"#5b4f3b","rgb":{"r":91,"g":79,"b":59},"luminance":54.185089148214935},{"name":"Beech Fern","hex":"#758067","rgb":{"r":117,"g":128,"b":103},"luminance":83.70844251925847},{"name":"Beechnut","hex":"#c2c18d","rgb":{"r":194,"g":193,"b":141},"luminance":128.28842579515893},{"name":"Beef Jerky","hex":"#a25768","rgb":{"r":162,"g":87,"b":104},"luminance":71.37819933985446},{"name":"Beekeeper","hex":"#f6e491","rgb":{"r":246,"g":228,"b":145},"luminance":153.60828985442157},{"name":"Beer","hex":"#f28e1c","rgb":{"r":242,"g":142,"b":28},"luminance":110.42535190797446},{"name":"Beer Garden","hex":"#449933","rgb":{"r":68,"g":153,"b":51},"luminance":92.26705013708848},{"name":"Beer Glazed Bacon","hex":"#773311","rgb":{"r":119,"g":51,"b":17},"luminance":46.54016946681651},{"name":"Beeswax","hex":"#e9d7ab","rgb":{"r":233,"g":215,"b":171},"luminance":145.46892778184625},{"name":"Beeswing","hex":"#f5d297","rgb":{"r":245,"g":210,"b":151},"luminance":144.42336971903126},{"name":"Beet Red","hex":"#7a1f3d","rgb":{"r":122,"g":31,"b":61},"luminance":41.35375930916076},{"name":"Beetle","hex":"#55584c","rgb":{"r":85,"g":88,"b":76},"luminance":58.21794789409877},{"name":"Beetroot Purple","hex":"#cf2d71","rgb":{"r":207,"g":45,"b":113},"luminance":68.51599519820171},{"name":"Beetroot Rice","hex":"#c58f9d","rgb":{"r":197,"g":143,"b":157},"luminance":104.096077226762},{"name":"Beets","hex":"#736a86","rgb":{"r":115,"g":106,"b":134},"luminance":72.71355915508468},{"name":"Befitting","hex":"#96496d","rgb":{"r":150,"g":73,"b":109},"luminance":63.26243891125286},{"name":"Before the Storm","hex":"#4d6a77","rgb":{"r":77,"g":106,"b":119},"luminance":67.71759128173416},{"name":"Beggar","hex":"#5a4d39","rgb":{"r":90,"g":77,"b":57},"luminance":53.00303486593951},{"name":"Begonia","hex":"#fa6e79","rgb":{"r":250,"g":110,"b":121},"luminance":99.73525874032713},{"name":"Begonia Pink","hex":"#ec9abe","rgb":{"r":236,"g":154,"b":190},"luminance":116.70575007256497},{"name":"Beige","hex":"#e6daa6","rgb":{"r":230,"g":218,"b":166},"luminance":146.50163081686154},{"name":"Beige Ganesh","hex":"#cfb095","rgb":{"r":207,"g":176,"b":149},"luminance":121.62498505241429},{"name":"Beige Linen","hex":"#e2dac6","rgb":{"r":226,"g":218,"b":198},"luminance":146.46172816131863},{"name":"Beige Red","hex":"#de9408","rgb":{"r":222,"g":148,"b":8},"luminance":109.33576726762381},{"name":"Beige Royal","hex":"#cfc8b8","rgb":{"r":207,"g":200,"b":184},"luminance":134.3632986533153},{"name":"Beige Topaz","hex":"#ffc87c","rgb":{"r":255,"g":200,"b":124},"luminance":140.69785542430986},{"name":"Bel Air Blue","hex":"#819ac1","rgb":{"r":129,"g":154,"b":193},"luminance":100.71548266776065},{"name":"Bel Esprit","hex":"#9bbcc3","rgb":{"r":155,"g":188,"b":195},"luminance":121.7393882890825},{"name":"Belgian Block","hex":"#a3a9a6","rgb":{"r":163,"g":169,"b":166},"luminance":112.13673864528073},{"name":"Belgian Blonde","hex":"#f7efd0","rgb":{"r":247,"g":239,"b":208},"luminance":160.3079860830395},{"name":"Belgian Waffle","hex":"#f3dfb6","rgb":{"r":243,"g":223,"b":182},"luminance":151.1442719854113},{"name":"Belize Green","hex":"#b9c3b3","rgb":{"r":185,"g":195,"b":179},"luminance":128.7570980024014},{"name":"Bell Blue","hex":"#618b97","rgb":{"r":97,"g":139,"b":151},"luminance":88.28880707088526},{"name":"Bell Heather","hex":"#a475b1","rgb":{"r":164,"g":117,"b":177},"luminance":86.76684862895506},{"name":"Bella","hex":"#574057","rgb":{"r":87,"g":64,"b":87},"luminance":46.75892981025122},{"name":"Bella Green","hex":"#93c3b1","rgb":{"r":147,"g":195,"b":177},"luminance":124.26284286945956},{"name":"Bella Pink","hex":"#e08194","rgb":{"r":224,"g":129,"b":148},"luminance":102.49108102171623},{"name":"Bella Sera","hex":"#40465d","rgb":{"r":64,"g":70,"b":93},"luminance":46.55080020794486},{"name":"Bella Vista","hex":"#0b695b","rgb":{"r":11,"g":105,"b":91},"luminance":62.58842242779411},{"name":"Belladonna","hex":"#220011","rgb":{"r":34,"g":0,"b":17},"luminance":10.34907725355261},{"name":"Bellagio Fountains","hex":"#b7dff3","rgb":{"r":183,"g":223,"b":243},"luminance":144.55595004703196},{"name":"Belle of the Ball","hex":"#e3cbc0","rgb":{"r":227,"g":203,"b":192},"luminance":138.87106463911047},{"name":"Bellflower","hex":"#5d66aa","rgb":{"r":93,"g":102,"b":170},"luminance":68.80195872938502},{"name":"Bellini","hex":"#f4c9b1","rgb":{"r":244,"g":201,"b":177},"luminance":140.18081819207646},{"name":"Belly Fire","hex":"#773b38","rgb":{"r":119,"g":59,"b":56},"luminance":50.06203857215564},{"name":"Belly Flop","hex":"#00817f","rgb":{"r":0,"g":129,"b":127},"luminance":77.09465100122057},{"name":"Below Zero","hex":"#87cded","rgb":{"r":135,"g":205,"b":237},"luminance":129.76832346146728},{"name":"Beluga","hex":"#4a4843","rgb":{"r":74,"g":72,"b":67},"luminance":48.31298599755556},{"name":"Belyi White","hex":"#f0f1e1","rgb":{"r":240,"g":241,"b":225},"luminance":160.6870629173363},{"name":"Benevolence","hex":"#694977","rgb":{"r":105,"g":73,"b":119},"luminance":54.826002790646704},{"name":"Bengal","hex":"#cc974d","rgb":{"r":204,"g":151,"b":77},"luminance":107.95407851952606},{"name":"Bengal Blue","hex":"#38738b","rgb":{"r":56,"g":115,"b":139},"luminance":71.33289757888711},{"name":"Bengala Red","hex":"#8f2e14","rgb":{"r":143,"g":46,"b":20},"luminance":50.620820350918855},{"name":"Bengara Red","hex":"#913225","rgb":{"r":145,"g":50,"b":37},"luminance":52.524946920487224},{"name":"Beni Shoga","hex":"#b85241","rgb":{"r":184,"g":82,"b":65},"luminance":73.47482774392874},{"name":"Benifuji","hex":"#bb7796","rgb":{"r":187,"g":119,"b":150},"luminance":91.09399089950995},{"name":"Benihi Red","hex":"#f35336","rgb":{"r":243,"g":83,"b":54},"luminance":87.69647556202015},{"name":"Benikakehana Purple","hex":"#5a4f74","rgb":{"r":90,"g":79,"b":116},"luminance":55.22207353042803},{"name":"Benikeshinezumi Purple","hex":"#44312e","rgb":{"r":68,"g":49,"b":46},"luminance":35.611794801722645},{"name":"Benimidori Purple","hex":"#78779b","rgb":{"r":120,"g":119,"b":155},"luminance":80.49251461471432},{"name":"Benitoite","hex":"#007baa","rgb":{"r":0,"g":123,"b":170},"luminance":74.75673080733264},{"name":"Beniukon Bronze","hex":"#fb8136","rgb":{"r":251,"g":129,"b":54},"luminance":106.79054951633127},{"name":"Benthic Black","hex":"#000011","rgb":{"r":0,"g":0,"b":17},"luminance":1.9380000000000002},{"name":"Bento Box","hex":"#cc363c","rgb":{"r":204,"g":54,"b":60},"luminance":69.08010437166405},{"name":"Bering Sea","hex":"#4b5b6e","rgb":{"r":75,"g":91,"b":110},"luminance":59.27485228998888},{"name":"Berkeley Hills","hex":"#7e613f","rgb":{"r":126,"g":97,"b":63},"luminance":68.65100961384326},{"name":"Berkshire Lace","hex":"#f0e1cf","rgb":{"r":240,"g":225,"b":207},"luminance":152.151795352536},{"name":"Berlin Blue","hex":"#5588cc","rgb":{"r":85,"g":136,"b":204},"luminance":86.94775434132845},{"name":"Bermuda","hex":"#1b7d8d","rgb":{"r":27,"g":125,"b":141},"luminance":75.54758387930086},{"name":"Bermuda Grey","hex":"#6b8ba2","rgb":{"r":107,"g":139,"b":162},"luminance":89.56582340379614},{"name":"Bermuda Onion","hex":"#9d5a8f","rgb":{"r":157,"g":90,"b":143},"luminance":72.52867952058689},{"name":"Bermuda Sand","hex":"#dacbbf","rgb":{"r":218,"g":203,"b":191},"luminance":137.55778466157412},{"name":"Bermuda Triangle","hex":"#6f8c9f","rgb":{"r":111,"g":140,"b":159},"luminance":90.46332957060557},{"name":"Bermudagrass","hex":"#6bc271","rgb":{"r":107,"g":194,"b":113},"luminance":118.98612043847803},{"name":"Bern Red","hex":"#e20909","rgb":{"r":226,"g":9,"b":9},"luminance":67.78796531096062},{"name":"Berries n Cream","hex":"#f2b8ca","rgb":{"r":242,"g":184,"b":202},"luminance":132.02915212936875},{"name":"Berry","hex":"#990f4b","rgb":{"r":153,"g":15,"b":75},"luminance":47.36473935323618},{"name":"Berry Blackmail","hex":"#662277","rgb":{"r":102,"g":34,"b":119},"luminance":38.890694568238295},{"name":"Berry Bliss","hex":"#9e8295","rgb":{"r":158,"g":130,"b":149},"luminance":91.34301757660516},{"name":"Berry Boost","hex":"#bb5588","rgb":{"r":187,"g":85,"b":136},"luminance":76.525476868818},{"name":"Berry Burst","hex":"#ac72af","rgb":{"r":172,"g":114,"b":175},"luminance":86.72289437051785},{"name":"Berry Bush","hex":"#77424e","rgb":{"r":119,"g":66,"b":78},"luminance":53.34808139942803},{"name":"Berry Chalk","hex":"#a6aebb","rgb":{"r":166,"g":174,"b":187},"luminance":115.5429016599462},{"name":"Berry Chocolate","hex":"#3f000f","rgb":{"r":63,"g":0,"b":15},"luminance":18.914456613923647},{"name":"Berry Conserve","hex":"#765269","rgb":{"r":118,"g":82,"b":105},"luminance":60.868566436215666},{"name":"Berry Crush","hex":"#aa6772","rgb":{"r":170,"g":103,"b":114},"luminance":80.05071790433861},{"name":"Berry Frost","hex":"#ebded7","rgb":{"r":235,"g":222,"b":215},"luminance":150.06548211031074},{"name":"Berry Mix","hex":"#555a90","rgb":{"r":85,"g":90,"b":144},"luminance":60.88034314128001},{"name":"Berry Mojito","hex":"#b6caca","rgb":{"r":182,"g":202,"b":202},"luminance":132.48170056275697},{"name":"Berry Pie","hex":"#4f6d8e","rgb":{"r":79,"g":109,"b":142},"luminance":70.09869666406074},{"name":"Berry Popsicle","hex":"#d6a5cd","rgb":{"r":214,"g":165,"b":205},"luminance":118.4113850987311},{"name":"Berry Riche","hex":"#e5a2ab","rgb":{"r":229,"g":162,"b":171},"luminance":118.79041507209242},{"name":"Berry Rossi","hex":"#992244","rgb":{"r":153,"g":34,"b":68},"luminance":50.5094375042922},{"name":"Berry Smoothie","hex":"#895360","rgb":{"r":137,"g":83,"b":96},"luminance":64.58695182465263},{"name":"Berta Blue","hex":"#45dcff","rgb":{"r":69,"g":220,"b":255},"luminance":133.9695587101786},{"name":"Beru","hex":"#bfe4d4","rgb":{"r":191,"g":228,"b":212},"luminance":147.50459315221337},{"name":"Beryl Green","hex":"#bcbfa8","rgb":{"r":188,"g":191,"b":168},"luminance":126.87320338432382},{"name":"Beryllonite","hex":"#e9e5d7","rgb":{"r":233,"g":229,"b":215},"luminance":153.37461953661042},{"name":"Bessie","hex":"#685e5b","rgb":{"r":104,"g":94,"b":91},"luminance":64.1809377930862},{"name":"Best Beige","hex":"#c6b49c","rgb":{"r":198,"g":180,"b":156},"luminance":122.41398228960611},{"name":"Bestial Brown","hex":"#6b3900","rgb":{"r":107,"g":57,"b":0},"luminance":46.29316072596469},{"name":"Bestigor Flesh","hex":"#d38a57","rgb":{"r":211,"g":138,"b":87},"luminance":103.15309341459421},{"name":"Betalain Red","hex":"#7d655c","rgb":{"r":125,"g":101,"b":92},"luminance":70.86492177375207},{"name":"Betel Nut Dye","hex":"#352925","rgb":{"r":53,"g":41,"b":37},"luminance":29.122833344302197},{"name":"Bethany","hex":"#cadbbd","rgb":{"r":202,"g":219,"b":189},"luminance":143.65939693942752},{"name":"Bethlehem Red","hex":"#ee0022","rgb":{"r":238,"g":0,"b":34},"luminance":71.26747939979356},{"name":"Bethlehem Superstar","hex":"#eaeeda","rgb":{"r":234,"g":238,"b":218},"luminance":158.2107123301074},{"name":"Betsy","hex":"#73c9d9","rgb":{"r":115,"g":201,"b":217},"luminance":125.36039660913649},{"name":"Better Than Beige","hex":"#ebe2cb","rgb":{"r":235,"g":226,"b":203},"luminance":151.89446544558496},{"name":"Beveled Glass","hex":"#7accb8","rgb":{"r":122,"g":204,"b":184},"luminance":126.92604367898655},{"name":"Bewitching","hex":"#75495e","rgb":{"r":117,"g":73,"b":94},"luminance":56.34581746678275},{"name":"Beyond the Pines","hex":"#688049","rgb":{"r":104,"g":128,"b":73},"luminance":81.74127106914841},{"name":"Beyond the Wall","hex":"#d7e0eb","rgb":{"r":215,"g":224,"b":235},"luminance":148.79300880417736},{"name":"Bhūrā Brown","hex":"#947706","rgb":{"r":148,"g":119,"b":6},"luminance":82.69310109676623},{"name":"Białowieża Forest","hex":"#1c5022","rgb":{"r":28,"g":80,"b":34},"luminance":47.85765727655293},{"name":"Bianca","hex":"#f4efe0","rgb":{"r":244,"g":239,"b":224},"luminance":160.17737381103487},{"name":"Bianchi Green","hex":"#3dcfc2","rgb":{"r":61,"g":207,"b":194},"luminance":124.84476624192139},{"name":"Bicyclette","hex":"#802c3a","rgb":{"r":128,"g":44,"b":58},"luminance":46.642792712272275},{"name":"Bidwell Blue","hex":"#a9b9b5","rgb":{"r":169,"g":185,"b":181},"luminance":121.5401906449056},{"name":"Bidwell Brown","hex":"#b19c8f","rgb":{"r":177,"g":156,"b":143},"luminance":107.01415942294737},{"name":"Biel-Tan Green","hex":"#1ba169","rgb":{"r":27,"g":161,"b":105},"luminance":95.60348988399952},{"name":"Bierwurst","hex":"#f0908d","rgb":{"r":240,"g":144,"b":141},"luminance":112.03951918854347},{"name":"Big Band","hex":"#afaba0","rgb":{"r":175,"g":171,"b":160},"luminance":114.65664112470763},{"name":"Big Bang Pink","hex":"#ff0099","rgb":{"r":255,"g":0,"b":153},"luminance":78.2145983113127},{"name":"Big Cypress","hex":"#b98675","rgb":{"r":185,"g":134,"b":117},"luminance":97.08106114479797},{"name":"Big Daddy Blue","hex":"#5d6b75","rgb":{"r":93,"g":107,"b":117},"luminance":69.9721514175461},{"name":"Big Dip O’Ruby","hex":"#9c2542","rgb":{"r":156,"g":37,"b":66},"luminance":51.99988724026236},{"name":"Big Fish to Fry","hex":"#dadbe1","rgb":{"r":218,"g":219,"b":225},"luminance":146.39839286344642},{"name":"Big Foot Feet","hex":"#e88e5a","rgb":{"r":232,"g":142,"b":90},"luminance":108.92693119701849},{"name":"Big Horn Mountains","hex":"#b79e94","rgb":{"r":183,"g":158,"b":148},"luminance":108.99740817560755},{"name":"Big Sky","hex":"#cde2de","rgb":{"r":205,"g":226,"b":222},"luminance":148.31310843280173},{"name":"Big Spender","hex":"#acddaf","rgb":{"r":172,"g":221,"b":175},"luminance":140.96785524721585},{"name":"Big Stone","hex":"#334046","rgb":{"r":51,"g":64,"b":70},"luminance":41.32271802531871},{"name":"Big Stone Beach","hex":"#886e54","rgb":{"r":136,"g":110,"b":84},"luminance":76.90608280233755},{"name":"Big Sur","hex":"#b3cadc","rgb":{"r":179,"g":202,"b":220},"luminance":132.48885733147523},{"name":"Big Sur Blue Jade","hex":"#3f6e8e","rgb":{"r":63,"g":110,"b":142},"luminance":69.18214229842842},{"name":"Big Yellow Streak","hex":"#ffee22","rgb":{"r":255,"g":238,"b":34},"luminance":159.20455344304696},{"name":"Big Yellow Taxi","hex":"#ffff33","rgb":{"r":255,"g":255,"b":51},"luminance":168.08540045464986},{"name":"Bigfoot","hex":"#715145","rgb":{"r":113,"g":81,"b":69},"luminance":58.85705169306393},{"name":"Bighorn Sheep","hex":"#20120e","rgb":{"r":32,"g":18,"b":14},"luminance":14.343437384392905},{"name":"Bijou Blue","hex":"#4e5e7f","rgb":{"r":78,"g":94,"b":127},"luminance":61.629050390217756},{"name":"Bijoux Green","hex":"#676b55","rgb":{"r":103,"g":107,"b":85},"luminance":70.6209727347337},{"name":"Biking Red","hex":"#77212e","rgb":{"r":119,"g":33,"b":46},"luminance":40.85024771038726},{"name":"Bilbao","hex":"#3e8027","rgb":{"r":62,"g":128,"b":39},"luminance":77.51672629826416},{"name":"Bilberry","hex":"#71777e","rgb":{"r":113,"g":119,"b":126},"luminance":78.91341757901503},{"name":"Bile","hex":"#b5c306","rgb":{"r":181,"g":195,"b":6},"luminance":126.6158372479525},{"name":"Bilious Brown","hex":"#e39f08","rgb":{"r":227,"g":159,"b":8},"luminance":115.4063462813029},{"name":"Bilious Green","hex":"#a9d171","rgb":{"r":169,"g":209,"b":113},"luminance":133.30583773413676},{"name":"Billabong","hex":"#1b6f81","rgb":{"r":27,"g":111,"b":129},"luminance":67.28205120238235},{"name":"Billet","hex":"#ad7c35","rgb":{"r":173,"g":124,"b":53},"luminance":89.50017450820975},{"name":"Billiard","hex":"#00aa92","rgb":{"r":0,"g":170,"b":146},"luminance":101.1685071353729},{"name":"Billiard Ball","hex":"#276b40","rgb":{"r":39,"g":107,"b":64},"luminance":64.29759729569993},{"name":"Billiard Green","hex":"#305a4a","rgb":{"r":48,"g":90,"b":74},"luminance":55.39092795756359},{"name":"Billiard Table","hex":"#155843","rgb":{"r":21,"g":88,"b":67},"luminance":52.59379451037926},{"name":"Billowing Clouds","hex":"#d8dee3","rgb":{"r":216,"g":222,"b":227},"luminance":147.72441415013296},{"name":"Billowing Sail","hex":"#d8e7e7","rgb":{"r":216,"g":231,"b":231},"luminance":152.48317619003086},{"name":"Billycart Blue","hex":"#4c77a4","rgb":{"r":76,"g":119,"b":164},"luminance":75.79816753062042},{"name":"Biloba Flower","hex":"#ae99d2","rgb":{"r":174,"g":153,"b":210},"luminance":106.51687188891721},{"name":"Biltong","hex":"#410200","rgb":{"r":65,"g":2,"b":0},"luminance":19.47042631788015},{"name":"Bimini Blue","hex":"#007a91","rgb":{"r":0,"g":122,"b":145},"luminance":73.4969788222618},{"name":"Bindi Dot","hex":"#8b3439","rgb":{"r":139,"g":52,"b":57},"luminance":51.973601962919595},{"name":"Bindi Red","hex":"#b0003c","rgb":{"r":176,"g":0,"b":60},"luminance":53.06666539363482},{"name":"Binrouji Black","hex":"#433d3c","rgb":{"r":67,"g":61,"b":60},"luminance":41.59624908570482},{"name":"Bio Blue","hex":"#465f9e","rgb":{"r":70,"g":95,"b":158},"luminance":62.22726306852969},{"name":"Biogenic Sand","hex":"#ffefd5","rgb":{"r":255,"g":239,"b":213},"luminance":161.50864186785793},{"name":"Biohazard Suit","hex":"#fbfb4c","rgb":{"r":251,"g":251,"b":76},"luminance":165.5765951636885},{"name":"BioShock","hex":"#889900","rgb":{"r":136,"g":153,"b":0},"luminance":98.58791313847757},{"name":"Birch","hex":"#3f3726","rgb":{"r":63,"g":55,"b":38},"luminance":37.62871268061132},{"name":"Birch Beige","hex":"#d9c3a1","rgb":{"r":217,"g":195,"b":161},"luminance":132.84919732538845},{"name":"Birch Forest","hex":"#899a8b","rgb":{"r":137,"g":154,"b":139},"luminance":100.50304218778653},{"name":"Birch Strain","hex":"#dfb45f","rgb":{"r":223,"g":180,"b":95},"luminance":125.4079217154961},{"name":"Birch White","hex":"#f6eedf","rgb":{"r":246,"g":238,"b":223},"luminance":159.9194654693418},{"name":"Birchwood","hex":"#ccbeac","rgb":{"r":204,"g":190,"b":172},"luminance":128.623196119518},{"name":"Birchy Woods","hex":"#806843","rgb":{"r":128,"g":104,"b":67},"luminance":72.45649268354079},{"name":"Bird Flower","hex":"#d0c117","rgb":{"r":208,"g":193,"b":23},"luminance":129.26550363109254},{"name":"Bird Of Paradise","hex":"#0083a8","rgb":{"r":0,"g":131,"b":168},"luminance":79.24612112274012},{"name":"Bird's Child","hex":"#fff1cf","rgb":{"r":255,"g":241,"b":207},"luminance":162.42868502207358},{"name":"Bird's Egg Green","hex":"#aaccb9","rgb":{"r":170,"g":204,"b":185},"luminance":131.78793762708332},{"name":"Bird's Nest","hex":"#cfbb9b","rgb":{"r":207,"g":187,"b":155},"luminance":127.24859806693352},{"name":"Birdhouse Brown","hex":"#6c483a","rgb":{"r":108,"g":72,"b":58},"luminance":53.597924437425746},{"name":"Birdie","hex":"#e9e424","rgb":{"r":233,"g":228,"b":36},"luminance":150.93842652220803},{"name":"Birdie Num Num","hex":"#89acda","rgb":{"r":137,"g":172,"b":218},"luminance":111.75561985421582},{"name":"Birdseed","hex":"#e2c28e","rgb":{"r":226,"g":194,"b":142},"luminance":133.40350709033103},{"name":"Biro Blue","hex":"#2f3946","rgb":{"r":47,"g":57,"b":70},"luminance":37.15739347693807},{"name":"Birōdo Green","hex":"#224634","rgb":{"r":34,"g":70,"b":52},"luminance":42.74197983247851},{"name":"Birth of a Star","hex":"#fce9df","rgb":{"r":252,"g":233,"b":223},"luminance":158.20842464609777},{"name":"Birthday Cake","hex":"#e9d2cc","rgb":{"r":233,"g":210,"b":204},"luminance":143.49155140634588},{"name":"Birthday King","hex":"#9bdcb9","rgb":{"r":155,"g":220,"b":185},"luminance":138.81565734815362},{"name":"Birthday Suit","hex":"#e2c7b6","rgb":{"r":226,"g":199,"b":182},"luminance":136.53571675206453},{"name":"Biscay","hex":"#2f3c53","rgb":{"r":47,"g":60,"b":83},"luminance":39.08279228765519},{"name":"Biscay Bay","hex":"#097988","rgb":{"r":9,"g":121,"b":136},"luminance":72.74922835329595},{"name":"Biscay Green","hex":"#55c6a9","rgb":{"r":85,"g":198,"b":169},"luminance":120.52213098431342},{"name":"Biscotti","hex":"#dac7ab","rgb":{"r":218,"g":199,"b":171},"luminance":135.18130835659196},{"name":"Biscuit","hex":"#feedca","rgb":{"r":254,"g":237,"b":202},"luminance":160.16297905883243},{"name":"Bismarck","hex":"#486c7a","rgb":{"r":72,"g":108,"b":122},"luminance":68.38084573913955},{"name":"Bison","hex":"#6e4f3a","rgb":{"r":110,"g":79,"b":58},"luminance":57.23570365602226},{"name":"Bison Beige","hex":"#9f9180","rgb":{"r":159,"g":145,"b":128},"luminance":98.57807246036006},{"name":"Bison Hide","hex":"#b5ac94","rgb":{"r":181,"g":172,"b":148},"luminance":115.78972251888334},{"name":"Bisque","hex":"#ffe4c4","rgb":{"r":255,"g":228,"b":196},"luminance":155.6426331600696},{"name":"Bisque Tan","hex":"#e5d2b0","rgb":{"r":229,"g":210,"b":176},"luminance":142.43010509369148},{"name":"Bistre","hex":"#3d2b1f","rgb":{"r":61,"g":43,"b":31},"luminance":31.341001228422808},{"name":"Bistre Brown","hex":"#967117","rgb":{"r":150,"g":113,"b":23},"luminance":80.1136626612465},{"name":"Bistro Green","hex":"#395551","rgb":{"r":57,"g":85,"b":81},"luminance":53.527951856950395},{"name":"Bit of Berry","hex":"#dd5599","rgb":{"r":221,"g":85,"b":153},"luminance":84.61777963288803},{"name":"Bit of Blue","hex":"#e2eaeb","rgb":{"r":226,"g":234,"b":235},"luminance":155.4064662103865},{"name":"Bit of Heaven","hex":"#cad7de","rgb":{"r":202,"g":215,"b":222},"luminance":142.18338613565228},{"name":"Bit of Lime","hex":"#e1e5ac","rgb":{"r":225,"g":229,"b":172},"luminance":151.5913659084844},{"name":"Bitcoin","hex":"#ffbb11","rgb":{"r":255,"g":187,"b":17},"luminance":133.6648391687208},{"name":"Bite the Bullet","hex":"#ecebce","rgb":{"r":236,"g":235,"b":206},"luminance":156.71502600899504},{"name":"Bitter","hex":"#88896c","rgb":{"r":136,"g":137,"b":108},"luminance":90.95252498419161},{"name":"Bitter Chocolate","hex":"#9e5b40","rgb":{"r":158,"g":91,"b":64},"luminance":71.68273201406319},{"name":"Bitter Dandelion","hex":"#6ecb3c","rgb":{"r":110,"g":203,"b":60},"luminance":123.8058222419285},{"name":"Bitter Lemon","hex":"#d2db32","rgb":{"r":210,"g":219,"b":50},"luminance":143.18152083631463},{"name":"Bitter Lime","hex":"#cfff00","rgb":{"r":207,"g":255,"b":0},"luminance":161.97636455359776},{"name":"Bitter Melon","hex":"#cfd1b2","rgb":{"r":207,"g":209,"b":178},"luminance":138.90150179893664},{"name":"Bittersweet","hex":"#fea051","rgb":{"r":254,"g":160,"b":81},"luminance":121.13640275325992},{"name":"Bittersweet Shimmer","hex":"#bf4f51","rgb":{"r":191,"g":79,"b":81},"luminance":74.14283354444986},{"name":"Bizarre","hex":"#e7d2c8","rgb":{"r":231,"g":210,"b":200},"luminance":143.12882190879654},{"name":"Black","hex":"#000000","rgb":{"r":0,"g":0,"b":0},"luminance":0},{"name":"Black Bay","hex":"#474a4e","rgb":{"r":71,"g":74,"b":78},"luminance":49.15890508341291},{"name":"Black Bean","hex":"#4e4b4a","rgb":{"r":78,"g":75,"b":74},"luminance":50.53001489214109},{"name":"Black Beauty","hex":"#26262a","rgb":{"r":38,"g":38,"b":42},"luminance":25.48681274698741},{"name":"Black Blueberry","hex":"#2f2f48","rgb":{"r":47,"g":47,"b":72},"luminance":32.031406369374416},{"name":"Black Cat","hex":"#2e2f31","rgb":{"r":46,"g":47,"b":49},"luminance":31.329360558428252},{"name":"Black Chestnut Oak","hex":"#252321","rgb":{"r":37,"g":35,"b":33},"luminance":23.635558762170188},{"name":"Black Chocolate","hex":"#441100","rgb":{"r":68,"g":17,"b":0},"luminance":22.64885571060931},{"name":"Black Coffee","hex":"#3b302f","rgb":{"r":59,"g":48,"b":47},"luminance":33.67194709249823},{"name":"Black Coral","hex":"#54626f","rgb":{"r":84,"g":98,"b":111},"luminance":64.03263111882877},{"name":"Black Dahlia","hex":"#4e434d","rgb":{"r":78,"g":67,"b":77},"luminance":46.558986339910795},{"name":"Black Diamond Apple","hex":"#8a779a","rgb":{"r":138,"g":119,"b":154},"luminance":83.0072731090475},{"name":"Black Dragon's Cauldron","hex":"#545562","rgb":{"r":84,"g":85,"b":98},"luminance":56.96611330431452},{"name":"Black Drop","hex":"#90abd9","rgb":{"r":144,"g":171,"b":217},"luminance":111.98807931650583},{"name":"Black Elder","hex":"#a66e7a","rgb":{"r":166,"g":110,"b":122},"luminance":82.62113119535461},{"name":"Black Elegance","hex":"#50484a","rgb":{"r":80,"g":72,"b":74},"luminance":49.29075158688493},{"name":"Black Feather","hex":"#112222","rgb":{"r":17,"g":34,"b":34},"luminance":20.95667027464048},{"name":"Black Flame","hex":"#484b5a","rgb":{"r":72,"g":75,"b":90},"luminance":50.06918222819302},{"name":"Black Forest","hex":"#5e6354","rgb":{"r":94,"g":99,"b":84},"luminance":65.25923521617457},{"name":"Black Glaze","hex":"#001111","rgb":{"r":0,"g":17,"b":17},"luminance":10.165445637058907},{"name":"Black Green","hex":"#384e49","rgb":{"r":56,"g":78,"b":73},"luminance":49.45679949208197},{"name":"Black Grey","hex":"#24272e","rgb":{"r":36,"g":39,"b":46},"luminance":25.835105592971743},{"name":"Black Haze","hex":"#e0ded7","rgb":{"r":224,"g":222,"b":215},"luminance":148.55390695636382},{"name":"Black Headed Gull","hex":"#9c856c","rgb":{"r":156,"g":133,"b":108},"luminance":91.77324839516142},{"name":"Black Hills Gold","hex":"#c89180","rgb":{"r":200,"g":145,"b":128},"luminance":105.04060971357697},{"name":"Black Hole","hex":"#010203","rgb":{"r":1,"g":2,"b":3},"luminance":1.258825246013123},{"name":"Black Htun","hex":"#110033","rgb":{"r":17,"g":0,"b":51},"luminance":7.7226604871637345},{"name":"Black Ice","hex":"#4d5051","rgb":{"r":77,"g":80,"b":81},"luminance":53.109009452257716},{"name":"Black Ink","hex":"#44413c","rgb":{"r":68,"g":65,"b":60},"luminance":43.771907075200644},{"name":"Black Iris","hex":"#2b3042","rgb":{"r":43,"g":48,"b":66},"luminance":31.87161748327185},{"name":"Black Is Beautiful","hex":"#552222","rgb":{"r":85,"g":34,"b":34},"luminance":32.54638789481868},{"name":"Black Jasmine Rice","hex":"#74563d","rgb":{"r":116,"g":86,"b":61},"luminance":61.64227685606689},{"name":"Black Kite","hex":"#351e1c","rgb":{"r":53,"g":30,"b":28},"luminance":23.904568036256165},{"name":"Black Knight","hex":"#010b13","rgb":{"r":1,"g":11,"b":19},"luminance":6.817169940671862},{"name":"Black Lead","hex":"#474c4d","rgb":{"r":71,"g":76,"b":77},"luminance":50.179221486587444},{"name":"Black Leather Jacket","hex":"#253529","rgb":{"r":37,"g":53,"b":41},"luminance":33.348621650676954},{"name":"Black Magic","hex":"#4f4554","rgb":{"r":79,"g":69,"b":84},"luminance":47.85545346143948},{"name":"Black Market","hex":"#222244","rgb":{"r":34,"g":34,"b":68},"luminance":23.701536321512997},{"name":"Black Marlin","hex":"#383740","rgb":{"r":56,"g":55,"b":64},"luminance":37.09331984333567},{"name":"Black Mesa","hex":"#222211","rgb":{"r":34,"g":34,"b":17},"luminance":22.481662838856025},{"name":"Black Metal","hex":"#060606","rgb":{"r":6,"g":6,"b":6},"luminance":4.011330951193132},{"name":"Black Oak","hex":"#4e4f4e","rgb":{"r":78,"g":79,"b":78},"luminance":52.663445358236864},{"name":"Black Olive","hex":"#3b3c36","rgb":{"r":59,"g":60,"b":54},"luminance":39.86915621128694},{"name":"Black Onyx","hex":"#2b272b","rgb":{"r":43,"g":39,"b":43},"luminance":26.70995136648511},{"name":"Black Out","hex":"#222222","rgb":{"r":34,"g":34,"b":34},"luminance":22.730875390094415},{"name":"Black Panther","hex":"#424242","rgb":{"r":66,"g":66,"b":66},"luminance":44.12464046312445},{"name":"Black Pearl","hex":"#1e272c","rgb":{"r":30,"g":39,"b":44},"luminance":25.094035247444758},{"name":"Black Plum","hex":"#6c5765","rgb":{"r":108,"g":87,"b":101},"luminance":61.50925313316689},{"name":"Black Pool","hex":"#4f5552","rgb":{"r":79,"g":85,"b":82},"luminance":55.98971128698557},{"name":"Black Powder","hex":"#34342c","rgb":{"r":52,"g":52,"b":44},"luminance":34.62102159093518},{"name":"Black Pudding","hex":"#a44a56","rgb":{"r":164,"g":74,"b":86},"luminance":66.23826353400275},{"name":"Black Raspberry","hex":"#16110d","rgb":{"r":22,"g":17,"b":13},"luminance":12.04353972053067},{"name":"Black River Falls","hex":"#343e54","rgb":{"r":52,"g":62,"b":84},"luminance":40.71809568238672},{"name":"Black Rock","hex":"#2c2d3c","rgb":{"r":44,"g":45,"b":60},"luminance":30.29221287723959},{"name":"Black Rooster","hex":"#331111","rgb":{"r":51,"g":17,"b":17},"luminance":18.32670963375586},{"name":"Black Rose","hex":"#532934","rgb":{"r":83,"g":41,"b":52},"luminance":35.07485084786534},{"name":"Black Russian","hex":"#24252b","rgb":{"r":36,"g":37,"b":43},"luminance":24.730714931032622},{"name":"Black Sabbath","hex":"#220022","rgb":{"r":34,"g":0,"b":34},"luminance":10.879840623832687},{"name":"Black Safflower","hex":"#302833","rgb":{"r":48,"g":40,"b":51},"luminance":28.12637374422803},{"name":"Black Sand","hex":"#5b4e4b","rgb":{"r":91,"g":78,"b":75},"luminance":53.942469140742894},{"name":"Black Shadows","hex":"#bfafb2","rgb":{"r":191,"g":175,"b":178},"luminance":119.27124033060106},{"name":"Black Sheep","hex":"#0f0d0d","rgb":{"r":15,"g":13,"b":13},"luminance":8.974614754963023},{"name":"Black Slug","hex":"#332211","rgb":{"r":51,"g":34,"b":17},"luminance":25.19145904865377},{"name":"Black Soap","hex":"#19443c","rgb":{"r":25,"g":68,"b":60},"luminance":41.18189263499189},{"name":"Black Spruce","hex":"#4c5752","rgb":{"r":76,"g":87,"b":82},"luminance":56.67281571441461},{"name":"Black Squeeze","hex":"#e5e6df","rgb":{"r":229,"g":230,"b":223},"luminance":153.5000196254059},{"name":"Black Swan","hex":"#332200","rgb":{"r":51,"g":34,"b":0},"luminance":25.116802443782525},{"name":"Black Tie","hex":"#464647","rgb":{"r":70,"g":70,"b":71},"luminance":46.818434788019125},{"name":"Black Tortoise","hex":"#353235","rgb":{"r":53,"g":50,"b":53},"luminance":33.8977237141375},{"name":"Black Truffle","hex":"#463d3e","rgb":{"r":70,"g":61,"b":62},"luminance":42.073302378111464},{"name":"Black Velvet","hex":"#222233","rgb":{"r":34,"g":34,"b":51},"luminance":23.140266117743764},{"name":"Black Walnut","hex":"#5e4f46","rgb":{"r":94,"g":79,"b":70},"luminance":54.809513453414276},{"name":"Black Wash","hex":"#0c0c0c","rgb":{"r":12,"g":12,"b":12},"luminance":8.022661902386265},{"name":"Black Water","hex":"#2e4846","rgb":{"r":46,"g":72,"b":70},"luminance":45.156379527149866},{"name":"Black White","hex":"#e5e4db","rgb":{"r":229,"g":228,"b":219},"luminance":152.3930900434793},{"name":"Blackadder","hex":"#292c2c","rgb":{"r":41,"g":44,"b":44},"luminance":29.026348736966554},{"name":"Blackberry","hex":"#43182f","rgb":{"r":67,"g":24,"b":47},"luminance":25.069922157836867},{"name":"Blackberry Burgundy","hex":"#4c3938","rgb":{"r":76,"g":57,"b":56},"luminance":40.946798568386264},{"name":"Blackberry Cordial","hex":"#3f2a47","rgb":{"r":63,"g":42,"b":71},"luminance":32.065013971617105},{"name":"Blackberry Jam","hex":"#87657e","rgb":{"r":135,"g":101,"b":126},"luminance":73.14783722024869},{"name":"Blackberry Pie","hex":"#64242e","rgb":{"r":100,"g":36,"b":46},"luminance":36.98744327471148},{"name":"Blackberry Sorbet","hex":"#c1a3b9","rgb":{"r":193,"g":163,"b":185},"luminance":113.70901331908566},{"name":"Blackberry Tint","hex":"#8f5973","rgb":{"r":143,"g":89,"b":115},"luminance":68.77037296685252},{"name":"Blackberry Wine","hex":"#4d3246","rgb":{"r":77,"g":50,"b":70},"luminance":38.14657820827446},{"name":"Blackberry Yogurt","hex":"#e5bddf","rgb":{"r":229,"g":189,"b":223},"luminance":132.82659814208898},{"name":"Blackbird's Ggg","hex":"#fce7e4","rgb":{"r":252,"g":231,"b":228},"luminance":157.28779856365207},{"name":"Blackcurrant","hex":"#2e183b","rgb":{"r":46,"g":24,"b":59},"luminance":20.805848600814148},{"name":"Blackcurrant Conserve","hex":"#52383d","rgb":{"r":82,"g":56,"b":61},"luminance":41.59397581381227},{"name":"Blackcurrant Elixir","hex":"#5c4f6a","rgb":{"r":92,"g":79,"b":106},"luminance":55.255481619473734},{"name":"Blackened Brown","hex":"#442200","rgb":{"r":68,"g":34,"b":0},"luminance":28.49055962946323},{"name":"Blackened Pearl","hex":"#4d4b50","rgb":{"r":77,"g":75,"b":80},"luminance":50.51171699714829},{"name":"Blackest Berry","hex":"#662266","rgb":{"r":102,"g":34,"b":102},"luminance":38.25781164677352},{"name":"Blackest Brown","hex":"#403330","rgb":{"r":64,"g":51,"b":48},"luminance":35.94931500042804},{"name":"Blackfire Earth","hex":"#7a5901","rgb":{"r":122,"g":89,"b":1},"luminance":63.71803927460417},{"name":"Blackheath","hex":"#49454b","rgb":{"r":73,"g":69,"b":75},"luminance":46.79757940321272},{"name":"Blackish Brown","hex":"#453b32","rgb":{"r":69,"g":59,"b":50},"luminance":40.71330065224385},{"name":"Blackish Green","hex":"#5d6161","rgb":{"r":93,"g":97,"b":97},"luminance":64.32385509280364},{"name":"Blackish Grey","hex":"#5b5c61","rgb":{"r":91,"g":92,"b":97},"luminance":61.47390552909421},{"name":"Blackjack","hex":"#51504d","rgb":{"r":81,"g":80,"b":77},"luminance":53.56169195423161},{"name":"Blacklist","hex":"#221133","rgb":{"r":34,"g":17,"b":51},"luminance":15.386051897741668},{"name":"Blackmail","hex":"#220066","rgb":{"r":34,"g":0,"b":102},"luminance":15.445320974327469},{"name":"Blackout","hex":"#0e0702","rgb":{"r":14,"g":7,"b":2},"luminance":5.870132962718987},{"name":"Blackthorn Berry","hex":"#8470ff","rgb":{"r":132,"g":112,"b":255},"luminance":82.00647206166109},{"name":"Blackwater Park","hex":"#696268","rgb":{"r":105,"g":98,"b":104},"luminance":66.59918495747526},{"name":"Blade Green","hex":"#6a9266","rgb":{"r":106,"g":146,"b":102},"luminance":92.11163240329638},{"name":"Bladed Grass","hex":"#758269","rgb":{"r":117,"g":130,"b":105},"luminance":84.79567965999212},{"name":"Bladerunner","hex":"#6a8561","rgb":{"r":106,"g":133,"b":97},"luminance":84.98158648201385},{"name":"Blair","hex":"#a1bde0","rgb":{"r":161,"g":189,"b":224},"luminance":123.60339746948706},{"name":"Blanc","hex":"#d9d0c2","rgb":{"r":217,"g":208,"b":194},"luminance":140.02269230735422},{"name":"Blanc Cassé","hex":"#f1eee2","rgb":{"r":241,"g":238,"b":226},"luminance":159.29234009518473},{"name":"Blanc De Blanc","hex":"#e7e9e7","rgb":{"r":231,"g":233,"b":231},"luminance":155.46804416985503},{"name":"Blanched Almond","hex":"#ffebcd","rgb":{"r":255,"g":235,"b":205},"luminance":159.33700119557918},{"name":"Blanched Driftwood","hex":"#ccbeb6","rgb":{"r":204,"g":190,"b":182},"luminance":128.80191155413803},{"name":"Bland","hex":"#afa88b","rgb":{"r":175,"g":168,"b":139},"luminance":112.75689245895347},{"name":"Blank Canvas","hex":"#ffefd6","rgb":{"r":255,"g":239,"b":214},"luminance":161.52582050557734},{"name":"Blanka Green","hex":"#9cd33c","rgb":{"r":156,"g":211,"b":60},"luminance":132.52548730338629},{"name":"Blarney","hex":"#00a776","rgb":{"r":0,"g":167,"b":118},"luminance":98.94766871937912},{"name":"Blarney Stone","hex":"#027944","rgb":{"r":2,"g":121,"b":68},"luminance":71.45128296258927},{"name":"Blast-Off Bronze","hex":"#a57164","rgb":{"r":165,"g":113,"b":100},"luminance":83.44880937437036},{"name":"Blasted Lands Rocks","hex":"#6c3550","rgb":{"r":108,"g":53,"b":80},"luminance":45.75851816875193},{"name":"Blaze","hex":"#fa8c4f","rgb":{"r":250,"g":140,"b":79},"luminance":111.4550265174254},{"name":"Blaze Orange","hex":"#fe6700","rgb":{"r":254,"g":103,"b":0},"luminance":97.07382467483188},{"name":"Blazing Autumn","hex":"#f3ad63","rgb":{"r":243,"g":173,"b":99},"luminance":125.37551214651128},{"name":"Blazing Orange","hex":"#ffa64f","rgb":{"r":255,"g":166,"b":79},"luminance":124.0538247092769},{"name":"Blazing Yellow","hex":"#fee715","rgb":{"r":254,"g":231,"b":21},"luminance":155.43510723449833},{"name":"Bleach White","hex":"#ebe1ce","rgb":{"r":235,"g":225,"b":206},"luminance":151.4347189583683},{"name":"Bleached Apricot","hex":"#fccaac","rgb":{"r":252,"g":202,"b":172},"luminance":141.85058422156743},{"name":"Bleached Aqua","hex":"#bce3df","rgb":{"r":188,"g":227,"b":223},"luminance":146.8378800888926},{"name":"Bleached Bare","hex":"#d0c7c3","rgb":{"r":208,"g":199,"b":195},"luminance":134.19126176096563},{"name":"Bleached Bark","hex":"#8b7f78","rgb":{"r":139,"g":127,"b":120},"luminance":86.4408035709988},{"name":"Bleached Bone","hex":"#efd9a8","rgb":{"r":239,"g":217,"b":168},"luminance":147.30540813561464},{"name":"Bleached Cedar","hex":"#2c2133","rgb":{"r":44,"g":33,"b":51},"luminance":24.127133542963612},{"name":"Bleached Coral","hex":"#ffd6d1","rgb":{"r":255,"g":214,"b":209},"luminance":148.8652418296494},{"name":"Bleached Denim","hex":"#646f9b","rgb":{"r":100,"g":111,"b":155},"luminance":73.8354491352223},{"name":"Bleached Grey","hex":"#788878","rgb":{"r":120,"g":136,"b":120},"luminance":88.58704772143611},{"name":"Bleached Jade","hex":"#e2e6d1","rgb":{"r":226,"g":230,"b":209},"luminance":152.8450975726732},{"name":"Bleached Maple","hex":"#c7a06c","rgb":{"r":199,"g":160,"b":108},"luminance":111.86116727890871},{"name":"Bleached Sand","hex":"#daccb4","rgb":{"r":218,"g":204,"b":180},"luminance":137.874388586133},{"name":"Bleached Silk","hex":"#f3f3f2","rgb":{"r":243,"g":243,"b":242},"luminance":162.43950342819937},{"name":"Bleached Spruce","hex":"#bad7ae","rgb":{"r":186,"g":215,"b":174},"luminance":139.3344390917048},{"name":"Bleached Wheat","hex":"#ddd2a9","rgb":{"r":221,"g":210,"b":169},"luminance":141.1846517756091},{"name":"Bleaches","hex":"#c7c7c3","rgb":{"r":199,"g":199,"b":195},"luminance":132.96547999386908},{"name":"Bleeding Heart","hex":"#c02e4c","rgb":{"r":192,"g":46,"b":76},"luminance":64.03008171164551},{"name":"Blende Blue","hex":"#a9c4c4","rgb":{"r":169,"g":196,"b":196},"luminance":127.63071339219255},{"name":"Blended Fruit","hex":"#f8e3a4","rgb":{"r":248,"g":227,"b":164},"luminance":153.6338358598131},{"name":"Blended Light","hex":"#fffbe8","rgb":{"r":255,"g":251,"b":232},"luminance":167.99103636206306},{"name":"Bleu Ciel","hex":"#007ba1","rgb":{"r":0,"g":123,"b":161},"luminance":74.49734033507504},{"name":"Bleu De France","hex":"#318ce7","rgb":{"r":49,"g":140,"b":231},"luminance":87.53104453278276},{"name":"Bleu Nattier","hex":"#9cc2bf","rgb":{"r":156,"g":194,"b":191},"luminance":124.97187161917677},{"name":"Bleuchâtel Blue","hex":"#4488ff","rgb":{"r":68,"g":136,"b":255},"luminance":87.35904846093506},{"name":"Blind Date","hex":"#bcaea1","rgb":{"r":188,"g":174,"b":161},"luminance":118.02046137852537},{"name":"Blind Forest","hex":"#223300","rgb":{"r":34,"g":51,"b":0},"luminance":31.616001091219616},{"name":"Bling Bling","hex":"#eef0ce","rgb":{"r":238,"g":240,"b":206},"luminance":159.57036974325777},{"name":"Blinking Blue","hex":"#0033ff","rgb":{"r":0,"g":51,"b":255},"luminance":41.72875350402885},{"name":"Blinking Terminal","hex":"#66cc00","rgb":{"r":102,"g":204,"b":0},"luminance":123.57067414237085},{"name":"Blissful","hex":"#ddc4d4","rgb":{"r":221,"g":196,"b":212},"luminance":134.86099943645678},{"name":"Blissful Berry","hex":"#aa1188","rgb":{"r":170,"g":17,"b":136},"luminance":54.07072550835618},{"name":"Blissful Light","hex":"#e5d2dd","rgb":{"r":229,"g":210,"b":221},"luminance":143.24283010678056},{"name":"Blissful Meditation","hex":"#d5daee","rgb":{"r":213,"g":218,"b":238},"luminance":145.4904689283803},{"name":"Blissful Orange","hex":"#ffac39","rgb":{"r":255,"g":172,"b":57},"luminance":126.68564766776068},{"name":"Blissful Serenity","hex":"#eaeed8","rgb":{"r":234,"g":238,"b":216},"luminance":158.17505798323577},{"name":"Blissfully Mine","hex":"#dab6cd","rgb":{"r":218,"g":182,"b":205},"luminance":127.3120323457292},{"name":"Blister Pearl","hex":"#aaffee","rgb":{"r":170,"g":255,"b":238},"luminance":160.39150086273276},{"name":"Blithe","hex":"#0084bd","rgb":{"r":0,"g":132,"b":189},"luminance":80.42387936427836},{"name":"Blizzard Blue","hex":"#a3e3ed","rgb":{"r":163,"g":227,"b":237},"luminance":144.43186453826593},{"name":"Blobfish","hex":"#ffc1cc","rgb":{"r":255,"g":193,"b":204},"luminance":138.5243380854065},{"name":"Blockchain Gold","hex":"#e8bc50","rgb":{"r":232,"g":188,"b":80},"luminance":130.6657589424253},{"name":"Bloedworst","hex":"#560319","rgb":{"r":86,"g":3,"b":25},"luminance":25.931321158012754},{"name":"Blond","hex":"#faf0be","rgb":{"r":250,"g":240,"b":190},"luminance":160.94686234903742},{"name":"Blonde Beauty","hex":"#f2efcd","rgb":{"r":242,"g":239,"b":205},"luminance":159.5743178365491},{"name":"Blonde Curl","hex":"#efe2c5","rgb":{"r":239,"g":226,"b":197},"luminance":152.34908115574575},{"name":"Blonde Girl","hex":"#edc558","rgb":{"r":237,"g":197,"b":88},"luminance":135.99479443714011},{"name":"Blonde Shell","hex":"#f6edcd","rgb":{"r":246,"g":237,"b":205},"luminance":159.09256417884527},{"name":"Blonde Wool","hex":"#e5d0b1","rgb":{"r":229,"g":208,"b":177},"luminance":141.43147719302092},{"name":"Blood","hex":"#770001","rgb":{"r":119,"g":0,"b":1},"luminance":35.5811826250899},{"name":"Blood Brother","hex":"#770011","rgb":{"r":119,"g":0,"b":17},"luminance":35.63373969989678},{"name":"Blood Burst","hex":"#ff474c","rgb":{"r":255,"g":71,"b":76},"luminance":87.32317704939507},{"name":"Blood God","hex":"#67080b","rgb":{"r":103,"g":8,"b":11},"luminance":31.178199771635306},{"name":"Blood Mahogany","hex":"#543839","rgb":{"r":84,"g":56,"b":57},"luminance":41.87607722793528},{"name":"Blood Omen","hex":"#8a0303","rgb":{"r":138,"g":3,"b":3},"luminance":41.300977337104264},{"name":"Blood Orange","hex":"#d1001c","rgb":{"r":209,"g":0,"b":28},"luminance":62.57246954532001},{"name":"Blood Orange Juice","hex":"#fe4b03","rgb":{"r":254,"g":75,"b":3},"luminance":87.78446619419634},{"name":"Blood Organ","hex":"#630f0f","rgb":{"r":99,"g":15,"b":15},"luminance":30.930103879553975},{"name":"Blood Pact","hex":"#771111","rgb":{"r":119,"g":17,"b":17},"luminance":37.00464627583947},{"name":"Blood Red","hex":"#980002","rgb":{"r":152,"g":0,"b":2},"luminance":45.4485719027562},{"name":"Blood Thorn","hex":"#b03060","rgb":{"r":176,"g":48,"b":96},"luminance":60.68725968438515},{"name":"Bloodhound","hex":"#bb5511","rgb":{"r":187,"g":85,"b":17},"luminance":74.96352738498902},{"name":"Bloodletter","hex":"#e97451","rgb":{"r":233,"g":116,"b":81},"luminance":97.85335001419217},{"name":"Bloodline","hex":"#882200","rgb":{"r":136,"g":34,"b":0},"luminance":45.29771142121862},{"name":"Bloodmyst Isle","hex":"#f02723","rgb":{"r":240,"g":39,"b":35},"luminance":75.42882173943856},{"name":"Bloodstain","hex":"#772200","rgb":{"r":119,"g":34,"b":0},"luminance":40.79619253067619},{"name":"Bloodstone","hex":"#413431","rgb":{"r":65,"g":52,"b":49},"luminance":36.61471284879891},{"name":"Bloodthirsty","hex":"#880011","rgb":{"r":136,"g":0,"b":17},"luminance":40.71015524411569},{"name":"Bloodtracker Brown","hex":"#703f00","rgb":{"r":112,"g":63,"b":0},"luminance":49.89028467547564},{"name":"Bloody Periphylla","hex":"#aa1144","rgb":{"r":170,"g":17,"b":68},"luminance":52.3771213890187},{"name":"Bloody Pico-8","hex":"#ff004d","rgb":{"r":255,"g":0,"b":77},"luminance":76.74863718008287},{"name":"Bloody Red","hex":"#ca1f1b","rgb":{"r":202,"g":31,"b":27},"luminance":63.15475672504803},{"name":"Bloody Rust","hex":"#da2c43","rgb":{"r":218,"g":44,"b":67},"luminance":70.527425530782},{"name":"Bloom","hex":"#ffaf75","rgb":{"r":255,"g":175,"b":117},"luminance":128.62203502510758},{"name":"Blooming Dahlia","hex":"#eb9687","rgb":{"r":235,"g":150,"b":135},"luminance":113.69619529694035},{"name":"Blossom","hex":"#fee9d8","rgb":{"r":254,"g":233,"b":216},"luminance":158.36806096243015},{"name":"Blossom Pink","hex":"#e6d5ce","rgb":{"r":230,"g":213,"b":206},"luminance":144.61522090361026},{"name":"Blossom Time","hex":"#e5d2c9","rgb":{"r":229,"g":210,"b":201},"luminance":142.85944888945917},{"name":"Blowout","hex":"#658499","rgb":{"r":101,"g":132,"b":153},"luminance":84.97042556678176},{"name":"Blue","hex":"#0000ff","rgb":{"r":0,"g":0,"b":255},"luminance":29.07},{"name":"Blue Accolade","hex":"#25415d","rgb":{"r":37,"g":65,"b":93},"luminance":41.116862696465546},{"name":"Blue Agave","hex":"#b1c6c7","rgb":{"r":177,"g":198,"b":199},"luminance":129.70729201166756},{"name":"Blue Alps","hex":"#89a3ae","rgb":{"r":137,"g":163,"b":174},"luminance":105.95417889823884},{"name":"Blue Android Base","hex":"#5a79ba","rgb":{"r":90,"g":121,"b":186},"luminance":78.85805250575238},{"name":"Blue Angels Yellow","hex":"#f8b800","rgb":{"r":248,"g":184,"b":0},"luminance":131.01239318476706},{"name":"Blue Angora","hex":"#a7cfcb","rgb":{"r":167,"g":207,"b":203},"luminance":133.39150547917208},{"name":"Blue Antarctic","hex":"#4b789b","rgb":{"r":75,"g":120,"b":155},"luminance":76.00594137960532},{"name":"Blue Arc","hex":"#0085a1","rgb":{"r":0,"g":133,"b":161},"luminance":80.19944112648167},{"name":"Blue Ash","hex":"#414654","rgb":{"r":65,"g":70,"b":84},"luminance":46.45220232669275},{"name":"Blue Ashes","hex":"#3b5f78","rgb":{"r":59,"g":95,"b":120},"luminance":60.067316454125034},{"name":"Blue Aster","hex":"#0077b3","rgb":{"r":0,"g":119,"b":179},"luminance":72.77256656872835},{"name":"Blue Astro","hex":"#50a7d9","rgb":{"r":80,"g":167,"b":217},"luminance":103.89331010705165},{"name":"Blue Atoll","hex":"#00b1d2","rgb":{"r":0,"g":177,"b":210},"luminance":106.6214134261969},{"name":"Blue Azure","hex":"#4682bf","rgb":{"r":70,"g":130,"b":191},"luminance":82.06941011119795},{"name":"Blue Ballad","hex":"#7498bd","rgb":{"r":116,"g":152,"b":189},"luminance":98.12304595761384},{"name":"Blue Ballerina","hex":"#b4c7db","rgb":{"r":180,"g":199,"b":219},"luminance":131.01591706735482},{"name":"Blue Ballet","hex":"#576b6b","rgb":{"r":87,"g":107,"b":107},"luminance":69.0683563869881},{"name":"Blue Bay","hex":"#619ad6","rgb":{"r":97,"g":154,"b":214},"luminance":98.0211060384446},{"name":"Blue Bayberry","hex":"#2d5360","rgb":{"r":45,"g":83,"b":96},"luminance":51.71599367700479},{"name":"Blue Bayou","hex":"#bec4d3","rgb":{"r":190,"g":196,"b":211},"luminance":130.54858758332088},{"name":"Blue Bayoux","hex":"#62777e","rgb":{"r":98,"g":119,"b":126},"luminance":77.09976205540455},{"name":"Blue Beads","hex":"#5a809e","rgb":{"r":90,"g":128,"b":158},"luminance":81.8168609762071},{"name":"Blue Beauty","hex":"#7498bf","rgb":{"r":116,"g":152,"b":191},"luminance":98.17336251753832},{"name":"Blue Beetle","hex":"#220099","rgb":{"r":34,"g":0,"b":153},"luminance":20.18838577004115},{"name":"Blue Bell","hex":"#93b4d7","rgb":{"r":147,"g":180,"b":215},"luminance":117.03265317423168},{"name":"Blue Beret","hex":"#40638e","rgb":{"r":64,"g":99,"b":142},"luminance":63.28790254859138},{"name":"Blue Bird Day","hex":"#237fac","rgb":{"r":35,"g":127,"b":172},"luminance":77.7916659417961},{"name":"Blue Black Crayfish","hex":"#52593b","rgb":{"r":82,"g":89,"b":59},"luminance":58.10079559696235},{"name":"Blue Blood","hex":"#6b7f81","rgb":{"r":107,"g":127,"b":129},"luminance":82.44617569056796},{"name":"Blue Blouse","hex":"#94a4b9","rgb":{"r":148,"g":164,"b":185},"luminance":108.03034494066934},{"name":"Blue Blue","hex":"#2242c7","rgb":{"r":34,"g":66,"b":199},"luminance":46.03199665450109},{"name":"Blue Blush","hex":"#d6dbd9","rgb":{"r":214,"g":219,"b":217},"luminance":145.71221859885327},{"name":"Blue Boater","hex":"#6181a3","rgb":{"r":97,"g":129,"b":163},"luminance":83.18916673461756},{"name":"Blue Bobbin","hex":"#52b4ca","rgb":{"r":82,"g":180,"b":202},"luminance":110.88488043011094},{"name":"Blue Bolt","hex":"#00b9fb","rgb":{"r":0,"g":185,"b":251},"luminance":112.30153614710709},{"name":"Blue Bonnet","hex":"#335599","rgb":{"r":51,"g":85,"b":153},"luminance":55.011511431699454},{"name":"Blue Booties","hex":"#c8ddee","rgb":{"r":200,"g":221,"b":238},"luminance":145.40041249253733},{"name":"Blue Bottle","hex":"#394e65","rgb":{"r":57,"g":78,"b":101},"luminance":50.19356374078254},{"name":"Blue Bouquet","hex":"#0033ee","rgb":{"r":0,"g":51,"b":238},"luminance":40.40259141441301},{"name":"Blue Bows","hex":"#a4c3d7","rgb":{"r":164,"g":195,"b":215},"luminance":126.91534824835016},{"name":"Blue Brocade","hex":"#70b8d0","rgb":{"r":112,"g":184,"b":208},"luminance":115.53974706567432},{"name":"Blue Buzz","hex":"#a1a2bd","rgb":{"r":161,"g":162,"b":189},"luminance":108.74034335516878},{"name":"Blue By You","hex":"#a0b7ba","rgb":{"r":160,"g":183,"b":186},"luminance":119.4886875691586},{"name":"Blue Calico","hex":"#a5cde1","rgb":{"r":165,"g":205,"b":225},"luminance":132.5608424460255},{"name":"Blue Calypso","hex":"#55a7b6","rgb":{"r":85,"g":167,"b":182},"luminance":103.37352934866837},{"name":"Blue Carpenter Bee","hex":"#9cd0e4","rgb":{"r":156,"g":208,"b":228},"luminance":133.2616974828101},{"name":"Blue Catch","hex":"#41788a","rgb":{"r":65,"g":120,"b":138},"luminance":74.74629521922809},{"name":"Blue Chalk","hex":"#94c0cc","rgb":{"r":148,"g":192,"b":204},"luminance":123.29344125297176},{"name":"Blue Charcoal","hex":"#262b2f","rgb":{"r":38,"g":43,"b":47},"luminance":28.19417118838573},{"name":"Blue Charm","hex":"#82c2db","rgb":{"r":130,"g":194,"b":219},"luminance":122.89172852556025},{"name":"Blue Chill","hex":"#408f90","rgb":{"r":64,"g":143,"b":144},"luminance":87.6456675084399},{"name":"Blue Chip","hex":"#1d5699","rgb":{"r":29,"g":86,"b":153},"luminance":54.109536396091954},{"name":"Blue Chrysocolla","hex":"#77b7d0","rgb":{"r":119,"g":183,"b":208},"luminance":115.6180684235816},{"name":"Blue Cloud","hex":"#627188","rgb":{"r":98,"g":113,"b":136},"luminance":74.15377792803277},{"name":"Blue Cola","hex":"#0088dc","rgb":{"r":0,"g":136,"b":220},"luminance":83.6788780039503},{"name":"Blue Collar Man","hex":"#005f7a","rgb":{"r":0,"g":95,"b":122},"luminance":57.47319104591287},{"name":"Blue Copper Ore","hex":"#4411dd","rgb":{"r":68,"g":17,"b":221},"luminance":33.87784380683045},{"name":"Blue Coral","hex":"#1b5366","rgb":{"r":27,"g":83,"b":102},"luminance":50.7357817915522},{"name":"Blue Crab Escape","hex":"#9ebdd6","rgb":{"r":158,"g":189,"b":214},"luminance":123.02569093079704},{"name":"Blue Cuddle","hex":"#7eb4d1","rgb":{"r":126,"g":180,"b":209},"luminance":114.67800204049598},{"name":"Blue Cue","hex":"#84a5dc","rgb":{"r":132,"g":165,"b":220},"luminance":107.55287280681998},{"name":"Blue Curacao","hex":"#32becc","rgb":{"r":50,"g":190,"b":204},"luminance":114.90554789043041},{"name":"Blue Dam","hex":"#a2c6d3","rgb":{"r":162,"g":198,"b":211},"luminance":128.19250304132453},{"name":"Blue Danube","hex":"#0087b6","rgb":{"r":0,"g":135,"b":182},"luminance":81.91611275567219},{"name":"Blue Darknut","hex":"#0078f8","rgb":{"r":0,"g":120,"b":248},"luminance":75.90190764401116},{"name":"Blue Dart","hex":"#518fd1","rgb":{"r":81,"g":143,"b":209},"luminance":90.55567192616925},{"name":"Blue Dart Frog","hex":"#3a7a9b","rgb":{"r":58,"g":122,"b":155},"luminance":75.77294279622508},{"name":"Blue Depression","hex":"#4428bc","rgb":{"r":68,"g":40,"b":188},"luminance":37.73633856112699},{"name":"Blue Depths","hex":"#263056","rgb":{"r":38,"g":48,"b":86},"luminance":31.923352518180167},{"name":"Blue Diamond","hex":"#4b2d72","rgb":{"r":75,"g":45,"b":114},"luminance":37.007146147737465},{"name":"Blue Dianne","hex":"#35514f","rgb":{"r":53,"g":81,"b":79},"luminance":50.9210433318093},{"name":"Blue Dolphin","hex":"#bcc5cf","rgb":{"r":188,"g":197,"b":207},"luminance":130.72502770701558},{"name":"Blue Dove","hex":"#76799e","rgb":{"r":118,"g":121,"b":158},"luminance":81.32703361736489},{"name":"Blue Dude","hex":"#4a5c94","rgb":{"r":74,"g":92,"b":148},"luminance":60.75077181402718},{"name":"Blue Earth","hex":"#375673","rgb":{"r":55,"g":86,"b":115},"luminance":54.68768096198631},{"name":"Blue Effervescence","hex":"#97d5ea","rgb":{"r":151,"g":213,"b":234},"luminance":135.58315580484177},{"name":"Blue Emerald","hex":"#0f5a5e","rgb":{"r":15,"g":90,"b":94},"luminance":54.09211385220585},{"name":"Blue Emulsion","hex":"#d1edef","rgb":{"r":209,"g":237,"b":239},"luminance":154.92438722809266},{"name":"Blue Estate","hex":"#384883","rgb":{"r":56,"g":72,"b":131},"luminance":47.85009496333314},{"name":"Blue et une Nuit","hex":"#0652ff","rgb":{"r":6,"g":82,"b":255},"luminance":56.25980174156322},{"name":"Blue Expanse","hex":"#253f74","rgb":{"r":37,"g":63,"b":116},"luminance":40.80267768174045},{"name":"Blue Exult","hex":"#2b2f43","rgb":{"r":43,"g":47,"b":67},"luminance":31.381434224713185},{"name":"Blue Eyed Boy","hex":"#87bde3","rgb":{"r":135,"g":189,"b":227},"luminance":120.86088431746641},{"name":"Blue Fantastic","hex":"#2c3b4d","rgb":{"r":44,"g":59,"b":77},"luminance":38.0733280525882},{"name":"Blue Fin","hex":"#577fae","rgb":{"r":87,"g":127,"b":174},"luminance":81.4106655543363},{"name":"Blue Fjord","hex":"#628daa","rgb":{"r":98,"g":141,"b":170},"luminance":89.91422519824101},{"name":"Blue Flag","hex":"#3b506f","rgb":{"r":59,"g":80,"b":111},"luminance":51.73557960436898},{"name":"Blue Flame","hex":"#005e88","rgb":{"r":0,"g":94,"b":136},"luminance":57.314794774124415},{"name":"Blue Flower","hex":"#d0d9d4","rgb":{"r":208,"g":217,"b":212},"luminance":143.796198590227},{"name":"Blue Fog","hex":"#9babbb","rgb":{"r":155,"g":171,"b":187},"luminance":112.59599583466544},{"name":"Blue Fox","hex":"#b9bcb6","rgb":{"r":185,"g":188,"b":182},"luminance":125.1745799473679},{"name":"Blue Frosting","hex":"#86d2c1","rgb":{"r":134,"g":210,"b":193},"luminance":131.47191814224055},{"name":"Blue Garter","hex":"#a2b8ce","rgb":{"r":162,"g":184,"b":206},"luminance":120.67918695450346},{"name":"Blue Gem","hex":"#4b3c8e","rgb":{"r":75,"g":60,"b":142},"luminance":44.78147350188468},{"name":"Blue Genie","hex":"#6666ff","rgb":{"r":102,"g":102,"b":255},"luminance":73.21262718957708},{"name":"Blue Glass","hex":"#c6e3e1","rgb":{"r":198,"g":227,"b":225},"luminance":148.04761161531786},{"name":"Blue Glaze","hex":"#56597c","rgb":{"r":86,"g":89,"b":124},"luminance":59.9196740728786},{"name":"Blue Glint","hex":"#92c6d7","rgb":{"r":146,"g":198,"b":215},"luminance":126.54996994073132},{"name":"Blue Glow","hex":"#b2d4dd","rgb":{"r":178,"g":212,"b":221},"luminance":137.67217604149357},{"name":"Blue Granite","hex":"#717388","rgb":{"r":113,"g":115,"b":136},"luminance":77.0640020372677},{"name":"Blue Graphite","hex":"#323137","rgb":{"r":50,"g":49,"b":55},"luminance":33.01704967134404},{"name":"Blue Grass","hex":"#007c7a","rgb":{"r":0,"g":124,"b":122},"luminance":74.10482715721021},{"name":"Blue Green","hex":"#137e6d","rgb":{"r":19,"g":126,"b":109},"luminance":75.21340758800919},{"name":"Blue Green Rules","hex":"#d8eeed","rgb":{"r":216,"g":238,"b":237},"luminance":156.26526106591956},{"name":"Blue Grey","hex":"#758da3","rgb":{"r":117,"g":141,"b":163},"luminance":91.75770976871644},{"name":"Blue Grotto","hex":"#5cacce","rgb":{"r":92,"g":172,"b":206},"luminance":107.24699350564565},{"name":"Blue Grouse","hex":"#9abcdc","rgb":{"r":154,"g":188,"b":220},"luminance":122.17891492397531},{"name":"Blue Haze","hex":"#bdbace","rgb":{"r":189,"g":186,"b":206},"luminance":125.16269612388508},{"name":"Blue Heath Butterfly","hex":"#5566ff","rgb":{"r":85,"g":102,"b":255},"luminance":71.24523142639092},{"name":"Blue Heather","hex":"#aebbc1","rgb":{"r":174,"g":187,"b":193},"luminance":123.45050036755622},{"name":"Blue Heaven","hex":"#5b7e98","rgb":{"r":91,"g":126,"b":152},"luminance":80.69056146167283},{"name":"Blue Heeler","hex":"#939cab","rgb":{"r":147,"g":156,"b":171},"luminance":103.42781748156537},{"name":"Blue Heist","hex":"#006384","rgb":{"r":0,"g":99,"b":132},"luminance":60.02968493170692},{"name":"Blue Hepatica","hex":"#6666ee","rgb":{"r":102,"g":102,"b":238},"luminance":72.46495224589609},{"name":"Blue Heron","hex":"#96a3c7","rgb":{"r":150,"g":163,"b":199},"luminance":108.07881779978906},{"name":"Blue Hijab","hex":"#d0eefb","rgb":{"r":208,"g":238,"b":251},"luminance":155.5775443179381},{"name":"Blue Horizon","hex":"#4e6482","rgb":{"r":78,"g":100,"b":130},"luminance":64.87864120032108},{"name":"Blue Horror","hex":"#a2bad2","rgb":{"r":162,"g":186,"b":210},"luminance":121.81983651277815},{"name":"Blue Hour","hex":"#0034ab","rgb":{"r":0,"g":52,"b":171},"luminance":36.21782174565444},{"name":"Blue Hue","hex":"#394d60","rgb":{"r":57,"g":77,"b":96},"luminance":49.529633412735855},{"name":"Blue Hyacinth","hex":"#8394c5","rgb":{"r":131,"g":148,"b":197},"luminance":97.90817994937909},{"name":"Blue Hydrangea","hex":"#bbc3dd","rgb":{"r":187,"g":195,"b":221},"luminance":129.85852852238853},{"name":"Blue Ice","hex":"#70789b","rgb":{"r":112,"g":120,"b":155},"luminance":79.9716740102394},{"name":"Blue Iguana","hex":"#539ccc","rgb":{"r":83,"g":156,"b":204},"luminance":97.68396085847459},{"name":"Blue Indigo","hex":"#49516d","rgb":{"r":73,"g":81,"b":109},"luminance":53.773047282072454},{"name":"Blue Insignia","hex":"#566977","rgb":{"r":86,"g":105,"b":119},"luminance":68.14777602387329},{"name":"Blue Intrigue","hex":"#7f809c","rgb":{"r":127,"g":128,"b":156},"luminance":86.04439482615936},{"name":"Blue Iris","hex":"#5a5b9f","rgb":{"r":90,"g":91,"b":159},"luminance":62.49860690447427},{"name":"Blue Jasmine","hex":"#828596","rgb":{"r":130,"g":133,"b":150},"luminance":88.87276264975675},{"name":"Blue Jay","hex":"#5588dd","rgb":{"r":85,"g":136,"b":221},"luminance":87.48604508720233},{"name":"Blue Jeans","hex":"#5dadec","rgb":{"r":93,"g":173,"b":236},"luminance":108.67225987343778},{"name":"Blue Jewel","hex":"#465383","rgb":{"r":70,"g":83,"b":131},"luminance":55.08924665485996},{"name":"Blue Kelp","hex":"#1d7881","rgb":{"r":29,"g":120,"b":129},"luminance":72.47928170863726},{"name":"Blue Lagoon","hex":"#00626f","rgb":{"r":0,"g":98,"b":111},"luminance":58.901310613601794},{"name":"Blue Lava","hex":"#2e5169","rgb":{"r":46,"g":81,"b":105},"luminance":50.9231835709434},{"name":"Blue League","hex":"#006284","rgb":{"r":0,"g":98,"b":132},"luminance":59.46160929541009},{"name":"Blue Lechery","hex":"#779ecb","rgb":{"r":119,"g":158,"b":203},"luminance":101.99696192044154},{"name":"Blue Light","hex":"#acdfdd","rgb":{"r":172,"g":223,"b":221},"luminance":142.87983979904232},{"name":"Blue Limewash","hex":"#7fcce2","rgb":{"r":127,"g":204,"b":226},"luminance":128.23929167380797},{"name":"Blue Linen","hex":"#5a5e6a","rgb":{"r":90,"g":94,"b":106},"luminance":62.56822548226855},{"name":"Blue Lips","hex":"#a6bce2","rgb":{"r":166,"g":188,"b":226},"luminance":123.71646773166455},{"name":"Blue Lobelia","hex":"#28314d","rgb":{"r":40,"g":49,"b":77},"luminance":32.36363782086309},{"name":"Blue Lobster","hex":"#0055aa","rgb":{"r":0,"g":85,"b":170},"luminance":53.52658615118285},{"name":"Blue Lullaby","hex":"#c8d7d2","rgb":{"r":200,"g":215,"b":210},"luminance":141.6928566477506},{"name":"Blue Lust","hex":"#012389","rgb":{"r":1,"g":35,"b":137},"luminance":25.809074954364405},{"name":"Blue Magenta","hex":"#5f34e7","rgb":{"r":95,"g":52,"b":231},"luminance":49.31569888990726},{"name":"Blue Magenta Violet","hex":"#553592","rgb":{"r":85,"g":53,"b":146},"luminance":43.483781827251406},{"name":"Blue Marble","hex":"#6594bc","rgb":{"r":101,"g":148,"b":188},"luminance":94.43913172514875},{"name":"Blue Marguerite","hex":"#6a5bb1","rgb":{"r":106,"g":91,"b":177},"luminance":65.30725234612156},{"name":"Blue Martina","hex":"#1fcecb","rgb":{"r":31,"g":206,"b":203},"luminance":123.46496105778351},{"name":"Blue Martini","hex":"#52b4d3","rgb":{"r":82,"g":180,"b":211},"luminance":111.10248800094442},{"name":"Blue Mediterranean","hex":"#1e7e9a","rgb":{"r":30,"g":126,"b":154},"luminance":76.54444120901269},{"name":"Blue Mercury","hex":"#67a6ac","rgb":{"r":103,"g":166,"b":172},"luminance":104.05706240808452},{"name":"Blue Metal","hex":"#5a6370","rgb":{"r":90,"g":99,"b":112},"luminance":65.30153668176577},{"name":"Blue Mirage","hex":"#5c6d7c","rgb":{"r":92,"g":109,"b":124},"luminance":71.06575018248945},{"name":"Blue Mist","hex":"#5bacc3","rgb":{"r":91,"g":172,"b":195},"luminance":106.90290864611681},{"name":"Blue Monday","hex":"#637983","rgb":{"r":99,"g":121,"b":131},"luminance":78.38417114443452},{"name":"Blue Mood","hex":"#7a808d","rgb":{"r":122,"g":128,"b":141},"luminance":85.0554904518221},{"name":"Blue Moon","hex":"#3686a0","rgb":{"r":54,"g":134,"b":160},"luminance":82.3436207608094},{"name":"Blue Mosque","hex":"#21426b","rgb":{"r":33,"g":66,"b":107},"luminance":41.79822313209019},{"name":"Blue Mountain","hex":"#759dbe","rgb":{"r":117,"g":157,"b":190},"luminance":100.92693976337536},{"name":"Blue Nebula","hex":"#1199ff","rgb":{"r":17,"g":153,"b":255},"luminance":94.5352712483547},{"name":"Blue Nights","hex":"#363b48","rgb":{"r":54,"g":59,"b":72},"luminance":39.08336307177262},{"name":"Blue Nile","hex":"#779fb9","rgb":{"r":119,"g":159,"b":185},"luminance":102.08743580872232},{"name":"Blue Nude","hex":"#29518c","rgb":{"r":41,"g":81,"b":140},"luminance":51.63062937830605},{"name":"Blue Oar","hex":"#647e9c","rgb":{"r":100,"g":126,"b":156},"luminance":81.73529286666806},{"name":"Blue Oasis","hex":"#296d93","rgb":{"r":41,"g":109,"b":147},"luminance":67.2676589008418},{"name":"Blue Oblivion","hex":"#26428b","rgb":{"r":38,"g":66,"b":139},"luminance":43.37203389282084},{"name":"Blue Odyssey","hex":"#4f6997","rgb":{"r":79,"g":105,"b":151},"luminance":68.21397702817217},{"name":"Blue Opal","hex":"#0f3b57","rgb":{"r":15,"g":59,"b":87},"luminance":36.303259330258484},{"name":"Blue Overdose","hex":"#0000ee","rgb":{"r":0,"g":0,"b":238},"luminance":27.132},{"name":"Blue Paisley","hex":"#2282a8","rgb":{"r":34,"g":130,"b":168},"luminance":79.33071763194884},{"name":"Blue Party Parrot","hex":"#8080ff","rgb":{"r":128,"g":128,"b":255},"luminance":89.19209258673102},{"name":"Blue Pearl","hex":"#c5d9e3","rgb":{"r":197,"g":217,"b":227},"luminance":142.70474390853303},{"name":"Blue Pencil","hex":"#2200ff","rgb":{"r":34,"g":0,"b":255},"luminance":30.79630588236193},{"name":"Blue Perennial","hex":"#bcd7df","rgb":{"r":188,"g":215,"b":223},"luminance":140.47693423832968},{"name":"Blue Phlox","hex":"#d2e6e8","rgb":{"r":210,"g":230,"b":232},"luminance":151.22757983912854},{"name":"Blue Planet","hex":"#545e6a","rgb":{"r":84,"g":94,"b":106},"luminance":61.817863081798606},{"name":"Blue Plate","hex":"#5b7a9c","rgb":{"r":91,"g":122,"b":156},"luminance":78.64582209501022},{"name":"Blue Plaza","hex":"#30363c","rgb":{"r":48,"g":54,"b":60},"luminance":35.46165123058992},{"name":"Blue Pointer","hex":"#95b9d6","rgb":{"r":149,"g":185,"b":214},"luminance":119.88674005910745},{"name":"Blue Potato","hex":"#64617b","rgb":{"r":100,"g":97,"b":123},"luminance":65.82306742320658},{"name":"Blue Prince","hex":"#6a808f","rgb":{"r":106,"g":128,"b":143},"luminance":83.16058763621142},{"name":"Blue Promise","hex":"#729cc2","rgb":{"r":114,"g":156,"b":194},"luminance":100.18185482411471},{"name":"Blue Purple","hex":"#5729ce","rgb":{"r":87,"g":41,"b":206},"luminance":42.513467442682206},{"name":"Blue Quarry","hex":"#43505e","rgb":{"r":67,"g":80,"b":94},"luminance":52.16699478597554},{"name":"Blue Racer","hex":"#4ba4a9","rgb":{"r":75,"g":164,"b":169},"luminance":100.70544774241361},{"name":"Blue Radiance","hex":"#58c9d4","rgb":{"r":88,"g":201,"b":212},"luminance":123.27751513151131},{"name":"Blue Ranger","hex":"#00177d","rgb":{"r":0,"g":23,"b":125},"luminance":19.630066250524983},{"name":"Blue Raspberry","hex":"#0cbfe9","rgb":{"r":12,"g":191,"b":233},"luminance":115.27634309345521},{"name":"Blue Regal","hex":"#303048","rgb":{"r":48,"g":48,"b":72},"luminance":32.6686109897559},{"name":"Blue Regatta","hex":"#376298","rgb":{"r":55,"g":98,"b":152},"luminance":62.289150620312675},{"name":"Blue Regent","hex":"#285991","rgb":{"r":40,"g":89,"b":145},"luminance":56.08576957660472},{"name":"Blue Review","hex":"#4e5878","rgb":{"r":78,"g":88,"b":120},"luminance":58.30437736568327},{"name":"Blue Rhapsody","hex":"#3d4655","rgb":{"r":61,"g":70,"b":85},"luminance":45.988534668980265},{"name":"Blue Ribbon","hex":"#0066ff","rgb":{"r":0,"g":102,"b":255},"luminance":66.55795050931181},{"name":"Blue Ribbon Beauty","hex":"#3e6490","rgb":{"r":62,"g":100,"b":144},"luminance":63.70896718673125},{"name":"Blue Rice","hex":"#b3d9f3","rgb":{"r":179,"g":217,"b":243},"luminance":140.91596036645387},{"name":"Blue Rinse","hex":"#b7bdc6","rgb":{"r":183,"g":189,"b":198},"luminance":125.74495823690108},{"name":"Blue Romance","hex":"#d8f0d2","rgb":{"r":216,"g":240,"b":210},"luminance":156.81642470098598},{"name":"Blue Royale","hex":"#29217a","rgb":{"r":41,"g":33,"b":122},"luminance":26.813265112626624},{"name":"Blue Sabre","hex":"#575f6a","rgb":{"r":87,"g":95,"b":106},"luminance":62.70912573142763},{"name":"Blue Sail","hex":"#24549a","rgb":{"r":36,"g":84,"b":154},"luminance":53.43552840573395},{"name":"Blue Sapphire","hex":"#126180","rgb":{"r":18,"g":97,"b":128},"luminance":59.024927861031735},{"name":"Blue Sari","hex":"#666a76","rgb":{"r":102,"g":106,"b":118},"luminance":70.58797058989583},{"name":"Blue Sash","hex":"#494d58","rgb":{"r":73,"g":77,"b":88},"luminance":51.186019126320026},{"name":"Blue Satin","hex":"#9eb6d0","rgb":{"r":158,"g":182,"b":208},"luminance":119.19550773414238},{"name":"Blue Shade Wash","hex":"#293f54","rgb":{"r":41,"g":63,"b":84},"luminance":40.11953661247846},{"name":"Blue Shadow","hex":"#66829a","rgb":{"r":102,"g":130,"b":154},"luminance":84.03307229894669},{"name":"Blue Shamrock","hex":"#bacbc4","rgb":{"r":186,"g":203,"b":196},"luminance":133.3848389173222},{"name":"Blue Shell","hex":"#9bb3bc","rgb":{"r":155,"g":179,"b":188},"luminance":116.82262185895331},{"name":"Blue Shimmer","hex":"#b3dae2","rgb":{"r":179,"g":218,"b":226},"luminance":141.08004214983777},{"name":"Blue Shutters","hex":"#93bde7","rgb":{"r":147,"g":189,"b":231},"luminance":122.20349837054583},{"name":"Blue Silk","hex":"#d0dce8","rgb":{"r":208,"g":220,"b":232},"luminance":145.75486670434026},{"name":"Blue Slate","hex":"#5a5f68","rgb":{"r":90,"g":95,"b":104},"luminance":63.04322375164518},{"name":"Blue Smart","hex":"#5786b4","rgb":{"r":87,"g":134,"b":180},"luminance":85.35120112218691},{"name":"Blue Smoke","hex":"#d7e0e2","rgb":{"r":215,"g":224,"b":226},"luminance":148.61170567959982},{"name":"Blue Sonki","hex":"#4a87cb","rgb":{"r":74,"g":135,"b":203},"luminance":85.46860280243266},{"name":"Blue Sou'wester","hex":"#404956","rgb":{"r":64,"g":73,"b":86},"luminance":47.942810858354974},{"name":"Blue Sparkle","hex":"#0077ff","rgb":{"r":0,"g":119,"b":255},"luminance":75.66046860150946},{"name":"Blue Spruce","hex":"#adc5c9","rgb":{"r":173,"g":197,"b":201},"luminance":128.73660025804625},{"name":"Blue Steel","hex":"#535a61","rgb":{"r":83,"g":90,"b":97},"luminance":59.406832544750266},{"name":"Blue Stone","hex":"#577284","rgb":{"r":87,"g":114,"b":132},"luminance":73.35623488838559},{"name":"Blue Streak","hex":"#2266bb","rgb":{"r":34,"g":102,"b":187},"luminance":64.36381402620574},{"name":"Blue Stream","hex":"#95cdd8","rgb":{"r":149,"g":205,"b":216},"luminance":130.65850604533944},{"name":"Blue Suede","hex":"#687b92","rgb":{"r":104,"g":123,"b":146},"luminance":80.35526338081407},{"name":"Blue Suede Shoes","hex":"#484b62","rgb":{"r":72,"g":75,"b":98},"luminance":50.26399300692296},{"name":"Blue Surf","hex":"#90a8a4","rgb":{"r":144,"g":168,"b":164},"luminance":109.21755814886176},{"name":"Blue Syzygy","hex":"#1b4556","rgb":{"r":27,"g":69,"b":86},"luminance":42.447435187535184},{"name":"Blue Tang","hex":"#2a4b6e","rgb":{"r":42,"g":75,"b":110},"luminance":47.467416076715196},{"name":"Blue Tapestry","hex":"#475c62","rgb":{"r":71,"g":92,"b":98},"luminance":59.09243641110087},{"name":"Blue Thistle","hex":"#adc0d6","rgb":{"r":173,"g":192,"b":214},"luminance":126.38448860916436},{"name":"Blue Tint","hex":"#9fd9d7","rgb":{"r":159,"g":217,"b":215},"luminance":138.15316290986607},{"name":"Blue Titmouse","hex":"#4466ff","rgb":{"r":68,"g":102,"b":255},"luminance":69.59418797572107},{"name":"Blue To You","hex":"#babfc5","rgb":{"r":186,"g":191,"b":197},"luminance":127.15148622410985},{"name":"Blue Tone Ink","hex":"#2b4057","rgb":{"r":43,"g":64,"b":87},"luminance":40.92705458495639},{"name":"Blue Topaz","hex":"#78bdd4","rgb":{"r":120,"g":189,"b":212},"luminance":119.07903204594837},{"name":"Blue Tourmaline","hex":"#4997d0","rgb":{"r":73,"g":151,"b":208},"luminance":94.3143395354068},{"name":"Blue Trust","hex":"#120a8f","rgb":{"r":18,"g":10,"b":143},"luminance":18.143263984189833},{"name":"Blue Tulip","hex":"#5c4671","rgb":{"r":92,"g":70,"b":113},"luminance":51.098180867815636},{"name":"Blue Tuna","hex":"#6f95c1","rgb":{"r":111,"g":149,"b":193},"luminance":96.100853763117},{"name":"Blue Turquoise","hex":"#53b0ae","rgb":{"r":83,"g":176,"b":174},"luminance":108.0866306672569},{"name":"Blue Vacation","hex":"#1e7eae","rgb":{"r":30,"g":126,"b":174},"luminance":77.09932061957484},{"name":"Blue Vault","hex":"#4e83bd","rgb":{"r":78,"g":131,"b":189},"luminance":83.19431716770082},{"name":"Blue Veil","hex":"#aecbe5","rgb":{"r":174,"g":203,"b":229},"luminance":132.61814292546853},{"name":"Blue Velvet","hex":"#0d6183","rgb":{"r":13,"g":97,"b":131},"luminance":58.9930745596464},{"name":"Blue Venus","hex":"#397c80","rgb":{"r":57,"g":124,"b":128},"luminance":76.16746849541475},{"name":"Blue Violet","hex":"#324ab2","rgb":{"r":50,"g":74,"b":178},"luminance":50.22078860392377},{"name":"Blue Whale","hex":"#1e3442","rgb":{"r":30,"g":52,"b":66},"luminance":32.69229346497428},{"name":"Blue Willow","hex":"#a8bbba","rgb":{"r":168,"g":187,"b":186},"luminance":122.56466375346525},{"name":"Blue Wing Teal","hex":"#2c4053","rgb":{"r":44,"g":64,"b":83},"luminance":40.91411008441953},{"name":"Blue With A Hint Of Purple","hex":"#533cc6","rgb":{"r":83,"g":60,"b":198},"luminance":48.639768430781},{"name":"Blue Yonder","hex":"#5a77a8","rgb":{"r":90,"g":119,"b":168},"luminance":77.26829112255557},{"name":"Blue Zephyr","hex":"#5b6676","rgb":{"r":91,"g":102,"b":118},"luminance":67.12810038277561},{"name":"Blue Zodiac","hex":"#3c4354","rgb":{"r":60,"g":67,"b":84},"luminance":44.275429043658065},{"name":"Blue-Eyed Boy","hex":"#2277cc","rgb":{"r":34,"g":119,"b":204},"luminance":74.32113226397993},{"name":"Bluealicious","hex":"#0000dd","rgb":{"r":0,"g":0,"b":221},"luminance":25.194000000000003},{"name":"Bluebeard","hex":"#abb5c4","rgb":{"r":171,"g":181,"b":196},"luminance":120.00772469303799},{"name":"Bluebell","hex":"#333399","rgb":{"r":51,"g":51,"b":153},"luminance":37.85471349779311},{"name":"Bluebell Frost","hex":"#9999cc","rgb":{"r":153,"g":153,"b":204},"luminance":103.43908964216574},{"name":"Blueberry","hex":"#464196","rgb":{"r":70,"g":65,"b":150},"luminance":46.75766167164479},{"name":"Blueberry Blush","hex":"#836268","rgb":{"r":131,"g":98,"b":104},"luminance":70.59756350611542},{"name":"Blueberry Glaze","hex":"#cc66dd","rgb":{"r":204,"g":102,"b":221},"luminance":89.10749423028345},{"name":"Blueberry Muffin","hex":"#5588ab","rgb":{"r":85,"g":136,"b":171},"luminance":86.01794280846293},{"name":"Blueberry Patch","hex":"#627099","rgb":{"r":98,"g":112,"b":153},"luminance":74.06148866988835},{"name":"Blueberry Pie","hex":"#314d67","rgb":{"r":49,"g":77,"b":103},"luminance":48.94359984717103},{"name":"Blueberry Popover","hex":"#5488c0","rgb":{"r":84,"g":136,"b":192},"luminance":86.50460232843105},{"name":"Blueberry Soda","hex":"#8290a6","rgb":{"r":130,"g":144,"b":166},"luminance":94.94196890732779},{"name":"Bluebird","hex":"#009dae","rgb":{"r":0,"g":157,"b":174},"luminance":94.26955063539869},{"name":"Bluebird's Belly","hex":"#7395b8","rgb":{"r":115,"g":149,"b":184},"luminance":96.29172949947467},{"name":"Bluebonnet","hex":"#1c1cf0","rgb":{"r":28,"g":28,"b":240},"luminance":32.997001075855366},{"name":"Bluebonnet Frost","hex":"#4d6eb0","rgb":{"r":77,"g":110,"b":176},"luminance":71.42763838319169},{"name":"Bluebottle","hex":"#8ecfe8","rgb":{"r":142,"g":207,"b":232},"luminance":131.40249445501405},{"name":"Bluebound","hex":"#4f9297","rgb":{"r":79,"g":146,"b":151},"luminance":90.54891628837973},{"name":"Bluejay","hex":"#157ea0","rgb":{"r":21,"g":126,"b":160},"luminance":76.43625373472983},{"name":"Blueprint","hex":"#35637c","rgb":{"r":53,"g":99,"b":124},"luminance":61.8714366569906},{"name":"Blues","hex":"#296a9d","rgb":{"r":41,"g":106,"b":157},"luminance":65.89536227231775},{"name":"Blues White Shoes","hex":"#99badd","rgb":{"r":153,"g":186,"b":221},"luminance":121.0298920473781},{"name":"Bluewash","hex":"#e2e6e0","rgb":{"r":226,"g":230,"b":224},"luminance":153.12097463117195},{"name":"Bluey","hex":"#375978","rgb":{"r":55,"g":89,"b":120},"luminance":56.45273663871398},{"name":"Bluff Stone","hex":"#d2bd9e","rgb":{"r":210,"g":189,"b":158},"luminance":128.74535134520391},{"name":"Bluish","hex":"#2976bb","rgb":{"r":41,"g":118,"b":187},"luminance":73.50182964389388},{"name":"Bluish Black","hex":"#413f44","rgb":{"r":65,"g":63,"b":68},"luminance":42.490082254568534},{"name":"Bluish Green","hex":"#10a674","rgb":{"r":16,"g":166,"b":116},"luminance":98.45153221763488},{"name":"Bluish Grey","hex":"#748b97","rgb":{"r":116,"g":139,"b":151},"luminance":90.31455752535135},{"name":"Bluish Lilac Purple","hex":"#d0d5d3","rgb":{"r":208,"g":213,"b":211},"luminance":141.70106118515838},{"name":"Bluish Purple","hex":"#703be7","rgb":{"r":112,"g":59,"b":231},"luminance":54.903282133220415},{"name":"Bluish Purple Anemone","hex":"#6666bb","rgb":{"r":102,"g":102,"b":187},"luminance":70.49454591668777},{"name":"Bluish Water","hex":"#89cfdb","rgb":{"r":137,"g":207,"b":219},"luminance":130.63577460251844},{"name":"Blumine","hex":"#305c71","rgb":{"r":48,"g":92,"b":113},"luminance":57.34420497312697},{"name":"Blunt","hex":"#b5bbc7","rgb":{"r":181,"g":187,"b":199},"luminance":124.46989241579668},{"name":"Blurple","hex":"#5539cc","rgb":{"r":85,"g":57,"b":204},"luminance":48.02362379079696},{"name":"Blush","hex":"#f29e8e","rgb":{"r":242,"g":158,"b":142},"luminance":118.74153453615125},{"name":"Blush Beige","hex":"#edd5c7","rgb":{"r":237,"g":213,"b":199},"luminance":145.49560242838956},{"name":"Blush Bomb","hex":"#dd99aa","rgb":{"r":221,"g":153,"b":170},"luminance":113.1725866188451},{"name":"Blush d'Amour","hex":"#de5d83","rgb":{"r":222,"g":93,"b":131},"luminance":87.2309607937457},{"name":"Blush Essence","hex":"#cc88dd","rgb":{"r":204,"g":136,"b":221},"luminance":103.57797968680407},{"name":"Blush Mint","hex":"#d9e6e0","rgb":{"r":217,"g":230,"b":224},"luminance":151.95259486102896},{"name":"Blush Pink","hex":"#ff6fff","rgb":{"r":255,"g":111,"b":255},"luminance":104.42126016286146},{"name":"Blush Sand","hex":"#e2e0d8","rgb":{"r":226,"g":224,"b":216},"luminance":149.8722155571205},{"name":"Blush Sky","hex":"#dee1ed","rgb":{"r":222,"g":225,"b":237},"luminance":150.26582057474013},{"name":"Blush Tint","hex":"#f4e1e6","rgb":{"r":244,"g":225,"b":230},"luminance":153.14657019012864},{"name":"Blushed Bombshell","hex":"#ee88cc","rgb":{"r":238,"g":136,"b":204},"luminance":109.44414102180161},{"name":"Blushed Velvet","hex":"#dec5d3","rgb":{"r":222,"g":197,"b":211},"luminance":135.48805158020392},{"name":"Blushing Bride","hex":"#eedad1","rgb":{"r":238,"g":218,"b":209},"luminance":148.3475839911119},{"name":"Blushing Bud","hex":"#dd9999","rgb":{"r":221,"g":153,"b":153},"luminance":112.85687097381354},{"name":"Blushing Cherub","hex":"#ffcdaf","rgb":{"r":255,"g":205,"b":175},"luminance":143.84649717667787},{"name":"Blushing Peach","hex":"#ffd79f","rgb":{"r":255,"g":215,"b":159},"luminance":148.55825095227797},{"name":"Blushing Senorita","hex":"#f3cacb","rgb":{"r":243,"g":202,"b":203},"luminance":140.97654162661246},{"name":"Blushing Tulip","hex":"#e3a1b8","rgb":{"r":227,"g":161,"b":184},"luminance":118.22990211448202},{"name":"Bluster Blue","hex":"#4a5a6f","rgb":{"r":74,"g":90,"b":111},"luminance":58.65741634269276},{"name":"Blustery Day","hex":"#d6dfe7","rgb":{"r":214,"g":223,"b":231},"luminance":148.0633633043637},{"name":"Blustery Wind","hex":"#b6c5c1","rgb":{"r":182,"g":197,"b":193},"luminance":129.68340313625333},{"name":"Boa","hex":"#8e855f","rgb":{"r":142,"g":133,"b":95},"luminance":89.52682114874848},{"name":"Boat Anchor","hex":"#6c6b6a","rgb":{"r":108,"g":107,"b":106},"luminance":71.65030914797228},{"name":"Boat Blue","hex":"#2d5384","rgb":{"r":45,"g":83,"b":132},"luminance":52.737227553218986},{"name":"Boat Orchid","hex":"#c0448f","rgb":{"r":192,"g":68,"b":143},"luminance":71.79638378080055},{"name":"Boathouse","hex":"#577190","rgb":{"r":87,"g":113,"b":144},"luminance":73.11609115646158},{"name":"Boating Green","hex":"#087170","rgb":{"r":8,"g":113,"b":112},"luminance":67.59101307866305},{"name":"Boatswain","hex":"#243256","rgb":{"r":36,"g":50,"b":86},"luminance":32.762854149173265},{"name":"Bobby Blue","hex":"#97c5da","rgb":{"r":151,"g":197,"b":218},"luminance":126.60344555342874},{"name":"Bobcat Whiskers","hex":"#eadfd0","rgb":{"r":234,"g":223,"b":208},"luminance":150.30825626358651},{"name":"Bock","hex":"#5d341a","rgb":{"r":93,"g":52,"b":26},"luminance":41.397211512371214},{"name":"Bockwurst","hex":"#df8f67","rgb":{"r":223,"g":143,"b":103},"luminance":107.84149653078816},{"name":"Bodacious","hex":"#b76ba3","rgb":{"r":183,"g":107,"b":163},"luminance":85.34759102634357},{"name":"Bodega Bay","hex":"#5e81c1","rgb":{"r":94,"g":129,"b":193},"luminance":83.71384574250547},{"name":"Bodhi Tree","hex":"#b09870","rgb":{"r":176,"g":152,"b":112},"luminance":104.3706346440415},{"name":"Boeing Blue","hex":"#3d4652","rgb":{"r":61,"g":70,"b":82},"luminance":45.91769076292927},{"name":"Boerewors","hex":"#973443","rgb":{"r":151,"g":52,"b":67},"luminance":55.03168015788724},{"name":"Bog","hex":"#bab696","rgb":{"r":186,"g":182,"b":150},"luminance":121.65044410934141},{"name":"Bogart","hex":"#8b8274","rgb":{"r":139,"g":130,"b":116},"luminance":87.89429445077764},{"name":"Bogey Green","hex":"#116f26","rgb":{"r":17,"g":111,"b":38},"luminance":65.49837984255794},{"name":"Bogong Moth","hex":"#663b3a","rgb":{"r":102,"g":59,"b":58},"luminance":46.61857180352053},{"name":"Bohemian Blue","hex":"#0000aa","rgb":{"r":0,"g":0,"b":170},"luminance":19.38},{"name":"Bohemian Jazz","hex":"#9d777c","rgb":{"r":157,"g":119,"b":124},"luminance":85.33998684087078},{"name":"Boiling Magma","hex":"#ff3300","rgb":{"r":255,"g":51,"b":0},"luminance":81.91168411160888},{"name":"Boiling Mud","hex":"#a59c9b","rgb":{"r":165,"g":156,"b":155},"luminance":105.50640885273272},{"name":"Boiling Point","hex":"#d7e9e8","rgb":{"r":215,"g":233,"b":232},"luminance":153.42217691715888},{"name":"Bok Choy","hex":"#bccab3","rgb":{"r":188,"g":202,"b":179},"luminance":132.8005544265535},{"name":"Bokara Grey","hex":"#2a2725","rgb":{"r":42,"g":39,"b":37},"luminance":26.449656651835763},{"name":"Bold Brandy","hex":"#796660","rgb":{"r":121,"g":102,"b":96},"luminance":70.80668791152429},{"name":"Bold Eagle","hex":"#463d2f","rgb":{"r":70,"g":61,"b":47},"luminance":41.8200228718254},{"name":"Bold Irish","hex":"#2a814d","rgb":{"r":42,"g":129,"b":77},"luminance":77.25755223277527},{"name":"Bold Sangria","hex":"#7a4549","rgb":{"r":122,"g":69,"b":73},"luminance":55.1397604002774},{"name":"Bole","hex":"#79443b","rgb":{"r":121,"g":68,"b":59},"luminance":54.29038748250006},{"name":"Bologna Sausage","hex":"#ffcfdc","rgb":{"r":255,"g":207,"b":220},"luminance":145.62535323905652},{"name":"Bolognese","hex":"#bb4400","rgb":{"r":187,"g":68,"b":0},"luminance":68.69898561842089},{"name":"Bolt from the Blue","hex":"#2277ff","rgb":{"r":34,"g":119,"b":255},"luminance":76.34038292411167},{"name":"Boltgun Metal","hex":"#393939","rgb":{"r":57,"g":57,"b":57},"luminance":38.107644036334754},{"name":"Bombay","hex":"#aeaead","rgb":{"r":174,"g":174,"b":173},"luminance":116.3092128939062},{"name":"Bombay Brown","hex":"#9f5130","rgb":{"r":159,"g":81,"b":48},"luminance":67.45966701667004},{"name":"Bombay Pink","hex":"#c9736a","rgb":{"r":201,"g":115,"b":106},"luminance":91.1857328862361},{"name":"Bona Fide","hex":"#304471","rgb":{"r":48,"g":68,"b":113},"luminance":44.330721672447424},{"name":"Bonanza","hex":"#523b2c","rgb":{"r":82,"g":59,"b":44},"luminance":42.728646936218325},{"name":"Bondi","hex":"#16698c","rgb":{"r":22,"g":105,"b":140},"luminance":64.00675674489374},{"name":"Bondi Blue","hex":"#0095b6","rgb":{"r":0,"g":149,"b":182},"luminance":89.89024348059137},{"name":"Bone","hex":"#e0d7c6","rgb":{"r":224,"g":215,"b":198},"luminance":144.6477852751296},{"name":"Bone Brown","hex":"#9d7446","rgb":{"r":157,"g":116,"b":70},"luminance":83.08938628368848},{"name":"Bone China","hex":"#f3edde","rgb":{"r":243,"g":237,"b":222},"luminance":158.97682432983746},{"name":"Bone Dust","hex":"#e7ece6","rgb":{"r":231,"g":236,"b":230},"luminance":157.0004146013634},{"name":"Bone Trace","hex":"#d7d0c0","rgb":{"r":215,"g":208,"b":192},"luminance":139.71069746086016},{"name":"Bone White","hex":"#f1e1b0","rgb":{"r":241,"g":225,"b":176},"luminance":151.78560274940438},{"name":"Boneyard","hex":"#bb9977","rgb":{"r":187,"g":153,"b":119},"luminance":106.65981270375454},{"name":"Bonfire","hex":"#f78058","rgb":{"r":247,"g":128,"b":88},"luminance":105.83158852157516},{"name":"Bonfire Flame","hex":"#ce4e35","rgb":{"r":206,"g":78,"b":53},"luminance":76.98496214196639},{"name":"Bongo Drum","hex":"#d2c2b2","rgb":{"r":210,"g":194,"b":178},"luminance":131.61515204565163},{"name":"Bongo Skin","hex":"#dece96","rgb":{"r":222,"g":206,"b":150},"luminance":138.99848548815197},{"name":"Bonjour","hex":"#dfd7d2","rgb":{"r":223,"g":215,"b":210},"luminance":144.72956834731457},{"name":"Bonnie Blue","hex":"#8dbbd1","rgb":{"r":141,"g":187,"b":209},"luminance":119.97621813509542},{"name":"Bonnie Dune Beach","hex":"#e4d1bc","rgb":{"r":228,"g":209,"b":188},"luminance":141.97841630684573},{"name":"Bonnie's Bench","hex":"#7c644a","rgb":{"r":124,"g":100,"b":74},"luminance":69.93915835924821},{"name":"Bonny Belle","hex":"#c58eab","rgb":{"r":197,"g":142,"b":171},"luminance":103.91086931115532},{"name":"Bonsai","hex":"#787b54","rgb":{"r":120,"g":123,"b":84},"luminance":81.19149325514341},{"name":"Bonsai Garden","hex":"#9e9e7c","rgb":{"r":158,"g":158,"b":124},"luminance":105.0402474102189},{"name":"Bonus Level","hex":"#ffa00a","rgb":{"r":255,"g":160,"b":10},"luminance":120.97754347398528},{"name":"Bonza Green","hex":"#5e6b44","rgb":{"r":94,"g":107,"b":68},"luminance":69.24601953181136},{"name":"Booger","hex":"#9bb53c","rgb":{"r":155,"g":181,"b":60},"luminance":116.11662083440079},{"name":"Booger Buster","hex":"#00ff77","rgb":{"r":0,"g":255,"b":119},"luminance":150.29848828581078},{"name":"Boogie Blast","hex":"#119944","rgb":{"r":17,"g":153,"b":68},"luminance":90.28812831153384},{"name":"Bookworm","hex":"#ebe3de","rgb":{"r":235,"g":227,"b":222},"luminance":152.7513047080122},{"name":"Boot Hill Ghost","hex":"#ddaf8e","rgb":{"r":221,"g":175,"b":142},"luminance":123.21084047274411},{"name":"Bootstrap Leather","hex":"#793721","rgb":{"r":121,"g":55,"b":33},"luminance":48.635315461092674},{"name":"Booty Bay","hex":"#7fc6be","rgb":{"r":127,"g":198,"b":190},"luminance":124.17563128488617},{"name":"Borage","hex":"#507ea4","rgb":{"r":80,"g":126,"b":164},"luminance":79.95051131793967},{"name":"Borage Blue","hex":"#5566cc","rgb":{"r":85,"g":102,"b":204},"luminance":69.07720055850555},{"name":"Bordeaux","hex":"#7b002c","rgb":{"r":123,"g":0,"b":44},"luminance":37.117488937157376},{"name":"Bordeaux Hint","hex":"#efbcde","rgb":{"r":239,"g":188,"b":222},"luminance":133.88657931622572},{"name":"Bored Accent Green","hex":"#dedd98","rgb":{"r":222,"g":221,"b":152},"luminance":146.74942247586532},{"name":"Boredom","hex":"#8c9c9c","rgb":{"r":140,"g":156,"b":156},"luminance":102.24461570175711},{"name":"Borg Drone","hex":"#06470c","rgb":{"r":6,"g":71,"b":12},"luminance":41.738018508309665},{"name":"Borg Queen","hex":"#054907","rgb":{"r":5,"g":73,"b":7},"luminance":42.88449638272554},{"name":"Boring Green","hex":"#63b365","rgb":{"r":99,"g":179,"b":101},"luminance":109.76851427435828},{"name":"Borscht","hex":"#8c2c24","rgb":{"r":140,"g":44,"b":36},"luminance":49.35775521637911},{"name":"Bosco Blue","hex":"#76a0af","rgb":{"r":118,"g":160,"b":175},"luminance":102.2926606555915},{"name":"Boson Brown","hex":"#552c1c","rgb":{"r":85,"g":44,"b":28},"luminance":36.37577041108545},{"name":"Bōsōzoku Pink","hex":"#e7dbe1","rgb":{"r":231,"g":219,"b":225},"luminance":148.16991283658098},{"name":"Bosphorus","hex":"#007558","rgb":{"r":0,"g":117,"b":88},"luminance":69.40782423473595},{"name":"Bossa Nova","hex":"#4c3d4e","rgb":{"r":76,"g":61,"b":78},"luminance":43.33115610043193},{"name":"Bossa Nova Blue","hex":"#767c9e","rgb":{"r":118,"g":124,"b":158},"luminance":82.86944317418815},{"name":"Boston Blue","hex":"#438eac","rgb":{"r":67,"g":142,"b":172},"luminance":87.94136722271266},{"name":"Boston University Red","hex":"#cc0000","rgb":{"r":204,"g":0,"b":0},"luminance":60.995999999999995},{"name":"Bōtan","hex":"#a2345c","rgb":{"r":162,"g":52,"b":92},"luminance":58.20612136193237},{"name":"Botanical Garden","hex":"#5e624a","rgb":{"r":94,"g":98,"b":74},"luminance":64.57827814366065},{"name":"Botanical Night","hex":"#12403c","rgb":{"r":18,"g":64,"b":60},"luminance":38.563015286670726},{"name":"Botticelli","hex":"#92acb4","rgb":{"r":146,"g":172,"b":180},"luminance":111.89491235976728},{"name":"Bottle Green","hex":"#006a4e","rgb":{"r":0,"g":106,"b":78},"luminance":62.854156171250914},{"name":"Bottlebrush Blossom","hex":"#e8edb0","rgb":{"r":232,"g":237,"b":176},"luminance":156.7436750908948},{"name":"Boudin","hex":"#dab27d","rgb":{"r":218,"g":178,"b":125},"luminance":123.9720929080412},{"name":"Boudoir Blue","hex":"#7ea3d2","rgb":{"r":126,"g":163,"b":210},"luminance":105.58081093172187},{"name":"Bougainvillea","hex":"#9884b9","rgb":{"r":152,"g":132,"b":185},"luminance":92.27176740477012},{"name":"Boulder","hex":"#7c817c","rgb":{"r":124,"g":129,"b":124},"luminance":85.48935021977883},{"name":"Boundless","hex":"#5b6d84","rgb":{"r":91,"g":109,"b":132},"luminance":71.13786807319994},{"name":"Bouquet","hex":"#a78199","rgb":{"r":167,"g":129,"b":153},"luminance":92.36612248005217},{"name":"Bourbon","hex":"#af6c3e","rgb":{"r":175,"g":108,"b":62},"luminance":82.50403059851075},{"name":"Bourbon Spice","hex":"#e6be8a","rgb":{"r":230,"g":190,"b":138},"luminance":131.9687448754439},{"name":"Bourbon Truffle","hex":"#6c5654","rgb":{"r":108,"g":86,"b":84},"luminance":60.6869455814016},{"name":"Bourgeois","hex":"#ee0066","rgb":{"r":238,"g":0,"b":102},"luminance":72.10576001957125},{"name":"Boutique Beige","hex":"#e1cead","rgb":{"r":225,"g":206,"b":173},"luminance":139.77486538358747},{"name":"Bow Tie","hex":"#be2633","rgb":{"r":190,"g":38,"b":51},"luminance":61.308533924731876},{"name":"Bowerbird Blue","hex":"#006585","rgb":{"r":0,"g":101,"b":133},"luminance":61.19505382790344},{"name":"Bowling Green","hex":"#bfdeaf","rgb":{"r":191,"g":222,"b":175},"luminance":143.67038308920874},{"name":"Bowser Shell","hex":"#536b1f","rgb":{"r":83,"g":107,"b":31},"luminance":67.62649721817625},{"name":"Boxcar","hex":"#873d30","rgb":{"r":135,"g":61,"b":48},"luminance":54.23483435947785},{"name":"Boxwood","hex":"#707b71","rgb":{"r":112,"g":123,"b":113},"luminance":80.62491221080491},{"name":"Boy Red","hex":"#0e9ca5","rgb":{"r":14,"g":156,"b":165},"luminance":93.57761420339801},{"name":"Boycott","hex":"#635c53","rgb":{"r":99,"g":92,"b":83},"luminance":62.307147752083786},{"name":"Boynton Canyon","hex":"#9f4e3e","rgb":{"r":159,"g":78,"b":62},"luminance":66.38118032243777},{"name":"Boysenberry","hex":"#873260","rgb":{"r":135,"g":50,"b":96},"luminance":51.093315228119614},{"name":"Boysenberry Shadow","hex":"#f1f3f9","rgb":{"r":241,"g":243,"b":249},"luminance":162.3105645298543},{"name":"Boyzone","hex":"#2a96d5","rgb":{"r":42,"g":150,"b":213},"luminance":92.19610288943888},{"name":"Bracing Blue","hex":"#014182","rgb":{"r":1,"g":65,"b":130},"luminance":40.93318734230209},{"name":"Bracken","hex":"#5b3d27","rgb":{"r":91,"g":61,"b":39},"luminance":45.19112574388914},{"name":"Bracken Fern","hex":"#31453b","rgb":{"r":49,"g":69,"b":59},"luminance":43.59339268742455},{"name":"Bracken Green","hex":"#626f5d","rgb":{"r":98,"g":111,"b":93},"luminance":72.22495591552826},{"name":"Braid","hex":"#77675b","rgb":{"r":119,"g":103,"b":91},"luminance":70.91657040494837},{"name":"Braided Raffia","hex":"#e1d0af","rgb":{"r":225,"g":208,"b":175},"luminance":140.8238663756964},{"name":"Brain Freeze","hex":"#00eeff","rgb":{"r":0,"g":238,"b":255},"luminance":142.69839289914935},{"name":"Brain Pink","hex":"#f2aeb1","rgb":{"r":242,"g":174,"b":177},"luminance":126.78723473599383},{"name":"Brainstem Grey","hex":"#b5b5b5","rgb":{"r":181,"g":181,"b":181},"luminance":121.00848369432616},{"name":"Brainstorm","hex":"#d1d3c0","rgb":{"r":209,"g":211,"b":192},"luminance":140.44488625079947},{"name":"Brake Light Trails","hex":"#ee0033","rgb":{"r":238,"g":0,"b":51},"luminance":71.3991095182566},{"name":"Bramble Jam","hex":"#c71581","rgb":{"r":199,"g":21,"b":129},"luminance":62.51872012445552},{"name":"Bran","hex":"#a66e4a","rgb":{"r":166,"g":110,"b":74},"luminance":81.87786606891999},{"name":"Brandeis Blue","hex":"#0070ff","rgb":{"r":0,"g":112,"b":255},"luminance":71.8842015744767},{"name":"Brandied Apricot","hex":"#ca848a","rgb":{"r":202,"g":132,"b":138},"luminance":99.49464550416769},{"name":"Brandied Melon","hex":"#ce7b5b","rgb":{"r":206,"g":123,"b":91},"luminance":95.46949833847458},{"name":"Brandied Pears","hex":"#eae2d1","rgb":{"r":234,"g":226,"b":209},"luminance":151.8621930435617},{"name":"Brandy","hex":"#dcb68a","rgb":{"r":220,"g":182,"b":138},"luminance":126.44369410927537},{"name":"Brandy Alexander","hex":"#f3e2dc","rgb":{"r":243,"g":226,"b":220},"luminance":153.32074971444666},{"name":"Brandy Brown","hex":"#73362a","rgb":{"r":115,"g":54,"b":42},"luminance":47.01081123528927},{"name":"Brandy Punch","hex":"#c07c40","rgb":{"r":192,"g":124,"b":64},"luminance":92.98926295008471},{"name":"Brandy Rose","hex":"#b6857a","rgb":{"r":182,"g":133,"b":122},"luminance":96.17604810450467},{"name":"Brandy Snaps","hex":"#b58e8b","rgb":{"r":181,"g":142,"b":139},"luminance":100.63722568215003},{"name":"Brandywine","hex":"#490206","rgb":{"r":73,"g":2,"b":6},"luminance":21.869249209792272},{"name":"Brandywine Raspberry","hex":"#5555aa","rgb":{"r":85,"g":85,"b":170},"luminance":59.253840803782495},{"name":"Brandywine Spritz","hex":"#e69dad","rgb":{"r":230,"g":157,"b":173},"luminance":116.66855388235511},{"name":"Brass","hex":"#b5a642","rgb":{"r":181,"g":166,"b":66},"luminance":111.71580058792041},{"name":"Brass Balls","hex":"#e7bd42","rgb":{"r":231,"g":189,"b":66},"luminance":130.9025843365974},{"name":"Brass Buttons","hex":"#dfac4c","rgb":{"r":223,"g":172,"b":76},"luminance":121.3038190701348},{"name":"Brass Mesh","hex":"#e1a84b","rgb":{"r":225,"g":168,"b":75},"luminance":119.68351424068396},{"name":"Brass Scorpion","hex":"#773b2e","rgb":{"r":119,"g":59,"b":46},"luminance":49.92946811252849},{"name":"Brass Trumpet","hex":"#ecae58","rgb":{"r":236,"g":174,"b":88},"luminance":124.54754178224474},{"name":"Brassed Off","hex":"#cfa743","rgb":{"r":207,"g":167,"b":67},"luminance":116.18419571525207},{"name":"Brassica","hex":"#788879","rgb":{"r":120,"g":136,"b":121},"luminance":88.6047236889772},{"name":"Brasso","hex":"#f3bc6b","rgb":{"r":243,"g":188,"b":107},"luminance":132.6886490586139},{"name":"Brassy","hex":"#d5ab2c","rgb":{"r":213,"g":171,"b":44},"luminance":118.98208417236604},{"name":"Brassy Brass","hex":"#776022","rgb":{"r":119,"g":96,"b":34},"luminance":66.75761260710271},{"name":"Bratwurst","hex":"#582f2b","rgb":{"r":88,"g":47,"b":43},"luminance":38.43831251498952},{"name":"Braun","hex":"#897058","rgb":{"r":137,"g":112,"b":88},"luminance":78.10814252688384},{"name":"Brave Orange","hex":"#ff631c","rgb":{"r":255,"g":99,"b":28},"luminance":95.91980847562195},{"name":"Brazen Brass","hex":"#7b6623","rgb":{"r":123,"g":102,"b":35},"luminance":70.38013714820397},{"name":"Brazen Orange","hex":"#ce7850","rgb":{"r":206,"g":120,"b":80},"luminance":94.01483306372458},{"name":"Brazilian Sand","hex":"#dacab7","rgb":{"r":218,"g":202,"b":183},"luminance":136.90766831700844},{"name":"Bread and Butter","hex":"#faedd2","rgb":{"r":250,"g":237,"b":210},"luminance":159.73347257541232},{"name":"Bread Basket","hex":"#ab8659","rgb":{"r":171,"g":134,"b":89},"luminance":94.36205233567145},{"name":"Bread Crumb","hex":"#e4d4be","rgb":{"r":228,"g":212,"b":190},"luminance":143.5370555640598},{"name":"Bread Crust","hex":"#b78b43","rgb":{"r":183,"g":139,"b":67},"luminance":98.53784441522961},{"name":"Bread Flavour","hex":"#dcd6d2","rgb":{"r":220,"g":214,"b":210},"luminance":143.80547251061066},{"name":"Bread Pudding","hex":"#bfa270","rgb":{"r":191,"g":162,"b":112},"luminance":111.65719207019313},{"name":"Break of Day","hex":"#fffabd","rgb":{"r":255,"g":250,"b":189},"luminance":166.77257760495277},{"name":"Break the Ice","hex":"#b2e1ee","rgb":{"r":178,"g":225,"b":238},"luminance":144.95700166946057},{"name":"Breakaway","hex":"#cedac3","rgb":{"r":206,"g":218,"b":195},"luminance":143.74731612103233},{"name":"Breakaway Blue","hex":"#424d60","rgb":{"r":66,"g":77,"b":96},"luminance":50.51882315533488},{"name":"Breaker Bay","hex":"#517b78","rgb":{"r":81,"g":123,"b":120},"luminance":77.37368261883364},{"name":"Breakfast Biscuit","hex":"#f6e3d3","rgb":{"r":246,"g":227,"b":211},"luminance":154.09114780869146},{"name":"Breaking Wave","hex":"#00a0b0","rgb":{"r":0,"g":160,"b":176},"luminance":96.0392133245582},{"name":"Breakwater","hex":"#d1dee4","rgb":{"r":209,"g":222,"b":228},"luminance":146.84157361251616},{"name":"Breath of Fire","hex":"#ee0011","rgb":{"r":238,"g":0,"b":17},"luminance":71.18838450196773},{"name":"Breath of Spring","hex":"#e9e1a7","rgb":{"r":233,"g":225,"b":167},"luminance":150.53153144109044},{"name":"Breathless","hex":"#dfdae0","rgb":{"r":223,"g":218,"b":224},"luminance":146.53739038552584},{"name":"Breathtaking View","hex":"#c3acb7","rgb":{"r":195,"g":172,"b":183},"luminance":118.44165384272544},{"name":"Bredon Green","hex":"#5e9948","rgb":{"r":94,"g":153,"b":72},"luminance":94.46340148967745},{"name":"Breen","hex":"#795d34","rgb":{"r":121,"g":93,"b":52},"luminance":65.75894240329599},{"name":"Breeze in June","hex":"#c2dde6","rgb":{"r":194,"g":221,"b":230},"luminance":144.50356038866312},{"name":"Breeze of Green","hex":"#cffdbc","rgb":{"r":207,"g":253,"b":188},"luminance":162.3132502108192},{"name":"Breezeway","hex":"#d6dbc0","rgb":{"r":214,"g":219,"b":192},"luminance":145.25552157835517},{"name":"Breezy","hex":"#aec9ea","rgb":{"r":174,"g":201,"b":234},"luminance":131.67857009020108},{"name":"Breezy Aqua","hex":"#d9e4de","rgb":{"r":217,"g":228,"b":222},"luminance":150.87204329828637},{"name":"Breezy Beige","hex":"#f7f2d7","rgb":{"r":247,"g":242,"b":215},"luminance":161.97019671840866},{"name":"Breonne Blue","hex":"#2d567c","rgb":{"r":45,"g":86,"b":124},"luminance":54.122969661688},{"name":"Bresaola","hex":"#a9203e","rgb":{"r":169,"g":32,"b":62},"luminance":54.37073883073505},{"name":"Bretzel Brown","hex":"#aa5555","rgb":{"r":170,"g":85,"b":85},"luminance":71.88251543317052},{"name":"Brewed Mustard","hex":"#e68364","rgb":{"r":230,"g":131,"b":100},"luminance":103.79027656288424},{"name":"Brewing Storm","hex":"#777788","rgb":{"r":119,"g":119,"b":136},"luminance":79.91134579019426},{"name":"Briar","hex":"#745443","rgb":{"r":116,"g":84,"b":67},"luminance":60.76674883519769},{"name":"Briar Rose","hex":"#c07281","rgb":{"r":192,"g":114,"b":129},"luminance":89.38659644488092},{"name":"Brick","hex":"#a03623","rgb":{"r":160,"g":54,"b":35},"luminance":57.52694067999792},{"name":"Brick Brown","hex":"#77603f","rgb":{"r":119,"g":96,"b":63},"luminance":67.03086295878936},{"name":"Brick Dust","hex":"#b07069","rgb":{"r":176,"g":112,"b":105},"luminance":85.05786155318036},{"name":"Brick Fence","hex":"#b38070","rgb":{"r":179,"g":128,"b":112},"luminance":93.12860871397145},{"name":"Brick Orange","hex":"#c14a09","rgb":{"r":193,"g":74,"b":9},"luminance":72.23579700536294},{"name":"Brick Red","hex":"#8f1402","rgb":{"r":143,"g":20,"b":2},"luminance":44.34005675458704},{"name":"Brick-A-Brack","hex":"#a75c3d","rgb":{"r":167,"g":92,"b":61},"luminance":73.87891865072201},{"name":"Brickhouse","hex":"#864a36","rgb":{"r":134,"g":74,"b":54},"luminance":59.41414424192272},{"name":"Bricks of Hope","hex":"#db5856","rgb":{"r":219,"g":88,"b":86},"luminance":83.97750956655001},{"name":"Bridal Blush","hex":"#eee2dd","rgb":{"r":238,"g":226,"b":221},"luminance":152.6367391030089},{"name":"Bridal Heath","hex":"#f8ebdd","rgb":{"r":248,"g":235,"b":221},"luminance":158.62559618485284},{"name":"Bridal Rose","hex":"#d69fa2","rgb":{"r":214,"g":159,"b":162},"luminance":114.65742064515493},{"name":"Bridal Veil","hex":"#e7e1de","rgb":{"r":231,"g":225,"b":222},"luminance":151.17813085893079},{"name":"Bride's Blush","hex":"#f9e2e1","rgb":{"r":249,"g":226,"b":225},"luminance":154.27274595663357},{"name":"Bridesmaid","hex":"#fae6df","rgb":{"r":250,"g":230,"b":223},"luminance":156.40185639563234},{"name":"Bridge Troll Grey","hex":"#817f6e","rgb":{"r":129,"g":127,"b":110},"luminance":84.86770317382225},{"name":"Bridgewater","hex":"#527065","rgb":{"r":82,"g":112,"b":101},"luminance":71.10540103255167},{"name":"Brierwood Green","hex":"#545e4f","rgb":{"r":84,"g":94,"b":79},"luminance":61.290563515112176},{"name":"Brig","hex":"#4fa1c0","rgb":{"r":79,"g":161,"b":192},"luminance":99.84292280377211},{"name":"Brig O'Doon","hex":"#ddcfbf","rgb":{"r":221,"g":207,"b":191},"luminance":140.0177788639714},{"name":"Brigade","hex":"#365d73","rgb":{"r":54,"g":93,"b":115},"luminance":58.41868448535964},{"name":"Brigadier Blue","hex":"#0063a0","rgb":{"r":0,"g":99,"b":160},"luminance":60.90827832897594},{"name":"Bright Aqua","hex":"#0bf9ea","rgb":{"r":11,"g":249,"b":234},"luminance":148.61375799703066},{"name":"Bright Blue","hex":"#0165fc","rgb":{"r":1,"g":101,"b":252},"luminance":65.88122459396152},{"name":"Bright Blue Violet","hex":"#8a2be2","rgb":{"r":138,"g":43,"b":226},"luminance":54.80368984840346},{"name":"Bright Bluebell","hex":"#9da7cf","rgb":{"r":157,"g":167,"b":207},"luminance":111.22138146058067},{"name":"Bright Bluebonnet","hex":"#90b3c2","rgb":{"r":144,"g":179,"b":194},"luminance":115.68609216755486},{"name":"Bright Bronze","hex":"#a05822","rgb":{"r":160,"g":88,"b":34},"luminance":70.51263228670449},{"name":"Bright Brown","hex":"#533b32","rgb":{"r":83,"g":59,"b":50},"luminance":42.98625568713795},{"name":"Bright Camouflage","hex":"#1cac78","rgb":{"r":28,"g":172,"b":120},"luminance":102.22994708009976},{"name":"Bright Cerulean","hex":"#1dacd6","rgb":{"r":29,"g":172,"b":214},"luminance":104.23089922379063},{"name":"Bright Chambray","hex":"#adbfc8","rgb":{"r":173,"g":191,"b":200},"luminance":125.56171477803255},{"name":"Bright Chartreuse","hex":"#dfff11","rgb":{"r":223,"g":255,"b":17},"luminance":163.8754935858318},{"name":"Bright Clove","hex":"#efcf9b","rgb":{"r":239,"g":207,"b":155},"luminance":142.06808403719674},{"name":"Bright Cobalt","hex":"#385d8d","rgb":{"r":56,"g":93,"b":141},"luminance":59.32042053964216},{"name":"Bright Cyan","hex":"#41fdfe","rgb":{"r":65,"g":253,"b":254},"luminance":152.55060236524795},{"name":"Bright Delight","hex":"#cd5b26","rgb":{"r":205,"g":91,"b":38},"luminance":81.42001681404885},{"name":"Bright Dusk","hex":"#eee9f9","rgb":{"r":238,"g":233,"b":249},"luminance":156.76766784321313},{"name":"Bright Ecru","hex":"#feffca","rgb":{"r":254,"g":255,"b":202},"luminance":169.4216129217285},{"name":"Bright Eggplant","hex":"#5a4e88","rgb":{"r":90,"g":78,"b":136},"luminance":55.325219493464274},{"name":"Bright Gold","hex":"#cf9f52","rgb":{"r":207,"g":159,"b":82},"luminance":112.37961310664849},{"name":"Bright Greek","hex":"#3844f4","rgb":{"r":56,"g":68,"b":244},"luminance":51.452681640513156},{"name":"Bright Green","hex":"#66ff00","rgb":{"r":102,"g":255,"b":0},"luminance":152.76035882715124},{"name":"Bright Grey","hex":"#ebecf0","rgb":{"r":235,"g":236,"b":240},"luminance":157.72398311290516},{"name":"Bright Idea","hex":"#ecbe63","rgb":{"r":236,"g":190,"b":99},"luminance":132.4597780158188},{"name":"Bright Indigo","hex":"#6f00fe","rgb":{"r":111,"g":0,"b":254},"luminance":44.04497311839343},{"name":"Bright Khaki","hex":"#f1e78c","rgb":{"r":241,"g":231,"b":140},"luminance":154.38188847789107},{"name":"Bright Lady","hex":"#9f3645","rgb":{"r":159,"g":54,"b":69},"luminance":57.67827876245961},{"name":"Bright Laughter","hex":"#f0edd1","rgb":{"r":240,"g":237,"b":209},"luminance":158.33910457306496},{"name":"Bright Lavender","hex":"#bf94e4","rgb":{"r":191,"g":148,"b":228},"luminance":107.16557899344359},{"name":"Bright Lettuce","hex":"#8dce65","rgb":{"r":141,"g":206,"b":101},"luminance":128.57715022895786},{"name":"Bright Light Green","hex":"#2dfe54","rgb":{"r":45,"g":254,"b":84},"luminance":150.00983436095115},{"name":"Bright Lilac","hex":"#d891ef","rgb":{"r":216,"g":145,"b":239},"luminance":110.26332480475999},{"name":"Bright Lime","hex":"#87fd05","rgb":{"r":135,"g":253,"b":5},"luminance":153.8998870889774},{"name":"Bright Lime Green","hex":"#65fe08","rgb":{"r":101,"g":254,"b":8},"luminance":152.12831738042723},{"name":"Bright Loam","hex":"#c1b9aa","rgb":{"r":193,"g":185,"b":170},"luminance":124.49319770172184},{"name":"Bright Magenta","hex":"#ff08e8","rgb":{"r":255,"g":8,"b":232},"luminance":80.83841379567018},{"name":"Bright Manatee","hex":"#979aaa","rgb":{"r":151,"g":154,"b":170},"luminance":102.88738992218627},{"name":"Bright Mango","hex":"#ff8830","rgb":{"r":255,"g":136,"b":48},"luminance":110.52778398665197},{"name":"Bright Marigold","hex":"#ff8d00","rgb":{"r":255,"g":141,"b":0},"luminance":112.53300099970673},{"name":"Bright Maroon","hex":"#c32148","rgb":{"r":195,"g":33,"b":72},"luminance":61.984513630422235},{"name":"Bright Midnight","hex":"#011993","rgb":{"r":1,"g":25,"b":147},"luminance":22.277243770269248},{"name":"Bright Midnight Blue","hex":"#1a4876","rgb":{"r":26,"g":72,"b":118},"luminance":45.02929131132312},{"name":"Bright Mint","hex":"#98ff98","rgb":{"r":152,"g":255,"b":152},"luminance":157.38926111078862},{"name":"Bright Nautilus","hex":"#225869","rgb":{"r":34,"g":88,"b":105},"luminance":53.9904694552659},{"name":"Bright Navy Blue","hex":"#1974d2","rgb":{"r":25,"g":116,"b":210},"luminance":72.56390072894372},{"name":"Bright Nori","hex":"#2d5e22","rgb":{"r":45,"g":94,"b":34},"luminance":56.92690124185577},{"name":"Bright Ocarina","hex":"#f0e8da","rgb":{"r":240,"g":232,"b":218},"luminance":155.9269103137749},{"name":"Bright Olive","hex":"#9cbb04","rgb":{"r":156,"g":187,"b":4},"luminance":119.2690405469919},{"name":"Bright Orange","hex":"#ff7034","rgb":{"r":255,"g":112,"b":52},"luminance":100.84996155180228},{"name":"Bright Pink","hex":"#fe01b1","rgb":{"r":254,"g":1,"b":177},"luminance":78.58302086965097},{"name":"Bright Purple","hex":"#be03fd","rgb":{"r":190,"g":3,"b":253},"luminance":63.73647452597296},{"name":"Bright Red","hex":"#ff000d","rgb":{"r":255,"g":0,"b":13},"luminance":76.25940170890405},{"name":"Bright Rose","hex":"#c51959","rgb":{"r":197,"g":25,"b":89},"luminance":61.54559569944871},{"name":"Bright Saffron","hex":"#ffcf09","rgb":{"r":255,"g":207,"b":9},"luminance":143.45309261915546},{"name":"Bright Sage","hex":"#d1ceb4","rgb":{"r":209,"g":206,"b":180},"luminance":137.65291702321457},{"name":"Bright Scarlet","hex":"#fc0e34","rgb":{"r":252,"g":14,"b":52},"luminance":76.02629684523639},{"name":"Bright Sea Green","hex":"#9fe2bf","rgb":{"r":159,"g":226,"b":191},"luminance":142.59544172588406},{"name":"Bright Sepia","hex":"#b1aa9c","rgb":{"r":177,"g":170,"b":156},"luminance":114.34666013924499},{"name":"Bright Sienna","hex":"#d68a59","rgb":{"r":214,"g":138,"b":89},"luminance":103.72618544996244},{"name":"Bright Sky Blue","hex":"#02ccfe","rgb":{"r":2,"g":204,"b":254},"luminance":123.2006130017217},{"name":"Bright Spark","hex":"#76c1e1","rgb":{"r":118,"g":193,"b":225},"luminance":121.39848724345786},{"name":"Bright Star","hex":"#dde2e6","rgb":{"r":221,"g":226,"b":230},"luminance":150.50956409809976},{"name":"Bright Sun","hex":"#ecbd2c","rgb":{"r":236,"g":189,"b":44},"luminance":131.57806656506241},{"name":"Bright Teal","hex":"#01f9c6","rgb":{"r":1,"g":249,"b":198},"luminance":147.89593352759906},{"name":"Bright Turquoise","hex":"#08e8de","rgb":{"r":8,"g":232,"b":222},"luminance":138.5362710051054},{"name":"Bright Ube","hex":"#d19fe8","rgb":{"r":209,"g":159,"b":232},"luminance":115.39354693395987},{"name":"Bright Umber","hex":"#826644","rgb":{"r":130,"g":102,"b":68},"luminance":71.80436114888845},{"name":"Bright Violet","hex":"#ad0afd","rgb":{"r":173,"g":10,"b":253},"luminance":59.51470736717101},{"name":"Bright White","hex":"#f4f5f0","rgb":{"r":244,"g":245,"b":240},"luminance":163.5661999344608},{"name":"Bright Winter Cloud","hex":"#f5efe8","rgb":{"r":245,"g":239,"b":232},"luminance":160.46157664064003},{"name":"Bright Yarrow","hex":"#face6d","rgb":{"r":250,"g":206,"b":109},"luminance":142.70283129636917},{"name":"Bright Yellow","hex":"#fffd01","rgb":{"r":255,"g":253,"b":1},"luminance":166.9396002810597},{"name":"Bright Yellow Green","hex":"#9dff00","rgb":{"r":157,"g":255,"b":0},"luminance":156.8733389521623},{"name":"Bright Zenith","hex":"#757cae","rgb":{"r":117,"g":124,"b":174},"luminance":83.15870446922558},{"name":"Brihaspati Orange","hex":"#e2681b","rgb":{"r":226,"g":104,"b":27},"luminance":91.11848255979683},{"name":"Brik Dough","hex":"#dab77f","rgb":{"r":218,"g":183,"b":127},"luminance":126.4815276987118},{"name":"Brilliance","hex":"#fdfdfd","rgb":{"r":253,"g":253,"b":253},"luminance":169.14445510864374},{"name":"Brilliant","hex":"#0094a7","rgb":{"r":0,"g":148,"b":167},"luminance":88.93753324665576},{"name":"Brilliant Azure","hex":"#3399ff","rgb":{"r":51,"g":153,"b":255},"luminance":95.62223916014516},{"name":"Brilliant Beige","hex":"#efc5b5","rgb":{"r":239,"g":197,"b":181},"luminance":137.49478098458863},{"name":"Brilliant Blue","hex":"#0075b3","rgb":{"r":0,"g":117,"b":179},"luminance":71.6464226392358},{"name":"Brilliant Impression","hex":"#efc600","rgb":{"r":239,"g":198,"b":0},"luminance":136.43737609980633},{"name":"Brilliant Lavender","hex":"#f4bbff","rgb":{"r":244,"g":187,"b":255},"luminance":134.9699084870402},{"name":"Brilliant Rose","hex":"#fe54a3","rgb":{"r":254,"g":84,"b":163},"luminance":92.43573174914557},{"name":"Brilliant Silver","hex":"#a9b0b4","rgb":{"r":169,"g":176,"b":180},"luminance":116.82389184152358},{"name":"Brilliant White","hex":"#edf1fe","rgb":{"r":237,"g":241,"b":254},"luminance":160.85063504381944},{"name":"Brimstone","hex":"#ffbd2b","rgb":{"r":255,"g":189,"b":43},"luminance":134.70589771053082},{"name":"Brimstone Butterfly","hex":"#c2c190","rgb":{"r":194,"g":193,"b":144},"luminance":128.33172551243905},{"name":"Brindle","hex":"#82776b","rgb":{"r":130,"g":119,"b":107},"luminance":80.86476187437887},{"name":"Brink Pink","hex":"#fb607f","rgb":{"r":251,"g":96,"b":127},"luminance":94.96058544996444},{"name":"Briquette","hex":"#e15f65","rgb":{"r":225,"g":95,"b":101},"luminance":88.1375802141175},{"name":"Brisket","hex":"#6e4534","rgb":{"r":110,"g":69,"b":52},"luminance":52.510820722971},{"name":"Bristol Blue","hex":"#558f91","rgb":{"r":85,"g":143,"b":145},"luminance":89.24827508697295},{"name":"British Khaki","hex":"#bcaf97","rgb":{"r":188,"g":175,"b":151},"luminance":118.3576628909172},{"name":"British Racing Green","hex":"#05480d","rgb":{"r":5,"g":72,"b":13},"luminance":42.316392154813954},{"name":"British Rose","hex":"#f4c8db","rgb":{"r":244,"g":200,"b":219},"luminance":140.45867396497803},{"name":"British Shorthair","hex":"#5f6672","rgb":{"r":95,"g":102,"b":114},"luminance":67.53248045940559},{"name":"Brittany Blue","hex":"#4c7e86","rgb":{"r":76,"g":126,"b":134},"luminance":78.86769805186404},{"name":"Brittany's Bow","hex":"#f3d8e0","rgb":{"r":243,"g":216,"b":224},"luminance":148.3487047769545},{"name":"Broadleaf Forest","hex":"#014421","rgb":{"r":1,"g":68,"b":33},"luminance":40.09400330473373},{"name":"Broadwater Blue","hex":"#034a71","rgb":{"r":3,"g":74,"b":113},"luminance":45.316778095976765},{"name":"Broccoli Brown","hex":"#9b856b","rgb":{"r":155,"g":133,"b":107},"luminance":91.60639317209251},{"name":"Broccoli Green","hex":"#4b5338","rgb":{"r":75,"g":83,"b":56},"luminance":54.01270148770564},{"name":"Broiled Flounder","hex":"#ffdd88","rgb":{"r":255,"g":221,"b":136},"luminance":151.27051454265634},{"name":"Broken Blue","hex":"#74bbfb","rgb":{"r":116,"g":187,"b":251},"luminance":118.62113729432879},{"name":"Broken Tube","hex":"#060310","rgb":{"r":6,"g":3,"b":16},"luminance":3.1058868298764524},{"name":"Broken White","hex":"#eeebe3","rgb":{"r":238,"g":235,"b":227},"luminance":157.36112656243915},{"name":"Bronco","hex":"#a79781","rgb":{"r":167,"g":151,"b":129},"luminance":102.79148162177643},{"name":"Bronze","hex":"#a87900","rgb":{"r":168,"g":121,"b":0},"luminance":86.99476164114711},{"name":"Bronze Brown","hex":"#825e2f","rgb":{"r":130,"g":94,"b":47},"luminance":67.70669647826571},{"name":"Bronze Fig","hex":"#6e6654","rgb":{"r":110,"g":102,"b":84},"luminance":68.980778134202},{"name":"Bronze Flesh","hex":"#f7944a","rgb":{"r":247,"g":148,"b":74},"luminance":114.33665676850971},{"name":"Bronze Green","hex":"#8d8752","rgb":{"r":141,"g":135,"b":82},"luminance":90.24708532689573},{"name":"Bronze Icon","hex":"#585538","rgb":{"r":88,"g":85,"b":56},"luminance":56.767841468563866},{"name":"Bronze Medal","hex":"#6d6240","rgb":{"r":109,"g":98,"b":64},"luminance":66.51800938843554},{"name":"Bronze Mist","hex":"#9c7e41","rgb":{"r":156,"g":126,"b":65},"luminance":87.7550470343444},{"name":"Bronze Olive","hex":"#584c25","rgb":{"r":88,"g":76,"b":37},"luminance":51.9648286055097},{"name":"Bronze Sand","hex":"#e6be9c","rgb":{"r":230,"g":190,"b":156},"luminance":132.22906055780626},{"name":"Bronze Satin","hex":"#cc5533","rgb":{"r":204,"g":85,"b":51},"luminance":79.01788175470156},{"name":"Bronze Tone","hex":"#434c28","rgb":{"r":67,"g":76,"b":40},"luminance":49.115631249124746},{"name":"Bronze Treasure","hex":"#b08d57","rgb":{"r":176,"g":141,"b":87},"luminance":98.58006080846165},{"name":"Bronze Yellow","hex":"#737000","rgb":{"r":115,"g":112,"b":0},"luminance":74.19300345046021},{"name":"Bronzed","hex":"#dd6633","rgb":{"r":221,"g":102,"b":51},"luminance":89.35956978969851},{"name":"Bronzed Brass","hex":"#9b7e4e","rgb":{"r":155,"g":126,"b":78},"luminance":87.73428140128577},{"name":"Bronzed Flesh","hex":"#eb9552","rgb":{"r":235,"g":149,"b":82},"luminance":112.58033441947133},{"name":"Bronzed Orange","hex":"#d78a6c","rgb":{"r":215,"g":138,"b":108},"luminance":104.14470032123575},{"name":"Brood","hex":"#69605a","rgb":{"r":105,"g":96,"b":90},"luminance":65.31815619718608},{"name":"Brooding Storm","hex":"#5e6d6e","rgb":{"r":94,"g":109,"b":110},"luminance":71.00016285192591},{"name":"Brook Green","hex":"#afddcc","rgb":{"r":175,"g":221,"b":204},"luminance":141.80212159907904},{"name":"Broom","hex":"#eecc24","rgb":{"r":238,"g":204,"b":36},"luminance":139.3572982085976},{"name":"Broomstick","hex":"#74462d","rgb":{"r":116,"g":70,"b":45},"luminance":54.01559826568617},{"name":"Brother Blue","hex":"#b0b7c6","rgb":{"r":176,"g":183,"b":198},"luminance":121.72942044140356},{"name":"Brown","hex":"#653700","rgb":{"r":101,"g":55,"b":0},"luminance":44.20747477520062},{"name":"Brown 383","hex":"#443724","rgb":{"r":68,"g":55,"b":36},"luminance":38.37387477177669},{"name":"Brown Alpaca","hex":"#b86d29","rgb":{"r":184,"g":109,"b":41},"luminance":84.51290328109667},{"name":"Brown Bear","hex":"#4a3f37","rgb":{"r":74,"g":63,"b":55},"luminance":43.548445862051146},{"name":"Brown Beauty","hex":"#4a3832","rgb":{"r":74,"g":56,"b":50},"luminance":40.03271487171461},{"name":"Brown Beige","hex":"#cc8833","rgb":{"r":204,"g":136,"b":51},"luminance":100.6352961738574},{"name":"Brown Bramble","hex":"#53331e","rgb":{"r":83,"g":51,"b":30},"luminance":39.03593034628482},{"name":"Brown Butter","hex":"#ac7c00","rgb":{"r":172,"g":124,"b":0},"luminance":89.12312902945003},{"name":"Brown Cerberus","hex":"#995555","rgb":{"r":153,"g":85,"b":85},"luminance":68.38271078277023},{"name":"Brown Chocolate","hex":"#5f1933","rgb":{"r":95,"g":25,"b":51},"luminance":32.49618817646156},{"name":"Brown Clay","hex":"#c37c59","rgb":{"r":195,"g":124,"b":89},"luminance":93.81101899563825},{"name":"Brown Coffee","hex":"#4a2c2a","rgb":{"r":74,"g":44,"b":42},"luminance":34.34487449387463},{"name":"Brown Derby","hex":"#594537","rgb":{"r":89,"g":69,"b":55},"luminance":48.866667883128684},{"name":"Brown Eyes","hex":"#9e6b4a","rgb":{"r":158,"g":107,"b":74},"luminance":79.0439317152177},{"name":"Brown Fox","hex":"#544a42","rgb":{"r":84,"g":74,"b":66},"luminance":50.73740115536072},{"name":"Brown Green","hex":"#706c11","rgb":{"r":112,"g":108,"b":17},"luminance":71.72346062481927},{"name":"Brown Grey","hex":"#8d8468","rgb":{"r":141,"g":132,"b":104},"luminance":89.00402391465231},{"name":"Brown Knapweed","hex":"#f485ac","rgb":{"r":244,"g":133,"b":172},"luminance":108.63762074438117},{"name":"Brown Labrador","hex":"#97382c","rgb":{"r":151,"g":56,"b":44},"luminance":56.07281730928097},{"name":"Brown Moelleux","hex":"#662211","rgb":{"r":102,"g":34,"b":17},"luminance":36.49939194014059},{"name":"Brown Mouse","hex":"#d8cbb5","rgb":{"r":216,"g":203,"b":181},"luminance":137.09923024218625},{"name":"Brown Mustard","hex":"#dfac59","rgb":{"r":223,"g":172,"b":89},"luminance":121.41866800867155},{"name":"Brown Orange","hex":"#b96902","rgb":{"r":185,"g":105,"b":2},"luminance":82.81711437861138},{"name":"Brown Patina","hex":"#834f3d","rgb":{"r":131,"g":79,"b":61},"luminance":61.09847629851337},{"name":"Brown Pepper","hex":"#4e403b","rgb":{"r":78,"g":64,"b":59},"luminance":44.72705427367199},{"name":"Brown Pod","hex":"#3c241b","rgb":{"r":60,"g":36,"b":27},"luminance":27.89048418367813},{"name":"Brown Red","hex":"#922b05","rgb":{"r":146,"g":43,"b":5},"luminance":50.42920480237617},{"name":"Brown Rice","hex":"#dabd84","rgb":{"r":218,"g":189,"b":132},"luminance":129.5510890614201},{"name":"Brown Rose","hex":"#8d736c","rgb":{"r":141,"g":115,"b":108},"luminance":80.53503368100121},{"name":"Brown Rum","hex":"#bc9b4e","rgb":{"r":188,"g":155,"b":78},"luminance":107.31787750882889},{"name":"Brown Rust","hex":"#af593e","rgb":{"r":175,"g":89,"b":62},"luminance":74.27781161289015},{"name":"Brown Sand","hex":"#f7945f","rgb":{"r":247,"g":148,"b":95},"luminance":114.53817653952763},{"name":"Brown Stone","hex":"#593c39","rgb":{"r":89,"g":60,"b":57},"luminance":44.61858049064313},{"name":"Brown Sugar","hex":"#a17249","rgb":{"r":161,"g":114,"b":73},"luminance":82.85310935022292},{"name":"Brown Sugar Coating","hex":"#c8ae96","rgb":{"r":200,"g":174,"b":150},"luminance":119.58520411823528},{"name":"Brown Tumbleweed","hex":"#37290e","rgb":{"r":55,"g":41,"b":14},"luminance":29.19256292277196},{"name":"Brown Wood","hex":"#b4674d","rgb":{"r":180,"g":103,"b":77},"luminance":81.41976544427034},{"name":"Brown Yellow","hex":"#dd9966","rgb":{"r":221,"g":153,"b":102},"luminance":112.10557678367299},{"name":"Brown-Bag-It","hex":"#ddbda3","rgb":{"r":221,"g":189,"b":163},"luminance":130.46100648852897},{"name":"Browned Off","hex":"#bb4433","rgb":{"r":187,"g":68,"b":51},"luminance":68.94456629060771},{"name":"Brownie","hex":"#964b00","rgb":{"r":150,"g":75,"b":0},"luminance":62.84682271205124},{"name":"Brownish","hex":"#9c6d57","rgb":{"r":156,"g":109,"b":87},"luminance":79.7988330052514},{"name":"Brownish Black","hex":"#413936","rgb":{"r":65,"g":57,"b":54},"luminance":39.18061053633544},{"name":"Brownish Green","hex":"#6a6e09","rgb":{"r":106,"g":110,"b":9},"luminance":71.93641089184251},{"name":"Brownish Grey","hex":"#86775f","rgb":{"r":134,"g":119,"b":95},"luminance":81.25278373692805},{"name":"Brownish Orange","hex":"#cb7723","rgb":{"r":203,"g":119,"b":35},"luminance":92.62552303765953},{"name":"Brownish Pink","hex":"#c27e79","rgb":{"r":194,"g":126,"b":121},"luminance":95.00183111919475},{"name":"Brownish Purple","hex":"#76424e","rgb":{"r":118,"g":66,"b":78},"luminance":53.14912748107912},{"name":"Brownish Purple Red","hex":"#8d746f","rgb":{"r":141,"g":116,"b":111},"luminance":81.08036421353816},{"name":"Brownish Red","hex":"#9e3623","rgb":{"r":158,"g":54,"b":35},"luminance":57.03060466100635},{"name":"Brownish Yellow","hex":"#c9b003","rgb":{"r":201,"g":176,"b":3},"luminance":119.52144623037323},{"name":"Bruin Spice","hex":"#d3b99b","rgb":{"r":211,"g":185,"b":155},"luminance":126.82793401297681},{"name":"Bruise","hex":"#7e4071","rgb":{"r":126,"g":64,"b":113},"luminance":54.74149088214533},{"name":"Bruised Bear","hex":"#5d3954","rgb":{"r":93,"g":57,"b":84},"luminance":44.54698313017391},{"name":"Bruised Burgundy","hex":"#5b4148","rgb":{"r":91,"g":65,"b":72},"luminance":47.57630681337088},{"name":"Brume","hex":"#c6c6c2","rgb":{"r":198,"g":198,"b":194},"luminance":132.29692867183275},{"name":"Brunette","hex":"#664238","rgb":{"r":102,"g":66,"b":56},"luminance":49.71746196257407},{"name":"Brunnera Blue","hex":"#9ba9ca","rgb":{"r":155,"g":169,"b":202},"luminance":111.89004878897855},{"name":"Bruno Brown","hex":"#433430","rgb":{"r":67,"g":52,"b":48},"luminance":36.918538012765346},{"name":"Brunswick","hex":"#236649","rgb":{"r":35,"g":102,"b":73},"luminance":61.34873906609654},{"name":"Brunswick Green","hex":"#1b4d3e","rgb":{"r":27,"g":77,"b":62},"luminance":46.455134850735284},{"name":"Bruschetta","hex":"#a75949","rgb":{"r":167,"g":89,"b":73},"luminance":72.7453862591986},{"name":"Bruschetta Tomato","hex":"#ff6347","rgb":{"r":255,"g":99,"b":71},"luminance":96.207762836478},{"name":"Brush","hex":"#b99984","rgb":{"r":185,"g":153,"b":132},"luminance":106.54673739725679},{"name":"Brushed Clay","hex":"#db9351","rgb":{"r":219,"g":147,"b":81},"luminance":108.71439480583977},{"name":"Brushed Nickel","hex":"#73706f","rgb":{"r":115,"g":112,"b":111},"luminance":75.26437056801844},{"name":"Brushwood","hex":"#8c5939","rgb":{"r":140,"g":89,"b":57},"luminance":67.2593090434328},{"name":"Brusque Brown","hex":"#cc6611","rgb":{"r":204,"g":102,"b":17},"luminance":85.49364734294589},{"name":"Brusque Pink","hex":"#ee00ff","rgb":{"r":238,"g":0,"b":255},"luminance":76.87063902427245},{"name":"Brussels","hex":"#6c7c6d","rgb":{"r":108,"g":124,"b":109},"luminance":80.59324837726793},{"name":"Brutal Doom","hex":"#e61626","rgb":{"r":230,"g":22,"b":38},"luminance":70.10599489344688},{"name":"Brutal Pink","hex":"#ff00bb","rgb":{"r":255,"g":0,"b":187},"luminance":79.16916791908324},{"name":"Bryophyte","hex":"#a6bea6","rgb":{"r":166,"g":190,"b":166},"luminance":123.53377122066661},{"name":"Bryopsida Green","hex":"#9fe010","rgb":{"r":159,"g":224,"b":16},"luminance":139.83049667722702},{"name":"Bubble Algae","hex":"#90e4c1","rgb":{"r":144,"g":228,"b":193},"luminance":142.30243158850095},{"name":"Bubble Bobble Green","hex":"#00b800","rgb":{"r":0,"g":184,"b":0},"luminance":108.008},{"name":"Bubble Bobble P2","hex":"#0084ff","rgb":{"r":0,"g":132,"b":255},"luminance":82.75768940708772},{"name":"Bubble Gum","hex":"#ff85ff","rgb":{"r":255,"g":133,"b":255},"luminance":112.93115586940567},{"name":"Bubblegum","hex":"#ea738d","rgb":{"r":234,"g":115,"b":141},"luminance":98.54207049275959},{"name":"Bubbles","hex":"#e7feff","rgb":{"r":231,"g":254,"b":255},"luminance":166.8706243321454},{"name":"Bubbles in the Air","hex":"#d3e3e5","rgb":{"r":211,"g":227,"b":229},"luminance":149.72321516050877},{"name":"Bubbly Barracuda","hex":"#77ccff","rgb":{"r":119,"g":204,"b":255},"luminance":128.26011057612573},{"name":"Bubonic Brown","hex":"#c68400","rgb":{"r":198,"g":132,"b":0},"luminance":97.51229184056746},{"name":"Bucatini Noodle","hex":"#fdf5d7","rgb":{"r":253,"g":245,"b":215},"luminance":164.33491088019002},{"name":"Buccaneer","hex":"#6e5150","rgb":{"r":110,"g":81,"b":80},"luminance":58.52899887235387},{"name":"Buccaneer Blue","hex":"#035b8d","rgb":{"r":3,"g":91,"b":141},"luminance":55.790267735511},{"name":"Büchel Cherry","hex":"#aa1111","rgb":{"r":170,"g":17,"b":17},"luminance":51.836523658517066},{"name":"Buckingham Palace","hex":"#6b5140","rgb":{"r":107,"g":81,"b":64},"luminance":57.77110760579201},{"name":"Buckskin","hex":"#d4ba8c","rgb":{"r":212,"g":186,"b":140},"luminance":127.25356288921736},{"name":"Buckthorn Brown","hex":"#a76f1f","rgb":{"r":167,"g":111,"b":31},"luminance":82.165858444977},{"name":"Buckwheat","hex":"#d4dcd6","rgb":{"r":212,"g":220,"b":214},"luminance":145.91210696854458},{"name":"Buckwheat Groats","hex":"#e0d8a7","rgb":{"r":224,"g":216,"b":167},"luminance":144.65283019699268},{"name":"Bud","hex":"#a5a88f","rgb":{"r":165,"g":168,"b":143},"luminance":111.46664471939576},{"name":"Bud Green","hex":"#79b465","rgb":{"r":121,"g":180,"b":101},"luminance":112.27434184621167},{"name":"Bud's Sails","hex":"#e9e3d3","rgb":{"r":233,"g":227,"b":211},"luminance":152.27403523253727},{"name":"Budder Skin","hex":"#fce2c4","rgb":{"r":252,"g":226,"b":196},"luminance":154.19397421429932},{"name":"Buddha Gold","hex":"#bc9b1b","rgb":{"r":188,"g":155,"b":27},"luminance":106.99314582252454},{"name":"Buddha Green","hex":"#37b575","rgb":{"r":55,"g":181,"b":117},"luminance":108.33635252305665},{"name":"Buddha's Love Handles","hex":"#ffbb33","rgb":{"r":255,"g":187,"b":51},"luminance":133.77718782363456},{"name":"Budding Bloom","hex":"#deeabd","rgb":{"r":222,"g":234,"b":189},"luminance":154.06975421542023},{"name":"Budding Fern","hex":"#edecd4","rgb":{"r":237,"g":236,"b":212},"luminance":157.4699082904413},{"name":"Budding Peach","hex":"#f3d4bf","rgb":{"r":243,"g":212,"b":191},"luminance":145.7376267852609},{"name":"Budgie Blue","hex":"#84c9e1","rgb":{"r":132,"g":201,"b":225},"luminance":127.02982993376004},{"name":"Budōnezumi Grape","hex":"#63424b","rgb":{"r":99,"g":66,"b":75},"luminance":49.50014409069937},{"name":"Buenos Aires","hex":"#f4dcc1","rgb":{"r":244,"g":220,"b":193},"luminance":149.94600874981634},{"name":"Buff","hex":"#f0dc82","rgb":{"r":240,"g":220,"b":130},"luminance":148.47986260769503},{"name":"Buff It","hex":"#d9cfbe","rgb":{"r":217,"g":207,"b":190},"luminance":139.4395796393549},{"name":"Buff Leather","hex":"#aa7733","rgb":{"r":170,"g":119,"b":51},"luminance":86.5848318413797},{"name":"Buff Orange","hex":"#ffbb7c","rgb":{"r":255,"g":187,"b":124},"luminance":134.39627927141436},{"name":"Buff Yellow","hex":"#f1bf70","rgb":{"r":241,"g":191,"b":112},"luminance":133.88705312314553},{"name":"Buffalo Bill","hex":"#ae9274","rgb":{"r":174,"g":146,"b":116},"luminance":101.1257220295608},{"name":"Buffalo Dance","hex":"#695645","rgb":{"r":105,"g":86,"b":69},"luminance":59.966259721613454},{"name":"Buffalo Herd","hex":"#705046","rgb":{"r":112,"g":80,"b":70},"luminance":58.22686788759979},{"name":"Buffalo Hide","hex":"#bb9f6a","rgb":{"r":187,"g":159,"b":106},"luminance":109.46842245140833},{"name":"Buffalo Soldier","hex":"#95786c","rgb":{"r":149,"g":120,"b":108},"luminance":84.25064121417712},{"name":"Buffalo Trail","hex":"#e2ac78","rgb":{"r":226,"g":172,"b":120},"luminance":122.25840327764796},{"name":"Buffed Copper","hex":"#dd9475","rgb":{"r":221,"g":148,"b":117},"luminance":109.96261119580599},{"name":"Buffhide","hex":"#a79c81","rgb":{"r":167,"g":156,"b":129},"luminance":105.3328159169781},{"name":"Bugman's Glow","hex":"#cd5b45","rgb":{"r":205,"g":91,"b":69},"luminance":81.68431226373886},{"name":"Built on Sand","hex":"#e9e3da","rgb":{"r":233,"g":227,"b":218},"luminance":152.4021285743739},{"name":"Bulbasaur","hex":"#73a263","rgb":{"r":115,"g":162,"b":99},"luminance":101.74758403519957},{"name":"Bulgarian Rose","hex":"#480607","rgb":{"r":72,"g":6,"b":7},"luminance":21.828789980207333},{"name":"Bull Kelp","hex":"#636153","rgb":{"r":99,"g":97,"b":83},"luminance":64.86754478165487},{"name":"Bull Ring","hex":"#6b605b","rgb":{"r":107,"g":96,"b":91},"luminance":65.62560345627305},{"name":"Bull Shot","hex":"#75442b","rgb":{"r":117,"g":68,"b":43},"luminance":53.30222273976948},{"name":"Bullet Hell","hex":"#faf1c8","rgb":{"r":250,"g":241,"b":200},"luminance":161.6178040594538},{"name":"Bullfrog","hex":"#8a966a","rgb":{"r":138,"g":150,"b":106},"luminance":97.98662255634694},{"name":"Bulma Hair","hex":"#359e6b","rgb":{"r":53,"g":158,"b":107},"luminance":94.8774953769333},{"name":"Bulrush","hex":"#6d5837","rgb":{"r":109,"g":88,"b":55},"luminance":61.39892928219514},{"name":"Bumble Baby","hex":"#f5f1de","rgb":{"r":245,"g":241,"b":222},"luminance":161.30623663702528},{"name":"Bumblebee","hex":"#ffc82a","rgb":{"r":255,"g":200,"b":42},"luminance":140.0677870496996},{"name":"Bundaberg Sand","hex":"#ffc58a","rgb":{"r":255,"g":197,"b":138},"luminance":139.40292023483582},{"name":"Bungalow Brown","hex":"#ad947b","rgb":{"r":173,"g":148,"b":123},"luminance":102.07711981144452},{"name":"Bungalow Gold","hex":"#ad8047","rgb":{"r":173,"g":128,"b":71},"luminance":91.57845740675042},{"name":"Bungalow Maple","hex":"#e4c590","rgb":{"r":228,"g":197,"b":144},"luminance":135.23788286201466},{"name":"Bungalow Taupe","hex":"#cebe9f","rgb":{"r":206,"g":190,"b":159},"luminance":128.69076739222592},{"name":"Bungee Cord","hex":"#696156","rgb":{"r":105,"g":97,"b":86},"luminance":65.75571581239154},{"name":"Bunker","hex":"#292c2f","rgb":{"r":41,"g":44,"b":47},"luminance":29.08739983222976},{"name":"Bunni Brown","hex":"#6c4522","rgb":{"r":108,"g":69,"b":34},"luminance":51.945063759706755},{"name":"Bunny Cake","hex":"#f1b5cc","rgb":{"r":241,"g":181,"b":204},"luminance":130.46749030314027},{"name":"Bunny Hop","hex":"#f3ecea","rgb":{"r":243,"g":236,"b":234},"luminance":158.68762916182217},{"name":"Bunny Pink","hex":"#dec3c9","rgb":{"r":222,"g":195,"b":201},"luminance":134.28822176572297},{"name":"Bunny Soft","hex":"#d3bfc4","rgb":{"r":211,"g":191,"b":196},"luminance":130.5744919423392},{"name":"Bunny Tail","hex":"#ffe3f4","rgb":{"r":255,"g":227,"b":244},"luminance":156.0202739454075},{"name":"Bunny's Nose","hex":"#fad9dd","rgb":{"r":250,"g":217,"b":221},"luminance":149.82559786965643},{"name":"Bunting","hex":"#2b3449","rgb":{"r":43,"g":52,"b":73},"luminance":34.150735116538854},{"name":"Bunting Blue","hex":"#35537c","rgb":{"r":53,"g":83,"b":124},"luminance":53.1478103594118},{"name":"Buoyancy","hex":"#79b0b6","rgb":{"r":121,"g":176,"b":182},"luminance":111.41260650841986},{"name":"Buoyant","hex":"#65707e","rgb":{"r":101,"g":112,"b":126},"luminance":73.76027137287389},{"name":"Buoyant Blue","hex":"#84addb","rgb":{"r":132,"g":173,"b":219},"luminance":111.77490675907538},{"name":"Burdock","hex":"#717867","rgb":{"r":113,"g":120,"b":103},"luminance":79.00145272714926},{"name":"Bureaucracy","hex":"#746c8f","rgb":{"r":116,"g":108,"b":143},"luminance":74.0796049935473},{"name":"Burgundy","hex":"#900020","rgb":{"r":144,"g":0,"b":32},"luminance":43.21026544699766},{"name":"Burgundy Snail","hex":"#7e7150","rgb":{"r":126,"g":113,"b":80},"luminance":76.82646833611447},{"name":"Burgundy Wine","hex":"#6c403e","rgb":{"r":108,"g":64,"b":62},"luminance":50.040828450376395},{"name":"Burj Khalifa Fountain","hex":"#d4dee8","rgb":{"r":212,"g":222,"b":232},"luminance":147.30673387187701},{"name":"Burka Black","hex":"#353e4f","rgb":{"r":53,"g":62,"b":79},"luminance":40.703300615552045},{"name":"Burlap","hex":"#8b7753","rgb":{"r":139,"g":119,"b":83},"luminance":81.83084854747626},{"name":"Burled Redwood","hex":"#8f4c3a","rgb":{"r":143,"g":76,"b":58},"luminance":62.14587787617131},{"name":"Burlwood","hex":"#9b716b","rgb":{"r":155,"g":113,"b":107},"luminance":81.83185070618897},{"name":"Burmese Gold","hex":"#bc8143","rgb":{"r":188,"g":129,"b":67},"luminance":94.6155416250417},{"name":"Burned Brown","hex":"#6f4b3e","rgb":{"r":111,"g":75,"b":62},"luminance":55.584772824938305},{"name":"Burnham","hex":"#234537","rgb":{"r":35,"g":69,"b":55},"luminance":42.30037983281001},{"name":"Burning Brier","hex":"#884736","rgb":{"r":136,"g":71,"b":54},"luminance":58.552792939363705},{"name":"Burning Bush","hex":"#a0403e","rgb":{"r":160,"g":64,"b":62},"luminance":61.23705453399926},{"name":"Burning Flame","hex":"#ffb162","rgb":{"r":255,"g":177,"b":98},"luminance":129.356545292459},{"name":"Burning Gold","hex":"#ccaa77","rgb":{"r":204,"g":170,"b":119},"luminance":117.73951109122204},{"name":"Burning Orange","hex":"#ff7124","rgb":{"r":255,"g":113,"b":36},"luminance":101.14318762032369},{"name":"Burning Sand","hex":"#d08363","rgb":{"r":208,"g":131,"b":99},"luminance":99.54078193886161},{"name":"Burning Steppes","hex":"#742100","rgb":{"r":116,"g":33,"b":0},"luminance":39.726760464452674},{"name":"Burning Tomato","hex":"#eb5030","rgb":{"r":235,"g":80,"b":48},"luminance":84.68975504156332},{"name":"Burnished Bark","hex":"#6a3d36","rgb":{"r":106,"g":61,"b":54},"luminance":48.21355847684341},{"name":"Burnished Brown","hex":"#a17a74","rgb":{"r":161,"g":122,"b":116},"luminance":87.29720781903622},{"name":"Burnished Copper","hex":"#bb8833","rgb":{"r":187,"g":136,"b":51},"luminance":97.63818100005754},{"name":"Burnished Cream","hex":"#fce5bf","rgb":{"r":252,"g":229,"b":191},"luminance":155.63088096197362},{"name":"Burnished Gold","hex":"#aa9855","rgb":{"r":170,"g":152,"b":85},"luminance":103.14313925802335},{"name":"Burnished Lilac","hex":"#c5aeb1","rgb":{"r":197,"g":174,"b":177},"luminance":119.61975646606207},{"name":"Burnished Russet","hex":"#794029","rgb":{"r":121,"g":64,"b":41},"luminance":52.36526464174511},{"name":"Burns Cave","hex":"#7b5847","rgb":{"r":123,"g":88,"b":71},"luminance":63.92497869377822},{"name":"Burnside","hex":"#d0a664","rgb":{"r":208,"g":166,"b":100},"luminance":116.15828953630472},{"name":"Burnt Almond","hex":"#b0724a","rgb":{"r":176,"g":114,"b":74},"luminance":85.54805781547584},{"name":"Burnt Bamboo","hex":"#4d3b3c","rgb":{"r":77,"g":59,"b":60},"luminance":42.146041546033715},{"name":"Burnt Brick","hex":"#a14d3a","rgb":{"r":161,"g":77,"b":58},"luminance":66.36287716788657},{"name":"Burnt Butter","hex":"#a47c53","rgb":{"r":164,"g":124,"b":83},"luminance":88.27316514094188},{"name":"Burnt Coral","hex":"#e9897e","rgb":{"r":233,"g":137,"b":126},"luminance":107.36401140978293},{"name":"Burnt Crimson","hex":"#582124","rgb":{"r":88,"g":33,"b":36},"luminance":32.930226251879894},{"name":"Burnt Crust","hex":"#885533","rgb":{"r":136,"g":85,"b":51},"luminance":64.62874373682348},{"name":"Burnt Earth","hex":"#9d4531","rgb":{"r":157,"g":69,"b":49},"luminance":62.25224216042343},{"name":"Burnt Grape","hex":"#75625e","rgb":{"r":117,"g":98,"b":94},"luminance":68.175388675093},{"name":"Burnt Henna","hex":"#7e392f","rgb":{"r":126,"g":57,"b":47},"luminance":50.67092974280223},{"name":"Burnt Maroon","hex":"#420303","rgb":{"r":66,"g":3,"b":3},"luminance":19.815368808074197},{"name":"Burnt Ochre","hex":"#bb4f35","rgb":{"r":187,"g":79,"b":53},"luminance":72.89186828446641},{"name":"Burnt Olive","hex":"#646049","rgb":{"r":100,"g":96,"b":73},"luminance":64.3336116505206},{"name":"Burnt Orange","hex":"#cc5500","rgb":{"r":204,"g":85,"b":0},"luminance":78.80369941189309},{"name":"Burnt Red","hex":"#9f2305","rgb":{"r":159,"g":35,"b":5},"luminance":51.793518957491194},{"name":"Burnt Russet","hex":"#7e3940","rgb":{"r":126,"g":57,"b":64},"luminance":50.912342049840916},{"name":"Burnt Sienna","hex":"#b75203","rgb":{"r":183,"g":82,"b":3},"luminance":72.87625819840093},{"name":"Burnt Umber","hex":"#8a3324","rgb":{"r":138,"g":51,"b":36},"luminance":51.14312689892944},{"name":"Burnt Yellow","hex":"#d5ab09","rgb":{"r":213,"g":171,"b":9},"luminance":118.88073340116976},{"name":"Burple","hex":"#6832e3","rgb":{"r":104,"g":50,"b":227},"luminance":49.98054221394562},{"name":"Burro","hex":"#947764","rgb":{"r":148,"g":119,"b":100},"luminance":83.4723973119258},{"name":"Burst of Gold","hex":"#deb368","rgb":{"r":222,"g":179,"b":104},"luminance":124.84766296971681},{"name":"Bursting Lemon","hex":"#fce282","rgb":{"r":252,"g":226,"b":130},"luminance":153.28457113486667},{"name":"Burtuqali Orange","hex":"#ff6700","rgb":{"r":255,"g":103,"b":0},"luminance":97.30792642945383},{"name":"Bush","hex":"#0d2e1c","rgb":{"r":13,"g":46,"b":28},"luminance":27.46644565647328},{"name":"Bush Viper","hex":"#a0bcd0","rgb":{"r":160,"g":188,"b":208},"luminance":122.59433624764236},{"name":"Bushland Grey","hex":"#7f7b73","rgb":{"r":127,"g":123,"b":115},"luminance":82.62448323590289},{"name":"Bussell Lace","hex":"#e5a1a0","rgb":{"r":229,"g":161,"b":160},"luminance":118.12090623594113},{"name":"Buster","hex":"#3e4b69","rgb":{"r":62,"g":75,"b":105},"luminance":49.245700005178115},{"name":"Butter","hex":"#ffff81","rgb":{"r":255,"g":255,"b":129},"luminance":168.6272981637315},{"name":"Butter Base","hex":"#c28a35","rgb":{"r":194,"g":138,"b":53},"luminance":99.81569934634531},{"name":"Butter Cake","hex":"#fdff52","rgb":{"r":253,"g":255,"b":82},"luminance":167.97456038936372},{"name":"Butter Cookie","hex":"#f0e4b2","rgb":{"r":240,"g":228,"b":178},"luminance":153.21010984918715},{"name":"Butter Cupcake","hex":"#ffdd99","rgb":{"r":255,"g":221,"b":153},"luminance":151.48141113021094},{"name":"Butter Fingers","hex":"#fce9ad","rgb":{"r":252,"g":233,"b":173},"luminance":157.39309015646143},{"name":"Butter Fudge","hex":"#aa6600","rgb":{"r":170,"g":102,"b":0},"luminance":78.54033852740896},{"name":"Butter Icing","hex":"#f5e5da","rgb":{"r":245,"g":229,"b":218},"luminance":155.09177882144493},{"name":"Butter Lettuce","hex":"#cfe7cb","rgb":{"r":207,"g":231,"b":203},"luminance":150.84045220695938},{"name":"Butter Ridge","hex":"#f9e097","rgb":{"r":249,"g":224,"b":151},"luminance":152.08013460343858},{"name":"Butter Up","hex":"#f4e0bb","rgb":{"r":244,"g":224,"b":187},"luminance":151.87537392217345},{"name":"Butter Yellow","hex":"#fffd74","rgb":{"r":255,"g":253,"b":116},"luminance":167.46250721280867},{"name":"Butterblond","hex":"#f1c766","rgb":{"r":241,"g":199,"b":102},"luminance":137.74246561609095},{"name":"Butterbrot","hex":"#c5ae7c","rgb":{"r":197,"g":174,"b":124},"luminance":118.7499934694735},{"name":"Buttercream","hex":"#efe0cd","rgb":{"r":239,"g":224,"b":205},"luminance":151.46592212441715},{"name":"Buttercream Frosting","hex":"#f5edd7","rgb":{"r":245,"g":237,"b":215},"luminance":159.1261489699289},{"name":"Buttercup","hex":"#da9429","rgb":{"r":218,"g":148,"b":41},"luminance":108.7105274386984},{"name":"Buttered Popcorn","hex":"#fff0a4","rgb":{"r":255,"g":240,"b":164},"luminance":161.27620667972073},{"name":"Buttered Rum","hex":"#9d702e","rgb":{"r":157,"g":112,"b":46},"luminance":80.95318598424647},{"name":"Butterfly","hex":"#cadea5","rgb":{"r":202,"g":222,"b":165},"luminance":144.85673301576284},{"name":"Butterfly Blue","hex":"#2099bb","rgb":{"r":32,"g":153,"b":187},"luminance":92.80096696155702},{"name":"Butterfly Bush","hex":"#68578c","rgb":{"r":104,"g":87,"b":140},"luminance":61.88477661751717},{"name":"Butterfly Wing","hex":"#f8cfb4","rgb":{"r":248,"g":207,"b":180},"luminance":143.819423531733},{"name":"Buttermilk","hex":"#fffee4","rgb":{"r":255,"g":254,"b":228},"luminance":169.46709914611742},{"name":"Butternut","hex":"#ffa177","rgb":{"r":255,"g":161,"b":119},"luminance":122.18391641292236},{"name":"Butternut Pizazz","hex":"#e59752","rgb":{"r":229,"g":151,"b":82},"luminance":112.39297448684238},{"name":"Butterscotch","hex":"#fdb147","rgb":{"r":253,"g":177,"b":71},"luminance":128.77493407492003},{"name":"Butterscotch Bliss","hex":"#d7ad62","rgb":{"r":215,"g":173,"b":98},"luminance":120.70617386861367},{"name":"Butterscotch Ripple","hex":"#b08843","rgb":{"r":176,"g":136,"b":67},"luminance":95.920658066967},{"name":"Butterscotch Sundae","hex":"#dbb486","rgb":{"r":219,"g":180,"b":134},"luminance":125.24038141510108},{"name":"Butterscotch Syrup","hex":"#d9a05f","rgb":{"r":217,"g":160,"b":95},"luminance":114.6649858893289},{"name":"Butterum","hex":"#c68f65","rgb":{"r":198,"g":143,"b":101},"luminance":103.3612136200035},{"name":"Buttery Leather","hex":"#d4b185","rgb":{"r":212,"g":177,"b":133},"luminance":122.64961063533792},{"name":"Buttery Salmon","hex":"#ffb19a","rgb":{"r":255,"g":177,"b":154},"luminance":130.063505111926},{"name":"Buttery White","hex":"#f1ebda","rgb":{"r":241,"g":235,"b":218},"luminance":157.60375760114349},{"name":"Button Blue","hex":"#24a0ed","rgb":{"r":36,"g":160,"b":237},"luminance":98.31989839294992},{"name":"Button Eyes","hex":"#4f3a32","rgb":{"r":79,"g":58,"b":50},"luminance":41.82788253067564},{"name":"Button Mushroom","hex":"#ece6c8","rgb":{"r":236,"g":230,"b":200},"luminance":154.03512000839288},{"name":"Buzz","hex":"#f0c641","rgb":{"r":240,"g":198,"b":65},"luminance":136.79506122663932},{"name":"Buzzard","hex":"#5f563f","rgb":{"r":95,"g":86,"b":63},"luminance":58.36829167450423},{"name":"Buzzards Bay","hex":"#017a79","rgb":{"r":1,"g":122,"b":121},"luminance":72.93098678202564},{"name":"By Gum","hex":"#816a38","rgb":{"r":129,"g":106,"b":56},"luminance":73.48506502004335},{"name":"By the Bayou","hex":"#007b90","rgb":{"r":0,"g":123,"b":144},"luminance":74.0436996441966},{"name":"By The Sea","hex":"#8d999e","rgb":{"r":141,"g":153,"b":158},"luminance":100.83565414078494},{"name":"Byakuroku Green","hex":"#a5ba93","rgb":{"r":165,"g":186,"b":147},"luminance":120.97719583871994},{"name":"Bygone","hex":"#918e8a","rgb":{"r":145,"g":142,"b":138},"luminance":95.26301047625988},{"name":"Bypass","hex":"#b6c4d2","rgb":{"r":182,"g":196,"b":210},"luminance":129.50445949078355},{"name":"Byron Place","hex":"#31667d","rgb":{"r":49,"g":102,"b":125},"luminance":63.26618509915071},{"name":"Byzantine","hex":"#bd33a4","rgb":{"r":189,"g":51,"b":164},"luminance":66.62775327144087},{"name":"Byzantine Night Blue","hex":"#6a79f7","rgb":{"r":106,"g":121,"b":247},"luminance":82.71769658906128},{"name":"Byzantium","hex":"#702963","rgb":{"r":112,"g":41,"b":99},"luminance":42.75558944746289},{"name":"C-3PO","hex":"#c33140","rgb":{"r":195,"g":49,"b":64},"luminance":65.42182212381431},{"name":"C64 Blue","hex":"#003aff","rgb":{"r":0,"g":58,"b":255},"luminance":44.768236686293555},{"name":"C64 NTSC","hex":"#4e7fff","rgb":{"r":78,"g":127,"b":255},"luminance":83.3458696337137},{"name":"C64 Purple","hex":"#6f6ed1","rgb":{"r":111,"g":110,"b":209},"luminance":76.40990051688327},{"name":"Cab Sav","hex":"#4a2e32","rgb":{"r":74,"g":46,"b":50},"luminance":35.37171016504574},{"name":"Cabal","hex":"#7f6473","rgb":{"r":127,"g":100,"b":115},"luminance":71.13023849952985},{"name":"Cabana Bay","hex":"#8ec1c0","rgb":{"r":142,"g":193,"b":192},"luminance":122.94965225245657},{"name":"Cabaret","hex":"#cd526c","rgb":{"r":205,"g":82,"b":108},"luminance":78.90211863441944},{"name":"Cabaret Charm","hex":"#7c8ea6","rgb":{"r":124,"g":142,"b":166},"luminance":93.16993542983703},{"name":"Cabbage","hex":"#87d7be","rgb":{"r":135,"g":215,"b":190},"luminance":134.26165070488295},{"name":"Cabbage Patch","hex":"#93c460","rgb":{"r":147,"g":196,"b":96},"luminance":123.64707861085921},{"name":"Cabbage Pont","hex":"#4c5544","rgb":{"r":76,"g":85,"b":68},"luminance":55.371334686821484},{"name":"Cabernet","hex":"#8e5b68","rgb":{"r":142,"g":91,"b":104},"luminance":69.25765220537006},{"name":"Cabernet Craving","hex":"#6d3445","rgb":{"r":109,"g":52,"b":69},"luminance":45.340509624396596},{"name":"Cabin Fever","hex":"#5e5349","rgb":{"r":94,"g":83,"b":73},"luminance":56.858937388945286},{"name":"Caboose","hex":"#a8a4a1","rgb":{"r":168,"g":164,"b":161},"luminance":110.1256144772868},{"name":"Cacodemon Red","hex":"#9f0000","rgb":{"r":159,"g":0,"b":0},"luminance":47.541},{"name":"Cactus","hex":"#5b6f55","rgb":{"r":91,"g":111,"b":85},"luminance":71.27173654401862},{"name":"Cactus Blossom","hex":"#d8e5dd","rgb":{"r":216,"g":229,"b":221},"luminance":151.24606977042413},{"name":"Cactus Flower","hex":"#a83e6c","rgb":{"r":168,"g":62,"b":108},"luminance":63.24051236351584},{"name":"Cactus Sand","hex":"#9c9369","rgb":{"r":156,"g":147,"b":105},"luminance":98.81667448867118},{"name":"Cactus Spike","hex":"#c1e0a3","rgb":{"r":193,"g":224,"b":163},"luminance":144.79116933363028},{"name":"Cactus Water","hex":"#d0f7e4","rgb":{"r":208,"g":247,"b":228},"luminance":159.89133512795496},{"name":"Cadaverous","hex":"#009977","rgb":{"r":0,"g":153,"b":119},"luminance":90.82979729692232},{"name":"Caddies Silk","hex":"#3e354d","rgb":{"r":62,"g":53,"b":77},"luminance":37.263991318698},{"name":"Cadet","hex":"#536872","rgb":{"r":83,"g":104,"b":114},"luminance":67.1687264208575},{"name":"Cadet Blue","hex":"#5f9ea0","rgb":{"r":95,"g":158,"b":160},"luminance":98.69833909950056},{"name":"Cadet Grey","hex":"#91a3b0","rgb":{"r":145,"g":163,"b":176},"luminance":106.94425595608209},{"name":"Cadian Fleshtone","hex":"#90766e","rgb":{"r":144,"g":118,"b":110},"luminance":82.51575299298915},{"name":"Cadillac","hex":"#984961","rgb":{"r":152,"g":73,"b":97},"luminance":63.43507128552785},{"name":"Cadillac Coupe","hex":"#c0362c","rgb":{"r":192,"g":54,"b":44},"luminance":65.76930837404328},{"name":"Cadmium Blue","hex":"#0a1195","rgb":{"r":10,"g":17,"b":149},"luminance":19.925981456380008},{"name":"Cadmium Green","hex":"#006b3c","rgb":{"r":0,"g":107,"b":60},"luminance":63.18034568598054},{"name":"Cadmium Orange","hex":"#ed872d","rgb":{"r":237,"g":135,"b":45},"luminance":106.43144128498871},{"name":"Cadmium Purple","hex":"#b60c26","rgb":{"r":182,"g":12,"b":38},"luminance":55.04273688689544},{"name":"Cadmium Red","hex":"#e30022","rgb":{"r":227,"g":0,"b":34},"luminance":67.9835826137458},{"name":"Cadmium Violet","hex":"#7f3e98","rgb":{"r":127,"g":62,"b":152},"luminance":55.37807823498392},{"name":"Cadmium Yellow","hex":"#fff600","rgb":{"r":255,"g":246,"b":0},"luminance":163.29494061054064},{"name":"Caduceus Gold","hex":"#ffee66","rgb":{"r":255,"g":238,"b":102},"luminance":159.58156799893902},{"name":"Café Au Lait","hex":"#a57c5b","rgb":{"r":165,"g":124,"b":91},"luminance":88.54182652848313},{"name":"Cafe Creme","hex":"#c79685","rgb":{"r":199,"g":150,"b":133},"luminance":107.34550640338885},{"name":"Café de Paris","hex":"#889944","rgb":{"r":136,"g":153,"b":68},"luminance":98.89221466323828},{"name":"Cafe Latte","hex":"#d6c6b4","rgb":{"r":214,"g":198,"b":180},"luminance":134.2526039672974},{"name":"Café Noir","hex":"#4b3621","rgb":{"r":75,"g":54,"b":33},"luminance":39.01020985588259},{"name":"Café Renversé","hex":"#ae8774","rgb":{"r":174,"g":135,"b":116},"luminance":95.71493549598202},{"name":"Cafe Royale","hex":"#6a4928","rgb":{"r":106,"g":73,"b":40},"luminance":53.493097096728285},{"name":"Cairns","hex":"#0a6b92","rgb":{"r":10,"g":107,"b":146},"luminance":65.0456248874588},{"name":"Cajun Brown","hex":"#5f3e41","rgb":{"r":95,"g":62,"b":65},"luminance":46.75762356022812},{"name":"Cajun Spice","hex":"#c3705f","rgb":{"r":195,"g":112,"b":95},"luminance":88.53832763837364},{"name":"Cake Batter","hex":"#f0eddb","rgb":{"r":240,"g":237,"b":219},"luminance":158.51465205778297},{"name":"Cake Dough","hex":"#fce0a8","rgb":{"r":252,"g":224,"b":168},"luminance":152.75213370686512},{"name":"Cal Poly Pomona Green","hex":"#1e4d2b","rgb":{"r":30,"g":77,"b":43},"luminance":46.34048019820252},{"name":"Calabash","hex":"#f8eb97","rgb":{"r":248,"g":235,"b":151},"luminance":157.5552726029821},{"name":"Calabash Clash","hex":"#728478","rgb":{"r":114,"g":132,"b":120},"luminance":85.74828308485249},{"name":"Calamansi","hex":"#fcffa4","rgb":{"r":252,"g":255,"b":164},"luminance":168.61927750112085},{"name":"Calamansi Green","hex":"#c4cc7a","rgb":{"r":196,"g":204,"b":122},"luminance":134.04269761534943},{"name":"Calc Sinter","hex":"#e7e1dd","rgb":{"r":231,"g":225,"b":221},"luminance":151.15908845319225},{"name":"Calcareous Sinter","hex":"#ddeeff","rgb":{"r":221,"g":238,"b":255},"luminance":157.25541509595146},{"name":"Calcium Rock","hex":"#eee9d9","rgb":{"r":238,"g":233,"b":217},"luminance":156.1483439841742},{"name":"Calculus","hex":"#a1ccb1","rgb":{"r":161,"g":204,"b":177},"luminance":130.62962339760458},{"name":"Caledor Sky","hex":"#31639c","rgb":{"r":49,"g":99,"b":156},"luminance":62.514344161960146},{"name":"Calf Skin","hex":"#b1aa9d","rgb":{"r":177,"g":170,"b":157},"luminance":114.3644456682233},{"name":"Calgar Blue","hex":"#0485d1","rgb":{"r":4,"g":133,"b":209},"luminance":81.63448862460032},{"name":"Caliban Green","hex":"#005726","rgb":{"r":0,"g":87,"b":38},"luminance":51.252404675293036},{"name":"Calico","hex":"#d5b185","rgb":{"r":213,"g":177,"b":133},"luminance":122.80440714404348},{"name":"Calico Cat","hex":"#c48e36","rgb":{"r":196,"g":142,"b":54},"luminance":102.0794517422581},{"name":"Calico Dress","hex":"#3d4e67","rgb":{"r":61,"g":78,"b":103},"luminance":50.66451895557679},{"name":"Calico Rock","hex":"#9c9584","rgb":{"r":156,"g":149,"b":132},"luminance":100.25907145490626},{"name":"Calico Rose","hex":"#e5c1b3","rgb":{"r":229,"g":193,"b":179},"luminance":133.93854321292284},{"name":"California","hex":"#e98c3a","rgb":{"r":233,"g":140,"b":58},"luminance":107.93869479014464},{"name":"California Chamois","hex":"#e6b76c","rgb":{"r":230,"g":183,"b":108},"luminance":128.14120916005123},{"name":"California Dreamin'","hex":"#93807f","rgb":{"r":147,"g":128,"b":127},"luminance":88.24339742439658},{"name":"California Girl","hex":"#fca716","rgb":{"r":252,"g":167,"b":22},"luminance":123.66606652190406},{"name":"California Gold Rush","hex":"#95743f","rgb":{"r":149,"g":116,"b":63},"luminance":81.6877787003662},{"name":"California Peach","hex":"#fcbe6a","rgb":{"r":252,"g":190,"b":106},"luminance":135.13802225872627},{"name":"California Roll","hex":"#a09574","rgb":{"r":160,"g":149,"b":116},"luminance":100.56498468651998},{"name":"California Sagebrush","hex":"#959988","rgb":{"r":149,"g":153,"b":136},"luminance":101.44545991812545},{"name":"California Wine","hex":"#ca4b65","rgb":{"r":202,"g":75,"b":101},"luminance":75.6220287019596},{"name":"Calla Green","hex":"#6a6f34","rgb":{"r":106,"g":111,"b":52},"luminance":72.69859330826147},{"name":"Calla Lily","hex":"#e4eaed","rgb":{"r":228,"g":234,"b":237},"luminance":155.70682089105796},{"name":"Calliste Green","hex":"#757a4e","rgb":{"r":117,"g":122,"b":78},"luminance":80.1962776505244},{"name":"Calm Balm","hex":"#5e9d47","rgb":{"r":94,"g":157,"b":71},"luminance":96.6888895013279},{"name":"Calm Breeze","hex":"#e9ece4","rgb":{"r":233,"g":236,"b":228},"luminance":157.2265562079129},{"name":"Calm Day","hex":"#7caacf","rgb":{"r":124,"g":170,"b":207},"luminance":109.03916489041907},{"name":"Calm Interlude","hex":"#a7b0d5","rgb":{"r":167,"g":176,"b":213},"luminance":117.28720883796323},{"name":"Calm Tint","hex":"#eae3e9","rgb":{"r":234,"g":227,"b":233},"luminance":152.82695116045468},{"name":"Calm Waters","hex":"#e7fafa","rgb":{"r":231,"g":250,"b":250},"luminance":164.67646844950252},{"name":"Calming Effect","hex":"#cfd3a2","rgb":{"r":207,"g":211,"b":162},"luminance":139.6866741031513},{"name":"Calthan Brown","hex":"#6d5044","rgb":{"r":109,"g":80,"b":68},"luminance":57.684559329165374},{"name":"Calypso","hex":"#3d7188","rgb":{"r":61,"g":113,"b":136},"luminance":70.51834298960803},{"name":"Calypso Berry","hex":"#c53a4b","rgb":{"r":197,"g":58,"b":75},"luminance":68.56964361144077},{"name":"Calypso Coral","hex":"#ee5c6c","rgb":{"r":238,"g":92,"b":108},"luminance":90.17786648618385},{"name":"Calypso Green","hex":"#2e5f60","rgb":{"r":46,"g":95,"b":96},"luminance":58.46946961449196},{"name":"Camaron Pink","hex":"#fe828c","rgb":{"r":254,"g":130,"b":140},"luminance":108.83810277655523},{"name":"Camarone","hex":"#206937","rgb":{"r":32,"g":105,"b":55},"luminance":62.68758050044681},{"name":"Cambridge Blue","hex":"#a3c1ad","rgb":{"r":163,"g":193,"b":173},"luminance":124.89636957894332},{"name":"Cambridge Leather","hex":"#8c633c","rgb":{"r":140,"g":99,"b":60},"luminance":71.9455764380271},{"name":"Camel","hex":"#c69f59","rgb":{"r":198,"g":159,"b":89},"luminance":110.99039151656326},{"name":"Camel Cord","hex":"#e0cb82","rgb":{"r":224,"g":203,"b":130},"luminance":137.49458497337267},{"name":"Camel Fur","hex":"#bb6600","rgb":{"r":187,"g":102,"b":0},"luminance":81.92166651747264},{"name":"Camel Hair Coat","hex":"#f5b784","rgb":{"r":245,"g":183,"b":132},"luminance":130.88929891324193},{"name":"Camel Hide","hex":"#c1aa91","rgb":{"r":193,"g":170,"b":145},"luminance":116.45335052715315},{"name":"Camel Spider","hex":"#af8751","rgb":{"r":175,"g":135,"b":81},"luminance":95.40934129318784},{"name":"Camel Train","hex":"#baae9d","rgb":{"r":186,"g":174,"b":157},"luminance":117.6665901775011},{"name":"Camelback Mountain","hex":"#d3b587","rgb":{"r":211,"g":181,"b":135},"luminance":124.52107865739038},{"name":"Camellia","hex":"#f6745f","rgb":{"r":246,"g":116,"b":95},"luminance":100.81666667768778},{"name":"Camellia Rose","hex":"#eb6081","rgb":{"r":235,"g":96,"b":129},"luminance":91.26327062405772},{"name":"Camelot","hex":"#803a4b","rgb":{"r":128,"g":58,"b":75},"luminance":51.93244265389411},{"name":"Cameo","hex":"#f2debc","rgb":{"r":242,"g":222,"b":188},"luminance":150.58801208595588},{"name":"Cameo Appearance","hex":"#dfc1c3","rgb":{"r":223,"g":193,"b":195},"luminance":133.32233837583257},{"name":"Cameo Blue","hex":"#769da6","rgb":{"r":118,"g":157,"b":166},"luminance":100.47994118728373},{"name":"Cameo Brown","hex":"#c08a80","rgb":{"r":192,"g":138,"b":128},"luminance":100.3522643690714},{"name":"Cameo Green","hex":"#dce6e5","rgb":{"r":220,"g":230,"b":229},"luminance":152.43435221760217},{"name":"Cameo Peach","hex":"#ebcfc9","rgb":{"r":235,"g":207,"b":201},"luminance":142.22045809938876},{"name":"Cameo Pink","hex":"#efbbcc","rgb":{"r":239,"g":187,"b":204},"luminance":133.0291299603211},{"name":"Cameo Role","hex":"#ddcaaf","rgb":{"r":221,"g":202,"b":175},"luminance":137.20142206624536},{"name":"Cameo Rose","hex":"#f7dfd7","rgb":{"r":247,"g":223,"b":215},"luminance":152.28288646463199},{"name":"Camisole","hex":"#fcd9c7","rgb":{"r":252,"g":217,"b":199},"luminance":149.7243645536691},{"name":"Camo","hex":"#7f8f4e","rgb":{"r":127,"g":143,"b":78},"luminance":92.55867260284148},{"name":"Camo Beige","hex":"#8c8475","rgb":{"r":140,"g":132,"b":117},"luminance":89.07262261772694},{"name":"Camo Green","hex":"#a5a542","rgb":{"r":165,"g":165,"b":66},"luminance":108.9561555213839},{"name":"Camouflage","hex":"#3c3910","rgb":{"r":60,"g":57,"b":16},"luminance":38.008883922051695},{"name":"Camouflage Green","hex":"#4b6113","rgb":{"r":75,"g":97,"b":19},"luminance":61.23415633451644},{"name":"Campanelle Noodle","hex":"#fcf7db","rgb":{"r":252,"g":247,"b":219},"luminance":165.29498595238758},{"name":"Campánula","hex":"#3272af","rgb":{"r":50,"g":114,"b":175},"luminance":71.41094960858592},{"name":"Campanula Purple","hex":"#6c6d94","rgb":{"r":108,"g":109,"b":148},"luminance":73.6292193154321},{"name":"Campfire","hex":"#ce5f38","rgb":{"r":206,"g":95,"b":56},"luminance":83.33253576484996},{"name":"Campfire Smoke","hex":"#d5d1cb","rgb":{"r":213,"g":209,"b":203},"luminance":140.15243352150543},{"name":"Camping Trip","hex":"#67786e","rgb":{"r":103,"g":120,"b":110},"luminance":77.89416158480685},{"name":"Can Can","hex":"#d08a9b","rgb":{"r":208,"g":138,"b":155},"luminance":103.64384110983151},{"name":"Canada Goose Eggs","hex":"#eae2dd","rgb":{"r":234,"g":226,"b":221},"luminance":152.08282294855},{"name":"Canadian Lake","hex":"#8f9aa4","rgb":{"r":143,"g":154,"b":164},"luminance":101.73249170741863},{"name":"Canadian Maple","hex":"#cab266","rgb":{"r":202,"g":178,"b":102},"luminance":121.24542458996132},{"name":"Canadian Pancake","hex":"#edd8c3","rgb":{"r":237,"g":216,"b":195},"luminance":146.9419917280285},{"name":"Canadian Pine","hex":"#2e7b52","rgb":{"r":46,"g":123,"b":82},"luminance":74.0914436422992},{"name":"Canal Blue","hex":"#9cc2c5","rgb":{"r":156,"g":194,"b":197},"luminance":125.0928590447912},{"name":"Canaletto","hex":"#818c72","rgb":{"r":129,"g":140,"b":114},"luminance":91.70698150631716},{"name":"Canary","hex":"#fdff63","rgb":{"r":253,"g":255,"b":99},"luminance":168.09355023319605},{"name":"Canary Feather","hex":"#efde75","rgb":{"r":239,"g":222,"b":117},"luminance":149.21901809420942},{"name":"Canary Grass","hex":"#d0cca9","rgb":{"r":208,"g":204,"b":169},"luminance":136.30336431651273},{"name":"Canary Green","hex":"#d6dec9","rgb":{"r":214,"g":222,"b":201},"luminance":146.97278043229636},{"name":"Canary Island","hex":"#e9d4a9","rgb":{"r":233,"g":212,"b":169},"luminance":143.91309454319992},{"name":"Canary Wharf","hex":"#91a1b5","rgb":{"r":145,"g":161,"b":181},"luminance":106.00467456673785},{"name":"Canary Yellow","hex":"#ffdf01","rgb":{"r":255,"g":223,"b":1},"luminance":151.48724309987293},{"name":"Candela","hex":"#bac4d5","rgb":{"r":186,"g":196,"b":213},"luminance":130.07496001921353},{"name":"Candelabra","hex":"#e1c161","rgb":{"r":225,"g":193,"b":97},"luminance":132.22350649563035},{"name":"Candidate","hex":"#c3bc90","rgb":{"r":195,"g":188,"b":144},"luminance":125.88647590984505},{"name":"Candied Apple","hex":"#b95b6d","rgb":{"r":185,"g":91,"b":109},"luminance":77.89435531538854},{"name":"Candied Blueberry","hex":"#331166","rgb":{"r":51,"g":17,"b":102},"luminance":21.617650797438653},{"name":"Candied Ginger","hex":"#bfa387","rgb":{"r":191,"g":163,"b":135},"luminance":112.48619356169894},{"name":"Candied Yams","hex":"#f9a765","rgb":{"r":249,"g":167,"b":101},"luminance":123.63336296485669},{"name":"Candle Bark","hex":"#c3bdaa","rgb":{"r":195,"g":189,"b":170},"luminance":126.82037168373226},{"name":"Candle Flame","hex":"#fff4a1","rgb":{"r":255,"g":244,"b":161},"luminance":163.2924656100213},{"name":"Candle Glow","hex":"#ffe8c3","rgb":{"r":255,"g":232,"b":195},"luminance":157.65010238182532},{"name":"Candle in the Wind","hex":"#f9ebbf","rgb":{"r":249,"g":235,"b":191},"luminance":158.2589065487311},{"name":"Candle Wax","hex":"#f2eacf","rgb":{"r":242,"g":234,"b":207},"luminance":157.0342826646462},{"name":"Candlelight","hex":"#fcd917","rgb":{"r":252,"g":217,"b":23},"luminance":148.0189367243259},{"name":"Candlelight Peach","hex":"#f8a39d","rgb":{"r":248,"g":163,"b":157},"luminance":122.36711677979505},{"name":"Candlelit Beige","hex":"#f1ede0","rgb":{"r":241,"g":237,"b":224},"luminance":158.74093025429832},{"name":"Candlestick Point","hex":"#fff1d5","rgb":{"r":255,"g":241,"b":213},"luminance":162.52946698368268},{"name":"Candlewick","hex":"#f2ebd3","rgb":{"r":242,"g":235,"b":211},"luminance":157.61693470246146},{"name":"Candy","hex":"#ff9b87","rgb":{"r":255,"g":155,"b":135},"luminance":119.70138825427213},{"name":"Candy Apple Red","hex":"#ff0800","rgb":{"r":255,"g":8,"b":0},"luminance":76.38947860144091},{"name":"Candy Bar","hex":"#ffb7d5","rgb":{"r":255,"g":183,"b":213},"luminance":133.9484482552896},{"name":"Candy Cane","hex":"#f7bfc2","rgb":{"r":247,"g":191,"b":194},"luminance":136.06470796646718},{"name":"Candy Corn","hex":"#fcfc5d","rgb":{"r":252,"g":252,"b":93},"luminance":166.34672609943362},{"name":"Candy Floss","hex":"#e8a7e2","rgb":{"r":232,"g":167,"b":226},"luminance":122.82258734043994},{"name":"Candy Grass","hex":"#e2d6bd","rgb":{"r":226,"g":214,"b":189},"luminance":144.2579547754646},{"name":"Candy Green","hex":"#82dbcc","rgb":{"r":130,"g":219,"b":204},"luminance":136.2996413971805},{"name":"Candy Heart Pink","hex":"#f5a2a1","rgb":{"r":245,"g":162,"b":161},"luminance":121.43324576490575},{"name":"Candy Mix","hex":"#f3dfe3","rgb":{"r":243,"g":223,"b":227},"luminance":151.9334799640948},{"name":"Candy Pink","hex":"#ff63e9","rgb":{"r":255,"g":99,"b":233},"luminance":99.47844308190594},{"name":"Candyman","hex":"#ff9e76","rgb":{"r":255,"g":158,"b":118},"luminance":120.8142245143344},{"name":"Candytuft","hex":"#edc9d8","rgb":{"r":237,"g":201,"b":216},"luminance":139.81716029872726},{"name":"Cane Sugar","hex":"#e3b982","rgb":{"r":227,"g":185,"b":130},"luminance":128.91567225903916},{"name":"Cane Sugar Glaze","hex":"#ddbb99","rgb":{"r":221,"g":187,"b":153},"luminance":129.3054173884451},{"name":"Cane Toad","hex":"#977042","rgb":{"r":151,"g":112,"b":66},"luminance":80.10815384840672},{"name":"Caneel Bay","hex":"#00849f","rgb":{"r":0,"g":132,"b":159},"luminance":79.57588913735114},{"name":"Cannery Park","hex":"#bcb09e","rgb":{"r":188,"g":176,"b":158},"luminance":118.98567322161101},{"name":"Cannoli Cream","hex":"#f0efe2","rgb":{"r":240,"g":239,"b":226},"luminance":159.67281279228467},{"name":"Cannon Ball","hex":"#484335","rgb":{"r":72,"g":67,"b":53},"luminance":45.24080888976235},{"name":"Cannon barrel","hex":"#3c4142","rgb":{"r":60,"g":65,"b":66},"luminance":42.828240694663144},{"name":"Cannon Black","hex":"#251706","rgb":{"r":37,"g":23,"b":6},"luminance":17.46810882723141},{"name":"Cannon Grey","hex":"#646c64","rgb":{"r":100,"g":108,"b":100},"luminance":71.01424375433423},{"name":"Cannon Pink","hex":"#8e5164","rgb":{"r":142,"g":81,"b":100},"luminance":64.75615007858326},{"name":"Canoe Blue","hex":"#1d5671","rgb":{"r":29,"g":86,"b":113},"luminance":52.81632786364459},{"name":"Canopy","hex":"#728f02","rgb":{"r":114,"g":143,"b":2},"luminance":90.59800693723896},{"name":"Cantaloupe","hex":"#ffd479","rgb":{"r":255,"g":212,"b":121},"luminance":146.59428227935766},{"name":"Cantankerous Coyote","hex":"#ac8d74","rgb":{"r":172,"g":141,"b":116},"luminance":98.33661397973798},{"name":"Canteen","hex":"#5e5347","rgb":{"r":94,"g":83,"b":71},"luminance":56.826014403616234},{"name":"Canterbury Cathedral","hex":"#b2ab94","rgb":{"r":178,"g":171,"b":148},"luminance":114.85986155746488},{"name":"Canton","hex":"#6da29e","rgb":{"r":109,"g":162,"b":158},"luminance":102.12479748327533},{"name":"Canvas","hex":"#bb8855","rgb":{"r":187,"g":136,"b":85},"luminance":97.94543324218847},{"name":"Canvas Cloth","hex":"#e6dfd2","rgb":{"r":230,"g":223,"b":210},"luminance":149.79154949796066},{"name":"Canvas Satchel","hex":"#ccb88d","rgb":{"r":204,"g":184,"b":141},"luminance":125.07842961917933},{"name":"Canyon Blue","hex":"#607b8e","rgb":{"r":96,"g":123,"b":142},"luminance":79.36595845197107},{"name":"Canyon Clay","hex":"#ce8477","rgb":{"r":206,"g":132,"b":119},"luminance":99.90809500736164},{"name":"Canyon Cloud","hex":"#aeafbb","rgb":{"r":174,"g":175,"b":187},"luminance":117.1050273259009},{"name":"Canyon Dusk","hex":"#ddc3b7","rgb":{"r":221,"g":195,"b":183},"luminance":133.80543154147367},{"name":"Canyon Echo","hex":"#e5e1cc","rgb":{"r":229,"g":225,"b":204},"luminance":150.5753133883506},{"name":"Canyon Falls","hex":"#97987f","rgb":{"r":151,"g":152,"b":127},"luminance":101.03943220842048},{"name":"Canyon Peach","hex":"#eedacb","rgb":{"r":238,"g":218,"b":203},"luminance":148.23926458263344},{"name":"Canyon Rose","hex":"#af6c67","rgb":{"r":175,"g":108,"b":103},"luminance":83.03513114941168},{"name":"Canyon Stone","hex":"#93625b","rgb":{"r":147,"g":98,"b":91},"luminance":73.13498999111164},{"name":"Canyon Sunset","hex":"#e1927a","rgb":{"r":225,"g":146,"b":122},"luminance":109.83711072765888},{"name":"Canyon Verde","hex":"#8a7e5c","rgb":{"r":138,"g":126,"b":92},"luminance":85.34007400981089},{"name":"Canyonville","hex":"#f5ded1","rgb":{"r":245,"g":222,"b":209},"luminance":151.37936417160694},{"name":"Cǎo Lǜ Grass","hex":"#1fa774","rgb":{"r":31,"g":167,"b":116},"luminance":99.35025605402332},{"name":"Cape Cod","hex":"#4e5552","rgb":{"r":78,"g":85,"b":82},"luminance":55.86422659448531},{"name":"Cape Cod Blue","hex":"#91a2a6","rgb":{"r":145,"g":162,"b":166},"luminance":106.21036972442944},{"name":"Cape Honey","hex":"#fee0a5","rgb":{"r":254,"g":224,"b":165},"luminance":153.0055723168277},{"name":"Cape Hope","hex":"#d8d6d7","rgb":{"r":216,"g":214,"b":215},"luminance":143.35869377195093},{"name":"Cape Jasmine","hex":"#ffb95a","rgb":{"r":255,"g":185,"b":90},"luminance":133.08434036354538},{"name":"Cape Lee","hex":"#50818b","rgb":{"r":80,"g":129,"b":139},"luminance":80.97675496708916},{"name":"Cape Palliser","hex":"#75482f","rgb":{"r":117,"g":72,"b":47},"luminance":55.12498661224327},{"name":"Cape Pond","hex":"#0092ad","rgb":{"r":0,"g":146,"b":173},"luminance":87.94197000295138},{"name":"Capella","hex":"#d9ced2","rgb":{"r":217,"g":206,"b":210},"luminance":139.3020364998301},{"name":"Caper","hex":"#afc182","rgb":{"r":175,"g":193,"b":130},"luminance":125.66777115076084},{"name":"Capers","hex":"#695e4b","rgb":{"r":105,"g":94,"b":75},"luminance":64.05747582445002},{"name":"Capital Blue","hex":"#1a4157","rgb":{"r":26,"g":65,"b":87},"luminance":40.18215804309171},{"name":"Capital Grains","hex":"#dbd0a8","rgb":{"r":219,"g":208,"b":168},"luminance":139.8641972807909},{"name":"Capital Yellow","hex":"#e6ba45","rgb":{"r":230,"g":186,"b":69},"luminance":129.2744985679697},{"name":"Capocollo","hex":"#d9544d","rgb":{"r":217,"g":84,"b":77},"luminance":81.96423510897908},{"name":"Cappuccino","hex":"#633f33","rgb":{"r":99,"g":63,"b":51},"luminance":47.72437697864687},{"name":"Cappuccino Bombe","hex":"#b4897d","rgb":{"r":180,"g":137,"b":125},"luminance":97.8103801291049},{"name":"Cappuccino Froth","hex":"#c8b089","rgb":{"r":200,"g":176,"b":137},"luminance":120.3882522009519},{"name":"Capri","hex":"#00bfff","rgb":{"r":0,"g":191,"b":255},"luminance":115.82437821546894},{"name":"Capri Breeze","hex":"#008799","rgb":{"r":0,"g":135,"b":153},"luminance":81.14181036309209},{"name":"Capri Cream","hex":"#f1f0d6","rgb":{"r":241,"g":240,"b":214},"luminance":160.10883391306052},{"name":"Capri Isle","hex":"#4f5855","rgb":{"r":79,"g":88,"b":85},"luminance":57.621090557190946},{"name":"Capricious Purple","hex":"#bb00dd","rgb":{"r":187,"g":0,"b":221},"luminance":61.32700225023232},{"name":"Caps","hex":"#7e7a75","rgb":{"r":126,"g":122,"b":117},"luminance":82.01095973100179},{"name":"Capsella","hex":"#6d8a74","rgb":{"r":109,"g":138,"b":116},"luminance":88.3120574610285},{"name":"Capsicum Red","hex":"#76392e","rgb":{"r":118,"g":57,"b":46},"luminance":48.9062750677252},{"name":"Capstan","hex":"#007eb0","rgb":{"r":0,"g":126,"b":176},"luminance":76.63511949491564},{"name":"Captain Kirk Uniform","hex":"#9b870c","rgb":{"r":155,"g":135,"b":12},"luminance":91.81231112438027},{"name":"Captains Blue","hex":"#557088","rgb":{"r":85,"g":112,"b":136},"luminance":72.1704217598872},{"name":"Captivated","hex":"#947cae","rgb":{"r":148,"g":124,"b":174},"luminance":87.46313134115425},{"name":"Captive","hex":"#005b6a","rgb":{"r":0,"g":91,"b":106},"luminance":54.766768619300514},{"name":"Capture","hex":"#2cbaa3","rgb":{"r":44,"g":186,"b":163},"luminance":111.53062442217383},{"name":"Capulet Olive","hex":"#656344","rgb":{"r":101,"g":99,"b":68},"luminance":65.94841828277613},{"name":"Caput Mortuum","hex":"#592720","rgb":{"r":89,"g":39,"b":32},"luminance":35.29224665560412},{"name":"Carafe","hex":"#5d473a","rgb":{"r":93,"g":71,"b":58},"luminance":50.53632477733219},{"name":"Carambar","hex":"#552233","rgb":{"r":85,"g":34,"b":51},"luminance":32.83361973648351},{"name":"Caramel","hex":"#af6f09","rgb":{"r":175,"g":111,"b":9},"luminance":83.57268064385633},{"name":"Caramel Apple","hex":"#b87a59","rgb":{"r":184,"g":122,"b":89},"luminance":90.87500518844551},{"name":"Caramel Bar","hex":"#cc8654","rgb":{"r":204,"g":134,"b":84},"luminance":99.99646371747352},{"name":"Caramel Cafe","hex":"#864c24","rgb":{"r":134,"g":76,"b":36},"luminance":60.10289274236307},{"name":"Caramel Cream","hex":"#f4ba94","rgb":{"r":244,"g":186,"b":148},"luminance":132.39316992957},{"name":"Caramel Cupcake","hex":"#b98c5d","rgb":{"r":185,"g":140,"b":93},"luminance":99.62782758346184},{"name":"Caramel Finish","hex":"#ffd59a","rgb":{"r":255,"g":213,"b":154},"luminance":147.49326805654553},{"name":"Caramel Ice","hex":"#eec9aa","rgb":{"r":238,"g":201,"b":170},"luminance":139.14218200459555},{"name":"Caramel Infused","hex":"#cc7755","rgb":{"r":204,"g":119,"b":85},"luminance":93.24081576755964},{"name":"Caramel Kiss","hex":"#b08a61","rgb":{"r":176,"g":138,"b":97},"luminance":97.22929998719522},{"name":"Caramel Milk","hex":"#ddc283","rgb":{"r":221,"g":194,"b":131},"luminance":132.50531114261045},{"name":"Caramel Powder","hex":"#eebb99","rgb":{"r":238,"g":187,"b":153},"luminance":131.97532712215568},{"name":"Caramel Sundae","hex":"#a9876a","rgb":{"r":169,"g":135,"b":106},"luminance":94.75850907438338},{"name":"Caramelized","hex":"#ba947f","rgb":{"r":186,"g":148,"b":127},"luminance":104.16318378390706},{"name":"Caramelized Orange","hex":"#ef924a","rgb":{"r":239,"g":146,"b":74},"luminance":111.90475155684855},{"name":"Caramelized Pears","hex":"#e7d5ad","rgb":{"r":231,"g":213,"b":173},"luminance":144.19512823254468},{"name":"Caramelized Pecan","hex":"#a17b4d","rgb":{"r":161,"g":123,"b":77},"luminance":87.22041622235014},{"name":"Caramelized Walnut","hex":"#6e564a","rgb":{"r":110,"g":86,"b":74},"luminance":60.83872549618376},{"name":"Caravel Brown","hex":"#8c6e54","rgb":{"r":140,"g":110,"b":84},"luminance":77.54511123210797},{"name":"Carbon","hex":"#333333","rgb":{"r":51,"g":51,"b":51},"luminance":34.096313085141624},{"name":"Carbon Dating","hex":"#565b58","rgb":{"r":86,"g":91,"b":88},"luminance":60.12675535067562},{"name":"Carbon Footprint","hex":"#7b808b","rgb":{"r":123,"g":128,"b":139},"luminance":85.1414231793197},{"name":"Cardamom","hex":"#aaaa77","rgb":{"r":170,"g":170,"b":119},"luminance":112.8085517857578},{"name":"Cardboard","hex":"#c19a6c","rgb":{"r":193,"g":154,"b":108},"luminance":107.95129270647942},{"name":"Cardin Green","hex":"#1b3427","rgb":{"r":27,"g":52,"b":39},"luminance":31.885025027432548},{"name":"Cardinal","hex":"#c41e3a","rgb":{"r":196,"g":30,"b":58},"luminance":61.548838006903104},{"name":"Cardinal Pink","hex":"#8c055e","rgb":{"r":140,"g":5,"b":94},"luminance":43.30942716083878},{"name":"Cardoon","hex":"#9aae8c","rgb":{"r":154,"g":174,"b":140},"luminance":113.16857673400332},{"name":"Cardueline Finch","hex":"#957b38","rgb":{"r":149,"g":123,"b":56},"luminance":85.07955957807961},{"name":"Careys Pink","hex":"#c99aa0","rgb":{"r":201,"g":154,"b":160},"luminance":110.07445573338074},{"name":"Cargo","hex":"#8f755b","rgb":{"r":143,"g":117,"b":91},"luminance":81.56338618522406},{"name":"Cargo Green","hex":"#c8c5a7","rgb":{"r":200,"g":197,"b":167},"luminance":131.57075573621972},{"name":"Cargo River","hex":"#cfcdbb","rgb":{"r":207,"g":205,"b":187},"luminance":136.9880023870704},{"name":"Caribbean Blue","hex":"#1ac1dd","rgb":{"r":26,"g":193,"b":221},"luminance":116.31862874449646},{"name":"Caribbean Cruise","hex":"#3f9da9","rgb":{"r":63,"g":157,"b":169},"luminance":96.01714745814935},{"name":"Caribbean Green","hex":"#00cc99","rgb":{"r":0,"g":204,"b":153},"luminance":121.0115980722509},{"name":"Caribbean Pleasure","hex":"#d5dcce","rgb":{"r":213,"g":220,"b":206},"luminance":145.89267228000176},{"name":"Caribbean Sea","hex":"#00819d","rgb":{"r":0,"g":129,"b":157},"luminance":77.80945400785177},{"name":"Caribbean Splash","hex":"#00697c","rgb":{"r":0,"g":105,"b":124},"luminance":63.23527275975015},{"name":"Caribbean Swim","hex":"#126366","rgb":{"r":18,"g":99,"b":102},"luminance":59.50879831587931},{"name":"Caribbean Turquoise","hex":"#009d94","rgb":{"r":0,"g":157,"b":148},"luminance":93.69069145331353},{"name":"Caribou","hex":"#816d5e","rgb":{"r":129,"g":109,"b":94},"luminance":75.47435979191873},{"name":"Caribou Herd","hex":"#cda563","rgb":{"r":205,"g":165,"b":99},"luminance":115.17526577351578},{"name":"Carissima","hex":"#e68095","rgb":{"r":230,"g":128,"b":149},"luminance":103.26304078420313},{"name":"Carla","hex":"#f5f9cb","rgb":{"r":245,"g":249,"b":203},"luminance":165.12259008990864},{"name":"Carlisle","hex":"#45867c","rgb":{"r":69,"g":134,"b":124},"luminance":82.53814645968251},{"name":"Carmel Mission","hex":"#927f76","rgb":{"r":146,"g":127,"b":118},"luminance":87.43100949319984},{"name":"Carmen","hex":"#7c383f","rgb":{"r":124,"g":56,"b":63},"luminance":50.06774694351644},{"name":"Carmen Miranda","hex":"#903e2f","rgb":{"r":144,"g":62,"b":47},"luminance":56.63082672891152},{"name":"Carmim","hex":"#a13905","rgb":{"r":161,"g":57,"b":5},"luminance":58.62757799875413},{"name":"Carmine","hex":"#9d0216","rgb":{"r":157,"g":2,"b":22},"luminance":47.024606207814216},{"name":"Carmine Carnation","hex":"#ad4b53","rgb":{"r":173,"g":75,"b":83},"luminance":68.58143041669516},{"name":"Carmine Pink","hex":"#eb4c42","rgb":{"r":235,"g":76,"b":66},"luminance":83.57039754003806},{"name":"Carmine Red","hex":"#ff0038","rgb":{"r":255,"g":0,"b":56},"luminance":76.5117996194051},{"name":"Carmine Rose","hex":"#e35b8f","rgb":{"r":227,"g":91,"b":143},"luminance":87.89695797921563},{"name":"Carmoisine","hex":"#b31c45","rgb":{"r":179,"g":28,"b":69},"luminance":56.537717437123334},{"name":"Carnaby Tan","hex":"#5b3a24","rgb":{"r":91,"g":58,"b":36},"luminance":43.77559380522439},{"name":"Carnage Red","hex":"#940008","rgb":{"r":148,"g":0,"b":8},"luminance":44.26139681483177},{"name":"Carnal Brown","hex":"#bb8866","rgb":{"r":187,"g":136,"b":102},"luminance":98.15611125650811},{"name":"Carnal Pink","hex":"#ef9cb5","rgb":{"r":239,"g":156,"b":181},"luminance":117.97401265109193},{"name":"Carnation","hex":"#fd798f","rgb":{"r":253,"g":121,"b":143},"luminance":105.03836699987295},{"name":"Carnation Pink","hex":"#ff7fa7","rgb":{"r":255,"g":127,"b":167},"luminance":108.32035298133033},{"name":"Carnelian","hex":"#b31b1b","rgb":{"r":179,"g":27,"b":27},"luminance":55.90315130652296},{"name":"Carnival Night","hex":"#006e7a","rgb":{"r":0,"g":110,"b":122},"luminance":66.05086951736517},{"name":"Caro","hex":"#ffcac3","rgb":{"r":255,"g":202,"b":195},"luminance":142.71393204939733},{"name":"Carob Brown","hex":"#855c4c","rgb":{"r":133,"g":92,"b":76},"luminance":67.62330368297603},{"name":"Carob Chip","hex":"#5a484b","rgb":{"r":90,"g":72,"b":75},"luminance":50.828105374880934},{"name":"Carol","hex":"#338dae","rgb":{"r":51,"g":141,"b":174},"luminance":86.4660348691901},{"name":"Carol's Purr","hex":"#77a135","rgb":{"r":119,"g":161,"b":53},"luminance":101.16366133152754},{"name":"Carolina","hex":"#cbefcb","rgb":{"r":203,"g":239,"b":203},"luminance":154.60208220460677},{"name":"Carolina Blue","hex":"#8ab8fe","rgb":{"r":138,"g":184,"b":254},"luminance":119.19199068729408},{"name":"Carolina Green","hex":"#008b6d","rgb":{"r":0,"g":139,"b":109},"luminance":82.53376960372037},{"name":"Carona","hex":"#fba52e","rgb":{"r":251,"g":165,"b":46},"luminance":122.64070679020077},{"name":"Carousel Pink","hex":"#f8dbe0","rgb":{"r":248,"g":219,"b":224},"luminance":150.58711833686175},{"name":"Carpaccio","hex":"#e34234","rgb":{"r":227,"g":66,"b":52},"luminance":78.37619458100781},{"name":"Carrageen Moss","hex":"#905d36","rgb":{"r":144,"g":93,"b":54},"luminance":69.79894521409331},{"name":"Carrara","hex":"#eeebe4","rgb":{"r":238,"g":235,"b":228},"luminance":157.37991400747427},{"name":"Carrara Marble","hex":"#e8e7d7","rgb":{"r":232,"g":231,"b":215},"luminance":154.2699125980176},{"name":"Carriage","hex":"#6c6358","rgb":{"r":108,"g":99,"b":88},"luminance":67.23492438457859},{"name":"Carroburg Crimson","hex":"#a82a70","rgb":{"r":168,"g":42,"b":112},"luminance":57.39421019580285},{"name":"Carrot","hex":"#fd6f3b","rgb":{"r":253,"g":111,"b":59},"luminance":100.0656900940577},{"name":"Carrot Cake","hex":"#bf6f31","rgb":{"r":191,"g":111,"b":49},"luminance":86.8220935361501},{"name":"Carrot Curl","hex":"#fe8c18","rgb":{"r":254,"g":140,"b":24},"luminance":111.9322697527393},{"name":"Carrot Flower","hex":"#cbd3c1","rgb":{"r":203,"g":211,"b":193},"luminance":139.6737994829381},{"name":"Carrot Orange","hex":"#ed9121","rgb":{"r":237,"g":145,"b":33},"luminance":110.81642765402609},{"name":"Carte Blanche","hex":"#eeeeff","rgb":{"r":238,"g":238,"b":255},"luminance":159.45802450801904},{"name":"Carter's Scroll","hex":"#405978","rgb":{"r":64,"g":89,"b":120},"luminance":57.2945018740891},{"name":"Cartwheel","hex":"#665537","rgb":{"r":102,"g":85,"b":55},"luminance":58.81285513389058},{"name":"Carved Wood","hex":"#937a62","rgb":{"r":147,"g":122,"b":98},"luminance":84.76582323672672},{"name":"Casa Talec","hex":"#c49ca5","rgb":{"r":196,"g":156,"b":165},"luminance":110.3343831269292},{"name":"Casa Verde","hex":"#abb790","rgb":{"r":171,"g":183,"b":144},"luminance":120.09550756793527},{"name":"Casablanca","hex":"#f0b253","rgb":{"r":240,"g":178,"b":83},"luminance":127.10763643463754},{"name":"Casal","hex":"#3f545a","rgb":{"r":63,"g":84,"b":90},"luminance":53.77154482623686},{"name":"Casandora Yellow","hex":"#fece5a","rgb":{"r":254,"g":206,"b":90},"luminance":143.16142147939158},{"name":"Cascade","hex":"#d4ede6","rgb":{"r":212,"g":237,"b":230},"luminance":155.11164722547434},{"name":"Cascade Tour","hex":"#697f8e","rgb":{"r":105,"g":127,"b":142},"luminance":82.49394383832063},{"name":"Cascading White","hex":"#f7f5f6","rgb":{"r":247,"g":245,"b":246},"luminance":164.08377668130387},{"name":"Cashew","hex":"#a47149","rgb":{"r":164,"g":113,"b":73},"luminance":82.90709584227396},{"name":"Cashew Cheese","hex":"#fcf9bd","rgb":{"r":252,"g":249,"b":189},"luminance":165.8468383449018},{"name":"Cashew Nut","hex":"#edccb3","rgb":{"r":237,"g":204,"b":179},"luminance":140.63268862181368},{"name":"Cashmere","hex":"#d1b399","rgb":{"r":209,"g":179,"b":153},"luminance":123.48960998399824},{"name":"Cashmere Blue","hex":"#a5b8d0","rgb":{"r":165,"g":184,"b":208},"luminance":121.08645354869387},{"name":"Cashmere Rose","hex":"#ce879f","rgb":{"r":206,"g":135,"b":159},"luminance":101.99089536326268},{"name":"Casket","hex":"#a49186","rgb":{"r":164,"g":145,"b":134},"luminance":99.41050596893669},{"name":"Casper","hex":"#aab5b8","rgb":{"r":170,"g":181,"b":184},"luminance":119.63321647853492},{"name":"Cassava Cake","hex":"#e7c084","rgb":{"r":231,"g":192,"b":132},"luminance":133.03819256514274},{"name":"Cassiopeia","hex":"#aed0c9","rgb":{"r":174,"g":208,"b":201},"luminance":134.68180756137778},{"name":"Castaway","hex":"#6dbac0","rgb":{"r":109,"g":186,"b":192},"luminance":116.02571675710517},{"name":"Castaway Cove","hex":"#7a9291","rgb":{"r":122,"g":146,"b":145},"luminance":94.59766481261575},{"name":"Castaway Lagoon","hex":"#607374","rgb":{"r":96,"g":115,"b":116},"luminance":74.53669443301064},{"name":"Castellan Green","hex":"#455440","rgb":{"r":69,"g":84,"b":64},"luminance":53.945793543148476},{"name":"Caster Sugar","hex":"#ffffe8","rgb":{"r":255,"g":255,"b":232},"luminance":170.05409713970434},{"name":"Casting Sea","hex":"#4586c7","rgb":{"r":69,"g":134,"b":199},"luminance":84.42377461947552},{"name":"Casting Shadow","hex":"#9da7a0","rgb":{"r":157,"g":167,"b":160},"luminance":110.20901818816823},{"name":"Castle In The Clouds","hex":"#efdcca","rgb":{"r":239,"g":220,"b":202},"luminance":149.3790577858891},{"name":"Castle in the Sky","hex":"#d1eaed","rgb":{"r":209,"g":234,"b":237},"luminance":153.30465605779887},{"name":"Castle Mist","hex":"#bdaeb7","rgb":{"r":189,"g":174,"b":183},"luminance":118.57861193739788},{"name":"Castle Moat","hex":"#8b6b47","rgb":{"r":139,"g":107,"b":71},"luminance":75.74826755774681},{"name":"Castle Stone","hex":"#525746","rgb":{"r":82,"g":87,"b":70},"luminance":57.20887592847809},{"name":"Castle Wall","hex":"#c8c1ab","rgb":{"r":200,"g":193,"b":171},"luminance":129.5797311194926},{"name":"Castlerock","hex":"#5f5e62","rgb":{"r":95,"g":94,"b":98},"luminance":63.05766640940655},{"name":"Castleton Green","hex":"#00564f","rgb":{"r":0,"g":86,"b":79},"luminance":51.27904406285281},{"name":"Castlevania Heart","hex":"#a80020","rgb":{"r":168,"g":0,"b":32},"luminance":50.36429020645481},{"name":"Castor Grey","hex":"#646762","rgb":{"r":100,"g":103,"b":98},"luminance":68.3692628671686},{"name":"Castro","hex":"#44232f","rgb":{"r":68,"g":35,"b":47},"luminance":29.397200768100355},{"name":"Casual Elegance","hex":"#dfd5c8","rgb":{"r":223,"g":213,"b":200},"luminance":143.52147327142373},{"name":"Cat Person","hex":"#636d70","rgb":{"r":99,"g":109,"b":112},"luminance":71.64541376808428},{"name":"Cat's Purr","hex":"#0071a0","rgb":{"r":0,"g":113,"b":160},"luminance":68.79316216747127},{"name":"Catachan Green","hex":"#475742","rgb":{"r":71,"g":87,"b":66},"luminance":55.81508557728815},{"name":"Catacomb Bone","hex":"#e2dccc","rgb":{"r":226,"g":220,"b":204},"luminance":147.59480550480086},{"name":"Catacomb Walls","hex":"#dbd7d0","rgb":{"r":219,"g":215,"b":208},"luminance":144.1447964027838},{"name":"Catalan","hex":"#429395","rgb":{"r":66,"g":147,"b":149},"luminance":90.13182830166045},{"name":"Catalina","hex":"#72a49f","rgb":{"r":114,"g":164,"b":159},"luminance":103.72046613855917},{"name":"Catalina Blue","hex":"#062a78","rgb":{"r":6,"g":42,"b":120},"luminance":28.252089338666618},{"name":"Catalina Green","hex":"#859475","rgb":{"r":133,"g":148,"b":117},"luminance":96.47152900726721},{"name":"Catalina Tile","hex":"#efac73","rgb":{"r":239,"g":172,"b":115},"luminance":124.38760355035384},{"name":"Catawba","hex":"#703642","rgb":{"r":112,"g":54,"b":66},"luminance":46.72065842857953},{"name":"Catawba Grape","hex":"#5d3c43","rgb":{"r":93,"g":60,"b":67},"luminance":45.5194100686729},{"name":"Catch The Wave","hex":"#b5dcd8","rgb":{"r":181,"g":220,"b":216},"luminance":142.17013447626752},{"name":"Caterpillar Green","hex":"#146b47","rgb":{"r":20,"g":107,"b":71},"luminance":63.61009131419322},{"name":"Cathay Spice","hex":"#99642c","rgb":{"r":153,"g":100,"b":44},"luminance":74.5898000064352},{"name":"Cathedral Glass","hex":"#7a999c","rgb":{"r":122,"g":153,"b":156},"luminance":98.55420265518867},{"name":"Cathedral Stone","hex":"#80796e","rgb":{"r":128,"g":121,"b":110},"luminance":81.65067245895774},{"name":"Cathode Green","hex":"#00ff55","rgb":{"r":0,"g":255,"b":85},"luminance":149.99831774056668},{"name":"Catmint","hex":"#c9a8ce","rgb":{"r":201,"g":168,"b":206},"luminance":117.84949517499004},{"name":"Catnap","hex":"#9fc3ac","rgb":{"r":159,"g":195,"b":172},"luminance":125.48647963027729},{"name":"Catnip","hex":"#80aa95","rgb":{"r":128,"g":170,"b":149},"luminance":108.21882590381398},{"name":"Catnip Wood","hex":"#6f6066","rgb":{"r":111,"g":96,"b":102},"luminance":66.42490503568672},{"name":"Catskill White","hex":"#e0e4dc","rgb":{"r":224,"g":228,"b":220},"luminance":151.74605718765807},{"name":"Cattail Red","hex":"#b64925","rgb":{"r":182,"g":73,"b":37},"luminance":69.39249562452702},{"name":"Caulerpa Lentillifera","hex":"#599c99","rgb":{"r":89,"g":156,"b":153},"luminance":96.94225017503976},{"name":"Caustic Green","hex":"#11dd00","rgb":{"r":17,"g":221,"b":0},"luminance":129.826543580271},{"name":"Cautious Blue","hex":"#d5dde5","rgb":{"r":213,"g":221,"b":229},"luminance":146.85588763818768},{"name":"Cautious Grey","hex":"#dfd8d9","rgb":{"r":223,"g":216,"b":217},"luminance":145.37538387567542},{"name":"Cautious Jade","hex":"#dae4de","rgb":{"r":218,"g":228,"b":222},"luminance":151.00087047431217},{"name":"Cavalry","hex":"#3f4c5a","rgb":{"r":63,"g":76,"b":90},"luminance":49.50081527611439},{"name":"Cavalry Brown","hex":"#990003","rgb":{"r":153,"g":0,"b":3},"luminance":45.74827836104873},{"name":"Cave Lake","hex":"#52b7c6","rgb":{"r":82,"g":183,"b":198},"luminance":112.4717686755214},{"name":"Cave of the Winds","hex":"#86736e","rgb":{"r":134,"g":115,"b":110},"luminance":79.49503746146672},{"name":"Cave Painting","hex":"#aa1100","rgb":{"r":170,"g":17,"b":0},"luminance":51.800283213511484},{"name":"Cave Pearl","hex":"#d6e5e2","rgb":{"r":214,"g":229,"b":226},"luminance":151.08783809757819},{"name":"Caveman","hex":"#625c58","rgb":{"r":98,"g":92,"b":88},"luminance":62.25496160146595},{"name":"Cavendish","hex":"#fed200","rgb":{"r":254,"g":210,"b":0},"luminance":144.78704298382505},{"name":"Cavern Moss","hex":"#92987d","rgb":{"r":146,"g":152,"b":125},"luminance":100.3476775615659},{"name":"Cavern Pink","hex":"#e0b8b1","rgb":{"r":224,"g":184,"b":177},"luminance":128.68047374796222},{"name":"Cavernous","hex":"#515252","rgb":{"r":81,"g":82,"b":82},"luminance":54.68845418367574},{"name":"Caviar","hex":"#292a2d","rgb":{"r":41,"g":42,"b":45},"luminance":28.007493586538587},{"name":"Caviar Couture","hex":"#772244","rgb":{"r":119,"g":34,"b":68},"luminance":41.52617041095891},{"name":"Cayenne","hex":"#941100","rgb":{"r":148,"g":17,"b":0},"luminance":45.363200339041335},{"name":"Cayman Green","hex":"#495a44","rgb":{"r":73,"g":90,"b":68},"luminance":57.6846628923148},{"name":"Ce Soir","hex":"#9271a7","rgb":{"r":146,"g":113,"b":167},"luminance":81.65732496843134},{"name":"Cedar","hex":"#463430","rgb":{"r":70,"g":52,"b":48},"luminance":37.41286222677971},{"name":"Cedar Chest","hex":"#c95a49","rgb":{"r":201,"g":90,"b":73},"luminance":80.4497009627755},{"name":"Cedar Green","hex":"#5e6737","rgb":{"r":94,"g":103,"b":55},"luminance":66.96859455744908},{"name":"Cedar Grove","hex":"#bf6955","rgb":{"r":191,"g":105,"b":85},"luminance":84.58254669847675},{"name":"Cedar Plank Salmon","hex":"#a96a50","rgb":{"r":169,"g":106,"b":80},"luminance":80.67300443766798},{"name":"Cedar Ridge","hex":"#9b6663","rgb":{"r":155,"g":102,"b":99},"luminance":76.55147743185627},{"name":"Cedar Staff","hex":"#91493e","rgb":{"r":145,"g":73,"b":62},"luminance":61.36628430987165},{"name":"Cedar Wood","hex":"#a1655b","rgb":{"r":161,"g":101,"b":91},"luminance":77.07095150573917},{"name":"Cedar Wood Finish","hex":"#711a00","rgb":{"r":113,"g":26,"b":0},"luminance":37.0741151344169},{"name":"Cedarville","hex":"#dda896","rgb":{"r":221,"g":168,"b":150},"luminance":119.93314678186343},{"name":"Ceil","hex":"#92a1cf","rgb":{"r":146,"g":161,"b":207},"luminance":106.74319823295534},{"name":"Celadon","hex":"#ace1af","rgb":{"r":172,"g":225,"b":175},"luminance":143.1315734176076},{"name":"Celadon Blue","hex":"#007ba7","rgb":{"r":0,"g":123,"b":167},"luminance":74.66880101488171},{"name":"Celadon Glaze","hex":"#ccd4cb","rgb":{"r":204,"g":212,"b":203},"luminance":140.5075560815147},{"name":"Celadon Green","hex":"#2f847c","rgb":{"r":47,"g":132,"b":124},"luminance":80.00677196962766},{"name":"Celadon Porcelain","hex":"#7ebea5","rgb":{"r":126,"g":190,"b":165},"luminance":119.21445917337375},{"name":"Celadon Sorbet","hex":"#b1dac6","rgb":{"r":177,"g":218,"b":198},"luminance":140.30551047268244},{"name":"Celadon Tint","hex":"#cbcebe","rgb":{"r":203,"g":206,"b":190},"luminance":137.02339761150282},{"name":"Celandine","hex":"#ebdf67","rgb":{"r":235,"g":223,"b":103},"luminance":149.03058944391248},{"name":"Celandine Green","hex":"#b8bfaf","rgb":{"r":184,"g":191,"b":175},"luminance":126.47127913087618},{"name":"Celery","hex":"#b4c04c","rgb":{"r":180,"g":192,"b":76},"luminance":125.19524316842073},{"name":"Celery Green","hex":"#c5cc7b","rgb":{"r":197,"g":204,"b":123},"luminance":134.1855558433917},{"name":"Celery Mousse","hex":"#c1fd95","rgb":{"r":193,"g":253,"b":149},"luminance":160.23151739280257},{"name":"Celery Satin","hex":"#d0d8be","rgb":{"r":208,"g":216,"b":190},"luminance":142.87481138395248},{"name":"Celery Sprig","hex":"#9ed686","rgb":{"r":158,"g":214,"b":134},"luminance":135.07421909454075},{"name":"Celery Stick","hex":"#caedd0","rgb":{"r":202,"g":237,"b":208},"luminance":153.50659109302114},{"name":"Celery Victor","hex":"#cceec2","rgb":{"r":204,"g":238,"b":194},"luminance":154.03699525763284},{"name":"Celeste","hex":"#b2ffff","rgb":{"r":178,"g":255,"b":255},"luminance":161.50308173220722},{"name":"Celestial","hex":"#006380","rgb":{"r":0,"g":99,"b":128},"luminance":59.917002870637646},{"name":"Celestial Blue","hex":"#2c4d69","rgb":{"r":44,"g":77,"b":105},"luminance":48.57273759013383},{"name":"Celestial Coral","hex":"#dd4455","rgb":{"r":221,"g":68,"b":85},"luminance":77.80499596426954},{"name":"Celestial Dragon","hex":"#992266","rgb":{"r":153,"g":34,"b":102},"luminance":51.247635623509495},{"name":"Celestial Green","hex":"#2ddfc1","rgb":{"r":45,"g":223,"b":193},"luminance":133.41737829083584},{"name":"Celestial Indigo","hex":"#091f92","rgb":{"r":9,"g":31,"b":146},"luminance":24.807156749615626},{"name":"Celestial Moon","hex":"#e3d4b9","rgb":{"r":227,"g":212,"b":185},"luminance":143.31029748416543},{"name":"Celestial Pink","hex":"#9c004a","rgb":{"r":156,"g":0,"b":74},"luminance":47.400726070388416},{"name":"Celestial Plum","hex":"#3c7ac2","rgb":{"r":60,"g":122,"b":194},"luminance":77.06832067717578},{"name":"Celestine","hex":"#85c1c4","rgb":{"r":133,"g":193,"b":196},"luminance":122.12910916730704},{"name":"Celestine Spring","hex":"#24a4c8","rgb":{"r":36,"g":164,"b":200},"luminance":99.51498138471413},{"name":"Celestra Grey","hex":"#99a7ab","rgb":{"r":153,"g":167,"b":171},"luminance":109.9203752086027},{"name":"Celestyn","hex":"#b5c7d2","rgb":{"r":181,"g":199,"b":210},"luminance":130.94757244790756},{"name":"Celine","hex":"#826167","rgb":{"r":130,"g":97,"b":103},"luminance":69.93426331205613},{"name":"Cellar Door","hex":"#75553f","rgb":{"r":117,"g":85,"b":63},"luminance":61.35880081944235},{"name":"Cello","hex":"#3a4e5f","rgb":{"r":58,"g":78,"b":95},"luminance":50.143710074145886},{"name":"Celluloid","hex":"#515153","rgb":{"r":81,"g":81,"b":83},"luminance":54.192311391930865},{"name":"Celosia Orange","hex":"#e8703a","rgb":{"r":232,"g":112,"b":58},"luminance":95.80141702501065},{"name":"Celtic","hex":"#2b3f36","rgb":{"r":43,"g":63,"b":54},"luminance":39.63323284820454},{"name":"Celtic Blue","hex":"#246bce","rgb":{"r":36,"g":107,"b":206},"luminance":67.91415487952419},{"name":"Celtic Clover","hex":"#006940","rgb":{"r":0,"g":105,"b":64},"luminance":62.06532720448672},{"name":"Celtic Green","hex":"#1f6954","rgb":{"r":31,"g":105,"b":84},"luminance":63.05939550931328},{"name":"Celtic Linen","hex":"#f5e5ce","rgb":{"r":245,"g":229,"b":206},"luminance":154.878456248763},{"name":"Celtic Rush","hex":"#2e4c5b","rgb":{"r":46,"g":76,"b":91},"luminance":47.822828607266636},{"name":"Celuce","hex":"#8bab68","rgb":{"r":139,"g":171,"b":104},"luminance":109.28597158830587},{"name":"Cembra Blossom","hex":"#725671","rgb":{"r":114,"g":86,"b":113},"luminance":62.25940606848093},{"name":"Cement","hex":"#a5a391","rgb":{"r":165,"g":163,"b":145},"luminance":108.91297850118691},{"name":"Cemetery Ash","hex":"#c0c7d0","rgb":{"r":192,"g":199,"b":208},"luminance":132.29971419848192},{"name":"Cendre Blue","hex":"#3e7fa5","rgb":{"r":62,"g":127,"b":165},"luminance":79.08872830561887},{"name":"Census","hex":"#327a68","rgb":{"r":50,"g":122,"b":104},"luminance":74.11229474250543},{"name":"Centaur","hex":"#90673f","rgb":{"r":144,"g":103,"b":63},"luminance":74.57166205067445},{"name":"Centaur Brown","hex":"#8b6a4f","rgb":{"r":139,"g":106,"b":79},"luminance":75.36578826629493},{"name":"Centennial Rose","hex":"#b3a7a6","rgb":{"r":179,"g":167,"b":166},"luminance":113.27974248734854},{"name":"Center Ridge","hex":"#817a69","rgb":{"r":129,"g":122,"b":105},"luminance":82.21659161629115},{"name":"Centipede Brown","hex":"#6d2400","rgb":{"r":109,"g":36,"b":0},"luminance":38.84243433411454},{"name":"Centra","hex":"#c08f45","rgb":{"r":192,"g":143,"b":69},"luminance":101.99825440172982},{"name":"Ceramic","hex":"#fcfff9","rgb":{"r":252,"g":255,"b":249},"luminance":169.96671828625745},{"name":"Ceramic Green","hex":"#3bb773","rgb":{"r":59,"g":183,"b":115},"luminance":109.64646926372048},{"name":"Ceramite White","hex":"#fefee0","rgb":{"r":254,"g":254,"b":224},"luminance":169.26339183651024},{"name":"Cereal Flake","hex":"#efd7ab","rgb":{"r":239,"g":215,"b":171},"luminance":146.33657294743512},{"name":"Cerebellum Grey","hex":"#cbcbcb","rgb":{"r":203,"g":203,"b":203},"luminance":135.7166971820343},{"name":"Cerebral Grey","hex":"#cccccc","rgb":{"r":204,"g":204,"b":204},"luminance":136.3852523405665},{"name":"Cerise","hex":"#a41247","rgb":{"r":164,"g":18,"b":71},"luminance":50.81025967262911},{"name":"Cerise Pink","hex":"#ec3b83","rgb":{"r":236,"g":59,"b":131},"luminance":80.01091888611204},{"name":"Cerise Red","hex":"#de3163","rgb":{"r":222,"g":49,"b":99},"luminance":73.21695738693326},{"name":"Cerulean","hex":"#55aaee","rgb":{"r":85,"g":170,"b":238},"luminance":106.48996078973829},{"name":"Cerulean Blue","hex":"#2a52be","rgb":{"r":42,"g":82,"b":190},"luminance":54.25625235859919},{"name":"Cerulean Frost","hex":"#6d9bc3","rgb":{"r":109,"g":155,"b":195},"luminance":99.1696344956459},{"name":"Cetacean Blue","hex":"#001440","rgb":{"r":0,"g":20,"b":64},"luminance":13.822417154752637},{"name":"Ceylanite","hex":"#33431e","rgb":{"r":51,"g":67,"b":30},"luminance":42.32019189465001},{"name":"Ceylon Yellow","hex":"#d4ae40","rgb":{"r":212,"g":174,"b":64},"luminance":120.43023376212469},{"name":"Ceylonese","hex":"#756858","rgb":{"r":117,"g":104,"b":88},"luminance":71.07256585349933},{"name":"CG Blue","hex":"#007aa5","rgb":{"r":0,"g":122,"b":165},"luminance":74.0431029603703},{"name":"CG Red","hex":"#e03c31","rgb":{"r":224,"g":60,"b":49},"luminance":75.87777258196236},{"name":"CGA Blue","hex":"#56ffff","rgb":{"r":86,"g":255,"b":255},"luminance":154.63464657378697},{"name":"CGA Pink","hex":"#fc0fc0","rgb":{"r":252,"g":15,"b":192},"luminance":78.95526374473079},{"name":"Chá Lǜ Green","hex":"#77926f","rgb":{"r":119,"g":146,"b":111},"luminance":93.65342535647055},{"name":"Chablis","hex":"#fde9e0","rgb":{"r":253,"g":233,"b":224},"luminance":158.36938576000097},{"name":"Chai Tea","hex":"#b1832f","rgb":{"r":177,"g":131,"b":47},"luminance":93.50241014006002},{"name":"Chai Tea Latte","hex":"#efd7b3","rgb":{"r":239,"g":215,"b":179},"luminance":146.4608527286387},{"name":"Chain Gang Grey","hex":"#708090","rgb":{"r":112,"g":128,"b":144},"luminance":83.88295235624459},{"name":"Chain Mail","hex":"#7b737b","rgb":{"r":123,"g":115,"b":123},"luminance":78.1414693872594},{"name":"Chainmail","hex":"#81777f","rgb":{"r":129,"g":119,"b":127},"luminance":81.09732507302569},{"name":"Chalcedony","hex":"#dddd99","rgb":{"r":221,"g":221,"b":153},"luminance":146.627937767671},{"name":"Chalet","hex":"#c29867","rgb":{"r":194,"g":152,"b":103},"luminance":107.06770183393309},{"name":"Chalet Green","hex":"#5a6e41","rgb":{"r":90,"g":110,"b":65},"luminance":70.3444461205005},{"name":"Chalk Blue","hex":"#ccdad7","rgb":{"r":204,"g":218,"b":215},"luminance":143.8629530907801},{"name":"Chalk Pink","hex":"#e6c5ca","rgb":{"r":230,"g":197,"b":202},"luminance":136.49901100374316},{"name":"Chalk Violet","hex":"#8f7da5","rgb":{"r":143,"g":125,"b":165},"luminance":86.98199683842628},{"name":"Chalkware","hex":"#e0ceb7","rgb":{"r":224,"g":206,"b":183},"luminance":139.7967728669013},{"name":"Chalky","hex":"#dfc281","rgb":{"r":223,"g":194,"b":129},"luminance":132.77909341835408},{"name":"Challah Bread","hex":"#cd7a50","rgb":{"r":205,"g":122,"b":80},"luminance":94.70383530248391},{"name":"Chambray","hex":"#475877","rgb":{"r":71,"g":88,"b":119},"luminance":57.47215963403498},{"name":"Chambray Blue","hex":"#9eb4d3","rgb":{"r":158,"g":180,"b":211},"luminance":118.21352325347551},{"name":"Chameleon Tango","hex":"#c0c2a0","rgb":{"r":192,"g":194,"b":160},"luminance":128.82769480201065},{"name":"Chamois","hex":"#e8cd9a","rgb":{"r":232,"g":205,"b":154},"luminance":140.00230278463278},{"name":"Chamoisee","hex":"#a0785a","rgb":{"r":160,"g":120,"b":90},"luminance":85.76553386996433},{"name":"Chamomile","hex":"#e8d0a7","rgb":{"r":232,"g":208,"b":167},"luminance":141.71026103991198},{"name":"Chamomile Tea","hex":"#dac395","rgb":{"r":218,"g":195,"b":149},"luminance":132.81360451776013},{"name":"Champagne","hex":"#e9d2ac","rgb":{"r":233,"g":210,"b":172},"luminance":142.94564509980708},{"name":"Champagne Bliss","hex":"#f0e1c5","rgb":{"r":240,"g":225,"b":197},"luminance":151.97915971935097},{"name":"Champagne Bubbles","hex":"#ddcead","rgb":{"r":221,"g":206,"b":173},"luminance":139.203166662975},{"name":"Champagne Burst","hex":"#f1e4cb","rgb":{"r":241,"g":228,"b":203},"luminance":153.75346025699713},{"name":"Champagne Ice","hex":"#f3e5dd","rgb":{"r":243,"g":229,"b":221},"luminance":154.86549071371581},{"name":"Champagne Pink","hex":"#f1ddcf","rgb":{"r":241,"g":221,"b":207},"luminance":150.26130444662058},{"name":"Champignon","hex":"#949089","rgb":{"r":148,"g":144,"b":137},"luminance":96.68062997312336},{"name":"Champion","hex":"#7b5986","rgb":{"r":123,"g":89,"b":134},"luminance":65.69044796619977},{"name":"Champion Blue","hex":"#606788","rgb":{"r":96,"g":103,"b":136},"luminance":68.70099091716217},{"name":"Chandra Cream","hex":"#ecba5d","rgb":{"r":236,"g":186,"b":93},"luminance":130.43155148966065},{"name":"Changeling Pink","hex":"#f4afcd","rgb":{"r":244,"g":175,"b":205},"luminance":128.14507583594462},{"name":"Channel","hex":"#f1c3c2","rgb":{"r":241,"g":195,"b":194},"luminance":137.0541978999549},{"name":"Channel Marker Green","hex":"#04d8b2","rgb":{"r":4,"g":216,"b":178},"luminance":128.41108575197077},{"name":"Chanterelle","hex":"#daa520","rgb":{"r":218,"g":165,"b":32},"luminance":116.80279128942081},{"name":"Chanterelle Sauce","hex":"#a28776","rgb":{"r":162,"g":135,"b":118},"luminance":93.84543767813115},{"name":"Chanterelles","hex":"#ffc66e","rgb":{"r":255,"g":198,"b":110},"luminance":139.5673124374042},{"name":"Chantilly","hex":"#edb8c7","rgb":{"r":237,"g":184,"b":199},"luminance":131.1561947793546},{"name":"Chantilly Lace","hex":"#f1e2de","rgb":{"r":241,"g":226,"b":222},"luminance":153.07580014162917},{"name":"Chaos Black","hex":"#0f0f0f","rgb":{"r":15,"g":15,"b":15},"luminance":10.02832737798283},{"name":"Chaotic Red","hex":"#740600","rgb":{"r":116,"g":6,"b":0},"luminance":34.86236280001687},{"name":"Chaparral","hex":"#e5d0b0","rgb":{"r":229,"g":208,"b":176},"luminance":141.41525785077081},{"name":"Chapel Wall","hex":"#ede2ac","rgb":{"r":237,"g":226,"b":172},"luminance":151.67479908343378},{"name":"Chaps","hex":"#644b41","rgb":{"r":100,"g":75,"b":65},"luminance":53.73191532971815},{"name":"Chapter","hex":"#9f9369","rgb":{"r":159,"g":147,"b":105},"luminance":99.24323202113078},{"name":"Charade","hex":"#394043","rgb":{"r":57,"g":64,"b":67},"luminance":41.95423121688681},{"name":"Charadon Granite","hex":"#504d4c","rgb":{"r":80,"g":77,"b":76},"luminance":51.86695380490356},{"name":"Charcoal","hex":"#343837","rgb":{"r":52,"g":56,"b":55},"luminance":36.90015701863611},{"name":"Charcoal Blue","hex":"#67778a","rgb":{"r":103,"g":119,"b":138},"luminance":77.94480509950614},{"name":"Charcoal Briquette","hex":"#5d625c","rgb":{"r":93,"g":98,"b":92},"luminance":64.74927079898275},{"name":"Charcoal Dust","hex":"#9497b3","rgb":{"r":148,"g":151,"b":179},"luminance":101.1492071595225},{"name":"Charcoal Grey","hex":"#6e6969","rgb":{"r":110,"g":105,"b":105},"luminance":70.87951907991476},{"name":"Charcoal Light","hex":"#726e68","rgb":{"r":114,"g":110,"b":104},"luminance":73.97097425341916},{"name":"Charcoal Sketch","hex":"#5d5b56","rgb":{"r":93,"g":91,"b":86},"luminance":61.014125856231026},{"name":"Charcoal Smoke","hex":"#474f43","rgb":{"r":71,"g":79,"b":67},"luminance":51.569997227069926},{"name":"Charcoal Smudge","hex":"#60605e","rgb":{"r":96,"g":96,"b":94},"luminance":64.14281078967463},{"name":"Chardon","hex":"#f8eadf","rgb":{"r":248,"g":234,"b":223},"luminance":158.15188064642166},{"name":"Chardonnay","hex":"#efe8bc","rgb":{"r":239,"g":232,"b":188},"luminance":155.2806716916178},{"name":"Charisma","hex":"#632a60","rgb":{"r":99,"g":42,"b":96},"luminance":40.047597343660954},{"name":"Charismatic Red","hex":"#ee2244","rgb":{"r":238,"g":34,"b":68},"luminance":74.31315840414804},{"name":"Charleston Cherry","hex":"#9f414b","rgb":{"r":159,"g":65,"b":75},"luminance":61.55528576816129},{"name":"Charleston Chocolate","hex":"#c09278","rgb":{"r":192,"g":146,"b":120},"luminance":104.05601216652501},{"name":"Charleston Green","hex":"#232b2b","rgb":{"r":35,"g":43,"b":43},"luminance":27.760653990855474},{"name":"Charlie Brown","hex":"#995500","rgb":{"r":153,"g":85,"b":0},"luminance":67.69268080080741},{"name":"Charlie Horse","hex":"#948263","rgb":{"r":148,"g":130,"b":99},"luminance":88.93159955831223},{"name":"Charlock","hex":"#e5e790","rgb":{"r":229,"g":231,"b":144},"luminance":152.78844624512678},{"name":"Charlotte","hex":"#a4dce6","rgb":{"r":164,"g":220,"b":230},"luminance":140.6028353056936},{"name":"Charm","hex":"#d0748b","rgb":{"r":208,"g":116,"b":139},"luminance":93.57062062421089},{"name":"Charm Pink","hex":"#e68fac","rgb":{"r":230,"g":143,"b":172},"luminance":110.27183704373476},{"name":"Charmed Green","hex":"#007f3a","rgb":{"r":0,"g":127,"b":58},"luminance":74.84164579296743},{"name":"Charming","hex":"#d4e092","rgb":{"r":212,"g":224,"b":146},"luminance":146.9154703358363},{"name":"Charming Cherry","hex":"#ff90a2","rgb":{"r":255,"g":144,"b":162},"luminance":115.32280708081987},{"name":"Charolais Cattle","hex":"#f1ebea","rgb":{"r":241,"g":235,"b":234},"luminance":157.90165129598867},{"name":"Charred Brown","hex":"#3e0007","rgb":{"r":62,"g":0,"b":7},"luminance":18.555167689891675},{"name":"Charred Chocolate","hex":"#553b3d","rgb":{"r":85,"g":59,"b":61},"luminance":43.51695106507348},{"name":"Charred Clay","hex":"#885132","rgb":{"r":136,"g":81,"b":50},"luminance":62.82330861232955},{"name":"Charter","hex":"#69b2cf","rgb":{"r":105,"g":178,"b":207},"luminance":111.62363470609617},{"name":"Chartreuse","hex":"#c1f80a","rgb":{"r":193,"g":248,"b":10},"luminance":156.60066802220226},{"name":"Chartreuse Shot","hex":"#dad000","rgb":{"r":218,"g":208,"b":0},"luminance":138.40565862709516},{"name":"Chasm Green","hex":"#63b521","rgb":{"r":99,"g":181,"b":33},"luminance":110.3575863001724},{"name":"Chaste Blossoms","hex":"#9944ee","rgb":{"r":153,"g":68,"b":238},"luminance":66.49977811241178},{"name":"Chat Orange","hex":"#f79a3e","rgb":{"r":247,"g":154,"b":62},"luminance":116.9445194825307},{"name":"Chateau de Chillon","hex":"#a2aab3","rgb":{"r":162,"g":170,"b":179},"luminance":112.78603096128526},{"name":"Chateau Green","hex":"#419f59","rgb":{"r":65,"g":159,"b":89},"luminance":95.8734031418516},{"name":"Chateau Grey","hex":"#bbb1a8","rgb":{"r":187,"g":177,"b":168},"luminance":119.53269374526786},{"name":"Chateau Rose","hex":"#dba3ce","rgb":{"r":219,"g":163,"b":206},"luminance":118.2967175284251},{"name":"Chatelle","hex":"#b3abb6","rgb":{"r":179,"g":171,"b":182},"luminance":115.63096070689718},{"name":"Chathams Blue","hex":"#2c5971","rgb":{"r":44,"g":89,"b":113},"luminance":55.39275502265616},{"name":"Chatty Cricket","hex":"#89b386","rgb":{"r":137,"g":179,"b":134},"luminance":113.80535520791628},{"name":"Che Guevara Red","hex":"#ed214d","rgb":{"r":237,"g":33,"b":77},"luminance":73.98549651114061},{"name":"Cheater","hex":"#eeb15d","rgb":{"r":238,"g":177,"b":93},"luminance":126.37814229129971},{"name":"Cheddar Biscuit","hex":"#d2ad87","rgb":{"r":210,"g":173,"b":135},"luminance":120.38289662987845},{"name":"Cheddar Chunk","hex":"#f9c982","rgb":{"r":249,"g":201,"b":130},"luminance":140.2979542616356},{"name":"Cheerful Heart","hex":"#dcc7c0","rgb":{"r":220,"g":199,"b":192},"luminance":135.83581969789853},{"name":"Cheers!","hex":"#c09962","rgb":{"r":192,"g":153,"b":98},"luminance":107.17512663393498},{"name":"Cheese","hex":"#ffa600","rgb":{"r":255,"g":166,"b":0},"luminance":123.72648620647075},{"name":"Cheese Please","hex":"#ff9613","rgb":{"r":255,"g":150,"b":19},"luminance":116.49375125301785},{"name":"Cheesecake","hex":"#fffcda","rgb":{"r":255,"g":252,"b":218},"luminance":168.26298376351227},{"name":"Cheesus","hex":"#ffcc77","rgb":{"r":255,"g":204,"b":119},"luminance":142.60757302822316},{"name":"Cheesy Grin","hex":"#fae195","rgb":{"r":250,"g":225,"b":149},"luminance":152.70852078715188},{"name":"Chefchaouen Blue","hex":"#a3d1e8","rgb":{"r":163,"g":209,"b":232},"luminance":134.63250113549847},{"name":"Chelsea Cucumber","hex":"#88a95b","rgb":{"r":136,"g":169,"b":91},"luminance":107.71451146897525},{"name":"Chelsea Gem","hex":"#95532f","rgb":{"r":149,"g":83,"b":47},"luminance":66.23621068569668},{"name":"Chéng Hóng Sè Orange","hex":"#f94009","rgb":{"r":249,"g":64,"b":9},"luminance":83.39879316273107},{"name":"Chenille","hex":"#a6cd91","rgb":{"r":166,"g":205,"b":145},"luminance":131.2146603127867},{"name":"Chenin","hex":"#dec371","rgb":{"r":222,"g":195,"b":113},"luminance":132.9444283638844},{"name":"Chernobog","hex":"#ac0132","rgb":{"r":172,"g":1,"b":50},"luminance":51.74624385402287},{"name":"Chernobog Breath","hex":"#e3dcda","rgb":{"r":227,"g":220,"b":218},"luminance":147.9915728445373},{"name":"Cherokee","hex":"#f5cd82","rgb":{"r":245,"g":205,"b":130},"luminance":141.65606111282355},{"name":"Cherokee Red","hex":"#824e4a","rgb":{"r":130,"g":78,"b":74},"luminance":60.64982103848287},{"name":"Cherries Jubilee","hex":"#a22452","rgb":{"r":162,"g":36,"b":82},"luminance":53.667367850491786},{"name":"Cherry","hex":"#cf0234","rgb":{"r":207,"g":2,"b":52},"luminance":62.18732112738094},{"name":"Cherry Bark","hex":"#908279","rgb":{"r":144,"g":130,"b":121},"luminance":88.6978560733009},{"name":"Cherry Berry","hex":"#9f4d65","rgb":{"r":159,"g":77,"b":101},"luminance":66.60081439442013},{"name":"Cherry Blossom","hex":"#f7cee0","rgb":{"r":247,"g":206,"b":224},"luminance":143.97389690148697},{"name":"Cherry Blossom Pink","hex":"#ffb7c5","rgb":{"r":255,"g":183,"b":197},"luminance":133.62983585262685},{"name":"Cherry Blush","hex":"#ffc9dd","rgb":{"r":255,"g":201,"b":221},"luminance":142.71989990887747},{"name":"Cherry Bomb","hex":"#b73d3f","rgb":{"r":183,"g":61,"b":63},"luminance":65.78504740440641},{"name":"Cherry Brandy","hex":"#e26b81","rgb":{"r":226,"g":107,"b":129},"luminance":93.42099546140578},{"name":"Cherry Chip","hex":"#ffbbb4","rgb":{"r":255,"g":187,"b":180},"luminance":135.21687685344605},{"name":"Cherry Cocoa","hex":"#8e5e65","rgb":{"r":142,"g":94,"b":101},"luminance":70.56816310490163},{"name":"Cherry Cola","hex":"#894c3b","rgb":{"r":137,"g":76,"b":59},"luminance":60.93797657454668},{"name":"Cherry Cordial","hex":"#ebbed3","rgb":{"r":235,"g":190,"b":211},"luminance":133.99517170778952},{"name":"Cherry Flower","hex":"#fbdae8","rgb":{"r":251,"g":218,"b":232},"luminance":150.68890556706555},{"name":"Cherry Foam","hex":"#f392a0","rgb":{"r":243,"g":146,"b":160},"luminance":113.82693026257012},{"name":"Cherry Hill","hex":"#cc5160","rgb":{"r":204,"g":81,"b":96},"luminance":78.10890065159028},{"name":"Cherry Lolly","hex":"#c8385a","rgb":{"r":200,"g":56,"b":90},"luminance":69.00634741819044},{"name":"Cherry Mahogany","hex":"#66352b","rgb":{"r":102,"g":53,"b":43},"luminance":43.84121267711466},{"name":"Cherry On Top","hex":"#ac495c","rgb":{"r":172,"g":73,"b":92},"luminance":67.75725443817805},{"name":"Cherry Pearl","hex":"#f9e7f4","rgb":{"r":249,"g":231,"b":244},"luminance":157.1726046930571},{"name":"Cherry Pie","hex":"#372d52","rgb":{"r":55,"g":45,"b":82},"luminance":32.4896191728989},{"name":"Cherry Pink","hex":"#c7607b","rgb":{"r":199,"g":96,"b":123},"luminance":83.14164653770095},{"name":"Cherry Plum","hex":"#a10047","rgb":{"r":161,"g":0,"b":71},"luminance":48.81471250555512},{"name":"Cherry Race","hex":"#a64137","rgb":{"r":166,"g":65,"b":55},"luminance":62.9178105229354},{"name":"Cherry Red","hex":"#f7022a","rgb":{"r":247,"g":2,"b":42},"luminance":74.01735491761374},{"name":"Cherry Tomato","hex":"#f2013f","rgb":{"r":242,"g":1,"b":63},"luminance":72.71592574532762},{"name":"Cherry Tree","hex":"#dfb7b4","rgb":{"r":223,"g":183,"b":180},"luminance":128.08654874732161},{"name":"Cherrywood","hex":"#651a14","rgb":{"r":101,"g":26,"b":20},"luminance":33.91322227391552},{"name":"Chert","hex":"#848182","rgb":{"r":132,"g":129,"b":130},"luminance":86.66791882236471},{"name":"Cherub","hex":"#f5d7dc","rgb":{"r":245,"g":215,"b":220},"luminance":148.06418692580593},{"name":"Cherubic","hex":"#ffe6f1","rgb":{"r":255,"g":230,"b":241},"luminance":157.4668879510864},{"name":"Chess Ivory","hex":"#ffe9c5","rgb":{"r":255,"g":233,"b":197},"luminance":158.18965904887713},{"name":"Chester Brown","hex":"#876b4b","rgb":{"r":135,"g":107,"b":75},"luminance":75.14922625017506},{"name":"Chestnut","hex":"#742802","rgb":{"r":116,"g":40,"b":2},"luminance":41.88486886693093},{"name":"Chestnut Brown","hex":"#6d1008","rgb":{"r":109,"g":16,"b":8},"luminance":33.929554801087505},{"name":"Chestnut Gold","hex":"#ab8508","rgb":{"r":171,"g":133,"b":8},"luminance":93.32784914482922},{"name":"Chestnut Leather","hex":"#60281e","rgb":{"r":96,"g":40,"b":30},"luminance":37.241460981008785},{"name":"Chestnut Peel","hex":"#6d3c32","rgb":{"r":109,"g":60,"b":50},"luminance":48.3229932951178},{"name":"Chestnut Plum","hex":"#852e19","rgb":{"r":133,"g":46,"b":25},"luminance":48.152308283196554},{"name":"Chestnut Rose","hex":"#cd5252","rgb":{"r":205,"g":82,"b":82},"luminance":78.49422962868034},{"name":"Chestnut Shell","hex":"#adff2f","rgb":{"r":173,"g":255,"b":47},"luminance":158.4613199427545},{"name":"Chesty Bond","hex":"#516fa0","rgb":{"r":81,"g":111,"b":160},"luminance":71.86579304509205},{"name":"Chetwode Blue","hex":"#666fb4","rgb":{"r":102,"g":111,"b":180},"luminance":74.81064799211406},{"name":"Chewing Gum","hex":"#e6b0af","rgb":{"r":230,"g":176,"b":175},"luminance":125.70077463564017},{"name":"Chewy Caramel","hex":"#977043","rgb":{"r":151,"g":112,"b":67},"luminance":80.11894146205378},{"name":"Chi-Gong","hex":"#d52b2d","rgb":{"r":213,"g":43,"b":45},"luminance":68.69831839281075},{"name":"Chic Brick","hex":"#a4725a","rgb":{"r":164,"g":114,"b":90},"luminance":83.59315534181012},{"name":"Chic Green","hex":"#d8ebd6","rgb":{"r":216,"g":235,"b":214},"luminance":154.2565424771345},{"name":"Chic Peach","hex":"#f0d1c8","rgb":{"r":240,"g":209,"b":200},"luminance":143.94601796854263},{"name":"Chicago","hex":"#5b5d56","rgb":{"r":91,"g":93,"b":86},"luminance":61.77884247863502},{"name":"Chicago Blue","hex":"#b6dbe9","rgb":{"r":182,"g":219,"b":233},"luminance":142.1011343269293},{"name":"Chicha Morada","hex":"#7e6072","rgb":{"r":126,"g":96,"b":114},"luminance":69.02009994197343},{"name":"Chickadee","hex":"#ffcf65","rgb":{"r":255,"g":207,"b":101},"luminance":143.91076854078707},{"name":"Chicken Comb","hex":"#dd2222","rgb":{"r":221,"g":34,"b":34},"luminance":69.13594854343144},{"name":"Chicken Masala","hex":"#cc8822","rgb":{"r":204,"g":136,"b":34},"luminance":100.54194953351559},{"name":"Chickpea","hex":"#efe7df","rgb":{"r":239,"g":231,"b":223},"luminance":155.36891263698797},{"name":"Chickweed","hex":"#d9dfe3","rgb":{"r":217,"g":223,"b":227},"luminance":148.3729974557365},{"name":"Chicon","hex":"#d9eeb4","rgb":{"r":217,"g":238,"b":180},"luminance":155.3983285785275},{"name":"Chicory","hex":"#a78658","rgb":{"r":167,"g":134,"b":88},"luminance":93.70713140951439},{"name":"Chicory Coffee","hex":"#4a342e","rgb":{"r":74,"g":52,"b":46},"luminance":38.06276379875744},{"name":"Chicory Flower","hex":"#66789a","rgb":{"r":102,"g":120,"b":154},"luminance":78.74093433532524},{"name":"Chieftain","hex":"#6a5637","rgb":{"r":106,"g":86,"b":55},"luminance":59.935422414462046},{"name":"Chiffon","hex":"#f0f5bb","rgb":{"r":240,"g":245,"b":187},"luminance":162.13176415804523},{"name":"Chifle Yellow","hex":"#dbc963","rgb":{"r":219,"g":201,"b":99},"luminance":135.41073563791016},{"name":"Child of Heaven","hex":"#eae5c5","rgb":{"r":234,"g":229,"b":197},"luminance":153.19642896947695},{"name":"Chilean Fire","hex":"#d05e34","rgb":{"r":208,"g":94,"b":52},"luminance":83.35225091141811},{"name":"Chilean Heath","hex":"#f9f7de","rgb":{"r":249,"g":247,"b":222},"luminance":164.94016001568568},{"name":"Chili","hex":"#be5141","rgb":{"r":190,"g":81,"b":65},"luminance":74.45133584429496},{"name":"Chili Con Carne","hex":"#985e2b","rgb":{"r":152,"g":94,"b":43},"luminance":71.65306687086046},{"name":"Chili Oil","hex":"#8e3c36","rgb":{"r":142,"g":60,"b":54},"luminance":55.50699505467757},{"name":"Chili Pepper","hex":"#9b1b30","rgb":{"r":155,"g":27,"b":48},"luminance":49.28481114907512},{"name":"Chili Sauce","hex":"#bc4e40","rgb":{"r":188,"g":78,"b":64},"luminance":72.86548123768894},{"name":"Chili Soda","hex":"#ca7c74","rgb":{"r":202,"g":124,"b":116},"luminance":95.50332729282262},{"name":"Chill in the Air","hex":"#d1d5e7","rgb":{"r":209,"g":213,"b":231},"luminance":142.23696987070554},{"name":"Chilled Mint","hex":"#e4efde","rgb":{"r":228,"g":239,"b":222},"luminance":158.01912003615257},{"name":"Chilled Wine","hex":"#6d4052","rgb":{"r":109,"g":64,"b":82},"luminance":50.60546422077363},{"name":"Chilli Cashew","hex":"#cc5544","rgb":{"r":204,"g":85,"b":68},"luminance":79.18406749466713},{"name":"Chilly Spice","hex":"#fd9989","rgb":{"r":253,"g":153,"b":137},"luminance":118.45845792513086},{"name":"Chimera","hex":"#74626d","rgb":{"r":116,"g":98,"b":109},"luminance":68.31270751478087},{"name":"Chimera Brown","hex":"#c89b75","rgb":{"r":200,"g":155,"b":117},"luminance":109.69144209554362},{"name":"Chimes","hex":"#c7ca86","rgb":{"r":199,"g":202,"b":134},"luminance":133.54219802369587},{"name":"Chimney Sweep","hex":"#272f38","rgb":{"r":39,"g":47,"b":56},"luminance":30.624945681584478},{"name":"Chin-Chin Cherry","hex":"#dd3355","rgb":{"r":221,"g":51,"b":85},"luminance":73.18848481831003},{"name":"China Blue","hex":"#546477","rgb":{"r":84,"g":100,"b":119},"luminance":65.27281066416552},{"name":"China Clay","hex":"#718b9a","rgb":{"r":113,"g":139,"b":154},"luminance":90.03994754552004},{"name":"China Doll","hex":"#f3e4d5","rgb":{"r":243,"g":228,"b":213},"luminance":154.21001935347778},{"name":"China Ivory","hex":"#fbf3d3","rgb":{"r":251,"g":243,"b":211},"luminance":162.96442003701299},{"name":"China Pink","hex":"#df6ea1","rgb":{"r":223,"g":110,"b":161},"luminance":94.6148854303592},{"name":"China Rose","hex":"#a8516e","rgb":{"r":168,"g":81,"b":110},"luminance":70.2938306894709},{"name":"China Seas","hex":"#034f7c","rgb":{"r":3,"g":79,"b":124},"luminance":48.488000928064665},{"name":"China Silk","hex":"#e3d1cc","rgb":{"r":227,"g":209,"b":204},"luminance":142.12214519208467},{"name":"China White","hex":"#eae6d9","rgb":{"r":234,"g":230,"b":217},"luminance":154.0613835456504},{"name":"Chinaberry","hex":"#464960","rgb":{"r":70,"g":73,"b":96},"luminance":48.92897134622799},{"name":"Chinchilla","hex":"#9c8e7b","rgb":{"r":156,"g":142,"b":123},"luminance":96.5410199656084},{"name":"Chinchilla Chenille","hex":"#d0bba7","rgb":{"r":208,"g":187,"b":167},"luminance":127.59123664656597},{"name":"Chinese Bellflower","hex":"#4d5aaf","rgb":{"r":77,"g":90,"b":175},"luminance":60.9841776938904},{"name":"Chinese Black","hex":"#111100","rgb":{"r":17,"g":17,"b":0},"luminance":11.198987900698883},{"name":"Chinese Blue","hex":"#365194","rgb":{"r":54,"g":81,"b":148},"luminance":52.972397614229244},{"name":"Chinese Bronze","hex":"#cd8032","rgb":{"r":205,"g":128,"b":50},"luminance":97.13385362992656},{"name":"Chinese Brown","hex":"#ab381f","rgb":{"r":171,"g":56,"b":31},"luminance":60.887044442968325},{"name":"Chinese Dragon","hex":"#cb5251","rgb":{"r":203,"g":82,"b":81},"luminance":78.01457890035682},{"name":"Chinese Garden","hex":"#006967","rgb":{"r":0,"g":105,"b":103},"luminance":62.74350794305336},{"name":"Chinese Gold","hex":"#ddaa00","rgb":{"r":221,"g":170,"b":0},"luminance":119.6849127542816},{"name":"Chinese Goldfish","hex":"#f34723","rgb":{"r":243,"g":71,"b":35},"luminance":83.85661618500951},{"name":"Chinese Green","hex":"#d0db61","rgb":{"r":208,"g":219,"b":97},"luminance":143.2340673059311},{"name":"Chinese Hamster","hex":"#ebdbca","rgb":{"r":235,"g":219,"b":202},"luminance":148.30149297292996},{"name":"Chinese Ibis Brown","hex":"#e09e87","rgb":{"r":224,"g":158,"b":135},"luminance":115.43161261976721},{"name":"Chinese Ink","hex":"#3f312b","rgb":{"r":63,"g":49,"b":43},"luminance":34.72999196659855},{"name":"Chinese Lacquer","hex":"#60c7c2","rgb":{"r":96,"g":199,"b":194},"luminance":122.30418652278424},{"name":"Chinese Lantern","hex":"#f09056","rgb":{"r":240,"g":144,"b":86},"luminance":111.31306661843432},{"name":"Chinese Leaf","hex":"#ccd6b0","rgb":{"r":204,"g":214,"b":176},"luminance":141.077843887692},{"name":"Chinese Money Plant","hex":"#a4be5c","rgb":{"r":164,"g":190,"b":92},"luminance":122.28437488084893},{"name":"Chinese Night","hex":"#aa381e","rgb":{"r":170,"g":56,"b":30},"luminance":60.62964360772706},{"name":"Chinese Orange","hex":"#f37042","rgb":{"r":243,"g":112,"b":66},"luminance":98.2747361278574},{"name":"Chinese Pink","hex":"#de70a1","rgb":{"r":222,"g":112,"b":161},"luminance":95.2112479489687},{"name":"Chinese Porcelain","hex":"#3a5f7d","rgb":{"r":58,"g":95,"b":125},"luminance":60.112749804014115},{"name":"Chinese Purple","hex":"#720b98","rgb":{"r":114,"g":11,"b":152},"luminance":38.778961164528376},{"name":"Chinese Red","hex":"#cd071e","rgb":{"r":205,"g":7,"b":30},"luminance":61.52769543872092},{"name":"Chinese Safflower","hex":"#b94047","rgb":{"r":185,"g":64,"b":71},"luminance":67.35441102852877},{"name":"Chinese Silver","hex":"#dddcef","rgb":{"r":221,"g":220,"b":239},"luminance":147.60053643872706},{"name":"Chinese Tzu","hex":"#8fbfbd","rgb":{"r":143,"g":191,"b":189},"luminance":121.91231625229668},{"name":"Chinese Violet","hex":"#835e81","rgb":{"r":131,"g":94,"b":129},"luminance":69.24657883967987},{"name":"Chinese White","hex":"#e2e5de","rgb":{"r":226,"g":229,"b":222},"luminance":152.56566871023114},{"name":"Chinese Yellow","hex":"#ffb200","rgb":{"r":255,"g":178,"b":0},"luminance":129.3469142306843},{"name":"Chino","hex":"#b8ad8a","rgb":{"r":184,"g":173,"b":138},"luminance":116.5626942078811},{"name":"Chino Green","hex":"#d9caa5","rgb":{"r":217,"g":202,"b":165},"luminance":136.46762716849736},{"name":"Chinois Green","hex":"#7c8c87","rgb":{"r":124,"g":140,"b":135},"luminance":91.4605613147},{"name":"Chinook","hex":"#9dd3a8","rgb":{"r":157,"g":211,"b":168},"luminance":133.83198721531411},{"name":"Chinook Salmon","hex":"#c8987e","rgb":{"r":200,"g":152,"b":126},"luminance":108.36644624605901},{"name":"Chinotto","hex":"#554747","rgb":{"r":85,"g":71,"b":71},"luminance":49.48138427732191},{"name":"Chintz","hex":"#d5c7b9","rgb":{"r":213,"g":199,"b":185},"luminance":134.7074572471769},{"name":"Chintz Rose","hex":"#eec4be","rgb":{"r":238,"g":196,"b":190},"luminance":137.004191716896},{"name":"Chipmunk","hex":"#cfa14a","rgb":{"r":207,"g":161,"b":74},"luminance":113.28496190580637},{"name":"Chipolata","hex":"#aa4433","rgb":{"r":170,"g":68,"b":51},"luminance":64.89051203373263},{"name":"Chips Provencale","hex":"#ddd618","rgb":{"r":221,"g":214,"b":24},"luminance":141.96408651838675},{"name":"Chitin Green","hex":"#026b67","rgb":{"r":2,"g":107,"b":103},"luminance":63.89994248041229},{"name":"Chive","hex":"#4a5335","rgb":{"r":74,"g":83,"b":53},"luminance":53.84980483715795},{"name":"Chive Bloom","hex":"#4f3650","rgb":{"r":79,"g":54,"b":80},"luminance":40.569560571936194},{"name":"Chive Blossom","hex":"#7d5d99","rgb":{"r":125,"g":93,"b":153},"luminance":68.41996251095144},{"name":"Chive Flower","hex":"#a193bf","rgb":{"r":161,"g":147,"b":191},"luminance":101.17935519660125},{"name":"Chlorella Green","hex":"#56ae57","rgb":{"r":86,"g":174,"b":87},"luminance":105.7910561626076},{"name":"Chloride","hex":"#93d8c2","rgb":{"r":147,"g":216,"b":194},"luminance":136.0043930503717},{"name":"Chlorite","hex":"#5e8e82","rgb":{"r":94,"g":142,"b":130},"luminance":89.2046464709098},{"name":"Chlorophyll","hex":"#44891a","rgb":{"r":68,"g":137,"b":26},"luminance":83.0023558762039},{"name":"Chlorophyll Cream","hex":"#b3d6c3","rgb":{"r":179,"g":214,"b":195},"luminance":138.34215649974524},{"name":"Chlorophyll Green","hex":"#4aff00","rgb":{"r":74,"g":255,"b":0},"luminance":151.31146387831956},{"name":"Chlorosis","hex":"#75876e","rgb":{"r":117,"g":135,"b":110},"luminance":87.52617844965013},{"name":"Choco Biscuit","hex":"#b4835b","rgb":{"r":180,"g":131,"b":91},"luminance":94.43177899944489},{"name":"Choco Chic","hex":"#993311","rgb":{"r":153,"g":51,"b":17},"luminance":54.70619546267131},{"name":"Choco Death","hex":"#63493e","rgb":{"r":99,"g":73,"b":62},"luminance":52.558386828364505},{"name":"Choco Loco","hex":"#7d5f53","rgb":{"r":125,"g":95,"b":83},"luminance":67.79495035767782},{"name":"Chocobo Feather","hex":"#f9bc08","rgb":{"r":249,"g":188,"b":8},"luminance":133.12486575016703},{"name":"Chocoholic","hex":"#993300","rgb":{"r":153,"g":51,"b":0},"luminance":54.67185727593311},{"name":"Chocolate","hex":"#d2691e","rgb":{"r":210,"g":105,"b":30},"luminance":88.05199444078481},{"name":"Chocolate Bar","hex":"#773333","rgb":{"r":119,"g":51,"b":51},"luminance":46.86186216957238},{"name":"Chocolate Brown","hex":"#411900","rgb":{"r":65,"g":25,"b":0},"luminance":24.35312813582682},{"name":"Chocolate Chip","hex":"#685a4e","rgb":{"r":104,"g":90,"b":78},"luminance":61.94382761825427},{"name":"Chocolate Chunk","hex":"#6b574a","rgb":{"r":107,"g":87,"b":74},"luminance":60.85031557847502},{"name":"Chocolate Cosmos","hex":"#58111a","rgb":{"r":88,"g":17,"b":26},"luminance":28.29641463153945},{"name":"Chocolate Eclair","hex":"#674848","rgb":{"r":103,"g":72,"b":72},"luminance":52.934602756609024},{"name":"Chocolate Fondant","hex":"#56352d","rgb":{"r":86,"g":53,"b":45},"luminance":40.68686541133391},{"name":"Chocolate Fondue","hex":"#9a3001","rgb":{"r":154,"g":48,"b":1},"luminance":53.98272027232418},{"name":"Chocolate Kiss","hex":"#3c1421","rgb":{"r":60,"g":20,"b":33},"luminance":21.767495124611834},{"name":"Chocolate Lab","hex":"#5c3e35","rgb":{"r":92,"g":62,"b":53},"luminance":46.01868168472452},{"name":"Chocolate Lust","hex":"#993322","rgb":{"r":153,"g":51,"b":34},"luminance":54.80908094467558},{"name":"Chocolate Magma","hex":"#7a463a","rgb":{"r":122,"g":70,"b":58},"luminance":55.34212796776068},{"name":"Chocolate Melange","hex":"#331100","rgb":{"r":51,"g":17,"b":0},"luminance":18.223952425311033},{"name":"Chocolate Milk","hex":"#976f4c","rgb":{"r":151,"g":111,"b":76},"luminance":79.74291031809662},{"name":"Chocolate Moment","hex":"#998069","rgb":{"r":153,"g":128,"b":105},"luminance":88.7777416079053},{"name":"Chocolate Pancakes","hex":"#884400","rgb":{"r":136,"g":68,"b":0},"luminance":56.98111925892646},{"name":"Chocolate Plum","hex":"#3c2d2e","rgb":{"r":60,"g":45,"b":46},"luminance":32.358852899940686},{"name":"Chocolate Praline","hex":"#66424d","rgb":{"r":102,"g":66,"b":77},"luminance":50.081172630041316},{"name":"Chocolate Pretzel","hex":"#60504b","rgb":{"r":96,"g":80,"b":75},"luminance":55.697968688274436},{"name":"Chocolate Pudding","hex":"#6f6665","rgb":{"r":111,"g":102,"b":101},"luminance":69.4188576180853},{"name":"Chocolate Red","hex":"#4d3635","rgb":{"r":77,"g":54,"b":53},"luminance":39.639973473755},{"name":"Chocolate Ripple","hex":"#76604e","rgb":{"r":118,"g":96,"b":78},"luminance":67.07782861721151},{"name":"Chocolate Sparkle","hex":"#8c6c6f","rgb":{"r":140,"g":108,"b":111},"luminance":77.01581741434677},{"name":"Chocolate Stain","hex":"#84563c","rgb":{"r":132,"g":86,"b":60},"luminance":64.44331577440751},{"name":"Chocolate Torte","hex":"#382e2d","rgb":{"r":56,"g":46,"b":45},"luminance":32.18363621469768},{"name":"Chocolate Truffle","hex":"#612e35","rgb":{"r":97,"g":46,"b":53},"luminance":40.084757414758045},{"name":"Chōjicha Brown","hex":"#8f583c","rgb":{"r":143,"g":88,"b":60},"luminance":67.4039241068352},{"name":"Chokecherry","hex":"#92000a","rgb":{"r":146,"g":0,"b":10},"luminance":43.668882696950234},{"name":"Choo Choo","hex":"#867578","rgb":{"r":134,"g":117,"b":120},"luminance":80.67981034310876},{"name":"Choral Singer","hex":"#b77795","rgb":{"r":183,"g":119,"b":149},"luminance":90.34332235422826},{"name":"Chorizo","hex":"#aa0011","rgb":{"r":170,"g":0,"b":17},"luminance":50.86693173369119},{"name":"Chōshun Red","hex":"#b95754","rgb":{"r":185,"g":87,"b":84},"luminance":75.89131545835795},{"name":"Chowder Bowl","hex":"#e5d2b2","rgb":{"r":229,"g":210,"b":178},"luminance":142.46240207507384},{"name":"Christalle","hex":"#382161","rgb":{"r":56,"g":33,"b":97},"luminance":27.890438164360198},{"name":"Christi","hex":"#71a91d","rgb":{"r":113,"g":169,"b":29},"luminance":104.85097144995844},{"name":"Christina Brown","hex":"#009094","rgb":{"r":0,"g":144,"b":148},"luminance":86.19540108381652},{"name":"Christmas Blue","hex":"#2a8fbd","rgb":{"r":42,"g":143,"b":189},"luminance":87.5672596408041},{"name":"Christmas Brown","hex":"#5d2b2c","rgb":{"r":93,"g":43,"b":44},"luminance":37.88796096387347},{"name":"Christmas Gold","hex":"#caa906","rgb":{"r":202,"g":169,"b":6},"luminance":116.14482971273408},{"name":"Christmas Green","hex":"#3c8d0d","rgb":{"r":60,"g":141,"b":13},"luminance":84.70192567468581},{"name":"Christmas Holly","hex":"#68846a","rgb":{"r":104,"g":132,"b":106},"luminance":84.36085898092787},{"name":"Christmas Ivy","hex":"#477266","rgb":{"r":71,"g":114,"b":102},"luminance":71.16108170200899},{"name":"Christmas Orange","hex":"#d56c2b","rgb":{"r":213,"g":108,"b":43},"luminance":89.99509091611608},{"name":"Christmas Pink","hex":"#e34285","rgb":{"r":227,"g":66,"b":133},"luminance":79.60887473768236},{"name":"Christmas Purple","hex":"#4d084b","rgb":{"r":77,"g":8,"b":75},"luminance":25.00426853559208},{"name":"Christmas Red","hex":"#b01b2e","rgb":{"r":176,"g":27,"b":46},"luminance":55.20847501063581},{"name":"Christmas Rose","hex":"#ffddbb","rgb":{"r":255,"g":221,"b":187},"luminance":151.97648396380276},{"name":"Christmas Silver","hex":"#e1dfe0","rgb":{"r":225,"g":223,"b":224},"luminance":149.3756496956582},{"name":"Christobel","hex":"#d4c5ba","rgb":{"r":212,"g":197,"b":186},"luminance":133.5665619868985},{"name":"Chrome Aluminum","hex":"#a8a9ad","rgb":{"r":168,"g":169,"b":173},"luminance":112.93115742344979},{"name":"Chrome Chalice","hex":"#cdc8d2","rgb":{"r":205,"g":200,"b":210},"luminance":134.58439963457874},{"name":"Chrome White","hex":"#cac7b7","rgb":{"r":202,"g":199,"b":183},"luminance":133.1481070725378},{"name":"Chrome Yellow","hex":"#ffa700","rgb":{"r":255,"g":167,"b":0},"luminance":124.18931059475287},{"name":"Chromis Damsel Blue","hex":"#82cafc","rgb":{"r":130,"g":202,"b":252},"luminance":128.04674287149984},{"name":"Chromophobia Green","hex":"#06b48b","rgb":{"r":6,"g":180,"b":139},"luminance":106.85667855590496},{"name":"Chronicle","hex":"#3e4265","rgb":{"r":62,"g":66,"b":101},"luminance":44.46540457479275},{"name":"Chronus Blue","hex":"#72a8d1","rgb":{"r":114,"g":168,"b":209},"luminance":107.02639453891736},{"name":"Chrysanthemum","hex":"#be454f","rgb":{"r":190,"g":69,"b":79},"luminance":70.34896690783738},{"name":"Chrysanthemum Leaf","hex":"#9db8ab","rgb":{"r":157,"g":184,"b":171},"luminance":119.37080610015163},{"name":"Chrysocolla Green","hex":"#378661","rgb":{"r":55,"g":134,"b":97},"luminance":81.11595621701072},{"name":"Chrysomela Goettingensis","hex":"#39334a","rgb":{"r":57,"g":51,"b":74},"luminance":35.46623625365398},{"name":"Chuff Blue","hex":"#91c1c6","rgb":{"r":145,"g":193,"b":198},"luminance":123.38558218041523},{"name":"Chun-Li Blue","hex":"#1559db","rgb":{"r":21,"g":89,"b":219},"luminance":58.241377439068174},{"name":"Chupacabra Grey","hex":"#cfcdcf","rgb":{"r":207,"g":205,"b":207},"luminance":137.36128012653347},{"name":"Church Mouse","hex":"#b3b5af","rgb":{"r":179,"g":181,"b":175},"luminance":120.62721479831987},{"name":"Churchill","hex":"#4d4d58","rgb":{"r":77,"g":77,"b":88},"luminance":51.70734139365511},{"name":"Chutney","hex":"#98594b","rgb":{"r":152,"g":89,"b":75},"luminance":69.77072633275361},{"name":"Chyornyi Black","hex":"#0f0809","rgb":{"r":15,"g":8,"b":9},"luminance":6.574216074940037},{"name":"Cider Mill","hex":"#938a43","rgb":{"r":147,"g":138,"b":67},"luminance":92.47798272561961},{"name":"Cider Toddy","hex":"#b98033","rgb":{"r":185,"g":128,"b":51},"luminance":93.48245994302887},{"name":"Cielo","hex":"#a5cee8","rgb":{"r":165,"g":206,"b":232},"luminance":133.25002443902216},{"name":"Cigar","hex":"#7d4e38","rgb":{"r":125,"g":78,"b":56},"luminance":59.44748839942693},{"name":"Cigar Box","hex":"#9c7351","rgb":{"r":156,"g":115,"b":81},"luminance":82.57030045361346},{"name":"Cigar Smoke","hex":"#78857a","rgb":{"r":120,"g":133,"b":122},"luminance":87.03957665912674},{"name":"Cigarette Glow","hex":"#ee5500","rgb":{"r":238,"g":85,"b":0},"luminance":86.91111130919911},{"name":"Cilantro","hex":"#43544b","rgb":{"r":67,"g":84,"b":75},"luminance":53.904568016078194},{"name":"Cinder","hex":"#242a2e","rgb":{"r":36,"g":42,"b":46},"luminance":27.40771694249632},{"name":"Cinderella","hex":"#fbd7cc","rgb":{"r":251,"g":215,"b":204},"luminance":148.66370088895272},{"name":"Cinderella Pink","hex":"#ffc6c4","rgb":{"r":255,"g":198,"b":196},"luminance":140.7872062262761},{"name":"Cinereous","hex":"#98817b","rgb":{"r":152,"g":129,"b":123},"luminance":89.42097023070147},{"name":"Cinnabar","hex":"#730113","rgb":{"r":115,"g":1,"b":19},"luminance":34.45815360694766},{"name":"Cinnamon","hex":"#d26911","rgb":{"r":210,"g":105,"b":17},"luminance":88.00689273573974},{"name":"Cinnamon Brandy","hex":"#cf8d6c","rgb":{"r":207,"g":141,"b":108},"luminance":104.0802819077658},{"name":"Cinnamon Bun","hex":"#ac4f06","rgb":{"r":172,"g":79,"b":6},"luminance":69.25144163842367},{"name":"Cinnamon Crunch","hex":"#a37d5a","rgb":{"r":163,"g":125,"b":90},"luminance":88.68175344455024},{"name":"Cinnamon Diamonds","hex":"#a97673","rgb":{"r":169,"g":118,"b":115},"luminance":86.73541846904297},{"name":"Cinnamon Frost","hex":"#d3b191","rgb":{"r":211,"g":177,"b":145},"luminance":122.6721852010471},{"name":"Cinnamon Ice","hex":"#dbbba7","rgb":{"r":219,"g":187,"b":167},"luminance":129.2263137522695},{"name":"Cinnamon Milk","hex":"#ebdab5","rgb":{"r":235,"g":218,"b":181},"luminance":147.4389003519763},{"name":"Cinnamon Roast","hex":"#bb9988","rgb":{"r":187,"g":153,"b":136},"luminance":106.9235862941381},{"name":"Cinnamon Roll","hex":"#c0737a","rgb":{"r":192,"g":115,"b":122},"luminance":89.69969873416521},{"name":"Cinnamon Sand","hex":"#b78153","rgb":{"r":183,"g":129,"b":83},"luminance":93.9012899911391},{"name":"Cinnamon Satin","hex":"#cd607e","rgb":{"r":205,"g":96,"b":126},"luminance":84.49230393947131},{"name":"Cinnamon Spice","hex":"#935f43","rgb":{"r":147,"g":95,"b":67},"luminance":71.41386754685675},{"name":"Cinnamon Stick","hex":"#9b4722","rgb":{"r":155,"g":71,"b":34},"luminance":62.4488168823077},{"name":"Cinnamon Stone","hex":"#c9543a","rgb":{"r":201,"g":84,"b":58},"luminance":78.01850555477206},{"name":"Cinnamon Toast","hex":"#8d7d77","rgb":{"r":141,"g":125,"b":119},"luminance":85.70477385770293},{"name":"Cinnamon Twist","hex":"#9f7250","rgb":{"r":159,"g":114,"b":80},"luminance":82.59140273055058},{"name":"Cinque Foil","hex":"#ffff88","rgb":{"r":255,"g":255,"b":136},"luminance":168.69876486210563},{"name":"Cioccolato","hex":"#5d3b2e","rgb":{"r":93,"g":59,"b":46},"luminance":44.72329900622269},{"name":"Cipher","hex":"#aa7691","rgb":{"r":170,"g":118,"b":145},"luminance":87.49119130518226},{"name":"Cipollino","hex":"#f0cfa0","rgb":{"r":240,"g":207,"b":160},"luminance":142.2906612571605},{"name":"Cippolino","hex":"#c8cec3","rgb":{"r":200,"g":206,"b":195},"luminance":136.71994362198953},{"name":"Circumorbital Ring","hex":"#6258c4","rgb":{"r":98,"g":88,"b":196},"luminance":63.45237486493315},{"name":"Circus","hex":"#fc5e30","rgb":{"r":252,"g":94,"b":48},"luminance":93.55145948621005},{"name":"Citadel","hex":"#748995","rgb":{"r":116,"g":137,"b":149},"luminance":89.21165626194819},{"name":"Citrine","hex":"#e4d00a","rgb":{"r":228,"g":208,"b":10},"luminance":139.843320898783},{"name":"Citrine Brown","hex":"#933709","rgb":{"r":147,"g":55,"b":9},"luminance":54.5457616135296},{"name":"Citrine White","hex":"#faf7d6","rgb":{"r":250,"g":247,"b":214},"luminance":164.9379805775492},{"name":"Citrino","hex":"#e9e89b","rgb":{"r":233,"g":232,"b":155},"luminance":153.98636837395705},{"name":"Citron","hex":"#d5c757","rgb":{"r":213,"g":199,"b":87},"luminance":133.4154326230665},{"name":"Citron Goby","hex":"#deff00","rgb":{"r":222,"g":255,"b":0},"luminance":163.74259711205266},{"name":"Citronella","hex":"#66bb77","rgb":{"r":102,"g":187,"b":119},"luminance":114.73185137964086},{"name":"Citronelle","hex":"#b8af23","rgb":{"r":184,"g":175,"b":35},"luminance":116.59805307551235},{"name":"Citrus","hex":"#9fb70a","rgb":{"r":159,"g":183,"b":10},"luminance":117.47645518145328},{"name":"Citrus Butter","hex":"#e4de8e","rgb":{"r":228,"g":222,"b":142},"luminance":147.9567893812244},{"name":"Citrus Delight","hex":"#d0d557","rgb":{"r":208,"g":213,"b":87},"luminance":139.99629476882592},{"name":"Citrus Honey","hex":"#f6b96b","rgb":{"r":246,"g":185,"b":107},"luminance":131.72644436482753},{"name":"Citrus Leaf","hex":"#b3d157","rgb":{"r":179,"g":209,"b":87},"luminance":134.21617880866674},{"name":"Citrus Lime","hex":"#c3dc68","rgb":{"r":195,"g":220,"b":104},"luminance":142.18712093927493},{"name":"Citrus Notes","hex":"#d26643","rgb":{"r":210,"g":102,"b":67},"luminance":87.09660739661447},{"name":"Citrus Punch","hex":"#fdea83","rgb":{"r":253,"g":234,"b":131},"luminance":157.52051653356145},{"name":"Citrus Sachet","hex":"#f2c6a7","rgb":{"r":242,"g":198,"b":167},"luminance":138.22665692260665},{"name":"Citrus Spice","hex":"#e2cd52","rgb":{"r":226,"g":205,"b":82},"luminance":138.3262187909436},{"name":"Citrus Sugar","hex":"#e6d943","rgb":{"r":230,"g":217,"b":67},"luminance":144.95882720621051},{"name":"Citrus Yellow","hex":"#d7c275","rgb":{"r":215,"g":194,"b":117},"luminance":131.4483257900229},{"name":"City Bench","hex":"#675c49","rgb":{"r":103,"g":92,"b":73},"luminance":62.72274634452799},{"name":"City Brume","hex":"#e0e0dc","rgb":{"r":224,"g":224,"b":220},"luminance":149.67927418316805},{"name":"City Dweller","hex":"#c0b9ac","rgb":{"r":192,"g":185,"b":172},"luminance":124.39061923231992},{"name":"City Hunter Blue","hex":"#0022aa","rgb":{"r":0,"g":34,"b":170},"luminance":27.819169002685896},{"name":"City Lights","hex":"#dfe6ea","rgb":{"r":223,"g":230,"b":234},"luminance":152.92197816206797},{"name":"City Loft","hex":"#a79b8a","rgb":{"r":167,"g":155,"b":138},"luminance":104.97176066923903},{"name":"City of Pink Angels","hex":"#e6b4a6","rgb":{"r":230,"g":180,"b":166},"luminance":127.48123891773251},{"name":"City Roast","hex":"#663333","rgb":{"r":102,"g":51,"b":51},"luminance":43.12950925990232},{"name":"City Street","hex":"#bab2ab","rgb":{"r":186,"g":178,"b":171},"luminance":119.95939824790719},{"name":"City Tower","hex":"#aeaba5","rgb":{"r":174,"g":171,"b":165},"luminance":114.61266467978135},{"name":"Cityscape","hex":"#dae3e7","rgb":{"r":218,"g":227,"b":231},"luminance":150.6567910218454},{"name":"Clair De Lune","hex":"#dbe9df","rgb":{"r":219,"g":233,"b":223},"luminance":153.75417355636236},{"name":"Clairvoyance","hex":"#838493","rgb":{"r":131,"g":132,"b":147},"luminance":88.42404300302039},{"name":"Clairvoyant","hex":"#480656","rgb":{"r":72,"g":6,"b":86},"luminance":23.916054942234933},{"name":"Clam","hex":"#dad1c0","rgb":{"r":218,"g":209,"b":192},"luminance":140.63746356145649},{"name":"Clam Shell","hex":"#d2b3a9","rgb":{"r":210,"g":179,"b":169},"luminance":123.91165475854157},{"name":"Clam Up","hex":"#ebdbc1","rgb":{"r":235,"g":219,"b":193},"luminance":148.14564468117177},{"name":"Clambake","hex":"#e0d1bb","rgb":{"r":224,"g":209,"b":187},"luminance":141.39080659293234},{"name":"Claret","hex":"#680018","rgb":{"r":104,"g":0,"b":24},"luminance":31.216132239596885},{"name":"Claret Red","hex":"#c84c61","rgb":{"r":200,"g":76,"b":97},"luminance":75.42247614604017},{"name":"Clarinet","hex":"#002255","rgb":{"r":0,"g":34,"b":85},"luminance":22.185983503103934},{"name":"Clarity","hex":"#eaf0e0","rgb":{"r":234,"g":240,"b":224},"luminance":159.35652748475664},{"name":"Clary","hex":"#684976","rgb":{"r":104,"g":73,"b":118},"luminance":54.62715186608212},{"name":"Clary Sage","hex":"#c7c0ce","rgb":{"r":199,"g":192,"b":206},"luminance":129.5918935466258},{"name":"Classic Blue","hex":"#0f4c81","rgb":{"r":15,"g":76,"b":129},"luminance":47.18699190454928},{"name":"Classic Calm","hex":"#6b8885","rgb":{"r":107,"g":136,"b":133},"luminance":87.33032988028843},{"name":"Classic Chalk","hex":"#f4f4f0","rgb":{"r":244,"g":244,"b":240},"luminance":163.05032204813332},{"name":"Classic Cloud","hex":"#9197a3","rgb":{"r":145,"g":151,"b":163},"luminance":100.40649639341072},{"name":"Classic Cool","hex":"#b7b2ac","rgb":{"r":183,"g":178,"b":172},"luminance":119.56482739083428},{"name":"Classic Green","hex":"#39a845","rgb":{"r":57,"g":168,"b":69},"luminance":100.38651931907988},{"name":"Classic Rose","hex":"#fbcce7","rgb":{"r":251,"g":204,"b":231},"luminance":143.75470587427736},{"name":"Clay","hex":"#b66a50","rgb":{"r":182,"g":106,"b":80},"luminance":83.1629148599302},{"name":"Clay Ash","hex":"#bdc8b3","rgb":{"r":189,"g":200,"b":179},"luminance":131.88122670418258},{"name":"Clay Bake","hex":"#e1c68f","rgb":{"r":225,"g":198,"b":143},"luminance":135.27809839364244},{"name":"Clay Bath","hex":"#8a7d69","rgb":{"r":138,"g":125,"b":105},"luminance":85.02778468830057},{"name":"Clay Brown","hex":"#b2713d","rgb":{"r":178,"g":113,"b":61},"luminance":85.32725801875975},{"name":"Clay Court","hex":"#a9765d","rgb":{"r":169,"g":118,"b":93},"luminance":86.39191583128597},{"name":"Clay Creek","hex":"#897e59","rgb":{"r":137,"g":126,"b":89},"luminance":85.15448390425486},{"name":"Clay Dust","hex":"#f8dca3","rgb":{"r":248,"g":220,"b":163},"luminance":150.06981517946903},{"name":"Clay Fire","hex":"#d8a686","rgb":{"r":216,"g":166,"b":134},"luminance":117.89568523063089},{"name":"Clay Pipe","hex":"#d9c8b7","rgb":{"r":217,"g":200,"b":183},"luminance":135.7489842798096},{"name":"Clay Play","hex":"#774433","rgb":{"r":119,"g":68,"b":51},"luminance":53.787519119215744},{"name":"Clay Pot","hex":"#c3663f","rgb":{"r":195,"g":102,"b":63},"luminance":83.88057000879286},{"name":"Clay Ridge","hex":"#956a66","rgb":{"r":149,"g":106,"b":102},"luminance":77.40529225447055},{"name":"Clay Slate Wacke","hex":"#cdcace","rgb":{"r":205,"g":202,"b":206},"luminance":135.52995520179292},{"name":"Clay Terrace","hex":"#d4823c","rgb":{"r":212,"g":130,"b":60},"luminance":99.43862551342913},{"name":"Clayton","hex":"#83756c","rgb":{"r":131,"g":117,"b":108},"luminance":80.0162542612437},{"name":"Clean Green","hex":"#8fe0c6","rgb":{"r":143,"g":224,"b":198},"luminance":140.09550448533312},{"name":"Clean N Crisp","hex":"#d0e798","rgb":{"r":208,"g":231,"b":152},"luminance":150.18205903835516},{"name":"Clean Slate","hex":"#577396","rgb":{"r":87,"g":115,"b":150},"luminance":74.33714545232417},{"name":"Clear Blue","hex":"#247afd","rgb":{"r":36,"g":122,"b":253},"luminance":77.95055904866878},{"name":"Clear Brook","hex":"#60949b","rgb":{"r":96,"g":148,"b":155},"luminance":93.1857708665867},{"name":"Clear Calamine","hex":"#f6e6e4","rgb":{"r":246,"g":230,"b":228},"luminance":155.9277880302289},{"name":"Clear Camouflage Green","hex":"#dae8e1","rgb":{"r":218,"g":232,"b":225},"luminance":153.1427356422759},{"name":"Clear Chill","hex":"#1e90ff","rgb":{"r":30,"g":144,"b":255},"luminance":89.83600939489688},{"name":"Clear Cinnamon","hex":"#dfdbd8","rgb":{"r":223,"g":219,"b":216},"luminance":146.89464766968197},{"name":"Clear Concrete","hex":"#bab6b2","rgb":{"r":186,"g":182,"b":178},"luminance":122.14002544620661},{"name":"Clear Day","hex":"#dfefea","rgb":{"r":223,"g":239,"b":234},"luminance":157.60570152757796},{"name":"Clear Green","hex":"#12732b","rgb":{"r":18,"g":115,"b":43},"luminance":67.89639572908123},{"name":"Clear Lake Trail","hex":"#a3bbda","rgb":{"r":163,"g":187,"b":218},"luminance":122.64644484859721},{"name":"Clear Orange","hex":"#ee8800","rgb":{"r":238,"g":136,"b":0},"luminance":106.94474492933254},{"name":"Clear Plum","hex":"#64005e","rgb":{"r":100,"g":0,"b":94},"luminance":31.76228354511054},{"name":"Clear Purple","hex":"#412a7a","rgb":{"r":65,"g":42,"b":122},"luminance":34.33615303146233},{"name":"Clear Red","hex":"#ce261c","rgb":{"r":206,"g":38,"b":28},"luminance":65.58633497917077},{"name":"Clear Sand","hex":"#eae7da","rgb":{"r":234,"g":231,"b":218},"luminance":154.59433841185773},{"name":"Clear Skies","hex":"#e8f7fd","rgb":{"r":232,"g":247,"b":253},"luminance":163.29602110584324},{"name":"Clear Viridian","hex":"#367588","rgb":{"r":54,"g":117,"b":136},"luminance":72.23484182165834},{"name":"Clear Vision","hex":"#e7f0f7","rgb":{"r":231,"g":240,"b":247},"luminance":159.40694503377196},{"name":"Clear Water","hex":"#aad5db","rgb":{"r":170,"g":213,"b":219},"luminance":137.2579360802136},{"name":"Clear Weather","hex":"#66bbdd","rgb":{"r":102,"g":187,"b":221},"luminance":116.67947120637803},{"name":"Clear Yellow","hex":"#f1f1e6","rgb":{"r":241,"g":241,"b":230},"luminance":160.9127091624524},{"name":"Clearly Aqua","hex":"#cee1d4","rgb":{"r":206,"g":225,"b":212},"luminance":147.72176104081618},{"name":"Clearview","hex":"#fbfbe5","rgb":{"r":251,"g":251,"b":229},"luminance":167.39793071002998},{"name":"Clematis Blue","hex":"#363b7c","rgb":{"r":54,"g":59,"b":124},"luminance":40.74266192825402},{"name":"Clematis Magenta","hex":"#e05aec","rgb":{"r":224,"g":90,"b":236},"luminance":89.44617762654813},{"name":"Clementine","hex":"#e96e00","rgb":{"r":233,"g":110,"b":0},"luminance":94.98829290496803},{"name":"Clementine Jelly","hex":"#ffad01","rgb":{"r":255,"g":173,"b":1},"luminance":126.98786801108204},{"name":"Cleo's Bath","hex":"#00507f","rgb":{"r":0,"g":80,"b":127},"luminance":49.14116486205836},{"name":"Cleopatra","hex":"#007590","rgb":{"r":0,"g":117,"b":144},"luminance":70.61366791917837},{"name":"Cleopatra's Gown","hex":"#795088","rgb":{"r":121,"g":80,"b":136},"luminance":61.2742658625952},{"name":"Cliff Brown","hex":"#d0ab8c","rgb":{"r":208,"g":171,"b":140},"luminance":119.15581644636572},{"name":"Cliff's View","hex":"#ddc5aa","rgb":{"r":221,"g":197,"b":170},"luminance":134.58973572304836},{"name":"Climate Control","hex":"#466082","rgb":{"r":70,"g":96,"b":130},"luminance":61.91320702402678},{"name":"Climbing Ivy","hex":"#58714a","rgb":{"r":88,"g":113,"b":74},"luminance":71.85602967740425},{"name":"Clinker","hex":"#463623","rgb":{"r":70,"g":54,"b":35},"luminance":38.19356233712692},{"name":"Clipped Grass","hex":"#a1b841","rgb":{"r":161,"g":184,"b":65},"luminance":118.48206398016536},{"name":"Clippership Twill","hex":"#a6937d","rgb":{"r":166,"g":147,"b":125},"luminance":100.56036981336136},{"name":"Cloak and Dagger","hex":"#550055","rgb":{"r":85,"g":0,"b":85},"luminance":27.199601559581712},{"name":"Clock Chimes Thirteen","hex":"#002211","rgb":{"r":0,"g":34,"b":17},"luminance":20.051872929978384},{"name":"Cloisonne","hex":"#0075af","rgb":{"r":0,"g":117,"b":175},"luminance":71.51788266580604},{"name":"Cloistered Garden","hex":"#99b090","rgb":{"r":153,"g":176,"b":144},"luminance":114.1737378252985},{"name":"Clooney","hex":"#5f6c84","rgb":{"r":95,"g":108,"b":132},"luminance":71.07980827914493},{"name":"Closed Shutter","hex":"#25252c","rgb":{"r":37,"g":37,"b":44},"luminance":24.885039401214534},{"name":"Clotted Cream","hex":"#f3efcd","rgb":{"r":243,"g":239,"b":205},"luminance":159.71011989852113},{"name":"Clotted Red","hex":"#991115","rgb":{"r":153,"g":17,"b":21},"luminance":46.883895806556005},{"name":"Cloud Abyss","hex":"#dfe7eb","rgb":{"r":223,"g":231,"b":235},"luminance":153.46032985107257},{"name":"Cloud Blue","hex":"#a2b6b9","rgb":{"r":162,"g":182,"b":185},"luminance":119.18276511308167},{"name":"Cloud Cream","hex":"#e6ddc5","rgb":{"r":230,"g":221,"b":197},"luminance":148.53541393553257},{"name":"Cloud Dancer","hex":"#f0eee9","rgb":{"r":240,"g":238,"b":233},"luminance":159.28842983719815},{"name":"Cloud Grey","hex":"#b8a9af","rgb":{"r":184,"g":169,"b":175},"luminance":115.17811408857153},{"name":"Cloud Over London","hex":"#c2bcb1","rgb":{"r":194,"g":188,"b":177},"luminance":126.2944751602381},{"name":"Cloud Pink","hex":"#f5d1c8","rgb":{"r":245,"g":209,"b":200},"luminance":144.6971095564801},{"name":"Cloud White","hex":"#f2f2ed","rgb":{"r":242,"g":242,"b":237},"luminance":161.6941291574929},{"name":"Cloudberry","hex":"#ffa168","rgb":{"r":255,"g":161,"b":104},"luminance":122.0058925216319},{"name":"Cloudburst","hex":"#837f7f","rgb":{"r":131,"g":127,"b":127},"luminance":85.44809211445273},{"name":"Clouded Blue","hex":"#1f75fe","rgb":{"r":31,"g":117,"b":254},"luminance":75.10771823188347},{"name":"Clouded Sky","hex":"#7d93a2","rgb":{"r":125,"g":147,"b":162},"luminance":95.83187971651186},{"name":"Clouded Vision","hex":"#d1d0d1","rgb":{"r":209,"g":208,"b":209},"luminance":139.21291812543834},{"name":"Cloudless","hex":"#d6eafc","rgb":{"r":214,"g":234,"b":252},"luminance":154.22946003925452},{"name":"Cloudy","hex":"#d8d7d3","rgb":{"r":216,"g":215,"b":211},"luminance":143.79634903918807},{"name":"Cloudy Blue","hex":"#acc2d9","rgb":{"r":172,"g":194,"b":217},"luminance":127.37741837547188},{"name":"Cloudy Camouflage","hex":"#177245","rgb":{"r":23,"g":114,"b":69},"luminance":67.72876648072072},{"name":"Cloudy Carrot","hex":"#ffa812","rgb":{"r":255,"g":168,"b":18},"luminance":124.67006932299347},{"name":"Cloudy Cinnamon","hex":"#87715f","rgb":{"r":135,"g":113,"b":95},"luminance":78.39913064569019},{"name":"Cloudy Day","hex":"#dfe6da","rgb":{"r":223,"g":230,"b":218},"luminance":152.6143647662303},{"name":"Cloudy Desert","hex":"#b0a99f","rgb":{"r":176,"g":169,"b":159},"luminance":113.75004378460694},{"name":"Cloudy Grey","hex":"#ece3e1","rgb":{"r":236,"g":227,"b":225},"luminance":152.94605780143533},{"name":"Cloudy Plum","hex":"#9d7aac","rgb":{"r":157,"g":122,"b":172},"luminance":87.84465782846443},{"name":"Cloudy Sea","hex":"#6699aa","rgb":{"r":102,"g":153,"b":170},"luminance":96.80768629091389},{"name":"Cloudy Viridian","hex":"#4b5f56","rgb":{"r":75,"g":95,"b":86},"luminance":60.89937820700634},{"name":"Clove","hex":"#876155","rgb":{"r":135,"g":97,"b":85},"luminance":70.46473618768468},{"name":"Clove Brown","hex":"#766051","rgb":{"r":118,"g":96,"b":81},"luminance":67.12402091650947},{"name":"Clove Dye","hex":"#a96232","rgb":{"r":169,"g":98,"b":50},"luminance":76.77963686421029},{"name":"Clovedust","hex":"#b0705d","rgb":{"r":176,"g":112,"b":93},"luminance":84.87615281102224},{"name":"Clover","hex":"#008f00","rgb":{"r":0,"g":143,"b":0},"luminance":83.94099999999999},{"name":"Clover Honey","hex":"#f0e2bc","rgb":{"r":240,"g":226,"b":188},"luminance":152.3418342675445},{"name":"Clover Mist","hex":"#6fc288","rgb":{"r":111,"g":194,"b":136},"luminance":119.62475755879298},{"name":"Clown Nose","hex":"#e94257","rgb":{"r":233,"g":66,"b":87},"luminance":80.3293232698994},{"name":"Club Cruise","hex":"#8bc3e1","rgb":{"r":139,"g":195,"b":225},"luminance":124.44868599547364},{"name":"Club Moss","hex":"#6b977a","rgb":{"r":107,"g":151,"b":122},"luminance":95.25493311109929},{"name":"Club-Mate","hex":"#f8de7e","rgb":{"r":248,"g":222,"b":126},"luminance":150.62065660459723},{"name":"Clumsy Caramel","hex":"#d3b683","rgb":{"r":211,"g":182,"b":131},"luminance":124.9669949746732},{"name":"Co Pilot","hex":"#4978a9","rgb":{"r":73,"g":120,"b":169},"luminance":76.21935636700168},{"name":"CO₂","hex":"#cadfec","rgb":{"r":202,"g":223,"b":236},"luminance":146.65202153737943},{"name":"Coal Miner","hex":"#777872","rgb":{"r":119,"g":120,"b":114},"luminance":79.97935469232044},{"name":"Coalmine","hex":"#220033","rgb":{"r":34,"g":0,"b":51},"luminance":11.711112329749042},{"name":"Coarse Wool","hex":"#181b26","rgb":{"r":24,"g":27,"b":38},"luminance":17.92908254763751},{"name":"Coastal Breeze","hex":"#e0f6fb","rgb":{"r":224,"g":246,"b":251},"luminance":161.7296607799571},{"name":"Coastal Calm","hex":"#538f94","rgb":{"r":83,"g":143,"b":148},"luminance":89.1439249416358},{"name":"Coastal Crush","hex":"#b4c0af","rgb":{"r":180,"g":192,"b":175},"luminance":126.47840335804369},{"name":"Coastal Fjord","hex":"#505d7e","rgb":{"r":80,"g":93,"b":126},"luminance":61.30797808605337},{"name":"Coastal Foam","hex":"#b0e5c9","rgb":{"r":176,"g":229,"b":201},"luminance":146.16387960436737},{"name":"Coastal Fringe","hex":"#80b9c0","rgb":{"r":128,"g":185,"b":192},"luminance":117.20368830800504},{"name":"Coastal Surf","hex":"#2d4982","rgb":{"r":45,"g":73,"b":130},"luminance":47.295640665921844},{"name":"Coastal Trim","hex":"#bdffca","rgb":{"r":189,"g":255,"b":202},"luminance":161.64585095201176},{"name":"Coastline Trail","hex":"#6e6c5b","rgb":{"r":110,"g":108,"b":91},"luminance":72.16941729015137},{"name":"Cobalite","hex":"#9999ff","rgb":{"r":153,"g":153,"b":255},"luminance":104.89932616561461},{"name":"Cobalt","hex":"#030aa7","rgb":{"r":3,"g":10,"b":167},"luminance":19.9425914314063},{"name":"Cobalt Glaze","hex":"#0072b5","rgb":{"r":0,"g":114,"b":181},"luminance":70.02699965013494},{"name":"Cobalt Stone","hex":"#0264ae","rgb":{"r":2,"g":100,"b":174},"luminance":61.96381605421021},{"name":"Cobbler","hex":"#c4ab7d","rgb":{"r":196,"g":171,"b":125},"luminance":117.10266198938433},{"name":"Cobblestone","hex":"#a89a8e","rgb":{"r":168,"g":154,"b":142},"luminance":104.67618435919414},{"name":"Cobblestone Path","hex":"#9e8779","rgb":{"r":158,"g":135,"b":121},"luminance":93.2837125386849},{"name":"Cobblestone Street","hex":"#cfc7b9","rgb":{"r":207,"g":199,"b":185},"luminance":133.86862409840478},{"name":"Cobra Leather","hex":"#b08e08","rgb":{"r":176,"g":142,"b":8},"luminance":98.57994946235263},{"name":"Cobre","hex":"#996515","rgb":{"r":153,"g":101,"b":21},"luminance":74.92307798001895},{"name":"Coca Mocha","hex":"#bd9d95","rgb":{"r":189,"g":157,"b":149},"luminance":109.43170746177726},{"name":"Cochin Chicken","hex":"#f8b862","rgb":{"r":248,"g":184,"b":98},"luminance":131.48787302257193},{"name":"Cochineal Red","hex":"#7a4848","rgb":{"r":122,"g":72,"b":72},"luminance":56.42926053033125},{"name":"Cochineal Red/Rouge","hex":"#9d2933","rgb":{"r":157,"g":41,"b":51},"luminance":53.072293468437934},{"name":"Cochise","hex":"#ddcdb3","rgb":{"r":221,"g":205,"b":179},"luminance":138.79247566781132},{"name":"Cockatoo","hex":"#58c8b6","rgb":{"r":88,"g":200,"b":182},"luminance":122.08833215340441},{"name":"Cockatrice Brown","hex":"#a46422","rgb":{"r":164,"g":100,"b":34},"luminance":76.58487234434747},{"name":"Cocktail Olive","hex":"#9fa36c","rgb":{"r":159,"g":163,"b":108},"luminance":107.54806267897158},{"name":"Coco-Lemon Tart","hex":"#eedd88","rgb":{"r":238,"g":221,"b":136},"luminance":148.77331343019824},{"name":"Cocoa","hex":"#875f42","rgb":{"r":135,"g":95,"b":66},"luminance":69.25084133784945},{"name":"Cocoa Bean","hex":"#4f3835","rgb":{"r":79,"g":56,"b":53},"luminance":40.927078920929596},{"name":"Cocoa Brown","hex":"#35281e","rgb":{"r":53,"g":40,"b":30},"luminance":28.53303714994252},{"name":"Cocoa Butter","hex":"#f5f4c1","rgb":{"r":245,"g":244,"b":193},"luminance":162.3719280325266},{"name":"Cocoa Cream","hex":"#dbc8b6","rgb":{"r":219,"g":200,"b":182},"luminance":136.01838429050684},{"name":"Cocoa Cupcake","hex":"#967859","rgb":{"r":150,"g":120,"b":89},"luminance":84.12049343649858},{"name":"Cocoa Delight","hex":"#8d725a","rgb":{"r":141,"g":114,"b":90},"luminance":79.75379367152385},{"name":"Cocoa Milk","hex":"#7d675d","rgb":{"r":125,"g":103,"b":93},"luminance":71.86672074054862},{"name":"Cocoa Pecan","hex":"#967b5d","rgb":{"r":150,"g":123,"b":93},"luminance":85.65576048929809},{"name":"Cocoa Powder","hex":"#766a5f","rgb":{"r":118,"g":106,"b":95},"luminance":72.3442168248437},{"name":"Cocobolo","hex":"#784848","rgb":{"r":120,"g":72,"b":72},"luminance":56.04454799532243},{"name":"Cocoloco","hex":"#aa8f7a","rgb":{"r":170,"g":143,"b":122},"luminance":99.11212259355561},{"name":"Coconut","hex":"#965a3e","rgb":{"r":150,"g":90,"b":62},"luminance":69.65980206690226},{"name":"Coconut Aroma","hex":"#eeeedd","rgb":{"r":238,"g":238,"b":221},"luminance":158.79714832452123},{"name":"Coconut Butter","hex":"#f2efe1","rgb":{"r":242,"g":239,"b":225},"luminance":159.92413361653703},{"name":"Coconut Cream","hex":"#e1dabb","rgb":{"r":225,"g":218,"b":187},"luminance":146.1358269042879},{"name":"Coconut Husk","hex":"#7d6044","rgb":{"r":125,"g":96,"b":68},"luminance":68.06270662411244},{"name":"Coconut Milk","hex":"#f0ede5","rgb":{"r":240,"g":237,"b":229},"luminance":158.69819468727425},{"name":"Coconut Pulp","hex":"#fbf9e1","rgb":{"r":251,"g":249,"b":225},"luminance":166.2946104658837},{"name":"Coconut Shell","hex":"#917a56","rgb":{"r":145,"g":122,"b":86},"luminance":84.28724361966049},{"name":"Coconut White","hex":"#e9edf6","rgb":{"r":233,"g":237,"b":246},"luminance":158.09507578036707},{"name":"Cocoon","hex":"#dedbcc","rgb":{"r":222,"g":219,"b":204},"luminance":146.53584622542022},{"name":"Cod Grey","hex":"#2d3032","rgb":{"r":45,"g":48,"b":50},"luminance":31.73978577432431},{"name":"Codex Grey","hex":"#9c9c9c","rgb":{"r":156,"g":156,"b":156},"luminance":104.29460473102144},{"name":"Codium Fragile","hex":"#524b2a","rgb":{"r":82,"g":75,"b":42},"luminance":50.61875040930979},{"name":"Coelia Greenshade","hex":"#0e7f78","rgb":{"r":14,"g":127,"b":120},"luminance":75.90927741060376},{"name":"Coffee","hex":"#6f4e37","rgb":{"r":111,"g":78,"b":55},"luminance":56.89622498022166},{"name":"Coffee Addiction","hex":"#883300","rgb":{"r":136,"g":51,"b":0},"luminance":50.49539449296341},{"name":"Coffee Bag","hex":"#dbd6d3","rgb":{"r":219,"g":214,"b":211},"luminance":143.68798906310855},{"name":"Coffee Bar","hex":"#825c43","rgb":{"r":130,"g":92,"b":67},"luminance":66.97498010451366},{"name":"Coffee Bean","hex":"#362d26","rgb":{"r":54,"g":45,"b":38},"luminance":31.260386513925255},{"name":"Coffee Clay","hex":"#b7997c","rgb":{"r":183,"g":153,"b":124},"luminance":106.11216851049646},{"name":"Coffee Cream","hex":"#fff2d7","rgb":{"r":255,"g":242,"b":215},"luminance":163.07476518762797},{"name":"Coffee Custard","hex":"#ab9b9c","rgb":{"r":171,"g":155,"b":156},"luminance":105.87122140600816},{"name":"Coffee Diva","hex":"#bea88d","rgb":{"r":190,"g":168,"b":141},"luminance":114.9385271873622},{"name":"Coffee House","hex":"#6c5b4d","rgb":{"r":108,"g":91,"b":77},"luminance":63.0333438506954},{"name":"Coffee Kiss","hex":"#b19576","rgb":{"r":177,"g":149,"b":118},"luminance":103.10953691099576},{"name":"Coffee Liqueur","hex":"#6a513b","rgb":{"r":106,"g":81,"b":59},"luminance":57.53664850336696},{"name":"Coffee Rose","hex":"#a9898d","rgb":{"r":169,"g":137,"b":141},"luminance":96.32741560947227},{"name":"Coffee With Cream","hex":"#a68966","rgb":{"r":166,"g":137,"b":102},"luminance":95.21533437950004},{"name":"Cognac","hex":"#d48c46","rgb":{"r":212,"g":140,"b":70},"luminance":104.09260945907734},{"name":"Coin Purse","hex":"#e0d5e3","rgb":{"r":224,"g":213,"b":227},"luminance":144.1811583425518},{"name":"Coin Slot","hex":"#ff4411","rgb":{"r":255,"g":68,"b":17},"luminance":86.08334870925967},{"name":"Coincidence","hex":"#c7de88","rgb":{"r":199,"g":222,"b":136},"luminance":144.09192070688766},{"name":"Cola","hex":"#3c2f23","rgb":{"r":60,"g":47,"b":35},"luminance":33.149911327181556},{"name":"Cola Bubble","hex":"#3c3024","rgb":{"r":60,"g":48,"b":36},"luminance":33.65372775785767},{"name":"Cold Brew Coffee","hex":"#785736","rgb":{"r":120,"g":87,"b":54},"luminance":62.71613426383995},{"name":"Cold Current","hex":"#234272","rgb":{"r":35,"g":66,"b":114},"luminance":42.182399232381265},{"name":"Cold Grey","hex":"#9f9f9f","rgb":{"r":159,"g":159,"b":159},"luminance":106.30027020661801},{"name":"Cold Heights","hex":"#22ddee","rgb":{"r":34,"g":221,"b":238},"luminance":132.9232391608029},{"name":"Cold Light","hex":"#dde3e6","rgb":{"r":221,"g":227,"b":230},"luminance":151.0272115944673},{"name":"Cold Lips","hex":"#9ba0ef","rgb":{"r":155,"g":160,"b":239},"luminance":108.21815901686739},{"name":"Cold Morning","hex":"#e6e5e4","rgb":{"r":230,"g":229,"b":228},"luminance":153.21370660942839},{"name":"Cold Pilsner","hex":"#d09351","rgb":{"r":208,"g":147,"b":81},"luminance":106.76564588387035},{"name":"Cold Purple","hex":"#9d8abf","rgb":{"r":157,"g":138,"b":191},"luminance":96.12348496075244},{"name":"Cold Sea Currents","hex":"#32545e","rgb":{"r":50,"g":84,"b":94},"luminance":52.627122475012825},{"name":"Cold Shoulder","hex":"#d4e0ef","rgb":{"r":212,"g":224,"b":239},"luminance":148.49066369304165},{"name":"Cold Steel","hex":"#262335","rgb":{"r":38,"g":35,"b":53},"luminance":24.242479926773168},{"name":"Cold Turbulance","hex":"#cfe1ef","rgb":{"r":207,"g":225,"b":239},"luminance":148.3809070938711},{"name":"Cold Turkey","hex":"#cab5b2","rgb":{"r":202,"g":181,"b":178},"luminance":123.88748394006555},{"name":"Cold Water","hex":"#d9dfe0","rgb":{"r":217,"g":223,"b":224},"luminance":148.31373094221584},{"name":"Cold Wave","hex":"#c2e2e3","rgb":{"r":194,"g":226,"b":227},"luminance":147.0835584421318},{"name":"Cold Well Water","hex":"#c1e2e3","rgb":{"r":193,"g":226,"b":227},"luminance":146.9658973265567},{"name":"Cold Wind","hex":"#e1e3e4","rgb":{"r":225,"g":227,"b":228},"luminance":151.5150345345306},{"name":"Collard Green","hex":"#536861","rgb":{"r":83,"g":104,"b":97},"luminance":66.82081380079114},{"name":"Cologne","hex":"#75bfd2","rgb":{"r":117,"g":191,"b":210},"luminance":119.86307011753036},{"name":"Colonel Mustard","hex":"#b68238","rgb":{"r":182,"g":130,"b":56},"luminance":93.94301613212129},{"name":"Colonial Aqua","hex":"#a1bdbf","rgb":{"r":161,"g":189,"b":191},"luminance":122.88132342223533},{"name":"Colonial Blue","hex":"#2d6471","rgb":{"r":45,"g":100,"b":113},"luminance":61.58468112282469},{"name":"Colonial White","hex":"#ffedbc","rgb":{"r":255,"g":237,"b":188},"luminance":160.0834994932332},{"name":"Colony","hex":"#67a195","rgb":{"r":103,"g":161,"b":149},"luminance":100.83924064569308},{"name":"Colony Blue","hex":"#65769a","rgb":{"r":101,"g":118,"b":154},"luminance":77.57558567616489},{"name":"Color Blind","hex":"#c6d2de","rgb":{"r":198,"g":210,"b":222},"luminance":139.0714369236185},{"name":"Color Me Green","hex":"#7cb77b","rgb":{"r":124,"g":183,"b":123},"luminance":114.50116812067901},{"name":"Colorada Bronze","hex":"#ee7766","rgb":{"r":238,"g":119,"b":102},"luminance":100.39264035276689},{"name":"Colorado Dawn","hex":"#e09cab","rgb":{"r":224,"g":156,"b":171},"luminance":115.11399478777547},{"name":"Colorado Peach","hex":"#e6994c","rgb":{"r":230,"g":153,"b":76},"luminance":113.44775677376789},{"name":"Colorado Peak","hex":"#9c9ba7","rgb":{"r":156,"g":155,"b":167},"luminance":104.00181923889602},{"name":"Colorado Trail","hex":"#b49375","rgb":{"r":180,"g":147,"b":117},"luminance":102.56844624444693},{"name":"Colossus","hex":"#625c91","rgb":{"r":98,"g":92,"b":145},"luminance":63.62609621845426},{"name":"Columbia","hex":"#009288","rgb":{"r":0,"g":146,"b":136},"luminance":87.093092837492},{"name":"Columbia Blue","hex":"#9bddff","rgb":{"r":155,"g":221,"b":255},"luminance":140.79069022488667},{"name":"Columbo's Coat","hex":"#d0cbce","rgb":{"r":208,"g":203,"b":206},"luminance":136.45030978711625},{"name":"Columbus","hex":"#5f758f","rgb":{"r":95,"g":117,"b":143},"luminance":76.08813488317347},{"name":"Colusa Wetlands","hex":"#7f725c","rgb":{"r":127,"g":114,"b":92},"luminance":77.6528531156454},{"name":"Combed Cotton","hex":"#f4f0de","rgb":{"r":244,"g":240,"b":222},"luminance":160.65567901571362},{"name":"Comet","hex":"#636373","rgb":{"r":99,"g":99,"b":115},"luminance":66.52226747488392},{"name":"Comfort","hex":"#e3ceb8","rgb":{"r":227,"g":206,"b":184},"luminance":140.24573715090236},{"name":"Comforting Cherry","hex":"#cc1144","rgb":{"r":204,"g":17,"b":68},"luminance":62.29113870367116},{"name":"Comfrey","hex":"#5b7961","rgb":{"r":91,"g":121,"b":97},"luminance":76.85989704650925},{"name":"Commandes","hex":"#0b597c","rgb":{"r":11,"g":89,"b":124},"luminance":54.22153692030501},{"name":"Commercial White","hex":"#edece6","rgb":{"r":237,"g":236,"b":230},"luminance":157.79787131960938},{"name":"Common Calcedony","hex":"#c8ad7f","rgb":{"r":200,"g":173,"b":127},"luminance":118.73608585851227},{"name":"Common Chestnut","hex":"#cd5c5c","rgb":{"r":205,"g":92,"b":92},"luminance":82.36204942204874},{"name":"Common Dandelion","hex":"#fed85d","rgb":{"r":254,"g":216,"b":93},"luminance":148.17695024530636},{"name":"Common Feldspar","hex":"#858f94","rgb":{"r":133,"g":143,"b":148},"luminance":94.4042909723917},{"name":"Common Jasper","hex":"#946943","rgb":{"r":148,"g":105,"b":67},"luminance":76.25910944274133},{"name":"Common Teal","hex":"#009193","rgb":{"r":0,"g":145,"b":147},"luminance":86.74902759685551},{"name":"Community","hex":"#d0b997","rgb":{"r":208,"g":185,"b":151},"luminance":126.32118066658497},{"name":"Como","hex":"#4c785c","rgb":{"r":76,"g":120,"b":92},"luminance":74.75407627681584},{"name":"Compact Disc Grey","hex":"#cdcdcd","rgb":{"r":205,"g":205,"b":205},"luminance":137.0538074990987},{"name":"Composite Artefact Green","hex":"#55cc00","rgb":{"r":85,"g":204,"b":0},"luminance":122.41530022427752},{"name":"Concealment","hex":"#405852","rgb":{"r":64,"g":88,"b":82},"luminance":55.87409002391001},{"name":"Conceptual","hex":"#7ac34f","rgb":{"r":122,"g":195,"b":79},"luminance":120.47401688746},{"name":"Conch","hex":"#a0b1ae","rgb":{"r":160,"g":177,"b":174},"luminance":116.0910620892065},{"name":"Conch Pink","hex":"#dba496","rgb":{"r":219,"g":164,"b":150},"luminance":117.67624732714755},{"name":"Conch Shell","hex":"#fc8f9b","rgb":{"r":252,"g":143,"b":155},"luminance":114.17373377883374},{"name":"Conclave","hex":"#abb9d7","rgb":{"r":171,"g":185,"b":215},"luminance":122.50628051655147},{"name":"Concord","hex":"#827f79","rgb":{"r":130,"g":127,"b":121},"luminance":85.19803247141331},{"name":"Concord Grape","hex":"#7c5379","rgb":{"r":124,"g":83,"b":121},"luminance":62.75858549234518},{"name":"Concord Jam","hex":"#695a82","rgb":{"r":105,"g":90,"b":130},"luminance":63.21619511644148},{"name":"Concrete","hex":"#d2d1cd","rgb":{"r":210,"g":209,"b":205},"luminance":139.7850474442814},{"name":"Concrete Jungle","hex":"#999988","rgb":{"r":153,"g":153,"b":136},"luminance":101.97635876025383},{"name":"Condiment","hex":"#b98142","rgb":{"r":185,"g":129,"b":66},"luminance":94.07620597154202},{"name":"Conditioner","hex":"#ffffcc","rgb":{"r":255,"g":255,"b":204},"luminance":169.58697115639515},{"name":"Confederate","hex":"#5c6272","rgb":{"r":92,"g":98,"b":114},"luminance":65.07554652863085},{"name":"Confetti","hex":"#ddcb46","rgb":{"r":221,"g":203,"b":70},"luminance":136.48977456937936},{"name":"Confidence","hex":"#a98a6b","rgb":{"r":169,"g":138,"b":107},"luminance":96.25042961462562},{"name":"Confident Yellow","hex":"#ffcc13","rgb":{"r":255,"g":204,"b":19},"luminance":141.9773752574684},{"name":"Cōng Lǜ Green","hex":"#01c08d","rgb":{"r":1,"g":192,"b":141},"luminance":113.8448702972602},{"name":"Congo","hex":"#e8c3be","rgb":{"r":232,"g":195,"b":190},"luminance":135.585070155235},{"name":"Congo Brown","hex":"#654d49","rgb":{"r":101,"g":77,"b":73},"luminance":54.99258937347832},{"name":"Congo Capture","hex":"#776959","rgb":{"r":119,"g":105,"b":89},"luminance":71.88756569810944},{"name":"Congo Green","hex":"#00a483","rgb":{"r":0,"g":164,"b":131},"luminance":97.41946509810039},{"name":"Congo Pink","hex":"#f98379","rgb":{"r":249,"g":131,"b":121},"luminance":107.9183693631441},{"name":"Congress Blue","hex":"#02478e","rgb":{"r":2,"g":71,"b":142},"luminance":44.71444148147218},{"name":"Conifer","hex":"#b1dd52","rgb":{"r":177,"g":221,"b":82},"luminance":140.41838754949438},{"name":"Conifer Blossom","hex":"#ffdd49","rgb":{"r":255,"g":221,"b":73},"luminance":150.7038494465221},{"name":"Conifer Cone","hex":"#885555","rgb":{"r":136,"g":85,"b":85},"luminance":65.09199659712398},{"name":"Conker","hex":"#b94e41","rgb":{"r":185,"g":78,"b":65},"luminance":72.18736122757223},{"name":"Conker Brown","hex":"#552200","rgb":{"r":85,"g":34,"b":0},"luminance":32.31476425722459},{"name":"Connect Red","hex":"#eb6651","rgb":{"r":235,"g":102,"b":81},"luminance":92.77571264614464},{"name":"Connecticut Lilac","hex":"#ccbbee","rgb":{"r":204,"g":187,"b":238},"luminance":128.47525365221117},{"name":"Conservation","hex":"#796e54","rgb":{"r":121,"g":110,"b":84},"luminance":74.63179427697018},{"name":"Conspiracy Velvet","hex":"#57465d","rgb":{"r":87,"g":70,"b":93},"luminance":49.7741566779388},{"name":"Constellation","hex":"#bccedb","rgb":{"r":188,"g":206,"b":219},"luminance":135.6658401514545},{"name":"Contessa","hex":"#c16f68","rgb":{"r":193,"g":111,"b":104},"luminance":87.84131848964928},{"name":"Continental Waters","hex":"#98c6cb","rgb":{"r":152,"g":198,"b":203},"luminance":126.92342551318099},{"name":"Contrail","hex":"#dedeff","rgb":{"r":222,"g":222,"b":255},"luminance":149.10681533719375},{"name":"Cook's Bay","hex":"#014e83","rgb":{"r":1,"g":78,"b":131},"luminance":48.16089236091872},{"name":"Cookie Crumb","hex":"#b19778","rgb":{"r":177,"g":151,"b":120},"luminance":104.13694876459556},{"name":"Cookie Dough","hex":"#ab7100","rgb":{"r":171,"g":113,"b":0},"luminance":83.74948478647495},{"name":"Cookies And Cream","hex":"#eee0b1","rgb":{"r":238,"g":224,"b":177},"luminance":150.86509229109296},{"name":"Cool","hex":"#96b3b3","rgb":{"r":150,"g":179,"b":179},"luminance":116.05284427794089},{"name":"Cool Black","hex":"#002e63","rgb":{"r":0,"g":46,"b":99},"luminance":29.265710310874052},{"name":"Cool Blue","hex":"#4984b8","rgb":{"r":73,"g":132,"b":184},"luminance":83.18762384513695},{"name":"Cool Camel","hex":"#ae996b","rgb":{"r":174,"g":153,"b":107},"luminance":104.50603619408784},{"name":"Cool Camo","hex":"#827566","rgb":{"r":130,"g":117,"b":102},"luminance":79.76773987646887},{"name":"Cool Cantaloupe","hex":"#f1d3ca","rgb":{"r":241,"g":211,"b":202},"luminance":145.1321629205601},{"name":"Cool Charcoal","hex":"#807b76","rgb":{"r":128,"g":123,"b":118},"luminance":82.81718836690847},{"name":"Cool Clay","hex":"#ba947b","rgb":{"r":186,"g":148,"b":123},"luminance":104.10078220647527},{"name":"Cool Concrete","hex":"#d9d0c1","rgb":{"r":217,"g":208,"b":193},"luminance":140.00473173789518},{"name":"Cool Copper","hex":"#ad8458","rgb":{"r":173,"g":132,"b":88},"luminance":93.70215477244906},{"name":"Cool Crayon","hex":"#b0e6e3","rgb":{"r":176,"g":230,"b":227},"luminance":147.19597942878738},{"name":"Cool Current","hex":"#283c44","rgb":{"r":40,"g":60,"b":68},"luminance":37.99451939424948},{"name":"Cool December","hex":"#fdfbf8","rgb":{"r":253,"g":251,"b":248},"luminance":168.017755496257},{"name":"Cool Dive","hex":"#00606f","rgb":{"r":0,"g":96,"b":111},"luminance":57.75527352545393},{"name":"Cool Frost","hex":"#e7e6ed","rgb":{"r":231,"g":230,"b":237},"luminance":154.0396026513961},{"name":"Cool Green","hex":"#33b864","rgb":{"r":51,"g":184,"b":100},"luminance":109.67324224714065},{"name":"Cool Grey","hex":"#8c93ad","rgb":{"r":140,"g":147,"b":173},"luminance":97.91326981058288},{"name":"Cool Icicle","hex":"#e1eee6","rgb":{"r":225,"g":238,"b":230},"luminance":157.26150342979682},{"name":"Cool Lavender","hex":"#b3a6a5","rgb":{"r":179,"g":166,"b":165},"luminance":112.75307935927958},{"name":"Cool Melon","hex":"#ebd1cd","rgb":{"r":235,"g":209,"b":205},"luminance":143.29844944729862},{"name":"Cool Purple","hex":"#aa23ff","rgb":{"r":170,"g":35,"b":255},"luminance":62.05522399443901},{"name":"Cool Quiet","hex":"#cbb5c6","rgb":{"r":203,"g":181,"b":198},"luminance":124.42687009645465},{"name":"Cool Slate","hex":"#d0ccc5","rgb":{"r":208,"g":204,"b":197},"luminance":136.7910455110275},{"name":"Cool Touch","hex":"#7295c9","rgb":{"r":114,"g":149,"b":201},"luminance":96.62651375787082},{"name":"Cool Waters","hex":"#487678","rgb":{"r":72,"g":118,"b":120},"luminance":73.81311495933495},{"name":"Cool Yellow","hex":"#eaefce","rgb":{"r":234,"g":239,"b":206},"luminance":158.5208669576343},{"name":"Cooled Cream","hex":"#fadc97","rgb":{"r":250,"g":220,"b":151},"luminance":150.203275250575},{"name":"Cooling Trend","hex":"#e6e2e4","rgb":{"r":230,"g":226,"b":228},"luminance":151.67103615390778},{"name":"Copacabana","hex":"#006c8d","rgb":{"r":0,"g":108,"b":141},"luminance":65.40203583987275},{"name":"Copacabana Sand","hex":"#e5d68e","rgb":{"r":229,"g":214,"b":142},"luminance":143.9798982809753},{"name":"Copen Blue","hex":"#516b84","rgb":{"r":81,"g":107,"b":132},"luminance":68.97805988863415},{"name":"Copenhagen","hex":"#adc8c0","rgb":{"r":173,"g":200,"b":192},"luminance":130.1442548597517},{"name":"Copper","hex":"#b87333","rgb":{"r":184,"g":115,"b":51},"luminance":87.27822109209147},{"name":"Copper Beech","hex":"#b1715a","rgb":{"r":177,"g":113,"b":90},"luminance":85.47463419050122},{"name":"Copper Blush","hex":"#e8c1ab","rgb":{"r":232,"g":193,"b":171},"luminance":134.2638675928859},{"name":"Copper Brown","hex":"#9a6051","rgb":{"r":154,"g":96,"b":81},"luminance":73.35563220366927},{"name":"Copper Canyon","hex":"#77422c","rgb":{"r":119,"g":66,"b":44},"luminance":52.84042373978467},{"name":"Copper Coin","hex":"#da8a67","rgb":{"r":218,"g":138,"b":103},"luminance":104.63526998101548},{"name":"Copper Cove","hex":"#d89166","rgb":{"r":216,"g":145,"b":102},"luminance":107.47495831587933},{"name":"Copper Creek","hex":"#a35d31","rgb":{"r":163,"g":93,"b":49},"luminance":73.39397690546548},{"name":"Copper Lake","hex":"#c09078","rgb":{"r":192,"g":144,"b":120},"luminance":103.09123943381415},{"name":"Copper Mining","hex":"#945c54","rgb":{"r":148,"g":92,"b":84},"luminance":70.47248609209129},{"name":"Copper Penny","hex":"#ad6f69","rgb":{"r":173,"g":111,"b":105},"luminance":84.0499736942255},{"name":"Copper Pipe","hex":"#da8f67","rgb":{"r":218,"g":143,"b":103},"luminance":106.92361371091044},{"name":"Copper Pot","hex":"#936647","rgb":{"r":147,"g":102,"b":71},"luminance":74.71462320724103},{"name":"Copper Red","hex":"#cb6d51","rgb":{"r":203,"g":109,"b":81},"luminance":88.6747813868182},{"name":"Copper River","hex":"#f7a270","rgb":{"r":247,"g":162,"b":112},"luminance":121.07913226068314},{"name":"Copper Rose","hex":"#996666","rgb":{"r":153,"g":102,"b":102},"luminance":76.2423390840024},{"name":"Copper Rust","hex":"#95524c","rgb":{"r":149,"g":82,"b":76},"luminance":66.15692294083817},{"name":"Copper Tan","hex":"#de8e65","rgb":{"r":222,"g":142,"b":101},"luminance":107.17509223695586},{"name":"Copper Trail","hex":"#c18978","rgb":{"r":193,"g":137,"b":120},"luminance":99.92224882377297},{"name":"Copper Turquoise","hex":"#38887f","rgb":{"r":56,"g":136,"b":127},"luminance":82.84396323209072},{"name":"Copper Wire","hex":"#db8b67","rgb":{"r":219,"g":139,"b":103},"luminance":105.27608263038664},{"name":"Copperfield","hex":"#da8a88","rgb":{"r":218,"g":138,"b":136},"luminance":105.1239229481092},{"name":"Coppersmith","hex":"#d98a3f","rgb":{"r":217,"g":138,"b":63},"luminance":104.03536345397174},{"name":"Coppery Orange","hex":"#7f4330","rgb":{"r":127,"g":67,"b":48},"luminance":54.942349367314094},{"name":"Copra","hex":"#654636","rgb":{"r":101,"g":70,"b":54},"luminance":51.3640344696559},{"name":"Coquelicot","hex":"#ff3800","rgb":{"r":255,"g":56,"b":0},"luminance":83.02932258545772},{"name":"Cor-de-pele","hex":"#f4c2c2","rgb":{"r":244,"g":194,"b":194},"luminance":137.03975436346929},{"name":"Coral","hex":"#ff7f50","rgb":{"r":255,"g":127,"b":80},"luminance":107.02349193518215},{"name":"Coral Almond","hex":"#e29d94","rgb":{"r":226,"g":157,"b":148},"luminance":115.51705995652762},{"name":"Coral Atoll","hex":"#dc938d","rgb":{"r":220,"g":147,"b":141},"luminance":109.68670565296416},{"name":"Coral Beach","hex":"#ffbbaa","rgb":{"r":255,"g":187,"b":170},"luminance":135.04857565335516},{"name":"Coral Bisque","hex":"#f7c6b1","rgb":{"r":247,"g":198,"b":177},"luminance":139.17578944988958},{"name":"Coral Blossom","hex":"#f7bea2","rgb":{"r":247,"g":190,"b":162},"luminance":135.03434205045767},{"name":"Coral Blush","hex":"#e5a090","rgb":{"r":229,"g":160,"b":144},"luminance":117.38283220726954},{"name":"Coral Burst","hex":"#dd5544","rgb":{"r":221,"g":85,"b":68},"luminance":83.16272464271478},{"name":"Coral Candy","hex":"#f5d0c9","rgb":{"r":245,"g":208,"b":201},"luminance":144.2178201090281},{"name":"Coral Clay","hex":"#c2b1a1","rgb":{"r":194,"g":177,"b":161},"luminance":120.4016924839514},{"name":"Coral Cloud","hex":"#e2a9a1","rgb":{"r":226,"g":169,"b":161},"luminance":121.42631510920522},{"name":"Coral Coast","hex":"#068e9e","rgb":{"r":6,"g":142,"b":158},"luminance":85.29677541384551},{"name":"Coral Cornsnake","hex":"#e9adca","rgb":{"r":233,"g":173,"b":202},"luminance":125.28521570400873},{"name":"Coral Cove","hex":"#dda69f","rgb":{"r":221,"g":166,"b":159},"luminance":119.12149042469204},{"name":"Coral Cream","hex":"#ead6ce","rgb":{"r":234,"g":214,"b":206},"luminance":145.69358714782197},{"name":"Coral Dusk","hex":"#ffb48a","rgb":{"r":255,"g":180,"b":138},"luminance":131.24340535432628},{"name":"Coral Dust","hex":"#edaa86","rgb":{"r":237,"g":170,"b":134},"luminance":123.34084905253408},{"name":"Coral Garden","hex":"#cf8179","rgb":{"r":207,"g":129,"b":121},"luminance":98.76735601401913},{"name":"Coral Gold","hex":"#d27d56","rgb":{"r":210,"g":125,"b":86},"luminance":97.07004244873904},{"name":"Coral Haze","hex":"#e38e84","rgb":{"r":227,"g":142,"b":132},"luminance":108.54066403426874},{"name":"Coral Kiss","hex":"#ffddc7","rgb":{"r":255,"g":221,"b":199},"luminance":152.17440372809088},{"name":"Coral Pink","hex":"#f88379","rgb":{"r":248,"g":131,"b":121},"luminance":107.71231196571726},{"name":"Coral Quartz","hex":"#f77464","rgb":{"r":247,"g":116,"b":100},"luminance":101.09770557732752},{"name":"Coral Red","hex":"#ff4040","rgb":{"r":255,"g":64,"b":64},"luminance":85.31052845340953},{"name":"Coral Reef","hex":"#c7bca2","rgb":{"r":199,"g":188,"b":162},"luminance":126.72759273733561},{"name":"Coral Rose","hex":"#f3774d","rgb":{"r":243,"g":119,"b":77},"luminance":101.17081862869352},{"name":"Coral Sand","hex":"#ca884e","rgb":{"r":202,"g":136,"b":78},"luminance":100.49942433665976},{"name":"Coral Serenade","hex":"#f9a48e","rgb":{"r":249,"g":164,"b":142},"luminance":122.77023486578496},{"name":"Coral Silk","hex":"#f2a37d","rgb":{"r":242,"g":163,"b":125},"luminance":120.80395864788538},{"name":"Coral Tree","hex":"#ab6e67","rgb":{"r":171,"g":110,"b":103},"luminance":83.19455574134643},{"name":"Corally","hex":"#fea89f","rgb":{"r":254,"g":168,"b":159},"luminance":125.78339416632069},{"name":"Corbeau","hex":"#111122","rgb":{"r":17,"g":17,"b":34},"luminance":11.850768160756498},{"name":"Cordon Bleu Crust","hex":"#ebe0c8","rgb":{"r":235,"g":224,"b":200},"luminance":150.81811684608715},{"name":"Cordovan","hex":"#893f45","rgb":{"r":137,"g":63,"b":69},"luminance":55.744378066312656},{"name":"Corduroy","hex":"#404d49","rgb":{"r":64,"g":77,"b":73},"luminance":49.78344886606391},{"name":"Corfu Shallows","hex":"#008e8d","rgb":{"r":0,"g":142,"b":141},"luminance":84.88970957660298},{"name":"Corfu Sky","hex":"#8993c3","rgb":{"r":137,"g":147,"b":195},"luminance":98.07105480211784},{"name":"Corfu Waters","hex":"#008aad","rgb":{"r":0,"g":138,"b":173},"luminance":83.37223350732545},{"name":"Coriander","hex":"#bbb58d","rgb":{"r":187,"g":181,"b":141},"luminance":121.1324153725996},{"name":"Corinthian Column","hex":"#dedecf","rgb":{"r":222,"g":222,"b":207},"luminance":148.13724408129104},{"name":"Cork","hex":"#5a4c42","rgb":{"r":90,"g":76,"b":66},"luminance":52.640186359852486},{"name":"Cork Bark","hex":"#7e6b43","rgb":{"r":126,"g":107,"b":67},"luminance":73.63857549545618},{"name":"Cork Brown","hex":"#cc8855","rgb":{"r":204,"g":136,"b":85},"luminance":100.93342528617562},{"name":"Cork Wood","hex":"#cc7744","rgb":{"r":204,"g":119,"b":68},"luminance":93.05937421345578},{"name":"Corkboard","hex":"#9d805d","rgb":{"r":157,"g":128,"b":93},"luminance":89.22704830375147},{"name":"Corkscrew Willow","hex":"#d1b9ab","rgb":{"r":209,"g":185,"b":171},"luminance":126.79911333286208},{"name":"Corn","hex":"#fbec5d","rgb":{"r":251,"g":236,"b":93},"luminance":157.91095537992288},{"name":"Corn Bread","hex":"#eec657","rgb":{"r":238,"g":198,"b":87},"luminance":136.64142872496612},{"name":"Corn Field","hex":"#f8f3c4","rgb":{"r":248,"g":243,"b":196},"luminance":162.309051876351},{"name":"Corn Harvest","hex":"#8d702a","rgb":{"r":141,"g":112,"b":42},"luminance":78.24691534495146},{"name":"Corn Husk","hex":"#f2d6ae","rgb":{"r":242,"g":214,"b":174},"luminance":146.31824556083222},{"name":"Corn Kernel","hex":"#ffcba4","rgb":{"r":255,"g":203,"b":164},"luminance":142.69612595301948},{"name":"Corn Poppy Cherry","hex":"#ee4411","rgb":{"r":238,"g":68,"b":17},"luminance":81.6153977139118},{"name":"Corn Snake","hex":"#ab6134","rgb":{"r":171,"g":97,"b":52},"luminance":76.75523139174292},{"name":"Cornell Red","hex":"#b31b11","rgb":{"r":179,"g":27,"b":17},"luminance":55.85198372484186},{"name":"Cornerstone","hex":"#e3d7bb","rgb":{"r":227,"g":215,"b":187},"luminance":144.87547507428576},{"name":"Cornflake","hex":"#f0e68c","rgb":{"r":240,"g":230,"b":140},"luminance":153.72676832614417},{"name":"Cornflower","hex":"#5170d7","rgb":{"r":81,"g":112,"b":215},"luminance":74.22650198547686},{"name":"Cornflower Blue","hex":"#7391c8","rgb":{"r":115,"g":145,"b":200},"luminance":94.58716324110793},{"name":"Cornflower Lilac","hex":"#ffb0ac","rgb":{"r":255,"g":176,"b":172},"luminance":129.88896424639006},{"name":"Cornsilk","hex":"#fff8dc","rgb":{"r":255,"g":248,"b":220},"luminance":166.23681361539627},{"name":"Cornsilk Yellow","hex":"#f4c96c","rgb":{"r":244,"g":201,"b":108},"luminance":139.26627534690513},{"name":"Cornstalk","hex":"#a9947a","rgb":{"r":169,"g":148,"b":122},"luminance":101.46060221090745},{"name":"Cornucopia","hex":"#ed9b44","rgb":{"r":237,"g":155,"b":68},"luminance":115.58515691039227},{"name":"Corona","hex":"#ffb437","rgb":{"r":255,"g":180,"b":55},"luminance":130.44787665960683},{"name":"Coronado Moss","hex":"#9ba591","rgb":{"r":155,"g":165,"b":145},"luminance":108.63696861566046},{"name":"Coronation","hex":"#edecec","rgb":{"r":237,"g":236,"b":236},"luminance":157.9129665638639},{"name":"Coronet Blue","hex":"#59728e","rgb":{"r":89,"g":114,"b":142},"luminance":73.81202740068856},{"name":"Corporate Green","hex":"#78a486","rgb":{"r":120,"g":164,"b":134},"luminance":103.86654129217936},{"name":"Corral","hex":"#61513d","rgb":{"r":97,"g":81,"b":61},"luminance":56.12708200147233},{"name":"Corsair","hex":"#18576c","rgb":{"r":24,"g":87,"b":108},"luminance":53.020025282906076},{"name":"Corsican","hex":"#85ac9d","rgb":{"r":133,"g":172,"b":157},"luminance":109.97946166898618},{"name":"Corsican Blue","hex":"#646093","rgb":{"r":100,"g":96,"b":147},"luminance":65.95747469392684},{"name":"Cortex","hex":"#a99592","rgb":{"r":169,"g":149,"b":146},"luminance":102.37275548699468},{"name":"Cortez Chocolate","hex":"#a4896a","rgb":{"r":164,"g":137,"b":106},"luminance":94.96192875568609},{"name":"Corvette","hex":"#e9ba81","rgb":{"r":233,"g":186,"b":129},"luminance":130.34748347781786},{"name":"Corydalis Blue","hex":"#a9cada","rgb":{"r":169,"g":202,"b":218},"luminance":131.26613173625555},{"name":"Cos","hex":"#a4c48e","rgb":{"r":164,"g":196,"b":142},"luminance":126.1092516193796},{"name":"Cosmic","hex":"#b8b9cb","rgb":{"r":184,"g":185,"b":203},"luminance":123.91604595450906},{"name":"Cosmic Aura","hex":"#cfb3a6","rgb":{"r":207,"g":179,"b":166},"luminance":123.40663091584665},{"name":"Cosmic Cobalt","hex":"#2e2d88","rgb":{"r":46,"g":45,"b":136},"luminance":33.57527002125225},{"name":"Cosmic Dust","hex":"#dce2e5","rgb":{"r":220,"g":226,"b":229},"luminance":150.35869738728118},{"name":"Cosmic Energy","hex":"#9392ab","rgb":{"r":147,"g":146,"b":171},"luminance":98.26858627760959},{"name":"Cosmic Latte","hex":"#fff8e7","rgb":{"r":255,"g":248,"b":231},"luminance":166.43062025060172},{"name":"Cosmic Ray","hex":"#cadada","rgb":{"r":202,"g":218,"b":218},"luminance":143.66919455471307},{"name":"Cosmic Sky","hex":"#aaaac4","rgb":{"r":170,"g":170,"b":196},"luminance":114.19714241608675},{"name":"Cosmo Purple","hex":"#a09bc6","rgb":{"r":160,"g":155,"b":198},"luminance":105.24462460857562},{"name":"Cosmopolitan","hex":"#528bab","rgb":{"r":82,"g":139,"b":171},"luminance":87.39889020462444},{"name":"Cosmos","hex":"#fcd5cf","rgb":{"r":252,"g":213,"b":207},"luminance":147.87473641227564},{"name":"Cossack Dancer","hex":"#4d8aa1","rgb":{"r":77,"g":138,"b":161},"luminance":86.19106613216941},{"name":"Costa Del Sol","hex":"#625d2a","rgb":{"r":98,"g":93,"b":42},"luminance":62.142653861900676},{"name":"Costa Rican Palm","hex":"#c44041","rgb":{"r":196,"g":64,"b":65},"luminance":70.00493939715969},{"name":"Cotswold Dill","hex":"#dbcdad","rgb":{"r":219,"g":205,"b":173},"luminance":138.40964876048199},{"name":"Cottage Green","hex":"#dcecdc","rgb":{"r":220,"g":236,"b":220},"luminance":155.3934677648967},{"name":"Cottage White","hex":"#f7efdd","rgb":{"r":247,"g":239,"b":221},"luminance":160.53388768107496},{"name":"Cottingley Fairies","hex":"#eddbd7","rgb":{"r":237,"g":219,"b":215},"luminance":148.82264168465764},{"name":"Cotton Ball","hex":"#f2f7fd","rgb":{"r":242,"g":247,"b":253},"luminance":164.58842987585732},{"name":"Cotton Candy","hex":"#ffbcd9","rgb":{"r":255,"g":188,"b":217},"luminance":136.3954376253106},{"name":"Cotton Cardigan","hex":"#7596b8","rgb":{"r":117,"g":150,"b":184},"luminance":97.03919499356948},{"name":"Cotton Cloth","hex":"#faf4d4","rgb":{"r":250,"g":244,"b":212},"luminance":163.35824040433343},{"name":"Cotton Club","hex":"#f3e4d3","rgb":{"r":243,"g":228,"b":211},"luminance":154.1742827484532},{"name":"Cotton Field","hex":"#f2f0e8","rgb":{"r":242,"g":240,"b":232},"luminance":160.56883654059402},{"name":"Cotton Flannel","hex":"#9090a2","rgb":{"r":144,"g":144,"b":162},"luminance":96.64299738729133},{"name":"Cotton Puff","hex":"#ffffe7","rgb":{"r":255,"g":255,"b":231},"luminance":170.03640435506745},{"name":"Cotton Seed","hex":"#bfbaaf","rgb":{"r":191,"g":186,"b":175},"luminance":124.82046909461604},{"name":"Cotton Tail","hex":"#fff8d7","rgb":{"r":255,"g":248,"b":215},"luminance":166.15177369200725},{"name":"Cotton Wool Blue","hex":"#83abd2","rgb":{"r":131,"g":171,"b":210},"luminance":110.37606755995613},{"name":"Country Air","hex":"#9fb6c6","rgb":{"r":159,"g":182,"b":198},"luminance":119.09301163796303},{"name":"Country Blue","hex":"#717f9b","rgb":{"r":113,"g":127,"b":155},"luminance":83.73376660583232},{"name":"Country Charm","hex":"#c7c0a7","rgb":{"r":199,"g":192,"b":167},"luminance":128.86041308718515},{"name":"Country Club","hex":"#948675","rgb":{"r":148,"g":134,"b":117},"luminance":91.23169795635725},{"name":"Country Cottage","hex":"#d9c1b7","rgb":{"r":217,"g":193,"b":183},"luminance":132.21148745097756},{"name":"Country Rubble","hex":"#d0bca2","rgb":{"r":208,"g":188,"b":162},"luminance":128.01311895270734},{"name":"Country Sky","hex":"#49545a","rgb":{"r":73,"g":84,"b":90},"luminance":54.89047634152941},{"name":"Country Sleigh","hex":"#7e4337","rgb":{"r":126,"g":67,"b":55},"luminance":54.82165098754323},{"name":"Country Summer","hex":"#fffbd7","rgb":{"r":255,"g":251,"b":215},"luminance":167.69684461551444},{"name":"County Green","hex":"#1b4b35","rgb":{"r":27,"g":75,"b":53},"luminance":45.16502759879595},{"name":"Court Jester","hex":"#926d9d","rgb":{"r":146,"g":109,"b":157},"luminance":79.49738617715678},{"name":"Courtyard Green","hex":"#978d71","rgb":{"r":151,"g":141,"b":113},"luminance":95.15647331632252},{"name":"Couscous","hex":"#ffe29b","rgb":{"r":255,"g":226,"b":155},"luminance":154.02835832728985},{"name":"Cousteau","hex":"#55a9d6","rgb":{"r":85,"g":169,"b":214},"luminance":105.2726092105634},{"name":"Cover of Night","hex":"#494e4f","rgb":{"r":73,"g":78,"b":79},"luminance":51.515859315360345},{"name":"Covered in Platinum","hex":"#b9baba","rgb":{"r":185,"g":186,"b":186},"luminance":124.21782466699374},{"name":"Covered Wagon","hex":"#726449","rgb":{"r":114,"g":100,"b":73},"luminance":68.38714118896914},{"name":"Covert Green","hex":"#80765f","rgb":{"r":128,"g":118,"b":95},"luminance":79.87373560814592},{"name":"Coverts Wood Pigeon","hex":"#d4cdd2","rgb":{"r":212,"g":205,"b":210},"luminance":138.10023305193948},{"name":"Cow's Milk","hex":"#f1ede5","rgb":{"r":241,"g":237,"b":229},"luminance":158.8336201123679},{"name":"Cowardly Custard","hex":"#fbf1c0","rgb":{"r":251,"g":241,"b":192},"luminance":161.63028501490678},{"name":"Cowbell","hex":"#ffe481","rgb":{"r":255,"g":228,"b":129},"luminance":154.7308674990223},{"name":"Cowboy","hex":"#443736","rgb":{"r":68,"g":55,"b":54},"luminance":38.64722221583331},{"name":"Cowboy Hat","hex":"#b27d50","rgb":{"r":178,"g":125,"b":80},"luminance":91.102394639219},{"name":"Cowboy Trails","hex":"#8d6b4b","rgb":{"r":141,"g":107,"b":75},"luminance":76.12788097668292},{"name":"Cowgirl Boots","hex":"#9e7c60","rgb":{"r":158,"g":124,"b":96},"luminance":87.46239559948035},{"name":"Cowhide","hex":"#884344","rgb":{"r":136,"g":67,"b":68},"luminance":57.10012820475975},{"name":"Cowpeas","hex":"#661100","rgb":{"r":102,"g":17,"b":0},"luminance":32.08907049136824},{"name":"Coy","hex":"#fff4f3","rgb":{"r":255,"g":244,"b":243},"luminance":164.60547017945666},{"name":"Coyote","hex":"#dc9b68","rgb":{"r":220,"g":155,"b":104},"luminance":112.89749049912491},{"name":"Coyote Brown","hex":"#81613c","rgb":{"r":129,"g":97,"b":60},"luminance":69.11264256270339},{"name":"Coyote Tracks","hex":"#b08f7f","rgb":{"r":176,"g":143,"b":127},"luminance":100.12486874398387},{"name":"Cozy Cottage","hex":"#f2ddd8","rgb":{"r":242,"g":221,"b":216},"luminance":150.56930653024872},{"name":"Cozy Cover","hex":"#e4c38f","rgb":{"r":228,"g":195,"b":143},"luminance":134.2215072669056},{"name":"Cozy Cream","hex":"#e0dbc7","rgb":{"r":224,"g":219,"b":199},"luminance":146.7184820702559},{"name":"Cozy Wool","hex":"#d1b99b","rgb":{"r":209,"g":185,"b":155},"luminance":126.53152969121965},{"name":"Crab Bisque","hex":"#f0b599","rgb":{"r":240,"g":181,"b":153},"luminance":129.39144474423338},{"name":"Crab-Apple","hex":"#f0e681","rgb":{"r":240,"g":230,"b":129},"luminance":153.60164105894182},{"name":"Crabapple","hex":"#87382f","rgb":{"r":135,"g":56,"b":47},"luminance":52.33172816752758},{"name":"Cracked Earth","hex":"#c5b1a0","rgb":{"r":197,"g":177,"b":160},"luminance":120.8191342875788},{"name":"Cracked Slate","hex":"#69656a","rgb":{"r":105,"g":101,"b":106},"luminance":68.16610191290096},{"name":"Cracker Bitz","hex":"#d1b088","rgb":{"r":209,"g":176,"b":136},"luminance":121.73277471987566},{"name":"Cracker Crumbs","hex":"#d3b9b0","rgb":{"r":211,"g":185,"b":176},"luminance":127.18356828615873},{"name":"Crackled Leather","hex":"#a27c4f","rgb":{"r":162,"g":124,"b":79},"luminance":87.89448688057743},{"name":"Crackling Lake","hex":"#b3c5cc","rgb":{"r":179,"g":197,"b":204},"luminance":129.52882805769534},{"name":"Cradle Pillow","hex":"#f1d3d9","rgb":{"r":241,"g":211,"b":217},"luminance":145.4132888494033},{"name":"Cradle Pink","hex":"#edd0dd","rgb":{"r":237,"g":208,"b":221},"luminance":143.40061234527556},{"name":"Craft","hex":"#293b4a","rgb":{"r":41,"g":59,"b":74},"luminance":37.694745867295616},{"name":"Craftsman Gold","hex":"#d3b78b","rgb":{"r":211,"g":183,"b":139},"luminance":125.5810052436275},{"name":"Craggy Skin","hex":"#f7bd7b","rgb":{"r":247,"g":189,"b":123},"luminance":134.01205670386526},{"name":"Crail","hex":"#a65648","rgb":{"r":166,"g":86,"b":72},"luminance":71.26947133240151},{"name":"Cranapple","hex":"#db8079","rgb":{"r":219,"g":128,"b":121},"luminance":100.61537801449637},{"name":"Cranberry","hex":"#9e003a","rgb":{"r":158,"g":0,"b":58},"luminance":47.70246438078435},{"name":"Cranberry Pie","hex":"#c27277","rgb":{"r":194,"g":114,"b":119},"luminance":89.5921375791425},{"name":"Cranberry Sauce","hex":"#a53756","rgb":{"r":165,"g":55,"b":86},"luminance":59.76940576917257},{"name":"Cranberry Splash","hex":"#da5265","rgb":{"r":218,"g":82,"b":101},"luminance":81.84220962315229},{"name":"Crash Pink","hex":"#cc88ff","rgb":{"r":204,"g":136,"b":255},"luminance":104.58836044225953},{"name":"Crashing Waves","hex":"#3e6f87","rgb":{"r":62,"g":111,"b":135},"luminance":69.46901606471766},{"name":"Crater Brown","hex":"#4d3e3c","rgb":{"r":77,"g":62,"b":60},"luminance":43.604671366724},{"name":"Crater Crawler","hex":"#c8ced6","rgb":{"r":200,"g":206,"b":214},"luminance":137.08878473456534},{"name":"Cray","hex":"#bc763c","rgb":{"r":188,"g":118,"b":60},"luminance":89.46705147706611},{"name":"Crayola Green","hex":"#1dac78","rgb":{"r":29,"g":172,"b":120},"luminance":102.25486754673344},{"name":"Crayola Orange","hex":"#fe7438","rgb":{"r":254,"g":116,"b":56},"luminance":102.20112932839832},{"name":"Crazy","hex":"#e5cb3f","rgb":{"r":229,"g":203,"b":63},"luminance":137.61977650759354},{"name":"Crazy Eyes","hex":"#5eb68d","rgb":{"r":94,"g":182,"b":141},"luminance":111.63254125925826},{"name":"Crazy Horse Mountain","hex":"#e9dbd2","rgb":{"r":233,"g":219,"b":210},"luminance":148.16372126131282},{"name":"Cream","hex":"#ffffc2","rgb":{"r":255,"g":255,"b":194},"luminance":169.4344023685863},{"name":"Cream Blush","hex":"#f8c19a","rgb":{"r":248,"g":193,"b":154},"luminance":136.53418224386155},{"name":"Cream Cake","hex":"#e3d0ad","rgb":{"r":227,"g":208,"b":173},"luminance":141.07846975708233},{"name":"Cream Can","hex":"#eec051","rgb":{"r":238,"g":192,"b":81},"luminance":133.609463048094},{"name":"Cream Cheese Avocado","hex":"#d7d3a6","rgb":{"r":215,"g":211,"b":166},"luminance":140.82341939464473},{"name":"Cream Cheese Frosting","hex":"#f4efe2","rgb":{"r":244,"g":239,"b":226},"luminance":160.21388042551118},{"name":"Cream Clear","hex":"#f1f3da","rgb":{"r":241,"g":243,"b":218},"luminance":161.72994857477696},{"name":"Cream Filling","hex":"#f5f1da","rgb":{"r":245,"g":241,"b":218},"luminance":161.23532186837969},{"name":"Cream Gold","hex":"#dec05f","rgb":{"r":222,"g":192,"b":95},"luminance":131.24602622555852},{"name":"Cream Pink","hex":"#f6e4d9","rgb":{"r":246,"g":228,"b":217},"luminance":154.7069308596095},{"name":"Cream Puff","hex":"#ffbb99","rgb":{"r":255,"g":187,"b":153},"luminance":134.78411163783363},{"name":"Cream Tan","hex":"#e4c7b8","rgb":{"r":228,"g":199,"b":184},"luminance":136.86742172262908},{"name":"Cream Washed","hex":"#f2e0c5","rgb":{"r":242,"g":224,"b":197},"luminance":151.75353726355112},{"name":"Cream Wave","hex":"#e8dbc5","rgb":{"r":232,"g":219,"b":197},"luminance":147.7909164901551},{"name":"Cream Yellow","hex":"#f3daa7","rgb":{"r":243,"g":218,"b":167},"luminance":148.38053190698568},{"name":"Creamed Avocado","hex":"#70804d","rgb":{"r":112,"g":128,"b":77},"luminance":82.72797546175055},{"name":"Creamed Butter","hex":"#fffcd3","rgb":{"r":255,"g":252,"b":211},"luminance":168.1469735588482},{"name":"Creamed Caramel","hex":"#b79c94","rgb":{"r":183,"g":156,"b":148},"luminance":108.00021137479314},{"name":"Creamed Muscat","hex":"#8b6962","rgb":{"r":139,"g":105,"b":98},"luminance":75.1731569777404},{"name":"Creamed Raspberry","hex":"#bd6883","rgb":{"r":189,"g":104,"b":131},"luminance":84.51849372178847},{"name":"Creamy Apricot","hex":"#ffe8bd","rgb":{"r":255,"g":232,"b":189},"luminance":157.55510780993424},{"name":"Creamy Axolotl","hex":"#ffdae8","rgb":{"r":255,"g":218,"b":232},"luminance":151.28811547838117},{"name":"Creamy Cameo","hex":"#f9eedc","rgb":{"r":249,"g":238,"b":220},"luminance":160.28014299032802},{"name":"Creamy Cappuccino","hex":"#dbccb5","rgb":{"r":219,"g":204,"b":181},"luminance":138.032991784573},{"name":"Creamy Caramel","hex":"#b3956c","rgb":{"r":179,"g":149,"b":108},"luminance":103.27564647098559},{"name":"Creamy Chenille","hex":"#e1cfaf","rgb":{"r":225,"g":207,"b":175},"luminance":140.31523511721738},{"name":"Creamy Coral","hex":"#dd7788","rgb":{"r":221,"g":119,"b":136},"luminance":97.39738120709406},{"name":"Creamy Corn","hex":"#fff2c2","rgb":{"r":255,"g":242,"b":194},"luminance":162.7321615323781},{"name":"Creamy Custard","hex":"#f9e7bf","rgb":{"r":249,"g":231,"b":191},"luminance":156.2165320508684},{"name":"Creamy Gelato","hex":"#f0e2c5","rgb":{"r":240,"g":226,"b":197},"luminance":152.48955901306817},{"name":"Creamy Ivory","hex":"#eeddaa","rgb":{"r":238,"g":221,"b":170},"luminance":149.22703901438237},{"name":"Creamy Mauve","hex":"#dccad8","rgb":{"r":220,"g":202,"b":216},"luminance":137.81561323739774},{"name":"Creamy Mint","hex":"#aaffaa","rgb":{"r":170,"g":255,"b":170},"luminance":159.26353168569383},{"name":"Creamy Peach","hex":"#f4a384","rgb":{"r":244,"g":163,"b":132},"luminance":121.25953158824258},{"name":"Creamy Strawberry","hex":"#fcd2df","rgb":{"r":252,"g":210,"b":223},"luminance":146.69387201924968},{"name":"Creamy White","hex":"#f0e9d6","rgb":{"r":240,"g":233,"b":214},"luminance":156.36805574349256},{"name":"Crease","hex":"#7a6d44","rgb":{"r":122,"g":109,"b":68},"luminance":74.05783062580215},{"name":"Credo","hex":"#dcba42","rgb":{"r":220,"g":186,"b":66},"luminance":127.6884023707713},{"name":"Creed","hex":"#c1a44a","rgb":{"r":193,"g":164,"b":74},"luminance":112.55572739314513},{"name":"Creek Bay","hex":"#ab9d89","rgb":{"r":171,"g":157,"b":137},"luminance":106.5428451187596},{"name":"Creek Pebble","hex":"#dbd7d9","rgb":{"r":219,"g":215,"b":217},"luminance":144.31712313512904},{"name":"Creeping Bellflower","hex":"#b48ac2","rgb":{"r":180,"g":138,"b":194},"luminance":99.73806641398258},{"name":"Crema","hex":"#c16104","rgb":{"r":193,"g":97,"b":4},"luminance":81.07006541257999},{"name":"Creme","hex":"#ffffb6","rgb":{"r":255,"g":255,"b":182},"luminance":169.26127363930593},{"name":"Creme Brulee","hex":"#ffe39b","rgb":{"r":255,"g":227,"b":155},"luminance":154.5342192719787},{"name":"Crème de la Crème","hex":"#f3e7b4","rgb":{"r":243,"g":231,"b":180},"luminance":155.19876435719453},{"name":"Crème de Menthe","hex":"#f1fde9","rgb":{"r":241,"g":253,"b":233},"luminance":167.19317105073398},{"name":"Creme De Peche","hex":"#f5d6c6","rgb":{"r":245,"g":214,"b":198},"luminance":147.1586631258928},{"name":"Crème fraîche","hex":"#f7f0e2","rgb":{"r":247,"g":240,"b":226},"luminance":161.13728216958359},{"name":"Cremini","hex":"#cfa33b","rgb":{"r":207,"g":163,"b":59},"luminance":114.15268847469164},{"name":"Creole","hex":"#393227","rgb":{"r":57,"g":50,"b":39},"luminance":34.22942104389146},{"name":"Creole Pink","hex":"#f7d5cc","rgb":{"r":247,"g":213,"b":204},"luminance":147.06412922939433},{"name":"Creole Sauce","hex":"#ee8833","rgb":{"r":238,"g":136,"b":51},"luminance":107.10266599856419},{"name":"Crepe","hex":"#d4bc94","rgb":{"r":212,"g":188,"b":148},"luminance":128.3789299846357},{"name":"Crepe Myrtle","hex":"#e399ca","rgb":{"r":227,"g":153,"b":202},"luminance":114.90451964130915},{"name":"Crêpe Papier","hex":"#dbd7c4","rgb":{"r":219,"g":215,"b":196},"luminance":143.9260842307606},{"name":"Crescendo","hex":"#e3df84","rgb":{"r":227,"g":223,"b":132},"luminance":148.2169296470548},{"name":"Crescent Moon","hex":"#f1e9cf","rgb":{"r":241,"g":233,"b":207},"luminance":156.38309219989222},{"name":"Cress Green","hex":"#bca949","rgb":{"r":188,"g":169,"b":73},"luminance":114.32532456546974},{"name":"Cress Vinaigrette","hex":"#bcb58a","rgb":{"r":188,"g":181,"b":138},"luminance":121.22586265727293},{"name":"Cressida","hex":"#8aae7c","rgb":{"r":138,"g":174,"b":124},"luminance":111.06102009255991},{"name":"Crestline","hex":"#b4bcbf","rgb":{"r":180,"g":188,"b":191},"luminance":124.69621570841674},{"name":"Cretan Green","hex":"#598784","rgb":{"r":89,"g":135,"b":132},"luminance":84.93737487113667},{"name":"Crete","hex":"#77712b","rgb":{"r":119,"g":113,"b":43},"luminance":75.43101965372071},{"name":"Cria Wool","hex":"#e4d5bc","rgb":{"r":228,"g":213,"b":188},"luminance":144.0121632675518},{"name":"Cricket Chirping","hex":"#c7c10c","rgb":{"r":199,"g":193,"b":12},"luminance":127.97300928711492},{"name":"Cricket Green","hex":"#6a7b6b","rgb":{"r":106,"g":123,"b":107},"luminance":79.7890045119},{"name":"Cricket's Cross","hex":"#908a78","rgb":{"r":144,"g":138,"b":120},"luminance":92.75200036656891},{"name":"Crimson","hex":"#8c000f","rgb":{"r":140,"g":0,"b":15},"luminance":41.8949125789755},{"name":"Crimson Glory","hex":"#be0032","rgb":{"r":190,"g":0,"b":50},"luminance":57.09523710433296},{"name":"Crimson Red","hex":"#980001","rgb":{"r":152,"g":0,"b":1},"luminance":45.448142976363734},{"name":"Crimson Strawberry","hex":"#9f2d47","rgb":{"r":159,"g":45,"b":71},"luminance":54.9855593951721},{"name":"Crisis Red","hex":"#bb2222","rgb":{"r":187,"g":34,"b":34},"luminance":59.494610755933174},{"name":"Crisp","hex":"#eaebaf","rgb":{"r":234,"g":235,"b":175},"luminance":155.95533553232477},{"name":"Crisp Candlelight","hex":"#f4ebd0","rgb":{"r":244,"g":235,"b":208},"luminance":157.84061551134423},{"name":"Crisp Capsicum","hex":"#5d6e3b","rgb":{"r":93,"g":110,"b":59},"luminance":70.6240272499381},{"name":"Crisp Cyan","hex":"#22ffff","rgb":{"r":34,"g":255,"b":255},"luminance":152.82019395681974},{"name":"Crisp Lettuce","hex":"#4f9785","rgb":{"r":79,"g":151,"b":133},"luminance":92.9750270449006},{"name":"Crisp Muslin","hex":"#e9e2d7","rgb":{"r":233,"g":226,"b":215},"luminance":151.83358400894053},{"name":"Crisp Wonton","hex":"#f3dcc6","rgb":{"r":243,"g":220,"b":198},"luminance":149.88553777132734},{"name":"Crispy Chicken Skin","hex":"#ddaa44","rgb":{"r":221,"g":170,"b":68},"luminance":119.93569879314498},{"name":"Crispy Crust","hex":"#ebe0cf","rgb":{"r":235,"g":224,"b":207},"luminance":150.940816126719},{"name":"Crispy Samosa","hex":"#ffbb66","rgb":{"r":255,"g":187,"b":102},"luminance":134.15566991372373},{"name":"Crocker Grove","hex":"#b1a685","rgb":{"r":177,"g":166,"b":133},"luminance":111.91815552893998},{"name":"Crockery","hex":"#a49887","rgb":{"r":164,"g":152,"b":135},"luminance":102.9674879367269},{"name":"Crocodile","hex":"#706950","rgb":{"r":112,"g":105,"b":80},"luminance":70.73537848205804},{"name":"Crocodile Smile","hex":"#898e58","rgb":{"r":137,"g":142,"b":88},"luminance":93.41572516980212},{"name":"Crocodile Tears","hex":"#d6d69b","rgb":{"r":214,"g":214,"b":155},"luminance":142.07856636382562},{"name":"Crocodile Tooth","hex":"#d1ccc2","rgb":{"r":209,"g":204,"b":194},"luminance":136.87156768664556},{"name":"Crocus","hex":"#c67fae","rgb":{"r":198,"g":127,"b":174},"luminance":97.24143716029704},{"name":"Crocus Petal","hex":"#b99bc5","rgb":{"r":185,"g":155,"b":197},"luminance":108.82270541573573},{"name":"Croissant","hex":"#c4ab86","rgb":{"r":196,"g":171,"b":134},"luminance":117.23193729099592},{"name":"Croissant Crumbs","hex":"#f8efd8","rgb":{"r":248,"g":239,"b":216},"luminance":160.58326914407985},{"name":"Crop Circle","hex":"#e9bf63","rgb":{"r":233,"g":191,"b":99},"luminance":132.48051318590217},{"name":"Croque Monsieur","hex":"#ac9877","rgb":{"r":172,"g":152,"b":119},"luminance":103.87395109458386},{"name":"Cross My Heart","hex":"#ad2a2d","rgb":{"r":173,"g":42,"b":45},"luminance":57.53102767203102},{"name":"Crossbow","hex":"#60543f","rgb":{"r":96,"g":84,"b":63},"luminance":57.50460506776827},{"name":"Crossed Fingers","hex":"#ddb596","rgb":{"r":221,"g":181,"b":150},"luminance":126.28249779759663},{"name":"Crossroads","hex":"#edd2a3","rgb":{"r":237,"g":210,"b":163},"luminance":143.3957753666404},{"name":"Crow Wing","hex":"#180614","rgb":{"r":24,"g":6,"b":20},"luminance":8.312512255630063},{"name":"Crowberry","hex":"#220055","rgb":{"r":34,"g":0,"b":85},"luminance":14.04434605099148},{"name":"Crown Blue","hex":"#464b65","rgb":{"r":70,"g":75,"b":101},"luminance":50.08829924243785},{"name":"Crown Gold","hex":"#b48c60","rgb":{"r":180,"g":140,"b":96},"luminance":98.84288510560584},{"name":"Crown Jewel","hex":"#482d54","rgb":{"r":72,"g":45,"b":84},"luminance":35.396423336263794},{"name":"Crown of Thorns","hex":"#763c33","rgb":{"r":118,"g":60,"b":51},"luminance":50.19034289582011},{"name":"Crown Point Cream","hex":"#fff0c1","rgb":{"r":255,"g":240,"b":193},"luminance":161.69280265058183},{"name":"Crowshead","hex":"#1c1208","rgb":{"r":28,"g":18,"b":8},"luminance":13.511568524786453},{"name":"Crucified Red","hex":"#cc0044","rgb":{"r":204,"g":0,"b":68},"luminance":61.48662879033131},{"name":"Crude Banana","hex":"#21c40e","rgb":{"r":33,"g":196,"b":14},"luminance":115.4853566864648},{"name":"Cruel Ruby","hex":"#dd3344","rgb":{"r":221,"g":51,"b":68},"luminance":72.95719096840283},{"name":"Cruel Sea","hex":"#213638","rgb":{"r":33,"g":54,"b":56},"luminance":33.8064542506309},{"name":"Cruise","hex":"#b4e2d5","rgb":{"r":180,"g":226,"b":213},"luminance":145.20817527949313},{"name":"Crumble Topping","hex":"#efcea0","rgb":{"r":239,"g":206,"b":160},"luminance":141.63863245950944},{"name":"Crunch","hex":"#f2b95f","rgb":{"r":242,"g":185,"b":95},"luminance":130.94213641528842},{"name":"Crusade King","hex":"#dbc364","rgb":{"r":219,"g":195,"b":100},"luminance":132.362976643773},{"name":"Crushed Almond","hex":"#d4cac5","rgb":{"r":212,"g":202,"b":197},"luminance":136.31652058353015},{"name":"Crushed Berries","hex":"#d15b9b","rgb":{"r":209,"g":91,"b":155},"luminance":84.08763208700789},{"name":"Crushed Berry","hex":"#804f5a","rgb":{"r":128,"g":79,"b":90},"luminance":60.99564503306773},{"name":"Crushed Cashew","hex":"#ffedd5","rgb":{"r":255,"g":237,"b":213},"luminance":160.48991155209725},{"name":"Crushed Cinnamon","hex":"#b7735e","rgb":{"r":183,"g":115,"b":94},"luminance":87.55402772003124},{"name":"Crushed Grape","hex":"#7a547f","rgb":{"r":122,"g":84,"b":127},"luminance":63.02012243720255},{"name":"Crushed Ice","hex":"#c4fff7","rgb":{"r":196,"g":255,"b":247},"luminance":163.19589763532662},{"name":"Crushed Limestone","hex":"#d6ddd3","rgb":{"r":214,"g":221,"b":211},"luminance":146.63525374547555},{"name":"Crushed Pineapple","hex":"#efcc44","rgb":{"r":239,"g":204,"b":68},"luminance":139.66514070805212},{"name":"Crushed Raspberry","hex":"#b06880","rgb":{"r":176,"g":104,"b":128},"luminance":81.90891370296642},{"name":"Crushed Silk","hex":"#d8cfbe","rgb":{"r":216,"g":207,"b":190},"luminance":139.30070257181043},{"name":"Crushed Stone","hex":"#bcaa9f","rgb":{"r":188,"g":170,"b":159},"luminance":115.95854828342755},{"name":"Crushed Velvet","hex":"#445397","rgb":{"r":68,"g":83,"b":151},"luminance":55.52880208504412},{"name":"Crushed Violets","hex":"#643a4c","rgb":{"r":100,"g":58,"b":76},"luminance":46.13247242452977},{"name":"Crusoe","hex":"#165b31","rgb":{"r":22,"g":91,"b":49},"luminance":54.10960514548225},{"name":"Crust","hex":"#898076","rgb":{"r":137,"g":128,"b":118},"luminance":86.62760627536697},{"name":"Crusta","hex":"#f38653","rgb":{"r":243,"g":134,"b":83},"luminance":107.49720953122457},{"name":"Crustose Lichen","hex":"#c04e01","rgb":{"r":192,"g":78,"b":1},"luminance":73.4305743951387},{"name":"Cry Baby Blue","hex":"#c3d4e7","rgb":{"r":195,"g":212,"b":231},"luminance":139.9259151015279},{"name":"Crypt","hex":"#373b40","rgb":{"r":55,"g":59,"b":64},"luminance":39.02709738117863},{"name":"Cryptic Light","hex":"#6d434e","rgb":{"r":109,"g":67,"b":78},"luminance":51.84603346448019},{"name":"Crysolite","hex":"#8e9849","rgb":{"r":142,"g":152,"b":73},"luminance":99.16077664076657},{"name":"Crysoprase","hex":"#adba98","rgb":{"r":173,"g":186,"b":152},"luminance":122.05183831880615},{"name":"Crystal","hex":"#a7d8de","rgb":{"r":167,"g":216,"b":222},"luminance":138.6001826008898},{"name":"Crystal Apple","hex":"#cee9a0","rgb":{"r":206,"g":233,"b":160},"luminance":151.1053436414477},{"name":"Crystal Ball","hex":"#365955","rgb":{"r":54,"g":89,"b":85},"luminance":55.53305740727769},{"name":"Crystal Bell","hex":"#efeeef","rgb":{"r":239,"g":238,"b":239},"luminance":159.26953717833175},{"name":"Crystal Blue","hex":"#68a0b0","rgb":{"r":104,"g":160,"b":176},"luminance":100.94796536830248},{"name":"Crystal Brooke","hex":"#e4e6dc","rgb":{"r":228,"g":230,"b":220},"luminance":153.31056090172},{"name":"Crystal Clear","hex":"#f4e9ea","rgb":{"r":244,"g":233,"b":234},"luminance":157.29111021605766},{"name":"Crystal Falls","hex":"#e1e6f2","rgb":{"r":225,"g":230,"b":242},"luminance":153.34511230880494},{"name":"Crystal Gem","hex":"#79d0a7","rgb":{"r":121,"g":208,"b":167},"luminance":128.75868398286772},{"name":"Crystal Glass","hex":"#ddffee","rgb":{"r":221,"g":255,"b":238},"luminance":165.8558979656738},{"name":"Crystal Grey","hex":"#d7cbc4","rgb":{"r":215,"g":203,"b":196},"luminance":137.2266719045536},{"name":"Crystal Haze","hex":"#e7e2d6","rgb":{"r":231,"g":226,"b":214},"luminance":151.54173623460966},{"name":"Crystal Lake","hex":"#88b5c4","rgb":{"r":136,"g":181,"b":196},"luminance":115.93636289361505},{"name":"Crystal Oasis","hex":"#afc7bf","rgb":{"r":175,"g":199,"b":191},"luminance":129.83562558096293},{"name":"Crystal Palace","hex":"#d3cfab","rgb":{"r":211,"g":207,"b":171},"luminance":138.29199195181187},{"name":"Crystal Pink","hex":"#edd0ce","rgb":{"r":237,"g":208,"b":206},"luminance":143.11008434418588},{"name":"Crystal River","hex":"#b1e2ee","rgb":{"r":177,"g":226,"b":238},"luminance":145.38292746055157},{"name":"Crystal Rose","hex":"#fdc3c6","rgb":{"r":253,"g":195,"b":198},"luminance":139.0474739720215},{"name":"Crystal Seas","hex":"#5dafce","rgb":{"r":93,"g":175,"b":206},"luminance":108.9823523787223},{"name":"Crystal Teal","hex":"#00637c","rgb":{"r":0,"g":99,"b":124},"luminance":59.807585346676554},{"name":"Crystalsong Blue","hex":"#4fb3b3","rgb":{"r":79,"g":179,"b":179},"luminance":109.61154960130797},{"name":"Cub","hex":"#6e5c4b","rgb":{"r":110,"g":92,"b":75},"luminance":63.806634576664514},{"name":"Cub Scout","hex":"#4e6341","rgb":{"r":78,"g":99,"b":65},"luminance":63.05509141219288},{"name":"Cuba Brown","hex":"#623d3d","rgb":{"r":98,"g":61,"b":61},"luminance":46.7878891274227},{"name":"Cuba Libre","hex":"#73383c","rgb":{"r":115,"g":56,"b":60},"luminance":48.059153228079246},{"name":"Cuban Cigar","hex":"#927247","rgb":{"r":146,"g":114,"b":71},"luminance":80.30693168089539},{"name":"Cuban Rhythm","hex":"#9b555d","rgb":{"r":155,"g":85,"b":93},"luminance":68.9185929484925},{"name":"Cuban Sand","hex":"#c1a68d","rgb":{"r":193,"g":166,"b":141},"luminance":114.38275520811692},{"name":"Cucumber","hex":"#006400","rgb":{"r":0,"g":100,"b":0},"luminance":58.699999999999996},{"name":"Cucumber Cream","hex":"#e4ebb1","rgb":{"r":228,"g":235,"b":177},"luminance":155.18826080925064},{"name":"Cucumber Crush","hex":"#a2ac86","rgb":{"r":162,"g":172,"b":134},"luminance":113.01913694591725},{"name":"Cucumber Ice","hex":"#cdd79d","rgb":{"r":205,"g":215,"b":157},"luminance":141.43944801221474},{"name":"Cuddle","hex":"#bccae8","rgb":{"r":188,"g":202,"b":232},"luminance":133.8621646470727},{"name":"Cuddlepot","hex":"#ad8068","rgb":{"r":173,"g":128,"b":104},"luminance":91.98731304370185},{"name":"Cuddly Yarn","hex":"#fffce4","rgb":{"r":255,"g":252,"b":228},"luminance":168.43513251397403},{"name":"Culpeo","hex":"#e69b3a","rgb":{"r":230,"g":155,"b":58},"luminance":114.24229369633647},{"name":"Cultured","hex":"#f6f4f5","rgb":{"r":246,"g":244,"b":245},"luminance":163.41522511687825},{"name":"Cultured Rose","hex":"#e5867b","rgb":{"r":229,"g":134,"b":123},"luminance":105.22345408225297},{"name":"Cumberland Fog","hex":"#dadbdf","rgb":{"r":218,"g":219,"b":223},"luminance":146.35861784329614},{"name":"Cumberland Sausage","hex":"#e5dfdc","rgb":{"r":229,"g":223,"b":220},"luminance":149.84110264543568},{"name":"Cumin","hex":"#a58459","rgb":{"r":165,"g":132,"b":89},"luminance":92.41565774802449},{"name":"Cumquat Cream","hex":"#f19b7d","rgb":{"r":241,"g":155,"b":125},"luminance":116.93516240207647},{"name":"Cumulus","hex":"#f3f3e6","rgb":{"r":243,"g":243,"b":230},"luminance":162.21277055151975},{"name":"Cumulus Cloud","hex":"#b0c6df","rgb":{"r":176,"g":198,"b":223},"luminance":130.0924538011333},{"name":"Cupcake Rose","hex":"#e6c7b7","rgb":{"r":230,"g":199,"b":183},"luminance":137.14887135153535},{"name":"Cupid","hex":"#f5b2c5","rgb":{"r":245,"g":178,"b":197},"luminance":129.5684413157772},{"name":"Cupid's Arrow","hex":"#ee6b8b","rgb":{"r":238,"g":107,"b":139},"luminance":96.22939489054266},{"name":"Cupid's Revenge","hex":"#eedcdf","rgb":{"r":238,"g":220,"b":223},"luminance":149.6243560654481},{"name":"Cuppa Coffee","hex":"#b09f8f","rgb":{"r":176,"g":159,"b":143},"luminance":108.37937750790046},{"name":"Curd","hex":"#f8e1ba","rgb":{"r":248,"g":225,"b":186},"luminance":152.9442197175166},{"name":"Curds and Whey","hex":"#bca483","rgb":{"r":188,"g":164,"b":131},"luminance":112.47373526294928},{"name":"Cure All","hex":"#aa6988","rgb":{"r":170,"g":105,"b":136},"luminance":81.38142380789365},{"name":"Cured Eggplant","hex":"#380835","rgb":{"r":56,"g":8,"b":53},"luminance":18.409772296256136},{"name":"Curious","hex":"#d9e49e","rgb":{"r":217,"g":228,"b":158},"luminance":149.8209288751074},{"name":"Curious Blue","hex":"#3d85b8","rgb":{"r":61,"g":133,"b":184},"luminance":82.87179699994444},{"name":"Curious Chipmunk","hex":"#dabfa4","rgb":{"r":218,"g":191,"b":164},"luminance":131.02845198276594},{"name":"Curlew","hex":"#766859","rgb":{"r":118,"g":104,"b":89},"luminance":71.23636110863609},{"name":"Curly Maple","hex":"#d8c8be","rgb":{"r":216,"g":200,"b":190},"luminance":135.73138419687615},{"name":"Curry","hex":"#be9e6f","rgb":{"r":190,"g":158,"b":111},"luminance":109.49575485835055},{"name":"Curry Powder","hex":"#cc6600","rgb":{"r":204,"g":102,"b":0},"luminance":85.47167888838969},{"name":"Curry Sauce","hex":"#d6a332","rgb":{"r":214,"g":163,"b":50},"luminance":115.24561578211988},{"name":"Currywurst","hex":"#ddaa33","rgb":{"r":221,"g":170,"b":51},"luminance":119.82604448532881},{"name":"Curtsy","hex":"#ffd6b8","rgb":{"r":255,"g":214,"b":184},"luminance":148.43575891610485},{"name":"Cushion Bush","hex":"#c1c8af","rgb":{"r":193,"g":200,"b":175},"luminance":132.32860744752057},{"name":"Custard","hex":"#fffd78","rgb":{"r":255,"g":253,"b":120},"luminance":167.49913297089032},{"name":"Custard Powder","hex":"#f8dcaa","rgb":{"r":248,"g":220,"b":170},"luminance":150.17071320334065},{"name":"Custard Puff","hex":"#fceeae","rgb":{"r":252,"g":238,"b":174},"luminance":159.96422861377476},{"name":"Cut of Mustard","hex":"#bc914d","rgb":{"r":188,"g":145,"b":77},"luminance":102.37873535554148},{"name":"Cute Crab","hex":"#dd4444","rgb":{"r":221,"g":68,"b":68},"luminance":77.58746548895638},{"name":"Cute Little Pink","hex":"#f4e2e1","rgb":{"r":244,"g":226,"b":225},"luminance":153.55685162180163},{"name":"Cute Pixie","hex":"#8d8d40","rgb":{"r":141,"g":141,"b":64},"luminance":93.1718261385919},{"name":"Cuticle Pink","hex":"#e3a49a","rgb":{"r":227,"g":164,"b":154},"luminance":119.09023926838},{"name":"Cutlery Polish","hex":"#f4dda5","rgb":{"r":244,"g":221,"b":165},"luminance":150.01829410108624},{"name":"Cuttlefish","hex":"#7fbbc2","rgb":{"r":127,"g":187,"b":194},"luminance":118.23831674207815},{"name":"Cutty Sark","hex":"#5c8173","rgb":{"r":92,"g":129,"b":115},"luminance":81.62435232821146},{"name":"Cyan","hex":"#0ff0fe","rgb":{"r":15,"g":240,"b":254},"luminance":143.89489067023888},{"name":"Cyan Azure","hex":"#4e82b4","rgb":{"r":78,"g":130,"b":180},"luminance":82.39054669074602},{"name":"Cyan Blue","hex":"#14a3c7","rgb":{"r":20,"g":163,"b":199},"luminance":98.51532244783041},{"name":"Cyan Cobalt Blue","hex":"#28589c","rgb":{"r":40,"g":88,"b":156},"luminance":55.925437789971745},{"name":"Cyan Cornflower Blue","hex":"#188bc2","rgb":{"r":24,"g":139,"b":194},"luminance":84.8412050892725},{"name":"Cyanara","hex":"#779080","rgb":{"r":119,"g":144,"b":128},"luminance":92.86504621761623},{"name":"Cyanite","hex":"#00b7eb","rgb":{"r":0,"g":183,"b":235},"luminance":110.71122499999717},{"name":"Cyber Grape","hex":"#58427c","rgb":{"r":88,"g":66,"b":124},"luminance":48.91922325630283},{"name":"Cyber Lavender","hex":"#e6e6fa","rgb":{"r":230,"g":230,"b":250},"luminance":154.1728348315617},{"name":"Cyber Yellow","hex":"#ffd400","rgb":{"r":255,"g":212,"b":0},"luminance":145.94385619477097},{"name":"Cyclamen","hex":"#d687ba","rgb":{"r":214,"g":135,"b":186},"luminance":104.03647358979444},{"name":"Cymophane Yellow","hex":"#f3e4a7","rgb":{"r":243,"g":228,"b":167},"luminance":153.47169116485293},{"name":"Cynical Black","hex":"#171717","rgb":{"r":23,"g":23,"b":23},"luminance":15.37676864624034},{"name":"Cypress","hex":"#545a3e","rgb":{"r":84,"g":90,"b":62},"luminance":58.92180394387123},{"name":"Cypress Bark Red","hex":"#6f3028","rgb":{"r":111,"g":48,"b":40},"luminance":43.774310925473166},{"name":"Cypress Garden","hex":"#667c71","rgb":{"r":102,"g":124,"b":113},"luminance":79.96353463923414},{"name":"Cyprus","hex":"#0f4645","rgb":{"r":15,"g":70,"b":69},"luminance":42.07585151841849},{"name":"Cyprus Spring","hex":"#acb7b0","rgb":{"r":172,"g":183,"b":176},"luminance":120.77530592385183},{"name":"Cyrus Grass","hex":"#cfc5a7","rgb":{"r":207,"g":197,"b":167},"luminance":132.5351546345346},{"name":"Czech Bakery","hex":"#dec9a9","rgb":{"r":222,"g":201,"b":169},"luminance":136.74117817614413},{"name":"D. Darx Blue","hex":"#030764","rgb":{"r":3,"g":7,"b":100},"luminance":12.151069500253877},{"name":"Da Blues","hex":"#516172","rgb":{"r":81,"g":97,"b":114},"luminance":63.22583093957722},{"name":"Dachshund","hex":"#704f37","rgb":{"r":112,"g":79,"b":55},"luminance":57.54315053071043},{"name":"Dad's Coupe","hex":"#2f484e","rgb":{"r":47,"g":72,"b":78},"luminance":45.418059943154766},{"name":"Daddy-O","hex":"#b0af8a","rgb":{"r":176,"g":175,"b":138},"luminance":116.48693843088158},{"name":"Daemonette Hide","hex":"#696684","rgb":{"r":105,"g":102,"b":132},"luminance":69.26026425736477},{"name":"Daffodil","hex":"#ffff31","rgb":{"r":255,"g":255,"b":49},"luminance":168.07766849287268},{"name":"Dagger Moth","hex":"#e8e1d5","rgb":{"r":232,"g":225,"b":213},"luminance":151.1467517778665},{"name":"Dahlia","hex":"#843e83","rgb":{"r":132,"g":62,"b":131},"luminance":55.72495505606083},{"name":"Dahlia Mauve","hex":"#a64f82","rgb":{"r":166,"g":79,"b":130},"luminance":69.5242510567356},{"name":"Dahlia Purple","hex":"#7e6eac","rgb":{"r":126,"g":110,"b":172},"luminance":77.28576091363789},{"name":"Daikon White","hex":"#d4d4c4","rgb":{"r":212,"g":212,"b":196},"luminance":141.43409071366068},{"name":"Daintree","hex":"#012731","rgb":{"r":1,"g":39,"b":49},"luminance":23.566549301923686},{"name":"Dainty Flower","hex":"#e9dfe5","rgb":{"r":233,"g":223,"b":229},"luminance":150.5658856647149},{"name":"Daiquiri Green","hex":"#c9d77e","rgb":{"r":201,"g":215,"b":126},"luminance":140.52016340013273},{"name":"Dairy Cream","hex":"#edd2a4","rgb":{"r":237,"g":210,"b":164},"luminance":143.4105926527047},{"name":"Dairy Made","hex":"#f0b33c","rgb":{"r":240,"g":179,"b":60},"luminance":127.42299058254753},{"name":"Daisy Bush","hex":"#5b3e90","rgb":{"r":91,"g":62,"b":144},"luminance":48.31498704335954},{"name":"Daisy Chain","hex":"#fff09b","rgb":{"r":255,"g":240,"b":155},"luminance":161.16048934214615},{"name":"Daisy Desi","hex":"#fcdf8a","rgb":{"r":252,"g":223,"b":138},"luminance":151.85482780932583},{"name":"Daisy Leaf","hex":"#55643b","rgb":{"r":85,"g":100,"b":59},"luminance":64.31835897315788},{"name":"Daisy White","hex":"#f8f3e3","rgb":{"r":248,"g":243,"b":227},"luminance":162.8331811056948},{"name":"Dallas","hex":"#664a2d","rgb":{"r":102,"g":74,"b":45},"luminance":53.32264760868499},{"name":"Dallas Dust","hex":"#ece0d6","rgb":{"r":236,"g":224,"b":214},"luminance":151.2069345499736},{"name":"Dallol Yellow","hex":"#fddc00","rgb":{"r":253,"g":220,"b":0},"luminance":149.66498658336891},{"name":"Dalmatian Sage","hex":"#97a3da","rgb":{"r":151,"g":163,"b":218},"luminance":108.67800083733597},{"name":"Daly Waters","hex":"#afdadf","rgb":{"r":175,"g":218,"b":223},"luminance":140.56842058229154},{"name":"Damask","hex":"#fcf2df","rgb":{"r":252,"g":242,"b":223},"luminance":162.79723002557506},{"name":"Dame Dignity","hex":"#999ba8","rgb":{"r":153,"g":155,"b":168},"luminance":103.6236331055807},{"name":"Damp Basement","hex":"#5f6171","rgb":{"r":95,"g":97,"b":113},"luminance":64.92179657095141},{"name":"Damson","hex":"#854c65","rgb":{"r":133,"g":76,"b":101},"luminance":60.86227919655983},{"name":"Damson Plum","hex":"#dda0dd","rgb":{"r":221,"g":160,"b":221},"luminance":117.56759024918388},{"name":"Dana","hex":"#576780","rgb":{"r":87,"g":103,"b":128},"luminance":67.41761753429144},{"name":"Dance Studio","hex":"#064d83","rgb":{"r":6,"g":77,"b":131},"luminance":47.63604090392064},{"name":"Dancer","hex":"#dc9399","rgb":{"r":220,"g":147,"b":153},"luminance":109.89551075908423},{"name":"Dancing Crocodiles","hex":"#254a47","rgb":{"r":37,"g":74,"b":71},"luminance":45.54956255552845},{"name":"Dancing Daisy","hex":"#efc857","rgb":{"r":239,"g":200,"b":87},"luminance":137.79623088096423},{"name":"Dancing Dogs","hex":"#6e493d","rgb":{"r":110,"g":73,"b":61},"luminance":54.46391848738025},{"name":"Dancing Dolphin","hex":"#c4baa1","rgb":{"r":196,"g":186,"b":161},"luminance":125.26774228028538},{"name":"Dancing Dragonfly","hex":"#006658","rgb":{"r":0,"g":102,"b":88},"luminance":60.70862294600331},{"name":"Dancing Kite","hex":"#c8cc9e","rgb":{"r":200,"g":204,"b":158},"luminance":135.0557501478556},{"name":"Dancing Wand","hex":"#c8a4bd","rgb":{"r":200,"g":164,"b":189},"luminance":115.35942935018359},{"name":"Dancing-Lady Orchid","hex":"#dfff00","rgb":{"r":223,"g":255,"b":0},"luminance":163.86403374139184},{"name":"Dandelion","hex":"#fedf08","rgb":{"r":254,"g":223,"b":8},"luminance":151.33967906996497},{"name":"Dandelion Floatie","hex":"#eae8ec","rgb":{"r":234,"g":232,"b":236},"luminance":155.45143366337925},{"name":"Dandelion Tincture","hex":"#f0e130","rgb":{"r":240,"g":225,"b":48},"luminance":150.41025898854105},{"name":"Dandelion Whisper","hex":"#fff0b5","rgb":{"r":255,"g":240,"b":181},"luminance":161.51234126530392},{"name":"Dandelion Wine","hex":"#fcf2b9","rgb":{"r":252,"g":242,"b":185},"luminance":162.17721208603876},{"name":"Dandelion Yellow","hex":"#fcd93b","rgb":{"r":252,"g":217,"b":59},"luminance":148.14847221959462},{"name":"Danger Ridge","hex":"#595539","rgb":{"r":89,"g":85,"b":57},"luminance":56.919946855210604},{"name":"Dangerous Robot","hex":"#cbc5c6","rgb":{"r":203,"g":197,"b":198},"luminance":132.53678475804367},{"name":"Dangerously Red","hex":"#d84139","rgb":{"r":216,"g":65,"b":57},"luminance":75.2935660265869},{"name":"Daniel Boon","hex":"#5e4235","rgb":{"r":94,"g":66,"b":53},"luminance":48.24308825106452},{"name":"Dante Peak","hex":"#b4d5d5","rgb":{"r":180,"g":213,"b":213},"luminance":138.2713234369296},{"name":"Danube","hex":"#5b89c0","rgb":{"r":91,"g":137,"b":192},"luminance":87.67342690918383},{"name":"Daphne","hex":"#0f5f9a","rgb":{"r":15,"g":95,"b":154},"luminance":58.635003078366076},{"name":"Daphne Rose","hex":"#c37cb3","rgb":{"r":195,"g":124,"b":179},"luminance":95.46711897297413},{"name":"Dapper Dingo","hex":"#e2c299","rgb":{"r":226,"g":194,"b":153},"luminance":133.56147544857387},{"name":"Dapper Greyhound","hex":"#697078","rgb":{"r":105,"g":112,"b":120},"luminance":74.12868514279745},{"name":"Dapple Grey","hex":"#959486","rgb":{"r":149,"g":148,"b":134},"luminance":98.82098538772014},{"name":"Daring Indigo","hex":"#374874","rgb":{"r":55,"g":72,"b":116},"luminance":47.239368084257855},{"name":"Dark","hex":"#1b2431","rgb":{"r":27,"g":36,"b":49},"luminance":23.3010332174348},{"name":"Dark Yellow","hex":"#9B870C","rgb":{"r":27,"g":36,"b":49},"luminance":23.3010332174348},{"name":"Dark Brown","hex":"#654321","rgb":{"r":27,"g":36,"b":49},"luminance":23.3010332174348},{"name":"Dark & Stormy","hex":"#353f51","rgb":{"r":53,"g":63,"b":81},"luminance":41.279395901587506},{"name":"Dark Ages","hex":"#9698a3","rgb":{"r":150,"g":152,"b":163},"luminance":101.57625411482745},{"name":"Dark Blue","hex":"#305679","rgb":{"r":48,"g":86,"b":121},"luminance":54.2649671887858},{"name":"Dark Brazilian Topaz","hex":"#92462f","rgb":{"r":146,"g":70,"b":47},"luminance":60.18943412260992},{"name":"Dark Citron","hex":"#aabb00","rgb":{"r":170,"g":187,"b":0},"luminance":120.9666163079715},{"name":"Dark Crypt","hex":"#3f4551","rgb":{"r":63,"g":69,"b":81},"luminance":45.61351043276542},{"name":"Dark Cyan","hex":"#008b8b","rgb":{"r":0,"g":139,"b":139},"luminance":83.11746726771695},{"name":"Dark Denim","hex":"#005588","rgb":{"r":0,"g":85,"b":136},"luminance":52.24830180015423},{"name":"Dark Earth","hex":"#884455","rgb":{"r":136,"g":68,"b":85},"luminance":57.799169994040575},{"name":"Dark Elf","hex":"#3b3f42","rgb":{"r":59,"g":63,"b":66},"luminance":41.65825029931045},{"name":"Dark Emerald","hex":"#00834e","rgb":{"r":0,"g":131,"b":78},"luminance":77.40940687668392},{"name":"Dark Energy","hex":"#503d4d","rgb":{"r":80,"g":61,"b":77},"luminance":43.947251711568946},{"name":"Dark Engine","hex":"#3e3f41","rgb":{"r":62,"g":63,"b":65},"luminance":42.02570528854929},{"name":"Dark Envy","hex":"#a4a582","rgb":{"r":164,"g":165,"b":130},"luminance":109.56757148444972},{"name":"Dark Fern","hex":"#0a480d","rgb":{"r":10,"g":72,"b":13},"luminance":42.39554363373584},{"name":"Dark Forest","hex":"#556962","rgb":{"r":85,"g":105,"b":98},"luminance":67.59888337835174},{"name":"Dark Galaxy","hex":"#0018a8","rgb":{"r":0,"g":24,"b":168},"luminance":23.77542529588062},{"name":"Dark Granite","hex":"#4f443f","rgb":{"r":79,"g":68,"b":63},"luminance":46.93420736520432},{"name":"Dark Green","hex":"#033500","rgb":{"r":3,"g":53,"b":0},"luminance":31.12392857593655},{"name":"Dark Grey","hex":"#363737","rgb":{"r":54,"g":55,"b":55},"luminance":36.63778706472321},{"name":"Dark Horizon","hex":"#666699","rgb":{"r":102,"g":102,"b":153},"luminance":69.42079835323129},{"name":"Dark Imperial Blue","hex":"#00416a","rgb":{"r":0,"g":65,"b":106},"luminance":40.022831996249344},{"name":"Dark Ivy","hex":"#5b7763","rgb":{"r":91,"g":119,"b":99},"luminance":75.80992735783354},{"name":"Dark Lagoon","hex":"#6a7f7d","rgb":{"r":106,"g":127,"b":125},"luminance":82.25038320275473},{"name":"Dark Lavender","hex":"#856798","rgb":{"r":133,"g":103,"b":152},"luminance":74.41240752723971},{"name":"Dark Lemon Lime","hex":"#8bbe1b","rgb":{"r":139,"g":190,"b":27},"luminance":119.06188183041623},{"name":"Dark Lilac","hex":"#9c6da5","rgb":{"r":156,"g":109,"b":165},"luminance":81.38367849268057},{"name":"Dark Lime","hex":"#84b701","rgb":{"r":132,"g":183,"b":1},"luminance":114.4421568347958},{"name":"Dark Lime Green","hex":"#7ebd01","rgb":{"r":126,"g":189,"b":1},"luminance":117.16523597466954},{"name":"Dark Limestone","hex":"#989a98","rgb":{"r":152,"g":154,"b":152},"luminance":102.65270913132298},{"name":"Dark LUA Console","hex":"#5f574f","rgb":{"r":95,"g":87,"b":79},"luminance":59.12693820924604},{"name":"Dark Magenta","hex":"#8b008b","rgb":{"r":139,"g":0,"b":139},"luminance":44.47934843272775},{"name":"Dark Maroon","hex":"#3c0008","rgb":{"r":60,"g":0,"b":8},"luminance":17.96316631332015},{"name":"Dark Matter","hex":"#110101","rgb":{"r":17,"g":1,"b":1},"luminance":5.118051777776384},{"name":"Dark Midnight Blue","hex":"#003377","rgb":{"r":0,"g":51,"b":119},"luminance":32.86731393040812},{"name":"Dark Mountain Meadow","hex":"#1ab385","rgb":{"r":26,"g":179,"b":133},"luminance":106.44555720648935},{"name":"Dark Olive","hex":"#373e02","rgb":{"r":55,"g":62,"b":2},"luminance":39.93761691688676},{"name":"Dark Olive Paste","hex":"#6e5160","rgb":{"r":110,"g":81,"b":96},"luminance":58.84080595131239},{"name":"Dark Orange","hex":"#c65102","rgb":{"r":198,"g":81,"b":2},"luminance":75.93185100470026},{"name":"Dark Pansy","hex":"#653d7c","rgb":{"r":101,"g":61,"b":124},"luminance":48.927981217295276},{"name":"Dark Periwinkle","hex":"#665fd1","rgb":{"r":102,"g":95,"b":209},"luminance":67.87887377527709},{"name":"Dark Pewter","hex":"#606865","rgb":{"r":96,"g":104,"b":101},"luminance":68.43500650982654},{"name":"Dark Pink","hex":"#cb416b","rgb":{"r":203,"g":65,"b":107},"luminance":72.72359340681675},{"name":"Dark Potion","hex":"#603e53","rgb":{"r":96,"g":62,"b":83},"luminance":47.307211881488},{"name":"Dark Puce","hex":"#4f3a3c","rgb":{"r":79,"g":58,"b":60},"luminance":41.99842088698097},{"name":"Dark Purple","hex":"#35063e","rgb":{"r":53,"g":6,"b":62},"luminance":17.705606936787003},{"name":"Dark Rainforest","hex":"#505838","rgb":{"r":80,"g":88,"b":56},"luminance":57.282320064745974},{"name":"Dark Raspberry","hex":"#872657","rgb":{"r":135,"g":38,"b":87},"luminance":47.17263597680333},{"name":"Dark Reaper","hex":"#3b5150","rgb":{"r":59,"g":81,"b":80},"luminance":51.52762841427888},{"name":"Dark Red","hex":"#840000","rgb":{"r":132,"g":0,"b":0},"luminance":39.467999999999996},{"name":"Dark Rose","hex":"#b5485d","rgb":{"r":181,"g":72,"b":93},"luminance":69.48031563687661},{"name":"Dark Royalty","hex":"#02066f","rgb":{"r":2,"g":6,"b":111},"luminance":13.14860464079744},{"name":"Dark Rum","hex":"#45362b","rgb":{"r":69,"g":54,"b":43},"luminance":38.1370026221254},{"name":"Dark Sage","hex":"#6d765b","rgb":{"r":109,"g":118,"b":91},"luminance":77.25006092554231},{"name":"Dark Sakura","hex":"#a2646f","rgb":{"r":162,"g":100,"b":111},"luminance":77.14955320674255},{"name":"Dark Salmon","hex":"#c85a53","rgb":{"r":200,"g":90,"b":83},"luminance":80.35283656474114},{"name":"Dark Sanctuary","hex":"#3f012c","rgb":{"r":63,"g":1,"b":44},"luminance":19.50224074305309},{"name":"Dark Sand","hex":"#a88f59","rgb":{"r":168,"g":143,"b":89},"luminance":98.34778401672301},{"name":"Dark Sapphire","hex":"#082567","rgb":{"r":8,"g":37,"b":103},"luminance":24.805466917597013},{"name":"Dark Seagreen","hex":"#666655","rgb":{"r":102,"g":102,"b":85},"luminance":67.88902694839571},{"name":"Dark Secret","hex":"#3e5361","rgb":{"r":62,"g":83,"b":97},"luminance":53.288578973359755},{"name":"Dark Shadow","hex":"#4a4b4d","rgb":{"r":74,"g":75,"b":77},"luminance":50.048114699756674},{"name":"Dark Shamrock","hex":"#33cc99","rgb":{"r":51,"g":204,"b":153},"luminance":121.968597880766},{"name":"Dark Side of the Moon","hex":"#070d0d","rgb":{"r":7,"g":13,"b":13},"luminance":8.050412039144332},{"name":"Dark Sienna","hex":"#3c1414","rgb":{"r":60,"g":20,"b":20},"luminance":21.56083486324219},{"name":"Dark Sky","hex":"#909989","rgb":{"r":144,"g":153,"b":137},"luminance":100.81545903778844},{"name":"Dark Slate","hex":"#465352","rgb":{"r":70,"g":83,"b":82},"luminance":53.84408830131679},{"name":"Dark Slate Blue","hex":"#214761","rgb":{"r":33,"g":71,"b":97},"luminance":44.23357754014477},{"name":"Dark Slate Grey","hex":"#2f4f4f","rgb":{"r":47,"g":79,"b":79},"luminance":49.285393109926595},{"name":"Dark Sorrel","hex":"#587a65","rgb":{"r":88,"g":122,"b":101},"luminance":77.15865820502582},{"name":"Dark Souls","hex":"#a3a3a2","rgb":{"r":163,"g":163,"b":162},"luminance":108.95510981133468},{"name":"Dark Spell","hex":"#303b4c","rgb":{"r":48,"g":59,"b":76},"luminance":38.477129427752274},{"name":"Dark Sting","hex":"#7e736d","rgb":{"r":126,"g":115,"b":109},"luminance":78.29853623791443},{"name":"Dark Strawberry","hex":"#80444c","rgb":{"r":128,"g":68,"b":76},"luminance":55.974082716914616},{"name":"Dark Summoning","hex":"#383839","rgb":{"r":56,"g":56,"b":57},"luminance":37.45869623999212},{"name":"Dark Taupe","hex":"#483c3c","rgb":{"r":72,"g":60,"b":60},"luminance":41.84123306022422},{"name":"Dark Tavern","hex":"#634e43","rgb":{"r":99,"g":78,"b":67},"luminance":55.053755920917865},{"name":"Dark Teal","hex":"#014d4e","rgb":{"r":1,"g":77,"b":78},"luminance":46.06632898332577},{"name":"Dark Tone Ink","hex":"#121212","rgb":{"r":18,"g":18,"b":18},"luminance":12.033992853579395},{"name":"Dark Topaz","hex":"#817c87","rgb":{"r":129,"g":124,"b":135},"luminance":83.80135491148098},{"name":"Dark Turquoise","hex":"#045c5a","rgb":{"r":4,"g":92,"b":90},"luminance":54.982997662913945},{"name":"Dark Violet","hex":"#34013f","rgb":{"r":52,"g":1,"b":63},"luminance":17.136685706401924},{"name":"Dark Void","hex":"#151517","rgb":{"r":21,"g":21,"b":23},"luminance":14.080328618324218},{"name":"Dark Wood","hex":"#855e42","rgb":{"r":133,"g":94,"b":66},"luminance":68.42979284639111},{"name":"Dark Wood Grain","hex":"#4f301f","rgb":{"r":79,"g":48,"b":31},"luminance":36.93680783446236},{"name":"Darkest Dungeon","hex":"#660011","rgb":{"r":102,"g":0,"b":17},"luminance":30.559513216018345},{"name":"Darkest Spruce","hex":"#303f3d","rgb":{"r":48,"g":63,"b":61},"luminance":40.27322163671538},{"name":"Darkness","hex":"#16160e","rgb":{"r":22,"g":22,"b":14},"luminance":14.580421667427865},{"name":"Darkout","hex":"#2d1608","rgb":{"r":45,"g":22,"b":8},"luminance":18.67190844557674},{"name":"Darkshore","hex":"#464964","rgb":{"r":70,"g":73,"b":100},"luminance":49.03297972793413},{"name":"Darlak","hex":"#4f4969","rgb":{"r":79,"g":73,"b":105},"luminance":50.37301601055867},{"name":"Darling Bud","hex":"#ff88ff","rgb":{"r":255,"g":136,"b":255},"luminance":114.15565316268834},{"name":"Darling Lilac","hex":"#c9acd6","rgb":{"r":201,"g":172,"b":214},"luminance":120.00326625971478},{"name":"Darth Vader","hex":"#0b0b0b","rgb":{"r":11,"g":11,"b":11},"luminance":7.354106743854076},{"name":"Dartmoor Mist","hex":"#cddce3","rgb":{"r":205,"g":220,"b":227},"luminance":145.27177120486965},{"name":"Dartmouth Green","hex":"#00703c","rgb":{"r":0,"g":112,"b":60},"luminance":66.09885881011866},{"name":"DaVanzo Beige","hex":"#ccac86","rgb":{"r":204,"g":172,"b":134},"luminance":118.9436735938486},{"name":"DaVanzo Green","hex":"#58936d","rgb":{"r":88,"g":147,"b":109},"luminance":91.06326559595807},{"name":"Davao Green","hex":"#b1d27b","rgb":{"r":177,"g":210,"b":123},"luminance":134.88125634423784},{"name":"Davy's Grey","hex":"#555555","rgb":{"r":85,"g":85,"b":85},"luminance":56.827188475236035},{"name":"Dawn","hex":"#9f9d91","rgb":{"r":159,"g":157,"b":145},"luminance":105.00794666119322},{"name":"Dawn Blue","hex":"#cacccb","rgb":{"r":202,"g":204,"b":203},"luminance":136.099427155297},{"name":"Dawn Departs","hex":"#ccffff","rgb":{"r":204,"g":255,"b":255},"luminance":164.22903562098878},{"name":"Dawn Pink","hex":"#e6d6cd","rgb":{"r":230,"g":214,"b":205},"luminance":145.10462337224132},{"name":"Dawnstone","hex":"#70756e","rgb":{"r":112,"g":117,"b":110},"luminance":77.43063208446642},{"name":"Day At The Zoo","hex":"#ffa373","rgb":{"r":255,"g":163,"b":115},"luminance":123.04481251153987},{"name":"Day Dreamer","hex":"#d9cdc4","rgb":{"r":217,"g":205,"b":196},"luminance":138.5264243745575},{"name":"Day Glow","hex":"#eadd82","rgb":{"r":234,"g":221,"b":130},"luminance":148.13496577445852},{"name":"Day Glow Orange","hex":"#eb5c34","rgb":{"r":235,"g":92,"b":52},"luminance":88.8185984183493},{"name":"Day Lily","hex":"#fff9ec","rgb":{"r":255,"g":249,"b":236},"luminance":167.03516938058283},{"name":"Day On Mercury","hex":"#d5d2d1","rgb":{"r":213,"g":210,"b":209},"luminance":140.78069876584644},{"name":"Daybreak","hex":"#8981a0","rgb":{"r":137,"g":129,"b":160},"luminance":88.00362320950201},{"name":"Daydream","hex":"#e3ebae","rgb":{"r":227,"g":235,"b":174},"luminance":155.0130125183044},{"name":"Daydreaming","hex":"#f4f0e1","rgb":{"r":244,"g":240,"b":225},"luminance":160.70990895399078},{"name":"Dayflower","hex":"#38a1db","rgb":{"r":56,"g":161,"b":219},"luminance":99.17275705051262},{"name":"Daystar","hex":"#fff8da","rgb":{"r":255,"g":248,"b":218},"luminance":166.20256828641365},{"name":"Dazzle Me","hex":"#edebea","rgb":{"r":237,"g":235,"b":234},"luminance":157.3594508442375},{"name":"Dazzling Blue","hex":"#3850a0","rgb":{"r":56,"g":80,"b":160},"luminance":53.087670282279284},{"name":"De York","hex":"#85ca87","rgb":{"r":133,"g":202,"b":135},"luminance":126.00817380233713},{"name":"Dead 99","hex":"#99dead","rgb":{"r":153,"g":222,"b":173},"luminance":139.5115905184942},{"name":"Dead Flesh","hex":"#849b63","rgb":{"r":132,"g":155,"b":99},"luminance":99.8166671703679},{"name":"Dead Forest","hex":"#434b4f","rgb":{"r":67,"g":75,"b":79},"luminance":49.19989583322306},{"name":"Dead Grass","hex":"#e4dc8a","rgb":{"r":228,"g":220,"b":138},"luminance":146.87428981275107},{"name":"Dead Lake","hex":"#2e5a88","rgb":{"r":46,"g":90,"b":136},"luminance":56.749937726838084},{"name":"Dead Pixel","hex":"#3b3a3a","rgb":{"r":59,"g":58,"b":58},"luminance":38.910840918695136},{"name":"Dead Sea","hex":"#77eeee","rgb":{"r":119,"g":238,"b":238},"luminance":146.69669192248335},{"name":"Dead Sea Mud","hex":"#3a403b","rgb":{"r":58,"g":64,"b":59},"luminance":41.92062337322764},{"name":"Deadlock","hex":"#8f666a","rgb":{"r":143,"g":102,"b":106},"luminance":74.5592380661176},{"name":"Deadly Depths","hex":"#111144","rgb":{"r":17,"g":17,"b":68},"luminance":13.620236194721441},{"name":"Deadsy","hex":"#c2a84b","rgb":{"r":194,"g":168,"b":75},"luminance":114.7297432752292},{"name":"Deadwind Pass","hex":"#596d7f","rgb":{"r":89,"g":109,"b":127},"luminance":70.79252851819886},{"name":"Death Cap","hex":"#e7d9db","rgb":{"r":231,"g":217,"b":219},"luminance":147.03481750252217},{"name":"Death Guard","hex":"#9eb37b","rgb":{"r":158,"g":179,"b":123},"luminance":116.0549799750101},{"name":"Death Valley Beige","hex":"#ddbb88","rgb":{"r":221,"g":187,"b":136},"luminance":129.05828767653784},{"name":"Deathclaw Brown","hex":"#b36853","rgb":{"r":179,"g":104,"b":83},"luminance":81.736682028328},{"name":"Deathworld Forest","hex":"#5c6730","rgb":{"r":92,"g":103,"b":48},"luminance":66.64957140897457},{"name":"Deauville Mauve","hex":"#af9294","rgb":{"r":175,"g":146,"b":148},"luminance":101.82044398351442},{"name":"Debian Red","hex":"#d70a53","rgb":{"r":215,"g":10,"b":83},"luminance":65.2422222874114},{"name":"Debonaire","hex":"#cbd0dd","rgb":{"r":203,"g":208,"b":221},"luminance":138.65892203893696},{"name":"Debrito","hex":"#ee7744","rgb":{"r":238,"g":119,"b":68},"luminance":100.01782519631188},{"name":"Decadence","hex":"#73667b","rgb":{"r":115,"g":102,"b":123},"luminance":70.45452849178682},{"name":"Decadent Chocolate","hex":"#513235","rgb":{"r":81,"g":50,"b":53},"luminance":38.52905689216906},{"name":"Decanter","hex":"#ada3bb","rgb":{"r":173,"g":163,"b":187},"luminance":110.8376895013605},{"name":"Decaying Leave","hex":"#d57835","rgb":{"r":213,"g":120,"b":53},"luminance":95.1542607191081},{"name":"December Forest","hex":"#e0e8db","rgb":{"r":224,"g":232,"b":219},"luminance":153.80236535242233},{"name":"December Rain","hex":"#d6dddc","rgb":{"r":214,"g":221,"b":220},"luminance":146.80704725931926},{"name":"December Sky","hex":"#d5d7d9","rgb":{"r":213,"g":215,"b":217},"luminance":143.51203656139788},{"name":"Decency","hex":"#bfb5ca","rgb":{"r":191,"g":181,"b":202},"luminance":122.80126902438754},{"name":"Dechala Lilac","hex":"#b69fcc","rgb":{"r":182,"g":159,"b":204},"luminance":110.51338900332392},{"name":"Deck Crew","hex":"#5e7cac","rgb":{"r":94,"g":124,"b":172},"luminance":80.45193499226727},{"name":"Deco","hex":"#cccf82","rgb":{"r":204,"g":207,"b":130},"luminance":136.7646938979501},{"name":"Deco Grey","hex":"#89978e","rgb":{"r":137,"g":151,"b":142},"luminance":98.97745441260852},{"name":"Deco Rose","hex":"#985f68","rgb":{"r":152,"g":95,"b":104},"luminance":72.90967470096132},{"name":"Deco-Rate","hex":"#8fcbc0","rgb":{"r":143,"g":203,"b":192},"luminance":128.47797287473054},{"name":"Deconstruction","hex":"#7b736b","rgb":{"r":123,"g":115,"b":107},"luminance":77.83485053624757},{"name":"Decoration Blue","hex":"#3f74a3","rgb":{"r":63,"g":116,"b":163},"luminance":73.05233573952307},{"name":"Decore Splash","hex":"#00829e","rgb":{"r":0,"g":130,"b":158},"luminance":78.40694002446467},{"name":"Decorum","hex":"#b39aa0","rgb":{"r":179,"g":154,"b":160},"luminance":106.62548215600246},{"name":"Dedication","hex":"#fee2c8","rgb":{"r":254,"g":226,"b":200},"luminance":154.55368374775153},{"name":"Deduction","hex":"#d4cb83","rgb":{"r":212,"g":203,"b":131},"luminance":135.79545950067697},{"name":"Deep Amethyst","hex":"#5b3082","rgb":{"r":91,"g":48,"b":130},"luminance":41.87898108836938},{"name":"Deep Aquamarine","hex":"#78dbe2","rgb":{"r":120,"g":219,"b":226},"luminance":135.93024646854724},{"name":"Deep Blue","hex":"#040273","rgb":{"r":4,"g":2,"b":115},"luminance":13.216686120204265},{"name":"Deep Blush","hex":"#e36f8a","rgb":{"r":227,"g":111,"b":138},"luminance":95.39221457750102},{"name":"Deep Bottlebrush","hex":"#5e675a","rgb":{"r":94,"g":103,"b":90},"luminance":67.4592273673513},{"name":"Deep Breath","hex":"#27275f","rgb":{"r":39,"g":39,"b":95},"luminance":27.88112748796217},{"name":"Deep Bronze","hex":"#51412d","rgb":{"r":81,"g":65,"b":45},"luminance":45.48275372050377},{"name":"Deep Cerulean","hex":"#007bbb","rgb":{"r":0,"g":123,"b":187},"luminance":75.2824117905371},{"name":"Deep Champagne","hex":"#fad6c5","rgb":{"r":250,"g":214,"b":197},"luminance":147.89119712815906},{"name":"Deep Chestnut","hex":"#b94e48","rgb":{"r":185,"g":78,"b":72},"luminance":72.27363478475397},{"name":"Deep Claret","hex":"#771133","rgb":{"r":119,"g":17,"b":51},"luminance":37.4084295045916},{"name":"Deep Cobalt","hex":"#404466","rgb":{"r":64,"g":68,"b":102},"luminance":45.76771718143696},{"name":"Deep Coral","hex":"#da7c55","rgb":{"r":218,"g":124,"b":85},"luminance":98.18697555175024},{"name":"Deep Cove","hex":"#051040","rgb":{"r":5,"g":16,"b":64},"luminance":11.986505120342626},{"name":"Deep Current","hex":"#007381","rgb":{"r":0,"g":115,"b":129},"luminance":69.0882874371626},{"name":"Deep Denim","hex":"#6688ff","rgb":{"r":102,"g":136,"b":255},"luminance":90.26816231651112},{"name":"Deep Depths","hex":"#46483c","rgb":{"r":70,"g":72,"b":60},"luminance":47.656019514852474},{"name":"Deep Dive","hex":"#29495c","rgb":{"r":41,"g":73,"b":92},"luminance":45.78743742556467},{"name":"Deep Diving","hex":"#5e97a9","rgb":{"r":94,"g":151,"b":169},"luminance":94.96127505988954},{"name":"Deep Dungeon","hex":"#553d3a","rgb":{"r":85,"g":61,"b":58},"luminance":44.40475220063726},{"name":"Deep Exquisite","hex":"#614454","rgb":{"r":97,"g":68,"b":84},"luminance":50.26092757799044},{"name":"Deep Fir","hex":"#193925","rgb":{"r":25,"g":57,"b":37},"luminance":34.542319406779846},{"name":"Deep Forest","hex":"#37413a","rgb":{"r":55,"g":65,"b":58},"luminance":42.070899610063016},{"name":"Deep Green","hex":"#02590f","rgb":{"r":2,"g":89,"b":15},"luminance":52.2743986383392},{"name":"Deep into the Jungle","hex":"#004b49","rgb":{"r":0,"g":75,"b":73},"luminance":44.8046460648893},{"name":"Deep into the Wood","hex":"#306030","rgb":{"r":48,"g":96,"b":48},"luminance":58.40779564407477},{"name":"Deep Koamaru","hex":"#343467","rgb":{"r":52,"g":52,"b":103},"luminance":36.21228305423451},{"name":"Deep Lagoon","hex":"#005265","rgb":{"r":0,"g":82,"b":101},"luminance":49.491960478445385},{"name":"Deep Lake","hex":"#00656b","rgb":{"r":0,"g":101,"b":107},"luminance":60.528832575888984},{"name":"Deep Loch","hex":"#2e5767","rgb":{"r":46,"g":87,"b":103},"luminance":54.17646944015455},{"name":"Deep Magenta","hex":"#a0025c","rgb":{"r":160,"g":2,"b":92},"luminance":48.99022371861553},{"name":"Deep Marine","hex":"#2e6469","rgb":{"r":46,"g":100,"b":105},"luminance":61.46660407082857},{"name":"Deep Marsh","hex":"#938565","rgb":{"r":147,"g":133,"b":101},"luminance":90.33005837482891},{"name":"Deep Mint","hex":"#55aa66","rgb":{"r":85,"g":170,"b":102},"luminance":103.62999907845217},{"name":"Deep Mystery","hex":"#494c59","rgb":{"r":73,"g":76,"b":89},"luminance":50.691121402075915},{"name":"Deep Night","hex":"#494c55","rgb":{"r":73,"g":76,"b":85},"luminance":50.60182381100507},{"name":"Deep Ocean","hex":"#2a4b5f","rgb":{"r":42,"g":75,"b":95},"luminance":47.04458405597822},{"name":"Deep Orange","hex":"#dc4d01","rgb":{"r":220,"g":77,"b":1},"luminance":79.81209806163474},{"name":"Deep Orange-coloured Brown","hex":"#864735","rgb":{"r":134,"g":71,"b":53},"luminance":58.12712317842678},{"name":"Deep Pacific","hex":"#006e62","rgb":{"r":0,"g":110,"b":98},"luminance":65.52937115523083},{"name":"Deep Peacock Blue","hex":"#008381","rgb":{"r":0,"g":131,"b":129},"luminance":78.2905808191509},{"name":"Deep Periwinkle","hex":"#7c83bc","rgb":{"r":124,"g":131,"b":188},"luminance":88.0176630512308},{"name":"Deep Pond","hex":"#014420","rgb":{"r":1,"g":68,"b":32},"luminance":40.08346742735713},{"name":"Deep Purple","hex":"#36013f","rgb":{"r":54,"g":1,"b":63},"luminance":17.681035292086264},{"name":"Deep Red","hex":"#9a0200","rgb":{"r":154,"g":2,"b":0},"luminance":46.06096386312384},{"name":"Deep Reddish Orange","hex":"#bb603c","rgb":{"r":187,"g":96,"b":60},"luminance":79.6780840193839},{"name":"Deep Reservoir","hex":"#424f5f","rgb":{"r":66,"g":79,"b":95},"luminance":51.54779127178971},{"name":"Deep Rhubarb","hex":"#7f5153","rgb":{"r":127,"g":81,"b":83},"luminance":61.58080368101735},{"name":"Deep Rift","hex":"#4c6a68","rgb":{"r":76,"g":106,"b":104},"luminance":67.29429541944843},{"name":"Deep Saffron","hex":"#ff9932","rgb":{"r":255,"g":153,"b":50},"luminance":117.94831811433343},{"name":"Deep Sanction","hex":"#195155","rgb":{"r":25,"g":81,"b":85},"luminance":49.09673037993467},{"name":"Deep Sea","hex":"#167e65","rgb":{"r":22,"g":126,"b":101},"luminance":75.14133166240799},{"name":"Deep Sea Coral","hex":"#d9615b","rgb":{"r":217,"g":97,"b":91},"luminance":86.94523153111963},{"name":"Deep Sea Diver","hex":"#255c61","rgb":{"r":37,"g":92,"b":97},"luminance":56.223672496556105},{"name":"Deep Sea Dolphin","hex":"#6a6873","rgb":{"r":106,"g":104,"b":115},"luminance":70.02313931837102},{"name":"Deep Sea Dream","hex":"#002d69","rgb":{"r":0,"g":45,"b":105},"luminance":29.00057111506599},{"name":"Deep Sea Exploration","hex":"#2000b1","rgb":{"r":32,"g":0,"b":177},"luminance":22.331554088329813},{"name":"Deep Sea Green","hex":"#095859","rgb":{"r":9,"g":88,"b":89},"luminance":52.71171722681779},{"name":"Deep Sea Nightmare","hex":"#002366","rgb":{"r":0,"g":35,"b":102},"luminance":23.607359212753973},{"name":"Deep Sea Shadow","hex":"#4f5a4c","rgb":{"r":79,"g":90,"b":76},"luminance":58.515172707597806},{"name":"Deep Sea Turtle","hex":"#5e5749","rgb":{"r":94,"g":87,"b":73},"luminance":58.883322604961755},{"name":"Deep Seagrass","hex":"#959889","rgb":{"r":149,"g":152,"b":137},"luminance":100.94372541668946},{"name":"Deep Seaweed","hex":"#37412a","rgb":{"r":55,"g":65,"b":42},"luminance":41.8230438155809},{"name":"Deep Serenity","hex":"#7f6968","rgb":{"r":127,"g":105,"b":104},"luminance":73.35793542623729},{"name":"Deep Sky Blue","hex":"#0d75f8","rgb":{"r":13,"g":117,"b":248},"luminance":74.37217083022387},{"name":"Deep South","hex":"#b4989f","rgb":{"r":180,"g":152,"b":159},"luminance":105.76420212907578},{"name":"Deep Space Sparkle","hex":"#4a646c","rgb":{"r":74,"g":100,"b":108},"luminance":63.928360060305},{"name":"Deep Tan","hex":"#726751","rgb":{"r":114,"g":103,"b":81},"luminance":70.01895938244155},{"name":"Deep Taupe","hex":"#7b6660","rgb":{"r":123,"g":102,"b":96},"luminance":71.11409664053956},{"name":"Deep Teal","hex":"#00555a","rgb":{"r":0,"g":85,"b":90},"luminance":50.93896961070178},{"name":"Deep Velvet","hex":"#313248","rgb":{"r":49,"g":50,"b":72},"luminance":33.81487195007546},{"name":"Deep Violet","hex":"#330066","rgb":{"r":51,"g":0,"b":102},"luminance":19.176610362626654},{"name":"Deep Walnut","hex":"#615d58","rgb":{"r":97,"g":93,"b":88},"luminance":62.62581188296084},{"name":"Deep Water","hex":"#266691","rgb":{"r":38,"g":102,"b":145},"luminance":63.14453119629601},{"name":"Deep Well","hex":"#2c2a33","rgb":{"r":44,"g":42,"b":51},"luminance":28.542996478996383},{"name":"Deep Wisteria","hex":"#443f6f","rgb":{"r":68,"g":63,"b":111},"luminance":44.058010633708825},{"name":"Deepest Sea","hex":"#444d56","rgb":{"r":68,"g":77,"b":86},"luminance":50.521859041408995},{"name":"Deepest Water","hex":"#466174","rgb":{"r":70,"g":97,"b":116},"luminance":62.08855608725331},{"name":"Deeply Embarrassed","hex":"#ecb2b3","rgb":{"r":236,"g":178,"b":179},"luminance":127.72238303445484},{"name":"Deepsea Kraken","hex":"#082599","rgb":{"r":8,"g":37,"b":153},"luminance":27.958182862983065},{"name":"Deer","hex":"#ba8759","rgb":{"r":186,"g":135,"b":89},"luminance":97.34283916652522},{"name":"Deer God","hex":"#96847a","rgb":{"r":150,"g":132,"b":122},"luminance":90.60201554049445},{"name":"Deer Leather","hex":"#ac7434","rgb":{"r":172,"g":116,"b":52},"luminance":85.53654676218815},{"name":"Deer Tracks","hex":"#a1614c","rgb":{"r":161,"g":97,"b":76},"luminance":75.06315965904979},{"name":"Defenestration","hex":"#c6d5e4","rgb":{"r":198,"g":213,"b":228},"luminance":140.75941115605733},{"name":"Del Rio","hex":"#b5998e","rgb":{"r":181,"g":153,"b":142},"luminance":106.09869568472554},{"name":"Del Sol Maize","hex":"#dabf92","rgb":{"r":218,"g":191,"b":146},"luminance":130.75143421393128},{"name":"Delft","hex":"#3d5e8c","rgb":{"r":61,"g":94,"b":140},"luminance":60.26603027411047},{"name":"Delft Blue","hex":"#3311ee","rgb":{"r":51,"g":17,"b":238},"luminance":32.6842143243493},{"name":"Delhi Dance Pink","hex":"#fdc1c5","rgb":{"r":253,"g":193,"b":197},"luminance":138.0640469275039},{"name":"Delhi Spice","hex":"#a36a6d","rgb":{"r":163,"g":106,"b":109},"luminance":80.00798665758312},{"name":"Delicacy","hex":"#f5e3e2","rgb":{"r":245,"g":227,"b":226},"luminance":154.22507812285264},{"name":"Delicate Blue","hex":"#bcdfe8","rgb":{"r":188,"g":223,"b":232},"luminance":144.89429750338692},{"name":"Delicate Brown","hex":"#a78c8b","rgb":{"r":167,"g":140,"b":139},"luminance":97.4574399674032},{"name":"Delicate Cloud","hex":"#dddfe8","rgb":{"r":221,"g":223,"b":232},"luminance":149.0000092147648},{"name":"Delicate Daisy","hex":"#e9edc0","rgb":{"r":233,"g":237,"b":192},"luminance":157.1199274248814},{"name":"Delicate Girl Blue","hex":"#6ab2ca","rgb":{"r":106,"g":178,"b":202},"luminance":111.58907928646065},{"name":"Delicate Mauve","hex":"#c5b5ca","rgb":{"r":197,"g":181,"b":202},"luminance":123.64577308586009},{"name":"Delicate Mint","hex":"#ddf3e6","rgb":{"r":221,"g":243,"b":230},"luminance":159.3749588925437},{"name":"Delicate Mist","hex":"#e1ebe5","rgb":{"r":225,"g":235,"b":229},"luminance":155.68003046633822},{"name":"Delicate Pink","hex":"#e4cfd3","rgb":{"r":228,"g":207,"b":211},"luminance":141.38760052069628},{"name":"Delicate Prunus","hex":"#a95c68","rgb":{"r":169,"g":92,"b":104},"luminance":74.90246132804982},{"name":"Delicate Sapling","hex":"#d7f3dd","rgb":{"r":215,"g":243,"b":221},"luminance":158.47319565781464},{"name":"Delicate Seashell","hex":"#ffefdd","rgb":{"r":255,"g":239,"b":221},"luminance":161.64827097745277},{"name":"Delicate Truffle","hex":"#aa9c8b","rgb":{"r":170,"g":156,"b":139},"luminance":105.92552006008748},{"name":"Delicate Turquoise","hex":"#c0dfe2","rgb":{"r":192,"g":223,"b":226},"luminance":145.2395743624994},{"name":"Delicate White","hex":"#f1f2ee","rgb":{"r":241,"g":242,"b":238},"luminance":161.57965163039557},{"name":"Délicieux","hex":"#412010","rgb":{"r":65,"g":32,"b":16},"luminance":27.09030928210307},{"name":"Delicioso","hex":"#3f352f","rgb":{"r":63,"g":53,"b":47},"luminance":36.761869566168684},{"name":"Delicious Dill","hex":"#77cc00","rgb":{"r":119,"g":204,"b":0},"luminance":124.92234013578195},{"name":"Delicious Mandarin","hex":"#ffaa11","rgb":{"r":255,"g":170,"b":17},"luminance":125.59896484047947},{"name":"Delightful Camouflage","hex":"#a5a943","rgb":{"r":165,"g":169,"b":67},"luminance":111.05636622004161},{"name":"Delightful Dandelion","hex":"#eeee33","rgb":{"r":238,"g":238,"b":51},"luminance":156.89359220822243},{"name":"Delightful Green","hex":"#00ee00","rgb":{"r":0,"g":238,"b":0},"luminance":139.706},{"name":"Delightful Pastry","hex":"#f9e7c8","rgb":{"r":249,"g":231,"b":200},"luminance":156.36284024665193},{"name":"Delightful Peach","hex":"#ffebd1","rgb":{"r":255,"g":235,"b":209},"luminance":159.40452103375233},{"name":"Delirious Donkey","hex":"#ddcccc","rgb":{"r":221,"g":204,"b":204},"luminance":138.733050427791},{"name":"Dell","hex":"#486531","rgb":{"r":72,"g":101,"b":49},"luminance":63.321454097327866},{"name":"Della Robbia Blue","hex":"#7a9dcb","rgb":{"r":122,"g":157,"b":203},"luminance":101.7815205673407},{"name":"Delltone","hex":"#8ec39e","rgb":{"r":142,"g":195,"b":158},"luminance":123.40725316204067},{"name":"Delos Blue","hex":"#169ec0","rgb":{"r":22,"g":158,"b":192},"luminance":95.52054828150851},{"name":"Delphinium Blue","hex":"#6198ae","rgb":{"r":97,"g":152,"b":174},"luminance":95.89349863781172},{"name":"Delta","hex":"#999b95","rgb":{"r":153,"g":155,"b":149},"luminance":103.24525378921784},{"name":"Delta Break","hex":"#979147","rgb":{"r":151,"g":145,"b":71},"luminance":96.68768412781434},{"name":"Delta Green","hex":"#2d4a4c","rgb":{"r":45,"g":74,"b":76},"luminance":46.29213502313324},{"name":"Delta Waters","hex":"#c4c2ab","rgb":{"r":196,"g":194,"b":171},"luminance":129.54784342473633},{"name":"Deluge","hex":"#0077aa","rgb":{"r":0,"g":119,"b":170},"luminance":72.49155819128183},{"name":"Delusional Dragonfly","hex":"#66bbcc","rgb":{"r":102,"g":187,"b":204},"luminance":116.27640732754},{"name":"Deluxe Days","hex":"#8bc7e6","rgb":{"r":139,"g":199,"b":230},"luminance":126.72837918161818},{"name":"Demerara Sugar","hex":"#e1b270","rgb":{"r":225,"g":178,"b":112},"luminance":124.92506411845461},{"name":"Demeter","hex":"#ecda9e","rgb":{"r":236,"g":218,"b":158},"luminance":147.23792784469632},{"name":"Demeter Green","hex":"#00cc00","rgb":{"r":0,"g":204,"b":0},"luminance":119.74799999999999},{"name":"Demitasse","hex":"#40342b","rgb":{"r":64,"g":52,"b":43},"luminance":36.358364594684396},{"name":"Demon","hex":"#224376","rgb":{"r":34,"g":67,"b":118},"luminance":42.79105164634307},{"name":"Demonic","hex":"#bb2233","rgb":{"r":187,"g":34,"b":51},"luminance":59.652224845348385},{"name":"Demonic Presence","hex":"#7c0a02","rgb":{"r":124,"g":10,"b":2},"luminance":37.538495707739806},{"name":"Demonic Purple","hex":"#d725de","rgb":{"r":215,"g":37,"b":222},"luminance":72.42079155877819},{"name":"Demonic Yellow","hex":"#ffe700","rgb":{"r":255,"g":231,"b":0},"luminance":155.5629982804394},{"name":"Denali Green","hex":"#7d775d","rgb":{"r":125,"g":119,"b":93},"luminance":79.92956047670974},{"name":"Denim","hex":"#2243b6","rgb":{"r":34,"g":67,"b":182},"luminance":45.61356487932071},{"name":"Denim Tradition","hex":"#7f97b5","rgb":{"r":127,"g":151,"b":181},"luminance":98.61150264548249},{"name":"Denver River","hex":"#7795c1","rgb":{"r":119,"g":149,"b":193},"luminance":96.95293669611044},{"name":"Dépaysement","hex":"#e7d8c7","rgb":{"r":231,"g":216,"b":199},"luminance":146.15537150922643},{"name":"Depth Charge","hex":"#355859","rgb":{"r":53,"g":88,"b":89},"luminance":54.976459152986564},{"name":"Derby","hex":"#f9e4c6","rgb":{"r":249,"g":228,"b":198},"luminance":154.8047850713924},{"name":"Derby Brown","hex":"#8a7265","rgb":{"r":138,"g":114,"b":101},"luminance":79.45529286334548},{"name":"Derby Green","hex":"#599c89","rgb":{"r":89,"g":156,"b":137},"luminance":96.63073232155492},{"name":"Desaturated Cyan","hex":"#669999","rgb":{"r":102,"g":153,"b":153},"luminance":96.43841085895183},{"name":"Descent to the Catacombs","hex":"#445155","rgb":{"r":68,"g":81,"b":85},"luminance":52.61181932797991},{"name":"Desert","hex":"#ccad60","rgb":{"r":204,"g":173,"b":96},"luminance":118.96591424857792},{"name":"Desert Bud","hex":"#c28996","rgb":{"r":194,"g":137,"b":150},"luminance":100.61968791941266},{"name":"Desert Camel","hex":"#c2ae88","rgb":{"r":194,"g":174,"b":136},"luminance":118.47886349893807},{"name":"Desert Chaparral","hex":"#727a60","rgb":{"r":114,"g":122,"b":96},"luminance":80.06367171195684},{"name":"Desert Convoy","hex":"#f7d497","rgb":{"r":247,"g":212,"b":151},"luminance":145.72884594684746},{"name":"Desert Cover","hex":"#d0c8a9","rgb":{"r":208,"g":200,"b":169},"luminance":134.2452368614991},{"name":"Desert Dawn","hex":"#eddbe8","rgb":{"r":237,"g":219,"b":232},"luminance":149.15406558991276},{"name":"Desert Dune","hex":"#b5ab9c","rgb":{"r":181,"g":171,"b":156},"luminance":115.41524572603049},{"name":"Desert Dust","hex":"#e3bc8e","rgb":{"r":227,"g":188,"b":142},"luminance":130.56508801743288},{"name":"Desert Field","hex":"#efcdb8","rgb":{"r":239,"g":205,"b":184},"luminance":141.5174170270218},{"name":"Desert Floor","hex":"#c6b183","rgb":{"r":198,"g":177,"b":131},"luminance":120.51100929375706},{"name":"Desert Flower","hex":"#ff9687","rgb":{"r":255,"g":150,"b":135},"luminance":117.4859762907897},{"name":"Desert Grey","hex":"#b8a487","rgb":{"r":184,"g":164,"b":135},"luminance":111.94257536790906},{"name":"Desert Iguana","hex":"#f3f2e1","rgb":{"r":243,"g":242,"b":225},"luminance":161.6053868687551},{"name":"Desert Khaki","hex":"#d6cdb7","rgb":{"r":214,"g":205,"b":183},"luminance":137.87655154158736},{"name":"Desert Lily","hex":"#fef5db","rgb":{"r":254,"g":245,"b":219},"luminance":164.5413330959732},{"name":"Desert Locust","hex":"#a9a450","rgb":{"r":169,"g":164,"b":80},"luminance":109.10583937168532},{"name":"Desert Mauve","hex":"#e8d2d6","rgb":{"r":232,"g":210,"b":214},"luminance":143.53597855590075},{"name":"Desert Mesa","hex":"#efcfbc","rgb":{"r":239,"g":207,"b":188},"luminance":142.58485973622865},{"name":"Desert Mirage","hex":"#b9e0cf","rgb":{"r":185,"g":224,"b":207},"luminance":144.58806649582115},{"name":"Desert Mist","hex":"#e0b589","rgb":{"r":224,"g":181,"b":137},"luminance":126.56275719578805},{"name":"Desert Morning","hex":"#d0bbb0","rgb":{"r":208,"g":187,"b":176},"luminance":127.74835545321122},{"name":"Desert Palm","hex":"#5a4632","rgb":{"r":90,"g":70,"b":50},"luminance":49.44720619003665},{"name":"Desert Panzer","hex":"#c0cabc","rgb":{"r":192,"g":202,"b":188},"luminance":133.47210406672997},{"name":"Desert Pear","hex":"#aaae9a","rgb":{"r":170,"g":174,"b":154},"luminance":115.42994880012725},{"name":"Desert Pebble","hex":"#cab698","rgb":{"r":202,"g":182,"b":152},"luminance":123.94225084288246},{"name":"Desert Riverbed","hex":"#d5a884","rgb":{"r":213,"g":168,"b":132},"luminance":118.35367222439699},{"name":"Desert Rock","hex":"#d5c6bd","rgb":{"r":213,"g":198,"b":189},"luminance":134.27117025258997},{"name":"Desert Rose","hex":"#cf6977","rgb":{"r":207,"g":105,"b":119},"luminance":88.39486993033023},{"name":"Desert Sage","hex":"#90926f","rgb":{"r":144,"g":146,"b":111},"luminance":96.74076522335349},{"name":"Desert Sand","hex":"#edc9af","rgb":{"r":237,"g":201,"b":175},"luminance":139.0701241748205},{"name":"Desert Shadow","hex":"#403c39","rgb":{"r":64,"g":60,"b":57},"luminance":40.606143623840964},{"name":"Desert Soil","hex":"#a15f3b","rgb":{"r":161,"g":95,"b":59},"luminance":73.97525006378822},{"name":"Desert Spice","hex":"#c66b30","rgb":{"r":198,"g":107,"b":48},"luminance":86.48577957676048},{"name":"Desert Star","hex":"#f9f0e1","rgb":{"r":249,"g":240,"b":225},"luminance":161.39407765156687},{"name":"Desert Storm","hex":"#ede7e0","rgb":{"r":237,"g":231,"b":224},"luminance":155.1135019074742},{"name":"Desert Suede","hex":"#d5c7b3","rgb":{"r":213,"g":199,"b":179},"luminance":134.60206452354288},{"name":"Desert Sun","hex":"#c87629","rgb":{"r":200,"g":118,"b":41},"luminance":91.62786165790402},{"name":"Desert Tan","hex":"#a38c6c","rgb":{"r":163,"g":140,"b":108},"luminance":96.33500357087239},{"name":"Desert Taupe","hex":"#8d7e71","rgb":{"r":141,"g":126,"b":113},"luminance":86.10287247821641},{"name":"Desert Willow","hex":"#89734b","rgb":{"r":137,"g":115,"b":75},"luminance":79.42288646227861},{"name":"Desert Wind","hex":"#e5d295","rgb":{"r":229,"g":210,"b":149},"luminance":142.02920452146452},{"name":"Desert Yellow","hex":"#a29259","rgb":{"r":162,"g":146,"b":89},"luminance":98.96471070032995},{"name":"Deserted Beach","hex":"#e7dbbf","rgb":{"r":231,"g":219,"b":191},"luminance":147.5483230877261},{"name":"Deserted Path","hex":"#e7bf7b","rgb":{"r":231,"g":191,"b":123},"luminance":132.4287164251017},{"name":"Design Delight","hex":"#a47bac","rgb":{"r":164,"g":123,"b":172},"luminance":89.45382809583947},{"name":"Desire","hex":"#ea3c53","rgb":{"r":234,"g":60,"b":83},"luminance":78.90005703419992},{"name":"Desolace Dew","hex":"#b5c1a9","rgb":{"r":181,"g":193,"b":169},"luminance":127.02320889506767},{"name":"Desolate Field","hex":"#d3cbc6","rgb":{"r":211,"g":203,"b":198},"luminance":136.70794061063168},{"name":"Destroying Angels","hex":"#e9e9e1","rgb":{"r":233,"g":233,"b":225},"luminance":155.62043512983763},{"name":"Detailed Devil","hex":"#ff3355","rgb":{"r":255,"g":51,"b":85},"luminance":82.48284727141758},{"name":"Detective Coat","hex":"#8b8685","rgb":{"r":139,"g":134,"b":133},"luminance":90.24568648417497},{"name":"Detroit","hex":"#bdd0d1","rgb":{"r":189,"g":208,"b":209},"luminance":136.63310218611008},{"name":"Deutzia White","hex":"#f7fcfe","rgb":{"r":247,"g":252,"b":254},"luminance":167.85179570382914},{"name":"Devil Blue","hex":"#277594","rgb":{"r":39,"g":117,"b":148},"luminance":71.67599560522338},{"name":"Devil's Advocate","hex":"#ff3344","rgb":{"r":255,"g":51,"b":68},"luminance":82.27768529801989},{"name":"Devil's Flower Mantis","hex":"#8f9805","rgb":{"r":143,"g":152,"b":5},"luminance":98.94143785593576},{"name":"Devil's Lip","hex":"#662a2c","rgb":{"r":102,"g":42,"b":44},"luminance":39.53616035985284},{"name":"Devil's Plum","hex":"#423450","rgb":{"r":66,"g":52,"b":80},"luminance":37.47425425542181},{"name":"Devil’s Butterfly","hex":"#bb4422","rgb":{"r":187,"g":68,"b":34},"luminance":68.80824079280039},{"name":"Devilish","hex":"#dd3322","rgb":{"r":221,"g":51,"b":34},"luminance":72.64765368544258},{"name":"Devilish Diva","hex":"#ce7790","rgb":{"r":206,"g":119,"b":144},"luminance":94.56610122554487},{"name":"Devlan Mud","hex":"#5a573f","rgb":{"r":90,"g":87,"b":63},"luminance":58.1701984266858},{"name":"Devlan Mud Wash","hex":"#3c3523","rgb":{"r":60,"g":53,"b":35},"luminance":36.13389020019848},{"name":"Devon Rex","hex":"#717e6f","rgb":{"r":113,"g":126,"b":111},"luminance":82.29254236563602},{"name":"Dew","hex":"#e7f2e9","rgb":{"r":231,"g":242,"b":233},"luminance":160.1730486723656},{"name":"Dew Not Disturb","hex":"#cee3dc","rgb":{"r":206,"g":227,"b":220},"luminance":148.92321255264403},{"name":"Dewberry","hex":"#8b5987","rgb":{"r":139,"g":89,"b":135},"luminance":68.50912253123667},{"name":"Dewdrop","hex":"#dde4e3","rgb":{"r":221,"g":228,"b":227},"luminance":151.4865671305545},{"name":"Dewkist","hex":"#c4d1c2","rgb":{"r":196,"g":209,"b":194},"luminance":137.74855629370495},{"name":"Dewmist Delight","hex":"#dceedb","rgb":{"r":220,"g":238,"b":219},"luminance":156.42274768076413},{"name":"Dewpoint","hex":"#b2ced2","rgb":{"r":178,"g":206,"b":210},"luminance":134.26777337842466},{"name":"Dexter","hex":"#6bb1b4","rgb":{"r":107,"g":177,"b":180},"luminance":110.63283712352315},{"name":"Dhalsim's Yoga Flame","hex":"#fae432","rgb":{"r":250,"g":228,"b":50},"luminance":153.40184938911264},{"name":"Dhūsar Grey","hex":"#aaaaaa","rgb":{"r":170,"g":170,"b":170},"luminance":113.65437695047207},{"name":"Di Sierra","hex":"#db995e","rgb":{"r":219,"g":153,"b":94},"luminance":111.66292911257521},{"name":"Diablo Red","hex":"#cd0d01","rgb":{"r":205,"g":13,"b":1},"luminance":61.768294310268914},{"name":"Diamond","hex":"#faf7e2","rgb":{"r":250,"g":247,"b":226},"luminance":165.14586375988955},{"name":"Diamond Blue","hex":"#cfe4ee","rgb":{"r":207,"g":228,"b":238},"luminance":149.92986283259248},{"name":"Diamond Dust","hex":"#f8f5e5","rgb":{"r":248,"g":245,"b":229},"luminance":163.8987387535365},{"name":"Diamonds In The Sky","hex":"#e5e2e1","rgb":{"r":229,"g":226,"b":225},"luminance":151.47741278817776},{"name":"Diarrhea","hex":"#9f8303","rgb":{"r":159,"g":131,"b":3},"luminance":90.40692591831667},{"name":"Dickie Bird","hex":"#60b8be","rgb":{"r":96,"g":184,"b":190},"luminance":113.83673958788523},{"name":"Diesel","hex":"#322c2b","rgb":{"r":50,"g":44,"b":43},"luminance":30.242646841835782},{"name":"Diffused Light","hex":"#ebe5d5","rgb":{"r":235,"g":229,"b":213},"luminance":153.61096535729473},{"name":"Diffused Orchid","hex":"#9879a2","rgb":{"r":152,"g":121,"b":162},"luminance":86.32162218702797},{"name":"Digger's Gold","hex":"#a37336","rgb":{"r":163,"g":115,"b":54},"luminance":83.48722375309889},{"name":"Digital Garage","hex":"#b7b3a4","rgb":{"r":183,"g":179,"b":164},"luminance":119.93258870715664},{"name":"Digital Violets","hex":"#aa00ff","rgb":{"r":170,"g":0,"b":255},"luminance":58.5555616487452},{"name":"Digital Yellow","hex":"#ffeb7e","rgb":{"r":255,"g":235,"b":126},"luminance":158.26701344879166},{"name":"Dignified","hex":"#3b695f","rgb":{"r":59,"g":105,"b":95},"luminance":65.0182051890084},{"name":"Diisha Green","hex":"#007044","rgb":{"r":0,"g":112,"b":68},"luminance":66.19944894030463},{"name":"Dijon","hex":"#97754c","rgb":{"r":151,"g":117,"b":76},"luminance":82.64564197826768},{"name":"Dijon Mustard","hex":"#e2ca73","rgb":{"r":226,"g":202,"b":115},"luminance":137.10547418684638},{"name":"Dijonnaise","hex":"#9b8f55","rgb":{"r":155,"g":143,"b":85},"luminance":96.37347459752604},{"name":"Dill","hex":"#6f7755","rgb":{"r":111,"g":119,"b":85},"luminance":77.94130759744796},{"name":"Dill Grass","hex":"#a2a57b","rgb":{"r":162,"g":165,"b":123},"luminance":109.1959127119692},{"name":"Dill Pickle","hex":"#67744a","rgb":{"r":103,"g":116,"b":74},"luminance":75.2073252349796},{"name":"Dill Powder","hex":"#9da073","rgb":{"r":157,"g":160,"b":115},"luminance":105.81343841403131},{"name":"Dilly Blue","hex":"#35495a","rgb":{"r":53,"g":73,"b":90},"luminance":46.82524116328714},{"name":"Dilly Dally","hex":"#f6db5d","rgb":{"r":246,"g":219,"b":93},"luminance":148.48726251433152},{"name":"Diluno Red","hex":"#f46860","rgb":{"r":244,"g":104,"b":96},"luminance":95.75597827812109},{"name":"Diluted Blue","hex":"#b8def2","rgb":{"r":184,"g":222,"b":242},"luminance":144.11660763423484},{"name":"Diluted Green","hex":"#ddeae0","rgb":{"r":221,"g":234,"b":224},"luminance":154.55012682298258},{"name":"Diluted Lilac","hex":"#dadfea","rgb":{"r":218,"g":223,"b":234},"luminance":148.64512740416347},{"name":"Diluted Lime","hex":"#e8efdb","rgb":{"r":232,"g":239,"b":219},"luminance":158.48453056686634},{"name":"Diluted Mint","hex":"#daf4ea","rgb":{"r":218,"g":244,"b":234},"luminance":159.60752514840894},{"name":"Diluted Orange","hex":"#fbe8e2","rgb":{"r":251,"g":232,"b":226},"luminance":157.61414261734257},{"name":"Diluted Pink","hex":"#e9dfe8","rgb":{"r":233,"g":223,"b":232},"luminance":150.6255602280038},{"name":"Diluted Red","hex":"#e8dde2","rgb":{"r":232,"g":221,"b":226},"luminance":149.347908083776},{"name":"Dim","hex":"#c8c2be","rgb":{"r":200,"g":194,"b":190},"luminance":130.43540349153676},{"name":"Dim Grey","hex":"#696969","rgb":{"r":105,"g":105,"b":105},"luminance":70.1982916458798},{"name":"Diminished Blue","hex":"#bce1eb","rgb":{"r":188,"g":225,"b":235},"luminance":146.01814499917467},{"name":"Diminished Brown","hex":"#e7ded7","rgb":{"r":231,"g":222,"b":215},"luminance":149.50921529123212},{"name":"Diminished Green","hex":"#e3e6d6","rgb":{"r":227,"g":230,"b":214},"luminance":153.06733500325927},{"name":"Diminished Lime","hex":"#edf5dd","rgb":{"r":237,"g":245,"b":221},"luminance":162.29311947830692},{"name":"Diminished Mint","hex":"#e9f3dd","rgb":{"r":233,"g":243,"b":221},"luminance":160.73171250876413},{"name":"Diminished Orange","hex":"#fae9e1","rgb":{"r":250,"g":233,"b":225},"luminance":157.96136059492522},{"name":"Diminished Pink","hex":"#f1e5e0","rgb":{"r":241,"g":229,"b":224},"luminance":154.64194032021197},{"name":"Diminished Red","hex":"#e8d8da","rgb":{"r":232,"g":216,"b":218},"luminance":146.64839785009585},{"name":"Diminished Sky","hex":"#d3f2ed","rgb":{"r":211,"g":242,"b":237},"luminance":157.76416944604372},{"name":"Diminishing Green","hex":"#062e03","rgb":{"r":6,"g":46,"b":3},"luminance":27.06369161810709},{"name":"Dingley","hex":"#607c47","rgb":{"r":96,"g":124,"b":71},"luminance":78.66082504016849},{"name":"Dingy Dungeon","hex":"#c53151","rgb":{"r":197,"g":49,"b":81},"luminance":66.197736622939},{"name":"Dingy Sticky Note","hex":"#e6f2a2","rgb":{"r":230,"g":242,"b":162},"luminance":158.90160112472122},{"name":"Dinosaur","hex":"#7f997d","rgb":{"r":127,"g":153,"b":125},"luminance":98.5445429742307},{"name":"Dinosaur Bone","hex":"#827563","rgb":{"r":130,"g":117,"b":99},"luminance":79.71860345615696},{"name":"Dinosaur Egg","hex":"#cabaa9","rgb":{"r":202,"g":186,"b":169},"luminance":126.25294564484425},{"name":"Diorite","hex":"#9dbfb1","rgb":{"r":157,"g":191,"b":177},"luminance":123.21127635894369},{"name":"Diplomatic","hex":"#3a445d","rgb":{"r":58,"g":68,"b":93},"luminance":44.79324082939299},{"name":"Dire Wolf","hex":"#282828","rgb":{"r":40,"g":40,"b":40},"luminance":26.742206341287545},{"name":"Directoire Blue","hex":"#0061a3","rgb":{"r":0,"g":97,"b":163},"luminance":59.8944107993392},{"name":"Diroset","hex":"#5acaa4","rgb":{"r":90,"g":202,"b":164},"luminance":123.01821813048667},{"name":"Dirt","hex":"#9b7653","rgb":{"r":155,"g":118,"b":83},"luminance":83.87590372091378},{"name":"Dirt Brown","hex":"#836539","rgb":{"r":131,"g":101,"b":57},"luminance":71.35392725001196},{"name":"Dirt Track","hex":"#bb6644","rgb":{"r":187,"g":102,"b":68},"luminance":82.28762330387238},{"name":"Dirty Blonde","hex":"#dfc393","rgb":{"r":223,"g":195,"b":147},"luminance":133.52486329519306},{"name":"Dirty Blue","hex":"#3f829d","rgb":{"r":63,"g":130,"b":157},"luminance":80.6125739137512},{"name":"Dirty Brown","hex":"#b5651e","rgb":{"r":181,"g":101,"b":30},"luminance":80.34619424714526},{"name":"Dirty Green","hex":"#667e2c","rgb":{"r":102,"g":126,"b":44},"luminance":80.16025014931029},{"name":"Dirty Leather","hex":"#430005","rgb":{"r":67,"g":0,"b":5},"luminance":20.04110747937848},{"name":"Dirty Orange","hex":"#c87606","rgb":{"r":200,"g":118,"b":6},"luminance":91.51112835060006},{"name":"Dirty Pink","hex":"#ca7b80","rgb":{"r":202,"g":123,"b":128},"luminance":95.25664947393436},{"name":"Dirty Purple","hex":"#734a65","rgb":{"r":115,"g":74,"b":101},"luminance":56.584099047347216},{"name":"Dirty Snow","hex":"#cdced5","rgb":{"r":205,"g":206,"b":213},"luminance":137.7273488926582},{"name":"Dirty White","hex":"#e8e4c9","rgb":{"r":232,"g":228,"b":201},"luminance":152.4763775671497},{"name":"Dirty Yellow","hex":"#cdc50a","rgb":{"r":205,"g":197,"b":10},"luminance":130.88450995438689},{"name":"Disappearing Island","hex":"#bbdee5","rgb":{"r":187,"g":222,"b":229},"luminance":144.18573230732645},{"name":"Disappearing Memories","hex":"#eae3e0","rgb":{"r":234,"g":227,"b":224},"luminance":152.65197166430573},{"name":"Disappearing Purple","hex":"#3f313a","rgb":{"r":63,"g":49,"b":58},"luminance":35.01230186662968},{"name":"Disarm","hex":"#006e9d","rgb":{"r":0,"g":110,"b":157},"luminance":67.00465136093165},{"name":"Disc Jockey","hex":"#47c6ac","rgb":{"r":71,"g":198,"b":172},"luminance":119.76488292066252},{"name":"Disco","hex":"#892d4f","rgb":{"r":137,"g":45,"b":79},"luminance":49.56639617724896},{"name":"Discover","hex":"#bdb0a0","rgb":{"r":189,"g":176,"b":160},"luminance":119.161906937578},{"name":"Discover Deco","hex":"#4a934e","rgb":{"r":74,"g":147,"b":78},"luminance":89.52328781384205},{"name":"Discovery Bay","hex":"#276878","rgb":{"r":39,"g":104,"b":120},"luminance":63.63945022546942},{"name":"Discreet Orange","hex":"#ffad98","rgb":{"r":255,"g":173,"b":152},"luminance":128.16460201631335},{"name":"Discreet Romance","hex":"#f5e5e1","rgb":{"r":245,"g":229,"b":225},"luminance":155.22164943718386},{"name":"Discrete Pink","hex":"#ebdbdd","rgb":{"r":235,"g":219,"b":221},"luminance":148.65322623475078},{"name":"Discretion","hex":"#9f6f62","rgb":{"r":159,"g":111,"b":98},"luminance":81.42723692966622},{"name":"Disembark","hex":"#5bb4d7","rgb":{"r":91,"g":180,"b":215},"luminance":111.82622850208264},{"name":"Disguise","hex":"#b7b698","rgb":{"r":183,"g":182,"b":152},"luminance":121.27536117860048},{"name":"Dissolved Denim","hex":"#e2ecf2","rgb":{"r":226,"g":236,"b":242},"luminance":156.5837100211896},{"name":"Distant Cloud","hex":"#e5eae6","rgb":{"r":229,"g":234,"b":230},"luminance":155.70159409909715},{"name":"Distant Flare","hex":"#ead1da","rgb":{"r":234,"g":209,"b":218},"luminance":143.40146982858997},{"name":"Distant Haze","hex":"#dfe4da","rgb":{"r":223,"g":228,"b":218},"luminance":151.5767763511284},{"name":"Distant Horizon","hex":"#f1f8fa","rgb":{"r":241,"g":248,"b":250},"luminance":164.9154973221134},{"name":"Distant Landscape","hex":"#e1efdd","rgb":{"r":225,"g":239,"b":221},"luminance":157.61595449065425},{"name":"Distant Searchlight","hex":"#f2f3ce","rgb":{"r":242,"g":243,"b":206},"luminance":161.65900315478873},{"name":"Distant Sky","hex":"#6f8daf","rgb":{"r":111,"g":141,"b":175},"luminance":91.37772436431102},{"name":"Distant Thunder","hex":"#7f8688","rgb":{"r":127,"g":134,"b":136},"luminance":88.70965961494835},{"name":"Distant Valley","hex":"#c2b79a","rgb":{"r":194,"g":183,"b":154},"luminance":123.3376682648087},{"name":"Distilled Moss","hex":"#ccffcc","rgb":{"r":204,"g":255,"b":204},"luminance":163.30019221360396},{"name":"Distilled Rose","hex":"#ffbbff","rgb":{"r":255,"g":187,"b":255},"luminance":136.7757225753167},{"name":"Distilled Venom","hex":"#c7fdb5","rgb":{"r":199,"g":253,"b":181},"luminance":161.31226883904395},{"name":"Distilled Watermelon","hex":"#ede3e0","rgb":{"r":237,"g":227,"b":224},"luminance":153.06517587616068},{"name":"Distinct Purple","hex":"#a294c9","rgb":{"r":162,"g":148,"b":201},"luminance":102.07218336060025},{"name":"Dithered Amber","hex":"#feb308","rgb":{"r":254,"g":179,"b":8},"luminance":129.64938098193912},{"name":"Dithered Sky","hex":"#bcdfff","rgb":{"r":188,"g":223,"b":255},"luminance":145.3957552509701},{"name":"Diva","hex":"#c9a0ff","rgb":{"r":201,"g":160,"b":255},"luminance":115.22986201935676},{"name":"Diva Blue","hex":"#007bb2","rgb":{"r":0,"g":123,"b":178},"luminance":74.99833108143139},{"name":"Diva Girl","hex":"#e1cbda","rgb":{"r":225,"g":203,"b":218},"luminance":139.07872393001023},{"name":"Diva Rouge","hex":"#e8b9a5","rgb":{"r":232,"g":185,"b":165},"luminance":130.22522623900485},{"name":"Dive In","hex":"#3c4d85","rgb":{"r":60,"g":77,"b":133},"luminance":50.93799608347388},{"name":"Diver Lady","hex":"#27546e","rgb":{"r":39,"g":84,"b":110},"luminance":52.19683309358911},{"name":"Diver's Eden","hex":"#3a797e","rgb":{"r":58,"g":121,"b":126},"luminance":74.5111011125188},{"name":"Diversion","hex":"#a99a89","rgb":{"r":169,"g":154,"b":137},"luminance":104.73348217738203},{"name":"Divine","hex":"#9a7aa0","rgb":{"r":154,"g":122,"b":160},"luminance":87.07179056387895},{"name":"Divine Dove","hex":"#eeddee","rgb":{"r":238,"g":221,"b":238},"luminance":150.43028351033578},{"name":"Divine Purple","hex":"#69005f","rgb":{"r":105,"g":0,"b":95},"luminance":33.21046408889825},{"name":"Dixie","hex":"#cd8431","rgb":{"r":205,"g":132,"b":49},"luminance":98.9547910765315},{"name":"Dizzy Days","hex":"#d14e2f","rgb":{"r":209,"g":78,"b":47},"luminance":77.65430471648045},{"name":"Do Not Disturb","hex":"#99a456","rgb":{"r":153,"g":164,"b":86},"luminance":107.03473384373878},{"name":"Dobunezumi Brown","hex":"#4b3c39","rgb":{"r":75,"g":60,"b":57},"luminance":42.255804678174094},{"name":"Dockside","hex":"#95aed0","rgb":{"r":149,"g":174,"b":208},"luminance":113.92638671089327},{"name":"Doctor","hex":"#f9f9f9","rgb":{"r":249,"g":249,"b":249},"luminance":166.47023447451497},{"name":"Dodger Blue","hex":"#3e82fc","rgb":{"r":62,"g":130,"b":252},"luminance":83.61920549730188},{"name":"DodgeRoll Gold","hex":"#f79a12","rgb":{"r":247,"g":154,"b":18},"luminance":116.74876751811986},{"name":"Dodie Yellow","hex":"#fef65b","rgb":{"r":254,"g":246,"b":91},"luminance":163.4850219316742},{"name":"Doe","hex":"#b98e68","rgb":{"r":185,"g":142,"b":104},"luminance":100.73829101687204},{"name":"Doeskin","hex":"#fff2e4","rgb":{"r":255,"g":242,"b":228},"luminance":163.30408140949814},{"name":"Dogwood","hex":"#faeae2","rgb":{"r":250,"g":234,"b":226},"luminance":158.48837925854374},{"name":"Dogwood Bloom","hex":"#c58f94","rgb":{"r":197,"g":143,"b":148},"luminance":103.92458455052875},{"name":"Dogwood Rose","hex":"#d71868","rgb":{"r":215,"g":24,"b":104},"luminance":66.87000601914134},{"name":"Doll House","hex":"#facfc1","rgb":{"r":250,"g":207,"b":193},"luminance":144.34710798973424},{"name":"Dollar","hex":"#7d8774","rgb":{"r":125,"g":135,"b":116},"luminance":88.60888683422222},{"name":"Dollar Bill","hex":"#85bb65","rgb":{"r":133,"g":187,"b":101},"luminance":117.3167500657941},{"name":"Dolly","hex":"#f5f171","rgb":{"r":245,"g":241,"b":113},"luminance":159.8285113426262},{"name":"Dolomite Crystal","hex":"#fee8f5","rgb":{"r":254,"g":232,"b":245},"luminance":158.41073723709513},{"name":"Dolphin","hex":"#86c4da","rgb":{"r":134,"g":196,"b":218},"luminance":124.33772140424642},{"name":"Dolphin Daze","hex":"#659fb5","rgb":{"r":101,"g":159,"b":181},"luminance":100.24365539025399},{"name":"Dolphin Grey","hex":"#828e74","rgb":{"r":130,"g":142,"b":116},"luminance":92.91738476732974},{"name":"Dolphin Tales","hex":"#c7c7c2","rgb":{"r":199,"g":199,"b":194},"luminance":132.94646827200788},{"name":"Domain","hex":"#9c9c6e","rgb":{"r":156,"g":156,"b":110},"luminance":103.52944276871192},{"name":"Domino","hex":"#6c5b4c","rgb":{"r":108,"g":91,"b":76},"luminance":63.01756936759779},{"name":"Don Juan","hex":"#5a4f51","rgb":{"r":90,"g":79,"b":81},"luminance":54.40468716020707},{"name":"Döner Kebab","hex":"#bb7766","rgb":{"r":187,"g":119,"b":102},"luminance":90.22702234918317},{"name":"Donkey Brown","hex":"#816e5c","rgb":{"r":129,"g":110,"b":92},"luminance":75.94079987068874},{"name":"Donkey Kong","hex":"#ab4210","rgb":{"r":171,"g":66,"b":16},"luminance":64.17510561736536},{"name":"Donnegal","hex":"#8caea3","rgb":{"r":140,"g":174,"b":163},"luminance":111.93623795715129},{"name":"Doodle","hex":"#fbdca8","rgb":{"r":251,"g":220,"b":168},"luminance":150.58649044652046},{"name":"Doombull Brown","hex":"#7c1e08","rgb":{"r":124,"g":30,"b":8},"luminance":41.055737966817745},{"name":"Dorado","hex":"#6e5f56","rgb":{"r":110,"g":95,"b":86},"luminance":65.47981170559365},{"name":"Doric White","hex":"#d5cfbd","rgb":{"r":213,"g":207,"b":189},"luminance":138.86936727010746},{"name":"Dormitory","hex":"#5d71a9","rgb":{"r":93,"g":113,"b":169},"luminance":74.45944913844045},{"name":"Dorn Yellow","hex":"#fff200","rgb":{"r":255,"g":242,"b":0},"luminance":161.22232767517033},{"name":"Dotted Dove","hex":"#6c6868","rgb":{"r":108,"g":104,"b":104},"luminance":70.07279289424676},{"name":"Dòu Lǜ Green","hex":"#009276","rgb":{"r":0,"g":146,"b":118},"luminance":86.75130608815063},{"name":"Dòu Shā Sè Red","hex":"#a52939","rgb":{"r":165,"g":41,"b":57},"luminance":55.27555262500774},{"name":"Double Colonial White","hex":"#e4cf99","rgb":{"r":228,"g":207,"b":153},"luminance":140.4139666450599},{"name":"Double Cream","hex":"#f3e0ac","rgb":{"r":243,"g":224,"b":172},"luminance":151.5011797214794},{"name":"Double Dragon Skin","hex":"#fca044","rgb":{"r":252,"g":160,"b":68},"luminance":120.65811621271068},{"name":"Double Duty","hex":"#686858","rgb":{"r":104,"g":104,"b":88},"luminance":69.24204318187036},{"name":"Double Jeopardy","hex":"#4d786c","rgb":{"r":77,"g":120,"b":108},"luminance":75.12281592831835},{"name":"Double Pearl Lusta","hex":"#e9dcbe","rgb":{"r":233,"g":220,"b":190},"luminance":148.3232486463265},{"name":"Double Spanish White","hex":"#d2c3a3","rgb":{"r":210,"g":195,"b":163},"luminance":131.87157028336318},{"name":"Douro","hex":"#555500","rgb":{"r":85,"g":85,"b":0},"luminance":55.994939503494415},{"name":"Dove","hex":"#b3ada7","rgb":{"r":179,"g":173,"b":167},"luminance":116.3595655113923},{"name":"Dove Feather","hex":"#755d5b","rgb":{"r":117,"g":93,"b":91},"luminance":65.662831541139},{"name":"Dove Grey","hex":"#6d6c6c","rgb":{"r":109,"g":108,"b":108},"luminance":72.33817416136516},{"name":"Dove's Wing","hex":"#f4f2ea","rgb":{"r":244,"g":242,"b":234},"luminance":161.90591659355752},{"name":"Dover Grey","hex":"#848585","rgb":{"r":132,"g":133,"b":133},"luminance":88.78451615569011},{"name":"Dover Plains","hex":"#ccaf92","rgb":{"r":204,"g":175,"b":146},"luminance":120.62321657541717},{"name":"Dover Straits","hex":"#326ab1","rgb":{"r":50,"g":106,"b":177},"luminance":67.09866964403989},{"name":"Down Dog","hex":"#baafb9","rgb":{"r":186,"g":175,"b":185},"luminance":118.7018564345141},{"name":"Down Feathers","hex":"#fff9e7","rgb":{"r":255,"g":249,"b":231},"luminance":166.9443085283233},{"name":"Downing to Earth","hex":"#635a4f","rgb":{"r":99,"g":90,"b":79},"luminance":61.223656677790814},{"name":"Download Progress","hex":"#58d332","rgb":{"r":88,"g":211,"b":50},"luminance":126.74923192272212},{"name":"Downpour","hex":"#898a86","rgb":{"r":137,"g":138,"b":134},"luminance":92.05050559882874},{"name":"Downriver","hex":"#092256","rgb":{"r":9,"g":34,"b":86},"luminance":22.39825129334877},{"name":"Downtown Benny Brown","hex":"#7d6a58","rgb":{"r":125,"g":106,"b":88},"luminance":73.27420373501167},{"name":"Downwell","hex":"#001100","rgb":{"r":0,"g":17,"b":0},"luminance":9.979},{"name":"Downy","hex":"#6fd2be","rgb":{"r":111,"g":210,"b":190},"luminance":129.48420066170235},{"name":"Dr Who","hex":"#78587d","rgb":{"r":120,"g":88,"b":125},"luminance":64.48859772083743},{"name":"Dr. White","hex":"#fafafa","rgb":{"r":250,"g":250,"b":250},"luminance":167.13878963304717},{"name":"Drab","hex":"#828344","rgb":{"r":130,"g":131,"b":68},"luminance":86.51080286877472},{"name":"Drab Green","hex":"#749551","rgb":{"r":116,"g":149,"b":81},"luminance":94.54111793817545},{"name":"Dracula Orchid","hex":"#2c3539","rgb":{"r":44,"g":53,"b":57},"luminance":34.397654876459235},{"name":"Dragon Ball","hex":"#ff9922","rgb":{"r":255,"g":153,"b":34},"luminance":117.8742513104537},{"name":"Dragon Bay","hex":"#5da99f","rgb":{"r":93,"g":169,"b":159},"luminance":104.60887311313509},{"name":"Dragon Fire","hex":"#fc642d","rgb":{"r":252,"g":100,"b":45},"luminance":95.65211970468819},{"name":"Dragon Red","hex":"#9e0200","rgb":{"r":158,"g":2,"b":0},"luminance":47.256585149585234},{"name":"Dragon Scale","hex":"#00a877","rgb":{"r":0,"g":168,"b":119},"luminance":99.54472267277659},{"name":"Dragon's Blood","hex":"#b84048","rgb":{"r":184,"g":64,"b":72},"luminance":67.12291817255863},{"name":"Dragon's Fire","hex":"#9c2d5d","rgb":{"r":156,"g":45,"b":93},"luminance":54.64263321802857},{"name":"Dragonfly","hex":"#314a76","rgb":{"r":49,"g":74,"b":118},"luminance":47.775181307871556},{"name":"Dragonfly Blue","hex":"#45abca","rgb":{"r":69,"g":171,"b":202},"luminance":105.03080059677733},{"name":"Dragonlord Purple","hex":"#6241c7","rgb":{"r":98,"g":65,"b":199},"luminance":53.188963375873385},{"name":"Drake Tooth","hex":"#bbb0a4","rgb":{"r":187,"g":176,"b":164},"luminance":118.95029772556266},{"name":"Drake’s Neck","hex":"#31668a","rgb":{"r":49,"g":102,"b":138},"luminance":63.61637761614536},{"name":"Drakenhof Nightshade","hex":"#1f5da0","rgb":{"r":31,"g":93,"b":160},"luminance":58.299135859804984},{"name":"Drama Queen","hex":"#a37298","rgb":{"r":163,"g":114,"b":152},"luminance":84.57880039939086},{"name":"Dramatical Red","hex":"#991100","rgb":{"r":153,"g":17,"b":0},"luminance":46.82273432852892},{"name":"Draw Your Sword","hex":"#6c7179","rgb":{"r":108,"g":113,"b":121},"luminance":75.0523101643114},{"name":"Dream Blue","hex":"#d7e6ee","rgb":{"r":215,"g":230,"b":238},"luminance":151.9750201480493},{"name":"Dream Dust","hex":"#ebe2e8","rgb":{"r":235,"g":226,"b":232},"luminance":152.4331760903774},{"name":"Dreamcatcher","hex":"#a5b2a9","rgb":{"r":165,"g":178,"b":169},"luminance":117.1428409122811},{"name":"Dreamland","hex":"#b5b1bf","rgb":{"r":181,"g":177,"b":191},"luminance":119.15525770187398},{"name":"Dreamless Sleep","hex":"#111111","rgb":{"r":17,"g":17,"b":17},"luminance":11.365437695047207},{"name":"Dreams of Peach","hex":"#ffd29d","rgb":{"r":255,"g":210,"b":157},"luminance":146.04496338114504},{"name":"Dreamsicle","hex":"#f5d5c2","rgb":{"r":245,"g":213,"b":194},"luminance":146.58841510160343},{"name":"Dreamweaver","hex":"#ccc6d7","rgb":{"r":204,"g":198,"b":215},"luminance":133.5280314840296},{"name":"Drenched Rain","hex":"#c1d1e2","rgb":{"r":193,"g":209,"b":226},"luminance":138.00362326402882},{"name":"Dresden Blue","hex":"#0086bb","rgb":{"r":0,"g":134,"b":187},"luminance":81.49563232468351},{"name":"Dresden Doll","hex":"#8ca8c6","rgb":{"r":140,"g":168,"b":198},"luminance":109.48456621825744},{"name":"Dresden Dream","hex":"#8ea7b9","rgb":{"r":142,"g":167,"b":185},"luminance":108.89056297494287},{"name":"Dress Blues","hex":"#2a3244","rgb":{"r":42,"g":50,"b":68},"luminance":32.85147436569628},{"name":"Dress Up","hex":"#fac7bf","rgb":{"r":250,"g":199,"b":191},"luminance":140.38143233704378},{"name":"Dreyfus","hex":"#b2aba1","rgb":{"r":178,"g":171,"b":161},"luminance":115.08689208159198},{"name":"Dried Blood","hex":"#4b0101","rgb":{"r":75,"g":1,"b":1},"luminance":22.4329710470994},{"name":"Dried Chive","hex":"#7b7d69","rgb":{"r":123,"g":125,"b":105},"luminance":82.9440730492541},{"name":"Dried Goldenrod","hex":"#e2a829","rgb":{"r":226,"g":168,"b":41},"luminance":119.63781679719837},{"name":"Dried Grass","hex":"#aca08d","rgb":{"r":172,"g":160,"b":141},"luminance":108.27824832347446},{"name":"Dried Herb","hex":"#847a59","rgb":{"r":132,"g":122,"b":89},"luminance":82.3967798885369},{"name":"Dried Lavender Flowers","hex":"#77747f","rgb":{"r":119,"g":116,"b":127},"luminance":78.1801797708345},{"name":"Dried Lilac","hex":"#bbbbff","rgb":{"r":187,"g":187,"b":255},"luminance":126.57235808026964},{"name":"Dried Magenta","hex":"#ff40ff","rgb":{"r":255,"g":64,"b":255},"luminance":89.83161775789189},{"name":"Dried Moss","hex":"#ccb97e","rgb":{"r":204,"g":185,"b":126},"luminance":125.3782697958462},{"name":"Dried Mustard","hex":"#804a00","rgb":{"r":128,"g":74,"b":0},"luminance":57.89305509299021},{"name":"Dried Pipe Clay","hex":"#d8d6cc","rgb":{"r":216,"g":214,"b":204},"luminance":143.14962981440084},{"name":"Dried Plum","hex":"#683332","rgb":{"r":104,"g":51,"b":50},"luminance":43.53935214263069},{"name":"Dried Tobacco","hex":"#997b38","rgb":{"r":153,"g":123,"b":56},"luminance":85.71188870862663},{"name":"Dried Tomatoes","hex":"#ab6057","rgb":{"r":171,"g":96,"b":87},"luminance":76.73388605433716},{"name":"Drift on the Sea","hex":"#87cefa","rgb":{"r":135,"g":206,"b":250},"luminance":130.6281489917085},{"name":"Drifting","hex":"#beb4a8","rgb":{"r":190,"g":180,"b":168},"luminance":121.48337665705542},{"name":"Drifting Downstream","hex":"#61736f","rgb":{"r":97,"g":115,"b":111},"luminance":74.55348918729425},{"name":"Driftwood","hex":"#a67a45","rgb":{"r":166,"g":122,"b":69},"luminance":87.48698707807921},{"name":"Dripping Ice","hex":"#d2dfed","rgb":{"r":210,"g":223,"b":237},"luminance":147.67406077236447},{"name":"Drippy Honey","hex":"#eebb22","rgb":{"r":238,"g":187,"b":34},"luminance":130.87508158927733},{"name":"Drisheen","hex":"#a24857","rgb":{"r":162,"g":72,"b":87},"luminance":65.04500183718962},{"name":"Drive-In Cherry","hex":"#a62e30","rgb":{"r":166,"g":46,"b":48},"luminance":56.767814331714405},{"name":"Drizzle","hex":"#a0af9d","rgb":{"r":160,"g":175,"b":157},"luminance":114.72327413824972},{"name":"Droëwors","hex":"#523839","rgb":{"r":82,"g":56,"b":57},"luminance":41.520172350316656},{"name":"Dromedary","hex":"#e3c295","rgb":{"r":227,"g":194,"b":149},"luminance":133.65428241923263},{"name":"Drop of Lemon","hex":"#fcf1bd","rgb":{"r":252,"g":241,"b":189},"luminance":161.72341608128363},{"name":"Droplet","hex":"#afc3bc","rgb":{"r":175,"g":195,"b":188},"luminance":127.66938738006068},{"name":"Drops of Honey","hex":"#d4ae76","rgb":{"r":212,"g":174,"b":118},"luminance":120.95935636402831},{"name":"Drought","hex":"#d5d1cc","rgb":{"r":213,"g":209,"b":204},"luminance":140.17130231969736},{"name":"Drover","hex":"#fbeb9b","rgb":{"r":251,"g":235,"b":155},"luminance":158.02975772303137},{"name":"Druchii Violet","hex":"#842994","rgb":{"r":132,"g":41,"b":148},"luminance":49.209835368552085},{"name":"Druid Green","hex":"#427131","rgb":{"r":66,"g":113,"b":49},"luminance":69.42935771703495},{"name":"Drunk-Tank Pink","hex":"#dd11dd","rgb":{"r":221,"g":17,"b":221},"luminance":71.4195513707556},{"name":"Drunken Dragonfly","hex":"#33dd88","rgb":{"r":51,"g":221,"b":136},"luminance":131.53706909460922},{"name":"Drunken Flamingo","hex":"#ff55cc","rgb":{"r":255,"g":85,"b":204},"luminance":94.04069643510728},{"name":"Dry Bone","hex":"#eadfce","rgb":{"r":234,"g":223,"b":206},"luminance":150.2724566013346},{"name":"Dry Catmint","hex":"#b9bdae","rgb":{"r":185,"g":189,"b":174},"luminance":125.5450730614308},{"name":"Dry Creek","hex":"#d8c7b6","rgb":{"r":216,"g":199,"b":182},"luminance":135.0808999414795},{"name":"Dry Dock","hex":"#817665","rgb":{"r":129,"g":118,"b":101},"luminance":80.11287657424366},{"name":"Dry Dune","hex":"#efdfcf","rgb":{"r":239,"g":223,"b":207},"luminance":150.99209226313806},{"name":"Dry Grass","hex":"#9ea26b","rgb":{"r":158,"g":162,"b":107},"luminance":106.88061846752197},{"name":"Dry Hemlock","hex":"#909373","rgb":{"r":144,"g":147,"b":115},"luminance":97.32154312894961},{"name":"Dry Highlighter Green","hex":"#2ba727","rgb":{"r":43,"g":167,"b":39},"luminance":98.9684505587513},{"name":"Dry Lichen","hex":"#c7d9cc","rgb":{"r":199,"g":217,"b":204},"luminance":142.50129886425597},{"name":"Dry Moss","hex":"#769958","rgb":{"r":118,"g":153,"b":88},"luminance":97.01276343347817},{"name":"Dry Mud","hex":"#777672","rgb":{"r":119,"g":118,"b":114},"luminance":78.94733898618748},{"name":"Dry Peach","hex":"#de7e5d","rgb":{"r":222,"g":126,"b":93},"luminance":99.94407802366281},{"name":"Dry Riverbed","hex":"#d2c5ae","rgb":{"r":210,"g":197,"b":174},"luminance":133.07302249892726},{"name":"Dry Rose","hex":"#c22f4d","rgb":{"r":194,"g":47,"b":77},"luminance":64.82979439270187},{"name":"Dry Sand","hex":"#eae4d6","rgb":{"r":234,"g":228,"b":214},"luminance":152.97869416359913},{"name":"Dry Season","hex":"#d4cecd","rgb":{"r":212,"g":206,"b":205},"luminance":138.5147123160569},{"name":"Dry Seedlings","hex":"#c7dc68","rgb":{"r":199,"g":220,"b":104},"luminance":142.68172040243977},{"name":"Dry Starfish","hex":"#b09a77","rgb":{"r":176,"g":154,"b":119},"luminance":105.47568504636507},{"name":"Dryad Bark","hex":"#33312d","rgb":{"r":51,"g":49,"b":45},"luminance":32.95692749635499},{"name":"Drying Grass Green","hex":"#7bb369","rgb":{"r":123,"g":179,"b":105},"luminance":111.96501220470616},{"name":"Dubarry","hex":"#f25f66","rgb":{"r":242,"g":95,"b":102},"luminance":92.09031313335838},{"name":"Dubbin","hex":"#ae8b64","rgb":{"r":174,"g":139,"b":100},"luminance":97.43758168694458},{"name":"Dublin Jack","hex":"#6fab92","rgb":{"r":111,"g":171,"b":146},"luminance":107.02371039166975},{"name":"Ducal","hex":"#763d35","rgb":{"r":118,"g":61,"b":53},"luminance":50.630687700247556},{"name":"Ducal Pink","hex":"#ce9096","rgb":{"r":206,"g":144,"b":150},"luminance":105.97742033093652},{"name":"Ducati","hex":"#16a0a6","rgb":{"r":22,"g":160,"b":166},"luminance":96.03308940151825},{"name":"Duck Butter","hex":"#ddc75b","rgb":{"r":221,"g":199,"b":91},"luminance":134.60806471382014},{"name":"Duck Egg Blue","hex":"#c3fbf4","rgb":{"r":195,"g":251,"b":244},"luminance":160.87695437818306},{"name":"Duck Egg Cream","hex":"#c8e3d2","rgb":{"r":200,"g":227,"b":210},"luminance":148.00155269793623},{"name":"Duck Green","hex":"#53665c","rgb":{"r":83,"g":102,"b":92},"luminance":65.65651155064515},{"name":"Duck Hunt Green","hex":"#005800","rgb":{"r":0,"g":88,"b":0},"luminance":51.656},{"name":"Duck Sauce","hex":"#cc9922","rgb":{"r":204,"g":153,"b":34},"luminance":108.63494425367925},{"name":"Duck Tail","hex":"#e9d6b1","rgb":{"r":233,"g":214,"b":177},"luminance":145.05352287000824},{"name":"Duck Willow","hex":"#6a695a","rgb":{"r":106,"g":105,"b":90},"luminance":70.06176176060661},{"name":"Duck's Egg Blue","hex":"#ccdfe8","rgb":{"r":204,"g":223,"b":232},"luminance":146.81648586245345},{"name":"Duckie Yellow","hex":"#ffff11","rgb":{"r":255,"g":255,"b":17},"luminance":167.99599725588703},{"name":"Duckling","hex":"#fcb057","rgb":{"r":252,"g":176,"b":87},"luminance":128.25387780492252},{"name":"Duct Tape Grey","hex":"#aeacac","rgb":{"r":174,"g":172,"b":172},"luminance":115.26017367677353},{"name":"Duffel Bag","hex":"#394034","rgb":{"r":57,"g":64,"b":52},"luminance":41.67684797342525},{"name":"Dugong","hex":"#71706e","rgb":{"r":113,"g":112,"b":110},"luminance":74.97390549384498},{"name":"Duke Blue","hex":"#00009c","rgb":{"r":0,"g":0,"b":156},"luminance":17.784},{"name":"Dulcet","hex":"#9ad4d8","rgb":{"r":154,"g":212,"b":216},"luminance":134.95512079206182},{"name":"Dulcet Violet","hex":"#59394c","rgb":{"r":89,"g":57,"b":76},"luminance":43.62012033454287},{"name":"Dull","hex":"#727171","rgb":{"r":114,"g":113,"b":113},"luminance":75.6809281193089},{"name":"Dull Blue","hex":"#49759c","rgb":{"r":73,"g":117,"b":156},"luminance":74.22596328778765},{"name":"Dull Brown","hex":"#876e4b","rgb":{"r":135,"g":110,"b":75},"luminance":76.6271533139526},{"name":"Dull Desert","hex":"#dcd6d3","rgb":{"r":220,"g":214,"b":211},"luminance":143.82449457585452},{"name":"Dull Gold","hex":"#8a6f48","rgb":{"r":138,"g":111,"b":72},"luminance":77.55874262131897},{"name":"Dull Green","hex":"#74a662","rgb":{"r":116,"g":166,"b":98},"luminance":104.03238343900422},{"name":"Dull Lavender","hex":"#a899e6","rgb":{"r":168,"g":153,"b":230},"luminance":106.19208042504864},{"name":"Dull Orange","hex":"#d8863b","rgb":{"r":216,"g":134,"b":59},"luminance":101.9971229790331},{"name":"Dull Pink","hex":"#d5869d","rgb":{"r":213,"g":134,"b":157},"luminance":102.77866187589717},{"name":"Dull Purple","hex":"#84597e","rgb":{"r":132,"g":89,"b":126},"luminance":67.03266792393093},{"name":"Dull Red","hex":"#bb3f3f","rgb":{"r":187,"g":63,"b":63},"luminance":67.41987135852456},{"name":"Dull Sage","hex":"#dbd4ab","rgb":{"r":219,"g":212,"b":171},"luminance":141.96508913461787},{"name":"Dull Teal","hex":"#5f9e8f","rgb":{"r":95,"g":158,"b":143},"luminance":98.35862821837237},{"name":"Dull Violet","hex":"#803790","rgb":{"r":128,"g":55,"b":144},"luminance":52.69300015182282},{"name":"Dull Yellow","hex":"#eedc5b","rgb":{"r":238,"g":220,"b":91},"luminance":147.81336110108583},{"name":"Dun Morogh Blue","hex":"#80b4dc","rgb":{"r":128,"g":180,"b":220},"luminance":115.14246820352601},{"name":"Dune","hex":"#514f4a","rgb":{"r":81,"g":79,"b":74},"luminance":52.99227477661248},{"name":"Dune Shadow","hex":"#867665","rgb":{"r":134,"g":118,"b":101},"luminance":80.84327620773418},{"name":"Dunes Manor","hex":"#d5c0a1","rgb":{"r":213,"g":192,"b":161},"luminance":130.7482118462811},{"name":"Dungeon Keeper","hex":"#ef3038","rgb":{"r":239,"g":48,"b":56},"luminance":77.07993871948783},{"name":"Dunnock's Egg","hex":"#d9ece6","rgb":{"r":217,"g":236,"b":230},"luminance":155.20440429639874},{"name":"Duomo","hex":"#6e6064","rgb":{"r":110,"g":96,"b":100},"luminance":66.23639485962381},{"name":"Dupain","hex":"#58a0bc","rgb":{"r":88,"g":160,"b":188},"luminance":99.86299799224935},{"name":"Duqqa Brown","hex":"#442211","rgb":{"r":68,"g":34,"b":17},"luminance":28.556397391827982},{"name":"Durango Dust","hex":"#fbe3a1","rgb":{"r":251,"g":227,"b":161},"luminance":154.02765244591635},{"name":"Durban Sky","hex":"#5d8a9b","rgb":{"r":93,"g":138,"b":155},"luminance":87.44958653418551},{"name":"Durian","hex":"#b07939","rgb":{"r":176,"g":121,"b":57},"luminance":88.63602038110692},{"name":"Durian Smell","hex":"#e5e0db","rgb":{"r":229,"g":224,"b":219},"luminance":150.33520260072157},{"name":"Durian White","hex":"#e6d0ab","rgb":{"r":230,"g":208,"b":171},"luminance":141.48060698201715},{"name":"Durian Yellow","hex":"#e1bd27","rgb":{"r":225,"g":189,"b":39},"luminance":129.82311731737147},{"name":"Durotar Fire","hex":"#f06126","rgb":{"r":240,"g":97,"b":38},"luminance":91.7077616398961},{"name":"Dusk","hex":"#4e5481","rgb":{"r":78,"g":84,"b":129},"luminance":56.493017126013015},{"name":"Dusk Blue","hex":"#7ba0c0","rgb":{"r":123,"g":160,"b":192},"luminance":103.21142704662114},{"name":"Dusk Orange","hex":"#fe4c40","rgb":{"r":254,"g":76,"b":64},"luminance":88.38131632873545},{"name":"Duskwood","hex":"#123d55","rgb":{"r":18,"g":61,"b":85},"luminance":37.48337328736569},{"name":"Dusky","hex":"#c3aba8","rgb":{"r":195,"g":171,"b":168},"luminance":117.65123993396755},{"name":"Dusky Citron","hex":"#e3cc81","rgb":{"r":227,"g":204,"b":129},"luminance":138.4290217728927},{"name":"Dusky Cyclamen","hex":"#7d6d70","rgb":{"r":125,"g":109,"b":112},"luminance":75.19133419483924},{"name":"Dusky Damask","hex":"#b98478","rgb":{"r":185,"g":132,"b":120},"luminance":96.18036120227455},{"name":"Dusky Dawn","hex":"#e5e1de","rgb":{"r":229,"g":225,"b":222},"luminance":150.90585916391714},{"name":"Dusky Flesh","hex":"#774400","rgb":{"r":119,"g":68,"b":0},"luminance":53.47237246466627},{"name":"Dusky Grape","hex":"#877f95","rgb":{"r":135,"g":127,"b":149},"luminance":86.46045814127982},{"name":"Dusky Green","hex":"#746c57","rgb":{"r":116,"g":108,"b":87},"luminance":72.94106796585858},{"name":"Dusky Grouse","hex":"#8e969e","rgb":{"r":142,"g":150,"b":158},"luminance":99.39776862686607},{"name":"Dusky Haze","hex":"#a77572","rgb":{"r":167,"g":117,"b":114},"luminance":85.90113821131825},{"name":"Dusky Lilac","hex":"#d6cbda","rgb":{"r":214,"g":203,"b":218},"luminance":137.51790436521347},{"name":"Dusky Moon","hex":"#edecd7","rgb":{"r":237,"g":236,"b":215},"luminance":157.52275992059052},{"name":"Dusky Orchid","hex":"#9a7182","rgb":{"r":154,"g":113,"b":130},"luminance":82.09548146518175},{"name":"Dusky Pink","hex":"#cc7a8b","rgb":{"r":204,"g":122,"b":139},"luminance":95.3948254781149},{"name":"Dusky Purple","hex":"#895b7b","rgb":{"r":137,"g":91,"b":123},"luminance":68.76016100911923},{"name":"Dusky Rose","hex":"#ba6873","rgb":{"r":186,"g":104,"b":115},"luminance":83.61607142170696},{"name":"Dusky Taupe","hex":"#c9bdb7","rgb":{"r":201,"g":189,"b":183},"luminance":127.8884752196225},{"name":"Dusky Yellow","hex":"#ffff05","rgb":{"r":255,"g":255,"b":5},"luminance":167.98578555937405},{"name":"Dust","hex":"#b2996e","rgb":{"r":178,"g":153,"b":110},"luminance":105.14679550514128},{"name":"Dust Bowl","hex":"#e2d8d3","rgb":{"r":226,"g":216,"b":211},"luminance":145.67447153156243},{"name":"Dust Storm","hex":"#e7d3b7","rgb":{"r":231,"g":211,"b":183},"luminance":143.33982787069334},{"name":"Dust to Dust","hex":"#bbbcbc","rgb":{"r":187,"g":188,"b":188},"luminance":125.55493191826436},{"name":"Dusted Clay","hex":"#cc7357","rgb":{"r":204,"g":115,"b":87},"luminance":91.5194174205671},{"name":"Dusted Peri","hex":"#696ba0","rgb":{"r":105,"g":107,"b":160},"luminance":72.5487016148463},{"name":"Dustwallow Marsh","hex":"#685243","rgb":{"r":104,"g":82,"b":67},"luminance":57.81160969909072},{"name":"Dusty Aqua","hex":"#c0dccd","rgb":{"r":192,"g":220,"b":205},"luminance":143.24445875495496},{"name":"Dusty Blue","hex":"#8c9dad","rgb":{"r":140,"g":157,"b":173},"luminance":103.12370321608897},{"name":"Dusty Cedar","hex":"#dd9592","rgb":{"r":221,"g":149,"b":146},"luminance":110.87485443507919},{"name":"Dusty Coral","hex":"#d29b83","rgb":{"r":210,"g":155,"b":131},"luminance":111.55213436326532},{"name":"Dusty Dream","hex":"#97a2a0","rgb":{"r":151,"g":162,"b":160},"luminance":106.83631703217777},{"name":"Dusty Green","hex":"#76a973","rgb":{"r":118,"g":169,"b":115},"luminance":106.10337804707257},{"name":"Dusty Grey","hex":"#cdccd0","rgb":{"r":205,"g":204,"b":208},"luminance":136.59765544474033},{"name":"Dusty Ivory","hex":"#f1ddbe","rgb":{"r":241,"g":221,"b":190},"luminance":149.9691621967663},{"name":"Dusty Jade Green","hex":"#7bb5a3","rgb":{"r":123,"g":181,"b":163},"luminance":113.95728788454032},{"name":"Dusty Lavender","hex":"#ac86a8","rgb":{"r":172,"g":134,"b":168},"luminance":95.90995387341191},{"name":"Dusty Olive","hex":"#646356","rgb":{"r":100,"g":99,"b":86},"luminance":66.08516614944689},{"name":"Dusty Orange","hex":"#e27a53","rgb":{"r":226,"g":122,"b":83},"luminance":98.91582237438051},{"name":"Dusty Pink","hex":"#d58a94","rgb":{"r":213,"g":138,"b":148},"luminance":104.41585314979713},{"name":"Dusty Plum","hex":"#d7d0e1","rgb":{"r":215,"g":208,"b":225},"luminance":140.34926768957504},{"name":"Dusty Purple","hex":"#825f87","rgb":{"r":130,"g":95,"b":135},"luminance":69.69551079517245},{"name":"Dusty Red","hex":"#b9484e","rgb":{"r":185,"g":72,"b":78},"luminance":70.17879013633677},{"name":"Dusty Rose","hex":"#ba797d","rgb":{"r":186,"g":121,"b":125},"luminance":91.32805825703292},{"name":"Dusty Sand","hex":"#bdbaae","rgb":{"r":189,"g":186,"b":174},"luminance":124.52979218243318},{"name":"Dusty Sky","hex":"#95a3a6","rgb":{"r":149,"g":163,"b":166},"luminance":107.22762301757882},{"name":"Dusty Teal","hex":"#4c9085","rgb":{"r":76,"g":144,"b":133},"luminance":88.83270345993078},{"name":"Dusty Trail","hex":"#c9bba3","rgb":{"r":201,"g":187,"b":163},"luminance":126.51645697694825},{"name":"Dusty Trail Rider","hex":"#c3b9a6","rgb":{"r":195,"g":185,"b":166},"luminance":124.70150290192977},{"name":"Dusty Turquoise","hex":"#649b9e","rgb":{"r":100,"g":155,"b":158},"luminance":97.4510767975398},{"name":"Dusty Warrior","hex":"#bab7b3","rgb":{"r":186,"g":183,"b":179},"luminance":122.67270712346735},{"name":"Dusty Yellow","hex":"#d4cc9a","rgb":{"r":212,"g":204,"b":154},"luminance":136.62296726392674},{"name":"Dutch Blue","hex":"#4a638d","rgb":{"r":74,"g":99,"b":141},"luminance":64.22658422335724},{"name":"Dutch Jug","hex":"#a5abb6","rgb":{"r":165,"g":171,"b":182},"luminance":113.753961944189},{"name":"Dutch Orange","hex":"#dfa837","rgb":{"r":223,"g":168,"b":55},"luminance":119.20675603756693},{"name":"Dutch White","hex":"#f0dfbb","rgb":{"r":240,"g":223,"b":187},"luminance":150.79465018693466},{"name":"Duvall","hex":"#0f8b8e","rgb":{"r":15,"g":139,"b":142},"luminance":83.30416687057135},{"name":"Dwarf Fortress","hex":"#1d0200","rgb":{"r":29,"g":2,"b":0},"luminance":8.750115256383769},{"name":"Dwarf Pony","hex":"#af7b57","rgb":{"r":175,"g":123,"b":87},"luminance":89.71765015870622},{"name":"Dwarf Rabbit","hex":"#c8ac89","rgb":{"r":200,"g":172,"b":137},"luminance":118.37943748810432},{"name":"Dwarf Spruce","hex":"#71847d","rgb":{"r":113,"g":132,"b":125},"luminance":85.72277483259626},{"name":"Dwarven Bronze","hex":"#bf652e","rgb":{"r":191,"g":101,"b":46},"luminance":82.48567018579651},{"name":"Dwarven Flesh","hex":"#ffa07a","rgb":{"r":255,"g":160,"b":122},"luminance":121.76903912325167},{"name":"Dwindling Damon","hex":"#efdfe7","rgb":{"r":239,"g":223,"b":231},"luminance":151.44380435659951},{"name":"Dwindling Dandelion","hex":"#f9e9d7","rgb":{"r":249,"g":233,"b":215},"luminance":157.63882117676468},{"name":"Dwindling Denim","hex":"#cce1ee","rgb":{"r":204,"g":225,"b":238},"luminance":147.98805041286272},{"name":"Dying Light","hex":"#364141","rgb":{"r":54,"g":65,"b":65},"luminance":42.088067679569235},{"name":"Dying Moss","hex":"#669c7d","rgb":{"r":102,"g":156,"b":125},"luminance":97.56342392515751},{"name":"Dynamic","hex":"#6d5160","rgb":{"r":109,"g":81,"b":96},"luminance":58.674198980471814},{"name":"Dynamic Green","hex":"#a7e142","rgb":{"r":167,"g":225,"b":66},"luminance":141.3991537810605},{"name":"Dynamite Red","hex":"#dd3311","rgb":{"r":221,"g":51,"b":17},"luminance":72.57006307011176},{"name":"Dynasty Green","hex":"#008e80","rgb":{"r":0,"g":142,"b":128},"luminance":84.62160350643327},{"name":"E. Honda Beige","hex":"#f8d77f","rgb":{"r":248,"g":215,"b":127},"luminance":147.09124247554644},{"name":"Eagle","hex":"#b0ac94","rgb":{"r":176,"g":172,"b":148},"luminance":115.09856235418407},{"name":"Eagle Eye","hex":"#736665","rgb":{"r":115,"g":102,"b":101},"luminance":69.99854496344906},{"name":"Eagle's Meadow","hex":"#8d7d68","rgb":{"r":141,"g":125,"b":104},"luminance":85.45078491155012},{"name":"Eagle's View","hex":"#d4cbcc","rgb":{"r":212,"g":203,"b":204},"luminance":136.9606658898824},{"name":"Eagles Nest","hex":"#8a693f","rgb":{"r":138,"g":105,"b":63},"luminance":74.51850101149378},{"name":"Eames for Blue","hex":"#466b82","rgb":{"r":70,"g":107,"b":130},"luminance":67.84296412303932},{"name":"Earhart Emerald","hex":"#416659","rgb":{"r":65,"g":102,"b":89},"luminance":63.76171591950768},{"name":"Earl Grey","hex":"#a6978a","rgb":{"r":166,"g":151,"b":138},"luminance":102.79857756311613},{"name":"Earls Green","hex":"#b8a722","rgb":{"r":184,"g":167,"b":34},"luminance":112.47874676133263},{"name":"Early Blossom","hex":"#ffe5ed","rgb":{"r":255,"g":229,"b":237},"luminance":156.88471970845345},{"name":"Early Dawn","hex":"#797287","rgb":{"r":121,"g":114,"b":135},"luminance":77.61308436726374},{"name":"Early Dog Violet","hex":"#d3d6e9","rgb":{"r":211,"g":214,"b":233},"luminance":143.0581828802533},{"name":"Early Evening","hex":"#cac7bf","rgb":{"r":202,"g":199,"b":191},"luminance":133.29404506203568},{"name":"Early Forget-Me-Not","hex":"#bae5ee","rgb":{"r":186,"g":229,"b":238},"luminance":147.9817737054128},{"name":"Early Frost","hex":"#dae3e9","rgb":{"r":218,"g":227,"b":233},"luminance":150.69681140953182},{"name":"Early Harvest","hex":"#b9be82","rgb":{"r":185,"g":190,"b":130},"luminance":125.37273437633877},{"name":"Early July","hex":"#a5ddea","rgb":{"r":165,"g":221,"b":234},"luminance":141.33168692830353},{"name":"Early June","hex":"#b1d2df","rgb":{"r":177,"g":210,"b":223},"luminance":136.53796143563883},{"name":"Early Snow","hex":"#fdf3e4","rgb":{"r":253,"g":243,"b":228},"luminance":163.5374805786123},{"name":"Early Spring","hex":"#96bc4a","rgb":{"r":150,"g":188,"b":74},"luminance":119.41999552838712},{"name":"Early Spring Night","hex":"#3c3fb1","rgb":{"r":60,"g":63,"b":177},"luminance":45.7885318065561},{"name":"Earth","hex":"#a2653e","rgb":{"r":162,"g":101,"b":62},"luminance":76.88396996123444},{"name":"Earth Brown","hex":"#4f1507","rgb":{"r":79,"g":21,"b":7},"luminance":26.656019470281002},{"name":"Earth Chi","hex":"#c7af88","rgb":{"r":199,"g":175,"b":136},"luminance":119.7212121639269},{"name":"Earth Crust","hex":"#8c4f42","rgb":{"r":140,"g":79,"b":66},"luminance":62.923169858169096},{"name":"Earth Eclipse","hex":"#71bab4","rgb":{"r":113,"g":186,"b":180},"luminance":116.11778887405666},{"name":"Earth Red","hex":"#95424e","rgb":{"r":149,"g":66,"b":78},"luminance":59.70596141927537},{"name":"Earth Rose","hex":"#b57770","rgb":{"r":181,"g":119,"b":112},"luminance":89.28230280408319},{"name":"Earth Warming","hex":"#bf9f91","rgb":{"r":191,"g":159,"b":145},"luminance":110.6604160031942},{"name":"Earth Yellow","hex":"#e1a95f","rgb":{"r":225,"g":169,"b":95},"luminance":120.35135950208455},{"name":"Earthbound","hex":"#a48a80","rgb":{"r":164,"g":138,"b":128},"luminance":95.80933042245938},{"name":"Earthly Delight","hex":"#ab8a68","rgb":{"r":171,"g":138,"b":104},"luminance":96.52311336151566},{"name":"Earthly Pleasures","hex":"#9f8863","rgb":{"r":159,"g":136,"b":99},"luminance":93.59844390266325},{"name":"Earthtone","hex":"#5d3a1a","rgb":{"r":93,"g":58,"b":26},"luminance":44.058423269563335},{"name":"Earthy Cane","hex":"#c5b28b","rgb":{"r":197,"g":178,"b":139},"luminance":120.9875337421174},{"name":"Earthy Khaki Green","hex":"#666600","rgb":{"r":102,"g":102,"b":0},"luminance":67.1939274041933},{"name":"Earthy Ocher","hex":"#b89e78","rgb":{"r":184,"g":158,"b":120},"luminance":108.7001525849895},{"name":"Eased Pink","hex":"#fae3e3","rgb":{"r":250,"g":227,"b":227},"luminance":154.95976698807985},{"name":"Easily Suede","hex":"#b29d8a","rgb":{"r":178,"g":157,"b":138},"luminance":107.57954447291547},{"name":"East Bay","hex":"#47526e","rgb":{"r":71,"g":82,"b":110},"luminance":54.081457053226664},{"name":"East Cape","hex":"#b0eee2","rgb":{"r":176,"g":238,"b":226},"luminance":151.49533163764485},{"name":"East Side","hex":"#aa8cbc","rgb":{"r":170,"g":140,"b":188},"luminance":98.97763345322012},{"name":"Easter Egg","hex":"#919bc9","rgb":{"r":145,"g":155,"b":201},"luminance":103.35849092358112},{"name":"Easter Green","hex":"#8cfd7e","rgb":{"r":140,"g":253,"b":126},"luminance":154.9648386473525},{"name":"Easter Purple","hex":"#c071fe","rgb":{"r":192,"g":113,"b":254},"luminance":92.37927235586997},{"name":"Easter Rabbit","hex":"#c7bfc3","rgb":{"r":199,"g":191,"b":195},"luminance":128.85947225563203},{"name":"Eastern Blue","hex":"#00879f","rgb":{"r":0,"g":135,"b":159},"luminance":81.29158567158103},{"name":"Eastern Gold","hex":"#b89b6c","rgb":{"r":184,"g":155,"b":108},"luminance":107.03558205101703},{"name":"Eastern Sky","hex":"#8fc1d2","rgb":{"r":143,"g":193,"b":210},"luminance":123.43474117929685},{"name":"Eastern Wolf","hex":"#dbd7d2","rgb":{"r":219,"g":215,"b":210},"luminance":144.18247808246323},{"name":"Eastlake Lavender","hex":"#887d79","rgb":{"r":136,"g":125,"b":121},"luminance":85.01603352897617},{"name":"Eastlake Olive","hex":"#a9a482","rgb":{"r":169,"g":164,"b":130},"luminance":109.72940437731356},{"name":"Easy","hex":"#beb394","rgb":{"r":190,"g":179,"b":148},"luminance":120.63322847789492},{"name":"Easy Breezy Blue","hex":"#9eb1ae","rgb":{"r":158,"g":177,"b":174},"luminance":115.84591344108776},{"name":"Easy Green","hex":"#9fb289","rgb":{"r":159,"g":178,"b":137},"luminance":115.85073500414228},{"name":"Easy On The Eyes","hex":"#f9ecb6","rgb":{"r":249,"g":236,"b":182},"luminance":158.63336953176022},{"name":"Eat Your Greens","hex":"#696845","rgb":{"r":105,"g":104,"b":69},"luminance":69.09687608712856},{"name":"Eat Your Peas","hex":"#80987a","rgb":{"r":128,"g":152,"b":122},"luminance":98.07701373920393},{"name":"Eaton Gold","hex":"#bb9f60","rgb":{"r":187,"g":159,"b":96},"luminance":109.34845035024502},{"name":"Eaves","hex":"#cecdad","rgb":{"r":206,"g":205,"b":173},"luminance":136.6136535819169},{"name":"Ebb","hex":"#e6d8d4","rgb":{"r":230,"g":216,"b":212},"luminance":146.25189362192887},{"name":"Ebbing Tide","hex":"#688d8a","rgb":{"r":104,"g":141,"b":138},"luminance":89.80441709069771},{"name":"Ebi Brown","hex":"#773c30","rgb":{"r":119,"g":60,"b":48},"luminance":50.362672139194515},{"name":"Ebicha Brown","hex":"#5e2824","rgb":{"r":94,"g":40,"b":36},"luminance":36.852414466354844},{"name":"Ebizome Purple","hex":"#6d2b50","rgb":{"r":109,"g":43,"b":80},"luminance":42.21913975911873},{"name":"Ebony","hex":"#313337","rgb":{"r":49,"g":51,"b":55},"luminance":33.91443158892685},{"name":"Ebony Clay","hex":"#323438","rgb":{"r":50,"g":52,"b":56},"luminance":34.58283580043719},{"name":"Ebony Lips","hex":"#b06a40","rgb":{"r":176,"g":106,"b":64},"luminance":81.81744481466039},{"name":"Ebony Wood","hex":"#2c3227","rgb":{"r":44,"g":50,"b":39},"luminance":32.46952035371019},{"name":"Eburnean","hex":"#ffffee","rgb":{"r":255,"g":255,"b":238},"luminance":170.1618190840707},{"name":"Eccentricity","hex":"#968a9f","rgb":{"r":150,"g":138,"b":159},"luminance":94.35065665908213},{"name":"Echinoderm","hex":"#ffa565","rgb":{"r":255,"g":165,"b":101},"luminance":123.80130551007932},{"name":"Echinoida Torns","hex":"#ffa756","rgb":{"r":255,"g":167,"b":86},"luminance":124.57569298221863},{"name":"Echo","hex":"#d7e7e0","rgb":{"r":215,"g":231,"b":224},"luminance":152.2208754737667},{"name":"Echo Blue","hex":"#a4afcd","rgb":{"r":164,"g":175,"b":205},"luminance":116.20289076008393},{"name":"Echo Isles Water","hex":"#95b5db","rgb":{"r":149,"g":181,"b":219},"luminance":117.88349233883427},{"name":"Echo One","hex":"#629da6","rgb":{"r":98,"g":157,"b":166},"luminance":98.5393640176351},{"name":"Echoes of Love","hex":"#eededd","rgb":{"r":238,"g":222,"b":221},"luminance":150.60048630731575},{"name":"Eclectic","hex":"#aaafbd","rgb":{"r":170,"g":175,"b":189},"luminance":116.62051552364188},{"name":"Eclectic Plum","hex":"#8c6e67","rgb":{"r":140,"g":110,"b":103},"luminance":77.84227041909811},{"name":"Eclipse","hex":"#3f3939","rgb":{"r":63,"g":57,"b":57},"luminance":38.94305142127411},{"name":"Eclipse Blue","hex":"#456074","rgb":{"r":69,"g":96,"b":116},"luminance":61.44965615038053},{"name":"Ecological","hex":"#677f70","rgb":{"r":103,"g":127,"b":112},"luminance":81.6641318695056},{"name":"Ecru","hex":"#c2b280","rgb":{"r":194,"g":178,"b":128},"luminance":120.39496125669046},{"name":"Ecru Olive","hex":"#927b3c","rgb":{"r":146,"g":123,"b":60},"luminance":84.64893216692103},{"name":"Ecru Wealth","hex":"#d5cdb4","rgb":{"r":213,"g":205,"b":180},"luminance":137.68666091528257},{"name":"Ecru White","hex":"#d6d1c0","rgb":{"r":214,"g":209,"b":192},"luminance":140.08715583164647},{"name":"Ecstasy","hex":"#c96138","rgb":{"r":201,"g":97,"b":56},"luminance":83.03430000909262},{"name":"Ecstatic Red","hex":"#aa1122","rgb":{"r":170,"g":17,"b":34},"luminance":51.94509329089707},{"name":"Ecuadorian Banana","hex":"#ffff7e","rgb":{"r":255,"g":255,"b":126},"luminance":168.59781655169797},{"name":"Edamame","hex":"#9ca389","rgb":{"r":156,"g":163,"b":137},"luminance":107.5845640461493},{"name":"Edelweiss","hex":"#eee8d9","rgb":{"r":238,"g":232,"b":217},"luminance":155.63444587879638},{"name":"Eden","hex":"#266255","rgb":{"r":38,"g":98,"b":85},"luminance":59.4325821414483},{"name":"Eden Prairie","hex":"#95863c","rgb":{"r":149,"g":134,"b":60},"luminance":90.65681532571061},{"name":"Edge of Black","hex":"#54585e","rgb":{"r":84,"g":88,"b":94},"luminance":58.429345777614174},{"name":"Edge of Space","hex":"#330044","rgb":{"r":51,"g":0,"b":68},"luminance":17.106300155205975},{"name":"Edge of the Galaxy","hex":"#303d3c","rgb":{"r":48,"g":61,"b":60},"luminance":39.17788602004962},{"name":"Edgewater","hex":"#c1d8c5","rgb":{"r":193,"g":216,"b":197},"luminance":141.10517664848444},{"name":"Edocha","hex":"#a13d2d","rgb":{"r":161,"g":61,"b":45},"luminance":60.2147944445549},{"name":"Edward","hex":"#5e7e7d","rgb":{"r":94,"g":126,"b":125},"luminance":80.39519376181637},{"name":"Eerie Black","hex":"#1b1b1b","rgb":{"r":27,"g":27,"b":27},"luminance":18.050989280369095},{"name":"Effervescent Lime","hex":"#98da2c","rgb":{"r":152,"g":218,"b":44},"luminance":135.88958060131026},{"name":"EGA Green","hex":"#01ff07","rgb":{"r":1,"g":255,"b":7},"luminance":149.68742575781042},{"name":"Egg Liqueur","hex":"#dccaa8","rgb":{"r":220,"g":202,"b":168},"luminance":136.94378766486633},{"name":"Egg Sour","hex":"#f9e4c5","rgb":{"r":249,"g":228,"b":197},"luminance":154.78820388194958},{"name":"Egg Wash","hex":"#e2e1c8","rgb":{"r":226,"g":225,"b":200},"luminance":150.09960393352142},{"name":"Egg White","hex":"#ffefc1","rgb":{"r":255,"g":239,"b":193},"luminance":161.18161768018086},{"name":"Egg Yolk Yellow","hex":"#ffce81","rgb":{"r":255,"g":206,"b":129},"luminance":143.70698154578295},{"name":"Eggnog","hex":"#fdea9f","rgb":{"r":253,"g":234,"b":159},"luminance":157.8551255075362},{"name":"Eggplant","hex":"#430541","rgb":{"r":67,"g":5,"b":65},"luminance":21.560227596201294},{"name":"Eggplant Ash","hex":"#656579","rgb":{"r":101,"g":101,"b":121},"luminance":67.94999930831493},{"name":"Eggplant Tint","hex":"#531b93","rgb":{"r":83,"g":27,"b":147},"luminance":33.88074459040119},{"name":"Eggshell","hex":"#f0ead6","rgb":{"r":240,"g":234,"b":214},"luminance":156.88174712183698},{"name":"Eggshell Blue","hex":"#a3ccc9","rgb":{"r":163,"g":204,"b":201},"luminance":131.300914197122},{"name":"Eggshell Paper","hex":"#e2be9f","rgb":{"r":226,"g":190,"b":159},"luminance":131.65765550092405},{"name":"Egret","hex":"#f3ece0","rgb":{"r":243,"g":236,"b":224},"luminance":158.4999746656131},{"name":"Egyptian Blue","hex":"#1034a6","rgb":{"r":16,"g":52,"b":166},"luminance":36.23146433695442},{"name":"Egyptian Enamel","hex":"#005c69","rgb":{"r":0,"g":92,"b":105},"luminance":55.31467179691117},{"name":"Egyptian Gold","hex":"#efa84c","rgb":{"r":239,"g":168,"b":76},"luminance":122.09363158248672},{"name":"Egyptian Jasper","hex":"#7a4b3a","rgb":{"r":122,"g":75,"b":58},"luminance":57.55487514537756},{"name":"Egyptian Red","hex":"#983f4a","rgb":{"r":152,"g":63,"b":74},"luminance":59.19696918761973},{"name":"Egyptian Sand","hex":"#beac90","rgb":{"r":190,"g":172,"b":144},"luminance":117.00679660600917},{"name":"Egyptian Teal","hex":"#008c8d","rgb":{"r":0,"g":140,"b":141},"luminance":83.73724306424232},{"name":"Egyptian Violet","hex":"#3d496d","rgb":{"r":61,"g":73,"b":109},"luminance":48.200360973752055},{"name":"Eiffel Tower","hex":"#998e83","rgb":{"r":153,"g":142,"b":131},"luminance":96.24812559733307},{"name":"Eigengrau","hex":"#16161d","rgb":{"r":22,"g":22,"b":29},"luminance":14.865097241525195},{"name":"Eiger Nordwand","hex":"#7799bb","rgb":{"r":119,"g":153,"b":187},"luminance":98.9266415380609},{"name":"El Capitan","hex":"#b7a696","rgb":{"r":183,"g":166,"b":150},"luminance":113.05442695003146},{"name":"El Niño","hex":"#d0cacd","rgb":{"r":208,"g":202,"b":205},"luminance":135.91834033713036},{"name":"El Paso","hex":"#39392c","rgb":{"r":57,"g":57,"b":44},"luminance":37.88309366986809},{"name":"El Salva","hex":"#8f4e45","rgb":{"r":143,"g":78,"b":69},"luminance":63.137887207286234},{"name":"Elastic Pink","hex":"#eca6ca","rgb":{"r":236,"g":166,"b":202},"luminance":122.49289874927443},{"name":"Eldar Flesh","hex":"#ecc083","rgb":{"r":236,"g":192,"b":131},"luminance":133.8076756692231},{"name":"Elder Creek","hex":"#afa892","rgb":{"r":175,"g":168,"b":146},"luminance":112.871802577083},{"name":"Elderberry","hex":"#2e2249","rgb":{"r":46,"g":34,"b":73},"luminance":25.627133355098458},{"name":"Electra","hex":"#55b492","rgb":{"r":85,"g":180,"b":146},"luminance":109.9408048042218},{"name":"Electric Blue","hex":"#7df9ff","rgb":{"r":125,"g":249,"b":255},"luminance":153.64106903429172},{"name":"Electric Brown","hex":"#b56257","rgb":{"r":181,"g":98,"b":87},"luminance":79.60196957990424},{"name":"Electric Crimson","hex":"#ff003f","rgb":{"r":255,"g":0,"b":63},"luminance":76.58251203114193},{"name":"Electric Cyan","hex":"#0ff0fc","rgb":{"r":15,"g":240,"b":252},"luminance":143.84918355347034},{"name":"Electric Eel","hex":"#88bbee","rgb":{"r":136,"g":187,"b":238},"luminance":120.16213913292323},{"name":"Electric Energy","hex":"#c9e423","rgb":{"r":201,"g":228,"b":35},"luminance":146.7647259970869},{"name":"Electric Flamingo","hex":"#fc74fd","rgb":{"r":252,"g":116,"b":253},"luminance":105.57320934782649},{"name":"Electric Glow","hex":"#ffd100","rgb":{"r":255,"g":209,"b":0},"luminance":144.4452093840429},{"name":"Electric Green","hex":"#21fc0d","rgb":{"r":33,"g":252,"b":13},"luminance":148.26012204568022},{"name":"Electric Indigo","hex":"#6600ff","rgb":{"r":102,"g":0,"b":255},"luminance":42.13303815297444},{"name":"Electric Lavender","hex":"#f4bfff","rgb":{"r":244,"g":191,"b":255},"luminance":136.88631971457193},{"name":"Electric Lime","hex":"#ccff00","rgb":{"r":204,"g":255,"b":0},"luminance":161.63573627450089},{"name":"Electric Orange","hex":"#ff3503","rgb":{"r":255,"g":53,"b":3},"luminance":82.34871771922134},{"name":"Electric Pink","hex":"#ff0490","rgb":{"r":255,"g":4,"b":144},"luminance":78.02754760339452},{"name":"Electric Purple","hex":"#bf00ff","rgb":{"r":191,"g":0,"b":255},"luminance":64.08200044474266},{"name":"Electric Red","hex":"#e60000","rgb":{"r":230,"g":0,"b":0},"luminance":68.77},{"name":"Electric Sheep","hex":"#55ffff","rgb":{"r":85,"g":255,"b":255},"luminance":154.58520741002354},{"name":"Electric Slide","hex":"#9db0b9","rgb":{"r":157,"g":176,"b":185},"luminance":115.42011390134736},{"name":"Electric Ultramarine","hex":"#3f00ff","rgb":{"r":63,"g":0,"b":255},"luminance":34.63953621225319},{"name":"Electric Violet","hex":"#8f00f1","rgb":{"r":143,"g":0,"b":241},"luminance":50.82304324811728},{"name":"Electric Yellow","hex":"#fffc00","rgb":{"r":255,"g":252,"b":0},"luminance":166.4175765987475},{"name":"Electromagnetic","hex":"#2e3840","rgb":{"r":46,"g":56,"b":64},"luminance":36.372689149965254},{"name":"Electron Blue","hex":"#0881d1","rgb":{"r":8,"g":129,"b":209},"luminance":79.41896920131865},{"name":"Electronic","hex":"#556d88","rgb":{"r":85,"g":109,"b":136},"luminance":70.56996903782797},{"name":"Electrum","hex":"#e7c697","rgb":{"r":231,"g":198,"b":151},"luminance":136.29134834243882},{"name":"Elegant Ice","hex":"#c4b9b7","rgb":{"r":196,"g":185,"b":183},"luminance":125.15001352377074},{"name":"Elegant Ivory","hex":"#f1e6d6","rgb":{"r":241,"g":230,"b":214},"luminance":154.9689142925122},{"name":"Elemental","hex":"#d0d3d3","rgb":{"r":208,"g":211,"b":211},"luminance":140.6662583173378},{"name":"Elemental Green","hex":"#969783","rgb":{"r":150,"g":151,"b":131},"luminance":100.45429122242614},{"name":"Elephant","hex":"#243640","rgb":{"r":36,"g":54,"b":64},"luminance":34.261618700814466},{"name":"Elephant Grey","hex":"#95918c","rgb":{"r":149,"g":145,"b":140},"luminance":97.38622297840696},{"name":"Elephant in the Room","hex":"#a8a9a8","rgb":{"r":168,"g":169,"b":168},"luminance":112.83300996162426},{"name":"Elephant Skin","hex":"#8f8982","rgb":{"r":143,"g":137,"b":130},"luminance":92.27680645752756},{"name":"Elf Flesh","hex":"#f7c380","rgb":{"r":247,"g":195,"b":128},"luminance":137.0015631224695},{"name":"Elf Green","hex":"#1b8a6b","rgb":{"r":27,"g":138,"b":107},"luminance":82.31607722067422},{"name":"Elf Shoe","hex":"#68b082","rgb":{"r":104,"g":176,"b":130},"luminance":108.90345706174804},{"name":"Elf Skintone","hex":"#f7c985","rgb":{"r":247,"g":201,"b":133},"luminance":140.01815604413594},{"name":"Elf Slippers","hex":"#a6a865","rgb":{"r":166,"g":168,"b":101},"luminance":111.00099822974566},{"name":"Elfin Games","hex":"#9dd196","rgb":{"r":157,"g":209,"b":150},"luminance":132.4657455269097},{"name":"Elfin Herb","hex":"#cab4d4","rgb":{"r":202,"g":180,"b":212},"luminance":124.08080523594292},{"name":"Elfin Magic","hex":"#eddbe9","rgb":{"r":237,"g":219,"b":233},"luminance":149.17432226090386},{"name":"Elfin Yellow","hex":"#eeea97","rgb":{"r":238,"g":234,"b":151},"luminance":155.65208705314555},{"name":"Elite Pink","hex":"#bb8da8","rgb":{"r":187,"g":141,"b":168},"luminance":101.70269889240893},{"name":"Elizabeth Blue","hex":"#a1b8d2","rgb":{"r":161,"g":184,"b":210},"luminance":120.64914000936766},{"name":"Ellen","hex":"#e2c8b7","rgb":{"r":226,"g":200,"b":183},"luminance":137.055567271089},{"name":"Ellis Mist","hex":"#778070","rgb":{"r":119,"g":128,"b":112},"luminance":84.1097371354827},{"name":"Elm","hex":"#297b76","rgb":{"r":41,"g":123,"b":118},"luminance":74.45954462659572},{"name":"Elm Green","hex":"#547053","rgb":{"r":84,"g":112,"b":83},"luminance":71.01138243971877},{"name":"Elmer's Echo","hex":"#264066","rgb":{"r":38,"g":64,"b":102},"luminance":40.934826883718465},{"name":"Elmwood","hex":"#8c7c61","rgb":{"r":140,"g":124,"b":97},"luminance":84.69139217181402},{"name":"Elusion","hex":"#d2cfcc","rgb":{"r":210,"g":207,"b":204},"luminance":138.73666680802157},{"name":"Elusive","hex":"#fed7cf","rgb":{"r":254,"g":215,"b":207},"luminance":149.17225796038616},{"name":"Elusive Blue","hex":"#dde4e8","rgb":{"r":221,"g":228,"b":232},"luminance":151.584978942506},{"name":"Elusive Dream","hex":"#cdbfc6","rgb":{"r":205,"g":191,"b":198},"luminance":129.75667188241226},{"name":"Elusive Mauve","hex":"#dec4d2","rgb":{"r":222,"g":196,"b":210},"luminance":134.96712632341254},{"name":"Elusive Violet","hex":"#d4c0c5","rgb":{"r":212,"g":192,"b":197},"luminance":131.24249282911384},{"name":"Elven Flesh","hex":"#f7cf8a","rgb":{"r":247,"g":207,"b":138},"luminance":143.0601220256714},{"name":"Elwynn Forest Olive","hex":"#7a8716","rgb":{"r":122,"g":135,"b":22},"luminance":87.27373358004114},{"name":"Elysia Chlorotica","hex":"#9aae07","rgb":{"r":154,"g":174,"b":7},"luminance":112.0403586391975},{"name":"Elysian Green","hex":"#a5b145","rgb":{"r":165,"g":177,"b":69},"luminance":115.2858117115892},{"name":"Elysium Gold","hex":"#ce9500","rgb":{"r":206,"g":149,"b":0},"luminance":106.97475031520288},{"name":"Emanation","hex":"#b4a3bb","rgb":{"r":180,"g":163,"b":187},"luminance":111.82979605185731},{"name":"Embarrassed Frog","hex":"#996611","rgb":{"r":153,"g":102,"b":17},"luminance":75.37532573063946},{"name":"Embarrassment","hex":"#ff7777","rgb":{"r":255,"g":119,"b":119},"luminance":104.29179253421623},{"name":"Embellishment","hex":"#cbdee2","rgb":{"r":203,"g":222,"b":226},"luminance":146.0467325926876},{"name":"Emberglow","hex":"#ea6759","rgb":{"r":234,"g":103,"b":89},"luminance":93.02534597086968},{"name":"Embracing","hex":"#246453","rgb":{"r":36,"g":100,"b":83},"luminance":60.424193333465354},{"name":"Embroidered Silk","hex":"#b8dca7","rgb":{"r":184,"g":220,"b":167},"luminance":141.65572808750093},{"name":"Emerald","hex":"#028f1e","rgb":{"r":2,"g":143,"b":30},"luminance":84.01276977341003},{"name":"Emerald City","hex":"#6a7e5f","rgb":{"r":106,"g":126,"b":95},"luminance":81.1922162525448},{"name":"Emerald Dream","hex":"#007a5e","rgb":{"r":0,"g":122,"b":94},"luminance":72.41130886815952},{"name":"Emerald Forest","hex":"#224347","rgb":{"r":34,"g":67,"b":71},"luminance":41.420171812777404},{"name":"Emerald Green","hex":"#046307","rgb":{"r":4,"g":99,"b":7},"luminance":58.13078348861299},{"name":"Emerald Pool","hex":"#155e60","rgb":{"r":21,"g":94,"b":96},"luminance":56.602196609318966},{"name":"Emerald Reflection","hex":"#50c878","rgb":{"r":80,"g":200,"b":120},"luminance":120.59050045505242},{"name":"Emerald Ring","hex":"#578758","rgb":{"r":87,"g":135,"b":88},"luminance":84.00647128644316},{"name":"Emerald Spring","hex":"#095155","rgb":{"r":9,"g":81,"b":85},"luminance":48.59891758053877},{"name":"Emerald Starling","hex":"#11bb11","rgb":{"r":17,"g":187,"b":17},"luminance":109.90371283082295},{"name":"Emerald Stone","hex":"#016360","rgb":{"r":1,"g":99,"b":96},"luminance":59.13527970678756},{"name":"Emerald Succulent","hex":"#55aaaa","rgb":{"r":85,"g":170,"b":170},"luminance":104.78335137320241},{"name":"Emerald Wave","hex":"#4fb3a9","rgb":{"r":79,"g":179,"b":169},"luminance":109.40505347560503},{"name":"Emerald-Crested Manakin","hex":"#5c6b8f","rgb":{"r":92,"g":107,"b":143},"luminance":70.47989606263619},{"name":"Emerging Leaf","hex":"#e1e1cf","rgb":{"r":225,"g":225,"b":207},"luminance":150.08862999574617},{"name":"Emerson","hex":"#3e6058","rgb":{"r":62,"g":96,"b":88},"luminance":60.16515912054085},{"name":"Emilie's Dream","hex":"#eccee5","rgb":{"r":236,"g":206,"b":229},"luminance":142.41815690423746},{"name":"Emily Ann Tan","hex":"#d5c7b6","rgb":{"r":213,"g":199,"b":182},"luminance":134.65433688522623},{"name":"Eminence","hex":"#6e3974","rgb":{"r":110,"g":57,"b":116},"luminance":48.745573717005314},{"name":"Emoji Yellow","hex":"#ffde34","rgb":{"r":255,"g":222,"b":52},"luminance":151.0965909774274},{"name":"Emotive Ring","hex":"#856d70","rgb":{"r":133,"g":109,"b":112},"luminance":76.4085100103385},{"name":"Emperador","hex":"#684832","rgb":{"r":104,"g":72,"b":50},"luminance":52.77970170434842},{"name":"Emperor","hex":"#50494a","rgb":{"r":80,"g":73,"b":74},"luminance":49.79498666532606},{"name":"Emperor Jade","hex":"#007b75","rgb":{"r":0,"g":123,"b":117},"luminance":73.42265757244148},{"name":"Emperor Jewel","hex":"#715a8d","rgb":{"r":113,"g":90,"b":141},"luminance":64.73749875458581},{"name":"Emperor's Children","hex":"#f0a0b6","rgb":{"r":240,"g":160,"b":182},"luminance":120.00393120227352},{"name":"Emperor's Gold","hex":"#b0976d","rgb":{"r":176,"g":151,"b":109},"luminance":103.82778347340368},{"name":"Emperor's Robe","hex":"#99959d","rgb":{"r":153,"g":149,"b":157},"luminance":100.31402086448334},{"name":"Emperors Children","hex":"#b94278","rgb":{"r":185,"g":66,"b":120},"luminance":68.90452952455303},{"name":"Empire Ranch","hex":"#93826a","rgb":{"r":147,"g":130,"b":106},"luminance":88.88816211959836},{"name":"Empire State Grey","hex":"#d9dbdf","rgb":{"r":217,"g":219,"b":223},"luminance":146.22570082581242},{"name":"Empire Yellow","hex":"#f7d000","rgb":{"r":247,"g":208,"b":0},"luminance":142.69442464581437},{"name":"Empress","hex":"#7c7173","rgb":{"r":124,"g":113,"b":115},"luminance":77.11227812093222},{"name":"Empress Envy","hex":"#2a9ca0","rgb":{"r":42,"g":156,"b":160},"luminance":94.211634886568},{"name":"Empress Teal","hex":"#10605a","rgb":{"r":16,"g":96,"b":90},"luminance":57.47784059966067},{"name":"Emptiness","hex":"#fcfdfc","rgb":{"r":252,"g":253,"b":252},"luminance":168.9915270331622},{"name":"Emu Egg","hex":"#3d8481","rgb":{"r":61,"g":132,"b":129},"luminance":80.94873570970704},{"name":"En Plein Air","hex":"#d0c5be","rgb":{"r":208,"g":197,"b":190},"luminance":133.0765899209925},{"name":"Enamel Blue","hex":"#007a8e","rgb":{"r":0,"g":122,"b":142},"luminance":73.42081680286591},{"name":"Enamelled Dragon","hex":"#54c589","rgb":{"r":84,"g":197,"b":137},"luminance":119.36127387473711},{"name":"Enamelled Jewel","hex":"#045c61","rgb":{"r":4,"g":92,"b":97},"luminance":55.1374808637464},{"name":"Encarnado","hex":"#fd0202","rgb":{"r":253,"g":2,"b":2},"luminance":75.6564529237262},{"name":"Enchanted","hex":"#c9e2cf","rgb":{"r":201,"g":226,"b":207},"luminance":147.53969516370842},{"name":"Enchanted Blue","hex":"#047495","rgb":{"r":4,"g":116,"b":149},"luminance":70.18885293264167},{"name":"Enchanted Eve","hex":"#79837f","rgb":{"r":121,"g":131,"b":127},"luminance":86.20719885253203},{"name":"Enchanted Evening","hex":"#d3e9ec","rgb":{"r":211,"g":233,"b":236},"luminance":153.0044233935738},{"name":"Enchanted Silver","hex":"#b5b5bd","rgb":{"r":181,"g":181,"b":189},"luminance":121.16732763414402},{"name":"Enchanted Wood","hex":"#94895f","rgb":{"r":148,"g":137,"b":95},"luminance":92.42696557282403},{"name":"Enchanting Ivy","hex":"#315955","rgb":{"r":49,"g":89,"b":85},"luminance":55.11695700961728},{"name":"Enchanting Sky","hex":"#7886aa","rgb":{"r":120,"g":134,"b":170},"luminance":88.60045013429672},{"name":"Enchantress","hex":"#5d3a47","rgb":{"r":93,"g":58,"b":71},"luminance":44.69756370318185},{"name":"Encore Teal","hex":"#30525b","rgb":{"r":48,"g":82,"b":91},"luminance":51.28822219574393},{"name":"Encounter","hex":"#ff9552","rgb":{"r":255,"g":149,"b":82},"luminance":116.40644955499673},{"name":"End of Summer","hex":"#cc8f15","rgb":{"r":204,"g":143,"b":21},"luminance":103.7898585267366},{"name":"Endeavour","hex":"#29598b","rgb":{"r":41,"g":89,"b":139},"luminance":55.952746545634376},{"name":"Ending Dawn","hex":"#fcc9b9","rgb":{"r":252,"g":201,"b":185},"luminance":141.57344868653868},{"name":"Ending Navy Blue","hex":"#1c305c","rgb":{"r":28,"g":48,"b":92},"luminance":31.208580614952677},{"name":"Endive","hex":"#cee1c8","rgb":{"r":206,"g":225,"b":200},"luminance":147.50412353897093},{"name":"Endless","hex":"#5b976a","rgb":{"r":91,"g":151,"b":106},"luminance":93.50331815502592},{"name":"Endless Galaxy Blue","hex":"#000044","rgb":{"r":0,"g":0,"b":68},"luminance":7.752000000000001},{"name":"Endless Silk","hex":"#ddddbb","rgb":{"r":221,"g":221,"b":187},"luminance":147.13934176147453},{"name":"Endless Slumber","hex":"#b1aab3","rgb":{"r":177,"g":170,"b":179},"luminance":114.78367856537791},{"name":"Endo","hex":"#5da464","rgb":{"r":93,"g":164,"b":100},"luminance":100.84997309369993},{"name":"Enduring Ice","hex":"#ebe8db","rgb":{"r":235,"g":232,"b":219},"luminance":155.26285208316895},{"name":"Energic Eggplant","hex":"#b300b3","rgb":{"r":179,"g":0,"b":179},"luminance":57.27916093135443},{"name":"Energise","hex":"#7cca6b","rgb":{"r":124,"g":202,"b":107},"luminance":124.83274592830199},{"name":"Energized","hex":"#d2d25a","rgb":{"r":210,"g":210,"b":90},"luminance":138.72038278493898},{"name":"Energos","hex":"#c0e740","rgb":{"r":192,"g":231,"b":64},"luminance":147.42949667213816},{"name":"Energy Orange","hex":"#ff9532","rgb":{"r":255,"g":149,"b":50},"luminance":116.17041961704363},{"name":"Energy Peak","hex":"#bb5f60","rgb":{"r":187,"g":95,"b":96},"luminance":79.72308279287749},{"name":"Energy Yellow","hex":"#f5d752","rgb":{"r":245,"g":215,"b":82},"luminance":146.22374004928201},{"name":"Enfield Brown","hex":"#a73211","rgb":{"r":167,"g":50,"b":17},"luminance":57.95241869844605},{"name":"English Channel Fog","hex":"#cbd3e6","rgb":{"r":203,"g":211,"b":230},"luminance":140.40003795583533},{"name":"English Forest","hex":"#606256","rgb":{"r":96,"g":98,"b":86},"luminance":65.0329048097961},{"name":"English Green","hex":"#1b4d3f","rgb":{"r":27,"g":77,"b":63},"luminance":46.472616173398286},{"name":"English Holly","hex":"#274234","rgb":{"r":39,"g":66,"b":52},"luminance":40.89086290358764},{"name":"English Ivy","hex":"#61845b","rgb":{"r":97,"g":132,"b":91},"luminance":83.38203728022},{"name":"English Lavender","hex":"#9d7bb0","rgb":{"r":157,"g":123,"b":176},"luminance":88.42620508650135},{"name":"English Manor","hex":"#7181a4","rgb":{"r":113,"g":129,"b":164},"luminance":85.00043831651693},{"name":"English Meadow","hex":"#028a52","rgb":{"r":2,"g":138,"b":82},"luminance":81.54578311598951},{"name":"English Red","hex":"#ab4b52","rgb":{"r":171,"g":75,"b":82},"luminance":68.11578649623007},{"name":"English River","hex":"#3c768a","rgb":{"r":60,"g":118,"b":138},"luminance":73.26061820650982},{"name":"English Rose","hex":"#f4c6c3","rgb":{"r":244,"g":198,"b":195},"luminance":139.01522906502007},{"name":"English Rose Bud","hex":"#e9c9cb","rgb":{"r":233,"g":201,"b":203},"luminance":138.9603368663159},{"name":"English Scone","hex":"#e9cfbb","rgb":{"r":233,"g":207,"b":187},"luminance":141.67704504964803},{"name":"English Vermillion","hex":"#cc474b","rgb":{"r":204,"g":71,"b":75},"luminance":74.36791542728623},{"name":"English Violet","hex":"#563d5d","rgb":{"r":86,"g":61,"b":93},"luminance":45.34041738890368},{"name":"English Walnut","hex":"#3e2b23","rgb":{"r":62,"g":43,"b":35},"luminance":31.570328237127978},{"name":"Enhance","hex":"#d2a5be","rgb":{"r":210,"g":165,"b":190},"luminance":117.44203133886947},{"name":"Enigma","hex":"#bdbf35","rgb":{"r":189,"g":191,"b":53},"luminance":125.69892829296516},{"name":"Enjoy","hex":"#ead4c4","rgb":{"r":234,"g":212,"b":196},"luminance":144.50191911528373},{"name":"Enoki","hex":"#f8faee","rgb":{"r":248,"g":250,"b":238},"luminance":166.64401287775087},{"name":"Enokitake Mushroom","hex":"#ffeedd","rgb":{"r":255,"g":238,"b":221},"luminance":161.13908308352757},{"name":"Enough Is Enough","hex":"#898c4a","rgb":{"r":137,"g":140,"b":74},"luminance":92.210009570545},{"name":"Enraged","hex":"#ee0044","rgb":{"r":238,"g":0,"b":68},"luminance":71.58298504533042},{"name":"Enshūcha Red","hex":"#cb6649","rgb":{"r":203,"g":102,"b":73},"luminance":85.66374594307676},{"name":"Ensign Blue","hex":"#384c67","rgb":{"r":56,"g":76,"b":103},"luminance":49.07613110260424},{"name":"Entan Red","hex":"#ec6d51","rgb":{"r":236,"g":109,"b":81},"luminance":95.69936855068585},{"name":"Enterprise","hex":"#65788c","rgb":{"r":101,"g":120,"b":140},"luminance":78.2847034930835},{"name":"Enthusiasm","hex":"#00ffaa","rgb":{"r":0,"g":255,"b":170},"luminance":150.93436860105786},{"name":"Entrapment","hex":"#005961","rgb":{"r":0,"g":89,"b":97},"luminance":53.40047202974895},{"name":"Enviable","hex":"#53983c","rgb":{"r":83,"g":152,"b":60},"luminance":92.8632934210283},{"name":"Envious Pastel","hex":"#ddf3c2","rgb":{"r":221,"g":243,"b":194},"luminance":158.75139866470468},{"name":"Envisage","hex":"#96bfb7","rgb":{"r":150,"g":191,"b":183},"luminance":122.54373600066222},{"name":"Envy","hex":"#8ba58f","rgb":{"r":139,"g":165,"b":143},"luminance":106.64878316230333},{"name":"Ephemera","hex":"#6f5965","rgb":{"r":111,"g":89,"b":101},"luminance":62.95564284478397},{"name":"Ephemeral Blue","hex":"#cbd4df","rgb":{"r":203,"g":212,"b":223},"luminance":140.7718474305143},{"name":"Ephemeral Fog","hex":"#d6ced3","rgb":{"r":214,"g":206,"b":211},"luminance":138.90620287085815},{"name":"Ephemeral Mist","hex":"#c7cdd3","rgb":{"r":199,"g":205,"b":211},"luminance":136.37989639972602},{"name":"Ephemeral Peach","hex":"#fce2d4","rgb":{"r":252,"g":226,"b":212},"luminance":154.4688304221923},{"name":"Ephemeral Red","hex":"#e4cfd7","rgb":{"r":228,"g":207,"b":215},"luminance":141.46589258545677},{"name":"Ephren Blue","hex":"#1164b4","rgb":{"r":17,"g":100,"b":180},"luminance":62.390682709840576},{"name":"Epicurean Orange","hex":"#ea6a0a","rgb":{"r":234,"g":106,"b":10},"luminance":93.63822958599762},{"name":"Epidote Olvene Ore","hex":"#ab924b","rgb":{"r":171,"g":146,"b":75},"luminance":100.16042105043289},{"name":"Epsom","hex":"#849161","rgb":{"r":132,"g":145,"b":97},"luminance":94.46991909068197},{"name":"Equanimity","hex":"#83a9b3","rgb":{"r":131,"g":169,"b":179},"luminance":108.59028780696734},{"name":"Equator","hex":"#dab160","rgb":{"r":218,"g":177,"b":96},"luminance":123.14002785853185},{"name":"Equatorial Forest","hex":"#70855e","rgb":{"r":112,"g":133,"b":94},"luminance":85.62336036970284},{"name":"Equestrian","hex":"#bea781","rgb":{"r":190,"g":167,"b":129},"luminance":114.25115919324406},{"name":"Equilibrium","hex":"#a49f9f","rgb":{"r":164,"g":159,"b":159},"luminance":106.97724085523986},{"name":"Equinox","hex":"#62696b","rgb":{"r":98,"g":105,"b":107},"luminance":69.3272791403211},{"name":"Erebus Blue","hex":"#060030","rgb":{"r":6,"g":0,"b":48},"luminance":5.758577949459397},{"name":"Ermine","hex":"#836b4f","rgb":{"r":131,"g":107,"b":79},"luminance":74.56734592299769},{"name":"Erosion","hex":"#ddd1bf","rgb":{"r":221,"g":209,"b":191},"luminance":141.03779566485005},{"name":"Erythrosine","hex":"#fc7ab0","rgb":{"r":252,"g":122,"b":176},"luminance":105.86996833852363},{"name":"Escalope","hex":"#cc8866","rgb":{"r":204,"g":136,"b":102},"luminance":101.13787927379137},{"name":"Escape from Columbia","hex":"#d2e2ef","rgb":{"r":210,"g":226,"b":239},"luminance":149.2787153615679},{"name":"Escargot","hex":"#fff1d8","rgb":{"r":255,"g":241,"b":216},"luminance":162.5809136707012},{"name":"Eshin Grey","hex":"#4a4f52","rgb":{"r":74,"g":79,"b":82},"luminance":52.224516359656214},{"name":"Eskimo White","hex":"#c2bdc2","rgb":{"r":194,"g":189,"b":194},"luminance":127.13049492942281},{"name":"Esmeralda","hex":"#45be76","rgb":{"r":69,"g":190,"b":118},"luminance":114.21705373979842},{"name":"Esper's Fungus Green","hex":"#80f9ad","rgb":{"r":128,"g":249,"b":173},"luminance":152.37232634897978},{"name":"Esplanade","hex":"#d5bda4","rgb":{"r":213,"g":189,"b":164},"luminance":129.28234076624696},{"name":"Espresso","hex":"#4e312d","rgb":{"r":78,"g":49,"b":45},"luminance":37.38372310244125},{"name":"Espresso Macchiato","hex":"#4f4744","rgb":{"r":79,"g":71,"b":68},"luminance":48.52852227298911},{"name":"Esprit","hex":"#bebd99","rgb":{"r":190,"g":189,"b":153},"luminance":125.85685802927068},{"name":"Essence of Violet","hex":"#efedee","rgb":{"r":239,"g":237,"b":238},"luminance":158.7353650135974},{"name":"Essential Brown","hex":"#7d6848","rgb":{"r":125,"g":104,"b":72},"luminance":72.04942881799965},{"name":"Estate Blue","hex":"#233658","rgb":{"r":35,"g":54,"b":88},"luminance":34.85570904457403},{"name":"Estuary Blue","hex":"#70a5b7","rgb":{"r":112,"g":165,"b":183},"luminance":104.58279118956425},{"name":"Eternal Cherry","hex":"#dd0044","rgb":{"r":221,"g":0,"b":68},"luminance":66.53215572187632},{"name":"Eternal Flame","hex":"#a13f49","rgb":{"r":161,"g":63,"b":73},"luminance":61.27163590112475},{"name":"Eternal White","hex":"#faf3dc","rgb":{"r":250,"g":243,"b":220},"luminance":162.9816670089001},{"name":"Eternity","hex":"#2d2f28","rgb":{"r":45,"g":47,"b":40},"luminance":31.031976185863506},{"name":"Ether","hex":"#9eb6b8","rgb":{"r":158,"g":182,"b":184},"luminance":118.68151792086246},{"name":"Etherea","hex":"#a5958f","rgb":{"r":165,"g":149,"b":143},"luminance":101.7323635722674},{"name":"Ethereal","hex":"#f9eecb","rgb":{"r":249,"g":238,"b":203},"luminance":159.98834332850626},{"name":"Ethereal Blue","hex":"#5ca6ce","rgb":{"r":92,"g":166,"b":206},"luminance":103.9381146836905},{"name":"Ethereal Green","hex":"#f1ecca","rgb":{"r":241,"g":236,"b":202},"luminance":157.84138648972896},{"name":"Etherium Blue","hex":"#b9c4de","rgb":{"r":185,"g":196,"b":222},"luminance":130.1430243731872},{"name":"Ethiopian Wolf","hex":"#985629","rgb":{"r":152,"g":86,"b":41},"luminance":68.086704311488},{"name":"Eton Blue","hex":"#96c8a2","rgb":{"r":150,"g":200,"b":162},"luminance":127.02499566620736},{"name":"Etruscan Red","hex":"#a2574b","rgb":{"r":162,"g":87,"b":75},"luminance":70.90405563153634},{"name":"Eucalipto","hex":"#4bc3a8","rgb":{"r":75,"g":195,"b":168},"luminance":118.20285933089772},{"name":"Eucalyptus","hex":"#329760","rgb":{"r":50,"g":151,"b":96},"luminance":90.55269960084017},{"name":"Eucalyptus Leaf","hex":"#bad2b8","rgb":{"r":186,"g":210,"b":184},"luminance":136.8517536314387},{"name":"Eunry","hex":"#cda59c","rgb":{"r":205,"g":165,"b":156},"luminance":115.99240796707342},{"name":"Euro Linen","hex":"#f2e8db","rgb":{"r":242,"g":232,"b":219},"luminance":156.2211995089015},{"name":"European Pine","hex":"#756556","rgb":{"r":117,"g":101,"b":86},"luminance":69.53328033395232},{"name":"Eva Green","hex":"#36ff9a","rgb":{"r":54,"g":255,"b":154},"luminance":151.57343328235328},{"name":"Even Evan","hex":"#998371","rgb":{"r":153,"g":131,"b":113},"luminance":90.39846537414226},{"name":"Even Growth","hex":"#b2aa7a","rgb":{"r":178,"g":170,"b":122},"luminance":113.94761010218687},{"name":"Evening Blue","hex":"#2a293e","rgb":{"r":42,"g":41,"b":62},"luminance":28.051389929912563},{"name":"Evening Blush","hex":"#c49087","rgb":{"r":196,"g":144,"b":135},"luminance":104.00126778073428},{"name":"Evening Cityscape","hex":"#4b535c","rgb":{"r":75,"g":83,"b":92},"luminance":54.64992781331005},{"name":"Evening Dove","hex":"#c2bead","rgb":{"r":194,"g":190,"b":173},"luminance":127.25012463648119},{"name":"Evening Dress","hex":"#d1a19b","rgb":{"r":209,"g":161,"b":155},"luminance":114.6687709448392},{"name":"Evening East","hex":"#585e6a","rgb":{"r":88,"g":94,"b":106},"luminance":62.313370026022504},{"name":"Evening Emerald","hex":"#56736f","rgb":{"r":86,"g":115,"b":111},"luminance":73.33661116386548},{"name":"Evening Fizz","hex":"#4d4970","rgb":{"r":77,"g":73,"b":112},"luminance":50.29203270896892},{"name":"Evening Glory","hex":"#3a4a62","rgb":{"r":58,"g":74,"b":98},"luminance":48.08761162711244},{"name":"Evening Glow","hex":"#fdd792","rgb":{"r":253,"g":215,"b":146},"luminance":148.0783352486109},{"name":"Evening Green","hex":"#7c7a3a","rgb":{"r":124,"g":122,"b":58},"luminance":80.91299843659236},{"name":"Evening Haze","hex":"#bdb8c7","rgb":{"r":189,"g":184,"b":199},"luminance":123.9914343049551},{"name":"Evening Hush","hex":"#7b8ca8","rgb":{"r":123,"g":140,"b":168},"luminance":92.04835269031162},{"name":"Evening Lagoon","hex":"#5868ae","rgb":{"r":88,"g":104,"b":174},"luminance":69.3732408353538},{"name":"Evening Lavender","hex":"#4d4469","rgb":{"r":77,"g":68,"b":105},"luminance":47.60910086317531},{"name":"Evening Mist","hex":"#e3e9e8","rgb":{"r":227,"g":233,"b":232},"luminance":154.95982470950332},{"name":"Evening Primrose","hex":"#ccdb1e","rgb":{"r":204,"g":219,"b":30},"luminance":142.33088991852753},{"name":"Evening Sand","hex":"#ddb6ab","rgb":{"r":221,"g":182,"b":171},"luminance":127.12180707101358},{"name":"Evening Sea","hex":"#26604f","rgb":{"r":38,"g":96,"b":79},"luminance":58.18720636016133},{"name":"Evening Shadow","hex":"#a1838b","rgb":{"r":161,"g":131,"b":139},"luminance":92.09564401208125},{"name":"Evening Sunset","hex":"#edb06d","rgb":{"r":237,"g":176,"b":109},"luminance":125.89416026567713},{"name":"Eventide","hex":"#656470","rgb":{"r":101,"g":100,"b":112},"luminance":67.23608722256226},{"name":"Everglade","hex":"#264334","rgb":{"r":38,"g":67,"b":52},"luminance":41.36431395538913},{"name":"Everglade Mist","hex":"#b7d7de","rgb":{"r":183,"g":215,"b":222},"luminance":139.86474530059388},{"name":"Evergreen","hex":"#11574a","rgb":{"r":17,"g":87,"b":74},"luminance":52.01005427799513},{"name":"Evergreen Boughs","hex":"#50594f","rgb":{"r":80,"g":89,"b":79},"luminance":58.16017095057407},{"name":"Evergreen Forest","hex":"#0e695f","rgb":{"r":14,"g":105,"b":95},"luminance":62.71909375142469},{"name":"Everlasting","hex":"#a1bed9","rgb":{"r":161,"g":190,"b":217},"luminance":123.9688382820457},{"name":"Everlasting Ice","hex":"#f6fdfa","rgb":{"r":246,"g":253,"b":250},"luminance":168.16051271627356},{"name":"Eversong Orange","hex":"#ffa62d","rgb":{"r":255,"g":166,"b":45},"luminance":123.83279165471478},{"name":"Evil Centipede","hex":"#aa2211","rgb":{"r":170,"g":34,"b":17},"luminance":54.64216785596998},{"name":"Evil Forces","hex":"#770022","rgb":{"r":119,"g":0,"b":34},"luminance":35.79149252266521},{"name":"Evil Sunz Scarlet","hex":"#c2191f","rgb":{"r":194,"g":25,"b":31},"luminance":59.93780790953236},{"name":"Evora","hex":"#538b89","rgb":{"r":83,"g":139,"b":137},"luminance":86.70192075150352},{"name":"Exaggerated Blush","hex":"#b55067","rgb":{"r":181,"g":80,"b":103},"luminance":72.60841772824966},{"name":"Excalibur","hex":"#676168","rgb":{"r":103,"g":97,"b":104},"luminance":65.81086282674009},{"name":"Excelsior","hex":"#908b85","rgb":{"r":144,"g":139,"b":133},"luminance":93.49397322287676},{"name":"Exclusive Elixir","hex":"#f9f1dd","rgb":{"r":249,"g":241,"b":221},"luminance":161.83510473936116},{"name":"Exclusive Ivory","hex":"#e2d8c3","rgb":{"r":226,"g":216,"b":195},"luminance":145.3844202106952},{"name":"Exclusively","hex":"#6b515f","rgb":{"r":107,"g":81,"b":95},"luminance":58.32287851263859},{"name":"Exclusively Yours","hex":"#f2aeb8","rgb":{"r":242,"g":174,"b":184},"luminance":126.91668047975412},{"name":"Executive Course","hex":"#8f8a70","rgb":{"r":143,"g":138,"b":112},"luminance":92.48326826512998},{"name":"Existential Angst","hex":"#0a0a0a","rgb":{"r":10,"g":10,"b":10},"luminance":6.685551585321886},{"name":"Exodus Fruit","hex":"#6264dc","rgb":{"r":98,"g":100,"b":220},"luminance":70.23748005160778},{"name":"Exotic Escape","hex":"#96d9df","rgb":{"r":150,"g":217,"b":223},"luminance":137.41619345986848},{"name":"Exotic Evening","hex":"#58516e","rgb":{"r":88,"g":81,"b":110},"luminance":55.7699753720584},{"name":"Exotic Flower","hex":"#ffa24c","rgb":{"r":255,"g":162,"b":76},"luminance":122.19342763422262},{"name":"Exotic Incense","hex":"#b86f73","rgb":{"r":184,"g":111,"b":115},"luminance":86.27900674555775},{"name":"Exotic Life","hex":"#ae7543","rgb":{"r":174,"g":117,"b":67},"luminance":86.49768066832776},{"name":"Exotic Lilac","hex":"#d198b5","rgb":{"r":209,"g":152,"b":181},"luminance":110.86843199486498},{"name":"Exotic Liras","hex":"#de0c62","rgb":{"r":222,"g":12,"b":98},"luminance":67.67917260132543},{"name":"Exotic Orange","hex":"#f96531","rgb":{"r":249,"g":101,"b":49},"luminance":95.3367881040682},{"name":"Exotic Violet","hex":"#e1a0cf","rgb":{"r":225,"g":160,"b":207},"luminance":117.91419604525996},{"name":"Exotica","hex":"#938586","rgb":{"r":147,"g":133,"b":134},"luminance":90.88621141845444},{"name":"Expanse","hex":"#777e65","rgb":{"r":119,"g":126,"b":101},"luminance":82.8791722991971},{"name":"Experience","hex":"#64acb5","rgb":{"r":100,"g":172,"b":181},"luminance":107.30098439436611},{"name":"Exploding Star","hex":"#fed83a","rgb":{"r":254,"g":216,"b":58},"luminance":147.94500574199859},{"name":"Exploration Green","hex":"#55a860","rgb":{"r":85,"g":168,"b":96},"luminance":102.42464945998107},{"name":"Explore Blue","hex":"#30aabc","rgb":{"r":48,"g":170,"b":188},"luminance":103.06965910489856},{"name":"Exquisite","hex":"#c8a3bb","rgb":{"r":200,"g":163,"b":187},"luminance":114.82748314319181},{"name":"Exquisite Eggplant","hex":"#330033","rgb":{"r":51,"g":0,"b":51},"luminance":16.319760935749027},{"name":"Exquisite Turquoise","hex":"#11ccbb","rgb":{"r":17,"g":204,"b":187},"luminance":121.7369192849893},{"name":"Extinct","hex":"#9490b2","rgb":{"r":148,"g":144,"b":178},"luminance":97.54479766753325},{"name":"Extinct Volcano","hex":"#4a4f5a","rgb":{"r":74,"g":79,"b":90},"luminance":52.39544450617821},{"name":"Extra Life","hex":"#6ab417","rgb":{"r":106,"g":180,"b":23},"luminance":110.34228618258732},{"name":"Extra Mile","hex":"#91916d","rgb":{"r":145,"g":145,"b":109},"luminance":96.32561822277601},{"name":"Extraordinaire","hex":"#bda6c5","rgb":{"r":189,"g":166,"b":197},"luminance":114.85990705637889},{"name":"Extraviolet","hex":"#661188","rgb":{"r":102,"g":17,"b":136},"luminance":35.63821629936044},{"name":"Extreme Lavender","hex":"#dfc5d5","rgb":{"r":223,"g":197,"b":213},"luminance":135.67540740311046},{"name":"Exuberance","hex":"#e86800","rgb":{"r":232,"g":104,"b":0},"luminance":92.40550702203846},{"name":"Exuberant Orange","hex":"#f0622f","rgb":{"r":240,"g":98,"b":47},"luminance":92.12733817928313},{"name":"Eye Blue","hex":"#1e80c7","rgb":{"r":30,"g":128,"b":199},"luminance":78.99705052721905},{"name":"Eye Of Newt","hex":"#ae3d3b","rgb":{"r":174,"g":61,"b":59},"luminance":63.51444718329838},{"name":"Eye of the Storm","hex":"#d9e3d9","rgb":{"r":217,"g":227,"b":217},"luminance":150.2566748400882},{"name":"Eyeball","hex":"#fffbf8","rgb":{"r":255,"g":251,"b":248},"luminance":168.2878414443539},{"name":"Eyefull","hex":"#8db6b7","rgb":{"r":141,"g":182,"b":183},"luminance":116.73092084362223},{"name":"Eyelash Camel","hex":"#553300","rgb":{"r":85,"g":51,"b":0},"luminance":39.27016926370448},{"name":"Eyelash Viper","hex":"#f4c54b","rgb":{"r":244,"g":197,"b":75},"luminance":136.99656476350054},{"name":"Eyelids","hex":"#440000","rgb":{"r":68,"g":0,"b":0},"luminance":20.332},{"name":"Eyre","hex":"#8f9482","rgb":{"r":143,"g":148,"b":130},"luminance":97.95525930239785},{"name":"Fabulous Fantasy","hex":"#ba90ad","rgb":{"r":186,"g":144,"b":173},"luminance":103.08664833042153},{"name":"Fabulous Find","hex":"#abe3c9","rgb":{"r":171,"g":227,"b":201},"luminance":144.5493757786591},{"name":"Fabulous Forties","hex":"#ddcdab","rgb":{"r":221,"g":205,"b":171},"luminance":138.66132302123762},{"name":"Fabulous Frog","hex":"#88cc00","rgb":{"r":136,"g":204,"b":0},"luminance":126.46400436487846},{"name":"Facemark","hex":"#f7cf89","rgb":{"r":247,"g":207,"b":137},"luminance":143.04763057807003},{"name":"Fade to Black","hex":"#676965","rgb":{"r":103,"g":105,"b":101},"luminance":69.85628554396519},{"name":"Faded Blue","hex":"#658cbb","rgb":{"r":101,"g":140,"b":187},"luminance":90.11098226631424},{"name":"Faded Denim","hex":"#798ea4","rgb":{"r":121,"g":142,"b":164},"luminance":92.770414319437},{"name":"Faded Firebrick","hex":"#e5d9dc","rgb":{"r":229,"g":217,"b":220},"luminance":146.7742957128393},{"name":"Faded Forest","hex":"#e3e2d7","rgb":{"r":227,"g":226,"b":215},"luminance":151.01884145033029},{"name":"Faded Fuchsia","hex":"#ede2ee","rgb":{"r":237,"g":226,"b":238},"luminance":152.82969749691975},{"name":"Faded Green","hex":"#7bb274","rgb":{"r":123,"g":178,"b":116},"luminance":111.55602225339517},{"name":"Faded Grey","hex":"#eae8e4","rgb":{"r":234,"g":232,"b":228},"luminance":155.2961914407433},{"name":"Faded Jade","hex":"#427977","rgb":{"r":66,"g":121,"b":119},"luminance":74.95533230531368},{"name":"Faded Jeans","hex":"#5dbdcb","rgb":{"r":93,"g":189,"b":203},"luminance":116.69246189021808},{"name":"Faded Khaki","hex":"#a5975b","rgb":{"r":165,"g":151,"b":91},"luminance":101.97097562542001},{"name":"Faded Light","hex":"#f5e4de","rgb":{"r":245,"g":228,"b":222},"luminance":154.657249377454},{"name":"Faded Orange","hex":"#f0944d","rgb":{"r":240,"g":148,"b":77},"luminance":113.02207863952952},{"name":"Faded Pink","hex":"#de9dac","rgb":{"r":222,"g":157,"b":172},"luminance":115.25534186752472},{"name":"Faded Poster","hex":"#80dbeb","rgb":{"r":128,"g":219,"b":235},"luminance":136.77837509270242},{"name":"Faded Purple","hex":"#916e99","rgb":{"r":145,"g":110,"b":153},"luminance":79.70673929474219},{"name":"Faded Red","hex":"#d3494e","rgb":{"r":211,"g":73,"b":78},"luminance":76.78214496873606},{"name":"Faded Rose","hex":"#bf6464","rgb":{"r":191,"g":100,"b":100},"luminance":82.68668502848568},{"name":"Faded Shells","hex":"#ebdcd7","rgb":{"r":235,"g":220,"b":215},"luminance":149.04713994236855},{"name":"Faded Violet","hex":"#ddbedd","rgb":{"r":221,"g":190,"b":221},"luminance":132.06101914266753},{"name":"Faded Yellow","hex":"#feff7f","rgb":{"r":254,"g":255,"b":127},"luminance":168.47256935477657},{"name":"Fading Ember","hex":"#df691e","rgb":{"r":223,"g":105,"b":30},"luminance":90.86469035879668},{"name":"Fading Love","hex":"#c973a2","rgb":{"r":201,"g":115,"b":162},"luminance":92.2490208620124},{"name":"Fading Parchment","hex":"#ece6dc","rgb":{"r":236,"g":230,"b":220},"luminance":154.38906890061872},{"name":"Faience","hex":"#2a6a8b","rgb":{"r":42,"g":106,"b":139},"luminance":65.42458531775344},{"name":"Faint Clover","hex":"#b2eed3","rgb":{"r":178,"g":238,"b":211},"luminance":151.42305846864934},{"name":"Faint Fawn","hex":"#e2c59c","rgb":{"r":226,"g":197,"b":156},"luminance":135.1106748299334},{"name":"Faint Fern","hex":"#dadbe0","rgb":{"r":218,"g":219,"b":224},"luminance":146.3784623125957},{"name":"Faint Fuchsia","hex":"#e6deea","rgb":{"r":230,"g":222,"b":234},"luminance":149.7419796583443},{"name":"Faint Gold","hex":"#b59410","rgb":{"r":181,"g":148,"b":16},"luminance":102.37007625766428},{"name":"Fainting Light","hex":"#1f2847","rgb":{"r":31,"g":40,"b":71},"luminance":26.509198346988914},{"name":"Fair Aqua","hex":"#b8e2dc","rgb":{"r":184,"g":226,"b":220},"luminance":145.79085327962107},{"name":"Fair Green","hex":"#92af88","rgb":{"r":146,"g":175,"b":136},"luminance":112.68749423516346},{"name":"Fair Maiden","hex":"#f1e7dc","rgb":{"r":241,"g":231,"b":220},"luminance":155.58937074877574},{"name":"Fair Orchid","hex":"#c0aac0","rgb":{"r":192,"g":170,"b":192},"luminance":117.18706032664186},{"name":"Fair Pink","hex":"#f3e5dc","rgb":{"r":243,"g":229,"b":220},"luminance":154.84698569232788},{"name":"Fair Spring","hex":"#93977f","rgb":{"r":147,"g":151,"b":127},"luminance":99.98998180817915},{"name":"Fairbank Green","hex":"#9d9c7e","rgb":{"r":157,"g":156,"b":126},"luminance":103.90091880729446},{"name":"Fairest Jade","hex":"#d8e3d7","rgb":{"r":216,"g":227,"b":215},"luminance":150.09040328082273},{"name":"Fairstar","hex":"#6ba5a9","rgb":{"r":107,"g":165,"b":169},"luminance":103.80569266663557},{"name":"Fairway","hex":"#477050","rgb":{"r":71,"g":112,"b":80},"luminance":69.68585492766806},{"name":"Fairway Green","hex":"#26623f","rgb":{"r":38,"g":98,"b":63},"luminance":59.07551814415172},{"name":"Fairy Dust","hex":"#ffe8f4","rgb":{"r":255,"g":232,"b":244},"luminance":158.53426045180268},{"name":"Fairy Pink","hex":"#eed3cb","rgb":{"r":238,"g":211,"b":203},"luminance":144.70707949855114},{"name":"Fairy Princess","hex":"#f6dbdd","rgb":{"r":246,"g":219,"b":221},"luminance":150.23582249583487},{"name":"Fairy Sparkles","hex":"#b0e0f7","rgb":{"r":176,"g":224,"b":247},"luminance":144.39962771420153},{"name":"Fairy Tail","hex":"#ecdde5","rgb":{"r":236,"g":221,"b":229},"luminance":149.96631575457204},{"name":"Fairy Tale","hex":"#f2c1d1","rgb":{"r":242,"g":193,"b":209},"luminance":136.5218265370047},{"name":"Fairy Wand","hex":"#aea4c1","rgb":{"r":174,"g":164,"b":193},"luminance":111.61684686461986},{"name":"Fairy Wings","hex":"#ffebf2","rgb":{"r":255,"g":235,"b":242},"luminance":160.01006466469536},{"name":"Fairy Wren","hex":"#9479af","rgb":{"r":148,"g":121,"b":175},"luminance":86.02951082622752},{"name":"Fairy-Nuff","hex":"#e2d7da","rgb":{"r":226,"g":215,"b":218},"luminance":145.2982085402294},{"name":"Fairytale Dream","hex":"#facfcc","rgb":{"r":250,"g":207,"b":204},"luminance":144.54356131284436},{"name":"Faith","hex":"#d5ebac","rgb":{"r":213,"g":235,"b":172},"luminance":153.19703214488197},{"name":"Fake Jade","hex":"#13eac9","rgb":{"r":19,"g":234,"b":201},"luminance":139.37196748629188},{"name":"Falafel","hex":"#aa7711","rgb":{"r":170,"g":119,"b":17},"luminance":86.41114715706533},{"name":"Falcon","hex":"#6e5a5b","rgb":{"r":110,"g":90,"b":91},"luminance":63.09025975536953},{"name":"Falcon Turquoise","hex":"#007062","rgb":{"r":0,"g":112,"b":98},"luminance":66.68648378794612},{"name":"Fall Canyon","hex":"#c69896","rgb":{"r":198,"g":152,"b":150},"luminance":108.43527553337981},{"name":"Fall Chill","hex":"#e1dddb","rgb":{"r":225,"g":221,"b":219},"luminance":148.25087288107278},{"name":"Fall Foliage","hex":"#c28359","rgb":{"r":194,"g":131,"b":89},"luminance":96.85445762070015},{"name":"Fall Gold","hex":"#ffbc35","rgb":{"r":255,"g":188,"b":53},"luminance":134.2693283106756},{"name":"Fall Green","hex":"#ecfcbd","rgb":{"r":236,"g":252,"b":189},"luminance":165.30280695741374},{"name":"Fall Harvest","hex":"#a78a59","rgb":{"r":167,"g":138,"b":89},"luminance":95.69857805108705},{"name":"Fall Heliotrope","hex":"#a49491","rgb":{"r":164,"g":148,"b":145},"luminance":101.11977834232034},{"name":"Fall Leaf","hex":"#e5b7a5","rgb":{"r":229,"g":183,"b":165},"luminance":128.76864984148898},{"name":"Fallen Leaves","hex":"#917347","rgb":{"r":145,"g":115,"b":71},"luminance":80.63556216707364},{"name":"Fallen Rock","hex":"#807669","rgb":{"r":128,"g":118,"b":105},"luminance":80.03627702485916},{"name":"Falling Star","hex":"#cad5c8","rgb":{"r":202,"g":213,"b":200},"luminance":140.71428273277735},{"name":"Falling Tears","hex":"#c2d7df","rgb":{"r":194,"g":215,"b":223},"luminance":141.20437721614724},{"name":"Fallout Green","hex":"#b6c121","rgb":{"r":182,"g":193,"b":33},"luminance":125.739103102416},{"name":"Fallow","hex":"#c19a51","rgb":{"r":193,"g":154,"b":81},"luminance":107.64368541163945},{"name":"Fallow Deer","hex":"#9f8d57","rgb":{"r":159,"g":141,"b":87},"luminance":95.96296001062075},{"name":"False Morel","hex":"#784d4c","rgb":{"r":120,"g":77,"b":76},"luminance":58.355710063369116},{"name":"False Puce","hex":"#a57e52","rgb":{"r":165,"g":126,"b":82},"luminance":89.39633534435289},{"name":"Falu Red","hex":"#801818","rgb":{"r":128,"g":24,"b":24},"luminance":40.87423912441674},{"name":"Family Tree","hex":"#a7b191","rgb":{"r":167,"g":177,"b":145},"luminance":116.45405785115433},{"name":"Fancy Flamingo","hex":"#ffb1b0","rgb":{"r":255,"g":177,"b":176},"luminance":130.42571188994904},{"name":"Fancy Flirt","hex":"#b4b780","rgb":{"r":180,"g":183,"b":128},"luminance":121.03218623572822},{"name":"Fancy Fuchsia","hex":"#ff0088","rgb":{"r":255,"g":0,"b":136},"luminance":77.80535997603249},{"name":"Fancy Pants","hex":"#f3dae1","rgb":{"r":243,"g":218,"b":225},"luminance":149.37288678003114},{"name":"Fandangle","hex":"#e4de65","rgb":{"r":228,"g":222,"b":101},"luminance":147.5185831548012},{"name":"Fandango","hex":"#b53389","rgb":{"r":181,"g":51,"b":137},"luminance":63.78880821899716},{"name":"Fandango Pink","hex":"#e04f80","rgb":{"r":224,"g":79,"b":128},"luminance":82.75968927563709},{"name":"Fanfare","hex":"#006d70","rgb":{"r":0,"g":109,"b":112},"luminance":65.24451021350379},{"name":"Fangtooth Fish","hex":"#bbaa97","rgb":{"r":187,"g":170,"b":151},"luminance":115.67467080134699},{"name":"Fanlight","hex":"#f2eeaf","rgb":{"r":242,"g":238,"b":175},"luminance":158.5920839764709},{"name":"Fantan","hex":"#9f7e53","rgb":{"r":159,"g":126,"b":83},"luminance":88.43106676389242},{"name":"Fantasy","hex":"#f2e6dd","rgb":{"r":242,"g":230,"b":221},"luminance":155.23568500831246},{"name":"Fantasy Console Sky","hex":"#29adff","rgb":{"r":41,"g":173,"b":255},"luminance":106.33886204958183},{"name":"Far Away Grey","hex":"#2d383a","rgb":{"r":45,"g":56,"b":58},"luminance":36.12926726353581},{"name":"Faraway Sky","hex":"#8980c1","rgb":{"r":137,"g":128,"b":193},"luminance":88.35991098343185},{"name":"Farfalle Noodle","hex":"#e5d4c9","rgb":{"r":229,"g":212,"b":201},"luminance":143.87368895319253},{"name":"Farm Fresh","hex":"#8e9b88","rgb":{"r":142,"g":155,"b":136},"luminance":101.59392700845854},{"name":"Farmer's Market","hex":"#8f917c","rgb":{"r":143,"g":145,"b":124},"luminance":96.29408481313895},{"name":"Farmers Green","hex":"#96a69f","rgb":{"r":150,"g":166,"b":159},"luminance":108.78886772092078},{"name":"Farrago","hex":"#456f6e","rgb":{"r":69,"g":111,"b":110},"luminance":69.48614545360823},{"name":"Farsighted","hex":"#e5e3ef","rgb":{"r":229,"g":227,"b":239},"luminance":152.26922984634814},{"name":"Fashion Fuchsia","hex":"#f400a1","rgb":{"r":244,"g":0,"b":161},"luminance":75.22929783003428},{"name":"Fast Velvet","hex":"#8b94c7","rgb":{"r":139,"g":148,"b":199},"luminance":98.94145083330848},{"name":"Fat Tuesday","hex":"#352235","rgb":{"r":53,"g":34,"b":53},"luminance":26.190741436622215},{"name":"Fatback","hex":"#fff7ed","rgb":{"r":255,"g":247,"b":237},"luminance":166.02735458351432},{"name":"Fate","hex":"#6ba0bf","rgb":{"r":107,"g":160,"b":191},"luminance":101.58063558080347},{"name":"Favored One","hex":"#fae6cc","rgb":{"r":250,"g":230,"b":204},"luminance":156.06442303100346},{"name":"Favorite Fudge","hex":"#877252","rgb":{"r":135,"g":114,"b":82},"luminance":78.7066518980448},{"name":"Favorite Lavender","hex":"#d3a5d6","rgb":{"r":211,"g":165,"b":214},"luminance":118.13669100664703},{"name":"Favourite Lady","hex":"#e3c5d6","rgb":{"r":227,"g":197,"b":214},"luminance":136.28751691185806},{"name":"Fawn","hex":"#cfaf7b","rgb":{"r":207,"g":175,"b":123},"luminance":120.74678280600274},{"name":"Feather Boa","hex":"#f1c9cd","rgb":{"r":241,"g":201,"b":205},"luminance":140.21265474271573},{"name":"Feather Falls","hex":"#606972","rgb":{"r":96,"g":105,"b":114},"luminance":69.22202580826423},{"name":"Feather Grey","hex":"#b8ad9e","rgb":{"r":184,"g":173,"b":158},"luminance":116.8922495334913},{"name":"Feather White","hex":"#e7eae5","rgb":{"r":231,"g":234,"b":229},"luminance":155.94636950246712},{"name":"Featherbed","hex":"#afcbe5","rgb":{"r":175,"g":203,"b":229},"luminance":132.73572534174812},{"name":"Featherstone","hex":"#cdc7bb","rgb":{"r":205,"g":199,"b":187},"luminance":133.62937969623297},{"name":"February Frost","hex":"#e0dee3","rgb":{"r":224,"g":222,"b":227},"luminance":148.7857320309982},{"name":"Federal Blue","hex":"#43628b","rgb":{"r":67,"g":98,"b":139},"luminance":62.94169906349843},{"name":"Federal Fund","hex":"#30594b","rgb":{"r":48,"g":89,"b":75},"luminance":54.84900594359026},{"name":"Federation Brown","hex":"#634041","rgb":{"r":99,"g":64,"b":65},"luminance":48.39919343336209},{"name":"Fedora","hex":"#625665","rgb":{"r":98,"g":86,"b":101},"luminance":59.494636094357276},{"name":"Fēi Hóng Scarlet","hex":"#fe420f","rgb":{"r":254,"g":66,"b":15},"luminance":85.27403813588283},{"name":"Feijoa","hex":"#a5d785","rgb":{"r":165,"g":215,"b":133},"luminance":136.3507627188055},{"name":"Feijoa Flower","hex":"#edf2c3","rgb":{"r":237,"g":242,"b":195},"luminance":160.2968389738238},{"name":"Feldgrau","hex":"#4d5d53","rgb":{"r":77,"g":93,"b":83},"luminance":59.998043751442424},{"name":"Feldspar","hex":"#d19275","rgb":{"r":209,"g":146,"b":117},"luminance":106.90116991408466},{"name":"Felix","hex":"#00608f","rgb":{"r":0,"g":96,"b":143},"luminance":58.66262104611419},{"name":"Felt","hex":"#247345","rgb":{"r":36,"g":115,"b":69},"luminance":68.80888516027564},{"name":"Felt Green","hex":"#6fc391","rgb":{"r":111,"g":195,"b":145},"luminance":120.32035092202814},{"name":"Felwood Leaves","hex":"#2bc51b","rgb":{"r":43,"g":197,"b":27},"luminance":116.39224567813785},{"name":"Feminine Fancy","hex":"#c4a8cf","rgb":{"r":196,"g":168,"b":207},"luminance":117.11707764455191},{"name":"Femininity","hex":"#c7c2ce","rgb":{"r":199,"g":194,"b":206},"luminance":130.61418813053962},{"name":"Feminism","hex":"#9d5783","rgb":{"r":157,"g":87,"b":131},"luminance":70.95570707138363},{"name":"Femme Fatale","hex":"#948593","rgb":{"r":148,"g":133,"b":147},"luminance":91.29157194944119},{"name":"Fěn Hóng Pink","hex":"#ff6cb5","rgb":{"r":255,"g":108,"b":181},"luminance":101.28235185361761},{"name":"Fennec Fox","hex":"#dad7c8","rgb":{"r":218,"g":215,"b":200},"luminance":143.86186134274783},{"name":"Fennel Bulb","hex":"#ddeebb","rgb":{"r":221,"g":238,"b":187},"luminance":156.0085183603767},{"name":"Fennel Flower","hex":"#77aaff","rgb":{"r":119,"g":170,"b":255},"luminance":109.85953104305516},{"name":"Fennel Seed","hex":"#998456","rgb":{"r":153,"g":132,"b":86},"luminance":90.51340608440276},{"name":"Fennel Stem","hex":"#b1b6a3","rgb":{"r":177,"g":182,"b":163},"luminance":120.66332586581558},{"name":"Fennel Tea","hex":"#d2f4dd","rgb":{"r":210,"g":244,"b":221},"luminance":158.40322509343045},{"name":"Fennelly","hex":"#9a9e80","rgb":{"r":154,"g":158,"b":128},"luminance":104.57045995882393},{"name":"Fenrisian Grey","hex":"#cedee7","rgb":{"r":206,"g":222,"b":231},"luminance":146.52316877545337},{"name":"Fenugreek","hex":"#c0916c","rgb":{"r":192,"g":145,"b":108},"luminance":103.4012912540264},{"name":"Feralas Lime","hex":"#8de07c","rgb":{"r":141,"g":224,"b":124},"luminance":138.8031048680108},{"name":"Fern","hex":"#548d44","rgb":{"r":84,"g":141,"b":68},"luminance":86.84056223332504},{"name":"Fern Flower","hex":"#576a7d","rgb":{"r":87,"g":106,"b":125},"luminance":68.92979002579364},{"name":"Fern Frond","hex":"#657220","rgb":{"r":101,"g":114,"b":32},"luminance":73.50718488011903},{"name":"Fern Green","hex":"#008c45","rgb":{"r":0,"g":140,"b":69},"luminance":82.55559554627415},{"name":"Fern Gully","hex":"#595646","rgb":{"r":89,"g":86,"b":70},"luminance":57.62168033821992},{"name":"Fern Shade","hex":"#797447","rgb":{"r":121,"g":116,"b":71},"luminance":77.53033819737922},{"name":"Ferocious Fuchsia","hex":"#aa00cc","rgb":{"r":170,"g":0,"b":204},"luminance":55.897499371617684},{"name":"Ferra","hex":"#876a68","rgb":{"r":135,"g":106,"b":104},"luminance":75.10975465943154},{"name":"Ferrari Red","hex":"#ff2800","rgb":{"r":255,"g":40,"b":0},"luminance":79.77850854083448},{"name":"Ferris Wheel","hex":"#ad7d76","rgb":{"r":173,"g":125,"b":118},"luminance":90.7773620348157},{"name":"Ferry","hex":"#383e44","rgb":{"r":56,"g":62,"b":68},"luminance":40.80414532863052},{"name":"Fertility Green","hex":"#66fc00","rgb":{"r":102,"g":252,"b":0},"luminance":151.03522032956417},{"name":"Fervent Green","hex":"#469f4e","rgb":{"r":70,"g":159,"b":78},"luminance":96.06342411656998},{"name":"Festering Brown","hex":"#cb8e00","rgb":{"r":203,"g":142,"b":0},"luminance":103.1116633800464},{"name":"Festival","hex":"#eacc4a","rgb":{"r":234,"g":204,"b":74},"luminance":138.94599942423676},{"name":"Festival Fuchsia","hex":"#9e2c6a","rgb":{"r":158,"g":44,"b":106},"luminance":55.18075030298156},{"name":"Festive Fennec","hex":"#ff5566","rgb":{"r":255,"g":85,"b":102},"luminance":91.85870363770653},{"name":"Festive Ferret","hex":"#dfdfe5","rgb":{"r":223,"g":223,"b":229},"luminance":149.2059562014868},{"name":"Feta","hex":"#dbe0d0","rgb":{"r":219,"g":224,"b":208},"luminance":148.79218544332227},{"name":"Fibre Moss","hex":"#bec0af","rgb":{"r":190,"g":192,"b":175},"luminance":127.77938102839596},{"name":"Ficus","hex":"#3b593a","rgb":{"r":59,"g":89,"b":58},"luminance":55.536064624710306},{"name":"Ficus Elastica","hex":"#006131","rgb":{"r":0,"g":97,"b":49},"luminance":57.21235108785515},{"name":"Fiddle-Leaf Fig","hex":"#a6c875","rgb":{"r":166,"g":200,"b":117},"luminance":128.15692021892536},{"name":"Fiddlehead Fern","hex":"#c8c387","rgb":{"r":200,"g":195,"b":135},"luminance":130.0581728496906},{"name":"Fiddler","hex":"#5a9589","rgb":{"r":90,"g":149,"b":137},"luminance":92.83235639043103},{"name":"Fiddlesticks","hex":"#bb9fb1","rgb":{"r":187,"g":159,"b":177},"luminance":110.65470682262007},{"name":"Field Blue","hex":"#4477aa","rgb":{"r":68,"g":119,"b":170},"luminance":75.2888851889839},{"name":"Field Day","hex":"#c5e6a4","rgb":{"r":197,"g":230,"b":164},"luminance":148.48166191486408},{"name":"Field Drab","hex":"#6c541e","rgb":{"r":108,"g":84,"b":30},"luminance":59.040228048340055},{"name":"Field Green","hex":"#60b922","rgb":{"r":96,"g":185,"b":34},"luminance":112.3913565048487},{"name":"Field Maple","hex":"#80884e","rgb":{"r":128,"g":136,"b":78},"luminance":88.9773109955566},{"name":"Field of Wheat","hex":"#deb699","rgb":{"r":222,"g":182,"b":153},"luminance":126.97939125700672},{"name":"Field Poppy","hex":"#d86f3c","rgb":{"r":216,"g":111,"b":60},"luminance":91.99626788625721},{"name":"Fierce Mantis","hex":"#7fc15c","rgb":{"r":127,"g":193,"b":92},"luminance":119.94497719371161},{"name":"Fiery Coral","hex":"#e26058","rgb":{"r":226,"g":96,"b":88},"luminance":88.5575203130711},{"name":"Fiery Flamingo","hex":"#f96d7b","rgb":{"r":249,"g":109,"b":123},"luminance":99.16346188995219},{"name":"Fiery Fuchsia","hex":"#b7386e","rgb":{"r":183,"g":56,"b":110},"luminance":65.05205663927929},{"name":"Fiery Glow","hex":"#f0531c","rgb":{"r":240,"g":83,"b":28},"luminance":86.79528964753789},{"name":"Fiery Orange","hex":"#b1592f","rgb":{"r":177,"g":89,"b":47},"luminance":74.55791803691945},{"name":"Fiery Red","hex":"#d01c1f","rgb":{"r":208,"g":28,"b":31},"luminance":64.42418890447904},{"name":"Fiery Rose","hex":"#ff5470","rgb":{"r":255,"g":84,"b":112},"luminance":91.69296981230349},{"name":"Fiesta","hex":"#edd8d2","rgb":{"r":237,"g":216,"b":210},"luminance":147.2103924082807},{"name":"Fiesta Blue","hex":"#6fc0b1","rgb":{"r":111,"g":192,"b":177},"luminance":119.20928244478279},{"name":"Fiesta Rojo","hex":"#b67c80","rgb":{"r":182,"g":124,"b":128},"luminance":92.04530477976591},{"name":"Fife","hex":"#a9a5c2","rgb":{"r":169,"g":165,"b":194},"luminance":111.46026395985251},{"name":"Fig","hex":"#532d3b","rgb":{"r":83,"g":45,"b":59},"luminance":36.86291890233328},{"name":"Fig Balsamic","hex":"#550022","rgb":{"r":85,"g":0,"b":34},"luminance":25.708862304660624},{"name":"Fig Branches","hex":"#7a634d","rgb":{"r":122,"g":99,"b":77},"luminance":69.1723827621978},{"name":"Fig Leaf","hex":"#556b2f","rgb":{"r":85,"g":107,"b":47},"luminance":67.96764575884616},{"name":"Figue","hex":"#9469a2","rgb":{"r":148,"g":105,"b":162},"luminance":78.09084295229499},{"name":"Figue Pulp","hex":"#962c54","rgb":{"r":150,"g":44,"b":84},"luminance":52.63371410037487},{"name":"Figure Stone","hex":"#eedac3","rgb":{"r":238,"g":218,"b":195},"luminance":148.09962964167062},{"name":"Figurine","hex":"#e4d5c0","rgb":{"r":228,"g":213,"b":192},"luminance":144.0807311509766},{"name":"Fiji Coral","hex":"#6b5f68","rgb":{"r":107,"g":95,"b":104},"luminance":65.37470466472487},{"name":"Fiji Green","hex":"#636f22","rgb":{"r":99,"g":111,"b":34},"luminance":71.6706161965976},{"name":"Fiji Palm","hex":"#528d3c","rgb":{"r":82,"g":141,"b":60},"luminance":86.59269145257005},{"name":"Fiji Sands","hex":"#d8caa9","rgb":{"r":216,"g":202,"b":169},"luminance":136.38938847285738},{"name":"Filigree","hex":"#dfe7e8","rgb":{"r":223,"g":231,"b":232},"luminance":153.40099557043297},{"name":"Filtered Light","hex":"#b1b2c4","rgb":{"r":177,"g":178,"b":196},"luminance":119.2368334911658},{"name":"Filtered Rays","hex":"#d0b064","rgb":{"r":208,"g":176,"b":100},"luminance":121.12462263305508},{"name":"Filthy Brown","hex":"#e8aa08","rgb":{"r":232,"g":170,"b":8},"luminance":121.53516062440531},{"name":"Finch","hex":"#75785a","rgb":{"r":117,"g":120,"b":90},"luminance":79.31501427220448},{"name":"Fine Grain","hex":"#d8cfc1","rgb":{"r":216,"g":207,"b":193},"luminance":139.3542899985501},{"name":"Fine Linen","hex":"#faf5c3","rgb":{"r":250,"g":245,"b":195},"luminance":163.59856241727798},{"name":"Fine Pine","hex":"#008800","rgb":{"r":0,"g":136,"b":0},"luminance":79.832},{"name":"Fine Sand","hex":"#f1d5ae","rgb":{"r":241,"g":213,"b":174},"luminance":145.66645920732748},{"name":"Fine White Sand","hex":"#e4d4c0","rgb":{"r":228,"g":212,"b":192},"luminance":143.5716380905365},{"name":"Finest Silk","hex":"#f1e5d7","rgb":{"r":241,"g":229,"b":215},"luminance":154.4758314753476},{"name":"Finger Banana","hex":"#e1c12f","rgb":{"r":225,"g":193,"b":47},"luminance":131.86919454520074},{"name":"Fingerpaint","hex":"#8a7e61","rgb":{"r":138,"g":126,"b":97},"luminance":85.4119982906383},{"name":"Fingerprint","hex":"#555356","rgb":{"r":85,"g":83,"b":86},"luminance":55.81914082104811},{"name":"Finishing Touch","hex":"#cbbfb3","rgb":{"r":203,"g":191,"b":179},"luminance":129.1152676254826},{"name":"Finlandia","hex":"#61755b","rgb":{"r":97,"g":117,"b":91},"luminance":75.2701728840847},{"name":"Finn","hex":"#694554","rgb":{"r":105,"g":69,"b":84},"luminance":52.132895660993164},{"name":"Finnish Fiord","hex":"#5db0be","rgb":{"r":93,"g":176,"b":190},"luminance":109.15930648826969},{"name":"Fioletowy Purple","hex":"#fc44a3","rgb":{"r":252,"g":68,"b":163},"luminance":87.26911758463014},{"name":"Fioletowyi Purple","hex":"#fffce3","rgb":{"r":255,"g":252,"b":227},"luminance":168.41757831354778},{"name":"Fiord","hex":"#4b5a62","rgb":{"r":75,"g":90,"b":98},"luminance":58.4696768333809},{"name":"Fir","hex":"#3a725f","rgb":{"r":58,"g":114,"b":95},"luminance":69.97179851911767},{"name":"Fir Green","hex":"#67592a","rgb":{"r":103,"g":89,"b":42},"luminance":60.83347106651074},{"name":"Fire","hex":"#8f3f2a","rgb":{"r":143,"g":63,"b":42},"luminance":56.733414792342614},{"name":"Fire Ant","hex":"#be6400","rgb":{"r":190,"g":100,"b":0},"luminance":81.68883705868262},{"name":"Fire Axe Red","hex":"#ce1620","rgb":{"r":206,"g":22,"b":32},"luminance":63.0388779722482},{"name":"Fire Bush","hex":"#e09842","rgb":{"r":224,"g":152,"b":66},"luminance":111.81823343265621},{"name":"Fire Chalk","hex":"#d2806c","rgb":{"r":210,"g":128,"b":108},"luminance":98.68935069195662},{"name":"Fire Chi","hex":"#92353a","rgb":{"r":146,"g":53,"b":58},"luminance":54.01189295886601},{"name":"Fire Coral","hex":"#e3b46f","rgb":{"r":227,"g":180,"b":111},"luminance":126.21768277464136},{"name":"Fire Dragon Bright","hex":"#f97306","rgb":{"r":249,"g":115,"b":6},"luminance":100.50046906358197},{"name":"Fire Dust","hex":"#b98d68","rgb":{"r":185,"g":141,"b":104},"luminance":100.25313087380364},{"name":"Fire Engine Red","hex":"#fe0002","rgb":{"r":254,"g":0,"b":2},"luminance":75.94634224240164},{"name":"Fire Flower","hex":"#f68f37","rgb":{"r":246,"g":143,"b":55},"luminance":111.78369870871155},{"name":"Fire Opal","hex":"#fd3c06","rgb":{"r":253,"g":60,"b":6},"luminance":83.44689847441904},{"name":"Fire Orange","hex":"#ff8e57","rgb":{"r":255,"g":142,"b":87},"luminance":113.39998264991047},{"name":"Fireball","hex":"#ce2029","rgb":{"r":206,"g":32,"b":41},"luminance":64.563966482861},{"name":"Firebrick","hex":"#b22222","rgb":{"r":178,"g":34,"b":34},"luminance":56.973032427631935},{"name":"Firebug","hex":"#cd5c51","rgb":{"r":205,"g":92,"b":81},"luminance":82.21177407768306},{"name":"Firecracker","hex":"#f36944","rgb":{"r":243,"g":105,"b":68},"luminance":95.59292012487117},{"name":"Fired Brick","hex":"#6a2e2a","rgb":{"r":106,"g":46,"b":42},"luminance":41.911127209847265},{"name":"Fired Clay","hex":"#884444","rgb":{"r":136,"g":68,"b":68},"luminance":57.50601234653643},{"name":"Firefly","hex":"#314643","rgb":{"r":49,"g":70,"b":67},"luminance":44.28745810045999},{"name":"Firefly Glow","hex":"#fff3a1","rgb":{"r":255,"g":243,"b":161},"luminance":162.7778370110624},{"name":"Firelight","hex":"#f9d97b","rgb":{"r":249,"g":217,"b":123},"luminance":148.2058619825815},{"name":"Fireplace Kitten","hex":"#c5c9c7","rgb":{"r":197,"g":201,"b":199},"luminance":133.8101273222621},{"name":"Firewatch","hex":"#ee8866","rgb":{"r":238,"g":136,"b":102},"luminance":107.57503823843149},{"name":"Fireweed","hex":"#b38491","rgb":{"r":179,"g":132,"b":145},"luminance":95.61123677162638},{"name":"Fireworks","hex":"#44363d","rgb":{"r":68,"g":54,"b":61},"luminance":38.29505900243529},{"name":"First Colors of Spring","hex":"#dbe64c","rgb":{"r":219,"g":230,"b":76},"luminance":150.30145161308323},{"name":"First Crush","hex":"#f6e2ea","rgb":{"r":246,"g":226,"b":234},"luminance":154.01625283066718},{"name":"First Date","hex":"#f5b1a2","rgb":{"r":245,"g":177,"b":162},"luminance":128.46152828765506},{"name":"First Frost","hex":"#cfe5f0","rgb":{"r":207,"g":229,"b":240},"luminance":150.4953686264132},{"name":"First Impression","hex":"#f4e5e7","rgb":{"r":244,"g":229,"b":231},"luminance":155.19536211175898},{"name":"First Landing","hex":"#59a6cf","rgb":{"r":89,"g":166,"b":207},"luminance":103.7301995033269},{"name":"First Light","hex":"#d9e6ee","rgb":{"r":217,"g":230,"b":238},"luminance":152.22893684513465},{"name":"First Lilac","hex":"#e7d6ed","rgb":{"r":231,"g":214,"b":237},"luminance":145.87796615322},{"name":"First Love","hex":"#cf758a","rgb":{"r":207,"g":117,"b":138},"luminance":93.78189758156955},{"name":"First of July","hex":"#bce6ef","rgb":{"r":188,"g":230,"b":239},"luminance":148.76099475332907},{"name":"First Plum","hex":"#b87592","rgb":{"r":184,"g":117,"b":146},"luminance":89.55773575186011},{"name":"First Post","hex":"#2fbda1","rgb":{"r":47,"g":189,"b":161},"luminance":113.32566070400824},{"name":"First Shade of Blue","hex":"#cbe1f2","rgb":{"r":203,"g":225,"b":242},"luminance":147.9494142536563},{"name":"First Snow","hex":"#e8eff8","rgb":{"r":232,"g":239,"b":248},"luminance":159.03883568801675},{"name":"First Timer Green","hex":"#00e8d8","rgb":{"r":0,"g":232,"b":216},"luminance":138.3922802471294},{"name":"First Tulip","hex":"#ffe79c","rgb":{"r":255,"g":231,"b":156},"luminance":156.5762341161646},{"name":"Fish Bone","hex":"#e4d9c5","rgb":{"r":228,"g":217,"b":197},"luminance":146.20941484391489},{"name":"Fish Camp Woods","hex":"#7a9682","rgb":{"r":122,"g":150,"b":130},"luminance":96.4524721507956},{"name":"Fish Ceviche","hex":"#e1e1d5","rgb":{"r":225,"g":225,"b":213},"luminance":150.1976923058407},{"name":"Fish Finger","hex":"#eecc55","rgb":{"r":238,"g":204,"b":85},"luminance":139.63348397859303},{"name":"Fish Net Blue","hex":"#1e446e","rgb":{"r":30,"g":68,"b":110},"luminance":42.79018060256348},{"name":"Fish Pond","hex":"#86c8ed","rgb":{"r":134,"g":200,"b":237},"luminance":126.95675121867288},{"name":"Fisher King","hex":"#5182b9","rgb":{"r":81,"g":130,"b":185},"luminance":82.79229529974393},{"name":"Fist of the North Star","hex":"#225599","rgb":{"r":34,"g":85,"b":153},"luminance":53.824547791876526},{"name":"Fistfull of Green","hex":"#a2a415","rgb":{"r":162,"g":164,"b":21},"luminance":107.79377952368124},{"name":"Fitzgerald Smoke","hex":"#b3b6b0","rgb":{"r":179,"g":182,"b":176},"luminance":121.16338181562942},{"name":"Five Star","hex":"#ffaa4a","rgb":{"r":255,"g":170,"b":74},"luminance":125.86703389291415},{"name":"Fizz","hex":"#b1dbaa","rgb":{"r":177,"g":219,"b":170},"luminance":140.36488926366167},{"name":"Fizzle","hex":"#d8e4de","rgb":{"r":216,"g":228,"b":222},"luminance":150.74369909220084},{"name":"Fjord Blue","hex":"#007290","rgb":{"r":0,"g":114,"b":144},"luminance":68.90213189735132},{"name":"Flagstone","hex":"#acadad","rgb":{"r":172,"g":173,"b":173},"luminance":115.52662926355983},{"name":"Flagstone Quartzite","hex":"#9a9e88","rgb":{"r":154,"g":158,"b":136},"luminance":104.70161721769153},{"name":"Flamboyant","hex":"#129c8b","rgb":{"r":18,"g":156,"b":139},"luminance":93.08862886518416},{"name":"Flamboyant Plum","hex":"#694e52","rgb":{"r":105,"g":78,"b":82},"luminance":56.29732609103206},{"name":"Flame","hex":"#e25822","rgb":{"r":226,"g":88,"b":34},"luminance":85.14464861633995},{"name":"Flame Hawkfish","hex":"#960018","rgb":{"r":150,"g":0,"b":24},"luminance":44.933375079110185},{"name":"Flame Orange","hex":"#fb8b23","rgb":{"r":251,"g":139,"b":35},"luminance":110.93101527526014},{"name":"Flame Pea","hex":"#be5c48","rgb":{"r":190,"g":92,"b":72},"luminance":78.81103590234048},{"name":"Flame Red","hex":"#86282e","rgb":{"r":134,"g":40,"b":46},"luminance":46.7342946025721},{"name":"Flame Scarlet","hex":"#cd212a","rgb":{"r":205,"g":33,"b":42},"luminance":64.46113255288026},{"name":"Flamenco","hex":"#ea8645","rgb":{"r":234,"g":134,"b":69},"luminance":105.56607445576442},{"name":"Flamingo","hex":"#e1634f","rgb":{"r":225,"g":99,"b":79},"luminance":89.35409576510749},{"name":"Flamingo Feather","hex":"#f8bdd9","rgb":{"r":248,"g":189,"b":217},"luminance":135.71601599295494},{"name":"Flamingo Fury","hex":"#df01f0","rgb":{"r":223,"g":1,"b":240},"luminance":72.07452044932383},{"name":"Flamingo Peach","hex":"#f6e2d8","rgb":{"r":246,"g":226,"b":216},"luminance":153.67413099152375},{"name":"Flamingo Pink","hex":"#fc8eac","rgb":{"r":252,"g":142,"b":172},"luminance":114.06000212169032},{"name":"Flan","hex":"#f6e3b4","rgb":{"r":246,"g":227,"b":180},"luminance":153.57915651871514},{"name":"Flannel Pajamas","hex":"#8b8d98","rgb":{"r":139,"g":141,"b":152},"luminance":94.22288784578829},{"name":"Flare Gun","hex":"#ff4519","rgb":{"r":255,"g":69,"b":25},"luminance":86.38237976578324},{"name":"Flash Gitz Yellow","hex":"#fffb05","rgb":{"r":255,"g":251,"b":5},"luminance":165.8970056812358},{"name":"Flash of Orange","hex":"#ffaa00","rgb":{"r":255,"g":170,"b":0},"luminance":125.58401221891263},{"name":"Flashlight","hex":"#f9eed6","rgb":{"r":249,"g":238,"b":214},"luminance":160.17453809204508},{"name":"Flashman","hex":"#7cbd85","rgb":{"r":124,"g":189,"b":133},"luminance":117.95280950024038},{"name":"Flat Aluminum","hex":"#c3c6cd","rgb":{"r":195,"g":198,"b":205},"luminance":132.11401515736324},{"name":"Flat Blue","hex":"#3c73a8","rgb":{"r":60,"g":115,"b":168},"luminance":72.42629169714544},{"name":"Flat Brown","hex":"#754600","rgb":{"r":117,"g":70,"b":0},"luminance":53.96478841800456},{"name":"Flat Earth","hex":"#aa5533","rgb":{"r":170,"g":85,"b":51},"luminance":71.46329492123911},{"name":"Flat Flesh","hex":"#f7d48f","rgb":{"r":247,"g":212,"b":143},"luminance":145.62393329738074},{"name":"Flat Green","hex":"#699d4c","rgb":{"r":105,"g":157,"b":76},"luminance":97.74452517660515},{"name":"Flat Yellow","hex":"#fff005","rgb":{"r":255,"g":240,"b":5},"luminance":160.18988521439172},{"name":"Flattery","hex":"#6b4424","rgb":{"r":107,"g":68,"b":36},"luminance":51.31941076240061},{"name":"Flavescent","hex":"#f7e98e","rgb":{"r":247,"g":233,"b":142},"luminance":156.27739245969008},{"name":"Flavoparmelia Caperata","hex":"#8fb67b","rgb":{"r":143,"g":182,"b":123},"luminance":115.92360022445817},{"name":"Flax","hex":"#eedc82","rgb":{"r":238,"g":220,"b":130},"luminance":148.19177522386317},{"name":"Flax Bloom","hex":"#d2d8f4","rgb":{"r":210,"g":216,"b":244},"luminance":144.19613455290678},{"name":"Flax Fiber","hex":"#e0d68e","rgb":{"r":224,"g":214,"b":142},"luminance":143.2749728459231},{"name":"Flax Flower","hex":"#5577aa","rgb":{"r":85,"g":119,"b":170},"luminance":76.81762970829027},{"name":"Flax Flower Blue","hex":"#4499dd","rgb":{"r":68,"g":153,"b":221},"luminance":95.46802386663295},{"name":"Flax Smoke","hex":"#7b8265","rgb":{"r":123,"g":130,"b":101},"luminance":85.48880643101762},{"name":"Flax-Flower Blue","hex":"#6f88af","rgb":{"r":111,"g":136,"b":175},"luminance":88.7280138682254},{"name":"Flaxen","hex":"#fbecc9","rgb":{"r":251,"g":236,"b":201},"luminance":159.21218176069314},{"name":"Flaxen Fair","hex":"#e3ddbd","rgb":{"r":227,"g":221,"b":189},"luminance":147.9867182351173},{"name":"Flaxseed","hex":"#f7e6c6","rgb":{"r":247,"g":230,"b":198},"luminance":155.53604371013168},{"name":"Flayed One Flesh","hex":"#fcfcde","rgb":{"r":252,"g":252,"b":222},"luminance":167.9265486574413},{"name":"Fleck","hex":"#97bbe1","rgb":{"r":151,"g":187,"b":225},"luminance":121.43141299515541},{"name":"Flemish Blue","hex":"#add0e0","rgb":{"r":173,"g":208,"b":224},"luminance":135.03778375328883},{"name":"Flesh","hex":"#ffcbc4","rgb":{"r":255,"g":203,"b":196},"luminance":143.2197552085605},{"name":"Flesh Fly","hex":"#894585","rgb":{"r":137,"g":69,"b":133},"luminance":59.56799998321247},{"name":"Flesh Red","hex":"#e9c49d","rgb":{"r":233,"g":196,"b":157},"luminance":135.68637365999578},{"name":"Flesh Wash","hex":"#ce8c42","rgb":{"r":206,"g":140,"b":66},"luminance":102.97564669376928},{"name":"Fleshtone Shade Wash","hex":"#cf9346","rgb":{"r":207,"g":147,"b":70},"luminance":106.49044731805759},{"name":"Fleur-De-Lis","hex":"#b090c7","rgb":{"r":176,"g":144,"b":199},"luminance":102.12209729534543},{"name":"Flickering Firefly","hex":"#f8f6e6","rgb":{"r":248,"g":246,"b":230},"luminance":164.43218999940368},{"name":"Flickering Gold","hex":"#c6a668","rgb":{"r":198,"g":166,"b":104},"luminance":114.63151793464134},{"name":"Flickering Light","hex":"#fff1dc","rgb":{"r":255,"g":241,"b":220},"luminance":162.6506025626711},{"name":"Flickery C64","hex":"#4f81ff","rgb":{"r":79,"g":129,"b":255},"luminance":84.48070353636977},{"name":"Flickery CRT Green","hex":"#90f215","rgb":{"r":144,"g":242,"b":21},"luminance":148.45500762183806},{"name":"Flickr Blue","hex":"#216bd6","rgb":{"r":33,"g":107,"b":214},"luminance":68.0991408609536},{"name":"Flickr Pink","hex":"#fb0081","rgb":{"r":251,"g":0,"b":129},"luminance":76.47626322591866},{"name":"Flier Lie","hex":"#cdb891","rgb":{"r":205,"g":184,"b":145},"luminance":125.28386164626312},{"name":"Flight Time","hex":"#a3b8ce","rgb":{"r":163,"g":184,"b":206},"luminance":120.79950947334181},{"name":"Flinders Green","hex":"#6d7058","rgb":{"r":109,"g":112,"b":88},"luminance":74.06137887590265},{"name":"Fling Green","hex":"#8ecfd0","rgb":{"r":142,"g":207,"b":208},"luminance":130.87924888613932},{"name":"Flint","hex":"#716e61","rgb":{"r":113,"g":110,"b":97},"luminance":73.70973906479387},{"name":"Flint Corn Red","hex":"#d9623b","rgb":{"r":217,"g":98,"b":59},"luminance":86.972889114942},{"name":"Flint Grey","hex":"#a09c98","rgb":{"r":160,"g":156,"b":152},"luminance":104.75856226581193},{"name":"Flint Purple","hex":"#42424d","rgb":{"r":66,"g":66,"b":77},"luminance":44.355682882805446},{"name":"Flint Rock","hex":"#989493","rgb":{"r":152,"g":148,"b":147},"luminance":99.46753562846523},{"name":"Flintstone","hex":"#677283","rgb":{"r":103,"g":114,"b":131},"luminance":75.16314448584491},{"name":"Flip","hex":"#45747e","rgb":{"r":69,"g":116,"b":126},"luminance":72.5843173213057},{"name":"Flip-Flop","hex":"#f2c4a7","rgb":{"r":242,"g":196,"b":167},"luminance":137.24098626867996},{"name":"Flipper","hex":"#7f726b","rgb":{"r":127,"g":114,"b":107},"luminance":77.90223781766477},{"name":"Flirt","hex":"#7a2e4d","rgb":{"r":122,"g":46,"b":77},"luminance":46.22559650237085},{"name":"Flirtatious","hex":"#ffd637","rgb":{"r":255,"g":214,"b":55},"luminance":147.07989274200602},{"name":"Flirtatious Indigo Tea","hex":"#473f2d","rgb":{"r":71,"g":63,"b":45},"luminance":42.94859371388078},{"name":"Floating Feather","hex":"#e9d8c2","rgb":{"r":233,"g":216,"b":194},"luminance":146.3516983468248},{"name":"Floating Lily Pad","hex":"#ccc7a1","rgb":{"r":204,"g":199,"b":161},"luminance":133.05133708835848},{"name":"Flood","hex":"#6677bb","rgb":{"r":102,"g":119,"b":187},"luminance":79.14560466001886},{"name":"Flood Mud","hex":"#877966","rgb":{"r":135,"g":121,"b":102},"luminance":82.51895744615294},{"name":"Flood Out","hex":"#579dab","rgb":{"r":87,"g":157,"b":171},"luminance":97.72396577094075},{"name":"Floppy Disk","hex":"#110044","rgb":{"r":17,"g":0,"b":68},"luminance":9.26986477787028},{"name":"Flora","hex":"#73fa79","rgb":{"r":115,"g":250,"b":121},"luminance":151.35443555112616},{"name":"Floral Bouquet","hex":"#bacb7c","rgb":{"r":186,"g":203,"b":124},"luminance":132.2576554041391},{"name":"Floral Leaf","hex":"#ffb94e","rgb":{"r":255,"g":185,"b":78},"luminance":132.98587035471098},{"name":"Floral Linen","hex":"#f5e2de","rgb":{"r":245,"g":226,"b":222},"luminance":153.64242946855532},{"name":"Floral Tapestry","hex":"#c39191","rgb":{"r":195,"g":145,"b":145},"luminance":104.48577486911795},{"name":"Floral White","hex":"#fffaf0","rgb":{"r":255,"g":250,"b":240},"luminance":167.62288663843012},{"name":"Florence","hex":"#96b576","rgb":{"r":150,"g":181,"b":118},"luminance":116.10729440048115},{"name":"Florentine Lapis","hex":"#1c5798","rgb":{"r":28,"g":87,"b":152},"luminance":54.574652806957914},{"name":"Florida Keys","hex":"#56beab","rgb":{"r":86,"g":190,"b":171},"luminance":116.10412021974068},{"name":"Floriography","hex":"#a54049","rgb":{"r":165,"g":64,"b":73},"luminance":62.56638500824545},{"name":"Floss","hex":"#d7b3b9","rgb":{"r":215,"g":179,"b":185},"luminance":124.97073519028363},{"name":"Flotation","hex":"#7bb0ba","rgb":{"r":123,"g":176,"b":186},"luminance":111.69389727733561},{"name":"Flounce","hex":"#4a8791","rgb":{"r":74,"g":135,"b":145},"luminance":83.92002622139724},{"name":"Flour Sack","hex":"#b9b297","rgb":{"r":185,"g":178,"b":151},"luminance":119.47131545689115},{"name":"Flower Bulb","hex":"#d9e8c9","rgb":{"r":217,"g":232,"b":201},"luminance":152.58091932151936},{"name":"Flower Centre","hex":"#fde6c6","rgb":{"r":253,"g":230,"b":198},"luminance":156.39585638053202},{"name":"Flower Girl","hex":"#f498ad","rgb":{"r":244,"g":152,"b":173},"luminance":116.92928374021623},{"name":"Flower Girl Dress","hex":"#ede7e6","rgb":{"r":237,"g":231,"b":230},"luminance":155.2275735106363},{"name":"Flower Hat Jellyfish","hex":"#f9d593","rgb":{"r":249,"g":213,"b":147},"luminance":146.48048650246898},{"name":"Flower Spell","hex":"#ffc9d7","rgb":{"r":255,"g":201,"b":215},"luminance":142.60074436692116},{"name":"Flower Stem","hex":"#b5d5b0","rgb":{"r":181,"g":213,"b":176},"luminance":137.71049784965558},{"name":"Flowering Cactus","hex":"#a2d4bd","rgb":{"r":162,"g":212,"b":189},"luminance":135.2655872570699},{"name":"Flowering Raspberry","hex":"#a16c94","rgb":{"r":161,"g":108,"b":148},"luminance":81.37002225021202},{"name":"Flowering Reed","hex":"#e1d8b8","rgb":{"r":225,"g":216,"b":184},"luminance":145.059055094813},{"name":"Fluffy Duckling","hex":"#fcdf39","rgb":{"r":252,"g":223,"b":57},"luminance":151.17743518462004},{"name":"Fluffy Pink","hex":"#f7d6cb","rgb":{"r":247,"g":214,"b":203},"luminance":147.54558514913282},{"name":"Fluor Spar","hex":"#a77d35","rgb":{"r":167,"g":125,"b":53},"luminance":88.95898424554993},{"name":"Fluorescence","hex":"#89d178","rgb":{"r":137,"g":209,"b":120},"luminance":130.06240140025093},{"name":"Fluorescent Fire","hex":"#984427","rgb":{"r":152,"g":68,"b":39},"luminance":60.65125452948191},{"name":"Fluorescent Green","hex":"#08ff08","rgb":{"r":8,"g":255,"b":8},"luminance":149.70688906326257},{"name":"Fluorescent Lime","hex":"#bdc233","rgb":{"r":189,"g":194,"b":51},"luminance":127.26152050403924},{"name":"Fluorescent Orange","hex":"#ffcf00","rgb":{"r":255,"g":207,"b":0},"luminance":143.44942351226092},{"name":"Fluorescent Pink","hex":"#fe1493","rgb":{"r":254,"g":20,"b":147},"luminance":78.65400867088721},{"name":"Fluorescent Red","hex":"#ff5555","rgb":{"r":255,"g":85,"b":85},"luminance":91.63354816877931},{"name":"Fluorescent Red Orange","hex":"#fc8427","rgb":{"r":252,"g":132,"b":39},"luminance":108.17050557337707},{"name":"Fluorescent Turquoise","hex":"#00fdff","rgb":{"r":0,"g":253,"b":255},"luminance":151.32938254351004},{"name":"Fluorescent Yellow","hex":"#ccff02","rgb":{"r":204,"g":255,"b":2},"luminance":161.63589708044438},{"name":"Fluorite Green","hex":"#699158","rgb":{"r":105,"g":145,"b":88},"luminance":91.27349162818304},{"name":"Fluoro Green","hex":"#74af54","rgb":{"r":116,"g":175,"b":84},"luminance":108.84440847834122},{"name":"Fluro Green","hex":"#0aff02","rgb":{"r":10,"g":255,"b":2},"luminance":149.71503367731646},{"name":"Flush Mahogany","hex":"#ca2425","rgb":{"r":202,"g":36,"b":37},"luminance":64.12699394170913},{"name":"Flush Orange","hex":"#ff6f01","rgb":{"r":255,"g":111,"b":1},"luminance":100.29330820149467},{"name":"Flushed","hex":"#dd5555","rgb":{"r":221,"g":85,"b":85},"luminance":83.36570857372952},{"name":"Fly a Kite","hex":"#c8daf5","rgb":{"r":200,"g":218,"b":245},"luminance":143.9841034836832},{"name":"Fly Agaric","hex":"#ff2052","rgb":{"r":255,"g":32,"b":82},"luminance":79.07922473696867},{"name":"Flying Carpet","hex":"#787489","rgb":{"r":120,"g":116,"b":137},"luminance":78.5354492442744},{"name":"Flying Fish Blue","hex":"#024aca","rgb":{"r":2,"g":74,"b":202},"luminance":49.16814245016787},{"name":"Foam","hex":"#d0eae8","rgb":{"r":208,"g":234,"b":232},"luminance":153.08351228006237},{"name":"Foam Green","hex":"#90fda9","rgb":{"r":144,"g":253,"b":169},"luminance":155.8220620226802},{"name":"Foaming Surf","hex":"#90d1dd","rgb":{"r":144,"g":209,"b":221},"luminance":132.4374390457623},{"name":"Foamy Milk","hex":"#f7f4f7","rgb":{"r":247,"g":244,"b":247},"luminance":163.58911503214384},{"name":"Focus","hex":"#e5e0d2","rgb":{"r":229,"g":224,"b":210},"luminance":150.16822428529943},{"name":"Focus on Light","hex":"#fef9d3","rgb":{"r":254,"g":249,"b":211},"luminance":166.46324639691488},{"name":"Focus Point","hex":"#91c3bd","rgb":{"r":145,"g":195,"b":189},"luminance":124.28242983624033},{"name":"Fog","hex":"#d6d7d2","rgb":{"r":214,"g":215,"b":210},"luminance":143.5096993969397},{"name":"Fog Beacon","hex":"#d8d6d1","rgb":{"r":216,"g":214,"b":209},"luminance":143.2433358170634},{"name":"Fog Green","hex":"#c2cbb4","rgb":{"r":194,"g":203,"b":180},"luminance":134.10857674660483},{"name":"Fog of War","hex":"#112233","rgb":{"r":17,"g":34,"b":51},"luminance":21.40002918222309},{"name":"Foggy Day","hex":"#e7e3db","rgb":{"r":231,"g":227,"b":219},"luminance":152.14836153570633},{"name":"Foggy Dew","hex":"#d1d5d0","rgb":{"r":209,"g":213,"b":208},"luminance":141.7749448456955},{"name":"Foggy Grey","hex":"#a7a69d","rgb":{"r":167,"g":166,"b":157},"luminance":110.94406814697214},{"name":"Foggy Heath","hex":"#e2c9ff","rgb":{"r":226,"g":201,"b":255},"luminance":139.0404349281172},{"name":"Foggy London","hex":"#5c5658","rgb":{"r":92,"g":86,"b":88},"luminance":58.35891887278242},{"name":"Foggy Love","hex":"#d5c7e8","rgb":{"r":213,"g":199,"b":232},"luminance":135.649576637747},{"name":"Foggy Night","hex":"#a79c8e","rgb":{"r":167,"g":156,"b":142},"luminance":105.54992665558795},{"name":"Foggy Quartz","hex":"#bfa2a1","rgb":{"r":191,"g":162,"b":161},"luminance":112.43298463084577},{"name":"Fogtown","hex":"#eef0e7","rgb":{"r":238,"g":240,"b":231},"luminance":160.0146374554528},{"name":"Foil","hex":"#c0c3c4","rgb":{"r":192,"g":195,"b":196},"luminance":129.98911117859063},{"name":"Foille","hex":"#b0b99c","rgb":{"r":176,"g":185,"b":156},"luminance":121.97717022869485},{"name":"Foliage","hex":"#95b388","rgb":{"r":149,"g":179,"b":136},"luminance":115.17595645793438},{"name":"Foliage Green","hex":"#3e6f58","rgb":{"r":62,"g":111,"b":88},"luminance":68.48162612701307},{"name":"Folk Tales","hex":"#a5c1b6","rgb":{"r":165,"g":193,"b":182},"luminance":125.29673742759626},{"name":"Folklore","hex":"#684141","rgb":{"r":104,"g":65,"b":65},"luminance":49.77623269191834},{"name":"Folkstone Grey","hex":"#626879","rgb":{"r":98,"g":104,"b":121},"luminance":69.10672864490114},{"name":"Follow the Leader","hex":"#f7e5d0","rgb":{"r":247,"g":229,"b":208},"luminance":155.19686685626098},{"name":"Folly","hex":"#fd004d","rgb":{"r":253,"g":0,"b":77},"luminance":76.15459206771446},{"name":"Fond de Teint","hex":"#ffaaaa","rgb":{"r":255,"g":170,"b":170},"luminance":127.07056514000399},{"name":"Fond Memory","hex":"#c8bcb7","rgb":{"r":200,"g":188,"b":183},"luminance":127.23879039035225},{"name":"Fondue Fudge","hex":"#5d4236","rgb":{"r":93,"g":66,"b":54},"luminance":48.083969771640106},{"name":"Fool's Gold","hex":"#cad175","rgb":{"r":202,"g":209,"b":117},"luminance":137.39337370120873},{"name":"Football","hex":"#825736","rgb":{"r":130,"g":87,"b":54},"luminance":64.4733743261511},{"name":"Foothill Drive","hex":"#cab48e","rgb":{"r":202,"g":180,"b":142},"luminance":122.77624097519845},{"name":"Foothills","hex":"#e1cfa5","rgb":{"r":225,"g":207,"b":165},"luminance":140.15769263939814},{"name":"Footie Pajamas","hex":"#e6cee6","rgb":{"r":230,"g":206,"b":230},"luminance":141.55893254754358},{"name":"For the Love of Hue","hex":"#457e87","rgb":{"r":69,"g":126,"b":135},"luminance":78.31262800468389},{"name":"Forbidden Blackberry","hex":"#323f75","rgb":{"r":50,"g":63,"b":117},"luminance":42.05947104993119},{"name":"Forbidden Forest","hex":"#215354","rgb":{"r":33,"g":83,"b":84},"luminance":50.62403881556666},{"name":"Forbidden Fruit","hex":"#fe7b7c","rgb":{"r":254,"g":123,"b":124},"luminance":105.73838382063535},{"name":"Forbidden Thrill","hex":"#856363","rgb":{"r":133,"g":99,"b":99},"luminance":71.3155582884969},{"name":"Force of Nature","hex":"#d5ce69","rgb":{"r":213,"g":206,"b":105},"luminance":137.19127141695276},{"name":"Foresight","hex":"#94a8d3","rgb":{"r":148,"g":168,"b":211},"luminance":110.73368898397632},{"name":"Forest","hex":"#0b5509","rgb":{"r":11,"g":85,"b":9},"luminance":50.01381031275261},{"name":"Forest Biome","hex":"#184a45","rgb":{"r":24,"g":74,"b":69},"luminance":44.72391727029285},{"name":"Forest Blues","hex":"#0d4462","rgb":{"r":13,"g":68,"b":98},"luminance":41.631831679617456},{"name":"Forest Bound","hex":"#738f50","rgb":{"r":115,"g":143,"b":80},"luminance":91.16794450902135},{"name":"Forest Canopy","hex":"#969582","rgb":{"r":150,"g":149,"b":130},"luminance":99.40287354498359},{"name":"Forest Fern","hex":"#63b76c","rgb":{"r":99,"g":183,"b":108},"luminance":112.10296956816084},{"name":"Forest Floor","hex":"#555142","rgb":{"r":85,"g":81,"b":66},"luminance":54.43574202672358},{"name":"Forest Frolic","hex":"#88bb95","rgb":{"r":136,"g":187,"b":149},"luminance":118.28490374092546},{"name":"Forest Fruit Pink","hex":"#68393b","rgb":{"r":104,"g":57,"b":59},"luminance":46.1703906524517},{"name":"Forest Green","hex":"#154406","rgb":{"r":21,"g":68,"b":6},"luminance":40.41263110711798},{"name":"Forest Lichen","hex":"#9aa22b","rgb":{"r":154,"g":162,"b":43},"luminance":105.76924201297842},{"name":"Forest Maid","hex":"#52b963","rgb":{"r":82,"g":185,"b":99},"luminance":111.89897293988001},{"name":"Forest Night","hex":"#434237","rgb":{"r":67,"g":66,"b":55},"luminance":44.063324352572394},{"name":"Forest Path","hex":"#708d6c","rgb":{"r":112,"g":141,"b":108},"luminance":90.12994938975612},{"name":"Forest Ride","hex":"#006800","rgb":{"r":0,"g":104,"b":0},"luminance":61.047999999999995},{"name":"Forest Shade","hex":"#91ac80","rgb":{"r":145,"g":172,"b":128},"luminance":110.84363664640384},{"name":"Forest Spirit","hex":"#667028","rgb":{"r":102,"g":112,"b":40},"luminance":72.6167690000044},{"name":"Forest Splendor","hex":"#016e61","rgb":{"r":1,"g":110,"b":97},"luminance":65.51071412372177},{"name":"Forest Tapestry","hex":"#a4ba8a","rgb":{"r":164,"g":186,"b":138},"luminance":120.71758050921994},{"name":"Forest Tent","hex":"#bba748","rgb":{"r":187,"g":167,"b":72},"luminance":113.1517550637196},{"name":"Forester","hex":"#9aa77c","rgb":{"r":154,"g":167,"b":124},"luminance":109.22337411470129},{"name":"Forever Blue","hex":"#899bb8","rgb":{"r":137,"g":155,"b":184},"luminance":101.96190548435234},{"name":"Forever Fairytale","hex":"#d2bbb2","rgb":{"r":210,"g":187,"b":178},"luminance":128.07647217580597},{"name":"Forever Faithful","hex":"#efe6e1","rgb":{"r":239,"g":230,"b":225},"luminance":154.89447091810604},{"name":"Forged Iron","hex":"#48464a","rgb":{"r":72,"g":70,"b":74},"luminance":47.14879616702848},{"name":"Forget Me Not","hex":"#8fadbd","rgb":{"r":143,"g":173,"b":189},"luminance":112.27197676179037},{"name":"Forget-Me-Not","hex":"#0087bd","rgb":{"r":0,"g":135,"b":189},"luminance":82.12186152907152},{"name":"Forgive Quickly","hex":"#e1e1be","rgb":{"r":225,"g":225,"b":190},"luminance":149.79615098526395},{"name":"Forgotten Blue","hex":"#c0e5ec","rgb":{"r":192,"g":229,"b":236},"luminance":148.6238426666462},{"name":"Forgotten Gold","hex":"#c7b89f","rgb":{"r":199,"g":184,"b":159},"luminance":124.6380717959003},{"name":"Forgotten Mosque","hex":"#e2d9db","rgb":{"r":226,"g":217,"b":219},"luminance":146.33849894337442},{"name":"Forgotten Pink","hex":"#ffd9d6","rgb":{"r":255,"g":217,"b":214},"luminance":150.4455864490547},{"name":"Forgotten Purple","hex":"#9878f8","rgb":{"r":152,"g":120,"b":248},"luminance":88.4681879999811},{"name":"Forgotten Sunset","hex":"#fdd5b1","rgb":{"r":253,"g":213,"b":177},"luminance":147.5207485542288},{"name":"Formal Grey","hex":"#97969a","rgb":{"r":151,"g":150,"b":154},"luminance":100.49600906006168},{"name":"Forsythia Blossom","hex":"#f6d76e","rgb":{"r":246,"g":215,"b":110},"luminance":146.61222507349106},{"name":"Forsythia Bud","hex":"#bbcc55","rgb":{"r":187,"g":204,"b":85},"luminance":132.51318112927484},{"name":"Fortress Grey","hex":"#b8b8b8","rgb":{"r":184,"g":184,"b":184},"luminance":123.01414916992272},{"name":"Fortune Cookie","hex":"#e0c5a1","rgb":{"r":224,"g":197,"b":161},"luminance":134.88896253215086},{"name":"Fossil","hex":"#806f63","rgb":{"r":128,"g":111,"b":99},"luminance":76.40389014310725},{"name":"Fossil Green","hex":"#6c6a43","rgb":{"r":108,"g":106,"b":67},"luminance":70.51729994831055},{"name":"Fossil Sand","hex":"#d2c8bb","rgb":{"r":210,"g":200,"b":187},"luminance":134.83249320545846},{"name":"Fossil Stone","hex":"#e3ddcc","rgb":{"r":227,"g":221,"b":204},"luminance":148.24533784912092},{"name":"Fossilized Leaf","hex":"#756a43","rgb":{"r":117,"g":106,"b":67},"luminance":71.78946034760256},{"name":"Foul Green","hex":"#85c7a1","rgb":{"r":133,"g":199,"b":161},"luminance":124.75400023245747},{"name":"Foundation","hex":"#f8e8c5","rgb":{"r":248,"g":232,"b":197},"luminance":156.6810860442319},{"name":"Foundation White","hex":"#efeeff","rgb":{"r":239,"g":238,"b":255},"luminance":159.5916847990521},{"name":"Fountain Blue","hex":"#65adb2","rgb":{"r":101,"g":173,"b":178},"luminance":107.87191694783215},{"name":"Fountain City","hex":"#9cd4cf","rgb":{"r":156,"g":212,"b":207},"luminance":134.9771739072944},{"name":"Fountain Frolic","hex":"#e4e4c5","rgb":{"r":228,"g":228,"b":197},"luminance":151.8678973450281},{"name":"Fountains of Budapest","hex":"#b9def0","rgb":{"r":185,"g":222,"b":240},"luminance":144.18757720760829},{"name":"Four Leaf Clover","hex":"#738f5d","rgb":{"r":115,"g":143,"b":93},"luminance":91.32810142557436},{"name":"Fox","hex":"#c38743","rgb":{"r":195,"g":135,"b":67},"luminance":98.67918774493434},{"name":"Fox Tails","hex":"#dd8800","rgb":{"r":221,"g":136,"b":0},"luminance":103.63195677492536},{"name":"Foxfire Brown","hex":"#9f6949","rgb":{"r":159,"g":105,"b":73},"luminance":78.28330339223045},{"name":"Foxglove","hex":"#b98391","rgb":{"r":185,"g":131,"b":145},"luminance":96.15684444697632},{"name":"Foxtail","hex":"#bc896e","rgb":{"r":188,"g":137,"b":110},"luminance":98.91539872537541},{"name":"Foxy Fuchsia","hex":"#9f00c5","rgb":{"r":159,"g":0,"b":197},"luminance":52.5785930298634},{"name":"Foxy Lady","hex":"#d5a6ad","rgb":{"r":213,"g":166,"b":173},"luminance":118.06750025726808},{"name":"Fozzie Bear","hex":"#70625c","rgb":{"r":112,"g":98,"b":92},"luminance":67.38460479961279},{"name":"Fragile","hex":"#bbb8d0","rgb":{"r":187,"g":184,"b":208},"luminance":123.91226967899506},{"name":"Fragile Fern","hex":"#eff2db","rgb":{"r":239,"g":242,"b":219},"luminance":160.9637058252574},{"name":"Fragrant Cloves","hex":"#ac5e3a","rgb":{"r":172,"g":94,"b":58},"luminance":75.71769550111783},{"name":"Fragrant Lilac","hex":"#ceadbe","rgb":{"r":206,"g":173,"b":190},"luminance":120.72937520338617},{"name":"Fragrant Satchel","hex":"#a99fba","rgb":{"r":169,"g":159,"b":186},"luminance":108.23142088136883},{"name":"Fragrant Wand","hex":"#adb1c1","rgb":{"r":173,"g":177,"b":193},"luminance":118.13032097645379},{"name":"Framboise","hex":"#e40058","rgb":{"r":228,"g":0,"b":88},"luminance":68.90618700813447},{"name":"Frangipani","hex":"#ffd7a0","rgb":{"r":255,"g":215,"b":160},"luminance":148.57220349042413},{"name":"Frank Lloyd White","hex":"#efebdb","rgb":{"r":239,"g":235,"b":219},"luminance":157.3492888512687},{"name":"Frankenstein","hex":"#7ba05b","rgb":{"r":123,"g":160,"b":91},"luminance":101.39592696454822},{"name":"Frankly Earnest","hex":"#e2dbca","rgb":{"r":226,"g":219,"b":202},"luminance":147.04559860465054},{"name":"Frappe","hex":"#d1b7a0","rgb":{"r":209,"g":183,"b":160},"luminance":125.60690236607222},{"name":"Freckles","hex":"#d78775","rgb":{"r":215,"g":135,"b":117},"luminance":102.90886013361532},{"name":"Free Reign","hex":"#d1cdca","rgb":{"r":209,"g":205,"b":202},"luminance":137.53518128100896},{"name":"Free Speech Aquamarine","hex":"#029d74","rgb":{"r":2,"g":157,"b":116},"luminance":93.10484982534474},{"name":"Free Speech Blue","hex":"#4156c5","rgb":{"r":65,"g":86,"b":197},"luminance":58.57058402474744},{"name":"Free Speech Green","hex":"#09f911","rgb":{"r":9,"g":249,"b":17},"luminance":146.20061523126364},{"name":"Free Speech Magenta","hex":"#e35bd8","rgb":{"r":227,"g":91,"b":216},"luminance":89.81348113729919},{"name":"Free Speech Red","hex":"#c00000","rgb":{"r":192,"g":0,"b":0},"luminance":57.408},{"name":"Free Spirit","hex":"#deeeed","rgb":{"r":222,"g":238,"b":237},"luminance":157.01521468953254},{"name":"Freedom","hex":"#3b5e68","rgb":{"r":59,"g":94,"b":104},"luminance":59.130206333142446},{"name":"Freedom Found","hex":"#657682","rgb":{"r":101,"g":118,"b":130},"luminance":77.00253734131103},{"name":"Freefall","hex":"#565266","rgb":{"r":86,"g":82,"b":102},"luminance":55.79697246267041},{"name":"Freesia","hex":"#f3c12c","rgb":{"r":243,"g":193,"b":44},"luminance":134.6812926356144},{"name":"Freinacht Black","hex":"#232f36","rgb":{"r":35,"g":47,"b":54},"luminance":30.142419975841353},{"name":"French 75","hex":"#f9f3d5","rgb":{"r":249,"g":243,"b":213},"luminance":162.7237591933028},{"name":"French Beige","hex":"#a67b50","rgb":{"r":166,"g":123,"b":80},"luminance":88.08911826667355},{"name":"French Bistre","hex":"#856d4d","rgb":{"r":133,"g":109,"b":77},"luminance":75.84386502545871},{"name":"French Blue","hex":"#0072bb","rgb":{"r":0,"g":114,"b":187},"luminance":70.2315872524607},{"name":"French Bustle","hex":"#f2d5d4","rgb":{"r":242,"g":213,"b":212},"luminance":146.46679947687804},{"name":"French Diamond","hex":"#597191","rgb":{"r":89,"g":113,"b":145},"luminance":73.35657967762674},{"name":"French Fuchsia","hex":"#fd3f92","rgb":{"r":253,"g":63,"b":146},"luminance":85.83172901672201},{"name":"French Grey","hex":"#bfbdc1","rgb":{"r":191,"g":189,"b":193},"luminance":126.70388760412996},{"name":"French Grey Linen","hex":"#cac8b6","rgb":{"r":202,"g":200,"b":182},"luminance":133.64564305655458},{"name":"French Lilac","hex":"#deb7d9","rgb":{"r":222,"g":183,"b":217},"luminance":128.6750899319678},{"name":"French Lilac Blue","hex":"#adbae3","rgb":{"r":173,"g":186,"b":227},"luminance":123.55590854750733},{"name":"French Lime","hex":"#c0ff00","rgb":{"r":192,"g":255,"b":0},"luminance":160.31618037178905},{"name":"French Limestone","hex":"#c9d6c2","rgb":{"r":201,"g":214,"b":194},"luminance":140.99960702427506},{"name":"French Manicure","hex":"#fee6dc","rgb":{"r":254,"g":230,"b":220},"luminance":156.9219596359923},{"name":"French Market","hex":"#a2c7a3","rgb":{"r":162,"g":199,"b":163},"luminance":127.81552150267196},{"name":"French Mauve","hex":"#d473d4","rgb":{"r":212,"g":115,"b":212},"luminance":95.70295603062634},{"name":"French Mirage Blue","hex":"#446688","rgb":{"r":68,"g":102,"b":136},"luminance":65.10499301896898},{"name":"French Oak","hex":"#bb9e7c","rgb":{"r":187,"g":158,"b":124},"luminance":109.2149741610554},{"name":"French Pass","hex":"#a4d2e0","rgb":{"r":164,"g":210,"b":224},"luminance":135.1003682156344},{"name":"French Pink","hex":"#fd6c9e","rgb":{"r":253,"g":108,"b":158},"luminance":100.32922589654521},{"name":"French Plum","hex":"#811453","rgb":{"r":129,"g":20,"b":83},"luminance":41.413513313893084},{"name":"French Porcelain","hex":"#f6f4f6","rgb":{"r":246,"g":244,"b":246},"luminance":163.43474794547208},{"name":"French Porcelain Clay","hex":"#faf1d7","rgb":{"r":250,"g":241,"b":215},"luminance":161.86789270574937},{"name":"French Puce","hex":"#4e1609","rgb":{"r":78,"g":22,"b":9},"luminance":26.67845115444298},{"name":"French Raspberry","hex":"#c72c48","rgb":{"r":199,"g":44,"b":72},"luminance":65.38215237356445},{"name":"French Roast","hex":"#58423f","rgb":{"r":88,"g":66,"b":63},"luminance":47.379795609521146},{"name":"French Rose","hex":"#f64a8a","rgb":{"r":246,"g":74,"b":138},"luminance":86.8593494334375},{"name":"French Sky Blue","hex":"#77b5fe","rgb":{"r":119,"g":181,"b":254},"luminance":115.72762205281849},{"name":"French Toast","hex":"#dd8822","rgb":{"r":221,"g":136,"b":34},"luminance":103.7044157256575},{"name":"French Vanilla","hex":"#efe1a7","rgb":{"r":239,"g":225,"b":167},"luminance":151.37016083099073},{"name":"French Vanilla Sorbet","hex":"#fbe8ce","rgb":{"r":251,"g":232,"b":206},"luminance":157.25753563184182},{"name":"French Violet","hex":"#8806ce","rgb":{"r":136,"g":6,"b":206},"luminance":47.08995260137772},{"name":"French White","hex":"#f1e7db","rgb":{"r":241,"g":231,"b":219},"luminance":155.57103536969854},{"name":"French Wine","hex":"#ac1e44","rgb":{"r":172,"g":30,"b":68},"luminance":54.90942348996208},{"name":"Fresco","hex":"#f4dbd9","rgb":{"r":244,"g":219,"b":217},"luminance":149.868009892038},{"name":"Fresco Blue","hex":"#034c67","rgb":{"r":3,"g":76,"b":103},"luminance":46.1401096335932},{"name":"Fresco Green","hex":"#7bd9ad","rgb":{"r":123,"g":217,"b":173},"luminance":134.0407201338459},{"name":"Fresh Acorn","hex":"#d2693e","rgb":{"r":210,"g":105,"b":62},"luminance":88.26898633721812},{"name":"Fresh Air","hex":"#a6e7ff","rgb":{"r":166,"g":231,"b":255},"luminance":147.29271966054532},{"name":"Fresh Apricot","hex":"#ffd7a5","rgb":{"r":255,"g":215,"b":165},"luminance":148.64325800385296},{"name":"Fresh Artichoke","hex":"#7c8447","rgb":{"r":124,"g":132,"b":71},"luminance":86.27811349351583},{"name":"Fresh Auburn","hex":"#a52a24","rgb":{"r":165,"g":42,"b":36},"luminance":55.30465402658261},{"name":"Fresh Baked Bread","hex":"#f8d7be","rgb":{"r":248,"g":215,"b":190},"luminance":147.97086445986588},{"name":"Fresh Basil","hex":"#5c5f4b","rgb":{"r":92,"g":95,"b":75},"luminance":62.76565771980725},{"name":"Fresh Blue of Bel Air","hex":"#069af3","rgb":{"r":6,"g":154,"b":243},"luminance":94.56435715426822},{"name":"Fresh Breeze","hex":"#beeddc","rgb":{"r":190,"g":237,"b":220},"luminance":152.3498561239885},{"name":"Fresh Cantaloupe","hex":"#ff9c68","rgb":{"r":255,"g":156,"b":104},"luminance":119.74679931004418},{"name":"Fresh Cinnamon","hex":"#995511","rgb":{"r":153,"g":85,"b":17},"luminance":67.72041699517214},{"name":"Fresh Clay","hex":"#be8035","rgb":{"r":190,"g":128,"b":53},"luminance":94.38909025941504},{"name":"Fresh Cut","hex":"#f2003c","rgb":{"r":242,"g":0,"b":60},"luminance":72.68057349801252},{"name":"Fresh Cut Grass","hex":"#91cb7d","rgb":{"r":145,"g":203,"b":125},"luminance":127.60118512772519},{"name":"Fresh Dough","hex":"#f2ebe6","rgb":{"r":242,"g":235,"b":230},"luminance":157.96199412833454},{"name":"Fresh Eggplant","hex":"#4f467e","rgb":{"r":79,"g":70,"b":126},"luminance":49.52438022832795},{"name":"Fresh Eggs","hex":"#faf4ce","rgb":{"r":250,"g":244,"b":206},"luminance":163.25844768342003},{"name":"Fresh Frappe","hex":"#dbe69d","rgb":{"r":219,"g":230,"b":157},"luminance":151.11518740682553},{"name":"Fresh Gingerbread","hex":"#d3691f","rgb":{"r":211,"g":105,"b":31},"luminance":88.26995129714301},{"name":"Fresh Granny Smith","hex":"#7ff217","rgb":{"r":127,"g":242,"b":23},"luminance":147.0651642266108},{"name":"Fresh Green","hex":"#69d84f","rgb":{"r":105,"g":216,"b":79},"luminance":130.93114726832573},{"name":"Fresh Grown","hex":"#f0f7c4","rgb":{"r":240,"g":247,"b":196},"luminance":163.31124289833815},{"name":"Fresh Gum","hex":"#ffaadd","rgb":{"r":255,"g":170,"b":221},"luminance":128.08622783500184},{"name":"Fresh Herb","hex":"#77913b","rgb":{"r":119,"g":145,"b":59},"luminance":92.49762084507903},{"name":"Fresh Honeydew","hex":"#f6efc5","rgb":{"r":246,"g":239,"b":197},"luminance":159.98962006642805},{"name":"Fresh Lavender","hex":"#8e90b4","rgb":{"r":142,"g":144,"b":180},"luminance":96.79222565888233},{"name":"Fresh Lawn","hex":"#88aa00","rgb":{"r":136,"g":170,"b":0},"luminance":107.75715751633392},{"name":"Fresh Leaf","hex":"#93ef10","rgb":{"r":147,"g":239,"b":16},"luminance":147.0282933111855},{"name":"Fresh Lemonade","hex":"#ece678","rgb":{"r":236,"g":230,"b":120},"luminance":152.95136676734862},{"name":"Fresh Lettuce","hex":"#b2d58c","rgb":{"r":178,"g":213,"b":140},"luminance":136.8212477833761},{"name":"Fresh Lime","hex":"#d8f1cb","rgb":{"r":216,"g":241,"b":203},"luminance":157.2245442321268},{"name":"Fresh Linen","hex":"#ebe8da","rgb":{"r":235,"g":232,"b":218},"luminance":155.24456185322563},{"name":"Fresh Mint","hex":"#2a5443","rgb":{"r":42,"g":84,"b":67},"luminance":51.452126020214166},{"name":"Fresh Neon Pink","hex":"#ff11ff","rgb":{"r":255,"g":17,"b":255},"luminance":82.20672336250848},{"name":"Fresh Onion","hex":"#5b8930","rgb":{"r":91,"g":137,"b":48},"luminance":85.07342726139578},{"name":"Fresh Oregano","hex":"#4faa6c","rgb":{"r":79,"g":170,"b":108},"luminance":103.283982712713},{"name":"Fresh Piglet","hex":"#fddde6","rgb":{"r":253,"g":221,"b":230},"luminance":152.44360117105603},{"name":"Fresh Pineapple","hex":"#f3d64f","rgb":{"r":243,"g":214,"b":79},"luminance":145.39611277128424},{"name":"Fresh Pink Lemonade","hex":"#d2adb5","rgb":{"r":210,"g":173,"b":181},"luminance":121.16497702306553},{"name":"Fresh Salmon","hex":"#ff7f6a","rgb":{"r":255,"g":127,"b":106},"luminance":107.31671110316417},{"name":"Fresh Snow","hex":"#f6efe1","rgb":{"r":246,"g":239,"b":225},"luminance":160.46881087924842},{"name":"Fresh Sod","hex":"#91a085","rgb":{"r":145,"g":160,"b":133},"luminance":104.54907301836778},{"name":"Fresh Squeezed","hex":"#ffad00","rgb":{"r":255,"g":173,"b":0},"luminance":126.98781684082925},{"name":"Fresh Straw","hex":"#eecc66","rgb":{"r":238,"g":204,"b":102},"luminance":139.7813440055575},{"name":"Fresh Thyme","hex":"#aebda8","rgb":{"r":174,"g":189,"b":168},"luminance":124.02359867783227},{"name":"Fresh Turquoise","hex":"#40e0d0","rgb":{"r":64,"g":224,"b":208},"luminance":134.9723660013412},{"name":"Fresh Up","hex":"#dfebb1","rgb":{"r":223,"g":235,"b":177},"luminance":154.5373645368653},{"name":"Fresh Water","hex":"#c6e3f7","rgb":{"r":198,"g":227,"b":247},"luminance":148.50267933273122},{"name":"Fresh Wood Ashes","hex":"#eae6cc","rgb":{"r":234,"g":230,"b":204},"luminance":153.8303701874243},{"name":"Freshly Roasted Coffee","hex":"#663322","rgb":{"r":102,"g":51,"b":34},"luminance":42.91124967884296},{"name":"Freshman","hex":"#e6f2c4","rgb":{"r":230,"g":242,"b":196},"luminance":159.39857638009192},{"name":"Freshmint","hex":"#d9f4ea","rgb":{"r":217,"g":244,"b":234},"luminance":159.48565029180523},{"name":"Friar Brown","hex":"#6e493a","rgb":{"r":110,"g":73,"b":58},"luminance":54.4213087402352},{"name":"Friar Grey","hex":"#807e79","rgb":{"r":128,"g":126,"b":121},"luminance":84.41207179071012},{"name":"Friar Tuck","hex":"#ddb994","rgb":{"r":221,"g":185,"b":148},"luminance":128.2340541743885},{"name":"Friar's Brown","hex":"#5e5241","rgb":{"r":94,"g":82,"b":65},"luminance":56.229327685826014},{"name":"Friend Flesh","hex":"#f1a4b7","rgb":{"r":241,"g":164,"b":183},"luminance":122.04609927810066},{"name":"Friendly Basilisk","hex":"#e2f5e1","rgb":{"r":226,"g":245,"b":225},"luminance":160.95627418960717},{"name":"Friendly Homestead","hex":"#c8a992","rgb":{"r":200,"g":169,"b":146},"luminance":117.02263860040073},{"name":"Friends","hex":"#e8c5c1","rgb":{"r":232,"g":197,"b":193},"luminance":136.63230126511078},{"name":"Fright Night","hex":"#004499","rgb":{"r":0,"g":68,"b":153},"luminance":43.56042263339509},{"name":"Frilled Shark","hex":"#939fa9","rgb":{"r":147,"g":159,"b":169},"luminance":104.94805312153245},{"name":"Frills","hex":"#8fa6c1","rgb":{"r":143,"g":166,"b":193},"luminance":108.66090565148073},{"name":"Fringy Flower","hex":"#b4e1bb","rgb":{"r":180,"g":225,"b":187},"luminance":144.20421335384066},{"name":"Frisky","hex":"#ccdda1","rgb":{"r":204,"g":221,"b":161},"luminance":144.52154116601443},{"name":"Frivolous Folly","hex":"#cfd2c7","rgb":{"r":207,"g":210,"b":199},"luminance":139.78873683169184},{"name":"Frog Green","hex":"#58bc08","rgb":{"r":88,"g":188,"b":8},"luminance":113.45307322413085},{"name":"Frog Hollow","hex":"#7da270","rgb":{"r":125,"g":162,"b":112},"luminance":102.96980763796735},{"name":"Frog Prince","hex":"#bbd75a","rgb":{"r":187,"g":215,"b":90},"luminance":138.41688189668193},{"name":"Frog's Legs","hex":"#8c8449","rgb":{"r":140,"g":132,"b":73},"luminance":88.46064401755166},{"name":"Frogger","hex":"#8cd612","rgb":{"r":140,"g":214,"b":18},"luminance":132.42489278077593},{"name":"Froly","hex":"#e56d75","rgb":{"r":229,"g":109,"b":117},"luminance":94.65729963399548},{"name":"Frond","hex":"#7b7f56","rgb":{"r":123,"g":127,"b":86},"luminance":83.7031632974525},{"name":"Frontier","hex":"#314a49","rgb":{"r":49,"g":74,"b":73},"luminance":46.591494170073574},{"name":"Frontier Fort","hex":"#c3b19f","rgb":{"r":195,"g":177,"b":159},"luminance":120.51152269389014},{"name":"Frontier Land","hex":"#bca59a","rgb":{"r":188,"g":165,"b":154},"luminance":113.35295807785519},{"name":"Frontier Shingle","hex":"#7b5f46","rgb":{"r":123,"g":95,"b":70},"luminance":67.2752804081856},{"name":"Frost","hex":"#e1e4c5","rgb":{"r":225,"g":228,"b":197},"luminance":151.46736376196688},{"name":"Frost Grey","hex":"#848283","rgb":{"r":132,"g":130,"b":131},"luminance":87.20070802464852},{"name":"Frost Gum","hex":"#8ecb9e","rgb":{"r":142,"g":203,"b":158},"luminance":127.77502819017492},{"name":"Frostbite","hex":"#acfffc","rgb":{"r":172,"g":255,"b":252},"luminance":160.8593683718794},{"name":"Frosted Almond","hex":"#d2c2ac","rgb":{"r":210,"g":194,"b":172},"luminance":131.51143162478309},{"name":"Frosted Garden","hex":"#e2f7d9","rgb":{"r":226,"g":247,"b":217},"luminance":161.86421544306822},{"name":"Frosted Glass","hex":"#eaf0f0","rgb":{"r":234,"g":240,"b":240},"luminance":159.6589651601187},{"name":"Frosted Grape","hex":"#d4c4d2","rgb":{"r":212,"g":196,"b":210},"luminance":133.52200136307124},{"name":"Frosted Iris","hex":"#b1b9d9","rgb":{"r":177,"g":185,"b":217},"luminance":123.31134010300919},{"name":"Frosted Lilac","hex":"#d3d1dc","rgb":{"r":211,"g":209,"b":220},"luminance":140.21535868085206},{"name":"Frosted Mint","hex":"#e2f2e4","rgb":{"r":226,"g":242,"b":228},"luminance":159.44017202700203},{"name":"Frosted Sugar","hex":"#d5bcc2","rgb":{"r":213,"g":188,"b":194},"luminance":129.3197516275066},{"name":"Frosted Tulip","hex":"#f6d8d7","rgb":{"r":246,"g":216,"b":215},"luminance":148.61743598918667},{"name":"Frostee","hex":"#dbe5d2","rgb":{"r":219,"g":229,"b":210},"luminance":151.42796270834523},{"name":"Frosting Cream","hex":"#fffbee","rgb":{"r":255,"g":251,"b":238},"luminance":168.10008036286},{"name":"Frostproof","hex":"#d1f0f6","rgb":{"r":209,"g":240,"b":246},"luminance":156.6485410624689},{"name":"Frosty Dawn","hex":"#cbe9c9","rgb":{"r":203,"g":233,"b":201},"luminance":151.37861026578358},{"name":"Frosty Day","hex":"#ccebf5","rgb":{"r":204,"g":235,"b":245},"luminance":153.39302442092992},{"name":"Frosty Fog","hex":"#dee1e9","rgb":{"r":222,"g":225,"b":233},"luminance":150.18450104121928},{"name":"Frosty Glade","hex":"#a0c0bf","rgb":{"r":160,"g":192,"b":191},"luminance":124.35820958826964},{"name":"Frosty Green","hex":"#a3b5a6","rgb":{"r":163,"g":181,"b":166},"luminance":118.4138419020344},{"name":"Frosty Mint","hex":"#e2f7f1","rgb":{"r":226,"g":247,"b":241},"luminance":162.30488678102085},{"name":"Frosty Pine","hex":"#c7cfbe","rgb":{"r":199,"g":207,"b":190},"luminance":137.01810713186777},{"name":"Frosty Spruce","hex":"#578270","rgb":{"r":87,"g":130,"b":112},"luminance":81.62667513135642},{"name":"Froth","hex":"#c6b8ae","rgb":{"r":198,"g":184,"b":174},"luminance":124.75604900765333},{"name":"Frozen Blue","hex":"#a5c5d9","rgb":{"r":165,"g":197,"b":217},"luminance":128.1338721416004},{"name":"Frozen Civilization","hex":"#e1f5e5","rgb":{"r":225,"g":245,"b":229},"luminance":160.90432898464852},{"name":"Frozen Custard","hex":"#fbeabd","rgb":{"r":251,"g":234,"b":189},"luminance":157.99937557155093},{"name":"Frozen Dew","hex":"#d8cfb2","rgb":{"r":216,"g":207,"b":178},"luminance":139.09455561236032},{"name":"Frozen Edamame","hex":"#9ca48a","rgb":{"r":156,"g":164,"b":138},"luminance":108.12347748754662},{"name":"Frozen Forest","hex":"#cfe8b6","rgb":{"r":207,"g":232,"b":182},"luminance":151.02087540800446},{"name":"Frozen Frappe","hex":"#ddc5d2","rgb":{"r":221,"g":197,"b":210},"luminance":135.32160271737843},{"name":"Frozen Grass","hex":"#deeadc","rgb":{"r":222,"g":234,"b":220},"luminance":154.60357514624297},{"name":"Frozen Lake","hex":"#7b9cb3","rgb":{"r":123,"g":156,"b":179},"luminance":100.76896223044076},{"name":"Frozen Mammoth","hex":"#dfd9da","rgb":{"r":223,"g":217,"b":218},"luminance":145.9070041978794},{"name":"Frozen Margarita","hex":"#dbe2cc","rgb":{"r":219,"g":226,"b":204},"luminance":149.7591704737977},{"name":"Frozen Mint","hex":"#d8e8e6","rgb":{"r":216,"g":232,"b":230},"luminance":152.9858271605576},{"name":"Frozen Moss Green","hex":"#addfad","rgb":{"r":173,"g":223,"b":173},"luminance":142.12568949349023},{"name":"Frozen Pea","hex":"#c4ead5","rgb":{"r":196,"g":234,"b":213},"luminance":151.2985938599563},{"name":"Frozen Salmon","hex":"#fea993","rgb":{"r":254,"g":169,"b":147},"luminance":126.05499073420297},{"name":"Frozen State","hex":"#26f7fd","rgb":{"r":38,"g":247,"b":253},"luminance":148.2658629928009},{"name":"Frozen Statues","hex":"#e1dee5","rgb":{"r":225,"g":222,"b":229},"luminance":148.9603553197964},{"name":"Frozen Tundra","hex":"#a3bfcb","rgb":{"r":163,"g":191,"b":203},"luminance":124.42294411401781},{"name":"Frozen Wave","hex":"#56acca","rgb":{"r":86,"g":172,"b":202},"luminance":106.70158328722212},{"name":"Frugal","hex":"#a5d7b2","rgb":{"r":165,"g":215,"b":178},"luminance":137.01609217168615},{"name":"Fruit Dove","hex":"#ce5b78","rgb":{"r":206,"g":91,"b":120},"luminance":82.67006184224128},{"name":"Fruit Of Passion","hex":"#946985","rgb":{"r":148,"g":105,"b":133},"luminance":77.3757001454591},{"name":"Fruit Salad","hex":"#4ba351","rgb":{"r":75,"g":163,"b":81},"luminance":98.70664183326268},{"name":"Fruit Yard","hex":"#604241","rgb":{"r":96,"g":66,"b":65},"luminance":48.7828892133297},{"name":"Fruitless Fig Tree","hex":"#448822","rgb":{"r":68,"g":136,"b":34},"luminance":82.47158191765209},{"name":"Fruity Licious","hex":"#f69092","rgb":{"r":246,"g":144,"b":146},"luminance":113.27928511426968},{"name":"Fuchsia","hex":"#ed0dd9","rgb":{"r":237,"g":13,"b":217},"luminance":75.44379082469278},{"name":"Fuchsia Berries","hex":"#333322","rgb":{"r":51,"g":51,"b":34},"luminance":33.81980700713711},{"name":"Fuchsia Blue","hex":"#7a58c1","rgb":{"r":122,"g":88,"b":193},"luminance":66.9557676679164},{"name":"Fuchsia Blush","hex":"#e47cb8","rgb":{"r":228,"g":124,"b":184},"luminance":101.90930823040651},{"name":"Fuchsia Fever","hex":"#ff5599","rgb":{"r":255,"g":85,"b":153},"luminance":92.77410422095164},{"name":"Fuchsia Flair","hex":"#bb22bb","rgb":{"r":187,"g":34,"b":187},"luminance":63.07965168737062},{"name":"Fuchsia Flash","hex":"#dd55cc","rgb":{"r":221,"g":85,"b":204},"luminance":86.00457430857965},{"name":"Fuchsia Flock","hex":"#ab446b","rgb":{"r":171,"g":68,"b":107},"luminance":66.00191588885886},{"name":"Fuchsia Fluorish","hex":"#bb2299","rgb":{"r":187,"g":34,"b":153},"luminance":61.87736821326518},{"name":"Fúchsia Intenso","hex":"#d800cc","rgb":{"r":216,"g":0,"b":204},"luminance":68.64353277622008},{"name":"Fuchsia Pink","hex":"#ff77ff","rgb":{"r":255,"g":119,"b":255},"luminance":107.41418218280116},{"name":"Fuchsia Purple","hex":"#d33479","rgb":{"r":211,"g":52,"b":121},"luminance":71.42976223535956},{"name":"Fuchsia Red","hex":"#ab3475","rgb":{"r":171,"g":52,"b":117},"luminance":61.02287653822949},{"name":"Fuchsia Rose","hex":"#c74375","rgb":{"r":199,"g":67,"b":117},"luminance":72.56060560662375},{"name":"Fuchsia Tint","hex":"#c255c1","rgb":{"r":194,"g":85,"b":193},"luminance":79.61341008272413},{"name":"Fuchsite","hex":"#c3d9ce","rgb":{"r":195,"g":217,"b":206},"luminance":142.043588105905},{"name":"Fudge","hex":"#493338","rgb":{"r":73,"g":51,"b":56},"luminance":37.595177270495746},{"name":"Fudge Truffle","hex":"#604a3f","rgb":{"r":96,"g":74,"b":63},"luminance":52.55816381876368},{"name":"Fudgesicle","hex":"#d46bac","rgb":{"r":212,"g":107,"b":172},"luminance":91.36455926123651},{"name":"Fuegan Orange","hex":"#c77e4d","rgb":{"r":199,"g":126,"b":77},"luminance":95.32995189865564},{"name":"Fuego","hex":"#c2d62e","rgb":{"r":194,"g":214,"b":46},"luminance":138.46327128881506},{"name":"Fuel Town","hex":"#596472","rgb":{"r":89,"g":100,"b":114},"luminance":65.74748160195948},{"name":"Fuel Yellow","hex":"#d19033","rgb":{"r":209,"g":144,"b":51},"luminance":105.28015226527742},{"name":"Fuji Peak","hex":"#f6eee2","rgb":{"r":246,"g":238,"b":226},"luminance":159.97418869305133},{"name":"Fuji Purple","hex":"#89729e","rgb":{"r":137,"g":114,"b":158},"luminance":80.50104494352853},{"name":"Fujinezumi","hex":"#766980","rgb":{"r":118,"g":105,"b":128},"luminance":72.50254625183864},{"name":"Fulgrim Pink","hex":"#f5b3ce","rgb":{"r":245,"g":179,"b":206},"luminance":130.22337965972162},{"name":"Fulgurite Copper","hex":"#e6b77e","rgb":{"r":230,"g":183,"b":126},"luminance":128.35462062972258},{"name":"Full City Roast","hex":"#662222","rgb":{"r":102,"g":34,"b":34},"luminance":36.65341926751172},{"name":"Full Moon","hex":"#f4f3e0","rgb":{"r":244,"g":243,"b":224},"luminance":162.2378504326287},{"name":"Full Of Life","hex":"#de5f2f","rgb":{"r":222,"g":95,"b":47},"luminance":86.85897923070475},{"name":"Fulvous","hex":"#e48400","rgb":{"r":228,"g":132,"b":0},"luminance":103.20461152487324},{"name":"Fun and Games","hex":"#33789c","rgb":{"r":51,"g":120,"b":156},"luminance":74.23339044527064},{"name":"Fun Blue","hex":"#335083","rgb":{"r":51,"g":80,"b":131},"luminance":51.582923114146986},{"name":"Fun Green","hex":"#15633d","rgb":{"r":21,"g":99,"b":61},"luminance":58.86344133670746},{"name":"Fundy Bay","hex":"#cdd2c9","rgb":{"r":205,"g":210,"b":201},"luminance":139.56224891065634},{"name":"Fungal Hallucinations","hex":"#cc00dd","rgb":{"r":204,"g":0,"b":221},"luminance":65.99431530063782},{"name":"Fungi","hex":"#8f8177","rgb":{"r":143,"g":129,"b":119},"luminance":88.01232944309564},{"name":"Funk","hex":"#3ea380","rgb":{"r":62,"g":163,"b":128},"luminance":98.5466268778389},{"name":"Funki Porcini","hex":"#ee9999","rgb":{"r":238,"g":153,"b":153},"luminance":115.90629546750253},{"name":"Funkie Friday","hex":"#4a3c4a","rgb":{"r":74,"g":60,"b":74},"luminance":42.44024472125485},{"name":"Funky Frog","hex":"#98bd3c","rgb":{"r":152,"g":189,"b":60},"luminance":120.08603396315493},{"name":"Funnel Cloud","hex":"#113366","rgb":{"r":17,"g":51,"b":102},"luminance":32.51570761954905},{"name":"Furious Frog","hex":"#55ee00","rgb":{"r":85,"g":238,"b":0},"luminance":141.99890373168378},{"name":"Furious Red","hex":"#ff1100","rgb":{"r":255,"g":17,"b":0},"luminance":76.89525645968025},{"name":"Furnace","hex":"#dd4124","rgb":{"r":221,"g":65,"b":36},"luminance":76.41388016584422},{"name":"Furry Lady","hex":"#f5efeb","rgb":{"r":245,"g":239,"b":235},"luminance":160.518301056297},{"name":"Fury","hex":"#ff0011","rgb":{"r":255,"g":0,"b":17},"luminance":76.26962612337888},{"name":"Fuscous Grey","hex":"#54534d","rgb":{"r":84,"g":83,"b":77},"luminance":55.51218407701141},{"name":"Fusilli","hex":"#f1e8d6","rgb":{"r":241,"g":232,"b":214},"luminance":155.9927759641452},{"name":"Fusion Coral","hex":"#ff8576","rgb":{"r":255,"g":133,"b":118},"luminance":109.95152281801283},{"name":"Fusion Red","hex":"#ff6163","rgb":{"r":255,"g":97,"b":99},"luminance":95.82652838332399},{"name":"Futaai Indigo","hex":"#614e6e","rgb":{"r":97,"g":78,"b":110},"luminance":55.630777497712536},{"name":"Future","hex":"#15abbe","rgb":{"r":21,"g":171,"b":190},"luminance":102.87916975753643},{"name":"Future Hair","hex":"#20b562","rgb":{"r":32,"g":181,"b":98},"luminance":107.26036181646974},{"name":"Futuristic","hex":"#998da8","rgb":{"r":153,"g":141,"b":168},"luminance":96.48815161458944},{"name":"Fuzzy Duckling","hex":"#ffea70","rgb":{"r":255,"g":234,"b":112},"luminance":157.61834288241963},{"name":"Fuzzy Navel","hex":"#ffd69f","rgb":{"r":255,"g":214,"b":159},"luminance":148.05989944951332},{"name":"Fuzzy Peach","hex":"#ffbb8f","rgb":{"r":255,"g":187,"b":143},"luminance":134.6413331410529},{"name":"Fuzzy Sheep","hex":"#f0e9d1","rgb":{"r":240,"g":233,"b":209},"luminance":156.2801405073594},{"name":"Fuzzy Unicorn","hex":"#eae3db","rgb":{"r":234,"g":227,"b":219},"luminance":152.55765570104964},{"name":"Fuzzy Wuzzy","hex":"#cc6666","rgb":{"r":204,"g":102,"b":102},"luminance":86.25901851980464},{"name":"Fuzzy Wuzzy Brown","hex":"#c45655","rgb":{"r":196,"g":86,"b":85},"luminance":77.95355822539469},{"name":"Gable Green","hex":"#2c4641","rgb":{"r":44,"g":70,"b":65},"luminance":43.776438137427306},{"name":"Gaboon Viper","hex":"#8c6450","rgb":{"r":140,"g":100,"b":80},"luminance":72.6713423572181},{"name":"Gabriel's Torch","hex":"#f8e6c6","rgb":{"r":248,"g":230,"b":198},"luminance":155.67823993095502},{"name":"Gadabout","hex":"#ffc4ae","rgb":{"r":255,"g":196,"b":174},"luminance":139.44077461417086},{"name":"Gaharā Lāl","hex":"#ac0c20","rgb":{"r":172,"g":12,"b":32},"luminance":52.03618956072783},{"name":"Gaia","hex":"#d3bc9e","rgb":{"r":211,"g":188,"b":158},"luminance":128.38652889224787},{"name":"Gaiety","hex":"#f4e4e5","rgb":{"r":244,"g":228,"b":229},"luminance":154.64855663083313},{"name":"Gainsboro","hex":"#dcdcdc","rgb":{"r":220,"g":220,"b":220},"luminance":147.0821348770815},{"name":"Galactic Civilization","hex":"#442288","rgb":{"r":68,"g":34,"b":136},"luminance":32.43587526181466},{"name":"Galactic Mediator","hex":"#e0dfdb","rgb":{"r":224,"g":223,"b":219},"luminance":149.14475362211036},{"name":"Galactica","hex":"#c4dde2","rgb":{"r":196,"g":221,"b":226},"luminance":144.6627354953583},{"name":"Galago","hex":"#95a69f","rgb":{"r":149,"g":166,"b":159},"luminance":108.66594149502409},{"name":"Galah","hex":"#d28083","rgb":{"r":210,"g":128,"b":131},"luminance":99.05062822617532},{"name":"Galapagos Green","hex":"#29685f","rgb":{"r":41,"g":104,"b":95},"luminance":63.20150540137473},{"name":"Galaxy Blue","hex":"#2a4b7c","rgb":{"r":42,"g":75,"b":124},"luminance":47.91378178561989},{"name":"Galaxy Green","hex":"#79afad","rgb":{"r":121,"g":175,"b":173},"luminance":110.68108668602778},{"name":"Gale of the Wind","hex":"#007844","rgb":{"r":0,"g":120,"b":68},"luminance":70.86527431683307},{"name":"Gallant Green","hex":"#99aa66","rgb":{"r":153,"g":170,"b":102},"luminance":110.39040942491336},{"name":"Galleon Blue","hex":"#3f95bf","rgb":{"r":63,"g":149,"b":191},"luminance":92.07994360337109},{"name":"Gallery","hex":"#dcd7d1","rgb":{"r":220,"g":215,"b":209},"luminance":144.29964899818708},{"name":"Gallery Blue","hex":"#9bbce4","rgb":{"r":155,"g":188,"b":228},"luminance":122.48220207442385},{"name":"Gallery Grey","hex":"#c5c2be","rgb":{"r":197,"g":194,"b":190},"luminance":130.0266045584518},{"name":"Galliano","hex":"#d8a723","rgb":{"r":216,"g":167,"b":35},"luminance":117.45934614580484},{"name":"Gallstone Yellow","hex":"#a36629","rgb":{"r":163,"g":102,"b":41},"luminance":77.34363141849495},{"name":"Galveston Tan","hex":"#e8c8b8","rgb":{"r":232,"g":200,"b":184},"luminance":137.9661987589714},{"name":"Galway Bay","hex":"#95a7a4","rgb":{"r":149,"g":167,"b":164},"luminance":109.28868586454865},{"name":"Gamboge","hex":"#e49b0f","rgb":{"r":228,"g":155,"b":15},"luminance":113.7040716465334},{"name":"Gamboge Brown","hex":"#996600","rgb":{"r":153,"g":102,"b":0},"luminance":75.35040733134758},{"name":"Gamboge Yellow","hex":"#e6d058","rgb":{"r":230,"g":208,"b":88},"luminance":140.4898115167075},{"name":"Gameboy Contrast","hex":"#0f380f","rgb":{"r":15,"g":56,"b":15},"luminance":33.220591641329925},{"name":"Gameboy Light","hex":"#9bbc0f","rgb":{"r":155,"g":188,"b":15},"luminance":119.7047612294515},{"name":"Gameboy Screen","hex":"#8bac0f","rgb":{"r":139,"g":172,"b":15},"luminance":109.19693272706884},{"name":"Gameboy Shade","hex":"#306230","rgb":{"r":48,"g":98,"b":48},"luminance":59.54127445730398},{"name":"Gamin","hex":"#bfd1af","rgb":{"r":191,"g":209,"b":175},"luminance":136.78654491579206},{"name":"Gǎn Lǎn Huáng Olive","hex":"#c9ff27","rgb":{"r":201,"g":255,"b":39},"luminance":161.36063938271937},{"name":"Gǎn Lǎn Lǜ Green","hex":"#658b38","rgb":{"r":101,"g":139,"b":56},"luminance":87.2361891992079},{"name":"Ganache","hex":"#34292a","rgb":{"r":52,"g":41,"b":42},"luminance":29.049711478773762},{"name":"Ganadian Voodoo Grey","hex":"#b8b7a3","rgb":{"r":184,"g":183,"b":163},"luminance":122.11192497459042},{"name":"Gangsters Gold","hex":"#ffdd22","rgb":{"r":255,"g":221,"b":34},"luminance":150.52381183719737},{"name":"Ganon Blue","hex":"#a4e4fc","rgb":{"r":164,"g":228,"b":252},"luminance":145.40255216467142},{"name":"Ganymede","hex":"#8b7d82","rgb":{"r":139,"g":125,"b":130},"luminance":85.62032320658454},{"name":"Garden Aroma","hex":"#9c6989","rgb":{"r":156,"g":105,"b":137},"luminance":78.85719932257295},{"name":"Garden Dawn","hex":"#f1f8ec","rgb":{"r":241,"g":248,"b":236},"luminance":164.6471878684844},{"name":"Garden Gate","hex":"#dadcc1","rgb":{"r":218,"g":220,"b":193},"luminance":146.32129280456758},{"name":"Garden Gazebo","hex":"#abc0bb","rgb":{"r":171,"g":192,"b":187},"luminance":125.58193891240889},{"name":"Garden Glade","hex":"#dcd8a8","rgb":{"r":220,"g":216,"b":168},"luminance":144.1180723157231},{"name":"Garden Gnome Red","hex":"#9b2002","rgb":{"r":155,"g":32,"b":2},"luminance":50.00749608808663},{"name":"Garden Green","hex":"#495e35","rgb":{"r":73,"g":94,"b":53},"luminance":59.645078397131805},{"name":"Garden Hedge","hex":"#6f7d6d","rgb":{"r":111,"g":125,"b":109},"luminance":81.48500366325082},{"name":"Garden Lattice","hex":"#e1d4b4","rgb":{"r":225,"g":212,"b":180},"luminance":142.94511240682556},{"name":"Garden of Eden","hex":"#7fa771","rgb":{"r":127,"g":167,"b":113},"luminance":105.91307517960188},{"name":"Garden Party","hex":"#e3a4b8","rgb":{"r":227,"g":164,"b":184},"luminance":119.64223555667957},{"name":"Garden Pebble","hex":"#e4e4d5","rgb":{"r":228,"g":228,"b":213},"luminance":152.14832238312718},{"name":"Garden Picket","hex":"#e4d195","rgb":{"r":228,"g":209,"b":149},"luminance":141.37561412421874},{"name":"Garden Pond","hex":"#afc09e","rgb":{"r":175,"g":192,"b":158},"luminance":125.55687709161931},{"name":"Garden Shed","hex":"#d6efda","rgb":{"r":214,"g":239,"b":218},"luminance":156.18564578411164},{"name":"Garden Snail","hex":"#cdb1ab","rgb":{"r":205,"g":177,"b":171},"luminance":122.19695275251343},{"name":"Garden Statue","hex":"#bfd4c4","rgb":{"r":191,"g":212,"b":196},"luminance":138.73356246056682},{"name":"Garden Topiary","hex":"#3e524b","rgb":{"r":62,"g":82,"b":75},"luminance":52.284241411729404},{"name":"Garden Weed","hex":"#786e38","rgb":{"r":120,"g":110,"b":56},"luminance":74.14455311079836},{"name":"Gardenia","hex":"#f1e8df","rgb":{"r":241,"g":232,"b":223},"luminance":156.1565221852741},{"name":"Gardening","hex":"#acba8d","rgb":{"r":172,"g":186,"b":141},"luminance":121.75352883592326},{"name":"Garfield","hex":"#a75429","rgb":{"r":167,"g":84,"b":41},"luminance":70.3308582984738},{"name":"Gargantua","hex":"#eeee55","rgb":{"r":238,"g":238,"b":85},"luminance":157.08498585160837},{"name":"Gargoyle","hex":"#abb39e","rgb":{"r":171,"g":179,"b":158},"luminance":118.23257636539938},{"name":"Gargoyle Gas","hex":"#ffdf46","rgb":{"r":255,"g":223,"b":70},"luminance":151.69723868943692},{"name":"Garlic Clove","hex":"#e2d7c1","rgb":{"r":226,"g":215,"b":193},"luminance":144.8379629275419},{"name":"Garlic Suede","hex":"#cdd2bc","rgb":{"r":205,"g":210,"b":188},"luminance":139.3265967035727},{"name":"Garlic Toast","hex":"#dddd88","rgb":{"r":221,"g":221,"b":136},"luminance":146.41005015366946},{"name":"Garnet","hex":"#733635","rgb":{"r":115,"g":54,"b":53},"luminance":47.155033591335716},{"name":"Garnet Evening","hex":"#763b42","rgb":{"r":118,"g":59,"b":66},"luminance":50.008747124878056},{"name":"Garnet Rose","hex":"#ac4b55","rgb":{"r":172,"g":75,"b":85},"luminance":68.38812695929023},{"name":"Garnet Sand","hex":"#cc7446","rgb":{"r":204,"g":116,"b":70},"luminance":91.76444235105447},{"name":"Garnish","hex":"#1e9752","rgb":{"r":30,"g":151,"b":82},"luminance":89.57881319262943},{"name":"Garrison Grey","hex":"#7b8588","rgb":{"r":123,"g":133,"b":136},"luminance":87.68125675422313},{"name":"Garuda Gold","hex":"#ffbb31","rgb":{"r":255,"g":187,"b":49},"luminance":133.76747281009685},{"name":"Gas Giant","hex":"#98dcff","rgb":{"r":152,"g":220,"b":255},"luminance":139.95615457706745},{"name":"Gaslight","hex":"#feffea","rgb":{"r":254,"g":255,"b":234},"luminance":169.9558857968738},{"name":"Gathering Field","hex":"#ab8f55","rgb":{"r":171,"g":143,"b":85},"luminance":98.76316227217514},{"name":"Gathering Place","hex":"#ad9466","rgb":{"r":173,"g":148,"b":102},"luminance":101.7758924745934},{"name":"Gatsby Brick","hex":"#8e3b2f","rgb":{"r":142,"g":59,"b":47},"luminance":55.05301642053776},{"name":"Gatsby Glitter","hex":"#eed683","rgb":{"r":238,"g":214,"b":131},"luminance":145.14453666604197},{"name":"Gauss Blaster Green","hex":"#84c3aa","rgb":{"r":132,"g":195,"b":170},"luminance":122.61950762011726},{"name":"Gazelle","hex":"#947e68","rgb":{"r":148,"g":126,"b":104},"luminance":87.00104415465368},{"name":"Gazpacho","hex":"#c23b22","rgb":{"r":194,"g":59,"b":34},"luminance":67.66952121154692},{"name":"Gecko","hex":"#9d913c","rgb":{"r":157,"g":145,"b":60},"luminance":97.44226020572387},{"name":"Gédéon Brown","hex":"#7f5f00","rgb":{"r":127,"g":95,"b":0},"luminance":67.46616895896787},{"name":"Geebung","hex":"#c5832e","rgb":{"r":197,"g":131,"b":46},"luminance":97.00624492268526},{"name":"Gehenna's Gold","hex":"#dba674","rgb":{"r":219,"g":166,"b":116},"luminance":118.14219779993937},{"name":"Gellibrand","hex":"#b5acb2","rgb":{"r":181,"g":172,"b":178},"luminance":116.33727141806274},{"name":"Generic Viridian","hex":"#007f66","rgb":{"r":0,"g":127,"b":102},"luminance":75.45040612879428},{"name":"Genestealer Purple","hex":"#7761ab","rgb":{"r":119,"g":97,"b":171},"luminance":69.91475751227347},{"name":"Genetic Code","hex":"#18515d","rgb":{"r":24,"g":81,"b":93},"luminance":49.2403755976739},{"name":"Geneva Green","hex":"#1f7f76","rgb":{"r":31,"g":127,"b":118},"luminance":76.31791445001625},{"name":"Gengiana","hex":"#5f4871","rgb":{"r":95,"g":72,"b":113},"luminance":52.52652325254356},{"name":"Genie","hex":"#3e4364","rgb":{"r":62,"g":67,"b":100},"luminance":44.948722840588026},{"name":"Genoa","hex":"#31796d","rgb":{"r":49,"g":121,"b":109},"luminance":73.57915469750927},{"name":"Genoa Lemon","hex":"#fde910","rgb":{"r":253,"g":233,"b":16},"luminance":156.30771582362783},{"name":"Genteel Blue","hex":"#698eb3","rgb":{"r":105,"g":142,"b":179},"luminance":91.37800707500683},{"name":"Gentian","hex":"#9079ad","rgb":{"r":144,"g":121,"b":173},"luminance":85.36750640026918},{"name":"Gentian Flower","hex":"#3366ff","rgb":{"r":51,"g":102,"b":255},"luminance":68.28244852815399},{"name":"Gentian Violet","hex":"#544275","rgb":{"r":84,"g":66,"b":117},"luminance":48.05890410735559},{"name":"Gentle Calm","hex":"#c4cebf","rgb":{"r":196,"g":206,"b":191},"luminance":136.12738877977495},{"name":"Gentle Caress","hex":"#fcd7ba","rgb":{"r":252,"g":215,"b":186},"luminance":148.508022493736},{"name":"Gentle Doe","hex":"#e8b793","rgb":{"r":232,"g":183,"b":147},"luminance":128.96519386640722},{"name":"Gentle Giant","hex":"#b3ebe0","rgb":{"r":179,"g":235,"b":224},"luminance":150.15128291826213},{"name":"Gentle Glow","hex":"#f6e5b9","rgb":{"r":246,"g":229,"b":185},"luminance":154.67553764251153},{"name":"Gentle Touch","hex":"#e3d5b8","rgb":{"r":227,"g":213,"b":184},"luminance":143.80364274245628},{"name":"Gentle Yellow","hex":"#fff5be","rgb":{"r":255,"g":245,"b":190},"luminance":164.21087007259902},{"name":"Gentleman's Suit","hex":"#c1becd","rgb":{"r":193,"g":190,"b":205},"luminance":127.73095023916481},{"name":"Geode","hex":"#4b3f69","rgb":{"r":75,"g":63,"b":105},"luminance":44.87489148733398},{"name":"Georgia Clay","hex":"#b06144","rgb":{"r":176,"g":97,"b":68},"luminance":77.91937243715455},{"name":"Georgia On My Mind","hex":"#fdd4c5","rgb":{"r":253,"g":212,"b":197},"luminance":147.35379027700642},{"name":"Georgia Peach","hex":"#f97272","rgb":{"r":249,"g":114,"b":114},"luminance":100.9448668382895},{"name":"Georgian Leather","hex":"#cf875e","rgb":{"r":207,"g":135,"b":94},"luminance":101.12045356899858},{"name":"Geraldine","hex":"#e77b75","rgb":{"r":231,"g":123,"b":117},"luminance":100.80383626628502},{"name":"Geranium","hex":"#da3d58","rgb":{"r":218,"g":61,"b":88},"luminance":75.04315689654852},{"name":"Geranium Pink","hex":"#f6909d","rgb":{"r":246,"g":144,"b":157},"luminance":113.47031375650637},{"name":"Geranium Red","hex":"#d76968","rgb":{"r":215,"g":105,"b":104},"luminance":89.84430525080596},{"name":"German Camouflage Beige","hex":"#9b8c7b","rgb":{"r":155,"g":140,"b":123},"luminance":95.3835830161564},{"name":"German Grey","hex":"#53504e","rgb":{"r":83,"g":80,"b":78},"luminance":53.853437708283764},{"name":"German Hop","hex":"#89ac27","rgb":{"r":137,"g":172,"b":39},"luminance":109.04798751467172},{"name":"German Liquorice","hex":"#2e3749","rgb":{"r":46,"g":55,"b":73},"luminance":36.065903912143945},{"name":"German Mustard","hex":"#cd7a00","rgb":{"r":205,"g":122,"b":0},"luminance":94.2636834682371},{"name":"Germander Speedwell","hex":"#0094c8","rgb":{"r":0,"g":148,"b":200},"luminance":89.81803480370742},{"name":"Germania","hex":"#ddc47e","rgb":{"r":221,"g":196,"b":126},"luminance":133.45306830867546},{"name":"Get Up and Go","hex":"#1a9d49","rgb":{"r":26,"g":157,"b":73},"luminance":92.8599592989357},{"name":"Gettysburg Grey","hex":"#c7c1b7","rgb":{"r":199,"g":193,"b":183},"luminance":129.6550914002223},{"name":"Geyser","hex":"#c4d7cf","rgb":{"r":196,"g":215,"b":207},"luminance":141.13467484994607},{"name":"Geyser Basin","hex":"#e3cab5","rgb":{"r":227,"g":202,"b":181},"luminance":138.17488759177624},{"name":"Geyser Steam","hex":"#cbd0cf","rgb":{"r":203,"g":208,"b":207},"luminance":138.37783286711783},{"name":"Ghost","hex":"#c0bfc7","rgb":{"r":192,"g":191,"b":199},"luminance":127.98654128071435},{"name":"Ghost Grey","hex":"#9c9b98","rgb":{"r":156,"g":155,"b":152},"luminance":103.70242304305141},{"name":"Ghost Ship","hex":"#887b6e","rgb":{"r":136,"g":123,"b":110},"luminance":83.80809565310501},{"name":"Ghost Town","hex":"#beb6a8","rgb":{"r":190,"g":182,"b":168},"luminance":122.50583153466613},{"name":"Ghost Whisperer","hex":"#cbd1d0","rgb":{"r":203,"g":209,"b":208},"luminance":138.91545357518723},{"name":"Ghost White","hex":"#f8f8ff","rgb":{"r":248,"g":248,"b":255},"luminance":165.9396148603461},{"name":"Ghost Writer","hex":"#bcb7ad","rgb":{"r":188,"g":183,"b":173},"luminance":122.83329137086574},{"name":"Ghosting","hex":"#cac6ba","rgb":{"r":202,"g":198,"b":186},"luminance":132.68764485060393},{"name":"Ghostlands Coal","hex":"#113c42","rgb":{"r":17,"g":60,"b":66},"luminance":36.3716354457701},{"name":"Ghostly","hex":"#a7a09f","rgb":{"r":167,"g":160,"b":159},"luminance":107.90191270315832},{"name":"Ghostly Green","hex":"#d9d7b8","rgb":{"r":217,"g":215,"b":184},"luminance":143.44859110496694},{"name":"Ghostly Grey","hex":"#ccccd3","rgb":{"r":204,"g":204,"b":211},"luminance":136.52358930236196},{"name":"Ghostwaver","hex":"#e2dbdb","rgb":{"r":226,"g":219,"b":219},"luminance":147.36152971858021},{"name":"Ghoul Skin","hex":"#667744","rgb":{"r":102,"g":119,"b":68},"luminance":76.61372668784622},{"name":"Giant Onion","hex":"#665d9e","rgb":{"r":102,"g":93,"b":158},"luminance":65.07486019193587},{"name":"Giant's Club","hex":"#b05c52","rgb":{"r":176,"g":92,"b":82},"luminance":75.98093508242708},{"name":"Giants Orange","hex":"#fe5a1d","rgb":{"r":254,"g":90,"b":29},"luminance":92.57285483336895},{"name":"Gibraltar Grey","hex":"#6f6a68","rgb":{"r":111,"g":106,"b":104},"luminance":71.50980171277222},{"name":"Gibraltar Sea","hex":"#123850","rgb":{"r":18,"g":56,"b":80},"luminance":34.53561506618928},{"name":"Gigas","hex":"#564786","rgb":{"r":86,"g":71,"b":134},"luminance":51.298521430934045},{"name":"Giggle","hex":"#eff0d3","rgb":{"r":239,"g":240,"b":211},"luminance":159.78874752935516},{"name":"Gilded","hex":"#f4db4f","rgb":{"r":244,"g":219,"b":79},"luminance":148.0863254355378},{"name":"Gilded Beige","hex":"#b39f8d","rgb":{"r":179,"g":159,"b":141},"luminance":108.78382143499097},{"name":"Gilded Pear","hex":"#c09e6c","rgb":{"r":192,"g":158,"b":108},"luminance":109.76832113137196},{"name":"Gilneas Grey","hex":"#6c8396","rgb":{"r":108,"g":131,"b":150},"luminance":85.1371356870784},{"name":"Gimblet","hex":"#b9ad61","rgb":{"r":185,"g":173,"b":97},"luminance":116.16640732156606},{"name":"Gin","hex":"#d9dfcd","rgb":{"r":217,"g":223,"b":205},"luminance":147.9561840208107},{"name":"Gin Fizz","hex":"#f8eaca","rgb":{"r":248,"g":234,"b":202},"luminance":157.7847522798068},{"name":"Gin Tonic","hex":"#ecebe5","rgb":{"r":236,"g":235,"b":229},"luminance":157.12932367002665},{"name":"Ginger","hex":"#b06500","rgb":{"r":176,"g":101,"b":0},"luminance":79.27315904516483},{"name":"Ginger Ale","hex":"#c9a86a","rgb":{"r":201,"g":168,"b":106},"luminance":116.116442905387},{"name":"Ginger Ale Fizz","hex":"#f5dfbc","rgb":{"r":245,"g":223,"b":188},"luminance":151.52787680819657},{"name":"Ginger Beer","hex":"#c27f38","rgb":{"r":194,"g":127,"b":56},"luminance":94.67314768718741},{"name":"Ginger Cream","hex":"#efe0d7","rgb":{"r":239,"g":224,"b":215},"luminance":151.64599818326892},{"name":"Ginger Crunch","hex":"#ceaa64","rgb":{"r":206,"g":170,"b":100},"luminance":117.82115657215387},{"name":"Ginger Dy","hex":"#97653c","rgb":{"r":151,"g":101,"b":60},"luminance":74.83425799725684},{"name":"Ginger Flower","hex":"#cf524e","rgb":{"r":207,"g":82,"b":78},"luminance":78.90939784968582},{"name":"Ginger Lemon Tea","hex":"#ffffaa","rgb":{"r":255,"g":255,"b":170},"luminance":169.09903503568552},{"name":"Ginger Milk","hex":"#f7a454","rgb":{"r":247,"g":164,"b":84},"luminance":121.71069471907552},{"name":"Ginger Peach","hex":"#f9d09f","rgb":{"r":249,"g":208,"b":159},"luminance":144.14900795010695},{"name":"Ginger Pie","hex":"#9a7d61","rgb":{"r":154,"g":125,"b":97},"luminance":87.32928549461515},{"name":"Ginger Root","hex":"#c17444","rgb":{"r":193,"g":116,"b":68},"luminance":89.59191825717318},{"name":"Ginger Shortbread","hex":"#e3cec6","rgb":{"r":227,"g":206,"b":198},"luminance":140.4933073032306},{"name":"Ginger Snap","hex":"#977d70","rgb":{"r":151,"g":125,"b":112},"luminance":87.09388411363912},{"name":"Ginger Spice","hex":"#b65d48","rgb":{"r":182,"g":93,"b":72},"luminance":77.51688376734451},{"name":"Ginger Whisper","hex":"#cc8877","rgb":{"r":204,"g":136,"b":119},"luminance":101.37897511811805},{"name":"Gingerbread","hex":"#8c4a2f","rgb":{"r":140,"g":74,"b":47},"luminance":60.56259248083754},{"name":"Gingerbread Crumble","hex":"#9c5e33","rgb":{"r":156,"g":94,"b":51},"luminance":72.48501235427915},{"name":"Gingerbread House","hex":"#ca994e","rgb":{"r":202,"g":153,"b":78},"luminance":108.59558825753466},{"name":"Gingerline","hex":"#ffdd11","rgb":{"r":255,"g":221,"b":17},"luminance":150.4863794434566},{"name":"Ginnezumi","hex":"#97867c","rgb":{"r":151,"g":134,"b":124},"luminance":91.78964898614657},{"name":"Ginninderra","hex":"#b3d5c0","rgb":{"r":179,"g":213,"b":192},"luminance":137.75461134205273},{"name":"Ginseng Root","hex":"#e6cdb5","rgb":{"r":230,"g":205,"b":181},"luminance":140.12703907883017},{"name":"Ginshu","hex":"#bc2d29","rgb":{"r":188,"g":45,"b":41},"luminance":62.28472882657513},{"name":"Giraffe","hex":"#fefe33","rgb":{"r":254,"g":254,"b":51},"luminance":167.42703221403644},{"name":"Girl Power","hex":"#d39bcb","rgb":{"r":211,"g":155,"b":203},"luminance":113.11076124754887},{"name":"Girl Talk","hex":"#e4c7c8","rgb":{"r":228,"g":199,"b":200},"luminance":137.15880778499059},{"name":"Girlie","hex":"#ffd3cf","rgb":{"r":255,"g":211,"b":207},"luminance":147.34558723626574},{"name":"Girls Night Out","hex":"#ff69b4","rgb":{"r":255,"g":105,"b":180},"luminance":100.16608033660896},{"name":"Girly Nursery","hex":"#f6e6e5","rgb":{"r":246,"g":230,"b":229},"luminance":155.94683149073597},{"name":"Givry","hex":"#ebd4ae","rgb":{"r":235,"g":212,"b":174},"luminance":144.2807896325772},{"name":"Gizmo","hex":"#d4a1b5","rgb":{"r":212,"g":161,"b":181},"luminance":115.65195004408702},{"name":"Glacial Ice","hex":"#eae9e7","rgb":{"r":234,"g":233,"b":231},"luminance":155.86862145088728},{"name":"Glacier","hex":"#78b1bf","rgb":{"r":120,"g":177,"b":191},"luminance":112.05571684211387},{"name":"Glacier Blue","hex":"#a9c1c0","rgb":{"r":169,"g":193,"b":192},"luminance":125.96553967653216},{"name":"Glacier Green","hex":"#3e9eac","rgb":{"r":62,"g":158,"b":172},"luminance":96.59167471371433},{"name":"Glacier Grey","hex":"#c5c6c7","rgb":{"r":197,"g":198,"b":199},"luminance":132.25997535535836},{"name":"Glacier Ivy","hex":"#eaf3e6","rgb":{"r":234,"g":243,"b":230},"luminance":161.02541550016258},{"name":"Glacier Lake","hex":"#62b4c0","rgb":{"r":98,"g":180,"b":192},"luminance":111.81112354323248},{"name":"Glacier Pearl","hex":"#d1d2dc","rgb":{"r":209,"g":210,"b":220},"luminance":140.46218131938573},{"name":"Glacier Point","hex":"#b3d8e5","rgb":{"r":179,"g":216,"b":229},"luminance":140.0793772865942},{"name":"Glade","hex":"#9ca687","rgb":{"r":156,"g":166,"b":135},"luminance":109.12130039547732},{"name":"Glade Green","hex":"#5f8151","rgb":{"r":95,"g":129,"b":81},"luminance":81.40075865739827},{"name":"Gladeye","hex":"#7a8ca6","rgb":{"r":122,"g":140,"b":166},"luminance":91.882069306258},{"name":"Gladiator Leather","hex":"#a95c3e","rgb":{"r":169,"g":92,"b":62},"luminance":74.29515866461287},{"name":"Glamorgan Sausage","hex":"#dacba7","rgb":{"r":218,"g":203,"b":167},"luminance":137.151312385263},{"name":"Glamour Pink","hex":"#ff1dcd","rgb":{"r":255,"g":29,"b":205},"luminance":81.54286881144175},{"name":"Glamour White","hex":"#fffcec","rgb":{"r":255,"g":252,"b":236},"luminance":168.57827563775825},{"name":"Glass Bead","hex":"#c7bec4","rgb":{"r":199,"g":190,"b":196},"luminance":128.36886007517555},{"name":"Glass Bull","hex":"#880000","rgb":{"r":136,"g":0,"b":0},"luminance":40.664},{"name":"Glass Green","hex":"#dcdfb0","rgb":{"r":220,"g":223,"b":176},"luminance":147.86698176739793},{"name":"Glass Jar Blue","hex":"#20b2aa","rgb":{"r":32,"g":178,"b":170},"luminance":106.6979625859838},{"name":"Glass Sand","hex":"#cdb69b","rgb":{"r":205,"g":182,"b":155},"luminance":124.42993804145365},{"name":"Glass Sea","hex":"#095d75","rgb":{"r":9,"g":93,"b":117},"luminance":56.26118560784157},{"name":"Glass Tile","hex":"#cdd0c0","rgb":{"r":205,"g":208,"b":192},"luminance":138.36038011294997},{"name":"Glassine","hex":"#d7e2e5","rgb":{"r":215,"g":226,"b":229},"luminance":149.71069001577675},{"name":"Glaucous","hex":"#6082b6","rgb":{"r":96,"g":130,"b":182},"luminance":84.12856363923017},{"name":"Glazed Carrot","hex":"#e9692c","rgb":{"r":233,"g":105,"b":44},"luminance":93.15323059346895},{"name":"Glazed Chestnut","hex":"#967217","rgb":{"r":150,"g":114,"b":23},"luminance":80.60034806376459},{"name":"Glazed Ginger","hex":"#91552b","rgb":{"r":145,"g":85,"b":43},"luminance":66.28119381845804},{"name":"Glazed Granite","hex":"#5b5e61","rgb":{"r":91,"g":94,"b":97},"luminance":62.50776534959476},{"name":"Glazed Pears","hex":"#efe3d2","rgb":{"r":239,"g":227,"b":210},"luminance":153.08525115764743},{"name":"Glazed Persimmon","hex":"#d34e36","rgb":{"r":211,"g":78,"b":54},"luminance":78.1951152758278},{"name":"Glazed Ringlet","hex":"#89626d","rgb":{"r":137,"g":98,"b":109},"luminance":71.70504529668746},{"name":"Glazed Sugar","hex":"#ffdccc","rgb":{"r":255,"g":220,"b":204},"luminance":151.7606047727802},{"name":"Gleam","hex":"#bfd1ad","rgb":{"r":191,"g":209,"b":173},"luminance":136.75347766693173},{"name":"Gleaming Shells","hex":"#f8ded1","rgb":{"r":248,"g":222,"b":209},"luminance":151.81546685367732},{"name":"Glen","hex":"#4aac72","rgb":{"r":74,"g":172,"b":114},"luminance":104.1738219899798},{"name":"Glen Falls","hex":"#acb8c1","rgb":{"r":172,"g":184,"b":193},"luminance":121.63328184341653},{"name":"Glenwood Green","hex":"#a7d3b7","rgb":{"r":167,"g":211,"b":183},"luminance":135.16317539182037},{"name":"Glide Time","hex":"#5d6f80","rgb":{"r":93,"g":111,"b":128},"luminance":72.32973359552764},{"name":"Glimpse","hex":"#4fb9ce","rgb":{"r":79,"g":185,"b":206},"luminance":113.58839695144923},{"name":"Glimpse into Space","hex":"#121210","rgb":{"r":18,"g":18,"b":16},"luminance":11.997218677676921},{"name":"Glimpse of Pink","hex":"#fff3f4","rgb":{"r":255,"g":243,"b":244},"luminance":164.11424301991585},{"name":"Glimpse of Void","hex":"#335588","rgb":{"r":51,"g":85,"b":136},"luminance":54.42809055993054},{"name":"Glisten Green","hex":"#f2efdc","rgb":{"r":242,"g":239,"b":220},"luminance":159.83370236905606},{"name":"Glistening Grey","hex":"#b1b3be","rgb":{"r":177,"g":179,"b":190},"luminance":119.62581183841553},{"name":"Glitch","hex":"#2c5463","rgb":{"r":44,"g":84,"b":99},"luminance":52.265983163047835},{"name":"Glitchy Shader Blue","hex":"#99ffff","rgb":{"r":153,"g":255,"b":255},"luminance":159.19626922136084},{"name":"Glitter","hex":"#e6e8fa","rgb":{"r":230,"g":232,"b":250},"luminance":155.2019482996267},{"name":"Glitter Shower","hex":"#88ffff","rgb":{"r":136,"g":255,"b":255},"luminance":157.81072530408065},{"name":"Glittery Glow","hex":"#eeeddb","rgb":{"r":238,"g":237,"b":219},"luminance":158.24483423164244},{"name":"Glitzy Red","hex":"#af413b","rgb":{"r":175,"g":65,"b":59},"luminance":65.10720947790651},{"name":"Global Warming","hex":"#f1d7d3","rgb":{"r":241,"g":215,"b":211},"luminance":147.30511335999168},{"name":"Globe Artichoke","hex":"#5f6c3c","rgb":{"r":95,"g":108,"b":60},"luminance":69.80460186119537},{"name":"Globe Thistle","hex":"#2e0329","rgb":{"r":46,"g":3,"b":41},"luminance":14.63283680630656},{"name":"Gloomy Purple","hex":"#8756e4","rgb":{"r":135,"g":86,"b":228},"luminance":69.66598605488907},{"name":"Gloomy Sea","hex":"#4a657a","rgb":{"r":74,"g":101,"b":122},"luminance":64.79151726113534},{"name":"Glorious Gold","hex":"#cba956","rgb":{"r":203,"g":169,"b":86},"luminance":116.71109387714604},{"name":"Glossy Black","hex":"#110011","rgb":{"r":17,"g":0,"b":17},"luminance":5.439920311916343},{"name":"Glossy Gold","hex":"#ffdd77","rgb":{"r":255,"g":221,"b":119},"luminance":151.08418484407954},{"name":"Glossy Grape","hex":"#ab92b3","rgb":{"r":171,"g":146,"b":179},"luminance":101.8597677250444},{"name":"Glossy Kiss","hex":"#eee3de","rgb":{"r":238,"g":227,"b":222},"luminance":153.16599201193455},{"name":"Glossy Olive","hex":"#636340","rgb":{"r":99,"g":99,"b":64},"luminance":65.62447398646331},{"name":"Glow in the Dark","hex":"#befdb7","rgb":{"r":190,"g":253,"b":183},"luminance":160.36868854299456},{"name":"Glow Worm","hex":"#bed565","rgb":{"r":190,"g":213,"b":101},"luminance":137.81400239815983},{"name":"Glowing Coals","hex":"#bc4d39","rgb":{"r":188,"g":77,"b":57},"luminance":72.42211367393249},{"name":"Glowing Firelight","hex":"#af5941","rgb":{"r":175,"g":89,"b":65},"luminance":74.31113492606609},{"name":"Glowing Meteor","hex":"#ee4400","rgb":{"r":238,"g":68,"b":0},"luminance":81.59238506135237},{"name":"Glowlight","hex":"#fff6b9","rgb":{"r":255,"g":246,"b":185},"luminance":164.65122449893897},{"name":"Gloxinia","hex":"#622e5a","rgb":{"r":98,"g":46,"b":90},"luminance":41.14587230816719},{"name":"Gluon Grey","hex":"#1a1b1c","rgb":{"r":26,"g":27,"b":28},"luminance":17.93919566201339},{"name":"Gluten","hex":"#ddcc66","rgb":{"r":221,"g":204,"b":102},"luminance":137.26335319013592},{"name":"Gnarls Green","hex":"#00754b","rgb":{"r":0,"g":117,"b":75},"luminance":69.209157927257},{"name":"Gnocchi Beige","hex":"#ffeebb","rgb":{"r":255,"g":238,"b":187},"luminance":160.57871460750954},{"name":"Gnome","hex":"#81a19b","rgb":{"r":129,"g":161,"b":155},"luminance":103.59306921797422},{"name":"Gnu Tan","hex":"#b09f84","rgb":{"r":176,"g":159,"b":132},"luminance":108.19785843074713},{"name":"Go Alpha","hex":"#007f87","rgb":{"r":0,"g":127,"b":135},"luminance":76.12099251192143},{"name":"Go Bananas","hex":"#f7ca50","rgb":{"r":247,"g":202,"b":80},"luminance":139.99011924060926},{"name":"Go Ben","hex":"#786e4c","rgb":{"r":120,"g":110,"b":76},"luminance":74.37556181972677},{"name":"Go Go Glow","hex":"#fcecd5","rgb":{"r":252,"g":236,"b":213},"luminance":159.55579479291873},{"name":"Go Go Green","hex":"#008a7d","rgb":{"r":0,"g":138,"b":125},"luminance":82.24983000590336},{"name":"Go Go Mango","hex":"#feb87e","rgb":{"r":254,"g":184,"b":126},"luminance":132.81508753149998},{"name":"Go Green!","hex":"#00ab66","rgb":{"r":0,"g":171,"b":102},"luminance":101.04826823355262},{"name":"Go To Grey","hex":"#dcd8d7","rgb":{"r":220,"g":216,"b":215},"luminance":144.92742930170257},{"name":"Goat","hex":"#a89a91","rgb":{"r":168,"g":154,"b":145},"luminance":104.72961915332262},{"name":"Goblin","hex":"#34533d","rgb":{"r":52,"g":83,"b":61},"luminance":51.61234601333289},{"name":"Goblin Blue","hex":"#5f7278","rgb":{"r":95,"g":114,"b":120},"luminance":73.97300283887357},{"name":"Goblin Eyes","hex":"#eb8931","rgb":{"r":235,"g":137,"b":49},"luminance":106.9373142640117},{"name":"Goblin Green","hex":"#76ff7a","rgb":{"r":118,"g":255,"b":122},"luminance":154.41454339860607},{"name":"Goblin Warboss","hex":"#4efd54","rgb":{"r":78,"g":253,"b":84},"luminance":150.63576129525154},{"name":"Gobo Brown","hex":"#635147","rgb":{"r":99,"g":81,"b":71},"luminance":56.59018683482146},{"name":"Gochujang Red","hex":"#770000","rgb":{"r":119,"g":0,"b":0},"luminance":35.580999999999996},{"name":"God’s Own Junkyard Pink","hex":"#f56991","rgb":{"r":245,"g":105,"b":145},"luminance":97.15147528473256},{"name":"Goddess","hex":"#d0e1e8","rgb":{"r":208,"g":225,"b":232},"luminance":148.36154216305516},{"name":"Goddess of Dawn","hex":"#a8d4b0","rgb":{"r":168,"g":212,"b":176},"luminance":135.6912932210464},{"name":"Godzilla","hex":"#3c4d03","rgb":{"r":60,"g":77,"b":3},"luminance":48.630342020183235},{"name":"Gogo Blue","hex":"#0087a1","rgb":{"r":0,"g":135,"b":161},"luminance":81.34272764666795},{"name":"Goji Berry","hex":"#b91228","rgb":{"r":185,"g":18,"b":40},"luminance":56.49940867832158},{"name":"Goku Orange","hex":"#f0833a","rgb":{"r":240,"g":131,"b":58},"luminance":105.3867389807655},{"name":"Gold","hex":"#ffd700","rgb":{"r":255,"g":215,"b":0},"luminance":147.4483029742967},{"name":"Gold Black","hex":"#2a2424","rgb":{"r":42,"g":36,"b":36},"luminance":24.922030495126194},{"name":"Gold Buff","hex":"#ecc481","rgb":{"r":236,"g":196,"b":129},"luminance":135.76637004796143},{"name":"Gold Bullion","hex":"#eedd99","rgb":{"r":238,"g":221,"b":153},"luminance":148.9877449221915},{"name":"Gold Canyon","hex":"#ae9769","rgb":{"r":174,"g":151,"b":105},"luminance":103.47223465741908},{"name":"Gold Deposit","hex":"#e0ce57","rgb":{"r":224,"g":206,"b":87},"luminance":138.58672874413335},{"name":"Gold Drop","hex":"#d56c30","rgb":{"r":213,"g":108,"b":48},"luminance":90.02793771380081},{"name":"Gold Dust","hex":"#a4803f","rgb":{"r":164,"g":128,"b":63},"luminance":90.00849357699528},{"name":"Gold Earth","hex":"#dd9c6b","rgb":{"r":221,"g":156,"b":107},"luminance":113.58105752721268},{"name":"Gold Flame","hex":"#b45422","rgb":{"r":180,"g":84,"b":34},"luminance":73.09510681297347},{"name":"Gold Foil","hex":"#d99f4d","rgb":{"r":217,"g":159,"b":77},"luminance":114.00835873741889},{"name":"Gold Fusion","hex":"#ffb000","rgb":{"r":255,"g":176,"b":0},"luminance":128.4004258910382},{"name":"Gold Gleam","hex":"#cfb352","rgb":{"r":207,"g":179,"b":82},"luminance":122.30479909635598},{"name":"Gold Pheasant","hex":"#c6795f","rgb":{"r":198,"g":121,"b":95},"luminance":93.0967262206357},{"name":"Gold Plate","hex":"#e6bd8f","rgb":{"r":230,"g":189,"b":143},"luminance":131.5424545650567},{"name":"Gold Red","hex":"#eb5406","rgb":{"r":235,"g":84,"b":6},"luminance":85.84239596493099},{"name":"Gold Rush","hex":"#c4a777","rgb":{"r":196,"g":167,"b":119},"luminance":115.01369489326042},{"name":"Gold Sand","hex":"#f7e5a9","rgb":{"r":247,"g":229,"b":169},"luminance":154.5800352374135},{"name":"Gold Spell","hex":"#c19d61","rgb":{"r":193,"g":157,"b":97},"luminance":109.2961961552185},{"name":"Gold Spike","hex":"#907047","rgb":{"r":144,"g":112,"b":71},"luminance":79.00383223616434},{"name":"Gold Taffeta","hex":"#bb9a39","rgb":{"r":187,"g":154,"b":57},"luminance":106.4907788355405},{"name":"Gold Tips","hex":"#e2b227","rgb":{"r":226,"g":178,"b":39},"luminance":124.51239531869909},{"name":"Gold Tooth","hex":"#dbb40c","rgb":{"r":219,"g":180,"b":12},"luminance":124.3127844793125},{"name":"Gold Wash","hex":"#d4c19e","rgb":{"r":212,"g":193,"b":158},"luminance":131.0622804967165},{"name":"Goldbrown","hex":"#9c8a53","rgb":{"r":156,"g":138,"b":83},"luminance":93.95298939363238},{"name":"Golden","hex":"#f5bf03","rgb":{"r":245,"g":191,"b":3},"luminance":133.92771810943393},{"name":"Golden Age","hex":"#ceab77","rgb":{"r":206,"g":171,"b":119},"luminance":118.54703421427294},{"name":"Golden Appeal","hex":"#e6be59","rgb":{"r":230,"g":190,"b":89},"luminance":131.41991902295482},{"name":"Golden Apricot","hex":"#dda758","rgb":{"r":221,"g":167,"b":88},"luminance":118.64552290752482},{"name":"Golden Aurelia","hex":"#ffee77","rgb":{"r":255,"g":238,"b":119},"luminance":159.7344759812358},{"name":"Golden Banner","hex":"#fcc62a","rgb":{"r":252,"g":198,"b":42},"luminance":138.59555953925795},{"name":"Golden Bell","hex":"#ca8136","rgb":{"r":202,"g":129,"b":54},"luminance":97.05558958143523},{"name":"Golden Blond","hex":"#ccaa55","rgb":{"r":204,"g":170,"b":85},"luminance":117.35609151637591},{"name":"Golden Boy","hex":"#ffdd44","rgb":{"r":255,"g":221,"b":68},"luminance":150.6734484174302},{"name":"Golden Brown","hex":"#b27a01","rgb":{"r":178,"g":122,"b":1},"luminance":89.22532866848964},{"name":"Golden Buddha Belly","hex":"#ffcc22","rgb":{"r":255,"g":204,"b":34},"luminance":142.01375604144832},{"name":"Golden Buff","hex":"#f8e6c8","rgb":{"r":248,"g":230,"b":200},"luminance":155.71146137648313},{"name":"Golden Cartridge","hex":"#bdb76b","rgb":{"r":189,"g":183,"b":107},"luminance":121.98998141650813},{"name":"Golden Chandelier","hex":"#dddd11","rgb":{"r":221,"g":221,"b":17},"luminance":145.59974111927534},{"name":"Golden Coin","hex":"#fcd975","rgb":{"r":252,"g":217,"b":117},"luminance":148.5955348891749},{"name":"Golden Cream","hex":"#f7b768","rgb":{"r":247,"g":183,"b":104},"luminance":130.89729403620228},{"name":"Golden Crest","hex":"#f6ca69","rgb":{"r":246,"g":202,"b":105},"luminance":140.0473680295349},{"name":"Golden Crested Wren","hex":"#ccddbb","rgb":{"r":204,"g":221,"b":187},"luminance":144.92778777377376},{"name":"Golden Delicious","hex":"#d2d88f","rgb":{"r":210,"g":216,"b":143},"luminance":142.42384129070524},{"name":"Golden Dream","hex":"#f1cc2b","rgb":{"r":241,"g":204,"b":43},"luminance":139.8431714064008},{"name":"Golden Ecru","hex":"#d8c39f","rgb":{"r":216,"g":195,"b":159},"luminance":132.67208130198304},{"name":"Golden Egg","hex":"#b29155","rgb":{"r":178,"g":145,"b":85},"luminance":100.85157712698398},{"name":"Golden Elm","hex":"#bdd5b1","rgb":{"r":189,"g":213,"b":177},"luminance":138.6845188404243},{"name":"Golden Field","hex":"#c39e44","rgb":{"r":195,"g":158,"b":68},"luminance":109.82434632175145},{"name":"Golden Fizz","hex":"#ebde31","rgb":{"r":235,"g":222,"b":49},"luminance":148.15570261383797},{"name":"Golden Fleece","hex":"#edd9aa","rgb":{"r":237,"g":217,"b":170},"luminance":147.04611116925193},{"name":"Golden Fog","hex":"#f0ead2","rgb":{"r":240,"g":234,"b":210},"luminance":156.8114835208187},{"name":"Golden Foil","hex":"#cccc00","rgb":{"r":204,"g":204,"b":0},"luminance":134.3878548083866},{"name":"Golden Foliage","hex":"#bdd043","rgb":{"r":189,"g":208,"b":67},"luminance":134.75631851976365},{"name":"Golden Fragrance","hex":"#eeee99","rgb":{"r":238,"g":238,"b":153},"luminance":157.7530349755592},{"name":"Golden Gate","hex":"#d9c09c","rgb":{"r":217,"g":192,"b":156},"luminance":131.2564892148194},{"name":"Golden Gate Bridge","hex":"#c0362d","rgb":{"r":192,"g":54,"b":45},"luminance":65.7781009759327},{"name":"Golden Glam","hex":"#eebb44","rgb":{"r":238,"g":187,"b":68},"luminance":131.0471560507896},{"name":"Golden Glitter","hex":"#fbe573","rgb":{"r":251,"g":229,"b":115},"luminance":154.5113828492904},{"name":"Golden Glow","hex":"#f9d77e","rgb":{"r":249,"g":215,"b":126},"luminance":147.2310358654044},{"name":"Golden Grain","hex":"#c59137","rgb":{"r":197,"g":145,"b":55},"luminance":103.69879234590921},{"name":"Golden Granola","hex":"#b8996b","rgb":{"r":184,"g":153,"b":107},"luminance":106.02625703569846},{"name":"Golden Grass","hex":"#daa631","rgb":{"r":218,"g":166,"b":49},"luminance":117.36626382397968},{"name":"Golden Green","hex":"#bdb369","rgb":{"r":189,"g":179,"b":105},"luminance":119.90458435773003},{"name":"Golden Griffon","hex":"#a99058","rgb":{"r":169,"g":144,"b":88},"luminance":98.98992761387393},{"name":"Golden Guernsey","hex":"#e1c3bb","rgb":{"r":225,"g":195,"b":187},"luminance":134.4716288813369},{"name":"Golden Gun","hex":"#dddd00","rgb":{"r":221,"g":221,"b":0},"luminance":145.5868427090855},{"name":"Golden Hamster","hex":"#da9e38","rgb":{"r":218,"g":158,"b":56},"luminance":113.53972474865351},{"name":"Golden Handshake","hex":"#ffcc44","rgb":{"r":255,"g":204,"b":68},"luminance":142.1723497484655},{"name":"Golden Harmony","hex":"#9f8046","rgb":{"r":159,"g":128,"b":70},"luminance":89.27063110004319},{"name":"Golden Haze","hex":"#fbd897","rgb":{"r":251,"g":216,"b":151},"luminance":148.34043771338952},{"name":"Golden Hermes","hex":"#ffffbb","rgb":{"r":255,"g":255,"b":187},"luminance":169.33208902626816},{"name":"Golden Hind","hex":"#a37111","rgb":{"r":163,"g":113,"b":17},"luminance":82.33378756015054},{"name":"Golden History","hex":"#bb993a","rgb":{"r":187,"g":153,"b":58},"luminance":105.99998978301836},{"name":"Golden Hominy","hex":"#edc283","rgb":{"r":237,"g":194,"b":131},"luminance":134.95476282443684},{"name":"Golden Hop","hex":"#cfdd7b","rgb":{"r":207,"g":221,"b":123},"luminance":144.41763902653997},{"name":"Golden Impression","hex":"#ffefcb","rgb":{"r":255,"g":239,"b":203},"luminance":161.34118518840748},{"name":"Golden Kiwi","hex":"#f3dd3e","rgb":{"r":243,"g":221,"b":62},"luminance":148.8559397605618},{"name":"Golden Koi","hex":"#eaa34b","rgb":{"r":234,"g":163,"b":75},"luminance":118.84105947440892},{"name":"Golden Lime","hex":"#9a9738","rgb":{"r":154,"g":151,"b":56},"luminance":100.087498425128},{"name":"Golden Lock","hex":"#f5bc1d","rgb":{"r":245,"g":188,"b":29},"luminance":132.49781657446283},{"name":"Golden Lotus","hex":"#e9dbc4","rgb":{"r":233,"g":219,"b":196},"luminance":147.91422863943822},{"name":"Golden Marguerite","hex":"#fdcc37","rgb":{"r":253,"g":204,"b":55},"luminance":141.77928273552521},{"name":"Golden Mary","hex":"#f0be3a","rgb":{"r":240,"g":190,"b":58},"luminance":132.7861327247691},{"name":"Golden Mist","hex":"#d5cd94","rgb":{"r":213,"g":205,"b":148},"luminance":137.19041722365304},{"name":"Golden Moray Eel","hex":"#ffcf60","rgb":{"r":255,"g":207,"b":96},"luminance":143.86628598111508},{"name":"Golden Mushroom","hex":"#f4e8d1","rgb":{"r":244,"g":232,"b":209},"luminance":156.32126556550136},{"name":"Golden Nectar","hex":"#ffda68","rgb":{"r":255,"g":218,"b":104},"luminance":149.42945465001202},{"name":"Golden Nugget","hex":"#db9b59","rgb":{"r":219,"g":155,"b":89},"luminance":112.55653202724397},{"name":"Golden Oak","hex":"#be752d","rgb":{"r":190,"g":117,"b":45},"luminance":89.27764580789527},{"name":"Golden Ochre","hex":"#c77943","rgb":{"r":199,"g":121,"b":67},"luminance":92.9706554456835},{"name":"Golden Olive","hex":"#af9841","rgb":{"r":175,"g":152,"b":65},"luminance":103.70022131606083},{"name":"Golden Opportunity","hex":"#f7c070","rgb":{"r":247,"g":192,"b":112},"luminance":135.34947007284512},{"name":"Golden Orange","hex":"#d7942d","rgb":{"r":215,"g":148,"b":45},"luminance":108.19573698163896},{"name":"Golden Palm","hex":"#aa8805","rgb":{"r":170,"g":136,"b":5},"luminance":94.64228454554548},{"name":"Golden Passionfruit","hex":"#b4bb31","rgb":{"r":180,"g":187,"b":49},"luminance":122.38067313509923},{"name":"Golden Pheasant","hex":"#cf9632","rgb":{"r":207,"g":150,"b":50},"luminance":107.77771545639663},{"name":"Golden Pilsner","hex":"#956f3f","rgb":{"r":149,"g":111,"b":63},"luminance":79.2578537054846},{"name":"Golden Poppy","hex":"#fcc200","rgb":{"r":252,"g":194,"b":0},"luminance":136.54859936301068},{"name":"Golden Raspberry","hex":"#f8d878","rgb":{"r":248,"g":216,"b":120},"luminance":147.51905899916795},{"name":"Golden Rays","hex":"#f6da74","rgb":{"r":246,"g":218,"b":116},"luminance":148.1902906671014},{"name":"Golden Retriever","hex":"#eedec7","rgb":{"r":238,"g":222,"b":199},"luminance":150.20127641268564},{"name":"Golden Rice","hex":"#e3d474","rgb":{"r":227,"g":212,"b":116},"luminance":142.36547137912336},{"name":"Golden Rule","hex":"#daae49","rgb":{"r":218,"g":174,"b":73},"luminance":121.45007143678426},{"name":"Golden Sand","hex":"#eace6a","rgb":{"r":234,"g":206,"b":106},"luminance":140.22622542163788},{"name":"Golden Schnitzel","hex":"#ddbb11","rgb":{"r":221,"g":187,"b":17},"luminance":128.13829812355087},{"name":"Golden Slumber","hex":"#b98841","rgb":{"r":185,"g":136,"b":65},"luminance":97.40536714678508},{"name":"Golden Snitch","hex":"#f1e346","rgb":{"r":241,"g":227,"b":70},"luminance":151.69533902529767},{"name":"Golden Spice","hex":"#c6973f","rgb":{"r":198,"g":151,"b":63},"luminance":106.83152950791259},{"name":"Golden Straw","hex":"#f5edae","rgb":{"r":245,"g":237,"b":174},"luminance":158.47352486141023},{"name":"Golden Tainoi","hex":"#ffc152","rgb":{"r":255,"g":193,"b":82},"luminance":136.87781343227252},{"name":"Golden Wash","hex":"#fffec6","rgb":{"r":255,"g":254,"b":198},"luminance":168.97635578091982},{"name":"Golden West","hex":"#e9ca94","rgb":{"r":233,"g":202,"b":148},"luminance":138.55666259332315},{"name":"Golden Yarrow","hex":"#e2c74f","rgb":{"r":226,"g":199,"b":79},"luminance":135.25025131584783},{"name":"Golden Yellow","hex":"#ffdf00","rgb":{"r":255,"g":223,"b":0},"luminance":151.48720020516583},{"name":"Goldenrod","hex":"#fdcb18","rgb":{"r":253,"g":203,"b":24},"luminance":141.1711664115587},{"name":"Goldfinch","hex":"#f8dc6c","rgb":{"r":248,"g":220,"b":108},"luminance":149.4230372064495},{"name":"Goldfinger","hex":"#eebb11","rgb":{"r":238,"g":187,"b":17},"luminance":130.83202761174343},{"name":"Goldfish","hex":"#f2ad62","rgb":{"r":242,"g":173,"b":98},"luminance":125.19224955643219},{"name":"Goldie","hex":"#c89d3f","rgb":{"r":200,"g":157,"b":63},"luminance":110.09496993505196},{"name":"Goldilocks","hex":"#fff39a","rgb":{"r":255,"g":243,"b":154},"luminance":162.68979083519653},{"name":"Goldvreneli 1882","hex":"#e7de54","rgb":{"r":231,"g":222,"b":84},"luminance":147.7970403391083},{"name":"Golem","hex":"#836e59","rgb":{"r":131,"g":110,"b":89},"luminance":76.1999788517031},{"name":"Golf Blazer","hex":"#53a391","rgb":{"r":83,"g":163,"b":145},"luminance":100.21964952044085},{"name":"Golf Course","hex":"#5a9e4b","rgb":{"r":90,"g":158,"b":75},"luminance":96.94880667651357},{"name":"Golf Green","hex":"#008763","rgb":{"r":0,"g":135,"b":99},"luminance":80.04463642868271},{"name":"Golfer Green","hex":"#5e6841","rgb":{"r":94,"g":104,"b":65},"luminance":67.61444845593284},{"name":"Golgfag Brown","hex":"#d77e70","rgb":{"r":215,"g":126,"b":112},"luminance":98.8228743409136},{"name":"Goluboy Blue","hex":"#8bb9dd","rgb":{"r":139,"g":185,"b":221},"luminance":118.97448626491311},{"name":"Gomashio Yellow","hex":"#cc9933","rgb":{"r":204,"g":153,"b":51},"luminance":108.72134258276982},{"name":"Gondola","hex":"#373332","rgb":{"r":55,"g":51,"b":50},"luminance":34.62877407590398},{"name":"Gondolier","hex":"#5db1c5","rgb":{"r":93,"g":177,"b":197},"luminance":109.87535307793098},{"name":"Gone Giddy","hex":"#d9c737","rgb":{"r":217,"g":199,"b":55},"luminance":133.76992770424897},{"name":"Gonzo Violet","hex":"#5d06e9","rgb":{"r":93,"g":6,"b":233},"luminance":38.61571670965075},{"name":"Good Graces","hex":"#f3f0d6","rgb":{"r":243,"g":240,"b":214},"luminance":160.37886040560332},{"name":"Good Karma","hex":"#333c76","rgb":{"r":51,"g":60,"b":118},"luminance":40.6686206429478},{"name":"Good Life","hex":"#c49e69","rgb":{"r":196,"g":158,"b":105},"luminance":110.3609089850206},{"name":"Good Luck Charm","hex":"#9d865c","rgb":{"r":157,"g":134,"b":92},"luminance":92.19937286663071},{"name":"Good Morning","hex":"#fcfcda","rgb":{"r":252,"g":252,"b":218},"luminance":167.8584307802262},{"name":"Good Morning Akihabara","hex":"#f4ead5","rgb":{"r":244,"g":234,"b":213},"luminance":157.41478210130077},{"name":"Good Night!","hex":"#46565f","rgb":{"r":70,"g":86,"b":95},"luminance":55.711633650432475},{"name":"Good Samaritan","hex":"#3f6782","rgb":{"r":63,"g":103,"b":130},"luminance":65.03843086975577},{"name":"Goodbye Kiss","hex":"#d9cac3","rgb":{"r":217,"g":202,"b":195},"luminance":136.98091131613924},{"name":"Goody Gumdrop","hex":"#ccd87a","rgb":{"r":204,"g":216,"b":122},"luminance":141.38654725255864},{"name":"Goody Two Shoes","hex":"#c2ba8e","rgb":{"r":194,"g":186,"b":142},"luminance":124.68944022650834},{"name":"Goose Bill","hex":"#7b6c7c","rgb":{"r":123,"g":108,"b":124},"luminance":74.64199247742519},{"name":"Goose Wing Grey","hex":"#a89dac","rgb":{"r":168,"g":157,"b":172},"luminance":106.77550640947575},{"name":"Gooseberry Fool","hex":"#acb75f","rgb":{"r":172,"g":183,"b":95},"luminance":119.58845815964013},{"name":"Gorā White","hex":"#f0f0e0","rgb":{"r":240,"g":240,"b":224},"luminance":160.15230031441945},{"name":"Gordons Green","hex":"#29332b","rgb":{"r":41,"g":51,"b":43},"luminance":32.7190564350502},{"name":"Gorgeous Green","hex":"#287c37","rgb":{"r":40,"g":124,"b":55},"luminance":74.03004419828478},{"name":"Gorgonzola Blue","hex":"#4455cc","rgb":{"r":68,"g":85,"b":204},"luminance":58.683411497628526},{"name":"Gorse","hex":"#fde336","rgb":{"r":253,"g":227,"b":54},"luminance":153.34816903373837},{"name":"Gorthor Brown","hex":"#654741","rgb":{"r":101,"g":71,"b":65},"luminance":51.99865411719807},{"name":"Gory Red","hex":"#a30800","rgb":{"r":163,"g":8,"b":0},"luminance":48.962716274732955},{"name":"Goshawk Grey","hex":"#444444","rgb":{"r":68,"g":68,"b":68},"luminance":45.46175078018883},{"name":"Gossamer","hex":"#399f86","rgb":{"r":57,"g":159,"b":134},"luminance":96.09822534261494},{"name":"Gossamer Green","hex":"#b2cfbe","rgb":{"r":178,"g":207,"b":190},"luminance":134.41046821211506},{"name":"Gossamer Pink","hex":"#fac8c3","rgb":{"r":250,"g":200,"b":195},"luminance":140.9414608977784},{"name":"Gossamer Wings","hex":"#e8eee9","rgb":{"r":232,"g":238,"b":233},"luminance":158.22523725373267},{"name":"Gossip","hex":"#9fd385","rgb":{"r":159,"g":211,"b":133},"luminance":133.53122995763948},{"name":"Gothic","hex":"#698890","rgb":{"r":105,"g":136,"b":144},"luminance":87.34002121021038},{"name":"Gothic Amethyst","hex":"#a38b93","rgb":{"r":163,"g":139,"b":147},"luminance":96.50670122846391},{"name":"Gothic Gold","hex":"#bb852f","rgb":{"r":187,"g":133,"b":47},"luminance":96.17719466692715},{"name":"Gothic Grape","hex":"#473951","rgb":{"r":71,"g":57,"b":81},"luminance":40.687121770899445},{"name":"Gothic Olive","hex":"#7c6e4f","rgb":{"r":124,"g":110,"b":79},"luminance":75.00015141318048},{"name":"Gothic Revival Green","hex":"#a0a160","rgb":{"r":160,"g":161,"b":96},"luminance":106.48948203930752},{"name":"Gothic Spire","hex":"#7c6b6f","rgb":{"r":124,"g":107,"b":111},"luminance":74.02515770331057},{"name":"Gotta Have It","hex":"#d0c2b4","rgb":{"r":208,"g":194,"b":180},"luminance":131.36633567242407},{"name":"Gouda Gold","hex":"#eecc11","rgb":{"r":238,"g":204,"b":17},"luminance":139.31033555339673},{"name":"Goulash","hex":"#8d6449","rgb":{"r":141,"g":100,"b":73},"luminance":72.74838118473839},{"name":"Gould Blue","hex":"#7d9ea2","rgb":{"r":125,"g":158,"b":162},"luminance":101.68469975861659},{"name":"Gould Gold","hex":"#bc9d70","rgb":{"r":188,"g":157,"b":112},"luminance":108.70184933569436},{"name":"Gourmet Honey","hex":"#e3cba8","rgb":{"r":227,"g":203,"b":168},"luminance":138.46619498635758},{"name":"Government Green","hex":"#32493e","rgb":{"r":50,"g":73,"b":62},"luminance":45.93111499844087},{"name":"Governor Bay","hex":"#51559b","rgb":{"r":81,"g":85,"b":155},"luminance":58.209104837645455},{"name":"Graceful","hex":"#a8c0ce","rgb":{"r":168,"g":192,"b":206},"luminance":125.60630436407241},{"name":"Graceful Gazelle","hex":"#a78a50","rgb":{"r":167,"g":138,"b":80},"luminance":95.59524530540209},{"name":"Graceful Green","hex":"#acb7a8","rgb":{"r":172,"g":183,"b":168},"luminance":120.62715087823304},{"name":"Graceland Grass","hex":"#546c46","rgb":{"r":84,"g":108,"b":70},"luminance":68.65527417467648},{"name":"Gracilis","hex":"#c4d5cb","rgb":{"r":196,"g":213,"b":203},"luminance":140.00975659217468},{"name":"Gracious","hex":"#f8edd7","rgb":{"r":248,"g":237,"b":215},"luminance":159.5410773594061},{"name":"Gracious Glow","hex":"#bab078","rgb":{"r":186,"g":176,"b":120},"luminance":118.12463223223173},{"name":"Graham Cracker","hex":"#c0a480","rgb":{"r":192,"g":164,"b":128},"luminance":113.0315564433225},{"name":"Grain Brown","hex":"#cab8a2","rgb":{"r":202,"g":184,"b":162},"luminance":125.1187975166002},{"name":"Grain Mill","hex":"#d8c095","rgb":{"r":216,"g":192,"b":149},"luminance":131.00308724606452},{"name":"Grain of Salt","hex":"#d8dbe1","rgb":{"r":216,"g":219,"b":225},"luminance":146.1331220668333},{"name":"Grainfield","hex":"#b79e66","rgb":{"r":183,"g":158,"b":102},"luminance":108.30965325860849},{"name":"Gram's Hair","hex":"#f5f6f7","rgb":{"r":245,"g":246,"b":247},"luminance":164.35055702065628},{"name":"Gran Torino Red","hex":"#ee3300","rgb":{"r":238,"g":51,"b":0},"luminance":77.20268268007271},{"name":"Granada Sky","hex":"#5d81bb","rgb":{"r":93,"g":129,"b":187},"luminance":83.43655734748408},{"name":"Grand Avenue","hex":"#665a48","rgb":{"r":102,"g":90,"b":72},"luminance":61.550858385565995},{"name":"Grand Bleu","hex":"#015482","rgb":{"r":1,"g":84,"b":130},"luminance":51.48786910525624},{"name":"Grand Gusto","hex":"#86bb9d","rgb":{"r":134,"g":187,"b":157},"luminance":118.21529563047245},{"name":"Grand Piano","hex":"#d8d0bd","rgb":{"r":216,"g":208,"b":189},"luminance":139.79540903763612},{"name":"Grand Poobah","hex":"#864764","rgb":{"r":134,"g":71,"b":100},"luminance":58.925518113971634},{"name":"Grand Purple","hex":"#534778","rgb":{"r":83,"g":71,"b":120},"luminance":50.39839499428528},{"name":"Grandiflora Rose","hex":"#e0ebaf","rgb":{"r":224,"g":235,"b":175},"luminance":154.63702694050994},{"name":"Grandiose","hex":"#caa84c","rgb":{"r":202,"g":168,"b":76},"luminance":115.9659379128199},{"name":"Grandis","hex":"#ffcd73","rgb":{"r":255,"g":205,"b":115},"luminance":143.05832499368918},{"name":"Grandma's Cameo","hex":"#f7e7dd","rgb":{"r":247,"g":231,"b":221},"luminance":156.44663516355982},{"name":"Grange Hall","hex":"#857767","rgb":{"r":133,"g":119,"b":103},"luminance":81.23257020432136},{"name":"Granita","hex":"#a52350","rgb":{"r":165,"g":35,"b":80},"luminance":54.214515122797145},{"name":"Granite","hex":"#746a5e","rgb":{"r":116,"g":106,"b":94},"luminance":72.03741941519004},{"name":"Granite Boulder","hex":"#816f6b","rgb":{"r":129,"g":111,"b":107},"luminance":76.69385825475206},{"name":"Granite Canyon","hex":"#6c6f78","rgb":{"r":108,"g":111,"b":120},"luminance":73.99561009276158},{"name":"Granite Falls","hex":"#638496","rgb":{"r":99,"g":132,"b":150},"luminance":84.6900198193388},{"name":"Granite Green","hex":"#8b8265","rgb":{"r":139,"g":130,"b":101},"luminance":87.65332290906034},{"name":"Granite Grey","hex":"#615e5f","rgb":{"r":97,"g":94,"b":95},"luminance":63.2698553262136},{"name":"Granny Apple","hex":"#c5e7cd","rgb":{"r":197,"g":231,"b":205},"luminance":149.67386785274172},{"name":"Granny Smith","hex":"#7b948c","rgb":{"r":123,"g":148,"b":140},"luminance":95.6802419781639},{"name":"Granny Smith Apple","hex":"#9de093","rgb":{"r":157,"g":224,"b":147},"luminance":140.61852636477172},{"name":"Granola","hex":"#f5ce9f","rgb":{"r":245,"g":206,"b":159},"luminance":142.53763357443535},{"name":"Grant Drab","hex":"#8f8461","rgb":{"r":143,"g":132,"b":97},"luminance":89.18638163419345},{"name":"Grant Village","hex":"#6c90b2","rgb":{"r":108,"g":144,"b":178},"luminance":92.73360400631478},{"name":"Grant Wood Ivy","hex":"#a8b989","rgb":{"r":168,"g":185,"b":137},"luminance":120.66503127667103},{"name":"Granular Limestone","hex":"#e3e0da","rgb":{"r":227,"g":224,"b":218},"luminance":150.0448605484373},{"name":"Granulated Sugar","hex":"#fffdf2","rgb":{"r":255,"g":253,"b":242},"luminance":169.20376736349576},{"name":"Grape","hex":"#6c3461","rgb":{"r":108,"g":52,"b":97},"luminance":45.79047066803311},{"name":"Grape Arbor","hex":"#a598c7","rgb":{"r":165,"g":152,"b":199},"luminance":104.44864286815793},{"name":"Grape Candy","hex":"#905284","rgb":{"r":144,"g":82,"b":132},"luminance":66.31095984827847},{"name":"Grape Cassata","hex":"#dfe384","rgb":{"r":223,"g":227,"b":132},"luminance":149.75834078274238},{"name":"Grape Compote","hex":"#6b5876","rgb":{"r":107,"g":88,"b":118},"luminance":62.23223191401703},{"name":"Grape Expectations","hex":"#6a587e","rgb":{"r":106,"g":88,"b":126},"luminance":62.28303515404495},{"name":"Grape Gatsby","hex":"#a19abd","rgb":{"r":161,"g":154,"b":189},"luminance":104.65845327062692},{"name":"Grape Glimmer","hex":"#dccae0","rgb":{"r":220,"g":202,"b":224},"luminance":137.98148126469727},{"name":"Grape Green","hex":"#a8e4a0","rgb":{"r":168,"g":228,"b":160},"luminance":144.1111595956399},{"name":"Grape Grey","hex":"#6d6166","rgb":{"r":109,"g":97,"b":102},"luminance":66.62907312877765},{"name":"Grape Harvest","hex":"#807697","rgb":{"r":128,"g":118,"b":151},"luminance":80.98670592140415},{"name":"Grape Haze","hex":"#606a88","rgb":{"r":96,"g":106,"b":136},"luminance":70.25575361491754},{"name":"Grape Hyacinth","hex":"#5533cc","rgb":{"r":85,"g":51,"b":204},"luminance":45.63976040690836},{"name":"Grape Jam","hex":"#7f779a","rgb":{"r":127,"g":119,"b":154},"luminance":81.4223769856911},{"name":"Grape Jelly","hex":"#7e667f","rgb":{"r":126,"g":102,"b":127},"luminance":72.20691543058739},{"name":"Grape Juice","hex":"#682961","rgb":{"r":104,"g":41,"b":97},"luminance":40.84679998482133},{"name":"Grape Kiss","hex":"#7b4368","rgb":{"r":123,"g":67,"b":104},"luminance":55.135131322959595},{"name":"Grape Leaf","hex":"#545144","rgb":{"r":84,"g":81,"b":68},"luminance":54.32885208616136},{"name":"Grape Leaves","hex":"#576049","rgb":{"r":87,"g":96,"b":73},"luminance":62.621719530846484},{"name":"Grape Nectar","hex":"#8d5c74","rgb":{"r":141,"g":92,"b":116},"luminance":69.77598063087326},{"name":"Grape Popsicle","hex":"#60406d","rgb":{"r":96,"g":64,"b":109},"luminance":48.884350420149794},{"name":"Grape Purple","hex":"#5d1451","rgb":{"r":93,"g":20,"b":81},"luminance":31.564594168149856},{"name":"Grape Royale","hex":"#4f2d54","rgb":{"r":79,"g":45,"b":84},"luminance":36.7069971803742},{"name":"Grape Shake","hex":"#886971","rgb":{"r":136,"g":105,"b":113},"luminance":74.95585397418937},{"name":"Grape Soda","hex":"#ae94a6","rgb":{"r":174,"g":148,"b":166},"luminance":103.01583289960818},{"name":"Grape Taffy","hex":"#f4daf1","rgb":{"r":244,"g":218,"b":241},"luminance":149.84223626200992},{"name":"Grape Wine","hex":"#5a2f43","rgb":{"r":90,"g":47,"b":67},"luminance":39.289185089538314},{"name":"Grapeade","hex":"#aa9fb2","rgb":{"r":170,"g":159,"b":178},"luminance":108.19659446119364},{"name":"Grapefruit","hex":"#fd5956","rgb":{"r":253,"g":89,"b":86},"luminance":92.45495159265401},{"name":"Grapefruit Juice","hex":"#ee6d8a","rgb":{"r":238,"g":109,"b":138},"luminance":96.98118558256543},{"name":"Grapefruit Pulp","hex":"#fe6f5e","rgb":{"r":254,"g":111,"b":94},"luminance":100.63827413563887},{"name":"Grapemist","hex":"#8398ca","rgb":{"r":131,"g":152,"b":202},"luminance":100.1270269258006},{"name":"Grapes of Wrath","hex":"#58424c","rgb":{"r":88,"g":66,"b":76},"luminance":47.626975591569945},{"name":"Grapeshot","hex":"#71384b","rgb":{"r":113,"g":56,"b":75},"luminance":47.90858224786035},{"name":"Grapevine","hex":"#b194a6","rgb":{"r":177,"g":148,"b":166},"luminance":103.47174049468771},{"name":"Grapevine Canyon","hex":"#62534f","rgb":{"r":98,"g":83,"b":79},"luminance":57.56258403685505},{"name":"Graphical 80's Sky","hex":"#0000fc","rgb":{"r":0,"g":0,"b":252},"luminance":28.728},{"name":"Graphite","hex":"#383428","rgb":{"r":56,"g":52,"b":40},"luminance":35.11224447397232},{"name":"Grapple","hex":"#92786a","rgb":{"r":146,"g":120,"b":106},"luminance":83.74657230000521},{"name":"Grasping Grass","hex":"#92b300","rgb":{"r":146,"g":179,"b":0},"luminance":113.78052137778239},{"name":"Grass","hex":"#5cac2d","rgb":{"r":92,"g":172,"b":45},"luminance":104.76992058792447},{"name":"Grass Blade","hex":"#636f46","rgb":{"r":99,"g":111,"b":70},"luminance":72.0092650288836},{"name":"Grass Court","hex":"#088d46","rgb":{"r":8,"g":141,"b":70},"luminance":83.18520513288405},{"name":"Grass Daisy","hex":"#ceb02a","rgb":{"r":206,"g":176,"b":42},"luminance":120.3748940767966},{"name":"Grass Green","hex":"#3f9b0b","rgb":{"r":63,"g":155,"b":11},"luminance":92.9229536228805},{"name":"Grass Root","hex":"#c3c175","rgb":{"r":195,"g":193,"b":117},"luminance":128.11021017077445},{"name":"Grass Sands","hex":"#a1afa0","rgb":{"r":161,"g":175,"b":160},"luminance":114.90207372367131},{"name":"Grass Skirt","hex":"#e2dac2","rgb":{"r":226,"g":218,"b":194},"luminance":146.3921448985566},{"name":"Grass Stain Green","hex":"#c0fb2d","rgb":{"r":192,"g":251,"b":45},"luminance":158.20931367337386},{"name":"Grass Valley","hex":"#f4f7ee","rgb":{"r":244,"g":247,"b":238},"luminance":164.56164036919418},{"name":"Grasshopper","hex":"#77824a","rgb":{"r":119,"g":130,"b":74},"luminance":84.61908624536193},{"name":"Grassroots","hex":"#d8c475","rgb":{"r":216,"g":196,"b":117},"luminance":132.61205829033798},{"name":"Grassy Green","hex":"#419c03","rgb":{"r":65,"g":156,"b":3},"luminance":93.6123248990217},{"name":"Grassy Meadow","hex":"#76a55b","rgb":{"r":118,"g":165,"b":91},"luminance":103.60178775001906},{"name":"Grated Beet","hex":"#a60e46","rgb":{"r":166,"g":14,"b":70},"luminance":50.938687458551584},{"name":"Gratefully Grass","hex":"#71714e","rgb":{"r":113,"g":113,"b":78},"luminance":74.96953110430931},{"name":"Gratitude","hex":"#e0ead7","rgb":{"r":224,"g":234,"b":215},"luminance":154.76997396135985},{"name":"Grauzone","hex":"#85a3b2","rgb":{"r":133,"g":163,"b":178},"luminance":105.58424747091775},{"name":"Gravel","hex":"#4a4b46","rgb":{"r":74,"g":75,"b":70},"luminance":49.91433562615053},{"name":"Gravel Dust","hex":"#bab9a9","rgb":{"r":186,"g":185,"b":169},"luminance":123.51910693087122},{"name":"Gravel Fint","hex":"#bbbbbb","rgb":{"r":187,"g":187,"b":187},"luminance":125.01981464551929},{"name":"Graveyard Earth","hex":"#68553a","rgb":{"r":104,"g":85,"b":58},"luminance":59.162410236568284},{"name":"Great Coat Grey","hex":"#7f8488","rgb":{"r":127,"g":132,"b":136},"luminance":87.67036558039437},{"name":"Great Dane","hex":"#d1a369","rgb":{"r":209,"g":163,"b":105},"luminance":114.90543826120677},{"name":"Great Fennel Flower","hex":"#719ba2","rgb":{"r":113,"g":155,"b":162},"luminance":98.79726017456152},{"name":"Great Grape","hex":"#6b6d85","rgb":{"r":107,"g":109,"b":133},"luminance":73.12497919315943},{"name":"Great Joy","hex":"#d8e6cb","rgb":{"r":216,"g":230,"b":203},"luminance":151.44089711831478},{"name":"Great Serpent","hex":"#4a72a3","rgb":{"r":74,"g":114,"b":163},"luminance":72.88943218327331},{"name":"Great Tit Eggs","hex":"#e9e2db","rgb":{"r":233,"g":226,"b":219},"luminance":151.90786118236278},{"name":"Great Void","hex":"#3b5760","rgb":{"r":59,"g":87,"b":96},"luminance":55.1272961245153},{"name":"Great White","hex":"#bdbdc6","rgb":{"r":189,"g":189,"b":198},"luminance":126.53591408766128},{"name":"Grecian Gold","hex":"#9e7e54","rgb":{"r":158,"g":126,"b":84},"luminance":88.28297561817907},{"name":"Grecian Isle","hex":"#00a49b","rgb":{"r":0,"g":164,"b":155},"luminance":97.8762316601942},{"name":"Greedo Green","hex":"#00aa66","rgb":{"r":0,"g":170,"b":102},"luminance":100.46519040941494},{"name":"Greedy Gecko","hex":"#aa9922","rgb":{"r":170,"g":153,"b":34},"luminance":103.27016992820336},{"name":"Greedy Gold","hex":"#c4ce3b","rgb":{"r":196,"g":206,"b":59},"luminance":134.54292242998145},{"name":"Greedy Green","hex":"#d1ffbd","rgb":{"r":209,"g":255,"b":189},"luminance":163.63054244852947},{"name":"Greek Aubergine","hex":"#3d0734","rgb":{"r":61,"g":7,"b":52},"luminance":19.61341851896298},{"name":"Greek Flag Blue","hex":"#0d5eaf","rgb":{"r":13,"g":94,"b":175},"luminance":58.80240601369981},{"name":"Greek Lavender","hex":"#9b8fb0","rgb":{"r":155,"g":143,"b":176},"luminance":97.96180174945741},{"name":"Greek Sea","hex":"#72a7e1","rgb":{"r":114,"g":167,"b":225},"luminance":106.90866539715103},{"name":"Green","hex":"#00ff00","rgb":{"r":0,"g":255,"b":0},"luminance":149.685},{"name":"Green 383","hex":"#3e3d29","rgb":{"r":62,"g":61,"b":41},"luminance":40.59119324434796},{"name":"Green Alabaster","hex":"#c8ccba","rgb":{"r":200,"g":204,"b":186},"luminance":135.51838664919237},{"name":"Green Apple","hex":"#5edc1f","rgb":{"r":94,"g":220,"b":31},"luminance":132.2103475224235},{"name":"Green Apple Martini","hex":"#d2c785","rgb":{"r":210,"g":199,"b":133},"luminance":133.48313493846328},{"name":"Green Ash","hex":"#a0daa9","rgb":{"r":160,"g":218,"b":169},"luminance":137.96790029568473},{"name":"Green Balloon","hex":"#80c4a9","rgb":{"r":128,"g":196,"b":169},"luminance":122.7716882835778},{"name":"Green Banana","hex":"#a8b453","rgb":{"r":168,"g":180,"b":83},"luminance":117.37469432548056},{"name":"Green Bark","hex":"#a9c4a6","rgb":{"r":169,"g":196,"b":166},"luminance":127.07660068242302},{"name":"Green Bay","hex":"#7e9285","rgb":{"r":126,"g":146,"b":133},"luminance":94.83696180287515},{"name":"Green Bayou","hex":"#566e57","rgb":{"r":86,"g":110,"b":87},"luminance":70.2058503260234},{"name":"Green Bell Pepper","hex":"#228800","rgb":{"r":34,"g":136,"b":0},"luminance":80.47667848513629},{"name":"Green Belt","hex":"#2d7f6c","rgb":{"r":45,"g":127,"b":108},"luminance":76.74748054496642},{"name":"Green Beret","hex":"#516a62","rgb":{"r":81,"g":106,"b":98},"luminance":67.69749499796872},{"name":"Green Blue","hex":"#42b395","rgb":{"r":66,"g":179,"b":149},"luminance":108.25105210112278},{"name":"Green Blue Slate","hex":"#358082","rgb":{"r":53,"g":128,"b":130},"luminance":78.20599916246834},{"name":"Green Brocade","hex":"#daf1e0","rgb":{"r":218,"g":241,"b":224},"luminance":157.84071879271204},{"name":"Green Brown","hex":"#696006","rgb":{"r":105,"g":96,"b":6},"luminance":64.51094314145469},{"name":"Green Buoy","hex":"#32a7b5","rgb":{"r":50,"g":167,"b":181},"luminance":101.28647144115546},{"name":"Green Bush","hex":"#7f8866","rgb":{"r":127,"g":136,"b":102},"luminance":89.16449594429388},{"name":"Green Cacophony","hex":"#bbee11","rgb":{"r":187,"g":238,"b":17},"luminance":150.49181322915874},{"name":"Green Caterpillar","hex":"#98be3c","rgb":{"r":152,"g":190,"b":60},"luminance":120.62855053427442},{"name":"Green Chalk","hex":"#bcdf8a","rgb":{"r":188,"g":223,"b":138},"luminance":143.32604986184472},{"name":"Green Coconut","hex":"#868e65","rgb":{"r":134,"g":142,"b":101},"luminance":93.19734903955154},{"name":"Green Cow","hex":"#beef69","rgb":{"r":190,"g":239,"b":105},"luminance":151.83142905538364},{"name":"Green Crush","hex":"#62ae9e","rgb":{"r":98,"g":174,"b":158},"luminance":107.77388548252308},{"name":"Green Cyan","hex":"#009966","rgb":{"r":0,"g":153,"b":102},"luminance":90.56062116063471},{"name":"Green Darner Tail","hex":"#75bbfd","rgb":{"r":117,"g":187,"b":253},"luminance":118.76407122526575},{"name":"Green Daze","hex":"#8bd3c6","rgb":{"r":139,"g":211,"b":198},"luminance":132.57966795100972},{"name":"Green Dragon","hex":"#006c67","rgb":{"r":0,"g":108,"b":103},"luminance":64.4742381110471},{"name":"Green Dragon Spring","hex":"#c1cab0","rgb":{"r":193,"g":202,"b":176},"luminance":133.38836313936835},{"name":"Green Eggs","hex":"#e3ecc5","rgb":{"r":227,"g":236,"b":197},"luminance":155.89169611303868},{"name":"Green Eggs and Ham","hex":"#7cb68e","rgb":{"r":124,"g":182,"b":142},"luminance":114.23740488999212},{"name":"Green Elliott","hex":"#00bb66","rgb":{"r":0,"g":187,"b":102},"luminance":110.38316785180609},{"name":"Green Emulsion","hex":"#daeae2","rgb":{"r":218,"g":234,"b":226},"luminance":154.20666971308344},{"name":"Green Envy","hex":"#77aa00","rgb":{"r":119,"g":170,"b":0},"luminance":105.94362491910498},{"name":"Green Epiphany","hex":"#7efbb3","rgb":{"r":126,"g":251,"b":179},"luminance":153.44030331369916},{"name":"Green Essence","hex":"#e9eac8","rgb":{"r":233,"g":234,"b":200},"luminance":155.6937733276447},{"name":"Green Eyes","hex":"#7d956d","rgb":{"r":125,"g":149,"b":109},"luminance":95.92222093967591},{"name":"Green Fiasco","hex":"#aaee00","rgb":{"r":170,"g":238,"b":0},"luminance":148.66558221727044},{"name":"Green Fingers","hex":"#297e6b","rgb":{"r":41,"g":126,"b":107},"luminance":75.95690705261767},{"name":"Green Flash","hex":"#79c753","rgb":{"r":121,"g":199,"b":83},"luminance":122.6528697340588},{"name":"Green Flavor","hex":"#bbaa22","rgb":{"r":187,"g":170,"b":34},"luminance":114.45230904180133},{"name":"Green Fluorite","hex":"#55bbaa","rgb":{"r":85,"g":187,"b":170},"luminance":114.3273370021361},{"name":"Green Fog","hex":"#989a87","rgb":{"r":152,"g":154,"b":135},"luminance":102.34339845832754},{"name":"Green Frost","hex":"#d0d6bf","rgb":{"r":208,"g":214,"b":191},"luminance":141.85144998906426},{"name":"Green Frosting","hex":"#d8f1eb","rgb":{"r":216,"g":241,"b":235},"luminance":157.80275423768748},{"name":"Green Gables","hex":"#324241","rgb":{"r":50,"g":66,"b":65},"luminance":42.182379781136106},{"name":"Green Gamora","hex":"#11bb00","rgb":{"r":17,"g":187,"b":0},"luminance":109.88662452728266},{"name":"Green Gardens","hex":"#009911","rgb":{"r":0,"g":153,"b":17},"luminance":89.83190727686905},{"name":"Green Garter","hex":"#61ba85","rgb":{"r":97,"g":186,"b":133},"luminance":113.98144312562461},{"name":"Green Gas","hex":"#00ff99","rgb":{"r":0,"g":255,"b":153},"luminance":150.6977856141224},{"name":"Green Gate","hex":"#676957","rgb":{"r":103,"g":105,"b":87},"luminance":69.61102756029392},{"name":"Green Gecko","hex":"#cdd47f","rgb":{"r":205,"g":212,"b":127},"luminance":139.47400705866306},{"name":"Green Glacier","hex":"#e7f0c2","rgb":{"r":231,"g":240,"b":194},"luminance":158.45131308070629},{"name":"Green Glimmer","hex":"#00bb00","rgb":{"r":0,"g":187,"b":0},"luminance":109.76899999999999},{"name":"Green Glint","hex":"#dcf1c7","rgb":{"r":220,"g":241,"b":199},"luminance":157.65333832494633},{"name":"Green Glitter","hex":"#dde26a","rgb":{"r":221,"g":226,"b":106},"luminance":148.69991103225314},{"name":"Green Globe","hex":"#79aa87","rgb":{"r":121,"g":170,"b":135},"luminance":107.2558447871257},{"name":"Green Gloss","hex":"#00955e","rgb":{"r":0,"g":149,"b":94},"luminance":88.11701892937594},{"name":"Green Glow","hex":"#b0c965","rgb":{"r":176,"g":201,"b":101},"luminance":129.70269750857148},{"name":"Green Goanna","hex":"#505a39","rgb":{"r":80,"g":90,"b":57},"luminance":58.35579923195294},{"name":"Green Goblin","hex":"#11bb33","rgb":{"r":17,"g":187,"b":51},"luminance":110.04032372725918},{"name":"Green Gooseberry","hex":"#b0dfa4","rgb":{"r":176,"g":223,"b":164},"luminance":142.3161887945289},{"name":"Green Granite","hex":"#7c9793","rgb":{"r":124,"g":151,"b":147},"luminance":97.52937049422599},{"name":"Green Grapple","hex":"#3db9b2","rgb":{"r":61,"g":185,"b":178},"luminance":111.97008712151651},{"name":"Green Grey","hex":"#7ea07a","rgb":{"r":126,"g":160,"b":122},"luminance":102.14562712128208},{"name":"Green Grey Mist","hex":"#afa984","rgb":{"r":175,"g":169,"b":132},"luminance":113.16175651694347},{"name":"Green Gum","hex":"#95e3c0","rgb":{"r":149,"g":227,"b":192},"luminance":142.1941354135254},{"name":"Green Haze","hex":"#01a368","rgb":{"r":1,"g":163,"b":104},"luminance":96.41321433289112},{"name":"Green Hills","hex":"#007800","rgb":{"r":0,"g":120,"b":0},"luminance":70.44},{"name":"Green Hour","hex":"#587d79","rgb":{"r":88,"g":125,"b":121},"luminance":79.16114201424838},{"name":"Green Iced Tea","hex":"#e8e8d4","rgb":{"r":232,"g":232,"b":212},"luminance":154.732328567756},{"name":"Green Illude","hex":"#6e6f56","rgb":{"r":110,"g":111,"b":86},"luminance":73.64309312488172},{"name":"Green Incandescence","hex":"#c4fe82","rgb":{"r":196,"g":254,"b":130},"luminance":160.8859062192832},{"name":"Green Ink","hex":"#11887b","rgb":{"r":17,"g":136,"b":123},"luminance":81.21330923561727},{"name":"Green Jelly","hex":"#349b82","rgb":{"r":52,"g":155,"b":130},"luminance":93.4860574042996},{"name":"Green Juice","hex":"#3bde39","rgb":{"r":59,"g":222,"b":57},"luminance":131.6630832124176},{"name":"Green Katamari","hex":"#53fe5c","rgb":{"r":83,"g":254,"b":92},"luminance":151.51269001968117},{"name":"Green Kelp","hex":"#393d2a","rgb":{"r":57,"g":61,"b":42},"luminance":39.944086445930886},{"name":"Green Lacewing","hex":"#8ad370","rgb":{"r":138,"g":211,"b":112},"luminance":131.17214230544533},{"name":"Green Lane","hex":"#cad6c4","rgb":{"r":202,"g":214,"b":196},"luminance":141.16321994060635},{"name":"Green Lantern","hex":"#9cd03b","rgb":{"r":156,"g":208,"b":59},"luminance":130.87526514968366},{"name":"Green Lapis","hex":"#008684","rgb":{"r":0,"g":134,"b":132},"luminance":80.08447582396978},{"name":"Green Leaf","hex":"#526b2d","rgb":{"r":82,"g":107,"b":45},"luminance":67.61966951264993},{"name":"Green Lentils","hex":"#9c9463","rgb":{"r":156,"g":148,"b":99},"luminance":99.24956376730327},{"name":"Green Lily","hex":"#c1cec1","rgb":{"r":193,"g":206,"b":193},"luminance":135.7803959966239},{"name":"Green Lizard","hex":"#a7f432","rgb":{"r":167,"g":244,"b":50},"luminance":151.78950712417506},{"name":"Green McQuarrie","hex":"#555d50","rgb":{"r":85,"g":93,"b":80},"luminance":60.903808632958246},{"name":"Green Me","hex":"#b2b55f","rgb":{"r":178,"g":181,"b":95},"luminance":119.32432775004433},{"name":"Green Mesh","hex":"#d7d7ad","rgb":{"r":215,"g":215,"b":173},"luminance":143.0007710958231},{"name":"Green Milieu","hex":"#8a9992","rgb":{"r":138,"g":153,"b":146},"luminance":100.22769627702714},{"name":"Green Minions","hex":"#99dd00","rgb":{"r":153,"g":221,"b":0},"luminance":137.55683384695942},{"name":"Green Mirror","hex":"#d7e2d5","rgb":{"r":215,"g":226,"b":213},"luminance":149.40342363212432},{"name":"Green Mist","hex":"#bfc298","rgb":{"r":191,"g":194,"b":152},"luminance":128.56864450168243},{"name":"Green Moblin","hex":"#008888","rgb":{"r":0,"g":136,"b":136},"luminance":81.32356509647126},{"name":"Green Moonstone","hex":"#33565e","rgb":{"r":51,"g":86,"b":94},"luminance":53.812609869806536},{"name":"Green Moray","hex":"#3a7968","rgb":{"r":58,"g":121,"b":104},"luminance":74.0685117239438},{"name":"Green Moss","hex":"#857946","rgb":{"r":133,"g":121,"b":70},"luminance":81.791988715277},{"name":"Green Oasis","hex":"#b0b454","rgb":{"r":176,"g":180,"b":84},"luminance":118.42728043825036},{"name":"Green Oblivion","hex":"#005249","rgb":{"r":0,"g":82,"b":73},"luminance":48.84810784462383},{"name":"Green Ochre","hex":"#9f8f55","rgb":{"r":159,"g":143,"b":85},"luminance":96.95428954925097},{"name":"Green Olive","hex":"#8d8b55","rgb":{"r":141,"g":139,"b":85},"luminance":92.35093410464236},{"name":"Green Olive Pit","hex":"#bdaa89","rgb":{"r":189,"g":170,"b":137},"luminance":115.73875385971631},{"name":"Green Onion","hex":"#c1e089","rgb":{"r":193,"g":224,"b":137},"luminance":144.4406934246717},{"name":"Green Parlor","hex":"#cfddb9","rgb":{"r":207,"g":221,"b":185},"luminance":145.27431320780698},{"name":"Green Patina","hex":"#66d0c0","rgb":{"r":102,"g":208,"b":192},"luminance":127.736626556364},{"name":"Green Paw Paw","hex":"#0d6349","rgb":{"r":13,"g":99,"b":73},"luminance":58.83438809063965},{"name":"Green Pea","hex":"#266242","rgb":{"r":38,"g":98,"b":66},"luminance":59.11807080749506},{"name":"Green Pear","hex":"#79be58","rgb":{"r":121,"g":190,"b":88},"luminance":117.6796582464446},{"name":"Green People","hex":"#388004","rgb":{"r":56,"g":128,"b":4},"luminance":76.98043886598724},{"name":"Green Pepper","hex":"#97bc62","rgb":{"r":151,"g":188,"b":98},"luminance":119.75680573979918},{"name":"Green Pigment","hex":"#00a550","rgb":{"r":0,"g":165,"b":80},"luminance":97.28342831644039},{"name":"Green Room","hex":"#80aea4","rgb":{"r":128,"g":174,"b":164},"luminance":110.66371331199761},{"name":"Green Savage","hex":"#888866","rgb":{"r":136,"g":136,"b":102},"luminance":90.34334233356655},{"name":"Green Scene","hex":"#858365","rgb":{"r":133,"g":131,"b":101},"luminance":87.33347063984117},{"name":"Green Shade Wash","hex":"#45523a","rgb":{"r":69,"g":82,"b":58},"luminance":52.78483362671516},{"name":"Green Sheen","hex":"#d9ce52","rgb":{"r":217,"g":206,"b":82},"luminance":137.54751497936994},{"name":"Green Shimmer","hex":"#ccfd7f","rgb":{"r":204,"g":253,"b":127},"luminance":161.20062537409711},{"name":"Green Silk","hex":"#a2c2b0","rgb":{"r":162,"g":194,"b":176},"luminance":125.36747115579863},{"name":"Green Sky","hex":"#859d66","rgb":{"r":133,"g":157,"b":102},"luminance":101.0440792624684},{"name":"Green Smoke","hex":"#9ca664","rgb":{"r":156,"g":166,"b":100},"luminance":108.63041056720718},{"name":"Green Snow","hex":"#9eb788","rgb":{"r":158,"g":183,"b":136},"luminance":118.36997854608235},{"name":"Green Spool","hex":"#006474","rgb":{"r":0,"g":100,"b":116},"luminance":60.171124104507136},{"name":"Green Spring","hex":"#a9af99","rgb":{"r":169,"g":175,"b":153},"luminance":115.80168802742038},{"name":"Green Spruce","hex":"#589f7e","rgb":{"r":88,"g":159,"b":126},"luminance":98.02905043404225},{"name":"Green Stain","hex":"#2b553e","rgb":{"r":43,"g":85,"b":62},"luminance":52.00740426131648},{"name":"Green Sulphur","hex":"#ae8e2c","rgb":{"r":174,"g":142,"b":44},"luminance":98.38574209711486},{"name":"Green Tea","hex":"#b5b68f","rgb":{"r":181,"g":182,"b":143},"luminance":120.86407622201064},{"name":"Green Tea Candy","hex":"#65ab7c","rgb":{"r":101,"g":171,"b":124},"luminance":105.77026153886544},{"name":"Green Tea Leaf","hex":"#939a89","rgb":{"r":147,"g":154,"b":137},"luminance":101.72308753178896},{"name":"Green Tea Mochi","hex":"#90a96e","rgb":{"r":144,"g":169,"b":110},"luminance":108.86829632634102},{"name":"Green Teal","hex":"#0cb577","rgb":{"r":12,"g":181,"b":119},"luminance":107.1696557286623},{"name":"Green Tease","hex":"#e3ede0","rgb":{"r":227,"g":237,"b":224},"luminance":156.88507763965316},{"name":"Green Thumb","hex":"#779900","rgb":{"r":119,"g":153,"b":0},"luminance":96.60239791019681},{"name":"Green Tilberi","hex":"#d5e0d0","rgb":{"r":213,"g":224,"b":208},"luminance":148.0114423178154},{"name":"Green Tint","hex":"#c5ccc0","rgb":{"r":197,"g":204,"b":192},"luminance":135.23398780262303},{"name":"Green Tone Ink","hex":"#47553c","rgb":{"r":71,"g":85,"b":60},"luminance":54.65315238849448},{"name":"Green Tourmaline","hex":"#5eab81","rgb":{"r":94,"g":171,"b":129},"luminance":105.26991878499764},{"name":"Green Turquoise","hex":"#679591","rgb":{"r":103,"g":149,"b":145},"luminance":94.18849440350982},{"name":"Green Valley","hex":"#3f4948","rgb":{"r":63,"g":73,"b":72},"luminance":47.52275280326256},{"name":"Green Veil","hex":"#e0f1c4","rgb":{"r":224,"g":241,"b":196},"luminance":158.10740337188514},{"name":"Green Velvet","hex":"#127453","rgb":{"r":18,"g":116,"b":83},"luminance":68.95662282913803},{"name":"Green Venom","hex":"#b8f818","rgb":{"r":184,"g":248,"b":24},"luminance":155.64902096704623},{"name":"Green Vogue","hex":"#23414e","rgb":{"r":35,"g":65,"b":78},"luminance":40.55105317991137},{"name":"Green Wash","hex":"#c6ddcd","rgb":{"r":198,"g":221,"b":205},"luminance":144.49957866028538},{"name":"Green Waterloo","hex":"#2c2d24","rgb":{"r":44,"g":45,"b":36},"luminance":29.79388153631547},{"name":"Green Wave","hex":"#c3dcd5","rgb":{"r":195,"g":220,"b":213},"luminance":143.75753249482267},{"name":"Green Weed","hex":"#548f6f","rgb":{"r":84,"g":143,"b":111},"luminance":88.52699392275781},{"name":"Green Whisper","hex":"#e3eee3","rgb":{"r":227,"g":238,"b":227},"luminance":157.46168247862715},{"name":"Green White","hex":"#deddcb","rgb":{"r":222,"g":221,"b":203},"luminance":147.5489260448886},{"name":"Green Yellow","hex":"#c6f808","rgb":{"r":198,"g":248,"b":8},"luminance":157.15622903340483},{"name":"Greenalicious","hex":"#00dd00","rgb":{"r":0,"g":221,"b":0},"luminance":129.727},{"name":"Greenbrier","hex":"#4b9b69","rgb":{"r":75,"g":155,"b":105},"luminance":94.46921059265817},{"name":"Greenday","hex":"#99ff00","rgb":{"r":153,"g":255,"b":0},"luminance":156.51960654818936},{"name":"Greene & Greene","hex":"#445544","rgb":{"r":68,"g":85,"b":68},"luminance":54.43339740453465},{"name":"Greenella","hex":"#60857a","rgb":{"r":96,"g":133,"b":122},"luminance":84.3352424612629},{"name":"Greener Grass","hex":"#2f8351","rgb":{"r":47,"g":131,"b":81},"luminance":78.71405321796101},{"name":"Greener Pastures","hex":"#495a4c","rgb":{"r":73,"g":90,"b":76},"luminance":57.814286512937265},{"name":"Greenery","hex":"#88b04b","rgb":{"r":136,"g":176,"b":75},"luminance":111.35543426344312},{"name":"Greenette","hex":"#daecc5","rgb":{"r":218,"g":236,"b":197},"luminance":154.73903809963406},{"name":"Greenfinch","hex":"#bda928","rgb":{"r":189,"g":169,"b":40},"luminance":114.26076286284807},{"name":"Greengage","hex":"#8bc28c","rgb":{"r":139,"g":194,"b":140},"luminance":122.27116260590638},{"name":"Greengrass","hex":"#72a355","rgb":{"r":114,"g":163,"b":85},"luminance":102.03237357329292},{"name":"Greenhouse","hex":"#3e6334","rgb":{"r":62,"g":99,"b":52},"luminance":61.28555618577676},{"name":"Greenhouse Glass","hex":"#d7e7cd","rgb":{"r":215,"g":231,"b":205},"luminance":151.872527252298},{"name":"Greenish","hex":"#40a368","rgb":{"r":64,"g":163,"b":104},"luminance":98.29346363314298},{"name":"Greenish Beige","hex":"#c9d179","rgb":{"r":201,"g":209,"b":121},"luminance":137.3072566399897},{"name":"Greenish Black","hex":"#454445","rgb":{"r":69,"g":68,"b":69},"luminance":45.61577767615061},{"name":"Greenish Blue","hex":"#0b8b87","rgb":{"r":11,"g":139,"b":135},"luminance":83.09685475395563},{"name":"Greenish Brown","hex":"#696112","rgb":{"r":105,"g":97,"b":18},"luminance":65.0531048451955},{"name":"Greenish Cyan","hex":"#2afeb7","rgb":{"r":42,"g":254,"b":183},"luminance":151.07329351013698},{"name":"Greenish Grey","hex":"#96ae8d","rgb":{"r":150,"g":174,"b":141},"luminance":112.70344724097839},{"name":"Greenish Grey Bark","hex":"#66675a","rgb":{"r":102,"g":103,"b":90},"luminance":68.49035059773018},{"name":"Greenish Tan","hex":"#bccb7a","rgb":{"r":188,"g":203,"b":122},"luminance":132.4860948514975},{"name":"Greenish Teal","hex":"#32bf84","rgb":{"r":50,"g":191,"b":132},"luminance":114.1059441615554},{"name":"Greenish Turquoise","hex":"#00fbb0","rgb":{"r":0,"g":251,"b":176},"luminance":148.69685828893626},{"name":"Greenish White","hex":"#d1f1de","rgb":{"r":209,"g":241,"b":222},"luminance":156.71162060932176},{"name":"Greenish Yellow","hex":"#cdfd02","rgb":{"r":205,"g":253,"b":2},"luminance":160.66314490261914},{"name":"Greenlake","hex":"#007d69","rgb":{"r":0,"g":125,"b":105},"luminance":74.34494955946907},{"name":"Greenland","hex":"#737d6a","rgb":{"r":115,"g":125,"b":106},"luminance":81.92827293431738},{"name":"Greenland Green","hex":"#22acae","rgb":{"r":34,"g":172,"b":174},"luminance":103.39508570526938},{"name":"Greenland Ice","hex":"#b9d7d6","rgb":{"r":185,"g":215,"b":214},"luminance":139.9379007488679},{"name":"Greenway","hex":"#419a7d","rgb":{"r":65,"g":154,"b":125},"luminance":93.5552250224433},{"name":"Greenwood","hex":"#bcbaab","rgb":{"r":188,"g":186,"b":171},"luminance":124.34031568240447},{"name":"Greeny Glaze","hex":"#067376","rgb":{"r":6,"g":115,"b":118},"luminance":68.85564439463188},{"name":"Gregorio Garden","hex":"#cbc8dd","rgb":{"r":203,"g":200,"b":221},"luminance":134.54227382127894},{"name":"Greige","hex":"#b0a999","rgb":{"r":176,"g":169,"b":153},"luminance":113.64305499677486},{"name":"Gremlin","hex":"#a79954","rgb":{"r":167,"g":153,"b":84},"luminance":103.20377893275031},{"name":"Gremolata","hex":"#527e6d","rgb":{"r":82,"g":126,"b":109},"luminance":78.90446910029874},{"name":"Grenache","hex":"#8e6268","rgb":{"r":142,"g":98,"b":104},"luminance":72.4740448436542},{"name":"Grenade","hex":"#c32149","rgb":{"r":195,"g":33,"b":73},"luminance":61.99971249933341},{"name":"Grenadier","hex":"#c14d36","rgb":{"r":193,"g":77,"b":54},"luminance":73.55911762657298},{"name":"Grenadine","hex":"#ac545e","rgb":{"r":172,"g":84,"b":94},"luminance":72.04825260892869},{"name":"Gretchin Green","hex":"#5d6732","rgb":{"r":93,"g":103,"b":50},"luminance":66.79260265927657},{"name":"Gretna Green","hex":"#596442","rgb":{"r":89,"g":100,"b":66},"luminance":64.88794878095624},{"name":"Gray","hex":"#D3D3D3","rgb":{"r":128,"g":128,"b":128},"luminance":85.57506029212016},{"name":"Grey","hex":"#808080","rgb":{"r":128,"g":128,"b":128},"luminance":85.57506029212016},{"name":"Grey Aqua","hex":"#88b69f","rgb":{"r":136,"g":182,"b":159},"luminance":115.73943289994124},{"name":"Grey Area","hex":"#dddddd","rgb":{"r":221,"g":221,"b":221},"luminance":147.75069003561373},{"name":"Grey Asparagus","hex":"#465945","rgb":{"r":70,"g":89,"b":69},"luminance":56.826665439738754},{"name":"Grey Blue","hex":"#77a1b5","rgb":{"r":119,"g":161,"b":181},"luminance":103.06960059105691},{"name":"Grey Blueberry","hex":"#6c8096","rgb":{"r":108,"g":128,"b":150},"luminance":83.54999557151395},{"name":"Grey Brown","hex":"#7f7053","rgb":{"r":127,"g":112,"b":83},"luminance":76.50981446193684},{"name":"Grey By Me","hex":"#a1988b","rgb":{"r":161,"g":152,"b":139},"luminance":102.61277314740109},{"name":"Grey Chateau","hex":"#9fa3a7","rgb":{"r":159,"g":163,"b":167},"luminance":108.52394153365422},{"name":"Grey Cloud","hex":"#747880","rgb":{"r":116,"g":120,"b":128},"luminance":79.86050287845676},{"name":"Grey Dawn","hex":"#bbc1cc","rgb":{"r":187,"g":193,"b":204},"luminance":128.45993844775109},{"name":"Grey Dolphin","hex":"#c8c7c5","rgb":{"r":200,"g":199,"b":197},"luminance":133.13781856782842},{"name":"Grey Dusk","hex":"#897f98","rgb":{"r":137,"g":127,"b":152},"luminance":86.80887255344352},{"name":"Grey Flannel","hex":"#8d9a9e","rgb":{"r":141,"g":154,"b":158},"luminance":101.35882708970146},{"name":"Grey Frost","hex":"#b8bfc2","rgb":{"r":184,"g":191,"b":194},"luminance":126.83098754247716},{"name":"Grey Ghost","hex":"#dddcda","rgb":{"r":221,"g":220,"b":218},"luminance":147.17742946865187},{"name":"Grey Glimpse","hex":"#e0e4e2","rgb":{"r":224,"g":228,"b":226},"luminance":151.8606043975856},{"name":"Grey Grain","hex":"#a9bdbf","rgb":{"r":169,"g":189,"b":191},"luminance":123.8379517191721},{"name":"Grey Green","hex":"#86a17d","rgb":{"r":134,"g":161,"b":125},"luminance":103.63358483136632},{"name":"Grey Heron","hex":"#89928a","rgb":{"r":137,"g":146,"b":138},"luminance":96.28237635725449},{"name":"Grey Jade","hex":"#b9bbad","rgb":{"r":185,"g":187,"b":173},"luminance":124.49072202377171},{"name":"Grey Lilac","hex":"#d4cacd","rgb":{"r":212,"g":202,"b":205},"luminance":136.46973627878086},{"name":"Grey Linnet Egg","hex":"#f2e8d7","rgb":{"r":242,"g":232,"b":215},"luminance":156.14897412407166},{"name":"Grey Marble","hex":"#b9b4b1","rgb":{"r":185,"g":180,"b":177},"luminance":120.95840817818329},{"name":"Grey Matter","hex":"#c87f89","rgb":{"r":200,"g":127,"b":137},"luminance":96.8375718665023},{"name":"Grey Mauve","hex":"#cab8ab","rgb":{"r":202,"g":184,"b":171},"luminance":125.27434894662196},{"name":"Grey Mist","hex":"#99aeae","rgb":{"r":153,"g":174,"b":174},"luminance":113.6592536883821},{"name":"Grey Monument","hex":"#707c78","rgb":{"r":112,"g":124,"b":120},"luminance":81.2814953602602},{"name":"Grey Morn","hex":"#cabeb5","rgb":{"r":202,"g":190,"b":181},"luminance":128.50144458331974},{"name":"Grey Nickel","hex":"#c3c3bd","rgb":{"r":195,"g":195,"b":189},"luminance":130.25336604479745},{"name":"Grey Nurse","hex":"#d1d3cc","rgb":{"r":209,"g":211,"b":204},"luminance":140.66457644339602},{"name":"Grey Of Darkness","hex":"#a2a2a2","rgb":{"r":162,"g":162,"b":162},"luminance":108.30593568221457},{"name":"Grey Olive","hex":"#a19a7f","rgb":{"r":161,"g":154,"b":127},"luminance":103.43487907374377},{"name":"Grey Pearl","hex":"#c3c0bb","rgb":{"r":195,"g":192,"b":187},"luminance":128.6705940182138},{"name":"Grey Pebble","hex":"#cfcac1","rgb":{"r":207,"g":202,"b":193},"luminance":135.5530336399743},{"name":"Grey Pink","hex":"#c3909b","rgb":{"r":195,"g":144,"b":155},"luminance":104.19541596922582},{"name":"Grey Pinstripe","hex":"#49494d","rgb":{"r":73,"g":73,"b":77},"luminance":48.884347331226586},{"name":"Grey Porcelain","hex":"#86837a","rgb":{"r":134,"g":131,"b":122},"luminance":87.81722740442218},{"name":"Grey Purple","hex":"#826d8c","rgb":{"r":130,"g":109,"b":140},"luminance":76.54686661777868},{"name":"Grey Ridge","hex":"#847986","rgb":{"r":132,"g":121,"b":134},"luminance":82.6795859266361},{"name":"Grey Rose","hex":"#c6b6b2","rgb":{"r":198,"g":182,"b":178},"luminance":123.8149652667237},{"name":"Grey Russian","hex":"#8e9598","rgb":{"r":142,"g":149,"b":152},"luminance":98.75584902677916},{"name":"Grey Sand","hex":"#e5ccaf","rgb":{"r":229,"g":204,"b":175},"luminance":139.37669763988526},{"name":"Grey Scape","hex":"#b8b0af","rgb":{"r":184,"g":176,"b":175},"luminance":118.7355553320066},{"name":"Grey Shadows","hex":"#c2bdba","rgb":{"r":194,"g":189,"b":186},"luminance":126.9750168379591},{"name":"Grey Spell","hex":"#c8c7c2","rgb":{"r":200,"g":199,"b":194},"luminance":133.08055614927372},{"name":"Grey Suit","hex":"#9391a0","rgb":{"r":147,"g":145,"b":160},"luminance":97.51475290436825},{"name":"Grey Teal","hex":"#5e9b8a","rgb":{"r":94,"g":155,"b":138},"luminance":96.51794281375872},{"name":"Grey Violet","hex":"#9b8e8e","rgb":{"r":155,"g":142,"b":142},"luminance":96.73572083258593},{"name":"Grey Whisper","hex":"#e6e4e4","rgb":{"r":230,"g":228,"b":228},"luminance":152.6989582806641},{"name":"Grey Wolf","hex":"#9ca0a6","rgb":{"r":156,"g":160,"b":166},"luminance":106.55865479631393},{"name":"Grey Wonder","hex":"#e5e8e6","rgb":{"r":229,"g":232,"b":230},"luminance":154.66689399157144},{"name":"Greybeard","hex":"#d4d0c5","rgb":{"r":212,"g":208,"b":197},"luminance":139.39093773986886},{"name":"Greyed Jade","hex":"#9bbea9","rgb":{"r":155,"g":190,"b":169},"luminance":122.30281550724823},{"name":"Greyhound","hex":"#b2aca2","rgb":{"r":178,"g":172,"b":162},"luminance":115.61737587404411},{"name":"Greyish","hex":"#a8a495","rgb":{"r":168,"g":164,"b":149},"luminance":109.90589540147516},{"name":"Greyish Black","hex":"#555152","rgb":{"r":85,"g":81,"b":82},"luminance":54.71768030536382},{"name":"Greyish Blue","hex":"#5e819d","rgb":{"r":94,"g":129,"b":157},"luminance":82.73003305329934},{"name":"Greyish Brown","hex":"#7a6a4f","rgb":{"r":122,"g":106,"b":79},"luminance":72.6865173467542},{"name":"Greyish Green","hex":"#82a67d","rgb":{"r":130,"g":166,"b":125},"luminance":105.8720112399873},{"name":"Greyish Pink","hex":"#c88d94","rgb":{"r":200,"g":141,"b":148},"luminance":103.49435092313009},{"name":"Greyish Purple","hex":"#887191","rgb":{"r":136,"g":113,"b":145},"luminance":79.53994818328712},{"name":"Greyish Teal","hex":"#719f91","rgb":{"r":113,"g":159,"b":145},"luminance":100.62728833671312},{"name":"Greyish White","hex":"#d6dee9","rgb":{"r":214,"g":222,"b":233},"luminance":147.58552312472926},{"name":"Greystone","hex":"#b7b9b5","rgb":{"r":183,"g":185,"b":181},"luminance":123.33931275145001},{"name":"Greywacke","hex":"#aaccbb","rgb":{"r":170,"g":204,"b":187},"luminance":131.8246165478967},{"name":"Griffin","hex":"#8d8f8f","rgb":{"r":141,"g":143,"b":143},"luminance":95.33744262355687},{"name":"Griffon Brown","hex":"#70393f","rgb":{"r":112,"g":57,"b":63},"luminance":47.88039211410032},{"name":"Grill Master","hex":"#863b2c","rgb":{"r":134,"g":59,"b":44},"luminance":53.19670385465625},{"name":"Grilled","hex":"#633f2e","rgb":{"r":99,"g":63,"b":46},"luminance":47.658295164640535},{"name":"Grim Grey","hex":"#e3dcd6","rgb":{"r":227,"g":220,"b":214},"luminance":147.91568052441227},{"name":"Grim White","hex":"#f6f1f4","rgb":{"r":246,"g":241,"b":244},"luminance":161.8543569416653},{"name":"Grimace","hex":"#50314c","rgb":{"r":80,"g":49,"b":76},"luminance":38.399758658095756},{"name":"Grisaille","hex":"#585e6f","rgb":{"r":88,"g":94,"b":111},"luminance":62.42641062883561},{"name":"Gristmill","hex":"#a29371","rgb":{"r":162,"g":147,"b":113},"luminance":99.78966524144671},{"name":"Grizzly","hex":"#885818","rgb":{"r":136,"g":88,"b":24},"luminance":65.79809213039539},{"name":"Groovy Giraffe","hex":"#eeaa11","rgb":{"r":238,"g":170,"b":17},"luminance":122.57989308202221},{"name":"Gross Green","hex":"#a0bf16","rgb":{"r":160,"g":191,"b":22},"luminance":121.92283359978146},{"name":"Grotesque Green","hex":"#64e986","rgb":{"r":100,"g":233,"b":134},"luminance":140.83207240185027},{"name":"Grouchy Badger","hex":"#6f675c","rgb":{"r":111,"g":103,"b":92},"luminance":69.7641769535053},{"name":"Ground Bean","hex":"#604e42","rgb":{"r":96,"g":78,"b":66},"luminance":54.56086498581194},{"name":"Ground Coffee","hex":"#63554b","rgb":{"r":99,"g":85,"b":75},"luminance":58.64156142191304},{"name":"Ground Cover","hex":"#a8bf8b","rgb":{"r":168,"g":191,"b":139},"luminance":123.87320625946515},{"name":"Ground Cumin","hex":"#8a6c42","rgb":{"r":138,"g":108,"b":66},"luminance":76.01457778610626},{"name":"Groundwater","hex":"#1100aa","rgb":{"r":17,"g":0,"b":170},"luminance":20.035500717476467},{"name":"Growth","hex":"#6ca178","rgb":{"r":108,"g":161,"b":120},"luminance":100.80420979800397},{"name":"Grubenwald","hex":"#4a5b51","rgb":{"r":74,"g":91,"b":81},"luminance":58.55085414406864},{"name":"Grullo","hex":"#a99a86","rgb":{"r":169,"g":154,"b":134},"luminance":104.68302890631317},{"name":"Grunervetliner","hex":"#c0cf3f","rgb":{"r":192,"g":207,"b":63},"luminance":134.57970377809573},{"name":"Gruyère Cheese","hex":"#f5deb3","rgb":{"r":245,"g":222,"b":179},"luminance":150.87888671712818},{"name":"Gryphonne Sepia Wash","hex":"#883f11","rgb":{"r":136,"g":63,"b":17},"luminance":54.999191821334975},{"name":"Gǔ Tóng Hēi Copper","hex":"#634950","rgb":{"r":99,"g":73,"b":80},"luminance":52.87345082364116},{"name":"Guacamole","hex":"#95986b","rgb":{"r":149,"g":152,"b":107},"luminance":100.47141375037975},{"name":"Guardian Angel","hex":"#e4e1ea","rgb":{"r":228,"g":225,"b":234},"luminance":151.00607996037775},{"name":"Guardsman Red","hex":"#952e31","rgb":{"r":149,"g":46,"b":49},"luminance":52.39373055051529},{"name":"Guerrilla Forest","hex":"#142d25","rgb":{"r":20,"g":45,"b":37},"luminance":27.409927927668836},{"name":"Guide Pink","hex":"#eb4962","rgb":{"r":235,"g":73,"b":98},"luminance":83.05535509526162},{"name":"Guiding Star","hex":"#fee9da","rgb":{"r":254,"g":233,"b":218},"luminance":158.40367186716347},{"name":"Guilliman Blue","hex":"#6495ed","rgb":{"r":100,"g":149,"b":237},"luminance":96.30035666081409},{"name":"Guinea Pig Brown","hex":"#987654","rgb":{"r":152,"g":118,"b":84},"luminance":83.39663803775305},{"name":"Guinea Pig White","hex":"#e8e4d6","rgb":{"r":232,"g":228,"b":214},"luminance":152.70612016549958},{"name":"Guitar","hex":"#6b4c37","rgb":{"r":107,"g":76,"b":55},"luminance":55.25482325553127},{"name":"Gulābī Pink","hex":"#c772c0","rgb":{"r":199,"g":114,"b":192},"luminance":92.18173500753822},{"name":"Gulf Blue","hex":"#343f5c","rgb":{"r":52,"g":63,"b":92},"luminance":41.46483822469346},{"name":"Gulf Harbour","hex":"#225e64","rgb":{"r":34,"g":94,"b":100},"luminance":57.253115548413604},{"name":"Gulf Stream","hex":"#74b2a8","rgb":{"r":116,"g":178,"b":168},"luminance":111.74570755067059},{"name":"Gulf Weed","hex":"#686e43","rgb":{"r":104,"g":110,"b":67},"luminance":72.0734705699677},{"name":"Gulf Wind","hex":"#bcc9cd","rgb":{"r":188,"g":201,"b":205},"luminance":132.76625329126372},{"name":"Gull","hex":"#918c8f","rgb":{"r":145,"g":140,"b":143},"luminance":94.33431840533963},{"name":"Gull Grey","hex":"#a4adb0","rgb":{"r":164,"g":173,"b":176},"luminance":114.54125454612411},{"name":"Gully","hex":"#777661","rgb":{"r":119,"g":118,"b":97},"luminance":78.65154595429131},{"name":"Gully Green","hex":"#4b6e3b","rgb":{"r":75,"g":110,"b":59},"luminance":68.68336480546071},{"name":"Gum Leaf","hex":"#acc9b2","rgb":{"r":172,"g":201,"b":178},"luminance":130.29787648691746},{"name":"Gumbo","hex":"#718f8a","rgb":{"r":113,"g":143,"b":138},"luminance":91.84306546495493},{"name":"Gumdrop","hex":"#de96c1","rgb":{"r":222,"g":150,"b":193},"luminance":112.4407816941878},{"name":"Gumdrop Green","hex":"#2ea785","rgb":{"r":46,"g":167,"b":133},"luminance":100.14361487883288},{"name":"Gun Barrel","hex":"#979d9a","rgb":{"r":151,"g":157,"b":154},"luminance":104.1149682706574},{"name":"Gun Corps Brown","hex":"#6b593c","rgb":{"r":107,"g":89,"b":60},"luminance":61.641452757053024},{"name":"Gun Powder","hex":"#484753","rgb":{"r":72,"g":71,"b":83},"luminance":47.85349054144326},{"name":"Gundaroo Green","hex":"#959984","rgb":{"r":149,"g":153,"b":132},"luminance":101.37677064298309},{"name":"Gunjō Blue","hex":"#5d8cae","rgb":{"r":93,"g":140,"b":174},"luminance":88.99577824256609},{"name":"Gunmetal","hex":"#536267","rgb":{"r":83,"g":98,"b":103},"luminance":63.74165615200157},{"name":"Gunmetal Beige","hex":"#908982","rgb":{"r":144,"g":137,"b":130},"luminance":92.41572970549981},{"name":"Gunmetal Green","hex":"#777648","rgb":{"r":119,"g":118,"b":72},"luminance":78.30170867228887},{"name":"Gunmetal Grey","hex":"#808c8c","rgb":{"r":128,"g":140,"b":140},"luminance":92.04900859868073},{"name":"Gunny Sack","hex":"#dcd3bc","rgb":{"r":220,"g":211,"b":188},"luminance":141.86929009831547},{"name":"Gunsmoke","hex":"#7a7c76","rgb":{"r":122,"g":124,"b":118},"luminance":82.52086846368015},{"name":"Guppie Green","hex":"#00ff7f","rgb":{"r":0,"g":255,"b":127},"luminance":150.38354866473927},{"name":"Guppy Violet","hex":"#ae5883","rgb":{"r":174,"g":88,"b":131},"luminance":74.82026041120145},{"name":"Gurkha","hex":"#989171","rgb":{"r":152,"g":145,"b":113},"luminance":97.34490152545226},{"name":"Gustav","hex":"#a49691","rgb":{"r":164,"g":150,"b":145},"luminance":102.13017524708357},{"name":"Guy","hex":"#897a68","rgb":{"r":137,"g":122,"b":104},"luminance":83.34924775305413},{"name":"Gypsum","hex":"#eeede4","rgb":{"r":238,"g":237,"b":228},"luminance":158.40994435009438},{"name":"Gypsum Rose","hex":"#e2c4af","rgb":{"r":226,"g":196,"b":175},"luminance":134.91186263631525},{"name":"Gypsum Sand","hex":"#d6cfbf","rgb":{"r":214,"g":207,"b":191},"luminance":139.04226822445034},{"name":"Gypsy","hex":"#e59368","rgb":{"r":229,"g":147,"b":104},"luminance":110.79094772588599},{"name":"Gypsy Canvas","hex":"#b7a467","rgb":{"r":183,"g":164,"b":103},"luminance":111.3523797545432},{"name":"Gypsy Dancer","hex":"#c07c7b","rgb":{"r":192,"g":124,"b":123},"luminance":93.75706849086099},{"name":"Gypsy Jewels","hex":"#613a57","rgb":{"r":97,"g":58,"b":87},"luminance":45.811252427760586},{"name":"H₂O","hex":"#bfe1e6","rgb":{"r":191,"g":225,"b":230},"luminance":146.2625444397847},{"name":"Habanero Gold","hex":"#fed450","rgb":{"r":254,"g":212,"b":80},"luminance":146.072853234268},{"name":"Hacienda","hex":"#9e8022","rgb":{"r":158,"g":128,"b":34},"luminance":88.83832751690004},{"name":"Hadopelagic Water","hex":"#000022","rgb":{"r":0,"g":0,"b":34},"luminance":3.8760000000000003},{"name":"Haggis","hex":"#c3c7b2","rgb":{"r":195,"g":199,"b":178},"luminance":132.12310645000744},{"name":"Hailstorm","hex":"#d0d1e1","rgb":{"r":208,"g":209,"b":225},"luminance":139.91742512282022},{"name":"Hair Brown","hex":"#8b7859","rgb":{"r":139,"g":120,"b":89},"luminance":82.41390439118875},{"name":"Hair Ribbon","hex":"#939cc9","rgb":{"r":147,"g":156,"b":201},"luminance":104.12659981484077},{"name":"Hairy Brown","hex":"#734a12","rgb":{"r":115,"g":74,"b":18},"luminance":55.43824287439132},{"name":"Hairy Heath","hex":"#633528","rgb":{"r":99,"g":53,"b":40},"luminance":43.184570415832546},{"name":"Haiti","hex":"#2c2a35","rgb":{"r":44,"g":42,"b":53},"luminance":28.59030982693262},{"name":"Hakusai Green","hex":"#88b378","rgb":{"r":136,"g":179,"b":120},"luminance":113.49466342079701},{"name":"Halakā Pīlā","hex":"#f0e483","rgb":{"r":240,"g":228,"b":131},"luminance":152.59291219450526},{"name":"Halayà Úbe","hex":"#663854","rgb":{"r":102,"g":56,"b":84},"luminance":45.85189378858849},{"name":"Half Baked","hex":"#558f93","rgb":{"r":85,"g":143,"b":147},"luminance":89.2907849108742},{"name":"Half Colonial White","hex":"#f2e5bf","rgb":{"r":242,"g":229,"b":191},"luminance":154.2054803468411},{"name":"Half Dutch White","hex":"#fbf0d6","rgb":{"r":251,"g":240,"b":214},"luminance":161.47659773787655},{"name":"Half Moon Bay Blush","hex":"#cda894","rgb":{"r":205,"g":168,"b":148},"luminance":117.33224989319858},{"name":"Half Orc Highlight","hex":"#976f3c","rgb":{"r":151,"g":111,"b":60},"luminance":79.56539731566733},{"name":"Half Pearl Lusta","hex":"#f1ead7","rgb":{"r":241,"g":234,"b":215},"luminance":157.03649176226526},{"name":"Half Spanish White","hex":"#e6dbc7","rgb":{"r":230,"g":219,"b":199},"luminance":147.54606502716365},{"name":"Half-Smoke","hex":"#ee8855","rgb":{"r":238,"g":136,"b":85},"luminance":107.3828411246415},{"name":"Hallowed Hush","hex":"#e2ebe5","rgb":{"r":226,"g":235,"b":229},"luminance":155.8094725522168},{"name":"Halloween Orange","hex":"#eb6123","rgb":{"r":235,"g":97,"b":35},"luminance":90.52701279728609},{"name":"Halloween Punch","hex":"#dd2211","rgb":{"r":221,"g":34,"b":17},"luminance":69.05441223412157},{"name":"Halo","hex":"#e2c392","rgb":{"r":226,"g":195,"b":146},"luminance":133.96083172703877},{"name":"Halogen Blue","hex":"#bdc6dc","rgb":{"r":189,"g":198,"b":220},"luminance":131.64718985606947},{"name":"Halt Red","hex":"#ff004f","rgb":{"r":255,"g":0,"b":79},"luminance":76.77504842720712},{"name":"Hamilton Blue","hex":"#8a99a4","rgb":{"r":138,"g":153,"b":164},"luminance":100.5888104164673},{"name":"Hammam Blue","hex":"#65dcd6","rgb":{"r":101,"g":220,"b":214},"luminance":134.84911574422725},{"name":"Hammered Copper","hex":"#834831","rgb":{"r":131,"g":72,"b":49},"luminance":57.893519956900185},{"name":"Hammered Pewter","hex":"#7e7567","rgb":{"r":126,"g":117,"b":103},"luminance":79.208647766516},{"name":"Hammerhead Shark","hex":"#4e7496","rgb":{"r":78,"g":116,"b":150},"luminance":73.97868712000775},{"name":"Hammock","hex":"#6d8687","rgb":{"r":109,"g":134,"b":135},"luminance":86.52228814010873},{"name":"Hampton","hex":"#e8d4a2","rgb":{"r":232,"g":212,"b":162},"luminance":143.66382837722233},{"name":"Hamster Fur","hex":"#a6814c","rgb":{"r":166,"g":129,"b":76},"luminance":90.95367821589186},{"name":"Hamster Habitat","hex":"#c4d6af","rgb":{"r":196,"g":214,"b":175},"luminance":140.04396895261144},{"name":"Hamtaro Brown","hex":"#b07426","rgb":{"r":176,"g":116,"b":38},"luminance":86.16595652576486},{"name":"Han Blue","hex":"#446ccf","rgb":{"r":68,"g":108,"b":207},"luminance":70.63503835915996},{"name":"Han Purple","hex":"#5218fa","rgb":{"r":82,"g":24,"b":250},"luminance":40.147902410960405},{"name":"Hanaasagi Blue","hex":"#1d697c","rgb":{"r":29,"g":105,"b":124},"luminance":63.82700025851128},{"name":"Hanada Blue","hex":"#044f67","rgb":{"r":4,"g":79,"b":103},"luminance":47.851437898980635},{"name":"Hancock","hex":"#4d6968","rgb":{"r":77,"g":105,"b":104},"luminance":66.85429298107938},{"name":"Handmade Linen","hex":"#ddd6b7","rgb":{"r":221,"g":214,"b":183},"luminance":143.46267531661326},{"name":"Handmade Red","hex":"#a87678","rgb":{"r":168,"g":118,"b":120},"luminance":86.64972579298794},{"name":"Handwoven","hex":"#bfa984","rgb":{"r":191,"g":169,"b":132},"luminance":115.45178818017501},{"name":"Hanover","hex":"#dac5b1","rgb":{"r":218,"g":197,"b":177},"luminance":134.26921884408205},{"name":"Hanover Pewter","hex":"#848472","rgb":{"r":132,"g":132,"b":114},"luminance":87.92263244466693},{"name":"Hansa Yellow","hex":"#e9d66c","rgb":{"r":233,"g":214,"b":108},"luminance":144.1698933793044},{"name":"Hanuman Green","hex":"#55ffaa","rgb":{"r":85,"g":255,"b":170},"luminance":153.05915800761483},{"name":"Hanyauku","hex":"#e3d6c7","rgb":{"r":227,"g":214,"b":199},"luminance":144.5727520973437},{"name":"Happy","hex":"#f8d664","rgb":{"r":248,"g":214,"b":100},"luminance":146.3159629978903},{"name":"Happy Days","hex":"#506e82","rgb":{"r":80,"g":110,"b":130},"luminance":70.43496077943111},{"name":"Happy Daze","hex":"#f7cf1b","rgb":{"r":247,"g":207,"b":27},"luminance":142.22579503732786},{"name":"Happy Hippo","hex":"#818581","rgb":{"r":129,"g":133,"b":129},"luminance":88.31234068916982},{"name":"Happy Piglets","hex":"#f6cbca","rgb":{"r":246,"g":203,"b":202},"luminance":141.91484637274564},{"name":"Happy Prawn","hex":"#ffbe98","rgb":{"r":255,"g":190,"b":152},"luminance":136.20756406675804},{"name":"Happy Thoughts","hex":"#d1dfeb","rgb":{"r":209,"g":223,"b":235},"luminance":147.50559644298244},{"name":"Happy Trails","hex":"#b67a63","rgb":{"r":182,"g":122,"b":99},"luminance":90.6490899899166},{"name":"Happy Tune","hex":"#96b957","rgb":{"r":150,"g":185,"b":87},"luminance":117.90997942922388},{"name":"Happy Yipee","hex":"#ffc217","rgb":{"r":255,"g":194,"b":23},"luminance":137.07068903671563},{"name":"Hapsburg Court","hex":"#e2d4d6","rgb":{"r":226,"g":212,"b":214},"luminance":143.69314328804975},{"name":"Harā Green","hex":"#55aa55","rgb":{"r":85,"g":170,"b":85},"luminance":103.43047145304908},{"name":"Harbor Blue","hex":"#556699","rgb":{"r":85,"g":102,"b":153},"luminance":67.34271649554984},{"name":"Harbor Mist","hex":"#88aaaa","rgb":{"r":136,"g":170,"b":170},"luminance":109.48602374732585},{"name":"Harbour Afternoon","hex":"#e0e9f3","rgb":{"r":224,"g":233,"b":243},"luminance":154.78853904924614},{"name":"Harbour Blue","hex":"#417491","rgb":{"r":65,"g":116,"b":145},"luminance":72.71506438833703},{"name":"Harbour Fog","hex":"#afb1b4","rgb":{"r":175,"g":177,"b":180},"luminance":118.12695808324195},{"name":"Harbour Grey","hex":"#a8c0bb","rgb":{"r":168,"g":192,"b":187},"luminance":125.21941767952764},{"name":"Harbour Light","hex":"#d7e0e7","rgb":{"r":215,"g":224,"b":231},"luminance":148.7115830223053},{"name":"Harbour Mist","hex":"#dae1e3","rgb":{"r":218,"g":225,"b":227},"luminance":149.53985967961853},{"name":"Harbour Mist Grey","hex":"#778071","rgb":{"r":119,"g":128,"b":113},"luminance":84.12711798819687},{"name":"Harbour Rat","hex":"#757d75","rgb":{"r":117,"g":125,"b":117},"luminance":82.37477258238714},{"name":"Harbour Sky","hex":"#7eb6d0","rgb":{"r":126,"g":182,"b":208},"luminance":115.7371711076437},{"name":"Harbourmaster","hex":"#4e536b","rgb":{"r":78,"g":83,"b":107},"luminance":55.375470463012775},{"name":"Hard Candy","hex":"#ffbbbb","rgb":{"r":255,"g":187,"b":187},"luminance":135.3402767471679},{"name":"Harem Silk","hex":"#006383","rgb":{"r":0,"g":99,"b":131},"luminance":60.00120936281201},{"name":"Harissa Red","hex":"#a52a2a","rgb":{"r":165,"g":42,"b":42},"luminance":55.35961420566441},{"name":"Harlequin","hex":"#3fff00","rgb":{"r":63,"g":255,"b":0},"luminance":150.86560838706745},{"name":"Harlequin Green","hex":"#46cb18","rgb":{"r":70,"g":203,"b":24},"luminance":121.0160919754063},{"name":"Harley Davidson Orange","hex":"#c93413","rgb":{"r":201,"g":52,"b":19},"luminance":67.44105524826847},{"name":"Harlock's Cape","hex":"#bb0000","rgb":{"r":187,"g":0,"b":0},"luminance":55.913},{"name":"Harmonious","hex":"#afc195","rgb":{"r":175,"g":193,"b":149},"luminance":125.9415757484398},{"name":"Harmonious Rose","hex":"#f29cb7","rgb":{"r":242,"g":156,"b":183},"luminance":118.55941292027386},{"name":"Harold","hex":"#6d6353","rgb":{"r":109,"g":99,"b":83},"luminance":67.29653404150915},{"name":"Harp","hex":"#cbcec0","rgb":{"r":203,"g":206,"b":192},"luminance":137.05962365700557},{"name":"Harpoon","hex":"#283b4c","rgb":{"r":40,"g":59,"b":76},"luminance":37.65038094096791},{"name":"Harpy Brown","hex":"#493c2b","rgb":{"r":73,"g":60,"b":43},"luminance":41.72404502202537},{"name":"Harrison Grey","hex":"#989b9e","rgb":{"r":152,"g":155,"b":158},"luminance":103.28709054378481},{"name":"Harrison Rust","hex":"#9a5f3f","rgb":{"r":154,"g":95,"b":63},"luminance":72.67427650138666},{"name":"Harrow's Gate","hex":"#7e8e90","rgb":{"r":126,"g":142,"b":144},"luminance":92.93387244702546},{"name":"Harvard Crimson","hex":"#c90016","rgb":{"r":201,"g":0,"b":22},"luminance":60.15130809051454},{"name":"Harvest Blessing","hex":"#ba8e4e","rgb":{"r":186,"g":142,"b":78},"luminance":100.59758434475452},{"name":"Harvest Dance","hex":"#a5997c","rgb":{"r":165,"g":153,"b":124},"luminance":103.43976238371779},{"name":"Harvest Eve Gold","hex":"#da9100","rgb":{"r":218,"g":145,"b":0},"luminance":107.20660590187528},{"name":"Harvest Gold","hex":"#eab76a","rgb":{"r":234,"g":183,"b":106},"luminance":128.7654280193251},{"name":"Harvest Night","hex":"#554488","rgb":{"r":85,"g":68,"b":136},"luminance":49.79541441739389},{"name":"Harvest Pumpkin","hex":"#d56231","rgb":{"r":213,"g":98,"b":49},"luminance":86.00277926323079},{"name":"Harvest Time","hex":"#cf875f","rgb":{"r":207,"g":135,"b":95},"luminance":101.13259797908881},{"name":"Hashibami Brown","hex":"#bfa46f","rgb":{"r":191,"g":164,"b":111},"luminance":112.64585842808425},{"name":"Hashita Purple","hex":"#8d608c","rgb":{"r":141,"g":96,"b":140},"luminance":72.16405466019768},{"name":"Hashut Copper","hex":"#c9643b","rgb":{"r":201,"g":100,"b":59},"luminance":84.27822302943981},{"name":"Hassan II Mosque","hex":"#009e6d","rgb":{"r":0,"g":158,"b":109},"luminance":93.5747080786256},{"name":"Hat Box Brown","hex":"#8f775d","rgb":{"r":143,"g":119,"b":93},"luminance":82.5833219360907},{"name":"Hatching Chameleon","hex":"#cfebde","rgb":{"r":207,"g":235,"b":222},"luminance":153.2972972299251},{"name":"Hatoba Pigeon","hex":"#95859c","rgb":{"r":149,"g":133,"b":156},"luminance":91.6304714491855},{"name":"Hatoba-Nezumi Grey","hex":"#9e8b8e","rgb":{"r":158,"g":139,"b":142},"luminance":95.6622995594398},{"name":"Haunting Hue","hex":"#d3e0ec","rgb":{"r":211,"g":224,"b":236},"luminance":148.30084720256994},{"name":"Haute Couture","hex":"#a0252a","rgb":{"r":160,"g":37,"b":42},"luminance":52.75704223134576},{"name":"Haute Red","hex":"#a11729","rgb":{"r":161,"g":23,"b":41},"luminance":50.21440627947322},{"name":"Havana","hex":"#3b2b2c","rgb":{"r":59,"g":43,"b":44},"luminance":31.20053233520223},{"name":"Havana Blue","hex":"#a5dbe5","rgb":{"r":165,"g":219,"b":229},"luminance":140.14756248326262},{"name":"Havana Cigar","hex":"#af884a","rgb":{"r":175,"g":136,"b":74},"luminance":95.82390069810349},{"name":"Havelock Blue","hex":"#5784c1","rgb":{"r":87,"g":132,"b":193},"luminance":84.6435728747316},{"name":"Hawaii Morning","hex":"#00bbff","rgb":{"r":0,"g":187,"b":255},"luminance":113.55306363546515},{"name":"Hawaiian Breeze","hex":"#75c7e0","rgb":{"r":117,"g":199,"b":224},"luminance":124.5840060120078},{"name":"Hawaiian Coconut","hex":"#99522c","rgb":{"r":153,"g":82,"b":44},"luminance":66.59452095330366},{"name":"Hawaiian Ocean","hex":"#008db9","rgb":{"r":0,"g":141,"b":185},"luminance":85.41173449239864},{"name":"Hawaiian Shell","hex":"#f3dbd9","rgb":{"r":243,"g":219,"b":217},"luminance":149.7226839927738},{"name":"Hawaiian Sunset","hex":"#bb5c14","rgb":{"r":187,"g":92,"b":20},"luminance":77.76820677500542},{"name":"Hawaiian Surf","hex":"#0078a7","rgb":{"r":0,"g":120,"b":167},"luminance":72.96738342574714},{"name":"Hawaiian Vacation","hex":"#77cabd","rgb":{"r":119,"g":202,"b":189},"luminance":125.65839069875119},{"name":"Hawk Turquoise","hex":"#00756a","rgb":{"r":0,"g":117,"b":106},"luminance":69.7339809346921},{"name":"Hawk’s Eye","hex":"#34363a","rgb":{"r":52,"g":54,"b":58},"luminance":35.91966107857923},{"name":"Hawkbit","hex":"#fddb6d","rgb":{"r":253,"g":219,"b":109},"luminance":149.67547525897487},{"name":"Hawker's Gold","hex":"#f4c26c","rgb":{"r":244,"g":194,"b":108},"luminance":135.80265889885956},{"name":"Hawkes Blue","hex":"#d2daed","rgb":{"r":210,"g":218,"b":237},"luminance":145.07878404508358},{"name":"Hawkesbury","hex":"#729183","rgb":{"r":114,"g":145,"b":131},"luminance":92.89479520941956},{"name":"Hawthorn Berry","hex":"#cc1111","rgb":{"r":204,"g":17,"b":17},"luminance":61.837272748723315},{"name":"Hawthorn Blossom","hex":"#eeffaa","rgb":{"r":238,"g":255,"b":170},"luminance":166.8688523032384},{"name":"Hawthorn Rose","hex":"#884c5e","rgb":{"r":136,"g":76,"b":94},"luminance":61.307618580401574},{"name":"Hay","hex":"#d3cca3","rgb":{"r":211,"g":204,"b":163},"luminance":136.6202625857526},{"name":"Hay Day","hex":"#dacd81","rgb":{"r":218,"g":205,"b":129},"luminance":137.64255077918313},{"name":"Hay Wain","hex":"#cdad59","rgb":{"r":205,"g":173,"b":89},"luminance":119.04883007404985},{"name":"Hayden Valley","hex":"#5f5d50","rgb":{"r":95,"g":93,"b":80},"luminance":62.21089700366005},{"name":"Hayride","hex":"#d4ac99","rgb":{"r":212,"g":172,"b":153},"luminance":120.48232735135888},{"name":"Haystacks","hex":"#cfac47","rgb":{"r":207,"g":172,"b":71},"luminance":118.7012450692915},{"name":"Haze","hex":"#c8c2c6","rgb":{"r":200,"g":194,"b":198},"luminance":130.58994627458884},{"name":"Haze Blue","hex":"#b7c0be","rgb":{"r":183,"g":192,"b":190},"luminance":127.14282246749126},{"name":"Hazed Nuts","hex":"#c39e6d","rgb":{"r":195,"g":158,"b":109},"luminance":110.25288666062218},{"name":"Hazel","hex":"#ae7250","rgb":{"r":174,"g":114,"b":80},"luminance":85.25196654623281},{"name":"Hazel Blush","hex":"#eae2de","rgb":{"r":234,"g":226,"b":222},"luminance":152.10174970722724},{"name":"Hazelnut","hex":"#a8715a","rgb":{"r":168,"g":113,"b":90},"luminance":83.8350939941025},{"name":"Hazelnut Chocolate","hex":"#7b3f00","rgb":{"r":123,"g":63,"b":0},"luminance":52.154981449522154},{"name":"Hazelnut Milk","hex":"#eeaa77","rgb":{"r":238,"g":170,"b":119},"luminance":123.31305973010319},{"name":"Hazelnut Turkish Delight","hex":"#fce974","rgb":{"r":252,"g":233,"b":116},"luminance":156.71152389342654},{"name":"Hazelwood","hex":"#fff3d5","rgb":{"r":255,"g":243,"b":213},"luminance":163.55234767498752},{"name":"Hazy Daze","hex":"#a5b8c5","rgb":{"r":165,"g":184,"b":197},"luminance":120.84714333818569},{"name":"Hazy Grove","hex":"#f2f1dc","rgb":{"r":242,"g":241,"b":220},"luminance":160.86515674004733},{"name":"Hazy Moon","hex":"#f1dca1","rgb":{"r":241,"g":220,"b":161},"luminance":149.01848340726056},{"name":"Hazy Rose","hex":"#b39897","rgb":{"r":179,"g":152,"b":151},"luminance":105.45966723349737},{"name":"Hazy Sky","hex":"#b7bdd6","rgb":{"r":183,"g":189,"b":214},"luminance":126.08514644477359},{"name":"Hè Sè Brown","hex":"#7f5e00","rgb":{"r":127,"g":94,"b":0},"luminance":66.98179165265736},{"name":"Head in the Clouds","hex":"#d1dde1","rgb":{"r":209,"g":221,"b":225},"luminance":146.260528202246},{"name":"Head in the Sand","hex":"#ebe2de","rgb":{"r":235,"g":226,"b":222},"luminance":152.23951961629413},{"name":"Healing Retreat","hex":"#bac2aa","rgb":{"r":186,"g":194,"b":170},"luminance":128.20569519331036},{"name":"Heart Gold","hex":"#808000","rgb":{"r":128,"g":128,"b":0},"luminance":84.321791252321},{"name":"Heart of Gold","hex":"#9d7f4c","rgb":{"r":157,"g":127,"b":76},"luminance":88.52267249693718},{"name":"Heart Stone","hex":"#ede3df","rgb":{"r":237,"g":227,"b":223},"luminance":153.0461984304086},{"name":"Heart Throb","hex":"#cb3d3c","rgb":{"r":203,"g":61,"b":60},"luminance":70.80291419143707},{"name":"Heart Wood","hex":"#6f4232","rgb":{"r":111,"g":66,"b":50},"luminance":51.331688896820836},{"name":"Heart's Content","hex":"#e2b5bd","rgb":{"r":226,"g":181,"b":189},"luminance":127.74545236915482},{"name":"Heart's Desire","hex":"#ac3e5f","rgb":{"r":172,"g":62,"b":95},"luminance":63.92692171534618},{"name":"Heartbeat","hex":"#aa0000","rgb":{"r":170,"g":0,"b":0},"luminance":50.83},{"name":"Heartfelt","hex":"#ffadc9","rgb":{"r":255,"g":173,"b":201},"luminance":129.03858733727674},{"name":"Hearth","hex":"#e1cca6","rgb":{"r":225,"g":204,"b":166},"luminance":138.64929464299485},{"name":"Hearth Gold","hex":"#a17135","rgb":{"r":161,"g":113,"b":53},"luminance":82.180719429803},{"name":"Heartless","hex":"#623b70","rgb":{"r":98,"g":59,"b":112},"luminance":47.1282687672696},{"name":"Hearty Hosta","hex":"#96bf83","rgb":{"r":150,"g":191,"b":131},"luminance":121.67484762677945},{"name":"Heat Signature","hex":"#e3000e","rgb":{"r":227,"g":0,"b":14},"luminance":67.89176198184872},{"name":"Heat Wave","hex":"#ff7a00","rgb":{"r":255,"g":122,"b":0},"luminance":104.60337002697379},{"name":"Heath","hex":"#4f2a2c","rgb":{"r":79,"g":42,"b":44},"luminance":34.50987703542277},{"name":"Heath Green","hex":"#9acda9","rgb":{"r":154,"g":205,"b":169},"luminance":130.27634127883695},{"name":"Heath Spotted Orchid","hex":"#9f5f9f","rgb":{"r":159,"g":95,"b":159},"luminance":75.48797110798515},{"name":"Heather","hex":"#a484ac","rgb":{"r":164,"g":132,"b":172},"luminance":93.76978839690318},{"name":"Heather Berry","hex":"#e75480","rgb":{"r":231,"g":84,"b":128},"luminance":86.10883862298923},{"name":"Heather Rose","hex":"#ad6d7f","rgb":{"r":173,"g":109,"b":127},"luminance":83.54112341835008},{"name":"Heathered Grey","hex":"#b6b095","rgb":{"r":182,"g":176,"b":149},"luminance":117.99666208838282},{"name":"Heating Lamp","hex":"#ee4422","rgb":{"r":238,"g":68,"b":34},"luminance":81.68439677196618},{"name":"Heaven Sent","hex":"#eee1eb","rgb":{"r":238,"g":225,"b":235},"luminance":152.39927811180732},{"name":"Heaven Sent Storm","hex":"#cad6de","rgb":{"r":202,"g":214,"b":222},"luminance":141.66261042349882},{"name":"Heavenly","hex":"#7eb2c5","rgb":{"r":126,"g":178,"b":197},"luminance":113.31820787499244},{"name":"Heavenly Blue","hex":"#a3bbcd","rgb":{"r":163,"g":187,"b":205},"luminance":122.35475238011803},{"name":"Heavenly Haze","hex":"#d8d5e3","rgb":{"r":216,"g":213,"b":227},"luminance":143.08569076256367},{"name":"Heavenly Pink","hex":"#f4dede","rgb":{"r":244,"g":222,"b":222},"luminance":151.47544816240023},{"name":"Heavy Black Green","hex":"#3a514d","rgb":{"r":58,"g":81,"b":77},"luminance":51.36648184370816},{"name":"Heavy Blue Grey","hex":"#9fabaf","rgb":{"r":159,"g":171,"b":175},"luminance":112.84365870530785},{"name":"Heavy Brown","hex":"#73624a","rgb":{"r":115,"g":98,"b":74},"luminance":67.54801993396994},{"name":"Heavy Charcoal","hex":"#565350","rgb":{"r":86,"g":83,"b":80},"luminance":55.84012927098217},{"name":"Heavy Cream","hex":"#e8ddc6","rgb":{"r":232,"g":221,"b":198},"luminance":148.83047113074662},{"name":"Heavy Gluten","hex":"#ddccaa","rgb":{"r":221,"g":204,"b":170},"luminance":138.1361724712249},{"name":"Heavy Goldbrown","hex":"#baab74","rgb":{"r":186,"g":171,"b":116},"luminance":115.51334685221444},{"name":"Heavy Green","hex":"#49583e","rgb":{"r":73,"g":88,"b":62},"luminance":56.521826660149614},{"name":"Heavy Grey","hex":"#82868a","rgb":{"r":130,"g":134,"b":138},"luminance":89.13727440302401},{"name":"Heavy Hammock","hex":"#beb9a2","rgb":{"r":190,"g":185,"b":162},"luminance":123.94078081487142},{"name":"Heavy Khaki","hex":"#5e6a34","rgb":{"r":94,"g":106,"b":52},"luminance":68.53222383667408},{"name":"Heavy Metal","hex":"#46473e","rgb":{"r":70,"g":71,"b":62},"luminance":47.169840502168334},{"name":"Heavy Metal Armor","hex":"#888a8e","rgb":{"r":136,"g":138,"b":142},"luminance":92.0737979883528},{"name":"Heavy Ochre","hex":"#9b753d","rgb":{"r":155,"g":117,"b":61},"luminance":83.14458600534373},{"name":"Heavy Orange","hex":"#ee4328","rgb":{"r":238,"g":67,"b":40},"luminance":81.43460004813679},{"name":"Heavy Red","hex":"#9e1212","rgb":{"r":158,"g":18,"b":18},"luminance":48.45263278708392},{"name":"Heavy Siena","hex":"#735848","rgb":{"r":115,"g":88,"b":72},"luminance":62.59426351511774},{"name":"Heavy Skintone","hex":"#927a71","rgb":{"r":146,"g":122,"b":113},"luminance":84.8538899285118},{"name":"Heavy Violet","hex":"#4f566c","rgb":{"r":79,"g":86,"b":108},"luminance":57.07862392349696},{"name":"Heavy Warm Grey","hex":"#bdb3a7","rgb":{"r":189,"g":179,"b":167},"luminance":120.81504001571989},{"name":"Hedge Green","hex":"#768a75","rgb":{"r":118,"g":138,"b":117},"luminance":89.35711389699199},{"name":"Hedgehog Mushroom","hex":"#faf0da","rgb":{"r":250,"g":240,"b":218},"luminance":161.4074310680893},{"name":"Hēi Sè Black","hex":"#142030","rgb":{"r":20,"g":32,"b":48},"luminance":20.458295139136105},{"name":"Heidelberg Red[2]","hex":"#960117","rgb":{"r":150,"g":1,"b":23},"luminance":44.93041233952789},{"name":"Heifer","hex":"#c3bdb1","rgb":{"r":195,"g":189,"b":177},"luminance":126.94476735178965},{"name":"Heirloom Lilac","hex":"#9d96b2","rgb":{"r":157,"g":150,"b":178},"luminance":101.82442247810688},{"name":"Heirloom Rose","hex":"#d182a0","rgb":{"r":209,"g":130,"b":160},"luminance":100.30472960434119},{"name":"Heirloom Shade","hex":"#dcd8d4","rgb":{"r":220,"g":216,"b":212},"luminance":144.86998270173154},{"name":"Heirloom Tomato","hex":"#833633","rgb":{"r":131,"g":54,"b":51},"luminance":50.72254292718377},{"name":"Heisenberg Blue","hex":"#70d4fb","rgb":{"r":112,"g":212,"b":251},"luminance":132.00953100439375},{"name":"Helena Rose","hex":"#d28b72","rgb":{"r":210,"g":139,"b":114},"luminance":103.77329986562054},{"name":"Heliotrope","hex":"#d94ff5","rgb":{"r":217,"g":79,"b":245},"luminance":84.50055454255906},{"name":"Heliotrope Grey","hex":"#ab98a9","rgb":{"r":171,"g":152,"b":169},"luminance":104.62445016820875},{"name":"Heliotrope Magenta","hex":"#aa00bb","rgb":{"r":170,"g":0,"b":187},"luminance":55.119379749775845},{"name":"Helium","hex":"#eae5d8","rgb":{"r":234,"g":229,"b":216},"luminance":153.52890757443694},{"name":"Hellebore","hex":"#646944","rgb":{"r":100,"g":105,"b":68},"luminance":68.9418358400761},{"name":"Hellion Green","hex":"#87c5ae","rgb":{"r":135,"g":197,"b":174},"luminance":124.07730832831601},{"name":"Hello Fall","hex":"#995533","rgb":{"r":153,"g":85,"b":51},"luminance":67.94189892842266},{"name":"Hello Spring","hex":"#44dd66","rgb":{"r":68,"g":221,"b":102},"luminance":131.82448610557904},{"name":"Hello Summer","hex":"#55bbff","rgb":{"r":85,"g":187,"b":255},"luminance":116.36245307658308},{"name":"Hello Winter","hex":"#99ffee","rgb":{"r":153,"g":255,"b":238},"luminance":158.85380907614396},{"name":"Hello Yellow","hex":"#ffe59d","rgb":{"r":255,"g":229,"b":157},"luminance":155.57371679689342},{"name":"Helvetia Red","hex":"#f00000","rgb":{"r":240,"g":0,"b":0},"luminance":71.75999999999999},{"name":"Hematitic Sand","hex":"#dc8c59","rgb":{"r":220,"g":140,"b":89},"luminance":105.75207854222063},{"name":"Hemlock","hex":"#69684b","rgb":{"r":105,"g":104,"b":75},"luminance":69.1780805530191},{"name":"Hemoglobin Red","hex":"#c61a1b","rgb":{"r":198,"g":26,"b":27},"luminance":61.215027011347466},{"name":"Hemp","hex":"#987d73","rgb":{"r":152,"g":125,"b":115},"luminance":87.29996236539854},{"name":"Hemp Fabric","hex":"#b5ad88","rgb":{"r":181,"g":173,"b":136},"luminance":116.11135077157616},{"name":"Hemp Rope","hex":"#b9a379","rgb":{"r":185,"g":163,"b":121},"luminance":111.3771853747436},{"name":"Hemp Tea","hex":"#b5b35c","rgb":{"r":181,"g":179,"b":92},"luminance":118.65580320405739},{"name":"Hen of the Woods","hex":"#eed9c4","rgb":{"r":238,"g":217,"b":196},"luminance":147.6099394383725},{"name":"Henna","hex":"#7c423c","rgb":{"r":124,"g":66,"b":60},"luminance":54.05883776035145},{"name":"Henna Red","hex":"#6e3530","rgb":{"r":110,"g":53,"b":48},"luminance":45.60251314346611},{"name":"Hephaestus Gold","hex":"#ff9911","rgb":{"r":255,"g":153,"b":17},"luminance":117.82644690391031},{"name":"Hera Blue","hex":"#7777ee","rgb":{"r":119,"g":119,"b":238},"luminance":82.9553771252955},{"name":"Herald's Trumpet","hex":"#ce9f2f","rgb":{"r":206,"g":159,"b":47},"luminance":111.95346305050147},{"name":"Herb Garden","hex":"#e9f3e1","rgb":{"r":233,"g":243,"b":225},"luminance":160.803819202157},{"name":"Herb Robert","hex":"#dda0df","rgb":{"r":221,"g":160,"b":223},"luminance":117.61666006565565},{"name":"Herbal","hex":"#29ab87","rgb":{"r":41,"g":171,"b":135},"luminance":102.28722945705393},{"name":"Herbal Garden","hex":"#9cad60","rgb":{"r":156,"g":173,"b":96},"luminance":112.28552655173327},{"name":"Herbal Mist","hex":"#d2e6d3","rgb":{"r":210,"g":230,"b":211},"luminance":150.82731554993612},{"name":"Herbal Tea","hex":"#f9fee9","rgb":{"r":249,"g":254,"b":233},"luminance":168.75634758135766},{"name":"Herbalist","hex":"#969e86","rgb":{"r":150,"g":158,"b":134},"luminance":104.1474876893341},{"name":"Herbery Honey","hex":"#eeee22","rgb":{"r":238,"g":238,"b":34},"luminance":156.833733794742},{"name":"Here Comes the Sun","hex":"#fcdf63","rgb":{"r":252,"g":223,"b":99},"luminance":151.45879539003337},{"name":"Hereford Bull","hex":"#5f3b36","rgb":{"r":95,"g":59,"b":54},"luminance":45.2126647080218},{"name":"Hereford Cow Brown","hex":"#6c2e1f","rgb":{"r":108,"g":46,"b":31},"luminance":42.24180895747719},{"name":"Heritage Blue","hex":"#5d96bc","rgb":{"r":93,"g":150,"b":188},"luminance":94.79115134336116},{"name":"Heritage Taffeta","hex":"#956f7b","rgb":{"r":149,"g":111,"b":123},"luminance":80.16759154421442},{"name":"Hero","hex":"#005d6a","rgb":{"r":0,"g":93,"b":106},"luminance":55.91243454724538},{"name":"Heroic Blue","hex":"#1166ff","rgb":{"r":17,"g":102,"b":255},"luminance":66.75176151233764},{"name":"Heron","hex":"#62617e","rgb":{"r":98,"g":97,"b":126},"luminance":65.62759648958661},{"name":"Herring Silver","hex":"#c6c8cf","rgb":{"r":198,"g":200,"b":207},"luminance":133.58331635350277},{"name":"Hesperide Apple Gold","hex":"#ffe296","rgb":{"r":255,"g":226,"b":150},"luminance":153.96400965485407},{"name":"Hestia Red","hex":"#ee2200","rgb":{"r":238,"g":34,"b":0},"luminance":73.90772630787663},{"name":"Hexed Lichen","hex":"#6e0060","rgb":{"r":110,"g":0,"b":96},"luminance":34.662995196607},{"name":"Hexos Palesun","hex":"#fbff0a","rgb":{"r":251,"g":255,"b":10},"luminance":167.44924970270844},{"name":"Hey Blue!","hex":"#16f8ff","rgb":{"r":22,"g":248,"b":255},"luminance":148.5957831164801},{"name":"Hi Def Lime","hex":"#bbb465","rgb":{"r":187,"g":180,"b":101},"luminance":120.09525954424679},{"name":"Hibiscus","hex":"#b6316c","rgb":{"r":182,"g":49,"b":108},"luminance":62.77112582230782},{"name":"Hibiscus Delight","hex":"#fe9773","rgb":{"r":254,"g":151,"b":115},"luminance":117.45716148877429},{"name":"Hibiscus Leaf","hex":"#6e826e","rgb":{"r":110,"g":130,"b":110},"luminance":84.03701446386586},{"name":"Hibiscus Pop","hex":"#dd77dd","rgb":{"r":221,"g":119,"b":221},"luminance":99.40127507230477},{"name":"Hickory","hex":"#b7a28e","rgb":{"r":183,"g":162,"b":142},"luminance":110.90027172644798},{"name":"Hickory Branch","hex":"#ab8274","rgb":{"r":171,"g":130,"b":116},"luminance":92.80228939525145},{"name":"Hickory Cliff","hex":"#7c6e6d","rgb":{"r":124,"g":110,"b":109},"luminance":75.48721846776445},{"name":"Hidcote","hex":"#9c949b","rgb":{"r":156,"g":148,"b":155},"luminance":100.17649929998552},{"name":"Hidden Cottage","hex":"#8d7f64","rgb":{"r":141,"g":127,"b":100},"luminance":86.39962200148794},{"name":"Hidden Creek","hex":"#d5dae0","rgb":{"r":213,"g":218,"b":224},"luminance":145.20130309676975},{"name":"Hidden Depths","hex":"#305451","rgb":{"r":48,"g":84,"b":81},"luminance":52.177825980008016},{"name":"Hidden Diary","hex":"#ede4cc","rgb":{"r":237,"g":228,"b":204},"luminance":153.21384141454058},{"name":"Hidden Forest","hex":"#4f5a51","rgb":{"r":79,"g":90,"b":81},"luminance":58.60228064674616},{"name":"Hidden Hills","hex":"#c5d2b1","rgb":{"r":197,"g":210,"b":177},"luminance":138.10216505544003},{"name":"Hidden Mask","hex":"#96748a","rgb":{"r":150,"g":116,"b":138},"luminance":83.03938094663279},{"name":"Hidden Paradise","hex":"#5e8b3d","rgb":{"r":94,"g":139,"b":61},"luminance":86.57784359176428},{"name":"Hidden Waters","hex":"#225258","rgb":{"r":34,"g":82,"b":88},"luminance":50.208271589450284},{"name":"Hideaway","hex":"#c8c0aa","rgb":{"r":200,"g":192,"b":170},"luminance":129.04966492013838},{"name":"Hideout","hex":"#5386b7","rgb":{"r":83,"g":134,"b":183},"luminance":85.07753814609353},{"name":"High Altar","hex":"#334f7b","rgb":{"r":51,"g":79,"b":123},"luminance":50.78979832604182},{"name":"High Blue","hex":"#4ca8e0","rgb":{"r":76,"g":168,"b":224},"luminance":104.37232836341249},{"name":"High Chaparral","hex":"#75603d","rgb":{"r":117,"g":96,"b":61},"luminance":66.69120113628183},{"name":"High Dive","hex":"#59b9cc","rgb":{"r":89,"g":185,"b":204},"luminance":114.20096707996828},{"name":"High Elf Blue","hex":"#8cbed6","rgb":{"r":140,"g":190,"b":214},"luminance":121.59919948749662},{"name":"High Grass","hex":"#bbdd00","rgb":{"r":187,"g":221,"b":0},"luminance":141.26343510618733},{"name":"High Hopes","hex":"#deeaaa","rgb":{"r":222,"g":234,"b":170},"luminance":153.781804671424},{"name":"High Noon","hex":"#cfb999","rgb":{"r":207,"g":185,"b":153},"luminance":126.20554994927916},{"name":"High Point","hex":"#bcd8d2","rgb":{"r":188,"g":216,"b":210},"luminance":140.74488910081243},{"name":"High Priest","hex":"#643949","rgb":{"r":100,"g":57,"b":73},"luminance":45.637379032981286},{"name":"High Profile","hex":"#005a85","rgb":{"r":0,"g":90,"b":133},"luminance":54.96267045913981},{"name":"High Rank","hex":"#645453","rgb":{"r":100,"g":84,"b":83},"luminance":58.436446743449416},{"name":"High Rise","hex":"#aeb2b5","rgb":{"r":174,"g":178,"b":181},"luminance":118.53181356918486},{"name":"High Risk Red","hex":"#c71f2d","rgb":{"r":199,"g":31,"b":45},"luminance":62.4324972270051},{"name":"High Salute","hex":"#445056","rgb":{"r":68,"g":80,"b":86},"luminance":52.103265156801825},{"name":"High Sierra","hex":"#cedee2","rgb":{"r":206,"g":222,"b":226},"luminance":146.42179867765591},{"name":"High Society","hex":"#cab7c0","rgb":{"r":202,"g":183,"b":192},"luminance":125.16498787200835},{"name":"High Tea Green","hex":"#567063","rgb":{"r":86,"g":112,"b":99},"luminance":71.4902589728139},{"name":"High Voltage","hex":"#eeff11","rgb":{"r":238,"g":255,"b":17},"luminance":165.75097379201125},{"name":"Highball","hex":"#928c3c","rgb":{"r":146,"g":140,"b":60},"luminance":93.30600042869696},{"name":"Highland","hex":"#7a9461","rgb":{"r":122,"g":148,"b":97},"luminance":94.87024414430479},{"name":"Highland Green","hex":"#305144","rgb":{"r":48,"g":81,"b":68},"luminance":50.267192252999365},{"name":"Highlander","hex":"#3a533d","rgb":{"r":58,"g":83,"b":61},"luminance":52.18082905627315},{"name":"Highlands Moss","hex":"#445500","rgb":{"r":68,"g":85,"b":0},"luminance":53.87857875816696},{"name":"Highlands Twilight","hex":"#484a80","rgb":{"r":72,"g":74,"b":128},"luminance":50.62846128414333},{"name":"Highlight Gold","hex":"#dfc16d","rgb":{"r":223,"g":193,"b":109},"luminance":132.04195729388442},{"name":"Highlighter","hex":"#ffe536","rgb":{"r":255,"g":229,"b":54},"luminance":154.66330944991446},{"name":"Highlighter Blue","hex":"#3aafdc","rgb":{"r":58,"g":175,"b":220},"luminance":107.1549205076463},{"name":"Highlighter Green","hex":"#1bfc06","rgb":{"r":27,"g":252,"b":6},"luminance":148.14570854736223},{"name":"Highlighter Lavender","hex":"#85569c","rgb":{"r":133,"g":86,"b":156},"luminance":66.67921167050491},{"name":"Highlighter Lilac","hex":"#d72e83","rgb":{"r":215,"g":46,"b":131},"luminance":71.30703741567167},{"name":"Highlighter Orange","hex":"#f39539","rgb":{"r":243,"g":149,"b":57},"luminance":113.89047379829447},{"name":"Highlighter Pink","hex":"#ea5a79","rgb":{"r":234,"g":90,"b":121},"luminance":88.7497858701642},{"name":"Highlighter Red","hex":"#e94f58","rgb":{"r":233,"g":79,"b":88},"luminance":84.28871242343189},{"name":"Highlighter Turquoise","hex":"#009e6c","rgb":{"r":0,"g":158,"b":108},"luminance":93.55963798561855},{"name":"Highlighter Yellow","hex":"#f1e740","rgb":{"r":241,"g":231,"b":64},"luminance":153.7279333953332},{"name":"Hihada Brown","hex":"#752e23","rgb":{"r":117,"g":46,"b":35},"luminance":44.37159443833408},{"name":"Hiker's Delight","hex":"#d2b395","rgb":{"r":210,"g":179,"b":149},"luminance":123.577682552312},{"name":"Hiking Boots","hex":"#5e5440","rgb":{"r":94,"g":84,"b":64},"luminance":57.222877557843944},{"name":"Hill Giant","hex":"#e0eedf","rgb":{"r":224,"g":238,"b":223},"luminance":157.00264041091793},{"name":"Hillary","hex":"#a7a07e","rgb":{"r":167,"g":160,"b":126},"luminance":107.33403647026417},{"name":"Hillsbrad Grass","hex":"#7fa91f","rgb":{"r":127,"g":169,"b":31},"luminance":106.28110412486312},{"name":"Himalaya","hex":"#736330","rgb":{"r":115,"g":99,"b":48},"luminance":67.74504984129837},{"name":"Himalaya Peaks","hex":"#e2eaf0","rgb":{"r":226,"g":234,"b":240},"luminance":155.5057402155946},{"name":"Himalayan Balsam","hex":"#ff99cc","rgb":{"r":255,"g":153,"b":204},"luminance":120.08395930348065},{"name":"Himalayan Salt","hex":"#c07765","rgb":{"r":192,"g":119,"b":101},"luminance":91.1465428252767},{"name":"Himawari Yellow","hex":"#fcc800","rgb":{"r":252,"g":200,"b":0},"luminance":139.49939463667934},{"name":"Hindsight","hex":"#bdc9e3","rgb":{"r":189,"g":201,"b":227},"luminance":133.35702521427208},{"name":"Hindu Lotus","hex":"#8e8062","rgb":{"r":142,"g":128,"b":98},"luminance":87.02249044930856},{"name":"Hinomaru Red","hex":"#bc002d","rgb":{"r":188,"g":0,"b":45},"luminance":56.44560074974842},{"name":"Hint of Blue","hex":"#cee1f2","rgb":{"r":206,"g":225,"b":242},"luminance":148.31966897549358},{"name":"Hint of Green","hex":"#dfeade","rgb":{"r":223,"g":234,"b":222},"luminance":154.7693036651648},{"name":"Hint of Mint","hex":"#dff1d6","rgb":{"r":223,"g":241,"b":214},"luminance":158.284235582701},{"name":"Hint of Orange","hex":"#f8e6d9","rgb":{"r":248,"g":230,"b":217},"luminance":156.0070121757352},{"name":"Hint of Pink","hex":"#f1e4e1","rgb":{"r":241,"g":228,"b":225},"luminance":154.150889964995},{"name":"Hint of Red","hex":"#f6dfe0","rgb":{"r":246,"g":223,"b":224},"luminance":152.30676286035364},{"name":"Hint of Yellow","hex":"#faf1cd","rgb":{"r":250,"g":241,"b":205},"luminance":161.6992006442827},{"name":"Hinterland","hex":"#616c51","rgb":{"r":97,"g":108,"b":81},"luminance":70.3242033797753},{"name":"Hinterlands Green","hex":"#304112","rgb":{"r":48,"g":65,"b":18},"luminance":40.81659751865655},{"name":"Hip Hop","hex":"#e4e8a7","rgb":{"r":228,"g":232,"b":167},"luminance":153.47947381979128},{"name":"Hip Waders","hex":"#746a51","rgb":{"r":116,"g":106,"b":81},"luminance":71.83191418861117},{"name":"Hippie Blue","hex":"#49889a","rgb":{"r":73,"g":136,"b":154},"luminance":84.60366002130168},{"name":"Hippie Green","hex":"#608a5a","rgb":{"r":96,"g":138,"b":90},"luminance":86.55148324552272},{"name":"Hippie Pink","hex":"#ab495c","rgb":{"r":171,"g":73,"b":92},"luminance":67.53059296348582},{"name":"Hippie Trail","hex":"#c6aa2b","rgb":{"r":198,"g":170,"b":43},"luminance":116.13333073670107},{"name":"Hippogriff Brown","hex":"#5c3c0d","rgb":{"r":92,"g":60,"b":13},"luminance":44.713921635213346},{"name":"Hippy","hex":"#eae583","rgb":{"r":234,"g":229,"b":131},"luminance":152.27543610510529},{"name":"Hipster","hex":"#f2f1d9","rgb":{"r":242,"g":241,"b":217},"luminance":160.81219138174816},{"name":"Hipster Salmon","hex":"#fd7c6e","rgb":{"r":253,"g":124,"b":110},"luminance":105.72517747916055},{"name":"Hiroshima Aquamarine","hex":"#7fffd4","rgb":{"r":127,"g":255,"b":212},"luminance":156.30623844875802},{"name":"His Eyes","hex":"#9bb9e1","rgb":{"r":155,"g":185,"b":225},"luminance":120.8248962341785},{"name":"Hisoku Blue","hex":"#abced8","rgb":{"r":171,"g":206,"b":216},"luminance":133.57636804839393},{"name":"Historic White","hex":"#ebe6d7","rgb":{"r":235,"g":230,"b":215},"luminance":154.1609886612044},{"name":"Hisui Kingfisher","hex":"#38b48b","rgb":{"r":56,"g":180,"b":139},"luminance":108.14570195805287},{"name":"Hit Grey","hex":"#a1adb5","rgb":{"r":161,"g":173,"b":181},"luminance":114.26167720631445},{"name":"Hit Pink","hex":"#fda470","rgb":{"r":253,"g":164,"b":112},"luminance":123.09759647125527},{"name":"Hitchcock Milk","hex":"#eeffa9","rgb":{"r":238,"g":255,"b":169},"luminance":166.85565086325366},{"name":"Hitching Post","hex":"#c48d69","rgb":{"r":196,"g":141,"b":105},"luminance":102.11800039660001},{"name":"Hitsujiyama Pink","hex":"#ee66ff","rgb":{"r":238,"g":102,"b":255},"luminance":97.43711315510122},{"name":"Hive","hex":"#ffff77","rgb":{"r":255,"g":255,"b":119},"luminance":168.53170504685463},{"name":"Hobgoblin","hex":"#01ad8f","rgb":{"r":1,"g":173,"b":143},"luminance":102.85159311357309},{"name":"Hockham Green","hex":"#59685f","rgb":{"r":89,"g":104,"b":95},"luminance":67.47067900206726},{"name":"Hoeth Blue","hex":"#57a9d4","rgb":{"r":87,"g":169,"b":212},"luminance":105.36604577376907},{"name":"Hog Bristle","hex":"#dcd1bb","rgb":{"r":220,"g":209,"b":187},"luminance":140.82820744793992},{"name":"Hog-Maw","hex":"#fbe8e4","rgb":{"r":251,"g":232,"b":228},"luminance":157.65157252942325},{"name":"Hog's Pudding","hex":"#dad5c7","rgb":{"r":218,"g":213,"b":199},"luminance":142.81491056959004},{"name":"Hokey Pokey","hex":"#bb8e34","rgb":{"r":187,"g":142,"b":52},"luminance":100.5449853001133},{"name":"Hoki","hex":"#647d86","rgb":{"r":100,"g":125,"b":134},"luminance":80.69235900009369},{"name":"Hold Your Horses","hex":"#705446","rgb":{"r":112,"g":84,"b":70},"luminance":60.13655633639159},{"name":"Hole In One","hex":"#4aae97","rgb":{"r":74,"g":174,"b":151},"luminance":105.9153091672776},{"name":"Holenso","hex":"#598069","rgb":{"r":89,"g":128,"b":105},"luminance":80.60300687319301},{"name":"Holiday","hex":"#81c3b4","rgb":{"r":129,"g":195,"b":180},"luminance":122.51950320663235},{"name":"Holiday Camp","hex":"#6d9e7a","rgb":{"r":109,"g":158,"b":122},"luminance":99.28457211974073},{"name":"Holland Tile","hex":"#dd9789","rgb":{"r":221,"g":151,"b":137},"luminance":111.65515632517828},{"name":"Holland Tulip","hex":"#f89851","rgb":{"r":248,"g":152,"b":81},"luminance":116.38173411665595},{"name":"Hollandaise Yellow","hex":"#ffee44","rgb":{"r":255,"g":238,"b":68},"luminance":159.34603843522436},{"name":"Hollow Knight","hex":"#330055","rgb":{"r":51,"g":0,"b":85},"luminance":18.067321356526538},{"name":"Holly","hex":"#25342b","rgb":{"r":37,"g":52,"b":43},"luminance":32.834953159704675},{"name":"Holly Berry","hex":"#b44e5d","rgb":{"r":180,"g":78,"b":93},"luminance":71.45175015351269},{"name":"Holly Bush","hex":"#355d51","rgb":{"r":53,"g":93,"b":81},"luminance":57.58968176678874},{"name":"Holly Fern","hex":"#8cb299","rgb":{"r":140,"g":178,"b":153},"luminance":113.90262139213476},{"name":"Holly Glen","hex":"#a2b7b5","rgb":{"r":162,"g":183,"b":181},"luminance":119.6297330975874},{"name":"Holly Green","hex":"#0f9d76","rgb":{"r":15,"g":157,"b":118},"luminance":93.24351350094008},{"name":"Holly Leaf","hex":"#2e5a50","rgb":{"r":46,"g":90,"b":80},"luminance":55.34759087801383},{"name":"Hollyhock","hex":"#823270","rgb":{"r":130,"g":50,"b":112},"luminance":50.351973387346},{"name":"Hollyhock Bloom","hex":"#b7737d","rgb":{"r":183,"g":115,"b":125},"luminance":88.0564456130271},{"name":"Hollywood Cerise","hex":"#f400a0","rgb":{"r":244,"g":0,"b":160},"luminance":75.20156604752324},{"name":"Hollywood Golden Age","hex":"#ecd8b1","rgb":{"r":236,"g":216,"b":177},"luminance":146.50133461508122},{"name":"Hollywood Starlet","hex":"#f2d082","rgb":{"r":242,"g":208,"b":130},"luminance":142.698093119705},{"name":"Holy Grail","hex":"#e8d720","rgb":{"r":232,"g":215,"b":32},"luminance":144.0587704827443},{"name":"Holy White","hex":"#f5f5dc","rgb":{"r":245,"g":245,"b":220},"luminance":163.33418396037004},{"name":"Home Body","hex":"#f3d2b2","rgb":{"r":243,"g":210,"b":178},"luminance":144.52092517348484},{"name":"Home Brew","hex":"#897b66","rgb":{"r":137,"g":123,"b":102},"luminance":83.82220561402568},{"name":"Home Plate","hex":"#f7eedb","rgb":{"r":247,"g":238,"b":219},"luminance":159.9854155884217},{"name":"Home World","hex":"#2299dd","rgb":{"r":34,"g":153,"b":221},"luminance":93.83017059027442},{"name":"Homebush","hex":"#726e69","rgb":{"r":114,"g":110,"b":105},"luminance":73.98933163639201},{"name":"Homeopathic","hex":"#5f7c47","rgb":{"r":95,"g":124,"b":71},"luminance":78.55221069454377},{"name":"Homeopathic Blue","hex":"#dbe7e3","rgb":{"r":219,"g":231,"b":227},"luminance":152.78736418303706},{"name":"Homeopathic Green","hex":"#e1ebd8","rgb":{"r":225,"g":235,"b":216},"luminance":155.43838015754022},{"name":"Homeopathic Lavender","hex":"#e5e0ec","rgb":{"r":229,"g":224,"b":236},"luminance":150.66916473187206},{"name":"Homeopathic Lilac","hex":"#e1e0eb","rgb":{"r":225,"g":224,"b":235},"luminance":150.10903993097816},{"name":"Homeopathic Mint","hex":"#e5ead8","rgb":{"r":229,"g":234,"b":216},"luminance":155.4407905956477},{"name":"Homeopathic Orange","hex":"#f2e6e1","rgb":{"r":242,"g":230,"b":225},"luminance":155.31034339025845},{"name":"Homeopathic Red","hex":"#ecdbe0","rgb":{"r":236,"g":219,"b":224},"luminance":148.85307924594642},{"name":"Homeopathic Rose","hex":"#e8dbdd","rgb":{"r":232,"g":219,"b":221},"luminance":148.23134239761848},{"name":"Homeopathic Yellow","hex":"#ede7d7","rgb":{"r":237,"g":231,"b":215},"luminance":154.94789859175242},{"name":"Homestead","hex":"#ac8674","rgb":{"r":172,"g":134,"b":116},"luminance":94.9041322809497},{"name":"Homestead Red","hex":"#986e6e","rgb":{"r":152,"g":110,"b":110},"luminance":79.95034211308916},{"name":"Homeworld","hex":"#acdcee","rgb":{"r":172,"g":220,"b":238},"luminance":141.62670725537606},{"name":"Honed Steel","hex":"#867c83","rgb":{"r":134,"g":124,"b":131},"luminance":84.41801736596281},{"name":"Honesty","hex":"#dfebe9","rgb":{"r":223,"g":235,"b":233},"luminance":155.4997916333009},{"name":"Honey","hex":"#ba9238","rgb":{"r":186,"g":146,"b":56},"luminance":102.36457031610107},{"name":"Honey and Thyme","hex":"#aaaa00","rgb":{"r":170,"g":170,"b":0},"luminance":111.98987900698883},{"name":"Honey Baked Ham","hex":"#ffaa99","rgb":{"r":255,"g":170,"b":153},"luminance":126.78946126946039},{"name":"Honey Bee","hex":"#fcdfa4","rgb":{"r":252,"g":223,"b":164},"luminance":152.19045082067402},{"name":"Honey Beehive","hex":"#d39f5f","rgb":{"r":211,"g":159,"b":95},"luminance":113.17490759881362},{"name":"Honey Beige","hex":"#f3e2c6","rgb":{"r":243,"g":226,"b":198},"luminance":152.93051061511565},{"name":"Honey Bunny","hex":"#dbb881","rgb":{"r":219,"g":184,"b":129},"luminance":127.16035491064028},{"name":"Honey Carrot Cake","hex":"#ff9955","rgb":{"r":255,"g":153,"b":85},"luminance":118.20834084784371},{"name":"Honey Chili","hex":"#883344","rgb":{"r":136,"g":51,"b":68},"luminance":51.08696868086812},{"name":"Honey Crusted Chicken","hex":"#ffbb55","rgb":{"r":255,"g":187,"b":85},"luminance":134.00160255011878},{"name":"Honey Do","hex":"#ededc7","rgb":{"r":237,"g":237,"b":199},"luminance":157.7666489661234},{"name":"Honey Flower","hex":"#5c3c6d","rgb":{"r":92,"g":60,"b":109},"luminance":46.38473822282497},{"name":"Honey Fungus","hex":"#d18e54","rgb":{"r":209,"g":142,"b":84},"luminance":104.61698797518498},{"name":"Honey Garlic Beef","hex":"#884422","rgb":{"r":136,"g":68,"b":34},"luminance":57.112794783655964},{"name":"Honey Ginger","hex":"#a86217","rgb":{"r":168,"g":98,"b":23},"luminance":76.41576659302712},{"name":"Honey Glow","hex":"#e8b447","rgb":{"r":232,"g":180,"b":71},"luminance":126.65491644622406},{"name":"Honey Gold","hex":"#d1a054","rgb":{"r":209,"g":160,"b":84},"luminance":113.2156846775216},{"name":"Honey Graham","hex":"#bc886a","rgb":{"r":188,"g":136,"b":106},"luminance":98.38170675486373},{"name":"Honey Grove","hex":"#dcb149","rgb":{"r":220,"g":177,"b":73},"luminance":123.252855078493},{"name":"Honey Haven","hex":"#bc9263","rgb":{"r":188,"g":146,"b":99},"luminance":103.1115684295414},{"name":"Honey Lime Chicken","hex":"#ddccbb","rgb":{"r":221,"g":204,"b":187},"luminance":138.4213670969912},{"name":"Honey Mustard","hex":"#b68f52","rgb":{"r":182,"g":143,"b":82},"luminance":100.47285856886923},{"name":"Honey N Cream","hex":"#f1dcb7","rgb":{"r":241,"g":220,"b":183},"luminance":149.34812394201674},{"name":"Honey Nectar","hex":"#f1dda2","rgb":{"r":241,"g":221,"b":162},"luminance":149.5415027141295},{"name":"Honey Oat Bread","hex":"#faeed9","rgb":{"r":250,"g":238,"b":217},"luminance":160.3661360138106},{"name":"Honey Peach","hex":"#dcbd9e","rgb":{"r":220,"g":189,"b":158},"luminance":130.22975770921175},{"name":"Honey Pink","hex":"#cc99aa","rgb":{"r":204,"g":153,"b":170},"luminance":110.28196650858199},{"name":"Honey Pot","hex":"#ffc863","rgb":{"r":255,"g":200,"b":99},"luminance":140.44014319630978},{"name":"Honey Robber","hex":"#dfbb86","rgb":{"r":223,"g":187,"b":134},"luminance":129.338361927156},{"name":"Honey Teriyaki","hex":"#ee6611","rgb":{"r":238,"g":102,"b":17},"luminance":93.01979339903953},{"name":"Honey Wax","hex":"#ffaa22","rgb":{"r":255,"g":170,"b":34},"luminance":125.6438120282889},{"name":"Honey Yellow","hex":"#ca9456","rgb":{"r":202,"g":148,"b":86},"luminance":106.26135796233736},{"name":"Honey Yogurt Popsicles","hex":"#f3f0d9","rgb":{"r":243,"g":240,"b":217},"luminance":160.43123976644947},{"name":"Honeycomb","hex":"#ddaa11","rgb":{"r":221,"g":170,"b":17},"luminance":119.70060227500944},{"name":"Honeydew","hex":"#f0fff0","rgb":{"r":240,"g":255,"b":240},"luminance":168.23693537686663},{"name":"Honeydew Melon","hex":"#e6eccc","rgb":{"r":230,"g":236,"b":204},"luminance":156.40098931912163},{"name":"Honeydew Peel","hex":"#d4fb79","rgb":{"r":212,"g":251,"b":121},"luminance":160.98603836668568},{"name":"Honeysuckle","hex":"#e8ed69","rgb":{"r":232,"g":237,"b":105},"luminance":155.91438831935943},{"name":"Honeysuckle Vine","hex":"#fbf1c8","rgb":{"r":251,"g":241,"b":200},"luminance":161.75631205612964},{"name":"Honeysweet","hex":"#e9cfc8","rgb":{"r":233,"g":207,"b":200},"luminance":141.90760363701446},{"name":"Hóng Bǎo Shū Red","hex":"#e02006","rgb":{"r":224,"g":32,"b":6},"luminance":69.56357587128483},{"name":"Hong Kong Skyline","hex":"#676e7a","rgb":{"r":103,"g":110,"b":122},"luminance":72.87779204256945},{"name":"Hong Kong Taxi","hex":"#a8102a","rgb":{"r":168,"g":16,"b":42},"luminance":51.326293768399054},{"name":"Hóng Lóu Mèng Red","hex":"#cf3f4f","rgb":{"r":207,"g":63,"b":79},"luminance":72.65979525156949},{"name":"Hóng Sè Red","hex":"#ff0809","rgb":{"r":255,"g":8,"b":9},"luminance":76.39636848044545},{"name":"Hóng Zōng Brown","hex":"#564a33","rgb":{"r":86,"g":74,"b":51},"luminance":50.81212685963853},{"name":"Honolulu Blue","hex":"#007fbf","rgb":{"r":0,"g":127,"b":191},"luminance":77.66376553451423},{"name":"Hooked Mimosa","hex":"#ffc9c4","rgb":{"r":255,"g":201,"b":196},"luminance":142.24446045452876},{"name":"Hooker's Green","hex":"#49796b","rgb":{"r":73,"g":121,"b":107},"luminance":75.299693638155},{"name":"Hooloovoo Blue","hex":"#4455ff","rgb":{"r":68,"g":85,"b":255},"luminance":61.220634993439916},{"name":"Hopbush","hex":"#cd6d93","rgb":{"r":205,"g":109,"b":147},"luminance":90.1761158955075},{"name":"Hope","hex":"#e581a0","rgb":{"r":229,"g":129,"b":160},"luminance":103.70606621601264},{"name":"Hope Chest","hex":"#875942","rgb":{"r":135,"g":89,"b":66},"luminance":66.44753456675423},{"name":"Hopi Moccasin","hex":"#ffe4b5","rgb":{"r":255,"g":228,"b":181},"luminance":155.4063604779418},{"name":"Hopscotch","hex":"#afbb42","rgb":{"r":175,"g":187,"b":66},"luminance":121.83492751259796},{"name":"Horenso Green","hex":"#789b73","rgb":{"r":120,"g":155,"b":115},"luminance":98.67885652458688},{"name":"Horizon","hex":"#648894","rgb":{"r":100,"g":136,"b":148},"luminance":86.90122328252922},{"name":"Horizon Blue","hex":"#289dbe","rgb":{"r":40,"g":157,"b":190},"luminance":95.42263086396224},{"name":"Horizon Glow","hex":"#ad7171","rgb":{"r":173,"g":113,"b":113},"luminance":85.09659225844476},{"name":"Horizon Grey","hex":"#9ca9aa","rgb":{"r":156,"g":169,"b":170},"luminance":111.32152687149058},{"name":"Horizon Haze","hex":"#80c1e2","rgb":{"r":128,"g":193,"b":226},"luminance":122.32489673406636},{"name":"Horizon Island","hex":"#cdd4c6","rgb":{"r":205,"g":212,"b":198},"luminance":140.54494421714355},{"name":"Horizon Sky","hex":"#c2c3d3","rgb":{"r":194,"g":195,"b":211},"luminance":130.55852012411904},{"name":"Hormagaunt Purple","hex":"#51576f","rgb":{"r":81,"g":87,"b":111},"luminance":57.92000032803867},{"name":"Horn of Plenty","hex":"#bba46d","rgb":{"r":187,"g":164,"b":109},"luminance":112.01873445544723},{"name":"Hornblende","hex":"#332222","rgb":{"r":51,"g":34,"b":34},"luminance":25.414113028000795},{"name":"Horned Frog","hex":"#c2ae87","rgb":{"r":194,"g":174,"b":135},"luminance":118.46399951039977},{"name":"Horned Lizard","hex":"#e8ead5","rgb":{"r":232,"g":234,"b":213},"luminance":155.78432242045412},{"name":"Hornet Nest","hex":"#d5dfd3","rgb":{"r":213,"g":223,"b":211},"luminance":147.54558850063935},{"name":"Hornet Sting","hex":"#ff0033","rgb":{"r":255,"g":0,"b":51},"luminance":76.46634959902296},{"name":"Hornet Yellow","hex":"#a67c08","rgb":{"r":166,"g":124,"b":8},"luminance":88.1048162361173},{"name":"Horror Snob","hex":"#d34d4d","rgb":{"r":211,"g":77,"b":77},"luminance":78.10393591874868},{"name":"Horse Liver","hex":"#543d37","rgb":{"r":84,"g":61,"b":55},"luminance":44.184472442250566},{"name":"Horseradish","hex":"#e6dfc4","rgb":{"r":230,"g":223,"b":196},"luminance":149.54477268363476},{"name":"Horseradish Cream","hex":"#eeeadd","rgb":{"r":238,"g":234,"b":221},"luminance":156.7354077545977},{"name":"Horses Neck","hex":"#6d562c","rgb":{"r":109,"g":86,"b":44},"luminance":60.29731222036352},{"name":"Horsetail","hex":"#3d5d42","rgb":{"r":61,"g":93,"b":66},"luminance":58.04695494166769},{"name":"Hortensia","hex":"#553b50","rgb":{"r":85,"g":59,"b":80},"luminance":43.91516041186688},{"name":"Hospital Green","hex":"#9be5aa","rgb":{"r":155,"g":229,"b":170},"luminance":143.5025656704437},{"name":"Hot Aquarelle Pink","hex":"#ffb3de","rgb":{"r":255,"g":179,"b":222},"luminance":132.26537800195484},{"name":"Hot Bolognese","hex":"#cc5511","rgb":{"r":204,"g":85,"b":17},"luminance":78.82752618850853},{"name":"Hot Cacao","hex":"#a5694f","rgb":{"r":165,"g":105,"b":79},"luminance":79.46020064157905},{"name":"Hot Calypso","hex":"#fa8d7c","rgb":{"r":250,"g":141,"b":124},"luminance":112.41781569217576},{"name":"Hot Chilli","hex":"#b7513a","rgb":{"r":183,"g":81,"b":58},"luminance":72.7900119659284},{"name":"Hot Chocolate","hex":"#683b39","rgb":{"r":104,"g":59,"b":57},"luminance":46.99606269678344},{"name":"Hot Cinnamon","hex":"#d1691c","rgb":{"r":209,"g":105,"b":28},"luminance":87.83044557555199},{"name":"Hot Coral","hex":"#f35b53","rgb":{"r":243,"g":91,"b":83},"luminance":90.67494131236037},{"name":"Hot Cuba","hex":"#bb0033","rgb":{"r":187,"g":0,"b":51},"luminance":56.214465798404596},{"name":"Hot Curry","hex":"#815b28","rgb":{"r":129,"g":91,"b":40},"luminance":66.04461772165843},{"name":"Hot Desert","hex":"#eae4da","rgb":{"r":234,"g":228,"b":218},"luminance":153.05207596109238},{"name":"Hot Embers","hex":"#f55931","rgb":{"r":245,"g":89,"b":49},"luminance":90.14892938909479},{"name":"Hot Flamingo","hex":"#b35966","rgb":{"r":179,"g":89,"b":102},"luminance":75.69041467715711},{"name":"Hot Ginger","hex":"#a36736","rgb":{"r":163,"g":103,"b":54},"luminance":77.90201554517058},{"name":"Hot Green","hex":"#25ff29","rgb":{"r":37,"g":255,"b":41},"luminance":150.1660263508361},{"name":"Hot Hazel","hex":"#dd6622","rgb":{"r":221,"g":102,"b":34},"luminance":89.25443122332918},{"name":"Hot Hibiscus","hex":"#bb2244","rgb":{"r":187,"g":34,"b":68},"luminance":59.87218750805752},{"name":"Hot Jazz","hex":"#bc3033","rgb":{"r":188,"g":48,"b":51},"luminance":63.14648458940528},{"name":"Hot Lava","hex":"#aa0033","rgb":{"r":170,"g":0,"b":51},"luminance":51.16142585972365},{"name":"Hot Lips","hex":"#c9312b","rgb":{"r":201,"g":49,"b":43},"luminance":66.80740658040843},{"name":"Hot Magenta","hex":"#ff00cc","rgb":{"r":255,"g":0,"b":204},"luminance":79.71286948165897},{"name":"Hot Mustard","hex":"#735c12","rgb":{"r":115,"g":92,"b":18},"luminance":64.05443735604895},{"name":"Hot Orange","hex":"#f4893d","rgb":{"r":244,"g":137,"b":61},"luminance":108.80327023118376},{"name":"Hot Pink","hex":"#ff028d","rgb":{"r":255,"g":2,"b":141},"luminance":77.92978748206617},{"name":"Hot Purple","hex":"#cb00f5","rgb":{"r":203,"g":0,"b":245},"luminance":66.81474918758582},{"name":"Hot Sand","hex":"#ccaa00","rgb":{"r":204,"g":170,"b":0},"luminance":116.95535950096514},{"name":"Hot Sauce","hex":"#ab4f41","rgb":{"r":171,"g":79,"b":65},"luminance":69.42289154162336},{"name":"Hot Spice","hex":"#cc2211","rgb":{"r":204,"g":34,"b":17},"luminance":64.20739539959551},{"name":"Hot Stone","hex":"#aba89e","rgb":{"r":171,"g":168,"b":158},"luminance":112.53320505966228},{"name":"Hot Sun","hex":"#f9b82b","rgb":{"r":249,"g":184,"b":43},"luminance":131.27341341261754},{"name":"Hot Toddy","hex":"#a7752c","rgb":{"r":167,"g":117,"b":44},"luminance":85.06038905389512},{"name":"Hothouse Orchid","hex":"#755468","rgb":{"r":117,"g":84,"b":104},"luminance":61.608878329344705},{"name":"Hotot Bunny","hex":"#f1f3f2","rgb":{"r":241,"g":243,"b":242},"luminance":162.17290805186911},{"name":"Hottest Of Pinks","hex":"#ff80ff","rgb":{"r":255,"g":128,"b":255},"luminance":110.92242073178893},{"name":"Hourglass","hex":"#e5e0d5","rgb":{"r":229,"g":224,"b":213},"luminance":150.22312574633773},{"name":"House Martin Eggs","hex":"#e2e0db","rgb":{"r":226,"g":224,"b":219},"luminance":149.92878568173626},{"name":"House Sparrow's Egg","hex":"#d6d9dd","rgb":{"r":214,"g":217,"b":221},"luminance":144.75619321120598},{"name":"House Stark Grey","hex":"#4d495b","rgb":{"r":77,"g":73,"b":91},"luminance":49.73818056583896},{"name":"How Handsome","hex":"#a0aeb8","rgb":{"r":160,"g":174,"b":184},"luminance":114.72065733772624},{"name":"How Now","hex":"#886150","rgb":{"r":136,"g":97,"b":80},"luminance":70.56050607103099},{"name":"Howdy Neighbor","hex":"#f9e4c8","rgb":{"r":249,"g":228,"b":200},"luminance":154.8381939219132},{"name":"Howdy Partner","hex":"#c6a698","rgb":{"r":198,"g":166,"b":152},"luminance":115.32597171496106},{"name":"Howling Coyote","hex":"#9c7f5a","rgb":{"r":156,"g":127,"b":90},"luminance":88.53521184816807},{"name":"Hú Lán Blue","hex":"#1dacd1","rgb":{"r":29,"g":172,"b":209},"luminance":104.09896163266951},{"name":"Huáng Dì Yellow","hex":"#f8ff73","rgb":{"r":248,"g":255,"b":115},"luminance":167.5589162921508},{"name":"Huáng Jīn Zhōu Gold","hex":"#fada6a","rgb":{"r":250,"g":218,"b":106},"luminance":148.69056026527036},{"name":"Huáng Sè Yellow","hex":"#f0f20c","rgb":{"r":240,"g":242,"b":12},"luminance":159.15623751521647},{"name":"Hubert's Truck Green","hex":"#559933","rgb":{"r":85,"g":153,"b":51},"luminance":93.51866413716567},{"name":"Huckleberry","hex":"#5b4349","rgb":{"r":91,"g":67,"b":73},"luminance":48.54230738232372},{"name":"Hudson Bee","hex":"#fdef02","rgb":{"r":253,"g":239,"b":2},"luminance":159.38835102352994},{"name":"Hugh's Hue","hex":"#9fa09f","rgb":{"r":159,"g":160,"b":159},"luminance":106.81603323939716},{"name":"Hugo","hex":"#e6cfcc","rgb":{"r":230,"g":207,"b":204},"luminance":141.5436028826453},{"name":"Hūi Sè Grey","hex":"#c1c6d3","rgb":{"r":193,"g":198,"b":211},"luminance":131.974148381416},{"name":"Hula Girl","hex":"#929264","rgb":{"r":146,"g":146,"b":100},"luminance":96.85279820428524},{"name":"Hulk Green","hex":"#008000","rgb":{"r":0,"g":128,"b":0},"luminance":75.136},{"name":"Hull Red","hex":"#4d140b","rgb":{"r":77,"g":20,"b":11},"luminance":25.873898913770223},{"name":"Humble Hippo","hex":"#aaaa99","rgb":{"r":170,"g":170,"b":153},"luminance":113.34000337038992},{"name":"Humboldt Redwoods","hex":"#1f6357","rgb":{"r":31,"g":99,"b":87},"luminance":59.67748196765678},{"name":"Humid Cave","hex":"#c9ccd2","rgb":{"r":201,"g":204,"b":210},"luminance":136.10509507362315},{"name":"Hummingbird","hex":"#ceefe4","rgb":{"r":206,"g":239,"b":228},"luminance":155.40762770533496},{"name":"Hummus","hex":"#eecc99","rgb":{"r":238,"g":204,"b":153},"luminance":140.38460425559492},{"name":"Humpback Whale","hex":"#473b3b","rgb":{"r":71,"g":59,"b":59},"luminance":41.1746791851497},{"name":"Humus","hex":"#b7a793","rgb":{"r":183,"g":167,"b":147},"luminance":113.50975946587147},{"name":"Hunky Hummingbird","hex":"#bb11ff","rgb":{"r":187,"g":17,"b":255},"luminance":63.803674737431855},{"name":"Hunter Green","hex":"#0b4008","rgb":{"r":11,"g":64,"b":8},"luminance":37.72272377493439},{"name":"Hunter's Orange","hex":"#db472c","rgb":{"r":219,"g":71,"b":44},"luminance":77.78106418660006},{"name":"Huntington Garden","hex":"#96a782","rgb":{"r":150,"g":167,"b":130},"luminance":108.81562268810484},{"name":"Huntington Woods","hex":"#46554c","rgb":{"r":70,"g":85,"b":76},"luminance":54.79635773479839},{"name":"Hurricane","hex":"#8b7e77","rgb":{"r":139,"g":126,"b":119},"luminance":85.91699785839819},{"name":"Hurricane Haze","hex":"#bdbbad","rgb":{"r":189,"g":187,"b":173},"luminance":125.02673220555674},{"name":"Hurricane Mist","hex":"#ebeee8","rgb":{"r":235,"g":238,"b":232},"luminance":158.6014923164344},{"name":"Hush","hex":"#c4bdba","rgb":{"r":196,"g":189,"b":186},"luminance":127.24931308655461},{"name":"Hush Grey","hex":"#e1ded8","rgb":{"r":225,"g":222,"b":216},"luminance":148.70778593268074},{"name":"Hush Puppy","hex":"#e4b095","rgb":{"r":228,"g":176,"b":149},"luminance":124.93724474311092},{"name":"Hush-A-Bye","hex":"#5397b7","rgb":{"r":83,"g":151,"b":183},"luminance":94.38021138988829},{"name":"Hushed Green","hex":"#d8e9e5","rgb":{"r":216,"g":233,"b":229},"luminance":153.48916161410224},{"name":"Hushed Violet","hex":"#d1c0bf","rgb":{"r":209,"g":192,"b":191},"luminance":130.6959210266334},{"name":"Husk","hex":"#b2994b","rgb":{"r":178,"g":153,"b":75},"luminance":104.74588061112475},{"name":"Husky","hex":"#e0ebfa","rgb":{"r":224,"g":235,"b":250},"luminance":155.97069468653396},{"name":"Hutchins Plaza","hex":"#ae957c","rgb":{"r":174,"g":149,"b":124},"luminance":102.74389296206368},{"name":"Hyacinth","hex":"#936ca7","rgb":{"r":147,"g":108,"b":167},"luminance":79.456682972548},{"name":"Hyacinth Dream","hex":"#807388","rgb":{"r":128,"g":115,"b":136},"luminance":79.13308426315758},{"name":"Hyacinth Red","hex":"#a75536","rgb":{"r":167,"g":85,"b":54},"luminance":70.85698166024291},{"name":"Hyacinth Violet","hex":"#8d4687","rgb":{"r":141,"g":70,"b":135},"luminance":60.84916992860297},{"name":"Hydra Blue","hex":"#006995","rgb":{"r":0,"g":105,"b":149},"luminance":63.93275702642582},{"name":"Hydra Turquoise","hex":"#007a73","rgb":{"r":0,"g":122,"b":115},"luminance":72.80410081856651},{"name":"Hydrangea","hex":"#849bcc","rgb":{"r":132,"g":155,"b":204},"luminance":101.86675014449023},{"name":"Hydrangea Floret","hex":"#e6eae0","rgb":{"r":230,"g":234,"b":224},"luminance":155.71968520389453},{"name":"Hydrangea Pink","hex":"#e7b6c8","rgb":{"r":231,"g":182,"b":200},"luminance":129.24345367174308},{"name":"Hydrangea Purple","hex":"#caa0ff","rgb":{"r":202,"g":160,"b":255},"luminance":115.38608973355495},{"name":"Hydro","hex":"#426972","rgb":{"r":66,"g":105,"b":114},"luminance":66.00909026035733},{"name":"Hydroport","hex":"#5e9ca1","rgb":{"r":94,"g":156,"b":161},"luminance":97.5307527706005},{"name":"Hygge Green","hex":"#e0e1d8","rgb":{"r":224,"g":225,"b":216},"luminance":150.11972414376467},{"name":"Hyper Green","hex":"#55ff00","rgb":{"r":85,"g":255,"b":0},"luminance":151.8272750529364},{"name":"Hyper Light Drifter","hex":"#eddbda","rgb":{"r":237,"g":219,"b":218},"luminance":148.87934874253045},{"name":"Hypnotic Sea","hex":"#00787f","rgb":{"r":0,"g":120,"b":127},"luminance":71.91248906831136},{"name":"Hypnotism","hex":"#32584c","rgb":{"r":50,"g":88,"b":76},"luminance":54.469346719049234},{"name":"Hypothalamus Grey","hex":"#415d66","rgb":{"r":65,"g":93,"b":102},"luminance":59.10251170635643},{"name":"Hyssop","hex":"#6d4976","rgb":{"r":109,"g":73,"b":118},"luminance":55.491781247316254},{"name":"I Miss You","hex":"#dddbc5","rgb":{"r":221,"g":219,"b":197},"luminance":146.27600559900452},{"name":"I R Dark Green","hex":"#404034","rgb":{"r":64,"g":64,"b":52},"luminance":42.57560691287912},{"name":"Ibex Brown","hex":"#482400","rgb":{"r":72,"g":36,"b":0},"luminance":30.166474901784596},{"name":"Ibis","hex":"#f4b3c2","rgb":{"r":244,"g":179,"b":194},"luminance":129.81537166684075},{"name":"Ibis Mouse","hex":"#e4d2d8","rgb":{"r":228,"g":210,"b":216},"luminance":143.00089461258625},{"name":"Ibis Rose","hex":"#ca628f","rgb":{"r":202,"g":98,"b":143},"luminance":84.98773019677606},{"name":"Ibis Wing","hex":"#f58f84","rgb":{"r":245,"g":143,"b":132},"luminance":112.42254582600413},{"name":"Ibiza Blue","hex":"#007cb7","rgb":{"r":0,"g":124,"b":183},"luminance":75.71866340605861},{"name":"Ice","hex":"#d6fffa","rgb":{"r":214,"g":255,"b":250},"luminance":165.26359980649096},{"name":"Ice Age","hex":"#c6e4e9","rgb":{"r":198,"g":228,"b":233},"luminance":148.7363154848203},{"name":"Ice Blue","hex":"#739bd0","rgb":{"r":115,"g":155,"b":208},"luminance":100.114221736974},{"name":"Ice Bomb","hex":"#cce2dd","rgb":{"r":204,"g":226,"b":221},"luminance":148.170361057804},{"name":"Ice Breaker","hex":"#d4e7e7","rgb":{"r":212,"g":231,"b":231},"luminance":151.9804741044059},{"name":"Ice Cap Green","hex":"#b9e7dd","rgb":{"r":185,"g":231,"b":221},"luminance":148.59688176405317},{"name":"Ice Castle","hex":"#d5edfb","rgb":{"r":213,"g":237,"b":251},"luminance":155.65632375846477},{"name":"Ice Cave","hex":"#a0beda","rgb":{"r":160,"g":190,"b":218},"luminance":123.87585884263325},{"name":"Ice Climber","hex":"#25e2cd","rgb":{"r":37,"g":226,"b":205},"luminance":135.1582521084081},{"name":"Ice Cold","hex":"#d2eaf1","rgb":{"r":210,"g":234,"b":241},"luminance":153.50773576598672},{"name":"Ice Cold Stare","hex":"#b1d1fc","rgb":{"r":177,"g":209,"b":252},"luminance":136.66477381534716},{"name":"Ice Cream Cone","hex":"#e3d0bf","rgb":{"r":227,"g":208,"b":191},"luminance":141.37992934288798},{"name":"Ice Cube","hex":"#afe3d6","rgb":{"r":175,"g":227,"b":214},"luminance":145.21834058410116},{"name":"Ice Dagger","hex":"#cee5df","rgb":{"r":206,"g":229,"b":223},"luminance":150.03213605424673},{"name":"Ice Effect","hex":"#cbeaee","rgb":{"r":203,"g":234,"b":238},"luminance":152.6023964326904},{"name":"Ice Fishing","hex":"#dcecf5","rgb":{"r":220,"g":236,"b":245},"luminance":155.87882577181546},{"name":"Ice Floe","hex":"#d8e7e1","rgb":{"r":216,"g":231,"b":225},"luminance":152.36653820639228},{"name":"Ice Flow","hex":"#c6d2d2","rgb":{"r":198,"g":210,"b":210},"luminance":138.82900743000363},{"name":"Ice Glow","hex":"#ffffe9","rgb":{"r":255,"g":255,"b":233},"luminance":170.07186449851133},{"name":"Ice Green","hex":"#87d8c3","rgb":{"r":135,"g":216,"b":195},"luminance":134.90632820220108},{"name":"Ice Grey","hex":"#cac7c4","rgb":{"r":202,"g":199,"b":196},"luminance":133.3883417282035},{"name":"Ice Ice Baby","hex":"#00ffdd","rgb":{"r":0,"g":255,"b":221},"luminance":151.79043731737517},{"name":"Ice Lemon","hex":"#fffbc1","rgb":{"r":255,"g":251,"b":193},"luminance":167.3486767142184},{"name":"Ice Mist","hex":"#b6dbbf","rgb":{"r":182,"g":219,"b":191},"luminance":141.28446343812897},{"name":"Ice Pack","hex":"#a5dbe3","rgb":{"r":165,"g":219,"b":227},"luminance":140.1052708430343},{"name":"Ice Palace","hex":"#e2e4d7","rgb":{"r":226,"g":228,"b":215},"luminance":151.91793992810722},{"name":"Ice Rink","hex":"#bbddee","rgb":{"r":187,"g":221,"b":238},"luminance":143.84541536663585},{"name":"Ice Yellow","hex":"#fefecd","rgb":{"r":254,"g":254,"b":205},"luminance":168.95018620883494},{"name":"Ice-Cold White","hex":"#dff0e2","rgb":{"r":223,"g":240,"b":226},"luminance":157.97715159161464},{"name":"Iceberg","hex":"#dae4ee","rgb":{"r":218,"g":228,"b":238},"luminance":151.31726089247053},{"name":"Iceberg Green","hex":"#8c9c92","rgb":{"r":140,"g":156,"b":146},"luminance":102.05250374194647},{"name":"Iced Aniseed","hex":"#cbd3c3","rgb":{"r":203,"g":211,"b":195},"luminance":139.70989642111974},{"name":"Iced Aqua","hex":"#abd3db","rgb":{"r":171,"g":211,"b":219},"luminance":136.30125548211214},{"name":"Iced Avocado","hex":"#c8e4b9","rgb":{"r":200,"g":228,"b":185},"luminance":148.0976130665177},{"name":"Iced Cappuccino","hex":"#9c8866","rgb":{"r":156,"g":136,"b":102},"luminance":93.18809657890861},{"name":"Iced Celery","hex":"#e5e9b7","rgb":{"r":229,"g":233,"b":183},"luminance":154.36906207527463},{"name":"Iced Coffee","hex":"#b18f6a","rgb":{"r":177,"g":143,"b":106},"luminance":99.96478612991676},{"name":"Iced Lavender","hex":"#c2c7db","rgb":{"r":194,"g":199,"b":219},"luminance":132.7903391101928},{"name":"Iced Tulip","hex":"#afa9af","rgb":{"r":175,"g":169,"b":175},"luminance":113.91726530249925},{"name":"Iced Vovo","hex":"#e1a4b2","rgb":{"r":225,"g":164,"b":178},"luminance":119.18564809992854},{"name":"Iced Watermelon","hex":"#d1afb7","rgb":{"r":209,"g":175,"b":183},"luminance":122.03595269427775},{"name":"Icedrop","hex":"#d3e2ee","rgb":{"r":211,"g":226,"b":238},"luminance":149.38398036268816},{"name":"Iceland Poppy","hex":"#f4963a","rgb":{"r":244,"g":150,"b":58},"luminance":114.53863531577456},{"name":"Icelandic Blue","hex":"#a9adc2","rgb":{"r":169,"g":173,"b":194},"luminance":115.56428954482435},{"name":"Icelandic Winds","hex":"#d7deeb","rgb":{"r":215,"g":222,"b":235},"luminance":147.75656980655717},{"name":"Icelandic Winter","hex":"#d9e7e3","rgb":{"r":217,"g":231,"b":227},"luminance":152.53203264232727},{"name":"Icepick","hex":"#dadcd0","rgb":{"r":218,"g":220,"b":208},"luminance":146.58817028669128},{"name":"Icewind Dale","hex":"#e8ecee","rgb":{"r":232,"g":236,"b":238},"luminance":157.28693484202682},{"name":"Icicle","hex":"#dde7df","rgb":{"r":221,"g":231,"b":223},"luminance":152.96816248487787},{"name":"Icing Flower","hex":"#d5b7cb","rgb":{"r":213,"g":183,"b":203},"luminance":127.00731228555307},{"name":"Icky Green","hex":"#8fae22","rgb":{"r":143,"g":174,"b":34},"luminance":110.79420322832779},{"name":"Icterine","hex":"#fcf75e","rgb":{"r":252,"g":247,"b":94},"luminance":163.74969887300557},{"name":"Icy Bay","hex":"#e0e5e2","rgb":{"r":224,"g":229,"b":226},"luminance":152.37818479362457},{"name":"Icy Lavender","hex":"#e2e2ed","rgb":{"r":226,"g":226,"b":237},"luminance":151.31233936464005},{"name":"Icy Lilac","hex":"#e6e9f9","rgb":{"r":230,"g":233,"b":249},"luminance":155.69644933973285},{"name":"Icy Morn","hex":"#b0d3d1","rgb":{"r":176,"g":211,"b":209},"luminance":136.66572394349652},{"name":"Icy Teal","hex":"#d6dfe8","rgb":{"r":214,"g":223,"b":232},"luminance":148.08368141358451},{"name":"Icy Water","hex":"#bce2e8","rgb":{"r":188,"g":226,"b":232},"luminance":146.48717313130186},{"name":"Icy Waterfall","hex":"#c0d2d0","rgb":{"r":192,"g":210,"b":208},"luminance":138.03416355381012},{"name":"Icy Wind","hex":"#d3f1ee","rgb":{"r":211,"g":241,"b":238},"luminance":157.2554591548414},{"name":"Identity","hex":"#7890ac","rgb":{"r":120,"g":144,"b":172},"luminance":93.8979810645575},{"name":"Idol","hex":"#645a8b","rgb":{"r":100,"g":90,"b":139},"luminance":62.738462014939444},{"name":"Idyllic Isle","hex":"#94c8d2","rgb":{"r":148,"g":200,"b":210},"luminance":127.72675171631039},{"name":"Igloo","hex":"#fdfcfa","rgb":{"r":253,"g":252,"b":250},"luminance":168.57113746131037},{"name":"Iguana","hex":"#818455","rgb":{"r":129,"g":132,"b":85},"luminance":87.0941352617959},{"name":"Iguana Green","hex":"#71bc77","rgb":{"r":113,"g":188,"b":119},"luminance":116.20690367185591},{"name":"Ikkonzome Pink","hex":"#f08f90","rgb":{"r":240,"g":143,"b":144},"luminance":111.64709641096806},{"name":"Illicit Darkness","hex":"#00022e","rgb":{"r":0,"g":2,"b":46},"luminance":5.373807960841176},{"name":"Illicit Green","hex":"#56fca2","rgb":{"r":86,"g":252,"b":162},"luminance":151.27387942404332},{"name":"Illicit Pink","hex":"#ff5ccd","rgb":{"r":255,"g":92,"b":205},"luminance":96.31141646243191},{"name":"Illicit Purple","hex":"#bf77f6","rgb":{"r":191,"g":119,"b":246},"luminance":94.48463063377027},{"name":"Illuminating Emerald","hex":"#319177","rgb":{"r":49,"g":145,"b":119},"luminance":87.42569062924238},{"name":"Illusion","hex":"#ef95ae","rgb":{"r":239,"g":149,"b":174},"luminance":114.67309094116196},{"name":"Illusion Blue","hex":"#c9d3dc","rgb":{"r":201,"g":211,"b":220},"luminance":139.93374378612185},{"name":"Illustrious Indigo","hex":"#5533bb","rgb":{"r":85,"g":51,"b":187},"luminance":44.683367352964794},{"name":"Ilvaite Black","hex":"#330011","rgb":{"r":51,"g":0,"b":17},"luminance":15.371657197582827},{"name":"Image Tone","hex":"#bec1cf","rgb":{"r":190,"g":193,"b":207},"luminance":128.91505879841966},{"name":"Imagery","hex":"#7a6e70","rgb":{"r":122,"g":110,"b":112},"luminance":75.25258273308631},{"name":"Imaginary Mauve","hex":"#89687d","rgb":{"r":137,"g":104,"b":125},"luminance":74.88583426122726},{"name":"Imagine","hex":"#af9468","rgb":{"r":175,"g":148,"b":104},"luminance":102.10734418737958},{"name":"Imam Ali Gold","hex":"#fae199","rgb":{"r":250,"g":225,"b":153},"luminance":152.75991453584936},{"name":"Imayou Pink","hex":"#d0576b","rgb":{"r":208,"g":87,"b":107},"luminance":81.39213001881693},{"name":"Immaculate Iguana","hex":"#aacc00","rgb":{"r":170,"g":204,"b":0},"luminance":130.08947845233294},{"name":"Immersed","hex":"#204f54","rgb":{"r":32,"g":79,"b":84},"luminance":48.30840019085708},{"name":"Immortal","hex":"#c0a9cc","rgb":{"r":192,"g":169,"b":204},"luminance":116.95193546495928},{"name":"Immortal Indigo","hex":"#d8b7cf","rgb":{"r":216,"g":183,"b":207},"luminance":127.54305116704712},{"name":"Impala","hex":"#f8ce97","rgb":{"r":248,"g":206,"b":151},"luminance":142.88796654722188},{"name":"Impatiens Pink","hex":"#ffc4bc","rgb":{"r":255,"g":196,"b":188},"luminance":139.67674592787446},{"name":"Imperial","hex":"#602f6b","rgb":{"r":96,"g":47,"b":107},"luminance":41.639689492117974},{"name":"Imperial Blue","hex":"#002395","rgb":{"r":0,"g":35,"b":149},"luminance":26.657479644557544},{"name":"Imperial Dynasty","hex":"#33746b","rgb":{"r":51,"g":116,"b":107},"luminance":70.83673954241542},{"name":"Imperial Ivory","hex":"#f1e8d2","rgb":{"r":241,"g":232,"b":210},"luminance":155.92211176417538},{"name":"Imperial Palace","hex":"#604e7a","rgb":{"r":96,"g":78,"b":122},"luminance":55.80062612551941},{"name":"Imperial Primer","hex":"#21303e","rgb":{"r":33,"g":48,"b":62},"luminance":30.679004041852465},{"name":"Imperial Purple","hex":"#542c5d","rgb":{"r":84,"g":44,"b":93},"luminance":37.55398040154998},{"name":"Imperial Red","hex":"#ec2938","rgb":{"r":236,"g":41,"b":56},"luminance":74.82816342126806},{"name":"Impression of Obscurity","hex":"#1a2578","rgb":{"r":26,"g":37,"b":120},"luminance":26.819627831123977},{"name":"Impressionist Blue","hex":"#a7cac9","rgb":{"r":167,"g":202,"b":201},"luminance":130.68339359306523},{"name":"Improbable","hex":"#6e7376","rgb":{"r":110,"g":115,"b":118},"luminance":76.28652193539826},{"name":"Impromptu","hex":"#705f63","rgb":{"r":112,"g":95,"b":99},"luminance":66.01935447276048},{"name":"Impulse","hex":"#005b87","rgb":{"r":0,"g":91,"b":135},"luminance":55.589819112855544},{"name":"Impure White","hex":"#f5e7e3","rgb":{"r":245,"g":231,"b":227},"luminance":156.27703707838845},{"name":"Imrik Blue","hex":"#67aed0","rgb":{"r":103,"g":174,"b":208},"luminance":109.28350834869823},{"name":"In A Pickle","hex":"#978c59","rgb":{"r":151,"g":140,"b":89},"luminance":94.31291490034648},{"name":"In Good Taste","hex":"#b6d4a0","rgb":{"r":182,"g":212,"b":160},"luminance":137.0413275621628},{"name":"In the Buff","hex":"#d6cbbf","rgb":{"r":214,"g":203,"b":191},"luminance":136.99510645639864},{"name":"In the Pink","hex":"#f4c4d0","rgb":{"r":244,"g":196,"b":208},"luminance":138.28159524680066},{"name":"In the Red","hex":"#ff2233","rgb":{"r":255,"g":34,"b":51},"luminance":79.02799747557823},{"name":"In the Shadows","hex":"#cbc4c0","rgb":{"r":203,"g":196,"b":192},"luminance":131.90971555196379},{"name":"In The Slip","hex":"#e2c3cf","rgb":{"r":226,"g":195,"b":207},"luminance":135.0012863086867},{"name":"In the Tropics","hex":"#a3bc3a","rgb":{"r":163,"g":188,"b":58},"luminance":120.81995054211865},{"name":"Inca Gold","hex":"#bb7a2c","rgb":{"r":187,"g":122,"b":44},"luminance":90.99444390181192},{"name":"Inca Temple","hex":"#8c7b6c","rgb":{"r":140,"g":123,"b":108},"luminance":84.36130241408082},{"name":"Inca Yellow","hex":"#ffd301","rgb":{"r":255,"g":211,"b":1},"luminance":145.44369862596318},{"name":"Incandescence","hex":"#ffbb22","rgb":{"r":255,"g":187,"b":34},"luminance":133.70698097706043},{"name":"Incarnadine","hex":"#aa0022","rgb":{"r":170,"g":0,"b":34},"luminance":50.977566399348646},{"name":"Incense","hex":"#af9a7e","rgb":{"r":175,"g":154,"b":126},"luminance":105.4325781008887},{"name":"Inchworm","hex":"#b2ec5d","rgb":{"r":178,"g":236,"b":93},"luminance":148.7820510411118},{"name":"Incision","hex":"#ff0022","rgb":{"r":255,"g":0,"b":34},"luminance":76.34345683161065},{"name":"Incremental Blue","hex":"#123456","rgb":{"r":18,"g":52,"b":86},"luminance":32.50844376465905},{"name":"Incubi Darkness","hex":"#0b474a","rgb":{"r":11,"g":71,"b":74},"luminance":42.64921975839652},{"name":"Incubus","hex":"#772222","rgb":{"r":119,"g":34,"b":34},"luminance":40.979906063825965},{"name":"Independence","hex":"#4c516d","rgb":{"r":76,"g":81,"b":109},"luminance":54.14335472613421},{"name":"India Green","hex":"#138808","rgb":{"r":19,"g":136,"b":8},"luminance":80.03907626278554},{"name":"India Ink","hex":"#3c3d4c","rgb":{"r":60,"g":61,"b":76},"luminance":40.97620950014776},{"name":"Indian Brass","hex":"#a5823d","rgb":{"r":165,"g":130,"b":61},"luminance":91.13460616582485},{"name":"Indian Clay","hex":"#f2d0c0","rgb":{"r":242,"g":208,"b":192},"luminance":143.60431025564657},{"name":"Indian Ink","hex":"#3c3f4a","rgb":{"r":60,"g":63,"b":74},"luminance":41.95955263107555},{"name":"Indian Khaki","hex":"#d3b09c","rgb":{"r":211,"g":176,"b":156},"luminance":122.35138708245199},{"name":"Indian Maize","hex":"#e4c14d","rgb":{"r":228,"g":193,"b":77},"luminance":132.51160533704208},{"name":"Indian Mesa","hex":"#d5a193","rgb":{"r":213,"g":161,"b":147},"luminance":115.1887042291908},{"name":"Indian Muslin","hex":"#eae3d8","rgb":{"r":234,"g":227,"b":216},"luminance":152.50206075001086},{"name":"Indian Pale Ale","hex":"#d5bc26","rgb":{"r":213,"g":188,"b":38},"luminance":127.48822270704066},{"name":"Indian Princess","hex":"#da846d","rgb":{"r":218,"g":132,"b":109},"luminance":102.01406205028795},{"name":"Indian Red","hex":"#850e04","rgb":{"r":133,"g":14,"b":4},"luminance":40.60982330668283},{"name":"Indian Reed","hex":"#9f7060","rgb":{"r":159,"g":112,"b":96},"luminance":81.86691244330642},{"name":"Indian Silk","hex":"#8a5773","rgb":{"r":138,"g":87,"b":115},"luminance":66.95123228888323},{"name":"Indian Summer","hex":"#a85143","rgb":{"r":168,"g":81,"b":67},"luminance":69.58670905424397},{"name":"Indian Teal","hex":"#3c586b","rgb":{"r":60,"g":88,"b":107},"luminance":56.02657530136926},{"name":"Indian Yellow","hex":"#e3a857","rgb":{"r":227,"g":168,"b":87},"luminance":120.12587693332357},{"name":"Indiana Clay","hex":"#e88a5b","rgb":{"r":232,"g":138,"b":91},"luminance":107.15181443167447},{"name":"Indica","hex":"#588c3a","rgb":{"r":88,"g":140,"b":58},"luminance":86.54243056443468},{"name":"Indifferent","hex":"#9892b8","rgb":{"r":152,"g":146,"b":184},"luminance":99.24890973708477},{"name":"Indigo","hex":"#4b0082","rgb":{"r":75,"g":0,"b":130},"luminance":26.87960239661294},{"name":"Indigo Blue","hex":"#3a18b1","rgb":{"r":58,"g":24,"b":177},"luminance":30.105952766853267},{"name":"Indigo Bunting","hex":"#006ca9","rgb":{"r":0,"g":108,"b":169},"luminance":66.25882259744735},{"name":"Indigo Carmine","hex":"#006ec7","rgb":{"r":0,"g":110,"b":199},"luminance":68.43931250385263},{"name":"Indigo Child","hex":"#a09fcc","rgb":{"r":160,"g":159,"b":204},"luminance":107.42697996779022},{"name":"Indigo Dye","hex":"#00416c","rgb":{"r":0,"g":65,"b":108},"luminance":40.09226071201274},{"name":"Indigo Hamlet","hex":"#1f4788","rgb":{"r":31,"g":71,"b":136},"luminance":45.42312963678307},{"name":"Indigo Ink","hex":"#474a4d","rgb":{"r":71,"g":74,"b":77},"luminance":49.13841235734016},{"name":"Indigo Ink Brown","hex":"#393432","rgb":{"r":57,"g":52,"b":50},"luminance":35.421299030385654},{"name":"Indigo Iron","hex":"#393f4c","rgb":{"r":57,"g":63,"b":76},"luminance":41.63079516415702},{"name":"Indigo Light","hex":"#5d76cb","rgb":{"r":93,"g":118,"b":203},"luminance":78.14448265232804},{"name":"Indigo Mouse","hex":"#6c848d","rgb":{"r":108,"g":132,"b":141},"luminance":85.46880715208326},{"name":"Indigo Night","hex":"#324680","rgb":{"r":50,"g":70,"b":128},"luminance":46.095738024246884},{"name":"Indigo Purple","hex":"#660099","rgb":{"r":102,"g":0,"b":153},"luminance":35.13333698924712},{"name":"Indigo Sloth","hex":"#1f0954","rgb":{"r":31,"g":9,"b":84},"luminance":14.336116140712589},{"name":"Indigo White","hex":"#ebf6f7","rgb":{"r":235,"g":246,"b":247},"luminance":163.03981352111512},{"name":"Indochine","hex":"#9c5b34","rgb":{"r":156,"g":91,"b":52},"luminance":71.16305086911325},{"name":"Indocile Indochine","hex":"#b96b00","rgb":{"r":185,"g":107,"b":0},"luminance":83.69420353883535},{"name":"Indolence","hex":"#a29dad","rgb":{"r":162,"g":157,"b":173},"luminance":105.96451485756917},{"name":"Indonesian Jungle","hex":"#008c69","rgb":{"r":0,"g":140,"b":105},"luminance":83.04717514762316},{"name":"Indonesian Rattan","hex":"#d1b272","rgb":{"r":209,"g":178,"b":114},"luminance":122.43914934774742},{"name":"Indulgence","hex":"#533d47","rgb":{"r":83,"g":61,"b":71},"luminance":44.31182205687326},{"name":"Industrial Age","hex":"#aeadad","rgb":{"r":174,"g":173,"b":173},"luminance":115.79407394594939},{"name":"Industrial Revolution","hex":"#737373","rgb":{"r":115,"g":115,"b":115},"luminance":76.88384323120171},{"name":"Ineffable Forest","hex":"#4f9153","rgb":{"r":79,"g":145,"b":83},"luminance":88.83717864723079},{"name":"Ineffable Green","hex":"#63f7b4","rgb":{"r":99,"g":247,"b":180},"luminance":149.39578214260268},{"name":"Ineffable Ice Cap","hex":"#caede4","rgb":{"r":202,"g":237,"b":228},"luminance":153.87526971219253},{"name":"Ineffable Linen","hex":"#e6e1c7","rgb":{"r":230,"g":225,"b":199},"luminance":150.62460994472318},{"name":"Ineffable Magenta","hex":"#cc99cc","rgb":{"r":204,"g":153,"b":204},"luminance":111.02868671203852},{"name":"Infatuation","hex":"#f0d5ea","rgb":{"r":240,"g":213,"b":234},"luminance":146.60783586493594},{"name":"Infinitesimal Blue","hex":"#bddde1","rgb":{"r":189,"g":221,"b":225},"luminance":143.80719783793856},{"name":"Infinitesimal Green","hex":"#d7e4cc","rgb":{"r":215,"g":228,"b":204},"luminance":150.28465542762507},{"name":"Infinity","hex":"#6e7e99","rgb":{"r":110,"g":126,"b":153},"luminance":82.8030972126043},{"name":"Infra Red","hex":"#fe486c","rgb":{"r":254,"g":72,"b":108},"luminance":87.78169487996914},{"name":"Infra-White","hex":"#ffccee","rgb":{"r":255,"g":204,"b":238},"luminance":144.5303738077225},{"name":"Infrared Burn","hex":"#dd3333","rgb":{"r":221,"g":51,"b":51},"luminance":72.77678754932784},{"name":"Infrared Flush","hex":"#cc3344","rgb":{"r":204,"g":51,"b":68},"luminance":68.38734889583014},{"name":"Infrared Gloze","hex":"#cc3355","rgb":{"r":204,"g":51,"b":85},"luminance":68.63404464986745},{"name":"Infrared Tang","hex":"#dd2244","rgb":{"r":221,"g":34,"b":68},"luminance":69.46113668088077},{"name":"Infusion","hex":"#c8d0ca","rgb":{"r":200,"g":208,"b":202},"luminance":137.8903985054797},{"name":"Inglenook Olive","hex":"#aaa380","rgb":{"r":170,"g":163,"b":128},"luminance":109.32277496020671},{"name":"Ink Black","hex":"#252024","rgb":{"r":37,"g":32,"b":36},"luminance":22.182683358872524},{"name":"Ink Blotch","hex":"#00608b","rgb":{"r":0,"g":96,"b":139},"luminance":58.537540262638295},{"name":"Ink Blue","hex":"#0b5369","rgb":{"r":11,"g":83,"b":105},"luminance":50.27757215697671},{"name":"Inked Silk","hex":"#d9dce4","rgb":{"r":217,"g":220,"b":228},"luminance":146.8418446935341},{"name":"Inkjet","hex":"#44556b","rgb":{"r":68,"g":85,"b":107},"luminance":55.242125710367084},{"name":"Inky Storm","hex":"#535266","rgb":{"r":83,"g":82,"b":102},"luminance":55.389311505018725},{"name":"Inner Cervela","hex":"#bbaa7e","rgb":{"r":187,"g":170,"b":126},"luminance":115.28500407685293},{"name":"Inner Journey","hex":"#6d69a1","rgb":{"r":109,"g":105,"b":161},"luminance":72.09657288664975},{"name":"Inner Space","hex":"#285b5f","rgb":{"r":40,"g":91,"b":95},"luminance":55.80059488034155},{"name":"Inner Touch","hex":"#bbafba","rgb":{"r":187,"g":175,"b":186},"luminance":118.86252062782448},{"name":"Inness Sage","hex":"#959272","rgb":{"r":149,"g":146,"b":114},"luminance":97.46035307241607},{"name":"Innuendo","hex":"#a4b0c4","rgb":{"r":164,"g":176,"b":196},"luminance":116.5210409153643},{"name":"Inoffensive Blue","hex":"#114477","rgb":{"r":17,"g":68,"b":119},"luminance":42.463635042233484},{"name":"Inside","hex":"#221122","rgb":{"r":34,"g":17,"b":34},"luminance":14.763176250387314},{"name":"Inside Passage","hex":"#e0cfb5","rgb":{"r":224,"g":207,"b":181},"luminance":140.27110754891754},{"name":"Insignia Blue","hex":"#2f3e55","rgb":{"r":47,"g":62,"b":85},"luminance":40.19833510233975},{"name":"Insignia White","hex":"#ecf3f9","rgb":{"r":236,"g":243,"b":249},"luminance":161.65239859958774},{"name":"Inspiration Peak","hex":"#4fa183","rgb":{"r":79,"g":161,"b":131},"luminance":98.55226555488208},{"name":"Instant","hex":"#d9cec7","rgb":{"r":217,"g":206,"b":199},"luminance":139.09201403747088},{"name":"Instant Classic","hex":"#e3dac6","rgb":{"r":227,"g":218,"b":198},"luminance":146.59991974417994},{"name":"Instant Orange","hex":"#ff8d28","rgb":{"r":255,"g":141,"b":40},"luminance":112.62535200388942},{"name":"Instant Relief","hex":"#ede7d2","rgb":{"r":237,"g":231,"b":210},"luminance":154.85875751148203},{"name":"Instigate","hex":"#ada7c8","rgb":{"r":173,"g":167,"b":200},"luminance":113.16009619119276},{"name":"Integra","hex":"#405e95","rgb":{"r":64,"g":94,"b":149},"luminance":60.82205501296384},{"name":"Integrity","hex":"#233e57","rgb":{"r":35,"g":62,"b":87},"luminance":39.14596000866501},{"name":"Intellectual","hex":"#3f414c","rgb":{"r":63,"g":65,"b":76},"luminance":43.42466453526153},{"name":"Intense Brown","hex":"#7f5400","rgb":{"r":127,"g":84,"b":0},"luminance":62.23526004605428},{"name":"Intense Passion","hex":"#df3163","rgb":{"r":223,"g":49,"b":99},"luminance":73.48813709708526},{"name":"Intense Purple","hex":"#4d4a6f","rgb":{"r":77,"g":74,"b":111},"luminance":50.76457513857473},{"name":"Inter-Galactic Blue","hex":"#afe0ef","rgb":{"r":175,"g":224,"b":239},"luminance":144.11573226056896},{"name":"Interdimensional Blue","hex":"#360ccc","rgb":{"r":54,"g":12,"b":204},"luminance":29.17452292669068},{"name":"Interdimensional Portal","hex":"#d6e6e6","rgb":{"r":214,"g":230,"b":230},"luminance":151.68848570672725},{"name":"Intergalactic","hex":"#4d516c","rgb":{"r":77,"g":81,"b":108},"luminance":54.24353493274567},{"name":"Intergalactic Cowboy","hex":"#222266","rgb":{"r":34,"g":34,"b":102},"luminance":25.236475665195407},{"name":"Intergalactic Ray","hex":"#573935","rgb":{"r":87,"g":57,"b":53},"luminance":42.80988920798558},{"name":"Interior Green","hex":"#536437","rgb":{"r":83,"g":100,"b":55},"luminance":64.03816353550435},{"name":"Intermediate Blue","hex":"#56626e","rgb":{"r":86,"g":98,"b":110},"luminance":64.24719505161295},{"name":"Intermediate Green","hex":"#137730","rgb":{"r":19,"g":119,"b":48},"luminance":70.29692848197566},{"name":"International","hex":"#3762a5","rgb":{"r":55,"g":98,"b":165},"luminance":62.717579680660506},{"name":"International Blue","hex":"#002fa7","rgb":{"r":0,"g":47,"b":167},"luminance":33.52011880945531},{"name":"International Klein Blue","hex":"#002fa6","rgb":{"r":0,"g":47,"b":166},"luminance":33.45550323937752},{"name":"International Orange","hex":"#ba160c","rgb":{"r":186,"g":22,"b":12},"luminance":57.1100675538035},{"name":"Interstellar Blue","hex":"#001155","rgb":{"r":0,"g":17,"b":85},"luminance":13.909584501342948},{"name":"Intimate Journal","hex":"#ccbb99","rgb":{"r":204,"g":187,"b":153},"luminance":126.78315637733586},{"name":"Intrigue","hex":"#635951","rgb":{"r":99,"g":89,"b":81},"luminance":60.75209466347641},{"name":"Introspective","hex":"#6d6053","rgb":{"r":109,"g":96,"b":83},"luminance":65.78184117976632},{"name":"Intuitive","hex":"#cfc6bc","rgb":{"r":207,"g":198,"b":188},"luminance":133.411233218946},{"name":"Inuit Blue","hex":"#d8e4e7","rgb":{"r":216,"g":228,"b":231},"luminance":150.91934106667705},{"name":"Inuit White","hex":"#d1cdd0","rgb":{"r":209,"g":205,"b":208},"luminance":137.6513576031853},{"name":"Inverness Grey","hex":"#dce3e2","rgb":{"r":220,"g":227,"b":226},"luminance":150.8180629003038},{"name":"Inviting Veranda","hex":"#b9c4bc","rgb":{"r":185,"g":196,"b":188},"luminance":129.44513336931595},{"name":"Iolite","hex":"#707bb4","rgb":{"r":112,"g":123,"b":180},"luminance":82.19185449300922},{"name":"Iridescent","hex":"#3a5b52","rgb":{"r":58,"g":91,"b":82},"luminance":56.93422483006157},{"name":"Iridescent Green","hex":"#48c072","rgb":{"r":72,"g":192,"b":114},"luminance":115.47528920076364},{"name":"Iridescent Peacock","hex":"#00707d","rgb":{"r":0,"g":112,"b":125},"luminance":67.27061792491578},{"name":"Iridescent Purple","hex":"#966fd6","rgb":{"r":150,"g":111,"b":214},"luminance":82.77754505299127},{"name":"Iridescent Red","hex":"#cc4e5c","rgb":{"r":204,"g":78,"b":92},"luminance":76.98615431361668},{"name":"Iridescent Turquoise","hex":"#7bfdc7","rgb":{"r":123,"g":253,"b":199},"luminance":154.6697108227723},{"name":"Iris","hex":"#5a4fcf","rgb":{"r":90,"g":79,"b":207},"luminance":58.57874045248839},{"name":"Iris Bloom","hex":"#5b609e","rgb":{"r":91,"g":96,"b":158},"luminance":65.11766065361992},{"name":"Iris Blue","hex":"#03b4c8","rgb":{"r":3,"g":180,"b":200},"luminance":108.09569930852939},{"name":"Iris Eyes","hex":"#767694","rgb":{"r":118,"g":118,"b":148},"luminance":79.54409257763896},{"name":"Iris Ice","hex":"#e0e3ef","rgb":{"r":224,"g":227,"b":239},"luminance":151.6028531822538},{"name":"Iris Isle","hex":"#e8e5ec","rgb":{"r":232,"g":229,"b":236},"luminance":153.64012356477718},{"name":"Iris Mauve","hex":"#b39b94","rgb":{"r":179,"g":155,"b":148},"luminance":106.8991676768346},{"name":"Iris Orchid","hex":"#a767a2","rgb":{"r":167,"g":103,"b":162},"luminance":80.55994062808139},{"name":"Irish Beauty","hex":"#007f59","rgb":{"r":0,"g":127,"b":89},"luminance":75.23625932354692},{"name":"Irish Charm","hex":"#69905b","rgb":{"r":105,"g":144,"b":91},"luminance":90.76479871073366},{"name":"Irish Clover","hex":"#53734c","rgb":{"r":83,"g":115,"b":76},"luminance":72.44220737940002},{"name":"Irish Coffee","hex":"#62422b","rgb":{"r":98,"g":66,"b":43},"luminance":48.821914874367636},{"name":"Irish Cream","hex":"#e9dbbe","rgb":{"r":233,"g":219,"b":190},"luminance":147.81244973952633},{"name":"Irish Green","hex":"#019529","rgb":{"r":1,"g":149,"b":41},"luminance":87.5883099848376},{"name":"Irish Hedge","hex":"#7cb386","rgb":{"r":124,"g":179,"b":134},"luminance":112.46475572818356},{"name":"Irish Moor","hex":"#b5c0b3","rgb":{"r":181,"g":192,"b":179},"luminance":126.6785799296787},{"name":"Irogon Blue","hex":"#9dacb5","rgb":{"r":157,"g":172,"b":181},"luminance":113.23928868109336},{"name":"Iroko","hex":"#433120","rgb":{"r":67,"g":49,"b":32},"luminance":35.2411572170949},{"name":"Iron","hex":"#5e5e5e","rgb":{"r":94,"g":94,"b":94},"luminance":62.84418490202574},{"name":"Iron Creek","hex":"#50676b","rgb":{"r":80,"g":103,"b":107},"luminance":66.15504610383095},{"name":"Iron Earth","hex":"#8aa1a6","rgb":{"r":138,"g":161,"b":166},"luminance":104.84390048543595},{"name":"Iron Fixture","hex":"#5d5b5b","rgb":{"r":93,"g":91,"b":91},"luminance":61.10830560570306},{"name":"Iron Flint","hex":"#6e3b31","rgb":{"r":110,"g":59,"b":49},"luminance":48.087422316027705},{"name":"Iron Gate","hex":"#4e5055","rgb":{"r":78,"g":80,"b":85},"luminance":53.32029054684529},{"name":"Iron Head","hex":"#344d56","rgb":{"r":52,"g":77,"b":86},"luminance":48.79352744985752},{"name":"Iron Maiden","hex":"#d6d1dc","rgb":{"r":214,"g":209,"b":220},"luminance":140.6212398075056},{"name":"Iron Ore","hex":"#af5b46","rgb":{"r":175,"g":91,"b":70},"luminance":75.19948080937792},{"name":"Iron River","hex":"#4d504b","rgb":{"r":77,"g":80,"b":75},"luminance":52.99436412487652},{"name":"Iron-ic","hex":"#6a6b67","rgb":{"r":106,"g":107,"b":103},"luminance":71.32569439549818},{"name":"Ironbreaker","hex":"#887f85","rgb":{"r":136,"g":127,"b":133},"luminance":86.26123428864207},{"name":"Ironbreaker Metal","hex":"#a1a6a9","rgb":{"r":161,"g":166,"b":169},"luminance":110.37882695970274},{"name":"Ironside Grey","hex":"#706e66","rgb":{"r":112,"g":110,"b":102},"luminance":73.66098986573557},{"name":"Ironstone","hex":"#865040","rgb":{"r":134,"g":80,"b":64},"luminance":62.15913104283231},{"name":"Ironwood","hex":"#a19583","rgb":{"r":161,"g":149,"b":131},"luminance":100.94634241021316},{"name":"Irradiant Iris","hex":"#dadee6","rgb":{"r":218,"g":222,"b":230},"luminance":148.04701996325358},{"name":"Irradiated Green","hex":"#aaff55","rgb":{"r":170,"g":255,"b":85},"luminance":158.37671617065433},{"name":"Irresistible","hex":"#b3446c","rgb":{"r":179,"g":68,"b":108},"luminance":67.89234007603508},{"name":"Irresistible Beige","hex":"#e6ddc6","rgb":{"r":230,"g":221,"b":198},"luminance":148.5526930519942},{"name":"Irrigation","hex":"#786c57","rgb":{"r":120,"g":108,"b":87},"luminance":73.51730367743365},{"name":"Irrigo Purple","hex":"#9955ff","rgb":{"r":153,"g":85,"b":255},"luminance":73.67064499514036},{"name":"Irritated Ibis","hex":"#ee1122","rgb":{"r":238,"g":17,"b":34},"luminance":71.96272688690999},{"name":"Isabelline","hex":"#f4f0ec","rgb":{"r":244,"g":240,"b":236},"luminance":160.91481458212604},{"name":"Ishtar","hex":"#484450","rgb":{"r":72,"g":68,"b":80},"luminance":46.259228700876534},{"name":"Islamic Green","hex":"#009900","rgb":{"r":0,"g":153,"b":0},"luminance":89.81099999999999},{"name":"Island Coral","hex":"#d8877a","rgb":{"r":216,"g":135,"b":122},"luminance":103.1711953260211},{"name":"Island Girl","hex":"#ffb59a","rgb":{"r":255,"g":181,"b":154},"luminance":131.94672474146526},{"name":"Island Green","hex":"#2bae66","rgb":{"r":43,"g":174,"b":102},"luminance":103.59866735146741},{"name":"Island Light","hex":"#a7c9eb","rgb":{"r":167,"g":201,"b":235},"luminance":130.88903986965448},{"name":"Island Lush","hex":"#008292","rgb":{"r":0,"g":130,"b":146},"luminance":78.10402573491331},{"name":"Island Monkey","hex":"#ad4e1a","rgb":{"r":173,"g":78,"b":26},"luminance":69.14351467057485},{"name":"Island Oasis","hex":"#88d9d8","rgb":{"r":136,"g":217,"b":216},"luminance":135.96069988419447},{"name":"Island Paradise","hex":"#95dee3","rgb":{"r":149,"g":222,"b":227},"luminance":140.12922993080352},{"name":"Island Sea","hex":"#81d7d0","rgb":{"r":129,"g":215,"b":208},"luminance":134.08088234345715},{"name":"Island Spice","hex":"#f8eddb","rgb":{"r":248,"g":237,"b":219},"luminance":159.61176780237727},{"name":"Island View","hex":"#c3ddee","rgb":{"r":195,"g":221,"b":238},"luminance":144.7919644800774},{"name":"Isle Royale","hex":"#80d7cf","rgb":{"r":128,"g":215,"b":207},"luminance":133.97504847172104},{"name":"Isolation","hex":"#494d55","rgb":{"r":73,"g":77,"b":85},"luminance":51.120090277698054},{"name":"Issey-San","hex":"#cfdac3","rgb":{"r":207,"g":218,"b":195},"luminance":143.87568767863456},{"name":"It Works","hex":"#af8a5b","rgb":{"r":175,"g":138,"b":91},"luminance":96.99225503616255},{"name":"It's Your Mauve","hex":"#bc989e","rgb":{"r":188,"g":152,"b":158},"luminance":106.98197635115926},{"name":"Italian Basil","hex":"#5f6957","rgb":{"r":95,"g":105,"b":87},"luminance":68.58632497808874},{"name":"Italian Buckthorn","hex":"#6b8c23","rgb":{"r":107,"g":140,"b":35},"luminance":88.27810911545397},{"name":"Italian Clay","hex":"#d79979","rgb":{"r":215,"g":153,"b":121},"luminance":111.30521722722614},{"name":"Italian Fitch","hex":"#d0c8e6","rgb":{"r":208,"g":200,"b":230},"luminance":135.4182161453916},{"name":"Italian Grape","hex":"#413d4b","rgb":{"r":65,"g":61,"b":75},"luminance":41.62887187998252},{"name":"Italian Lace","hex":"#ede9d4","rgb":{"r":237,"g":233,"b":212},"luminance":155.9229406918687},{"name":"Italian Plum","hex":"#533146","rgb":{"r":83,"g":49,"b":70},"luminance":38.81847572999228},{"name":"Italian Roast","hex":"#221111","rgb":{"r":34,"g":17,"b":17},"luminance":14.376503086634107},{"name":"Italian Sky Blue","hex":"#b2fcff","rgb":{"r":178,"g":252,"b":255},"luminance":159.87231142383598},{"name":"Italian Straw","hex":"#e7d1a1","rgb":{"r":231,"g":209,"b":161},"luminance":141.980683777759},{"name":"Italian Villa","hex":"#ad5d5d","rgb":{"r":173,"g":93,"b":93},"luminance":75.94907645258104},{"name":"Ivalo River","hex":"#cce5e8","rgb":{"r":204,"g":229,"b":232},"luminance":149.96516811913358},{"name":"Ivory","hex":"#fffff0","rgb":{"r":255,"g":255,"b":240},"luminance":170.1983221127635},{"name":"Ivory Charm","hex":"#fff6da","rgb":{"r":255,"g":246,"b":218},"luminance":165.1752388616405},{"name":"Ivory Cream","hex":"#dac0a7","rgb":{"r":218,"g":192,"b":167},"luminance":131.58012837811035},{"name":"Ivory Keys","hex":"#f8f7e6","rgb":{"r":248,"g":247,"b":230},"luminance":164.94792397905468},{"name":"Ivory Lashes","hex":"#e6e6d8","rgb":{"r":230,"g":230,"b":216},"luminance":153.50359727380985},{"name":"Ivory Memories","hex":"#e6ddcd","rgb":{"r":230,"g":221,"b":205},"luminance":148.67603818033356},{"name":"Ivory Mist","hex":"#efeade","rgb":{"r":239,"g":234,"b":222},"luminance":156.88973691417806},{"name":"Ivory Oats","hex":"#f9e4c1","rgb":{"r":249,"g":228,"b":193},"luminance":154.7227013110875},{"name":"Ivory Steam","hex":"#f0eada","rgb":{"r":240,"g":234,"b":218},"luminance":156.95330410029604},{"name":"Ivory Tower","hex":"#fbf3f1","rgb":{"r":251,"g":243,"b":241},"luminance":163.50421388453572},{"name":"Ivy","hex":"#226c63","rgb":{"r":34,"g":108,"b":99},"luminance":65.19029197664327},{"name":"Ivy Enchantment","hex":"#93a272","rgb":{"r":147,"g":162,"b":114},"luminance":105.56339830168409},{"name":"Ivy Garden","hex":"#818068","rgb":{"r":129,"g":128,"b":104},"luminance":85.28602038435139},{"name":"Ivy Green","hex":"#585442","rgb":{"r":88,"g":84,"b":66},"luminance":56.39335762303926},{"name":"Ivy League","hex":"#007958","rgb":{"r":0,"g":121,"b":88},"luminance":71.73197162353758},{"name":"Iwai Brown","hex":"#6b6f59","rgb":{"r":107,"g":111,"b":89},"luminance":73.2934377280804},{"name":"Iwaicha Brown","hex":"#5e5545","rgb":{"r":94,"g":85,"b":69},"luminance":57.80425777570368},{"name":"Iyanden Darksun","hex":"#a59a59","rgb":{"r":165,"g":154,"b":89},"luminance":103.48276158375366},{"name":"J's Big Heart","hex":"#a06856","rgb":{"r":160,"g":104,"b":86},"luminance":78.17699354669506},{"name":"Jabłoński Brown","hex":"#ad6d68","rgb":{"r":173,"g":109,"b":104},"luminance":83.12684015406816},{"name":"Jabłoński Grey","hex":"#536871","rgb":{"r":83,"g":104,"b":113},"luminance":67.14676252061598},{"name":"Jacaranda","hex":"#f9d7ee","rgb":{"r":249,"g":215,"b":238},"luminance":149.01945795767745},{"name":"Jacaranda Jazz","hex":"#6c70a9","rgb":{"r":108,"g":112,"b":169},"luminance":75.73787398653332},{"name":"Jacaranda Light","hex":"#a8acb7","rgb":{"r":168,"g":172,"b":183},"luminance":114.68306834053578},{"name":"Jacaranda Pink","hex":"#c760ff","rgb":{"r":199,"g":96,"b":255},"luminance":86.95390620897948},{"name":"Jacarta","hex":"#440044","rgb":{"r":68,"g":0,"b":68},"luminance":21.759681247665373},{"name":"Jacey's Favorite","hex":"#bcaccd","rgb":{"r":188,"g":172,"b":205},"luminance":117.89688350418767},{"name":"Jack Bone","hex":"#869f69","rgb":{"r":134,"g":159,"b":105},"luminance":102.27225501082881},{"name":"Jack Frost","hex":"#dae6e3","rgb":{"r":218,"g":230,"b":227},"luminance":152.13830585358835},{"name":"Jack Rabbit","hex":"#c0b2b1","rgb":{"r":192,"g":178,"b":177},"luminance":120.91383024286344},{"name":"Jack-o","hex":"#fb9902","rgb":{"r":251,"g":153,"b":2},"luminance":117.04024993992451},{"name":"Jacko Bean","hex":"#413628","rgb":{"r":65,"g":54,"b":40},"luminance":37.46032606638655},{"name":"Jackpot","hex":"#d19431","rgb":{"r":209,"g":148,"b":49},"luminance":107.16234344675372},{"name":"Jacksons Purple","hex":"#3d3f7d","rgb":{"r":61,"g":63,"b":125},"luminance":43.62703269762911},{"name":"Jacobean Lace","hex":"#e4ccb0","rgb":{"r":228,"g":204,"b":176},"luminance":139.24643329004874},{"name":"Jacqueline","hex":"#5d4e50","rgb":{"r":93,"g":78,"b":80},"luminance":54.339317671461416},{"name":"Jacuzzi","hex":"#007cac","rgb":{"r":0,"g":124,"b":172},"luminance":75.38280047862376},{"name":"Jade","hex":"#00a86b","rgb":{"r":0,"g":168,"b":107},"luminance":99.36753322891738},{"name":"Jade Bracelet","hex":"#c2d7ad","rgb":{"r":194,"g":215,"b":173},"luminance":140.2902539202207},{"name":"Jade Cream","hex":"#60b892","rgb":{"r":96,"g":184,"b":146},"luminance":112.98969163600722},{"name":"Jade Dust","hex":"#ceddda","rgb":{"r":206,"g":221,"b":218},"luminance":145.74133685746128},{"name":"Jade Glass","hex":"#00ced1","rgb":{"r":0,"g":206,"b":209},"luminance":123.24694057054722},{"name":"Jade Gravel","hex":"#0abab5","rgb":{"r":10,"g":186,"b":181},"luminance":111.15489723804345},{"name":"Jade Green","hex":"#779977","rgb":{"r":119,"g":153,"b":119},"luminance":97.55029286475771},{"name":"Jade Jewel","hex":"#247e81","rgb":{"r":36,"g":126,"b":129},"luminance":76.17419232259702},{"name":"Jade Lime","hex":"#a1ca7b","rgb":{"r":161,"g":202,"b":123},"luminance":128.7391676258628},{"name":"Jade Mountain","hex":"#34c2a7","rgb":{"r":52,"g":194,"b":167},"luminance":116.50057781830955},{"name":"Jade Orchid","hex":"#00aaaa","rgb":{"r":0,"g":170,"b":170},"luminance":101.65445637058907},{"name":"Jade Powder","hex":"#2baf6a","rgb":{"r":43,"g":175,"b":106},"luminance":104.22931991527143},{"name":"Jade Shard","hex":"#017b92","rgb":{"r":1,"g":123,"b":146},"luminance":74.09518566006835},{"name":"Jade Spell","hex":"#c1e5d5","rgb":{"r":193,"g":229,"b":213},"luminance":148.28774832062155},{"name":"Jaded","hex":"#0092a1","rgb":{"r":0,"g":146,"b":161},"luminance":87.6453200119664},{"name":"Jaded Clouds","hex":"#aeddd3","rgb":{"r":174,"g":221,"b":211},"luminance":141.82522385316375},{"name":"Jaded Ginger","hex":"#cc7766","rgb":{"r":204,"g":119,"b":102},"luminance":93.4620993183868},{"name":"Jadeite","hex":"#38c6a1","rgb":{"r":56,"g":198,"b":161},"luminance":118.85164671976574},{"name":"Jadesheen","hex":"#77a276","rgb":{"r":119,"g":162,"b":118},"luminance":102.41988430475793},{"name":"Jaffa","hex":"#e27945","rgb":{"r":226,"g":121,"b":69},"luminance":98.35117773061998},{"name":"Jaffa Orange","hex":"#d86d39","rgb":{"r":216,"g":109,"b":57},"luminance":91.1435206089824},{"name":"Jagdwurst","hex":"#ffcccb","rgb":{"r":255,"g":204,"b":203},"luminance":143.83475133986224},{"name":"Jagged Ice","hex":"#cae7e2","rgb":{"r":202,"g":231,"b":226},"luminance":150.65937909403448},{"name":"Jagger","hex":"#3f2e4c","rgb":{"r":63,"g":46,"b":76},"luminance":34.04416938331731},{"name":"Jaguar","hex":"#29292f","rgb":{"r":41,"g":41,"b":47},"luminance":27.53564478998086},{"name":"Jaguar Rose","hex":"#f1b3b6","rgb":{"r":241,"g":179,"b":182},"luminance":129.08646061458188},{"name":"Jaipur Pink","hex":"#d0417e","rgb":{"r":208,"g":65,"b":126},"luminance":74.36379081918834},{"name":"Jakarta","hex":"#efddc3","rgb":{"r":239,"g":221,"b":195},"luminance":149.766291100501},{"name":"Jakarta Skyline","hex":"#3d325d","rgb":{"r":61,"g":50,"b":93},"luminance":36.145345827644256},{"name":"Jalapeno","hex":"#9a8d3f","rgb":{"r":154,"g":141,"b":63},"luminance":94.98521742355491},{"name":"Jalapeno Poppers","hex":"#576648","rgb":{"r":87,"g":102,"b":72},"luminance":65.79470578245639},{"name":"Jalapeno Red","hex":"#b2103c","rgb":{"r":178,"g":16,"b":60},"luminance":54.47546739588381},{"name":"Jam Session","hex":"#d4cfd6","rgb":{"r":212,"g":207,"b":214},"luminance":139.20359349169115},{"name":"Jama Masjid Taupe","hex":"#b38b6d","rgb":{"r":179,"g":139,"b":109},"luminance":98.36829044971758},{"name":"Jamaican Dream","hex":"#04627a","rgb":{"r":4,"g":98,"b":122},"luminance":59.195469049581824},{"name":"Jamaican Jade","hex":"#64d1be","rgb":{"r":100,"g":209,"b":190},"luminance":128.11824260814694},{"name":"Jamaican Sea","hex":"#26a5ba","rgb":{"r":38,"g":165,"b":186},"luminance":99.79777394811968},{"name":"Jambalaya","hex":"#674834","rgb":{"r":103,"g":72,"b":52},"luminance":52.62928926937927},{"name":"James Blonde","hex":"#f2e3b5","rgb":{"r":242,"g":227,"b":181},"luminance":153.02528588765975},{"name":"Janemba Red","hex":"#ff2211","rgb":{"r":255,"g":34,"b":17},"luminance":78.83766633405634},{"name":"Janey's Party","hex":"#ceb5c8","rgb":{"r":206,"g":181,"b":200},"luminance":124.90830975159339},{"name":"Janna","hex":"#f4ebd3","rgb":{"r":244,"g":235,"b":211},"luminance":157.89235534692617},{"name":"January Dawn","hex":"#dfe2e5","rgb":{"r":223,"g":226,"b":229},"luminance":150.75328125450537},{"name":"January Frost","hex":"#99c1dc","rgb":{"r":153,"g":193,"b":220},"luminance":124.72628067091554},{"name":"Japanese Bonsai","hex":"#829f96","rgb":{"r":130,"g":159,"b":150},"luminance":102.53943528711282},{"name":"Japanese Carmine","hex":"#9f2832","rgb":{"r":159,"g":40,"b":50},"luminance":53.32867034719691},{"name":"Japanese Cypress","hex":"#965036","rgb":{"r":150,"g":80,"b":54},"luminance":65.22775817088917},{"name":"Japanese Horseradish","hex":"#a8bf93","rgb":{"r":168,"g":191,"b":147},"luminance":123.99316947719338},{"name":"Japanese Indigo","hex":"#264348","rgb":{"r":38,"g":67,"b":72},"luminance":41.7520843671307},{"name":"Japanese Iris","hex":"#7f5d3b","rgb":{"r":127,"g":93,"b":59},"luminance":66.83835041351634},{"name":"Japanese Laurel","hex":"#2f7532","rgb":{"r":47,"g":117,"b":50},"luminance":70.33336228277446},{"name":"Japanese Maple","hex":"#780109","rgb":{"r":120,"g":1,"b":9},"luminance":35.89946580382499},{"name":"Japanese Poet","hex":"#c4bab7","rgb":{"r":196,"g":186,"b":183},"luminance":125.65970310326217},{"name":"Japanese Sable","hex":"#313739","rgb":{"r":49,"g":55,"b":57},"luminance":36.044375844228455},{"name":"Japanese Violet","hex":"#5b3256","rgb":{"r":91,"g":50,"b":86},"luminance":41.2052253603836},{"name":"Japanese Wax Tree","hex":"#b77b57","rgb":{"r":183,"g":123,"b":87},"luminance":91.13342533889528},{"name":"Japanese Wineberry","hex":"#522c35","rgb":{"r":82,"g":44,"b":53},"luminance":36.120958902000375},{"name":"Japanese Yew","hex":"#d8a373","rgb":{"r":216,"g":163,"b":115},"luminance":116.18011412027448},{"name":"Japonica","hex":"#ce7259","rgb":{"r":206,"g":114,"b":89},"luminance":91.51382887848152},{"name":"Jarrah","hex":"#827058","rgb":{"r":130,"g":112,"b":88},"luminance":77.03110709317373},{"name":"Jasmine","hex":"#fff4bb","rgb":{"r":255,"g":244,"b":187},"luminance":163.65212229910125},{"name":"Jasmine Flower","hex":"#f4e8e1","rgb":{"r":244,"g":232,"b":225},"luminance":156.60964942173902},{"name":"Jasmine Green","hex":"#7ec845","rgb":{"r":126,"g":200,"b":69},"luminance":123.5474169377895},{"name":"Jasmine Hollow","hex":"#7e7468","rgb":{"r":126,"g":116,"b":104},"luminance":78.71731369908402},{"name":"Jasper","hex":"#d73b3e","rgb":{"r":215,"g":59,"b":62},"luminance":73.36186024086358},{"name":"Jasper Orange","hex":"#de8f4e","rgb":{"r":222,"g":143,"b":78},"luminance":107.3834159868273},{"name":"Jasper Park","hex":"#4a6558","rgb":{"r":74,"g":101,"b":88},"luminance":64.07143879295984},{"name":"Java","hex":"#259797","rgb":{"r":37,"g":151,"b":151},"luminance":90.9682886175177},{"name":"Jay Wing Feathers","hex":"#7994b5","rgb":{"r":121,"g":148,"b":181},"luminance":96.34376665358272},{"name":"Jazz","hex":"#5f2c2f","rgb":{"r":95,"g":44,"b":47},"luminance":38.76387200732145},{"name":"Jazz Age Blues","hex":"#3b4a6c","rgb":{"r":59,"g":74,"b":108},"luminance":48.47318917711109},{"name":"Jazz Tune","hex":"#9892a8","rgb":{"r":152,"g":146,"b":168},"luminance":98.87948529396783},{"name":"Jazzberry Jam","hex":"#674247","rgb":{"r":103,"g":66,"b":71},"luminance":50.14888442428206},{"name":"Jazzercise","hex":"#b6e12a","rgb":{"r":182,"g":225,"b":42},"luminance":142.9267270072326},{"name":"Jazzy","hex":"#b61c50","rgb":{"r":182,"g":28,"b":80},"luminance":57.57286878382907},{"name":"Jazzy Jade","hex":"#55ddcc","rgb":{"r":85,"g":221,"b":204},"luminance":134.22316599603812},{"name":"Jealous Jellyfish","hex":"#bb0099","rgb":{"r":187,"g":0,"b":153},"luminance":58.5703588259454},{"name":"Jealousy","hex":"#7fab60","rgb":{"r":127,"g":171,"b":96},"luminance":107.87614191284372},{"name":"Jeans Indigo","hex":"#6d8994","rgb":{"r":109,"g":137,"b":148},"luminance":88.39713358474923},{"name":"Jedi Night","hex":"#041108","rgb":{"r":4,"g":17,"b":8},"luminance":10.09170951821345},{"name":"Jefferson Cream","hex":"#f1e4c8","rgb":{"r":241,"g":228,"b":200},"luminance":153.7023564458268},{"name":"Jelly Bean","hex":"#44798e","rgb":{"r":68,"g":121,"b":142},"luminance":75.63250820249188},{"name":"Jelly Yogurt","hex":"#ede6d9","rgb":{"r":237,"g":230,"b":217},"luminance":154.47081767440736},{"name":"Jellybean Pink","hex":"#9b6575","rgb":{"r":155,"g":101,"b":117},"luminance":76.4245355759523},{"name":"Jellyfish Blue","hex":"#95cad0","rgb":{"r":149,"g":202,"b":208},"luminance":128.8675444826974},{"name":"Jellyfish Sting","hex":"#ee6688","rgb":{"r":238,"g":102,"b":136},"luminance":94.2830851001387},{"name":"Jemima","hex":"#f6d67f","rgb":{"r":246,"g":214,"b":127},"luminance":146.28631283889823},{"name":"Jerboa","hex":"#deb887","rgb":{"r":222,"g":184,"b":135},"luminance":127.7052036841099},{"name":"Jericho Jade","hex":"#4d8681","rgb":{"r":77,"g":134,"b":129},"luminance":83.26707590038214},{"name":"Jess","hex":"#25b387","rgb":{"r":37,"g":179,"b":135},"luminance":106.76880348678634},{"name":"Jester Red","hex":"#9e1030","rgb":{"r":158,"g":16,"b":48},"luminance":48.47637581337944},{"name":"Jet","hex":"#343434","rgb":{"r":52,"g":52,"b":52},"luminance":34.76486824367381},{"name":"Jet Black","hex":"#2d2c2f","rgb":{"r":45,"g":44,"b":47},"luminance":29.611328457196915},{"name":"Jet d'Eau","hex":"#d1eaec","rgb":{"r":209,"g":234,"b":236},"luminance":153.2846060796713},{"name":"Jet Fuel","hex":"#575654","rgb":{"r":87,"g":86,"b":84},"luminance":57.59173785361924},{"name":"Jet Set","hex":"#262c2a","rgb":{"r":38,"g":44,"b":42},"luminance":28.620020475184848},{"name":"Jet Stream","hex":"#bbd0c9","rgb":{"r":187,"g":208,"b":201},"luminance":136.23049651601508},{"name":"Jetski Race","hex":"#005d96","rgb":{"r":0,"g":93,"b":150},"luminance":57.206531803632345},{"name":"Jewel","hex":"#136843","rgb":{"r":19,"g":104,"b":67},"luminance":61.78568692666611},{"name":"Jewel Caterpillar","hex":"#d374d5","rgb":{"r":211,"g":116,"b":213},"luminance":95.94976763390311},{"name":"Jewel Cave","hex":"#3c4173","rgb":{"r":60,"g":65,"b":115},"luminance":44.1533659532317},{"name":"Jewel Weed","hex":"#46a795","rgb":{"r":70,"g":167,"b":149},"luminance":101.66746744657308},{"name":"Jigglypuff","hex":"#ffaaff","rgb":{"r":255,"g":170,"b":255},"luminance":128.90465090523304},{"name":"Jimbaran Bay","hex":"#3d5d64","rgb":{"r":61,"g":93,"b":100},"luminance":58.675364523793114},{"name":"Jīn Huáng Gold","hex":"#f5d565","rgb":{"r":245,"g":213,"b":101},"luminance":145.3671839928118},{"name":"Jīn Sè Gold","hex":"#a5a502","rgb":{"r":165,"g":165,"b":2},"luminance":108.69629816143693},{"name":"Jīn Zōng Gold","hex":"#8e7618","rgb":{"r":142,"g":118,"b":24},"luminance":81.28927491373015},{"name":"Jinza Safflower","hex":"#ee827c","rgb":{"r":238,"g":130,"b":124},"luminance":105.29517006966654},{"name":"Jinzamomi Pink","hex":"#f7665a","rgb":{"r":247,"g":102,"b":90},"luminance":95.62650827568682},{"name":"Jitterbug","hex":"#bac08a","rgb":{"r":186,"g":192,"b":138},"luminance":126.65940326718739},{"name":"Jitterbug Lure","hex":"#8db0ad","rgb":{"r":141,"g":176,"b":173},"luminance":113.31243492662223},{"name":"Jodhpur Blue","hex":"#9bd7e9","rgb":{"r":155,"g":215,"b":233},"luminance":137.0441567305954},{"name":"Jodhpurs","hex":"#ebdcb6","rgb":{"r":235,"g":220,"b":182},"luminance":148.47487777061815},{"name":"Jojoba","hex":"#dabe81","rgb":{"r":218,"g":190,"b":129},"luminance":130.01500090374188},{"name":"Jokaero Orange","hex":"#ea5505","rgb":{"r":234,"g":85,"b":5},"luminance":85.93647119238722},{"name":"Joker's Smile","hex":"#d70141","rgb":{"r":215,"g":1,"b":65},"luminance":64.71332083891228},{"name":"Jolly Green","hex":"#5e774a","rgb":{"r":94,"g":119,"b":74},"luminance":75.76644996962706},{"name":"Jonquil","hex":"#eef293","rgb":{"r":238,"g":242,"b":147},"luminance":159.7629485331314},{"name":"Jordy Blue","hex":"#7aaae0","rgb":{"r":122,"g":170,"b":224},"luminance":109.27385725780891},{"name":"Joshua Tree","hex":"#7fb377","rgb":{"r":127,"g":179,"b":119},"luminance":112.54474849587606},{"name":"Joust Blue","hex":"#55aaff","rgb":{"r":85,"g":170,"b":255},"luminance":107.00014591111547},{"name":"Joyful","hex":"#f6eec0","rgb":{"r":246,"g":238,"b":192},"luminance":159.39586536670265},{"name":"Joyful Poppy","hex":"#ebada5","rgb":{"r":235,"g":173,"b":165},"luminance":124.91433835232846},{"name":"Jú Huáng Tangerine","hex":"#f9900f","rgb":{"r":249,"g":144,"b":15},"luminance":112.65370959271603},{"name":"Jube","hex":"#4b373c","rgb":{"r":75,"g":55,"b":60},"luminance":39.8997174175457},{"name":"Jube Green","hex":"#78cf86","rgb":{"r":120,"g":207,"b":134},"luminance":127.61335218933792},{"name":"Jubilation","hex":"#fbdd24","rgb":{"r":251,"g":221,"b":36},"luminance":149.9276150213829},{"name":"Jubilee","hex":"#7e6099","rgb":{"r":126,"g":96,"b":153},"luminance":69.99358216293834},{"name":"Judah Silk","hex":"#473739","rgb":{"r":71,"g":55,"b":57},"luminance":39.181828313645596},{"name":"Judge Grey","hex":"#5d5346","rgb":{"r":93,"g":83,"b":70},"luminance":56.66255809615376},{"name":"Juggernaut","hex":"#255367","rgb":{"r":37,"g":83,"b":103},"luminance":51.322513325050636},{"name":"Juicy Jackfruit","hex":"#eedd33","rgb":{"r":238,"g":221,"b":51},"luminance":148.0774370692578},{"name":"Juicy Lime","hex":"#b1cf5d","rgb":{"r":177,"g":207,"b":93},"luminance":132.95744963709254},{"name":"Julep Green","hex":"#c7dbd9","rgb":{"r":199,"g":219,"b":217},"luminance":143.7992053316012},{"name":"Jules","hex":"#a73940","rgb":{"r":167,"g":57,"b":64},"luminance":60.547838821877036},{"name":"July","hex":"#8bd2e3","rgb":{"r":139,"g":210,"b":227},"luminance":132.63664842342783},{"name":"Jumbo","hex":"#878785","rgb":{"r":135,"g":135,"b":133},"luminance":90.21634826349378},{"name":"June","hex":"#9bc4d4","rgb":{"r":155,"g":196,"b":212},"luminance":126.36816827429287},{"name":"June Bud","hex":"#bdda57","rgb":{"r":189,"g":218,"b":87},"luminance":140.2396413322567},{"name":"June Bug","hex":"#264a48","rgb":{"r":38,"g":74,"b":72},"luminance":45.64346779113085},{"name":"June Bugs","hex":"#bb6633","rgb":{"r":187,"g":102,"b":51},"luminance":82.12771786065895},{"name":"Juneberry","hex":"#775496","rgb":{"r":119,"g":84,"b":150},"luminance":63.16404376700402},{"name":"Jungle","hex":"#00a466","rgb":{"r":0,"g":164,"b":102},"luminance":96.96771734964169},{"name":"Jungle Adventure","hex":"#446d46","rgb":{"r":68,"g":109,"b":70},"luminance":67.608393805799},{"name":"Jungle Book Green","hex":"#366c4e","rgb":{"r":54,"g":108,"b":78},"luminance":66.02131319505845},{"name":"Jungle Camouflage","hex":"#53665a","rgb":{"r":83,"g":102,"b":90},"luminance":65.62047672030431},{"name":"Jungle Civilization","hex":"#69673a","rgb":{"r":105,"g":103,"b":58},"luminance":68.44630808159049},{"name":"Jungle Cloak","hex":"#686959","rgb":{"r":104,"g":105,"b":89},"luminance":69.77661325257912},{"name":"Jungle Cover","hex":"#565042","rgb":{"r":86,"g":80,"b":66},"luminance":54.06534908793246},{"name":"Jungle Green","hex":"#048243","rgb":{"r":4,"g":130,"b":67},"luminance":76.70062294401527},{"name":"Jungle Juice","hex":"#a4c161","rgb":{"r":164,"g":193,"b":97},"luminance":123.94216127290987},{"name":"Jungle King","hex":"#4f4d32","rgb":{"r":79,"g":77,"b":50},"luminance":51.316578627184406},{"name":"Jungle Mist","hex":"#b0c4c4","rgb":{"r":176,"g":196,"b":196},"luminance":128.47374212655285},{"name":"Jungle Moss","hex":"#bdc3ac","rgb":{"r":189,"g":195,"b":172},"luminance":129.1518602653481},{"name":"Jungle Noises","hex":"#36716f","rgb":{"r":54,"g":113,"b":111},"luminance":69.4306747266653},{"name":"Juniper","hex":"#74918e","rgb":{"r":116,"g":145,"b":142},"luminance":93.32520787547168},{"name":"Juniper Berry","hex":"#b9b3c2","rgb":{"r":185,"g":179,"b":194},"luminance":120.78576907069805},{"name":"Juniper Oil","hex":"#6b8b75","rgb":{"r":107,"g":139,"b":117},"luminance":88.65027886024949},{"name":"Junket","hex":"#fbecd3","rgb":{"r":251,"g":236,"b":211},"luminance":159.38024451292574},{"name":"Jupiter","hex":"#e1e1e2","rgb":{"r":225,"g":225,"b":226},"luminance":150.444391540529},{"name":"Jupiter Brown","hex":"#ac8181","rgb":{"r":172,"g":129,"b":129},"luminance":92.70964539356193},{"name":"Jurassic Gold","hex":"#e7aa56","rgb":{"r":231,"g":170,"b":86},"luminance":121.75668062574636},{"name":"Jurassic Park","hex":"#3c663e","rgb":{"r":60,"g":102,"b":62},"luminance":62.90227420372017},{"name":"Jurney to the Sky","hex":"#cdeced","rgb":{"r":205,"g":236,"b":237},"luminance":153.87710802130377},{"name":"Just A Tease","hex":"#fbd6d2","rgb":{"r":251,"g":214,"b":210},"luminance":148.2746031018124},{"name":"Just Gorgeous","hex":"#d6c4c1","rgb":{"r":214,"g":196,"b":193},"luminance":133.47381355157273},{"name":"Just Peachy","hex":"#f8c275","rgb":{"r":248,"g":194,"b":117},"luminance":136.54530468675955},{"name":"Just Perfect","hex":"#eaecd3","rgb":{"r":234,"g":236,"b":211},"luminance":157.0507914529564},{"name":"Just Pink Enough","hex":"#ffebee","rgb":{"r":255,"g":235,"b":238},"luminance":159.93207456292185},{"name":"Just Right","hex":"#dcbfac","rgb":{"r":220,"g":191,"b":172},"luminance":131.45989408561076},{"name":"Just Rosey","hex":"#c4a295","rgb":{"r":196,"g":162,"b":149},"luminance":112.9859365053899},{"name":"Justice","hex":"#606b8e","rgb":{"r":96,"g":107,"b":142},"luminance":70.92912970705336},{"name":"Jute","hex":"#ad9773","rgb":{"r":173,"g":151,"b":115},"luminance":103.46048713397786},{"name":"Juzcar Blue","hex":"#a1d5f1","rgb":{"r":161,"g":213,"b":241},"luminance":136.7659861149694},{"name":"Kā Fēi Sè Brown","hex":"#736354","rgb":{"r":115,"g":99,"b":84},"luminance":68.19933115507806},{"name":"Kabacha Brown","hex":"#b14a30","rgb":{"r":177,"g":74,"b":48},"luminance":68.68512617008139},{"name":"Kabalite Green","hex":"#038c67","rgb":{"r":3,"g":140,"b":103},"luminance":83.01946502477595},{"name":"Kabocha Green","hex":"#044a05","rgb":{"r":4,"g":74,"b":5},"luminance":43.458200146807734},{"name":"Kabul","hex":"#6c5e53","rgb":{"r":108,"g":94,"b":83},"luminance":64.62905222885448},{"name":"Kacey's Pink","hex":"#e94b7e","rgb":{"r":233,"g":75,"b":126},"luminance":83.65414520512418},{"name":"Kachi Indigo","hex":"#393e4f","rgb":{"r":57,"g":62,"b":79},"luminance":41.18367541878699},{"name":"Kahili","hex":"#b7bfb0","rgb":{"r":183,"g":191,"b":176},"luminance":126.35954999128478},{"name":"Kahlua Milk","hex":"#bab099","rgb":{"r":186,"g":176,"b":153},"luminance":118.61917932611065},{"name":"Kahu Blue","hex":"#0093d6","rgb":{"r":0,"g":147,"b":214},"luminance":89.67137969831846},{"name":"Kaitoke Green","hex":"#245336","rgb":{"r":36,"g":83,"b":54},"luminance":50.274206836110295},{"name":"Kakadu Trail","hex":"#7d806e","rgb":{"r":125,"g":128,"b":110},"luminance":84.85022522657202},{"name":"Kakitsubata Blue","hex":"#3e62ad","rgb":{"r":62,"g":98,"b":173},"luminance":63.57558811367772},{"name":"Kālā Black","hex":"#201819","rgb":{"r":32,"g":24,"b":25},"luminance":17.266756151634272},{"name":"Kala Namak","hex":"#46444c","rgb":{"r":70,"g":68,"b":76},"luminance":45.89571714223452},{"name":"Kalamata","hex":"#5f5b4c","rgb":{"r":95,"g":91,"b":76},"luminance":61.11697644681058},{"name":"Kale","hex":"#5a7247","rgb":{"r":90,"g":114,"b":71},"luminance":72.57878243674249},{"name":"Kaleidoscope","hex":"#8da8be","rgb":{"r":141,"g":168,"b":190},"luminance":109.41504620937653},{"name":"Kalish Violet","hex":"#552288","rgb":{"r":85,"g":34,"b":136},"luminance":35.84156811580654},{"name":"Kalliene Yellow","hex":"#b59808","rgb":{"r":181,"g":152,"b":8},"luminance":104.3581337558314},{"name":"Kaltes Klares Wasser","hex":"#0ffef9","rgb":{"r":15,"g":254,"b":249},"luminance":151.84233212447705},{"name":"Kamenozoki Grey","hex":"#c6c2b6","rgb":{"r":198,"g":194,"b":182},"luminance":130.01367309633244},{"name":"Kamut","hex":"#cca483","rgb":{"r":204,"g":164,"b":131},"luminance":114.939393577659},{"name":"Kanafeh","hex":"#dd8833","rgb":{"r":221,"g":136,"b":51},"luminance":103.79491828119524},{"name":"Kangaroo","hex":"#c5c3b0","rgb":{"r":197,"g":195,"b":176},"luminance":130.28570040491778},{"name":"Kangaroo Fur","hex":"#c4ad92","rgb":{"r":196,"g":173,"b":146},"luminance":118.42321205321193},{"name":"Kangaroo Paw","hex":"#decac5","rgb":{"r":222,"g":202,"b":197},"luminance":137.7323278101405},{"name":"Kangaroo Pouch","hex":"#bda289","rgb":{"r":189,"g":162,"b":137},"luminance":111.7151909142172},{"name":"Kantor Blue","hex":"#001146","rgb":{"r":0,"g":17,"b":70},"luminance":12.777356573250978},{"name":"Kanzō Orange","hex":"#ff8936","rgb":{"r":255,"g":137,"b":54},"luminance":110.98834137872319},{"name":"Kaolin","hex":"#ad7d40","rgb":{"r":173,"g":125,"b":64},"luminance":90.07110951909053},{"name":"Kappa Green","hex":"#c5ded1","rgb":{"r":197,"g":222,"b":209},"luminance":144.97924086226965},{"name":"Kara Cha Brown","hex":"#783c1d","rgb":{"r":120,"g":60,"b":29},"luminance":50.38603413645491},{"name":"Karacha Red","hex":"#b35c44","rgb":{"r":179,"g":92,"b":68},"luminance":76.42658543334251},{"name":"Karak Stone","hex":"#bb9662","rgb":{"r":187,"g":150,"b":98},"luminance":104.89937870645373},{"name":"Karaka","hex":"#2d2d24","rgb":{"r":45,"g":45,"b":36},"luminance":29.927112557010908},{"name":"Karakurenai Red","hex":"#c91f37","rgb":{"r":201,"g":31,"b":55},"luminance":63.105732782370886},{"name":"Kariyasu Green","hex":"#6e7955","rgb":{"r":110,"g":121,"b":85},"luminance":78.8700382211141},{"name":"Karma","hex":"#b2a484","rgb":{"r":178,"g":164,"b":132},"luminance":111.02500354424674},{"name":"Karma Chameleon","hex":"#9f78a9","rgb":{"r":159,"g":120,"b":169},"luminance":87.13850490454837},{"name":"Karry","hex":"#fedcc1","rgb":{"r":254,"g":220,"b":193},"luminance":151.42332224594728},{"name":"Kashmir","hex":"#6f8d6a","rgb":{"r":111,"g":141,"b":106},"luminance":89.9883829502453},{"name":"Kashmir Blue","hex":"#576d8e","rgb":{"r":87,"g":109,"b":142},"luminance":70.94048070037304},{"name":"Kasugai Peach","hex":"#f3dfd5","rgb":{"r":243,"g":223,"b":213},"luminance":151.669795852701},{"name":"Katmandu","hex":"#ad9a5d","rgb":{"r":173,"g":154,"b":93},"luminance":104.68946144192356},{"name":"Katsura","hex":"#c9e3cc","rgb":{"r":201,"g":227,"b":204},"luminance":148.01360524627458},{"name":"Katydid","hex":"#66bc91","rgb":{"r":102,"g":188,"b":145},"luminance":115.6797978905565},{"name":"Kazakhstan Flag Yellow","hex":"#fec50c","rgb":{"r":254,"g":197,"b":12},"luminance":138.35477823696584},{"name":"Keel Joy","hex":"#d49595","rgb":{"r":212,"g":149,"b":149},"luminance":109.34504611092356},{"name":"Keen Green","hex":"#226600","rgb":{"r":34,"g":102,"b":0},"luminance":60.73091002117455},{"name":"Keepsake","hex":"#c0ced6","rgb":{"r":192,"g":206,"b":214},"luminance":136.06238776384896},{"name":"Keepsake Lilac","hex":"#c0a5ae","rgb":{"r":192,"g":165,"b":174},"luminance":114.32425982703758},{"name":"Keepsake Rose","hex":"#b08693","rgb":{"r":176,"g":134,"b":147},"luminance":96.11033713394204},{"name":"Keese Blue","hex":"#0000bc","rgb":{"r":0,"g":0,"b":188},"luminance":21.432000000000002},{"name":"Kefir","hex":"#d5d5ce","rgb":{"r":213,"g":213,"b":206},"luminance":142.26834920670163},{"name":"Kelley Green","hex":"#02ab2e","rgb":{"r":2,"g":171,"b":46},"luminance":100.51566678384022},{"name":"Kellie Belle","hex":"#dec7cf","rgb":{"r":222,"g":199,"b":207},"luminance":136.41180834883758},{"name":"Kelly Green","hex":"#339c5e","rgb":{"r":51,"g":156,"b":94},"luminance":93.4494293241002},{"name":"Kelly's Flower","hex":"#babd6c","rgb":{"r":186,"g":189,"b":108},"luminance":124.71107243945903},{"name":"Kelp","hex":"#4d503c","rgb":{"r":77,"g":80,"b":60},"luminance":52.7454806500045},{"name":"Kelp Brown","hex":"#716246","rgb":{"r":113,"g":98,"b":70},"luminance":67.18989838509953},{"name":"Kelp Forest","hex":"#448811","rgb":{"r":68,"g":136,"b":17},"luminance":82.40324199932913},{"name":"Kelp'thar Forest Blue","hex":"#0092ae","rgb":{"r":0,"g":146,"b":174},"luminance":87.96760596947037},{"name":"Kemp Kelly","hex":"#437b48","rgb":{"r":67,"g":123,"b":72},"luminance":75.37689801258738},{"name":"Ken Masters Red","hex":"#ec2c25","rgb":{"r":236,"g":44,"b":37},"luminance":75.26058200678493},{"name":"Kendall Rose","hex":"#f7cccd","rgb":{"r":247,"g":204,"b":205},"luminance":142.61839296878927},{"name":"Kenny's Kiss","hex":"#d45871","rgb":{"r":212,"g":88,"b":113},"luminance":82.77878232977336},{"name":"Kenpō Brown","hex":"#543f32","rgb":{"r":84,"g":63,"b":50},"luminance":45.0654836543446},{"name":"Kenpōzome Black","hex":"#2e211b","rgb":{"r":46,"g":33,"b":27},"luminance":23.955839392515553},{"name":"Kentucky","hex":"#6395bf","rgb":{"r":99,"g":149,"b":191},"luminance":94.86887079543004},{"name":"Kentucky Blue","hex":"#a5b3cc","rgb":{"r":165,"g":179,"b":204},"luminance":118.3854682382935},{"name":"Kenyan Copper","hex":"#6c322e","rgb":{"r":108,"g":50,"b":46},"luminance":43.951055732484974},{"name":"Kenyan Sand","hex":"#bb8800","rgb":{"r":187,"g":136,"b":0},"luminance":97.46492596313814},{"name":"Keppel","hex":"#5fb69c","rgb":{"r":95,"g":182,"b":156},"luminance":111.9670408513148},{"name":"Kermit Green","hex":"#5cb200","rgb":{"r":92,"g":178,"b":0},"luminance":108.04635236786108},{"name":"Kerr's Pink Potato","hex":"#b57281","rgb":{"r":181,"g":114,"b":129},"luminance":87.31065983601314},{"name":"Keshizumi Cinder","hex":"#524e4d","rgb":{"r":82,"g":78,"b":77},"luminance":52.673934768536135},{"name":"Ketchup","hex":"#9a382d","rgb":{"r":154,"g":56,"b":45},"luminance":56.80774066973619},{"name":"Kettle Black","hex":"#131313","rgb":{"r":19,"g":19,"b":19},"luminance":12.702548012111585},{"name":"Kettle Drum","hex":"#9bcb96","rgb":{"r":155,"g":203,"b":150},"luminance":128.99462370967248},{"name":"Kettleman","hex":"#606061","rgb":{"r":96,"g":96,"b":97},"luminance":64.20083242450988},{"name":"Key Keeper","hex":"#ecd1a5","rgb":{"r":236,"g":209,"b":165},"luminance":142.7732912172301},{"name":"Key Largo","hex":"#7fb6a4","rgb":{"r":127,"g":182,"b":164},"luminance":114.91297881875657},{"name":"Key Lime","hex":"#aeff6e","rgb":{"r":174,"g":255,"b":110},"luminance":158.96400693553244},{"name":"Key Lime Pie","hex":"#bfc921","rgb":{"r":191,"g":201,"b":33},"luminance":131.1355127110883},{"name":"Key Lime Water","hex":"#e8f48c","rgb":{"r":232,"g":244,"b":140},"luminance":159.9403045139029},{"name":"Khaki","hex":"#c3b091","rgb":{"r":195,"g":176,"b":145},"luminance":119.77513627209947},{"name":"Khaki Brown","hex":"#954e2a","rgb":{"r":149,"g":78,"b":42},"luminance":64.06304973227546},{"name":"Khaki Core","hex":"#fbe4af","rgb":{"r":251,"g":228,"b":175},"luminance":154.73341525669235},{"name":"Khaki Green","hex":"#728639","rgb":{"r":114,"g":134,"b":57},"luminance":85.97185797689846},{"name":"Khardic Flesh","hex":"#b16840","rgb":{"r":177,"g":104,"b":64},"luminance":81.12295512985212},{"name":"Khemri Brown","hex":"#76664c","rgb":{"r":118,"g":102,"b":76},"luminance":70.03413664778056},{"name":"Khorne Red","hex":"#6a0001","rgb":{"r":106,"g":0,"b":1},"luminance":31.694205022369623},{"name":"Kickstart Purple","hex":"#7777cc","rgb":{"r":119,"g":119,"b":204},"luminance":81.76974199543496},{"name":"Kid Gloves","hex":"#b6aeae","rgb":{"r":182,"g":174,"b":174},"luminance":117.417871995706},{"name":"Kid Icarus","hex":"#a81000","rgb":{"r":168,"g":16,"b":0},"luminance":51.10248025291923},{"name":"Kidnapper","hex":"#bfc0ab","rgb":{"r":191,"g":192,"b":171},"luminance":127.84226817840803},{"name":"Kihada Yellow","hex":"#fef263","rgb":{"r":254,"g":242,"b":99},"luminance":161.47602802893067},{"name":"Kikuchiba Gold","hex":"#e29c45","rgb":{"r":226,"g":156,"b":69},"luminance":114.07695041505973},{"name":"Kikyō Purple","hex":"#5d3f6a","rgb":{"r":93,"g":63,"b":106},"luminance":47.820985623468694},{"name":"Kilauea Lava","hex":"#843d38","rgb":{"r":132,"g":61,"b":56},"luminance":53.67140513346003},{"name":"Kilimanjaro","hex":"#3a3532","rgb":{"r":58,"g":53,"b":50},"luminance":36.07116972042908},{"name":"Killarney","hex":"#49764f","rgb":{"r":73,"g":118,"b":79},"luminance":73.17994753346028},{"name":"Killer Fog","hex":"#c9d2d1","rgb":{"r":201,"g":210,"b":209},"luminance":139.19432810642823},{"name":"Kiln Dried","hex":"#a89887","rgb":{"r":168,"g":152,"b":135},"luminance":103.54239759634696},{"name":"Kimberley Sea","hex":"#386b7d","rgb":{"r":56,"g":107,"b":125},"luminance":66.54618333909166},{"name":"Kimberley Tree","hex":"#b8c1b1","rgb":{"r":184,"g":193,"b":177},"luminance":127.54905966333111},{"name":"Kimberlite","hex":"#696fa5","rgb":{"r":105,"g":111,"b":165},"luminance":74.73216692964282},{"name":"Kimberly","hex":"#695d87","rgb":{"r":105,"g":93,"b":135},"luminance":64.82804490342123},{"name":"Kimchi","hex":"#ed4b00","rgb":{"r":237,"g":75,"b":0},"luminance":83.42520838451648},{"name":"Kimirucha Brown","hex":"#896c39","rgb":{"r":137,"g":108,"b":57},"luminance":75.7577995258574},{"name":"Kimono","hex":"#6d86b6","rgb":{"r":109,"g":134,"b":182},"luminance":87.63409010767442},{"name":"Kimono Grey","hex":"#3d4c51","rgb":{"r":61,"g":76,"b":81},"luminance":49.07299074847588},{"name":"Kin Gold","hex":"#f39800","rgb":{"r":243,"g":152,"b":0},"luminance":115.06503302480732},{"name":"Kincha Brown","hex":"#c66b27","rgb":{"r":198,"g":107,"b":39},"luminance":86.42692983671235},{"name":"Kind Magenta","hex":"#ff1dce","rgb":{"r":255,"g":29,"b":206},"luminance":81.57561406449845},{"name":"Kinder","hex":"#b8bfca","rgb":{"r":184,"g":191,"b":202},"luminance":126.99319166396283},{"name":"Kindleflame","hex":"#e9967a","rgb":{"r":233,"g":150,"b":122},"luminance":113.13587341334312},{"name":"Kindness","hex":"#d4b2c0","rgb":{"r":212,"g":178,"b":192},"luminance":124.15493258022411},{"name":"King Creek Falls","hex":"#5f686f","rgb":{"r":95,"g":104,"b":111},"luminance":68.51150301226795},{"name":"King Ghidorah","hex":"#aa9977","rgb":{"r":170,"g":153,"b":119},"luminance":104.08525821171796},{"name":"King Kong","hex":"#161410","rgb":{"r":22,"g":20,"b":16},"luminance":13.580304120305994},{"name":"King Neptune","hex":"#7794c0","rgb":{"r":119,"g":148,"b":192},"luminance":96.39777736545588},{"name":"King of Waves","hex":"#c6dce7","rgb":{"r":198,"g":220,"b":231},"luminance":144.48354909815856},{"name":"King Tide","hex":"#2a7279","rgb":{"r":42,"g":114,"b":121},"luminance":69.46939271362604},{"name":"King Triton","hex":"#3c85be","rgb":{"r":60,"g":133,"b":190},"luminance":82.98240922629326},{"name":"King's Court","hex":"#706d5e","rgb":{"r":112,"g":109,"b":94},"luminance":73.00755501316284},{"name":"King's Ransom","hex":"#b59d77","rgb":{"r":181,"g":157,"b":119},"luminance":107.73199987933017},{"name":"King's Robe","hex":"#6274ab","rgb":{"r":98,"g":116,"b":171},"luminance":76.64948599958123},{"name":"Kingfisher Bright","hex":"#096872","rgb":{"r":9,"g":104,"b":114},"luminance":62.47396098375706},{"name":"Kingfisher Daisy","hex":"#583580","rgb":{"r":88,"g":53,"b":128},"luminance":43.2798120259319},{"name":"Kingfisher Sheen","hex":"#007fa2","rgb":{"r":0,"g":127,"b":162},"luminance":76.80247668532571},{"name":"Kings Yellow","hex":"#ead665","rgb":{"r":234,"g":214,"b":101},"luminance":144.24872712090044},{"name":"Kingston Aqua","hex":"#8fbcc4","rgb":{"r":143,"g":188,"b":196},"luminance":120.44028446080654},{"name":"Kinky Koala","hex":"#bb00bb","rgb":{"r":187,"g":0,"b":187},"luminance":59.83912343107977},{"name":"Kinlock","hex":"#7f7793","rgb":{"r":127,"g":119,"b":147},"luminance":81.25405160359696},{"name":"Kinsusutake Brown","hex":"#7d4e2d","rgb":{"r":125,"g":78,"b":45},"luminance":59.32592452714074},{"name":"Kirby Pink","hex":"#d74894","rgb":{"r":215,"g":72,"b":148},"luminance":78.76211846439885},{"name":"Kiri Mist","hex":"#c5c5d3","rgb":{"r":197,"g":197,"b":211},"luminance":131.98688058288218},{"name":"Kiriume Red","hex":"#8b352d","rgb":{"r":139,"g":53,"b":45},"luminance":52.16826566026515},{"name":"Kislev Flesh","hex":"#efcdcb","rgb":{"r":239,"g":205,"b":203},"luminance":141.85464007215273},{"name":"Kiss","hex":"#d28ca7","rgb":{"r":210,"g":140,"b":167},"luminance":105.15979243037711},{"name":"Kiss A Frog","hex":"#bec187","rgb":{"r":190,"g":193,"b":135},"luminance":127.66784591665984},{"name":"Kiss Candy","hex":"#aa854a","rgb":{"r":170,"g":133,"b":74},"luminance":93.54109277210738},{"name":"Kiss Me Kate","hex":"#e7eeec","rgb":{"r":231,"g":238,"b":236},"luminance":158.1522001522584},{"name":"Kissable","hex":"#fd8f79","rgb":{"r":253,"g":143,"b":121},"luminance":113.83687682820535},{"name":"Kite Brown","hex":"#95483f","rgb":{"r":149,"g":72,"b":63},"luminance":61.82732746124483},{"name":"Kitsilano Cookie","hex":"#d0c8b0","rgb":{"r":208,"g":200,"b":176},"luminance":134.36208155577225},{"name":"Kitsurubami Brown","hex":"#bb8141","rgb":{"r":187,"g":129,"b":65},"luminance":94.42004235330548},{"name":"Kittiwake Gull","hex":"#ccccbb","rgb":{"r":204,"g":204,"b":187},"luminance":136.0681911542885},{"name":"Kiwi","hex":"#7aab55","rgb":{"r":122,"g":171,"b":85},"luminance":107.23843859829365},{"name":"Kiwi Fruit","hex":"#9daa4d","rgb":{"r":157,"g":170,"b":77},"luminance":110.62885081659304},{"name":"Kiwi Green","hex":"#8ee53f","rgb":{"r":142,"g":229,"b":63},"luminance":141.15171205833815},{"name":"Kiwi Kiss","hex":"#eef9c1","rgb":{"r":238,"g":249,"b":193},"luminance":164.04798327623536},{"name":"Kiwi Pulp","hex":"#9cef43","rgb":{"r":156,"g":239,"b":67},"luminance":148.0409660499417},{"name":"Knapsack","hex":"#95896c","rgb":{"r":149,"g":137,"b":108},"luminance":92.75555242679543},{"name":"Knarloc Green","hex":"#4b5b40","rgb":{"r":75,"g":91,"b":64},"luminance":58.39082230967466},{"name":"Knight Elf","hex":"#926cac","rgb":{"r":146,"g":108,"b":172},"luminance":79.43046138604508},{"name":"Knight Rider","hex":"#0f0707","rgb":{"r":15,"g":7,"b":7},"luminance":6.134811325542131},{"name":"Knight's Armor","hex":"#5c5d5d","rgb":{"r":92,"g":93,"b":93},"luminance":62.042483420636856},{"name":"Knight's Tale","hex":"#aa91ae","rgb":{"r":170,"g":145,"b":174},"luminance":101.10251738211072},{"name":"Knighthood","hex":"#3c3f52","rgb":{"r":60,"g":63,"b":82},"luminance":42.1523791143513},{"name":"Knit Cardigan","hex":"#6d6c5f","rgb":{"r":109,"g":108,"b":95},"luminance":72.1007281308587},{"name":"Knock On Wood","hex":"#9f9b84","rgb":{"r":159,"g":155,"b":132},"luminance":103.75383949522062},{"name":"Knot","hex":"#988266","rgb":{"r":152,"g":130,"b":102},"luminance":89.57648791954281},{"name":"Kōbai Red","hex":"#db5a6b","rgb":{"r":219,"g":90,"b":107},"luminance":85.01506610595558},{"name":"Kobe","hex":"#882d17","rgb":{"r":136,"g":45,"b":23},"luminance":48.56117796141275},{"name":"Kobi","hex":"#e093ab","rgb":{"r":224,"g":147,"b":171},"luminance":110.95761412809848},{"name":"Kobicha","hex":"#6b4423","rgb":{"r":107,"g":68,"b":35},"luminance":51.31042004310625},{"name":"Kobold Skin","hex":"#f0d2cf","rgb":{"r":240,"g":210,"b":207},"luminance":144.57474227540575},{"name":"Kobra Khan","hex":"#00aa22","rgb":{"r":0,"g":170,"b":34},"luminance":99.86524658758921},{"name":"Kodama White","hex":"#e8f5fc","rgb":{"r":232,"g":245,"b":252},"luminance":162.2343108993902},{"name":"Koeksister","hex":"#e97551","rgb":{"r":233,"g":117,"b":81},"luminance":98.26272276911526},{"name":"Kofta Brown","hex":"#883322","rgb":{"r":136,"g":51,"b":34},"luminance":50.64393587587758},{"name":"Köfte Brown","hex":"#773644","rgb":{"r":119,"g":54,"b":68},"luminance":48.27902514550184},{"name":"Kogane Gold","hex":"#e5b321","rgb":{"r":229,"g":179,"b":33},"luminance":125.47017898289616},{"name":"Kohaku Amber","hex":"#ca6924","rgb":{"r":202,"g":105,"b":36},"luminance":86.39232862355314},{"name":"Koi","hex":"#d15837","rgb":{"r":209,"g":88,"b":55},"luminance":81.31900341863518},{"name":"Koi Pond","hex":"#797f63","rgb":{"r":121,"g":127,"b":99},"luminance":83.62922478416262},{"name":"Koji Orange","hex":"#f6ad49","rgb":{"r":246,"g":173,"b":73},"luminance":125.66643227608556},{"name":"Koke Moss","hex":"#8b7d3a","rgb":{"r":139,"g":125,"b":58},"luminance":84.5867950096231},{"name":"Kokiake Brown","hex":"#7b3b3a","rgb":{"r":123,"g":59,"b":58},"luminance":50.948120298986495},{"name":"Kokimurasaki Purple","hex":"#3a243b","rgb":{"r":58,"g":36,"b":59},"luminance":28.152184000535375},{"name":"Kokoda","hex":"#7b785a","rgb":{"r":123,"g":120,"b":90},"luminance":80.12246207525078},{"name":"Kokushoku Black","hex":"#171412","rgb":{"r":23,"g":20,"b":18},"luminance":13.759775906605455},{"name":"Komatsuna Green","hex":"#7b8d42","rgb":{"r":123,"g":141,"b":66},"luminance":90.88198167953865},{"name":"Kombu","hex":"#7e726d","rgb":{"r":126,"g":114,"b":109},"luminance":77.7930233118626},{"name":"Kombu Green","hex":"#3a4032","rgb":{"r":58,"g":64,"b":50},"luminance":41.76828447518523},{"name":"Kombucha","hex":"#d89f66","rgb":{"r":216,"g":159,"b":102},"luminance":114.09361213056583},{"name":"Kommando Khaki","hex":"#9d907e","rgb":{"r":157,"g":144,"b":126},"luminance":97.74943748687252},{"name":"Komorebi","hex":"#bbc5b2","rgb":{"r":187,"g":197,"b":178},"luminance":130.04002135496594},{"name":"Kon","hex":"#192236","rgb":{"r":25,"g":34,"b":54},"luminance":22.183185636873706},{"name":"Kona","hex":"#574b50","rgb":{"r":87,"g":75,"b":80},"luminance":51.94276844759047},{"name":"Konjō Blue","hex":"#003171","rgb":{"r":0,"g":49,"b":113},"luminance":31.51596568407828},{"name":"Konkikyō Blue","hex":"#191f45","rgb":{"r":25,"g":31,"b":69},"luminance":21.18679753997758},{"name":"Koopa Green Shell","hex":"#58d854","rgb":{"r":88,"g":216,"b":84},"luminance":129.846957546182},{"name":"Kopi Luwak","hex":"#833d3e","rgb":{"r":131,"g":61,"b":62},"luminance":53.53791585409353},{"name":"Kōrainando Green","hex":"#203838","rgb":{"r":32,"g":56,"b":56},"luminance":34.826289839717354},{"name":"Korichnewyi Brown","hex":"#8d4512","rgb":{"r":141,"g":69,"b":18},"luminance":58.49858967530756},{"name":"Korila","hex":"#d7e9c8","rgb":{"r":215,"g":233,"b":200},"luminance":152.83555759704612},{"name":"Korma","hex":"#804e2c","rgb":{"r":128,"g":78,"b":44},"luminance":59.88542423662038},{"name":"Koromiko","hex":"#feb552","rgb":{"r":254,"g":181,"b":82},"luminance":130.9335901478303},{"name":"Kōrozen","hex":"#592b1f","rgb":{"r":89,"g":43,"b":31},"luminance":36.84755837229925},{"name":"Kosher Khaki","hex":"#888877","rgb":{"r":136,"g":136,"b":119},"luminance":90.61316392224695},{"name":"Kournikova","hex":"#f9d054","rgb":{"r":249,"g":208,"b":84},"luminance":143.32510035928806},{"name":"Kowloon","hex":"#e1d956","rgb":{"r":225,"g":217,"b":86},"luminance":144.38647333458906},{"name":"Kraft Paper","hex":"#d5b59c","rgb":{"r":213,"g":181,"b":156},"luminance":125.14283692644977},{"name":"Krasnyi Red","hex":"#eb2e28","rgb":{"r":235,"g":46,"b":40},"luminance":75.41267684547472},{"name":"Krieg Khaki","hex":"#c0bd81","rgb":{"r":192,"g":189,"b":129},"luminance":125.77875078486032},{"name":"Krishna Blue","hex":"#01abfd","rgb":{"r":1,"g":171,"b":253},"luminance":104.43894146342157},{"name":"KSU Purple","hex":"#512888","rgb":{"r":81,"g":40,"b":136},"luminance":37.124713830546895},{"name":"KU Crimson","hex":"#e8000d","rgb":{"r":232,"g":0,"b":13},"luminance":69.38382915348502},{"name":"Kuchinashi Yellow","hex":"#ffdb4f","rgb":{"r":255,"g":219,"b":79},"luminance":149.73403711247488},{"name":"Kul Sharif Blue","hex":"#87d3f8","rgb":{"r":135,"g":211,"b":248},"luminance":133.30114649919557},{"name":"Kumera","hex":"#886221","rgb":{"r":136,"g":98,"b":33},"luminance":70.54753160812928},{"name":"Kumquat","hex":"#fbaa4c","rgb":{"r":251,"g":170,"b":76},"luminance":125.16174094746366},{"name":"Kundalini Bliss","hex":"#d2ccda","rgb":{"r":210,"g":204,"b":218},"luminance":137.47650529454114},{"name":"Kurenai Red","hex":"#d7003a","rgb":{"r":215,"g":0,"b":58},"luminance":64.62414230765465},{"name":"Kuretake Black Manga","hex":"#001122","rgb":{"r":0,"g":17,"b":34},"luminance":10.70531723023657},{"name":"Kuri Black","hex":"#554738","rgb":{"r":85,"g":71,"b":56},"luminance":49.23058002908355},{"name":"Kuro Brown","hex":"#583822","rgb":{"r":88,"g":56,"b":34},"luminance":42.28372150130591},{"name":"Kuro Green","hex":"#1b2b1b","rgb":{"r":27,"g":43,"b":27},"luminance":26.678746109965513},{"name":"Kurobeni","hex":"#23191e","rgb":{"r":35,"g":25,"b":30},"luminance":18.345796521274295},{"name":"Kuroi Black","hex":"#14151d","rgb":{"r":20,"g":21,"b":29},"luminance":14.094146480010771},{"name":"Kurumizome Brown","hex":"#9f7462","rgb":{"r":159,"g":116,"b":98},"luminance":83.79427623053975},{"name":"Kuta Surf","hex":"#5789a5","rgb":{"r":87,"g":137,"b":165},"luminance":86.58930551748293},{"name":"Kuwanomi Purple","hex":"#55295b","rgb":{"r":85,"g":41,"b":91},"luminance":36.5070211055353},{"name":"Kuwazome Red","hex":"#59292c","rgb":{"r":89,"g":41,"b":44},"luminance":36.228801608664895},{"name":"Kvass","hex":"#c7610f","rgb":{"r":199,"g":97,"b":15},"luminance":82.37319237470403},{"name":"Kyo Purple","hex":"#9d5b8b","rgb":{"r":157,"g":91,"b":139},"luminance":72.85682434748306},{"name":"Kyoto House","hex":"#503000","rgb":{"r":80,"g":48,"b":0},"luminance":36.96015930701598},{"name":"Kyuri Green","hex":"#4b5d16","rgb":{"r":75,"g":93,"b":22},"luminance":59.07070314462152},{"name":"La Grange","hex":"#7a7a60","rgb":{"r":122,"g":122,"b":96},"luminance":81.11091551696356},{"name":"Là Jiāo Hóng Red","hex":"#fc2647","rgb":{"r":252,"g":38,"b":71},"luminance":78.99614912133374},{"name":"La Luna","hex":"#ffffe5","rgb":{"r":255,"g":255,"b":229},"luminance":170.001242601341},{"name":"La Minute","hex":"#f5e5dc","rgb":{"r":245,"g":229,"b":220},"luminance":155.12847692799667},{"name":"La Palma","hex":"#428929","rgb":{"r":66,"g":137,"b":41},"luminance":82.93667821295955},{"name":"La Paz Siesta","hex":"#c1e5ea","rgb":{"r":193,"g":229,"b":234},"luminance":148.698519676559},{"name":"La Pineta","hex":"#577e88","rgb":{"r":87,"g":126,"b":136},"luminance":79.9213840533308},{"name":"La Rioja","hex":"#bac00e","rgb":{"r":186,"g":192,"b":14},"luminance":125.6887259383275},{"name":"La Salle Green","hex":"#087830","rgb":{"r":8,"g":120,"b":48},"luminance":70.69270151861505},{"name":"La Terra","hex":"#ea936e","rgb":{"r":234,"g":147,"b":110},"luminance":111.79572566516127},{"name":"La Vie en Rose","hex":"#d2a5a3","rgb":{"r":210,"g":165,"b":163},"luminance":116.91349729180116},{"name":"La-De-Dah","hex":"#c3b1be","rgb":{"r":195,"g":177,"b":190},"luminance":121.09347970060155},{"name":"Labrador","hex":"#f2ecd9","rgb":{"r":242,"g":236,"b":217},"luminance":158.23641752769808},{"name":"Labyrinth Walk","hex":"#c9a487","rgb":{"r":201,"g":164,"b":135},"luminance":114.52628399192912},{"name":"Lace Veil","hex":"#ecebea","rgb":{"r":236,"g":235,"b":234},"luminance":157.2250301224331},{"name":"Lace Wisteria","hex":"#c2bbc0","rgb":{"r":194,"g":187,"b":192},"luminance":126.06749755983894},{"name":"Laced Green","hex":"#ccee99","rgb":{"r":204,"g":238,"b":153},"luminance":153.43566018367437},{"name":"Lacey","hex":"#caaeab","rgb":{"r":202,"g":174,"b":171},"luminance":120.2501787275179},{"name":"Lacrosse","hex":"#2e5c58","rgb":{"r":46,"g":92,"b":88},"luminance":56.62371902303839},{"name":"Lacustral","hex":"#19504c","rgb":{"r":25,"g":80,"b":76},"luminance":48.334067912808656},{"name":"Lacy Mist","hex":"#a78490","rgb":{"r":167,"g":132,"b":144},"luminance":93.62990868841001},{"name":"Lady Fern","hex":"#8fa174","rgb":{"r":143,"g":161,"b":116},"luminance":104.56867730826472},{"name":"Lady Fingers","hex":"#ccbbc0","rgb":{"r":204,"g":187,"b":192},"luminance":127.47089832977564},{"name":"Lady in Red","hex":"#b34b47","rgb":{"r":179,"g":75,"b":71},"luminance":69.77256553975924},{"name":"Lady Luck","hex":"#47613c","rgb":{"r":71,"g":97,"b":60},"luminance":61.15149844443715},{"name":"Lady of the Sea","hex":"#0000cc","rgb":{"r":0,"g":0,"b":204},"luminance":23.256},{"name":"Lady Pink","hex":"#f3d2cf","rgb":{"r":243,"g":210,"b":207},"luminance":145.02206091833062},{"name":"Ladylike","hex":"#ffc3bf","rgb":{"r":255,"g":195,"b":191},"luminance":139.2466995156438},{"name":"Lager","hex":"#f6f513","rgb":{"r":246,"g":245,"b":19},"luminance":161.54762980929186},{"name":"Lagoon","hex":"#4d9e9a","rgb":{"r":77,"g":158,"b":154},"luminance":97.16013678973492},{"name":"Lagoon Blue","hex":"#80a4b1","rgb":{"r":128,"g":164,"b":177},"luminance":105.5434767856356},{"name":"Lagoona Teal","hex":"#76c6d3","rgb":{"r":118,"g":198,"b":211},"luminance":123.82203970214672},{"name":"Laguna Beach","hex":"#e9d7c0","rgb":{"r":233,"g":215,"b":192},"luminance":145.8090444999898},{"name":"Lahar","hex":"#5f5855","rgb":{"r":95,"g":88,"b":85},"luminance":59.741798273905346},{"name":"Lahmian Medium","hex":"#e2dad1","rgb":{"r":226,"g":218,"b":209},"luminance":146.66022265086056},{"name":"Lahn Yellow","hex":"#fff80a","rgb":{"r":255,"g":248,"b":10},"luminance":164.33797918010308},{"name":"Laird","hex":"#79853c","rgb":{"r":121,"g":133,"b":60},"luminance":86.3179395143327},{"name":"Lake Baikal","hex":"#155084","rgb":{"r":21,"g":80,"b":132},"luminance":49.710257945418064},{"name":"Lake Blue","hex":"#008c96","rgb":{"r":0,"g":140,"b":150},"luminance":83.94023111714667},{"name":"Lake Green","hex":"#2e8b57","rgb":{"r":46,"g":139,"b":87},"luminance":83.33640794394728},{"name":"Lake Lucerne","hex":"#689db7","rgb":{"r":104,"g":157,"b":183},"luminance":99.4759545870257},{"name":"Lake Placid","hex":"#aeb9bc","rgb":{"r":174,"g":185,"b":188},"luminance":122.30662011927237},{"name":"Lake Red","hex":"#b74a70","rgb":{"r":183,"g":74,"b":112},"luminance":71.01993915091732},{"name":"Lake Reflection","hex":"#9dd8db","rgb":{"r":157,"g":216,"b":219},"luminance":137.4887547001572},{"name":"Lake Retba Pink","hex":"#ee55ee","rgb":{"r":238,"g":85,"b":238},"luminance":91.04771657213594},{"name":"Lake Thun","hex":"#44bbdd","rgb":{"r":68,"g":187,"b":221},"luminance":114.44370328244364},{"name":"Lake Water","hex":"#86aba5","rgb":{"r":134,"g":171,"b":165},"luminance":109.70251859004878},{"name":"Lake Winnipeg","hex":"#80a1b0","rgb":{"r":128,"g":161,"b":176},"luminance":103.91767476709627},{"name":"Lakelike","hex":"#306f73","rgb":{"r":48,"g":111,"b":115},"luminance":67.99475459916007},{"name":"Lakeville","hex":"#6c849b","rgb":{"r":108,"g":132,"b":155},"luminance":85.78328753317862},{"name":"Lāl Red","hex":"#d85525","rgb":{"r":216,"g":85,"b":37},"luminance":81.72145131481697},{"name":"Lama","hex":"#e0bb95","rgb":{"r":224,"g":187,"b":149},"luminance":129.70559792468478},{"name":"Lamb's Ears","hex":"#c8ccbc","rgb":{"r":200,"g":204,"b":188},"luminance":135.554247915733},{"name":"Lamb's Wool","hex":"#ffffe3","rgb":{"r":255,"g":255,"b":227},"luminance":169.9663794225199},{"name":"Lambent Lagoon","hex":"#3b5b92","rgb":{"r":59,"g":91,"b":146},"luminance":58.665181377031466},{"name":"Lambs Wool","hex":"#e6d1b2","rgb":{"r":230,"g":209,"b":178},"luminance":142.09924930484326},{"name":"Lamenters Yellow","hex":"#fffeb6","rgb":{"r":255,"g":254,"b":182},"luminance":168.742386889009},{"name":"Lamina","hex":"#bbd9bc","rgb":{"r":187,"g":217,"b":188},"luminance":140.7515677852293},{"name":"Laminated Wood","hex":"#948c7e","rgb":{"r":148,"g":140,"b":126},"luminance":94.4357792364737},{"name":"Lamp Post","hex":"#4a4f55","rgb":{"r":74,"g":79,"b":85},"luminance":52.28681578562611},{"name":"Lampoon","hex":"#805557","rgb":{"r":128,"g":85,"b":87},"luminance":63.66022096254458},{"name":"Lán Sè Blue","hex":"#4d4dff","rgb":{"r":77,"g":77,"b":255},"luminance":58.464288501614384},{"name":"Land Before Time","hex":"#bfbead","rgb":{"r":191,"g":190,"b":173},"luminance":126.84374665311648},{"name":"Land Light","hex":"#dfcaaa","rgb":{"r":223,"g":202,"b":170},"luminance":137.40887964392985},{"name":"Land Rush Bone","hex":"#c9bba1","rgb":{"r":201,"g":187,"b":161},"luminance":126.48317073033866},{"name":"Landjäger","hex":"#af403c","rgb":{"r":175,"g":64,"b":60},"luminance":64.77689286311902},{"name":"Langoustino","hex":"#ca6c56","rgb":{"r":202,"g":108,"b":86},"luminance":88.10839707996054},{"name":"Languid Lavender","hex":"#d6cadd","rgb":{"r":214,"g":202,"b":221},"luminance":137.07202233862313},{"name":"Lannister Red","hex":"#cd0101","rgb":{"r":205,"g":1,"b":1},"luminance":61.29791668564274},{"name":"Lantana","hex":"#da7e7a","rgb":{"r":218,"g":126,"b":122},"luminance":99.56155398546167},{"name":"Lantana Lime","hex":"#d7eccd","rgb":{"r":215,"g":236,"b":205},"luminance":154.49865096174787},{"name":"Lap Dog","hex":"#a6927f","rgb":{"r":166,"g":146,"b":127},"luminance":100.08985584963143},{"name":"Lapis Blue","hex":"#004b8d","rgb":{"r":0,"g":75,"b":141},"luminance":46.867623163544366},{"name":"Lapis Jewel","hex":"#165d95","rgb":{"r":22,"g":93,"b":149},"luminance":57.54973119832967},{"name":"Lapis Lazuli","hex":"#26619c","rgb":{"r":38,"g":97,"b":156},"luminance":60.724092590997195},{"name":"Larb Gai","hex":"#dfc6aa","rgb":{"r":223,"g":198,"b":170},"luminance":135.3879234089954},{"name":"Larch Bolete","hex":"#ffaa77","rgb":{"r":255,"g":170,"b":119},"luminance":126.31460913528569},{"name":"Laredo Road","hex":"#c7994f","rgb":{"r":199,"g":153,"b":79},"luminance":108.10870805813933},{"name":"Large Wild Convolvulus","hex":"#e4e2d6","rgb":{"r":228,"g":226,"b":214},"luminance":151.13501461937932},{"name":"Largest Black Slug","hex":"#551f2f","rgb":{"r":85,"g":31,"b":47},"luminance":31.713738316382695},{"name":"Larimar Blue","hex":"#1d78ab","rgb":{"r":29,"g":120,"b":171},"luminance":73.600243729216},{"name":"Lark","hex":"#b89b72","rgb":{"r":184,"g":155,"b":114},"luminance":107.11641562804462},{"name":"Larkspur","hex":"#3c7d90","rgb":{"r":60,"g":125,"b":144},"luminance":77.29954256656374},{"name":"Larkspur Bud","hex":"#b7c0ea","rgb":{"r":183,"g":192,"b":234},"luminance":128.0927424993313},{"name":"Las Palmas","hex":"#c6da36","rgb":{"r":198,"g":218,"b":54},"luminance":141.13139372938963},{"name":"Laser","hex":"#c6a95e","rgb":{"r":198,"g":169,"b":94},"luminance":116.02131127081782},{"name":"Laser Lemon","hex":"#ffff66","rgb":{"r":255,"g":255,"b":102},"luminance":168.38678580577516},{"name":"Last Light Blue","hex":"#475f94","rgb":{"r":71,"g":95,"b":148},"luminance":62.00862883502585},{"name":"Last Straw","hex":"#e3dbcd","rgb":{"r":227,"g":219,"b":205},"luminance":147.23713810720446},{"name":"Lasting Impression","hex":"#b36663","rgb":{"r":179,"g":102,"b":99},"luminance":81.09726945464934},{"name":"Lasting Thoughts","hex":"#d4e6b1","rgb":{"r":212,"g":230,"b":177},"luminance":150.50877159820286},{"name":"Later Gator","hex":"#008a51","rgb":{"r":0,"g":138,"b":81},"luminance":81.53060034122157},{"name":"Latigo Bay","hex":"#379190","rgb":{"r":55,"g":145,"b":144},"luminance":88.22973595109531},{"name":"Latin Charm","hex":"#292e44","rgb":{"r":41,"g":46,"b":68},"luminance":30.65101285439031},{"name":"Latte","hex":"#c5a582","rgb":{"r":197,"g":165,"b":130},"luminance":114.32448046678365},{"name":"Latte Froth","hex":"#f3f0e8","rgb":{"r":243,"g":240,"b":232},"luminance":160.7037981909575},{"name":"Lattice Work","hex":"#b9e1c2","rgb":{"r":185,"g":225,"b":194},"luminance":144.88848230967153},{"name":"Laughing Jack","hex":"#c9c3d2","rgb":{"r":201,"g":195,"b":210},"luminance":131.48098579642607},{"name":"Launderette Blue","hex":"#c0e7eb","rgb":{"r":192,"g":231,"b":235},"luminance":149.66605818621667},{"name":"Laura","hex":"#a6979a","rgb":{"r":166,"g":151,"b":154},"luminance":103.09347632609932},{"name":"Laura Potato","hex":"#800008","rgb":{"r":128,"g":0,"b":8},"luminance":38.282864678600006},{"name":"Laurel","hex":"#6e8d71","rgb":{"r":110,"g":141,"b":113},"luminance":89.98930110296445},{"name":"Laurel Green","hex":"#a9ba9d","rgb":{"r":169,"g":186,"b":157},"luminance":121.63235379207292},{"name":"Laurel Oak","hex":"#918c7e","rgb":{"r":145,"g":140,"b":126},"luminance":94.01879025492723},{"name":"Laurel Wreath","hex":"#52a786","rgb":{"r":82,"g":167,"b":134},"luminance":102.19673840685914},{"name":"Lauren's Lace","hex":"#efeae7","rgb":{"r":239,"g":234,"b":231},"luminance":157.0585057900399},{"name":"Lava","hex":"#cf1020","rgb":{"r":207,"g":16,"b":32},"luminance":62.70774287916923},{"name":"Lava Core","hex":"#764031","rgb":{"r":118,"g":64,"b":49},"luminance":51.83992229932448},{"name":"Lava Geyser","hex":"#dbd0ce","rgb":{"r":219,"g":208,"b":206},"luminance":140.52292636078994},{"name":"Lava Grey","hex":"#5e686d","rgb":{"r":94,"g":104,"b":109},"luminance":68.34625824432527},{"name":"Lava Pit","hex":"#e46f34","rgb":{"r":228,"g":111,"b":52},"luminance":94.48808081975207},{"name":"Lava Stone","hex":"#3c4151","rgb":{"r":60,"g":65,"b":81},"luminance":43.161491876440046},{"name":"Lavenbrun","hex":"#af9894","rgb":{"r":175,"g":152,"b":148},"luminance":104.80215734897826},{"name":"Lavendaire","hex":"#8f818b","rgb":{"r":143,"g":129,"b":139},"luminance":88.3924741932253},{"name":"Lavender","hex":"#b56edc","rgb":{"r":181,"g":110,"b":220},"luminance":87.90425166623056},{"name":"Lavender Ash","hex":"#9998a7","rgb":{"r":153,"g":152,"b":167},"luminance":102.05956902221368},{"name":"Lavender Aura","hex":"#9f99aa","rgb":{"r":159,"g":153,"b":170},"luminance":103.4492474694717},{"name":"Lavender Blossom","hex":"#b57edc","rgb":{"r":181,"g":126,"b":220},"luminance":95.01710374979865},{"name":"Lavender Blue","hex":"#ccccff","rgb":{"r":204,"g":204,"b":255},"luminance":137.4960378338227},{"name":"Lavender Blue Shadow","hex":"#8b88f8","rgb":{"r":139,"g":136,"b":248},"luminance":94.33859723888202},{"name":"Lavender Blush","hex":"#fff0f5","rgb":{"r":255,"g":240,"b":245},"luminance":162.60553288556943},{"name":"Lavender Bonnet","hex":"#9994c0","rgb":{"r":153,"g":148,"b":192},"luminance":100.59479076473094},{"name":"Lavender Breeze","hex":"#e4e1e3","rgb":{"r":228,"g":225,"b":227},"luminance":150.86715379100912},{"name":"Lavender Candy","hex":"#fcb4d5","rgb":{"r":252,"g":180,"b":213},"luminance":132.02640731308264},{"name":"Lavender Cloud","hex":"#b8abb1","rgb":{"r":184,"g":171,"b":177},"luminance":116.23017710130188},{"name":"Lavender Cream","hex":"#c79fef","rgb":{"r":199,"g":159,"b":239},"luminance":113.99018556875849},{"name":"Lavender Crystal","hex":"#936a98","rgb":{"r":147,"g":106,"b":152},"luminance":78.12619968358885},{"name":"Lavender Dream","hex":"#b4aecc","rgb":{"r":180,"g":174,"b":204},"luminance":117.76928708283836},{"name":"Lavender Dust","hex":"#c4c3d0","rgb":{"r":196,"g":195,"b":208},"luminance":130.76285399531474},{"name":"Lavender Earl","hex":"#af92bd","rgb":{"r":175,"g":146,"b":189},"luminance":102.69843496860115},{"name":"Lavender Elan","hex":"#9d9399","rgb":{"r":157,"g":147,"b":153},"luminance":99.7680316233612},{"name":"Lavender Elegance","hex":"#786c75","rgb":{"r":120,"g":108,"b":117},"luminance":74.05625874968298},{"name":"Lavender Essence","hex":"#dfdad9","rgb":{"r":223,"g":218,"b":217},"luminance":146.4004375983897},{"name":"Lavender Fog","hex":"#d2c4d6","rgb":{"r":210,"g":196,"b":214},"luminance":133.321834745851},{"name":"Lavender Fragrance","hex":"#ddbbff","rgb":{"r":221,"g":187,"b":255},"luminance":131.38010694926382},{"name":"Lavender Frost","hex":"#bdabbe","rgb":{"r":189,"g":171,"b":190},"luminance":117.21002879446792},{"name":"Lavender Grey","hex":"#bdbbd7","rgb":{"r":189,"g":187,"b":215},"luminance":125.87083292804571},{"name":"Lavender Haze","hex":"#d3d0dd","rgb":{"r":211,"g":208,"b":221},"luminance":139.72255642164583},{"name":"Lavender Herb","hex":"#b18eaa","rgb":{"r":177,"g":142,"b":170},"luminance":100.61966828110694},{"name":"Lavender Illusion","hex":"#a99ba7","rgb":{"r":169,"g":155,"b":167},"luminance":105.80216269056129},{"name":"Lavender Indigo","hex":"#9457eb","rgb":{"r":148,"g":87,"b":235},"luminance":72.69103359424737},{"name":"Lavender Lake","hex":"#a198a2","rgb":{"r":161,"g":152,"b":162},"luminance":103.05024270228574},{"name":"Lavender Lily","hex":"#a5969c","rgb":{"r":165,"g":150,"b":156},"luminance":102.48422015608062},{"name":"Lavender Lustre","hex":"#8c9cc1","rgb":{"r":140,"g":156,"b":193},"luminance":103.0620142826638},{"name":"Lavender Magenta","hex":"#ee82ed","rgb":{"r":238,"g":130,"b":237},"luminance":107.78320216063355},{"name":"Lavender Mist","hex":"#e5e5fa","rgb":{"r":229,"g":229,"b":250},"luminance":153.52547270730025},{"name":"Lavender Mosaic","hex":"#857e86","rgb":{"r":133,"g":126,"b":134},"luminance":85.3530779116957},{"name":"Lavender Oil","hex":"#c0c0ca","rgb":{"r":192,"g":192,"b":202},"luminance":128.5618872916853},{"name":"Lavender Pearl","hex":"#ede5e8","rgb":{"r":237,"g":229,"b":232},"luminance":154.24203189144004},{"name":"Lavender Phlox","hex":"#a6badf","rgb":{"r":166,"g":186,"b":223},"luminance":122.59902595045361},{"name":"Lavender Pillow","hex":"#c5b9d3","rgb":{"r":197,"g":185,"b":211},"luminance":125.86116299319659},{"name":"Lavender Pink","hex":"#dd85d7","rgb":{"r":221,"g":133,"b":215},"luminance":105.17725696175955},{"name":"Lavender Princess","hex":"#e9d2ef","rgb":{"r":233,"g":210,"b":239},"luminance":144.1919841912164},{"name":"Lavender Purple","hex":"#967bb6","rgb":{"r":150,"g":123,"b":182},"luminance":87.4927791591969},{"name":"Lavender Rose","hex":"#fba0e3","rgb":{"r":251,"g":160,"b":227},"luminance":122.97556539817167},{"name":"Lavender Savor","hex":"#eeddff","rgb":{"r":238,"g":221,"b":255},"luminance":150.79187535474185},{"name":"Lavender Scent","hex":"#bfacb1","rgb":{"r":191,"g":172,"b":177},"luminance":117.73834915183753},{"name":"Lavender Sky","hex":"#dbd7f2","rgb":{"r":219,"g":215,"b":242},"luminance":144.83287309861666},{"name":"Lavender Soap","hex":"#f1bfe2","rgb":{"r":241,"g":191,"b":226},"luminance":135.74426273695693},{"name":"Lavender Sweater","hex":"#bd83be","rgb":{"r":189,"g":131,"b":190},"luminance":97.8560030350719},{"name":"Lavender Syrup","hex":"#e6e6f1","rgb":{"r":230,"g":230,"b":241},"luminance":153.98647237988146},{"name":"Lavender Tea","hex":"#d783ff","rgb":{"r":215,"g":131,"b":255},"luminance":104.35887472563125},{"name":"Lavender Tonic","hex":"#ccbbff","rgb":{"r":204,"g":187,"b":255},"luminance":128.89844947477064},{"name":"Lavender Twilight","hex":"#e7dfe3","rgb":{"r":231,"g":223,"b":227},"luminance":150.2506886706347},{"name":"Lavender Violet","hex":"#767ba5","rgb":{"r":118,"g":123,"b":165},"luminance":82.532539189098},{"name":"Lavender Vista","hex":"#e3d7e5","rgb":{"r":227,"g":215,"b":229},"luminance":145.65702657269918},{"name":"Lavender Water","hex":"#d2c9df","rgb":{"r":210,"g":201,"b":223},"luminance":136.05070508086314},{"name":"Lavendula","hex":"#bca4cb","rgb":{"r":188,"g":164,"b":203},"luminance":113.85459556820709},{"name":"Lavish Lavender","hex":"#c2aec3","rgb":{"r":194,"g":174,"b":195},"luminance":119.54513783504538},{"name":"Lawn Green","hex":"#4da409","rgb":{"r":77,"g":164,"b":9},"luminance":98.98807518585257},{"name":"Laylock","hex":"#ab9ba5","rgb":{"r":171,"g":155,"b":165},"luminance":106.04838973789276},{"name":"Lazy Afternoon","hex":"#97928b","rgb":{"r":151,"g":146,"b":139},"luminance":98.15477940986878},{"name":"Lazy Caterpillar","hex":"#e2e5c7","rgb":{"r":226,"g":229,"b":199},"luminance":152.15269633167858},{"name":"Lazy Daisy","hex":"#f6eba1","rgb":{"r":246,"g":235,"b":161},"luminance":157.4035681202939},{"name":"Lazy Lavender","hex":"#a3a0b3","rgb":{"r":163,"g":160,"b":179},"luminance":107.76208240842415},{"name":"Lazy Lichen","hex":"#6e6e5c","rgb":{"r":110,"g":110,"b":92},"luminance":73.21909002439185},{"name":"Lazy Lizard","hex":"#9c9c4b","rgb":{"r":156,"g":156,"b":75},"luminance":103.12224018125285},{"name":"Lazy Shell Red","hex":"#cc0011","rgb":{"r":204,"g":0,"b":17},"luminance":61.026779859337154},{"name":"Lazy Summer Day","hex":"#fef3c3","rgb":{"r":254,"g":243,"b":195},"luminance":163.1208836936583},{"name":"Le Corbusier Crush","hex":"#bf4e46","rgb":{"r":191,"g":78,"b":70},"luminance":73.63067347919615},{"name":"Le Max","hex":"#85b2a1","rgb":{"r":133,"g":178,"b":161},"luminance":113.29434143415989},{"name":"Lead","hex":"#212121","rgb":{"r":33,"g":33,"b":33},"luminance":22.062320231562225},{"name":"Lead Glass","hex":"#fffae5","rgb":{"r":255,"g":250,"b":229},"luminance":167.4227755145637},{"name":"Lead Grey","hex":"#8a7963","rgb":{"r":138,"g":121,"b":99},"luminance":82.9141795412582},{"name":"Lead Ore","hex":"#99aabb","rgb":{"r":153,"g":170,"b":187},"luminance":111.82705054234418},{"name":"Leadbelcher","hex":"#cacacb","rgb":{"r":202,"g":202,"b":203},"luminance":135.06762766851278},{"name":"Leadbelcher Metal","hex":"#888d8f","rgb":{"r":136,"g":141,"b":143},"luminance":93.64663575911308},{"name":"Leaf","hex":"#71aa34","rgb":{"r":113,"g":170,"b":52},"luminance":105.52130899965181},{"name":"Leaf Bud","hex":"#eff19d","rgb":{"r":239,"g":241,"b":157},"luminance":159.49898123185613},{"name":"Leaf Green","hex":"#5ca904","rgb":{"r":92,"g":169,"b":4},"luminance":102.94723507214752},{"name":"Leaf Print","hex":"#e1d38e","rgb":{"r":225,"g":211,"b":142},"luminance":141.87506270659406},{"name":"Leaf Tea","hex":"#697d4c","rgb":{"r":105,"g":125,"b":76},"luminance":80.27827567904033},{"name":"Leafy","hex":"#679b6a","rgb":{"r":103,"g":155,"b":106},"luminance":96.81295620938346},{"name":"Leafy Seadragon","hex":"#b6c406","rgb":{"r":182,"g":196,"b":6},"luminance":127.27430724227101},{"name":"Leamington Spa","hex":"#a0b7a8","rgb":{"r":160,"g":183,"b":168},"luminance":119.14166334662278},{"name":"Leap of Faith","hex":"#c4d3e3","rgb":{"r":196,"g":211,"b":227},"luminance":139.44409685963763},{"name":"Leapfrog","hex":"#41a94f","rgb":{"r":65,"g":169,"b":79},"luminance":101.48922341805557},{"name":"Leather","hex":"#906a54","rgb":{"r":144,"g":106,"b":84},"luminance":76.26989049421796},{"name":"Leather Bound","hex":"#916e52","rgb":{"r":145,"g":110,"b":82},"luminance":78.33470513763359},{"name":"Leather Brown","hex":"#97572b","rgb":{"r":151,"g":87,"b":43},"luminance":68.34108988010068},{"name":"Leather Chair","hex":"#a3754c","rgb":{"r":163,"g":117,"b":76},"luminance":84.65911118125445},{"name":"Leather Loafers","hex":"#867354","rgb":{"r":134,"g":115,"b":84},"luminance":79.08166131917058},{"name":"Leather Satchel","hex":"#7c4f3a","rgb":{"r":124,"g":79,"b":58},"luminance":59.739463079274486},{"name":"Leather Tan","hex":"#a48454","rgb":{"r":164,"g":132,"b":84},"luminance":92.19544092849709},{"name":"Lebanon Cedar","hex":"#3c341f","rgb":{"r":60,"g":52,"b":31},"luminance":35.58155887535002},{"name":"LeChuck's Beard","hex":"#3c351f","rgb":{"r":60,"g":53,"b":31},"luminance":36.08638354005566},{"name":"Leek","hex":"#98d98e","rgb":{"r":152,"g":217,"b":142},"luminance":136.20933040361075},{"name":"Leek Green","hex":"#979c84","rgb":{"r":151,"g":156,"b":132},"luminance":103.20031826016816},{"name":"Leek Powder","hex":"#b7b17a","rgb":{"r":183,"g":177,"b":122},"luminance":118.24713423165907},{"name":"Leek Soup","hex":"#7a9c58","rgb":{"r":122,"g":156,"b":88},"luminance":99.07934543586771},{"name":"Leery Lemon","hex":"#f5c71a","rgb":{"r":245,"g":199,"b":26},"luminance":137.91431140385683},{"name":"Legal Eagle","hex":"#6d758f","rgb":{"r":109,"g":117,"b":143},"luminance":77.74788438279205},{"name":"Legal Ribbon","hex":"#6f434a","rgb":{"r":111,"g":67,"b":74},"luminance":52.14830829470885},{"name":"Legendary","hex":"#c6baaf","rgb":{"r":198,"g":186,"b":175},"luminance":125.79184563396785},{"name":"Legendary Grey","hex":"#787976","rgb":{"r":120,"g":121,"b":118},"luminance":80.70418473040911},{"name":"Legendary Lilac","hex":"#ad969d","rgb":{"r":173,"g":150,"b":157},"luminance":103.67653270147493},{"name":"Legendary Purple","hex":"#4e4e63","rgb":{"r":78,"g":78,"b":99},"luminance":52.608433506425555},{"name":"Legion Blue","hex":"#1f495b","rgb":{"r":31,"g":73,"b":91},"luminance":45.05266294016371},{"name":"Lemon","hex":"#fff700","rgb":{"r":255,"g":247,"b":0},"luminance":163.8142550146354},{"name":"Lemon Blast","hex":"#fcecad","rgb":{"r":252,"g":236,"b":173},"luminance":158.92574810898324},{"name":"Lemon Caipirinha","hex":"#f7de9d","rgb":{"r":247,"g":222,"b":157},"luminance":150.85205536882816},{"name":"Lemon Candy","hex":"#fae8ab","rgb":{"r":250,"g":232,"b":171},"luminance":156.56838886569665},{"name":"Lemon Chiffon","hex":"#fffacd","rgb":{"r":255,"g":250,"b":205},"luminance":167.0180212581864},{"name":"Lemon Chiffon Pie","hex":"#fff7c4","rgb":{"r":255,"g":247,"b":196},"luminance":165.3310753669739},{"name":"Lemon Chrome","hex":"#ffc300","rgb":{"r":255,"g":195,"b":0},"luminance":137.53376403632672},{"name":"Lemon Curd","hex":"#ffee11","rgb":{"r":255,"g":238,"b":17},"luminance":159.16916254413098},{"name":"Lemon Curry","hex":"#cda323","rgb":{"r":205,"g":163,"b":35},"luminance":113.70070749999755},{"name":"Lemon Delicious","hex":"#fce699","rgb":{"r":252,"g":230,"b":153},"luminance":155.59320219084123},{"name":"Lemon Drop","hex":"#fdd878","rgb":{"r":253,"g":216,"b":120},"luminance":148.2761689314908},{"name":"Lemon Flesh","hex":"#f0e891","rgb":{"r":240,"g":232,"b":145},"luminance":154.81866927473573},{"name":"Lemon Gelato","hex":"#f8ec9e","rgb":{"r":248,"g":236,"b":158},"luminance":158.15835821100316},{"name":"Lemon Ginger","hex":"#968428","rgb":{"r":150,"g":132,"b":40},"luminance":89.64422098495808},{"name":"Lemon Glacier","hex":"#fdff00","rgb":{"r":253,"g":255,"b":0},"luminance":167.71424457689932},{"name":"Lemon Grass","hex":"#999a86","rgb":{"r":153,"g":154,"b":134},"luminance":102.4594680300459},{"name":"Lemon Green","hex":"#adf802","rgb":{"r":173,"g":248,"b":2},"luminance":154.49306226818084},{"name":"Lemon Ice","hex":"#fffee6","rgb":{"r":255,"g":254,"b":230},"luminance":169.50221836011468},{"name":"Lemon Icing","hex":"#f6ebc8","rgb":{"r":246,"g":235,"b":200},"luminance":157.98371416383398},{"name":"Lemon Juice","hex":"#ffffec","rgb":{"r":255,"g":255,"b":236},"luminance":170.12561378581415},{"name":"Lemon Lime","hex":"#bffe28","rgb":{"r":191,"g":254,"b":40},"luminance":159.72615654613367},{"name":"Lemon Lime Mojito","hex":"#cbba61","rgb":{"r":203,"g":186,"b":97},"luminance":125.40779201070401},{"name":"Lemon Meringue","hex":"#f6e199","rgb":{"r":246,"g":225,"b":153},"luminance":152.17825043349657},{"name":"Lemon Pepper","hex":"#ebeca7","rgb":{"r":235,"g":236,"b":167},"luminance":156.49514590874693},{"name":"Lemon Pie","hex":"#f1ff62","rgb":{"r":241,"g":255,"b":98},"luminance":166.50198884698045},{"name":"Lemon Popsicle","hex":"#faf2d1","rgb":{"r":250,"g":242,"b":209},"luminance":162.27932613860582},{"name":"Lemon Punch","hex":"#fecf24","rgb":{"r":254,"g":207,"b":36},"luminance":143.34948487176365},{"name":"Lemon Rose","hex":"#fbe9ac","rgb":{"r":251,"g":233,"b":172},"luminance":157.23591353758846},{"name":"Lemon Sachet","hex":"#faf0cf","rgb":{"r":250,"g":240,"b":207},"luminance":161.21911333337619},{"name":"Lemon Sherbet","hex":"#f1ffa8","rgb":{"r":241,"g":255,"b":168},"luminance":167.22708455869224},{"name":"Lemon Slice","hex":"#fffba8","rgb":{"r":255,"g":251,"b":168},"luminance":166.9978763278144},{"name":"Lemon Soap","hex":"#fffcc4","rgb":{"r":255,"g":252,"b":196},"luminance":167.91088153243672},{"name":"Lemon Sorbet","hex":"#fffac0","rgb":{"r":255,"g":250,"b":192},"luminance":166.8171066437732},{"name":"Lemon Splash","hex":"#f9f6de","rgb":{"r":249,"g":246,"b":222},"luminance":164.42440168357004},{"name":"Lemon Sponge Cake","hex":"#f7f0e1","rgb":{"r":247,"g":240,"b":225},"luminance":161.11909417880923},{"name":"Lemon Sugar","hex":"#f0f6dd","rgb":{"r":240,"g":246,"b":221},"luminance":163.20592158374646},{"name":"Lemon Tart","hex":"#ffdd66","rgb":{"r":255,"g":221,"b":102},"luminance":150.92251302572456},{"name":"Lemon Verbena","hex":"#f3e779","rgb":{"r":243,"g":231,"b":121},"luminance":154.4534249992534},{"name":"Lemon Zest","hex":"#f9d857","rgb":{"r":249,"g":216,"b":87},"luminance":147.36868523875754},{"name":"Lemonade","hex":"#f0e79d","rgb":{"r":240,"g":231,"b":157},"luminance":154.45511455759564},{"name":"Lemonade Stand","hex":"#f2ca3b","rgb":{"r":242,"g":202,"b":59},"luminance":139.07089097291353},{"name":"Lemonwood Place","hex":"#f9f3d7","rgb":{"r":249,"g":243,"b":215},"luminance":162.7579379999636},{"name":"Lemur","hex":"#695f4f","rgb":{"r":105,"g":95,"b":79},"luminance":64.62576333011471},{"name":"Lemures","hex":"#bfb9d4","rgb":{"r":191,"g":185,"b":212},"luminance":125.05360502600475},{"name":"Lens Flare Blue","hex":"#cee2e2","rgb":{"r":206,"g":226,"b":226},"luminance":148.51535535425285},{"name":"Lens Flare Green","hex":"#b0ff9d","rgb":{"r":176,"g":255,"b":157},"luminance":159.67223617460863},{"name":"Lens Flare Pink","hex":"#e4cbff","rgb":{"r":228,"g":203,"b":255},"luminance":140.3275824811359},{"name":"Lenticular Ore","hex":"#6fb5a8","rgb":{"r":111,"g":181,"b":168},"luminance":112.94571188849979},{"name":"Lentil Sprout","hex":"#aba44d","rgb":{"r":171,"g":164,"b":77},"luminance":109.35609607607616},{"name":"Lenurple","hex":"#ba93d8","rgb":{"r":186,"g":147,"b":216},"luminance":105.57011837163014},{"name":"Leopard","hex":"#d09800","rgb":{"r":208,"g":152,"b":0},"luminance":108.7601353437922},{"name":"Lepidolite Purple","hex":"#947e94","rgb":{"r":148,"g":126,"b":148},"luminance":87.82528868156369},{"name":"Leprechaun","hex":"#29906d","rgb":{"r":41,"g":144,"b":109},"luminance":86.31147861669385},{"name":"Leprechaun Green","hex":"#395549","rgb":{"r":57,"g":85,"b":73},"luminance":53.37818428908949},{"name":"Leprous Brown","hex":"#d99631","rgb":{"r":217,"g":150,"b":49},"luminance":109.51625260663369},{"name":"Lepton Gold","hex":"#d0a000","rgb":{"r":208,"g":160,"b":0},"luminance":112.64462376873563},{"name":"Leroy","hex":"#71635a","rgb":{"r":113,"g":99,"b":90},"luminance":67.9996304254663},{"name":"Les Cavaliers Beach","hex":"#0f63b3","rgb":{"r":15,"g":99,"b":179},"luminance":61.754682656459345},{"name":"Lester","hex":"#afd1c4","rgb":{"r":175,"g":209,"b":196},"luminance":135.23416154951383},{"name":"Let It Ring","hex":"#cfae74","rgb":{"r":207,"g":174,"b":116},"luminance":120.15734962539744},{"name":"Let it Snow","hex":"#d8f1f4","rgb":{"r":216,"g":241,"b":244},"luminance":157.98017280975483},{"name":"Leticiaz","hex":"#95be76","rgb":{"r":149,"g":190,"b":118},"luminance":120.8498605915621},{"name":"Letter Jacket","hex":"#b8860b","rgb":{"r":184,"g":134,"b":11},"luminance":95.99694649310467},{"name":"Lettuce Alone","hex":"#cedda2","rgb":{"r":206,"g":221,"b":162},"luminance":144.7894415660203},{"name":"Lettuce Green","hex":"#bed38e","rgb":{"r":190,"g":211,"b":142},"luminance":137.2223884539254},{"name":"Lettuce Mound","hex":"#92a772","rgb":{"r":146,"g":167,"b":114},"luminance":108.09372124688834},{"name":"Leukocyte White","hex":"#f2f1ed","rgb":{"r":242,"g":241,"b":237},"luminance":161.1786728354592},{"name":"Leverkaas","hex":"#edcdc2","rgb":{"r":237,"g":205,"b":194},"luminance":141.3902204892545},{"name":"Leviathan Purple Wash","hex":"#8b2a98","rgb":{"r":139,"g":42,"b":152},"luminance":51.33610835464644},{"name":"Lexaloffle Green","hex":"#00e436","rgb":{"r":0,"g":228,"b":54},"luminance":133.97750270847712},{"name":"Lián Hóng Lotus Pink","hex":"#f075e6","rgb":{"r":240,"g":117,"b":230},"luminance":102.73164576215062},{"name":"Liberace","hex":"#ccb8d2","rgb":{"r":204,"g":184,"b":210},"luminance":126.3303751280744},{"name":"Liberal Lilac","hex":"#9955bb","rgb":{"r":153,"g":85,"b":187},"luminance":70.97010749604371},{"name":"Liberated Lime","hex":"#d8ddcc","rgb":{"r":216,"g":221,"b":204},"luminance":146.76862444337345},{"name":"Liberator Gold","hex":"#e8c447","rgb":{"r":232,"g":196,"b":71},"luminance":134.58972830049103},{"name":"Liberty","hex":"#4d448a","rgb":{"r":77,"g":68,"b":138},"luminance":48.69128678726821},{"name":"Liberty Green","hex":"#16a74e","rgb":{"r":22,"g":167,"b":78},"luminance":98.65101413062108},{"name":"Library Red","hex":"#5b3530","rgb":{"r":91,"g":53,"b":48},"luminance":41.69132746747218},{"name":"Lich Grey","hex":"#a9a694","rgb":{"r":169,"g":166,"b":148},"luminance":111.05399456570663},{"name":"Liche Purple","hex":"#730061","rgb":{"r":115,"g":0,"b":97},"luminance":36.11935200138563},{"name":"Lichen","hex":"#9bc2b1","rgb":{"r":155,"g":194,"b":177},"luminance":124.59217308081595},{"name":"Lichen Blue","hex":"#5d89b3","rgb":{"r":93,"g":137,"b":179},"luminance":87.50342648148127},{"name":"Lichen Green","hex":"#9da693","rgb":{"r":157,"g":166,"b":147},"luminance":109.4505330137775},{"name":"Lichtenstein Yellow","hex":"#fdff38","rgb":{"r":253,"g":255,"b":56},"luminance":167.83570326363815},{"name":"Lickedy Lick","hex":"#b4496c","rgb":{"r":180,"g":73,"b":108},"luminance":69.88838204594524},{"name":"Lickety Split","hex":"#c3d997","rgb":{"r":195,"g":217,"b":151},"luminance":141.14249700922824},{"name":"Licorice","hex":"#1a1110","rgb":{"r":26,"g":17,"b":16},"luminance":12.780551357433684},{"name":"Liddell","hex":"#c99c59","rgb":{"r":201,"g":156,"b":89},"luminance":110.0011922708113},{"name":"Lieonhead","hex":"#d5b60a","rgb":{"r":213,"g":182,"b":10},"luminance":124.38181991352272},{"name":"Life Aquatic","hex":"#a2b0a8","rgb":{"r":162,"g":176,"b":168},"luminance":115.69964689660897},{"name":"Life Lesson","hex":"#c5cabe","rgb":{"r":197,"g":202,"b":190},"luminance":134.15853489435548},{"name":"Lifeboat Blue","hex":"#81b6bc","rgb":{"r":129,"g":182,"b":188},"luminance":115.58787229203588},{"name":"Lifeguard Red","hex":"#e50000","rgb":{"r":229,"g":0,"b":0},"luminance":68.471},{"name":"Lifeless Planet","hex":"#e6d699","rgb":{"r":230,"g":214,"b":153},"luminance":144.26856271551333},{"name":"Lifeline","hex":"#990033","rgb":{"r":153,"g":0,"b":51},"luminance":46.11497159274849},{"name":"Ligado","hex":"#cdd6c2","rgb":{"r":205,"g":214,"b":194},"luminance":141.5135202198009},{"name":"Light Air","hex":"#cce7e8","rgb":{"r":204,"g":231,"b":232},"luminance":151.0183933466384},{"name":"Light Amourette","hex":"#d4d3e0","rgb":{"r":212,"g":211,"b":224},"luminance":141.45911879055376},{"name":"Light Angel Kiss","hex":"#dad4e4","rgb":{"r":218,"g":212,"b":228},"luminance":142.86562331085807},{"name":"Light Angora Blue","hex":"#c9d4e1","rgb":{"r":201,"g":212,"b":225},"luminance":140.55647063369227},{"name":"Light Aroma","hex":"#decfd2","rgb":{"r":222,"g":207,"b":210},"luminance":140.51191965452608},{"name":"Light Ballet Blue","hex":"#c2d1e2","rgb":{"r":194,"g":209,"b":226},"luminance":138.12891884395532},{"name":"Light Bassinet","hex":"#ded0d8","rgb":{"r":222,"g":208,"b":216},"luminance":141.13756932865184},{"name":"Light Bathing","hex":"#abd5dc","rgb":{"r":171,"g":213,"b":220},"luminance":137.38970850103726},{"name":"Light Beige","hex":"#e5deca","rgb":{"r":229,"g":222,"b":202},"luminance":148.9976685086045},{"name":"Light Bleaches","hex":"#d5d4d0","rgb":{"r":213,"g":212,"b":208},"luminance":141.7906980341094},{"name":"Light Blossom Time","hex":"#ecddd6","rgb":{"r":236,"g":221,"b":214},"luminance":149.6781127653606},{"name":"Light Blue","hex":"#add8e6","rgb":{"r":173,"g":216,"b":230},"luminance":139.4251849308438},{"name":"Light Blue Bayou","hex":"#cdd2de","rgb":{"r":205,"g":210,"b":222},"luminance":139.97522919788344},{"name":"Light Blue Cloud","hex":"#d2d3e1","rgb":{"r":210,"g":211,"b":225},"luminance":141.21282891083231},{"name":"Light Blue Glint","hex":"#a8d3e1","rgb":{"r":168,"g":211,"b":225},"luminance":136.094572900612},{"name":"Light Blue Grey","hex":"#b7c9e2","rgb":{"r":183,"g":201,"b":226},"luminance":132.58456152207162},{"name":"Light Blue Ice","hex":"#b7d2e3","rgb":{"r":183,"g":210,"b":227},"luminance":137.32848893437952},{"name":"Light Blue Mist","hex":"#bed7f0","rgb":{"r":190,"g":215,"b":240},"luminance":141.08028822269964},{"name":"Light Blue Sloth","hex":"#c6dde4","rgb":{"r":198,"g":221,"b":228},"luminance":144.9467329642169},{"name":"Light Blue Veil","hex":"#c0d8eb","rgb":{"r":192,"g":216,"b":235},"luminance":141.73776429731066},{"name":"Light Bluish Water","hex":"#a4dbe4","rgb":{"r":164,"g":219,"b":228},"luminance":140.02138111374276},{"name":"Light Blush","hex":"#e9c4cc","rgb":{"r":233,"g":196,"b":204},"luminance":136.49650225921542},{"name":"Light Bobby Blue","hex":"#add2e3","rgb":{"r":173,"g":210,"b":227},"luminance":136.16477633000392},{"name":"Light Breeze","hex":"#cfe0f2","rgb":{"r":207,"g":224,"b":242},"luminance":147.92205831788579},{"name":"Light Bright Spark","hex":"#94d0e9","rgb":{"r":148,"g":208,"b":233},"luminance":132.55645048054055},{"name":"Light Brown","hex":"#b5651d","rgb":{"r":181,"g":101,"b":29},"luminance":80.34142247931635},{"name":"Light Brume","hex":"#d6d5d2","rgb":{"r":214,"g":213,"b":210},"luminance":142.4783589075899},{"name":"Light Budgie Blue","hex":"#9ed6e8","rgb":{"r":158,"g":214,"b":232},"luminance":136.78883431040708},{"name":"Light Bunny Soft","hex":"#deced1","rgb":{"r":222,"g":206,"b":209},"luminance":139.98516794289313},{"name":"Light Cameo Blue","hex":"#c6d4e1","rgb":{"r":198,"g":212,"b":225},"luminance":140.17527756348477},{"name":"Light Candela","hex":"#c9d2df","rgb":{"r":201,"g":210,"b":223},"luminance":139.47638074240385},{"name":"Light Cargo River","hex":"#dbd9c9","rgb":{"r":219,"g":217,"b":201},"luminance":145.0455873096455},{"name":"Light Carob","hex":"#f9dbcf","rgb":{"r":249,"g":219,"b":207},"luminance":150.41838589082118},{"name":"Light Carolina","hex":"#d8f3d7","rgb":{"r":216,"g":243,"b":215},"luminance":158.48750120119882},{"name":"Light Carrot Flower","hex":"#d8decf","rgb":{"r":216,"g":222,"b":207},"luminance":147.34210958174856},{"name":"Light Celery Stick","hex":"#d8f2dc","rgb":{"r":216,"g":242,"b":220},"luminance":158.0488480565423},{"name":"Light Chintz","hex":"#e0d5c9","rgb":{"r":224,"g":213,"b":201},"luminance":143.67876298534867},{"name":"Light Christobel","hex":"#dfd3ca","rgb":{"r":223,"g":211,"b":202},"luminance":142.53654816221697},{"name":"Light Cipollino","hex":"#d5dad1","rgb":{"r":213,"g":218,"b":209},"luminance":144.91034953032167},{"name":"Light Continental Waters","hex":"#afd5d8","rgb":{"r":175,"g":213,"b":216},"luminance":137.75702509128163},{"name":"Light Cool Crayon","hex":"#c3ece9","rgb":{"r":195,"g":236,"b":233},"luminance":152.6306911895507},{"name":"Light Cornflower Blue","hex":"#93ccea","rgb":{"r":147,"g":204,"b":234},"luminance":130.31906494830292},{"name":"Light Crushed Almond","hex":"#ddd7d1","rgb":{"r":221,"g":215,"b":209},"luminance":144.4361954012913},{"name":"Light Cuddle","hex":"#cbd7ed","rgb":{"r":203,"g":215,"b":237},"luminance":142.62468284977885},{"name":"Light Curd","hex":"#f9e9c9","rgb":{"r":249,"g":233,"b":201},"luminance":157.39856809386796},{"name":"Light Cyan","hex":"#e0ffff","rgb":{"r":224,"g":255,"b":255},"luminance":166.54263328349293},{"name":"Light Daly Waters","hex":"#c2e4e7","rgb":{"r":194,"g":228,"b":231},"luminance":148.22365023166847},{"name":"Light Dante Peak","hex":"#c6dedf","rgb":{"r":198,"g":222,"b":223},"luminance":145.37157041182434},{"name":"Light Daydreamer","hex":"#e2d9d2","rgb":{"r":226,"g":217,"b":210},"luminance":146.166954941943},{"name":"Light Dedication","hex":"#fce9d5","rgb":{"r":252,"g":233,"b":213},"luminance":158.02924751133884},{"name":"Light Delphin","hex":"#9ed1e3","rgb":{"r":158,"g":209,"b":227},"luminance":133.98729767033888},{"name":"Light Deluxe Days","hex":"#a4d4ec","rgb":{"r":164,"g":212,"b":236},"luminance":136.43556592032738},{"name":"Light Detroit","hex":"#cddbdc","rgb":{"r":205,"g":219,"b":220},"luminance":144.60967199326606},{"name":"Light Dewpoint","hex":"#c4dadd","rgb":{"r":196,"g":218,"b":221},"luminance":142.98413760973628},{"name":"Light Drizzle","hex":"#a7aea5","rgb":{"r":167,"g":174,"b":165},"luminance":115.23580881392728},{"name":"Light Dry Lichen","hex":"#d4e3d7","rgb":{"r":212,"g":227,"b":215},"luminance":149.57965986389993},{"name":"Light Duck Egg Cream","hex":"#d5ebdd","rgb":{"r":213,"g":235,"b":221},"luminance":154.0116704344187},{"name":"Light Easter Rabbit","hex":"#d4ced1","rgb":{"r":212,"g":206,"b":209},"luminance":138.59237678891287},{"name":"Light Eggshell Pink","hex":"#d9d2c9","rgb":{"r":217,"g":210,"b":201},"luminance":141.17488439874847},{"name":"Light Ellen","hex":"#ead5c7","rgb":{"r":234,"g":213,"b":199},"luminance":145.06083797152144},{"name":"Light Elusive Dream","hex":"#d8cdd3","rgb":{"r":216,"g":205,"b":211},"luminance":138.67299736069745},{"name":"Light Enchanted","hex":"#d6eadb","rgb":{"r":214,"g":234,"b":219},"luminance":153.57320572287344},{"name":"Light Fairy Pink","hex":"#f3ded7","rgb":{"r":243,"g":222,"b":215},"luminance":151.200259077159},{"name":"Light Favourite Lady","hex":"#ead3e0","rgb":{"r":234,"g":211,"b":224},"luminance":144.52641592802334},{"name":"Light Featherbed","hex":"#c1d8eb","rgb":{"r":193,"g":216,"b":235},"luminance":141.8591315812979},{"name":"Light First Love","hex":"#fce6db","rgb":{"r":252,"g":230,"b":219},"luminance":156.61520475356153},{"name":"Light Fresh Lime","hex":"#e2f4d7","rgb":{"r":226,"g":244,"b":215},"luminance":160.253691252339},{"name":"Light Freshman","hex":"#ecf4d2","rgb":{"r":236,"g":244,"b":210},"luminance":161.45173173428643},{"name":"Light Frost","hex":"#ede8d7","rgb":{"r":237,"g":232,"b":215},"luminance":155.4618497413433},{"name":"Light Frosty Dawn","hex":"#d7efd5","rgb":{"r":215,"g":239,"b":213},"luminance":156.21876519163757},{"name":"Light Frozen Frappe","hex":"#e6d2dc","rgb":{"r":230,"g":210,"b":220},"luminance":143.3660078261231},{"name":"Light Gentle Calm","hex":"#d2d9cd","rgb":{"r":210,"g":217,"b":205},"luminance":143.92411417479698},{"name":"Light Ghost Town","hex":"#d4cfcc","rgb":{"r":212,"g":207,"b":204},"luminance":139.00833486161898},{"name":"Light Ghosting","hex":"#d7d3ca","rgb":{"r":215,"g":211,"b":202},"luminance":141.43339937228407},{"name":"Light Glaze","hex":"#c0b5aa","rgb":{"r":192,"g":181,"b":170},"luminance":122.30980284915842},{"name":"Light Green","hex":"#76ff7b","rgb":{"r":118,"g":255,"b":123},"luminance":154.42485302890853},{"name":"Light Green Alabaster","hex":"#d5d8c9","rgb":{"r":213,"g":216,"b":201},"luminance":143.72646460899256},{"name":"Light Green Ash","hex":"#d7ddcd","rgb":{"r":215,"g":221,"b":205},"luminance":146.6554214954224},{"name":"Light Green Frost","hex":"#dce0cd","rgb":{"r":220,"g":224,"b":205},"luminance":148.86994137165502},{"name":"Light Green Glint","hex":"#e5f4d5","rgb":{"r":229,"g":244,"b":213},"luminance":160.59935662698027},{"name":"Light Green Veil","hex":"#e8f4d2","rgb":{"r":232,"g":244,"b":210},"luminance":160.93260393096233},{"name":"Light Green Wash","hex":"#d4e6d9","rgb":{"r":212,"g":230,"b":217},"luminance":151.1876558717675},{"name":"Light Greenette","hex":"#e2f0d2","rgb":{"r":226,"g":240,"b":210},"luminance":158.0713240154583},{"name":"Light Gregorio Garden","hex":"#d7d4e4","rgb":{"r":215,"g":212,"b":228},"luminance":142.4586060053937},{"name":"Light Grey","hex":"#d8dcd6","rgb":{"r":216,"g":220,"b":214},"luminance":146.43564276500445},{"name":"Light Hindsight","hex":"#cdd6ea","rgb":{"r":205,"g":214,"b":234},"luminance":142.2974628199674},{"name":"Light Hint Of Lavender","hex":"#dccfce","rgb":{"r":220,"g":207,"b":206},"luminance":140.15328657223844},{"name":"Light Hog Bristle","hex":"#e5ddcb","rgb":{"r":229,"g":221,"b":203},"luminance":148.50227114088187},{"name":"Light Horizon Sky","hex":"#d0d2de","rgb":{"r":208,"g":210,"b":222},"luminance":140.3703409841267},{"name":"Light Iced Aniseed","hex":"#d8ded0","rgb":{"r":216,"g":222,"b":208},"luminance":147.36041054503073},{"name":"Light Iced Lavender","hex":"#d0d4e3","rgb":{"r":208,"g":212,"b":227},"luminance":141.50556485170466},{"name":"Light Image Tone","hex":"#ccd0da","rgb":{"r":204,"g":208,"b":218},"luminance":138.72839340236013},{"name":"Light Imagine","hex":"#aed4d8","rgb":{"r":174,"g":212,"b":216},"luminance":137.1107406004358},{"name":"Light Instant","hex":"#e2d9d4","rgb":{"r":226,"g":217,"b":212},"luminance":146.20447100208665},{"name":"Light Issey-San","hex":"#dbe4d1","rgb":{"r":219,"g":228,"b":209},"luminance":150.88908023114195},{"name":"Light Jellyfish Blue","hex":"#acd6db","rgb":{"r":172,"g":214,"b":219},"luminance":138.01457265086177},{"name":"Light Karma","hex":"#bce6e8","rgb":{"r":188,"g":230,"b":232},"luminance":148.6169093609472},{"name":"Light Katsura","hex":"#d6ead8","rgb":{"r":214,"g":234,"b":216},"luminance":153.5179785432312},{"name":"Light Kiri Mist","hex":"#d3d2dd","rgb":{"r":211,"g":210,"b":221},"luminance":140.7496090829385},{"name":"Light Lamb's Ears","hex":"#d6d9cb","rgb":{"r":214,"g":217,"b":203},"luminance":144.41319192165236},{"name":"Light Lavender","hex":"#efc0fe","rgb":{"r":239,"g":192,"b":254},"luminance":136.5551759289995},{"name":"Light Lavender Blush","hex":"#e3d2cf","rgb":{"r":227,"g":210,"b":207},"luminance":142.68532732204807},{"name":"Light Lavender Water","hex":"#ddd6e7","rgb":{"r":221,"g":214,"b":231},"luminance":144.35995192919674},{"name":"Light Ligado","hex":"#d9e0d0","rgb":{"r":217,"g":224,"b":208},"luminance":148.52998612064837},{"name":"Light Light Blush","hex":"#eed2d7","rgb":{"r":238,"g":210,"b":215},"luminance":144.4308251170781},{"name":"Light Light Lichen","hex":"#d3e7dc","rgb":{"r":211,"g":231,"b":220},"luminance":151.6435779385332},{"name":"Light Lilac","hex":"#dcc6d2","rgb":{"r":220,"g":198,"b":210},"luminance":135.67835153774533},{"name":"Light Lilac Crystal","hex":"#d7d2e2","rgb":{"r":215,"g":210,"b":226},"luminance":141.39249563184038},{"name":"Light Lime Sherbet","hex":"#d8e6ce","rgb":{"r":216,"g":230,"b":206},"luminance":151.49353587529734},{"name":"Light Limed White","hex":"#dbd5ce","rgb":{"r":219,"g":213,"b":206},"luminance":143.0804339453861},{"name":"Light Limpid Light","hex":"#dad1d7","rgb":{"r":218,"g":209,"b":215},"luminance":141.06931527798665},{"name":"Light Lip Gloss","hex":"#e7d9d4","rgb":{"r":231,"g":217,"b":212},"luminance":146.9014248603464},{"name":"Light Livingstone","hex":"#d8d7ca","rgb":{"r":216,"g":215,"b":202},"luminance":143.62828365262882},{"name":"Light Lost Lace","hex":"#d1f0dd","rgb":{"r":209,"g":240,"b":221},"luminance":156.1634948283369},{"name":"Light Lunette","hex":"#dcd5d3","rgb":{"r":220,"g":213,"b":211},"luminance":143.31208698850213},{"name":"Light Mahogany","hex":"#aa5511","rgb":{"r":170,"g":85,"b":17},"luminance":71.2527597290098},{"name":"Light Maiden's Blush","hex":"#f6ddce","rgb":{"r":246,"g":221,"b":206},"luminance":150.96616740515074},{"name":"Light Male","hex":"#e3dbd0","rgb":{"r":227,"g":219,"b":208},"luminance":147.29180860455207},{"name":"Light Marsh Fog","hex":"#d3e1d3","rgb":{"r":211,"g":225,"b":211},"luminance":148.33280979607983},{"name":"Light Marshmallow Magic","hex":"#f4dddb","rgb":{"r":244,"g":221,"b":219},"luminance":150.91379533031434},{"name":"Light Martian Moon","hex":"#d1efdd","rgb":{"r":209,"g":239,"b":221},"luminance":155.63414974227217},{"name":"Light Mauve","hex":"#c292a1","rgb":{"r":194,"g":146,"b":161},"luminance":105.10184658701291},{"name":"Light Meadow Lane","hex":"#cee1d9","rgb":{"r":206,"g":225,"b":217},"luminance":147.81608540683249},{"name":"Light Mint","hex":"#b6ffbb","rgb":{"r":182,"g":255,"b":187},"luminance":160.69030796224146},{"name":"Light Mint Green","hex":"#a6fbb2","rgb":{"r":166,"g":251,"b":178},"luminance":156.79123313820833},{"name":"Light Modesty","hex":"#ded5e2","rgb":{"r":222,"g":213,"b":226},"luminance":143.88388909464464},{"name":"Light Morality","hex":"#c4d9eb","rgb":{"r":196,"g":217,"b":235},"luminance":142.74993014709324},{"name":"Light Mosque","hex":"#d8cdd0","rgb":{"r":216,"g":205,"b":208},"luminance":138.6140837902123},{"name":"Light Mr Frosty","hex":"#b8d3e4","rgb":{"r":184,"g":211,"b":228},"luminance":137.9960172215126},{"name":"Light Mystified","hex":"#d6e4d4","rgb":{"r":214,"g":228,"b":212},"luminance":150.3009491520263},{"name":"Light Naked Pink","hex":"#e2d4e1","rgb":{"r":226,"g":212,"b":225},"luminance":143.91135157450228},{"name":"Light Nursery","hex":"#f4dcdc","rgb":{"r":244,"g":220,"b":220},"luminance":150.42846783770682},{"name":"Light Nut Milk","hex":"#e3d8d4","rgb":{"r":227,"g":216,"b":212},"luminance":145.83225849241998},{"name":"Light of New Hope","hex":"#eaf3d0","rgb":{"r":234,"g":243,"b":208},"luminance":160.6360948884154},{"name":"Light Olive","hex":"#acbf69","rgb":{"r":172,"g":191,"b":105},"luminance":123.92877701728521},{"name":"Light Opale","hex":"#c1e8ea","rgb":{"r":193,"g":232,"b":234},"luminance":150.2923440531819},{"name":"Light Opus","hex":"#dad7e8","rgb":{"r":218,"g":215,"b":232},"luminance":144.48491911960917},{"name":"Light Orchid","hex":"#e6a8d7","rgb":{"r":230,"g":168,"b":215},"luminance":122.6995047096768},{"name":"Light Orchid Haze","hex":"#d6cdd0","rgb":{"r":214,"g":205,"b":208},"luminance":138.33647156480464},{"name":"Light Oriental Blush","hex":"#e1d4e8","rgb":{"r":225,"g":212,"b":232},"luminance":143.91570958376988},{"name":"Light Otto Ice","hex":"#cde7dd","rgb":{"r":205,"g":231,"b":221},"luminance":150.92501803875987},{"name":"Light Pale Icelandish","hex":"#ccdfdc","rgb":{"r":204,"g":223,"b":220},"luminance":146.57622664334073},{"name":"Light Pale Lilac","hex":"#ced5e4","rgb":{"r":206,"g":213,"b":228},"luminance":141.782071719241},{"name":"Light Pale Pearl","hex":"#d4cbce","rgb":{"r":212,"g":203,"b":206},"luminance":136.9995646744908},{"name":"Light Pale Tendril","hex":"#dbdacb","rgb":{"r":219,"g":218,"b":203},"luminance":145.59742676640957},{"name":"Light Pastel Green","hex":"#b2fba5","rgb":{"r":178,"g":251,"b":165},"luminance":157.78019189049047},{"name":"Light Pax","hex":"#d5d3e3","rgb":{"r":213,"g":211,"b":227},"luminance":141.65543160076848},{"name":"Light Pearl Ash","hex":"#dcd6d1","rgb":{"r":220,"g":214,"b":209},"luminance":143.78653831287545},{"name":"Light Pelican Bill","hex":"#e1ced4","rgb":{"r":225,"g":206,"b":212},"luminance":140.47116406223734},{"name":"Light Penna","hex":"#c8d4e7","rgb":{"r":200,"g":212,"b":231},"luminance":140.5554292512388},{"name":"Light Pensive","hex":"#d0d0d7","rgb":{"r":208,"g":208,"b":215},"luminance":139.1977664332298},{"name":"Light Periwinkle","hex":"#c1c6fc","rgb":{"r":193,"g":198,"b":252},"luminance":132.90552625455422},{"name":"Light Perk Up","hex":"#e0d5cd","rgb":{"r":224,"g":213,"b":205},"luminance":143.752191068519},{"name":"Light Petite Pink","hex":"#f0d7d7","rgb":{"r":240,"g":215,"b":215},"luminance":147.23430213438715},{"name":"Light Pianissimo","hex":"#ecdbd6","rgb":{"r":236,"g":219,"b":214},"luminance":148.66175271736842},{"name":"Light Picnic Bay","hex":"#cde5de","rgb":{"r":205,"g":229,"b":222},"luminance":149.8903426442144},{"name":"Light Pink","hex":"#ffd1df","rgb":{"r":255,"g":209,"b":223},"luminance":146.66525354698024},{"name":"Light Pink Clay","hex":"#fedfdc","rgb":{"r":254,"g":223,"b":220},"luminance":153.40102058656583},{"name":"Light Pink Linen","hex":"#ddced1","rgb":{"r":221,"g":206,"b":209},"luminance":139.8436362549258},{"name":"Light Pink Pandora","hex":"#e9d3d5","rgb":{"r":233,"g":211,"b":213},"luminance":144.16540105725784},{"name":"Light Pink Polar","hex":"#d8c9cc","rgb":{"r":216,"g":201,"b":204},"luminance":136.50225917910663},{"name":"Light Pink Tone","hex":"#fad9da","rgb":{"r":250,"g":217,"b":218},"luminance":149.7684681266387},{"name":"Light Pistachio Tang","hex":"#e2dec8","rgb":{"r":226,"g":222,"b":200},"luminance":148.55242869774966},{"name":"Light Placid Blue","hex":"#c8d8e8","rgb":{"r":200,"g":216,"b":232},"luminance":142.6595526699842},{"name":"Light Pollinate","hex":"#ebe1cb","rgb":{"r":235,"g":225,"b":203},"luminance":151.38205974949605},{"name":"Light Poolside","hex":"#bee0e2","rgb":{"r":190,"g":224,"b":226},"luminance":145.53437374036415},{"name":"Light Porcelain","hex":"#e7dad7","rgb":{"r":231,"g":218,"b":215},"luminance":147.46716250406394},{"name":"Light Powder Blue","hex":"#c4d9ef","rgb":{"r":196,"g":217,"b":239},"luminance":142.83621030046967},{"name":"Light Powdered Granite","hex":"#d1d6eb","rgb":{"r":209,"g":214,"b":235},"luminance":142.83805902139667},{"name":"Light Pre School","hex":"#c5d0d9","rgb":{"r":197,"g":208,"b":217},"luminance":137.8004545311807},{"name":"Light Pretty Pale","hex":"#ead4e0","rgb":{"r":234,"g":212,"b":224},"luminance":145.0297817277541},{"name":"Light Puffball","hex":"#d9ced5","rgb":{"r":217,"g":206,"b":213},"luminance":139.36121876978544},{"name":"Light Pure Blue","hex":"#c2d2d8","rgb":{"r":194,"g":210,"b":216},"luminance":138.44323859257267},{"name":"Light Purity","hex":"#e0d5e9","rgb":{"r":224,"g":213,"b":233},"luminance":144.30549324609925},{"name":"Light Quaver","hex":"#cdded7","rgb":{"r":205,"g":222,"b":215},"luminance":146.0806480030808},{"name":"Light Quilt","hex":"#fde1d4","rgb":{"r":253,"g":225,"b":212},"luminance":154.11153901638903},{"name":"Light Radar","hex":"#c6d5ea","rgb":{"r":198,"g":213,"b":234},"luminance":140.88731930518088},{"name":"Light Raw Cotton","hex":"#ecdfca","rgb":{"r":236,"g":223,"b":202},"luminance":150.48135658944597},{"name":"Light Red","hex":"#f3d3d9","rgb":{"r":243,"g":211,"b":217},"luminance":145.71055123771922},{"name":"Light Relax","hex":"#caddde","rgb":{"r":202,"g":221,"b":222},"luminance":145.31864228996912},{"name":"Light Ridge Light","hex":"#c3d5e5","rgb":{"r":195,"g":213,"b":229},"luminance":140.40565238621983},{"name":"Light Roast","hex":"#615544","rgb":{"r":97,"g":85,"b":68},"luminance":58.230391875720706},{"name":"Light Rose Aspect","hex":"#f4d4d6","rgb":{"r":244,"g":212,"b":214},"luminance":146.3012367958658},{"name":"Light Rose Romantic","hex":"#f3dcd8","rgb":{"r":243,"g":220,"b":216},"luminance":150.20825751269467},{"name":"Light Salome","hex":"#ccf1e3","rgb":{"r":204,"g":241,"b":227},"luminance":156.214900022373},{"name":"Light Salt Spray","hex":"#bbd3da","rgb":{"r":187,"g":211,"b":218},"luminance":138.14645099313987},{"name":"Light Sandbank","hex":"#dedcc6","rgb":{"r":222,"g":220,"b":198},"luminance":146.94445776551083},{"name":"Light Sandy Day","hex":"#e1dacf","rgb":{"r":225,"g":218,"b":207},"luminance":146.48579584724246},{"name":"Light Sea Breeze","hex":"#b7cdd9","rgb":{"r":183,"g":205,"b":217},"luminance":134.48580206847114},{"name":"Light Sea Cliff","hex":"#b9d4e7","rgb":{"r":185,"g":212,"b":231},"luminance":138.70666140095793},{"name":"Light Sea Spray","hex":"#abd6de","rgb":{"r":171,"g":214,"b":222},"luminance":137.96576179980306},{"name":"Light Sea-Foam","hex":"#a0febf","rgb":{"r":160,"g":254,"b":191},"luminance":158.09170212253392},{"name":"Light Seafoam Green","hex":"#a7ffb5","rgb":{"r":167,"g":255,"b":181},"luminance":159.1372541864412},{"name":"Light Security","hex":"#e0e9d0","rgb":{"r":224,"g":233,"b":208},"luminance":154.12446256516193},{"name":"Light Shell Haven","hex":"#f1e8ce","rgb":{"r":241,"g":232,"b":206},"luminance":155.8527497126695},{"name":"Light Shell Tint","hex":"#fce0d6","rgb":{"r":252,"g":224,"b":214},"luminance":153.49781778253396},{"name":"Light Shetland Lace","hex":"#e7dccf","rgb":{"r":231,"g":220,"b":207},"luminance":148.33924620612035},{"name":"Light Shimmer","hex":"#a3d4ef","rgb":{"r":163,"g":212,"b":239},"luminance":136.39629328174573},{"name":"Light Short Phase","hex":"#cbe8df","rgb":{"r":203,"g":232,"b":223},"luminance":151.24974627747315},{"name":"Light Shutterbug","hex":"#cef2e4","rgb":{"r":206,"g":242,"b":228},"luminance":156.9991841252686},{"name":"Light Silver Grass","hex":"#d4dbd1","rgb":{"r":212,"g":219,"b":209},"luminance":145.29828157621134},{"name":"Light Silverton","hex":"#cee3d9","rgb":{"r":206,"g":227,"b":217},"luminance":148.86599840460548},{"name":"Light Sky Babe","hex":"#a1d0e2","rgb":{"r":161,"g":208,"b":226},"luminance":133.74819712055933},{"name":"Light Sky Bus","hex":"#afcfe0","rgb":{"r":175,"g":207,"b":224},"luminance":134.73837612944575},{"name":"Light Sky Chase","hex":"#bad7dc","rgb":{"r":186,"g":215,"b":220},"luminance":140.17712160334867},{"name":"Light Skyway","hex":"#c2e3e8","rgb":{"r":194,"g":227,"b":232},"luminance":147.7142130636047},{"name":"Light Slipper Satin","hex":"#cfd1d8","rgb":{"r":207,"g":209,"b":216},"luminance":139.60015513601695},{"name":"Light Snow Goose","hex":"#d1e2d8","rgb":{"r":209,"g":226,"b":216},"luminance":148.69657931842278},{"name":"Light Soft Celadon","hex":"#cedcd4","rgb":{"r":206,"g":220,"b":212},"luminance":145.10359285696543},{"name":"Light Soft Fresco","hex":"#cfe0d7","rgb":{"r":207,"g":224,"b":215},"luminance":147.3790273173222},{"name":"Light Soft Kind","hex":"#dcddcc","rgb":{"r":220,"g":221,"b":204},"luminance":147.29882709987885},{"name":"Light Spearmint Ice","hex":"#cfded7","rgb":{"r":207,"g":222,"b":215},"luminance":146.33257376606207},{"name":"Light Spirit","hex":"#c3cad3","rgb":{"r":195,"g":202,"b":211},"luminance":134.30510569967174},{"name":"Light Spirited","hex":"#d8eee7","rgb":{"r":216,"g":238,"b":231},"luminance":156.1484519551827},{"name":"Light Sprig Muslin","hex":"#e0cfd2","rgb":{"r":224,"g":207,"b":210},"luminance":140.7954021159782},{"name":"Light Spring Burst","hex":"#d6e8d5","rgb":{"r":214,"g":232,"b":213},"luminance":152.41360036427196},{"name":"Light Sprinkle","hex":"#e3e3d7","rgb":{"r":227,"g":227,"b":215},"luminance":151.53474924914087},{"name":"Light Stargate","hex":"#c7d2dd","rgb":{"r":199,"g":210,"b":221},"luminance":139.17830124340503},{"name":"Light Starlight","hex":"#cbd0d7","rgb":{"r":203,"g":208,"b":215},"luminance":138.53627367949522},{"name":"Light Stately Frills","hex":"#d2ccd1","rgb":{"r":210,"g":204,"b":209},"luminance":137.29474090437694},{"name":"Light Steel Blue","hex":"#b0c4de","rgb":{"r":176,"g":196,"b":222},"luminance":129.0222575527184},{"name":"Light Subpoena","hex":"#e4dad3","rgb":{"r":228,"g":218,"b":211},"luminance":146.97385364751105},{"name":"Light Supernova","hex":"#cde5e2","rgb":{"r":205,"g":229,"b":226},"luminance":149.96800875520086},{"name":"Light Tactile","hex":"#deedd4","rgb":{"r":222,"g":237,"b":212},"luminance":156.02636722362027},{"name":"Light Taupe","hex":"#b19d8d","rgb":{"r":177,"g":157,"b":141},"luminance":107.48255061171557},{"name":"Light Taupe White","hex":"#d5d0cb","rgb":{"r":213,"g":208,"b":203},"luminance":139.63888909970603},{"name":"Light Template","hex":"#bbd6ea","rgb":{"r":187,"g":214,"b":234},"luminance":140.06339446479225},{"name":"Light Thought","hex":"#e2d8d4","rgb":{"r":226,"g":216,"b":212},"luminance":145.69333877703536},{"name":"Light Tidal Foam","hex":"#bcd6e9","rgb":{"r":188,"g":214,"b":233},"luminance":140.16137382317567},{"name":"Light Time Travel","hex":"#c5d2df","rgb":{"r":197,"g":210,"b":223},"luminance":138.96522728006457},{"name":"Light Tinge Of Mauve","hex":"#dfd2d9","rgb":{"r":223,"g":210,"b":217},"luminance":142.31403259341644},{"name":"Light Tip Toes","hex":"#e1d0d8","rgb":{"r":225,"g":208,"b":216},"luminance":141.56164811487608},{"name":"Light Turquoise","hex":"#7ef4cc","rgb":{"r":126,"g":244,"b":204},"luminance":149.9147484272311},{"name":"Light Vandamint","hex":"#bfe7ea","rgb":{"r":191,"g":231,"b":234},"luminance":149.53124511619635},{"name":"Light Vanilla Ice","hex":"#b8ced9","rgb":{"r":184,"g":206,"b":217},"luminance":135.13274578724432},{"name":"Light Vanilla Quake","hex":"#d8d5d0","rgb":{"r":216,"g":213,"b":208},"luminance":142.7098558649682},{"name":"Light Violet","hex":"#d6b4fc","rgb":{"r":214,"g":180,"b":252},"luminance":126.82090434940132},{"name":"Light Vision","hex":"#dcd9eb","rgb":{"r":220,"g":217,"b":235},"luminance":145.84279941430086},{"name":"Light Wallis","hex":"#d4ccce","rgb":{"r":212,"g":204,"b":206},"luminance":137.51043707297273},{"name":"Light Washed Blue","hex":"#acdce7","rgb":{"r":172,"g":220,"b":231},"luminance":141.47599916593626},{"name":"Light Water Wash","hex":"#bfd5eb","rgb":{"r":191,"g":213,"b":235},"luminance":140.04246835156826},{"name":"Light Water Wings","hex":"#c2f0e6","rgb":{"r":194,"g":240,"b":230},"luminance":154.59417465092272},{"name":"Light Watermark","hex":"#b7dadd","rgb":{"r":183,"g":218,"b":221},"luminance":141.4354442174945},{"name":"Light Watermelon Milk","hex":"#e6dad6","rgb":{"r":230,"g":218,"b":214},"luminance":147.30843449035768},{"name":"Light Wavecrest","hex":"#b5d1df","rgb":{"r":181,"g":209,"b":223},"luminance":136.47806686057655},{"name":"Light Weathered Hide","hex":"#e0d4d0","rgb":{"r":224,"g":212,"b":208},"luminance":143.29812509589928},{"name":"Light Whimsy","hex":"#99d0e7","rgb":{"r":153,"g":208,"b":231},"luminance":133.01767093510546},{"name":"Light White Box","hex":"#cedcd6","rgb":{"r":206,"g":220,"b":214},"luminance":145.14174193525443},{"name":"Light Yellow","hex":"#fffe7a","rgb":{"r":255,"g":254,"b":122},"luminance":168.03852562135862},{"name":"Light Yellowish Green","hex":"#c2ff89","rgb":{"r":194,"g":255,"b":137},"luminance":161.28923456015283},{"name":"Light Youth","hex":"#ead7d5","rgb":{"r":234,"g":215,"b":213},"luminance":146.33030685746544},{"name":"Light Zen","hex":"#d1dbd2","rgb":{"r":209,"g":219,"b":210},"luminance":144.92799070572946},{"name":"Lighter Green","hex":"#75fd63","rgb":{"r":117,"g":253,"b":99},"luminance":152.9924874168663},{"name":"Lighter Purple","hex":"#a55af4","rgb":{"r":165,"g":90,"b":244},"luminance":77.45115222512833},{"name":"Lightest Sky","hex":"#e4eadf","rgb":{"r":228,"g":234,"b":223},"luminance":155.43783269204445},{"name":"Lighthearted","hex":"#f7e0e1","rgb":{"r":247,"g":224,"b":225},"luminance":152.97477652541284},{"name":"Lighthearted Rose","hex":"#c7a1a9","rgb":{"r":199,"g":161,"b":169},"luminance":113.3274936015087},{"name":"Lighthouse","hex":"#f3f4f4","rgb":{"r":243,"g":244,"b":244},"luminance":162.99395537565186},{"name":"Lighthouse Glow","hex":"#f8d568","rgb":{"r":248,"g":213,"b":104},"luminance":145.84867089212707},{"name":"Lighthouse View","hex":"#d9dcd5","rgb":{"r":217,"g":220,"b":213},"luminance":146.5488274023371},{"name":"Lightish Blue","hex":"#3d7afd","rgb":{"r":61,"g":122,"b":253},"luminance":79.3289800829432},{"name":"Lightish Green","hex":"#61e160","rgb":{"r":97,"g":225,"b":96},"luminance":135.6641101028566},{"name":"Lightish Purple","hex":"#a552e6","rgb":{"r":165,"g":82,"b":230},"luminance":73.74491562812992},{"name":"Lightish Red","hex":"#fe2f4a","rgb":{"r":254,"g":47,"b":74},"luminance":81.24108525247554},{"name":"Lightning Bolt","hex":"#e5ebe6","rgb":{"r":229,"g":235,"b":230},"luminance":156.21968270995814},{"name":"Lightning Bolt Blue","hex":"#93b9df","rgb":{"r":147,"g":185,"b":223},"luminance":119.87918217105086},{"name":"Lightning Bug","hex":"#efde74","rgb":{"r":239,"g":222,"b":116},"luminance":149.20887136159163},{"name":"Lightning Yellow","hex":"#f7a233","rgb":{"r":247,"g":162,"b":51},"luminance":120.54433641196088},{"name":"Lights of Shibuya","hex":"#f8f2de","rgb":{"r":248,"g":242,"b":222},"luminance":162.22932189958755},{"name":"Lights Out","hex":"#3d474b","rgb":{"r":61,"g":71,"b":75},"luminance":46.289695937649014},{"name":"Lightsaber Blue","hex":"#15f2fd","rgb":{"r":21,"g":242,"b":253},"luminance":145.08833764641457},{"name":"Lignum Vitœ Foliage","hex":"#67765b","rgb":{"r":103,"g":118,"b":91},"luminance":76.51048190280858},{"name":"Lilac","hex":"#cea2fd","rgb":{"r":206,"g":162,"b":253},"luminance":116.9125768940194},{"name":"Lilac Ash","hex":"#d7cdcd","rgb":{"r":215,"g":205,"b":205},"luminance":138.41687162336822},{"name":"Lilac Breeze","hex":"#b3a0c9","rgb":{"r":179,"g":160,"b":201},"luminance":110.50120016090322},{"name":"Lilac Bush","hex":"#9470c4","rgb":{"r":148,"g":112,"b":196},"luminance":82.33934281982096},{"name":"Lilac Chiffon","hex":"#de9bc4","rgb":{"r":222,"g":155,"b":196},"luminance":114.81969972526491},{"name":"Lilac Cotton Candy","hex":"#cdd7ec","rgb":{"r":205,"g":215,"b":236},"luminance":142.8586863512331},{"name":"Lilac Crystal","hex":"#cbc5d9","rgb":{"r":203,"g":197,"b":217},"luminance":132.9228075764276},{"name":"Lilac Flare","hex":"#b2badb","rgb":{"r":178,"g":186,"b":219},"luminance":124.0023853157672},{"name":"Lilac Fluff","hex":"#c8a4bf","rgb":{"r":200,"g":164,"b":191},"luminance":115.40223091431119},{"name":"Lilac Frost","hex":"#e8deea","rgb":{"r":232,"g":222,"b":234},"luminance":150.017555626},{"name":"Lilac Geode","hex":"#bb88ff","rgb":{"r":187,"g":136,"b":255},"luminance":101.70780055138347},{"name":"Lilac Grey","hex":"#9896a4","rgb":{"r":152,"g":150,"b":164},"luminance":100.83582508216016},{"name":"Lilac Haze","hex":"#d5b6d4","rgb":{"r":213,"g":182,"b":212},"luminance":126.702919259976},{"name":"Lilac Hint","hex":"#d0d0da","rgb":{"r":208,"g":208,"b":218},"luminance":139.25839286736004},{"name":"Lilac Light","hex":"#d7c1ba","rgb":{"r":215,"g":193,"b":186},"luminance":131.97356372395194},{"name":"Lilac Lust","hex":"#c3b9d8","rgb":{"r":195,"g":185,"b":216},"luminance":125.69283363024321},{"name":"Lilac Luster","hex":"#ae98aa","rgb":{"r":174,"g":152,"b":170},"luminance":105.08668446573047},{"name":"Lilac Marble","hex":"#c3babf","rgb":{"r":195,"g":186,"b":191},"luminance":125.67533260349859},{"name":"Lilac Paradise","hex":"#dcbbba","rgb":{"r":220,"g":187,"b":186},"luminance":129.71449948637198},{"name":"Lilac Rose","hex":"#bd4275","rgb":{"r":189,"g":66,"b":117},"luminance":69.8021341292657},{"name":"Lilac Sachet","hex":"#abb6d7","rgb":{"r":171,"g":182,"b":215},"luminance":120.94799831745873},{"name":"Lilac Smoke","hex":"#b6a3a0","rgb":{"r":182,"g":163,"b":160},"luminance":111.57450463703614},{"name":"Lilac Snow","hex":"#e0c7d7","rgb":{"r":224,"g":199,"b":215},"luminance":136.8641722475243},{"name":"Lilac Suede","hex":"#ba9b97","rgb":{"r":186,"g":155,"b":151},"luminance":108.0162442274309},{"name":"Lilac Time","hex":"#a4abbf","rgb":{"r":164,"g":171,"b":191},"luminance":113.81642456605286},{"name":"Lilas","hex":"#b88995","rgb":{"r":184,"g":137,"b":149},"luminance":98.90652158983248},{"name":"Lilás","hex":"#cc99ff","rgb":{"r":204,"g":153,"b":255},"luminance":112.3903582919816},{"name":"Liliac","hex":"#c48efd","rgb":{"r":196,"g":142,"b":253},"luminance":105.89702118567831},{"name":"Lily","hex":"#c19fb3","rgb":{"r":193,"g":159,"b":179},"luminance":111.61340230456197},{"name":"Lily Green","hex":"#c5cf98","rgb":{"r":197,"g":207,"b":152},"luminance":136.14058936995974},{"name":"Lily Legs","hex":"#eec7d6","rgb":{"r":238,"g":199,"b":214},"luminance":138.94053414680684},{"name":"Lily Pad","hex":"#818f84","rgb":{"r":129,"g":143,"b":132},"luminance":93.59623831116289},{"name":"Lily Pond","hex":"#deead8","rgb":{"r":222,"g":234,"b":216},"luminance":154.5302573090461},{"name":"Lily Pond Blue","hex":"#55707f","rgb":{"r":85,"g":112,"b":127},"luminance":71.95698885445388},{"name":"Lily The Pink","hex":"#f5dee2","rgb":{"r":245,"g":222,"b":226},"luminance":151.69646441825859},{"name":"Lily White","hex":"#f0e7d3","rgb":{"r":240,"g":231,"b":211},"luminance":155.28888860765278},{"name":"Lilylock","hex":"#e0e1c1","rgb":{"r":224,"g":225,"b":193},"luminance":149.71198417294454},{"name":"Lima","hex":"#a9f971","rgb":{"r":169,"g":249,"b":113},"luminance":155.18682435696658},{"name":"Lima Bean","hex":"#e1d590","rgb":{"r":225,"g":213,"b":144},"luminance":142.9271200367516},{"name":"Lima Bean Green","hex":"#88be69","rgb":{"r":136,"g":190,"b":105},"luminance":119.31379926898647},{"name":"Lima Sombrio","hex":"#7aac21","rgb":{"r":122,"g":172,"b":33},"luminance":107.41753313123515},{"name":"Limbert Leather","hex":"#988870","rgb":{"r":152,"g":136,"b":112},"luminance":92.7453004308035},{"name":"Lime","hex":"#aaff32","rgb":{"r":170,"g":255,"b":50},"luminance":158.1827364948527},{"name":"Lime Acid","hex":"#afff01","rgb":{"r":175,"g":255,"b":1},"luminance":158.56707680347773},{"name":"Lime Blossom","hex":"#f4f2d3","rgb":{"r":244,"g":242,"b":211},"luminance":161.4946183871153},{"name":"Lime Cake","hex":"#dae3d0","rgb":{"r":218,"g":227,"b":208},"luminance":150.22066458713329},{"name":"Lime Candy Pearl","hex":"#aaff00","rgb":{"r":170,"g":255,"b":0},"luminance":158.0800054560981},{"name":"Lime Chalk","hex":"#e5ddc8","rgb":{"r":229,"g":221,"b":200},"luminance":148.4493596146511},{"name":"Lime Coco Cake","hex":"#e6efcc","rgb":{"r":230,"g":239,"b":204},"luminance":157.96290794044023},{"name":"Lime Cream","hex":"#d7e8bc","rgb":{"r":215,"g":232,"b":188},"luminance":152.11171455545428},{"name":"Lime Daiquiri","hex":"#dde6d7","rgb":{"r":221,"g":230,"b":215},"luminance":152.29863571614814},{"name":"Lime Dream","hex":"#c2ecbc","rgb":{"r":194,"g":236,"b":188},"luminance":151.70742132143698},{"name":"Lime Fizz","hex":"#cfe838","rgb":{"r":207,"g":232,"b":56},"luminance":149.72501715144332},{"name":"Lime Flip","hex":"#d2e3cc","rgb":{"r":210,"g":227,"b":204},"luminance":149.12652895108906},{"name":"Lime Glow","hex":"#e1ecd9","rgb":{"r":225,"g":236,"b":217},"luminance":155.97759227850645},{"name":"Lime Green","hex":"#9fc131","rgb":{"r":159,"g":193,"b":49},"luminance":122.98862044107983},{"name":"Lime Hawk Moth","hex":"#cdaea5","rgb":{"r":205,"g":174,"b":165},"luminance":120.59462744666529},{"name":"Lime Ice","hex":"#d1dd86","rgb":{"r":209,"g":221,"b":134},"luminance":144.80185007795998},{"name":"Lime Jelly","hex":"#e3ff00","rgb":{"r":227,"g":255,"b":0},"luminance":164.3543225899459},{"name":"Lime Lightning","hex":"#befd73","rgb":{"r":190,"g":253,"b":115},"luminance":159.54549608497257},{"name":"Lime Lizard","hex":"#abd35d","rgb":{"r":171,"g":211,"b":93},"luminance":134.41403756304624},{"name":"Lime Meringue","hex":"#e6ecd6","rgb":{"r":230,"g":236,"b":214},"luminance":156.57455968323845},{"name":"Lime Parfait","hex":"#95c577","rgb":{"r":149,"g":197,"b":119},"luminance":124.66437453418678},{"name":"Lime Peel","hex":"#c6c191","rgb":{"r":198,"g":193,"b":145},"luminance":128.89130453603144},{"name":"Lime Popsicle","hex":"#c0db3a","rgb":{"r":192,"g":219,"b":58},"luminance":140.94421171867967},{"name":"Lime Punch","hex":"#c0d725","rgb":{"r":192,"g":215,"b":37},"luminance":138.71255175001286},{"name":"Lime Rasp","hex":"#b5ce08","rgb":{"r":181,"g":206,"b":8},"luminance":132.48331211514903},{"name":"Lime Sherbet","hex":"#cdd78a","rgb":{"r":205,"g":215,"b":138},"luminance":141.18170870902506},{"name":"Lime Shot","hex":"#1df914","rgb":{"r":29,"g":249,"b":20},"luminance":146.4377246818592},{"name":"Lime Slice","hex":"#f0fded","rgb":{"r":240,"g":253,"b":237},"luminance":167.13762905162918},{"name":"Lime Soap","hex":"#7af9ab","rgb":{"r":122,"g":249,"b":171},"luminance":151.9022155500044},{"name":"Lime Sorbet","hex":"#bee5be","rgb":{"r":190,"g":229,"b":190},"luminance":147.5333000681541},{"name":"Lime Splash","hex":"#cfdb8d","rgb":{"r":207,"g":219,"b":141},"luminance":143.57921414327356},{"name":"Lime Spritz","hex":"#dae1cf","rgb":{"r":218,"g":225,"b":207},"luminance":149.16220819296018},{"name":"Lime Taffy","hex":"#bad1b5","rgb":{"r":186,"g":209,"b":181},"luminance":136.27104402990386},{"name":"Lime Time","hex":"#ebe734","rgb":{"r":235,"g":231,"b":52},"luminance":152.83604881702482},{"name":"Lime Twist","hex":"#c6d624","rgb":{"r":198,"g":214,"b":36},"luminance":138.93020385790845},{"name":"Lime Wash","hex":"#dfe3d0","rgb":{"r":223,"g":227,"b":208},"luminance":150.8753700045173},{"name":"Lime Yellow","hex":"#d0fe1d","rgb":{"r":208,"g":254,"b":29},"luminance":161.582759303089},{"name":"Lime Zest","hex":"#ddff00","rgb":{"r":221,"g":255,"b":0},"luminance":163.62161674424317},{"name":"Limeade","hex":"#5f9727","rgb":{"r":95,"g":151,"b":39},"luminance":93.18330703511225},{"name":"Limed Ash","hex":"#747d63","rgb":{"r":116,"g":125,"b":99},"luminance":81.9404922916625},{"name":"Limed Oak","hex":"#ac8a56","rgb":{"r":172,"g":138,"b":86},"luminance":96.45169586896851},{"name":"Limed Spruce","hex":"#394851","rgb":{"r":57,"g":72,"b":81},"luminance":46.49705690686239},{"name":"Limed White","hex":"#cfc9c0","rgb":{"r":207,"g":201,"b":192},"luminance":135.02133224790813},{"name":"Limelight","hex":"#f0e87d","rgb":{"r":240,"g":232,"b":125},"luminance":154.59185604681767},{"name":"Limerick","hex":"#76857b","rgb":{"r":118,"g":133,"b":123},"luminance":86.81311565080475},{"name":"Limesicle","hex":"#f2eabf","rgb":{"r":242,"g":234,"b":191},"luminance":156.7705565595785},{"name":"Limestone","hex":"#dcd8c7","rgb":{"r":220,"g":216,"b":199},"luminance":144.63012915710198},{"name":"Limetta","hex":"#8e9a21","rgb":{"r":142,"g":154,"b":33},"luminance":99.94314789919316},{"name":"Limited Lime","hex":"#eaecb9","rgb":{"r":234,"g":236,"b":185},"luminance":156.62421358142552},{"name":"Limitless","hex":"#f0ddb8","rgb":{"r":240,"g":221,"b":184},"luminance":149.7283697400062},{"name":"Limoge Pink","hex":"#f3e0db","rgb":{"r":243,"g":224,"b":219},"luminance":152.28734336444379},{"name":"Limoges","hex":"#243f6c","rgb":{"r":36,"g":63,"b":108},"luminance":40.43566990912849},{"name":"Limoncello","hex":"#bfff00","rgb":{"r":191,"g":255,"b":0},"luminance":160.20935399033354},{"name":"Limone","hex":"#d6c443","rgb":{"r":214,"g":196,"b":67},"luminance":131.86929113330365},{"name":"Limonite","hex":"#be7f51","rgb":{"r":190,"g":127,"b":81},"luminance":94.18171933554834},{"name":"Limpet Shell","hex":"#98ddde","rgb":{"r":152,"g":221,"b":222},"luminance":139.76805821431446},{"name":"Limpid Light","hex":"#cdc2ca","rgb":{"r":205,"g":194,"b":202},"luminance":131.36043808163856},{"name":"Limuyi Yellow","hex":"#fefc7e","rgb":{"r":254,"g":252,"b":126},"luminance":166.90005748351317},{"name":"Lincoln Green","hex":"#195905","rgb":{"r":25,"g":89,"b":5},"luminance":52.77813537820372},{"name":"Lincolnshire Sausage","hex":"#e3e6da","rgb":{"r":227,"g":230,"b":218},"luminance":153.1406743259282},{"name":"Linden Green","hex":"#c4bf71","rgb":{"r":196,"g":191,"b":113},"luminance":127.16366001731782},{"name":"Linden Spear","hex":"#8e9985","rgb":{"r":142,"g":153,"b":133},"luminance":100.491709752596},{"name":"Lindworm Green","hex":"#172808","rgb":{"r":23,"g":40,"b":8},"luminance":24.483367272497464},{"name":"Line Dried Sheets","hex":"#f5eded","rgb":{"r":245,"g":237,"b":237},"luminance":159.5317006428503},{"name":"Lineage","hex":"#4c3430","rgb":{"r":76,"g":52,"b":48},"luminance":38.445253751275985},{"name":"Linear","hex":"#164975","rgb":{"r":22,"g":73,"b":117},"luminance":45.35835677138227},{"name":"Linen","hex":"#faf0e6","rgb":{"r":250,"g":240,"b":230},"luminance":161.62371515343904},{"name":"Linen Ruffle","hex":"#efebe3","rgb":{"r":239,"g":235,"b":227},"luminance":157.49656640701727},{"name":"Linen White","hex":"#e9dcd1","rgb":{"r":233,"g":220,"b":209},"luminance":148.65499912549188},{"name":"Lingering Lilac","hex":"#e6def0","rgb":{"r":230,"g":222,"b":240},"luminance":149.86534321183132},{"name":"Lingonberry","hex":"#ff255c","rgb":{"r":255,"g":37,"b":92},"luminance":79.96882598863134},{"name":"Link","hex":"#778290","rgb":{"r":119,"g":130,"b":144},"luminance":85.78291623044765},{"name":"Link Green","hex":"#01a049","rgb":{"r":1,"g":160,"b":73},"luminance":94.28844831155085},{"name":"Link to the Past","hex":"#d2b48c","rgb":{"r":210,"g":180,"b":140},"luminance":123.9408782444275},{"name":"Link Water","hex":"#c7cdd8","rgb":{"r":199,"g":205,"b":216},"luminance":136.48158338032277},{"name":"Link's Awakening","hex":"#3eaf76","rgb":{"r":62,"g":175,"b":118},"luminance":105.24751480676396},{"name":"Linnet","hex":"#c3bcb3","rgb":{"r":195,"g":188,"b":179},"luminance":126.46867041682694},{"name":"Linnet Egg Red","hex":"#ffccdd","rgb":{"r":255,"g":204,"b":221},"luminance":144.17912874268592},{"name":"Linseed","hex":"#b0a895","rgb":{"r":176,"g":168,"b":149},"luminance":113.06159837893678},{"name":"Lint","hex":"#b6ba99","rgb":{"r":182,"g":186,"b":153},"luminance":123.23250874667771},{"name":"Lion","hex":"#c19a62","rgb":{"r":193,"g":154,"b":98},"luminance":107.82722215192229},{"name":"Lion King","hex":"#dd9933","rgb":{"r":221,"g":153,"b":51},"luminance":111.65237372308749},{"name":"Lion of Menecrates","hex":"#eeaa66","rgb":{"r":238,"g":170,"b":102},"luminance":123.11492487915507},{"name":"Lion's Mane","hex":"#e8af49","rgb":{"r":232,"g":175,"b":73},"luminance":124.23204390574921},{"name":"Lionfish Red","hex":"#e03c28","rgb":{"r":224,"g":60,"b":40},"luminance":75.80914572793971},{"name":"Lionheart","hex":"#cc2222","rgb":{"r":204,"g":34,"b":34},"luminance":64.29507878523829},{"name":"Lip Gloss","hex":"#dfcdc7","rgb":{"r":223,"g":205,"b":199},"luminance":139.43094760489868},{"name":"Lippie","hex":"#d16a68","rgb":{"r":209,"g":106,"b":104},"luminance":88.97902618595013},{"name":"Lips of Apricot","hex":"#fbceb1","rgb":{"r":251,"g":206,"b":177},"luminance":143.74155338314665},{"name":"Lipstick","hex":"#c95b83","rgb":{"r":201,"g":91,"b":131},"luminance":81.7819665085158},{"name":"Lipstick Red","hex":"#c0022f","rgb":{"r":192,"g":2,"b":47},"luminance":57.66944515079021},{"name":"Liquid Green Stuff","hex":"#3b7a5f","rgb":{"r":59,"g":122,"b":95},"luminance":74.54568248396414},{"name":"Liquid Lime","hex":"#cdf80c","rgb":{"r":205,"g":248,"b":12},"luminance":157.95986903324527},{"name":"Liquorice","hex":"#0a0502","rgb":{"r":10,"g":5,"b":2},"luminance":4.195987249742306},{"name":"Liquorice Green","hex":"#2a4041","rgb":{"r":42,"g":64,"b":65},"luminance":40.29846260094794},{"name":"Liquorice Root","hex":"#222200","rgb":{"r":34,"g":34,"b":0},"luminance":22.397975801397767},{"name":"Lira","hex":"#e2c28d","rgb":{"r":226,"g":194,"b":141},"luminance":133.3897216280175},{"name":"Lisbon Brown","hex":"#423921","rgb":{"r":66,"g":57,"b":33},"luminance":39.026761087745925},{"name":"Lisbon Lemon","hex":"#fffb00","rgb":{"r":255,"g":251,"b":0},"luminance":165.89602645633195},{"name":"Liselotte Syrup","hex":"#dd5511","rgb":{"r":221,"g":85,"b":17},"luminance":82.82331259977471},{"name":"Liseran Purple","hex":"#de6fa1","rgb":{"r":222,"g":111,"b":161},"luminance":94.80687131743142},{"name":"Lit","hex":"#fffed8","rgb":{"r":255,"g":254,"b":216},"luminance":169.26268048509687},{"name":"Lit'L Buoy Blew","hex":"#d6e8e1","rgb":{"r":214,"g":232,"b":225},"luminance":152.637520131847},{"name":"Lithic Sand","hex":"#53626e","rgb":{"r":83,"g":98,"b":110},"luminance":63.89347200614472},{"name":"Litmus","hex":"#9895c5","rgb":{"r":152,"g":149,"b":197},"luminance":101.0923282796474},{"name":"Little Baby Girl","hex":"#f8b9d4","rgb":{"r":248,"g":185,"b":212},"luminance":133.699234676194},{"name":"Little Bear","hex":"#604b42","rgb":{"r":96,"g":75,"b":66},"luminance":53.091720795242644},{"name":"Little Beaux Blue","hex":"#b6d3c5","rgb":{"r":182,"g":211,"b":197},"luminance":137.13583389107313},{"name":"Little Blue Heron","hex":"#3c4378","rgb":{"r":60,"g":67,"b":120},"luminance":45.340448178199566},{"name":"Little Boy Blue","hex":"#6ca0dc","rgb":{"r":108,"g":160,"b":220},"luminance":102.4341059608566},{"name":"Little Dipper","hex":"#e4e6ea","rgb":{"r":228,"g":230,"b":234},"luminance":153.57972086183773},{"name":"Little Lamb","hex":"#eae6d7","rgb":{"r":234,"g":230,"b":215},"luminance":154.02493744845344},{"name":"Little League","hex":"#6a9a8e","rgb":{"r":106,"g":154,"b":142},"luminance":97.15121915858802},{"name":"Little Lilac","hex":"#e0d8df","rgb":{"r":224,"g":216,"b":223},"luminance":145.6306077855888},{"name":"Little Mermaid","hex":"#2d454a","rgb":{"r":45,"g":69,"b":74},"luminance":43.50512762882095},{"name":"Little Red Corvette","hex":"#e50102","rgb":{"r":229,"g":1,"b":2},"luminance":68.47389571216172},{"name":"Little Valley","hex":"#a4a191","rgb":{"r":164,"g":161,"b":145},"luminance":107.74666233809751},{"name":"Lively Coral","hex":"#e67c7a","rgb":{"r":230,"g":124,"b":122},"luminance":101.09816174392094},{"name":"Lively Ivy","hex":"#b3ae87","rgb":{"r":179,"g":174,"b":135},"luminance":116.33366058454448},{"name":"Lively Laugh","hex":"#e1dd8e","rgb":{"r":225,"g":221,"b":142},"luminance":147.02745151161398},{"name":"Lively Lavender","hex":"#816f7a","rgb":{"r":129,"g":111,"b":122},"luminance":76.98434356412997},{"name":"Lively Light","hex":"#a18899","rgb":{"r":161,"g":136,"b":153},"luminance":94.84057627935417},{"name":"Liver","hex":"#534b4f","rgb":{"r":83,"g":75,"b":79},"luminance":51.33412266709153},{"name":"Liver Brown","hex":"#513e32","rgb":{"r":81,"g":62,"b":50},"luminance":44.085975060102726},{"name":"Liver Chestnut","hex":"#987456","rgb":{"r":152,"g":116,"b":86},"luminance":82.45095259607375},{"name":"Livery Green","hex":"#a8d275","rgb":{"r":168,"g":210,"b":117},"luminance":133.77835762185154},{"name":"Livid","hex":"#6688cc","rgb":{"r":102,"g":136,"b":204},"luminance":88.56702413426794},{"name":"Livid Brown","hex":"#312a29","rgb":{"r":49,"g":42,"b":41},"luminance":29.057147020999842},{"name":"Livid Lime","hex":"#b8e100","rgb":{"r":184,"g":225,"b":0},"luminance":143.07538530788585},{"name":"Living Coral","hex":"#ff6f61","rgb":{"r":255,"g":111,"b":97},"luminance":100.90101108512243},{"name":"Living Large","hex":"#c87163","rgb":{"r":200,"g":113,"b":99},"luminance":90.01786132207319},{"name":"Livingstone","hex":"#cbcbbb","rgb":{"r":203,"g":203,"b":187},"luminance":135.41760171410507},{"name":"Lizard","hex":"#71643e","rgb":{"r":113,"g":100,"b":62},"luminance":68.09704834278796},{"name":"Lizard Belly","hex":"#cccc33","rgb":{"r":204,"g":204,"b":51},"luminance":134.51356108586228},{"name":"Lizard Legs","hex":"#7f6944","rgb":{"r":127,"g":105,"b":68},"luminance":72.80738601268418},{"name":"Loafer","hex":"#dbd9c2","rgb":{"r":219,"g":217,"b":194},"luminance":144.92166317704195},{"name":"Lobaria Lichen","hex":"#9fc8b2","rgb":{"r":159,"g":200,"b":178},"luminance":128.27576522866661},{"name":"Loblolly","hex":"#b3bbb7","rgb":{"r":179,"g":187,"b":183},"luminance":123.89089492775487},{"name":"Lobster Bisque","hex":"#dd9289","rgb":{"r":221,"g":146,"b":137},"luminance":109.33978676127002},{"name":"Lobster Brown","hex":"#a73836","rgb":{"r":167,"g":56,"b":54},"luminance":60.097996713700866},{"name":"Lobster Butter Sauce","hex":"#cc8811","rgb":{"r":204,"g":136,"b":17},"luminance":100.48589992630805},{"name":"Loch Blue","hex":"#609795","rgb":{"r":96,"g":151,"b":149},"luminance":94.70460168861912},{"name":"Loch Modan Moss","hex":"#dfe5bf","rgb":{"r":223,"g":229,"b":191},"luminance":151.62279622141256},{"name":"Loch Ness","hex":"#5f6db0","rgb":{"r":95,"g":109,"b":176},"luminance":72.82329579193734},{"name":"Lochinvar","hex":"#489084","rgb":{"r":72,"g":144,"b":132},"luminance":88.51485678686939},{"name":"Lochmara","hex":"#316ea0","rgb":{"r":49,"g":110,"b":160},"luminance":68.67775695958626},{"name":"Locomotion","hex":"#988171","rgb":{"r":152,"g":129,"b":113},"luminance":89.249310120583},{"name":"Locust","hex":"#a2a580","rgb":{"r":162,"g":165,"b":128},"luminance":109.27056938169581},{"name":"Loden Frost","hex":"#788f74","rgb":{"r":120,"g":143,"b":116},"luminance":92.24066379314492},{"name":"Loden Green","hex":"#6e7153","rgb":{"r":110,"g":113,"b":83},"luminance":74.63968853766741},{"name":"Lodgepole Pines","hex":"#aca690","rgb":{"r":172,"g":166,"b":144},"luminance":111.39689225467647},{"name":"Log Cabin","hex":"#705a46","rgb":{"r":112,"g":90,"b":70},"luminance":63.05660507829453},{"name":"Logan","hex":"#9d9cb4","rgb":{"r":157,"g":156,"b":180},"luminance":104.92924679516192},{"name":"Loganberry","hex":"#5a4769","rgb":{"r":90,"g":71,"b":105},"luminance":51.033335468103594},{"name":"Loggia Lights","hex":"#e1ebde","rgb":{"r":225,"g":235,"b":222},"luminance":155.54820318473628},{"name":"Lola","hex":"#b9acbb","rgb":{"r":185,"g":172,"b":187},"luminance":117.08089359498415},{"name":"Lolita","hex":"#bf2735","rgb":{"r":191,"g":39,"b":53},"luminance":61.82259371783102},{"name":"Lollipop","hex":"#cc1c3b","rgb":{"r":204,"g":28,"b":59},"luminance":63.52868004295382},{"name":"Lolly","hex":"#fd978f","rgb":{"r":253,"g":151,"b":143},"luminance":117.66367996115028},{"name":"Lolly Ice","hex":"#a6dad0","rgb":{"r":166,"g":218,"b":208},"luminance":139.2877957898681},{"name":"London Fog","hex":"#a29e92","rgb":{"r":162,"g":158,"b":146},"luminance":105.94849265562961},{"name":"London Grey","hex":"#666677","rgb":{"r":102,"g":102,"b":119},"luminance":68.54969172797205},{"name":"London Hue","hex":"#ae94ab","rgb":{"r":174,"g":148,"b":171},"luminance":103.12206402123648},{"name":"London Square","hex":"#7f909d","rgb":{"r":127,"g":144,"b":157},"luminance":94.3783339384628},{"name":"Lone Pine","hex":"#575a44","rgb":{"r":87,"g":90,"b":68},"luminance":59.395105631693255},{"name":"Lonely Road","hex":"#947754","rgb":{"r":148,"g":119,"b":84},"luminance":83.24290293472471},{"name":"Lonestar","hex":"#522426","rgb":{"r":82,"g":36,"b":38},"luminance":32.65669873088827},{"name":"Long Forgotten Purple","hex":"#a1759c","rgb":{"r":161,"g":117,"b":156},"luminance":85.7347013641501},{"name":"Long Island Sound","hex":"#95d0fc","rgb":{"r":149,"g":208,"b":252},"luminance":133.1071853845614},{"name":"Long Lake","hex":"#68757e","rgb":{"r":104,"g":117,"b":126},"luminance":76.74692666810834},{"name":"Long Spring","hex":"#c97586","rgb":{"r":201,"g":117,"b":134},"luminance":92.53135154097772},{"name":"Longbeard Grey","hex":"#ceceaf","rgb":{"r":206,"g":206,"b":175},"luminance":137.1639654574043},{"name":"Longboat","hex":"#60513a","rgb":{"r":96,"g":81,"b":58},"luminance":55.931702718583495},{"name":"Longlure Frogfish","hex":"#ebd84b","rgb":{"r":235,"g":216,"b":75},"luminance":145.21185898197157},{"name":"Loofah","hex":"#e3d3b5","rgb":{"r":227,"g":211,"b":181},"luminance":142.73423742746516},{"name":"Look At Me!","hex":"#a67e4b","rgb":{"r":166,"g":126,"b":75},"luminance":89.48191940274862},{"name":"Looking Glass","hex":"#888786","rgb":{"r":136,"g":135,"b":134},"luminance":90.36972444906534},{"name":"Loom of Fate","hex":"#454151","rgb":{"r":69,"g":65,"b":81},"luminance":44.347592290901204},{"name":"Looney Blue","hex":"#11ffff","rgb":{"r":17,"g":255,"b":255},"luminance":152.5663823193039},{"name":"Loophole","hex":"#cbc0b3","rgb":{"r":203,"g":192,"b":179},"luminance":129.625314892578},{"name":"Loose Leather","hex":"#84613d","rgb":{"r":132,"g":97,"b":61},"luminance":69.62852045677833},{"name":"Loquat Brown","hex":"#ae7c4f","rgb":{"r":174,"g":124,"b":79},"luminance":89.92166399705913},{"name":"Loren Forest","hex":"#50702d","rgb":{"r":80,"g":112,"b":45},"luminance":70.14810643203421},{"name":"Lorian","hex":"#8ebcbd","rgb":{"r":142,"g":188,"b":189},"luminance":120.18884563885285},{"name":"Lorna","hex":"#658477","rgb":{"r":101,"g":132,"b":119},"luminance":84.26022912976204},{"name":"Lost At Sea","hex":"#8d9ca7","rgb":{"r":141,"g":156,"b":167},"luminance":102.59267960727021},{"name":"Lost in the Woods","hex":"#014426","rgb":{"r":1,"g":68,"b":38},"luminance":40.15149662216839},{"name":"Lost Lace","hex":"#c2ebd1","rgb":{"r":194,"g":235,"b":209},"luminance":151.52952628778326},{"name":"Lost Lake","hex":"#b5adb5","rgb":{"r":181,"g":173,"b":181},"luminance":116.90694469534304},{"name":"Lost Lavender Somewhere","hex":"#8d828c","rgb":{"r":141,"g":130,"b":140},"luminance":88.63023739672596},{"name":"Lost Love","hex":"#e5d7d4","rgb":{"r":229,"g":215,"b":212},"luminance":145.6024453434763},{"name":"Lost River","hex":"#08457e","rgb":{"r":8,"g":69,"b":126},"luminance":43.04113345394148},{"name":"Lost Soul Grey","hex":"#929591","rgb":{"r":146,"g":149,"b":145},"luminance":99.13974472934656},{"name":"Lothern Blue","hex":"#6699cc","rgb":{"r":102,"g":153,"b":204},"luminance":97.65748952845347},{"name":"Lotion","hex":"#fefdfa","rgb":{"r":254,"g":253,"b":250},"luminance":169.22045395577922},{"name":"Lots of Bubbles","hex":"#e5ecb7","rgb":{"r":229,"g":236,"b":183},"luminance":155.93144618389195},{"name":"Lottery Winnings","hex":"#768371","rgb":{"r":118,"g":131,"b":113},"luminance":85.57986946122317},{"name":"Lotti Red","hex":"#e40046","rgb":{"r":228,"g":0,"b":70},"luminance":68.63746778545956},{"name":"Lotus","hex":"#8b504b","rgb":{"r":139,"g":80,"b":75},"luminance":63.29029010045696},{"name":"Lotus Flower","hex":"#f4f0da","rgb":{"r":244,"g":240,"b":218},"luminance":160.58447695839098},{"name":"Lotus Petal","hex":"#f2e9dc","rgb":{"r":242,"g":233,"b":220},"luminance":156.75137321567553},{"name":"Louisiana Mud","hex":"#655856","rgb":{"r":101,"g":88,"b":86},"luminance":60.633656932433155},{"name":"Loulou","hex":"#4c3347","rgb":{"r":76,"g":51,"b":71},"luminance":38.44628695986128},{"name":"Lounge Leather","hex":"#563e31","rgb":{"r":86,"g":62,"b":49},"luminance":44.9103153852208},{"name":"Love Affair","hex":"#ffbec8","rgb":{"r":255,"g":190,"b":200},"luminance":137.01124379042764},{"name":"Love Bird","hex":"#ba5b6a","rgb":{"r":186,"g":91,"b":106},"luminance":78.05328911070949},{"name":"Love In A Mist","hex":"#e1b9c2","rgb":{"r":225,"g":185,"b":194},"luminance":129.645351270302},{"name":"Love Letter","hex":"#e4658e","rgb":{"r":228,"g":101,"b":142},"luminance":91.78464630318079},{"name":"Love Potion","hex":"#c01352","rgb":{"r":192,"g":19,"b":82},"luminance":59.22375348624908},{"name":"Love Red","hex":"#ff496c","rgb":{"r":255,"g":73,"b":108},"luminance":88.32379956727404},{"name":"Love Spell","hex":"#f8b4c4","rgb":{"r":248,"g":180,"b":196},"luminance":131.00308790253763},{"name":"Love-Struck Chinchilla","hex":"#aeaeb7","rgb":{"r":174,"g":174,"b":183},"luminance":116.50793433925433},{"name":"Lovecloud","hex":"#eebbee","rgb":{"r":238,"g":187,"b":238},"luminance":133.60168048718546},{"name":"Loveliest Leaves","hex":"#a69a5c","rgb":{"r":166,"g":154,"b":92},"luminance":103.65968601148664},{"name":"Lovely Euphoric Delight","hex":"#ffeeff","rgb":{"r":255,"g":238,"b":255},"luminance":161.79039329020742},{"name":"Lovely Harmony","hex":"#f4dbdc","rgb":{"r":244,"g":219,"b":220},"luminance":149.9248416540768},{"name":"Lovely Lilac","hex":"#a7b0cc","rgb":{"r":167,"g":176,"b":204},"luminance":117.0790987708737},{"name":"Lovely Linen","hex":"#dbceac","rgb":{"r":219,"g":206,"b":172},"luminance":138.90415799752},{"name":"Lover's Hideaway","hex":"#d0c6b5","rgb":{"r":208,"g":198,"b":181},"luminance":133.42447262777543},{"name":"Lover's Knot","hex":"#f2dbdb","rgb":{"r":242,"g":219,"b":219},"luminance":149.61569145313604},{"name":"Lover's Leap","hex":"#957e68","rgb":{"r":149,"g":126,"b":104},"luminance":87.15350699197364},{"name":"Lover's Retreat","hex":"#f4ced8","rgb":{"r":244,"g":206,"b":216},"luminance":143.35637201045512},{"name":"Lover's Tryst","hex":"#b48ca3","rgb":{"r":180,"g":140,"b":163},"luminance":99.97717501510031},{"name":"Lower Green","hex":"#e0efe3","rgb":{"r":224,"g":239,"b":227},"luminance":157.59943308590928},{"name":"Lower Lavender","hex":"#dcdfef","rgb":{"r":220,"g":223,"b":239},"luminance":149.0114918957595},{"name":"Lower Lilac","hex":"#e2d6d8","rgb":{"r":226,"g":214,"b":216},"luminance":144.74967625525107},{"name":"Lower Lime","hex":"#e6f1de","rgb":{"r":230,"g":241,"b":222},"luminance":159.3195526387141},{"name":"Lower Linen","hex":"#e0dcd8","rgb":{"r":224,"g":220,"b":216},"luminance":147.54411391851588},{"name":"Lower Lip","hex":"#f7468a","rgb":{"r":247,"g":70,"b":138},"luminance":85.96597892771301},{"name":"Lǜ Sè Green","hex":"#02c14d","rgb":{"r":2,"g":193,"b":77},"luminance":113.63213264301608},{"name":"Lucea","hex":"#7cafe1","rgb":{"r":124,"g":175,"b":225},"luminance":112.18278789992696},{"name":"Lucent Lime","hex":"#00ff33","rgb":{"r":0,"g":255,"b":51},"luminance":149.79786988138383},{"name":"Lucid Blue","hex":"#7e8d9f","rgb":{"r":126,"g":141,"b":159},"luminance":92.72679462269791},{"name":"Lucidity","hex":"#1e4469","rgb":{"r":30,"g":68,"b":105},"luminance":42.62662144716609},{"name":"Lucius Lilac","hex":"#baa2ce","rgb":{"r":186,"g":162,"b":206},"luminance":112.63784483023457},{"name":"Lucky","hex":"#ab9a1c","rgb":{"r":171,"g":154,"b":28},"luminance":103.90458078929917},{"name":"Lucky Clover","hex":"#008400","rgb":{"r":0,"g":132,"b":0},"luminance":77.484},{"name":"Lucky Dog","hex":"#d3c8ba","rgb":{"r":211,"g":200,"b":186},"luminance":134.95403490448146},{"name":"Lucky Duck","hex":"#f4ecd7","rgb":{"r":244,"g":236,"b":215},"luminance":158.47533896477393},{"name":"Lucky Lime","hex":"#9acd32","rgb":{"r":154,"g":205,"b":50},"luminance":128.96990478790002},{"name":"Lucky Orange","hex":"#ff7700","rgb":{"r":255,"g":119,"b":0},"luminance":103.40571373961885},{"name":"Lucky Penny","hex":"#bc6f37","rgb":{"r":188,"g":111,"b":55},"luminance":86.28172745720845},{"name":"Lucky Point","hex":"#292d4f","rgb":{"r":41,"g":45,"b":79},"luminance":30.48185266679176},{"name":"Lucky Shamrock","hex":"#487a7b","rgb":{"r":72,"g":122,"b":123},"luminance":76.08308789737703},{"name":"Lugganath Orange","hex":"#f7a58b","rgb":{"r":247,"g":165,"b":139},"luminance":122.82610614197617},{"name":"Luigi Green","hex":"#4cbb17","rgb":{"r":76,"g":187,"b":23},"luminance":112.12710832354503},{"name":"Lull Wind","hex":"#c3d5e8","rgb":{"r":195,"g":213,"b":232},"luminance":140.4696433041673},{"name":"Lumber","hex":"#ffe4cd","rgb":{"r":255,"g":228,"b":205},"luminance":155.7932341951986},{"name":"Lumberjack","hex":"#9d4542","rgb":{"r":157,"g":69,"b":66},"luminance":62.45597516651229},{"name":"Luminary","hex":"#fffeed","rgb":{"r":255,"g":254,"b":237},"luminance":169.62749173704123},{"name":"Luminary Green","hex":"#e3eaa5","rgb":{"r":227,"g":234,"b":165},"luminance":154.36249671795284},{"name":"Luminescent Blue","hex":"#a4dde9","rgb":{"r":164,"g":221,"b":233},"luminance":141.2061035118525},{"name":"Luminescent Lime","hex":"#b9ff66","rgb":{"r":185,"g":255,"b":102},"luminance":160.0017463467196},{"name":"Luminescent Pink","hex":"#f984ef","rgb":{"r":249,"g":132,"b":239},"luminance":110.856060605634},{"name":"Luminescent Sky","hex":"#cafffb","rgb":{"r":202,"g":255,"b":251},"luminance":163.9276627814842},{"name":"Luminous Light","hex":"#bbaeb9","rgb":{"r":187,"g":174,"b":185},"luminance":118.33521332638057},{"name":"Luna Pier","hex":"#414d62","rgb":{"r":65,"g":77,"b":98},"luminance":50.452774056537265},{"name":"Lunar Base","hex":"#878786","rgb":{"r":135,"g":135,"b":134},"luminance":90.23557738497604},{"name":"Lunar Dust","hex":"#ccccdd","rgb":{"r":204,"g":204,"b":221},"luminance":136.72905015394497},{"name":"Lunar Eclipse","hex":"#415053","rgb":{"r":65,"g":80,"b":83},"luminance":51.69613398504765},{"name":"Lunar Green","hex":"#4e5541","rgb":{"r":78,"g":85,"b":65},"luminance":55.572788386043754},{"name":"Lunar Landing","hex":"#d2cfc1","rgb":{"r":210,"g":207,"b":193},"luminance":138.53197892544523},{"name":"Lunar Launch Site","hex":"#938673","rgb":{"r":147,"g":134,"b":115},"luminance":91.05393606538928},{"name":"Lunar Light","hex":"#9b959c","rgb":{"r":155,"g":149,"b":156},"luminance":100.56791759800936},{"name":"Lunar Rays","hex":"#caced2","rgb":{"r":202,"g":206,"b":210},"luminance":137.27043413641553},{"name":"Lunar Rock","hex":"#c5c5c5","rgb":{"r":197,"g":197,"b":197},"luminance":131.70536623084118},{"name":"Lunatic Sky Dancer","hex":"#76fda8","rgb":{"r":118,"g":253,"b":168},"luminance":153.84126802974552},{"name":"Lunette","hex":"#d0c8c6","rgb":{"r":208,"g":200,"b":198},"luminance":134.75941543357925},{"name":"Lupin Grey","hex":"#d1e0e9","rgb":{"r":209,"g":224,"b":233},"luminance":147.98567183683696},{"name":"Lupine","hex":"#be9cc1","rgb":{"r":190,"g":156,"b":193},"luminance":109.98588676734846},{"name":"Lurid Pink","hex":"#ff33ee","rgb":{"r":255,"g":51,"b":238},"luminance":86.28829247354474},{"name":"Lurid Red","hex":"#ff4400","rgb":{"r":255,"g":68,"b":0},"luminance":86.0615307846659},{"name":"Luscious Lavender","hex":"#696987","rgb":{"r":105,"g":105,"b":135},"luminance":70.86163524785466},{"name":"Luscious Leek","hex":"#bbcc22","rgb":{"r":187,"g":204,"b":34},"luminance":132.21524287690886},{"name":"Luscious Lime","hex":"#91a673","rgb":{"r":145,"g":166,"b":115},"luminance":107.45450892819714},{"name":"Luscious Lobster","hex":"#c5847c","rgb":{"r":197,"g":132,"b":124},"luminance":98.35222499262535},{"name":"Lush Garden","hex":"#008811","rgb":{"r":0,"g":136,"b":17},"luminance":79.85551995948683},{"name":"Lush Green","hex":"#bbee00","rgb":{"r":187,"g":238,"b":0},"luminance":150.47933414592183},{"name":"Lush Greenery","hex":"#7ff23e","rgb":{"r":127,"g":242,"b":62},"luminance":147.2115629595719},{"name":"Lush Hosta","hex":"#6c765c","rgb":{"r":108,"g":118,"b":92},"luminance":77.13980920380864},{"name":"Lush Lilac","hex":"#9d7eb7","rgb":{"r":157,"g":126,"b":183},"luminance":90.0513505562243},{"name":"Lush Mauve","hex":"#a091b7","rgb":{"r":160,"g":145,"b":183},"luminance":99.84213473779494},{"name":"Lush Meadow","hex":"#006e51","rgb":{"r":0,"g":110,"b":81},"luminance":65.22692431810654},{"name":"Lush Un'goro Crater","hex":"#54a64d","rgb":{"r":84,"g":166,"b":77},"luminance":101.00896051341186},{"name":"Lust","hex":"#e62020","rgb":{"r":230,"g":32,"b":32},"luminance":71.38248706790763},{"name":"Luster Green","hex":"#bece61","rgb":{"r":190,"g":206,"b":97},"luminance":134.05888835881044},{"name":"Lustrian Undergrowth","hex":"#415a09","rgb":{"r":65,"g":90,"b":9},"luminance":56.30080639742205},{"name":"Lustrous Yellow","hex":"#e6da78","rgb":{"r":230,"g":218,"b":120},"luminance":145.91693683736648},{"name":"Lusty Lavender","hex":"#8d5eb7","rgb":{"r":141,"g":94,"b":183},"luminance":72.50666182496613},{"name":"Lusty Lips","hex":"#d5174e","rgb":{"r":213,"g":23,"b":78},"luminance":65.70676246780083},{"name":"Lusty Lizard","hex":"#00bb11","rgb":{"r":0,"g":187,"b":17},"luminance":109.7861066119024},{"name":"Lusty-Gallant","hex":"#ffcccc","rgb":{"r":255,"g":204,"b":204},"luminance":143.8531371399317},{"name":"Luxor Gold","hex":"#ab8d3f","rgb":{"r":171,"g":141,"b":63},"luminance":97.55066403669427},{"name":"Luxury","hex":"#818eb1","rgb":{"r":129,"g":142,"b":177},"luminance":94.03596674145484},{"name":"Lyceum (Was Lycra Strip)","hex":"#adcf43","rgb":{"r":173,"g":207,"b":67},"luminance":132.2817396846594},{"name":"Lychee","hex":"#ba0b32","rgb":{"r":186,"g":11,"b":50},"luminance":56.27699214599159},{"name":"Lychee Pulp","hex":"#f7f2da","rgb":{"r":247,"g":242,"b":218},"luminance":162.02230225805334},{"name":"Lye","hex":"#9e9478","rgb":{"r":158,"g":148,"b":120},"luminance":99.83180024421075},{"name":"Lye Tinted","hex":"#7f6b5d","rgb":{"r":127,"g":107,"b":93},"luminance":74.15741105243629},{"name":"Lynch","hex":"#697d89","rgb":{"r":105,"g":125,"b":137},"luminance":81.32317365917295},{"name":"Lynx","hex":"#604d47","rgb":{"r":96,"g":77,"b":71},"luminance":54.15147323019014},{"name":"Lynx Screen Blue","hex":"#2cb1eb","rgb":{"r":44,"g":177,"b":235},"luminance":108.10081700431316},{"name":"Lynx White","hex":"#f7f7f7","rgb":{"r":247,"g":247,"b":247},"luminance":165.13312415745062},{"name":"Lyons Blue","hex":"#005871","rgb":{"r":0,"g":88,"b":113},"luminance":53.238033960693926},{"name":"Lyrebird","hex":"#0087ad","rgb":{"r":0,"g":135,"b":173},"luminance":81.6622759234642},{"name":"Lythrum","hex":"#72696f","rgb":{"r":114,"g":105,"b":111},"luminance":71.56013091799092},{"name":"M. Bison Red","hex":"#b4023d","rgb":{"r":180,"g":2,"b":61},"luminance":54.28009572578147},{"name":"Maastricht Blue","hex":"#001c3d","rgb":{"r":0,"g":28,"b":61},"luminance":17.846574237090994},{"name":"Mabel","hex":"#cbe8e8","rgb":{"r":203,"g":232,"b":232},"luminance":151.4255736954627},{"name":"Macadamia","hex":"#e4cfb6","rgb":{"r":228,"g":207,"b":182},"luminance":140.86283459095944},{"name":"Macadamia Nut","hex":"#eee3dd","rgb":{"r":238,"g":227,"b":221},"luminance":153.14719677813238},{"name":"Macaroni and Cheese","hex":"#ffb97b","rgb":{"r":255,"g":185,"b":123},"luminance":133.4270981997285},{"name":"Macaroon","hex":"#b38b71","rgb":{"r":179,"g":139,"b":113},"luminance":98.4269323610159},{"name":"Macaroon Cream","hex":"#fee8d6","rgb":{"r":254,"g":232,"b":214},"luminance":157.8259851482005},{"name":"Macau","hex":"#46c299","rgb":{"r":70,"g":194,"b":153},"luminance":117.0917894132633},{"name":"Macaw Green","hex":"#9bb53e","rgb":{"r":155,"g":181,"b":62},"luminance":116.13027451099907},{"name":"Macharius Solar Orange","hex":"#dd4400","rgb":{"r":221,"g":68,"b":0},"luminance":77.19923119435839},{"name":"Machine Green","hex":"#a6a23f","rgb":{"r":166,"g":162,"b":63},"luminance":107.5080644230934},{"name":"Machine Gun Metal","hex":"#454545","rgb":{"r":69,"g":69,"b":69},"luminance":46.13030593872102},{"name":"Machine Oil","hex":"#f1e782","rgb":{"r":241,"g":231,"b":130},"luminance":154.26820245922357},{"name":"Machined Iron","hex":"#cbcdcd","rgb":{"r":203,"g":205,"b":205},"luminance":136.78740780495843},{"name":"Machu Picchu Gardens","hex":"#99bb33","rgb":{"r":153,"g":187,"b":51},"luminance":119.06226927956648},{"name":"Mack Creek","hex":"#bfae5b","rgb":{"r":191,"g":174,"b":91},"luminance":117.47863125266655},{"name":"MacKintosh Midnight","hex":"#41434e","rgb":{"r":65,"g":67,"b":78},"luminance":44.76111180477982},{"name":"Macquarie","hex":"#007d82","rgb":{"r":0,"g":125,"b":130},"luminance":74.8566832353665},{"name":"Macragge Blue","hex":"#004577","rgb":{"r":0,"g":69,"b":119},"luminance":42.71451000538342},{"name":"Maculata Bark","hex":"#ada5a3","rgb":{"r":173,"g":165,"b":163},"luminance":111.36365779732631},{"name":"Mad For Mango","hex":"#f8a200","rgb":{"r":248,"g":162,"b":0},"luminance":120.58767739698779},{"name":"Madagascar Pink","hex":"#d194a1","rgb":{"r":209,"g":148,"b":161},"luminance":108.57915901774152},{"name":"Madam Butterfly","hex":"#7ca7cb","rgb":{"r":124,"g":167,"b":203},"luminance":107.33064232082094},{"name":"Madame Mauve","hex":"#b5adb4","rgb":{"r":181,"g":173,"b":180},"luminance":116.88687762961246},{"name":"Madang","hex":"#b7e3a8","rgb":{"r":183,"g":227,"b":168},"luminance":145.31360980307386},{"name":"Madder Blue","hex":"#b5b6ce","rgb":{"r":181,"g":182,"b":206},"luminance":122.04043581125069},{"name":"Madder Brown","hex":"#6a3331","rgb":{"r":106,"g":51,"b":49},"luminance":43.953805307390624},{"name":"Madder Lake","hex":"#cc3336","rgb":{"r":204,"g":51,"b":54},"luminance":68.2248658554929},{"name":"Madder Red","hex":"#b7282e","rgb":{"r":183,"g":40,"b":46},"luminance":59.77256916847392},{"name":"Madder Rose","hex":"#eebbcb","rgb":{"r":238,"g":187,"b":203},"luminance":132.84884556893974},{"name":"Made of Steel","hex":"#5b686f","rgb":{"r":91,"g":104,"b":111},"luminance":68.02434638421747},{"name":"Mademoiselle Pink","hex":"#f504c9","rgb":{"r":245,"g":4,"b":201},"luminance":76.79101200661441},{"name":"Madera","hex":"#eed09d","rgb":{"r":238,"g":208,"b":157},"luminance":142.44929576519496},{"name":"Madison","hex":"#2d3c54","rgb":{"r":45,"g":60,"b":84},"luminance":38.899681245480664},{"name":"Madonna","hex":"#3f4250","rgb":{"r":63,"g":66,"b":80},"luminance":44.03350466406234},{"name":"Madonna Lily","hex":"#eee6db","rgb":{"r":238,"g":230,"b":219},"luminance":154.64485604118877},{"name":"Madras","hex":"#473e23","rgb":{"r":71,"g":62,"b":35},"luminance":42.321552157263795},{"name":"Madrid Beige","hex":"#ecbf9f","rgb":{"r":236,"g":191,"b":159},"luminance":133.70883164922202},{"name":"Magenta","hex":"#ff00ff","rgb":{"r":255,"g":0,"b":255},"luminance":81.59880467874514},{"name":"Magenta Affair","hex":"#aa44dd","rgb":{"r":170,"g":68,"b":221},"luminance":69.36651636056116},{"name":"Magenta Crayon","hex":"#ff55a3","rgb":{"r":255,"g":85,"b":163},"luminance":92.99517070256927},{"name":"Magenta Dye","hex":"#ca1f7b","rgb":{"r":202,"g":31,"b":123},"luminance":64.61939102931875},{"name":"Magenta Elephant","hex":"#de0170","rgb":{"r":222,"g":1,"b":112},"luminance":67.59737625825429},{"name":"Magenta Haze","hex":"#9d446e","rgb":{"r":157,"g":68,"b":110},"luminance":62.88230200143757},{"name":"Magenta Ink","hex":"#513d3c","rgb":{"r":81,"g":61,"b":60},"luminance":43.766274801495264},{"name":"Magenta Pink","hex":"#cc338b","rgb":{"r":204,"g":51,"b":139},"luminance":69.76984807923834},{"name":"Magenta Purple","hex":"#6b264b","rgb":{"r":107,"g":38,"b":75},"luminance":39.927586766545254},{"name":"Magenta Stream","hex":"#fa5ff7","rgb":{"r":250,"g":95,"b":247},"luminance":97.41750709703057},{"name":"Magenta Twilight","hex":"#bb989f","rgb":{"r":187,"g":152,"b":159},"luminance":106.84445526558689},{"name":"Maggie's Magic","hex":"#ddeee2","rgb":{"r":221,"g":238,"b":226},"luminance":156.67796390367087},{"name":"Magic","hex":"#656b78","rgb":{"r":101,"g":107,"b":120},"luminance":71.02177470325562},{"name":"Magic Blue","hex":"#3e8baa","rgb":{"r":62,"g":139,"b":170},"luminance":85.88748158492015},{"name":"Magic Carpet","hex":"#9488be","rgb":{"r":148,"g":136,"b":190},"luminance":93.81121109974009},{"name":"Magic Dust","hex":"#817c85","rgb":{"r":129,"g":124,"b":133},"luminance":83.75978288534421},{"name":"Magic Fountain","hex":"#1f75ff","rgb":{"r":31,"g":117,"b":255},"luminance":75.15174184275439},{"name":"Magic Gem","hex":"#8e7282","rgb":{"r":142,"g":114,"b":130},"luminance":80.62464194029019},{"name":"Magic Ink","hex":"#0247fe","rgb":{"r":2,"g":71,"b":254},"luminance":50.752141521319075},{"name":"Magic Lamp","hex":"#c2a260","rgb":{"r":194,"g":162,"b":96},"luminance":111.9255824554869},{"name":"Magic Magenta","hex":"#7f4774","rgb":{"r":127,"g":71,"b":116},"luminance":57.91196106159763},{"name":"Magic Malt","hex":"#a5887e","rgb":{"r":165,"g":136,"b":126},"luminance":94.9390064462442},{"name":"Magic Melon","hex":"#de9851","rgb":{"r":222,"g":152,"b":81},"luminance":111.58955065775648},{"name":"Magic Metal","hex":"#3f3925","rgb":{"r":63,"g":57,"b":37},"luminance":38.62808271193381},{"name":"Magic Mint","hex":"#aaf0d1","rgb":{"r":170,"g":240,"b":209},"luminance":151.65270052326795},{"name":"Magic Moments","hex":"#e9dbe0","rgb":{"r":233,"g":219,"b":224},"luminance":148.42995652495492},{"name":"Magic Mountain","hex":"#717462","rgb":{"r":113,"g":116,"b":98},"luminance":76.83030272620303},{"name":"Magic Night","hex":"#3a3b5b","rgb":{"r":58,"g":59,"b":91},"luminance":40.097500283683516},{"name":"Magic Potion","hex":"#ff4466","rgb":{"r":255,"g":68,"b":102},"luminance":86.84352287303871},{"name":"Magic Sage","hex":"#598556","rgb":{"r":89,"g":133,"b":86},"luminance":83.06229456257515},{"name":"Magic Sail","hex":"#e0d2ba","rgb":{"r":224,"g":210,"b":186},"luminance":141.8833573468009},{"name":"Magic Spell","hex":"#544f66","rgb":{"r":84,"g":79,"b":102},"luminance":54.00443471604901},{"name":"Magic Wand","hex":"#c3d9e4","rgb":{"r":195,"g":217,"b":228},"luminance":142.47970637954023},{"name":"Magical","hex":"#c1ceda","rgb":{"r":193,"g":206,"b":218},"luminance":136.27123627897413},{"name":"Magical Malachite","hex":"#22cc88","rgb":{"r":34,"g":204,"b":136},"luminance":121.17468826450514},{"name":"Magical Mauve","hex":"#baa3a9","rgb":{"r":186,"g":163,"b":169},"luminance":112.33409773083149},{"name":"Magical Melon","hex":"#e9e9d0","rgb":{"r":233,"g":233,"b":208},"luminance":155.31276919171842},{"name":"Magical Merlin","hex":"#3d8ed0","rgb":{"r":61,"g":142,"b":208},"luminance":88.55963742586123},{"name":"Magical Moonlight","hex":"#f0eeeb","rgb":{"r":240,"g":238,"b":235},"luminance":159.32660837411933},{"name":"Magical Stardust","hex":"#eaeadb","rgb":{"r":234,"g":234,"b":219},"luminance":156.15941366437056},{"name":"Magma","hex":"#ff4e01","rgb":{"r":255,"g":78,"b":1},"luminance":88.93633013004302},{"name":"Magna Cum Laude","hex":"#dd0066","rgb":{"r":221,"g":0,"b":102},"luminance":67.09429651617192},{"name":"Magnesia Bay","hex":"#64bfdc","rgb":{"r":100,"g":191,"b":220},"luminance":118.71494467420688},{"name":"Magnesium","hex":"#c1c2c3","rgb":{"r":193,"g":194,"b":195},"luminance":129.58576169085862},{"name":"Magnet","hex":"#4d4b4f","rgb":{"r":77,"g":75,"b":79},"luminance":50.491258550366915},{"name":"Magnetic Blue","hex":"#054c8a","rgb":{"r":5,"g":76,"b":138},"luminance":47.32823040216061},{"name":"Magnetic Green","hex":"#2b6867","rgb":{"r":43,"g":104,"b":103},"luminance":63.482559156039066},{"name":"Magnetic Grey","hex":"#eef0f3","rgb":{"r":238,"g":240,"b":243},"luminance":160.24545375142472},{"name":"Magnetic Magic","hex":"#3fbbb2","rgb":{"r":63,"g":187,"b":178},"luminance":113.20702802388197},{"name":"Magnetos","hex":"#bf3cff","rgb":{"r":191,"g":60,"b":255},"luminance":73.12284992394648},{"name":"Magnificence","hex":"#7f556f","rgb":{"r":127,"g":85,"b":111},"luminance":63.96548655329685},{"name":"Magnificent Magenta","hex":"#ee22aa","rgb":{"r":238,"g":34,"b":170},"luminance":76.40638983749984},{"name":"Magnitude","hex":"#ae8d7b","rgb":{"r":174,"g":141,"b":123},"luminance":98.76080927675714},{"name":"Magnolia","hex":"#fff9e4","rgb":{"r":255,"g":249,"b":228},"luminance":166.89070273085915},{"name":"Magnolia Blossom","hex":"#f4e7ce","rgb":{"r":244,"g":231,"b":206},"luminance":155.75821840596404},{"name":"Magnolia Spray","hex":"#f6e6cb","rgb":{"r":246,"g":230,"b":203},"luminance":155.47811157844694},{"name":"Magnus Blue","hex":"#003686","rgb":{"r":0,"g":54,"b":134},"luminance":35.18692058137511},{"name":"Magos","hex":"#69475a","rgb":{"r":105,"g":71,"b":90},"luminance":53.17787090510488},{"name":"Maharaja","hex":"#3f354f","rgb":{"r":63,"g":53,"b":79},"luminance":37.467785176068254},{"name":"Mahogany","hex":"#c04000","rgb":{"r":192,"g":64,"b":0},"luminance":68.60782089528861},{"name":"Mahogany Brown","hex":"#812308","rgb":{"r":129,"g":35,"b":8},"luminance":43.710991867035},{"name":"Mahogany Cherry","hex":"#82495a","rgb":{"r":130,"g":73,"b":90},"luminance":58.75672473002558},{"name":"Mahogany Rose","hex":"#c5a193","rgb":{"r":197,"g":161,"b":147},"luminance":112.61423987222929},{"name":"Mai Tai","hex":"#a56531","rgb":{"r":165,"g":101,"b":49},"luminance":77.33106743088446},{"name":"Maiden Hair","hex":"#f5e9ca","rgb":{"r":245,"g":233,"b":202},"luminance":156.85308492344038},{"name":"Maiden Mist","hex":"#b9c0c0","rgb":{"r":185,"g":192,"b":192},"luminance":127.44028164203027},{"name":"Maiden Pink","hex":"#ff2feb","rgb":{"r":255,"g":47,"b":235},"luminance":85.39412770208499},{"name":"Maiden's Blush","hex":"#f3d3bf","rgb":{"r":243,"g":211,"b":191},"luminance":145.2367142770725},{"name":"Maidenhair Fern","hex":"#44764a","rgb":{"r":68,"g":118,"b":74},"luminance":72.67967443515414},{"name":"Maiko","hex":"#d8baa6","rgb":{"r":216,"g":186,"b":166},"luminance":128.2572413394269},{"name":"Main Mast Gold","hex":"#b79400","rgb":{"r":183,"g":148,"b":0},"luminance":102.6712689363485},{"name":"Maine-Anjou Cattle","hex":"#a95249","rgb":{"r":169,"g":82,"b":73},"luminance":70.28171597933562},{"name":"Maire","hex":"#2a2922","rgb":{"r":42,"g":41,"b":34},"luminance":27.421656204540234},{"name":"Maison De Campagne","hex":"#bb9b7d","rgb":{"r":187,"g":155,"b":125},"luminance":107.73855528082785},{"name":"Maize","hex":"#f4d054","rgb":{"r":244,"g":208,"b":84},"luminance":142.5542385479997},{"name":"Maizena","hex":"#fbec5e","rgb":{"r":251,"g":236,"b":94},"luminance":157.91865020003178},{"name":"Majestic","hex":"#5d4250","rgb":{"r":93,"g":66,"b":80},"luminance":48.552509852735724},{"name":"Majestic Magic","hex":"#555570","rgb":{"r":85,"g":85,"b":112},"luminance":57.43217803635867},{"name":"Majesty","hex":"#593761","rgb":{"r":89,"g":55,"b":97},"luminance":43.275234372560014},{"name":"Majin Bū Pink","hex":"#ffaacc","rgb":{"r":255,"g":170,"b":204},"luminance":127.71916716374248},{"name":"Majolica Blue","hex":"#274357","rgb":{"r":39,"g":67,"b":87},"luminance":42.2032686648795},{"name":"Majolica Earthenware","hex":"#976352","rgb":{"r":151,"g":99,"b":82},"luminance":74.1817907171295},{"name":"Major Brown","hex":"#5b5149","rgb":{"r":91,"g":81,"b":73},"luminance":55.410311080159076},{"name":"Majorca Blue","hex":"#4a9c95","rgb":{"r":74,"g":156,"b":149},"luminance":95.7262516554367},{"name":"Majorelle Blue","hex":"#6050dc","rgb":{"r":96,"g":80,"b":220},"luminance":60.48278776643814},{"name":"Makara","hex":"#695f50","rgb":{"r":105,"g":95,"b":80},"luminance":64.6417485066733},{"name":"Mako","hex":"#505555","rgb":{"r":80,"g":85,"b":85},"luminance":56.174491764501084},{"name":"Malachite","hex":"#0bda51","rgb":{"r":11,"g":218,"b":81},"luminance":128.3408798201103},{"name":"Malachite Green","hex":"#004e00","rgb":{"r":0,"g":78,"b":0},"luminance":45.785999999999994},{"name":"Malaga","hex":"#9f5069","rgb":{"r":159,"g":80,"b":105},"luminance":67.88717979854516},{"name":"Male","hex":"#d6cec3","rgb":{"r":214,"g":206,"b":195},"luminance":138.6019883695757},{"name":"Male Betta","hex":"#347699","rgb":{"r":52,"g":118,"b":153},"luminance":73.10090576730222},{"name":"Malibu","hex":"#66b7e1","rgb":{"r":102,"g":183,"b":225},"luminance":114.57452485173133},{"name":"Malibu Beige","hex":"#c9c0b1","rgb":{"r":201,"g":192,"b":177},"luminance":129.31060707072717},{"name":"Malibu Blue","hex":"#008cc1","rgb":{"r":0,"g":140,"b":193},"luminance":85.07432282422235},{"name":"Malibu Dune","hex":"#e7ceb5","rgb":{"r":231,"g":206,"b":181},"luminance":140.77790594052746},{"name":"Malibu Sun","hex":"#fff2d9","rgb":{"r":255,"g":242,"b":217},"luminance":163.1091891494774},{"name":"Mallard","hex":"#254855","rgb":{"r":37,"g":72,"b":85},"luminance":44.749656590861115},{"name":"Mallard Blue","hex":"#3a5c6e","rgb":{"r":58,"g":92,"b":110},"luminance":58.08983198460811},{"name":"Mallard Green","hex":"#478865","rgb":{"r":71,"g":136,"b":101},"luminance":83.40498103231005},{"name":"Mallard Lake","hex":"#91b9c2","rgb":{"r":145,"g":185,"b":194},"luminance":119.00272058234634},{"name":"Mallard's Egg","hex":"#f8f2d8","rgb":{"r":248,"g":242,"b":216},"luminance":162.12402473415221},{"name":"Mallardish","hex":"#3a4531","rgb":{"r":58,"g":69,"b":49},"luminance":44.41217590931568},{"name":"Malmö FF","hex":"#a7d7ff","rgb":{"r":167,"g":215,"b":255},"luminance":138.8022745274731},{"name":"Malt","hex":"#ddcfbc","rgb":{"r":221,"g":207,"b":188},"luminance":139.96500257564387},{"name":"Malt Shake","hex":"#bba87f","rgb":{"r":187,"g":168,"b":127},"luminance":114.28469499018667},{"name":"Malta","hex":"#a59784","rgb":{"r":165,"g":151,"b":132},"luminance":102.55194926475069},{"name":"Malted Milk","hex":"#e8d9ce","rgb":{"r":232,"g":217,"b":206},"luminance":146.93136942463988},{"name":"Malted Mint","hex":"#bfd6c8","rgb":{"r":191,"g":214,"b":200},"luminance":139.86121622880304},{"name":"Mama Racoon","hex":"#594f40","rgb":{"r":89,"g":79,"b":64},"luminance":53.96139421845955},{"name":"Mamala Bay","hex":"#005e8c","rgb":{"r":0,"g":94,"b":140},"luminance":57.43982315432386},{"name":"Mamba","hex":"#766d7c","rgb":{"r":118,"g":109,"b":124},"luminance":74.42089967878647},{"name":"Mamba Green","hex":"#77ad3b","rgb":{"r":119,"g":173,"b":59},"luminance":107.81397051402938},{"name":"Mamie Pink","hex":"#ee82ee","rgb":{"r":238,"g":130,"b":238},"luminance":107.81183500896364},{"name":"Mammary Red","hex":"#b00b1e","rgb":{"r":176,"g":11,"b":30},"luminance":53.12884927231155},{"name":"Mammoth Wool","hex":"#995522","rgb":{"r":153,"g":85,"b":34},"luminance":67.80355750253817},{"name":"Man Cave","hex":"#816045","rgb":{"r":129,"g":96,"b":69},"luminance":68.73968214212225},{"name":"Man Friday","hex":"#3c4c5d","rgb":{"r":60,"g":76,"b":93},"luminance":49.23897387233003},{"name":"Mana","hex":"#b09737","rgb":{"r":176,"g":151,"b":55},"luminance":103.27204871115902},{"name":"Mana Tree Green","hex":"#4f7942","rgb":{"r":79,"g":121,"b":66},"luminance":75.2289634781711},{"name":"Manakin","hex":"#94bbda","rgb":{"r":148,"g":187,"b":218},"luminance":120.93425804543557},{"name":"Manatee","hex":"#8d90a1","rgb":{"r":141,"g":144,"b":161},"luminance":96.22491039746411},{"name":"Mandalay","hex":"#b57b2e","rgb":{"r":181,"g":123,"b":46},"luminance":90.38445717046709},{"name":"Mandarin","hex":"#f37a48","rgb":{"r":243,"g":122,"b":72},"luminance":102.34732975998932},{"name":"Mandarin Jelly","hex":"#ff8800","rgb":{"r":255,"g":136,"b":0},"luminance":110.39224723231246},{"name":"Mandarin Orange","hex":"#ec6a37","rgb":{"r":236,"g":106,"b":55},"luminance":94.28768891005866},{"name":"Mandarin Peel","hex":"#ff9f00","rgb":{"r":255,"g":159,"b":0},"luminance":120.51700674178727},{"name":"Mandarin Red","hex":"#e74a33","rgb":{"r":231,"g":74,"b":51},"luminance":81.7996894920757},{"name":"Mandarin Sorbet","hex":"#ffae42","rgb":{"r":255,"g":174,"b":66},"luminance":127.67960543877004},{"name":"Mandarin Sugar","hex":"#f6e7e1","rgb":{"r":246,"g":231,"b":225},"luminance":156.37985747851286},{"name":"Mandrake","hex":"#8889a0","rgb":{"r":136,"g":137,"b":160},"luminance":91.9427759913741},{"name":"Mandy","hex":"#cd525b","rgb":{"r":205,"g":82,"b":91},"luminance":78.62301734861109},{"name":"Mandys Pink","hex":"#f5b799","rgb":{"r":245,"g":183,"b":153},"luminance":131.1860877913508},{"name":"Mangala Pink","hex":"#e781a6","rgb":{"r":231,"g":129,"b":166},"luminance":104.22388049770551},{"name":"Manganese Red","hex":"#e52b50","rgb":{"r":229,"g":43,"b":80},"luminance":73.5429148320897},{"name":"Mångata","hex":"#9dbcd4","rgb":{"r":157,"g":188,"b":212},"luminance":122.33635685682322},{"name":"Mango","hex":"#ffa62b","rgb":{"r":255,"g":166,"b":43},"luminance":123.8235558890149},{"name":"Mango Cheesecake","hex":"#fbedda","rgb":{"r":251,"g":237,"b":218},"luminance":160.0127197006538},{"name":"Mango Green","hex":"#96ff00","rgb":{"r":150,"g":255,"b":0},"luminance":156.25978921334817},{"name":"Mango Margarita","hex":"#f7b74e","rgb":{"r":247,"g":183,"b":78},"luminance":130.66217705977502},{"name":"Mango Mojito","hex":"#d69c2f","rgb":{"r":214,"g":156,"b":47},"luminance":111.84072399622598},{"name":"Mango Salsa","hex":"#ffb066","rgb":{"r":255,"g":176,"b":102},"luminance":128.92586921560778},{"name":"Mango Squash","hex":"#8e6c39","rgb":{"r":142,"g":108,"b":57},"luminance":76.57648845435521},{"name":"Mango Tango","hex":"#ff8243","rgb":{"r":255,"g":130,"b":67},"luminance":108.14275365922582},{"name":"Mangosteen","hex":"#383e5d","rgb":{"r":56,"g":62,"b":93},"luminance":41.44016380276506},{"name":"Mangrove","hex":"#757461","rgb":{"r":117,"g":116,"b":97},"luminance":77.34733425917146},{"name":"Mangrove Leaf","hex":"#607c3d","rgb":{"r":96,"g":124,"b":61},"luminance":78.55170702155364},{"name":"Mangy Moose","hex":"#b2896c","rgb":{"r":178,"g":137,"b":108},"luminance":97.21821942928186},{"name":"Manhattan","hex":"#e2af80","rgb":{"r":226,"g":175,"b":128},"luminance":123.82082847808763},{"name":"Mani","hex":"#97908e","rgb":{"r":151,"g":144,"b":142},"luminance":97.1877889912102},{"name":"Maniac Green","hex":"#009000","rgb":{"r":0,"g":144,"b":0},"luminance":84.52799999999999},{"name":"Maniac Mansion","hex":"#004058","rgb":{"r":0,"g":64,"b":88},"luminance":38.8843882297253},{"name":"Manifest","hex":"#899888","rgb":{"r":137,"g":152,"b":136},"luminance":99.39448456026118},{"name":"Manila","hex":"#e7c9a9","rgb":{"r":231,"g":201,"b":169},"luminance":138.06751133412956},{"name":"Mannequin","hex":"#eedfdd","rgb":{"r":238,"g":223,"b":221},"luminance":151.10870153965323},{"name":"Mantella Frog","hex":"#ffbb00","rgb":{"r":255,"g":187,"b":0},"luminance":133.65078894641812},{"name":"Manticore Brown","hex":"#957840","rgb":{"r":149,"g":120,"b":64},"luminance":83.66490791843376},{"name":"Manticore Wing","hex":"#dd7711","rgb":{"r":221,"g":119,"b":17},"luminance":96.17500555757717},{"name":"Mantis","hex":"#74c365","rgb":{"r":116,"g":195,"b":101},"luminance":120.15734799420298},{"name":"Mantle","hex":"#96a793","rgb":{"r":150,"g":167,"b":147},"luminance":109.09646146873874},{"name":"Manure","hex":"#ad900d","rgb":{"r":173,"g":144,"b":13},"luminance":99.11035080656308},{"name":"Manz","hex":"#e4db55","rgb":{"r":228,"g":219,"b":85},"luminance":145.83275178436426},{"name":"Maple Brown Sugar","hex":"#a38e6f","rgb":{"r":163,"g":142,"b":111},"luminance":97.3822786804663},{"name":"Maple Elixir","hex":"#f6d193","rgb":{"r":246,"g":209,"b":147},"luminance":144.02131775886514},{"name":"Maple Sugar","hex":"#c9a38d","rgb":{"r":201,"g":163,"b":141},"luminance":114.12763485676902},{"name":"Maple Syrup","hex":"#bb9351","rgb":{"r":187,"g":147,"b":81},"luminance":103.23430556748082},{"name":"Maple View","hex":"#b49161","rgb":{"r":180,"g":145,"b":97},"luminance":101.30861261018235},{"name":"Maraschino","hex":"#ff2600","rgb":{"r":255,"g":38,"b":0},"luminance":79.44090672317378},{"name":"Marble Dust","hex":"#f3e5cb","rgb":{"r":243,"g":229,"b":203},"luminance":154.54492790771232},{"name":"Marble Garden","hex":"#646255","rgb":{"r":100,"g":98,"b":85},"luminance":65.55262600384518},{"name":"Marble Green","hex":"#8f9f97","rgb":{"r":143,"g":159,"b":151},"luminance":104.09386021279064},{"name":"Marble White","hex":"#f2f0e6","rgb":{"r":242,"g":240,"b":230},"luminance":160.53143917625607},{"name":"March Hare Orange","hex":"#ff750f","rgb":{"r":255,"g":117,"b":15},"luminance":102.63054694388022},{"name":"March Pink","hex":"#9a7276","rgb":{"r":154,"g":114,"b":118},"luminance":82.33595292458817},{"name":"Mardi Gras","hex":"#880085","rgb":{"r":136,"g":0,"b":133},"luminance":43.398699750107724},{"name":"Margarine","hex":"#f2d930","rgb":{"r":242,"g":217,"b":48},"luminance":146.59820117927777},{"name":"Margarita","hex":"#b5c38e","rgb":{"r":181,"g":195,"b":142},"luminance":127.64463846946333},{"name":"Mariana Trench","hex":"#445956","rgb":{"r":68,"g":89,"b":86},"luminance":56.91080467714369},{"name":"Marigold","hex":"#fcc006","rgb":{"r":252,"g":192,"b":6},"luminance":135.57278700388215},{"name":"Marigold Yellow","hex":"#fbe870","rgb":{"r":251,"g":232,"b":112},"luminance":156.01748645905047},{"name":"Marilyn Monroe","hex":"#e7c3ac","rgb":{"r":231,"g":195,"b":172},"luminance":135.1193422497312},{"name":"Marina","hex":"#4f84c4","rgb":{"r":79,"g":132,"b":196},"luminance":84.02961521392324},{"name":"Marine","hex":"#042e60","rgb":{"r":4,"g":46,"b":96},"luminance":29.160067832568565},{"name":"Marine Blue","hex":"#01386a","rgb":{"r":1,"g":56,"b":106},"luminance":35.02400378311994},{"name":"Marine Green","hex":"#40a48e","rgb":{"r":64,"g":164,"b":142},"luminance":99.47746309591938},{"name":"Marine Ink","hex":"#6384b8","rgb":{"r":99,"g":132,"b":184},"luminance":85.5568935445882},{"name":"Marine Layer","hex":"#a5b4b6","rgb":{"r":165,"g":180,"b":182},"luminance":118.44178877828551},{"name":"Marine Teal","hex":"#008384","rgb":{"r":0,"g":131,"b":132},"luminance":78.35554168659674},{"name":"Marine Tinge","hex":"#33a3b3","rgb":{"r":51,"g":163,"b":179},"luminance":99.01409292620924},{"name":"Marine Wonder","hex":"#1f7073","rgb":{"r":31,"g":112,"b":115},"luminance":67.67614052973175},{"name":"Mariner","hex":"#42639f","rgb":{"r":66,"g":99,"b":159},"luminance":63.992994936946026},{"name":"Mario Red","hex":"#e4000f","rgb":{"r":228,"g":0,"b":15},"luminance":68.19344311588908},{"name":"Marionberry","hex":"#380282","rgb":{"r":56,"g":2,"b":130},"luminance":22.39134234475459},{"name":"Maritime","hex":"#bdcfea","rgb":{"r":189,"g":207,"b":234},"luminance":136.6365221234791},{"name":"Maritime Blue","hex":"#27293d","rgb":{"r":39,"g":41,"b":61},"luminance":27.63254468918851},{"name":"Market Melon","hex":"#fbb377","rgb":{"r":251,"g":179,"b":119},"luminance":129.83344748561518},{"name":"Marlin","hex":"#515b87","rgb":{"r":81,"g":91,"b":135},"luminance":60.63652323476338},{"name":"Marlin Green","hex":"#41a1aa","rgb":{"r":65,"g":161,"b":170},"luminance":98.4117710134311},{"name":"Marmalade","hex":"#c16512","rgb":{"r":193,"g":101,"b":18},"luminance":82.76023756611625},{"name":"Marmot","hex":"#928475","rgb":{"r":146,"g":132,"b":117},"luminance":89.92966260361483},{"name":"Maroon","hex":"#800000","rgb":{"r":128,"g":0,"b":0},"luminance":38.272},{"name":"Maroon Flush","hex":"#c32249","rgb":{"r":195,"g":34,"b":73},"luminance":62.18561307087034},{"name":"Maroon Light","hex":"#bf3160","rgb":{"r":191,"g":49,"b":96},"luminance":64.87310063500895},{"name":"Maroon Oak","hex":"#520c17","rgb":{"r":82,"g":12,"b":23},"luminance":25.644202931656892},{"name":"Marooned","hex":"#86cdab","rgb":{"r":134,"g":205,"b":171},"luminance":128.3191825761059},{"name":"Marrakesh Red","hex":"#783b3c","rgb":{"r":120,"g":59,"b":60},"luminance":50.33492514149594},{"name":"Marron","hex":"#6e4c4b","rgb":{"r":110,"g":76,"b":75},"luminance":56.08105869186137},{"name":"Marrs Green","hex":"#008c8c","rgb":{"r":0,"g":140,"b":140},"luminance":83.71543465813218},{"name":"Mars Brown","hex":"#ad6242","rgb":{"r":173,"g":98,"b":66},"luminance":77.72730396070611},{"name":"Mars Red","hex":"#bc2731","rgb":{"r":188,"g":39,"b":49},"luminance":60.95147076978536},{"name":"Marsala","hex":"#964f4c","rgb":{"r":150,"g":79,"b":76},"luminance":65.09256889230905},{"name":"Marsh","hex":"#5c5337","rgb":{"r":92,"g":83,"b":55},"luminance":56.300433435276496},{"name":"Marsh Field","hex":"#d4c477","rgb":{"r":212,"g":196,"b":119},"luminance":132.05694833669298},{"name":"Marsh Fog","hex":"#c6d8c7","rgb":{"r":198,"g":216,"b":199},"luminance":141.75945352603472},{"name":"Marsh Marigold","hex":"#ffef17","rgb":{"r":255,"g":239,"b":23},"luminance":159.69439801696237},{"name":"Marsh Mix","hex":"#5a653a","rgb":{"r":90,"g":101,"b":58},"luminance":65.4432197633949},{"name":"Marsh Orchid","hex":"#c4a3bf","rgb":{"r":196,"g":163,"b":191},"luminance":114.29518648219617},{"name":"Marshal Blue","hex":"#3e4355","rgb":{"r":62,"g":67,"b":85},"luminance":44.54574934828238},{"name":"Marshland","hex":"#2b2e26","rgb":{"r":43,"g":46,"b":38},"luminance":30.218813295693792},{"name":"Marshmallow","hex":"#f0eee4","rgb":{"r":240,"g":238,"b":228},"luminance":159.19437207388958},{"name":"Marshmallow Cream","hex":"#f3e0d6","rgb":{"r":243,"g":224,"b":214},"luminance":152.19493621339706},{"name":"Marshmallow Magic","hex":"#efd2d0","rgb":{"r":239,"g":210,"b":208},"luminance":144.4452365604349},{"name":"Marshmallow Rose","hex":"#f7e5e6","rgb":{"r":247,"g":229,"b":230},"luminance":155.59979735847986},{"name":"Marsupilami","hex":"#fdf200","rgb":{"r":253,"g":242,"b":0},"luminance":160.94038500326758},{"name":"Martian","hex":"#aea132","rgb":{"r":174,"g":161,"b":50},"luminance":108.0313275166051},{"name":"Martian Green","hex":"#136c51","rgb":{"r":19,"g":108,"b":81},"luminance":64.31635354247004},{"name":"Martian Haze","hex":"#adeace","rgb":{"r":173,"g":234,"b":206},"luminance":148.64185463388165},{"name":"Martian Ironcrust","hex":"#b7410e","rgb":{"r":183,"g":65,"b":14},"luminance":66.72556728870876},{"name":"Martian Ironearth","hex":"#c15a4b","rgb":{"r":193,"g":90,"b":75},"luminance":78.70329884445759},{"name":"Martian Moon","hex":"#c3e9d3","rgb":{"r":195,"g":233,"b":211},"luminance":150.61332737178338},{"name":"Martini","hex":"#b7a8a3","rgb":{"r":183,"g":168,"b":163},"luminance":114.29941499850294},{"name":"Martini Olive","hex":"#cdc796","rgb":{"r":205,"g":199,"b":150},"luminance":133.0216673854301},{"name":"Martinique","hex":"#3c3748","rgb":{"r":60,"g":55,"b":72},"luminance":37.83564574577788},{"name":"Marvellous","hex":"#6a7fb4","rgb":{"r":106,"g":127,"b":180},"luminance":83.56514486913787},{"name":"Mary Poppins","hex":"#d1b5ca","rgb":{"r":209,"g":181,"b":202},"luminance":125.39473224182905},{"name":"Mary Rose","hex":"#d7b1b0","rgb":{"r":215,"g":177,"b":176},"luminance":123.81489216568417},{"name":"Mary's Garden","hex":"#69913d","rgb":{"r":105,"g":145,"b":61},"luminance":90.98663289736575},{"name":"Mary's Rose","hex":"#f7d1d4","rgb":{"r":247,"g":209,"b":212},"luminance":145.2221619519555},{"name":"Marzipan","hex":"#ebc881","rgb":{"r":235,"g":200,"b":129},"luminance":137.60885386122507},{"name":"Masala","hex":"#57534b","rgb":{"r":87,"g":83,"b":75},"luminance":55.888411231667696},{"name":"Masala Chai","hex":"#eeccaa","rgb":{"r":238,"g":204,"b":170},"luminance":140.63853720797866},{"name":"Mask","hex":"#ab878d","rgb":{"r":171,"g":135,"b":141},"luminance":95.66774870352077},{"name":"Masked Mauve","hex":"#c6b2be","rgb":{"r":198,"g":178,"b":190},"luminance":122.03014627541835},{"name":"Masoho Red","hex":"#d57c6b","rgb":{"r":213,"g":124,"b":107},"luminance":97.48291192306473},{"name":"Master","hex":"#3a4b61","rgb":{"r":58,"g":75,"b":97},"luminance":48.59243719963015},{"name":"Master Chief Green","hex":"#507d2a","rgb":{"r":80,"g":125,"b":42},"luminance":77.32387709498276},{"name":"Master Round Yellow","hex":"#e78303","rgb":{"r":231,"g":131,"b":3},"luminance":103.36243192765929},{"name":"Master Sword Blue","hex":"#00ffee","rgb":{"r":0,"g":255,"b":238},"luminance":152.12410936140267},{"name":"Masuhana Blue","hex":"#4d646c","rgb":{"r":77,"g":100,"b":108},"luminance":64.24432950074271},{"name":"Mat Dazzle Rose","hex":"#ff48d0","rgb":{"r":255,"g":72,"b":208},"luminance":90.3427067615311},{"name":"Matcha Picchu","hex":"#99bb00","rgb":{"r":153,"g":187,"b":0},"luminance":118.92023112153792},{"name":"Matcha Powder","hex":"#a0d404","rgb":{"r":160,"g":212,"b":4},"luminance":133.32360133149717},{"name":"Mate Tea","hex":"#7bb18d","rgb":{"r":123,"g":177,"b":141},"luminance":111.3818809591578},{"name":"Matisse","hex":"#365c7d","rgb":{"r":54,"g":92,"b":125},"luminance":58.13938279686154},{"name":"Matriarch","hex":"#7e6884","rgb":{"r":126,"g":104,"b":132},"luminance":73.29823247527868},{"name":"Matrix","hex":"#8e4d45","rgb":{"r":142,"g":77,"b":69},"luminance":62.51004176130424},{"name":"Matsuba Green","hex":"#454d32","rgb":{"r":69,"g":77,"b":50},"luminance":50.01077645867938},{"name":"Matt Black","hex":"#151515","rgb":{"r":21,"g":21,"b":21},"luminance":14.039658329175962},{"name":"Matt Blue","hex":"#2c6fbb","rgb":{"r":44,"g":111,"b":187},"luminance":69.80667667924037},{"name":"Matt Green","hex":"#39ad48","rgb":{"r":57,"g":173,"b":72},"luminance":103.29782531108773},{"name":"Matt Lilac","hex":"#dec6d3","rgb":{"r":222,"g":198,"b":211},"luminance":135.9893998663131},{"name":"Matt Pink","hex":"#ffb6c1","rgb":{"r":255,"g":182,"b":193},"luminance":133.08227374447733},{"name":"Matt Purple","hex":"#9370db","rgb":{"r":147,"g":112,"b":219},"luminance":82.93033763949113},{"name":"Matt Sage","hex":"#b2b9a5","rgb":{"r":178,"g":185,"b":165},"luminance":122.38983376490059},{"name":"Matt White","hex":"#ffffd4","rgb":{"r":255,"g":255,"b":212},"luminance":169.7144409707082},{"name":"Mattar Paneer","hex":"#884433","rgb":{"r":136,"g":68,"b":51},"luminance":57.27696350191759},{"name":"Matterhorn","hex":"#524b4b","rgb":{"r":82,"g":75,"b":75},"luminance":51.11198928822865},{"name":"Mature","hex":"#c4afb3","rgb":{"r":196,"g":175,"b":179},"luminance":120.0135795524823},{"name":"Mature Cognac","hex":"#9a463d","rgb":{"r":154,"g":70,"b":61},"luminance":62.10459187531949},{"name":"Maud","hex":"#988286","rgb":{"r":152,"g":130,"b":134},"luminance":90.12265519834622},{"name":"Maui","hex":"#21a5be","rgb":{"r":33,"g":165,"b":190},"luminance":99.73667486937791},{"name":"Maui Blue","hex":"#52a2b4","rgb":{"r":82,"g":162,"b":180},"luminance":100.32483022661937},{"name":"Maui Mai Tai","hex":"#b66044","rgb":{"r":182,"g":96,"b":68},"luminance":78.72077319234104},{"name":"Mauve","hex":"#e0b0ff","rgb":{"r":224,"g":176,"b":255},"luminance":126.50778165788853},{"name":"Mauve Aquarelle","hex":"#e3d2db","rgb":{"r":227,"g":210,"b":219},"luminance":142.91794213813742},{"name":"Mauve Chalk","hex":"#e5d0cf","rgb":{"r":229,"g":208,"b":207},"luminance":141.95977127693604},{"name":"Mauve Day","hex":"#ac8c8c","rgb":{"r":172,"g":140,"b":140},"luminance":98.25025793350366},{"name":"Mauve Glow","hex":"#d18489","rgb":{"r":209,"g":132,"b":137},"luminance":100.76118925955568},{"name":"Mauve It","hex":"#bb4466","rgb":{"r":187,"g":68,"b":102},"luminance":69.67611505386907},{"name":"Mauve Jazz","hex":"#908186","rgb":{"r":144,"g":129,"b":134},"luminance":88.43725482510185},{"name":"Mauve Madness","hex":"#aa7982","rgb":{"r":170,"g":121,"b":130},"luminance":88.58981899180063},{"name":"Mauve Magic","hex":"#bf91b2","rgb":{"r":191,"g":145,"b":178},"luminance":104.48811592712349},{"name":"Mauve Mist","hex":"#c49bd4","rgb":{"r":196,"g":155,"b":212},"luminance":110.8908980259426},{"name":"Mauve Mole","hex":"#7d716e","rgb":{"r":125,"g":113,"b":110},"luminance":77.16180263576014},{"name":"Mauve Morn","hex":"#ecd6d6","rgb":{"r":236,"g":214,"b":214},"luminance":146.13119049675876},{"name":"Mauve Musk","hex":"#a98ca1","rgb":{"r":169,"g":140,"b":161},"luminance":98.20287000388532},{"name":"Mauve Muslin","hex":"#b59ead","rgb":{"r":181,"g":158,"b":173},"luminance":109.17712196701285},{"name":"Mauve Mystery","hex":"#685c61","rgb":{"r":104,"g":92,"b":97},"luminance":63.29038312413664},{"name":"Mauve Mystique","hex":"#bb4477","rgb":{"r":187,"g":68,"b":119},"luminance":70.0256166056394},{"name":"Mauve Nymph","hex":"#c0ada6","rgb":{"r":192,"g":173,"b":166},"luminance":118.17953224226265},{"name":"Mauve Orchid","hex":"#b58299","rgb":{"r":181,"g":130,"b":153},"luminance":95.16462381053161},{"name":"Mauve Organdie","hex":"#d9c4d0","rgb":{"r":217,"g":196,"b":208},"luminance":134.19770987986345},{"name":"Mauve Pansy","hex":"#bebbc0","rgb":{"r":190,"g":187,"b":192},"luminance":125.52168738907233},{"name":"Mauve Seductress","hex":"#bb7788","rgb":{"r":187,"g":119,"b":136},"luminance":90.80792473127},{"name":"Mauve Shadows","hex":"#b598a3","rgb":{"r":181,"g":152,"b":163},"luminance":105.9956558590964},{"name":"Mauve Stone","hex":"#c4bab6","rgb":{"r":196,"g":186,"b":182},"luminance":125.64082713831519},{"name":"Mauve Taupe","hex":"#915f6d","rgb":{"r":145,"g":95,"b":109},"luminance":71.72026719135951},{"name":"Mauve Wine","hex":"#5b3644","rgb":{"r":91,"g":54,"b":68},"luminance":42.48748508678761},{"name":"Mauve Wisp","hex":"#eadde1","rgb":{"r":234,"g":221,"b":225},"luminance":149.60701248604627},{"name":"Mauve-a-Lish","hex":"#90686c","rgb":{"r":144,"g":104,"b":108},"luminance":75.71170836799286},{"name":"Mauvelous","hex":"#d6b3c0","rgb":{"r":214,"g":179,"b":192},"luminance":124.95450399645463},{"name":"Mauverine","hex":"#9d8888","rgb":{"r":157,"g":136,"b":136},"luminance":93.89977363657485},{"name":"Mauvewood","hex":"#a75d67","rgb":{"r":167,"g":93,"b":103},"luminance":74.90898700423067},{"name":"Mauvey Nude","hex":"#bb8899","rgb":{"r":187,"g":136,"b":153},"luminance":99.01330797928124},{"name":"Mauvey Pink","hex":"#8c8188","rgb":{"r":140,"g":129,"b":136},"luminance":87.90111685866113},{"name":"Maverick","hex":"#c8b1c0","rgb":{"r":200,"g":177,"b":192},"luminance":121.8610961094639},{"name":"Mawmaw's Pearls","hex":"#efe9dd","rgb":{"r":239,"g":233,"b":221},"luminance":156.3576624217694},{"name":"Maximum Blue","hex":"#47abcc","rgb":{"r":71,"g":171,"b":204},"luminance":105.20006704370488},{"name":"Maximum Blue Green","hex":"#30bfbf","rgb":{"r":48,"g":191,"b":191},"luminance":115.1099850968629},{"name":"Maximum Blue Purple","hex":"#acace6","rgb":{"r":172,"g":172,"b":230},"luminance":116.3015772893902},{"name":"Maximum Green","hex":"#5e8c31","rgb":{"r":94,"g":140,"b":49},"luminance":87.032769874341},{"name":"Maximum Green Yellow","hex":"#d9e650","rgb":{"r":217,"g":230,"b":80},"luminance":150.06891146736555},{"name":"Maximum Orange","hex":"#ff5b00","rgb":{"r":255,"g":91,"b":0},"luminance":93.0949832912601},{"name":"Maximum Purple","hex":"#733380","rgb":{"r":115,"g":51,"b":128},"luminance":47.86939166106041},{"name":"Maximum Red","hex":"#d92121","rgb":{"r":217,"g":33,"b":33},"luminance":67.81734272293481},{"name":"Maximum Red Purple","hex":"#a63a79","rgb":{"r":166,"g":58,"b":121},"luminance":61.74899600803239},{"name":"Maximum Yellow","hex":"#fafa37","rgb":{"r":250,"g":250,"b":55},"luminance":164.8103088401936},{"name":"Maximum Yellow Red","hex":"#f2ba49","rgb":{"r":242,"g":186,"b":73},"luminance":131.24650460869424},{"name":"May Apple","hex":"#92d599","rgb":{"r":146,"g":213,"b":153},"luminance":133.57636782380334},{"name":"May Green","hex":"#4c9141","rgb":{"r":76,"g":145,"b":65},"luminance":88.40730456811812},{"name":"Maya Blue","hex":"#73c2fb","rgb":{"r":115,"g":194,"b":251},"luminance":122.34904210904146},{"name":"Maya Green","hex":"#98d2d9","rgb":{"r":152,"g":210,"b":217},"luminance":133.68987339361198},{"name":"Mayan Chocolate","hex":"#655046","rgb":{"r":101,"g":80,"b":70},"luminance":56.39948227599257},{"name":"Mayan Gold","hex":"#b68c37","rgb":{"r":182,"g":140,"b":55},"luminance":98.7632726472751},{"name":"Mayan Treasure","hex":"#ce9844","rgb":{"r":206,"g":152,"b":68},"luminance":108.69607405973777},{"name":"Maybe Maui","hex":"#f6d48d","rgb":{"r":246,"g":212,"b":141},"luminance":145.44715029178124},{"name":"Maybe Mushroom","hex":"#e2d8cb","rgb":{"r":226,"g":216,"b":203},"luminance":145.52666045780063},{"name":"Maybeck Muslin","hex":"#eddfc9","rgb":{"r":237,"g":223,"b":201},"luminance":150.60440885312752},{"name":"Mayfly","hex":"#65663f","rgb":{"r":101,"g":102,"b":63},"luminance":67.4422464112814},{"name":"Maypole","hex":"#bee8d3","rgb":{"r":190,"g":232,"b":211},"luminance":149.50602955065057},{"name":"Mazarine Blue","hex":"#273c76","rgb":{"r":39,"g":60,"b":118},"luminance":39.46370009261676},{"name":"Maze","hex":"#5c5638","rgb":{"r":92,"g":86,"b":56},"luminance":57.84356354859199},{"name":"Mazzone","hex":"#b0907c","rgb":{"r":176,"g":144,"b":124},"luminance":100.56885529824827},{"name":"Mazzy Star","hex":"#bf5bb0","rgb":{"r":191,"g":91,"b":176},"luminance":80.7302784957416},{"name":"McKenzie","hex":"#8c6338","rgb":{"r":140,"g":99,"b":56},"luminance":71.90365654818955},{"name":"Mead","hex":"#ffc878","rgb":{"r":255,"g":200,"b":120},"luminance":140.65277254643792},{"name":"Meadow","hex":"#8bba94","rgb":{"r":139,"g":186,"b":148},"luminance":118.03681726054798},{"name":"Meadow Green","hex":"#739957","rgb":{"r":115,"g":153,"b":87},"luminance":96.6783878123751},{"name":"Meadow Lane","hex":"#c0d7cd","rgb":{"r":192,"g":215,"b":205},"luminance":140.60418695401643},{"name":"Meadow Mauve","hex":"#a9568c","rgb":{"r":169,"g":86,"b":140},"luminance":73.18835894457533},{"name":"Meadow Mist","hex":"#d3dec4","rgb":{"r":211,"g":222,"b":196},"luminance":146.49646703248513},{"name":"Meadow Violet","hex":"#764f82","rgb":{"r":118,"g":79,"b":130},"luminance":60.124097107565774},{"name":"Meadowbrook","hex":"#60a0a3","rgb":{"r":96,"g":160,"b":163},"luminance":99.95087163201728},{"name":"Meadowlark","hex":"#ead94e","rgb":{"r":234,"g":217,"b":78},"luminance":145.60123097350515},{"name":"Meadowood","hex":"#9da28e","rgb":{"r":157,"g":162,"b":142},"luminance":107.27798203266128},{"name":"Meadowsweet Mist","hex":"#d4e3e2","rgb":{"r":212,"g":227,"b":226},"luminance":149.7902474829386},{"name":"Meander","hex":"#8f8c79","rgb":{"r":143,"g":140,"b":121},"luminance":93.65889111557962},{"name":"Meat","hex":"#f08080","rgb":{"r":240,"g":128,"b":128},"luminance":104.9182660931832},{"name":"Meat Brown","hex":"#e5b73b","rgb":{"r":229,"g":183,"b":59},"luminance":127.5648390349002},{"name":"Meatbun","hex":"#f8eed3","rgb":{"r":248,"g":238,"b":211},"luminance":159.9840006250625},{"name":"Meatloaf","hex":"#663311","rgb":{"r":102,"g":51,"b":17},"luminance":42.77975943130115},{"name":"Mecca Gold","hex":"#c89134","rgb":{"r":200,"g":145,"b":52},"luminance":104.19090367685655},{"name":"Mecca Orange","hex":"#bd5745","rgb":{"r":189,"g":87,"b":69},"luminance":76.57290537781624},{"name":"Mecca Red","hex":"#663f3f","rgb":{"r":102,"g":63,"b":63},"luminance":48.4696140793384},{"name":"Mecha Grey","hex":"#8d847f","rgb":{"r":141,"g":132,"b":127},"luminance":89.39107349730173},{"name":"Mechagozilla","hex":"#dedce2","rgb":{"r":222,"g":220,"b":226},"luminance":147.46851250351716},{"name":"Mechanicus Standard Grey","hex":"#3d4b4d","rgb":{"r":61,"g":75,"b":77},"luminance":48.45528897860377},{"name":"Mechrite Red","hex":"#a31713","rgb":{"r":163,"g":23,"b":19},"luminance":50.61880802626628},{"name":"Medal Bronze","hex":"#977547","rgb":{"r":151,"g":117,"b":71},"luminance":82.58783250576323},{"name":"Medallion","hex":"#c3a679","rgb":{"r":195,"g":166,"b":121},"luminance":114.38833343046832},{"name":"Medicine Man","hex":"#69556d","rgb":{"r":105,"g":85,"b":109},"luminance":60.245850695296845},{"name":"Medicine Wheel","hex":"#99a28c","rgb":{"r":153,"g":162,"b":140},"luminance":106.72571594981221},{"name":"Medieval Blue","hex":"#29304e","rgb":{"r":41,"g":48,"b":78},"luminance":31.98808717319621},{"name":"Medieval Cobblestone","hex":"#878573","rgb":{"r":135,"g":133,"b":115},"luminance":88.86105089407843},{"name":"Medieval Forest","hex":"#007e6b","rgb":{"r":0,"g":126,"b":107},"luminance":74.96111423931744},{"name":"Medieval Wine","hex":"#8c7d88","rgb":{"r":140,"g":125,"b":136},"luminance":85.88669420230353},{"name":"Mediterranea","hex":"#32575d","rgb":{"r":50,"g":87,"b":93},"luminance":54.25815758943534},{"name":"Mediterranean Blue","hex":"#0090a8","rgb":{"r":0,"g":144,"b":168},"luminance":86.67053644693794},{"name":"Mediterranean Cove","hex":"#007b84","rgb":{"r":0,"g":123,"b":132},"luminance":73.75246914510727},{"name":"Mediterranean Sea","hex":"#1e8cab","rgb":{"r":30,"g":140,"b":171},"luminance":84.93544216638892},{"name":"Mediterranean Swirl","hex":"#2999a2","rgb":{"r":41,"g":153,"b":162},"luminance":92.50603129526203},{"name":"Medium Aquamarine","hex":"#66ddaa","rgb":{"r":102,"g":221,"b":170},"luminance":134.665537287756},{"name":"Medium Blue","hex":"#0000cd","rgb":{"r":0,"g":0,"b":205},"luminance":23.37},{"name":"Medium Brown","hex":"#7f5112","rgb":{"r":127,"g":81,"b":18},"luminance":60.88412471244044},{"name":"Medium Candy Apple Red","hex":"#e2062c","rgb":{"r":226,"g":6,"b":44},"luminance":67.8513833020374},{"name":"Medium Carmine","hex":"#af4035","rgb":{"r":175,"g":64,"b":53},"luminance":64.69749618802878},{"name":"Medium Champagne","hex":"#f3e5ac","rgb":{"r":243,"g":229,"b":172},"luminance":154.05536745598965},{"name":"Medium Electric Blue","hex":"#035096","rgb":{"r":3,"g":80,"b":150},"luminance":49.9845597059732},{"name":"Medium Goldenrod","hex":"#eaeaae","rgb":{"r":234,"g":234,"b":174},"luminance":155.42177523114322},{"name":"Medium Green","hex":"#3c824e","rgb":{"r":60,"g":130,"b":78},"luminance":78.89313889052711},{"name":"Medium Grey","hex":"#7d7f7c","rgb":{"r":125,"g":127,"b":124},"luminance":84.58292098290292},{"name":"Medium Grey Green","hex":"#4d6b53","rgb":{"r":77,"g":107,"b":83},"luminance":67.56151607239138},{"name":"Medium Gunship Grey","hex":"#3f4952","rgb":{"r":63,"g":73,"b":82},"luminance":47.73285947856047},{"name":"Medium Jungle Green","hex":"#1c352d","rgb":{"r":28,"g":53,"b":45},"luminance":32.62363568028554},{"name":"Medium Lavender Magenta","hex":"#dda0fd","rgb":{"r":221,"g":160,"b":253},"luminance":118.4029628218821},{"name":"Medium Orchid","hex":"#ba55d3","rgb":{"r":186,"g":85,"b":211},"luminance":78.49218392298688},{"name":"Medium Persian Blue","hex":"#0067a5","rgb":{"r":0,"g":103,"b":165},"luminance":63.31941740888019},{"name":"Medium Pink","hex":"#f36196","rgb":{"r":243,"g":97,"b":150},"luminance":93.88023950757689},{"name":"Medium Purple","hex":"#9e43a2","rgb":{"r":158,"g":67,"b":162},"luminance":64.18445161407863},{"name":"Medium Red Violet","hex":"#bb3385","rgb":{"r":187,"g":51,"b":133},"luminance":65.21022758739613},{"name":"Medium Roast","hex":"#3c2005","rgb":{"r":60,"g":32,"b":5},"luminance":25.980899830452366},{"name":"Medium Ruby","hex":"#aa4069","rgb":{"r":170,"g":64,"b":105},"luminance":64.32980976188254},{"name":"Medium Scarlet","hex":"#fc2847","rgb":{"r":252,"g":40,"b":71},"luminance":79.33564356580212},{"name":"Medium Sea Green","hex":"#3cb371","rgb":{"r":60,"g":179,"b":113},"luminance":107.3691056729076},{"name":"Medium Sky Blue","hex":"#80daeb","rgb":{"r":128,"g":218,"b":235},"luminance":136.22682276262628},{"name":"Medium Slate Blue","hex":"#7b68ee","rgb":{"r":123,"g":104,"b":238},"luminance":76.25976302743145},{"name":"Medium Spring Bud","hex":"#c9dc87","rgb":{"r":201,"g":220,"b":135},"luminance":143.2685642456153},{"name":"Medium Spring Green","hex":"#00fa9a","rgb":{"r":0,"g":250,"b":154},"luminance":147.7963992660173},{"name":"Medium Taupe","hex":"#674c47","rgb":{"r":103,"g":76,"b":71},"luminance":54.810570048121185},{"name":"Medium Turquoise","hex":"#48d1cc","rgb":{"r":72,"g":209,"b":204},"luminance":126.7099633375371},{"name":"Medium Tuscan Red","hex":"#794431","rgb":{"r":121,"g":68,"b":49},"luminance":54.160968353603124},{"name":"Medium Vermilion","hex":"#d9603b","rgb":{"r":217,"g":96,"b":59},"luminance":86.20087394568571},{"name":"Medium Violet Red","hex":"#c71585","rgb":{"r":199,"g":21,"b":133},"luminance":62.62755123745459},{"name":"Medium Wood","hex":"#a68064","rgb":{"r":166,"g":128,"b":100},"luminance":90.76845515926775},{"name":"Medlar","hex":"#d5d7bf","rgb":{"r":213,"g":215,"b":191},"luminance":143.03091648311562},{"name":"Medusa Green","hex":"#998800","rgb":{"r":153,"g":136,"b":0},"luminance":92.01052240369032},{"name":"Medusa's Snakes","hex":"#777711","rgb":{"r":119,"g":119,"b":17},"luminance":78.416866897371},{"name":"Mee-hua Sunset","hex":"#ee7700","rgb":{"r":238,"g":119,"b":0},"luminance":99.7169587031213},{"name":"Meek Moss Green","hex":"#869f98","rgb":{"r":134,"g":159,"b":152},"luminance":103.03685180070283},{"name":"Meerkat","hex":"#a46f44","rgb":{"r":164,"g":111,"b":68},"luminance":81.91494032836745},{"name":"Mega Magenta","hex":"#d767ad","rgb":{"r":215,"g":103,"b":173},"luminance":90.42704811061787},{"name":"Mega Metal Mecha","hex":"#dfcbcf","rgb":{"r":223,"g":203,"b":207},"luminance":138.57139623313316},{"name":"Mega Metal Phoenix","hex":"#c6ccd4","rgb":{"r":198,"g":204,"b":212},"luminance":135.75180489407865},{"name":"Megadrive Screen","hex":"#4a40ad","rgb":{"r":74,"g":64,"b":173},"luminance":47.8526047775876},{"name":"Megaman","hex":"#3cbcfc","rgb":{"r":60,"g":188,"b":252},"luminance":115.43651207481972},{"name":"Megaman Helmet","hex":"#0058f8","rgb":{"r":0,"g":88,"b":248},"luminance":58.88674146189446},{"name":"Méi Gūi Hóng Red","hex":"#fe023c","rgb":{"r":254,"g":2,"b":60},"luminance":76.26243368789119},{"name":"Méi Gūi Zǐ Purple","hex":"#e03fd8","rgb":{"r":224,"g":63,"b":216},"luminance":80.37238526384544},{"name":"Méi Hēi Coal","hex":"#123120","rgb":{"r":18,"g":49,"b":32},"luminance":29.48870965301805},{"name":"Melancholia","hex":"#12390d","rgb":{"r":18,"g":57,"b":13},"luminance":33.92148182199592},{"name":"Melancholic Macaw","hex":"#aa1133","rgb":{"r":170,"g":17,"b":51},"luminance":52.12554016027076},{"name":"Melancholic Sea","hex":"#53778f","rgb":{"r":83,"g":119,"b":143},"luminance":75.90178062469944},{"name":"Melancholy","hex":"#dd8899","rgb":{"r":221,"g":136,"b":153},"luminance":105.08951341118674},{"name":"Melanie","hex":"#e0b7c2","rgb":{"r":224,"g":183,"b":194},"luminance":128.5074833346292},{"name":"Melanzane","hex":"#342931","rgb":{"r":52,"g":41,"b":49},"luminance":29.191851414393025},{"name":"Melbourne Cup","hex":"#45c3ad","rgb":{"r":69,"g":195,"b":173},"luminance":117.96962181002361},{"name":"Melissa","hex":"#b5d96b","rgb":{"r":181,"g":217,"b":107},"luminance":138.93547785213104},{"name":"Mellifluous Blue","hex":"#c9e1e0","rgb":{"r":201,"g":225,"b":224},"luminance":147.3356125381776},{"name":"Mellow Apricot","hex":"#f8b878","rgb":{"r":248,"g":184,"b":120},"luminance":131.72467334558092},{"name":"Mellow Buff","hex":"#d8b998","rgb":{"r":216,"g":185,"b":152},"luminance":127.53127720288855},{"name":"Mellow Flower","hex":"#f1dfe9","rgb":{"r":241,"g":223,"b":233},"luminance":151.7666337704042},{"name":"Mellow Green","hex":"#d5d593","rgb":{"r":213,"g":213,"b":147},"luminance":141.31388995424334},{"name":"Mellow Mango","hex":"#cc4400","rgb":{"r":204,"g":68,"b":0},"luminance":72.89580970124413},{"name":"Mellow Mauve","hex":"#996378","rgb":{"r":153,"g":99,"b":120},"luminance":75.21337100542695},{"name":"Mellow Melon","hex":"#ee2266","rgb":{"r":238,"g":34,"b":102},"luminance":74.8168590091832},{"name":"Mellow Mint","hex":"#ddedbd","rgb":{"r":221,"g":237,"b":189},"luminance":155.5145025970247},{"name":"Mellow Mood","hex":"#b1b7a1","rgb":{"r":177,"g":183,"b":161},"luminance":121.14860496926903},{"name":"Mellow Rose","hex":"#d9a6a1","rgb":{"r":217,"g":166,"b":161},"luminance":118.49732642131636},{"name":"Mellow Yellow","hex":"#f8de7f","rgb":{"r":248,"g":222,"b":127},"luminance":150.63157100687758},{"name":"Melmac Silver","hex":"#b6b2a1","rgb":{"r":182,"g":178,"b":161},"luminance":119.22882300853263},{"name":"Melodious","hex":"#7bb5ae","rgb":{"r":123,"g":181,"b":174},"luminance":114.16847040229628},{"name":"Melon","hex":"#ff7855","rgb":{"r":255,"g":120,"b":85},"luminance":104.25444702745297},{"name":"Melon Baby","hex":"#f47869","rgb":{"r":244,"g":120,"b":105},"luminance":102.11587749219022},{"name":"Melon Balls","hex":"#f2bd85","rgb":{"r":242,"g":189,"b":133},"luminance":133.3188495937465},{"name":"Melon Green","hex":"#74ac8d","rgb":{"r":116,"g":172,"b":141},"luminance":107.95870797670746},{"name":"Melon Ice","hex":"#f4d9c8","rgb":{"r":244,"g":217,"b":200},"luminance":148.55244049493095},{"name":"Melon Melody","hex":"#f9c291","rgb":{"r":249,"g":194,"b":145},"luminance":137.05616069699312},{"name":"Melon Pink","hex":"#f1d4c4","rgb":{"r":241,"g":212,"b":196},"luminance":145.52684615905065},{"name":"Melon Seed","hex":"#332c22","rgb":{"r":51,"g":44,"b":34},"luminance":30.243031610604117},{"name":"Melon Sprinkle","hex":"#ffcd9d","rgb":{"r":255,"g":205,"b":157},"luminance":143.57628862037072},{"name":"Melon Twist","hex":"#aa6864","rgb":{"r":170,"g":104,"b":100},"luminance":80.25277069360284},{"name":"Melon Water","hex":"#fdbcb4","rgb":{"r":253,"g":188,"b":180},"luminance":135.35872984407027},{"name":"Melrose","hex":"#c3b9dd","rgb":{"r":195,"g":185,"b":221},"luminance":125.80574186419314},{"name":"Melt Ice","hex":"#b4cbe3","rgb":{"r":180,"g":203,"b":227},"luminance":133.2876858715763},{"name":"Melt with You","hex":"#e3cfab","rgb":{"r":227,"g":207,"b":171},"luminance":140.53895277110897},{"name":"Melted Butter","hex":"#ffcf53","rgb":{"r":255,"g":207,"b":83},"luminance":143.76114408977134},{"name":"Melted Copper","hex":"#ce8544","rgb":{"r":206,"g":133,"b":68},"luminance":99.74465088915795},{"name":"Melted Wax","hex":"#f6e6c5","rgb":{"r":246,"g":230,"b":197},"luminance":155.3777744080536},{"name":"Melting Glacier","hex":"#e9f9f5","rgb":{"r":233,"g":249,"b":245},"luminance":164.30824190526778},{"name":"Melting Ice","hex":"#cae1d9","rgb":{"r":202,"g":225,"b":217},"luminance":147.3217318422506},{"name":"Melting Moment","hex":"#bba2b6","rgb":{"r":187,"g":162,"b":182},"luminance":112.24799289519613},{"name":"Melting Point","hex":"#cbe1e4","rgb":{"r":203,"g":225,"b":228},"luminance":147.66013510084568},{"name":"Melting Snowman","hex":"#dae5e0","rgb":{"r":218,"g":229,"b":224},"luminance":151.55963627892487},{"name":"Melting Violet","hex":"#d4b8bf","rgb":{"r":212,"g":184,"b":191},"luminance":127.11362509188383},{"name":"Meltwater","hex":"#79c0cc","rgb":{"r":121,"g":192,"b":204},"luminance":120.63147679192193},{"name":"Memoir","hex":"#ecf0da","rgb":{"r":236,"g":240,"b":218},"luminance":159.5119882642054},{"name":"Memorize","hex":"#9197a4","rgb":{"r":145,"g":151,"b":164},"luminance":100.42765659916594},{"name":"Memory Lane","hex":"#c7d1db","rgb":{"r":199,"g":209,"b":219},"luminance":138.61741826336257},{"name":"Men Brown","hex":"#5e5239","rgb":{"r":94,"g":82,"b":57},"luminance":56.11642536726658},{"name":"Mendocino Hills","hex":"#837a64","rgb":{"r":131,"g":122,"b":100},"luminance":82.41805358657773},{"name":"Menoth White Base","hex":"#f3e8b8","rgb":{"r":243,"g":232,"b":184},"luminance":155.77263585431172},{"name":"Menoth White Highlight","hex":"#f0f1ce","rgb":{"r":240,"g":241,"b":206},"luminance":160.35556724042976},{"name":"Mental Floss","hex":"#deb4c5","rgb":{"r":222,"g":180,"b":197},"luminance":126.78500009070473},{"name":"Mental Note","hex":"#eaeede","rgb":{"r":234,"g":238,"b":222},"luminance":158.2829822059213},{"name":"Menthol","hex":"#c1f9a2","rgb":{"r":193,"g":249,"b":162},"luminance":158.2238523168994},{"name":"Mephiston Red","hex":"#9a1115","rgb":{"r":154,"g":17,"b":21},"luminance":47.17569069976613},{"name":"Meranda's Spike","hex":"#614251","rgb":{"r":97,"g":66,"b":81},"luminance":49.268482105703235},{"name":"Mercer Charcoal","hex":"#aca495","rgb":{"r":172,"g":164,"b":149},"luminance":110.45764438915036},{"name":"Merchant Marine Blue","hex":"#0343df","rgb":{"r":3,"g":67,"b":223},"luminance":46.83858381719072},{"name":"Mercurial","hex":"#b6b0a9","rgb":{"r":182,"g":176,"b":169},"luminance":118.34638492155136},{"name":"Mercury","hex":"#ebebeb","rgb":{"r":235,"g":235,"b":235},"luminance":157.11046225506433},{"name":"Mercury Mist","hex":"#89c8c3","rgb":{"r":137,"g":200,"b":195},"luminance":126.31270826405392},{"name":"Merguez","hex":"#650021","rgb":{"r":101,"g":0,"b":33},"luminance":30.432420952004456},{"name":"Meridian Star","hex":"#7bc8b2","rgb":{"r":123,"g":200,"b":178},"luminance":124.68790235223302},{"name":"Merin's Fire","hex":"#ff9408","rgb":{"r":255,"g":148,"b":8},"luminance":115.59226247893929},{"name":"Meringue","hex":"#f3e4b3","rgb":{"r":243,"g":228,"b":179},"luminance":153.64738650885016},{"name":"Meringue Tips","hex":"#c2a080","rgb":{"r":194,"g":160,"b":128},"luminance":111.34895105029054},{"name":"Merino","hex":"#e1dbd0","rgb":{"r":225,"g":219,"b":208},"luminance":147.01720436057815},{"name":"Meristem","hex":"#aae1ce","rgb":{"r":170,"g":225,"b":206},"luminance":143.4538001622822},{"name":"Merlin","hex":"#4f4e48","rgb":{"r":79,"g":78,"b":72},"luminance":52.16972973861374},{"name":"Merlin's Choice","hex":"#9f8898","rgb":{"r":159,"g":136,"b":152},"luminance":94.51748245166075},{"name":"Merlin's Cloak","hex":"#89556e","rgb":{"r":137,"g":85,"b":110},"luminance":65.76267934018503},{"name":"Merlot","hex":"#730039","rgb":{"r":115,"g":0,"b":57},"luminance":34.9936026867769},{"name":"Mermaid","hex":"#817a65","rgb":{"r":129,"g":122,"b":101},"luminance":82.1514408455506},{"name":"Mermaid Net","hex":"#22cccc","rgb":{"r":34,"g":204,"b":204},"luminance":122.40822111279944},{"name":"Mermaid Tears","hex":"#d9e6a6","rgb":{"r":217,"g":230,"b":166},"luminance":150.98218956221294},{"name":"Mermaid's Cove","hex":"#8aa786","rgb":{"r":138,"g":167,"b":134},"luminance":107.45042420111703},{"name":"Mermaid's Kiss","hex":"#59c8a5","rgb":{"r":89,"g":200,"b":165},"luminance":121.8389158725569},{"name":"Mermaid's Tail","hex":"#337b35","rgb":{"r":51,"g":123,"b":53},"luminance":74.04067912978648},{"name":"Merry Music","hex":"#ced3c1","rgb":{"r":206,"g":211,"b":193},"luminance":140.06593193564237},{"name":"Merrylyn","hex":"#a5d0af","rgb":{"r":165,"g":208,"b":175},"luminance":133.18925610198443},{"name":"Mesa Beige","hex":"#f2ebd6","rgb":{"r":242,"g":235,"b":214},"luminance":157.6694897721179},{"name":"Mesa Pink","hex":"#ddb1a8","rgb":{"r":221,"g":177,"b":168},"luminance":124.61234106620418},{"name":"Mesa Red","hex":"#92555b","rgb":{"r":146,"g":85,"b":91},"luminance":67.10292554725166},{"name":"Mesa Rose","hex":"#eeb5af","rgb":{"r":238,"g":181,"b":175},"luminance":129.4235594974887},{"name":"Mesa Tan","hex":"#a78b71","rgb":{"r":167,"g":139,"b":113},"luminance":96.52288879846063},{"name":"Meški Black","hex":"#1f0b1e","rgb":{"r":31,"g":11,"b":30},"luminance":11.802695031220624},{"name":"Mesmerize","hex":"#8e9074","rgb":{"r":142,"g":144,"b":116},"luminance":95.51198209648881},{"name":"Message Green","hex":"#37b8af","rgb":{"r":55,"g":184,"b":175},"luminance":111.05930212728693},{"name":"Messinesi","hex":"#fee2be","rgb":{"r":254,"g":226,"b":190},"luminance":154.38962646499277},{"name":"Metal","hex":"#babfbc","rgb":{"r":186,"g":191,"b":188},"luminance":126.97428601492508},{"name":"Metal Chi","hex":"#9c9c9b","rgb":{"r":156,"g":156,"b":155},"luminance":104.27522630040175},{"name":"Metal Deluxe","hex":"#244343","rgb":{"r":36,"g":67,"b":67},"luminance":41.48461137578608},{"name":"Metal Flake","hex":"#838782","rgb":{"r":131,"g":135,"b":130},"luminance":89.63042444393533},{"name":"Metal Fringe","hex":"#837e74","rgb":{"r":131,"g":126,"b":116},"luminance":84.73170705821994},{"name":"Metal Gear","hex":"#a2c3db","rgb":{"r":162,"g":195,"b":219},"luminance":126.77451331004981},{"name":"Metal Petal","hex":"#b090b2","rgb":{"r":176,"g":144,"b":178},"luminance":101.61709218433677},{"name":"Metal Spark","hex":"#eeff99","rgb":{"r":238,"g":255,"b":153},"luminance":166.65489141636377},{"name":"Metalise","hex":"#34373c","rgb":{"r":52,"g":55,"b":60},"luminance":36.48077752734993},{"name":"Metallic Blue","hex":"#4f738e","rgb":{"r":79,"g":115,"b":142},"luminance":73.32753923322396},{"name":"Metallic Bronze","hex":"#554a3c","rgb":{"r":85,"g":74,"b":60},"luminance":50.78944446437664},{"name":"Metallic Copper","hex":"#6e3d34","rgb":{"r":110,"g":61,"b":52},"luminance":48.97994010817081},{"name":"Metallic Gold","hex":"#d4af37","rgb":{"r":212,"g":175,"b":55},"luminance":120.87091076433568},{"name":"Metallic Mist","hex":"#cdccbe","rgb":{"r":205,"g":204,"b":190},"luminance":136.25643518381065},{"name":"Metallic Seaweed","hex":"#0a7e8c","rgb":{"r":10,"g":126,"b":140},"luminance":75.7234385378794},{"name":"Metallic Sunburst","hex":"#9c7c38","rgb":{"r":156,"g":124,"b":56},"luminance":86.68627997555322},{"name":"Meteor","hex":"#bb7431","rgb":{"r":187,"g":116,"b":49},"luminance":88.28356262068267},{"name":"Meteor Shower","hex":"#5533ff","rgb":{"r":85,"g":51,"b":255},"luminance":48.85909428141295},{"name":"Meteorite","hex":"#4a3b6a","rgb":{"r":74,"g":59,"b":106},"luminance":42.83722237727371},{"name":"Methadone","hex":"#cc2233","rgb":{"r":204,"g":34,"b":51},"luminance":64.44095263107148},{"name":"Methyl Blue","hex":"#0074a8","rgb":{"r":0,"g":116,"b":168},"luminance":70.73414711438882},{"name":"Metroid Red","hex":"#f83800","rgb":{"r":248,"g":56,"b":0},"luminance":81.11157431587677},{"name":"Metropolis","hex":"#61584f","rgb":{"r":97,"g":88,"b":79},"luminance":59.921818905971136},{"name":"Mette Penne","hex":"#f9e1d4","rgb":{"r":249,"g":225,"b":212},"luminance":153.5280080311081},{"name":"Mettwurst","hex":"#df7163","rgb":{"r":223,"g":113,"b":99},"luminance":94.72590820889499},{"name":"Mexican Chile","hex":"#d16d76","rgb":{"r":209,"g":109,"b":118},"luminance":90.4428309707298},{"name":"Mexican Chocolate","hex":"#6f5a48","rgb":{"r":111,"g":90,"b":72},"luminance":62.92765596301835},{"name":"Mexican Milk","hex":"#ffb9b2","rgb":{"r":255,"g":185,"b":178},"luminance":134.23091787662037},{"name":"Mexican Moonlight","hex":"#c99387","rgb":{"r":201,"g":147,"b":135},"luminance":106.27574239684238},{"name":"Mexican Mudkip","hex":"#fcd8dc","rgb":{"r":252,"g":216,"b":220},"luminance":149.60795021655767},{"name":"Mexican Pink","hex":"#e4007c","rgb":{"r":228,"g":0,"b":124},"luminance":69.6221809483156},{"name":"Mexican Red","hex":"#9b3d3d","rgb":{"r":155,"g":61,"b":61},"luminance":58.97760922587486},{"name":"Mexican Red Papaya","hex":"#c6452f","rgb":{"r":198,"g":69,"b":47},"luminance":71.93106406136364},{"name":"Mexican Sand Dollar","hex":"#dad4c5","rgb":{"r":218,"g":212,"b":197},"luminance":142.2651187888303},{"name":"Mexican Standoff","hex":"#ec9f76","rgb":{"r":236,"g":159,"b":118},"luminance":117.77641227767128},{"name":"Mǐ Bái Beige","hex":"#dad7ad","rgb":{"r":218,"g":215,"b":173},"luminance":143.40624963020267},{"name":"Mì Chéng Honey","hex":"#e8af45","rgb":{"r":232,"g":175,"b":69},"luminance":124.20233091613055},{"name":"Miami Jade","hex":"#17917f","rgb":{"r":23,"g":145,"b":127},"luminance":86.61102030342327},{"name":"Miami Spice","hex":"#907a6e","rgb":{"r":144,"g":122,"b":110},"luminance":84.49636519993034},{"name":"Mica Creek","hex":"#70828f","rgb":{"r":112,"g":130,"b":143},"luminance":84.91417695532355},{"name":"Microchip","hex":"#babcc0","rgb":{"r":186,"g":188,"b":192},"luminance":125.50078994173701},{"name":"MicroProse Red","hex":"#ee172b","rgb":{"r":238,"g":23,"b":43},"luminance":72.597085678421},{"name":"Microwave Blue","hex":"#2d5254","rgb":{"r":45,"g":82,"b":84},"luminance":50.88829685693952},{"name":"Mid Blue","hex":"#276ab3","rgb":{"r":39,"g":106,"b":179},"luminance":66.51286372574856},{"name":"Mid Cypress","hex":"#779781","rgb":{"r":119,"g":151,"b":129},"luminance":96.6374242516842},{"name":"Mid Green","hex":"#50a747","rgb":{"r":80,"g":167,"b":71},"luminance":101.22926492373635},{"name":"Mid Grey","hex":"#5f5f6e","rgb":{"r":95,"g":95,"b":110},"luminance":63.82656852753404},{"name":"Mid Spring Morning","hex":"#cff7ef","rgb":{"r":207,"g":247,"b":239},"luminance":159.98405572431275},{"name":"Mid Tan","hex":"#c4915e","rgb":{"r":196,"g":145,"b":94},"luminance":103.8933332654218},{"name":"Mid-century Gem","hex":"#81b39c","rgb":{"r":129,"g":179,"b":156},"luminance":113.33281972138519},{"name":"Midas Finger Gold","hex":"#f6b404","rgb":{"r":246,"g":180,"b":4},"luminance":128.7417354706701},{"name":"Midas Touch","hex":"#e8bd45","rgb":{"r":232,"g":189,"b":69},"luminance":131.08067221753174},{"name":"Midday Sun","hex":"#ffe1a3","rgb":{"r":255,"g":225,"b":163},"luminance":153.63071429242265},{"name":"Middle Blue","hex":"#7ed4e6","rgb":{"r":126,"g":212,"b":230},"luminance":132.63908855235698},{"name":"Middle Blue Green","hex":"#8dd9cc","rgb":{"r":141,"g":217,"b":204},"luminance":136.1750067303101},{"name":"Middle Blue Purple","hex":"#8b72be","rgb":{"r":139,"g":114,"b":190},"luminance":81.69755837844849},{"name":"Middle Ditch","hex":"#7c6942","rgb":{"r":124,"g":105,"b":66},"luminance":72.31952417570237},{"name":"Middle Green","hex":"#4d8c57","rgb":{"r":77,"g":140,"b":87},"luminance":85.91843604838253},{"name":"Middle Green Yellow","hex":"#acbf60","rgb":{"r":172,"g":191,"b":96},"luminance":123.83388877443846},{"name":"Middle Purple","hex":"#d982b5","rgb":{"r":217,"g":130,"b":181},"luminance":102.2681853999571},{"name":"Middle Red","hex":"#e58e73","rgb":{"r":229,"g":142,"b":115},"luminance":108.66480229126633},{"name":"Middle Red Purple","hex":"#210837","rgb":{"r":33,"g":8,"b":55},"luminance":12.59853185891118},{"name":"Middle Safflower","hex":"#c85179","rgb":{"r":200,"g":81,"b":121},"luminance":77.63395935413831},{"name":"Middle Yellow","hex":"#ffeb00","rgb":{"r":255,"g":235,"b":0},"luminance":157.6138415558735},{"name":"Middle Yellow Red","hex":"#ecb176","rgb":{"r":236,"g":177,"b":118},"luminance":126.31403960367983},{"name":"Middlestone","hex":"#c7ab84","rgb":{"r":199,"g":171,"b":132},"luminance":117.65353132821811},{"name":"Middy's Purple","hex":"#aa8ed6","rgb":{"r":170,"g":142,"b":214},"luminance":100.63171981040571},{"name":"Midnight","hex":"#03012d","rgb":{"r":3,"g":1,"b":45},"luminance":5.240808907029525},{"name":"Midnight Badger","hex":"#585960","rgb":{"r":88,"g":89,"b":96},"luminance":59.50986077113607},{"name":"Midnight Blue","hex":"#020035","rgb":{"r":2,"g":0,"b":53},"luminance":6.071521061480393},{"name":"Midnight Blush","hex":"#979fbf","rgb":{"r":151,"g":159,"b":191},"luminance":105.94143743597215},{"name":"Midnight Brown","hex":"#706048","rgb":{"r":112,"g":96,"b":72},"luminance":66.0633431791035},{"name":"Midnight Clover","hex":"#3c574e","rgb":{"r":60,"g":87,"b":78},"luminance":54.853933541725155},{"name":"Midnight Dreams","hex":"#002233","rgb":{"r":0,"g":34,"b":51},"luminance":20.78760111220147},{"name":"Midnight Escape","hex":"#403c40","rgb":{"r":64,"g":60,"b":64},"luminance":40.74145937494139},{"name":"Midnight Express","hex":"#21263a","rgb":{"r":33,"g":38,"b":58},"luminance":25.271206322611505},{"name":"Midnight Garden","hex":"#637057","rgb":{"r":99,"g":112,"b":87},"luminance":72.77952638620287},{"name":"Midnight Green","hex":"#004953","rgb":{"r":0,"g":73,"b":83},"luminance":43.88322737675523},{"name":"Midnight Grey","hex":"#666a6d","rgb":{"r":102,"g":106,"b":109},"luminance":70.39965031163152},{"name":"Midnight Haze","hex":"#3e505f","rgb":{"r":62,"g":80,"b":95},"luminance":51.635142529095425},{"name":"Midnight Hour","hex":"#3b484f","rgb":{"r":59,"g":72,"b":79},"luminance":46.67503200855892},{"name":"Midnight Merlot","hex":"#880044","rgb":{"r":136,"g":0,"b":68},"luminance":41.39630901421044},{"name":"Midnight Moss","hex":"#242e28","rgb":{"r":36,"g":46,"b":40},"luminance":29.42388995357344},{"name":"Midnight Navy","hex":"#34414e","rgb":{"r":52,"g":65,"b":78},"luminance":42.149875361618804},{"name":"Midnight Pearl","hex":"#5f6c74","rgb":{"r":95,"g":108,"b":116},"luminance":70.71612982198616},{"name":"Midnight Purple","hex":"#280137","rgb":{"r":40,"g":1,"b":55},"luminance":13.516621952248277},{"name":"Midnight Sea","hex":"#565b8d","rgb":{"r":86,"g":91,"b":141},"luminance":61.424418279703715},{"name":"Midnight Sky","hex":"#424753","rgb":{"r":66,"g":71,"b":83},"luminance":47.073692536277626},{"name":"Midnight Spruce","hex":"#555b53","rgb":{"r":85,"g":91,"b":83},"luminance":59.9068239685597},{"name":"Midnight Sun","hex":"#4e5a6d","rgb":{"r":78,"g":90,"b":109},"luminance":59.07055154643471},{"name":"Midnight Violet","hex":"#6a75ad","rgb":{"r":106,"g":117,"b":173},"luminance":78.16822859064929},{"name":"Midori","hex":"#2a603b","rgb":{"r":42,"g":96,"b":59},"luminance":58.124782528625424},{"name":"Midori Green","hex":"#3eb370","rgb":{"r":62,"g":179,"b":112},"luminance":107.4570360516239},{"name":"Midsummer's Dream","hex":"#b4d0d9","rgb":{"r":180,"g":208,"b":217},"luminance":135.70554248076974},{"name":"Midwinter Fire","hex":"#dd1100","rgb":{"r":221,"g":17,"b":0},"luminance":66.82824763526273},{"name":"Mighty Mauve","hex":"#8f7f85","rgb":{"r":143,"g":127,"b":133},"luminance":87.26740911703521},{"name":"Mighty Midnight","hex":"#000133","rgb":{"r":0,"g":1,"b":51},"luminance":5.843557563676429},{"name":"Migol Blue","hex":"#283482","rgb":{"r":40,"g":52,"b":130},"luminance":35.977612149780036},{"name":"Mikado","hex":"#3f3623","rgb":{"r":63,"g":54,"b":35},"luminance":37.087947813272166},{"name":"Mikado Yellow","hex":"#ffc40c","rgb":{"r":255,"g":196,"b":12},"luminance":138.0294684225075},{"name":"Mikan Orange","hex":"#f08300","rgb":{"r":240,"g":131,"b":0},"luminance":105.17911488979168},{"name":"Mike Wazowski Green","hex":"#11ee55","rgb":{"r":17,"g":238,"b":85},"luminance":140.13386252080542},{"name":"Milan","hex":"#f6f493","rgb":{"r":246,"g":244,"b":147},"luminance":161.8804542370696},{"name":"Milano Red","hex":"#9e3332","rgb":{"r":158,"g":51,"b":50},"luminance":56.21850703282682},{"name":"Mild Blue Yonder","hex":"#a2add0","rgb":{"r":162,"g":173,"b":208},"luminance":114.98306131339518},{"name":"Mild Mint","hex":"#dce6e3","rgb":{"r":220,"g":230,"b":227},"luminance":152.3954703526322},{"name":"Mildura","hex":"#667960","rgb":{"r":102,"g":121,"b":96},"luminance":78.0687765306976},{"name":"Miles","hex":"#829ba0","rgb":{"r":130,"g":155,"b":160},"luminance":100.60737907827635},{"name":"Militant Vegan","hex":"#229955","rgb":{"r":34,"g":153,"b":85},"luminance":90.90247178707517},{"name":"Military Green","hex":"#667c3e","rgb":{"r":102,"g":124,"b":62},"luminance":79.23495170693296},{"name":"Military Olive","hex":"#63563b","rgb":{"r":99,"g":86,"b":59},"luminance":58.90577731428387},{"name":"Milk","hex":"#fdfff5","rgb":{"r":253,"g":255,"b":245},"luminance":170.0239769385483},{"name":"Milk and Cookies","hex":"#e9e1df","rgb":{"r":233,"g":225,"b":223},"luminance":151.47136560419597},{"name":"Milk Brownie Dough","hex":"#8f7265","rgb":{"r":143,"g":114,"b":101},"luminance":80.24183428237417},{"name":"Milk Chocolate","hex":"#7f4e1e","rgb":{"r":127,"g":78,"b":30},"luminance":59.581900985114586},{"name":"Milk Froth","hex":"#ffeecc","rgb":{"r":255,"g":238,"b":204},"luminance":160.84746810876445},{"name":"Milk Glass","hex":"#faf7f0","rgb":{"r":250,"g":247,"b":240},"luminance":165.40236461731737},{"name":"Milk Mustache","hex":"#faf3e6","rgb":{"r":250,"g":243,"b":230},"luminance":163.16098118422798},{"name":"Milk Paint","hex":"#efe9d9","rgb":{"r":239,"g":233,"b":217},"luminance":156.28483485610496},{"name":"Milk Punch","hex":"#f3e5c0","rgb":{"r":243,"g":229,"b":192},"luminance":154.36212981816493},{"name":"Milk Quartz","hex":"#f5deae","rgb":{"r":245,"g":222,"b":174},"luminance":150.80285314608608},{"name":"Milk Tooth","hex":"#faebd7","rgb":{"r":250,"g":235,"b":215},"luminance":158.79901015119708},{"name":"Milk White","hex":"#dcd9cd","rgb":{"r":220,"g":217,"b":205},"luminance":145.25348512514253},{"name":"Milkweed","hex":"#e3e8d9","rgb":{"r":227,"g":232,"b":217},"luminance":154.15834271618257},{"name":"Milky Aquamarine","hex":"#038487","rgb":{"r":3,"g":132,"b":135},"luminance":79.00270226390992},{"name":"Milky Blue","hex":"#72a8ba","rgb":{"r":114,"g":168,"b":186},"luminance":106.47337915178609},{"name":"Milky Green","hex":"#cfdbd1","rgb":{"r":207,"g":219,"b":209},"luminance":144.65232640369115},{"name":"Milky Maize","hex":"#f9d9a0","rgb":{"r":249,"g":217,"b":160},"luminance":148.66424802890572},{"name":"Milky Way","hex":"#e8f4f7","rgb":{"r":232,"g":244,"b":247},"luminance":161.61389906811849},{"name":"Milky Yellow","hex":"#f8dd74","rgb":{"r":248,"g":221,"b":116},"luminance":150.00829246744996},{"name":"Mill Creek","hex":"#876e59","rgb":{"r":135,"g":110,"b":89},"luminance":76.82160790428692},{"name":"Millbrook","hex":"#595648","rgb":{"r":89,"g":86,"b":72},"luminance":57.65369813810732},{"name":"Mille-Feuille","hex":"#efc87d","rgb":{"r":239,"g":200,"b":125},"luminance":138.17560211918746},{"name":"Milly Green","hex":"#99bd91","rgb":{"r":153,"g":189,"b":145},"luminance":121.13784775205477},{"name":"Milpa","hex":"#689663","rgb":{"r":104,"g":150,"b":99},"luminance":94.05922342864626},{"name":"Milton","hex":"#b4b498","rgb":{"r":180,"g":180,"b":152},"luminance":119.83692078821117},{"name":"Milvus Milvus Orange","hex":"#bb7722","rgb":{"r":187,"g":119,"b":34},"luminance":89.55852027585091},{"name":"Mimesia Blue","hex":"#2269ca","rgb":{"r":34,"g":105,"b":202},"luminance":66.5770948975697},{"name":"Mimi Pink","hex":"#ffdae9","rgb":{"r":255,"g":218,"b":233},"luminance":151.30808644946904},{"name":"Mimolette Orange","hex":"#ee8811","rgb":{"r":238,"g":136,"b":17},"luminance":106.96230322875437},{"name":"Mimosa","hex":"#f5e9d5","rgb":{"r":245,"g":233,"b":213},"luminance":157.04208668379314},{"name":"Mincemeat","hex":"#b66a3c","rgb":{"r":182,"g":106,"b":60},"luminance":82.94384611289736},{"name":"Mindaro","hex":"#daea6f","rgb":{"r":218,"g":234,"b":111},"luminance":152.56486162940666},{"name":"Mine Rock","hex":"#8e8583","rgb":{"r":142,"g":133,"b":131},"luminance":90.11541023043728},{"name":"Mine Shaft","hex":"#373e41","rgb":{"r":55,"g":62,"b":65},"luminance":40.61858393642004},{"name":"Miner's Dust","hex":"#d3cec5","rgb":{"r":211,"g":206,"b":197},"luminance":138.22703704051534},{"name":"Mineral Blue","hex":"#6d9192","rgb":{"r":109,"g":145,"b":146},"luminance":92.64857927674876},{"name":"Mineral Green","hex":"#506355","rgb":{"r":80,"g":99,"b":85},"luminance":63.58603045480981},{"name":"Mineral Grey","hex":"#b2b6ac","rgb":{"r":178,"g":182,"b":172},"luminance":120.95684562685982},{"name":"Mineral Red","hex":"#b35457","rgb":{"r":179,"g":84,"b":87},"luminance":73.44482983164983},{"name":"Mineral Water","hex":"#dfebd6","rgb":{"r":223,"g":235,"b":214},"luminance":155.14448159699396},{"name":"Mineral Yellow","hex":"#d39c43","rgb":{"r":211,"g":156,"b":67},"luminance":111.46296312677138},{"name":"Minerva","hex":"#b5deda","rgb":{"r":181,"g":222,"b":218},"luminance":143.2767485009344},{"name":"Ming","hex":"#407577","rgb":{"r":64,"g":117,"b":119},"luminance":72.57429223216717},{"name":"Ming Green","hex":"#3aa278","rgb":{"r":58,"g":162,"b":120},"luminance":97.62559193162416},{"name":"Mini Bay","hex":"#8aadcf","rgb":{"r":138,"g":173,"b":207},"luminance":112.12503667334963},{"name":"Mini Blue","hex":"#96d7db","rgb":{"r":150,"g":215,"b":219},"luminance":136.2443601805227},{"name":"Mini Cake","hex":"#fbf6de","rgb":{"r":251,"g":246,"b":222},"luminance":164.696037806014},{"name":"Minified Ballerina Blue","hex":"#d3dfea","rgb":{"r":211,"g":223,"b":234},"luminance":147.73930654365478},{"name":"Minified Blue","hex":"#b3dbea","rgb":{"r":179,"g":219,"b":234},"luminance":141.78145233421753},{"name":"Minified Blush","hex":"#f2dde1","rgb":{"r":242,"g":221,"b":225},"luminance":150.7404961946192},{"name":"Minified Cinnamon","hex":"#ded9db","rgb":{"r":222,"g":217,"b":219},"luminance":145.79008773232837},{"name":"Minified Green","hex":"#dde8e0","rgb":{"r":221,"g":232,"b":224},"luminance":153.5076655838398},{"name":"Minified Jade","hex":"#c1e3e9","rgb":{"r":193,"g":227,"b":233},"luminance":147.6175250232844},{"name":"Minified Lime","hex":"#ebf5de","rgb":{"r":235,"g":245,"b":222},"luminance":162.05066897115853},{"name":"Minified Magenta","hex":"#e6dfe8","rgb":{"r":230,"g":223,"b":232},"luminance":150.21278708884938},{"name":"Minified Malachite","hex":"#ddf3e5","rgb":{"r":221,"g":243,"b":229},"luminance":159.35624354884874},{"name":"Minified Maroon","hex":"#e5dbda","rgb":{"r":229,"g":219,"b":218},"luminance":147.7557902554076},{"name":"Minified Mauve","hex":"#e0dce4","rgb":{"r":224,"g":220,"b":228},"luminance":147.77857842055457},{"name":"Minified Mint","hex":"#e4ebdc","rgb":{"r":228,"g":235,"b":220},"luminance":155.9014143906334},{"name":"Minified Moss","hex":"#e3e8db","rgb":{"r":227,"g":232,"b":219},"luminance":154.1950944128898},{"name":"Minified Mustard","hex":"#e9e6d4","rgb":{"r":233,"g":230,"b":212},"luminance":153.83524697870772},{"name":"Minified Purple","hex":"#e1dee7","rgb":{"r":225,"g":222,"b":231},"luminance":149.00048247237322},{"name":"Minified Yellow","hex":"#f4ebd4","rgb":{"r":244,"g":235,"b":212},"luminance":157.9097627919186},{"name":"Minimal","hex":"#f3eecd","rgb":{"r":243,"g":238,"b":205},"luminance":159.19473290596017},{"name":"Minimal Grey","hex":"#948d99","rgb":{"r":148,"g":141,"b":153},"luminance":95.46119188968886},{"name":"Minimal Rose","hex":"#f2cfe0","rgb":{"r":242,"g":207,"b":224},"luminance":143.708749006454},{"name":"Minion Yellow","hex":"#fed55d","rgb":{"r":254,"g":213,"b":93},"luminance":146.67292961211348},{"name":"Mink","hex":"#8a7561","rgb":{"r":138,"g":117,"b":97},"luminance":80.88038729506678},{"name":"Minnesota April","hex":"#9b9fb5","rgb":{"r":155,"g":159,"b":181},"luminance":106.22932678879218},{"name":"Minotaur Red","hex":"#734b42","rgb":{"r":115,"g":75,"b":66},"luminance":56.36611948679809},{"name":"Minotaurus Brown","hex":"#882211","rgb":{"r":136,"g":34,"b":17},"luminance":45.33914979352833},{"name":"Minsk","hex":"#3e3267","rgb":{"r":62,"g":50,"b":103},"luminance":36.64634371939443},{"name":"Mint","hex":"#3eb489","rgb":{"r":62,"g":180,"b":137},"luminance":108.40486597934614},{"name":"Mint Chiffon","hex":"#e6fdf1","rgb":{"r":230,"g":253,"b":241},"luminance":165.95074780488335},{"name":"Mint Circle","hex":"#a9ceaa","rgb":{"r":169,"g":206,"b":170},"luminance":132.48055119526035},{"name":"Mint Condition","hex":"#dffbf3","rgb":{"r":223,"g":251,"b":243},"luminance":164.07746555209826},{"name":"Mint Cream","hex":"#f5fffa","rgb":{"r":245,"g":255,"b":250},"luminance":169.06846024613816},{"name":"Mint Emulsion","hex":"#dfeadb","rgb":{"r":223,"g":234,"b":219},"luminance":154.7137474466959},{"name":"Mint Flash","hex":"#dcf4e6","rgb":{"r":220,"g":244,"b":230},"luminance":159.77720983920076},{"name":"Mint Gloss","hex":"#c8f3cd","rgb":{"r":200,"g":243,"b":205},"luminance":156.42458815991813},{"name":"Mint Green","hex":"#487d49","rgb":{"r":72,"g":125,"b":73},"luminance":76.9194454803205},{"name":"Mint Ice","hex":"#bde8d8","rgb":{"r":189,"g":232,"b":216},"luminance":149.48550549467998},{"name":"Mint Ice Cream","hex":"#98cdb5","rgb":{"r":152,"g":205,"b":181},"luminance":130.27584152481992},{"name":"Mint Jelly","hex":"#45cea2","rgb":{"r":69,"g":206,"b":162},"luminance":124.05174432066644},{"name":"Mint Julep","hex":"#def0a3","rgb":{"r":222,"g":240,"b":163},"luminance":156.8391022927637},{"name":"Mint Leaf","hex":"#00b694","rgb":{"r":0,"g":182,"b":148},"luminance":108.15806923202724},{"name":"Mint Leaves","hex":"#6a7d4e","rgb":{"r":106,"g":125,"b":78},"luminance":80.42056904175698},{"name":"Mint Macaron","hex":"#afeeee","rgb":{"r":175,"g":238,"b":238},"luminance":151.63052952819228},{"name":"Mint Morning","hex":"#00ddcc","rgb":{"r":0,"g":221,"b":204},"luminance":131.79505326452886},{"name":"Mint Mousse","hex":"#b4ccbd","rgb":{"r":180,"g":204,"b":189},"luminance":133.0428728643515},{"name":"Mint Shake","hex":"#daeed3","rgb":{"r":218,"g":238,"b":211},"luminance":156.02901805753953},{"name":"Mint Smoothie","hex":"#c5e6d1","rgb":{"r":197,"g":230,"b":209},"luminance":149.21441547317067},{"name":"Mint Soap","hex":"#cbd5b1","rgb":{"r":203,"g":213,"b":177},"luminance":140.44226021393987},{"name":"Mint Tea","hex":"#afeee1","rgb":{"r":175,"g":238,"b":225},"luminance":151.37237053372718},{"name":"Mint Tonic","hex":"#99eeaa","rgb":{"r":153,"g":238,"b":170},"luminance":148.2772364356714},{"name":"Mint Tulip","hex":"#c6eadd","rgb":{"r":198,"g":234,"b":221},"luminance":151.68004022942506},{"name":"Mint Twist","hex":"#98cbba","rgb":{"r":152,"g":203,"b":186},"luminance":129.28447022361192},{"name":"Mint Wafer","hex":"#dce5d8","rgb":{"r":220,"g":229,"b":216},"luminance":151.6670455471458},{"name":"Mint Zest","hex":"#cfecee","rgb":{"r":207,"g":236,"b":238},"luminance":154.1363159576613},{"name":"Mint-o-licious","hex":"#b6e9c8","rgb":{"r":182,"g":233,"b":200},"luminance":148.95457416608593},{"name":"Mintage","hex":"#78bfb2","rgb":{"r":120,"g":191,"b":178},"luminance":119.4544321195325},{"name":"Minted Blue","hex":"#26a6be","rgb":{"r":38,"g":166,"b":190},"luminance":100.46488942909357},{"name":"Mintie","hex":"#abf4d2","rgb":{"r":171,"g":244,"b":210},"luminance":153.9531039797509},{"name":"Mintos","hex":"#80d9cc","rgb":{"r":128,"g":217,"b":204},"luminance":135.0222098804489},{"name":"Minty Fresh","hex":"#d2f2e7","rgb":{"r":210,"g":242,"b":231},"luminance":157.5290531044988},{"name":"Minty Green","hex":"#0bf77d","rgb":{"r":11,"g":247,"b":125},"luminance":145.7247066972516},{"name":"Minuet","hex":"#a5b6cf","rgb":{"r":165,"g":182,"b":207},"luminance":120.01796275974692},{"name":"Mirabella","hex":"#886793","rgb":{"r":136,"g":103,"b":147},"luminance":74.76579419092664},{"name":"Miracle","hex":"#898696","rgb":{"r":137,"g":134,"b":150},"luminance":90.3186488661118},{"name":"Mirage","hex":"#373f43","rgb":{"r":55,"g":63,"b":67},"luminance":41.187029875920885},{"name":"Mirage Blue","hex":"#636c77","rgb":{"r":99,"g":108,"b":119},"luminance":71.26926667926364},{"name":"Mirage Grey","hex":"#abafae","rgb":{"r":171,"g":175,"b":174},"luminance":116.44770140281858},{"name":"Mirror Mirror","hex":"#a8b0b2","rgb":{"r":168,"g":176,"b":178},"luminance":116.65499745831723},{"name":"Mischief Maker","hex":"#954738","rgb":{"r":149,"g":71,"b":56},"luminance":61.33937875459776},{"name":"Mischief Mouse","hex":"#b7bab9","rgb":{"r":183,"g":186,"b":185},"luminance":123.93323732155146},{"name":"Mischka","hex":"#a5a9b2","rgb":{"r":165,"g":169,"b":178},"luminance":112.63632938799097},{"name":"Missed","hex":"#eff0c0","rgb":{"r":239,"g":240,"b":192},"luminance":159.47706250429871},{"name":"Missing Link","hex":"#6f5d57","rgb":{"r":111,"g":93,"b":87},"luminance":64.65333499518799},{"name":"Mission Bay Blue","hex":"#9ba9ab","rgb":{"r":155,"g":169,"b":171},"luminance":111.21650178817889},{"name":"Mission Courtyard","hex":"#f3d1b3","rgb":{"r":243,"g":209,"b":179},"luminance":144.03667232340518},{"name":"Mission Gold","hex":"#b78d61","rgb":{"r":183,"g":141,"b":97},"luminance":99.83288907970157},{"name":"Mission Jewel","hex":"#456252","rgb":{"r":69,"g":98,"b":82},"luminance":61.824460701246714},{"name":"Mission Tan","hex":"#dac6a8","rgb":{"r":218,"g":198,"b":168},"luminance":134.6253144991684},{"name":"Mission Trail","hex":"#857a64","rgb":{"r":133,"g":122,"b":100},"luminance":82.70392545097238},{"name":"Mission White","hex":"#e2d8c2","rgb":{"r":226,"g":216,"b":194},"luminance":145.36703269999012},{"name":"Mississippi River","hex":"#3b638c","rgb":{"r":59,"g":99,"b":140},"luminance":62.79368797896808},{"name":"Missouri Mud","hex":"#a6a19b","rgb":{"r":166,"g":161,"b":155},"luminance":108.20044318301103},{"name":"Mist Green","hex":"#aacebc","rgb":{"r":170,"g":206,"b":188},"luminance":132.9103066281919},{"name":"Mist Grey","hex":"#c4c4bc","rgb":{"r":196,"g":196,"b":188},"luminance":130.8843846453808},{"name":"Mist of Green","hex":"#e3f1eb","rgb":{"r":227,"g":241,"b":235},"luminance":159.17713503515506},{"name":"Mist Spirit","hex":"#e4ebe7","rgb":{"r":228,"g":235,"b":231},"luminance":156.10805285122223},{"name":"Misted Eve","hex":"#a2b7cf","rgb":{"r":162,"g":183,"b":207},"luminance":120.1764398249507},{"name":"Misted Yellow","hex":"#dab965","rgb":{"r":218,"g":185,"b":101},"luminance":127.1775897908118},{"name":"Mistletoe","hex":"#8aa282","rgb":{"r":138,"g":162,"b":130},"luminance":104.71415319812313},{"name":"Mistletoe Kiss","hex":"#98b489","rgb":{"r":152,"g":180,"b":137},"luminance":116.07531274134048},{"name":"Mistral","hex":"#b8bfcc","rgb":{"r":184,"g":191,"b":204},"luminance":127.03473336454088},{"name":"Misty Afternoon","hex":"#c6dcc7","rgb":{"r":198,"g":220,"b":199},"luminance":143.86337615946596},{"name":"Misty Aqua","hex":"#bcdbdb","rgb":{"r":188,"g":219,"b":219},"luminance":142.50952216957293},{"name":"Misty Bead","hex":"#d2d59b","rgb":{"r":210,"g":213,"b":155},"luminance":141.02327453651046},{"name":"Misty Blue","hex":"#bfcdcc","rgb":{"r":191,"g":205,"b":204},"luminance":135.2138737038474},{"name":"Misty Blush","hex":"#ddc9c6","rgb":{"r":221,"g":201,"b":198},"luminance":137.10164694123844},{"name":"Misty Grape","hex":"#65434d","rgb":{"r":101,"g":67,"b":77},"luminance":50.35675849377122},{"name":"Misty Hillside","hex":"#dce5cc","rgb":{"r":220,"g":229,"b":204},"luminance":151.45095861367136},{"name":"Misty Jade","hex":"#bcd9c8","rgb":{"r":188,"g":217,"b":200},"luminance":141.08521745739344},{"name":"Misty Lake","hex":"#c2d5c4","rgb":{"r":194,"g":213,"b":196},"luminance":139.63058881563165},{"name":"Misty Lawn","hex":"#dffae1","rgb":{"r":223,"g":250,"b":225},"luminance":163.21552416666742},{"name":"Misty Lilac","hex":"#bcb4c4","rgb":{"r":188,"g":180,"b":196},"luminance":121.75006726897526},{"name":"Misty Meadow","hex":"#bec0b0","rgb":{"r":190,"g":192,"b":176},"luminance":127.79722928138935},{"name":"Misty Moonstone","hex":"#e5e0cc","rgb":{"r":229,"g":224,"b":204},"luminance":150.06069945525377},{"name":"Misty Moor","hex":"#718981","rgb":{"r":113,"g":137,"b":129},"luminance":88.4592751835555},{"name":"Misty Morn","hex":"#e7e1e3","rgb":{"r":231,"g":225,"b":227},"luminance":151.27459558696563},{"name":"Misty Morning","hex":"#b2c8bd","rgb":{"r":178,"g":200,"b":189},"luminance":130.68883425909038},{"name":"Misty Moss","hex":"#bbb477","rgb":{"r":187,"g":180,"b":119},"luminance":120.30933265960708},{"name":"Misty Rose","hex":"#ffe4e1","rgb":{"r":255,"g":228,"b":225},"luminance":156.15152071305613},{"name":"Misty Surf","hex":"#b5c8c9","rgb":{"r":181,"g":200,"b":201},"luminance":131.28852789562384},{"name":"Misty Violet","hex":"#dbd7e4","rgb":{"r":219,"g":215,"b":228},"luminance":144.53735658991414},{"name":"Mitchell Blue","hex":"#0d789f","rgb":{"r":13,"g":120,"b":159},"luminance":72.83854916869227},{"name":"Mithril","hex":"#878787","rgb":{"r":135,"g":135,"b":135},"luminance":90.25494640184547},{"name":"Mithril Silver","hex":"#b8b8bf","rgb":{"r":184,"g":184,"b":191},"luminance":123.15273198756087},{"name":"Mithril Silver / Silver","hex":"#bbbbc1","rgb":{"r":187,"g":187,"b":193},"luminance":125.13826326907369},{"name":"Mix Or Match","hex":"#ccccba","rgb":{"r":204,"g":204,"b":186},"luminance":136.0503771990361},{"name":"Miyamoto Red","hex":"#e4030f","rgb":{"r":228,"g":3,"b":15},"luminance":68.21617700369906},{"name":"Miyazaki Verdant","hex":"#6fea3e","rgb":{"r":111,"g":234,"b":62},"luminance":141.48740759869762},{"name":"Mizu","hex":"#70c1e0","rgb":{"r":112,"g":193,"b":224},"luminance":120.86514849616493},{"name":"Mizu Cyan","hex":"#a7dbed","rgb":{"r":167,"g":219,"b":237},"luminance":140.53167124175246},{"name":"Mizuasagi Green","hex":"#749f8d","rgb":{"r":116,"g":159,"b":141},"luminance":100.85832747473061},{"name":"Moat","hex":"#3e6a6b","rgb":{"r":62,"g":106,"b":107},"luminance":66.06077453375792},{"name":"Mobster","hex":"#605a67","rgb":{"r":96,"g":90,"b":103},"luminance":61.26012634658861},{"name":"Moby Dick","hex":"#dde8ed","rgb":{"r":221,"g":232,"b":237},"luminance":153.76114080286996},{"name":"Moccasin","hex":"#fbebd6","rgb":{"r":251,"g":235,"b":214},"luminance":158.92243467176056},{"name":"Mocha","hex":"#9d7651","rgb":{"r":157,"g":118,"b":81},"luminance":84.18248488254548},{"name":"Mocha Bisque","hex":"#8c543a","rgb":{"r":140,"g":84,"b":58},"luminance":65.01735928196408},{"name":"Mocha Glow","hex":"#773322","rgb":{"r":119,"g":51,"b":34},"luminance":46.661064132743476},{"name":"Mocha Magic","hex":"#88796d","rgb":{"r":136,"g":121,"b":109},"luminance":82.78164712664275},{"name":"Mocha Mousse","hex":"#a47864","rgb":{"r":164,"g":120,"b":100},"luminance":86.58107700877831},{"name":"Mocha Wisp","hex":"#918278","rgb":{"r":145,"g":130,"b":120},"luminance":88.82575372604501},{"name":"Mochaccino","hex":"#945200","rgb":{"r":148,"g":82,"b":0},"luminance":65.38441297434734},{"name":"Mochito","hex":"#8efa00","rgb":{"r":142,"g":250,"b":0},"luminance":152.76859711341203},{"name":"Mock Orange","hex":"#ffa368","rgb":{"r":255,"g":163,"b":104},"luminance":122.91752731811684},{"name":"Modal","hex":"#31a6d1","rgb":{"r":49,"g":166,"b":209},"luminance":101.37688810078951},{"name":"Modal Blue","hex":"#40a6ac","rgb":{"r":64,"g":166,"b":172},"luminance":101.22056868048114},{"name":"Mode Beige","hex":"#96711f","rgb":{"r":150,"g":113,"b":31},"luminance":80.1486944185618},{"name":"Modern Ivory","hex":"#f5ecdc","rgb":{"r":245,"g":236,"b":220},"luminance":158.70228873270855},{"name":"Modern Monument","hex":"#d6d6d1","rgb":{"r":214,"g":214,"b":209},"luminance":142.97471243545132},{"name":"Moderne Class","hex":"#745b49","rgb":{"r":116,"g":91,"b":73},"luminance":64.23092268526118},{"name":"Modest Mauve","hex":"#838492","rgb":{"r":131,"g":132,"b":146},"luminance":88.40250874833812},{"name":"Modest Violet","hex":"#e9e4ef","rgb":{"r":233,"g":228,"b":239},"luminance":153.3228955537952},{"name":"Modesty","hex":"#d4c7d9","rgb":{"r":212,"g":199,"b":217},"luminance":135.18610933450225},{"name":"Moegi Green","hex":"#f19172","rgb":{"r":241,"g":145,"b":114},"luminance":112.27626072327132},{"name":"Moelleux Au Chocolat","hex":"#553311","rgb":{"r":85,"g":51,"b":17},"luminance":39.317960755868306},{"name":"Moenkopi Soil","hex":"#c8a692","rgb":{"r":200,"g":166,"b":146},"luminance":115.53357131154563},{"name":"Mogwa-Cheong Yellow","hex":"#ddcc00","rgb":{"r":221,"g":204,"b":0},"luminance":136.76994459675706},{"name":"Moire","hex":"#beadb0","rgb":{"r":190,"g":173,"b":176},"luminance":118.07855773594119},{"name":"Moired Satin","hex":"#665d63","rgb":{"r":102,"g":93,"b":99},"luminance":63.54273428961016},{"name":"Moist Gold","hex":"#dbdb70","rgb":{"r":219,"g":219,"b":112},"luminance":144.83320404520506},{"name":"Moist Silver","hex":"#e0e7dd","rgb":{"r":224,"g":231,"b":221},"luminance":153.32015073368535},{"name":"Mojave Desert","hex":"#c7b595","rgb":{"r":199,"g":181,"b":149},"luminance":122.95250386226382},{"name":"Mojito","hex":"#e4f3e0","rgb":{"r":228,"g":243,"b":224},"luminance":160.14357233744974},{"name":"Mojo","hex":"#97463c","rgb":{"r":151,"g":70,"b":60},"luminance":61.42968257284095},{"name":"Molasses","hex":"#574a47","rgb":{"r":87,"g":74,"b":71},"luminance":51.27425132559226},{"name":"Molasses Cookie","hex":"#8b714b","rgb":{"r":139,"g":113,"b":75},"luminance":78.7414806947393},{"name":"Moldy Ochre","hex":"#d5a300","rgb":{"r":213,"g":163,"b":0},"luminance":114.93862592705726},{"name":"Mole","hex":"#392d2b","rgb":{"r":57,"g":45,"b":43},"luminance":31.815808617729644},{"name":"Mole Grey","hex":"#938f8a","rgb":{"r":147,"g":143,"b":138},"luminance":96.04922443205878},{"name":"Molly Green","hex":"#e3efe3","rgb":{"r":227,"g":239,"b":227},"luminance":157.9827233022649},{"name":"Molly Robins","hex":"#4d8b72","rgb":{"r":77,"g":139,"b":114},"luminance":85.76929633615981},{"name":"Molten Bronze","hex":"#c69c04","rgb":{"r":198,"g":156,"b":4},"luminance":109.04364229059848},{"name":"Molten Core","hex":"#ff5800","rgb":{"r":255,"g":88,"b":0},"luminance":92.09583248442895},{"name":"Molten Ice","hex":"#e1ede6","rgb":{"r":225,"g":237,"b":230},"luminance":156.74026344880247},{"name":"Molten Lava","hex":"#b5332e","rgb":{"r":181,"g":51,"b":46},"luminance":62.06923284526722},{"name":"Momentum","hex":"#746f5c","rgb":{"r":116,"g":111,"b":92},"luminance":74.554762751953},{"name":"Momo Peach","hex":"#f47983","rgb":{"r":244,"g":121,"b":131},"luminance":102.90984899901467},{"name":"Momoshio Brown","hex":"#542d24","rgb":{"r":84,"g":45,"b":36},"luminance":36.6798104820622},{"name":"Mona Lisa","hex":"#ff9889","rgb":{"r":255,"g":152,"b":137},"luminance":118.39824375808958},{"name":"Monaco Blue","hex":"#274374","rgb":{"r":39,"g":67,"b":116},"luminance":43.1001547329009},{"name":"Monarch","hex":"#6b252c","rgb":{"r":107,"g":37,"b":44},"luminance":38.99265656505081},{"name":"Monarch Migration","hex":"#bf764c","rgb":{"r":191,"g":118,"b":76},"luminance":90.19025187347022},{"name":"Monarch's Cocoon","hex":"#8cb293","rgb":{"r":140,"g":178,"b":147},"luminance":113.79988734616566},{"name":"Monastery Mantle","hex":"#41363a","rgb":{"r":65,"g":54,"b":58},"luminance":37.76507610213436},{"name":"Monastic","hex":"#aba9d2","rgb":{"r":171,"g":169,"b":210},"luminance":114.14260138090422},{"name":"Monastir","hex":"#b78999","rgb":{"r":183,"g":137,"b":153},"luminance":98.81998286783903},{"name":"Moncur","hex":"#9bb9ae","rgb":{"r":155,"g":185,"b":174},"luminance":119.72551919286046},{"name":"Mondo","hex":"#554d42","rgb":{"r":85,"g":77,"b":66},"luminance":52.39735109716902},{"name":"Mondrian Blue","hex":"#0f478c","rgb":{"r":15,"g":71,"b":140},"luminance":44.85319558292363},{"name":"Monet Magic","hex":"#c1acc3","rgb":{"r":193,"g":172,"b":195},"luminance":118.3976353015549},{"name":"Monet's Lavender","hex":"#dde0ea","rgb":{"r":221,"g":224,"b":234},"luminance":149.5564688035927},{"name":"Money","hex":"#7b9a6d","rgb":{"r":123,"g":154,"b":109},"luminance":98.380646516477},{"name":"Money Banks","hex":"#aabe49","rgb":{"r":170,"g":190,"b":73},"luminance":122.84903534012791},{"name":"Mongolian Plateau","hex":"#777700","rgb":{"r":119,"g":119,"b":0},"luminance":78.39291530489218},{"name":"Mongoose","hex":"#a58b6f","rgb":{"r":165,"g":139,"b":111},"luminance":96.18463281626643},{"name":"Monkey Island","hex":"#553b39","rgb":{"r":85,"g":59,"b":57},"luminance":43.44641432845753},{"name":"Monkey Madness","hex":"#63584c","rgb":{"r":99,"g":88,"b":76},"luminance":60.16333129905623},{"name":"Monks Robe","hex":"#704822","rgb":{"r":112,"g":72,"b":34},"luminance":54.062142169914054},{"name":"Monologue","hex":"#a1bcd8","rgb":{"r":161,"g":188,"b":216},"luminance":122.89081101937606},{"name":"Monroe Kiss","hex":"#dec1b8","rgb":{"r":222,"g":193,"b":184},"luminance":132.9694782309083},{"name":"Monsoon","hex":"#7a7679","rgb":{"r":122,"g":118,"b":121},"luminance":79.49023635642304},{"name":"Monstera Deliciosa","hex":"#75bf0a","rgb":{"r":117,"g":191,"b":10},"luminance":117.45352944037057},{"name":"Mont Blanc","hex":"#9eb6d8","rgb":{"r":158,"g":182,"b":216},"luminance":119.38028101826532},{"name":"Mont Blanc Peak","hex":"#f2e7e7","rgb":{"r":242,"g":231,"b":231},"luminance":155.93494197581245},{"name":"Montana","hex":"#393b3c","rgb":{"r":57,"g":59,"b":60},"luminance":39.20069052963225},{"name":"Montana Grape","hex":"#6c5971","rgb":{"r":108,"g":89,"b":113},"luminance":62.75388623025669},{"name":"Monte Carlo","hex":"#7ac5b4","rgb":{"r":122,"g":197,"b":180},"luminance":122.98005206129976},{"name":"Montecito","hex":"#b6a180","rgb":{"r":182,"g":161,"b":128},"luminance":110.02644335340482},{"name":"Montego Bay","hex":"#3fbabd","rgb":{"r":63,"g":186,"b":189},"luminance":112.87059762843465},{"name":"Monterey Brown","hex":"#946e5c","rgb":{"r":148,"g":110,"b":92},"luminance":78.97798774342125},{"name":"Montezuma Hills","hex":"#a6b2a4","rgb":{"r":166,"g":178,"b":164},"luminance":117.1767834001258},{"name":"Montezuma's Castle","hex":"#d9ad9e","rgb":{"r":217,"g":173,"b":158},"luminance":121.84761562706099},{"name":"Montreux Blue","hex":"#5879a2","rgb":{"r":88,"g":121,"b":162},"luminance":77.9629597757807},{"name":"Monument","hex":"#84898c","rgb":{"r":132,"g":137,"b":140},"luminance":90.99263808133051},{"name":"Monza","hex":"#c7031e","rgb":{"r":199,"g":3,"b":30},"luminance":59.62521716522296},{"name":"Moo","hex":"#fbe5bd","rgb":{"r":251,"g":229,"b":189},"luminance":155.45457679335144},{"name":"Mood Indigo","hex":"#353a4c","rgb":{"r":53,"g":58,"b":76},"luminance":38.539880915747524},{"name":"Mood Lighting","hex":"#ffe7d5","rgb":{"r":255,"g":231,"b":213},"luminance":157.44669560838676},{"name":"Moody Blue","hex":"#8378c7","rgb":{"r":131,"g":120,"b":199},"luminance":83.72967668037421},{"name":"Moody Blues","hex":"#586e75","rgb":{"r":88,"g":110,"b":117},"luminance":70.98949561730946},{"name":"Mooloolaba","hex":"#c7b8a9","rgb":{"r":199,"g":184,"b":169},"luminance":124.80895729473906},{"name":"Moon Buggy","hex":"#c7bdc1","rgb":{"r":199,"g":189,"b":193},"luminance":127.79986797332772},{"name":"Moon Dust","hex":"#e0e6f0","rgb":{"r":224,"g":230,"b":240},"luminance":153.1732818607736},{"name":"Moon Glow","hex":"#f5f3ce","rgb":{"r":245,"g":243,"b":206},"luminance":162.06248227766966},{"name":"Moon Goddess","hex":"#cfc7d5","rgb":{"r":207,"g":199,"b":213},"luminance":134.40846677944063},{"name":"Moon Jellyfish","hex":"#8eb8ce","rgb":{"r":142,"g":184,"b":206},"luminance":118.40569278544001},{"name":"Moon Lily","hex":"#e6e6e7","rgb":{"r":230,"g":230,"b":231},"luminance":153.7871664216491},{"name":"Moon Mist","hex":"#cecdb8","rgb":{"r":206,"g":205,"b":184},"luminance":136.8003130003729},{"name":"Moon Rock","hex":"#958b84","rgb":{"r":149,"g":139,"b":132},"luminance":94.17351832654442},{"name":"Moon Rose","hex":"#b9aba5","rgb":{"r":185,"g":171,"b":165},"luminance":116.14261687253305},{"name":"Moon Shell","hex":"#e9e3d8","rgb":{"r":233,"g":227,"b":216},"luminance":152.3651149902759},{"name":"Moon White","hex":"#eaf4fc","rgb":{"r":234,"g":244,"b":252},"luminance":161.97159974514048},{"name":"Moon Yellow","hex":"#f0c420","rgb":{"r":240,"g":196,"b":32},"luminance":135.64574526316702},{"name":"Moonbeam","hex":"#cdc6bd","rgb":{"r":205,"g":198,"b":189},"luminance":133.15325837920753},{"name":"Moondance","hex":"#e5decc","rgb":{"r":229,"g":222,"b":204},"luminance":149.03307677492268},{"name":"Moondoggie","hex":"#f3debf","rgb":{"r":243,"g":222,"b":191},"luminance":150.78091829207037},{"name":"Moonglade Water","hex":"#65ffff","rgb":{"r":101,"g":255,"b":255},"luminance":155.44337787760534},{"name":"Moonless Night","hex":"#2f2d30","rgb":{"r":47,"g":45,"b":48},"luminance":30.416801574130044},{"name":"Moonlight","hex":"#f6eed5","rgb":{"r":246,"g":238,"b":213},"luminance":159.74220755955514},{"name":"Moonlight Blue","hex":"#506886","rgb":{"r":80,"g":104,"b":134},"luminance":67.32295953090595},{"name":"Moonlight Jade","hex":"#c7e5df","rgb":{"r":199,"g":229,"b":223},"luminance":149.18508643292733},{"name":"Moonlit Mauve","hex":"#d28fb0","rgb":{"r":210,"g":143,"b":176},"luminance":106.72975066493876},{"name":"Moonlit Ocean","hex":"#293b4d","rgb":{"r":41,"g":59,"b":77},"luminance":37.772755446220756},{"name":"Moonlit Snow","hex":"#eaeeec","rgb":{"r":234,"g":238,"b":236},"luminance":158.54599587501414},{"name":"Moonraker","hex":"#c0b2d7","rgb":{"r":192,"g":178,"b":215},"luminance":121.71171989582596},{"name":"Moonscape","hex":"#725f69","rgb":{"r":114,"g":95,"b":105},"luminance":66.44449955413916},{"name":"Moonshade","hex":"#5a6e9c","rgb":{"r":90,"g":110,"b":156},"luminance":72.17827689824688},{"name":"Moonshadow","hex":"#9845b0","rgb":{"r":152,"g":69,"b":176},"luminance":64.09818881216536},{"name":"Moonstone","hex":"#3aa8c1","rgb":{"r":58,"g":168,"b":193},"luminance":102.51803950524999},{"name":"Moonstone Blue","hex":"#73a9c2","rgb":{"r":115,"g":169,"b":194},"luminance":107.29716161203892},{"name":"Moonstruck","hex":"#fcf0c2","rgb":{"r":252,"g":240,"b":194},"luminance":161.28736143914065},{"name":"Moonwort","hex":"#a5ae9f","rgb":{"r":165,"g":174,"b":159},"luminance":114.8680336081366},{"name":"Moorland","hex":"#a6ab9b","rgb":{"r":166,"g":171,"b":155},"luminance":113.36359638349518},{"name":"Moorland Heather","hex":"#cc94be","rgb":{"r":204,"g":148,"b":190},"luminance":108.33792960916318},{"name":"Moose Fur","hex":"#725440","rgb":{"r":114,"g":84,"b":64},"luminance":60.38514615366928},{"name":"Moot Green","hex":"#a2db10","rgb":{"r":162,"g":219,"b":16},"luminance":137.387920244103},{"name":"Morado Purple","hex":"#9955cc","rgb":{"r":153,"g":85,"b":204},"luminance":71.57611731576392},{"name":"Morality","hex":"#b4cde5","rgb":{"r":180,"g":205,"b":229},"luminance":134.3823941630748},{"name":"Morass","hex":"#726138","rgb":{"r":114,"g":97,"b":56},"luminance":66.66828761112738},{"name":"Moray","hex":"#c8bd6a","rgb":{"r":200,"g":189,"b":106},"luminance":126.61126452650252},{"name":"Moray Eel","hex":"#00a78b","rgb":{"r":0,"g":167,"b":139},"luminance":99.30146301540576},{"name":"Mordant Red 19","hex":"#ae0c00","rgb":{"r":174,"g":12,"b":0},"luminance":52.50069153830262},{"name":"Mordian Blue","hex":"#2f5684","rgb":{"r":47,"g":86,"b":132},"luminance":54.519367540352114},{"name":"More Maple","hex":"#d0ab70","rgb":{"r":208,"g":171,"b":112},"luminance":118.77040379235898},{"name":"More Melon","hex":"#e0e3c8","rgb":{"r":224,"g":227,"b":200},"luminance":150.86722830687916},{"name":"More Mint","hex":"#e6e8c5","rgb":{"r":230,"g":232,"b":197},"luminance":154.20686275260255},{"name":"More Than A Week","hex":"#8d8d8d","rgb":{"r":141,"g":141,"b":141},"luminance":94.2662773530386},{"name":"Morel","hex":"#685c53","rgb":{"r":104,"g":92,"b":83},"luminance":63.031124660757875},{"name":"Morganite","hex":"#dfcdc6","rgb":{"r":223,"g":205,"b":198},"luminance":139.4124447027596},{"name":"Morning Blue","hex":"#8da399","rgb":{"r":141,"g":163,"b":153},"luminance":106.002162270399},{"name":"Morning Breeze","hex":"#d5e3de","rgb":{"r":213,"g":227,"b":222},"luminance":149.83933006390544},{"name":"Morning Calm","hex":"#ceeeef","rgb":{"r":206,"g":238,"b":239},"luminance":155.0933002679355},{"name":"Morning Fog","hex":"#d0dbd7","rgb":{"r":208,"g":219,"b":215},"luminance":144.89464715095585},{"name":"Morning Forest","hex":"#6dae81","rgb":{"r":109,"g":174,"b":129},"luminance":108.2155754085335},{"name":"Morning Frost","hex":"#ebf4df","rgb":{"r":235,"g":244,"b":223},"luminance":161.5478514032297},{"name":"Morning Glory","hex":"#9ed1d3","rgb":{"r":158,"g":209,"b":211},"luminance":133.64699760563272},{"name":"Morning Glow","hex":"#eef0d6","rgb":{"r":238,"g":240,"b":214},"luminance":159.70713653434527},{"name":"Morning Green","hex":"#89bab2","rgb":{"r":137,"g":186,"b":178},"luminance":118.36571191438844},{"name":"Morning Light Wave","hex":"#e0efe9","rgb":{"r":224,"g":239,"b":233},"luminance":157.71318990179608},{"name":"Morning Mist","hex":"#e5edf1","rgb":{"r":229,"g":237,"b":241},"luminance":157.4712503220826},{"name":"Morning Moon","hex":"#f7eecf","rgb":{"r":247,"g":238,"b":207},"luminance":159.77765065552816},{"name":"Morning Moor","hex":"#dad6ae","rgb":{"r":218,"g":214,"b":174},"luminance":142.90570997689352},{"name":"Morning Rush","hex":"#dee4dc","rgb":{"r":222,"g":228,"b":220},"luminance":151.48306895491652},{"name":"Morning Song","hex":"#e4ece9","rgb":{"r":228,"g":236,"b":233},"luminance":156.6654922182929},{"name":"Morning Wheat","hex":"#e7d2a9","rgb":{"r":231,"g":210,"b":169},"luminance":142.6085495929329},{"name":"Mornington","hex":"#dcc6b9","rgb":{"r":220,"g":198,"b":185},"luminance":135.20458415305305},{"name":"Moroccan Blue","hex":"#0f4e67","rgb":{"r":15,"g":78,"b":103},"luminance":47.479970355930085},{"name":"Moroccan Blunt","hex":"#75583d","rgb":{"r":117,"g":88,"b":61},"luminance":62.77348756441687},{"name":"Moroccan Brown","hex":"#7c726c","rgb":{"r":124,"g":114,"b":108},"luminance":77.48699145017825},{"name":"Moroccan Dusk","hex":"#6b5e5d","rgb":{"r":107,"g":94,"b":93},"luminance":64.65729763143523},{"name":"Moroccan Leather","hex":"#6d4444","rgb":{"r":109,"g":68,"b":68},"luminance":52.11097620463466},{"name":"Moroccan Moonlight","hex":"#eae0d4","rgb":{"r":234,"g":224,"b":212},"luminance":150.8921055721604},{"name":"Morocco","hex":"#b67267","rgb":{"r":182,"g":114,"b":103},"luminance":87.0471826769827},{"name":"Morocco Brown","hex":"#442d21","rgb":{"r":68,"g":45,"b":33},"luminance":33.545418360783636},{"name":"Morocco Sand","hex":"#ece3cc","rgb":{"r":236,"g":227,"b":204},"luminance":152.56282519998112},{"name":"Morris Artichoke","hex":"#8cb295","rgb":{"r":140,"g":178,"b":149},"luminance":113.83368566465727},{"name":"Morris Leaf","hex":"#c2d3af","rgb":{"r":194,"g":211,"b":175},"luminance":138.21452523161233},{"name":"Morro Bay","hex":"#546b78","rgb":{"r":84,"g":107,"b":120},"luminance":69.01395755207783},{"name":"Morrow White","hex":"#fcfccf","rgb":{"r":252,"g":252,"b":207},"luminance":167.67735829264484},{"name":"Mortar","hex":"#565051","rgb":{"r":86,"g":80,"b":81},"luminance":54.329717024847454},{"name":"Mosaic Blue","hex":"#00758f","rgb":{"r":0,"g":117,"b":143},"luminance":70.58725270897006},{"name":"Mosaic Tile","hex":"#1c6b69","rgb":{"r":28,"g":107,"b":105},"luminance":64.48520578396257},{"name":"Moscow Papyrus","hex":"#937c00","rgb":{"r":147,"g":124,"b":0},"luminance":85.02916648421292},{"name":"Mosque","hex":"#005f5b","rgb":{"r":0,"g":95,"b":91},"luminance":56.7217339385883},{"name":"Moss","hex":"#009051","rgb":{"r":0,"g":144,"b":81},"luminance":85.03087403996268},{"name":"Moss Beach","hex":"#6b7061","rgb":{"r":107,"g":112,"b":97},"luminance":73.94663581935286},{"name":"Moss Cottage","hex":"#42544c","rgb":{"r":66,"g":84,"b":76},"luminance":53.81240113579768},{"name":"Moss Covered","hex":"#7a7e66","rgb":{"r":122,"g":126,"b":102},"luminance":83.28404596319753},{"name":"Moss Green","hex":"#638b27","rgb":{"r":99,"g":139,"b":39},"luminance":86.91032025024414},{"name":"Moss Grey","hex":"#afab97","rgb":{"r":175,"g":171,"b":151},"luminance":114.49790194584352},{"name":"Moss Island","hex":"#c8c6b4","rgb":{"r":200,"g":198,"b":180},"luminance":132.30870521624797},{"name":"Moss Point Green","hex":"#7e8d60","rgb":{"r":126,"g":141,"b":96},"luminance":91.59409206384437},{"name":"Moss Ring","hex":"#729067","rgb":{"r":114,"g":144,"b":103},"luminance":91.89511817283875},{"name":"Moss Rock","hex":"#5e5b4d","rgb":{"r":94,"g":91,"b":77},"luminance":60.99488838419167},{"name":"Moss Rose","hex":"#8f6d6b","rgb":{"r":143,"g":109,"b":107},"luminance":77.91518813427841},{"name":"Moss Stone","hex":"#b4a54b","rgb":{"r":180,"g":165,"b":75},"luminance":111.1331900244027},{"name":"Moss Vale","hex":"#38614c","rgb":{"r":56,"g":97,"b":76},"luminance":59.97896425414497},{"name":"Mossa","hex":"#b4c2b6","rgb":{"r":180,"g":194,"b":182},"luminance":127.65293098084352},{"name":"Mossleaf","hex":"#8c9d8f","rgb":{"r":140,"g":157,"b":143},"luminance":102.52461209387722},{"name":"Mosstone","hex":"#858961","rgb":{"r":133,"g":137,"b":97},"luminance":90.3930816711102},{"name":"Mossy","hex":"#857349","rgb":{"r":133,"g":115,"b":73},"luminance":78.78829226477751},{"name":"Mossy Bronze","hex":"#525f48","rgb":{"r":82,"g":95,"b":72},"luminance":61.46738007268571},{"name":"Mossy Gold","hex":"#9c9273","rgb":{"r":156,"g":146,"b":115},"luminance":98.44982295565595},{"name":"Mossy Shade","hex":"#7e6c44","rgb":{"r":126,"g":108,"b":68},"luminance":74.15171337197812},{"name":"Mossy White","hex":"#e7f2de","rgb":{"r":231,"g":242,"b":222},"luminance":159.96987385442299},{"name":"Mossy Woods","hex":"#7a9703","rgb":{"r":122,"g":151,"b":3},"luminance":95.8502958628715},{"name":"Mostly Metal","hex":"#575e5f","rgb":{"r":87,"g":94,"b":95},"luminance":61.95624870019165},{"name":"Mote of Dust","hex":"#c1c1c5","rgb":{"r":193,"g":193,"b":197},"luminance":129.10968319223775},{"name":"Moth","hex":"#d2cbaf","rgb":{"r":210,"g":203,"b":175},"luminance":136.16141348047177},{"name":"Moth Green","hex":"#007700","rgb":{"r":0,"g":119,"b":0},"luminance":69.853},{"name":"Moth Grey","hex":"#d1c9ba","rgb":{"r":209,"g":201,"b":186},"luminance":135.18752481645635},{"name":"Moth Orchid","hex":"#c875c4","rgb":{"r":200,"g":117,"b":196},"luminance":93.7661952784691},{"name":"Moth Pink","hex":"#cfbdba","rgb":{"r":207,"g":189,"b":186},"luminance":128.79713628027605},{"name":"Mother Earth","hex":"#849c8d","rgb":{"r":132,"g":156,"b":141},"luminance":101.00261226324791},{"name":"Mother Lode","hex":"#a28761","rgb":{"r":162,"g":135,"b":97},"luminance":93.53228978807265},{"name":"Mother Nature","hex":"#bde1c4","rgb":{"r":189,"g":225,"b":196},"luminance":145.38415691539433},{"name":"Mother of Pearl","hex":"#e9d4c3","rgb":{"r":233,"g":212,"b":195},"luminance":144.33978289092718},{"name":"Mothra Wing","hex":"#eedd82","rgb":{"r":238,"g":221,"b":130},"luminance":148.70358829900508},{"name":"Motto","hex":"#917c6f","rgb":{"r":145,"g":124,"b":111},"luminance":85.66138386110744},{"name":"Mount Eden","hex":"#e7efe0","rgb":{"r":231,"g":239,"b":224},"luminance":158.44475348208914},{"name":"Mount Hyjal","hex":"#3d703e","rgb":{"r":61,"g":112,"b":62},"luminance":68.5922100606184},{"name":"Mount Olympus","hex":"#d4ffff","rgb":{"r":212,"g":255,"b":255},"luminance":165.13237922648605},{"name":"Mount Sterling","hex":"#cad3d4","rgb":{"r":202,"g":211,"b":212},"luminance":139.90199096867778},{"name":"Mount Tam","hex":"#7c7b6a","rgb":{"r":124,"g":123,"b":106},"luminance":82.05874257506021},{"name":"Mountain Air","hex":"#e6e0e0","rgb":{"r":230,"g":224,"b":224},"luminance":150.5672419220064},{"name":"Mountain Ash","hex":"#cc7700","rgb":{"r":204,"g":119,"b":0},"luminance":92.73593491737708},{"name":"Mountain Bluebird","hex":"#4c98c2","rgb":{"r":76,"g":152,"b":194},"luminance":94.69118125781301},{"name":"Mountain Dew","hex":"#cfe2e0","rgb":{"r":207,"g":226,"b":224},"luminance":148.6002590475535},{"name":"Mountain Fern","hex":"#94b491","rgb":{"r":148,"g":180,"b":145},"luminance":115.73899949455239},{"name":"Mountain Forest","hex":"#4d663e","rgb":{"r":77,"g":102,"b":62},"luminance":64.53612189309177},{"name":"Mountain Green","hex":"#b2b599","rgb":{"r":178,"g":181,"b":153},"luminance":120.1050775654385},{"name":"Mountain Grey","hex":"#e8e3db","rgb":{"r":232,"g":227,"b":219},"luminance":152.2843280872986},{"name":"Mountain Haze","hex":"#6c6e7e","rgb":{"r":108,"g":110,"b":126},"luminance":73.60966417529698},{"name":"Mountain Heather","hex":"#eedae6","rgb":{"r":238,"g":218,"b":230},"luminance":148.7508514261347},{"name":"Mountain Lake","hex":"#2d5975","rgb":{"r":45,"g":89,"b":117},"luminance":55.572208143999454},{"name":"Mountain Laurel","hex":"#f4c8d5","rgb":{"r":244,"g":200,"b":213},"luminance":140.33870977032674},{"name":"Mountain Lichen","hex":"#a7ae9e","rgb":{"r":167,"g":174,"b":158},"luminance":115.10824330602912},{"name":"Mountain Maize","hex":"#efcc7c","rgb":{"r":239,"g":204,"b":124},"luminance":140.16449094189298},{"name":"Mountain Meadow","hex":"#30ba8f","rgb":{"r":48,"g":186,"b":143},"luminance":111.32135568703787},{"name":"Mountain Mint","hex":"#a7e0c2","rgb":{"r":167,"g":224,"b":194},"luminance":142.37807446724372},{"name":"Mountain Mist","hex":"#a09f9c","rgb":{"r":160,"g":159,"b":156},"luminance":106.37661935312666},{"name":"Mountain Moss","hex":"#94a293","rgb":{"r":148,"g":162,"b":147},"luminance":106.21647190525582},{"name":"Mountain Pine","hex":"#3b5257","rgb":{"r":59,"g":82,"b":87},"luminance":52.215453277741446},{"name":"Mountain Spring","hex":"#d9e1c1","rgb":{"r":217,"g":225,"b":193},"luminance":148.78742325210152},{"name":"Mountain Stream","hex":"#96afb7","rgb":{"r":150,"g":175,"b":183},"luminance":114.01390778760282},{"name":"Mountain View","hex":"#2e3d30","rgb":{"r":46,"g":61,"b":48},"luminance":38.74605204404701},{"name":"Mountbatten Pink","hex":"#997a8d","rgb":{"r":153,"g":122,"b":141},"luminance":86.48541195484934},{"name":"Mourn Mountain Snow","hex":"#e9eaeb","rgb":{"r":233,"g":234,"b":235},"luminance":156.3279090661677},{"name":"Mournfang Brown","hex":"#6f5749","rgb":{"r":111,"g":87,"b":73},"luminance":61.47201124088913},{"name":"Mourning Dove","hex":"#94908b","rgb":{"r":148,"g":144,"b":139},"luminance":96.717723318945},{"name":"Mouse Catcher","hex":"#9e928f","rgb":{"r":158,"g":146,"b":143},"luminance":99.20884321470541},{"name":"Mouse Nose","hex":"#ffe5b4","rgb":{"r":255,"g":229,"b":180},"luminance":155.89712426468938},{"name":"Mouse Tail","hex":"#727664","rgb":{"r":114,"g":118,"b":100},"luminance":78.03585170932652},{"name":"Mouse Trap","hex":"#beb1b0","rgb":{"r":190,"g":177,"b":176},"luminance":120.10388168997703},{"name":"Mousy Brown","hex":"#5c4939","rgb":{"r":92,"g":73,"b":57},"luminance":51.33344201395422},{"name":"Mousy Indigo","hex":"#5c544e","rgb":{"r":92,"g":84,"b":78},"luminance":57.157996745862256},{"name":"Moutarde de Bénichon","hex":"#bf9005","rgb":{"r":191,"g":144,"b":5},"luminance":102.01345776415971},{"name":"Mover & Shaker","hex":"#9cce9e","rgb":{"r":156,"g":206,"b":158},"luminance":130.85191998591384},{"name":"Mow the Lawn","hex":"#a9b49a","rgb":{"r":169,"g":180,"b":154},"luminance":118.42985559815565},{"name":"Mr Frosty","hex":"#a3c5db","rgb":{"r":163,"g":197,"b":219},"luminance":127.94910959440084},{"name":"Mr Mustard","hex":"#e4b857","rgb":{"r":228,"g":184,"b":87},"luminance":128.10744073628197},{"name":"Mr. Glass","hex":"#c0d5ef","rgb":{"r":192,"g":213,"b":239},"luminance":140.25253630861724},{"name":"Ms. Pac-Man Kiss","hex":"#ff00aa","rgb":{"r":255,"g":0,"b":170},"luminance":78.66946310354481},{"name":"MSU Green","hex":"#18453b","rgb":{"r":24,"g":69,"b":59},"luminance":41.68005591406998},{"name":"Mt Burleigh","hex":"#597766","rgb":{"r":89,"g":119,"b":102},"luminance":75.64917259296362},{"name":"Mt. Rushmore","hex":"#7f8181","rgb":{"r":127,"g":129,"b":129},"luminance":85.9778337363765},{"name":"Mǔ Lì Bái Oyster","hex":"#f1f2d3","rgb":{"r":241,"g":242,"b":211},"luminance":161.09138187066372},{"name":"Mud","hex":"#70543e","rgb":{"r":112,"g":84,"b":62},"luminance":60.02234277333733},{"name":"Mud Ball","hex":"#966544","rgb":{"r":150,"g":101,"b":68},"luminance":74.74332326703168},{"name":"Mud Bath","hex":"#7c6841","rgb":{"r":124,"g":104,"b":65},"luminance":71.80805094138121},{"name":"Mud Berry","hex":"#d0c8c4","rgb":{"r":208,"g":200,"b":196},"luminance":134.72141329424954},{"name":"Mud Brown","hex":"#60460f","rgb":{"r":96,"g":70,"b":15},"luminance":50.15208685588268},{"name":"Mud Green","hex":"#606602","rgb":{"r":96,"g":102,"b":2},"luminance":66.39930327947725},{"name":"Mud House","hex":"#847146","rgb":{"r":132,"g":113,"b":70},"luminance":77.59642379001754},{"name":"Mud Pack","hex":"#9d9588","rgb":{"r":157,"g":149,"b":136},"luminance":100.46788359470901},{"name":"Mud Pots","hex":"#b6b5b1","rgb":{"r":182,"g":181,"b":177},"luminance":121.06566572319338},{"name":"Mud Puddle","hex":"#9d958b","rgb":{"r":157,"g":149,"b":139},"luminance":100.52122827542448},{"name":"Mud Room","hex":"#60584b","rgb":{"r":96,"g":88,"b":75},"luminance":59.71067284832754},{"name":"Mud-Dell","hex":"#a08b76","rgb":{"r":160,"g":139,"b":118},"luminance":95.53554078456874},{"name":"Muddy Brown","hex":"#886806","rgb":{"r":136,"g":104,"b":6},"luminance":73.35452989420625},{"name":"Muddy Green","hex":"#657432","rgb":{"r":101,"g":116,"b":50},"luminance":74.70602428854048},{"name":"Muddy Mauve","hex":"#e4b3cc","rgb":{"r":228,"g":179,"b":204},"luminance":127.39151639336113},{"name":"Muddy Olive","hex":"#4b5d46","rgb":{"r":75,"g":93,"b":70},"luminance":59.554498621010985},{"name":"Muddy Quicksand","hex":"#c3988b","rgb":{"r":195,"g":152,"b":139},"luminance":107.75662818128636},{"name":"Muddy River","hex":"#715d3d","rgb":{"r":113,"g":93,"b":61},"luminance":64.57628640607943},{"name":"Muddy Rose","hex":"#e2beb4","rgb":{"r":226,"g":190,"b":180},"luminance":132.00854811715791},{"name":"Muddy Waters","hex":"#a9844f","rgb":{"r":169,"g":132,"b":79},"luminance":92.94224148900219},{"name":"Muddy Yellow","hex":"#bfac05","rgb":{"r":191,"g":172,"b":5},"luminance":115.99781065606368},{"name":"Mudra","hex":"#b8d0da","rgb":{"r":184,"g":208,"b":218},"luminance":136.2050490106736},{"name":"Mudskipper","hex":"#897a69","rgb":{"r":137,"g":122,"b":105},"luminance":83.36554003303762},{"name":"Mudstone","hex":"#84846f","rgb":{"r":132,"g":132,"b":111},"luminance":87.87273181141006},{"name":"Muesli","hex":"#9e7e53","rgb":{"r":158,"g":126,"b":83},"luminance":88.27068285676734},{"name":"Mughal Green","hex":"#448800","rgb":{"r":68,"g":136,"b":0},"luminance":82.38044942824722},{"name":"Mukluks","hex":"#a38961","rgb":{"r":163,"g":137,"b":97},"luminance":94.68257545081882},{"name":"Mulberry","hex":"#920a4e","rgb":{"r":146,"g":10,"b":78},"luminance":44.9354679512743},{"name":"Mulberry Brown","hex":"#956f29","rgb":{"r":149,"g":111,"b":41},"luminance":79.07004822307876},{"name":"Mulberry Bush","hex":"#ad6ea0","rgb":{"r":173,"g":110,"b":160},"luminance":84.7211014387797},{"name":"Mulberry Mix","hex":"#9f556c","rgb":{"r":159,"g":85,"b":108},"luminance":70.00887836553304},{"name":"Mulberry Purple","hex":"#493c62","rgb":{"r":73,"g":60,"b":98},"luminance":42.91479829848907},{"name":"Mulberry Thorn","hex":"#c57f2e","rgb":{"r":197,"g":127,"b":46},"luminance":95.15574783479975},{"name":"Mulberry Wood","hex":"#5c0536","rgb":{"r":92,"g":5,"b":54},"luminance":28.340794360779658},{"name":"Mulberry Yogurt","hex":"#c54b8c","rgb":{"r":197,"g":75,"b":140},"luminance":75.24948926072521},{"name":"Mulch","hex":"#433937","rgb":{"r":67,"g":57,"b":55},"luminance":39.498590734354046},{"name":"Mule","hex":"#827b77","rgb":{"r":130,"g":123,"b":119},"luminance":83.11376334278215},{"name":"Mule Fawn","hex":"#884f40","rgb":{"r":136,"g":79,"b":64},"luminance":62.10674392527755},{"name":"Mulgore Mustard","hex":"#c2b332","rgb":{"r":194,"g":179,"b":50},"luminance":120.15623731209294},{"name":"Mulled Cider","hex":"#a18162","rgb":{"r":161,"g":129,"b":98},"luminance":90.42206386717791},{"name":"Mulled Grape","hex":"#675a74","rgb":{"r":103,"g":90,"b":116},"luminance":62.56467281941143},{"name":"Mulled Wine","hex":"#524d5b","rgb":{"r":82,"g":77,"b":91},"luminance":52.45666593484569},{"name":"Mummy's Tomb","hex":"#828e84","rgb":{"r":130,"g":142,"b":132},"luminance":93.19446614472342},{"name":"Munchkin","hex":"#9bb139","rgb":{"r":155,"g":177,"b":57},"luminance":113.95211814617576},{"name":"Munsell Blue","hex":"#0093af","rgb":{"r":0,"g":147,"b":175},"luminance":88.56519644307238},{"name":"Munsell Yellow","hex":"#efcc00","rgb":{"r":239,"g":204,"b":0},"luminance":139.4498405341505},{"name":"Muntok White Pepper","hex":"#d2a172","rgb":{"r":210,"g":161,"b":114},"luminance":114.206187069703},{"name":"Murasaki","hex":"#4f284b","rgb":{"r":79,"g":40,"b":75},"luminance":34.385528075049244},{"name":"Murasaki Purple","hex":"#884898","rgb":{"r":136,"g":72,"b":152},"luminance":61.156080449943815},{"name":"Murdoch","hex":"#5b8d6b","rgb":{"r":91,"g":141,"b":107},"luminance":87.97441204122934},{"name":"Murex","hex":"#847eb1","rgb":{"r":132,"g":126,"b":177},"luminance":86.22790819682453},{"name":"Murky Green","hex":"#6c7a0e","rgb":{"r":108,"g":122,"b":14},"luminance":78.57407636110015},{"name":"Murmur","hex":"#d2d8d2","rgb":{"r":210,"g":216,"b":210},"luminance":143.4988465598243},{"name":"Murray Red","hex":"#6b3c39","rgb":{"r":107,"g":60,"b":57},"luminance":48.0231657952701},{"name":"Muscat Blanc","hex":"#ebe2cf","rgb":{"r":235,"g":226,"b":207},"luminance":151.96460796185406},{"name":"Muscovado Sugar","hex":"#9b6957","rgb":{"r":155,"g":105,"b":87},"luminance":77.75023455913171},{"name":"Mushiao Green","hex":"#2d4436","rgb":{"r":45,"g":68,"b":54},"luminance":42.570182252370024},{"name":"Mushroom","hex":"#bdaca3","rgb":{"r":189,"g":172,"b":163},"luminance":117.1858060560237},{"name":"Mushroom Risotto","hex":"#dbd0ca","rgb":{"r":219,"g":208,"b":202},"luminance":140.44743985206705},{"name":"Musk","hex":"#cca195","rgb":{"r":204,"g":161,"b":149},"luminance":113.75679874627274},{"name":"Musk Deer","hex":"#7e5b58","rgb":{"r":126,"g":91,"b":88},"luminance":66.13128751959998},{"name":"Musk Dusk","hex":"#cfbfb9","rgb":{"r":207,"g":191,"b":185},"luminance":129.79119091063154},{"name":"Musk Memory","hex":"#774548","rgb":{"r":119,"g":69,"b":72},"luminance":54.533217711776366},{"name":"Musket","hex":"#7d6d39","rgb":{"r":125,"g":109,"b":57},"luminance":74.38372750810488},{"name":"Muskmelon","hex":"#ec935e","rgb":{"r":236,"g":147,"b":94},"luminance":111.98170508167841},{"name":"Muskrat","hex":"#7e6f4f","rgb":{"r":126,"g":111,"b":79},"luminance":75.8015366664819},{"name":"Muslin","hex":"#d3d1c4","rgb":{"r":211,"g":209,"b":196},"luminance":139.75190426609578},{"name":"Mustang","hex":"#5e4a47","rgb":{"r":94,"g":74,"b":71},"luminance":52.367164483099515},{"name":"Mustard","hex":"#ceb301","rgb":{"r":206,"g":179,"b":1},"luminance":121.79560402986635},{"name":"Mustard Brown","hex":"#ac7e04","rgb":{"r":172,"g":126,"b":4},"luminance":90.0856512658925},{"name":"Mustard Flower","hex":"#d2bd0a","rgb":{"r":210,"g":189,"b":10},"luminance":127.48424588552108},{"name":"Mustard Gold","hex":"#b08e51","rgb":{"r":176,"g":142,"b":81},"luminance":99.00727977275206},{"name":"Mustard Green","hex":"#a8b504","rgb":{"r":168,"g":181,"b":4},"luminance":117.52398380330715},{"name":"Mustard Magic","hex":"#857139","rgb":{"r":133,"g":113,"b":57},"luminance":77.61082304678904},{"name":"Mustard Oil","hex":"#d5bd66","rgb":{"r":213,"g":189,"b":102},"luminance":128.45074387484098},{"name":"Mustard On Toast","hex":"#ddcc33","rgb":{"r":221,"g":204,"b":51},"luminance":136.89346347068584},{"name":"Mustard Sauce","hex":"#edbd68","rgb":{"r":237,"g":189,"b":104},"luminance":132.17593863483626},{"name":"Mustard Seed","hex":"#c69f26","rgb":{"r":198,"g":159,"b":38},"luminance":110.61054161787655},{"name":"Mustard Yellow","hex":"#e1ad01","rgb":{"r":225,"g":173,"b":1},"luminance":121.81356337452736},{"name":"Mutabilis","hex":"#c29594","rgb":{"r":194,"g":149,"b":148},"luminance":106.29739784679585},{"name":"Muted Berry","hex":"#91788c","rgb":{"r":145,"g":120,"b":140},"luminance":84.23877506825464},{"name":"Muted Blue","hex":"#3b719f","rgb":{"r":59,"g":113,"b":159},"luminance":70.98984658386014},{"name":"Muted Clay","hex":"#d29380","rgb":{"r":210,"g":147,"b":128},"luminance":107.70934075093022},{"name":"Muted Green","hex":"#5fa052","rgb":{"r":95,"g":160,"b":82},"luminance":98.56569143977025},{"name":"Muted Lime","hex":"#d1c87c","rgb":{"r":209,"g":200,"b":124},"luminance":133.74494972521393},{"name":"Muted Mauve","hex":"#b3a9a3","rgb":{"r":179,"g":169,"b":163},"luminance":114.24107568646227},{"name":"Muted Pink","hex":"#d1768f","rgb":{"r":209,"g":118,"b":143},"luminance":94.70300439268016},{"name":"Muted Purple","hex":"#805b87","rgb":{"r":128,"g":91,"b":135},"luminance":67.49054728626817},{"name":"MVS Red","hex":"#ee0000","rgb":{"r":238,"g":0,"b":0},"luminance":71.16199999999999},{"name":"My Love","hex":"#e1c6a8","rgb":{"r":225,"g":198,"b":168},"luminance":135.65105161774457},{"name":"My Pink","hex":"#d68b80","rgb":{"r":214,"g":139,"b":128},"luminance":104.71175821749914},{"name":"My Sin","hex":"#fdae45","rgb":{"r":253,"g":174,"b":69},"luminance":127.34407567295779},{"name":"Mykonos","hex":"#387abe","rgb":{"r":56,"g":122,"b":190},"luminance":76.66865155981289},{"name":"Mykonos Blue","hex":"#005780","rgb":{"r":0,"g":87,"b":128},"luminance":53.1127971867421},{"name":"Myoga Purple","hex":"#e0218a","rgb":{"r":224,"g":33,"b":138},"luminance":71.4738836289172},{"name":"Myrtle","hex":"#21421e","rgb":{"r":33,"g":66,"b":30},"luminance":40.124763588088584},{"name":"Myrtle Green","hex":"#317873","rgb":{"r":49,"g":120,"b":115},"luminance":73.13219196085947},{"name":"Myrtle Pepper","hex":"#b77961","rgb":{"r":183,"g":121,"b":97},"luminance":90.33860847943143},{"name":"Myself","hex":"#8e6f76","rgb":{"r":142,"g":111,"b":118},"luminance":78.92447476543636},{"name":"Mysteria","hex":"#826f7a","rgb":{"r":130,"g":111,"b":122},"luminance":77.13458376759417},{"name":"Mysterioso","hex":"#46394b","rgb":{"r":70,"g":57,"b":75},"luminance":40.38158096211687},{"name":"Mysterious","hex":"#535e63","rgb":{"r":83,"g":94,"b":99},"luminance":61.5456657206663},{"name":"Mysterious Blue","hex":"#3e7a85","rgb":{"r":62,"g":122,"b":133},"luminance":75.51230816231218},{"name":"Mysterious Moss","hex":"#6f6a52","rgb":{"r":111,"g":106,"b":82},"luminance":71.13699536106371},{"name":"Mystery","hex":"#a4cdcc","rgb":{"r":164,"g":205,"b":204},"luminance":132.00713259896224},{"name":"Mystic","hex":"#d8ddda","rgb":{"r":216,"g":221,"b":218},"luminance":147.0299611949891},{"name":"Mystic Blue","hex":"#48a8d0","rgb":{"r":72,"g":168,"b":208},"luminance":103.68620536985621},{"name":"Mystic Green","hex":"#d8f878","rgb":{"r":216,"g":248,"b":120},"luminance":159.84557307601608},{"name":"Mystic Iris","hex":"#8596d2","rgb":{"r":133,"g":150,"b":210},"luminance":99.53562371834519},{"name":"Mystic Maroon","hex":"#ad4379","rgb":{"r":173,"g":67,"b":121},"luminance":66.42836145803989},{"name":"Mystic Mauve","hex":"#dbb7ba","rgb":{"r":219,"g":183,"b":186},"luminance":127.57994441917585},{"name":"Mystic Melon","hex":"#edebb4","rgb":{"r":237,"g":235,"b":180},"luminance":156.43355840100295},{"name":"Mystic Red","hex":"#ff5500","rgb":{"r":255,"g":85,"b":0},"luminance":91.11976212655517},{"name":"Mystical","hex":"#5f4e72","rgb":{"r":95,"g":78,"b":114},"luminance":55.42650843233768},{"name":"Mystical Trip","hex":"#7a6a75","rgb":{"r":122,"g":106,"b":117},"luminance":73.3493286404177},{"name":"Mystification","hex":"#2a4071","rgb":{"r":42,"g":64,"b":113},"luminance":41.65337815831988},{"name":"Mystified","hex":"#c9dbc7","rgb":{"r":201,"g":219,"b":199},"luminance":143.7094924004674},{"name":"Mystique","hex":"#a598a0","rgb":{"r":165,"g":152,"b":160},"luminance":103.57394460480879},{"name":"Mythical Blue","hex":"#93a8a7","rgb":{"r":147,"g":168,"b":167},"luminance":109.63314785684118},{"name":"Mythical Forest","hex":"#398467","rgb":{"r":57,"g":132,"b":103},"luminance":80.20042810982993},{"name":"Mythical Orange","hex":"#ff7f49","rgb":{"r":255,"g":127,"b":73},"luminance":106.95844571608171},{"name":"Nadeshiko Pink","hex":"#f6adc6","rgb":{"r":246,"g":173,"b":198},"luminance":127.406011243583},{"name":"Nadia","hex":"#afc9c0","rgb":{"r":175,"g":201,"b":192},"luminance":130.91188768786432},{"name":"Naggaroth Night","hex":"#3d3354","rgb":{"r":61,"g":51,"b":84},"luminance":36.339852311202364},{"name":"Nǎi Yóu Sè Cream","hex":"#fdedc3","rgb":{"r":253,"g":237,"b":195},"luminance":159.9085290720917},{"name":"Nakabeni Pink","hex":"#c93756","rgb":{"r":201,"g":55,"b":86},"luminance":68.92263374247969},{"name":"Naked Lady","hex":"#d6b3a9","rgb":{"r":214,"g":179,"b":169},"luminance":124.52197509275219},{"name":"Naked Light","hex":"#e9b6c1","rgb":{"r":233,"g":182,"b":193},"luminance":129.42597285321057},{"name":"Naked Pink","hex":"#d8c6d6","rgb":{"r":216,"g":198,"b":214},"luminance":135.18410020412904},{"name":"Naked Rose","hex":"#ebb5b3","rgb":{"r":235,"g":181,"b":179},"luminance":129.00387618207446},{"name":"Namakabe Brown","hex":"#785e49","rgb":{"r":120,"g":94,"b":73},"luminance":66.34185532527711},{"name":"Namara Grey","hex":"#7b7c7d","rgb":{"r":123,"g":124,"b":125},"luminance":82.78709544971365},{"name":"Namaste","hex":"#bdd8c0","rgb":{"r":189,"g":216,"b":192},"luminance":140.53038436224386},{"name":"Namibia","hex":"#7c6d61","rgb":{"r":124,"g":109,"b":97},"luminance":74.77120721908935},{"name":"Nana","hex":"#a08da7","rgb":{"r":160,"g":141,"b":167},"luminance":97.4755730067795},{"name":"Nancy","hex":"#57b8dc","rgb":{"r":87,"g":184,"b":220},"luminance":113.89210083671298},{"name":"Nandi Bear","hex":"#8f423d","rgb":{"r":143,"g":66,"b":61},"luminance":58.11593352085123},{"name":"Nandor","hex":"#4e5d4e","rgb":{"r":78,"g":93,"b":78},"luminance":60.02633279653189},{"name":"Nanohanacha Gold","hex":"#e3b130","rgb":{"r":227,"g":177,"b":48},"luminance":124.2243499238374},{"name":"Nantucket Mist","hex":"#cabfbf","rgb":{"r":202,"g":191,"b":191},"luminance":129.1984797472478},{"name":"Napa","hex":"#a39a87","rgb":{"r":163,"g":154,"b":135},"luminance":103.84577831091642},{"name":"Napa Sunset","hex":"#cd915c","rgb":{"r":205,"g":145,"b":92},"luminance":105.41175643162387},{"name":"Napier Green","hex":"#2a8000","rgb":{"r":42,"g":128,"b":0},"luminance":76.1782243164016},{"name":"Naples Yellow","hex":"#fada5f","rgb":{"r":250,"g":218,"b":95},"luminance":148.5939048413494},{"name":"Napoleon","hex":"#404149","rgb":{"r":64,"g":65,"b":73},"luminance":43.488460595886814},{"name":"Nārangī Orange","hex":"#ff8050","rgb":{"r":255,"g":128,"b":80},"luminance":107.43320213509415},{"name":"Narcissus","hex":"#c39449","rgb":{"r":195,"g":148,"b":73},"luminance":104.95793483581886},{"name":"Narcomedusae","hex":"#e6e3d8","rgb":{"r":230,"g":227,"b":216},"luminance":151.95706721636873},{"name":"Nârenji Orange","hex":"#ffc14b","rgb":{"r":255,"g":193,"b":75},"luminance":136.82563066180253},{"name":"Narvik","hex":"#e9e6dc","rgb":{"r":233,"g":230,"b":220},"luminance":153.9811592013776},{"name":"Narwhale Grey","hex":"#080813","rgb":{"r":8,"g":8,"b":19},"luminance":5.697862406201118},{"name":"Nasake","hex":"#746062","rgb":{"r":116,"g":96,"b":98},"luminance":67.10693961133974},{"name":"Nasturcian Flower","hex":"#e64d1d","rgb":{"r":230,"g":77,"b":29},"luminance":82.36013681994463},{"name":"Nasturtium","hex":"#fe6347","rgb":{"r":254,"g":99,"b":71},"luminance":95.97097749319843},{"name":"Nasturtium Leaf","hex":"#87b369","rgb":{"r":135,"g":179,"b":105},"luminance":113.19429956495158},{"name":"Nasturtium Shoot","hex":"#869f49","rgb":{"r":134,"g":159,"b":73},"luminance":101.90970968950897},{"name":"Nasty Green","hex":"#70b23f","rgb":{"r":112,"g":178,"b":63},"luminance":109.95613427180858},{"name":"Nasu Purple","hex":"#5d21d0","rgb":{"r":93,"g":33,"b":208},"luminance":41.36089740322374},{"name":"Nataneyu Gold","hex":"#a17917","rgb":{"r":161,"g":121,"b":23},"luminance":85.8433045379778},{"name":"Native Berry","hex":"#dc6b67","rgb":{"r":220,"g":107,"b":103},"luminance":91.70525309381136},{"name":"Native Flora","hex":"#9aa099","rgb":{"r":154,"g":160,"b":153},"luminance":106.04444294728506},{"name":"Native Hue of Resolution","hex":"#d33300","rgb":{"r":211,"g":51,"b":0},"luminance":69.83155368456296},{"name":"Natrolite","hex":"#ebbc71","rgb":{"r":235,"g":188,"b":113},"luminance":131.45935830133965},{"name":"Natural","hex":"#aa907d","rgb":{"r":170,"g":144,"b":125},"luminance":99.65808639543506},{"name":"Natural Bridge","hex":"#a29171","rgb":{"r":162,"g":145,"b":113},"luminance":98.77625723320355},{"name":"Natural Candy Pink","hex":"#e4717a","rgb":{"r":228,"g":113,"b":122},"luminance":96.12832885783462},{"name":"Natural Grey","hex":"#8b8680","rgb":{"r":139,"g":134,"b":128},"luminance":90.15167302385464},{"name":"Natural Instinct Green","hex":"#017374","rgb":{"r":1,"g":115,"b":116},"luminance":68.78872438125306},{"name":"Natural Leather","hex":"#a80e00","rgb":{"r":168,"g":14,"b":0},"luminance":50.899797131226364},{"name":"Natural Light","hex":"#f1ebc8","rgb":{"r":241,"g":235,"b":200},"luminance":157.29323731807415},{"name":"Natural Pumice","hex":"#4a4a43","rgb":{"r":74,"g":74,"b":67},"luminance":49.34327475958602},{"name":"Natural Radiance","hex":"#e7dcc1","rgb":{"r":231,"g":220,"b":193},"luminance":148.09373506330374},{"name":"Natural Spring","hex":"#aa838b","rgb":{"r":170,"g":131,"b":139},"luminance":93.53038663985089},{"name":"Natural Steel","hex":"#8a8287","rgb":{"r":138,"g":130,"b":135},"luminance":88.10573672582281},{"name":"Natural Stone","hex":"#aea295","rgb":{"r":174,"g":162,"b":149},"luminance":109.71826515216142},{"name":"Natural Wool","hex":"#fff6d7","rgb":{"r":255,"g":246,"b":215},"luminance":165.12412824599556},{"name":"Natural Youth","hex":"#d7e5b4","rgb":{"r":215,"g":229,"b":180},"luminance":150.41002145468897},{"name":"Nature","hex":"#bfd5b3","rgb":{"r":191,"g":213,"b":179},"luminance":138.96256214534904},{"name":"Nature Spirits","hex":"#c8c8b4","rgb":{"r":200,"g":200,"b":180},"luminance":133.34118043575285},{"name":"Nature's Delight","hex":"#a6d292","rgb":{"r":166,"g":210,"b":146},"luminance":133.92553749005452},{"name":"Nature's Gate","hex":"#666a60","rgb":{"r":102,"g":106,"b":96},"luminance":70.15323530671981},{"name":"Naughty Hottie","hex":"#ba403a","rgb":{"r":186,"g":64,"b":58},"luminance":67.43878827499795},{"name":"Nauseous Blue","hex":"#483d8b","rgb":{"r":72,"g":61,"b":139},"luminance":44.684356871281025},{"name":"Nautical","hex":"#2e4a7d","rgb":{"r":46,"g":74,"b":125},"luminance":47.73986656872849},{"name":"Nautical Blue","hex":"#1a5091","rgb":{"r":26,"g":80,"b":145},"luminance":50.387672857555145},{"name":"Nautical Star","hex":"#aab5b7","rgb":{"r":170,"g":181,"b":183},"luminance":119.61328083870954},{"name":"Nautilus","hex":"#273c5a","rgb":{"r":39,"g":60,"b":90},"luminance":38.492790506794904},{"name":"Navagio Bay","hex":"#3183a0","rgb":{"r":49,"g":131,"b":160},"luminance":80.37722320408935},{"name":"Navajo","hex":"#efdcc3","rgb":{"r":239,"g":220,"b":195},"luminance":149.25812212740718},{"name":"Navajo Turquoise","hex":"#007c78","rgb":{"r":0,"g":124,"b":120},"luminance":74.06237468512604},{"name":"Navajo White","hex":"#ffdead","rgb":{"r":255,"g":222,"b":173},"luminance":152.26291703825984},{"name":"Naval","hex":"#41729f","rgb":{"r":65,"g":114,"b":159},"luminance":72.00201264548095},{"name":"Naval Passage","hex":"#386782","rgb":{"r":56,"g":103,"b":130},"luminance":64.4633729880775},{"name":"Navigate","hex":"#008583","rgb":{"r":0,"g":133,"b":131},"luminance":79.48651078642212},{"name":"Navigator","hex":"#5d83ab","rgb":{"r":93,"g":131,"b":171},"luminance":84.06184564949784},{"name":"Navy","hex":"#01153e","rgb":{"r":1,"g":21,"b":62},"luminance":14.212703965115153},{"name":"Navy Blazer","hex":"#282d3c","rgb":{"r":40,"g":45,"b":60},"luminance":29.792271229297036},{"name":"Navy Blue","hex":"#000080","rgb":{"r":0,"g":0,"b":128},"luminance":14.592},{"name":"Navy Cosmos","hex":"#503b53","rgb":{"r":80,"g":59,"b":83},"luminance":43.14093801715488},{"name":"Navy Damask","hex":"#425166","rgb":{"r":66,"g":81,"b":102},"luminance":52.77649428486132},{"name":"Navy Green","hex":"#35530a","rgb":{"r":53,"g":83,"b":10},"luminance":51.246100827282454},{"name":"Navy Peony","hex":"#223a5e","rgb":{"r":34,"g":58,"b":94},"luminance":37.11213181696789},{"name":"Navy Purple","hex":"#9556eb","rgb":{"r":149,"g":86,"b":235},"luminance":72.4632874288767},{"name":"Navy Teal","hex":"#20576e","rgb":{"r":32,"g":87,"b":110},"luminance":53.44942455256184},{"name":"Navy Trim","hex":"#203462","rgb":{"r":32,"g":52,"b":98},"luminance":33.88325226420864},{"name":"Neapolitan","hex":"#9b7a78","rgb":{"r":155,"g":122,"b":120},"luminance":86.3919349302931},{"name":"Neapolitan Blue","hex":"#4d7faa","rgb":{"r":77,"g":127,"b":170},"luminance":80.39400680399005},{"name":"Nearsighted","hex":"#c8d5dd","rgb":{"r":200,"g":213,"b":221},"luminance":140.86706001404303},{"name":"Nebula","hex":"#b8c6be","rgb":{"r":184,"g":198,"b":190},"luminance":130.40091614708848},{"name":"Nebula Fuchsia","hex":"#7722aa","rgb":{"r":119,"g":34,"b":170},"luminance":45.16540407214353},{"name":"Nebula Outpost","hex":"#922b9c","rgb":{"r":146,"g":43,"b":156},"luminance":53.47008933039106},{"name":"Nebulas Blue","hex":"#2d62a3","rgb":{"r":45,"g":98,"b":163},"luminance":61.93196609990675},{"name":"Nebulous","hex":"#c4b9b8","rgb":{"r":196,"g":185,"b":184},"luminance":125.16906733294772},{"name":"Necklace Pearl","hex":"#f6eeed","rgb":{"r":246,"g":238,"b":237},"luminance":160.18092794087565},{"name":"Necron Compound","hex":"#828b8e","rgb":{"r":130,"g":139,"b":142},"luminance":91.81691507015468},{"name":"Necrotic Flesh","hex":"#9faf6c","rgb":{"r":159,"g":175,"b":108},"luminance":113.86025491803537},{"name":"Nectar of the Gods","hex":"#513439","rgb":{"r":81,"g":52,"b":57},"luminance":39.50314596332803},{"name":"Nectarine","hex":"#ff8656","rgb":{"r":255,"g":134,"b":86},"luminance":109.98408705353697},{"name":"Nectarous Nectarine","hex":"#dd5566","rgb":{"r":221,"g":85,"b":102},"luminance":83.61313084677549},{"name":"Nefarious Blue","hex":"#c5ced8","rgb":{"r":197,"g":206,"b":216},"luminance":136.74075789244404},{"name":"Nefarious Mauve","hex":"#e6d1dc","rgb":{"r":230,"g":209,"b":220},"luminance":142.861603620427},{"name":"Negishi Green","hex":"#938b4b","rgb":{"r":147,"g":139,"b":75},"luminance":93.07194184070728},{"name":"Negroni","hex":"#eec7a2","rgb":{"r":238,"g":199,"b":162},"luminance":138.02309312937453},{"name":"Nelson's Milk Snake","hex":"#933d41","rgb":{"r":147,"g":61,"b":65},"luminance":57.17443098099009},{"name":"Neo Tokyo Grey","hex":"#bec0c2","rgb":{"r":190,"g":192,"b":194},"luminance":128.1354173208953},{"name":"Neon Blue","hex":"#04d9ff","rgb":{"r":4,"g":217,"b":255},"luminance":130.6595000640979},{"name":"Neon Boneyard","hex":"#dfc5fe","rgb":{"r":223,"g":197,"b":254},"luminance":136.5893501924656},{"name":"Neon Carrot","hex":"#ff9933","rgb":{"r":255,"g":153,"b":51},"luminance":117.9538822676049},{"name":"Neon Fuchsia","hex":"#fe4164","rgb":{"r":254,"g":65,"b":100},"luminance":85.75289465085129},{"name":"Neon Green","hex":"#39ff14","rgb":{"r":57,"g":255,"b":20},"luminance":150.66937802353868},{"name":"Neon Pink","hex":"#fe019a","rgb":{"r":254,"g":1,"b":154},"luminance":77.9509629254187},{"name":"Neon Purple","hex":"#bc13fe","rgb":{"r":188,"g":19,"b":254},"luminance":64.207696493489},{"name":"Neon Red","hex":"#ff073a","rgb":{"r":255,"g":7,"b":58},"luminance":76.64138862259738},{"name":"Neon Violet","hex":"#674876","rgb":{"r":103,"g":72,"b":118},"luminance":53.996825915973986},{"name":"Neon Yellow","hex":"#cfff04","rgb":{"r":207,"g":255,"b":4},"luminance":161.9770064237514},{"name":"Nepal","hex":"#93aab9","rgb":{"r":147,"g":170,"b":185},"luminance":111.06168740389279},{"name":"Nephrite","hex":"#6d9288","rgb":{"r":109,"g":146,"b":136},"luminance":92.99129045776276},{"name":"Neptune","hex":"#007dac","rgb":{"r":0,"g":125,"b":172},"luminance":75.9497484459297},{"name":"Neptune Green","hex":"#7fbb9e","rgb":{"r":127,"g":187,"b":158},"luminance":117.53984104974789},{"name":"Neptune's Wrath","hex":"#11425d","rgb":{"r":17,"g":66,"b":93},"luminance":40.48681090182332},{"name":"Nereus","hex":"#4c793c","rgb":{"r":76,"g":121,"b":60},"luminance":74.88658427916178},{"name":"Nero","hex":"#252525","rgb":{"r":37,"g":37,"b":37},"luminance":24.73654086569098},{"name":"Nero's Green","hex":"#318181","rgb":{"r":49,"g":129,"b":129},"luminance":78.5168196375783},{"name":"Nervous Neon Pink","hex":"#ff6ec7","rgb":{"r":255,"g":110,"b":199},"luminance":102.45603701588306},{"name":"Nessie","hex":"#716748","rgb":{"r":113,"g":103,"b":72},"luminance":69.7457178183722},{"name":"Net Worker","hex":"#b6a194","rgb":{"r":182,"g":161,"b":148},"luminance":110.35196489868225},{"name":"Nettle","hex":"#bbac7d","rgb":{"r":187,"g":172,"b":125},"luminance":116.28867255670262},{"name":"Nettle Rash","hex":"#e4f7e7","rgb":{"r":228,"g":247,"b":231},"luminance":162.3659793829976},{"name":"Neutral Buff","hex":"#9d928f","rgb":{"r":157,"g":146,"b":143},"luminance":99.06681208659133},{"name":"Neutral Green","hex":"#aaa583","rgb":{"r":170,"g":165,"b":131},"luminance":110.39748312801336},{"name":"Neutral Grey","hex":"#8e918f","rgb":{"r":142,"g":145,"b":143},"luminance":96.50388693208164},{"name":"Neutral Peach","hex":"#ffe6c3","rgb":{"r":255,"g":230,"b":195},"luminance":156.63707423531633},{"name":"Neutral Valley","hex":"#8b694d","rgb":{"r":139,"g":105,"b":77},"luminance":74.85481434082914},{"name":"Neutrino Blue","hex":"#01248f","rgb":{"r":1,"g":36,"b":143},"luminance":26.69093533392938},{"name":"Nevada","hex":"#666f6f","rgb":{"r":102,"g":111,"b":111},"luminance":73.04578269140526},{"name":"Nevada Morning","hex":"#ffd5a7","rgb":{"r":255,"g":213,"b":167},"luminance":147.6770003419625},{"name":"Never Cry Wolf","hex":"#6e6455","rgb":{"r":110,"g":100,"b":85},"luminance":67.98042512370748},{"name":"Never Forget","hex":"#a67283","rgb":{"r":166,"g":114,"b":131},"luminance":84.64382455914902},{"name":"Nevergreen","hex":"#666556","rgb":{"r":102,"g":101,"b":86},"luminance":67.38838764208563},{"name":"Neverland","hex":"#9ce5d6","rgb":{"r":156,"g":229,"b":214},"luminance":144.3619426337842},{"name":"New Amber","hex":"#6d3b24","rgb":{"r":109,"g":59,"b":36},"luminance":47.733225179113965},{"name":"New Bamboo","hex":"#adac84","rgb":{"r":173,"g":172,"b":132},"luminance":114.43711866785182},{"name":"New Brick Red","hex":"#cb4154","rgb":{"r":203,"g":65,"b":84},"luminance":72.33000490806012},{"name":"New Bulgarian Rose","hex":"#482427","rgb":{"r":72,"g":36,"b":39},"luminance":30.49234533452617},{"name":"New Car","hex":"#214fc6","rgb":{"r":33,"g":79,"b":198},"luminance":52.51007524275698},{"name":"New Clay","hex":"#efc1b5","rgb":{"r":239,"g":193,"b":181},"luminance":135.52596488496218},{"name":"New Cork","hex":"#b89b6b","rgb":{"r":184,"g":155,"b":107},"luminance":107.02252886658958},{"name":"New England Roast","hex":"#aa7755","rgb":{"r":170,"g":119,"b":85},"luminance":86.93116017286322},{"name":"New Fawn","hex":"#c9a171","rgb":{"r":201,"g":161,"b":113},"luminance":112.73601365136165},{"name":"New Frond","hex":"#bacca0","rgb":{"r":186,"g":204,"b":160},"luminance":133.28615119358798},{"name":"New Gold","hex":"#ead151","rgb":{"r":234,"g":209,"b":81},"luminance":141.5331282809788},{"name":"New Hope","hex":"#e2efc2","rgb":{"r":226,"g":239,"b":194},"luminance":157.28155893492408},{"name":"New Kenyan Copper","hex":"#7c1c05","rgb":{"r":124,"g":28,"b":5},"luminance":40.55979255371013},{"name":"New Life","hex":"#7c916e","rgb":{"r":124,"g":145,"b":110},"luminance":93.68268036835838},{"name":"New Limerick","hex":"#9dc209","rgb":{"r":157,"g":194,"b":9},"luminance":123.1783130628115},{"name":"New Love","hex":"#c6bbdb","rgb":{"r":198,"g":187,"b":219},"luminance":127.19045294753847},{"name":"New Neutral","hex":"#bec0aa","rgb":{"r":190,"g":192,"b":170},"luminance":127.69162899736223},{"name":"New Orleans","hex":"#e4c385","rgb":{"r":228,"g":195,"b":133},"luminance":134.0878221651765},{"name":"New Penny","hex":"#a27d66","rgb":{"r":162,"g":125,"b":102},"luminance":88.68675692007234},{"name":"New Steel","hex":"#738595","rgb":{"r":115,"g":133,"b":149},"luminance":86.98237443298498},{"name":"New Wave Green","hex":"#11ff11","rgb":{"r":17,"g":255,"b":17},"luminance":149.783817410293},{"name":"New Wave Pink","hex":"#ff22ff","rgb":{"r":255,"g":34,"b":255},"luminance":84.0040873350815},{"name":"New Wheat","hex":"#d7b57f","rgb":{"r":215,"g":181,"b":127},"luminance":125.02239286623816},{"name":"New Wool","hex":"#d6c3b9","rgb":{"r":214,"g":195,"b":185},"luminance":132.82030161462515},{"name":"New York Pink","hex":"#dd8374","rgb":{"r":221,"g":131,"b":116},"luminance":102.2470392040767},{"name":"New Youth","hex":"#f0e1df","rgb":{"r":240,"g":225,"b":223},"luminance":152.44533875786428},{"name":"Newburyport","hex":"#445a79","rgb":{"r":68,"g":90,"b":121},"luminance":58.26382720007329},{"name":"Newman's Eye","hex":"#b2c7e1","rgb":{"r":178,"g":199,"b":225},"luminance":130.90370794213584},{"name":"Newmarket Sausage","hex":"#eae2dc","rgb":{"r":234,"g":226,"b":220},"luminance":152.06397929818883},{"name":"Newport Blue","hex":"#1c8ac9","rgb":{"r":28,"g":138,"b":201},"luminance":84.59972704447692},{"name":"Newsprint","hex":"#756f6d","rgb":{"r":117,"g":111,"b":109},"luminance":74.9910022202664},{"name":"Niagara","hex":"#29a98b","rgb":{"r":41,"g":169,"b":139},"luminance":101.20580025868081},{"name":"Niagara Falls","hex":"#cbe3ee","rgb":{"r":203,"g":227,"b":238},"luminance":148.91463069154756},{"name":"Niblet Green","hex":"#7dc734","rgb":{"r":125,"g":199,"b":52},"luminance":122.78969328897274},{"name":"Nice Blue","hex":"#107ab0","rgb":{"r":16,"g":122,"b":176},"luminance":74.52526919106027},{"name":"Niche","hex":"#65758f","rgb":{"r":101,"g":117,"b":143},"luminance":76.77590667650888},{"name":"Nick's Nook","hex":"#909062","rgb":{"r":144,"g":144,"b":98},"luminance":95.51761881454121},{"name":"Nickel","hex":"#929292","rgb":{"r":146,"g":146,"b":146},"luminance":97.60905314569955},{"name":"Nicotine Gold","hex":"#eebb33","rgb":{"r":238,"g":187,"b":51},"luminance":130.94680676137162},{"name":"Night Bloom","hex":"#613e3d","rgb":{"r":97,"g":62,"b":61},"luminance":47.05374970180378},{"name":"Night Blue","hex":"#040348","rgb":{"r":4,"g":3,"b":72},"luminance":8.479551933917262},{"name":"Night Fog","hex":"#2d1962","rgb":{"r":45,"g":25,"b":98},"luminance":22.829941611839484},{"name":"Night Gull Grey","hex":"#615d5c","rgb":{"r":97,"g":93,"b":92},"luminance":62.70047395355157},{"name":"Night in the Woods","hex":"#443300","rgb":{"r":68,"g":51,"b":0},"luminance":36.18859202842796},{"name":"Night Kite","hex":"#005572","rgb":{"r":0,"g":85,"b":114},"luminance":51.55974244505106},{"name":"Night Market","hex":"#4c6177","rgb":{"r":76,"g":97,"b":119},"luminance":62.78906157126415},{"name":"Night Mode","hex":"#234e86","rgb":{"r":35,"g":78,"b":134},"luminance":49.38856342312458},{"name":"Night Night","hex":"#4f4f5e","rgb":{"r":79,"g":79,"b":94},"luminance":53.13416439542453},{"name":"Night Owl","hex":"#5d7b89","rgb":{"r":93,"g":123,"b":137},"luminance":78.93120785848902},{"name":"Night Pearl","hex":"#11ffbb","rgb":{"r":17,"g":255,"b":187},"luminance":151.28084227026235},{"name":"Night Rendezvous","hex":"#66787e","rgb":{"r":102,"g":120,"b":126},"luminance":78.0912677576693},{"name":"Night Rider","hex":"#332e2e","rgb":{"r":51,"g":46,"b":46},"luminance":31.450588881609196},{"name":"Night Romance","hex":"#715055","rgb":{"r":113,"g":80,"b":85},"luminance":58.657472405483},{"name":"Night Rose","hex":"#b0807a","rgb":{"r":176,"g":128,"b":122},"luminance":92.78004276782802},{"name":"Night Shadz","hex":"#a23d54","rgb":{"r":162,"g":61,"b":84},"luminance":60.99246567404862},{"name":"Night Shift","hex":"#2a5c6a","rgb":{"r":42,"g":92,"b":106},"luminance":56.74643985308682},{"name":"Night Sky","hex":"#2a2a35","rgb":{"r":42,"g":42,"b":53},"luminance":28.32011377095791},{"name":"Night Snow","hex":"#aaccff","rgb":{"r":170,"g":204,"b":255},"luminance":133.29792685559667},{"name":"Night Tan","hex":"#ab967b","rgb":{"r":171,"g":150,"b":123},"luminance":102.77934434992277},{"name":"Night Thistle","hex":"#6b7ba7","rgb":{"r":107,"g":123,"b":167},"luminance":81.23411779541892},{"name":"Night Watch","hex":"#3c4f4e","rgb":{"r":60,"g":79,"b":78},"luminance":50.511052186625456},{"name":"Night White","hex":"#e1e1dd","rgb":{"r":225,"g":225,"b":221},"luminance":150.3478263427842},{"name":"Night Wind","hex":"#d7e2db","rgb":{"r":215,"g":226,"b":219},"luminance":149.51611493414347},{"name":"Night Wizard","hex":"#313740","rgb":{"r":49,"g":55,"b":64},"luminance":36.1967490529191},{"name":"Nightfall","hex":"#43535e","rgb":{"r":67,"g":83,"b":94},"luminance":53.757693272684236},{"name":"Nighthawk","hex":"#615452","rgb":{"r":97,"g":84,"b":82},"luminance":57.96410938675759},{"name":"Nightingale","hex":"#5c4827","rgb":{"r":92,"g":72,"b":39},"luminance":50.62314367954641},{"name":"Nightlife","hex":"#27426b","rgb":{"r":39,"g":66,"b":107},"luminance":42.25769384384339},{"name":"Nightly Aurora","hex":"#9beec1","rgb":{"r":155,"g":238,"b":193},"luminance":148.82779802510012},{"name":"Nightly Blade","hex":"#5a7d9a","rgb":{"r":90,"g":125,"b":154},"luminance":80.10150972984218},{"name":"Nightly Escapade","hex":"#0433ff","rgb":{"r":4,"g":51,"b":255},"luminance":41.74588943836267},{"name":"Nightly Ivy","hex":"#444940","rgb":{"r":68,"g":73,"b":64},"luminance":47.98781137955763},{"name":"Nightly Silhouette","hex":"#4f5b93","rgb":{"r":79,"g":91,"b":147},"luminance":60.76313104177565},{"name":"Nightly Violet","hex":"#784384","rgb":{"r":120,"g":67,"b":132},"luminance":55.32257174969363},{"name":"Nightly Woods","hex":"#013220","rgb":{"r":1,"g":50,"b":32},"luminance":29.57735290724983},{"name":"Nightmare","hex":"#112211","rgb":{"r":17,"g":34,"b":17},"luminance":20.686094290609812},{"name":"Nightshade","hex":"#4f4352","rgb":{"r":79,"g":67,"b":82},"luminance":46.81994218279215},{"name":"Nightshade Berries","hex":"#1b1811","rgb":{"r":27,"g":24,"b":17},"luminance":16.352397897556187},{"name":"Nightshade Purple","hex":"#535872","rgb":{"r":83,"g":88,"b":114},"luminance":58.763269488686554},{"name":"Nightshadow Blue","hex":"#4e5368","rgb":{"r":78,"g":83,"b":104},"luminance":55.30114158857844},{"name":"Nihilakh Oxide","hex":"#a0d6b4","rgb":{"r":160,"g":214,"b":180},"luminance":135.9765344609135},{"name":"Nīlā Blue","hex":"#0055ff","rgb":{"r":0,"g":85,"b":255},"luminance":57.74578707576856},{"name":"Nile","hex":"#b4bb85","rgb":{"r":180,"g":187,"b":133},"luminance":123.1897398527978},{"name":"Nile Blue","hex":"#253f4e","rgb":{"r":37,"g":63,"b":78},"luminance":39.61126094938155},{"name":"Nile Clay","hex":"#8b8174","rgb":{"r":139,"g":129,"b":116},"luminance":87.38514533946831},{"name":"Nile Green","hex":"#a7c796","rgb":{"r":167,"g":199,"b":150},"luminance":128.18342895241958},{"name":"Nile Reed","hex":"#968f5f","rgb":{"r":150,"g":143,"b":95},"luminance":95.78571334494512},{"name":"Nile Stone","hex":"#61c9c1","rgb":{"r":97,"g":201,"b":193},"luminance":123.47548008410413},{"name":"Nimbus Cloud","hex":"#d5d5d8","rgb":{"r":213,"g":213,"b":216},"luminance":142.46096414807812},{"name":"Nina","hex":"#f5e3ea","rgb":{"r":245,"g":227,"b":234},"luminance":154.3800505311486},{"name":"Nine Iron","hex":"#46434a","rgb":{"r":70,"g":67,"b":74},"luminance":45.34314983544923},{"name":"Níng Méng Huáng Lemon","hex":"#ffef19","rgb":{"r":255,"g":239,"b":25},"luminance":159.69830423019525},{"name":"Ninja Turtle","hex":"#94b1a9","rgb":{"r":148,"g":177,"b":169},"luminance":114.56186303041687},{"name":"Ninjin Orange","hex":"#e5aa70","rgb":{"r":229,"g":170,"b":112},"luminance":121.69364718423061},{"name":"Nipple Pink","hex":"#bb7777","rgb":{"r":187,"g":119,"b":119},"luminance":90.4971907519786},{"name":"Nippon","hex":"#bc002c","rgb":{"r":188,"g":0,"b":44},"luminance":56.43535416740112},{"name":"Nirvana","hex":"#a2919b","rgb":{"r":162,"g":145,"b":155},"luminance":99.51397876177998},{"name":"Nirvana Jewel","hex":"#64a5ad","rgb":{"r":100,"g":165,"b":173},"luminance":103.26595910076078},{"name":"Nirvana Nevermind","hex":"#7bc8f6","rgb":{"r":123,"g":200,"b":246},"luminance":126.1815107890217},{"name":"Nisemurasaki Purple","hex":"#43242a","rgb":{"r":67,"g":36,"b":42},"luminance":29.50944691111644},{"name":"Níu Zǎi Sè Denim","hex":"#056eee","rgb":{"r":5,"g":110,"b":238},"luminance":70.05473109647912},{"name":"No Need to Blush","hex":"#ffd6dd","rgb":{"r":255,"g":214,"b":221},"luminance":149.09030681100631},{"name":"No$GMB Yellow","hex":"#f8e888","rgb":{"r":248,"g":232,"b":136},"luminance":155.83637244237946},{"name":"Nobel","hex":"#a99d9d","rgb":{"r":169,"g":157,"b":157},"luminance":106.61614158278286},{"name":"Noble Cause Purple","hex":"#7e1e9c","rgb":{"r":126,"g":30,"b":156},"luminance":45.22955927267034},{"name":"Noble Knight","hex":"#394d78","rgb":{"r":57,"g":77,"b":120},"luminance":50.2051376853007},{"name":"Noble Plum","hex":"#871f78","rgb":{"r":135,"g":31,"b":120},"luminance":46.34227480389801},{"name":"Noble Robe","hex":"#807070","rgb":{"r":128,"g":112,"b":112},"luminance":77.13651109558948},{"name":"Noble Tone","hex":"#884967","rgb":{"r":136,"g":73,"b":103},"luminance":60.2299233022922},{"name":"Noblesse","hex":"#524b50","rgb":{"r":82,"g":75,"b":80},"luminance":51.21042226929983},{"name":"Noctis","hex":"#646b77","rgb":{"r":100,"g":107,"b":119},"luminance":70.87324486010218},{"name":"Nocturnal Flight","hex":"#675754","rgb":{"r":103,"g":87,"b":84},"luminance":60.40031246607918},{"name":"Nocturnal Rose","hex":"#cc6699","rgb":{"r":204,"g":102,"b":153},"luminance":87.23320042277481},{"name":"Nocturnal Sea","hex":"#0e6071","rgb":{"r":14,"g":96,"b":113},"luminance":57.95702221474115},{"name":"Nocturne","hex":"#7a4b56","rgb":{"r":122,"g":75,"b":86},"luminance":58.00830565531112},{"name":"Nocturne Shade","hex":"#356fad","rgb":{"r":53,"g":111,"b":173},"luminance":69.89649019800636},{"name":"Nomad","hex":"#a19986","rgb":{"r":161,"g":153,"b":134},"luminance":103.03754275990862},{"name":"Nomadic Taupe","hex":"#d2c6ae","rgb":{"r":210,"g":198,"b":174},"luminance":133.58343487124444},{"name":"Nomadic Travels","hex":"#e0c997","rgb":{"r":224,"g":201,"b":151},"luminance":136.75905286671153},{"name":"Nominee","hex":"#357567","rgb":{"r":53,"g":117,"b":103},"luminance":71.45492994888457},{"name":"Non Skid Grey","hex":"#8a8daa","rgb":{"r":138,"g":141,"b":170},"luminance":94.49081083893819},{"name":"Non-Photo Blue","hex":"#a4dded","rgb":{"r":164,"g":221,"b":237},"luminance":141.29259056652617},{"name":"Non-Stop Orange","hex":"#dd8811","rgb":{"r":221,"g":136,"b":17},"luminance":103.65007626142875},{"name":"Nonpareil Apple","hex":"#c1a65c","rgb":{"r":193,"g":166,"b":92},"luminance":113.7323144800984},{"name":"Noodles","hex":"#f9e3b4","rgb":{"r":249,"g":227,"b":180},"luminance":154.01077170769582},{"name":"Noqrei Silver","hex":"#bdbebd","rgb":{"r":189,"g":190,"b":189},"luminance":126.8726295817975},{"name":"Nora's Forest","hex":"#003333","rgb":{"r":0,"g":51,"b":51},"luminance":30.496336911176723},{"name":"Nordic","hex":"#1d393c","rgb":{"r":29,"g":57,"b":60},"luminance":35.23459268957142},{"name":"Nordic Breeze","hex":"#d3dde7","rgb":{"r":211,"g":221,"b":231},"luminance":146.63831697752127},{"name":"Nordic Grass Green","hex":"#1fab58","rgb":{"r":31,"g":171,"b":88},"luminance":101.30201140155116},{"name":"Norfolk Green","hex":"#2e4b3c","rgb":{"r":46,"g":75,"b":60},"luminance":46.62787514995724},{"name":"Norfolk Sky","hex":"#6cbae7","rgb":{"r":108,"g":186,"b":231},"luminance":116.86300502725402},{"name":"Nori Green","hex":"#112a12","rgb":{"r":17,"g":42,"b":18},"luminance":25.25603510054577},{"name":"Norman Shaw Goldspar","hex":"#e9c68e","rgb":{"r":233,"g":198,"b":142},"luminance":136.4698696013153},{"name":"Norse Blue","hex":"#4ca5c7","rgb":{"r":76,"g":165,"b":199},"luminance":102.03884454951456},{"name":"North Atlantic","hex":"#536d70","rgb":{"r":83,"g":109,"b":112},"luminance":69.80493966761951},{"name":"North Rim","hex":"#d8a892","rgb":{"r":216,"g":168,"b":146},"luminance":119.05138070597923},{"name":"North Sea","hex":"#316c6b","rgb":{"r":49,"g":108,"b":107},"luminance":66.20042160741878},{"name":"North Sea Blue","hex":"#343c4c","rgb":{"r":52,"g":60,"b":76},"luminance":39.462052658218376},{"name":"North Star","hex":"#f2dea4","rgb":{"r":242,"g":222,"b":164},"luminance":150.22303144325107},{"name":"North Star Blue","hex":"#223399","rgb":{"r":34,"g":51,"b":153},"luminance":36.108100046942376},{"name":"North Texas Green","hex":"#059033","rgb":{"r":5,"g":144,"b":51},"luminance":84.74090160601314},{"name":"Northampton Trees","hex":"#767962","rgb":{"r":118,"g":121,"b":98},"luminance":80.09037293582794},{"name":"Northern Barrens Dust","hex":"#de743c","rgb":{"r":222,"g":116,"b":60},"luminance":95.33805613709563},{"name":"Northern Beach","hex":"#e9dad2","rgb":{"r":233,"g":218,"b":210},"luminance":147.65470410725152},{"name":"Northern Exposure","hex":"#bfc7d4","rgb":{"r":191,"g":199,"b":212},"luminance":132.2528149946155},{"name":"Northern Landscape","hex":"#c5c1a3","rgb":{"r":197,"g":193,"b":163},"luminance":129.03373517805335},{"name":"Northern Lights","hex":"#e6f0ea","rgb":{"r":230,"g":240,"b":234},"luminance":159.02231376759678},{"name":"Northern Pond","hex":"#a3b9cd","rgb":{"r":163,"g":185,"b":205},"luminance":121.3026219584721},{"name":"Northern Sky","hex":"#8daccc","rgb":{"r":141,"g":172,"b":204},"luminance":111.8568375782187},{"name":"Northern Star","hex":"#ffffea","rgb":{"r":255,"g":255,"b":234},"luminance":170.08970640811867},{"name":"Northern Territory","hex":"#5e463c","rgb":{"r":94,"g":70,"b":60},"luminance":50.250581449372305},{"name":"Northgate Green","hex":"#aaa388","rgb":{"r":170,"g":163,"b":136},"luminance":109.44823743213044},{"name":"Northpointe","hex":"#9e9181","rgb":{"r":158,"g":145,"b":129},"luminance":98.45118701671402},{"name":"Northrend","hex":"#b9f2ff","rgb":{"r":185,"g":242,"b":255},"luminance":155.19069895132247},{"name":"Norway","hex":"#a4b88f","rgb":{"r":164,"g":184,"b":143},"luminance":119.73308884347718},{"name":"Norwich Green","hex":"#acb597","rgb":{"r":172,"g":181,"b":151},"luminance":119.28782833550119},{"name":"Nosegay","hex":"#ffe6ec","rgb":{"r":255,"g":230,"b":236},"luminance":157.36843819838845},{"name":"Nosferatu","hex":"#a9a8a8","rgb":{"r":169,"g":168,"b":168},"luminance":112.45130733344098},{"name":"Noshime Flower","hex":"#426579","rgb":{"r":66,"g":101,"b":121},"luminance":63.989480080713264},{"name":"Nostalgia","hex":"#d6b8bd","rgb":{"r":214,"g":184,"b":189},"luminance":127.37411972610448},{"name":"Nostalgia Rose","hex":"#a4777e","rgb":{"r":164,"g":119,"b":126},"luminance":86.54649271345431},{"name":"Not My Fault","hex":"#7e7d78","rgb":{"r":126,"g":125,"b":120},"luminance":83.60839252730553},{"name":"Not Yo Cheese","hex":"#ffc12c","rgb":{"r":255,"g":193,"b":44},"luminance":136.65032368055336},{"name":"Notes of Plum","hex":"#770f05","rgb":{"r":119,"g":15,"b":5},"luminance":36.6587027320935},{"name":"Notorious","hex":"#bda998","rgb":{"r":189,"g":169,"b":152},"luminance":115.47721816012022},{"name":"Notorious Neanderthal","hex":"#664400","rgb":{"r":102,"g":68,"b":0},"luminance":50.23360488756505},{"name":"Nottingham Forest","hex":"#585d4e","rgb":{"r":88,"g":93,"b":78},"luminance":61.25003093060443},{"name":"Nougat","hex":"#b69885","rgb":{"r":182,"g":152,"b":133},"luminance":105.60363224813811},{"name":"Nougat Brown","hex":"#7c503f","rgb":{"r":124,"g":80,"b":63},"luminance":60.26153416566822},{"name":"Nouveau Rose","hex":"#996872","rgb":{"r":153,"g":104,"b":114},"luminance":77.38567263389263},{"name":"Nouveau-Riche","hex":"#ffbb77","rgb":{"r":255,"g":187,"b":119},"luminance":134.33752172047835},{"name":"Novelle Peach","hex":"#e7cfbd","rgb":{"r":231,"g":207,"b":189},"luminance":141.41850641977518},{"name":"Novelty Navy","hex":"#515b62","rgb":{"r":81,"g":91,"b":98},"luminance":59.70552264238208},{"name":"Noxious","hex":"#89a203","rgb":{"r":137,"g":162,"b":3},"luminance":103.54203575843002},{"name":"Nuclear Blast","hex":"#bbff00","rgb":{"r":187,"g":255,"b":0},"luminance":159.78692935906867},{"name":"Nuclear Fallout","hex":"#aa9900","rgb":{"r":170,"g":153,"b":0},"luminance":103.1974060768971},{"name":"Nuclear Meltdown","hex":"#44ee00","rgb":{"r":68,"g":238,"b":0},"luminance":141.1777484591676},{"name":"Nuclear Throne","hex":"#00de00","rgb":{"r":0,"g":222,"b":0},"luminance":130.314},{"name":"Nuclear Waste","hex":"#7cfc00","rgb":{"r":124,"g":252,"b":0},"luminance":152.49963787497987},{"name":"Nude","hex":"#f2d3bc","rgb":{"r":242,"g":211,"b":188},"luminance":145.0364341708662},{"name":"Nugget","hex":"#bc9229","rgb":{"r":188,"g":146,"b":41},"luminance":102.59857710514314},{"name":"Nugget Gold","hex":"#c89720","rgb":{"r":200,"g":151,"b":32},"luminance":106.98535260959791},{"name":"Nuisette","hex":"#b48395","rgb":{"r":180,"g":131,"b":149},"luminance":95.38482691183121},{"name":"Nuit Blanche","hex":"#1e488f","rgb":{"r":30,"g":72,"b":143},"luminance":46.178585946301986},{"name":"Nuln Oil","hex":"#14100e","rgb":{"r":20,"g":16,"b":14},"luminance":11.247990042669846},{"name":"Nuln Oil Gloss","hex":"#171310","rgb":{"r":23,"g":19,"b":16},"luminance":13.22911614583529},{"name":"Numbers","hex":"#929bac","rgb":{"r":146,"g":155,"b":172},"luminance":102.80279959709267},{"name":"Nurgle's Rot","hex":"#9b8f22","rgb":{"r":155,"g":143,"b":34},"luminance":95.96339865803002},{"name":"Nurgling Green","hex":"#b8cc82","rgb":{"r":184,"g":204,"b":130},"luminance":132.61212674563362},{"name":"Nursery","hex":"#efd0d2","rgb":{"r":239,"g":208,"b":210},"luminance":143.48251230376474},{"name":"Nursery Green","hex":"#edf0de","rgb":{"r":237,"g":240,"b":222},"luminance":159.71610448855807},{"name":"Nurude Brown","hex":"#9d896c","rgb":{"r":157,"g":137,"b":108},"luminance":93.92787740601827},{"name":"Nut Brown","hex":"#86695e","rgb":{"r":134,"g":105,"b":94},"luminance":74.28990669667044},{"name":"Nut Cracker","hex":"#816c5b","rgb":{"r":129,"g":108,"b":91},"luminance":74.92926486360318},{"name":"Nut Milk","hex":"#d9ccc8","rgb":{"r":217,"g":204,"b":200},"luminance":138.09137262334676},{"name":"Nut Oil","hex":"#775d38","rgb":{"r":119,"g":93,"b":56},"luminance":65.47473022472104},{"name":"Nuthatch Back","hex":"#445599","rgb":{"r":68,"g":85,"b":153},"luminance":56.63148075937976},{"name":"Nutmeg","hex":"#7e4a3b","rgb":{"r":126,"g":74,"b":59},"luminance":57.8915295703957},{"name":"Nutmeg Glow","hex":"#d8b691","rgb":{"r":216,"g":182,"b":145},"luminance":125.92790600974828},{"name":"Nutmeg Wood Finish","hex":"#683600","rgb":{"r":104,"g":54,"b":0},"luminance":44.40410363919082},{"name":"Nutria","hex":"#75663e","rgb":{"r":117,"g":102,"b":62},"luminance":69.70410883871911},{"name":"Nyanza","hex":"#e9ffdb","rgb":{"r":233,"g":255,"b":219},"luminance":166.9802122109084},{"name":"NYC Taxi","hex":"#f7b731","rgb":{"r":247,"g":183,"b":49},"luminance":130.4788881237114},{"name":"Nyctophobia Blue","hex":"#4d587a","rgb":{"r":77,"g":88,"b":122},"luminance":58.23944822025703},{"name":"Nymph Green","hex":"#aec2a5","rgb":{"r":174,"g":194,"b":165},"luminance":126.60457993295503},{"name":"Nymph's Delight","hex":"#7b6c8e","rgb":{"r":123,"g":108,"b":142},"luminance":75.0576570977272},{"name":"Nymphaeaceae","hex":"#cee0e3","rgb":{"r":206,"g":224,"b":227},"luminance":147.48757867698552},{"name":"O'Brien Orange","hex":"#f3a347","rgb":{"r":243,"g":163,"b":71},"luminance":120.41348033339125},{"name":"O'grady Green","hex":"#58ac8f","rgb":{"r":88,"g":172,"b":143},"luminance":105.60211098268822},{"name":"O'Neal Green","hex":"#395643","rgb":{"r":57,"g":86,"b":67},"luminance":53.825971584356935},{"name":"Oak Barrel","hex":"#715636","rgb":{"r":113,"g":86,"b":54},"luminance":61.05644952828489},{"name":"Oak Buff","hex":"#cf9c63","rgb":{"r":207,"g":156,"b":99},"luminance":111.10152307236835},{"name":"Oak Harbour","hex":"#cdb386","rgb":{"r":205,"g":179,"b":134},"luminance":122.60003478792326},{"name":"Oak Plank","hex":"#5d4f39","rgb":{"r":93,"g":79,"b":57},"luminance":54.460154076168386},{"name":"Oak Shaving","hex":"#eed8c2","rgb":{"r":238,"g":216,"b":194},"luminance":147.0692318739715},{"name":"Oakley Apricot","hex":"#e0b695","rgb":{"r":224,"g":182,"b":149},"luminance":127.23133390796467},{"name":"Oakmoss","hex":"#6d7244","rgb":{"r":109,"g":114,"b":68},"luminance":74.83505534841275},{"name":"Oakwood","hex":"#bda58b","rgb":{"r":189,"g":165,"b":139},"luminance":113.24963515173016},{"name":"Oakwood Brown","hex":"#8f716e","rgb":{"r":143,"g":113,"b":110},"luminance":79.90753537683415},{"name":"Oasis","hex":"#0092a3","rgb":{"r":0,"g":146,"b":163},"luminance":87.6933493943526},{"name":"Oasis Sand","hex":"#fcedc5","rgb":{"r":252,"g":237,"b":197},"luminance":159.7991834428449},{"name":"Oasis Spring","hex":"#47a3c6","rgb":{"r":71,"g":163,"b":198},"luminance":100.5734526900613},{"name":"Oasis Stream","hex":"#a2ebd8","rgb":{"r":162,"g":235,"b":216},"luminance":148.26127021241925},{"name":"Oat Straw","hex":"#f1d694","rgb":{"r":241,"g":214,"b":148},"luminance":145.79796222512852},{"name":"Oath","hex":"#4a465a","rgb":{"r":74,"g":70,"b":90},"luminance":47.78300509595435},{"name":"Oatmeal","hex":"#cbc3b4","rgb":{"r":203,"g":195,"b":180},"luminance":131.17710331456476},{"name":"Oatmeal Bath","hex":"#ddc7a2","rgb":{"r":221,"g":199,"b":162},"luminance":135.4724261021408},{"name":"Oatmeal Biscuit","hex":"#b7a86d","rgb":{"r":183,"g":168,"b":109},"luminance":113.46131949259183},{"name":"Oatmeal Cookie","hex":"#eadac6","rgb":{"r":234,"g":218,"b":198},"luminance":147.58059999878031},{"name":"Objectivity","hex":"#bbc6de","rgb":{"r":187,"g":198,"b":222},"luminance":131.43531302127295},{"name":"Obligation","hex":"#54645c","rgb":{"r":84,"g":100,"b":92},"luminance":64.70318075643577},{"name":"Oblivion","hex":"#000435","rgb":{"r":0,"g":4,"b":53},"luminance":6.482196232759388},{"name":"Obscure Ochre","hex":"#88654e","rgb":{"r":136,"g":101,"b":78},"luminance":72.44016102273655},{"name":"Obscure Ogre","hex":"#771908","rgb":{"r":119,"g":25,"b":8},"luminance":38.49928479855177},{"name":"Obscure Olive","hex":"#4a5d23","rgb":{"r":74,"g":93,"b":35},"luminance":59.039455087254986},{"name":"Obscure Orange","hex":"#bb5500","rgb":{"r":187,"g":85,"b":0},"luminance":74.93847205541357},{"name":"Obscure Orchid","hex":"#9d0759","rgb":{"r":157,"g":7,"b":89},"luminance":48.20239045939527},{"name":"Observatory","hex":"#008f70","rgb":{"r":0,"g":143,"b":112},"luminance":84.90649742510874},{"name":"Obsession","hex":"#ae9550","rgb":{"r":174,"g":149,"b":80},"luminance":102.1746321011238},{"name":"Obsidian","hex":"#445055","rgb":{"r":68,"g":80,"b":85},"luminance":52.08193471828787},{"name":"Obsidian Shard","hex":"#060313","rgb":{"r":6,"g":3,"b":19},"luminance":3.31829971521561},{"name":"Obsidian Shell","hex":"#441166","rgb":{"r":68,"g":17,"b":102},"luminance":25.45940001256903},{"name":"Obtrusive Orange","hex":"#ffb077","rgb":{"r":255,"g":176,"b":119},"luminance":129.11508713159742},{"name":"Ocean","hex":"#005493","rgb":{"r":0,"g":84,"b":147},"luminance":52.07791689382362},{"name":"Ocean Blue","hex":"#009dc4","rgb":{"r":0,"g":157,"b":196},"luminance":94.82898089191931},{"name":"Ocean Boat Blue","hex":"#0077be","rgb":{"r":0,"g":119,"b":190},"luminance":73.13410428110814},{"name":"Ocean Breeze","hex":"#d3e5eb","rgb":{"r":211,"g":229,"b":235},"luminance":150.88892918302523},{"name":"Ocean Bubble","hex":"#8cadcd","rgb":{"r":140,"g":173,"b":205},"luminance":112.29880721094057},{"name":"Ocean Call","hex":"#2b6c8e","rgb":{"r":43,"g":108,"b":142},"luminance":66.68138127693517},{"name":"Ocean City","hex":"#7896ba","rgb":{"r":120,"g":150,"b":186},"luminance":97.41553529083541},{"name":"Ocean Cruise","hex":"#9cd4e1","rgb":{"r":156,"g":212,"b":225},"luminance":135.3510043257899},{"name":"Ocean Current","hex":"#537783","rgb":{"r":83,"g":119,"b":131},"luminance":75.61976893643619},{"name":"Ocean Depths","hex":"#006175","rgb":{"r":0,"g":97,"b":117},"luminance":58.480355376827184},{"name":"Ocean Dream","hex":"#d4dde2","rgb":{"r":212,"g":221,"b":226},"luminance":146.666004135246},{"name":"Ocean Drive","hex":"#b0bec5","rgb":{"r":176,"g":190,"b":197},"luminance":125.34986254479898},{"name":"Ocean Green","hex":"#3d9973","rgb":{"r":61,"g":153,"b":115},"luminance":92.57725931350528},{"name":"Ocean Liner","hex":"#189086","rgb":{"r":24,"g":144,"b":134},"luminance":86.19648447587639},{"name":"Ocean Mirage","hex":"#00748f","rgb":{"r":0,"g":116,"b":143},"luminance":70.01625288459816},{"name":"Ocean Night","hex":"#637195","rgb":{"r":99,"g":113,"b":149},"luminance":74.59587762068357},{"name":"Ocean Oasis","hex":"#006c68","rgb":{"r":0,"g":108,"b":104},"luminance":64.49509711598238},{"name":"Ocean Surf","hex":"#79a2bd","rgb":{"r":121,"g":162,"b":189},"luminance":104.00009131245992},{"name":"Ocean Trapeze","hex":"#2e526a","rgb":{"r":46,"g":82,"b":106},"luminance":51.498325487339876},{"name":"Ocean Trip","hex":"#62aeba","rgb":{"r":98,"g":174,"b":186},"luminance":108.35307039489005},{"name":"Ocean Wave","hex":"#8ec5b6","rgb":{"r":142,"g":197,"b":182},"luminance":124.92213410360871},{"name":"Ocean Weed","hex":"#6c6541","rgb":{"r":108,"g":101,"b":65},"luminance":67.91634363685961},{"name":"Oceanic","hex":"#4f6d82","rgb":{"r":79,"g":109,"b":130},"luminance":69.79547499659273},{"name":"Oceano","hex":"#9ad6e5","rgb":{"r":154,"g":214,"b":229},"luminance":136.31448666961265},{"name":"Ocelot","hex":"#f1e2c9","rgb":{"r":241,"g":226,"b":201},"luminance":152.69825513410427},{"name":"Ocher","hex":"#bf9b0c","rgb":{"r":191,"g":155,"b":12},"luminance":107.43174358633486},{"name":"Ochre","hex":"#cc7722","rgb":{"r":204,"g":119,"b":34},"luminance":92.81690040612214},{"name":"Ochre Brown","hex":"#9f7b3e","rgb":{"r":159,"g":123,"b":62},"luminance":86.7357348847636},{"name":"Ochre Maroon","hex":"#cc7733","rgb":{"r":204,"g":119,"b":51},"luminance":92.91800805548942},{"name":"Ochre Revival","hex":"#eec987","rgb":{"r":238,"g":201,"b":135},"luminance":138.64275860282063},{"name":"Ochre Yellow","hex":"#efcc83","rgb":{"r":239,"g":204,"b":131},"luminance":140.24721879951844},{"name":"Octarine","hex":"#ccdd00","rgb":{"r":204,"g":221,"b":0},"luminance":143.35133952984185},{"name":"October Haze","hex":"#f8ac8c","rgb":{"r":248,"g":172,"b":140},"luminance":126.28131294851191},{"name":"Ode to Green","hex":"#b6e5d6","rgb":{"r":182,"g":229,"b":214},"luminance":147.057901756417},{"name":"Ode to Purple","hex":"#a798c2","rgb":{"r":167,"g":152,"b":194},"luminance":104.61043982796363},{"name":"Odious Orange","hex":"#ffdfbf","rgb":{"r":255,"g":223,"b":191},"luminance":153.0440423603611},{"name":"Odyssey","hex":"#374a5a","rgb":{"r":55,"g":74,"b":90},"luminance":47.56643216597183},{"name":"Odyssey Grey","hex":"#434452","rgb":{"r":67,"g":68,"b":82},"luminance":45.628864208963165},{"name":"Off Blue","hex":"#5684ae","rgb":{"r":86,"g":132,"b":174},"luminance":84.0145639041232},{"name":"Off Green","hex":"#6ba353","rgb":{"r":107,"g":163,"b":83},"luminance":101.33082084933488},{"name":"Off the Grid","hex":"#9f9049","rgb":{"r":159,"g":144,"b":73},"luminance":97.33645334097599},{"name":"Off White","hex":"#ffffe4","rgb":{"r":255,"g":255,"b":228},"luminance":169.98377367854852},{"name":"Off Yellow","hex":"#f1f33f","rgb":{"r":241,"g":243,"b":63},"luminance":159.97042065957066},{"name":"Office Green","hex":"#00800f","rgb":{"r":0,"g":128,"b":15},"luminance":75.1554561958079},{"name":"Often Orange","hex":"#ff714e","rgb":{"r":255,"g":113,"b":78},"luminance":101.4503289792596},{"name":"Ogen Melon","hex":"#d7b235","rgb":{"r":215,"g":178,"b":53},"luminance":122.82667130961417},{"name":"Ogre Odor","hex":"#fd5240","rgb":{"r":253,"g":82,"b":64},"luminance":89.95878045527296},{"name":"Ogryn Camo","hex":"#9da94b","rgb":{"r":157,"g":169,"b":75},"luminance":110.0817103700701},{"name":"Ogryn Flesh Wash","hex":"#d1a14e","rgb":{"r":209,"g":161,"b":78},"luminance":113.64755076111408},{"name":"Oh Boy!","hex":"#bbdaf8","rgb":{"r":187,"g":218,"b":248},"luminance":142.48111000760767},{"name":"Oh Dahling","hex":"#edeec5","rgb":{"r":237,"g":238,"b":197},"luminance":158.25199199062234},{"name":"Oh My Gold","hex":"#eebb55","rgb":{"r":238,"g":187,"b":85},"luminance":131.17606376545987},{"name":"Oh So Pretty","hex":"#eac7cb","rgb":{"r":234,"g":199,"b":203},"luminance":138.11614782131738},{"name":"Oil","hex":"#313330","rgb":{"r":49,"g":51,"b":48},"luminance":33.77600559568878},{"name":"Oil Blue","hex":"#658c88","rgb":{"r":101,"g":140,"b":136},"luminance":88.91516190729227},{"name":"Oil Green","hex":"#80856d","rgb":{"r":128,"g":133,"b":109},"luminance":87.83070363489068},{"name":"Oil Of Lavender","hex":"#c7bebe","rgb":{"r":199,"g":190,"b":190},"luminance":128.25157114437232},{"name":"Oil Rush","hex":"#333144","rgb":{"r":51,"g":49,"b":68},"luminance":33.4654399941193},{"name":"Oil Slick","hex":"#031602","rgb":{"r":3,"g":22,"b":2},"luminance":12.947122807790153},{"name":"Oil Yellow","hex":"#c4a647","rgb":{"r":196,"g":166,"b":71},"luminance":113.99510961440407},{"name":"Oiled Up Kardashian","hex":"#996644","rgb":{"r":153,"g":102,"b":68},"luminance":75.74811805583028},{"name":"Oilseed Crops","hex":"#c2be0e","rgb":{"r":194,"g":190,"b":14},"luminance":125.72264772903885},{"name":"Oily Steel","hex":"#99aaaa","rgb":{"r":153,"g":170,"b":170},"luminance":111.47383777819798},{"name":"Oitake Green","hex":"#5e644f","rgb":{"r":94,"g":100,"b":79},"luminance":65.7019426805631},{"name":"OK Corral","hex":"#d07360","rgb":{"r":208,"g":115,"b":96},"luminance":92.43668657519048},{"name":"Okra","hex":"#fdefe9","rgb":{"r":253,"g":239,"b":233},"luminance":161.58630604726378},{"name":"Okroshka","hex":"#40533d","rgb":{"r":64,"g":83,"b":61},"luminance":52.80417079170924},{"name":"Old Army Helmet","hex":"#616652","rgb":{"r":97,"g":102,"b":82},"luminance":67.18225203876392},{"name":"Old Asparagus","hex":"#929000","rgb":{"r":146,"g":144,"b":0},"luminance":95.13492786563722},{"name":"Old Bamboo","hex":"#769164","rgb":{"r":118,"g":145,"b":100},"luminance":92.84041549346921},{"name":"Old Benchmark","hex":"#029386","rgb":{"r":2,"g":147,"b":134},"luminance":87.6327866782747},{"name":"Old Bone","hex":"#dbc2ab","rgb":{"r":219,"g":194,"b":171},"luminance":132.80051310518346},{"name":"Old Boot","hex":"#7c644b","rgb":{"r":124,"g":100,"b":75},"luminance":69.95300047889296},{"name":"Old Brick","hex":"#8a3335","rgb":{"r":138,"g":51,"b":53},"luminance":51.33500148047139},{"name":"Old Brown Crayon","hex":"#330000","rgb":{"r":51,"g":0,"b":0},"luminance":15.248999999999999},{"name":"Old Burgundy","hex":"#43302e","rgb":{"r":67,"g":48,"b":46},"luminance":34.96723610753357},{"name":"Old Chalk","hex":"#e3d6e9","rgb":{"r":227,"g":214,"b":233},"luminance":145.23142186524237},{"name":"Old Cheddar","hex":"#dd6644","rgb":{"r":221,"g":102,"b":68},"luminance":89.50655630175925},{"name":"Old Coffee","hex":"#704241","rgb":{"r":112,"g":66,"b":65},"luminance":51.74260148079143},{"name":"Old Copper","hex":"#73503b","rgb":{"r":115,"g":80,"b":59},"luminance":58.5901775129586},{"name":"Old Cumin","hex":"#784430","rgb":{"r":120,"g":68,"b":48},"luminance":53.95001612604022},{"name":"Old Doeskin","hex":"#bdab9b","rgb":{"r":189,"g":171,"b":155},"luminance":116.53868091753912},{"name":"Old Driftwood","hex":"#97694f","rgb":{"r":151,"g":105,"b":79},"luminance":76.93122553293948},{"name":"Old Eggplant","hex":"#614051","rgb":{"r":97,"g":64,"b":81},"luminance":48.35075375834383},{"name":"Old Eggshell","hex":"#cdc4ba","rgb":{"r":205,"g":196,"b":186},"luminance":132.0744083651333},{"name":"Old Faithful","hex":"#82a2be","rgb":{"r":130,"g":162,"b":190},"luminance":104.99000588627472},{"name":"Old Fashioned Purple","hex":"#73486b","rgb":{"r":115,"g":72,"b":107},"luminance":55.83336927859539},{"name":"Old Four Leaf Clover","hex":"#757d43","rgb":{"r":117,"g":125,"b":67},"luminance":81.64582021144744},{"name":"Old Geranium","hex":"#c66787","rgb":{"r":198,"g":103,"b":135},"luminance":86.00733355359878},{"name":"Old Glory Blue","hex":"#002868","rgb":{"r":0,"g":40,"b":104},"luminance":26.303519460330776},{"name":"Old Glory Red","hex":"#bf0a30","rgb":{"r":191,"g":10,"b":48},"luminance":57.67007512566634},{"name":"Old Gold","hex":"#cfb53b","rgb":{"r":207,"g":181,"b":59},"luminance":123.14384894910505},{"name":"Old Grey Mare","hex":"#b4b6ad","rgb":{"r":180,"g":182,"b":173},"luminance":121.23965209451897},{"name":"Old Gungeon Red","hex":"#0063ec","rgb":{"r":0,"g":99,"b":236},"luminance":64.03862885009329},{"name":"Old Heart","hex":"#e66a77","rgb":{"r":230,"g":106,"b":119},"luminance":93.7279389509873},{"name":"Old Heliotrope","hex":"#563c5c","rgb":{"r":86,"g":60,"b":92},"luminance":44.851492059908104},{"name":"Old Ivory","hex":"#ffffcb","rgb":{"r":255,"g":255,"b":203},"luminance":169.57137557382734},{"name":"Old Lace","hex":"#fdf5e6","rgb":{"r":253,"g":245,"b":230},"luminance":164.5986367926539},{"name":"Old Laser Lemon","hex":"#fdfc74","rgb":{"r":253,"g":252,"b":116},"luminance":166.66989098514463},{"name":"Old Lavender","hex":"#796878","rgb":{"r":121,"g":104,"b":120},"luminance":72.26977753528787},{"name":"Old Leather","hex":"#a88b66","rgb":{"r":168,"g":139,"b":102},"luminance":96.51881607748822},{"name":"Old Lime","hex":"#aec571","rgb":{"r":174,"g":197,"b":113},"luminance":127.45598817238834},{"name":"Old Mahogany","hex":"#4a0100","rgb":{"r":74,"g":1,"b":0},"luminance":22.13378514850092},{"name":"Old Mandarin","hex":"#8e2323","rgb":{"r":142,"g":35,"b":35},"luminance":47.33602105162621},{"name":"Old Mauve","hex":"#673147","rgb":{"r":103,"g":49,"b":71},"luminance":42.910117851154865},{"name":"Old Mill","hex":"#343b4e","rgb":{"r":52,"g":59,"b":78},"luminance":38.99041750225303},{"name":"Old Mill Blue","hex":"#6e6f82","rgb":{"r":110,"g":111,"b":130},"luminance":74.47697059494297},{"name":"Old Mission Pink","hex":"#d8c2ca","rgb":{"r":216,"g":194,"b":202},"luminance":132.92697515553417},{"name":"Old Money","hex":"#2c5c4f","rgb":{"r":44,"g":92,"b":79},"luminance":56.30826216462376},{"name":"Old Moss Green","hex":"#867e36","rgb":{"r":134,"g":126,"b":54},"luminance":84.34191209594431},{"name":"Old Nan Yarn","hex":"#5e5896","rgb":{"r":94,"g":88,"b":150},"luminance":61.24295528466927},{"name":"Old Pearls","hex":"#f6ebd7","rgb":{"r":246,"g":235,"b":215},"luminance":158.2395463877472},{"name":"Old Pink","hex":"#c77986","rgb":{"r":199,"g":121,"b":134},"luminance":93.9071877227723},{"name":"Old Prune","hex":"#8272a4","rgb":{"r":130,"g":114,"b":164},"luminance":79.61429545000068},{"name":"Old Red Crest","hex":"#d8cbcf","rgb":{"r":216,"g":203,"b":207},"luminance":137.57653354042614},{"name":"Old Rose","hex":"#c08081","rgb":{"r":192,"g":128,"b":129},"luminance":95.69411369567095},{"name":"Old Ruin","hex":"#917b53","rgb":{"r":145,"g":123,"b":83},"luminance":84.74768356716305},{"name":"Old School","hex":"#353c3d","rgb":{"r":53,"g":60,"b":61},"luminance":39.241991858212295},{"name":"Old Silver","hex":"#848482","rgb":{"r":132,"g":132,"b":130},"luminance":88.2106891481979},{"name":"Old Trail","hex":"#bb8811","rgb":{"r":187,"g":136,"b":17},"luminance":97.48419172871056},{"name":"Old Treasure Chest","hex":"#544333","rgb":{"r":84,"g":67,"b":51},"luminance":47.025379243553154},{"name":"Old Truck","hex":"#0a888a","rgb":{"r":10,"g":136,"b":138},"luminance":81.4222583081555},{"name":"Old Whiskey","hex":"#ddaa55","rgb":{"r":221,"g":170,"b":85},"luminance":120.07653576365367},{"name":"Old Willow Leaf","hex":"#756947","rgb":{"r":117,"g":105,"b":71},"luminance":71.33159433238542},{"name":"Old Wine","hex":"#90091f","rgb":{"r":144,"g":9,"b":31},"luminance":43.522619188187655},{"name":"Old World","hex":"#b2b7d1","rgb":{"r":178,"g":183,"b":209},"luminance":122.22737337028886},{"name":"Old Yella","hex":"#feed9a","rgb":{"r":254,"g":237,"b":154},"luminance":159.4681918534226},{"name":"Old Yellow Bricks","hex":"#ece6d7","rgb":{"r":236,"g":230,"b":215},"luminance":154.29749931868628},{"name":"Ole Yeller","hex":"#c79e5f","rgb":{"r":199,"g":158,"b":95},"luminance":110.72252894962253},{"name":"Oleander Pink","hex":"#f85898","rgb":{"r":248,"g":88,"b":152},"luminance":92.01696052359043},{"name":"Olive","hex":"#808010","rgb":{"r":128,"g":128,"b":16},"luminance":84.34151679926084},{"name":"Olive Bark","hex":"#5f5537","rgb":{"r":95,"g":85,"b":55},"luminance":57.75524175345472},{"name":"Olive Branch","hex":"#646a45","rgb":{"r":100,"g":106,"b":69},"luminance":69.47993408171887},{"name":"Olive Bread","hex":"#c3bebb","rgb":{"r":195,"g":190,"b":187},"luminance":127.64353116785824},{"name":"Olive Brown","hex":"#645403","rgb":{"r":100,"g":84,"b":3},"luminance":57.66633184103181},{"name":"Olive Chutney","hex":"#a6997a","rgb":{"r":166,"g":153,"b":122},"luminance":103.55183311269771},{"name":"Olive Court","hex":"#5f5d48","rgb":{"r":95,"g":93,"b":72},"luminance":62.08375447731878},{"name":"Olive Creed","hex":"#e8ecc0","rgb":{"r":232,"g":236,"b":192},"luminance":156.46762921448},{"name":"Olive Drab","hex":"#6f7632","rgb":{"r":111,"g":118,"b":50},"luminance":77.01803994519724},{"name":"Olive Green","hex":"#677a04","rgb":{"r":103,"g":122,"b":4},"luminance":77.95657856140171},{"name":"Olive Grey","hex":"#afa78d","rgb":{"r":175,"g":167,"b":141},"luminance":112.27628396950087},{"name":"Olive Grove","hex":"#716a4d","rgb":{"r":113,"g":106,"b":77},"luminance":71.3455810614785},{"name":"Olive Haze","hex":"#888064","rgb":{"r":136,"g":128,"b":100},"luminance":86.19129533775438},{"name":"Olive Hint","hex":"#c9bd88","rgb":{"r":201,"g":189,"b":136},"luminance":127.12439996318565},{"name":"Olive It","hex":"#aeab9a","rgb":{"r":174,"g":171,"b":154},"luminance":114.41354789097312},{"name":"Olive Leaf","hex":"#4e4b35","rgb":{"r":78,"g":75,"b":53},"luminance":50.18587523397395},{"name":"Olive Leaf Tea","hex":"#78866b","rgb":{"r":120,"g":134,"b":107},"luminance":87.31120528317084},{"name":"Olive Martini","hex":"#ced2ab","rgb":{"r":206,"g":210,"b":171},"luminance":139.17373952006895},{"name":"Olive Night","hex":"#535040","rgb":{"r":83,"g":80,"b":64},"luminance":53.61302738141168},{"name":"Olive Ochre","hex":"#837752","rgb":{"r":131,"g":119,"b":82},"luminance":80.62901012662874},{"name":"Olive Oil","hex":"#bab86c","rgb":{"r":186,"g":184,"b":108},"luminance":122.10745433428706},{"name":"Olive Paste","hex":"#83826d","rgb":{"r":131,"g":130,"b":109},"luminance":86.67082633158634},{"name":"Olive Pit","hex":"#a9a491","rgb":{"r":169,"g":164,"b":145},"luminance":109.97340899053735},{"name":"Olive Reserve","hex":"#a4a84d","rgb":{"r":164,"g":168,"b":77},"luminance":110.48392659568178},{"name":"Olive Sand","hex":"#9abf8d","rgb":{"r":154,"g":191,"b":141},"luminance":122.26540508663928},{"name":"Olive Sapling","hex":"#7f7452","rgb":{"r":127,"g":116,"b":82},"luminance":78.52295394978465},{"name":"Olive Soap","hex":"#97a49a","rgb":{"r":151,"g":164,"b":154},"luminance":107.76907330491434},{"name":"Olive Sprig","hex":"#acaf95","rgb":{"r":172,"g":175,"b":149},"luminance":116.12832989843606},{"name":"Olive Wood","hex":"#756244","rgb":{"r":117,"g":98,"b":68},"luminance":67.7727413419289},{"name":"Olive Yellow","hex":"#c2b709","rgb":{"r":194,"g":183,"b":9},"luminance":122.08611695438591},{"name":"Olivenite","hex":"#333311","rgb":{"r":51,"g":51,"b":17},"luminance":33.65281286906044},{"name":"Olivetone","hex":"#747028","rgb":{"r":116,"g":112,"b":40},"luminance":74.47178655034402},{"name":"Olivia","hex":"#996622","rgb":{"r":153,"g":102,"b":34},"luminance":75.45003155068923},{"name":"Olivine","hex":"#9ab973","rgb":{"r":154,"g":185,"b":115},"luminance":118.68015942439578},{"name":"Olm Pink","hex":"#ffe6e2","rgb":{"r":255,"g":230,"b":226},"luminance":157.17755508023401},{"name":"Olympia Ivy","hex":"#5a6647","rgb":{"r":90,"g":102,"b":71},"luminance":66.14043250538963},{"name":"Olympian Blue","hex":"#1a4c8b","rgb":{"r":26,"g":76,"b":139},"luminance":47.97667491604644},{"name":"Ombre Blue","hex":"#434854","rgb":{"r":67,"g":72,"b":84},"luminance":47.741664832722364},{"name":"Omphalodes","hex":"#b5cedf","rgb":{"r":181,"g":206,"b":223},"luminance":134.8972732452365},{"name":"On Cloud Nine","hex":"#c2e7e8","rgb":{"r":194,"g":231,"b":232},"luminance":149.8357071895748},{"name":"On the Avenue","hex":"#948776","rgb":{"r":148,"g":135,"b":118},"luminance":91.75492266358246},{"name":"On the Nile","hex":"#b29aa7","rgb":{"r":178,"g":154,"b":167},"luminance":106.61531377808724},{"name":"Onahau","hex":"#c2e6ec","rgb":{"r":194,"g":230,"b":236},"luminance":149.38614846096007},{"name":"One Year of Rain","hex":"#29465b","rgb":{"r":41,"g":70,"b":91},"luminance":44.11678883373086},{"name":"Onion","hex":"#48412b","rgb":{"r":72,"g":65,"b":43},"luminance":44.08274507105927},{"name":"Onion Powder","hex":"#ece2d4","rgb":{"r":236,"g":226,"b":212},"luminance":152.19256408905133},{"name":"Onion Seedling","hex":"#47885e","rgb":{"r":71,"g":136,"b":94},"luminance":83.29856734062116},{"name":"Onion Skin","hex":"#eeeddf","rgb":{"r":238,"g":237,"b":223},"luminance":158.31741688456137},{"name":"Online Lime","hex":"#44883c","rgb":{"r":68,"g":136,"b":60},"luminance":82.6639222877792},{"name":"Only Oatmeal","hex":"#d4cdb5","rgb":{"r":212,"g":205,"b":181},"luminance":137.56566695582148},{"name":"Only Olive","hex":"#cbccb5","rgb":{"r":203,"g":204,"b":181},"luminance":135.82883077241002},{"name":"Only Yesterday","hex":"#f4d1b9","rgb":{"r":244,"g":209,"b":185},"luminance":144.2861203477313},{"name":"Ontario Violet","hex":"#777cb0","rgb":{"r":119,"g":124,"b":176},"luminance":83.4665477961081},{"name":"Onyx","hex":"#464544","rgb":{"r":70,"g":69,"b":68},"luminance":46.24555560267387},{"name":"Onyx Heart","hex":"#353839","rgb":{"r":53,"g":56,"b":57},"luminance":37.06642411941028},{"name":"Ooid Sand","hex":"#c2beb6","rgb":{"r":194,"g":190,"b":182},"luminance":127.41317216049524},{"name":"Opal","hex":"#aee0e4","rgb":{"r":174,"g":224,"b":228},"luminance":143.7754599505771},{"name":"Opal Blue","hex":"#c3ddd6","rgb":{"r":195,"g":221,"b":214},"luminance":144.3043047521452},{"name":"Opal Fire","hex":"#e49c86","rgb":{"r":228,"g":156,"b":134},"luminance":115.17902996639621},{"name":"Opal Flame","hex":"#e95c4b","rgb":{"r":233,"g":92,"b":75},"luminance":88.56085707015261},{"name":"Opal Green","hex":"#157954","rgb":{"r":21,"g":121,"b":84},"luminance":71.94414740616502},{"name":"Opal Grey","hex":"#a49e9e","rgb":{"r":164,"g":158,"b":158},"luminance":106.44614580152727},{"name":"Opalescent","hex":"#3c94c1","rgb":{"r":60,"g":148,"b":193},"luminance":91.39677773313454},{"name":"Opalescent Coral","hex":"#ffd2a9","rgb":{"r":255,"g":210,"b":169},"luminance":146.21891697383072},{"name":"Opaline","hex":"#c1d1c4","rgb":{"r":193,"g":209,"b":196},"luminance":137.40622501910167},{"name":"Opaline Green","hex":"#a3c57d","rgb":{"r":163,"g":197,"b":125},"luminance":126.29622318185132},{"name":"Open Range","hex":"#91876b","rgb":{"r":145,"g":135,"b":107},"luminance":91.14942267507786},{"name":"Open Sesame","hex":"#f8e2a9","rgb":{"r":248,"g":226,"b":169},"luminance":153.19563996406686},{"name":"Opera","hex":"#816575","rgb":{"r":129,"g":101,"b":117},"luminance":71.97619505086386},{"name":"Opera Mauve","hex":"#b784a7","rgb":{"r":183,"g":132,"b":167},"luminance":96.74794979223073},{"name":"Opera Red","hex":"#ff1b2d","rgb":{"r":255,"g":27,"b":45},"luminance":78.04362706845447},{"name":"Opium","hex":"#987e7e","rgb":{"r":152,"g":126,"b":126},"luminance":87.98990080685395},{"name":"Opulent Ostrich","hex":"#775577","rgb":{"r":119,"g":85,"b":119},"luminance":62.76587402402678},{"name":"Opulent Violet","hex":"#a09ec6","rgb":{"r":160,"g":158,"b":198},"luminance":106.77069494950382},{"name":"Opus","hex":"#cecae1","rgb":{"r":206,"g":202,"b":225},"luminance":136.05710864192287},{"name":"Opus Magnum","hex":"#e3e1ed","rgb":{"r":227,"g":225,"b":237},"luminance":150.9321770796406},{"name":"Oracle","hex":"#395555","rgb":{"r":57,"g":85,"b":85},"luminance":53.60849721825822},{"name":"Orange","hex":"#ffa500","rgb":{"r":255,"g":165,"b":0},"luminance":123.26471940502682},{"name":"Orange Aura","hex":"#ff9682","rgb":{"r":255,"g":150,"b":130},"luminance":117.41266935471657},{"name":"Orange Avant-Garde","hex":"#ff8822","rgb":{"r":255,"g":136,"b":34},"luminance":110.4602717043553},{"name":"Orange Bell Pepper","hex":"#ff8844","rgb":{"r":255,"g":136,"b":68},"luminance":110.66409423566434},{"name":"Orange Brown","hex":"#b16002","rgb":{"r":177,"g":96,"b":2},"luminance":77.30746288037139},{"name":"Orange Burst","hex":"#ff6e3a","rgb":{"r":255,"g":110,"b":58},"luminance":100.1314309744947},{"name":"Orange Chalk","hex":"#fad48b","rgb":{"r":250,"g":212,"b":139},"luminance":146.0307068804366},{"name":"Orange Chiffon","hex":"#f9aa7d","rgb":{"r":249,"g":170,"b":125},"luminance":125.31583300205924},{"name":"Orange Chocolate","hex":"#f3c775","rgb":{"r":243,"g":199,"b":117},"luminance":138.2107769387033},{"name":"Orange Clay","hex":"#e6a57f","rgb":{"r":230,"g":165,"b":127},"luminance":119.66543531446328},{"name":"Orange Coloured White","hex":"#fbebcf","rgb":{"r":251,"g":235,"b":207},"luminance":158.80189240056302},{"name":"Orange Com","hex":"#da321c","rgb":{"r":218,"g":50,"b":28},"luminance":71.55630292294313},{"name":"Orange Crush","hex":"#ee7733","rgb":{"r":238,"g":119,"b":51},"luminance":99.8863076152082},{"name":"Orange Danger","hex":"#dd6600","rgb":{"r":221,"g":102,"b":0},"luminance":89.17023111442516},{"name":"Orange Daylily","hex":"#eb7d5d","rgb":{"r":235,"g":125,"b":93},"luminance":102.14432560842526},{"name":"Orange Delight","hex":"#ffc355","rgb":{"r":255,"g":195,"b":85},"luminance":137.87469800510897},{"name":"Orange Drop","hex":"#e18e3f","rgb":{"r":225,"g":142,"b":63},"luminance":107.35639741068066},{"name":"Orange Essential","hex":"#d1907c","rgb":{"r":209,"g":144,"b":124},"luminance":106.06570775231738},{"name":"Orange Fire","hex":"#ffaf6b","rgb":{"r":255,"g":175,"b":107},"luminance":128.5088201408759},{"name":"Orange Glass","hex":"#ffca7d","rgb":{"r":255,"g":202,"b":125},"luminance":141.69035253326174},{"name":"Orange Gluttony","hex":"#ee7722","rgb":{"r":238,"g":119,"b":34},"luminance":99.79226036622278},{"name":"Orange Hibiscus","hex":"#ff9a45","rgb":{"r":255,"g":154,"b":69},"luminance":118.51992400014437},{"name":"Orange Jelly","hex":"#fac205","rgb":{"r":250,"g":194,"b":5},"luminance":136.22072633780806},{"name":"Orange Jewel","hex":"#ff9731","rgb":{"r":255,"g":151,"b":49},"luminance":117.05136133339073},{"name":"Orange Juice","hex":"#ff7f00","rgb":{"r":255,"g":127,"b":0},"luminance":106.63420382785253},{"name":"Orange Keeper","hex":"#ca5333","rgb":{"r":202,"g":83,"b":51},"luminance":77.81681592689334},{"name":"Orange Lily","hex":"#be7249","rgb":{"r":190,"g":114,"b":73},"luminance":88.17397863315456},{"name":"Orange Liqueur","hex":"#edaa80","rgb":{"r":237,"g":170,"b":128},"luminance":123.25800311947293},{"name":"Orange Maple","hex":"#d3a083","rgb":{"r":211,"g":160,"b":131},"luminance":114.12367272831696},{"name":"Orange Marmalade","hex":"#faac72","rgb":{"r":250,"g":172,"b":114},"luminance":126.29405295579043},{"name":"Orange Ochre","hex":"#dc793a","rgb":{"r":220,"g":121,"b":58},"luminance":97.03381716185342},{"name":"Orange Outburst","hex":"#dd7700","rgb":{"r":221,"g":119,"b":0},"luminance":96.15547748308465},{"name":"Orange Peel","hex":"#ffa000","rgb":{"r":255,"g":160,"b":0},"luminance":120.97217210995261},{"name":"Orange Pepper","hex":"#df7500","rgb":{"r":223,"g":117,"b":0},"luminance":95.72161391242835},{"name":"Orange Piñata","hex":"#ff6611","rgb":{"r":255,"g":102,"b":17},"luminance":96.96366198220856},{"name":"Orange Pink","hex":"#ff6f52","rgb":{"r":255,"g":111,"b":82},"luminance":100.7279493388007},{"name":"Orange Poppy","hex":"#e68750","rgb":{"r":230,"g":135,"b":80},"luminance":105.31978600908758},{"name":"Orange Popsicle","hex":"#ff7913","rgb":{"r":255,"g":121,"b":19},"luminance":104.22488335325686},{"name":"Orange Red","hex":"#fe4401","rgb":{"r":254,"g":68,"b":1},"luminance":85.79682376405317},{"name":"Orange Roughy","hex":"#a85335","rgb":{"r":168,"g":83,"b":53},"luminance":70.23884558419222},{"name":"Orange Rust","hex":"#c25a3c","rgb":{"r":194,"g":90,"b":60},"luminance":78.75589207164121},{"name":"Orange Salmonberry","hex":"#f0b073","rgb":{"r":240,"g":176,"b":115},"luminance":126.47030894245493},{"name":"Orange Satisfaction","hex":"#dd9900","rgb":{"r":221,"g":153,"b":0},"luminance":111.50089668697736},{"name":"Orange Shot","hex":"#dd7744","rgb":{"r":221,"g":119,"b":68},"luminance":96.46745230387293},{"name":"Orange Soda","hex":"#fa5b3d","rgb":{"r":250,"g":91,"b":61},"luminance":92.13737843568157},{"name":"Orange Squash","hex":"#c27635","rgb":{"r":194,"g":118,"b":53},"luminance":90.54822226857907},{"name":"Orange Tea Rose","hex":"#ff8379","rgb":{"r":255,"g":131,"b":121},"luminance":109.16374430185141},{"name":"Orange Tiger","hex":"#f96714","rgb":{"r":249,"g":103,"b":20},"luminance":95.93582397623945},{"name":"Orange Vermillion","hex":"#bc5339","rgb":{"r":188,"g":83,"b":57},"luminance":74.67093670900346},{"name":"Orange White","hex":"#eae3cd","rgb":{"r":234,"g":227,"b":205},"luminance":152.3046094410803},{"name":"Orange Wood","hex":"#b74923","rgb":{"r":183,"g":73,"b":35},"luminance":69.61378017318123},{"name":"Orange Yellow","hex":"#fdb915","rgb":{"r":253,"g":185,"b":21},"luminance":132.3671933297673},{"name":"Orange Zest","hex":"#f07227","rgb":{"r":240,"g":114,"b":39},"luminance":98.22058460424677},{"name":"Orangeade","hex":"#e2552c","rgb":{"r":226,"g":85,"b":44},"luminance":84.14818332560722},{"name":"Orangealicious","hex":"#ee5511","rgb":{"r":238,"g":85,"b":17},"luminance":86.93271601071716},{"name":"Orangeville","hex":"#e57059","rgb":{"r":229,"g":112,"b":89},"luminance":95.46461487378451},{"name":"Orangina","hex":"#fec615","rgb":{"r":254,"g":198,"b":21},"luminance":138.85967459273408},{"name":"Orangish","hex":"#fd8d49","rgb":{"r":253,"g":141,"b":73},"luminance":112.43709611155919},{"name":"Orangish Brown","hex":"#b25f03","rgb":{"r":178,"g":95,"b":3},"luminance":77.08718099009718},{"name":"Orangish Red","hex":"#f43605","rgb":{"r":244,"g":54,"b":5},"luminance":79.54662808692774},{"name":"Oranzhewyi Orange","hex":"#ee6237","rgb":{"r":238,"g":98,"b":55},"luminance":91.72013857381594},{"name":"Orbital","hex":"#6d83bb","rgb":{"r":109,"g":131,"b":187},"luminance":86.19616588920879},{"name":"Orbital Kingdom","hex":"#220088","rgb":{"r":34,"g":0,"b":136},"luminance":18.53972955574056},{"name":"Orca White","hex":"#d0ccc9","rgb":{"r":208,"g":204,"b":201},"luminance":136.86664956811063},{"name":"Orchid","hex":"#7a81ff","rgb":{"r":122,"g":129,"b":255},"luminance":88.93639363612627},{"name":"Orchid Bloom","hex":"#c5aecf","rgb":{"r":197,"g":174,"b":207},"luminance":120.24391900216825},{"name":"Orchid Blossom","hex":"#e4e1e4","rgb":{"r":228,"g":225,"b":228},"luminance":150.88674982582134},{"name":"Orchid Bouquet","hex":"#d1acce","rgb":{"r":209,"g":172,"b":206},"luminance":121.03864107383228},{"name":"Orchid Dottyback","hex":"#aa55aa","rgb":{"r":170,"g":85,"b":170},"luminance":73.81588125193656},{"name":"Orchid Ecstasy","hex":"#bb4488","rgb":{"r":187,"g":68,"b":136},"luminance":70.42673243165552},{"name":"Orchid Haze","hex":"#b0879b","rgb":{"r":176,"g":135,"b":155},"luminance":96.7537301658184},{"name":"Orchid Hue","hex":"#e5e999","rgb":{"r":229,"g":233,"b":153},"luminance":153.94417054893634},{"name":"Orchid Hush","hex":"#cec3d2","rgb":{"r":206,"g":195,"b":210},"luminance":132.1710280696946},{"name":"Orchid Ice","hex":"#e0d0db","rgb":{"r":224,"g":208,"b":219},"luminance":141.47974748351794},{"name":"Orchid Lane","hex":"#e5dde7","rgb":{"r":229,"g":221,"b":231},"luminance":149.03305648747863},{"name":"Orchid Lei","hex":"#9c4a7d","rgb":{"r":156,"g":74,"b":125},"luminance":65.31144677619689},{"name":"Orchid Mist","hex":"#e8e6e8","rgb":{"r":232,"g":230,"b":232},"luminance":154.0750344085634},{"name":"Orchid Orange","hex":"#ffa180","rgb":{"r":255,"g":161,"b":128},"luminance":122.3020831302558},{"name":"Orchid Petal","hex":"#bfb4cb","rgb":{"r":191,"g":180,"b":203},"luminance":122.31527151177812},{"name":"Orchid Pink","hex":"#f3bbca","rgb":{"r":243,"g":187,"b":202},"luminance":133.6359300263219},{"name":"Orchid Smoke","hex":"#d294aa","rgb":{"r":210,"g":148,"b":170},"luminance":108.92937104380984},{"name":"Orchid Tint","hex":"#dbd2db","rgb":{"r":219,"g":210,"b":219},"luminance":141.7975860760683},{"name":"Orchid Whisper","hex":"#dde0e8","rgb":{"r":221,"g":224,"b":232},"luminance":149.51596934441486},{"name":"Orchid White","hex":"#f1ebd9","rgb":{"r":241,"g":235,"b":217},"luminance":157.5858215386143},{"name":"Orchilla","hex":"#938ea9","rgb":{"r":147,"g":142,"b":169},"luminance":96.18177728135407},{"name":"Ordain","hex":"#998188","rgb":{"r":153,"g":129,"b":136},"luminance":89.81722971679766},{"name":"Orecchiette","hex":"#faeecb","rgb":{"r":250,"g":238,"b":203},"luminance":160.12770247524318},{"name":"Oregano","hex":"#7f8353","rgb":{"r":127,"g":131,"b":83},"luminance":86.28225067764515},{"name":"Oregon","hex":"#9b4703","rgb":{"r":155,"g":71,"b":3},"luminance":62.32935358240128},{"name":"Oregon Grape","hex":"#49354e","rgb":{"r":73,"g":53,"b":78},"luminance":39.03049979182946},{"name":"Oregon Hazel","hex":"#916238","rgb":{"r":145,"g":98,"b":56},"luminance":72.31633395713585},{"name":"Orenju Ogon Koi","hex":"#ffcda8","rgb":{"r":255,"g":205,"b":168},"luminance":143.7379955126688},{"name":"Organic","hex":"#747261","rgb":{"r":116,"g":114,"b":97},"luminance":76.17924877550315},{"name":"Organic Bamboo","hex":"#e1cda4","rgb":{"r":225,"g":205,"b":164},"luminance":139.12576420634676},{"name":"Organic Fiber","hex":"#feede0","rgb":{"r":254,"g":237,"b":224},"luminance":160.5427618206439},{"name":"Organic Matter","hex":"#a99e54","rgb":{"r":169,"g":158,"b":84},"luminance":106.05141325319525},{"name":"Organza","hex":"#ffdea6","rgb":{"r":255,"g":222,"b":166},"luminance":152.1616127576203},{"name":"Orient","hex":"#255b77","rgb":{"r":37,"g":91,"b":119},"luminance":56.212118035171024},{"name":"Orient Blue","hex":"#47457a","rgb":{"r":71,"g":69,"b":122},"luminance":47.79744673097089},{"name":"Oriental Blush","hex":"#d7c6e1","rgb":{"r":215,"g":198,"b":225},"luminance":135.2736737173941},{"name":"Oriental Herbs","hex":"#118822","rgb":{"r":17,"g":136,"b":34},"luminance":80.08750519900092},{"name":"Oriental Olive","hex":"#445533","rgb":{"r":68,"g":85,"b":51},"luminance":54.19136319562371},{"name":"Oriental Pink","hex":"#c28e88","rgb":{"r":194,"g":142,"b":136},"luminance":102.72759788878547},{"name":"Oriental Ruby","hex":"#ce536b","rgb":{"r":206,"g":83,"b":107},"luminance":79.4754545819022},{"name":"Oriental Spice","hex":"#8b5131","rgb":{"r":139,"g":81,"b":49},"luminance":63.39745520129337},{"name":"Origami","hex":"#ece0c6","rgb":{"r":236,"g":224,"b":198},"luminance":150.9233826284052},{"name":"Orinoco","hex":"#d2d3b3","rgb":{"r":210,"g":211,"b":179},"luminance":140.35506896795712},{"name":"Orioles Orange","hex":"#fb4f14","rgb":{"r":251,"g":79,"b":20},"luminance":88.24967948950297},{"name":"Orion Blue","hex":"#3e4f5c","rgb":{"r":62,"g":79,"b":92},"luminance":51.03048811249996},{"name":"Orka Black","hex":"#27221f","rgb":{"r":39,"g":34,"b":31},"luminance":23.383537820441113},{"name":"Orkhide Shade","hex":"#3e5755","rgb":{"r":62,"g":87,"b":85},"luminance":55.18692150319675},{"name":"Orlean's Tune","hex":"#b8995b","rgb":{"r":184,"g":153,"b":91},"luminance":105.83192265569024},{"name":"Ornate","hex":"#806d95","rgb":{"r":128,"g":109,"b":149},"luminance":76.46629629451135},{"name":"Ornery Tangerine","hex":"#f77d25","rgb":{"r":247,"g":125,"b":37},"luminance":104.19187952043094},{"name":"Oro","hex":"#c29436","rgb":{"r":194,"g":148,"b":54},"luminance":104.64239937998363},{"name":"Orpiment Orange","hex":"#d17c3f","rgb":{"r":209,"g":124,"b":63},"luminance":96.20186666068388},{"name":"Orpiment Yellow","hex":"#f9c89b","rgb":{"r":249,"g":200,"b":155},"luminance":140.13543556502756},{"name":"Orpington Chicken","hex":"#be855e","rgb":{"r":190,"g":133,"b":94},"luminance":97.14571424926578},{"name":"Orzo Pasta","hex":"#f9eacc","rgb":{"r":249,"g":234,"b":204},"luminance":157.95889687193943},{"name":"Osiris","hex":"#5b5a4d","rgb":{"r":91,"g":90,"b":77},"luminance":60.069891501483504},{"name":"Oslo Grey","hex":"#878d91","rgb":{"r":135,"g":141,"b":145},"luminance":93.5572039663435},{"name":"Osprey Nest","hex":"#ccbab1","rgb":{"r":204,"g":186,"b":177},"luminance":126.68217247900351},{"name":"Osso Bucco","hex":"#ad9769","rgb":{"r":173,"g":151,"b":105},"luminance":103.3222202529543},{"name":"Ostrich Egg","hex":"#dcd0bb","rgb":{"r":220,"g":208,"b":187},"luminance":140.3171363020212},{"name":"Oswego Tea","hex":"#665d59","rgb":{"r":102,"g":93,"b":89},"luminance":63.35019022070888},{"name":"Ōtan Red","hex":"#ff4e20","rgb":{"r":255,"g":78,"b":32},"luminance":89.01104271381163},{"name":"Otter","hex":"#7f674f","rgb":{"r":127,"g":103,"b":79},"luminance":71.96241578768739},{"name":"Otter Brown","hex":"#654320","rgb":{"r":101,"g":67,"b":32},"luminance":49.71979229642859},{"name":"Otto Ice","hex":"#bedfd3","rgb":{"r":190,"g":223,"b":211},"luminance":144.7102028780279},{"name":"Ottoman","hex":"#d3dbcb","rgb":{"r":211,"g":219,"b":203},"luminance":145.05739517170437},{"name":"Ottoman Red","hex":"#ee2222","rgb":{"r":238,"g":34,"b":34},"luminance":74.00929255167894},{"name":"OU Crimson Red","hex":"#990000","rgb":{"r":153,"g":0,"b":0},"luminance":45.747},{"name":"Oubliette","hex":"#4f4944","rgb":{"r":79,"g":73,"b":68},"luminance":49.54042133450219},{"name":"Ouni Red","hex":"#ee7948","rgb":{"r":238,"g":121,"b":72},"luminance":100.8773326223488},{"name":"Out of Blue","hex":"#c0f7db","rgb":{"r":192,"g":247,"b":219},"luminance":157.92653273278688},{"name":"Out of Plumb","hex":"#9c909c","rgb":{"r":156,"g":144,"b":156},"luminance":98.16779602293208},{"name":"Out of the Blue","hex":"#1199ee","rgb":{"r":17,"g":153,"b":238},"luminance":93.95742671018613},{"name":"Outback","hex":"#c9a375","rgb":{"r":201,"g":163,"b":117},"luminance":113.77453935745027},{"name":"Outer Boundary","hex":"#654846","rgb":{"r":101,"g":72,"b":70},"luminance":52.553836177771075},{"name":"Outer Reef","hex":"#2a6295","rgb":{"r":42,"g":98,"b":149},"luminance":61.28187526504063},{"name":"Outer Rim","hex":"#221177","rgb":{"r":34,"g":17,"b":119},"luminance":19.671409532618654},{"name":"Outer Space","hex":"#414a4c","rgb":{"r":65,"g":74,"b":76},"luminance":48.3698662909047},{"name":"Outlawed Orange","hex":"#b67350","rgb":{"r":182,"g":115,"b":80},"luminance":87.18611213375671},{"name":"Outrageous Orange","hex":"#ff6e4a","rgb":{"r":255,"g":110,"b":74},"luminance":100.26839492581897},{"name":"Outrigger","hex":"#82714d","rgb":{"r":130,"g":113,"b":77},"luminance":77.38043515643989},{"name":"Overboard","hex":"#005555","rgb":{"r":0,"g":85,"b":85},"luminance":50.82722818529454},{"name":"Overcast","hex":"#73a3d0","rgb":{"r":115,"g":163,"b":208},"luminance":104.40038759506594},{"name":"Overcast Night","hex":"#42426f","rgb":{"r":66,"g":66,"b":111},"luminance":45.2824142024252},{"name":"Overcast Sky","hex":"#a7b8c4","rgb":{"r":167,"g":184,"b":196},"luminance":121.07141235237987},{"name":"Overdue Grey","hex":"#c7c3be","rgb":{"r":199,"g":195,"b":190},"luminance":130.8119292190127},{"name":"Overgrown","hex":"#6b6048","rgb":{"r":107,"g":96,"b":72},"luminance":65.31823035722874},{"name":"Overgrown Trellis","hex":"#6a8988","rgb":{"r":106,"g":137,"b":136},"luminance":87.81855847712372},{"name":"Overtake","hex":"#33557f","rgb":{"r":51,"g":85,"b":127},"luminance":54.14476438216349},{"name":"Overtone","hex":"#a4e3b3","rgb":{"r":164,"g":227,"b":179},"luminance":143.44417078780162},{"name":"Ovoid Fruit","hex":"#8c7e49","rgb":{"r":140,"g":126,"b":73},"luminance":85.39258005236753},{"name":"Owl Manner Malt","hex":"#c0af87","rgb":{"r":192,"g":175,"b":135},"luminance":118.68005809317755},{"name":"Oxalis","hex":"#c1e28a","rgb":{"r":193,"g":226,"b":138},"luminance":145.52250656513584},{"name":"Oxblood","hex":"#800020","rgb":{"r":128,"g":0,"b":32},"luminance":38.445466416731115},{"name":"Oxblood Red","hex":"#71383f","rgb":{"r":113,"g":56,"b":63},"luminance":47.683444474995724},{"name":"Oxford","hex":"#b1bbc5","rgb":{"r":177,"g":187,"b":197},"luminance":123.91303020263848},{"name":"Oxford Blue","hex":"#002147","rgb":{"r":0,"g":33,"b":71},"luminance":20.99401050299823},{"name":"Oxford Brick","hex":"#743b39","rgb":{"r":116,"g":59,"b":57},"luminance":49.443387313168586},{"name":"Oxford Brown","hex":"#504139","rgb":{"r":80,"g":65,"b":57},"luminance":45.499389325572274},{"name":"Oxford Sausage","hex":"#db7192","rgb":{"r":219,"g":113,"b":146},"luminance":94.68149585848334},{"name":"Oxford Tan","hex":"#b8a99a","rgb":{"r":184,"g":169,"b":154},"luminance":114.78766746040273},{"name":"Oxley","hex":"#6d9a78","rgb":{"r":109,"g":154,"b":120},"luminance":97.06242365096804},{"name":"Oxygen Blue","hex":"#92b6d5","rgb":{"r":146,"g":182,"b":213},"luminance":117.93553661216791},{"name":"Oyster","hex":"#e3d3bf","rgb":{"r":227,"g":211,"b":191},"luminance":142.90349069914282},{"name":"Oyster Bay","hex":"#71818c","rgb":{"r":113,"g":129,"b":140},"luminance":84.44084140982964},{"name":"Oyster Cracker","hex":"#f4f0d2","rgb":{"r":244,"g":240,"b":210},"luminance":160.44586606079946},{"name":"Oyster Grey","hex":"#cbc1ae","rgb":{"r":203,"g":193,"b":174},"luminance":130.0478503705463},{"name":"Oyster Haze","hex":"#e4ded2","rgb":{"r":228,"g":222,"b":210},"luminance":149.0043079243013},{"name":"Oyster Linen","hex":"#b1ab96","rgb":{"r":177,"g":171,"b":150},"luminance":114.75537485451389},{"name":"Oyster Mushroom","hex":"#c3c6c8","rgb":{"r":195,"g":198,"b":200},"luminance":132.01437838735598},{"name":"Oyster Pink","hex":"#d4b5b0","rgb":{"r":212,"g":181,"b":176},"luminance":125.33565992565723},{"name":"Oyster White","hex":"#d2caaf","rgb":{"r":210,"g":202,"b":175},"luminance":135.64800063399386},{"name":"Ozone","hex":"#8b95a2","rgb":{"r":139,"g":149,"b":162},"luminance":98.58072891797869},{"name":"Ozone Blue","hex":"#c7d3e0","rgb":{"r":199,"g":211,"b":224},"luminance":139.76055504325961},{"name":"Pa Red","hex":"#5e3a39","rgb":{"r":94,"g":58,"b":57},"luminance":44.62399977590534},{"name":"Paarl","hex":"#864b36","rgb":{"r":134,"g":75,"b":54},"luminance":59.8446431771466},{"name":"Pablo","hex":"#7a715c","rgb":{"r":122,"g":113,"b":92},"luminance":76.42279888227073},{"name":"Pac-Man","hex":"#ffe737","rgb":{"r":255,"g":231,"b":55},"luminance":155.68930385225568},{"name":"Paccheri","hex":"#ecdfad","rgb":{"r":236,"g":223,"b":173},"luminance":150.01102353160582},{"name":"Pachyderm","hex":"#8f989d","rgb":{"r":143,"g":152,"b":157},"luminance":100.54561964103657},{"name":"Pacific","hex":"#1f595c","rgb":{"r":31,"g":89,"b":92},"luminance":54.0855207426165},{"name":"Pacific Bliss","hex":"#96acb8","rgb":{"r":150,"g":172,"b":184},"luminance":112.45107545950817},{"name":"Pacific Blue","hex":"#1ca9c9","rgb":{"r":28,"g":169,"b":201},"luminance":102.15858744618583},{"name":"Pacific Blues","hex":"#4470b0","rgb":{"r":68,"g":112,"b":176},"luminance":71.68143313299477},{"name":"Pacific Breeze","hex":"#c1dbe7","rgb":{"r":193,"g":219,"b":231},"luminance":143.35079774455392},{"name":"Pacific Bridge","hex":"#0052cc","rgb":{"r":0,"g":82,"b":204},"luminance":53.457679448326225},{"name":"Pacific Coast","hex":"#5480ac","rgb":{"r":84,"g":128,"b":172},"luminance":81.61314609791734},{"name":"Pacific Depths","hex":"#004488","rgb":{"r":0,"g":68,"b":136},"luminance":42.82126892094628},{"name":"Pacific Harbour","hex":"#77b9db","rgb":{"r":119,"g":185,"b":219},"luminance":116.97086279069673},{"name":"Pacific Line","hex":"#2d3544","rgb":{"r":45,"g":53,"b":68},"luminance":34.771034640919154},{"name":"Pacific Ocean","hex":"#92cbf1","rgb":{"r":146,"g":203,"b":241},"luminance":129.84543239174798},{"name":"Pacific Palisade","hex":"#69a4b9","rgb":{"r":105,"g":164,"b":185},"luminance":103.43095256740122},{"name":"Pacific Pearl","hex":"#e8eae6","rgb":{"r":232,"g":234,"b":230},"luminance":156.09813576080913},{"name":"Pacific Queen","hex":"#026b5d","rgb":{"r":2,"g":107,"b":93},"luminance":63.700317809254294},{"name":"Pacific Sand","hex":"#f1ebcd","rgb":{"r":241,"g":235,"b":205},"luminance":157.3768706195418},{"name":"Pacific Spirit","hex":"#3c4a56","rgb":{"r":60,"g":74,"b":86},"luminance":48.00856027835036},{"name":"Pacific Storm","hex":"#035453","rgb":{"r":3,"g":84,"b":83},"luminance":50.21566406013167},{"name":"Pacifica","hex":"#4e77a3","rgb":{"r":78,"g":119,"b":163},"luminance":75.95161628958267},{"name":"Pacifika","hex":"#778120","rgb":{"r":119,"g":129,"b":32},"luminance":83.74537715002542},{"name":"Paco","hex":"#4f4037","rgb":{"r":79,"g":64,"b":55},"luminance":44.81762114392061},{"name":"Padded Leaf","hex":"#859e94","rgb":{"r":133,"g":158,"b":148},"luminance":102.31275183964118},{"name":"Paddle Wheel","hex":"#88724d","rgb":{"r":136,"g":114,"b":77},"luminance":78.79487866606559},{"name":"Paddy","hex":"#da9585","rgb":{"r":218,"g":149,"b":133},"luminance":110.12881429035727},{"name":"Paddy Field","hex":"#99bb44","rgb":{"r":153,"g":187,"b":68},"luminance":119.17262636192928},{"name":"Padua","hex":"#7eb394","rgb":{"r":126,"g":179,"b":148},"luminance":112.89078788368872},{"name":"Pageant Song","hex":"#b6c3d1","rgb":{"r":182,"g":195,"b":209},"luminance":128.96213872683717},{"name":"Pagoda","hex":"#127e93","rgb":{"r":18,"g":126,"b":147},"luminance":76.02745511984469},{"name":"Pagoda Blue","hex":"#1a7f8e","rgb":{"r":26,"g":127,"b":142},"luminance":76.68141770337843},{"name":"Paid In Full","hex":"#8c8e65","rgb":{"r":140,"g":142,"b":101},"luminance":93.9825574880786},{"name":"Painite","hex":"#6b4947","rgb":{"r":107,"g":73,"b":71},"luminance":54.08579375399791},{"name":"Painted Bark","hex":"#5f3d32","rgb":{"r":95,"g":61,"b":50},"luminance":46.059475398662535},{"name":"Painted Clay","hex":"#eb8f6f","rgb":{"r":235,"g":143,"b":111},"luminance":110.19703000534996},{"name":"Painted Desert","hex":"#beb8b6","rgb":{"r":190,"g":184,"b":182},"luminance":123.7884633881526},{"name":"Painted Pony","hex":"#bb9471","rgb":{"r":187,"g":148,"b":113},"luminance":104.11363440491354},{"name":"Painted Sea","hex":"#008595","rgb":{"r":0,"g":133,"b":149},"luminance":79.8974670249314},{"name":"Painted Turtle","hex":"#56745f","rgb":{"r":86,"g":116,"b":95},"luminance":73.58681376442385},{"name":"Painter's White","hex":"#f2ebdd","rgb":{"r":242,"g":235,"b":221},"luminance":157.79493282421967},{"name":"Paisley","hex":"#726f7e","rgb":{"r":114,"g":111,"b":126},"luminance":74.924058492583},{"name":"Paisley Purple","hex":"#8b79b1","rgb":{"r":139,"g":121,"b":177},"luminance":84.73076852006005},{"name":"Pakistan Green","hex":"#006600","rgb":{"r":0,"g":102,"b":0},"luminance":59.873999999999995},{"name":"Palace Blue","hex":"#346cb0","rgb":{"r":52,"g":108,"b":176},"luminance":68.28877811178056},{"name":"Palace Purple","hex":"#68457a","rgb":{"r":104,"g":69,"b":122},"luminance":52.92340398160345},{"name":"Palak Paneer","hex":"#888811","rgb":{"r":136,"g":136,"b":17},"luminance":89.61286159921464},{"name":"Palatinate Blue","hex":"#273be2","rgb":{"r":39,"g":59,"b":226},"luminance":44.71249608330986},{"name":"Palatinate Purple","hex":"#682860","rgb":{"r":104,"g":40,"b":96},"luminance":40.47274085109631},{"name":"Pale","hex":"#fff9d0","rgb":{"r":255,"g":249,"b":208},"luminance":166.55083769828357},{"name":"Pale Ale","hex":"#fef068","rgb":{"r":254,"g":240,"b":104},"luminance":160.48530790075458},{"name":"Pale Aqua","hex":"#bcd4e1","rgb":{"r":188,"g":212,"b":225},"luminance":138.93890952501388},{"name":"Pale Berries","hex":"#e2ccc7","rgb":{"r":226,"g":204,"b":199},"luminance":139.35739512490895},{"name":"Pale Beryl","hex":"#98ded9","rgb":{"r":152,"g":222,"b":217},"luminance":140.2113688115197},{"name":"Pale Blackish Purple","hex":"#4a475c","rgb":{"r":74,"g":71,"b":92},"luminance":48.337670082452256},{"name":"Pale Blossom","hex":"#fde1f0","rgb":{"r":253,"g":225,"b":240},"luminance":154.644249275555},{"name":"Pale Blue","hex":"#d0fefe","rgb":{"r":208,"g":254,"b":254},"luminance":164.12345476500303},{"name":"Pale Blue Grey","hex":"#a2adb1","rgb":{"r":162,"g":173,"b":177},"luminance":114.30659267513838},{"name":"Pale Blush","hex":"#e4bfb3","rgb":{"r":228,"g":191,"b":179},"luminance":132.7932532510594},{"name":"Pale Brown","hex":"#b1916e","rgb":{"r":177,"g":145,"b":110},"luminance":101.00821131967439},{"name":"Pale Celadon","hex":"#c9cbbe","rgb":{"r":201,"g":203,"b":190},"luminance":135.2049900040675},{"name":"Pale Cerulean","hex":"#9bc4e2","rgb":{"r":155,"g":196,"b":226},"luminance":126.68309052513678},{"name":"Pale Cherry Blossom","hex":"#fdeff2","rgb":{"r":253,"g":239,"b":242},"luminance":161.7581287045569},{"name":"Pale Chestnut","hex":"#ddadaf","rgb":{"r":221,"g":173,"b":175},"luminance":122.78860835598715},{"name":"Pale Cloud","hex":"#dadee9","rgb":{"r":218,"g":222,"b":233},"luminance":148.107972655087},{"name":"Pale Daffodil","hex":"#fde89a","rgb":{"r":253,"g":232,"b":154},"luminance":156.7697789786029},{"name":"Pale Dogwood","hex":"#ecccc1","rgb":{"r":236,"g":204,"b":193},"luminance":140.72295336582442},{"name":"Pale Egg","hex":"#fde8d0","rgb":{"r":253,"g":232,"b":208},"luminance":157.57794708968638},{"name":"Pale Flower","hex":"#698aab","rgb":{"r":105,"g":138,"b":171},"luminance":89.03726240737639},{"name":"Pale Gold","hex":"#fdde6c","rgb":{"r":253,"g":222,"b":108},"luminance":151.18132341331054},{"name":"Pale Grape","hex":"#c0a2c7","rgb":{"r":192,"g":162,"b":199},"luminance":113.3719625657067},{"name":"Pale Green","hex":"#69b076","rgb":{"r":105,"g":176,"b":118},"luminance":108.81163390465193},{"name":"Pale Grey","hex":"#fdfdfe","rgb":{"r":253,"g":253,"b":254},"luminance":169.16393133880518},{"name":"Pale Grey Blue","hex":"#d4e2eb","rgb":{"r":212,"g":226,"b":235},"luminance":149.448816950821},{"name":"Pale Grey Magenta","hex":"#e7d8ea","rgb":{"r":231,"g":216,"b":234},"luminance":146.82760980483198},{"name":"Pale Icelandish","hex":"#bdd4d1","rgb":{"r":189,"g":212,"b":209},"luminance":138.73528942918594},{"name":"Pale Iris","hex":"#8895c5","rgb":{"r":136,"g":149,"b":197},"luminance":99.0338277004378},{"name":"Pale Jade","hex":"#77c3b4","rgb":{"r":119,"g":195,"b":180},"luminance":121.61132425066343},{"name":"Pale Jasper","hex":"#fed6cc","rgb":{"r":254,"g":214,"b":204},"luminance":148.6220655757415},{"name":"Pale Khaki","hex":"#998877","rgb":{"r":153,"g":136,"b":119},"luminance":93.00522882612567},{"name":"Pale Lavender","hex":"#dcd0ff","rgb":{"r":220,"g":208,"b":255},"luminance":141.70217541025966},{"name":"Pale Leaf","hex":"#bdcaa8","rgb":{"r":189,"g":202,"b":168},"luminance":132.74067086239998},{"name":"Pale Light Green","hex":"#b1fc99","rgb":{"r":177,"g":252,"b":153},"luminance":158.07143027441737},{"name":"Pale Lilac","hex":"#e1c6cc","rgb":{"r":225,"g":198,"b":204},"luminance":136.29104973181475},{"name":"Pale Lily","hex":"#f3ece7","rgb":{"r":243,"g":236,"b":231},"luminance":158.63049589848728},{"name":"Pale Lime Green","hex":"#b1ff65","rgb":{"r":177,"g":255,"b":101},"luminance":159.18233366174778},{"name":"Pale Lime Yellow","hex":"#dfe69f","rgb":{"r":223,"g":230,"b":159},"luminance":151.6643475079097},{"name":"Pale Lychee","hex":"#c4acb2","rgb":{"r":196,"g":172,"b":178},"luminance":118.4901826144259},{"name":"Pale Marigold","hex":"#ffbb44","rgb":{"r":255,"g":187,"b":68},"luminance":133.87541555491057},{"name":"Pale Mauve","hex":"#c6a4a4","rgb":{"r":198,"g":164,"b":164},"luminance":114.55105867690617},{"name":"Pale Mint","hex":"#aac2a1","rgb":{"r":170,"g":194,"b":161},"luminance":126.05061324721906},{"name":"Pale Moss Green","hex":"#d0dbc4","rgb":{"r":208,"g":219,"b":196},"luminance":144.54401754828874},{"name":"Pale Orchid","hex":"#dedbe5","rgb":{"r":222,"g":219,"b":229},"luminance":147.01508741962508},{"name":"Pale Orchid Petal","hex":"#f6e2ec","rgb":{"r":246,"g":226,"b":236},"luminance":154.05590665729113},{"name":"Pale Oyster","hex":"#9c8d72","rgb":{"r":156,"g":141,"b":114},"luminance":95.89022390734104},{"name":"Pale Parchment","hex":"#d1c3ad","rgb":{"r":209,"g":195,"b":173},"luminance":131.8951044959592},{"name":"Pale Pastel","hex":"#9adedb","rgb":{"r":154,"g":222,"b":219},"luminance":140.44669404439537},{"name":"Pale Peach","hex":"#ffe5ad","rgb":{"r":255,"g":229,"b":173},"luminance":155.79409564550255},{"name":"Pale Pearl","hex":"#fff2de","rgb":{"r":255,"g":242,"b":222},"luminance":163.19661088699115},{"name":"Pale Periwinkle","hex":"#c8d2e2","rgb":{"r":200,"g":210,"b":226},"luminance":139.4106043168883},{"name":"Pale Persimmon","hex":"#d4acad","rgb":{"r":212,"g":172,"b":173},"luminance":120.8334602831517},{"name":"Pale Petticoat","hex":"#ba9ba5","rgb":{"r":186,"g":155,"b":165},"luminance":108.28205447349066},{"name":"Pale Phthalo Blue","hex":"#ccd5ff","rgb":{"r":204,"g":213,"b":255},"luminance":142.12082140559139},{"name":"Pale Poppy","hex":"#bca8ad","rgb":{"r":188,"g":168,"b":173},"luminance":115.21224624144779},{"name":"Pale Primrose","hex":"#eec8d3","rgb":{"r":238,"g":200,"b":211},"luminance":139.37498039461744},{"name":"Pale Purple","hex":"#b790d4","rgb":{"r":183,"g":144,"b":212},"luminance":103.55204052552513},{"name":"Pale Rebelka Jakub","hex":"#ebebd7","rgb":{"r":235,"g":235,"b":215},"luminance":156.7377853295114},{"name":"Pale Robin Egg Blue","hex":"#96ded1","rgb":{"r":150,"g":222,"b":209},"luminance":139.8604281846727},{"name":"Pale Rose","hex":"#efd6da","rgb":{"r":239,"g":214,"b":218},"luminance":146.64303034580266},{"name":"Pale Sage","hex":"#acbda1","rgb":{"r":172,"g":189,"b":161},"luminance":123.65297306979723},{"name":"Pale Sand","hex":"#e5d5ba","rgb":{"r":229,"g":213,"b":186},"luminance":144.12022209946804},{"name":"Pale Seafoam","hex":"#c3e7e8","rgb":{"r":195,"g":231,"b":232},"luminance":149.95171268778492},{"name":"Pale Shale","hex":"#cacfdc","rgb":{"r":202,"g":207,"b":220},"luminance":137.99044128127133},{"name":"Pale Sky Blue","hex":"#bdf6fe","rgb":{"r":189,"g":246,"b":254},"luminance":157.7462540315934},{"name":"Pale Spring Bud","hex":"#ecebbd","rgb":{"r":236,"g":235,"b":189},"luminance":156.43634883555674},{"name":"Pale Spring Morning","hex":"#b3be98","rgb":{"r":179,"g":190,"b":152},"luminance":124.91476263836871},{"name":"Pale Sunshine","hex":"#f2c880","rgb":{"r":242,"g":200,"b":128},"luminance":138.677202985927},{"name":"Pale Taupe","hex":"#bc987e","rgb":{"r":188,"g":152,"b":126},"luminance":106.42854699750437},{"name":"Pale Teal","hex":"#82cbb2","rgb":{"r":130,"g":203,"b":178},"luminance":126.97238315870106},{"name":"Pale Tendril","hex":"#cecdbb","rgb":{"r":206,"g":205,"b":187},"luminance":136.85317016788466},{"name":"Pale Turquoise","hex":"#a5fbd5","rgb":{"r":165,"g":251,"b":213},"luminance":157.26331205338388},{"name":"Pale View","hex":"#f4f2e2","rgb":{"r":244,"g":242,"b":226},"luminance":161.75815450233105},{"name":"Pale Vista","hex":"#d8dece","rgb":{"r":216,"g":222,"b":206},"luminance":147.3238945588936},{"name":"Pale Willow","hex":"#89ab98","rgb":{"r":137,"g":171,"b":152},"luminance":109.78965835633153},{"name":"Pale Wisteria","hex":"#bbc8e6","rgb":{"r":187,"g":200,"b":230},"luminance":132.6518449513613},{"name":"Pale Wood","hex":"#ead2a2","rgb":{"r":234,"g":210,"b":162},"luminance":142.93985126618819},{"name":"Palest of Lemon","hex":"#f4eed1","rgb":{"r":244,"g":238,"b":209},"luminance":159.39894180326291},{"name":"Palisade Orchid","hex":"#af8ea5","rgb":{"r":175,"g":142,"b":165},"luminance":100.19785946316418},{"name":"Pallid Flesh","hex":"#f3dfdb","rgb":{"r":243,"g":223,"b":219},"luminance":151.78080447144822},{"name":"Pallid Wych Flesh","hex":"#cdcebe","rgb":{"r":205,"g":206,"b":190},"luminance":137.28933938583867},{"name":"Palm","hex":"#afaf5e","rgb":{"r":175,"g":175,"b":94},"luminance":115.78067155617987},{"name":"Palm Frond","hex":"#aead5b","rgb":{"r":174,"g":173,"b":91},"luminance":114.57281594252625},{"name":"Palm Green","hex":"#20392c","rgb":{"r":32,"g":57,"b":44},"luminance":35.15980035495082},{"name":"Palm Lane","hex":"#7a7363","rgb":{"r":122,"g":115,"b":99},"luminance":77.55606555905219},{"name":"Palm Leaf","hex":"#36482f","rgb":{"r":54,"g":72,"b":47},"luminance":45.55927102138488},{"name":"Palm Springs Splash","hex":"#20887a","rgb":{"r":32,"g":136,"b":122},"luminance":81.59734868241736},{"name":"Palm Tree","hex":"#74b560","rgb":{"r":116,"g":181,"b":96},"luminance":112.29949243429375},{"name":"Palmerin","hex":"#577063","rgb":{"r":87,"g":112,"b":99},"luminance":71.59834845162283},{"name":"Palmetto","hex":"#6d9a9b","rgb":{"r":109,"g":154,"b":155},"luminance":97.70465999633794},{"name":"Palmito","hex":"#eaeacf","rgb":{"r":234,"g":234,"b":207},"luminance":155.9465514976205},{"name":"Palo Verde","hex":"#5f6356","rgb":{"r":95,"g":99,"b":86},"luminance":65.42234488307493},{"name":"Paloma","hex":"#9f9c99","rgb":{"r":159,"g":156,"b":153},"luminance":104.64129791339553},{"name":"Paloma Tan","hex":"#e9b679","rgb":{"r":233,"g":182,"b":121},"luminance":128.28588730254003},{"name":"Palomino","hex":"#bb7744","rgb":{"r":187,"g":119,"b":68},"luminance":89.8097916821991},{"name":"Palomino Gold","hex":"#daae00","rgb":{"r":218,"g":174,"b":0},"luminance":121.16461598998282},{"name":"Palomino Mane","hex":"#e6d6ba","rgb":{"r":230,"g":214,"b":186},"luminance":144.77155949978572},{"name":"Palomino Pony","hex":"#837871","rgb":{"r":131,"g":120,"b":113},"luminance":81.62076993633421},{"name":"Pampas","hex":"#eae4dc","rgb":{"r":234,"g":228,"b":220},"luminance":153.08926301997798},{"name":"Pampered Princess","hex":"#f5eaeb","rgb":{"r":245,"g":234,"b":235},"luminance":157.95954953405},{"name":"Panache","hex":"#ebf7e4","rgb":{"r":235,"g":247,"b":228},"luminance":163.20099390015983},{"name":"Panama Rose","hex":"#c6577c","rgb":{"r":198,"g":87,"b":124},"luminance":79.45279139841469},{"name":"Pancake","hex":"#f7d788","rgb":{"r":247,"g":215,"b":136},"luminance":147.04537275956696},{"name":"Pancake Mix","hex":"#d7bfa6","rgb":{"r":215,"g":191,"b":166},"luminance":130.61738280183076},{"name":"Pancho","hex":"#dfb992","rgb":{"r":223,"g":185,"b":146},"luminance":128.51349769576734},{"name":"Panda","hex":"#544f3a","rgb":{"r":84,"g":79,"b":58},"luminance":53.15060798335236},{"name":"Pandanus","hex":"#616c44","rgb":{"r":97,"g":108,"b":68},"luminance":70.14499503884792},{"name":"Pandora's Box","hex":"#fedbb7","rgb":{"r":254,"g":219,"b":183},"luminance":150.7610419471821},{"name":"Pannikin","hex":"#7895cc","rgb":{"r":120,"g":149,"b":204},"luminance":97.35498089466198},{"name":"Panorama","hex":"#327a88","rgb":{"r":50,"g":122,"b":136},"luminance":74.78262841061417},{"name":"Pansy","hex":"#f75394","rgb":{"r":247,"g":83,"b":148},"luminance":90.07033825849662},{"name":"Pansy Petal","hex":"#5f4561","rgb":{"r":95,"g":69,"b":97},"luminance":50.69138386353247},{"name":"Pansy Purple","hex":"#78184a","rgb":{"r":120,"g":24,"b":74},"luminance":39.458994411920834},{"name":"Pantomime","hex":"#adafba","rgb":{"r":173,"g":175,"b":186},"luminance":116.9517754033687},{"name":"Paolo Veronese Green","hex":"#009b7d","rgb":{"r":0,"g":155,"b":125},"luminance":92.09415141582011},{"name":"Papaya","hex":"#fea166","rgb":{"r":254,"g":161,"b":102},"luminance":121.7972838326044},{"name":"Papaya Punch","hex":"#fca289","rgb":{"r":252,"g":162,"b":137},"luminance":122.32788669800522},{"name":"Papaya Whip","hex":"#ffd1af","rgb":{"r":255,"g":209,"b":175},"luminance":145.81639487382753},{"name":"Paper Brown","hex":"#d7ac7f","rgb":{"r":215,"g":172,"b":127},"luminance":120.56493273336156},{"name":"Paper Daisy","hex":"#f0e5c7","rgb":{"r":240,"g":229,"b":199},"luminance":154.05744099198844},{"name":"Paper Dog","hex":"#d6c5a9","rgb":{"r":214,"g":197,"b":169},"luminance":133.55809699527768},{"name":"Paper Elephant","hex":"#c5d0e6","rgb":{"r":197,"g":208,"b":230},"luminance":138.0742011564796},{"name":"Paper Goat","hex":"#b1a99f","rgb":{"r":177,"g":169,"b":159},"luminance":113.88867816424948},{"name":"Paper Lamb","hex":"#f2ebe1","rgb":{"r":242,"g":235,"b":225},"luminance":157.86838090320683},{"name":"Paper Sack","hex":"#b4a07a","rgb":{"r":180,"g":160,"b":122},"luminance":109.13748789485672},{"name":"Paper Tiger","hex":"#fdf1af","rgb":{"r":253,"g":241,"b":175},"luminance":161.6582296018362},{"name":"Paperboy's Lawn","hex":"#249148","rgb":{"r":36,"g":145,"b":72},"luminance":86.18467488480768},{"name":"Papilio Argeotus","hex":"#8590ae","rgb":{"r":133,"g":144,"b":174},"luminance":95.49797887390078},{"name":"Pappardelle Noodle","hex":"#f9ebcc","rgb":{"r":249,"g":235,"b":204},"luminance":158.46960579871458},{"name":"Paprika","hex":"#7c2d37","rgb":{"r":124,"g":45,"b":55},"luminance":45.95318161999232},{"name":"Papyrus","hex":"#999911","rgb":{"r":153,"g":153,"b":17},"luminance":100.80952124675525},{"name":"Papyrus Map","hex":"#c0ac92","rgb":{"r":192,"g":172,"b":146},"luminance":117.33043294900092},{"name":"Papyrus Paper","hex":"#f5edd6","rgb":{"r":245,"g":237,"b":214},"luminance":159.10862956483535},{"name":"Par Four","hex":"#507069","rgb":{"r":80,"g":112,"b":105},"luminance":70.97690353910912},{"name":"Parachute","hex":"#beb755","rgb":{"r":190,"g":183,"b":85},"luminance":121.90382865603524},{"name":"Parachute Purple","hex":"#392852","rgb":{"r":57,"g":40,"b":82},"luminance":30.482115297334595},{"name":"Parachute Silk","hex":"#ffe2b5","rgb":{"r":255,"g":226,"b":181},"luminance":154.39646441871653},{"name":"Parachuting","hex":"#00589b","rgb":{"r":0,"g":88,"b":155},"luminance":54.59460812204809},{"name":"Paradise Bird","hex":"#ff8c55","rgb":{"r":255,"g":140,"b":85},"luminance":112.51999166814757},{"name":"Paradise Found","hex":"#83988c","rgb":{"r":131,"g":152,"b":140},"luminance":98.74135069463046},{"name":"Paradise Grape","hex":"#746565","rgb":{"r":116,"g":101,"b":101},"luminance":69.64553410664607},{"name":"Paradise Green","hex":"#b2e79f","rgb":{"r":178,"g":231,"b":159},"luminance":146.79127892691716},{"name":"Paradise Island","hex":"#5aa7a0","rgb":{"r":90,"g":167,"b":160},"luminance":103.27889688121189},{"name":"Paradise Pink","hex":"#e4445e","rgb":{"r":228,"g":68,"b":94},"luminance":79.72164885399698},{"name":"Paradiso","hex":"#488084","rgb":{"r":72,"g":128,"b":132},"luminance":79.59469570266602},{"name":"Parador Inn","hex":"#a99a8a","rgb":{"r":169,"g":154,"b":138},"luminance":104.75054266685208},{"name":"Parakeet","hex":"#78ae48","rgb":{"r":120,"g":174,"b":72},"luminance":108.56756747758513},{"name":"Parakeet Blue","hex":"#7eb6ff","rgb":{"r":126,"g":182,"b":255},"luminance":116.95254906157453},{"name":"Parakeet Pete","hex":"#cbd3c6","rgb":{"r":203,"g":211,"b":198},"luminance":139.76472173620925},{"name":"Parasailing","hex":"#00736c","rgb":{"r":0,"g":115,"b":108},"luminance":68.61858617750732},{"name":"Parasite Brown","hex":"#914b13","rgb":{"r":145,"g":75,"b":19},"luminance":61.826759627203494},{"name":"Parchment","hex":"#fefcaf","rgb":{"r":254,"g":252,"b":175},"luminance":167.47330292318233},{"name":"Parchment Paper","hex":"#f0e7d8","rgb":{"r":240,"g":231,"b":216},"luminance":155.3782011255118},{"name":"Parfait","hex":"#c8a6a1","rgb":{"r":200,"g":166,"b":161},"luminance":115.79228247167424},{"name":"Parfait d'Amour","hex":"#734f96","rgb":{"r":115,"g":79,"b":150},"luminance":60.20957859012135},{"name":"Parfait Pink","hex":"#e9c3cf","rgb":{"r":233,"g":195,"b":207},"luminance":136.0609889645081},{"name":"Paris Creek","hex":"#888873","rgb":{"r":136,"g":136,"b":115},"luminance":90.54601714045737},{"name":"Paris Daisy","hex":"#fbeb50","rgb":{"r":251,"g":235,"b":80},"luminance":157.30336876875842},{"name":"Paris Green","hex":"#50c87c","rgb":{"r":80,"g":200,"b":124},"luminance":120.64308059727254},{"name":"Paris M","hex":"#312760","rgb":{"r":49,"g":39,"b":96},"luminance":29.30038201116156},{"name":"Paris Pink","hex":"#da6d91","rgb":{"r":218,"g":109,"b":145},"luminance":92.82110919936262},{"name":"Paris White","hex":"#bfcdc0","rgb":{"r":191,"g":205,"b":192},"luminance":134.9853127195696},{"name":"Parisian Blue","hex":"#4f7ca4","rgb":{"r":79,"g":124,"b":164},"luminance":78.77553554879839},{"name":"Parisian Cashmere","hex":"#d1c7b8","rgb":{"r":209,"g":199,"b":184},"luminance":134.12827675773664},{"name":"Parisian Night","hex":"#323441","rgb":{"r":50,"g":52,"b":65},"luminance":34.78685349381286},{"name":"Park Avenue","hex":"#465048","rgb":{"r":70,"g":80,"b":72},"luminance":52.06416967550716},{"name":"Park Green Flat","hex":"#88c9a6","rgb":{"r":136,"g":201,"b":166},"luminance":126.22444628914003},{"name":"Parkview","hex":"#46483e","rgb":{"r":70,"g":72,"b":62},"luminance":47.689277830556414},{"name":"Parlor Rose","hex":"#baa1b2","rgb":{"r":186,"g":161,"b":178},"luminance":111.51795958050882},{"name":"Parma Violet","hex":"#55455a","rgb":{"r":85,"g":69,"b":90},"luminance":48.9048344644985},{"name":"Parmentier","hex":"#887cab","rgb":{"r":136,"g":124,"b":171},"luminance":85.62517080858875},{"name":"Parmesan","hex":"#ffffdd","rgb":{"r":255,"g":255,"b":221},"luminance":169.8635831660218},{"name":"Parrot Green","hex":"#8db051","rgb":{"r":141,"g":176,"b":81},"luminance":111.96435763670509},{"name":"Parrot Pink","hex":"#d998a0","rgb":{"r":217,"g":152,"b":160},"luminance":111.81870802777144},{"name":"Parsley","hex":"#305d35","rgb":{"r":48,"g":93,"b":53},"luminance":56.7685031421474},{"name":"Parsnip","hex":"#d6c69a","rgb":{"r":214,"g":198,"b":154},"luminance":133.83162708418365},{"name":"Partial Pink","hex":"#ffedf8","rgb":{"r":255,"g":237,"b":248},"luminance":161.1418696987223},{"name":"Particle Ioniser Red","hex":"#cb3215","rgb":{"r":203,"g":50,"b":21},"luminance":67.46317176800984},{"name":"Particular Mint","hex":"#d0d2c5","rgb":{"r":208,"g":210,"b":197},"luminance":139.8845936048713},{"name":"Partridge","hex":"#844c44","rgb":{"r":132,"g":76,"b":68},"luminance":60.067021500986705},{"name":"Partridge Knoll","hex":"#a9875b","rgb":{"r":169,"g":135,"b":91},"luminance":94.55565483883024},{"name":"Party Pig","hex":"#ee99ff","rgb":{"r":238,"g":153,"b":255},"luminance":118.21637308342697},{"name":"Pasadena Rose","hex":"#a84a49","rgb":{"r":168,"g":74,"b":73},"luminance":66.92809090359593},{"name":"Paseo Verde","hex":"#929178","rgb":{"r":146,"g":145,"b":120},"luminance":96.6301057693719},{"name":"Paspalum Grass","hex":"#b9bd97","rgb":{"r":185,"g":189,"b":151},"luminance":125.15758175196578},{"name":"Pass Time Blue","hex":"#5d98b3","rgb":{"r":93,"g":152,"b":179},"luminance":95.65853992718056},{"name":"Passion Flower","hex":"#6d5698","rgb":{"r":109,"g":86,"b":152},"luminance":62.53691061285327},{"name":"Passion Potion","hex":"#e398af","rgb":{"r":227,"g":152,"b":175},"luminance":113.86689073211755},{"name":"Passion Razz","hex":"#59355e","rgb":{"r":89,"g":53,"b":94},"luminance":42.318699152974915},{"name":"Passionate Blue","hex":"#1f3465","rgb":{"r":31,"g":52,"b":101},"luminance":33.914615330267274},{"name":"Passionate Blueberry","hex":"#334159","rgb":{"r":51,"g":65,"b":89},"luminance":42.323484521007956},{"name":"Passionate Pause","hex":"#edefcb","rgb":{"r":237,"g":239,"b":203},"luminance":158.86863372610716},{"name":"Passionate Pink","hex":"#dd00cc","rgb":{"r":221,"g":0,"b":204},"luminance":70.05195055813934},{"name":"Passionate Plum","hex":"#753a58","rgb":{"r":117,"g":58,"b":88},"luminance":49.83554383168703},{"name":"Passive Pink","hex":"#dba29e","rgb":{"r":219,"g":162,"b":158},"luminance":116.85487726663358},{"name":"Passive Royal","hex":"#795365","rgb":{"r":121,"g":83,"b":101},"luminance":61.76753255554248},{"name":"Pasta","hex":"#f7dfaf","rgb":{"r":247,"g":223,"b":175},"luminance":151.61576405506122},{"name":"Pastel Blue","hex":"#a2bffe","rgb":{"r":162,"g":191,"b":254},"luminance":125.51857021572545},{"name":"Pastel Brown","hex":"#836953","rgb":{"r":131,"g":105,"b":83},"luminance":73.63839508028403},{"name":"Pastel Day","hex":"#dfd8e1","rgb":{"r":223,"g":216,"b":225},"luminance":145.5333504493042},{"name":"Pastel Green","hex":"#77dd77","rgb":{"r":119,"g":221,"b":119},"luminance":135.2003640749536},{"name":"Pastel Grey","hex":"#cfcfc4","rgb":{"r":207,"g":207,"b":196},"luminance":138.18261419585315},{"name":"Pastel Lavender","hex":"#d8a1c4","rgb":{"r":216,"g":161,"b":196},"luminance":116.62727142911301},{"name":"Pastel Lilac","hex":"#bdb0d0","rgb":{"r":189,"g":176,"b":208},"luminance":120.12127791944272},{"name":"Pastel Magenta","hex":"#f49ac2","rgb":{"r":244,"g":154,"b":194},"luminance":118.25182364767149},{"name":"Pastel Mint","hex":"#cef0cc","rgb":{"r":206,"g":240,"b":204},"luminance":155.50510207707012},{"name":"Pastel Orange","hex":"#ff964f","rgb":{"r":255,"g":150,"b":79},"luminance":116.82127614865367},{"name":"Pastel Parchment","hex":"#e5d9d3","rgb":{"r":229,"g":217,"b":211},"luminance":146.602463819678},{"name":"Pastel Pea","hex":"#bee7a5","rgb":{"r":190,"g":231,"b":165},"luminance":148.21517671615143},{"name":"Pastel Pink","hex":"#dea5a4","rgb":{"r":222,"g":165,"b":164},"luminance":118.8968894673027},{"name":"Pastel Purple","hex":"#b39eb5","rgb":{"r":179,"g":158,"b":181},"luminance":109.05081344492575},{"name":"Pastel Red","hex":"#ff6961","rgb":{"r":255,"g":105,"b":97},"luminance":98.66332963163163},{"name":"Pastel Rose Tan","hex":"#e9d1bf","rgb":{"r":233,"g":209,"b":191},"luminance":142.754041813183},{"name":"Pastel Smirk","hex":"#deece1","rgb":{"r":222,"g":236,"b":225},"luminance":155.74041353483042},{"name":"Pastel Turquoise","hex":"#99c5c4","rgb":{"r":153,"g":197,"b":196},"luminance":126.35038846794258},{"name":"Pastel Violet","hex":"#cb99c9","rgb":{"r":203,"g":153,"b":201},"luminance":110.79346969023038},{"name":"Pastel Yellow","hex":"#fdfd96","rgb":{"r":253,"g":253,"b":150},"luminance":167.54222073853504},{"name":"Pastoral","hex":"#edfad9","rgb":{"r":237,"g":250,"b":217},"luminance":164.83050662119558},{"name":"Pastry","hex":"#f8deb8","rgb":{"r":248,"g":222,"b":184},"luminance":151.39435351425757},{"name":"Pastry Dough","hex":"#faedd5","rgb":{"r":250,"g":237,"b":213},"luminance":159.7850874925442},{"name":"Pastry Shell","hex":"#bd8c66","rgb":{"r":189,"g":140,"b":102},"luminance":100.41043723139542},{"name":"Patches","hex":"#8a7d6b","rgb":{"r":138,"g":125,"b":107},"luminance":85.0601814775868},{"name":"Path to the Sky","hex":"#c4eee8","rgb":{"r":196,"g":238,"b":232},"luminance":153.79106591736726},{"name":"Pathway","hex":"#dbd6d2","rgb":{"r":219,"g":214,"b":210},"luminance":143.66894892425432},{"name":"Patina","hex":"#639283","rgb":{"r":99,"g":146,"b":131},"luminance":91.89165555696556},{"name":"Patina Creek","hex":"#b6c4bd","rgb":{"r":182,"g":196,"b":189},"luminance":129.08335114955761},{"name":"Patina Green","hex":"#b9eab3","rgb":{"r":185,"g":234,"b":179},"luminance":149.47700232811735},{"name":"Patriarch","hex":"#800070","rgb":{"r":128,"g":0,"b":112},"luminance":40.345604568527655},{"name":"Patrice","hex":"#8cd9a1","rgb":{"r":140,"g":217,"b":161},"luminance":135.3312179690998},{"name":"Patrician Purple","hex":"#6c4e79","rgb":{"r":108,"g":78,"b":121},"luminance":57.7010008232093},{"name":"Patrinia Flowers","hex":"#d9b611","rgb":{"r":217,"g":182,"b":17},"luminance":125.00825208361245},{"name":"Patrinia Scabiosaefolia","hex":"#f2f2b0","rgb":{"r":242,"g":242,"b":176},"luminance":160.6785087558383},{"name":"Patriot Blue","hex":"#363756","rgb":{"r":54,"g":55,"b":86},"luminance":37.40498572383098},{"name":"Pattens Blue","hex":"#d3e5ef","rgb":{"r":211,"g":229,"b":239},"luminance":150.97055794425614},{"name":"Pattipan","hex":"#bcc6b1","rgb":{"r":188,"g":198,"b":177},"luminance":130.6729647019612},{"name":"Paua","hex":"#2a2551","rgb":{"r":42,"g":37,"b":81},"luminance":26.73359461426764},{"name":"Paua Shell","hex":"#245056","rgb":{"r":36,"g":80,"b":86},"luminance":49.16526936771525},{"name":"Pauley","hex":"#629191","rgb":{"r":98,"g":145,"b":145},"luminance":91.52273667783322},{"name":"Pauper","hex":"#343445","rgb":{"r":52,"g":52,"b":69},"luminance":35.147245069848644},{"name":"Pavement","hex":"#524d50","rgb":{"r":82,"g":77,"b":80},"luminance":52.223139746667854},{"name":"Pavilion","hex":"#bebf84","rgb":{"r":190,"g":191,"b":132},"luminance":126.58609755024443},{"name":"Pavilion Peach","hex":"#df9c45","rgb":{"r":223,"g":156,"b":69},"luminance":113.54790825462173},{"name":"Paving Stone","hex":"#a8a498","rgb":{"r":168,"g":164,"b":152},"luminance":109.95927078696002},{"name":"Pavlova","hex":"#baab87","rgb":{"r":186,"g":171,"b":135},"luminance":115.78130775302203},{"name":"Paw Paw","hex":"#fbd49c","rgb":{"r":251,"g":212,"b":156},"luminance":146.40673547688985},{"name":"Paw Print","hex":"#827a6d","rgb":{"r":130,"g":122,"b":109},"luminance":82.424798283041},{"name":"Pawn Broker","hex":"#473430","rgb":{"r":71,"g":52,"b":48},"luminance":37.580949974687975},{"name":"Pax","hex":"#c8c6da","rgb":{"r":200,"g":198,"b":218},"luminance":133.0494080407726},{"name":"Payne's Grey","hex":"#536878","rgb":{"r":83,"g":104,"b":120},"luminance":67.30441436488397},{"name":"PCB Green","hex":"#002d04","rgb":{"r":0,"g":45,"b":4},"luminance":26.418935652293033},{"name":"Pea","hex":"#a4bf20","rgb":{"r":164,"g":191,"b":32},"luminance":122.42572805174572},{"name":"Pea Case","hex":"#709d3d","rgb":{"r":112,"g":157,"b":61},"luminance":98.3009946083965},{"name":"Pea Green","hex":"#8eab12","rgb":{"r":142,"g":171,"b":18},"luminance":109.00658052154465},{"name":"Pea Soup","hex":"#929901","rgb":{"r":146,"g":153,"b":1},"luminance":99.85840191491148},{"name":"Pea Soup Green","hex":"#94a617","rgb":{"r":148,"g":166,"b":23},"luminance":107.05165926785067},{"name":"Peabody","hex":"#3f7074","rgb":{"r":63,"g":112,"b":116},"luminance":69.65615752394041},{"name":"Peace","hex":"#a2b2bd","rgb":{"r":162,"g":178,"b":189},"luminance":117.16566969893528},{"name":"Peace N Quiet","hex":"#cacfe0","rgb":{"r":202,"g":207,"b":224},"luminance":138.0740481806773},{"name":"Peace River","hex":"#a8bfcc","rgb":{"r":168,"g":191,"b":204},"luminance":125.03726264198204},{"name":"Peaceful Night","hex":"#d6e7e3","rgb":{"r":214,"g":231,"b":227},"luminance":152.1526387842156},{"name":"Peaceful Pastures","hex":"#94d8ac","rgb":{"r":148,"g":216,"b":172},"luminance":135.7163381174131},{"name":"Peaceful Peach","hex":"#ffddcd","rgb":{"r":255,"g":221,"b":205},"luminance":152.27787578634002},{"name":"Peaceful Purple","hex":"#660088","rgb":{"r":102,"g":0,"b":136},"luminance":34.21260031041195},{"name":"Peaceful Rain","hex":"#f1fbf1","rgb":{"r":241,"g":251,"b":241},"luminance":166.29946399793354},{"name":"Peach","hex":"#ffb07c","rgb":{"r":255,"g":176,"b":124},"luminance":129.17622019938497},{"name":"Peach A La Mode","hex":"#efc9aa","rgb":{"r":239,"g":201,"b":170},"luminance":139.29533764631176},{"name":"Peach Amber","hex":"#fb9f93","rgb":{"r":251,"g":159,"b":147},"luminance":120.93069028993425},{"name":"Peach Ash","hex":"#efc4bb","rgb":{"r":239,"g":196,"b":187},"luminance":137.10614263773888},{"name":"Peach Beauty","hex":"#e7c3ab","rgb":{"r":231,"g":195,"b":171},"luminance":135.10284609141289},{"name":"Peach Beige","hex":"#d3a297","rgb":{"r":211,"g":162,"b":151},"luminance":115.40975934902559},{"name":"Peach Bellini","hex":"#fedcad","rgb":{"r":254,"g":220,"b":173},"luminance":151.10887399487825},{"name":"Peach Bloom","hex":"#d99b7c","rgb":{"r":217,"g":155,"b":124},"luminance":112.64058065368803},{"name":"Peach Blossom","hex":"#de8286","rgb":{"r":222,"g":130,"b":134},"luminance":102.28690610239416},{"name":"Peach Blossom Red","hex":"#eecfbf","rgb":{"r":238,"g":207,"b":191},"luminance":142.4871025777421},{"name":"Peach Blush","hex":"#e4ccc6","rgb":{"r":228,"g":204,"b":198},"luminance":139.62986883901308},{"name":"Peach Breeze","hex":"#ffece5","rgb":{"r":255,"g":236,"b":229},"luminance":160.26833213395588},{"name":"Peach Brick","hex":"#e5ccbd","rgb":{"r":229,"g":204,"b":189},"luminance":139.61408045394273},{"name":"Peach Bud","hex":"#fdb2ab","rgb":{"r":253,"g":178,"b":171},"luminance":130.45998942587724},{"name":"Peach Buff","hex":"#cc99bb","rgb":{"r":204,"g":153,"b":187},"luminance":110.63898436355966},{"name":"Peach Burst","hex":"#f39998","rgb":{"r":243,"g":153,"b":152},"luminance":116.81316258881101},{"name":"Peach Caramel","hex":"#c5733d","rgb":{"r":197,"g":115,"b":61},"luminance":89.8601499553612},{"name":"Peach Cider","hex":"#ffd9aa","rgb":{"r":255,"g":217,"b":170},"luminance":149.714040978126},{"name":"Peach Cobbler","hex":"#ffb181","rgb":{"r":255,"g":177,"b":129},"luminance":129.70955501427025},{"name":"Peach Crayon","hex":"#ffcba7","rgb":{"r":255,"g":203,"b":167},"luminance":142.74133735537157},{"name":"Peach Cream","hex":"#fff0db","rgb":{"r":255,"g":240,"b":219},"luminance":162.12271765856875},{"name":"Peach Darling","hex":"#efcdb4","rgb":{"r":239,"g":205,"b":180},"luminance":141.45054664440147},{"name":"Peach Dip","hex":"#f4debf","rgb":{"r":244,"g":222,"b":191},"luminance":150.9252252209683},{"name":"Peach Dust","hex":"#f0d8cc","rgb":{"r":240,"g":216,"b":204},"luminance":147.53491247836897},{"name":"Peach Echo","hex":"#f7786b","rgb":{"r":247,"g":120,"b":107},"luminance":102.78545817867428},{"name":"Peach Everlasting","hex":"#f4e2d4","rgb":{"r":244,"g":226,"b":212},"luminance":153.31626268599166},{"name":"Peach Fizz","hex":"#ffa883","rgb":{"r":255,"g":168,"b":131},"luminance":125.54457310851791},{"name":"Peach Flower","hex":"#e198b4","rgb":{"r":225,"g":152,"b":180},"luminance":113.6130195048085},{"name":"Peach Fuzz","hex":"#ffc7b9","rgb":{"r":255,"g":199,"b":185},"luminance":141.0792865519244},{"name":"Peach Juice","hex":"#ffcfab","rgb":{"r":255,"g":207,"b":171},"luminance":144.76792856845051},{"name":"Peach Melba","hex":"#fbbdaf","rgb":{"r":251,"g":189,"b":175},"luminance":135.42047167987562},{"name":"Peach Nectar","hex":"#ffb59b","rgb":{"r":255,"g":181,"b":155},"luminance":131.96194123306915},{"name":"Peach Nirvana","hex":"#edb48f","rgb":{"r":237,"g":180,"b":143},"luminance":128.26283784869256},{"name":"Peach Nougat","hex":"#e6af91","rgb":{"r":230,"g":175,"b":145},"luminance":124.71960321056189},{"name":"Peach Orange","hex":"#ffcc99","rgb":{"r":255,"g":204,"b":153},"luminance":143.0283429708951},{"name":"Peach Parfait","hex":"#f8bfa8","rgb":{"r":248,"g":191,"b":168},"luminance":135.7775382638822},{"name":"Peach Patch","hex":"#f3d5a1","rgb":{"r":243,"g":213,"b":161},"luminance":145.76920088276535},{"name":"Peach Pearl","hex":"#ffb2a5","rgb":{"r":255,"g":178,"b":165},"luminance":130.70746084673206},{"name":"Peach Pink","hex":"#ff9a8a","rgb":{"r":255,"g":154,"b":138},"luminance":119.3004369354949},{"name":"Peach Poppy","hex":"#ddaaaa","rgb":{"r":221,"g":170,"b":170},"luminance":121.24381526906846},{"name":"Peach Powder","hex":"#e2bdb3","rgb":{"r":226,"g":189,"b":179},"luminance":131.495245393132},{"name":"Peach Puff","hex":"#ffdab9","rgb":{"r":255,"g":218,"b":185},"luminance":150.4439605999523},{"name":"Peach Puree","hex":"#efcfba","rgb":{"r":239,"g":207,"b":186},"luminance":142.55076716033486},{"name":"Peach Quartz","hex":"#f5b895","rgb":{"r":245,"g":184,"b":149},"luminance":131.60755025833433},{"name":"Peach Schnapps","hex":"#ffdcd6","rgb":{"r":255,"g":220,"b":214},"luminance":151.93947624300932},{"name":"Peach Shortcake","hex":"#f3dfd4","rgb":{"r":243,"g":223,"b":212},"luminance":151.65158645395042},{"name":"Peach Smoothie","hex":"#ffe5bd","rgb":{"r":255,"g":229,"b":189},"luminance":156.0354865727665},{"name":"Peach Souffle","hex":"#ecbcb2","rgb":{"r":236,"g":188,"b":178},"luminance":132.54995321010114},{"name":"Peach Surprise","hex":"#f3e3d1","rgb":{"r":243,"g":227,"b":209},"luminance":153.6294695883573},{"name":"Peach Temptation","hex":"#f2c5b2","rgb":{"r":242,"g":197,"b":178},"luminance":137.9123770696452},{"name":"Peach Tone","hex":"#f2e3dc","rgb":{"r":242,"g":227,"b":220},"luminance":153.68793890543265},{"name":"Peach Umbrella","hex":"#f9e8ce","rgb":{"r":249,"g":232,"b":206},"luminance":156.97302797933153},{"name":"Peach Whip","hex":"#dbbeb7","rgb":{"r":219,"g":190,"b":183},"luminance":131.0035316508681},{"name":"Peach Yellow","hex":"#fadfad","rgb":{"r":250,"g":223,"b":173},"luminance":152.02497026804508},{"name":"Peachade","hex":"#fadfc7","rgb":{"r":250,"g":223,"b":199},"luminance":152.43781977252232},{"name":"Peaches 'n' Cream","hex":"#eec9a6","rgb":{"r":238,"g":201,"b":166},"luminance":139.07940246132782},{"name":"Peaches N Cream","hex":"#f4a6a3","rgb":{"r":244,"g":166,"b":163},"luminance":123.1373705420089},{"name":"Peachskin","hex":"#dfb8b6","rgb":{"r":223,"g":184,"b":182},"luminance":128.61582288738813},{"name":"Peachtree","hex":"#f3ddcd","rgb":{"r":243,"g":221,"b":205},"luminance":150.51342490954087},{"name":"Peachy Bon-Bon","hex":"#ffd2b9","rgb":{"r":255,"g":210,"b":185},"luminance":146.47041006633387},{"name":"Peachy Ethereal","hex":"#fde0dc","rgb":{"r":253,"g":224,"b":220},"luminance":153.7548996064841},{"name":"Peachy Keen","hex":"#ffdeda","rgb":{"r":255,"g":222,"b":218},"luminance":153.0119620323849},{"name":"Peachy Milk","hex":"#f3e0d8","rgb":{"r":243,"g":224,"b":216},"luminance":152.2316496954559},{"name":"Peachy Pico","hex":"#ffccaa","rgb":{"r":255,"g":204,"b":170},"luminance":143.27759046340776},{"name":"Peachy Sand","hex":"#ffdcb7","rgb":{"r":255,"g":220,"b":183},"luminance":151.41222760728405},{"name":"Peachy Scene","hex":"#dd7755","rgb":{"r":221,"g":119,"b":85},"luminance":96.64249557001308},{"name":"Peacoat","hex":"#2b2e43","rgb":{"r":43,"g":46,"b":67},"luminance":30.866640520147314},{"name":"Peacock Blue","hex":"#016795","rgb":{"r":1,"g":103,"b":149},"luminance":62.80243719793046},{"name":"Peacock Green","hex":"#006a50","rgb":{"r":0,"g":106,"b":80},"luminance":62.88681645623349},{"name":"Peacock Plume","hex":"#206d71","rgb":{"r":32,"g":109,"b":113},"luminance":65.96451195150313},{"name":"Peacock Purple","hex":"#513843","rgb":{"r":81,"g":56,"b":67},"luminance":41.53874563585183},{"name":"Peacock Silk","hex":"#6da893","rgb":{"r":109,"g":168,"b":147},"luminance":105.20512963254215},{"name":"Peahen","hex":"#719e8a","rgb":{"r":113,"g":158,"b":138},"luminance":99.95437813822863},{"name":"Peanut","hex":"#7a4434","rgb":{"r":122,"g":68,"b":52},"luminance":54.39735953150667},{"name":"Peanut Brittle","hex":"#a6893a","rgb":{"r":166,"g":137,"b":58},"luminance":94.73366909921731},{"name":"Peanut Butter","hex":"#ffb75f","rgb":{"r":255,"g":183,"b":95},"luminance":132.17359859669403},{"name":"Peapod","hex":"#82b185","rgb":{"r":130,"g":177,"b":133},"luminance":111.96323211215366},{"name":"Pear","hex":"#d1e231","rgb":{"r":209,"g":226,"b":49},"luminance":146.74990535261003},{"name":"Pear Cactus","hex":"#91af88","rgb":{"r":145,"g":175,"b":136},"luminance":112.57200214085205},{"name":"Pear Perfume","hex":"#ccdd99","rgb":{"r":204,"g":221,"b":153},"luminance":144.40855206323482},{"name":"Pear Sorbet","hex":"#f3eac3","rgb":{"r":243,"g":234,"b":195},"luminance":156.9727132752696},{"name":"Pear Spritz","hex":"#cbf85f","rgb":{"r":203,"g":248,"b":95},"luminance":158.09423292770674},{"name":"Pearl","hex":"#eae0c8","rgb":{"r":234,"g":224,"b":200},"luminance":150.67904731580964},{"name":"Pearl Aqua","hex":"#88d8c0","rgb":{"r":136,"g":216,"b":192},"luminance":134.94019676879088},{"name":"Pearl Ash","hex":"#d0c9c3","rgb":{"r":208,"g":201,"b":195},"luminance":135.21445903822564},{"name":"Pearl Bay","hex":"#7fc6cc","rgb":{"r":127,"g":198,"b":204},"luminance":124.46394393960044},{"name":"Pearl Blue","hex":"#79b4c9","rgb":{"r":121,"g":180,"b":201},"luminance":114.00880245402107},{"name":"Pearl Blush","hex":"#f4cec5","rgb":{"r":244,"g":206,"b":197},"luminance":143.00024399979182},{"name":"Pearl Bush","hex":"#ded1c6","rgb":{"r":222,"g":209,"b":198},"luminance":141.3034060346742},{"name":"Pearl City","hex":"#dce4e9","rgb":{"r":220,"g":228,"b":233},"luminance":151.4748267534906},{"name":"Pearl Dust","hex":"#efe5d9","rgb":{"r":239,"g":229,"b":217},"luminance":154.23419236343153},{"name":"Pearl Grey","hex":"#b0b7be","rgb":{"r":176,"g":183,"b":190},"luminance":121.56361386944697},{"name":"Pearl Lusta","hex":"#eae1c8","rgb":{"r":234,"g":225,"b":200},"luminance":151.19155657972436},{"name":"Pearl Necklace","hex":"#fcf7eb","rgb":{"r":252,"g":247,"b":235},"luminance":165.58029872240235},{"name":"Pearl Oyster","hex":"#ddd6cb","rgb":{"r":221,"g":214,"b":203},"luminance":143.81191998231577},{"name":"Pearl Pebble","hex":"#ded7da","rgb":{"r":222,"g":215,"b":218},"luminance":144.74585594413404},{"name":"Pearl Sugar","hex":"#f4f1eb","rgb":{"r":244,"g":241,"b":235},"luminance":161.41001866365048},{"name":"Pearl White","hex":"#f3f2ed","rgb":{"r":243,"g":242,"b":237},"luminance":161.82815233759544},{"name":"Pearled Couscous","hex":"#f2e9d5","rgb":{"r":242,"g":233,"b":213},"luminance":156.62567519088304},{"name":"Pearled Ivory","hex":"#f0dfcc","rgb":{"r":240,"g":223,"b":204},"luminance":151.08080929423164},{"name":"Pearls and Lace","hex":"#eee7dc","rgb":{"r":238,"g":231,"b":220},"luminance":155.1759744709212},{"name":"Pearly Flesh","hex":"#f4e3df","rgb":{"r":244,"g":227,"b":223},"luminance":154.0264653265795},{"name":"Pearly Purple","hex":"#b768a2","rgb":{"r":183,"g":104,"b":162},"luminance":84.03496544296308},{"name":"Pearly Putty","hex":"#dbd3bd","rgb":{"r":219,"g":211,"b":189},"luminance":141.7481849125413},{"name":"Pearly Star","hex":"#e4e4da","rgb":{"r":228,"g":228,"b":218},"luminance":152.24033100331854},{"name":"Pearly Swirly","hex":"#eee9d8","rgb":{"r":238,"g":233,"b":216},"luminance":156.13032396366825},{"name":"Peas in a Pod","hex":"#7b9459","rgb":{"r":123,"g":148,"b":89},"luminance":94.88376268361199},{"name":"Peas Please","hex":"#8c7f3c","rgb":{"r":140,"g":127,"b":60},"luminance":85.77061618643064},{"name":"Peaslake","hex":"#8caa95","rgb":{"r":140,"g":170,"b":149},"luminance":109.53916147205071},{"name":"Peat","hex":"#766d52","rgb":{"r":118,"g":109,"b":82},"luminance":73.66158372584722},{"name":"Peat Swamp Forest","hex":"#988c75","rgb":{"r":152,"g":140,"b":117},"luminance":94.85238714971806},{"name":"Peaty Brown","hex":"#552211","rgb":{"r":85,"g":34,"b":17},"luminance":32.37282553315357},{"name":"Pebble","hex":"#9d9880","rgb":{"r":157,"g":152,"b":128},"luminance":101.86998522135947},{"name":"Pebble Beach","hex":"#7f8285","rgb":{"r":127,"g":130,"b":133},"luminance":86.57396302006741},{"name":"Pebble Stone","hex":"#e0d9da","rgb":{"r":224,"g":217,"b":218},"luminance":146.04388423004914},{"name":"Pebble Walk","hex":"#afb2a7","rgb":{"r":175,"g":178,"b":167},"luminance":118.39626372905522},{"name":"Pebbles","hex":"#ded8dc","rgb":{"r":222,"g":216,"b":220},"luminance":145.29713193315274},{"name":"Pecan Brown","hex":"#a36e51","rgb":{"r":163,"g":110,"b":81},"luminance":81.42387134618446},{"name":"Pecan Sandie","hex":"#f4decb","rgb":{"r":244,"g":222,"b":203},"luminance":151.12864948777911},{"name":"Pecan Veneer","hex":"#e09f78","rgb":{"r":224,"g":159,"b":120},"luminance":115.68913460217429},{"name":"Pedestrian Green","hex":"#00bb22","rgb":{"r":0,"g":187,"b":34},"luminance":109.8374104620097},{"name":"Pedestrian Lemon","hex":"#ffff22","rgb":{"r":255,"g":255,"b":34},"luminance":168.02952902987022},{"name":"Pedestrian Red","hex":"#cc1122","rgb":{"r":204,"g":17,"b":34},"luminance":61.92831204707585},{"name":"Pedigree","hex":"#31646e","rgb":{"r":49,"g":100,"b":110},"luminance":61.786676565421445},{"name":"Peekaboo","hex":"#e6dee6","rgb":{"r":230,"g":222,"b":230},"luminance":149.66141752636182},{"name":"Peeled Asparagus","hex":"#87a96b","rgb":{"r":135,"g":169,"b":107},"luminance":107.7931335382732},{"name":"Peevish Red","hex":"#ff2266","rgb":{"r":255,"g":34,"b":102},"luminance":79.66700805854327},{"name":"Pegasus","hex":"#e8e9e4","rgb":{"r":232,"g":233,"b":228},"luminance":155.54359494688296},{"name":"Pekin Chicken","hex":"#f5d2ac","rgb":{"r":245,"g":210,"b":172},"luminance":144.7282335586253},{"name":"Pelagic","hex":"#355d83","rgb":{"r":53,"g":93,"b":131},"luminance":58.773540356184085},{"name":"Pelati","hex":"#ff3333","rgb":{"r":255,"g":51,"b":51},"luminance":82.1177605028291},{"name":"Pelican","hex":"#c1bcac","rgb":{"r":193,"g":188,"b":172},"luminance":126.06751464592294},{"name":"Pelican Bill","hex":"#d7c0c7","rgb":{"r":215,"g":192,"b":199},"luminance":131.71714936560082},{"name":"Pelican Feather","hex":"#e8c3c2","rgb":{"r":232,"g":195,"b":194},"luminance":135.65866395110928},{"name":"Pelican Pecker","hex":"#fb9a30","rgb":{"r":251,"g":154,"b":48},"luminance":117.61842368013609},{"name":"Pelican Pink","hex":"#e2a695","rgb":{"r":226,"g":166,"b":149},"luminance":119.79028773652729},{"name":"Pelorus","hex":"#2599b2","rgb":{"r":37,"g":153,"b":178},"luminance":92.73710667257201},{"name":"Pencil Eraser","hex":"#dbb7bb","rgb":{"r":219,"g":183,"b":187},"luminance":127.59894092820676},{"name":"Pencil Lead","hex":"#5c6274","rgb":{"r":92,"g":98,"b":116},"luminance":65.12146279069597},{"name":"Penelope Pink","hex":"#9d6984","rgb":{"r":157,"g":105,"b":132},"luminance":78.92376560960582},{"name":"Penna","hex":"#b9c8e0","rgb":{"r":185,"g":200,"b":224},"luminance":132.26714074553814},{"name":"Pensive","hex":"#c2c1cb","rgb":{"r":194,"g":193,"b":203},"luminance":129.3642102012763},{"name":"Pensive Pink","hex":"#eab6ad","rgb":{"r":234,"g":182,"b":173},"luminance":129.21958828289152},{"name":"Pentagon","hex":"#96ccd1","rgb":{"r":150,"g":204,"b":209},"luminance":130.07222716629403},{"name":"Pentalon","hex":"#dbb2bc","rgb":{"r":219,"g":178,"b":188},"luminance":125.157565416558},{"name":"Penzance","hex":"#627e75","rgb":{"r":98,"g":126,"b":117},"luminance":80.66527686681549},{"name":"Peony","hex":"#ed9ca8","rgb":{"r":237,"g":156,"b":168},"luminance":117.36181260103304},{"name":"People's Choice","hex":"#b6a8d0","rgb":{"r":182,"g":168,"b":208},"luminance":115.1029674856387},{"name":"Pepper Green","hex":"#007d60","rgb":{"r":0,"g":125,"b":96},"luminance":74.18666835085668},{"name":"Pepper Jelly","hex":"#cc2244","rgb":{"r":204,"g":34,"b":68},"luminance":64.6446230091877},{"name":"Pepperberry","hex":"#c79d9b","rgb":{"r":199,"g":157,"b":155},"luminance":111.11201187090438},{"name":"Peppercorn","hex":"#6c5656","rgb":{"r":108,"g":86,"b":86},"luminance":60.72333986203328},{"name":"Peppercorn Rent","hex":"#4f4337","rgb":{"r":79,"g":67,"b":55},"luminance":46.30372319803236},{"name":"Peppered Moss","hex":"#807548","rgb":{"r":128,"g":117,"b":72},"luminance":79.05012516751634},{"name":"Peppered Pecan","hex":"#957d6f","rgb":{"r":149,"g":125,"b":111},"luminance":86.76869217638352},{"name":"Peppermint","hex":"#d7e7d0","rgb":{"r":215,"g":231,"b":208},"luminance":151.92552971110547},{"name":"Peppermint Bar","hex":"#81bca8","rgb":{"r":129,"g":188,"b":168},"luminance":118.46082846662857},{"name":"Peppermint Fresh","hex":"#64be9f","rgb":{"r":100,"g":190,"b":159},"luminance":116.88243142577073},{"name":"Peppermint Frosting","hex":"#b8ffeb","rgb":{"r":184,"g":255,"b":235},"luminance":161.7098128778832},{"name":"Peppermint Patty","hex":"#d1e6d5","rgb":{"r":209,"g":230,"b":213},"luminance":150.73964543211585},{"name":"Peppermint Pie","hex":"#aac7c1","rgb":{"r":170,"g":199,"b":193},"luminance":129.2789769181362},{"name":"Peppermint Spray","hex":"#90cbaa","rgb":{"r":144,"g":203,"b":170},"luminance":128.17467556814802},{"name":"Peppermint Twist","hex":"#96ced5","rgb":{"r":150,"g":206,"b":213},"luminance":131.237449335165},{"name":"Pepperoni","hex":"#aa4400","rgb":{"r":170,"g":68,"b":0},"luminance":64.62952851444918},{"name":"Peppy","hex":"#72d7b7","rgb":{"r":114,"g":215,"b":183},"luminance":132.38119377388918},{"name":"Peppy Peacock","hex":"#55ccbb","rgb":{"r":85,"g":204,"b":187},"luminance":124.25764706045258},{"name":"Peppy Pineapple","hex":"#ffff44","rgb":{"r":255,"g":255,"b":68},"luminance":168.16358926355016},{"name":"Peptalk","hex":"#0060a6","rgb":{"r":0,"g":96,"b":166},"luminance":59.44464382936447},{"name":"Pêra Rocha","hex":"#a3ce27","rgb":{"r":163,"g":206,"b":39},"luminance":130.44996040244703},{"name":"Perano","hex":"#acb9e8","rgb":{"r":172,"g":185,"b":232},"luminance":123.03336910367041},{"name":"Percale","hex":"#f0e8dd","rgb":{"r":240,"g":232,"b":221},"luminance":155.98178448780487},{"name":"Perdu Pink","hex":"#c1ada9","rgb":{"r":193,"g":173,"b":169},"luminance":118.38024415416618},{"name":"Perennial Phlox","hex":"#e6a7ac","rgb":{"r":230,"g":167,"b":172},"luminance":121.34031236567672},{"name":"Perfect Dark","hex":"#313390","rgb":{"r":49,"g":51,"b":144},"luminance":37.153207479301166},{"name":"Perfect Ocean","hex":"#3062a0","rgb":{"r":48,"g":98,"b":160},"luminance":62.03159017790854},{"name":"Perfect Pear","hex":"#e9e8bb","rgb":{"r":233,"g":232,"b":187},"luminance":154.44749874633774},{"name":"Perfect Pink","hex":"#e5b3b2","rgb":{"r":229,"g":179,"b":178},"luminance":127.04478908636905},{"name":"Perfect Solution","hex":"#f2edd7","rgb":{"r":242,"g":237,"b":215},"luminance":158.71520539948276},{"name":"Perfect Storm","hex":"#9598a1","rgb":{"r":149,"g":152,"b":161},"luminance":101.40307240414364},{"name":"Perfectly Purple","hex":"#694878","rgb":{"r":105,"g":72,"b":120},"luminance":54.39700470614168},{"name":"Perfume","hex":"#c2a9db","rgb":{"r":194,"g":169,"b":219},"luminance":117.59775678557817},{"name":"Perfume Cloud","hex":"#e2c9ce","rgb":{"r":226,"g":201,"b":206},"luminance":137.98070843781022},{"name":"Perfume Haze","hex":"#f3e9f7","rgb":{"r":243,"g":233,"b":247},"luminance":157.41098771686808},{"name":"Pergament","hex":"#bfa58a","rgb":{"r":191,"g":165,"b":138},"luminance":113.53336395086687},{"name":"Pergament Shreds","hex":"#e4e0dc","rgb":{"r":228,"g":224,"b":220},"luminance":150.2182483189043},{"name":"Pergola Panorama","hex":"#e1e9db","rgb":{"r":225,"g":233,"b":219},"luminance":154.4523655435552},{"name":"Pericallis Hybrida","hex":"#904fef","rgb":{"r":144,"g":79,"b":239},"luminance":68.89570945276635},{"name":"Peridot","hex":"#e6e200","rgb":{"r":230,"g":226,"b":0},"luminance":149.42730387716966},{"name":"Periglacial Blue","hex":"#acb6b2","rgb":{"r":172,"g":182,"b":178},"luminance":120.29176199557473},{"name":"Périgord Truffle","hex":"#524a46","rgb":{"r":82,"g":74,"b":70},"luminance":50.514082868047794},{"name":"Periscope","hex":"#52677b","rgb":{"r":82,"g":103,"b":123},"luminance":66.73291038910261},{"name":"Periwinkle","hex":"#8e82fe","rgb":{"r":142,"g":130,"b":254},"luminance":92.00189019797365},{"name":"Periwinkle Blue","hex":"#8f99fb","rgb":{"r":143,"g":153,"b":251},"luminance":103.50332248773466},{"name":"Periwinkle Grey","hex":"#c3cde6","rgb":{"r":195,"g":205,"b":230},"luminance":136.26251740665882},{"name":"Periwinkle Powder","hex":"#c5cbe1","rgb":{"r":197,"g":203,"b":225},"luminance":135.37662216941297},{"name":"Periwinkle Tint","hex":"#d3ddd6","rgb":{"r":211,"g":221,"b":214},"luminance":146.30270423338047},{"name":"Perk Up","hex":"#d6c7be","rgb":{"r":214,"g":199,"b":190},"luminance":134.93939663789814},{"name":"Perky","hex":"#408e7c","rgb":{"r":64,"g":142,"b":124},"luminance":86.6827682299083},{"name":"Permafrost","hex":"#98eff9","rgb":{"r":152,"g":239,"b":249},"luminance":150.17793296286905},{"name":"Permanent Geranium Lake","hex":"#e12c2c","rgb":{"r":225,"g":44,"b":44},"luminance":72.23691206716964},{"name":"Perplexed","hex":"#bdb3c3","rgb":{"r":189,"g":179,"b":195},"luminance":121.35897721223591},{"name":"Perrigloss Tan","hex":"#ddaa99","rgb":{"r":221,"g":170,"b":153},"luminance":120.94916992274068},{"name":"Perrywinkle","hex":"#8f8ce7","rgb":{"r":143,"g":140,"b":231},"luminance":96.30780344811109},{"name":"Perseverance","hex":"#acb3c7","rgb":{"r":172,"g":179,"b":199},"luminance":119.163035833265},{"name":"Persian Bazaar","hex":"#c5988c","rgb":{"r":197,"g":152,"b":140},"luminance":108.09813682483153},{"name":"Persian Belt","hex":"#99ac4b","rgb":{"r":153,"g":172,"b":75},"luminance":111.17382697829557},{"name":"Persian Blinds","hex":"#e3e1cc","rgb":{"r":227,"g":225,"b":204},"luminance":150.30432891304227},{"name":"Persian Blue","hex":"#1c39bb","rgb":{"r":28,"g":57,"b":187},"luminance":40.546913433700475},{"name":"Persian Fable","hex":"#d4ebdd","rgb":{"r":212,"g":235,"b":221},"luminance":153.88826857496318},{"name":"Persian Flatbread","hex":"#e1c7a8","rgb":{"r":225,"g":199,"b":168},"luminance":136.1543304415985},{"name":"Persian Green","hex":"#00a693","rgb":{"r":0,"g":166,"b":147},"luminance":98.87251351108658},{"name":"Persian Indigo","hex":"#32127a","rgb":{"r":50,"g":18,"b":122},"luminance":22.990765972450763},{"name":"Persian Jewel","hex":"#6e81be","rgb":{"r":110,"g":129,"b":190},"luminance":85.35151099424075},{"name":"Persian Orange","hex":"#d99058","rgb":{"r":217,"g":144,"b":88},"luminance":107.03003081845767},{"name":"Persian Pastel","hex":"#aa9499","rgb":{"r":170,"g":148,"b":153},"luminance":102.15356890486008},{"name":"Persian Pink","hex":"#f77fbe","rgb":{"r":247,"g":127,"b":190},"luminance":107.14930989045146},{"name":"Persian Plum","hex":"#701c1c","rgb":{"r":112,"g":28,"b":28},"luminance":37.44031388757311},{"name":"Persian Plush","hex":"#575b93","rgb":{"r":87,"g":91,"b":147},"luminance":61.73234664258276},{"name":"Persian Prince","hex":"#38343e","rgb":{"r":56,"g":52,"b":62},"luminance":35.52510008430659},{"name":"Persian Red","hex":"#cc3333","rgb":{"r":204,"g":51,"b":51},"luminance":68.1948574380796},{"name":"Persian Rose","hex":"#fe28a2","rgb":{"r":254,"g":40,"b":162},"luminance":81.60987893631506},{"name":"Persian Violet","hex":"#8c8eb2","rgb":{"r":140,"g":142,"b":178},"luminance":95.45634698646288},{"name":"Persicus","hex":"#ffb49b","rgb":{"r":255,"g":180,"b":155},"luminance":131.48978867197255},{"name":"Persimmon","hex":"#e59b34","rgb":{"r":229,"g":155,"b":52},"luminance":114.02495012057668},{"name":"Persimmon Fade","hex":"#f7bd8f","rgb":{"r":247,"g":189,"b":143},"luminance":134.26976600113667},{"name":"Persimmon Juice","hex":"#934337","rgb":{"r":147,"g":67,"b":55},"luminance":59.312303529706206},{"name":"Persimmon Orange","hex":"#f47327","rgb":{"r":244,"g":115,"b":39},"luminance":99.49507463688843},{"name":"Persimmon Varnish","hex":"#9f563a","rgb":{"r":159,"g":86,"b":58},"luminance":69.65843487331595},{"name":"Perspective","hex":"#cebeda","rgb":{"r":206,"g":190,"b":218},"luminance":129.80902757512666},{"name":"Persuasion","hex":"#c4ae96","rgb":{"r":196,"g":174,"b":150},"luminance":118.99163777341666},{"name":"Peru","hex":"#cd853f","rgb":{"r":205,"g":133,"b":63},"luminance":99.51753207349948},{"name":"Peruvian Lily","hex":"#cd7db5","rgb":{"r":205,"g":125,"b":181},"luminance":97.80966008529013},{"name":"Peruvian Soil","hex":"#733d1f","rgb":{"r":115,"g":61,"b":31},"luminance":49.769052934529505},{"name":"Pervenche","hex":"#0099ee","rgb":{"r":0,"g":153,"b":238},"luminance":93.81983343089028},{"name":"Pesto","hex":"#c1b23e","rgb":{"r":193,"g":178,"b":62},"luminance":119.57164659316187},{"name":"Pesto Alla Genovese","hex":"#558800","rgb":{"r":85,"g":136,"b":0},"luminance":83.7798928681578},{"name":"Petal Dust","hex":"#f4dfcd","rgb":{"r":244,"g":223,"b":205},"luminance":151.67005847233},{"name":"Petal Pink","hex":"#f2e2e0","rgb":{"r":242,"g":226,"b":224},"luminance":153.25460418532293},{"name":"Petal Plush","hex":"#ddaaee","rgb":{"r":221,"g":170,"b":238},"luminance":122.72173305898185},{"name":"Petal Purple","hex":"#53465d","rgb":{"r":83,"g":70,"b":93},"luminance":49.15967852824101},{"name":"Peter Pan","hex":"#19a700","rgb":{"r":25,"g":167,"b":0},"luminance":98.31358230682065},{"name":"Petit Four","hex":"#87c2d4","rgb":{"r":135,"g":194,"b":212},"luminance":123.21373435214112},{"name":"Petite Orchid","hex":"#da9790","rgb":{"r":218,"g":151,"b":144},"luminance":111.24161069042465},{"name":"Petite Pink","hex":"#eacacb","rgb":{"r":234,"g":202,"b":203},"luminance":139.60869169217224},{"name":"Petite Purple","hex":"#cfbbd8","rgb":{"r":207,"g":187,"b":216},"luminance":128.39905835324493},{"name":"Petrel","hex":"#4076b4","rgb":{"r":64,"g":118,"b":180},"luminance":74.73309609537128},{"name":"Petrichor","hex":"#66cccc","rgb":{"r":102,"g":204,"b":204},"luminance":125.7400216478429},{"name":"Petrichor Brown","hex":"#6a4345","rgb":{"r":106,"g":67,"b":69},"luminance":51.119016353994915},{"name":"Petrified Oak","hex":"#8d7960","rgb":{"r":141,"g":121,"b":96},"luminance":83.31858823815968},{"name":"Petrol","hex":"#005f6a","rgb":{"r":0,"g":95,"b":106},"luminance":57.05925236979538},{"name":"Petticoat","hex":"#fecdac","rgb":{"r":254,"g":205,"b":172},"luminance":143.6411528949834},{"name":"Petula","hex":"#ffbab0","rgb":{"r":255,"g":186,"b":176},"luminance":134.6720952721832},{"name":"Petunia","hex":"#4f3466","rgb":{"r":79,"g":52,"b":102},"luminance":40.30975813621312},{"name":"Pewter","hex":"#91a092","rgb":{"r":145,"g":160,"b":146},"luminance":104.77425810283745},{"name":"Pewter Blue","hex":"#8ba8b7","rgb":{"r":139,"g":168,"b":183},"luminance":109.03052426270361},{"name":"Pewter Grey","hex":"#a7a19e","rgb":{"r":167,"g":161,"b":158},"luminance":108.394232697132},{"name":"Pewter Mug","hex":"#8b8283","rgb":{"r":139,"g":130,"b":131},"luminance":88.16777856450734},{"name":"Pewter Patter","hex":"#bab4a6","rgb":{"r":186,"g":180,"b":166},"luminance":120.892805294608},{"name":"Peyote","hex":"#c5bbae","rgb":{"r":197,"g":187,"b":174},"luminance":126.14382135483291},{"name":"Phantom","hex":"#6e797b","rgb":{"r":110,"g":121,"b":123},"luminance":79.51857212626494},{"name":"Phantom Green","hex":"#dce4d7","rgb":{"r":220,"g":228,"b":215},"luminance":151.1284996153935},{"name":"Phantom Hue","hex":"#645d5e","rgb":{"r":100,"g":93,"b":94},"luminance":63.15868853134934},{"name":"Phantom Mist","hex":"#4b4441","rgb":{"r":75,"g":68,"b":65},"luminance":46.379691471591315},{"name":"Pharaoh's Gem","hex":"#007367","rgb":{"r":0,"g":115,"b":103},"luminance":68.51860761136349},{"name":"Pharaoh's Jade","hex":"#83d1a9","rgb":{"r":131,"g":209,"b":169},"luminance":130.21715634277996},{"name":"Pharaoh's Seas","hex":"#59bbc2","rgb":{"r":89,"g":187,"b":194},"luminance":115.09342352193717},{"name":"Pharlap","hex":"#826663","rgb":{"r":130,"g":102,"b":99},"luminance":72.27133990732426},{"name":"Pharmacy Green","hex":"#005500","rgb":{"r":0,"g":85,"b":0},"luminance":49.894999999999996},{"name":"Phaser Beam","hex":"#ff4d00","rgb":{"r":255,"g":77,"b":0},"luminance":88.63548739641476},{"name":"Pheasant","hex":"#c68463","rgb":{"r":198,"g":132,"b":99},"luminance":98.16323576573869},{"name":"Pheasant Brown","hex":"#795435","rgb":{"r":121,"g":84,"b":53},"luminance":61.454899471075535},{"name":"Pheasant's Egg","hex":"#e0dcd7","rgb":{"r":224,"g":220,"b":215},"luminance":147.5251309980777},{"name":"Phellodendron Amurense","hex":"#f3c13a","rgb":{"r":243,"g":193,"b":58},"luminance":134.7501720741016},{"name":"Phenomenal Peach","hex":"#ffcba2","rgb":{"r":255,"g":203,"b":162},"luminance":142.66643252706643},{"name":"Phenomenal Pink","hex":"#ee55ff","rgb":{"r":238,"g":85,"b":255},"luminance":91.64390961215044},{"name":"Phenomenon","hex":"#3e729b","rgb":{"r":62,"g":114,"b":155},"luminance":71.65127401519109},{"name":"Philanthropist Pink","hex":"#e2d9dd","rgb":{"r":226,"g":217,"b":221},"luminance":146.377569159349},{"name":"Philippine Blue","hex":"#0038a7","rgb":{"r":0,"g":56,"b":167},"luminance":37.987021836411444},{"name":"Philippine Bronze","hex":"#6e3a07","rgb":{"r":110,"g":58,"b":7},"luminance":47.3446831228175},{"name":"Philippine Brown","hex":"#5d1916","rgb":{"r":93,"g":25,"b":22},"luminance":31.541638162910942},{"name":"Philippine Gold","hex":"#b17304","rgb":{"r":177,"g":115,"b":4},"luminance":85.77865054895652},{"name":"Philippine Golden Yellow","hex":"#eebb00","rgb":{"r":238,"g":187,"b":0},"luminance":130.81767313708036},{"name":"Philippine Green","hex":"#008543","rgb":{"r":0,"g":133,"b":67},"luminance":78.44373834156553},{"name":"Philippine Orange","hex":"#ff7300","rgb":{"r":255,"g":115,"b":0},"luminance":101.83430193210928},{"name":"Philippine Pink","hex":"#fa1a8e","rgb":{"r":250,"g":26,"b":142},"luminance":77.99065641472701},{"name":"Philippine Red","hex":"#ce1127","rgb":{"r":206,"g":17,"b":39},"luminance":62.555321060641994},{"name":"Philippine Violet","hex":"#81007f","rgb":{"r":129,"g":0,"b":127},"luminance":41.19871994370698},{"name":"Philippine Yellow","hex":"#fecb00","rgb":{"r":254,"g":203,"b":0},"luminance":141.3051267187429},{"name":"Philodendron","hex":"#116356","rgb":{"r":17,"g":99,"b":86},"luminance":59.15298871570227},{"name":"Phlox","hex":"#df00ff","rgb":{"r":223,"g":0,"b":255},"luminance":72.73848519868969},{"name":"Phlox Pink","hex":"#ce5e9a","rgb":{"r":206,"g":94,"b":154},"luminance":84.53783564771456},{"name":"Phoenix Fossil","hex":"#f8d99e","rgb":{"r":248,"g":217,"b":158},"luminance":148.48690477277785},{"name":"Phoenix Red","hex":"#e2725b","rgb":{"r":226,"g":114,"b":91},"luminance":95.66548006465027},{"name":"Phoenix Rising","hex":"#d2813a","rgb":{"r":210,"g":129,"b":58},"luminance":98.59145689662974},{"name":"Phoenix Villa","hex":"#f7efde","rgb":{"r":247,"g":239,"b":222},"luminance":160.5518181834139},{"name":"Phosphor Green","hex":"#00aa00","rgb":{"r":0,"g":170,"b":0},"luminance":99.78999999999999},{"name":"Phosphorescent Blue","hex":"#11eeee","rgb":{"r":17,"g":238,"b":238},"luminance":142.40698279578848},{"name":"Phosphorescent Green","hex":"#11ff00","rgb":{"r":17,"g":255,"b":0},"luminance":149.77127933619315},{"name":"Phosphorus","hex":"#a5d0c6","rgb":{"r":165,"g":208,"b":198},"luminance":133.60715035131912},{"name":"Photo Grey","hex":"#aead96","rgb":{"r":174,"g":173,"b":150},"luminance":115.37642860220625},{"name":"Photon White","hex":"#f8f8e8","rgb":{"r":248,"g":248,"b":232},"luminance":165.50041566110943},{"name":"PHP Purple","hex":"#8892bf","rgb":{"r":136,"g":146,"b":191},"luminance":97.32677317162016},{"name":"Phthalo Blue","hex":"#000f89","rgb":{"r":0,"g":15,"b":137},"luminance":17.929025322085973},{"name":"Phthalo Green","hex":"#123524","rgb":{"r":18,"g":53,"b":36},"luminance":31.838703820978637},{"name":"Phuket Palette","hex":"#0480bd","rgb":{"r":4,"g":128,"b":189},"luminance":78.17339079251967},{"name":"Physalis","hex":"#ef9548","rgb":{"r":239,"g":149,"b":72},"luminance":113.24231609252789},{"name":"Physalis Aquarelle","hex":"#ebe1d4","rgb":{"r":235,"g":225,"b":212},"luminance":151.5422979699067},{"name":"Physalis Peal","hex":"#e1d8bb","rgb":{"r":225,"g":216,"b":187},"luminance":145.10890397560033},{"name":"Pianissimo","hex":"#e6d0ca","rgb":{"r":230,"g":208,"b":202},"luminance":142.01068586553617},{"name":"Piano Keys","hex":"#eee5d4","rgb":{"r":238,"g":229,"b":212},"luminance":154.0054070381946},{"name":"Picador","hex":"#765c52","rgb":{"r":118,"g":92,"b":82},"luminance":65.18156675011731},{"name":"Picante","hex":"#8d3f2d","rgb":{"r":141,"g":63,"b":45},"luminance":56.31423036853118},{"name":"Picasso","hex":"#f8ea97","rgb":{"r":248,"g":234,"b":151},"luminance":157.04159023647208},{"name":"Picasso Lily","hex":"#634878","rgb":{"r":99,"g":72,"b":120},"luminance":53.38171313286976},{"name":"Piccadilly Grey","hex":"#625d5d","rgb":{"r":98,"g":93,"b":93},"luminance":62.85846712257625},{"name":"Piccolo","hex":"#8bd2e2","rgb":{"r":139,"g":210,"b":226},"luminance":132.6144536504223},{"name":"Picket Fence","hex":"#f3f2ea","rgb":{"r":243,"g":242,"b":234},"luminance":161.7714052019083},{"name":"Pickford","hex":"#c9f0d1","rgb":{"r":201,"g":240,"b":209},"luminance":155.00562079163453},{"name":"Pickle Juice","hex":"#bba528","rgb":{"r":187,"g":165,"b":40},"luminance":111.92831721240161},{"name":"Pickled","hex":"#b3a74b","rgb":{"r":179,"g":167,"b":75},"luminance":112.01466324548764},{"name":"Pickled Avocado","hex":"#99bb11","rgb":{"r":153,"g":187,"b":17},"luminance":118.93602151577123},{"name":"Pickled Bean","hex":"#6e4826","rgb":{"r":110,"g":72,"b":38},"luminance":53.7286145363902},{"name":"Pickled Beet","hex":"#4d233d","rgb":{"r":77,"g":35,"b":61},"luminance":31.63089739479422},{"name":"Pickled Beets","hex":"#aa0044","rgb":{"r":170,"g":0,"b":68},"luminance":51.41772460932125},{"name":"Pickled Bluewood","hex":"#314459","rgb":{"r":49,"g":68,"b":89},"luminance":43.713615418997314},{"name":"Pickled Cucumber","hex":"#94a135","rgb":{"r":148,"g":161,"b":53},"luminance":104.52903097704483},{"name":"Pickled Ginger","hex":"#ffdd55","rgb":{"r":255,"g":221,"b":85},"luminance":150.78557840191482},{"name":"Pickled Grape Leaves","hex":"#775500","rgb":{"r":119,"g":85,"b":0},"luminance":61.28228607028298},{"name":"Pickled Lemon","hex":"#ddcc11","rgb":{"r":221,"g":204,"b":17},"luminance":136.78367442425284},{"name":"Pickled Limes","hex":"#bbbb11","rgb":{"r":187,"g":187,"b":17},"luminance":123.2041102155281},{"name":"Pickled Okra","hex":"#887647","rgb":{"r":136,"g":118,"b":71},"luminance":80.72702452091244},{"name":"Pickled Pink","hex":"#da467d","rgb":{"r":218,"g":70,"b":125},"luminance":78.35906918793765},{"name":"Pickled Plum","hex":"#8e4785","rgb":{"r":142,"g":71,"b":133},"luminance":61.396582453749005},{"name":"Pickled Pork","hex":"#ddbbaa","rgb":{"r":221,"g":187,"b":170},"luminance":129.58106343906888},{"name":"Pickled Purple","hex":"#8e7aa1","rgb":{"r":142,"g":122,"b":161},"luminance":85.25324671823354},{"name":"Pickled Radish","hex":"#ee1144","rgb":{"r":238,"g":17,"b":68},"luminance":72.27519760609444},{"name":"Pickled Salmon","hex":"#ff6655","rgb":{"r":255,"g":102,"b":85},"luminance":97.42736782342013},{"name":"Pickling Spice","hex":"#cfd2b5","rgb":{"r":207,"g":210,"b":181},"luminance":139.47042089633197},{"name":"Picnic Bay","hex":"#bcdbd4","rgb":{"r":188,"g":219,"b":212},"luminance":142.3718897008816},{"name":"Picnic Day Sky","hex":"#00ccee","rgb":{"r":0,"g":204,"b":238},"luminance":122.78325996649542},{"name":"Pico Earth","hex":"#ab5236","rgb":{"r":171,"g":82,"b":54},"luminance":70.49080034302348},{"name":"Pico Eggplant","hex":"#7e2553","rgb":{"r":126,"g":37,"b":83},"luminance":44.50364795160055},{"name":"Pico Ivory","hex":"#fff1e8","rgb":{"r":255,"g":241,"b":232},"luminance":162.86715082545035},{"name":"Pico Metal","hex":"#c2c3c7","rgb":{"r":194,"g":195,"b":199},"luminance":130.31341779341065},{"name":"Pico Orange","hex":"#ffa300","rgb":{"r":255,"g":163,"b":0},"luminance":122.34440643527599},{"name":"Pico Sun","hex":"#ffec27","rgb":{"r":255,"g":236,"b":39},"luminance":158.19033461308564},{"name":"Pico Void","hex":"#1d2b53","rgb":{"r":29,"g":43,"b":83},"luminance":28.316492826619612},{"name":"Pico-8 Pink","hex":"#ff77a8","rgb":{"r":255,"g":119,"b":168},"luminance":105.16435107963153},{"name":"Picton Blue","hex":"#5ba0d0","rgb":{"r":91,"g":160,"b":208},"luminance":100.61587859279467},{"name":"Pictorial Carmine","hex":"#c30b4e","rgb":{"r":195,"g":11,"b":78},"luminance":59.331556005215305},{"name":"Picture Book Green","hex":"#00804c","rgb":{"r":0,"g":128,"b":76},"luminance":75.63387727731535},{"name":"Pie Safe","hex":"#877a64","rgb":{"r":135,"g":122,"b":100},"luminance":82.99312152823268},{"name":"Piece of Cake","hex":"#ede7c8","rgb":{"r":237,"g":231,"b":200},"luminance":154.6866224920565},{"name":"Pied Wagtail Grey","hex":"#bebdc2","rgb":{"r":190,"g":189,"b":194},"luminance":126.58926812727846},{"name":"Pier 17 Steel","hex":"#647d8e","rgb":{"r":100,"g":125,"b":142},"luminance":80.86996951279257},{"name":"Piercing Pink","hex":"#dd00ee","rgb":{"r":221,"g":0,"b":238},"luminance":71.43234326969821},{"name":"Piercing Red","hex":"#dd1122","rgb":{"r":221,"g":17,"b":34},"luminance":66.94055615245513},{"name":"Piezo Blue","hex":"#a1c8db","rgb":{"r":161,"g":200,"b":219},"luminance":129.31908009648075},{"name":"Pig Iron","hex":"#484848","rgb":{"r":72,"g":72,"b":72},"luminance":48.13597141431758},{"name":"Pig Pink","hex":"#fdd7e4","rgb":{"r":253,"g":215,"b":228},"luminance":149.41805345405888},{"name":"Pigeon","hex":"#a9afaa","rgb":{"r":169,"g":175,"b":170},"luminance":116.10939663093595},{"name":"Pigeon Grey","hex":"#c1b4a0","rgb":{"r":193,"g":180,"b":160},"luminance":121.76547560371945},{"name":"Pigeon Pink","hex":"#9d857f","rgb":{"r":157,"g":133,"b":127},"luminance":92.24065683851128},{"name":"Pigeon Post","hex":"#afbdd9","rgb":{"r":175,"g":189,"b":217},"luminance":125.1328235036675},{"name":"Piggy","hex":"#ef98aa","rgb":{"r":239,"g":152,"b":170},"luminance":115.94473294203578},{"name":"Piggy Bank","hex":"#ffccbb","rgb":{"r":255,"g":204,"b":187},"luminance":143.55257104280648},{"name":"Piggyback","hex":"#f0dce3","rgb":{"r":240,"g":220,"b":227},"luminance":149.98769310846805},{"name":"Piglet","hex":"#ffc0c6","rgb":{"r":255,"g":192,"b":198},"luminance":137.93109448199124},{"name":"Pigment Indigo","hex":"#4d0082","rgb":{"r":77,"g":0,"b":130},"luminance":27.380484455173544},{"name":"Pigskin Puffball","hex":"#e8dad1","rgb":{"r":232,"g":218,"b":209},"luminance":147.49540621999046},{"name":"Pika Yellow","hex":"#eee92d","rgb":{"r":238,"g":233,"b":45},"luminance":154.26164003082553},{"name":"PikachuChu","hex":"#eede73","rgb":{"r":238,"g":222,"b":115},"luminance":149.0558316202355},{"name":"Pike Lake","hex":"#6c7779","rgb":{"r":108,"g":119,"b":121},"luminance":78.1824104834329},{"name":"Pikkoro Green","hex":"#15b01a","rgb":{"r":21,"g":176,"b":26},"luminance":103.54506497655984},{"name":"Pīlā Yellow","hex":"#ffff55","rgb":{"r":255,"g":255,"b":85},"luminance":168.26406434530222},{"name":"Pilsener","hex":"#f8f753","rgb":{"r":248,"g":247,"b":83},"luminance":163.12528519208786},{"name":"Piment Piquant","hex":"#cc2200","rgb":{"r":204,"g":34,"b":0},"luminance":64.17814098273648},{"name":"Pimlico","hex":"#df9e9d","rgb":{"r":223,"g":158,"b":157},"luminance":115.61998637346399},{"name":"Pimm's","hex":"#c3585c","rgb":{"r":195,"g":88,"b":92},"luminance":78.59906809243986},{"name":"Pinafore Blue","hex":"#7198c0","rgb":{"r":113,"g":152,"b":192},"luminance":97.88548456742704},{"name":"Pinball","hex":"#d3d3d3","rgb":{"r":211,"g":211,"b":211},"luminance":141.06513845029184},{"name":"Pinch Me","hex":"#c88ca4","rgb":{"r":200,"g":140,"b":164},"luminance":103.33988976189204},{"name":"Pinch of Pearl","hex":"#fff8e3","rgb":{"r":255,"g":248,"b":227},"luminance":166.35907755514876},{"name":"Pinch of Pistachio","hex":"#ddddcc","rgb":{"r":221,"g":221,"b":204},"luminance":147.43259580567658},{"name":"Pinch Purple","hex":"#b4abaf","rgb":{"r":180,"g":171,"b":175},"luminance":115.62930869377365},{"name":"Pincushion","hex":"#ac989c","rgb":{"r":172,"g":152,"b":156},"luminance":104.50852604452902},{"name":"Pindjur Red","hex":"#bb4411","rgb":{"r":187,"g":68,"b":17},"luminance":68.72631569493595},{"name":"Pine","hex":"#2b5d34","rgb":{"r":43,"g":93,"b":52},"luminance":56.39699383832439},{"name":"Pine Bark","hex":"#827064","rgb":{"r":130,"g":112,"b":100},"luminance":77.22117867528311},{"name":"Pine Crush","hex":"#b7b8a5","rgb":{"r":183,"g":184,"b":165},"luminance":122.52956481192611},{"name":"Pine Forest","hex":"#415241","rgb":{"r":65,"g":82,"b":65},"luminance":52.43576337767955},{"name":"Pine Frost","hex":"#deeae0","rgb":{"r":222,"g":234,"b":224},"luminance":154.67820254968055},{"name":"Pine Garland","hex":"#797e65","rgb":{"r":121,"g":126,"b":101},"luminance":83.13765501263552},{"name":"Pine Glade","hex":"#bdc07e","rgb":{"r":189,"g":192,"b":126},"luminance":126.89369264467008},{"name":"Pine Grain","hex":"#ebc79e","rgb":{"r":235,"g":199,"b":158},"luminance":137.50228848277396},{"name":"Pine Green","hex":"#0a481e","rgb":{"r":10,"g":72,"b":30},"luminance":42.507436949315114},{"name":"Pine Grove","hex":"#213631","rgb":{"r":33,"g":54,"b":49},"luminance":33.66488213257251},{"name":"Pine Haven","hex":"#486358","rgb":{"r":72,"g":99,"b":88},"luminance":62.77910939954469},{"name":"Pine Hutch","hex":"#ecdbd2","rgb":{"r":236,"g":219,"b":210},"luminance":148.58760212413415},{"name":"Pine Leaves","hex":"#839b5c","rgb":{"r":131,"g":155,"b":92},"luminance":99.61164053462828},{"name":"Pine Mist","hex":"#d5d8bc","rgb":{"r":213,"g":216,"b":188},"luminance":143.49765105046143},{"name":"Pine Needle","hex":"#334d41","rgb":{"r":51,"g":77,"b":65},"luminance":48.27411005911968},{"name":"Pine Nut","hex":"#eadac2","rgb":{"r":234,"g":218,"b":194},"luminance":147.51154452448796},{"name":"Pine Ridge","hex":"#6d9185","rgb":{"r":109,"g":145,"b":133},"luminance":92.39384584483967},{"name":"Pine Strain","hex":"#d5bfa5","rgb":{"r":213,"g":191,"b":165},"luminance":130.30760437518603},{"name":"Pine Trail","hex":"#9c9f75","rgb":{"r":156,"g":159,"b":117},"luminance":105.18846832709373},{"name":"Pine Tree","hex":"#2a2f23","rgb":{"r":42,"g":47,"b":35},"luminance":30.574112987951096},{"name":"Pine Water","hex":"#e5e7d5","rgb":{"r":229,"g":231,"b":213},"luminance":153.8325055831829},{"name":"Pine Whisper","hex":"#b3c6b9","rgb":{"r":179,"g":198,"b":185},"luminance":129.68333978194732},{"name":"Pineal Pink","hex":"#786d72","rgb":{"r":120,"g":109,"b":114},"luminance":74.49895774438725},{"name":"Pineapple","hex":"#563c0d","rgb":{"r":86,"g":60,"b":13},"luminance":43.63318141048163},{"name":"Pineapple Blossom","hex":"#b4655c","rgb":{"r":180,"g":101,"b":92},"luminance":80.75604567461187},{"name":"Pineapple Delight","hex":"#f0e7a9","rgb":{"r":240,"g":231,"b":169},"luminance":154.6196066642261},{"name":"Pineapple Perfume","hex":"#eeee88","rgb":{"r":238,"g":238,"b":136},"luminance":157.5505337851954},{"name":"Pineapple Sage","hex":"#9c8f60","rgb":{"r":156,"g":143,"b":96},"luminance":96.65156673846522},{"name":"Pineapple Slice","hex":"#e7d391","rgb":{"r":231,"g":211,"b":145},"luminance":142.77368143323895},{"name":"Pineapple Soda","hex":"#e4e5ce","rgb":{"r":228,"g":229,"b":206},"luminance":152.5400366100651},{"name":"Pineapple Sorbet","hex":"#f7f4da","rgb":{"r":247,"g":244,"b":218},"luminance":163.05259119989475},{"name":"Pineberry","hex":"#f0d6dd","rgb":{"r":240,"g":214,"b":221},"luminance":146.84725792468853},{"name":"Pinebrook","hex":"#5d695a","rgb":{"r":93,"g":105,"b":90},"luminance":68.39130115738404},{"name":"Pinehurst","hex":"#2b7b66","rgb":{"r":43,"g":123,"b":102},"luminance":74.25292744397353},{"name":"Pinetop","hex":"#57593f","rgb":{"r":87,"g":89,"b":63},"luminance":58.80126139803465},{"name":"Píng Gǔo Lǜ Green","hex":"#23c48b","rgb":{"r":35,"g":196,"b":139},"luminance":116.608638809481},{"name":"Pink","hex":"#ffc0cb","rgb":{"r":255,"g":192,"b":203},"luminance":138.02551867317868},{"name":"Pink and Sleek","hex":"#ffc3c6","rgb":{"r":255,"g":195,"b":198},"luminance":139.37371141646474},{"name":"Pink Apatite","hex":"#d7b8ab","rgb":{"r":215,"g":184,"b":171},"luminance":127.19396732942957},{"name":"Pink Bite","hex":"#e936a7","rgb":{"r":233,"g":54,"b":167},"luminance":78.87141140489373},{"name":"Pink Blush","hex":"#f4acb6","rgb":{"r":244,"g":172,"b":182},"luminance":126.28058732837759},{"name":"Pink Booties","hex":"#efe1e4","rgb":{"r":239,"g":225,"b":228},"luminance":152.40099806103632},{"name":"Pink Bubble Tea","hex":"#fdbac4","rgb":{"r":253,"g":186,"b":196},"luminance":134.69384569830947},{"name":"Pink Cardoon","hex":"#ecc9ca","rgb":{"r":236,"g":201,"b":202},"luminance":139.39332498007212},{"name":"Pink Carnation","hex":"#ed7a9e","rgb":{"r":237,"g":122,"b":158},"luminance":102.34530721532863},{"name":"Pink Cattleya","hex":"#ffb2d0","rgb":{"r":255,"g":178,"b":208},"luminance":131.50240744944557},{"name":"Pink Chablis","hex":"#f4ded9","rgb":{"r":244,"g":222,"b":217},"luminance":151.3812576774285},{"name":"Pink Chalk","hex":"#f2a3bd","rgb":{"r":242,"g":163,"b":189},"luminance":121.88012159905323},{"name":"Pink Champagne","hex":"#e8dfed","rgb":{"r":232,"g":223,"b":237},"luminance":150.5887231800575},{"name":"Pink Charge","hex":"#dd66bb","rgb":{"r":221,"g":102,"b":187},"luminance":91.68308045108431},{"name":"Pink Chi","hex":"#e4898a","rgb":{"r":228,"g":137,"b":138},"luminance":106.59330639866651},{"name":"Pink Clay","hex":"#ffd5d1","rgb":{"r":255,"g":213,"b":209},"luminance":148.37024385637437},{"name":"Pink Clay Pot","hex":"#d99294","rgb":{"r":217,"g":146,"b":148},"luminance":108.80855148838256},{"name":"Pink Condition","hex":"#ff99dd","rgb":{"r":255,"g":153,"b":221},"luminance":120.47428514832531},{"name":"Pink Cupcake","hex":"#f5d0d6","rgb":{"r":245,"g":208,"b":214},"luminance":144.46069727437978},{"name":"Pink Currant","hex":"#fed5e9","rgb":{"r":254,"g":213,"b":233},"luminance":148.68115455900926},{"name":"Pink Dahlia","hex":"#b94c66","rgb":{"r":185,"g":76,"b":102},"luminance":72.00826447707234},{"name":"Pink Dazzle","hex":"#c97376","rgb":{"r":201,"g":115,"b":118},"luminance":91.37708208298183},{"name":"Pink Delight","hex":"#ff8ad8","rgb":{"r":255,"g":138,"b":216},"luminance":113.93688356717503},{"name":"Pink Diamond","hex":"#fed0fc","rgb":{"r":254,"g":208,"b":252},"luminance":146.63057701584617},{"name":"Pink Diminishing","hex":"#fff4f2","rgb":{"r":255,"g":244,"b":242},"luminance":164.58632310432114},{"name":"Pink Discord","hex":"#b499a1","rgb":{"r":180,"g":153,"b":161},"luminance":106.29900016933367},{"name":"Pink Dogwood","hex":"#f7d1d1","rgb":{"r":247,"g":209,"b":209},"luminance":145.1656377177464},{"name":"Pink Dream","hex":"#fea5a2","rgb":{"r":254,"g":165,"b":162},"luminance":124.45783609319261},{"name":"Pink Dust","hex":"#e4b5b2","rgb":{"r":228,"g":181,"b":178},"luminance":127.85777980631448},{"name":"Pink Dyed Blond","hex":"#ecdfd5","rgb":{"r":236,"g":223,"b":213},"luminance":150.67835087032242},{"name":"Pink Earth","hex":"#b08272","rgb":{"r":176,"g":130,"b":114},"luminance":93.60233700073947},{"name":"Pink Elephants","hex":"#ff99ee","rgb":{"r":255,"g":153,"b":238},"luminance":120.89442158346264},{"name":"Pink Emulsion","hex":"#f2e4e2","rgb":{"r":242,"g":228,"b":226},"luminance":154.30987899677712},{"name":"Pink Fetish","hex":"#dd77ff","rgb":{"r":221,"g":119,"b":255},"luminance":100.45367464657527},{"name":"Pink Fever","hex":"#cc55ff","rgb":{"r":204,"g":85,"b":255},"luminance":83.99457090193388},{"name":"Pink Fire","hex":"#fc845d","rgb":{"r":252,"g":132,"b":93},"luminance":108.59785340419947},{"name":"Pink Flambe","hex":"#d3507a","rgb":{"r":211,"g":80,"b":122},"luminance":79.86799099138528},{"name":"Pink Flamingo","hex":"#ff66ff","rgb":{"r":255,"g":102,"b":255},"luminance":101.20899565256045},{"name":"Pink Flare","hex":"#d8b4b6","rgb":{"r":216,"g":180,"b":182},"luminance":125.5611729795481},{"name":"Pink Floyd","hex":"#eb9a9d","rgb":{"r":235,"g":154,"b":157},"luminance":115.8848869913588},{"name":"Pink Fluorite","hex":"#fbd3d9","rgb":{"r":251,"g":211,"b":217},"luminance":146.9179277487945},{"name":"Pink Frosting","hex":"#f7d7e2","rgb":{"r":247,"g":215,"b":226},"luminance":148.47811734393724},{"name":"Pink Garnet","hex":"#d2738f","rgb":{"r":210,"g":115,"b":143},"luminance":93.62299038697707},{"name":"Pink Gin","hex":"#dfa3ba","rgb":{"r":223,"g":163,"b":186},"luminance":118.53390108319222},{"name":"Pink Glamour","hex":"#ff787b","rgb":{"r":255,"g":120,"b":123},"luminance":104.74593122885489},{"name":"Pink Glitter","hex":"#fddfda","rgb":{"r":253,"g":223,"b":218},"luminance":153.21606415125012},{"name":"Pink Glow","hex":"#ffece0","rgb":{"r":255,"g":236,"b":224},"luminance":160.17647250766885},{"name":"Pink Grapefruit","hex":"#f3bac9","rgb":{"r":243,"g":186,"b":201},"luminance":133.13451907375486},{"name":"Pink Horror","hex":"#90305d","rgb":{"r":144,"g":48,"b":93},"luminance":52.53673491948277},{"name":"Pink Ice","hex":"#cf9fa9","rgb":{"r":207,"g":159,"b":169},"luminance":113.63525462637024},{"name":"Pink Icing","hex":"#eea0a6","rgb":{"r":238,"g":160,"b":166},"luminance":119.34451985742787},{"name":"Pink Illusion","hex":"#d8b8f8","rgb":{"r":216,"g":184,"b":248},"luminance":128.9811114233398},{"name":"Pink Ink","hex":"#ff1476","rgb":{"r":255,"g":20,"b":118},"luminance":78.30762369654693},{"name":"Pink Insanity","hex":"#cc44ff","rgb":{"r":204,"g":68,"b":255},"luminance":78.47842997919874},{"name":"Pink Jazz","hex":"#9e6b89","rgb":{"r":158,"g":107,"b":137},"luminance":80.12926412366458},{"name":"Pink Katydid","hex":"#ff55aa","rgb":{"r":255,"g":85,"b":170},"luminance":93.15790599836386},{"name":"Pink Kitsch","hex":"#ff22ee","rgb":{"r":255,"g":34,"b":238},"luminance":83.3532675604262},{"name":"Pink Lace","hex":"#f6ccd7","rgb":{"r":246,"g":204,"b":215},"luminance":142.6552295571389},{"name":"Pink Lady","hex":"#f3d7b6","rgb":{"r":243,"g":215,"b":182},"luminance":147.09595908113857},{"name":"Pink Lavender","hex":"#d9afca","rgb":{"r":217,"g":175,"b":202},"luminance":123.66292127392106},{"name":"Pink Lemonade","hex":"#ffeaeb","rgb":{"r":255,"g":234,"b":235},"luminance":159.36820350684764},{"name":"Pink Lily","hex":"#f8d0e7","rgb":{"r":248,"g":208,"b":231},"luminance":145.25643488672023},{"name":"Pink Linen","hex":"#d2bfc4","rgb":{"r":210,"g":191,"b":196},"luminance":130.4302883727549},{"name":"Pink Lotus","hex":"#fadbd7","rgb":{"r":250,"g":219,"b":215},"luminance":150.7122304559255},{"name":"Pink Makeup","hex":"#fc80a5","rgb":{"r":252,"g":128,"b":165},"luminance":108.05811260613429},{"name":"Pink Manhattan","hex":"#c16c7b","rgb":{"r":193,"g":108,"b":123},"luminance":86.86637524957513},{"name":"Pink Marble","hex":"#e5d0ca","rgb":{"r":229,"g":208,"b":202},"luminance":141.86613352382588},{"name":"Pink Mist","hex":"#e6bccd","rgb":{"r":230,"g":188,"b":205},"luminance":132.11327161190127},{"name":"Pink Moroccan","hex":"#a98981","rgb":{"r":169,"g":137,"b":129},"luminance":96.1086050153679},{"name":"Pink Nectar","hex":"#d8aab7","rgb":{"r":216,"g":170,"b":183},"luminance":120.6828910823734},{"name":"Pink OCD","hex":"#6844fc","rgb":{"r":104,"g":68,"b":252},"luminance":58.18544711523664},{"name":"Pink Orange","hex":"#ff9066","rgb":{"r":255,"g":144,"b":102},"luminance":114.42680277365088},{"name":"Pink Orchid","hex":"#da70d6","rgb":{"r":218,"g":112,"b":214},"luminance":95.73991579273506},{"name":"Pink Orchid Mantis","hex":"#fd82c3","rgb":{"r":253,"g":130,"b":195},"luminance":109.72628495032536},{"name":"Pink Orthoclase","hex":"#aa98a9","rgb":{"r":170,"g":152,"b":169},"luminance":104.47865730377663},{"name":"Pink Overflow","hex":"#ff33ff","rgb":{"r":255,"g":51,"b":255},"luminance":86.91713809140289},{"name":"Pink Pail","hex":"#eaced4","rgb":{"r":234,"g":206,"b":212},"luminance":141.7796299332171},{"name":"Pink Pampas","hex":"#d1b6c3","rgb":{"r":209,"g":182,"b":195},"luminance":125.74896236947642},{"name":"Pink Pandora","hex":"#e1c5c9","rgb":{"r":225,"g":197,"b":201},"luminance":135.7326612941778},{"name":"Pink Panther","hex":"#ff0090","rgb":{"r":255,"g":0,"b":144},"luminance":77.9922116688583},{"name":"Pink Papaya","hex":"#d5877e","rgb":{"r":213,"g":135,"b":126},"luminance":102.6748678596666},{"name":"Pink Parakeet","hex":"#ad546e","rgb":{"r":173,"g":84,"b":110},"luminance":72.55489640954633},{"name":"Pink Party","hex":"#ff55ee","rgb":{"r":255,"g":85,"b":238},"luminance":95.07342675006512},{"name":"Pink Peacock","hex":"#c62168","rgb":{"r":198,"g":33,"b":104},"luminance":63.40880996360048},{"name":"Pink Pearl","hex":"#e7accf","rgb":{"r":231,"g":172,"b":207},"luminance":124.58379373337448},{"name":"Pink Peony","hex":"#e1bed9","rgb":{"r":225,"g":190,"b":217},"luminance":132.57765712592752},{"name":"Pink Pepper","hex":"#c62d42","rgb":{"r":198,"g":45,"b":66},"luminance":65.26285011398139},{"name":"Pink Perfume","hex":"#ffdbe5","rgb":{"r":255,"g":219,"b":229},"luminance":151.72572975603052},{"name":"Pink Persimmon","hex":"#ffad97","rgb":{"r":255,"g":173,"b":151},"luminance":128.1492388662531},{"name":"Pink Petal","hex":"#f6e6e2","rgb":{"r":246,"g":230,"b":226},"luminance":155.88994422989572},{"name":"Pink Piano","hex":"#f62681","rgb":{"r":246,"g":38,"b":129},"luminance":78.25608594863405},{"name":"Pink Pieris","hex":"#efc9b8","rgb":{"r":239,"g":201,"b":184},"luminance":139.52633896866928},{"name":"Pink Ping","hex":"#ee66ee","rgb":{"r":238,"g":102,"b":238},"luminance":96.87657892390709},{"name":"Pink Pleasure","hex":"#ffdfe5","rgb":{"r":255,"g":223,"b":229},"luminance":153.72018430251765},{"name":"Pink Poison","hex":"#ff007e","rgb":{"r":255,"g":0,"b":126},"luminance":77.5862392502691},{"name":"Pink Polar","hex":"#ccbabe","rgb":{"r":204,"g":186,"b":190},"luminance":126.92665890190285},{"name":"Pink Poppy","hex":"#8e6e74","rgb":{"r":142,"g":110,"b":116},"luminance":78.40179105097025},{"name":"Pink Potion","hex":"#ceaebb","rgb":{"r":206,"g":174,"b":187},"luminance":121.16290275492742},{"name":"Pink Power","hex":"#d5b6cd","rgb":{"r":213,"g":182,"b":205},"luminance":126.5531288629404},{"name":"Pink Pride","hex":"#ef1de7","rgb":{"r":239,"g":29,"b":231},"luminance":78.03804588788728},{"name":"Pink Punch","hex":"#d04a70","rgb":{"r":208,"g":74,"b":112},"luminance":76.9267608313258},{"name":"Pink Purple","hex":"#db4bda","rgb":{"r":219,"g":75,"b":218},"luminance":82.72595656745226},{"name":"Pink Pussycat","hex":"#dc9f9f","rgb":{"r":220,"g":159,"b":159},"luminance":115.61405262769746},{"name":"Pink Quartz","hex":"#ffbbee","rgb":{"r":255,"g":187,"b":238},"luminance":136.3769731662937},{"name":"Pink Quince","hex":"#ab485b","rgb":{"r":171,"g":72,"b":91},"luminance":67.14194078964354},{"name":"Pink Raspberry","hex":"#980036","rgb":{"r":152,"g":0,"b":54},"luminance":45.863024758513255},{"name":"Pink Red","hex":"#f5054f","rgb":{"r":245,"g":5,"b":79},"luminance":73.86485826155763},{"name":"Pink Rose Bud","hex":"#feab9a","rgb":{"r":254,"g":171,"b":154},"luminance":127.08874923060657},{"name":"Pink Sachet","hex":"#eebcb8","rgb":{"r":238,"g":188,"b":184},"luminance":132.97544719232945},{"name":"Pink Salt","hex":"#f7cdc7","rgb":{"r":247,"g":205,"b":199},"luminance":143.00151198501362},{"name":"Pink Sand","hex":"#dfb19b","rgb":{"r":223,"g":177,"b":155},"luminance":124.7118816713147},{"name":"Pink Sangria","hex":"#f6dbd3","rgb":{"r":246,"g":219,"b":211},"luminance":150.0488575131447},{"name":"Pink Satin","hex":"#ffbbdd","rgb":{"r":255,"g":187,"b":221},"luminance":136.00467279472423},{"name":"Pink Scallop","hex":"#f2e0d4","rgb":{"r":242,"g":224,"b":212},"luminance":152.01600748605392},{"name":"Pink Shade","hex":"#cd7584","rgb":{"r":205,"g":117,"b":132},"luminance":93.27552932039572},{"name":"Pink Shadow","hex":"#bb3377","rgb":{"r":187,"g":51,"b":119},"luminance":64.85772038855512},{"name":"Pink Sherbet","hex":"#f780a1","rgb":{"r":247,"g":128,"b":161},"luminance":106.94182259995384},{"name":"Pink Shimmer","hex":"#fde0da","rgb":{"r":253,"g":224,"b":218},"luminance":153.7178735768876},{"name":"Pink Slip","hex":"#d58d8a","rgb":{"r":213,"g":141,"b":138},"luminance":105.61205462446036},{"name":"Pink Sparkle","hex":"#ffe9eb","rgb":{"r":255,"g":233,"b":235},"luminance":158.8625524344866},{"name":"Pink Spinel","hex":"#e7c9ca","rgb":{"r":231,"g":201,"b":202},"luminance":138.64251769929743},{"name":"Pink Spyro","hex":"#a328b3","rgb":{"r":163,"g":40,"b":179},"luminance":57.81877208139238},{"name":"Pink Stock","hex":"#ddabab","rgb":{"r":221,"g":171,"b":171},"luminance":121.74560528413335},{"name":"Pink Sugar","hex":"#eeaaff","rgb":{"r":238,"g":170,"b":255},"luminance":125.96483336233172},{"name":"Pink Swan","hex":"#bfb3b2","rgb":{"r":191,"g":179,"b":178},"luminance":121.29937540647106},{"name":"Pink Tease","hex":"#ff81c0","rgb":{"r":255,"g":129,"b":192},"luminance":109.66474956885644},{"name":"Pink Theory","hex":"#ffe6e4","rgb":{"r":255,"g":230,"b":228},"luminance":157.215088935509},{"name":"Pink Tint","hex":"#dbcbbd","rgb":{"r":219,"g":203,"b":189},"luminance":137.6638492778696},{"name":"Pink Tulip","hex":"#985672","rgb":{"r":152,"g":86,"b":114},"luminance":69.15814517466471},{"name":"Pink Tulle","hex":"#deb59a","rgb":{"r":222,"g":181,"b":154},"luminance":126.50168785039985},{"name":"Pink Tutu","hex":"#f9e4e9","rgb":{"r":249,"g":228,"b":233},"luminance":155.43669496293336},{"name":"Pink Wink","hex":"#ffaaee","rgb":{"r":255,"g":170,"b":238},"luminance":128.48147550911764},{"name":"Pink Wraith","hex":"#ddbbbb","rgb":{"r":221,"g":187,"b":187},"luminance":129.8850442737731},{"name":"Pink Yarrow","hex":"#ce3175","rgb":{"r":206,"g":49,"b":117},"luminance":69.27505502704417},{"name":"Pink Zest","hex":"#f2d8cd","rgb":{"r":242,"g":216,"b":205},"luminance":147.8446763600232},{"name":"Pink-N-Purple","hex":"#866180","rgb":{"r":134,"g":97,"b":128},"luminance":71.13550829930155},{"name":"Pinkalicious","hex":"#ff99ff","rgb":{"r":255,"g":153,"b":255},"luminance":121.34405896458217},{"name":"Pinkham","hex":"#e8c5ae","rgb":{"r":232,"g":197,"b":174},"luminance":136.3002738111703},{"name":"Pinkish","hex":"#d46a7e","rgb":{"r":212,"g":106,"b":126},"luminance":89.97744341778109},{"name":"Pinkish Brown","hex":"#b17261","rgb":{"r":177,"g":114,"b":97},"luminance":86.02989025332997},{"name":"Pinkish Grey","hex":"#c8aca9","rgb":{"r":200,"g":172,"b":169},"luminance":118.91571827138748},{"name":"Pinkish Orange","hex":"#ff724c","rgb":{"r":255,"g":114,"b":76},"luminance":101.81543912884725},{"name":"Pinkish Purple","hex":"#d648d7","rgb":{"r":214,"g":72,"b":215},"luminance":80.50586309083333},{"name":"Pinkish Red","hex":"#f10c45","rgb":{"r":241,"g":12,"b":69},"luminance":72.82850659597517},{"name":"Pinkish Tan","hex":"#d99b82","rgb":{"r":217,"g":155,"b":130},"luminance":112.72846275009698},{"name":"Pinktone","hex":"#f9ced1","rgb":{"r":249,"g":206,"b":209},"luminance":143.98874873058656},{"name":"Pinky","hex":"#fc86aa","rgb":{"r":252,"g":134,"b":170},"luminance":110.63447233118617},{"name":"Pinnacle","hex":"#beddd5","rgb":{"r":190,"g":221,"b":213},"luminance":143.6874599712863},{"name":"Pinot Noir","hex":"#605258","rgb":{"r":96,"g":82,"b":88},"luminance":56.933668386992245},{"name":"Pinwheel Geyser","hex":"#d2dcde","rgb":{"r":210,"g":220,"b":222},"luminance":145.80884254392802},{"name":"Pinyon Pine","hex":"#625a42","rgb":{"r":98,"g":90,"b":66},"luminance":60.878786781603985},{"name":"Pion Purple","hex":"#480840","rgb":{"r":72,"g":8,"b":64},"luminance":23.210747855250162},{"name":"Pioneer Village","hex":"#aa9076","rgb":{"r":170,"g":144,"b":118},"luminance":99.54711441322645},{"name":"Pipe","hex":"#857165","rgb":{"r":133,"g":113,"b":101},"luminance":78.19071585552852},{"name":"Pipe Clay","hex":"#cac7bc","rgb":{"r":202,"g":199,"b":188},"luminance":133.2386055053114},{"name":"Piper","hex":"#9d5432","rgb":{"r":157,"g":84,"b":50},"luminance":68.31847563434066},{"name":"Pipitschah","hex":"#f5e6c4","rgb":{"r":245,"g":230,"b":196},"luminance":155.22000341772963},{"name":"Pippin","hex":"#fcdbd2","rgb":{"r":252,"g":219,"b":210},"luminance":150.91825109310005},{"name":"Piquant Green","hex":"#769358","rgb":{"r":118,"g":147,"b":88},"luminance":93.76167697412413},{"name":"Piquant Pink","hex":"#ee00ee","rgb":{"r":238,"g":0,"b":238},"luminance":76.15888436682879},{"name":"Pirat's Wine","hex":"#71424a","rgb":{"r":113,"g":66,"b":74},"luminance":52.092898066819046},{"name":"Pirate Black","hex":"#363838","rgb":{"r":54,"g":56,"b":56},"luminance":37.17549133501802},{"name":"Pirate Gold","hex":"#ba782a","rgb":{"r":186,"g":120,"b":42},"luminance":89.87566711852547},{"name":"Pirate Plunder","hex":"#b1905e","rgb":{"r":177,"g":144,"b":94},"luminance":100.302838289851},{"name":"Pirate Silver","hex":"#818988","rgb":{"r":129,"g":137,"b":136},"luminance":90.52796042107654},{"name":"Pirate's Haven","hex":"#005176","rgb":{"r":0,"g":81,"b":118},"luminance":49.41329287752436},{"name":"Pirate's Hook","hex":"#b08f42","rgb":{"r":176,"g":143,"b":66},"luminance":99.3578755459274},{"name":"Pirate's Trinket","hex":"#716970","rgb":{"r":113,"g":105,"b":112},"luminance":71.43847995303372},{"name":"Pisco Sour","hex":"#beeb71","rgb":{"r":190,"g":235,"b":113},"luminance":149.7402586113701},{"name":"Pistachio","hex":"#93c572","rgb":{"r":147,"g":197,"b":114},"luminance":124.39107904508265},{"name":"Pistachio Cream","hex":"#d5e2e1","rgb":{"r":213,"g":226,"b":225},"luminance":149.37591075203525},{"name":"Pistachio Flour","hex":"#4f8f00","rgb":{"r":79,"g":143,"b":0},"luminance":87.20116468258894},{"name":"Pistachio Green","hex":"#a9d39e","rgb":{"r":169,"g":211,"b":158},"luminance":134.97544426302142},{"name":"Pistachio Ice Cream","hex":"#a0b7ad","rgb":{"r":160,"g":183,"b":173},"luminance":119.23461798068546},{"name":"Pistachio Mousse","hex":"#c0fa8b","rgb":{"r":192,"g":250,"b":139},"luminance":158.37404042329663},{"name":"Pistachio Pudding","hex":"#c6d4ac","rgb":{"r":198,"g":212,"b":172},"luminance":139.1964784180979},{"name":"Pistachio Shell","hex":"#d7cfbb","rgb":{"r":215,"g":207,"b":187},"luminance":139.10950876917076},{"name":"Pistachio Tang","hex":"#d7d2b8","rgb":{"r":215,"g":210,"b":184},"luminance":140.59888584551445},{"name":"Pistou Green","hex":"#00bb55","rgb":{"r":0,"g":187,"b":85},"luminance":110.19586862037977},{"name":"Pit Stop","hex":"#414958","rgb":{"r":65,"g":73,"b":88},"luminance":48.10996206608357},{"name":"Pita Bread","hex":"#f5e7d2","rgb":{"r":245,"g":231,"b":210},"luminance":155.96783333110707},{"name":"Pitapat","hex":"#edeb9a","rgb":{"r":237,"g":235,"b":154},"luminance":156.07242206744917},{"name":"Pitch","hex":"#423937","rgb":{"r":66,"g":57,"b":55},"luminance":39.34778693903889},{"name":"Pitch Black","hex":"#483c41","rgb":{"r":72,"g":60,"b":65},"luminance":41.93818408085882},{"name":"Pitch Mary Brown","hex":"#5c4033","rgb":{"r":92,"g":64,"b":51},"luminance":46.923845579832864},{"name":"Pitcher","hex":"#b5d1be","rgb":{"r":181,"g":209,"b":190},"luminance":135.82761225170674},{"name":"Pitter Patter","hex":"#9bc2bd","rgb":{"r":155,"g":194,"b":189},"luminance":124.82102397032321},{"name":"Pixel Bleeding","hex":"#bb0022","rgb":{"r":187,"g":0,"b":34},"luminance":56.04718498729441},{"name":"Pixel Cream","hex":"#f7d384","rgb":{"r":247,"g":211,"b":132},"luminance":144.9871179174205},{"name":"Pixel Nature","hex":"#008751","rgb":{"r":0,"g":135,"b":81},"luminance":79.78118061924127},{"name":"Pixelated Grass","hex":"#009337","rgb":{"r":0,"g":147,"b":55},"luminance":86.51649797004038},{"name":"Pixie Green","hex":"#bbcda5","rgb":{"r":187,"g":205,"b":165},"luminance":134.01713283755925},{"name":"Pixie Powder","hex":"#391285","rgb":{"r":57,"g":18,"b":133},"luminance":25.139420220044855},{"name":"Pixieland","hex":"#b4a6c6","rgb":{"r":180,"g":166,"b":198},"luminance":113.58270532083658},{"name":"Pizazz","hex":"#e57f3d","rgb":{"r":229,"g":127,"b":61},"luminance":101.4602846339394},{"name":"Pizza","hex":"#bf8d3c","rgb":{"r":191,"g":141,"b":60},"luminance":100.78987930343006},{"name":"Pizza Pie","hex":"#a06165","rgb":{"r":160,"g":97,"b":101},"luminance":75.2548172345133},{"name":"Placid Blue","hex":"#8cadd3","rgb":{"r":140,"g":173,"b":211},"luminance":112.44314170726464},{"name":"Plague Brown","hex":"#dfb900","rgb":{"r":223,"g":185,"b":0},"luminance":127.43114357958183},{"name":"Plaguelands Beige","hex":"#ab8d44","rgb":{"r":171,"g":141,"b":68},"luminance":97.59428484291485},{"name":"Plaguelands Hazel","hex":"#ad5f28","rgb":{"r":173,"g":95,"b":40},"luminance":76.19849968339271},{"name":"Plain and Simple","hex":"#ebf0d6","rgb":{"r":235,"g":240,"b":214},"luminance":159.3094769340481},{"name":"Planet Green","hex":"#496a76","rgb":{"r":73,"g":106,"b":118},"luminance":67.29748522047461},{"name":"Planet of the Apes","hex":"#883333","rgb":{"r":136,"g":51,"b":51},"luminance":50.82900216411886},{"name":"Planetarium","hex":"#1c70ad","rgb":{"r":28,"g":112,"b":173},"luminance":69.14709830499035},{"name":"Plantain","hex":"#97943b","rgb":{"r":151,"g":148,"b":59},"luminance":98.13822218177786},{"name":"Plantation","hex":"#3e594c","rgb":{"r":62,"g":89,"b":76},"luminance":56.10751633248436},{"name":"Plantation Island","hex":"#9b8a44","rgb":{"r":155,"g":138,"b":68},"luminance":93.6478753896745},{"name":"Plasma Trail","hex":"#d59cfc","rgb":{"r":213,"g":156,"b":252},"luminance":115.18143573076348},{"name":"Plaster Mix","hex":"#ead1a6","rgb":{"r":234,"g":209,"b":166},"luminance":142.49378028882523},{"name":"Plastic Marble","hex":"#ffddcc","rgb":{"r":255,"g":221,"b":204},"luminance":152.2604219421449},{"name":"Plastic Veggie","hex":"#22ff22","rgb":{"r":34,"g":255,"b":34},"luminance":150.0798792543491},{"name":"Plasticine","hex":"#4a623b","rgb":{"r":74,"g":98,"b":59},"luminance":62.000319579821515},{"name":"Plate Mail Metal","hex":"#8c8589","rgb":{"r":140,"g":133,"b":137},"luminance":89.9514455970553},{"name":"Plateau","hex":"#d3e7e5","rgb":{"r":211,"g":231,"b":229},"luminance":151.8166379748939},{"name":"Platinum","hex":"#e5e4e2","rgb":{"r":229,"g":228,"b":226},"luminance":152.52585496564177},{"name":"Platinum Blonde","hex":"#f0e8d7","rgb":{"r":240,"g":232,"b":215},"luminance":155.8727672045377},{"name":"Platinum Granite","hex":"#807f7e","rgb":{"r":128,"g":127,"b":126},"luminance":85.02131427471583},{"name":"Platinum Ogon Koi","hex":"#ece1d3","rgb":{"r":236,"g":225,"b":211},"luminance":151.6630430823541},{"name":"Platonic Blue","hex":"#88ccff","rgb":{"r":136,"g":204,"b":255},"luminance":129.76212583030534},{"name":"Platoon Green","hex":"#2a4845","rgb":{"r":42,"g":72,"b":69},"luminance":44.78641552971168},{"name":"Plaudit","hex":"#39536c","rgb":{"r":57,"g":83,"b":108},"luminance":53.06397114803979},{"name":"Play on Grey","hex":"#bab6a9","rgb":{"r":186,"g":182,"b":169},"luminance":121.97376483490208},{"name":"Play School","hex":"#ce5924","rgb":{"r":206,"g":89,"b":36},"luminance":80.87023371426596},{"name":"Playful Plum","hex":"#ba99a2","rgb":{"r":186,"g":153,"b":162},"luminance":107.23805174004234},{"name":"Playful Purple","hex":"#bfb9d5","rgb":{"r":191,"g":185,"b":213},"luminance":125.07568680602957},{"name":"Playing Hooky","hex":"#8b8c6b","rgb":{"r":139,"g":140,"b":107},"luminance":92.89596506307471},{"name":"Plaza Taupe","hex":"#aea393","rgb":{"r":174,"g":163,"b":147},"luminance":110.19250882432979},{"name":"Pleasant Pomegranate","hex":"#cc3300","rgb":{"r":204,"g":51,"b":0},"luminance":67.94656713182793},{"name":"Pleasing Pink","hex":"#f5cdd2","rgb":{"r":245,"g":205,"b":210},"luminance":142.8983234681219},{"name":"Pleasure","hex":"#80385c","rgb":{"r":128,"g":56,"b":92},"luminance":51.52972454807031},{"name":"Plein Air","hex":"#bfcad6","rgb":{"r":191,"g":202,"b":214},"luminance":133.8521429525878},{"name":"Ploughed Earth","hex":"#6c6459","rgb":{"r":108,"g":100,"b":89},"luminance":67.75990392555173},{"name":"Plum","hex":"#5a315d","rgb":{"r":90,"g":49,"b":93},"luminance":40.79044830594535},{"name":"Plum Blossom","hex":"#f2a0a1","rgb":{"r":242,"g":160,"b":161},"luminance":119.97297979128467},{"name":"Plum Blossom Dye","hex":"#b48a76","rgb":{"r":180,"g":138,"b":118},"luminance":98.18106100465609},{"name":"Plum Caspia","hex":"#61224a","rgb":{"r":97,"g":34,"b":74},"luminance":36.20306435925003},{"name":"Plum Crush","hex":"#716063","rgb":{"r":113,"g":96,"b":99},"luminance":66.66695635020396},{"name":"Plum Dust","hex":"#aa4c8f","rgb":{"r":170,"g":76,"b":143},"luminance":69.56777018131312},{"name":"Plum Fuzz","hex":"#313048","rgb":{"r":49,"g":48,"b":72},"luminance":32.80106768079356},{"name":"Plum Haze","hex":"#8b7574","rgb":{"r":139,"g":117,"b":116},"luminance":81.35721196058775},{"name":"Plum Jam","hex":"#624076","rgb":{"r":98,"g":64,"b":118},"luminance":49.506748348078766},{"name":"Plum Juice","hex":"#dea1dd","rgb":{"r":222,"g":161,"b":221},"luminance":118.20469351510539},{"name":"Plum Kitten","hex":"#625b5c","rgb":{"r":98,"g":91,"b":92},"luminance":61.82217431472303},{"name":"Plum Majesty","hex":"#994548","rgb":{"r":153,"g":69,"b":72},"luminance":61.64943050831856},{"name":"Plum Mouse","hex":"#c099a0","rgb":{"r":192,"g":153,"b":160},"luminance":108.14061117360119},{"name":"Plum Paradise","hex":"#aa1166","rgb":{"r":170,"g":17,"b":102},"luminance":53.08935604243095},{"name":"Plum Passion","hex":"#9b4b80","rgb":{"r":155,"g":75,"b":128},"luminance":65.56665397898539},{"name":"Plum Perfect","hex":"#aa1155","rgb":{"r":170,"g":17,"b":85},"luminance":52.69881821255577},{"name":"Plum Perfume","hex":"#a489a3","rgb":{"r":164,"g":137,"b":163},"luminance":96.0053934995321},{"name":"Plum Pie","hex":"#8e4585","rgb":{"r":142,"g":69,"b":133},"luminance":60.605783692647684},{"name":"Plum Point","hex":"#d4bddf","rgb":{"r":212,"g":189,"b":223},"luminance":130.2791843580547},{"name":"Plum Power","hex":"#7e5e8d","rgb":{"r":126,"g":94,"b":141},"luminance":68.7191053201364},{"name":"Plum Purple","hex":"#580f41","rgb":{"r":88,"g":15,"b":65},"luminance":28.718590999559847},{"name":"Plum Sauce","hex":"#6a3939","rgb":{"r":106,"g":57,"b":57},"luminance":46.54286541458315},{"name":"Plum Savor","hex":"#915d88","rgb":{"r":145,"g":93,"b":136},"luminance":71.41573581501487},{"name":"Plum Shade","hex":"#78738b","rgb":{"r":120,"g":115,"b":139},"luminance":78.0730116045231},{"name":"Plum Skin","hex":"#51304e","rgb":{"r":81,"g":48,"b":78},"luminance":38.20359408485018},{"name":"Plum Truffle","hex":"#675657","rgb":{"r":103,"g":86,"b":87},"luminance":59.96043909945957},{"name":"Plum Wine","hex":"#674550","rgb":{"r":103,"g":69,"b":80},"luminance":51.692577977887694},{"name":"Plumberry","hex":"#735054","rgb":{"r":115,"g":80,"b":84},"luminance":58.98533377883014},{"name":"Plumburn","hex":"#7d665f","rgb":{"r":125,"g":102,"b":95},"luminance":71.40781050417384},{"name":"Plume","hex":"#a5cfd5","rgb":{"r":165,"g":207,"b":213},"luminance":133.37164177590375},{"name":"Plume Grass","hex":"#d9d5c5","rgb":{"r":217,"g":213,"b":197},"luminance":142.64261780407705},{"name":"Plumosa","hex":"#64a281","rgb":{"r":100,"g":162,"b":129},"luminance":100.7628169117954},{"name":"Plumville","hex":"#9e8185","rgb":{"r":158,"g":129,"b":133},"luminance":90.52991514963438},{"name":"Plunder","hex":"#5072a9","rgb":{"r":80,"g":114,"b":169},"luminance":73.6299115848987},{"name":"Plunge","hex":"#035568","rgb":{"r":3,"g":85,"b":104},"luminance":51.29210826238281},{"name":"Plunge Pool","hex":"#656457","rgb":{"r":101,"g":100,"b":87},"luminance":66.75354915658043},{"name":"Plunging Waterfall","hex":"#8cd4df","rgb":{"r":140,"g":212,"b":223},"luminance":133.7342395200272},{"name":"Plush","hex":"#3b3549","rgb":{"r":59,"g":53,"b":73},"luminance":36.719952151384945},{"name":"Plush Purple","hex":"#5d4a61","rgb":{"r":93,"g":74,"b":97},"luminance":52.74816069779116},{"name":"Plush Suede","hex":"#b1928c","rgb":{"r":177,"g":146,"b":140},"luminance":101.98234324136703},{"name":"Plushy Pink","hex":"#eab7a8","rgb":{"r":234,"g":183,"b":168},"luminance":129.61987309436776},{"name":"Pluto","hex":"#34acb1","rgb":{"r":52,"g":172,"b":177},"luminance":104.12790828591535},{"name":"Plutonium","hex":"#35fa00","rgb":{"r":53,"g":250,"b":0},"luminance":147.6031500646243},{"name":"Pluviophile","hex":"#66dddd","rgb":{"r":102,"g":221,"b":221},"luminance":135.6243347227923},{"name":"Plymouth Grey","hex":"#b0b1ac","rgb":{"r":176,"g":177,"b":172},"luminance":118.10487390874265},{"name":"Poached","hex":"#f5d893","rgb":{"r":245,"g":216,"b":147},"luminance":147.3883877820773},{"name":"Poached Rainbow Trout","hex":"#ff8552","rgb":{"r":255,"g":133,"b":82},"luminance":109.52518509457083},{"name":"Pochard Duck Head","hex":"#ee9977","rgb":{"r":238,"g":153,"b":119},"luminance":115.3866643984477},{"name":"Pocket Lint","hex":"#b5d5d7","rgb":{"r":181,"g":213,"b":215},"luminance":138.42816628851224},{"name":"Poetic Green","hex":"#00a844","rgb":{"r":0,"g":168,"b":68},"luminance":98.92021512309807},{"name":"Poetic License","hex":"#e4e8e1","rgb":{"r":228,"g":232,"b":225},"luminance":154.43906869701073},{"name":"Poetic Yellow","hex":"#fffed7","rgb":{"r":255,"g":254,"b":215},"luminance":169.24613357178944},{"name":"Pogo Sands","hex":"#ece4d2","rgb":{"r":236,"g":228,"b":210},"luminance":153.1811887667673},{"name":"Pohutukawa","hex":"#651c26","rgb":{"r":101,"g":28,"b":38},"luminance":34.65382981720779},{"name":"Poinciana","hex":"#ca3422","rgb":{"r":202,"g":52,"b":34},"luminance":67.78389451779825},{"name":"Poinsettia","hex":"#cb3441","rgb":{"r":203,"g":52,"b":65},"luminance":68.34287442740464},{"name":"Pointed Rock","hex":"#646767","rgb":{"r":100,"g":103,"b":103},"luminance":68.46471415992328},{"name":"Poise","hex":"#a77693","rgb":{"r":167,"g":118,"b":147},"luminance":87.0167444173821},{"name":"Poised Peach","hex":"#ffa99d","rgb":{"r":255,"g":169,"b":157},"luminance":126.39174671631055},{"name":"Poison Green","hex":"#40fd14","rgb":{"r":64,"g":253,"b":20},"luminance":149.75614183398287},{"name":"Poison Ivy","hex":"#00ad43","rgb":{"r":0,"g":173,"b":67},"luminance":101.83783503688596},{"name":"Poison Purple","hex":"#7f01fe","rgb":{"r":127,"g":1,"b":254},"luminance":47.75712757275085},{"name":"Poisoning Green","hex":"#66ff11","rgb":{"r":102,"g":255,"b":17},"luminance":152.77265158725234},{"name":"Poisonous Apple","hex":"#993333","rgb":{"r":153,"g":51,"b":51},"luminance":54.98012890126759},{"name":"Poisonous Dart","hex":"#77ff66","rgb":{"r":119,"g":255,"b":102},"luminance":154.2945791983633},{"name":"Poisonous Pesticide","hex":"#32cd32","rgb":{"r":50,"g":205,"b":50},"luminance":121.39400613292239},{"name":"Poisonous Purple","hex":"#2a0134","rgb":{"r":42,"g":1,"b":52},"luminance":13.899248792650631},{"name":"Poker Green","hex":"#35654d","rgb":{"r":53,"g":101,"b":77},"luminance":61.99297590856564},{"name":"Polar","hex":"#e5f2e7","rgb":{"r":229,"g":242,"b":231},"luminance":159.87837975473732},{"name":"Polar Bear","hex":"#eae9e0","rgb":{"r":234,"g":233,"b":224},"luminance":155.73578552471488},{"name":"Polar Expedition","hex":"#c9e7e3","rgb":{"r":201,"g":231,"b":227},"luminance":150.55931420539878},{"name":"Polar Ice","hex":"#71a6d2","rgb":{"r":113,"g":166,"b":210},"luminance":105.87553226784742},{"name":"Polar Mist","hex":"#adafbd","rgb":{"r":173,"g":175,"b":189},"luminance":117.01426524146532},{"name":"Polar Wind","hex":"#b4dfed","rgb":{"r":180,"g":223,"b":237},"luminance":144.08898821561624},{"name":"Polaris","hex":"#a0aead","rgb":{"r":160,"g":174,"b":173},"luminance":114.49800840189317},{"name":"Polenta","hex":"#efc47f","rgb":{"r":239,"g":196,"b":127},"luminance":136.21031425336335},{"name":"Police Blue","hex":"#374f6b","rgb":{"r":55,"g":79,"b":107},"luminance":50.69205418998129},{"name":"Polignac","hex":"#c28799","rgb":{"r":194,"g":135,"b":153},"luminance":99.74311718108673},{"name":"Polished Aqua","hex":"#77bcb6","rgb":{"r":119,"g":188,"b":182},"luminance":117.79190889445675},{"name":"Polished Bronze","hex":"#cd7f32","rgb":{"r":205,"g":127,"b":50},"luminance":96.68050695977963},{"name":"Polished Brown","hex":"#985538","rgb":{"r":152,"g":85,"b":56},"luminance":67.79223543297566},{"name":"Polished Copper","hex":"#b66325","rgb":{"r":182,"g":99,"b":37},"luminance":79.72597454405935},{"name":"Polished Garnet","hex":"#953640","rgb":{"r":149,"g":54,"b":64},"luminance":55.161457749047926},{"name":"Polished Gold","hex":"#eeaa44","rgb":{"r":238,"g":170,"b":68},"luminance":122.80947784271375},{"name":"Polished Limestone","hex":"#dcd5c8","rgb":{"r":220,"g":213,"b":200},"luminance":143.10695077808066},{"name":"Polished Metal","hex":"#819ab1","rgb":{"r":129,"g":154,"b":177},"luminance":100.33280684302616},{"name":"Polished Pewter","hex":"#9c9a99","rgb":{"r":156,"g":154,"b":153},"luminance":103.20699832860173},{"name":"Polished Pine","hex":"#5da493","rgb":{"r":93,"g":164,"b":147},"luminance":101.59521463632035},{"name":"Polished Pink","hex":"#fff2ef","rgb":{"r":255,"g":242,"b":239},"luminance":163.50835898204105},{"name":"Polished Silver","hex":"#c5d1da","rgb":{"r":197,"g":209,"b":218},"luminance":138.3412584950708},{"name":"Polished Steel","hex":"#6f828a","rgb":{"r":111,"g":130,"b":138},"luminance":84.68897003152182},{"name":"Polished Stone","hex":"#beb49e","rgb":{"r":190,"g":180,"b":158},"luminance":121.30887784494587},{"name":"Polka Dot Plum","hex":"#5a4458","rgb":{"r":90,"g":68,"b":88},"luminance":49.173938015985655},{"name":"Pollen","hex":"#eeeeaa","rgb":{"r":238,"g":238,"b":170},"luminance":157.97905266205387},{"name":"Pollen Storm","hex":"#b8a02a","rgb":{"r":184,"g":160,"b":42},"luminance":108.95251993414378},{"name":"Pollinate","hex":"#e3d6bc","rgb":{"r":227,"g":214,"b":188},"luminance":144.38128922059119},{"name":"Pollination","hex":"#eedd66","rgb":{"r":238,"g":221,"b":102},"luminance":148.41945680064995},{"name":"Polly","hex":"#ffcaa4","rgb":{"r":255,"g":202,"b":164},"luminance":142.20630758514193},{"name":"Polo Blue","hex":"#8aa7cc","rgb":{"r":138,"g":167,"b":204},"luminance":108.87184677867828},{"name":"Polo Pony","hex":"#d09258","rgb":{"r":208,"g":146,"b":88},"luminance":106.36408553642532},{"name":"Polo Tan","hex":"#f4e5dd","rgb":{"r":244,"g":229,"b":221},"luminance":155.00599504857868},{"name":"Polyanthus Narcissus","hex":"#feffcc","rgb":{"r":254,"g":255,"b":204},"luminance":169.45275352439688},{"name":"Pomegranate","hex":"#c35550","rgb":{"r":195,"g":85,"b":80},"luminance":77.27974152389486},{"name":"Pomegranate Tea","hex":"#ab6f73","rgb":{"r":171,"g":111,"b":115},"luminance":83.8539288882757},{"name":"Pomelo Red","hex":"#e38fac","rgb":{"r":227,"g":143,"b":172},"luminance":109.71467209995204},{"name":"Pomelo Sugar","hex":"#fce8e3","rgb":{"r":252,"g":232,"b":227},"luminance":157.77539048913806},{"name":"Pomodoro","hex":"#c30232","rgb":{"r":195,"g":2,"b":50},"luminance":58.59472076049172},{"name":"Pomodoro e Mozzarella","hex":"#f2d4df","rgb":{"r":242,"g":212,"b":223},"luminance":146.17888829786605},{"name":"Pomp and Power","hex":"#87608e","rgb":{"r":135,"g":96,"b":142},"luminance":71.18238878402437},{"name":"Pompadour","hex":"#6a1f44","rgb":{"r":106,"g":31,"b":68},"luminance":37.35952286900891},{"name":"Pompeian Pink","hex":"#c87763","rgb":{"r":200,"g":119,"b":99},"luminance":92.64370137791343},{"name":"Pompeian Red","hex":"#a4292e","rgb":{"r":164,"g":41,"b":46},"luminance":54.87485144399026},{"name":"Pompeii Ash","hex":"#6c757d","rgb":{"r":108,"g":117,"b":125},"luminance":77.21813779805882},{"name":"Pompeii Ruins","hex":"#5e615b","rgb":{"r":94,"g":97,"b":91},"luminance":64.33985415743496},{"name":"Pompeius Blue","hex":"#77a8ab","rgb":{"r":119,"g":168,"b":171},"luminance":106.63554310360125},{"name":"Pompelmo","hex":"#ff6666","rgb":{"r":255,"g":102,"b":102},"luminance":97.63916368445604},{"name":"Pomtini","hex":"#ca93c1","rgb":{"r":202,"g":147,"b":193},"luminance":107.60017624985565},{"name":"Ponceau","hex":"#f75c75","rgb":{"r":247,"g":92,"b":117},"luminance":92.45863869320162},{"name":"Pond Bath","hex":"#00827f","rgb":{"r":0,"g":130,"b":127},"luminance":77.67128545350592},{"name":"Pond Blue","hex":"#8bb6c6","rgb":{"r":139,"g":182,"b":198},"luminance":116.83456449612844},{"name":"Pond Moss","hex":"#01796f","rgb":{"r":1,"g":121,"b":111},"luminance":72.14601753388749},{"name":"Pond Newt","hex":"#486b67","rgb":{"r":72,"g":107,"b":103},"luminance":67.42625474546246},{"name":"Ponderosa Pine","hex":"#203b3d","rgb":{"r":32,"g":59,"b":61},"luminance":36.59712323393739},{"name":"Pont Moss","hex":"#5f9228","rgb":{"r":95,"g":146,"b":40},"luminance":90.4017169582525},{"name":"Pontoon","hex":"#0c608e","rgb":{"r":12,"g":96,"b":142},"luminance":58.74072685964994},{"name":"Pony","hex":"#c6aa81","rgb":{"r":198,"g":170,"b":129},"luminance":116.95805803791374},{"name":"Pony Express","hex":"#726a60","rgb":{"r":114,"g":106,"b":96},"luminance":71.78581904526825},{"name":"Pony Tail","hex":"#d2bc9b","rgb":{"r":210,"g":188,"b":155},"luminance":128.1922764288083},{"name":"Ponzu Brown","hex":"#220000","rgb":{"r":34,"g":0,"b":0},"luminance":10.166},{"name":"Poodle Skirt","hex":"#ffaebb","rgb":{"r":255,"g":174,"b":187},"luminance":129.2282020032779},{"name":"Poodle Skirt Peach","hex":"#ea927a","rgb":{"r":234,"g":146,"b":122},"luminance":111.50563404599787},{"name":"Pookie Bear","hex":"#824b2e","rgb":{"r":130,"g":75,"b":46},"luminance":58.962505552257525},{"name":"Pool Bar","hex":"#8fabbd","rgb":{"r":143,"g":171,"b":189},"luminance":111.21121028925097},{"name":"Pool Blue","hex":"#67bcb3","rgb":{"r":103,"g":188,"b":179},"luminance":116.3757138796579},{"name":"Pool Floor","hex":"#7daee1","rgb":{"r":125,"g":174,"b":225},"luminance":111.74517514863896},{"name":"Pool Green","hex":"#00af9d","rgb":{"r":0,"g":175,"b":157},"luminance":104.27254686157809},{"name":"Pool Party","hex":"#bee9e3","rgb":{"r":190,"g":233,"b":227},"luminance":150.34411669566586},{"name":"Pool Side","hex":"#aad5d9","rgb":{"r":170,"g":213,"b":217},"luminance":137.21664806064896},{"name":"Pool Tiles","hex":"#89cff0","rgb":{"r":137,"g":207,"b":240},"luminance":131.11435485865},{"name":"Pop Shop","hex":"#93d4c0","rgb":{"r":147,"g":212,"b":192},"luminance":133.780640935077},{"name":"Popcorn","hex":"#f8de8d","rgb":{"r":248,"g":222,"b":141},"luminance":150.79333929587207},{"name":"Poplar","hex":"#a29f46","rgb":{"r":162,"g":159,"b":70},"luminance":105.4560056753526},{"name":"Poplar Kitten","hex":"#ece9e9","rgb":{"r":236,"g":233,"b":233},"luminance":156.1765807699733},{"name":"Poppy Crepe","hex":"#fbe9d8","rgb":{"r":251,"g":233,"b":216},"luminance":157.93986266297688},{"name":"Poppy Flower","hex":"#ec5800","rgb":{"r":236,"g":88,"b":0},"luminance":87.4506742798476},{"name":"Poppy Leaf","hex":"#88a496","rgb":{"r":136,"g":164,"b":150},"luminance":105.89380869531514},{"name":"Poppy Petal","hex":"#f6a08c","rgb":{"r":246,"g":160,"b":140},"luminance":120.35729689553516},{"name":"Poppy Pods","hex":"#736157","rgb":{"r":115,"g":97,"b":87},"luminance":67.25135441015296},{"name":"Poppy Pompadour","hex":"#6b3fa0","rgb":{"r":107,"g":63,"b":160},"luminance":52.19045899395788},{"name":"Poppy Power","hex":"#ed2939","rgb":{"r":237,"g":41,"b":57},"luminance":75.11996580137667},{"name":"Poppy Red","hex":"#dc343b","rgb":{"r":220,"g":52,"b":59},"luminance":72.82830529402699},{"name":"Poppy Surprise","hex":"#ff5630","rgb":{"r":255,"g":86,"b":48},"luminance":91.60608676829285},{"name":"Poppy's Whiskers","hex":"#ccd7df","rgb":{"r":204,"g":215,"b":223},"luminance":142.45873832447063},{"name":"Popstar","hex":"#be4f62","rgb":{"r":190,"g":79,"b":98},"luminance":74.17981405342022},{"name":"Porcelain","hex":"#dddcdb","rgb":{"r":221,"g":220,"b":219},"luminance":147.1967221000522},{"name":"Porcelain Basin","hex":"#d9d0c4","rgb":{"r":217,"g":208,"b":196},"luminance":140.05888490559963},{"name":"Porcelain Blue","hex":"#95c0cb","rgb":{"r":149,"g":192,"b":203},"luminance":123.37963924813526},{"name":"Porcelain Crab","hex":"#e9b7a8","rgb":{"r":233,"g":183,"b":168},"luminance":129.4587240551984},{"name":"Porcelain Earth","hex":"#eeffbb","rgb":{"r":238,"g":255,"b":187},"luminance":167.10501666018288},{"name":"Porcelain Figurines","hex":"#a9998c","rgb":{"r":169,"g":153,"b":140},"luminance":104.27904526797317},{"name":"Porcelain Green","hex":"#108780","rgb":{"r":16,"g":135,"b":128},"luminance":80.71916219213378},{"name":"Porcelain Jasper","hex":"#dfe2e4","rgb":{"r":223,"g":226,"b":228},"luminance":150.73358164987656},{"name":"Porcelain Pink","hex":"#ecd9b9","rgb":{"r":236,"g":217,"b":185},"luminance":147.137608506459},{"name":"Porcelain Rose","hex":"#ea6b6a","rgb":{"r":234,"g":107,"b":106},"luminance":94.79575250505688},{"name":"Porcelain Skin","hex":"#ffe7eb","rgb":{"r":255,"g":231,"b":235},"luminance":157.8529395798507},{"name":"Porcelain Tan","hex":"#f7d8c4","rgb":{"r":247,"g":216,"b":196},"luminance":148.42415978876215},{"name":"Porcellana","hex":"#ffbfab","rgb":{"r":255,"g":191,"b":171},"luminance":136.98006333039854},{"name":"Porch Swing","hex":"#597175","rgb":{"r":89,"g":113,"b":117},"luminance":72.70384533159164},{"name":"Porchetta Crust","hex":"#aa8736","rgb":{"r":170,"g":135,"b":54},"luminance":94.34699391607556},{"name":"Porcini","hex":"#cca580","rgb":{"r":204,"g":165,"b":128},"luminance":115.38773550512202},{"name":"Porcupine Needles","hex":"#917a75","rgb":{"r":145,"g":122,"b":117},"luminance":84.77100486015249},{"name":"Pork Belly","hex":"#f8e0e7","rgb":{"r":248,"g":224,"b":231},"luminance":153.23541628487845},{"name":"Porous Stone","hex":"#d4cebf","rgb":{"r":212,"g":206,"b":191},"luminance":138.25438764827683},{"name":"Porpita Porpita","hex":"#2792c3","rgb":{"r":39,"g":146,"b":195},"luminance":89.30276941394371},{"name":"Porpoise","hex":"#dbdbda","rgb":{"r":219,"g":219,"b":218},"luminance":146.39418388037143},{"name":"Porpoise Fin","hex":"#c8cbcd","rgb":{"r":200,"g":203,"b":205},"luminance":135.35708633462824},{"name":"Porpoise Place","hex":"#076a7e","rgb":{"r":7,"g":106,"b":126},"luminance":63.8927415987137},{"name":"Porsche","hex":"#df9d5b","rgb":{"r":223,"g":157,"b":91},"luminance":114.22225477550334},{"name":"Port","hex":"#663336","rgb":{"r":102,"g":51,"b":54},"luminance":43.176941867158675},{"name":"Port Au Prince","hex":"#006a93","rgb":{"r":0,"g":106,"b":147},"luminance":64.43917944853115},{"name":"Port Glow","hex":"#54383b","rgb":{"r":84,"g":56,"b":59},"luminance":41.91206170066083},{"name":"Port Gore","hex":"#3b436c","rgb":{"r":59,"g":67,"b":108},"luminance":44.82812137486914},{"name":"Port Hope","hex":"#54c3c1","rgb":{"r":84,"g":195,"b":193},"luminance":119.23563932398734},{"name":"Port Malmesbury","hex":"#0e4d4e","rgb":{"r":14,"g":77,"b":78},"luminance":46.25516037157367},{"name":"Port Royale","hex":"#502b33","rgb":{"r":80,"g":43,"b":51},"luminance":35.25729820902333},{"name":"Port Wine","hex":"#a17a83","rgb":{"r":161,"g":122,"b":131},"luminance":87.57255662021063},{"name":"Port Wine Stain","hex":"#85677b","rgb":{"r":133,"g":103,"b":123},"luminance":73.71270781893716},{"name":"Portabella","hex":"#937b6a","rgb":{"r":147,"g":123,"b":106},"luminance":85.3866129202933},{"name":"Portage","hex":"#8b98d8","rgb":{"r":139,"g":152,"b":216},"luminance":101.46221105909332},{"name":"Portal Entrance","hex":"#f8f6da","rgb":{"r":248,"g":246,"b":218},"luminance":164.219604834502},{"name":"Portica","hex":"#f0d555","rgb":{"r":240,"g":213,"b":85},"luminance":144.48579397643215},{"name":"Portland Orange","hex":"#ff5a36","rgb":{"r":255,"g":90,"b":54},"luminance":92.9634619675924},{"name":"Portobello","hex":"#a28c82","rgb":{"r":162,"g":140,"b":130},"luminance":96.53716716374062},{"name":"Portobello Mushroom","hex":"#9d928a","rgb":{"r":157,"g":146,"b":138},"luminance":98.97461228517139},{"name":"Portofino","hex":"#f4f09b","rgb":{"r":244,"g":240,"b":155},"luminance":159.63076531796744},{"name":"Portrait Pink","hex":"#c6b4a9","rgb":{"r":198,"g":180,"b":169},"luminance":122.63804939740356},{"name":"Poseidon","hex":"#123955","rgb":{"r":18,"g":57,"b":85},"luminance":35.24722265654415},{"name":"Poseidon Jr.","hex":"#66eeee","rgb":{"r":102,"g":238,"b":238},"luminance":145.5473801344428},{"name":"Posey Blue","hex":"#a5b4c6","rgb":{"r":165,"g":180,"b":198},"luminance":118.77488374652278},{"name":"Positively Palm","hex":"#76745d","rgb":{"r":118,"g":116,"b":93},"luminance":77.41926370096786},{"name":"Possessed Plum","hex":"#773355","rgb":{"r":119,"g":51,"b":85},"luminance":47.49871187727094},{"name":"Post Apocalyptic Cloud","hex":"#c8cdd8","rgb":{"r":200,"g":205,"b":216},"luminance":136.61220150850363},{"name":"Post Boy","hex":"#7a99ad","rgb":{"r":122,"g":153,"b":173},"luminance":98.92228004347655},{"name":"Post It","hex":"#0074b4","rgb":{"r":0,"g":116,"b":180},"luminance":71.11674109518799},{"name":"Post Yellow","hex":"#ffee01","rgb":{"r":255,"g":238,"b":1},"luminance":159.15740465652232},{"name":"Postwar Boom","hex":"#466f97","rgb":{"r":70,"g":111,"b":151},"luminance":70.56784923036835},{"name":"Posy Green","hex":"#325b51","rgb":{"r":50,"g":91,"b":81},"luminance":56.23295426171383},{"name":"Posy Petal","hex":"#f3879c","rgb":{"r":243,"g":135,"b":156},"luminance":108.97284216721155},{"name":"Pot Black","hex":"#161616","rgb":{"r":22,"g":22,"b":22},"luminance":14.708213487708152},{"name":"Potash","hex":"#e07757","rgb":{"r":224,"g":119,"b":87},"luminance":97.28099973273301},{"name":"Potato Chip","hex":"#fddc57","rgb":{"r":253,"g":220,"b":87},"luminance":149.99324962477476},{"name":"Potent Purple","hex":"#462639","rgb":{"r":70,"g":38,"b":57},"luminance":31.27053789112045},{"name":"Potpourri","hex":"#f1e0db","rgb":{"r":241,"g":224,"b":219},"luminance":152.00294333005527},{"name":"Potted Plant","hex":"#9ecca7","rgb":{"r":158,"g":204,"b":167},"luminance":130.1300715130826},{"name":"Potter's Clay","hex":"#9e4624","rgb":{"r":158,"g":70,"b":36},"luminance":62.745816434245235},{"name":"Potter's Pink","hex":"#c2937b","rgb":{"r":194,"g":147,"b":123},"luminance":104.9147465373672},{"name":"Potters Pot","hex":"#845c40","rgb":{"r":132,"g":92,"b":64},"luminance":67.28585777115426},{"name":"Pottery Blue","hex":"#54a6c2","rgb":{"r":84,"g":166,"b":194},"luminance":103.02851195664236},{"name":"Pottery Clay","hex":"#b9714a","rgb":{"r":185,"g":113,"b":74},"luminance":86.77970316842527},{"name":"Potting Soil","hex":"#54392d","rgb":{"r":84,"g":57,"b":45},"luminance":42.15014871859884},{"name":"Poudretteite Pink","hex":"#e68e96","rgb":{"r":230,"g":142,"b":150},"luminance":109.4057229581707},{"name":"Pound Sterling","hex":"#818081","rgb":{"r":129,"g":128,"b":129},"luminance":85.72868232394569},{"name":"Pouring Copper","hex":"#fb9b82","rgb":{"r":251,"g":155,"b":130},"luminance":118.87074924471537},{"name":"Pout Pink","hex":"#ff82ce","rgb":{"r":255,"g":130,"b":206},"luminance":110.39934049168953},{"name":"Pouty Purple","hex":"#e7d7ef","rgb":{"r":231,"g":215,"b":239},"luminance":146.4259994058432},{"name":"Powder Ash","hex":"#bcc9c2","rgb":{"r":188,"g":201,"b":194},"luminance":132.5512677004637},{"name":"Powder Blue","hex":"#b0e0e6","rgb":{"r":176,"g":224,"b":230},"luminance":144.03425953570905},{"name":"Powder Dust","hex":"#b7b7bc","rgb":{"r":183,"g":183,"b":188},"luminance":122.44407684326751},{"name":"Powder Mill","hex":"#9cb3b5","rgb":{"r":156,"g":179,"b":181},"luminance":116.79794527730357},{"name":"Powder Pink","hex":"#fdd6e5","rgb":{"r":253,"g":214,"b":229},"luminance":148.94251833845163},{"name":"Powder Puff","hex":"#ffeff3","rgb":{"r":255,"g":239,"b":243},"luminance":162.0580966135293},{"name":"Powder Puff Pink","hex":"#ffcebe","rgb":{"r":255,"g":206,"b":190},"luminance":144.58418208434833},{"name":"Powder Rose","hex":"#f5b3bc","rgb":{"r":245,"g":179,"b":188},"luminance":129.869014695577},{"name":"Powdered","hex":"#f9f2e7","rgb":{"r":249,"g":242,"b":231},"luminance":162.5292892773484},{"name":"Powdered Brick","hex":"#ac9b9b","rgb":{"r":172,"g":155,"b":155},"luminance":105.99687877008455},{"name":"Powdered Cocoa","hex":"#341c02","rgb":{"r":52,"g":28,"b":2},"luminance":22.625967029057563},{"name":"Powdered Coffee","hex":"#a0450e","rgb":{"r":160,"g":69,"b":14},"luminance":62.7033159011547},{"name":"Powdered Granite","hex":"#c3c9e6","rgb":{"r":195,"g":201,"b":230},"luminance":134.19349311348893},{"name":"Powdered Green Tea","hex":"#c5c56a","rgb":{"r":197,"g":197,"b":106},"luminance":130.33788699376709},{"name":"Powdered Gum","hex":"#a0b0a4","rgb":{"r":160,"g":176,"b":164},"luminance":115.37580058227114},{"name":"Powdered Petals","hex":"#e3c7c6","rgb":{"r":227,"g":199,"b":198},"luminance":136.9726844374454},{"name":"Power Outage","hex":"#332244","rgb":{"r":51,"g":34,"b":68},"luminance":26.285875846164988},{"name":"Power Peony","hex":"#ee5588","rgb":{"r":238,"g":85,"b":136},"luminance":88.28315402725481},{"name":"Powered Rock","hex":"#bbb7ab","rgb":{"r":187,"g":183,"b":171},"luminance":122.66030672552552},{"name":"Practical Tan","hex":"#e1cbb6","rgb":{"r":225,"g":203,"b":182},"luminance":138.40429563420346},{"name":"Pragmatic","hex":"#c2a593","rgb":{"r":194,"g":165,"b":147},"luminance":114.13333266403815},{"name":"Prairie Clay","hex":"#935444","rgb":{"r":147,"g":84,"b":68},"luminance":66.50743249442125},{"name":"Prairie Denim","hex":"#516678","rgb":{"r":81,"g":102,"b":120},"luminance":66.01968067932471},{"name":"Prairie Dog","hex":"#937067","rgb":{"r":147,"g":112,"b":103},"luminance":79.95007385237363},{"name":"Prairie Dune","hex":"#fbd5bd","rgb":{"r":251,"g":213,"b":189},"luminance":147.40872931410811},{"name":"Prairie Dusk","hex":"#cec5ad","rgb":{"r":206,"g":197,"b":173},"luminance":132.49587329800124},{"name":"Prairie Dust","hex":"#b9ab8f","rgb":{"r":185,"g":171,"b":143},"luminance":115.76288938170124},{"name":"Prairie Fire","hex":"#996e5a","rgb":{"r":153,"g":110,"b":90},"luminance":79.79561710394876},{"name":"Prairie Green","hex":"#50a400","rgb":{"r":80,"g":164,"b":0},"luminance":99.19523286932694},{"name":"Prairie Grove","hex":"#8e7d5d","rgb":{"r":142,"g":125,"b":93},"luminance":85.43403767234696},{"name":"Prairie Land","hex":"#e2cc9c","rgb":{"r":226,"g":204,"b":156},"luminance":138.64378686403512},{"name":"Prairie Sage","hex":"#b3a98c","rgb":{"r":179,"g":169,"b":140},"luminance":113.8439908383398},{"name":"Prairie Sand","hex":"#883c32","rgb":{"r":136,"g":60,"b":50},"luminance":54.09712835262145},{"name":"Prairie Sun","hex":"#eea372","rgb":{"r":238,"g":163,"b":114},"luminance":119.9490726141724},{"name":"Prairie Sunset","hex":"#ffbb9e","rgb":{"r":255,"g":187,"b":158},"luminance":134.85905801984526},{"name":"Prairie Winds","hex":"#e8e6d9","rgb":{"r":232,"g":230,"b":217},"luminance":153.79072848517234},{"name":"Praise the Sun","hex":"#f3f4d9","rgb":{"r":243,"g":244,"b":217},"luminance":162.4969792857701},{"name":"Praline","hex":"#ad8b75","rgb":{"r":173,"g":139,"b":117},"luminance":97.52436834965914},{"name":"Prancer","hex":"#c58380","rgb":{"r":197,"g":131,"b":128},"luminance":97.95732990440276},{"name":"Praxeti White","hex":"#01b44c","rgb":{"r":1,"g":180,"b":76},"luminance":106.01504561617656},{"name":"Prayer Flag","hex":"#d59c6a","rgb":{"r":213,"g":156,"b":106},"luminance":112.19397581421204},{"name":"Praying Mantis","hex":"#a5be8f","rgb":{"r":165,"g":190,"b":143},"luminance":123.03917396097877},{"name":"Prcelain Goldfish","hex":"#e1dad9","rgb":{"r":225,"g":218,"b":217},"luminance":146.6737584743774},{"name":"Prcelain Mint","hex":"#dbe7e1","rgb":{"r":219,"g":231,"b":225},"luminance":152.74891250022043},{"name":"Pre School","hex":"#b5c2cd","rgb":{"r":181,"g":194,"b":205},"luminance":128.23112705189797},{"name":"Pre-Raphaelite","hex":"#8b7f7a","rgb":{"r":139,"g":127,"b":122},"luminance":86.47717956779118},{"name":"Precious Blue","hex":"#008389","rgb":{"r":0,"g":131,"b":137},"luminance":78.46700282921478},{"name":"Precious Garnet","hex":"#b7757c","rgb":{"r":183,"g":117,"b":124},"luminance":88.94145055034801},{"name":"Precious Nectar","hex":"#ffde9c","rgb":{"r":255,"g":222,"b":156},"luminance":152.02404177300377},{"name":"Precious Oxley","hex":"#6d9a79","rgb":{"r":109,"g":154,"b":121},"luminance":97.07855644270776},{"name":"Precious Pearls","hex":"#f1f0ef","rgb":{"r":241,"g":240,"b":239},"luminance":160.56780000049824},{"name":"Precious Pink","hex":"#f6b5b6","rgb":{"r":246,"g":181,"b":182},"luminance":130.8781701774593},{"name":"Precision","hex":"#2c3944","rgb":{"r":44,"g":57,"b":68},"luminance":36.7787781335922},{"name":"Precocious Red","hex":"#e8dee3","rgb":{"r":232,"g":222,"b":227},"luminance":149.87771316643446},{"name":"Prediction","hex":"#6d6e7b","rgb":{"r":109,"g":110,"b":123},"luminance":73.67546854279244},{"name":"Prefect","hex":"#5772b0","rgb":{"r":87,"g":114,"b":176},"luminance":74.5470253531286},{"name":"Prehistoric Meteor","hex":"#ee2211","rgb":{"r":238,"g":34,"b":17},"luminance":73.93313094952762},{"name":"Prehistoric Stone","hex":"#9aa0a3","rgb":{"r":154,"g":160,"b":163},"luminance":106.2378992638691},{"name":"Prelude","hex":"#dfebee","rgb":{"r":223,"g":235,"b":238},"luminance":155.59817086971168},{"name":"Preserve","hex":"#4a3c50","rgb":{"r":74,"g":60,"b":80},"luminance":42.58148278301262},{"name":"Presidential","hex":"#3e4d59","rgb":{"r":62,"g":77,"b":89},"luminance":49.89537414430319},{"name":"Presidio Peach","hex":"#ec9580","rgb":{"r":236,"g":149,"b":128},"luminance":113.3224643616613},{"name":"Presidio Plaza","hex":"#bb9174","rgb":{"r":187,"g":145,"b":116},"luminance":102.6922634379046},{"name":"Presley Purple","hex":"#634875","rgb":{"r":99,"g":72,"b":117},"luminance":53.29509490562898},{"name":"Press Agent","hex":"#606b77","rgb":{"r":96,"g":107,"b":119},"luminance":70.37703072025701},{"name":"Pressed Laser Lemon","hex":"#fefe22","rgb":{"r":254,"g":254,"b":34},"luminance":167.37094101426328},{"name":"Prestige Blue","hex":"#303742","rgb":{"r":48,"g":55,"b":66},"luminance":36.123561632264334},{"name":"Prestige Green","hex":"#154647","rgb":{"r":21,"g":70,"b":71},"luminance":42.34768915773327},{"name":"Presumption","hex":"#5e6277","rgb":{"r":94,"g":98,"b":119},"luminance":65.44634648320714},{"name":"Pretencious Peacock","hex":"#4444ff","rgb":{"r":68,"g":68,"b":255},"luminance":53.40170577799926},{"name":"Pretty in Pink","hex":"#fabfe4","rgb":{"r":250,"g":191,"b":228},"luminance":137.23471956104984},{"name":"Pretty in Plum","hex":"#cc5588","rgb":{"r":204,"g":85,"b":136},"luminance":80.31436395191086},{"name":"Pretty Lady","hex":"#c3a1b6","rgb":{"r":195,"g":161,"b":182},"luminance":112.96692249503833},{"name":"Pretty Maiden","hex":"#849457","rgb":{"r":132,"g":148,"b":87},"luminance":95.93502553290949},{"name":"Pretty Pale","hex":"#e3c6d6","rgb":{"r":227,"g":198,"b":214},"luminance":136.78593502622994},{"name":"Pretty Petunia","hex":"#d6b7e2","rgb":{"r":214,"g":183,"b":226},"luminance":127.66073449968866},{"name":"Pretty Pink","hex":"#ebb3b2","rgb":{"r":235,"g":179,"b":178},"luminance":128.020587477171},{"name":"Pretty Please","hex":"#ffccc8","rgb":{"r":255,"g":204,"b":200},"luminance":143.78012216227944},{"name":"Pretty Primrose","hex":"#f5a994","rgb":{"r":245,"g":169,"b":148},"luminance":124.46764486403684},{"name":"Pretty Puce","hex":"#7b6065","rgb":{"r":123,"g":96,"b":101},"luminance":68.26908399121817},{"name":"Priceless Purple","hex":"#46373f","rgb":{"r":70,"g":55,"b":63},"luminance":39.140353204844736},{"name":"Prickly Pear Cactus","hex":"#69916e","rgb":{"r":105,"g":145,"b":110},"luminance":91.5830816799697},{"name":"Prim","hex":"#e2cdd5","rgb":{"r":226,"g":205,"b":213},"luminance":140.12984416247667},{"name":"Primal","hex":"#cba792","rgb":{"r":203,"g":167,"b":146},"luminance":116.49391995293145},{"name":"Primal Green","hex":"#11875d","rgb":{"r":17,"g":135,"b":93},"luminance":80.11247916523368},{"name":"Primary Blue","hex":"#0804f9","rgb":{"r":8,"g":4,"b":249},"luminance":28.58320772761518},{"name":"Primavera","hex":"#6fa77a","rgb":{"r":111,"g":167,"b":122},"luminance":104.42522217357259},{"name":"Prime Blue","hex":"#0064a1","rgb":{"r":0,"g":100,"b":161},"luminance":61.502514712814786},{"name":"Prime Merchandise","hex":"#92b979","rgb":{"r":146,"g":185,"b":121},"luminance":117.85083867754187},{"name":"Prime Pink","hex":"#ff8d86","rgb":{"r":255,"g":141,"b":134},"luminance":113.56510243028004},{"name":"Primitive Plum","hex":"#663c55","rgb":{"r":102,"g":60,"b":85},"luminance":47.586473960569926},{"name":"Primo","hex":"#7cbc6c","rgb":{"r":124,"g":188,"b":108},"luminance":117.06691187521774},{"name":"Primrose","hex":"#d6859f","rgb":{"r":214,"g":133,"b":159},"luminance":102.55652642811182},{"name":"Primrose Garden","hex":"#f3949b","rgb":{"r":243,"g":148,"b":155},"luminance":114.62420305066463},{"name":"Primrose Path","hex":"#ffe262","rgb":{"r":255,"g":226,"b":98},"luminance":153.4187728180616},{"name":"Primrose Pink","hex":"#eed4d9","rgb":{"r":238,"g":212,"b":217},"luminance":145.47270542613825},{"name":"Primrose Yellow","hex":"#f6d155","rgb":{"r":246,"g":209,"b":85},"luminance":143.37086700233073},{"name":"Primula","hex":"#ca9fa5","rgb":{"r":202,"g":159,"b":165},"luminance":112.75097956558959},{"name":"Prince","hex":"#4b384c","rgb":{"r":75,"g":56,"b":76},"luminance":40.72485610778754},{"name":"Prince Royal","hex":"#60606f","rgb":{"r":96,"g":96,"b":111},"luminance":64.49489310015173},{"name":"Princely","hex":"#7d4961","rgb":{"r":125,"g":73,"b":97},"luminance":57.92562636691985},{"name":"Princely Violet","hex":"#6d5c7b","rgb":{"r":109,"g":92,"b":123},"luminance":64.61595608671283},{"name":"Princess Blue","hex":"#00539c","rgb":{"r":0,"g":83,"b":156},"luminance":51.86527255302916},{"name":"Princess Bride","hex":"#f4c1c1","rgb":{"r":244,"g":193,"b":193},"luminance":136.53393944730374},{"name":"Princess Elle","hex":"#f6e9ea","rgb":{"r":246,"g":233,"b":234},"luminance":157.5693699073522},{"name":"Princess Kate","hex":"#6599a4","rgb":{"r":101,"g":153,"b":164},"luminance":96.57916824036123},{"name":"Princess Peach Pink","hex":"#f878f8","rgb":{"r":248,"g":120,"b":248},"luminance":106.11135042020717},{"name":"Princess Perfume","hex":"#ff85cf","rgb":{"r":255,"g":133,"b":207},"luminance":111.64786907953057},{"name":"Princess Pink","hex":"#dfb5b0","rgb":{"r":223,"g":181,"b":176},"luminance":127.03074995448937},{"name":"Princeton Orange","hex":"#ff8f00","rgb":{"r":255,"g":143,"b":0},"luminance":113.39925707869517},{"name":"Priory","hex":"#756f54","rgb":{"r":117,"g":111,"b":84},"luminance":74.57174206091742},{"name":"Prism","hex":"#aadccd","rgb":{"r":170,"g":220,"b":205},"luminance":140.73729214390903},{"name":"Prism Pink","hex":"#f0a1bf","rgb":{"r":240,"g":161,"b":191},"luminance":120.64484126973684},{"name":"Prism Violet","hex":"#53357d","rgb":{"r":83,"g":53,"b":125},"luminance":42.2710339357816},{"name":"Prismatic Springs","hex":"#005c77","rgb":{"r":0,"g":92,"b":119},"luminance":55.68184957416555},{"name":"Prison Jumpsuit","hex":"#fdaa48","rgb":{"r":253,"g":170,"b":72},"luminance":125.49057324357076},{"name":"Pristine","hex":"#f2e8da","rgb":{"r":242,"g":232,"b":218},"luminance":156.20302149446405},{"name":"Pristine Petal","hex":"#d5e1e0","rgb":{"r":213,"g":225,"b":224},"luminance":148.83523403414932},{"name":"Private Eye","hex":"#006e89","rgb":{"r":0,"g":110,"b":137},"luminance":66.43197139931947},{"name":"Private Tone","hex":"#845469","rgb":{"r":132,"g":84,"b":105},"luminance":64.2828343183466},{"name":"Prize Winning Orchid","hex":"#cc9dc6","rgb":{"r":204,"g":157,"b":198},"luminance":112.79755529708964},{"name":"Professor Plum","hex":"#393540","rgb":{"r":57,"g":53,"b":64},"luminance":36.21587754010663},{"name":"Prom","hex":"#daa5aa","rgb":{"r":218,"g":165,"b":170},"luminance":118.34343475241877},{"name":"Prom Corsage","hex":"#e7c3e7","rgb":{"r":231,"g":195,"b":231},"luminance":136.2579999192708},{"name":"Promenade","hex":"#f8f6df","rgb":{"r":248,"g":246,"b":223},"luminance":164.30683123960486},{"name":"Prompt","hex":"#5e7fb5","rgb":{"r":94,"g":127,"b":181},"luminance":82.2998334931487},{"name":"Property","hex":"#4b5667","rgb":{"r":75,"g":86,"b":103},"luminance":56.47289184201567},{"name":"Prophetic Purple","hex":"#624f59","rgb":{"r":98,"g":79,"b":89},"luminance":55.78533542966287},{"name":"Prophetic Sea","hex":"#818b9c","rgb":{"r":129,"g":139,"b":156},"luminance":91.98592471677392},{"name":"Prosciutto","hex":"#e0b4a4","rgb":{"r":224,"g":180,"b":164},"luminance":126.48857889944055},{"name":"Prosecco","hex":"#fad6a5","rgb":{"r":250,"g":214,"b":165},"luminance":147.3813438804247},{"name":"Proton Red","hex":"#840804","rgb":{"r":132,"g":8,"b":4},"luminance":39.74900471709952},{"name":"Protoss Pylon","hex":"#00aaff","rgb":{"r":0,"g":170,"b":255},"luminance":103.93800556100737},{"name":"Provence","hex":"#658dc6","rgb":{"r":101,"g":141,"b":198},"luminance":90.94971728378268},{"name":"Provincial Blue","hex":"#5c798e","rgb":{"r":92,"g":121,"b":142},"luminance":77.86896774068602},{"name":"Provincial Pink","hex":"#f6e3da","rgb":{"r":246,"g":227,"b":218},"luminance":154.2177318631032},{"name":"Prudence","hex":"#d4c6db","rgb":{"r":212,"g":198,"b":219},"luminance":134.72127811151438},{"name":"Prune","hex":"#701c11","rgb":{"r":112,"g":28,"b":17},"luminance":37.354304758621865},{"name":"Prune Plum","hex":"#211640","rgb":{"r":33,"g":22,"b":64},"luminance":17.8146204281764},{"name":"Prune Purple","hex":"#5c3a4d","rgb":{"r":92,"g":58,"b":77},"luminance":44.6416113508462},{"name":"Prunelle","hex":"#220878","rgb":{"r":34,"g":8,"b":120},"luminance":17.678867950182784},{"name":"Prunus Avium","hex":"#dd4492","rgb":{"r":221,"g":68,"b":146},"luminance":78.97305890618647},{"name":"Prussian Blue","hex":"#003366","rgb":{"r":0,"g":51,"b":102},"luminance":32.11595169070971},{"name":"Prussian Nights","hex":"#0b085f","rgb":{"r":11,"g":8,"b":95},"luminance":12.253931491566288},{"name":"Psychedelic Purple","hex":"#dd00ff","rgb":{"r":221,"g":0,"b":255},"luminance":72.19071367565222},{"name":"Psychic","hex":"#625981","rgb":{"r":98,"g":89,"b":129},"luminance":61.678235132013945},{"name":"Pú Táo Zǐ Purple","hex":"#ce5dae","rgb":{"r":206,"g":93,"b":174},"luminance":84.66088242512004},{"name":"Puce","hex":"#cc8899","rgb":{"r":204,"g":136,"b":153},"luminance":101.97001325880073},{"name":"Puddle","hex":"#c8b69e","rgb":{"r":200,"g":182,"b":158},"luminance":123.74964929243232},{"name":"Puddle Jumper","hex":"#6a8389","rgb":{"r":106,"g":131,"b":137},"luminance":84.62611989805511},{"name":"Pueblo","hex":"#6e3326","rgb":{"r":110,"g":51,"b":38},"luminance":44.684922434754206},{"name":"Pueblo Rose","hex":"#e9786e","rgb":{"r":233,"g":120,"b":110},"luminance":99.862586032007},{"name":"Pueblo White","hex":"#e5dfcd","rgb":{"r":229,"g":223,"b":205},"luminance":149.564389284348},{"name":"Puerto Rico","hex":"#59baa3","rgb":{"r":89,"g":186,"b":163},"luminance":113.90410514551263},{"name":"Puff Dragon","hex":"#635940","rgb":{"r":99,"g":89,"b":64},"luminance":60.487865444236},{"name":"Puffball","hex":"#ccbfc9","rgb":{"r":204,"g":191,"b":201},"luminance":129.6756920205171},{"name":"Puffball Vapour","hex":"#e2dadf","rgb":{"r":226,"g":218,"b":223},"luminance":146.92794395893517},{"name":"Puffins Bill","hex":"#e95c20","rgb":{"r":233,"g":92,"b":32},"luminance":88.22262073300702},{"name":"Puffy Little Cloud","hex":"#d7edea","rgb":{"r":215,"g":237,"b":234},"luminance":155.55791963767064},{"name":"Puissant Purple","hex":"#7722cc","rgb":{"r":119,"g":34,"b":204},"luminance":46.95924681039933},{"name":"Pulled Taffy","hex":"#f1d6bc","rgb":{"r":241,"g":214,"b":188},"luminance":146.39573774191652},{"name":"Pullman Brown","hex":"#644117","rgb":{"r":100,"g":65,"b":23},"luminance":48.54574037956368},{"name":"Pullman Green","hex":"#3b331c","rgb":{"r":59,"g":51,"b":28},"luminance":34.894379404138995},{"name":"Pulp","hex":"#e18289","rgb":{"r":225,"g":130,"b":137},"luminance":102.92260999896962},{"name":"Puma","hex":"#96711c","rgb":{"r":150,"g":113,"b":28},"luminance":80.13434298102156},{"name":"Pumice","hex":"#bac0b4","rgb":{"r":186,"g":192,"b":180},"luminance":127.34276191444883},{"name":"Pumice Stone","hex":"#cac2b9","rgb":{"r":202,"g":194,"b":185},"luminance":130.61740078565336},{"name":"Pumpernickel Brown","hex":"#6c462d","rgb":{"r":108,"g":70,"b":45},"luminance":52.5116964494578},{"name":"Pumpkin","hex":"#ff7518","rgb":{"r":255,"g":117,"b":24},"luminance":102.65276792176624},{"name":"Pumpkin Bread","hex":"#d27d46","rgb":{"r":210,"g":125,"b":70},"luminance":96.90281278167316},{"name":"Pumpkin Cream","hex":"#e6c8a9","rgb":{"r":230,"g":200,"b":169},"luminance":137.41634420985008},{"name":"Pumpkin Orange","hex":"#fb7d07","rgb":{"r":251,"g":125,"b":7},"luminance":104.96132540131151},{"name":"Pumpkin Patch","hex":"#d59466","rgb":{"r":213,"g":148,"b":102},"luminance":108.34520630374007},{"name":"Pumpkin Pie","hex":"#e99e56","rgb":{"r":233,"g":158,"b":86},"luminance":116.41060871329555},{"name":"Pumpkin Seed","hex":"#fffdd8","rgb":{"r":255,"g":253,"b":216},"luminance":168.74584001390966},{"name":"Pumpkin Skin","hex":"#b1610b","rgb":{"r":177,"g":97,"b":11},"luminance":77.7461649600802},{"name":"Pumpkin Soup","hex":"#e17701","rgb":{"r":225,"g":119,"b":1},"luminance":96.98133959685232},{"name":"Pumpkin Spice","hex":"#a05c17","rgb":{"r":160,"g":92,"b":23},"luminance":72.19399213230973},{"name":"Punch","hex":"#dc4333","rgb":{"r":220,"g":67,"b":51},"luminance":76.86079128528408},{"name":"Punch of Yellow","hex":"#ecd086","rgb":{"r":236,"g":208,"b":134},"luminance":141.8452237052767},{"name":"Punch Out Glove","hex":"#6888fc","rgb":{"r":104,"g":136,"b":252},"luminance":90.36264396308907},{"name":"Punchit Purple","hex":"#56414d","rgb":{"r":86,"g":65,"b":77},"luminance":46.84087002821361},{"name":"Punctuate","hex":"#856b71","rgb":{"r":133,"g":107,"b":113},"luminance":75.44753603663939},{"name":"Punga","hex":"#534931","rgb":{"r":83,"g":73,"b":49},"luminance":49.83267086962127},{"name":"Punk Rock Pink","hex":"#8811ff","rgb":{"r":136,"g":17,"b":255},"luminance":50.972602807782934},{"name":"Punk Rock Purple","hex":"#bb11aa","rgb":{"r":187,"g":17,"b":170},"luminance":60.01190223613979},{"name":"Puppeteers","hex":"#79ccb3","rgb":{"r":121,"g":204,"b":179},"luminance":126.7474196226495},{"name":"Puppy","hex":"#bcaea0","rgb":{"r":188,"g":174,"b":160},"luminance":118.0027863569331},{"name":"Puppy Love","hex":"#e2babf","rgb":{"r":226,"g":186,"b":191},"luminance":130.23464084489962},{"name":"Pure Apple","hex":"#6ab54b","rgb":{"r":106,"g":181,"b":75},"luminance":111.2026849720815},{"name":"Pure Black","hex":"#595652","rgb":{"r":89,"g":86,"b":82},"luminance":57.82700709011318},{"name":"Pure Blue","hex":"#0203e2","rgb":{"r":2,"g":3,"b":226},"luminance":25.831036003226814},{"name":"Pure Cashmere","hex":"#ada396","rgb":{"r":173,"g":163,"b":150},"luminance":110.1042519160818},{"name":"Pure Hedonist","hex":"#ff2255","rgb":{"r":255,"g":34,"b":85},"luminance":79.40729115767644},{"name":"Pure Purple","hex":"#751973","rgb":{"r":117,"g":25,"b":115},"luminance":40.137738027945716},{"name":"Pure Red","hex":"#d22d1d","rgb":{"r":210,"g":45,"b":29},"luminance":68.20019032964645},{"name":"Pure Zeal","hex":"#615753","rgb":{"r":97,"g":87,"b":83},"luminance":59.48736180063795},{"name":"Purebred","hex":"#67707d","rgb":{"r":103,"g":112,"b":125},"luminance":73.98507447451817},{"name":"Pureed Pumpkin","hex":"#c34121","rgb":{"r":195,"g":65,"b":33},"luminance":69.7812990277481},{"name":"Purehearted","hex":"#e66771","rgb":{"r":230,"g":103,"b":113},"luminance":92.47048904920963},{"name":"Purification","hex":"#c3dce9","rgb":{"r":195,"g":220,"b":233},"luminance":144.16016255887058},{"name":"Puritan Grey","hex":"#a8b0ae","rgb":{"r":168,"g":176,"b":174},"luminance":116.57654165397084},{"name":"Purity","hex":"#d7c9e3","rgb":{"r":215,"g":201,"b":227},"luminance":136.83261408743164},{"name":"Purple","hex":"#800080","rgb":{"r":128,"g":0,"b":128},"luminance":40.9593999956054},{"name":"Purple Agate","hex":"#988eb4","rgb":{"r":152,"g":142,"b":180},"luminance":97.13125356959004},{"name":"Purple Amethyst","hex":"#9190ba","rgb":{"r":145,"g":144,"b":186},"luminance":97.33575101164011},{"name":"Purple Anemone","hex":"#8866ff","rgb":{"r":136,"g":102,"b":255},"luminance":77.99693373460266},{"name":"Purple Anxiety","hex":"#c20078","rgb":{"r":194,"g":0,"b":120},"luminance":59.59730225438061},{"name":"Purple Ash","hex":"#8f8395","rgb":{"r":143,"g":131,"b":149},"luminance":89.60934021629664},{"name":"Purple Balance","hex":"#9d9eb4","rgb":{"r":157,"g":158,"b":180},"luminance":105.9553498649313},{"name":"Purple Basil","hex":"#5c4450","rgb":{"r":92,"g":68,"b":80},"luminance":49.326985717758994},{"name":"Purple Berry","hex":"#4c4a74","rgb":{"r":76,"g":74,"b":116},"luminance":50.7751336384258},{"name":"Purple Blue","hex":"#661aee","rgb":{"r":102,"g":26,"b":238},"luminance":43.57983561235632},{"name":"Purple Brown","hex":"#673a3f","rgb":{"r":103,"g":58,"b":63},"luminance":46.46683170821957},{"name":"Purple cabbage","hex":"#3d34a5","rgb":{"r":61,"g":52,"b":165},"luminance":40.2267547410924},{"name":"Purple Chalk","hex":"#c4adc9","rgb":{"r":196,"g":173,"b":201},"luminance":119.46583533797434},{"name":"Purple Climax","hex":"#8800ff","rgb":{"r":136,"g":0,"b":255},"luminance":49.986256071044174},{"name":"Purple Comet","hex":"#6e6970","rgb":{"r":110,"g":105,"b":112},"luminance":71.01863944768303},{"name":"Purple Corallite","hex":"#5a4e8f","rgb":{"r":90,"g":78,"b":143},"luminance":55.554127659427785},{"name":"Purple Cort","hex":"#593c50","rgb":{"r":89,"g":60,"b":80},"luminance":45.07513861320895},{"name":"Purple Crystal","hex":"#e7e7eb","rgb":{"r":231,"g":231,"b":235},"luminance":154.51465066458906},{"name":"Purple Daze","hex":"#63647e","rgb":{"r":99,"g":100,"b":126},"luminance":67.29215182322527},{"name":"Purple Door","hex":"#331144","rgb":{"r":51,"g":17,"b":68},"luminance":19.804190112195954},{"name":"Purple Dove","hex":"#98878c","rgb":{"r":152,"g":135,"b":140},"luminance":92.73625142844625},{"name":"Purple Dragon","hex":"#c6bedd","rgb":{"r":198,"g":190,"b":221},"luminance":128.75773895187814},{"name":"Purple Dreamer","hex":"#660066","rgb":{"r":102,"g":0,"b":102},"luminance":32.639521871498054},{"name":"Purple Dusk","hex":"#7c6b76","rgb":{"r":124,"g":107,"b":118},"luminance":74.16573710953057},{"name":"Purple Empire","hex":"#5a4d55","rgb":{"r":90,"g":77,"b":85},"luminance":53.488258533999776},{"name":"Purple Emulsion","hex":"#eadce2","rgb":{"r":234,"g":220,"b":226},"luminance":149.11795482771348},{"name":"Purple Essence","hex":"#c2b1c8","rgb":{"r":194,"g":177,"b":200},"luminance":121.15914425663462},{"name":"Purple Feather","hex":"#594670","rgb":{"r":89,"g":70,"b":112},"luminance":50.59204725053138},{"name":"Purple Grapes","hex":"#736993","rgb":{"r":115,"g":105,"b":147},"luminance":72.53986499849583},{"name":"Purple Grey","hex":"#866f85","rgb":{"r":134,"g":111,"b":133},"luminance":77.97823573921123},{"name":"Purple Gumball","hex":"#6a6283","rgb":{"r":106,"g":98,"b":131},"luminance":67.35558379228851},{"name":"Purple Gumdrop","hex":"#7a596f","rgb":{"r":122,"g":89,"b":111},"luminance":64.96229097715073},{"name":"Purple Haze","hex":"#807396","rgb":{"r":128,"g":115,"b":150},"luminance":79.46119184230753},{"name":"Purple Heart","hex":"#69359c","rgb":{"r":105,"g":53,"b":156},"luminance":47.642533538845306},{"name":"Purple Heart Kiwi","hex":"#cc2288","rgb":{"r":204,"g":34,"b":136},"luminance":66.02429701253925},{"name":"Purple Heather","hex":"#bab8d3","rgb":{"r":186,"g":184,"b":211},"luminance":123.84361096156717},{"name":"Purple Hedonist","hex":"#aa66ff","rgb":{"r":170,"g":102,"b":255},"luminance":83.7475353428386},{"name":"Purple Hepatica","hex":"#ccaaff","rgb":{"r":204,"g":170,"b":255},"luminance":120.51398680651137},{"name":"Purple Illusion","hex":"#b8b8f8","rgb":{"r":184,"g":184,"b":248},"luminance":124.46603674898627},{"name":"Purple Illusionist","hex":"#a675fe","rgb":{"r":166,"g":117,"b":254},"luminance":89.54769083008227},{"name":"Purple Impression","hex":"#858fb1","rgb":{"r":133,"g":143,"b":177},"luminance":95.05081511486368},{"name":"Purple Ink","hex":"#9a2ca0","rgb":{"r":154,"g":44,"b":160},"luminance":55.85711503470261},{"name":"Purple Kasbah","hex":"#73626f","rgb":{"r":115,"g":98,"b":111},"luminance":68.20331822572858},{"name":"Purple Kite","hex":"#512c31","rgb":{"r":81,"g":44,"b":49},"luminance":35.844789593468114},{"name":"Purple Kush","hex":"#cc77cc","rgb":{"r":204,"g":119,"b":204},"luminance":95.60750577752773},{"name":"Purple Lepidolite","hex":"#b88aac","rgb":{"r":184,"g":138,"b":172},"luminance":99.86593991947404},{"name":"Purple Magic","hex":"#663271","rgb":{"r":102,"g":50,"b":113},"luminance":44.24360324385888},{"name":"Purple Mountain Majesty","hex":"#7a70a8","rgb":{"r":122,"g":112,"b":168},"luminance":77.58683602261404},{"name":"Purple Mountains Majesty","hex":"#9678b6","rgb":{"r":150,"g":120,"b":182},"luminance":86.04531134233869},{"name":"Purple Mountains’ Majesty","hex":"#9d81ba","rgb":{"r":157,"g":129,"b":186},"luminance":91.5818082044682},{"name":"Purple Mystery","hex":"#815989","rgb":{"r":129,"g":89,"b":137},"luminance":66.79053087077538},{"name":"Purple Navy","hex":"#4e5180","rgb":{"r":78,"g":81,"b":128},"luminance":54.932316144506416},{"name":"Purple Odyssey","hex":"#643e65","rgb":{"r":100,"g":62,"b":101},"luminance":48.48819889416393},{"name":"Purple Opulence","hex":"#60569a","rgb":{"r":96,"g":86,"b":154},"luminance":60.66766087463732},{"name":"Purple Orchid","hex":"#ad4d8c","rgb":{"r":173,"g":77,"b":140},"luminance":70.52200883412213},{"name":"Purple Passion","hex":"#683d62","rgb":{"r":104,"g":61,"b":98},"luminance":48.72284935222898},{"name":"Purple Pennant","hex":"#432c47","rgb":{"r":67,"g":44,"b":71},"luminance":33.67372134172283},{"name":"Purple People Eater","hex":"#5b4763","rgb":{"r":91,"g":71,"b":99},"luminance":51.03602459047922},{"name":"Purple Peril","hex":"#903f75","rgb":{"r":144,"g":63,"b":117},"luminance":58.30365118069364},{"name":"Purple Pink","hex":"#c83cb9","rgb":{"r":200,"g":60,"b":185},"luminance":72.53465723362866},{"name":"Purple Pizzazz","hex":"#fe4eda","rgb":{"r":254,"g":78,"b":218},"luminance":92.09655051086332},{"name":"Purple Pj's","hex":"#c7cee8","rgb":{"r":199,"g":206,"b":232},"luminance":137.33898131630363},{"name":"Purple Plum","hex":"#9c51b6","rgb":{"r":156,"g":81,"b":182},"luminance":69.76288016560096},{"name":"Purple Plumeria","hex":"#473854","rgb":{"r":71,"g":56,"b":84},"luminance":40.285712119807435},{"name":"Purple Poodle","hex":"#dab4cc","rgb":{"r":218,"g":180,"b":204},"luminance":126.30744340695048},{"name":"Purple Pool","hex":"#4c4976","rgb":{"r":76,"g":73,"b":118},"luminance":50.33432905085753},{"name":"Purple Potion","hex":"#aa00aa","rgb":{"r":170,"g":0,"b":170},"luminance":54.399203119163424},{"name":"Purple Premiere","hex":"#b9a0d2","rgb":{"r":185,"g":160,"b":210},"luminance":111.59677067460329},{"name":"Purple Pride","hex":"#a274b5","rgb":{"r":162,"g":116,"b":181},"luminance":86.072773070234},{"name":"Purple Prince","hex":"#5b4d54","rgb":{"r":91,"g":77,"b":84},"luminance":53.61883118830547},{"name":"Purple Prophet","hex":"#bb9eca","rgb":{"r":187,"g":158,"b":202},"luminance":110.71753641135626},{"name":"Purple Prose","hex":"#554348","rgb":{"r":85,"g":67,"b":72},"luminance":47.54012757660627},{"name":"Purple Punch","hex":"#696374","rgb":{"r":105,"g":99,"b":116},"luminance":67.36201429589231},{"name":"Purple Ragwort","hex":"#8c8798","rgb":{"r":140,"g":135,"b":152},"luminance":91.28137383387697},{"name":"Purple Rain","hex":"#7442c8","rgb":{"r":116,"g":66,"b":200},"luminance":56.77818612812494},{"name":"Purple Red","hex":"#990147","rgb":{"r":153,"g":1,"b":71},"luminance":46.46122484394917},{"name":"Purple Reign","hex":"#56456b","rgb":{"r":86,"g":69,"b":107},"luminance":49.50246467601386},{"name":"Purple Rhapsody","hex":"#8278ad","rgb":{"r":130,"g":120,"b":173},"luminance":82.83494301319945},{"name":"Purple Rose","hex":"#b09fca","rgb":{"r":176,"g":159,"b":202},"luminance":109.59298813792788},{"name":"Purple Sage","hex":"#75697e","rgb":{"r":117,"g":105,"b":126},"luminance":72.31188014427505},{"name":"Purple Sand","hex":"#c2b2f0","rgb":{"r":194,"g":178,"b":240},"luminance":122.59930600129839},{"name":"Purple Sapphire","hex":"#6f4685","rgb":{"r":111,"g":70,"b":133},"luminance":54.95256195119568},{"name":"Purple Shade","hex":"#4e2e53","rgb":{"r":78,"g":46,"b":83},"luminance":36.91277735418997},{"name":"Purple Shine","hex":"#c8bad4","rgb":{"r":200,"g":186,"b":212},"luminance":126.81025726651609},{"name":"Purple Snail","hex":"#cc69e4","rgb":{"r":204,"g":105,"b":228},"luminance":90.52606975341412},{"name":"Purple Sphinx","hex":"#563948","rgb":{"r":86,"g":57,"b":72},"luminance":42.9893677669258},{"name":"Purple Spot","hex":"#652dc1","rgb":{"r":101,"g":45,"b":193},"luminance":45.75827608203788},{"name":"Purple Springs","hex":"#ab9bbc","rgb":{"r":171,"g":155,"b":188},"luminance":106.54471122491252},{"name":"Purple Squid","hex":"#845998","rgb":{"r":132,"g":89,"b":152},"luminance":67.72971029762344},{"name":"Purple Starburst","hex":"#b16d90","rgb":{"r":177,"g":109,"b":144},"luminance":84.64132131530083},{"name":"Purple Statement","hex":"#6e5755","rgb":{"r":110,"g":87,"b":85},"luminance":61.5117140144867},{"name":"Purple Statice","hex":"#a885b5","rgb":{"r":168,"g":133,"b":181},"luminance":95.10045647103908},{"name":"Purple Stone","hex":"#605467","rgb":{"r":96,"g":84,"b":103},"luminance":58.25009050636746},{"name":"Purple Surf","hex":"#9b95a9","rgb":{"r":155,"g":149,"b":169},"luminance":100.84053822744104},{"name":"Purple Tanzanite","hex":"#835995","rgb":{"r":131,"g":89,"b":149},"luminance":67.4689988513243},{"name":"Purple Taupe","hex":"#50404d","rgb":{"r":80,"g":64,"b":77},"luminance":45.39354918928459},{"name":"Purple Thorn","hex":"#f0b9be","rgb":{"r":240,"g":185,"b":190},"luminance":131.95274618210868},{"name":"Purple Tone Ink","hex":"#a22da4","rgb":{"r":162,"g":45,"b":164},"luminance":58.254034066320244},{"name":"Purple Trinket","hex":"#665261","rgb":{"r":102,"g":82,"b":97},"luminance":58.04557971112012},{"name":"Purple Urn Orchid","hex":"#c364c5","rgb":{"r":195,"g":100,"b":197},"luminance":85.72936946577876},{"name":"Purple Vanity","hex":"#9932cc","rgb":{"r":153,"g":50,"b":204},"luminance":59.11896518884612},{"name":"Purple Velvet","hex":"#41354d","rgb":{"r":65,"g":53,"b":77},"luminance":37.71825592468453},{"name":"Purple Verbena","hex":"#46354b","rgb":{"r":70,"g":53,"b":75},"luminance":38.45857148933121},{"name":"Purple Wine","hex":"#8c3573","rgb":{"r":140,"g":53,"b":115},"luminance":53.77756057130148},{"name":"Purple Wineberry","hex":"#5a395b","rgb":{"r":90,"g":57,"b":91},"luminance":44.17321198418788},{"name":"Purple Zergling","hex":"#a15589","rgb":{"r":161,"g":85,"b":137},"luminance":71.06895433309822},{"name":"Purplish","hex":"#98568d","rgb":{"r":152,"g":86,"b":141},"luminance":69.80205229074572},{"name":"Purplish Blue","hex":"#6140ef","rgb":{"r":97,"g":64,"b":239},"luminance":54.72543420567808},{"name":"Purplish Brown","hex":"#6b4247","rgb":{"r":107,"g":66,"b":71},"luminance":50.89211578427448},{"name":"Purplish Grey","hex":"#7a687f","rgb":{"r":122,"g":104,"b":127},"luminance":72.57489422658499},{"name":"Purplish Pink","hex":"#df4ec8","rgb":{"r":223,"g":78,"b":200},"luminance":84.03582643729993},{"name":"Purplish Red","hex":"#b0054b","rgb":{"r":176,"g":5,"b":75},"luminance":53.39477597106293},{"name":"Purplish White","hex":"#dfd3e3","rgb":{"r":223,"g":211,"b":227},"luminance":143.02464704378752},{"name":"Purposeful","hex":"#776c76","rgb":{"r":119,"g":108,"b":118},"luminance":73.93251436952485},{"name":"Purpura","hex":"#8d8485","rgb":{"r":141,"g":132,"b":133},"luminance":89.50440090297236},{"name":"Purpureus","hex":"#9a4eae","rgb":{"r":154,"g":78,"b":174},"luminance":67.8974138535482},{"name":"Purri Sticks","hex":"#898078","rgb":{"r":137,"g":128,"b":120},"luminance":86.66330402771405},{"name":"Purslane","hex":"#879f6c","rgb":{"r":135,"g":159,"b":108},"luminance":102.43030536906545},{"name":"Pussy Foot","hex":"#cebada","rgb":{"r":206,"g":186,"b":218},"luminance":127.79730773377034},{"name":"Pussywillow Grey","hex":"#aeaca1","rgb":{"r":174,"g":172,"b":161},"luminance":115.05348012120277},{"name":"Put on Ice","hex":"#c8ddea","rgb":{"r":200,"g":221,"b":234},"luminance":145.316012555396},{"name":"Putnam Plum","hex":"#8d4362","rgb":{"r":141,"g":67,"b":98},"luminance":58.727890358840575},{"name":"Putrid Green","hex":"#89a572","rgb":{"r":137,"g":165,"b":114},"luminance":105.96109856923907},{"name":"Putting Green","hex":"#3a9234","rgb":{"r":58,"g":146,"b":52},"luminance":87.63971104470849},{"name":"Putty","hex":"#cdae70","rgb":{"r":205,"g":174,"b":112},"luminance":119.80095948280213},{"name":"Putty Pearl","hex":"#a99891","rgb":{"r":169,"g":152,"b":145},"luminance":103.86310719885093},{"name":"Puturple","hex":"#ada2ce","rgb":{"r":173,"g":162,"b":206},"luminance":110.7702560302178},{"name":"Puyo Blob Green","hex":"#55ff55","rgb":{"r":85,"g":255,"b":85},"luminance":152.1361809366858},{"name":"Pygmy Goat","hex":"#d6d0cf","rgb":{"r":214,"g":208,"b":207},"luminance":139.85173225956123},{"name":"Pylon","hex":"#9fbadf","rgb":{"r":159,"g":186,"b":223},"luminance":121.7667191354025},{"name":"Pyramid","hex":"#9f7d4f","rgb":{"r":159,"g":125,"b":79},"luminance":87.89280597409551},{"name":"Pyrite Gold","hex":"#ac9362","rgb":{"r":172,"g":147,"b":98},"luminance":101.07148108640735},{"name":"Python Blue","hex":"#3776ab","rgb":{"r":55,"g":118,"b":171},"luminance":73.81214545723488},{"name":"Python Yellow","hex":"#ffd343","rgb":{"r":255,"g":211,"b":67},"luminance":145.6440713451804},{"name":"Qahvei Brown","hex":"#7b5804","rgb":{"r":123,"g":88,"b":4},"luminance":63.412128185387374},{"name":"Qermez Red","hex":"#cf3c71","rgb":{"r":207,"g":60,"b":113},"luminance":72.3680715025625},{"name":"Qiān Hūi Grey","hex":"#89a0b0","rgb":{"r":137,"g":160,"b":176},"luminance":104.41023831502348},{"name":"Qing Dynasty Dragon","hex":"#4455ee","rgb":{"r":68,"g":85,"b":238},"luminance":60.32451137804599},{"name":"Qing Dynasty Fire","hex":"#dd2266","rgb":{"r":221,"g":34,"b":102},"luminance":69.99975992101686},{"name":"Qing Yellow","hex":"#ffcc66","rgb":{"r":255,"g":204,"b":102},"luminance":142.43628018521125},{"name":"Quack Quack","hex":"#ffe989","rgb":{"r":255,"g":233,"b":137},"luminance":157.36431739755997},{"name":"Quagmire Green","hex":"#998811","rgb":{"r":153,"g":136,"b":17},"luminance":92.03093000182058},{"name":"Quail","hex":"#98868c","rgb":{"r":152,"g":134,"b":140},"luminance":92.23515201917326},{"name":"Quail Valley","hex":"#ab9673","rgb":{"r":171,"g":150,"b":115},"luminance":102.65889752476401},{"name":"Quaking Grass","hex":"#bbc6a4","rgb":{"r":187,"g":198,"b":164},"luminance":130.32377780359192},{"name":"Quantum Blue","hex":"#6e799b","rgb":{"r":110,"g":121,"b":155},"luminance":80.24223158038416},{"name":"Quantum of Light","hex":"#130173","rgb":{"r":19,"g":1,"b":115},"luminance":14.300015034957132},{"name":"Quarry","hex":"#98a0a5","rgb":{"r":152,"g":160,"b":165},"luminance":106.02029618898449},{"name":"Quarry Quartz","hex":"#af9a91","rgb":{"r":175,"g":154,"b":145},"luminance":105.74944410728597},{"name":"Quarter Pearl Lusta","hex":"#f2eddd","rgb":{"r":242,"g":237,"b":221},"luminance":158.8222716151611},{"name":"Quarter Spanish White","hex":"#ebe2d2","rgb":{"r":235,"g":226,"b":210},"luminance":152.0180912556134},{"name":"Quarterdeck","hex":"#1272a3","rgb":{"r":18,"g":114,"b":163},"luminance":69.65827568925317},{"name":"Quartz","hex":"#d9d9f3","rgb":{"r":217,"g":217,"b":243},"luminance":145.61117448190575},{"name":"Quartz Pink","hex":"#efa6aa","rgb":{"r":239,"g":166,"b":170},"luminance":122.38138046696483},{"name":"Quartz Sand","hex":"#a9aaab","rgb":{"r":169,"g":170,"b":171},"luminance":113.54048659839361},{"name":"Quartzite","hex":"#232e26","rgb":{"r":35,"g":46,"b":38},"luminance":29.281230387400047},{"name":"Quaver","hex":"#bed3cb","rgb":{"r":190,"g":211,"b":203},"luminance":138.215356285038},{"name":"Queen Anne's Lace","hex":"#f2eede","rgb":{"r":242,"g":238,"b":222},"luminance":159.35476605360756},{"name":"Queen Blue","hex":"#436b95","rgb":{"r":67,"g":107,"b":149},"luminance":68.07948124067926},{"name":"Queen Conch Shell","hex":"#e8bc95","rgb":{"r":232,"g":188,"b":149},"luminance":131.44919305952394},{"name":"Queen of Hearts","hex":"#98333a","rgb":{"r":152,"g":51,"b":58},"luminance":54.822105185773374},{"name":"Queen Palm","hex":"#ad9e4b","rgb":{"r":173,"g":158,"b":75},"luminance":106.53922068890874},{"name":"Queen Pink","hex":"#e8ccd7","rgb":{"r":232,"g":204,"b":215},"luminance":140.5426733344716},{"name":"Queen Valley","hex":"#6c7068","rgb":{"r":108,"g":112,"b":104},"luminance":74.19980819382218},{"name":"Queen's","hex":"#7b6fa0","rgb":{"r":123,"g":111,"b":160},"luminance":77.01090817540071},{"name":"Queen's Honour","hex":"#8b5776","rgb":{"r":139,"g":87,"b":118},"luminance":67.20353998116468},{"name":"Queer Blue","hex":"#88ace0","rgb":{"r":136,"g":172,"b":224},"luminance":111.80061488203006},{"name":"Queer Purple","hex":"#b36ff6","rgb":{"r":179,"g":111,"b":246},"luminance":88.86167917612181},{"name":"Quest","hex":"#bdc1c1","rgb":{"r":189,"g":193,"b":193},"luminance":128.5007074143952},{"name":"Question Mark Block","hex":"#ef9a49","rgb":{"r":239,"g":154,"b":73},"luminance":115.53237039462142},{"name":"Quetzal Green","hex":"#006865","rgb":{"r":0,"g":104,"b":101},"luminance":62.12431488555829},{"name":"Quibble","hex":"#b393c0","rgb":{"r":179,"g":147,"b":192},"luminance":103.87190912850308},{"name":"Quicksand","hex":"#ac9884","rgb":{"r":172,"g":152,"b":132},"luminance":104.07787307588487},{"name":"Quicksilver","hex":"#a6a6a6","rgb":{"r":166,"g":166,"b":166},"luminance":110.98015631634331},{"name":"Quiet Bay","hex":"#6597cc","rgb":{"r":101,"g":151,"b":204},"luminance":96.48491543241357},{"name":"Quiet Drizzle","hex":"#b7d0c5","rgb":{"r":183,"g":208,"b":197},"luminance":135.66777461504998},{"name":"Quiet Green","hex":"#9ebc97","rgb":{"r":158,"g":188,"b":151},"luminance":121.27066873733317},{"name":"Quiet Grey","hex":"#b9babd","rgb":{"r":185,"g":186,"b":189},"luminance":124.27666098266398},{"name":"Quiet Harbour","hex":"#5a789a","rgb":{"r":90,"g":120,"b":154},"luminance":77.42192735911449},{"name":"Quiet Night","hex":"#3e8fbc","rgb":{"r":62,"g":143,"b":188},"luminance":88.59503117556875},{"name":"Quiet Pink","hex":"#dba39a","rgb":{"r":219,"g":163,"b":154},"luminance":117.26392564638113},{"name":"Quiet Rain","hex":"#e7efcf","rgb":{"r":231,"g":239,"b":207},"luminance":158.14397937955144},{"name":"Quiet Shade","hex":"#66676d","rgb":{"r":102,"g":103,"b":109},"luminance":68.84813723696524},{"name":"Quiet Splendor","hex":"#fae6ca","rgb":{"r":250,"g":230,"b":202},"luminance":156.03061040706083},{"name":"Quill Grey","hex":"#cbc9c0","rgb":{"r":203,"g":201,"b":192},"luminance":134.47729370417892},{"name":"Quill Tip","hex":"#2d3359","rgb":{"r":45,"g":51,"b":89},"luminance":34.354072684326674},{"name":"Quills of Terico","hex":"#612741","rgb":{"r":97,"g":39,"b":65},"luminance":37.685163632389866},{"name":"Quilotoa Blue","hex":"#7f9daf","rgb":{"r":127,"g":157,"b":175},"luminance":101.65250862620164},{"name":"Quilotoa Green","hex":"#70a38d","rgb":{"r":112,"g":163,"b":141},"luminance":102.63855699005126},{"name":"Quilt","hex":"#fcd9c6","rgb":{"r":252,"g":217,"b":198},"luminance":149.70713386141622},{"name":"Quinacridone Magenta","hex":"#8e3a59","rgb":{"r":142,"g":58,"b":89},"luminance":55.36021311375165},{"name":"Quince Jelly","hex":"#f89330","rgb":{"r":248,"g":147,"b":48},"luminance":113.90458028104051},{"name":"Quincy","hex":"#6a5445","rgb":{"r":106,"g":84,"b":69},"luminance":59.14103867873813},{"name":"Quinoa","hex":"#f9ecd1","rgb":{"r":249,"g":236,"b":209},"luminance":159.06522153192378},{"name":"Quinoline Yellow","hex":"#f5e326","rgb":{"r":245,"g":227,"b":38},"luminance":152.11954920390738},{"name":"Quintana","hex":"#008ca9","rgb":{"r":0,"g":140,"b":169},"luminance":84.40812257123125},{"name":"Quintessential","hex":"#c2dbc6","rgb":{"r":194,"g":219,"b":198},"luminance":142.82879621770954},{"name":"Quithayran Green","hex":"#9be510","rgb":{"r":155,"g":229,"b":16},"luminance":142.19960945797285},{"name":"Quiver","hex":"#886037","rgb":{"r":136,"g":96,"b":55},"luminance":69.77407613146877},{"name":"Quixotic","hex":"#948491","rgb":{"r":148,"g":132,"b":145},"luminance":90.7482818570137},{"name":"Rabbit","hex":"#5f575c","rgb":{"r":95,"g":87,"b":92},"luminance":59.370741363065356},{"name":"Rabbit Paws","hex":"#885d62","rgb":{"r":136,"g":93,"b":98},"luminance":68.982256856383},{"name":"Rabbit-Ear Iris","hex":"#491e3c","rgb":{"r":73,"g":30,"b":60},"luminance":28.867206809804095},{"name":"Raccoon Tail","hex":"#735e56","rgb":{"r":115,"g":94,"b":86},"luminance":65.7499682509429},{"name":"Race the Sun","hex":"#eef3d0","rgb":{"r":238,"g":243,"b":208},"luminance":161.16061575025083},{"name":"Racing Green","hex":"#014600","rgb":{"r":1,"g":70,"b":0},"luminance":41.09108785369401},{"name":"Racing Red","hex":"#bd162c","rgb":{"r":189,"g":22,"b":44},"luminance":58.184403176452705},{"name":"Rackham Red","hex":"#d6341e","rgb":{"r":214,"g":52,"b":30},"luminance":70.97618735886002},{"name":"Rackley","hex":"#5d8aaa","rgb":{"r":93,"g":138,"b":170},"luminance":87.81107951164249},{"name":"Racoon Eyes","hex":"#776a3c","rgb":{"r":119,"g":106,"b":60},"luminance":72.00257248876598},{"name":"Radar","hex":"#b6c8e4","rgb":{"r":182,"g":200,"b":228},"luminance":131.98357014416604},{"name":"Radar Blip Green","hex":"#96f97b","rgb":{"r":150,"g":249,"b":123},"luminance":153.53097913124893},{"name":"Radiant Glow","hex":"#ffeed2","rgb":{"r":255,"g":238,"b":210},"luminance":160.94778675396563},{"name":"Radiant Orchid","hex":"#ad5e99","rgb":{"r":173,"g":94,"b":153},"luminance":77.61776585937011},{"name":"Radiant Rouge","hex":"#d7b1b2","rgb":{"r":215,"g":177,"b":178},"luminance":123.85204354389958},{"name":"Radiant Sunrise","hex":"#eebe1b","rgb":{"r":238,"g":190,"b":27},"luminance":132.33459573369313},{"name":"Radiant Yellow","hex":"#fc9e21","rgb":{"r":252,"g":158,"b":33},"luminance":119.55456605249336},{"name":"Radiation Carrot","hex":"#ffa343","rgb":{"r":255,"g":163,"b":67},"luminance":122.58259595064872},{"name":"Radical Red","hex":"#ff355e","rgb":{"r":255,"g":53,"b":94},"luminance":83.04232054801936},{"name":"Radioactive","hex":"#89fe05","rgb":{"r":137,"g":254,"b":5},"luminance":154.62375584948128},{"name":"Radioactive Eggplant","hex":"#f9006f","rgb":{"r":249,"g":0,"b":111},"luminance":75.51870706652755},{"name":"Radioactive Green","hex":"#2cfa1f","rgb":{"r":44,"g":250,"b":31},"luminance":147.38090782730305},{"name":"Radish Lips","hex":"#ee3355","rgb":{"r":238,"g":51,"b":85},"luminance":77.80842057900931},{"name":"Radisson","hex":"#e5e7e6","rgb":{"r":229,"g":231,"b":230},"luminance":154.1502924097129},{"name":"Radium","hex":"#7fff00","rgb":{"r":127,"g":255,"b":0},"luminance":154.42651311869992},{"name":"Radler","hex":"#ffd15c","rgb":{"r":255,"g":209,"b":92},"luminance":144.82546964536314},{"name":"Radome Tan","hex":"#f1c7a1","rgb":{"r":241,"g":199,"b":161},"luminance":138.47254517051385},{"name":"Raffia","hex":"#dcc6a0","rgb":{"r":220,"g":198,"b":160},"luminance":134.78942494127645},{"name":"Raffia Cream","hex":"#cda09a","rgb":{"r":205,"g":160,"b":154},"luminance":113.51764867631816},{"name":"Raffles Tan","hex":"#ca9a5d","rgb":{"r":202,"g":154,"b":93},"luminance":109.23424010812727},{"name":"Raftsman","hex":"#3c5f9b","rgb":{"r":60,"g":95,"b":155},"luminance":61.18666296669561},{"name":"Rage","hex":"#ff1133","rgb":{"r":255,"g":17,"b":51},"luminance":77.1147395897827},{"name":"Rage of Quel'Danas","hex":"#f32507","rgb":{"r":243,"g":37,"b":7},"luminance":75.83792859776696},{"name":"Ragin' Cajun","hex":"#8d514c","rgb":{"r":141,"g":81,"b":76},"luminance":64.13394877909826},{"name":"Raging Raisin","hex":"#aa3333","rgb":{"r":170,"g":51,"b":51},"luminance":59.276601328011374},{"name":"Raging Tide","hex":"#5187a0","rgb":{"r":81,"g":135,"b":160},"luminance":84.84708354445661},{"name":"Ragtime Blues","hex":"#4a5e6c","rgb":{"r":74,"g":94,"b":108},"luminance":60.71043488561089},{"name":"Railroad Ties","hex":"#544540","rgb":{"r":84,"g":69,"b":64},"luminance":48.213463690135356},{"name":"Rain Barrel","hex":"#8b795f","rgb":{"r":139,"g":121,"b":95},"luminance":83.00265266845392},{"name":"Rain Check","hex":"#b6d5de","rgb":{"r":182,"g":213,"b":222},"luminance":138.6887325956943},{"name":"Rain Cloud","hex":"#919fa1","rgb":{"r":145,"g":159,"b":161},"luminance":104.53503828860445},{"name":"Rain Dance","hex":"#a9ccdb","rgb":{"r":169,"g":204,"b":219},"luminance":132.349033320988},{"name":"Rain Drop","hex":"#e7eee8","rgb":{"r":231,"g":238,"b":232},"luminance":158.07526656944154},{"name":"Rain Drum","hex":"#5f4c40","rgb":{"r":95,"g":76,"b":64},"luminance":53.38825886840663},{"name":"Rain or Shine","hex":"#b5dcea","rgb":{"r":181,"g":220,"b":234},"luminance":142.53987069237854},{"name":"Rainbow","hex":"#f6bfbc","rgb":{"r":246,"g":191,"b":188},"luminance":135.7930161274872},{"name":"Rainbow Bright","hex":"#2863ad","rgb":{"r":40,"g":99,"b":173},"luminance":62.52295300927492},{"name":"Rainbow Trout","hex":"#ff975c","rgb":{"r":255,"g":151,"b":92},"luminance":117.38746073580431},{"name":"Rainbow's Inner Rim","hex":"#ff09ff","rgb":{"r":255,"g":9,"b":255},"luminance":81.76964604301524},{"name":"Rainbow's Outer Rim","hex":"#ff0001","rgb":{"r":255,"g":0,"b":1},"luminance":76.24508522521303},{"name":"Raindrops","hex":"#ece5e1","rgb":{"r":236,"g":229,"b":225},"luminance":153.96994357666043},{"name":"Rainee","hex":"#b3c1b1","rgb":{"r":179,"g":193,"b":177},"luminance":126.91138564368447},{"name":"Rainford","hex":"#759180","rgb":{"r":117,"g":145,"b":128},"luminance":93.17349396690025},{"name":"Rainforest","hex":"#009a70","rgb":{"r":0,"g":154,"b":112},"luminance":91.2952366117751},{"name":"Rainforest Fern","hex":"#cec192","rgb":{"r":206,"g":193,"b":146},"luminance":130.02189912856986},{"name":"Rainforest Glow","hex":"#b2c346","rgb":{"r":178,"g":195,"b":70},"luminance":126.48516873135758},{"name":"Rainforest Nights","hex":"#002200","rgb":{"r":0,"g":34,"b":0},"luminance":19.958},{"name":"Rainforest Zipline","hex":"#7f795f","rgb":{"r":127,"g":121,"b":95},"luminance":81.26544381223793},{"name":"Rainier Blue","hex":"#558484","rgb":{"r":85,"g":132,"b":132},"luminance":82.9224624875552},{"name":"Rainmaker","hex":"#485769","rgb":{"r":72,"g":87,"b":105},"luminance":56.69901626130739},{"name":"Rainsong","hex":"#acbdb1","rgb":{"r":172,"g":189,"b":177},"luminance":123.93683922466315},{"name":"Rainy Day","hex":"#cfc8bd","rgb":{"r":207,"g":200,"b":189},"luminance":134.4534624507677},{"name":"Rainy Grey","hex":"#a5a5a5","rgb":{"r":165,"g":165,"b":165},"luminance":110.31160115781113},{"name":"Rainy Lake","hex":"#3f6c8f","rgb":{"r":63,"g":108,"b":143},"luminance":68.11490724503703},{"name":"Rainy Season","hex":"#d1d8d6","rgb":{"r":209,"g":216,"b":214},"luminance":143.44511550066804},{"name":"Rainy Week","hex":"#99bbdd","rgb":{"r":153,"g":187,"b":221},"luminance":121.55969317993525},{"name":"Raisin","hex":"#524144","rgb":{"r":82,"g":65,"b":68},"luminance":46.011192692648166},{"name":"Raisin Black","hex":"#242124","rgb":{"r":36,"g":33,"b":36},"luminance":22.53757202983498},{"name":"Raisin in the Sun","hex":"#78615c","rgb":{"r":120,"g":97,"b":92},"luminance":68.11330461077337},{"name":"Rajah","hex":"#fbab60","rgb":{"r":251,"g":171,"b":96},"luminance":125.80805087910709},{"name":"Rajah Rose","hex":"#e6d9e2","rgb":{"r":230,"g":217,"b":226},"luminance":147.03233058412695},{"name":"Rakuda Brown","hex":"#bf794e","rgb":{"r":191,"g":121,"b":78},"luminance":91.57150361329664},{"name":"Ramadi Grey","hex":"#b7a9ac","rgb":{"r":183,"g":169,"b":172},"luminance":114.97677575058364},{"name":"Ramjet","hex":"#4c73af","rgb":{"r":76,"g":115,"b":175},"luminance":73.9682884822949},{"name":"Ramona","hex":"#8f9a88","rgb":{"r":143,"g":154,"b":136},"luminance":101.19453280192562},{"name":"Rampart","hex":"#bcb7b1","rgb":{"r":188,"g":183,"b":177},"luminance":122.90733041198152},{"name":"Ramsons","hex":"#195456","rgb":{"r":25,"g":84,"b":86},"luminance":50.825907812846786},{"name":"Ranch Mink","hex":"#968379","rgb":{"r":150,"g":131,"b":121},"luminance":90.0829925402126},{"name":"Rancho Verde","hex":"#dfd8b3","rgb":{"r":223,"g":216,"b":179},"luminance":144.70120396527457},{"name":"Randall","hex":"#756e60","rgb":{"r":117,"g":110,"b":96},"luminance":74.24867894447685},{"name":"Range Land","hex":"#68bd56","rgb":{"r":104,"g":189,"b":86},"luminance":115.63489473770449},{"name":"Ranger Green","hex":"#6a8472","rgb":{"r":106,"g":132,"b":114},"luminance":84.71821473567535},{"name":"Ranger Station","hex":"#707651","rgb":{"r":112,"g":118,"b":81},"luminance":77.48865501478264},{"name":"Rangitoto","hex":"#2e3222","rgb":{"r":46,"g":50,"b":34},"luminance":32.64381092948555},{"name":"Rangoon Green","hex":"#2b2e25","rgb":{"r":43,"g":46,"b":37},"luminance":30.20268161935294},{"name":"Ranier White","hex":"#f7ecd8","rgb":{"r":247,"g":236,"b":216},"luminance":158.90790417408442},{"name":"Rapakivi Granite","hex":"#d28239","rgb":{"r":210,"g":130,"b":57},"luminance":99.03546942383825},{"name":"Rape Blossoms","hex":"#ffec47","rgb":{"r":255,"g":236,"b":71},"luminance":158.33485998035934},{"name":"Rapeseed","hex":"#c19a13","rgb":{"r":193,"g":154,"b":19},"luminance":107.26876436782517},{"name":"Rapeseed Oil","hex":"#a69425","rgb":{"r":166,"g":148,"b":37},"luminance":100.14372100136882},{"name":"Rapid Rock","hex":"#a39281","rgb":{"r":163,"g":146,"b":129},"luminance":99.68146472138137},{"name":"Rapier Silver","hex":"#d8dfda","rgb":{"r":216,"g":223,"b":218},"luminance":148.0668320759244},{"name":"Rapt","hex":"#45363a","rgb":{"r":69,"g":54,"b":58},"luminance":38.3942692208095},{"name":"Rapture Rose","hex":"#d16277","rgb":{"r":209,"g":98,"b":119},"luminance":86.01396463947002},{"name":"Rapunzel","hex":"#f6d77f","rgb":{"r":246,"g":215,"b":127},"luminance":146.79068575696485},{"name":"Rare Blue","hex":"#0044ff","rgb":{"r":0,"g":68,"b":255},"luminance":49.37967148533898},{"name":"Rare Crystal","hex":"#e1dee8","rgb":{"r":225,"g":222,"b":232},"luminance":149.02067281085533},{"name":"Rare Find","hex":"#ac8044","rgb":{"r":172,"g":128,"b":68},"luminance":91.38025598563401},{"name":"Rare Happening","hex":"#8daca0","rgb":{"r":141,"g":172,"b":160},"luminance":110.922532323239},{"name":"Rare Orchid","hex":"#dbdce2","rgb":{"r":219,"g":220,"b":226},"luminance":147.06693937455825},{"name":"Rare Red","hex":"#dd1133","rgb":{"r":221,"g":17,"b":51},"luminance":67.08067738179155},{"name":"Rare Rhubarb","hex":"#cc0022","rgb":{"r":204,"g":0,"b":34},"luminance":61.11902643203669},{"name":"Rare Turquoise","hex":"#00748e","rgb":{"r":0,"g":116,"b":142},"luminance":69.98979788512038},{"name":"Rare White Jade","hex":"#e8e9cc","rgb":{"r":232,"g":233,"b":204},"luminance":155.10985591186653},{"name":"Rare White Raven","hex":"#e8dbdf","rgb":{"r":232,"g":219,"b":223},"luminance":148.2702644396374},{"name":"Raspberry","hex":"#b00149","rgb":{"r":176,"g":1,"b":73},"luminance":53.281193952463184},{"name":"Raspberry Fool","hex":"#8e3643","rgb":{"r":142,"g":54,"b":67},"luminance":53.533017960880926},{"name":"Raspberry Glace","hex":"#915f6c","rgb":{"r":145,"g":95,"b":108},"luminance":71.70060386077651},{"name":"Raspberry Glaze","hex":"#ff77aa","rgb":{"r":255,"g":119,"b":170},"luminance":105.20611215133842},{"name":"Raspberry Ice","hex":"#d9ccc7","rgb":{"r":217,"g":204,"b":199},"luminance":138.07259608264053},{"name":"Raspberry Jam","hex":"#ca3767","rgb":{"r":202,"g":55,"b":103},"luminance":69.48463278308377},{"name":"Raspberry Kahlua","hex":"#c9a196","rgb":{"r":201,"g":161,"b":150},"luminance":113.29551116438815},{"name":"Raspberry Milk","hex":"#ebd2d1","rgb":{"r":235,"g":210,"b":209},"luminance":143.87613214498086},{"name":"Raspberry Mousse","hex":"#e06f8b","rgb":{"r":224,"g":111,"b":139},"luminance":94.77507552621628},{"name":"Raspberry Parfait","hex":"#b96482","rgb":{"r":185,"g":100,"b":130},"luminance":82.0065340384533},{"name":"Raspberry Patch","hex":"#a34f66","rgb":{"r":163,"g":79,"b":102},"luminance":68.27122880101103},{"name":"Raspberry Pink","hex":"#e25098","rgb":{"r":226,"g":80,"b":152},"luminance":84.09367788365545},{"name":"Raspberry Radiance","hex":"#802a50","rgb":{"r":128,"g":42,"b":80},"luminance":46.429948309254016},{"name":"Raspberry Ripple","hex":"#cd827d","rgb":{"r":205,"g":130,"b":125},"luminance":98.91084685210213},{"name":"Raspberry Rose","hex":"#b3436c","rgb":{"r":179,"g":67,"b":108},"luminance":67.5488935956763},{"name":"Raspberry Sorbet","hex":"#d2386c","rgb":{"r":210,"g":56,"b":108},"luminance":71.9356506052458},{"name":"Raspberry Truffle","hex":"#8a5d55","rgb":{"r":138,"g":93,"b":85},"luminance":69.11313930794925},{"name":"Raspberry Whip","hex":"#b3737f","rgb":{"r":179,"g":115,"b":127},"luminance":87.35579517124208},{"name":"Raspberry Wine","hex":"#b63753","rgb":{"r":182,"g":55,"b":83},"luminance":63.977882060912265},{"name":"Raspberry Yogurt","hex":"#e30b5d","rgb":{"r":227,"g":11,"b":93},"luminance":68.99883609163273},{"name":"Rat Brown","hex":"#885f01","rgb":{"r":136,"g":95,"b":1},"luminance":69.01673070350405},{"name":"Rationality","hex":"#6f6138","rgb":{"r":111,"g":97,"b":56},"luminance":66.21415934677415},{"name":"Ratskin Flesh","hex":"#f7b273","rgb":{"r":247,"g":178,"b":115},"luminance":128.62138976468881},{"name":"Rattan","hex":"#a58e61","rgb":{"r":165,"g":142,"b":97},"luminance":97.48902966488075},{"name":"Rattan Basket","hex":"#a79069","rgb":{"r":167,"g":144,"b":105},"luminance":98.90181076704307},{"name":"Rattan Palm","hex":"#8f876b","rgb":{"r":143,"g":135,"b":107},"luminance":90.8665080103775},{"name":"Rattlesnake","hex":"#7f7667","rgb":{"r":127,"g":118,"b":103},"luminance":79.8598901138738},{"name":"Rave Regatta","hex":"#00619d","rgb":{"r":0,"g":97,"b":157},"luminance":59.68574473858896},{"name":"Raven","hex":"#6f747b","rgb":{"r":111,"g":116,"b":123},"luminance":77.03665795580699},{"name":"Raven Night","hex":"#3b3f66","rgb":{"r":59,"g":63,"b":102},"luminance":42.59119188282948},{"name":"Raven's Coat","hex":"#030205","rgb":{"r":3,"g":2,"b":5},"luminance":1.58359874968377},{"name":"Ravishing Rouge","hex":"#bb2200","rgb":{"r":187,"g":34,"b":0},"luminance":59.36821820637705},{"name":"Raw Amethyst","hex":"#544173","rgb":{"r":84,"g":65,"b":115},"luminance":47.52356868965125},{"name":"Raw Cashew Nut","hex":"#c8beb1","rgb":{"r":200,"g":190,"b":177},"luminance":128.14886883620937},{"name":"Raw Chocolate","hex":"#662200","rgb":{"r":102,"g":34,"b":0},"luminance":36.447904850622066},{"name":"Raw Cotton","hex":"#e3d4bb","rgb":{"r":227,"g":212,"b":187},"luminance":143.3440280897673},{"name":"Raw Linen","hex":"#cc8844","rgb":{"r":204,"g":136,"b":68},"luminance":100.76583619461508},{"name":"Raw Sienna","hex":"#9a6200","rgb":{"r":154,"g":98,"b":0},"luminance":73.68496991924472},{"name":"Raw Sugar","hex":"#d8cab2","rgb":{"r":216,"g":202,"b":178},"luminance":136.5380965005738},{"name":"Raw Sunset","hex":"#f95d2d","rgb":{"r":249,"g":93,"b":45},"luminance":92.4632120467378},{"name":"Raw Umber","hex":"#a75e09","rgb":{"r":167,"g":94,"b":9},"luminance":74.42424906574469},{"name":"Rawhide","hex":"#865e49","rgb":{"r":134,"g":94,"b":73},"luminance":68.69608230459725},{"name":"Rawhide Canoe","hex":"#7a643f","rgb":{"r":122,"g":100,"b":63},"luminance":69.48320378336048},{"name":"Razee","hex":"#7197cb","rgb":{"r":113,"g":151,"b":203},"luminance":97.64031596630565},{"name":"Razzberries","hex":"#d1768c","rgb":{"r":209,"g":118,"b":140},"luminance":94.64473274831515},{"name":"Razzle Dazzle","hex":"#ba417b","rgb":{"r":186,"g":65,"b":123},"luminance":68.88641016194704},{"name":"Razzle Dazzle Rose","hex":"#ff33cc","rgb":{"r":255,"g":51,"b":204},"luminance":85.14907826864598},{"name":"Razzmatazz","hex":"#e30b5c","rgb":{"r":227,"g":11,"b":92},"luminance":68.98141142365817},{"name":"Razzmatazz Lips","hex":"#e3256b","rgb":{"r":227,"g":37,"b":107},"luminance":72.29972540750067},{"name":"Razzmic Berry","hex":"#8d4e85","rgb":{"r":141,"g":78,"b":133},"luminance":64.05954512014583},{"name":"Rè Dài Chéng Orange","hex":"#f08101","rgb":{"r":240,"g":129,"b":1},"luminance":104.32393457399888},{"name":"Ready Lawn","hex":"#7ba570","rgb":{"r":123,"g":165,"b":112},"luminance":104.38611295569922},{"name":"Real Brown","hex":"#563d2d","rgb":{"r":86,"g":61,"b":45},"luminance":44.38094123607564},{"name":"Real Mccoy","hex":"#00577e","rgb":{"r":0,"g":87,"b":126},"luminance":53.05061033579161},{"name":"Real Raspberry","hex":"#dd79a2","rgb":{"r":221,"g":121,"b":162},"luminance":98.75391634765681},{"name":"Real Red","hex":"#a90308","rgb":{"r":169,"g":3,"b":8},"luminance":50.56990039539331},{"name":"Real Simple","hex":"#ccb896","rgb":{"r":204,"g":184,"b":150},"luminance":125.21441642239122},{"name":"Real Teal","hex":"#405d73","rgb":{"r":64,"g":93,"b":115},"luminance":59.31471889000233},{"name":"Really Light Green","hex":"#e9eadb","rgb":{"r":233,"g":234,"b":219},"luminance":156.0256780437118},{"name":"Really Rain","hex":"#e8ecdb","rgb":{"r":232,"g":236,"b":219},"luminance":156.92780379524845},{"name":"Realm","hex":"#796c70","rgb":{"r":121,"g":108,"b":112},"luminance":74.10124615011544},{"name":"Rebecca Purple","hex":"#663399","rgb":{"r":102,"g":51,"b":153},"luminance":46.158155693225005},{"name":"Rebel","hex":"#453430","rgb":{"r":69,"g":52,"b":48},"luminance":37.246416216865754},{"name":"Rebel Red","hex":"#cd4035","rgb":{"r":205,"g":64,"b":53},"luminance":72.14525218612795},{"name":"Rebel Rouser","hex":"#9b7697","rgb":{"r":155,"g":118,"b":151},"luminance":85.09970374214001},{"name":"Rebellion Red","hex":"#cc0404","rgb":{"r":204,"g":4,"b":4},"luminance":61.04287883119537},{"name":"Rebounder","hex":"#bad56b","rgb":{"r":186,"g":213,"b":107},"luminance":137.38434831158898},{"name":"Receding Night","hex":"#4a4e5c","rgb":{"r":74,"g":78,"b":92},"luminance":51.922209275029886},{"name":"Reclaimed Wood","hex":"#bab6ab","rgb":{"r":186,"g":182,"b":171},"luminance":122.00998560773621},{"name":"Recuperate","hex":"#decce4","rgb":{"r":222,"g":204,"b":228},"luminance":139.35998870551043},{"name":"Recycled","hex":"#cdb6a0","rgb":{"r":205,"g":182,"b":160},"luminance":124.5121607755644},{"name":"Red","hex":"#ff0000","rgb":{"r":255,"g":0,"b":0},"luminance":76.24499999999999},{"name":"Red Alert","hex":"#ff0f0f","rgb":{"r":255,"g":15,"b":15},"luminance":76.77077666664574},{"name":"Red Baron","hex":"#bb0011","rgb":{"r":187,"g":0,"b":17},"luminance":55.946576418937376},{"name":"Red Bean","hex":"#3d0c02","rgb":{"r":61,"g":12,"b":2},"luminance":19.55328721724304},{"name":"Red Beech","hex":"#7b3801","rgb":{"r":123,"g":56,"b":1},"luminance":49.32675854949319},{"name":"Red Bell Pepper","hex":"#dd3300","rgb":{"r":221,"g":51,"b":0},"luminance":72.54418108987102},{"name":"Red Berry","hex":"#701f28","rgb":{"r":112,"g":31,"b":40},"luminance":38.38450928434542},{"name":"Red Birch","hex":"#9d2b22","rgb":{"r":157,"g":43,"b":34},"luminance":53.439467680731994},{"name":"Red Blood","hex":"#660000","rgb":{"r":102,"g":0,"b":0},"luminance":30.497999999999998},{"name":"Red Blooded","hex":"#8a3c38","rgb":{"r":138,"g":60,"b":56},"luminance":54.623772297416444},{"name":"Red Brown","hex":"#a52a2f","rgb":{"r":165,"g":42,"b":47},"luminance":55.41182279080883},{"name":"Red Bud","hex":"#962d49","rgb":{"r":150,"g":45,"b":73},"luminance":52.711767272592944},{"name":"Red Cabbage","hex":"#534a77","rgb":{"r":83,"g":74,"b":119},"luminance":51.83415562155903},{"name":"Red Card","hex":"#ff3322","rgb":{"r":255,"g":51,"b":34},"luminance":82.00333755402885},{"name":"Red Carpet","hex":"#bc2026","rgb":{"r":188,"g":32,"b":38},"luminance":59.425531751933015},{"name":"Red Cedar","hex":"#d87678","rgb":{"r":216,"g":118,"b":120},"luminance":95.68706397418619},{"name":"Red Chalk","hex":"#ed7777","rgb":{"r":237,"g":119,"b":119},"luminance":100.42431346043645},{"name":"Red Clay","hex":"#8f4b41","rgb":{"r":143,"g":75,"b":65},"luminance":61.81641993839501},{"name":"Red Clown","hex":"#d43e38","rgb":{"r":212,"g":62,"b":56},"luminance":73.37109264553717},{"name":"Red Contrast","hex":"#b33234","rgb":{"r":179,"g":50,"b":52},"luminance":61.32749077697538},{"name":"Red Craft","hex":"#91433e","rgb":{"r":145,"g":67,"b":62},"luminance":58.96085896592755},{"name":"Red Cray","hex":"#e45e32","rgb":{"r":228,"g":94,"b":50},"luminance":87.88926708079889},{"name":"Red Crayon","hex":"#ee204d","rgb":{"r":238,"g":32,"b":77},"luminance":74.12099691720287},{"name":"Red Dahlia","hex":"#7d2027","rgb":{"r":125,"g":32,"b":39},"luminance":42.0653800291879},{"name":"Red Damask","hex":"#cb6f4a","rgb":{"r":203,"g":111,"b":74},"luminance":89.44678056811212},{"name":"Red Dead Redemption","hex":"#bb012d","rgb":{"r":187,"g":1,"b":45},"luminance":56.150913064704476},{"name":"Red Devil","hex":"#860111","rgb":{"r":134,"g":1,"b":17},"luminance":40.11713809583131},{"name":"Red Dit","hex":"#ff4500","rgb":{"r":255,"g":69,"b":0},"luminance":86.33535216815878},{"name":"Red Dust","hex":"#e8dedb","rgb":{"r":232,"g":222,"b":219},"luminance":149.72294138174016},{"name":"Red Earth","hex":"#a2816e","rgb":{"r":162,"g":129,"b":110},"luminance":90.76047693241811},{"name":"Red Emulsion","hex":"#e9dbde","rgb":{"r":233,"g":219,"b":222},"luminance":148.39090121028312},{"name":"Red Endive","hex":"#794d60","rgb":{"r":121,"g":77,"b":96},"luminance":58.920631174487596},{"name":"Red Flag","hex":"#ff2244","rgb":{"r":255,"g":34,"b":68},"luminance":79.19416198811626},{"name":"Red Gooseberry","hex":"#604046","rgb":{"r":96,"g":64,"b":70},"luminance":47.94741536308292},{"name":"Red Gore","hex":"#ad1400","rgb":{"r":173,"g":20,"b":0},"luminance":53.042531321572504},{"name":"Red Gravel","hex":"#b8866e","rgb":{"r":184,"g":134,"b":110},"luminance":96.80440496175781},{"name":"Red Gumball","hex":"#ac3a3e","rgb":{"r":172,"g":58,"b":62},"luminance":62.079996166236995},{"name":"Red Herring","hex":"#dd1144","rgb":{"r":221,"g":17,"b":68},"luminance":67.27635681277636},{"name":"Red Hook","hex":"#845544","rgb":{"r":132,"g":85,"b":68},"luminance":64.08843540764589},{"name":"Red Hot","hex":"#dd0033","rgb":{"r":221,"g":0,"b":51},"luminance":66.33428100914338},{"name":"Red Hot Jazz","hex":"#773c31","rgb":{"r":119,"g":60,"b":49},"luminance":50.3751859252152},{"name":"Red Icon","hex":"#c93543","rgb":{"r":201,"g":53,"b":67},"luminance":68.10376763439743},{"name":"Red Ink","hex":"#ac3235","rgb":{"r":172,"g":50,"b":53},"luminance":59.52115126574754},{"name":"Red Kite","hex":"#913228","rgb":{"r":145,"g":50,"b":40},"luminance":52.55351677100211},{"name":"Red Knuckles","hex":"#dd0011","rgb":{"r":221,"g":0,"b":17},"luminance":66.107413237851},{"name":"Red Leather","hex":"#ab4d50","rgb":{"r":171,"g":77,"b":80},"luminance":68.8498267390703},{"name":"Red Leever","hex":"#881400","rgb":{"r":136,"g":20,"b":0},"luminance":42.324797648659825},{"name":"Red Licorice","hex":"#a83e4c","rgb":{"r":168,"g":62,"b":76},"luminance":62.63259499653515},{"name":"Red Light Neon","hex":"#ff0055","rgb":{"r":255,"g":0,"b":85},"luminance":76.85828598791414},{"name":"Red Lilac Purple","hex":"#bfbac0","rgb":{"r":191,"g":186,"b":192},"luminance":125.14484227885701},{"name":"Red Mahogany","hex":"#60373d","rgb":{"r":96,"g":55,"b":61},"luminance":43.75613050762144},{"name":"Red Mane","hex":"#6d3d2a","rgb":{"r":109,"g":61,"b":42},"luminance":48.654285258340806},{"name":"Red Maple Leaf","hex":"#834c4b","rgb":{"r":131,"g":76,"b":75},"luminance":59.979526548648245},{"name":"Red Mull","hex":"#ff8888","rgb":{"r":255,"g":136,"b":136},"luminance":111.47565772400716},{"name":"Red Mulled Wine","hex":"#880022","rgb":{"r":136,"g":0,"b":34},"luminance":40.84830806777681},{"name":"Red Ochre","hex":"#913832","rgb":{"r":145,"g":56,"b":50},"luminance":54.705707279953884},{"name":"Red October","hex":"#fe2712","rgb":{"r":254,"g":39,"b":18},"luminance":79.34793676586682},{"name":"Red Onion","hex":"#473442","rgb":{"r":71,"g":52,"b":66},"luminance":37.93409538924053},{"name":"Red Orange","hex":"#ff3f34","rgb":{"r":255,"g":63,"b":52},"luminance":84.94725169185874},{"name":"Red Orange Juice","hex":"#ff5349","rgb":{"r":255,"g":83,"b":73},"luminance":90.86413786527663},{"name":"Red Orpiment","hex":"#cd6d57","rgb":{"r":205,"g":109,"b":87},"luminance":89.1586677670769},{"name":"Red Oxide","hex":"#5d1f1e","rgb":{"r":93,"g":31,"b":30},"luminance":33.407431179305},{"name":"Red Paracentrotus","hex":"#bb0044","rgb":{"r":187,"g":0,"b":68},"luminance":56.44782611403206},{"name":"Red Pear","hex":"#7b3539","rgb":{"r":123,"g":53,"b":57},"luminance":48.60726338727577},{"name":"Red Pegasus","hex":"#dd0000","rgb":{"r":221,"g":0,"b":0},"luminance":66.079},{"name":"Red Perfume","hex":"#f6b894","rgb":{"r":246,"g":184,"b":148},"luminance":131.75956649898328},{"name":"Red Pigment","hex":"#ed1c24","rgb":{"r":237,"g":28,"b":36},"luminance":72.85979468129182},{"name":"Red Pink","hex":"#fa2a55","rgb":{"r":250,"g":42,"b":85},"luminance":79.30497031081974},{"name":"Red Plum","hex":"#7c2946","rgb":{"r":124,"g":41,"b":70},"luminance":44.91693071660173},{"name":"Red Potion","hex":"#dd143d","rgb":{"r":221,"g":20,"b":61},"luminance":67.47310543468411},{"name":"Red Power","hex":"#d63d3b","rgb":{"r":214,"g":61,"b":59},"luminance":73.6314370428827},{"name":"Red Prayer Flag","hex":"#bb1100","rgb":{"r":187,"g":17,"b":0},"luminance":56.796514065565674},{"name":"Red Purple","hex":"#e40078","rgb":{"r":228,"g":0,"b":120},"luminance":69.53102892953619},{"name":"Red Radish","hex":"#ee3344","rgb":{"r":238,"g":51,"b":68},"luminance":77.59089970479785},{"name":"Red Rampage","hex":"#ee3322","rgb":{"r":238,"g":51,"b":34},"luminance":77.29991972182118},{"name":"Red Revival","hex":"#a8453b","rgb":{"r":168,"g":69,"b":59},"luminance":64.87669773501115},{"name":"Red Ribbon","hex":"#ed0a3f","rgb":{"r":237,"g":10,"b":63},"luminance":71.46749466016001},{"name":"Red Riding Hood","hex":"#fe2713","rgb":{"r":254,"g":39,"b":19},"luminance":79.35096673009095},{"name":"Red River","hex":"#b95543","rgb":{"r":185,"g":85,"b":67},"luminance":74.88390544035481},{"name":"Red Robin","hex":"#7d4138","rgb":{"r":125,"g":65,"b":56},"luminance":53.79079945492538},{"name":"Red Rock","hex":"#a65052","rgb":{"r":166,"g":80,"b":82},"luminance":68.96492340313299},{"name":"Red Rock Falls","hex":"#a27253","rgb":{"r":162,"g":114,"b":83},"luminance":83.14919128891151},{"name":"Red Rock Panorama","hex":"#b29e9d","rgb":{"r":178,"g":158,"b":157},"luminance":108.4192796692544},{"name":"Red Rooster","hex":"#7e5146","rgb":{"r":126,"g":81,"b":70},"luminance":61.186010533454464},{"name":"Red Rust","hex":"#8a3319","rgb":{"r":138,"g":51,"b":25},"luminance":51.05780168593238},{"name":"Red Safflower","hex":"#c53d43","rgb":{"r":197,"g":61,"b":67},"luminance":69.35447860088057},{"name":"Red Salsa","hex":"#fd3a4a","rgb":{"r":253,"g":58,"b":74},"luminance":83.38324064822618},{"name":"Red Sandstorm","hex":"#e5cac0","rgb":{"r":229,"g":202,"b":192},"luminance":138.66202025428592},{"name":"Red Shade Wash","hex":"#862808","rgb":{"r":134,"g":40,"b":8},"luminance":46.448105451137614},{"name":"Red Shimmer","hex":"#fee0da","rgb":{"r":254,"g":224,"b":218},"luminance":153.86523637261277},{"name":"Red Shrivel","hex":"#874c62","rgb":{"r":135,"g":76,"b":98},"luminance":61.191317627585036},{"name":"Red Sparowes","hex":"#c8756d","rgb":{"r":200,"g":117,"b":109},"luminance":91.90892512155716},{"name":"Red Stage","hex":"#ad522e","rgb":{"r":173,"g":82,"b":46},"luminance":70.85241012837884},{"name":"Red Stop","hex":"#ff2222","rgb":{"r":255,"g":34,"b":34},"luminance":78.9090943111122},{"name":"Red Tape","hex":"#cc1133","rgb":{"r":204,"g":17,"b":51},"luminance":62.07974752687063},{"name":"Red Terra","hex":"#ae4930","rgb":{"r":174,"g":73,"b":48},"luminance":67.62289302447803},{"name":"Red Tolumnia Orchid","hex":"#be0119","rgb":{"r":190,"g":1,"b":25},"luminance":56.88447212552824},{"name":"Red Tone Ink","hex":"#8b2e08","rgb":{"r":139,"g":46,"b":8},"luminance":49.5707218930691},{"name":"Red Velvet","hex":"#783b38","rgb":{"r":120,"g":59,"b":56},"luminance":50.274989259073934},{"name":"Red Vine","hex":"#5f383c","rgb":{"r":95,"g":56,"b":60},"luminance":43.97951806238899},{"name":"Red Violet","hex":"#9e0168","rgb":{"r":158,"g":1,"b":104},"luminance":48.71053139722456},{"name":"Red Wattle Hog","hex":"#765952","rgb":{"r":118,"g":89,"b":82},"luminance":63.7301786989492},{"name":"Red Wine","hex":"#8c0034","rgb":{"r":140,"g":0,"b":52},"luminance":42.277662943923474},{"name":"Red Wine Vinegar","hex":"#722f37","rgb":{"r":114,"g":47,"b":55},"luminance":44.298094959038586},{"name":"Red Wrath","hex":"#ee1155","rgb":{"r":238,"g":17,"b":85},"luminance":72.50866696471532},{"name":"Red-Eye","hex":"#dd1155","rgb":{"r":221,"g":17,"b":85},"luminance":67.52711145902806},{"name":"Red-Handed","hex":"#dd2233","rgb":{"r":221,"g":34,"b":51},"luminance":69.2716291204415},{"name":"Red-Letter Day","hex":"#cc0055","rgb":{"r":204,"g":0,"b":85},"luminance":61.76089471502173},{"name":"Red-Tailed-Hawk","hex":"#a27547","rgb":{"r":162,"g":117,"b":71},"luminance":84.4307865710133},{"name":"Redalicious","hex":"#bb2211","rgb":{"r":187,"g":34,"b":17},"luminance":59.399841557027734},{"name":"Redbox","hex":"#94332f","rgb":{"r":148,"g":51,"b":47},"luminance":53.69517331194676},{"name":"Reddish","hex":"#c44240","rgb":{"r":196,"g":66,"b":64},"luminance":70.63004315445376},{"name":"Reddish Banana","hex":"#ffbb88","rgb":{"r":255,"g":187,"b":136},"luminance":134.54704531129622},{"name":"Reddish Black","hex":"#433635","rgb":{"r":67,"g":54,"b":53},"luminance":37.98144358762578},{"name":"Reddish Brown","hex":"#7f2b0a","rgb":{"r":127,"g":43,"b":10},"luminance":45.6109242397038},{"name":"Reddish Grey","hex":"#997570","rgb":{"r":153,"g":117,"b":112},"luminance":83.50218484566737},{"name":"Reddish Orange","hex":"#f8481c","rgb":{"r":248,"g":72,"b":28},"luminance":85.41050090006497},{"name":"Reddish Pink","hex":"#fe2c54","rgb":{"r":254,"g":44,"b":84},"luminance":80.78725317771362},{"name":"Reddish Purple","hex":"#910951","rgb":{"r":145,"g":9,"b":81},"luminance":44.64115668304306},{"name":"Reddish White","hex":"#fff8d5","rgb":{"r":255,"g":248,"b":213},"luminance":166.1182931678507},{"name":"Reddy Brown","hex":"#6e1005","rgb":{"r":110,"g":16,"b":5},"luminance":34.20945284566826},{"name":"Rediscover","hex":"#c3cdc9","rgb":{"r":195,"g":205,"b":201},"luminance":135.66516371567167},{"name":"Redneck","hex":"#f5d6d8","rgb":{"r":245,"g":214,"b":216},"luminance":147.48734971176341},{"name":"Redridge Brown","hex":"#9d4e34","rgb":{"r":157,"g":78,"b":52},"luminance":65.84181216370035},{"name":"Redrum","hex":"#ff2200","rgb":{"r":255,"g":34,"b":0},"luminance":78.81384262298089},{"name":"Redstone","hex":"#e46b71","rgb":{"r":228,"g":107,"b":113},"luminance":93.58599248284969},{"name":"Redtail","hex":"#af4544","rgb":{"r":175,"g":69,"b":68},"luminance":66.6220094113049},{"name":"Reduced Blue","hex":"#d6dfec","rgb":{"r":214,"g":223,"b":236},"luminance":148.16580311596869},{"name":"Reduced Green","hex":"#e7e9d8","rgb":{"r":231,"g":233,"b":216},"luminance":155.18754646555888},{"name":"Reduced Pink","hex":"#f6e4e4","rgb":{"r":246,"g":228,"b":228},"luminance":154.9123941974947},{"name":"Reduced Red","hex":"#efdedf","rgb":{"r":239,"g":222,"b":223},"luminance":150.78027457529052},{"name":"Reduced Sand","hex":"#eee5da","rgb":{"r":238,"g":229,"b":218},"luminance":154.11422736723563},{"name":"Reduced Sky","hex":"#d3eeec","rgb":{"r":211,"g":238,"b":236},"luminance":155.6335875478041},{"name":"Reduced Spearmint","hex":"#dbe8df","rgb":{"r":219,"g":232,"b":223},"luminance":153.2322462832155},{"name":"Reduced Turquoise","hex":"#daece7","rgb":{"r":218,"g":236,"b":231},"luminance":155.34892244235232},{"name":"Reduced Yellow","hex":"#f0ead7","rgb":{"r":240,"g":234,"b":215},"luminance":156.89951518089532},{"name":"Redwood","hex":"#5b342e","rgb":{"r":91,"g":52,"b":46},"luminance":41.225523562472794},{"name":"Redwood City","hex":"#b45f56","rgb":{"r":180,"g":95,"b":86},"luminance":78.11815436247838},{"name":"Redwood Forest","hex":"#916f5e","rgb":{"r":145,"g":111,"b":94},"luminance":78.99318533898983},{"name":"RedЯum","hex":"#ff0044","rgb":{"r":255,"g":0,"b":68},"luminance":76.63806840598215},{"name":"Reed","hex":"#c3d3a8","rgb":{"r":195,"g":211,"b":168},"luminance":138.22745233129345},{"name":"Reed Bed","hex":"#b0ad96","rgb":{"r":176,"g":173,"b":150},"luminance":115.64731288274707},{"name":"Reed Green","hex":"#a1a14a","rgb":{"r":161,"g":161,"b":74},"luminance":106.3959701586484},{"name":"Reed Mace","hex":"#cd5e3c","rgb":{"r":205,"g":94,"b":60},"luminance":82.75550923654569},{"name":"Reed Mace Brown","hex":"#726250","rgb":{"r":114,"g":98,"b":80},"luminance":67.48533523662752},{"name":"Reed Yellow","hex":"#dcc99e","rgb":{"r":220,"g":201,"b":158},"luminance":136.28049278234943},{"name":"Reeds","hex":"#a0bca7","rgb":{"r":160,"g":188,"b":167},"luminance":121.77667173970555},{"name":"Reef","hex":"#017371","rgb":{"r":1,"g":115,"b":113},"luminance":68.72379755223076},{"name":"Reef Encounter","hex":"#00968f","rgb":{"r":0,"g":150,"b":143},"luminance":89.54639972662217},{"name":"Reef Escape","hex":"#0474ad","rgb":{"r":4,"g":116,"b":173},"luminance":70.9006922674243},{"name":"Reef Gold","hex":"#a98d36","rgb":{"r":169,"g":141,"b":54},"luminance":97.16817681730988},{"name":"Reef Refractions","hex":"#d1ef9f","rgb":{"r":209,"g":239,"b":159},"luminance":154.64734981887014},{"name":"Reef Resort","hex":"#274256","rgb":{"r":39,"g":66,"b":86},"luminance":41.62979583183179},{"name":"Reef Waters","hex":"#6f9fa9","rgb":{"r":111,"g":159,"b":169},"luminance":100.91450523091316},{"name":"Refined Chianti","hex":"#8c1b3c","rgb":{"r":140,"g":27,"b":60},"luminance":45.279531810742036},{"name":"Refined Green","hex":"#384543","rgb":{"r":56,"g":69,"b":67},"luminance":44.48812863000646},{"name":"Refined Mint","hex":"#f1f9ec","rgb":{"r":241,"g":249,"b":236},"luminance":165.16642293759344},{"name":"Reflecting Pond","hex":"#203e4a","rgb":{"r":32,"g":62,"b":74},"luminance":38.56469831335388},{"name":"Reflection Pool","hex":"#cadbdf","rgb":{"r":202,"g":219,"b":223},"luminance":144.29161547713022},{"name":"Reform","hex":"#8aaad6","rgb":{"r":138,"g":170,"b":214},"luminance":110.70574312112267},{"name":"Refreshed","hex":"#cfe587","rgb":{"r":207,"g":229,"b":135},"luminance":148.78554525893972},{"name":"Refreshing Primer","hex":"#d7fffe","rgb":{"r":215,"g":255,"b":254},"luminance":165.4587875756377},{"name":"Regal Blue","hex":"#203f58","rgb":{"r":32,"g":63,"b":88},"luminance":39.49407561900898},{"name":"Regal Destiny","hex":"#2e508a","rgb":{"r":46,"g":80,"b":138},"luminance":51.39951303271267},{"name":"Regal Gown","hex":"#655777","rgb":{"r":101,"g":87,"b":119},"luminance":60.86097861520138},{"name":"Regal Orchid","hex":"#a98baf","rgb":{"r":169,"g":139,"b":175},"luminance":98.02449749934961},{"name":"Regal Violet","hex":"#a298a2","rgb":{"r":162,"g":152,"b":162},"luminance":103.1902565361672},{"name":"Regalia","hex":"#522d80","rgb":{"r":82,"g":45,"b":128},"luminance":38.88201400390674},{"name":"Regality","hex":"#664480","rgb":{"r":102,"g":68,"b":128},"luminance":52.31005184474586},{"name":"Regatta","hex":"#487ab7","rgb":{"r":72,"g":122,"b":183},"luminance":77.63531943645236},{"name":"Regatta Bay","hex":"#2d5367","rgb":{"r":45,"g":83,"b":103},"luminance":51.89072585732445},{"name":"Regency Cream","hex":"#e1bb87","rgb":{"r":225,"g":187,"b":135},"luminance":129.66113945974715},{"name":"Regent Grey","hex":"#798488","rgb":{"r":121,"g":132,"b":136},"luminance":86.90836733594757},{"name":"Regent St Blue","hex":"#a0cdd9","rgb":{"r":160,"g":205,"b":217},"luminance":131.8375760889133},{"name":"Registra","hex":"#c2bbbf","rgb":{"r":194,"g":187,"b":191},"luminance":126.04775473208556},{"name":"Registration Black","hex":"#000200","rgb":{"r":0,"g":2,"b":0},"luminance":1.174},{"name":"Regula Barbara Blue","hex":"#009999","rgb":{"r":0,"g":153,"b":153},"luminance":91.48901073353018},{"name":"Reign Over Me","hex":"#76679e","rgb":{"r":118,"g":103,"b":158},"luminance":72.28266866268844},{"name":"Reikland Fleshshade","hex":"#ca6c4d","rgb":{"r":202,"g":108,"b":77},"luminance":88.00013922716258},{"name":"Reikland Fleshshade Gloss","hex":"#cb7351","rgb":{"r":203,"g":115,"b":81},"luminance":91.24865801752922},{"name":"Reindeer","hex":"#dac0ba","rgb":{"r":218,"g":192,"b":186},"luminance":131.91093342100191},{"name":"Reindeer Moss","hex":"#bdf8a3","rgb":{"r":189,"g":248,"b":163},"luminance":157.2614244530425},{"name":"Relax","hex":"#b9d2d3","rgb":{"r":185,"g":210,"b":211},"luminance":137.23642752928248},{"name":"Relaxed Rhino","hex":"#bbaaaa","rgb":{"r":187,"g":170,"b":170},"luminance":116.01677494655675},{"name":"Relic","hex":"#88789b","rgb":{"r":136,"g":120,"b":155},"luminance":83.23210556029446},{"name":"Relief","hex":"#bf2133","rgb":{"r":191,"g":33,"b":51},"luminance":60.58445442520713},{"name":"Relieved Red","hex":"#e9dbdf","rgb":{"r":233,"g":219,"b":223},"luminance":148.41038636834014},{"name":"Reliquial Rose","hex":"#ff2288","rgb":{"r":255,"g":34,"b":136},"luminance":80.32431639920752},{"name":"Remembrance","hex":"#ca9e9c","rgb":{"r":202,"g":158,"b":156},"luminance":112.09821397328326},{"name":"Remington Rust","hex":"#a25d4c","rgb":{"r":162,"g":93,"b":76},"luminance":73.4947754673759},{"name":"Remote Control","hex":"#6d7a6a","rgb":{"r":109,"g":122,"b":106},"luminance":79.60377712772177},{"name":"Remy","hex":"#f6deda","rgb":{"r":246,"g":222,"b":218},"luminance":151.68899569843555},{"name":"Renaissance Rose","hex":"#865560","rgb":{"r":134,"g":85,"b":96},"luminance":64.91969282890977},{"name":"Renanthera Orchid","hex":"#820747","rgb":{"r":130,"g":7,"b":71},"luminance":39.91583165862888},{"name":"Rendezvous","hex":"#abbed0","rgb":{"r":171,"g":190,"b":208},"luminance":124.96149200853836},{"name":"Renga Brick","hex":"#b55233","rgb":{"r":181,"g":82,"b":51},"luminance":72.66051687815055},{"name":"Renkon Beige","hex":"#989f7a","rgb":{"r":152,"g":159,"b":122},"luminance":104.73777760197129},{"name":"Rennie's Rose","hex":"#b87f84","rgb":{"r":184,"g":127,"b":132},"luminance":93.8656271539268},{"name":"Reno Sand","hex":"#b26e33","rgb":{"r":178,"g":110,"b":51},"luminance":83.8788935310904},{"name":"Renwick Brown","hex":"#504e47","rgb":{"r":80,"g":78,"b":71},"luminance":52.28801996633645},{"name":"Reptile Green","hex":"#24da91","rgb":{"r":36,"g":218,"b":145},"luminance":129.4774179229722},{"name":"Reptilian Green","hex":"#009e82","rgb":{"r":0,"g":158,"b":130},"luminance":93.92259001965395},{"name":"Requiem","hex":"#4e3f44","rgb":{"r":78,"g":63,"b":68},"luminance":44.402742584214316},{"name":"Reseda","hex":"#a1ad92","rgb":{"r":161,"g":173,"b":146},"luminance":113.60894180477167},{"name":"Reservation","hex":"#8c7544","rgb":{"r":140,"g":117,"b":68},"luminance":80.80320627920653},{"name":"Reserved Beige","hex":"#e2e1d6","rgb":{"r":226,"g":225,"b":214},"luminance":150.35031066479377},{"name":"Reserved Blue","hex":"#d2d8de","rgb":{"r":210,"g":216,"b":222},"luminance":143.7333998345548},{"name":"Resolution Blue","hex":"#002387","rgb":{"r":0,"g":35,"b":135},"luminance":25.670004382547344},{"name":"Restoration","hex":"#939581","rgb":{"r":147,"g":149,"b":129},"luminance":98.98438772857061},{"name":"Retributor Armour Metal","hex":"#c39e81","rgb":{"r":195,"g":158,"b":129},"luminance":110.53307186991593},{"name":"Retro","hex":"#9bdc96","rgb":{"r":155,"g":220,"b":150},"luminance":138.2657174609816},{"name":"Retro Blue","hex":"#2b62f4","rgb":{"r":43,"g":98,"b":244},"luminance":65.17877707505718},{"name":"Retro Orange","hex":"#e85112","rgb":{"r":232,"g":81,"b":18},"luminance":84.12399976819933},{"name":"Retro Peach","hex":"#e7c0ad","rgb":{"r":231,"g":192,"b":173},"luminance":133.64758007910206},{"name":"Revenant Brown","hex":"#c59782","rgb":{"r":197,"g":151,"b":130},"luminance":107.45098221049447},{"name":"Revered","hex":"#a78faf","rgb":{"r":167,"g":143,"b":175},"luminance":99.68650094170222},{"name":"Reversed Grey","hex":"#080808","rgb":{"r":8,"g":8,"b":8},"luminance":5.34844126825751},{"name":"Revival","hex":"#5f81a4","rgb":{"r":95,"g":129,"b":164},"luminance":83.00817532026589},{"name":"Revival Red","hex":"#7f4e47","rgb":{"r":127,"g":78,"b":71},"luminance":60.03181957095752},{"name":"Revival Rose","hex":"#c09084","rgb":{"r":192,"g":144,"b":132},"luminance":103.28167093923297},{"name":"Revolver","hex":"#37363f","rgb":{"r":55,"g":54,"b":63},"luminance":36.42502371996482},{"name":"Rhapsody","hex":"#9f86aa","rgb":{"r":159,"g":134,"b":170},"luminance":93.929825108961},{"name":"Rhapsody In Blue","hex":"#002244","rgb":{"r":0,"g":34,"b":68},"luminance":21.41063446047314},{"name":"Rhapsody Rap","hex":"#74676c","rgb":{"r":116,"g":103,"b":108},"luminance":70.78204377524006},{"name":"Rhind Papyrus","hex":"#969565","rgb":{"r":150,"g":149,"b":101},"luminance":98.96398872822375},{"name":"Rhine Falls","hex":"#e3eadb","rgb":{"r":227,"g":234,"b":219},"luminance":155.2329393170148},{"name":"Rhinestone","hex":"#8e6c94","rgb":{"r":142,"g":108,"b":148},"luminance":78.14345119074277},{"name":"Rhino","hex":"#3d4653","rgb":{"r":61,"g":70,"b":83},"luminance":45.941034653129},{"name":"Rhinoceros","hex":"#727a7c","rgb":{"r":114,"g":122,"b":124},"luminance":80.56206854345287},{"name":"Rhinoceros Beetle","hex":"#440011","rgb":{"r":68,"g":0,"b":17},"luminance":20.424154033888406},{"name":"Rhinox Hide","hex":"#493435","rgb":{"r":73,"g":52,"b":53},"luminance":38.00839734848077},{"name":"Rhode Island Red","hex":"#9b5b55","rgb":{"r":155,"g":91,"b":85},"luminance":71.38018642452539},{"name":"Rhododendron","hex":"#722b3f","rgb":{"r":114,"g":43,"b":63},"luminance":43.01795672739466},{"name":"Rhubarb","hex":"#77202f","rgb":{"r":119,"g":32,"b":47},"luminance":40.59007737119997},{"name":"Rhubarb Gin","hex":"#d9a6c1","rgb":{"r":217,"g":166,"b":193},"luminance":119.11689660581322},{"name":"Rhubarb Pie","hex":"#d78187","rgb":{"r":215,"g":129,"b":135},"luminance":100.51560104779755},{"name":"Rhubarb Smoothie","hex":"#8c474b","rgb":{"r":140,"g":71,"b":75},"luminance":59.685294914241645},{"name":"Rhynchites Nitens","hex":"#383867","rgb":{"r":56,"g":56,"b":103},"luminance":38.714396340379636},{"name":"Rhys","hex":"#beceb4","rgb":{"r":190,"g":206,"b":180},"luminance":135.16869676075152},{"name":"Rhythm","hex":"#767194","rgb":{"r":118,"g":113,"b":148},"luminance":77.00185367249284},{"name":"Rhythm & Blues","hex":"#70767b","rgb":{"r":112,"g":118,"b":123},"luminance":78.20384507170986},{"name":"Ribbon Red","hex":"#b92636","rgb":{"r":185,"g":38,"b":54},"luminance":59.96001331720999},{"name":"Rice Bowl","hex":"#f1e7d5","rgb":{"r":241,"g":231,"b":213},"luminance":155.46273319995373},{"name":"Rice Cake","hex":"#efecde","rgb":{"r":239,"g":236,"b":222},"luminance":157.91860057953906},{"name":"Rice Fibre","hex":"#e4d8ab","rgb":{"r":228,"g":216,"b":171},"luminance":145.27094989708024},{"name":"Rice Flower","hex":"#eff5d1","rgb":{"r":239,"g":245,"b":209},"luminance":162.34872041996513},{"name":"Rice Paper","hex":"#fffcdb","rgb":{"r":255,"g":252,"b":219},"luminance":168.27985903547696},{"name":"Rice Pudding","hex":"#fff0e3","rgb":{"r":255,"g":240,"b":227},"luminance":162.26566275401584},{"name":"Rich Biscuit","hex":"#948165","rgb":{"r":148,"g":129,"b":101},"luminance":88.45781157704502},{"name":"Rich Black","hex":"#004040","rgb":{"r":0,"g":64,"b":64},"luminance":38.26991298657471},{"name":"Rich Blue","hex":"#021bf9","rgb":{"r":2,"g":27,"b":249},"luminance":32.5163558997622},{"name":"Rich Brilliant Lavender","hex":"#f1a7fe","rgb":{"r":241,"g":167,"b":254},"luminance":125.06252139630001},{"name":"Rich Carmine","hex":"#d70041","rgb":{"r":215,"g":0,"b":65},"luminance":64.71065851156206},{"name":"Rich Electric Blue","hex":"#0892d0","rgb":{"r":8,"g":146,"b":208},"luminance":88.95399604289848},{"name":"Rich Gardenia","hex":"#f57f4f","rgb":{"r":245,"g":127,"b":79},"luminance":104.90451116134138},{"name":"Rich Georgia Clay","hex":"#de7a63","rgb":{"r":222,"g":122,"b":99},"luminance":98.29535938181415},{"name":"Rich Gold","hex":"#aa8833","rgb":{"r":170,"g":136,"b":51},"luminance":94.81898396418302},{"name":"Rich Honey","hex":"#f9bc7d","rgb":{"r":249,"g":188,"b":125},"luminance":133.8822640867714},{"name":"Rich Ivory","hex":"#fff0c4","rgb":{"r":255,"g":240,"b":196},"luminance":161.7396944506821},{"name":"Rich Lavender","hex":"#a76bcf","rgb":{"r":167,"g":107,"b":207},"luminance":83.63695698672926},{"name":"Rich Lilac","hex":"#b666d2","rgb":{"r":182,"g":102,"b":210},"luminance":84.37617080669162},{"name":"Rich Loam","hex":"#583d37","rgb":{"r":88,"g":61,"b":55},"luminance":44.87510994972602},{"name":"Rich Maroon","hex":"#b0306a","rgb":{"r":176,"g":48,"b":106},"luminance":60.90316418709293},{"name":"Rich Mocha","hex":"#745342","rgb":{"r":116,"g":83,"b":66},"luminance":60.27707916778981},{"name":"Rich Purple","hex":"#720058","rgb":{"r":114,"g":0,"b":88},"luminance":35.53162563125982},{"name":"Rich Red","hex":"#ff1144","rgb":{"r":255,"g":17,"b":68},"luminance":77.28501775894212},{"name":"Rich Red Violet","hex":"#7c3651","rgb":{"r":124,"g":54,"b":81},"luminance":49.645339519435254},{"name":"Rich Texture","hex":"#645671","rgb":{"r":100,"g":86,"b":113},"luminance":60.06986139487921},{"name":"Rickrack","hex":"#a6a660","rgb":{"r":166,"g":166,"b":96},"luminance":109.90108487180642},{"name":"Ricochet","hex":"#817c74","rgb":{"r":129,"g":124,"b":116},"luminance":83.43074469882191},{"name":"Ride off into the Sunset","hex":"#f3cf64","rgb":{"r":243,"g":207,"b":100},"luminance":142.03322403578676},{"name":"Ridge Light","hex":"#b2c8dd","rgb":{"r":178,"g":200,"b":221},"luminance":131.33955580859865},{"name":"Ridgecrest","hex":"#9d8861","rgb":{"r":157,"g":136,"b":97},"luminance":93.26882028309352},{"name":"Riding Boots","hex":"#734a35","rgb":{"r":115,"g":74,"b":53},"luminance":55.72875230076482},{"name":"Riding Star","hex":"#a0a197","rgb":{"r":160,"g":161,"b":151},"luminance":107.31523864298117},{"name":"Rifle Green","hex":"#414833","rgb":{"r":65,"g":72,"b":51},"luminance":46.88035320899363},{"name":"Rigby Ridge","hex":"#a0a082","rgb":{"r":160,"g":160,"b":130},"luminance":106.43901728219778},{"name":"Right as Rain","hex":"#c0e1e4","rgb":{"r":192,"g":225,"b":228},"luminance":146.33888120728543},{"name":"Rikan Brown","hex":"#534a32","rgb":{"r":83,"g":74,"b":50},"luminance":50.35110061359135},{"name":"Rikyū Brown","hex":"#826b58","rgb":{"r":130,"g":107,"b":88},"luminance":74.5418567316377},{"name":"Rikyūnezumi Brown","hex":"#656255","rgb":{"r":101,"g":98,"b":85},"luminance":65.68954541629893},{"name":"Rikyūshira Brown","hex":"#b0927a","rgb":{"r":176,"g":146,"b":122},"luminance":101.52610818897767},{"name":"Rincon Cove","hex":"#c7b39e","rgb":{"r":199,"g":179,"b":158},"luminance":122.08659416168508},{"name":"Ringlet","hex":"#fbedbe","rgb":{"r":251,"g":237,"b":190},"luminance":159.54812490906937},{"name":"Rinse","hex":"#d5d9dd","rgb":{"r":213,"g":217,"b":221},"luminance":144.6242761295627},{"name":"Rinsed-Out red","hex":"#ff7952","rgb":{"r":255,"g":121,"b":82},"luminance":104.62083854567406},{"name":"Rio Grande","hex":"#b7c61a","rgb":{"r":183,"g":198,"b":26},"luminance":128.49598616688382},{"name":"Rio Red","hex":"#8a2232","rgb":{"r":138,"g":34,"b":50},"luminance":46.188357927079416},{"name":"Rip Cord","hex":"#dfab56","rgb":{"r":223,"g":171,"b":86},"luminance":120.90278273886005},{"name":"Rip Van Periwinkle","hex":"#8fa4d2","rgb":{"r":143,"g":164,"b":210},"luminance":108.02227766993252},{"name":"Ripasso","hex":"#774041","rgb":{"r":119,"g":64,"b":65},"luminance":52.2711228595675},{"name":"Ripe Lemon","hex":"#f4d81c","rgb":{"r":244,"g":216,"b":28},"luminance":146.31807155645538},{"name":"Ripe Mango","hex":"#ffc324","rgb":{"r":255,"g":195,"b":36},"luminance":137.59498197972192},{"name":"Ripe Melon","hex":"#febaad","rgb":{"r":254,"g":186,"b":173},"luminance":134.45245004833492},{"name":"Ripe Pear","hex":"#e1e36e","rgb":{"r":225,"g":227,"b":110},"luminance":149.79477035597736},{"name":"Ripe Pineapple","hex":"#ffe07b","rgb":{"r":255,"g":224,"b":123},"luminance":152.64013447648688},{"name":"Ripe Plum","hex":"#410056","rgb":{"r":65,"g":0,"b":86},"luminance":21.767812039798578},{"name":"Ripe Pumpkin","hex":"#ffaf37","rgb":{"r":255,"g":175,"b":55},"luminance":128.0821554706197},{"name":"Ripe Rhubarb","hex":"#7e3947","rgb":{"r":126,"g":57,"b":71},"luminance":51.03281094550837},{"name":"Ripening Grape","hex":"#6f3942","rgb":{"r":111,"g":57,"b":66},"luminance":47.724469384163925},{"name":"Riptide","hex":"#89d9c8","rgb":{"r":137,"g":217,"b":200},"luminance":135.73215171800675},{"name":"Rise-N-Shine","hex":"#ffc632","rgb":{"r":255,"g":198,"b":50},"luminance":139.11963592893707},{"name":"Rising Ash","hex":"#978888","rgb":{"r":151,"g":136,"b":136},"luminance":93.01588273515442},{"name":"Risotto","hex":"#f8f5e9","rgb":{"r":248,"g":245,"b":233},"luminance":163.97198898897335},{"name":"Rita Repulsa","hex":"#00aa55","rgb":{"r":0,"g":170,"b":85},"luminance":100.25936464989192},{"name":"Ritterlich Blue","hex":"#293286","rgb":{"r":41,"g":50,"b":134},"luminance":35.28543264578174},{"name":"Ritual","hex":"#767081","rgb":{"r":118,"g":112,"b":129},"luminance":76.04840232378324},{"name":"Ritual Experience","hex":"#533844","rgb":{"r":83,"g":56,"b":68},"luminance":41.911160530340844},{"name":"Ritzy","hex":"#d79c5f","rgb":{"r":215,"g":156,"b":95},"luminance":112.40676718507652},{"name":"River Bank","hex":"#7e705e","rgb":{"r":126,"g":112,"b":94},"luminance":76.52735764417845},{"name":"River Blue","hex":"#38afcd","rgb":{"r":56,"g":175,"b":205},"luminance":106.67213347918002},{"name":"River Fountain","hex":"#248591","rgb":{"r":36,"g":133,"b":145},"luminance":80.52444123991175},{"name":"River Reed","hex":"#dedbc4","rgb":{"r":222,"g":219,"b":196},"luminance":146.39387633709273},{"name":"River Rock","hex":"#d8cdc4","rgb":{"r":216,"g":205,"b":196},"luminance":138.38663091859706},{"name":"River Rouge","hex":"#ec9b9d","rgb":{"r":236,"g":155,"b":157},"luminance":116.52418944150608},{"name":"River Shark","hex":"#dfdcd5","rgb":{"r":223,"g":220,"b":213},"luminance":147.35188309960614},{"name":"River Styx","hex":"#161820","rgb":{"r":22,"g":24,"b":32},"luminance":15.970276516078235},{"name":"Riverbed","hex":"#556061","rgb":{"r":85,"g":96,"b":97},"luminance":62.799279398731954},{"name":"Rivergrass","hex":"#84a27b","rgb":{"r":132,"g":162,"b":123},"luminance":103.90961622487112},{"name":"Riverside","hex":"#4c6a92","rgb":{"r":76,"g":106,"b":146},"luminance":68.30066028963408},{"name":"Riveter Rose","hex":"#b7a9a2","rgb":{"r":183,"g":169,"b":162},"luminance":114.7878579031772},{"name":"Riviera","hex":"#189fac","rgb":{"r":24,"g":159,"b":172},"luminance":95.64004145231222},{"name":"Riviera Paradise","hex":"#009a9e","rgb":{"r":0,"g":154,"b":158},"luminance":92.17499958231625},{"name":"Riviera Rose","hex":"#f7b1a6","rgb":{"r":247,"g":177,"b":166},"luminance":128.86964571224675},{"name":"Riviera Sea","hex":"#1b8188","rgb":{"r":27,"g":129,"b":136},"luminance":77.7143492155728},{"name":"Rivulet","hex":"#d5dae1","rgb":{"r":213,"g":218,"b":225},"luminance":145.22139520401254},{"name":"Rix","hex":"#605655","rgb":{"r":96,"g":86,"b":85},"luminance":58.87485065798469},{"name":"Roadster Yellow","hex":"#f3dea2","rgb":{"r":243,"g":222,"b":162},"luminance":150.33910093186003},{"name":"Roan Rouge","hex":"#885157","rgb":{"r":136,"g":81,"b":87},"luminance":63.345440475222844},{"name":"Roast Coffee","hex":"#704341","rgb":{"r":112,"g":67,"b":65},"luminance":52.18356527681871},{"name":"Roasted Almond","hex":"#d2b49c","rgb":{"r":210,"g":180,"b":156},"luminance":124.18893008638089},{"name":"Roasted Cashew","hex":"#918579","rgb":{"r":145,"g":133,"b":121},"luminance":90.36045319718134},{"name":"Roasted Coconut","hex":"#ab8c72","rgb":{"r":171,"g":140,"b":114},"luminance":97.6556350499038},{"name":"Roasted Kona","hex":"#574038","rgb":{"r":87,"g":64,"b":56},"luminance":46.13877164598121},{"name":"Roasted Pecan","hex":"#93592b","rgb":{"r":147,"g":89,"b":43},"luminance":68.44871702230802},{"name":"Roasted Pistachio","hex":"#c9b27c","rgb":{"r":201,"g":178,"b":124},"luminance":121.363258414563},{"name":"Roasted Sienna","hex":"#ea7e5d","rgb":{"r":234,"g":126,"b":93},"luminance":102.36220495866625},{"name":"Roasted Squash","hex":"#e6a255","rgb":{"r":230,"g":162,"b":85},"luminance":117.75431132659219},{"name":"Rob Roy","hex":"#ddad56","rgb":{"r":221,"g":173,"b":86},"luminance":121.55310879611429},{"name":"Robeson Rose","hex":"#654f4f","rgb":{"r":101,"g":79,"b":79},"luminance":56.06730567808658},{"name":"Robin's Egg","hex":"#6dedfd","rgb":{"r":109,"g":237,"b":253},"luminance":145.76738457556272},{"name":"Robinhood","hex":"#6e6a3b","rgb":{"r":110,"g":106,"b":59},"luminance":70.70055487759625},{"name":"Robo Master","hex":"#adadad","rgb":{"r":173,"g":173,"b":173},"luminance":115.66004242606864},{"name":"Robot Grendizer Gold","hex":"#eeee11","rgb":{"r":238,"g":238,"b":17},"luminance":156.7978077780426},{"name":"Rock","hex":"#5a4d41","rgb":{"r":90,"g":77,"b":65},"luminance":53.122554541362184},{"name":"Rock Blue","hex":"#93a2ba","rgb":{"r":147,"g":162,"b":186},"luminance":106.88472604165666},{"name":"Rock Cliffs","hex":"#c0af92","rgb":{"r":192,"g":175,"b":146},"luminance":118.84917679563456},{"name":"Rock Slide","hex":"#a1968c","rgb":{"r":161,"g":150,"b":140},"luminance":101.61145319795402},{"name":"Rock Spray","hex":"#9d442d","rgb":{"r":157,"g":68,"b":45},"luminance":61.83242842554382},{"name":"Rock'n Oak","hex":"#8b785c","rgb":{"r":139,"g":120,"b":92},"luminance":82.45670661019636},{"name":"Rock'n'Rose","hex":"#fc8aaa","rgb":{"r":252,"g":138,"b":170},"luminance":112.3159718828983},{"name":"Rockabilly","hex":"#6c7186","rgb":{"r":108,"g":113,"b":134},"luminance":75.3387748838538},{"name":"Rockabye Baby","hex":"#f4e4e0","rgb":{"r":244,"g":228,"b":224},"luminance":154.5533568965747},{"name":"Rocket Man","hex":"#bebec3","rgb":{"r":190,"g":190,"b":195},"luminance":127.1239155312642},{"name":"Rocket Metallic","hex":"#8a7f80","rgb":{"r":138,"g":127,"b":128},"luminance":86.44670328589748},{"name":"Rocket Science","hex":"#ff3311","rgb":{"r":255,"g":51,"b":17},"luminance":81.93460708394224},{"name":"Rockfall","hex":"#aabbaa","rgb":{"r":170,"g":187,"b":170},"luminance":122.50921051496495},{"name":"Rockin Red","hex":"#bc363c","rgb":{"r":188,"g":54,"b":60},"luminance":64.8948206561972},{"name":"Rocking Chair","hex":"#721f37","rgb":{"r":114,"g":31,"b":55},"luminance":39.14459228297058},{"name":"Rockman Blue","hex":"#31a2f2","rgb":{"r":49,"g":162,"b":242},"luminance":100.09304861477644},{"name":"Rockmelon Rind","hex":"#d3e0b1","rgb":{"r":211,"g":224,"b":177},"luminance":147.2293032959132},{"name":"Rockpool","hex":"#519ea1","rgb":{"r":81,"g":158,"b":161},"luminance":97.59738619963139},{"name":"Rocky Creek","hex":"#3e4d50","rgb":{"r":62,"g":77,"b":80},"luminance":49.696895728002964},{"name":"Rocky Mountain Red","hex":"#76443e","rgb":{"r":118,"g":68,"b":62},"luminance":53.740703419289176},{"name":"Rocky Ridge","hex":"#918c86","rgb":{"r":145,"g":140,"b":134},"luminance":94.16243731446207},{"name":"Rocky Road","hex":"#5a3e36","rgb":{"r":90,"g":62,"b":54},"luminance":45.67896312308325},{"name":"Rococco Red","hex":"#bb363f","rgb":{"r":187,"g":54,"b":63},"luminance":64.67308479576337},{"name":"Rodan Gold","hex":"#fddc5c","rgb":{"r":253,"g":220,"b":92},"luminance":150.03201775954358},{"name":"Rodeo","hex":"#7f5e46","rgb":{"r":127,"g":94,"b":70},"luminance":67.45547281725923},{"name":"Rodeo Dust","hex":"#c7a384","rgb":{"r":199,"g":163,"b":132},"luminance":113.67350203983337},{"name":"Rodeo Roundup","hex":"#a68e6d","rgb":{"r":166,"g":142,"b":109},"luminance":97.80505481824547},{"name":"Rodham","hex":"#b2b26c","rgb":{"r":178,"g":178,"b":108},"luminance":117.90458355806189},{"name":"Roebuck","hex":"#b09080","rgb":{"r":176,"g":144,"b":128},"luminance":100.63396357095351},{"name":"Rogan Josh","hex":"#883311","rgb":{"r":136,"g":51,"b":17},"luminance":50.5325707737099},{"name":"Rogue","hex":"#807a6c","rgb":{"r":128,"g":122,"b":108},"luminance":82.12731776942431},{"name":"Rogue Cowboy","hex":"#ba9e88","rgb":{"r":186,"g":158,"b":136},"luminance":109.24793603542356},{"name":"Rogue Pink","hex":"#f8a4c0","rgb":{"r":248,"g":164,"b":192},"luminance":123.47117668508712},{"name":"Rohwurst","hex":"#734a45","rgb":{"r":115,"g":74,"b":69},"luminance":55.95589356805947},{"name":"Rokō Brown","hex":"#665343","rgb":{"r":102,"g":83,"b":67},"luminance":57.98450559416713},{"name":"Rokou Brown","hex":"#8c7042","rgb":{"r":140,"g":112,"b":66},"luminance":78.30162011095301},{"name":"Rokushō Green","hex":"#407a52","rgb":{"r":64,"g":122,"b":82},"luminance":74.71369751257127},{"name":"Roller Coaster","hex":"#8c8578","rgb":{"r":140,"g":133,"b":120},"luminance":89.63527788209282},{"name":"Roller Coaster Chariot","hex":"#0078be","rgb":{"r":0,"g":120,"b":190},"luminance":73.69497404843834},{"name":"Roller Derby","hex":"#8cffdb","rgb":{"r":140,"g":255,"b":219},"luminance":157.42032899533658},{"name":"Rolling Hills","hex":"#7c7e6a","rgb":{"r":124,"g":126,"b":106},"luminance":83.61238111667433},{"name":"Rolling Sea","hex":"#5a6d77","rgb":{"r":90,"g":109,"b":119},"luminance":70.7248806644451},{"name":"Rolling Stone","hex":"#6d7876","rgb":{"r":109,"g":120,"b":118},"luminance":78.77133479255002},{"name":"Rolling Waves","hex":"#bfd1c9","rgb":{"r":191,"g":209,"b":201},"luminance":137.25016490336176},{"name":"Roman","hex":"#d8625b","rgb":{"r":216,"g":98,"b":91},"luminance":87.10886067444574},{"name":"Roman Bath","hex":"#8c97a3","rgb":{"r":140,"g":151,"b":163},"luminance":99.77007614009322},{"name":"Roman Brick","hex":"#ab7f5b","rgb":{"r":171,"g":127,"b":91},"luminance":90.99092217358827},{"name":"Roman Bronze Coin","hex":"#514100","rgb":{"r":81,"g":65,"b":0},"luminance":45.192521350329635},{"name":"Roman Coffee","hex":"#7d6757","rgb":{"r":125,"g":103,"b":87},"luminance":71.7690035460992},{"name":"Roman Coin","hex":"#ac8760","rgb":{"r":172,"g":135,"b":96},"luminance":95.10194711466215},{"name":"Roman Empire Red","hex":"#ee1111","rgb":{"r":238,"g":17,"b":17},"luminance":71.88439697876028},{"name":"Roman Gold","hex":"#d19b2f","rgb":{"r":209,"g":155,"b":47},"luminance":110.50838642383663},{"name":"Roman Mosaic","hex":"#dad1ce","rgb":{"r":218,"g":209,"b":206},"luminance":140.89467651050552},{"name":"Roman Purple","hex":"#524765","rgb":{"r":82,"g":71,"b":101},"luminance":49.7059035628566},{"name":"Roman Silver","hex":"#838996","rgb":{"r":131,"g":137,"b":150},"luminance":91.07050083314574},{"name":"Roman Snail","hex":"#a49593","rgb":{"r":164,"g":149,"b":147},"luminance":101.66187205142349},{"name":"Roman Violet","hex":"#4d517f","rgb":{"r":77,"g":81,"b":127},"luminance":54.7757996016489},{"name":"Romance","hex":"#f4f0e6","rgb":{"r":244,"g":240,"b":230},"luminance":160.8018679493494},{"name":"Romantic","hex":"#ffc69e","rgb":{"r":255,"g":198,"b":158},"luminance":140.16495726464586},{"name":"Romantic Cruise","hex":"#e7e0ee","rgb":{"r":231,"g":224,"b":238},"luminance":150.98266896899128},{"name":"Romantic Isle","hex":"#007c75","rgb":{"r":0,"g":124,"b":117},"luminance":73.99996748647933},{"name":"Romantic Morning","hex":"#ddbbdd","rgb":{"r":221,"g":187,"b":221},"luminance":130.57720029928655},{"name":"Romantic Rose","hex":"#aa4488","rgb":{"r":170,"g":68,"b":136},"luminance":66.46314747286648},{"name":"Romeo","hex":"#e3d2ce","rgb":{"r":227,"g":210,"b":206},"luminance":142.6665177433023},{"name":"Ronchi","hex":"#eab852","rgb":{"r":234,"g":184,"b":82},"luminance":129.028501983089},{"name":"Rondo of Blood","hex":"#a60044","rgb":{"r":166,"g":0,"b":68},"luminance":50.23571896569213},{"name":"Roof Terracotta","hex":"#a14743","rgb":{"r":161,"g":71,"b":67},"luminance":64.13013873367187},{"name":"Rooibos Tea","hex":"#a23c26","rgb":{"r":162,"g":60,"b":38},"luminance":60.04543669588889},{"name":"Rooster Comb","hex":"#96463f","rgb":{"r":150,"g":70,"b":63},"luminance":61.24942223400968},{"name":"Root Beer","hex":"#714a41","rgb":{"r":113,"g":74,"b":65},"luminance":55.52773462874206},{"name":"Root Beer Float","hex":"#cfa46b","rgb":{"r":207,"g":164,"b":107},"luminance":115.09588384038761},{"name":"Root Brew","hex":"#290e05","rgb":{"r":41,"g":14,"b":5},"luminance":14.769681953244627},{"name":"Rope","hex":"#8e593c","rgb":{"r":142,"g":89,"b":60},"luminance":67.66681914350636},{"name":"Roquefort Blue","hex":"#aec6cf","rgb":{"r":174,"g":198,"b":207},"luminance":129.506962577307},{"name":"Rosa","hex":"#fe86a4","rgb":{"r":254,"g":134,"b":164},"luminance":110.92527347723782},{"name":"Rosarian","hex":"#faeadd","rgb":{"r":250,"g":234,"b":221},"luminance":158.39671808468762},{"name":"Rose","hex":"#ff007f","rgb":{"r":255,"g":0,"b":127},"luminance":77.60742560477057},{"name":"Rose Ashes","hex":"#b5acab","rgb":{"r":181,"g":172,"b":171},"luminance":116.2007379193437},{"name":"Rose Aspect","hex":"#f1c6ca","rgb":{"r":241,"g":198,"b":202},"luminance":138.67685942867325},{"name":"Rose Bisque","hex":"#c6a499","rgb":{"r":198,"g":164,"b":153},"luminance":114.3530847506966},{"name":"Rose Bonbon","hex":"#f9429e","rgb":{"r":249,"g":66,"b":158},"luminance":85.83895449619595},{"name":"Rose Branch","hex":"#80565b","rgb":{"r":128,"g":86,"b":91},"luminance":64.19344346582444},{"name":"Rose Brown","hex":"#bc8f8f","rgb":{"r":188,"g":143,"b":143},"luminance":102.33101010446441},{"name":"Rose Bud","hex":"#b65f9a","rgb":{"r":182,"g":95,"b":154},"luminance":79.87031416615312},{"name":"Rose Cloud","hex":"#dbb0a2","rgb":{"r":219,"g":176,"b":162},"luminance":123.70205224247493},{"name":"Rose Colored Glasses","hex":"#e5c4c0","rgb":{"r":229,"g":196,"b":192},"luminance":135.6625412153259},{"name":"Rose Daphne","hex":"#ff9ede","rgb":{"r":255,"g":158,"b":222},"luminance":122.70132601157984},{"name":"Rose Dawn","hex":"#b38380","rgb":{"r":179,"g":131,"b":128},"luminance":94.81862957246324},{"name":"Rose de Mai","hex":"#cb8e81","rgb":{"r":203,"g":142,"b":129},"luminance":104.15508418219439},{"name":"Rose Dragée","hex":"#eecffe","rgb":{"r":238,"g":207,"b":254},"luminance":143.75992926055577},{"name":"Rose Dusk","hex":"#e5a192","rgb":{"r":229,"g":161,"b":146},"luminance":117.8850017008101},{"name":"Rose Dust","hex":"#cdb2a5","rgb":{"r":205,"g":178,"b":165},"luminance":122.58962974493396},{"name":"Rose Ebony","hex":"#674846","rgb":{"r":103,"g":72,"b":70},"luminance":52.89972878002306},{"name":"Rose Fog","hex":"#e7bcb4","rgb":{"r":231,"g":188,"b":180},"luminance":131.79546235360306},{"name":"Rose Frost","hex":"#ffece9","rgb":{"r":255,"g":236,"b":233},"luminance":160.34324087095158},{"name":"Rose Fusion","hex":"#f96653","rgb":{"r":249,"g":102,"b":83},"luminance":96.00717015410879},{"name":"Rose Garnet","hex":"#960145","rgb":{"r":150,"g":1,"b":69},"luminance":45.53834675303881},{"name":"Rose Glory","hex":"#e585a5","rgb":{"r":229,"g":133,"b":165},"luminance":105.53281471656103},{"name":"Rose Glow","hex":"#ffdbeb","rgb":{"r":255,"g":219,"b":235},"luminance":151.84491408670888},{"name":"Rose Gold","hex":"#b76e79","rgb":{"r":183,"g":110,"b":121},"luminance":85.75260593707924},{"name":"Rose Hip","hex":"#fd0e35","rgb":{"r":253,"g":14,"b":53},"luminance":76.33157863558174},{"name":"Rose Hip Tonic","hex":"#dbb9b6","rgb":{"r":219,"g":185,"b":182},"luminance":128.4955831536633},{"name":"Rose Madder","hex":"#e33636","rgb":{"r":227,"g":54,"b":54},"luminance":75.16251505238498},{"name":"Rose Marble","hex":"#ceb9c4","rgb":{"r":206,"g":185,"b":196},"luminance":126.83039539873712},{"name":"Rose Mauve","hex":"#af9690","rgb":{"r":175,"g":150,"b":144},"luminance":103.73135100344543},{"name":"Rose Meadow","hex":"#c4989e","rgb":{"r":196,"g":152,"b":158},"luminance":108.25794721866842},{"name":"Rose Melody","hex":"#ecbfc9","rgb":{"r":236,"g":191,"b":201},"luminance":134.4416274113044},{"name":"Rose Mochi","hex":"#ffe9ed","rgb":{"r":255,"g":233,"b":237},"luminance":158.90116044258454},{"name":"Rose of Sharon","hex":"#ac512d","rgb":{"r":172,"g":81,"b":45},"luminance":70.22729734939256},{"name":"Rose Petal","hex":"#e6c1bb","rgb":{"r":230,"g":193,"b":187},"luminance":134.23345598247852},{"name":"Rose Pink","hex":"#ff66cc","rgb":{"r":255,"g":102,"b":204},"luminance":99.69472120929974},{"name":"Rose Pink Villa","hex":"#7c383e","rgb":{"r":124,"g":56,"b":62},"luminance":50.05152129556104},{"name":"Rose Quartz","hex":"#f7cac1","rgb":{"r":247,"g":202,"b":193},"luminance":141.41480505590636},{"name":"Rose Red","hex":"#c92351","rgb":{"r":201,"g":35,"b":81},"luminance":64.18141149896908},{"name":"Rose Reminder","hex":"#f4c0c6","rgb":{"r":244,"g":192,"b":198},"luminance":136.14060649196475},{"name":"Rose Romantic","hex":"#eed1cd","rgb":{"r":238,"g":209,"b":205},"luminance":143.74041057754079},{"name":"Rose Rush","hex":"#dd2255","rgb":{"r":221,"g":34,"b":85},"luminance":69.70403220044017},{"name":"Rose Shadow","hex":"#f9c2cd","rgb":{"r":249,"g":194,"b":205},"luminance":138.04820601876725},{"name":"Rose Smoke","hex":"#d3b4ad","rgb":{"r":211,"g":180,"b":173},"luminance":124.63231846114394},{"name":"Rose Stain","hex":"#d3b6ba","rgb":{"r":211,"g":182,"b":186},"luminance":125.87031060977007},{"name":"Rose Sugar","hex":"#fae6e5","rgb":{"r":250,"g":230,"b":229},"luminance":156.5144908179431},{"name":"Rose Tan","hex":"#fae8e1","rgb":{"r":250,"g":232,"b":225},"luminance":157.45337994466806},{"name":"Rose Tattoo","hex":"#e1a890","rgb":{"r":225,"g":168,"b":144},"luminance":120.50114579123303},{"name":"Rose Taupe","hex":"#905d5d","rgb":{"r":144,"g":93,"b":93},"luminance":70.33063927620735},{"name":"Rose Tea","hex":"#b48993","rgb":{"r":180,"g":137,"b":147},"luminance":98.20712054123162},{"name":"Rose Tonic","hex":"#ffdddd","rgb":{"r":255,"g":221,"b":221},"luminance":152.5684508343714},{"name":"Rose Turkish Delight","hex":"#db5079","rgb":{"r":219,"g":80,"b":121},"luminance":81.75131434417429},{"name":"Rose Vale","hex":"#ab4e5f","rgb":{"r":171,"g":78,"b":95},"luminance":69.48252540747205},{"name":"Rose Vapor","hex":"#f2dbd6","rgb":{"r":242,"g":219,"b":214},"luminance":149.5216331806204},{"name":"Rose Violet","hex":"#c0428a","rgb":{"r":192,"g":66,"b":138},"luminance":71.02194627014947},{"name":"Rose Water","hex":"#f6dbd8","rgb":{"r":246,"g":219,"b":216},"luminance":150.14128712982316},{"name":"Rose White","hex":"#fbeee8","rgb":{"r":251,"g":238,"b":232},"luminance":160.77815629307358},{"name":"Rose Wine","hex":"#9d5c75","rgb":{"r":157,"g":92,"b":117},"luminance":72.78722078084861},{"name":"Rose Yogurt","hex":"#d9bcb7","rgb":{"r":217,"g":188,"b":183},"luminance":129.70533323267782},{"name":"Roseberry","hex":"#f4a6a1","rgb":{"r":244,"g":166,"b":161},"luminance":123.10317061716972},{"name":"Rosebloom","hex":"#e290b2","rgb":{"r":226,"g":144,"b":178},"luminance":110.10446641258473},{"name":"Rosebud Cherry","hex":"#8a2d52","rgb":{"r":138,"g":45,"b":82},"luminance":49.87674781899879},{"name":"Rosemary","hex":"#405e5c","rgb":{"r":64,"g":94,"b":92},"luminance":59.336298536393386},{"name":"Rosenkavalier","hex":"#bc8a90","rgb":{"r":188,"g":138,"b":144},"luminance":99.95622059681928},{"name":"Roses are Red","hex":"#aa3646","rgb":{"r":170,"g":54,"b":70},"luminance":60.432876019597146},{"name":"Rosetta","hex":"#ba8f7f","rgb":{"r":186,"g":143,"b":127},"luminance":101.72817191417526},{"name":"Rosette","hex":"#ce8e8b","rgb":{"r":206,"g":142,"b":139},"luminance":104.84658252895036},{"name":"Rosewood","hex":"#65000b","rgb":{"r":101,"g":0,"b":11},"luminance":30.225024681544923},{"name":"Rosey Afterglow","hex":"#fac8ce","rgb":{"r":250,"g":200,"b":206},"luminance":141.14468022564648},{"name":"Rosie","hex":"#ffbbcc","rgb":{"r":255,"g":187,"b":204},"luminance":135.65903921965537},{"name":"Rosin","hex":"#36362d","rgb":{"r":54,"g":54,"b":45},"luminance":35.941249560915374},{"name":"Rosso Corsa","hex":"#d40000","rgb":{"r":212,"g":0,"b":0},"luminance":63.388},{"name":"Rosy Cheeks","hex":"#dc506e","rgb":{"r":220,"g":80,"b":110},"luminance":81.78937339288032},{"name":"Rosy Highlight","hex":"#f7d994","rgb":{"r":247,"g":217,"b":148},"luminance":148.20370991982622},{"name":"Rosy Maple Moth","hex":"#fec9ed","rgb":{"r":254,"g":201,"b":237},"luminance":142.894014601732},{"name":"Rosy Pink","hex":"#f6688e","rgb":{"r":246,"g":104,"b":142},"luminance":96.94895855036299},{"name":"Rosy Queen","hex":"#cf9384","rgb":{"r":207,"g":147,"b":132},"luminance":107.25193366089024},{"name":"Rosy Skin","hex":"#f7b978","rgb":{"r":247,"g":185,"b":120},"luminance":132.03894135443528},{"name":"Roti","hex":"#b69642","rgb":{"r":182,"g":150,"b":66},"luminance":103.78213622777282},{"name":"Rotting Flesh","hex":"#8aa775","rgb":{"r":138,"g":167,"b":117},"luminance":107.19206933817445},{"name":"Rotunda White","hex":"#d7d1c6","rgb":{"r":215,"g":209,"b":198},"luminance":140.33237295079135},{"name":"Rouge","hex":"#ab1239","rgb":{"r":171,"g":18,"b":57},"luminance":52.61215639944822},{"name":"Rouge Like","hex":"#a94064","rgb":{"r":169,"g":64,"b":100},"luminance":63.989816260089384},{"name":"Rouge Red","hex":"#e24666","rgb":{"r":226,"g":70,"b":102},"luminance":79.93649954807879},{"name":"Rouge Sarde","hex":"#ee2233","rgb":{"r":238,"g":34,"b":51},"luminance":74.1360546832646},{"name":"Rough Ride","hex":"#7a8687","rgb":{"r":122,"g":134,"b":135},"luminance":88.06007919596712},{"name":"Rough Stone","hex":"#9ea2aa","rgb":{"r":158,"g":162,"b":170},"luminance":107.93636921816483},{"name":"Roulette","hex":"#97635f","rgb":{"r":151,"g":99,"b":95},"luminance":74.38307515826433},{"name":"Rousseau Green","hex":"#175844","rgb":{"r":23,"g":88,"b":68},"luminance":52.68518737747831},{"name":"Roux","hex":"#994400","rgb":{"r":153,"g":68,"b":0},"luminance":60.71305514467213},{"name":"Rowan","hex":"#cb0162","rgb":{"r":203,"g":1,"b":98},"luminance":61.71939696724199},{"name":"Rowdy Orange","hex":"#eaa007","rgb":{"r":234,"g":160,"b":7},"luminance":117.11893254294968},{"name":"Rowntree","hex":"#8e8e6e","rgb":{"r":142,"g":142,"b":110},"luminance":94.381262335275},{"name":"Roxy Brown","hex":"#7a5546","rgb":{"r":122,"g":85,"b":70},"luminance":62.320429306929526},{"name":"Royal","hex":"#0c1793","rgb":{"r":12,"g":23,"b":147},"luminance":21.816995874776158},{"name":"Royal Azure","hex":"#0038a8","rgb":{"r":0,"g":56,"b":168},"luminance":38.04428324991811},{"name":"Royal Banner","hex":"#c74767","rgb":{"r":199,"g":71,"b":103},"luminance":73.58815049992764},{"name":"Royal Battle","hex":"#2f3844","rgb":{"r":47,"g":56,"b":68},"luminance":36.580714823524154},{"name":"Royal Blue","hex":"#4169e1","rgb":{"r":65,"g":105,"b":225},"luminance":69.5306763234761},{"name":"Royal Brown","hex":"#523b35","rgb":{"r":82,"g":59,"b":53},"luminance":42.86120363452244},{"name":"Royal Consort","hex":"#2e5686","rgb":{"r":46,"g":86,"b":134},"luminance":54.50652269224299},{"name":"Royal Coronation","hex":"#3e3542","rgb":{"r":62,"g":53,"b":66},"luminance":36.98867855168659},{"name":"Royal Curtsy","hex":"#282a4a","rgb":{"r":40,"g":42,"b":74},"luminance":28.671020421324386},{"name":"Royal Decree","hex":"#403547","rgb":{"r":64,"g":53,"b":71},"luminance":37.41114343347447},{"name":"Royal Flycatcher Crest","hex":"#ee6600","rgb":{"r":238,"g":102,"b":0},"luminance":92.99960279485067},{"name":"Royal Fuchsia","hex":"#ca2c92","rgb":{"r":202,"g":44,"b":146},"luminance":67.7644945675831},{"name":"Royal Heath","hex":"#b54b73","rgb":{"r":181,"g":75,"b":115},"luminance":70.98548362869693},{"name":"Royal Hunter Green","hex":"#3f5948","rgb":{"r":63,"g":89,"b":72},"luminance":56.13853295197515},{"name":"Royal Hyacinth","hex":"#464b6a","rgb":{"r":70,"g":75,"b":106},"luminance":50.22239123140195},{"name":"Royal Indigo","hex":"#4e4260","rgb":{"r":78,"g":66,"b":96},"luminance":46.525577739561705},{"name":"Royal Lavender","hex":"#7851a9","rgb":{"r":120,"g":81,"b":169},"luminance":62.60407626504843},{"name":"Royal Lilac","hex":"#774d8e","rgb":{"r":119,"g":77,"b":142},"luminance":59.757915843844486},{"name":"Royal Mail Red","hex":"#da202a","rgb":{"r":218,"g":32,"b":42},"luminance":68.00335818178394},{"name":"Royal Maroon","hex":"#543938","rgb":{"r":84,"g":57,"b":56},"luminance":42.32107740830802},{"name":"Royal Mile","hex":"#a1a0b7","rgb":{"r":161,"g":160,"b":183},"luminance":107.58044787506695},{"name":"Royal Navy Blue","hex":"#0066cc","rgb":{"r":0,"g":102,"b":204},"luminance":64.23190338141941},{"name":"Royal Oakleaf","hex":"#879473","rgb":{"r":135,"g":148,"b":115},"luminance":96.6883896908},{"name":"Royal Oranje","hex":"#ff7722","rgb":{"r":255,"g":119,"b":34},"luminance":103.47833111333019},{"name":"Royal Palm","hex":"#418d84","rgb":{"r":65,"g":141,"b":132},"luminance":86.33966538040322},{"name":"Royal Plum","hex":"#654161","rgb":{"r":101,"g":65,"b":97},"luminance":49.90053095909902},{"name":"Royal Pretender","hex":"#a063a1","rgb":{"r":160,"g":99,"b":161},"luminance":77.47680740066669},{"name":"Royal Purple","hex":"#4b006e","rgb":{"r":75,"g":0,"b":110},"luminance":25.693038454024858},{"name":"Royal Red Flush","hex":"#8e3c3f","rgb":{"r":142,"g":60,"b":63},"luminance":55.630129318562616},{"name":"Royal Robe","hex":"#614a7b","rgb":{"r":97,"g":74,"b":123},"luminance":54.08003639976585},{"name":"Royal Rum","hex":"#a54a4a","rgb":{"r":165,"g":74,"b":74},"luminance":66.27192591889872},{"name":"Royal Silk","hex":"#4b3841","rgb":{"r":75,"g":56,"b":65},"luminance":40.47662422930055},{"name":"Royal Silver","hex":"#e0dddd","rgb":{"r":224,"g":221,"b":221},"luminance":148.1540304581688},{"name":"Royal Yellow","hex":"#fada50","rgb":{"r":250,"g":218,"b":80},"luminance":148.47906942057523},{"name":"Rozowyi Pink","hex":"#f2a8b8","rgb":{"r":242,"g":168,"b":184},"luminance":124.09991215145965},{"name":"Rub Elbows","hex":"#5f5547","rgb":{"r":95,"g":85,"b":71},"luminance":57.98161679360105},{"name":"Rubber","hex":"#815b37","rgb":{"r":129,"g":91,"b":55},"luminance":66.18467216810852},{"name":"Rubber Band","hex":"#ce4676","rgb":{"r":206,"g":70,"b":118},"luminance":75.25400481037536},{"name":"Rubber Ducky","hex":"#facf58","rgb":{"r":250,"g":207,"b":88},"luminance":143.01272882159824},{"name":"Rubber Radish","hex":"#ff9999","rgb":{"r":255,"g":153,"b":153},"luminance":119.09466449006015},{"name":"Rubber Rose","hex":"#ffc5cb","rgb":{"r":255,"g":197,"b":203},"luminance":140.4322986709254},{"name":"Rubidium","hex":"#c5b9b4","rgb":{"r":197,"g":185,"b":180},"luminance":125.23381266255531},{"name":"Rubine","hex":"#6c383c","rgb":{"r":108,"g":56,"b":60},"luminance":46.584624587947474},{"name":"Rubine Red","hex":"#d10056","rgb":{"r":209,"g":0,"b":86},"luminance":63.255383146416875},{"name":"Ruby","hex":"#ca0147","rgb":{"r":202,"g":1,"b":71},"luminance":60.94075655093231},{"name":"Ruby Dust","hex":"#e0115f","rgb":{"r":224,"g":17,"b":95},"luminance":68.57589895145378},{"name":"Ruby Lips","hex":"#813e45","rgb":{"r":129,"g":62,"b":69},"luminance":53.61081265006155},{"name":"Ruby Red","hex":"#9b111e","rgb":{"r":155,"g":17,"b":30},"luminance":47.53036782942038},{"name":"Ruby Slippers","hex":"#9c2e33","rgb":{"r":156,"g":46,"b":51},"luminance":54.20860942691668},{"name":"Ruby Star","hex":"#bb1122","rgb":{"r":187,"g":17,"b":34},"luminance":56.928616582523766},{"name":"Ruby Wine","hex":"#77333b","rgb":{"r":119,"g":51,"b":59},"luminance":46.98372703394229},{"name":"Rucksack Tan","hex":"#edb508","rgb":{"r":237,"g":181,"b":8},"luminance":127.71382666727983},{"name":"Ruddy","hex":"#ff0028","rgb":{"r":255,"g":0,"b":40},"luminance":76.38123869773257},{"name":"Ruddy Brown","hex":"#bb6528","rgb":{"r":187,"g":101,"b":40},"luminance":81.62110963470172},{"name":"Ruddy Oak","hex":"#a5654e","rgb":{"r":165,"g":101,"b":78},"luminance":77.63992695771938},{"name":"Ruddy Pink","hex":"#e18e96","rgb":{"r":225,"g":142,"b":150},"luminance":108.47223119766643},{"name":"Rudraksha Beads","hex":"#894e45","rgb":{"r":137,"g":78,"b":69},"luminance":61.93705773605975},{"name":"Rufous","hex":"#a81c07","rgb":{"r":168,"g":28,"b":7},"luminance":52.85861068927181},{"name":"Rugby Tan","hex":"#c2a594","rgb":{"r":194,"g":165,"b":148},"luminance":114.15012678486168},{"name":"Ruined Smores","hex":"#0f1012","rgb":{"r":15,"g":16,"b":18},"luminance":10.608279455217984},{"name":"Rum","hex":"#716675","rgb":{"r":113,"g":102,"b":117},"luminance":70.03113228414917},{"name":"Rum Custard","hex":"#e9cfaa","rgb":{"r":233,"g":207,"b":170},"luminance":141.39841714106984},{"name":"Rum Punch","hex":"#aa423a","rgb":{"r":170,"g":66,"b":58},"luminance":64.25223737738632},{"name":"Rum Raisin","hex":"#583432","rgb":{"r":88,"g":52,"b":50},"luminance":40.70044127524909},{"name":"Rum Riche","hex":"#990044","rgb":{"r":153,"g":0,"b":68},"luminance":46.39915422720548},{"name":"Rum Swizzle","hex":"#f1edd4","rgb":{"r":241,"g":237,"b":212},"luminance":158.52661563914117},{"name":"Rumba Red","hex":"#7c2439","rgb":{"r":124,"g":36,"b":57},"luminance":43.16729322067808},{"name":"Runefang Steel","hex":"#c4c4c7","rgb":{"r":196,"g":196,"b":199},"luminance":131.09556100799142},{"name":"Runelord Brass","hex":"#b6a89a","rgb":{"r":182,"g":168,"b":154},"luminance":113.99406702105158},{"name":"Runic Mauve","hex":"#cab2c1","rgb":{"r":202,"g":178,"b":193},"luminance":122.67571317909669},{"name":"Rural Eyes","hex":"#99af73","rgb":{"r":153,"g":175,"b":115},"luminance":113.21256879869831},{"name":"Rural Red","hex":"#bb1144","rgb":{"r":187,"g":17,"b":68},"luminance":57.32309756110533},{"name":"Ruri Blue","hex":"#1e50a2","rgb":{"r":30,"g":80,"b":162},"luminance":51.25201970654424},{"name":"Rurikon Blue","hex":"#1b294b","rgb":{"r":27,"g":41,"b":75},"luminance":26.78612174242475},{"name":"Rushing River","hex":"#5f7797","rgb":{"r":95,"g":119,"b":151},"luminance":77.34731688946941},{"name":"Ruskie","hex":"#866c5e","rgb":{"r":134,"g":108,"b":94},"luminance":75.7573087431173},{"name":"Ruskin Blue","hex":"#546b75","rgb":{"r":84,"g":107,"b":117},"luminance":68.94698094188026},{"name":"Ruskin Bronze","hex":"#4d4d41","rgb":{"r":77,"g":77,"b":65},"luminance":51.26320542065234},{"name":"Ruskin Red","hex":"#935242","rgb":{"r":147,"g":82,"b":66},"luminance":65.61523253787949},{"name":"Russ Grey","hex":"#547588","rgb":{"r":84,"g":117,"b":136},"luminance":74.7528762857992},{"name":"Russet","hex":"#80461b","rgb":{"r":128,"g":70,"b":27},"luminance":56.23707111861356},{"name":"Russet Brown","hex":"#743332","rgb":{"r":116,"g":51,"b":50},"luminance":46.17026992557006},{"name":"Russet Green","hex":"#e3d9a0","rgb":{"r":227,"g":217,"b":160},"luminance":145.48144682398507},{"name":"Russet Leather","hex":"#965849","rgb":{"r":150,"g":88,"b":73},"luminance":68.9138630465598},{"name":"Russet Orange","hex":"#e47127","rgb":{"r":228,"g":113,"b":39},"luminance":95.22074385867819},{"name":"Russian Green","hex":"#679267","rgb":{"r":103,"g":146,"b":103},"luminance":91.82136231291713},{"name":"Russian Olive","hex":"#726647","rgb":{"r":114,"g":102,"b":71},"luminance":69.37048441520355},{"name":"Russian Toffee","hex":"#d0c4af","rgb":{"r":208,"g":196,"b":175},"luminance":132.29818618560117},{"name":"Russian Uniform","hex":"#5f6d36","rgb":{"r":95,"g":109,"b":54},"luminance":70.27492191386625},{"name":"Russian Violet","hex":"#32174d","rgb":{"r":50,"g":23,"b":77},"luminance":21.97345637354306},{"name":"Rust","hex":"#a83c09","rgb":{"r":168,"g":60,"b":9},"luminance":61.35759855144267},{"name":"Rust Brown","hex":"#8b3103","rgb":{"r":139,"g":49,"b":3},"luminance":50.544474020410966},{"name":"Rust Orange","hex":"#c45508","rgb":{"r":196,"g":85,"b":8},"luminance":76.972537862539},{"name":"Rust Red","hex":"#aa2704","rgb":{"r":170,"g":39,"b":4},"luminance":55.749316453208635},{"name":"Rusted Crimson","hex":"#60372e","rgb":{"r":96,"g":55,"b":46},"luminance":43.51712739830146},{"name":"Rusted Lock","hex":"#aa4411","rgb":{"r":170,"g":68,"b":17},"luminance":64.6585787038348},{"name":"Rustic Brown","hex":"#855141","rgb":{"r":133,"g":81,"b":65},"luminance":62.42627329898846},{"name":"Rustic Cabin","hex":"#705536","rgb":{"r":112,"g":85,"b":54},"luminance":60.40574066262245},{"name":"Rustic Hacienda","hex":"#9c8e74","rgb":{"r":156,"g":142,"b":116},"luminance":96.42834763698899},{"name":"Rustic Pottery","hex":"#df745b","rgb":{"r":223,"g":116,"b":91},"luminance":95.86429298231954},{"name":"Rustic Ranch","hex":"#8d794f","rgb":{"r":141,"g":121,"b":79},"luminance":83.08624462569},{"name":"Rustic Red","hex":"#3a181a","rgb":{"r":58,"g":24,"b":26},"luminance":22.538899795686568},{"name":"Rustic Taupe","hex":"#cdb9a2","rgb":{"r":205,"g":185,"b":162},"luminance":126.05958144464861},{"name":"Rustique","hex":"#f5bfb2","rgb":{"r":245,"g":191,"b":178},"luminance":135.45583035809128},{"name":"Rustling Leaves","hex":"#6b6d4e","rgb":{"r":107,"g":109,"b":78},"luminance":72.08636488268776},{"name":"Rusty","hex":"#96512a","rgb":{"r":150,"g":81,"b":42},"luminance":65.53750569711973},{"name":"Rusty Chainmail","hex":"#c6494c","rgb":{"r":198,"g":73,"b":76},"luminance":73.59449640428284},{"name":"Rusty Nail","hex":"#8d5f2c","rgb":{"r":141,"g":95,"b":44},"luminance":70.08763629913624},{"name":"Rusty Orange","hex":"#cd5909","rgb":{"r":205,"g":89,"b":9},"luminance":80.54477481500584},{"name":"Rusty Pebble","hex":"#e3dce0","rgb":{"r":227,"g":220,"b":224},"luminance":148.10797083546854},{"name":"Rusty Red","hex":"#af2f0d","rgb":{"r":175,"g":47,"b":13},"luminance":59.171402467746184},{"name":"Rusty Sand","hex":"#edb384","rgb":{"r":237,"g":179,"b":132},"luminance":127.62579050489755},{"name":"Rusty Sword","hex":"#a4493d","rgb":{"r":164,"g":73,"b":61},"luminance":65.49118729264266},{"name":"Rutabaga","hex":"#ecddbe","rgb":{"r":236,"g":221,"b":190},"luminance":149.25658519810776},{"name":"Ryn Flesh","hex":"#f6ebe7","rgb":{"r":246,"g":235,"b":231},"luminance":158.53231057737094},{"name":"Ryoku-Ou-Shoku Yellow","hex":"#dccb18","rgb":{"r":220,"g":203,"b":24},"luminance":136.1390392833738},{"name":"Ryu's Kimono","hex":"#f3f1e1","rgb":{"r":243,"g":241,"b":225},"luminance":161.0896465884757},{"name":"Ryza Dust","hex":"#ec631a","rgb":{"r":236,"g":99,"b":26},"luminance":91.46138070792502},{"name":"S'mores","hex":"#a87f5f","rgb":{"r":168,"g":127,"b":95},"luminance":90.5433383800266},{"name":"Saber-Toothed Tiger","hex":"#e69656","rgb":{"r":230,"g":150,"b":86},"luminance":112.15272540602835},{"name":"Sabiasagi Blue","hex":"#6a7f7a","rgb":{"r":106,"g":127,"b":122},"luminance":82.19182137536556},{"name":"Sabionando Grey","hex":"#455859","rgb":{"r":69,"g":88,"b":89},"luminance":56.541328362534955},{"name":"Sabiseiji Grey","hex":"#898a74","rgb":{"r":137,"g":138,"b":116},"luminance":91.73229301069499},{"name":"Sable","hex":"#6e403c","rgb":{"r":110,"g":64,"b":60},"luminance":50.39734441416532},{"name":"Sablé","hex":"#f6d8be","rgb":{"r":246,"g":216,"b":190},"luminance":148.1740793121388},{"name":"Sablewood","hex":"#ecdfd6","rgb":{"r":236,"g":223,"b":214},"luminance":150.6967641092535},{"name":"Sabz Green","hex":"#a5d610","rgb":{"r":165,"g":214,"b":16},"luminance":134.9709269620684},{"name":"Sachet Cushion","hex":"#d4d8ed","rgb":{"r":212,"g":216,"b":237},"luminance":144.30600171857023},{"name":"Sachet Pink","hex":"#f18aad","rgb":{"r":241,"g":138,"b":173},"luminance":110.19722682989804},{"name":"Sacramento State Green","hex":"#00563f","rgb":{"r":0,"g":86,"b":63},"luminance":50.990327004246595},{"name":"Sacred Blue","hex":"#97b9e0","rgb":{"r":151,"g":185,"b":224},"luminance":120.3469713869028},{"name":"Sacred Ground","hex":"#b2865d","rgb":{"r":178,"g":134,"b":93},"luminance":95.56183679691387},{"name":"Sacred Sapling","hex":"#7c8635","rgb":{"r":124,"g":134,"b":53},"luminance":87.16774921953646},{"name":"Sacred Turquoise","hex":"#49b3a5","rgb":{"r":73,"g":179,"b":165},"luminance":108.95214251220578},{"name":"Sacred Vortex","hex":"#a59c8d","rgb":{"r":165,"g":156,"b":141},"luminance":105.25087593459733},{"name":"Sacrifice","hex":"#2a5774","rgb":{"r":42,"g":87,"b":116},"luminance":54.22748658199087},{"name":"Sacrifice Altar","hex":"#850101","rgb":{"r":133,"g":1,"b":1},"luminance":39.77149549614648},{"name":"Saddle","hex":"#5d4e46","rgb":{"r":93,"g":78,"b":70},"luminance":54.15964775550151},{"name":"Saddle Brown","hex":"#8b4513","rgb":{"r":139,"g":69,"b":19},"luminance":58.073240705164714},{"name":"Saddle Soap","hex":"#9f906e","rgb":{"r":159,"g":144,"b":110},"luminance":97.78742794960914},{"name":"Saddle Up","hex":"#ab927a","rgb":{"r":171,"g":146,"b":122},"luminance":100.75931673547612},{"name":"Saddlebag","hex":"#8a534e","rgb":{"r":138,"g":83,"b":78},"luminance":64.46205200736321},{"name":"Safari","hex":"#baaa91","rgb":{"r":186,"g":170,"b":145},"luminance":115.43050721538046},{"name":"Safari Brown","hex":"#976c60","rgb":{"r":151,"g":108,"b":96},"luminance":78.59552247424786},{"name":"Safari Trail","hex":"#8f7b51","rgb":{"r":143,"g":123,"b":81},"luminance":84.41807985260029},{"name":"Safe Harbour","hex":"#1e8ea1","rgb":{"r":30,"g":142,"b":161},"luminance":85.82085720848983},{"name":"Safe Haven","hex":"#5588aa","rgb":{"r":85,"g":136,"b":170},"luminance":85.99217899902293},{"name":"Safety Orange","hex":"#ff6600","rgb":{"r":255,"g":102,"b":0},"luminance":96.94429277167377},{"name":"Safety Yellow","hex":"#eed202","rgb":{"r":238,"g":210,"b":2},"luminance":142.3361343018701},{"name":"Safflower","hex":"#fdae44","rgb":{"r":253,"g":174,"b":68},"luminance":127.33708476716434},{"name":"Safflower Bark","hex":"#bb5548","rgb":{"r":187,"g":85,"b":72},"luminance":75.38664243750347},{"name":"Safflower Kite","hex":"#9a493f","rgb":{"r":154,"g":73,"b":63},"luminance":63.30895229744368},{"name":"Safflower Purple","hex":"#b44c97","rgb":{"r":180,"g":76,"b":151},"luminance":71.99406044945653},{"name":"Safflower Red","hex":"#d9333f","rgb":{"r":217,"g":51,"b":63},"luminance":71.81649380191155},{"name":"Safflower Scarlet","hex":"#e83929","rgb":{"r":232,"g":57,"b":41},"luminance":77.157438921986},{"name":"Safflower Wisteria","hex":"#cca6bf","rgb":{"r":204,"g":166,"b":191},"luminance":117.00240363342968},{"name":"Safflowerish Sky","hex":"#8491c3","rgb":{"r":132,"g":145,"b":195},"luminance":96.41814740493616},{"name":"Saffron","hex":"#f4c430","rgb":{"r":244,"g":196,"b":48},"luminance":136.34325588014977},{"name":"Saffron Bread","hex":"#e8e9cf","rgb":{"r":232,"g":233,"b":207},"luminance":155.16150124628209},{"name":"Saffron Crocus","hex":"#584c77","rgb":{"r":88,"g":76,"b":119},"luminance":53.54052898505953},{"name":"Saffron Mango","hex":"#f9bf58","rgb":{"r":249,"g":191,"b":88},"luminance":134.9585644336809},{"name":"Saffron Robe","hex":"#d49f4e","rgb":{"r":212,"g":159,"b":78},"luminance":113.17312002856508},{"name":"Saffron Soufflé","hex":"#feb209","rgb":{"r":254,"g":178,"b":9},"luminance":129.17496579446032},{"name":"Saffron Sunset","hex":"#da9e35","rgb":{"r":218,"g":158,"b":53},"luminance":113.52100864597708},{"name":"Saffron Yellow","hex":"#d09b2c","rgb":{"r":208,"g":155,"b":44},"luminance":110.32350313963022},{"name":"Sagat Purple","hex":"#6a31ca","rgb":{"r":106,"g":49,"b":202},"luminance":48.60152866937417},{"name":"Sage","hex":"#87ae73","rgb":{"r":135,"g":174,"b":115},"luminance":110.60459470112441},{"name":"Sage Advice","hex":"#948b76","rgb":{"r":148,"g":139,"b":118},"luminance":93.79026312469753},{"name":"Sage Green","hex":"#887766","rgb":{"r":136,"g":119,"b":102},"luminance":81.65912618317685},{"name":"Sage Leaves","hex":"#7b8b5d","rgb":{"r":123,"g":139,"b":93},"luminance":90.12417978544936},{"name":"Sage Splash","hex":"#e4e5d2","rgb":{"r":228,"g":229,"b":210},"luminance":152.61090430568845},{"name":"Sage Splendor","hex":"#c3c6a4","rgb":{"r":195,"g":198,"b":164},"luminance":131.3677910181944},{"name":"Sagebrush Green","hex":"#567572","rgb":{"r":86,"g":117,"b":114},"luminance":74.47758624579613},{"name":"Sago","hex":"#d8cfc3","rgb":{"r":216,"g":207,"b":195},"luminance":139.3904696778083},{"name":"Sago Garden","hex":"#94be7f","rgb":{"r":148,"g":190,"b":127},"luminance":120.85856563769072},{"name":"Sahara","hex":"#b79826","rgb":{"r":183,"g":152,"b":38},"luminance":104.7551358597754},{"name":"Sahara Dust","hex":"#a8989b","rgb":{"r":168,"g":152,"b":155},"luminance":103.90575008150414},{"name":"Sahara Gravel","hex":"#dfc08a","rgb":{"r":223,"g":192,"b":138},"luminance":131.89203830785237},{"name":"Sahara Sand","hex":"#f1e788","rgb":{"r":241,"g":231,"b":136},"luminance":154.33541364832635},{"name":"Sahara Splendor","hex":"#9b7448","rgb":{"r":155,"g":116,"b":72},"luminance":82.77530279618432},{"name":"Sahara Sun","hex":"#c67363","rgb":{"r":198,"g":115,"b":99},"luminance":90.49406403184686},{"name":"Sahara Wind","hex":"#dfd4b7","rgb":{"r":223,"g":212,"b":183},"luminance":142.71424073651514},{"name":"Sail","hex":"#a5ceec","rgb":{"r":165,"g":206,"b":236},"luminance":133.34128214847794},{"name":"Sail Away","hex":"#55b4de","rgb":{"r":85,"g":180,"b":222},"luminance":111.58159655158192},{"name":"Sail Cover","hex":"#588fa0","rgb":{"r":88,"g":143,"b":160},"luminance":89.83935899704538},{"name":"Sail Maker","hex":"#0e4d72","rgb":{"r":14,"g":77,"b":114},"luminance":47.21618592177898},{"name":"Sail On","hex":"#4575ad","rgb":{"r":69,"g":117,"b":173},"luminance":74.37338560264686},{"name":"Sail to the Sea","hex":"#99c3f0","rgb":{"r":153,"g":195,"b":240},"luminance":126.26794460194557},{"name":"Sailcloth","hex":"#ece0c4","rgb":{"r":236,"g":224,"b":196},"luminance":150.88945150672396},{"name":"Sailing Safari","hex":"#3a5161","rgb":{"r":58,"g":81,"b":97},"luminance":51.80484086453697},{"name":"Sailor Blue","hex":"#0e3a53","rgb":{"r":14,"g":58,"b":83},"luminance":35.58345340182709},{"name":"Sailor Boy","hex":"#aebbd0","rgb":{"r":174,"g":187,"b":208},"luminance":123.76670384638996},{"name":"Sailor Moon Locks","hex":"#ffee00","rgb":{"r":255,"g":238,"b":0},"luminance":159.15736382901042},{"name":"Sailor's Coat","hex":"#334b58","rgb":{"r":51,"g":75,"b":88},"luminance":47.65893043281605},{"name":"Sailor's Knot","hex":"#b8a47a","rgb":{"r":184,"g":164,"b":122},"luminance":111.7484699850517},{"name":"Sainsbury","hex":"#66b89c","rgb":{"r":102,"g":184,"b":156},"luminance":113.6315393013753},{"name":"Saint Seiya Gold","hex":"#eeee00","rgb":{"r":238,"g":238,"b":0},"luminance":156.78583060978437},{"name":"Saira Red","hex":"#ff9bb7","rgb":{"r":255,"g":155,"b":183},"luminance":120.52714753946515},{"name":"Sakura","hex":"#dfb1b6","rgb":{"r":223,"g":177,"b":182},"luminance":125.18507911887902},{"name":"Sakura Mochi","hex":"#cea19f","rgb":{"r":206,"g":161,"b":159},"luminance":114.25386540944686},{"name":"Sakura Nezu","hex":"#e8dfe4","rgb":{"r":232,"g":223,"b":228},"luminance":150.4080293368675},{"name":"Salad","hex":"#8ba673","rgb":{"r":139,"g":166,"b":115},"luminance":106.74330042208737},{"name":"Saladin","hex":"#7e8f69","rgb":{"r":126,"g":143,"b":105},"luminance":92.78309467246713},{"name":"Salal Leaves","hex":"#637d74","rgb":{"r":99,"g":125,"b":116},"luminance":80.21835202745068},{"name":"Salamander","hex":"#63775b","rgb":{"r":99,"g":119,"b":91},"luminance":76.57206204615362},{"name":"Salami","hex":"#820000","rgb":{"r":130,"g":0,"b":0},"luminance":38.87},{"name":"Salami Slice","hex":"#da655e","rgb":{"r":218,"g":101,"b":94},"luminance":88.76076920013706},{"name":"Salem","hex":"#177b4d","rgb":{"r":23,"g":123,"b":77},"luminance":73.05703808668949},{"name":"Salem Black","hex":"#45494d","rgb":{"r":69,"g":73,"b":77},"luminance":48.362171642720924},{"name":"Salem Blue","hex":"#66a9d3","rgb":{"r":102,"g":169,"b":211},"luminance":106.53618225279146},{"name":"Salina Springs","hex":"#cad2d4","rgb":{"r":202,"g":210,"b":212},"luminance":139.38257971497012},{"name":"Saline Water","hex":"#c5e8e7","rgb":{"r":197,"g":232,"b":231},"luminance":150.6954704727385},{"name":"Salisbury Stone","hex":"#ddd8c6","rgb":{"r":221,"g":216,"b":198},"luminance":144.74854295985156},{"name":"Salmon","hex":"#ff796c","rgb":{"r":255,"g":121,"b":108},"luminance":104.92721333381535},{"name":"Salmon Buff","hex":"#feaa7b","rgb":{"r":254,"g":170,"b":123},"luminance":126.18421256242794},{"name":"Salmon Carpaccio","hex":"#ee867d","rgb":{"r":238,"g":134,"b":125},"luminance":107.02417347496778},{"name":"Salmon Eggs","hex":"#f7d560","rgb":{"r":247,"g":213,"b":96},"luminance":145.625504998266},{"name":"Salmon Grey","hex":"#e3b6aa","rgb":{"r":227,"g":182,"b":170},"luminance":128.04621074049788},{"name":"Salmon Nigiri","hex":"#f9906f","rgb":{"r":249,"g":144,"b":111},"luminance":113.34927393239005},{"name":"Salmon Orange","hex":"#ff8c69","rgb":{"r":255,"g":140,"b":105},"luminance":112.73922709066262},{"name":"Salmon Pate","hex":"#d5847e","rgb":{"r":213,"g":132,"b":126},"luminance":101.32190642205661},{"name":"Salmon Pink","hex":"#ff91a4","rgb":{"r":255,"g":145,"b":164},"luminance":115.79034357838307},{"name":"Salmon Rose","hex":"#ff8d94","rgb":{"r":255,"g":141,"b":148},"luminance":113.79077597942637},{"name":"Salmon Run","hex":"#edaf9c","rgb":{"r":237,"g":175,"b":156},"luminance":126.05657876525127},{"name":"Salmon Salt","hex":"#e7968b","rgb":{"r":231,"g":150,"b":139},"luminance":113.0240017739595},{"name":"Salmon Sashimi","hex":"#ff7e79","rgb":{"r":255,"g":126,"b":121},"luminance":107.11653422791458},{"name":"Salmon Slice","hex":"#f1ac8d","rgb":{"r":241,"g":172,"b":141},"luminance":125.07838443552107},{"name":"Salmon Smoke","hex":"#d4bfbd","rgb":{"r":212,"g":191,"b":189},"luminance":130.5851842629936},{"name":"Salmon Tartare","hex":"#ff9baa","rgb":{"r":255,"g":155,"b":170},"luminance":120.27948557422417},{"name":"Salmon Upstream","hex":"#ffa8a6","rgb":{"r":255,"g":168,"b":166},"luminance":126.0814548496328},{"name":"Salome","hex":"#bbeddb","rgb":{"r":187,"g":237,"b":219},"luminance":151.99888448932776},{"name":"Salomie","hex":"#ffd67b","rgb":{"r":255,"g":214,"b":123},"luminance":147.61367969466787},{"name":"Salon Bleu","hex":"#7d8697","rgb":{"r":125,"g":134,"b":151},"luminance":88.77101658199032},{"name":"Salsa","hex":"#aa182b","rgb":{"r":170,"g":24,"b":43},"luminance":52.973486273795494},{"name":"Salsa Diane","hex":"#bb4f5c","rgb":{"r":187,"g":79,"b":92},"luminance":73.39425619215716},{"name":"Salsify Grass","hex":"#2bb179","rgb":{"r":43,"g":177,"b":121},"luminance":105.59630242579519},{"name":"Salt Blue","hex":"#7d9c9d","rgb":{"r":125,"g":156,"b":157},"luminance":100.51199039418131},{"name":"Salt Box","hex":"#f5e9d9","rgb":{"r":245,"g":233,"b":217},"luminance":157.1132397667364},{"name":"Salt Box Blue","hex":"#648fa4","rgb":{"r":100,"g":143,"b":164},"luminance":91.04747056892903},{"name":"Salt Island Green","hex":"#757261","rgb":{"r":117,"g":114,"b":97},"luminance":76.31584617233828},{"name":"Salt Lake","hex":"#74c6d3","rgb":{"r":116,"g":198,"b":211},"luminance":123.6529734701111},{"name":"Salt n Pepa","hex":"#dcd9db","rgb":{"r":220,"g":217,"b":219},"luminance":145.51879327770692},{"name":"Salt Spray","hex":"#a7c5ce","rgb":{"r":167,"g":197,"b":206},"luminance":128.12954798172044},{"name":"Salt Steppe","hex":"#eeddbb","rgb":{"r":238,"g":221,"b":187},"luminance":149.49107631226687},{"name":"Salt Water","hex":"#95bbd8","rgb":{"r":149,"g":187,"b":216},"luminance":120.99738153365138},{"name":"Salt Water Taffy","hex":"#d1ab99","rgb":{"r":209,"g":171,"b":153},"luminance":119.51941505044275},{"name":"Salted Pretzel","hex":"#816b56","rgb":{"r":129,"g":107,"b":86},"luminance":74.35597446069818},{"name":"Saltpan","hex":"#eef3e5","rgb":{"r":238,"g":243,"b":229},"luminance":161.53020881866027},{"name":"Salty Breeze","hex":"#dde2d7","rgb":{"r":221,"g":226,"b":215},"luminance":150.22110565762722},{"name":"Salty Cracker","hex":"#e2c681","rgb":{"r":226,"g":198,"b":129},"luminance":135.24420500709078},{"name":"Salty Seeds","hex":"#c1b993","rgb":{"r":193,"g":185,"b":147},"luminance":124.1120559736241},{"name":"Salty Tears","hex":"#bacad4","rgb":{"r":186,"g":202,"b":212},"luminance":133.17958813571994},{"name":"Salty Thyme","hex":"#96b403","rgb":{"r":150,"g":180,"b":3},"luminance":114.78534341979379},{"name":"Salty Vapour","hex":"#cbdee3","rgb":{"r":203,"g":222,"b":227},"luminance":146.06688635347848},{"name":"Salute","hex":"#282b34","rgb":{"r":40,"g":43,"b":52},"luminance":28.55329867108177},{"name":"Salvation","hex":"#514e5c","rgb":{"r":81,"g":78,"b":92},"luminance":52.84804538485789},{"name":"Salvia","hex":"#a8b59e","rgb":{"r":168,"g":181,"b":158},"luminance":118.89537828275749},{"name":"Salvia Divinorum","hex":"#929752","rgb":{"r":146,"g":151,"b":82},"luminance":99.24502299359902},{"name":"Samantha's Room","hex":"#f2d7e6","rgb":{"r":242,"g":215,"b":230},"luminance":147.82039977283245},{"name":"Samba","hex":"#a2242f","rgb":{"r":162,"g":36,"b":47},"luminance":53.11788241261129},{"name":"Samba de Coco","hex":"#f0e0d4","rgb":{"r":240,"g":224,"b":212},"luminance":151.73227727810584},{"name":"Sambuca","hex":"#3b2e25","rgb":{"r":59,"g":46,"b":37},"luminance":32.52851685828912},{"name":"Sambucus","hex":"#17182b","rgb":{"r":23,"g":24,"b":43},"luminance":16.425421668864395},{"name":"Samoan Sun","hex":"#fbc85f","rgb":{"r":251,"g":200,"b":95},"luminance":139.75836755271578},{"name":"Samphire Green","hex":"#4db560","rgb":{"r":77,"g":181,"b":96},"luminance":109.26232046776235},{"name":"San Carlos Plaza","hex":"#d9bb8e","rgb":{"r":217,"g":187,"b":142},"luminance":128.53438603735577},{"name":"San Felix","hex":"#2c6e31","rgb":{"r":44,"g":110,"b":49},"luminance":66.13296176642929},{"name":"San Francisco Fog","hex":"#c4c2bc","rgb":{"r":196,"g":194,"b":188},"luminance":129.85360343094064},{"name":"San Francisco Mauve","hex":"#936a6d","rgb":{"r":147,"g":106,"b":109},"luminance":77.18710364432648},{"name":"San Gabriel Blue","hex":"#2f6679","rgb":{"r":47,"g":102,"b":121},"luminance":63.02901808690978},{"name":"San Juan","hex":"#445761","rgb":{"r":68,"g":87,"b":97},"luminance":56.06881797398622},{"name":"San Marino","hex":"#4e6c9d","rgb":{"r":78,"g":108,"b":157},"luminance":69.88066187436979},{"name":"San Miguel Blue","hex":"#527585","rgb":{"r":82,"g":117,"b":133},"luminance":74.48371371648973},{"name":"Sanctuary","hex":"#d4c9a6","rgb":{"r":212,"g":201,"b":166},"luminance":135.2667309023176},{"name":"Sanctuary Spa","hex":"#66b2e4","rgb":{"r":102,"g":178,"b":228},"luminance":111.90637275865927},{"name":"Sand","hex":"#e2ca76","rgb":{"r":226,"g":202,"b":118},"luminance":137.13859870948076},{"name":"Sand Blast","hex":"#decbab","rgb":{"r":222,"g":203,"b":171},"luminance":137.7875133711324},{"name":"Sand Brown","hex":"#cba560","rgb":{"r":203,"g":165,"b":96},"luminance":114.82503198344861},{"name":"Sand Dagger","hex":"#e6ddd2","rgb":{"r":230,"g":221,"b":210},"luminance":148.76670000036972},{"name":"Sand Diamond","hex":"#fae8bc","rgb":{"r":250,"g":232,"b":188},"luminance":156.82147486871816},{"name":"Sand Dollar","hex":"#decdbe","rgb":{"r":222,"g":205,"b":190},"luminance":139.12478826219288},{"name":"Sand Dune","hex":"#e3d2c0","rgb":{"r":227,"g":210,"b":192},"luminance":142.4125049741068},{"name":"Sand Fossil","hex":"#decfb3","rgb":{"r":222,"g":207,"b":179},"luminance":139.95313787479006},{"name":"Sand Grain","hex":"#e3e4d9","rgb":{"r":227,"g":228,"b":217},"luminance":152.0880918053744},{"name":"Sand Paper","hex":"#ccbb88","rgb":{"r":204,"g":187,"b":136},"luminance":126.53110049707146},{"name":"Sand Pebble","hex":"#b09d7f","rgb":{"r":176,"g":157,"b":127},"luminance":107.10825897660739},{"name":"Sand Puffs","hex":"#e6e5d3","rgb":{"r":230,"g":229,"b":211},"luminance":152.896863097318},{"name":"Sand Pyramid","hex":"#ddcc77","rgb":{"r":221,"g":204,"b":119},"luminance":137.44109320359757},{"name":"Sand Shark","hex":"#5a86ad","rgb":{"r":90,"g":134,"b":173},"luminance":85.44112796540084},{"name":"Sand Trail","hex":"#d0c6a1","rgb":{"r":208,"g":198,"b":161},"luminance":133.09093603998733},{"name":"Sand Verbena","hex":"#9f90c1","rgb":{"r":159,"g":144,"b":193},"luminance":99.44454469200409},{"name":"Sand Yellow","hex":"#fdee73","rgb":{"r":253,"g":238,"b":115},"luminance":159.41175347194445},{"name":"Sandal","hex":"#a3876a","rgb":{"r":163,"g":135,"b":106},"luminance":93.81411540914299},{"name":"Sandalwood","hex":"#615543","rgb":{"r":97,"g":85,"b":67},"luminance":58.215325112894455},{"name":"Sandbank","hex":"#e9d5ad","rgb":{"r":233,"g":213,"b":173},"luminance":144.48252189797907},{"name":"Sandcastle","hex":"#e5d7c4","rgb":{"r":229,"g":215,"b":196},"luminance":145.31081928748458},{"name":"Sandgrass Green","hex":"#93917f","rgb":{"r":147,"g":145,"b":127},"luminance":96.88158709476222},{"name":"Sanding Sugar","hex":"#efebde","rgb":{"r":239,"g":235,"b":222},"luminance":157.40391484966312},{"name":"Sandpaper","hex":"#d7b1a5","rgb":{"r":215,"g":177,"b":165},"luminance":123.61787704858872},{"name":"Sandpiper","hex":"#ebdac8","rgb":{"r":235,"g":218,"b":200},"luminance":147.75759669472157},{"name":"Sandpiper Cove","hex":"#717474","rgb":{"r":113,"g":116,"b":116},"luminance":77.15540168387435},{"name":"Sandpit","hex":"#9e7c5e","rgb":{"r":158,"g":124,"b":94},"luminance":87.43415902266115},{"name":"Sandrift","hex":"#af937d","rgb":{"r":175,"g":147,"b":125},"luminance":101.91545342096065},{"name":"Sandshell","hex":"#d8ccbb","rgb":{"r":216,"g":204,"b":187},"luminance":137.71395602479802},{"name":"Sandstone","hex":"#c9ae74","rgb":{"r":201,"g":174,"b":116},"luminance":119.24317599342949},{"name":"Sandstorm","hex":"#ecd540","rgb":{"r":236,"g":213,"b":64},"luminance":143.7541674978503},{"name":"Sandwashed Glassshard","hex":"#dee8e3","rgb":{"r":222,"g":232,"b":227},"luminance":153.6938242871196},{"name":"Sandwisp","hex":"#decb81","rgb":{"r":222,"g":203,"b":129},"luminance":137.19201595209537},{"name":"Sandworm","hex":"#fce883","rgb":{"r":252,"g":232,"b":131},"luminance":156.35353311006438},{"name":"Sandy","hex":"#f1da7a","rgb":{"r":241,"g":218,"b":122},"luminance":147.5168773428993},{"name":"Sandy Ash","hex":"#e4ded5","rgb":{"r":228,"g":222,"b":213},"luminance":149.05963807818668},{"name":"Sandy Beach","hex":"#f9e2d0","rgb":{"r":249,"g":226,"b":208},"luminance":153.9623869294056},{"name":"Sandy Day","hex":"#d7cfc1","rgb":{"r":215,"g":207,"b":193},"luminance":139.21597002499388},{"name":"Sandy Pail","hex":"#d2c098","rgb":{"r":210,"g":192,"b":152},"luminance":130.17309745104782},{"name":"Sandy Shore","hex":"#f2e9bb","rgb":{"r":242,"g":233,"b":187},"luminance":156.19360975724967},{"name":"Sandy Tan","hex":"#fdd9b5","rgb":{"r":253,"g":217,"b":181},"luminance":149.57820765739908},{"name":"Sandy Taupe","hex":"#967111","rgb":{"r":150,"g":113,"b":17},"luminance":80.09419395311997},{"name":"Sandy Toes","hex":"#c7b8a4","rgb":{"r":199,"g":184,"b":164},"luminance":124.72224132447266},{"name":"Sang de Boeuf","hex":"#771100","rgb":{"r":119,"g":17,"b":0},"luminance":36.953863153938315},{"name":"Sango Pink","hex":"#f5b1aa","rgb":{"r":245,"g":177,"b":170},"luminance":128.59580718670418},{"name":"Sango Red","hex":"#f8674f","rgb":{"r":248,"g":103,"b":79},"luminance":96.09973809017379},{"name":"Sangoire Red","hex":"#881100","rgb":{"r":136,"g":17,"b":0},"luminance":41.87053065104382},{"name":"Sangria","hex":"#b14566","rgb":{"r":177,"g":69,"b":102},"luminance":67.65018345873128},{"name":"Sanguine Brown","hex":"#6c3736","rgb":{"r":108,"g":55,"b":54},"luminance":46.07592457021345},{"name":"Sanskrit","hex":"#e69332","rgb":{"r":230,"g":147,"b":50},"luminance":110.48798315201522},{"name":"Santa Fe","hex":"#b16d52","rgb":{"r":177,"g":109,"b":82},"luminance":83.5586819067893},{"name":"Santa Fe Sunrise","hex":"#cc9469","rgb":{"r":204,"g":148,"b":105},"luminance":106.82336959673195},{"name":"Santa Fe Sunset","hex":"#a75a4c","rgb":{"r":167,"g":90,"b":76},"luminance":73.20777475787663},{"name":"Santana Soul","hex":"#714636","rgb":{"r":113,"g":70,"b":54},"luminance":53.552271707183436},{"name":"Santas Grey","hex":"#9fa0b1","rgb":{"r":159,"g":160,"b":177},"luminance":107.18332316643293},{"name":"Santiago Orange","hex":"#e95f24","rgb":{"r":233,"g":95,"b":36},"luminance":89.33123154865828},{"name":"Santolina Blooms","hex":"#e3d0d5","rgb":{"r":227,"g":208,"b":213},"luminance":141.7878445742088},{"name":"Santorini","hex":"#41b0d0","rgb":{"r":65,"g":176,"b":208},"luminance":107.76524260168489},{"name":"Sap Green","hex":"#5c8b15","rgb":{"r":92,"g":139,"b":21},"luminance":86.13848703686406},{"name":"Sapless Green","hex":"#bebdac","rgb":{"r":190,"g":189,"b":172},"luminance":126.17527100426612},{"name":"Sapling","hex":"#e1d5a6","rgb":{"r":225,"g":213,"b":166},"luminance":143.23684708202703},{"name":"Sappanwood","hex":"#9e3d3f","rgb":{"r":158,"g":61,"b":63},"luminance":59.71205018252177},{"name":"Sappanwood Incense","hex":"#a24f46","rgb":{"r":162,"g":79,"b":70},"luminance":67.53055140453097},{"name":"Sappanwood Perfume","hex":"#a86965","rgb":{"r":168,"g":105,"b":101},"luminance":80.34114291569419},{"name":"Sapphire","hex":"#0f52ba","rgb":{"r":15,"g":82,"b":186},"luminance":52.78832064955278},{"name":"Sapphire Blue","hex":"#0067bc","rgb":{"r":0,"g":103,"b":188},"luminance":64.1471990425147},{"name":"Sapphire Fog","hex":"#99a8c9","rgb":{"r":153,"g":168,"b":201},"luminance":111.09885175374227},{"name":"Sapphire Siren","hex":"#662288","rgb":{"r":102,"g":34,"b":136},"luminance":39.60838022439191},{"name":"Sapphire Stone","hex":"#41495d","rgb":{"r":65,"g":73,"b":93},"luminance":48.23204152842796},{"name":"Saratoga","hex":"#555b2c","rgb":{"r":85,"g":91,"b":44},"luminance":59.36714891250884},{"name":"Sarawak White Pepper","hex":"#f4eeba","rgb":{"r":244,"g":238,"b":186},"luminance":159.02815470224132},{"name":"Sarcoline","hex":"#ffddaa","rgb":{"r":255,"g":221,"b":170},"luminance":151.71677215786},{"name":"Sardinia Beaches","hex":"#28a4cb","rgb":{"r":40,"g":164,"b":203},"luminance":99.73024409876876},{"name":"Sargasso Sea","hex":"#35435a","rgb":{"r":53,"g":67,"b":90},"luminance":43.62528223404406},{"name":"Sarsaparilla","hex":"#5b4c44","rgb":{"r":91,"g":76,"b":68},"luminance":52.82663844122584},{"name":"Sasquatch Socks","hex":"#ff4681","rgb":{"r":255,"g":70,"b":129},"luminance":87.851889911373},{"name":"Sassafras","hex":"#54353b","rgb":{"r":84,"g":53,"b":59},"luminance":40.545614473084505},{"name":"Sassafras Tea","hex":"#dbd8ca","rgb":{"r":219,"g":216,"b":202},"luminance":144.54847425344894},{"name":"Sassy","hex":"#c18862","rgb":{"r":193,"g":136,"b":98},"luminance":99.13657073451753},{"name":"Sassy Pink","hex":"#f6cefc","rgb":{"r":246,"g":206,"b":252},"luminance":144.42167075615765},{"name":"Satellite","hex":"#9f8d89","rgb":{"r":159,"g":141,"b":137},"luminance":96.71837929783563},{"name":"Satin Blush","hex":"#ffe4c6","rgb":{"r":255,"g":228,"b":198},"luminance":155.6755282791743},{"name":"Satin Green","hex":"#c7dfb8","rgb":{"r":199,"g":223,"b":184},"luminance":145.3115046305694},{"name":"Satin Latour","hex":"#fad7b0","rgb":{"r":250,"g":215,"b":176},"luminance":148.04671094286422},{"name":"Satin Linen","hex":"#e6e4d4","rgb":{"r":230,"g":228,"b":212},"luminance":152.39908142767788},{"name":"Satin Pink","hex":"#fbe0dc","rgb":{"r":251,"g":224,"b":220},"luminance":153.46156829968862},{"name":"Satin Purse","hex":"#fff8ee","rgb":{"r":255,"g":248,"b":238},"luminance":166.55875007035803},{"name":"Satin Ribbon","hex":"#ffd8dc","rgb":{"r":255,"g":216,"b":220},"luminance":150.06171293504548},{"name":"Satin Sheen Gold","hex":"#cba135","rgb":{"r":203,"g":161,"b":53},"luminance":112.48201910527743},{"name":"Satin Soil","hex":"#6b4836","rgb":{"r":107,"g":72,"b":54},"luminance":53.36378997972314},{"name":"Satin Weave","hex":"#f3edd9","rgb":{"r":243,"g":237,"b":217},"luminance":158.8870808278634},{"name":"Sativa","hex":"#b5bf50","rgb":{"r":181,"g":191,"b":80},"luminance":124.82893194287932},{"name":"Satoimo Brown","hex":"#654321","rgb":{"r":101,"g":67,"b":33},"luminance":49.72828657816394},{"name":"Satsuma Imo Red","hex":"#96466a","rgb":{"r":150,"g":70,"b":106},"luminance":62.015592039421826},{"name":"Sattle","hex":"#aa6622","rgb":{"r":170,"g":102,"b":34},"luminance":78.63592151173661},{"name":"Saturated Sky","hex":"#4b4cfc","rgb":{"r":75,"g":76,"b":252},"luminance":57.60563473307103},{"name":"Saturn","hex":"#fae5bf","rgb":{"r":250,"g":229,"b":191},"luminance":155.34224314396906},{"name":"Satyr Brown","hex":"#bca17a","rgb":{"r":188,"g":161,"b":122},"luminance":110.83679198262641},{"name":"Saucisson","hex":"#882c17","rgb":{"r":136,"g":44,"b":23},"luminance":48.244392047159224},{"name":"Saudi Sand","hex":"#9e958a","rgb":{"r":158,"g":149,"b":138},"luminance":100.64332445323932},{"name":"Sausage Roll","hex":"#ebdfcd","rgb":{"r":235,"g":223,"b":205},"luminance":150.3941452517351},{"name":"Sausalito","hex":"#f4e5c5","rgb":{"r":244,"g":229,"b":197},"luminance":154.58487192801243},{"name":"Sausalito Ridge","hex":"#6a5d53","rgb":{"r":106,"g":93,"b":83},"luminance":63.82958844454505},{"name":"Sauteed Mushroom","hex":"#ab9378","rgb":{"r":171,"g":147,"b":120},"luminance":101.22800285494128},{"name":"Sauterne","hex":"#c5a253","rgb":{"r":197,"g":162,"b":83},"luminance":112.25845932044497},{"name":"Sauvignon","hex":"#f4eae4","rgb":{"r":244,"g":234,"b":228},"luminance":157.68760941811504},{"name":"Sauvignon Blanc","hex":"#b18276","rgb":{"r":177,"g":130,"b":118},"luminance":93.83504853198511},{"name":"Savannah","hex":"#d1bd92","rgb":{"r":209,"g":189,"b":146},"luminance":128.41533033870994},{"name":"Savannah Grass","hex":"#babc72","rgb":{"r":186,"g":188,"b":114},"luminance":124.25884172967329},{"name":"Savannah Sun","hex":"#ffb989","rgb":{"r":255,"g":185,"b":137},"luminance":133.60425133205902},{"name":"Saveloy","hex":"#aa2200","rgb":{"r":170,"g":34,"b":0},"luminance":54.607789407739254},{"name":"Savile Row","hex":"#c0b7cf","rgb":{"r":192,"g":183,"b":207},"luminance":124.0637550173297},{"name":"Savon de Provence","hex":"#eed9b6","rgb":{"r":238,"g":217,"b":182},"luminance":147.3767939297093},{"name":"Savory Salmon","hex":"#d19c97","rgb":{"r":209,"g":156,"b":151},"luminance":112.1912566156561},{"name":"Savoy","hex":"#87b550","rgb":{"r":135,"g":181,"b":80},"luminance":114.0216323072074},{"name":"Sawdust","hex":"#f6e9cf","rgb":{"r":246,"g":233,"b":207},"luminance":157.07756988507302},{"name":"Sawshark","hex":"#aa7766","rgb":{"r":170,"g":119,"b":102},"luminance":87.16846272018337},{"name":"Sawtooth Aak","hex":"#ec956c","rgb":{"r":236,"g":149,"b":108},"luminance":113.05149184774164},{"name":"Saxon","hex":"#abc1a0","rgb":{"r":171,"g":193,"b":160},"luminance":125.62532754982173},{"name":"Saxony Blue","hex":"#1f6680","rgb":{"r":31,"g":102,"b":128},"luminance":62.31963335097536},{"name":"Saxophone Gold","hex":"#ceaf81","rgb":{"r":206,"g":175,"b":129},"luminance":120.67523729829578},{"name":"Sazerac","hex":"#f5dec4","rgb":{"r":245,"g":222,"b":196},"luminance":151.1531936711891},{"name":"Scab Red","hex":"#8b0000","rgb":{"r":139,"g":0,"b":0},"luminance":41.561},{"name":"Scallion","hex":"#6b8e23","rgb":{"r":107,"g":142,"b":35},"luminance":89.37203961530697},{"name":"Scallop Shell","hex":"#fbd8c9","rgb":{"r":251,"g":216,"b":201},"luminance":149.10940634648102},{"name":"Scalloped Oak","hex":"#f2d1a0","rgb":{"r":242,"g":209,"b":160},"luminance":143.594903297436},{"name":"Scalloped Shell","hex":"#f3e9e0","rgb":{"r":243,"g":233,"b":224},"luminance":156.96315932727654},{"name":"Scallywag","hex":"#e5d5bd","rgb":{"r":229,"g":213,"b":189},"luminance":144.17093645391915},{"name":"Scaly Green","hex":"#027275","rgb":{"r":2,"g":114,"b":117},"luminance":68.23692967887695},{"name":"Scampi","hex":"#6f63a0","rgb":{"r":111,"g":99,"b":160},"luminance":69.36373757230791},{"name":"Scandal","hex":"#add9d1","rgb":{"r":173,"g":217,"b":209},"luminance":139.53053589089376},{"name":"Scandinavian Sky","hex":"#c2d3d6","rgb":{"r":194,"g":211,"b":214},"luminance":138.9259417855427},{"name":"Scarab","hex":"#23312d","rgb":{"r":35,"g":49,"b":45},"luminance":31.034550004793044},{"name":"Scarabaeus Sacer","hex":"#414040","rgb":{"r":65,"g":64,"b":64},"luminance":42.922085981461805},{"name":"Scarabœus Nobilis","hex":"#7d8c55","rgb":{"r":125,"g":140,"b":85},"luminance":90.79834318422334},{"name":"Scarborough","hex":"#809391","rgb":{"r":128,"g":147,"b":145},"luminance":95.83203224913892},{"name":"Scarlet","hex":"#ff2400","rgb":{"r":255,"g":36,"b":0},"luminance":79.11928620127964},{"name":"Scarlet Apple","hex":"#922e4a","rgb":{"r":146,"g":46,"b":74},"luminance":52.01870640452336},{"name":"Scarlet Flame","hex":"#993366","rgb":{"r":153,"g":51,"b":102},"luminance":55.89474359901832},{"name":"Scarlet Gum","hex":"#4a2d57","rgb":{"r":74,"g":45,"b":87},"luminance":35.85636380058636},{"name":"Scarlet Ibis","hex":"#f45520","rgb":{"r":244,"g":85,"b":32},"luminance":88.4612732499369},{"name":"Scarlet Past","hex":"#a53b3d","rgb":{"r":165,"g":59,"b":61},"luminance":60.67738483158284},{"name":"Scarlet Red","hex":"#b63e36","rgb":{"r":182,"g":62,"b":54},"luminance":65.7551389322538},{"name":"Scarlet Ribbons","hex":"#a4334a","rgb":{"r":164,"g":51,"b":74},"luminance":58.068230221008115},{"name":"Scarlet Sage","hex":"#9d202f","rgb":{"r":157,"g":32,"b":47},"luminance":50.8447840884392},{"name":"Scarlet Shade","hex":"#7e2530","rgb":{"r":126,"g":37,"b":48},"luminance":43.82907734598117},{"name":"Scarpa Flow","hex":"#6b6a6c","rgb":{"r":107,"g":106,"b":108},"luminance":71.04023280508024},{"name":"Scarpetta","hex":"#8ca468","rgb":{"r":140,"g":164,"b":104},"luminance":105.64256793546814},{"name":"Scatman Blue","hex":"#647983","rgb":{"r":100,"g":121,"b":131},"luminance":78.49757375231415},{"name":"Scenario","hex":"#81a79e","rgb":{"r":129,"g":167,"b":158},"luminance":106.87300419656967},{"name":"Scented Frill","hex":"#caaeb8","rgb":{"r":202,"g":174,"b":184},"luminance":120.49930300213359},{"name":"Scented Valentine","hex":"#f3d9d6","rgb":{"r":243,"g":217,"b":214},"luminance":148.65938956554342},{"name":"Sceptre Blue","hex":"#353542","rgb":{"r":53,"g":53,"b":66},"luminance":35.71599510023485},{"name":"Schabziger Yellow","hex":"#eeeebb","rgb":{"r":238,"g":238,"b":187},"luminance":158.22848606998676},{"name":"Schauss Pink","hex":"#ff91af","rgb":{"r":255,"g":145,"b":175},"luminance":115.99942133476355},{"name":"Schindler Brown","hex":"#8b714c","rgb":{"r":139,"g":113,"b":76},"luminance":78.75394071410014},{"name":"Schist","hex":"#87876f","rgb":{"r":135,"g":135,"b":111},"luminance":89.82887601434184},{"name":"Schnipo","hex":"#dd8855","rgb":{"r":221,"g":136,"b":85},"luminance":104.08399764132812},{"name":"Scholarship","hex":"#586a7d","rgb":{"r":88,"g":106,"b":125},"luminance":69.04318306683143},{"name":"School Bus Yellow","hex":"#ffd800","rgb":{"r":255,"g":216,"b":0},"luminance":147.95104355495434},{"name":"School Ink","hex":"#31373f","rgb":{"r":49,"g":55,"b":63},"luminance":36.17394297004405},{"name":"Schooner","hex":"#8d8478","rgb":{"r":141,"g":132,"b":120},"luminance":89.26530085649182},{"name":"Sci-fi Petrol","hex":"#006666","rgb":{"r":0,"g":102,"b":102},"luminance":60.992673822353446},{"name":"Sci-Fi Takeout","hex":"#00604b","rgb":{"r":0,"g":96,"b":75},"luminance":56.99693328592337},{"name":"Science Blue","hex":"#0076cc","rgb":{"r":0,"g":118,"b":204},"luminance":73.06586269934817},{"name":"Scintillating Violet","hex":"#764663","rgb":{"r":118,"g":70,"b":99},"luminance":55.32252181526073},{"name":"Sconce","hex":"#ae935d","rgb":{"r":174,"g":147,"b":93},"luminance":101.31583588462368},{"name":"Scoop of Dark Matter","hex":"#110055","rgb":{"r":17,"g":0,"b":85},"luminance":10.942257034085792},{"name":"Scooter","hex":"#308ea0","rgb":{"r":48,"g":142,"b":160},"luminance":86.52494911873684},{"name":"Scorched","hex":"#351f19","rgb":{"r":53,"g":31,"b":25},"luminance":24.29775129513017},{"name":"Scorched Brown","hex":"#4d0001","rgb":{"r":77,"g":0,"b":1},"luminance":23.023282237769664},{"name":"Scorched Earth","hex":"#44403d","rgb":{"r":68,"g":64,"b":61},"luminance":43.27935956088075},{"name":"Scorched Metal","hex":"#423d27","rgb":{"r":66,"g":61,"b":39},"luminance":41.12589112712331},{"name":"Scorpion","hex":"#6a6466","rgb":{"r":106,"g":100,"b":102},"luminance":67.71565564919237},{"name":"Scorpion Grass Blue","hex":"#99aac8","rgb":{"r":153,"g":170,"b":200},"luminance":112.11900868719809},{"name":"Scorpion Venom","hex":"#97ea10","rgb":{"r":151,"g":234,"b":16},"luminance":144.59937531331178},{"name":"Scorpy Green","hex":"#8eef15","rgb":{"r":142,"g":239,"b":21},"luminance":146.59651717895616},{"name":"Scorzonera Brown","hex":"#544e03","rgb":{"r":84,"g":78,"b":3},"luminance":52.223445079772354},{"name":"Scotch Blue","hex":"#000077","rgb":{"r":0,"g":0,"b":119},"luminance":13.566},{"name":"Scotch Mist","hex":"#eee7c8","rgb":{"r":238,"g":231,"b":200},"luminance":154.82382456521344},{"name":"Scotchtone","hex":"#ebccb9","rgb":{"r":235,"g":204,"b":185},"luminance":140.4334070974567},{"name":"Scots Pine","hex":"#5f653b","rgb":{"r":95,"g":101,"b":59},"luminance":66.0835188984364},{"name":"Scott Base","hex":"#66a3c3","rgb":{"r":102,"g":163,"b":195},"luminance":102.85501769481156},{"name":"Scouring Rush","hex":"#3b7960","rgb":{"r":59,"g":121,"b":96},"luminance":73.99872124570803},{"name":"Screamer Pink","hex":"#ab0040","rgb":{"r":171,"g":0,"b":64},"luminance":51.64693850558811},{"name":"Screamin' Green","hex":"#66ff66","rgb":{"r":102,"g":255,"b":102},"luminance":153.202276787912},{"name":"Screaming Bell Metal","hex":"#c16f45","rgb":{"r":193,"g":111,"b":69},"luminance":87.39225625877845},{"name":"Screaming Magenta","hex":"#cc00cc","rgb":{"r":204,"g":0,"b":204},"luminance":65.27904374299611},{"name":"Screaming Skull","hex":"#f0f2d2","rgb":{"r":240,"g":242,"b":210},"luminance":160.94085906319748},{"name":"Screech Owl","hex":"#eae4d8","rgb":{"r":234,"g":228,"b":216},"luminance":153.01521959596045},{"name":"Screen Glow","hex":"#66eeaa","rgb":{"r":102,"g":238,"b":170},"luminance":144.30342629334896},{"name":"Screen Test","hex":"#999eb0","rgb":{"r":153,"g":158,"b":176},"luminance":105.34311852703051},{"name":"Scribe","hex":"#9fabb6","rgb":{"r":159,"g":171,"b":182},"luminance":112.98746972120405},{"name":"Scrofulous Brown","hex":"#dba539","rgb":{"r":219,"g":165,"b":57},"luminance":117.09345152483975},{"name":"Scrolled Parchment","hex":"#e9ddc9","rgb":{"r":233,"g":221,"b":201},"luminance":149.0222695237192},{"name":"Scrub","hex":"#3d4031","rgb":{"r":61,"g":64,"b":49},"luminance":42.13334951080913},{"name":"Scuba","hex":"#6392b7","rgb":{"r":99,"g":146,"b":183},"luminance":93.03910494517883},{"name":"Scuba Blue","hex":"#00abc0","rgb":{"r":0,"g":171,"b":192},"luminance":102.73571274391392},{"name":"Scud","hex":"#acd7c8","rgb":{"r":172,"g":215,"b":200},"luminance":138.17518304312102},{"name":"Sculptural Silver","hex":"#d1dad5","rgb":{"r":209,"g":218,"b":213},"luminance":144.46465921117178},{"name":"Scurf Green","hex":"#02737a","rgb":{"r":2,"g":115,"b":122},"luminance":68.92543139509537},{"name":"Sè Lèi Orange","hex":"#fc824a","rgb":{"r":252,"g":130,"b":74},"luminance":107.57185180148197},{"name":"Sea","hex":"#3c9992","rgb":{"r":60,"g":153,"b":146},"luminance":93.08534824020373},{"name":"Sea Anemone","hex":"#e8dad6","rgb":{"r":232,"g":218,"b":214},"luminance":147.58855442072735},{"name":"Sea Angel","hex":"#98bfca","rgb":{"r":152,"g":191,"b":202},"luminance":123.15044123753678},{"name":"Sea Bed","hex":"#29848d","rgb":{"r":41,"g":132,"b":141},"luminance":80.07762991622566},{"name":"Sea Blithe","hex":"#41545c","rgb":{"r":65,"g":84,"b":92},"luminance":54.02773577524788},{"name":"Sea Blue","hex":"#006994","rgb":{"r":0,"g":105,"b":148},"luminance":63.90256339928783},{"name":"Sea Breeze","hex":"#a4bfce","rgb":{"r":164,"g":191,"b":206},"luminance":124.60437087437984},{"name":"Sea Buckthorn","hex":"#ffbf65","rgb":{"r":255,"g":191,"b":101},"luminance":136.0738546157931},{"name":"Sea Cabbage","hex":"#519d76","rgb":{"r":81,"g":157,"b":118},"luminance":96.23303770535355},{"name":"Sea Caller","hex":"#45868b","rgb":{"r":69,"g":134,"b":139},"luminance":82.84814325620097},{"name":"Sea Capture","hex":"#61bddc","rgb":{"r":97,"g":189,"b":220},"luminance":117.38198182855834},{"name":"Sea Cave","hex":"#005986","rgb":{"r":0,"g":89,"b":134},"luminance":54.43057252133216},{"name":"Sea Challenge","hex":"#2c585c","rgb":{"r":44,"g":88,"b":92},"luminance":54.326980552944406},{"name":"Sea Cliff","hex":"#a5c7df","rgb":{"r":165,"g":199,"b":223},"luminance":129.3270941373075},{"name":"Sea Creature","hex":"#00586d","rgb":{"r":0,"g":88,"b":109},"luminance":53.129538036764444},{"name":"Sea Crystal","hex":"#608ba6","rgb":{"r":96,"g":139,"b":166},"luminance":88.54069708896581},{"name":"Sea Current","hex":"#4c959d","rgb":{"r":76,"g":149,"b":157},"luminance":92.12217403535371},{"name":"Sea Deep","hex":"#2d3c44","rgb":{"r":45,"g":60,"b":68},"luminance":38.49128380555785},{"name":"Sea Drifter","hex":"#4b7794","rgb":{"r":75,"g":119,"b":148},"luminance":75.27939039338722},{"name":"Sea Drive","hex":"#c2d2e0","rgb":{"r":194,"g":210,"b":224},"luminance":138.60835556343636},{"name":"Sea Elephant","hex":"#77675c","rgb":{"r":119,"g":103,"b":92},"luminance":70.93333649279441},{"name":"Sea Fantasy","hex":"#1a9597","rgb":{"r":26,"g":149,"b":151},"luminance":89.47923357405337},{"name":"Sea Foam","hex":"#87e0cf","rgb":{"r":135,"g":224,"b":207},"luminance":139.55390705028648},{"name":"Sea Fog","hex":"#dfddd6","rgb":{"r":223,"g":221,"b":214},"luminance":147.88536666621212},{"name":"Sea Frost","hex":"#d5dcdc","rgb":{"r":213,"g":220,"b":220},"luminance":146.15806501524298},{"name":"Sea Garden","hex":"#568e88","rgb":{"r":86,"g":142,"b":136},"luminance":88.59725237274573},{"name":"Sea Glass","hex":"#afc1bf","rgb":{"r":175,"g":193,"b":191},"luminance":126.676214744521},{"name":"Sea Goddess","hex":"#216987","rgb":{"r":33,"g":105,"b":135},"luminance":64.28905827588393},{"name":"Sea Going","hex":"#2a2e44","rgb":{"r":42,"g":46,"b":68},"luminance":30.771819445720137},{"name":"Sea Grass","hex":"#67ad83","rgb":{"r":103,"g":173,"b":131},"luminance":107.16382396126035},{"name":"Sea Green","hex":"#53fca1","rgb":{"r":83,"g":252,"b":161},"luminance":151.11010085695793},{"name":"Sea Hunter","hex":"#245878","rgb":{"r":36,"g":88,"b":120},"luminance":54.51007642629021},{"name":"Sea Kale","hex":"#30a299","rgb":{"r":48,"g":162,"b":153},"luminance":97.73981841603758},{"name":"Sea Kelp","hex":"#354a55","rgb":{"r":53,"g":74,"b":85},"luminance":47.24281271262328},{"name":"Sea Lavender","hex":"#cfb1d8","rgb":{"r":207,"g":177,"b":216},"luminance":123.4183415299363},{"name":"Sea Lettuce","hex":"#67a181","rgb":{"r":103,"g":161,"b":129},"luminance":100.48031993380593},{"name":"Sea Lion","hex":"#7f8793","rgb":{"r":127,"g":135,"b":147},"luminance":89.45696908570063},{"name":"Sea Loch","hex":"#6e99d1","rgb":{"r":110,"g":153,"b":209},"luminance":98.56696250265603},{"name":"Sea Mark","hex":"#92b6cf","rgb":{"r":146,"g":182,"b":207},"luminance":117.79660808359465},{"name":"Sea Mist","hex":"#dbeee0","rgb":{"r":219,"g":238,"b":224},"luminance":156.38930619770647},{"name":"Sea Monster","hex":"#658c7b","rgb":{"r":101,"g":140,"b":123},"luminance":88.66875709628503},{"name":"Sea Moss","hex":"#254445","rgb":{"r":37,"g":68,"b":69},"luminance":42.161012570857444},{"name":"Sea Nettle","hex":"#f47633","rgb":{"r":244,"g":118,"b":51},"luminance":100.76784848353168},{"name":"Sea Note","hex":"#5482c2","rgb":{"r":84,"g":130,"b":194},"luminance":83.32554837503321},{"name":"Sea Nymph","hex":"#8aaea4","rgb":{"r":138,"g":174,"b":164},"luminance":111.73300364708719},{"name":"Sea of Atlantis","hex":"#2d535a","rgb":{"r":45,"g":83,"b":90},"luminance":51.575580132461916},{"name":"Sea Paint","hex":"#00507a","rgb":{"r":0,"g":80,"b":122},"luminance":48.976260208390755},{"name":"Sea Palm","hex":"#72897e","rgb":{"r":114,"g":137,"b":126},"luminance":88.51776913704954},{"name":"Sea Pea","hex":"#457973","rgb":{"r":69,"g":121,"b":115},"luminance":75.11554426348783},{"name":"Sea Pearl","hex":"#e0e9e4","rgb":{"r":224,"g":233,"b":228},"luminance":154.4916667040653},{"name":"Sea Pine","hex":"#4c6969","rgb":{"r":76,"g":105,"b":105},"luminance":66.77225697099058},{"name":"Sea Pink","hex":"#db817e","rgb":{"r":219,"g":129,"b":126},"luminance":101.13386468438748},{"name":"Sea Quest","hex":"#3e7984","rgb":{"r":62,"g":121,"b":132},"luminance":74.93286646725855},{"name":"Sea Radish","hex":"#799781","rgb":{"r":121,"g":151,"b":129},"luminance":96.85919804541022},{"name":"Sea Salt","hex":"#f1e6de","rgb":{"r":241,"g":230,"b":222},"luminance":155.11510063498008},{"name":"Sea Serpent","hex":"#4bc7cf","rgb":{"r":75,"g":199,"b":207},"luminance":121.26427007985492},{"name":"Sea Sight","hex":"#00789b","rgb":{"r":0,"g":120,"b":155},"luminance":72.62246553236815},{"name":"Sea Sparkle","hex":"#469ba7","rgb":{"r":70,"g":155,"b":167},"luminance":95.2826351913086},{"name":"Sea Spray","hex":"#d2ebea","rgb":{"r":210,"g":235,"b":234},"luminance":153.8928721578748},{"name":"Sea Sprite","hex":"#b7ccc7","rgb":{"r":183,"g":204,"b":199},"luminance":133.59711145455205},{"name":"Sea Squash","hex":"#baa243","rgb":{"r":186,"g":162,"b":67},"luminance":110.42701153250503},{"name":"Sea Star","hex":"#4d939a","rgb":{"r":77,"g":147,"b":154},"luminance":91.01682913615481},{"name":"Sea Swimmer","hex":"#337f86","rgb":{"r":51,"g":127,"b":134},"luminance":77.61083415348658},{"name":"Sea Turtle","hex":"#818a40","rgb":{"r":129,"g":138,"b":64},"luminance":90.01625238255589},{"name":"Sea Urchin","hex":"#367d83","rgb":{"r":54,"g":125,"b":131},"luminance":76.60031525392046},{"name":"Sea Wonder","hex":"#0f9bc0","rgb":{"r":15,"g":155,"b":192},"luminance":93.68815290099383},{"name":"Seaborne","hex":"#7aa5c9","rgb":{"r":122,"g":165,"b":201},"luminance":106.00276838366061},{"name":"Seabrook","hex":"#4b81af","rgb":{"r":75,"g":129,"b":175},"luminance":81.45462450960044},{"name":"Seachange","hex":"#3e8896","rgb":{"r":62,"g":136,"b":150},"luminance":83.7210586889583},{"name":"Seacrest","hex":"#bfd1b3","rgb":{"r":191,"g":209,"b":179},"luminance":136.85379500035796},{"name":"Seafair Green","hex":"#b8f8d8","rgb":{"r":184,"g":248,"b":216},"luminance":157.5610148736038},{"name":"Seafoam Blue","hex":"#78d1b6","rgb":{"r":120,"g":209,"b":182},"luminance":129.4950670604869},{"name":"Seafoam Green","hex":"#99bb88","rgb":{"r":153,"g":187,"b":136},"luminance":119.92662500879443},{"name":"Seagrass","hex":"#bcc6a2","rgb":{"r":188,"g":198,"b":162},"luminance":130.41985678569043},{"name":"Seagrass Green","hex":"#264e50","rgb":{"r":38,"g":78,"b":80},"luminance":48.04817624010301},{"name":"Seagull","hex":"#e0ded8","rgb":{"r":224,"g":222,"b":216},"luminance":148.5727584316856},{"name":"Seagull Wail","hex":"#c7bda8","rgb":{"r":199,"g":189,"b":168},"luminance":127.34016394680823},{"name":"Seal Brown","hex":"#321414","rgb":{"r":50,"g":20,"b":20},"luminance":19.144934055775693},{"name":"Seal Pup","hex":"#65869b","rgb":{"r":101,"g":134,"b":155},"luminance":86.08884634492438},{"name":"Sealegs","hex":"#6b8b8b","rgb":{"r":107,"g":139,"b":139},"luminance":89.0621435515674},{"name":"Seamount","hex":"#15646d","rgb":{"r":21,"g":100,"b":109},"luminance":60.328445338828345},{"name":"Seance","hex":"#69326e","rgb":{"r":105,"g":50,"b":110},"luminance":44.7696339609785},{"name":"Seaplane Grey","hex":"#3a3f41","rgb":{"r":58,"g":63,"b":65},"luminance":41.51201542927059},{"name":"Seaport","hex":"#005e7d","rgb":{"r":0,"g":94,"b":125},"luminance":56.988368848388696},{"name":"Seaport Steam","hex":"#aecac8","rgb":{"r":174,"g":202,"b":200},"luminance":131.4775195689362},{"name":"Searchlight","hex":"#eff0bf","rgb":{"r":239,"g":240,"b":191},"luminance":159.46145614850005},{"name":"Seared Earth","hex":"#9a5633","rgb":{"r":154,"g":86,"b":51},"luminance":68.57455093546002},{"name":"Searing Gorge Brown","hex":"#6b3b23","rgb":{"r":107,"g":59,"b":35},"luminance":47.31719389397473},{"name":"Seascape Blue","hex":"#a6bad1","rgb":{"r":166,"g":186,"b":209},"luminance":122.27804936291713},{"name":"Seascape Green","hex":"#b5e4e4","rgb":{"r":181,"g":228,"b":228},"luminance":146.68512235738154},{"name":"Seashell","hex":"#fff5ee","rgb":{"r":255,"g":245,"b":238},"luminance":165.02181575173628},{"name":"Seashell Cove","hex":"#104c77","rgb":{"r":16,"g":76,"b":119},"luminance":46.8738045820904},{"name":"Seashell Peach","hex":"#fff6de","rgb":{"r":255,"g":246,"b":222},"luminance":165.2444628209974},{"name":"Seashell Pink","hex":"#f7c8c2","rgb":{"r":247,"g":200,"b":194},"luminance":140.44978841208697},{"name":"Seasonal Beige","hex":"#e6b99f","rgb":{"r":230,"g":185,"b":159},"luminance":129.81039558140174},{"name":"Seasoned Acorn","hex":"#7f6640","rgb":{"r":127,"g":102,"b":64},"luminance":71.27465342602515},{"name":"Seasoned Apple Green","hex":"#8db600","rgb":{"r":141,"g":182,"b":0},"luminance":114.8515774249531},{"name":"Seattle Red","hex":"#7d212a","rgb":{"r":125,"g":33,"b":42},"luminance":42.36804467992357},{"name":"Seaweed","hex":"#18d17b","rgb":{"r":24,"g":209,"b":123},"luminance":123.690055982686},{"name":"Seaweed Green","hex":"#35ad6b","rgb":{"r":53,"g":173,"b":107},"luminance":103.50132469683659},{"name":"Seaweed Tea","hex":"#5d7759","rgb":{"r":93,"g":119,"b":89},"luminance":75.86575099476707},{"name":"Seaweed Wrap","hex":"#4d473d","rgb":{"r":77,"g":71,"b":61},"luminance":48.11848889979817},{"name":"Seaworld","hex":"#125459","rgb":{"r":18,"g":84,"b":89},"luminance":50.627918227001985},{"name":"Sebright Chicken","hex":"#bd5701","rgb":{"r":189,"g":87,"b":1},"luminance":76.16789926209071},{"name":"Secluded Canyon","hex":"#c6876f","rgb":{"r":198,"g":135,"b":111},"luminance":99.72347038185143},{"name":"Secluded Green","hex":"#6f6d56","rgb":{"r":111,"g":109,"b":86},"luminance":72.74237022533704},{"name":"Second Nature","hex":"#585642","rgb":{"r":88,"g":86,"b":66},"luminance":57.422680571356125},{"name":"Second Wind","hex":"#dfece9","rgb":{"r":223,"g":236,"b":233},"luminance":156.02075886560735},{"name":"Secrecy","hex":"#50759e","rgb":{"r":80,"g":117,"b":158},"luminance":74.92265068055188},{"name":"Secret Crush","hex":"#d7dfd6","rgb":{"r":215,"g":223,"b":214},"luminance":147.86073800032244},{"name":"Secret of Mana","hex":"#4166f5","rgb":{"r":65,"g":102,"b":245},"luminance":68.86726363810311},{"name":"Secret Passageway","hex":"#6d695e","rgb":{"r":109,"g":105,"b":94},"luminance":70.53991183720036},{"name":"Secret Path","hex":"#737054","rgb":{"r":115,"g":112,"b":84},"luminance":74.80843225866988},{"name":"Secret Safari","hex":"#c6bb68","rgb":{"r":198,"g":187,"b":104},"luminance":125.27838960092039},{"name":"Secret Story","hex":"#ff1493","rgb":{"r":255,"g":20,"b":147},"luminance":78.94275260592323},{"name":"Security","hex":"#d6e1c2","rgb":{"r":214,"g":225,"b":194},"luminance":148.4154010775162},{"name":"Sedge Green","hex":"#707a68","rgb":{"r":112,"g":122,"b":104},"luminance":79.94107752588778},{"name":"Sedia","hex":"#b0a67e","rgb":{"r":176,"g":166,"b":126},"luminance":111.67163129461304},{"name":"Sedona at Sunset","hex":"#bf7c45","rgb":{"r":191,"g":124,"b":69},"luminance":92.85152007910263},{"name":"Sedona Sage","hex":"#686d6c","rgb":{"r":104,"g":109,"b":108},"luminance":72.1967509587516},{"name":"Seduction","hex":"#fbf2bf","rgb":{"r":251,"g":242,"b":191},"luminance":162.12895605967492},{"name":"Seed Pearl","hex":"#e6dac4","rgb":{"r":230,"g":218,"b":196},"luminance":146.9825309075878},{"name":"Seedling","hex":"#c0cba1","rgb":{"r":192,"g":203,"b":161},"luminance":133.53610635704487},{"name":"Seeress","hex":"#a99ba9","rgb":{"r":169,"g":155,"b":169},"luminance":105.84342654128314},{"name":"Sefid White","hex":"#fff1f1","rgb":{"r":255,"g":241,"b":241},"luminance":163.03690622064684},{"name":"Seiheki Green","hex":"#3a6960","rgb":{"r":58,"g":105,"b":96},"luminance":64.95682662353511},{"name":"Seiji Green","hex":"#819c8b","rgb":{"r":129,"g":156,"b":139},"luminance":100.61932687610266},{"name":"Sekichiku Pink","hex":"#e5abbe","rgb":{"r":229,"g":171,"b":190},"luminance":123.42194120171665},{"name":"Sekkasshoku Brown","hex":"#683f36","rgb":{"r":104,"g":63,"b":54},"luminance":48.707821887249274},{"name":"Selago","hex":"#e6dfe7","rgb":{"r":230,"g":223,"b":231},"luminance":150.19275700578905},{"name":"Selective Yellow","hex":"#ffba00","rgb":{"r":255,"g":186,"b":0},"luminance":133.16909982800064},{"name":"Self Powered","hex":"#8c7591","rgb":{"r":140,"g":117,"b":145},"luminance":82.11154328716518},{"name":"Self-Destruct","hex":"#c2b398","rgb":{"r":194,"g":179,"b":152},"luminance":121.26537407273354},{"name":"Seljuk Blue","hex":"#4488ee","rgb":{"r":68,"g":136,"b":238},"luminance":86.73340689722731},{"name":"Sell Gold","hex":"#d4ae5e","rgb":{"r":212,"g":174,"b":94},"luminance":120.68571681851999},{"name":"Sell Out","hex":"#90a2b7","rgb":{"r":144,"g":162,"b":183},"luminance":106.45144910239597},{"name":"Semi Opal","hex":"#ab9649","rgb":{"r":171,"g":150,"b":73},"luminance":102.15788185450988},{"name":"Semi Sweet Chocolate","hex":"#6b4226","rgb":{"r":107,"g":66,"b":38},"luminance":50.43075288948203},{"name":"Semolina","hex":"#ceb899","rgb":{"r":206,"g":184,"b":153},"luminance":125.5538620035242},{"name":"Semolina Pudding","hex":"#ffe8c7","rgb":{"r":255,"g":232,"b":199},"luminance":157.71504835303446},{"name":"Sēn Lín Lǜ Forest","hex":"#4ca973","rgb":{"r":76,"g":169,"b":115},"luminance":102.61329097636427},{"name":"Senate","hex":"#4a515f","rgb":{"r":74,"g":81,"b":95},"luminance":53.54965905587075},{"name":"Sencha Brown","hex":"#824b35","rgb":{"r":130,"g":75,"b":53},"luminance":59.03882865538577},{"name":"Seneca Rock","hex":"#9a927f","rgb":{"r":154,"g":146,"b":127},"luminance":98.35994816997413},{"name":"Senior Moment","hex":"#fdecc7","rgb":{"r":253,"g":236,"b":199},"luminance":159.46234109970916},{"name":"Sensai Brown","hex":"#494a41","rgb":{"r":73,"g":74,"b":65},"luminance":49.175053360418424},{"name":"Sensaicha brown","hex":"#3b3429","rgb":{"r":59,"g":52,"b":41},"luminance":35.563545000463606},{"name":"Sensaimidori Green","hex":"#374231","rgb":{"r":55,"g":66,"b":49},"luminance":42.456848505276504},{"name":"Sensitive Scorpion","hex":"#cc2266","rgb":{"r":204,"g":34,"b":102},"luminance":65.22303399873391},{"name":"Sensitivity","hex":"#a1b0be","rgb":{"r":161,"g":176,"b":190},"luminance":116.01675855237467},{"name":"Sensual Climax","hex":"#da3287","rgb":{"r":218,"g":50,"b":135},"luminance":73.12296304171488},{"name":"Sensual Fumes","hex":"#cd68e2","rgb":{"r":205,"g":104,"b":226},"luminance":90.26471639018204},{"name":"Sentimental Lady","hex":"#c4d3dc","rgb":{"r":196,"g":211,"b":220},"luminance":139.29821127710147},{"name":"Sentimental Pink","hex":"#f8eef4","rgb":{"r":248,"g":238,"b":244},"luminance":160.59270031978414},{"name":"Sentinel","hex":"#d2e0d6","rgb":{"r":210,"g":224,"b":214},"luminance":147.73910470826604},{"name":"Sephiroth Grey","hex":"#8c92ac","rgb":{"r":140,"g":146,"b":172},"luminance":97.37333345428819},{"name":"Sepia","hex":"#704214","rgb":{"r":112,"g":66,"b":20},"luminance":51.259995200936174},{"name":"Sepia Black","hex":"#2b0202","rgb":{"r":43,"g":2,"b":2},"luminance":12.912502042594223},{"name":"Sepia Rose","hex":"#d4bab6","rgb":{"r":212,"g":186,"b":182},"luminance":127.94228062685141},{"name":"Sepia Skin","hex":"#9f5c42","rgb":{"r":159,"g":92,"b":66},"luminance":72.34078568138446},{"name":"Sepia Tint","hex":"#897560","rgb":{"r":137,"g":117,"b":96},"luminance":80.71272233049757},{"name":"Sepia Tone","hex":"#b8a88a","rgb":{"r":184,"g":168,"b":138},"luminance":114.0147864796492},{"name":"Sepia Wash","hex":"#995915","rgb":{"r":153,"g":89,"b":21},"luminance":69.48273378329323},{"name":"September Morn","hex":"#ede6b3","rgb":{"r":237,"g":230,"b":179},"luminance":153.83650316163587},{"name":"Sequesta","hex":"#d4d158","rgb":{"r":212,"g":209,"b":88},"luminance":138.45503983965335},{"name":"Sequoia","hex":"#804839","rgb":{"r":128,"g":72,"b":57},"luminance":57.38654619333699},{"name":"Sequoia Fog","hex":"#c5bbaf","rgb":{"r":197,"g":187,"b":175},"luminance":126.16179798179796},{"name":"Sequoia Redwood","hex":"#763f3d","rgb":{"r":118,"g":63,"b":61},"luminance":51.58267151864082},{"name":"Seraphim Sepia","hex":"#d7824b","rgb":{"r":215,"g":130,"b":75},"luminance":100.14429501973639},{"name":"Seraphinite","hex":"#616f65","rgb":{"r":97,"g":111,"b":101},"luminance":72.24389838595367},{"name":"Serena","hex":"#cfd0c1","rgb":{"r":207,"g":208,"b":193},"luminance":138.6443820318732},{"name":"Serenade","hex":"#fce9d7","rgb":{"r":252,"g":233,"b":215},"luminance":158.06444143133518},{"name":"Serendibite Black","hex":"#4a4354","rgb":{"r":74,"g":67,"b":84},"luminance":46.130574384024314},{"name":"Serendipity","hex":"#bde1d8","rgb":{"r":189,"g":225,"b":216},"luminance":145.75198153713038},{"name":"Serene Blue","hex":"#1199bb","rgb":{"r":17,"g":153,"b":187},"luminance":92.4462532177481},{"name":"Serene Scene","hex":"#d2c880","rgb":{"r":210,"g":200,"b":128},"luminance":133.93382905002005},{"name":"Serene Sea","hex":"#78a7c3","rgb":{"r":120,"g":167,"b":195},"luminance":106.72971536081224},{"name":"Serene Stream","hex":"#819daa","rgb":{"r":129,"g":157,"b":170},"luminance":101.76732148386336},{"name":"Serene Thought","hex":"#c5c0ac","rgb":{"r":197,"g":192,"b":172},"luminance":128.67100951263265},{"name":"Serenity","hex":"#91a8d0","rgb":{"r":145,"g":168,"b":208},"luminance":110.30426295025954},{"name":"Seriously Sand","hex":"#dcccb4","rgb":{"r":220,"g":204,"b":180},"luminance":138.15810618273542},{"name":"Serpent","hex":"#817f6d","rgb":{"r":129,"g":127,"b":109},"luminance":84.85093351283767},{"name":"Serpentine","hex":"#9b8e54","rgb":{"r":155,"g":142,"b":84},"luminance":95.85117692026529},{"name":"Serpentine Shadow","hex":"#003300","rgb":{"r":0,"g":51,"b":0},"luminance":29.936999999999998},{"name":"Serrano Pepper","hex":"#556600","rgb":{"r":85,"g":102,"b":0},"luminance":65.04473922616647},{"name":"Seryi Grey","hex":"#9ca9ad","rgb":{"r":156,"g":169,"b":173},"luminance":111.38157490806098},{"name":"Sesame","hex":"#baa38b","rgb":{"r":186,"g":163,"b":139},"luminance":111.79832947320814},{"name":"Sesame Crunch","hex":"#c26a35","rgb":{"r":194,"g":106,"b":53},"luminance":85.28059031221582},{"name":"Sesame Seed","hex":"#e1d9b8","rgb":{"r":225,"g":217,"b":184},"luminance":145.5724144266351},{"name":"Sesame Street Green","hex":"#00a870","rgb":{"r":0,"g":168,"b":112},"luminance":99.43911343128516},{"name":"Settler","hex":"#8b9cac","rgb":{"r":139,"g":156,"b":172},"luminance":102.45594940753804},{"name":"Seven Days of Rain","hex":"#d3dae1","rgb":{"r":211,"g":218,"b":225},"luminance":144.9601378896971},{"name":"Seven Seas","hex":"#4a5c6a","rgb":{"r":74,"g":92,"b":106},"luminance":59.598783108382335},{"name":"Seven Veils","hex":"#e3b8bd","rgb":{"r":227,"g":184,"b":189},"luminance":129.370407392881},{"name":"Severe Seal","hex":"#eee7de","rgb":{"r":238,"g":231,"b":222},"luminance":155.21298759124505},{"name":"Seville Scarlet","hex":"#955843","rgb":{"r":149,"g":88,"b":67},"luminance":68.64017031593089},{"name":"Shabby Chic","hex":"#bb8a8e","rgb":{"r":187,"g":138,"b":142},"luminance":99.75112505129954},{"name":"Shade of Amber","hex":"#ff7e00","rgb":{"r":255,"g":126,"b":0},"luminance":106.22465565489021},{"name":"Shade of Bone Marrow","hex":"#889988","rgb":{"r":136,"g":153,"b":136},"luminance":99.79955226853474},{"name":"Shade of Marigold","hex":"#b88a3d","rgb":{"r":184,"g":138,"b":61},"luminance":98.16868343825337},{"name":"Shade of Mauve","hex":"#ae7181","rgb":{"r":174,"g":113,"b":129},"luminance":85.57320067053703},{"name":"Shade of Violet","hex":"#8601af","rgb":{"r":134,"g":1,"b":175},"luminance":44.761941702745645},{"name":"Shaded Fern","hex":"#786947","rgb":{"r":120,"g":105,"b":71},"luminance":71.77576513698757},{"name":"Shaded Fuchsia","hex":"#664348","rgb":{"r":102,"g":67,"b":72},"luminance":50.44075246266653},{"name":"Shaded Glen","hex":"#8e824a","rgb":{"r":142,"g":130,"b":74},"luminance":87.7329126383024},{"name":"Shaded Hammock","hex":"#859c9b","rgb":{"r":133,"g":156,"b":155},"luminance":101.38577007154406},{"name":"Shaded Spruce","hex":"#00585e","rgb":{"r":0,"g":88,"b":94},"luminance":52.75580529192972},{"name":"Shaded Sun","hex":"#f3eba5","rgb":{"r":243,"g":235,"b":165},"luminance":157.0403730701121},{"name":"Shadow","hex":"#837050","rgb":{"r":131,"g":112,"b":80},"luminance":77.06917994243872},{"name":"Shadow Black","hex":"#8A795D","rgb":{"r":131,"g":112,"b":80},"luminance":77.06917994243872},{"name":"Shadow Azalea Pink","hex":"#e96a97","rgb":{"r":233,"g":106,"b":151},"luminance":94.98099793642936},{"name":"Shadow Blue","hex":"#778ba5","rgb":{"r":119,"g":139,"b":165},"luminance":90.9793455131438},{"name":"Shadow Cliff","hex":"#7a6f66","rgb":{"r":122,"g":111,"b":102},"luminance":75.57307402110887},{"name":"Shadow Dance","hex":"#877d83","rgb":{"r":135,"g":125,"b":131},"luminance":85.06614018515239},{"name":"Shadow Effect","hex":"#788788","rgb":{"r":120,"g":135,"b":136},"luminance":88.36016320152424},{"name":"Shadow Gargoyle","hex":"#686767","rgb":{"r":104,"g":103,"b":103},"luminance":68.99542231916548},{"name":"Shadow Green","hex":"#9ac0b6","rgb":{"r":154,"g":192,"b":182},"luminance":123.50265274883775},{"name":"Shadow Grey","hex":"#bba5a0","rgb":{"r":187,"g":165,"b":160},"luminance":113.31307159370448},{"name":"Shadow Leaf","hex":"#395648","rgb":{"r":57,"g":86,"b":72},"luminance":53.90980835617949},{"name":"Shadow Lime","hex":"#cfe09d","rgb":{"r":207,"g":224,"b":157},"luminance":146.42464272450863},{"name":"Shadow of the Colossus","hex":"#a3a2a1","rgb":{"r":163,"g":162,"b":161},"luminance":108.42063143608785},{"name":"Shadow Planet","hex":"#221144","rgb":{"r":34,"g":17,"b":68},"luminance":16.21793763090733},{"name":"Shadow Purple","hex":"#4e334e","rgb":{"r":78,"g":51,"b":78},"luminance":38.977010108524226},{"name":"Shadow Warrior","hex":"#1a2421","rgb":{"r":26,"g":36,"b":33},"luminance":22.82869124588617},{"name":"Shadow White","hex":"#eef1ea","rgb":{"r":238,"g":241,"b":234},"luminance":160.58814186919278},{"name":"Shadow Woods","hex":"#8a795d","rgb":{"r":138,"g":121,"b":93},"luminance":82.82384787607975},{"name":"Shadowed Steel","hex":"#4b4b4b","rgb":{"r":75,"g":75,"b":75},"luminance":50.14163688991415},{"name":"Shady","hex":"#dbd6cb","rgb":{"r":219,"g":214,"b":203},"luminance":143.53813238648468},{"name":"Shady Glade","hex":"#006e5b","rgb":{"r":0,"g":110,"b":91},"luminance":65.398048717068},{"name":"Shady Lady","hex":"#9f9b9d","rgb":{"r":159,"g":155,"b":157},"luminance":104.2053516380037},{"name":"Shady Neon Blue","hex":"#5555ff","rgb":{"r":85,"g":85,"b":255},"luminance":63.09118916298851},{"name":"Shady Oak","hex":"#73694b","rgb":{"r":115,"g":105,"b":75},"luminance":71.09362805484047},{"name":"Shagbark Olive","hex":"#645d41","rgb":{"r":100,"g":93,"b":65},"luminance":62.68249660790482},{"name":"Shaggy Barked","hex":"#b3ab98","rgb":{"r":179,"g":171,"b":152},"luminance":115.06649883436968},{"name":"Shaker Grey","hex":"#6c6556","rgb":{"r":108,"g":101,"b":86},"luminance":68.21905927964707},{"name":"Shaker Peg","hex":"#886a3f","rgb":{"r":136,"g":106,"b":63},"luminance":74.67743503897277},{"name":"Shakespeare","hex":"#609ab8","rgb":{"r":96,"g":154,"b":184},"luminance":97.13758590782457},{"name":"Shakshuka","hex":"#aa3311","rgb":{"r":170,"g":51,"b":17},"luminance":59.02261187883843},{"name":"Shaku-Do Copper","hex":"#752100","rgb":{"r":117,"g":33,"b":0},"luminance":39.98807234663856},{"name":"Shale","hex":"#4a3f41","rgb":{"r":74,"g":63,"b":65},"luminance":43.72713501934468},{"name":"Shale Green","hex":"#739072","rgb":{"r":115,"g":144,"b":114},"luminance":92.17487198255282},{"name":"Shalimar","hex":"#f8f6a8","rgb":{"r":248,"g":246,"b":168},"luminance":163.45413978238665},{"name":"Shallot Leaf","hex":"#505c3a","rgb":{"r":80,"g":92,"b":58},"luminance":59.43329841090767},{"name":"Shallow End","hex":"#c5f5e8","rgb":{"r":197,"g":245,"b":232},"luminance":157.64458232999954},{"name":"Shallow Sea","hex":"#9ab8c2","rgb":{"r":154,"g":184,"b":194},"luminance":119.47836471930806},{"name":"Shallow Shoal","hex":"#9dd6d4","rgb":{"r":157,"g":214,"b":212},"luminance":136.26305220785272},{"name":"Shallow Shore","hex":"#b0dec8","rgb":{"r":176,"g":222,"b":200},"luminance":142.37578435956024},{"name":"Shallow Water","hex":"#8af1fe","rgb":{"r":138,"g":241,"b":254},"luminance":150.17960803318138},{"name":"Shallow Water Ground","hex":"#8caeac","rgb":{"r":140,"g":174,"b":172},"luminance":112.11112481819097},{"name":"Shamanic Journey","hex":"#cc855a","rgb":{"r":204,"g":133,"b":90},"luminance":99.60351729231252},{"name":"Shampoo","hex":"#ffcff1","rgb":{"r":255,"g":207,"b":241},"luminance":146.05669372541607},{"name":"Shamrock","hex":"#009e60","rgb":{"r":0,"g":158,"b":96},"luminance":93.38946221067985},{"name":"Shamrock Field","hex":"#358d52","rgb":{"r":53,"g":141,"b":82},"luminance":84.78731510078615},{"name":"Shān Hú Hóng Coral","hex":"#fa9a85","rgb":{"r":250,"g":154,"b":133},"luminance":118.27614784055152},{"name":"Shandy","hex":"#ffe670","rgb":{"r":255,"g":230,"b":112},"luminance":155.57641835766756},{"name":"Shanghai Silk","hex":"#c8dfc3","rgb":{"r":200,"g":223,"b":195},"luminance":145.62034439253327},{"name":"Shangri La","hex":"#ecd4d2","rgb":{"r":236,"g":212,"b":210},"luminance":145.0472710256901},{"name":"Shani Purple","hex":"#4c1050","rgb":{"r":76,"g":16,"b":80},"luminance":26.22525957926823},{"name":"Shank","hex":"#a18b5d","rgb":{"r":161,"g":139,"b":93},"luminance":95.3267190980577},{"name":"Sharbah Fizz","hex":"#9be3d7","rgb":{"r":155,"g":227,"b":215},"luminance":143.19181235671263},{"name":"Sharegaki Persimmon","hex":"#ffa26b","rgb":{"r":255,"g":162,"b":107},"luminance":122.49473484603327},{"name":"Shark","hex":"#cadcde","rgb":{"r":202,"g":220,"b":222},"luminance":144.79486478463247},{"name":"Shark Bait","hex":"#ee6699","rgb":{"r":238,"g":102,"b":153},"luminance":94.62108371816504},{"name":"Sharknado","hex":"#35524a","rgb":{"r":53,"g":82,"b":74},"luminance":51.372905903793296},{"name":"Sharkskin","hex":"#838487","rgb":{"r":131,"g":132,"b":135},"luminance":88.17501299688024},{"name":"Sharp Blue","hex":"#2b3d54","rgb":{"r":43,"g":61,"b":84},"luminance":39.23191907108292},{"name":"Sharp Green","hex":"#c6ec7a","rgb":{"r":198,"g":236,"b":122},"luminance":151.2925123461171},{"name":"Sharp Grey","hex":"#c9cad1","rgb":{"r":201,"g":202,"b":209},"luminance":135.05318046236454},{"name":"Sharp Pebbles","hex":"#dbd6d8","rgb":{"r":219,"g":214,"b":216},"luminance":143.78450772249423},{"name":"Sharp Yellow","hex":"#ecc043","rgb":{"r":236,"g":192,"b":67},"luminance":133.19087339604016},{"name":"Sharp-Rip Drill","hex":"#eae1d6","rgb":{"r":234,"g":225,"b":214},"luminance":151.4404556154002},{"name":"Shattan Gold","hex":"#bb5577","rgb":{"r":187,"g":85,"b":119},"luminance":76.15648987446835},{"name":"Shattell","hex":"#b5a088","rgb":{"r":181,"g":160,"b":136},"luminance":109.49980172128166},{"name":"Shattered Ice","hex":"#daeee6","rgb":{"r":218,"g":238,"b":230},"luminance":156.37758138556816},{"name":"Shattered Porcelain","hex":"#eee2e0","rgb":{"r":238,"g":226,"b":224},"luminance":152.69356169793144},{"name":"Shattered Sky","hex":"#d0dde9","rgb":{"r":208,"g":221,"b":233},"luminance":146.2958619954782},{"name":"Shattered White","hex":"#f1f1e5","rgb":{"r":241,"g":241,"b":229},"luminance":160.89417269124445},{"name":"Shaved Chocolate","hex":"#543b35","rgb":{"r":84,"g":59,"b":53},"luminance":43.206063336064304},{"name":"Shawarma","hex":"#dd9955","rgb":{"r":221,"g":153,"b":85},"luminance":111.92116002794108},{"name":"Shebang","hex":"#81876f","rgb":{"r":129,"g":135,"b":111},"luminance":89.03715955711974},{"name":"Sheen Green","hex":"#8fd400","rgb":{"r":143,"g":212,"b":0},"luminance":131.5844602717205},{"name":"Sheepskin","hex":"#dab58f","rgb":{"r":218,"g":181,"b":143},"luminance":125.70947990107985},{"name":"Sheepskin Gloves","hex":"#ad9e87","rgb":{"r":173,"g":158,"b":135},"luminance":107.30496328222661},{"name":"Sheer Green","hex":"#b0c69a","rgb":{"r":176,"g":198,"b":154},"luminance":128.78657378779823},{"name":"Sheer Lavender","hex":"#efe2f2","rgb":{"r":239,"g":226,"b":242},"luminance":153.18935507730293},{"name":"Sheer Lilac","hex":"#b793c0","rgb":{"r":183,"g":147,"b":192},"luminance":104.49318711762983},{"name":"Sheer Peach","hex":"#fff7e7","rgb":{"r":255,"g":247,"b":231},"luminance":165.91741832007872},{"name":"Sheer Pink","hex":"#f6e5db","rgb":{"r":246,"g":229,"b":219},"luminance":155.25152173489315},{"name":"Sheer Rosebud","hex":"#ffe8e5","rgb":{"r":255,"g":232,"b":229},"luminance":158.24318347720384},{"name":"Sheer Sunlight","hex":"#fffedf","rgb":{"r":255,"g":254,"b":223},"luminance":169.38061197492468},{"name":"Sheet Metal","hex":"#5e6063","rgb":{"r":94,"g":96,"b":99},"luminance":63.975533886009885},{"name":"Sheffield","hex":"#638f7b","rgb":{"r":99,"g":143,"b":123},"luminance":90.10508956768201},{"name":"Sheffield Grey","hex":"#6b7680","rgb":{"r":107,"g":118,"b":128},"luminance":77.68048190504484},{"name":"Sheikh Zayed White","hex":"#e6efef","rgb":{"r":230,"g":239,"b":239},"luminance":158.59944282689014},{"name":"Shell","hex":"#e1cfc6","rgb":{"r":225,"g":207,"b":198},"luminance":140.7119678279001},{"name":"Shell Brown","hex":"#56564b","rgb":{"r":86,"g":86,"b":75},"luminance":57.295240814573766},{"name":"Shell Coral","hex":"#ea9575","rgb":{"r":234,"g":149,"b":117},"luminance":112.79592088812431},{"name":"Shell Haven","hex":"#ebdfc0","rgb":{"r":235,"g":223,"b":192},"luminance":150.17099110680462},{"name":"Shell Pink","hex":"#f88180","rgb":{"r":248,"g":129,"b":128},"luminance":106.98326176089417},{"name":"Shell Tint","hex":"#fdd7ca","rgb":{"r":253,"g":215,"b":202},"luminance":148.93105592185935},{"name":"Shelter","hex":"#b8986c","rgb":{"r":184,"g":152,"b":108},"luminance":105.54272962170344},{"name":"Sheltered Bay","hex":"#758f9a","rgb":{"r":117,"g":143,"b":154},"luminance":92.61811327164897},{"name":"Shēn Chéng Orange","hex":"#c03f20","rgb":{"r":192,"g":63,"b":32},"luminance":68.38553011419887},{"name":"Shēn Hóng Red","hex":"#be0620","rgb":{"r":190,"g":6,"b":32},"luminance":57.03585265427352},{"name":"Shepherd's Warning","hex":"#c06f68","rgb":{"r":192,"g":111,"b":104},"luminance":87.6451815503853},{"name":"Sheriff","hex":"#ebcfaa","rgb":{"r":235,"g":207,"b":170},"luminance":141.69400730447282},{"name":"Sheringa Rose","hex":"#735153","rgb":{"r":115,"g":81,"b":83},"luminance":59.43546818188614},{"name":"Sherpa Blue","hex":"#00494e","rgb":{"r":0,"g":73,"b":78},"luminance":43.7638648316165},{"name":"Sherwood Forest","hex":"#555a4c","rgb":{"r":85,"g":90,"b":76},"luminance":59.262095988920265},{"name":"Sherwood Green","hex":"#1b4636","rgb":{"r":27,"g":70,"b":54},"luminance":42.32561594353943},{"name":"Shetland Lace","hex":"#dfd0c0","rgb":{"r":223,"g":208,"b":192},"luminance":140.82734141138928},{"name":"Shì Zǐ Chéng Persimmon","hex":"#e29f31","rgb":{"r":226,"g":159,"b":49},"luminance":115.36246253006217},{"name":"Shifting Sand","hex":"#d8c0ad","rgb":{"r":216,"g":192,"b":173},"luminance":131.38585143005315},{"name":"Shiitake Mushroom","hex":"#736253","rgb":{"r":115,"g":98,"b":83},"luminance":67.68381154308614},{"name":"Shikon","hex":"#2b2028","rgb":{"r":43,"g":32,"b":40},"luminance":23.214967262522684},{"name":"Shilo","hex":"#e6b2a6","rgb":{"r":230,"g":178,"b":166},"luminance":126.5099002924277},{"name":"Shimmer","hex":"#88c7e9","rgb":{"r":136,"g":199,"b":233},"luminance":126.50840963746244},{"name":"Shimmering Blush","hex":"#d98695","rgb":{"r":217,"g":134,"b":149},"luminance":103.37025127666082},{"name":"Shimmering Brook","hex":"#64b3d3","rgb":{"r":100,"g":179,"b":211},"luminance":111.8612544404898},{"name":"Shimmering Champagne","hex":"#f3debc","rgb":{"r":243,"g":222,"b":188},"luminance":150.73191058631213},{"name":"Shimmering Expanse Cyan","hex":"#45e9fd","rgb":{"r":69,"g":233,"b":253},"luminance":141.29333164024408},{"name":"Shimmering Glade","hex":"#a4943a","rgb":{"r":164,"g":148,"b":58},"luminance":99.97843375448527},{"name":"Shimmering Sea","hex":"#2b526a","rgb":{"r":43,"g":82,"b":106},"luminance":51.26604588809244},{"name":"Shimmering Sky","hex":"#dbd1e8","rgb":{"r":219,"g":209,"b":232},"luminance":141.55697282013344},{"name":"Shinbashi","hex":"#59b9c6","rgb":{"r":89,"g":185,"b":198},"luminance":114.06364245455254},{"name":"Shinbashi Azure","hex":"#006c7f","rgb":{"r":0,"g":108,"b":127},"luminance":65.02818850314068},{"name":"Shindig","hex":"#00a990","rgb":{"r":0,"g":169,"b":144},"luminance":100.55207737784436},{"name":"Shiner","hex":"#773ca7","rgb":{"r":119,"g":60,"b":167},"luminance":53.56212659146386},{"name":"Shingle Fawn","hex":"#745937","rgb":{"r":116,"g":89,"b":55},"luminance":63.020820408814096},{"name":"Shining Armor","hex":"#908b8e","rgb":{"r":144,"g":139,"b":142},"luminance":93.66583223886924},{"name":"Shining Gold","hex":"#bad147","rgb":{"r":186,"g":209,"b":71},"luminance":134.9427594241351},{"name":"Shining Knight","hex":"#989ea7","rgb":{"r":152,"g":158,"b":167},"luminance":105.02279116458485},{"name":"Shining Silver","hex":"#c7c7c9","rgb":{"r":199,"g":199,"b":201},"luminance":133.08154404724945},{"name":"Shinshu","hex":"#8f1d21","rgb":{"r":143,"g":29,"b":33},"luminance":46.17462747007278},{"name":"Shiny Armor","hex":"#a1a9a8","rgb":{"r":161,"g":169,"b":168},"luminance":111.91692291159545},{"name":"Shiny Nickel","hex":"#ccd3d8","rgb":{"r":204,"g":211,"b":216},"luminance":140.2405427863141},{"name":"Shiny Rubber","hex":"#3a363b","rgb":{"r":58,"g":54,"b":59},"luminance":36.75251343785891},{"name":"Shiny Shamrock","hex":"#5fa778","rgb":{"r":95,"g":167,"b":120},"luminance":102.9741291101799},{"name":"Shiny Silk","hex":"#f7ecca","rgb":{"r":247,"g":236,"b":202},"luminance":158.66842602420934},{"name":"Ship Cove","hex":"#7988ab","rgb":{"r":121,"g":136,"b":171},"luminance":89.78911014705513},{"name":"Ship Grey","hex":"#3e3a44","rgb":{"r":62,"g":58,"b":68},"luminance":39.53329057895383},{"name":"Ship Steering Wheel","hex":"#62493b","rgb":{"r":98,"g":73,"b":59},"luminance":52.34552971362502},{"name":"Ship's Harbour","hex":"#4f84af","rgb":{"r":79,"g":132,"b":175},"luminance":83.42496267305127},{"name":"Ship's Officer","hex":"#2d3a49","rgb":{"r":45,"g":58,"b":73},"luminance":37.542280498126374},{"name":"Shipwreck","hex":"#968772","rgb":{"r":150,"g":135,"b":114},"luminance":91.9792832163852},{"name":"Shiracha Brown","hex":"#c48e69","rgb":{"r":196,"g":142,"b":105},"luminance":102.59434210520578},{"name":"Shiraz","hex":"#842833","rgb":{"r":132,"g":40,"b":51},"luminance":46.290776835132064},{"name":"Shire","hex":"#646b59","rgb":{"r":100,"g":107,"b":89},"luminance":70.29880366691883},{"name":"Shire Green","hex":"#68e52f","rgb":{"r":104,"g":229,"b":47},"luminance":138.0768348022216},{"name":"Shiroi White","hex":"#ebf5f0","rgb":{"r":235,"g":245,"b":240},"luminance":162.38378629038058},{"name":"Shironeri Silk","hex":"#feddcb","rgb":{"r":254,"g":221,"b":203},"luminance":152.09352914900754},{"name":"Shisha Coal","hex":"#3c3b3c","rgb":{"r":60,"g":59,"b":60},"luminance":39.598912724972635},{"name":"Shishi Pink","hex":"#efab93","rgb":{"r":239,"g":171,"b":147},"luminance":124.35050146259965},{"name":"Shishito Pepper Green","hex":"#bbf90f","rgb":{"r":187,"g":249,"b":15},"luminance":156.5017898875281},{"name":"Shiso Green","hex":"#63a950","rgb":{"r":99,"g":169,"b":80},"luminance":103.92607377362044},{"name":"Shiva Blue","hex":"#99dbfe","rgb":{"r":153,"g":219,"b":254},"luminance":139.4887513529317},{"name":"Shocking","hex":"#e899be","rgb":{"r":232,"g":153,"b":190},"luminance":115.5296098193013},{"name":"Shocking Pink","hex":"#fe02a2","rgb":{"r":254,"g":2,"b":162},"luminance":78.1680255347415},{"name":"Shockwave","hex":"#72c8b8","rgb":{"r":114,"g":200,"b":184},"luminance":124.03470470799694},{"name":"Shoelace Beige","hex":"#f6ebd3","rgb":{"r":246,"g":235,"b":211},"luminance":158.16955730165017},{"name":"Shoji Screen","hex":"#ded5c7","rgb":{"r":222,"g":213,"b":199},"luminance":143.3647252325341},{"name":"Shojo's Blood","hex":"#e2041b","rgb":{"r":226,"g":4,"b":27},"luminance":67.68480378932925},{"name":"Shōjōhi Red","hex":"#dc3023","rgb":{"r":220,"g":48,"b":35},"luminance":71.67158067183952},{"name":"Shooting Star","hex":"#ecf0eb","rgb":{"r":236,"g":240,"b":235},"luminance":159.8253940899255},{"name":"Shopping Bag","hex":"#5a4743","rgb":{"r":90,"g":71,"b":67},"luminance":50.194217525527776},{"name":"Shore Water","hex":"#6797a2","rgb":{"r":103,"g":151,"b":162},"luminance":95.63493086733529},{"name":"Shoreland","hex":"#ead9cb","rgb":{"r":234,"g":217,"b":203},"luminance":147.160466705566},{"name":"Short and Sweet","hex":"#edd1d3","rgb":{"r":237,"g":209,"b":211},"luminance":143.70552589931955},{"name":"Short Phase","hex":"#bbdfd5","rgb":{"r":187,"g":223,"b":213},"luminance":144.39858342102943},{"name":"Shortbread","hex":"#f5e6d3","rgb":{"r":245,"g":230,"b":211},"luminance":155.47536795582766},{"name":"Shot Over","hex":"#4a5c69","rgb":{"r":74,"g":92,"b":105},"luminance":59.575773532535855},{"name":"Shot-Put","hex":"#716b63","rgb":{"r":113,"g":107,"b":99},"luminance":72.20737944282426},{"name":"Show Business","hex":"#dd835b","rgb":{"r":221,"g":131,"b":91},"luminance":101.91762716036907},{"name":"Shower","hex":"#9fadb7","rgb":{"r":159,"g":173,"b":183},"luminance":114.05251126564464},{"name":"Shrimp","hex":"#e29a86","rgb":{"r":226,"g":154,"b":134},"luminance":113.89205440240333},{"name":"Shrimp Boat","hex":"#f5be9d","rgb":{"r":245,"g":190,"b":157},"luminance":134.63125316582327},{"name":"Shrimp Boudin","hex":"#dbbfa3","rgb":{"r":219,"g":191,"b":163},"luminance":131.16125103855939},{"name":"Shrimp Cocktail","hex":"#f4a460","rgb":{"r":244,"g":164,"b":96},"luminance":121.2842813228491},{"name":"Shrimp Toast","hex":"#f7c5a0","rgb":{"r":247,"g":197,"b":160},"luminance":138.41727323567676},{"name":"Shrinking Violet","hex":"#5d84b1","rgb":{"r":93,"g":132,"b":177},"luminance":84.75937227823245},{"name":"Shrubbery","hex":"#a9c08a","rgb":{"r":169,"g":192,"b":138},"luminance":124.51132238073772},{"name":"Shrubby Lichen","hex":"#b5d1db","rgb":{"r":181,"g":209,"b":219},"luminance":136.39386278715037},{"name":"Shu Red","hex":"#eb6101","rgb":{"r":235,"g":97,"b":1},"luminance":90.43911179351552},{"name":"Shǔi Cǎo Lǜ Green","hex":"#40826d","rgb":{"r":64,"g":130,"b":109},"luminance":79.64802616512226},{"name":"Shukra Blue","hex":"#2b64ad","rgb":{"r":43,"g":100,"b":173},"luminance":63.24515580659122},{"name":"Shuriken","hex":"#333344","rgb":{"r":51,"g":51,"b":68},"luminance":34.47969654738858},{"name":"Shutter Blue","hex":"#666e7f","rgb":{"r":102,"g":110,"b":127},"luminance":72.86305914522117},{"name":"Shutter Copper","hex":"#bb6622","rgb":{"r":187,"g":102,"b":34},"luminance":82.01330880412031},{"name":"Shutterbug","hex":"#bba262","rgb":{"r":187,"g":162,"b":98},"luminance":110.8780681153852},{"name":"Shutters","hex":"#6c705e","rgb":{"r":108,"g":112,"b":94},"luminance":74.02620789963511},{"name":"Shuttle Grey","hex":"#61666b","rgb":{"r":97,"g":102,"b":107},"luminance":67.63771942488896},{"name":"Shy Beige","hex":"#e2ded6","rgb":{"r":226,"g":222,"b":214},"luminance":148.80574212038997},{"name":"Shy Blunt","hex":"#d3d8de","rgb":{"r":211,"g":216,"b":222},"luminance":143.8642695355591},{"name":"Shy Candela","hex":"#d6dde6","rgb":{"r":214,"g":221,"b":230},"luminance":147.00609213566628},{"name":"Shy Cupid","hex":"#f0d6ca","rgb":{"r":240,"g":214,"b":202},"luminance":146.4911884995135},{"name":"Shy Denim","hex":"#d7dadd","rgb":{"r":215,"g":218,"b":221},"luminance":145.4049380763941},{"name":"Shy Girl","hex":"#ffd7cf","rgb":{"r":255,"g":215,"b":207},"luminance":149.3247054375129},{"name":"Shy Green","hex":"#e5e8d9","rgb":{"r":229,"g":232,"b":217},"luminance":154.42256422233118},{"name":"Shy Guy Red","hex":"#aa0055","rgb":{"r":170,"g":0,"b":85},"luminance":51.74538626776304},{"name":"Shy Mint","hex":"#e0e4db","rgb":{"r":224,"g":228,"b":219},"luminance":151.7272573666314},{"name":"Shy Moment","hex":"#aaaaff","rgb":{"r":170,"g":170,"b":255},"luminance":115.7013305887188},{"name":"Shy Pink","hex":"#dfd9dc","rgb":{"r":223,"g":217,"b":220},"luminance":145.94601183314327},{"name":"Shy Violet","hex":"#d6c7d6","rgb":{"r":214,"g":199,"b":214},"luminance":135.40550203370614},{"name":"Shylock","hex":"#5ab9a4","rgb":{"r":90,"g":185,"b":164},"luminance":113.43087119915812},{"name":"Shyness","hex":"#f3f3d9","rgb":{"r":243,"g":243,"b":217},"luminance":161.97982335463882},{"name":"Siam","hex":"#686b50","rgb":{"r":104,"g":107,"b":80},"luminance":70.67606452682548},{"name":"Siamese Kitten","hex":"#efe1d5","rgb":{"r":239,"g":225,"b":213},"luminance":152.11868941717844},{"name":"Siberian Fur","hex":"#eee2d5","rgb":{"r":238,"g":226,"b":213},"luminance":152.48885864875504},{"name":"Sicilia Bougainvillea","hex":"#ff44ff","rgb":{"r":255,"g":68,"b":255},"luminance":90.83860402383998},{"name":"Sicilian Villa","hex":"#fcc792","rgb":{"r":252,"g":199,"b":146},"luminance":139.9986457398785},{"name":"Sicily Sea","hex":"#c1c6ad","rgb":{"r":193,"g":198,"b":173},"luminance":131.25371693403582},{"name":"Sick Blue","hex":"#502d86","rgb":{"r":80,"g":45,"b":134},"luminance":38.77208791127968},{"name":"Sick Green","hex":"#9db92c","rgb":{"r":157,"g":185,"b":44},"luminance":118.41317295807927},{"name":"Sickly Green","hex":"#94b21c","rgb":{"r":148,"g":178,"b":28},"luminance":113.51542874869476},{"name":"Sickly Yellow","hex":"#d0e429","rgb":{"r":208,"g":228,"b":41},"luminance":147.65421103375274},{"name":"Sidecar","hex":"#e9d9a9","rgb":{"r":233,"g":217,"b":169},"luminance":146.45845583645897},{"name":"Sidekick","hex":"#bfc3ae","rgb":{"r":191,"g":195,"b":174},"luminance":129.44937621325178},{"name":"Sideshow","hex":"#e2c591","rgb":{"r":226,"g":197,"b":145},"luminance":134.95134196072303},{"name":"Sidewalk Chalk Blue","hex":"#dbe9ed","rgb":{"r":219,"g":233,"b":237},"luminance":154.02610209311925},{"name":"Sidewalk Chalk Pink","hex":"#f7ccc4","rgb":{"r":247,"g":204,"b":196},"luminance":142.45386428244058},{"name":"Sidewalk Grey","hex":"#7b8f99","rgb":{"r":123,"g":143,"b":153},"luminance":93.28913427618458},{"name":"Sienna","hex":"#a9561e","rgb":{"r":169,"g":86,"b":30},"luminance":71.50881543558108},{"name":"Sienna Red","hex":"#b1635e","rgb":{"r":177,"g":99,"b":94},"luminance":79.32715395121647},{"name":"Sienna Yellow","hex":"#f1d28c","rgb":{"r":241,"g":210,"b":140},"luminance":143.6757250930024},{"name":"Sierra","hex":"#985c41","rgb":{"r":152,"g":92,"b":65},"luminance":70.97084485899825},{"name":"Sierra Foothills","hex":"#a28a67","rgb":{"r":162,"g":138,"b":103},"luminance":95.11091653432848},{"name":"Siesta","hex":"#f0c3a7","rgb":{"r":240,"g":195,"b":167},"luminance":136.4337907887925},{"name":"Siesta Dreams","hex":"#c9a480","rgb":{"r":201,"g":164,"b":128},"luminance":114.42178153218906},{"name":"Siesta Rose","hex":"#ec7878","rgb":{"r":236,"g":120,"b":120},"luminance":100.6390286916562},{"name":"Siesta Sands","hex":"#f1e6e0","rgb":{"r":241,"g":230,"b":224},"luminance":155.1524633288173},{"name":"Sightful","hex":"#76a4a6","rgb":{"r":118,"g":164,"b":166},"luminance":104.2615227396953},{"name":"Sigmarite","hex":"#caad76","rgb":{"r":202,"g":173,"b":118},"luminance":118.91795620931263},{"name":"Silent Breath","hex":"#e9f1ec","rgb":{"r":233,"g":241,"b":236},"luminance":159.9694601916253},{"name":"Silent Delight","hex":"#e5e7e8","rgb":{"r":229,"g":231,"b":232},"luminance":154.1892374778473},{"name":"Silent Ivory","hex":"#fef2c7","rgb":{"r":254,"g":242,"b":199},"luminance":162.6707977112057},{"name":"Silent Night","hex":"#526771","rgb":{"r":82,"g":103,"b":113},"luminance":66.50271249355171},{"name":"Silent Ripple","hex":"#abe3de","rgb":{"r":171,"g":227,"b":222},"luminance":144.94814764597717},{"name":"Silent Sage","hex":"#729988","rgb":{"r":114,"g":153,"b":136},"luminance":97.30490806223496},{"name":"Silent Smoke","hex":"#dbd7ce","rgb":{"r":219,"g":215,"b":206},"luminance":144.10746560119637},{"name":"Silent Storm","hex":"#c3c7bd","rgb":{"r":195,"g":199,"b":189},"luminance":132.3215028255045},{"name":"Silentropae Cloud","hex":"#ccbbbb","rgb":{"r":204,"g":187,"b":187},"luminance":127.3742615326974},{"name":"Silhouette","hex":"#cbcdc4","rgb":{"r":203,"g":205,"b":196},"luminance":136.61585694933075},{"name":"Silica Sand","hex":"#ede2e0","rgb":{"r":237,"g":226,"b":224},"luminance":152.55444375369734},{"name":"Silicone Seduction","hex":"#ebe0ca","rgb":{"r":235,"g":224,"b":202},"luminance":150.8527532165058},{"name":"Silicone Serena","hex":"#dcdccf","rgb":{"r":220,"g":220,"b":207},"luminance":146.83669025144906},{"name":"Silithus Brown","hex":"#d57b65","rgb":{"r":213,"g":123,"b":101},"luminance":96.96179951919208},{"name":"Silk","hex":"#bbada1","rgb":{"r":187,"g":173,"b":161},"luminance":117.37009195702284},{"name":"Silk Chiffon","hex":"#ccbfc7","rgb":{"r":204,"g":191,"b":199},"luminance":129.63559812412637},{"name":"Silk Crepe Grey","hex":"#354e4b","rgb":{"r":53,"g":78,"b":75},"luminance":49.19946854387758},{"name":"Silk Dessou","hex":"#eee9dc","rgb":{"r":238,"g":233,"b":220},"luminance":156.20289077030552},{"name":"Silk Jewel","hex":"#02517a","rgb":{"r":2,"g":81,"b":122},"luminance":49.5429841349913},{"name":"Silk Khimar","hex":"#70939e","rgb":{"r":112,"g":147,"b":158},"luminance":94.29565106090524},{"name":"Silk Road","hex":"#97976f","rgb":{"r":151,"g":151,"b":111},"luminance":100.27499033158766},{"name":"Silk Sails","hex":"#f6eecd","rgb":{"r":246,"g":238,"b":205},"luminance":159.60612222593468},{"name":"Silk Sari","hex":"#009283","rgb":{"r":0,"g":146,"b":131},"luminance":86.99343170607767},{"name":"Silk Sheets","hex":"#efdddf","rgb":{"r":239,"g":221,"b":223},"luminance":150.27324157680238},{"name":"Silk Sox","hex":"#a5b2c7","rgb":{"r":165,"g":178,"b":199},"luminance":117.75364545100079},{"name":"Silk Star","hex":"#f5eec6","rgb":{"r":245,"g":238,"b":198},"luminance":159.35355862044625},{"name":"Silk Stone","hex":"#cc9999","rgb":{"r":204,"g":153,"b":153},"luminance":109.95795151329438},{"name":"Silken Raspberry","hex":"#aa7d89","rgb":{"r":170,"g":125,"b":137},"luminance":90.61733525656115},{"name":"Silken Tofu","hex":"#fef6d8","rgb":{"r":254,"g":246,"b":216},"luminance":165.0032541982127},{"name":"Silkie Chicken","hex":"#fdefdb","rgb":{"r":253,"g":239,"b":219},"luminance":161.331632403568},{"name":"Silkworm","hex":"#eeeecc","rgb":{"r":238,"g":238,"b":204},"luminance":158.50122465142027},{"name":"Silky Green","hex":"#bdc2bb","rgb":{"r":189,"g":194,"b":187},"luminance":128.90364280733107},{"name":"Silky Pink","hex":"#ffddf4","rgb":{"r":255,"g":221,"b":244},"luminance":153.02328061442154},{"name":"Silky Tofu","hex":"#fff5e4","rgb":{"r":255,"g":245,"b":228},"luminance":164.8382186084283},{"name":"Silly Puddy","hex":"#f4b0bb","rgb":{"r":244,"g":176,"b":187},"luminance":128.2591299050481},{"name":"Silt","hex":"#8a7d72","rgb":{"r":138,"g":125,"b":114},"luminance":85.17827942028414},{"name":"Silt Green","hex":"#a9bdb1","rgb":{"r":169,"g":189,"b":177},"luminance":123.5673213030047},{"name":"Silver","hex":"#c0c0c0","rgb":{"r":192,"g":192,"b":192},"luminance":128.36259043818023},{"name":"Silver Bells","hex":"#b8b4b6","rgb":{"r":184,"g":180,"b":182},"luminance":120.91846575275424},{"name":"Silver Birch","hex":"#d2cfc4","rgb":{"r":210,"g":207,"b":196},"luminance":138.58670757688125},{"name":"Silver Blue","hex":"#8a9a9a","rgb":{"r":138,"g":154,"b":154},"luminance":100.90869231141586},{"name":"Silver Blueberry","hex":"#5b7085","rgb":{"r":91,"g":112,"b":133},"luminance":72.7494980120138},{"name":"Silver Bullet","hex":"#b6b5b8","rgb":{"r":182,"g":181,"b":184},"luminance":121.20122239070034},{"name":"Silver Chalice","hex":"#acaea9","rgb":{"r":172,"g":174,"b":169},"luminance":115.96632694019415},{"name":"Silver Charm","hex":"#adb0b4","rgb":{"r":173,"g":176,"b":180},"luminance":117.34616428754713},{"name":"Silver City","hex":"#e2e4e9","rgb":{"r":226,"g":228,"b":233},"luminance":152.2624714629314},{"name":"Silver Cloud","hex":"#beb7b0","rgb":{"r":190,"g":183,"b":176},"luminance":123.1633526541073},{"name":"Silver Creek","hex":"#d9dad2","rgb":{"r":217,"g":218,"b":210},"luminance":145.45866919850462},{"name":"Silver Cross","hex":"#cdc5c2","rgb":{"r":205,"g":197,"b":194},"luminance":132.7349720382688},{"name":"Silver Dagger","hex":"#c1c1d1","rgb":{"r":193,"g":193,"b":209},"luminance":129.35465513849897},{"name":"Silver Dollar","hex":"#bdb6ae","rgb":{"r":189,"g":182,"b":174},"luminance":122.47637965338458},{"name":"Silver Drop","hex":"#9ab2a9","rgb":{"r":154,"g":178,"b":169},"luminance":115.79610126424808},{"name":"Silver Feather","hex":"#edebe7","rgb":{"r":237,"g":235,"b":231},"luminance":157.30183517683446},{"name":"Silver Fern","hex":"#e1ddbf","rgb":{"r":225,"g":221,"b":191},"luminance":147.74683492379796},{"name":"Silver Filigree","hex":"#7f7c81","rgb":{"r":127,"g":124,"b":129},"luminance":83.40448494535529},{"name":"Silver Fox","hex":"#bdbcc4","rgb":{"r":189,"g":188,"b":196},"luminance":125.98092789386811},{"name":"Silver Grass","hex":"#c6cec3","rgb":{"r":198,"g":206,"b":195},"luminance":136.45944374795025},{"name":"Silver Grass Traces","hex":"#dfe4dc","rgb":{"r":223,"g":228,"b":220},"luminance":151.61432526314917},{"name":"Silver Green","hex":"#d7d7c7","rgb":{"r":215,"g":215,"b":199},"luminance":143.4395965066829},{"name":"Silver Grey","hex":"#c1b7b0","rgb":{"r":193,"g":183,"b":176},"luminance":123.5796633188487},{"name":"Silver Lake","hex":"#dedddd","rgb":{"r":222,"g":221,"b":221},"luminance":147.88465454197743},{"name":"Silver Lake Blue","hex":"#618bb9","rgb":{"r":97,"g":139,"b":185},"luminance":89.12564029503518},{"name":"Silver Laurel","hex":"#d8dcc8","rgb":{"r":216,"g":220,"b":200},"luminance":146.17822223573523},{"name":"Silver Leaf","hex":"#9db7a5","rgb":{"r":157,"g":183,"b":165},"luminance":118.72966179518914},{"name":"Silver Lined","hex":"#bbbfc3","rgb":{"r":187,"g":191,"b":195},"luminance":127.24251710022085},{"name":"Silver Lining","hex":"#bdb6ab","rgb":{"r":189,"g":182,"b":171},"luminance":122.42145528051853},{"name":"Silver Lustre","hex":"#a8a798","rgb":{"r":168,"g":167,"b":152},"luminance":111.50425215658817},{"name":"Silver Mauve","hex":"#dbccd3","rgb":{"r":219,"g":204,"b":211},"luminance":138.58549628658838},{"name":"Silver Medal","hex":"#d6d6d6","rgb":{"r":214,"g":214,"b":214},"luminance":143.07080392588838},{"name":"Silver Mink","hex":"#9f8d7c","rgb":{"r":159,"g":141,"b":124},"luminance":96.49015217108945},{"name":"Silver Peony","hex":"#e7cfc7","rgb":{"r":231,"g":207,"b":199},"luminance":141.59667523639104},{"name":"Silver Pink","hex":"#dcb1af","rgb":{"r":220,"g":177,"b":175},"luminance":124.57934460013826},{"name":"Silver Polish","hex":"#c6c6c6","rgb":{"r":198,"g":198,"b":198},"luminance":132.37392138937338},{"name":"Silver Rust","hex":"#c9a0df","rgb":{"r":201,"g":160,"b":223},"luminance":114.36404279755065},{"name":"Silver Sage","hex":"#938b78","rgb":{"r":147,"g":139,"b":120},"luminance":93.6825824686745},{"name":"Silver Sand","hex":"#bebdb6","rgb":{"r":190,"g":189,"b":182},"luminance":126.35744874363363},{"name":"Silver Sconce","hex":"#a19fa5","rgb":{"r":161,"g":159,"b":165},"luminance":106.68752649677468},{"name":"Silver Screen","hex":"#a6aeaa","rgb":{"r":166,"g":174,"b":170},"luminance":115.20108246019218},{"name":"Silver Service","hex":"#b2aaaa","rgb":{"r":178,"g":170,"b":170},"luminance":114.74410566124953},{"name":"Silver Setting","hex":"#d8dadb","rgb":{"r":216,"g":218,"b":219},"luminance":145.49808028974127},{"name":"Silver Skate","hex":"#87a1b1","rgb":{"r":135,"g":161,"b":177},"luminance":104.72849639902216},{"name":"Silver Spoon","hex":"#d3d3d2","rgb":{"r":211,"g":211,"b":210},"luminance":141.045744246326},{"name":"Silver Springs","hex":"#b7bdc4","rgb":{"r":183,"g":189,"b":196},"luminance":125.70423093118227},{"name":"Silver Spruce","hex":"#cadfdd","rgb":{"r":202,"g":223,"b":221},"luminance":146.3479683528268},{"name":"Silver Star","hex":"#98a0b8","rgb":{"r":152,"g":160,"b":184},"luminance":106.42593518499143},{"name":"Silver Storm","hex":"#8599a8","rgb":{"r":133,"g":153,"b":168},"luminance":100.07112027952918},{"name":"Silver Strand Beach","hex":"#cacdca","rgb":{"r":202,"g":205,"b":202},"luminance":136.59692314616754},{"name":"Silver Strawberry","hex":"#f2c1c0","rgb":{"r":242,"g":193,"b":192},"luminance":136.1969727600434},{"name":"Silver Surfer","hex":"#7e7d88","rgb":{"r":126,"g":125,"b":136},"luminance":83.92612773743348},{"name":"Silver Sweetpea","hex":"#c4c9e2","rgb":{"r":196,"g":201,"b":226},"luminance":134.23540770228993},{"name":"Silver Tree","hex":"#67be90","rgb":{"r":103,"g":190,"b":144},"luminance":116.86265941266268},{"name":"Silverado","hex":"#6a6472","rgb":{"r":106,"g":100,"b":114},"luminance":67.96392905063685},{"name":"Silverbeet","hex":"#5a6a43","rgb":{"r":90,"g":106,"b":67},"luminance":68.22070380756857},{"name":"Silverberry","hex":"#bebbc9","rgb":{"r":190,"g":187,"b":201},"luminance":125.70465726058045},{"name":"Silverfish","hex":"#8d95aa","rgb":{"r":141,"g":149,"b":170},"luminance":99.00879784140396},{"name":"Silverpine","hex":"#4e6866","rgb":{"r":78,"g":104,"b":102},"luminance":66.3775893807541},{"name":"Silverpine Cyan","hex":"#8ae8ff","rgb":{"r":138,"g":232,"b":255},"luminance":145.23670128448938},{"name":"Silverton","hex":"#bfd9ce","rgb":{"r":191,"g":217,"b":206},"luminance":141.55686411474363},{"name":"Silvery Moon","hex":"#e6e5dc","rgb":{"r":230,"g":229,"b":220},"luminance":153.06162885909714},{"name":"Silvery Streak","hex":"#d5dbd5","rgb":{"r":213,"g":219,"b":213},"luminance":145.50437554245576},{"name":"Simmered Seaweed","hex":"#4c3d30","rgb":{"r":76,"g":61,"b":48},"luminance":42.76054500354269},{"name":"Simmering Smoke","hex":"#a99f96","rgb":{"r":169,"g":159,"b":150},"luminance":107.50274810440894},{"name":"Simple Pink","hex":"#f9a3aa","rgb":{"r":249,"g":163,"b":170},"luminance":122.77373319240562},{"name":"Simply Delicious","hex":"#ffd2c1","rgb":{"r":255,"g":210,"b":193},"luminance":146.60450514564687},{"name":"Simply Elegant","hex":"#cedde7","rgb":{"r":206,"g":221,"b":231},"luminance":146.00135246291384},{"name":"Simply Green","hex":"#009b75","rgb":{"r":0,"g":155,"b":117},"luminance":91.95744923060883},{"name":"Simply Peachy","hex":"#ffc06c","rgb":{"r":255,"g":192,"b":108},"luminance":136.62751181588573},{"name":"Simply Taupe","hex":"#ad9f93","rgb":{"r":173,"g":159,"b":147},"luminance":108.01648939860988},{"name":"Simply Violet","hex":"#a6a1d7","rgb":{"r":166,"g":161,"b":215},"luminance":109.52555457517666},{"name":"Simpson Surprise","hex":"#82856d","rgb":{"r":130,"g":133,"b":109},"luminance":88.09292489751942},{"name":"Simpsons Yellow","hex":"#ffd90f","rgb":{"r":255,"g":217,"b":15},"luminance":148.46425080132926},{"name":"Sinatra","hex":"#4675b7","rgb":{"r":70,"g":117,"b":183},"luminance":74.7669244051138},{"name":"Sinbad","hex":"#a6d5d0","rgb":{"r":166,"g":213,"b":208},"luminance":136.5962805533152},{"name":"Sinful","hex":"#645059","rgb":{"r":100,"g":80,"b":89},"luminance":56.58792199754289},{"name":"Singapore Orchid","hex":"#a020f0","rgb":{"r":160,"g":32,"b":240},"luminance":58.22434075195699},{"name":"Singing Blue","hex":"#0074a4","rgb":{"r":0,"g":116,"b":164},"luminance":70.61204486488123},{"name":"Singing the Blues","hex":"#2b4d68","rgb":{"r":43,"g":77,"b":104},"luminance":48.46459311703751},{"name":"Siniy Blue","hex":"#4c4dff","rgb":{"r":76,"g":77,"b":255},"luminance":58.347190823552076},{"name":"Sinkhole","hex":"#49716d","rgb":{"r":73,"g":113,"b":109},"luminance":70.92689874793625},{"name":"Sinking Sand","hex":"#d8b778","rgb":{"r":216,"g":183,"b":120},"luminance":126.08531515208264},{"name":"Sinner's City","hex":"#fee5cb","rgb":{"r":254,"g":229,"b":203},"luminance":156.11819243445012},{"name":"Sinoper Red","hex":"#bb1111","rgb":{"r":187,"g":17,"b":17},"luminance":56.82956848331685},{"name":"Sinopia","hex":"#cb410b","rgb":{"r":203,"g":65,"b":11},"luminance":71.70427009599916},{"name":"Sip of Mint","hex":"#dedfc9","rgb":{"r":222,"g":223,"b":201},"luminance":148.54683463810326},{"name":"Sip of Nut Milk","hex":"#eae2df","rgb":{"r":234,"g":226,"b":223},"luminance":152.12075954319977},{"name":"Sir Edmund","hex":"#20415d","rgb":{"r":32,"g":65,"b":93},"luminance":40.74006692434366},{"name":"Siren","hex":"#69293b","rgb":{"r":105,"g":41,"b":59},"luminance":40.126121043529736},{"name":"Sirocco","hex":"#68766e","rgb":{"r":104,"g":118,"b":110},"luminance":76.95447727065657},{"name":"Sis Kebab","hex":"#884411","rgb":{"r":136,"g":68,"b":17},"luminance":57.01406665025746},{"name":"Sisal","hex":"#c5baa0","rgb":{"r":197,"g":186,"b":160},"luminance":125.39126816888007},{"name":"Siskin Green","hex":"#c8c76f","rgb":{"r":200,"g":199,"b":111},"luminance":131.83869191174492},{"name":"Siskin Sprout","hex":"#7a942e","rgb":{"r":122,"g":148,"b":46},"luminance":94.36939862052739},{"name":"Sixteen Million Pink","hex":"#fd02ff","rgb":{"r":253,"g":2,"b":255},"luminance":81.04882346462531},{"name":"Sixties Blue","hex":"#0079a9","rgb":{"r":0,"g":121,"b":169},"luminance":73.59356959001242},{"name":"Siyâh Black","hex":"#1c1b1a","rgb":{"r":28,"g":27,"b":26},"luminance":18.16773186173772},{"name":"Sizzling Red","hex":"#ff3855","rgb":{"r":255,"g":56,"b":85},"luminance":83.59284962842216},{"name":"Sizzling Sunrise","hex":"#ffdb00","rgb":{"r":255,"g":219,"b":0},"luminance":149.4629513759179},{"name":"Skarsnik Green","hex":"#5f9370","rgb":{"r":95,"g":147,"b":112},"luminance":91.73689208818881},{"name":"Skavenblight Dinge","hex":"#47413b","rgb":{"r":71,"g":65,"b":59},"luminance":44.178202113712146},{"name":"Skeleton","hex":"#ebdecc","rgb":{"r":235,"g":222,"b":204},"luminance":149.8657744683555},{"name":"Skeleton Bone","hex":"#f4ebbc","rgb":{"r":244,"g":235,"b":188},"luminance":157.51422661143977},{"name":"Skeletor's Cape","hex":"#773399","rgb":{"r":119,"g":51,"b":153},"luminance":49.663416052462594},{"name":"Skeptic","hex":"#9db4aa","rgb":{"r":157,"g":180,"b":170},"luminance":117.23167340356444},{"name":"Ski Patrol","hex":"#bb1237","rgb":{"r":187,"g":18,"b":55},"luminance":57.24698092476143},{"name":"Skilandis","hex":"#41332f","rgb":{"r":65,"g":51,"b":47},"luminance":36.092261746806614},{"name":"Skimmed Milk White","hex":"#feffe3","rgb":{"r":254,"g":255,"b":227},"luminance":169.83246163498896},{"name":"Skin Tone","hex":"#decaae","rgb":{"r":222,"g":202,"b":174},"luminance":137.32916389463676},{"name":"Skink Blue","hex":"#5cbfce","rgb":{"r":92,"g":191,"b":206},"luminance":117.80666368673718},{"name":"Skinny Dip","hex":"#f9dbd2","rgb":{"r":249,"g":219,"b":210},"luminance":150.47241876835767},{"name":"Skinny Jeans","hex":"#5588ff","rgb":{"r":85,"g":136,"b":255},"luminance":88.67996024469113},{"name":"Skipper Blue","hex":"#484a72","rgb":{"r":72,"g":74,"b":114},"luminance":50.191738802316856},{"name":"Skipping Stone","hex":"#d0cbb6","rgb":{"r":208,"g":203,"b":182},"luminance":136.00613327714302},{"name":"Skirret Green","hex":"#51b73b","rgb":{"r":81,"g":183,"b":59},"luminance":110.32257374626462},{"name":"Skobeloff","hex":"#007474","rgb":{"r":0,"g":116,"b":116},"luminance":69.36421728816667},{"name":"Skrag Brown","hex":"#b04e0f","rgb":{"r":176,"g":78,"b":15},"luminance":69.77511929047488},{"name":"Skull","hex":"#e3dac9","rgb":{"r":227,"g":218,"b":201},"luminance":146.65296683326935},{"name":"Skullcrusher Brass","hex":"#f1c78e","rgb":{"r":241,"g":199,"b":142},"luminance":138.20212659000583},{"name":"Skullfire","hex":"#f9f5da","rgb":{"r":249,"g":245,"b":218},"luminance":163.83933450182224},{"name":"Sky","hex":"#76d6ff","rgb":{"r":118,"g":214,"b":255},"luminance":133.6778453895783},{"name":"Sky Babe","hex":"#88c1d8","rgb":{"r":136,"g":193,"b":216},"luminance":122.86070548796307},{"name":"Sky Blue","hex":"#9fb9e2","rgb":{"r":159,"g":185,"b":226},"luminance":121.31283692173719},{"name":"Sky Blue Pink","hex":"#dcbfe1","rgb":{"r":220,"g":191,"b":225},"luminance":132.49585876169866},{"name":"Sky Bus","hex":"#99c1d6","rgb":{"r":153,"g":193,"b":214},"luminance":124.59054340518786},{"name":"Sky Captain","hex":"#262934","rgb":{"r":38,"g":41,"b":52},"luminance":27.26640271469634},{"name":"Sky Chase","hex":"#a5cad1","rgb":{"r":165,"g":202,"b":209},"luminance":130.61934763655802},{"name":"Sky City","hex":"#a0bdd9","rgb":{"r":160,"g":189,"b":217},"luminance":123.3247075528663},{"name":"Sky Cloud","hex":"#addee5","rgb":{"r":173,"g":222,"b":229},"luminance":142.6146709178267},{"name":"Sky Eyes","hex":"#8eaabd","rgb":{"r":142,"g":170,"b":189},"luminance":110.56652287197966},{"name":"Sky Glass","hex":"#d1dcd8","rgb":{"r":209,"g":220,"b":216},"luminance":145.5630655660975},{"name":"Sky Grey","hex":"#bcc8c6","rgb":{"r":188,"g":200,"b":198},"luminance":132.10618504824063},{"name":"Sky High","hex":"#a7c2eb","rgb":{"r":167,"g":194,"b":235},"luminance":127.19751362742906},{"name":"Sky Lodge","hex":"#546977","rgb":{"r":84,"g":105,"b":119},"luminance":67.92439206205677},{"name":"Sky Magenta","hex":"#cf71af","rgb":{"r":207,"g":113,"b":175},"luminance":92.88997529335445},{"name":"Sky of Magritte","hex":"#0099ff","rgb":{"r":0,"g":153,"b":255},"luminance":94.39852022674931},{"name":"Sky of Ocean","hex":"#82cde5","rgb":{"r":130,"g":205,"b":229},"luminance":129.12363207794303},{"name":"Sky Pilot","hex":"#a2bad4","rgb":{"r":162,"g":186,"b":212},"luminance":121.86484805718176},{"name":"Sky Splash","hex":"#c9d3d3","rgb":{"r":201,"g":211,"b":211},"luminance":139.75350144450766},{"name":"Sky Wanderer","hex":"#b8dced","rgb":{"r":184,"g":220,"b":237},"luminance":142.94709573824855},{"name":"Skydiver","hex":"#83acd3","rgb":{"r":131,"g":172,"b":211},"luminance":110.93482218401938},{"name":"Skydiving","hex":"#c6d6d7","rgb":{"r":198,"g":214,"b":215},"luminance":141.01595238837342},{"name":"Skydome","hex":"#38a3cc","rgb":{"r":56,"g":163,"b":204},"luminance":99.880212419678},{"name":"Skylight","hex":"#c8e0e0","rgb":{"r":200,"g":224,"b":224},"luminance":146.68749585428202},{"name":"Skyline","hex":"#959eb7","rgb":{"r":149,"g":158,"b":183},"luminance":104.98492825639306},{"name":"Skysail Blue","hex":"#818db3","rgb":{"r":129,"g":141,"b":179},"luminance":93.56550200795162},{"name":"Skyscraper","hex":"#d3dbe2","rgb":{"r":211,"g":219,"b":226},"luminance":145.49872654425536},{"name":"Skywalker","hex":"#c1deea","rgb":{"r":193,"g":222,"b":234},"luminance":144.99463928366455},{"name":"Skyway","hex":"#adbed3","rgb":{"r":173,"g":190,"b":211},"luminance":125.272576188885},{"name":"Slaanesh Grey","hex":"#dbd5e6","rgb":{"r":219,"g":213,"b":230},"luminance":143.5548700741288},{"name":"Slap Happy","hex":"#c9cc4a","rgb":{"r":201,"g":204,"b":74},"luminance":134.24842420304233},{"name":"Slate","hex":"#516572","rgb":{"r":81,"g":101,"b":114},"luminance":65.34833085856133},{"name":"Slate Black","hex":"#4b3d33","rgb":{"r":75,"g":61,"b":51},"luminance":42.647678365885284},{"name":"Slate Blue","hex":"#5b7c99","rgb":{"r":91,"g":124,"b":153},"luminance":79.64073071613545},{"name":"Slate Brown","hex":"#a0987c","rgb":{"r":160,"g":152,"b":124},"luminance":102.22237657186413},{"name":"Slate Green","hex":"#658d6d","rgb":{"r":101,"g":141,"b":109},"luminance":88.97618426298129},{"name":"Slate Grey","hex":"#59656d","rgb":{"r":89,"g":101,"b":109},"luminance":66.16267199864286},{"name":"Slate Pebble","hex":"#b4ada9","rgb":{"r":180,"g":173,"b":169},"luminance":116.53487356581289},{"name":"Slate Rose","hex":"#b45865","rgb":{"r":180,"g":88,"b":101},"luminance":75.48183180077176},{"name":"Slate Wall","hex":"#40535d","rgb":{"r":64,"g":83,"b":93},"luminance":53.40716001623752},{"name":"Sleep","hex":"#4579ac","rgb":{"r":69,"g":121,"b":172},"luminance":76.51762250619134},{"name":"Sleep Baby Sleep","hex":"#bed1e1","rgb":{"r":190,"g":209,"b":225},"luminance":137.6096547811962},{"name":"Sleeping Easy","hex":"#98bddd","rgb":{"r":152,"g":189,"b":221},"luminance":122.50962243432146},{"name":"Sleeping Giant","hex":"#786d5e","rgb":{"r":120,"g":109,"b":94},"luminance":74.13522337593648},{"name":"Sleet","hex":"#92949b","rgb":{"r":146,"g":148,"b":155},"luminance":98.81973483065009},{"name":"Slice of Watermelon","hex":"#e1697c","rgb":{"r":225,"g":105,"b":124},"luminance":92.32889767564649},{"name":"Slices of Happy","hex":"#ede5bc","rgb":{"r":237,"g":229,"b":188},"luminance":153.46152065583084},{"name":"Slick Mud","hex":"#a66e49","rgb":{"r":166,"g":110,"b":73},"luminance":81.86619900789336},{"name":"Sliding","hex":"#97aeaf","rgb":{"r":151,"g":174,"b":175},"luminance":113.43987722577982},{"name":"Slight Mushroom","hex":"#cfc9c5","rgb":{"r":207,"g":201,"b":197},"luminance":135.11490436661677},{"name":"Slightly Golden","hex":"#cb904e","rgb":{"r":203,"g":144,"b":78},"luminance":104.44221491810674},{"name":"Slightly Peach","hex":"#f1ddd8","rgb":{"r":241,"g":221,"b":216},"luminance":150.4258468016717},{"name":"Slightly Rose","hex":"#e6cfce","rgb":{"r":230,"g":207,"b":206},"luminance":141.58124253233547},{"name":"Slightly Spritzig","hex":"#92d2ed","rgb":{"r":146,"g":210,"b":237},"luminance":133.53328027124923},{"name":"Slightly Zen","hex":"#dce4dd","rgb":{"r":220,"g":228,"b":221},"luminance":151.24093669374042},{"name":"Slime","hex":"#a7c408","rgb":{"r":167,"g":196,"b":8},"luminance":125.42367773670168},{"name":"Slimer Green","hex":"#aadd00","rgb":{"r":170,"g":221,"b":0},"luminance":139.32976505040122},{"name":"Slimlime","hex":"#b8ebc5","rgb":{"r":184,"g":235,"b":197},"luminance":150.199683904461},{"name":"Slimy Green","hex":"#7ded17","rgb":{"r":125,"g":237,"b":23},"luminance":144.07588857959544},{"name":"Slipper Satin","hex":"#bfc1cb","rgb":{"r":191,"g":193,"b":203},"luminance":128.96449405165748},{"name":"Slippery Moss","hex":"#beba82","rgb":{"r":190,"g":186,"b":130},"luminance":123.96659882403807},{"name":"Slippery Salmon","hex":"#f87e63","rgb":{"r":248,"g":126,"b":99},"luminance":105.3388358773724},{"name":"Slippery Soap","hex":"#efedd8","rgb":{"r":239,"g":237,"b":216},"luminance":158.32596773113374},{"name":"Slippery Stone","hex":"#8d6a4a","rgb":{"r":141,"g":106,"b":74},"luminance":75.63150574330778},{"name":"Slippery Tub","hex":"#d5f3ec","rgb":{"r":213,"g":243,"b":236},"luminance":158.5128198790243},{"name":"Slopes","hex":"#d2b698","rgb":{"r":210,"g":182,"b":152},"luminance":125.12532613344109},{"name":"Slow Dance","hex":"#dbdcc4","rgb":{"r":219,"g":220,"b":196},"luminance":146.50650257582424},{"name":"Slow Perch","hex":"#d5d4ce","rgb":{"r":213,"g":212,"b":206},"luminance":141.7527472784919},{"name":"Slubbed Silk","hex":"#e1c2be","rgb":{"r":225,"g":194,"b":190},"luminance":134.02716183296576},{"name":"Sludge","hex":"#ca6b02","rgb":{"r":202,"g":107,"b":2},"luminance":87.1374825720826},{"name":"Slugger","hex":"#42342b","rgb":{"r":66,"g":52,"b":43},"luminance":36.676626562430734},{"name":"Slumber","hex":"#2d517c","rgb":{"r":45,"g":81,"b":124},"luminance":51.396310470694296},{"name":"Sly Shrimp","hex":"#f8e2d9","rgb":{"r":248,"g":226,"b":217},"luminance":153.97952458687487},{"name":"Smallmouth Bass","hex":"#ac9a7e","rgb":{"r":172,"g":154,"b":126},"luminance":104.99029518960312},{"name":"Smalt","hex":"#003399","rgb":{"r":0,"g":51,"b":153},"luminance":34.64747224546114},{"name":"Smalt Blue","hex":"#496267","rgb":{"r":73,"g":98,"b":103},"luminance":62.63811275094421},{"name":"Smaragdine","hex":"#4a9976","rgb":{"r":74,"g":153,"b":118},"luminance":93.46941692874734},{"name":"Smashed Grape","hex":"#8775a1","rgb":{"r":135,"g":117,"b":161},"luminance":81.74966410940169},{"name":"Smashed Potatoes","hex":"#e2d0b9","rgb":{"r":226,"g":208,"b":185},"luminance":141.13279842758024},{"name":"Smashed Pumpkin","hex":"#ff6d3a","rgb":{"r":255,"g":109,"b":58},"luminance":99.75391149223171},{"name":"Smell of Garlic","hex":"#d9ddcb","rgb":{"r":217,"g":221,"b":203},"luminance":146.88243728233815},{"name":"Smell of Lavender","hex":"#dce0ea","rgb":{"r":220,"g":224,"b":234},"luminance":149.42460145504822},{"name":"Smells of Fresh Bread","hex":"#d7cecd","rgb":{"r":215,"g":206,"b":205},"luminance":138.92749263194813},{"name":"Smitten","hex":"#c84186","rgb":{"r":200,"g":65,"b":134},"luminance":72.56169927034509},{"name":"Smoke","hex":"#bfc8c3","rgb":{"r":191,"g":200,"b":195},"luminance":132.4325140628237},{"name":"Smoke & Ash","hex":"#939789","rgb":{"r":147,"g":151,"b":137},"luminance":100.1613992613921},{"name":"Smoke and Mirrors","hex":"#d9e6e8","rgb":{"r":217,"g":230,"b":232},"luminance":152.1085155177053},{"name":"Smoke Blue","hex":"#6688bb","rgb":{"r":102,"g":136,"b":187},"luminance":88.0779958445922},{"name":"Smoke Bush","hex":"#cc7788","rgb":{"r":204,"g":119,"b":136},"luminance":94.02301654914076},{"name":"Smoke Cloud","hex":"#adb6b9","rgb":{"r":173,"g":182,"b":185},"luminance":120.55693337589504},{"name":"Smoke Green","hex":"#a8bba2","rgb":{"r":168,"g":187,"b":162},"luminance":122.12106374004445},{"name":"Smoke Grey","hex":"#cebaa8","rgb":{"r":206,"g":186,"b":168},"luminance":126.81218026672357},{"name":"Smoke Pine","hex":"#3e6257","rgb":{"r":62,"g":98,"b":87},"luminance":61.24757010690301},{"name":"Smoke Screen","hex":"#aeaeae","rgb":{"r":174,"g":174,"b":174},"luminance":116.32859758460083},{"name":"Smoke Tree","hex":"#bb5f34","rgb":{"r":187,"g":95,"b":52},"luminance":79.19052959792603},{"name":"Smoked Amethyst","hex":"#5a4351","rgb":{"r":90,"g":67,"b":81},"luminance":48.54055105785265},{"name":"Smoked Black Coffee","hex":"#3b2f2f","rgb":{"r":59,"g":47,"b":47},"luminance":33.182314054327186},{"name":"Smoked Claret","hex":"#583a39","rgb":{"r":88,"g":58,"b":57},"luminance":43.51638155913241},{"name":"Smoked Flamingo","hex":"#674244","rgb":{"r":103,"g":66,"b":68},"luminance":50.094822856259306},{"name":"Smoked Lavender","hex":"#ceb5b3","rgb":{"r":206,"g":181,"b":179},"luminance":124.49357686643917},{"name":"Smoked Paprika","hex":"#6e362c","rgb":{"r":110,"g":54,"b":44},"luminance":45.95297117706318},{"name":"Smoked Pearl","hex":"#656466","rgb":{"r":101,"g":100,"b":102},"luminance":67.0289488579375},{"name":"Smoked Purple","hex":"#444251","rgb":{"r":68,"g":66,"b":81},"luminance":44.71688209166645},{"name":"Smoked Salmon","hex":"#fa8072","rgb":{"r":250,"g":128,"b":114},"luminance":106.7795720725645},{"name":"Smoked Silver","hex":"#ddbbcc","rgb":{"r":221,"g":187,"b":204},"luminance":130.2171614573133},{"name":"Smoking Red","hex":"#992200","rgb":{"r":153,"g":34,"b":0},"luminance":49.91101855302093},{"name":"Smoky","hex":"#605d6b","rgb":{"r":96,"g":93,"b":107},"luminance":62.871997749395554},{"name":"Smoky Black","hex":"#100c08","rgb":{"r":16,"g":12,"b":8},"luminance":8.563663701944396},{"name":"Smoky Blue","hex":"#7196a6","rgb":{"r":113,"g":150,"b":166},"luminance":96.18982090117436},{"name":"Smoky Day","hex":"#a49e93","rgb":{"r":164,"g":158,"b":147},"luminance":106.24114257668731},{"name":"Smoky Emerald","hex":"#4c726b","rgb":{"r":76,"g":114,"b":107},"luminance":71.71603798314571},{"name":"Smoky Forest","hex":"#817d68","rgb":{"r":129,"g":125,"b":104},"luminance":83.73874492730351},{"name":"Smoky Grape","hex":"#9b8fa6","rgb":{"r":155,"g":143,"b":166},"luminance":97.73468310686845},{"name":"Smoky Mountain","hex":"#afa8a9","rgb":{"r":175,"g":168,"b":169},"luminance":113.28812752005392},{"name":"Smoky Orchid","hex":"#e1d9dc","rgb":{"r":225,"g":217,"b":220},"luminance":146.2201821432322},{"name":"Smoky Pink","hex":"#bb8d88","rgb":{"r":187,"g":141,"b":136},"luminance":101.07924551558544},{"name":"Smoky Quartz","hex":"#51484f","rgb":{"r":81,"g":72,"b":79},"luminance":49.53699317681686},{"name":"Smoky Slate","hex":"#a1a18f","rgb":{"r":161,"g":161,"b":143},"luminance":107.30653090096612},{"name":"Smoky Sunrise","hex":"#aa9793","rgb":{"r":170,"g":151,"b":147},"luminance":103.54244169904436},{"name":"Smoky Topaz","hex":"#7e7668","rgb":{"r":126,"g":118,"b":104},"luminance":79.73502221734185},{"name":"Smooth As Corn Silk","hex":"#f4e4b3","rgb":{"r":244,"g":228,"b":179},"luminance":153.78900372913532},{"name":"Smooth Beech","hex":"#d3bb96","rgb":{"r":211,"g":187,"b":150},"luminance":127.75705570339353},{"name":"Smooth Satin","hex":"#a2d5d3","rgb":{"r":162,"g":213,"b":211},"luminance":136.2262299302157},{"name":"Smooth Stone","hex":"#bcb6b3","rgb":{"r":188,"g":182,"b":179},"luminance":122.43241946478064},{"name":"Smooth-Hound Shark","hex":"#97b2b1","rgb":{"r":151,"g":178,"b":177},"luminance":115.59804531651908},{"name":"Smudged Lips","hex":"#ee4466","rgb":{"r":238,"g":68,"b":102},"luminance":82.416792487939},{"name":"Snail Trail Silver","hex":"#e9eeeb","rgb":{"r":233,"g":238,"b":235},"luminance":158.39495391267994},{"name":"Snake Eyes","hex":"#e9cb4c","rgb":{"r":233,"g":203,"b":76},"luminance":138.30365037120313},{"name":"Snake River","hex":"#45698c","rgb":{"r":69,"g":105,"b":140},"luminance":66.92707214573188},{"name":"Snakebite","hex":"#bb4444","rgb":{"r":187,"g":68,"b":68},"luminance":69.13497037679267},{"name":"Snakebite Leather","hex":"#baa208","rgb":{"r":186,"g":162,"b":8},"luminance":110.16631779269015},{"name":"Snakes in the Grass","hex":"#889717","rgb":{"r":136,"g":151,"b":23},"luminance":97.55487455273571},{"name":"Snap-Shot","hex":"#2b3e52","rgb":{"r":43,"g":62,"b":82},"luminance":39.71411322187617},{"name":"Snapdragon","hex":"#fed777","rgb":{"r":254,"g":215,"b":119},"luminance":147.91731912457038},{"name":"Snappy Happy","hex":"#eb8239","rgb":{"r":235,"g":130,"b":57},"luminance":103.93560664661557},{"name":"Sneezy","hex":"#9d7938","rgb":{"r":157,"g":121,"b":56},"luminance":85.37701935532769},{"name":"Snip of Tannin","hex":"#dccebb","rgb":{"r":220,"g":206,"b":187},"luminance":139.29678965432046},{"name":"Snoop","hex":"#49556c","rgb":{"r":73,"g":85,"b":108},"luminance":55.8347051393665},{"name":"Snorkel Blue","hex":"#034f84","rgb":{"r":3,"g":79,"b":132},"luminance":48.76168620956416},{"name":"Snorkel Sea","hex":"#004f7d","rgb":{"r":0,"g":79,"b":125},"luminance":48.51306658004624},{"name":"Snorlax","hex":"#222277","rgb":{"r":34,"g":34,"b":119},"luminance":26.185982433355445},{"name":"Snot","hex":"#acbb0d","rgb":{"r":172,"g":187,"b":13},"luminance":121.22816862841738},{"name":"Snot Green","hex":"#9dc100","rgb":{"r":157,"g":193,"b":0},"luminance":122.63154541144786},{"name":"Snow","hex":"#fffafa","rgb":{"r":255,"g":250,"b":250},"luminance":167.81273052125692},{"name":"Snow Ballet","hex":"#def1e7","rgb":{"r":222,"g":241,"b":231},"luminance":158.46902072329465},{"name":"Snow Drift","hex":"#e3e3dc","rgb":{"r":227,"g":227,"b":220},"luminance":151.62798729126493},{"name":"Snow Drop","hex":"#eeffcc","rgb":{"r":238,"g":255,"b":204},"luminance":167.36329049406265},{"name":"Snow Flurry","hex":"#eaf7c9","rgb":{"r":234,"g":247,"b":201},"luminance":162.6102784973939},{"name":"Snow Globe","hex":"#f4f2e9","rgb":{"r":244,"g":242,"b":233},"luminance":161.88717273459315},{"name":"Snow Goose","hex":"#c3d9cb","rgb":{"r":195,"g":217,"b":203},"luminance":141.9874460295698},{"name":"Snow Green","hex":"#c8dac2","rgb":{"r":200,"g":218,"b":194},"luminance":142.97011789881128},{"name":"Snow Leopard","hex":"#cfdfdb","rgb":{"r":207,"g":223,"b":219},"luminance":146.93235316294366},{"name":"Snow Pea","hex":"#6ccc7b","rgb":{"r":108,"g":204,"b":123},"luminance":124.8157572264015},{"name":"Snow Peak","hex":"#e0dcdb","rgb":{"r":224,"g":220,"b":219},"luminance":147.60157631949596},{"name":"Snow Plum","hex":"#f4eaf0","rgb":{"r":244,"g":234,"b":240},"luminance":157.91886429429513},{"name":"Snow Shadow","hex":"#d7e4ed","rgb":{"r":215,"g":228,"b":237},"luminance":150.91258544269922},{"name":"Snow Storm","hex":"#eeedea","rgb":{"r":238,"g":237,"b":234},"luminance":158.52361143060045},{"name":"Snow White","hex":"#eeffee","rgb":{"r":238,"g":255,"b":238},"luminance":167.94574985095633},{"name":"Snow White Blush","hex":"#f8afa9","rgb":{"r":248,"g":175,"b":169},"luminance":128.14883333452553},{"name":"Snowball Effect","hex":"#d9e9e5","rgb":{"r":217,"g":233,"b":229},"luminance":153.61521202667396},{"name":"Snowbank","hex":"#e8e9e9","rgb":{"r":232,"g":233,"b":233},"luminance":155.6398589982656},{"name":"Snowdrop Explosion","hex":"#e0efe1","rgb":{"r":224,"g":239,"b":225},"luminance":157.56215575130975},{"name":"Snowflake","hex":"#eff0f0","rgb":{"r":239,"g":240,"b":240},"luminance":160.31973840110894},{"name":"Snowpink","hex":"#f1c5c2","rgb":{"r":241,"g":197,"b":194},"luminance":138.03620995231648},{"name":"Snowshoe Hare","hex":"#e7e3d6","rgb":{"r":231,"g":227,"b":214},"luminance":152.0558699228675},{"name":"Snowy Evergreen","hex":"#edf2e0","rgb":{"r":237,"g":242,"b":224},"luminance":160.78865314754023},{"name":"Snowy Mint","hex":"#d6f0cd","rgb":{"r":214,"g":240,"b":205},"luminance":156.48494974277878},{"name":"Snowy Mount","hex":"#f1eeeb","rgb":{"r":241,"g":238,"b":235},"luminance":159.46150010896045},{"name":"Snowy Shadow","hex":"#d3dbec","rgb":{"r":211,"g":219,"b":236},"luminance":145.70491050750488},{"name":"Snowy Summit","hex":"#c5d8e9","rgb":{"r":197,"g":216,"b":233},"luminance":142.30711337456043},{"name":"Snub","hex":"#a5adbd","rgb":{"r":165,"g":173,"b":189},"luminance":114.93814833204857},{"name":"Snuff","hex":"#e4d7e5","rgb":{"r":228,"g":215,"b":229},"luminance":145.79659407887414},{"name":"Snug Cottage","hex":"#fff9e2","rgb":{"r":255,"g":249,"b":226},"luminance":166.85534540433517},{"name":"Snuggle Pie","hex":"#a58f73","rgb":{"r":165,"g":143,"b":115},"luminance":98.24411334018949},{"name":"So Chic!","hex":"#cecdc5","rgb":{"r":206,"g":205,"b":197},"luminance":137.03537800509764},{"name":"So Sublime","hex":"#8b847c","rgb":{"r":139,"g":132,"b":124},"luminance":89.05567625367851},{"name":"So-Sari","hex":"#006f47","rgb":{"r":0,"g":111,"b":71},"luminance":65.65780597156746},{"name":"Soap","hex":"#cec8ef","rgb":{"r":206,"g":200,"b":239},"luminance":135.34742462270938},{"name":"Soap Bubble","hex":"#b2dcef","rgb":{"r":178,"g":220,"b":239},"luminance":142.3097515984059},{"name":"Soapstone","hex":"#ece5da","rgb":{"r":236,"g":229,"b":218},"luminance":153.839016276756},{"name":"Soaring Eagle","hex":"#9badbe","rgb":{"r":155,"g":173,"b":190},"luminance":113.70848792416508},{"name":"Soaring Sky","hex":"#b9e5e8","rgb":{"r":185,"g":229,"b":232},"luminance":147.74568981191973},{"name":"Sodalite Blue","hex":"#253668","rgb":{"r":37,"g":54,"b":104},"luminance":35.60502645694846},{"name":"Sōdenkaracha Brown","hex":"#9b533f","rgb":{"r":155,"g":83,"b":63},"luminance":67.62526147823755},{"name":"Sodium Silver","hex":"#fffcee","rgb":{"r":255,"g":252,"b":238},"luminance":168.61481318377693},{"name":"Soft Amber","hex":"#cfbea5","rgb":{"r":207,"g":190,"b":165},"luminance":128.93215444178384},{"name":"Soft Amethyst","hex":"#cfb7c9","rgb":{"r":207,"g":183,"b":201},"luminance":126.07563636960155},{"name":"Soft Bark","hex":"#897670","rgb":{"r":137,"g":118,"b":112},"luminance":81.47863492351844},{"name":"Soft Beige","hex":"#b9b5af","rgb":{"r":185,"g":181,"b":175},"luminance":121.43383685777206},{"name":"Soft Blue","hex":"#6488ea","rgb":{"r":100,"g":136,"b":234},"luminance":89.32394527784808},{"name":"Soft Blush","hex":"#e3bcbc","rgb":{"r":227,"g":188,"b":188},"luminance":131.318397374473},{"name":"Soft Bromeliad","hex":"#99656c","rgb":{"r":153,"g":101,"b":108},"luminance":75.89019516380229},{"name":"Soft Candlelight","hex":"#f7eacf","rgb":{"r":247,"g":234,"b":207},"luminance":157.7287271773915},{"name":"Soft Cashmere","hex":"#efb6d8","rgb":{"r":239,"g":182,"b":216},"luminance":130.86832868574427},{"name":"Soft Celadon","hex":"#bfcfc8","rgb":{"r":191,"g":207,"b":200},"luminance":136.18265294082062},{"name":"Soft Celery","hex":"#c4cd87","rgb":{"r":196,"g":205,"b":135},"luminance":134.72859065914702},{"name":"Soft Chamois","hex":"#dbb67a","rgb":{"r":219,"g":182,"b":122},"luminance":126.07417412380696},{"name":"Soft Charcoal","hex":"#838298","rgb":{"r":131,"g":130,"b":152},"luminance":87.50820672942625},{"name":"Soft Cocoa","hex":"#987b71","rgb":{"r":152,"g":123,"b":113},"luminance":86.2812321944929},{"name":"Soft Coral","hex":"#ffeee0","rgb":{"r":255,"g":238,"b":224},"luminance":161.19290851957476},{"name":"Soft Cream","hex":"#f5efd6","rgb":{"r":245,"g":239,"b":214},"luminance":160.13614735592958},{"name":"Soft Doeskin","hex":"#e0cfb9","rgb":{"r":224,"g":207,"b":185},"luminance":140.33891034563436},{"name":"Soft Dove","hex":"#c2bbb2","rgb":{"r":194,"g":187,"b":178},"luminance":125.8002172533895},{"name":"Soft Fern","hex":"#c7d368","rgb":{"r":199,"g":211,"b":104},"luminance":137.91841858867147},{"name":"Soft Focus","hex":"#e2efdd","rgb":{"r":226,"g":239,"b":221},"luminance":157.74380799574985},{"name":"Soft Fresco","hex":"#c0d5ca","rgb":{"r":192,"g":213,"b":202},"luminance":139.4945096016327},{"name":"Soft Froth","hex":"#bdccb3","rgb":{"r":189,"g":204,"b":179},"luminance":133.97567488540597},{"name":"Soft Fur","hex":"#7e7574","rgb":{"r":126,"g":117,"b":116},"luminance":79.44186234599489},{"name":"Soft Green","hex":"#6fc276","rgb":{"r":111,"g":194,"b":118},"luminance":119.37614882797986},{"name":"Soft Impact","hex":"#b28ea8","rgb":{"r":178,"g":142,"b":168},"luminance":100.73365725515976},{"name":"Soft Impala","hex":"#a28b7e","rgb":{"r":162,"g":139,"b":126},"luminance":95.96865107419192},{"name":"Soft Ivory","hex":"#fbf1df","rgb":{"r":251,"g":241,"b":223},"luminance":162.14666994422055},{"name":"Soft Kind","hex":"#d1d2be","rgb":{"r":209,"g":210,"b":190},"luminance":139.892006851714},{"name":"Soft Lavender","hex":"#f6e5f6","rgb":{"r":246,"g":229,"b":246},"luminance":155.77612070211532},{"name":"Soft Leather","hex":"#d9a077","rgb":{"r":217,"g":160,"b":119},"luminance":114.95567165216337},{"name":"Soft Lilac","hex":"#e2d4df","rgb":{"r":226,"g":212,"b":223},"luminance":143.87088898036322},{"name":"Soft Lumen","hex":"#beddba","rgb":{"r":190,"g":221,"b":186},"luminance":143.19944219514267},{"name":"Soft Matte","hex":"#dd99bb","rgb":{"r":221,"g":153,"b":187},"luminance":113.52051394351595},{"name":"Soft Metal","hex":"#bab2b1","rgb":{"r":186,"g":178,"b":177},"luminance":120.07244844676066},{"name":"Soft Mint","hex":"#e6f9f1","rgb":{"r":230,"g":249,"b":241},"luminance":163.85284905975848},{"name":"Soft Moss","hex":"#cce1c7","rgb":{"r":204,"g":225,"b":199},"luminance":147.23780844946043},{"name":"Soft Orange Bloom","hex":"#ffdcd2","rgb":{"r":255,"g":220,"b":210},"luminance":151.8669260405306},{"name":"Soft Peach","hex":"#eedfde","rgb":{"r":238,"g":223,"b":222},"luminance":151.12775029424606},{"name":"Soft Peach Mist","hex":"#fff3f0","rgb":{"r":255,"g":243,"b":240},"luminance":164.0375704099521},{"name":"Soft Petals","hex":"#ebf8ef","rgb":{"r":235,"g":248,"b":239},"luminance":163.9264667983788},{"name":"Soft Pink","hex":"#fdb0c0","rgb":{"r":253,"g":176,"b":192},"luminance":129.9035122581372},{"name":"Soft Pumice","hex":"#949ea2","rgb":{"r":148,"g":158,"b":162},"luminance":104.40846251142672},{"name":"Soft Purple","hex":"#a66fb5","rgb":{"r":166,"g":111,"b":181},"luminance":84.46733428373362},{"name":"Soft Salmon","hex":"#eaaaa2","rgb":{"r":234,"g":170,"b":162},"luminance":123.26537340226572},{"name":"Soft Satin","hex":"#eec5ce","rgb":{"r":238,"g":197,"b":206},"luminance":137.79661396783303},{"name":"Soft Savvy","hex":"#837e87","rgb":{"r":131,"g":126,"b":135},"luminance":85.09665154987003},{"name":"Soft Silver","hex":"#f7f9e9","rgb":{"r":247,"g":249,"b":233},"luminance":165.90186262366072},{"name":"Soft Sky","hex":"#b5b5cb","rgb":{"r":181,"g":181,"b":203},"luminance":121.46128327166646},{"name":"Soft Steel","hex":"#404854","rgb":{"r":64,"g":72,"b":84},"luminance":47.37227003216122},{"name":"Soft Straw","hex":"#f5d180","rgb":{"r":245,"g":209,"b":128},"luminance":143.6326563773016},{"name":"Soft Suede","hex":"#d8cbad","rgb":{"r":216,"g":203,"b":173},"luminance":136.96493807175617},{"name":"Soft Summer Rain","hex":"#a1d7ef","rgb":{"r":161,"g":215,"b":239},"luminance":137.79481072232002},{"name":"Soft Tone","hex":"#c3b3b2","rgb":{"r":195,"g":179,"b":178},"luminance":121.8670325313618},{"name":"Soft Tone Ink","hex":"#9d6016","rgb":{"r":157,"g":96,"b":22},"luminance":73.38585161323672},{"name":"Soft Touch","hex":"#639b95","rgb":{"r":99,"g":155,"b":149},"luminance":97.17516978117403},{"name":"Softly Softly","hex":"#c9b7ce","rgb":{"r":201,"g":183,"b":206},"luminance":125.31025216637303},{"name":"Softsun","hex":"#f3ca40","rgb":{"r":243,"g":202,"b":64},"luminance":139.2553939386191},{"name":"Sohi Orange","hex":"#e0815e","rgb":{"r":224,"g":129,"b":94},"luminance":101.65918532528184},{"name":"Sohi Red","hex":"#e35c38","rgb":{"r":227,"g":92,"b":56},"luminance":86.97086639214305},{"name":"Soho Red","hex":"#ab6953","rgb":{"r":171,"g":105,"b":83},"luminance":80.63855969695886},{"name":"Soil Of Avagddu","hex":"#845c00","rgb":{"r":132,"g":92,"b":0},"luminance":66.88912497558927},{"name":"Solar","hex":"#fbeab8","rgb":{"r":251,"g":234,"b":184},"luminance":157.9226555659447},{"name":"Solar Light","hex":"#faf0c9","rgb":{"r":250,"g":240,"b":201},"luminance":161.12041551584952},{"name":"Solar Power","hex":"#f4bf3a","rgb":{"r":244,"g":191,"b":58},"luminance":133.92728687239207},{"name":"Solar Wind","hex":"#fce9b9","rgb":{"r":252,"g":233,"b":185},"luminance":157.57035141485215},{"name":"Soldier Green","hex":"#545a2c","rgb":{"r":84,"g":90,"b":44},"luminance":58.71100929127347},{"name":"Soleil","hex":"#e9cb2e","rgb":{"r":233,"g":203,"b":46},"luminance":138.13158344853647},{"name":"Solid Empire","hex":"#635c59","rgb":{"r":99,"g":92,"b":89},"luminance":62.414682030752985},{"name":"Solid Gold","hex":"#b7d24b","rgb":{"r":183,"g":210,"b":75},"luminance":135.13898582200474},{"name":"Solid Pink","hex":"#c78b95","rgb":{"r":199,"g":139,"b":149},"luminance":102.40268964241125},{"name":"Solid Snake","hex":"#a1a58c","rgb":{"r":161,"g":165,"b":140},"luminance":109.32966635822136},{"name":"Solitaire","hex":"#c6decf","rgb":{"r":198,"g":222,"b":207},"luminance":145.06371360198938},{"name":"Solitary State","hex":"#c4c7c4","rgb":{"r":196,"g":199,"b":196},"luminance":132.58567087359026},{"name":"Solitude","hex":"#e9ecf1","rgb":{"r":233,"g":236,"b":241},"luminance":157.4783368879669},{"name":"Solstice","hex":"#babdb8","rgb":{"r":186,"g":189,"b":184},"luminance":125.86206267577217},{"name":"Solution","hex":"#77abab","rgb":{"r":119,"g":171,"b":171},"luminance":108.26617997324927},{"name":"Somber","hex":"#cbb489","rgb":{"r":203,"g":180,"b":137},"luminance":122.84984059004717},{"name":"Somber Green","hex":"#005c2b","rgb":{"r":0,"g":92,"b":43},"luminance":54.22602345737699},{"name":"Sombre Grey","hex":"#555470","rgb":{"r":85,"g":84,"b":112},"luminance":56.92295594046394},{"name":"Someday","hex":"#efe4cc","rgb":{"r":239,"g":228,"b":204},"luminance":153.4913383647429},{"name":"Somnambulist","hex":"#778899","rgb":{"r":119,"g":136,"b":153},"luminance":89.12563687850987},{"name":"Sonata","hex":"#abc8d8","rgb":{"r":171,"g":200,"b":216},"luminance":130.3966104505788},{"name":"Song Thrush Egg","hex":"#f2e5e0","rgb":{"r":242,"g":229,"b":224},"luminance":154.78149239815463},{"name":"Songbird","hex":"#a3d1eb","rgb":{"r":163,"g":209,"b":235},"luminance":134.7001030363377},{"name":"Sonia Rose","hex":"#f3c8c2","rgb":{"r":243,"g":200,"b":194},"luminance":139.8245940634193},{"name":"Sonic Blue","hex":"#17569b","rgb":{"r":23,"g":86,"b":155},"luminance":53.92545181081008},{"name":"Sonic Silver","hex":"#757575","rgb":{"r":117,"g":117,"b":117},"luminance":78.22095354826608},{"name":"Sonoma Chardonnay","hex":"#ddcb91","rgb":{"r":221,"g":203,"b":145},"luminance":137.25530613422563},{"name":"Sonoma Sage","hex":"#90a58a","rgb":{"r":144,"g":165,"b":138},"luminance":107.15505580699399},{"name":"Sonoma Sky","hex":"#bfd1ca","rgb":{"r":191,"g":209,"b":202},"luminance":137.26924329215194},{"name":"Sonora Apricot","hex":"#e0b493","rgb":{"r":224,"g":180,"b":147},"luminance":126.21668170253882},{"name":"Sonora Hills","hex":"#bea77d","rgb":{"r":190,"g":167,"b":125},"luminance":114.19335988138714},{"name":"Sonora Rose","hex":"#e8d2e3","rgb":{"r":232,"g":210,"b":227},"luminance":143.7952822870069},{"name":"Sonora Shade","hex":"#c89672","rgb":{"r":200,"g":150,"b":114},"luminance":107.22750820568386},{"name":"Sonorous Bells","hex":"#faf0cb","rgb":{"r":250,"g":240,"b":203},"luminance":161.15299892958865},{"name":"Soooo Bloody","hex":"#550000","rgb":{"r":85,"g":0,"b":0},"luminance":25.415},{"name":"Soot","hex":"#555e5f","rgb":{"r":85,"g":94,"b":95},"luminance":61.707558767139695},{"name":"Soothing Breeze","hex":"#b3bec4","rgb":{"r":179,"g":190,"b":196},"luminance":125.70876133746604},{"name":"Soothing Sea","hex":"#c3e9e4","rgb":{"r":195,"g":233,"b":228},"luminance":150.93496457083756},{"name":"Soothsayer","hex":"#8092bc","rgb":{"r":128,"g":146,"b":188},"luminance":96.27517547114624},{"name":"Sooty","hex":"#141414","rgb":{"r":20,"g":20,"b":20},"luminance":13.371103170643773},{"name":"Sooty Willow Bamboo","hex":"#4d4b3a","rgb":{"r":77,"g":75,"b":58},"luminance":50.11963385740163},{"name":"Sophisticated Plum","hex":"#5d5153","rgb":{"r":93,"g":81,"b":83},"luminance":55.88806582804597},{"name":"Sophistication","hex":"#bfb5a6","rgb":{"r":191,"g":181,"b":166},"luminance":122.09824186285402},{"name":"Sophomore","hex":"#7d7170","rgb":{"r":125,"g":113,"b":112},"luminance":77.19918399827812},{"name":"Sora Blue","hex":"#a0d8ef","rgb":{"r":160,"g":216,"b":239},"luminance":138.22887317778438},{"name":"Sora Sky","hex":"#4d8fac","rgb":{"r":77,"g":143,"b":172},"luminance":89.22232721690237},{"name":"Sorbus","hex":"#dd6b38","rgb":{"r":221,"g":107,"b":56},"luminance":91.3901536162403},{"name":"Sorcerer","hex":"#3398ce","rgb":{"r":51,"g":152,"b":206},"luminance":93.51445039671675},{"name":"Sorrel Felt","hex":"#a49688","rgb":{"r":164,"g":150,"b":136},"luminance":101.96914146936807},{"name":"Sorrell Brown","hex":"#9d7f61","rgb":{"r":157,"g":127,"b":97},"luminance":88.78895209427803},{"name":"Sorx Red","hex":"#fc0156","rgb":{"r":252,"g":1,"b":86},"luminance":75.98542023967492},{"name":"Sotek Green","hex":"#47788a","rgb":{"r":71,"g":120,"b":138},"luminance":75.23270475664158},{"name":"Souffle","hex":"#edd1a8","rgb":{"r":237,"g":209,"b":168},"luminance":142.966717672331},{"name":"Soul Quenching","hex":"#7e989d","rgb":{"r":126,"g":152,"b":157},"luminance":98.49157758915226},{"name":"Soul Side","hex":"#ffaa55","rgb":{"r":255,"g":170,"b":85},"luminance":125.95729524326885},{"name":"Soulstone Blue","hex":"#0047ab","rgb":{"r":0,"g":71,"b":171},"luminance":46.010741843617346},{"name":"Sour Apple","hex":"#a0ac4f","rgb":{"r":160,"g":172,"b":79},"luminance":112.08703284501736},{"name":"Sour Candy","hex":"#66b348","rgb":{"r":102,"g":179,"b":72},"luminance":109.71706611553189},{"name":"Sour Face","hex":"#adc979","rgb":{"r":173,"g":201,"b":121},"luminance":129.56422783314844},{"name":"Sour Green Cherry","hex":"#c8ffb0","rgb":{"r":200,"g":255,"b":176},"luminance":162.43214989958116},{"name":"Sour Lemon","hex":"#ffeea5","rgb":{"r":255,"g":238,"b":165},"luminance":160.2650384862525},{"name":"Sour Patch Peach","hex":"#f4d9c5","rgb":{"r":244,"g":217,"b":197},"luminance":148.5003344811048},{"name":"Sourdough","hex":"#c9b59a","rgb":{"r":201,"g":181,"b":154},"luminance":123.32286059770102},{"name":"South Peak","hex":"#eadfd2","rgb":{"r":234,"g":223,"b":210},"luminance":150.34439316781985},{"name":"South Rim Trail","hex":"#a6847b","rgb":{"r":166,"g":132,"b":123},"luminance":93.08018422843823},{"name":"South Shore Sun","hex":"#ffdc9e","rgb":{"r":255,"g":220,"b":158},"luminance":151.0459260258283},{"name":"Southern Barrens Mud","hex":"#b98258","rgb":{"r":185,"g":130,"b":88},"luminance":94.78188829623517},{"name":"Southern Belle","hex":"#a6d6c3","rgb":{"r":166,"g":214,"b":195},"luminance":136.88531250649208},{"name":"Southern Breeze","hex":"#e4dfd1","rgb":{"r":228,"g":223,"b":209},"luminance":149.49973799642592},{"name":"Southern Moss","hex":"#bca66a","rgb":{"r":188,"g":166,"b":106},"luminance":113.14042320939055},{"name":"Southern Pine","hex":"#acb4ab","rgb":{"r":172,"g":180,"b":171},"luminance":119.11713067397149},{"name":"Southern Platyfish","hex":"#d0d34d","rgb":{"r":208,"g":211,"b":77},"luminance":138.8720799765021},{"name":"Southwestern Clay","hex":"#cc6758","rgb":{"r":204,"g":103,"b":88},"luminance":86.46782963044694},{"name":"Sovereignty","hex":"#304e63","rgb":{"r":48,"g":78,"b":99},"luminance":49.29210378955233},{"name":"Soya","hex":"#fae3bc","rgb":{"r":250,"g":227,"b":188},"luminance":154.27958103715474},{"name":"Soya Bean","hex":"#6f634b","rgb":{"r":111,"g":99,"b":75},"luminance":67.46653236976093},{"name":"Soybean","hex":"#d2c29d","rgb":{"r":210,"g":194,"b":157},"luminance":131.26736604350677},{"name":"Soylent Green","hex":"#578363","rgb":{"r":87,"g":131,"b":99},"luminance":81.9585173975225},{"name":"Spa Blue","hex":"#d3dedf","rgb":{"r":211,"g":222,"b":223},"luminance":146.99741018466958},{"name":"Spa Dream","hex":"#1993be","rgb":{"r":25,"g":147,"b":190},"luminance":89.27946430170826},{"name":"Spa Sangria","hex":"#d7c9a5","rgb":{"r":215,"g":201,"b":165},"luminance":135.67354013955705},{"name":"Space Angel","hex":"#3b4271","rgb":{"r":59,"g":66,"b":113},"luminance":44.475761589881735},{"name":"Space Cadet","hex":"#1d2951","rgb":{"r":29,"g":41,"b":81},"luminance":27.196938908634554},{"name":"Space Convoy","hex":"#667788","rgb":{"r":102,"g":119,"b":136},"luminance":77.78138356316374},{"name":"Space Grey","hex":"#110022","rgb":{"r":17,"g":0,"b":34},"luminance":6.392203454208885},{"name":"Space Invader","hex":"#139d08","rgb":{"r":19,"g":157,"b":8},"luminance":92.33843612494202},{"name":"Space Opera","hex":"#5511dd","rgb":{"r":85,"g":17,"b":221},"luminance":37.15158545742025},{"name":"Space Shuttle","hex":"#4b433b","rgb":{"r":75,"g":67,"b":59},"luminance":45.76996768624596},{"name":"Space Station","hex":"#6c6d7a","rgb":{"r":108,"g":109,"b":122},"luminance":73.00705457008932},{"name":"Space Wolves Grey","hex":"#dae6ef","rgb":{"r":218,"g":230,"b":239},"luminance":152.3769593475339},{"name":"Spaceman","hex":"#5f6882","rgb":{"r":95,"g":104,"b":130},"luminance":68.94443218273685},{"name":"Spacescape","hex":"#222255","rgb":{"r":34,"g":34,"b":85},"luminance":24.404209063192354},{"name":"Spacious Plain","hex":"#9a8557","rgb":{"r":154,"g":133,"b":87},"luminance":91.17939394951031},{"name":"Spacious Sky","hex":"#aeb5c7","rgb":{"r":174,"g":181,"b":199},"luminance":120.45656595221367},{"name":"Spaghetti","hex":"#fef69e","rgb":{"r":254,"g":246,"b":158},"luminance":164.14677780571873},{"name":"Spaghetti Carbonara","hex":"#ddddaa","rgb":{"r":221,"g":221,"b":170},"luminance":146.87107669653682},{"name":"Spaghetti Monster","hex":"#eecc88","rgb":{"r":238,"g":204,"b":136},"luminance":140.15701111253765},{"name":"Spaghetti Strap Pink","hex":"#fbaed2","rgb":{"r":251,"g":174,"b":210},"luminance":128.98700339569098},{"name":"Spandex Green","hex":"#36b14e","rgb":{"r":54,"g":177,"b":78},"luminance":105.52138731555797},{"name":"Spanish Bistre","hex":"#807532","rgb":{"r":128,"g":117,"b":50},"luminance":78.82918891502057},{"name":"Spanish Blue","hex":"#0070b8","rgb":{"r":0,"g":112,"b":184},"luminance":69.00917411475085},{"name":"Spanish Carmine","hex":"#d10047","rgb":{"r":209,"g":0,"b":71},"luminance":63.01299800041258},{"name":"Spanish Cream","hex":"#fce5c0","rgb":{"r":252,"g":229,"b":192},"luminance":155.6468714012588},{"name":"Spanish Crimson","hex":"#e51a4c","rgb":{"r":229,"g":26,"b":76},"luminance":70.68430788371631},{"name":"Spanish Gold","hex":"#b09a4f","rgb":{"r":176,"g":154,"b":79},"luminance":104.9866268436128},{"name":"Spanish Green","hex":"#7b8976","rgb":{"r":123,"g":137,"b":118},"luminance":89.44674166228751},{"name":"Spanish Grey","hex":"#989898","rgb":{"r":152,"g":152,"b":152},"luminance":101.62038409689268},{"name":"Spanish Mustang","hex":"#684b40","rgb":{"r":104,"g":75,"b":64},"luminance":54.39111560723865},{"name":"Spanish Olive","hex":"#a1a867","rgb":{"r":161,"g":168,"b":103},"luminance":110.36463809119296},{"name":"Spanish Orange","hex":"#e86100","rgb":{"r":232,"g":97,"b":0},"luminance":89.74390867908528},{"name":"Spanish Peanut","hex":"#c57556","rgb":{"r":197,"g":117,"b":86},"luminance":91.00816922672381},{"name":"Spanish Pink","hex":"#f7bfbe","rgb":{"r":247,"g":191,"b":190},"luminance":135.99133390771632},{"name":"Spanish Plum","hex":"#5c3357","rgb":{"r":92,"g":51,"b":87},"luminance":41.84830650098042},{"name":"Spanish Purple","hex":"#66033c","rgb":{"r":102,"g":3,"b":60},"luminance":31.305186870549104},{"name":"Spanish Red","hex":"#e60026","rgb":{"r":230,"g":0,"b":38},"luminance":68.90630685213074},{"name":"Spanish Roast","hex":"#111133","rgb":{"r":17,"g":17,"b":51},"luminance":12.618237832597703},{"name":"Spanish Sand","hex":"#cab08e","rgb":{"r":202,"g":176,"b":142},"luminance":120.76149672805484},{"name":"Spanish Sky Blue","hex":"#00fffe","rgb":{"r":0,"g":255,"b":254},"luminance":152.45999200118044},{"name":"Spanish Style","hex":"#93765c","rgb":{"r":147,"g":118,"b":92},"luminance":82.70213485152604},{"name":"Spanish Villa","hex":"#dfbaa9","rgb":{"r":223,"g":186,"b":169},"luminance":129.37430273821766},{"name":"Spanish Violet","hex":"#4c2882","rgb":{"r":76,"g":40,"b":130},"luminance":35.87928338191832},{"name":"Spanish Viridian","hex":"#007f5c","rgb":{"r":0,"g":127,"b":92},"luminance":75.28314250215648},{"name":"Spanish White","hex":"#ded1b7","rgb":{"r":222,"g":209,"b":183},"luminance":141.04035031507826},{"name":"Spanish Yellow","hex":"#f6b511","rgb":{"r":246,"g":181,"b":17},"luminance":129.23765615717426},{"name":"Sparkler","hex":"#ffee99","rgb":{"r":255,"g":238,"b":153},"luminance":160.11024272356843},{"name":"Sparkling Champagne","hex":"#efcf98","rgb":{"r":239,"g":207,"b":152},"luminance":142.02595250868765},{"name":"Sparkling Cider","hex":"#fffdeb","rgb":{"r":255,"g":253,"b":235},"luminance":169.07548978488867},{"name":"Sparkling Cove","hex":"#2da4b6","rgb":{"r":45,"g":164,"b":182},"luminance":99.39338183702174},{"name":"Sparkling Frost","hex":"#d2d5da","rgb":{"r":210,"g":213,"b":218},"luminance":142.10192456472925},{"name":"Sparkling Grape","hex":"#773376","rgb":{"r":119,"g":51,"b":118},"luminance":48.40648545391412},{"name":"Sparkling Green","hex":"#66ee00","rgb":{"r":102,"g":238,"b":0},"luminance":142.99613435334535},{"name":"Sparkling Lavender","hex":"#eeccff","rgb":{"r":238,"g":204,"b":255},"luminance":142.29785187415865},{"name":"Sparkling Pink","hex":"#f5cee6","rgb":{"r":245,"g":206,"b":230},"luminance":143.79121499243269},{"name":"Sparkling Purple","hex":"#cc11ff","rgb":{"r":204,"g":17,"b":255},"luminance":68.30195719743321},{"name":"Sparkling Red","hex":"#ee3333","rgb":{"r":238,"g":51,"b":51},"luminance":77.42129428652042},{"name":"Sparkling River","hex":"#d6edf1","rgb":{"r":214,"g":237,"b":241},"luminance":155.5735357732799},{"name":"Sparks In The Dark","hex":"#ff7711","rgb":{"r":255,"g":119,"b":17},"luminance":103.42387286308707},{"name":"Sparrow","hex":"#69595c","rgb":{"r":105,"g":89,"b":92},"luminance":61.84638403334507},{"name":"Spartacus","hex":"#76a4a7","rgb":{"r":118,"g":164,"b":167},"luminance":104.2822745820209},{"name":"Spartan Blue","hex":"#7a8898","rgb":{"r":122,"g":136,"b":152},"luminance":89.46536923301663},{"name":"Spartan Crimson","hex":"#9e1316","rgb":{"r":158,"g":19,"b":22},"luminance":48.60541160200167},{"name":"Spatial Spirit","hex":"#c1edd3","rgb":{"r":193,"g":237,"b":211},"luminance":152.52143759485094},{"name":"Spätzle Yellow","hex":"#ffee88","rgb":{"r":255,"g":238,"b":136},"luminance":159.9107265851794},{"name":"Speak To Me","hex":"#ffd9a6","rgb":{"r":255,"g":217,"b":166},"luminance":149.6556963232606},{"name":"Speakeasy","hex":"#826a6c","rgb":{"r":130,"g":106,"b":108},"luminance":74.39112533091564},{"name":"Speaking of the Devil","hex":"#a8415b","rgb":{"r":168,"g":65,"b":91},"luminance":63.92712823989515},{"name":"Spear Shaft","hex":"#885500","rgb":{"r":136,"g":85,"b":0},"luminance":64.36669885119167},{"name":"Spearfish","hex":"#5fb6bf","rgb":{"r":95,"g":182,"b":191},"luminance":112.66967052849671},{"name":"Spearmint","hex":"#64bfa4","rgb":{"r":100,"g":191,"b":164},"luminance":117.53200459874748},{"name":"Spearmint Ice","hex":"#bfd3cb","rgb":{"r":191,"g":211,"b":203},"luminance":138.33852136697138},{"name":"Spearmint Stick","hex":"#e8f0e2","rgb":{"r":232,"g":240,"b":226},"luminance":159.13163582393037},{"name":"Spearmint Water","hex":"#b1eae8","rgb":{"r":177,"g":234,"b":232},"luminance":149.55788443609384},{"name":"Special Delivery","hex":"#a5b2b7","rgb":{"r":165,"g":178,"b":183},"luminance":117.41588250743592},{"name":"Special Ops","hex":"#868b53","rgb":{"r":134,"g":139,"b":83},"luminance":91.39054354253506},{"name":"Species","hex":"#dcd867","rgb":{"r":220,"g":216,"b":103},"luminance":143.32164605529758},{"name":"Speckled Easter Egg","hex":"#d38798","rgb":{"r":211,"g":135,"b":152},"luminance":102.76308447102976},{"name":"Spectra","hex":"#375d4f","rgb":{"r":55,"g":93,"b":79},"luminance":57.721082301010256},{"name":"Spectra Green","hex":"#009b8c","rgb":{"r":0,"g":155,"b":140},"luminance":92.37419458376891},{"name":"Spectra Yellow","hex":"#f7b718","rgb":{"r":247,"g":183,"b":24},"luminance":130.38796932999608},{"name":"Spectrum Blue","hex":"#3d3c7c","rgb":{"r":61,"g":60,"b":124},"luminance":42.10624676933341},{"name":"Speeding Ticket","hex":"#f9f1d7","rgb":{"r":249,"g":241,"b":215},"luminance":161.73003304890528},{"name":"Speedwell","hex":"#5a6272","rgb":{"r":90,"g":98,"b":114},"luminance":64.82503214036997},{"name":"Spell","hex":"#5e4f50","rgb":{"r":94,"g":79,"b":80},"luminance":54.98705997778023},{"name":"Spell Caster","hex":"#4a373e","rgb":{"r":74,"g":55,"b":62},"luminance":39.77232360574372},{"name":"Spelunking","hex":"#35465e","rgb":{"r":53,"g":70,"b":94},"luminance":45.32491770538585},{"name":"Sphagnales Moss","hex":"#a5ad44","rgb":{"r":165,"g":173,"b":68},"luminance":113.16643199288382},{"name":"Sphagnum Moss","hex":"#75693d","rgb":{"r":117,"g":105,"b":61},"luminance":71.2112465134546},{"name":"Sphinx","hex":"#ab9895","rgb":{"r":171,"g":152,"b":149},"luminance":104.22869572723242},{"name":"Spice","hex":"#6c4f3f","rgb":{"r":108,"g":79,"b":63},"luminance":56.96322951694365},{"name":"Spice Cake","hex":"#b87243","rgb":{"r":184,"g":114,"b":67},"luminance":86.96618897019691},{"name":"Spice Cookie","hex":"#f0ded3","rgb":{"r":240,"g":222,"b":211},"luminance":150.6978138925711},{"name":"Spice Delight","hex":"#f3e9cf","rgb":{"r":243,"g":233,"b":207},"luminance":156.65954070531419},{"name":"Spice Girl","hex":"#e1c2c1","rgb":{"r":225,"g":194,"b":193},"luminance":134.08285689453368},{"name":"Spice Is Nice","hex":"#ebd0a4","rgb":{"r":235,"g":208,"b":164},"luminance":142.10610070296067},{"name":"Spice Ivory","hex":"#f4eedc","rgb":{"r":244,"g":238,"b":220},"luminance":159.5911989177348},{"name":"Spice of Life","hex":"#86493f","rgb":{"r":134,"g":73,"b":63},"luminance":59.10223076162185},{"name":"Spice Route","hex":"#b95b3f","rgb":{"r":185,"g":91,"b":63},"luminance":77.23151065465441},{"name":"Spiced Apple","hex":"#783937","rgb":{"r":120,"g":57,"b":55},"luminance":49.45899292343101},{"name":"Spiced Berry","hex":"#85443f","rgb":{"r":133,"g":68,"b":63},"luminance":56.800373845600696},{"name":"Spiced Butternut","hex":"#ffd978","rgb":{"r":255,"g":217,"b":120},"luminance":149.08337286900908},{"name":"Spiced Cider","hex":"#915b41","rgb":{"r":145,"g":91,"b":65},"luminance":69.19494211284521},{"name":"Spiced Cinnamon","hex":"#805b48","rgb":{"r":128,"g":91,"b":72},"luminance":66.22305593220536},{"name":"Spiced Coral","hex":"#d75c5d","rgb":{"r":215,"g":92,"b":93},"luminance":84.62502966026068},{"name":"Spiced Hot Chocolate","hex":"#53433e","rgb":{"r":83,"g":67,"b":62},"luminance":47.03839234072525},{"name":"Spiced Nectarine","hex":"#ffbb72","rgb":{"r":255,"g":187,"b":114},"luminance":134.28115803045486},{"name":"Spiced Nutmeg","hex":"#927d6c","rgb":{"r":146,"g":125,"b":108},"luminance":86.26208718202916},{"name":"Spiced Orange","hex":"#edc7b6","rgb":{"r":237,"g":199,"b":182},"luminance":138.1930578647133},{"name":"Spiced Plum","hex":"#6d4773","rgb":{"r":109,"g":71,"b":115},"luminance":54.50704275595953},{"name":"Spiced Up","hex":"#b14b38","rgb":{"r":177,"g":75,"b":56},"luminance":69.13609773483024},{"name":"Spiced Vinegar","hex":"#cdba99","rgb":{"r":205,"g":186,"b":153},"luminance":126.4199727614272},{"name":"Spiced Wine","hex":"#664942","rgb":{"r":102,"g":73,"b":66},"luminance":53.131410493228955},{"name":"Spicy Hummus","hex":"#eebbaa","rgb":{"r":238,"g":187,"b":170},"luminance":132.24540825677084},{"name":"Spicy Mix","hex":"#8b5f4d","rgb":{"r":139,"g":95,"b":77},"luminance":70.10067924064644},{"name":"Spicy Mustard","hex":"#74640d","rgb":{"r":116,"g":100,"b":13},"luminance":68.1972593290962},{"name":"Spicy Orange","hex":"#d73c26","rgb":{"r":215,"g":60,"b":38},"luminance":73.4287127015039},{"name":"Spicy Pink","hex":"#ff1cae","rgb":{"r":255,"g":28,"b":174},"luminance":80.47924587743103},{"name":"Spicy Red","hex":"#ff1111","rgb":{"r":255,"g":17,"b":17},"luminance":76.91967440128695},{"name":"Spicy Tomato","hex":"#c75433","rgb":{"r":199,"g":84,"b":51},"luminance":77.49484151219357},{"name":"Spider Cotton","hex":"#e2e8df","rgb":{"r":226,"g":232,"b":223},"luminance":154.13826720188598},{"name":"Spike","hex":"#656271","rgb":{"r":101,"g":98,"b":113},"luminance":66.23568676325473},{"name":"Spiked Apricot","hex":"#fdddb7","rgb":{"r":253,"g":221,"b":183},"luminance":151.61393795426594},{"name":"Spill the Beans","hex":"#9b351b","rgb":{"r":155,"g":53,"b":27},"luminance":55.9037335962456},{"name":"Spilled Cappuccino","hex":"#e4e1de","rgb":{"r":228,"g":225,"b":222},"luminance":150.77042837705275},{"name":"Spilt Milk","hex":"#f4f4d1","rgb":{"r":244,"g":244,"b":209},"luminance":162.49466513088973},{"name":"Spinach Banana Smoothie","hex":"#aaaa55","rgb":{"r":170,"g":170,"b":85},"luminance":112.40831419428012},{"name":"Spinach Dip","hex":"#b1cdac","rgb":{"r":177,"g":205,"b":172},"luminance":132.9128655097015},{"name":"Spinach Green","hex":"#909b4c","rgb":{"r":144,"g":155,"b":76},"luminance":101.0304620250744},{"name":"Spinach Soup","hex":"#6e750e","rgb":{"r":110,"g":117,"b":14},"luminance":76.16498117245222},{"name":"Spindle","hex":"#b3c4d8","rgb":{"r":179,"g":196,"b":216},"luminance":129.2586612997365},{"name":"Spindrift","hex":"#73fcd6","rgb":{"r":115,"g":252,"b":214},"luminance":153.81483289006948},{"name":"Spinnaker","hex":"#a3e2dd","rgb":{"r":163,"g":226,"b":221},"luminance":143.55918308836954},{"name":"Spinning Blue","hex":"#5b6a7c","rgb":{"r":91,"g":106,"b":124},"luminance":69.36665957792691},{"name":"Spirit","hex":"#b2bbc6","rgb":{"r":178,"g":187,"b":198},"luminance":124.06171782221944},{"name":"Spirit Dance","hex":"#514b80","rgb":{"r":81,"g":75,"b":128},"luminance":52.32291132955046},{"name":"Spirit Mountain","hex":"#6a8b98","rgb":{"r":106,"g":139,"b":152},"luminance":89.2310868980088},{"name":"Spirit Rock","hex":"#5f534e","rgb":{"r":95,"g":83,"b":78},"luminance":57.09332298964564},{"name":"Spirited Away","hex":"#fde7e3","rgb":{"r":253,"g":231,"b":227},"luminance":157.4124706050953},{"name":"Spiritstone Red","hex":"#fd411e","rgb":{"r":253,"g":65,"b":30},"luminance":84.79368510685214},{"name":"Spiro Disco Ball","hex":"#0fc0fc","rgb":{"r":15,"g":192,"b":252},"luminance":116.39417865597918},{"name":"Spirulina","hex":"#5a665c","rgb":{"r":90,"g":102,"b":92},"luminance":66.47587622589116},{"name":"Splash","hex":"#f1d79e","rgb":{"r":241,"g":215,"b":158},"luminance":146.43986359594848},{"name":"Splash Of Grenadine","hex":"#f984e5","rgb":{"r":249,"g":132,"b":229},"luminance":110.58139487725772},{"name":"Splash of Honey","hex":"#d8b98c","rgb":{"r":216,"g":185,"b":140},"luminance":127.35261552477043},{"name":"Splash Palace","hex":"#5984b0","rgb":{"r":89,"g":132,"b":176},"luminance":84.34737502139589},{"name":"Splatter","hex":"#a9586c","rgb":{"r":169,"g":88,"b":108},"luminance":73.3028624338777},{"name":"Spleen Green","hex":"#ccee00","rgb":{"r":204,"g":238,"b":0},"luminance":152.441065504017},{"name":"Splendiferous","hex":"#806e7c","rgb":{"r":128,"g":110,"b":124},"luminance":76.37969219628997},{"name":"Splinter","hex":"#a3713f","rgb":{"r":163,"g":113,"b":63},"luminance":82.62371241961958},{"name":"Splish Splash","hex":"#3194ce","rgb":{"r":49,"g":148,"b":206},"luminance":91.17888699145213},{"name":"Split Pea","hex":"#9c9a40","rgb":{"r":156,"g":154,"b":64},"luminance":101.98378673102896},{"name":"Split Pea Soup","hex":"#c8b165","rgb":{"r":200,"g":177,"b":101},"luminance":120.43095281944753},{"name":"Spoiled Egg","hex":"#e8ff2a","rgb":{"r":232,"g":255,"b":42},"luminance":165.04679213180728},{"name":"Sponge","hex":"#a49775","rgb":{"r":164,"g":151,"b":117},"luminance":102.17117650785862},{"name":"Sponge Cake","hex":"#fffe40","rgb":{"r":255,"g":254,"b":64},"luminance":167.62083774101595},{"name":"Spooky","hex":"#d1d2bf","rgb":{"r":209,"g":210,"b":191},"luminance":139.9097032267598},{"name":"Spooky Ghost","hex":"#d4d1d9","rgb":{"r":212,"g":209,"b":217},"luminance":140.28943537201937},{"name":"Spooky Graveyard","hex":"#685e4f","rgb":{"r":104,"g":94,"b":79},"luminance":63.9740645574439},{"name":"Spooled White","hex":"#f5eae3","rgb":{"r":245,"g":234,"b":227},"luminance":157.80743351629542},{"name":"Spores","hex":"#7f8162","rgb":{"r":127,"g":129,"b":98},"luminance":85.44433885284619},{"name":"Sports Fan","hex":"#e08119","rgb":{"r":224,"g":129,"b":25},"luminance":101.13298079756177},{"name":"Spotlight","hex":"#faeacd","rgb":{"r":250,"g":234,"b":205},"luminance":158.11685414275104},{"name":"Spotted Dove","hex":"#bfbfbd","rgb":{"r":191,"g":191,"b":189},"luminance":127.65535510114724},{"name":"Spotted Snake Eel","hex":"#b1d3e3","rgb":{"r":177,"g":211,"b":227},"luminance":137.15345880436263},{"name":"Spray","hex":"#7ecddd","rgb":{"r":126,"g":205,"b":221},"luminance":128.58685833707892},{"name":"Spray Green","hex":"#aea692","rgb":{"r":174,"g":166,"b":146},"luminance":111.70797095999909},{"name":"Spray of Mint","hex":"#bdd0c3","rgb":{"r":189,"g":208,"b":195},"luminance":136.36384871731948},{"name":"Sprig Muslin","hex":"#d6c1c5","rgb":{"r":214,"g":193,"b":197},"luminance":132.0356794241617},{"name":"Sprig of Mint","hex":"#8be0ba","rgb":{"r":139,"g":224,"b":186},"luminance":139.52068119458133},{"name":"Spring","hex":"#00f900","rgb":{"r":0,"g":249,"b":0},"luminance":146.16299999999998},{"name":"Spring Blossom","hex":"#e9edbd","rgb":{"r":233,"g":237,"b":189},"luminance":157.07264932508141},{"name":"Spring Bouquet","hex":"#6dce87","rgb":{"r":109,"g":206,"b":135},"luminance":126.17906111950587},{"name":"Spring Boutique","hex":"#d7b9cb","rgb":{"r":215,"g":185,"b":203},"luminance":128.30037963310943},{"name":"Spring Bud","hex":"#a7fc00","rgb":{"r":167,"g":252,"b":0},"luminance":156.12435513077386},{"name":"Spring Burst","hex":"#c9e0c8","rgb":{"r":201,"g":224,"b":200},"luminance":146.35854585571695},{"name":"Spring Buttercup","hex":"#fff6c2","rgb":{"r":255,"g":246,"b":194},"luminance":164.78578544583266},{"name":"Spring Crocus","hex":"#ba69a1","rgb":{"r":186,"g":105,"b":161},"luminance":85.02152396305303},{"name":"Spring Fever","hex":"#e5e3bf","rgb":{"r":229,"g":227,"b":191},"luminance":151.38586762970974},{"name":"Spring Fields","hex":"#b3cdac","rgb":{"r":179,"g":205,"b":172},"luminance":133.15210599160645},{"name":"Spring Fog","hex":"#ecf1ec","rgb":{"r":236,"g":241,"b":236},"luminance":160.36213830265544},{"name":"Spring Frost","hex":"#87ff2a","rgb":{"r":135,"g":255,"b":42},"luminance":155.10595537889574},{"name":"Spring Garden","hex":"#558961","rgb":{"r":85,"g":137,"b":97},"luminance":85.0612552811208},{"name":"Spring Green","hex":"#00ff7c","rgb":{"r":0,"g":255,"b":124},"luminance":150.35100838038966},{"name":"Spring Heat","hex":"#fffddd","rgb":{"r":255,"g":253,"b":221},"luminance":168.82995818870535},{"name":"Spring Juniper","hex":"#4a754a","rgb":{"r":74,"g":117,"b":74},"luminance":72.64661735414802},{"name":"Spring Kiss","hex":"#e3efb2","rgb":{"r":227,"g":239,"b":178},"luminance":157.16435741605025},{"name":"Spring Leaves","hex":"#a8c3aa","rgb":{"r":168,"g":195,"b":170},"luminance":126.49535346802267},{"name":"Spring Lilac","hex":"#b1b3cb","rgb":{"r":177,"g":179,"b":203},"luminance":119.90300839428508},{"name":"Spring Lily","hex":"#fcf4c8","rgb":{"r":252,"g":244,"b":200},"luminance":163.43629060890973},{"name":"Spring Lobster","hex":"#640125","rgb":{"r":100,"g":1,"b":37},"luminance":30.201756455544103},{"name":"Spring Lobster Brown","hex":"#6c2c2f","rgb":{"r":108,"g":44,"b":47},"luminance":41.696127062354364},{"name":"Spring Lobster Dye","hex":"#7a4171","rgb":{"r":122,"g":65,"b":113},"luminance":54.33594052742623},{"name":"Spring Marsh","hex":"#c0b05d","rgb":{"r":192,"g":176,"b":93},"luminance":118.66528646575628},{"name":"Spring Mist","hex":"#d3e0de","rgb":{"r":211,"g":224,"b":222},"luminance":148.01963021504952},{"name":"Spring Onion","hex":"#596c3c","rgb":{"r":89,"g":108,"b":60},"luminance":69.09402099313658},{"name":"Spring Rain","hex":"#a3bd9c","rgb":{"r":163,"g":189,"b":156},"luminance":122.474140429725},{"name":"Spring Roll","hex":"#c4a661","rgb":{"r":196,"g":166,"b":97},"luminance":114.24382497098037},{"name":"Spring Savor","hex":"#cceecc","rgb":{"r":204,"g":238,"b":204},"luminance":154.20479884880365},{"name":"Spring Shoot","hex":"#e2edc1","rgb":{"r":226,"g":237,"b":193},"luminance":156.21917180999264},{"name":"Spring Shower","hex":"#abdcee","rgb":{"r":171,"g":220,"b":238},"luminance":141.5184075129451},{"name":"Spring Slumber Green","hex":"#b8f8b8","rgb":{"r":184,"g":248,"b":184},"luminance":157.03224066413878},{"name":"Spring Sprout","hex":"#86ba4a","rgb":{"r":134,"g":186,"b":74},"luminance":116.60685904353997},{"name":"Spring Sun","hex":"#f1f1c6","rgb":{"r":241,"g":241,"b":198},"luminance":160.35868156729148},{"name":"Spring Thaw","hex":"#d9dcdd","rgb":{"r":217,"g":220,"b":221},"luminance":146.70269569779555},{"name":"Spring Thyme","hex":"#d8dcb3","rgb":{"r":216,"g":220,"b":179},"luminance":145.82399491167425},{"name":"Spring Wheat","hex":"#e0eed4","rgb":{"r":224,"g":238,"b":212},"luminance":156.80447454074772},{"name":"Spring White","hex":"#ecfcec","rgb":{"r":236,"g":252,"b":236},"luminance":166.08616163907212},{"name":"Spring Wisteria","hex":"#cda4de","rgb":{"r":205,"g":164,"b":222},"luminance":116.89781740049726},{"name":"Spring Wood","hex":"#e9e1d9","rgb":{"r":233,"g":225,"b":217},"luminance":151.35806935211613},{"name":"Springtime Dew","hex":"#ffffef","rgb":{"r":255,"g":255,"b":239},"luminance":170.1800333940501},{"name":"Springtime Rain","hex":"#ebeef3","rgb":{"r":235,"g":238,"b":243},"luminance":158.815419481233},{"name":"Sprite Twist","hex":"#b9dcc3","rgb":{"r":185,"g":220,"b":195},"luminance":142.235936826809},{"name":"Spritzig","hex":"#76c5e7","rgb":{"r":118,"g":197,"b":231},"luminance":123.73632207642184},{"name":"Sprout","hex":"#b8ca9d","rgb":{"r":184,"g":202,"b":157},"luminance":131.93518157034535},{"name":"Sprout Green","hex":"#cbd7d2","rgb":{"r":203,"g":215,"b":210},"luminance":142.07375350148246},{"name":"Spruce","hex":"#0a5f38","rgb":{"r":10,"g":95,"b":56},"luminance":56.20881408640463},{"name":"Spruce Shade","hex":"#91a49d","rgb":{"r":145,"g":164,"b":157},"luminance":107.0865176060927},{"name":"Spruce Stone","hex":"#9fc09c","rgb":{"r":159,"g":192,"b":156},"luminance":123.60667034185492},{"name":"Spruce Tree Flower","hex":"#b35e97","rgb":{"r":179,"g":94,"b":151},"luminance":78.77455757413048},{"name":"Spruce Woods","hex":"#6e6a51","rgb":{"r":110,"g":106,"b":81},"luminance":70.98306938981999},{"name":"Spruce Yellow","hex":"#be8a4a","rgb":{"r":190,"g":138,"b":74},"luminance":99.30012201402374},{"name":"Spruced Up","hex":"#9a7f28","rgb":{"r":154,"g":127,"b":40},"luminance":87.74155866520721},{"name":"Spumoni","hex":"#bccfa4","rgb":{"r":188,"g":207,"b":164},"luminance":135.18049578618948},{"name":"Spun Cotton","hex":"#f3ecdc","rgb":{"r":243,"g":236,"b":220},"luminance":158.42714752528997},{"name":"Spun Jute","hex":"#f4e4cf","rgb":{"r":244,"g":228,"b":207},"luminance":154.2449948491036},{"name":"Spun Pearl","hex":"#a2a1ac","rgb":{"r":162,"g":161,"b":172},"luminance":107.9920671021719},{"name":"Spun Sugar","hex":"#fae2ed","rgb":{"r":250,"g":226,"b":237},"luminance":154.65038334255755},{"name":"SQL Injection Purple","hex":"#5e0092","rgb":{"r":94,"g":0,"b":146},"luminance":32.66450630271335},{"name":"Squant","hex":"#666666","rgb":{"r":102,"g":102,"b":102},"luminance":68.19262617028325},{"name":"Squash","hex":"#f2ab15","rgb":{"r":242,"g":171,"b":21},"luminance":123.7616803740156},{"name":"Squash Blossom","hex":"#f8b438","rgb":{"r":248,"g":180,"b":56},"luminance":129.24128659217223},{"name":"Squeaky","hex":"#6cc4da","rgb":{"r":108,"g":196,"b":218},"luminance":122.05473309954021},{"name":"Squeeze Toy Alien","hex":"#11ee00","rgb":{"r":17,"g":238,"b":0},"luminance":139.79843820658368},{"name":"Squid Hat","hex":"#6e2233","rgb":{"r":110,"g":34,"b":51},"luminance":38.90856538090296},{"name":"Squid Ink Powder","hex":"#001133","rgb":{"r":0,"g":17,"b":51},"luminance":11.549157415153712},{"name":"Squid Pink","hex":"#f5b4bd","rgb":{"r":245,"g":180,"b":189},"luminance":130.36318782923345},{"name":"Squid's Ink","hex":"#4d4e5c","rgb":{"r":77,"g":78,"b":92},"luminance":52.31074907703004},{"name":"Squig Orange","hex":"#aa4f44","rgb":{"r":170,"g":79,"b":68},"luminance":69.24043279038628},{"name":"Squirrel","hex":"#8f7d6b","rgb":{"r":143,"g":125,"b":107},"luminance":85.79535464114593},{"name":"Squirt","hex":"#95bcc5","rgb":{"r":149,"g":188,"b":197},"luminance":121.10986789275263},{"name":"St. Augustine","hex":"#d0ddcc","rgb":{"r":208,"g":221,"b":204},"luminance":145.7318802767603},{"name":"St. Nicholas Beard","hex":"#eedddd","rgb":{"r":238,"g":221,"b":221},"luminance":150.09284596209108},{"name":"St. Patrick","hex":"#2b8c4e","rgb":{"r":43,"g":140,"b":78},"luminance":83.65358637261166},{"name":"St. Patrick's Blue","hex":"#23297a","rgb":{"r":35,"g":41,"b":122},"luminance":29.70133293305201},{"name":"St. Tropez","hex":"#325482","rgb":{"r":50,"g":84,"b":130},"luminance":53.613559516226864},{"name":"Stability","hex":"#c1d0b2","rgb":{"r":193,"g":208,"b":178},"luminance":136.56242649059806},{"name":"Stack","hex":"#858885","rgb":{"r":133,"g":136,"b":133},"luminance":90.46794325616118},{"name":"Stacked Limestone","hex":"#d1b992","rgb":{"r":209,"g":185,"b":146},"luminance":126.39233300323244},{"name":"Stacked Stone","hex":"#918676","rgb":{"r":145,"g":134,"b":118},"luminance":90.81681173108863},{"name":"Stadium Grass","hex":"#d5f534","rgb":{"r":213,"g":245,"b":52},"luminance":157.39736140736287},{"name":"Stadium Lawn","hex":"#9af764","rgb":{"r":154,"g":247,"b":100},"luminance":152.55164449130007},{"name":"Stag Beetle","hex":"#603b41","rgb":{"r":96,"g":59,"b":65},"luminance":45.588073056447556},{"name":"Stained Glass","hex":"#556682","rgb":{"r":85,"g":102,"b":130},"luminance":66.71169688293051},{"name":"Stalactite Brown","hex":"#d4c4a7","rgb":{"r":212,"g":196,"b":167},"luminance":132.7307300213481},{"name":"Stalk","hex":"#7cb26e","rgb":{"r":124,"g":178,"b":110},"luminance":111.5760080483255},{"name":"Stamina","hex":"#b0a8ad","rgb":{"r":176,"g":168,"b":173},"luminance":113.50488146330976},{"name":"Stand Out","hex":"#7f8596","rgb":{"r":127,"g":133,"b":150},"luminance":88.48412156991783},{"name":"Standby Led","hex":"#ff0066","rgb":{"r":255,"g":0,"b":102},"luminance":77.12658691398187},{"name":"Standing Waters","hex":"#005599","rgb":{"r":0,"g":85,"b":153},"luminance":52.85578860446602},{"name":"Stanford Green","hex":"#658f7c","rgb":{"r":101,"g":143,"b":124},"luminance":90.321080474051},{"name":"Stanford Stone","hex":"#bcab9c","rgb":{"r":188,"g":171,"b":156},"luminance":116.41134708008494},{"name":"Stanger Red","hex":"#a40000","rgb":{"r":164,"g":0,"b":0},"luminance":49.036},{"name":"Stanley","hex":"#9bc2b4","rgb":{"r":155,"g":194,"b":180},"luminance":124.64801766975678},{"name":"Star Anise","hex":"#5c5042","rgb":{"r":92,"g":80,"b":66},"luminance":54.94126172559199},{"name":"Star Bright","hex":"#e8ddae","rgb":{"r":232,"g":221,"b":174},"luminance":148.44015915176055},{"name":"Star City","hex":"#5796a1","rgb":{"r":87,"g":150,"b":161},"luminance":93.62877754729045},{"name":"Star Command Blue","hex":"#007bb8","rgb":{"r":0,"g":123,"b":184},"luminance":75.18628184050597},{"name":"Star Grass","hex":"#75dbc1","rgb":{"r":117,"g":219,"b":193},"luminance":135.03248535815374},{"name":"Star Magic","hex":"#e4d8d8","rgb":{"r":228,"g":216,"b":216},"luminance":146.04784909063193},{"name":"Star Map","hex":"#dae2e9","rgb":{"r":218,"g":226,"b":233},"luminance":150.1780250635891},{"name":"Star of Gold","hex":"#ebe3c7","rgb":{"r":235,"g":227,"b":199},"luminance":152.33883556729714},{"name":"Star Sapphire","hex":"#386192","rgb":{"r":56,"g":97,"b":146},"luminance":61.639548935727944},{"name":"Star White","hex":"#efefe8","rgb":{"r":239,"g":239,"b":232},"luminance":159.65054673880698},{"name":"Star-Studded","hex":"#f7ebac","rgb":{"r":247,"g":235,"b":172},"luminance":157.69452209255715},{"name":"Starbur","hex":"#6cb037","rgb":{"r":108,"g":176,"b":55},"luminance":108.42257840505361},{"name":"Starburst","hex":"#dce7e5","rgb":{"r":220,"g":231,"b":229},"luminance":152.95449664851307},{"name":"Stardust","hex":"#ddd3ae","rgb":{"r":221,"g":211,"b":174},"luminance":141.77608255978862},{"name":"Starfish","hex":"#e5bca5","rgb":{"r":229,"g":188,"b":165},"luminance":131.22705771676814},{"name":"Starfleet Blue","hex":"#0096ff","rgb":{"r":0,"g":150,"b":255},"luminance":92.72468603343987},{"name":"Starfox","hex":"#f0e8d5","rgb":{"r":240,"g":232,"b":213},"luminance":155.83707832220162},{"name":"Stargate","hex":"#b7c4d3","rgb":{"r":183,"g":196,"b":211},"luminance":129.65148556418472},{"name":"Stargate Shimmer","hex":"#7777ff","rgb":{"r":119,"g":119,"b":255},"luminance":83.60929416039822},{"name":"Stargazer","hex":"#39505c","rgb":{"r":57,"g":80,"b":92},"luminance":51.046092827953046},{"name":"Stargazing","hex":"#414549","rgb":{"r":65,"g":69,"b":73},"luminance":45.688816115106334},{"name":"Starglider","hex":"#faeede","rgb":{"r":250,"g":238,"b":222},"luminance":160.4550522732145},{"name":"Stark White","hex":"#d2c6b6","rgb":{"r":210,"g":198,"b":182},"luminance":133.72190052493272},{"name":"Starlight","hex":"#bcc0cc","rgb":{"r":188,"g":192,"b":204},"luminance":128.0735027084057},{"name":"Starlight Blue","hex":"#b5ced4","rgb":{"r":181,"g":206,"b":212},"luminance":134.6665825993962},{"name":"Starling's Egg","hex":"#e8dfd8","rgb":{"r":232,"g":223,"b":216},"luminance":150.17767011443476},{"name":"Starlit Eve","hex":"#384351","rgb":{"r":56,"g":67,"b":81},"luminance":43.730979099489645},{"name":"Starry Night","hex":"#286492","rgb":{"r":40,"g":100,"b":146},"luminance":62.17519067924118},{"name":"Starship","hex":"#e3dd39","rgb":{"r":227,"g":221,"b":57},"luminance":146.55395819287858},{"name":"Starsilt","hex":"#758ba4","rgb":{"r":117,"g":139,"b":164},"luminance":90.72358212725068},{"name":"Starstruck","hex":"#4664a5","rgb":{"r":70,"g":100,"b":165},"luminance":65.09662817688793},{"name":"Stately Frills","hex":"#c5bdc4","rgb":{"r":197,"g":189,"b":196},"luminance":127.58200105814299},{"name":"Stately Stems","hex":"#577a6c","rgb":{"r":87,"g":122,"b":108},"luminance":77.1804801034562},{"name":"Static","hex":"#d5d3c3","rgb":{"r":213,"g":211,"b":195},"luminance":141.0346174455052},{"name":"Statue of Liberty","hex":"#376d64","rgb":{"r":55,"g":109,"b":100},"luminance":67.0389611643856},{"name":"Steadfast","hex":"#4a5777","rgb":{"r":74,"g":87,"b":119},"luminance":57.28559149559337},{"name":"Steam Chestnut","hex":"#ebe1a9","rgb":{"r":235,"g":225,"b":169},"luminance":150.8381735702206},{"name":"Steamboat Geyser","hex":"#d2ccb4","rgb":{"r":210,"g":204,"b":180},"luminance":136.75978211447983},{"name":"Steamed Chestnut","hex":"#d3b17d","rgb":{"r":211,"g":177,"b":125},"luminance":122.38581054190882},{"name":"Steamed Salmon","hex":"#ee8888","rgb":{"r":238,"g":136,"b":136},"luminance":108.06272476668353},{"name":"Steamy Spring","hex":"#b1cfc7","rgb":{"r":177,"g":207,"b":199},"luminance":134.4616510608136},{"name":"Steel","hex":"#797979","rgb":{"r":121,"g":121,"b":121},"luminance":80.89517418239484},{"name":"Steel Armor","hex":"#767275","rgb":{"r":118,"g":114,"b":117},"luminance":76.81627751980695},{"name":"Steel Blue","hex":"#4682b4","rgb":{"r":70,"g":130,"b":180},"luminance":81.74565064882657},{"name":"Steel Blue Eyes","hex":"#7d94c6","rgb":{"r":125,"g":148,"b":198},"luminance":97.23078311419691},{"name":"Steel Grey","hex":"#43464b","rgb":{"r":67,"g":70,"b":75},"luminance":46.50603927448563},{"name":"Steel Legion Drab","hex":"#7a744d","rgb":{"r":122,"g":116,"b":77},"luminance":77.74457043421103},{"name":"Steel Me","hex":"#ddd5ce","rgb":{"r":221,"g":213,"b":206},"luminance":143.35509568201613},{"name":"Steel Pan Mallet","hex":"#71a6a1","rgb":{"r":113,"g":166,"b":161},"luminance":104.75387367061897},{"name":"Steel Pink","hex":"#cc33cc","rgb":{"r":204,"g":51,"b":204},"luminance":71.81627615659279},{"name":"Steel Teal","hex":"#5f8a8b","rgb":{"r":95,"g":138,"b":139},"luminance":87.29210604058078},{"name":"Steel Wool","hex":"#777777","rgb":{"r":119,"g":119,"b":119},"luminance":79.55806386533045},{"name":"Steeple Grey","hex":"#827e7c","rgb":{"r":130,"g":126,"b":124},"luminance":84.74125819221709},{"name":"Stegadon Scale Green","hex":"#074863","rgb":{"r":7,"g":72,"b":99},"luminance":43.79497849069},{"name":"Steiglitz Fog","hex":"#415862","rgb":{"r":65,"g":88,"b":98},"luminance":56.31052428276618},{"name":"Stella","hex":"#f5d056","rgb":{"r":245,"g":208,"b":86},"luminance":142.72297172144363},{"name":"Stella Dora","hex":"#f9daa5","rgb":{"r":249,"g":218,"b":165},"luminance":149.23828147295183},{"name":"Stellar","hex":"#46647e","rgb":{"r":70,"g":100,"b":126},"luminance":63.95372855432277},{"name":"Stellar Explorer","hex":"#002222","rgb":{"r":0,"g":34,"b":34},"luminance":20.330891274117814},{"name":"Stellar Light","hex":"#fff4dd","rgb":{"r":255,"g":244,"b":221},"luminance":164.2020025608701},{"name":"Stellar Mist","hex":"#ab9d9c","rgb":{"r":171,"g":157,"b":156},"luminance":106.88183464929855},{"name":"Stem Green","hex":"#abdf8f","rgb":{"r":171,"g":223,"b":143},"luminance":141.47438512324413},{"name":"Stepping Stone","hex":"#a4a7a4","rgb":{"r":164,"g":167,"b":164},"luminance":111.192421293},{"name":"Sterling Blue","hex":"#a2b9c2","rgb":{"r":162,"g":185,"b":194},"luminance":120.94722537123371},{"name":"Sterling Shadow","hex":"#e9ebde","rgb":{"r":233,"g":235,"b":222},"luminance":156.5976014439557},{"name":"Sterling Silver","hex":"#9eafc2","rgb":{"r":158,"g":175,"b":194},"luminance":115.21002406474881},{"name":"Stetson","hex":"#9e7a58","rgb":{"r":158,"g":122,"b":88},"luminance":86.37715313669464},{"name":"Steveareno Beige","hex":"#c5b5a4","rgb":{"r":197,"g":181,"b":164},"luminance":122.9126878479191},{"name":"Sticks & Stones","hex":"#baa482","rgb":{"r":186,"g":164,"b":130},"luminance":112.16094338048339},{"name":"Sticky Black Tarmac","hex":"#112111","rgb":{"r":17,"g":33,"b":17},"luminance":20.120347263404774},{"name":"Sticky Toffee","hex":"#cc8149","rgb":{"r":204,"g":129,"b":73},"luminance":97.58965328865555},{"name":"Stieglitz Silver","hex":"#8d8f8e","rgb":{"r":141,"g":143,"b":142},"luminance":95.31801564237475},{"name":"Stil De Grain Yellow","hex":"#fadb5e","rgb":{"r":250,"g":219,"b":94},"luminance":149.09147851235497},{"name":"Stiletto","hex":"#323235","rgb":{"r":50,"g":50,"b":53},"luminance":33.48777036471673},{"name":"Still","hex":"#adaf9c","rgb":{"r":173,"g":175,"b":156},"luminance":116.3803196850739},{"name":"Still Fuchsia","hex":"#c154c0","rgb":{"r":193,"g":84,"b":192},"luminance":78.99659016058858},{"name":"Still Morning","hex":"#fff8e1","rgb":{"r":255,"g":248,"b":225},"luminance":166.32376348856468},{"name":"Stillwater","hex":"#70a4b0","rgb":{"r":112,"g":164,"b":176},"luminance":103.88232796775398},{"name":"Stillwater Lake","hex":"#c2d0df","rgb":{"r":194,"g":208,"b":223},"luminance":137.54420138995317},{"name":"Stilted Stalks","hex":"#a29a6a","rgb":{"r":162,"g":154,"b":106},"luminance":103.26694197079722},{"name":"Stinging Nettle","hex":"#495d39","rgb":{"r":73,"g":93,"b":57},"luminance":59.15081752604945},{"name":"Stinging Wasabi","hex":"#aefd6c","rgb":{"r":174,"g":253,"b":108},"luminance":157.84108191785813},{"name":"Stinkhorn","hex":"#2a545c","rgb":{"r":42,"g":84,"b":92},"luminance":51.95171192559491},{"name":"Stirland Battlemire","hex":"#ae5a2c","rgb":{"r":174,"g":90,"b":44},"luminance":74.31604020667409},{"name":"Stirland Mud","hex":"#492b00","rgb":{"r":73,"g":43,"b":0},"luminance":33.36953715591512},{"name":"Stizza","hex":"#900910","rgb":{"r":144,"g":9,"b":16},"luminance":43.417233916959745},{"name":"Stock Horse","hex":"#806852","rgb":{"r":128,"g":104,"b":82},"luminance":72.65665414812328},{"name":"Stocking White","hex":"#e9e5d8","rgb":{"r":233,"g":229,"b":216},"luminance":153.3928785635109},{"name":"Stockleaf","hex":"#647b72","rgb":{"r":100,"g":123,"b":114},"luminance":79.22051765167909},{"name":"Stoic White","hex":"#e0e0ff","rgb":{"r":224,"g":224,"b":255},"luminance":150.39928064987546},{"name":"Stomy Shower","hex":"#0088b0","rgb":{"r":0,"g":136,"b":176},"luminance":82.31471508788692},{"name":"Stone","hex":"#ada587","rgb":{"r":173,"g":165,"b":135},"luminance":110.87572166168749},{"name":"Stone Blue","hex":"#829ca5","rgb":{"r":130,"g":156,"b":165},"luminance":101.24289695578646},{"name":"Stone Bridge","hex":"#52706c","rgb":{"r":82,"g":112,"b":108},"luminance":71.23897250803103},{"name":"Stone Craft","hex":"#7d867c","rgb":{"r":125,"g":134,"b":124},"luminance":88.22583570020745},{"name":"Stone Creek","hex":"#8f9183","rgb":{"r":143,"g":145,"b":131},"luminance":96.41446276363313},{"name":"Stone Golem","hex":"#c2cbd2","rgb":{"r":194,"g":203,"b":210},"luminance":134.674286918476},{"name":"Stone Green","hex":"#658e67","rgb":{"r":101,"g":142,"b":103},"luminance":89.43010388566033},{"name":"Stone Grey","hex":"#9f9484","rgb":{"r":159,"g":148,"b":132},"luminance":100.16999730957369},{"name":"Stone Harbour","hex":"#e8e0d8","rgb":{"r":232,"g":224,"b":216},"luminance":150.68959799534937},{"name":"Stone Hearth","hex":"#636869","rgb":{"r":99,"g":104,"b":105},"luminance":68.89381978813483},{"name":"Stone Mason","hex":"#7a7b75","rgb":{"r":122,"g":123,"b":117},"luminance":81.98494452641899},{"name":"Stone Path","hex":"#e4efe5","rgb":{"r":228,"g":239,"b":229},"luminance":158.14888766286026},{"name":"Stone Pillar","hex":"#efe5d4","rgb":{"r":239,"g":229,"b":212},"luminance":154.14379544438367},{"name":"Stone Pine","hex":"#665c46","rgb":{"r":102,"g":92,"b":70},"luminance":62.531915211354274},{"name":"Stone Quarry","hex":"#ece4dc","rgb":{"r":236,"g":228,"b":220},"luminance":153.36348780593116},{"name":"Stone Silver","hex":"#8ba8ae","rgb":{"r":139,"g":168,"b":174},"luminance":108.83886747389464},{"name":"Stone Terrace","hex":"#a09484","rgb":{"r":160,"g":148,"b":132},"luminance":100.31224890311252},{"name":"Stone's Throw","hex":"#605c58","rgb":{"r":96,"g":92,"b":88},"luminance":61.97574248042535},{"name":"Stonebread","hex":"#ddcea7","rgb":{"r":221,"g":206,"b":167},"luminance":139.10790692480424},{"name":"Stonecrop","hex":"#a08f6f","rgb":{"r":160,"g":143,"b":111},"luminance":97.4416789520788},{"name":"Stonegate","hex":"#99917e","rgb":{"r":153,"g":145,"b":126},"luminance":97.69173828937633},{"name":"Stonehenge Greige","hex":"#a79d8d","rgb":{"r":167,"g":157,"b":141},"luminance":106.04225217336719},{"name":"Stonelake","hex":"#bab1a3","rgb":{"r":186,"g":177,"b":163},"luminance":119.3030172334296},{"name":"Stonetalon Mountains","hex":"#8d7a4d","rgb":{"r":141,"g":122,"b":77},"luminance":83.56434383754831},{"name":"Stonewall","hex":"#807661","rgb":{"r":128,"g":118,"b":97},"luminance":79.90496920717759},{"name":"Stonewall Grey","hex":"#c1c1c1","rgb":{"r":193,"g":193,"b":193},"luminance":129.0311455967124},{"name":"Stonewash","hex":"#74809a","rgb":{"r":116,"g":128,"b":154},"luminance":84.59675814119593},{"name":"Stonish Beige","hex":"#ccb49a","rgb":{"r":204,"g":180,"b":154},"luminance":123.25891753540593},{"name":"Stony Creek","hex":"#948f82","rgb":{"r":148,"g":143,"b":130},"luminance":96.04146700774618},{"name":"Storks Bill","hex":"#e5e1dd","rgb":{"r":229,"g":225,"b":221},"luminance":150.88678239660356},{"name":"Storksbill White","hex":"#f2f2e2","rgb":{"r":242,"g":242,"b":226},"luminance":161.48932712721296},{"name":"Storm","hex":"#444400","rgb":{"r":68,"g":68,"b":0},"luminance":44.79595160279553},{"name":"Storm Blue","hex":"#507b9c","rgb":{"r":80,"g":123,"b":156},"luminance":78.11159617495983},{"name":"Storm Break","hex":"#938988","rgb":{"r":147,"g":137,"b":136},"luminance":92.94867285765838},{"name":"Storm Cloud","hex":"#808283","rgb":{"r":128,"g":130,"b":131},"luminance":86.66594740727179},{"name":"Storm Dust","hex":"#65645f","rgb":{"r":101,"g":100,"b":95},"luminance":66.89513062249},{"name":"Storm Front","hex":"#787376","rgb":{"r":120,"g":115,"b":118},"luminance":77.6225207591199},{"name":"Storm Green","hex":"#113333","rgb":{"r":17,"g":51,"b":51},"luminance":30.91704148200471},{"name":"Storm Grey","hex":"#717486","rgb":{"r":113,"g":116,"b":134},"luminance":77.53346380112268},{"name":"Storm Petrel","hex":"#7f95a5","rgb":{"r":127,"g":149,"b":165},"luminance":97.18817416743664},{"name":"Storm's Coming","hex":"#cfc9bc","rgb":{"r":207,"g":201,"b":188},"luminance":134.94816131389118},{"name":"Stormeye","hex":"#e7b57f","rgb":{"r":231,"g":181,"b":127},"luminance":127.5482820503671},{"name":"Stormfang","hex":"#80a7c1","rgb":{"r":128,"g":167,"b":193},"luminance":107.5105521751237},{"name":"Stormhost Silver","hex":"#bbc6c9","rgb":{"r":187,"g":198,"b":201},"luminance":130.99541228989662},{"name":"Stormvermin Fur","hex":"#5c5954","rgb":{"r":92,"g":89,"b":84},"luminance":59.81405260471823},{"name":"Stormy","hex":"#b0bcc3","rgb":{"r":176,"g":188,"b":195},"luminance":124.26546186290058},{"name":"Stormy Pink","hex":"#e3b5ad","rgb":{"r":227,"g":181,"b":173},"luminance":127.60927247657202},{"name":"Stormy Ridge","hex":"#507b9a","rgb":{"r":80,"g":123,"b":154},"luminance":78.06000215859592},{"name":"Stormy Sea","hex":"#6e8082","rgb":{"r":110,"g":128,"b":130},"luminance":83.34748344131333},{"name":"Stormy Strait Green","hex":"#0f9b8e","rgb":{"r":15,"g":155,"b":142},"luminance":92.52262855107392},{"name":"Stormy Strait Grey","hex":"#6b8ba4","rgb":{"r":107,"g":139,"b":164},"luminance":89.61311351582422},{"name":"Stormy Sunrise","hex":"#c8a2c8","rgb":{"r":200,"g":162,"b":200},"luminance":114.62438150760073},{"name":"Stormy Weather","hex":"#58646d","rgb":{"r":88,"g":100,"b":109},"luminance":65.51653852272722},{"name":"Stout","hex":"#0f0b0a","rgb":{"r":15,"g":11,"b":10},"luminance":7.944033861962069},{"name":"Stowaway","hex":"#7b8393","rgb":{"r":123,"g":131,"b":147},"luminance":86.8707482527922},{"name":"Straken Green","hex":"#628026","rgb":{"r":98,"g":128,"b":38},"luminance":80.76380330321251},{"name":"Stranglethorn Ochre","hex":"#dbb060","rgb":{"r":219,"g":176,"b":96},"luminance":122.80432338073443},{"name":"Stratford Sage","hex":"#8c8670","rgb":{"r":140,"g":134,"b":112},"luminance":90.0131234209768},{"name":"Stratos","hex":"#000741","rgb":{"r":0,"g":7,"b":65},"luminance":8.473014870752912},{"name":"Stratosphere","hex":"#9ec1cc","rgb":{"r":158,"g":193,"b":204},"luminance":124.92997551028336},{"name":"Stravinsky","hex":"#996e74","rgb":{"r":153,"g":110,"b":116},"luminance":80.2305869665678},{"name":"Stravinsky Pink","hex":"#77515a","rgb":{"r":119,"g":81,"b":90},"luminance":60.26601339063336},{"name":"Straw","hex":"#e4d96f","rgb":{"r":228,"g":217,"b":111},"luminance":145.02742823686833},{"name":"Straw Gold","hex":"#fcf679","rgb":{"r":252,"g":246,"b":121},"luminance":163.4611059059616},{"name":"Straw Hat","hex":"#f0d5a8","rgb":{"r":240,"g":213,"b":168},"luminance":145.4271214904565},{"name":"Straw Hut","hex":"#bdb268","rgb":{"r":189,"g":178,"b":104},"luminance":119.3791525057872},{"name":"Straw Yellow","hex":"#f0d696","rgb":{"r":240,"g":214,"b":150},"luminance":145.67700410153964},{"name":"Strawberry","hex":"#fb2943","rgb":{"r":251,"g":41,"b":67},"luminance":79.18277548810725},{"name":"Strawberry Blonde","hex":"#ffdadc","rgb":{"r":255,"g":218,"b":220},"luminance":151.0549687398597},{"name":"Strawberry Confection","hex":"#f4bfc6","rgb":{"r":244,"g":191,"b":198},"luminance":135.65505817698062},{"name":"Strawberry Cough","hex":"#990011","rgb":{"r":153,"g":0,"b":17},"luminance":45.78803176595386},{"name":"Strawberry Cream","hex":"#f4c3c4","rgb":{"r":244,"g":195,"b":196},"luminance":137.5647792750746},{"name":"Strawberry Dust","hex":"#fff0ea","rgb":{"r":255,"g":240,"b":234},"luminance":162.3948379752263},{"name":"Strawberry Frappe","hex":"#ffa2aa","rgb":{"r":255,"g":162,"b":170},"luminance":123.41698935316806},{"name":"Strawberry Frosting","hex":"#ff6ffc","rgb":{"r":255,"g":111,"b":252},"luminance":104.32656736421457},{"name":"Strawberry Glaze","hex":"#dab7be","rgb":{"r":218,"g":183,"b":190},"luminance":127.50341158180827},{"name":"Strawberry Ice","hex":"#e78b90","rgb":{"r":231,"g":139,"b":144},"luminance":108.15465531358323},{"name":"Strawberry Jam","hex":"#86423e","rgb":{"r":134,"g":66,"b":62},"luminance":56.179921181859974},{"name":"Strawberry Jubilee","hex":"#c08591","rgb":{"r":192,"g":133,"b":145},"luminance":98.30564787945808},{"name":"Strawberry Mousse","hex":"#a5647e","rgb":{"r":165,"g":100,"b":126},"luminance":78.01254207497664},{"name":"Strawberry Pink","hex":"#f57f8e","rgb":{"r":245,"g":127,"b":142},"luminance":105.76341413740386},{"name":"Strawberry Pop","hex":"#ee2255","rgb":{"r":238,"g":34,"b":85},"luminance":74.54024488824811},{"name":"Strawberry Shortcake","hex":"#fa8e99","rgb":{"r":250,"g":142,"b":153},"luminance":113.31229050725257},{"name":"Strawberry Smash","hex":"#ee0055","rgb":{"r":238,"g":0,"b":85},"luminance":71.81870469452926},{"name":"Strawberry Smoothie","hex":"#e79ea6","rgb":{"r":231,"g":158,"b":166},"luminance":117.17706709505917},{"name":"Strawberry Soap","hex":"#f7879a","rgb":{"r":247,"g":135,"b":154},"luminance":109.73718043580307},{"name":"Strawberry Spinach Red","hex":"#fa4224","rgb":{"r":250,"g":66,"b":36},"luminance":84.29322558782526},{"name":"Strawberry Surprise","hex":"#b9758d","rgb":{"r":185,"g":117,"b":141},"luminance":89.63775846148765},{"name":"Strawberry Yogurt","hex":"#e9b3b4","rgb":{"r":233,"g":179,"b":180},"luminance":127.7297796835178},{"name":"Strawflower","hex":"#ddbdba","rgb":{"r":221,"g":189,"b":186},"luminance":130.8602044396997},{"name":"Stream","hex":"#495e7b","rgb":{"r":73,"g":94,"b":123},"luminance":60.97250279429244},{"name":"Stretch Limo","hex":"#2b2c30","rgb":{"r":43,"g":44,"b":48},"luminance":29.365469807241293},{"name":"Streusel Cake","hex":"#d7aa60","rgb":{"r":215,"g":170,"b":96},"luminance":119.2072835903914},{"name":"Strike It Rich","hex":"#d7b55f","rgb":{"r":215,"g":181,"b":95},"luminance":124.65261783853558},{"name":"Strikemaster","hex":"#946a81","rgb":{"r":148,"g":106,"b":129},"luminance":77.75656386440953},{"name":"Striking Purple","hex":"#944e87","rgb":{"r":148,"g":78,"b":135},"luminance":65.50915508537717},{"name":"Striking Red","hex":"#c03543","rgb":{"r":192,"g":53,"b":67},"luminance":65.74124906784172},{"name":"String","hex":"#aa9f96","rgb":{"r":170,"g":159,"b":150},"luminance":107.6436147154117},{"name":"String Ball","hex":"#f1e8d8","rgb":{"r":241,"g":232,"b":216},"luminance":156.0285958182025},{"name":"String Deep","hex":"#7f7860","rgb":{"r":127,"g":120,"b":96},"luminance":80.76827016223636},{"name":"String of Pearls","hex":"#ebe3d8","rgb":{"r":235,"g":227,"b":216},"luminance":152.63946934525157},{"name":"Stromboli","hex":"#406356","rgb":{"r":64,"g":99,"b":86},"luminance":61.963099349532214},{"name":"Strong Blue","hex":"#0c06f7","rgb":{"r":12,"g":6,"b":247},"luminance":28.60334232218326},{"name":"Strong Cerise","hex":"#960056","rgb":{"r":150,"g":0,"b":86},"luminance":45.909050480270224},{"name":"Strong Envy","hex":"#782e2c","rgb":{"r":120,"g":46,"b":44},"luminance":45.184540055200294},{"name":"Strong Mocha","hex":"#6f372d","rgb":{"r":111,"g":55,"b":45},"luminance":46.58484566895118},{"name":"Strong Mustard","hex":"#a88905","rgb":{"r":168,"g":137,"b":5},"luminance":94.81979901370809},{"name":"Strong Olive","hex":"#646756","rgb":{"r":100,"g":103,"b":86},"luminance":68.15908550589569},{"name":"Strong Pink","hex":"#ff0789","rgb":{"r":255,"g":7,"b":137},"luminance":77.9365500262874},{"name":"Strong Sage","hex":"#2b6460","rgb":{"r":43,"g":100,"b":96},"luminance":61.0799769564462},{"name":"Strong Strawberry","hex":"#8a3e34","rgb":{"r":138,"g":62,"b":52},"luminance":55.33730264478022},{"name":"Strong Tone Wash","hex":"#454129","rgb":{"r":69,"g":65,"b":41},"luminance":43.62669437397246},{"name":"Stucco","hex":"#a58d7f","rgb":{"r":165,"g":141,"b":127},"luminance":97.43680515082582},{"name":"Stucco Tan","hex":"#e8dece","rgb":{"r":232,"g":222,"b":206},"luminance":149.48296316303072},{"name":"Studer Blue","hex":"#005577","rgb":{"r":0,"g":85,"b":119},"luminance":51.70635725904504},{"name":"Studio","hex":"#724aa1","rgb":{"r":114,"g":74,"b":161},"luminance":58.18577623440285},{"name":"Studio Cream","hex":"#ebdbaa","rgb":{"r":235,"g":219,"b":170},"luminance":147.7789850892203},{"name":"Studio White","hex":"#e8dcd5","rgb":{"r":232,"g":220,"b":213},"luminance":148.5889449050635},{"name":"Stuffed Olive","hex":"#adac7c","rgb":{"r":173,"g":172,"b":124},"luminance":114.32076942095867},{"name":"Stunning Sapphire","hex":"#185887","rgb":{"r":24,"g":88,"b":135},"luminance":54.375448614241336},{"name":"Stylish","hex":"#cec1a5","rgb":{"r":206,"g":193,"b":165},"luminance":130.31687387671636},{"name":"Su-Nezumi Grey","hex":"#9fa0a0","rgb":{"r":159,"g":160,"b":160},"luminance":106.83543738385684},{"name":"Suave Grey","hex":"#d1d8dd","rgb":{"r":209,"g":216,"b":221},"luminance":143.58298639114594},{"name":"Subaqueous","hex":"#00576f","rgb":{"r":0,"g":87,"b":111},"luminance":52.61336785456715},{"name":"Subdue Red","hex":"#ccb8b3","rgb":{"r":204,"g":184,"b":179},"luminance":125.70857137045189},{"name":"Submarine","hex":"#7a7778","rgb":{"r":122,"g":119,"b":120},"luminance":79.98267620553841},{"name":"Submerge","hex":"#4a7d82","rgb":{"r":74,"g":125,"b":130},"luminance":78.05820200978242},{"name":"Submersible","hex":"#00576e","rgb":{"r":0,"g":87,"b":110},"luminance":52.58606622480902},{"name":"Subpoena","hex":"#d8ccc6","rgb":{"r":216,"g":204,"b":198},"luminance":137.91363871640831},{"name":"Subterranean River","hex":"#1f3b4d","rgb":{"r":31,"g":59,"b":77},"luminance":36.91087013333606},{"name":"Subtle Blue","hex":"#d9e3e5","rgb":{"r":217,"g":227,"b":229},"luminance":150.48794943782045},{"name":"Subtle Green","hex":"#b5cbbb","rgb":{"r":181,"g":203,"b":187},"luminance":132.59965009757755},{"name":"Subtle Night Sky","hex":"#554b4f","rgb":{"r":85,"g":75,"b":79},"luminance":51.62587419114566},{"name":"Subtle Shadow","hex":"#d8d8d0","rgb":{"r":216,"g":216,"b":208},"luminance":144.25520186114605},{"name":"Subtle Suede","hex":"#d0bd94","rgb":{"r":208,"g":189,"b":148},"luminance":128.2998772290917},{"name":"Subtle Sunshine","hex":"#e4d89a","rgb":{"r":228,"g":216,"b":154},"luminance":145.0236049200267},{"name":"Subtle Violet","hex":"#b29e9e","rgb":{"r":178,"g":158,"b":158},"luminance":108.43815723259041},{"name":"Subway","hex":"#87857c","rgb":{"r":135,"g":133,"b":124},"luminance":89.01820466623666},{"name":"Succubus","hex":"#990022","rgb":{"r":153,"g":0,"b":34},"luminance":45.91090703743502},{"name":"Succulent","hex":"#dcdd65","rgb":{"r":220,"g":221,"b":101},"luminance":145.90639165231934},{"name":"Succulent Garden","hex":"#bccbb2","rgb":{"r":188,"g":203,"b":178},"luminance":133.30753215403846},{"name":"Succulent Leaves","hex":"#658e64","rgb":{"r":101,"g":142,"b":100},"luminance":89.38584293387852},{"name":"Sudan Brown","hex":"#ac6b29","rgb":{"r":172,"g":107,"b":41},"luminance":81.31208975914959},{"name":"Suddenly Sapphire","hex":"#1a5897","rgb":{"r":26,"g":88,"b":151},"luminance":55.0009018835146},{"name":"Suds","hex":"#a6b4c5","rgb":{"r":166,"g":180,"b":197},"luminance":118.87779994599495},{"name":"Suede Leather","hex":"#896757","rgb":{"r":137,"g":103,"b":87},"luminance":73.70119818564689},{"name":"Suede Vest","hex":"#d79043","rgb":{"r":215,"g":144,"b":67},"luminance":106.47010403394935},{"name":"Suffragette Yellow","hex":"#ecd0a1","rgb":{"r":236,"g":208,"b":161},"luminance":142.2096361995206},{"name":"Sugar Almond","hex":"#935529","rgb":{"r":147,"g":85,"b":41},"luminance":66.65750902936593},{"name":"Sugar Cane","hex":"#eeefdf","rgb":{"r":238,"g":239,"b":223},"luminance":159.3500366394686},{"name":"Sugar Cane Dahlia","hex":"#f7c2bf","rgb":{"r":247,"g":194,"b":191},"luminance":137.4648012001618},{"name":"Sugar Chic","hex":"#ffccff","rgb":{"r":255,"g":204,"b":255},"luminance":144.90668869655397},{"name":"Sugar Coated Almond","hex":"#bb6611","rgb":{"r":187,"g":102,"b":17},"luminance":81.94458669735299},{"name":"Sugar Cookie","hex":"#f2e2a4","rgb":{"r":242,"g":226,"b":164},"luminance":152.26433208076014},{"name":"Sugar Coral","hex":"#f56c73","rgb":{"r":245,"g":108,"b":115},"luminance":97.76103488097904},{"name":"Sugar Crystal","hex":"#f8f4ff","rgb":{"r":248,"g":244,"b":255},"luminance":163.88362940818706},{"name":"Sugar Dust","hex":"#f9ede3","rgb":{"r":249,"g":237,"b":227},"luminance":159.89596131860242},{"name":"Sugar Glaze","hex":"#fff0e1","rgb":{"r":255,"g":240,"b":225},"luminance":162.22945763639845},{"name":"Sugar Glazed Cashew","hex":"#cc9955","rgb":{"r":204,"g":153,"b":85},"luminance":108.99735701841581},{"name":"Sugar Grape","hex":"#9437ff","rgb":{"r":148,"g":55,"b":255},"luminance":62.01310852553675},{"name":"Sugar Honey Cashew","hex":"#ddaa66","rgb":{"r":221,"g":170,"b":102},"luminance":120.24844583195244},{"name":"Sugar Maple","hex":"#9c7647","rgb":{"r":156,"g":118,"b":71},"luminance":83.89847631512743},{"name":"Sugar Pie","hex":"#c7a77b","rgb":{"r":199,"g":167,"b":123},"luminance":115.52779027576004},{"name":"Sugar Pine","hex":"#73776e","rgb":{"r":115,"g":119,"b":110},"luminance":78.86077246641703},{"name":"Sugar Plum","hex":"#914e75","rgb":{"r":145,"g":78,"b":117},"luminance":64.45088102578583},{"name":"Sugar Shack","hex":"#eed5b6","rgb":{"r":238,"g":213,"b":182},"luminance":145.35219540481663},{"name":"Sugar Soap","hex":"#efe8dc","rgb":{"r":239,"g":232,"b":220},"luminance":155.82606578169134},{"name":"Sugar Swizzle","hex":"#f3eee7","rgb":{"r":243,"g":238,"b":231},"luminance":159.65677449140702},{"name":"Sugar Tooth","hex":"#d68f9f","rgb":{"r":214,"g":143,"b":159},"luminance":107.09272408992123},{"name":"Sugar Tree","hex":"#a2999a","rgb":{"r":162,"g":153,"b":154},"luminance":103.5396962570395},{"name":"Sugar-Candied Peanuts","hex":"#8b2e16","rgb":{"r":139,"g":46,"b":22},"luminance":49.62574723870664},{"name":"Sugared Pears","hex":"#ebd5b7","rgb":{"r":235,"g":213,"b":183},"luminance":144.9315156548085},{"name":"Sugarloaf Brown","hex":"#554400","rgb":{"r":85,"g":68,"b":0},"luminance":47.32028403338255},{"name":"Sugarpills","hex":"#ffddff","rgb":{"r":255,"g":221,"b":255},"luminance":153.2561889582277},{"name":"Sugilite","hex":"#a2999f","rgb":{"r":162,"g":153,"b":159},"luminance":103.6378668296487},{"name":"Sulfuric Yellow","hex":"#a79f5c","rgb":{"r":167,"g":159,"b":92},"luminance":106.36894058887678},{"name":"Sullen Gold","hex":"#a58b34","rgb":{"r":165,"g":139,"b":52},"luminance":95.5327224462906},{"name":"Sulphur","hex":"#ddb614","rgb":{"r":221,"g":182,"b":20},"luminance":125.63891195405982},{"name":"Sulphur Spring","hex":"#d5d717","rgb":{"r":213,"g":215,"b":23},"luminance":141.38815678125238},{"name":"Sulphur Water","hex":"#f2f3cf","rgb":{"r":242,"g":243,"b":207},"luminance":161.6756031347958},{"name":"Sulphur Yellow","hex":"#ccc050","rgb":{"r":204,"g":192,"b":80},"luminance":128.47520395780657},{"name":"Sultan Sand","hex":"#e3c9be","rgb":{"r":227,"g":201,"b":190},"luminance":137.82899512802086},{"name":"Sultan's Silk","hex":"#134558","rgb":{"r":19,"g":69,"b":88},"luminance":42.11184861769903},{"name":"Sultry Sea","hex":"#506770","rgb":{"r":80,"g":103,"b":112},"luminance":66.26251387473916},{"name":"Sultry Spell","hex":"#716563","rgb":{"r":113,"g":101,"b":99},"luminance":69.16562393270229},{"name":"Sulu","hex":"#c6ea80","rgb":{"r":198,"g":234,"b":128},"luminance":150.28314420453148},{"name":"Sumac dyed","hex":"#e08a1e","rgb":{"r":224,"g":138,"b":30},"luminance":105.16393398879676},{"name":"Sumatra Chicken","hex":"#4f666a","rgb":{"r":79,"g":102,"b":106},"luminance":65.48946917634926},{"name":"Sumi Ink","hex":"#595857","rgb":{"r":89,"g":88,"b":87},"luminance":58.9478954755808},{"name":"Sumire Violet","hex":"#7058a3","rgb":{"r":112,"g":88,"b":163},"luminance":64.3045815164052},{"name":"Summer Air","hex":"#3fafcf","rgb":{"r":63,"g":175,"b":207},"luminance":107.07064862977154},{"name":"Summer Birthday","hex":"#bbd5ef","rgb":{"r":187,"g":213,"b":239},"luminance":139.64726651818142},{"name":"Summer Breeze","hex":"#d3e5db","rgb":{"r":211,"g":229,"b":219},"luminance":150.57578160514393},{"name":"Summer Cloud","hex":"#bbffee","rgb":{"r":187,"g":255,"b":238},"luminance":162.07408249933115},{"name":"Summer Clover","hex":"#e5cfde","rgb":{"r":229,"g":207,"b":222},"luminance":141.75051952638478},{"name":"Summer Concrete","hex":"#57595d","rgb":{"r":87,"g":89,"b":93},"luminance":59.31618347466397},{"name":"Summer Daffodil","hex":"#ffe078","rgb":{"r":255,"g":224,"b":120},"luminance":152.6090972681511},{"name":"Summer Fig","hex":"#be4b3b","rgb":{"r":190,"g":75,"b":59},"luminance":72.18598064028775},{"name":"Summer Forest Green","hex":"#228b22","rgb":{"r":34,"g":139,"b":34},"luminance":82.31517831481627},{"name":"Summer Garden","hex":"#7aac80","rgb":{"r":122,"g":172,"b":128},"luminance":108.3388214999591},{"name":"Summer Green","hex":"#8fb69c","rgb":{"r":143,"g":182,"b":156},"luminance":116.43854714397634},{"name":"Summer Hill","hex":"#c1a58d","rgb":{"r":193,"g":165,"b":141},"luminance":113.88310827335192},{"name":"Summer Hue","hex":"#ffefc2","rgb":{"r":255,"g":239,"b":194},"luminance":161.19721874151548},{"name":"Summer Lake","hex":"#0077a7","rgb":{"r":0,"g":119,"b":167},"luminance":72.40087743252839},{"name":"Summer Lily","hex":"#f8d374","rgb":{"r":248,"g":211,"b":116},"luminance":144.96189060922185},{"name":"Summer Melon","hex":"#ead3ae","rgb":{"r":234,"g":211,"b":174},"luminance":143.62891248282847},{"name":"Summer Mist","hex":"#e1eaec","rgb":{"r":225,"g":234,"b":236},"luminance":155.29639726986588},{"name":"Summer Night","hex":"#36576a","rgb":{"r":54,"g":87,"b":106},"luminance":54.90682228102442},{"name":"Summer Orange","hex":"#ffb653","rgb":{"r":255,"g":182,"b":83},"luminance":131.5915385767641},{"name":"Summer Pear","hex":"#f5f0d1","rgb":{"r":245,"g":240,"b":209},"luminance":160.56508867434414},{"name":"Summer Rain","hex":"#e1e8db","rgb":{"r":225,"g":232,"b":219},"luminance":153.93280559062126},{"name":"Summer Sandcastle","hex":"#ece4ce","rgb":{"r":236,"g":228,"b":206},"luminance":153.1105850292526},{"name":"Summer Sea","hex":"#66a9b1","rgb":{"r":102,"g":169,"b":177},"luminance":105.72849614460615},{"name":"Summer Shade","hex":"#d1d9d7","rgb":{"r":209,"g":217,"b":215},"luminance":143.98359219716667},{"name":"Summer Shower","hex":"#e5ebe3","rgb":{"r":229,"g":235,"b":227},"luminance":156.16264518123404},{"name":"Summer Sky","hex":"#38b0de","rgb":{"r":56,"g":176,"b":222},"luminance":107.67648649542758},{"name":"Summer Solstice","hex":"#ded1a3","rgb":{"r":222,"g":209,"b":163},"luminance":140.7211714597345},{"name":"Summer Storm","hex":"#b0c5df","rgb":{"r":176,"g":197,"b":223},"luminance":129.56829002884925},{"name":"Summer Sun","hex":"#ffdc00","rgb":{"r":255,"g":220,"b":0},"luminance":149.9681286974002},{"name":"Summer Sunset","hex":"#d88167","rgb":{"r":216,"g":129,"b":103},"luminance":100.21447175433296},{"name":"Summer Waters","hex":"#215399","rgb":{"r":33,"g":83,"b":153},"luminance":52.68127650313724},{"name":"Summer Weasel","hex":"#bb8e55","rgb":{"r":187,"g":142,"b":85},"luminance":100.8367442205469},{"name":"Summer's Heat","hex":"#f9e699","rgb":{"r":249,"g":230,"b":153},"luminance":155.16080324940316},{"name":"Summerday Blue","hex":"#376698","rgb":{"r":55,"g":102,"b":152},"luminance":64.46389287810658},{"name":"Summertime","hex":"#f2d178","rgb":{"r":242,"g":209,"b":120},"luminance":143.0871799044205},{"name":"Summertown","hex":"#8cbc9e","rgb":{"r":140,"g":188,"b":158},"luminance":119.39488464754258},{"name":"Summerville Brown","hex":"#997651","rgb":{"r":153,"g":118,"b":81},"luminance":83.52145545307503},{"name":"Summit","hex":"#8bb6b8","rgb":{"r":139,"g":182,"b":184},"luminance":116.53674464734287},{"name":"Sun","hex":"#ef8e38","rgb":{"r":239,"g":142,"b":56},"luminance":109.97872200112165},{"name":"Sun Baked","hex":"#d27f63","rgb":{"r":210,"g":127,"b":99},"luminance":98.11988227163748},{"name":"Sun Bleached Mint","hex":"#e3efe1","rgb":{"r":227,"g":239,"b":225},"luminance":157.94553642949202},{"name":"Sun Bleached Pink","hex":"#fadadd","rgb":{"r":250,"g":218,"b":221},"luminance":150.32497228338346},{"name":"Sun City","hex":"#fffed9","rgb":{"r":255,"g":254,"b":217},"luminance":169.2793025535018},{"name":"Sun Crete","hex":"#ff8c00","rgb":{"r":255,"g":140,"b":0},"luminance":112.10197333231916},{"name":"Sun Dance","hex":"#c4aa4d","rgb":{"r":196,"g":170,"b":77},"luminance":116.05828794187858},{"name":"Sun Deck","hex":"#f0dca0","rgb":{"r":240,"g":220,"b":160},"luminance":148.86011823184876},{"name":"Sun Dial","hex":"#c79b36","rgb":{"r":199,"g":155,"b":54},"luminance":108.88771997796628},{"name":"Sun Drenched","hex":"#ffe7a3","rgb":{"r":255,"g":231,"b":163},"luminance":156.66887743901145},{"name":"Sun Dried Tomato","hex":"#752329","rgb":{"r":117,"g":35,"b":41},"luminance":40.83813891450001},{"name":"Sun Dust","hex":"#f6e0a4","rgb":{"r":246,"g":224,"b":164},"luminance":151.81839636881955},{"name":"Sun Glare","hex":"#f1f4d1","rgb":{"r":241,"g":244,"b":209},"luminance":162.0939164219311},{"name":"Sun God","hex":"#dfba5a","rgb":{"r":223,"g":186,"b":90},"luminance":128.3425068050332},{"name":"Sun Kiss","hex":"#ebd1bb","rgb":{"r":235,"g":209,"b":187},"luminance":142.97813062842863},{"name":"Sun Kissed","hex":"#ffeec2","rgb":{"r":255,"g":238,"b":194},"luminance":160.68660154785772},{"name":"Sun Orange","hex":"#f48037","rgb":{"r":244,"g":128,"b":55},"luminance":104.91572490337185},{"name":"Sun Salutation","hex":"#e7c26f","rgb":{"r":231,"g":194,"b":111},"luminance":133.78658139365098},{"name":"Sun Song","hex":"#e9ad17","rgb":{"r":233,"g":173,"b":23},"luminance":123.17861573341372},{"name":"Sun Surprise","hex":"#fff2a0","rgb":{"r":255,"g":242,"b":160},"luminance":162.25084450011346},{"name":"Sun Yellow","hex":"#ffdf22","rgb":{"r":255,"g":223,"b":34},"luminance":151.5367783806954},{"name":"Sun-Kissed Brick","hex":"#b75e41","rgb":{"r":183,"g":94,"b":65},"luminance":78.06068071058566},{"name":"Sun's Glory","hex":"#f6f2e5","rgb":{"r":246,"g":242,"b":229},"luminance":162.08347561673276},{"name":"Suna White","hex":"#dcd3b2","rgb":{"r":220,"g":211,"b":178},"luminance":141.7015529660843},{"name":"Sunbaked Adobe","hex":"#ab9a6e","rgb":{"r":171,"g":154,"b":110},"luminance":104.60986877441343},{"name":"Sunbeam","hex":"#f5edb2","rgb":{"r":245,"g":237,"b":178},"luminance":158.5312475507589},{"name":"Sunblast Yellow","hex":"#feff0f","rgb":{"r":254,"g":255,"b":15},"luminance":167.85803001643978},{"name":"Sunbound","hex":"#f9d964","rgb":{"r":249,"g":217,"b":100},"luminance":147.9808130873729},{"name":"Sunburn","hex":"#b37256","rgb":{"r":179,"g":114,"b":86},"luminance":86.24751927446957},{"name":"Sunburnt Cyclops","hex":"#ff404c","rgb":{"r":255,"g":64,"b":76},"luminance":85.43839619866468},{"name":"Sunburnt Toes","hex":"#d79584","rgb":{"r":215,"g":149,"b":132},"luminance":109.58457874171894},{"name":"Sunburst","hex":"#f6c289","rgb":{"r":246,"g":194,"b":137},"luminance":136.46359120292854},{"name":"Sunburst Yellow","hex":"#ffff99","rgb":{"r":255,"g":255,"b":153},"luminance":168.88789954878357},{"name":"Sunday Best","hex":"#fcc9c7","rgb":{"r":252,"g":201,"b":199},"luminance":141.8199840255244},{"name":"Sunday Drive","hex":"#dcc9ae","rgb":{"r":220,"g":201,"b":174},"luminance":136.5335397072822},{"name":"Sunday Gloves","hex":"#d7bad1","rgb":{"r":215,"g":186,"b":209},"luminance":128.92225806663487},{"name":"Sunday Niqab","hex":"#3d4035","rgb":{"r":61,"g":64,"b":53},"luminance":42.19622624121735},{"name":"Sundaze","hex":"#fae198","rgb":{"r":250,"g":225,"b":152},"luminance":152.74694009701142},{"name":"Sundown","hex":"#f5c99e","rgb":{"r":245,"g":201,"b":158},"luminance":140.04163430208888},{"name":"Sundress","hex":"#ebcf89","rgb":{"r":235,"g":207,"b":137},"luminance":141.22864167724617},{"name":"Sunezumi Brown","hex":"#6e5f57","rgb":{"r":110,"g":95,"b":87},"luminance":65.4969774035413},{"name":"Sunflower","hex":"#ffc512","rgb":{"r":255,"g":197,"b":18},"luminance":138.52757505276702},{"name":"Sunflower Yellow","hex":"#ffda03","rgb":{"r":255,"g":218,"b":3},"luminance":148.9587665933093},{"name":"Sunglo","hex":"#c76155","rgb":{"r":199,"g":97,"b":85},"luminance":82.92354805481975},{"name":"Sunglow","hex":"#ffcc33","rgb":{"r":255,"g":204,"b":51},"luminance":142.0798582663989},{"name":"Sunglow Gecko","hex":"#ffcf48","rgb":{"r":255,"g":207,"b":72},"luminance":143.68405746637305},{"name":"Sunken Battleship","hex":"#51574f","rgb":{"r":81,"g":87,"b":79},"luminance":57.23382529588599},{"name":"Sunken Gold","hex":"#b29700","rgb":{"r":178,"g":151,"b":0},"luminance":103.38809918457733},{"name":"Sunken Ship","hex":"#6b443d","rgb":{"r":107,"g":68,"b":61},"luminance":51.62554814236842},{"name":"Sunkist Coral","hex":"#ea6676","rgb":{"r":234,"g":102,"b":118},"luminance":93.06499522376821},{"name":"Sunlight","hex":"#edd59e","rgb":{"r":237,"g":213,"b":158},"luminance":144.84042209963349},{"name":"Sunlit Allium","hex":"#9787bb","rgb":{"r":151,"g":135,"b":187},"luminance":93.66247567729566},{"name":"Sunlit Kelp Green","hex":"#7d7103","rgb":{"r":125,"g":113,"b":3},"luminance":76.13677922003268},{"name":"Sunlounge","hex":"#da8433","rgb":{"r":218,"g":132,"b":51},"luminance":101.42123040074006},{"name":"Sunny","hex":"#f2f27a","rgb":{"r":242,"g":242,"b":122},"luminance":160.026408895532},{"name":"Sunny Disposition","hex":"#dba637","rgb":{"r":219,"g":166,"b":55},"luminance":117.567077130462},{"name":"Sunny Festival","hex":"#ffc946","rgb":{"r":255,"g":201,"b":70},"luminance":140.7050553249598},{"name":"Sunny Green","hex":"#c5cd40","rgb":{"r":197,"g":205,"b":64},"luminance":134.17640347691543},{"name":"Sunny Honey","hex":"#f8f0d8","rgb":{"r":248,"g":240,"b":216},"luminance":161.0963527830472},{"name":"Sunny Lime","hex":"#dfef87","rgb":{"r":223,"g":239,"b":135},"luminance":156.09228128898621},{"name":"Sunny Mimosa","hex":"#f5f5cc","rgb":{"r":245,"g":245,"b":204},"luminance":163.06406957389478},{"name":"Sunny Pavement","hex":"#d9d7d9","rgb":{"r":217,"g":215,"b":217},"luminance":144.04677836730679},{"name":"Sunny Side Up","hex":"#ffdc41","rgb":{"r":255,"g":220,"b":65},"luminance":150.15108299642728},{"name":"Sunny Summit","hex":"#e3e9cf","rgb":{"r":227,"g":233,"b":207},"luminance":154.49891965318074},{"name":"Sunny Yellow","hex":"#fff917","rgb":{"r":255,"g":249,"b":23},"luminance":164.875096597394},{"name":"Sunray","hex":"#e3ab57","rgb":{"r":227,"g":171,"b":87},"luminance":121.57570884843732},{"name":"Sunray Venus","hex":"#cfc5b6","rgb":{"r":207,"g":197,"b":182},"luminance":132.79157079423376},{"name":"Sunset","hex":"#c0514a","rgb":{"r":192,"g":81,"b":74},"luminance":75.01707651595069},{"name":"Sunset Cove","hex":"#dcb397","rgb":{"r":220,"g":179,"b":151},"luminance":125.15456653674286},{"name":"Sunset Cruise","hex":"#ffbe94","rgb":{"r":255,"g":190,"b":148},"luminance":136.15030410909847},{"name":"Sunset Gold","hex":"#f7c46c","rgb":{"r":247,"g":196,"b":108},"luminance":137.26912856502003},{"name":"Sunset Horizon","hex":"#ba87aa","rgb":{"r":186,"g":135,"b":170},"luminance":98.73333490265584},{"name":"Sunset Meadow","hex":"#a5a796","rgb":{"r":165,"g":167,"b":150},"luminance":111.06771387761611},{"name":"Sunset Orange","hex":"#fd5e53","rgb":{"r":253,"g":94,"b":83},"luminance":94.10956240999104},{"name":"Sunset Papaya","hex":"#fc7d64","rgb":{"r":252,"g":125,"b":100},"luminance":105.78833456010166},{"name":"Sunset Pink","hex":"#fad6e5","rgb":{"r":250,"g":214,"b":229},"luminance":148.48894793889545},{"name":"Sunset Purple","hex":"#6f456e","rgb":{"r":111,"g":69,"b":110},"luminance":53.8447242540994},{"name":"Sunset Riders","hex":"#d70040","rgb":{"r":215,"g":0,"b":64},"luminance":64.69770352184071},{"name":"Sunset Strip","hex":"#ffbc00","rgb":{"r":255,"g":188,"b":0},"luminance":134.1333171177094},{"name":"Sunset Yellow","hex":"#fa873d","rgb":{"r":250,"g":135,"b":61},"luminance":109.15901539039274},{"name":"Sunshade","hex":"#fa9d49","rgb":{"r":250,"g":157,"b":73},"luminance":118.95419061554745},{"name":"Sunshine","hex":"#fade85","rgb":{"r":250,"g":222,"b":133},"luminance":150.99399769527264},{"name":"Sunshine Surprise","hex":"#fcb02f","rgb":{"r":252,"g":176,"b":47},"luminance":127.98202456595222},{"name":"Sunshine Yellow","hex":"#fffd37","rgb":{"r":255,"g":253,"b":55},"luminance":167.05726576835858},{"name":"Sunstitch","hex":"#fee2b2","rgb":{"r":254,"g":226,"b":178},"luminance":154.2036524340458},{"name":"Sunstone","hex":"#c7887f","rgb":{"r":199,"g":136,"b":127},"luminance":100.61376500757736},{"name":"Suntan","hex":"#d9b19f","rgb":{"r":217,"g":177,"b":159},"luminance":123.8279361291304},{"name":"Suō","hex":"#7e2639","rgb":{"r":126,"g":38,"b":57},"luminance":44.261856219548676},{"name":"Super Banana","hex":"#fffe71","rgb":{"r":255,"g":254,"b":113},"luminance":167.95671928505865},{"name":"Super Black","hex":"#221100","rgb":{"r":34,"g":17,"b":0},"luminance":14.245279814731616},{"name":"Super Gold","hex":"#aa8822","rgb":{"r":170,"g":136,"b":34},"luminance":94.71990551093259},{"name":"Super Leaf Brown","hex":"#ba5e0f","rgb":{"r":186,"g":94,"b":15},"luminance":78.36104121309262},{"name":"Super Lemon","hex":"#e4bf45","rgb":{"r":228,"g":191,"b":69},"luminance":131.45157750670015},{"name":"Super Pink","hex":"#ce6ba4","rgb":{"r":206,"g":107,"b":164},"luminance":89.93515293254356},{"name":"Super Saiyan","hex":"#ffdd00","rgb":{"r":255,"g":221,"b":0},"luminance":150.47389990958564},{"name":"Super Sepia","hex":"#ffaa88","rgb":{"r":255,"g":170,"b":136},"luminance":126.53741794821008},{"name":"Super Silver","hex":"#eeeeee","rgb":{"r":238,"g":238,"b":238},"luminance":159.1161277306609},{"name":"Superman Red","hex":"#ff1122","rgb":{"r":255,"g":17,"b":34},"luminance":76.99288176188756},{"name":"Supermint","hex":"#00928c","rgb":{"r":0,"g":146,"b":140},"luminance":87.17542316501824},{"name":"Supernatural","hex":"#313641","rgb":{"r":49,"g":54,"b":65},"luminance":35.697662458485986},{"name":"Supernova","hex":"#fff8d9","rgb":{"r":255,"g":248,"b":217},"luminance":166.18556027826244},{"name":"Supernova Residues","hex":"#d9ece9","rgb":{"r":217,"g":236,"b":233},"luminance":155.26254718057407},{"name":"Superstar","hex":"#ffcc11","rgb":{"r":255,"g":204,"b":17},"luminance":141.9740799336273},{"name":"Superstition","hex":"#5b6e74","rgb":{"r":91,"g":110,"b":116},"luminance":71.30560116147959},{"name":"Superstitious","hex":"#ac91b5","rgb":{"r":172,"g":145,"b":181},"luminance":101.56359763714556},{"name":"Support Green","hex":"#78a300","rgb":{"r":120,"g":163,"b":0},"luminance":102.18722112377849},{"name":"Supreme Grey","hex":"#86949f","rgb":{"r":134,"g":148,"b":159},"luminance":97.37184196676161},{"name":"Surati Pink","hex":"#fc53fc","rgb":{"r":252,"g":83,"b":252},"luminance":94.21440934910116},{"name":"Surf","hex":"#b8d4bb","rgb":{"r":184,"g":212,"b":187},"luminance":137.72264343963195},{"name":"Surf Crest","hex":"#c3d6bd","rgb":{"r":195,"g":214,"b":189},"luminance":140.15557450561857},{"name":"Surf Green","hex":"#427573","rgb":{"r":66,"g":117,"b":115},"luminance":72.65058772645958},{"name":"Surf Rider","hex":"#0193c2","rgb":{"r":1,"g":147,"b":194},"luminance":89.07860785845276},{"name":"Surf Spray","hex":"#b4c8c2","rgb":{"r":180,"g":200,"b":194},"luminance":131.02850779887558},{"name":"Surf the Web","hex":"#203c7f","rgb":{"r":32,"g":60,"b":127},"luminance":39.263309947074},{"name":"Surf Wash","hex":"#87ceca","rgb":{"r":135,"g":206,"b":202},"luminance":129.54440201336374},{"name":"Surf'n'dive","hex":"#374755","rgb":{"r":55,"g":71,"b":85},"luminance":45.84000931500778},{"name":"Surf's Up","hex":"#c6e4eb","rgb":{"r":198,"g":228,"b":235},"luminance":148.77720188254648},{"name":"Surfer Girl","hex":"#db6484","rgb":{"r":219,"g":100,"b":132},"luminance":89.21823616839777},{"name":"Surfie Green","hex":"#007b77","rgb":{"r":0,"g":123,"b":119},"luminance":73.46441830573491},{"name":"Surfside","hex":"#9acad3","rgb":{"r":154,"g":202,"b":211},"luminance":129.45509842412542},{"name":"Surgeon Green","hex":"#009f6b","rgb":{"r":0,"g":159,"b":107},"luminance":94.12672358581275},{"name":"Surprise","hex":"#c9936f","rgb":{"r":201,"g":147,"b":111},"luminance":105.91413993419387},{"name":"Surya Red","hex":"#70191f","rgb":{"r":112,"g":25,"b":31},"luminance":36.73269558581292},{"name":"Sushi","hex":"#7c9f2f","rgb":{"r":124,"g":159,"b":47},"luminance":100.57030788955555},{"name":"Sushi Rice","hex":"#fff7df","rgb":{"r":255,"g":247,"b":223},"luminance":165.77511342176786},{"name":"Sussie","hex":"#58bac2","rgb":{"r":88,"g":186,"b":194},"luminance":114.4646142875605},{"name":"Susu Green","hex":"#887f7a","rgb":{"r":136,"g":127,"b":122},"luminance":86.0496761237368},{"name":"Susu-Take Bamboo","hex":"#6f514c","rgb":{"r":111,"g":81,"b":76},"luminance":58.62842165707686},{"name":"Sutherland","hex":"#859d95","rgb":{"r":133,"g":157,"b":149},"luminance":101.79990061881199},{"name":"Suva Grey","hex":"#888387","rgb":{"r":136,"g":131,"b":135},"luminance":88.33776997977705},{"name":"Suzu Grey","hex":"#9ea1a3","rgb":{"r":158,"g":161,"b":163},"luminance":107.27847098556167},{"name":"Suzume Brown","hex":"#aa4f37","rgb":{"r":170,"g":79,"b":55},"luminance":69.09020863335121},{"name":"Suzumecha Brown","hex":"#8c4736","rgb":{"r":140,"g":71,"b":54},"luminance":59.389630955243355},{"name":"Swagger","hex":"#19b6b5","rgb":{"r":25,"g":182,"b":181},"luminance":109.06484831053496},{"name":"Swallow-Tailed Moth","hex":"#ece9dd","rgb":{"r":236,"g":233,"b":221},"luminance":155.94974245890884},{"name":"Swamp","hex":"#7f755f","rgb":{"r":127,"g":117,"b":95},"luminance":79.22147859008945},{"name":"Swamp Fox","hex":"#b79d69","rgb":{"r":183,"g":157,"b":105},"luminance":107.8448527747152},{"name":"Swamp Green","hex":"#748500","rgb":{"r":116,"g":133,"b":0},"luminance":85.4286889575159},{"name":"Swamp Mosquito","hex":"#252f2f","rgb":{"r":37,"g":47,"b":47},"luminance":30.203494069395347},{"name":"Swamp Moss","hex":"#698339","rgb":{"r":105,"g":131,"b":57},"luminance":83.31277595903283},{"name":"Swamp Mud","hex":"#857947","rgb":{"r":133,"g":121,"b":71},"luminance":81.80318975443438},{"name":"Swamp of Sorrows","hex":"#36310d","rgb":{"r":54,"g":49,"b":13},"luminance":33.01817391982785},{"name":"Swamp Shrub","hex":"#6d753b","rgb":{"r":109,"g":117,"b":59},"luminance":76.31656044398228},{"name":"Swan Dive","hex":"#e5e4dd","rgb":{"r":229,"g":228,"b":221},"luminance":152.4306083862424},{"name":"Swan Lake","hex":"#c5e5e2","rgb":{"r":197,"g":229,"b":226},"luminance":149.00634226099237},{"name":"Swan White","hex":"#f7f1e2","rgb":{"r":247,"g":241,"b":226},"luminance":161.65073892191148},{"name":"Swanndri","hex":"#5f7963","rgb":{"r":95,"g":121,"b":99},"luminance":77.32433349211618},{"name":"Swans Down","hex":"#dae6dd","rgb":{"r":218,"g":230,"b":221},"luminance":152.02345496665967},{"name":"Sweat Bee","hex":"#1d4e8f","rgb":{"r":29,"g":78,"b":143},"luminance":49.36901093803682},{"name":"Swedish Blue","hex":"#007eb1","rgb":{"r":0,"g":126,"b":177},"luminance":76.6650450205307},{"name":"Swedish Clover","hex":"#7b8867","rgb":{"r":123,"g":136,"b":103},"luminance":88.6767755221174},{"name":"Swedish Yellow","hex":"#fce081","rgb":{"r":252,"g":224,"b":129},"luminance":152.25860134652493},{"name":"Sweet 60","hex":"#f29eab","rgb":{"r":242,"g":158,"b":171},"luminance":119.23722873331131},{"name":"Sweet Almond","hex":"#cc9977","rgb":{"r":204,"g":153,"b":119},"luminance":109.41007308744474},{"name":"Sweet Alyssum","hex":"#e7c2de","rgb":{"r":231,"g":194,"b":222},"luminance":135.56998380541322},{"name":"Sweet Angel","hex":"#f5c8bb","rgb":{"r":245,"g":200,"b":187},"luminance":140.01254282741957},{"name":"Sweet Annie","hex":"#9c946e","rgb":{"r":156,"g":148,"b":110},"luminance":99.39996837021629},{"name":"Sweet Aqua","hex":"#a7e8d3","rgb":{"r":167,"g":232,"b":211},"luminance":147.0305453332742},{"name":"Sweet Bianca","hex":"#eedadd","rgb":{"r":238,"g":218,"b":221},"luminance":148.57343314334497},{"name":"Sweet Breeze","hex":"#c8dae3","rgb":{"r":200,"g":218,"b":227},"luminance":143.60016727009756},{"name":"Sweet Brown","hex":"#a83731","rgb":{"r":168,"g":55,"b":49},"luminance":59.97314769961636},{"name":"Sweet Butter","hex":"#fffcd7","rgb":{"r":255,"g":252,"b":215},"luminance":168.21281134622296},{"name":"Sweet Cashew","hex":"#ddaa77","rgb":{"r":221,"g":170,"b":119},"luminance":120.45129595400789},{"name":"Sweet Corn","hex":"#f9e176","rgb":{"r":249,"g":225,"b":118},"luminance":152.20943903056732},{"name":"Sweet Cream","hex":"#f0eae7","rgb":{"r":240,"g":234,"b":231},"luminance":157.1947751040091},{"name":"Sweet Dough","hex":"#dbcbab","rgb":{"r":219,"g":203,"b":171},"luminance":137.35764018794148},{"name":"Sweet Dreams","hex":"#9bc7ea","rgb":{"r":155,"g":199,"b":234},"luminance":128.47079422966138},{"name":"Sweet Earth","hex":"#ab9368","rgb":{"r":171,"g":147,"b":104},"luminance":100.99767768617257},{"name":"Sweet Emily","hex":"#cbd1e1","rgb":{"r":203,"g":209,"b":225},"luminance":139.25935084582292},{"name":"Sweet Flag","hex":"#674196","rgb":{"r":103,"g":65,"b":150},"luminance":51.929464025733985},{"name":"Sweet Florence","hex":"#8a9b76","rgb":{"r":138,"g":155,"b":118},"luminance":100.80565050134838},{"name":"Sweet Frosting","hex":"#fff8e4","rgb":{"r":255,"g":248,"b":228},"luminance":166.37684894539865},{"name":"Sweet Garden","hex":"#5fd1ba","rgb":{"r":95,"g":209,"b":186},"luminance":127.70110465458002},{"name":"Sweet Gardenia","hex":"#efe4da","rgb":{"r":239,"g":228,"b":218},"luminance":153.74124794927351},{"name":"Sweet Grape","hex":"#4b3b4f","rgb":{"r":75,"g":59,"b":79},"luminance":42.23071571735435},{"name":"Sweet Honey","hex":"#d4a55c","rgb":{"r":212,"g":165,"b":92},"luminance":116.22791279636745},{"name":"Sweet Illusion","hex":"#e0e8ec","rgb":{"r":224,"g":232,"b":236},"luminance":154.1288151125545},{"name":"Sweet Jasmine","hex":"#f9f4d4","rgb":{"r":249,"g":244,"b":212},"luminance":163.22163952429835},{"name":"Sweet Lavender","hex":"#9a9bc1","rgb":{"r":154,"g":155,"b":193},"luminance":104.3196642297127},{"name":"Sweet Lilac","hex":"#e8b5ce","rgb":{"r":232,"g":181,"b":206},"luminance":129.04201908293282},{"name":"Sweet Lychee","hex":"#9b4040","rgb":{"r":155,"g":64,"b":64},"luminance":60.103621063959196},{"name":"Sweet Menthol","hex":"#c2e4bc","rgb":{"r":194,"g":228,"b":188},"luminance":147.43168436940547},{"name":"Sweet Mint Tea","hex":"#d5e3d0","rgb":{"r":213,"g":227,"b":208},"luminance":149.57803620184347},{"name":"Sweet Murmur","hex":"#ecc5df","rgb":{"r":236,"g":197,"b":223},"luminance":137.83299496492123},{"name":"Sweet Mustard","hex":"#d1b871","rgb":{"r":209,"g":184,"b":113},"luminance":125.44639918706315},{"name":"Sweet Nothings","hex":"#bbdbd0","rgb":{"r":187,"g":219,"b":208},"luminance":142.17734109906544},{"name":"Sweet Pea","hex":"#a3a969","rgb":{"r":163,"g":169,"b":105},"luminance":111.17468811739477},{"name":"Sweet Peach","hex":"#e2bcb3","rgb":{"r":226,"g":188,"b":179},"luminance":131.00037041169006},{"name":"Sweet Pink","hex":"#ee918d","rgb":{"r":238,"g":145,"b":141},"luminance":112.10248411609797},{"name":"Sweet Potato","hex":"#d87c3b","rgb":{"r":216,"g":124,"b":59},"luminance":97.54191445732444},{"name":"Sweet Potato Peel","hex":"#917798","rgb":{"r":145,"g":119,"b":152},"luminance":84.01998106403023},{"name":"Sweet Romance","hex":"#ffc4dd","rgb":{"r":255,"g":196,"b":221},"luminance":140.3032443138789},{"name":"Sweet Sachet","hex":"#ffd8f0","rgb":{"r":255,"g":216,"b":240},"luminance":150.4595656281115},{"name":"Sweet Serenade","hex":"#ffc5d5","rgb":{"r":255,"g":197,"b":213},"luminance":140.62465598180142},{"name":"Sweet Sheba","hex":"#f0b9a9","rgb":{"r":240,"g":185,"b":169},"luminance":131.58096511653957},{"name":"Sweet Sixteen","hex":"#ffc9d3","rgb":{"r":255,"g":201,"b":211},"luminance":142.52307571056696},{"name":"Sweet Slumber Pink","hex":"#f8b8f8","rgb":{"r":248,"g":184,"b":248},"luminance":134.0281804397866},{"name":"Sweet Sparrow","hex":"#a8946b","rgb":{"r":168,"g":148,"b":107},"luminance":101.09146553493028},{"name":"Sweet Spiceberry","hex":"#7b453e","rgb":{"r":123,"g":69,"b":62},"luminance":55.16336974841185},{"name":"Sweet Spring","hex":"#d1e8c2","rgb":{"r":209,"g":232,"b":194},"luminance":151.4606364472301},{"name":"Sweet Tea","hex":"#c18244","rgb":{"r":193,"g":130,"b":68},"luminance":95.98649620128866},{"name":"Sweet Tooth","hex":"#5f6255","rgb":{"r":95,"g":98,"b":85},"luminance":64.8843648423871},{"name":"Sweet Truffle","hex":"#f0dcd7","rgb":{"r":240,"g":220,"b":215},"luminance":149.75772868202827},{"name":"Sweet Violet","hex":"#8c667a","rgb":{"r":140,"g":102,"b":122},"luminance":74.3679227893317},{"name":"Sweet William","hex":"#8892c1","rgb":{"r":136,"g":146,"b":193},"luminance":97.3780350181703},{"name":"Sweetheart","hex":"#f3c3d8","rgb":{"r":243,"g":195,"b":216},"luminance":137.79556324497534},{"name":"Sweetie Pie","hex":"#e1bbdb","rgb":{"r":225,"g":187,"b":219},"luminance":131.1428997010513},{"name":"Sweetly","hex":"#ffe5ef","rgb":{"r":255,"g":229,"b":239},"luminance":156.9241455927035},{"name":"Sweetness","hex":"#f8dbc4","rgb":{"r":248,"g":219,"b":196},"luminance":150.07880346338052},{"name":"Sweety Pie","hex":"#e7cee3","rgb":{"r":231,"g":206,"b":227},"luminance":141.64154662033312},{"name":"Swift","hex":"#82aadc","rgb":{"r":130,"g":170,"b":220},"luminance":109.9905786874494},{"name":"Swimmer","hex":"#0a91bf","rgb":{"r":10,"g":145,"b":191},"luminance":87.9068279543745},{"name":"Swing Sage","hex":"#c2c0a9","rgb":{"r":194,"g":192,"b":169},"luminance":128.21102295824645},{"name":"Swinging Vine","hex":"#706842","rgb":{"r":112,"g":104,"b":66},"luminance":70.0350985149589},{"name":"Swirl","hex":"#d7cec5","rgb":{"r":215,"g":206,"b":197},"luminance":138.77699043069063},{"name":"Swirling Smoke","hex":"#cecac1","rgb":{"r":206,"g":202,"b":193},"luminance":135.41677265390723},{"name":"Swiss Cheese","hex":"#fff4b9","rgb":{"r":255,"g":244,"b":185},"luminance":163.6225782372347},{"name":"Swiss Coffee","hex":"#d5c3ad","rgb":{"r":213,"g":195,"b":173},"luminance":132.46594837164756},{"name":"Swiss Lilac","hex":"#86608e","rgb":{"r":134,"g":96,"b":142},"luminance":71.01326357801054},{"name":"Swiss Plum","hex":"#5946b2","rgb":{"r":89,"g":70,"b":178},"luminance":52.99338340774251},{"name":"Swollen Sky","hex":"#67667c","rgb":{"r":103,"g":102,"b":124},"luminance":68.79809285874136},{"name":"Sword Steel","hex":"#d6d2de","rgb":{"r":214,"g":210,"b":222},"luminance":141.1743459697972},{"name":"Sybarite Green","hex":"#8bcbab","rgb":{"r":139,"g":203,"b":171},"luminance":127.69759856003556},{"name":"Sycamore","hex":"#908d39","rgb":{"r":144,"g":141,"b":57},"luminance":93.52229375394937},{"name":"Sycamore Stand","hex":"#959e8f","rgb":{"r":149,"g":158,"b":143},"luminance":104.1746961646637},{"name":"Sycorax Bronze","hex":"#cbb394","rgb":{"r":203,"g":179,"b":148},"luminance":122.5117362622863},{"name":"Syhar Soil","hex":"#a16717","rgb":{"r":161,"g":103,"b":23},"luminance":77.32897727243002},{"name":"Sylph","hex":"#adaab1","rgb":{"r":173,"g":170,"b":177},"luminance":114.19666506951943},{"name":"Sylvan","hex":"#979381","rgb":{"r":151,"g":147,"b":129},"luminance":98.49106638675408},{"name":"Sylvan Green","hex":"#e7eacb","rgb":{"r":231,"g":234,"b":203},"luminance":155.47764819741778},{"name":"Sylvaneth Bark","hex":"#ac8262","rgb":{"r":172,"g":130,"b":98},"luminance":92.69772849428404},{"name":"Symbolic","hex":"#b29ead","rgb":{"r":178,"g":158,"b":173},"luminance":108.73527065308662},{"name":"Symmetry","hex":"#8fa0a7","rgb":{"r":143,"g":160,"b":167},"luminance":104.93604191601663},{"name":"Symphony of Blue","hex":"#89a0a6","rgb":{"r":137,"g":160,"b":166},"luminance":104.19717628131771},{"name":"Synallactida","hex":"#331133","rgb":{"r":51,"g":17,"b":51},"luminance":19.12890582338676},{"name":"Synchronicity","hex":"#c7d4ce","rgb":{"r":199,"g":212,"b":206},"luminance":139.92203683837653},{"name":"Syndicate Camouflage","hex":"#918151","rgb":{"r":145,"g":129,"b":81},"luminance":87.74335023236803},{"name":"Synthetic Mint","hex":"#9ffeb0","rgb":{"r":159,"g":254,"b":176},"luminance":157.77491683090818},{"name":"Synthetic Pumpkin","hex":"#ff7538","rgb":{"r":255,"g":117,"b":56},"luminance":102.81469020524256},{"name":"Synthetic Spearmint","hex":"#1ef876","rgb":{"r":30,"g":248,"b":118},"luminance":146.4711199520233},{"name":"Syrah","hex":"#6a282c","rgb":{"r":106,"g":40,"b":44},"luminance":39.761542877509164},{"name":"Syrian Violet","hex":"#dfcae4","rgb":{"r":223,"g":202,"b":228},"luminance":138.49620886147028},{"name":"System Shock Blue","hex":"#3a2efe","rgb":{"r":58,"g":46,"b":254},"luminance":43.22386960927955},{"name":"Szöllősi Grape","hex":"#8020ff","rgb":{"r":128,"g":32,"b":255},"luminance":51.60086762836455},{"name":"T-Bird Turquoise","hex":"#6fc1af","rgb":{"r":111,"g":193,"b":175},"luminance":119.72619973088598},{"name":"T-Rex Fossil","hex":"#8e908d","rgb":{"r":142,"g":144,"b":141},"luminance":95.94810067948193},{"name":"Ta Prohm","hex":"#c7c4a5","rgb":{"r":199,"g":196,"b":165},"luminance":130.88601073071177},{"name":"Tabasco","hex":"#a02712","rgb":{"r":160,"g":39,"b":18},"luminance":53.07509541206685},{"name":"Tabbouleh Green","hex":"#526525","rgb":{"r":82,"g":101,"b":37},"luminance":64.29519590918127},{"name":"Tacao","hex":"#f6ae78","rgb":{"r":246,"g":174,"b":120},"luminance":126.60767891403744},{"name":"Tacha","hex":"#d2b960","rgb":{"r":210,"g":185,"b":96},"luminance":125.91754945598329},{"name":"Tactile","hex":"#d3e7c7","rgb":{"r":211,"g":231,"b":199},"luminance":151.26606667061847},{"name":"Tadpole","hex":"#7d7771","rgb":{"r":125,"g":119,"b":113},"luminance":80.26380353559131},{"name":"Taffy","hex":"#c39b6a","rgb":{"r":195,"g":155,"b":106},"luminance":108.73714317564169},{"name":"Taffy Pink","hex":"#fea6c8","rgb":{"r":254,"g":166,"b":200},"luminance":125.6287319047677},{"name":"Taffy Twist","hex":"#aad0ba","rgb":{"r":170,"g":208,"b":186},"luminance":133.9430167347294},{"name":"Tagliatelle","hex":"#f9f2d4","rgb":{"r":249,"g":242,"b":212},"luminance":162.19242442543361},{"name":"Tahini","hex":"#ddbb77","rgb":{"r":221,"g":187,"b":119},"luminance":128.83983839635937},{"name":"Tahiti Gold","hex":"#dc722a","rgb":{"r":220,"g":114,"b":42},"luminance":93.9571820990817},{"name":"Tahitian Sand","hex":"#f5dcb4","rgb":{"r":245,"g":220,"b":180},"luminance":149.88163671711087},{"name":"Tahitian Tide","hex":"#006b7e","rgb":{"r":0,"g":107,"b":126},"luminance":64.43054382045831},{"name":"Tahitian Treat","hex":"#00686d","rgb":{"r":0,"g":104,"b":109},"luminance":62.29978956625776},{"name":"Tahoe Snow","hex":"#d7e1e5","rgb":{"r":215,"g":225,"b":229},"luminance":149.1907841858873},{"name":"Tahuna Sands","hex":"#d8cc9b","rgb":{"r":216,"g":204,"b":155},"luminance":137.19659419971038},{"name":"Tail Lights","hex":"#dd4411","rgb":{"r":221,"g":68,"b":17},"luminance":77.22355301978794},{"name":"Tainted Gold","hex":"#ead795","rgb":{"r":234,"g":215,"b":149},"luminance":145.2978574411887},{"name":"Taisha Brown","hex":"#bb5520","rgb":{"r":187,"g":85,"b":32},"luminance":75.02721171681645},{"name":"Taisha Red","hex":"#9f5233","rgb":{"r":159,"g":82,"b":51},"luminance":67.90310179218619},{"name":"Taiwan Blue Magpie","hex":"#3377a2","rgb":{"r":51,"g":119,"b":162},"luminance":73.84470620159578},{"name":"Taiwan Gold","hex":"#c7aa71","rgb":{"r":199,"g":170,"b":113},"luminance":116.8946492573548},{"name":"Taj","hex":"#734a33","rgb":{"r":115,"g":74,"b":51},"luminance":55.70449411851794},{"name":"Taj Mahal","hex":"#ede9df","rgb":{"r":237,"g":233,"b":223},"luminance":156.12222549656406},{"name":"Take the Plunge","hex":"#d8d4dd","rgb":{"r":216,"g":212,"b":221},"luminance":142.45048202094648},{"name":"Talavera","hex":"#a0928b","rgb":{"r":160,"g":146,"b":139},"luminance":99.4212961090329},{"name":"Talâyi Gold","hex":"#e7b25d","rgb":{"r":231,"g":178,"b":93},"luminance":125.69905871167055},{"name":"Taliesin Blue","hex":"#707e84","rgb":{"r":112,"g":126,"b":132},"luminance":82.57279147515845},{"name":"Tall Poppy","hex":"#853534","rgb":{"r":133,"g":53,"b":52},"luminance":50.837484143100546},{"name":"Tall Ships","hex":"#0e81b9","rgb":{"r":14,"g":129,"b":185},"luminance":78.71647492742545},{"name":"Tallarn Flesh","hex":"#947e74","rgb":{"r":148,"g":126,"b":116},"luminance":87.19799954127387},{"name":"Tallarn Sand","hex":"#a79b5e","rgb":{"r":167,"g":155,"b":94},"luminance":104.33794789049668},{"name":"Tallow","hex":"#a39977","rgb":{"r":163,"g":153,"b":119},"luminance":103.07932501719246},{"name":"Tamago Egg","hex":"#fcd575","rgb":{"r":252,"g":213,"b":117},"luminance":146.58776998440217},{"name":"Tamago Orange","hex":"#ffa631","rgb":{"r":255,"g":166,"b":49},"luminance":123.85252030136488},{"name":"Tamale","hex":"#f0e4c6","rgb":{"r":240,"g":228,"b":198},"luminance":153.52871939803313},{"name":"Tamale Maize","hex":"#f8e7b7","rgb":{"r":248,"g":231,"b":183},"luminance":155.9496346805596},{"name":"Tamanegi Peel","hex":"#deaa9b","rgb":{"r":222,"g":170,"b":155},"luminance":121.14582899959866},{"name":"Tamarama","hex":"#11ddee","rgb":{"r":17,"g":221,"b":238},"luminance":132.63135693341903},{"name":"Tamarillo","hex":"#752b2f","rgb":{"r":117,"g":43,"b":47},"luminance":43.46983475929026},{"name":"Tamarind","hex":"#341515","rgb":{"r":52,"g":21,"b":21},"luminance":19.98565658165876},{"name":"Tamarind Tart","hex":"#8e604b","rgb":{"r":142,"g":96,"b":75},"luminance":71.07272450103486},{"name":"Tambo Tank","hex":"#7c7d57","rgb":{"r":124,"g":125,"b":87},"luminance":82.80632297717366},{"name":"Tamboon","hex":"#bdc8af","rgb":{"r":189,"g":200,"b":175},"luminance":131.8114396439095},{"name":"Tambourine","hex":"#f0edd6","rgb":{"r":240,"g":237,"b":214},"luminance":158.42587723285612},{"name":"Tambua Bay","hex":"#658498","rgb":{"r":101,"g":132,"b":152},"luminance":84.94709789627895},{"name":"Tame Thyme","hex":"#c5c5ac","rgb":{"r":197,"g":197,"b":172},"luminance":131.24943959499407},{"name":"Tan","hex":"#d1b26f","rgb":{"r":209,"g":178,"b":111},"luminance":122.4033210047832},{"name":"Tan 686A","hex":"#a38d6d","rgb":{"r":163,"g":141,"b":109},"luminance":96.85079728117884},{"name":"Tan Brown","hex":"#ab7e4c","rgb":{"r":171,"g":126,"b":76},"luminance":90.3305982544121},{"name":"Tan Green","hex":"#a9be70","rgb":{"r":169,"g":190,"b":112},"luminance":123.10704563508945},{"name":"Tàn Hēi Soot","hex":"#323939","rgb":{"r":50,"g":57,"b":57},"luminance":37.21869402598645},{"name":"Tan Hide","hex":"#fa9d5a","rgb":{"r":250,"g":157,"b":90},"luminance":119.10546327100197},{"name":"Tan Oak","hex":"#c2aa87","rgb":{"r":194,"g":170,"b":135},"luminance":116.44566216051157},{"name":"Tan Plan","hex":"#c19e78","rgb":{"r":193,"g":158,"b":120},"luminance":110.08660574747502},{"name":"Tan Temptation","hex":"#f0bd9e","rgb":{"r":240,"g":189,"b":158},"luminance":133.35021182210397},{"name":"Tan Wagon","hex":"#a3755d","rgb":{"r":163,"g":117,"b":93},"luminance":84.87934150310075},{"name":"Tan Whirl","hex":"#f1d7ce","rgb":{"r":241,"g":215,"b":206},"luminance":147.21311002081302},{"name":"Tan Your Hide","hex":"#b5905a","rgb":{"r":181,"g":144,"b":90},"luminance":100.89160790174769},{"name":"Tana","hex":"#b8b5a1","rgb":{"r":184,"g":181,"b":161},"luminance":121.04567146742588},{"name":"Tanager Turquoise","hex":"#91dce8","rgb":{"r":145,"g":220,"b":232},"luminance":138.7670433820653},{"name":"Tanami Desert","hex":"#d0b25c","rgb":{"r":208,"g":178,"b":92},"luminance":122.04575864813982},{"name":"Tanaris Beige","hex":"#e9b581","rgb":{"r":233,"g":181,"b":129},"luminance":127.8991099812661},{"name":"Tandayapa Cloud Forest","hex":"#4a766e","rgb":{"r":74,"g":118,"b":110},"luminance":73.78746663221335},{"name":"Tandoori Red","hex":"#d25762","rgb":{"r":210,"g":87,"b":98},"luminance":81.70336862700339},{"name":"Tandoori Spice","hex":"#9f4440","rgb":{"r":159,"g":68,"b":64},"luminance":62.50332273567542},{"name":"Tangara","hex":"#97725f","rgb":{"r":151,"g":114,"b":95},"luminance":81.44777360370263},{"name":"Tangaroa","hex":"#1e2f3c","rgb":{"r":30,"g":47,"b":60},"luminance":29.80602994362047},{"name":"Tangelo","hex":"#f94d00","rgb":{"r":249,"g":77,"b":0},"luminance":87.09707803365161},{"name":"Tangelo Cream","hex":"#f2e9de","rgb":{"r":242,"g":233,"b":222},"luminance":156.78801443031287},{"name":"Tangent","hex":"#ead3a2","rgb":{"r":234,"g":211,"b":162},"luminance":143.44638241865843},{"name":"Tangerine","hex":"#ff9300","rgb":{"r":255,"g":147,"b":0},"luminance":115.14812871254139},{"name":"Tangerine Bliss","hex":"#d86130","rgb":{"r":216,"g":97,"b":48},"luminance":86.27331894044647},{"name":"Tangerine Cream","hex":"#ffa089","rgb":{"r":255,"g":160,"b":137},"luminance":121.97617943270726},{"name":"Tangerine Dream","hex":"#ff8449","rgb":{"r":255,"g":132,"b":73},"luminance":109.02442829476335},{"name":"Tangerine Flake","hex":"#e57f5b","rgb":{"r":229,"g":127,"b":91},"luminance":101.7519096528414},{"name":"Tangerine Skin","hex":"#f28500","rgb":{"r":242,"g":133,"b":0},"luminance":106.44604832965852},{"name":"Tangerine Tango","hex":"#ff9e4b","rgb":{"r":255,"g":158,"b":75},"luminance":120.36703469388951},{"name":"Tangerine Yellow","hex":"#fecd01","rgb":{"r":254,"g":205,"b":1},"luminance":142.296592148231},{"name":"Tangier","hex":"#a97164","rgb":{"r":169,"g":113,"b":100},"luminance":84.16141349811087},{"name":"Tangle","hex":"#7c7c65","rgb":{"r":124,"g":124,"b":101},"luminance":82.49421140904371},{"name":"Tangled Twine","hex":"#b19466","rgb":{"r":177,"g":148,"b":102},"luminance":102.38893343032731},{"name":"Tangled Vines","hex":"#cac19a","rgb":{"r":202,"g":193,"b":154},"luminance":129.58002246102598},{"name":"Tanglewood","hex":"#a58f85","rgb":{"r":165,"g":143,"b":133},"luminance":98.53892606477908},{"name":"Tango","hex":"#d46f31","rgb":{"r":212,"g":111,"b":49},"luminance":91.07511509188446},{"name":"Tango Mango","hex":"#f8c884","rgb":{"r":248,"g":200,"b":132},"luminance":139.6700447769671},{"name":"Tango Pink","hex":"#e47f7a","rgb":{"r":228,"g":127,"b":122},"luminance":101.97258184924023},{"name":"Tango Red","hex":"#ac0e2e","rgb":{"r":172,"g":14,"b":46},"luminance":52.343808076982704},{"name":"Tangy Taffy","hex":"#e7cac3","rgb":{"r":231,"g":202,"b":195},"luminance":139.01256467312587},{"name":"Tank","hex":"#5c6141","rgb":{"r":92,"g":97,"b":65},"luminance":63.66826434731828},{"name":"Tank Grey","hex":"#848481","rgb":{"r":132,"g":132,"b":129},"luminance":88.19160796810544},{"name":"Tank Yellow","hex":"#efc93d","rgb":{"r":239,"g":201,"b":61},"luminance":138.11576595740254},{"name":"Tanned Flesh","hex":"#f7b45e","rgb":{"r":247,"g":180,"b":94},"luminance":129.35661508017282},{"name":"Tanned Leather","hex":"#f2c108","rgb":{"r":242,"g":193,"b":8},"luminance":134.42976823977642},{"name":"Tanned Skin","hex":"#f7cd08","rgb":{"r":247,"g":205,"b":8},"luminance":141.1935181869196},{"name":"Tanned Wood","hex":"#8f6e4b","rgb":{"r":143,"g":110,"b":75},"luminance":77.91372439435814},{"name":"Tannin","hex":"#a68a6d","rgb":{"r":166,"g":138,"b":109},"luminance":95.81185452750614},{"name":"Tanooki Suit Brown","hex":"#ae6c37","rgb":{"r":174,"g":108,"b":55},"luminance":82.25004797566989},{"name":"Tansy","hex":"#c7c844","rgb":{"r":199,"g":200,"b":68},"luminance":131.84544931471848},{"name":"Tantanmen Brown","hex":"#857158","rgb":{"r":133,"g":113,"b":88},"luminance":77.986260802785},{"name":"Tanzanite","hex":"#1478a7","rgb":{"r":20,"g":120,"b":167},"luminance":73.21201707370177},{"name":"Taos Taupe","hex":"#bfa77f","rgb":{"r":191,"g":167,"b":127},"luminance":114.3710418156624},{"name":"Tap Shoe","hex":"#2a2b2d","rgb":{"r":42,"g":43,"b":45},"luminance":28.65533711195874},{"name":"Tapa","hex":"#7c7c72","rgb":{"r":124,"g":124,"b":114},"luminance":82.714078221304},{"name":"Tapenade","hex":"#805d24","rgb":{"r":128,"g":93,"b":36},"luminance":66.79645260790426},{"name":"Tapering Light","hex":"#f7f2dd","rgb":{"r":247,"g":242,"b":221},"luminance":162.07511271321084},{"name":"Tapestry","hex":"#b37084","rgb":{"r":179,"g":112,"b":132},"luminance":86.10001905342415},{"name":"Tapestry Beige","hex":"#b8ac9e","rgb":{"r":184,"g":172,"b":158},"luminance":116.3826520405855},{"name":"Tapioca","hex":"#dccdbc","rgb":{"r":220,"g":205,"b":188},"luminance":138.80508365690355},{"name":"Tara","hex":"#def1dd","rgb":{"r":222,"g":241,"b":221},"luminance":158.28357024340838},{"name":"Tara's Drapes","hex":"#767a49","rgb":{"r":118,"g":122,"b":73},"luminance":80.26605885428783},{"name":"Tarawera","hex":"#253c48","rgb":{"r":37,"g":60,"b":72},"luminance":37.81811249917161},{"name":"Tardis","hex":"#105673","rgb":{"r":16,"g":86,"b":115},"luminance":52.37548166842955},{"name":"Tareyton","hex":"#a1cdbf","rgb":{"r":161,"g":205,"b":191},"luminance":131.422915132788},{"name":"Tarmac","hex":"#5a5348","rgb":{"r":90,"g":83,"b":72},"luminance":56.260600823311506},{"name":"Tarmac Green","hex":"#477f4a","rgb":{"r":71,"g":127,"b":74},"luminance":77.97044272030267},{"name":"Tarnished Brass","hex":"#7f6c24","rgb":{"r":127,"g":108,"b":36},"luminance":74.0124608495083},{"name":"Tarnished Silver","hex":"#797b80","rgb":{"r":121,"g":123,"b":128},"luminance":82.06601553627421},{"name":"Tarpon Green","hex":"#c1b55c","rgb":{"r":193,"g":181,"b":92},"luminance":121.36111816393255},{"name":"Tarragon","hex":"#a4ae77","rgb":{"r":164,"g":174,"b":119},"luminance":114.10844270254502},{"name":"Tarsier","hex":"#825e61","rgb":{"r":130,"g":94,"b":97},"luminance":68.39420990113125},{"name":"Tart Orange","hex":"#fb4d46","rgb":{"r":251,"g":77,"b":70},"luminance":87.97148630096004},{"name":"Tartare","hex":"#bf5b3c","rgb":{"r":191,"g":91,"b":60},"luminance":78.49585575047895},{"name":"Tartrazine","hex":"#f7d917","rgb":{"r":247,"g":217,"b":23},"luminance":147.26353973064752},{"name":"Tarzan Green","hex":"#919585","rgb":{"r":145,"g":149,"b":133},"luminance":98.78926377901598},{"name":"Tasman","hex":"#bac0b3","rgb":{"r":186,"g":192,"b":179},"luminance":127.32444167558717},{"name":"Tassel Flower","hex":"#f9c0ce","rgb":{"r":249,"g":192,"b":206},"luminance":137.10084344379504},{"name":"Tassel Taupe","hex":"#9f9291","rgb":{"r":159,"g":146,"b":145},"luminance":99.38923676636219},{"name":"Tatami","hex":"#deccaf","rgb":{"r":222,"g":204,"b":175},"luminance":138.3604888976618},{"name":"Tatarian Aster","hex":"#976e9a","rgb":{"r":151,"g":110,"b":154},"luminance":80.72131216103959},{"name":"Tattered Teddy","hex":"#a2806f","rgb":{"r":162,"g":128,"b":111},"luminance":90.28721978220395},{"name":"Tattletail","hex":"#80736a","rgb":{"r":128,"g":115,"b":106},"luminance":78.53466791806024},{"name":"Tatzelwurm Green","hex":"#376d03","rgb":{"r":55,"g":109,"b":3},"luminance":66.06344888060265},{"name":"Tau Light Ochre","hex":"#f7d60d","rgb":{"r":247,"g":214,"b":13},"luminance":145.72694965928574},{"name":"Taupe","hex":"#b9a281","rgb":{"r":185,"g":162,"b":129},"luminance":110.99047029812965},{"name":"Taupe Grey","hex":"#8b8589","rgb":{"r":139,"g":133,"b":137},"luminance":89.81269223222294},{"name":"Taupe Night","hex":"#705a56","rgb":{"r":112,"g":90,"b":86},"luminance":63.313296075942844},{"name":"Taupe Tapestry","hex":"#c3a79a","rgb":{"r":195,"g":167,"b":154},"luminance":115.40091421648269},{"name":"Taupe White","hex":"#c7c1bb","rgb":{"r":199,"g":193,"b":187},"luminance":129.7292442204147},{"name":"Tausept Ochre","hex":"#a3813f","rgb":{"r":163,"g":129,"b":63},"luminance":90.33741761861471},{"name":"Tavern","hex":"#b7a594","rgb":{"r":183,"g":165,"b":148},"luminance":112.5144679496819},{"name":"Tavern Creek","hex":"#957046","rgb":{"r":149,"g":112,"b":70},"luminance":79.81695018603504},{"name":"Tawny Amber","hex":"#d19776","rgb":{"r":209,"g":151,"b":118},"luminance":109.28219962098127},{"name":"Tawny Birch","hex":"#ae856c","rgb":{"r":174,"g":133,"b":108},"luminance":94.62225457576034},{"name":"Tawny Brown","hex":"#ab856f","rgb":{"r":171,"g":133,"b":111},"luminance":94.17738262449217},{"name":"Tawny Daylily","hex":"#eabd5b","rgb":{"r":234,"g":189,"b":91},"luminance":131.5720725724118},{"name":"Tawny Mushroom","hex":"#b39997","rgb":{"r":179,"g":153,"b":151},"luminance":105.956759850422},{"name":"Tawny Olive","hex":"#c4962c","rgb":{"r":196,"g":150,"b":44},"luminance":105.88858093297878},{"name":"Tawny Orange","hex":"#d37f6f","rgb":{"r":211,"g":127,"b":111},"luminance":98.47791142180057},{"name":"Tawny Owl","hex":"#978b71","rgb":{"r":151,"g":139,"b":113},"luminance":94.1371115660556},{"name":"Tawny Port","hex":"#643a48","rgb":{"r":100,"g":58,"b":72},"luminance":46.04901062997988},{"name":"Tax Break","hex":"#496569","rgb":{"r":73,"g":101,"b":105},"luminance":64.30122236785239},{"name":"Taxite","hex":"#5c3937","rgb":{"r":92,"g":57,"b":55},"luminance":43.76651282658923},{"name":"Taylor","hex":"#5f5879","rgb":{"r":95,"g":88,"b":121},"luminance":60.543049122091624},{"name":"Te Papa Green","hex":"#2b4b40","rgb":{"r":43,"g":75,"b":64},"luminance":46.440657725747165},{"name":"Tea","hex":"#bfb5a2","rgb":{"r":191,"g":181,"b":162},"luminance":122.02839798178127},{"name":"Tea Bag","hex":"#726259","rgb":{"r":114,"g":98,"b":89},"luminance":67.63163008533803},{"name":"Tea Biscuit","hex":"#f5ebe1","rgb":{"r":245,"g":235,"b":225},"luminance":158.28152308466076},{"name":"Tea Chest","hex":"#605547","rgb":{"r":96,"g":85,"b":71},"luminance":58.12868033079712},{"name":"Tea Green","hex":"#d0f0c0","rgb":{"r":208,"g":240,"b":192},"luminance":155.54453962772206},{"name":"Tea Leaf","hex":"#8f8667","rgb":{"r":143,"g":134,"b":103},"luminance":90.29460990003777},{"name":"Tea Leaf Brown","hex":"#a59564","rgb":{"r":165,"g":149,"b":100},"luminance":101.06274582654085},{"name":"Tea Leaf Mouse","hex":"#888e7e","rgb":{"r":136,"g":142,"b":126},"luminance":93.84974538058161},{"name":"Tea Party","hex":"#ffd7d0","rgb":{"r":255,"g":215,"b":208},"luminance":149.34276344704486},{"name":"Tea Rose","hex":"#f883c2","rgb":{"r":248,"g":131,"b":194},"luminance":109.09071990320716},{"name":"Tea Time","hex":"#d9bebc","rgb":{"r":217,"g":190,"b":188},"luminance":130.79784101046926},{"name":"Teaberry","hex":"#dc3855","rgb":{"r":220,"g":56,"b":85},"luminance":74.17191438812942},{"name":"Teaberry Blossom","hex":"#b44940","rgb":{"r":180,"g":73,"b":64},"luminance":69.18115507130537},{"name":"Teak","hex":"#ab8953","rgb":{"r":171,"g":137,"b":83},"luminance":95.76491866022755},{"name":"Teak Wood","hex":"#624133","rgb":{"r":98,"g":65,"b":51},"luminance":48.45837208367611},{"name":"Teal","hex":"#008080","rgb":{"r":0,"g":128,"b":128},"luminance":76.53982597314942},{"name":"Teal Bayou","hex":"#57a1a0","rgb":{"r":87,"g":161,"b":160},"luminance":99.7042968883488},{"name":"Teal Blue","hex":"#01889f","rgb":{"r":1,"g":136,"b":159},"luminance":81.864458106067},{"name":"Teal Deer","hex":"#99e6b3","rgb":{"r":153,"g":230,"b":179},"luminance":144.00310047009404},{"name":"Teal Essence","hex":"#3da3ae","rgb":{"r":61,"g":163,"b":174},"luminance":99.40312760673076},{"name":"Teal Fury","hex":"#1a6c76","rgb":{"r":26,"g":108,"b":118},"luminance":65.27207822645147},{"name":"Teal Green","hex":"#25a36f","rgb":{"r":37,"g":163,"b":111},"luminance":97.14611390065997},{"name":"Teal Me No Lies","hex":"#0daca7","rgb":{"r":13,"g":172,"b":167},"luminance":102.81674722047961},{"name":"Teal Tree","hex":"#94b9b4","rgb":{"r":148,"g":185,"b":180},"luminance":119.04698202390516},{"name":"Teal Trip","hex":"#00a093","rgb":{"r":0,"g":160,"b":147},"luminance":95.40333832733526},{"name":"Teal Tune","hex":"#02708c","rgb":{"r":2,"g":112,"b":140},"luminance":67.65613601145131},{"name":"Teal Waters","hex":"#007765","rgb":{"r":0,"g":119,"b":101},"luminance":70.79557758080655},{"name":"Tealish","hex":"#24bca8","rgb":{"r":36,"g":188,"b":168},"luminance":112.52159586497162},{"name":"Tealish Green","hex":"#0cdc73","rgb":{"r":12,"g":220,"b":115},"luminance":129.85332280692703},{"name":"Team Spirit","hex":"#416986","rgb":{"r":65,"g":105,"b":134},"luminance":66.40744405561774},{"name":"Teardrop","hex":"#d1eaea","rgb":{"r":209,"g":234,"b":234},"luminance":153.24475267036064},{"name":"Tears of Joy","hex":"#f0f1da","rgb":{"r":240,"g":241,"b":218},"luminance":160.5616130742339},{"name":"Teasel Dipsacus","hex":"#ceaefa","rgb":{"r":206,"g":174,"b":250},"luminance":122.63050958060965},{"name":"Teatime Mauve","hex":"#c8a89e","rgb":{"r":200,"g":168,"b":158},"luminance":116.72869227400776},{"name":"Tech Wave","hex":"#4c7a9d","rgb":{"r":76,"g":122,"b":157},"luminance":77.23524827434684},{"name":"Techno Green","hex":"#69ac58","rgb":{"r":105,"g":172,"b":88},"luminance":106.20742132732533},{"name":"Teclis Blue","hex":"#a3bae3","rgb":{"r":163,"g":186,"b":227},"luminance":122.33427637829062},{"name":"Teddy Bear","hex":"#9d8164","rgb":{"r":157,"g":129,"b":100},"luminance":89.81969704914395},{"name":"Teddy's Taupe","hex":"#bcac9f","rgb":{"r":188,"g":172,"b":159},"luminance":116.97038136212089},{"name":"Tee Off","hex":"#68855a","rgb":{"r":104,"g":133,"b":90},"luminance":84.65996608196816},{"name":"Teeny Bikini","hex":"#326395","rgb":{"r":50,"g":99,"b":149},"luminance":62.3630296329484},{"name":"Teewurst","hex":"#f2dbd7","rgb":{"r":242,"g":219,"b":215},"luminance":149.5402757553964},{"name":"Teldrassil Purple","hex":"#ad66d2","rgb":{"r":173,"g":102,"b":210},"luminance":82.66620836230484},{"name":"Telemagenta","hex":"#cf3476","rgb":{"r":207,"g":52,"b":118},"luminance":70.30941849425297},{"name":"Tempered Chocolate","hex":"#772211","rgb":{"r":119,"g":34,"b":17},"luminance":40.84219838598309},{"name":"Tempest","hex":"#79839b","rgb":{"r":121,"g":131,"b":155},"luminance":86.80033150858354},{"name":"Template","hex":"#a6c9e3","rgb":{"r":166,"g":201,"b":227},"luminance":130.59148903737946},{"name":"Temple Guard Blue","hex":"#339a8d","rgb":{"r":51,"g":154,"b":141},"luminance":93.0736476184317},{"name":"Temple of Orange","hex":"#ee7755","rgb":{"r":238,"g":119,"b":85},"luminance":100.18666554487179},{"name":"Tempo","hex":"#33abb2","rgb":{"r":51,"g":171,"b":178},"luminance":103.53665724756618},{"name":"Tempting Taupe","hex":"#ccaa99","rgb":{"r":204,"g":170,"b":153},"luminance":118.24880329204181},{"name":"Temptress","hex":"#3c2126","rgb":{"r":60,"g":33,"b":38},"luminance":26.75528854264143},{"name":"Tenacious Tentacles","hex":"#98f6b0","rgb":{"r":152,"g":246,"b":176},"luminance":152.7089467058168},{"name":"Tender Greens","hex":"#c5cfb6","rgb":{"r":197,"g":207,"b":182},"luminance":136.61800757586823},{"name":"Tender Limerence","hex":"#e0d4e0","rgb":{"r":224,"g":212,"b":224},"luminance":143.611214770992},{"name":"Tender Peach","hex":"#f8d5b8","rgb":{"r":248,"g":213,"b":184},"luminance":146.8715855466945},{"name":"Tender Shoots","hex":"#b5cc39","rgb":{"r":181,"g":204,"b":57},"luminance":131.57003332446183},{"name":"Tender Touch","hex":"#d5c6d6","rgb":{"r":213,"g":198,"b":214},"luminance":134.75786381877683},{"name":"Tender Waves","hex":"#badbdf","rgb":{"r":186,"g":219,"b":223},"luminance":142.35543154021207},{"name":"Tender Yellow","hex":"#ededb7","rgb":{"r":237,"g":237,"b":183},"luminance":157.51471034160588},{"name":"Tenderness","hex":"#c8dbce","rgb":{"r":200,"g":219,"b":206},"luminance":143.71295023413862},{"name":"Tendril","hex":"#89a06b","rgb":{"r":137,"g":160,"b":107},"luminance":103.18781407220523},{"name":"Tenné","hex":"#cd5700","rgb":{"r":205,"g":87,"b":0},"luminance":79.78170082167965},{"name":"Tennis Ball","hex":"#dfff4f","rgb":{"r":223,"g":255,"b":79},"luminance":164.11133291153297},{"name":"Tense Terracotta","hex":"#a35732","rgb":{"r":163,"g":87,"b":50},"luminance":70.82251005153658},{"name":"Tentacle Pink","hex":"#ffbacd","rgb":{"r":255,"g":186,"b":205},"luminance":135.2041643182635},{"name":"Tenzing","hex":"#9ecfd9","rgb":{"r":158,"g":207,"b":217},"luminance":132.69593923327116},{"name":"Tequila","hex":"#f4d0a4","rgb":{"r":244,"g":208,"b":164},"luminance":143.45574776912915},{"name":"Teri-Gaki Persimmon","hex":"#eb6238","rgb":{"r":235,"g":98,"b":56},"luminance":91.0338747774695},{"name":"Terminator Chrome","hex":"#dcdfe5","rgb":{"r":220,"g":223,"b":229},"luminance":148.8072694360057},{"name":"Terminatus Stone","hex":"#bdb192","rgb":{"r":189,"g":177,"b":146},"luminance":119.43834416970121},{"name":"Termite Beige","hex":"#ddbb66","rgb":{"r":221,"g":187,"b":102},"luminance":128.6502156469238},{"name":"Terra Rosa","hex":"#bb6569","rgb":{"r":187,"g":101,"b":105},"luminance":82.36803286469818},{"name":"Terra Rose","hex":"#9f6d66","rgb":{"r":159,"g":109,"b":102},"luminance":80.55545514737037},{"name":"Terra Tone","hex":"#b6706b","rgb":{"r":182,"g":112,"b":107},"luminance":86.2112722560107},{"name":"Terracotta","hex":"#cb6843","rgb":{"r":203,"g":104,"b":67},"luminance":86.42524606271016},{"name":"Terracotta Chip","hex":"#c47c5e","rgb":{"r":196,"g":124,"b":94},"luminance":94.06037643981657},{"name":"Terracotta Sand","hex":"#d6ba9b","rgb":{"r":214,"g":186,"b":155},"luminance":127.77772192365927},{"name":"Terran Khaki","hex":"#a1965e","rgb":{"r":161,"g":150,"b":94},"luminance":100.92075345041772},{"name":"Terrazzo Tan","hex":"#be8973","rgb":{"r":190,"g":137,"b":115},"luminance":99.33007480617337},{"name":"Terror from the Deep","hex":"#1d4769","rgb":{"r":29,"g":71,"b":105},"luminance":44.22035131022819},{"name":"Testosterose","hex":"#ddaaff","rgb":{"r":221,"g":170,"b":255},"luminance":123.16469965456822},{"name":"Tête-à-Tête","hex":"#d90166","rgb":{"r":217,"g":1,"b":102},"luminance":65.91933435646934},{"name":"Teton Breeze","hex":"#dfeae8","rgb":{"r":223,"g":234,"b":232},"luminance":154.9597986479074},{"name":"Tetrarose","hex":"#8e6f73","rgb":{"r":142,"g":111,"b":115},"luminance":78.86690378733022},{"name":"Tetsu Black","hex":"#2b3733","rgb":{"r":43,"g":55,"b":51},"luminance":35.23387957633958},{"name":"Tetsu Green","hex":"#005243","rgb":{"r":0,"g":82,"b":67},"luminance":48.736239083458216},{"name":"Tetsu Iron","hex":"#455765","rgb":{"r":69,"g":87,"b":101},"luminance":56.26946879081053},{"name":"Tetsu-Guro Black","hex":"#281a14","rgb":{"r":40,"g":26,"b":20},"luminance":19.52354076493298},{"name":"Tetsu-Kon Blue","hex":"#17184b","rgb":{"r":23,"g":24,"b":75},"luminance":17.85685787029734},{"name":"Tetsuonando Black","hex":"#2b3736","rgb":{"r":43,"g":55,"b":54},"luminance":35.291925563788666},{"name":"Texan Angel","hex":"#e2ddd1","rgb":{"r":226,"g":221,"b":209},"luminance":148.19925195830106},{"name":"Texas","hex":"#ece67e","rgb":{"r":236,"g":230,"b":126},"luminance":153.01406043890213},{"name":"Texas Boots","hex":"#8b6947","rgb":{"r":139,"g":105,"b":71},"luminance":74.77768906565647},{"name":"Texas Heatwave","hex":"#a54e37","rgb":{"r":165,"g":78,"b":55},"luminance":67.59891212882053},{"name":"Texas Hills","hex":"#c9926e","rgb":{"r":201,"g":146,"b":110},"luminance":105.42283531095148},{"name":"Texas Longhorn","hex":"#e08d3c","rgb":{"r":224,"g":141,"b":60},"luminance":106.69089213705169},{"name":"Texas Ranger Brown","hex":"#a0522d","rgb":{"r":160,"g":82,"b":45},"luminance":68.05780231538482},{"name":"Texas Rose","hex":"#f1d2c9","rgb":{"r":241,"g":210,"b":201},"luminance":144.61342875749818},{"name":"Texas Sage","hex":"#b9a77c","rgb":{"r":185,"g":167,"b":124},"luminance":113.44276337431135},{"name":"Texas Sweet Tea","hex":"#794840","rgb":{"r":121,"g":72,"b":64},"luminance":56.11058147087766},{"name":"Thai Basil","hex":"#7a7f3f","rgb":{"r":122,"g":127,"b":63},"luminance":83.30533601756852},{"name":"Thai Curry","hex":"#ab6819","rgb":{"r":171,"g":104,"b":25},"luminance":79.68158786695957},{"name":"Thai Mango","hex":"#e77200","rgb":{"r":231,"g":114,"b":0},"luminance":96.16935834765665},{"name":"Thai Teak","hex":"#624435","rgb":{"r":98,"g":68,"b":53},"luminance":49.88386536747127},{"name":"Thai Temple","hex":"#e7c630","rgb":{"r":231,"g":198,"b":48},"luminance":135.3105783780411},{"name":"Thallium Flame","hex":"#58f898","rgb":{"r":88,"g":248,"b":152},"luminance":148.94614027896122},{"name":"Thamar Black","hex":"#181818","rgb":{"r":24,"g":24,"b":24},"luminance":16.04532380477253},{"name":"That's Atomic","hex":"#b0b08e","rgb":{"r":176,"g":176,"b":142},"luminance":117.06710069015973},{"name":"Thatch","hex":"#b1948f","rgb":{"r":177,"g":148,"b":143},"luminance":103.02445587820397},{"name":"Thatch Green","hex":"#544e31","rgb":{"r":84,"g":78,"b":49},"luminance":52.5202308448849},{"name":"Thatched Cottage","hex":"#d6c7a6","rgb":{"r":214,"g":199,"b":166},"luminance":134.5273315761522},{"name":"Thatched Roof","hex":"#efe0c6","rgb":{"r":239,"g":224,"b":198},"luminance":151.34485075152045},{"name":"Thawed Out","hex":"#e1eeec","rgb":{"r":225,"g":238,"b":236},"luminance":157.37699093895523},{"name":"The Blarney Stone","hex":"#ab9f89","rgb":{"r":171,"g":159,"b":137},"luminance":107.55996213275644},{"name":"The Bluff","hex":"#ffc8c2","rgb":{"r":255,"g":200,"b":194},"luminance":141.72218415265831},{"name":"The Boulevard","hex":"#d0a492","rgb":{"r":208,"g":164,"b":146},"luminance":115.81189672913574},{"name":"The Broadway","hex":"#145775","rgb":{"r":20,"g":87,"b":117},"luminance":53.11972707949467},{"name":"The Fang","hex":"#585673","rgb":{"r":88,"g":86,"b":115},"luminance":58.41768369252584},{"name":"The Fang Grey","hex":"#436174","rgb":{"r":67,"g":97,"b":116},"luminance":61.79194920052288},{"name":"The Golden State","hex":"#e9d2af","rgb":{"r":233,"g":210,"b":175},"luminance":142.99295887910006},{"name":"The Killing Joke","hex":"#b0bf1a","rgb":{"r":176,"g":191,"b":26},"luminance":123.88822527181507},{"name":"The Oregon Blue","hex":"#448ee4","rgb":{"r":68,"g":142,"b":228},"luminance":89.64855606199131},{"name":"The Rainbow Fish","hex":"#4466ee","rgb":{"r":68,"g":102,"b":238},"luminance":68.80720546570686},{"name":"The Sickener","hex":"#db7093","rgb":{"r":219,"g":112,"b":147},"luminance":94.29138593212001},{"name":"The Speed of Light","hex":"#f6f4ef","rgb":{"r":246,"g":244,"b":239},"luminance":163.2997103977836},{"name":"The White in my Eye","hex":"#f1eee5","rgb":{"r":241,"g":238,"b":229},"luminance":159.34801270489695},{"name":"Theatre District Lights","hex":"#eef4db","rgb":{"r":238,"g":244,"b":219},"luminance":161.86905628933528},{"name":"Theatre Dress","hex":"#274242","rgb":{"r":39,"g":66,"b":66},"luminance":41.15254622742072},{"name":"Themeda Japonica","hex":"#e2b13c","rgb":{"r":226,"g":177,"b":60},"luminance":124.1290992354331},{"name":"Therapeutic Toucan","hex":"#ee7711","rgb":{"r":238,"g":119,"b":17},"luminance":99.7357894489235},{"name":"Thermos","hex":"#d2bb95","rgb":{"r":210,"g":187,"b":149},"luminance":127.59444210858089},{"name":"Thick Fog","hex":"#dcd3ce","rgb":{"r":220,"g":211,"b":206},"luminance":142.1937519900224},{"name":"Thicket","hex":"#69865b","rgb":{"r":105,"g":134,"b":91},"luminance":85.32494866684655},{"name":"Thimbleberry","hex":"#e34b50","rgb":{"r":227,"g":75,"b":80},"luminance":81.4132615364352},{"name":"Thimbleberry Leaf","hex":"#afa97d","rgb":{"r":175,"g":169,"b":125},"luminance":113.05840673740276},{"name":"Thin Air","hex":"#c6fcff","rgb":{"r":198,"g":252,"b":255},"luminance":161.96126536922338},{"name":"Thin Cloud","hex":"#d4dcda","rgb":{"r":212,"g":220,"b":218},"luminance":145.98904084896233},{"name":"Thin Heights","hex":"#cae0df","rgb":{"r":202,"g":224,"b":223},"luminance":146.91252714455632},{"name":"Thin Ice","hex":"#d9dcdb","rgb":{"r":217,"g":220,"b":219},"luminance":146.6637120933464},{"name":"Think Pink","hex":"#e5a5c1","rgb":{"r":229,"g":165,"b":193},"luminance":120.63688022325509},{"name":"Thirsty Thursday","hex":"#726e9b","rgb":{"r":114,"g":110,"b":155},"luminance":75.12236149110329},{"name":"Thistle","hex":"#d8bfd8","rgb":{"r":216,"g":191,"b":216},"luminance":131.71050117967056},{"name":"Thistle Down","hex":"#9499bb","rgb":{"r":148,"g":153,"b":187},"luminance":102.36558185738016},{"name":"Thistle Green","hex":"#cccaa8","rgb":{"r":204,"g":202,"b":168},"luminance":134.71118957235885},{"name":"Thistle Grey","hex":"#e2dcd4","rgb":{"r":226,"g":220,"b":212},"luminance":147.74125117921534},{"name":"Thor's Thunder","hex":"#915a7f","rgb":{"r":145,"g":90,"b":127},"luminance":69.85898230721658},{"name":"Thorn Crown","hex":"#b5a197","rgb":{"r":181,"g":161,"b":151},"luminance":110.25770270597877},{"name":"Thought","hex":"#d8cdc8","rgb":{"r":216,"g":205,"b":200},"luminance":138.460988299954},{"name":"Thousand Herb","hex":"#317589","rgb":{"r":49,"g":117,"b":137},"luminance":71.94010540720663},{"name":"Thousand Needles Sand","hex":"#ffd9bb","rgb":{"r":255,"g":217,"b":187},"luminance":149.97722090370922},{"name":"Thousand Sons Blue","hex":"#02d8e9","rgb":{"r":2,"g":216,"b":233},"luminance":129.54577844144515},{"name":"Thousand Years Green","hex":"#316745","rgb":{"r":49,"g":103,"b":69},"luminance":62.70612631952319},{"name":"Thraka Green Wash","hex":"#4f6446","rgb":{"r":79,"g":100,"b":70},"luminance":63.77555990346145},{"name":"Thredbo","hex":"#73c4d7","rgb":{"r":115,"g":196,"b":215},"luminance":122.55623618975902},{"name":"Three Ring Circus","hex":"#fddbb6","rgb":{"r":253,"g":219,"b":182},"luminance":150.59489341275818},{"name":"Thresher Shark","hex":"#93cce7","rgb":{"r":147,"g":204,"b":231},"luminance":130.24948855561775},{"name":"Throat","hex":"#281f3f","rgb":{"r":40,"g":31,"b":63},"luminance":22.929316016837483},{"name":"Thrush","hex":"#936b4f","rgb":{"r":147,"g":107,"b":79},"luminance":77.18772393327839},{"name":"Thrush Egg","hex":"#a4b6a7","rgb":{"r":164,"g":182,"b":167},"luminance":119.08181345612772},{"name":"Thulian Pink","hex":"#df6fa1","rgb":{"r":223,"g":111,"b":161},"luminance":95.01645275424671},{"name":"Thumper","hex":"#bdada4","rgb":{"r":189,"g":173,"b":164},"luminance":117.70997892277441},{"name":"Thundelarra","hex":"#e88a76","rgb":{"r":232,"g":138,"b":118},"luminance":107.4934777742352},{"name":"Thunder","hex":"#4d4d4b","rgb":{"r":77,"g":77,"b":75},"luminance":51.44035993264433},{"name":"Thunder Bay","hex":"#cbd9d7","rgb":{"r":203,"g":217,"b":215},"luminance":143.21408991436562},{"name":"Thunder Chi","hex":"#aac4d4","rgb":{"r":170,"g":196,"b":212},"luminance":128.0810049460887},{"name":"Thunderbird","hex":"#923830","rgb":{"r":146,"g":56,"b":48},"luminance":54.91978590635618},{"name":"Thunderbolt","hex":"#7c8783","rgb":{"r":124,"g":135,"b":131},"luminance":88.75485427287906},{"name":"Thunderbolt Blue","hex":"#454c56","rgb":{"r":69,"g":76,"b":86},"luminance":50.11972786238967},{"name":"Thundercat","hex":"#8a99a3","rgb":{"r":138,"g":153,"b":163},"luminance":100.56768411870684},{"name":"Thundercloud","hex":"#698589","rgb":{"r":105,"g":133,"b":137},"luminance":85.58416319623625},{"name":"Thunderhawk Blue","hex":"#417074","rgb":{"r":65,"g":112,"b":116},"luminance":69.82024732840753},{"name":"Thunderstorm","hex":"#9098a1","rgb":{"r":144,"g":152,"b":161},"luminance":100.75520149352091},{"name":"Thunderstruck","hex":"#5f5755","rgb":{"r":95,"g":87,"b":85},"luminance":59.23498025660175},{"name":"Thurman","hex":"#7f7b60","rgb":{"r":127,"g":123,"b":96},"luminance":82.30859169005383},{"name":"Thy Flesh Consumed","hex":"#98514a","rgb":{"r":152,"g":81,"b":74},"luminance":66.31292490156048},{"name":"Thyme","hex":"#50574c","rgb":{"r":80,"g":87,"b":76},"luminance":57.055009043904285},{"name":"Thyme and Salt","hex":"#629a31","rgb":{"r":98,"g":154,"b":49},"luminance":95.19248396801083},{"name":"Thyme Green","hex":"#737b6c","rgb":{"r":115,"g":123,"b":108},"luminance":80.9129036062852},{"name":"Tia Maria","hex":"#97422d","rgb":{"r":151,"g":66,"b":45},"luminance":59.71341277301105},{"name":"Tiamo","hex":"#9bb2aa","rgb":{"r":155,"g":178,"b":170},"luminance":115.9343246023368},{"name":"Tiān Lán Sky","hex":"#5db3ff","rgb":{"r":93,"g":179,"b":255},"luminance":112.51057496075646},{"name":"Tiara","hex":"#b9c3be","rgb":{"r":185,"g":195,"b":190},"luminance":128.961781354012},{"name":"Tiara Jewel","hex":"#eae0e8","rgb":{"r":234,"g":224,"b":232},"luminance":151.27402950936423},{"name":"Tiber","hex":"#184343","rgb":{"r":24,"g":67,"b":67},"luminance":40.70140367358354},{"name":"Tibetan Plateau","hex":"#88ffdd","rgb":{"r":136,"g":255,"b":221},"luminance":157.14292143459724},{"name":"Tibetan Red","hex":"#782a39","rgb":{"r":120,"g":42,"b":57},"luminance":44.01611205002095},{"name":"Tibetan Silk","hex":"#9c8a52","rgb":{"r":156,"g":138,"b":82},"luminance":93.94157692949379},{"name":"Tibetan Stone","hex":"#82c2c7","rgb":{"r":130,"g":194,"b":199},"luminance":122.4488888475514},{"name":"Tibetan Temple","hex":"#814d50","rgb":{"r":129,"g":77,"b":80},"luminance":60.11527295122263},{"name":"Tibetan Yellow","hex":"#fedf00","rgb":{"r":254,"g":223,"b":0},"luminance":151.33693110738037},{"name":"Ticino Blue","hex":"#268bcc","rgb":{"r":38,"g":139,"b":204},"luminance":85.5999662908812},{"name":"Tickle Me Pink","hex":"#fc89ac","rgb":{"r":252,"g":137,"b":172},"luminance":111.93306182268043},{"name":"Tickled Crow","hex":"#b6baa4","rgb":{"r":182,"g":186,"b":164},"luminance":123.41623987142047},{"name":"Tickled Pink","hex":"#efa7bf","rgb":{"r":239,"g":167,"b":191},"luminance":123.24961029552993},{"name":"Tidal","hex":"#f0f590","rgb":{"r":240,"g":245,"b":144},"luminance":161.5603196363513},{"name":"Tidal Foam","hex":"#bfb9a3","rgb":{"r":191,"g":185,"b":163},"luminance":124.0951354002243},{"name":"Tidal Green","hex":"#cdca98","rgb":{"r":205,"g":202,"b":152},"luminance":134.5998888743969},{"name":"Tidal Mist","hex":"#e5e9e1","rgb":{"r":229,"g":233,"b":225},"luminance":155.08870617166164},{"name":"Tidal Pool","hex":"#005e59","rgb":{"r":0,"g":94,"b":89},"luminance":56.103056957709526},{"name":"Tidal Thicket","hex":"#8b866b","rgb":{"r":139,"g":134,"b":107},"luminance":89.79526094956236},{"name":"Tidal Wave","hex":"#355978","rgb":{"r":53,"g":89,"b":120},"luminance":56.28144328284412},{"name":"Tide","hex":"#beb4ab","rgb":{"r":190,"g":180,"b":171},"luminance":121.53776259253746},{"name":"Tidepool","hex":"#0a6f69","rgb":{"r":10,"g":111,"b":105},"luminance":66.31482224209003},{"name":"Tides of Darkness","hex":"#002400","rgb":{"r":0,"g":36,"b":0},"luminance":21.131999999999998},{"name":"Tiě Hēi Metal","hex":"#343450","rgb":{"r":52,"g":52,"b":80},"luminance":35.44896726281317},{"name":"Tiffany Amber","hex":"#b58141","rgb":{"r":181,"g":129,"b":65},"luminance":93.36887591697781},{"name":"Tiffany Blue","hex":"#7bf2da","rgb":{"r":123,"g":242,"b":218},"luminance":148.82710959028938},{"name":"Tiffany Rose","hex":"#d2a694","rgb":{"r":210,"g":166,"b":148},"luminance":117.14175962482379},{"name":"Tiger Cat","hex":"#cda035","rgb":{"r":205,"g":160,"b":53},"luminance":112.31451014450447},{"name":"Tiger Claw","hex":"#e1daca","rgb":{"r":225,"g":218,"b":202},"luminance":146.39505307557354},{"name":"Tiger Cub","hex":"#deae46","rgb":{"r":222,"g":174,"b":70},"luminance":122.07329899695509},{"name":"Tiger Moth","hex":"#f8f2dd","rgb":{"r":248,"g":242,"b":221},"luminance":162.211576824837},{"name":"Tiger Moth Orange","hex":"#dd6611","rgb":{"r":221,"g":102,"b":17},"luminance":89.19128859367376},{"name":"Tiger of Mysore","hex":"#ff8855","rgb":{"r":255,"g":136,"b":85},"luminance":110.81671511554562},{"name":"Tiger Tail","hex":"#fee9c4","rgb":{"r":254,"g":233,"b":196},"luminance":158.02960385003817},{"name":"Tiger's Eye","hex":"#977c61","rgb":{"r":151,"g":124,"b":97},"luminance":86.36437059922338},{"name":"Tigerlily","hex":"#e2583e","rgb":{"r":226,"g":88,"b":62},"luminance":85.34954268184453},{"name":"Tijolo","hex":"#aa5500","rgb":{"r":170,"g":85,"b":0},"luminance":71.22639907365807},{"name":"Tiki Hut","hex":"#8a6e45","rgb":{"r":138,"g":110,"b":69},"luminance":77.0305880803204},{"name":"Tiki Monster","hex":"#8fbc8f","rgb":{"r":143,"g":188,"b":143},"luminance":119.46699539621811},{"name":"Tiki Straw","hex":"#b9a37e","rgb":{"r":185,"g":163,"b":126},"luminance":111.44921481105195},{"name":"Tiki Torch","hex":"#bb9e3f","rgb":{"r":187,"g":158,"b":63},"luminance":108.53416609068316},{"name":"Tile Blue","hex":"#008491","rgb":{"r":0,"g":132,"b":145},"luminance":79.22759087590634},{"name":"Tile Red","hex":"#c76b4a","rgb":{"r":199,"g":107,"b":74},"luminance":86.92816331891522},{"name":"Tilla Kari Mosque","hex":"#00cccc","rgb":{"r":0,"g":204,"b":204},"luminance":121.98534764470689},{"name":"Tillandsia Purple","hex":"#563474","rgb":{"r":86,"g":52,"b":116},"luminance":42.045196491394826},{"name":"Tilted Red","hex":"#991122","rgb":{"r":153,"g":17,"b":34},"luminance":46.98288865108232},{"name":"Timber Beam","hex":"#a0855c","rgb":{"r":160,"g":133,"b":92},"luminance":92.16151466311737},{"name":"Timber Green","hex":"#324336","rgb":{"r":50,"g":67,"b":54},"luminance":42.522571382737425},{"name":"Timber Wolf","hex":"#8d8070","rgb":{"r":141,"g":128,"b":112},"luminance":87.09662221349345},{"name":"Timber Wolf White","hex":"#d9d6cf","rgb":{"r":217,"g":214,"b":207},"luminance":143.34068235152222},{"name":"Time Capsule","hex":"#a59888","rgb":{"r":165,"g":152,"b":136},"luminance":103.12729229937145},{"name":"Time Travel","hex":"#b3c4d5","rgb":{"r":179,"g":196,"b":213},"luminance":129.19394594562084},{"name":"Time Warp","hex":"#9397a3","rgb":{"r":147,"g":151,"b":163},"luminance":100.66615469958113},{"name":"Timeless","hex":"#b1d8db","rgb":{"r":177,"g":216,"b":219},"luminance":139.6436763659565},{"name":"Timeless Beauty","hex":"#b6273e","rgb":{"r":182,"g":39,"b":62},"luminance":59.45893370217801},{"name":"Timeless Lilac","hex":"#afb2c4","rgb":{"r":175,"g":178,"b":196},"luminance":118.97261935840531},{"name":"Times Square Screens","hex":"#20c073","rgb":{"r":32,"g":192,"b":115},"luminance":113.86663400663075},{"name":"Timid Beige","hex":"#e5e0dd","rgb":{"r":229,"g":224,"b":221},"luminance":150.37323439029964},{"name":"Timid Blue","hex":"#d9e0ee","rgb":{"r":217,"g":224,"b":238},"luminance":149.11419535711548},{"name":"Timid Cloud","hex":"#dcdde5","rgb":{"r":220,"g":221,"b":229},"luminance":147.77559394230158},{"name":"Timid Green","hex":"#e1e2d6","rgb":{"r":225,"g":226,"b":214},"luminance":150.73253359842394},{"name":"Timid Lime","hex":"#e4e0da","rgb":{"r":228,"g":224,"b":218},"luminance":150.18035035250116},{"name":"Timid Purple","hex":"#dfdfea","rgb":{"r":223,"g":223,"b":234},"luminance":149.3067416629269},{"name":"Timid Sea","hex":"#66a9b0","rgb":{"r":102,"g":169,"b":176},"luminance":105.70679878323816},{"name":"Timid Sheep","hex":"#e4e0dd","rgb":{"r":228,"g":224,"b":221},"luminance":150.23732347189895},{"name":"Tin","hex":"#919191","rgb":{"r":145,"g":145,"b":145},"luminance":96.94049798716736},{"name":"Tin Bitz","hex":"#48452b","rgb":{"r":72,"g":69,"b":43},"luminance":46.130005386949605},{"name":"Tin Lizzie","hex":"#928a98","rgb":{"r":146,"g":138,"b":152},"luminance":93.63708312415547},{"name":"Tin Man","hex":"#a4a298","rgb":{"r":164,"g":162,"b":152},"luminance":108.38661225446619},{"name":"Tin Soldier","hex":"#bebebe","rgb":{"r":190,"g":190,"b":190},"luminance":127.02548012111585},{"name":"Tinge Of Mauve","hex":"#d4c3cc","rgb":{"r":212,"g":195,"b":204},"luminance":132.8951327363045},{"name":"Tingle","hex":"#e6541b","rgb":{"r":230,"g":84,"b":27},"luminance":84.67624134313002},{"name":"Tinker Light","hex":"#fbedb8","rgb":{"r":251,"g":237,"b":184},"luminance":159.45670615562082},{"name":"Tinny Tin","hex":"#4b492d","rgb":{"r":75,"g":73,"b":45},"luminance":48.63543693645612},{"name":"Tinsel","hex":"#c3964d","rgb":{"r":195,"g":150,"b":77},"luminance":105.96852744565246},{"name":"Tint of Earth","hex":"#ce9480","rgb":{"r":206,"g":148,"b":128},"luminance":107.49040271577736},{"name":"Tint of Green","hex":"#dae9dc","rgb":{"r":218,"g":233,"b":220},"luminance":153.57084998462435},{"name":"Tint of Turquoise","hex":"#41bfb5","rgb":{"r":65,"g":191,"b":181},"luminance":115.64472694420614},{"name":"Tinted Ice","hex":"#cff6f4","rgb":{"r":207,"g":246,"b":244},"luminance":159.5506531136742},{"name":"Tinted Iris","hex":"#c4b7d8","rgb":{"r":196,"g":183,"b":216},"luminance":124.82003618409986},{"name":"Tinted Mint","hex":"#e3e7c4","rgb":{"r":227,"g":231,"b":196},"luminance":153.2727792988696},{"name":"Tinted Rosewood","hex":"#e1c8d1","rgb":{"r":225,"g":200,"b":209},"luminance":137.39128029463876},{"name":"Tiny Bubbles","hex":"#0088ab","rgb":{"r":0,"g":136,"b":171},"luminance":82.17763844258363},{"name":"Tiny Ribbons","hex":"#b98faf","rgb":{"r":185,"g":143,"b":175},"luminance":102.4882588690041},{"name":"Tip of the Iceberg","hex":"#bbe4ea","rgb":{"r":187,"g":228,"b":234},"luminance":147.47863384572014},{"name":"Tip Toes","hex":"#d8c2cd","rgb":{"r":216,"g":194,"b":205},"luminance":132.98664910433678},{"name":"Tiramisu","hex":"#634235","rgb":{"r":99,"g":66,"b":53},"luminance":49.1290904556557},{"name":"Tirisfal Lime","hex":"#75de2f","rgb":{"r":117,"g":222,"b":47},"luminance":135.0342810141188},{"name":"Tirol","hex":"#9e915c","rgb":{"r":158,"g":145,"b":92},"luminance":97.90999914717597},{"name":"Titan White","hex":"#ddd6e1","rgb":{"r":221,"g":214,"b":225},"luminance":144.23674519691573},{"name":"Titanium","hex":"#807d7f","rgb":{"r":128,"g":125,"b":127},"luminance":84.01338639169356},{"name":"Titanium Grey","hex":"#545b62","rgb":{"r":84,"g":91,"b":98},"luminance":60.07497756137741},{"name":"Titanium Yellow","hex":"#eee600","rgb":{"r":238,"g":230,"b":0},"luminance":152.61628466189313},{"name":"Titmouse Grey","hex":"#b8b2be","rgb":{"r":184,"g":178,"b":190},"luminance":120.05515420838873},{"name":"Tizzy","hex":"#f9f3df","rgb":{"r":249,"g":243,"b":223},"luminance":162.89777274720487},{"name":"Toad","hex":"#748d70","rgb":{"r":116,"g":141,"b":112},"luminance":90.64423847658493},{"name":"Toad King","hex":"#3d6c54","rgb":{"r":61,"g":108,"b":84},"luminance":66.65893573257826},{"name":"Toadstool","hex":"#b8282f","rgb":{"r":184,"g":40,"b":47},"luminance":60.056463598850044},{"name":"Toadstool Dot","hex":"#d7e7da","rgb":{"r":215,"g":231,"b":218},"luminance":152.10762485161615},{"name":"Toadstool Soup","hex":"#988088","rgb":{"r":152,"g":128,"b":136},"luminance":89.17013634620056},{"name":"Toast","hex":"#9f715f","rgb":{"r":159,"g":113,"b":95},"luminance":82.32397671395618},{"name":"Toast and Butter","hex":"#d2ad84","rgb":{"r":210,"g":173,"b":132},"luminance":120.33965267109589},{"name":"Toasted Almond","hex":"#dacfba","rgb":{"r":218,"g":207,"b":186},"luminance":139.5089238041782},{"name":"Toasted Coconut","hex":"#e9c2a1","rgb":{"r":233,"g":194,"b":161},"luminance":134.7536978676281},{"name":"Toasted Marshmallow","hex":"#efe0d4","rgb":{"r":239,"g":224,"b":212},"luminance":151.59109765748119},{"name":"Toasted Nut","hex":"#c08768","rgb":{"r":192,"g":135,"b":104},"luminance":98.5698393272506},{"name":"Toasted Oatmeal","hex":"#efdecc","rgb":{"r":239,"g":222,"b":204},"luminance":150.43023184519794},{"name":"Toasted Sesame","hex":"#af9a73","rgb":{"r":175,"g":154,"b":115},"luminance":105.26906539435029},{"name":"Toasted Truffle","hex":"#aa3344","rgb":{"r":170,"g":51,"b":68},"luminance":59.49795267906283},{"name":"Tobacco Brown","hex":"#6d5843","rgb":{"r":109,"g":88,"b":67},"luminance":61.553673009821274},{"name":"Tobacco Leaf","hex":"#8c724f","rgb":{"r":140,"g":114,"b":79},"luminance":79.44423427788827},{"name":"Tobago","hex":"#44362d","rgb":{"r":68,"g":54,"b":45},"luminance":38.00618802247865},{"name":"Tobermory","hex":"#d39898","rgb":{"r":211,"g":152,"b":152},"luminance":110.64087707985688},{"name":"Tobernite","hex":"#077a7d","rgb":{"r":7,"g":122,"b":125},"luminance":73.04798522204428},{"name":"Tobey Rattan","hex":"#ad785c","rgb":{"r":173,"g":120,"b":92},"luminance":88.019737973934},{"name":"Tobi Brown","hex":"#4c221b","rgb":{"r":76,"g":34,"b":27},"luminance":30.400263551489154},{"name":"Tobiko Orange","hex":"#e45c10","rgb":{"r":228,"g":92,"b":16},"luminance":86.98954291177762},{"name":"Toffee","hex":"#755139","rgb":{"r":117,"g":81,"b":57},"luminance":59.38645891110195},{"name":"Toffee Crunch","hex":"#995e39","rgb":{"r":153,"g":94,"b":57},"luminance":71.96960259026028},{"name":"Toffee Fingers","hex":"#968678","rgb":{"r":150,"g":134,"b":120},"luminance":91.57371819468729},{"name":"Toffee Tan","hex":"#c8a883","rgb":{"r":200,"g":168,"b":131},"luminance":116.29350717903385},{"name":"Tofino Belue","hex":"#03719c","rgb":{"r":3,"g":113,"b":156},"luminance":68.679522610455},{"name":"Tofu","hex":"#e8e3d9","rgb":{"r":232,"g":227,"b":217},"luminance":152.24711514179833},{"name":"Toki Brown","hex":"#b88884","rgb":{"r":184,"g":136,"b":132},"luminance":98.11396834294288},{"name":"Tokiwa Green","hex":"#007b43","rgb":{"r":0,"g":123,"b":67},"luminance":72.6038803715063},{"name":"Tokyo Underground","hex":"#ecf3d8","rgb":{"r":236,"g":243,"b":216},"luminance":161.03438872799808},{"name":"Tol Barad Green","hex":"#6c5846","rgb":{"r":108,"g":88,"b":70},"luminance":61.43936848633781},{"name":"Tol Barad Grey","hex":"#4e4851","rgb":{"r":78,"g":72,"b":81},"luminance":49.14700536146632},{"name":"Toledo","hex":"#3e2631","rgb":{"r":62,"g":38,"b":49},"luminance":29.536730963327678},{"name":"Toledo Cioio","hex":"#decbb1","rgb":{"r":222,"g":203,"b":177},"luminance":137.8859473949394},{"name":"Tolopea","hex":"#2d2541","rgb":{"r":45,"g":37,"b":65},"luminance":26.60188124926506},{"name":"Tom Thumb","hex":"#4f6348","rgb":{"r":79,"g":99,"b":72},"luminance":63.26486919294151},{"name":"Tomatillo Peel","hex":"#cad3c1","rgb":{"r":202,"g":211,"b":193},"luminance":139.54412512535237},{"name":"Tomatillo Salsa","hex":"#bbb085","rgb":{"r":187,"g":176,"b":133},"luminance":118.44627118233818},{"name":"Tomato","hex":"#ef4026","rgb":{"r":239,"g":64,"b":38},"luminance":80.85045064191046},{"name":"Tomato Cream","hex":"#c57644","rgb":{"r":197,"g":118,"b":68},"luminance":91.2547843622459},{"name":"Tomato Frog","hex":"#ff4444","rgb":{"r":255,"g":68,"b":68},"luminance":86.40995651543865},{"name":"Tomato Puree","hex":"#c53346","rgb":{"r":197,"g":51,"b":70},"luminance":66.55424688177307},{"name":"Tomato Red","hex":"#ec2d01","rgb":{"r":236,"g":45,"b":1},"luminance":75.34615661730862},{"name":"Tomato Sauce","hex":"#b21807","rgb":{"r":178,"g":24,"b":7},"luminance":55.06078306744284},{"name":"Tomb Blue","hex":"#0099cc","rgb":{"r":0,"g":153,"b":204},"luminance":92.77314943991068},{"name":"Tombstone Grey","hex":"#cec5b6","rgb":{"r":206,"g":197,"b":182},"luminance":132.65247325624952},{"name":"Tōmorokoshi Corn","hex":"#faa945","rgb":{"r":250,"g":169,"b":69},"luminance":124.46152684665249},{"name":"Tomorokoshi Yellow","hex":"#eec362","rgb":{"r":238,"g":195,"b":98},"luminance":135.24451949339758},{"name":"Tongue","hex":"#d1908e","rgb":{"r":209,"g":144,"b":142},"luminance":106.35863485867048},{"name":"Tonocha","hex":"#975437","rgb":{"r":151,"g":84,"b":55},"luminance":67.1492663027676},{"name":"Tonys Pink","hex":"#e79e88","rgb":{"r":231,"g":158,"b":136},"luminance":116.67356724211359},{"name":"Too Blue","hex":"#3d6695","rgb":{"r":61,"g":102,"b":149},"luminance":64.85430743597529},{"name":"Tōō Gold","hex":"#ffb61e","rgb":{"r":255,"g":182,"b":30},"luminance":131.295468242434},{"name":"Toolbox","hex":"#746cc0","rgb":{"r":116,"g":108,"b":192},"luminance":75.50574293389874},{"name":"Tootie Fruity","hex":"#f9dbe2","rgb":{"r":249,"g":219,"b":226},"luminance":150.77336935281375},{"name":"Top Hat Tan","hex":"#c1a393","rgb":{"r":193,"g":163,"b":147},"luminance":112.98576093473018},{"name":"Top Shelf","hex":"#82889c","rgb":{"r":130,"g":136,"b":156},"luminance":90.55548453848611},{"name":"Topaz","hex":"#d08344","rgb":{"r":208,"g":131,"b":68},"luminance":99.20225288268406},{"name":"Topaz Mountain","hex":"#92653f","rgb":{"r":146,"g":101,"b":63},"luminance":73.97432804020595},{"name":"Topiary","hex":"#8e9655","rgb":{"r":142,"g":150,"b":85},"luminance":98.23125960711285},{"name":"Topiary Garden","hex":"#6f7c00","rgb":{"r":111,"g":124,"b":0},"luminance":79.99751661770507},{"name":"Torch Light","hex":"#f69a54","rgb":{"r":246,"g":154,"b":84},"luminance":116.93455048017246},{"name":"Torch Red","hex":"#fd0d35","rgb":{"r":253,"g":13,"b":53},"luminance":76.2706138299673},{"name":"Torea Bay","hex":"#353d75","rgb":{"r":53,"g":61,"b":117},"luminance":41.36630152672583},{"name":"Toreador","hex":"#b61032","rgb":{"r":182,"g":16,"b":50},"luminance":55.515929137500706},{"name":"Tornado","hex":"#d1d3cf","rgb":{"r":209,"g":211,"b":207},"luminance":140.72152335019686},{"name":"Tornado Cloud","hex":"#5e5b60","rgb":{"r":94,"g":91,"b":96},"luminance":61.344064594710375},{"name":"Torrefacto Roast","hex":"#220044","rgb":{"r":34,"g":0,"b":68},"luminance":12.78440690841777},{"name":"Torrid Turquoise","hex":"#00938b","rgb":{"r":0,"g":147,"b":139},"luminance":87.73190546773733},{"name":"Tort","hex":"#5e8e91","rgb":{"r":94,"g":142,"b":145},"luminance":89.50462251749906},{"name":"Tortilla","hex":"#efdba7","rgb":{"r":239,"g":219,"b":167},"luminance":148.30709279734398},{"name":"Tortoise Shell","hex":"#754734","rgb":{"r":117,"g":71,"b":52},"luminance":54.73503267560913},{"name":"Tortuga","hex":"#84816f","rgb":{"r":132,"g":129,"b":111},"luminance":86.32392176563806},{"name":"Tory Blue","hex":"#374e88","rgb":{"r":55,"g":78,"b":136},"luminance":51.06045276924206},{"name":"Tosca","hex":"#744042","rgb":{"r":116,"g":64,"b":66},"luminance":51.681186673682326},{"name":"Toscana","hex":"#9f846b","rgb":{"r":159,"g":132,"b":107},"luminance":91.7208162905237},{"name":"Total Eclipse","hex":"#2c313d","rgb":{"r":44,"g":49,"b":61},"luminance":32.38438853830654},{"name":"Total Recall","hex":"#f6ead8","rgb":{"r":246,"g":234,"b":216},"luminance":157.7458476664283},{"name":"Totally Toffee","hex":"#dd9977","rgb":{"r":221,"g":153,"b":119},"luminance":112.32313349439642},{"name":"Totem Pole","hex":"#991b07","rgb":{"r":153,"g":27,"b":7},"luminance":48.42123102524346},{"name":"Touch of Blue","hex":"#c2d7e9","rgb":{"r":194,"g":215,"b":233},"luminance":141.414065442586},{"name":"Touch of Blush","hex":"#f6ded5","rgb":{"r":246,"g":222,"b":213},"luminance":151.59665245644445},{"name":"Touch of Lime","hex":"#e1e5d7","rgb":{"r":225,"g":229,"b":215},"luminance":152.30301590579222},{"name":"Touch of Mint","hex":"#f8fff8","rgb":{"r":248,"g":255,"b":248},"luminance":169.42084969979345},{"name":"Touch of Tan","hex":"#eed9d1","rgb":{"r":238,"g":217,"b":209},"luminance":147.8415305690522},{"name":"Touch of Turquoise","hex":"#a1d4cf","rgb":{"r":161,"g":212,"b":207},"luminance":135.5010629515503},{"name":"Touchable","hex":"#ecdfd8","rgb":{"r":236,"g":223,"b":216},"luminance":150.73384249398006},{"name":"Toupe","hex":"#c7ac7d","rgb":{"r":199,"g":172,"b":125},"luminance":118.0557529178481},{"name":"Tourmaline","hex":"#86a1a9","rgb":{"r":134,"g":161,"b":169},"luminance":104.44154422929603},{"name":"Tower Grey","hex":"#9caca5","rgb":{"r":156,"g":172,"b":165},"luminance":112.79719913189334},{"name":"Towering Cliffs","hex":"#897565","rgb":{"r":137,"g":117,"b":101},"luminance":80.79198355034985},{"name":"Townhouse Taupe","hex":"#bbb09b","rgb":{"r":187,"g":176,"b":155},"luminance":118.79335761312582},{"name":"Toxic Essence","hex":"#cceebb","rgb":{"r":204,"g":238,"b":187},"luminance":153.92444762285163},{"name":"Toxic Frog","hex":"#98fb98","rgb":{"r":152,"g":251,"b":152},"luminance":155.15789331194205},{"name":"Toxic Green","hex":"#61de2a","rgb":{"r":97,"g":222,"b":42},"luminance":133.5883136692727},{"name":"Toxic Latte","hex":"#e1f8e7","rgb":{"r":225,"g":248,"b":231},"luminance":162.51700513177073},{"name":"Toxic Orange","hex":"#ff6037","rgb":{"r":255,"g":96,"b":55},"luminance":95.01663448575728},{"name":"Toy Camouflage","hex":"#117700","rgb":{"r":17,"g":119,"b":0},"luminance":70.03769340862104},{"name":"Toy Submarine Blue","hex":"#005280","rgb":{"r":0,"g":82,"b":128},"luminance":50.297200916154374},{"name":"Toy Tank Green","hex":"#6d6f4f","rgb":{"r":109,"g":111,"b":79},"luminance":73.40787400544986},{"name":"Track and Field","hex":"#dd1111","rgb":{"r":221,"g":17,"b":17},"luminance":66.85634245155802},{"name":"Tractor Beam","hex":"#00bffe","rgb":{"r":0,"g":191,"b":254},"luminance":115.79581868530487},{"name":"Tractor Red","hex":"#fd0f35","rgb":{"r":253,"g":15,"b":53},"luminance":76.39700516381515},{"name":"Trade Secret","hex":"#6a7978","rgb":{"r":106,"g":121,"b":120},"luminance":78.97143005543207},{"name":"Trade Winds","hex":"#e6e3d6","rgb":{"r":230,"g":227,"b":214},"luminance":151.92028737795357},{"name":"Tradewind","hex":"#6dafa7","rgb":{"r":109,"g":175,"b":167},"luminance":109.43968361613624},{"name":"Tradewinds","hex":"#7e8692","rgb":{"r":126,"g":134,"b":146},"luminance":88.7887041013664},{"name":"Trading Post","hex":"#bb8d3b","rgb":{"r":187,"g":141,"b":59},"luminance":100.10933489939886},{"name":"Traditional Rose","hex":"#be013c","rgb":{"r":190,"g":1,"b":60},"luminance":57.22330180092721},{"name":"Traditional Royal Blue","hex":"#0504aa","rgb":{"r":5,"g":4,"b":170},"luminance":19.578879666620356},{"name":"Trail Dust","hex":"#d0c4ac","rgb":{"r":208,"g":196,"b":172},"luminance":132.24704621276044},{"name":"Trail Sand","hex":"#bfaa97","rgb":{"r":191,"g":170,"b":151},"luminance":116.25748912220666},{"name":"Trailblazer","hex":"#c0b28e","rgb":{"r":192,"g":178,"b":142},"luminance":120.31231858791517},{"name":"Trailing Vine","hex":"#cfd5a7","rgb":{"r":207,"g":213,"b":167},"luminance":140.80461588314498},{"name":"Trance","hex":"#8f97a5","rgb":{"r":143,"g":151,"b":165},"luminance":100.19228971333074},{"name":"Tranquil","hex":"#ddede9","rgb":{"r":221,"g":237,"b":233},"luminance":156.28842006367586},{"name":"Tranquil Bay","hex":"#74b8de","rgb":{"r":116,"g":184,"b":222},"luminance":116.22909611624793},{"name":"Tranquil Eve","hex":"#ece7f2","rgb":{"r":236,"g":231,"b":242},"luminance":155.32843348530878},{"name":"Tranquil Green","hex":"#a4af9e","rgb":{"r":164,"g":175,"b":158},"luminance":115.24490038609083},{"name":"Tranquil Peach","hex":"#fce2d7","rgb":{"r":252,"g":226,"b":215},"luminance":154.5227085188452},{"name":"Tranquil Pool","hex":"#88ddff","rgb":{"r":136,"g":221,"b":255},"luminance":139.02417172923563},{"name":"Tranquil Sea","hex":"#d2d2df","rgb":{"r":210,"g":210,"b":223},"luminance":140.65687002062856},{"name":"Tranquil Seashore","hex":"#629091","rgb":{"r":98,"g":144,"b":145},"luminance":90.97708990729478},{"name":"Tranquil Taupe","hex":"#b0a596","rgb":{"r":176,"g":165,"b":150},"luminance":111.54634194360655},{"name":"Tranquil Teal","hex":"#8ac7bb","rgb":{"r":138,"g":199,"b":187},"luminance":125.70714672205393},{"name":"Tranquility","hex":"#8e9b96","rgb":{"r":142,"g":155,"b":150},"luminance":101.84970294016571},{"name":"Transcend","hex":"#c3ac98","rgb":{"r":195,"g":172,"b":152},"luminance":117.87053026520242},{"name":"Transformer","hex":"#a5acb7","rgb":{"r":165,"g":172,"b":183},"luminance":114.2930206311829},{"name":"Translucent Silk","hex":"#ffe9e1","rgb":{"r":255,"g":233,"b":225},"luminance":158.6742857743497},{"name":"Translucent Vision","hex":"#e5efd7","rgb":{"r":229,"g":239,"b":215},"luminance":158.0226053132905},{"name":"Transparent Beige","hex":"#f4ecc2","rgb":{"r":244,"g":236,"b":194},"luminance":158.12277007439502},{"name":"Transparent Blue","hex":"#ddddff","rgb":{"r":221,"g":221,"b":255},"luminance":148.46074791001155},{"name":"Transparent Green","hex":"#ddffdd","rgb":{"r":221,"g":255,"b":221},"luminance":165.54990517061617},{"name":"Transparent Orange","hex":"#ffaa66","rgb":{"r":255,"g":170,"b":102},"luminance":126.1211897699986},{"name":"Transparent Pink","hex":"#ffddee","rgb":{"r":255,"g":221,"b":238},"luminance":152.90042504192064},{"name":"Transparent Yellow","hex":"#ffeeaa","rgb":{"r":255,"g":238,"b":170},"luminance":160.3329375424775},{"name":"Transtasman","hex":"#307d67","rgb":{"r":48,"g":125,"b":103},"luminance":75.68186766326528},{"name":"Travertine","hex":"#e2ddc7","rgb":{"r":226,"g":221,"b":199},"luminance":148.02025064497087},{"name":"Treasure Casket","hex":"#9b7856","rgb":{"r":155,"g":120,"b":86},"luminance":84.88681311605473},{"name":"Treasure Chest","hex":"#726854","rgb":{"r":114,"g":104,"b":84},"luminance":70.57204457857233},{"name":"Treasure Island","hex":"#47493b","rgb":{"r":71,"g":73,"b":59},"luminance":48.29200470057129},{"name":"Treasure Isle","hex":"#609d91","rgb":{"r":96,"g":157,"b":145},"luminance":97.93080106381238},{"name":"Treasure Seeker","hex":"#3f363d","rgb":{"r":63,"g":54,"b":61},"luminance":37.52271164241731},{"name":"Tree Frog","hex":"#9fb32e","rgb":{"r":159,"g":179,"b":46},"luminance":115.44687759311638},{"name":"Tree Frog Green","hex":"#7ca14e","rgb":{"r":124,"g":161,"b":78},"luminance":101.90814731413774},{"name":"Tree Green","hex":"#2a7e19","rgb":{"r":42,"g":126,"b":25},"luminance":75.07465156762301},{"name":"Tree House","hex":"#3b2820","rgb":{"r":59,"g":40,"b":32},"luminance":29.594310010540873},{"name":"Tree Lined","hex":"#8ea597","rgb":{"r":142,"g":165,"b":151},"luminance":107.14426995878034},{"name":"Tree Moss","hex":"#dcdbca","rgb":{"r":220,"g":219,"b":202},"luminance":146.22985670853953},{"name":"Tree of Life","hex":"#595d45","rgb":{"r":89,"g":93,"b":69},"luminance":61.23884843789928},{"name":"Tree Palm","hex":"#7faa4b","rgb":{"r":127,"g":170,"b":75},"luminance":107.11253581630864},{"name":"Tree Peony","hex":"#a4345d","rgb":{"r":164,"g":52,"b":93},"luminance":58.7251758277487},{"name":"Tree Poppy","hex":"#e2813b","rgb":{"r":226,"g":129,"b":59},"luminance":101.71262105068378},{"name":"Tree Pose","hex":"#bdc7bc","rgb":{"r":189,"g":199,"b":188},"luminance":131.52224417945428},{"name":"Tree Sap","hex":"#cc7711","rgb":{"r":204,"g":119,"b":17},"luminance":92.75618291521054},{"name":"Tree Shade","hex":"#476a30","rgb":{"r":71,"g":106,"b":48},"luminance":65.97113390718701},{"name":"Treeless","hex":"#d1b7a7","rgb":{"r":209,"g":183,"b":167},"luminance":125.72526303810226},{"name":"Treetop","hex":"#91b6ac","rgb":{"r":145,"g":182,"b":172},"luminance":116.95141403591492},{"name":"Trefoil","hex":"#47562f","rgb":{"r":71,"g":86,"b":47},"luminance":55.025547966376486},{"name":"Trekking Green","hex":"#355048","rgb":{"r":53,"g":80,"b":72},"luminance":50.23684178966667},{"name":"Trellis","hex":"#eaefe5","rgb":{"r":234,"g":239,"b":229},"luminance":158.93045724781638},{"name":"Trellised Ivy","hex":"#9aa097","rgb":{"r":154,"g":160,"b":151},"luminance":106.00718047377732},{"name":"Trendy Green","hex":"#7e8424","rgb":{"r":126,"g":132,"b":36},"luminance":86.25510621406711},{"name":"Trendy Pink","hex":"#805d80","rgb":{"r":128,"g":93,"b":128},"luminance":68.24844122029455},{"name":"Trevi Fountain","hex":"#c2dfe2","rgb":{"r":194,"g":223,"b":226},"luminance":145.4769793919299},{"name":"Tri-Tip","hex":"#f2d1c4","rgb":{"r":242,"g":209,"b":196},"luminance":144.1736903495225},{"name":"Triamble","hex":"#94a089","rgb":{"r":148,"g":160,"b":137},"luminance":104.99108451673408},{"name":"Triassic","hex":"#67422d","rgb":{"r":103,"g":66,"b":45},"luminance":49.75655407079553},{"name":"Tribal","hex":"#807943","rgb":{"r":128,"g":121,"b":67},"luminance":81.04270329277028},{"name":"Tricycle Taupe","hex":"#b09994","rgb":{"r":176,"g":153,"b":148},"luminance":105.4512469390476},{"name":"Tried & True Blue","hex":"#494f62","rgb":{"r":73,"g":79,"b":98},"luminance":52.45652144395394},{"name":"Triforce Shine","hex":"#f5f5da","rgb":{"r":245,"g":245,"b":218},"luminance":163.29932992514085},{"name":"Triforce Yellow","hex":"#f0f00f","rgb":{"r":240,"g":240,"b":15},"luminance":158.1126057593132},{"name":"Trim","hex":"#756d44","rgb":{"r":117,"g":109,"b":68},"luminance":73.33299449770206},{"name":"Trinidad","hex":"#c54f33","rgb":{"r":197,"g":79,"b":51},"luminance":75.19189540103375},{"name":"Trinity Islands","hex":"#b9b79b","rgb":{"r":185,"g":183,"b":155},"luminance":122.11162666183756},{"name":"Trinket Box","hex":"#7e633f","rgb":{"r":126,"g":99,"b":63},"luminance":69.62781174932901},{"name":"Tripoli White","hex":"#e5e3e5","rgb":{"r":229,"g":227,"b":229},"luminance":152.0693824476183},{"name":"Trippy Velvet","hex":"#cc00ee","rgb":{"r":204,"g":0,"b":238},"luminance":66.75820129392342},{"name":"Tristesse","hex":"#0c0c1f","rgb":{"r":12,"g":12,"b":31},"luminance":8.659147533100473},{"name":"Trite White","hex":"#f4f0e3","rgb":{"r":244,"g":240,"b":227},"luminance":160.74645632174912},{"name":"Trixter","hex":"#705676","rgb":{"r":112,"g":86,"b":118},"luminance":62.055094649835155},{"name":"Trojan Horse Brown","hex":"#775020","rgb":{"r":119,"g":80,"b":32},"luminance":59.03013692174531},{"name":"Troll Slayer Orange","hex":"#f4a34c","rgb":{"r":244,"g":163,"b":76},"luminance":120.63372908519408},{"name":"Trolley Grey","hex":"#818181","rgb":{"r":129,"g":129,"b":129},"luminance":86.24361545065234},{"name":"Trooper","hex":"#697a7e","rgb":{"r":105,"g":122,"b":126},"luminance":79.50179568412275},{"name":"Tropic Canary","hex":"#bcc23c","rgb":{"r":188,"g":194,"b":60},"luminance":127.1800826702043},{"name":"Tropic Tide","hex":"#6cc1bb","rgb":{"r":108,"g":193,"b":187},"luminance":119.71666997122831},{"name":"Tropical Blue","hex":"#aec9eb","rgb":{"r":174,"g":201,"b":235},"luminance":131.7017120048179},{"name":"Tropical Breeze","hex":"#ebedee","rgb":{"r":235,"g":237,"b":238},"luminance":158.20054301423875},{"name":"Tropical Cascade","hex":"#8ca8a0","rgb":{"r":140,"g":168,"b":160},"luminance":108.67415817939423},{"name":"Tropical Dream","hex":"#d9eae5","rgb":{"r":217,"g":234,"b":229},"luminance":154.13807799826753},{"name":"Tropical Fog","hex":"#cbcab6","rgb":{"r":203,"g":202,"b":182},"luminance":134.81245784051265},{"name":"Tropical Forest","hex":"#024a43","rgb":{"r":2,"g":74,"b":67},"luminance":44.1084628161082},{"name":"Tropical Forest Green","hex":"#228b21","rgb":{"r":34,"g":139,"b":33},"luminance":82.309889132473},{"name":"Tropical Freeze","hex":"#99ddcc","rgb":{"r":153,"g":221,"b":204},"luminance":139.50886736691686},{"name":"Tropical Green","hex":"#17806d","rgb":{"r":23,"g":128,"b":109},"luminance":76.4664442811355},{"name":"Tropical Holiday","hex":"#8fcdc7","rgb":{"r":143,"g":205,"b":199},"luminance":129.70477196310088},{"name":"Tropical Kelp","hex":"#009d7d","rgb":{"r":0,"g":157,"b":125},"luminance":93.25418908016947},{"name":"Tropical Lagoon","hex":"#1e98ae","rgb":{"r":30,"g":152,"b":174},"luminance":91.84143929621311},{"name":"Tropical Light","hex":"#9cd572","rgb":{"r":156,"g":213,"b":114},"luminance":134.07949027722321},{"name":"Tropical Moss","hex":"#d2c478","rgb":{"r":210,"g":196,"b":120},"luminance":131.78273484793067},{"name":"Tropical Orchid","hex":"#a0828a","rgb":{"r":160,"g":130,"b":138},"luminance":91.4296315425147},{"name":"Tropical Peach","hex":"#ffc4b2","rgb":{"r":255,"g":196,"b":178},"luminance":139.50637258921185},{"name":"Tropical Rainforest","hex":"#00755e","rgb":{"r":0,"g":117,"b":94},"luminance":69.50998271471516},{"name":"Tropical Siesta","hex":"#ddc073","rgb":{"r":221,"g":192,"b":115},"luminance":131.3030767232817},{"name":"Tropical Splash","hex":"#70cbce","rgb":{"r":112,"g":203,"b":206},"luminance":125.98527025410549},{"name":"Tropical Tale","hex":"#e0deb8","rgb":{"r":224,"g":222,"b":184},"luminance":148.01187705045837},{"name":"Tropical Teal","hex":"#008794","rgb":{"r":0,"g":135,"b":148},"luminance":81.0211972819459},{"name":"Tropical Tide","hex":"#5ecaae","rgb":{"r":94,"g":202,"b":174},"luminance":123.4633856979469},{"name":"Tropical Tree","hex":"#20aea7","rgb":{"r":32,"g":174,"b":167},"luminance":104.33677737020633},{"name":"Tropical Violet","hex":"#cda5df","rgb":{"r":205,"g":165,"b":223},"luminance":117.40632919055086},{"name":"Tropical Waterfall","hex":"#bee7e2","rgb":{"r":190,"g":231,"b":226},"luminance":149.25718141851667},{"name":"Tropical Wood","hex":"#ba8f68","rgb":{"r":186,"g":143,"b":104},"luminance":101.38823015024968},{"name":"Tropicana","hex":"#447700","rgb":{"r":68,"g":119,"b":0},"luminance":72.75185106236128},{"name":"Trough Shell","hex":"#726d40","rgb":{"r":114,"g":109,"b":64},"luminance":72.86227625458869},{"name":"Trough Shell Brown","hex":"#918754","rgb":{"r":145,"g":135,"b":84},"luminance":90.8357078796659},{"name":"Trout","hex":"#4c5356","rgb":{"r":76,"g":83,"b":86},"luminance":54.64644940890487},{"name":"True Blonde","hex":"#dcc49b","rgb":{"r":220,"g":196,"b":155},"luminance":133.70190725640379},{"name":"True Blue","hex":"#010fcc","rgb":{"r":1,"g":15,"b":204},"luminance":24.86883515567225},{"name":"True Crimson","hex":"#a22042","rgb":{"r":162,"g":32,"b":66},"luminance":52.494657594844824},{"name":"True Green","hex":"#089404","rgb":{"r":8,"g":148,"b":4},"luminance":86.91012010117117},{"name":"True Khaki","hex":"#b8ae98","rgb":{"r":184,"g":174,"b":152},"luminance":117.29957750989557},{"name":"True Love","hex":"#e27e8a","rgb":{"r":226,"g":126,"b":138},"luminance":101.41064413561328},{"name":"True Navy","hex":"#3f5277","rgb":{"r":63,"g":82,"b":119},"luminance":53.43922605165611},{"name":"True Purple","hex":"#65318e","rgb":{"r":101,"g":49,"b":142},"luminance":44.736351147584664},{"name":"True Red","hex":"#bf1932","rgb":{"r":191,"g":25,"b":50},"luminance":59.239205818444255},{"name":"True To You","hex":"#cdd3a3","rgb":{"r":205,"g":211,"b":163},"luminance":139.4378865229963},{"name":"True V","hex":"#8e72c7","rgb":{"r":142,"g":114,"b":199},"luminance":82.43394376105027},{"name":"Truesky Gloxym","hex":"#99bbff","rgb":{"r":153,"g":187,"b":255},"luminance":122.42175570543006},{"name":"Trump Tan","hex":"#faa76c","rgb":{"r":250,"g":167,"b":108},"luminance":123.89040594412465},{"name":"Trumpet","hex":"#867e85","rgb":{"r":134,"g":126,"b":133},"luminance":85.47249875837255},{"name":"Trumpet Teal","hex":"#5a7d7a","rgb":{"r":90,"g":125,"b":122},"luminance":79.38180641053718},{"name":"Trumpeter","hex":"#907baa","rgb":{"r":144,"g":123,"b":170},"luminance":86.26927574171467},{"name":"Trunks Hair","hex":"#9b5fc0","rgb":{"r":155,"g":95,"b":192},"luminance":75.74086607637913},{"name":"Trusted Purple","hex":"#6600cc","rgb":{"r":102,"g":0,"b":204},"luminance":38.35322072525331},{"name":"Trustee","hex":"#527498","rgb":{"r":82,"g":116,"b":152},"luminance":74.41715106076019},{"name":"Truth","hex":"#344989","rgb":{"r":52,"g":73,"b":137},"luminance":48.18579073751929},{"name":"Tsar","hex":"#8b7f7b","rgb":{"r":139,"g":127,"b":123},"luminance":86.49558720535978},{"name":"Tsarina","hex":"#d1b4c6","rgb":{"r":209,"g":180,"b":198},"luminance":124.81448579792331},{"name":"Tsunami","hex":"#869baf","rgb":{"r":134,"g":155,"b":175},"luminance":101.39801320045675},{"name":"Tsurubami Green","hex":"#9ba88d","rgb":{"r":155,"g":168,"b":141},"luminance":110.142398543885},{"name":"Tǔ Hēi Black","hex":"#574d35","rgb":{"r":87,"g":77,"b":53},"luminance":52.49887174025743},{"name":"Tuatara","hex":"#454642","rgb":{"r":69,"g":70,"b":66},"luminance":46.59009376466203},{"name":"Tuberose","hex":"#fffaec","rgb":{"r":255,"g":250,"b":236},"luminance":167.5490606986503},{"name":"Tudor Tan","hex":"#b68960","rgb":{"r":182,"g":137,"b":96},"luminance":97.71543082338631},{"name":"Tuffet","hex":"#a59788","rgb":{"r":165,"g":151,"b":136},"luminance":102.61985192934162},{"name":"Tuft","hex":"#cbc2ad","rgb":{"r":203,"g":194,"b":173},"luminance":130.54226126814257},{"name":"Tuft Bush","hex":"#f9d3be","rgb":{"r":249,"g":211,"b":190},"luminance":146.1255058160621},{"name":"Tufts Blue","hex":"#417dc1","rgb":{"r":65,"g":125,"b":193},"luminance":79.0297276599129},{"name":"Tuğçe Silver","hex":"#ccddee","rgb":{"r":204,"g":221,"b":238},"luminance":145.89637407763087},{"name":"Tuk Tuk","hex":"#573b2a","rgb":{"r":87,"g":59,"b":42},"luminance":43.57804265911905},{"name":"Tulip","hex":"#ff878d","rgb":{"r":255,"g":135,"b":141},"luminance":111.13704839521337},{"name":"Tulip Petals","hex":"#fbf4da","rgb":{"r":251,"g":244,"b":218},"luminance":163.59778204181129},{"name":"Tulip Tree","hex":"#e3ac3d","rgb":{"r":227,"g":172,"b":61},"luminance":121.85578172987935},{"name":"Tulipwood","hex":"#805466","rgb":{"r":128,"g":84,"b":102},"luminance":63.49200919800853},{"name":"Tumbleweed","hex":"#deaa88","rgb":{"r":222,"g":170,"b":136},"luminance":120.848901525831},{"name":"Tumbling Tumbleweed","hex":"#cebf9c","rgb":{"r":206,"g":191,"b":156},"luminance":129.15228678192267},{"name":"Tuna","hex":"#46494e","rgb":{"r":70,"g":73,"b":78},"luminance":48.511243696693654},{"name":"Tuna Sashimi","hex":"#cf6275","rgb":{"r":207,"g":98,"b":117},"luminance":85.54464547240815},{"name":"Tundora","hex":"#585452","rgb":{"r":88,"g":84,"b":82},"luminance":56.66555666363827},{"name":"Tundra Frost","hex":"#e1e1db","rgb":{"r":225,"g":225,"b":219},"luminance":150.30978812439326},{"name":"Tungsten","hex":"#b5ac9f","rgb":{"r":181,"g":172,"b":159},"luminance":115.97908144575038},{"name":"Tunisian Stone","hex":"#ffddb5","rgb":{"r":255,"g":221,"b":181},"luminance":151.88204801753233},{"name":"Tupelo Honey","hex":"#c0a04d","rgb":{"r":192,"g":160,"b":77},"luminance":110.42507934341727},{"name":"Turbinado Sugar","hex":"#f9bb59","rgb":{"r":249,"g":187,"b":89},"luminance":133.0230283747893},{"name":"Turbo","hex":"#f5cc23","rgb":{"r":245,"g":204,"b":35},"luminance":140.43432140684126},{"name":"Turbulence","hex":"#4e545b","rgb":{"r":78,"g":84,"b":91},"luminance":55.52309811240724},{"name":"Turbulent Sea","hex":"#536a79","rgb":{"r":83,"g":106,"b":121},"luminance":68.39397056027671},{"name":"Turf","hex":"#5f4f42","rgb":{"r":95,"g":79,"b":66},"luminance":54.899086786575964},{"name":"Turf Green","hex":"#6f8c69","rgb":{"r":111,"g":140,"b":105},"luminance":89.4334558261057},{"name":"Turkish Aqua","hex":"#006169","rgb":{"r":0,"g":97,"b":105},"luminance":58.183594088024506},{"name":"Turkish Bath","hex":"#bb937b","rgb":{"r":187,"g":147,"b":123},"luminance":103.77221002754061},{"name":"Turkish Coffee","hex":"#483f39","rgb":{"r":72,"g":63,"b":57},"luminance":43.281325638201054},{"name":"Turkish Jade","hex":"#2b888d","rgb":{"r":43,"g":136,"b":141},"luminance":82.44285383827999},{"name":"Turkish Rose","hex":"#a56e75","rgb":{"r":165,"g":110,"b":117},"luminance":82.34761301337154},{"name":"Turkish Sea","hex":"#195190","rgb":{"r":25,"g":81,"b":144},"luminance":50.8534943735433},{"name":"Turkish Stone","hex":"#2f7a92","rgb":{"r":47,"g":122,"b":146},"luminance":74.85368755779503},{"name":"Turkish Tile","hex":"#00698b","rgb":{"r":0,"g":105,"b":139},"luminance":63.63936628377124},{"name":"Turkish Turquoise","hex":"#77dde7","rgb":{"r":119,"g":221,"b":231},"luminance":137.07144723099702},{"name":"Turmeric","hex":"#ae9041","rgb":{"r":174,"g":144,"b":65},"luminance":99.53188212829093},{"name":"Turmeric Root","hex":"#feae0d","rgb":{"r":254,"g":174,"b":13},"luminance":127.2877145839299},{"name":"Turmeric Tea","hex":"#d88e2d","rgb":{"r":216,"g":142,"b":45},"luminance":105.571299471021},{"name":"Turned Leaf","hex":"#8d7448","rgb":{"r":141,"g":116,"b":72},"luminance":80.5063538424142},{"name":"Turner's Light","hex":"#93bcbb","rgb":{"r":147,"g":188,"b":187},"luminance":120.68458919431262},{"name":"Turner's Yellow","hex":"#e6c26f","rgb":{"r":230,"g":194,"b":111},"luminance":133.6324642442846},{"name":"Turning Oakleaf","hex":"#ede1a8","rgb":{"r":237,"g":225,"b":168},"luminance":151.1031750096602},{"name":"Turquesa","hex":"#448899","rgb":{"r":68,"g":136,"b":153},"luminance":84.20666132794958},{"name":"Turquoise","hex":"#06c2ac","rgb":{"r":6,"g":194,"b":172},"luminance":115.56769005219408},{"name":"Turquoise Blue","hex":"#00ffef","rgb":{"r":0,"g":255,"b":239},"luminance":152.14448311062745},{"name":"Turquoise Chalk","hex":"#6fe7db","rgb":{"r":111,"g":231,"b":219},"luminance":141.81451719058947},{"name":"Turquoise Cyan","hex":"#0e7c61","rgb":{"r":14,"g":124,"b":97},"luminance":73.74208367004555},{"name":"Turquoise Green","hex":"#04f489","rgb":{"r":4,"g":244,"b":137},"luminance":144.0819639094359},{"name":"Turquoise Panic","hex":"#30d5c8","rgb":{"r":48,"g":213,"b":200},"luminance":127.90062886866505},{"name":"Turquoise Sea","hex":"#6cdae7","rgb":{"r":108,"g":218,"b":231},"luminance":134.5791587728204},{"name":"Turquoise Surf","hex":"#00c5cd","rgb":{"r":0,"g":197,"b":205},"luminance":117.97684188432913},{"name":"Turquoise Topaz","hex":"#13bbaf","rgb":{"r":19,"g":187,"b":175},"luminance":111.7117255349679},{"name":"Turtle Bay","hex":"#84897f","rgb":{"r":132,"g":137,"b":127},"luminance":90.74442720630286},{"name":"Turtle Chalk","hex":"#ced8c1","rgb":{"r":206,"g":216,"b":193},"luminance":142.66786640305517},{"name":"Turtle Green","hex":"#75b84f","rgb":{"r":117,"g":184,"b":79},"luminance":113.88874566435437},{"name":"Turtle Lake","hex":"#73b7a5","rgb":{"r":115,"g":183,"b":165},"luminance":114.34778338909766},{"name":"Turtle Moss","hex":"#939717","rgb":{"r":147,"g":151,"b":23},"luminance":98.97100010609168},{"name":"Turtle Skin","hex":"#363e1d","rgb":{"r":54,"g":62,"b":29},"luminance":39.95179830746045},{"name":"Turtle Trail","hex":"#b6b5a0","rgb":{"r":182,"g":181,"b":160},"luminance":120.7577795961817},{"name":"Turtledove","hex":"#ded7c8","rgb":{"r":222,"g":215,"b":200},"luminance":144.40768992335555},{"name":"Tuscan","hex":"#fbd5a6","rgb":{"r":251,"g":213,"b":166},"luminance":147.0483632618874},{"name":"Tuscan Bread","hex":"#e7d2ad","rgb":{"r":231,"g":210,"b":173},"luminance":142.6708692936298},{"name":"Tuscan Brown","hex":"#6f4c37","rgb":{"r":111,"g":76,"b":55},"luminance":55.95581439850554},{"name":"Tuscan Clay","hex":"#aa5e5a","rgb":{"r":170,"g":94,"b":90},"luminance":75.72032873674017},{"name":"Tuscan Image","hex":"#dc938c","rgb":{"r":220,"g":147,"b":140},"luminance":109.67005754078914},{"name":"Tuscan Mosaic","hex":"#a08d71","rgb":{"r":160,"g":141,"b":113},"luminance":96.46236474916006},{"name":"Tuscan Olive","hex":"#5d583e","rgb":{"r":93,"g":88,"b":62},"luminance":59.089154749412344},{"name":"Tuscan Red","hex":"#7c4848","rgb":{"r":124,"g":72,"b":72},"luminance":56.81766218351473},{"name":"Tuscan Soil","hex":"#a67b5b","rgb":{"r":166,"g":123,"b":91},"luminance":88.22776339112309},{"name":"Tuscan Sun","hex":"#ffd84d","rgb":{"r":255,"g":216,"b":77},"luminance":148.21121608366892},{"name":"Tuscan Sunset","hex":"#bb7c3f","rgb":{"r":187,"g":124,"b":63},"luminance":92.06485560190707},{"name":"Tuscany","hex":"#be9785","rgb":{"r":190,"g":151,"b":133},"luminance":106.36625457822608},{"name":"Tusi Grey","hex":"#9996b3","rgb":{"r":153,"g":150,"b":179},"luminance":101.30150712106904},{"name":"Tusk","hex":"#e3e5b1","rgb":{"r":227,"g":229,"b":177},"luminance":151.9323492282009},{"name":"Tuskgor Fur","hex":"#883636","rgb":{"r":136,"g":54,"b":54},"luminance":51.92514261896639},{"name":"Tussock","hex":"#bf914b","rgb":{"r":191,"g":145,"b":75},"luminance":102.85476948591153},{"name":"Tutu","hex":"#f8e4e3","rgb":{"r":248,"g":228,"b":227},"luminance":155.17817141595654},{"name":"Tutuji Pink","hex":"#e95295","rgb":{"r":233,"g":82,"b":149},"luminance":86.36490630458648},{"name":"Tweed","hex":"#937b56","rgb":{"r":147,"g":123,"b":86},"luminance":85.09388359923408},{"name":"Tweety","hex":"#ffef00","rgb":{"r":255,"g":239,"b":0},"luminance":159.67287144032952},{"name":"Twig Basket","hex":"#77623a","rgb":{"r":119,"g":98,"b":58},"luminance":67.96298096022569},{"name":"Twilight","hex":"#4e518b","rgb":{"r":78,"g":81,"b":139},"luminance":55.2786451443955},{"name":"Twilight Blue","hex":"#0a437a","rgb":{"r":10,"g":67,"b":122},"luminance":41.82275463189865},{"name":"Twilight Lavender","hex":"#8a496b","rgb":{"r":138,"g":73,"b":107},"luminance":60.725217570627116},{"name":"Twilight Light","hex":"#dac0cd","rgb":{"r":218,"g":192,"b":205},"luminance":132.27638353084802},{"name":"Twilight Mauve","hex":"#8b6f70","rgb":{"r":139,"g":111,"b":112},"luminance":78.33117638590653},{"name":"Twilight Purple","hex":"#66648b","rgb":{"r":102,"g":100,"b":139},"luminance":68.02142103778779},{"name":"Twilight Stroll","hex":"#71898d","rgb":{"r":113,"g":137,"b":141},"luminance":88.6969582680263},{"name":"Twilight Taupe","hex":"#a79994","rgb":{"r":167,"g":153,"b":148},"luminance":104.13445440390994},{"name":"Twilight Twinkle","hex":"#7b85c6","rgb":{"r":123,"g":133,"b":198},"luminance":89.20271270538805},{"name":"Twilight Twist","hex":"#e5e6d7","rgb":{"r":229,"g":230,"b":215},"luminance":153.35161571043193},{"name":"Twill","hex":"#a79b82","rgb":{"r":167,"g":155,"b":130},"luminance":104.83895799749251},{"name":"Twin Cities","hex":"#a4c7c8","rgb":{"r":164,"g":199,"b":200},"luminance":128.72313803275617},{"name":"Twine","hex":"#c19156","rgb":{"r":193,"g":145,"b":86},"luminance":103.2994651002608},{"name":"Twinkle","hex":"#adc6d3","rgb":{"r":173,"g":198,"b":211},"luminance":129.4710798634197},{"name":"Twinkle Blue","hex":"#d0d7df","rgb":{"r":208,"g":215,"b":223},"luminance":142.97491029198093},{"name":"Twinkle Little Star","hex":"#fce79a","rgb":{"r":252,"g":231,"b":154},"luminance":156.1156002742839},{"name":"Twinkle Toes","hex":"#e2d39b","rgb":{"r":226,"g":211,"b":155},"luminance":142.19363848288012},{"name":"Twinkle Twinkle","hex":"#fcf0c5","rgb":{"r":252,"g":240,"b":197},"luminance":161.33461274010608},{"name":"Twinkling Lights","hex":"#fffac1","rgb":{"r":255,"g":250,"b":193},"luminance":166.8321028129778},{"name":"Twist of Lime","hex":"#4e632c","rgb":{"r":78,"g":99,"b":44},"luminance":62.818760804396646},{"name":"Twisted Blue","hex":"#76c4d1","rgb":{"r":118,"g":196,"b":209},"luminance":122.67624262260398},{"name":"Twisted Tail","hex":"#9a845e","rgb":{"r":154,"g":132,"b":94},"luminance":90.76803968358026},{"name":"Twisted Time","hex":"#7f6c6e","rgb":{"r":127,"g":108,"b":110},"luminance":74.95500747114897},{"name":"Twisted Vine","hex":"#655f50","rgb":{"r":101,"g":95,"b":80},"luminance":64.06940944007522},{"name":"Two Harbours","hex":"#bed3e1","rgb":{"r":190,"g":211,"b":225},"luminance":138.6573295898922},{"name":"Typhus Corrosion","hex":"#463d2b","rgb":{"r":70,"g":61,"b":43},"luminance":41.76404857051097},{"name":"Tyrant Skull","hex":"#cdc586","rgb":{"r":205,"g":197,"b":134},"luminance":131.76802162133268},{"name":"Tyrian","hex":"#4e4d59","rgb":{"r":78,"g":77,"b":89},"luminance":51.86334544743522},{"name":"Tyrian Purple","hex":"#66023c","rgb":{"r":102,"g":2,"b":60},"luminance":31.27765784070156},{"name":"Tyrol","hex":"#b3cdbf","rgb":{"r":179,"g":205,"b":191},"luminance":133.4882644354926},{"name":"Tzatziki Green","hex":"#ddeecc","rgb":{"r":221,"g":238,"b":204},"luminance":156.28513113217136},{"name":"UA Blue","hex":"#0033aa","rgb":{"r":0,"g":51,"b":170},"luminance":35.6624223658461},{"name":"UA Red","hex":"#d9004c","rgb":{"r":217,"g":0,"b":76},"luminance":65.4589076062227},{"name":"Ube","hex":"#8878c3","rgb":{"r":136,"g":120,"b":195},"luminance":84.31801347280425},{"name":"UCLA Blue","hex":"#536895","rgb":{"r":83,"g":104,"b":149},"luminance":68.05340541809792},{"name":"UCLA Gold","hex":"#ffb300","rgb":{"r":255,"g":179,"b":0},"luminance":129.82155196268454},{"name":"Ufo","hex":"#989fa3","rgb":{"r":152,"g":159,"b":163},"luminance":105.460230973576},{"name":"UFO Defense Green","hex":"#88aa11","rgb":{"r":136,"g":170,"b":17},"luminance":107.774583460109},{"name":"UFO Green","hex":"#3cd070","rgb":{"r":60,"g":208,"b":112},"luminance":124.06570291583407},{"name":"Uguisu Brown","hex":"#645530","rgb":{"r":100,"g":85,"b":48},"luminance":58.42485608882575},{"name":"Uguisu Green","hex":"#928c36","rgb":{"r":146,"g":140,"b":54},"luminance":93.25835325588801},{"name":"Ukon Saffron","hex":"#fabf14","rgb":{"r":250,"g":191,"b":20},"luminance":134.77011014687196},{"name":"Uldum Beige","hex":"#fcc680","rgb":{"r":252,"g":198,"b":128},"luminance":139.2793259748194},{"name":"Ulthuan Grey","hex":"#c7e0d9","rgb":{"r":199,"g":224,"b":217},"luminance":146.42893084701532},{"name":"Ultimate Orange","hex":"#ff4200","rgb":{"r":255,"g":66,"b":0},"luminance":85.52334528653564},{"name":"Ultimate Pink","hex":"#ff55ff","rgb":{"r":255,"g":85,"b":255},"luminance":95.6445291169338},{"name":"Ultra Indigo","hex":"#4433ff","rgb":{"r":68,"g":51,"b":255},"luminance":46.418521012630286},{"name":"Ultra Pink","hex":"#f06fff","rgb":{"r":240,"g":111,"b":255},"luminance":101.19287103842838},{"name":"Ultra Red","hex":"#fc6c85","rgb":{"r":252,"g":108,"b":133},"luminance":99.63061860693226},{"name":"Ultra Violet","hex":"#7366bd","rgb":{"r":115,"g":102,"b":189},"luminance":72.32879244809773},{"name":"Ultramarine","hex":"#1805db","rgb":{"r":24,"g":5,"b":219},"luminance":26.14211844897043},{"name":"Ultramarine Blue","hex":"#657abb","rgb":{"r":101,"g":122,"b":187},"luminance":80.59157351113079},{"name":"Ultramarine Green","hex":"#006b54","rgb":{"r":0,"g":107,"b":84},"luminance":63.53479563986965},{"name":"Ultramarine Highlight","hex":"#2e328f","rgb":{"r":46,"g":50,"b":143},"luminance":36.28154103673106},{"name":"Ultramarine Shadow","hex":"#090045","rgb":{"r":9,"g":0,"b":69},"luminance":8.313569450001605},{"name":"Ultramint","hex":"#b6ccb6","rgb":{"r":182,"g":204,"b":182},"luminance":133.15923449764946},{"name":"Ultraviolet Berl","hex":"#bb44cc","rgb":{"r":187,"g":68,"b":204},"luminance":72.52856100185636},{"name":"Ultraviolet Cryner","hex":"#bb44bb","rgb":{"r":187,"g":68,"b":187},"luminance":71.93057589787531},{"name":"Ultraviolet Nusp","hex":"#bb44aa","rgb":{"r":187,"g":68,"b":170},"luminance":71.38021452055185},{"name":"Ultraviolet Onsible","hex":"#bb44dd","rgb":{"r":187,"g":68,"b":221},"luminance":73.1730022685963},{"name":"Uluru Red","hex":"#921d0f","rgb":{"r":146,"g":29,"b":15},"luminance":46.886867511063265},{"name":"Ulva Lactuca Green","hex":"#90ee90","rgb":{"r":144,"g":238,"b":144},"luminance":147.10904332501113},{"name":"Umber","hex":"#b26400","rgb":{"r":178,"g":100,"b":0},"luminance":79.23554305991725},{"name":"Umber Brown","hex":"#613936","rgb":{"r":97,"g":57,"b":54},"luminance":44.7054250175524},{"name":"Umber Shade Wash","hex":"#4e4d2f","rgb":{"r":78,"g":77,"b":47},"luminance":51.142677374185254},{"name":"Umbral Umber","hex":"#520200","rgb":{"r":82,"g":2,"b":0},"luminance":24.546091338541054},{"name":"Umbrella Green","hex":"#a2af70","rgb":{"r":162,"g":175,"b":112},"luminance":114.28773903179639},{"name":"Umemurasaki Purple","hex":"#8f4155","rgb":{"r":143,"g":65,"b":85},"luminance":58.11937004132099},{"name":"Umenezumi Plum","hex":"#97645a","rgb":{"r":151,"g":100,"b":90},"luminance":74.7622217500256},{"name":"Umezome Pink","hex":"#fa9258","rgb":{"r":250,"g":146,"b":88},"luminance":114.16232446827631},{"name":"Unakite","hex":"#75a14f","rgb":{"r":117,"g":161,"b":79},"luminance":101.17554731257943},{"name":"Unbleached","hex":"#fbfaf5","rgb":{"r":251,"g":250,"b":245},"luminance":167.17655278477304},{"name":"Unbleached Calico","hex":"#f5d8bb","rgb":{"r":245,"g":216,"b":187},"luminance":147.9762258371256},{"name":"Unbleached Silk","hex":"#ffddca","rgb":{"r":255,"g":221,"b":202},"luminance":152.22576436989897},{"name":"Unburdened Pink","hex":"#fbe7e6","rgb":{"r":251,"g":231,"b":230},"luminance":157.18265556351946},{"name":"Uncharted","hex":"#19565e","rgb":{"r":25,"g":86,"b":94},"luminance":52.145379517268836},{"name":"Underbrush","hex":"#be9e48","rgb":{"r":190,"g":158,"b":72},"luminance":109.07138891570052},{"name":"Underground Civilization","hex":"#524b4c","rgb":{"r":82,"g":75,"b":76},"luminance":51.131182706837514},{"name":"Underhive Ash","hex":"#b2ac88","rgb":{"r":178,"g":172,"b":136},"luminance":115.18109478555931},{"name":"Undersea","hex":"#90b1ae","rgb":{"r":144,"g":177,"b":174},"luminance":114.20283811271942},{"name":"Underwater","hex":"#cfeee8","rgb":{"r":207,"g":238,"b":232},"luminance":155.07419704451158},{"name":"Underwater Flare","hex":"#e78ea5","rgb":{"r":231,"g":142,"b":165},"luminance":109.87371012667225},{"name":"Unexplained","hex":"#69667c","rgb":{"r":105,"g":102,"b":124},"luminance":69.06785357168702},{"name":"Unfired Clay","hex":"#986960","rgb":{"r":152,"g":105,"b":96},"luminance":77.35738532939179},{"name":"Ungor Flesh","hex":"#d6a766","rgb":{"r":214,"g":167,"b":102},"luminance":117.63971872203706},{"name":"Unicorn Dust","hex":"#ff2f92","rgb":{"r":255,"g":47,"b":146},"luminance":82.77364122714428},{"name":"Unicorn Silver","hex":"#e8e8e8","rgb":{"r":232,"g":232,"b":232},"luminance":155.1047967794678},{"name":"Uniform","hex":"#a7b7ca","rgb":{"r":167,"g":183,"b":202},"luminance":120.67669416254324},{"name":"Uniform Brown","hex":"#6e5d3e","rgb":{"r":110,"g":93,"b":62},"luminance":64.12398930977392},{"name":"Uniform Grey","hex":"#a8a8a8","rgb":{"r":168,"g":168,"b":168},"luminance":112.3172666334077},{"name":"Union Springs","hex":"#9c9680","rgb":{"r":156,"g":150,"b":128},"luminance":100.70447706035715},{"name":"Union Station","hex":"#c7c5ba","rgb":{"r":199,"g":197,"b":186},"luminance":131.76629666952016},{"name":"United Nations Blue","hex":"#5b92e5","rgb":{"r":91,"g":146,"b":229},"luminance":93.63058112070009},{"name":"Unity","hex":"#264d8e","rgb":{"r":38,"g":77,"b":142},"luminance":49.33655834165979},{"name":"University of California Gold","hex":"#b78727","rgb":{"r":183,"g":135,"b":39},"luminance":96.40273351933544},{"name":"University of Tennessee Orange","hex":"#f77f00","rgb":{"r":247,"g":127,"b":0},"luminance":104.93721460949875},{"name":"Unloaded Texture Purple","hex":"#c154c1","rgb":{"r":193,"g":84,"b":193},"luminance":79.02825265055529},{"name":"Unmellow Yellow","hex":"#fefe66","rgb":{"r":254,"g":254,"b":102},"luminance":167.72960055994886},{"name":"Unripe Strawberry","hex":"#f78fa7","rgb":{"r":247,"g":143,"b":167},"luminance":113.41429598599993},{"name":"Untamed Orange","hex":"#de5730","rgb":{"r":222,"g":87,"b":48},"luminance":83.92868656782375},{"name":"Untamed Red","hex":"#dd0022","rgb":{"r":221,"g":0,"b":34},"luminance":66.19257977296246},{"name":"UP Forest Green","hex":"#014431","rgb":{"r":1,"g":68,"b":49},"luminance":40.30607712243899},{"name":"Up In Smoke","hex":"#6e706d","rgb":{"r":110,"g":112,"b":109},"luminance":74.55488657358416},{"name":"UP Maroon","hex":"#7b1113","rgb":{"r":123,"g":17,"b":19},"luminance":38.1683078744657},{"name":"Up North","hex":"#6f9587","rgb":{"r":111,"g":149,"b":135},"luminance":94.80579196441533},{"name":"Upbeat","hex":"#f1d9a5","rgb":{"r":241,"g":217,"b":165},"luminance":147.552449054565},{"name":"Upper Crust","hex":"#a3758b","rgb":{"r":163,"g":117,"b":139},"luminance":85.69244964406141},{"name":"Uproar Red","hex":"#ee1100","rgb":{"r":238,"g":17,"b":0},"luminance":71.85826803507025},{"name":"Upsdell Red","hex":"#ae2029","rgb":{"r":174,"g":32,"b":41},"luminance":55.51026578931144},{"name":"Upstream Salmon","hex":"#f99a7a","rgb":{"r":249,"g":154,"b":122},"luminance":117.93295667030485},{"name":"Uptown Taupe","hex":"#f1e4d7","rgb":{"r":241,"g":228,"b":215},"luminance":153.96530283476207},{"name":"Urahayanagi Green","hex":"#bcb58c","rgb":{"r":188,"g":181,"b":140},"luminance":121.25566194203057},{"name":"Uran Mica","hex":"#93b778","rgb":{"r":147,"g":183,"b":120},"luminance":116.86864357046332},{"name":"Uranus","hex":"#ace5ee","rgb":{"r":172,"g":229,"b":238},"luminance":146.4599861293179},{"name":"Urban Bird","hex":"#ddd4c5","rgb":{"r":221,"g":212,"b":197},"luminance":142.67832750982188},{"name":"Urban Chic","hex":"#464e4d","rgb":{"r":70,"g":78,"b":77},"luminance":51.10260247776036},{"name":"Urban Exploration","hex":"#89776e","rgb":{"r":137,"g":119,"b":110},"luminance":81.94303251649892},{"name":"Urban Pigeon","hex":"#9dacb7","rgb":{"r":157,"g":172,"b":183},"luminance":113.2810557374886},{"name":"Urbanite","hex":"#4d5659","rgb":{"r":77,"g":86,"b":89},"luminance":56.4041857400672},{"name":"Uri Yellow","hex":"#ffd72e","rgb":{"r":255,"g":215,"b":46},"luminance":147.5415249548411},{"name":"Urnebes Beige","hex":"#ffecc2","rgb":{"r":255,"g":236,"b":194},"luminance":159.6669424301724},{"name":"Urobilin","hex":"#e1ad21","rgb":{"r":225,"g":173,"b":33},"luminance":121.87158762402332},{"name":"US Air Force Blue","hex":"#00308f","rgb":{"r":0,"g":48,"b":143},"luminance":32.55214555140721},{"name":"US Field Drab","hex":"#716140","rgb":{"r":113,"g":97,"b":64},"luminance":66.60962922881346},{"name":"USAFA Blue","hex":"#004f98","rgb":{"r":0,"g":79,"b":152},"luminance":49.50469384815949},{"name":"USC Cardinal","hex":"#990010","rgb":{"r":153,"g":0,"b":16},"luminance":45.78334833757793},{"name":"USC Gold","hex":"#ffcc00","rgb":{"r":255,"g":204,"b":0},"luminance":141.96085210014766},{"name":"Used Oil","hex":"#231712","rgb":{"r":35,"g":23,"b":18},"luminance":17.204764747011218},{"name":"Ushabti Bone","hex":"#bbbb7f","rgb":{"r":187,"g":187,"b":127},"luminance":124.03672606933802},{"name":"USMC Green","hex":"#373d31","rgb":{"r":55,"g":61,"b":49},"luminance":39.79676707975159},{"name":"Usu Koubai Blossom","hex":"#e597b2","rgb":{"r":229,"g":151,"b":178},"luminance":113.82688994257904},{"name":"Usu Pink","hex":"#a87ca0","rgb":{"r":168,"g":124,"b":160},"luminance":90.299747330765},{"name":"Usuao Blue","hex":"#8c9c76","rgb":{"r":140,"g":156,"b":118},"luminance":101.58074171810323},{"name":"Usubeni Red","hex":"#f2666c","rgb":{"r":242,"g":102,"b":108},"luminance":94.7214937804509},{"name":"Usugaki Persimmon","hex":"#fca474","rgb":{"r":252,"g":164,"b":116},"luminance":122.96228325791611},{"name":"Usukō","hex":"#fea464","rgb":{"r":254,"g":164,"b":100},"luminance":123.14740248986172},{"name":"Usumoegi Green","hex":"#8db255","rgb":{"r":141,"g":178,"b":85},"luminance":113.08669938149224},{"name":"Utah Crimson","hex":"#d3003f","rgb":{"r":211,"g":0,"b":63},"luminance":63.49648057176082},{"name":"Utepils","hex":"#fafad2","rgb":{"r":250,"g":250,"b":210},"luminance":166.42189940028925},{"name":"UV Light","hex":"#0098c8","rgb":{"r":0,"g":152,"b":200},"luminance":92.09105372401815},{"name":"Va Va Bloom","hex":"#efd5cf","rgb":{"r":239,"g":213,"b":207},"luminance":145.93248811008465},{"name":"Va Va Voom","hex":"#e3b34c","rgb":{"r":227,"g":179,"b":76},"luminance":125.38797531661477},{"name":"Vacherin Cheese","hex":"#fde882","rgb":{"r":253,"g":232,"b":130},"luminance":156.4870054189804},{"name":"Vagabond","hex":"#aa8877","rgb":{"r":170,"g":136,"b":119},"luminance":95.60791536269367},{"name":"Valencia","hex":"#d4574e","rgb":{"r":212,"g":87,"b":78},"luminance":81.88497401233025},{"name":"Valentine Red","hex":"#9b233b","rgb":{"r":155,"g":35,"b":59},"luminance":51.13897853887971},{"name":"Valentine's Day","hex":"#a63864","rgb":{"r":166,"g":56,"b":100},"luminance":60.614044082209205},{"name":"Valentino","hex":"#b64476","rgb":{"r":182,"g":68,"b":118},"luminance":68.81542039397856},{"name":"Valentino Nero","hex":"#382c38","rgb":{"r":56,"g":44,"b":56},"luminance":31.435689526396583},{"name":"Valerian","hex":"#9f7a93","rgb":{"r":159,"g":122,"b":147},"luminance":87.57592272422825},{"name":"Valhalla","hex":"#2a2b41","rgb":{"r":42,"g":43,"b":65},"luminance":29.149949313849586},{"name":"Valhallan Blizzard","hex":"#f2ede7","rgb":{"r":242,"g":237,"b":231},"luminance":159.00709380716322},{"name":"Valiant Poppy","hex":"#bc322c","rgb":{"r":188,"g":50,"b":44},"luminance":63.61109730227894},{"name":"Vallarta Blue","hex":"#30658e","rgb":{"r":48,"g":101,"b":142},"luminance":63.11085181646655},{"name":"Valley Flower","hex":"#ffdd9d","rgb":{"r":255,"g":221,"b":157},"luminance":151.5345932716355},{"name":"Valley of Fire","hex":"#ff8a4a","rgb":{"r":255,"g":138,"b":74},"luminance":111.56360588023318},{"name":"Valonia","hex":"#79c9d1","rgb":{"r":121,"g":201,"b":209},"luminance":125.6882273166425},{"name":"Valor","hex":"#a3bcdb","rgb":{"r":163,"g":188,"b":219},"luminance":123.19514219724736},{"name":"Vampire Bite","hex":"#c40233","rgb":{"r":196,"g":2,"b":51},"luminance":58.90339283946214},{"name":"Vampire Red","hex":"#dd4132","rgb":{"r":221,"g":65,"b":50},"luminance":76.51619610252459},{"name":"Vampire State Building","hex":"#cc1100","rgb":{"r":204,"g":17,"b":0},"luminance":61.806896516489154},{"name":"Vampiric Shadow","hex":"#bfb6aa","rgb":{"r":191,"g":182,"b":170},"luminance":122.68058459674863},{"name":"Van Cleef","hex":"#523936","rgb":{"r":82,"g":57,"b":54},"luminance":41.93487022753259},{"name":"Van de Cane","hex":"#faf7eb","rgb":{"r":250,"g":247,"b":235},"luminance":165.30903399693557},{"name":"Van Dyke Brown","hex":"#664228","rgb":{"r":102,"g":66,"b":40},"luminance":49.516302042862606},{"name":"Van Gogh Blue","hex":"#abddf1","rgb":{"r":171,"g":221,"b":241},"luminance":142.11998397832727},{"name":"Van Gogh Green","hex":"#65ce95","rgb":{"r":101,"g":206,"b":149},"luminance":125.7880514238137},{"name":"Van Gogh Olives","hex":"#759465","rgb":{"r":117,"g":148,"b":101},"luminance":94.36006496924425},{"name":"Vanadyl Blue","hex":"#00a3e0","rgb":{"r":0,"g":163,"b":224},"luminance":99.03000079268908},{"name":"Vandermint","hex":"#abdee4","rgb":{"r":171,"g":222,"b":228},"luminance":142.3780084879684},{"name":"Vanilla","hex":"#f3e5ab","rgb":{"r":243,"g":229,"b":171},"luminance":154.0408991599309},{"name":"Vanilla Blush","hex":"#fcede4","rgb":{"r":252,"g":237,"b":228},"luminance":160.33403047700136},{"name":"Vanilla Cream","hex":"#f4d8c6","rgb":{"r":244,"g":216,"b":198},"luminance":148.014473562554},{"name":"Vanilla Custard","hex":"#f3e0be","rgb":{"r":243,"g":224,"b":190},"luminance":151.78039857965848},{"name":"Vanilla Doe","hex":"#d1bea8","rgb":{"r":209,"g":190,"b":168},"luminance":129.27051127384001},{"name":"Vanilla Flower","hex":"#e9dfcf","rgb":{"r":233,"g":223,"b":207},"luminance":150.15135128929074},{"name":"Vanilla Frost","hex":"#fde9c5","rgb":{"r":253,"g":233,"b":197},"luminance":157.90230148417723},{"name":"Vanilla Ice","hex":"#fdf2d1","rgb":{"r":253,"g":242,"b":209},"luminance":162.6944553480542},{"name":"Vanilla Ice Smoke","hex":"#c9dae2","rgb":{"r":201,"g":218,"b":226},"luminance":143.70445592604287},{"name":"Vanilla Love","hex":"#e6e0cc","rgb":{"r":230,"g":224,"b":204},"luminance":150.19736542296604},{"name":"Vanilla Milkshake","hex":"#f1ece2","rgb":{"r":241,"g":236,"b":226},"luminance":158.26369830444375},{"name":"Vanilla Powder","hex":"#faf3dd","rgb":{"r":250,"g":243,"b":221},"luminance":162.99924851667262},{"name":"Vanilla Pudding","hex":"#f7e26b","rgb":{"r":247,"g":226,"b":107},"luminance":152.3228907846749},{"name":"Vanilla Quake","hex":"#cbc8c2","rgb":{"r":203,"g":200,"b":194},"luminance":134.00001218283526},{"name":"Vanilla Seed","hex":"#ccb69b","rgb":{"r":204,"g":182,"b":155},"luminance":124.28292107928586},{"name":"Vanilla Shake","hex":"#fffbf0","rgb":{"r":255,"g":251,"b":240},"luminance":168.13703100150184},{"name":"Vanilla Tan","hex":"#f1e9dd","rgb":{"r":241,"g":233,"b":221},"luminance":156.63187273987373},{"name":"Vanilla Wafer","hex":"#f3ead2","rgb":{"r":243,"g":234,"b":210},"luminance":157.22399121317332},{"name":"Vanishing","hex":"#331155","rgb":{"r":51,"g":17,"b":85},"luminance":20.639974370139125},{"name":"Vanishing Blue","hex":"#cfdfef","rgb":{"r":207,"g":223,"b":239},"luminance":147.33689207391336},{"name":"Vanishing Night","hex":"#990088","rgb":{"r":153,"g":0,"b":136},"luminance":48.302815911704364},{"name":"Vanishing Point","hex":"#ddeedd","rgb":{"r":221,"g":238,"b":221},"luminance":156.5852429605038},{"name":"Vanity","hex":"#5692b2","rgb":{"r":86,"g":146,"b":178},"luminance":91.74861232738074},{"name":"Vantablack","hex":"#000100","rgb":{"r":0,"g":1,"b":0},"luminance":0.587},{"name":"Vape Smoke","hex":"#e8e8d7","rgb":{"r":232,"g":232,"b":215},"luminance":154.78611494575344},{"name":"Vapor","hex":"#eaeaea","rgb":{"r":234,"g":234,"b":234},"luminance":156.44190709653216},{"name":"Vapor Blue","hex":"#bebdbd","rgb":{"r":190,"g":189,"b":189},"luminance":126.49093036656818},{"name":"Vapor Trail","hex":"#f5eedf","rgb":{"r":245,"g":238,"b":223},"luminance":159.78216278733993},{"name":"Vaporous Grey","hex":"#dfddd7","rgb":{"r":223,"g":221,"b":215},"luminance":147.90421548421128},{"name":"Vapour","hex":"#f0ffff","rgb":{"r":240,"g":255,"b":255},"luminance":168.52347529350325},{"name":"Vaquero Boots","hex":"#855f43","rgb":{"r":133,"g":95,"b":67},"luminance":68.91653327032635},{"name":"Varden","hex":"#fdefd3","rgb":{"r":253,"g":239,"b":211},"luminance":161.19301899896283},{"name":"Variegated Frond","hex":"#747d5a","rgb":{"r":116,"g":125,"b":90},"luminance":81.805489308481},{"name":"Vast","hex":"#c9bdb8","rgb":{"r":201,"g":189,"b":184},"luminance":127.90712109182975},{"name":"Vast Escape","hex":"#d2c595","rgb":{"r":210,"g":197,"b":149},"luminance":132.6781316457237},{"name":"Vega Violet","hex":"#aa55ff","rgb":{"r":170,"g":85,"b":255},"luminance":76.93025948870834},{"name":"Vegan","hex":"#22bb88","rgb":{"r":34,"g":187,"b":136},"luminance":111.32364947754812},{"name":"Vegan Mastermind","hex":"#22bb55","rgb":{"r":34,"g":187,"b":85},"luminance":110.66380174655124},{"name":"Vegan Villain","hex":"#aa9911","rgb":{"r":170,"g":153,"b":17},"luminance":103.21560184875152},{"name":"Vegas Gold","hex":"#c5b358","rgb":{"r":197,"g":179,"b":88},"luminance":120.8740657130387},{"name":"Vegeta Blue","hex":"#26538d","rgb":{"r":38,"g":83,"b":141},"luminance":52.54716320601903},{"name":"Vegetable Garden","hex":"#8b8c40","rgb":{"r":139,"g":140,"b":64},"luminance":92.38019667114807},{"name":"Vegetarian","hex":"#22aa00","rgb":{"r":34,"g":170,"b":0},"luminance":100.30648860367907},{"name":"Vegetarian Veteran","hex":"#78945a","rgb":{"r":120,"g":148,"b":90},"luminance":94.55200355360006},{"name":"Vegetarian Vulture","hex":"#cccc99","rgb":{"r":204,"g":204,"b":153},"luminance":135.51501350034985},{"name":"Vegetation","hex":"#5ccd97","rgb":{"r":92,"g":205,"b":151},"luminance":124.63355922463259},{"name":"Veil of Dusk","hex":"#dad8c9","rgb":{"r":218,"g":216,"b":201},"luminance":144.39513767436907},{"name":"Veiled Delight","hex":"#b2b0bd","rgb":{"r":178,"g":176,"b":189},"luminance":118.19551913672531},{"name":"Veiled Rose","hex":"#f8cdc9","rgb":{"r":248,"g":205,"b":201},"luminance":143.1924674171096},{"name":"Veiled Spotlight","hex":"#cfd5d7","rgb":{"r":207,"g":213,"b":215},"luminance":141.6482774692301},{"name":"Veiled Violet","hex":"#b19bb0","rgb":{"r":177,"g":155,"b":176},"luminance":107.15259329572943},{"name":"Veinous Blood Red","hex":"#3f3033","rgb":{"r":63,"g":48,"b":51},"luminance":34.38781966045536},{"name":"Velvet","hex":"#750851","rgb":{"r":117,"g":8,"b":81},"luminance":36.48464692168474},{"name":"Velvet Black","hex":"#241f20","rgb":{"r":36,"g":31,"b":32},"luminance":21.45465937739399},{"name":"Velvet Cape","hex":"#623941","rgb":{"r":98,"g":57,"b":65},"luminance":45.089022888060015},{"name":"Velvet Clover","hex":"#656d63","rgb":{"r":101,"g":109,"b":99},"luminance":71.64619798705301},{"name":"Velvet Ears","hex":"#c5adb4","rgb":{"r":197,"g":173,"b":180},"luminance":119.17734436544556},{"name":"Velvet Green","hex":"#2f5d50","rgb":{"r":47,"g":93,"b":80},"luminance":57.10375197830699},{"name":"Velvet Morning","hex":"#60688d","rgb":{"r":96,"g":104,"b":141},"luminance":69.34804536538863},{"name":"Velvet Rose","hex":"#7e374c","rgb":{"r":126,"g":55,"b":76},"luminance":50.36582568567698},{"name":"Velvet Scarf","hex":"#e3dfec","rgb":{"r":227,"g":223,"b":236},"luminance":149.8854267298859},{"name":"Velvet Slipper","hex":"#846c76","rgb":{"r":132,"g":108,"b":118},"luminance":75.87972155984758},{"name":"Velvet Umber","hex":"#6b605a","rgb":{"r":107,"g":96,"b":90},"luminance":65.60767907036492},{"name":"Velvet Violet","hex":"#43354f","rgb":{"r":67,"g":53,"b":79},"luminance":38.08311234655067},{"name":"Velvet Wine","hex":"#9a435d","rgb":{"r":154,"g":67,"b":93},"luminance":61.47687988992284},{"name":"Velveteen Crush","hex":"#936064","rgb":{"r":147,"g":96,"b":100},"luminance":72.36970438657325},{"name":"Venetian","hex":"#928083","rgb":{"r":146,"g":128,"b":131},"luminance":88.17093947554375},{"name":"Venetian Nights","hex":"#7755ff","rgb":{"r":119,"g":85,"b":255},"luminance":67.82760121071657},{"name":"Venetian Pink","hex":"#bb8e84","rgb":{"r":187,"g":142,"b":132},"luminance":101.49184789430134},{"name":"Venetian Red","hex":"#c80815","rgb":{"r":200,"g":8,"b":21},"luminance":60.0318553103267},{"name":"Venetian Wall","hex":"#949486","rgb":{"r":148,"g":148,"b":134},"luminance":98.68654951917205},{"name":"Venice Blue","hex":"#2c5778","rgb":{"r":44,"g":87,"b":120},"luminance":54.48179050838913},{"name":"Venom Dart","hex":"#01ff01","rgb":{"r":1,"g":255,"b":1},"luminance":149.68534204122994},{"name":"Venom Wyrm","hex":"#607038","rgb":{"r":96,"g":112,"b":56},"luminance":72.02047353357239},{"name":"Venomous Green","hex":"#66ff22","rgb":{"r":102,"g":255,"b":34},"luminance":152.80952393421035},{"name":"Venus","hex":"#eed053","rgb":{"r":238,"g":208,"b":83},"luminance":141.6368345593758},{"name":"Venus Deathtrap","hex":"#fed8b1","rgb":{"r":254,"g":216,"b":177},"luminance":149.16822002021743},{"name":"Venus Deva","hex":"#8f7974","rgb":{"r":143,"g":121,"b":116},"luminance":83.95159292115903},{"name":"Venus Flower","hex":"#9ea6cf","rgb":{"r":158,"g":166,"b":207},"luminance":110.83147356234147},{"name":"Venus Flytrap","hex":"#94b44c","rgb":{"r":148,"g":180,"b":76},"luminance":114.87967618338763},{"name":"Venus Mist","hex":"#5f606e","rgb":{"r":95,"g":96,"b":110},"luminance":64.34006161793754},{"name":"Venus Slipper Orchid","hex":"#df73ff","rgb":{"r":223,"g":115,"b":255},"luminance":99.23614388921004},{"name":"Venusian","hex":"#71384c","rgb":{"r":113,"g":56,"b":76},"luminance":47.92905850316695},{"name":"Veranda","hex":"#61a9a5","rgb":{"r":97,"g":169,"b":165},"luminance":105.05344029587988},{"name":"Veranda Gold","hex":"#af9968","rgb":{"r":175,"g":153,"b":104},"luminance":104.61589784540398},{"name":"Veranda Green","hex":"#8e977e","rgb":{"r":142,"g":151,"b":126},"luminance":99.3253443437273},{"name":"Veranda Hills","hex":"#ccb994","rgb":{"r":204,"g":185,"b":148},"luminance":125.69029566756535},{"name":"Verdant Green","hex":"#12674a","rgb":{"r":18,"g":103,"b":74},"luminance":61.28347690038482},{"name":"Verdant Views","hex":"#75794a","rgb":{"r":117,"g":121,"b":74},"luminance":79.62293083025769},{"name":"Verde","hex":"#7fb383","rgb":{"r":127,"g":179,"b":131},"luminance":112.71782651382166},{"name":"Verde Garrafa","hex":"#355e3b","rgb":{"r":53,"g":94,"b":59},"luminance":57.80119522120628},{"name":"Verde Tropa","hex":"#758000","rgb":{"r":117,"g":128,"b":0},"luminance":82.8808107163534},{"name":"Verdigris","hex":"#43b3ae","rgb":{"r":67,"g":179,"b":174},"luminance":108.78935294411856},{"name":"Verdigris Foncé","hex":"#62603e","rgb":{"r":98,"g":96,"b":62},"luminance":63.90705541644052},{"name":"Verdigris Green","hex":"#61ac86","rgb":{"r":97,"g":172,"b":134},"luminance":106.15205829846164},{"name":"Verdigris Roundhead","hex":"#558367","rgb":{"r":85,"g":131,"b":103},"luminance":81.83486664008196},{"name":"Verditer","hex":"#00bbaa","rgb":{"r":0,"g":187,"b":170},"luminance":111.46666659140749},{"name":"Verditter Blue","hex":"#55aabb","rgb":{"r":85,"g":170,"b":187},"luminance":105.15903883642147},{"name":"Verdun Green","hex":"#48531a","rgb":{"r":72,"g":83,"b":26},"luminance":53.34768899399486},{"name":"Veritably Verdant","hex":"#00844b","rgb":{"r":0,"g":132,"b":75},"luminance":77.95429915020722},{"name":"Vermicelle","hex":"#dabe82","rgb":{"r":218,"g":190,"b":130},"luminance":130.02794478111232},{"name":"Vermicelli","hex":"#d1b791","rgb":{"r":209,"g":183,"b":145},"luminance":125.37000128419876},{"name":"Vermilion","hex":"#f4320c","rgb":{"r":244,"g":50,"b":12},"luminance":78.65031379466963},{"name":"Vermilion Bird","hex":"#f24433","rgb":{"r":242,"g":68,"b":51},"luminance":82.84183614575429},{"name":"Vermilion Cinnabar","hex":"#e34244","rgb":{"r":227,"g":66,"b":68},"luminance":78.53521628543464},{"name":"Vermilion Red","hex":"#b5493a","rgb":{"r":181,"g":73,"b":58},"luminance":69.34546060125349},{"name":"Vermillion","hex":"#da3b1f","rgb":{"r":218,"g":59,"b":31},"luminance":73.89605516534695},{"name":"Vermillion Orange","hex":"#f9633b","rgb":{"r":249,"g":99,"b":59},"luminance":94.68532751171112},{"name":"Vermillion Seabass","hex":"#973a36","rgb":{"r":151,"g":58,"b":54},"luminance":56.881092227558355},{"name":"Vermin Brown","hex":"#8f7303","rgb":{"r":143,"g":115,"b":3},"luminance":79.90746547100589},{"name":"Verminlord Hide","hex":"#a16954","rgb":{"r":161,"g":105,"b":84},"luminance":78.7904583182507},{"name":"Verona Beach","hex":"#e9d3ba","rgb":{"r":233,"g":211,"b":186},"luminance":143.67900665720097},{"name":"Veronica","hex":"#a020ff","rgb":{"r":160,"g":32,"b":255},"luminance":59.047177375383484},{"name":"Vers de Terre","hex":"#acdfad","rgb":{"r":172,"g":223,"b":173},"luminance":142.01714075772682},{"name":"Verse Green","hex":"#18880d","rgb":{"r":24,"g":136,"b":13},"luminance":80.16757152365287},{"name":"Very Berry","hex":"#b73275","rgb":{"r":183,"g":50,"b":117},"luminance":63.50806903850879},{"name":"Very Grape","hex":"#927288","rgb":{"r":146,"g":114,"b":136},"luminance":81.38835577648683},{"name":"Very Light Blue","hex":"#d5ffff","rgb":{"r":213,"g":255,"b":255},"luminance":165.2473845299828},{"name":"Very Pale Blue","hex":"#d6fffe","rgb":{"r":214,"g":255,"b":254},"luminance":165.34284791608013},{"name":"Vestige","hex":"#937899","rgb":{"r":147,"g":120,"b":153},"luminance":84.84033930271613},{"name":"Vesuvius","hex":"#a85533","rgb":{"r":168,"g":85,"b":51},"luminance":71.03919653965688},{"name":"Vetiver","hex":"#807d6f","rgb":{"r":128,"g":125,"b":111},"luminance":83.71833923938053},{"name":"Viameter","hex":"#d9d140","rgb":{"r":217,"g":209,"b":64},"luminance":138.97537117777378},{"name":"Vibrant Blue","hex":"#0339f8","rgb":{"r":3,"g":57,"b":248},"luminance":43.81341431570929},{"name":"Vibrant Green","hex":"#0add08","rgb":{"r":10,"g":221,"b":8},"luminance":129.76465764221012},{"name":"Vibrant Honey","hex":"#ffbd31","rgb":{"r":255,"g":189,"b":49},"luminance":134.73252268847338},{"name":"Vibrant Hue","hex":"#544563","rgb":{"r":84,"g":69,"b":99},"luminance":48.97632347369492},{"name":"Vibrant Orange","hex":"#ff7420","rgb":{"r":255,"g":116,"b":32},"luminance":102.2894344152904},{"name":"Vibrant Orchid","hex":"#804b81","rgb":{"r":128,"g":75,"b":129},"luminance":60.15989565316748},{"name":"Vibrant Purple","hex":"#ad03de","rgb":{"r":173,"g":3,"b":222},"luminance":57.613180037210235},{"name":"Vibrant Vine","hex":"#4b373a","rgb":{"r":75,"g":55,"b":58},"luminance":39.861264330173974},{"name":"Vibrant Vision","hex":"#6c6068","rgb":{"r":108,"g":96,"b":104},"luminance":66.02185928917785},{"name":"Vibrant Yellow","hex":"#ffda29","rgb":{"r":255,"g":218,"b":41},"luminance":149.03168608386608},{"name":"VIC 20 Blue","hex":"#c7ffff","rgb":{"r":199,"g":255,"b":255},"luminance":163.6796661958962},{"name":"VIC 20 Creme","hex":"#ffffb2","rgb":{"r":255,"g":255,"b":178},"luminance":169.20598250061965},{"name":"VIC 20 Green","hex":"#94e089","rgb":{"r":148,"g":224,"b":137},"luminance":139.61108685201185},{"name":"VIC 20 Pink","hex":"#ea9ff6","rgb":{"r":234,"g":159,"b":246},"luminance":119.9698127905516},{"name":"VIC 20 Sky","hex":"#87d6dd","rgb":{"r":135,"g":214,"b":221},"luminance":134.32778113629362},{"name":"Vicarious Violet","hex":"#5f4d50","rgb":{"r":95,"g":77,"b":80},"luminance":54.15688345907655},{"name":"Vicious Violet","hex":"#8f509d","rgb":{"r":143,"g":80,"b":157},"luminance":65.98288454591841},{"name":"Victoria","hex":"#564985","rgb":{"r":86,"g":73,"b":133},"luminance":52.22359850680533},{"name":"Victoria Blue","hex":"#08589d","rgb":{"r":8,"g":88,"b":157},"luminance":54.7211330657544},{"name":"Victoria Peak","hex":"#007755","rgb":{"r":0,"g":119,"b":85},"luminance":70.52189524537751},{"name":"Victoria Red","hex":"#6a3c3a","rgb":{"r":106,"g":60,"b":58},"luminance":47.84011475738745},{"name":"Victorian Cottage","hex":"#d4c5ca","rgb":{"r":212,"g":197,"b":202},"luminance":133.86823988160896},{"name":"Victorian Crown","hex":"#c38b36","rgb":{"r":195,"g":139,"b":54},"luminance":100.47281726914996},{"name":"Victorian Greenhouse","hex":"#00b191","rgb":{"r":0,"g":177,"b":145},"luminance":105.20571800524912},{"name":"Victorian Lace","hex":"#efe1cd","rgb":{"r":239,"g":225,"b":205},"luminance":151.9757778265997},{"name":"Victorian Peacock","hex":"#104a65","rgb":{"r":16,"g":74,"b":101},"luminance":45.19202026906962},{"name":"Victorian Pewter","hex":"#828388","rgb":{"r":130,"g":131,"b":136},"luminance":87.54655632861865},{"name":"Victorian Plum","hex":"#8e6278","rgb":{"r":142,"g":98,"b":120},"luminance":72.79467590421706},{"name":"Victorian Rouge","hex":"#d28085","rgb":{"r":210,"g":128,"b":133},"luminance":99.08526045785013},{"name":"Victorian Valentine","hex":"#ae6aa1","rgb":{"r":174,"g":106,"b":161},"luminance":83.15738858333636},{"name":"Victorian Violet","hex":"#b079a7","rgb":{"r":176,"g":121,"b":167},"luminance":90.42436369142997},{"name":"Victoriana","hex":"#d6b2ad","rgb":{"r":214,"g":178,"b":173},"luminance":124.09870940505384},{"name":"Victory Blue","hex":"#3a405a","rgb":{"r":58,"g":64,"b":90},"luminance":42.63058981529577},{"name":"Victory Lake","hex":"#92abd8","rgb":{"r":146,"g":171,"b":216},"luminance":112.19427445730018},{"name":"Vida Loca","hex":"#549019","rgb":{"r":84,"g":144,"b":25},"luminance":88.22651948252293},{"name":"Vidalia","hex":"#a1ddd4","rgb":{"r":161,"g":221,"b":212},"luminance":140.46547644884134},{"name":"Vienna Roast","hex":"#330022","rgb":{"r":51,"g":0,"b":34},"luminance":15.733892620708962},{"name":"Vienna Sausage","hex":"#fed1bd","rgb":{"r":254,"g":209,"b":189},"luminance":145.88743441777294},{"name":"Viennese","hex":"#8c8185","rgb":{"r":140,"g":129,"b":133},"luminance":87.84143995290606},{"name":"Vietnamese Lantern","hex":"#eec172","rgb":{"r":238,"g":193,"b":114},"luminance":134.41643106778278},{"name":"Viking","hex":"#4db1c8","rgb":{"r":77,"g":177,"b":200},"luminance":108.834281042326},{"name":"Viking Castle","hex":"#757266","rgb":{"r":117,"g":114,"b":102},"luminance":76.40051961210735},{"name":"Viking Diva","hex":"#cabae0","rgb":{"r":202,"g":186,"b":224},"luminance":127.36057013063343},{"name":"Vile Green","hex":"#8fcdb0","rgb":{"r":143,"g":205,"b":176},"luminance":129.27195121139002},{"name":"Village Crier","hex":"#ab9769","rgb":{"r":171,"g":151,"b":105},"luminance":103.02413945284862},{"name":"Village Square","hex":"#7b6f60","rgb":{"r":123,"g":111,"b":96},"luminance":75.61582846203565},{"name":"Villandry","hex":"#728f66","rgb":{"r":114,"g":143,"b":102},"luminance":91.34088493659341},{"name":"Vin Cuit","hex":"#b47463","rgb":{"r":180,"g":116,"b":99},"luminance":87.52420613750233},{"name":"Vin Rouge","hex":"#955264","rgb":{"r":149,"g":82,"b":100},"luminance":66.5705156732318},{"name":"Vinca","hex":"#5778a7","rgb":{"r":87,"g":120,"b":167},"luminance":77.46557437339506},{"name":"Vincotto","hex":"#483743","rgb":{"r":72,"g":55,"b":67},"luminance":39.54889445989609},{"name":"Vindaloo","hex":"#ae7579","rgb":{"r":174,"g":117,"b":121},"luminance":87.25700059594072},{"name":"Vineyard","hex":"#819e84","rgb":{"r":129,"g":158,"b":132},"luminance":101.56763687809222},{"name":"Vineyard Autumn","hex":"#ee4455","rgb":{"r":238,"g":68,"b":85},"luminance":82.16576781117547},{"name":"Vineyard Green","hex":"#5f7355","rgb":{"r":95,"g":115,"b":85},"luminance":73.87601200660468},{"name":"Vineyard Wine","hex":"#58363d","rgb":{"r":88,"g":54,"b":61},"luminance":41.77849523379223},{"name":"Vinho do Porto","hex":"#b31a38","rgb":{"r":179,"g":26,"b":56},"luminance":56.019474658372154},{"name":"Vining Ivy","hex":"#4b7378","rgb":{"r":75,"g":115,"b":120},"luminance":72.43582021348277},{"name":"Vino Tinto","hex":"#4c1c24","rgb":{"r":76,"g":28,"b":36},"luminance":28.34369573644199},{"name":"Vintage","hex":"#847592","rgb":{"r":132,"g":117,"b":146},"luminance":80.94165059473399},{"name":"Vintage Beige","hex":"#dfe1cc","rgb":{"r":223,"g":225,"b":204},"luminance":149.7680523008829},{"name":"Vintage Copper","hex":"#9d5f46","rgb":{"r":157,"g":95,"b":70},"luminance":73.32844519011705},{"name":"Vintage Ephemera","hex":"#d8ceb9","rgb":{"r":216,"g":206,"b":185},"luminance":138.70115803409863},{"name":"Vintage Indigo","hex":"#4a556b","rgb":{"r":74,"g":85,"b":107},"luminance":55.927293024068305},{"name":"Vintage Khaki","hex":"#9a9186","rgb":{"r":154,"g":145,"b":134},"luminance":97.97016646408231},{"name":"Vintage Lace","hex":"#f1e7d2","rgb":{"r":241,"g":231,"b":210},"luminance":155.40968274209942},{"name":"Vintage Plum","hex":"#675d62","rgb":{"r":103,"g":93,"b":98},"luminance":63.66667946422209},{"name":"Vintage Porcelain","hex":"#f2edec","rgb":{"r":242,"g":237,"b":236},"luminance":159.10248753869314},{"name":"Vintage Pottery","hex":"#a66c47","rgb":{"r":166,"g":108,"b":71},"luminance":80.92032876848684},{"name":"Vintage Red","hex":"#9e3641","rgb":{"r":158,"g":54,"b":65},"luminance":57.371402876345975},{"name":"Vintage Vibe","hex":"#888f4f","rgb":{"r":136,"g":143,"b":79},"luminance":93.70571174160088},{"name":"Vintage Violet","hex":"#634f62","rgb":{"r":99,"g":79,"b":98},"luminance":56.138114628120526},{"name":"Vintage Wine","hex":"#65344e","rgb":{"r":101,"g":52,"b":78},"luminance":43.8493083297787},{"name":"Viola","hex":"#966ebd","rgb":{"r":150,"g":110,"b":189},"luminance":81.51709953132531},{"name":"Viola Sororia","hex":"#b9a5bd","rgb":{"r":185,"g":165,"b":189},"luminance":113.59960548346987},{"name":"Violaceous","hex":"#bf8fc4","rgb":{"r":191,"g":143,"b":196},"luminance":103.95568141280205},{"name":"Violaceous Greti","hex":"#881188","rgb":{"r":136,"g":17,"b":136},"luminance":44.64880012945477},{"name":"Violent Violet","hex":"#7f00ff","rgb":{"r":127,"g":0,"b":255},"luminance":47.822731300083646},{"name":"Violet","hex":"#9a0eea","rgb":{"r":154,"g":14,"b":234},"luminance":53.845878356657906},{"name":"Violet Aura","hex":"#838ba4","rgb":{"r":131,"g":139,"b":164},"luminance":92.41844310525902},{"name":"Violet Blue","hex":"#510ac9","rgb":{"r":81,"g":10,"b":201},"luminance":33.853629894001024},{"name":"Violet Bouquet","hex":"#b9b1c8","rgb":{"r":185,"g":177,"b":200},"luminance":119.89408419934655},{"name":"Violet Clues","hex":"#efecef","rgb":{"r":239,"g":236,"b":239},"luminance":158.24074715761424},{"name":"Violet Crush","hex":"#d8d3e6","rgb":{"r":216,"g":211,"b":230},"luminance":142.1236711635328},{"name":"Violet Dawn","hex":"#a89b9c","rgb":{"r":168,"g":155,"b":156},"luminance":105.44095364231111},{"name":"Violet Echo","hex":"#dfdee5","rgb":{"r":223,"g":222,"b":229},"luminance":148.69123767391272},{"name":"Violet Eclipse","hex":"#a387ac","rgb":{"r":163,"g":135,"b":172},"luminance":95.07648951239206},{"name":"Violet Eggplant","hex":"#991199","rgb":{"r":153,"g":17,"b":153},"luminance":49.96590651634372},{"name":"Violet Extract","hex":"#dee2ec","rgb":{"r":222,"g":226,"b":236},"luminance":150.761634191196},{"name":"Violet Frog","hex":"#926eae","rgb":{"r":146,"g":110,"b":174},"luminance":80.42651000758393},{"name":"Violet Gems","hex":"#c4c0e9","rgb":{"r":196,"g":192,"b":233},"luminance":129.77734885564584},{"name":"Violet Glow","hex":"#4422ee","rgb":{"r":68,"g":34,"b":238},"luminance":39.34281906523731},{"name":"Violet Hickey","hex":"#330099","rgb":{"r":51,"g":0,"b":153},"luminance":23.167981461491202},{"name":"Violet Hush","hex":"#e5e2e7","rgb":{"r":229,"g":226,"b":231},"luminance":151.59473487229033},{"name":"Violet Ice","hex":"#c2acb1","rgb":{"r":194,"g":172,"b":177},"luminance":118.17604247900671},{"name":"Violet Indigo","hex":"#3e285c","rgb":{"r":62,"g":40,"b":92},"luminance":31.701198526238716},{"name":"Violet Ink","hex":"#9400d3","rgb":{"r":148,"g":0,"b":211},"luminance":50.36699732960066},{"name":"Violet Intense","hex":"#4d4456","rgb":{"r":77,"g":68,"b":86},"luminance":47.1111876415783},{"name":"Violet Kiss","hex":"#f0a0d1","rgb":{"r":240,"g":160,"b":209},"luminance":120.57421895247755},{"name":"Violet Majesty","hex":"#644982","rgb":{"r":100,"g":73,"b":130},"luminance":54.31252710931429},{"name":"Violet Mix","hex":"#aca8cd","rgb":{"r":172,"g":168,"b":205},"luminance":113.64907188358382},{"name":"Violet Orchid","hex":"#ca7988","rgb":{"r":202,"g":121,"b":136},"luminance":94.51522178464165},{"name":"Violet Persuasion","hex":"#927b97","rgb":{"r":146,"g":123,"b":151},"luminance":86.11026601398929},{"name":"Violet Pink","hex":"#fb5ffc","rgb":{"r":251,"g":95,"b":252},"luminance":97.81301350024954},{"name":"Violet Poison","hex":"#8601bf","rgb":{"r":134,"g":1,"b":191},"luminance":45.6041226316218},{"name":"Violet Posy","hex":"#60394d","rgb":{"r":96,"g":57,"b":77},"luminance":44.949722813383396},{"name":"Violet Powder","hex":"#c7ccd8","rgb":{"r":199,"g":204,"b":216},"luminance":135.9643110562474},{"name":"Violet Purple","hex":"#3a2f52","rgb":{"r":58,"g":47,"b":82},"luminance":33.90107651683055},{"name":"Violet Quartz","hex":"#8b4963","rgb":{"r":139,"g":73,"b":99},"luminance":60.75276716331528},{"name":"Violet Red","hex":"#a50055","rgb":{"r":165,"g":0,"b":85},"luminance":50.27761256265059},{"name":"Violet Shadow","hex":"#4d4860","rgb":{"r":77,"g":72,"b":96},"luminance":49.35661415656467},{"name":"Violet Storm","hex":"#5c619d","rgb":{"r":92,"g":97,"b":157},"luminance":65.7196940726294},{"name":"Violet Sweet Pea","hex":"#c7c5dc","rgb":{"r":199,"g":197,"b":220},"luminance":132.44528576736886},{"name":"Violet Tulip","hex":"#9e91c3","rgb":{"r":158,"g":145,"b":195},"luminance":99.85260481830205},{"name":"Violet Tulle","hex":"#c193c0","rgb":{"r":193,"g":147,"b":192},"luminance":106.08946184235266},{"name":"Violet Vapor","hex":"#e5dae1","rgb":{"r":229,"g":218,"b":225},"luminance":147.3821478232693},{"name":"Violet Velvet","hex":"#b19cd9","rgb":{"r":177,"g":156,"b":217},"luminance":108.61972084755142},{"name":"Violet Verbena","hex":"#898ca3","rgb":{"r":137,"g":140,"b":163},"luminance":93.68463317428318},{"name":"Violet Vixen","hex":"#883377","rgb":{"r":136,"g":51,"b":119},"luminance":52.28595625022077},{"name":"Violet Vogue","hex":"#e9e1e8","rgb":{"r":233,"g":225,"b":232},"luminance":151.64693606532245},{"name":"Violet Webcap","hex":"#833e82","rgb":{"r":131,"g":62,"b":130},"luminance":55.48302620621914},{"name":"Violet Whimsey","hex":"#dad6df","rgb":{"r":218,"g":214,"b":223},"luminance":143.78752773450137},{"name":"Violets Are Blue","hex":"#7487c6","rgb":{"r":116,"g":135,"b":198},"luminance":89.39935718448986},{"name":"Violin Brown","hex":"#674403","rgb":{"r":103,"g":68,"b":3},"luminance":50.41685461232185},{"name":"Virgin Olive Oil","hex":"#e2dcab","rgb":{"r":226,"g":220,"b":171},"luminance":147.0489752157423},{"name":"Virgin Peach","hex":"#ecbdb0","rgb":{"r":236,"g":189,"b":176},"luminance":133.0044790260839},{"name":"Viric Green","hex":"#99cc00","rgb":{"r":153,"g":204,"b":0},"luminance":128.1888119650073},{"name":"Viridian","hex":"#1e9167","rgb":{"r":30,"g":145,"b":103},"luminance":86.38807029329917},{"name":"Viridian Green","hex":"#bcd7d4","rgb":{"r":188,"g":215,"b":212},"luminance":140.25542126064147},{"name":"Viridis","hex":"#00846b","rgb":{"r":0,"g":132,"b":107},"luminance":78.43826527913528},{"name":"Virtual Boy","hex":"#bb3311","rgb":{"r":187,"g":51,"b":17},"luminance":63.45268616851456},{"name":"Virtual Forest","hex":"#8aa56e","rgb":{"r":138,"g":165,"b":110},"luminance":106.02214518203259},{"name":"Virtual Pink","hex":"#c6174e","rgb":{"r":198,"g":23,"b":78},"luminance":61.369548385172266},{"name":"Virtuous","hex":"#9f7ba9","rgb":{"r":159,"g":123,"b":169},"luminance":88.56810847026145},{"name":"Vis Vis","hex":"#f9e496","rgb":{"r":249,"g":228,"b":150},"luminance":154.1020320988662},{"name":"Vision","hex":"#d2cce5","rgb":{"r":210,"g":204,"b":229},"luminance":137.7087173711236},{"name":"Vision Quest","hex":"#9b94c2","rgb":{"r":155,"g":148,"b":194},"luminance":100.91786688688974},{"name":"Visionary","hex":"#f6e0a9","rgb":{"r":246,"g":224,"b":169},"luminance":151.8896435442522},{"name":"Vista Blue","hex":"#97d5b3","rgb":{"r":151,"g":213,"b":179},"luminance":134.49010371770854},{"name":"Vista White","hex":"#e3dfd9","rgb":{"r":227,"g":223,"b":217},"luminance":149.51182085039295},{"name":"Vitalize","hex":"#2aaa45","rgb":{"r":42,"g":170,"b":69},"luminance":100.88419806887498},{"name":"Vitamin C","hex":"#ff9900","rgb":{"r":255,"g":153,"b":0},"luminance":117.81050779111342},{"name":"Viva La Bleu","hex":"#97bee2","rgb":{"r":151,"g":190,"b":226},"luminance":123.0494079506277},{"name":"Viva Las Vegas","hex":"#b39953","rgb":{"r":179,"g":153,"b":83},"luminance":104.9763907076253},{"name":"Vivacious","hex":"#a32857","rgb":{"r":163,"g":40,"b":87},"luminance":54.999748117605044},{"name":"Vivacious Violet","hex":"#804665","rgb":{"r":128,"g":70,"b":101},"luminance":57.321080589953986},{"name":"Vivaldi Red","hex":"#ef3939","rgb":{"r":239,"g":57,"b":57},"luminance":79.17324804503096},{"name":"Vivid Amber","hex":"#cc9900","rgb":{"r":204,"g":153,"b":0},"luminance":108.56577608528389},{"name":"Vivid Auburn","hex":"#922724","rgb":{"r":146,"g":39,"b":36},"luminance":49.463157814680606},{"name":"Vivid Blue","hex":"#152eff","rgb":{"r":21,"g":46,"b":255},"luminance":40.16962465595117},{"name":"Vivid Burgundy","hex":"#9f1d35","rgb":{"r":159,"g":29,"b":53},"luminance":50.85700516153109},{"name":"Vivid Cerise","hex":"#da1d81","rgb":{"r":218,"g":29,"b":129},"luminance":68.95463790783039},{"name":"Vivid Cerulean","hex":"#00aaee","rgb":{"r":0,"g":170,"b":238},"luminance":103.41271451809008},{"name":"Vivid Crimson","hex":"#cc0033","rgb":{"r":204,"g":0,"b":51},"luminance":61.272462101665205},{"name":"Vivid Green","hex":"#2fef10","rgb":{"r":47,"g":239,"b":16},"luminance":141.00687796699845},{"name":"Vivid Imagination","hex":"#5c9f59","rgb":{"r":92,"g":159,"b":89},"luminance":97.82985366952155},{"name":"Vivid Lime Green","hex":"#a6d608","rgb":{"r":166,"g":214,"b":8},"luminance":135.07126868435049},{"name":"Vivid Malachite","hex":"#00cc33","rgb":{"r":0,"g":204,"b":51},"luminance":119.88905746564195},{"name":"Vivid Mulberry","hex":"#b80ce3","rgb":{"r":184,"g":12,"b":227},"luminance":61.20497590882624},{"name":"Vivid Orange","hex":"#ff5f00","rgb":{"r":255,"g":95,"b":0},"luminance":94.46181900641125},{"name":"Vivid Orange Peel","hex":"#ffa102","rgb":{"r":255,"g":161,"b":2},"luminance":121.42868301188149},{"name":"Vivid Orchid","hex":"#cc00ff","rgb":{"r":204,"g":0,"b":255},"luminance":67.5690529458568},{"name":"Vivid Purple","hex":"#9900fa","rgb":{"r":153,"g":0,"b":250},"luminance":53.89840451256419},{"name":"Vivid Raspberry","hex":"#ff006c","rgb":{"r":255,"g":0,"b":108},"luminance":77.2326703474637},{"name":"Vivid Red","hex":"#f70d1a","rgb":{"r":247,"g":13,"b":26},"luminance":74.3053367262406},{"name":"Vivid Red Tangelo","hex":"#df6124","rgb":{"r":223,"g":97,"b":36},"luminance":87.77650520498067},{"name":"Vivid Sky Blue","hex":"#00ccff","rgb":{"r":0,"g":204,"b":255},"luminance":123.22600538847308},{"name":"Vivid Tangelo","hex":"#f07427","rgb":{"r":240,"g":116,"b":39},"luminance":99.02416361676579},{"name":"Vivid Tangerine","hex":"#ff9980","rgb":{"r":255,"g":153,"b":128},"luminance":118.71075018716711},{"name":"Vivid Vermilion","hex":"#e56024","rgb":{"r":229,"g":96,"b":36},"luminance":88.77312972403305},{"name":"Vivid Viola","hex":"#993c7c","rgb":{"r":153,"g":60,"b":124},"luminance":59.439573560045},{"name":"Vivid Violet","hex":"#9f00ff","rgb":{"r":159,"g":0,"b":255},"luminance":55.724425353699246},{"name":"Vivid Yellow","hex":"#ffe302","rgb":{"r":255,"g":227,"b":2},"luminance":153.5208390089111},{"name":"Vixen","hex":"#573d37","rgb":{"r":87,"g":61,"b":55},"luminance":44.70045098206504},{"name":"Vizcaya Palm","hex":"#47644b","rgb":{"r":71,"g":100,"b":75},"luminance":63.003674027789835},{"name":"Vodka","hex":"#bfc0ee","rgb":{"r":191,"g":192,"b":238},"luminance":129.22760897346973},{"name":"Void","hex":"#050d25","rgb":{"r":5,"g":13,"b":37},"luminance":8.846395311085752},{"name":"Voila!","hex":"#af8ba8","rgb":{"r":175,"g":139,"b":168},"luminance":98.80345326960996},{"name":"Volcanic Ash","hex":"#6f7678","rgb":{"r":111,"g":118,"b":120},"luminance":78.01558098867173},{"name":"Volcanic Brick","hex":"#72453a","rgb":{"r":114,"g":69,"b":58},"luminance":53.348542145029604},{"name":"Volcanic Glass","hex":"#615c60","rgb":{"r":97,"g":92,"b":96},"luminance":62.268588879145156},{"name":"Volcanic Rock","hex":"#6b6965","rgb":{"r":107,"g":105,"b":101},"luminance":70.39174291065679},{"name":"Volcanic Sand","hex":"#404048","rgb":{"r":64,"g":64,"b":72},"luminance":42.95244328324059},{"name":"Volcano","hex":"#4e2728","rgb":{"r":78,"g":39,"b":40},"luminance":32.99695035908621},{"name":"Voldemort","hex":"#2d135f","rgb":{"r":45,"g":19,"b":95},"luminance":20.560042169217454},{"name":"Volt","hex":"#ceff00","rgb":{"r":206,"g":255,"b":0},"luminance":161.86234911491925},{"name":"Voltage","hex":"#3b4956","rgb":{"r":59,"g":73,"b":86},"luminance":47.36593182868885},{"name":"Voodoo","hex":"#443240","rgb":{"r":68,"g":50,"b":64},"luminance":36.44234267991013},{"name":"Voxatron Purple","hex":"#83769c","rgb":{"r":131,"g":118,"b":156},"luminance":81.53686266346037},{"name":"Voyager","hex":"#4d5062","rgb":{"r":77,"g":80,"b":98},"luminance":53.48003097418699},{"name":"Voysey Grey","hex":"#9a937f","rgb":{"r":154,"g":147,"b":127},"luminance":98.87182673036844},{"name":"Vulcan","hex":"#36383c","rgb":{"r":54,"g":56,"b":60},"luminance":37.256506814246556},{"name":"Vulcan Burgundy","hex":"#5f3e42","rgb":{"r":95,"g":62,"b":66},"luminance":46.775825348143236},{"name":"Vulcan Mud","hex":"#897f79","rgb":{"r":137,"g":127,"b":121},"luminance":86.17305382774826},{"name":"Waaagh! Flesh","hex":"#1f5429","rgb":{"r":31,"g":84,"b":41},"luminance":50.38888271236028},{"name":"Waddles Pink","hex":"#eeaacc","rgb":{"r":238,"g":170,"b":204},"luminance":124.75141634466519},{"name":"Wafer","hex":"#d4bbb1","rgb":{"r":212,"g":187,"b":177},"luminance":128.3527311318306},{"name":"Waffle Cone","hex":"#e2c779","rgb":{"r":226,"g":199,"b":121},"luminance":135.65322289204926},{"name":"Wafting Grey","hex":"#cdbdba","rgb":{"r":205,"g":189,"b":186},"luminance":128.51083958172555},{"name":"Wageningen Green","hex":"#34b233","rgb":{"r":52,"g":178,"b":51},"luminance":105.79634727153862},{"name":"Wagon Wheel","hex":"#c2b79e","rgb":{"r":194,"g":183,"b":158},"luminance":123.40340117273915},{"name":"Wahoo","hex":"#272d4e","rgb":{"r":39,"g":45,"b":78},"luminance":30.212560467461213},{"name":"Waikawa Grey","hex":"#5b6e91","rgb":{"r":91,"g":110,"b":145},"luminance":71.99205151264964},{"name":"Waikiki","hex":"#218ba0","rgb":{"r":33,"g":139,"b":160},"luminance":84.1871304772885},{"name":"Waiouru","hex":"#4c4e31","rgb":{"r":76,"g":78,"b":49},"luminance":51.4192703954461},{"name":"Waiting","hex":"#9d9d9d","rgb":{"r":157,"g":157,"b":157},"luminance":104.96315988955362},{"name":"Wakame Green","hex":"#00656e","rgb":{"r":0,"g":101,"b":110},"luminance":60.59867959782622},{"name":"Wakatake Green","hex":"#6b9362","rgb":{"r":107,"g":147,"b":98},"luminance":92.70467708805204},{"name":"Wake Me Up","hex":"#f6d559","rgb":{"r":246,"g":213,"b":89},"luminance":145.41624115964487},{"name":"Wakefield","hex":"#295468","rgb":{"r":41,"g":84,"b":104},"luminance":52.17400388124339},{"name":"Walden Pond","hex":"#789bb6","rgb":{"r":120,"g":155,"b":182},"luminance":99.98061876683902},{"name":"Walk in the Woods","hex":"#3bb08f","rgb":{"r":59,"g":176,"b":143},"luminance":106.06757010981254},{"name":"Walker Lake","hex":"#3d87bb","rgb":{"r":61,"g":135,"b":187},"luminance":84.06478614735185},{"name":"Walleye","hex":"#9b5953","rgb":{"r":155,"g":89,"b":83},"luminance":70.4749566725656},{"name":"Wallflower","hex":"#a0848a","rgb":{"r":160,"g":132,"b":138},"luminance":92.41175076796239},{"name":"Wallis","hex":"#c6bdbf","rgb":{"r":198,"g":189,"b":191},"luminance":127.62183641132891},{"name":"Walls of Santorini","hex":"#e9edf1","rgb":{"r":233,"g":237,"b":241},"luminance":157.99496107787743},{"name":"Walnut","hex":"#773f1a","rgb":{"r":119,"g":63,"b":26},"luminance":51.40415564913015},{"name":"Walnut Grove","hex":"#5c5644","rgb":{"r":92,"g":86,"b":68},"luminance":58.01048088061329},{"name":"Walnut Hull","hex":"#5d5242","rgb":{"r":93,"g":82,"b":66},"luminance":56.09564850324845},{"name":"Walnut Oil","hex":"#eecb88","rgb":{"r":238,"g":203,"b":136},"luminance":139.6558204336647},{"name":"Walnut Shell","hex":"#aa8344","rgb":{"r":170,"g":131,"b":68},"luminance":92.50368107810628},{"name":"Walrus","hex":"#999b9b","rgb":{"r":153,"g":155,"b":155},"luminance":103.35998807081974},{"name":"Wan Blue","hex":"#cbdcdf","rgb":{"r":203,"g":220,"b":223},"luminance":144.93979264853388},{"name":"Wan White","hex":"#e4e2dc","rgb":{"r":228,"g":226,"b":220},"luminance":151.2469313011011},{"name":"Wandering River","hex":"#73a4c6","rgb":{"r":115,"g":164,"b":198},"luminance":104.68692006645338},{"name":"Wandering Road","hex":"#876d5e","rgb":{"r":135,"g":109,"b":94},"luminance":76.4067416528149},{"name":"Wandering Willow","hex":"#a6a897","rgb":{"r":166,"g":168,"b":151},"luminance":111.73616785982952},{"name":"War God","hex":"#643530","rgb":{"r":100,"g":53,"b":48},"luminance":43.495368776457106},{"name":"Warlock Purple","hex":"#b50038","rgb":{"r":181,"g":0,"b":56},"luminance":54.494234713407984},{"name":"Warlord Purple","hex":"#ba0033","rgb":{"r":186,"g":0,"b":51},"luminance":55.91707782064438},{"name":"Warm and Toasty","hex":"#cbb68f","rgb":{"r":203,"g":182,"b":143},"luminance":123.94912088837096},{"name":"Warm Apricot","hex":"#ffb865","rgb":{"r":255,"g":184,"b":101},"luminance":132.70870463161035},{"name":"Warm Ash","hex":"#cfc9c7","rgb":{"r":207,"g":201,"b":199},"luminance":135.15298818006207},{"name":"Warm Biscuits","hex":"#e3cdac","rgb":{"r":227,"g":205,"b":172},"luminance":139.54114095133377},{"name":"Warm Black","hex":"#004242","rgb":{"r":0,"g":66,"b":66},"luminance":39.46584776740517},{"name":"Warm Blue","hex":"#4b57db","rgb":{"r":75,"g":87,"b":219},"luminance":61.10830174370746},{"name":"Warm Brown","hex":"#964e02","rgb":{"r":150,"g":78,"b":2},"luminance":64.09315314446621},{"name":"Warm Buttercream","hex":"#e6d5ba","rgb":{"r":230,"g":213,"b":186},"luminance":144.2625158417806},{"name":"Warm Butterscotch","hex":"#d0b082","rgb":{"r":208,"g":176,"b":130},"luminance":121.49422458701484},{"name":"Warm Croissant","hex":"#e4ceb5","rgb":{"r":228,"g":206,"b":181},"luminance":140.3399929599542},{"name":"Warm Fuzzies","hex":"#f6e2ce","rgb":{"r":246,"g":226,"b":206},"luminance":153.49558761084958},{"name":"Warm Granite","hex":"#a49e97","rgb":{"r":164,"g":158,"b":151},"luminance":106.31402357168128},{"name":"Warm Grey","hex":"#978a84","rgb":{"r":151,"g":138,"b":132},"luminance":93.95129877228948},{"name":"Warm Grey Flannel","hex":"#aca49a","rgb":{"r":172,"g":164,"b":154},"luminance":110.54673285086268},{"name":"Warm Haze","hex":"#736967","rgb":{"r":115,"g":105,"b":103},"luminance":71.54771844021303},{"name":"Warm Hearth","hex":"#be9677","rgb":{"r":190,"g":150,"b":119},"luminance":105.66084873783666},{"name":"Warm Leather","hex":"#c89f59","rgb":{"r":200,"g":159,"b":89},"luminance":111.31051255384641},{"name":"Warm Light","hex":"#fff9d8","rgb":{"r":255,"g":249,"b":216},"luminance":166.68312443075934},{"name":"Warm Mahogany","hex":"#6d4741","rgb":{"r":109,"g":71,"b":65},"luminance":53.42334424200717},{"name":"Warm Neutral","hex":"#c1b19d","rgb":{"r":193,"g":177,"b":157},"luminance":120.18917777404087},{"name":"Warm Nutmeg","hex":"#8f6a50","rgb":{"r":143,"g":106,"b":80},"luminance":76.04546490751437},{"name":"Warm Olive","hex":"#c7b63c","rgb":{"r":199,"g":182,"b":60},"luminance":122.47717402438708},{"name":"Warm Pink","hex":"#fb5581","rgb":{"r":251,"g":85,"b":129},"luminance":91.31336080771531},{"name":"Warm Port","hex":"#513938","rgb":{"r":81,"g":57,"b":56},"luminance":41.79497694699687},{"name":"Warm Purple","hex":"#952e8f","rgb":{"r":149,"g":46,"b":143},"luminance":54.58621445933029},{"name":"Warm Sand","hex":"#c5ae91","rgb":{"r":197,"g":174,"b":145},"luminance":119.05870549019085},{"name":"Warm Spice","hex":"#987744","rgb":{"r":152,"g":119,"b":68},"luminance":83.69621148534742},{"name":"Warm Taupe","hex":"#af9483","rgb":{"r":175,"g":148,"b":131},"luminance":102.5103378055111},{"name":"Warm Turbulance","hex":"#f3f5dc","rgb":{"r":243,"g":245,"b":220},"luminance":163.0668582943818},{"name":"Warm Up","hex":"#9e6654","rgb":{"r":158,"g":102,"b":84},"luminance":76.86613178767355},{"name":"Warm Wassail","hex":"#a66e68","rgb":{"r":166,"g":110,"b":104},"luminance":82.30056860070894},{"name":"Warm Waters","hex":"#7ebbc2","rgb":{"r":126,"g":187,"b":194},"luminance":118.1426302949109},{"name":"Warm Welcome","hex":"#ea9073","rgb":{"r":234,"g":144,"b":115},"luminance":110.50835280647341},{"name":"Warm Wetlands","hex":"#8d894a","rgb":{"r":141,"g":137,"b":74},"luminance":91.19080511762137},{"name":"Warm Winter","hex":"#d4ede3","rgb":{"r":212,"g":237,"b":227},"luminance":155.0542021004268},{"name":"Warm Woolen","hex":"#d0b55a","rgb":{"r":208,"g":181,"b":90},"luminance":123.53759538294406},{"name":"Warmed Wine","hex":"#5c3839","rgb":{"r":92,"g":56,"b":57},"luminance":43.352998189283284},{"name":"Warmstone","hex":"#e6d7cc","rgb":{"r":230,"g":215,"b":204},"luminance":145.59483665638695},{"name":"Warmth","hex":"#9f552d","rgb":{"r":159,"g":85,"b":45},"luminance":69.10842644714174},{"name":"Warp Drive","hex":"#eaf2f1","rgb":{"r":234,"g":242,"b":241},"luminance":160.71527851452083},{"name":"Warpfiend Grey","hex":"#6b6a74","rgb":{"r":107,"g":106,"b":116},"luminance":71.20395711616032},{"name":"Warplock Bronze","hex":"#515131","rgb":{"r":81,"g":81,"b":49},"luminance":53.65147310186366},{"name":"Warplock Bronze Metal","hex":"#927d7b","rgb":{"r":146,"g":125,"b":123},"luminance":86.52270699070851},{"name":"Warpstone Glow","hex":"#168340","rgb":{"r":22,"g":131,"b":64},"luminance":77.52193437344039},{"name":"Warrant","hex":"#b8966e","rgb":{"r":184,"g":150,"b":110},"luminance":104.5792252600869},{"name":"Warrior","hex":"#7d685b","rgb":{"r":125,"g":104,"b":91},"luminance":72.32820200309143},{"name":"Wasabi","hex":"#afd77f","rgb":{"r":175,"g":215,"b":127},"luminance":137.38711778765867},{"name":"Wasabi Nori","hex":"#333300","rgb":{"r":51,"g":51,"b":0},"luminance":33.59696370209665},{"name":"Wasabi Nuts","hex":"#849137","rgb":{"r":132,"g":145,"b":55},"luminance":94.02977799080459},{"name":"Wasabi Paste","hex":"#cae277","rgb":{"r":202,"g":226,"b":119},"luminance":146.39385575904475},{"name":"Wasabi Peanut","hex":"#b4c79c","rgb":{"r":180,"g":199,"b":156},"luminance":129.83890027645796},{"name":"Wasabi Zing","hex":"#d2cca0","rgb":{"r":210,"g":204,"b":160},"luminance":136.43630456736946},{"name":"Wash Me","hex":"#fafbfd","rgb":{"r":250,"g":251,"b":253},"luminance":167.71289465333305},{"name":"Washed Black","hex":"#1f262a","rgb":{"r":31,"g":38,"b":42},"luminance":24.625128243320884},{"name":"Washed Blue","hex":"#94d1df","rgb":{"r":148,"g":209,"b":223},"luminance":132.87451251839082},{"name":"Washed Dollar","hex":"#e1e3d7","rgb":{"r":225,"g":227,"b":215},"luminance":151.26784762797413},{"name":"Washed Green","hex":"#ccd1c8","rgb":{"r":204,"g":209,"b":200},"luminance":138.89373817778826},{"name":"Washed Out Green","hex":"#bcf5a6","rgb":{"r":188,"g":245,"b":166},"luminance":155.56561620422426},{"name":"Washed-Out Crimson","hex":"#ffb3a7","rgb":{"r":255,"g":179,"b":167},"luminance":131.2100636308054},{"name":"Wasteland","hex":"#9c8855","rgb":{"r":156,"g":136,"b":85},"luminance":92.96616083285357},{"name":"Wasurenagusa Blue","hex":"#89c3eb","rgb":{"r":137,"g":195,"b":235},"luminance":124.49059279319059},{"name":"Watchet","hex":"#8fbabc","rgb":{"r":143,"g":186,"b":188},"luminance":119.1981576912999},{"name":"Water","hex":"#d4f1f9","rgb":{"r":212,"g":241,"b":249},"luminance":157.59668660539788},{"name":"Water Baby","hex":"#5ab5cb","rgb":{"r":90,"g":181,"b":203},"luminance":112.01841488344674},{"name":"Water Baptism","hex":"#cfdfdd","rgb":{"r":207,"g":223,"b":221},"luminance":146.97126551132368},{"name":"Water Blue","hex":"#0e87cc","rgb":{"r":14,"g":135,"b":204},"luminance":82.6930115366468},{"name":"Water Carrier","hex":"#4999a1","rgb":{"r":73,"g":153,"b":161},"luminance":94.23005341184944},{"name":"Water Chestnut","hex":"#ede4cf","rgb":{"r":237,"g":228,"b":207},"luminance":153.26612564099085},{"name":"Water Chi","hex":"#355873","rgb":{"r":53,"g":88,"b":115},"luminance":55.5998367353718},{"name":"Water Cooler","hex":"#75a7ad","rgb":{"r":117,"g":167,"b":173},"luminance":105.93607701817166},{"name":"Water Droplet","hex":"#e1e5dc","rgb":{"r":225,"g":229,"b":220},"luminance":152.39578391149803},{"name":"Water Fern","hex":"#75b790","rgb":{"r":117,"g":183,"b":144},"luminance":114.16026710725583},{"name":"Water Glitter","hex":"#76afb6","rgb":{"r":118,"g":175,"b":182},"luminance":110.57904255780116},{"name":"Water Iris","hex":"#e2e3eb","rgb":{"r":226,"g":227,"b":235},"luminance":151.7868425687813},{"name":"Water Leaf","hex":"#b6ecde","rgb":{"r":182,"g":236,"b":222},"luminance":150.97327118400793},{"name":"Water Lily","hex":"#dde3d5","rgb":{"r":221,"g":227,"b":213},"luminance":150.70283927650468},{"name":"Water Mist","hex":"#c7d8e3","rgb":{"r":199,"g":216,"b":227},"luminance":142.42981130718385},{"name":"Water Music","hex":"#6fb0be","rgb":{"r":111,"g":176,"b":190},"luminance":110.65276618774607},{"name":"Water Ouzel","hex":"#4f5156","rgb":{"r":79,"g":81,"b":86},"luminance":53.988769813730705},{"name":"Water Persimmon","hex":"#b56c60","rgb":{"r":181,"g":108,"b":96},"luminance":84.06955520876745},{"name":"Water Raceway","hex":"#0083c8","rgb":{"r":0,"g":131,"b":200},"luminance":80.20591380316041},{"name":"Water Reed","hex":"#b0ab80","rgb":{"r":176,"g":171,"b":128},"luminance":114.27052974848765},{"name":"Water Scrub","hex":"#949381","rgb":{"r":148,"g":147,"b":129},"luminance":98.08311506574411},{"name":"Water Spirit","hex":"#65a5d5","rgb":{"r":101,"g":165,"b":213},"luminance":104.31915524006125},{"name":"Water Wash","hex":"#acc7e5","rgb":{"r":172,"g":199,"b":229},"luminance":130.27524472822915},{"name":"Water Welt","hex":"#3994af","rgb":{"r":57,"g":148,"b":175},"luminance":90.75189102712956},{"name":"Water Wheel","hex":"#a28566","rgb":{"r":162,"g":133,"b":102},"luminance":92.60956359361596},{"name":"Water Wonder","hex":"#80d4d0","rgb":{"r":128,"g":212,"b":208},"luminance":132.33787841732993},{"name":"Watercourse","hex":"#006e4e","rgb":{"r":0,"g":110,"b":78},"luminance":65.17938756999791},{"name":"Watercress","hex":"#6e9377","rgb":{"r":110,"g":147,"b":119},"luminance":93.3358450810834},{"name":"Watercress Pesto","hex":"#c7c7a1","rgb":{"r":199,"g":199,"b":161},"luminance":132.37263798081534},{"name":"Watercress Spice","hex":"#748c69","rgb":{"r":116,"g":140,"b":105},"luminance":89.99896197179164},{"name":"Waterfall","hex":"#3ab0a2","rgb":{"r":58,"g":176,"b":162},"luminance":106.37284113908022},{"name":"Waterhen Back","hex":"#2f3f53","rgb":{"r":47,"g":63,"b":83},"luminance":40.67690516742885},{"name":"Waterline Blue","hex":"#436bad","rgb":{"r":67,"g":107,"b":173},"luminance":68.81314448562861},{"name":"Waterloo","hex":"#7b7c94","rgb":{"r":123,"g":124,"b":148},"luminance":83.2784789546495},{"name":"Watermark","hex":"#a2cdd2","rgb":{"r":162,"g":205,"b":210},"luminance":131.90858830644802},{"name":"Watermelon","hex":"#fd4659","rgb":{"r":253,"g":70,"b":89},"luminance":86.68216670688382},{"name":"Watermelon Candy","hex":"#fd5b78","rgb":{"r":253,"g":91,"b":120},"luminance":93.61082682040576},{"name":"Watermelon Milk","hex":"#dfcfca","rgb":{"r":223,"g":207,"b":202},"luminance":140.50106118460457},{"name":"Watermelon Pink","hex":"#c77690","rgb":{"r":199,"g":118,"b":144},"luminance":92.77732919738527},{"name":"Watermelon Red","hex":"#bf4147","rgb":{"r":191,"g":65,"b":71},"luminance":69.15746338610171},{"name":"Watermelon Water","hex":"#f05c85","rgb":{"r":240,"g":92,"b":133},"luminance":91.08136944512856},{"name":"Watermill Wood","hex":"#d3cccd","rgb":{"r":211,"g":204,"b":205},"luminance":137.35342123514798},{"name":"Waterpark","hex":"#c9e3e5","rgb":{"r":201,"g":227,"b":229},"luminance":148.4880770903846},{"name":"Waterscape","hex":"#dcece7","rgb":{"r":220,"g":236,"b":231},"luminance":155.60078078210273},{"name":"Watershed","hex":"#b0cec2","rgb":{"r":176,"g":206,"b":194},"luminance":133.71810990288486},{"name":"Waterslide","hex":"#d2f3eb","rgb":{"r":210,"g":243,"b":235},"luminance":158.13520506515934},{"name":"Waterspout","hex":"#a4f4f9","rgb":{"r":164,"g":244,"b":249},"luminance":154.02777111936663},{"name":"Waterway","hex":"#7eb7bf","rgb":{"r":126,"g":183,"b":191},"luminance":115.89956252290169},{"name":"Waterwings","hex":"#afebde","rgb":{"r":175,"g":235,"b":222},"luminance":149.69042559228694},{"name":"Waterworld","hex":"#00718a","rgb":{"r":0,"g":113,"b":138},"luminance":68.17108907007427},{"name":"Watson Lake","hex":"#74aeba","rgb":{"r":116,"g":174,"b":186},"luminance":109.9307077935915},{"name":"Wattle","hex":"#d6ca3d","rgb":{"r":214,"g":202,"b":61},"luminance":134.91612130505382},{"name":"Watusi","hex":"#f2cdbb","rgb":{"r":242,"g":205,"b":187},"luminance":142.0234118481879},{"name":"Wave","hex":"#a5ced5","rgb":{"r":165,"g":206,"b":213},"luminance":132.83707250989838},{"name":"Wave Jumper","hex":"#6c919f","rgb":{"r":108,"g":145,"b":159},"luminance":92.82180974857148},{"name":"Wave Splash","hex":"#cbe4e7","rgb":{"r":203,"g":228,"b":231},"luminance":149.29728819037535},{"name":"Wavecrest","hex":"#d6e1e4","rgb":{"r":214,"g":225,"b":228},"luminance":149.04226878640836},{"name":"Wavelet","hex":"#7dc4cd","rgb":{"r":125,"g":196,"b":205},"luminance":123.20718416147655},{"name":"Waves of Grain","hex":"#c7aa7c","rgb":{"r":199,"g":170,"b":124},"luminance":117.03947879668637},{"name":"Waves Queen","hex":"#d2eaea","rgb":{"r":210,"g":234,"b":234},"luminance":153.36692355263568},{"name":"Wax","hex":"#2b2b2b","rgb":{"r":43,"g":43,"b":43},"luminance":28.747871816884114},{"name":"Wax Flower","hex":"#eeb39e","rgb":{"r":238,"g":179,"b":158},"luminance":128.1748716285684},{"name":"Wax Poetic","hex":"#f1e6cc","rgb":{"r":241,"g":230,"b":204},"luminance":154.79354352491578},{"name":"Wax Way","hex":"#d3b667","rgb":{"r":211,"g":182,"b":103},"luminance":124.62584018172153},{"name":"Wax Wing","hex":"#f6ecd6","rgb":{"r":246,"g":236,"b":214},"luminance":158.7339622009102},{"name":"Wax Yellow","hex":"#ede9ad","rgb":{"r":237,"g":233,"b":173},"luminance":155.2959384336886},{"name":"Waxy Corn","hex":"#f8b500","rgb":{"r":248,"g":181,"b":0},"luminance":129.56444000187707},{"name":"Waystone Green","hex":"#00c000","rgb":{"r":0,"g":192,"b":0},"luminance":112.704},{"name":"Wayward Willow","hex":"#d9dcd1","rgb":{"r":217,"g":220,"b":209},"luminance":146.47396207176206},{"name":"Wayward Wind","hex":"#dedfe2","rgb":{"r":222,"g":223,"b":226},"luminance":149.01306781957075},{"name":"Waywatcher Green","hex":"#99cc04","rgb":{"r":153,"g":204,"b":4},"luminance":128.18962301606163},{"name":"Waza Bear","hex":"#5e5a59","rgb":{"r":94,"g":90,"b":89},"luminance":60.6951188482237},{"name":"Wazdakka Red","hex":"#b21b00","rgb":{"r":178,"g":27,"b":0},"luminance":55.53172143018799},{"name":"We Peep","hex":"#fdd7d8","rgb":{"r":253,"g":215,"b":216},"luminance":149.18616561196282},{"name":"Weak Blue","hex":"#cfe2ef","rgb":{"r":207,"g":226,"b":239},"luminance":148.90364068416864},{"name":"Weak Green","hex":"#e1f2df","rgb":{"r":225,"g":242,"b":223},"luminance":159.2216776227408},{"name":"Weak Lime","hex":"#e9f6e0","rgb":{"r":233,"g":246,"b":224},"luminance":162.34997933168947},{"name":"Weak Mauve","hex":"#eadee4","rgb":{"r":234,"g":222,"b":228},"luminance":150.1751105077003},{"name":"Weak Mint","hex":"#e0f0e5","rgb":{"r":224,"g":240,"b":229},"luminance":158.15967315343062},{"name":"Weak Orange","hex":"#faede3","rgb":{"r":250,"g":237,"b":227},"luminance":160.03540091179826},{"name":"Weak Pink","hex":"#ecdee5","rgb":{"r":236,"g":222,"b":229},"luminance":150.47438296268237},{"name":"Weak Yellow","hex":"#f1f5db","rgb":{"r":241,"g":245,"b":219},"luminance":162.7837671943981},{"name":"Weapon Bronze","hex":"#b47b27","rgb":{"r":180,"g":123,"b":39},"luminance":90.16287327387032},{"name":"Weather Board","hex":"#9f947d","rgb":{"r":159,"g":148,"b":125},"luminance":100.05322861857081},{"name":"Weathered Bamboo","hex":"#593a27","rgb":{"r":89,"g":58,"b":39},"luminance":43.44010074804155},{"name":"Weathered Blue","hex":"#d2e2f2","rgb":{"r":210,"g":226,"b":242},"luminance":149.34151495146955},{"name":"Weathered Brown","hex":"#59504c","rgb":{"r":89,"g":80,"b":76},"luminance":54.66673409853564},{"name":"Weathered Coral","hex":"#ead0a9","rgb":{"r":234,"g":208,"b":169},"luminance":142.03468987539628},{"name":"Weathered Hide","hex":"#d5c6c2","rgb":{"r":213,"g":198,"b":194},"luminance":134.36381395673465},{"name":"Weathered Leather","hex":"#90614a","rgb":{"r":144,"g":97,"b":74},"luminance":71.88209062763825},{"name":"Weathered Mint","hex":"#e4f5e1","rgb":{"r":228,"g":245,"b":225},"luminance":161.2082451644456},{"name":"Weathered Pebble","hex":"#7b9093","rgb":{"r":123,"g":144,"b":147},"luminance":93.69290836023823},{"name":"Weathered Pink","hex":"#eadfe8","rgb":{"r":234,"g":223,"b":232},"luminance":150.7640861113813},{"name":"Weathered Plastic","hex":"#f9f4d9","rgb":{"r":249,"g":244,"b":217},"luminance":163.30701157329403},{"name":"Weathered Saddle","hex":"#b5745c","rgb":{"r":181,"g":116,"b":92},"luminance":87.60927330482772},{"name":"Weathered Sandstone","hex":"#dfc0a6","rgb":{"r":223,"g":192,"b":166},"luminance":132.31073925044782},{"name":"Weathered Stone","hex":"#c4c4c4","rgb":{"r":196,"g":196,"b":196},"luminance":131.03681107230898},{"name":"Weathered Wicker","hex":"#97774d","rgb":{"r":151,"g":119,"b":77},"luminance":83.63568074691565},{"name":"Weathered Wood","hex":"#b19c86","rgb":{"r":177,"g":156,"b":134},"luminance":106.86267491037269},{"name":"Weaver's Spool","hex":"#bfb18a","rgb":{"r":191,"g":177,"b":138},"luminance":119.59906314850463},{"name":"Webcap Brown","hex":"#8f684b","rgb":{"r":143,"g":104,"b":75},"luminance":75.02080946644071},{"name":"Wedded Bliss","hex":"#edeadc","rgb":{"r":237,"g":234,"b":220},"luminance":156.58158043971838},{"name":"Wedding Cake","hex":"#eee2c9","rgb":{"r":238,"g":226,"b":201},"luminance":152.27701035941044},{"name":"Wedding Dress","hex":"#fefee7","rgb":{"r":254,"g":254,"b":231},"luminance":169.38561944864148},{"name":"Wedding Flowers","hex":"#bcb6cb","rgb":{"r":188,"g":182,"b":203},"luminance":122.91804043345304},{"name":"Wedge of Lime","hex":"#e1eca5","rgb":{"r":225,"g":236,"b":165},"luminance":155.14785447759178},{"name":"Wedgewood","hex":"#4c6b88","rgb":{"r":76,"g":107,"b":136},"luminance":68.56912332092338},{"name":"Weekend Gardener","hex":"#9fe4aa","rgb":{"r":159,"g":228,"b":170},"luminance":143.3450591300586},{"name":"Weeping Willow","hex":"#b3b17b","rgb":{"r":179,"g":177,"b":123},"luminance":117.71200502072844},{"name":"Weeping Wisteria","hex":"#d7ddec","rgb":{"r":215,"g":221,"b":236},"luminance":147.2599095816645},{"name":"Wèi Lán Azure","hex":"#5a06ef","rgb":{"r":90,"g":6,"b":239},"luminance":38.45643119167456},{"name":"Weird Green","hex":"#3ae57f","rgb":{"r":58,"g":229,"b":127},"luminance":136.3081082584598},{"name":"Weissbier","hex":"#b3833b","rgb":{"r":179,"g":131,"b":59},"luminance":93.93021412729772},{"name":"Weisswurst White","hex":"#e4e1d6","rgb":{"r":228,"g":225,"b":214},"luminance":150.6200253120414},{"name":"Welcome Home","hex":"#c09c6a","rgb":{"r":192,"g":156,"b":106},"luminance":108.75262159598728},{"name":"Welcoming Wasp","hex":"#eeaa00","rgb":{"r":238,"g":170,"b":0},"luminance":122.56457214056596},{"name":"Weldon Blue","hex":"#7c98ab","rgb":{"r":124,"g":152,"b":171},"luminance":98.56758081641244},{"name":"Well Read","hex":"#8e3537","rgb":{"r":142,"g":53,"b":55},"luminance":53.00838598750201},{"name":"Wellington","hex":"#4f6364","rgb":{"r":79,"g":99,"b":100},"luminance":63.75760668343817},{"name":"Wells Grey","hex":"#b9b5a4","rgb":{"r":185,"g":181,"b":164},"luminance":121.23413153893586},{"name":"Welsh Onion","hex":"#22bb66","rgb":{"r":34,"g":187,"b":102},"luminance":110.85031033335},{"name":"Wenge","hex":"#645452","rgb":{"r":100,"g":84,"b":82},"luminance":58.41809623738178},{"name":"Wentworth","hex":"#345362","rgb":{"r":52,"g":83,"b":98},"luminance":52.34777673406961},{"name":"West Coast","hex":"#5c512f","rgb":{"r":92,"g":81,"b":47},"luminance":55.19162469976763},{"name":"West Side","hex":"#e5823a","rgb":{"r":229,"g":130,"b":58},"luminance":102.73856376745783},{"name":"Westar","hex":"#d4cfc5","rgb":{"r":212,"g":207,"b":197},"luminance":138.87705854099875},{"name":"Westcar Papyrus","hex":"#a49d70","rgb":{"r":164,"g":157,"b":112},"luminance":105.1704920640766},{"name":"Western Red","hex":"#9b6959","rgb":{"r":155,"g":105,"b":89},"luminance":77.7796475049868},{"name":"Western Reserve","hex":"#8d876d","rgb":{"r":141,"g":135,"b":109},"luminance":90.61764056738622},{"name":"Western Sunrise","hex":"#daa36f","rgb":{"r":218,"g":163,"b":111},"luminance":116.46317272425648},{"name":"Westfall Yellow","hex":"#fcd450","rgb":{"r":252,"g":212,"b":80},"luminance":145.76283696470782},{"name":"Wet Adobe","hex":"#a3623b","rgb":{"r":163,"g":98,"b":59},"luminance":75.69527674168316},{"name":"Wet Aloeswood","hex":"#5a6457","rgb":{"r":90,"g":100,"b":87},"luminance":65.33149947766391},{"name":"Wet Ash","hex":"#b2beb5","rgb":{"r":178,"g":190,"b":181},"luminance":125.28880293146709},{"name":"Wet Clay","hex":"#a49690","rgb":{"r":164,"g":150,"b":144},"luminance":102.11178605822151},{"name":"Wet Concrete","hex":"#353838","rgb":{"r":53,"g":56,"b":56},"luminance":37.04660914307813},{"name":"Wet Coral","hex":"#d1584c","rgb":{"r":209,"g":88,"b":76},"luminance":81.53853268853935},{"name":"Wet Crow's Wing","hex":"#000b00","rgb":{"r":0,"g":11,"b":0},"luminance":6.457},{"name":"Wet Latex","hex":"#001144","rgb":{"r":0,"g":17,"b":68},"luminance":12.63621561227886},{"name":"Wet Leaf","hex":"#b9a023","rgb":{"r":185,"g":160,"b":35},"luminance":109.071699927158},{"name":"Wet Pottery Clay","hex":"#e0816f","rgb":{"r":224,"g":129,"b":111},"luminance":101.88170110966934},{"name":"Wet River Rock","hex":"#897870","rgb":{"r":137,"g":120,"b":112},"luminance":82.47898394742748},{"name":"Wet Sand","hex":"#ae8f60","rgb":{"r":174,"g":143,"b":96},"luminance":99.36079354051071},{"name":"Wet Sandstone","hex":"#786d5f","rgb":{"r":120,"g":109,"b":95},"luminance":74.15178749699834},{"name":"Wet Suit","hex":"#50493c","rgb":{"r":80,"g":73,"b":60},"luminance":49.549573166678236},{"name":"Wet Weather","hex":"#929090","rgb":{"r":146,"g":144,"b":144},"luminance":96.54086987385186},{"name":"Wetland Stone","hex":"#a49f80","rgb":{"r":164,"g":159,"b":128},"luminance":106.43544827265022},{"name":"Wetlands Swamp","hex":"#372418","rgb":{"r":55,"g":36,"b":24},"luminance":26.916261720380113},{"name":"Wewak","hex":"#f1919a","rgb":{"r":241,"g":145,"b":154},"luminance":112.89497704503951},{"name":"Whale Bone","hex":"#e5e7e5","rgb":{"r":229,"g":231,"b":229},"luminance":154.13094266239986},{"name":"Whale Shark","hex":"#607c8e","rgb":{"r":96,"g":124,"b":142},"luminance":79.90033732094001},{"name":"Whale Skin","hex":"#505a92","rgb":{"r":80,"g":90,"b":146},"luminance":60.334053701040176},{"name":"Whale Watching","hex":"#a5a495","rgb":{"r":165,"g":164,"b":149},"luminance":109.49883216272218},{"name":"Whale's Mouth","hex":"#c7d3d5","rgb":{"r":199,"g":211,"b":213},"luminance":139.5368803363469},{"name":"Whale's Tale","hex":"#115a82","rgb":{"r":17,"g":90,"b":130},"luminance":55.104248375238726},{"name":"Whaling Waters","hex":"#2e7176","rgb":{"r":46,"g":113,"b":118},"luminance":69.06468258813618},{"name":"Wharf View","hex":"#65737e","rgb":{"r":101,"g":115,"b":126},"luminance":75.33411658737361},{"name":"What's Left","hex":"#fff4e8","rgb":{"r":255,"g":244,"b":232},"luminance":164.39907759169452},{"name":"Wheat","hex":"#fbdd7e","rgb":{"r":251,"g":221,"b":126},"luminance":150.558199464526},{"name":"Wheat Beer","hex":"#bf923b","rgb":{"r":191,"g":146,"b":59},"luminance":103.20615175947604},{"name":"Wheat Bread","hex":"#dfbb7e","rgb":{"r":223,"g":187,"b":126},"luminance":129.2338198228312},{"name":"Wheat Seed","hex":"#e3d1c8","rgb":{"r":227,"g":209,"b":200},"luminance":142.0482404607674},{"name":"Wheat Sheaf","hex":"#dfd4c4","rgb":{"r":223,"g":212,"b":196},"luminance":142.93839862332302},{"name":"Wheat Tortilla","hex":"#a49a79","rgb":{"r":164,"g":154,"b":121},"luminance":103.76223848780441},{"name":"Wheatacre","hex":"#ad935b","rgb":{"r":173,"g":147,"b":91},"luminance":101.13898321616647},{"name":"Wheaten White","hex":"#fbebbb","rgb":{"r":251,"g":235,"b":187},"luminance":158.47912338853973},{"name":"Wheatfield","hex":"#dfd7bd","rgb":{"r":223,"g":215,"b":189},"luminance":144.35288175162972},{"name":"Wheatmeal","hex":"#9e8451","rgb":{"r":158,"g":132,"b":81},"luminance":91.2186580475727},{"name":"When Blue Met Red","hex":"#584165","rgb":{"r":88,"g":65,"b":101},"luminance":47.75664943230419},{"name":"Where Buffalo Roam","hex":"#c19851","rgb":{"r":193,"g":152,"b":81},"luminance":106.65967739028653},{"name":"Whetstone Brown","hex":"#9f6f55","rgb":{"r":159,"g":111,"b":85},"luminance":81.23716778667261},{"name":"Whimsy","hex":"#ed9987","rgb":{"r":237,"g":153,"b":135},"luminance":115.43150605445638},{"name":"Whimsy Blue","hex":"#b0dced","rgb":{"r":176,"g":220,"b":237},"luminance":142.0436457572108},{"name":"Whipped Citron","hex":"#f0edd2","rgb":{"r":240,"g":237,"b":210},"luminance":158.3562987727359},{"name":"Whipped Cream","hex":"#f2f0e7","rgb":{"r":242,"g":240,"b":231},"luminance":160.55009847396545},{"name":"Whipped Violet","hex":"#a1a8d5","rgb":{"r":161,"g":168,"b":213},"luminance":112.39259006269053},{"name":"Whippet","hex":"#cec1b5","rgb":{"r":206,"g":193,"b":181},"luminance":130.59262411407468},{"name":"Whirligig","hex":"#e6cdca","rgb":{"r":230,"g":205,"b":202},"luminance":140.49951568955674},{"name":"Whirligig Geyser","hex":"#dfd4c0","rgb":{"r":223,"g":212,"b":192},"luminance":142.8678270605387},{"name":"Whirlpool","hex":"#a5d8cd","rgb":{"r":165,"g":216,"b":205},"luminance":138.04459565299902},{"name":"Whirlwind","hex":"#e2d5d3","rgb":{"r":226,"g":213,"b":211},"luminance":144.14434207765493},{"name":"Whiskers","hex":"#f6f1e2","rgb":{"r":246,"g":241,"b":226},"luminance":161.51435447352657},{"name":"Whiskey","hex":"#d29062","rgb":{"r":210,"g":144,"b":98},"luminance":105.88852850049433},{"name":"Whiskey Sour","hex":"#d4915d","rgb":{"r":212,"g":145,"b":93},"luminance":106.65366460183166},{"name":"Whisky","hex":"#c2877b","rgb":{"r":194,"g":135,"b":123},"luminance":99.20223054447919},{"name":"Whisper","hex":"#efe6e6","rgb":{"r":239,"g":230,"b":230},"luminance":154.98988038255916},{"name":"Whisper Blue","hex":"#e5e8f2","rgb":{"r":229,"g":232,"b":242},"luminance":154.90467210836476},{"name":"Whisper Green","hex":"#e0e6d7","rgb":{"r":224,"g":230,"b":215},"luminance":152.68996291832676},{"name":"Whisper Grey","hex":"#e9e5da","rgb":{"r":233,"g":229,"b":218},"luminance":153.42964420867304},{"name":"Whisper of Grass","hex":"#cbede5","rgb":{"r":203,"g":237,"b":229},"luminance":154.012159279714},{"name":"Whisper of Rose","hex":"#cda2ac","rgb":{"r":205,"g":162,"b":172},"luminance":114.8234275964622},{"name":"Whisper Pink","hex":"#dacbbe","rgb":{"r":218,"g":203,"b":190},"luminance":137.53978568036231},{"name":"Whisper Ridge","hex":"#c9c3b5","rgb":{"r":201,"g":195,"b":181},"luminance":130.9193949802702},{"name":"Whisper White","hex":"#ede6db","rgb":{"r":237,"g":230,"b":219},"luminance":154.50749504473885},{"name":"Whispered Secret","hex":"#3f4855","rgb":{"r":63,"g":72,"b":85},"luminance":47.27551549163689},{"name":"Whispering Blue","hex":"#c9dcdc","rgb":{"r":201,"g":220,"b":220},"luminance":144.63068761849954},{"name":"Whispering Grasslands","hex":"#ac9d64","rgb":{"r":172,"g":157,"b":100},"luminance":106.15121508960695},{"name":"Whispering Pine","hex":"#c8cab5","rgb":{"r":200,"g":202,"b":181},"luminance":134.39343522657646},{"name":"Whispering Rain","hex":"#ececda","rgb":{"r":236,"g":236,"b":218},"luminance":157.44210054493047},{"name":"Whispering Winds","hex":"#b7c3bf","rgb":{"r":183,"g":195,"b":191},"luminance":128.72565163944594},{"name":"Whistler Rose","hex":"#c49e8f","rgb":{"r":196,"g":158,"b":143},"luminance":110.9144018421413},{"name":"White","hex":"#ffffff","rgb":{"r":255,"g":255,"b":255},"luminance":170.48156542570814},{"name":"White Acorn","hex":"#d7a98c","rgb":{"r":215,"g":169,"b":140},"luminance":119.28335187275717},{"name":"White Alyssum","hex":"#efebe7","rgb":{"r":239,"g":235,"b":231},"luminance":157.57213301215415},{"name":"White Asparagus","hex":"#eceabe","rgb":{"r":236,"g":234,"b":190},"luminance":155.9347743769811},{"name":"White Bass","hex":"#e8efec","rgb":{"r":232,"g":239,"b":236},"luminance":158.80135543816996},{"name":"White Beach","hex":"#fff6d9","rgb":{"r":255,"g":246,"b":217},"luminance":165.15812505898703},{"name":"White Blaze","hex":"#e3e7e1","rgb":{"r":227,"g":231,"b":225},"luminance":153.78950886845303},{"name":"White Blossom","hex":"#f4ecdb","rgb":{"r":244,"g":236,"b":219},"luminance":158.54650458461705},{"name":"White Box","hex":"#bfd0cb","rgb":{"r":191,"g":208,"b":203},"luminance":136.76411539947165},{"name":"White Cabbage","hex":"#b0b49b","rgb":{"r":176,"g":180,"b":155},"luminance":119.3547228893771},{"name":"White Castle","hex":"#dbd5d1","rgb":{"r":219,"g":213,"b":209},"luminance":143.1369644710967},{"name":"White Chalk","hex":"#f6f4f1","rgb":{"r":246,"g":244,"b":241},"luminance":163.3379061210226},{"name":"White Cherry","hex":"#e7dbdd","rgb":{"r":231,"g":219,"b":221},"luminance":148.0916547479972},{"name":"White Chocolate","hex":"#f0e3c7","rgb":{"r":240,"g":227,"b":199},"luminance":153.034140625548},{"name":"White Coffee","hex":"#e6e0d4","rgb":{"r":230,"g":224,"b":212},"luminance":150.3412759956493},{"name":"White Convulvulus","hex":"#f4f2f4","rgb":{"r":244,"g":242,"b":244},"luminance":162.0976455967205},{"name":"White Crest","hex":"#f9f8ef","rgb":{"r":249,"g":248,"b":239},"luminance":165.7638914028022},{"name":"White Currant","hex":"#f9ebc5","rgb":{"r":249,"g":235,"b":197},"luminance":158.35446375142064},{"name":"White Desert","hex":"#fdfaf1","rgb":{"r":253,"g":250,"b":241},"luminance":167.3704029540468},{"name":"White Duck","hex":"#cecaba","rgb":{"r":206,"g":202,"b":186},"luminance":135.28940804068884},{"name":"White Edgar","hex":"#ededed","rgb":{"r":237,"g":237,"b":237},"luminance":158.44757257212873},{"name":"White Elephant","hex":"#dedee5","rgb":{"r":222,"g":222,"b":229},"luminance":148.55739872520655},{"name":"White Fence","hex":"#f2e9d3","rgb":{"r":242,"g":233,"b":211},"luminance":156.5904898804522},{"name":"White Fever","hex":"#fbf4e8","rgb":{"r":251,"g":244,"b":232},"luminance":163.84782296081934},{"name":"White Flag","hex":"#c8c2c0","rgb":{"r":200,"g":194,"b":192},"luminance":130.47345871095777},{"name":"White Geranium","hex":"#f1f1e1","rgb":{"r":241,"g":241,"b":225},"luminance":160.82081354725202},{"name":"White Glaze","hex":"#ddeeee","rgb":{"r":221,"g":238,"b":238},"luminance":156.90871900885557},{"name":"White Gloss","hex":"#ffeeee","rgb":{"r":255,"g":238,"b":238},"luminance":161.45343565560935},{"name":"White Granite","hex":"#c8d1c4","rgb":{"r":200,"g":209,"b":196},"luminance":138.29827484462703},{"name":"White Grapes","hex":"#bbcc99","rgb":{"r":187,"g":204,"b":153},"luminance":133.30442767215197},{"name":"White Green","hex":"#d6e9ca","rgb":{"r":214,"g":233,"b":202},"luminance":152.74424185873588},{"name":"White Hamburgh Grapes","hex":"#e2e6d7","rgb":{"r":226,"g":230,"b":215},"luminance":152.95321401003642},{"name":"White Heat","hex":"#fdf9ef","rgb":{"r":253,"g":249,"b":239},"luminance":166.81857119038034},{"name":"White Hot Chocolate","hex":"#ead8bb","rgb":{"r":234,"g":216,"b":187},"luminance":146.37591859318934},{"name":"White Ice","hex":"#d7eee4","rgb":{"r":215,"g":238,"b":228},"luminance":155.96766243359548},{"name":"White Jade","hex":"#d4dbb2","rgb":{"r":212,"g":219,"b":178},"luminance":144.76075993514266},{"name":"White Lake","hex":"#e2e7e7","rgb":{"r":226,"g":231,"b":231},"luminance":153.7734419234999},{"name":"White Lightning","hex":"#f9f3db","rgb":{"r":249,"g":243,"b":219},"luminance":162.82723186862816},{"name":"White Lilac","hex":"#e7e5e8","rgb":{"r":231,"g":229,"b":232},"luminance":153.42609424084287},{"name":"White Lily","hex":"#faf0db","rgb":{"r":250,"g":240,"b":219},"luminance":161.42502301687927},{"name":"White Linen","hex":"#eee7dd","rgb":{"r":238,"g":231,"b":221},"luminance":155.19444026446305},{"name":"White Mecca","hex":"#ecf3e1","rgb":{"r":236,"g":243,"b":225},"luminance":161.1944647839993},{"name":"White Mouse","hex":"#b9a193","rgb":{"r":185,"g":161,"b":147},"luminance":110.77974922340273},{"name":"White Nectar","hex":"#f8f6d8","rgb":{"r":248,"g":246,"b":216},"luminance":164.18525537940366},{"name":"White Oak","hex":"#ce9f6f","rgb":{"r":206,"g":159,"b":111},"luminance":112.53885302863185},{"name":"White Owl","hex":"#f5f3f5","rgb":{"r":245,"g":243,"b":245},"luminance":162.7661967547316},{"name":"White Pearl","hex":"#ede1d1","rgb":{"r":237,"g":225,"b":209},"luminance":151.7664280069871},{"name":"White Pepper","hex":"#b6a893","rgb":{"r":182,"g":168,"b":147},"luminance":113.87389843155454},{"name":"White Picket Fence","hex":"#f0efeb","rgb":{"r":240,"g":239,"b":235},"luminance":159.84157015307372},{"name":"White Pointer","hex":"#dad6cc","rgb":{"r":218,"g":214,"b":204},"luminance":143.4204189925549},{"name":"White Porcelain","hex":"#f8fbf8","rgb":{"r":248,"g":251,"b":248},"luminance":167.3499825425745},{"name":"White Primer","hex":"#c3bdab","rgb":{"r":195,"g":189,"b":171},"luminance":126.83784257862477},{"name":"White Pudding","hex":"#f6e8df","rgb":{"r":246,"g":232,"b":223},"luminance":156.85200303470785},{"name":"White Rabbit","hex":"#f8eee7","rgb":{"r":248,"g":238,"b":231},"luminance":160.34264902389506},{"name":"White Rock","hex":"#d4cfb4","rgb":{"r":212,"g":207,"b":180},"luminance":138.57685963031489},{"name":"White Russian","hex":"#f0e0dc","rgb":{"r":240,"g":224,"b":220},"luminance":151.8802098497365},{"name":"White Sage","hex":"#d2d4c3","rgb":{"r":210,"g":212,"b":195},"luminance":141.14909187097166},{"name":"White Sand","hex":"#f5ebd8","rgb":{"r":245,"g":235,"b":216},"luminance":158.11849805130328},{"name":"White Scar","hex":"#8c9fa1","rgb":{"r":140,"g":159,"b":161},"luminance":103.9239039153168},{"name":"White Shadow","hex":"#d1d3e0","rgb":{"r":209,"g":211,"b":224},"luminance":141.05945138841284},{"name":"White Smoke","hex":"#f5f5f5","rgb":{"r":245,"g":245,"b":245},"luminance":163.79601384038625},{"name":"White Solid","hex":"#f4f5fa","rgb":{"r":244,"g":245,"b":250},"luminance":163.76074670384233},{"name":"White Spruce","hex":"#9fbdad","rgb":{"r":159,"g":189,"b":173},"luminance":122.30066726719032},{"name":"White Sulfur","hex":"#f1faea","rgb":{"r":241,"g":250,"b":234},"luminance":165.64924073777095},{"name":"White Swan","hex":"#e4d7c5","rgb":{"r":228,"g":215,"b":197},"luminance":145.18775903291572},{"name":"White Tiger","hex":"#c5b8a8","rgb":{"r":197,"g":184,"b":168},"luminance":124.50739165607798},{"name":"White Truffle","hex":"#efdbcd","rgb":{"r":239,"g":219,"b":205},"luminance":148.9251665434691},{"name":"White Ultramarine","hex":"#83ccd2","rgb":{"r":131,"g":204,"b":210},"luminance":128.24553662798562},{"name":"White Vienna","hex":"#c5dcb3","rgb":{"r":197,"g":220,"b":179},"luminance":143.3984234397296},{"name":"White Whale","hex":"#edeeef","rgb":{"r":237,"g":238,"b":239},"luminance":159.00212489460637},{"name":"White Zin","hex":"#f8eee3","rgb":{"r":248,"g":238,"b":227},"luminance":160.26838872341605},{"name":"Whitecap Foam","hex":"#dee3de","rgb":{"r":222,"g":227,"b":222},"luminance":151.00274748824936},{"name":"Whitecap Grey","hex":"#e0d5c6","rgb":{"r":224,"g":213,"b":198},"luminance":143.6246173920056},{"name":"Whitest White","hex":"#f8f9f5","rgb":{"r":248,"g":249,"b":245},"luminance":166.259515736694},{"name":"Whitewash","hex":"#fefffc","rgb":{"r":254,"g":255,"b":252},"luminance":170.29002356274427},{"name":"Whitewashed Fence","hex":"#faf2e3","rgb":{"r":250,"g":242,"b":227},"luminance":162.59327261605875},{"name":"Whitney Oaks","hex":"#b2a188","rgb":{"r":178,"g":161,"b":136},"luminance":109.56517854227226},{"name":"Who-Dun-It","hex":"#8b7181","rgb":{"r":139,"g":113,"b":129},"luminance":79.64536846546697},{"name":"Whole Nine Yards","hex":"#03c03c","rgb":{"r":3,"g":192,"b":60},"luminance":112.91493180709094},{"name":"Whole Wheat","hex":"#a48b73","rgb":{"r":164,"g":139,"b":115},"luminance":96.09276270874929},{"name":"Wholemeal Cookie","hex":"#aaa662","rgb":{"r":170,"g":166,"b":98},"luminance":110.46920769155538},{"name":"Wicked Green","hex":"#9bca47","rgb":{"r":155,"g":202,"b":71},"luminance":127.56631740784869},{"name":"Wicker Basket","hex":"#847567","rgb":{"r":132,"g":117,"b":103},"luminance":80.07747891261313},{"name":"Wiener Dog","hex":"#874e3c","rgb":{"r":135,"g":78,"b":60},"luminance":61.42049023737924},{"name":"Wiener Schnitzel","hex":"#ee9900","rgb":{"r":238,"g":153,"b":0},"luminance":114.58641265438061},{"name":"Wiggle","hex":"#c9c844","rgb":{"r":201,"g":200,"b":68},"luminance":132.11640059053985},{"name":"Wild Aster","hex":"#92316f","rgb":{"r":146,"g":49,"b":111},"luminance":53.787597092638364},{"name":"Wild Axolotl","hex":"#63775a","rgb":{"r":99,"g":119,"b":90},"luminance":76.55670062117358},{"name":"Wild Beet Leaf","hex":"#6b8372","rgb":{"r":107,"g":131,"b":114},"luminance":84.2947013400012},{"name":"Wild Berry","hex":"#7e3a3c","rgb":{"r":126,"g":58,"b":60},"luminance":51.23715440966643},{"name":"Wild Bill Brown","hex":"#795745","rgb":{"r":121,"g":87,"b":69},"luminance":63.07802119597602},{"name":"Wild Blue Yonder","hex":"#7a89b8","rgb":{"r":122,"g":137,"b":184},"luminance":90.76261686950195},{"name":"Wild Boar","hex":"#553322","rgb":{"r":85,"g":51,"b":34},"luminance":39.46098795012613},{"name":"Wild Caribbean Green","hex":"#1cd3a2","rgb":{"r":28,"g":211,"b":162},"luminance":125.50583196409639},{"name":"Wild Cattail","hex":"#916d5d","rgb":{"r":145,"g":109,"b":93},"luminance":78.01206777159544},{"name":"Wild Chestnut","hex":"#bc5d58","rgb":{"r":188,"g":93,"b":88},"luminance":78.99751419506818},{"name":"Wild Clary","hex":"#93a3c1","rgb":{"r":147,"g":163,"b":193},"luminance":107.56769019552293},{"name":"Wild Dove","hex":"#8b8c89","rgb":{"r":139,"g":140,"b":137},"luminance":93.40658994417898},{"name":"Wild Forest","hex":"#38914a","rgb":{"r":56,"g":145,"b":74},"luminance":87.15555551426426},{"name":"Wild Geranium","hex":"#986a79","rgb":{"r":152,"g":106,"b":121},"luminance":78.27753460604134},{"name":"Wild Ginger","hex":"#7c4c53","rgb":{"r":124,"g":76,"b":83},"luminance":58.77405689587881},{"name":"Wild Ginseng","hex":"#80805d","rgb":{"r":128,"g":128,"b":93},"luminance":84.98568634776093},{"name":"Wild Hemp","hex":"#9d7b74","rgb":{"r":157,"g":123,"b":116},"luminance":87.12923634463921},{"name":"Wild Honey","hex":"#eecc00","rgb":{"r":238,"g":204,"b":0},"luminance":139.29685476707647},{"name":"Wild Horses","hex":"#8d6747","rgb":{"r":141,"g":103,"b":71},"luminance":74.15137650778979},{"name":"Wild Iris","hex":"#2f2f4a","rgb":{"r":47,"g":47,"b":74},"luminance":32.09058781013523},{"name":"Wild Lilac","hex":"#beb8cd","rgb":{"r":190,"g":184,"b":205},"luminance":124.25482310156012},{"name":"Wild Lime","hex":"#c3d363","rgb":{"r":195,"g":211,"b":99},"luminance":137.35866652672485},{"name":"Wild Maple","hex":"#ffe2c7","rgb":{"r":255,"g":226,"b":199},"luminance":154.6840679094004},{"name":"Wild Mustang","hex":"#695649","rgb":{"r":105,"g":86,"b":73},"luminance":60.02777717856959},{"name":"Wild Nude","hex":"#beae8a","rgb":{"r":190,"g":174,"b":138},"luminance":117.92812628037468},{"name":"Wild Orchid","hex":"#d979a2","rgb":{"r":217,"g":121,"b":162},"luminance":97.95767168527435},{"name":"Wild Orchid Blue","hex":"#b4b6da","rgb":{"r":180,"g":182,"b":218},"luminance":122.17904018283986},{"name":"Wild Party","hex":"#b97a77","rgb":{"r":185,"g":122,"b":119},"luminance":91.50054959944228},{"name":"Wild Phlox","hex":"#9ea5c3","rgb":{"r":158,"g":165,"b":195},"luminance":110.03122506361544},{"name":"Wild Pigeon","hex":"#767c6b","rgb":{"r":118,"g":124,"b":107},"luminance":81.80283413183189},{"name":"Wild Plum","hex":"#83455d","rgb":{"r":131,"g":69,"b":93},"luminance":57.33328853292823},{"name":"Wild Primrose","hex":"#ebdd99","rgb":{"r":235,"g":221,"b":153},"luminance":148.56139511326623},{"name":"Wild Rice","hex":"#d5bfb4","rgb":{"r":213,"g":191,"b":180},"luminance":130.56540911742283},{"name":"Wild Rider Red","hex":"#dc143c","rgb":{"r":220,"g":20,"b":60},"luminance":67.16860576191826},{"name":"Wild Rose","hex":"#ce8498","rgb":{"r":206,"g":132,"b":152},"luminance":100.4880623556848},{"name":"Wild Sand","hex":"#e7e4de","rgb":{"r":231,"g":228,"b":222},"luminance":152.7190116553928},{"name":"Wild Seaweed","hex":"#8a6f45","rgb":{"r":138,"g":111,"b":69},"luminance":77.52329487966827},{"name":"Wild Strawberry","hex":"#ff3399","rgb":{"r":255,"g":51,"b":153},"luminance":83.74811853409005},{"name":"Wild Thyme","hex":"#7e9c6f","rgb":{"r":126,"g":156,"b":111},"luminance":99.82427147743176},{"name":"Wild Truffle","hex":"#463f3c","rgb":{"r":70,"g":63,"b":60},"luminance":43.04003788334764},{"name":"Wild Watermelon","hex":"#fc6d84","rgb":{"r":252,"g":109,"b":132},"luminance":99.98793775751153},{"name":"Wild West","hex":"#7e5c52","rgb":{"r":126,"g":92,"b":82},"luminance":66.50674699607552},{"name":"Wild Wheat","hex":"#e0e1d1","rgb":{"r":224,"g":225,"b":209},"luminance":149.99089464697514},{"name":"Wild Wilderness","hex":"#91857c","rgb":{"r":145,"g":133,"b":124},"luminance":90.41329306025746},{"name":"Wild Willow","hex":"#beca60","rgb":{"r":190,"g":202,"b":96},"luminance":131.93536566061428},{"name":"Wild Wisteria","hex":"#686b93","rgb":{"r":104,"g":107,"b":147},"luminance":72.0608233438947},{"name":"Wildcat Grey","hex":"#f5eec0","rgb":{"r":245,"g":238,"b":192},"luminance":159.25811126909673},{"name":"Wilderness","hex":"#8f886c","rgb":{"r":143,"g":136,"b":108},"luminance":91.3941716795989},{"name":"Wildfire","hex":"#ff8833","rgb":{"r":255,"g":136,"b":51},"luminance":110.54524343000922},{"name":"Wildflower Honey","hex":"#c69c5d","rgb":{"r":198,"g":156,"b":93},"luminance":109.55688199287162},{"name":"Will","hex":"#179fa6","rgb":{"r":23,"g":159,"b":166},"luminance":95.48015392740001},{"name":"William","hex":"#53736f","rgb":{"r":83,"g":115,"b":111},"luminance":73.02692811559308},{"name":"Willow","hex":"#9a8b4f","rgb":{"r":154,"g":139,"b":79},"luminance":94.12098491303625},{"name":"Willow Blue","hex":"#293648","rgb":{"r":41,"g":54,"b":72},"luminance":34.96308837903196},{"name":"Willow Bough","hex":"#59754d","rgb":{"r":89,"g":117,"b":77},"luminance":74.17549221946558},{"name":"Willow Brook","hex":"#dfe6cf","rgb":{"r":223,"g":230,"b":207},"luminance":152.4151830789833},{"name":"Willow Dyed","hex":"#93b881","rgb":{"r":147,"g":184,"b":129},"luminance":117.53238153377136},{"name":"Willow Grey","hex":"#817b69","rgb":{"r":129,"g":123,"b":105},"luminance":82.72839501646335},{"name":"Willow Grove","hex":"#69755c","rgb":{"r":105,"g":117,"b":92},"luminance":76.23942031521489},{"name":"Willow Leaf","hex":"#a1a46d","rgb":{"r":161,"g":164,"b":109},"luminance":108.34803468914423},{"name":"Willow Sooty Bamboo","hex":"#5b6356","rgb":{"r":91,"g":99,"b":86},"luminance":64.91200864246923},{"name":"Willow Springs","hex":"#e7e6e0","rgb":{"r":231,"g":230,"b":224},"luminance":153.78658640141538},{"name":"Willow Tree","hex":"#9e8f66","rgb":{"r":158,"g":143,"b":102},"luminance":97.02117515779737},{"name":"Willow Tree Mouse","hex":"#c8d5bb","rgb":{"r":200,"g":213,"b":187},"luminance":140.22570408095658},{"name":"Willowherb","hex":"#8e4483","rgb":{"r":142,"g":68,"b":131},"luminance":60.15806825356013},{"name":"Willowside","hex":"#f3f2e8","rgb":{"r":243,"g":242,"b":232},"luminance":161.73396448798255},{"name":"Willpower Orange","hex":"#fd5800","rgb":{"r":253,"g":88,"b":0},"luminance":91.60136977687614},{"name":"Wilted Brown","hex":"#ab4c3d","rgb":{"r":171,"g":76,"b":61},"luminance":68.21116698166071},{"name":"Wimbledon","hex":"#626d5b","rgb":{"r":98,"g":109,"b":91},"luminance":71.13403804789941},{"name":"Wind Cave","hex":"#686c7b","rgb":{"r":104,"g":108,"b":123},"luminance":71.99048906626486},{"name":"Wind Chill","hex":"#eff3f0","rgb":{"r":239,"g":243,"b":240},"luminance":161.86938871201065},{"name":"Wind Chimes","hex":"#cac5c2","rgb":{"r":202,"g":197,"b":194},"luminance":132.32314302872342},{"name":"Wind Force","hex":"#d5e2ee","rgb":{"r":213,"g":226,"b":238},"luminance":149.63751413666293},{"name":"Wind of Change","hex":"#c8deea","rgb":{"r":200,"g":222,"b":234},"luminance":145.8402810337391},{"name":"Wind Rose","hex":"#e8babd","rgb":{"r":232,"g":186,"b":189},"luminance":131.13679370794452},{"name":"Wind Tunnel","hex":"#c7dfe6","rgb":{"r":199,"g":223,"b":230},"luminance":146.16062808431002},{"name":"Wind Weaver","hex":"#c5d1d8","rgb":{"r":197,"g":209,"b":216},"luminance":138.30048182851715},{"name":"Windfall","hex":"#84a7ce","rgb":{"r":132,"g":167,"b":206},"luminance":108.2538965626642},{"name":"Windflower","hex":"#bc9ca2","rgb":{"r":188,"g":156,"b":162},"luminance":109.02425029322603},{"name":"Windham Cream","hex":"#f5e6c9","rgb":{"r":245,"g":230,"b":201},"luminance":155.3030795605805},{"name":"Winding Path","hex":"#c6bba2","rgb":{"r":198,"g":187,"b":162},"luminance":126.0760769892528},{"name":"Windjammer","hex":"#62a5df","rgb":{"r":98,"g":165,"b":223},"luminance":104.33492374559918},{"name":"Windmill","hex":"#f5ece7","rgb":{"r":245,"g":236,"b":231},"luminance":158.9052850128025},{"name":"Windmill Park","hex":"#a79b83","rgb":{"r":167,"g":155,"b":131},"luminance":104.8551337322117},{"name":"Window Box","hex":"#bcafbb","rgb":{"r":188,"g":175,"b":187},"luminance":119.02382825720234},{"name":"Window Pane","hex":"#e4ecdf","rgb":{"r":228,"g":236,"b":223},"luminance":156.47624321921842},{"name":"Windows 95 Desktop","hex":"#018281","rgb":{"r":1,"g":130,"b":129},"luminance":77.71468289197351},{"name":"Windows Blue","hex":"#3778bf","rgb":{"r":55,"g":120,"b":191},"luminance":75.54031176133708},{"name":"Windrock","hex":"#5e6c62","rgb":{"r":94,"g":108,"b":98},"luminance":70.24111072584202},{"name":"Windsor","hex":"#462c77","rgb":{"r":70,"g":44,"b":119},"luminance":35.905248084367834},{"name":"Windsor Brown","hex":"#a75502","rgb":{"r":167,"g":85,"b":2},"luminance":70.58942908113083},{"name":"Windsor Haze","hex":"#a697a7","rgb":{"r":166,"g":151,"b":167},"luminance":103.35616657461712},{"name":"Windsor Purple","hex":"#c9afd0","rgb":{"r":201,"g":175,"b":208},"luminance":121.35309790030082},{"name":"Windsor Toffee","hex":"#ccb490","rgb":{"r":204,"g":180,"b":144},"luminance":123.10171677113199},{"name":"Windsor Way","hex":"#9fc9e4","rgb":{"r":159,"g":201,"b":228},"luminance":129.83321190666123},{"name":"Windsor Wine","hex":"#582b36","rgb":{"r":88,"g":43,"b":54},"luminance":36.97736822706559},{"name":"Windstorm","hex":"#6d98c4","rgb":{"r":109,"g":152,"b":196},"luminance":97.58252811338717},{"name":"Windsurfer","hex":"#d7e2de","rgb":{"r":215,"g":226,"b":222},"luminance":149.57360172503704},{"name":"Windswept","hex":"#d1f1f5","rgb":{"r":209,"g":241,"b":245},"luminance":157.15636185022862},{"name":"Windswept Beach","hex":"#e3e4e5","rgb":{"r":227,"g":228,"b":229},"luminance":152.31658563990985},{"name":"Windy City","hex":"#88a3c2","rgb":{"r":136,"g":163,"b":194},"luminance":106.28984952948235},{"name":"Windy Day","hex":"#8cb0cb","rgb":{"r":140,"g":176,"b":203},"luminance":113.84718313599156},{"name":"Windy Meadow","hex":"#b0a676","rgb":{"r":176,"g":166,"b":118},"luminance":111.55798960182098},{"name":"Windy Sky","hex":"#e8ebe7","rgb":{"r":232,"g":235,"b":231},"luminance":156.63403846227038},{"name":"Wine","hex":"#80013f","rgb":{"r":128,"g":1,"b":63},"luminance":38.94446914518158},{"name":"Wine Bottle","hex":"#d3d6c4","rgb":{"r":211,"g":214,"b":196},"luminance":142.3353722059278},{"name":"Wine Bottle Green","hex":"#254636","rgb":{"r":37,"g":70,"b":54},"luminance":42.996213844942204},{"name":"Wine Brown","hex":"#5f3e3e","rgb":{"r":95,"g":62,"b":62},"luminance":46.704645218650356},{"name":"Wine Cellar","hex":"#70403d","rgb":{"r":112,"g":64,"b":61},"luminance":50.80510686929021},{"name":"Wine Cork","hex":"#866d4c","rgb":{"r":134,"g":109,"b":76},"luminance":75.98798287229368},{"name":"Wine Crush","hex":"#96837d","rgb":{"r":150,"g":131,"b":125},"luminance":90.15394394589734},{"name":"Wine Dregs","hex":"#673145","rgb":{"r":103,"g":49,"b":69},"luminance":42.86769569267748},{"name":"Wine Frost","hex":"#e5d8e1","rgb":{"r":229,"g":216,"b":225},"luminance":146.36396962709094},{"name":"Wine Goblet","hex":"#643b46","rgb":{"r":100,"g":59,"b":70},"luminance":46.44496839271182},{"name":"Wine Grape","hex":"#941751","rgb":{"r":148,"g":23,"b":81},"luminance":47.17820747972521},{"name":"Wine Leaf","hex":"#355e4b","rgb":{"r":53,"g":94,"b":75},"luminance":58.041722863815814},{"name":"Wine Red","hex":"#7b0323","rgb":{"r":123,"g":3,"b":35},"luminance":37.034699269738915},{"name":"Wine Stain","hex":"#69444f","rgb":{"r":105,"g":68,"b":79},"luminance":51.575586443587824},{"name":"Wine Stroll","hex":"#8f7191","rgb":{"r":143,"g":113,"b":145},"luminance":80.63004098969564},{"name":"Wine Tasting","hex":"#492a34","rgb":{"r":73,"g":42,"b":52},"luminance":33.45711925734193},{"name":"Wine Tour","hex":"#653b66","rgb":{"r":101,"g":59,"b":102},"luminance":47.39867797734447},{"name":"Wine Yellow","hex":"#d7c485","rgb":{"r":215,"g":196,"b":133},"luminance":132.66276860144293},{"name":"Wineberry","hex":"#663366","rgb":{"r":102,"g":51,"b":102},"luminance":44.28952875116194},{"name":"Wineshade","hex":"#433748","rgb":{"r":67,"g":55,"b":72},"luminance":38.871758102766584},{"name":"Wing Commander","hex":"#0065ac","rgb":{"r":0,"g":101,"b":172},"luminance":62.44535237309499},{"name":"Wing Man","hex":"#5a6868","rgb":{"r":90,"g":104,"b":104},"luminance":67.76113295983177},{"name":"Wingsuit Wind","hex":"#bad5d4","rgb":{"r":186,"g":213,"b":212},"luminance":138.95956311459818},{"name":"Wink","hex":"#7792af","rgb":{"r":119,"g":146,"b":175},"luminance":94.91492435333866},{"name":"Wink Pink","hex":"#ede3e7","rgb":{"r":237,"g":227,"b":231},"luminance":153.20032743437594},{"name":"Winner's Circle","hex":"#365771","rgb":{"r":54,"g":87,"b":113},"luminance":55.08794787428553},{"name":"Winning Ticket","hex":"#636653","rgb":{"r":99,"g":102,"b":83},"luminance":67.4584651544934},{"name":"Winsome Orchid","hex":"#d4b9cb","rgb":{"r":212,"g":185,"b":203},"luminance":127.85329379018751},{"name":"Winsome Rose","hex":"#c28ba1","rgb":{"r":194,"g":139,"b":161},"luminance":101.77908921286335},{"name":"Winter Blizzard","hex":"#b8c8d3","rgb":{"r":184,"g":200,"b":211},"luminance":131.86400256324697},{"name":"Winter Bloom","hex":"#47243b","rgb":{"r":71,"g":36,"b":59},"luminance":30.699689591264598},{"name":"Winter Breath","hex":"#deeced","rgb":{"r":222,"g":236,"b":237},"luminance":155.97155584272406},{"name":"Winter Chill","hex":"#8eced8","rgb":{"r":142,"g":206,"b":216},"luminance":130.50346058246885},{"name":"Winter Chime","hex":"#83c7df","rgb":{"r":131,"g":199,"b":223},"luminance":125.8004992597406},{"name":"Winter Dusk","hex":"#b8b8cb","rgb":{"r":184,"g":184,"b":203},"luminance":123.40194684039632},{"name":"Winter Duvet","hex":"#ffffe0","rgb":{"r":255,"g":255,"b":224},"luminance":169.91464488383573},{"name":"Winter Escape","hex":"#b4e5ec","rgb":{"r":180,"g":229,"b":236},"luminance":147.2751185536783},{"name":"Winter Frost","hex":"#e4decd","rgb":{"r":228,"g":222,"b":205},"luminance":148.91379076499263},{"name":"Winter Haven","hex":"#e1e6eb","rgb":{"r":225,"g":230,"b":235},"luminance":153.20355682881515},{"name":"Winter Hazel","hex":"#d0c383","rgb":{"r":208,"g":195,"b":131},"luminance":131.12248260691223},{"name":"Winter Lite","hex":"#efe0c9","rgb":{"r":239,"g":224,"b":201},"luminance":151.396235293352},{"name":"Winter Meadow","hex":"#b7fffa","rgb":{"r":183,"g":255,"b":250},"luminance":161.9005846623168},{"name":"Winter Mist","hex":"#e7fbec","rgb":{"r":231,"g":251,"b":236},"luminance":164.93193610092618},{"name":"Winter Morn","hex":"#d9d9d6","rgb":{"r":217,"g":217,"b":214},"luminance":145.01854414522302},{"name":"Winter Morning Mist","hex":"#a7b3b5","rgb":{"r":167,"g":179,"b":181},"luminance":118.14991228942998},{"name":"Winter Moss","hex":"#5b5a41","rgb":{"r":91,"g":90,"b":65},"luminance":59.885279334741355},{"name":"Winter Nap","hex":"#a99f97","rgb":{"r":169,"g":159,"b":151},"luminance":107.52094049997889},{"name":"Winter Oasis","hex":"#f2faed","rgb":{"r":242,"g":250,"b":237},"luminance":165.83490280396344},{"name":"Winter Orchid","hex":"#e7e3e7","rgb":{"r":231,"g":227,"b":231},"luminance":152.3788119063802},{"name":"Winter Palace","hex":"#41638a","rgb":{"r":65,"g":99,"b":138},"luminance":63.26401677098918},{"name":"Winter Park","hex":"#95928d","rgb":{"r":149,"g":146,"b":141},"luminance":97.91832249890722},{"name":"Winter Peach","hex":"#ebd9d0","rgb":{"r":235,"g":217,"b":208},"luminance":147.39348292919874},{"name":"Winter Pear","hex":"#b0b487","rgb":{"r":176,"g":180,"b":135},"luminance":119.03853609650952},{"name":"Winter Sea","hex":"#303e55","rgb":{"r":48,"g":62,"b":85},"luminance":40.30383654194721},{"name":"Winter Shamrock","hex":"#e3efdd","rgb":{"r":227,"g":239,"b":221},"luminance":157.87212424617587},{"name":"Winter Sky","hex":"#a9c0cb","rgb":{"r":169,"g":192,"b":203},"luminance":125.66274603477356},{"name":"Winter Solstice","hex":"#49545c","rgb":{"r":73,"g":84,"b":92},"luminance":54.93355019475803},{"name":"Winter Squash","hex":"#acb99f","rgb":{"r":172,"g":185,"b":159},"luminance":121.51652186019808},{"name":"Winter Storm","hex":"#4b7079","rgb":{"r":75,"g":112,"b":121},"luminance":70.81969074346483},{"name":"Winter Sunset","hex":"#ca6636","rgb":{"r":202,"g":102,"b":54},"luminance":85.26846202436161},{"name":"Winter Twig","hex":"#948a7a","rgb":{"r":148,"g":138,"b":122},"luminance":93.34690141616913},{"name":"Winter Waves","hex":"#21424d","rgb":{"r":33,"g":66,"b":77},"luminance":40.9310827733643},{"name":"Winter Wedding","hex":"#f1e4dc","rgb":{"r":241,"g":228,"b":220},"luminance":154.05706987022697},{"name":"Winter Wheat","hex":"#dfc09f","rgb":{"r":223,"g":192,"b":159},"luminance":132.19896301030505},{"name":"Winter White","hex":"#f5ecd2","rgb":{"r":245,"g":236,"b":210},"luminance":158.52612923111442},{"name":"Winter Willow Green","hex":"#c1d8ac","rgb":{"r":193,"g":216,"b":172},"luminance":140.67971700639717},{"name":"Winter Wizard","hex":"#a0e6ff","rgb":{"r":160,"g":230,"b":255},"luminance":146.1555014359706},{"name":"Winter's Breath","hex":"#d4dddd","rgb":{"r":212,"g":221,"b":221},"luminance":146.5669495793646},{"name":"Winter's Day","hex":"#def7fe","rgb":{"r":222,"g":247,"b":254},"luminance":162.06880927865177},{"name":"Wintergreen","hex":"#20f986","rgb":{"r":32,"g":249,"b":134},"luminance":147.27024604107916},{"name":"Wintergreen Dream","hex":"#56887d","rgb":{"r":86,"g":136,"b":125},"luminance":85.07303050908672},{"name":"Wintergreen Mint","hex":"#c6e5ca","rgb":{"r":198,"g":229,"b":202},"luminance":148.67652308619543},{"name":"Wintergreen Shadow","hex":"#4f9e81","rgb":{"r":79,"g":158,"b":129},"luminance":96.82994677784347},{"name":"Wintermint","hex":"#94d2bf","rgb":{"r":148,"g":210,"b":191},"luminance":132.7698741431956},{"name":"Winterspring Lilac","hex":"#b5afff","rgb":{"r":181,"g":175,"b":255},"luminance":119.69275953874569},{"name":"Wintessa","hex":"#8ba494","rgb":{"r":139,"g":164,"b":148},"luminance":106.20503250317284},{"name":"Wiped Out","hex":"#8b7180","rgb":{"r":139,"g":113,"b":128},"luminance":79.62439793178973},{"name":"Wire Wool","hex":"#676662","rgb":{"r":103,"g":102,"b":98},"luminance":68.25074848673822},{"name":"Wise Owl","hex":"#cdbba5","rgb":{"r":205,"g":187,"b":165},"luminance":127.12248615410256},{"name":"Wish","hex":"#b6bcdf","rgb":{"r":182,"g":188,"b":223},"luminance":125.64252283363304},{"name":"Wishard","hex":"#53786a","rgb":{"r":83,"g":120,"b":106},"luminance":75.6551395808639},{"name":"Wishful White","hex":"#f4f1e8","rgb":{"r":244,"g":241,"b":232},"luminance":161.35360773468932},{"name":"Wishing Star","hex":"#604f5a","rgb":{"r":96,"g":79,"b":90},"luminance":55.49452536061553},{"name":"Wishing Well","hex":"#d0d1c1","rgb":{"r":208,"g":209,"b":193},"luminance":139.29483607442165},{"name":"Wishy-Washy Beige","hex":"#ebdedb","rgb":{"r":235,"g":222,"b":219},"luminance":150.1406339969297},{"name":"Wishy-Washy Blue","hex":"#c6e0e1","rgb":{"r":198,"g":224,"b":225},"luminance":146.46464914101287},{"name":"Wishy-Washy Brown","hex":"#d1c2c2","rgb":{"r":209,"g":194,"b":194},"luminance":131.76661724807235},{"name":"Wishy-Washy Green","hex":"#dfeae1","rgb":{"r":223,"g":234,"b":225},"luminance":154.8255954065735},{"name":"Wishy-Washy Lichen","hex":"#deede4","rgb":{"r":222,"g":237,"b":228},"luminance":156.31928578713504},{"name":"Wishy-Washy Lilies","hex":"#f5dfe7","rgb":{"r":245,"g":223,"b":231},"luminance":152.2985435977639},{"name":"Wishy-Washy Lime","hex":"#eef5db","rgb":{"r":238,"g":245,"b":219},"luminance":162.38868687504066},{"name":"Wishy-Washy Mauve","hex":"#eddde4","rgb":{"r":237,"g":221,"b":228},"luminance":150.08745238027063},{"name":"Wishy-Washy Mint","hex":"#dde2d9","rgb":{"r":221,"g":226,"b":217},"luminance":150.25847439994857},{"name":"Wishy-Washy Pink","hex":"#f0dee7","rgb":{"r":240,"g":222,"b":231},"luminance":151.07850857087516},{"name":"Wishy-Washy Red","hex":"#e1dadd","rgb":{"r":225,"g":218,"b":221},"luminance":146.75135575864368},{"name":"Wishy-Washy Yellow","hex":"#e9e9d5","rgb":{"r":233,"g":233,"b":213},"luminance":155.40081355642897},{"name":"Wisley Pink","hex":"#f2a599","rgb":{"r":242,"g":165,"b":153},"luminance":122.1507042673107},{"name":"Wisp","hex":"#a9badd","rgb":{"r":169,"g":186,"b":221},"luminance":122.91797558127939},{"name":"Wisp of Smoke","hex":"#e5e7e9","rgb":{"r":229,"g":231,"b":233},"luminance":154.20883273664967},{"name":"Wisp Pink","hex":"#f9e8e2","rgb":{"r":249,"g":232,"b":226},"luminance":157.330279835129},{"name":"Wispy Mauve","hex":"#c6aeaa","rgb":{"r":198,"g":174,"b":170},"luminance":119.63541385392537},{"name":"Wisteria","hex":"#a87dc2","rgb":{"r":168,"g":125,"b":194},"luminance":91.6311186497251},{"name":"Wisteria Blue","hex":"#84a2d4","rgb":{"r":132,"g":162,"b":212},"luminance":105.75766678591202},{"name":"Wisteria Fragrance","hex":"#bbbcde","rgb":{"r":187,"g":188,"b":222},"luminance":126.27432505858029},{"name":"Wisteria Powder","hex":"#e6c8ff","rgb":{"r":230,"g":200,"b":255},"luminance":139.12993135914357},{"name":"Wisteria Purple","hex":"#875f9a","rgb":{"r":135,"g":95,"b":154},"luminance":71.04422274893292},{"name":"Wisteria Trellis","hex":"#b2adbf","rgb":{"r":178,"g":173,"b":191},"luminance":116.7017307540895},{"name":"Wisteria Yellow","hex":"#f7c114","rgb":{"r":247,"g":193,"b":20},"luminance":135.2564774419325},{"name":"Wisteria-Wise","hex":"#b2a7cc","rgb":{"r":178,"g":167,"b":204},"luminance":113.94344062296872},{"name":"Wistful","hex":"#a29ecd","rgb":{"r":162,"g":158,"b":205},"luminance":107.21108739304904},{"name":"Wistful Beige","hex":"#eaddd7","rgb":{"r":234,"g":221,"b":215},"luminance":149.415781579457},{"name":"Wistful Mauve","hex":"#946c74","rgb":{"r":148,"g":108,"b":116},"luminance":78.43574756448746},{"name":"Witch Haze","hex":"#fbf073","rgb":{"r":251,"g":240,"b":115},"luminance":160.16054102368662},{"name":"Witch Soup","hex":"#692746","rgb":{"r":105,"g":39,"b":70},"luminance":39.66630653337918},{"name":"Witch Wart","hex":"#113300","rgb":{"r":17,"g":51,"b":0},"luminance":30.365455010587276},{"name":"Witch Wood","hex":"#7c4a33","rgb":{"r":124,"g":74,"b":51},"luminance":57.404635840670565},{"name":"Witchcraft","hex":"#474c50","rgb":{"r":71,"g":76,"b":80},"luminance":50.240177000086284},{"name":"Witches Cauldron","hex":"#35343f","rgb":{"r":53,"g":52,"b":63},"luminance":35.13435795627977},{"name":"With A Twist","hex":"#d1d1bb","rgb":{"r":209,"g":209,"b":187},"luminance":139.32229072908612},{"name":"With the Grain","hex":"#bca380","rgb":{"r":188,"g":163,"b":128},"luminance":111.92662404003795},{"name":"Withered Rose","hex":"#a26666","rgb":{"r":162,"g":102,"b":102},"luminance":77.88675178745099},{"name":"Witness","hex":"#90c0c9","rgb":{"r":144,"g":192,"b":201},"luminance":122.80497607181884},{"name":"Wizard","hex":"#4d5b88","rgb":{"r":77,"g":91,"b":136},"luminance":60.19807666362772},{"name":"Wizard Blue","hex":"#0073cf","rgb":{"r":0,"g":115,"b":207},"luminance":71.51077281780697},{"name":"Wizard Grey","hex":"#525e68","rgb":{"r":82,"g":94,"b":104},"luminance":61.532989070904065},{"name":"Wizard Time","hex":"#6d4660","rgb":{"r":109,"g":70,"b":96},"luminance":53.57548429085825},{"name":"Wizard White","hex":"#dff1fd","rgb":{"r":223,"g":241,"b":253},"luminance":159.030171294632},{"name":"Wizard's Brew","hex":"#a090b8","rgb":{"r":160,"g":144,"b":184},"luminance":99.36619626412192},{"name":"Wizard's Spell","hex":"#584b4e","rgb":{"r":88,"g":75,"b":78},"luminance":52.053718724025856},{"name":"Woad Blue","hex":"#597fb9","rgb":{"r":89,"g":127,"b":185},"luminance":81.91756113312944},{"name":"Woad Purple","hex":"#584769","rgb":{"r":88,"g":71,"b":105},"luminance":50.72055375289193},{"name":"Wobbegong Brown","hex":"#c19a6b","rgb":{"r":193,"g":154,"b":107},"luminance":107.93835026069279},{"name":"Wolf Lichen","hex":"#a8ff04","rgb":{"r":168,"g":255,"b":4},"luminance":157.88939478318358},{"name":"Wolf's Bane","hex":"#3d343f","rgb":{"r":61,"g":52,"b":63},"luminance":36.27611915572006},{"name":"Wolf's Fur","hex":"#5c5451","rgb":{"r":92,"g":84,"b":81},"luminance":57.212198734186046},{"name":"Wolfram","hex":"#7d8574","rgb":{"r":125,"g":133,"b":116},"luminance":87.56052673436815},{"name":"Wolverine","hex":"#91989d","rgb":{"r":145,"g":152,"b":157},"luminance":100.80137203927335},{"name":"Wonder Lust","hex":"#ef8e9f","rgb":{"r":239,"g":142,"b":159},"luminance":111.27944874504007},{"name":"Wonder Wine","hex":"#635d63","rgb":{"r":99,"g":93,"b":99},"luminance":63.11711557097646},{"name":"Wonder Wish","hex":"#a97898","rgb":{"r":169,"g":120,"b":152},"luminance":88.40494977658209},{"name":"Wood Ash","hex":"#d7cab0","rgb":{"r":215,"g":202,"b":176},"luminance":136.36318710341143},{"name":"Wood Avens","hex":"#fbeeac","rgb":{"r":251,"g":238,"b":172},"luminance":159.79547084007106},{"name":"Wood Bark","hex":"#302621","rgb":{"r":48,"g":38,"b":33},"luminance":26.78974027496347},{"name":"Wood Brown","hex":"#554545","rgb":{"r":85,"g":69,"b":69},"luminance":48.45914970364214},{"name":"Wood Charcoal","hex":"#464646","rgb":{"r":70,"g":70,"b":70},"luminance":46.79886109725321},{"name":"Wood Chi","hex":"#90835e","rgb":{"r":144,"g":131,"b":94},"luminance":88.77950439712986},{"name":"Wood Garlic","hex":"#7a7229","rgb":{"r":122,"g":114,"b":41},"luminance":76.35777291147247},{"name":"Wood Lake","hex":"#a08475","rgb":{"r":160,"g":132,"b":117},"luminance":92.03443974947639},{"name":"Wood Pigeon","hex":"#aabbcc","rgb":{"r":170,"g":187,"b":204},"luminance":123.18183225216289},{"name":"Wood Stain Brown","hex":"#796a4e","rgb":{"r":121,"g":106,"b":78},"luminance":72.52285838961396},{"name":"Wood Thrush","hex":"#a47d43","rgb":{"r":164,"g":125,"b":67},"luminance":88.58193362644553},{"name":"Wood Violet","hex":"#75406a","rgb":{"r":117,"g":64,"b":106},"luminance":52.73696966076075},{"name":"Wood's Creek","hex":"#61633f","rgb":{"r":97,"g":99,"b":63},"luminance":65.34428744733545},{"name":"Woodbine","hex":"#7b7f32","rgb":{"r":123,"g":127,"b":50},"luminance":83.32221270465637},{"name":"Woodbridge","hex":"#847451","rgb":{"r":132,"g":116,"b":81},"luminance":79.24336088278942},{"name":"Woodbridge Trail","hex":"#b3987d","rgb":{"r":179,"g":152,"b":125},"luminance":105.01658020046168},{"name":"Woodburn","hex":"#463629","rgb":{"r":70,"g":54,"b":41},"luminance":38.2710645266107},{"name":"Woodchuck","hex":"#8e746c","rgb":{"r":142,"g":116,"b":108},"luminance":81.18366567235061},{"name":"Wooded Acre","hex":"#b59b7e","rgb":{"r":181,"g":155,"b":126},"luminance":106.83380027875073},{"name":"Wooden Peg","hex":"#a89983","rgb":{"r":168,"g":153,"b":131},"luminance":103.9821806897701},{"name":"Woodgrain","hex":"#996633","rgb":{"r":153,"g":102,"b":51},"luminance":75.57437714596132},{"name":"Woodland","hex":"#626746","rgb":{"r":98,"g":103,"b":70},"luminance":67.65959004457535},{"name":"Woodland Brown","hex":"#5f4737","rgb":{"r":95,"g":71,"b":55},"luminance":50.82449462611507},{"name":"Woodland Grass","hex":"#004400","rgb":{"r":0,"g":68,"b":0},"luminance":39.916},{"name":"Woodland Nymph","hex":"#69804b","rgb":{"r":105,"g":128,"b":75},"luminance":81.87897789420676},{"name":"Woodland Walk","hex":"#8b8d63","rgb":{"r":139,"g":141,"b":99},"luminance":93.30094750858642},{"name":"Woodlawn Green","hex":"#405b50","rgb":{"r":64,"g":91,"b":80},"luminance":57.46944218452098},{"name":"Woodrose","hex":"#ae8c8e","rgb":{"r":174,"g":140,"b":142},"luminance":98.60176681986991},{"name":"Woodrush","hex":"#45402b","rgb":{"r":69,"g":64,"b":43},"luminance":43.13956871597119},{"name":"Woodsmoke","hex":"#2b3230","rgb":{"r":43,"g":50,"b":48},"luminance":32.506426026249024},{"name":"Woodward Park","hex":"#755f4a","rgb":{"r":117,"g":95,"b":74},"luminance":66.36800140127771},{"name":"Wooed","hex":"#40446c","rgb":{"r":64,"g":68,"b":108},"luminance":45.946260957775436},{"name":"Woohringa","hex":"#5f655a","rgb":{"r":95,"g":101,"b":90},"luminance":66.53615553967633},{"name":"Wool Tweed","hex":"#917747","rgb":{"r":145,"g":119,"b":71},"luminance":82.61120063284397},{"name":"Woolen Mittens","hex":"#b59f55","rgb":{"r":181,"g":159,"b":85},"luminance":108.32271760808071},{"name":"Woolen Vest","hex":"#b0a582","rgb":{"r":176,"g":165,"b":130},"luminance":111.21964215461223},{"name":"Woolly Beige","hex":"#e7d5c9","rgb":{"r":231,"g":213,"b":201},"luminance":144.66626807241553},{"name":"Woolly Mammoth","hex":"#bb9c7c","rgb":{"r":187,"g":156,"b":124},"luminance":108.21978215187829},{"name":"Wooster Smoke","hex":"#a5a192","rgb":{"r":165,"g":161,"b":146},"luminance":107.90059318650663},{"name":"Workout Routine","hex":"#ffd789","rgb":{"r":255,"g":215,"b":137},"luminance":148.27313975902715},{"name":"World Peace","hex":"#005477","rgb":{"r":0,"g":84,"b":119},"luminance":51.14015271780091},{"name":"Worn Denim","hex":"#4282c6","rgb":{"r":66,"g":130,"b":198},"luminance":81.98867019289922},{"name":"Worn Olive","hex":"#6f6c0a","rgb":{"r":111,"g":108,"b":10},"luminance":71.56718617495031},{"name":"Worn Silver","hex":"#c9c0bb","rgb":{"r":201,"g":192,"b":187},"luminance":129.4933918815937},{"name":"Worn Wooden","hex":"#634333","rgb":{"r":99,"g":67,"b":51},"luminance":49.56603714238208},{"name":"Woven Basket","hex":"#8e7b58","rgb":{"r":142,"g":123,"b":88},"luminance":84.35820759712713},{"name":"Woven Gold","hex":"#dcb639","rgb":{"r":220,"g":182,"b":57},"luminance":125.62935946664696},{"name":"Woven Navajo","hex":"#cead8e","rgb":{"r":206,"g":173,"b":142},"luminance":119.86858546341487},{"name":"Woven Reed","hex":"#dddcbf","rgb":{"r":221,"g":220,"b":191},"luminance":146.68906202236073},{"name":"Wrack White","hex":"#ecead0","rgb":{"r":236,"g":234,"b":208},"luminance":156.23302213040623},{"name":"Wreath","hex":"#76856a","rgb":{"r":118,"g":133,"b":106},"luminance":86.52123219765191},{"name":"Wren","hex":"#4a4139","rgb":{"r":74,"g":65,"b":57},"luminance":44.58237213294062},{"name":"Wrought Iron","hex":"#999e98","rgb":{"r":153,"g":158,"b":152},"luminance":104.85641663245983},{"name":"Wrought Iron Gate","hex":"#474749","rgb":{"r":71,"g":71,"b":73},"luminance":47.50682534120755},{"name":"Wulfenite","hex":"#ce7639","rgb":{"r":206,"g":118,"b":57},"luminance":92.91837060560198},{"name":"Wyvern Green","hex":"#86a96f","rgb":{"r":134,"g":169,"b":111},"luminance":107.73413238616627},{"name":"Xâkestari White","hex":"#fef2dc","rgb":{"r":254,"g":242,"b":220},"luminance":163.0219010808057},{"name":"Xanadu","hex":"#738678","rgb":{"r":115,"g":134,"b":120},"luminance":86.92842796807038},{"name":"Xanthe Yellow","hex":"#ffee55","rgb":{"r":255,"g":238,"b":85},"luminance":159.45206979214788},{"name":"Xanthous","hex":"#f1b42f","rgb":{"r":241,"g":180,"b":47},"luminance":128.00485633365633},{"name":"Xavier Blue","hex":"#6ab4e0","rgb":{"r":106,"g":180,"b":224},"luminance":113.22823204483942},{"name":"Xena","hex":"#847e54","rgb":{"r":132,"g":126,"b":84},"luminance":84.37890876279451},{"name":"Xenon Blue","hex":"#b7c0d7","rgb":{"r":183,"g":192,"b":215},"luminance":127.65924096985694},{"name":"Xereus Purple","hex":"#7d0061","rgb":{"r":125,"g":0,"b":97},"luminance":38.97653125920777},{"name":"Xiān Hóng Red","hex":"#e60626","rgb":{"r":230,"g":6,"b":38},"luminance":68.99625792751372},{"name":"Xiàng Yá Bái Ivory","hex":"#ece6d1","rgb":{"r":236,"g":230,"b":209},"luminance":154.19032548120518},{"name":"Xìng Huáng Yellow","hex":"#fce166","rgb":{"r":252,"g":225,"b":102},"luminance":152.50028561612598},{"name":"Xmas Candy","hex":"#990020","rgb":{"r":153,"g":0,"b":32},"luminance":45.89222061526332},{"name":"Xoxo","hex":"#f08497","rgb":{"r":240,"g":132,"b":151},"luminance":107.00275534770121},{"name":"XV-88","hex":"#72491e","rgb":{"r":114,"g":73,"b":30},"luminance":54.861279578588025},{"name":"Y7K Blue","hex":"#1560fb","rgb":{"r":21,"g":96,"b":251},"luminance":63.51168979802065},{"name":"Yacht Club","hex":"#566062","rgb":{"r":86,"g":96,"b":98},"luminance":62.94101432293572},{"name":"Yahoo","hex":"#fabba9","rgb":{"r":250,"g":187,"b":169},"luminance":134.19379500185542},{"name":"Yale Blue","hex":"#0f4d92","rgb":{"r":15,"g":77,"b":146},"luminance":48.37445154211053},{"name":"Yam","hex":"#d0893f","rgb":{"r":208,"g":137,"b":63},"luminance":101.91487403220395},{"name":"Yamabuki Gold","hex":"#ffa400","rgb":{"r":255,"g":164,"b":0},"luminance":122.80402212061297},{"name":"Yamabukicha Gold","hex":"#cb7e1f","rgb":{"r":203,"g":126,"b":31},"luminance":95.74441189437637},{"name":"Yān Hūi Smoke","hex":"#a8c3bc","rgb":{"r":168,"g":195,"b":188},"luminance":126.82594637139515},{"name":"Yanagicha","hex":"#9c8a4d","rgb":{"r":156,"g":138,"b":77},"luminance":93.88657015782395},{"name":"Yanagizome Green","hex":"#8c9e5e","rgb":{"r":140,"g":158,"b":94},"luminance":102.31770507590561},{"name":"Yáng Chéng Orange","hex":"#f1a141","rgb":{"r":241,"g":161,"b":65},"luminance":119.07552489911602},{"name":"Yang Mist","hex":"#ede8dd","rgb":{"r":237,"g":232,"b":221},"luminance":155.57115497739292},{"name":"Yankee Doodle","hex":"#4d5a6b","rgb":{"r":77,"g":90,"b":107},"luminance":58.90550596506238},{"name":"Yankees Blue","hex":"#1c2841","rgb":{"r":28,"g":40,"b":65},"luminance":26.00593939852971},{"name":"Yardbird","hex":"#9e826a","rgb":{"r":158,"g":130,"b":106},"luminance":90.55962522007255},{"name":"Yarrow","hex":"#d8ad39","rgb":{"r":216,"g":173,"b":57},"luminance":120.52353571398409},{"name":"Yawl","hex":"#547497","rgb":{"r":84,"g":116,"b":151},"luminance":74.58991698614498},{"name":"Yearning","hex":"#061088","rgb":{"r":6,"g":16,"b":136},"luminance":18.215436201200344},{"name":"Yell Yellow","hex":"#ffffbf","rgb":{"r":255,"g":255,"b":191},"luminance":169.39010102718518},{"name":"Yellow","hex":"#ffff00","rgb":{"r":255,"g":255,"b":0},"luminance":167.98481851048328},{"name":"Yellow Acorn","hex":"#b68d4c","rgb":{"r":182,"g":141,"b":76},"luminance":99.43218748976611},{"name":"Yellow Avarice","hex":"#f5f5d9","rgb":{"r":245,"g":245,"b":217},"luminance":163.28201950612933},{"name":"Yellow Bell Pepper","hex":"#ffdd33","rgb":{"r":255,"g":221,"b":51},"luminance":150.5861784826217},{"name":"Yellow Bombinate","hex":"#faf3cf","rgb":{"r":250,"g":243,"b":207},"luminance":162.76020086311024},{"name":"Yellow Brick Road","hex":"#eac853","rgb":{"r":234,"g":200,"b":83},"luminance":136.99463712131217},{"name":"Yellow Brown","hex":"#ae8b0c","rgb":{"r":174,"g":139,"b":12},"luminance":96.7780643999455},{"name":"Yellow Canary","hex":"#ffeaac","rgb":{"r":255,"g":234,"b":172},"luminance":158.3192782102041},{"name":"Yellow Cattleya","hex":"#fff44f","rgb":{"r":255,"g":244,"b":79},"luminance":162.5074399681442},{"name":"Yellow Chalk","hex":"#f5f9ad","rgb":{"r":245,"g":249,"b":173},"luminance":164.67809471207758},{"name":"Yellow Coneflower","hex":"#edb856","rgb":{"r":237,"g":184,"b":86},"luminance":129.55080566712041},{"name":"Yellow Cream","hex":"#efdc75","rgb":{"r":239,"g":220,"b":117},"luminance":148.1948594418848},{"name":"Yellow Currant","hex":"#f7c66b","rgb":{"r":247,"g":198,"b":107},"luminance":138.24449315976386},{"name":"Yellow Diamond","hex":"#f6f1d7","rgb":{"r":246,"g":241,"b":215},"luminance":161.3190723535193},{"name":"Yellow Dragon","hex":"#f8e47e","rgb":{"r":248,"g":228,"b":126},"luminance":153.6779701063233},{"name":"Yellow Emulsion","hex":"#f0f0d9","rgb":{"r":240,"g":240,"b":217},"luminance":160.0269997344198},{"name":"Yellow Endive","hex":"#d2cc81","rgb":{"r":210,"g":204,"b":129},"luminance":136.00894838208256},{"name":"Yellow Geranium","hex":"#ffe1a0","rgb":{"r":255,"g":225,"b":160},"luminance":153.5897237773413},{"name":"Yellow Green","hex":"#c8fd3d","rgb":{"r":200,"g":253,"b":61},"luminance":160.24954052040212},{"name":"Yellow Green Shade","hex":"#c5e384","rgb":{"r":197,"g":227,"b":132},"luminance":146.46262906967087},{"name":"Yellow Iris","hex":"#eee78e","rgb":{"r":238,"g":231,"b":142},"luminance":153.98905154912796},{"name":"Yellow Jacket","hex":"#ffcc3a","rgb":{"r":255,"g":204,"b":58},"luminance":142.1147496673023},{"name":"Yellow Jasmine","hex":"#eee8aa","rgb":{"r":238,"g":232,"b":170},"luminance":154.87316262025516},{"name":"Yellow Jasper","hex":"#daa436","rgb":{"r":218,"g":164,"b":54},"luminance":116.42215117407856},{"name":"Yellow Maize","hex":"#c0a85a","rgb":{"r":192,"g":168,"b":90},"luminance":114.56902513332301},{"name":"Yellow Mandarin","hex":"#d28034","rgb":{"r":210,"g":128,"b":52},"luminance":98.0976237224939},{"name":"Yellow Mask","hex":"#f6d255","rgb":{"r":246,"g":210,"b":85},"luminance":143.8734857991562},{"name":"Yellow Metal","hex":"#73633e","rgb":{"r":115,"g":99,"b":62},"luminance":67.89260355885611},{"name":"Yellow Nile","hex":"#95804a","rgb":{"r":149,"g":128,"b":74},"luminance":87.75748511095792},{"name":"Yellow Ocher","hex":"#c39143","rgb":{"r":195,"g":145,"b":67},"luminance":103.45228510767657},{"name":"Yellow Ochre","hex":"#cb9d06","rgb":{"r":203,"g":157,"b":6},"luminance":110.35340930845769},{"name":"Yellow Orange","hex":"#fcb001","rgb":{"r":252,"g":176,"b":1},"luminance":127.86986917956864},{"name":"Yellow Pear","hex":"#ece99b","rgb":{"r":236,"g":233,"b":155},"luminance":154.91227658581485},{"name":"Yellow Phosphenes","hex":"#e4e4cb","rgb":{"r":228,"g":228,"b":203},"luminance":151.97055189739885},{"name":"Yellow Powder","hex":"#fcfd74","rgb":{"r":252,"g":253,"b":116},"luminance":167.05601575818812},{"name":"Yellow Rose","hex":"#fff000","rgb":{"r":255,"g":240,"b":0},"luminance":160.1888711022086},{"name":"Yellow Salmonberry","hex":"#fff47c","rgb":{"r":255,"g":244,"b":124},"luminance":162.87230122092583},{"name":"Yellow Sand","hex":"#a28744","rgb":{"r":162,"g":135,"b":68},"luminance":93.19926701964988},{"name":"Yellow Sea","hex":"#f49f35","rgb":{"r":244,"g":159,"b":53},"luminance":118.61758971164437},{"name":"Yellow Shimmer","hex":"#f8e2ca","rgb":{"r":248,"g":226,"b":202},"luminance":153.7140661488076},{"name":"Yellow Stagshorn","hex":"#fada5e","rgb":{"r":250,"g":218,"b":94},"luminance":148.58563965605828},{"name":"Yellow Submarine","hex":"#ffff14","rgb":{"r":255,"g":255,"b":20},"luminance":168.00029062474863},{"name":"Yellow Summer","hex":"#f9b500","rgb":{"r":249,"g":181,"b":0},"luminance":129.73579463663836},{"name":"Yellow Sunshine","hex":"#fff601","rgb":{"r":255,"g":246,"b":1},"luminance":163.2949804035629},{"name":"Yellow Tan","hex":"#ffe36e","rgb":{"r":255,"g":227,"b":110},"luminance":154.031969493349},{"name":"Yellow Tang","hex":"#ffd300","rgb":{"r":255,"g":211,"b":0},"luminance":145.44365394887464},{"name":"Yellow Urn Orchid","hex":"#fffdd0","rgb":{"r":255,"g":253,"b":208},"luminance":168.61517158903584},{"name":"Yellow Varnish","hex":"#eab565","rgb":{"r":234,"g":181,"b":101},"luminance":127.73503184717964},{"name":"Yellow Warbler","hex":"#ffba6f","rgb":{"r":255,"g":186,"b":111},"luminance":133.76895329260822},{"name":"Yellow Yarn","hex":"#fef6be","rgb":{"r":254,"g":246,"b":190},"luminance":164.58702293923417},{"name":"Yellow-Bellied","hex":"#ffee33","rgb":{"r":255,"g":238,"b":51},"luminance":159.26352079807853},{"name":"Yellow-Green Grosbeak","hex":"#c8cd37","rgb":{"r":200,"g":205,"b":55},"luminance":134.52087245108098},{"name":"Yellow-Rumped Warbler","hex":"#eebb77","rgb":{"r":238,"g":187,"b":119},"luminance":131.5191999709548},{"name":"Yellowed Bone","hex":"#f6f1c4","rgb":{"r":246,"g":241,"b":196},"luminance":161.00421528953828},{"name":"Yellowish","hex":"#faee66","rgb":{"r":250,"g":238,"b":102},"luminance":158.8727142085764},{"name":"Yellowish Brown","hex":"#9b7a01","rgb":{"r":155,"g":122,"b":1},"luminance":85.30203407305126},{"name":"Yellowish Green","hex":"#b0dd16","rgb":{"r":176,"g":221,"b":22},"luminance":140.0166774673646},{"name":"Yellowish Grey","hex":"#edeeda","rgb":{"r":237,"g":238,"b":218},"luminance":158.60943575021003},{"name":"Yellowish Orange","hex":"#ffab0f","rgb":{"r":255,"g":171,"b":15},"luminance":126.06254897470541},{"name":"Yellowish Tan","hex":"#fcfc81","rgb":{"r":252,"g":252,"b":129},"luminance":166.65862508733233},{"name":"Yellowish White","hex":"#e9f1d0","rgb":{"r":233,"g":241,"b":208},"luminance":159.46366959906572},{"name":"Yellowstone","hex":"#ceb736","rgb":{"r":206,"g":183,"b":54},"luminance":123.97979034100678},{"name":"Yellowstone Park","hex":"#e4d6ba","rgb":{"r":228,"g":214,"b":186},"luminance":144.48845325492275},{"name":"Yellowy Green","hex":"#bff128","rgb":{"r":191,"g":241,"b":40},"luminance":152.62746663035455},{"name":"Yeti Footprint","hex":"#c7d7e0","rgb":{"r":199,"g":215,"b":224},"luminance":141.84554389193903},{"name":"Yín Bái Silver","hex":"#e0e1e2","rgb":{"r":224,"g":225,"b":226},"luminance":150.31092407739365},{"name":"Yin Hūi Silver","hex":"#848999","rgb":{"r":132,"g":137,"b":153},"luminance":91.2642424446727},{"name":"Yin Mist","hex":"#3b3c3c","rgb":{"r":59,"g":60,"b":60},"luminance":39.98048125023009},{"name":"Yín Sè Silver","hex":"#b1c4cb","rgb":{"r":177,"g":196,"b":203},"luminance":128.73755783375728},{"name":"Yíng Guāng Sè Green","hex":"#05ffa6","rgb":{"r":5,"g":255,"b":166},"luminance":150.8839024747173},{"name":"Yíng Guāng Sè Pink","hex":"#ff69af","rgb":{"r":255,"g":105,"b":175},"luminance":100.05086581334515},{"name":"Yíng Guāng Sè Purple","hex":"#632de9","rgb":{"r":99,"g":45,"b":233},"luminance":47.744227609209474},{"name":"YInMn Blue","hex":"#2e5090","rgb":{"r":46,"g":80,"b":144},"luminance":51.61297484160354},{"name":"Yippie Ya Yellow","hex":"#f9f59f","rgb":{"r":249,"g":245,"b":159},"luminance":162.95477133855272},{"name":"Yippie Yellow","hex":"#ffff84","rgb":{"r":255,"g":255,"b":132},"luminance":168.6574681240057},{"name":"Yolande","hex":"#d5a585","rgb":{"r":213,"g":165,"b":133},"luminance":116.90513777417995},{"name":"Yolk Yellow","hex":"#e2b051","rgb":{"r":226,"g":176,"b":81},"luminance":123.79370572044445},{"name":"York Pink","hex":"#d7837f","rgb":{"r":215,"g":131,"b":127},"luminance":101.26856530039318},{"name":"York Plum","hex":"#d3bfe5","rgb":{"r":211,"g":191,"b":229},"luminance":131.27058637029089},{"name":"York River Green","hex":"#67706d","rgb":{"r":103,"g":112,"b":109},"luminance":73.65551045916388},{"name":"Yoshi's Green","hex":"#55aa00","rgb":{"r":85,"g":170,"b":0},"luminance":102.97556178530904},{"name":"You're Blushing","hex":"#e2caaf","rgb":{"r":226,"g":202,"b":175},"luminance":137.92766746378334},{"name":"Young Apricot","hex":"#fcd8b5","rgb":{"r":252,"g":216,"b":181},"luminance":148.92714434917497},{"name":"Young At Heart","hex":"#d5a1a9","rgb":{"r":213,"g":161,"b":169},"luminance":115.58021359211965},{"name":"Young Bamboo","hex":"#68be8d","rgb":{"r":104,"g":190,"b":141},"luminance":116.89429238418785},{"name":"Young Bud","hex":"#86af38","rgb":{"r":134,"g":175,"b":56},"luminance":110.44666331311235},{"name":"Young Colt","hex":"#938c83","rgb":{"r":147,"g":140,"b":131},"luminance":94.38454833816814},{"name":"Young Cornflower","hex":"#bbffff","rgb":{"r":187,"g":255,"b":255},"luminance":162.40975245963526},{"name":"Young Crab","hex":"#f6a09d","rgb":{"r":246,"g":160,"b":157},"luminance":120.62958061769093},{"name":"Young Fawn","hex":"#c3b4b3","rgb":{"r":195,"g":180,"b":179},"luminance":122.39245671609014},{"name":"Young Fern","hex":"#71bc78","rgb":{"r":113,"g":188,"b":120},"luminance":116.22026718692398},{"name":"Young Gecko","hex":"#aac0ad","rgb":{"r":170,"g":192,"b":173},"luminance":125.19919248940865},{"name":"Young Grass","hex":"#c3d825","rgb":{"r":195,"g":216,"b":37},"luminance":139.61903814666536},{"name":"Young Green Onion","hex":"#aacf53","rgb":{"r":170,"g":207,"b":83},"luminance":132.05171496425177},{"name":"Young Greens","hex":"#d8e698","rgb":{"r":216,"g":230,"b":152},"luminance":150.66204810767707},{"name":"Young Leaf","hex":"#b0c86f","rgb":{"r":176,"g":200,"b":111},"luminance":129.2755548895459},{"name":"Young Leaves","hex":"#b9d08b","rgb":{"r":185,"g":208,"b":139},"luminance":134.97510198921873},{"name":"Young Mahogany","hex":"#ca3435","rgb":{"r":202,"g":52,"b":53},"luminance":67.94217205830265},{"name":"Young Night","hex":"#232323","rgb":{"r":35,"g":35,"b":35},"luminance":23.399430548626604},{"name":"Young Peach","hex":"#f2e1d2","rgb":{"r":242,"g":225,"b":210},"luminance":152.4880631033131},{"name":"Young Prince","hex":"#b28ebc","rgb":{"r":178,"g":142,"b":188},"luminance":101.19190295670894},{"name":"Young Purple","hex":"#bc64a4","rgb":{"r":188,"g":100,"b":164},"luminance":83.39675869001144},{"name":"Young Redwood","hex":"#ab4e52","rgb":{"r":171,"g":78,"b":82},"luminance":69.267001819048},{"name":"Young Salmon","hex":"#ffb6b4","rgb":{"r":255,"g":182,"b":180},"luminance":132.84530093684157},{"name":"Young Tangerine","hex":"#ffa474","rgb":{"r":255,"g":164,"b":116},"luminance":123.51397501902365},{"name":"Young Turk","hex":"#c9afa9","rgb":{"r":201,"g":175,"b":169},"luminance":120.56323727405463},{"name":"Young Wheat","hex":"#e1e3a9","rgb":{"r":225,"g":227,"b":169},"luminance":150.50714395669064},{"name":"Your Majesty","hex":"#61496e","rgb":{"r":97,"g":73,"b":110},"luminance":53.241279191995375},{"name":"Your Pink","hex":"#ffc5bb","rgb":{"r":255,"g":197,"b":187},"luminance":140.14326765849296},{"name":"Your Shadow","hex":"#787e93","rgb":{"r":120,"g":126,"b":147},"luminance":83.8962597974427},{"name":"Youth","hex":"#e2c9c8","rgb":{"r":226,"g":201,"b":200},"luminance":137.8659408447206},{"name":"Yreka!","hex":"#a7b3b7","rgb":{"r":167,"g":179,"b":183},"luminance":118.18994399694078},{"name":"Yriel Yellow","hex":"#ffdb58","rgb":{"r":255,"g":219,"b":88},"luminance":149.7992485228147},{"name":"Yù Shí Bái White","hex":"#c0e2e1","rgb":{"r":192,"g":226,"b":225},"luminance":146.8087436360655},{"name":"Yucatan","hex":"#e9af78","rgb":{"r":233,"g":175,"b":120},"luminance":124.87217029426533},{"name":"Yucca","hex":"#75978f","rgb":{"r":117,"g":151,"b":143},"luminance":96.6751429375721},{"name":"Yucca Cream","hex":"#a1d7c9","rgb":{"r":161,"g":215,"b":201},"luminance":137.0040756401064},{"name":"Yuè Guāng Lán Blue","hex":"#2138ab","rgb":{"r":33,"g":56,"b":171},"luminance":39.47077537875332},{"name":"Yuè Guāng Lán Moonlight","hex":"#5959ab","rgb":{"r":89,"g":89,"b":171},"luminance":61.785859272166796},{"name":"Yukon Gold","hex":"#826a21","rgb":{"r":130,"g":106,"b":33},"luminance":73.46160104435512},{"name":"Yule Tree","hex":"#66b032","rgb":{"r":102,"g":176,"b":50},"luminance":107.8702338367726},{"name":"Yuma","hex":"#c7b882","rgb":{"r":199,"g":184,"b":130},"luminance":124.20036016453413},{"name":"Yuma Gold","hex":"#ffd678","rgb":{"r":255,"g":214,"b":120},"luminance":147.58158539939865},{"name":"Yuzu Jam","hex":"#fdd200","rgb":{"r":253,"g":210,"b":0},"luminance":144.63043078481098},{"name":"Yuzu Soy","hex":"#112200","rgb":{"r":17,"g":34,"b":0},"luminance":20.595112357061804},{"name":"Yves Klein Blue","hex":"#00008b","rgb":{"r":0,"g":0,"b":139},"luminance":15.846},{"name":"Zaffre","hex":"#0014a8","rgb":{"r":0,"g":20,"b":168},"luminance":22.463897791790277},{"name":"Zahri Pink","hex":"#ec6d71","rgb":{"r":236,"g":109,"b":113},"luminance":96.11996831564187},{"name":"Zambezi","hex":"#6b5a5a","rgb":{"r":107,"g":90,"b":90},"luminance":62.60853415469811},{"name":"Zamesi Desert","hex":"#dda026","rgb":{"r":221,"g":160,"b":38},"luminance":114.91808763201726},{"name":"Zanah","hex":"#b2c6b1","rgb":{"r":178,"g":198,"b":177},"luminance":129.41489884862563},{"name":"Zanci","hex":"#d38977","rgb":{"r":211,"g":137,"b":119},"luminance":103.1090385853733},{"name":"Zandri Dust","hex":"#a39a61","rgb":{"r":163,"g":154,"b":97},"luminance":103.29265674286822},{"name":"Zangief's Chest","hex":"#823c3d","rgb":{"r":130,"g":60,"b":61},"luminance":52.912034699111686},{"name":"Zǎo Hóng Maroon","hex":"#c1264c","rgb":{"r":193,"g":38,"b":76},"luminance":62.47175666651291},{"name":"Zappy Zebra","hex":"#f1f3f3","rgb":{"r":241,"g":243,"b":243},"luminance":162.1923400349104},{"name":"Zard Yellow","hex":"#fde634","rgb":{"r":253,"g":230,"b":52},"luminance":154.8719144745102},{"name":"Zatar Leaf","hex":"#60a448","rgb":{"r":96,"g":164,"b":72},"luminance":100.79096538876884},{"name":"Zebra Finch","hex":"#cec6bb","rgb":{"r":206,"g":198,"b":187},"luminance":133.25449724493353},{"name":"Zebra Grass","hex":"#9da286","rgb":{"r":157,"g":162,"b":134},"luminance":107.14415644821699},{"name":"Zeftron","hex":"#0090ad","rgb":{"r":0,"g":144,"b":173},"luminance":86.79827226391087},{"name":"Zelyony Green","hex":"#016612","rgb":{"r":1,"g":102,"b":18},"luminance":59.909898856532884},{"name":"Zen","hex":"#cfd9de","rgb":{"r":207,"g":217,"b":222},"luminance":143.86329606261634},{"name":"Zen Blue","hex":"#9fa9be","rgb":{"r":159,"g":169,"b":190},"luminance":112.11840834581982},{"name":"Zen Essence","hex":"#c6bfa7","rgb":{"r":198,"g":191,"b":167},"luminance":128.20898539884013},{"name":"Zen Garden","hex":"#d1dac0","rgb":{"r":209,"g":218,"b":192},"luminance":144.0815976486935},{"name":"Zenith Heights","hex":"#a6c8c7","rgb":{"r":166,"g":200,"b":199},"luminance":129.46408209229307},{"name":"Zephyr","hex":"#c89fa5","rgb":{"r":200,"g":159,"b":165},"luminance":112.43177926636223},{"name":"Zephyr Blue","hex":"#d3d9d1","rgb":{"r":211,"g":217,"b":209},"luminance":144.129489827724},{"name":"Zephyr Green","hex":"#7cb083","rgb":{"r":124,"g":176,"b":131},"luminance":110.77465177557544},{"name":"Zero Gravity","hex":"#332233","rgb":{"r":51,"g":34,"b":51},"luminance":25.780930181046607},{"name":"Zest","hex":"#c6723b","rgb":{"r":198,"g":114,"b":59},"luminance":89.59985828113791},{"name":"Zeus","hex":"#3b3c38","rgb":{"r":59,"g":60,"b":56},"luminance":39.904996391429485},{"name":"Zeus Palace","hex":"#3c343d","rgb":{"r":60,"g":52,"b":61},"luminance":36.082077157503},{"name":"Zeus Purple","hex":"#660077","rgb":{"r":102,"g":0,"b":119},"luminance":33.37910064696171},{"name":"Zeus'Temple","hex":"#6c94cd","rgb":{"r":108,"g":148,"b":205},"luminance":95.58435823920145},{"name":"Zheleznogorsk Yellow","hex":"#fef200","rgb":{"r":254,"g":242,"b":0},"luminance":161.08114052240876},{"name":"Zhēn Zhū Bái Pearl","hex":"#f8f8f9","rgb":{"r":248,"g":248,"b":249},"luminance":165.82115629798267},{"name":"Zhohltyi Yellow","hex":"#e4c500","rgb":{"r":228,"g":197,"b":0},"luminance":134.23784825823157},{"name":"Zhū Hóng Vermillion","hex":"#cb464a","rgb":{"r":203,"g":70,"b":74},"luminance":73.78129847732419},{"name":"Zǐ Lúo Lán Sè Violet","hex":"#9f0fef","rgb":{"r":159,"g":15,"b":239},"luminance":55.49792087997531},{"name":"Zǐ Sè Purple","hex":"#c94cbe","rgb":{"r":201,"g":76,"b":190},"luminance":77.91839285431907},{"name":"Ziggurat","hex":"#81a6aa","rgb":{"r":129,"g":166,"b":170},"luminance":106.57508998354164},{"name":"Zima Blue","hex":"#16b8f3","rgb":{"r":22,"g":184,"b":243},"luminance":111.69780191212358},{"name":"Zimidar","hex":"#6a5287","rgb":{"r":106,"g":82,"b":135},"luminance":59.65101585052848},{"name":"Zin Cluster","hex":"#463b3a","rgb":{"r":70,"g":59,"b":58},"luminance":41.00278201537061},{"name":"Zinc","hex":"#92898a","rgb":{"r":146,"g":137,"b":138},"luminance":92.84601822910876},{"name":"Zinc Blend","hex":"#a3907e","rgb":{"r":163,"g":144,"b":126},"luminance":98.62353902086458},{"name":"Zinc Dust","hex":"#5b5c5a","rgb":{"r":91,"g":92,"b":90},"luminance":61.33538372750267},{"name":"Zinfandel","hex":"#5c2935","rgb":{"r":92,"g":41,"b":53},"luminance":37.04613767992556},{"name":"Zing","hex":"#fbc17b","rgb":{"r":251,"g":193,"b":123},"luminance":136.61559049391104},{"name":"Zingiber","hex":"#dac01a","rgb":{"r":218,"g":192,"b":26},"luminance":130.22929791717374},{"name":"Zinnia","hex":"#ffa010","rgb":{"r":255,"g":160,"b":16},"luminance":120.9859223256987},{"name":"Zinnwaldite","hex":"#ebc2af","rgb":{"r":235,"g":194,"b":175},"luminance":135.28995383619582},{"name":"Zinnwaldite Brown","hex":"#2c1608","rgb":{"r":44,"g":22,"b":8},"luminance":18.45761295509254},{"name":"Zircon","hex":"#dee3e3","rgb":{"r":222,"g":227,"b":227},"luminance":151.0993241844582},{"name":"Zitronenzucker","hex":"#f4f3cd","rgb":{"r":244,"g":243,"b":205},"luminance":161.91105495610856},{"name":"Zodiac Constellation","hex":"#ee8844","rgb":{"r":238,"g":136,"b":68},"luminance":107.22533269708235},{"name":"Zombie","hex":"#595a5c","rgb":{"r":89,"g":90,"b":92},"luminance":60.07622129428581},{"name":"Zomp","hex":"#39a78e","rgb":{"r":57,"g":167,"b":142},"luminance":100.80773796688426},{"name":"Zōng Hóng Red","hex":"#ca6641","rgb":{"r":202,"g":102,"b":65},"luminance":85.36815788102727},{"name":"Zoom","hex":"#7b6c74","rgb":{"r":123,"g":108,"b":116},"luminance":74.47465824695001},{"name":"Zorba","hex":"#a29589","rgb":{"r":162,"g":149,"b":137},"luminance":101.1925794562032},{"name":"Zucchini","hex":"#17462e","rgb":{"r":23,"g":70,"b":46},"luminance":41.99024606977196},{"name":"Zucchini Cream","hex":"#97a98b","rgb":{"r":151,"g":169,"b":139},"luminance":110.13974362599542},{"name":"Zucchini Flower","hex":"#e8a64e","rgb":{"r":232,"g":166,"b":78},"luminance":119.9413625568761},{"name":"Zumthor","hex":"#cdd5d5","rgb":{"r":205,"g":213,"b":213},"luminance":141.34865938522373},{"name":"Zuni","hex":"#008996","rgb":{"r":0,"g":137,"b":150},"luminance":82.21694205575879},{"name":"Zürich Blue","hex":"#248bcc","rgb":{"r":36,"g":139,"b":204},"luminance":85.52264542798005}]}

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var proxyurl = "https://cors-anywhere.herokuapp.com/";
var URL = "https://zodiacal.herokuapp.com/elements/";
var TJO = __webpack_require__(84)();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      elements: {},
      element: this.$route.params.element,
      element_translate: [],
      desc: {},
      ascen: {}
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["language", "countryCode", "translateCode"]),
  mounted: function mounted() {
    this.getZodiacSign();
  },

  methods: {
    getZodiacSign: function getZodiacSign() {
      var _this = this;

      var related_icon = [];
      var element = {
        url: proxyurl + URL + this.element,
        method: 'GET'
      };
      this.$axios(element).then(function (res) {
        _this.loading = false;
        var elem = res.data[0];

        elem.elem_icon = __webpack_require__(211)("./" + _this.element + ".svg");
        for (var i = 0; i < elem.element_contents.length; i++) {
          //put image on each horoscope sign
          var str = elem.element_contents[i];
          //trim blank space
          var element_name = str.trim();
          related_icon[i] = [__webpack_require__(120)("./" + element_name + ".svg"), "" + element_name];
        }
        _this.element_translate['english'] = _this.element;
        elem.relate_icon = related_icon;
        _this.elements = elem;

        _this.translate(_this.elements);
      }).catch(function (err) {
        console.error(err);
      });
    },
    translate: function translate(elements) {
      var _this2 = this;

      //translate
      var elem = elements.element_name.toLowerCase();
      var i18n = this.$i18n._vm.messages;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(i18n)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (key == "arabic") {
            this.element_translate['arabic'] = value[elem];
          }
          if (key == "greek") {
            this.element_translate['greek'] = value[elem];
          }
          if (key == "malay") {
            this.element_translate['malay'] = value[elem];
          }
          if (key == "thai") {
            this.element_translate['thai'] = value[elem];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      TJO.init({
        // googleApiKey: 'AIzaSyBm4nfZjFUrt4A6MKWxHxCKIT3L4h8VPH8',
        googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04'
        // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
      });

      var translate = {
        desc: elements.description.join("/"),
        asce: elements.element_ascendant.join("/")
      };

      if (this.translateCode != "") {
        TJO.translate(translate, this.translateCode).then(function (data) {
          _this2.desc = data.desc.split("/");
          _this2.ascen = data.asce.split("/");
        });
      }
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zodiac_json__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zodiac_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zodiac_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_json__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      czodiacs: {},
      czodiac: __WEBPACK_IMPORTED_MODULE_4__zodiac_json___default.a,
      colors: __WEBPACK_IMPORTED_MODULE_5__colors_json___default.a
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["language"]),
  created: function created() {
    this.getCZodiac();
  },
  mounted: function mounted() {
    if (this.language == "arabic") {
      document.getElementById("bottomSection").classList.add("arLayout");
    } else {
      document.getElementById("bottomSection").classList.remove("arLayout");
    }
  },

  methods: {
    getCZodiac: function getCZodiac() {
      var zod = this.czodiac.eastern_zodiac;
      var czod = this.$route.params.chinesesign;
      var sign = [];
      var love_best = {};
      var love_worst = {};
      var col_code_unluc = [];
      var col_code_luc = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(zod)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.sign_english.toLowerCase() === czod) {
            for (var _i2 = 0; _i2 < value.love["best_english"].length; _i2++) {
              //to get best compatibility icon
              love_best[_i2] = {
                "image": __webpack_require__(209)("./" + value.love["best_english"][_i2] + ".svg"),
                "best_english": "" + value.love["best_english"][_i2],
                "best_arabic": "" + value.love["best_arabic"][_i2],
                "best_greek": "" + value.love["best_greek"][_i2],
                "best_malay": "" + value.love["best_malay"][_i2],
                "best_thai": "" + value.love["best_thai"][_i2]
              };
            }

            for (var _i3 = 0; _i3 < value.love["worst_english"].length; _i3++) {
              //to get worst compatibility icon
              love_worst[_i3] = {
                "image": __webpack_require__(209)("./" + value.love["worst_english"][_i3] + ".svg"),
                "worst_english": "" + value.love["worst_english"][_i3],
                "worst_arabic": "" + value.love["worst_arabic"][_i3],
                "worst_greek": "" + value.love["worst_greek"][_i3],
                "worst_malay": "" + value.love["worst_malay"][_i3],
                "worst_thai": "" + value.love["worst_thai"][_i3]
              };
            }

            value.best = love_best;
            value.worst = love_worst;
            value.sign = value.sign_english.replace(/^./, value.sign_english[0].toUpperCase());
            value.image = __webpack_require__(344)("./" + value.sign + ".svg");

            sign.push(value);
          }
        }

        //get color code for unlucky color
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var len = sign[0].unlucky.colors_english.length;

      for (var i = 0; i < len; i++) {
        var col = this.getColorCode(sign[0].unlucky.colors_english[i]);
        col_code_unluc[i] = [col, sign[0].unlucky.colors_english[i]];
      }

      sign[0].unlucky.code_color_unluc = col_code_unluc;

      //get color code for lucky color
      var len1 = sign[0].lucky.colors_english.length;

      for (var _i = 0; _i < len1; _i++) {
        var _col = this.getColorCode(sign[0].lucky.colors_english[_i]);
        col_code_luc[_i] = [_col, sign[0].lucky.colors_english[_i]];
      }

      sign[0].lucky.code_color_luc = col_code_luc;

      this.czodiacs = sign[0];
    },
    getColorCode: function getColorCode(color) {
      var co = this.colors.colors;

      //console.log(co)
      var found = co.find(function (element) {
        return element.name == color;
      });
      return found.hex;
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyCzech__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicySlovakia__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyFinnish__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["language"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-slovakia': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicySlovakia__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyFinnish__["a" /* default */]

  },
  methods: {}
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsCzech_vue__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsEnglish_vue__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsSlovakia_vue__ = __webpack_require__(1451);
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["language"]),
  components: {
    TermsSlovakia: __WEBPACK_IMPORTED_MODULE_3__TermsSlovakia_vue__["a" /* default */],
    TermsCzech: __WEBPACK_IMPORTED_MODULE_1__TermsCzech_vue__["a" /* default */],
    TermsEnglish: __WEBPACK_IMPORTED_MODULE_2__TermsEnglish_vue__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_mobiscope__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__locales_country_list_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      auth: "",
      user: "",
      name: ""
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["language", "countryCode", "langButton", "auth_mobis", "host_mobiscope"]),
  created: function created() {
    this.fetchTransButton(this.countryCode);
  },
  mounted: function mounted() {
    var _this = this;

    // button translate
    var btnLang1 = document.getElementsByClassName("lang1");
    var btnLang2 = document.getElementsByClassName("lang2");

    var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__locales_country_list_json___default.a);

    if (this.language == "english") {
      if (country_ls.includes(this.countryCode)) {
        btnLang2[0].style.display = "inline-block";
        btnLang2[1].style.display = "inline-block";
        btnLang1[0].style.display = "none";
        btnLang1[1].style.display = "none";
      }
    } else {
      if (this.language == null && sessionStorage.getItem('tokenID') == 'mobis80') {
        btnLang2[0].style.display = "inline-block";
        btnLang2[1].style.display = "inline-block";
        btnLang1[0].style.display = "none";
        btnLang1[1].style.display = "none";
      } else {
        btnLang2[0].style.display = "none";
        btnLang2[1].style.display = "none";
        btnLang1[0].style.display = "inline-block";
        btnLang1[1].style.display = "inline-block";
      }
    }

    var _loop = function _loop(i) {
      btnLang1[i].addEventListener("click", function (e) {
        var lang = e.target.getAttribute("lang");
        sessionStorage.setItem("language", lang);
        _this.$i18n.locale = "english";
        _this.fetchLang("english");
        btnLang2[i].style.display = "inline-block";
        btnLang1[i].style.display = "none";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      });
    };

    for (var i = 0; i < btnLang1.length; i++) {
      _loop(i);
    }

    var _loop2 = function _loop2(i) {
      btnLang2[i].addEventListener("click", function (e) {
        var lang = e.target.getAttribute("lang");
        sessionStorage.setItem("language", lang);
        _this.$i18n.locale = lang;
        _this.fetchLang(lang);
        btnLang1[i].style.display = "inline-block";
        btnLang2[i].style.display = "none";
        if (lang == "arabic") {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        }
      });
    };

    for (var i = 0; i < btnLang2.length; i++) {
      _loop2(i);
    }

    document.onreadystatechange = function () {
      if (document.readyState == "complete") {
        var menuBtn = document.getElementById("menuBtn");
        menuBtn.addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
        var mobileLinks = document.querySelectorAll(".siteNavMobile .navLinks__item");

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
          mobileLinks[elm].addEventListener("click", function () {
            document.body.classList.remove("mobile--active");
          });
        });
      }
    };
    // init mobile menu
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchLang", "fetchTransButton", "guest_mobis"]), {
    logout: function logout() {
      sessionStorage.removeItem("tokenID");
      sessionStorage.removeItem("logged-in");
      // localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_2__router_mobiscope__["a" /* default */].push({ name: Login }).catch(function (err) {});
    }
  })
});

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["is_unsub_mobis"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_mobis"]))
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobizone_mobizone_js_mobizone_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobizone_Navigation_vue__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mobizone_UnsubModal_vue__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Mobizone",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_mobizone_mobizone_js_mobizone_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_mobizone_mobizone_js_mobizone_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_8__components_mobizone_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_9__components_mobizone_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_mobiz", "country_mobiz", "host_mobiz"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_mobiz(this.host_mobiz); //check domain
    this.fetchToken_mobiz(this.id); //check token

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_mobizone__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_mobiz;
    var country_code = this.country_mobiz;

    if (this.lang_mobiz != "null" && this.lang_mobiz != null) {
      if (this.lang_mobiz == "arabic") {
        localStorage.setItem("lang_mobiz", this.lang_mobiz);
        this.$i18n.locale = this.lang_mobiz;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_mobiz(this.lang_mobiz);
      } else {
        localStorage.setItem("lang_mobiz", this.lang_mobiz);
        this.$i18n.locale = this.lang_mobiz;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_mobiz(this.lang_mobiz);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a[country_code].language;

        localStorage.setItem("lang_mobiz", language);
        this.$i18n.locale = language;
        this.fetchLocale_mobiz(language);

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_mobiz", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_mobiz("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLocale_mobiz", "fetchToken_mobiz", "getDomain_mobiz"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPickIcon_mobiz", "PopularIcon_mobiz", "lang_mobiz", "country_mobiz"]),
  created: function created() {},

  methods: {
    getAllData: function getAllData() {
      // console.log(this.allHotPicksData)
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_mobiz", "country_mobiz"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var TJO = __webpack_require__(84)();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      current_status: ""
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["msisdn_mobiz", "renew_date_mobiz", "subscription_date_mobiz", "auth_mobiz", "is_unsub_mobiz", "status_mobiz", "country_mobiz", "langcode_mobiz"]),
  mounted: function mounted() {
    this.current_status = this.status_mobiz;
  },
  updated: function updated() {
    var _this = this;

    TJO.init({
      googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04'
      // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
    });

    var curr_status = {
      status: this.status_mobiz
    };

    TJO.translate(curr_status, this.langcode_mobiz).then(function (data) {
      _this.current_status = data.status;
    }).catch(function (err) {
      console.log("error ", err);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout_mobiz"]))
});

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_mobiz", "HotPickIcon_mobiz", "lang_mobiz", "country_mobiz"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_mobiz([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_mobiz([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_mobiz"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_mobiz));
      var hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(function (item) {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      } else {
        hotpick.map(function (item) {
          if (_this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate: function getCategoryTranslate(q, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_mobiz", "PopularIcon_mobiz", "country_mobiz", "lang_mobiz"]),
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  created: function created() {
    this.fetchPagePopular_mobiz();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_mobiz"]))
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MobiZoneSlider_vue__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["HotPickIcon_mobiz", "PopularIcon_mobiz", "lang_mobiz", "country_mobiz", "host_mobiz"]),
  components: {
    "mobizone-slider": __WEBPACK_IMPORTED_MODULE_8__MobiZoneSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_mobiz;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_mobiz + "&lang=" + _this.lang_mobiz;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;

                  _this.hotpicks = data.slice(0, 10);
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_mobiz;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_mobiz + "&lang=" + _this2.lang_mobiz;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;

                  _this2.popular = data.slice(0, 10);
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_mobiz;
      var live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_mobiz + "&lang=" + this.lang_mobiz;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != '') {
            if (_this3.lang_mobiz != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_mobiz].title;

              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_mobiz] = sub_trans[_this3.lang_mobiz].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_mobiz == key) {
                    if (value.language != 'english') {
                      _this3.categoryTranslate = cat_trans["" + value.language].title;
                      if (sub_trans != null) {
                        item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                      }
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (category == 'video') {
                    item.icon = sub_icon["mobiflix.vip"]["class"];
                  } else {
                    item.icon = sub_icon["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_mobiz", "country_mobiz"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          case "arSlider":
            _this.$nextTick(function () {
              var arSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptions);
              arSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              arSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allSubcategory_mobiz", "lang_mobiz", "country_mobiz", "host_mobiz"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_mobiz(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_mobiz"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_mobiz;
                live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_mobiz + "&lang=" + _this.lang_mobiz;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data = data.filter(function (value) {
                    if (value.category.toLowerCase() == _this.category) {
                      return value;
                    }
                  });
                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allSubcategory_mobiz));

      var subcat = allSubcategory.map(function (item) {
        if (item.subcategory_translate != null) {
          var sub_trans = JSON.parse(item.subcategory_translate);
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          item.titleSub_english = item.subcategory;
          if (sub_trans != null) {
            for (var i = 0; i < trans_len; i++) {
              if (lang == 'english') {
                item["titleSub_english"] = _this2.subcategory;
              } else {
                item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
              }
            }
          }
        }

        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false,
      player: null
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_mobiz", "host_mobiz", "country_mobiz"]),
  created: function created() {
    this.getDetails(this.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_mobiz"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != '') {
          if (langt != 'english') {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(153)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat['mobile_computer'];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      // const vidPlyrr = new Plyr(document.getElementById("vidPlayer"));
      this.player = this.$refs.player.player;
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //everytime user display detail page, will collect the data
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_mobiz,
        product: 'mobizone',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_mobiz + "&lang=" + this.lang_mobiz).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب الان","notification":"تنبيه","view_more":"شاهد المزيد","main_title":"كل شي في مكان واحد","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Mobizone؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","android":"أندرويد","no_notification":"لا يوجد إشعارات","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Mobizone","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا","current_status":"الحالة الحالية"}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"ВСИЧКО НА ЕДНО МЯСТО","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Mobizone?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани от Mobizone","modal_title":"Анулиране на абонамента?","unsub_confirmation":"Наистина ли искате да се отпишете?","yes":"Да","no":"Не","current_status":"Актуално състояние"}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"vše na jednom místěE","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Mobizone?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledejte hry, aplikace atd...","not_subs":"Ještě nejste přihlášeni","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmětt","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","android":"Android","no_notification":"Žádné oznámení","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","unsubscription":"Nyní jste odhlášeni z Mobizone","modal_title":"Zrušit předplatné?","unsub_confirmation":"Opravdu se chcete odhlásit?","yes":"Ano","no":"Ne","current_status":"Aktuální stav"}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"ALT ET STED","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Mobizone?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Mobizone","modal_title":"Annuller abonnement?","unsub_confirmation":"Er du sikker på, at du vil afmelde dig?","yes":"Ja","no":"ingen","current_status":"Nuværende status"}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Mobizone?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Mobizone","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","current_status":"Current Status"}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Mobizone?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Mobizone","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","current_status":"Current Status"}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"ΟΛΑ ΣΕ ΜΙΑ ΧΩΡΑ","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Mobizone?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Εφαρμογή","game":"Παιχνίδι","video":"Βίντεο","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","android":"Android","no_notification":"καμία ειδοποίηση","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής","unsubscription":"Έχετε διαγραφεί από το Mobizone","modal_title":"Ακύρωση συνδρομής?","unsub_confirmation":"Είστε βέβαιοι ότι θέλετε να καταργήσετε την εγγραφή σας?","yes":"Ναί","no":"όχι","current_status":"Τωρινή κατάσταση"}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Mobizone?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan","unsubscription":"You are now unsubscribed from Mobizone","modal_title":"Batalkan Langganan?","unsub_confirmation":"Anda yakin ingin berhenti berlangganan?","yes":"Ya","no":"Tidak","current_status":"Status Terkini"}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"SEMUA DALAM SATU PLATFORM","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Mobizone?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan","unsubscription":"You are now unsubscribed from Mobizone","modal_title":"Batalkan Langganan?","unsub_confirmation":"Anda pasti mahu berhenti langganan?","yes":"Ya","no":"Tidak","current_status":"Status semasa"}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"ALT PÅ ET STED","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Mobizone?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Mobizone","modal_title":"Avbestille abonnementet?","unsub_confirmation":"Er du sikker på at du vil avslutte abonnementet?","yes":"Ja","no":"Nei","current_status":"Nåværende status"}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Mobizone?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Mobizone","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","current_status":"Current Status"}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"VŠETKO NA JEDNOM MIESTE","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Mobizone?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu Mobizone","modal_title":"Zrušiť predplatné?","unsub_confirmation":"Naozaj chcete zrušiť odber?","yes":"Áno","no":"Nie","current_status":"Súčasný stav"}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Mobizone?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Mobizone","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","current_status":"Current Status"}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"รวมทุกอย่างในที่เดียว","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Mobizone?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาเกมส์ แอพลิเคชั่น และอื่นๆ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","android":"แอนดรอยด์","no_notification":"ไม่มีการแจ้งเตือน","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","unsubscription":"ตอนนี้คุณยกเลิกการสมัครจาก Mobizone แล้ว","modal_title":"ยกเลิกการสมัครสมาชิก?","unsub_confirmation":"แน่ใจไหมว่าต้องการยกเลิกการสมัคร?","yes":"ใช่","no":"ไม่","current_status":"สถานะปัจจุบัน"}

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_mobiz);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_mobiz", "gcid_mobiz", "country_mobiz"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_mobiz != "") {
            gcid = this.gcid_mobiz;
          } else {
            //dummy gcid
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userToken_mobiz", response.token);
              localStorage.setItem("userProfile_mobiz", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_mobiz("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_mobizone__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_mobiz == key) {
                    var status_lang = __webpack_require__(153)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_mobiz"]))
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {}
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_mobiz", "gcid_mobiz", "country_mobiz"])
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["lang_mobiz", "country_mobiz"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {
        if (this.host_gamebox.includes("gamebox")) {
            var mobiSection__content = document.getElementsByClassName('mobiSection__content');
            var privacy = document.getElementsByClassName('privacy_color');
            var mobitxt = document.getElementsByClassName('mobitxt');

            mobiSection__content[0].style.color = 'white';
            for (var i = 0; i < privacy.length; i++) {
                privacy[i].style.color = 'white';
            }
            for (var _i = 0; _i < mobitxt.length; _i++) {
                mobitxt[_i].style.color = 'white';
            }
        }
    }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var currentDate = new Date();

var host = window.location.host;
var lang = localStorage.getItem("lang_mobiz");
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
    data: function data() {
        return {
            browse: {
                category: [],
                categoryAR: [],
                categoryMY: []
            },
            main: {
                hotpicks: {},
                category: {},
                isLoad: false
            },
            search: {
                allSearch: {}
            },
            type: 'browse',
            live: 'http://cook.grabmobi.com',
            local: 'http://[::1]/PuretechGlobalContentPortal'
        };
    },
    created: function created() {
        if (host.includes("mobizone")) {
            this.getBrowse();
            // this.getHotPicks();
        }
    },

    methods: {
        getHotPicks: function getHotPicks(browseCate) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var isload, browseCat, browseCategory, allDataContent, allData, temp, browseSort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                isload = '';
                                browseCat = [];
                                browseCategory = [];
                                allDataContent = [];
                                allData = [];

                                // let browse = await axios.get(
                                //     `${this.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=${host}`
                                // );

                                temp = [];
                                //get category from getBrowse()

                                browseSort = browseCate.filter(function (item) {
                                    if (item.category == 'Application') {
                                        temp = item;
                                    } else {
                                        return item;
                                    }
                                });

                                if (temp != '') {
                                    browseSort.push(temp);
                                }

                                browseCat = browseSort;

                                //get random number
                                oneHourInMs = 3600000;
                                currentTimeInMs = new Date().getTime(); // UTC time

                                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                                numberForToday = timeInHour % 20;
                                // zero-filling of numbers less than four digits might be optional for you
                                // zero-filled value will be a string to maintain its leading 0s

                                DigitNumber = numberForToday.toString();

                                while (DigitNumber.length < 2) {
                                    DigitNumber = 0 + Number(DigitNumber);
                                }

                                i = 0;

                            case 16:
                                if (!(i < browseCat.length)) {
                                    _context.next = 29;
                                    break;
                                }

                                _context.next = 19;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(_this.live + '/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=' + browseCat[i].category + '&limit=100&offset=0&domain=' + host + '&lang=' + lang);

                            case 19:
                                allData = _context.sent;
                                divide = DigitNumber % 2;


                                if (divide == 0) {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return Math.random() - 0.5;
                                    });
                                } else {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return 0.5 - Math.random();
                                    });
                                }

                                data_slice = allData.data.data.slice(0, 6);
                                categ = browseCat[i].category;

                                allDataContent[categ] = new Array();
                                allDataContent[categ] = data_slice;

                            case 26:
                                i++;
                                _context.next = 16;
                                break;

                            case 29:

                                isload = true;

                                _this.main.hotpicks = allDataContent;
                                _this.main.category = browseCat;
                                _this.main.isLoad = isload;

                            case 33:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getBrowse: function getBrowse() {
            var _this2 = this;

            var url = this.live + '/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;

            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (res) {
                // console.log(res.data.data)
                var data = res.data.data;
                var temp = [];

                data.map(function (item) {
                    item.title_english = item.category;
                    item.route = item.title_english.toLowerCase();

                    if (item.category_translate != null) {
                        var trans = JSON.parse(item.category_translate);
                        if (trans != null) {
                            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
                            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
                            for (var i = 0; i < trans_len; i++) {
                                item['title_' + trans_arr[i]] = trans[trans_arr[i]].title;
                            }
                            // item.icon = icon['my.1.grabmobi.com']['class'];
                        }
                    }

                    if (item.category_icon != null) {
                        var icon = JSON.parse(item.category_icon);
                        if (icon != null) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var _ref = _step.value;

                                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                                    var key = _ref2[0];
                                    var value = _ref2[1];

                                    if (key == host) {
                                        item.icon = icon[key]["class"];
                                    } else {
                                        item.icon = icon['mobizone.vip']['class'];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }

                    item.coverImg = __webpack_require__(1556)("./" + item.category + '.jpg');

                    temp.push(item);
                });

                var item_temp = temp.map(function (v) {
                    delete v.category_translate;
                    delete v.category_translate;
                    delete v.category_icon;
                    delete v.subcategory;
                    delete v.subcategory_translate;
                    delete v.subcategory_icon;
                    delete v.thumbnail_url;
                    delete v.cover_img;
                    return v;
                });

                _this2.browse.category = item_temp;
                _this2.getHotPicks(item_temp);
            });
        }
    }
}));

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobizone_js_mobizone__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobizone_Search_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobizone_Notification_vue__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__mobizone_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_5__mobizone_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["langButton_mobiz", "lang_mobiz", "auth_mobiz", "country_mobiz", "is_unsub_mobiz", "gcid_mobiz"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchTranslateButton_mobiz(this.country_mobiz);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_mobiz == "english") {
      if (this.country_mobiz != "ke1" && this.country_mobiz != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_mobiz != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLocale_mobiz(lang);
      localStorage.setItem("lang_mobiz", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      window.location.reload();
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLocale_mobiz(lang);
      localStorage.setItem("lang_mobiz", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
      window.location.reload();
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["fetchLocale_mobiz", "fetchTranslateButton_mobiz", "logout_mobiz"]), {
    getclick: function getclick(route, category_id) {
      // console.log(route, category_id)
      // location.reload();  
      // mobizone.push({ name: "Category" }).catch(err => {});
      // mobizone.push({ name: 'Category', params: { category: route+'-'+category_id } })
      // mobizone.push({ name: "Category", params: { category: route+'-'+category_id }}).catch(err => {})
    },
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_mobiz");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload(); 
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1203eb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1568);
function injectStyle (ssrContext) {
  __webpack_require__(1567)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1203eb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1203eb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_mobiz", "host_mobiz"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_mobiz;
        var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_mobiz;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(153)("./" + _this2.lang_mobiz + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match['not_match'];
          }

          var res_search = [];
          var bold = [];
          var img = "";
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var _icon = "";
            //use class icon
            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            // if (z[i].class_icon != null) {
            //   //my.1.grabmobi.com as default domain
            //   icon = icon_class['mobizone.vip']['class'];
            // } else {
            //   icon = icon_class['my.1.grabmobi.com']['class'];;
            // }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_mobiz) {
                    _icon = icon_class[key]["class"];
                  } else {
                    _icon = icon_class["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            //use class icon
            var r = res_search[_i].replace(res_search[_i], "<span class='" + _icon + "'></span> " + res_search[_i]);

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 443 */,
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_mobiz", "lang_mobiz", "country_mobiz"])),
  created: function created() {
    this.fetchNotification_mobiz();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_mobiz"]))
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_mobiz", "lang_mobiz", "auth_mobiz", "country_mobiz", "is_unsub_mobiz"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLocale_mobiz", "fetchTranslateButton_mobiz", "logout_mobiz"]))
});

/***/ }),
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_games4all__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_games4all_games4all_js__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_games4all_Navigation_vue__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_games4all_UnsubModal_vue__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Games4all",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_games4all_games4all_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_games4all_games4all_js__["a" /* default */].main,
      id: this.$route.params.token != undefined ? this.$route.params.token : this.$route.query.id,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_games4all_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_8__components_games4all_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_g4all", "country_g4all", "host_g4all"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_g4all(this.host_g4all);
    this.fetchTokenID_g4all(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_games4all__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
    }
    var country_id = this.country_g4all;

    if (this.lang_g4all != "null" && this.lang_g4all != null) {
      if (this.lang_g4all == "arabic") {
        localStorage.setItem("lang_g4all", this.lang_g4all);
        this.$i18n.locale = this.lang_g4all;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLanguage_g4all(this.lang_g4all);
      } else {
        localStorage.setItem("lang_g4all", this.lang_g4all);
        this.$i18n.locale = this.lang_g4all;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_g4all(this.lang_g4all);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a);

      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a[country_id].language;

        localStorage.setItem("lang_g4all", language);
        this.$i18n.locale = language;
        this.fetchLanguage_g4all(language);

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_g4all", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_g4all("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLanguage_g4all", "fetchTokenID_g4all", "getDomain_g4all"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      games: {}
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
  // "allSubGame_g4all",
  // "allStoreGameData_g4all",
  "IconHotPick_g4all", "IconPopular_g4all", "lang_g4all", "country_g4all"
  // "hpisLoad_g4all"
  ]),
  created: function created() {
    // this.fetchHomeHotPick_g4all();
  },
  mounted: function mounted() {},

  methods: {
    // ...mapActions(["fetchHomeHotPick_g4all"])
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_g4all", "host_g4all", "country_g4all", "host_g4all"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subscribeContent_g4all"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != '') {
          if (langt != 'english') {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(95)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat['mobile_computer'];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";

      //post view detail
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_g4all,
        product: 'games4all',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;

        _this2.contentCoverImg = data.cover_img;

        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);
          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"العب بحرارة","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل اشتركت في العاب للجميع Games4all؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك"}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Игра на огън","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Games4all?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","Action Games":"Екшън игри","Puzzle Game":"Puslespill","Sport Games":"Спортни игри","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента"}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Hraní v ohni","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Games4all?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledejte hry, aplikace atd...","not_subs":"eště nejste přihlášeni","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","Action Games":"Akční hry","Puzzle Game":"Logické hry","Sport Games":"Sportovní hry","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámení","android":"Android","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného"}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Spiller i brand","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonneret på Games4all?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","Action Games":"Action Spil","Puzzle Game":"Gåde","Sport Games":"Sport","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Playing on Fire","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Games4all?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Playing on Fire","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Games4all?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"Παίζοντας με την φωτιά","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Games4all?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Application","game":"Game","video":"Video","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Kehangatan Permainan","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Berlangganan Games4all?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Kehangatan Permainan","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Games4all?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Spiller på brann","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Games4all?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","Action Games":"Actionspill","Puzzle Game":"Пъзел игра","Sport Games":"Sportsspill","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Playing on Fire","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Games4all?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Hranie sa na oheň","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Games4all?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","Action Games":"Akčné hry","Puzzle Game":"Hádanka","Sport Games":"Šport","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného"}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Playing on Fire","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Games4all?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_g4all", "renew_date_g4all", "subscription_date_g4all", "authentication_g4all", "is_unsub_g4all"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_g4all"]))
});

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_g4all", "country_g4all", "host_g4all"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_g4all).then(function (res) {
        var data = res.data.data;

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPicksPage_g4all", "IconHotPick_g4all", "lang_g4all"]),
  created: function created() {
    this.isLoad = false;
    this.fetchHotPicks_g4all([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchHotPicks_g4all([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["fetchHotPicks_g4all"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_g4all));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_g4all", "IconPopular_g4all", "lang_g4all"]),
  created: function created() {
    this.fetchPopular_g4all();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPopular_g4all"]))
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_games4all__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_g4all);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_g4all", "gcid_g4all", "country_g4all"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_g4all != "") {
            gcid = this.gcid_g4all;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_g4all", response.token);
              localStorage.setItem("userProfile_g4all", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_g4all("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_games4all__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_g4all == key) {
                    var status_lang = __webpack_require__(95)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_g4all"]))
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_g4all", "country_g4all"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__games4all_Search_vue__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__games4all_Notification_vue__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_2__games4all_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_3__games4all_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["langButton_g4all", "lang_g4all", "authentication_g4all", "country_g4all", "is_unsub_g4all", "gateway_g4all"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchLanguageButton_g4all(this.country_g4all);
    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_g4all == "english") {
      if (this.country_g4all != "ke" && this.country_g4all != "ke1") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_g4all != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLanguage_g4all(lang);
      localStorage.setItem("lang_g4all", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLanguage_g4all(lang);
      localStorage.setItem("lang_g4all", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    // notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchLanguage_g4all", "fetchLanguageButton_g4all", "logout_g4all"]), {
    getclick: function getclick() {
      // location.reload();
    },
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userTokenID_g4all");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      // if(from.name == "Subcategory" && to.name == "Subcategory"){
      //   location.reload();
      // }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_g4all", "host_g4all"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_g4all).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          var item_search = search.filter(function (item) {
            return item.category_id == "2";
          });

          for (var i = 0; i < item_search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(item_search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(95)("./" + _this2.lang_g4all + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];

          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }
            var icon = "";
            //my.1.grabmobi.com as default domain
            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_g4all) {
                    icon = icon_class[key]["class"];
                  } else {
                    icon = icon_class["games4all.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");
            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_g4all", "lang_g4all", "country_g4all"])),
  created: function created() {
    this.fetchNotification_g4all();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_g4all"]))
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_cm", "lang_cm", "auth_cm", "country_cm", "is_unsub_cm"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLocale_cm", "fetchTranslateButton_cm", "logout_cm"]))
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mobiflix_mobiflix_js__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mobiflix_Navigation_vue__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mobiflix_UnsubModal_vue__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Mobiflix",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_mobiflix_mobiflix_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_mobiflix_mobiflix_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_mobiflix_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_8__components_mobiflix_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_Mobif", "country_Mobif", "host_Mobif"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_Mobif(this.host_Mobif);
    this.fetchTokenID_Mobif(this.id);
    if (this.country_Mobif == 'th') {
      var special_case = window.location.pathname.replace(/\W/g, "");
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (special_case.match(letterNumber)) {
        __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__["a" /* default */].push({ name: "Popular" }).catch(function (err) {});
      }
    }

    if (window.location.pathname === "/") {
      if (this.country_Mobif == 'th') {
        __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__["a" /* default */].push({ name: "Popular" }).catch(function (err) {});
      } else {
        __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
      }
    }

    var country_id = this.country_Mobif;

    if (this.lang_Mobif != "null" && this.lang_Mobif != null) {
      if (this.lang_Mobif == "arabic") {
        localStorage.setItem("lang_Mobif", this.lang_Mobif);
        this.$i18n.locale = this.lang_Mobif;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLang_Mobif(this.lang_Mobif);
      } else {
        localStorage.setItem("lang_Mobif", this.lang_Mobif);
        this.$i18n.locale = this.lang_Mobif;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang_Mobif(this.lang_Mobif);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a);

      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a[country_id].language;

        if (localStorage.getItem('userTokenID_Mobif') == 'mobif80') {
          localStorage.setItem("lang_Mobif", 'english');
          this.$i18n.locale = 'english';
          this.fetchLang_Mobif('english');
        } else {
          localStorage.setItem("lang_Mobif", language);
          this.$i18n.locale = language;
          this.fetchLang_Mobif(language);
        }

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_Mobif", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang_Mobif("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLang_Mobif", "fetchTokenID_Mobif", "getDomain_Mobif"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false,
        imagesLoaded: true,
        groupCells: true
      },
      stageDragging: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
  // "subCate_Mobif",
  // "allData_Mobif",
  "IconHotpick_Mobif", "IconPopular_Mobif", "lang_Mobif", "country_Mobif"
  // "homeSliderContentLoaded",
  // "hpisLoad_Mobif"
  ]),
  mounted: function mounted() {
    // this.fetchHomeHotPick_Mobif();
    if (this.$props.main.hotpicks.length !== undefined) {
      this.initHotPicksSlider();
    }
  },
  updated: function updated() {
    if (this.$props.main.dataLoaded === true) {
      this.initHotPicksSlider();
    }
  },

  methods: {
    // ...mapActions(["fetchHomeHotPick_Mobif"]),
    initHotPicksSlider: function initHotPicksSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$nextTick(function () {
          var i = 0;
          _this.$refs.hotPicksCarousel.map(function (flktyElm) {
            var flktyBName = "homeHotPlicksSliderflkty" + i;
            i++;

            flktyBName = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(flktyElm, _this.flickityOptions);
            flktyBName.on("dragStart", function () {
              this.stageDragging = true;
            });
            flktyBName.on("dragEnd", function () {
              this.stageDragging = false;
            });
          });
        });
      }, 0);
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_mobiflix__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomLightbox_vue__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_9__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_Mobif", "host_Mobif", "authentication_Mobif", "country_Mobif"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["subscribeContent_Mobif"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != '') {
          if (langt != 'english') {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(121)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat['mobile_computer'];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_6_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var live, local;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                live = "http://cook.grabmobi.com";
                local = "http://[::1]/PuretechGlobalContentPortal";


                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(live + "/api/newcontents_statistic", {
                  token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                  country: _this2.country_Mobif,
                  product: 'mobiflix',
                  content_id: id,
                  type: "view"
                });

                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + _this2.host_Mobif + "&lang=" + _this2.lang_Mobif).then(function (res) {
                  var data = res.data.data[0];

                  var sc = data.screenshot.split(",");
                  var sc_temp = [];
                  for (var i = 0; i < sc.length; i++) {
                    sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
                  }

                  data.screenshot = sc_temp;

                  _this2.contentCoverImg = data.cover_img;

                  data.titleSub_english = data.subcategory;

                  if (data.subcategory_translate != null) {
                    var sub_trans = JSON.parse(data.subcategory_translate);
                    var sub_icon = JSON.parse(data.subcategory_icon);

                    var trans_len = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sub_trans);

                    for (var _i = 0; _i < trans_len; _i++) {
                      data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
                    }
                  }

                  setTimeout(function () {
                    _this2.details = data;
                    _this2.isLoad = true;
                    _this2.$nextTick(function () {
                      _this2.initPlyr();
                    });
                  }, 0);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"شاهد التالي","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل اشتركت في Mobiflix؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","subscribe_messsage":"للاشتراك والحصول على وصول غير محدود، الرجاء الضغط على الزر في الأسفل!","subscribe":"اشتراك","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن فيديو ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Mobiflix","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا"}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"ВСИЧКО НА ЕДНО МЯСТО","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Mobizone?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","subscribe_messsage":"За да се абонирате и да получите неограничен достъп, моля, кликнете върху бутона по-долу!","subscribe":"Абонирай се","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани отMobiflix"}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Sledujte, co bude dál","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Mobiflix?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","subscribe_messsage":"Chcete-li se přihlásit k odběru a získat neomezený přístup, klikněte na tlačítko níže!","subscribe":"předplatit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslor","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Hledat videa...","not_subs":"Ještě nejste přihlášeni","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazuy","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"Neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentářs","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámenín","android":"Android","next_renew_date":"Datum dalšího obnoveníe","subscription_date":"Datum předplatnéh","unsubscription":"Nyní jste odhlášeni z Mobiflix"}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Se hvad der er næste","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Mobiflix?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","subscribe_messsage":"Klik på nedenstående knap for at abonnere og få ubegrænset adgang!","subscribe":"Abonner","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Mobiflix"}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Watch what's next","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Mobiflix?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Videos...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Mobiflix","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No"}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {"browse":"Selaa","hotpicks":"Hot Picks","popular":"Suosittu","profile":"Profiili","downloads":"Lataukset","download":"ladata","play":"Pelaa nyt","notification":"Ilmoitus","view_more":"Katso lisää","main_title":"Katso mitä seuraavaksi","home":"Koti","favorites":"Suosikit","contact":"Ottaa yhteyttä","settings":"asetukset","privacy":"Tietosuojakäytäntö","terms":"käyttöehdot","all":"Kaikki","allCategories":"kaikki kategoriat","categories":"Luokat","category":"Kategoria","platform":"Alusta","type":"Tyyppi","login":"Kirjaudu sisään","logout":"Kirjautua ulos","login_title":"Tilattu Mobiflix?","confirmation":"Vahvista sitten matkapuhelinnumerosi ja saat rajoittamattoman pääsyn kaikkiin palveluihimme!","submit":"Lähetä","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Lisää oikea numero!","full_name":"Koko nimi","registered_num":"Rekisteröity numero","registered_email":"Registered Email","registered_date":"Rekisteröity päivämäärä","hello":"Hei","search":"Hae videoita...","not_subs":"Ei vielä tilaa","application":"Sovellus","game":"Peli","video":"Video","contact_us":"Ota meihin yhteyttä","subject":"Aihe","message":"Viesti","let_us":"Kerro meille tiedusteluistasi","select_subject":"Valitse Aihe","app_issue":"Sovelluksen numero","content":"Sisältö","subscription":"Tilaus","unsubscribe":"Lopeta tilaus","not_match":"Ei täsmää","feedback":"Palaute","feedback_intro":"Olisimme erittäin kiitollisia, jos voisit säästää muutaman minuutin auttaaksesi meitä parantamaan sivustoamme täyttämällä tämän lyhyen kyselyn.","Overall":"Yleensä ottaen","Usability":"Käytettävyys","Your Suggestion":"Sinun ehdotuksesi","feedback_comment":"Kirjoita kommenttisi","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","no_notification":"Ei ilmoitusta","android":"Android","next_renew_date":"Seuraava uusimispäivä","subscription_date":"Tilauspäivä","unsubscription":"Olet nyt peruuttanut tilauksen Mobiflix"}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"Δείτε τι έρχεται","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Mobifix?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γεια σου","search":"Αναζητήστε Βίντεο","not_subs":"Δεν Εγγραφή ακόμα","Action Games":"Action Games","Puzzle Game":"Παζλ","Sport Games":"Sport Games","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητό και Υπολογιστή","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Tonton Selanjutnya","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Mobiflix?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Video...","not_subs":"Belum Berlangganan","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Tonton Yang Seterusnya","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Mobiflix?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Video...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"ALT PÅ ET STED","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Mobizone?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Mobiflix"}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Picks","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Urmăriți ce urmează","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la Mobiflix?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","subscribe_messsage":"Pentru a vă abona și pentru a obține acces nelimitat, faceți clic pe butonul de mai jos!","subscribe":"Abonati-va","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutați videoclipuri...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","no_notification":"Nicio notificare","android":"Android","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului","unsubscription":"Acum sunteți dezabonat de la Mobiflix"}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Sledujte, čo ďalej","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Mobiflix?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu Mobiflixu","subscribe_messsage":"Ak sa chcete prihlásiť na odber a získať neobmedzený prístup, kliknite na tlačidlo nižšie!","subscribe":"Prihlásiť sa na odber"}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Picks","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Se vad som är nästa","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på Mobiflix?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","subscribe_messsage":"För att prenumerera och få obegränsad åtkomst, klicka på knappen nedan!","subscribe":"Prenumerera","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök efter videor...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt fantastiska om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra denna korta undersökning.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","no_notification":"Ingen anmälan","android":"Android","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum","unsubscription":"Du prenumererar nu Mobiflix"}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"ดูวิดีโอถัดไป","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Mobiflix?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง!","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาวิดีโอ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","no_notification":"ไม่มีการแจ้งเตือน","android":"แอนดรอยด์","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก"}

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_Mobif", "renew_date_Mobif", "subscription_date_Mobif", "authentication_Mobif", "is_unsub_Mobif", "countryCode"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_Mobif"]))
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_Mobif", "country_Mobif", "host_Mobif"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    // let e = undefined;
    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com/";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_Mobif + "&lang=" + this.lang_Mobif).then(function (res) {
        var data = res.data.data;

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPicksPage_Mobif", "IconHotpick_Mobif", "lang_Mobif", "HotPicksPageLoad_Mobif"]),
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_Mobif([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_Mobif([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["fetchPageHotPicks_Mobif"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_Mobif));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_Mobif", "IconPopular_Mobif", "lang_Mobif"]),
  created: function created() {
    this.fetchPagePopular_Mobif();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_Mobif"]))
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_Mobif", "gcid_Mobif", "country_Mobif", "mobiflix_res_sub"])
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      isAoc: false
    };
  },
  created: function created() {
    this.getPrefix(this.country_Mobif);
    if (this.gcid_Mobif === '289' || this.gcid_Mobif === '290' || this.gcid_Mobif === '291' || this.gcid_Mobif == "299" || this.gcid_Mobif == "309") {
      this.isAoc = true;
    }
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_Mobif", "gcid_Mobif", "country_Mobif", "gateway_Mobif"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    consent_gateway: function consent_gateway() {
      if (this.gcid_Mobif == "289") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2641&aff_id=217&aff_sub5=test";
      } else if (this.gcid_Mobif == "290") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2642&aff_id=217&aff_sub5=test";
      } else if (this.gcid_Mobif == "291") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2643&aff_id=217&aff_sub5=test";
      } else if (this.gcid_Mobif == "299") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2735&aff_id=217&aff_sub5=test";
      } else if (this.gcid_Mobif == "309") {
        window.location = "https://www.mobiclub.biz/campaign/click.php?offer_id=3158&aff_sub5=test&aff_id=217";
      } else {
        alert('Invalid GCID');
      }
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_Mobif != "") {
            gcid = this.gcid_Mobif;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_Mobif", response.token);
              localStorage.setItem("userProfile_Mobif", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.loginMobif("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_Mobif == key) {
                    var status_lang = __webpack_require__(121)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["loginMobif"]))
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySlovakian__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicySKEnglish__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyFinnish__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapGetters */])(["lang_Mobif", "country_Mobif"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-slovakian': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySlovakian__["a" /* default */],
    'privacy-skenglish': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicySKEnglish__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyFinnish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermsSlovak__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsCzech__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsEnglish__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["lang_Mobif", "country_Mobif"]),
  components: {
    TermsSlovak: __WEBPACK_IMPORTED_MODULE_0__TermsSlovak__["a" /* default */],
    TermsCzech: __WEBPACK_IMPORTED_MODULE_1__TermsCzech__["a" /* default */],
    TermsEnglish: __WEBPACK_IMPORTED_MODULE_2__TermsEnglish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"])
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mobiflix_Search_vue__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobiflix_Notification_vue__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_2__mobiflix_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_3__mobiflix_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["langButton_Mobif", "lang_Mobif", "authentication_Mobif", "country_Mobif", "is_unsub_Mobif", 'gcid_Mobif']),
  mounted: function mounted() {
    var _this = this;

    this.fetchLangButton_Mobif(this.country_Mobif);
    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_Mobif == "english") {
      if (this.country_Mobif != "ke" && this.country_Mobif != "ke1") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_Mobif != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLang_Mobif(lang);
      localStorage.setItem("lang_Mobif", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      window.location.reload();
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLang_Mobif(lang);
      localStorage.setItem("lang_Mobif", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
      window.location.reload();
    });

    // notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchLang_Mobif", "fetchLangButton_Mobif", "logout_Mobif"]), {
    // getclick() {
    //   location.reload();
    // },
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userTokenID_Mobif");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      // if(from.name == "Category" && to.name == "Category"){
      //   location.reload();
      // }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_Mobif", "host_Mobif"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");

    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_Mobif).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          var item_search = search.filter(function (item) {
            return item.category_id == "3";
          });

          for (var i = 0; i < item_search.length; i++) {
            if (count <= 10) {
              _this2.count = count;
              z.push(item_search[i]);
            }
            count++;
          }

          _this2.result_search = z;
          var not_match = __webpack_require__(121)("./" + _this2.lang_Mobif + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == "mobiflix.vip") {
                    icon = icon_class[key]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
            //to show the bold text
            var rs = z[_i].content_name;

            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);
            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_Mobif", "lang_Mobif", "country_Mobif"])),
  created: function created() {
    this.fetchNotification_Mobif();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_Mobif"]))
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_Mobif", "lang_Mobif", "authentication_Mobif", "country_Mobif", "is_unsub_Mobif"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLang_Mobif", "fetchLangButton_Mobif", "logout_Mobif"]))
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_miximo__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_miximo_miximo_js_miximo_js__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_miximo_Navigation_vue__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Miximo",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_miximo_miximo_js_miximo_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_miximo_miximo_js_miximo_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_miximo_Navigation_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix", "gcid_Mix", "host_Mix"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_Mix(this.host_Mix);
    this.fetchToken_Mix(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_miximo__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_Mix;
    var country_code = this.country_Mix;

    if (this.lang_Mix != "null" && this.lang_Mix != null) {
      if (lang == "arabic") {
        localStorage.setItem("lang_Mix", this.lang_Mix);
        this.$i18n.locale = this.lang_Mix;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_Mix(this.lang_Mix);
      } else {
        localStorage.setItem("lang_Mix", this.lang_Mix);
        this.$i18n.locale = this.lang_Mix;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_Mix(this.lang_Mix);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a[country_code].language;

        localStorage.setItem("lang_Mix", language);
        this.$i18n.locale = language;
        this.fetchLocale_Mix(language);

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_Mix", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_Mix("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["fetchLocale_Mix", "fetchToken_Mix", "getDomain_Mix"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])([
  // "allHotPicksCategory_Mix",
  // "allHotPicksData_Mix",
  "HotPickIcon_Mix", "PopularIcon", "lang_Mix", "country_Mix", "time"
  // "hpisLoad_Mix"
  ]),
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getAllData: function getAllData() {
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);

      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["msisdn_Mix", "renew_date_Mix", "subscription_date_Mix", "auth_Mix", "is_unsub_Mix", "countryCode", "gateway_Mix"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout_Mix"]), {
    logout: function logout(is_unsub) {
      // localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("http://api.puretechglobal.net/gateway_request/bahrain/actel/unsub.php?code=28wpx48x4&msisdn=973234567").then(function (res) {
        console.log(res);
      });
      //router.push({name: Login}).catch(err => {})
    }
  })
});

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_Mix", "HotPickIcon_Mix", "lang_Mix"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_Mix([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_Mix([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_Mix"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_Mix));
      var hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(function (item) {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      } else {
        hotpick.map(function (item) {
          if (_this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate: function getCategoryTranslate(q, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_Mix", "PopularIcon_Mix", "lang_Mix"]),
  created: function created() {
    this.fetchPagePopular_Mix();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_Mix"]))
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MiximoSlider_vue__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["HotPickIcon_Mix", "PopularIcon_Mix", "lang_Mix", "country_Mix", "host_Mix"]),
  components: {
    "miximo-slider": __WEBPACK_IMPORTED_MODULE_8__MiximoSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=10&offset=0&domain=" + _this.host_Mix;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=25&offset=0&domain=" + _this.host_Mix + "&lang=" + _this.lang_Mix;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;
                  _this.hotpicks = data;
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=10&offset=0&domain=" + _this2.host_Mix;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=10&offset=0&domain=" + _this2.host_Mix + "&lang=" + _this2.lang_Mix;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;
                  _this2.popular = data;
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_Mix;
      var live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_Mix + "&lang=" + this.lang_Mix;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != '') {
            if (_this3.lang_Mix != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_Mix].title;

              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_Mix] = sub_trans[_this3.lang_Mix].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_Mix == key) {
                    _this3.categoryTranslate = cat_trans["" + value.language].title;
                    if (sub_trans != null) {
                      item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (category == 'video') {
                    item.icon = sub_icon["mobiflix.vip"]["class"];
                  } else {
                    item.icon = sub_icon["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }

          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          case "arSlider":
            _this.$nextTick(function () {
              var arSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptions);
              arSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              arSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allsubcategory_Mix", "lang_Mix", "country_Mix", "host_Mix"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_Mix(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_Mix"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_Mix;
                live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_Mix + "&lang=" + _this.lang_Mix;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;

                  data = data.filter(function (value) {
                    if (value.category.toLowerCase() == _this.category) {
                      return value;
                    }
                  });

                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allsubcategory_Mix));
      var subcat = allSubcategory.map(function (item) {
        var sub_trans = JSON.parse(item.subcategory_translate);
        var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
        var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

        item.titleSub_english = item.subcategory;
        if (sub_trans != null || sub_icon != null) {
          for (var i = 0; i < trans_len; i++) {
            if (lang == 'english') {
              item["titleSub_english"] = _this2.subcategory;
            } else {
              item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
            }
          }
        }
        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_miximo__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var host = window.location.host;

// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_Mix"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != '') {
          if (langt != 'english') {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(216)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat['mobile_computer'];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal";
      var live = "http://cook.grabmobi.com";
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_Mix,
        product: 'miximo',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=101&offset=0&domain=" + host + "&lang=" + this.lang_Mix).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {}
});

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"عيش متعة موبايلك!","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Miximo؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك"}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Изживейте мобилното си удоволствие!","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Mobizone?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента"}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Žijte svůj mobilní zážitek!","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběr Miximo?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló","search":"Vyhledejte hry, aplikace atd...","not_subs":"Ještě se nepřihlásíte k odběru","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazuy","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhys","feedback_comment":"Zadejte své komentářs","status":"Neaktivní","mobile_computer":"Mobilní a počítačovýr","no_notification":"Žádné oznámení","android":"Android","next_renew_date":"Datum dalšího obnovene","subscription_date":"Datum předplatnéh"}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Lev din mobile nydelse!","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonneret på Miximo?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Live your mobile enjoyment!","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Miximo?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = {"browse":"Selaa","hotpicks":"Hot Picks","popular":"Suosittu","profile":"Profiili","downloads":"Lataukset","download":"ladata","play":"Pelaa nyt","notification":"Ilmoitus","view_more":"Katso lisää","main_title":"Elä matkapuhelimesi nautintoa!","home":"Koti","favorites":"Suosikit","contact":"Ottaa yhteyttä","settings":"asetukset","privacy":"Tietosuojakäytäntö","terms":"käyttöehdot","all":"Kaikki","allCategories":"kaikki kategoriat","categories":"Luokat","category":"Kategoria","platform":"Alusta","type":"Tyyppi","login":"Kirjaudu sisään","logout":"Kirjautua ulos","login_title":"Tilattu Miximo?","confirmation":"Vahvista sitten matkapuhelinnumerosi ja saat rajoittamattoman pääsyn kaikkiin palveluihimme!","submit":"Lähetä","valid_number":"Lisää oikea numero!","full_name":"Koko nimi","registered_num":"Rekisteröity numero","registered_email":"Rekisteröity sähköposti","registered_date":"Rekisteröity päivämäärä","hello":"Hei","search":"Hae pelejä, sovelluksia jne...","not_subs":"Ei vielä tilaa","application":"Sovellus","game":"Peli","video":"Video","contact_us":"Ota meihin yhteyttä","subject":"Aihe","message":"Viesti","let_us":"Kerro meille tiedusteluistasi","select_subject":"Valitse Aihe","app_issue":"Sovelluksen numero","content":"Sisältö","subscription":"Tilaus","unsubscribe":"Lopeta tilaus","not_match":"Ei täsmää","feedback":"Palaute","feedback_intro":"Olisimme erittäin kiitollisia, jos voisit säästää muutaman minuutin auttaaksesi meitä parantamaan sivustoamme täyttämällä tämän lyhyen kyselyn.","Overall":"Yleensä ottaen","Usability":"Käytettävyys","Your Suggestion":"Sinun ehdotuksesi","feedback_comment":"Kirjoita kommenttisi","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","no_notification":"Ei ilmoitusta","android":"Android","next_renew_date":"Seuraava uusimispäivä","subscription_date":"Tilauspäivä"}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"ΟΛΑ ΣΕ ΜΙΑ ΧΩΡΑ","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Miximo?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Application","game":"Game","video":"Video","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"αδρανής","mobile_computer":"Κινητά και υπολογιστές","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Miximo?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Nikmati hidup dengan hiburan mudah alih","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Miximo?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Lev din mobile glede!","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Mobizone?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Picks","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Trăiește-ți plăcerea mobilă!","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la Miximo?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutați jocuri, aplicații etc....","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","no_notification":"Nicio notificare","android":"Android","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului"}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Žite svoj mobilný pôžitok!","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Miximo?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného"}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Picks","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Lev din mobilglädje!","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på Miximo?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök efter spel, appar etc...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt fantastiska om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra denna korta undersökning.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","no_notification":"Ingen anmälan","android":"Android","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum"}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_miximo__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_Mix);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_Mix", "gcid_Mix", "country_Mix"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_Mix != "") {
            gcid = this.gcid_Mix;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userToken_Mix", response.token);
              localStorage.setItem("userProfile_Mix", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.loginMix("loggedin");
              miximo.push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_Mix == key) {
                    var status_lang = __webpack_require__(216)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["loginMix"]))
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySlovakian__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicySKEnglish__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyFinnish__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-slovakian': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySlovakian__["a" /* default */],
    'privacy-skenglish': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicySKEnglish__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyFinnish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsSlovak__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsEnglish__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsCzech__ = __webpack_require__(1750);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix"]),
  components: {
    TermsSlovak: __WEBPACK_IMPORTED_MODULE_1__TermsSlovak__["a" /* default */],
    TermsEnglish: __WEBPACK_IMPORTED_MODULE_2__TermsEnglish__["a" /* default */],
    TermsCzech: __WEBPACK_IMPORTED_MODULE_3__TermsCzech__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_Mix", "country_Mix"])
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_miximo_store_js__ = __webpack_require__(542);










var host = window.location.host;
var lang = localStorage.getItem("lang_Mix");
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      browse: {
        category: [],
        categoryAR: [],
        categoryMY: []
      },
      main: {
        hotpicks: {},
        category: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("miximo")) {
      this.getBrowse();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(browseCate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, browseCat, browseCategory, allDataContent, allData, live, local, browse, temp, browseSort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = '';
                browseCat = [];
                browseCategory = [];
                allDataContent = [];
                allData = [];
                live = "http://cook.grabmobi.com";
                local = "http://[::1]/PuretechGlobalContentPortal";

                //get subcategory under game

                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=" + host);

              case 9:
                browse = _context.sent;
                temp = [];
                browseSort = browseCate.filter(function (item) {
                  if (item.category == 'Application') {
                    temp = item;
                  } else {
                    return item;
                  }
                });

                if (temp != '') {
                  browseSort.push(temp);
                }

                browseCat = browseSort;

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 15;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 21:
                if (!(i < browseCat.length)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 24;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + browseCat[i].category + "&limit=100&offset=0&domain=" + host + "&lang=" + lang);

              case 24:
                allData = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allData.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allData.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allData.data.data.slice(0, 6);
                categ = browseCat[i].category;

                allDataContent[categ] = new Array();
                allDataContent[categ] = data_slice;

              case 31:
                i++;
                _context.next = 21;
                break;

              case 34:

                isload = true;

                _this.main.hotpicks = allDataContent;
                _this.main.category = browseCat;
                _this.main.isLoad = isload;

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=500&offset=0&domain=" + host;
      var live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=" + host;

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp = [];

        data.map(function (item) {
          item.title_english = item.category;
          item.route = item.title_english.toLowerCase();

          var trans = JSON.parse(item.category_translate);
          var icon = JSON.parse(item.category_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
          if (trans != null) {
            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
            // item.icon = icon['my.1.grabmobi.com']['class']
          }

          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon["mobizone.vip"]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          item.coverImg = __webpack_require__(1759)("./" + item.category + ".jpg");
          // item.cover_img = require(`../../../assets/mobizone/imgs/browse/${item.category}.jpg`)
          // item.icon = require(`../../../assets/mobizone/imgs/category/${item.category}.svg`)
          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });
        _this2.getHotPicks(item_temp);
        _this2.browse.category = item_temp;
      });
    }
  }
}));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_miximo__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_Mix");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_Mix: {},
  //auth
  auth_Mix: "",
  //hotpicks.vue
  pageHP_Mix: {},
  //popular.vue
  pagePop_Mix: {},
  //notification.vue
  notification_Mix: {},
  //icon
  hotpickIcon_Mix: __webpack_require__(1757),
  popularIcon_Mix: __webpack_require__(1758),
  langButton_Mix: "",
  country_Mix: parts[0],
  host_Mix: host,
  lang_Mix: localStorage.getItem("lang_Mix"),
  // lang_Mix: brwlang,  
  type_Mix: 'browse',
  gcid_Mix: gcid,
  hpisLoad_Mix: false,
  renew_date_Mix: '',
  subscription_date_Mix: '',
  msisdn_Mix: '',
  country_name_Mix: '',
  gateway_Mix: '',
  is_unsub: '0',
  time: ''
};
// function getTime(test){
//   state.time = test
// }
var getters = {
  langButton_Mix: function langButton_Mix(state) {
    return state.langButton_Mix;
  },
  lang_Mix: function lang_Mix(state) {
    return state.lang_Mix;
  },
  gcid_Mix: function gcid_Mix(state) {
    return state.gcid_Mix;
  },
  country_Mix: function country_Mix(state) {
    return state.country_Mix;
  },
  host_Mix: function host_Mix(state) {
    return state.host_Mix;
  },
  allsubcategory_Mix: function allsubcategory_Mix(state) {
    return state.allsubcategory_Mix;
  },
  pageHotPicks_Mix: function pageHotPicks_Mix(state) {
    return state.pageHP_Mix;
  },
  pagePopular_Mix: function pagePopular_Mix(state) {
    return state.pagePop_Mix;
  },
  HotPickIcon_Mix: function HotPickIcon_Mix(state) {
    return state.hotpickIcon_Mix;
  },
  PopularIcon_Mix: function PopularIcon_Mix(state) {
    return state.popularIcon_Mix;
  },
  notification_Mix: function notification_Mix(state) {
    return state.notification_Mix;
  },
  auth_Mix: function auth_Mix(state) {
    return state.auth_Mix;
  },
  hpisLoad_Mix: function hpisLoad_Mix(state) {
    return state.hpisLoad_Mix;
  },
  renew_date_Mix: function renew_date_Mix(state) {
    return state.renew_date_Mix;
  },
  subscription_date_Mix: function subscription_date_Mix(state) {
    return state.subscription_date_Mix;
  },
  msisdn_Mix: function msisdn_Mix(state) {
    return state.msisdn_Mix;
  },
  country_name_Mix: function country_name_Mix(state) {
    return state.country_name_Mix;
  },
  gateway_Mix: function gateway_Mix(state) {
    return state.gateway_Mix;
  },
  is_unsub_Mix: function is_unsub_Mix(state) {
    return state.is_unsub;
  }
  // time: state => state.time,
};

var actions = {
  fetchLocale_Mix: function fetchLocale_Mix(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchTranslateButton_Mix: function fetchTranslateButton_Mix(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_Mix: function fetchAllSubcategory_Mix(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPageHotPicks_Mix: function fetchPageHotPicks_Mix(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              // console.log(response.data.data);

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPagePopular_Mix: function fetchPagePopular_Mix(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 4:
              response = _context5.sent;


              response.data.data.sort(function (a, b) {
                return (
                  // a.content_name.localeCompare(b.content_name),
                  b.rating - a.rating
                );
              });

              // console.log(response.data.data)
              commit("setPagePopular", response.data.data);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchToken_Mix: function fetchToken_Mix(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_Mix");
              userProfile = localStorage.getItem("userProfile_Mix");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_Mix", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {

                if (state.host_Mix != 'sa.miximo.vip') {
                  __WEBPACK_IMPORTED_MODULE_8__router_miximo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }
              }

              if (!(check == true)) {
                _context6.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 19;
                break;
              }

              localStorage.setItem("userToken_Mix", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 24;
              break;

            case 19:
              _context6.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userToken_Mix", data.code);
                localStorage.setItem("userProfile_Mix", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_miximo__["a" /* default */].push({ path: path }).catch(function (err) {});
                //   location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_miximo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context6.next = 27;
              break;

            case 26:
              //if check is false
              if (state.host_Mix != 'sa.miximo.vip') {
                __WEBPACK_IMPORTED_MODULE_8__router_miximo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getDomain_Mix: function getDomain_Mix(_ref11, host) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context7.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }
              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkToken_Mix: function checkToken_Mix(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subContent_Mix: function subContent_Mix(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userToken_Mix");
              lang = localStorage.getItem("lang_Mix");
              alert_pop = "";
              alert_lang = __webpack_require__(216)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;
              if (token != null) {
                if (file[1] != 'application/x-zip-compressed') {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_Mix,
                    product: 'miximo',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_Mix,
                    product: 'miximo',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_miximo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  loginMix: function loginMix(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchNotification_Mix: function fetchNotification_Mix(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, date, w, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              _context11.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=" + host);

            case 6:
              res = _context11.sent;
              data = res.data.data;
              noti = data.map(function (noti) {
                noti.titleSub_english = noti.subcategory;
                if (noti.subcategory_translate != null) {
                  var sub_trans = JSON.parse(noti.subcategory_translate);
                  if (sub_trans != null) {
                    var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                    if (sub_trans != null || sub_icon != null) {
                      for (var i = 0; i < trans_len; i++) {
                        noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                      }
                    }
                  }
                }
                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.content_name.localeCompare(b.content_name);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.content_name.localeCompare(a.content_name);
                });
              }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_Mix: function logout_Mix(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_Mix");
                localStorage.removeItem("userToken_Mix");
                localStorage.removeItem("logged-in");
              };

              if (!(is_unsub != '0')) {
                _context12.next = 13;
                break;
              }

              token = localStorage.getItem("userToken_Mix");
              _context12.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_Mix + "/" + state.gateway_Mix + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_Mix));

            case 5:
              responses = _context12.sent;

              removeStorage();
              console.log(response);
              response = JSON.parse(responses.data.contents);

              if (responses.data.contents == 'success' || response.status == 'success') {
                location.reload();
              }
              setTimeout(function () {
                location.reload();
              }, 0);
              _context12.next = 14;
              break;

            case 13:
              removeStorage();

            case 14:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

var mutations = {
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_Mix = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_Mix = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_Mix = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_Mix = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_Mix = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_Mix = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_Mix = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_Mix = response.next_renew_date, state.subscription_date_Mix = response.subscription_date, state.msisdn_Mix = response.msisdn, state.country_name_Mix = response.country_code, state.gateway_Mix = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_Mix = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_miximo__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__miximo_js_miximo__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobizone_Search_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Notification_vue__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__mobizone_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_5__Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["langButton_Mix", "lang_Mix", "auth_Mix", "country_Mix", "is_unsub_Mix", "countryCode"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchTranslateButton_Mix(this.country_Mix);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_Mix == "english") {
      if (this.country_Mix != "ke1" && this.country_Mix != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_Mix != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLocale_Mix(lang);
      localStorage.setItem("lang_Mix", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      window.location.reload();
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLocale_Mix(lang);
      localStorage.setItem("lang_Mix", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
      window.location.reload();
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["fetchLocale_Mix", "fetchTranslateButton_Mix", "logout_Mix"]), {
    getclick: function getclick(route, category_id) {},
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_Mix");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_Mix", "lang_Mix", "country_Mix"])),
  created: function created() {
    this.fetchNotification_Mix();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_Mix"]))
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gameknight__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gameknight_gameknight_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_gameknight_Navigation_vue__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Gameknight",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_gameknight_gameknight_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_gameknight_gameknight_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_gameknight_Navigation_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_Gkn", "country_Gkn", "host_Gkn"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_Gkn(this.host_Gkn);
    this.fetchTokenID_Gkn(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_gameknight__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
    }
    var country_id = this.country_Gkn;

    if (this.lang_Gkn != "null" && this.lang_Gkn != null && this.lang_Gkn != '') {
      if (this.lang_Gkn == "arabic") {
        localStorage.setItem("lang_Gkn", this.lang_Gkn);
        this.$i18n.locale = this.lang_Gkn;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLanguage_Gkn(this.lang_Gkn);
      } else {
        localStorage.setItem("lang_Gkn", this.lang_Gkn);
        this.$i18n.locale = this.lang_Gkn;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_Gkn(this.lang_Gkn);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a);
      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a[country_id].language;

        if (localStorage.getItem('userTokenID_Gkn') == 'gkn80') {
          localStorage.setItem("lang_Gkn", 'english');
          this.$i18n.locale = 'english';
          this.fetchLanguage_Gkn('english');
        } else {
          localStorage.setItem("lang_Gkn", language);
          this.$i18n.locale = language;
          this.fetchLanguage_Gkn(language);
        }

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_Gkn", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_Gkn("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["fetchLanguage_Gkn", "fetchTokenID_Gkn", "getDomain_Gkn"]), {
    // ...mapActions(["fetchLanguage_Gkn"]),
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
  // "allSubGame_Gkn",
  // "allStoreGameData_Gkn",
  "IconHotPick_Gkn", "IconPopular_Gkn", "lang_Gkn", "country_Gkn"
  // "hpisLoad_Gkn"
  ]),
  created: function created() {
    // this.fetchHomeHotPick_Gkn();
  },

  methods: {
    // ...mapActions(["fetchHomeHotPick_Gkn"])
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gameknight__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_Gkn", "host_Gkn", "authentication_Gkn", "country_Gkn"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subscribeContent_Gkn"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != '') {
          if (langt != 'english') {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(156)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat['mobile_computer'];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_Gkn,
        product: 'gameknight',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_Gkn).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;

        _this2.contentCoverImg = data.cover_img;

        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);
          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"ألعاب بمنظور جديد!","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Gameknight؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك"}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Игри с нова перспектива!","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Gameknight?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","unsubscribe":"Отписване","not_match":"Не съответства","Action Games":"Екшън игри","Puzzle Game":"Пъзел игра","Sport Games":"Спортни игри","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента"}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Hry s novou perspektivou!","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Gameknight?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledejte hry, aplikace atd...","not_subs":"Ještě se nepřihlásíte k odběru","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","Action Games":"Akční hry","Puzzle Game":"Logické hry","Sport Games":"Sportovní hry","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste si mohli ušetřit pár minut, abyste nám pomohli vylepšit náš web vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámení","android":"Android","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného"}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Spil med nyt perspektiv!","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonneret på Gameknight?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","Action Games":"Action Spil","Puzzle Game":"Gåde","Sport Games":"Sport","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Games with new perspective!","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameknight?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Games","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = {"browse":"Selaa","hotpicks":"Hot Picks","popular":"Suosittu","profile":"Profiili","downloads":"Lataukset","download":"ladata","play":"Pelaa nyt","notification":"Ilmoitus","view_more":"Katso lisää","main_title":"Pelit uudella näkökulmalla!","home":"Koti","favorites":"Suosikit","contact":"Ottaa yhteyttä","settings":"asetukset","privacy":"Tietosuojakäytäntö","terms":"käyttöehdot","all":"Kaikki","allCategories":"kaikki kategoriat","categories":"Luokat","category":"Kategoria","platform":"Alusta","type":"Tyyppi","login":"Kirjaudu sisään","logout":"Kirjautua ulos","login_title":"Tilattu Gameknight?","confirmation":"Vahvista sitten matkapuhelinnumerosi ja saat rajoittamattoman pääsyn kaikkiin palveluihimme!","submit":"Lähetä","valid_number":"Lisää oikea numero!","full_name":"Koko nimi","registered_num":"Rekisteröity numero","registered_email":"Rekisteröity sähköposti","registered_date":"Rekisteröity päivämäärä","hello":"Hei","search":"Etsi pelejä, sovelluksia jne...","not_subs":"Ei vielä tilaa","application":"Sovellus","game":"Peli","video":"Video","contact_us":"Ota meihin yhteyttä","subject":"Aihe","message":"Viesti","let_us":"Kerro meille tiedusteluistasi","select_subject":"Valitse Aihe","app_issue":"Sovelluksen numero","content":"Sisältö","subscription":"Tilaus","unsubscribe":"Lopeta tilaus","Action Games":"Toimintapelit","Puzzle Game":"Pulmapelit","Sport Games":"Urheilupelit","not_match":"Ei täsmää","feedback":"Palaute","feedback_intro":"Olisimme erittäin kiitollisia, jos voisit säästää muutaman minuutin auttaaksesi meitä parantamaan sivustoamme täyttämällä tämän lyhyen kyselyn.","Overall":"Yleensä ottaen","Usability":"Käytettävyys","Your Suggestion":"Sinun ehdotuksesi","feedback_comment":"Kirjoita kommenttisi","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","no_notification":"Ei ilmoitusta","android":"Android","next_renew_date":"Seuraava uusimispäivä","subscription_date":"Tilauspäivä"}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"ΟΛΑ ΣΕ ΜΙΑ ΧΩΡΑ","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Gameknight?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Application","game":"Game","video":"Video","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Gameknight?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Permainan dengan perspektif baru!","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Gameknight?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Spill med nytt perspektiv !","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Gameknight?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","Action Games":"Actionspill","Puzzle Game":"Пъзел игра","Sport Games":"Sportsspill","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Games with new perspective!","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameknight?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Games","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Hry s novou perspektívou!","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Gameknight?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","Action Games":"Akčné hry","Puzzle Game":"Hádanka","Sport Games":"Šport","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného"}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Games with new perspective!","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameknight?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Games","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date"}

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_Gkn", "renew_date_Gkn", "subscription_date_Gkn", "authentication_Gkn", "is_unsub_Gkn"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_Gkn"]))
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_Gkn", "country_Gkn", "host_Gkn", "subcategory_id_Gkn"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_Gkn).then(function (res) {
        var data = res.data.data;

        // data = data.filter((value)=>{
        //   if(value.category.toLowerCase() == 'game'){
        //     return value;
        //   }
        // })

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPicksPage_Gkn", "IconHotPick_Gkn", "lang_Gkn"]),
  created: function created() {
    this.isLoad = false;
    this.fetchHotPicksGame_Gkn([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchHotPicksGame_Gkn([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["fetchHotPicksGame_Gkn"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_Gkn));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_Gkn", "IconPopular_Gkn", "lang_Gkn"]),
  created: function created() {
    this.fetchPopularGame_Gkn();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPopularGame_Gkn"]))
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gameknight__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_Gkn);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_Gkn", "gcid_Gkn", "country_Gkn"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_Gkn != "") {
            gcid = this.gcid_Gkn;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_Gkn", response.token);
              localStorage.setItem("userProfile_Gkn", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_Gkn("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_gameknight__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_Gkn == key) {
                    var status_lang = __webpack_require__(156)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_Gkn"]))
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["lang_Gkn", "country_Gkn"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      ar: {
        arLanguage: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false
      },
      browse: {
        category: []
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("gameknight")) {
      this.getBrowse();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(subcate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allGameData, subcateg, allDataGame, live, local, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, _subcate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = '';
                subCate = [];
                allGameData = [];
                subcateg = [];
                allDataGame = [];
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";

                // let subgame = await axios.get(
                //     `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=1&domain=${host}`
                // );

                // subcateg = subgame.data.data
                //get subcategory from getBrowse()

                subcate.map(function (item) {
                  if (item.subcategory != "Arcade Games") {
                    subCate.push(item);
                  }
                });

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 12;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 15:
                if (!(i < subCate.length)) {
                  _context.next = 28;
                  break;
                }

                _context.next = 18;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subCate[i].subcategory + "&limit=50&offset=0&domain=" + host);

              case 18:
                allDataGame = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataGame.data.data.slice(0, 6);
                _subcate = subCate[i].subcategory;

                allGameData[_subcate] = new Array();
                allGameData[_subcate] = data_slice;

              case 25:
                i++;
                _context.next = 15;
                break;

              case 28:

                isload = true;
                _this.main.hotpicks = allGameData;
                // this.main.subcategory = subCate.slice(2,5);
                subcate.length >= 4 ? _this.main.subcategory = subCate.slice(2, 5) : _this.main.subcategory = subCate;
                _this.main.isLoad = isload;

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //game as default
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=100&offset=0&domain=" + host).then(function (res) {
        var data = res.data.data;

        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon["games4all.vip"]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans);
          if (trans != null) {
            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });

        _this2.browse.category = item_temp;
        _this2.getHotPicks(item_temp);
      });
    }
  }
}));

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gameknight_gameknight__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gameknight_Search_vue__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gameknight_Notification_vue__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_3__gameknight_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_4__gameknight_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["langButton_Gkn", "lang_Gkn", "authentication_Gkn", "country_Gkn", "is_unsub_Gkn"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchLanguageButton_Gkn(this.country_Gkn);
    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_Gkn == "english") {
      if (this.country_Gkn != "ke" && this.country_Gkn != "ke1") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_Gkn != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLanguage_Gkn(lang);
      localStorage.setItem("lang_Gkn", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLanguage_Gkn(lang);
      localStorage.setItem("lang_Gkn", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    // notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["fetchLanguage_Gkn", "fetchLanguageButton_Gkn", "logout_Gkn"]), {
    getSubCategory_Gkn: function getSubCategory_Gkn(id) {
      console.log(id);
    },
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    }
  }),
  watch: {
    $route: function $route(to, from) {}
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_Gkn", "host_Gkn"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_Gkn).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          var item_search = search.filter(function (item) {
            return item.category_id == "2";
          });

          for (var i = 0; i < item_search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(item_search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(156)("./" + _this2.lang_Gkn + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];
          var icon = "";

          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_Gkn) {
                    icon = icon_class[key]["class"];
                  } else {
                    icon = icon_class["games4all.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");
            bold.push(r);

            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_Gkn", "lang_Gkn", "country_Gkn"])),
  created: function created() {
    this.fetchGameNotification_Gkn();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchGameNotification_Gkn"]))
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gameonz__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gameonz_gameonz_js__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_gameonz_Navigation_vue__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_gameonz_UnsubModal_vue__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "gameonz",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_gameonz_gameonz_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_gameonz_gameonz_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_gameonz_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_8__components_gameonz_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_gonz", "country_gonz", "host_gonz"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_gonz(this.host_gonz);
    this.fetchTokenID_gonz(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_gameonz__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
    }
    var country_id = this.country_gonz;

    if (this.lang_gonz != "null" && this.lang_gonz != null) {
      if (this.lang_gonz == "arabic") {
        localStorage.setItem("lang_gonz", this.lang_gonz);
        this.$i18n.locale = this.lang_gonz;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLanguage_gonz(this.lang_gonz);
      } else {
        localStorage.setItem("lang_gonz", this.lang_gonz);
        this.$i18n.locale = this.lang_gonz;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_gonz(this.lang_gonz);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a);

      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a[country_id].language;

        localStorage.setItem("lang_gonz", language);
        this.$i18n.locale = language;
        this.fetchLanguage_gonz(language);

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_gonz", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_gonz("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLanguage_gonz", "fetchTokenID_gonz", "getDomain_gonz"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      games: {}
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
  // "allSubGame_gonz",
  // "allStoreGameData_gonz",
  "IconHotPick_gonz", "IconPopular_gonz", "lang_gonz", "country_gonz"
  // "hpisLoad_gonz"
  ]),
  created: function created() {
    // this.fetchHomeHotPick_gonz();
  },
  mounted: function mounted() {},

  methods: {
    // ...mapActions(["fetchHomeHotPick_gonz"])
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomLightbox_vue__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var host = window.location.host;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_6__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_gonz", "host_gonz", "country_gonz"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["subscribeContent_gonz"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(95)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";

      //post view detail
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_gonz,
        product: 'gameonz',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + host).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;

        _this2.contentCoverImg = data.cover_img;

        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);
          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_gonz", "renew_date_gonz", "subscription_date_gonz", "authentication_gonz", "is_unsub_gonz"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_gonz"]))
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_gonz", "country_gonz", "host_gonz"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_gonz).then(function (res) {
        var data = res.data.data;

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPicksPage_gonz", "IconHotPick_gonz", "lang_gonz"]),
  created: function created() {
    this.isLoad = false;
    this.fetchHotPicks_gonz([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchHotPicks_gonz([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["fetchHotPicks_gonz"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_gonz));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_gonz", "IconPopular_gonz", "lang_gonz"]),
  created: function created() {
    this.fetchPopular_gonz();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPopular_gonz"]))
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_gonz", "gcid_gonz", "country_gonz", "mondia_res_sub"])
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gameonz__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      isAoc: false
    };
  },
  created: function created() {
    this.getPrefix(this.country_gonz);

    if (this.gcid_gonz === '289' || this.gcid_gonz === '290' || this.gcid_gonz === '291' || this.gcid_gonz === '299' || this.gcid_gonz === '309') {
      this.isAoc = true;
    }
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_gonz", "gcid_gonz", "country_gonz"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    consent_gateway: function consent_gateway() {
      if (this.gcid_gonz == "289") {
        window.location = "https://www.gameonz.vip/campaign/click.php?offer_id=2638&aff_id=217&aff_sub5=test";
      } else if (this.gcid_gonz == "290") {
        window.location = "https://www.gameonz.vip/campaign/click.php?offer_id=2639&aff_id=217&aff_sub5=test";
      } else if (this.gcid_gonz == "291") {
        window.location = "https://www.gameonz.vip/campaign/click.php?offer_id=2640&aff_id=217&aff_sub5=test";
      } else if (this.gcid_gonz == "299") {
        window.location = "https://www.gameonz.vip/campaign/click.php?offer_id=2734&aff_id=217&aff_sub5=test";
      } else if (this.gcid_gonz == "309") {
        window.location = "https://www.mobiclub.biz/campaign/click.php?offer_id=3159&aff_sub5=test&aff_id=217";
      } else {
        alert('Invalid GCID');
      }
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_gonz != "") {
            gcid = this.gcid_gonz;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_gonz", response.token);
              localStorage.setItem("userProfile_gonz", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_gonz("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_gameonz__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_gonz == key) {
                    var status_lang = __webpack_require__(217)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_gonz"]))
});

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"الاختبار النهائي لاسياد اللعاب","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Gameonz؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","subscribe_messsage":"للاشتراك والحصول على وصول غير محدود، الرجاء الضغط على الزر في الأسفل!","subscribe":"اشتراك","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Mobiflix","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا"}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Финалният тест на играта на играта","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Gameonz?","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","Action Games":"Екшън игри","Puzzle Game":"Пъзел игра","Sport Games":"Спортни игри","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани от Gameonz"}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Závěrečný test herního mistra","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Gameonz?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","subscribe_messsage":"Chcete-li se přihlásit k odběru a získat neomezený přístup, klikněte na tlačítko níže!","subscribe":"předplatit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledejte hry, aplikace atd...","not_subs":"Ještě se nepřihlásíte k odběru","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","Action Games":"Akční hry","Puzzle Game":"Logická hra","Sport Games":"Sportovní hry","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste si mohli ušetřit pár minut, abyste nám pomohli vylepšit náš web vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámení","android":"Android","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","unsubscription":"Nyní jste odhlášeni z Gameonz"}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Den sidste test af spilmesteren","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonneret på Gameonz?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","Action Games":"Action Spil","Puzzle Game":"Gåde","Sport Games":"Sport","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Gameonz","subscribe_messsage":"Klik på nedenstående knap for at abonnere og få ubegrænset adgang!","subscribe":"Abonner"}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"The Final Test Of The Game Master","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameonz?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Gameonz","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No"}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"The Final Test Of The Game Master","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameonz?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Gameonz"}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"Το τελευταίο τεστ του μάστερ του παιχνιδιού","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Gameonz?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Application","game":"Game","video":"Video","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Ujian terakhir untuk game master","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Gameonz?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Percubaan Terakhir Untuk Pakar Permainan","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Gameonz?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Den siste testen av spillmesteren","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Gameonz?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","Action Games":"Actionspill","Puzzle Game":"Puslespill","Sport Games":"Sportsspill","unsubscription":"Du abonnerer nå på Gameonz"}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"The Final Test Of The Game Master","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameonz?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Gameonz"}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Záverečný test herného majstra","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Gameonz?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","Action Games":"Akčné hry","Puzzle Game":"Hádanka","Sport Games":"Šport","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","subscribe_messsage":"Ak sa chcete prihlásiť na odber a získať neobmedzený prístup, kliknite na tlačidlo nižšie!","subscribe":"Prihlásiť sa na odber","unsubscription":"Teraz ste odhlásení z odberu Gameonz"}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"The Final Test Of The Game Master","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Gameonz?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Gameonz"}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["lang_gonz", "country_gonz"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gameonz_Search_vue__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gameonz_Notification_vue__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_2__gameonz_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_3__gameonz_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["langButton_gonz", "lang_gonz", "authentication_gonz", "country_gonz", "is_unsub_gonz", "gcid_gonz"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchLanguageButton_gonz(this.country_gonz);
    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_gonz == "english") {
      if (this.country_gonz != "ke" && this.country_gonz != "ke1") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_gonz != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLanguage_gonz(lang);
      localStorage.setItem("lang_gonz", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLanguage_gonz(lang);
      localStorage.setItem("lang_gonz", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    // notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchLanguage_gonz", "fetchLanguageButton_gonz", "logout_gonz"]), {
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userTokenID_gonz");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      // if(from.name == "Subcategory" && to.name == "Subcategory"){
      //   location.reload();
      // }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_gonz", "host_gonz"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_gonz).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          var item_search = search.filter(function (item) {
            return item.category_id == "2";
          });

          for (var i = 0; i < item_search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(item_search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(217)("./" + _this2.lang_gonz + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];

          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }
            var icon = "";
            //my.1.grabmobi.com as default domain
            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_gonz) {
                    icon = icon_class[key]["class"];
                  } else {
                    icon = icon_class["games4all.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");
            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_gonz", "lang_gonz", "country_gonz"])),
  created: function created() {
    this.fetchNotification_gonz();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_gonz"]))
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_gonz", "lang_gonz", "authentication_gonz", "country_gonz", "is_unsub_gonz"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLanguage_gonz", "fetchLanguageButton_gonz", "logout_gonz"]))
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_funplus__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_funplus_funplus_js_funplus_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_funplus_Navigation_vue__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_funplus_UnsubModal_vue__ = __webpack_require__(1968);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FunPlus",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_funplus_funplus_js_funplus_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_funplus_funplus_js_funplus_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_funplus_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_15__components_funplus_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_fplus", "country_fplus", "host_fplus"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_fplus(this.host_fplus);
    this.fetchToken_fplus(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_funplus__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_fplus;
    var country_code = this.country_fplus;

    if (this.lang_fplus != "null" && this.lang_fplus != null) {
      if (lang == "arabic") {
        localStorage.setItem("lang_fplus", this.lang_fplus);
        this.$i18n.locale = this.lang_fplus;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_fplus(this.lang_fplus);
      } else {
        localStorage.setItem("lang_fplus", this.lang_fplus);
        this.$i18n.locale = this.lang_fplus;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_fplus(this.lang_fplus);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a[country_code].language;

        if (localStorage.getItem('userToken_fplus') == 'fplus80') {
          localStorage.setItem("lang_fplus", 'english');
          this.$i18n.locale = 'english';
          this.fetchLocale_fplus('english');
        } else {
          localStorage.setItem("lang_fplus", language);
          this.$i18n.locale = language;
          this.fetchLocale_fplus(language);
        }

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_fplus", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_fplus("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["fetchLocale_fplus", "fetchToken_fplus", "getDomain_fplus"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])([
  // "allHotPicksCategory_fplus",
  // "allHotPicksData_fplus",
  "HotPickIcon_fplus", "PopularIcon_fplus", "lang_fplus", "country_fplus"
  // "hpisLoad_fplus"
  ]),
  created: function created() {
    // this.fetchHotPicks_fplus();
    // this.fetchPopular_fplus();
  },

  methods: {
    // ...mapActions(["fetchHotPicks_fplus", "fetchPopular_fplus"]),
    getAllData: function getAllData() {
      // console.log(this.allHotPicksData)
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_fplus", "country_fplus"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["msisdn_fplus", "renew_date_fplus", "subscription_date_fplus", "auth_fplus", "is_unsub_fplus"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout_fplus"]), {
    logout: function logout(is_unsub) {
      // localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("http://api.puretechglobal.net/gateway_request/bahrain/actel/unsub.php?code=28wpx48x4&msisdn=973234567").then(function (res) {
        console.log(res);
      });
      //router.push({name: Login}).catch(err => {})
    }
  })
});

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_fplus", "HotPickIcon_fplus", "lang_fplus", "country_fplus"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_fplus([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_fplus([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_fplus"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_fplus));
      var hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(function (item) {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      } else {
        hotpick.map(function (item) {
          if (_this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate: function getCategoryTranslate(q, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_fplus", "PopularIcon_fplus", "country_fplus", "lang_fplus"]),
  created: function created() {
    this.fetchPagePopular_fplus();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_fplus"]))
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MobiZoneSlider_vue__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["HotPickIcon_fplus", "PopularIcon_fplus", "lang_fplus", "country_fplus", "host_fplus"]),
  components: {
    "mobizone-slider": __WEBPACK_IMPORTED_MODULE_8__MobiZoneSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_fplus;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_fplus + "&lang=" + _this.lang_fplus;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;

                  _this.hotpicks = data.slice(0, 10);
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_fplus;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_fplus + "&lang=" + _this2.lang_fplus;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;

                  _this2.popular = data.slice(0, 10);
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_fplus;
      var live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_fplus + "&lang=" + this.lang_fplus;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != '') {
            if (_this3.lang_fplus != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_fplus].title;console.log(_this3.categoryTranslate);
              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_fplus] = sub_trans[_this3.lang_fplus].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_fplus == key) {
                    _this3.categoryTranslate = cat_trans["" + value.language].title;
                    if (sub_trans != null) {
                      item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (category == 'video') {
                    item.icon = sub_icon["mobiflix.vip"]["class"];
                  } else {
                    item.icon = sub_icon["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }

          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_fplus", "country_fplus"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  components: {
    "star-rating": __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          case "arSlider":
            _this.$nextTick(function () {
              var arSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptions);
              arSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              arSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allSubcategory_fplus", "lang_fplus", "country_fplus", "host_fplus"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_fplus(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_fplus"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_fplus;
                live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_fplus + "&lang=" + _this.lang_fplus;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;

                  data = data.filter(function (value) {
                    if (value.category.toLowerCase() == _this.category) {
                      return value;
                    }
                  });

                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allSubcategory_fplus));

      var subcat = allSubcategory.map(function (item) {
        var sub_trans = JSON.parse(item.subcategory_translate);
        var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
        var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

        item.titleSub_english = item.subcategory;
        if (sub_trans != null || sub_icon != null) {
          for (var i = 0; i < trans_len; i++) {
            if (lang == 'english') {
              item["titleSub_english"] = _this2.subcategory;
            } else {
              item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
            }
          }
        }
        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_funplus__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_fplus", "host_fplus", "auth_fplus", "country_fplus"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_fplus"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(158)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //everytime user display detail page, will collect the data
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_fplus,
        product: 'funplus',
        content_id: id,
        type: "view"
      });

      // let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=${id}&category=&subcategory=&limit=100&offset=0&domain=${this.host_fplus}`;
      // let live = `http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=${id}&category=&subcategory=&limit=100&offset=0&domain=${this.host_fplus}`;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_fplus + "&lang=" + this.lang_fplus).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {}
});

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","hotpick":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"إضافة المرح على هاتفك","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في FunPlus؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","all_hotpick":"كل هوتبيك","all_popular":"كل شعبية","all_categories":"جميع الفئات","unsubscription":"أنت الأن غير مشترك في خدمة Prizeo","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا","subscribe_messsage":"للاشتراك والحصول على وصول غير محدود ، يرجى النقر فوق الزر أدناه!","subscribe":"الإشتراك"}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":" Добавяне на забавление към вашия мобилен телефон","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за FunPlus?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","all_hotpick":"Всички Hotpick","all_popular":"Всички популярни","all_categories":"Всички категории","unsubscription":"Вече сте отписани от Funplus","modal_title":"Анулиране на абонамента?","unsub_confirmation":"Наистина ли искате да се отпишете?","yes":"Да","no":"Не","current_status":"Актуално състояние","subscribe_messsage":"За да се абонирате и да получите неограничен достъп, моля, кликнете върху бутона по-долу!","subscribe":"Абонирай се","faq":"Faq","t&c":"Правила и условия"}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","hotpick":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Přidání zábavy do vašeho mobilu","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru FunPlus?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledejte hry, aplikace atd...","not_subs":"Ještě se nepřihlásíte k odběru","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste si mohli ušetřit pár minut, abyste nám pomohli vylepšit náš web vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","android":"Android","no_notification":"Žádné oznámení","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","all_hotpick":"Všechny Hotpick","all_popular":"Vše populární","all_categories":"Všechny kategorie"}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","hotpick":"Hot Pick","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Tilføje sjov til din mobil","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på FunPlus?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på FunPlus","modal_title":"Annuller abonnement?","unsub_confirmation":"Er du sikker på, at du vil afmelde dig?","yes":"Ja","no":"ingen","all_hotpick":"Alle hotpick","all_popular":"Alle populære","all_categories":"alle kategorier","faq":"FAQ","t&c":"Vilkår og betingelser","subscribe_messsage":"Klik på nedenstående knap for at abonnere og få ubegrænset adgang!","subscribe":"Abonner"}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","hotpick":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Adding Fun To Your Mobile","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to FunPlus?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","all_hotpick":"All Hotpick","all_popular":"All Popular","all_categories":"All Categories","unsubscription":"You are now unsubscribed from Funplus","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","faq":"Faq","t&c":"Terms and Conditions"}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Pick","hotpick":"Hot Pick","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Adăugarea distracției la telefonul mobil","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la FunPlus?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutați jocuri, aplicații etc...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs.","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","android":"Android","no_notification":"Nicio notificare","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului","all_hotpick":"Toate Hotpick","all_popular":"Toate populare","all_categories":"toate categoriile","unsubscription":"Acum sunteți dezabonat de la Funplus","modal_title":"Anuleaza abonarea?","unsub_confirmation":"Sigur doriți să vă dezabonați?","yes":"da","no":"Nu","subscribe_messsage":"Pentru a vă abona și a obține acces nelimitat, faceți clic pe butonul de mai jos!","subscribe":"Abonati-va","faq":"FAQ","t&c":"Termeni si conditii"}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = {"browse":"Εξερεύνηση","hotpicks":"Δημοφιλείς","hotpick":"Δημοφιλής Επιλογή","popular":"Δημοφιλή","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δες περισσότερα","main_title":"Φέροντας τη διασκέδαση στο κινητό σου","home":"Αρχική Σελίδα","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορίες","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο FunPlus?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γεια σου","search":"Αναζήτηση","not_subs":"Δεν Εγγραφή ακόμα","application":"Εφαρμογή","game":"Παιχνίδι","video":"Βίντεο","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Διαγραφή","not_match":"Δεν Ταιριάζει","feedback":"Αξιολόγηση","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής","all_hotpick":"Τα πιο καυτά όλων των εποχών","all_popular":"Τα πιο δημοφιλή όλων των εποχών","all_categories":"Όλες οι κατηγορίες","faq":"Συχνές Ερωτήσεις","t&c":"Όροι Χρήσης"}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","hotpick":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Menambahkan Kesenangan ke Ponsel Anda","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan FunPlus?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan","all_hotpick":"Semua Hotpick","all_popular":"Semua Populer","all_categories":"Semua Kategori"}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","hotpick":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Menambah Keseronokan Pada Telefon Anda","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan FunPlus?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan","all_hotpick":"Semua Hotpick","all_popular":"Semua Popular","all_categories":"Semua Kategori"}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Legge til moro på mobilen din","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert påFunPlus?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Funplus","modal_title":"Avbestille abonnementet?","unsub_confirmation":"Er du sikker på at du vil avslutte abonnementet?","yes":"Ja","no":"Nei","current_status":"Nåværende status","all_hotpick":"Alle hotpick","all_popular":"Alle populære","all_categories":"Alle Kategorier","subscribe_messsage":"For å abonnere og få ubegrenset tilgang, vennligst klikk på knappen nedenfor!","subscribe":"Abonnere","faq":"Faq","t&c":"Vilkår og betingelser"}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Pick","hotpick":"Hot Pick","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Adăugarea distracției la telefonul mobil","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la FunPlus?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutați jocuri, aplicații etc...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","android":"Android","no_notification":"Nicio notificare","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului","all_hotpick":"Toate Hotpick","all_popular":"Toate popularer","all_categories":"toate categoriile","unsubscription":"Acum sunteți dezabonat de la Funplus","modal_title":"Anuleaza abonarea?","unsub_confirmation":"Sigur doriți să vă dezabonați?","yes":"da","no":"Nu","subscribe_messsage":"Pentru a vă abona și a obține acces nelimitat, faceți clic pe butonul de mai jos!","subscribe":"Abonati-va","faq":"FAQ","t&c":"Termeni si conditii"}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","hotpick":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Pridanie zábavy do vášho mobilu","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber FunPlus?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","subscribe_messsage":"Ak sa chcete prihlásiť na odber a získať neobmedzený prístup, kliknite na tlačidlo nižšie!","subscribe":"Prihlásiť sa na odber","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu FunPlus","modal_title":"Zrušiť predplatné?","unsub_confirmation":"Naozaj chcete zrušiť odber?","yes":"Áno","no":"Nie","all_hotpick":"Všetko Hotpick","all_popular":"Všetko populárne","all_categories":"Všetky kategórie","faq":"Časté otázky","t&c":"Podmienky"}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Pick","hotpick":"Hot Pick","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Lägga till kul till din mobil","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på FunPlus?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök efter spel, appar etc...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din frågay","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt fantastiska om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra denna korta undersökning.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","android":"Android","no_notification":"Ingen anmälan","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum","all_hotpick":"Alla hotpick","all_popular":"Alla populära","all_categories":"alla kategorier","unsubscription":"Du prenumererar nu Funplus","modal_title":"Avsluta prenumeration?","unsub_confirmation":"Är du säker på att du vill avsluta prenumerationen?","yes":"Ja","no":"Nej","subscribe_messsage":"För att prenumerera och få obegränsad åtkomst, klicka på knappen nedan!","subscribe":"Prenumerera","faq":"Vanliga frågor","t&c":"Villkor"}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","hotpick":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"เพิ่มความสนุกบนมือถ","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร FunPlus?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาเกมส์ แอพลิเคชั่น และอื่นๆ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","no_notification":"ไม่มีการแจ้งเตือน","android":"แอนดรอยด์","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","all_hotpick":"ทั้งหมด Hotpick,","all_popular":"เป็นที่นิยมทั้งหมด","all_categories":"ทุกหมวดหมู่"}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_funplus__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"

    };
  },
  created: function created() {

    this.getPrefix(this.country_fplus);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_fplus", "gcid_fplus", "country_fplus"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.gcid_fplus == '303') {
        this.msisdn = '69';
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_fplus != "") {
            gcid = this.gcid_fplus;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userToken_fplus", response.token);
              localStorage.setItem("userProfile_fplus", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_fplus("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_funplus__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_fplus == key) {
                    var status_lang = __webpack_require__(158)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_fplus"]))
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contact__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactGRPaydashGreek__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactGRPaydashEnglish__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["lang_fplus", "country_fplus", "country_name_fplus", "gateway_code"]),
  components: {
    'contact': __WEBPACK_IMPORTED_MODULE_0__Contact__["a" /* default */],
    'contact-paydash-greek': __WEBPACK_IMPORTED_MODULE_1__ContactGRPaydashGreek__["a" /* default */],
    'contact-paydash-english': __WEBPACK_IMPORTED_MODULE_2__ContactGRPaydashEnglish__["a" /* default */]

  },
  methods: {}
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c05493e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(1910);
function injectStyle (ssrContext) {
  __webpack_require__(1909)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c05493e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c05493e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {}
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyPaydashGreek__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyPaydashEnglish__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_fplus", "country_fplus", "gateway_code", "country_name_fplus"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-paydash-greek': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyPaydashGreek__["a" /* default */],
    'privacy-paydash-english': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyPaydashEnglish__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyNorwegian__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FaqGRPaydashEnglish__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FaqGRPaydashGreek__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_fplus", "country_fplus", "country_name_fplus", "gateway_code"]),
  components: {
    'faq-paydash-english': __WEBPACK_IMPORTED_MODULE_0__FaqGRPaydashEnglish__["a" /* default */],
    'faq-paydash-greek': __WEBPACK_IMPORTED_MODULE_1__FaqGRPaydashGreek__["a" /* default */]

  },
  methods: {}
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_fplus", "gcid_fplus", "country_fplus"])
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermsGRPaydashGreek__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsEnglish__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsCzech__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["lang_fplus", "countryCode"]),
  components: {
    "terms-paydash-greek": __WEBPACK_IMPORTED_MODULE_0__TermsGRPaydashGreek__["a" /* default */],
    TermsEnglish: __WEBPACK_IMPORTED_MODULE_1__TermsEnglish__["a" /* default */],
    TermsCzech: __WEBPACK_IMPORTED_MODULE_2__TermsCzech__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"])
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"])
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;
var lang = localStorage.getItem("lang_fplus");
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
    data: function data() {
        return {
            browse: {
                category: [],
                categoryAR: [],
                categoryMY: []
            },
            main: {
                hotpicks: {},
                category: {},
                isLoad: false
            },
            search: {
                allSearch: {}
            },
            type: 'browse'
        };
    },
    created: function created() {
        if (host.includes("funplus")) {
            this.getBrowse();
        }
    },

    methods: {
        getHotPicks: function getHotPicks(browseCate) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var isload, browseCat, browseCategory, allDataContent, allData, live, local, temp, browseSort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                isload = '';
                                browseCat = [];
                                browseCategory = [];
                                allDataContent = [];
                                allData = [];
                                live = 'http://cook.grabmobi.com';
                                local = 'http://[::1]/PuretechGlobalContentPortal';

                                //get category
                                // let browse = await axios.get(
                                //     `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=${host}`
                                // );

                                temp = [];
                                browseSort = browseCate.filter(function (item) {
                                    if (item.category == 'Application') {
                                        temp = item;
                                    } else {
                                        return item;
                                    }
                                });

                                if (temp != '') {
                                    browseSort.push(temp);
                                }

                                browseCat = browseSort;

                                //get random number
                                oneHourInMs = 3600000;
                                currentTimeInMs = new Date().getTime(); // UTC time

                                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                                numberForToday = timeInHour % 18;
                                // zero-filling of numbers less than four digits might be optional for you
                                // zero-filled value will be a string to maintain its leading 0s

                                DigitNumber = numberForToday.toString();

                                while (DigitNumber.length < 2) {
                                    DigitNumber = 0 + Number(DigitNumber);
                                }

                                i = 0;

                            case 18:
                                if (!(i < browseCat.length)) {
                                    _context.next = 31;
                                    break;
                                }

                                _context.next = 21;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + '/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=' + browseCat[i].category + '&limit=100&offset=0&domain=' + host + '&lang=' + lang);

                            case 21:
                                allData = _context.sent;
                                divide = DigitNumber % 2;

                                if (divide == 0) {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return Math.random() - 0.5;
                                    });
                                } else {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return 0.5 - Math.random();
                                    });
                                }

                                data_slice = allData.data.data.slice(0, 6);
                                categ = browseCat[i].category;

                                allDataContent[categ] = new Array();
                                allDataContent[categ] = data_slice;

                            case 28:
                                i++;
                                _context.next = 18;
                                break;

                            case 31:

                                isload = true;

                                _this.main.hotpicks = allDataContent;
                                _this.main.category = browseCat;
                                _this.main.isLoad = isload;

                            case 35:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getBrowse: function getBrowse() {
            var _this2 = this;

            var local = 'http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;
            var live = 'http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;

            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live).then(function (res) {
                var data = res.data.data;
                var temp = [];

                data.map(function (item) {
                    item.title_english = item.category;
                    item.route = item.title_english.toLowerCase();

                    var trans = JSON.parse(item.category_translate);
                    var icon = JSON.parse(item.category_icon);

                    if (trans != null) {
                        var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
                        var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
                        for (var i = 0; i < trans_len; i++) {
                            item['title_' + trans_arr[i]] = trans[trans_arr[i]].title;
                        }
                        // item.icon = icon['my.1.grabmobi.com']['class'];
                    }

                    if (icon != null) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var _ref = _step.value;

                                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                                var key = _ref2[0];
                                var value = _ref2[1];

                                if (key == host) {
                                    item.icon = icon[key]["class"];
                                } else {
                                    item.icon = icon['mobizone.vip']['class'];
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    item.coverImg = __webpack_require__(639)("./" + item.category + '.jpg');

                    temp.push(item);
                });

                var item_temp = temp.map(function (v) {
                    delete v.category_translate;
                    delete v.category_translate;
                    delete v.category_icon;
                    delete v.subcategory;
                    delete v.subcategory_translate;
                    delete v.subcategory_icon;
                    delete v.thumbnail_url;
                    delete v.cover_img;
                    return v;
                });

                _this2.browse.category = item_temp;
                _this2.getHotPicks(item_temp);
            });
        }
    }
}));

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Application.jpg": 1950,
	"./Game.jpg": 1951,
	"./Music.jpg": 1952,
	"./Video.jpg": 1953,
	"./Wallpaper.jpg": 1954,
	"./Yummy Recipe.jpg": 1955,
	"./Yummy-Recipe.jpg": 1956
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 639;

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_funplus__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__funplus_js_funplus__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__funplus_Search_vue__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funplus_Notification_vue__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__funplus_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_5__funplus_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["langButton_fplus", "lang_fplus", "auth_fplus", "country_fplus", "is_unsub_fplus", "country_name_fplus", "gateway_code", "gcid_fplus"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchTranslateButton_fplus(this.country_fplus);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_fplus == "english") {
      if (this.country_fplus != "ke1" && this.country_fplus != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_fplus != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLocale_fplus(lang);
      localStorage.setItem("lang_fplus", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      window.location.reload();
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLocale_fplus(lang);
      localStorage.setItem("lang_fplus", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
      window.location.reload();
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["fetchLocale_fplus", "fetchTranslateButton_fplus", "logout_fplus"]), {
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_fplus");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_fplus", "host_fplus"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_fplus;
        var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_fplus;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(158)("./" + _this2.lang_fplus + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match['not_match'];
          }

          var res_search = [];
          var bold = [];
          var img = "";
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var _icon = "";
            //use class icon
            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            // if (z[i].class_icon != null) {
            //   //my.1.grabmobi.com as default domain
            //   icon = icon_class['mobizone.vip']['class'];
            // } else {
            //   icon = icon_class['my.1.grabmobi.com']['class'];;
            // }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_fplus) {
                    _icon = icon_class[key]["class"];
                  } else {
                    _icon = icon_class['mobizone.vip']['class'];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            //use class icon
            var r = res_search[_i].replace(res_search[_i], "<span class='" + _icon + "'></span> " + res_search[_i]);

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_fplus", "lang_fplus", "country_fplus"])),
  created: function created() {
    this.fetchNotification_fplus();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_fplus"]))
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_fplus", "lang_fplus", "auth_fplus", "country_fplus", "is_unsub_fplus"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLocale_fplus", "fetchTranslateButton_fplus", "logout_fplus"]))
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gamebox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gamebox_gamebox_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_gamebox_Navigation_vue__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_gamebox_DetailModal__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "gamebox",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_gamebox_gamebox_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_gamebox_gamebox_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_8__components_gamebox_Navigation_vue__["a" /* default */],
    DetailModal: __WEBPACK_IMPORTED_MODULE_9__components_gamebox_DetailModal__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_gamebox", "country_gamebox"]),
  mounted: function mounted() {},
  created: function created() {
    this.fetchToken_gamebox(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_gamebox__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_gamebox;
    var country_code = this.country_gamebox;

    if (this.lang_gamebox != "null" && this.lang_gamebox != null) {
      if (this.lang_gamebox == "arabic") {
        localStorage.setItem("lang_gamebox", this.lang_gamebox);
        this.$i18n.locale = this.lang_gamebox;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_gamebox(this.lang_gamebox);
      } else {
        localStorage.setItem("lang_gamebox", this.lang_gamebox);
        this.$i18n.locale = this.lang_gamebox;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_gamebox(this.lang_gamebox);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a[country_code].language;

        localStorage.setItem("lang_gamebox", language);
        this.$i18n.locale = language;
        this.fetchLocale_gamebox(language);

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_gamebox", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_gamebox("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLocale_gamebox", "fetchToken_gamebox"]), {
    enter: function enter(el, done) {},
    leave: function leave(el, done) {}
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameBoxSlider__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      homeSliderOptions: {
        fade: true,
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        cellAlign: "center",
        resize: true
      },
      stageDragging: false,
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  components: {
    "gamebox-slider": __WEBPACK_IMPORTED_MODULE_3__GameBoxSlider__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_gamebox", "country_gamebox", "main_cover_gamebox"
  // "hpisLoad_gamebox"
  ]),

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.intiHomeSider();
    });
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.intiHomeSider();
    });
  },

  methods: {
    intiHomeSider: function intiHomeSider() {
      if (this.main_cover_gamebox.length == 3) {
        var homeSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(this.$refs.homeSlider, this.homeSliderOptions);
        homeSliderflkty.on("dragStart", function () {
          this.stageDragging = true;
        });
        homeSliderflkty.on("dragEnd", function () {
          this.stageDragging = false;
        });
      }
    },
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    }
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityAppOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        freeScroll: true,
        contain: true
      },
      flickityVideoOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        freeScroll: true,
        contain: true,
        cellAlign: "left",
        resize: true
      },
      stageDragging: false
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_gamebox", "country_gamebox"]),
  props: ["sliderData", "isLoaded", "sliderCategory", "id", "slider_ref"],
  components: {
    "star-rating": __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var sliderStatus = false;
    var width = window.innerWidth;
    if (this.$props.isLoaded && this.$props.sliderCategory == "Video") {
      this.$nextTick(function () {
        var videoSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.videoSlider, _this.flickityVideoOptions);
        videoSliderflkty.on("dragStart", function () {
          this.stageDragging = true;
        });
        videoSliderflkty.on("dragEnd", function () {
          this.stageDragging = false;
        });
      });
    }
    if (this.$props.isLoaded && this.$props.sliderCategory == "Game") {
      var gameSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(this.$refs.gameSlider, this.flickityAppOptions);
      gameSliderflkty.on("dragStart", function () {
        this.stageDragging = true;
      });
      gameSliderflkty.on("dragEnd", function () {
        this.stageDragging = false;
      });
    }
    if (this.$props.isLoaded && this.$props.sliderCategory == "Wallpaper") {
      this.$nextTick(function () {
        var wallPaperSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.wallpaperSlider, _this.flickityVideoOptions);
        wallPaperSliderflkty.on("dragStart", function () {
          this.stageDragging = true;
        });
        wallPaperSliderflkty.on("dragEnd", function () {
          this.stageDragging = false;
        });
      });
    }
    if (this.$props.isLoaded && this.$props.sliderCategory == "Application") {
      this.$nextTick(function () {
        var wallPaperSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.applicationSlider, _this.flickityAppOptions);
        wallPaperSliderflkty.on("dragStart", function () {
          this.stageDragging = true;
        });
        wallPaperSliderflkty.on("dragEnd", function () {
          this.stageDragging = false;
        });
      });
    }
  },

  methods: {
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_gamebox", "renew_date_gamebox", "subscription_date_gamebox", "auth_gamebox", "is_unsub_gamebox", "countryCode"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_gamebox"]))
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_gamebox", "HotPickIcon_gamebox", "lang_gamebox", "country_gamebox"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_gamebox([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_gamebox([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_gamebox"]), {
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_gamebox));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-2 col-lg-2 col-sm-4 d2-appItem d2-appItem--noAnim";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: [],
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_gamebox", "PopularIcon_gamebox", "country_gamebox", "lang_gamebox"]),
  created: function created() {
    this.isLoad = false;
    this.fetchPagePopular_gamebox();
    this.getPopular();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_gamebox"]), {
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    getPopular: function getPopular() {
      var _this = this;

      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
    }
  })
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_gamebox", "country_gamebox", "host_gamebox"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_gamebox).then(function (res) {
        var data = res.data.data;

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  //   computed: mapGetters(["lang_fplus", "host_fplus", "auth_fplus", "country_fplus"]),
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["lang_gamebox", "host_gamebox", "authentication_gonz", "country_gamebox"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["subContent_gamebox"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(124)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_3_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //everytime user display detail page, will collect the data
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: "xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6",
        country: this.country_gamebox,
        product: "gamebox",
        content_id: id,
        type: "view"
      });

      // let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=${id}&category=&subcategory=&limit=100&offset=0&domain=${this.host_fplus}`;
      // let live = `http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=${id}&category=&subcategory=&limit=100&offset=0&domain=${this.host_fplus}`;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_gamebox).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب الان","notification":"تنبيه","view_more":"شاهد المزيد","main_title":"كل شي في مكان واحد","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Gamebox؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","android":"أندرويد","no_notification":"لا يوجد إشعارات","close":"أغلق","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","game_categories":"الفئات "}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"ВСИЧКО НА ЕДНО МЯСТО","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за gamebox?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","game_categories":"Категории игри"}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"VŠE NA JEDNOM MÍSTĚ","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru gamebox?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledejte hry, aplikace atd...","not_subs":"Ještě se nepřihlásíte k odběru","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste si mohli ušetřit pár minut, abyste nám pomohli vylepšit náš web vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","android":"Android","no_notification":"Žádné oznámení","close":"zavřít","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","game_categories":"Kategorie her"}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"ALT ET STED","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på gamebox?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","close":"Tæt","game_categories":"Spilkategorier"}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to gamebox?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","close":"Close","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","game_categories":"Game Categories"}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = {"browse":"Selaa","hotpicks":"Hot Pick","popular":"Suosittu","profile":"Profiili","downloads":"Lataukset","download":"ladata","play":"Pelaa nyt","notification":"Ilmoitus","view_more":"Katso lisää","main_title":"KAIKKI YKSI PAIKASSA","home":"Koti","favorites":"Suosikit","contact":"Ottaa yhteyttä","settings":"asetukset","privacy":"Tietosuojakäytäntö","terms":"käyttöehdot","all":"Kaikki","allCategories":"kaikki kategoriat","categories":"Luokat","category":"Kategoria","platform":"Alusta","type":"Tyyppi","login":"Kirjaudu sisään","logout":"Kirjautua ulos","login_title":"Tilattu gamebox?","confirmation":"Vahvista sitten matkapuhelinnumerosi ja saat rajoittamattoman pääsyn kaikkiin palveluihimme!","submit":"Lähetä","valid_number":"Lisää oikea numero!","full_name":"Koko nimi","registered_num":"Rekisteröity numero","registered_email":"Rekisteröity sähköposti","registered_date":"Rekisteröity päivämäärä","hello":"Hei","search":"Etsi pelejä, sovelluksia jne...","not_subs":"Ei vielä tilaa","application":"Sovellus","game":"Peli","video":"Video","contact_us":"Ota meihin yhteyttä","subject":"Aihe","message":"Viesti","let_us":"Kerro meille tiedusteluistasi","select_subject":"Valitse Aihe","app_issue":"Sovelluksen numero","content":"Sisältö","subscription":"Tilaus","unsubscribe":"Lopeta tilaus","not_match":"Ei täsmää","feedback":"Palaute","feedback_intro":"Olisimme erittäin kiitollisia, jos voisit säästää muutaman minuutin auttaaksesi meitä parantamaan sivustoamme täyttämällä tämän lyhyen kyselyn.","Overall":"Yleensä ottaen","Usability":"Käytettävyys","Your Suggestion":"Ehdotuksesis","feedback_comment":"Kirjoita kommenttisis","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","android":"Android","no_notification":"Ei ilmoitusta","close":"kiinni","next_renew_date":"Seuraava uusimispäivä","subscription_date":"Tilauspäivä","game_categories":"Pelin luokat"}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"ΟΛΑ ΣΕ ΜΙΑ ΧΩΡΑ","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο gamebox?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Εφαρμογή","game":"Παιχνίδι","video":"Βίντεο","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","android":"Android","no_notification":"καμία ειδοποίηση","close":"Κλείσε","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής","game_categories":"Κατηγορίες παιχνιδιών"}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Prizeo?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","close":"Tutup","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan","game_categories":"Kategori Game"}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"SEMUA DALAM SATU PLATFORM","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan gamebox?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","close":"Tutup","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan","game_categories":"Kategori Permainan"}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"ALT ETT STED","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på gamebox?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","game_categories":"Spillkategorier"}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Pick","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"TOTUL LA UN singur loc","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la gamebox?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutați jocuri, aplicații etc...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs.","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","android":"Android","no_notification":"Nicio notificare","close":"Închide","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului","game_categories":"Categorii de jocuri"}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"VŠETKO NA JEDNOM MIESTE","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber gamebox?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","close":"Zavrieť","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","game_categories":"Kategórie hier"}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Pick","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Allt på ett ställe","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på gamebox?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök efter spel, appar, etc...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt fantastiska om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra denna korta undersökning.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","android":"Android","no_notification":"Ingen anmälan","close":"Stänga","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum","game_categories":"Spelkategorier"}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"รวมทุกอย่างในที่เดียว","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร gamebox?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาเกมส์ แอพลิเคชั่น และอื่นๆ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","android":"แอนดรอยด์","no_notification":"ไม่มีการแจ้งเตือน","close":"ปิด","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","game_categories":"หมวดหมู่เกม"}

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gamebox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_gamebox);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_gamebox", "gcid_gamebox", "country_gamebox"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = "+" + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_gamebox != "") {
            gcid = this.gcid_gamebox;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response == "active") {
              localStorage.setItem("userToken_gamebox", response.token);
              localStorage.setItem("userProfile_gamebox", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_gamebox("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_gamebox__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_gamebox == key) {
                    var status_lang = __webpack_require__(124)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_gamebox"]))
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyFinnish__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_gamebox", "country_gamebox"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyFinnish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox"]),
    mounted: function mounted() {}
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox"]),
    mounted: function mounted() {}
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox"]),
    mounted: function mounted() {}
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
    mounted: function mounted() {}
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermsEnglish__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsSlovakia__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsCzech_vue__ = __webpack_require__(2021);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_gamebox", "country_gamebox"]),
  components: {
    "terms-english": __WEBPACK_IMPORTED_MODULE_0__TermsEnglish__["a" /* default */],
    "terms-slovakia": __WEBPACK_IMPORTED_MODULE_1__TermsSlovakia__["a" /* default */],
    TermsCzech: __WEBPACK_IMPORTED_MODULE_3__TermsCzech_vue__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["host_gamebox", "countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      ar: {
        arLanguage: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false
      },
      browse: {
        category: []
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("gamebox")) {
      this.getBrowse();
      // this.getHotPicks();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(subcate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allGameData, subcateg, allDataGame, live, local, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, _subcate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = '';
                subCate = [];
                allGameData = [];
                subcateg = [];
                allDataGame = [];
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";

                //get subcategory under game
                // let subgame = await axios.get(
                //   `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=1&domain=${host}`
                // );

                //get subcategory from getBrowse()
                //remove arcade game in list

                subcate.map(function (item) {
                  if (item.subcategory != "Arcade Games") {
                    subCate.push(item);
                  }
                });

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 12;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 15:
                if (!(i < subCate.length)) {
                  _context.next = 28;
                  break;
                }

                _context.next = 18;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subCate[i].subcategory + "&limit=50&offset=0&domain=" + host);

              case 18:
                allDataGame = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataGame.data.data.slice(0, 10);
                _subcate = subCate[i].subcategory;

                allGameData[_subcate] = new Array();
                allGameData[_subcate] = data_slice;

              case 25:
                i++;
                _context.next = 15;
                break;

              case 28:

                isload = true;
                _this.main.hotpicks = allGameData;
                // this.main.subcategory = subCate.slice(1,5);
                subcate.length >= 4 ? _this.main.subcategory = subCate.slice(1, 5) : _this.main.subcategory = subCate;
                _this.main.isLoad = isload;

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //game as default
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=100&offset=0&domain=" + host).then(function (res) {
        var data = res.data.data;

        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == "games4all.vip") {
                  item.icon = icon[key]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans);
          if (trans != null) {
            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });

        _this2.browse.category = item_temp;
        _this2.getHotPicks(item_temp);
      });
    }
  }
}));

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_gamebox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gamebox__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gamebox_Search_vue__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gamebox_Notification_vue__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      button: "<span lang=\"english\">\n        <img class=\"flag\" lang=\"english\" src=\"https://i.imgur.com/ISR1V1s.png\" />\n        <span lang=\"english\">English</span>\n        </span>",
      isSideMenuActive: false
    };
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_3__gamebox_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_4__gamebox_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["langButton_gamebox", "lang_gamebox", "auth_gamebox", "country_gamebox", "is_unsub_gamebox", "countryCode"]),
  mounted: function mounted() {
    this.fetchTranslateButton_gamebox(this.country_gamebox);
    this.butnLang();

    var dropdown = document.getElementById("dropdown-menu");

    if (this.country_gamebox == "ke" || this.country_gamebox == "ke1") {
      dropdown.style.display = "none";
    }

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["fetchLocale_gamebox", "fetchTranslateButton_gamebox", "logout_gamebox"]), {
    butnLang: function butnLang() {
      var _this = this;

      var btnLang1 = document.getElementById("lang1");
      var btnLang2 = document.getElementById("lang2");

      var btn1 = document.getElementById("btn1");
      var btn2 = document.getElementById("btn2");
      this.$nextTick(function () {
        if (_this.lang_gamebox == "english") {
          btn1.innerHTML = btnLang1.innerHTML;
          btn2.innerHTML = btnLang2.innerHTML;
        } else if (_this.lang_gamebox != "english") {
          btn1.innerHTML = btnLang2.innerHTML;
          btn2.innerHTML = btnLang1.innerHTML;
        }
      });
    },
    getTranslateDesktop: function getTranslateDesktop() {
      var btn1 = document.getElementById("btn1");
      var btn2 = document.getElementById("btn2");

      var lang = document.getElementById("btn2").children[0].getAttribute("lang");

      var temp = btn1.innerHTML;
      btn1.innerHTML = btn2.innerHTML;
      btn2.innerHTML = temp;

      this.$i18n.locale = lang;
      this.fetchLocale_gamebox(lang);
      localStorage.setItem("lang_gamebox", lang);
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    },
    getTranslateMobile: function getTranslateMobile(btn) {
      var btn1 = document.getElementById("btn1");
      var btn2 = document.getElementById("btn2");

      var btnLang = "";
      // const btnLang2 = document.getElementById("lang2");
      if (btn == "btn1") {
        btnLang = document.getElementById("lang1");
      } else {
        btnLang = document.getElementById("lang2");
      }
      var lang = btnLang.children[0].getAttribute("lang");
      this.$i18n.locale = lang;
      this.fetchLocale_gamebox(lang);
      localStorage.setItem("lang_gamebox", lang);
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }

      this.getTranslateDesktop();
    },
    openSideMenu: function openSideMenu() {
      this.isSideMenuActive = !this.isSideMenuActive;
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("d2-navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_gamebox");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_gamebox", "host_gamebox"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("d2-navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var searchWrap = document.getElementById("d2-searchWrap"),
        backdrop = document.getElementById("backdrop");

    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      // this.searchAniTl.reverse();
      // d2 - searchWrap.classList.remove("d2-searchWrap--expand");
    });
  },

  methods: {
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_gamebox;
        var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_gamebox;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(124)("./" + _this2.lang_gamebox + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];
          var img = "";
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var _icon = "";
            //use class icon
            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_gamebox) {
                    _icon = icon_class[key]["class"];
                  } else {
                    _icon = icon_class["games4all.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            //use class icon
            var r = res_search[_i].replace(res_search[_i], "<span class='" + _icon + " icon'></span> <p class='d2-h4'> " + res_search[_i] + "</p> ");

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_gamebox", "lang_gamebox", "country_gamebox"])),
  created: function created() {
    this.fetchNotification_gamebox();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_gamebox"]), {
    getDetail: function getDetail(id) {
      this.$root.$emit("getDetail", id);
    }
  })
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_gamebox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_gamebox", "host_gamebox", "country_gamebox"]),
  mounted: function mounted() {
    var _this = this;

    document.addEventListener("click", function (e) {
      if (e.target.id == "contentModal" || e.target.id == "close") {
        _this.details = {};
        _this.isLoad = false;
      }
    });

    this.$root.$on("getDetail", function (id) {
      _this.getDetail(id);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_gamebox"]), {
    getDetail: function getDetail(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";

      //post view detail
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_gamebox,
        product: 'gamebox',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_gamebox).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;

        _this2.contentCoverImg = data.cover_img;

        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);
          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        setTimeout(function () {
          _this2.details = data;
          console.log(_this2.details);
          _this2.isLoad = true;
          _this2.getTranslate(data, _this2.lang_gamebox);
        }, 0);
      });
    },
    getTranslate: function getTranslate(data, lang) {
      setTimeout(function () {
        if (lang != "") {
          if (lang != "english") {
            if (data["cont_name_" + lang] != "") {
              document.getElementById("cont_name").innerHTML = data["cont_name_" + lang];
            } else {
              document.getElementById("cont_name").innerHTML = data["cont_name_english"];
            }

            if (data["desc_" + lang] != "") {
              document.getElementById("description").innerHTML = "<span>" + data["desc_" + lang] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + data["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = data["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + data["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(124)("./" + lang + ".json");
          var file = data.content_detail.split(".");
          if (file[1] == "apk" || data.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }
          document.getElementById("thumbnail").setAttribute("src", data["thumbnail_url"]);
          document.getElementById("platform").innerHTML = platform;
        }
      }, 0);
    }
  })
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_prizeo__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_prizeo_prizeo_js_prizeo_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_prizeo_Navigation_vue__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_prizeo_UnsubModal_vue__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 //router











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Prizeo",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_prizeo_prizeo_js_prizeo_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_prizeo_prizeo_js_prizeo_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_8__components_prizeo_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_9__components_prizeo_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_prizeo", "country_prizeo", "host_prizeo"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_prizeo(this.host_prizeo);
    this.fetchToken_prizeo(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_prizeo__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_prizeo;
    var country_code = this.country_prizeo;

    if (this.lang_prizeo != "null" && this.lang_prizeo != null) {
      if (this.lang_prizeo == "arabic") {
        localStorage.setItem("lang_prizeo", this.lang_prizeo);
        this.$i18n.locale = this.lang_prizeo;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_prizeo(this.lang_prizeo);
      } else {
        localStorage.setItem("lang_prizeo", this.lang_prizeo);
        this.$i18n.locale = this.lang_prizeo;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_prizeo(this.lang_prizeo);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a[country_code].language;

        localStorage.setItem("lang_prizeo", language);
        this.$i18n.locale = language;
        this.fetchLocale_prizeo(language);

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_prizeo", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_prizeo("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLocale_prizeo", "fetchToken_prizeo", "getDomain_prizeo"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["HotPickIcon_prizeo", "PopularIcon_prizeo", "lang_prizeo", "country_prizeo"]),
  created: function created() {},

  methods: {
    getAllData: function getAllData() {
      // console.log(this.allHotPicksData)
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_prizeo", "country_prizeo"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["msisdn_prizeo", "renew_date_prizeo", "subscription_date_prizeo", "auth_prizeo", "is_unsub_prizeo"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout_prizeo"]), {
    logout: function logout(is_unsub) {
      // localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("http://api.puretechglobal.net/gateway_request/bahrain/actel/unsub.php?code=28wpx48x4&msisdn=973234567").then(function (res) {
        console.log(res);
      });
      //router.push({name: Login}).catch(err => {})
    }
  })
});

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_prizeo", "HotPickIcon_prizeo", "lang_prizeo", "country_prizeo"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_prizeo([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_prizeo([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_prizeo"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_prizeo));
      var hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(function (item) {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      } else {
        hotpick.map(function (item) {
          if (_this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate: function getCategoryTranslate(q, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_prizeo", "PopularIcon_prizeo", "country_prizeo", "lang_prizeo"]),
  created: function created() {
    this.fetchPagePopular_prizeo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_prizeo"]))
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrizeoSlider_vue__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["HotPickIcon_prizeo", "PopularIcon_prizeo", "lang_prizeo", "country_prizeo", "host_prizeo"]),
  components: {
    "prizeo-slider": __WEBPACK_IMPORTED_MODULE_8__PrizeoSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_prizeo;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_prizeo;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;

                  _this.hotpicks = data.slice(0, 10);
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_prizeo;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_prizeo;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;

                  _this2.popular = data.slice(0, 10);
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_prizeo;
      var live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_prizeo;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != '') {
            if (_this3.lang_prizeo != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_prizeo].title;

              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_prizeo] = sub_trans[_this3.lang_prizeo].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_prizeo == key) {
                    if (value.language != 'english') {
                      _this3.categoryTranslate = cat_trans["" + value.language].title;
                      if (sub_trans != null) {
                        item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                      }
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (category == 'video') {
                    item.icon = sub_icon["mobiflix.vip"]["class"];
                  } else {
                    item.icon = sub_icon["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_prizeo", "country_prizeo"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          case "arSlider":
            _this.$nextTick(function () {
              var arSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptions);
              arSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              arSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allSubcategory_prizeo", "lang_prizeo", "country_prizeo", "host_prizeo"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_prizeo(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_prizeo"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_prizeo;
                live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_prizeo;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data = data.filter(function (value) {
                    if (value.category.toLowerCase() == _this.category) {
                      return value;
                    }
                  });
                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allSubcategory_prizeo));

      var subcat = allSubcategory.map(function (item) {
        if (item.subcategory_translate != null) {
          var sub_trans = JSON.parse(item.subcategory_translate);
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          item.titleSub_english = item.subcategory;
          if (sub_trans != null) {
            for (var i = 0; i < trans_len; i++) {
              if (lang == 'english') {
                item["titleSub_english"] = _this2.subcategory;
              } else {
                item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
              }
            }
          }
        }

        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_prizeo__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_prizeo", "host_prizeo", "country_prizeo"]),
  created: function created() {
    this.getDetails(this.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_prizeo"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != '') {
          if (langt != 'english') {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(160)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat['mobile_computer'];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal";
      var live = "http://cook.grabmobi.com/";

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_prizeo,
        product: 'prizeo',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_prizeo).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب الان","notification":"تنبيه","view_more":"شاهد المزيد","main_title":"كل شي في مكان واحد","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Prizeo؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","android":"أندرويد","no_notification":"لا يوجد إشعارات","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Prizeo","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا"}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"ВСИЧКО НА ЕДНО МЯСТО ","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Mobizone?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани от Mobizone","modal_title":"Анулиране на абонамента?","unsub_confirmation":"Наистина ли искате да се отпишете?","yes":"Да","no":"Не","subscribe_messsage":"За да се абонирате и да получите неограничен достъп, моля, кликнете върху бутона по-долу!","subscribe":"Абонирай се"}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Sledujte, co bude dál","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Playmix?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","subscribe_messsage":"Chcete-li se přihlásit k odběru a získat neomezený přístup, klikněte na tlačítko níže!","subscribe":"předplatit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jmén","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Hledat videa...","not_subs":"Ještě nejste přihlášenit","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikac","content":"obsah","subscription":"předplatn","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámenín","android":"Android","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","unsubscription":"Nyní jste odhlášeni z Playmixu"}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"ALT ET STED","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Prizeo?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Prizeo","subscribe_messsage":"Klik på nedenstående knap for at abonnere og få ubegrænset adgang!","subscribe":"Abonner","modal_title":"Annuller abonnement?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Ja","no":"Ingen"}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Prizeo?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe"}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Prizeo?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe"}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"ΟΛΑ ΣΕ ΜΙΑ ΧΩΡΑ","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Prizeo?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Εφαρμογή","game":"Παιχνίδι","video":"Βίντεο","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","android":"Android","no_notification":"καμία ειδοποίηση","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No"}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Prizeo?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Ya","no":"Tidak"}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"SEMUA DALAM SATU PLATFORM","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Prizeo?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Batalkan Langganan?","unsub_confirmation":"Kamu pasti mahu hentikan langganan?","yes":"Ya","no":"Tidak"}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"ALT PÅ ET STED","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Prizeo?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Mobizone","modal_title":"Avbestille abonnementet?","unsub_confirmation":"Er du sikker på at du vil avslutte abonnementet?","yes":"Ja","no":"Nei","subscribe_messsage":"For å abonnere og få ubegrenset tilgang, vennligst klikk på knappen nedenfor!","subscribe":"Abonnere"}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Prizeo?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe"}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"VŠETKO NA JEDNOM MIESTE","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Prizeo?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu Prizeo","modal_title":"Zrušiť predplatné?","unsub_confirmation":"Naozaj chcete zrušiť odber?","yes":"Áno","no":"Nie","subscribe_messsage":"Ak sa chcete prihlásiť na odber a získať neobmedzený prístup, kliknite na tlačidlo nižšie!","subscribe":"Prihlásiť sa na odber"}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"EVERYTHING IN ONE PLACE","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Prizeo?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe"}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"รวมทุกอย่างในที่เดียว","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Prizeo?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาเกมส์ แอพลิเคชั่น และอื่นๆ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","android":"แอนดรอยด์","no_notification":"ไม่มีการแจ้งเตือน","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","unsubscription":"You are now unsubscribed from Prizeo","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No"}

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_prizeo__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el",
      isAoc: false
    };
  },
  created: function created() {
    this.getPrefix(this.country_prizeo);
    if (this.gcid_prizeo === "289" || this.gcid_prizeo === "290" || this.gcid_prizeo === "291") {
      this.isAoc = true;
    }
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_prizeo", "gcid_prizeo", "country_prizeo"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    consent_gateway: function consent_gateway() {
      if (this.gcid_prizeo == "289") {
        window.location = "https://www.prizeo.vip/campaign/click.php?offer_id=3138&aff_sub5=test&aff_id=217";
      } else if (this.gcid_prizeo == "291") {
        window.location = "https://www.prizeo.vip/campaign/click.php?offer_id=3139&aff_sub5=test&aff_id=217";
      } else if (this.gcid_prizeo == "290") {
        window.location = "https://www.prizeo.vip/campaign/click.php?offer_id=3140&aff_sub5=test&aff_id=217";
      } else {
        alert("Invalid GCID");
      }
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_prizeo != "") {
            gcid = this.gcid_prizeo;
          } else {
            //dummy gcid
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userToken_prizeo", response.token);
              localStorage.setItem("userProfile_prizeo", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_prizeo("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_prizeo__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_prizeo == key) {
                    var status_lang = __webpack_require__(160)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_prizeo"]))
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {}
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_prizeo", "gcid_prizeo", "country_prizeo"])
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["lang_prizeo", "country_prizeo"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var currentDate = new Date();

var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
    data: function data() {
        return {
            browse: {
                category: [],
                categoryAR: [],
                categoryMY: []
            },
            main: {
                hotpicks: {},
                category: {},
                isLoad: false
            },
            search: {
                allSearch: {}
            },
            type: 'browse',
            live: 'http://cook.grabmobi.com',
            local: 'http://[::1]/PuretechGlobalContentPortal'
        };
    },
    created: function created() {
        if (host.includes("prizeo")) {
            this.getBrowse();
        }
    },

    methods: {
        getHotPicks: function getHotPicks(browseCate) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var isload, browseCat, browseCategory, allDataContent, allData, browse, temp, browseSort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                isload = '';
                                browseCat = [];
                                browseCategory = [];
                                allDataContent = [];
                                allData = [];

                                //get subcategory under game

                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(_this.live + '/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=' + host);

                            case 7:
                                browse = _context.sent;
                                temp = [];
                                browseSort = browseCate.filter(function (item) {
                                    if (item.category == 'Application') {
                                        temp = item;
                                    } else {
                                        return item;
                                    }
                                });

                                if (temp != '') {
                                    browseSort.push(temp);
                                }

                                browseCat = browseSort;

                                //get random number
                                oneHourInMs = 3600000;
                                currentTimeInMs = new Date().getTime(); // UTC time

                                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                                numberForToday = timeInHour % 20;
                                // zero-filling of numbers less than four digits might be optional for you
                                // zero-filled value will be a string to maintain its leading 0s

                                DigitNumber = numberForToday.toString();

                                while (DigitNumber.length < 2) {
                                    DigitNumber = 0 + Number(DigitNumber);
                                }

                                i = 0;

                            case 19:
                                if (!(i < browseCat.length)) {
                                    _context.next = 32;
                                    break;
                                }

                                _context.next = 22;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(_this.live + '/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=' + browseCat[i].category + '&limit=100&offset=0&domain=' + host);

                            case 22:
                                allData = _context.sent;
                                divide = DigitNumber % 2;


                                if (divide == 0) {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return Math.random() - 0.5;
                                    });
                                } else {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return 0.5 - Math.random();
                                    });
                                }

                                data_slice = allData.data.data.slice(0, 6);
                                categ = browseCat[i].category;

                                allDataContent[categ] = new Array();
                                allDataContent[categ] = data_slice;

                            case 29:
                                i++;
                                _context.next = 19;
                                break;

                            case 32:

                                isload = true;

                                _this.main.hotpicks = allDataContent;
                                _this.main.category = browseCat;
                                _this.main.isLoad = isload;

                            case 36:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getBrowse: function getBrowse() {
            var _this2 = this;

            var url = this.live + '/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;

            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (res) {
                // console.log(res.data.data)
                var data = res.data.data;
                var temp = [];

                data.map(function (item) {
                    item.title_english = item.category;
                    item.route = item.title_english.toLowerCase();

                    if (item.category_translate != null) {
                        var trans = JSON.parse(item.category_translate);
                        if (trans != null) {
                            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
                            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
                            for (var i = 0; i < trans_len; i++) {
                                item['title_' + trans_arr[i]] = trans[trans_arr[i]].title;
                            }
                            // item.icon = icon['my.1.grabmobi.com']['class'];
                        }
                    }

                    if (item.category_icon != null) {
                        var icon = JSON.parse(item.category_icon);
                        if (icon != null) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var _ref = _step.value;

                                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                                    var key = _ref2[0];
                                    var value = _ref2[1];

                                    if (key == host) {
                                        item.icon = icon[key]["class"];
                                    } else {
                                        item.icon = icon['mobizone.vip']['class'];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }

                    item.coverImg = __webpack_require__(2086)("./" + item.category + '.jpg');

                    temp.push(item);
                });

                var item_temp = temp.map(function (v) {
                    delete v.category_translate;
                    delete v.category_translate;
                    delete v.category_icon;
                    delete v.subcategory;
                    delete v.subcategory_translate;
                    delete v.subcategory_icon;
                    delete v.thumbnail_url;
                    delete v.cover_img;
                    return v;
                });
                _this2.getHotPicks(item_temp);
                _this2.browse.category = item_temp;
            });
        }
    }
}));

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_prizeo__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prizeo_js_prizeo__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prizeo_Search_vue__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prizeo_Notification_vue__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__prizeo_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_5__prizeo_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["langButton_prizeo", "lang_prizeo", "auth_prizeo", "country_prizeo", "is_unsub_prizeo"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchTranslateButton_prizeo(this.country_prizeo);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_prizeo == "english") {
      if (this.country_prizeo != "ke1" && this.country_prizeo != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_prizeo != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLocale_prizeo(lang);
      localStorage.setItem("lang_prizeo", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLocale_prizeo(lang);
      localStorage.setItem("lang_prizeo", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["fetchLocale_prizeo", "fetchTranslateButton_prizeo", "logout_prizeo"]), {
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_prizeo");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_prizeo", "host_prizeo"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_prizeo;
        var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_prizeo;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(160)("./" + _this2.lang_prizeo + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match['not_match'];
          }

          var res_search = [];
          var bold = [];
          var img = "";
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var _icon = "";
            //use class icon
            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            // if (z[i].class_icon != null) {
            //   //my.1.grabmobi.com as default domain
            //   icon = icon_class['mobizone.vip']['class'];
            // } else {
            //   icon = icon_class['my.1.grabmobi.com']['class'];;
            // }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_prizeo) {
                    _icon = icon_class[key]["class"];
                  } else {
                    _icon = icon_class["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            //use class icon
            var r = res_search[_i].replace(res_search[_i], "<span class='" + _icon + "'></span> " + res_search[_i]);

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_prizeo", "lang_prizeo", "country_prizeo"])),
  created: function created() {
    this.fetchNotification_prizeo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_prizeo"]))
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_prizeo", "lang_prizeo", "auth_prizeo", "country_prizeo", "is_unsub_prizeo"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLocale_prizeo", "fetchTranslateButton_prizeo", "logout_prizeo"]))
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_fun2win__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fun2win_fun2win_js__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fun2win_Navigation_vue__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "fun2win",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_fun2win_fun2win_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_fun2win_fun2win_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_fun2win_Navigation_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_f2w", "country_f2w"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.fetchTokenID_f2w(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_fun2win__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
    }
    var country_id = this.country_f2w;

    if (this.lang_f2w != "null" && this.lang_f2w != null) {
      if (this.lang_f2w == "arabic") {
        localStorage.setItem("lang_f2w", this.lang_f2w);
        this.$i18n.locale = this.lang_f2w;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLanguage_f2w(this.lang_f2w);
      } else {
        localStorage.setItem("lang_f2w", this.lang_f2w);
        this.$i18n.locale = this.lang_f2w;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_f2w(this.lang_f2w);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a);

      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a[country_id].language;

        localStorage.setItem("lang_f2w", language);
        this.$i18n.locale = language;
        this.fetchLanguage_f2w(language);

        if (language != 'arabic') {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_f2w", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_f2w("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["fetchLanguage_f2w", "fetchTokenID_f2w"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      games: {}
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
  // "allSubGame_f2w",
  // "allStoreGameData_f2w",
  "IconHotPick_f2w", "IconPopular_f2w", "lang_f2w", "country_f2w"
  // "hpisLoad_f2w"
  ]),
  created: function created() {
    // this.fetchHomeHotPick_f2w();
  },
  mounted: function mounted() {},

  methods: {
    // ...mapActions(["fetchHomeHotPick_f2w"])
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomLightbox_vue__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_6__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_7_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_f2w", "host_f2w"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["subscribeContent_f2w"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(95)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;

        _this2.contentCoverImg = data.cover_img;

        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);
          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    logout: function logout() {
      // localStorage.clear();
      localStorage.removeItem("userTokenID_gonz");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_f2w", "country_f2w", "host_f2w"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_f2w).then(function (res) {
        var data = res.data.data;

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPicksPage_f2w", "IconHotPick_f2w", "lang_f2w"]),
  created: function created() {
    this.isLoad = false;
    this.fetchHotPicks_f2w([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchHotPicks_f2w([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["fetchHotPicks_f2w"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_f2w));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_f2w", "IconPopular_f2w", "lang_f2w"]),
  created: function created() {
    this.fetchPopular_f2w();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPopular_f2w"]))
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_fun2win__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_f2w", "gcid_f2w", "country_f2w"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_f2w != "") {
            gcid = this.gcid_f2w;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_f2w", response.token);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_f2w("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_fun2win__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this.country_f2w == key) {
                    var status_lang = __webpack_require__(218)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_f2w"]))
});

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"الاختبار النهائي لاسياد اللعاب","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Fun2win?","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"ارسال","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن ألعاب و تطبيقات وغيرها ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","android":"أندرويد"}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"The Final Test Of The Game Master","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Fun2win?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Games, Apps, etc...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Game","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android"}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"Το τελευταίο τεστ του μάστερ του παιχνιδιού","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Fun2win?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για παιχνίδια, εφαρμογές, κ.λπ ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Application","game":"Game","video":"Video","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","android":"Android"}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Ujian terakhir untuk game master","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Fun2win?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi,dll...","not_subs":"Belum Berlangganan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","android":"Android"}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Percubaan Terakhir Untuk Pakar Permainan","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Fun2win?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Permainan, Aplikasi dan sebagainya...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","android":"Android"}

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["lang_f2w", "country_f2w"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fun2win_Search_vue__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fun2win_Notification_vue__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_2__fun2win_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_3__fun2win_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["langButton_f2w", "lang_f2w", "authentication_f2w", "country_f2w"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchLanguageButton_f2w(this.country_f2w);
    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_f2w == "english") {
      if (this.country_f2w != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_f2w != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLanguage_f2w(lang);
      localStorage.setItem("lang_f2w", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLanguage_f2w(lang);
      localStorage.setItem("lang_f2w", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    // notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchLanguage_f2w", "fetchLanguageButton_f2w"]), {
    getclick: function getclick() {
      // location.reload();
    },
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userTokenID_f2w");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      // if(from.name == "Subcategory" && to.name == "Subcategory"){
      //   location.reload();
      // }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_f2w", "host_f2w"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_f2w).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          var item_search = search.filter(function (item) {
            return item.category_id == "2";
          });

          for (var i = 0; i < item_search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(item_search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(218)("./" + _this2.lang_f2w + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];

          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }
            var icon = "";
            //my.1.grabmobi.com as default domain
            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == "games4all.vip") {
                    icon = icon_class[key]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");
            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_f2w", "lang_f2w", "country_f2w"])),
  created: function created() {
    this.fetchNotification_f2w();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_f2w"]))
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_cutemobi__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutemobi_cutemobi_js_cutemobi_js__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cutemobi_Navigation_vue__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cutemobi_UnsubModal_vue__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "cutemobi",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_cutemobi_cutemobi_js_cutemobi_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_cutemobi_cutemobi_js_cutemobi_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_8__components_cutemobi_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_9__components_cutemobi_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm", "host_cm"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_cm(this.host_cm);
    this.fetchToken_cm(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_cutemobi__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_cm;
    var country_code = this.country_cm;

    if (this.lang_cm != "null" && this.lang_cm != null) {
      if (this.lang_cm == "arabic") {
        localStorage.setItem("lang_cm", this.lang_cm);
        this.$i18n.locale = this.lang_cm;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_cm(this.lang_cm);
      } else {
        localStorage.setItem("lang_cm", this.lang_cm);
        this.$i18n.locale = this.lang_cm;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_cm(this.lang_cm);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a[country_code].language;

        localStorage.setItem("lang_cm", language);
        this.$i18n.locale = language;
        this.fetchLocale_cm(language);

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_cm", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_cm("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLocale_cm", "fetchToken_cm", "getDomain_cm"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["HotPickIcon_cm", "PopularIcon_cm", "lang_cm", "country_cm"]),
  created: function created() {},

  methods: {
    getAllData: function getAllData() {
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["msisdn_cm", "renew_date_cm", "subscription_date_cm", "auth_cm", "is_unsub_cm"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout_cm"]))
});

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_cm", "HotPickIcon_cm", "lang_cm", "country_cm"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_cm([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_cm([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_cm"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_cm));
      var hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(function (item) {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      } else {
        hotpick.map(function (item) {
          if (_this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate: function getCategoryTranslate(q, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_cm", "PopularIcon_cm", "country_cm", "lang_cm"]),
  created: function created() {
    this.fetchPagePopular_cm();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_cm"]))
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CutemobiSlider_vue__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["HotPickIcon_cm", "PopularIcon_cm", "lang_cm", "country_cm", "host_cm"]),
  components: {
    "cutemobi-slider": __WEBPACK_IMPORTED_MODULE_8__CutemobiSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_cm;
                live = "http://cook.grabmobi.com/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_cm;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;

                  _this.hotpicks = data.slice(0, 10);
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_cm;
                live = "http://cook.grabmobi.com/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_cm;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;

                  _this2.popular = data.slice(0, 10);
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_cm;
      var live = "http://cook.grabmobi.com/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_cm;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != "") {
            if (_this3.lang_cm != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_cm].title;
              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_cm] = sub_trans[_this3.lang_cm].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_cm == key) {
                    if (value.language != "english") {
                      _this3.categoryTranslate = cat_trans["" + value.language].title;
                      if (sub_trans != null) {
                        item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                      }
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (_key == _this3.host_cm) {
                    item.icon = sub_icon[_key]["class"];
                  } else {
                    item.icon = sub_icon["cutemobi.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: true,
        wrapAround: false,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  components: {
    "star-rating": __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a
  },
  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          // case "arSlider":
          //   this.$nextTick(() => {
          //     const arSliderflkty = new Flickity(
          //       this.$refs.categoryCarousel,
          //       this.flickityOptions
          //     );
          //     arSliderflkty.on("dragStart", function() {
          //       this.stageDragging = true;
          //     });
          //     arSliderflkty.on("dragEnd", function() {
          //       this.stageDragging = false;
          //     });
          //   });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allSubcategory_cm", "lang_cm", "country_cm", "host_cm"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_cm(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_cm"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + _this.subcategory + "&limit=10&offset=0&domain=" + _this.host_cm;
                live = "http://cook.grabmobi.com/api/contents/cutemobi_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + _this.subcategory + "&limit=10&offset=0&domain=" + _this.host_cm;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  console.log(res.data.data);
                  var data = res.data.data;
                  // data = data.filter((value)=>{
                  //   if(value.category.toLowerCase() == this.category){
                  //     return value;
                  //   }
                  // })
                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allSubcategory_cm));

      var subcat = allSubcategory.map(function (item) {
        if (item.subcategory_translate != null) {
          var sub_trans = JSON.parse(item.subcategory_translate);
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          item.titleSub_english = item.subcategory;
          if (sub_trans != null) {
            for (var i = 0; i < trans_len; i++) {
              if (lang == 'english') {
                item["titleSub_english"] = _this2.subcategory;
              } else {
                item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
              }
            }
          }
        }

        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_cutemobi__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_cm", "host_cm", 'country_cm']),
  created: function created() {
    this.getDetails(this.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_cm"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(162)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal";
      var live = "http://cook.grabmobi.com";

      //everytime user display detail page, will collect the data
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_cm,
        product: 'cutemobi',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_cm).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب الان","notification":"تنبيه","view_more":"شاهد المزيد","main_title":"استكشف الفتيات الأكثر جاذبية","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Cutemobi؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"بحث ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","android":"أندرويد","no_notification":"لا يوجد إشعارات","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Cutemobi","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا","all_hotpick":"كل هوتبيك","all_popular":"كل شعبية","all_categories":"جميع الفئات"}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Разгледайте най-секси момичета","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Cutemobi?","confirmation":"Попълнете мобилния си телефон за достъп до горещото съдържание","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани от Mobizone","modal_title":"Анулиране на абонамента?","unsub_confirmation":"Наистина ли искате да се отпишете?","yes":"Да","no":"Не","all_hotpick":"Всички Hotpick","all_popular":"Всички популярни","all_categories":"Всички категории","faq":"Faq","t&c":"Правила и условия"}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Prozkoumejte nejvíc sexy dívky","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Cutemobi?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledávání ...","not_subs":"Ještě nejste přihlášeni","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","android":"Android","no_notification":"Žádné oznámení","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","unsubscription":"Nyní jste odhlášeni z Cutemobi","modal_title":"Zrušit předplatné?","unsub_confirmation":"Opravdu se chcete odhlásit?","yes":"Ano","no":"Ne","all_hotpick":"Všechny Hotpick","all_popular":"Vše populární","all_categories":"Všechny kategorie"}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Udforsk mest sexede piger","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Cutemobi?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Cutemobi","modal_title":"Annuller abonnement?","unsub_confirmation":"Er du sikker på, at du vil afmelde dig?","yes":"Ja","no":"ingen","all_hotpick":"Alle hotpick","all_popular":"Alle populære","all_categories":"alle kategorier","faq":"FAQ","t&c":"Vilkår og betingelser"}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Explore sexiest girls","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Are you a member to Cutemobi?","confirmation":"Fill in your mobile to access the hot content","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search ...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Cutemobi","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No","all_hotpick":"All Hotpick","all_popular":"All Popular","all_categories":"All Categories","faq":"Faq","t&c":"Terms and Conditions"}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = {"browse":"Selaa","hotpicks":"Hot Pick","popular":"Suosittu","profile":"Profiili","downloads":"Lataukset","download":"ladata","play":"Pelaa nyt","notification":"Ilmoitus","view_more":"Katso lisää","main_title":"Tutki seksikkäimpiä tyttöjä","home":"Koti","favorites":"Suosikit","contact":"Ottaa yhteyttä","settings":"asetukset","privacy":"Tietosuojakäytäntö","terms":"käyttöehdot","all":"Kaikki","allCategories":"kaikki kategoriat","categories":"Luokat","category":"Kategoria","platform":"Alusta","type":"Tyyppi","login":"Kirjaudu sisään","logout":"Kirjautua ulos","login_title":"Oletko jäsen Cutemobi?","confirmation":"Täytä matkapuhelimesi päästäksesi kuumaan sisältöön","submit":"Lähetä","valid_number":"Lisää oikea numero!","full_name":"Koko nimi","registered_num":"Rekisteröity numero","registered_email":"Rekisteröity sähköposti","registered_date":"Rekisteröity päivämäärä","hello":"Hei","search":"Hae ...","not_subs":"Ei vielä tilaa","application":"Sovellus","game":"Sovellus","video":"Video","contact_us":"Ota meihin yhteyttä","subject":"Aihe","message":"Viesti","let_us":"Kerro meille tiedusteluistasi","select_subject":"Valitse Aihe","app_issue":"Sovelluksen numero","content":"Sisältö","subscription":"Tilaus","unsubscribe":"Lopeta tilaus","not_match":"Ei täsmää","feedback":"Palaute","feedback_intro":"Olisimme erittäin kiitollisia, jos voisit säästää muutaman minuutin auttaaksesi meitä parantamaan sivustoamme täyttämällä tämän lyhyen kyselyn.","Overall":"Yleensä ottaen","Usability":"Käytettävyys","Your Suggestion":"Sinun ehdotuksesi","feedback_comment":"Kirjoita kommenttisi","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","android":"Android","no_notification":"Ei ilmoitusta","next_renew_date":"Seuraava uusimispäivä","subscription_date":"Tilauspäivä","unsubscription":"Olet nyt peruuttanut tilauksen Cutemobi","modal_title":"Peruuta tilaus?","unsub_confirmation":"Oletko varma että haluat unsubscribe?","yes":"Joo","no":"Ei","all_hotpick":"Kaikki Hotpick","all_popular":"Kaikki suositut","all_categories":"kaikki kategoriat","faq":"FAQ","t&c":"Käyttöehdot"}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = {"browse":"Αναζήτηση","hotpicks":"Καυτές επιλογές","hotpick":"Καυτές επιλογές","popular":"Δημοφιλή","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δες περισσότερα","main_title":"Αναζήτησε τα πιο σέξυ κορίτσια","home":"Αρχική Σελίδα","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορίες","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Eίσαι μέλος στο Cutemobi;","confirmation":"Συμπληρώστε το κινητό σας για πρόσβαση στο καυτό περιεχόμενο","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γεια σου","search":"Αναζήτηση ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Εφαρμογή","game":"Παιχνίδι","video":"Βίντεο","contact_us":"Επικοινωνία","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Διαγραφή","not_match":"Δεν Ταιριάζει","feedback":"Αξιολόγηση","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","android":"Android","no_notification":"καμία ειδοποίηση","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak","all_hotpick":"Τα πιο καυτά όλων των εποχών","all_popular":"Τα πιο δημοφιλή όλων των εποχών","all_categories":"Όλες οι κατηγορίες","faq":"Συχνές Ερωτήσεις","t&c":"Όροι Χρήσης"}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Cutemobi?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari ...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak","all_hotpick":"Semua Hotpick","all_popular":"Semua Populer","all_categories":"Semua Kategori"}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"SEMUA DALAM SATU PLATFORM","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Cutemobi?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari ...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak","all_hotpick":"Semua Hotpick","all_popular":"Semua Popular","all_categories":"Semua Kategori"}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Utforsk de mest sexy jentene","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Cutemobi?","confirmation":"Fyll ut mobilen din for å få tilgang til det varme innholdet","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Mobizone","modal_title":"Avbestille abonnementet?","unsub_confirmation":"Er du sikker på at du vil avslutte abonnementet?","yes":"Ja","no":"Nei","all_hotpick":"Alle hotpick","all_popular":"Alle populære","all_categories":"Alle Kategorier","faq":"Faq","t&c":"Vilkår og betingelser"}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Pick","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Explorează cele mai sexy fete","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Ești membru la Cutemobi?","confirmation":"Completați telefonul mobil pentru a accesa conținutul actual","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Numbe înregistratr","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutare ...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs.","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","android":"Android","no_notification":"Nicio notificare","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului","unsubscription":"Acum sunteți dezabonat de la Cutemobi","modal_title":"Anuleaza abonarea?","unsub_confirmation":"Sigur doriți să vă dezabonați?","yes":"da","no":"Nu","all_hotpick":"Toate Hotpick","all_popular":"Toate populare","all_categories":"toate categoriile","faq":"FAQ","t&c":"Termeni si conditii"}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Preskúmajte najsexi dievčatá","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Cutemobi?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","no_notification":"No Oznámenie","android":"Android","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu Cutemobi","modal_title":"Zrušiť predplatné?","unsub_confirmation":"Naozaj chcete zrušiť odber?","yes":"Áno","no":"Nie","all_hotpick":"Všetko Hotpick","all_popular":"Všetko populárne","all_categories":"Všetky kategórie","faq":"Časté otázky","t&c":"Podmienky"}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Pick","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Utforska sexigaste tjejer","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Är du medlem i Cutemobi?","confirmation":"Fyll i din mobil för att komma åt det heta innehållet","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök ...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt fantastiska om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra denna korta undersökning.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","android":"Android","no_notification":"Ingen anmälan","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum","unsubscription":"Du prenumererar nu Cutemobi","modal_title":"Avsluta prenumeration?","unsub_confirmation":"Är du säker på att du vill avsluta prenumerationen?","yes":"Ja","no":"Nej","all_hotpick":"Alla hotpick","all_popular":"Alla populära","all_categories":"alla kategorier","faq":"Vanliga frågor","t&c":"Villkor"}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"รวมทุกอย่างในที่เดียว","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Cutemobi?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหา ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","android":"แอนดรอยด์","no_notification":"ไม่มีการแจ้งเตือน","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak","all_hotpick":"ทั้งหมด Hotpick,","all_popular":"เป็นที่นิยมทั้งหมด","all_categories":"ทุกหมวดหมู่"}

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_cutemobi__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {

    this.getPrefix(this.country_cm);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_cm", "gcid_cm", "country_cm"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.gcid_cm == '303') {
        this.msisdn = '69';
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_cm != "") {
            gcid = this.gcid_cm;
          } else {
            //dummy gcid
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userToken_cm", response.token);
              localStorage.setItem("userProfile_cm", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_cm("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_cutemobi__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_cm == key) {
                    var status_lang = __webpack_require__(162)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_cm"]))
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contact__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactGRPaydashGreek__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactGRPaydashEnglish__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm", "country_code_cm", "gateway_code"]),
  components: {
    'contact': __WEBPACK_IMPORTED_MODULE_0__Contact__["a" /* default */],
    'contact-paydash-greek': __WEBPACK_IMPORTED_MODULE_1__ContactGRPaydashGreek__["a" /* default */],
    'contact-paydash-english': __WEBPACK_IMPORTED_MODULE_2__ContactGRPaydashEnglish__["a" /* default */]

  },
  methods: {}
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_cm", "gcid_cm", "country_cm"])
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyFinnish__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyPaydashGreek__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyPaydashEnglish__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm", "gateway_code", "country_code_cm"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyFinnish__["a" /* default */],
    'privacy-paydash-greek': __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyPaydashGreek__["a" /* default */],
    'privacy-paydash-english': __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyPaydashEnglish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FaqGRPaydashEnglish__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FaqGRPaydashGreek__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm", "country_code_cm", "gateway_code"]),
  components: {
    'faq-paydash-english': __WEBPACK_IMPORTED_MODULE_0__FaqGRPaydashEnglish__["a" /* default */],
    'faq-paydash-greek': __WEBPACK_IMPORTED_MODULE_1__FaqGRPaydashGreek__["a" /* default */]

  },
  methods: {}
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermsGRPaydashEnglish__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsGRPaydashGreek__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsGRMobivasGreek__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["lang_cm", "country_cm", "country_code_cm", "gateway_code"]),
  components: {
    'terms-paydash-english': __WEBPACK_IMPORTED_MODULE_0__TermsGRPaydashEnglish__["a" /* default */],
    'terms-paydash-greek': __WEBPACK_IMPORTED_MODULE_1__TermsGRPaydashGreek__["a" /* default */],
    'terms-mobivas-greek': __WEBPACK_IMPORTED_MODULE_2__TermsGRMobivasGreek__["a" /* default */]

  },
  methods: {}
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var currentDate = new Date();

var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
    data: function data() {
        return {
            browse: {
                category: [],
                categoryAR: [],
                categoryMY: []
            },
            main: {
                hotpicks: {},
                category: {},
                isLoad: false
            },
            search: {
                allSearch: {}
            },
            type: 'browse',
            live: 'http://cook.grabmobi.com',
            local: 'http://[::1]/PuretechGlobalContentPortal'
        };
    },
    created: function created() {
        if (host.includes("cutemobi")) {
            this.getBrowse();
        }
    },

    methods: {
        getHotPicks: function getHotPicks(browseCate) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var isload, category_arr, category, allDataContent, allData, categoryList, temp, categorySort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                isload = '';
                                category_arr = [];
                                category = [];
                                allDataContent = [];
                                allData = [];

                                //get category

                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(_this.live + '/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=' + host);

                            case 7:
                                categoryList = _context.sent;
                                temp = new Array();
                                categorySort = browseCate.filter(function (item) {
                                    if (item.category == 'Application') {
                                        temp = item;
                                    } else {
                                        return item;
                                    }
                                });

                                if (temp != '') {
                                    categorySort.push(temp);
                                }

                                category_arr = categorySort;

                                //get random number
                                oneHourInMs = 3600000;
                                currentTimeInMs = new Date().getTime(); // UTC time

                                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                                numberForToday = timeInHour % 20;
                                // zero-filling of numbers less than four digits might be optional for you
                                // zero-filled value will be a string to maintain its leading 0s

                                DigitNumber = numberForToday.toString();

                                while (DigitNumber.length < 2) {
                                    DigitNumber = 0 + Number(DigitNumber);
                                }

                                i = 0;

                            case 19:
                                if (!(i < category_arr.length)) {
                                    _context.next = 32;
                                    break;
                                }

                                _context.next = 22;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(_this.live + '/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=' + category_arr[i].category + '&limit=100&offset=0&domain=' + host);

                            case 22:
                                allData = _context.sent;
                                divide = DigitNumber % 2;


                                if (divide == 0) {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return Math.random() - 0.5;
                                    });
                                } else {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return 0.5 - Math.random();
                                    });
                                }

                                data_slice = allData.data.data.slice(0, 6);
                                categ = category_arr[i].category;

                                allDataContent[categ] = new Array();
                                allDataContent[categ] = data_slice;

                            case 29:
                                i++;
                                _context.next = 19;
                                break;

                            case 32:

                                isload = true;

                                _this.main.hotpicks = allDataContent;
                                _this.main.category = category_arr;
                                _this.main.isLoad = isload;

                            case 36:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getBrowse: function getBrowse() {
            var _this2 = this;

            var url = this.live + '/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;

            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (res) {
                // console.log(res.data.data)
                var data = res.data.data;
                var temp = [];

                data.map(function (item) {
                    item.title_english = item.category;
                    item.route = item.title_english.toLowerCase();

                    if (item.category_translate != null) {
                        var trans = JSON.parse(item.category_translate);
                        if (trans != null) {
                            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
                            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
                            for (var i = 0; i < trans_len; i++) {
                                item['title_' + trans_arr[i]] = trans[trans_arr[i]].title;
                            }
                            // item.icon = icon['my.1.grabmobi.com']['class'];
                        }
                    }

                    if (item.category_icon != null) {
                        var icon = JSON.parse(item.category_icon);
                        if (icon != null) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var _ref = _step.value;

                                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                                    var key = _ref2[0];
                                    var value = _ref2[1];

                                    if (key == host) {
                                        item.icon = icon[key]["class"];
                                    } else {
                                        item.icon = icon['mobizone.vip']['class'];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }

                    item.coverImg = __webpack_require__(2231)("./" + item.category + '.jpg');

                    temp.push(item);
                });

                var item_temp = temp.map(function (v) {
                    delete v.category_translate;
                    delete v.category_translate;
                    delete v.category_icon;
                    delete v.subcategory;
                    delete v.subcategory_translate;
                    delete v.subcategory_icon;
                    delete v.thumbnail_url;
                    delete v.cover_img;
                    return v;
                });
                _this2.getHotPicks(item_temp);
                _this2.browse.category = item_temp;
            });
        }
    }
}));

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_cutemobi__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cutemobi_js_cutemobi__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cutemobi_Search_vue__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cutemobi_Notification_vue__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__cutemobi_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_5__cutemobi_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["langButton_cm", "lang_cm", "auth_cm", "country_cm", "is_unsub_cm", "country_code_cm", "gateway_code", "gcid_cm"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchTranslateButton_cm(this.country_cm);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_cm == "english") {
      if (this.country_cm != "ke1" && this.country_cm != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_cm != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLocale_cm(lang);
      localStorage.setItem("lang_cm", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLocale_cm(lang);
      localStorage.setItem("lang_cm", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["fetchLocale_cm", "fetchTranslateButton_cm", "logout_cm"]), {
    getclick: function getclick(route, category_id) {},
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_cm");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_cm", "host_cm"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com/api/contents/cutemobi_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_cm;
        var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_cm;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(162)("./" + _this2.lang_cm + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match['not_match'];
          }

          var res_search = [];
          var bold = [];
          var img = "";
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var _icon = "";
            //use class icon
            var icon_class = [];
            if (z[_i].class_icon != null) {

              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            // if (z[i].class_icon != null) {
            //   //my.1.grabmobi.com as default domain
            //   icon = icon_class['cutemobi.vip']['class'];
            // } else {
            //   icon = icon_class['my.1.grabmobi.com']['class'];;
            // }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_mobiz) {
                    _icon = icon_class[key]["class"];
                  } else {
                    _icon = icon_class["cutemobi.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            //use class icon
            var r = res_search[_i].replace(res_search[_i], "<span class='" + _icon + "'></span> " + res_search[_i]);

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_cm", "lang_cm", "country_cm"])),
  created: function created() {
    this.fetchNotification_cm();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_cm"]))
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_cm", "lang_cm", "auth_cm", "country_cm", "is_unsub_cm"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLocale_cm", "fetchTranslateButton_cm", "logout_cm"]))
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_cutehub__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutehub_cutehub_js_cutehub_js__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cutehub_Navigation_vue__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_cutehub_UnsubModal_vue__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "cutehub",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_cutehub_cutehub_js_cutehub_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_cutehub_cutehub_js_cutehub_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_8__components_cutehub_Navigation_vue__["a" /* default */],
    UnsubModal: __WEBPACK_IMPORTED_MODULE_9__components_cutehub_UnsubModal_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_cutehub", "country_cutehub", "host_cutehub"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_cutehub(this.host_cutehub);
    this.fetchToken_cutehub(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_cutehub__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
    }

    var lang = this.lang_cutehub;
    var country_code = this.country_cutehub;

    if (this.lang_cutehub != "null" && this.lang_cutehub != null) {
      if (this.lang_cutehub == "arabic") {
        localStorage.setItem("lang_cutehub", this.lang_cutehub);
        this.$i18n.locale = this.lang_cutehub;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_cutehub(this.lang_cutehub);
      } else {
        localStorage.setItem("lang_cutehub", this.lang_cutehub);
        this.$i18n.locale = this.lang_cutehub;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_cutehub(this.lang_cutehub);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a);

      if (country_ls.includes(country_code)) {
        var language = __WEBPACK_IMPORTED_MODULE_7__locales_country_list_json___default.a[country_code].language;

        if (localStorage.getItem('userToken_cutehub') == 'chub80') {
          localStorage.setItem("lang_cutehub", 'english');
          this.$i18n.locale = 'english';
          this.fetchLocale_cutehub('english');
        } else {
          localStorage.setItem("lang_cutehub", language);
          this.$i18n.locale = language;
          this.fetchLocale_cutehub(language);
        }

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_cutehub", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_cutehub("english");
      }
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(["fetchLocale_cutehub", "fetchToken_cutehub", "getDomain_cutehub"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_12_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_11_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["HotPickIcon_cutehub", "PopularIcon_cutehub", "lang_cutehub", "country_cutehub"]),
  created: function created() {},

  methods: {
    getAllData: function getAllData() {
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_cutehub", "country_cutehub"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["msisdn_cutehub", "renew_date_cutehub", "subscription_date_cutehub", "auth_cutehub", "is_unsub_cutehub", "countryCode", "gateway_code_cutehub"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout_cutehub"]))
});

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["pageHotPicks_cutehub", "HotPickIcon_cutehub", "lang_cutehub", "country_cutehub"]),
  props: ["browse"],
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_cutehub([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_cutehub([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchPageHotPicks_cutehub"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pageHotPicks_cutehub));
      var hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(function (item) {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      } else {
        hotpick.map(function (item) {
          if (_this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(function () {
          _this.isLoad = true;
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate: function getCategoryTranslate(q, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["pagePopular_cutehub", "PopularIcon_cutehub", "country_cutehub", "lang_cutehub"]),
  created: function created() {
    this.fetchPagePopular_cutehub();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_cutehub"]))
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CutehubSlider_vue__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["HotPickIcon_cutehub", "PopularIcon_cutehub", "lang_cutehub", "country_cutehub", "host_cutehub"]),
  components: {
    "cutehub-slider": __WEBPACK_IMPORTED_MODULE_8__CutehubSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_cutehub;
                live = "http://cook.grabmobi.com/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_cutehub;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;

                  _this.hotpicks = data.slice(0, 10);
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_cutehub;
                live = "http://cook.grabmobi.com/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_cutehub;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;

                  _this2.popular = data.slice(0, 10);
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_cutehub;
      var live = "http://cook.grabmobi.com/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_cutehub;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != '') {
            if (_this3.lang_cutehub != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_cutehub].title;

              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_cutehub] = sub_trans[_this3.lang_cutehub].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_cutehub == key) {
                    if (value.language != 'english') {
                      _this3.categoryTranslate = cat_trans["" + value.language].title;
                      if (sub_trans != null) {
                        item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                      }
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (_key == _this3.host_cutehub) {
                    item.icon = sub_icon[_key]["class"];
                  } else {
                    item.icon = sub_icon["cutemobi.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: true,
        wrapAround: false,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_cutehub", "country_cutehub"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          // case "arSlider":
          //   this.$nextTick(() => {
          //     const arSliderflkty = new Flickity(
          //       this.$refs.categoryCarousel,
          //       this.flickityOptions
          //     );
          //     arSliderflkty.on("dragStart", function() {
          //       this.stageDragging = true;
          //     });
          //     arSliderflkty.on("dragEnd", function() {
          //       this.stageDragging = false;
          //     });
          //   });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allSubcategory_cutehub", "lang_cutehub", "country_cutehub", "host_cutehub"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_cutehub(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_cutehub"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + _this.subcategory + "&limit=10&offset=0&domain=" + _this.host_cutehub;
                live = "http://cook.grabmobi.com/api/contents/cutemobi_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + _this.subcategory + "&limit=10&offset=0&domain=" + _this.host_cutehub;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  console.log(res.data.data);
                  var data = res.data.data;
                  // data = data.filter((value)=>{
                  //   if(value.category.toLowerCase() == this.category){
                  //     return value;
                  //   }
                  // })
                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allSubcategory_cutehub));

      var subcat = allSubcategory.map(function (item) {
        if (item.subcategory_translate != null) {
          var sub_trans = JSON.parse(item.subcategory_translate);
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          item.titleSub_english = item.subcategory;
          if (sub_trans != null) {
            for (var i = 0; i < trans_len; i++) {
              if (lang == 'english') {
                item["titleSub_english"] = _this2.subcategory;
              } else {
                item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
              }
            }
          }
        }

        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_cutehub__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_cutehub", "host_cutehub", "auth_cutehub", "country_cutehub"]),
  created: function created() {
    this.getDetails(this.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subContent_cutehub"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(163)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal";
      var live = "http://cook.grabmobi.com";

      //everytime user display detail page, will collect the data
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_cutehub,
        product: 'cutehub',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_cutehub).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;
        _this2.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox: function openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب الان","notification":"تنبيه","view_more":"شاهد المزيد","main_title":"استكشف الفتيات الأكثر جاذبية","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Cutehub؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"بحث ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","android":"أندرويد","no_notification":"لا يوجد إشعارات","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Cutemobi","modal_title":"إلغاء الاشتراك","unsub_confirmation":"هل تريد الغاء الاشتراك؟","yes":"نعم","no":"لا"}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Разгледайте най-секси момичета","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Cutehub?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","android":"Android","no_notification":"Няма известие","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани от Cutehub","modal_title":"Анулиране на абонамента?","unsub_confirmation":"Наистина ли искате да се отпишете?","yes":"Да","no":"Не"}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Prozkoumejte nejvíc sexy dívky","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Cutehub?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Vyhledávání ...","not_subs":"Ještě nejste přihlášeni","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","android":"Android","no_notification":"Žádné oznámení","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","unsubscription":"Nyní jste odhlášeni z Cutehub","modal_title":"Zrušit předplatné?","unsub_confirmation":"Opravdu se chcete odhlásit?","yes":"Ano","no":"Ne"}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"Udforsk mest sexede piger","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Cutehub?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Cutehub","modal_title":"Annuller abonnement?","unsub_confirmation":"Er du sikker på, at du vil afmelde dig?","yes":"Ja","no":"ingen"}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Pick","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Explore sexiest girls","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Cutehub?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search ...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","android":"Android","no_notification":"No notification","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Cutehub","modal_title":"Cancel Subscription?","unsub_confirmation":"Are you sure you want to unsubscribe?","yes":"Yes","no":"No"}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Pick","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Utforska sexigaste tjejer","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Villkor & villkors","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på Cutehub?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen sätt in det giltiga numret!","full_name":"Fullständiga namn","registered_num":"Registrerat numme","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök ...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt bra om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra den här korta undersökningen.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","android":"Android","no_notification":"Ingen anmälan","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum","unsubscription":"Du prenumererar nu Cutehub","modal_title":"Avsluta prenumeration?","unsub_confirmation":"Är du säker på att du vill avsluta prenumerationen?","yes":"Ja","no":"Nej"}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = {"browse":"Αναζήτηση","hotpicks":"Καυτές επιλογές","popular":"Δημοφιλή","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δες περισσότερα","main_title":"Αναζήτησε τα πιο σέξυ κορίτσια","home":"Αρχική Σελίδα","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Cutehub?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση","not_subs":"Δεν Εγγραφή ακόμα","application":"Εφαρμογή","game":"Παιχνίδι","video":"Βίντεο","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Διαγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","android":"Android","no_notification":"καμία Ειδοποίηση","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής","unsubscription":"Έχετε διαγραφεί από τώρα Cutemobi","yes":"Ya","no":"Tidak"}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"SEMUANYA DISATU TEMPAT","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Cutehub?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari ...","not_subs":"Belum Berlangganan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak"}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"SEMUA DALAM SATU PLATFORM","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Cutehub?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari...","not_subs":"Belum Melanggan","application":"Aplikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","android":"Android","no_notification":"Tiada Notifikasi","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak"}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Utforsk de mest sexy jentene","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Cutehub?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv.","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Cutehub","modal_title":"Avbestille abonnementet?","unsub_confirmation":"Er du sikker på at du vil avslutte abonnementet?","yes":"Ja","no":"Nei"}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Hot Pick","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Explorează cele mai sexy fete","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la Cutehub?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutare ...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs.","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Usability","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","android":"Android","no_notification":"Nicio notificare","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului","unsubscription":"Acum sunteți dezabonat de la Cutehub","modal_title":"Anuleaza abonarea?","unsub_confirmation":"Sigur doriți să vă dezabonați?","yes":"da","no":"Nu"}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Preskúmajte najsexi dievčatá","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Cutehub?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","no_notification":"No Oznámenie","android":"Android","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu Cutehub","modal_title":"Zrušiť predplatné?","unsub_confirmation":"Naozaj chcete zrušiť odber?","yes":"Áno","no":"Nie"}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Hot Pick","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Utforska sexigaste tjejer","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på Cutehub?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök ...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt bra om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra den här korta undersökningen.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","android":"Android","no_notification":"Ingen anmälan","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum","unsubscription":"Du avslutar nu prenumerationen på Cutehub","modal_title":"Avsluta prenumeration?","unsub_confirmation":"Är du säker på att du vill avsluta prenumerationen?","yes":"Ja","no":"Nej"}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"รวมทุกอย่างในที่เดียว","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Cutehub?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหา...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","android":"แอนดรอยด์","no_notification":"ไม่มีการแจ้งเตือน","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak"}

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_cutehub__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_cutehub);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_cutehub", "gcid_cutehub", "country_cutehub"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = '+' + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_cutehub != "") {
            gcid = this.gcid_cutehub;
          } else {
            //dummy gcid
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userToken_cutehub", response.token);
              localStorage.setItem("userProfile_cutehub", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_cutehub("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_cutehub__["a" /* default */].push({ name: "Main" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_cutehub == key) {
                    var status_lang = __webpack_require__(163)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_cutehub"]))
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {}
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_cutehub", "gcid_cutehub", "country_cutehub"])
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySlovakian__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicySKEnglish__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyFinnish__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapGetters */])(["lang_cutehub", "country_cutehub"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-slovakian': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySlovakian__["a" /* default */],
    'privacy-skenglish': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicySKEnglish__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_11__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_10__PrivacyPolicyFinnish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermsSKSlovak__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsCZCzech__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsEnglish__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["lang_cutehub", "country_cutehub"]),
  components: {
    "terms-sk-slovak": __WEBPACK_IMPORTED_MODULE_0__TermsSKSlovak__["a" /* default */],
    "terms-cz-czech": __WEBPACK_IMPORTED_MODULE_1__TermsCZCzech__["a" /* default */],
    "terms-english": __WEBPACK_IMPORTED_MODULE_2__TermsEnglish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["country"]
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var currentDate = new Date();

var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
    data: function data() {
        return {
            browse: {
                category: [],
                categoryAR: [],
                categoryMY: []
            },
            main: {
                hotpicks: {},
                category: {},
                isLoad: false
            },
            search: {
                allSearch: {}
            },
            type: 'browse',
            live: 'http://cook.grabmobi.com',
            local: 'http://[::1]/PuretechGlobalContentPortal'
        };
    },
    created: function created() {
        if (host.includes("cutehub")) {
            this.getBrowse();
        }
    },

    methods: {
        getHotPicks: function getHotPicks(browseCate) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var isload, category_arr, category, allDataContent, allData, temp, categorySort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                isload = '';
                                category_arr = [];
                                category = [];
                                allDataContent = [];
                                allData = [];

                                //get category
                                // let categoryList = await axios.get(
                                //     `${this.live}/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=${host}`
                                // );

                                temp = new Array();
                                categorySort = browseCate.filter(function (item) {
                                    if (item.category == 'Application') {
                                        temp = item;
                                    } else {
                                        return item;
                                    }
                                });

                                if (temp != '') {
                                    categorySort.push(temp);
                                }

                                category_arr = categorySort;

                                //get random number
                                oneHourInMs = 3600000;
                                currentTimeInMs = new Date().getTime(); // UTC time

                                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                                numberForToday = timeInHour % 20;
                                // zero-filling of numbers less than four digits might be optional for you
                                // zero-filled value will be a string to maintain its leading 0s

                                DigitNumber = numberForToday.toString();

                                while (DigitNumber.length < 2) {
                                    DigitNumber = 0 + Number(DigitNumber);
                                }

                                i = 0;

                            case 16:
                                if (!(i < category_arr.length)) {
                                    _context.next = 29;
                                    break;
                                }

                                _context.next = 19;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(_this.live + '/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=' + category_arr[i].category + '&limit=100&offset=0&domain=' + host);

                            case 19:
                                allData = _context.sent;
                                divide = DigitNumber % 2;


                                if (divide == 0) {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return Math.random() - 0.5;
                                    });
                                } else {
                                    allData.data.data.sort(function (a, b) {
                                        //to sort random
                                        return 0.5 - Math.random();
                                    });
                                }

                                data_slice = allData.data.data.slice(0, 6);
                                categ = category_arr[i].category;

                                allDataContent[categ] = new Array();
                                allDataContent[categ] = data_slice;

                            case 26:
                                i++;
                                _context.next = 16;
                                break;

                            case 29:

                                isload = true;

                                _this.main.hotpicks = allDataContent;
                                _this.main.category = category_arr;
                                _this.main.isLoad = isload;

                            case 33:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getBrowse: function getBrowse() {
            var _this2 = this;

            var url = this.live + '/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;

            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (res) {
                // console.log(res.data.data)
                var data = res.data.data;
                var temp = [];

                data.map(function (item) {
                    item.title_english = item.category;
                    item.route = item.title_english.toLowerCase();

                    if (item.category_translate != null) {
                        var trans = JSON.parse(item.category_translate);
                        if (trans != null) {
                            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
                            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
                            for (var i = 0; i < trans_len; i++) {
                                item['title_' + trans_arr[i]] = trans[trans_arr[i]].title;
                            }
                            // item.icon = icon['my.1.grabmobi.com']['class'];
                        }
                    }

                    if (item.category_icon != null) {
                        var icon = JSON.parse(item.category_icon);
                        if (icon != null) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var _ref = _step.value;

                                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                                    var key = _ref2[0];
                                    var value = _ref2[1];

                                    if (key == host) {
                                        item.icon = icon[key]["class"];
                                    } else {
                                        item.icon = icon['mobizone.vip']['class'];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }

                    item.coverImg = __webpack_require__(2315)("./" + item.category + '.jpg');

                    temp.push(item);
                });

                var item_temp = temp.map(function (v) {
                    delete v.category_translate;
                    delete v.category_translate;
                    delete v.category_icon;
                    delete v.subcategory;
                    delete v.subcategory_translate;
                    delete v.subcategory_icon;
                    delete v.thumbnail_url;
                    delete v.cover_img;
                    return v;
                });
                _this2.getHotPicks(item_temp);
                _this2.browse.category = item_temp;
            });
        }
    }
}));

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_cutehub__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cutehub_js_cutehub__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cutehub_Search_vue__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cutehub_Notification_vue__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__cutehub_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_5__cutehub_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["langButton_cutehub", "lang_cutehub", "auth_cutehub", "country_cutehub", "is_unsub_cutehub", "gateway_code_cutehub"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchTranslateButton_cutehub(this.country_cutehub);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_cutehub == "english") {
      if (this.country_cutehub != "ke1" && this.country_cutehub != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_cutehub != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLocale_cutehub(lang);
      localStorage.setItem("lang_cutehub", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLocale_cutehub(lang);
      localStorage.setItem("lang_cutehub", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["fetchLocale_cutehub", "fetchTranslateButton_cutehub", "logout_cutehub"]), {
    getclick: function getclick(route, category_id) {},
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_cutehub");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_cutehub", "host_cutehub"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com/api/contents/cutemobi_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_cutehub;
        var local = "http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_cutehub;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(163)("./" + _this2.lang_cutehub + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];
          var img = "";
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var _icon = "";
            //use class icon
            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            // if (z[i].class_icon != null) {
            //   //my.1.grabmobi.com as default domain
            //   icon = icon_class['cutemobi.vip']['class'];
            // } else {
            //   icon = icon_class['my.1.grabmobi.com']['class'];;
            // }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_mobiz) {
                    _icon = icon_class[key]["class"];
                  } else {
                    _icon = icon_class["cutemobi.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            //use class icon
            var r = res_search[_i].replace(res_search[_i], "<span class='" + _icon + "'></span> " + res_search[_i]);

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_cutehub", "lang_cutehub", "country_cutehub"])),
  created: function created() {
    this.fetchNotification_cutehub();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_cutehub"]))
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["langButton_cutehub", "lang_cutehub", "auth_cutehub", "country_cutehub", "is_unsub_cutehub"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["fetchLocale_cutehub", "fetchTranslateButton_cutehub", "logout_cutehub"]))
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_apps4all__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_apps4all_apps4all_js_apps4all_js__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_apps4all_Navigation_vue__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Gameknight",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_apps4all_apps4all_js_apps4all_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_apps4all_apps4all_js_apps4all_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_apps4all_Navigation_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_a4all", "country_a4all", "host_a4all"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_a4all(this.host_a4all);
    this.fetchTokenID_a4all(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_apps4all__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
    }
    var country_id = this.country_a4all;

    if (this.lang_a4all != "null" && this.lang_a4all != null) {
      if (this.lang_a4all == "arabic") {
        localStorage.setItem("lang_a4all", this.lang_a4all);
        this.$i18n.locale = this.lang_a4all;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLanguage_a4all(this.lang_a4all);
      } else {
        localStorage.setItem("lang_a4all", this.lang_a4all);
        this.$i18n.locale = this.lang_a4all;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_a4all(this.lang_a4all);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a);

      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a[country_id].language;

        localStorage.setItem("lang_a4all", language);
        this.$i18n.locale = language;
        this.fetchLanguage_a4all(language);

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_a4all", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLanguage_a4all("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["fetchLanguage_a4all", "fetchTokenID_a4all", "getDomain_a4all"]), {
    // ...mapActions(["fetchLanguage_a4all"]),
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])([
  // "allSubApp_a4all",
  // "allStoreAppData_a4all",
  "IconHotPick_a4all", "IconPopular_a4all", "lang_a4all", "country_a4all"]
  // "hpisLoad_a4all"
  ),
  created: function created() {
    // this.fetchHomeHotPick_a4all();
  },

  methods: {
    getAllData: function getAllData() {
      // console.log(this.allHotPicksData)
      var data = this.$props.main.hotpicks;
      var dat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
      dat.map(function (item) {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_a4all", "country_a4all"]),
  mounted: function mounted() {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_a4all", "renew_date_a4all", "subscription_date_a4all", "authentication_a4all", "is_unsub_a4all", "countryCode"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_a4all"]))
});

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["HotPicksPage_a4all", "IconHotPick_a4all", "lang_a4all", "country_a4all"]),
  created: function created() {
    this.isLoad = false;
    this.fetchHotPicksApp_a4all([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchHotPicksApp_a4all([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchHotPicksApp_a4all"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_a4all));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_a4all", "IconPopular_a4all", "lang_a4all"]),
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  created: function created() {
    this.fetchPopularApp_a4all();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPopularApp_a4all"]))
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Apps4allSlider_vue__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component("star-rating", VueStarRating.default);
var currentDate = new Date();
var day = currentDate.getDay();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["IconHotPick_a4all", "IconPopular_a4all", "lang_a4all", "country_a4all", "host_a4all"]),
  components: {
    "a4all-slider": __WEBPACK_IMPORTED_MODULE_8__Apps4allSlider_vue__["a" /* default */],
    "star-rating": __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  created: function created() {
    var c = this.$route.params.category;
    //if route have '_' will change to space
    var cat = c.replace("_", " ");
    //split category name and category id
    var cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },

  methods: {
    getCatHotPicks: function getCatHotPicks(category) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_a4all;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this.host_a4all;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this.isLoaded.hotpicks = true;

                  _this.hotpicks = data.slice(0, 10);
                  setTimeout(function () {
                    _this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCatPopular: function getCatPopular(category) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var local, live;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                local = "http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_a4all;
                live = "http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + category + "&limit=100&offset=0&domain=" + _this2.host_a4all;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  var data = res.data.data;
                  data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });

                  _this2.isLoaded.popular = true;

                  _this2.popular = data.slice(0, 10);
                  setTimeout(function () {
                    _this2.$refs.popularComponent.triggerFn("popularSlider");
                  }, 0);
                }).catch(function (err) {
                  console.log(err);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSubcategory: function getSubcategory(category, id) {
      var _this3 = this;

      var local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_a4all;
      var live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=" + category + "&subcategory=" + id + "&limit=100&offset=0&domain=" + this.host_a4all;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp_data = data.map(function (item) {
          var cat_trans = [];
          var sub_trans = [];
          if (item.category_translate != null) {
            cat_trans = JSON.parse(item.category_translate);
          }
          if (item.subcategory_translate != null) {
            sub_trans = JSON.parse(item.subcategory_translate);
          }

          item.titleSub_english = item.subcategory;
          item.route = item.subcategory;
          if (cat_trans != null && cat_trans != '') {
            if (_this3.lang_a4all != "english") {
              _this3.categoryTranslate = cat_trans[_this3.lang_a4all].title;

              if (sub_trans != null) {
                item["titleSub_" + _this3.lang_a4all] = sub_trans[_this3.lang_a4all].title;
              }
            } else {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (_this3.country_a4all == key) {
                    if (value.language != 'english') {
                      _this3.categoryTranslate = cat_trans["" + value.language].title;
                      if (sub_trans != null) {
                        item["titleSub_" + value.language] = sub_trans["" + value.language].title;
                      }
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }

          if (item.subcategory_icon != null) {
            var sub_icon = JSON.parse(item.subcategory_icon);
            if (sub_icon != null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(sub_icon)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var _key = _ref4[0];
                  var _value = _ref4[1];

                  if (_key == _this3.host_a4all) {
                    item.icon = sub_icon[_key]["class"];
                  } else {
                    item.icon = sub_icon["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
          return item;
        });

        _this3.isLoaded.subCategory = true;
        _this3.subcategory = temp_data;

        setTimeout(function () {
          _this3.$refs.childComponent.triggerFn("catSlider");
        }, 100);
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCategoryTitle: function getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false
      },
      flickityOptionsCategory: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        resize: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      cate: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      }
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["lang_a4all", "country_a4all"]),
  props: ["sliderData", "cat", "hotpick", "popular", "category", "isLoaded"],
  mounted: function mounted() {
    var sliderStatus = false;
    var width = window.innerWidth;
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  methods: {
    triggerFn: function triggerFn(sliderType) {
      var _this = this;

      setTimeout(function () {
        switch (sliderType) {
          case "catSlider":
            var categorySliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptionsCategory);
            categorySliderflkty.on("dragStart", function () {
              this.stageDragging = true;
            });
            categorySliderflkty.on("dragEnd", function () {
              this.stageDragging = false;
            });
            break;
          case "hotPicksSlider":
            _this.$nextTick(function () {
              var hotPickSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.hotCarousel, _this.flickityOptions);
              hotPickSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              hotPickSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
            break;
          case "popularSlider":
            _this.$nextTick(function () {
              var popularSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.popularCarousel, _this.flickityOptions);
              popularSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              popularSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          case "arSlider":
            _this.$nextTick(function () {
              var arSliderflkty = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.$refs.categoryCarousel, _this.flickityOptions);
              arSliderflkty.on("dragStart", function () {
                this.stageDragging = true;
              });
              arSliderflkty.on("dragEnd", function () {
                this.stageDragging = false;
              });
            });
          default:
        }
      }, 0);
    }
  }
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTanslate: "",
      data: {},
      icon: "",
      isLoaded: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["allSubcategory_a4all", "lang_a4all", "country_a4all", "host_a4all"]),
  created: function created() {
    //replace '_' with blank space
    var subcategory = this.$route.params.subcat;
    var category = this.$route.params.category;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;
    category = category.replace("_", " ");
    this.category = category;

    this.fetchAllSubcategory_a4all(this.subcategory);

    var e = undefined;
    this.getSubContent(e);
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["fetchAllSubcategory_a4all"]), {
    getSubContent: function getSubContent(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, local, live;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = 0;


                if (e != undefined) {
                  limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                } else {
                  //default
                  limit = 100;
                }

                local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_fplus;
                live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + _this.subcategory + "&limit=" + limit + "&offset=0&domain=" + _this.host_fplus;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(live).then(function (res) {
                  console.log(res.data.data);
                  var data = res.data.data;
                  // data = data.filter((value)=>{
                  //   if(value.category.toLowerCase() == this.category){
                  //     return value;
                  //   }
                  // })
                  _this.isLoaded = true;
                  _this.data = data;
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubCategory: function getSubCategory(lang) {
      var _this2 = this;

      var allSubcategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.allSubcategory_a4all));

      var subcat = allSubcategory.map(function (item) {
        if (item.subcategory_translate != null) {
          var sub_trans = JSON.parse(item.subcategory_translate);
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

          item.titleSub_english = item.subcategory;
          if (sub_trans != null) {
            for (var i = 0; i < trans_len; i++) {
              if (lang == "english") {
                item["titleSub_english"] = _this2.subcategory;
              } else {
                item["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
              }
            }
          }
        }

        return item;
      });

      if (subcat[0] != undefined) {
        return subcat[0]["titleSub_" + lang];
      }
    }
  })
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_apps4all__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_7__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_8_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["lang_a4all", "host_a4all", "country_a4all"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["subscribeContent_a4all"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(164)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_4_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //everytime user display detail page, will collect the data
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(live + "/api/newcontents_statistic", {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_a4all,
        product: 'apps4all',
        content_id: id,
        type: "view"
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + this.host_a4all).then(function (res) {
        var data = res.data.data[0];

        var sc = data.screenshot.split(",");
        var sc_temp = [];
        for (var i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
        }

        data.screenshot = sc_temp;

        _this2.contentCoverImg = data.cover_img;

        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          var sub_trans = JSON.parse(data.subcategory_translate);
          var sub_icon = JSON.parse(data.subcategory_icon);

          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);
          for (var _i = 0; _i < trans_len; _i++) {
            data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
          }
        }

        setTimeout(function () {
          _this2.details = data;
          _this2.isLoad = true;
          _this2.$nextTick(function () {
            _this2.initPlyr();
          });
        }, 0);
      });
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"جميع التطبيقات في مكان واحد","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل انت مشترك في Apps4all؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن تطبيقات ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Apps4all"}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Play Now","notification":"Notification","view_more":"Виж повече","main_title":"ВСИЧКО НА ЕДНО МЯСТО","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Apps4all?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","valid_number":"Моля, въведете валидния номер!","full_name":"Full Name","registered_num":"Регистриран номер","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте!","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","Action Games":"Екшън игри","Puzzle Game":"Пъзел игри","Sport Games":"Спортни игри","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","no_notification":"Няма известие","android":"Android","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента"}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Všechny aplikace na jednom místě","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Apps4all?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jméno","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Hledat aplikace ...","not_subs":"Ještě nejste přihlášeni","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikací","content":"obsah","subscription":"předplatné","unsubscribe":"Odhlásit odběr","Action Games":"Akční hry","Puzzle Game":"Logické hry","Sport Games":"Sportovní hry","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámení","android":"Android","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného"}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"ALT ET STED","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Apps4all?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","Action Games":"Action Spil","Puzzle Game":"Gåde","Sport Games":"Sport","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato"}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"All apps in one place","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Apps4all?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Apps...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","Action Games":"Action Games","Puzzle Game":"Puzzle Games","Sport Games":"Sport Games","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Apps4all"}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = {"browse":"Selaa","hotpicks":"Hot Picks","popular":"Suosittu","profile":"Profiili","downloads":"Lataukset","download":"ladata","play":"Pelaa nyt","notification":"Ilmoitus","view_more":"Katso lisää","main_title":"Kaikki sovellukset yhdessä paikassa","home":"Koti","favorites":"Suosikit","contact":"Ottaa yhteyttä","settings":"asetukset","privacy":"Tietosuojakäytäntö","terms":"käyttöehdot","all":"Kaikki","allCategories":"kaikki kategoriat","categories":"Luokat","category":"Kategoria","platform":"Alusta","type":"Tyyppi","login":"Kirjaudu sisään","logout":"Kirjautua ulos","login_title":"Oletko tilannut Apps4all?","confirmation":"Vahvista sitten matkapuhelinnumerosi ja saat rajoittamattoman pääsyn kaikkiin palveluihimme!","submit":"Lähetä","valid_number":"Lisää oikea numero!","full_name":"Koko nimi","registered_num":"Rekisteröity numero","registered_email":"Rekisteröity sähköpostil","registered_date":"Rekisteröity päivämäärä","hello":"Hei","search":"Hae sovelluksia ...","not_subs":"Ei vielä tilaa","application":"Sovellus","game":"Peli","video":"Video","contact_us":"Ota meihin yhteyttä","subject":"Aihe","message":"Viesti","let_us":"Kerro meille tiedusteluistasi","select_subject":"Valitse Aihe","app_issue":"Sovelluksen numero","content":"Sisältö","subscription":"Tilaus","unsubscribe":"Lopeta tilaus","Action Games":"Toimintapelit","Puzzle Game":"Pulmapelit","Sport Games":"Urheilupelit","not_match":"Ei täsmää","feedback":"Palaute","feedback_intro":"Olisimme erittäin kiitollisia, jos voisit säästää muutaman minuutin auttaaksesi meitä parantamaan sivustoamme täyttämällä tämän lyhyen kyselyn.","Overall":"Yleensä ottaen","Usability":"Käytettävyys","Your Suggestion":"Sinun ehdotuksesi","feedback_comment":"Kirjoita kommenttisi","status":"Epäaktiivinen","mobile_computer":"Matkapuhelin ja tietokone","no_notification":"Ei ilmoitusta","android":"Android","next_renew_date":"Seuraava uusimispäivä","subscription_date":"Tilauspäivä"}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"Όλες οι εφαρμογές σε ένα μέρος","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Apps4all?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γειά σου","search":"Αναζήτηση για εφαρμογές ...","not_subs":"Δεν Εγγραφή ακόμα","application":"Application","game":"Game","video":"Video","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητά και υπολογιστές","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Semua aplikasi di satu tempat","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Apps4all?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Telusuri Aplikasi ...","not_subs":"Belum Berlangganan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Semua applikasi dalam satu tempat","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Apps4all?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Aplikasi...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Alle apper på ett sted","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"Alle Kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnert på Apps4all?","confirmation":"Bekreft deretter mobilnummeret ditt og få ubegrenset tilgang til alle våre tjenester!","submit":"sende inn","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","android":"Android","no_notification":"Ingen varsling","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","Action Games":"Actionspill","Puzzle Game":"Puslespill","Sport Games":"Sportsspill"}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = {"browse":"Naviga","hotpicks":"Alegeri fierbinți","popular":"Popular","profile":"Profil","downloads":"Descărcări","download":"Descarca","play":"Joaca acum","notification":"Notificare","view_more":"Vezi mai mult","main_title":"Toate aplicațiile într-un singur loc","home":"Acasă","favorites":"Favorite","contact":"a lua legatura","settings":"Setări","privacy":"Politica de Confidențialitate","terms":"termeni si conditii","all":"Toate","allCategories":"toate categoriile","categories":"Categorii","category":"Categorie","platform":"Platformă","type":"Tip","login":"Autentificare","logout":"Deconectați-vă","login_title":"Abonat la Apps4all?","confirmation":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate serviciile noastre!","submit":"Trimite","valid_number":"Vă rugăm să introduceți numărul valid!","full_name":"Numele complet","registered_num":"Număr înregistrat","registered_email":"email inregistrat","registered_date":"Data înregistrării","hello":"Buna ziua","search":"Căutați aplicații...","not_subs":"Nu te abona încă","application":"Cerere","game":"Joc","video":"Video","contact_us":"Contactează-ne","subject":"Subiect","message":"Mesaj","let_us":"Spuneți-ne despre solicitarea dvs.","select_subject":"Selectați Subiect","app_issue":"Problemă a aplicației","content":"Conţinut","subscription":"Abonament","unsubscribe":"Dezabonați-vă","Action Games":"Jocuri de acțiune","Puzzle Game":"Jocuri puzzle","Sport Games":"Jocuri sportive","not_match":"Nu se potrivesc","feedback":"Părere","feedback_intro":"Am fi foarte minunați dacă ați putea pierde câteva minute pentru a ne ajuta să ne îmbunătățim site-ul prin finalizarea acestui scurt sondaj.","Overall":"Per total","Usability":"Utilizare","Your Suggestion":"Sugestiile dumneavoastră","feedback_comment":"Vă rugăm să introduceți comentariile dvs.","status":"Inactiv","mobile_computer":"Mobile și computer","no_notification":"Nicio notificare","android":"Android","next_renew_date":"Data următoare de reînnoire","subscription_date":"Data abonamentului"}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"VŠETKO NA JEDNOM MIESTE","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Apps4all?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","Action Games":"Akčné hry","Puzzle Game":"Hádanka","Sport Games":"Šport","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","no_notification":"No Oznámenie","android":"Android","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného"}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bläddra","hotpicks":"Populära val","popular":"Populär","profile":"Profil","downloads":"Nedladdningar","download":"Ladda ner","play":"Spela nu","notification":"Underrättelse","view_more":"Visa mer","main_title":"Alla appar på ett ställe","home":"Hem","favorites":"Favoriter","contact":"Kontakt","settings":"inställningar","privacy":"Integritetspolicy","terms":"Allmänna Villkor","all":"Allt","allCategories":"alla kategorier","categories":"Kategorier","category":"Kategori","platform":"Plattform","type":"Typ","login":"Logga in","logout":"Logga ut","login_title":"Prenumerera på Apps4all?","confirmation":"Bekräfta sedan ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","submit":"Skicka in","valid_number":"Vänligen ange giltigt nummer!","full_name":"Fullständiga namn","registered_num":"Registrerat nummer","registered_email":"registrerad e-post","registered_date":"Registrerat datum","hello":"Hej","search":"Sök efter appar...","not_subs":"Prenumerera inte ännu","application":"Ansökan","game":"Spel","video":"Video","contact_us":"Kontakta oss","subject":"Ämne","message":"Meddelande","let_us":"Låt oss veta om din förfrågan","select_subject":"Välj ämne","app_issue":"Appproblem","content":"Innehåll","subscription":"Prenumeration","unsubscribe":"Säga upp","Action Games":"Actionspel","Puzzle Game":"Pussel spel","Sport Games":"Sportspel","not_match":"Matchar inte","feedback":"Respons","feedback_intro":"Vi skulle vara väldigt fantastiska om du kunde spara några minuter för att hjälpa oss att förbättra vår webbplats genom att slutföra denna korta undersökning.","Overall":"Övergripande","Usability":"Användbarhet","Your Suggestion":"Dina förslag","feedback_comment":"Vänligen ange dina kommentarer","status":"Inaktiv","mobile_computer":"Mobil och dator","no_notification":"Ingen anmälan","android":"Android","next_renew_date":"Nästa förnyelsedatum","subscription_date":"Prenumerationsdatum"}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"แอพทั้งหมดในที่เดียว","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Apps4all?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาแอพ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","android":"แอนดรอยด์","no_notification":"ไม่มีการแจ้งเตือน","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก","unsubscription":"You are now unsubscribed from Cutemobi","yes":"Ya","no":"Tidak"}

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_apps4all__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created: function created() {
    this.getPrefix(this.country_a4all);
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_a4all", "gcid_a4all", "country_a4all"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = "+" + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_a4all != "") {
            gcid = this.gcid_a4all;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_a4all", response.token);
              localStorage.setItem("userProfile_a4all", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_a4all("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_apps4all__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_a4all == key) {
                    var status_lang = __webpack_require__(164)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_a4all"]))
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {}
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1_vue_star_rating___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var rating1 = document.getElementById("rating1");
    var rating2 = document.getElementById("rating2");
    var rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", function (e) {
      _this.rating1;
    });

    rating2.addEventListener("click", function (e) {
      _this.rating2;
    });

    rating3.addEventListener("click", function (e) {
      _this.rating3;
    });
  },

  methods: {}
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySwedish__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyFinnish__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicyRomanian__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["lang_a4all", "country_a4all"]),
  components: {
    "privacy-english": __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    "privacy-arabic": __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    "privacy-malay": __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    "privacy-greek": __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */],
    'privacy-swedish': __WEBPACK_IMPORTED_MODULE_7__PrivacyPolicySwedish__["a" /* default */],
    'privacy-romanian': __WEBPACK_IMPORTED_MODULE_9__PrivacyPolicyRomanian__["a" /* default */],
    'privacy-finnish': __WEBPACK_IMPORTED_MODULE_8__PrivacyPolicyFinnish__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermsEnglish__ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermsSlovakia__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsCzech_vue__ = __webpack_require__(2387);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_a4all", "country_a4all"]),
  components: {
    "terms-english": __WEBPACK_IMPORTED_MODULE_0__TermsEnglish__["a" /* default */],
    "terms-slovakia": __WEBPACK_IMPORTED_MODULE_1__TermsSlovakia__["a" /* default */],
    TermsCzech: __WEBPACK_IMPORTED_MODULE_3__TermsCzech_vue__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["countryCode"]),
  mounted: function mounted() {}
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_a4all", "gcid_a4all", "country_a4all", 'app4all_res_sub'])
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      browse: {
        category: [],
        categoryAR: [],
        categoryMY: []
      },
      main: {
        hotpicks: {},
        category: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: 'browse'
    };
  },
  created: function created() {
    if (host.includes("apps4all")) {
      this.getBrowse();
      // this.getHotPicks();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(browseCate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, browseCat, browseCategory, allDataContent, allData, live, local, browse, temp, browseSort, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, categ;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = '';
                browseCat = [];
                browseCategory = [];
                allDataContent = [];
                allData = [];
                live = 'http://cook.grabmobi.com';
                local = 'http://[::1]/PuretechGlobalContentPortal';

                //get subcategory under game

                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + '/api/contents/app4all?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=' + host);

              case 9:
                browse = _context.sent;
                temp = [];
                browseSort = browseCate.filter(function (item) {
                  if (item.category == 'Application') {
                    temp = item;
                  } else {
                    return item;
                  }
                });

                if (temp != '') {
                  browseSort.push(temp);
                }

                browseCat = browseSort;
                // browseCat.map((item)=>{
                // let trans = JSON.parse(item.category_translate);
                // if (trans != null) {
                //     let trans_len = Object.keys(trans).length;
                //     let trans_arr = Object.keys(trans);
                //     for (let i = 0; i < trans_len; i++) {
                //         item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
                //     }
                // }
                //     browseCategory.push(item)
                // })

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 18;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 21:
                if (!(i < browseCat.length)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 24;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + '/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=' + browseCat[i].category + '&limit=100&offset=0&domain=' + host);

              case 24:
                allData = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allData.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allData.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allData.data.data.slice(0, 6);
                categ = browseCat[i].category;

                allDataContent[categ] = new Array();
                allDataContent[categ] = data_slice;

              case 31:
                i++;
                _context.next = 21;
                break;

              case 34:

                isload = true;

                _this.main.hotpicks = allDataContent;
                _this.main.category = browseCat;
                _this.main.isLoad = isload;

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var local = 'http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;
      var live = 'http://cook.grabmobi.com/api/contents/app4all?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=' + host;

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live).then(function (res) {
        var data = res.data.data;
        var temp = [];

        data.map(function (item) {
          item.title_english = item.category;
          item.route = item.title_english.toLowerCase();

          var trans = JSON.parse(item.category_translate);
          var icon = JSON.parse(item.category_icon);

          if (trans != null) {
            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);
            for (var i = 0; i < trans_len; i++) {
              item['title_' + trans_arr[i]] = trans[trans_arr[i]].title;
            }
            // item.icon = icon['my.1.grabmobi.com']['class'];
          }

          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon['mobizone.vip']['class'];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          item.coverImg = __webpack_require__(639)("./" + item.category + '.jpg');

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });

        _this2.browse.category = item_temp;
        _this2.getHotPicks(item_temp);
      });
    }
  }
}));

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apps4all_apps4all_js_apps4all__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apps4all_Search_vue__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apps4all_Notification_vue__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_3__apps4all_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_4__apps4all_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["langButton_a4all", "lang_a4all", "authentication_a4all", "country_a4all", "is_unsub_a4all",, "countryCode"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchLanguageButton_a4all(this.country_a4all);

    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_a4all == "english") {
      if (this.country_a4all != "ke1" && this.country_a4all != "ke") {
        btnLang2.style.display = "inline-block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_a4all != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "inline-block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLanguage_a4all(lang);
      localStorage.setItem("lang_a4all", lang);
      btnLang2.style.display = "inline-block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLanguage_a4all(lang);
      localStorage.setItem("lang_a4all", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "inline-block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    //notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["fetchLanguage_a4all", "fetchLanguageButton_a4all", "logout_a4all"]), {
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userToken_a4all");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_a4all", "host_a4all"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_a4all).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          for (var i = 0; i < search.length; i++) {
            if (count <= 15) {
              _this2.count = count;
              z.push(search[i]);
            }
            count++;
          }
          _this2.result_search = z;

          var not_match = __webpack_require__(164)("./" + _this2.lang_a4all + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];
          var icon = "";

          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == _this2.host_a4all) {
                    icon = icon_class[key]["class"];
                  } else {
                    icon = icon_class["mobizone.vip"]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }

            //to show the bold text
            var rs = z[_i].content_name;
            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);

            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");
            bold.push(r);

            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_a4all", "lang_a4all", "country_a4all"])),
  created: function created() {
    this.fetchAppNotification_a4all();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchAppNotification_a4all"]))
});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Apps4all-white.ea28aa1.png";

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_playmix__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_playmix_playmix_js__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_playmix_Navigation_vue__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Playmix",
  data: function data() {
    return {
      browse: __WEBPACK_IMPORTED_MODULE_6__components_playmix_playmix_js__["a" /* default */].browse,
      main: __WEBPACK_IMPORTED_MODULE_6__components_playmix_playmix_js__["a" /* default */].main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_7__components_playmix_Navigation_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["lang_playmix", "country_playmix", "host_playmix"]),
  mounted: function mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created: function created() {
    this.getDomain_playmix(this.host_playmix);
    this.fetchTokenID_playmix(this.id);

    if (window.location.pathname === "/") {
      __WEBPACK_IMPORTED_MODULE_5__router_playmix__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
    }
    var country_id = this.country_playmix;

    if (this.lang_playmix != "null" && this.lang_playmix != null) {
      if (this.lang_playmix == "arabic") {
        localStorage.setItem("lang_playmix", this.lang_playmix);
        this.$i18n.locale = this.lang_playmix;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLang_playmix(this.lang_playmix);
      } else {
        localStorage.setItem("lang_playmix", this.lang_playmix);
        this.$i18n.locale = this.lang_playmix;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang_playmix(this.lang_playmix);
      }
    } else {
      var country_ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a);

      if (country_ls.includes(country_id)) {
        var language = __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a[country_id].language;

        localStorage.setItem("lang_playmix", language);
        this.$i18n.locale = language;
        this.fetchLang_playmix(language);

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_playmix", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang_playmix("english");
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["fetchLang_playmix", "fetchTokenID_playmix", "getDomain_playmix"]), {
    initScrollContent: function initScrollContent() {
      var contentTitle = document.querySelector("#contentTitle");
      var contentPanel = document.querySelector("#contentPanel");

      var scrollCtrl = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Controller({});
      // build tween
      var scrollHeaderTween = __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(contentTitle, 0.5, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Linear"].easeNone
      });
      var scrollHeaderScene = new __WEBPACK_IMPORTED_MODULE_11_scrollmagic___default.a.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300
      }).setTween(scrollHeaderTween)
      // .addIndicators({ name: "1 (duration: 300)" })
      .addTo(scrollCtrl);
    },
    enter: function enter(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].fromTo(el, 1, {
          autoAlpha: 0,
          y: 200
        }, {
          autoAlpha: 1,
          y: 0,
          transformOrigin: "50% 50%",
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          delay: 1,
          onComplete: done
        });
      });
    },
    leave: function leave(el, done) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_10_gsap__["default"].to(el, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_10_gsap__["Power4"].easeOut,
          onComplete: done
        });
      });
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      //set content panel height of detail  page
      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(function () {
          _this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false,
        imagesLoaded: true,
        groupCells: true
      },
      stageDragging: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["main"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
  // "subCate_playmix",
  // "allData_playmix",
  "IconHotpick_playmix", "IconPopular_playmix", "lang_playmix", "country_playmix"
  // "homeSliderContentPlaymix",
  // "hpisLoad_playmix"
  ]),
  mounted: function mounted() {
    // this.fetchHomeHotPick_playmix();
    if (this.$props.main.hotpicks.length !== undefined) {
      this.initHotPicksSlider();
    }
  },
  updated: function updated() {
    if (this.$props.main.dataLoaded === true) {
      this.initHotPicksSlider();
    }
  },

  methods: {
    // ...mapActions(["fetchHomeHotPick_playmix"]),
    initHotPicksSlider: function initHotPicksSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$nextTick(function () {
          var i = 0;
          _this.$refs.hotPicksCarousel.map(function (flktyElm) {
            var flktyBName = "homeHotPlicksSliderflkty" + i;
            i++;

            flktyBName = new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(flktyElm, _this.flickityOptions);
            flktyBName.on("dragStart", function () {
              this.stageDragging = true;
            });
            flktyBName.on("dragEnd", function () {
              this.stageDragging = false;
            });
          });
        });
      }, 0);
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_plyr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_playmix__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomLightbox_vue__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },

  components: {
    CustomLightbox: __WEBPACK_IMPORTED_MODULE_9__CustomLightbox_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_playmix", "host_playmix", "country_playmix"]),
  created: function created() {
    this.getDetails(this.$route.params.id);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["subscribeContent_playmix"]), {
    goBack: function goBack() {
      window.history.back();
    },
    getLanguage: function getLanguage(langt) {
      var _this = this;

      setTimeout(function () {
        if (langt != "") {
          if (langt != "english") {
            if (_this.details["cont_name_" + langt] != "") {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_" + langt];
            } else {
              document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            }

            if (_this.details["desc_" + langt] != "") {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_" + langt] + "</span>";
            } else {
              document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
            }
          } else {
            document.getElementById("cont_name").innerHTML = _this.details["cont_name_english"];
            document.getElementById("description").innerHTML = "<span>" + _this.details["desc_english"] + "</span>";
          }

          var platform = "";
          var plat = __webpack_require__(219)("./" + langt + ".json");
          var file = _this.details.content_detail.split(".");
          if (file[1] == "apk" || _this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = _this.details["titleSub_" + langt];
        }
      }, 0);
    },
    initPlyr: function initPlyr() {
      var vidPlyrr = new __WEBPACK_IMPORTED_MODULE_6_plyr___default.a(document.getElementById("vidPlayer"));
    },
    getDetails: function getDetails(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var live, local;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                live = "http://cook.grabmobi.com";
                local = "http://[::1]/PuretechGlobalContentPortal";


                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(live + "/api/newcontents_statistic", {
                  token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                  country: _this2.country_playmix,
                  product: 'playmix',
                  content_id: id,
                  type: "view"
                });

                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=" + id + "&category=&subcategory=&limit=100&offset=0&domain=" + _this2.host_playmix + "&lang=" + _this2.lang_playmix).then(function (res) {
                  var data = res.data.data[0];

                  var sc = data.screenshot.split(",");
                  var sc_temp = [];
                  for (var i = 0; i < sc.length; i++) {
                    sc_temp.push({ id: i, url: _this2.srcUrl + "/" + data.id + "/" + sc[i] });
                  }

                  data.screenshot = sc_temp;

                  _this2.contentCoverImg = data.cover_img;

                  data.titleSub_english = data.subcategory;

                  if (data.subcategory_translate != null) {
                    var sub_trans = JSON.parse(data.subcategory_translate);
                    var sub_icon = JSON.parse(data.subcategory_icon);

                    var trans_len = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sub_trans);

                    for (var _i = 0; _i < trans_len; _i++) {
                      data["titleSub_" + trans_arr[_i]] = sub_trans[trans_arr[_i]].title;
                    }
                  }

                  setTimeout(function () {
                    _this2.details = data;
                    _this2.isLoad = true;
                    _this2.$nextTick(function () {
                      _this2.initPlyr();
                    });
                  }, 0);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    openBox: function openBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic: function nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic: function prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[this.lightBoxCurrentId].url;
      }
    },
    closeBox: function closeBox() {
      this.lightBoxToggle = false;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var toDepth = to.path.split("/");
      var fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["imgsource", "close", "next", "back"],
  mounted: function mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
});

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = {"browse":"تصفح","hotpicks":"افضل الاختيارات","popular":"رائج حاليا","profile":"الملف الشخصي","downloads":"التحميل","download":"تحميل","play":"العب","notification":"إشعارات","view_more":"شاهد المزيد","main_title":"شاهد التالي","home":"الرئيسية","favorites":"المفضلة","contact":"التواصل","settings":"اعدادات","privacy":"سياسة الخصوصية","terms":"البنود و الشروط","all":"كل","allCategories":"كل مجموعات","categories":"مجموعات","category":"مجموعة","platform":"يدعم","type":"نوع","login":"دخول","logout":"خروج","login_title":"هل اشتركت في Playmix؟","confirmation":"ثم قم بتأكيد رقم هاتفك واحصل على وصول غير محدود إلى جميع خدماتنا!","submit":"تابع","subscribe_messsage":"للاشتراك والحصول على وصول غير محدود، الرجاء الضغط على الزر في الأسفل!","subscribe":"اشتراك","valid_number":"رجاء ادخال الرقم الصحيح!","full_name":"الاسم الكامل","registered_num":"رقم مسجل","registered_email":"بريد الكتروني مسجل","registered_date":"تاريخ التسجيل","hello":"مرحبا","search":"البحث عن فيديو ...","not_subs":"لم اشترك بعد","application":"تطبيقات","game":"ألعاب","video":"فيديوهات","contact_us":"أتصل بنا","subject":"الموضوع","message":"رسالة ","let_us":"أبلغنا عن استفسارك","select_subject":"أختر موضوعا","app_issue":"مشكلة في التطبيق","content":"المحتويات","subscription":"اشتراك","unsubscribe":"إلغاء الاشتراك","not_match":"غير مطابق","feedback":"ملاحظات","feedback_intro":"سنكون ممتنين للغاية إذا تمكنت من توفير بضع دقائق لمساعدتنا على تحسين موقعنا من خلال إكمال هذا الاستبيان القصير.","Overall":"بشكل عام","Usability":"سهولة الاستخدام ","Your Suggestion":"اقتراحاتك","feedback_comment":"رجاء أدخل ملاحظاتك","status":"غير نشط","mobile_computer":"الموبايل والكمبيوتر","no_notification":"لا يوجد إشعارات","android":"أندرويد","next_renew_date":"تاريخ تجديد الاشتراك القادم","subscription_date":"تاريخ الاشتراك","unsubscription":"أنت الأن غير مشترك في خدمة Mobiflix"}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = {"browse":"Преглед","hotpicks":"Горещи снимки","popular":"Популярен","profile":"Профил","downloads":"Изтегляния","download":"Изтегляния","play":"Играй сега","notification":"уведомление","view_more":"Виж повече","main_title":"Гледайте какво следва","home":"У дома","favorites":"Любими","contact":"Контакт","settings":"Настройки","privacy":"Политика за поверителност","terms":"Правила и условия","all":"всичко","allCategories":"Всички категории","categories":"Категории","category":"Категория","platform":"Платформа","type":"Тип","login":"Влизам","logout":"Излез от профила си","login_title":"Абонирани ли сте за Playmix?","confirmation":"След това потвърдете мобилния си номер и получете неограничен достъп до всички наши услуги!","submit":"Изпращане","subscribe_messsage":"За да се абонирате и да получите неограничен достъп, моля, кликнете върху бутона по-долу!","subscribe":"Абонирай се","valid_number":"Моля, въведете валидния номер!!","full_name":"Full Name","registered_num":"Регистриран номерr","registered_email":"Registered Email","registered_date":"Регистрирана дата","hello":"Здравейте","search":"Търсете игри, приложения и т.н. ...","not_subs":"Все още не се абонирайте","application":"Приложение","game":"Игра","video":"Видео","contact_us":"Свържете се с нас","subject":"Предмет","message":"Съобщение","let_us":"Уведомете ни за вашето запитване","select_subject":"Изберете Тема","app_issue":"Издание на приложението","content":"Съдържание","subscription":"Абонамент","unsubscribe":"Отписване","not_match":"Не съответства","feedback":"Обратна връзка","feedback_intro":"Ще бъдем много благодарни, ако можете да пощадите няколко минути, за да ни помогнете да подобрим нашия сайт, като попълним това кратко проучване.","Overall":"Като цяло","Usability":"Използваемост","Your Suggestion":"Вашите предложения","feedback_comment":"Моля, въведете вашите коментари","status":"Неактивно","mobile_computer":"Мобилни и компютърни","no_notification":"Няма известие","android":"Android","next_renew_date":"Следваща дата на подновяване","subscription_date":"Дата на абонамента","unsubscription":"Вече сте отписани от Playmix"}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = {"browse":"Procházet","hotpicks":"Horký výběr","popular":"Oblíbený","profile":"Profil","downloads":"Stahování","download":"Stahování","play":"přehrát","notification":"Oznámení","view_more":"Ukázat více","main_title":"Sledujte, co bude dál","home":"domácnost","favorites":"Oblíbené","contact":"Kontakt","settings":"Nastavení","privacy":"Zásady ochrany osobních údajů","terms":"Všeobecné obchodní podmínky","all":"Všechno","allCategories":"Všechny kategorie","categories":"Kategorie","category":"Kategorie","platform":"Plošina","type":"typ","login":"přihlášení","logout":"odhlásit se","login_title":"Jste přihlášeni k odběru Playmix?","confirmation":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim službám!","submit":"Předložit","subscribe_messsage":"Chcete-li se přihlásit k odběru a získat neomezený přístup, klikněte na tlačítko níže!","subscribe":"předplatit","valid_number":"prosím zadejte platné číslo!","full_name":"Celé jmén","registered_num":"registrované číslo","registered_email":"registrovaný email","registered_date":"datum registrace","hello":"Haló!","search":"Hledat videa...","not_subs":"Ještě nejste přihlášenit","application":"přihláška","game":"hra","video":"Video","contact_us":"kontaktujte nás","subject":"předmět","message":"zpráva","let_us":"Dejte nám vědět o vašem dotazu","select_subject":"Vyberte předmět","app_issue":"problém s aplikac","content":"obsah","subscription":"předplatn","unsubscribe":"Odhlásit odběr","not_match":"neodpovídá","feedback":"zpětná vazba","feedback_intro":"Byli bychom velmi vděční, kdybyste ušetřili několik minut a pomohli nám vylepšit naše stránky vyplněním tohoto krátkého průzkumu.","Overall":"celkově","Usability":"Použitelnost","Your Suggestion":"Tvoje návrhy","feedback_comment":"Zadejte své komentáře","status":"Neaktivní","mobile_computer":"Mobilní a počítačový","no_notification":"Žádné oznámenín","android":"Android","next_renew_date":"Datum dalšího obnovení","subscription_date":"Datum předplatného","unsubscription":"Nyní jste odhlášeni z Playmixu"}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = {"browse":"Gennemse","hotpicks":"Hot Picks","popular":"Populær","profile":"Profil","downloads":"Downloads","download":"Download","play":"Spil","notification":"Notifikation","view_more":"Se mere","main_title":"se hvad der er næste","home":"Hjem","favorites":"Foretrukne","contact":"Kontakt","settings":"Indstillinger","privacy":"Fortrolighedspolitik","terms":"Vilkår og Betingelser","all":"Alle","allCategories":"alle kategorier","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Log på","logout":"Log ud","login_title":"Abonnerer du på Playmix?","confirmation":"Bekræft derefter dit mobilnummer, og få ubegrænset adgang til alle vores tjenester!","submit":"Indsend","subscribe_messsage":"Klik på nedenstående knap for at abonnere og få ubegrænset adgang!","subscribe":"Abonner","valid_number":"Indsæt venligst det gyldige nummer!","full_name":"Fulde navn","registered_num":"Registreret nummer","registered_email":"registreret email","registered_date":"Registreret dato","hello":"Hej","search":"Søg efter spil, apps osv ...","not_subs":"Ikke abonner endnut","application":"Ansøgning","game":"Spil","video":"Video","contact_us":"Kontakt os","subject":"Emne","message":"Besked","let_us":"Fortæl os om din forespørgsel","select_subject":"Vælg emne","app_issue":"App-udgave","content":"Indhold","subscription":"Abonnement","unsubscribe":"Opsige abonnement","not_match":"Passer ikke sammen","feedback":"Feedback","feedback_intro":"Vi ville være meget taknemmelige, hvis du kunne spare nogle få minutter til at hjælpe os med at forbedre vores side ved at udfylde denne korte undersøgelse.","Overall":"samlet set","Usability":"Anvendelighed","Your Suggestion":"Dine forslag","feedback_comment":"Indtast venligst dine kommentarer","status":"Inaktiv","mobile_computer":"Mobil og computer","no_notification":"No Notifikation","android":"Android","next_renew_date":"Næste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nu på Playmix"}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Watch what's next","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Playmix?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Videos...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Playmix"}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Watch what's next","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Playmix?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Videos...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Playmix"}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = {"browse":"Ξεφυλλίζω","hotpicks":"Hot επιλογές","popular":"Δημοφιλής","profile":"Προφίλ","downloads":"Λήψεις","download":"Λήψεις","notification":"Ειδοποίηση","play":"Αναπαραγωγή","view_more":"Δείτε περισσότερα","main_title":"Δείτε τι έρχεται","home":"Σπίτι","favorites":"Αγαπημένα","contact":"Επικοινωνία","settings":"Ρυθμίσεις","privacy":"Πολιτική Απορρήτου","terms":"όροι και Προϋποθέσεις","all":"Ολα","allCategories":"Όλες οι κατηγορίες","categories":"Κατηγορίες","category":"Κατηγορία","platform":"Πλατφόρμα","type":"Τύπος","login":"Σύνδεση","logout":"Αποσύνδεση","login_title":"Είστε εγγεγραμμένος στο Mobiflix?","confirmation":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και λάβετε απεριόριστη πρόσβαση σε όλες τις υπηρεσίες μας!","submit":"Υποβολή","valid_number":"Παρακαλώ Εισαγάγετε τον έγκυρο αριθμό!","full_name":"Πλήρες όνομα","registered_num":"καταχωρημένο αριθμό","registered_email":"Καταχωρημένη ηλεκτρονικη διευθυνση","registered_date":"καταχωρημένη ημερομηνία","hello":"Γεια σου","search":"Αναζητήστε Βίντεο","not_subs":"Δεν Εγγραφή ακόμα","Action Games":"Action Games","Puzzle Game":"Παζλ","Sport Games":"Sport Games","contact_us":"Επικοινωνήστε μαζί μας","subject":"Επικοινωνήστε μαζί μας","message":"Μήνυμα","let_us":"Πείτε μας την ερώτηση σας","select_subject":"Επιλογή Θέματος","app_issue":"Πρόβλημα Εφαρμογής","content":"Περιεχόμενο","subscription":"Εγγραφή","unsubscribe":"Απεγγραφή","not_match":"Δεν Ταιριάζει","feedback":"Σχόλια","feedback_intro":"Θα εκτιμούσαμε ιδιαίτερα αν θα μπορούσατε να αφιερώσετε μερικά λεπτά για να μας βοηθήσετε να βελτιώσουμε την ιστοσελίδα μας, συμπληρώνοντας το σύντομο ερωτηματολόγιο","Overall":"Συνολικά","Usability":"Χρηστικότητα","Your Suggestion":"Οι προτάσεις σας","feedback_comment":"Παρακαλούμε εισάγετε τα σχόλια σας","status":"Ανενεργό","mobile_computer":"Κινητό και Υπολογιστή","no_notification":"καμία ειδοποίηση","android":"Android","next_renew_date":"Επόμενη ανανέωση συνδρομής","subscription_date":"Ημερομηνία εγγραφής"}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = {"browse":"Jelajah","hotpicks":"Pilihan yang terbanyak","popular":"Populer","profile":"Profil","downloads":"Unduh","download":"Unduh","play":"Main","notification":"Notifikasi","view_more":"Lihat lebih banyak","main_title":"Tonton Selanjutnya","home":"Halaman Utama","favorites":"Kesukaan","contact":"Kontak","settings":"Pengaturan","privacy":"Kebijakan Privasi","terms":"Syarat & Ketentuan","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Tipe","login":"Log Masuk","logout":"Keluar","login_title":"Sudah langgan Playmix?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Kirimkan","valid_number":"Silakan masukkan nomor yang sah!","full_name":"Nama lengkap","registered_num":"Nomor Terdaftar","registered_email":"Email Terdaftar","registered_date":"Tanggal Terdaftar","hello":"Hello","search":"Cari Video...","not_subs":"Belum Berlangganan","contact_us":"Hubungi Kami","subject":"Subjek","message":"Pesan","let_us":"Mohon diinfokan permintaan anda","select_subject":"Pilih Subjek","app_issue":"Masalah Aplikasi","content":"Kandungan","subscription":"Berlangganan","unsubscribe":"Berhenti Berlangganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami Akan Sangat Bersyukur Jika Anda Dapat Menyisihkan Beberapa Menit Untuk Membantu Kami Meningkatkan Situs Kami Dengan Melengkapi Survei Singkat Ini.","Overall":"Secara keseluruhan","Usability":"Kegunaan","Your Suggestion":"Saran Anda","feedback_comment":"Silakan Masukkan Komentar Anda","status":"Non-aktif","mobile_computer":"Ponsel dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tanggal Pembaruan Selanjutnya","subscription_date":"Tanggal Berlangganan"}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = {"browse":"Layari","hotpicks":"Pilihan Hangat","popular":"Popular","profile":"Profil","downloads":"Muat Turun","download":"Muat Turun","play":"Main","notification":"Notifikasi","view_more":"Lihat lagi","main_title":"Tonton Yang Seterusnya","home":"Halaman Utama","favorites":"Kegemaran","contact":"Hubungi","settings":"Tetapan","privacy":"Dasar Privasi","terms":"Terma & Syarat","all":"Semua","allCategories":"Semua Kategori","categories":"Kategori","category":"Kategori","platform":"Platform","type":"Jenis","login":"Log Masuk","logout":"Log Keluar","login_title":"Sudah melanggan Playmix?","confirmation":"Kemudian sahkan nombor telefon bimbit anda dan dapatkan akses tanpa had ke semua perkhidmatan kami!","submit":"Hantar","valid_number":"Sila masukkan nombor yang sah!","full_name":"Nama penuh","registered_num":"Nombor berdaftar","registered_email":"E-mel yang didaftarkan","registered_date":"Tarikh Berdaftar","hello":"Hello","search":"Cari Video...","not_subs":"Belum Melanggan","application":"Applikasi","game":"Permainan","video":"Video","contact_us":"Hubungi Kami","subject":"Subjek","message":"Mesej","let_us":"Nyatakan kepada kami tentang persoalan anda","select_subject":"Pilih Subjek","app_issue":"Isu App","content":"Kandungan","subscription":"Langganan","unsubscribe":"Hentikan Langganan","not_match":"Tidak Padan","feedback":"Maklum Balas","feedback_intro":"Kami sangat berbesar hati jika anda meluangkan sedikit masa untuk membantu kami meningkatkan laman web kami dengan melengkapkan kaji selidik ringkas ini.","Overall":"Keseluruhan","Usability":"Kebolehgunaan","Your Suggestion":"Cadangan Anda","feedback_comment":"Sila masukkan komen anda","status":"Tidak Aktif","mobile_computer":"Telefon dan Komputer","no_notification":"Tiada Notifikasi","android":"Android","next_renew_date":"Tarikh Pembaharuan Seterusnya","subscription_date":"Tarikh Langganan"}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = {"browse":"Bla gjennom","hotpicks":"Populære valg","popular":"Populær","profile":"Profil","downloads":"Nedlastinger","download":"Nedlastinger","play":"Leke nå","notification":"melding","view_more":"Se mer","main_title":"Se hva som er neste","home":"Hjem","favorites":"Favoritter","contact":"Ta kontakt med","settings":"Innstillinger","privacy":"Personvernregler","terms":"Betingelser og vilkår","all":"Alle","allCategories":"All Categories","categories":"Kategorier","category":"Kategori","platform":"Platform","type":"Type","login":"Logg Inn","logout":"Logg ut","login_title":"Abonnerer på Playmix?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"sende inn","subscribe_messsage":"For å abonnere og få ubegrenset tilgang, vennligst klikk på knappen nedenfor!","subscribe":"Abonnere","valid_number":"Vennligst sett inn gyldig nummer!","full_name":"Fullt navn","registered_num":"Registrert nummer","registered_email":"Registrert E-post","registered_date":"Registrert dato","hello":"Hallo","search":"Søk etter spill, apper osv...","not_subs":"Ikke abonner ennå","application":"applikasjon","game":"Spill","video":"Video","contact_us":"Kontakt oss","subject":"Emne","message":"Beskjed","let_us":"Gi oss beskjed om din henvendelse","select_subject":"Velg Emne","app_issue":"App Issue","content":"Innhold","subscription":"Abonnement","unsubscribe":"Avslutte abonnementet","not_match":"Ikke Match","feedback":"Tilbakemelding","feedback_intro":"Vi ville være veldig takknemlige hvis du kunne spare noen få minutter for å hjelpe oss med å forbedre nettstedet vårt ved å fullføre denne korte undersøkelsen.","Overall":"Alt i alt","Usability":"Brukervennlighet","Your Suggestion":"Dine forslag","feedback_comment":"Vennligst skriv inn dine kommentarer","status":"Inaktiv","mobile_computer":"mobil og datamaskin","no_notification":"Ingen varsling","android":"Android","next_renew_date":"Neste fornyelsesdato","subscription_date":"Abonnementsdato","unsubscription":"Du abonnerer nå på Playmix"}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Watch what's next","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Playmix?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Videos...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Playmix"}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = {"browse":"Prechádzať","hotpicks":"Horúce tipy","popular":"Populárne","profile":"Profil","downloads":"K stiahnutiu","download":"Stiahnuť ▼","play":"hrať","notification":"Oznámenie","view_more":"Vidieť viac","main_title":"Sledujte, čo ďalej","home":"Domov","favorites":"Obľúbené","contact":"Kontakt","settings":"nastavenie","privacy":"Zásady ochrany osobných údajov","terms":"podmienky","all":"Všetky","allCategories":"Všetky kategórie","categories":"Kategórie","category":"Kategória","platform":"Plošina","type":"Typ","login":"Prihlásiť sa","logout":"Odhlásiť sa","login_title":"Prihlásili ste sa na odber Playmix?","confirmation":"Potom potvrďte svoje mobilné číslo a získajte neobmedzený prístup ku všetkým našim službám!","submit":"Predložiť","valid_number":"Zadajte platné číslo!","full_name":"Celé meno","registered_num":"Registračné číslo","registered_email":"registrovaný email","registered_date":"Dátum registrácie","hello":"Ahoj","search":"Vyhľadajte hry, aplikácie atď.","not_subs":"Zatiaľ nie ste prihlásení na odber","application":"Aplikácia","game":"Hra","video":"Video","contact_us":"Kontaktuj nás","subject":"Predmet","message":"Správa","let_us":"Dajte nám vedieť o vašej požiadavke","select_subject":"Vyberte Predmet","app_issue":"Vydanie aplikácie","content":"Obsah","subscription":"Predplatné","unsubscribe":"Odhlásiť sa","not_match":"Nezhoduje sa","feedback":"Spätná väzba","feedback_intro":"Boli by sme veľmi vďační, keby ste nám mohli ušetriť pár minút a pomohli nám tak vylepšiť našu stránku vyplnením tohto krátkeho prieskumu.","Overall":"Celkovo","Usability":"Použiteľnosť","Your Suggestion":"Vaše návrhy","feedback_comment":"Zadajte svoje pripomienky","status":"Neaktívne","mobile_computer":"Mobilné a počítačové","android":"Android","no_notification":"No Oznámenie","next_renew_date":"Nasledujúci dátum obnovenia","subscription_date":"Dátum predplatného","unsubscription":"Teraz ste odhlásení z odberu Playmix","subscribe_messsage":"Ak sa chcete prihlásiť na odber a získať neobmedzený prístup, kliknite na tlačidlo nižšie!","subscribe":"Prihlásiť sa na odber"}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = {"browse":"Browse","hotpicks":"Hot Picks","popular":"Popular","profile":"Profile","downloads":"Downloads","download":"Download","play":"Play Now","notification":"Notification","view_more":"View more","main_title":"Watch what's next","home":"Home","favorites":"Favorites","contact":"Contact","settings":"Settings","privacy":"Privacy Policy","terms":"Terms & Conditions","all":"All","allCategories":"All Categories","categories":"Categories","category":"Category","platform":"Platform","type":"Type","login":"Login","logout":"Logout","login_title":"Subscribed to Playmix?","confirmation":"Then confirm your mobile number and get unlimited access to all our services!","submit":"Submit","subscribe_messsage":"To subscribe and get unlimited access, please click on the below button!","subscribe":"Subscribe","valid_number":"Please insert the valid number!","full_name":"Full Name","registered_num":"Registered Number","registered_email":"Registered Email","registered_date":"Registered Date","hello":"Hello","search":"Search for Videos...","not_subs":"Not Subscribe yet","application":"Application","game":"Game","video":"Video","contact_us":"Contact Us","subject":"Subject","message":"Message","let_us":"Let us know about your enquiry","select_subject":"Select Subject","app_issue":"App Issue","content":"Content","subscription":"Subscription","unsubscribe":"Unsubscribe","not_match":"Not Match","feedback":"Feedback","feedback_intro":"We Would Be Very Greatful If You Could Spare A Few Minutes To Help Us Improve Our Site By Completing This Short Survey.","Overall":"Overall","Usability":"Usability","Your Suggestion":"Your Suggestions","feedback_comment":"Please Enter Your Comments","status":"Inactive","mobile_computer":"Mobile and Computer","no_notification":"No notification","android":"Android","next_renew_date":"Next Renewal Date","subscription_date":"Subscription Date","unsubscription":"You are now unsubscribed from Playmix"}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = {"browse":"การค้นหา","hotpicks":"ถูกเลือกใช้มากที่สุด","popular":"ยอดนิยม","profile":"โปร์ไฟล์","downloads":"ดาวน์โหลด","download":"ดาวน์โหลด","play":"เล่น","notification":"การแจ้งเตือน","view_more":"ดูเพิ่มเติม","main_title":"ดูวิดีโอถัดไป","home":"หน้าหลัก","favorites":"รายการโปรด","contact":"ติดต่อ","settings":"ตั้งค่า","privacy":"นโยบายความเป็นส่วนตัว","terms":"ข้อตกลงและเงื่อนไข","all":"ทั้งหมด","allCategories":"หมวดหมู่ทั้งหมด","categories":"หมวดหมู่","category":"ประเภท","platform":"เวที","type":"ชนิด","login":"เข้าสู่ระบบ","logout":"ออกจากระบบ","login_title":"สมัคร Playmix?","confirmation":"กรอกหมายเลขมือถือของคุณและดูดวงได้ไม่จำกัด","submit":"ส่ง","valid_number":"กรุณาใส่หมายเลขที่ถูกต้อง!","full_name":"ชื่อเต็ม","registered_num":"หมายเลขโทรศัพท์ที่ลงทะเบียน","registered_email":"อีเมลที่ลงทะเบียน","registered_date":"วันที่ลงทะเบียน","hello":"สวัสดี","search":"ค้นหาวิดีโอ...","not_subs":"ยังไม่ได้สมัคร","contact_us":"ติดต่อเรา","subject":"หัวข้อ","message":"ข้อความ","let_us":"บอกเราว่าคุณมีเรื่องอะไรจะสอบถาม","select_subject":"เลือกหัวข้อ","app_issue":"เรื่องแอพลิเคชั่น","content":"เนื้อหา","subscription":"สมัครสมาชิก","unsubscribe":"ยกเลิกมาชิก","not_match":"ไม่ตรงกัน","feedback":"ข้อเสนอแนะ","feedback_intro":"เรารู้สึกขอบคุณอย่างมากที่ท่านสละเวลาในกาทำแบบสอบถามของเรา","Overall":"ทั้งหมด","Usability":"มีประโยชน์","Your Suggestion":"ข้อเสนอแนะของคุณ","feedback_comment":"กรุณาพิมพ์ข้อเสนอแนะของคุณ","status":"ไม่ได้ใช้งาน","mobile_computer":"โทรศัพท์มือถือและคอมพิวเตอร์","no_notification":"ไม่มีการแจ้งเตือน","android":"แอนดรอยด์","next_renew_date":"วันที่ต่ออายุครั้งต่อไป","subscription_date":"วันที่สมัครสมาชิก"}

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["msisdn_playmix", "renew_date_playmix", "subscription_date_playmix", "authentication_playmix", "is_unsub_playmix"]),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout_playmix"]))
});

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["lang_playmix", "country_playmix", "host_playmix"]),
  created: function created() {
    //replace '_' with blank space\
    var subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    // let e = undefined;
    this.getSubContent(this.$route.params.subcategory);
  },
  updated: function updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },

  methods: {
    getSubContent: function getSubContent(subcategory) {
      var _this = this;

      var limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      var live = "http://cook.grabmobi.com/";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcategory + "&limit=100&offset=0&domain=" + this.host_playmix + "&lang=" + this.lang_playmix).then(function (res) {
        var data = res.data.data;

        _this.data = data;
        _this.isLoad = true;
      }).catch(function (err) {
        // console.log(err);
      });
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;
      hotpick.map(function (item) {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: "",
      isLoad: false
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  props: ["browse"],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["HotPicksPage_playmix", "IconHotpick_playmix", "lang_playmix", "HotPicksPageLoad_playmix"]),
  created: function created() {
    this.isLoad = false;
    this.fetchPageHotPicks_playmix([this.$route.query.q]);
    this.getHotPicks();
  },
  updated: function updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_playmix([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["fetchPageHotPicks_playmix"]), {
    getHotPicks: function getHotPicks() {
      var _this = this;

      var hotpick = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.HotPicksPage_playmix));
      var hot = [];
      hotpick.map(function (item) {
        item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        hot.push(item);
      });
      setTimeout(function () {
        _this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory: function getSubCategory(subcategory, lang) {
      var cat_translate = [];
      var hotpick = this.$props.browse.category;

      hotpick.map(function (item) {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item["title_" + lang]);
          } else {
            cat_translate.push(item["title_english"]);
          }
        }
      });

      return cat_translate[0];
    }
  })
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Vue.component("star-rating", VueStarRating.default);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["PopularPage_playmix", "IconPopular_playmix", "lang_playmix"]),
  created: function created() {
    this.fetchPagePopular_playmix();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchPagePopular_playmix"]))
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["lang_playmix", "gcid_playmix", "country_playmix"])
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      isAoc: false
    };
  },
  created: function created() {
    this.getPrefix(this.country_playmix);
    if (this.gcid_playmix === "289" || this.gcid_playmix === "290" || this.gcid_playmix === "291" || this.gcid_playmix == "299") {
      this.isAoc = true;
    }
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["lang_playmix", "gcid_playmix", "country_playmix", "gateway_playmix"]),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getPrefix: function getPrefix(country) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (country == key) {
            this.msisdn = "+" + value.prefix;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    close: function close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    consent_gateway: function consent_gateway() {
      if (this.gcid_playmix == "289") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2641&aff_id=217&aff_sub5=test";
      } else if (this.gcid_playmix == "290") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2642&aff_id=217&aff_sub5=test";
      } else if (this.gcid_playmix == "291") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2643&aff_id=217&aff_sub5=test";
      } else if (this.gcid_playmix == "299") {
        window.location = "https://www.mobiflix.vip/campaign/click.php?offer_id=2735&aff_id=217&aff_sub5=test";
      } else {
        alert("Invalid GCID");
      }
    },
    login: function login() {
      var _this = this;

      var regex = /^\d{9,}$/;
      var a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          var gcid = "";
          if (this.gcid_playmix != "") {
            gcid = this.gcid_playmix;
          } else {
            gcid = "264";
          }

          var data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          var login = {
            url: "" + proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=" + data.msisdn + "&gcid=" + data.gcid + "&verbose=" + data.verbose),
            method: "POST"
          };
          this.$axios(login).then(function (res) {
            var response = JSON.parse(res.data.contents);
            if (response.status == "active") {
              localStorage.setItem("userTokenID_playmix", response.token);
              localStorage.setItem("userProfile_playmix", res.data.contents);
              _this.msisdn = "";
              // this.emitMethod();
              _this.login_playmix("loggedin");
              __WEBPACK_IMPORTED_MODULE_5__router_mobiflix__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
              location.reload();
            } else if (response.status == "inactive") {
              _this.showStatusAlert = true;
              _this.showMsisdnAlert = false;
              var status = response.status.replace(response.status.toUpperCase());
              _this.status = status;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__locales_country_list_json___default.a)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                  var key = _ref4[0];
                  var value = _ref4[1];

                  if (_this.country_playmix == key) {
                    var status_lang = __webpack_require__(121)("./" + value.language + ".json");
                    _this.statusTran = status_lang.status;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }).catch(function (err) {
            console.error(err);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["login_playmix"]))
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["lang_playmix", "country_playmix"]),
  components: {
    'privacy-english': __WEBPACK_IMPORTED_MODULE_0__PrivacyPolicyEnglish__["a" /* default */],
    'privacy-arabic': __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyArabic__["a" /* default */],
    'privacy-malay': __WEBPACK_IMPORTED_MODULE_2__PrivacyPolicyMalay__["a" /* default */],
    'privacy-greek': __WEBPACK_IMPORTED_MODULE_3__PrivacyPolicyGreek__["a" /* default */],
    'privacy-czech': __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicyCzech__["a" /* default */],
    'privacy-bulgarian': __WEBPACK_IMPORTED_MODULE_5__PrivacyPolicyBulgarian__["a" /* default */],
    'privacy-norwegian': __WEBPACK_IMPORTED_MODULE_6__PrivacyPolicyNorwegian__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__playmix_Search_vue__ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__playmix_Notification_vue__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["browse"],
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_2__playmix_Search_vue__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_3__playmix_Notification_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["langButton_playmix", "lang_playmix", "authentication_playmix", "country_playmix", "is_unsub_playmix"]),
  mounted: function mounted() {
    var _this = this;

    this.fetchLangButton_playmix(this.country_playmix);
    var btnLang1 = document.getElementById("lang1");
    var btnLang2 = document.getElementById("lang2");

    var notificationIcon = document.getElementById("notificationIcon");
    var notificationPanel = document.getElementById("notification");

    if (this.lang_playmix == "english") {
      if (this.country_playmix != "ke" && this.country_playmix != "ke1") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_playmix != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = "english";
      _this.fetchLang_playmix(lang);
      localStorage.setItem("lang_playmix", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      window.location.reload();
    });

    btnLang2.addEventListener("click", function (e) {
      var lang = e.target.getAttribute("lang");
      _this.$i18n.locale = lang;
      _this.fetchLang_playmix(lang);
      localStorage.setItem("lang_playmix", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
      window.location.reload();
    });

    // notification
    notificationIcon.addEventListener("click", function (e) {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", function (event) {
      var isClickedInside = notificationPanel.contains(event.target) || notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(function () {
      _this.intiSideMenu();
      _this.initTopNavScroll();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["fetchLang_playmix", "fetchLangButton_playmix", "logout_playmix"]), {
    // getclick() {
    //   location.reload();
    // },
    intiSideMenu: function intiSideMenu() {
      // init mobile menu
      var mobileLinks = document.querySelectorAll(".browse_link");
      var menuIcons = document.querySelectorAll(".menuIcon");
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(menuIcons).map(function (elm) {
        menuIcons[elm].addEventListener("click", function () {
          document.body.classList.toggle("mobile--active");
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mobileLinks).map(function (elm) {
        mobileLinks[elm].addEventListener("click", function () {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll: function initTopNavScroll() {
      var navbar = document.getElementById("navigation");

      document.getElementsByTagName("html")[0].addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        var hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout: function logout() {
      localStorage.removeItem("userTokenID_playmix");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  }),
  watch: {
    $route: function $route(to, from) {
      // if(from.name == "Category" && to.name == "Category"){
      //   location.reload();
      // }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["lang_playmix", "host_playmix"]),
  mounted: function mounted() {
    var _this = this;

    //search ani timeline instance
    var navigation = document.getElementsByClassName("navigation")[0];
    var widthToExp = navigation.getBoundingClientRect().width - 180;
    var searchSuggestion = document.getElementById("searchSuggestion");
    var mobiSearchWrap = document.getElementById("mobiSearchWrap"),
        backdrop = document.getElementById("backdrop");

    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", function (e) {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        _this.search_input = "";
        _this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        _this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        _this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", function (e) {
      _this.search_input = "";
      _this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      _this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },

  methods: {
    initSearchAnimation: function initSearchAnimation(widthToExp) {
      this.searchAniTl = __WEBPACK_IMPORTED_MODULE_4_gsap__["default"].timeline({ paused: true });
      this.searchAniTl.to("#logo", { display: "none" }).to(".mobiSearch__input", {
        duration: 0.4,
        width: widthToExp,
        opacity: 1,
        visibility: "visible",
        ease: "back.inOut(1.4)"
      }).to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search: function search(input) {
      var _this2 = this;

      var autoComplete = document.getElementById("auto_result");
      var searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        var live = "http://cook.grabmobi.com";
        var local = "http://[::1]/PuretechGlobalContentPortal";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(live + "/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=" + input + "&domain=" + this.host_playmix).then(function (res) {
          var search = res.data.data;
          var count = 0;
          var z = [];

          var item_search = search.filter(function (item) {
            return item.category_id == "3";
          });

          for (var i = 0; i < item_search.length; i++) {
            if (count <= 10) {
              _this2.count = count;
              z.push(item_search[i]);
            }
            count++;
          }

          _this2.result_search = z;
          var not_match = __webpack_require__(219)("./" + _this2.lang_playmix + ".json");

          if (z.length < 1) {
            //if the input not match with the data
            searchSuggestion.style.display = "block";
            searchSuggestion.innerHTML = not_match["not_match"];
          }

          var res_search = [];
          var bold = [];
          var icon = "";
          for (var _i = 0; _i < z.length; _i++) {
            searchSuggestion.style.display = "none";
            searchSuggestion.innerHTML = "";

            var icon_class = [];
            if (z[_i].class_icon != null) {
              icon_class = JSON.parse(z[_i].class_icon);
            } else {
              icon_class = null;
            }

            if (icon_class != null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon_class)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _ref = _step.value;

                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                  var key = _ref2[0];
                  var value = _ref2[1];

                  if (key == "mobiflix.vip") {
                    icon = icon_class[key]["class"];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
            //to show the bold text
            var rs = z[_i].content_name;

            var t_char = rs.search(rgxp) + input.length;
            var re = rs.substring(rs.search(rgxp), t_char);
            var str = rs.replace(rgxp, "<b><i>" + re + "</i></b>");
            res_search.push(str);
            var r = res_search[_i].replace(res_search[_i], "<span class=\"" + icon + "\">" + res_search[_i] + "</span> ");

            bold.push(r);
            _this2.icon_bold = bold;
          }
        }).catch(function (err) {
          //console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["notification_playmix", "lang_playmix", "country_playmix"])),
  created: function created() {
    this.fetchNotification_playmix();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["fetchNotification_playmix"]))
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventsource_polyfill__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventsource_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eventsource_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_plyr__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_plyr_dist_vue_plyr_css__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_plyr_dist_vue_plyr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_plyr_dist_vue_plyr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mobiscope__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_mobiscope__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Mobizone__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Games4all__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_games4all__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Mobiflix__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_mobiflix__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Miximo__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_miximo__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Gameknight__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_gameknight__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Gameonz__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_gameonz__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FunPlus__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router_funplus__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GameBox__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__router_gamebox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Prizeo__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__router_prizeo__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Fun2win__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__router_fun2win__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Cutemobi__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__router_cutemobi__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Cutehub__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__router_cutehub__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Apps4all__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__router_apps4all__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Playmix__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__router_playmix__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__HelloWorld_vue__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__i18n_mobizone_i18n__ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__i18n_mobiscope_i18n__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__i18n_games4all_i18n__ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__i18n_mobiflix_i18n__ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__i18n_miximo_i18n__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__i18n_gameknight_i18n__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__i18n_gameonz_i18n__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__i18n_funplus_i18n__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__i18n_gamebox_i18n__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__i18n_prizeo_i18n__ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__i18n_fun2win_i18n__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__i18n_cutemobi_i18n__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__i18n_cutehub_i18n__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__i18n_apps4all_i18n__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__i18n_playmix_i18n__ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_vue_resource__ = __webpack_require__(2481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__store_index__ = __webpack_require__(2483);
//The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';




//template and route

































//locales or translate use i18n
//i18n is for locales translate
















//others




var proxyurl = "https://cors-anywhere.herokuapp.com/";

//default url for login
__WEBPACK_IMPORTED_MODULE_51_axios___default.a.defaults.baseURL = proxyurl + "http://cook.gateway.puretechglobal.net/gateway_request/api/sub/";

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_50_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_plyr__["a" /* default */]);

var host = window.location.host;
var template = "";

if (host.includes("mobizone")) {
  template = "Mobizone";
} else if (host.includes("mobiscope")) {
  template = "Mobiscope";
} else if (host.includes("games4all")) {
  template = "Games4all";
} else if (host.includes("mobiflix")) {
  template = "Mobiflix";
} else if (host.includes("miximo")) {
  template = "Miximo";
} else if (host.includes("gameknight")) {
  template = "Gameknight";
} else if (host.includes("gameonz")) {
  template = "Gameonz";
} else if (host.includes("funplus")) {
  template = "FunPlus";
} else if (host.includes("gamebox")) {
  template = "GameBox";
} else if (host.includes("fun2win")) {
  template = "Fun2win";
} else if (host.includes("prizeo")) {
  template = "Prizeo";
} else if (host.includes("cutemobi")) {
  template = "Cutemobi";
} else if (host.includes("cutehub")) {
  template = "Cutehub";
} else if (host.includes("apps4all")) {
  template = "Apps4all";
} else if (host.includes("playmix")) {
  template = "Playmix";
} else {
  template = "HelloWorld";
}

var domainLength = 3; // route1.example.com => domain length = 3

function getComp() {
  switch (template) {
    case "Mobiscope":
      document.getElementById("favicon").href = __webpack_require__(2518);
      return { component: { Mobiscope: __WEBPACK_IMPORTED_MODULE_4__Mobiscope__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_5__router_mobiscope__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_36__i18n_mobiscope_i18n__["a" /* default */] };
      break;
    case "Mobizone":
      document.getElementById("favicon").href = __webpack_require__(2519);
      return { component: { Mobizone: __WEBPACK_IMPORTED_MODULE_6__Mobizone__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_7__router_mobizone__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_35__i18n_mobizone_i18n__["a" /* default */] };
      break;
    case "Games4all":
      document.getElementById("favicon").href = __webpack_require__(2520);
      return { component: { Games4all: __WEBPACK_IMPORTED_MODULE_8__Games4all__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_9__router_games4all__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_37__i18n_games4all_i18n__["a" /* default */] };
      break;
    case "Mobiflix":
      document.getElementById("favicon").href = __webpack_require__(2521);
      return { component: { Mobiflix: __WEBPACK_IMPORTED_MODULE_10__Mobiflix__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_11__router_mobiflix__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_38__i18n_mobiflix_i18n__["a" /* default */] };
      break;
    case "Miximo":
      document.getElementById("favicon").href = __webpack_require__(2522);
      return { component: { Miximo: __WEBPACK_IMPORTED_MODULE_12__Miximo__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_13__router_miximo__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_39__i18n_miximo_i18n__["a" /* default */] };
      break;
    case "Gameknight":
      document.getElementById("favicon").href = __webpack_require__(2523);
      return { component: { Gameknight: __WEBPACK_IMPORTED_MODULE_14__Gameknight__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_15__router_gameknight__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_40__i18n_gameknight_i18n__["a" /* default */] };
      break;
    case "Gameonz":
      document.getElementById("favicon").href = __webpack_require__(2524);
      return { component: { Gameonz: __WEBPACK_IMPORTED_MODULE_16__Gameonz__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_17__router_gameonz__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_41__i18n_gameonz_i18n__["a" /* default */] };
      break;
    case "FunPlus":
      document.getElementById("favicon").href = __webpack_require__(2525);
      return { component: { FunPlus: __WEBPACK_IMPORTED_MODULE_18__FunPlus__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_19__router_funplus__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_42__i18n_funplus_i18n__["a" /* default */] };
      break;
    case "GameBox":
      document.getElementById("favicon").href = __webpack_require__(2526);
      return { component: { GameBox: __WEBPACK_IMPORTED_MODULE_20__GameBox__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_21__router_gamebox__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_43__i18n_gamebox_i18n__["a" /* default */] };
      break;
    case "Prizeo":
      document.getElementById("favicon").href = __webpack_require__(2527);
      return { component: { Prizeo: __WEBPACK_IMPORTED_MODULE_22__Prizeo__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_23__router_prizeo__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_44__i18n_prizeo_i18n__["a" /* default */] };
      break;
    case "Fun2win":
      document.getElementById("favicon").href = __webpack_require__(2528);
      return { component: { Fun2win: __WEBPACK_IMPORTED_MODULE_24__Fun2win__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_25__router_fun2win__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_45__i18n_fun2win_i18n__["a" /* default */] };
      break;
    case "Cutemobi":
      document.getElementById("favicon").href = __webpack_require__(2529);
      return { component: { Cutemobi: __WEBPACK_IMPORTED_MODULE_26__Cutemobi__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_27__router_cutemobi__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_46__i18n_cutemobi_i18n__["a" /* default */] };
      break;
    case "Cutehub":
      document.getElementById("favicon").href = __webpack_require__(2530);
      return { component: { Cutehub: __WEBPACK_IMPORTED_MODULE_28__Cutehub__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_29__router_cutehub__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_47__i18n_cutehub_i18n__["a" /* default */] };
      break;
    case "Apps4all":
      document.getElementById("favicon").href = __webpack_require__(2531);
      return { component: { Apps4all: __WEBPACK_IMPORTED_MODULE_30__Apps4all__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_31__router_apps4all__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_48__i18n_apps4all_i18n__["a" /* default */] };
      break;
    case "Playmix":
      document.getElementById("favicon").href = __webpack_require__(2532);
      return { component: { Playmix: __WEBPACK_IMPORTED_MODULE_32__Playmix__["a" /* default */] }, route: __WEBPACK_IMPORTED_MODULE_33__router_playmix__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_49__i18n_playmix_i18n__["a" /* default */] };
      break;
    default:
      return { component: { HelloWorld: __WEBPACK_IMPORTED_MODULE_34__HelloWorld_vue__["a" /* default */] }, route: "", i18n: "" };
      break;
  }
}

// next try
// case "Gameonz":
//       return {'component': { Gameonz },'route': gameonz}
//       break;

//change document title
document.title = template;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: "#app",
  store: __WEBPACK_IMPORTED_MODULE_52__store_index__["a" /* default */],
  i18n: getComp().i18n,
  router: getComp().route,
  template: "<" + template + "/>",
  components: getComp().component,
  render: function render(h) {
    return h(template);
  }
});

/***/ }),
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobiscope_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2dfcf52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobiscope_vue__ = __webpack_require__(1503);
function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobiscope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2dfcf52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobiscope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Horoscope_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a983cda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Horoscope_vue__ = __webpack_require__(946);
function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a983cda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Horoscope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a983cda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Horoscope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"monthlyHoroscope"},[_c('div',{staticClass:"heroElmWrap"},[_c('img',{staticClass:"horo_image",attrs:{"src":_vm.horoscopeData.horoscopeMonth.image,"alt":_vm.horoscopeData.horosign}}),_vm._v(" "),_c('img',{staticClass:"sumdge",attrs:{"src":__webpack_require__(947)}})]),_vm._v(" "),_c('div',{staticClass:"container"},[(_vm.horoscopeData.horosign != '')?_c('div',{staticClass:"monthlyHoroscope__content"},[_c('h1',{staticClass:"std__title"},[_vm._v(_vm._s(_vm.horoscopeData.horosign))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile"},[_vm._v("\n              "+_vm._s(_vm.$t("zodiac_of_the_month"))+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"horoscope"},[_c('span',[_vm._v(_vm._s(_vm.horoscopeData.horoscopeMonth.horoscope_description.today[("" + _vm.language)]))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg stdBtn"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{
                  name: 'HoroscopeDetails',
                  params: { sign: _vm.horoscopeData.horosign }
                }}},[_vm._v(_vm._s(_vm.$t("read_more")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('span',{on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("read_more")))]):_vm._e()],1)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("horoscopes")))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.horoscopeData.data),function(sunsign){return _c('div',{key:sunsign.key,staticClass:"col-md-2 col-sm-4 col-4"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticClass:"signIcon",attrs:{"to":{ name: 'HoroscopeDetails', params: { sign: sunsign.name }}}},[_c('span',{staticClass:"signIcon__img",style:({ '-webkit-mask': ("url(" + (sunsign.icon) + ")") })}),_vm._v(" "),_c('span',{staticClass:"shadow"}),_vm._v(" "),_c('div',{staticClass:"signIcon__label"},[_vm._v(_vm._s(sunsign.name))]),_vm._v(" "),_c('div',{staticClass:"signIcon__date"},[_vm._v(_vm._s(sunsign.date))])]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"signIcon",on:{"click":function($event){return _vm.guest_mobis()}}},[_c('span',{staticClass:"signIcon__img",style:({ '-webkit-mask': ("url(" + (sunsign.icon) + ")") })}),_vm._v(" "),_c('span',{staticClass:"shadow"}),_vm._v(" "),_c('div',{staticClass:"signIcon__label"},[_vm._v(_vm._s(sunsign.name))]),_vm._v(" "),_c('div',{staticClass:"signIcon__date"},[_vm._v(_vm._s(sunsign.date))])]):_vm._e()],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smudge_overlay.57201d3.png";

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tarot_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076255b3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tarot_vue__ = __webpack_require__(1334);
function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tarot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076255b3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tarot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarotSlider_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e759afe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarotSlider_vue__ = __webpack_require__(999);
function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarotSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e759afe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarotSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticClass:"tarotSlider"},_vm._l((_vm.major),function(maj,index){return _c('div',{key:maj.key,staticClass:"carousel-cell tarotSlider__item"},[_c('div',{staticClass:"cardWrapper",attrs:{"data-cardIndex":index,"data-toggle":"modal","data-target":"#astroModal"},on:{"click":function($event){return _vm.getTarot(maj.name_short)}}},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"tarotCard__face front"},[_c('img',{attrs:{"src":maj.image}})])]),_vm._v(" "),_c('p',{staticClass:"tarotCard__label"},[_vm._v(_vm._s(maj.name))])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tarotCard__face back"},[_c('img',{attrs:{"src":__webpack_require__(1000)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/back-card.eccfbc5.png";

/***/ }),
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1024 */,
/* 1025 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ace of Cups.70715b1.jpg";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ace of Pentacles.0834a77.jpg";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ace of Swords.dd74de5.jpg";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ace of Wands.8d71883.jpg";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Death.4965032.jpg";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Eight of Cups.794a1f3.jpg";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Eight of Pentacles.a895247.jpg";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Eight of Swords.4cb4bb6.jpg";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Eight of Wands.1d3ce11.jpg";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Five of Cups.6fcf8cb.jpg";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Five of Pentacles.a6a75b7.jpg";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Five of Swords.35696c1.jpg";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Five of Wands.df6e40b.jpg";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Fortitude.df1d91e.jpg";

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Four of Cups.b3f3577.jpg";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Four of Pentacles.ffbc18a.jpg";

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Four of Swords.7d2858e.jpg";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Four of Wands.9abea33.jpg";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Justice.648b67f.jpg";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/King of Cups.d2fd47f.jpg";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/King of Pentacles.56211b2.jpg";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/King of Swords.d30c2b4.jpg";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/King of Wands.49a906d.jpg";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Knight of Cups.09d9e22.jpg";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Knight of Pentacles.9b7f4c7.jpg";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Knight of Swords.30aefa6.jpg";

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Knight of Wands.b286b02.jpg";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Nine of Cups.eafd31b.jpg";

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Nine of Pentacles.f432ce9.jpg";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Nine of Swords.97b6439.jpg";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Nine of Wands.1ffc326.jpg";

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Page of Cups.c152800.jpg";

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Page of Pentacles.3f11fa9.jpg";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Page of Swords.756a4d4.jpg";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Page of Wands.a37a268.jpg";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Queen of Cups.8b962c1.jpg";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Queen of Pentacles.fdd5689.jpg";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Queen of Swords.1ed91e6.jpg";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Queen of Wands.5f4000d.jpg";

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Seven of Cups.4f07c81.jpg";

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Seven of Pentacles.26172c2.jpg";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Seven of Swords.b347a01.jpg";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Seven of Wands.1bcc80d.jpg";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Six of Cups.27b21c7.jpg";

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Six of Pentacles.9fbfd6f.jpg";

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Six of Swords.55e6161.jpg";

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Six of Wands.0ede4f4.jpg";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Temperance.71c4666.jpg";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ten of Cups.912a58d.jpg";

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ten of Pentacles.78434ee.jpg";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ten of Swords.601ecaa.jpg";

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ten of Wands.c11ec10.jpg";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Chariot.ed6a9c8.jpg";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Devil.ac1f512.jpg";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Emperor.86f9057.jpg";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Empress.0b5622c.jpg";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Fool.09bcef9.jpg";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Hanged Man.2c608f9.jpg";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Hermit.59ed006.jpg";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Hierophant.5034f85.jpg";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The High Priestess.81e0ce0.jpg";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Last Judgment.f7fb842.jpg";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Lovers.5b9762d.jpg";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Magician.2303bec.jpg";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Moon.76e2d49.jpg";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Star.a276f88.jpg";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Sun.7d84c51.jpg";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Tower.8f2f263.jpg";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The World.d2f7d56.jpg";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Three of Cups.e835c7f.jpg";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Three of Pentacles.2706427.jpg";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Three of Swords.d601e09.jpg";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Three of Wands.55c25b3.jpg";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Two of Cups.1cd321a.jpg";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Two of Pentacles.96e8a8b.jpg";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Two of Swords.306d2cb.jpg";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Two of Wands.3ee01e8.jpg";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wheel Of Fortune.aa81870.jpg";

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.tarotData.loading)?_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("tarot_cards")))]),_vm._v(" "),_c('p',{staticClass:"std__subtile md purple"},[_vm._v(_vm._s(_vm.$t("major")))]),_vm._v(" "),_c('tarot-slider',{attrs:{"major":_vm.tarotData.majors,"getTarot":_vm.getTarot}})],1)]):_vm._e(),_vm._v(" "),(!_vm.tarotData.loading)?_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('p',{staticClass:"std__subtile md purple"},[_vm._v(_vm._s(_vm.$t("minor")))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-6"},[_c('h2',{staticClass:"tarotLabel"},[_vm._v(_vm._s(_vm.$t("wands")))]),_vm._v(" "),_c('ul',{staticClass:"tarotUl"},_vm._l((_vm.tarotData.wands),function(wand){return _c('li',{key:wand.key,on:{"click":function($event){return _vm.getTarot(wand.name_short)}}},[_c('a',{key:wand.key,staticClass:"tarotLink",attrs:{"data-toggle":"modal","data-target":"#astroModal"}},[_vm._v(_vm._s(wand.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('h2',{staticClass:"tarotLabel"},[_vm._v(_vm._s(_vm.$t("cups")))]),_vm._v(" "),_c('ul',{staticClass:"tarotUl"},_vm._l((_vm.tarotData.cups),function(cup){return _c('li',{key:cup.key,on:{"click":function($event){return _vm.getTarot(cup.name_short)}}},[_c('a',{key:cup.key,staticClass:"tarotLink",attrs:{"data-toggle":"modal","data-target":"#astroModal"}},[_vm._v(_vm._s(cup.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('h2',{staticClass:"tarotLabel"},[_vm._v(_vm._s(_vm.$t("swords")))]),_vm._v(" "),_c('ul',{staticClass:"tarotUl"},_vm._l((_vm.tarotData.swords),function(sword){return _c('li',{key:sword.key,on:{"click":function($event){return _vm.getTarot(sword.name_short)}}},[_c('a',{key:sword.key,staticClass:"tarotLink",attrs:{"data-toggle":"modal","data-target":"#astroModal"}},[_vm._v(_vm._s(sword.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6"},[_c('h2',{staticClass:"tarotLabel"},[_vm._v(_vm._s(_vm.$t("pentacles")))]),_vm._v(" "),_c('ul',{staticClass:"tarotUl"},_vm._l((_vm.tarotData.pentacles),function(pentacle){return _c('li',{key:pentacle.key,on:{"click":function($event){return _vm.getTarot(pentacle.name_short)}}},[_c('a',{key:pentacle.key,staticClass:"tarotLink",attrs:{"data-toggle":"modal","data-target":"#astroModal"}},[_vm._v(_vm._s(pentacle.name))])])}),0)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"astroModal","tabindex":"-1","role":"dialog","aria-labelledby":"astroModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modalCustom"},_vm._l((_vm.tarots),function(tarot){return _c('div',{key:tarot.key,staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(tarot.name))]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"left col-md-3"},[_c('div',{staticClass:"thumbnail"},[_c('img',{attrs:{"src":tarot.image,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"right col-md-8"},[_c('div',{staticClass:"stdGroup"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("description")))]),_vm._v(" "),(_vm.language === 'english')?_c('p',[_vm._v(_vm._s(tarot.desc))]):_vm._e(),_vm._v(" "),(_vm.language !== 'english')?_c('p',[_vm._v(_vm._s(_vm.descTranslate))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"stdGroup"},[_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("meaning")))]),_vm._v(" "),(_vm.language === 'english')?_c('p',[_vm._v(" "+_vm._s(tarot.meaning_up)+" "+_vm._s(tarot.meaning_rev))]):_vm._e(),_vm._v(" "),(_vm.language !== 'english')?_c('p',[_vm._v(_vm._s(_vm.meaningTranslate))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n            "+_vm._s(_vm.$t("close"))+"\n          ")])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zodiac_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543b3bde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zodiac_vue__ = __webpack_require__(1337);
function injectStyle (ssrContext) {
  __webpack_require__(1336)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zodiac_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543b3bde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zodiac_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loadingPage.loading)?_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("zodiac_signs")))]),_vm._v(" "),_c('p',{staticClass:"std__subtile sm"},[_vm._v(_vm._s(_vm.$t("by_click")))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.horoscopeData.data),function(zodiac){return _c('div',{key:zodiac.key,staticClass:"col-md-2 col-sm-4 col-4"},[_c('router-link',{staticClass:"signIcon",attrs:{"to":{ name: 'ZodiacDetails', params: { zodiac: zodiac.name.toLowerCase() } }}},[_c('span',{staticClass:"signIcon__img",style:({ '-webkit-mask': ("url(" + (zodiac.icon) + ")") })}),_vm._v(" "),_c('span',{staticClass:"shadow"}),_vm._v(" "),_c('div',{staticClass:"signIcon__label"},[_vm._v(_vm._s(zodiac.name))]),_vm._v(" "),_c('div',{staticClass:"signIcon__date"},[_vm._v(_vm._s(zodiac.date))])])],1)}),0)])]):_vm._e(),_vm._v(" "),(!_vm.loadingPage.loading)?_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("element_signs")))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.zodiacData.elements),function(element){return _c('div',{key:element.key,staticClass:"col-md-3 col-6"},[_c('router-link',{staticClass:"elementItem",attrs:{"to":{ name: 'ElementsDetails', params: { element: element.element_name} }}},[_c('img',{staticClass:"elementItem__icon",attrs:{"src":element.icon,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"signIcon__label"},[(_vm.language==='english')?_c('span',[_vm._v(_vm._s(element.element_name))]):_vm._e(),_vm._v(" "),(_vm.language==='arabic')?_c('span',[_vm._v(_vm._s(element.element_nameAR))]):_vm._e(),_vm._v(" "),(_vm.language==='greek')?_c('span',[_vm._v(_vm._s(element.element_nameGR))]):_vm._e(),_vm._v(" "),(_vm.language==='malay')?_c('span',[_vm._v(_vm._s(element.element_nameMY))]):_vm._e(),_vm._v(" "),(_vm.language==='thai')?_c('span',[_vm._v(_vm._s(element.element_nameTH))]):_vm._e()])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_481860d7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1340);
function injectStyle (ssrContext) {
  __webpack_require__(1339)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-481860d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_481860d7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('div',{staticClass:"d2-section "},[_c('div',{staticClass:"d2-section __content"},[_c('div',{staticClass:"formElm"},[(_vm.auth_mobis === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_mobis != '0')?_c('div',[(_vm.gcid_mobis == '314')?_c('div',[_c('a',{staticClass:"btn btn-lg stdBtn",attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                        "+_vm._s(_vm.$t("unsubscribe"))+"\n                      ")])]):_c('div',[_c('a',{staticClass:"btn btn-lg stdBtn",attrs:{"href":""},on:{"click":function($event){return _vm.logout_mobis(_vm.is_unsub_mobis)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_c('div',[_c('a',{staticClass:"btn btn-lg stdBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_mobis(_vm.is_unsub_mobis)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(341)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChineseZodiac_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4865191f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChineseZodiac_vue__ = __webpack_require__(1370);
function injectStyle (ssrContext) {
  __webpack_require__(1342)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4865191f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChineseZodiac_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4865191f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChineseZodiac_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */,
/* 1344 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS4wNSA5MS4wNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5SYWJiaXQ8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjQuNjEsNjguNDZjMi4xNS01Ljg2LjgtMTIuNTktMy42Mi0xOFM0OS42NSw0Mi4wNyw0My4yMSw0M2E0NC44OCw0NC44OCwwLDAsMC00LjU1LDFjLS42Ni4xNy0xLjMxLjM1LTEuOTQuNWEuNTcuNTcsMCwwLDEtLjQ2LS4xLjU2LjU2LDAsMCwxLS4yMS0uNDNjMC0xLDAtMS45LDAtMi44MiwwLTIuMywwLTQuNDcuMDctNi42N2E3Ljc4LDcuNzgsMCwwLDEsMS4zNS0zLjkxYy45LTEuMjcsMS44OS0yLjUsMi44Ni0zLjY5czIuMTctMi42OCwzLjEzLTQuMDljMS41Ny0yLjMsMS43Ny0zLjYuNjgtNC4zN2ExLjc3LDEuNzcsMCwwLDAtMS40LS4zMkE1LDUsMCwwLDAsNDAsMjAuNTZhNTcuMzksNTcuMzksMCwwLDAtNC43Nyw5LjMzYy0uOSwyLjMzLTEuODIsMy40NC00LjYsMy40NS01Ljg5LDAtMTAuMjMsMy41MS0xMS4zNCw5LjEyLS4zOCwyLS4yOCwzLjIzLjMzLDRzMS45LDEuMjIsNCwxLjMybC42LDBjMS44MSwwLDQuMy4xMiw0Ljc2LDMuNDMsMS4xNiw4LjE5LDQuNTYsMTIuMzIsMTEsMTMuNDFhLjU0LjU0LDAsMCwxLC40Ni41M2MwLC40NCwwLC44NiwwLDEuMjcsMCwuODUsMCwxLjY2LDAsMi40NmEzLjIxLDMuMjEsMCwwLDEtLjYyLDIuNDIsMy40MSwzLjQxLDAsMCwxLTIuNTIuOTIsMy42MSwzLjYxLDAsMCwwLTIuNDksMUg0MmwyLjM1LTQuODljLTMuMi01LjU2LTIuNzEtOS43OCwxLjUzLTEzLjI3YS41NC41NCwwLDAsMSwuODkuMzljMCwuMzUuMDYuNjguMDksMWEyLjg5LDIuODksMCwwLDEtLjA4LDEuNjljLTIuNDIsNC44OC0xLjg5LDYuOTMsMi42MSwxMGEyLjY2LDIuNjYsMCwwLDEsLjU1LjU2bC4yMy4yOGEuNTMuNTMsMCwwLDEtLjIuODZxLS42LjI0LTEuMTcuNDJhNy4yMSw3LjIxLDAsMCwwLTIsLjg5bC0uMzIuMjJjLS4zOS4yNi0uNjEuNDEtLjc1LDEuNTEuMjguNDQsMS4xNS41MSwxLjU0LjUyLDIuNDkuMDgsNSwuMDcsNy40OC4wNmgyLjYzQzYxLjc4LDczLjQ3LDYzLjEyLDcyLjUzLDY0LjYxLDY4LjQ2Wk0yNi40NCw0MC4wNWEyLjE1LDIuMTUsMCwxLDEsMi4xNS0yLjE1QTIuMTYsMi4xNiwwLDAsMSwyNi40NCw0MC4wNVpNMzcuMTIsMTguNTNhLjY2LjY2LDAsMCwwLC44My0uMTYsNTkuNjQsNTkuNjQsMCwwLDAtNS42NSwxMGMtLjQxLjg3LS43MiwxLjI3LTEuMDksMS4zOWEyLjMsMi4zLDAsMCwxLTEuNTgtLjI4TDMwLjQ0LDI3QzMxLjIsMjQuNjUsMzIsMjIuMTksMzMsMTkuODVBMywzLDAsMCwxLDM0LjQzLDE4LDMuNDQsMy40NCwwLDAsMSwzNy4xMiwxOC41M1pNNDUuNTMsMGgwYTQ1LjU3LDQ1LjU3LDAsMCwwLTMyLjIsMTMuMzNoMEE0NS41Nyw0NS41NywwLDAsMCwwLDQ1LjUzSDBBNDUuNTYsNDUuNTYsMCwwLDAsMTMuMzMsNzcuNzJoMGE0NS41Myw0NS41MywwLDAsMCwzMi4yLDEzLjMzaDBBNDUuNTIsNDUuNTIsMCwwLDAsNzcuNzIsNzcuNzJoMEE0NS41Miw0NS41MiwwLDAsMCw5MS4wNSw0NS41M2gwYTQ1LjUzLDQ1LjUzLDAsMCwwLTEzLjMzLTMyLjJoMEE0NS41Niw0NS41NiwwLDAsMCw0NS41MywwWm0yMy45LDY0LjM1Yy0uMTQsMC0uNTMuNDMtLjk0LDEuNTktLjI0LjY3LS40MywxLjQtLjYxLDIuMTFBMTguODcsMTguODcsMCwwLDEsNjcsNzAuOTFjLTEuNjYsMy44OS00LjQ2LDUuNzgtOC41Niw1Ljc4SDU4Yy01LjQxLS4xNy0xMC45MS0uMTMtMTYuMjQtLjA5LTEuOTQsMC0zLjg4LDAtNS44MiwwLTEuNjUsMC0zLjc3LDAtNC4yMi0yLjQzLS40OC0yLjY1LDEuODktMy42OSwzLTQuMTlhNS4zMSw1LjMxLDAsMCwxLC44LS4yNSwyLjY0LDIuNjQsMCwwLDAsLjgxLS4zLDIsMiwwLDAsMCwuODUtMSwyLjA5LDIuMDksMCwwLDAtLjQ4LTEuMzJjLTYuMTMtMi4yMi05LjU1LTYuOS0xMC43Ny0xNC43Mi0uMi0xLjI4LS44OS0xLjY5LTIuNDYtMS40N2E2LjIzLDYuMjMsMCwwLDEtNS43OS0xLjc1LDguMjksOC4yOSwwLDAsMS0xLjU0LTcuMzFjMS4yMy01LjM0LDQuMy05LDkuMTMtMTAuODRBMi4xOSwyLjE5LDAsMCwwLDI3LDI4LjkyYy42LTUuMjgsMS44OS05LDQuMTctMTIuMTdhNS4zOCw1LjM4LDAsMCwxLDQuMDUtMi4zOCw0LjkxLDQuOTEsMCwwLDEsMy45MiwxLjguNTMuNTMsMCwwLDEsMCwuNzUsNC45LDQuOSwwLDAsMC0uNDkuNjYuNjEuNjEsMCwwLDAtLjA3LjFjMi41LTIuOSw1LjYtMy4yNiw3LjQ5LTIsMi4yMiwxLjQzLDIuMzgsNC44NC4zOSw4LjNhNDUuNTIsNDUuNTIsMCwwLDEtNS41Niw3LjU5Yy0xLjM3LDEuNTQtMS43OCwyLjczLTEuNDksNC4zOWEyMy4yNCwyMy4yNCwwLDAsMSwuMjQsMy40N2MwLC4zMywwLC42NSwwLDFDNTIsMzgsNjEuMjIsNDIuNjksNjcuMSw1NC40NWwuNjUtLjQ3YTI1LjM3LDI1LjM3LDAsMCwxLDIuNjUtMS43NmMxLjM2LS43NSwyLjQ4LS44OSwzLjMyLS40M3MxLjMxLDEuNTEsMS40LDMuMDlDNzUuMzEsNTguNDUsNzQuODQsNjIuNzcsNjkuNDMsNjQuMzVabTIuMzItOS4wOWMuMzQsMS45MS4yLDMuMjgtLjQxLDQuMThhMy45MiwzLjkyLDAsMCwxLTIuNTQsMS40OUM2OCw1OC4zNSw2OC45NCw1Ni41NCw3MS43NSw1NS4yNloiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS4wNSA5MS4wNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5TbmFrZTwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMy4zMywxMy4zM2gwQTQ1LjU3LDQ1LjU3LDAsMCwwLDAsNDUuNTNIMEE0NS41Niw0NS41NiwwLDAsMCwxMy4zMyw3Ny43MmgwYTQ1LjUzLDQ1LjUzLDAsMCwwLDMyLjIsMTMuMzNoMEE0NS41Miw0NS41MiwwLDAsMCw3Ny43Miw3Ny43MmgwQTQ1LjUyLDQ1LjUyLDAsMCwwLDkxLjA1LDQ1LjUzaDBhNDUuNTMsNDUuNTMsMCwwLDAtMTMuMzMtMzIuMmgwQTQ1LjU2LDQ1LjU2LDAsMCwwLDQ1LjUzLDBoMEE0NS41Nyw0NS41NywwLDAsMCwxMy4zMywxMy4zM1pNNjguMjcsMzEuODVBMTAuNTgsMTAuNTgsMCwwLDEsNjUsMzkuMzdRNTYuMjgsNDguMTYsNDcuNSw1Ni45bC04LDgtLjQxLjM5YTMuMzgsMy4zOCwwLDAsMC0uODUsMSwxLjIxLDEuMjEsMCwwLDAsLjE4LjkzLDEuMjMsMS4yMywwLDAsMCwuOTIsMCwzLjU1LDMuNTUsMCwwLDAsMS0uODdsLjQtLjQyLDYuNDEtNi40M2M0Ljc1LTQuNzcsOS42Ni05LjcsMTQuNTUtMTQuNSw0LjMtNC4yLDEwLjMzLTQuMTEsMTQuNjcuMjQsNCw0LDQsMTAuMTUtLjE2LDE0LjQ4LS42MS42NC0xLjIzLDEuMjUtMS44NiwxLjg3bC0yLDJjLS44Ni44NS0xLjcyLDEuNy0yLjU1LDIuNTdzLTEuMjYsMS40OS0xLjIxLDEuODguNTguODcsMS43NywxLjU5YTQuODgsNC44OCwwLDAsMSwxLjE4LDEuMTNsLjQ0LjQ5YS41NS41NSwwLDAsMSwuMTQuNDYuNTIuNTIsMCwwLDEtLjI3LjM5Yy0uMjEuMTItLjQyLjI2LS42Mi40YTQsNCwwLDAsMS0xLjcxLjgxLDcuMjgsNy4yOCwwLDAsMS03LjI3LTMuMjRBNy42Miw3LjYyLDAsMCwxLDYyLDYxLjE3YTI5Ljc2LDI5Ljc2LDAsMCwxLDMuMzMtMy45MWMuNzgtLjgzLDEuNTktMS42NywyLjMtMi41NWE1Ljc4LDUuNzgsMCwwLDEsMS0uODZjLjQ4LS4zNywxLS44LDEtMS4xNWExLDEsMCwwLDAtLjM2LS42NWMtLjI3LS4yOC0uNDgtLjQyLS43LS4zOS0uMzksMC0uODUuNjUtMS4yMiwxLjE2YTkuMjEsOS4yMSwwLDAsMS0uNjguODNDNjIuMjUsNTgsNTcuOCw2Mi40Miw1My41LDY2LjcyTDQ2LDc0LjE2YTkuNzgsOS43OCwwLDAsMS03LDMuMDksMTAuNTQsMTAuNTQsMCwwLDEtMy42Mi0uNjcsMTAuMzYsMTAuMzYsMCwwLDEtNy04LjY3Yy0uNDctMy4xNi42MS02LjA3LDMuMi04LjY2TDM0LDU2Ljg3YzcuNDctNy40NSwxNS4yLTE1LjE3LDIyLjczLTIyLjgyYTcuMjYsNy4yNiwwLDAsMCwxLjQxLTIuNTEsMS4wNywxLjA3LDAsMCwwLS43Mi0uMzNjLS4zOSwwLS43OS41Ny0xLjE1LDFhNi4yMSw2LjIxLDAsMCwxLS42My43NVE0OSwzOS41Myw0Mi40Miw0Ni4xNGwtNyw3Yy00LjY2LDQuNjMtMTAuNTYsNC43Ny0xNSwuMzctNC4yOC00LjIyLTQuMTYtMTAuMTkuMy0xNC44Ni4zOC0uNC44LS43OCwxLjIyLTEuMTdhNy45Myw3LjkzLDAsMCwwLDIuNDMtMywxMC41NywxMC41NywwLDAsMC0xLjgzLTEuNjIsMTcuNjgsMTcuNjgsMCwwLDEtMS43My0xLjQ3Yy0xLjkyLTEuOTQtNC00LjY4LTMuMTEtOC42MywwLS4xOC0uMjMtLjY0LS40NC0xYTguMzQsOC4zNCwwLDAsMS0uNDQtLjgyYy0uMTctLjQtLjMxLS44LS40NS0xLjIxbC0uMTctLjQ4YS41NC41NCwwLDAsMSwuMjktLjY4bC45Mi0uNDFhLjU1LjU1LDAsMCwxLC43LjI0LDIuNjksMi42OSwwLDAsMCwzLjY2LDEuNDdBMy44MSwzLjgxLDAsMCwxLDIzLjgsMjBjNS43OSwxLjYyLDguMTMsNi41MiwxMCwxMS40LDEuNDQsMy43MS4zMiw3LjQ4LTMuMjQsMTAuODlsLS40Ni40M2EyNywyNywwLDAsMC0yLjU3LDIuNjcsMi4xMSwyLjExLDAsMCwwLS4yLDFzMCwwLDAsLjA2aC4xNWEyLjI4LDIuMjgsMCwwLDAsMS0uMTNDMzEsNDQsMzMuNSw0MS41NCwzNS44OCwzOS4xNWw1Ljg2LTUuODZjMi44NC0yLjg1LDUuNjgtNS43LDguNTUtOC41Miw0LjM3LTQuMzEsMTAuNC00LjQxLDE0LjY3LS4yNUExMC40LDEwLjQsMCwwLDEsNjguMjcsMzEuODVaTTM5LjYyLDYwLjMxbC0yLjg0LDIuODJDMzUuNjksNjQuMjMsMzQuMTksNjUuNzIsMzUsNjhhMy45NCwzLjk0LDAsMCwwLDIuNzksMi42M0E0LjU3LDQuNTcsMCwwLDAsNDIsNjkuMTZxNS01LDEwLTEwYzQtNCw3LjkxLTcuOTEsMTEuODktMTEuODVBNi44Myw2LjgzLDAsMCwxLDcyLDQ1LjkxYzIuOSwxLjU0LDQuNTMsNC41NSw0LDcuMzNoMGExMCwxMCwwLDAsMS0yLjE2LDQuMjcsMzkuNDgsMzkuNDgsMCwwLDEtMi45MiwzLDM5LjEzLDM5LjEzLDAsMCwwLTMsMy4xMywyMC4zOCwyMC4zOCwwLDAsMC0yLjI1LDMuNjZjLS4yLjM4LS40Ljc3LS42MSwxLjE1YTQuMjQsNC4yNCwwLDAsMS0xLjE3LTIuNTgsNi4yOCw2LjI4LDAsMCwxLDEuNzUtNC41NmMxLjEyLTEuMjcsMi4zNS0yLjQ5LDMuNTUtMy42Ny42OS0uNjksMS4zOC0xLjM3LDIuMDYtMi4wNywyLjA4LTIuMTUsMi4yLTQuMTUuMzgtNS45My0xLjI2LTEuMjItMy4zMS0yLjEzLTUuOTUuNDlMNTUuNTMsNjAuMjNRNDkuNzQsNjYsNDQsNzEuNzhBNyw3LDAsMCwxLDM1LjEzLDczYy0zLjA1LTEuOTEtNC40LTUuMzItMy4zLTguMjlhMTEsMTEsMCwwLDEsMi40NS0zLjYyYzYuOTItNywxNC0xNCwyMC44My0yMC44OGw0LjY4LTQuNjZjMS4yNC0xLjI0LDIuNzctMi43OCwxLjYxLTUuMTRBNCw0LDAsMCwwLDU4LjUxLDI4YTMuNjgsMy42OCwwLDAsMC0uNTgtLjA1LDQuODUsNC44NSwwLDAsMC0zLjM0LDEuNThxLTcsNy0xNCwxNGwtNi41NCw2LjU1Yy0uNS41LTEsMS0xLjUyLDEuNDhhNi44LDYuOCwwLDAsMS05Ljk0LS4yNCw2LjgsNi44LDAsMCwxLS4zMS05Ljc1Yy43LS43NywxLjQ2LTEuNTIsMi4yMS0yLjI0czEuMzUtMS4zMSwyLTJhNC4yNyw0LjI3LDAsMCwwLDEuMzQtMy41Miw0LjIsNC4yLDAsMCwwLTIuMzItMi44OWMtMi43OS0xLjU2LTQuMjctMy4yNy00LjgxLTUuNTVhMi4xNSwyLjE1LDAsMCwxLC4yNC0xLjkzLDIuMTgsMi4xOCwwLDAsMSwyLS4zN2MyLjQ4LjQxLDUuMjMsMy4xNCw2Ljg0LDYuNzksMS4zOCwzLjE0LDEuNTQsNi4xOC40LDcuOTRhMjUuODIsMjUuODIsMCwwLDEtMy41NCw0Yy0uNTUuNTQtMS4wOSwxLjA4LTEuNjIsMS42My0xLjc0LDEuODYtMS43NiwzLjc4LDAsNS41NWEzLjYsMy42LDAsMCwwLDIuNTgsMS4yNiw0LjkxLDQuOTEsMCwwLDAsMy4zNy0xLjdRMzcuNjcsNDEuODMsNDQuNDMsMzVMNTEsMjguNDNjLjU2LS41NywxLjEyLTEuMTQsMS43MS0xLjY4LDMuMTktMi45Myw3LjE2LTIuODUsMTAuMTQuMTlzMyw3LjA2LDAsMTAuMTFDNTUuMTUsNDQuODQsNDcuMjUsNTIuNywzOS42Miw2MC4zMVoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Cow.f859902.svg";

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Dog.a76d6f6.svg";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Dragon.ffd1cd2.svg";

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Goat.4e69358.svg";

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Horse.0c00d26.svg";

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Monkey.e39ad8a.svg";

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ox.f859902.svg";

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Pig.2fe1ff1.svg";

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Rabbit.a320c76.svg";

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Rat.b2598b8.svg";

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Rooster.54fd1fb.svg";

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Snake.c82e962.svg";

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Tiger.1a8ebfa.svg";

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"monthlyHoroscope"},[_c('div',{staticClass:"heroElmWrap"},[_c('img',{staticClass:"horo_image",attrs:{"src":_vm.current_year.image_year}}),_vm._v(" "),_c('img',{staticClass:"sumdge",attrs:{"src":__webpack_require__(1371)}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"monthlyHoroscope__content"},[_c('h1',{staticClass:"std__title yellow"},[_vm._v(_vm._s(_vm.current_year[("sign_" + _vm.language)]))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("zodiac_of_the_year")))]),_vm._v(" "),_c('p',{staticClass:"horoscope"},[_vm._v(_vm._s(_vm.current_year.health[("" + _vm.language)]))]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg stdBtn yellow",staticStyle:{"text-decoration":"none"},attrs:{"to":{
                name: 'ChineseZodiacDetails',
                params: { chinesesign: _vm.current_year.route }
              }}},[_vm._v(_vm._s(_vm.$t("read_more")))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("chinese_zodiac_signs")))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.czodiacs),function(zodiac){return _c('div',{key:zodiac.key,staticClass:"col-3 col-md-2"},[_c('router-link',{staticClass:"signIcon yellow",staticStyle:{"text-decoration":"none"},attrs:{"to":{
                  name: 'ChineseZodiacDetails',
                  params: { chinesesign: zodiac.sign_english.toLowerCase() }
                }}},[_c('span',{staticClass:"signIcon__img",style:({ '-webkit-mask': ("url(" + (zodiac.image) + ")") })}),_vm._v(" "),_c('span',{staticClass:"shadow"}),_vm._v(" "),_c('div',{staticClass:"signIcon__label"},[_vm._v(_vm._s(zodiac[("sign_" + _vm.language)]))])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smudge_overlay-orange.dcce506.png";

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d729c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1375);
function injectStyle (ssrContext) {
  __webpack_require__(1373)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d729c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 347,
	"./bulgarian.json": 348,
	"./czech.json": 349,
	"./denmark.json": 350,
	"./english.json": 351,
	"./finnish.json": 352,
	"./greek.json": 353,
	"./malay.json": 354,
	"./norwegian.json": 355,
	"./romanian.json": 356,
	"./slovakia.json": 357,
	"./swedish.json": 358,
	"./thai.json": 359
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"formElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"formElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"formElm"},[_c('button',{staticClass:"btn btn-lg stdBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.language ==='english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.language !=='english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoroscopeDetails_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe62b84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoroscopeDetails_vue__ = __webpack_require__(1406);
function injectStyle (ssrContext) {
  __webpack_require__(1377)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoroscopeDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fe62b84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoroscopeDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Aquarius.b7b475c.svg";

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Aries.fe9a12e.svg";

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Cancer.190a68f.svg";

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Capricorn.a63343c.svg";

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Gemini.1f98983.svg";

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Leo.0f686fc.svg";

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Libra.c8f91e1.svg";

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Pisces.9134ee0.svg";

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sagittarius.55f8f2e.svg";

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Scorpio.de75a80.svg";

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Taurus.a8a41c2.svg";

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Virgo.96b3e4d.svg";

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content center"},[_c('div',{ref:"mobileCarousel",staticClass:"mobileCarousel"},_vm._l((_vm.data),function(sign){return _c('div',{key:sign.key,staticClass:"carousel-cell"},[_c('div',{staticClass:"signIcon blue sm",attrs:{"id":sign.name}},[_c('router-link',{attrs:{"to":{ name: 'HoroscopeDetails', params: { sign: sign.name } }}},[_c('div',{staticStyle:{"position":"relative"}},[_c('span',{staticClass:"signIcon__img",style:({ '-webkit-mask': ("url(" + (sign.icon) + ")") })}),_vm._v(" "),_c('span',{staticClass:"shadow"})]),_vm._v(" "),_c('span',{staticClass:"signIcon__label",staticStyle:{"text-decoration":"none","color":"white"}},[_vm._v(_vm._s(sign.name))])])],1)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$route.params.sign)+" "+_vm._s(_vm.$t("daily_horo")))]),_vm._v(" "),_c('p',{staticClass:"std__subtile sm purple"},[_vm._v(_vm._s(_vm.date_current[("" + _vm.language)]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 order-2 order-md-1 m2--topBtm"},[_c('ul',{staticClass:"nav nav-tabs custom",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"yesterday-tab","data-toggle":"tab","href":"#yesterday","role":"tab","aria-controls":"yesterday","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("yesterday")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"today-tab","data-toggle":"tab","href":"#today","role":"tab","aria-controls":"today","aria-selected":"true"}},[_vm._v(_vm._s(_vm.$t("today")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"tomorrow-tab","data-toggle":"tab","href":"#tomorrow","role":"tab","aria-controls":"tomorrow","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("tomorrow")))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade",attrs:{"id":"yesterday","role":"tabpanel","aria-labelledby":"yesterday-tab"}},[(!_vm.loading)?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.data_desc.yesterday[("" + _vm.language)]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"today","role":"tabpanel","aria-labelledby":"today-tab"}},[(!_vm.loading)?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.data_desc.today[("" + _vm.language)]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"tomorrow","role":"tabpanel","aria-labelledby":"tomorrow-tab"}},[(!_vm.loading)?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.data_desc.tomorrow[("" + _vm.language)]))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 order-1 order-md-2 m2--topBtm"},[_c('div',{staticClass:"imagePlaceholder"},[_c('img',{attrs:{"src":_vm.image,"alt":this.sign}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 m2--topBtm"},[_c('ul',{staticClass:"nav nav-tabs custom",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"week-tab","data-toggle":"tab","href":"#week","role":"tab","aria-controls":"week","aria-selected":"true"}},[_vm._v(_vm._s(_vm.$t("week")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"month-tab","data-toggle":"tab","href":"#month","role":"tab","aria-controls":"month","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("month")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"year-tab","data-toggle":"tab","href":"#year","role":"tab","aria-controls":"year","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("year")))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"week","role":"tabpanel","aria-labelledby":"week-tab"}},[(!_vm.loading)?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.data_desc.week[("" + _vm.language)]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"month","role":"tabpanel","aria-labelledby":"month-tab"}},[(!_vm.loading)?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.data_desc.month[("" + _vm.language)]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"year","role":"tabpanel","aria-labelledby":"year-tab"}},[(!_vm.loading)?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.data_desc.year[("" + _vm.language)]))]):_vm._e()])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZodiacDetails_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410da532_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZodiacDetails_vue__ = __webpack_require__(1424);
function injectStyle (ssrContext) {
  __webpack_require__(1408)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZodiacDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410da532_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZodiacDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Jupiter.svg": 1410,
	"./Mars.svg": 1411,
	"./Mercury.svg": 1412,
	"./Moon.svg": 1413,
	"./Neptune.svg": 1414,
	"./Pluto.svg": 1415,
	"./Saturn.svg": 1416,
	"./The Sun.svg": 1417,
	"./Uranus.svg": 1418,
	"./Venus.svg": 1419
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1409;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Jupiter.534f9aa.svg";

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mars.675e190.svg";

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mercury.44da08b.svg";

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Moon.1c8a8ed.svg";

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Neptune.6cda193.svg";

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Pluto.af9d3bf.svg";

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Saturn.ea6e697.svg";

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The Sun.90f9553.svg";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Uranus.5e70b4e.svg";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Venus.e836403.svg";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Air.bcf6a8b.svg";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Earth.1775563.svg";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Fire.498a7e6.svg";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Water.b71209e.svg";

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("zodiac_signs")))]),_vm._v(" "),_c('p',{staticClass:"std__subtile neon lg"},[_vm._v("\n        "+_vm._s(_vm.zodiacs.name)+"\n        "),_c('span',{staticClass:"dateStamp"},[_vm._v(_vm._s(_vm.zodiacs.date))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 order-2 order-md-1 m2--topBtm"},[_c('ul',{staticClass:"nav nav-tabs custom",attrs:{"id":"zodiacTraits","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"mentalTraits-tab","data-toggle":"tab","href":"#mentalTraits","role":"tab","aria-controls":"mentalTraits","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("mental")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"physicalTraits-tab","data-toggle":"tab","href":"#physicalTraits","role":"tab","aria-controls":"physicalTraits","aria-selected":"true"}},[_vm._v(_vm._s(_vm.$t("physical")))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"zodiacTraits"}},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"mentalTraits","role":"tabpanel","aria-labelledby":"mentalTraits-tab"}},[(_vm.language==='english')?_c('span',_vm._l((_vm.zodiacs.mental_traits),function(zodiac){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(zodiac))])}),0):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('span',_vm._l((_vm.zodiacs.mentalTranslate),function(zodiac){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(zodiac))])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"physicalTraits","role":"tabpanel","aria-labelledby":"physicalTraits-tab"}},[(_vm.language==='english')?_c('span',_vm._l((_vm.zodiacs.physical_traits),function(zodiac){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(zodiac))])}),0):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('span',_vm._l((_vm.zodiacs.physicalTranslate),function(zodiac){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(zodiac))])}),0):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 order-1 order-md-2 m2--topBtm"},[_c('div',{staticClass:"imagePlaceholder sign"},[_c('span',{staticClass:"signIcon__img",style:({ '-webkit-mask': ("url(" + (_vm.zodiacs.icon) + ")") })})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 m2--topBtm"},[_c('p',{staticClass:"std__subtile md bdr"},[_vm._v(_vm._s(_vm.$t("favorites")))]),_vm._v(" "),_c('div',{staticClass:"rowContent"},[(_vm.language==='english')?_c('span',_vm._l((_vm.zodiacs.favorites),function(zodiac,index){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(index+1)+". "+_vm._s(zodiac))])}),0):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('span',_vm._l((_vm.zodiacs.favTranslate),function(zodiac,index){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(index+1)+". "+_vm._s(zodiac))])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 m2--topBtm"},[_c('p',{staticClass:"std__subtile md bdr"},[_vm._v(_vm._s(_vm.$t("hates")))]),_vm._v(" "),_c('div',{staticClass:"rowContent"},[(_vm.language==='english')?_c('span',_vm._l((_vm.zodiacs.hates),function(zodiac,index){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(index+1)+". "+_vm._s(zodiac))])}),0):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('span',_vm._l((_vm.zodiacs.hateTranslate),function(zodiac,index){return _c('p',{key:zodiac.key,staticClass:"std__txt"},[_vm._v(_vm._s(index+1)+". "+_vm._s(zodiac))])}),0):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row m2--topBtm"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-6 zodiacCol"},[_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("ruling_planet")))]),_vm._v(" "),_c('img',{staticClass:"planet_img",attrs:{"src":_vm.zodiacs.planet_img,"alt":""}}),_vm._v(" "),(_vm.language==='english')?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.planet))]):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.rltranslate))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-6 zodiacCol"},[_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("compatibility")))]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.getZodiacSign(_vm.zodiacs.compatibility.toLowerCase())}}},[_c('img',{staticClass:"compatibility_img",attrs:{"src":_vm.zodiacs.compatibility_img,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.compatibility))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-6 zodiacCol"},[_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("element")))]),_vm._v(" "),_c('router-link',{staticClass:"favorites",attrs:{"to":{ name: 'ElementsDetails', params: { element: _vm.zodiacs.element } }}},[_c('img',{staticClass:"elem_img",attrs:{"src":_vm.zodiacs.element_img,"alt":""}}),_vm._v(" "),(_vm.language==='english')?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.element))]):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.elemTranslate))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-6 zodiacCol"},[_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("color")))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.zodiacs.colorCode)}}),_vm._v(" "),(_vm.language==='english')?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.color))]):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.zodiacs.colorTranslate))]):_vm._e()])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementsDetails_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc7db2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementsDetails_vue__ = __webpack_require__(1427);
function injectStyle (ssrContext) {
  __webpack_require__(1426)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc7db2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("astrology"))+" \n        "),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.element_translate[("" + _vm.language)]))]),_vm._v("\n         "+_vm._s(_vm.$t("element")))]),_vm._v(" "),_c('p',{staticClass:"std__subtile yellow lg"},[_vm._v(_vm._s(_vm.$t("elem"))+" \n        "),_c('span',[_vm._v(_vm._s(_vm.element_translate[("" + _vm.language)]))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 order-2 order-md-1 m2--topBtm"},[_c('ul',{staticClass:"nav nav-tabs custom",attrs:{"id":"elementsInfo","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"description-tab","data-toggle":"tab","href":"#description","role":"tab","aria-controls":"description","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("description")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"ascendant-tab","data-toggle":"tab","href":"#ascendant","role":"tab","aria-controls":"ascendant","aria-selected":"true"}},[_vm._v(_vm._s(_vm.$t("ascendant")))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"elementsInfo"}},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"description","role":"tabpanel","aria-labelledby":"description-tab"}},[(_vm.language==='english')?_c('span',_vm._l((_vm.elements.description),function(element){return _c('p',{key:element.key,staticClass:"std__txt"},[_vm._v(_vm._s(element.trim()))])}),0):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('span',_vm._l((_vm.desc),function(element){return _c('p',{key:element.key,staticClass:"std__txt"},[_vm._v(_vm._s(element.trim()))])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"ascendant","role":"tabpanel","aria-labelledby":"ascendant-tab"}},[(_vm.language==='english')?_c('span',_vm._l((_vm.elements.element_ascendant),function(element){return _c('p',{key:element.key,staticClass:"std__txt"},[_vm._v(_vm._s(element.trim()))])}),0):_vm._e(),_vm._v(" "),(_vm.language!=='english')?_c('span',_vm._l((_vm.ascen),function(element){return _c('p',{key:element.key,staticClass:"std__txt"},[_vm._v(_vm._s(element.trim()))])}),0):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 order-1 order-md-2 m2--topBtm"},[_c('div',{staticClass:"imagePlaceholder elem"},[_c('img',{staticClass:"elem_icon",attrs:{"src":_vm.elements.elem_icon,"alt":_vm.elements.element_name}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("related")))]),_vm._v(" "),_c('div',{staticClass:"rowContent"},_vm._l((_vm.elements.relate_icon),function(element){return _c('div',{key:element.key,staticClass:"inlineTags"},[_c('router-link',{attrs:{"to":{ name: 'ZodiacDetails', params: { zodiac:  element[1].toLowerCase()} }}},[_c('img',{staticClass:"elem_icon",attrs:{"src":element[0],"alt":""}}),_vm._v(" "),_c('p',{staticClass:"traits"},[_vm._v(_vm._s(element[1]))])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChineseZodiacDetails_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f13938e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChineseZodiacDetails_vue__ = __webpack_require__(1430);
function injectStyle (ssrContext) {
  __webpack_require__(1429)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f13938e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChineseZodiacDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f13938e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChineseZodiacDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile yellow"},[_vm._v(_vm._s(_vm.$t("chinese_zodiac")))]),_vm._v(" "),_c('p',{staticClass:"std__subtile lg"},[_vm._v(_vm._s(_vm.czodiacs[("sign_" + _vm.language)]))]),_vm._v(" "),_c('ul',{staticClass:"yearList"},_vm._l((_vm.czodiacs.years),function(year){return _c('li',{key:year.key},[_c('span',[_vm._v(_vm._s(year))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 order-2 order-md-1 m2--topBtm"},[_c('ul',{staticClass:"nav nav-tabs custom",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"personality-tab","data-toggle":"tab","href":"#personality","role":"tab","aria-controls":"personality","aria-selected":"false"}},[_vm._v(_vm._s(_vm.$t("personality")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"health-tab","data-toggle":"tab","href":"#health","role":"tab","aria-controls":"health","aria-selected":"true"}},[_vm._v(_vm._s(_vm.$t("health")))])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"carrers-tab","data-toggle":"tab","href":"#carrers","role":"tab","aria-controls":"carrers","aria-selected":"true"}},[_vm._v(_vm._s(_vm.$t("careers")))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"personality","role":"tabpanel","aria-labelledby":"personality-tab"}},[_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.czodiacs.personality[("first_" + _vm.language)]))]),_vm._v(" "),_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.czodiacs.personality[("second_" + _vm.language)]))])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"health","role":"tabpanel","aria-labelledby":"health-tab"}},[_c('p',{staticClass:"std__txt"},[_vm._v(_vm._s(_vm.czodiacs.health[("" + _vm.language)]))])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"carrers","role":"tabpanel","aria-labelledby":"carrers-tab"}},[_c('p',[_vm._v(_vm._s(_vm.czodiacs.carrers[("first_" + _vm.language)]))]),_vm._v(" "),_c('p',{staticClass:"best_career"},[_vm._v(_vm._s(_vm.$t("best_career"))+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.czodiacs.carrers[("second_" + _vm.language)]))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 order-1 order-md-2 m2--topBtm"},[_c('div',{staticClass:"imagePlaceholder chinese"},[_c('span',{staticClass:"symbol"},[_vm._v(_vm._s(_vm.czodiacs.unicode_symbol))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.czodiacs.image,"alt":_vm.czodiacs.sign}})])])])])]),_vm._v(" "),_c('div',{staticClass:"section",attrs:{"id":"bottomSection"}},[_c('div',{staticClass:"container section__content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 m2--topBtm"},[_c('p',{staticClass:"std__subtile md bdr"},[_vm._v(_vm._s(_vm.$t("lucky")))]),_vm._v(" "),_c('div',{staticClass:"rowContent"},[_c('span',[_vm._v(_vm._s(_vm.$t("numbers"))+":")]),_vm._v(" "),_vm._l((_vm.czodiacs.lucky['numbers']),function(number){return _c('div',{key:number.key,staticClass:"inlineTags"},[_c('div',{staticClass:"circle_num"},[_vm._v(_vm._s(number))])])})],2),_vm._v(" "),_c('div',{staticClass:"rowContent"},[_c('span',[_vm._v(_vm._s(_vm.$t("colors"))+":")]),_vm._v(" "),_c('div',{staticClass:"inlineTagsWrap"},_vm._l((_vm.czodiacs.lucky['code_color_luc']),function(color){return _c('div',{key:color.key,staticClass:"inlineTags"},[_c('div',{staticClass:"circle",style:({ background: color[0] }),attrs:{"title":color[1]}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"rowContent"},[_c('span',[_vm._v(_vm._s(_vm.$t("directions"))+":")]),_vm._v(" "),_c('span',_vm._l((_vm.czodiacs.lucky[("directions_" + _vm.language)]),function(direction){return _c('div',{key:direction.key,staticClass:"inlineTags text"},[_c('div',{},[_vm._v(_vm._s(direction))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 m2--topBtm"},[_c('p',{staticClass:"std__subtile md bdr"},[_vm._v(_vm._s(_vm.$t("unlucky")))]),_vm._v(" "),_c('div',{staticClass:"rowContent"},[_c('span',[_vm._v(_vm._s(_vm.$t("numbers"))+":")]),_vm._v(" "),_vm._l((_vm.czodiacs.unlucky['numbers']),function(number){return _c('div',{key:number.key,staticClass:"inlineTags"},[_c('div',{staticClass:"circle_num"},[_vm._v(_vm._s(number))])])})],2),_vm._v(" "),_c('div',{staticClass:"rowContent"},[_c('span',[_vm._v(_vm._s(_vm.$t("colors"))+":")]),_vm._v(" "),_c('div',{staticClass:"inlineTagsWrap"},_vm._l((_vm.czodiacs.unlucky['code_color_unluc']),function(color){return _c('div',{key:color.key,staticClass:"inlineTags",attrs:{"title":color[1]}},[_c('div',{staticClass:"circle",style:({ background: color[0] })})])}),0)]),_vm._v(" "),_c('div',{staticClass:"rowContent"},[_c('span',[_vm._v(_vm._s(_vm.$t("directions"))+":")]),_vm._v(" "),_c('span',_vm._l((_vm.czodiacs.unlucky[("directions_" + _vm.language)]),function(direction){return _c('div',{key:direction.key,staticClass:"inlineTags text"},[_c('div',{},[_vm._v(_vm._s(direction))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 m2--topBtm"},[_c('p',{staticClass:"std__subtile md bdr"},[_vm._v(_vm._s(_vm.$t("best_match")))]),_vm._v(" "),_vm._l((_vm.czodiacs.best),function(best){return _c('div',{key:best.key,staticClass:"inlineTags"},[_c('img',{staticClass:"match_icon",attrs:{"src":best.image,"alt":"","title":best[("best_" + _vm.language)]}})])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6 m2--topBtm"},[_c('p',{staticClass:"std__subtile md bdr"},[_vm._v(_vm._s(_vm.$t("worst_match")))]),_vm._v(" "),_vm._l((_vm.czodiacs.worst),function(worst){return _c('div',{key:worst.key,staticClass:"inlineTags"},[_c('img',{staticClass:"match_icon",attrs:{"src":worst.image,"alt":"","title":worst[("worst_" + _vm.language)]}})])})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbc221e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1444);
function injectStyle (ssrContext) {
  __webpack_require__(1432)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fbc221e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbc221e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEnglish_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636f9290_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEnglish_vue__ = __webpack_require__(1434);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636f9290_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$t('privacy')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"contentPanel",staticStyle:{"padding-top":"5px !important"}},[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content provider: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("What personal information do we collect from the people that visit our blog, website or app?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number or other details to help you with your experience.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("When do we collect information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We collect information from you when you register on our site, fill out a form or enter information on our site. Provide us with feedback on our products or services.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How do we use your information? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.")]),_vm._v(" "),_c('li',[_vm._v("To improve our website in order to better serve you.")]),_vm._v(" "),_c('li',[_vm._v("To allow us to better service you in responding to your customer service requests.")]),_vm._v(" "),_c('li',[_vm._v("To administer a contest, promotion, survey or other site feature.")]),_vm._v(" "),_c('li',[_vm._v("To quickly process your transactions.")]),_vm._v(" "),_c('li',[_vm._v("To ask for ratings and reviews of services or products")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How do we protect your information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Do we use cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Keep track of advertisements.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"}),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-party disclosure")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-party links")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not include or offer third-party products or services on our website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Click here to view")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Does our site allow third-party behavioral tracking?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("It's also important to note that we allow third-party behavioral tracking")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyCzech_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22bb897a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyCzech_vue__ = __webpack_require__(1436);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22bb897a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$t('privacy')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"contentPanel",staticStyle:{"padding-top":"5px !important"}},[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Tyto zásady ochrany osobních údajů byly sestaveny, aby lépe sloužily těm, kteří se zajímají o to, jak jsou jejich „osobně identifikovatelné informace“ (PII) používány online. Přečtěte si pozorně naše zásady ochrany osobních údajů, abyste získali jasnou představu o tom, jak shromažďujeme, používáme, chráníme nebo jinak zacházíme s vašimi osobně identifikovatelnými informacemi v souladu s našimi webovými stránkami.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πάροχος περιεχομένου: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Διεύθυνση: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jaké osobní údaje shromažďujeme od lidí, kteří navštěvují náš blog, web nebo aplikaci?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Při objednávání nebo registraci na našem webu můžete být požádáni, abyste zadali své jméno, e-mailovou adresu, poštovní adresu, telefonní číslo nebo jiné podrobnosti, které vám pomohou s vaší zkušeností.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kdy shromažďujeme informace?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Shromažďujeme informace od vás, když se zaregistrujete na našem webu, vyplníte formulář nebo zadáte informace na našem webu. Poskytněte nám zpětnou vazbu k našim produktům nebo službám.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jak používáme vaše údaje? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informace, které od vás shromažďujeme, můžeme použít při registraci, nákupu, registraci k odběru našeho zpravodaje, odpovědi na průzkum nebo marketingovou komunikaci, procházení webu nebo používání určitých dalších funkcí webu následujícími způsoby:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Chcete-li přizpůsobit své zkušenosti a umožnit nám doručit typ obsahu a nabídky produktů, o které máte největší zájem")]),_vm._v(" "),_c('li',[_vm._v("Vylepšit náš web, abychom vám mohli lépe sloužit.")]),_vm._v(" "),_c('li',[_vm._v("Abychom vám mohli lépe poskytovat služby v reakci na vaše požadavky na zákaznické služby.")]),_vm._v(" "),_c('li',[_vm._v("Spravovat soutěž, propagaci, průzkum nebo jiné funkce webu.")]),_vm._v(" "),_c('li',[_vm._v("Chcete-li rychle zpracovat své transakce.")]),_vm._v(" "),_c('li',[_vm._v("Požádat o hodnocení a recenze služeb nebo produktů")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jak chráníme vaše údaje?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naše webové stránky jsou pravidelně kontrolovány, zda neobsahují bezpečnostní mezery a známé chyby zabezpečení, aby byla vaše návštěva našeho webu co nejbezpečnější.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Používáme cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ano. Cookies jsou malé soubory, které web nebo jeho poskytovatel služeb přenáší na pevný disk vašeho počítače prostřednictvím vašeho webového prohlížeče (pokud to povolíte), což umožňuje systémům webu nebo poskytovatele služeb rozpoznat váš prohlížeč a zachytit a zapamatovat si určité informace. Používáme například soubory cookie, které nám pomáhají zapamatovat si a zpracovat položky ve vašem nákupním košíku. Používají se také k tomu, aby nám pomohly porozumět vašim preferencím na základě předchozí nebo aktuální aktivity na webu, což nám umožňuje poskytovat vám vylepšené služby. Používáme také soubory cookie, které nám pomáhají shromažďovat souhrnné údaje o provozu a interakci se stránkami, abychom mohli v budoucnu nabízet lepší zážitky a nástroje.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies používáme k:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pochopte a uložte preference uživatele pro budoucí návštěvy.")]),_vm._v(" "),_c('li',[_vm._v("Sledujte reklamy.")]),_vm._v(" "),_c('li',[_vm._v("Kompilace agregovaných dat o provozu webu a interakcích s webem, aby v budoucnu nabízel lepší prostředí a nástroje. Můžeme také použít důvěryhodné služby třetích stran, které tyto informace sledují naším jménem.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Můžete zvolit, aby vás počítač varoval při každém odeslání souboru cookie, nebo můžete vypnout všechny soubory cookie. To provedete prostřednictvím nastavení prohlížeče. Vzhledem k tomu, že se prohlížeč trochu liší, podívejte se do nabídky nápovědy svého prohlížeče a zjistěte správný způsob úpravy souborů cookie.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Zveřejnění třetí stranou")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vaše osobní identifikační údaje neprodáváme, neobchodujeme s nimi ani je jinak nepředáváme externím stranám, pokud na to uživatele předem nepředáme. To nezahrnuje partnery hostující webové stránky a další strany, které nám pomáhají s provozováním našich webových stránek, řízením našeho podnikání nebo poskytováním služeb našim uživatelům, pokud tyto strany souhlasí se zachováním důvěrnosti těchto informací. Můžeme také zveřejnit informace, pokud je jejich vydání vhodné k dodržení zákonů, prosazování zásad našich stránek nebo k ochraně našich práv či majetku ostatních")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informace o návštěvnících, které neumožňují osobní identifikaci, však mohou být poskytnuty dalším stranám za účelem marketingu, reklamy nebo k jiným účelům.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Odkazy třetích stran")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Na naše webové stránky nezahrnujeme ani nenabízíme produkty nebo služby třetích stran.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Reklamní požadavky společnosti Google lze shrnout do zásad inzerce společnosti Google. Jsou zavedeny, aby uživatelům poskytly pozitivní zážitek. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Kliknutím sem zobrazíte")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google jako prodejce třetí strany používá soubory cookie k zobrazování reklam na našem webu. Google pomocí cookie DART umožňuje zobrazovat reklamy našim uživatelům na základě předchozích návštěv našich stránek a dalších stránek na internetu. Uživatelé se mohou odhlásit z používání souboru cookie DART tak, že navštíví zásady ochrany osobních údajů reklamní sítě Google a obsahové sítě.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Implementovali jsme následující:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Společně s dodavateli třetích stran, jako je Google, používáme soubory cookie první strany (například soubory cookie Google Analytics) a soubory cookie třetích stran (například soubor cookie DoubleClick) nebo jiné identifikátory třetích stran společně ke shromažďování údajů o interakcích uživatelů s zobrazení reklam a další funkce reklamních služeb, které se vztahují k našemu webu.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Umožňuje náš web sledování chování třetích stran?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Je také důležité si uvědomit, že umožňujeme sledování chování třetích stran")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'bg')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Тази политика за поверителност е съставена, за да обслужва по-добре онези, които се занимават с това как тяхната „Лична информация“ (PII) се използва онлайн. Моля, прочетете внимателно нашата политика за поверителност, за да получите ясно разбиране за това как събираме, използваме, защитаваме или обработваме по друг начин Вашата лична информация в съответствие с нашия уебсайт.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Доставчик на съдържание: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Адрес: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Каква лична информация събираме от хората, които посещават нашия блог, уебсайт или приложение?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Когато поръчвате или се регистрирате на нашия сайт, според случая, може да бъдете помолени да въведете вашето име, имейл адрес, пощенски адрес, телефонен номер или други подробности, за да ви помогнем с вашия опит.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Кога събираме информация?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ние събираме информация от вас, когато се регистрирате на нашия сайт, попълните формуляр или въведете информация на нашия сайт. Предоставете ни обратна връзка за нашите продукти или услуги.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Как използваме вашата информация? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Можем да използваме информацията, която събираме от вас, когато се регистрирате, направите покупка, регистрирате се за нашия бюлетин, отговорите на анкета или маркетингова комуникация, сърфирате в уебсайта или използваме някои други функции на сайта по следните начини:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("За да персонализирате вашето преживяване и да ни позволите да доставим типа съдържание и предлагани продукти, от които най-много се интересувате.")]),_vm._v(" "),_c('li',[_vm._v("Да подобрим нашия уебсайт, за да Ви обслужваме по-добре.")]),_vm._v(" "),_c('li',[_vm._v("За да Ви позволим да Ви обслужваме по-добре в отговор на Вашите искания за обслужване на клиенти.")]),_vm._v(" "),_c('li',[_vm._v("За администриране на състезание, промоция, проучване или друга функция на сайта.")]),_vm._v(" "),_c('li',[_vm._v("За бързо обработване на вашите транзакции.")]),_vm._v(" "),_c('li',[_vm._v("Да поискате оценки и рецензии на услуги или продукти")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Как защитаваме вашата информация?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Нашият уебсайт се сканира редовно за дупки в сигурността и известни уязвимости, за да направи вашето посещение на нашия сайт възможно най-безопасно.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Използваме ли бисквитки?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("  Да. „Бисквитките“ са малки файлове, които сайт или негов доставчик на услуги прехвърля на твърдия диск на вашия компютър чрез вашия уеб браузър (ако разрешите), който позволява на системите на сайта или доставчика на услуги да разпознават вашия браузър и да улавят и запомнят определена информация. Например, ние използваме „бисквитки“, за да ни помогнем да запомним и обработим елементите в вашата количка за пазаруване. Те също се използват, за да ни помогнат да разберем вашите предпочитания въз основа на предишна или текуща активност на сайта, което ни позволява да ви предоставяме подобрени услуги. Ние също така използваме бисквитки, за да ни помогнем да съберем обобщени данни за трафика на сайта и взаимодействието на сайта, така че да можем да предложим по-добро преживяване и инструменти на сайта в бъдеще")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ние използваме бисквитки за:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Разберете и запазете предпочитанията на потребителя за бъдещи посещения.")]),_vm._v(" "),_c('li',[_vm._v("Следете рекламите.")]),_vm._v(" "),_c('li',[_vm._v("Компилирайте обобщени данни за трафика на сайта и взаимодействията с него, за да предложите по-добро преживяване и инструменти на сайта в бъдеще. Можем също да използваме доверени услуги на трети страни, които проследяват тази информация от наше име.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Можете да изберете компютърът ви да ви предупреждава всеки път, когато се изпраща бисквитка, или да изключите всички бисквитки. Правите това чрез настройките на браузъра си. Тъй като браузърът е малко по-различен, погледнете менюто за помощ на вашия браузър, за да научите правилния начин за промяна на вашите бисквитки.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Разкриване от трети страни")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ние не продаваме, търгуваме или прехвърляме по друг начин на външни лица Вашата лична информация, освен ако не предоставим на потребителите предварително уведомление. Това не включва партньори за хостинг на уебсайтове и други страни, които ни помагат при експлоатацията на нашия уебсайт, воденето на нашия бизнес или обслужването на нашите потребители, стига тези страни да се съгласят тази информация да бъде поверителна. Можем също така да пуснем информация, когато това е подходящо, за да се съобразим със закона, да приложим правилата на нашия сайт или да защитим нашите или чужди права, собственост")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Въпреки това, нелична информация за посетителите може да бъде предоставена на други страни за маркетинг, реклама или друга употреба.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Връзки на трети страни")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ние не включваме и не предлагаме продукти или услуги на трети страни на нашия уебсайт.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Рекламните изисквания на Google могат да бъдат обобщени от Рекламните принципи на Google. Те са създадени, за да осигурят положително изживяване на потребителите. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Щракнете тук, за да видите")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, като доставчик на трета страна, използва бисквитки, за да показва реклами на нашия сайт. Използването от Google на бисквитката DART му позволява да показва реклами на нашите потребители въз основа на предишни посещения на нашия сайт и други сайтове в Интернет. Потребителите могат да се откажат от използването на бисквитката DART, като посетят Декларацията за поверителност на Google Ad and Content Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Приложихме следното:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ние, заедно с доставчици на трети страни като Google, използваме собствени бисквитки (като бисквитките на Google Analytics) и бисквитки на трети страни (като бисквитката DoubleClick) или други идентификатори на трети страни, за да компилираме данни относно взаимодействието на потребителите с рекламни импресии и други функции за рекламно обслужване, тъй като те се отнасят до нашия уебсайт")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Отказване:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Потребителите могат да зададат предпочитания за начина, по който Google ви рекламира, като използвате страницата за настройки на рекламите в Google. Като алтернатива можете да се откажете, като посетите страницата за отказване на Network Advertising Initiative или като използвате добавения браузър за отказване на Google Analytics")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Нашият сайт позволява ли проследяване на поведението на трети страни?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Също така е важно да се отбележи, че разрешаваме проследяване на поведението на трети страни")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'no')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Denne personvernpolitikken er utarbeidet for bedre å kunne betjene de som er opptatt av hvordan deres 'personlig identifiserbare informasjon' (PII) blir brukt online. Les personvernreglene nøye for å få en klar forståelse av hvordan vi samler inn, bruker, beskytter eller på annen måte håndterer din personlig identifiserbare informasjon i samsvar med nettstedet vårt.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Innholdsleverandør: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adresse: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Hvilken personlig informasjon samler vi inn fra personene som besøker bloggen, nettstedet eller appen vår?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Når du bestiller eller registrerer deg på nettstedet vårt, etter behov, kan du bli bedt om å oppgi navn, e-postadresse, postadresse, telefonnummer eller andre detaljer for å hjelpe deg med din opplevelse.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Når samler vi inn informasjon?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi samler inn informasjon fra deg når du registrerer deg på nettstedet vårt, fyller ut skjema eller skriver inn informasjon på nettstedet vårt. Gi oss tilbakemelding på våre produkter eller tjenester.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Hvordan bruker vi informasjonen din? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi kan bruke informasjonen vi samler inn fra deg når du registrerer deg, kjøper, registrerer deg for vårt nyhetsbrev, svarer på en undersøkelse eller markedsføringskommunikasjon, surfer på nettstedet eller bruker visse andre nettstedsfunksjoner på følgende måter:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("For å tilpasse opplevelsen din og la oss levere den typen innhold og produkttilbud du er mest interessert i.")]),_vm._v(" "),_c('li',[_vm._v("For å forbedre nettstedet vårt for å betjene deg bedre.")]),_vm._v(" "),_c('li',[_vm._v("For å la oss bedre betjene deg når du svarer på kundeserviceforespørslene dine.")]),_vm._v(" "),_c('li',[_vm._v("For å administrere en konkurranse, kampanje, undersøkelse eller annen nettstedsfunksjon.")]),_vm._v(" "),_c('li',[_vm._v("For å raskt behandle transaksjonene dine.")]),_vm._v(" "),_c('li',[_vm._v("Å be om rangeringer og anmeldelser av tjenester eller produkter")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Hvordan beskytter vi informasjonen din?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Nettstedet vårt skannes regelmessig for sikkerhetshull og kjente sårbarheter for å gjøre ditt besøk på nettstedet vårt så trygt som mulig.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bruker vi informasjonskapsler?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ja. Informasjonskapsler er små filer som et nettsted eller dets tjenesteleverandør overfører til datamaskinens harddisk gjennom nettleseren din (hvis du tillater det) som gjør det mulig for nettstedets eller tjenesteleverandørens systemer å gjenkjenne nettleseren din og fange og huske viss informasjon. For eksempel bruker vi informasjonskapsler for å hjelpe oss med å huske og behandle varene i handlekurven din. De brukes også til å hjelpe oss med å forstå dine preferanser basert på tidligere eller nåværende nettstedaktivitet, som gjør det mulig for oss å tilby deg forbedrede tjenester. Vi bruker også informasjonskapsler for å hjelpe oss med å samle samlede data om nettstedstrafikk og nettstedinteraksjon, slik at vi kan tilby bedre nettstedopplevelser og verktøy i fremtiden.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi bruker informasjonskapsler for å:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Forstå og lagre brukerens preferanser for fremtidige besøk")]),_vm._v(" "),_c('li',[_vm._v("Hold oversikt over annonser.")]),_vm._v(" "),_c('li',[_vm._v("Samle samlede data om nettstedstrafikk og nettstedsinteraksjoner for å tilby bedre nettstedopplevelser og verktøy i fremtiden. Vi kan også bruke pålitelige tredjeparts tjenester som sporer denne informasjonen på våre vegne.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Du kan velge å få datamaskinen til å advare deg hver gang en informasjonskapsel blir sendt, eller du kan velge å slå av alle informasjonskapslene. Du gjør dette gjennom nettleserinnstillingene dine. Siden nettleseren er litt annerledes, kan du se på nettleserens Hjelp-meny for å lære den riktige måten å endre informasjonskapslene på.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("РTredjeparts avsløring")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi selger ikke, handler eller på annen måte overfører personlig identifiserbar informasjon til utenforstående parter med mindre vi gir brukerne forhåndsvarsel. Dette inkluderer ikke partnere og andre parter som hjelper oss med å drive nettstedet vårt, drive vår virksomhet eller betjene brukerne våre, så lenge disse partene er enige om å holde denne informasjonen konfidensiell. Vi kan også gi ut informasjon når utgivelsen er hensiktsmessig for å overholde loven, håndheve retningslinjene for nettstedet eller beskytte vår eller andres rettigheter, eiendom")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Imidlertid kan ikke-personlig identifiserbar besøkende bli gitt til andre parter for markedsføring, reklame eller annen bruk.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Tredjeparts lenker")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi inkluderer eller tilbyr ikke tredjepartsprodukter eller tjenester på nettstedet vårt.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Googles annonseringskrav kan oppsummeres av Googles annonseringsprinsipper. De er på plass for å gi brukerne en positiv opplevelse. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Klikk her for å se")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, som tredjepartsleverandør, bruker informasjonskapsler for å vise annonser på nettstedet vårt. Googles bruk av DART-informasjonskapselen gjør det mulig å vise annonser til brukerne våre basert på tidligere besøk på nettstedet vårt og andre nettsteder. Brukere kan velge bort bruk av DART-informasjonskapsel ved å gå til personvernreglene for Google Ad and Content Network.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Vi har implementert følgende:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi, sammen med tredjepartsleverandører som Google, bruker førsteparts informasjonskapsler (for eksempel Google Analytics-informasjonskapsler) og tredjeparts informasjonskapsler (for eksempel DoubleClick-informasjonskapselen) eller andre tredjepartsidentifikatorer sammen for å samle data om brukerinteraksjoner med annonseinntrykk og andre annonsetjenestefunksjoner når det gjelder nettstedet vårt.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Utmelding:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Brukere kan angi preferanser for hvordan Google annonserer for deg ved hjelp av siden Google Annonseinnstillinger. Alternativt kan du velge bort dette ved å gå til siden for Network Advertising Initiative Opt Out eller ved å bruke Google Analytics Opt Out Browser add-on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Tillater nettstedet vårt tredjeparts atferdssporing?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Det er også viktig å merke seg at vi tillater tredjeparts atferdssporing")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySlovakia_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e74d5d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySlovakia_vue__ = __webpack_require__(1440);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicySlovakia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e74d5d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicySlovakia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$t('privacy')))]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"contentPanel",staticStyle:{"padding-top":"5px !important"}},[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Poskytovateľ obsahu: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adresa: 46350 Petaling Jaya, Selangor Darul Ehsan, Malajzia")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Tieto zásady ochrany osobných údajov boli zostavené tak, aby lepšie slúžili tým, ktorí sa zaujímajú o to, ako sa ich „osobné identifikačné údaje“ (PII) používajú online. Prečítajte si pozorne naše pravidlá ochrany osobných údajov, aby ste mali jasnú predstavu o tom, ako zhromažďujeme, používame, chránime alebo inak zaobchádzame s vašimi osobne identifikovateľnými informáciami v súlade s našou webovou stránkou.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Aké osobné informácie zhromažďujeme od ľudí, ktorí navštevujú náš blog, web alebo aplikáciu?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Pri objednávaní alebo registrácii na našom webe môžete byť požiadaní, aby ste zadali svoje meno, e-mailovú adresu, poštovú adresu, telefónne číslo alebo ďalšie podrobnosti, ktoré vám pomôžu s vašimi skúsenosťami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Når samler vi inn informasjon?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi samler inn informasjon fra deg når du registrerer deg på nettstedet vårt, fyller ut skjema eller skriver inn informasjon på nettstedet vårt. Gi oss tilbakemelding på våre produkter eller tjenester.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kedy zhromažďujeme informácie?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Zhromažďujeme od vás informácie, keď sa zaregistrujete na našom webe, vyplníte formulár alebo zadáte informácie na našom webe. Poskytnite nám spätnú väzbu k našim produktom alebo službám.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ako používame vaše informácie?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informácie, ktoré od vás zhromažďujeme, môžeme použiť pri registrácii, nákupe, registrácii na odber nášho bulletinu, odpovedaní na prieskum alebo marketingovú komunikáciu, surfovaní po webových stránkach alebo pri používaní niektorých ďalších funkcií stránok nasledujúcimi spôsobmi:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Na prispôsobenie vašich skúseností a na to, aby sme vám mohli poskytnúť typ obsahu a ponúk produktov, o ktoré sa zaujímate najviac.")]),_vm._v(" "),_c('li',[_vm._v("Vylepšiť našu webovú stránku, aby sme vám mohli lepšie slúžiť.")]),_vm._v(" "),_c('li',[_vm._v("Aby sme vám mohli poskytnúť lepšie služby pri reagovaní na vaše požiadavky na zákaznícke služby.")]),_vm._v(" "),_c('li',[_vm._v("Spravovať súťaž, propagáciu, prieskum alebo inú funkciu stránky.")]),_vm._v(" "),_c('li',[_vm._v("Pre rýchle vybavenie vašich transakcií.")]),_vm._v(" "),_c('li',[_vm._v("Požiadať o hodnotenie a hodnotenie služieb alebo produktov")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ako chránime vaše informácie?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naše webové stránky sú pravidelne kontrolované, či neobsahujú bezpečnostné medzery a známe chyby zabezpečenia, aby bola vaša návšteva našich webových stránok čo najbezpečnejšia.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Používame cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Áno. Súbory cookie sú malé súbory, ktoré stránka alebo jej poskytovateľ služieb prenáša na pevný disk vášho počítača prostredníctvom vášho webového prehliadača (ak to povolíte), ktorý umožňuje systémom stránky alebo poskytovateľa služieb rozpoznať váš prehľadávač a zaznamenať a zapamätať si určité informácie. Používame napríklad súbory cookie, ktoré nám pomáhajú zapamätať si a spracovať položky vo vašom nákupnom košíku. Používajú sa tiež na to, aby nám pomohli pochopiť vaše preferencie založené na predchádzajúcej alebo aktuálnej aktivite stránok, čo nám umožňuje poskytovať vám vylepšené služby. Ďalej používame cookies, ktoré nám pomáhajú kompilovať súhrnné údaje o premávke na webe a interakcii s ním, aby sme v budúcnosti mohli ponúkať lepšie zážitky a nástroje na webe.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Súbory cookie používame na:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pochopte a uložte preferencie používateľa pre budúce návštevy.")]),_vm._v(" "),_c('li',[_vm._v("Sledujte reklamy.")]),_vm._v(" "),_c('li',[_vm._v("Zostavte súhrnné údaje o premávke na webe a interakciách s ním, aby ste v budúcnosti ponúkli lepšie zážitky a nástroje na webe. Môžeme tiež použiť dôveryhodné služby tretích strán, ktoré sledujú tieto informácie v našom mene.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Môžete si zvoliť, aby vás počítač varoval pri každom odoslaní súboru cookie, alebo môžete vypnúť všetky súbory cookie. Urobíte to prostredníctvom nastavení prehľadávača. Pretože sa prehliadač trochu líši, pozrite sa do ponuky Pomocník prehľadávača, aby ste zistili správny spôsob úpravy súborov cookie.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Zverejnenie treťou stranou")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vaše osobné identifikačné údaje nepredávame, neobchodujeme s nimi ani ich nijakým iným spôsobom neprevádzame, pokiaľ na to vopred neposkytneme používateľom oznámenie. Nezahŕňa to hostingových partnerov webových stránok a ďalšie strany, ktoré nám pomáhajú pri prevádzkovaní našich webových stránok, pri podnikaní alebo poskytovaní služieb našim používateľom, pokiaľ sa tieto strany zaviažu zachovávať dôvernosť týchto informácií. Môžeme tiež zverejniť informácie, ak je ich vydanie vhodné na dodržanie zákonov, presadzovanie našich zásad týkajúcich sa webových stránok alebo na ochranu práv alebo majetku našich alebo iných osôb.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informácie o návštevníkoch, ktoré neumožňujú osobnú identifikáciu, však môžu byť poskytnuté iným stranám na marketingové, reklamné alebo iné účely.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Odkazy tretích strán")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Na našu webovú stránku nezahŕňame ani neponúkame produkty alebo služby tretích strán.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Požiadavky spoločnosti Google na inzerciu možno zhrnúť do princípov inzercie spoločnosti Google. ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Sú zavedené s cieľom poskytnúť používateľom pozitívny zážitok. "),_c('a',{attrs:{"href":"https://support.google.com/adspolicy/answer/6008942?hl=en&visit_id=637557114334977110-1263660480&rd=1"}},[_vm._v("Click here to view")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Spoločnosť Google ako dodávateľ tretej strany používa súbory cookie na zobrazovanie reklám na našom webe. Používanie súborov cookie DART spoločnosťou Google jej umožňuje zobrazovať reklamy našim používateľom na základe predchádzajúcich návštev našej stránky a ďalších stránok na internete. Používatelia sa môžu odhlásiť z používania súborov cookie DART navštívením pravidiel ochrany osobných údajov reklamnej a obsahovej siete Google.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Implementovali sme nasledovné:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Spoločne s dodávateľmi tretích strán, ako napríklad Google, používame súbory cookie prvej strany (napríklad súbory cookie Google Analytics) a súbory cookie tretích strán (napríklad súbor cookie DoubleClick) alebo iné identifikátory tretích strán, aby sme zhromaždili údaje týkajúce sa interakcií používateľov s zobrazenia reklám a ďalšie funkcie reklamných služieb, ktoré sa týkajú našej webovej stránky.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Vyradenie:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Používatelia môžu nastaviť predvoľby toho, ako vám Google inzeruje, pomocou stránky Nastavenia reklám Google. Prípadne sa môžete odhlásiť tak, že navštívite stránku Zrušenie iniciatívy Network Advertising Initiative alebo použijete doplnok Prehliadač odhlásenia Google Analytics.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Umožňuje náš web sledovanie správania tretích strán?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Je tiež dôležité poznamenať, že povoľujeme sledovanie správania tretích strán\n")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz' || _vm.countryCode == 'bg' || _vm.countryCode == 'no')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Denna sekretesspolicy har sammanställts för att bättre kunna tjäna dem som är bekymrade över hur deras 'personligt identifierbara information' (PII) används online. Läs vår integritetspolicy noggrant för att få en tydlig förståelse för hur vi samlar in, använder, skyddar eller på annat sätt hanterar din personligt identifierbara information i enlighet med vår webbplats.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content provider: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Vilken personlig information samlar vi in ​​från personerna som besöker vår blogg, webbplats eller app?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("När du beställer eller registrerar dig på vår webbplats kan du bli ombedd att ange ditt namn, e-postadress, postadress, telefonnummer eller andra detaljer för att hjälpa dig med din upplevelse.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("När samlar vi in ​​information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi samlar in information från dig när du registrerar dig på vår webbplats, fyller i ett formulär eller anger information på vår webbplats. Ge oss feedback om våra produkter eller tjänster.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Hur använder vi din information? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi kan använda informationen vi samlar in från dig när du registrerar dig, gör ett köp, registrerar dig för vårt nyhetsbrev, svarar på en undersökning eller marknadsföringskommunikation, surfar på webbplatsen eller använder vissa andra webbplatsfunktioner på följande sätt:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("För att anpassa din upplevelse och låta oss leverera den typ av innehåll och produktutbud som du är mest intresserad av.")]),_vm._v(" "),_c('li',[_vm._v("För att förbättra vår webbplats för att bättre kunna tjäna dig.")]),_vm._v(" "),_c('li',[_vm._v("För att ge oss bättre service när du svarar på dina kundtjänstförfrågningar.")]),_vm._v(" "),_c('li',[_vm._v("För att administrera en tävling, kampanj, undersökning eller annan webbplatsfunktion.")]),_vm._v(" "),_c('li',[_vm._v("För att snabbt behandla dina transaktioner.")]),_vm._v(" "),_c('li',[_vm._v("Att be om betyg och recensioner av tjänster eller produkters")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Hur skyddar vi din information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vår webbplats skannas regelbundet för säkerhetshål och kända sårbarheter för att göra ditt besök på vår webbplats så säker som möjligt.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Använder vi kakor?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Da. Cookie-urile sunt fișiere mici pe care un site sau furnizorul său de servicii le transferă pe hard disk-ul computerului dvs. prin browserul dvs. Web (dacă permiteți), care permite sistemelor site-ului sau ale furnizorului de servicii să vă recunoască browserul și să capteze și să rețină anumite informații. De exemplu, folosim cookie-uri pentru a ne ajuta să ne amintim și să procesăm articolele din coșul de cumpărături. Ele sunt, de asemenea, utilizate pentru a ne ajuta să înțelegem preferințele dvs. pe baza activității anterioare sau actuale a site-ului, ceea ce ne permite să vă oferim servicii îmbunătățite. De asemenea, folosim cookie-uri pentru a ne ajuta să compilăm date agregate despre traficul site-ului și interacțiunea site-ului, astfel încât să putem oferi experiențe și instrumente mai bune pe site în viitor.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi använder cookies för att:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Förstå och spara användarens preferenser för framtida besök.")]),_vm._v(" "),_c('li',[_vm._v("Håll koll på annonser.")]),_vm._v(" "),_c('li',[_vm._v("Samla sammanlagd data om webbplatstrafik och webbplatsinteraktioner för att kunna erbjuda bättre webbplatsupplevelser och verktyg i framtiden. Vi kan också använda betrodda tjänster från tredje part som spårar denna information för våra räkning.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Du kan välja att låta din dator varna varje gång en cookie skickas, eller du kan välja att stänga av alla cookies. Du gör detta via webbläsarinställningarna. Eftersom webbläsaren är lite annorlunda, titta på webbläsarens hjälpmeny för att lära dig rätt sätt att ändra dina cookies.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Utlämnande av tredje part")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi säljer, handlar eller på annat sätt inte överför din personligt identifierbara information till externa parter såvida vi inte förser användare med förvarning. Detta inkluderar inte webbhotellpartners och andra parter som hjälper oss att driva vår webbplats, bedriva vår verksamhet eller betjäna våra användare, så länge dessa parter samtycker till att hålla denna information konfidentiell. Vi kan också släppa information när det är lämpligt att följa lagen, genomdriva vår webbplatspolicy eller skydda vår eller andras rättigheter, egendom")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Icke-personligt identifierbar besökarinformation kan dock ges till andra parter för marknadsföring, reklam eller annan användning.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Länkar från tredje part")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi inkluderar eller erbjuder inte produkter eller tjänster från tredje part på vår webbplats.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Googles reklamkrav kan sammanfattas av Googles reklamprinciper. De är på plats för att ge användarna en positiv upplevelse."),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Klicka här för att se")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, som tredjepartsleverantör, använder cookies för att visa annonser på vår webbplats. Googles användning av DART-kakan gör det möjligt att visa annonser till våra användare baserat på tidigare besök på vår webbplats och andra webbplatser på Internet. Användare kan välja bort DART-kakan genom att besöka sekretesspolicyn för Googles annons- och innehållsnätverk.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Vi har implementerat följande:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi, tillsammans med tredjepartsleverantörer som Google, använder förstapartscookies (som Google Analytics-cookies) och tredjepartscookies (som DoubleClick-cookien) eller andra tredjepartsidentifierare tillsammans för att sammanställa data om användarinteraktioner med annonsvisningar och andra annonstjänstfunktioner när det gäller vår webbplats.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Att välja bort:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Användare kan ställa in inställningar för hur Google annonserar för dig med hjälp av sidan Google Annonsinställningar. Alternativt kan du välja bort detta genom att besöka sidan Network Advertising Initiative Opt Out eller genom att använda Google Analytics Opt Out Browser-tillägg.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Tillåter vår webbplats spårning av beteenden från tredje part?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Det är också viktigt att notera att vi tillåter spårning av beteenden från tredje part")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz' || _vm.countryCode == 'bg' || _vm.countryCode == 'no')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Tämä tietosuojakäytäntö on laadittu palvelemaan paremmin niitä, jotka ovat kiinnostuneita siitä, miten heidän henkilökohtaisesti tunnistettavia tietojaan (PII) käytetään verkossa. Lue tietosuojakäytäntömme huolellisesti saadaksesi selkeän käsityksen siitä, miten keräämme, käytämme, suojaamme tai muuten käsittelemme henkilötietojasi verkkosivustomme mukaisesti.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content provider: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Mitä henkilökohtaisia ​​tietoja keräämme ihmisiltä, ​​jotka vierailevat blogissamme, verkkosivustollamme tai sovelluksessamme?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kun tilaat tai rekisteröidyt sivustollemme, sinua saatetaan tarvittaessa pyytää antamaan nimesi, sähköpostiosoitteesi, postiosoitteesi, puhelinnumerosi tai muita tietojasi kokemuksen parantamiseksi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Milloin keräämme tietoja?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Keräämme tietoja sinulta, kun rekisteröidyt sivustollemme, täytät lomakkeen tai syötät tietoja sivustollemme. Anna meille palautetta tuotteistamme tai palveluistamme.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kuinka käytämme tietojasi? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Voimme käyttää sinulta keräämäämme tietoja, kun rekisteröidyt, ostat, ilmoitat uutiskirjeemme, vastaat kyselyyn tai markkinointiviestintään, surffailemme verkkosivustolla tai käytämme tiettyjä muita sivuston ominaisuuksia seuraavilla tavoilla:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Voit mukauttaa kokemustasi ja antaa meille mahdollisuuden toimittaa sinua kiinnostavinta sisältö- ja tuotetyyppiä.")]),_vm._v(" "),_c('li',[_vm._v("Parantaa verkkosivustoamme palvelemaan sinua paremmin.")]),_vm._v(" "),_c('li',[_vm._v("Jotta voimme palvella sinua paremmin vastaamalla asiakaspalvelupyyntöihisi")]),_vm._v(" "),_c('li',[_vm._v("Kilpailun, kampanjan, kyselyn tai muun sivuston ominaisuuden hallinnoiminen.")]),_vm._v(" "),_c('li',[_vm._v("Tapahtumien nopea käsittelys.")]),_vm._v(" "),_c('li',[_vm._v("Pyydä luokituksia ja arvosteluja palveluista tai tuotteista")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kuinka suojaamme tietojasi?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Verkkosivustomme tarkistetaan säännöllisesti tietoturva-aukkojen ja tunnettujen haavoittuvuuksien varalta, jotta vierailustasi sivustollemme tulisi mahdollisimman turvallista.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Käytämmekö evästeitä?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Joo. Evästeet ovat pieniä tiedostoja, jotka sivusto tai sen palveluntarjoaja siirtää tietokoneen kiintolevylle verkkoselaimesi kautta (jos sallit), jonka avulla sivuston tai palveluntarjoajan järjestelmät voivat tunnistaa selaimesi ja siepata ja muistaa tiettyjä tietoja. Esimerkiksi käytämme evästeitä auttaaksemme meitä muistamaan ja käsittelemään ostoskorissasi olevat tuotteet. Niitä käytetään myös auttamaan meitä ymmärtämään asetuksesi aiemman tai nykyisen sivuston toiminnan perusteella, mikä antaa meille mahdollisuuden tarjota sinulle parempia palveluja. Käytämme myös evästeitä auttaaksemme meitä keräämään koottuja tietoja sivuston liikenteestä ja sivuston vuorovaikutuksesta, jotta voimme tarjota parempia sivustokokemuksia ja työkaluja tulevaisuudessa.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Käytämme evästeitä:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Ymmärrä ja tallenna käyttäjän asetukset tulevia vierailuja varten.")]),_vm._v(" "),_c('li',[_vm._v("Seuraa mainoksia.")]),_vm._v(" "),_c('li',[_vm._v("Kerää koottuja tietoja sivuston liikenteestä ja sivuston vuorovaikutuksesta tarjotaksesi parempia sivustokokemuksia ja työkaluja tulevaisuudessa. Voimme käyttää myös luotettavia kolmannen osapuolen palveluja, jotka seuraavat näitä tietoja puolestamme.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Voit halutessasi pyytää tietokonettasi varoittamaan sinua aina, kun eväste lähetetään, tai voit poistaa kaikki evästeet käytöstä. Teet tämän selaimesi asetusten kautta. Koska selain on hieman erilainen, katso selaimesi Ohje-valikosta oppiaksesi oikea tapa muokata evästeitä.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kolmannen osapuolen paljastaminen")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Emme myy, vaihda tai muuten välitä henkilötietojasi ulkopuolisille osapuolille, ellemme ilmoita asiasta käyttäjille etukäteen. Tämä ei sisällä verkkosivustojen isännöintikumppaneita eikä muita osapuolia, jotka auttavat meitä verkkosivustomme toiminnassa, liiketoiminnassamme tai palvelemisessa käyttäjillemme, kunhan osapuolet sitoutuvat pitämään nämä tiedot luottamuksellisina. Voimme myös julkaista tietoja, kun niiden julkaisu on tarkoituksenmukaista lain noudattamiseksi, sivustokäytäntöjemme noudattamiseksi tai omien tai muiden oikeuksien, omaisuuden suojaamiseksi")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Henkilökohtaisesti tunnistamatonta vierailijatietoa voidaan kuitenkin antaa muille osapuolille markkinointia, mainontaa tai muuta käyttöä varten.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kolmannen osapuolen linkit")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Emme sisälly tai tarjoa kolmannen osapuolen tuotteita tai palveluja verkkosivustollamme.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Googlen mainontavaatimukset voidaan tiivistää Googlen mainontaperiaatteilla. Ne perustetaan tarjoamaan käyttäjille positiivinen kokemus. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Napsauta tätä nähdäksesi")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google käyttää kolmannen osapuolen toimittajina evästeitä mainosten näyttämiseen sivustollamme. Googlen DART-evästeen käyttö antaa sen näyttää mainoksia käyttäjillemme aiempien vierailujen perusteella sivustollamme ja muilla Internet-sivustoilla. Käyttäjät voivat kieltäytyä DART-evästeen käytöstä vierailemalla Googlen mainos- ja sisältöverkoston tietosuojakäytännössä.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Olemme toteuttaneet seuraavat:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Me yhdessä kolmansien osapuolten toimittajien, kuten Google, kanssa käytämme ensimmäisen osapuolen evästeitä (kuten Google Analytics -evästeitä) ja kolmannen osapuolen evästeitä (kuten DoubleClick -eväste) tai muita kolmannen osapuolen tunnisteita keräämään tietoja käyttäjien vuorovaikutuksesta käyttäjien kanssa. mainosten näyttökerrat ja muut mainospalvelutoiminnot, jotka liittyvät verkkosivustoomme.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kieltäytyminen:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Käyttäjät voivat asettaa asetuksia sille, miten Google mainostaa sinulle, käyttämällä Google-mainosasetussivua. Vaihtoehtoisesti voit kieltäytyä käymällä Network Advertising Initiative Opt Out -sivulla tai käyttämällä Google Analytics Opt Out Browser -lisäosaa.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Sallitseeko sivustomme kolmannen osapuolen käyttäytymisen seurannan?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("On myös tärkeää huomata, että sallimme kolmannen osapuolen käyttäytymisen seurannan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz' || _vm.countryCode == 'bg' || _vm.countryCode == 'no')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Această politică de confidențialitate a fost compilată pentru a servi mai bine celor care sunt preocupați de modul în care „Informațiile de identificare personală” (PII) sunt utilizate online. Vă rugăm să citiți cu atenție politica noastră de confidențialitate pentru a obține o înțelegere clară a modului în care colectăm, folosim, protejăm sau gestionăm în alt mod informațiile dvs. de identificare personală în conformitate cu site-ul nostru web.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content provider: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ce informații personale colectăm de la persoanele care vizitează blogul, site-ul sau aplicația noastră?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Când comandați sau vă înregistrați pe site-ul nostru, după caz, vi se poate solicita să introduceți numele dvs., adresa de e-mail, adresa poștală, numărul de telefon sau alte detalii pentru a vă ajuta cu experiența dvs.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Când colectăm informații?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Colectăm informații de la dvs. atunci când vă înregistrați pe site-ul nostru, completați un formular sau introduceți informații pe site-ul nostru. Oferiți-ne feedback cu privire la produsele sau serviciile noastre.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Cum folosim informațiile dvs.? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Putem folosi informațiile pe care le colectăm de la dvs. atunci când vă înregistrați, faceți o achiziție, vă înscrieți la newsletter-ul nostru, răspundeți la un sondaj sau la o comunicare de marketing, navigați pe site-ul web sau puteți utiliza anumite alte caracteristici ale site-ului în următoarele moduri:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pentru a vă personaliza experiența și a ne permite să livrăm tipul de conținut și ofertele de produse care vă interesează cel mai mult.")]),_vm._v(" "),_c('li',[_vm._v("Pentru a ne îmbunătăți site-ul web pentru a vă servi mai bine.")]),_vm._v(" "),_c('li',[_vm._v("Pentru a ne permite să vă oferim servicii mai bune pentru a răspunde solicitărilor dvs. de servicii pentru clienți")]),_vm._v(" "),_c('li',[_vm._v("Pentru a administra un concurs, promovare, sondaj sau altă caracteristică a site-ului.")]),_vm._v(" "),_c('li',[_vm._v("Pentru a vă procesa rapid tranzacțiiles.")]),_vm._v(" "),_c('li',[_vm._v("Pentru a solicita evaluări și recenzii de servicii sau produse")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Cum vă protejăm informațiile?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Site-ul nostru web este scanat în mod regulat pentru a găsi găuri de securitate și vulnerabilități cunoscute pentru a vă face vizita pe site-ul nostru cât mai sigură posibil.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Folosim cookie-uri?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ja. Cookies är små filer som en webbplats eller dess tjänsteleverantör överför till din dators hårddisk via din webbläsare (om du tillåter det) som gör det möjligt för webbplatsens eller tjänsteleverantörens system att känna igen din webbläsare och fånga och komma ihåg viss information. Vi använder till exempel cookies för att hjälpa oss att komma ihåg och bearbeta artiklarna i din kundvagn. De används också för att hjälpa oss att förstå dina preferenser baserat på tidigare eller aktuell webbplatsaktivitet, vilket gör att vi kan erbjuda dig förbättrade tjänster. Vi använder också cookies för att hjälpa oss att sammanställa aggregerad data om webbplatstrafik och webbplatsinteraktion så att vi kan erbjuda bättre webbplatsupplevelser och verktyg i framtiden.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Folosim cookie-uri pentru:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Înțelegeți și salvați preferințele utilizatorului pentru vizitele viitoare.")]),_vm._v(" "),_c('li',[_vm._v("Țineți evidența reclamelor.")]),_vm._v(" "),_c('li',[_vm._v("Compilați date agregate despre traficul site-ului și interacțiunile site-ului pentru a oferi experiențe și instrumente mai bune pe site în viitor. De asemenea, putem folosi servicii terțe de încredere care urmăresc aceste informații în numele nostru.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Puteți alege ca computerul să vă avertizeze de fiecare dată când este trimis un cookie sau puteți alege să dezactivați toate cookie-urile. Faceți acest lucru prin setările browserului. Deoarece browserul este puțin diferit, uitați-vă la meniul de ajutor al browserului dvs. pentru a afla modul corect de modificare a cookie-urilor.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Divulgarea terților")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Nu vindem, comercializăm sau transferăm în alt mod către părți externe Informațiile dvs. de identificare personală, cu excepția cazului în care furnizăm utilizatorilor o notificare prealabilă. Aceasta nu include parteneri de găzduire de site-uri web și alte părți care ne asistă în operarea site-ului nostru web, în ​​desfășurarea afacerii noastre sau în deservirea utilizatorilor noștri, atât timp cât acele părți sunt de acord să păstreze confidențialitatea acestor informații. De asemenea, putem elibera informații atunci când eliberarea acestora este adecvată pentru a respecta legea, pentru a aplica politicile site-ului nostru sau pentru a proteja drepturile, proprietatea noastră sau a altora.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Cu toate acestea, informații despre vizitatori care nu pot fi identificate personal pot fi furnizate altor părți pentru marketing, publicitate sau alte utilizări.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Link-uri terță parte")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Nu includem sau oferim produse sau servicii terțe pe site-ul nostru.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Cerințele publicitare ale Google pot fi rezumate prin Principiile de publicitate ale Google. Acestea sunt create pentru a oferi utilizatorilor o experiență pozitivă. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Faceți clic aici pentru a vizualiza")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, ca furnizor terț, folosește cookie-uri pentru a difuza reclame pe site-ul nostru. Utilizarea de către Google a cookie-ului DART îi permite să difuzeze reclame utilizatorilor noștri pe baza vizitelor anterioare pe site-ul nostru și pe alte site-uri de pe Internet. Utilizatorii pot renunța la utilizarea cookie-ului DART vizitând politica de confidențialitate Google Ad și Rețeaua de conținut.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Am implementat următoarele:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Noi, împreună cu furnizori terți, precum Google folosim cookie-uri proprii (cum ar fi cookie-urile Google Analytics) și cookie-uri terțe (cum ar fi cookie-ul DoubleClick) sau alți identificatori terți împreună pentru a compila date privind interacțiunile utilizatorilor cu afișările de anunțuri și alte funcții ale serviciului publicitar, în legătură cu site-ul nostru web.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Renunțare:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Utilizatorii pot seta preferințe pentru modul în care Google vă face publicitate utilizând pagina Setări pentru anunțuri Google. Alternativ, puteți renunța accesând pagina de renunțare la inițiativa de publicitate în rețea sau utilizând suplimentul browserului de renunțare Google Analytics.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Site-ul nostru permite urmărirea comportamentală a terților?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("De asemenea, este important să rețineți că permitem urmărirea comportamentală terță parte")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.language == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.language == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.language == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.language == 'slovakia')?_c('span',[_c('privacy-slovakia')],1):(_vm.lang_a4all == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_a4all == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_a4all == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4484e440_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(1453);
function injectStyle (ssrContext) {
  __webpack_require__(1446)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4484e440"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4484e440_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4beecdb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__ = __webpack_require__(1448);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4beecdb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$t("terms")))]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"contentPanel",staticStyle:{"padding-top":"5px !important"}},[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Použitelnost")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Níže uvedené podmínky (Všeobecné podmínky) platí pro\n                    anglickou verzi jednorázové placené služby Mobiscope\n                    Premium (Puretech Global Sdn Bhd a / nebo Služba) nabízené\n                    online prostřednictvím internetu od společnosti Puretech\n                    Global Sdn Bhd (dále jen jako Puretech Global Sdn Bhd).\n                    Koncový uživatel vyžaduje službu Mobiscope od společnosti\n                    Puretech Global Sdn Bhd.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Obvykle")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Mobiscope poskytuje nejlepší sexy tapety a videa výhradně\n                    pro váš mobil.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n                    Potvrzení / registrace\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Aby měl koncový uživatel přístup k Mobiscope, musí zadat\n                    číslo svého mobilního telefonu a / nebo určitá další data\n                    a / nebo informace prostřednictvím propagační webové\n                    stránky (Landing Pages) provozované společností Puretech\n                    Global Sdn Bhd. Poté koncový uživatel obdrží na své\n                    mobilní zařízení SMS, s osobním identifikačním číslem (PIN\n                    kód), nebo takzvanou nabídkovou zprávou s informacemi o\n                    službě. Koncový uživatel zadáním přijatého PIN kódu na\n                    úvodní stránce a / nebo odesláním potvrzovací zprávy a /\n                    nebo používáním služby potvrzuje a potvrzuje, že si\n                    přečetl Všeobecné podmínky, je autorizovaným majitelem\n                    účtu mobilního telefonu nebo má souhlas plátce telefonního\n                    účtu s využitím této služby. Koncový uživatel obdrží\n                    potvrzovací SMS zprávu o úspěšné aktivaci služby\n                    Mobiscope, způsobu, frekvenci a nákladech na stažení\n                    Služby a také přesné údaje o odhlášení.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Náklady a poplatky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Mobiscope je placená služba, která stojí 3 SMS x 1,60 EUR\n                    / týden Poplatek bude účtován na účet za mobilní telefon\n                    nebo na předplacené mobilní číslo. Způsob účtování je\n                    Premium MT SMS zasílaná Koncovému uživateli na základě\n                    jeho požadavku na službu Mobiscope. Tato zpráva bude\n                    obsahovat vaše přihlášení do Mobiscope. Poplatky se\n                    vybírají podle provozovatelů mobilních sítí. Poplatky jsou\n                    odepsány na účet Koncového uživatele Provozovatelem; v\n                    případě SIM s předplatným jsou poplatky odečteny z kreditu\n                    Koncového uživatele. Koncový uživatel tímto výslovně\n                    uděluje své oprávnění účtovat poplatky a zavazuje se\n                    uhradit v plné výši poplatky vzniklé v důsledku\n                    předplatného a / nebo používání služby Mobiscope. Pokud\n                    nejste osobou odpovědnou za zaplacení účtu za mobilní\n                    telefon, před přihlášením a / nebo použitím Mobiscope si\n                    prosím vyžádejte povolení od svého mobilního plátce.\n                    Podpisem a / nebo účastí ve službě Puretech Global Sdn Bhd\n                    předpokládá, že koncový uživatel získal potřebné povolení,\n                    souhlas nebo schválení od plátce mobilního účtu,\n                    opatrovníka nebo rodičů. Všechny SMS zprávy zasílané\n                    koncovým uživatelem budou mobilním operátorem koncového\n                    uživatele účtovány za standardní tarif. Tyto sazby se\n                    mohou u jednotlivých operátorů lišit. Další informace o\n                    poplatcích vám poskytne váš mobilní operátor GSM.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Pomoc a podpora")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Zákaznický servis je k dispozici v pracovní dny od 09:00\n                    do 17:00 Kontakt: +421 313215999 nebo\n                    mobiscope.cz@silverlines.info\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Duševní vlastnictví")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Službu můžete používat pro osobní, nekomerční použití.\n                    Pojem Mobiscope a všechny ostatní ochranné známky,\n                    servisní značky a / nebo obchodní názvy používané\n                    společností Mobiscope ve Službě čas od času (ochranné\n                    známky) jsou ochranné známky, servisní značky a / nebo\n                    obchodní názvy společnosti Puretech Global Sdn Bhd nebo\n                    jedné z jejích společností v skupina nebo její\n                    poskytovatelé licencí a tyto subjekty si vyhrazují veškerá\n                    práva k ochranným známkám. Kromě toho další obsah Služby,\n                    mimo jiné včetně her, obrázků, obrázků, grafik,\n                    fotografií, animací, videí, hudby, zvuku a textu, patří\n                    společnosti Mobiscope nebo jedné z jejích společností a /\n                    nebo licencovaných skupin a je chráněn autorským právem a\n                    / nebo jinými právy duševního vlastnictví. Berete na\n                    vědomí, že používáním Služby nezískáte žádná práva na\n                    ochrannou známku ani Obsah Služby, než jak je uvedeno v\n                    této Smlouvě. Za žádných okolností nesmíte za žádných\n                    okolností kopírovat jakýkoli obsah služby (včetně, bez\n                    omezení, vědomostních otázek, odpovědí nebo her), ani ve\n                    službě používat dolování dat, roboty, škrábance na\n                    obrazovce nebo podobné nástroje pro sběr a extrakci dat.\n                    Odpovědnost Používání Mobiscope a / nebo webových stránek\n                    Mobiscope je na vlastní riziko koncového uživatele.\n                    Koncový uživatel musí poskytnout plně kompatibilní mobilní\n                    telefon, hardware nebo jiná zařízení a software a\n                    zajistit, aby byly funkční a vhodné pro služby Mobiscope.\n                    Mobiscope nemůže zaručit, že služby Mobiscope splňují\n                    požadavky koncového uživatele a že stahování, přijímání a\n                    / nebo prohlížení služeb Mobiscope proběhne bez přerušení\n                    nebo chyb. Pokud koncový uživatel nemůže kdykoli využívat\n                    službu Puretech Global Sdn Bhd bez přerušení, v žádném\n                    případě to nezakládá právo na snížení poplatků za služby\n                    Mobiscope, jakékoli právo na vrácení předplacených plateb.\n                    Jakékoli použití služeb Mobiscope je na uvážení a riziku\n                    koncového uživatele, a to za, nikoli však výhradně,\n                    infekci nebo kontaminaci, ztrátu dat nebo poškození\n                    hardwaru a / nebo softwaru koncového uživatele v důsledku\n                    přístup na webové stránky nebo používání služeb Mobiscope\n                    nebo stažených služeb Mobiscope, včetně hardwaru a\n                    softwaru nutného pro připojení ke službám Mobiscope. Je\n                    odpovědností koncových uživatelů, aby přijali nezbytná\n                    opatření, která zabrání možnému poškození tohoto druhu. V\n                    případě, že je společnost Mobiscope z jakéhokoli důvodu\n                    povinna nahradit koncovému uživateli přímé nebo následné\n                    škody jakéhokoli druhu, nesmí tato náhrada v žádném\n                    případě překročit hodnotu faktury za služby Mobiscope,\n                    kterou koncový uživatel zaplatil za údajné škody. Obsah\n                    webových stránek byl sestaven s největší péčí. Společnost\n                    Mobiscope však nemůže poskytnout žádnou záruku, pokud jde\n                    o povahu, přesnost nebo obsah těchto informací. Mobiscope\n                    nenese odpovědnost za chyby, opomenutí, nepřesnosti,\n                    nedorozumění, zpoždění nebo nečitelné objednávky nebo\n                    oznámení založená na používání internetu nebo příslušného\n                    informačního bodu. Závěrečná ustanovení Veškeré spory\n                    týkající se plnění těchto Obchodních podmínek budou řešit\n                    příslušné obecné soudy. Puretech Global Sdn Bhd si\n                    vyhrazuje právo čas od času tyto podmínky změnit. Změny\n                    budou koncovým uživatelům oznámeny zveřejněním na portálu\n                    Mobiscope.\n                  ")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289eb698_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(1450);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289eb698_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$t("terms")))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"contentPanel",staticStyle:{"padding-top":"5px !important"}},[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Help and support")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Customer service is available on working days from 09:00\n                    to 17:00 Contact: +421 313215999 or\n                    mobiscope."+_vm._s(_vm.countryCode)+"@silverlines.info\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Applicability")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    The terms and conditions below (General Terms and\n                    Conditions) apply to the English version of Mobiscope Premium (Puretech Global Sdn Bhd\n                    and / or the Service) offered online via the Internet from\n                    Puretech Global Sdn Bhd (hereinafter referred to as\n                    Puretech Global Sdn Bhd). The end user requires the\n                    Mobiscope service from Puretech Global Sdn Bhd.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n                   Generally\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                   Mobiscope provides the user with access, all the possibilities of playing and unlocking, and reveals the secrets that block the path to success and peace.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n                    Confirmation / Registration\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    To access Mobiscope, End User must provide their mobile\n                    phone number and / or certain other data and / or\n                    information through a promotional website (Landing Pages)\n                    operated by Puretech Global Sdn Bhd. Then the End User\n                    will receive an SMS on his mobile device, with a Personal\n                    Identification Number (PIN code), or a so-called offer\n                    message with information about the service. By entering\n                    the received PIN code on the landing page and / or sending\n                    a confirmation message and / or using the service, the End\n                    User acknowledges and confirms that he has read the\n                    General Terms and Conditions, is an authorized mobile\n                    phone account holder or has the consent of the telephone\n                    account payer to use this service. The end user will\n                    receive a confirmation SMS message about the successful\n                    activation of the Mobiscope service, the method, frequency\n                    and costs of downloading the Service, as well as the exact\n                    details of the logout.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Costs and Fees")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Mobiscope is a paid service that costs 3 SMS x 1.60 EUR /\n                    week The fee will be charged to a mobile phone bill or a\n                    prepaid mobile number. The method of charging is Premium\n                    MT SMS sent to the End User based on his request for the\n                    Mobiscope service. This message will include your\n                    Mobiscope login. Fees are collected according to Mobile\n                    Network Operators. Fees are written off against the End\n                    User's account by the Operator; in the case of a\n                    pre-subscription SIM, the fees are deducted from the End\n                    User's credit. The End User hereby expressly grants his or\n                    her authorization to charge, and undertakes to pay in full\n                    for the fees incurred as a result of subscribing to and /\n                    or using the Mobiscope Service. If you are not the person\n                    responsible for paying your mobile bill, please obtain\n                    permission from your mobile payer before signing in and /\n                    or using Mobiscope. By signing and / or participating in\n                    the Service, Puretech Global Sdn Bhd assumes that the End\n                    User has obtained the necessary permission, consent or\n                    approval from the mobile account payer, guardian or\n                    parents. All SMS messages sent by the End User will be\n                    charged by the End User's mobile operator at a standard\n                    tariff. These rates may vary by operator. Please contact\n                    your GSM operator for more information on charges.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n                    Intellectual Property\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    You may use the Service for your personal, non-commercial\n                    use. The term Mobiscope and all other trademarks, service\n                    marks and / or trade names used by Mobiscope on the\n                    Service from time to time (Trademarks) are trademarks,\n                    service marks and / or trade names of Puretech Global Sdn\n                    Bhd or one of its companies in the group or its licensors,\n                    and these entities reserve all rights to the Trademarks.\n                    In addition, other content of the Service, including, but\n                    not limited to, Games, images, pictures, graphics,\n                    photographs, animations, videos, music, sound and text\n                    belongs to Mobiscope or one of its companies and / or\n                    licensed groups, and is protected by copyright and / or\n                    other intellectual property rights. You acknowledge that,\n                    through your use of the Service, you will not acquire any\n                    trademark rights or Content of the Service other than as\n                    set forth in this Agreement. In particular, under no\n                    circumstances may you copy any Content of the Service\n                    (including, without limitation, trivia questions, answers,\n                    or games), or use data mining, robots, screen scratches,\n                    or similar data collection and extraction tools on the\n                    Service. Responsibility The use of Mobiscope and / or the\n                    Mobiscope website is at the end user's own risk. The end\n                    user must provide an all-compatible mobile phone,\n                    hardware, or other devices and software, and ensure that\n                    they are operational and suitable for Mobiscope services.\n                    Mobiscope cannot guarantee that Mobiscope services meet\n                    the requirements of the end user and that downloading,\n                    receiving and / or viewing Mobiscope services will be\n                    without interruption or error. If at any time the End User\n                    is unable to use the Puretech Global Sdn Bhd service\n                    without interruption, this in no way leads to the right to\n                    a reduction in the fees for Mobiscope services, to any\n                    right to a refund of prepaid payments. Any use of\n                    Mobiscope Services is at the end user's discretion and\n                    risk, and that for no, but not limited to, infection, or\n                    contamination, or loss of data, or damage (s) to end-user\n                    hardware and / or software resulting from access to the\n                    Website , or use of Mobiscope Services, or downloaded\n                    Mobiscope Services, including hardware and software\n                    required to connect to Mobiscope Services. It is the\n                    responsibility of end-users to take the necessary measures\n                    to prevent possible damage to this species. In the event\n                    that Mobiscope is obliged for any reason to compensate the\n                    end user for direct or consequential damages of any kind,\n                    such compensation may in no case exceed the value of the\n                    invoice for Mobiscope services paid by the end user for\n                    the alleged damages. The content of the Website has been\n                    compiled with the greatest care. However, Mobiscope cannot\n                    provide any guarantee as to the nature, accuracy or\n                    content of this information. Mobiscope shall not be liable\n                    for any errors, omissions, inaccuracies,\n                    misunderstandings, delays, or illegible orders, or notices\n                    based on the use of the Internet or the relevant\n                    information point. Final Provisions Any disputes\n                    concerning the fulfillment of these Business Conditions\n                    will be resolved by the competent general courts. Puretech\n                    Global Sdn Bhd reserves the right to change these terms\n                    from time to time. Changes will be announced to end users\n                    by posting on the Mobiscope portal.\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSlovakia_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3c352ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovakia_vue__ = __webpack_require__(1452);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSlovakia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3c352ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovakia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container section__content"},[_c('h2',{staticClass:"std__subtile daily"},[_vm._v(_vm._s(_vm.$t("terms")))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"contentPanel",staticStyle:{"padding-top":"5px !important"}},[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Pomoc a podpora")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Zákaznícky servis je k dispozícii v pracovných dňoch od\n                    09:00 do 17:00 Kontakt: +421 313215999 alebo\n                    mobiscope."+_vm._s(_vm.countryCode)+"@silverlines.info\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Použiteľnosť")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Podmienky a pravidlá uvedené nižšie (Všeobecné podmienky a\n                    Podmienky) sa vzťahujú na anglickú verziu Mobiscope Premium (Puretech Global Sdn Bhd\n                    a/alebo Služba) ponúkané online cez internet od\n                    Puretech Global Sdn Bhd (ďalej len\n                    Puretech Global Sdn Bhd). Koncový užívateľ vyžaduje\n                    Služba Mobiscope od Puretech Global Sdn Bhd.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n                   Vo všeobecnosti\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                  Či už hľadáte dennú astrológiu alebo týždennú alebo mesačnú astrológiu, Mobiscope sa na vás pozrel. Mobiscope poskytuje užívateľovi prístup, všetky možnosti hrania a odomykania a odhaľuje tajomstvá, ktoré blokujú cestu k úspechu a mieru.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n                    Potvrdenie / Registrácia\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Na vstup do služby Mobiscope musí Koncový používateľ zadať\n                    svoje mobilné telefónne číslo a /alebo niektoré ďalšie\n                    údaje a /alebo informácie prostredníctvom propagačnej\n                    webovej stránky (Vstupné Stránky) prevádzkovanej Puretech\n                    Global Sdn Bhd -om. Potom Koncový užívateľ dostane SMS vo\n                    svojom mobilnom zariadení, s Osobným Identifikačným Číslom\n                    (PIN kód), alebo tzv ponukovú správu s informáciami o\n                    službe. Zadaním obdržaného PIN kódu na vstupnej stránke a\n                    /alebo zaslaním potvrdzovacej správy a /alebo používaním\n                    služby Koncový užívateľ uznáva a potvrdzuje, že prečítal\n                    Všeobecné obchodné podmienky, je oprávneným držiteľom\n                    mobilného účtu za telefón, alebo má súhlas platiteľa\n                    telefóneho účtu používať túto službu. Koncový užívateľ\n                    dostane potvrdzujúcu SMS správu o úspešnej aktivácii\n                    Mobiscope služby, spôsobe, frekvencii a nákladov na\n                    prevzatie Služby, rovnako ako presné detaily odhlásenia.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Náklady a Poplatky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Mobiscope je platená služba ktorá stojí 3 SMS x 1.60 EUR /\n                    týždeň Poplatok bude účtovaný na mobilný telefónny účet,\n                    alebo predplatené mobilné číslo.Spôsob nabíjania je\n                    Premium MT SMSkami odoslanými na Koncového užívateľa na\n                    základe jeho žiadosti o službu Mobiscope. Táto správa bude\n                    obsahovať prihlasovacie údaje k službe Mobiscope. Poplatky\n                    sú vyberané podľa Prevádzkovateľov Mobilných Sietí.\n                    Poplatky sú odpísané proti účtu Koncového užívateľa\n                    Prevádzkovateľom, v prípade predplantnej SIM sa poplatky\n                    odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ\n                    týmto výslovne udeľuje jeho alebo jej oprávnenie pre\n                    nabíjanie, a zaväzuje sa na zaplatenie v plnej výške za\n                    poplatky, ktoré vznikli v dôsledku upísania a / alebo\n                    používania služby Mobiscope. Ak nie ste osoba zodpovedná\n                    za zaplatenie mobilného účtu, prosím, získajte povolenie\n                    od platiteľa mobilu pred prihlásením a /alebo používaním\n                    služby Mobiscope. Svojím podpisom a /alebo účasťou na\n                    službe, Puretech Global Sdn Bhd predpokladá, že Koncový\n                    užívateľ získal potrebné povolenie, súhlas alebo\n                    schválenie od platiteľa mobilného účtu, opatrovníka alebo\n                    rodičov. Všetky SMS správy zaslané Koncovým používateľom\n                    budú účtované mobilným operátorom Koncového užívateľa\n                    štandardnou tarifou. Tieto tarify sa môžu líšiť podľa\n                    operátora. Prosím, pre viac nformácií o uložených\n                    poplatkoch kontaktujte svojho GSM operátora.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Duševné vlastníctvo")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n                    Službu môžete použiť na svoje osobné nekomerčné použitie.\n                    Termín Mobiscope a všetky ostatné ochranné známky,\n                    servisné značky a /alebo obchodné názvy používané\n                    Mobiscope-om na Službe z času na čas (Ochranné Známky), sú\n                    ochrannými známkami, servisnými značkami a /alebo\n                    obchodnými názvami Puretech Global Sdn Bhd - u alebo\n                    jednej z jeho spoločností v skupine alebo udeľovateľov jej\n                    licencie, a tieto subjekty si vyhradzujú všetky práva na\n                    Ochranné Známky. Okrem toho, ďalší obsah Služby, vrátane,\n                    ale nie výhradne, Hry, obrázy, obrázky, grafika,\n                    fotografie, animácie, videá, hudba, zvuk a text patria\n                    Mobiscope- u, alebo jednému z jeho spoločností a /alebo\n                    licenčných skupín, a sú chránené autorskými právami a\n                    /alebo inými právami duševného vlastníctva. Beriete týmto\n                    na vedomie, že pri používaní Služby nezískate žiadne práva\n                    na ochranné známky, alebo Obsah Služby, než ako je uvedené\n                    v tejto Dohode. Najmä za žiadnych okolností nemôžete\n                    skopírovať ľubovoľný Obsah Služby (vrátane a bez\n                    obmedzenia trivia otázky, odpovede, alebo hry), alebo\n                    využívať dolovanie dát, roboty, škrabanie obrazovky, alebo\n                    podobné zhromažďovanie údajov a extrakčné nástroje na\n                    Službe. Zodpovednosť Použitie Mobiscope- u a /alebo web\n                    stránky Mobiscopeprebieha na vlastné riziko koncového\n                    užívateľa. Koncový užívateľ musí poskytnúť všetko-\n                    kompatibilný mobilný telefón, hardvér, alebo iné\n                    zariadenia a softvér, a zabezpečiť, aby boli v\n                    prevádzkyschopnom stave a vhodné na služby Mobiscope.\n                    Mobiscope nemôže zaručiť, že služby Mobiscope spĺňajú\n                    požiadavky koncového užívateľa, a že stiahnutie, príjem a\n                    /alebo prezeranie služieb Mobiscope bude bez prerušenia,\n                    alebo chýb. Ak kedykoľvek Koncový užívateľ nie je schopný\n                    používať bez prerušenia službu Puretech Global Sdn Bhd , v\n                    žiadnom prípade to nevedie k nároku na zníženie poplatkov\n                    za Mobiscope služby, k akékoľvek právo na vrátenie platieb\n                    dopredu zaplatených. Akékoľvek použitie služieb Mobiscope\n                    je podľa vlastného uváženia a rizika koncového užívateľa,\n                    a že za žiadny ale nie obmedzene, za infekcie, alebo\n                    kontaminácie, alebo straty dát, alebo poškodenie(ia)\n                    hardvéru a /alebo softvéru koncových užívateľov,\n                    vyplývajúcich z prístupu k webovým stránkam, alebo\n                    využívania služieb Mobiscope -u, alebo stiahnutých\n                    Mobiscope služieb, vrátane hardvéru a softvéru\n                    vyžadovaného na pripojenie k službám Mobiscope. Je\n                    zodpovednosťou koncových užívateľov, aby prijali potrebné\n                    opatrenia, aby sa zabránilo možnému poškodeniu tohto\n                    druhu. V prípade, že Mobiscope je z akéhokoľvek dôvodu\n                    povinný nahradiť koncovému užívateľovi priame, alebo\n                    následné škody akéhokoľvek druhu, takáto náhrada v žiadnom\n                    prípade nesmie prekročiť hodnotu faktúry za služby\n                    Mobiscope , platených koncovým užívateľom pre údajné\n                    poškodenia. Obsah Webovej stránky bol zostavený s\n                    najväčšou starostlivosťou. Avšak, Mobiscope nemôže\n                    poskytnúť žiadnu záruku, pokiaľ ide o povahu, presnosť\n                    alebo obsah týchto informácií. Mobiscope nenesie\n                    zodpovednosť za akékoľvek chyby, opomenutia, nepresnosti,\n                    nedorozumenia, oneskorenie, alebo nečitateľné objednávky,\n                    alebo oznámenia na základe používania Internetu, alebo\n                    príslušného informačného miesta. Záverečné ustanovenia\n                    Akékoľvek spory týkajúce sa plnenia týchto Obchodných\n                    podmienok budú riešené príslušnými všeobecnými súdmi.\n                    Puretech Global Sdn Bhd si vyhradzuje právo čas od času\n                    zmeniť tieto podmienky. Zmeny budú oznámené koncovým\n                    užívateľom vyvesením na portáli Mobiscope.\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.language == 'slovakia')?_c('span',[_c('terms-slovakia')],1):(_vm.language == 'czech')?_c('span',[_c('terms-czech')],1):_c('span',[_c('terms-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ec538a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1457);
function injectStyle (ssrContext) {
  __webpack_require__(1455)
  __webpack_require__(1456)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8ec538a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ec538a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navbar__wrap"},[_c('nav',{staticClass:"siteNav"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"siteNav__col"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":_vm.auth_mobis === 'loggedin' || _vm.auth_mobis === 'guest'  ? '/home' : ''}},[_c('img',{attrs:{"src":__webpack_require__(1458)}})]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',{staticClass:"navLinks__item active"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticClass:"text_col",staticStyle:{"text-decoration":"none"},attrs:{"to":"/horoscope"}},[_vm._v(_vm._s(_vm.$t("horoscope")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"text_dummmy",on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("horoscope")))]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticClass:"text_col",staticStyle:{"text-decoration":"none"},attrs:{"to":"/tarot"}},[_vm._v(_vm._s(_vm.$t("tarot")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"text_dummmy",on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("tarot")))]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item dropdown"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticClass:"text_col",staticStyle:{"text-decoration":"none"},attrs:{"to":"/chinesezodiac"}},[_vm._v(_vm._s(_vm.$t("chinese_zodiac")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"text_dummmy",on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("chinese_zodiac")))]):_vm._e()],1),_vm._v(" "),(_vm.countryCode === 'cz' || _vm.countryCode === 'sk')?_c('li',{staticClass:"navLinks__item dropdown"},[_c('router-link',{staticClass:"text_col",staticStyle:{"text-decoration":"none"},attrs:{"to":"/privacy"}},[_vm._v(_vm._s(_vm.$t("privacy")))])],1):_vm._e(),_vm._v(" "),(_vm.countryCode === 'cz'|| _vm.countryCode === 'sk')?_c('li',{staticClass:"navLinks__item dropdown"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/terms"}},[_vm._v(_vm._s(_vm.$t("terms")))])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"navLinks__item dropdown"})])],1),_vm._v(" "),_c('div',{staticClass:"siteNav__col"},[_c('div',{staticClass:"langPanel"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"langButton",attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton)}})]),_vm._v(" "),_c('div',{staticClass:"accountInfo"},[(_vm.auth_mobis == '')?_c('div'):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'loggedin')?_c('div',[(_vm.countryCode === 'om' || _vm.countryCode === 'gr')?_c('router-link',{staticClass:"login_btn",staticStyle:{"text-decoration":"none"},attrs:{"to":"/profile"}},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__(1459)}}),_vm._v(" "+_vm._s(_vm.$t("profile"))+"\n               ")]):_vm._e(),_vm._v(" "),(_vm.countryCode !== 'fi')?_c('a',{staticClass:"login_btn",staticStyle:{"text-decoration":"none"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t("logout")))]):_vm._e()],1):_vm._e()]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('ul',{staticClass:"navLinks"},[_c('li',{staticClass:"navLinks__item"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/horoscope"}},[_vm._v(_vm._s(_vm.$t("horoscope")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"text_dummmy",on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("chinese_zodiac")))]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/tarot"}},[_vm._v(_vm._s(_vm.$t("tarot")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"text_dummmy",on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("tarot")))]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[(_vm.countryCode === 'om' || _vm.countryCode === 'gr')?_c('router-link',{staticClass:"login_btn",staticStyle:{"text-decoration":"none"},attrs:{"to":"/profile"}},[(_vm.auth_mobis === 'loggedin')?_c('a',{staticClass:"text_dummmy"},[_vm._v(_vm._s(_vm.$t("profile")))]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[(_vm.auth_mobis === 'loggedin')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/chinesezodiac"}},[_vm._v(_vm._s(_vm.$t("chinese_zodiac")))]):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'guest')?_c('a',{staticClass:"text_dummmy",on:{"click":function($event){return _vm.guest_mobis()}}},[_vm._v(_vm._s(_vm.$t("chinese_zodiac")))]):_vm._e()],1),_vm._v(" "),(_vm.countryCode === 'cz' || _vm.countryCode === 'sk')?_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/privacy"}},[_vm._v(_vm._s(_vm.$t("privacy")))])],1):_vm._e(),_vm._v(" "),(_vm.countryCode === 'sk')?_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/terms"}},[_vm._v(_vm._s(_vm.$t("terms")))])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('div',{staticClass:"langPanel mobile"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"langButton",attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton)}})])]),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('div',{staticClass:"accountInfo"},[(_vm.auth_mobis == '')?_c('div'):_vm._e(),_vm._v(" "),(_vm.auth_mobis === 'loggedin')?_c('div',[_c('a',{staticClass:"login_btn",staticStyle:{"text-decoration":"none"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t("logout")))])]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lang1",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{staticStyle:{"text-transform":"uppercase"},attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menuBtn",attrs:{"id":"menuBtn"}},[_c('span',{staticClass:"menuBtn__inner"},[_vm._v("menu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lang1",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("ENGLISH")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mobiscope-logo.5cadf19.png";

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAoCAYAAADpE0oSAAAACXBIWXMAACE3AAAhNwEzWJ96AAABrUlEQVRYhe1X0W2DQAx1o/6XERiBDUo3YARGYIPSDRiBDcoIdANGIBukE7hC8kk0+N3ZkKiK1CdZisDnB5d3z+aJmcmJjIgKieX3LDG6yizExiiZeWCMCzP3zJxb6llIswShhvYo8UI6OUkD+r3ER0gDOlQ/Jq6WiN7BvbOIaRaRlUT0AnLfVOGBJ8rBGywCasDudGDN5NnqBhQpE5powbrCSjwqi6NiWcWsrN2oHC3WYDqfYLfG67yTw2tmY95kSfIQ3xQe4uKWeYj4S7nWGIm1PPM5RsepTgirP3qcMjELDchAEOlG0SmvRmbA8lCD5Ghnfg3VdFJn8m5NIkX8J21xTY4agAbUSNzEISyjT2e11j3DHkn/DUPfckYvVqsM8BCXxjzbQyT+2+aAuIaY4SDSKmIgXkxW50IOdBR1jPhepAGVpuqKiD4jcjgbh4EiMnF+y/15/bbarMTixZv/KBFVpF6/3uo6lrQzYnabh6KaI6ntzBmovTahkIbUDG0Nrb2OJ7E+TQS+710Mtc4JDGcu391B/PoQ4+0/8WMSP4v/flxdt36gWfG7PhH9APMvd3f/woNlAAAAAElFTkSuQmCC"

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios_cors__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios_cors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__horoscope_sign_json__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__horoscope_sign_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__horoscope_sign_json__);


//all main method




var proxyurl = "https://corsanywhere.herokuapp.com/";
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var horoscopeURL = "https://zodiacal.herokuapp.com/";
var tarotURL = "https://rws-cards-api.herokuapp.com/api/v1/cards";
var DB_API = 'http://cook.grabmobi.com/api/contents/mobiscope_content?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6';
var API_GET_ALL_MOBISCOPE = 'http://cook.grabmobi.com/api/contents/allmobiscope_content?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6';
var currentDate = new Date();
var year = currentDate.getFullYear();
var horo = __webpack_require__(1464);
var host = window.location.host;
var parts = host.split(".");

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios_cors___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  data: function data() {
    return {
      //for horoscope.vue
      horoscopeData: {
        data: {},
        horosign: "",
        horoscopeMonth: {}
      },
      //for tarot.vue
      tarotData: {
        data: {},
        majors: {},
        wands: {},
        swords: {},
        cups: {},
        pentacles: {},
        tarots: {},
        loading: true
      },
      //for zodiac.vue
      zodiacData: {
        zodiacs: {},
        elements: {}
      },
      //load page
      loadingPage: {
        loading: true
      },
      country: parts[0]
    };
  },
  created: function created() {
    if (host.includes("mobiscope")) {
      this.getHorosign();
      this.getCards();
      // this.getZodiac()
      // this.getElements()
    }
  },

  methods: {
    getHorosign: function getHorosign() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var importData, mon, horo_date, sign, signs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                importData = [];


                __WEBPACK_IMPORTED_MODULE_5__horoscope_sign_json___default.a.horoscope.map(function (item) {
                  item.icon = __webpack_require__(1498)("./" + item.icon);
                });

                importData = __WEBPACK_IMPORTED_MODULE_5__horoscope_sign_json___default.a.horoscope;
                //insert into data
                _this.horoscopeData.data = importData;

                mon = currentDate.getUTCMonth() + 1;

                mon = '0' + mon;

                horo_date = year + '-' + mon + '-' + currentDate.getUTCDate();
                sign = horo.getSign({ month: currentDate.getUTCMonth() + 1, day: currentDate.getUTCDate() });
                signs = sign;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(DB_API + '&horoscope=' + signs + '&date=' + horo_date).then(function (res) {
                  var data = res.data.data[0];
                  data.image = __webpack_require__(378)("./" + data.horoscope_sign + '.svg');
                  _this.loadingPage.loading = false;
                  _this.horoscopeData.horosign = data.horoscope_sign;
                  _this.horoscopeData.horoscopeMonth = data;
                }).catch(function (err) {
                  console.error(err);
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCards: function getCards() {
      var _this2 = this;

      var major = [];
      var wand = [];
      var sword = [];
      var cup = [];
      var pentacle = [];

      var card = {
        url: proxyurl + tarotURL,
        method: 'GET'
      };

      this.$axios(card).then(function (res) {
        _this2.tarotData.loading = false;
        var response = res.data;
        var tarot = response.cards;
        console.log(tarot);
        //to divide by type
        tarot.map(function (value) {
          if (value.type == "major") {
            major.push(value);
          } else if (value.type == "minor") {
            if (value.suit == "wands") {
              wand.push(value);
            } else if (value.suit == "cups") {
              cup.push(value);
            } else if (value.suit == "swords") {
              sword.push(value);
            } else if (value.suit == "pentacles") {
              pentacle.push(value);
            }
          }
        });

        //show image in slider
        for (var i = 0; i < major.length; i++) {
          major[i].image = __webpack_require__(338)("./" + major[i].name + '.jpg');

          //change name
          if (major[i].name == "Fortitude") {
            major[i].name = "Strength(Fortitude)";
          }

          _this2.tarotData.data = tarot;
          _this2.tarotData.majors = major;
          _this2.tarotData.wands = wand;
          _this2.tarotData.cups = cup;
          _this2.tarotData.swords = sword;
          _this2.tarotData.pentacles = pentacle;
        }
      }).catch(function (err) {
        // console.error(err);
      });
    },
    getZodiac: function getZodiac() {
      var _this3 = this;

      var zodiac = {
        url: proxyurl + horoscopeURL + "api",
        method: 'GET'
      };
      this.$axios(zodiac).then(function (res) {
        var response = JSON.parse(res.data);
        _this3.loadingPage.loading = false;
        _this3.zodiacData.zodiacs = response.data;

        var data = _this3.zodiacData.zodiacs;
        data.sort(function (a, b) {
          //to sort zodiacs based on date
          var date1 = new Date(a.sun_dates[0]);
          var date2 = new Date(b.sun_dates[0]);

          return date1 - date2;
        });

        //change month to short
        for (var i = 0; i < data.length; i++) {
          var first = new Date(data[i].sun_dates[0] + ", " + year);
          var last = new Date(data[i].sun_dates[1] + ", " + year);
          var date = months[first.getUTCMonth()] + " " + (first.getUTCDate() + 1) + " - " + months[last.getUTCMonth()] + " " + (last.getUTCDate() + 1);
          data[i].date = date;
          data[i].icon = __webpack_require__(120)("./" + data[i].name + '.svg');
        }
        _this3.zodiacData.zodiacs = data;
      }).catch(function (err) {
        // console.error(err);
      });
    },
    getElements: function getElements() {
      var _this4 = this;

      var elements = {
        url: proxyurl + horoscopeURL + "elements",
        method: 'GET'
      };
      this.$axios(elements).then(function (res) {
        // this.loadingPage.loading = false;
        var response = JSON.parse(responses.data);
        var data = response.data;

        data.sort(function (a, b) {
          //to sort element based on name
          return a.element_name.localeCompare(b.element_name);
        });
        for (var i = 0; i < data.length; i++) {
          if (data[i].element_name == 'Air') {
            data[i].element_nameAR = 'الهواء';
            data[i].element_nameGR = 'Αέρας';
            data[i].element_nameMY = 'Udara';
            data[i].element_nameTH = 'ลม';
          } else if (data[i].element_name == 'Water') {
            data[i].element_nameAR = 'الماء';
            data[i].element_nameGR = 'Νερό';
            data[i].element_nameMY = 'Air';
            data[i].element_nameTH = 'น้ำ';
          } else if (data[i].element_name == 'Fire') {
            data[i].element_nameAR = 'النار';
            data[i].element_nameGR = 'Φωτιά';
            data[i].element_nameMY = 'Api';
            data[i].element_nameTH = 'ไฟ';
          } else if (data[i].element_name == 'Earth') {
            data[i].element_nameAR = 'الارض';
            data[i].element_nameGR = 'Γη';
            data[i].element_nameMY = 'Bumi';
            data[i].element_nameTH = 'ดิน';
          }
        }

        for (var _i = 0; _i < data.length; _i++) {
          data[_i].icon = __webpack_require__(211)("./" + data[_i].element_name + '.svg');
        }

        setTimeout(function () {
          _this4.zodiacData.elements = data;
        }, 1000);
      }).catch(function (err) {
        // console.error(err);
      });
    }
  }
}));

/***/ }),
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Aquarius.svg": 366,
	"./Aries.svg": 367,
	"./Cancer.svg": 368,
	"./Capricorn.svg": 369,
	"./Gemini.svg": 370,
	"./Leo.svg": 371,
	"./Libra.svg": 372,
	"./Pisces.svg": 373,
	"./Sagittarius.svg": 374,
	"./Scorpio.svg": 375,
	"./Taurus.svg": 376,
	"./Virgo.svg": 377
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1498;

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0208889c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(1501);
function injectStyle (ssrContext) {
  __webpack_require__(1500)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0208889c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0208889c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_mobis(_vm.is_unsub_mobis)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planet-left.dee9d72.png";

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation'),_vm._v(" "),_c('div',{},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"view",attrs:{"horoscopeData":_vm.horoscopeData,"tarotData":_vm.tarotData,"zodiacData":_vm.zodiacData,"loadingPage":_vm.loadingPage}})],1)],1),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('footer',[_c('p',{staticClass:"editor"},[_vm._v("©Mobiscope "+_vm._s(_vm.year))])]),_vm._v(" "),_c('canvas',{attrs:{"id":"universe"}}),_vm._v(" "),_c('canvas',{attrs:{"id":"universeElms","height":"600"}}),_vm._v(" "),_c('canvas',{attrs:{"id":"granim-canvas"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobizone_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ae0cde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobizone_vue__ = __webpack_require__(1588);
function injectStyle (ssrContext) {
  __webpack_require__(1505)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobizone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ae0cde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobizone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a91dc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1508);
function injectStyle (ssrContext) {
  __webpack_require__(1507)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64a91dc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a91dc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_mobiz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n            "),(_vm.lang_mobiz !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_mobiz)]))]):_vm._e(),_vm._v(" "),(_vm.lang_mobiz === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[(hot.category !== 'Video')?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[(data.content_type === 'application/x-zip-compressed' && data.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1)]):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4d8a86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(1511);
function injectStyle (ssrContext) {
  __webpack_require__(1510)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d4d8a86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4d8a86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("allCategories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-6 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_mobiz)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449e211b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1514);
function injectStyle (ssrContext) {
  __webpack_require__(1513)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-449e211b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449e211b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_mobiz))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_mobiz))])]),_vm._v(" "),(_vm.country_mobiz !== 'bh')?_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_mobiz))])]):_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('current_status'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.current_status))])])]),_vm._v(" "),(_vm.auth_mobiz === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.country_mobiz == 'iq' || _vm.country_mobiz == 'bh')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_mobiz(_vm.is_unsub_mobiz)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(407)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305d3a87_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1517);
function injectStyle (ssrContext) {
  __webpack_require__(1516)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-305d3a87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305d3a87_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_mobiz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getCategoryTranslate(_vm.$route.query.q, _vm.lang_mobiz)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: hot.content_id }
                  }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e099a23e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1520);
function injectStyle (ssrContext) {
  __webpack_require__(1519)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e099a23e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e099a23e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_mobiz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.pagePopular_mobiz),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e336e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(1526);
function injectStyle (ssrContext) {
  __webpack_require__(1522)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58e336e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e336e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobiZoneSlider_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd636b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobiZoneSlider_vue__ = __webpack_require__(1525);
function injectStyle (ssrContext) {
  __webpack_require__(1524)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobiZoneSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd636b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobiZoneSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_mobiz",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_mobiz)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem "},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_mobiz))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.getCategoryTitle(_vm.lang_mobiz))+" "+_vm._s(_vm.$t("categories")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('mobizone-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_mobiz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('mobizone-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_mobiz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('mobizone-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a42abd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1529);
function injectStyle (ssrContext) {
  __webpack_require__(1528)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a42abd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a42abd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_mobiz))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_mobiz)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_mobiz !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_mobiz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_mobiz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5f4986_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1535);
function injectStyle (ssrContext) {
  __webpack_require__(1531)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5f4986_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d32589c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1534);
function injectStyle (ssrContext) {
  __webpack_require__(1533)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d32589c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns mobizone"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('plyr',{ref:"player"},[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])])],1):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_mobiz)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
        23,
        2,
        14,
        17,
        0,
        19,
        10,
        34,
        7,
        50,
        23,
        43,
        38,
        50,
        36,
        34,
        46,
        19,
        31,
        17
      ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_mobiz([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_mobiz([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_mobiz([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918936ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1538);
function injectStyle (ssrContext) {
  __webpack_require__(1537)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-918936ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918936ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_mobiz === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_mobiz !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4dd8d7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(1541);
function injectStyle (ssrContext) {
  __webpack_require__(1540)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b4dd8d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4dd8d7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("contact_us")))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t("subject")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('select',{attrs:{"id":"select"}},[_c('option',[_vm._v(_vm._s(_vm.$t("select_subject")))]),_vm._v(" "),_c('option',{attrs:{"value":"technical"}},[_vm._v(_vm._s(_vm.$t("app_issue")))]),_vm._v(" "),_c('option',{attrs:{"value":"content"}},[_vm._v(_vm._s(_vm.$t("content")))]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v(_vm._s(_vm.$t("subscription")))])]),_vm._v(" "),_c('span',{staticClass:"arrow__upper"})])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t("message")))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('let_us')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63be9102_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(1544);
function injectStyle (ssrContext) {
  __webpack_require__(1543)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63be9102"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63be9102_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b9014b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(1547);
function injectStyle (ssrContext) {
  __webpack_require__(1546)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b9014b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b9014b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f80f2f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f80f2f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f80f2f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz' || _vm.countryCode == 'bg' || _vm.countryCode == 'no')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content provider: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("What personal information do we collect from the people that visit our blog, website or app?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number or other details to help you with your experience.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("When do we collect information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We collect information from you when you register on our site, fill out a form or enter information on our site. Provide us with feedback on our products or services.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How do we use your information? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.")]),_vm._v(" "),_c('li',[_vm._v("To improve our website in order to better serve you.")]),_vm._v(" "),_c('li',[_vm._v("To allow us to better service you in responding to your customer service requests.")]),_vm._v(" "),_c('li',[_vm._v("To administer a contest, promotion, survey or other site feature.")]),_vm._v(" "),_c('li',[_vm._v("To quickly process your transactions.")]),_vm._v(" "),_c('li',[_vm._v("To ask for ratings and reviews of services or products")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How do we protect your information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Do we use cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Keep track of advertisements.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-party disclosure")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-party links")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not include or offer third-party products or services on our website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Click here to view")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Does our site allow third-party behavioral tracking?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("It's also important to note that we allow third-party behavioral tracking")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("تم تجميع سياسة الخصوصية هذه لتقديم خدمة أفضل لأولئك الذين يهتمون بكيفية استخدام \"معلومات التعريف الشخصية\" (PII) الخاصة بهم عبر الإنترنت. يرجى قراءة سياسة الخصوصية الخاصة بنا بعناية للحصول على فهم واضح لكيفية جمعنا لمعلوماتك الشخصية أو استخدامها أو حمايتها أو التعامل معها بطريقة أخرى وفقًا لموقعنا الإلكتروني.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("ما المعلومات الشخصية التي نجمعها من الأشخاص الذين يزورون مدونتنا أو موقعنا الإلكتروني أو تطبيقنا؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("عند الطلب أو التسجيل على موقعنا، حسب الاقتضاء، قد يُطلب منك إدخال اسمك أو عنوان بريدك الإلكتروني أو عنوانك البريدي أو رقم هاتفك أو تفاصيل أخرى لمساعدتك في تجربتك")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("متى نجمع المعلومات؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نقوم بجمع المعلومات منك عندما تقوم بالتسجيل على موقعنا، أو ملء نموذج أو إدخال معلومات على موقعنا. قدم لنا ملاحظاتك حول منتجاتنا أو خدماتنا.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("كيف نستعمل معلوماتك؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("قد نستخدم المعلومات التي نجمعها منك عندما تقوم بالتسجيل أو إجراء عملية شراء أو الاشتراك في النشرة الإخبارية أو الرد على استطلاع أو اتصالات تسويقية أو تصفح الموقع أو استخدام بعض ميزات الموقع الأخرى بالطرق التالية:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("لتخصيص تجربتك والسماح لنا بتقديم نوع المحتوى وعروض المنتجات التي تهمك أكثر.")]),_vm._v(" "),_c('li',[_vm._v("تحسين موقعنا من أجل تقديم خدمة أفضل لك.")]),_vm._v(" "),_c('li',[_vm._v("للسماح لنا بخدمة أفضل في الاستجابة لطلبات خدمة العملاء الخاصة بك.")]),_vm._v(" "),_c('li',[_vm._v("لإدارة مسابقة أو ترقية أو مسح أو ميزة أخرى في الموقع.")]),_vm._v(" "),_c('li',[_vm._v("لمعالجة المعاملات الخاصة بك بسرعة.")]),_vm._v(" "),_c('li',[_vm._v("طلب تقييمات ومراجعات للخدمات أو المنتجات")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("كيف نحمي معلوماتك؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("يتم فحص موقعنا على الإنترنت بانتظام للثغرات الأمنية ونقاط الضعف المعروفة من أجل جعل زيارتك لموقعنا آمنة قدر الإمكان.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("هل نستخدم ملفات تعريف الارتباط؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("ملفات تعريف الارتباط هي ملفات صغيرة ينقلها الموقع أو موفر الخدمة الخاص به إلى محرك الأقراص الثابتة بجهاز الحاسوب الخاص بك من خلال متصفح الويب (إذا سمحت بذلك) والتي تمكن أنظمة الموقع أو مزود الخدمة من التعرف على متصفحك والتقاط وتذكر معلومات معينة. على سبيل المثال، نستخدم ملفات تعريف الارتباط لمساعدتنا على تذكر ومعالجة العناصر الموجودة في سلة التسوق الخاصة بك. يتم استخدامها أيضًا لمساعدتنا على فهم تفضيلاتك استنادًا إلى نشاط الموقع السابق أو الحالي، مما يمكننا من تزويدك بخدمات محسنة. نستخدم أيضًا ملفات تعريف الارتباط لمساعدتنا في تجميع البيانات المجمعة حول حركة مرور الموقع وتفاعل الموقع حتى نتمكن من تقديم تجارب وأدوات أفضل للموقع في المستقبل.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نستخدم ملفات تعريف الارتباط من أجل:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("فهم وحفظ تفضيلات المستخدم للزيارات المستقبلية.")]),_vm._v(" "),_c('li',[_vm._v("تتبع الإعلانات.")]),_vm._v(" "),_c('li',[_vm._v("تجميع البيانات المجمعة حول حركة مرور الموقع وتفاعلات الموقع من أجل تقديم تجارب وأدوات موقع أفضل في المستقبل. قد نستخدم أيضًا خدمات الجهات الخارجية الموثوق بها التي تتعقب هذه المعلومات نيابة عنا.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("يمكنك اختيار جعل جهاز الحاسوب الخاص بك يحذرك في كل مرة يتم فيها إرسال ملف تعريف ارتباط، أو يمكنك اختيار إيقاف تشغيل كافة ملفات تعريف الارتباط. يمكنك القيام بذلك من خلال إعدادات المتصفح الخاص بك. نظرًا لأن المتصفح مختلف قليلاً، فراجع قائمة تعليمات المتصفح لمعرفة الطريقة الصحيحة لتعديل ملفات تعريف الارتباط.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("إفشاء طرف ثالث")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نحن لا نبيع أو نتاجر أو ننقل معلوماتك الشخصية إلى أطراف خارجية ما لم نقدم إشعارًا مسبقًا للمستخدمين. لا يشمل هذا شركاء استضافة الموقع والأطراف الأخرى الذين يساعدوننا في تشغيل موقعنا، أو إجراء أعمالنا، أو خدمة مستخدمينا، طالما وافقت تلك الأطراف على الحفاظ على سرية هذه المعلومات. يجوز لنا أيضًا نشر المعلومات عندما يكون إصدارها مناسبًا للامتثال للقانون، أو فرض سياسات موقعنا، أو حماية حقوقنا أو حقوق الآخرين أو ممتلكاتنا")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("ومع ذلك، قد يتم توفير معلومات الزائر غير الشخصية لأطراف أخرى للتسويق أو الإعلان أو الاستخدامات الأخرى.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("روابط الطرف الثالث")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نحن لا ندرج أو نقدم منتجات أو خدمات طرف ثالث على موقعنا.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("جوجل")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("كن تلخيص متطلبات Google الإعلانية من خلال مبادئ الإعلان من Google. يتم وضعها لتوفير تجربة إيجابية للمستخدمين. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=ar"}},[_vm._v("انقر هنا لعرض")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("تستخدم Google، بصفتها مورِّدًا خارجيًا، ملفات تعريف الارتباط لعرض الإعلانات على موقعنا. يمكّن استخدام Google لملف تعريف الارتباط DART من عرض الإعلانات لمستخدمينا بناءً على الزيارات السابقة إلى موقعنا والمواقع الأخرى على الإنترنت. يمكن للمستخدمين إلغاء الاشتراك في استخدام ملف تعريف الارتباط DART عن طريق زيارة سياسة خصوصية إعلانات Google وشبكة المحتوى.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("قمنا بتنفيذ ما يلي:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نحن، جنبًا إلى جنب مع موردي الجهات الخارجية مثل Google، نستخدم ملفات تعريف ارتباط الطرف الأول (مثل ملفات تعريف ارتباط Google Analytics) وملفات تعريف ارتباط الطرف الثالث (مثل ملف تعريف الارتباط DoubleClick) أو معرفات الجهات الخارجية الأخرى معًا لتجميع البيانات المتعلقة بتفاعلات المستخدم مع مرات ظهور الإعلان ووظائف خدمة الإعلان الأخرى من حيث صلتها بموقعنا على الويب.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("تعطيل الخدمة:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("يمكن للمستخدمين تعيين تفضيلات لكيفية إعلان Google لك باستخدام صفحة إعدادات إعلانات Google. بدلاً من ذلك، يمكنك إلغاء الاشتراك من خلال زيارة صفحة إلغاء الاشتراك في مبادرة الإعلانات على الشبكة أو باستخدام إضافة متصفح Google Analytics Opt Out.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("هل يسمح موقعنا بالتتبع السلوكي للجهات الخارجية؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("من المهم أيضًا ملاحظة أننا نسمح بالتتبع السلوكي لجهة خارجية")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Dasar privasi ini telah disusun untuk memberikan perkhidmatan yang lebih baik kepada  mereka yang lebih prihatin dengan bagaimana 'Maklumat Pengenalpastian Peribadi' (PII) mereka digunakan dalam talian. Sila baca dasar privasi kami dengan teliti untuk mendapatkan pemahaman yang jelas tentang bagaimana kami mengumpulkan, menggunakan, melindungi atau mengendalikan Maklumat Pengenalan Peribadi anda sesuai dengan laman web kami.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Apakah Maklumat Peribadi Yang Kami Kumpulkan Dari Orang Yang Melawat Blog, Laman Web atau Aplikasi Kami?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Semasa membuat pesanan atau mendaftar di laman web kami, jika sesuai, anda mungkin diminta untuk memasukkan nama, alamat e-mel, alamat surat, nombor telefon atau maklumat lain untuk membantu anda dengan pengalaman anda.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bila Kami Mengumpulkan Maklumat?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami mengumpulkan maklumat daripada anda semasa anda mendaftar di laman web kami, mengisi borang atau memasukkan maklumat di laman web kami. Beri kami maklum balas mengenai produk atau perkhidmatan kami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bagaimana Kami Menggunakan Maklumat Anda? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami mungkin menggunakan maklumat yang kami kumpulkan dari anda ketika anda mendaftar, melakukan pembelian, mendaftar ke laman web kami, balas tinjauan atau komunikasi pemasaran, melayari laman web, atau menggunakan ciri laman web tertentu dengan cara berikut:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Untuk memperibadikan pengalaman anda dan membolehkan kami menyampaikan jenis kandungan dan penawaran produk yang paling anda minati.")]),_vm._v(" "),_c('li',[_vm._v("Untuk memperbaiki laman web kami agar dapat melayani anda dengan lebih baik.")]),_vm._v(" "),_c('li',[_vm._v("Untuk membolehkan kami melayani anda dengan lebih baik dalam menjawab permintaan perkhidmatan pelanggan anda.")]),_vm._v(" "),_c('li',[_vm._v("Untuk menguruskan pertandingan, promosi, tinjauan atau ciri laman web lain.")]),_vm._v(" "),_c('li',[_vm._v("Untuk memproses transaksi anda dengan cepat.")]),_vm._v(" "),_c('li',[_vm._v("Untuk meminta penilaian dan ulasan perkhidmatan atau produk")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bagaimana Kami Melindungi Maklumat Anda?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Laman web kami diimbas secara berkala untuk mencari lubang keselamatan dan kelemahan yang diketahui agar lawatan anda ke laman web kami selamat yang mungkin.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adakah Kami Menggunakan Cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Yes. Cookies  adalah fail kecil yang dipindahkan oleh laman web atau penyedia perkhidmatannya ke cakera keras komputer anda melalui penyemak imbas Web anda (jika anda membenarkan) yang membolehkan sistem penyedia perkhidmatan atau laman web mengenali penyemak imbas anda dan menangkap dan mengingat maklumat tertentu. Contohnya, kami menggunakan cookies untuk membantu kami mengingat dan memproses barang-barang di shopping cart anda. Mereka juga digunakan untuk membantu kami memahami pilihan anda berdasarkan aktiviti laman web sebelumnya atau semasa, yang membolehkan kami memberi anda perkhidmatan yang lebih baik. Kami juga menggunakan cookies untuk membantu kami mengumpulkan data mengenai lalu lintas laman web dan interaksi laman web agar kami dapat menawarkan pengalaman dan alat laman yang lebih baik di masa depan.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami menggunakan Cookies untuk:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Fahami dan simpan pilihan pengguna untuk lawatan akan datang.")]),_vm._v(" "),_c('li',[_vm._v("Jejaki iklan.")]),_vm._v(" "),_c('li',[_vm._v("Kumpulkan data mengenai lalu lintas laman web dan interaksi laman web untuk menawarkan pengalaman dan alat laman web yang lebih baik pada masa akan datang. Kami juga boleh menggunakan perkhidmatan pihak ketiga yang dipercayai yang mengesan maklumat ini bagi pihak kami.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Anda boleh memilih agar komputer memberi amaran kepada anda setiap kali cookies dihantar, atau anda boleh memilih untuk mematikan semua cookies. Anda melakukannya melalui tetapan penyemak imbas anda. Oleh kerana penyemak imbas sedikit berbeza, lihat Menu Bantuan penyemak imbas anda untuk mengetahui cara yang betul untuk mengubah kuki anda.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Pendedahan Pihak Ketiga")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami tidak menjual, memperdagangkan, atau memindahkan kepada pihak luar Maklumat Peribadi Anda kecuali kami memberikan notis awal kepada pengguna. Ini tidak termasuk rakan hosting laman web dan pihak lain yang membantu kami mengendalikan laman web kami, menjalankan perniagaan kami, atau melayani pengguna kami, selagi pihak tersebut bersetuju untuk merahsiakan maklumat ini. Kami juga dapat melepaskan maklumat apabila pelepasannya sesuai untuk mematuhi undang-undang, menegakkan dasar laman web kami, atau melindungi hak, harta milik kami atau orang lain")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Walau bagaimanapun, maklumat pelawat yang tidak dapat dikenal pasti dapat diberikan kepada pihak lain untuk pemasaran, pengiklanan, atau kegunaan lain.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Pautan Pihak Ketiga")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami tidak memasukkan atau menawarkan produk atau perkhidmatan pihak ketiga di laman web kami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Keperluan periklanan Google dapat disimpulkan oleh Prinsip Periklanan Google. Mereka disediakan untuk memberikan pengalaman positif bagi pengguna.  "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Klik disini untuk melihat")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, sebagai vendor pihak ketiga, menggunakan Cookies untuk menayangkan iklan di laman web kami. Penggunaan Cookies DART oleh Google membolehkannya menayangkan iklan kepada pengguna kami berdasarkan lawatan sebelumnya ke laman web kami dan laman web lain di Internet. Pengguna boleh memilih untuk tidak menggunakan Cookies DART dengan mengunjungi dasar privasi Rangkaian Iklan dan Kandungan Google.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kami Telah Melaksanakan Perkara Berikut:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami, bersama dengan vendor pihak ketiga seperti Google menggunakan Cookies pihak pertama (seperti Cookies Google Analytics) dan Cookies pihak ketiga (seperti Cookies DoubleClick) atau pengecam pihak ketiga yang lain untuk mengumpulkan data mengenai interaksi pengguna dengan tayangan iklan dan fungsi perkhidmatan iklan lain yang berkaitan dengan laman web kami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Tidak ikut serta:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Pengguna dapat menetapkan pilihan bagaimana Google beriklan kepada Anda menggunakan halaman Pengaturan Iklan Google. Sebagai pilihan, anda boleh memilih untuk tidak ikut dengan mengunjungi halaman Pengiklanan Inisiatif Pengiklanan Rangkaian atau dengan menggunakan add-on Penyemak Imbas Google Analytics.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adakah Laman web Kami Membolehkan Penjejakan Tingkah Laku Pihak Ketiga?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Penting juga untuk memaklumkan bahawa kami membenarkan penjejakan tingkah laku pihak ketiga.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αυτή η πολιτική απορρήτου έχει συνταχθεί για καλύτερη εξυπηρέτηση όσων ενδιαφέρονται για τον τρόπο με τον οποίο χρησιμοποιούνται οι «προσωπικές πληροφορίες που μπορούν να αναγνωριστούν» (PII) στο διαδίκτυο. Διαβάστε προσεκτικά την πολιτική απορρήτου μας για να λάβετε μια σαφή κατανόηση του τρόπου με τον οποίο συλλέγουμε, χρησιμοποιούμε, προστατεύουμε ή χειριζόμαστε με άλλο τρόπο τα προσωπικά σας στοιχεία σύμφωνα με τον ιστότοπό μας.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ποιες προσωπικές πληροφορίες συλλέγουμε από τα άτομα που επισκέπτονται το ιστολόγιο, τον ιστότοπο ή την εφαρμογή μας?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Κατά την παραγγελία ή την εγγραφή στον ιστότοπό μας, κατά περίπτωση, ενδέχεται να σας ζητηθεί να εισαγάγετε το όνομά σας, τη διεύθυνση email, τη διεύθυνση αλληλογραφίας, τον αριθμό τηλεφώνου ή άλλες λεπτομέρειες για να σας βοηθήσουμε με την εμπειρία σας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πότε συλλέγουμε πληροφορίες?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Συλλέγουμε πληροφορίες από εσάς όταν εγγραφείτε στον ιστότοπό μας, συμπληρώνουμε μια φόρμα ή εισάγουμε πληροφορίες στον ιστότοπό μας. Δώστε μας σχόλια για τα προϊόντα ή τις υπηρεσίες μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πώς χρησιμοποιούμε τις πληροφορίες σας? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ενδέχεται να χρησιμοποιήσουμε τις πληροφορίες που συλλέγουμε από εσάς όταν εγγραφείτε, πραγματοποιείτε αγορά, εγγραφείτε στο ενημερωτικό μας δελτίο, απαντάμε σε μια έρευνα ή επικοινωνία μάρκετινγκ, περιηγηθείτε στον ιστότοπο ή χρησιμοποιήστε ορισμένες άλλες δυνατότητες του ιστότοπου με τους ακόλουθους τρόπους:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Για να εξατομικεύσετε την εμπειρία σας και να μας επιτρέψετε να παρέχουμε τον τύπο περιεχομένου και προϊόντων που σας ενδιαφέρει περισσότερο.")]),_vm._v(" "),_c('li',[_vm._v("Να βελτιώσουμε τον ιστότοπό μας για να σας εξυπηρετήσουμε καλύτερα")]),_vm._v(" "),_c('li',[_vm._v("Για τη διαχείριση ενός διαγωνισμού, προώθησης, έρευνας ή άλλης δυναΓια να μας επιτρέψετε να σας εξυπηρετήσουμε καλύτερα ανταποκρινόμενοι στα αιτήματα εξυπηρέτησης πελατών σας.τότητας ιστότοπου.")]),_vm._v(" "),_c('li',[_vm._v("Για τη διαχείριση ενός διαγωνισμού, προώθησης, έρευνας ή άλλης δυνατότητας ιστότοπου.")]),_vm._v(" "),_c('li',[_vm._v("Για να επεξεργαστείτε γρήγορα τις συναλλαγές σας.")]),_vm._v(" "),_c('li',[_vm._v("Για να ζητήσετε βαθμολογίες και κριτικές υπηρεσιών ή προϊόντων")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πώς προστατεύουμε τις πληροφορίες σας?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ο ιστότοπός μας σαρώνεται σε τακτική βάση για τρύπες ασφαλείας και γνωστές ευπάθειες προκειμένου να κάνει την επίσκεψή σας στον ιστότοπό μας όσο το δυνατόν πιο ασφαλή.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Χρησιμοποιούμε Cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ναί. Τα cookie είναι μικρά αρχεία που ένας ιστότοπος ή ο πάροχος υπηρεσιών του μεταφέρει στον σκληρό δίσκο του υπολογιστή σας μέσω του προγράμματος περιήγησης στο Web (εάν το επιτρέπετε) που επιτρέπει στα συστήματα του παρόχου ιστότοπου ή του παρόχου υπηρεσιών να αναγνωρίζουν το πρόγραμμα περιήγησής σας και να συλλαμβάνουν και να θυμούνται ορισμένες πληροφορίες. Για παράδειγμα, χρησιμοποιούμε cookies για να μας βοηθήσουν να θυμηθούμε και να επεξεργαστούμε τα αντικείμενα στο καλάθι αγορών σας. Χρησιμοποιούνται επίσης για να μας βοηθήσουν να κατανοήσουμε τις προτιμήσεις σας βάσει προηγούμενης ή τρέχουσας δραστηριότητας ιστότοπου, η οποία μας επιτρέπει να σας παρέχουμε βελτιωμένες υπηρεσίες. Χρησιμοποιούμε επίσης cookie για να μας βοηθήσουν να συγκεντρώσουμε συγκεντρωτικά δεδομένα σχετικά με την επισκεψιμότητα του ιστότοπου και την αλληλεπίδραση του ιστότοπου, ώστε να μπορούμε να προσφέρουμε καλύτερες εμπειρίες και εργαλεία ιστότοπου στο μέλλον.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιούμε cookies για:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Κατανοήστε και αποθηκεύστε τις προτιμήσεις του χρήστη για μελλοντικές επισκέψεις.")]),_vm._v(" "),_c('li',[_vm._v("Παρακολουθήστε τις διαφημίσεις.")]),_vm._v(" "),_c('li',[_vm._v("Συγκεντρώστε συγκεντρωτικά δεδομένα σχετικά με την επισκεψιμότητα του ιστότοπου και τις αλληλεπιδράσεις ιστότοπων, προκειμένου να προσφέρετε καλύτερες εμπειρίες και εργαλεία ιστότοπου στο μέλλον. Μπορούμε επίσης να χρησιμοποιήσουμε αξιόπιστες υπηρεσίες τρίτων που παρακολουθούν αυτές τις πληροφορίες εκ μέρους μας.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορείτε να επιλέξετε να σας προειδοποιεί ο υπολογιστής σας κάθε φορά που αποστέλλεται ένα cookie ή μπορείτε να επιλέξετε να απενεργοποιήσετε όλα τα cookie. Αυτό το κάνετε μέσω των ρυθμίσεων του προγράμματος περιήγησής σας. Επειδή το πρόγραμμα περιήγησης είναι λίγο διαφορετικό, ανατρέξτε στο Μενού Βοήθειας του προγράμματος περιήγησής σας για να μάθετε τον σωστό τρόπο τροποποίησης των cookie σας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Γνωστοποίηση τρίτων")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Δεν πουλάμε, ανταλλάσσουμε ή με άλλο τρόπο μεταβιβάζουμε σε τρίτους τα προσωπικά σας στοιχεία, εκτός εάν παρέχουμε στους χρήστες προηγούμενη ειδοποίηση. Αυτό δεν περιλαμβάνει συνεργάτες φιλοξενίας ιστότοπων και άλλα μέρη που μας βοηθούν στη λειτουργία του ιστότοπού μας, στη διεξαγωγή της επιχείρησής μας ή στην εξυπηρέτηση των χρηστών μας, εφόσον αυτά τα μέρη συμφωνούν να διατηρήσουν αυτές τις πληροφορίες εμπιστευτικές. Μπορούμε επίσης να δημοσιεύσουμε πληροφορίες όταν είναι αποδεκτό ότι είναι κατάλληλο να συμμορφωθούμε με το νόμο, να επιβάλουμε τις πολιτικές του ιστότοπού μας ή να προστατεύσουμε τα δικαιώματα, την ιδιοκτησία μας ή άλλων")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ωστόσο, ενδέχεται να παρέχονται μη αναγνωρίσιμες πληροφορίες επισκεπτών σε άλλα μέρη για μάρκετινγκ, διαφήμιση ή άλλες χρήσεις.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Σύνδεσμοι τρίτων")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Δεν συμπεριλαμβάνουμε ούτε προσφέρουμε προϊόντα ή υπηρεσίες τρίτων στον ιστότοπό μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Οι απαιτήσεις διαφήμισης της Google μπορούν να συνοψιστούν στις Αρχές Διαφήμισης της Google. Έχουν δημιουργηθεί για να παρέχουν μια θετική εμπειρία στους χρήστες. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=el"}},[_vm._v("Κάντε κλικ εδώ για προβολή")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, ως προμηθευτής τρίτου μέρους, χρησιμοποιεί cookies για την προβολή διαφημίσεων στον ιστότοπό μας. Η χρήση του cookie DART από την Google επιτρέπει την προβολή διαφημίσεων στους χρήστες μας με βάση προηγούμενες επισκέψεις στον ιστότοπό μας και σε άλλους ιστότοπους στο Διαδίκτυο. Οι χρήστες μπορούν να εξαιρεθούν από τη χρήση του cookie DART μεταβαίνοντας στην πολιτική απορρήτου του Google Ad και του Δικτύου περιεχομένου.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Έχουμε εφαρμόσει τα ακόλουθα:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Εμείς, μαζί με τρίτους προμηθευτές όπως η Google χρησιμοποιούν cookie πρώτου μέρους (όπως τα cookie του Google Analytics) και cookie τρίτου μέρους (όπως το cookie DoubleClick) ή άλλα αναγνωριστικά τρίτων για τη συλλογή δεδομένων σχετικά με τις αλληλεπιδράσεις χρηστών με εμφανίσεις διαφημίσεων και άλλες λειτουργίες υπηρεσιών διαφημίσεων που σχετίζονται με τον ιστότοπό μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Εξαίρεση:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Οι χρήστες μπορούν να ορίσουν προτιμήσεις για τον τρόπο με τον οποίο η Google διαφημίζει σε εσάς χρησιμοποιώντας τη σελίδα Ρυθμίσεις διαφημίσεων Google. Εναλλακτικά, μπορείτε να εξαιρεθείτε μεταβαίνοντας στη σελίδα Εξαίρεση πρωτοβουλίας Network Advertising Initiative ή χρησιμοποιώντας το πρόσθετο Google Analytics Opt Out Browser.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Επιτρέπει ο ιστότοπός μας παρακολούθηση συμπεριφοράς τρίτων?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("It's also important to note that we allow third-party behavioral tracking")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Tyto zásady ochrany osobních údajů byly sestaveny, aby lépe sloužily těm, kteří se zajímají o to, jak jsou jejich „osobně identifikovatelné informace“ (PII) používány online. Přečtěte si pozorně naše zásady ochrany osobních údajů, abyste získali jasnou představu o tom, jak shromažďujeme, používáme, chráníme nebo jinak zacházíme s vašimi osobně identifikovatelnými informacemi v souladu s našimi webovými stránkami.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Poskytovatel obsahu: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adresa: 46350 Petaling Jaya, Selangor Darul Ehsan, Malajsie.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jaké osobní údaje shromažďujeme od lidí, kteří navštěvují náš blog, web nebo aplikaci?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Při objednávání nebo registraci na našem webu můžete být požádáni, abyste zadali své jméno, e-mailovou adresu, poštovní adresu, telefonní číslo nebo jiné podrobnosti, které vám pomohou s vaší zkušeností.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kdy shromažďujeme informace?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Shromažďujeme informace od vás, když se zaregistrujete na našem webu, vyplníte formulář nebo zadáte informace na našem webu. Poskytněte nám zpětnou vazbu k našim produktům nebo službám.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jak používáme vaše údaje? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informace, které od vás shromažďujeme, můžeme použít při registraci, nákupu, registraci k odběru našeho zpravodaje, odpovědi na průzkum nebo marketingovou komunikaci, procházení webu nebo používání určitých dalších funkcí webu následujícími způsoby:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Chcete-li přizpůsobit své zkušenosti a umožnit nám doručit typ obsahu a nabídky produktů, o které máte největší zájem")]),_vm._v(" "),_c('li',[_vm._v("Vylepšit náš web, abychom vám mohli lépe sloužit.")]),_vm._v(" "),_c('li',[_vm._v("Abychom vám mohli lépe poskytovat služby v reakci na vaše požadavky na zákaznické služby.")]),_vm._v(" "),_c('li',[_vm._v("Spravovat soutěž, propagaci, průzkum nebo jiné funkce webu.")]),_vm._v(" "),_c('li',[_vm._v("Chcete-li rychle zpracovat své transakce.")]),_vm._v(" "),_c('li',[_vm._v("Požádat o hodnocení a recenze služeb nebo produktů")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jak chráníme vaše údaje?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naše webové stránky jsou pravidelně kontrolovány, zda neobsahují bezpečnostní mezery a známé chyby zabezpečení, aby byla vaše návštěva našeho webu co nejbezpečnější.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Používáme cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ano. Cookies jsou malé soubory, které web nebo jeho poskytovatel služeb přenáší na pevný disk vašeho počítače prostřednictvím vašeho webového prohlížeče (pokud to povolíte), což umožňuje systémům webu nebo poskytovatele služeb rozpoznat váš prohlížeč a zachytit a zapamatovat si určité informace. Používáme například soubory cookie, které nám pomáhají zapamatovat si a zpracovat položky ve vašem nákupním košíku. Používají se také k tomu, aby nám pomohly porozumět vašim preferencím na základě předchozí nebo aktuální aktivity na webu, což nám umožňuje poskytovat vám vylepšené služby. Používáme také soubory cookie, které nám pomáhají shromažďovat souhrnné údaje o provozu a interakci se stránkami, abychom mohli v budoucnu nabízet lepší zážitky a nástroje.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies používáme k:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pochopte a uložte preference uživatele pro budoucí návštěvy.")]),_vm._v(" "),_c('li',[_vm._v("Sledujte reklamy.")]),_vm._v(" "),_c('li',[_vm._v("Kompilace agregovaných dat o provozu webu a interakcích s webem, aby v budoucnu nabízel lepší prostředí a nástroje. Můžeme také použít důvěryhodné služby třetích stran, které tyto informace sledují naším jménem.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Můžete zvolit, aby vás počítač varoval při každém odeslání souboru cookie, nebo můžete vypnout všechny soubory cookie. To provedete prostřednictvím nastavení prohlížeče. Vzhledem k tomu, že se prohlížeč trochu liší, podívejte se do nabídky nápovědy svého prohlížeče a zjistěte správný způsob úpravy souborů cookie.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Zveřejnění třetí stranou")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vaše osobní identifikační údaje neprodáváme, neobchodujeme s nimi ani je jinak nepředáváme externím stranám, pokud na to uživatele předem nepředáme. To nezahrnuje partnery hostující webové stránky a další strany, které nám pomáhají s provozováním našich webových stránek, řízením našeho podnikání nebo poskytováním služeb našim uživatelům, pokud tyto strany souhlasí se zachováním důvěrnosti těchto informací. Můžeme také zveřejnit informace, pokud je jejich vydání vhodné k dodržení zákonů, prosazování zásad našich stránek nebo k ochraně našich práv či majetku ostatních")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informace o návštěvnících, které neumožňují osobní identifikaci, však mohou být poskytnuty dalším stranám za účelem marketingu, reklamy nebo k jiným účelům.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Odkazy třetích stran")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Na naše webové stránky nezahrnujeme ani nenabízíme produkty nebo služby třetích stran.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Reklamní požadavky společnosti Google lze shrnout do zásad inzerce společnosti Google. Jsou zavedeny, aby uživatelům poskytly pozitivní zážitek. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Kliknutím sem zobrazíte")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google jako prodejce třetí strany používá soubory cookie k zobrazování reklam na našem webu. Google pomocí cookie DART umožňuje zobrazovat reklamy našim uživatelům na základě předchozích návštěv našich stránek a dalších stránek na internetu. Uživatelé se mohou odhlásit z používání souboru cookie DART tak, že navštíví zásady ochrany osobních údajů reklamní sítě Google a obsahové sítě.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Implementovali jsme následující:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Společně s dodavateli třetích stran, jako je Google, používáme soubory cookie první strany (například soubory cookie Google Analytics) a soubory cookie třetích stran (například soubor cookie DoubleClick) nebo jiné identifikátory třetích stran společně ke shromažďování údajů o interakcích uživatelů s zobrazení reklam a další funkce reklamních služeb, které se vztahují k našemu webu.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Umožňuje náš web sledování chování třetích stran?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Je také důležité si uvědomit, že umožňujeme sledování chování třetích stran")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_mobiz == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_mobiz == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_mobiz == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_mobiz == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_mobiz == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_mobiz == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Application.jpg": 1557,
	"./Game.jpg": 1558,
	"./Music.jpg": 1559,
	"./Video.jpg": 1560,
	"./Wallpaper.jpg": 1561,
	"./Yummy Recipe.jpg": 1562,
	"./Yummy-Recipe.jpg": 1563
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1556;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Application.38f2fdc.jpg";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Game.59bcd11.jpg";

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Music.d470ef0.jpg";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Video.b89c4e0.jpg";

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wallpaper.e1a9ce6.jpg";

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy Recipe.a9fdf92.jpg";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy-Recipe.a5c0378.jpg";

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b532b04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1572);
function injectStyle (ssrContext) {
  __webpack_require__(1565)
  __webpack_require__(1566)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b532b04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b532b04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index))])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a120e4a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1571);
function injectStyle (ssrContext) {
  __webpack_require__(1570)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a120e4a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a120e4a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_mobiz),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_mobiz)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.auth_mobiz === 'loggedin' ? '/home' : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1573)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.auth_mobiz === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_mobiz === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.auth_mobiz === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(407)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_mobiz)}})])])]),_vm._v(" "),(_vm.auth_mobiz === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_mobiz)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpicks")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(_vm._s(_vm.$t("popular")))])],1),_vm._v(" "),(_vm.auth_mobiz === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.country_mobiz == 'iq')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):(_vm.country_mobiz == 'bh')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_mobiz(_vm.is_unsub_mobiz)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daee446e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(1576);
function injectStyle (ssrContext) {
  __webpack_require__(1575)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-daee446e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daee446e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_mobiz(_vm.is_unsub_mobiz)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobizone",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_Mobizone",attrs:{"id":"appBg1"}},[_c('div',{staticClass:"blueMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Games4all_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084a3668_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Games4all_vue__ = __webpack_require__(1633);
function injectStyle (ssrContext) {
  __webpack_require__(1590)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Games4all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084a3668_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Games4all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d678bf4a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1593);
function injectStyle (ssrContext) {
  __webpack_require__(1592)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d678bf4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d678bf4a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.subcategory),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_g4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_g4all !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_g4all)]))]):_vm._e(),_vm._v(" "),(_vm.lang_g4all === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.subcategory } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.main.hotpicks[hot.subcategory]),function(game){return _c('div',{key:game.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[(game.subcategory === hot.subcategory)?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: game.content_id } }}},[(game.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":game.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_g4all !== 'english')?_c('span',[(game[("cont_name_" + _vm.lang_g4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game[("cont_name_" + _vm.lang_g4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(game.rating)}})],1)])])],1):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd26a3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1599);
function injectStyle (ssrContext) {
  __webpack_require__(1595)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd26a3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793ed86e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1598);
function injectStyle (ssrContext) {
  __webpack_require__(1597)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793ed86e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_g4all)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_g4all([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[(_vm.host_g4all == 'aedu-actel.games4all.vip')?_c('div',[_c('a',{attrs:{"href":"http://fun2u.biz/29k27082020/basketballsuperstars"}},[_c('button',{staticClass:"mobiBtn"},[_c('span',[_vm._v(_vm._s(_vm.$t("downloads")))])])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_g4all([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v("\n                  "+_vm._s(_vm.$t("download")))])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c59f3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1602);
function injectStyle (ssrContext) {
  __webpack_require__(1601)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17c59f3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c59f3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_g4all))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_g4all))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_g4all))])])]),_vm._v(" "),(_vm.authentication_g4all === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_g4all != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":""},on:{"click":function($event){return _vm.logout_g4all(_vm.is_unsub_g4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_g4all(_vm.is_unsub_g4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(466)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0546b8cd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1605);
function injectStyle (ssrContext) {
  __webpack_require__(1604)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0546b8cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0546b8cd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_g4all))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_g4all)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.content_id }
                  }}},[(dat.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_g4all !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_g4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_g4all)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9ee6be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1608);
function injectStyle (ssrContext) {
  __webpack_require__(1607)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c9ee6be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9ee6be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_g4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_g4all)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_g4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_g4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_g4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe1ae3d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1611);
function injectStyle (ssrContext) {
  __webpack_require__(1610)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fe1ae3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe1ae3d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_g4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_g4all),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_g4all !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_g4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_g4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0532fbdc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1614);
function injectStyle (ssrContext) {
  __webpack_require__(1613)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0532fbdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0532fbdc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_g4all === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_g4all !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f01664_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1617);
function injectStyle (ssrContext) {
  __webpack_require__(1616)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17f01664"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f01664_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_g4all == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_g4all == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_g4all == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_g4all == 'czech')?_c('span',[_c('privacy-czech')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      browse: {
        category: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("games4all")) {
      this.getBrowse();
      // this.getHotPicks();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(subcate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allGameData, subcateg, allDataGame, live, local, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, _subcate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = "";
                subCate = [];
                allGameData = [];
                subcateg = [];
                allDataGame = [];
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";

                //get subcategory under game
                // let subgame = await axios.get(
                //   `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=1&domain=${host}`
                // );

                // subcateg = subgame.data.data;
                //get subcategory from getBrowse()

                subcate.map(function (item) {
                  if (item.subcategory != "Arcade Games") {
                    subCate.push(item);
                  }
                });

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 11;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 15:
                if (!(i < subCate.length)) {
                  _context.next = 28;
                  break;
                }

                _context.next = 18;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subCate[i].subcategory + "&limit=50&offset=0&domain=" + host);

              case 18:
                allDataGame = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataGame.data.data.slice(0, 6);
                _subcate = subCate[i].subcategory;

                allGameData[_subcate] = new Array();
                allGameData[_subcate] = data_slice;

              case 25:
                i++;
                _context.next = 15;
                break;

              case 28:
                isload = true;

                _this.main.hotpicks = allGameData;
                subcate.length >= 4 ? _this.main.subcategory = subCate.slice(1, 4) : _this.main.subcategory = subCate;
                _this.main.isLoad = isload;

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //game as default
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=0&domain=" + host).then(function (res) {
        var data = res.data.data;

        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon["games4all.vip"]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans);
          if (trans != null) {
            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });
        _this2.browse.category = item_temp;
        _this2.getHotPicks(item_temp);
      });
    }
  }
}));

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b24854_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1628);
function injectStyle (ssrContext) {
  __webpack_require__(1620)
  __webpack_require__(1621)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10b24854"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b24854_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6825f88e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1624);
function injectStyle (ssrContext) {
  __webpack_require__(1623)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6825f88e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch games",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(474);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b936144c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1627);
function injectStyle (ssrContext) {
  __webpack_require__(1626)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b936144c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b936144c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_g4all),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[(_vm.lang_g4all !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_g4all)] !== '')?_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_g4all)]))]):_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_g4all)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation ",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.authentication_g4all === 'loggedin' ? '/home' : ''}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1629)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.authentication_g4all === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.authentication_g4all === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile gamesOnly"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.authentication_g4all === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(466)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_g4all)}})])])]),_vm._v(" "),(_vm.authentication_g4all === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v("\n                "+_vm._s(_vm.$t("home"))+"\n                ")])],1),_vm._v(" "),_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"navLinks__item "},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_g4all)]))])])],1)}),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1)],2):_vm._e(),_vm._v(" "),(_vm.authentication_g4all === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.is_unsub_g4all != '0')?_c('div',[(_vm.country_g4all == 'iq' && _vm.gateway_g4all =='mt2')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                      "+_vm._s(_vm.$t("unsubscribes"))+"\n                    ")])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},on:{"click":function($event){return _vm.logout_g4all(_vm.is_unsub_g4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_g4all(_vm.is_unsub_g4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Games4all-WHITE.4824044.png";

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f30076b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(1632);
function injectStyle (ssrContext) {
  __webpack_require__(1631)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f30076b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f30076b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v("Unsubscribe Message")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n           To unsubscribe send message UGA to 3368\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("close")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"games4all",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_Games4all",attrs:{"id":"appBg"}},[_c('div',{staticClass:"redMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobiflix_vue__ = __webpack_require__(476);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95c9258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobiflix_vue__ = __webpack_require__(1696);
function injectStyle (ssrContext) {
  __webpack_require__(1635)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobiflix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95c9258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobiflix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39007316_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1638);
function injectStyle (ssrContext) {
  __webpack_require__(1637)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39007316"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39007316_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.subcategory),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotpick_Mobif,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_Mobif !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_Mobif)]))]):_vm._e(),_vm._v(" "),(_vm.lang_Mobif === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.subcategory } }}},[_vm._v(" "+_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{ref:"hotPicksCarousel",refInFor:true,staticClass:"row mobislider"},_vm._l((_vm.$props.main.hotpicks[hot.subcategory]),function(mobif){return _c('div',{key:mobif.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiVideoExpand"},[(mobif.subcategory === hot.subcategory)?_c('router-link',{staticClass:"mobiVideo",attrs:{"to":{name: 'DetailPage', params: { id: mobif.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":mobif.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn",attrs:{"data-v-238dec4a":""}},[_c('span',{attrs:{"data-v-238dec4a":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mobif !== 'english')?_c('span',[(mobif[("cont_name_" + _vm.lang_Mobif)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(mobif[("cont_name_" + _vm.lang_Mobif)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(mobif["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(mobif["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(mobif.rating)}})],1)])]):_vm._e()],1)}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(478);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f5f9b5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1645);
function injectStyle (ssrContext) {
  __webpack_require__(1640)
  __webpack_require__(1641)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f5f9b5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f5f9b5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(479);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a4be28e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1644);
function injectStyle (ssrContext) {
  __webpack_require__(1643)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a4be28e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[(_vm.authentication_Mobif == 'loggedin')?_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])]):_vm._e(),_vm._v(" "),(_vm.authentication_Mobif == 'guest' || _vm.authentication_Mobif == '')?_c('div',{staticClass:"dummyPlayer"},[_c('div',{staticClass:"playBtn",attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""},on:{"click":function($event){return _vm.subscribeContent_Mobif([_vm.details.raw_file_url, _vm.details.content_type])}}},[_c('span',{attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""}})]),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.cover_img,"alt":""}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_Mobif)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_Mobif([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(494);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b377ff2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1648);
function injectStyle (ssrContext) {
  __webpack_require__(1647)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b377ff2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b377ff2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_Mobif))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_Mobif))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_Mobif))])])]),_vm._v(" "),(_vm.authentication_Mobif === 'loggedin' && _vm.countryCode !== 'fi')?_c('div',{staticClass:"btnContainer "},[_c('div',[_c('a',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.logout_Mobif(_vm.is_unsub_Mobif)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(495)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6941c2ab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1651);
function injectStyle (ssrContext) {
  __webpack_require__(1650)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6941c2ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6941c2ab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_Mobif))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_Mobif)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.content_id }
                  }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mobif !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_Mobif)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_Mobif)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225bde22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1654);
function injectStyle (ssrContext) {
  __webpack_require__(1653)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-225bde22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225bde22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotpick_Mobif,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_Mobif)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mobif !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Mobif)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Mobif)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(498);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d6f9a0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1657);
function injectStyle (ssrContext) {
  __webpack_require__(1656)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d6f9a0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d6f9a0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_Mobif,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_Mobif),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mobif !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_Mobif)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_Mobif)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(499);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55171cf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(1660);
function injectStyle (ssrContext) {
  __webpack_require__(1659)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55171cf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55171cf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[(_vm.mobiflix_res_sub == '')?_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")]):_c('h1',[_vm._v("\n            "+_vm._s(_vm.mobiflix_res_sub)+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(500);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78e34082_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1663);
function injectStyle (ssrContext) {
  __webpack_require__(1662)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78e34082"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78e34082_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.isAoc === true)?_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.consent_gateway($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("subscribe_messsage")))]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("subscribe")))])])])]):_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("confirmation")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_Mobif === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_Mobif !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8b1f3b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1665)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8b1f3b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8b1f3b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Poskytovateľ obsahu: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adresa: 46350 Petaling Jaya, Selangor Darul Ehsan, Malajzia")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Tieto zásady ochrany osobných údajov boli zostavené tak, aby lepšie slúžili tým, ktorí sa zaujímajú o to, ako sa ich „osobné identifikačné údaje“ (PII) používajú online. Prečítajte si pozorne naše pravidlá ochrany osobných údajov, aby ste mali jasnú predstavu o tom, ako zhromažďujeme, používame, chránime alebo inak zaobchádzame s vašimi osobne identifikovateľnými informáciami v súlade s našou webovou stránkou.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Aké osobné informácie zhromažďujeme od ľudí, ktorí navštevujú náš blog, web alebo aplikáciu?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Pri objednávaní alebo registrácii na našom webe môžete byť požiadaní, aby ste zadali svoje meno, e-mailovú adresu, poštovú adresu, telefónne číslo alebo ďalšie podrobnosti, ktoré vám pomôžu s vašimi skúsenosťami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Når samler vi inn informasjon?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vi samler inn informasjon fra deg når du registrerer deg på nettstedet vårt, fyller ut skjema eller skriver inn informasjon på nettstedet vårt. Gi oss tilbakemelding på våre produkter eller tjenester.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kedy zhromažďujeme informácie?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Zhromažďujeme od vás informácie, keď sa zaregistrujete na našom webe, vyplníte formulár alebo zadáte informácie na našom webe. Poskytnite nám spätnú väzbu k našim produktom alebo službám.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ako používame vaše informácie?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informácie, ktoré od vás zhromažďujeme, môžeme použiť pri registrácii, nákupe, registrácii na odber nášho bulletinu, odpovedaní na prieskum alebo marketingovú komunikáciu, surfovaní po webových stránkach alebo pri používaní niektorých ďalších funkcií stránok nasledujúcimi spôsobmi:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Na prispôsobenie vašich skúseností a na to, aby sme vám mohli poskytnúť typ obsahu a ponúk produktov, o ktoré sa zaujímate najviac.")]),_vm._v(" "),_c('li',[_vm._v("Vylepšiť našu webovú stránku, aby sme vám mohli lepšie slúžiť.")]),_vm._v(" "),_c('li',[_vm._v("Aby sme vám mohli poskytnúť lepšie služby pri reagovaní na vaše požiadavky na zákaznícke služby.")]),_vm._v(" "),_c('li',[_vm._v("Spravovať súťaž, propagáciu, prieskum alebo inú funkciu stránky.")]),_vm._v(" "),_c('li',[_vm._v("Pre rýchle vybavenie vašich transakcií.")]),_vm._v(" "),_c('li',[_vm._v("Požiadať o hodnotenie a hodnotenie služieb alebo produktov")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ako chránime vaše informácie?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naše webové stránky sú pravidelne kontrolované, či neobsahujú bezpečnostné medzery a známe chyby zabezpečenia, aby bola vaša návšteva našich webových stránok čo najbezpečnejšia.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Používame cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Áno. Súbory cookie sú malé súbory, ktoré stránka alebo jej poskytovateľ služieb prenáša na pevný disk vášho počítača prostredníctvom vášho webového prehliadača (ak to povolíte), ktorý umožňuje systémom stránky alebo poskytovateľa služieb rozpoznať váš prehľadávač a zaznamenať a zapamätať si určité informácie. Používame napríklad súbory cookie, ktoré nám pomáhajú zapamätať si a spracovať položky vo vašom nákupnom košíku. Používajú sa tiež na to, aby nám pomohli pochopiť vaše preferencie založené na predchádzajúcej alebo aktuálnej aktivite stránok, čo nám umožňuje poskytovať vám vylepšené služby. Ďalej používame cookies, ktoré nám pomáhajú kompilovať súhrnné údaje o premávke na webe a interakcii s ním, aby sme v budúcnosti mohli ponúkať lepšie zážitky a nástroje na webe.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Súbory cookie používame na:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pochopte a uložte preferencie používateľa pre budúce návštevy.")]),_vm._v(" "),_c('li',[_vm._v("Sledujte reklamy.")]),_vm._v(" "),_c('li',[_vm._v("Zostavte súhrnné údaje o premávke na webe a interakciách s ním, aby ste v budúcnosti ponúkli lepšie zážitky a nástroje na webe. Môžeme tiež použiť dôveryhodné služby tretích strán, ktoré sledujú tieto informácie v našom mene.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Môžete si zvoliť, aby vás počítač varoval pri každom odoslaní súboru cookie, alebo môžete vypnúť všetky súbory cookie. Urobíte to prostredníctvom nastavení prehľadávača. Pretože sa prehliadač trochu líši, pozrite sa do ponuky Pomocník prehľadávača, aby ste zistili správny spôsob úpravy súborov cookie.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Zverejnenie treťou stranou")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vaše osobné identifikačné údaje nepredávame, neobchodujeme s nimi ani ich nijakým iným spôsobom neprevádzame, pokiaľ na to vopred neposkytneme používateľom oznámenie. Nezahŕňa to hostingových partnerov webových stránok a ďalšie strany, ktoré nám pomáhajú pri prevádzkovaní našich webových stránok, pri podnikaní alebo poskytovaní služieb našim používateľom, pokiaľ sa tieto strany zaviažu zachovávať dôvernosť týchto informácií. Môžeme tiež zverejniť informácie, ak je ich vydanie vhodné na dodržanie zákonov, presadzovanie našich zásad týkajúcich sa webových stránok alebo na ochranu práv alebo majetku našich alebo iných osôb.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informácie o návštevníkoch, ktoré neumožňujú osobnú identifikáciu, však môžu byť poskytnuté iným stranám na marketingové, reklamné alebo iné účely.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Odkazy tretích strán")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Na našu webovú stránku nezahŕňame ani neponúkame produkty alebo služby tretích strán.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Požiadavky spoločnosti Google na inzerciu možno zhrnúť do princípov inzercie spoločnosti Google. ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Sú zavedené s cieľom poskytnúť používateľom pozitívny zážitok. "),_c('a',{attrs:{"href":"https://support.google.com/adspolicy/answer/6008942?hl=en&visit_id=637557114334977110-1263660480&rd=1"}},[_vm._v("Click here to view")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Spoločnosť Google ako dodávateľ tretej strany používa súbory cookie na zobrazovanie reklám na našom webe. Používanie súborov cookie DART spoločnosťou Google jej umožňuje zobrazovať reklamy našim používateľom na základe predchádzajúcich návštev našej stránky a ďalších stránok na internete. Používatelia sa môžu odhlásiť z používania súborov cookie DART navštívením pravidiel ochrany osobných údajov reklamnej a obsahovej siete Google.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Implementovali sme nasledovné:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Spoločne s dodávateľmi tretích strán, ako napríklad Google, používame súbory cookie prvej strany (napríklad súbory cookie Google Analytics) a súbory cookie tretích strán (napríklad súbor cookie DoubleClick) alebo iné identifikátory tretích strán, aby sme zhromaždili údaje týkajúce sa interakcií používateľov s zobrazenia reklám a ďalšie funkcie reklamných služieb, ktoré sa týkajú našej webovej stránky.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Vyradenie:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Používatelia môžu nastaviť predvoľby toho, ako vám Google inzeruje, pomocou stránky Nastavenia reklám Google. Prípadne sa môžete odhlásiť tak, že navštívite stránku Zrušenie iniciatívy Network Advertising Initiative alebo použijete doplnok Prehliadač odhlásenia Google Analytics.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Umožňuje náš web sledovanie správania tretích strán?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Je tiež dôležité poznamenať, že povoľujeme sledovanie správania tretích strán\n")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content Provider: Puretech")]),_vm._v(" "),_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("What Personal Information Do We Collect From The People That Visit Our Blog, Website Or App?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number or other details to help you with your experience.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("When Do We Collect Information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We collect information from you when you register on our site, fill out a form or enter information on our site. Provide us with feedback on our products or services.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How Do We Use Your Information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.")]),_vm._v(" "),_c('li',[_vm._v("To improve our website in order to better serve you.")]),_vm._v(" "),_c('li',[_vm._v("To allow us to better service you in responding to your customer service requests.")]),_vm._v(" "),_c('li',[_vm._v("To administer a contest, promotion, survey or other site feature.")]),_vm._v(" "),_c('li',[_vm._v("To quickly process your transactions.")]),_vm._v(" "),_c('li',[_vm._v("To ask for ratings and reviews of services or products")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How Do We Protect Your Information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Do We Use Cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Keep track of advertisements.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-Party Disclosure")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-Party Links")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not include or offer third-party products or services on our website.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users."),_c('a',{attrs:{"href":"https://support.google.com/adspolicy/answer/6008942?hl=en&visit_id=637557114334977110-1263660480&rd=1"}},[_vm._v("Click here to view")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("We Have Implemented The Following:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting Out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Does Our Site Allow Third-Party Behavioral Tracking?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("It's also important to note that we allow third-party behavioral tracking")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_Mobif == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_Mobif == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_Mobif == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_Mobif == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_Mobif == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_Mobif == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.lang_Mobif == 'slovakia')?_c('span',[_c('privacy-slovakian')],1):(_vm.country_Mobif == 'sk' && _vm.lang_Mobif == 'english')?_c('span',[_c('privacy-skenglish')],1):(_vm.lang_Mobif == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_Mobif == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_Mobif == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b14e4d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(1680);
function injectStyle (ssrContext) {
  __webpack_require__(1670)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46b14e4d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b14e4d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70323b7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovak_vue__ = __webpack_require__(1673);
function injectStyle (ssrContext) {
  __webpack_require__(1672)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70323b7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovak_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("SLOVENSKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmienky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy upravené: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použiteľnosť")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Termíny a podmienky uvedené nižšie (Všeobecné podmienky) sa\n            vzťahujú na Slovenskú verziu jednorazovej platenej služby Mobiflix\n            Premium (Puretech Global Sdn Bhd a /alebo Služba) ponúkanú on -\n            line cez internet od Puretech Global Sdn Bhd (ďalej len Puretech\n            Global Sdn Bhd ). Koncový užívateľ požaduje službu Mobiflix z\n            Puretech Global Sdn Bhd .\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Všeobecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Mobiflix poskytuje najlepšie sexy tapety a videá exkluzívne pre\n            váš mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrdenie / Registrácia")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Na vstup do služby Mobiflix musí Koncový používateľ zadať svoje\n            mobilné telefónne číslo a /alebo niektoré ďalšie údaje a /alebo\n            informácie prostredníctvom propagačnej webovej stránky (Vstupné\n            Stránky) prevádzkovanej Puretech Global Sdn Bhd -om. Potom Koncový\n            užívateľ dostane SMS vo svojom mobilnom zariadení, s Osobným\n            Identifikačným Číslom (PIN kód), alebo tzv ponukovú správu s\n            informáciami o službe. Zadaním obdržaného PIN kódu na vstupnej\n            stránke a /alebo zaslaním potvrdzovacej správy a /alebo používaním\n            služby Koncový užívateľ uznáva a potvrdzuje, že prečítal Všeobecné\n            obchodné podmienky, je oprávneným držiteľom mobilného účtu za\n            telefón, alebo má súhlas platiteľa telefóneho účtu používať túto\n            službu. Koncový užívateľ dostane potvrdzujúcu SMS správu o\n            úspešnej aktivácii Mobiflix služby, spôsobe, frekvencii a nákladov\n            na prevzatie Služby, rovnako ako presné detaily odhlásenia.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a Poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Mobiflix je platená služba ktorá stojí 3 SMS x 1.60 EUR / týždeň\n            Poplatok bude účtovaný na mobilný telefónny účet, alebo\n            predplatené mobilné číslo.Spôsob nabíjania je Premium MT SMSkami\n            odoslanými na Koncového užívateľa na základe jeho žiadosti o\n            službu Mobiflix. Táto správa bude obsahovať prihlasovacie údaje k\n            službe Mobiflix. Poplatky sú vyberané podľa Prevádzkovateľov\n            Mobilných Sietí. Poplatky sú odpísané proti účtu Koncového\n            užívateľa Prevádzkovateľom, v prípade predplantnej SIM sa poplatky\n            odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ týmto\n            výslovne udeľuje jeho alebo jej oprávnenie pre nabíjanie, a\n            zaväzuje sa na zaplatenie v plnej výške za poplatky, ktoré vznikli\n            v dôsledku upísania a / alebo používania služby Mobiflix. Ak nie\n            ste osoba zodpovedná za zaplatenie mobilného účtu, prosím,\n            získajte povolenie od platiteľa mobilu pred prihlásením a /alebo\n            používaním služby Mobiflix. Svojím podpisom a /alebo účasťou na\n            službe, Puretech Global Sdn Bhd predpokladá, že Koncový užívateľ\n            získal potrebné povolenie, súhlas alebo schválenie od platiteľa\n            mobilného účtu, opatrovníka alebo rodičov. Všetky SMS správy\n            zaslané Koncovým používateľom budú účtované mobilným operátorom\n            Koncového užívateľa štandardnou tarifou. Tieto tarify sa môžu\n            líšiť podľa operátora. Prosím, pre viac nformácií o uložených\n            poplatkoch kontaktujte svojho GSM operátora.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznícky servis je k dispozícii v pracovných dňoch od 09:00 do\n            17:00 Kontakt: +421 313215999 alebo mobflix.sk@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševné vlastníctvo")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu môžete použiť na svoje osobné nekomerčné použitie. Termín\n            Mobiflix a všetky ostatné ochranné známky, servisné značky a\n            /alebo obchodné názvy používané Mobiflix-om na Službe z času na\n            čas (Ochranné Známky), sú ochrannými známkami, servisnými značkami\n            a /alebo obchodnými názvami Puretech Global Sdn Bhd - u alebo\n            jednej z jeho spoločností v skupine alebo udeľovateľov jej\n            licencie, a tieto subjekty si vyhradzujú všetky práva na Ochranné\n            Známky. Okrem toho, ďalší obsah Služby, vrátane, ale nie výhradne,\n            Hry, obrázy, obrázky, grafika, fotografie, animácie, videá, hudba,\n            zvuk a text patria Mobiflix- u, alebo jednému z jeho spoločností a\n            /alebo licenčných skupín, a sú chránené autorskými právami a\n            /alebo inými právami duševného vlastníctva. Beriete týmto na\n            vedomie, že pri používaní Služby nezískate žiadne práva na\n            ochranné známky, alebo Obsah Služby, než ako je uvedené v tejto\n            Dohode. Najmä za žiadnych okolností nemôžete skopírovať ľubovoľný\n            Obsah Služby (vrátane a bez obmedzenia trivia otázky, odpovede,\n            alebo hry), alebo využívať dolovanie dát, roboty, škrabanie\n            obrazovky, alebo podobné zhromažďovanie údajov a extrakčné\n            nástroje na Službe. Zodpovednosť Použitie Mobiflix- u a /alebo web\n            stránky Mobiflixprebieha na vlastné riziko koncového užívateľa.\n            Koncový užívateľ musí poskytnúť všetko- kompatibilný mobilný\n            telefón, hardvér, alebo iné zariadenia a softvér, a zabezpečiť,\n            aby boli v prevádzkyschopnom stave a vhodné na služby Mobiflix.\n            Mobiflix nemôže zaručiť, že služby Mobiflix spĺňajú požiadavky\n            koncového užívateľa, a že stiahnutie, príjem a /alebo prezeranie\n            služieb Mobiflix bude bez prerušenia, alebo chýb. Ak kedykoľvek\n            Koncový užívateľ nie je schopný používať bez prerušenia službu\n            Puretech Global Sdn Bhd , v žiadnom prípade to nevedie k nároku na\n            zníženie poplatkov za Mobiflix služby, k akékoľvek právo na\n            vrátenie platieb dopredu zaplatených. Akékoľvek použitie služieb\n            Mobiflix je podľa vlastného uváženia a rizika koncového užívateľa,\n            a že za žiadny ale nie obmedzene, za infekcie, alebo kontaminácie,\n            alebo straty dát, alebo poškodenie(ia) hardvéru a /alebo softvéru\n            koncových užívateľov, vyplývajúcich z prístupu k webovým stránkam,\n            alebo využívania služieb Mobiflix -u, alebo stiahnutých Mobiflix\n            služieb, vrátane hardvéru a softvéru vyžadovaného na pripojenie k\n            službám Mobiflix. Je zodpovednosťou koncových užívateľov, aby\n            prijali potrebné opatrenia, aby sa zabránilo možnému poškodeniu\n            tohto druhu. V prípade, že Mobiflix je z akéhokoľvek dôvodu\n            povinný nahradiť koncovému užívateľovi priame, alebo následné\n            škody akéhokoľvek druhu, takáto náhrada v žiadnom prípade nesmie\n            prekročiť hodnotu faktúry za služby Mobiflix , platených koncovým\n            užívateľom pre údajné poškodenia. Obsah Webovej stránky bol\n            zostavený s najväčšou starostlivosťou. Avšak, Mobiflix nemôže\n            poskytnúť žiadnu záruku, pokiaľ ide o povahu, presnosť alebo obsah\n            týchto informácií. Mobiflix nenesie zodpovednosť za akékoľvek\n            chyby, opomenutia, nepresnosti, nedorozumenia, oneskorenie, alebo\n            nečitateľné objednávky, alebo oznámenia na základe používania\n            Internetu, alebo príslušného informačného miesta. Záverečné\n            ustanovenia Akékoľvek spory týkajúce sa plnenia týchto Obchodných\n            podmienok budú riešené príslušnými všeobecnými súdmi. Puretech\n            Global Sdn Bhd si vyhradzuje právo čas od času zmeniť tieto\n            podmienky. Zmeny budú oznámené koncovým užívateľom vyvesením na\n            portáli Mobiflix.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5295ef2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__ = __webpack_require__(1676);
function injectStyle (ssrContext) {
  __webpack_require__(1675)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5295ef2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ČESKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmínky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy změněno: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použitelnost")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou\n            verzi jednorázové placené služby Mobiflix Premium (Puretech Global\n            Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu\n            od společnosti Puretech Global Sdn Bhd (dále jen jako Puretech\n            Global Sdn Bhd). Koncový uživatel požaduje službu Mobiflix od\n            společnosti Puretech Global Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Obecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Mobiflix poskytuje nejlepší sexy tapety a videa výhradně pro váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrzení / registrace")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Aby měl koncový uživatel přístup k Mobiflixu, musí zadat číslo\n            svého mobilního telefonu a / nebo určitá další data a / nebo\n            informace prostřednictvím propagační webové stránky (úvodní\n            stránky) provozované společností Puretech Global Sdn Bhd. Poté\n            koncový uživatel obdrží na své mobilní zařízení SMS , s osobním\n            identifikačním číslem (PIN kód) nebo takzvanou nabídkovou zprávou\n            s informacemi o službě. Koncový uživatel zadáním přijatého PIN\n            kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a /\n            nebo používáním služby potvrzuje a potvrzuje, že si přečetl\n            Všeobecné podmínky, je autorizovaným majitelem účtu mobilního\n            telefonu nebo má souhlas plátce telefonního účtu s využitím této\n            služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné\n            aktivaci služby Mobiflix, způsobu, frekvenci a nákladech na\n            stažení Služby a také přesné údaje o odhlášení.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Mobiflix je placená služba, která stojí 3 SMS x 1,60 EUR / týden\n            Poplatek bude účtován na účet za mobilní telefon nebo na\n            předplacené mobilní číslo. Způsob nabíjení je Premium MT SMS\n            zasílaná koncovému uživateli na základě jeho požadavku na službu\n            Mobiflix. Tato zpráva bude obsahovat vaše přihlášení do Mobiflix.\n            Poplatky se vybírají podle provozovatelů mobilních sítí. Poplatky\n            jsou odepsány na účet Koncového uživatele Provozovatelem; v\n            případě SIM s předplatným jsou poplatky odečteny z kreditu\n            Koncového uživatele. Koncový uživatel mu tímto výslovně uděluje\n            právo účtovat poplatky a zavazuje se uhradit v plné výši poplatky\n            vzniklé v důsledku předplatného a / nebo používání služby\n            Mobiflix. Pokud nejste osobou odpovědnou za placení účtů za\n            mobilní zařízení, před přihlášením a / nebo použitím Mobiflix si\n            vyžádejte svolení od svého mobilního plátce. Podpisem a / nebo\n            účastí ve službě Puretech Global Sdn Bhd předpokládá, že koncový\n            uživatel získal potřebné povolení, souhlas nebo schválení od\n            plátce mobilního účtu, opatrovníka nebo rodičů. Všechny SMS zprávy\n            zasílané koncovým uživatelem budou mobilním operátorem koncového\n            uživatele účtovány za standardní tarif. Tyto sazby se mohou u\n            jednotlivých operátorů lišit. Další informace o poplatcích vám\n            poskytne váš mobilní operátor GSM.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00\n            Kontakt: +421 313215999 nebo mobflix.cz@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševní vlastnictví")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu můžete používat pro osobní, nekomerční použití. Pojem\n            Mobiflix a všechny ostatní ochranné známky, servisní značky a /\n            nebo obchodní názvy používané společností Mobiflix ve Službě čas\n            od času (ochranné známky) jsou ochranné známky, servisní značky a\n            / nebo obchodní názvy společnosti Puretech Global Sdn Bhd nebo\n            jedné z jejích společností v skupina nebo její poskytovatelé\n            licencí a tyto subjekty si vyhrazují veškerá práva k ochranným\n            známkám. Kromě toho další obsah Služeb, mimo jiné včetně her,\n            obrázků, obrázků, grafik, fotografií, animací, videí, hudby, zvuku\n            a textu, patří společnosti Mobiflix nebo jedné z jejích\n            společností a / nebo licencovaných skupin a jsou chráněny\n            autorským právem a / nebo jinými právy duševního vlastnictví.\n            Berete na vědomí, že používáním Služby nezískáte žádná práva na\n            ochrannou známku ani Obsah Služby, než jak je uvedeno v této\n            Smlouvě. Za žádných okolností nesmíte za žádných okolností\n            kopírovat jakýkoli obsah služby (včetně, bez omezení, vědomostních\n            otázek, odpovědí nebo her), ani ve službě používat dolování dat,\n            roboty, škrábance na obrazovce nebo podobné nástroje pro sběr a\n            extrakci dat. Odpovědnost Použití Mobiflixu a / nebo webu Mobiflix\n            je na vlastní riziko koncového uživatele. Koncový uživatel musí\n            poskytnout kompatibilní mobilní telefon, hardware nebo jiná\n            zařízení a software a zajistit, aby byly funkční a vhodné pro\n            služby Mobiflix. Mobiflix nemůže zaručit, že služby Mobiflix budou\n            splňovat požadavky koncových uživatelů a že stahování, přijímání a\n            / nebo prohlížení služeb Mobiflix bude nepřerušované nebo bez\n            chyb. Pokud koncový uživatel kdykoli nemůže bez přerušení používat\n            službu Puretech Global Sdn Bhd, nevede to v žádném případě k právu\n            na snížení poplatků za služby Mobiflix, k jakémukoli právu na\n            vrácení předplacených plateb. Jakékoli použití Služeb Mobiflix je\n            na uvážení a riziku koncového uživatele, a to za, nikoli však\n            výhradně, infekci nebo kontaminaci, ztrátu dat nebo poškození\n            hardwaru a / nebo softwaru koncového uživatele z přístupu na Web,\n            z používání Služeb Mobiflix nebo ze stažených Služeb Mobiflix,\n            včetně hardwaru a softwaru potřebného k připojení ke Službám\n            Mobiflix. Je odpovědností koncových uživatelů, aby přijali\n            nezbytná opatření, která zabrání možnému poškození tohoto druhu. V\n            případě, že je Mobiflix z jakéhokoli důvodu povinen odškodnit\n            koncového uživatele za přímé nebo následné škody jakéhokoli druhu,\n            nesmí taková náhrada v žádném případě překročit hodnotu faktury za\n            služby Mobiflix zaplacené koncovým uživatelem za údajné škody .\n            Obsah webových stránek byl sestaven s největší péčí. Společnost\n            Mobiflix však nemůže poskytnout žádnou záruku, pokud jde o povahu,\n            přesnost nebo obsah těchto informací. Mobiflix neodpovídá za žádné\n            chyby, opomenutí, nepřesnosti, nedorozumění, zpoždění nebo\n            nečitelné objednávky nebo oznámení založená na používání internetu\n            nebo příslušného informačního bodu. Závěrečná ustanovení Veškeré\n            spory týkající se plnění těchto Obchodních podmínek budou řešit\n            příslušné obecné soudy. Puretech Global Sdn Bhd si vyhrazuje právo\n            čas od času tyto podmínky změnit. Změny budou koncovým uživatelům\n            oznámeny zveřejněním na portálu Mobiflix.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(505);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011a3891_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(1679);
function injectStyle (ssrContext) {
  __webpack_require__(1678)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011a3891_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ENGLISH TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("General conditions")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Last modified: 13/08/2021")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Customer service is available on working days from 09:00 to 17:00\n            Contact: +421 313215999 or mobflix."+_vm._s(_vm.countryCode)+"@silverlines.info\n          ")])]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Applicability")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            The terms and conditions below (General Terms and Conditions)\n            apply to the English version of the one-time paid service Mobiflix\n            Premium (Puretech Global Sdn Bhd and / or the Service) offered\n            online via the Internet from Puretech Global Sdn Bhd (hereinafter\n            referred to as Puretech Global Sdn Bhd). The end user requests the\n            Mobiflix service from Puretech Global Sdn Bhd.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. General")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Mobiflix provides the best sexy wallpapers and videos exclusively\n            for your mobile.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n            3. Confirmation / Registration\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            To access Mobiflix, the End User must enter their mobile phone\n            number and / or certain other data and / or information through a\n            promotional website (Landing Page) operated by Puretech Global Sdn\n            Bhd. Then the End User will receive an SMS on his mobile device,\n            with a Personal Identification Number (PIN code), or a so-called\n            offer message with information about the service. By entering the\n            received PIN code on the landing page and / or sending a\n            confirmation message and / or using the service, the End User\n            acknowledges and confirms that he has read the General Terms and\n            Conditions, is an authorized mobile phone account holder or has\n            the consent of the telephone account payer to use this service.\n            The end user will receive a confirmation SMS message about the\n            successful activation of the Mobiflix service, the method,\n            frequency and costs of downloading the Service, as well as the\n            exact details of the logout.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Costs and Fees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Mobiflix is ​​a paid service that costs 3 SMS x 1.60 EUR / week\n            The fee will be charged to a mobile phone bill or a prepaid mobile\n            number. The charging method is Premium MT SMS sent to the End User\n            based on his request for the Mobiflix service. This message will\n            include your Mobiflix login. Fees are collected according to\n            Mobile Network Operators. Fees are written off against the End\n            User's account by the Operator; in the case of a pre-subscription\n            SIM, the fees are deducted from the End User's credit. The End\n            User hereby expressly grants him or her the right to charge, and\n            undertakes to pay in full for the fees incurred as a result of\n            subscribing to and / or using the Mobiflix Service. If you are not\n            the person responsible for paying your mobile bill, please get\n            permission from your mobile payer before signing in and / or using\n            Mobiflix. By signing and / or participating in the Service,\n            Puretech Global Sdn Bhd assumes that the End User has obtained the\n            necessary permission, consent or approval from the mobile account\n            payer, guardian or parents. All SMS messages sent by the End User\n            will be charged by the End User's mobile operator at a standard\n            tariff. These rates may vary by operator. Please contact your GSM\n            operator for more information on charges.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Help And Support")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Intellectual Property")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            You may use the Service for your personal, non-commercial use. The\n            term Mobiflix and all other trademarks, service marks and / or\n            trade names used by Mobiflix on the Service from time to time\n            (Trademarks) are trademarks, service marks and / or trade names of\n            Puretech Global Sdn Bhd or one of its companies in the group or\n            its licensors, and these entities reserve all rights to the\n            Trademarks. In addition, other content of the Services, including,\n            but not limited to, Games, images, pictures, graphics,\n            photographs, animations, videos, music, sound and text belong to\n            Mobiflix or one of its companies and / or licensed groups, and are\n            protected by copyright and / or other intellectual property\n            rights. You acknowledge that, through your use of the Service, you\n            will not acquire any trademark rights or Content of the Service\n            other than as set forth in this Agreement. In particular, under no\n            circumstances may you copy any Content of the Service (including,\n            without limitation, trivia questions, answers, or games), or use\n            data mining, robots, screen scratches, or similar data collection\n            and extraction tools on the Service. Liability Use of Mobiflix and\n            / or the Mobiflix website is at the end user's own risk. The end\n            user must provide a compatible mobile phone, hardware, or other\n            devices and software, and ensure that they are operational and\n            suitable for Mobiflix services. Mobiflix cannot guarantee that\n            Mobiflix Services will meet end user requirements and that\n            downloading, receiving and / or viewing Mobiflix Services will be\n            uninterrupted or error free. If at any time the End User is unable\n            to use the Puretech Global Sdn Bhd service without interruption,\n            this in no way leads to a right to a reduction in the fees for\n            Mobiflix services, to any right to a refund of prepaid payments.\n            Any use of the Mobiflix Services is at the end user's discretion\n            and risk, and that for no, but not limited to, infection, or\n            contamination, or loss of data, or damage (s) to end-user hardware\n            and / or software resulting from access to the Website , or use of\n            the Mobiflix Services, or downloaded Mobiflix Services, including\n            the hardware and software required to connect to the Mobiflix\n            Services. It is the responsibility of end-users to take the\n            necessary measures to prevent possible damage to this species. In\n            the event that Mobiflix is ​​obliged for any reason to compensate\n            the end user for direct or consequential damages of any kind, such\n            compensation may in no case exceed the value of the invoice for\n            Mobiflix services paid by the end user for the alleged damages.\n            The content of the Website has been compiled with the greatest\n            care. However, Mobiflix cannot provide any guarantee as to the\n            nature, accuracy or content of this information. Mobiflix is ​​not\n            responsible for any errors, omissions, inaccuracies,\n            misunderstandings, delays, or illegible orders, or notices based\n            on the use of the Internet or the relevant information point.\n            Final Provisions Any disputes concerning the fulfillment of these\n            Business Conditions will be resolved by the competent general\n            courts. Puretech Global Sdn Bhd reserves the right to change these\n            terms from time to time. Changes will be announced to end users by\n            posting on the Mobiflix portal.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("terms"))+"\n  ")]),_vm._v(" "),(_vm.lang_Mobif == 'slovakia')?_c('span',[_c('terms-slovak')],1):_vm._e(),_vm._v(" "),(_vm.lang_Mobif == 'czech')?_c('span',[_c('terms-czech')],1):_c('span',[_c('terms-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;
var lang = localStorage.getItem("lang_Mobif");
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      ar: {
        arLanguage: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false,
        dataLoaded: false
      },
      browse: {
        category: []
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("mobiflix")) {
      this.getBrowse();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(subcate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allMobifData, subcateg, allDataMobif, dataLoaded, live, local, subMobif, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, _subcate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = "";
                subCate = [];
                allMobifData = [];
                subcateg = [];
                allDataMobif = [];
                dataLoaded = false;
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=2&limit=4&offset=0&domain=" + host + "&lang=" + lang);

              case 10:
                subMobif = _context.sent;


                //get subcategory from getBrowse()
                subcateg = subcate;

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 12;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 19:
                if (!(i < subcateg.length)) {
                  _context.next = 32;
                  break;
                }

                _context.next = 22;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcateg[i].subcategory + "&limit=50&offset=0&domain=" + host + "&lang=" + lang);

              case 22:
                allDataMobif = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataMobif.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataMobif.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataMobif.data.data.slice(0, 6);
                _subcate = subcateg[i].subcategory;

                allMobifData[_subcate] = new Array();
                allMobifData[_subcate] = data_slice;

              case 29:
                i++;
                _context.next = 19;
                break;

              case 32:

                isload = true;
                dataLoaded = true;
                _this.main.hotpicks = allMobifData;
                subcate.length >= 4 ? _this.main.subcategory = subcateg.slice(1, 4) : _this.main.subcategory = subcateg;
                _this.main.isLoad = isload;
                _this.main.dataLoaded = dataLoaded;

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=3&limit=100&offset=0&domain=" + host + "&lang=" + lang).then(function (res) {
        var data = res.data.data;
        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          if (trans != null) {
            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);

            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon["mobiflix.vip"]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });
        _this2.getHotPicks(item_temp);
        _this2.browse.category = item_temp;
      });
    }
  }
}));

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee6f8d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1691);
function injectStyle (ssrContext) {
  __webpack_require__(1683)
  __webpack_require__(1684)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ee6f8d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee6f8d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a7c845_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1687);
function injectStyle (ssrContext) {
  __webpack_require__(1686)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a7c845_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch games",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7aa479a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1690);
function injectStyle (ssrContext) {
  __webpack_require__(1689)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7aa479a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7aa479a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_Mobif),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[(_vm.lang_Mobif !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_Mobif)] !== '')?_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_Mobif)]))]):_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_Mobif)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation ",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.authentication_Mobif === 'loggedin' || _vm.authentication_Mobif === 'guest' ? '/home' : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1692)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.authentication_Mobif === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.authentication_Mobif === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile gamesOnly"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.authentication_Mobif === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(495)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_Mobif)}})])])]),_vm._v(" "),(_vm.authentication_Mobif === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v("\n                "+_vm._s(_vm.$t("home"))+"\n                ")])],1),_vm._v(" "),_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"navLinks__item "},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_Mobif)]))])])],1)}),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1)],2):_vm._e(),_vm._v(" "),(_vm.authentication_Mobif === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[((_vm.country_Mobif == 'bh' && _vm.gcid_Mobif =='317') || (_vm.country_Mobif == 'jo' && _vm.gcid_Mobif =='319'))?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                  "+_vm._s(_vm.$t("unsubscribe"))+"\n                ")])]):_c('div',[(_vm.country_Mobif !== 'fi')?_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},on:{"click":function($event){return _vm.logout_Mobif(_vm.is_unsub_Mobif)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mobiflix.fbab832.png";

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bfedffe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(1695);
function injectStyle (ssrContext) {
  __webpack_require__(1694)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bfedffe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bfedffe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_Mobif(_vm.is_unsub_Mobif)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiflix",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[(_vm.country_Mobif == 'jo' || _vm.country_Mobif == 'bh' || _vm.country_Mobif == 'my')?_c('div',{staticClass:"appBg_Mobiflix_blur",attrs:{"id":"appBg"}},[_c('div',{staticClass:"blackMask"})]):_c('div',{staticClass:"appBg_Mobiflix",attrs:{"id":"appBg"}},[_c('div',{staticClass:"blackMask"})]),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Miximo_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1987e136_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Miximo_vue__ = __webpack_require__(1775);
function injectStyle (ssrContext) {
  __webpack_require__(1698)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Miximo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1987e136_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Miximo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8c46f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1701);
function injectStyle (ssrContext) {
  __webpack_require__(1700)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f8c46f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8c46f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_Mix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_Mix !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_Mix)]))]):_vm._e(),_vm._v(" "),(_vm.lang_Mix === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[(hot.category !== 'Video')?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[(data.content_type === 'application/x-zip-compressed' && data.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(1702)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1)]):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de242ae4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(1705);
function injectStyle (ssrContext) {
  __webpack_require__(1704)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de242ae4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de242ae4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("allCategories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-6 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_Mix)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3f49bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1708);
function injectStyle (ssrContext) {
  __webpack_require__(1707)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b3f49bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3f49bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_Mix))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_Mix))])]),_vm._v(" "),(_vm.countryCode !== 'fi' && _vm.gateway_Mix !== 'nth')?_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_Mix))])]):_vm._e()]),_vm._v(" "),(_vm.auth_Mix === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_Mix != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white"},on:{"click":function($event){return _vm.logout_Mix(_vm.is_unsub_Mix)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):(_vm.countryCode === 'fi' && _vm.gateway_Mix === 'nth')?_c('div'):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_Mix(_vm.is_unsub_Mix)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(514)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b6efe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1711);
function injectStyle (ssrContext) {
  __webpack_require__(1710)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76b6efe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b6efe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_Mix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getCategoryTranslate(_vm.$route.query.q, _vm.lang_Mix)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: hot.content_id }
                  }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot.content_name))]),_vm._v(" "),(_vm.lang_Mix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48911bd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1714);
function injectStyle (ssrContext) {
  __webpack_require__(1713)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48911bd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48911bd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_Mix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.pagePopular_Mix),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056506fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(1720);
function injectStyle (ssrContext) {
  __webpack_require__(1716)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-056506fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056506fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiximoSlider_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fb7b80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MiximoSlider_vue__ = __webpack_require__(1719);
function injectStyle (ssrContext) {
  __webpack_require__(1718)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiximoSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fb7b80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MiximoSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_Mix)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop.content_name))]),_vm._v(" "),(_vm.lang_Mix !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem "},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_Mix))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.getCategoryTitle(_vm.lang_Mix))+" "+_vm._s(_vm.$t("categories")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('miximo-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_Mix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('miximo-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_Mix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('miximo-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0713585f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1723);
function injectStyle (ssrContext) {
  __webpack_require__(1722)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0713585f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0713585f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_Mix))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_Mix)))])])]),_vm._v(" "),(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Mix !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_Mix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_Mix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d69ea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1729);
function injectStyle (ssrContext) {
  __webpack_require__(1725)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d69ea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe29ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1728);
function injectStyle (ssrContext) {
  __webpack_require__(1727)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cfe29ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe29ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns mobizone"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_Mix)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
        23,
        2,
        14,
        17,
        0,
        19,
        10,
        34,
        7,
        50,
        23,
        43,
        38,
        50,
        36,
        34,
        46,
        19,
        31,
        17
      ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_Mix([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_Mix([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_Mix([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76dad001_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1732);
function injectStyle (ssrContext) {
  __webpack_require__(1731)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76dad001"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76dad001_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_Mix === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_Mix !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fea531_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(1735);
function injectStyle (ssrContext) {
  __webpack_require__(1734)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24fea531"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fea531_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("contact_us")))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t("subject")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('select',{attrs:{"id":"select"}},[_c('option',[_vm._v(_vm._s(_vm.$t("select_subject")))]),_vm._v(" "),_c('option',{attrs:{"value":"technical"}},[_vm._v(_vm._s(_vm.$t("app_issue")))]),_vm._v(" "),_c('option',{attrs:{"value":"content"}},[_vm._v(_vm._s(_vm.$t("content")))]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v(_vm._s(_vm.$t("subscription")))])]),_vm._v(" "),_c('span',{staticClass:"arrow__upper"})])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t("message")))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('let_us')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bbdf959_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(1738);
function injectStyle (ssrContext) {
  __webpack_require__(1737)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bbdf959"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bbdf959_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b16efa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1741);
function injectStyle (ssrContext) {
  __webpack_require__(1740)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06b16efa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b16efa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_Mix == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_Mix == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_Mix == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_Mix == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_Mix == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_Mix == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.lang_Mix == 'slovakia')?_c('span',[_c('privacy-slovakian')],1):(_vm.country_Mix == 'sk' && _vm.lang_Mix == 'english')?_c('span',[_c('privacy-skenglish')],1):(_vm.lang_Mix == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_Mix == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_Mix == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fad5a90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(1753);
function injectStyle (ssrContext) {
  __webpack_require__(1743)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fad5a90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fad5a90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe4c79c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovak_vue__ = __webpack_require__(1746);
function injectStyle (ssrContext) {
  __webpack_require__(1745)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe4c79c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovak_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("SLOVENSKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmienky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy upravené: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použiteľnosť")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Termíny a podmienky uvedené nižšie (Všeobecné podmienky) sa\n            vzťahujú na Slovenskú verziu jednorazovej platenej služby Miximo\n            Premium (Puretech Global Sdn Bhd a /alebo Služba) ponúkanú on -\n            line cez internet od Puretech Global Sdn Bhd (ďalej len Puretech\n            Global Sdn Bhd ). Koncový užívateľ požaduje službu Miximo z\n            Puretech Global Sdn Bhd .\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Všeobecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Miximo poskytuje najlepšie sexy tapety a videá exkluzívne pre váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrdenie / Registrácia")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Na vstup do služby Miximo musí Koncový používateľ zadať svoje\n            mobilné telefónne číslo a /alebo niektoré ďalšie údaje a /alebo\n            informácie prostredníctvom propagačnej webovej stránky (Vstupné\n            Stránky) prevádzkovanej Puretech Global Sdn Bhd -om. Potom Koncový\n            užívateľ dostane SMS vo svojom mobilnom zariadení, s Osobným\n            Identifikačným Číslom (PIN kód), alebo tzv ponukovú správu s\n            informáciami o službe. Zadaním obdržaného PIN kódu na vstupnej\n            stránke a /alebo zaslaním potvrdzovacej správy a /alebo používaním\n            služby Koncový užívateľ uznáva a potvrdzuje, že prečítal Všeobecné\n            obchodné podmienky, je oprávneným držiteľom mobilného účtu za\n            telefón, alebo má súhlas platiteľa telefóneho účtu používať túto\n            službu. Koncový užívateľ dostane potvrdzujúcu SMS správu o\n            úspešnej aktivácii Miximo služby, spôsobe, frekvencii a nákladov\n            na prevzatie Služby, rovnako ako presné detaily odhlásenia.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a Poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Miximo je platená služba ktorá stojí 3 SMS x 1.60 EUR / týždeň\n            Poplatok bude účtovaný na mobilný telefónny účet, alebo\n            predplatené mobilné číslo.Spôsob nabíjania je Premium MT SMSkami\n            odoslanými na Koncového užívateľa na základe jeho žiadosti o\n            službu Miximo. Táto správa bude obsahovať prihlasovacie údaje k\n            službe Miximo. Poplatky sú vyberané podľa Prevádzkovateľov\n            Mobilných Sietí. Poplatky sú odpísané proti účtu Koncového\n            užívateľa Prevádzkovateľom, v prípade predplantnej SIM sa poplatky\n            odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ týmto\n            výslovne udeľuje jeho alebo jej oprávnenie pre nabíjanie, a\n            zaväzuje sa na zaplatenie v plnej výške za poplatky, ktoré vznikli\n            v dôsledku upísania a / alebo používania služby Miximo. Ak nie ste\n            osoba zodpovedná za zaplatenie mobilného účtu, prosím, získajte\n            povolenie od platiteľa mobilu pred prihlásením a /alebo používaním\n            služby Miximo. Svojím podpisom a /alebo účasťou na službe,\n            Puretech Global Sdn Bhd predpokladá, že Koncový užívateľ získal\n            potrebné povolenie, súhlas alebo schválenie od platiteľa mobilného\n            účtu, opatrovníka alebo rodičov. Všetky SMS správy zaslané\n            Koncovým používateľom budú účtované mobilným operátorom Koncového\n            užívateľa štandardnou tarifou. Tieto tarify sa môžu líšiť podľa\n            operátora. Prosím, pre viac nformácií o uložených poplatkoch\n            kontaktujte svojho GSM operátora.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznícky servis je k dispozícii v pracovných dňoch od 09:00 do\n            17:00 Kontakt: +421 313215999 alebo miximo.sk@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševné vlastníctvo")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu môžete použiť na svoje osobné nekomerčné použitie. Termín\n            Miximo a všetky ostatné ochranné známky, servisné značky a /alebo\n            obchodné názvy používané Miximo-om na Službe z času na čas\n            (Ochranné Známky), sú ochrannými známkami, servisnými značkami a\n            /alebo obchodnými názvami Puretech Global Sdn Bhd - u alebo jednej\n            z jeho spoločností v skupine alebo udeľovateľov jej licencie, a\n            tieto subjekty si vyhradzujú všetky práva na Ochranné Známky.\n            Okrem toho, ďalší obsah Služby, vrátane, ale nie výhradne, Hry,\n            obrázy, obrázky, grafika, fotografie, animácie, videá, hudba, zvuk\n            a text patria Miximo- u, alebo jednému z jeho spoločností a /alebo\n            licenčných skupín, a sú chránené autorskými právami a /alebo inými\n            právami duševného vlastníctva. Beriete týmto na vedomie, že pri\n            používaní Služby nezískate žiadne práva na ochranné známky, alebo\n            Obsah Služby, než ako je uvedené v tejto Dohode. Najmä za žiadnych\n            okolností nemôžete skopírovať ľubovoľný Obsah Služby (vrátane a\n            bez obmedzenia trivia otázky, odpovede, alebo hry), alebo využívať\n            dolovanie dát, roboty, škrabanie obrazovky, alebo podobné\n            zhromažďovanie údajov a extrakčné nástroje na Službe. Zodpovednosť\n            Použitie Miximo- u a /alebo web stránky Miximoprebieha na vlastné\n            riziko koncového užívateľa. Koncový užívateľ musí poskytnúť\n            všetko- kompatibilný mobilný telefón, hardvér, alebo iné\n            zariadenia a softvér, a zabezpečiť, aby boli v prevádzkyschopnom\n            stave a vhodné na služby Miximo. Miximo nemôže zaručiť, že služby\n            Miximo spĺňajú požiadavky koncového užívateľa, a že stiahnutie,\n            príjem a /alebo prezeranie služieb Miximo bude bez prerušenia,\n            alebo chýb. Ak kedykoľvek Koncový užívateľ nie je schopný používať\n            bez prerušenia službu Puretech Global Sdn Bhd , v žiadnom prípade\n            to nevedie k nároku na zníženie poplatkov za Miximo služby, k\n            akékoľvek právo na vrátenie platieb dopredu zaplatených. Akékoľvek\n            použitie služieb Miximo je podľa vlastného uváženia a rizika\n            koncového užívateľa, a že za žiadny ale nie obmedzene, za\n            infekcie, alebo kontaminácie, alebo straty dát, alebo\n            poškodenie(ia) hardvéru a /alebo softvéru koncových užívateľov,\n            vyplývajúcich z prístupu k webovým stránkam, alebo využívania\n            služieb Miximo -u, alebo stiahnutých Miximo služieb, vrátane\n            hardvéru a softvéru vyžadovaného na pripojenie k službám Miximo.\n            Je zodpovednosťou koncových užívateľov, aby prijali potrebné\n            opatrenia, aby sa zabránilo možnému poškodeniu tohto druhu. V\n            prípade, že Miximo je z akéhokoľvek dôvodu povinný nahradiť\n            koncovému užívateľovi priame, alebo následné škody akéhokoľvek\n            druhu, takáto náhrada v žiadnom prípade nesmie prekročiť hodnotu\n            faktúry za služby Miximo , platených koncovým užívateľom pre\n            údajné poškodenia. Obsah Webovej stránky bol zostavený s najväčšou\n            starostlivosťou. Avšak, Miximo nemôže poskytnúť žiadnu záruku,\n            pokiaľ ide o povahu, presnosť alebo obsah týchto informácií.\n            Miximo nenesie zodpovednosť za akékoľvek chyby, opomenutia,\n            nepresnosti, nedorozumenia, oneskorenie, alebo nečitateľné\n            objednávky, alebo oznámenia na základe používania Internetu, alebo\n            príslušného informačného miesta. Záverečné ustanovenia Akékoľvek\n            spory týkajúce sa plnenia týchto Obchodných podmienok budú riešené\n            príslušnými všeobecnými súdmi. Puretech Global Sdn Bhd si\n            vyhradzuje právo čas od času zmeniť tieto podmienky. Zmeny budú\n            oznámené koncovým užívateľom vyvesením na portáli Miximo.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14231999_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(1749);
function injectStyle (ssrContext) {
  __webpack_require__(1748)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14231999_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ENGLISH TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("General conditions")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Last modified: 13/08/2021")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Customer service is available on working days from 09:00 to 17:00\n            Contact: +421 313215999 or miximo."+_vm._s(_vm.country_Mix)+"@silverlines.info\n          ")])]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Applicability")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            The terms and conditions set out below (General Terms and\n            Conditions) apply to the English version of the one-time paid\n            service Miximo Premium (Puretech Global Sdn Bhd and / or the\n            Service) offered online via the Internet from Puretech Global Sdn\n            Bhd (hereinafter referred to as Puretech Global Sdn Bhd). The end\n            user requires the Miximo service from Puretech Global Sdn Bhd.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. General")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Miximo provides the best sexy wallpapers and videos exclusively\n            for your mobile.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n            3. Confirmation / Registration\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            To access Miximo, the End User must enter their mobile phone\n            number and / or certain other data and / or information through a\n            promotional website (Landing Page) operated by Puretech Global Sdn\n            Bhd. Then the End User will receive an SMS on his mobile device,\n            with a Personal Identification Number (PIN code), or a so-called\n            offer message with information about the service. By entering the\n            received PIN code on the landing page and / or sending a\n            confirmation message and / or using the service, the End User\n            acknowledges and confirms that he has read the General Terms and\n            Conditions, is an authorized mobile phone account holder or has\n            the consent of the telephone account payer to use this service.\n            The end user will receive a confirmation SMS message about the\n            successful activation of the Miximo service, the method, frequency\n            and costs of taking over the Service, as well as the exact details\n            of the logout.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Costs and Fees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Miximo is a paid service that costs 3 SMS x 1.60 EUR / week The\n            fee will be charged to a mobile phone account or a prepaid mobile\n            number. The method of charging is Premium MT SMS sent to the End\n            User based on his request for the Miximo service. This message\n            will include your Miximo login. Fees are collected according to\n            Mobile Network Operators. Fees are written off against the End\n            User's account by the Operator; in the case of a pre-subscription\n            SIM, the fees are deducted from the End User's credit. The End\n            User hereby expressly grants his or her authorization to charge,\n            and undertakes to pay in full for the fees incurred as a result of\n            subscribing to and / or using the Miximo Service. If you are not\n            the person responsible for paying your mobile bill, please obtain\n            permission from your mobile payer before signing in and / or using\n            Miximo. By signing and / or participating in the Service, Puretech\n            Global Sdn Bhd assumes that the End User has obtained the\n            necessary permission, consent or approval from the mobile account\n            payer, guardian or parents. All SMS messages sent by the End User\n            will be charged by the End User's mobile operator at a standard\n            tariff. These rates may vary by operator. Please contact your GSM\n            operator for more information on charges.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Help And Support")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Intellectual Property")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            You may use the Service for your personal, non-commercial use. The\n            term Miximo and all other trademarks, service marks and / or trade\n            names used by Miximo on the Service from time to time (Trademarks)\n            are trademarks, service marks and / or trade names of Puretech\n            Global Sdn Bhd or one of its companies in the group or its\n            licensors, and these entities reserve all rights to the\n            Trademarks. In addition, other content of the Service, including,\n            but not limited to, Games, images, pictures, graphics,\n            photographs, animations, videos, music, sound and text belongs to\n            Miximo, or one of its companies and / or licensed groups, and is\n            protected by copyright and / or other intellectual property\n            rights. You acknowledge that, through your use of the Service, you\n            will not acquire any trademark rights or Content of the Service\n            other than as set forth in this Agreement. In particular, under no\n            circumstances may you copy any Content of the Service (including,\n            without limitation, trivia questions, answers, or games), or use\n            data mining, robots, screen scratches, or similar data collection\n            and extraction tools on the Service. Liability Use of the Miximo\n            and / or the Miximo website is at the end user's own risk. The end\n            user must provide a compatible mobile phone, hardware, or other\n            equipment and software, and ensure that they are operational and\n            suitable for Miximo services. Miximo cannot guarantee that the\n            Miximo services meet the requirements of the end user and that the\n            download, receipt and / or viewing of the Miximo services will be\n            uninterrupted or error free. If at any time the End User is unable\n            to use the Puretech Global Sdn Bhd service without interruption,\n            this in no way leads to the right to a reduction in fees for\n            Miximo services, to any right to a refund of prepaid payments. Any\n            use of the Miximo Services is at the end user's sole discretion\n            and risk, and that for no, but not limited to, infections or\n            contaminations, or loss of data, or damage (s) to end users'\n            hardware and / or software resulting from access to the Website ,\n            or use of the Miximo Services, or downloaded Miximo Services,\n            including the hardware and software required to connect to the\n            Miximo Services. It is the responsibility of end-users to take the\n            necessary measures to prevent possible damage to this species. In\n            the event that Miximo is obliged for any reason to compensate the\n            end user for direct or consequential damages of any kind, such\n            compensation may in no case exceed the value of the invoice for\n            Miximo services paid by the end user for the alleged damages. The\n            content of the Website has been compiled with the greatest care.\n            However, Miximo cannot provide any guarantee as to the nature,\n            accuracy or content of this information. Miximo is not responsible\n            for any errors, omissions, inaccuracies, misunderstandings,\n            delays, or illegible orders, or notices based on the use of the\n            Internet or the relevant information point. Final Provisions Any\n            disputes concerning the fulfillment of these Business Conditions\n            will be resolved by the competent general courts. Puretech Global\n            Sdn Bhd reserves the right to change these terms from time to\n            time. Changes will be announced to end users by posting on the\n            Miximo portal.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa936fb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__ = __webpack_require__(1752);
function injectStyle (ssrContext) {
  __webpack_require__(1751)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa936fb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ČESKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmínky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy změněno: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použitelnost")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou\n            verzi jednorázové placené služby Miximo Premium (Puretech Global\n            Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu\n            od společnosti Puretech Global Sdn Bhd (dále dále jen Puretech\n            Global Sdn Bhd). Koncový uživatel vyžaduje službu Miximo od\n            společnosti Puretech Global Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Obecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Miximo poskytuje nejlepší sexy tapety a videa výhradně pro váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrzení / registrace")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Aby měl koncový uživatel přístup k Miximo, musí zadat číslo svého\n            mobilního telefonu a / nebo určitá další data a / nebo informace\n            prostřednictvím propagační webové stránky (Landing Page)\n            provozované společností Puretech Global Sdn Bhd. Poté koncový\n            uživatel obdrží na své mobilní zařízení SMS , s osobním\n            identifikačním číslem (PIN kód) nebo takzvanou nabídkovou zprávou\n            s informacemi o službě. Koncový uživatel zadáním přijatého PIN\n            kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a /\n            nebo používáním služby potvrzuje a potvrzuje, že si přečetl\n            Všeobecné podmínky, je autorizovaným majitelem účtu mobilního\n            telefonu nebo má souhlas plátce telefonního účtu s využitím této\n            služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné\n            aktivaci služby Miximo, způsobu, frekvenci a nákladech na převzetí\n            Služby a také přesné údaje o odhlášení.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Miximo je placená služba, která stojí 3 SMS x 1,60 EUR / týden\n            Poplatek bude účtován na účet mobilního telefonu nebo na\n            předplacené mobilní číslo. Způsob účtování je Premium MT SMS\n            zasílaná Koncovému uživateli na základě jeho požadavku na službu\n            Miximo. Tato zpráva bude obsahovat vaše přihlášení do Miximo.\n            Poplatky se vybírají podle provozovatelů mobilních sítí. Poplatky\n            jsou odepsány na účet Koncového uživatele Provozovatelem; v\n            případě SIM s předplatným jsou poplatky odečteny z kreditu\n            Koncového uživatele. Koncový uživatel tímto výslovně uděluje své\n            oprávnění účtovat poplatky a zavazuje se zaplatit v plné výši\n            poplatky vzniklé v důsledku předplatného a / nebo používání služby\n            Miximo. Pokud nejste osobou odpovědnou za placení účtů za mobilní\n            zařízení, před přihlášením a / nebo použitím Miximo si vyžádejte\n            povolení od svého mobilního plátce. Podpisem a / nebo účastí ve\n            službě Puretech Global Sdn Bhd předpokládá, že koncový uživatel\n            získal potřebné povolení, souhlas nebo schválení od plátce\n            mobilního účtu, opatrovníka nebo rodičů. Všechny SMS zprávy\n            zasílané koncovým uživatelem budou mobilním operátorem koncového\n            uživatele účtovány za standardní tarif. Tyto sazby se mohou u\n            jednotlivých operátorů lišit. Další informace o poplatcích vám\n            poskytne váš mobilní operátor GSM.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00\n            Kontakt: +421 313215999 nebo miximo.cz@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševní vlastnictví")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu můžete používat pro osobní, nekomerční použití. Pojem\n            Miximo a všechny ostatní ochranné známky, servisní značky a / nebo\n            obchodní názvy používané Miximo ve Službě čas od času (ochranné\n            známky) jsou ochranné známky, servisní značky a / nebo obchodní\n            názvy společnosti Puretech Global Sdn Bhd nebo jedné z jejích\n            společností v skupina nebo její poskytovatelé licencí a tyto\n            subjekty si vyhrazují veškerá práva k ochranným známkám. Kromě\n            toho další obsah Služby, mimo jiné včetně her, obrázků, obrázků,\n            grafik, fotografií, animací, videí, hudby, zvuku a textu, patří\n            společnosti Miximo nebo jedné z jejích společností a / nebo\n            licencovaných skupin, a je chráněn autorským právem a / nebo\n            jinými právy duševního vlastnictví. Berete na vědomí, že\n            používáním Služby nezískáte žádná práva na ochrannou známku ani\n            Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných\n            okolností nesmíte za žádných okolností kopírovat jakýkoli obsah\n            služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo\n            her), ani ve službě používat dolování dat, roboty, škrábance na\n            obrazovce nebo podobné nástroje pro sběr a extrakci dat.\n            Odpovědnost Používání Miximo a / nebo webových stránek Miximo je\n            na vlastní riziko koncového uživatele. Koncový uživatel musí\n            poskytnout kompatibilní mobilní telefon, hardware nebo jiné\n            vybavení a software a zajistit, aby byly funkční a vhodné pro\n            služby Miximo. Miximo nemůže zaručit, že služby Miximo splňují\n            požadavky koncového uživatele a že stahování, příjem a / nebo\n            prohlížení služeb Miximo bude nepřerušované nebo bez chyb. Pokud\n            koncový uživatel kdykoli nemůže bez přerušení používat službu\n            Puretech Global Sdn Bhd, v žádném případě to nezakládá právo na\n            snížení poplatků za služby Miximo, jakékoli právo na vrácení\n            předplacených plateb. Jakékoli použití služeb Miximo je na\n            výhradním uvážení a riziku koncového uživatele, a to bez omezení,\n            ale nikoli výhradně, infekcí nebo znečištění, ztráty dat nebo\n            poškození hardwaru a / nebo softwaru koncových uživatelů. z\n            přístupu na Web, z používání Služeb Miximo nebo stažených Služeb\n            Miximo, včetně hardwaru a softwaru potřebného k připojení ke\n            Službám Miximo. Je odpovědností koncových uživatelů, aby přijali\n            nezbytná opatření, která zabrání možnému poškození tohoto druhu. V\n            případě, že je Miximo z jakéhokoli důvodu povinna nahradit\n            koncovému uživateli přímé nebo následné škody jakéhokoli druhu,\n            nesmí taková náhrada v žádném případě překročit hodnotu faktury za\n            služby Miximo zaplacené koncovým uživatelem za údajné škody. Obsah\n            webových stránek byl sestaven s největší péčí. Miximo však nemůže\n            poskytnout žádnou záruku, pokud jde o povahu, přesnost nebo obsah\n            těchto informací. Miximo neodpovídá za žádné chyby, opomenutí,\n            nepřesnosti, nedorozumění, zpoždění nebo nečitelné objednávky nebo\n            oznámení založená na používání internetu nebo příslušného\n            informačního bodu. Závěrečná ustanovení Veškeré spory týkající se\n            plnění těchto Obchodních podmínek budou řešit příslušné obecné\n            soudy. Puretech Global Sdn Bhd si vyhrazuje právo čas od času tyto\n            podmínky změnit. Změny budou koncovým uživatelům oznámeny\n            zveřejněním na portálu Miximo.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("terms"))+"\n  ")]),_vm._v(" "),(_vm.lang_Mix == 'slovakia')?_c('span',[_c('terms-slovak')],1):_vm._e(),_vm._v(" "),(_vm.lang_Mix == 'czech')?_c('span',[_c('terms-czech')],1):_c('span',[_c('terms-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA2MTEuOTk5IDYxMS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMS45OTkgNjExLjk5OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+DQoJPHBhdGggZD0iTTIxNi4wMiw2MTEuMTk1YzUuOTc4LDMuMTc4LDEyLjI4NC0zLjcwNCw4LjYyNC05LjRjLTE5Ljg2Ni0zMC45MTktMzguNjc4LTgyLjk0Ny04LjcwNi0xNDkuOTUyICAgYzQ5Ljk4Mi0xMTEuNzM3LDgwLjM5Ni0xNjkuNjA5LDgwLjM5Ni0xNjkuNjA5czE2LjE3Nyw2Ny41MzYsNjAuMDI5LDEyNy41ODVjNDIuMjA1LDU3Ljc5Myw2NS4zMDYsMTMwLjQ3OCwyOC4wNjQsMTkxLjAyOSAgIGMtMy40OTUsNS42ODMsMi42NjgsMTIuMzg4LDguNjA3LDkuMzQ5YzQ2LjEtMjMuNTgyLDk3LjgwNi03MC44ODUsMTAzLjY0LTE2NS4wMTdjMi4xNTEtMjguNzY0LTEuMDc1LTY5LjAzNC0xNy4yMDYtMTE5Ljg1MSAgIGMtMjAuNzQxLTY0LjQwNi00Ni4yMzktOTQuNDU5LTYwLjk5Mi0xMDcuMzY1Yy00LjQxMy0zLjg2MS0xMS4yNzYtMC40MzktMTAuOTE0LDUuNDEzYzQuMjk5LDY5LjQ5NC0yMS44NDUsODcuMTI5LTM2LjcyNiw0Ny4zODYgICBjLTUuOTQzLTE1Ljg3NC05LjQwOS00My4zMy05LjQwOS03Ni43NjZjMC01NS42NjUtMTYuMTUtMTEyLjk2Ny01MS43NTUtMTU5LjUzMWMtOS4yNTktMTIuMTA5LTIwLjA5My0yMy40MjQtMzIuNTIzLTMzLjA3MyAgIGMtNC41LTMuNDk0LTExLjAyMywwLjAxOC0xMC42MTEsNS43YzIuNzM0LDM3LjczNiwwLjI1NywxNDUuODg1LTk0LjYyNCwyNzUuMDg5Yy04Ni4wMjksMTE5Ljg1MS01Mi42OTMsMjExLjg5Ni00MC44NjQsMjM2LjgyNiAgIEMxNTMuNjY2LDU2Ni43NjcsMTg1LjIxMiw1OTQuODE0LDIxNi4wMiw2MTEuMTk1eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iIzE3MkVGMCIvPg0KPC9nPjwvZz4gPC9zdmc+DQo="

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgaGVpZ2h0PSI1MTJweCIgdmlld0JveD0iMCAtMTA2IDUxMi4wMDAxOSA1MTIiIHdpZHRoPSI1MTJweCIgY2xhc3M9ImhvdmVyZWQtcGF0aHMiPjxnPjxwYXRoIGQ9Im00OTcuMzI4MTI1IDcuNjc5Njg4Yy0xMC4zOTA2MjUtNy45NDUzMTMtMjQuMjgxMjUtOS44NzEwOTQtMzYuNDIxODc1LTUuMDg5ODQ0bC0xMjIuNDgwNDY5IDM5LjM5ODQzN2MtLjQwMjM0My4xMjg5MDctLjc5Njg3NS4yNzM0MzgtMS4xODM1OTMuNDM3NS0xMi4yOTI5NjkgNS4xMDkzNzUtMjEgMTYuNDkyMTg4LTIyLjcyMjY1NyAyOS42OTkyMTktMS43MTg3NSAxMy4yMDMxMjUgMy43ODUxNTcgMjYuNDMzNTk0IDE0LjM2MzI4MSAzNC41MjczNDRsOS42MDE1NjMgNy4zNDM3NS0zNC40MjE4NzUgMzUuODg2NzE4LTk4LjQzNzUtMTA4LjI4NTE1NmMtMTEuNjc5Njg4LTEzLjc5Mjk2OC0yOC43MzgyODEtMjEuNDc2NTYyLTQ2Ljg5NDUzMS0yMS4wNTQ2ODctMTguMjI2NTYzLjQzMzU5My0zNS4wMDM5MDcgOS4wMTE3MTktNDYuMDg1OTM4IDIzLjYwMTU2MmwtMTAwLjUwMzkwNiAxMzMuOTE0MDYzYy05LjYyNSAxMi42NzU3ODEtMTMuNzM4MjgxIDI4LjM0Mzc1LTExLjU4MjAzMSA0NC4xMTMyODEgMi4xNjAxNTYgMTUuNzczNDM3IDEwLjMyODEyNSAyOS43NTc4MTMgMjMuMDA3ODEyIDM5LjM4MjgxMyAxMC43NSA4LjE2Nzk2OCAyMy40MDYyNSAxMi4xMDkzNzQgMzUuOTY0ODQ0IDEyLjEwOTM3NCAxOC4wMTE3MTkgMCAzNS44MjQyMTktOC4xMTMyODEgNDcuNTMxMjUtMjMuNTMxMjUuMDI3MzQ0LS4wMzEyNS4wNTA3ODEtLjA2NjQwNi4wNzgxMjUtLjEwMTU2Mmw1NS44ODY3MTktNzQuOTAyMzQ0IDk0LjQ3MjY1NiAxMDMuNzE4NzVjMTEuMTY3OTY5IDEzLjE4MzU5NCAyNy40NjQ4NDQgMjAuODU1NDY5IDQ0LjgyNDIxOSAyMS4wNjI1aC42NDA2MjVjMTcuMDY2NDA2IDAgMzMuMzIwMzEyLTcuMzI0MjE4IDQ0LjYyNS0yMC4xMDE1NjJsODYuMDYyNS05My4wMDc4MTMgMTQuNjY0MDYyIDExLjIxODc1YzYuMDM5MDYzIDQuNjE3MTg4IDEzLjI0NjA5NCA3LjI2MTcxOSAyMC44Mzk4NDQgNy42NDA2MjUgNS41MTU2MjUuMjgxMjUgMTEuMTM2NzE5LS42OTUzMTIgMTYuMjQyMTg4LTIuODIwMzEyIDEyLjI5Mjk2OC01LjExMzI4MiAyMS0xNi40OTIxODggMjIuNzE4NzUtMjkuNjk5MjE5LjA2NjQwNi0uNTExNzE5LjEwNTQ2OC0xLjAyNzM0NC4xMjEwOTMtMS41NDY4NzVsMy41NTQ2ODgtMTMwLjI1NzgxMmMxLjM3MTA5My0xMi45MTAxNTctNC4xMTcxODgtMjUuNzM4MjgyLTE0LjQ2NDg0NC0zMy42NTYyNXptMCAwIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIGRhdGEtb2xkX2NvbG9yPSIjMDAwMDAwIiBmaWxsPSIjMTcyRUYwIi8+PC9nPiA8L3N2Zz4NCg=="

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Application.jpg": 1760,
	"./Game.jpg": 1761,
	"./Music.jpg": 1762,
	"./Video.jpg": 1763,
	"./Wallpaper.jpg": 1764,
	"./Yummy Recipe.jpg": 1765,
	"./Yummy-Recipe.jpg": 1766
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1759;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Application.e6e78bb.jpg";

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Game.9741221.jpg";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Music.d470ef0.jpg";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Video.e8cbc74.jpg";

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wallpaper.e1a9ce6.jpg";

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy Recipe.a9fdf92.jpg";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy-Recipe.a5c0378.jpg";

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7e070d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1773);
function injectStyle (ssrContext) {
  __webpack_require__(1768)
  __webpack_require__(1769)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d7e070d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7e070d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b985c8d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1772);
function injectStyle (ssrContext) {
  __webpack_require__(1771)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b985c8d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b985c8d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_Mix),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_Mix)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.auth_Mix === 'loggedin' ? '/home' : ''}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1774)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.auth_Mix === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_Mix === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.auth_Mix === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(514)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_Mix)}})])])]),_vm._v(" "),(_vm.auth_Mix === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_Mix)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpicks"))+"\n            ")])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(_vm._s(_vm.$t("popular"))+"\n            ")])],1)]):_vm._e(),_vm._v(" "),(_vm.auth_Mix === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.is_unsub_Mix != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_Mix(_vm.is_unsub_Mix)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):(_vm.countryCode === 'fi')?_c('div'):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_Mix(_vm.is_unsub_Mix)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Miximo-1.5fc123f.png";

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"miximo",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg",attrs:{"id":"appBg1"}},[_c('div',{staticClass:"blackMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gameknight_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43de43dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gameknight_vue__ = __webpack_require__(1817);
function injectStyle (ssrContext) {
  __webpack_require__(1777)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gameknight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43de43dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gameknight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b1e4a34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1780);
function injectStyle (ssrContext) {
  __webpack_require__(1779)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b1e4a34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b1e4a34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.subcategory),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_Gkn,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_Gkn !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_Gkn)]))]):_vm._e(),_vm._v(" "),(_vm.lang_Gkn === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.subcategory } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.main.hotpicks[hot.subcategory]),function(game){return _c('div',{key:game.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[(game.subcategory === hot.subcategory)?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: game.content_id } }}},[(game.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":game.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Gkn !== 'english')?_c('span',[(game[("cont_name_" + _vm.lang_Gkn)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game[("cont_name_" + _vm.lang_Gkn)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#febc13","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(game.rating)}})],1)])])],1):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deb8e654_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1786);
function injectStyle (ssrContext) {
  __webpack_require__(1782)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deb8e654_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e078a908_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1785);
function injectStyle (ssrContext) {
  __webpack_require__(1784)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e078a908"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e078a908_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_Gkn)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#febc13","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#272958","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_Gkn([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_Gkn([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72fcae03_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1789);
function injectStyle (ssrContext) {
  __webpack_require__(1788)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72fcae03"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72fcae03_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello"))+"!")])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_Gkn))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_Gkn))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_Gkn))])])]),_vm._v(" "),(_vm.authentication_Gkn === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_Gkn != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":""},on:{"click":function($event){return _vm.logout_Gkn(_vm.is_unsub_Gkn)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_Gkn(_vm.is_unsub_Gkn)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(1790)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eaa6dba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1793);
function injectStyle (ssrContext) {
  __webpack_require__(1792)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1eaa6dba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eaa6dba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_Gkn))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_Gkn)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.content_id }
                  }}},[(dat.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Gkn !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_Gkn)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_Gkn)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#febc13","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#272958","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76408cef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1796);
function injectStyle (ssrContext) {
  __webpack_require__(1795)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76408cef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76408cef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_Gkn,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_Gkn)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiApp ",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Gkn !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_Gkn)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_Gkn)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#febc13","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#272958","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(565);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f3218da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1799);
function injectStyle (ssrContext) {
  __webpack_require__(1798)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f3218da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f3218da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_Gkn,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_Gkn),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_Gkn !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_Gkn)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_Gkn)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#febc13","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#272958","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f004a58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1802);
function injectStyle (ssrContext) {
  __webpack_require__(1801)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f004a58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f004a58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.country_Gkn === 'my')?_c('div',{style:({ 'margin-top':'10px' })},[_c('p',[_vm._v("Maxis subscription: RM3/week for unlimited access")])]):_vm._e(),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_Gkn === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_Gkn !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dee8b762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1805);
function injectStyle (ssrContext) {
  __webpack_require__(1804)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dee8b762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dee8b762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_Gkn == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_Gkn == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_Gkn == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_Gkn == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_Gkn == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_Gkn == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9c8a41c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1815);
function injectStyle (ssrContext) {
  __webpack_require__(1807)
  __webpack_require__(1808)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a9c8a41c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9c8a41c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c2377a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1811);
function injectStyle (ssrContext) {
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c2377a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch games",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2b544fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1814);
function injectStyle (ssrContext) {
  __webpack_require__(1813)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2b544fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2b544fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_Gkn),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[(_vm.lang_Gkn !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_Gkn)] !== '')?_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_Gkn)]))]):_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_Gkn)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation ",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.authentication_Gkn === 'loggedin' || _vm.authentication_Gkn === 'guest'  ? '/home' : ''}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1816)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.authentication_Gkn === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.authentication_Gkn === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile gamesOnly"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.authentication_Gkn === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(123)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello"))+"!")])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_Gkn)}})])])]),_vm._v(" "),(_vm.authentication_Gkn === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v("\n                "+_vm._s(_vm.$t("home"))+"\n                ")])],1),_vm._v(" "),_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"navLinks__item "},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route}}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_Gkn)]))])])],1)}),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1)],2):_vm._e(),_vm._v(" "),(_vm.authentication_Gkn === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.is_unsub_Gkn != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},on:{"click":function($event){return _vm.logout_Gkn(_vm.is_unsub_Gkn)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_Gkn(_vm.is_unsub_Gkn)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Gameknight-1.79e8461.png";

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameKnight",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_Gameknight",attrs:{"id":"appBg"}},[_c('div',{staticClass:"purpleMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gameonz_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f2c93e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gameonz_vue__ = __webpack_require__(1869);
function injectStyle (ssrContext) {
  __webpack_require__(1819)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gameonz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f2c93e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gameonz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59853207_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1822);
function injectStyle (ssrContext) {
  __webpack_require__(1821)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59853207"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59853207_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.subcategory),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_gonz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_gonz !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_gonz)]))]):_vm._e(),_vm._v(" "),(_vm.lang_gonz === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.subcategory } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.main.hotpicks[hot.subcategory]),function(game){return _c('div',{key:game.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[(game.subcategory === hot.subcategory)?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: game.content_id } }}},[(game.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":game.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_gonz !== 'english')?_c('span',[(game[("cont_name_" + _vm.lang_gonz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game[("cont_name_" + _vm.lang_gonz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#21d0e3","inactive-color":"#151515","active-color":"#21d0e3","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(game.rating)}})],1)])])],1):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17dfc92f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1828);
function injectStyle (ssrContext) {
  __webpack_require__(1824)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17dfc92f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17dfc92f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e1a1416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1827);
function injectStyle (ssrContext) {
  __webpack_require__(1826)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e1a1416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_gonz)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_gonz([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_gonz([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f635f43_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1831);
function injectStyle (ssrContext) {
  __webpack_require__(1830)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f635f43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f635f43_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_gonz))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_gonz))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_gonz))])])]),_vm._v(" "),(_vm.authentication_gonz === 'loggedin')?_c('div',{staticClass:"btnContainer "},[_c('div',[_c('a',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.logout_gonz(_vm.is_unsub_gonz)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(1832)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/7QCcUGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAIAcAmcAFE9vXzRoLVVyb3FkdWlkc2NkVktwHAIoAGJGQk1EMDEwMDBhOTkwMTAwMDA5ZDAzMDAwMGUxMDQwMDAwMDUwNTAwMDAzYTA1MDAwMGY4MDUwMDAwNjUwNzAwMDBiYzA4MDAwMDA2MDkwMDAwNmQwOTAwMDBhZDBiMDAwMP/bAEMABgQFBgUEBgYFBgcHBggKEAoKCQkKFA4PDBAXFBgYFxQWFhodJR8aGyMcFhYgLCAjJicpKikZHy0wLSgwJSgpKP/bAEMBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/CABEIAUABQAMAIgABEQECEQH/xAAaAAEAAwEBAQAAAAAAAAAAAAAAAwQFAgEG/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAAABEQIRAAAB+5FgAAAAAAAAAAAAAAAAAAAAAAAAAAB50eLEhTXuCo65AAAAAAAAAAAAAAB4Jp75XsEoAHOVrxJkrdauQAAAAAAAAAAAALVbYOhKAAAA89GVDsZFngAAAAAAAAAAALWjVtQCgAAAAM7RplAWAAAAAAAAAADw15eO5QAAAAAFazWM0WAAAAAAAAAAPPfDa6jklAAAAAAVrNQzxYAAAAAAAAAALBbsEoAAAAACld8MVJHYAAAAAAAAAAuU7JpCUAAAAAADMrzQ2AAAAAAAAAAO+BtqluUAAAAAB57QKnhYAAAAAAAAAAB5sZGgWxKAAAABWzblOwAAAAAAAAAAABPANtXsSgAAACoUuCwAAAAAAAAAAAAD3WyNQnEoAAEeRrZNgAAAAAAAAAAAAAHmvkbZ6JQAAOMbcxLAAAAAAAAAAAAAAJNevYgFAAAZOtAmWKAAAAAAAAAAAJLxR0ZkAoAAAAEWdrDEaVGyMAAAAAAAB1dKd60gFAAAAAAAAArUdcmI0KNcgAAAHRzcszR56KAAAAAAAAAAAA89FGltxJku+KAA61obMAoAAAAAAAAAAAAAAHOTsQJlinfFs0BKAAAAAAAAAAAAAAAABkxXaVn/xAAnEAACAQMEAAYDAQAAAAAAAAABAgMAMEAEERIzECAhIjJQEyMxcP/aAAgBAAABBQL/AAkAmhC1fgr8FGA0ylfoUjLUsSjzMAwkXgc6KKzInNTAaZSuZAm5tkbiROByR6lRxFx15KRscjTjd72oHvyNOPZe1PxyIuu9qOvIT4XtR15CfG9qOvIj672p+ORB13tTkQLu18jepBxfG039wJ+zG0/ZgTdmMh2e+fQH1OPDJuL00m+VGd0uag/rytOfbc1J9cqFtnuOeT5cL8hanfYZgOxjbktiQ8UzoeuxL150XXYf45y/z6aMcntSjZ8yFOItSpzGUiFqjjCXXQPTxlcdULUkIGC8QNOhXDVS1JCBivCDTIVvqC1JDkvCDTKVuJDQG2WRvTw2VUsY4wme6B6dSp8qjkUUKPoGAYOvE+SBdl+imXkvig5P9JKOL+GnHu+k1I8P/8QAFBEBAAAAAAAAAAAAAAAAAAAAgP/aAAgBAhEBPwFIf//EABYRAAMAAAAAAAAAAAAAAAAAAAFwgP/aAAgBAREBPwGEAgP/xAAmEAABAwMDBAIDAAAAAAAAAAABACFAETBQIjFhAhASIEFRMnBx/9oACAEAAAY/Av0Sw7br8kxT4HhO/tQ4CvVaYp5lTtcdcS6XaSq/V+v3iBJGIGIGI6b4xHTIf4gkRzmTHBxNDvf8RKGIpdAl/wBukzObfiN5tQq2SZ4smeLJnjDgWzNfe3zLZc3eVxHZO8FmTw2Wp4rMnvstUnSye5qTS3WmzQLnAP7UCoMDQqnrX5OD59AMKe5OFB7f/8QAJhAAAQMEAQQCAwEAAAAAAAAAAQARITAxQFFBUGFxoSCREIGxcP/aAAgBAAABPyH/AAm6h8Im4A8lA+R+l5vpcBKIMLdBscbFb07oBhHxZA4RWTbg570ccCjEWPBXBCiDC2Zpp7qCaBwj7SscoGALlBCHFUBCRCA3GS6aK7IaMlojs1wl75IN4a/9Mn0RX/pk+mK/9Mk38FcvuyTce0Vzs85ADscAgGtXAEgFMhbjH9PBv+McmZsYJPj/AGoOAThNgicJ5L5AAHYLd64gdccnKcfaqwzZbLePQ1fBpy71aFX1hmQ5tp7AXzTCgITGxqJQFwiSS5kno+n4c8G8NEHH2zwYWhRMhGC3SEPPpGYJMKWu07bZZEEFiGOVZ0bKkL7VR0xsrmH2GObh+1JzYMvIrOjYwz8f2pCT0hFsSTmRuEbrlGF0ETM6QAAYQMczdSEmuEQYWp3sjGYjSELAwywAwOFz/VEEFjBoNIQDe2eMmDtMr7fI4ehCzjIiPvjLuhlnskfDzh0VlcX/AC9oDosn6vx//9oADAMAAAERAhEAABAIIIIIIIIIIIIIIIIIIIIIIIIIIII4YYoIIIIIIIIIIIIIIb0zzz8IIIIIIIIIIIIIIXzzzzywgIIIIIIIIIIIJ/zzzzzy4IIIIIIIIIIIZzzzzzzy4IIIIIIIIIIJZTzzzzzy4IIIIIIIIIIIbTzzzzzywIIIIIIIIIIJLzzzzzzzwIIIIIIIIIIILzzzzzzz4IIIIIIIIIIILXzzzzzyAIIIIIIIIIIIJLzzzzzyIIIIIIIIIIIIIIXzzzzEIIIIIIIIIIIIILnzzzzEIIIIIIIIIIIIIJfzzzz8oIIIIIIIIIIIK/zzzzzx44IIIIIIIIadzzzzzzzzzws4IIIIY9zzzzzzzzzzzzzx8oIK/wA888888888888888fCS888888888888888888C/8QAGhEAAgMBAQAAAAAAAAAAAAAAAREgMEAAUP/aAAgBAhEBPxDauWFQIvEyLRM5D6g8kTPhCJvETeIm1cqFUq1NXqAwnKe//8QAHBEBAAIDAQEBAAAAAAAAAAAAAREwACBAMRBQ/9oACAEBEQE/EO2TJOFdBybl3G193PeQ5D3kLHyk4y13PPwnUveQuo2zi7jk0zk1zk7LeOi8I/HjM//EACsQAQABAgUDAwMFAQAAAAAAAAERACEwMUBBUWFxgZGh8CBQwRBwsdHx4f/aAAgBAAABPxD9iWIZ6JrKx+GVbXdpVD4fzRzwSRUnK2dnz9hvZ9CqEQ82T0oIABwEfShElZpnfkNfDLhdd+rQQQWMALkBmCYoRPRkipKVtw6yxsvYd2IuMmzVpT/iHVKDuQVlHiO+LuLlnh5oE4SHUzAWsd3448UFrnc+Gp5Fd9LY8vBj6n/NTF+71vjmewuocqMD8ox83s1DlSn51sd+o6mYdJjwHz+LqYbyfdj2Oov41DdcCHJaAQAOhjpAhtcmhysZ7HTuz0Oh9i08pyTQyXhD0NPLWVztvoBsIJaXOyerUGWsEuT+8ZYzpQKS1k9DVc0wHuYsluL8tXKWcx2cWUOxXnVwYoKXfbEWCWxXHKx2GsCTs36nOHPpZybGtSGVI1LMjZMEUxC007dRKu+uMdWX3wRD7tfAelwepj/ijLW510MD2wRIO5FCRbMa1Ai0y9jDQ+y8TrAgBVYA3qTym/Q4w9gF9c9KZKCyO2qTye2Kszrv8cYtkYMjnUk+kWn2h7qwVAeTLHigAgIMfOpvwZZ8Ulm90aOAKm+QKh06eygAAAZBo0khuVIeDyfFeKYXHHltfTIqLTpMj+6JCBkBGnAEAjmNSi+4f1U/PB2cMFAJXIDOoV3g5vehpg2NWnAmYlQS89b/AA0iFDMS5gCZTuuR3qSBzv8AGvsTDkcyoP55DJ+rN6d+DmgQd3dfsKoZXt1pff3Hk+mzG49DY+xykPiR9HAbd23otl9kgOyYdn9ZkNg8/wCfZYOaK/T/2Q=="

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cae33c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1835);
function injectStyle (ssrContext) {
  __webpack_require__(1834)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cae33c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cae33c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_gonz))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_gonz)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.content_id }
                  }}},[(dat.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_gonz !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_gonz)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_gonz)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":3,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97423610_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1838);
function injectStyle (ssrContext) {
  __webpack_require__(1837)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97423610"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97423610_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_gonz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_gonz)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_gonz !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_gonz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_gonz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":3,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c853ae2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1841);
function injectStyle (ssrContext) {
  __webpack_require__(1840)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c853ae2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c853ae2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_gonz,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_gonz),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_gonz !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_gonz)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_gonz)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":3,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b97cf54c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(1844);
function injectStyle (ssrContext) {
  __webpack_require__(1843)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b97cf54c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b97cf54c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[(_vm.mondia_res_sub == '')?_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")]):_c('h1',[_vm._v("\n            "+_vm._s(_vm.mondia_res_sub)+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebb53f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1847);
function injectStyle (ssrContext) {
  __webpack_require__(1846)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ebb53f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebb53f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.isAoc === true)?_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.consent_gateway($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("subscribe_messsage")))]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("subscribe")))])])])]):_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("confirmation")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_gonz === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_gonz !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f7f695e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(1850);
function injectStyle (ssrContext) {
  __webpack_require__(1849)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f7f695e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f7f695e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c430d6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1853);
function injectStyle (ssrContext) {
  __webpack_require__(1852)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c430d6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c430d6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_gonz == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_gonz == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_gonz == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_gonz == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_gonz == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_gonz == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;
var currentDate = new Date();

function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      browse: {
        category: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("gameonz")) {
      this.getBrowse();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(subcate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allGameData, subcateg, allDataGame, live, local, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, _subcate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = "";
                subCate = [];
                allGameData = [];
                subcateg = [];
                allDataGame = [];
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";

                // subcateg = subgame.data.data;

                subcate.map(function (item) {
                  if (item.subcategory != "Arcade Games") {
                    subCate.push(item);
                  }
                });

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 10;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 15:
                if (!(i < subCate.length)) {
                  _context.next = 28;
                  break;
                }

                _context.next = 18;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subCate[i].subcategory + "&limit=50&offset=0&domain=" + host);

              case 18:
                allDataGame = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataGame.data.data.slice(0, 6);
                _subcate = subCate[i].subcategory;

                allGameData[_subcate] = new Array();
                allGameData[_subcate] = data_slice;

              case 25:
                i++;
                _context.next = 15;
                break;

              case 28:

                isload = true;

                _this.main.hotpicks = allGameData;
                // this.main.subcategory = subCate.slice(0,3);
                subcate.length >= 4 ? _this.main.subcategory = subCate.slice(0, 3) : _this.main.subcategory = subCate;
                _this.main.isLoad = isload;

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //game as default
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=0&domain=" + host).then(function (res) {
        var data = res.data.data;

        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon["games4all.vip"]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans);
          if (trans != null) {
            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });

        _this2.browse.category = item_temp;
        _this2.getHotPicks(item_temp);
      });
    }
  }
}));

/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125cd66a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1864);
function injectStyle (ssrContext) {
  __webpack_require__(1856)
  __webpack_require__(1857)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-125cd66a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125cd66a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dff67f30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1860);
function injectStyle (ssrContext) {
  __webpack_require__(1859)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dff67f30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch games",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b9b378_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1863);
function injectStyle (ssrContext) {
  __webpack_require__(1862)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44b9b378"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b9b378_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_gonz),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[(_vm.lang_gonz !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_gonz)] !== '')?_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_gonz)]))]):_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_gonz)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation ",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.authentication_gonz === 'loggedin' ? '/home' : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1865)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.authentication_gonz === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.authentication_gonz === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.authentication_gonz === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(123)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_gonz)}})])])]),_vm._v(" "),(_vm.authentication_gonz === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v("\n                "+_vm._s(_vm.$t("home"))+"\n                ")])],1),_vm._v(" "),_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"navLinks__item "},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_gonz)]))])])],1)}),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1)],2):_vm._e(),_vm._v(" "),(_vm.authentication_gonz === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[((_vm.country_gonz == 'bh' && _vm.gcid_gonz =='317') || (_vm.country_gonz == 'jo' && _vm.gcid_gonz =='319'))?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                  "+_vm._s(_vm.$t("unsubscribe"))+"\n                ")])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},on:{"click":function($event){return _vm.logout_gonz(_vm.is_unsub_gonz)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gameonz-logo.ea824e0.png";

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4cc3b78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(1868);
function injectStyle (ssrContext) {
  __webpack_require__(1867)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4cc3b78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4cc3b78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_gonz(_vm.is_unsub_gonz)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameonz",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_gameonz",attrs:{"id":"appBg"}},[_c('div',{staticClass:"orangeMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FunPlus_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279133e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FunPlus_vue__ = __webpack_require__(1971);
function injectStyle (ssrContext) {
  __webpack_require__(1871)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FunPlus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279133e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FunPlus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6627c0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1874);
function injectStyle (ssrContext) {
  __webpack_require__(1873)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6627c0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6627c0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_fplus,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpick"))+" - \n            "),(_vm.lang_fplus !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_fplus)]))]):_vm._e(),_vm._v(" "),(_vm.lang_fplus === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[(hot.category !== 'Video')?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[(data.content_type == 'application/x-zip-compressed' && data.parent_category == 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1)]):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6a56c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(1877);
function injectStyle (ssrContext) {
  __webpack_require__(1876)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6a56c6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6a56c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all_categories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-6 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_fplus)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(604);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd5ff54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1880);
function injectStyle (ssrContext) {
  __webpack_require__(1879)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dd5ff54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd5ff54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_fplus))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_fplus))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_fplus))])])]),_vm._v(" "),(_vm.auth_fplus === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_fplus != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white"},on:{"click":function($event){return _vm.logout_fplus(_vm.is_unsub_fplus)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_fplus(_vm.is_unsub_fplus)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(605)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ce5648_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1883);
function injectStyle (ssrContext) {
  __webpack_require__(1882)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94ce5648"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ce5648_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpick"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_fplus,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all_hotpick"))+" "+_vm._s(_vm.getCategoryTranslate(_vm.$route.query.q, _vm.lang_fplus)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: hot.content_id }
                  }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b1a0a32_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1886);
function injectStyle (ssrContext) {
  __webpack_require__(1885)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b1a0a32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b1a0a32_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_fplus,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all_popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.pagePopular_fplus),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dac22a1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(1892);
function injectStyle (ssrContext) {
  __webpack_require__(1888)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dac22a1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dac22a1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobiZoneSlider_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ab4a92c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobiZoneSlider_vue__ = __webpack_require__(1891);
function injectStyle (ssrContext) {
  __webpack_require__(1890)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobiZoneSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ab4a92c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobiZoneSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_fplus",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_fplus)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem "},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lang_fplus != 'greek')?_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_fplus))+"\n  ")]):_c('h1',{staticClass:"main_title white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_fplus))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[(_vm.lang_fplus != 'greek')?_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("category"))+" - "+_vm._s(_vm.getCategoryTitle(_vm.lang_fplus)))])]):_c('h2',{staticClass:"main_title md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("category"))+" - "+_vm._s(_vm.getCategoryTitle(_vm.lang_fplus)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('mobizone-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_fplus,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('mobizone-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_fplus,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('mobizone-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01790e18_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1895);
function injectStyle (ssrContext) {
  __webpack_require__(1894)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01790e18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01790e18_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_fplus))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_fplus)))])])]),_vm._v(" "),(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_fplus !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_fplus)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_fplus)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44bf3802_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1902);
function injectStyle (ssrContext) {
  __webpack_require__(1897)
  __webpack_require__(1898)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44bf3802"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44bf3802_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(612);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59976866_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(1901);
function injectStyle (ssrContext) {
  __webpack_require__(1900)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59976866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59976866_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns mobizone"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[(_vm.auth_fplus == 'loggedin')?_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])]):_vm._e(),_vm._v(" "),(_vm.auth_fplus == 'guest' || _vm.auth_fplus == '')?_c('div',{staticClass:"dummyPlayer"},[_c('div',{staticClass:"playBtn",attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""},on:{"click":function($event){return _vm.subContent_fplus([_vm.details.file_url, _vm.details.category])}}},[_c('span',{attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""}})]),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.cover_img,"alt":""}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_fplus)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
        23,
        2,
        14,
        17,
        0,
        19,
        10,
        34,
        7,
        50,
        23,
        43,
        38,
        50,
        36,
        34,
        46,
        19,
        31,
        17
      ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.country_fplus == 'iq')?_c('span',[_c('img',{staticClass:"back_img",attrs:{"src":__webpack_require__(1903)},on:{"click":function($event){return _vm.goBack()}}})]):_vm._e(),_vm._v(" "),(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_fplus([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_fplus([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_fplus([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/back.b23c0d3.png";

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248f432a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1906);
function injectStyle (ssrContext) {
  __webpack_require__(1905)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-248f432a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248f432a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[(_vm.gcid_fplus == '303')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"10","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_fplus === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_fplus !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c328064a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(1915);
function injectStyle (ssrContext) {
  __webpack_require__(1908)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c328064a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c328064a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("contact_us")))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t("subject")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('select',{attrs:{"id":"select"}},[_c('option',[_vm._v(_vm._s(_vm.$t("select_subject")))]),_vm._v(" "),_c('option',{attrs:{"value":"technical"}},[_vm._v(_vm._s(_vm.$t("app_issue")))]),_vm._v(" "),_c('option',{attrs:{"value":"content"}},[_vm._v(_vm._s(_vm.$t("content")))]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v(_vm._s(_vm.$t("subscription")))])]),_vm._v(" "),_c('span',{staticClass:"arrow__upper"})])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t("message")))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('let_us')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed64180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashGreek_vue__ = __webpack_require__(1912);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed64180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΠΙΚΟΙΝΩΝΗΣΤΕ ΜΑΖΙ ΜΑΣ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("FUNPLUS")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΔΙΑΓΡΑΦΗ ΑΠΟ ΤΗΝ FUNPLUS")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην περίπτωση που επιθυμείτε τη διαγραφή σας από κάποια υπηρεσία της MOBIVAS, μπορείτε να\nακολουθήσετε μία από τις παρακάτω διαδικασίες:\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(ι.) Να αποστείλετε την λέξη STOP FNP στον κωδικό 54006 ή 54124 με κόστος απλού τυπικού\nμηνύματος που διαφοροποιείται με βάση τον πάροχο κινητής τηλεφωνίας, που έχετε επιλέξει. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στη συνέχεια, θα λάβετε άμεσα δωρεάν μήνυμα από το 54303 το οποίο θα επιβεβαιώνει την διαγραφή\nσας από την υπηρεσία/ες. Ο συγκεκριμένος κωδικός 54303 χρησιμοποιείται μόνο για την αποστολή\nδωρεάν ενημερωτικών μηνυμάτων από την υπηρεσία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(ii.) Να καλέσετε στο 2111881795 (απλή χρέωση από οποιοδήποτε σταθερό τηλέφωνο):\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("- Επιλέγοντας (1) και αφού ακολουθήσετε τις ηχογραφημένες οδηγίες διαγράφεστε από την Υπηρεσία.\n(24ωρη Εξυπηρέτηση)")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("- Επιλέγοντας (2) θα εξυπηρετηθείτε από έναν αντιπρόσωπό μας, προκειμένου να γίνει η διαγραφή σας\n(Ώρες Εξυπηρέτησης: 10π.μ. ως 6μ.μ)")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία FUNPLUS, στην Ελλάδα υποστηρίζεται από την MOBIVAS Μονοπρόσωπη ΙΚΕ μέσω των\n5ψηφίων κωδικών της και της τεχνικής υποδομής της.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορείτε επίσης να επικοινωνήσετε και μέσω email στο support@mobivas.gr")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7797dd0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashEnglish_vue__ = __webpack_require__(1914);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7797dd0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("UNSUBSCRIBE FROM "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you wish to unsubscribe from any PAYDASH service, you may follow one of the following procedures:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(i.) Send the word "),_c('span',{staticClass:"redtext"},[_vm._v("STOP FNP")]),_vm._v(" to the code "),_c('span',{staticClass:"redtext"},[_vm._v("54006 or 54124")]),_vm._v(" with a standard text message charge, which may vary depending on your mobile phone operator. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You will, subsequently, receive a free message from 54303, which will confirm the termination of your subscription from the service(s). This specific code 54303 is only used to deliver free informative messages by the service.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(ii.) Call at 2111881788 (standard charge from any landline): ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("- By choosing option (1) and after you follow the recorded instructions, you unsubscribe from the service (24hour Customer Support ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("- By choosing option (2) one of our agents will assist you, in order to complete the termination of your subscription (Customer Support: 10 am to 6pm) ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Service "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")]),_vm._v(" in Greece is supported by PAYDASH Single Person PC via its 5 digit codes and technical connection.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You can also contact us via email to c.support@paydash.gr ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),(_vm.country_name_fplus == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('contact-paydash-greek')],1):_c('span',[_c('contact')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62493993_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(1918);
function injectStyle (ssrContext) {
  __webpack_require__(1917)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62493993"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62493993_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64fd6de6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1927);
function injectStyle (ssrContext) {
  __webpack_require__(1920)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64fd6de6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64fd6de6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a07c260_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashGreek_vue__ = __webpack_require__(1923);
function injectStyle (ssrContext) {
  __webpack_require__(1922)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a07c260_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. ΣΚΟΠΟΣ ΤΗΣ ΠΟΛΙΤΙΚΗΣ ΑΠΟΡΡΗΤΟΥ ΚΑΙ ΠΕΔΙΟ ΕΦΑΡΜΟΓΗΣ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η ανώνυμη εταιρεία με την επωνυμία Puretech Global Limited εδρεύει επί του Χονγκ Κονγκ (Unit\n2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,Mongkok, Kowloon) Εφεξής, στην\nπαρούσα θα καλείται χάριν συντομίας, η «Εταιρεία».\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην παρούσα Πολιτική Απορρήτου περιγράφονται ο τρόπος συλλογής και επεξεργασίας των\nπροσωπικών δεδομένων που λαμβάνουμε, μέσω διαδικτύου ή με άλλους τρόπους και οι πρακτικές\nαπορρήτου της Εταιρείας, η οποία δεσμεύεται να προστατεύει και να επεξεργάζεται νόμιμα τα\nπροσωπικά δεδομένα, σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων της ΕΕ 679/2016\n(ΓΚΠΔ) και τους εφαρμόσιμους αυτού Νόμους. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η εταιρεία απευθύνεται σε ενήλικο κοινό. Δεν συλλέγουμε προσωπικές πληροφορίες από κανένα\nπρόσωπο, το οποίο γνωρίζουμε ότι είναι κάτω των 18 ετών χωρίς την προηγούμενη επαληθεύσιμη\nσυγκατάθεση του ασκούντος την γονική μέριμνα. Ο ασκών τη γονική μέριμνα έχει το δικαίωμα,\nύστερα από αίτημά του, να ενημερωθεί για τις πληροφορίες που δόθηκαν από τον ανήλικο και/ή\nνα ζητήσει την διαγραφή τους. Εάν αντιληφθούμε ότι ένα άτομο που υποβάλλει τα προσωπικά του\nδεδομένα είναι μικρότερο των 18 ετών θα προβούμε στη διαγραφή τους το συντομότερο δυνατό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η παρούσα Πολιτική Απορρήτου ενσωματώνεται και υπόκειται στους ‘’ Γενικούς Όρους &\nΠροϋποθέσεις’’ στην ιστοσελίδα της Εταιρείας. Η Εταιρεία διεξάγει τις δραστηριότητές της μέσω\nτου ιστότοπου"),_c('a',{attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v(" https://www.puretechglobal.com/")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. ΟΡΙΣΜΟΙ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα προσωπικά δεδομένα είναι πληροφορίες που μπορούν να σχετίζονται με ένα άτομο – φυσικό\nπρόσωπο. Τα δεδομένα θεωρούνται προσωπικά εάν ταυτοποιείται το πρόσωπο το οποίο αφορούν. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κατάρτιση προφίλ είναι μια συλλογή δεδομένων που επιτρέπει την εκτίμηση των χαρακτηριστικών\nενός ατόμου και συνεπώς σημαντικών πτυχών της προσωπικότητάς του.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το υποκείμενο δεδομένων είναι φυσικό πρόσωπο στο οποίο αφορούν τα προσωπικά δεδομένα.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η επεξεργασία δεδομένων είναι οποιαδήποτε δραστηριότητα που περιλαμβάνει προσωπικά\nδεδομένα, ανεξάρτητα από τα μέσα και τη διαδικασία που εφαρμόζεται, π.χ. η συλλογή,\nαποθήκευση, χρήση, αναθεώρηση, αποκάλυψη, αρχειοθέτηση, προβολή και καταστροφή\nπροσωπικών δεδομένων.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ως διαβίβαση νοείται η πρόσβαση στα προσωπικά δεδομένα, για παράδειγμα επιτρέποντας\nπρόσβαση, μετάδοση ή δημοσίευση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο υπεύθυνος επεξεργασίας είναι το νομικό πρόσωπο που αποφασίζει για το σκοπό, το περιεχόμενο\nκαι τη διαδικασία επεξεργασίας δεδομένων προσωπικού χαρακτήρα.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο εκτελών την επεξεργασία είναι ένα φυσικό ή νομικό πρόσωπο που επεξεργάζεται δεδομένα\nπροσωπικού χαρακτήρα σύμφωνα με τις οδηγίες του υπεύθυνου επεξεργασίας δεδομένων.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. ΣΚΟΠΟΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα προσωπικά δεδομένα υποβάλλονται σε επεξεργασία μόνο για τον σκοπό που υποδεικνύεται\nκατά τη στιγμή της συλλογής, ή για το σκοπό που προβλέπεται από το νόμο. Οι πληροφορίες που\nσυλλέγουμε, τα προσωπικά δεδομένα, μας βοηθούν να δημιουργήσουμε ή να βελτιώσουμε τη\nσχέση μας μαζί σας και να εξατομικεύουμε και να βελτιώνουμε διαρκώς την εμπειρία σας με την\nΕταιρεία μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η επεξεργασία των προσωπικών δεδομένων γίνεται νόμιμα κα καλόπιστα και τα δεδομένα που\nσυλλέγονται ή αποθηκεύονται είναι απαραίτητα για την εκπλήρωση του σκοπού της επεξεργασίας\nτους, η οποία η Εταιρεία διασφαλίζει ότι είναι νόμιμη και συνεπής με το σκοπό για τον οποίο\nσυλλέχθηκαν.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. ΕΙΔΗ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΣΥΛΛΕΓΟΝΤΑΙ ΚΑΙ ΤΡΟΠΟΙ ΣΥΛΛΟΓΗΣ ΤΟΥΣ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΠΟΙΑ ΠΡΟΣΩΠΙΚΑ ΔΕΔΟΜΕΝΑ ΣΥΛΛΕΓΟΥΜΕ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το είδος προσωπικών δεδομένων που μπορεί να συλλεχθούν συμπεριλαμβάνει το πλήρες\nονοματεπώνυμό σας, την ηλεκτρονική σας διεύθυνση, πληροφορίες χρέωσης ή αριθμό κινητού\nτηλεφώνου και παρόμοια δεδομένα, όπως αυτά μπορεί να ζητηθούν ανά διαστήματα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Συλλέγουμε τα προσωπικά σας δεδομένα είτε επειδή εσείς μας τα παρέχετε, είτε με αυτόματα\nμέσα. Πιο συγκεκριμένα: ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Α. ΠΛΗΡΟΦΟΡΙΕΣ ΠΟΥ ΜΑΣ ΠΑΡΕΧΕΤΕ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Συλλέγουμε προσωπικά δεδομένα από εσάς όταν υποβάλλετε με δική σας πρωτοβουλία\nπληροφορίες σε εμάς και συγκεκριμένα, όταν:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('ul',{staticClass:"mobitxt"},[_c('li',[_vm._v("πραγματοποιείτε εγγραφή στον ιστότοπό μας για λήψη ψυχαγωγικού περιεχομένου κινητών\nτηλεφώνων, όπως αστρολογικές προβλέψεις, ήχους ειδοποιήσεων, παιχνίδια, φωτογραφίες,\nειδήσεις και άλλα αντικείμενα,")]),_vm._v(" "),_c('li',[_vm._v("πραγματοποιείτε σύνδεση επιλέγοντας τις λήψεις αρχείων της Εταιρείας χωρίς εγγραφή στην\nτοποθεσία https://www.puretechglobal.com/, όπως για Μεμονωμένες Λήψεις ή Συνδρομές\nμέσω SMS χρησιμοποιώντας το κινητό σας τηλέφωνο,")]),_vm._v(" "),_c('li',[_vm._v("δηλώνετε συμμετοχή σε δραστηριότητες όπως κληρώσεις λαχνών, διαγωνισμούς, παιχνίδια,\nέρευνες, φόρουμ, ")]),_vm._v(" "),_c('li',[_vm._v("υποβάλλετε απόψεις, ιδέες, ή προτάσεις σε εμάς ή μέσω συνομιλιών μας")]),_vm._v(" "),_c('li',[_vm._v("μας τα μεταφέρουν αξιόπιστα τρίτα μέρη με τα οποία συνεργαζόμαστε για την επίτευξη του\nσκοπού για τον οποίο υποβάλλατε τα προσωπικά σας δεδομένα καθώς και από δημόσιες\nβάσεις δεδομένων. ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Β. ΠΛΗΡΟΦΟΡΙΕΣ ΠΟΥ ΣΥΛΛΕΓΟΥΜΕ ΜΕ ΑΥΤΟΜΑΤΑ ΜΕΣΑ - COOKIES")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα cookies είναι πληροφορίες οι οποίες τοποθετούνται αυτόματα σε προκαθορισμένο φάκελο στον\nυπολογιστή σας κάθε φορά που μπαίνετε σε συγκεκριμένες ιστοσελίδες. Τα cookies συμβάλλουν\nστο να διακρίνουν μοναδικά τον υπολογιστή σας στον διακομιστή. Μας επιτρέπουν να συλλέγουμε\nπληροφορίες σε σχέση με τον διακομιστή ώστε να σας βοηθήσουμε να κινηθείτε καλύτερα στο\nδιαδίκτυο, καθώς και για να μπορέσουμε να αναλύσουμε την ιστοσελίδα και να ελέγξουμε την\nλειτουργία της. Η Εταιρεία χρησιμοποιεί cookies για να αναγνωρίσει το πρόγραμμα περιήγησής σας\nστο διαδίκτυο, να προσδιορίσει εάν έχετε εγκαταστήσει το λογισμικό ενεργοποίησης που ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("απαιτείται για πρόσβαση σε συγκεκριμένο υλικό στις τοποθεσίες μας στο διαδίκτυο, να\nπροσδιορίσει το συνολικό αριθμό επισκεπτών και να σας αναγνωρίσει όταν επιστρέψετε στον\nιστότοπο της Εταιρείας. Πληροφορίες σχετικά με τις δραστηριότητές σας στον ιστότοπό μας και\nάλλα μη προσωπικά δεδομένα σας, μπορεί επίσης να χρησιμοποιηθούν, για τον περιορισμό των\nηλεκτρονικών διαφημίσεων που συναντάτε, σε εκείνες που πιστεύουμε πως είναι σύμφωνες με τα\nενδιαφέροντά σας. Τα cookies μπορούν να αποθηκεύσουν τον κωδικό πρόσβασής σας για εύκολη\nσύνδεση σε μια τοποθεσία, την οποία έχετε προηγουμένως επισκεφθεί ή μπορούν να\nαποθηκεύσουν τις προτιμήσεις σας για να σας οδηγήσουν σε μια προσαρμοσμένη σε αυτές\nιστοσελίδα")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα cookies και άλλα μέσα αναγνώρισης δεν συλλέγουν αναγνωρίσιμες πληροφορίες για το άτομό\nσας αυτόματα. Μόνο στην περίπτωση που εθελοντικά υποβάλλετε αναγνωρίσιμη πληροφορία,\nόπως αίτηση εγγραφής ή αποστολή ηλεκτρονικού μηνύματος. Τότε τα αυτόματα μέσα θα\nχρησιμοποιηθούν για να δώσουν περαιτέρω πληροφορίες σχετικά με την χρήση που κάνετε στις\nιστοσελίδες και/ή τα διαδραστικά (Interactive) ηλεκτρονικά μηνύματα με απώτερο σκοπό την\nαύξηση της χρησιμότητάς τους για εσάς")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα περισσότερα προγράμματα περιήγησης (browsers) είναι προγραμματισμένα να δέχονται\ncookies, παρόλα αυτά μπορείτε να ρυθμίσετε το δικό σας πρόγραμμα περιήγησης έτσι ώστε να\nαρνείται την λήψη αυτών ή να σας ειδοποιεί κάθε φορά που λαμβάνετε ένα cookie. Επισημαίνουμε\nότι ορισμένα μέρη της ιστοσελίδας μας μπορεί να μην λειτουργήσουν σωστά σε περίπτωση που\nέχετε απορρίψει τα cookies, με αποτέλεσμα να μην έχετε πρόσβαση σε ορισμένες δυνατότητες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Είναι πιθανό να εμφανίζονται διαφημίσεις τρίτων στην διαδικτυακή τοποθεσία της Εταιρείας, οι\nοποίες μπορεί, επίσης, να περιέχουν cookies που ορίζονται από τον διαφημιστή ή τον\nδιαφημιζόμενο, τα οποία η εταιρεία μας δεν ελέγχει. Συνεπώς, θα πρέπει να ελέγξετε την πολιτική\nαπορρήτου του διαφημιστή ή διαφημιζόμενου, προκειμένου να διαπιστώσετε εάν κάνει χρήση\ncookies και με ποιον τρόπο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ενδέχεται να χρησιμοποιήσουμε cookies και παρόμοια εργαλεία για να συσχετίσουμε τη χρήση του\nιστότοπού μας από εσάς με προσωπικά δεδομένα που λαμβάνονται από εσάς ή ένα αξιόπιστο τρίτο\nμέρος, συνεργάτη μας. Για παράδειγμα, εάν μας έχετε ζητήσει να σας στείλουμε πληροφορίες\nσχετικά με μελλοντικά προϊόντα ή προωθητικές ενέργειές μας, cookies ή/και ιστορικό περιήγησης\nστο διαδίκτυο σχετικά με τις δραστηριότητές σας στον ιστότοπό μας μπορεί να μας επιτρέψουν να\nπεριορίσουμε το υλικό που σας παρέχουμε σε αυτό που θεωρούμε ότι θα βρείτε ενδιαφέρον, με\nβάση τις προηγούμενες ηλεκτρονικές σας δραστηριότητες και προτιμήσεις. Ωστόσο, εάν η εταιρεία\nεπιθυμεί να συνδυάσει τα προσωπικά σας δεδομένα και cookies ή πληροφορίες ιστορικού\nπεριήγησης στο διαδίκτυο με αυτόν τον τρόπο, θα λάβουμε τη ρητή συγκατάθεσή σας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επιπλέον, οι τεχνικές υπηρεσίες και άλλες υπηρεσίες της Εταιρείας ή συνεργάτες μας μπορεί να\nσυλλέγουν πληροφορίες σχετικά με τους επισκέπτες της ιστοσελίδας της Εταιρείας αυτόματα με\nσκοπό την συντήρηση, τη βελτίωση, ασφάλεια και άλλες νόμιμες αιτίες. Τέτοιες πληροφορίες\nμπορεί να περιλαμβάνουν τη διεύθυνση IP επισκεπτών, τον τύπο προγράμματος περιήγησης, την\nημερομηνία, την ώρα και τη διάρκεια της επίσκεψης και συγκεκριμένες σελίδες που\nεπισκεφθήκατε. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. ΠΡΑΚΤΙΚΕΣ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΣΧΕΤΙΚΑ ΜΕ ΤΗ ΣΥΛΛΟΓΗ ΤΩΝ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΚΑΙ ΠΑΡΟΧΗ\nΕΝΗΜΕΡΩΣΗΣ ΤΩΝ ΥΠΟΚΕΙΜΕΝΩΝ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διασφαλίζει ότι, όταν της παρέχετε προσωπικά δεδομένα σας, έχετε ενημερωθεί σχετικά\nμε το ποιος συλλέγει τις πληροφορίες, τον τρόπο και τον σκοπό συλλογής αυτών, καθώς και με το \nείδος της χρήσης των πληροφοριών αυτών από την Εταιρεία. Όταν παρέχετε τα προσωπικά\nδεδομένα σας, η Εταιρεία θα σας ειδοποιεί σχετικά με τις επιλογές σας αναφορικά με τη χρήση των\nπροσωπικών δεδομένων σας, συμπεριλαμβανομένης ενδεχόμενης κοινής χρήσης αυτών από εμάς\nμε τρίτες εταιρείες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην παρούσα Πολιτική περιγράφονται τα είδη των άλλων εταιρειών που μπορεί να επιθυμούν\nαποστολή πληροφοριών προς εσάς σχετικά με τα προϊόντα και υπηρεσίες τους και επομένως\nεπιθυμούν να μοιραστούν τα προσωπικά δεδομένα σας, με την προϋπόθεση πως έχετε δώσει στην\nΕταιρεία την ρητή σας συγκατάθεση για να το πράξει. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην περίπτωση που τα προσωπικά δεδομένα των υποκειμένων συλλέγονται χειροκίνητα ή με\nτρόπο μη συνδεόμενο με το διαδίκτυο, όπως μέσω ταχυδρομικής κάρτας ή φόρμας συνδρομής, η\nαναλυτική ειδοποίηση δεν είναι εφικτή, και προκειμένου η Εταιρεία να λάβει τη ρητή συγκατάθεση\nτων υποκειμένων εφαρμόζεται η αποστολή μίας σύντομης ειδοποίησης που τους περιγράφει τον\nτρόπο λήψης του πλήρους κειμένου της παρούσας Πολιτικής και άλλων σχετικών πληροφοριών\nαπό εμάς. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο ιστότοπος της Εταιρείας μπορεί να περιέχει σύνδεσμο που οδηγεί στους ιστότοπους άλλων\nεταιρειών. Ορισμένες από αυτές τις τοποθεσίες τρίτων μπορεί να φέρουν λογότυπο της Εταιρείας\nμας ακόμη και αν δεν τους διαχειριζόμαστε και δεν εξαρτώνται από εμάς.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στον ιστότοπο της Εταιρείας ενδέχεται να εμφανίζονται διαφημίσεις άλλων εταιρειών. Η Εταιρεία\nδεν φέρει ευθύνη για τις πρακτικές τρίτων μερών ή για τις πολιτικές απορρήτου τρίτων μερών ή\nτοπικών διαφημιστικών εταιρειών στο Internet, στων οποίων την ιστοσελίδα μπορείτε να\nμεταφερθείτε μέσω συνδέσμου που εμφανίζεται στον ιστότοπο της Εταιρείας μας. Όταν\nαπομακρυνθείτε από την τοποθεσία της Εταιρείας μέσω ενός τέτοιου συνδέσμου ή με κλικ σε μια\nδιαφήμιση, θα πρέπει να ελέγξετε την ισχύουσα πολιτική απορρήτου του τρίτου μέρους ή\nτοποθεσίας διαφημιστή, ώστε να προσδιορίσετε τον τρόπο που θα χειριστούν οποιαδήποτε\nπροσωπικά δεδομένα συλλέξουν από εσάς. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο ιστότοπος της Εταιρείας μπορεί, επίσης, να συνδέεται με τοποθεσίες που λειτουργούν από\nσχετιζόμενες εταιρείες με την Εταιρεία μας, όπως εταιρείες που είναι μέλη του Ομίλου της\nΕταιρείας. Αν και τα μέλη του Ομίλου της Εταιρείας τηρούν τους κανόνες του Ομίλου, τα\nυποκείμενα των προσωπικών δεδομένων που επισκέπτονται αυτές τις σχετιζόμενες με εμάς\nτοποθεσίες θα πρέπει να ανατρέχουν στις ξεχωριστές πολιτικές απορρήτου και πρακτικές τους, οι\nοποίες ενδέχεται να διαφέρουν σε ορισμένα θέματα από την παρούσα Πολιτική. \n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. ΧΡΗΣΗ/ΕΠΕΞΕΡΓΑΣΙΑ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΑΠΟ ΤΗΝ ΕΤΑΙΡΕΙΑ ΚΑΙ ΔΙΑΒΙΒΑΣΗ ΣΕ ΤΡΙΤΑ\nΜΕΡΗ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία θα χρησιμοποιήσει τα προσωπικά δεδομένα που της παρέχετε με τρόπο που συμφωνεί\nμε την παρούσα Πολιτική και αποκλειστικά και μόνο για τους σκοπούς για τους οποίους\nυποβλήθηκαν και δεν θα τα διαβιβάσει σε τρίτα μέρη που δεν σχετίζονται και συνεργάζονται με\nαυτή, εκτός εάν λάβει την ρητή συγκατάθεσή σας. Εάν η Εταιρεία λάβει προσωπικά δεδομένα από\nένα τρίτο μέρος, όπως έναν συνεργάτη, η χρήση των πληροφοριών από την Εταιρεία θα διέπεται\nαπό την παρούσα Πολιτική. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί να χρησιμοποιήσει τα προσωπικά δεδομένα που της χορηγήσατε κατά την\nεγγραφή σας για να σας στείλει σημαντικές πληροφορίες και ενημερώσεις σχετικά με τον\nλογαριασμό σας και τις υπηρεσίες που ζητήσατε να σας παρέχει. Επιπλέον, όταν η Εταιρεία\nσυλλέγει προσωπικά δεδομένα από το ίδιο το υποκείμενο κατά την υποβολή αιτήματός του για \nλήψη αρχείων και υπηρεσιών από την Εταιρεία, η Εταιρεία θα επεξεργαστεί το αίτημα συνδρομής\nή παροχής υπηρεσίας προς το υποκείμενο, συμπεριλαμβανομένης της επεξεργασίας εκπλήρωσης\nπαραγγελίας και πληρωμής, εάν υπάρχει. Στις περιπτώσεις αυτές, η Εταιρεία δεν θα μοιραστεί τα\nστοιχεία με τρίτα μέρη, εκτός από εκείνα που η Εταιρεία χρησιμοποιεί για την εκτέλεση εργασιών\n(όπως εκπλήρωση παραγγελίας και επεξεργασία πληρωμής), απαραίτητα για την ολοκλήρωση\nαγορών που πραγματοποιεί το υποκείμενο των δεδομένων και συνδρομών που αιτείται μέσω του\n"),_c('a',{attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v("https://www.puretechglobal.com/")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τρίτος, εκτελών την επεξεργασία για λογαριασμό της Εταιρείας, π.χ. ένας εργολάβος ή πάροχος\nυπηρεσιών, πρέπει να συμφωνήσει συμβατικά για την επεξεργασία προσωπικών δεδομένων\nσύμφωνα με την παρούσα πολιτική. Οι όροι αυτής της πολιτικής συμπεριλαμβάνονται στις σχετικές\nσυμβάσεις.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δεδομένα προσωπικού χαρακτήρα αποκαλύπτονται σε τρίτους μόνον εφόσον είναι απαραίτητο\nή εφόσον το υποκείμενο χορηγήσει τη ρητή συγκατάθεσή του. Τα δεδομένα προσωπικού\nχαρακτήρα πρέπει να παρέχονται ανωνύμως, εφόσον κρίνεται σκόπιμο.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί επίσης, να κάνει χρήση των προσωπικών δεδομένων στο σύνολό τους, ανώνυμα,\nγια ερευνητικούς σκοπούς.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επίσης, μια συνεργαζόμενη εταιρεία μπορεί να προσφέρει λήψεις δεδομένων και αρχείων στα\nυποκείμενα για λογαριασμό της Εταιρείας, συλλέγοντας προσωπικά δεδομένα εκ μέρους της\nΕταιρείας, όταν τα υποκείμενα πραγματοποιούν εγγραφή στην τοποθεσία gr.funplus.world/264p2\nή συνδέονται για μεμονωμένες λήψεις αρχείων και υπηρεσιών μέσω του κινητού τηλεφώνου τους.\nΗ συνεργαζόμενη εταιρεία παρέχει σε εμάς τα προσωπικά δεδομένα που χρειάζεται για να σας\nπροσφέρει λήψεις πληροφοριών και αρχείων της εταιρείας και άλλες υπηρεσίες που έχετε αιτηθεί.\nΗ συνεργάτης εταιρεία της ΕΤΑΙΡΕΙΑΣ παρέχει επίσης στον πάροχο κινητής τηλεφωνίας σας τις\nπληροφορίες που χρειάζεται για να σας χρεώσει για τις λήψεις πληροφοριών και αρχείων και για\nάλλες υπηρεσίες που αγοράσατε.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί να μοιραστεί τα προσωπικά δεδομένα σας με εταιρείες που σχετίζονται και\nσυνεργάζονται μαζί της ή αποτελούν μέρος του Ομίλου της Εταιρείας για την επίτευξη του σκοπού\nτης επεξεργασίας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κάθε υπάλληλος της Εταιρείας εκπαιδεύεται σε θέματα προστασίας δεδομένων και ασφάλειας\nδεδομένων. Οι υπάλληλοι, αντιπρόσωποι και συνεργάτες της Εταιρείας πρέπει να έχουν ένα νόμιμο\nλόγο για την απόκτηση πρόσβασης στα προσωπικά δεδομένα σας. Η Εταιρεία ενδέχεται να\nμοιραστεί τα προσωπικά δεδομένα σας με εξωτερικούς συνεργάτες ή αντιπροσώπους που την\nβοηθούν να διαχειριστεί τις πληροφοριακές δραστηριότητές της (π.χ. διαχείριση κλήρωσης λαχνών,\nεκπλήρωση παραγγελιών, στατιστικές αναλύσεις) αλλά μπορούν να χρησιμοποιήσουν τα\nπροσωπικά δεδομένα σας μόνο για να παρέχουν στην Εταιρεία συγκεκριμένη υπηρεσία και όχι για\nοποιονδήποτε άλλο σκοπό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί να συμβληθεί με τρίτες εταιρείες που κατέχουν την τεχνολογία που επιτρέπει\nστην Εταιρεία να προσαρμόσει τα διαφημιστικά και μάρκετινγκ μηνύματα που λαμβάνετε στις\nτοποθεσίες της Εταιρείας στο διαδίκτυο. Τα μη προσωπικά δεδομένα σας και το ιστορικό\nπεριήγησης στο διαδίκτυο σχετικά με τις δραστηριότητές σας στις τοποθεσίες αυτές μπορεί να\nμοιράζονται με αυτές τις εταιρείες, έτσι ώστε αυτή η προσαρμογή να μπορεί να επιτευχθεί. Αυτές\nοι εταιρείες δεν θα μοιραστούν τις πληροφορίες σας με οποιοδήποτε τρίτο μέρος, ούτε θα τις\nχρησιμοποιήσουν για οποιονδήποτε άλλο σκοπό. Ενδέχεται όμως να γίνει χρήση, ανώνυμα, του \nιστορικού περιήγησης και άλλων δημογραφικών πληροφοριών αποκλειστικά για διαφημιστικούςστατιστικούς σκοπούς από την Εταιρεία ή τους επιχειρηματικούς συνεργάτες της. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. ΔΙΑΣΥΝΟΡΙΑΚΗ ΑΠΟΚΑΛΥΨΗ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δεδομένα προσωπικού χαρακτήρα αποκαλύπτονται στο εξωτερικό μόνο εάν ο αλλοδαπός νόμος\nπροβλέπει επαρκές επίπεδο προστασίας των δεδομένων. Σε περίπτωση που ο αλλοδαπός νόμος\nδεν παρέχει επαρκές επίπεδο προστασίας δεδομένων, τα δεδομένα προσωπικού χαρακτήρα\nμπορούν να μεταφερθούν σε αυτή τη χώρα μόνον εάν το πρόσωπο στο οποίο αναφέρονται τα\nδεδομένα έχει συναινέσει ρητά στη μεταφορά ή εάν η προστασία δεδομένων προβλέπεται από την\nκατάλληλη συμφωνία περί μεταφοράς δεδομένων.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. ΑΠΟΚΑΛΥΨΗ ΤΩΝ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορεί να υπάρχουν περιπτώσεις που η Εταιρεία θα αποκαλύψει προσωπικά δεδομένα χωρίς να\nσας προσφέρει επιλογή, ώστε να προστατεύσει τα νόμιμα δικαιώματά της, άλλων εταιρειών εντός\nτου Ομίλου της Εταιρείας ή των υπαλλήλων, αντιπροσώπων και συνεργατών της, για προστασία\nτης ασφάλειας των επισκεπτών του ιστότοπού της, για προστασία έναντι απάτης ή για λόγους\nδιαχείρισης κινδύνου, δημόσιας τάξης και ασφάλειας, εθνικού συμφέροντος ή για συμμόρφωση με\nτις διατάξεις της νομοθεσίας ή τις νόμιμες διαδικασίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. ΜΕΤΑΒΙΒΑΣΗ ΕΤΑΙΡΕΙΑΣ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην περίπτωση που η Εταιρεία πωλήσει μέρος ή όλη την επιχείρησή της ή πραγματοποιήσει μια\nπώληση ή μεταφορά περιουσιακών στοιχείων ή εμπλακεί γενικότερα σε μια συγχώνευση ή\nμεταφορά επιχείρησης, η Εταιρεία μπορεί να μεταφέρει τα προσωπικά δεδομένα σας σε ένα τρίτο\nμέρος ως τμήμα αυτής της συναλλαγής. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. ΑΠΟΘΗΚΕΥΣΗ ΚΑΙ ΔΙΑΤΗΡΗΣΗ ΔΕΔΟΜΕΝΩΝ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δεδομένα προσωπικού χαρακτήρα αποθηκεύονται για όσο χρόνο απαιτείται για την εκπλήρωση\nτου σκοπού για τον οποίο συλλέχθηκαν και για όσο χρόνο απαιτείται από το νόμο. Τα στοιχεία της\nαποθήκευσης δεδομένων και των περιόδων διατήρησης καθορίζονται στην Πολιτική Διατήρησης\nΔεδομένων της Εταιρείας.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. ΑΣΦΑΛΕΙΑ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία λαμβάνει όλα τα ενδεικνυόμενα από την σύγχρονη τεχνολογία, οργανωτικά και φυσικά\nμέτρα για την διαφύλαξη των προσωπικών δεδομένων που βρίσκονται στην κατοχή της έναντι\nαπώλειας, κλοπής και μη εξουσιοδοτημένης χρήσης, αποκάλυψης ή τροποποίησης με στόχο την\nεξασφάλιση της ακεραιότητας, της εμπιστευτικότητας και της διαθεσιμότητάς τους. Επιπλέον, η\nΕταιρεία χρησιμοποιεί εύλογες μεθόδους για να βεβαιωθεί πως τα προσωπικά δεδομένα είναι\nακριβή, ενημερωμένα και κατάλληλα συμπληρωμένα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. ΔΙΚΑΙΩΜΑΤΑ ΤΩΝ ΥΠΟΚΕΙΜΕΝΩΝ ΤΩΝ ΔΕΔΟΜΕΝΩΝ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κάθε υποκείμενο δεδομένων έχει τα ακόλουθα δικαιώματα σύμφωνα με το ΓΚΠΔ τα οποία η\nεταιρεία σέβεται και προστατεύει: ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("α) Το δικαίωμα ενημέρωσης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("β) Το δικαίωμα πρόσβασης")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("γ) Το δικαίωμα διόρθωσης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("δ) Το δικαίωμα διαγραφής,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ε) Το δικαίωμα περιορισμού της επεξεργασίας,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("στ) Το δικαίωμα στη φορητότητα δεδομένων,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ζ) Το δικαίωμα αντίρρησης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("η) Δικαιώματα σχετικά με την αυτοματοποιημένη λήψη αποφάσεων και τη δημιουργία προφίλ.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Εάν ζητήσετε από την Εταιρεία να διακόψει την χρήση των προσωπικών δεδομένων σας, η Εταιρεία\nθα ικανοποιήσει αυτό το αίτημα, διατηρώντας μόνο τις πληροφορίες που είναι απαραίτητες για τη\nσυμμόρφωση με την ισχύουσα εθνική νομοθεσία.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορείτε να επικοινωνήσετε με την Εταιρεία για να ασκήσετε τα δικαιώματά σας και η Εταιρεία\nθα ανταποκριθεί σε εύλογο χρονικό διάστημα, όχι σε περισσότερο από 30 ημέρες.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. ΤΡΟΠΟΠΟΙΗΣΗ ΟΡΩΝ ΤΗΣ ΠΟΛΙΤΙΚΗΣ ΑΠΟΡΡΗΤΟΥ\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι παραπάνω όροι αποτελούν την πλήρη συμφωνία με την Εταιρεία, η οποία διατηρεί το δικαίωμα\nνα τροποποιεί ή να ανανεώνει ή να διαγράφει όλους τους όρους του παρόντος, χωρίς καμία\nπροειδοποίηση. Η τροποποίηση ή ανανέωση θα ισχύει από την στιγμή που θα ενημερωθεί σχετικά\nτο παρόν κείμενο για οποιαδήποτε αλλαγή. Επομένως, θα πρέπει να την εξετάζετε τακτικά ώστε να\nείστε ενήμεροι σχετικά με τις πλέον πρόσφατες πολιτικές και πρακτικές της Εταιρείας. Εάν η\nΕταιρεία αλλάξει ουσιωδώς τις πρακτικές της αναφορικά με τη συλλογή ή χρήση των προσωπικών\nδεδομένων σας, τα προσωπικά δεδομένα σας θα συνεχίσουν να διέπονται από την Πολιτική κάτω\nαπό την οποία έγινε η συλλογή τους, εκτός αν σας έχει παρασχεθεί σχετική ειδοποίηση και δεν\nπαρουσιάσατε καμία ένσταση έναντι της αλλαγής. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("14. ΤΡΟΠΟΙ ΕΠΙΚΟΙΝΩΝΙΑΣ ΓΙΑ ΤΗΝ ΕΠΙΛΥΣΗ ΘΕΜΑΤΩΝ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ\nΚΑΙ ΓΙΑ ΤΗΝ ΑΣΚΗΣΗ ΔΙΚΑΙΩΜΑΤΩΝ ΤΩΝ ΥΠΟΚΕΙΜΕΝΩΝ ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Για την άσκηση των δικαιωμάτων σας, όπως για την επίλυση θεμάτων απορρήτου, για θέματα\nσχετικά με τη συλλογή και επεξεργασία των προσωπικών δεδομένων σας από την Εταιρεία, για να\nαναθεωρήσετε, διορθώσετε ή διαγράψετε τα προσωπικά δεδομένα σας ή για να διακόψετε κάθε\nμελλοντική επικοινωνία μαζί μας μπορείτε να επικοινωνείτε με την εταιρεία μας στην ηλεκτρονική\nδιεύθυνση support@mobivas.gr ,με την εξυπηρέτηση πελατών τηλ. 2111881795 ή με επιστολή που\nαποστέλλετε στην έδρα της Εταιρείαςπου βρίσκονται στην Unit 2104, 21/F., Mongkok Commercial\nCentre, 16 Argyle Street,\nMongkok, Kowloon, Χόνγκ Κόνγκ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f04395a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashEnglish_vue__ = __webpack_require__(1926);
function injectStyle (ssrContext) {
  __webpack_require__(1925)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f04395a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. PRIVACY POLICY PURPOSE AND SCOPE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The company under corporate name "),_c('span',{staticClass:"redtext"},[_vm._v("Puretech Global Limited")]),_vm._v(", has its head offices in "),_c('span',{staticClass:"redtext"},[_vm._v("Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,Mongkok, Kowloon, Hong Kong ")]),_vm._v("Hereinafter referred to as “Company”.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The present Privacy Policy describes the means for the collection and processing of the personal data that the Company receives, via the internet or otherwise, and the Company’s privacy practices. The Company commits to protect and process the personal data in a lawful manner, in accordance with the General Data Protection Regulation (EU) 2016/679 (GDPR) and the laws implementing it.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company is addressed to adults. The Company does not collect personal data for any person, known to the Company to be aged under 18 years, without the prior verifiable consent of the holder of parental responsibility over the child, who has the right to be informed regarding the information provided by the minor and/or to request its erasure. If Company becomes aware that the person who is submitting his/her personal data is under 18 years old, the Company shall erase said data as soon as possible.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The present Privacy Policy is incorporated and is subject to the General Terms and Conditions, which can be found at the Company's website. The Company conducts its business activities via its website "),_c('a',{attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v(" https://www.puretechglobal.com/")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. DEFINITIONS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Personal data means any information relating to an individual – natural person. The data are deemed personal if the person concerned can be identified. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Profiling means the collection of data, which facilitates the evaluation of a person’s characteristics and, consequently, significant aspects of his/her personality. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Data subject is the natural person to whom the personal data relate to. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Data processing means any activity involving personal data, irrespective of the means and the procedure applied, e.g., collection, recording, use, revision, disclosure, organization, projection and destruction of personal data. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Transmission means the access to personal data, for example by allowing access, broadcast or publication.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Controller means the legal entity that determines the purpose, the scope and the procedure of the processing of personal data.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Processor means a natural person or legal entity, which processes personal data following the controller’s instructions. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. PROCESSING PURPOSE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Personal data is processed only for the purpose determined at the time of the collection or for the purpose provided by law. The information collected, i.e. the personal data, enable us to establish or improve our relationship with you and to personalize and constantly enhance your experience with our Company. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The processing of the personal data is conducted in a lawful manner and in good faith and the data collected or stored are necessary, in order to fulfil the processing purpose; the Company ensures that said processing is lawful and consistent with the purpose that the data was collected for.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. CATEGORIES OF COLLECTED DATA AND MEANS OF COLLECTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("WHICH PERSONAL DATA WE COLLECTN")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The types of personal data that may be collected include your full name, your email address, billing information or mobile telephone number and related data, as may be requested for time to time.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("We collect your personal data either because you provide them to us or via automated means. More specifically:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("A. INFORMATION PROVIDED BY YOU")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("We collect personal data from you when you submit information to us, on your own initiative and, more specifically, when you:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('ul',{staticClass:"mobitxt"},[_c('li',[_vm._v("subscribe to our website, in order to receive recreational content for mobile phones, for example star sign predictions, notification sounds, games, pictures, news etc")]),_vm._v(" "),_c('li',[_vm._v("use the Company’s download links, without subscribing to "),_c('a',{attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v(" https://www.puretechglobal.com/")]),_vm._v(" for example for individual downloads or subscription via SMS through your mobile phone, ")]),_vm._v(" "),_c('li',[_vm._v("participate in activities, such as sweepstakes, competitions, games, surveys, fora,")]),_vm._v(" "),_c('li',[_vm._v("express your views, ideas or suggestions to us or through our communications,")]),_vm._v(" "),_c('li',[_vm._v("the personal data are delivered to us by reliable third parties that we cooperate with, in order to fulfil the purpose that you submitted your personal data for, as well as through public databases.")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("B. INFORMATION COLLECTED VIA AUTOMATED MEANS - COOKIES")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies are information, which is automatically placed in a predetermined file in your computer each time you visit specific websites. Cookies contribute to uniquely identify your computer to the server. They allow us to collect information relating to the server, in order to help you browse the internet better and to evaluate our website and test its function. The Company uses cookies to identify how you browse the internet, to determine whether you have downloaded the activation software, which is required in order to access specific material in our websites, to determine the total number of visitors and to identify you when you use the Company’s website again. Information pertaining to your activities in our website and other non-personal data may also be used, in order to limit the online advertisements to those we believe meet your interests. Cookies may save your access code, in order to provide easy access to a website that you have previously used or may save your preferences, in order to redirect you to a website adjusted to said preferences.   ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies and other identifying means do not collect information that may be used to identify you automatically, unless you voluntarily submit such information, for example via a subscription request or by sending an email. In this event, the automated means will be used to deliver additional information regarding your use of the websites and/or the interactive emails, in order to render them more useful for you.    ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Most browsers are programmed to accept cookies. Nevertheless, you may adjust your browser’s settings to reject downloading them or to notify you each time you receive a cookie. Please be informed that some pages of our website may not function properly, if you reject cookies, and as a result you may not have access to specific applications.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Third party advertisements may appear in the Company’s website, which may also contain cookies; said cookies are determined by the advertiser or the advertised entity and the Company does not control them. Therefore, you should refer to the advertiser’s or the advertised entity’s privacy policy, in order to ascertain if they use cookies and how.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("We may use cookies and other similar means to associate your use of our website with personal data received by you or a by reliable third party, our associate. For example, if you have requested information in regard to future products or promotional activities of our Company, cookies and/or your browsing history in regard to your activities in our website, may allow us to limit the provided material to what we believe you may find interesting, based on your previous online activities and preferences. However, if the Company wishes to associate your personal data and cookies or information regarding your browsing history in the above manner, we will request your express consent. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Moreover, the technical department or other departments of our Company or our associates may automatically collect information regarding the visitors of the Company’s website for maintenance, improvement, security and other legitimately acceptable reasons. Such information may include the IP address of visitors, the browser type, the date, time and duration of the visit and specific pages that you have visited.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. COMPANY PRACTICES REGARDING PERSONAL DATA COLLECTION AND NOTICES TO THE SUBJECTS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company ensures that, when you provide personal data, you have been informed in regard to who collects the information, the means and the purpose of their collection, as well as the type of use of said information by the Company. When you provide your personal data, the Company will notify you about your options regarding their use, including any potential joint use of the data by the Company and third parties.   ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("This Privacy Policy describes the types of other companies that may wish to send you notifications about their products and services and, therefore, wish to share your personal data, under the condition that you have explicitly consented to the above.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("In the event that the subjects’ personal data are collected manually or by means not related to the internet, for example via a postal card or subscription form, a detailed notice is not possible and, in order for the Company to obtain the subjects’ express consent, the Company sends a brief notice, whereby it describes how the subjects may receive our entire Privacy Policy and other related information from us. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company’s website may contain a link to other companies’ websites. Some of these websites may have our Company’s logo, even if they are not operated by or depended on the Company. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company’s website may also have advertisements from other companies. The Company is not responsible for the practices of third parties or for the privacy policies of third parties or local advertising companies on the internet, where you may be redirected via a link that appears on the Company’s website. When redirected from the Company’s website via such link or by clicking on an advertisement, you should refer to the applicable privacy policy of the third party or the advertiser’s website to assess how they will handle any personal data collected from you. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company’s website may also be linked to websites operated by the Company’s affiliates, for example companies that are members of the Company’s Group. Although members of the Company Group abide by the rules of the Group, the subjects of the personal data should refer to the separate privacy policies and practices, which may differ in certain aspects from this Privacy Policy. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. USE/ PROCESSING OF PERSONAL DATA BY THE COMPANY AND TRANSFER TO THIRD PARTIES")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company will use the personal data that you provide according to this Privacy Policy and exclusively for the purposes that you provided them for and will not transfer them to any third parties that are not related or associated with it, unless you have provided your express consent.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If the Company receives personal data from a third party, such as a business partner, such information will be used by us in accordance with this Privacy Policy. \nThe Company may use the personal data that you provided during your registration, in order to send important information and notices regarding your account and the requested services. Furthermore, when the Company collects personal data from the subject itself, when the latter requested to receive files or services from the Company, the Company will process the request for assistance or service, including processing the completion of the order and the payment, if any. In these occasions, the Company will not share the data with third parties, with the exception of those that the Company uses to conduct its business (for example, the completion of the order and the payment processing), required to conclude purchases that are made by the subject and subscriptions that it has requested via "),_c('a',{staticClass:"redtext",attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v("https://www.puretechglobal.com/")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Any third party that undertakes the processing on behalf of the Company, for example a contractor or a service provider, is required to contractually agree to the processing of the personal data in accordance with this Privacy Policy. The terms of this Policy are included in the pertinent agreements.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The personal data are revealed to third parties only if necessary or if the subject expressly consents to it. The personal data should be provided anonymously, if deemed appropriate.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may, also, use all the personal data, in an anonymously, for research purposes.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Moreover, a Company ’s associate may offer the subjects downloads of data and files, by collecting personal data on behalf of the Company, when the subjects register at "),_c('span',{staticClass:"redtext"},[_vm._v("gr.funplus.world/264p2")]),_vm._v(" or log in for individual downloads of files and services via their mobile phone. The Company’s associate shares with the Company the personal data required, in order to offer you information and file downloads and other services you have requested. The Company’s associate also provides to your mobile phone operator the information required, in order to charge you for the information and file downloads and other services that you have purchased. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may share your personal data with companies that are associated or cooperating with it or belong to its Group of Companies, in order to fulfil the processing purpose.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("All Company’s employees are trained in personal data and data security issues. The employees, officers and associates of the Company should have legitimate reason, in order to access your personal data. The Company may share your personal data with outsource associates or agents, who assist us in managing our informational activities (for example managing sweepstakes’ tickets, completion of orders, statistical analyses), but can only use your personal data, in order to provide to the Company a specific service and not for any other purpose. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may enter into agreements with other companies that own the technology, which allows the Company to adjust the advertising and marketing messages you receive on the Company’s websites. Non-personal data and your browsing history data about your activities on these websites may be shared with these companies, in order to achieve this adjustment. These companies will not share your information with any third party nor use it for any other purpose. It is, nonetheless, possible for the browsing history and other demographic information to be used, anonymously, exclusively for advertising-statistical purposes by the Company or its business associates. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. CROSS-BOARDER PERSONAL DATA DISCLOSURE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The personal data are disclosed to a third country, only if the legislation of said country provides for sufficient protection of the data. If the legislation of the third country does not provide for sufficient protection of the data, the personal data may only be transferred to this country, if the subject has expressly consented to their transfer or if the data protection is provided for by an appropriate agreement regarding the transfer of data.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. PERSONAL DATA DISCLOSURE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may disclose personal data without offering you a choice, in order to protect its legitimate rights, the rights of other companies that belong to its Group of Companies or the rights of its employees, officers or associates, to safeguard the security of its website visitors, to be protected against fraud or for reasons relating to danger management, public order and security, public interest or in order to comply with the law or the legal procedures. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. COMPANY TRANSFER")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("In the event the Company transfers, in whole or in part, its business or sells or transfers assets or, in general, engages in a merger or transfer of its business, it may transfer your personal data to a third party as part of this transaction. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. DATA STORAGE AND RETENTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The personal data are stored for as long as it is required for the fulfilment of the purpose that they were collected for and for as long as it is required by law. The information relating to the storage of the personal data and the period of their retention are determined in the Data Retention Policy of the Company. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. SECURITY")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company takes all measures indicated by modern technology, organizational and physical, in order to safeguard the personal data in its possession against loss, theft and unauthorized use, disclosure or modification, so as to ensure their integrity, confidentiality and availability. Furthermore, the Company applies reasonable methods to ensure that the personal data are accurate, updated and properly completed. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. DATA SUBJECTS’ RIGHTS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("All data subjects have the following rights, pursuant to GDPR, which the Company respects and protects:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(a) right to be informed,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(b) right to access,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(c) right to rectification,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(d) right to erasure,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(e) right to restriction of processing,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(f) right to data portability,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(g) right to object,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(h) rights relating to the automated decision-making and profiling.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you request the Company to discontinue the use of your personal data, the Company shall satisfy your request and shall maintain only the information necessary to comply with the national legislation. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You may contact the Company, in order to exercise your rights, and the Company shall respond in a timely manner, not exceeding 30 days. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. AMENDMENT OF THE PRIVACY POLICY PROVISIONS ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The above provisions represent the entire agreement with the Company, which has the right to amend or update or remove all provisions herein, without any notice. The amendment or update will be effective upon relevant modification of this document. Therefore, you should regularly refer to this Policy, in order to be informed about the Company’s latest policies and practices. If the Company materially changes its practices in regard to the collection and use of your personal data, said data will continue to be subject to the Policy that was applicable during their collection, unless you have been accordingly notified and did not object to said change. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("14. MEANS OF COMMUNICATION FOR THE RESOLUTION OF PERSONAL DATA ISSUES AND THE EXERCISE OF THE SUBJECTS’ RIGHTS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("In order to exercise your rights, for example resolve a privacy issue, for issues relating to the collection and processing of your personal data by the Company, in order to revise, rectify or erase your personal data or to discontinue any future communication with us, you may contact the Company via the email address c.support@paydash.gr, by calling the customer service at 2111881788 or by sending a letter to the Company’s head offices at "),_c('span',{staticClass:"redtext"},[_vm._v("Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,\n                           Mongkok, Kowloon, Hong Kong")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.country_name_fplus == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('privacy-paydash-greek')],1):_c('span',[(_vm.lang_fplus == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_fplus == 'malay')?_c('span'):(_vm.lang_fplus == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_fplus == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_fplus == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_fplus == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):_c('span',[_c('privacy-english')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__(633);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_651c2de9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__(1934);
function injectStyle (ssrContext) {
  __webpack_require__(1929)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-651c2de9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_651c2de9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0603d5bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashEnglish_vue__ = __webpack_require__(1931);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0603d5bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Five Digit short code: "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ABOUT YOUR SUBSCRIPTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")]),_vm._v(" offers recreational services, consisting of downloading content for mobile phones, such as ringtones, pictures, games, news, star sign predictions and other material.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Upon valid subscription and payment, you may download certain files in compatible mobile phones and compatible devices via "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")]),_vm._v(" .")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The members of "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")]),_vm._v(" receive their personal link each week, which they may use to download different content, for example sounds, pictures, games etc.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS is a weekly subscription")]),_vm._v(".You will receive "),_c('span',{staticClass:"redtext"},[_vm._v("3")]),_vm._v(" chargeable messages (upon receipt), with a charge of 2,08€ each, per week, οr up to 12 chargeable messages (upon receipt), with a charge of 2,08€ each, per week  total charge of 6,24€ per week. "),_c('a',{attrs:{"href":"http://paydash.gr/pinakas-ypp/"}},[_vm._v(" Final SMS Price ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The weekly charge is received automatically via your mobile phone bill. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You should be aged 18 and over, in order to use one of the "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")]),_vm._v(" and have permission from the person that pays the mobile phone bill. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("COMMUNICATION ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Service "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")]),_vm._v(" in Greece is supported by PAYDASH Single Person PC via its 5 digit codes and technical connection.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("For any queries regarding your subscription, please contact the customer service at 2111881788 or contact us via the email address c.support@paydash.gr. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you wish to discontinue your subscription to this service, you may send a text message from your mobile phone with the word "),_c('span',{staticClass:"redtext"},[_vm._v("STOP FNP")]),_vm._v(" to the five-digit short code "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")]),_vm._v("  to which you were subscribed.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The text message that is sent by the subscriber to the 5digit code "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")]),_vm._v(", in order to discontinue the subscription, bears a standard charge, which may vary depending on the mobile phone operator. The confirmation regarding the termination of the subscription is sent to the subscriber, free of charge, via the code 54303")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c499c53_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashGreek_vue__ = __webpack_require__(1933);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c499c53_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("FUNPLUS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Πενταψήφιος Κωδικός: 54006/54124")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΣΧΕΤΙΚΑ ΜΕ ΤΗ ΣΥΝΔΡΟΜΗ ΣΑΣ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η FUNPLUS παρέχει ψυχαγωγικές υπηρεσίες που συνίστανται στην λήψη περιεχομένου για κινητά\nτηλέφωνα, όπως ήχoι ειδοποίησης, φωτογραφίες, παιχνίδια, ειδησεογραφικό υλικό, αστρολογικές\nπροβλέψεις και άλλα αντικείμενα.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μετά από έγκυρη εγγραφή και πληρωμή, μπορείτε να λάβετε ορισμένα αρχεία σε συμβατά κινητά\nτηλέφωνα και συμβατές συσκευές μέσω της FUNPLUS. \n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα μέλη της FUNPLUS λαμβάνουν τον προσωπικό τους σύνδεσμο κάθε εβδομάδα, με τον οποίο\nμπορούν να κάνουν λήψη διαφορετικού περιεχομένου, όπως ήχοι, φωτογραφίες, παιχνίδια και άλλα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το FUNPLUS .είναι μια εβδομαδιαία συνδρομή. Θα λαμβάνετε τρία (3) κατά την λήψη χρεώσιμα μηνύματα, αξίας 2,08€ έκαστο, εβδομαδιαίως, ή έως δώδεκα (12) κατά την λήψη χρεώσιμα μηνύματα αξίας 0,52€ έκαστο εβδομαδιαίως, συνολική χρέωση: 6,24€ ανά εβδομάδα. "),_c('a',{attrs:{"href":"https://mobivas.gr/table.html"}},[_vm._v(" Τελική Τιμή Μηνύματος ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το FUNPLUS είναι μια εβδομαδιαία συνδρομή. Θα λαμβάνετε τρία (3) κατά την λήψη χρεώσιμα\nμηνύματα, αξίας 2,08€ έκαστο, εβδομαδιαίως, ή έως δώδεκα (12) κατά την λήψη χρεώσιμα μηνύματα\nαξίας 0,52€ έκαστο εβδομαδιαίως, συνολική χρέωση: 6,24€ ανά εβδομάδα. Τελική Τιμή Μηνύματος\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η εβδομαδιαία χρέωση λαμβάνεται αυτόματα μέσω του λογαριασμού του τηλεφώνου σας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Για να χρησιμοποιήσετε μία από τις υπηρεσίες FUNPLUS, πρέπει να είστε 18 ετών και άνω και να έχετε\nτην άδεια του ατόμου που πληρώνει τον λογαριασμό του κινητού τηλεφώνου. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΠΙΚΟΙΝΩΝΙΑ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία FUNPLUS, στην Ελλάδα υποστηρίζεται από την MOBIVAS Μονοπρόσωπη ΙΚΕ μέσω των\n5ψηφίων κωδικών της και της τεχνικής υποδομής της.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Για όλες τις ερωτήσεις αναφορικά με τη συνδρομή σας, επικοινωνήστε με το τμήμα εξυπηρέτησης\nπελατών μας στο τηλ. 2111881795 ή επικοινωνήστε στην ηλεκτρονική διεύθυνση support@mobivas.gr")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Εάν επιθυμείτε να διακόψετε τη συνδρομή σας από αυτήν την υπηρεσία, στείλτε μήνυμα από το κινητό\nσας με την λέξη STOP FNP στον κωδικό πενταψήφιο αριθμό 54006/54124 όπου είχατε εγγραφεί")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το μήνυμα διαγραφής που αποστέλλει ο συνδρομητής στον πενταψήφιο κωδικό 54006/54124 έχει\nκόστος απλού τυπικού μηνύματος, που διαφοροποιείται ανά πάροχο κινητής τηλεφωνίας. Η\nεπιβεβαίωση διαγραφής αποστέλλεται στον συνδρομητή δωρεάν από τον κωδικό 54303")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('faq'))+"\n    \n  ")]),_vm._v(" "),(_vm.country_name_fplus == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('faq-paydash-greek')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e0b015_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(1937);
function injectStyle (ssrContext) {
  __webpack_require__(1936)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18e0b015"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e0b015_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b743233_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(1949);
function injectStyle (ssrContext) {
  __webpack_require__(1939)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b743233"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b743233_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e536320_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRPaydashGreek_vue__ = __webpack_require__(1942);
function injectStyle (ssrContext) {
  __webpack_require__(1941)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e536320_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Γενικοί Όροι και Προϋποθέσεις")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Τελευταία τροποποίηση: 20/11/2020")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. ΣΚΟΠΟΣ ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Puretech Global Limited (εφεξής καλούμενη χάριν συντομίας η «Εταιρεία»), έχει την επίσημη έδρα\nτης στο Χόνγκ Κονγκ ( Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Mongkok, Kowloon) όπου είναι εγγεγραμμένη στο Εμπορικό Επιμελητήριο με αριθμό 2291075 ,\nhttps://www.puretechglobal.com/ cs@puretechglobal.com")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι ακόλουθοι Όροι και Προϋποθέσεις διέπουν τη χρήση των Υπηρεσιών που παρέχει η Εταιρεία και\nαποτυπώνουν την πλήρη συμφωνία μεταξύ της Εταιρείας και του προσώπου που γίνεται συνδρομητής\nτων υπηρεσιών της Εταιρείας (εφεξής καλούμενου χάριν συντομίας ο «Τελικός Χρήστης» ή «Πελάτης»).\nΕπιπλέον όροι και προϋποθέσεις που έχουν αναρτηθεί στην ιστοσελίδα της Εταιρεία ρητώς\nενσωματώνονται στους παρόντες Όρους και Προϋποθέσεις δια του παρόντος (εφεξής καλούμενοι από\nκοινού χάριν συντομίας οι «Όροι»). ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία δύναται, κατά την απόλυτη διακριτική της ευχέρεια, να τροποποιήσει τους Όρους\nοποτεδήποτε, προκειμένου, επί παραδείγματι, να εναρμονιστούν με νομοθετικές αλλαγές ή αλλαγές\nσχετικές με τις υπηρεσίες της. Αυτές οι αλλαγές ή τροποποιήσεις τίθενται άμεσα σε ισχύ έναντι όλων\nτων Πελατών μετά την ανάρτηση των τροποποιημένων Όρων στην ιστοσελίδα της Εταιρεία. Εάν ο\nΤελικός Χρήστης διαφωνεί με τους τροποποιημένους Όρους, οφείλει να διακόψει τη χρήση των\nυπηρεσιών της Εταιρείας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις υπηρεσίες της Εταιρείας, ο Τελικός Χρήστης αποδέχεται τη συμμόρφωσή του με\nτους Όρους. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Υπηρεσίες")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι υπηρεσίες της Εταιρείας ενδεικτικά περιλαμβάνουν τις ψηφιακές και άλλες υπηρεσίες, τις οποίες η\nΕταιρεία προσφέρει διαδικτυακά μέσω του παρόχου υπηρεσίων κινητής τηλεφωνίας του Τελικού\nΧρήστη (εφεξής καλούμενου χάριν συντομίας ο «Πάροχος»), όπως, επί παραδείγματι, γραπτά\nμηνύματα, αρχεία ήχου και/ή εικόνας, παιχνίδια και/ή άλλες συναφείς υπηρεσίες (εφεξής καλούμενες\nχάριν συντομίας οι «Υπηρεσίες Περιεχομένου»). Οι ανωτέρω Υπηρεσίες Περιεχομένου προσφέρονται\nαπό το δίκτυο των Παρόχων μέσω Short Message Services (‘SMS’), General Packet Radio Services\n(‘GPRS’) και/ή Third Generation Services (‘3G’) ή οποιουδήποτε άλλου τρόπου. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην Ελλάδα η υπηρεσία FUNPLUS παρέχεται μέσω της τεχνικής υποδομής και των 5ψηφίων κωδικών\nτης MOBIVAS Μονοπρόσωπη ΙΚΕ, Λεωφόρος Κηφισίας 166Α, Μαρούσι, Αθήνα ΤΚ 15126 Τηλέφωνο\nΕξυπηρέτησης Πελατών: 2111881795 support@mobivas.gr")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διαρκώς αλλάζει και βελτιώνει τις Υπηρεσίες της. Κατά συνέπεια, ενδέχεται να προσθέσει ή\nνα αφαιρέσει λειτουργίες ή χαρακτηριστικά και να αναστείλει ή να διακόψει τελείως μία Υπηρεσία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Δικαιώματα και Υποχρεώσεις του Τελικού Χρήστη")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρήστης - σημαίνει ενήλικο άτομο, που χρησιμοποιεί την Υπηρεσία σύμφωνα με τους Όρους και\nΠροϋποθέσεις. Ατομα με περιορισμένη νομική ικανότητα μπορούν να χρησιμοποιούν την Υπηρεσία\nυπό τον όρο ότι ένας νόμιμος εκπρόσωπος αυτού του ατόμου συναινεί σε αυτήν τη χρήση και άτομα\nχωρίς νομική ικανότητα - υπό τον όρο ότι ο νόμιμος εκπρόσωπός τους ενεργεί για λογαριασμό τους.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στον Τελικό Χρήστη χορηγείται η άδεια να λαμβάνει, αποθηκεύει και να προβάλλει τις Υπηρεσίες\nΠεριεχομένου της Εταιρείας. Η ως άνω άδεια είναι προσωποπαγής, μη αποκλειστική, δεν δύναται να\nεκχωρηθεί και χορηγείται με αποκλειστικό σκοπό να διευκολύνει τον Τελικό Χρήστη κατά την χρήση και\nαπόλαυση των προνομίων των Υπηρεσιών, όπως αυτές παρέχονται από την Εταιρεία και κατά τρόπο\nπου επιτρέπουν οι Όροι.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κατά την χρήση των Υπηρεσιών, ο Τελικός Χρήστης ενδέχεται να λαμβάνει ανακοινώσεις υπηρεσιών,\nδιαχειριστικά μηνύματα και άλλες πληροφορίες και έχει το δικαίωμα να επιλέξει να εξαιρεθεί από\nαυτές τις επικοινωνίες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης οφείλει να συμμορφώνεται με τις πολιτικές της Εταιρείας σε σχέση με τις Υπηρεσίες\nκαι να τις χρησιμοποιεί κατά σύννομο τρόπο.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης οφείλει να απόσχει από οποιαδήποτε κακή χρήση των Υπηρεσιών, επί\nπαραδείγματι, να προσπαθεί να έχει πρόσβαση σε αυτές κατά τρόπο αντίθετο προς τις οδηγίες της\nΕταιρείας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Χρήση των Υπηρεσιών δεν παρέχει στον Τελικό Χρήστη την άδεια να αντιγράφει, αναπαράγει,\nτροποποιεί, να δημιουργεί παράγωγα έργα (όπως αυτά που προκύπτουν από μεταφράσεις,\nπροσαρμογές ή άλλες αλλαγές), να επικοινωνεί, να δημοσιεύει, να εκτελεί δημόσια, μεταβιβάζει,\nπωλεί, μισθώνει, διανέμει και, γενικά, να εμπορεύεται, ή να χρησιμοποιεί με οποιονδήποτε άλλο μη\nεξουσιοδοτημένο τρόπο τις Υπηρεσίες Περιεχομένου ή μέρος αυτών, εκτός εάν η Εταιρεία ρητώς\nσυναινεί σε αυτή τη χρήση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Χρεώσεις")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις Υπηρεσίες της Εταιρείας, ο Πελάτης αποδέχεται τις χρεώσεις της Εταιρείας, όπως\nαυτές αναφέρονται στην ιστοσελίδα της. Οι Χρεώσεις ενδέχεται να ποικίλλουν ανάλογα με τις\nπαρεχόμενες Υπηρεσίες, ήτοι (α) συνδρομή στις Υπηρεσίες Περιεχομένου, (β) δωρεάν μονάδες για\nλήψη αρχείων («Υπηρεσία Club») και (γ) μεμονωμένες παραγγελίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι Χρεώσεις για σταθερές συνδρομές θα τιμολογούνται μέσω του λογαριασμού του Παρόχου του\nΠελάτη. Οι Χρεώσεις για προπληρωμένες συνδρομές θα αφαιρούνται από το πιστωτικό υπόλοιπο του\nΠελάτη. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός χρήστης διά του παρόντος παραχωρεί ρητώς την άδειά του για χρέωση και δεσμεύεται για\nτην πλήρη αποπληρωμή των Χρεώσεων, συμφωνόντας για την άμεση εκτέλεση της Υπηρεσίας και τη\nλήψη ψηφιακού περιεχομένου πριν από το τέλος της περιόδου των 14 ημερών για υπαναχώρηση από\nτη συμφωνία, με συνέπεια την απώλεια του δικαιώματος αυτού")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Όλες οι Χρεώσεις καταβάλλονται εις το ακέραιο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα γραπτά μηνύματα που αποστέλλονται μέσω του πενταψήφιου κωδικού 54303 (PIN, μήνυμα\nκαλωσορίσματος, μηνιαία ενημέρωση, δεκαπενθήμερη ενημέρωση,επιβεβαίωση διαγραφής) είναι\nδωρεάν και ο Τελικός Χρήστης δεν δύναται να αποστείλει γραπτό μήνυμα στον ανωτέρω κωδικό. Η\nΕταιρεία καταγράφει τον αριθμό κινητού τηλεφώνου του Τελικού Χρήστη στο ηλεκτρονικό της\nσύστημα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διατηρεί το δικαίωμα να τροποποιεί μονομερώς τις Χρεώσεις της, οι οποίες ισχύουν μετά\nτην ανάρτησή τους στην ιστοσελίδα της https://www.puretechglobal.com/. Οι τροποποιήσεις των\nΧρεώσεων θα επικοινωνούνται στους υπάρχοντες Πελάτες μέσω γραπτού μηνύματος μία εβδομάδα\nπριν την τροποποίηση. Οι τροποποιημένες Χρεώσεις θα ισχύουν για τους νέους Πελάτες ή για Πελάτες\nπου είναι ήδη εγγεγραμμένοι τη στιγμή της τροποποίησης, εάν συνεχίζουν να χρησιμοποιούν τις\nΥπηρεσίες της Εταιρεία μετά την προαναφερθείσα ενημέρωση.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία FUNPLUS δεν σχετίζεται, χορηγείται, υποστηρίζεται ή είναι αντικείμενο διαχείρισης από\nκανένα από τα προϊόντα που παρουσιάζονται και καμμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα\nσημεία εξυπηρέτησης, τα λογότυπα (συμπεριλαμβανομένων, χωρίς περιορισμό, των εμπορικών\nονομάτων προϊόντων και εμπορικών εταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("H χρέωση της συνδρομητικής υπηρεσίας ανέρχεται σε 2,08 € ανά SMS (3SMS/εβδομάδα=12 SMS τον\nμήνα) ή 0,52€ ανά SMS (έως 12SMS/εβδομάδα=48 SMS τον μήνα) (συμπεριλαμβανομένου ΦΠΑ), που\nθα λαμβάνεται από τον 5ψήφιο κωδικό 54006 και 54124 αντίστοιχα . "),_c('a',{attrs:{"href":"https://mobivas.gr/table.html"}},[_vm._v(" Τελική Τιμή Μηνύματος ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Όλα τα γραπτά μηνύματα, που αποστέλλονται από τον Πελάτη, θα χρεώνονται σε αυτόν μέσω του\nΠαρόχου του, σύμφωνα με τις τυπικές χρεώσεις. Οι εν λόγω χρεώσεις ενδέχεται να διαφέρουν ανά\nΠάροχο.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός χρήστης διά του παρόντος παραχωρεί ρητώς την άδειά του για χρέωση και δεσμεύεται για\nτην πλήρη αποπληρωμή των Χρεώσεων., συμφωνόντας για την άμεση εκτέλεση της Υπηρεσίας και τη\nλήψη ψηφιακού περιεχομένου πριν από το τέλος της περιόδου των 14 ημερών για υπαναχώρηση από\nτη συμφωνία, με συνέπεια την απώλεια του δικαιώματος αυτου\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Εγγυήσεις και Δηλώσεις Αποποίησης")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία παρέχει τις Υπηρεσίες της χρησιμοποιώντας ένα εμπορικά εύλογο επίπεδο δεξιότητας και\nπροσοχής. Εντούτοις, η Εταιρεία δεν αναλαμβάνει συγκεκριμένες δεσμεύσεις σχετικά με τις Υπηρεσίες,\nόπως, επί παραδείγματι, σχετικά με το περιεχόμενο στις Υπηρεσίες, τις συγκεκριμένες λειτουργίες των\nΥπηρεσιών ή την αξιοπιστία, διαθεσιμότητα ή τη δυνατότητά τους να ικανοποιήσουν τις ανάγκες του\nΤελικού Χρήστη. Η Εταιρεία παρέχει τις Υπηρεσίες της “ως έχουν”.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επιπλέον, διευκρινίζεται ότι η πρόσβαση του Τελικού Χρήστη στις Υπηρεσίες ενδέχεται, ανά πάσα\nστιγμή, να διακοπεί ή να δυσχερανθεί εξ αιτίας παραγόντων, οι οποίοι εκφεύγουν του ελέγχου, που\nευλόγως αναμένεται να ασκεί η Εταιρεία, περιλαμβανομένων, ενδεικτικά, τεχνικών προβλημάτων στο\nδίκτυο του Παρόχου.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Ευθύνη")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία δεν ευθύνεται για τυχόν ζημίες που μπορεί να υποστεί ο Τελικός Χρήστης σε σχέση με τις")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Υπηρεσίες. Σε κάθε περίπτωση, για οποιαδήποτε απαίτηση σχετική με τους Όρους,\nσυμπεριλαμβανομένων τυχόν σιωπηρών εγγυήσεων, η συνολική ευθύνη της Εταιρεία περιορίζεται στο\nποσό που ο Τελικός Χρήστης κατέβαλε στην Εταιρεία για τις Υπηρεσίες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Περαιτέρω, ο Τελικός Χρήστης δεν δικαιούται να αξιώσει μείωση των Χρεώσεων ή επιστροφή\nχρημάτων για Χρεώσεις που έχουν ήδη καταβληθεί, σε περίπτωση διακοπής της χρήσης των\nΥπηρεσιών. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. Αποζημίωση")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης αναλαμβάνει την υποχρέωση να μην υποστεί βλάβη η Εταιρεία και να αποζημιώσει\nτην Εταιρεία και τους εκπροσώπους, εργαζομένους και συνεργάτες της για οποιαδήποτε απαίτηση,\nαγωγή ή διαδικασία που σχετίζεται με τη χρήση των Υπηρεσιών ή με παράβαση των Όρων,\nπεριλαμβανομένης οποιασδήποτε υποχρέωσης αποζημίωσης ή δαπάνης που πηγάζει από απαιτήσεις,\nβλάβη, ζημία, δικαστικές αποφάσεις, δικαστικά έξοδα και δικηγορικές αμοιβές. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. Καταγγελία")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης δύναται να διακόψει οποτεδήποτε τη χρήση των Υπηρεσιών.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία έχει δικαίωμα άμεσης καταγγελίας ή περιορισμού της πρόσβασης του Τελικού Χρήστη στις\nΥπηρεσίες, με ή χωρίς προηγούμενη ειδοποίηση, για οποιονδήποτε από τους ακόλουθους λόγους: (α)\nλόγω παράβασης των παρόντων Όρων, (β) κατόπιν σχετικού αιτήματος των δικαστικών ή άλλων\nκρατικών αρχών, (γ) λόγω διακοπής ή ουσιώδους τροποποίησης των Υπηρεσιών (ή μέρους αυτών), (δ)\nλόγω απρόβλεπτων τεχνικών θεμάτων ή προβλημάτων ή θεμάτων ασφαλείας, (ε) εξ αιτίας απατηλών ή\nπαρανόμων δραστηριοτήτων του Τελικού Χρήστη, (στ) λόγω μη καταβολής ή καθυστερήσεων στις\nκαταβολές των Χρεώσεων που οφείλονται από τον Τελικό Χρήστη σε σχέση με τις Υπηρεσίες, (ζ)\nκατόπιν σχετικού αιτήματος του Παρόχου του Τελικού Χρήστη.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η καταγγελία ή ο περιορισμός της πρόσβασης θα πραγματοποιείται κατά την απόλυτη διακριτική\nευχέρεια της Εταιρεία και η τελευταία δεν θα ευθύνεται έναντι του Τελικού Χρήστη ή οποιουδήποτε\nτρίτου για την καταγγελία ή τον περιορισμό πρόσβασης στις Υπηρεσίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μετά την καταγγελία, ο Τελικός Χρήστης δεν θα έχει πρόσβαση στις Υπηρεσίες, ανεξαρτήτως του εάν\nέχει καταβάλει τις σχετικές Χρεώσεις για αυτές τις Υπηρεσίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. Πνευματική Ιδιοκτησία ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δικαιώματα Πνευματικής Ιδιοκτησίας, όπως εμπορικά σήματα, εμπορικές επωνυμίες, δικαιώματα\nπνευματικής ιδιοκτησίας, δικαιώματα βάσης δεδομένων, κατοχυρωμένα σχέδια, διπλώματα\nευρεσιτεχνίας και οποιαδήποτε άλλα παρόμοια ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("δικαιώματα που προστατεύονται σε οποιαδήποτε χώρα, καθώς και εκκρεμείς αιτήσεις κατοχύρωσης,\nπου σχετίζονται με τις Υπηρεσίες της Εταιρεία και/ή την ιστοσελίδα της παραμένουν πάντα στην\nκυριότητα της Εταιρεία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η υπηρεσία δεν σχετίζεται, χορηγείται ή υποστηρίζεται από κανένα από τα προϊόντα που\nπαρουσιάζονται και καμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα σημεία εξυπηρέτησης, τα logos\n(συμπεριλαμβανομένων, χωρίς περιορισμό, των χαρακτηριστικών ονομάτων προϊόντων και εμπορικών\nεταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών και προστατεύονται από την αντίστοιχη\nνομοθεσία .")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. Επεξεργασία Δεδομένων")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία συλλέγει και χρησιμοποιεί συγκεκριμένα προσωπικά δεδομένα σχετικά με τον Τελικό\nΧρήστη για εμπορικούς σκοπούς. Η Εταιρεία θα χρησιμοποιεί τα δεδομένα αυτά, με τον τρόπο που\nπεριγράφεται στην Πολιτική Απορρήτου της, αντίγραφο της οποίας υπάρχει στην ιστοσελίδα της\nΕταιρεία, και σύμφωνα με την νομοθεσία περί προστασίας προσωπικών δεδομένων (Γενικός\nΚανονισμός για την Προστασία Δεδομένων (EE) 2016/679 (GDPR)).")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Σε σχέση με τη λειτουργία της Υπηρεσίας, η Εταιρεία διατηρεί στις βάσεις δεδομένων της τον αριθμό\nτου κινητού τηλεφώνου από το οποίο έχει ενεργοποιηθεί υπηρεσία , όπως απαιτείται από τις σχετικές\nνομοθετικές διατάξεις, ιδίως για μια περίοδο που επιτρέπει λαμβάνοντας υπόψη τα παράπονα που\nυποβλήθηκαν ή άλλες αξιώσεις σχετικά με την Υπηρεσία.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα στοιχεία των χρηστών θα υποβάλλονται σε επεξεργασία εντός του πεδίου εφαρμογής και για τον\nαναγκαίο σκοπό για την παροχή της Υπηρεσίας (επίσης με σκοπό την εξέταση καταγγελιών) και μετά\nτην ολοκλήρωση της Υπηρεσίας, τα δεδομένα των χρηστών θα αφαιρεθούν, εκτός εάν απαιτείται το\nαντίθετο .Η αποθήκευση ορισμένων δεδομένων για χρονικό διάστημα μεγαλύτερο από την παροχή της\nΥπηρεσίας προκύπτει από τις διατάξεις του νόμου. Η παροχή δεδομένων είναι εθελοντική και γίνεται\nμε τη συναίνεση του χρήστη . Οι χρήστες έχουν, μεταξύ άλλων, το δικαίωμα προβολής, διόρθωσης και\nεπίσης απαίτησης διαγραφής των προσωπικών τους δεδομένων. Ο Χρήστης μπορεί ζητήσει τη\nδιαγραφή ή διόρθωση των προσωπικών του δεδομένων\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις Υπηρεσίες της Εταιρείας, ο Τελικός Χρήστης συναινεί στην προαναφερθείσα\nεπεξεργασία, διατηρώντας το δικαίωμα να εναντιωθεί σε αυτή την επεξεργασία αποστέλλοντας\nμήνυμα ηλεκτρονικού ταχυδρομείου στη διεύθυνση support@mobivas.gr")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. Εκχώρηση")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης δεν δύναται να εκχωρήσει ή να μεταβιβάσει οποιοδήποτε από τα δικαιώματα ή τις\nυποχρεώσεις του, που πηγάζουν από τους Όρους. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία έχει δικαίωμα να εκχωρήσει, εν όλω ή εν μέρει, τα δικαιώματα ή τις υποχρεώσεις της, που\nπηγάζουν από τους Όρους χωρίς περιορισμό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. Διάφορα")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αυθυπαρξία εκάστου όρου. Εάν οποιαδήποτε διάταξη των Όρων κριθεί άκυρη ή μη εφαρμόσιμη, δεν\nθα επηρεάσει οποιαδήποτε άλλη διάταξη, και όλες οι λοιπές διατάξεις θα εξακολουθήσουν να ισχύουν\nκαι να παράγουν όλα τα αποτελέσματά τους.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ανοχή. Η ανοχή, καθυστέρηση ή επιείκεια εκ μέρους της MOBIVAS κατά την εφαρμογή οποιωνδήποτε\nδιατάξεων των Όρων δεν θα προκαλέσει ζημία ή θα επηρεάσει τα δικαιώματά της και τα δικαιώματα\nαποζημίωσης, ούτε οποιαδήποτε παραίτηση αναφορικά με κάποια παράβαση θα ερμηνευθεί ως\nπαραίτηση για επόμενη παράβαση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αγγλική Γλώσσα. Σε περίπτωση διάστασης μεταξύ του Αγγλικού και του Ελληνικού κειμένου των Όρων,\nθα υπερισχύει το Αγγλικό κείμενο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. Εφαρμοστέο Δίκαιο και Δικαιοδοσία ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι Όροι θα διέπονται από το Ελληνικό Δίκαιο και οποιαδήποτε διαφορά ανακύψει σχετικά με την\nερμηνεία και/ή την εφαρμογή και/ή την καταγγελία τους θα παραπέμπεται στα Δικαστήρια των\nΑθηνών, τα οποία θα αποφασίζουν επ’ αυτής έχοντας αποκλειστική αρμοδιότητα.\n\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2db94c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(1945);
function injectStyle (ssrContext) {
  __webpack_require__(1944)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2db94c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ENGLISH TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("General conditions")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Last modified: 13/08/2021")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Customer service is available on working days from 09:00 to 17:00\n            Contact: +421 313215999 or funplus."+_vm._s(_vm.countryCode)+"@silverlines.info\n          ")])]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Applicability")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            The terms and conditions below (General Terms and Conditions)\n            apply to the English version of the one-time paid service Funplus\n            Premium (Puretech Global Sdn Bhd and / or the Service) offered\n            online via the Internet from Puretech Global Sdn Bhd (hereinafter\n            referred to as Puretech Global Sdn Bhd). The end user requests the\n            Funplus service from Puretech Global Sdn Bhd.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. General")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Funplus provides the best sexy wallpapers and videos exclusively\n            for your mobile.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n            3. Confirmation / Registration\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            To access Funplus, the End User must enter their mobile phone\n            number and / or certain other data and / or information through a\n            promotional website (Landing Page) operated by Puretech Global Sdn\n            Bhd. Then the End User will receive an SMS on his mobile device,\n            with a Personal Identification Number (PIN code), or a so-called\n            offer message with information about the service. By entering the\n            received PIN code on the landing page and / or sending a\n            confirmation message and / or using the service, the End User\n            acknowledges and confirms that he has read the General Terms and\n            Conditions, is an authorized mobile phone account holder or has\n            the consent of the telephone account payer to use this service.\n            The end user will receive a confirmation SMS message about the\n            successful activation of the Funplus service, the method,\n            frequency and costs of downloading the Service, as well as the\n            exact details of the logout.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Costs and Fees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Funplus is ​​a paid service that costs 1 SMS x 99.00 CZK / week\n            The fee will be charged to a mobile phone bill or a prepaid mobile\n            number. The charging method is Premium MT SMS sent to the End User\n            based on his request for the Funplus service. This message will\n            include your Funplus login. Fees are collected according to\n            Mobile Network Operators. Fees are written off against the End\n            User's account by the Operator; in the case of a pre-subscription\n            SIM, the fees are deducted from the End User's credit. The End\n            User hereby expressly grants him or her the right to charge, and\n            undertakes to pay in full for the fees incurred as a result of\n            subscribing to and / or using the Funplus Service. If you are not\n            the person responsible for paying your mobile bill, please get\n            permission from your mobile payer before signing in and / or using\n            Funplus. By signing and / or participating in the Service,\n            Puretech Global Sdn Bhd assumes that the End User has obtained the\n            necessary permission, consent or approval from the mobile account\n            payer, guardian or parents. All SMS messages sent by the End User\n            will be charged by the End User's mobile operator at a standard\n            tariff. These rates may vary by operator. Please contact your GSM\n            operator for more information on charges.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Help And Support")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Intellectual Property")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            You may use the Service for your personal, non-commercial use. The\n            term Funplus and all other trademarks, service marks and / or\n            trade names used by Funplus on the Service from time to time\n            (Trademarks) are trademarks, service marks and / or trade names of\n            Puretech Global Sdn Bhd or one of its companies in the group or\n            its licensors, and these entities reserve all rights to the\n            Trademarks. In addition, other content of the Services, including,\n            but not limited to, Games, images, pictures, graphics,\n            photographs, animations, videos, music, sound and text belong to\n            Funplus or one of its companies and / or licensed groups, and are\n            protected by copyright and / or other intellectual property\n            rights. You acknowledge that, through your use of the Service, you\n            will not acquire any trademark rights or Content of the Service\n            other than as set forth in this Agreement. In particular, under no\n            circumstances may you copy any Content of the Service (including,\n            without limitation, trivia questions, answers, or games), or use\n            data mining, robots, screen scratches, or similar data collection\n            and extraction tools on the Service. Liability Use of Funplus and\n            / or the Funplus website is at the end user's own risk. The end\n            user must provide a compatible mobile phone, hardware, or other\n            devices and software, and ensure that they are operational and\n            suitable for Funplus services. Funplus cannot guarantee that\n            Funplus Services will meet end user requirements and that\n            downloading, receiving and / or viewing Funplus Services will be\n            uninterrupted or error free. If at any time the End User is unable\n            to use the Puretech Global Sdn Bhd service without interruption,\n            this in no way leads to a right to a reduction in the fees for\n            Funplus services, to any right to a refund of prepaid payments.\n            Any use of the Funplus Services is at the end user's discretion\n            and risk, and that for no, but not limited to, infection, or\n            contamination, or loss of data, or damage (s) to end-user hardware\n            and / or software resulting from access to the Website , or use of\n            the Funplus Services, or downloaded Funplus Services, including\n            the hardware and software required to connect to the Funplus\n            Services. It is the responsibility of end-users to take the\n            necessary measures to prevent possible damage to this species. In\n            the event that Funplus is ​​obliged for any reason to compensate\n            the end user for direct or consequential damages of any kind, such\n            compensation may in no case exceed the value of the invoice for\n            Funplus services paid by the end user for the alleged damages.\n            The content of the Website has been compiled with the greatest\n            care. However, Funplus cannot provide any guarantee as to the\n            nature, accuracy or content of this information. Funplus is ​​not\n            responsible for any errors, omissions, inaccuracies,\n            misunderstandings, delays, or illegible orders, or notices based\n            on the use of the Internet or the relevant information point.\n            Final Provisions Any disputes concerning the fulfillment of these\n            Business Conditions will be resolved by the competent general\n            courts. Puretech Global Sdn Bhd reserves the right to change these\n            terms from time to time. Changes will be announced to end users by\n            posting on the Funplus portal.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47805796_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__ = __webpack_require__(1948);
function injectStyle (ssrContext) {
  __webpack_require__(1947)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47805796_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ČESKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmínky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy změněno: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použitelnost")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou\n            verzi jednorázové placené služby Funplus Premium (Puretech Global\n            Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu\n            od společnosti Puretech Global Sdn Bhd (dále jen jako Puretech\n            Global Sdn Bhd). Koncový uživatel požaduje službu Funplus od\n            společnosti Puretech Global Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Obecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Funplus poskytuje nejlepší sexy tapety a videa výhradně pro váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrzení / registrace")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Aby koncový uživatel získal přístup k Funplus, musí zadat číslo\n            svého mobilního telefonu a / nebo určitá další data a / nebo\n            informace prostřednictvím propagační webové stránky (Landing Page)\n            provozované společností Puretech Global Sdn Bhd. Poté koncový\n            uživatel obdrží na své mobilní zařízení SMS , s osobním\n            identifikačním číslem (PIN kód) nebo takzvanou nabídkovou zprávou\n            s informacemi o službě. Koncový uživatel zadáním přijatého PIN\n            kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a /\n            nebo používáním služby potvrzuje a potvrzuje, že si přečetl\n            Všeobecné podmínky, je autorizovaným majitelem účtu mobilního\n            telefonu nebo má souhlas plátce telefonního účtu s využitím této\n            služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné\n            aktivaci služby Funplus, způsobu, frekvenci a nákladech na stažení\n            Služby a také přesné údaje o odhlášení.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Funplus je placená služba, která stojí 1 SMS x 99,00 CZK / týden\n            Poplatek bude účtován na účet za mobilní telefon nebo na\n            předplacené mobilní číslo. Způsob nabíjení je Premium MT SMS\n            zasílaná koncovému uživateli na základě jeho požadavku na službu\n            Funplus. Tato zpráva bude obsahovat vaše přihlášení do Funplus.\n            Poplatky se vybírají podle provozovatelů mobilních sítí. Poplatky\n            jsou odepsány na účet Koncového uživatele Provozovatelem; v\n            případě SIM s předplatným jsou poplatky odečteny z kreditu\n            Koncového uživatele. Koncový uživatel mu tímto výslovně uděluje\n            právo účtovat poplatky a zavazuje se zaplatit v plné výši poplatky\n            vzniklé v důsledku předplatného a / nebo používání služby Funplus.\n            Pokud nejste osobou odpovědnou za placení účtu za mobilní telefon,\n            před přihlášením a / nebo používáním Funplusu si vyžádejte\n            povolení od svého mobilního plátce. Podpisem a / nebo účastí ve\n            službě Puretech Global Sdn Bhd předpokládá, že koncový uživatel\n            získal potřebné povolení, souhlas nebo schválení od plátce\n            mobilního účtu, opatrovníka nebo rodičů. Všechny SMS zprávy\n            zasílané koncovým uživatelem budou mobilním operátorem koncového\n            uživatele účtovány za standardní tarif. Tyto sazby se mohou u\n            jednotlivých operátorů lišit. Další informace o poplatcích vám\n            poskytne váš GSM operátor.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00\n            Kontakt: +421 313215999 nebo funplus.cz@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševní vlastnictví")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu můžete používat pro osobní, nekomerční použití. Pojem\n            Funplus a všechny ostatní ochranné známky, servisní značky a /\n            nebo obchodní názvy používané Funplusem ve Službě čas od času\n            (ochranné známky) jsou ochranné známky, servisní značky a / nebo\n            obchodní názvy společnosti Puretech Global Sdn Bhd nebo jedné z\n            jejích společností v skupina nebo její poskytovatelé licencí a\n            tyto subjekty si vyhrazují veškerá práva k ochranným známkám.\n            Kromě toho další obsah Služeb, mimo jiné včetně her, obrázků,\n            obrázků, grafik, fotografií, animací, videí, hudby, zvuku a textu,\n            patří společnosti Funplus nebo jedné z jejích společností a / nebo\n            licencovaných skupin a jsou chráněny autorským právem a / nebo\n            jinými právy duševního vlastnictví. Berete na vědomí, že\n            používáním Služby nezískáte žádná práva na ochrannou známku ani\n            Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných\n            okolností nesmíte za žádných okolností kopírovat jakýkoli obsah\n            služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo\n            her), ani ve službě používat dolování dat, roboty, škrábance na\n            obrazovce nebo podobné nástroje pro sběr a extrakci dat.\n            Odpovědnost Použití Funplus a / nebo webové stránky Funplus je na\n            vlastní riziko koncového uživatele. Koncový uživatel musí\n            poskytnout kompatibilní mobilní telefon, hardware nebo jiná\n            zařízení a software a zajistit, aby byly funkční a vhodné pro\n            služby Funplus. Funplus nemůže zaručit, že služby Funplus budou\n            splňovat požadavky koncových uživatelů a že stahování, přijímání a\n            / nebo prohlížení služeb Funplus bude nepřerušované nebo bez chyb.\n            Pokud koncový uživatel kdykoli nemůže bez přerušení používat\n            službu Puretech Global Sdn Bhd, v žádném případě to nezakládá\n            právo na snížení poplatků za služby Funplus, na jakékoli právo na\n            vrácení předplacených plateb. Jakékoli použití služeb Funplus je\n            na uvážení a riziku koncového uživatele, a to za, nikoli však\n            výhradně, infekci nebo kontaminaci nebo ztrátu dat nebo poškození\n            hardwaru a / nebo softwaru koncového uživatele z přístupu na Web,\n            z používání Služeb Funplus nebo stažených Služeb Funplus, včetně\n            hardwaru a softwaru potřebného k připojení ke Službám Funplus. Je\n            odpovědností koncových uživatelů, aby přijali nezbytná opatření,\n            která zabrání možnému poškození tohoto druhu. V případě, že je\n            Funplus z jakéhokoli důvodu povinen nahradit koncovému uživateli\n            přímé nebo následné škody jakéhokoli druhu, nesmí taková náhrada v\n            žádném případě překročit hodnotu faktury za služby Funplus\n            zaplacené koncovým uživatelem za údajné škody . Obsah webových\n            stránek byl sestaven s největší péčí. Společnost Funplus však\n            nemůže poskytnout žádnou záruku, pokud jde o povahu, přesnost nebo\n            obsah těchto informací. Funplus neodpovídá za žádné chyby,\n            opomenutí, nepřesnosti, nedorozumění, zpoždění nebo nečitelné\n            objednávky nebo oznámení založená na používání internetu nebo\n            příslušného informačního bodu. Závěrečná ustanovení Veškeré spory\n            týkající se plnění těchto Obchodních podmínek budou řešit\n            příslušné obecné soudy. Puretech Global Sdn Bhd si vyhrazuje právo\n            čas od času tyto podmínky změnit. Změny budou koncovým uživatelům\n            oznámeny zveřejněním na portálu Funplus.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("terms"))+"\n  ")]),_vm._v(" "),(_vm.lang_fplus == 'greek')?_c('span',[_c('terms-paydash-greek')],1):_vm._e(),_vm._v(" "),(_vm.countryCode == 'cz')?_c('span',[(_vm.lang_fplus == 'czech')?_c('terms-czech'):_c('terms-english')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Application.38f2fdc.jpg";

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Game.59bcd11.jpg";

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Music.d470ef0.jpg";

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Video.b89c4e0.jpg";

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wallpaper.e1a9ce6.jpg";

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy Recipe.a9fdf92.jpg";

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy-Recipe.a5c0378.jpg";

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(640);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e5b2f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1966);
function injectStyle (ssrContext) {
  __webpack_require__(1958)
  __webpack_require__(1959)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48e5b2f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e5b2f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a09fbce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1962);
function injectStyle (ssrContext) {
  __webpack_require__(1961)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a09fbce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a09fbce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index))])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(642);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561e4f51_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1965);
function injectStyle (ssrContext) {
  __webpack_require__(1964)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-561e4f51"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561e4f51_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_fplus),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_fplus)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.auth_fplus === 'loggedin' || _vm.auth_fplus === 'guest'
            ? '/home'
            : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(1967)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.auth_fplus === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_fplus === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[(_vm.country_fplus != 'iq')?_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.auth_fplus === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(605)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_fplus)}})])])]),_vm._v(" "),(_vm.auth_fplus === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{
                      name: 'Category',
                      params: { category: cat.route + '-' + cat.category_id },
                    }}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_fplus)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpick")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_c('span',[_vm._v(_vm._s(_vm.$t("popular")))])])],1)]):_vm._e(),_vm._v(" "),(_vm.auth_fplus === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.is_unsub_fplus != '0')?_c('div',[(
                  _vm.gcid_fplus == '208' ||
                  _vm.gcid_fplus == '225' ||
                  _vm.gcid_fplus == '226' ||
                  _vm.gcid_fplus == '278'
                )?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                  "+_vm._s(_vm.$t("unsubscribe"))+"\n                ")])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_fplus(_vm.is_unsub_fplus)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_c('div',[(
                  _vm.country_name_fplus != 'greece' && _vm.gateway_code != 'paydash'
                )?_c('span',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_fplus(_vm.is_unsub_fplus)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[(_vm.country_name_fplus === 'greece' && _vm.gateway_code === 'paydash')?_c('span',[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-bell icon"}),_vm._v("\n              "+_vm._s(_vm.$t("t&c"))+"\n            ")])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/contact"}},[_c('span',{staticClass:"flaticon-phone icon"}),_vm._v("\n              "+_vm._s(_vm.$t("contact_us"))+"\n            ")])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/faq"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v("\n              "+_vm._s(_vm.$t("faq"))+"\n            ")])],1)]):_c('span',[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),(_vm.country_fplus == 'cz')?_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-bell icon"}),_vm._v("\n              "+_vm._s(_vm.$t("terms"))+"\n            ")])],1):_vm._e()])])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/funplus-logo.0cd3908.png";

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(643);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f848085_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(1970);
function injectStyle (ssrContext) {
  __webpack_require__(1969)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f848085"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f848085_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_fplus(_vm.is_unsub_fplus)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"funplus",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_funplus",attrs:{"id":"appBg1"}},[_c('div',{staticClass:"funMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameBox_vue__ = __webpack_require__(644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78075b6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameBox_vue__ = __webpack_require__(2038);
function injectStyle (ssrContext) {
  __webpack_require__(1973)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78075b6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78075b6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(645);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21541fc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1979);
function injectStyle (ssrContext) {
  __webpack_require__(1975)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21541fc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21541fc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameBoxSlider_vue__ = __webpack_require__(646);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d46a6182_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameBoxSlider_vue__ = __webpack_require__(1978);
function injectStyle (ssrContext) {
  __webpack_require__(1977)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d46a6182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameBoxSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d46a6182_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameBoxSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d2-slider"},[(_vm.sliderCategory == 'Video')?_c('div',{ref:"videoSlider",staticClass:"row"},_vm._l((_vm.sliderData),function(data){return _c('div',{key:data.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 d2-videoItem"},[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(data.content_id)}}},[_c('div',{staticClass:"d2-videoItem__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.cover_img,"alt":""}})]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"d2-videoItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h3',{staticClass:"d2-h3"},[_vm._v("\n              "+_vm._s(data[("cont_name_" + _vm.lang_gamebox)])+"\n            ")]):_c('h3',{staticClass:"d2-h3"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]):_c('span',[_c('h3',{staticClass:"d2-h3"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]),_vm._v(" "),_c('div')])])])}),0):(_vm.sliderCategory == 'Wallpaper')?_c('div',{ref:"wallpaperSlider",staticClass:"row"},_vm._l((_vm.sliderData),function(data){return _c('div',{key:data.key,staticClass:"col-4 col-md-2 col-lg-2 col-sm-3 col-2 d2-appItem"},[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(data.content_id)}}},[_c('div',{staticClass:"d2-appItem__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d2-appItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(_vm.sliderData[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h4',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(_vm.sliderData[("cont_name_" + _vm.lang_gamebox)])+"\n            ")]):_c('h4',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(_vm.sliderData["cont_name_english"])+"\n            ")])]):_c('span',[_c('h4',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":15,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":2,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[
                23,
                2,
                14,
                17,
                0,
                19,
                10,
                34,
                7,
                50,
                23,
                43,
                38,
                50,
                36,
                34,
                46,
                19,
                31,
                17
              ],"rating":Number(data.rating)}})],1)])])])}),0):(_vm.sliderCategory == 'Game')?_c('div',{ref:"gameSlider",staticClass:"row"},_vm._l((_vm.sliderData),function(data){return _c('div',{key:data.key,staticClass:"col-6 col-md-3 col-lg-2 d2-appItem"},[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(data.content_id)}}},[_c('div',{staticClass:"d2-appItem__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d2-appItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h3',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data[("cont_name_" + _vm.lang_gamebox)])+"\n            ")]):_c('h3',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]):_c('span',[_c('h3',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":14,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":2,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[
                23,
                2,
                14,
                17,
                0,
                19,
                10,
                34,
                7,
                50,
                23,
                43,
                38,
                50,
                36,
                34,
                46,
                19,
                31,
                17
              ],"rating":Number(data.rating)}})],1)])])])}),0):_c('div',{ref:"applicationSlider",staticClass:"row"},_vm._l((_vm.sliderData),function(data){return _c('div',{key:data.key,staticClass:"col-6 col-md-3 col-lg-2 d2-appItem"},[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(data.content_id)}}},[_c('div',{staticClass:"d2-appItem__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d2-appItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h4',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data[("cont_name_" + _vm.lang_gamebox)])+"\n            ")]):_c('h4',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]):_c('span',[_c('h4',{staticClass:"d2-h4"},[_vm._v("\n              "+_vm._s(data["cont_name_english"])+"\n            ")])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":15,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":2,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[
                23,
                2,
                14,
                17,
                0,
                19,
                10,
                34,
                7,
                50,
                23,
                43,
                38,
                50,
                36,
                34,
                46,
                19,
                31,
                17
              ],"rating":Number(data.rating)}})],1)])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playBtn"},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"homeSlider",staticClass:"d2-mainSlider"},_vm._l((_vm.main_cover_gamebox),function(main){return _c('div',{key:main.key,staticClass:"d2-mainSlider__cell"},[_c('div',{staticClass:"d2-mainSlider__content boxed"},[(_vm.lang_gamebox !== 'english')?_c('span',[(main[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h1',{staticClass:"d2-h1"},[_vm._v(_vm._s(main[("cont_name_" + _vm.lang_gamebox)]))]):_c('h1',{staticClass:"d2-h1"},[_vm._v(_vm._s(main["cont_name_english"]))])]):_c('span',[_c('h1',{staticClass:"d2-h1"},[_vm._v(_vm._s(main["cont_name_english"]))])]),_vm._v(" "),_c('div',{staticClass:"d2-rating"},[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":2,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[
                23,
                2,
                14,
                17,
                0,
                19,
                10,
                34,
                7,
                50,
                23,
                43,
                38,
                50,
                36,
                34,
                46,
                19,
                31,
                17
              ],"rating":Number(main.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"d2-btnContainer"},[_c('button',{staticClass:"d2-button md ",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(main.id)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('play')))])])])]),_vm._v(" "),_c('div',{staticClass:"d2-mainSlider__bg",style:({ 'background-image': 'url(' + main.cover_img + ')' })})])}),0),_vm._v(" "),(_vm.$props.main.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',{staticClass:"boxed"},_vm._l((_vm.$props.main.subcategory),function(hot,index){return _c('div',{key:index,staticClass:"d2-sliderRow"},[_c('div',{staticClass:"sliderRow__header"},[_c('h2',{staticClass:"d2-h2"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular"))+" - \n              "),(_vm.lang_gamebox !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_gamebox)]))]):_vm._e(),_vm._v(" "),(_vm.lang_gamebox === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('router-link',{staticClass:"d2-link",attrs:{"to":{ path: 'popular', query: { q: hot.subcategory } }}},[_vm._v(_vm._s(_vm.$t("view_more")))])],1)]),_vm._v(" "),_c('div',{staticClass:"sliderRow__content"},[_c('gamebox-slider',{attrs:{"id":hot.subcategory,"slider_ref":'gameSlider'+index,"sliderData":_vm.$props.main.hotpicks[hot.subcategory],"sliderCategory":hot.category,"isLoaded":_vm.$props.main.isLoad}})],1)])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(647);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12097210_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1982);
function injectStyle (ssrContext) {
  __webpack_require__(1981)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12097210"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12097210_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap boxed"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h3',{staticClass:"d2-h3 "},[_vm._v(_vm._s(_vm.$t("hello"))+", Sarah McWilson!")])])])]),_vm._v(" "),_c('div',{staticClass:"d2-section "},[_c('div',{staticClass:"d2-section __content"},[_c('div',{staticClass:"d2-inputWrap"},[_c('label',{staticClass:"d2-label"},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(_vm.msisdn_gamebox))])]),_vm._v(" "),_c('div',{staticClass:"d2-inputWrap"},[_c('label',{staticClass:"d2-label"},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(_vm.subscription_date_gamebox))])]),_vm._v(" "),_c('div',{staticClass:"d2-inputWrap"},[_c('label',{staticClass:"d2-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(_vm.renew_date_gamebox))])]),_vm._v(" "),(_vm.auth_gamebox === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_gamebox != '0' && _vm.countryCode !== 'fi')?_c('div',[_c('a',{staticClass:"d2-button d2-button--alert",attrs:{"href":""},on:{"click":function($event){return _vm.logout_gamebox(_vm.is_unsub_gamebox)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):(_vm.countryCode === 'fi')?_c('div'):_c('div',[_c('a',{staticClass:"d2-button d2-button--alert",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_gamebox(_vm.is_unsub_gamebox)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(123)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(648);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b2786c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(1985);
function injectStyle (ssrContext) {
  __webpack_require__(1984)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7b2786c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b2786c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap boxed "},[_c('div',{staticClass:"d2-section"},[_c('div',{staticClass:"d2-section__header"},[_c('h2',{staticClass:"d2-h2"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_gamebox)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',{staticClass:"d2-section__content"},[_c('div',{staticClass:"itemCollection row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(hot.content_id)}}},[_c('div',{staticClass:"d2-videoItem__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"d2-videoItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h3',{staticClass:"d2-h4"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_gamebox)]))]):_c('h3',{staticClass:"d2-h4"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"d2-h4"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":14,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#FFCF00","inactive-color":"transparent","active-color":"#FFCF00","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])]):_c('div',[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(hot.content_id)}}},[_c('div',{staticClass:"d2-appItem__thumb"},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"htmlBadge"},[_c('img',{attrs:{"src":__webpack_require__(159)}})]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d2-appItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_gamebox)]))]):_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":14,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":3,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])])}),0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playBtn"},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(649);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61987a4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(1988);
function injectStyle (ssrContext) {
  __webpack_require__(1987)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61987a4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61987a4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap boxed "},[_c('div',{staticClass:"d2-section"},[_c('div',{staticClass:"d2-section__header"},[_c('h2',{staticClass:"d2-h2"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',{staticClass:"d2-section__content"},[_c('div',{staticClass:" itemCollection row"},_vm._l((_vm.pagePopular_gamebox),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-2 col-lg-2 col-sm-4 d2-appItem d2-appItem--noAnim"},[_c('a',{staticClass:"d2__inner app ",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(pop.content_id)}}},[_c('div',{staticClass:"d2-appItem__thumb"},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"htmlBadge"},[_c('img',{attrs:{"src":__webpack_require__(159)}})]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d2-appItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_gamebox)]))]):_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":14,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":3,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])])}),0)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4ad02c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(1991);
function injectStyle (ssrContext) {
  __webpack_require__(1990)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d4ad02c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4ad02c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contentWrap boxed"},[_c('div',{staticClass:"d2-section"},[_c('div',{staticClass:"d2-section__header"},[_c('h2',{staticClass:"d2-h2"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_gamebox)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"d2-section__content"},[_c('div',{staticClass:"row itemCollection"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-2 col-lg-2 col-sm-4 d2-appItem d2-appItem--noAnim"},[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(dat.content_id)}}},[_c('div',{staticClass:"d2-appItem__thumb"},[(dat.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"htmlBadge"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d2-appItem__info"},[(_vm.lang_gamebox !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_gamebox)]))]):_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":14,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":3,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23d5376_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(1996);
function injectStyle (ssrContext) {
  __webpack_require__(1993)
  __webpack_require__(1994)
  __webpack_require__(1995)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b23d5376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23d5376_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap boxed"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(
              _vm.details.content_type === 'application/x-zip-compressed' &&
              _vm.details.category === 'Game'
            )?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(159)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[(_vm.authentication_gonz == 'loggedin')?_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])]):_vm._e(),_vm._v(" "),(_vm.authentication_gonz == 'guest' || _vm.authentication_gonz == '')?_c('div',{staticClass:"dummyPlayer"},[_c('div',{staticClass:"playBtn",attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""},on:{"click":function($event){return _vm.subscribeContent_gonz([_vm.details.file_url, _vm.details.category])}}},[_c('span',{attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""}})]),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.cover_img,"alt":""}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v("\n        "+_vm._s(_vm.getLanguage(_vm.lang_gamebox))+"\n      ")]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19,
          31, 17 ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"d3-button",on:{"click":function($event){return _vm.subContent_gamebox([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"d3-button",on:{"click":function($event){return _vm.subContent_gamebox([
                  _vm.details.content_detail,
                  _vm.details.content_type,
                  _vm.id ])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"d3-button",on:{"click":function($event){return _vm.subContent_gamebox([
                  _vm.details.raw_file_url,
                  _vm.details.content_type,
                  _vm.id ])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3acd1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1999);
function injectStyle (ssrContext) {
  __webpack_require__(1998)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c3acd1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3acd1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap  boxed"},[_c('div',{staticClass:"d2-section"},[_c('div',{staticClass:"loginPanel"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h2',{staticClass:"d2-h2 "},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h4',{staticClass:"d2-h4"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"d2-inputWrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"d2-inputWrap d2-btnContainer"},[_c('button',{staticClass:"d2-button lg",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"d2-inputWrap",attrs:{"role":"alert"}},[(_vm.lang_gamebox === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_gamebox !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"d2-inputWrap d2-alert ",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bd2b762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2014);
function injectStyle (ssrContext) {
  __webpack_require__(2001)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bd2b762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bd2b762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEnglish_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65143ec5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEnglish_vue__ = __webpack_require__(2003);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65143ec5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h4',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Content provider: Puretech")]),_vm._v(" "),_c('h4',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Address: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("What personal information do we collect from the people that visit our blog, website or app?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number or other details to help you with your experience.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("When do we collect information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We collect information from you when you register on our site, fill out a form or enter information on our site. Provide us with feedback on our products or services.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How do we use your information? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.")]),_vm._v(" "),_c('li',[_vm._v("To improve our website in order to better serve you.")]),_vm._v(" "),_c('li',[_vm._v("To allow us to better service you in responding to your customer service requests.")]),_vm._v(" "),_c('li',[_vm._v("To administer a contest, promotion, survey or other site feature.")]),_vm._v(" "),_c('li',[_vm._v("To quickly process your transactions.")]),_vm._v(" "),_c('li',[_vm._v("To ask for ratings and reviews of services or products")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("How do we protect your information?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Do we use cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Keep track of advertisements.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-party disclosure")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Third-party links")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We do not include or offer third-party products or services on our website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Click here to view")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Does our site allow third-party behavioral tracking?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("It's also important to note that we allow third-party behavioral tracking")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyArabic_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38ef6c08_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyArabic_vue__ = __webpack_require__(2005);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyArabic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38ef6c08_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyArabic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("تم تجميع سياسة الخصوصية هذه لتقديم خدمة أفضل لأولئك الذين يهتمون بكيفية استخدام \"معلومات التعريف الشخصية\" (PII) الخاصة بهم عبر الإنترنت. يرجى قراءة سياسة الخصوصية الخاصة بنا بعناية للحصول على فهم واضح لكيفية جمعنا لمعلوماتك الشخصية أو استخدامها أو حمايتها أو التعامل معها بطريقة أخرى وفقًا لموقعنا الإلكتروني.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("ما المعلومات الشخصية التي نجمعها من الأشخاص الذين يزورون مدونتنا أو موقعنا الإلكتروني أو تطبيقنا؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("عند الطلب أو التسجيل على موقعنا، حسب الاقتضاء، قد يُطلب منك إدخال اسمك أو عنوان بريدك الإلكتروني أو عنوانك البريدي أو رقم هاتفك أو تفاصيل أخرى لمساعدتك في تجربتك")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("متى نجمع المعلومات؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نقوم بجمع المعلومات منك عندما تقوم بالتسجيل على موقعنا، أو ملء نموذج أو إدخال معلومات على موقعنا. قدم لنا ملاحظاتك حول منتجاتنا أو خدماتنا.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("كيف نستعمل معلوماتك؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("قد نستخدم المعلومات التي نجمعها منك عندما تقوم بالتسجيل أو إجراء عملية شراء أو الاشتراك في النشرة الإخبارية أو الرد على استطلاع أو اتصالات تسويقية أو تصفح الموقع أو استخدام بعض ميزات الموقع الأخرى بالطرق التالية:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("لتخصيص تجربتك والسماح لنا بتقديم نوع المحتوى وعروض المنتجات التي تهمك أكثر.")]),_vm._v(" "),_c('li',[_vm._v("تحسين موقعنا من أجل تقديم خدمة أفضل لك.")]),_vm._v(" "),_c('li',[_vm._v("للسماح لنا بخدمة أفضل في الاستجابة لطلبات خدمة العملاء الخاصة بك.")]),_vm._v(" "),_c('li',[_vm._v("لإدارة مسابقة أو ترقية أو مسح أو ميزة أخرى في الموقع.")]),_vm._v(" "),_c('li',[_vm._v("لمعالجة المعاملات الخاصة بك بسرعة.")]),_vm._v(" "),_c('li',[_vm._v("طلب تقييمات ومراجعات للخدمات أو المنتجات")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("كيف نحمي معلوماتك؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("يتم فحص موقعنا على الإنترنت بانتظام للثغرات الأمنية ونقاط الضعف المعروفة من أجل جعل زيارتك لموقعنا آمنة قدر الإمكان.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("هل نستخدم ملفات تعريف الارتباط؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("ملفات تعريف الارتباط هي ملفات صغيرة ينقلها الموقع أو موفر الخدمة الخاص به إلى محرك الأقراص الثابتة بجهاز الحاسوب الخاص بك من خلال متصفح الويب (إذا سمحت بذلك) والتي تمكن أنظمة الموقع أو مزود الخدمة من التعرف على متصفحك والتقاط وتذكر معلومات معينة. على سبيل المثال، نستخدم ملفات تعريف الارتباط لمساعدتنا على تذكر ومعالجة العناصر الموجودة في سلة التسوق الخاصة بك. يتم استخدامها أيضًا لمساعدتنا على فهم تفضيلاتك استنادًا إلى نشاط الموقع السابق أو الحالي، مما يمكننا من تزويدك بخدمات محسنة. نستخدم أيضًا ملفات تعريف الارتباط لمساعدتنا في تجميع البيانات المجمعة حول حركة مرور الموقع وتفاعل الموقع حتى نتمكن من تقديم تجارب وأدوات أفضل للموقع في المستقبل.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نستخدم ملفات تعريف الارتباط من أجل:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("فهم وحفظ تفضيلات المستخدم للزيارات المستقبلية.")]),_vm._v(" "),_c('li',[_vm._v("تتبع الإعلانات.")]),_vm._v(" "),_c('li',[_vm._v("تجميع البيانات المجمعة حول حركة مرور الموقع وتفاعلات الموقع من أجل تقديم تجارب وأدوات موقع أفضل في المستقبل. قد نستخدم أيضًا خدمات الجهات الخارجية الموثوق بها التي تتعقب هذه المعلومات نيابة عنا.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("يمكنك اختيار جعل جهاز الحاسوب الخاص بك يحذرك في كل مرة يتم فيها إرسال ملف تعريف ارتباط، أو يمكنك اختيار إيقاف تشغيل كافة ملفات تعريف الارتباط. يمكنك القيام بذلك من خلال إعدادات المتصفح الخاص بك. نظرًا لأن المتصفح مختلف قليلاً، فراجع قائمة تعليمات المتصفح لمعرفة الطريقة الصحيحة لتعديل ملفات تعريف الارتباط.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("إفشاء طرف ثالث")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نحن لا نبيع أو نتاجر أو ننقل معلوماتك الشخصية إلى أطراف خارجية ما لم نقدم إشعارًا مسبقًا للمستخدمين. لا يشمل هذا شركاء استضافة الموقع والأطراف الأخرى الذين يساعدوننا في تشغيل موقعنا، أو إجراء أعمالنا، أو خدمة مستخدمينا، طالما وافقت تلك الأطراف على الحفاظ على سرية هذه المعلومات. يجوز لنا أيضًا نشر المعلومات عندما يكون إصدارها مناسبًا للامتثال للقانون، أو فرض سياسات موقعنا، أو حماية حقوقنا أو حقوق الآخرين أو ممتلكاتنا")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("ومع ذلك، قد يتم توفير معلومات الزائر غير الشخصية لأطراف أخرى للتسويق أو الإعلان أو الاستخدامات الأخرى.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("روابط الطرف الثالث")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نحن لا ندرج أو نقدم منتجات أو خدمات طرف ثالث على موقعنا.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("جوجل")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("كن تلخيص متطلبات Google الإعلانية من خلال مبادئ الإعلان من Google. يتم وضعها لتوفير تجربة إيجابية للمستخدمين. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=ar"}},[_vm._v("انقر هنا لعرض")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("تستخدم Google، بصفتها مورِّدًا خارجيًا، ملفات تعريف الارتباط لعرض الإعلانات على موقعنا. يمكّن استخدام Google لملف تعريف الارتباط DART من عرض الإعلانات لمستخدمينا بناءً على الزيارات السابقة إلى موقعنا والمواقع الأخرى على الإنترنت. يمكن للمستخدمين إلغاء الاشتراك في استخدام ملف تعريف الارتباط DART عن طريق زيارة سياسة خصوصية إعلانات Google وشبكة المحتوى.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("قمنا بتنفيذ ما يلي:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("نحن، جنبًا إلى جنب مع موردي الجهات الخارجية مثل Google، نستخدم ملفات تعريف ارتباط الطرف الأول (مثل ملفات تعريف ارتباط Google Analytics) وملفات تعريف ارتباط الطرف الثالث (مثل ملف تعريف الارتباط DoubleClick) أو معرفات الجهات الخارجية الأخرى معًا لتجميع البيانات المتعلقة بتفاعلات المستخدم مع مرات ظهور الإعلان ووظائف خدمة الإعلان الأخرى من حيث صلتها بموقعنا على الويب.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("تعطيل الخدمة:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("يمكن للمستخدمين تعيين تفضيلات لكيفية إعلان Google لك باستخدام صفحة إعدادات إعلانات Google. بدلاً من ذلك، يمكنك إلغاء الاشتراك من خلال زيارة صفحة إلغاء الاشتراك في مبادرة الإعلانات على الشبكة أو باستخدام إضافة متصفح Google Analytics Opt Out.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("هل يسمح موقعنا بالتتبع السلوكي للجهات الخارجية؟")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("من المهم أيضًا ملاحظة أننا نسمح بالتتبع السلوكي لجهة خارجية")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyMalay_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56193a54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyMalay_vue__ = __webpack_require__(2007);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyMalay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56193a54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyMalay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Dasar privasi ini telah disusun untuk memberikan perkhidmatan yang lebih baik kepada  mereka yang lebih prihatin dengan bagaimana 'Maklumat Pengenalpastian Peribadi' (PII) mereka digunakan dalam talian. Sila baca dasar privasi kami dengan teliti untuk mendapatkan pemahaman yang jelas tentang bagaimana kami mengumpulkan, menggunakan, melindungi atau mengendalikan Maklumat Pengenalan Peribadi anda sesuai dengan laman web kami.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Apakah Maklumat Peribadi Yang Kami Kumpulkan Dari Orang Yang Melawat Blog, Laman Web atau Aplikasi Kami?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Semasa membuat pesanan atau mendaftar di laman web kami, jika sesuai, anda mungkin diminta untuk memasukkan nama, alamat e-mel, alamat surat, nombor telefon atau maklumat lain untuk membantu anda dengan pengalaman anda.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bila Kami Mengumpulkan Maklumat?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami mengumpulkan maklumat daripada anda semasa anda mendaftar di laman web kami, mengisi borang atau memasukkan maklumat di laman web kami. Beri kami maklum balas mengenai produk atau perkhidmatan kami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bagaimana Kami Menggunakan Maklumat Anda? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami mungkin menggunakan maklumat yang kami kumpulkan dari anda ketika anda mendaftar, melakukan pembelian, mendaftar ke laman web kami, balas tinjauan atau komunikasi pemasaran, melayari laman web, atau menggunakan ciri laman web tertentu dengan cara berikut:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Untuk memperibadikan pengalaman anda dan membolehkan kami menyampaikan jenis kandungan dan penawaran produk yang paling anda minati.")]),_vm._v(" "),_c('li',[_vm._v("Untuk memperbaiki laman web kami agar dapat melayani anda dengan lebih baik.")]),_vm._v(" "),_c('li',[_vm._v("Untuk membolehkan kami melayani anda dengan lebih baik dalam menjawab permintaan perkhidmatan pelanggan anda.")]),_vm._v(" "),_c('li',[_vm._v("Untuk menguruskan pertandingan, promosi, tinjauan atau ciri laman web lain.")]),_vm._v(" "),_c('li',[_vm._v("Untuk memproses transaksi anda dengan cepat.")]),_vm._v(" "),_c('li',[_vm._v("Untuk meminta penilaian dan ulasan perkhidmatan atau produk")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Bagaimana Kami Melindungi Maklumat Anda?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Laman web kami diimbas secara berkala untuk mencari lubang keselamatan dan kelemahan yang diketahui agar lawatan anda ke laman web kami selamat yang mungkin.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adakah Kami Menggunakan Cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Yes. Cookies  adalah fail kecil yang dipindahkan oleh laman web atau penyedia perkhidmatannya ke cakera keras komputer anda melalui penyemak imbas Web anda (jika anda membenarkan) yang membolehkan sistem penyedia perkhidmatan atau laman web mengenali penyemak imbas anda dan menangkap dan mengingat maklumat tertentu. Contohnya, kami menggunakan cookies untuk membantu kami mengingat dan memproses barang-barang di shopping cart anda. Mereka juga digunakan untuk membantu kami memahami pilihan anda berdasarkan aktiviti laman web sebelumnya atau semasa, yang membolehkan kami memberi anda perkhidmatan yang lebih baik. Kami juga menggunakan cookies untuk membantu kami mengumpulkan data mengenai lalu lintas laman web dan interaksi laman web agar kami dapat menawarkan pengalaman dan alat laman yang lebih baik di masa depan.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami menggunakan Cookies untuk:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Fahami dan simpan pilihan pengguna untuk lawatan akan datang.")]),_vm._v(" "),_c('li',[_vm._v("Jejaki iklan.")]),_vm._v(" "),_c('li',[_vm._v("Kumpulkan data mengenai lalu lintas laman web dan interaksi laman web untuk menawarkan pengalaman dan alat laman web yang lebih baik pada masa akan datang. Kami juga boleh menggunakan perkhidmatan pihak ketiga yang dipercayai yang mengesan maklumat ini bagi pihak kami.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Anda boleh memilih agar komputer memberi amaran kepada anda setiap kali cookies dihantar, atau anda boleh memilih untuk mematikan semua cookies. Anda melakukannya melalui tetapan penyemak imbas anda. Oleh kerana penyemak imbas sedikit berbeza, lihat Menu Bantuan penyemak imbas anda untuk mengetahui cara yang betul untuk mengubah kuki anda.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Pendedahan Pihak Ketiga")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami tidak menjual, memperdagangkan, atau memindahkan kepada pihak luar Maklumat Peribadi Anda kecuali kami memberikan notis awal kepada pengguna. Ini tidak termasuk rakan hosting laman web dan pihak lain yang membantu kami mengendalikan laman web kami, menjalankan perniagaan kami, atau melayani pengguna kami, selagi pihak tersebut bersetuju untuk merahsiakan maklumat ini. Kami juga dapat melepaskan maklumat apabila pelepasannya sesuai untuk mematuhi undang-undang, menegakkan dasar laman web kami, atau melindungi hak, harta milik kami atau orang lain")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Walau bagaimanapun, maklumat pelawat yang tidak dapat dikenal pasti dapat diberikan kepada pihak lain untuk pemasaran, pengiklanan, atau kegunaan lain.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Pautan Pihak Ketiga")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami tidak memasukkan atau menawarkan produk atau perkhidmatan pihak ketiga di laman web kami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Keperluan periklanan Google dapat disimpulkan oleh Prinsip Periklanan Google. Mereka disediakan untuk memberikan pengalaman positif bagi pengguna.  "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Klik disini untuk melihat")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, sebagai vendor pihak ketiga, menggunakan Cookies untuk menayangkan iklan di laman web kami. Penggunaan Cookies DART oleh Google membolehkannya menayangkan iklan kepada pengguna kami berdasarkan lawatan sebelumnya ke laman web kami dan laman web lain di Internet. Pengguna boleh memilih untuk tidak menggunakan Cookies DART dengan mengunjungi dasar privasi Rangkaian Iklan dan Kandungan Google.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kami Telah Melaksanakan Perkara Berikut:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Kami, bersama dengan vendor pihak ketiga seperti Google menggunakan Cookies pihak pertama (seperti Cookies Google Analytics) dan Cookies pihak ketiga (seperti Cookies DoubleClick) atau pengecam pihak ketiga yang lain untuk mengumpulkan data mengenai interaksi pengguna dengan tayangan iklan dan fungsi perkhidmatan iklan lain yang berkaitan dengan laman web kami.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Tidak ikut serta:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Pengguna dapat menetapkan pilihan bagaimana Google beriklan kepada Anda menggunakan halaman Pengaturan Iklan Google. Sebagai pilihan, anda boleh memilih untuk tidak ikut dengan mengunjungi halaman Pengiklanan Inisiatif Pengiklanan Rangkaian atau dengan menggunakan add-on Penyemak Imbas Google Analytics.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Adakah Laman web Kami Membolehkan Penjejakan Tingkah Laku Pihak Ketiga?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Penting juga untuk memaklumkan bahawa kami membenarkan penjejakan tingkah laku pihak ketiga.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyGreek_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd39eb1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyGreek_vue__ = __webpack_require__(2009);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyGreek_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd39eb1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αυτή η πολιτική απορρήτου έχει συνταχθεί για καλύτερη εξυπηρέτηση όσων ενδιαφέρονται για τον τρόπο με τον οποίο χρησιμοποιούνται οι «προσωπικές πληροφορίες που μπορούν να αναγνωριστούν» (PII) στο διαδίκτυο. Διαβάστε προσεκτικά την πολιτική απορρήτου μας για να λάβετε μια σαφή κατανόηση του τρόπου με τον οποίο συλλέγουμε, χρησιμοποιούμε, προστατεύουμε ή χειριζόμαστε με άλλο τρόπο τα προσωπικά σας στοιχεία σύμφωνα με τον ιστότοπό μας.")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Ποιες προσωπικές πληροφορίες συλλέγουμε από τα άτομα που επισκέπτονται το ιστολόγιο, τον ιστότοπο ή την εφαρμογή μας?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Κατά την παραγγελία ή την εγγραφή στον ιστότοπό μας, κατά περίπτωση, ενδέχεται να σας ζητηθεί να εισαγάγετε το όνομά σας, τη διεύθυνση email, τη διεύθυνση αλληλογραφίας, τον αριθμό τηλεφώνου ή άλλες λεπτομέρειες για να σας βοηθήσουμε με την εμπειρία σας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πότε συλλέγουμε πληροφορίες?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Συλλέγουμε πληροφορίες από εσάς όταν εγγραφείτε στον ιστότοπό μας, συμπληρώνουμε μια φόρμα ή εισάγουμε πληροφορίες στον ιστότοπό μας. Δώστε μας σχόλια για τα προϊόντα ή τις υπηρεσίες μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πώς χρησιμοποιούμε τις πληροφορίες σας? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ενδέχεται να χρησιμοποιήσουμε τις πληροφορίες που συλλέγουμε από εσάς όταν εγγραφείτε, πραγματοποιείτε αγορά, εγγραφείτε στο ενημερωτικό μας δελτίο, απαντάμε σε μια έρευνα ή επικοινωνία μάρκετινγκ, περιηγηθείτε στον ιστότοπο ή χρησιμοποιήστε ορισμένες άλλες δυνατότητες του ιστότοπου με τους ακόλουθους τρόπους:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Για να εξατομικεύσετε την εμπειρία σας και να μας επιτρέψετε να παρέχουμε τον τύπο περιεχομένου και προϊόντων που σας ενδιαφέρει περισσότερο.")]),_vm._v(" "),_c('li',[_vm._v("Να βελτιώσουμε τον ιστότοπό μας για να σας εξυπηρετήσουμε καλύτερα")]),_vm._v(" "),_c('li',[_vm._v("Για τη διαχείριση ενός διαγωνισμού, προώθησης, έρευνας ή άλλης δυναΓια να μας επιτρέψετε να σας εξυπηρετήσουμε καλύτερα ανταποκρινόμενοι στα αιτήματα εξυπηρέτησης πελατών σας.τότητας ιστότοπου.")]),_vm._v(" "),_c('li',[_vm._v("Για τη διαχείριση ενός διαγωνισμού, προώθησης, έρευνας ή άλλης δυνατότητας ιστότοπου.")]),_vm._v(" "),_c('li',[_vm._v("Για να επεξεργαστείτε γρήγορα τις συναλλαγές σας.")]),_vm._v(" "),_c('li',[_vm._v("Για να ζητήσετε βαθμολογίες και κριτικές υπηρεσιών ή προϊόντων")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πώς προστατεύουμε τις πληροφορίες σας?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ο ιστότοπός μας σαρώνεται σε τακτική βάση για τρύπες ασφαλείας και γνωστές ευπάθειες προκειμένου να κάνει την επίσκεψή σας στον ιστότοπό μας όσο το δυνατόν πιο ασφαλή.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Χρησιμοποιούμε Cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ναί. Τα cookie είναι μικρά αρχεία που ένας ιστότοπος ή ο πάροχος υπηρεσιών του μεταφέρει στον σκληρό δίσκο του υπολογιστή σας μέσω του προγράμματος περιήγησης στο Web (εάν το επιτρέπετε) που επιτρέπει στα συστήματα του παρόχου ιστότοπου ή του παρόχου υπηρεσιών να αναγνωρίζουν το πρόγραμμα περιήγησής σας και να συλλαμβάνουν και να θυμούνται ορισμένες πληροφορίες. Για παράδειγμα, χρησιμοποιούμε cookies για να μας βοηθήσουν να θυμηθούμε και να επεξεργαστούμε τα αντικείμενα στο καλάθι αγορών σας. Χρησιμοποιούνται επίσης για να μας βοηθήσουν να κατανοήσουμε τις προτιμήσεις σας βάσει προηγούμενης ή τρέχουσας δραστηριότητας ιστότοπου, η οποία μας επιτρέπει να σας παρέχουμε βελτιωμένες υπηρεσίες. Χρησιμοποιούμε επίσης cookie για να μας βοηθήσουν να συγκεντρώσουμε συγκεντρωτικά δεδομένα σχετικά με την επισκεψιμότητα του ιστότοπου και την αλληλεπίδραση του ιστότοπου, ώστε να μπορούμε να προσφέρουμε καλύτερες εμπειρίες και εργαλεία ιστότοπου στο μέλλον.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιούμε cookies για:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Κατανοήστε και αποθηκεύστε τις προτιμήσεις του χρήστη για μελλοντικές επισκέψεις.")]),_vm._v(" "),_c('li',[_vm._v("Παρακολουθήστε τις διαφημίσεις.")]),_vm._v(" "),_c('li',[_vm._v("Συγκεντρώστε συγκεντρωτικά δεδομένα σχετικά με την επισκεψιμότητα του ιστότοπου και τις αλληλεπιδράσεις ιστότοπων, προκειμένου να προσφέρετε καλύτερες εμπειρίες και εργαλεία ιστότοπου στο μέλλον. Μπορούμε επίσης να χρησιμοποιήσουμε αξιόπιστες υπηρεσίες τρίτων που παρακολουθούν αυτές τις πληροφορίες εκ μέρους μας.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορείτε να επιλέξετε να σας προειδοποιεί ο υπολογιστής σας κάθε φορά που αποστέλλεται ένα cookie ή μπορείτε να επιλέξετε να απενεργοποιήσετε όλα τα cookie. Αυτό το κάνετε μέσω των ρυθμίσεων του προγράμματος περιήγησής σας. Επειδή το πρόγραμμα περιήγησης είναι λίγο διαφορετικό, ανατρέξτε στο Μενού Βοήθειας του προγράμματος περιήγησής σας για να μάθετε τον σωστό τρόπο τροποποίησης των cookie σας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Γνωστοποίηση τρίτων")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Δεν πουλάμε, ανταλλάσσουμε ή με άλλο τρόπο μεταβιβάζουμε σε τρίτους τα προσωπικά σας στοιχεία, εκτός εάν παρέχουμε στους χρήστες προηγούμενη ειδοποίηση. Αυτό δεν περιλαμβάνει συνεργάτες φιλοξενίας ιστότοπων και άλλα μέρη που μας βοηθούν στη λειτουργία του ιστότοπού μας, στη διεξαγωγή της επιχείρησής μας ή στην εξυπηρέτηση των χρηστών μας, εφόσον αυτά τα μέρη συμφωνούν να διατηρήσουν αυτές τις πληροφορίες εμπιστευτικές. Μπορούμε επίσης να δημοσιεύσουμε πληροφορίες όταν είναι αποδεκτό ότι είναι κατάλληλο να συμμορφωθούμε με το νόμο, να επιβάλουμε τις πολιτικές του ιστότοπού μας ή να προστατεύσουμε τα δικαιώματα, την ιδιοκτησία μας ή άλλων")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ωστόσο, ενδέχεται να παρέχονται μη αναγνωρίσιμες πληροφορίες επισκεπτών σε άλλα μέρη για μάρκετινγκ, διαφήμιση ή άλλες χρήσεις.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Σύνδεσμοι τρίτων")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Δεν συμπεριλαμβάνουμε ούτε προσφέρουμε προϊόντα ή υπηρεσίες τρίτων στον ιστότοπό μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Οι απαιτήσεις διαφήμισης της Google μπορούν να συνοψιστούν στις Αρχές Διαφήμισης της Google. Έχουν δημιουργηθεί για να παρέχουν μια θετική εμπειρία στους χρήστες. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=el"}},[_vm._v("Κάντε κλικ εδώ για προβολή")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google, ως προμηθευτής τρίτου μέρους, χρησιμοποιεί cookies για την προβολή διαφημίσεων στον ιστότοπό μας. Η χρήση του cookie DART από την Google επιτρέπει την προβολή διαφημίσεων στους χρήστες μας με βάση προηγούμενες επισκέψεις στον ιστότοπό μας και σε άλλους ιστότοπους στο Διαδίκτυο. Οι χρήστες μπορούν να εξαιρεθούν από τη χρήση του cookie DART μεταβαίνοντας στην πολιτική απορρήτου του Google Ad και του Δικτύου περιεχομένου.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Έχουμε εφαρμόσει τα ακόλουθα:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Εμείς, μαζί με τρίτους προμηθευτές όπως η Google χρησιμοποιούν cookie πρώτου μέρους (όπως τα cookie του Google Analytics) και cookie τρίτου μέρους (όπως το cookie DoubleClick) ή άλλα αναγνωριστικά τρίτων για τη συλλογή δεδομένων σχετικά με τις αλληλεπιδράσεις χρηστών με εμφανίσεις διαφημίσεων και άλλες λειτουργίες υπηρεσιών διαφημίσεων που σχετίζονται με τον ιστότοπό μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Εξαίρεση:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Οι χρήστες μπορούν να ορίσουν προτιμήσεις για τον τρόπο με τον οποίο η Google διαφημίζει σε εσάς χρησιμοποιώντας τη σελίδα Ρυθμίσεις διαφημίσεων Google. Εναλλακτικά, μπορείτε να εξαιρεθείτε μεταβαίνοντας στη σελίδα Εξαίρεση πρωτοβουλίας Network Advertising Initiative ή χρησιμοποιώντας το πρόσθετο Google Analytics Opt Out Browser.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Επιτρέπει ο ιστότοπός μας παρακολούθηση συμπεριφοράς τρίτων?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("It's also important to note that we allow third-party behavioral tracking")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyCzech_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332d3b3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyCzech_vue__ = __webpack_require__(2011);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332d3b3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[(_vm.countryCode == 'cz')?_c('span',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Tyto zásady ochrany osobních údajů byly sestaveny, aby lépe sloužily těm, kteří se zajímají o to, jak jsou jejich „osobně identifikovatelné informace“ (PII) používány online. Přečtěte si pozorně naše zásady ochrany osobních údajů, abyste získali jasnou představu o tom, jak shromažďujeme, používáme, chráníme nebo jinak zacházíme s vašimi osobně identifikovatelnými informacemi v souladu s našimi webovými stránkami.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h4',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Πάροχος περιεχομένου: Puretech")]),_vm._v(" "),_c('h4',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Διεύθυνση: 46350 Petaling Jaya, Selangor Darul Ehsan, Malaysia.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jaké osobní údaje shromažďujeme od lidí, kteří navštěvují náš blog, web nebo aplikaci?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Při objednávání nebo registraci na našem webu můžete být požádáni, abyste zadali své jméno, e-mailovou adresu, poštovní adresu, telefonní číslo nebo jiné podrobnosti, které vám pomohou s vaší zkušeností.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kdy shromažďujeme informace?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Shromažďujeme informace od vás, když se zaregistrujete na našem webu, vyplníte formulář nebo zadáte informace na našem webu. Poskytněte nám zpětnou vazbu k našim produktům nebo službám.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jak používáme vaše údaje? ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informace, které od vás shromažďujeme, můžeme použít při registraci, nákupu, registraci k odběru našeho zpravodaje, odpovědi na průzkum nebo marketingovou komunikaci, procházení webu nebo používání určitých dalších funkcí webu následujícími způsoby:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Chcete-li přizpůsobit své zkušenosti a umožnit nám doručit typ obsahu a nabídky produktů, o které máte největší zájem")]),_vm._v(" "),_c('li',[_vm._v("Vylepšit náš web, abychom vám mohli lépe sloužit.")]),_vm._v(" "),_c('li',[_vm._v("Abychom vám mohli lépe poskytovat služby v reakci na vaše požadavky na zákaznické služby.")]),_vm._v(" "),_c('li',[_vm._v("Spravovat soutěž, propagaci, průzkum nebo jiné funkce webu.")]),_vm._v(" "),_c('li',[_vm._v("Chcete-li rychle zpracovat své transakce.")]),_vm._v(" "),_c('li',[_vm._v("Požádat o hodnocení a recenze služeb nebo produktů")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Jak chráníme vaše údaje?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naše webové stránky jsou pravidelně kontrolovány, zda neobsahují bezpečnostní mezery a známé chyby zabezpečení, aby byla vaše návštěva našeho webu co nejbezpečnější.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Používáme cookies?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Ano. Cookies jsou malé soubory, které web nebo jeho poskytovatel služeb přenáší na pevný disk vašeho počítače prostřednictvím vašeho webového prohlížeče (pokud to povolíte), což umožňuje systémům webu nebo poskytovatele služeb rozpoznat váš prohlížeč a zachytit a zapamatovat si určité informace. Používáme například soubory cookie, které nám pomáhají zapamatovat si a zpracovat položky ve vašem nákupním košíku. Používají se také k tomu, aby nám pomohly porozumět vašim preferencím na základě předchozí nebo aktuální aktivity na webu, což nám umožňuje poskytovat vám vylepšené služby. Používáme také soubory cookie, které nám pomáhají shromažďovat souhrnné údaje o provozu a interakci se stránkami, abychom mohli v budoucnu nabízet lepší zážitky a nástroje.")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies používáme k:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pochopte a uložte preference uživatele pro budoucí návštěvy.")]),_vm._v(" "),_c('li',[_vm._v("Sledujte reklamy.")]),_vm._v(" "),_c('li',[_vm._v("Kompilace agregovaných dat o provozu webu a interakcích s webem, aby v budoucnu nabízel lepší prostředí a nástroje. Můžeme také použít důvěryhodné služby třetích stran, které tyto informace sledují naším jménem.")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Můžete zvolit, aby vás počítač varoval při každém odeslání souboru cookie, nebo můžete vypnout všechny soubory cookie. To provedete prostřednictvím nastavení prohlížeče. Vzhledem k tomu, že se prohlížeč trochu liší, podívejte se do nabídky nápovědy svého prohlížeče a zjistěte správný způsob úpravy souborů cookie.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Zveřejnění třetí stranou")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Vaše osobní identifikační údaje neprodáváme, neobchodujeme s nimi ani je jinak nepředáváme externím stranám, pokud na to uživatele předem nepředáme. To nezahrnuje partnery hostující webové stránky a další strany, které nám pomáhají s provozováním našich webových stránek, řízením našeho podnikání nebo poskytováním služeb našim uživatelům, pokud tyto strany souhlasí se zachováním důvěrnosti těchto informací. Můžeme také zveřejnit informace, pokud je jejich vydání vhodné k dodržení zákonů, prosazování zásad našich stránek nebo k ochraně našich práv či majetku ostatních")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Informace o návštěvnících, které neumožňují osobní identifikaci, však mohou být poskytnuty dalším stranám za účelem marketingu, reklamy nebo k jiným účelům.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Odkazy třetích stran")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Na naše webové stránky nezahrnujeme ani nenabízíme produkty nebo služby třetích stran.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Reklamní požadavky společnosti Google lze shrnout do zásad inzerce společnosti Google. Jsou zavedeny, aby uživatelům poskytly pozitivní zážitek. "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Kliknutím sem zobrazíte")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Google jako prodejce třetí strany používá soubory cookie k zobrazování reklam na našem webu. Google pomocí cookie DART umožňuje zobrazovat reklamy našim uživatelům na základě předchozích návštěv našich stránek a dalších stránek na internetu. Uživatelé se mohou odhlásit z používání souboru cookie DART tak, že navštíví zásady ochrany osobních údajů reklamní sítě Google a obsahové sítě.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Implementovali jsme následující:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Společně s dodavateli třetích stran, jako je Google, používáme soubory cookie první strany (například soubory cookie Google Analytics) a soubory cookie třetích stran (například soubor cookie DoubleClick) nebo jiné identifikátory třetích stran společně ke shromažďování údajů o interakcích uživatelů s zobrazení reklam a další funkce reklamních služeb, které se vztahují k našemu webu.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Opting out:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Umožňuje náš web sledování chování třetích stran?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Je také důležité si uvědomit, že umožňujeme sledování chování třetích stran")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyFinnish_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22320daa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyFinnish_vue__ = __webpack_require__(2013);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyFinnish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22320daa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyFinnish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n          Tämä tietosuojakäytäntö on laadittu palvelemaan paremmin niitä,\n          jotka ovat kiinnostuneita siitä, miten heidän henkilökohtaisesti\n          tunnistettavia tietojaan (PII) käytetään verkossa. Lue\n          tietosuojakäytäntömme huolellisesti saadaksesi selkeän käsityksen\n          siitä, miten keräämme, käytämme, suojaamme tai muuten käsittelemme\n          henkilötietojasi verkkosivustomme mukaisesti.\n        ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Mitä henkilökohtaisia ​​tietoja keräämme ihmisiltä, ​​jotka\n            vierailevat blogissamme, verkkosivustollamme tai sovelluksessamme?\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Kun tilaat tai rekisteröidyt sivustollemme, sinua saatetaan\n            tarvittaessa pyytää antamaan nimesi, sähköpostiosoitteesi,\n            postiosoitteesi, puhelinnumerosi tai muita tietojasi kokemuksen\n            parantamiseksi.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Milloin keräämme tietoja?\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Keräämme tietoja sinulta, kun rekisteröidyt sivustollemme, täytät\n            lomakkeen tai syötät tietoja sivustollemme. Anna meille palautetta\n            tuotteistamme tai palveluistamme.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Kuinka käytämme tietojasi?\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Voimme käyttää sinulta keräämäämme tietoja, kun rekisteröidyt,\n            ostat, ilmoitat uutiskirjeemme, vastaat kyselyyn tai\n            markkinointiviestintään, surffailemme verkkosivustolla tai\n            käytämme tiettyjä muita sivuston ominaisuuksia seuraavilla\n            tavoilla:\n          ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n              Voit mukauttaa kokemustasi ja antaa meille mahdollisuuden\n              toimittaa sinua kiinnostavinta sisältö- ja tuotetyyppiä.\n            ")]),_vm._v(" "),_c('li',[_vm._v("Parantaa verkkosivustoamme palvelemaan sinua paremmin.")]),_vm._v(" "),_c('li',[_vm._v("\n              Jotta voimme palvella sinua paremmin vastaamalla\n              asiakaspalvelupyyntöihisi\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              Kilpailun, kampanjan, kyselyn tai muun sivuston ominaisuuden\n              hallinnoiminen.\n            ")]),_vm._v(" "),_c('li',[_vm._v("Tapahtumien nopea käsittelys.")]),_vm._v(" "),_c('li',[_vm._v("\n              Pyydä luokituksia ja arvosteluja palveluista tai tuotteista\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Kuinka suojaamme tietojasi?\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Verkkosivustomme tarkistetaan säännöllisesti tietoturva-aukkojen\n            ja tunnettujen haavoittuvuuksien varalta, jotta vierailustasi\n            sivustollemme tulisi mahdollisimman turvallista.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Käytämmekö evästeitä?")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Joo. Evästeet ovat pieniä tiedostoja, jotka sivusto tai sen\n            palveluntarjoaja siirtää tietokoneen kiintolevylle verkkoselaimesi\n            kautta (jos sallit), jonka avulla sivuston tai palveluntarjoajan\n            järjestelmät voivat tunnistaa selaimesi ja siepata ja muistaa\n            tiettyjä tietoja. Esimerkiksi käytämme evästeitä auttaaksemme\n            meitä muistamaan ja käsittelemään ostoskorissasi olevat tuotteet.\n            Niitä käytetään myös auttamaan meitä ymmärtämään asetuksesi\n            aiemman tai nykyisen sivuston toiminnan perusteella, mikä antaa\n            meille mahdollisuuden tarjota sinulle parempia palveluja. Käytämme\n            myös evästeitä auttaaksemme meitä keräämään koottuja tietoja\n            sivuston liikenteestä ja sivuston vuorovaikutuksesta, jotta voimme\n            tarjota parempia sivustokokemuksia ja työkaluja tulevaisuudessa.\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Käytämme evästeitä:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n              Ymmärrä ja tallenna käyttäjän asetukset tulevia vierailuja\n              varten.\n            ")]),_vm._v(" "),_c('li',[_vm._v("Seuraa mainoksia.")]),_vm._v(" "),_c('li',[_vm._v("\n              Kerää koottuja tietoja sivuston liikenteestä ja sivuston\n              vuorovaikutuksesta tarjotaksesi parempia sivustokokemuksia ja\n              työkaluja tulevaisuudessa. Voimme käyttää myös luotettavia\n              kolmannen osapuolen palveluja, jotka seuraavat näitä tietoja\n              puolestamme.\n            ")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Voit halutessasi pyytää tietokonettasi varoittamaan sinua aina,\n            kun eväste lähetetään, tai voit poistaa kaikki evästeet käytöstä.\n            Teet tämän selaimesi asetusten kautta. Koska selain on hieman\n            erilainen, katso selaimesi Ohje-valikosta oppiaksesi oikea tapa\n            muokata evästeitä.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Kolmannen osapuolen paljastaminen\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Emme myy, vaihda tai muuten välitä henkilötietojasi ulkopuolisille\n            osapuolille, ellemme ilmoita asiasta käyttäjille etukäteen. Tämä\n            ei sisällä verkkosivustojen isännöintikumppaneita eikä muita\n            osapuolia, jotka auttavat meitä verkkosivustomme toiminnassa,\n            liiketoiminnassamme tai palvelemisessa käyttäjillemme, kunhan\n            osapuolet sitoutuvat pitämään nämä tiedot luottamuksellisina.\n            Voimme myös julkaista tietoja, kun niiden julkaisu on\n            tarkoituksenmukaista lain noudattamiseksi, sivustokäytäntöjemme\n            noudattamiseksi tai omien tai muiden oikeuksien, omaisuuden\n            suojaamiseksi\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Henkilökohtaisesti tunnistamatonta vierailijatietoa voidaan\n            kuitenkin antaa muille osapuolille markkinointia, mainontaa tai\n            muuta käyttöä varten.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Kolmannen osapuolen linkit\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Emme sisälly tai tarjoa kolmannen osapuolen tuotteita tai\n            palveluja verkkosivustollamme.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Google")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Googlen mainontavaatimukset voidaan tiivistää Googlen\n            mainontaperiaatteilla. Ne perustetaan tarjoamaan käyttäjille\n            positiivinen kokemus.\n            "),_c('a',{attrs:{"href":"https://support.google.com/adwordspolicy/answer/1316548?hl=en"}},[_vm._v("Napsauta tätä nähdäksesi")])]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Google käyttää kolmannen osapuolen toimittajina evästeitä\n            mainosten näyttämiseen sivustollamme. Googlen DART-evästeen käyttö\n            antaa sen näyttää mainoksia käyttäjillemme aiempien vierailujen\n            perusteella sivustollamme ja muilla Internet-sivustoilla.\n            Käyttäjät voivat kieltäytyä DART-evästeen käytöstä vierailemalla\n            Googlen mainos- ja sisältöverkoston tietosuojakäytännössä.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Olemme toteuttaneet seuraavat:\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Me yhdessä kolmansien osapuolten toimittajien, kuten Google,\n            kanssa käytämme ensimmäisen osapuolen evästeitä (kuten Google\n            Analytics -evästeitä) ja kolmannen osapuolen evästeitä (kuten\n            DoubleClick -eväste) tai muita kolmannen osapuolen tunnisteita\n            keräämään tietoja käyttäjien vuorovaikutuksesta käyttäjien kanssa.\n            mainosten näyttökerrat ja muut mainospalvelutoiminnot, jotka\n            liittyvät verkkosivustoomme.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Kieltäytyminen:")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Käyttäjät voivat asettaa asetuksia sille, miten Google mainostaa\n            sinulle, käyttämällä Google-mainosasetussivua. Vaihtoehtoisesti\n            voit kieltäytyä käymällä Network Advertising Initiative Opt Out\n            -sivulla tai käyttämällä Google Analytics Opt Out Browser\n            -lisäosaa.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Sallitseeko sivustomme kolmannen osapuolen käyttäytymisen\n            seurannan?\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            On myös tärkeää huomata, että sallimme kolmannen osapuolen\n            käyttäytymisen seurannan\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap boxed "},[_c('div',{staticClass:"d2-section"},[_c('div',{staticClass:"d2-section__header"},[_c('h2',{staticClass:"d2-h2"},[_c('span',{staticClass:"text_color"},[_vm._v(" "+_vm._s(_vm.$t('privacy')))])])]),_vm._v(" "),_c('div',{staticClass:"d2-section__content"},[(_vm.lang_gamebox == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_gamebox == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_gamebox == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_gamebox == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_gamebox == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_gamebox == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.lang_gamebox == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_gamebox == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_gamebox == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe420a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(2023);
function injectStyle (ssrContext) {
  __webpack_require__(2016)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fe420a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe420a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(675);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e590f78_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(2018);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e590f78_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Help and support")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Customer service is available on working days from 09:00 to 17:00\n            Contact: +421 313215999 or gamebox."+_vm._s(_vm.countryCode)+"@silverlines.info\n          ")])]),_vm._v(" "),_vm._m(5)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n              Conditions And Requirements\n            ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Applicability")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            The terms and conditions set out below (General Terms and\n            Conditions) apply to the English version of the one-time paid\n            service Miximo Premium (Puretech Global Sdn Bhd and / or the\n            Service) offered online via the Internet from Puretech Global Sdn\n            Bhd (hereinafter referred to as Puretech Global Sdn Bhd). End User\n            Requests GAMEBOX Puretech Global Sdn Bhd.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Generally")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            GAMEBOX provides the best sexy wallpapers and videos exclusively\n            for your mobile.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Confirmation / Registration")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            To access the GAMEBOX service, the End User must enter their\n            mobile telephone number and / or certain other data and / or\n            information through a promotional website (Landing Page) operated\n            by Puretech Global Sdn Bhd. Then the End User will receive an SMS\n            on his mobile device, with a Personal Identification Number (PIN\n            code), or a so-called offer message with information about the\n            service. By entering the received PIN code on the landing page and\n            / or sending a confirmation message and / or using the service,\n            the End User acknowledges and confirms that he has read the\n            General Terms and Conditions, is an authorized mobile phone\n            account holder or has the consent of the telephone account payer\n            to use this service. The end user will receive a confirmation SMS\n            message about the successful activation of the GAMEBOX service,\n            the method, frequency and costs of taking over the Service, as\n            well as the exact details of the logout.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Costs and Fees")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            GAMEBOX is a paid service that costs 3 SMS x 1.60 EUR / week The\n            fee will be charged to a mobile phone account or a prepaid mobile\n            number. The method of charging is Premium MT SMS sent to the End\n            User based on his request for the GAMEBOX service. This message\n            will contain your GAMEBOX login information. Fees are collected\n            according to Mobile Network Operators. Fees are written off\n            against the End User's account by the Operator; in the case of a\n            pre-subscription SIM, the fees are deducted from the End User's\n            credit. The End User hereby expressly grants his or her\n            authorization to charge, and undertakes to pay in full for the\n            fees incurred as a result of subscribing to and / or using the\n            GAMEBOX Service. If you are not the person responsible for paying\n            your mobile bill, please obtain permission from your mobile payer\n            before signing in and / or using the GAMEBOX service. By signing\n            and / or participating in the Service, Puretech Global Sdn Bhd\n            assumes that the End User has obtained the necessary permission,\n            consent or approval from the mobile account payer, guardian or\n            parents. All SMS messages sent by the End User will be charged by\n            the End User's mobile operator at a standard tariff. These rates\n            may vary by operator. Please contact your GSM operator for more\n            information on charges.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Intellectual Property")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            You may use the Service for your personal, non-commercial use. The\n            term GAMEBOX and all other trademarks, service marks and / or\n            trade names used by GAMEBOX on the Service from time to time\n            (Trademarks) are trademarks, service marks and / or trade names of\n            Puretech Global Sdn Bhd or one of its companies in the group or\n            its licensors, and these entities reserve all rights to the\n            Trademarks. In addition, other content of the Services, including,\n            but not limited to, Games, images, pictures, graphics,\n            photographs, animations, videos, music, sound and text belong to\n            GAMEBOX or one of its companies and / or licensed groups, and are\n            protected by copyright and / or other intellectual property\n            rights. You acknowledge that, through your use of the Service, you\n            will not acquire any trademark rights or Content of the Service\n            other than as set forth in this Agreement. In particular, under no\n            circumstances may you copy any Content of the Service (including,\n            without limitation, trivia questions, answers, or games), or use\n            data mining, robots, screen scratches, or similar data collection\n            and extraction tools on the Service. Liability The use of GAMEBOX\n            and / or the GAMEBOX website is at the end user's own risk. The\n            end user must provide a compatible mobile phone, hardware, or\n            other equipment and software, and ensure that they are in working\n            order and suitable for GAMEBOX services. GAMEBOX cannot guarantee\n            that the GAMEBOX services meet the requirements of the end user\n            and that the download, receipt and / or viewing of the GAMEBOX\n            services will be without interruption or error. If at any time the\n            End User is unable to use the Puretech Global Sdn Bhd service\n            without interruption, this in no way leads to the right to a\n            reduction in fees for GAMEBOX services, to any right to a refund\n            of prepaid payments. Any use of the GAMEBOX Services is at the end\n            user's discretion and risk, and that for no, but not limited to,\n            infections or contaminations, or loss of data, or damage (s) to\n            end users' hardware and / or software resulting from access to the\n            Website , or use the GAMEBOX Services, or downloaded GAMEBOX\n            Services, including the hardware and software required to connect\n            to the GAMEBOX Services. It is the responsibility of end-users to\n            take the necessary measures to prevent possible damage to this\n            species. In the event that GAMEBOX is obliged for any reason to\n            compensate the end user for direct or consequential damages of any\n            kind, such compensation may in no case exceed the value of the\n            invoice for GAMEBOX services paid by the end user for the alleged\n            damages. The content of the Website has been compiled with the\n            greatest care. However, Miximo cannot provide any guarantee as to\n            the nature, accuracy or content of this information. GAMEBOX is\n            not responsible for any errors, omissions, inaccuracies,\n            misunderstandings, delays, or illegible orders, or notices based\n            on the use of the Internet or the relevant information point.\n            Final Provisions Any disputes concerning the fulfillment of these\n            Business Conditions will be resolved by the competent general\n            courts. Puretech Global Sdn Bhd reserves the right to change these\n            terms from time to time. Changes will be announced to end users by\n            posting on the GAMEBOX portal.\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSlovakia_vue__ = __webpack_require__(676);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d359e9f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovakia_vue__ = __webpack_require__(2020);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSlovakia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d359e9f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovakia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('span',[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("podmienky a požiadavky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Použiteľnosť")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Termíny a podmienky uvedené nižšie (Všeobecné podmienky) sa\n            vzťahujú na Slovenskú verziu jednorazovej platenej služby Miximo\n            Premium (Puretech Global Sdn Bhd a /alebo Služba) ponúkanú on -\n            line cez internet od Puretech Global Sdn Bhd (ďalej len Puretech\n            Global Sdn Bhd ). Koncový užívateľ požaduje službu GAMEBOX\n            Puretech Global Sdn Bhd .\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Všeobecné")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            GAMEBOX poskytuje najlepšie sexy tapety a videá exkluzívne pre váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Potvrdenie / Registrácia")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Na vstup do služby GAMEBOX musí Koncový používateľ zadať svoje\n            mobilné telefónne číslo a /alebo niektoré ďalšie údaje a /alebo\n            informácie prostredníctvom propagačnej webovej stránky (Vstupné\n            Stránky) prevádzkovanej Puretech Global Sdn Bhd -om. Potom Koncový\n            užívateľ dostane SMS vo svojom mobilnom zariadení, s Osobným\n            Identifikačným Číslom (PIN kód), alebo tzv ponukovú správu s\n            informáciami o službe. Zadaním obdržaného PIN kódu na vstupnej\n            stránke a /alebo zaslaním potvrdzovacej správy a /alebo používaním\n            služby Koncový užívateľ uznáva a potvrdzuje, že prečítal Všeobecné\n            obchodné podmienky, je oprávneným držiteľom mobilného účtu za\n            telefón, alebo má súhlas platiteľa telefóneho účtu používať túto\n            službu. Koncový užívateľ dostane potvrdzujúcu SMS správu o\n            úspešnej aktivácii GAMEBOX služby, spôsobe, frekvencii a nákladov\n            na prevzatie Služby, rovnako ako presné detaily odhlásenia.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Náklady a Poplatky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            GAMEBOX je platená služba ktorá stojí 3 SMS x 1.60 EUR / týždeň\n            Poplatok bude účtovaný na mobilný telefónny účet, alebo\n            predplatené mobilné číslo.Spôsob nabíjania je Premium MT SMSkami\n            odoslanými na Koncového užívateľa na základe jeho žiadosti o\n            službu GAMEBOX. Táto správa bude obsahovať prihlasovacie údaje k\n            službe GAMEBOX. Poplatky sú vyberané podľa Prevádzkovateľov\n            Mobilných Sietí. Poplatky sú odpísané proti účtu Koncového\n            užívateľa Prevádzkovateľom, v prípade predplantnej SIM sa poplatky\n            odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ týmto\n            výslovne udeľuje jeho alebo jej oprávnenie pre nabíjanie, a\n            zaväzuje sa na zaplatenie v plnej výške za poplatky, ktoré vznikli\n            v dôsledku upísania a / alebo používania služby GAMEBOX. Ak nie\n            ste osoba zodpovedná za zaplatenie mobilného účtu, prosím,\n            získajte povolenie od platiteľa mobilu pred prihlásením a /alebo\n            používaním služby GAMEBOX. Svojím podpisom a /alebo účasťou na\n            službe, Puretech Global Sdn Bhd predpokladá, že Koncový užívateľ\n            získal potrebné povolenie, súhlas alebo schválenie od platiteľa\n            mobilného účtu, opatrovníka alebo rodičov. Všetky SMS správy\n            zaslané Koncovým používateľom budú účtované mobilným operátorom\n            Koncového užívateľa štandardnou tarifou. Tieto tarify sa môžu\n            líšiť podľa operátora. Prosím, pre viac nformácií o uložených\n            poplatkoch kontaktujte svojho GSM operátora.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Pomoc a podpora")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznícky servis je k dispozícii v pracovných dňoch od 09:00 do\n            17:00 Kontakt: +421 313215999 alebo gamebox.sk@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Duševné vlastníctvo")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu môžete použiť na svoje osobné nekomerčné použitie. Termín\n            GAMEBOX a všetky ostatné ochranné známky, servisné značky a /alebo\n            obchodné názvy používané GAMEBOX-om na Službe z času na čas\n            (Ochranné Známky), sú ochrannými známkami, servisnými značkami a\n            /alebo obchodnými názvami Puretech Global Sdn Bhd - u alebo jednej\n            z jeho spoločností v skupine alebo udeľovateľov jej licencie, a\n            tieto subjekty si vyhradzujú všetky práva na Ochranné Známky.\n            Okrem toho, ďalší obsah Služby, vrátane, ale nie výhradne, Hry,\n            obrázy, obrázky, grafika, fotografie, animácie, videá, hudba, zvuk\n            a text patria GAMEBOX- u, alebo jednému z jeho spoločností a\n            /alebo licenčných skupín, a sú chránené autorskými právami a\n            /alebo inými právami duševného vlastníctva. Beriete týmto na\n            vedomie, že pri používaní Služby nezískate žiadne práva na\n            ochranné známky, alebo Obsah Služby, než ako je uvedené v tejto\n            Dohode. Najmä za žiadnych okolností nemôžete skopírovať ľubovoľný\n            Obsah Služby (vrátane a bez obmedzenia trivia otázky, odpovede,\n            alebo hry), alebo využívať dolovanie dát, roboty, škrabanie\n            obrazovky, alebo podobné zhromažďovanie údajov a extrakčné\n            nástroje na Službe. Zodpovednosť Použitie GAMEBOX- u a /alebo web\n            stránky GAMEBOX prebieha na vlastné riziko koncového užívateľa.\n            Koncový užívateľ musí poskytnúť všetko- kompatibilný mobilný\n            telefón, hardvér, alebo iné zariadenia a softvér, a zabezpečiť,\n            aby boli v prevádzkyschopnom stave a vhodné na služby GAMEBOX.\n            GAMEBOX nemôže zaručiť, že služby GAMEBOX spĺňajú požiadavky\n            koncového užívateľa, a že stiahnutie, príjem a /alebo prezeranie\n            služieb GAMEBOX bude bez prerušenia, alebo chýb. Ak kedykoľvek\n            Koncový užívateľ nie je schopný používať bez prerušenia službu\n            Puretech Global Sdn Bhd , v žiadnom prípade to nevedie k nároku na\n            zníženie poplatkov za GAMEBOX služby, k akékoľvek právo na\n            vrátenie platieb dopredu zaplatených. Akékoľvek použitie služieb\n            GAMEBOX je podľa vlastného uváženia a rizika koncového užívateľa,\n            a že za žiadny ale nie obmedzene, za infekcie, alebo kontaminácie,\n            alebo straty dát, alebo poškodenie(ia) hardvéru a /alebo softvéru\n            koncových užívateľov, vyplývajúcich z prístupu k webovým stránkam,\n            alebo využívania služieb GAMEBOX -u, alebo stiahnutých GAMEBOX\n            služieb, vrátane hardvéru a softvéru vyžadovaného na pripojenie k\n            službám GAMEBOX. Je zodpovednosťou koncových užívateľov, aby\n            prijali potrebné opatrenia, aby sa zabránilo možnému poškodeniu\n            tohto druhu. V prípade, že GAMEBOX je z akéhokoľvek dôvodu povinný\n            nahradiť koncovému užívateľovi priame, alebo následné škody\n            akéhokoľvek druhu, takáto náhrada v žiadnom prípade nesmie\n            prekročiť hodnotu faktúry za služby GAMEBOX, platených koncovým\n            užívateľom pre údajné poškodenia. Obsah Webovej stránky bol\n            zostavený s najväčšou starostlivosťou. Avšak, Miximo nemôže\n            poskytnúť žiadnu záruku, pokiaľ ide o povahu, presnosť alebo obsah\n            týchto informácií. GAMEBOX nenesie zodpovednosť za akékoľvek\n            chyby, opomenutia, nepresnosti, nedorozumenia, oneskorenie, alebo\n            nečitateľné objednávky, alebo oznámenia na základe používania\n            Internetu, alebo príslušného informačného miesta. Záverečné\n            ustanovenia Akékoľvek spory týkajúce sa plnenia týchto Obchodných\n            podmienok budú riešené príslušnými všeobecnými súdmi. Puretech\n            Global Sdn Bhd si vyhradzuje právo čas od času zmeniť tieto\n            podmienky. Zmeny budú oznámené koncovým užívateľom vyvesením na\n            portáli GAMEBOX.\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__ = __webpack_require__(677);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6929deba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__ = __webpack_require__(2022);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6929deba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('span',[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Podmínky a požadavky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v(" ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Použitelnost")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou\n            verzi jednorázové placené služby Miximo Premium (Puretech Global\n            Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu\n            od společnosti Puretech Global Sdn Bhd (dále dále jen Puretech\n            Global Sdn Bhd). Koncový uživatel požaduje GAMEBOX Puretech Global\n            Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Obvykle")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            GAMEBOX poskytuje nejlepší sexy tapety a videa výhradně pro váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Potvrzení / registrace")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Pro přístup ke službě GAMEBOX musí koncový uživatel zadat své\n            mobilní telefonní číslo a / nebo určitá další data a / nebo\n            informace prostřednictvím propagační webové stránky (úvodní\n            stránky) provozované společností Puretech Global Sdn Bhd. Poté\n            koncový uživatel obdrží na svůj server SMS mobilní zařízení, s\n            osobním identifikačním číslem (PIN kód), nebo takzvanou nabídkovou\n            zprávou s informacemi o službě. Koncový uživatel zadáním přijatého\n            PIN kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a\n            / nebo používáním služby potvrzuje a potvrzuje, že si přečetl\n            Všeobecné podmínky, je autorizovaným majitelem účtu mobilního\n            telefonu nebo má souhlas plátce telefonního účtu s využitím této\n            služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné\n            aktivaci služby GAMEBOX, způsobu, frekvenci a nákladech na\n            převzetí Služby a také přesné údaje o odhlášení.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Náklady a poplatky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            GAMEBOX je placená služba, která stojí 3 SMS x 1,60 EUR / týden\n            Poplatek bude účtován na účet mobilního telefonu nebo na\n            předplacené mobilní číslo. Způsob účtování je Premium MT SMS\n            zasílaná Koncovému uživateli na základě jeho požadavku na službu\n            GAMEBOX. Tato zpráva bude obsahovat vaše přihlašovací údaje ke\n            GAMEBOXU. Poplatky se vybírají podle provozovatelů mobilních sítí.\n            Poplatky jsou odepsány na účet Koncového uživatele Provozovatelem;\n            v případě SIM s předplatným jsou poplatky odečteny z kreditu\n            Koncového uživatele. Koncový uživatel tímto výslovně uděluje své\n            oprávnění účtovat poplatky a zavazuje se zaplatit v plné výši\n            poplatky vzniklé v důsledku předplatného a / nebo používání služby\n            GAMEBOX. Pokud nejste osobou odpovědnou za placení účtu za mobilní\n            telefon, před přihlášením a / nebo používáním služby GAMEBOX si\n            prosím vyžádejte povolení od svého mobilního plátce. Podpisem a /\n            nebo účastí ve službě Puretech Global Sdn Bhd předpokládá, že\n            koncový uživatel získal potřebné povolení, souhlas nebo schválení\n            od plátce mobilního účtu, opatrovníka nebo rodičů. Všechny SMS\n            zprávy zasílané koncovým uživatelem budou mobilním operátorem\n            koncového uživatele účtovány za standardní tarif. Tyto sazby se\n            mohou u jednotlivých operátorů lišit. Další informace o poplatcích\n            vám poskytne váš mobilní operátor GSM.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Pomoc a podpora")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00\n            Kontakt: +421 313215999 nebo gamebox.cz@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Duševní vlastnictví")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu můžete používat pro osobní, nekomerční použití. Pojem\n            GAMEBOX a všechny ostatní ochranné známky, servisní značky a /\n            nebo obchodní názvy používané GAMEBOX ve Službě čas od času\n            (ochranné známky) jsou ochranné známky, servisní značky a / nebo\n            obchodní názvy společnosti Puretech Global Sdn Bhd nebo jedné z\n            jejích společností v skupina nebo její poskytovatelé licencí a\n            tyto subjekty si vyhrazují veškerá práva k ochranným známkám.\n            Kromě toho další obsah Služeb, mimo jiné včetně her, obrázků,\n            obrázků, grafik, fotografií, animací, videí, hudby, zvuku a textu,\n            patří společnosti GAMEBOX nebo jedné z jejích společností a / nebo\n            licencovaných skupin a jsou chráněny autorským právem a / nebo\n            jinými právy duševního vlastnictví. Berete na vědomí, že\n            používáním Služby nezískáte žádná práva na ochrannou známku ani\n            Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných\n            okolností nesmíte za žádných okolností kopírovat jakýkoli obsah\n            služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo\n            her), ani ve službě používat dolování dat, roboty, škrábance na\n            obrazovce nebo podobné nástroje pro sběr a extrakci dat.\n            Odpovědnost Používání GAMEBOXU a / nebo webových stránek GAMEBOXU\n            je na vlastní riziko koncového uživatele. Koncový uživatel musí\n            poskytnout kompatibilní mobilní telefon, hardware nebo jiné\n            vybavení a software a zajistit, aby byly v provozuschopném stavu a\n            vhodné pro služby GAMEBOX. GAMEBOX nemůže zaručit, že služby\n            GAMEBOX splňují požadavky koncového uživatele a že stahování,\n            příjem a / nebo prohlížení služeb GAMEBOX proběhne bez přerušení\n            nebo chyb. Pokud kdykoli koncový uživatel nemůže bez přerušení\n            používat službu Puretech Global Sdn Bhd, nevede to v žádném\n            případě k právu na snížení poplatků za služby GAMEBOX, k\n            jakémukoli právu na vrácení předplacených plateb. Jakékoli použití\n            služeb GAMEBOX je na uvážení a riziku koncového uživatele, a to\n            bez omezení, ale nikoli výhradně, infekce nebo kontaminace, ztráta\n            dat nebo poškození hardwaru a / nebo softwaru koncových uživatelů\n            v důsledku přístup k Webovým stránkám, nebo používání Služeb\n            GAMEBOX, nebo stažené Služby GAMEBOX, včetně hardwaru a softwaru\n            nutného pro připojení ke Službám GAMEBOX. Je odpovědností\n            koncových uživatelů, aby přijali nezbytná opatření, která zabrání\n            možnému poškození tohoto druhu. V případě, že je společnost\n            GAMEBOX z jakéhokoli důvodu povinna odškodnit koncového uživatele\n            za přímé nebo následné škody jakéhokoli druhu, nesmí taková\n            náhrada v žádném případě překročit hodnotu faktury za služby\n            GAMEBOX zaplacené koncovým uživatelem za údajné škody. Obsah\n            webových stránek byl sestaven s největší péčí. Miximo však nemůže\n            poskytnout žádnou záruku, pokud jde o povahu, přesnost nebo obsah\n            těchto informací. GAMEBOX neodpovídá za žádné chyby, opomenutí,\n            nepřesnosti, nedorozumění, zpoždění nebo nečitelné objednávky nebo\n            oznámení založená na používání internetu nebo příslušného\n            informačního bodu. Závěrečná ustanovení Veškeré spory týkající se\n            plnění těchto Obchodních podmínek budou řešit příslušné obecné\n            soudy. Puretech Global Sdn Bhd si vyhrazuje právo čas od času tyto\n            podmínky změnit. Změny budou koncovým uživatelům oznámeny\n            zveřejněním na portálu GAMEBOX.\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap boxed"},[_c('div',{staticClass:"d2-section"},[_c('div',{staticClass:"d2-section__header"},[_c('h2',{staticClass:"d2-h2"},[_c('span',{staticClass:"text_color"},[_vm._v(" "+_vm._s(_vm.$t("terms")))])])]),_vm._v(" "),_c('div',{staticClass:"d2-section__content"},[(_vm.lang_gamebox == 'slovakia')?_c('span',[_c('terms-slovakia')],1):_vm._e(),_vm._v(" "),(_vm.lang_gamebox == 'czech')?_c('span',[_c('terms-czech')],1):_c('span',[_c('terms-english')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(679);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b615580_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2033);
function injectStyle (ssrContext) {
  __webpack_require__(2025)
  __webpack_require__(2026)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b615580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b615580_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(680);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03888ddd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2029);
function injectStyle (ssrContext) {
  __webpack_require__(2028)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03888ddd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03888ddd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d2-search",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"d2-searchWrap ",attrs:{"id":"d2-searchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"d2-search__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"d2-mobiAutocomplete",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('a',{key:index,staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])},on:{"click":function($event){return _vm.getDetail(post.id)}}})}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon d2-search__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(681);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340fa6a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2032);
function injectStyle (ssrContext) {
  __webpack_require__(2031)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-340fa6a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340fa6a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d2-notificationComp "},[_c('div',{staticClass:"d2-notificationComp__head"},[_c('h3',{staticClass:"d2-h3"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_gamebox),function(item){return _c('li',{key:item.key},[_c('a',{staticClass:"d2__inner app",attrs:{"data-toggle":"modal","data-target":"#contentModal"},on:{"click":function($event){return _vm.getDetail(item.id)}}},[_c('div',{staticClass:"d2-notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"d2-notificationComp__content"},[(_vm.lang_gamebox !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_gamebox)] !== '')?_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_gamebox)]))]):_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h4',{staticClass:"d2-h4"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"d2-label"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_gamebox)]))])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigationComp ",class:{'openSideMenu' : _vm.isSideMenuActive == true }},[_c('header',{staticClass:"d2-navigation",attrs:{"id":"navigation"}},[_c('div',{staticClass:"d2-navigation__inner boxed"},[_c('div',{staticClass:"d2-navigation_left"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"logo",attrs:{"to":_vm.auth_gamebox === 'loggedin' ? '/home' : ''}},[_c('img',{attrs:{"src":__webpack_require__(2034)}})]),_vm._v(" "),(_vm.auth_gamebox === 'loggedin')?_c('Search'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"d2-navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.country_gamebox != 'iq')?_c('div',{staticClass:"userAccount"},[_c('router-link',{attrs:{"to":_vm.auth_gamebox === 'loggedin' ? '/profile' : ''}},[_c('div',{staticClass:"userAccount__image"},[_c('img',{attrs:{"src":__webpack_require__(123)}})]),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])])],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}}),_vm._v(" "),_c('div',{staticClass:"translationBtns"},[_c('button',{staticClass:"d2-button dropdown-toggle dropdown-toggle-split",attrs:{"id":"btn1","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{attrs:{"id":"lang1"},domProps:{"innerHTML":_vm._s(_vm.button)}})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"id":"dropdown-menu"}},[_c('button',{staticClass:"dropdown-item",attrs:{"id":"btn2"},on:{"click":function($event){return _vm.getTranslateDesktop()}}},[_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_gamebox)}})])])]),_vm._v(" "),_c('div',{staticClass:"d2-navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_gamebox === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('button',{staticClass:"menuBtn",attrs:{"id":"menuBtn"},on:{"click":function($event){return _vm.openSideMenu()}}},[_c('span',{staticClass:"menuBtn__inner"},[_vm._v("menu")])])])])]),_vm._v(" "),(_vm.auth_gamebox === 'loggedin')?_c('nav',{staticClass:"d2-btmMenu"},[_c('div',{staticClass:"d2-btmMenu__inner boxed"},[_c('ul',{staticClass:"d2-navLinks"},[_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"d2-navLinks__item"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t("game_categories")))]),_vm._v(" "),_c('ul',{staticClass:"subLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subLinks__item "},[_c('router-link',{attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_gamebox)]))])])],1)}),0)]),_vm._v(" "),_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1),_vm._v(" "),_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{attrs:{"to":"/privacy","c":""}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),(_vm.countryCode === 'sk' || _vm.countryCode === 'cz')?_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"d2-siteNavMobile"},[_c('div',{staticClass:"d2-siteNavMobile__wraper"},[(_vm.country_gamebox != 'iq')?_c('div',{staticClass:"userAccount",on:{"click":function($event){return _vm.openSideMenu()}}},[_c('router-link',{attrs:{"to":_vm.auth_gamebox === 'loggedin' ? '/profile' : ''}},[_c('div',{staticClass:"userAccount__image"},[_c('img',{attrs:{"src":__webpack_require__(123)}})])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"translationBtns"},[(_vm.lang_gamebox != 'english')?_c('button',{staticClass:"d2-button",attrs:{"id":"btn1"},on:{"click":function($event){return _vm.getTranslateMobile('btn1')}}},[_c('div',{attrs:{"id":"lang1"},domProps:{"innerHTML":_vm._s(_vm.button)}})]):_c('button',{staticClass:"d2-button",attrs:{"id":"btn2"},on:{"click":function($event){return _vm.getTranslateMobile('btn2')}}},[_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_gamebox)}})])]),_vm._v(" "),(_vm.auth_gamebox === 'loggedin')?_c('nav',[_c('ul',{staticClass:"d2-navLinks"},[_c('li',{staticClass:"d2-navLinks__item",on:{"click":function($event){return _vm.openSideMenu()}}},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"d2-navLinks__item"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t("game_categories"))+" ")]),_vm._v(" "),_c('ul',{staticClass:"subLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subLinks__item ",on:{"click":function($event){return _vm.openSideMenu()}}},[_c('router-link',{attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_gamebox)]))])])],1)}),0)])])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"d2-navLinks footer"},[_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{attrs:{"to":"/privacy","c":""}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),(_vm.countryCode === 'sk' || _vm.countryCode === 'cz')?_c('li',{staticClass:"d2-navLinks__item"},[_c('router-link',{attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1):_vm._e(),_vm._v(" "),(_vm.auth_gamebox === 'loggedin')?_c('li',{staticClass:"d2-navLinks__item"},[(_vm.is_unsub_gamebox != '0')?_c('div',{staticClass:"navLinks__item"},[_c('a',{staticClass:"d2-button d2-button--alert",on:{"click":function($event){return _vm.logout_gamebox(_vm.is_unsub_gamebox)}}},[_vm._v("\n                  "+_vm._s(_vm.$t("unsubscribe"))+"\n                ")])]):_c('div',{staticClass:"navLinks__itm"},[(_vm.countryCode !== 'fi')?_c('a',{staticClass:"d2-button d2-button--alert",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_gamebox(_vm.is_unsub_gamebox)}}},[_vm._v("\n                  "+_vm._s(_vm.$t("unsubscribe"))+"\n                ")]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailModal_vue__ = __webpack_require__(682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_948622de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailModal_vue__ = __webpack_require__(2037);
function injectStyle (ssrContext) {
  __webpack_require__(2036)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-948622de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_948622de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"contentModal","tabindex":"-1","role":"dialog","aria-labelledby":"contentModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered d2-modal"},[(_vm.isLoad != false)?_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",style:({ backgroundImage: 'url(' + _vm.details.cover_img + ')' })},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"d2-appItem__thumb"},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"htmlBadge"},[_c('img',{attrs:{"src":__webpack_require__(159)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"id":"thumbnail","src":_vm.details.thumbnail_url}})]),_vm._v(" "),_c('h2',{staticClass:"d2-h2",attrs:{"id":"cont_name"}}),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#FFCF00","show-rating":false,"border-width":2,"border-color":"#FFCF00","rounded-corners":false,"inactive-color":"transparent","star-points":[
                            23,
                            2,
                            14,
                            17,
                            0,
                            19,
                            10,
                            34,
                            7,
                            50,
                            23,
                            43,
                            38,
                            50,
                            36,
                            34,
                            46,
                            19,
                            31,
                            17
                        ],"rating":Number(_vm.details.rating)}}),_vm._v(" "),_c('div',{staticClass:"d2-modal__row"},[_c('span',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]),_vm._v(" "),_vm._m(1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"d2-modal__row"},[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"d2-button",on:{"click":function($event){return _vm.subContent_gamebox([_vm.details.content_detail, _vm.details.content_type, _vm.details.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"d2-button",on:{"click":function($event){return _vm.subContent_gamebox([_vm.details.raw_file_url, _vm.details.content_type, _vm.details.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"id":"close","type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true","id":"close"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d2-modal__row"},[_c('p',{staticClass:"d2-ptxt",attrs:{"id":"description"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gamebox",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1),_vm._v(" "),_c('DetailModal')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Prizeo_vue__ = __webpack_require__(683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74af98a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Prizeo_vue__ = __webpack_require__(2108);
function injectStyle (ssrContext) {
  __webpack_require__(2040)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Prizeo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74af98a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Prizeo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(684);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe1f1e44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(2043);
function injectStyle (ssrContext) {
  __webpack_require__(2042)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe1f1e44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe1f1e44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_prizeo,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n            "),(_vm.lang_prizeo !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_prizeo)]))]):_vm._e(),_vm._v(" "),(_vm.lang_prizeo === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[(hot.category !== 'Video')?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[(data.content_type === 'application/x-zip-compressed' && data.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1)]):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(685);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e5b96b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(2046);
function injectStyle (ssrContext) {
  __webpack_require__(2045)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e5b96b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e5b96b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("allCategories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-6 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_prizeo)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(686);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e8f455_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(2049);
function injectStyle (ssrContext) {
  __webpack_require__(2048)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e8f455"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e8f455_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_prizeo))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_prizeo))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_prizeo))])])]),_vm._v(" "),(_vm.auth_prizeo === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_prizeo != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white"},on:{"click":function($event){return _vm.logout_prizeo(_vm.is_unsub_prizeo)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_prizeo(_vm.is_unsub_prizeo)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(687)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(688);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_350ff06e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(2052);
function injectStyle (ssrContext) {
  __webpack_require__(2051)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-350ff06e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_350ff06e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_prizeo,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getCategoryTranslate(_vm.$route.query.q, _vm.lang_prizeo)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: hot.content_id }
                  }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(689);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fea59f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(2055);
function injectStyle (ssrContext) {
  __webpack_require__(2054)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fea59f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fea59f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_prizeo,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.pagePopular_prizeo),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(690);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41624de6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(2061);
function injectStyle (ssrContext) {
  __webpack_require__(2057)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41624de6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41624de6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizeoSlider_vue__ = __webpack_require__(691);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7556659e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizeoSlider_vue__ = __webpack_require__(2060);
function injectStyle (ssrContext) {
  __webpack_require__(2059)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizeoSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7556659e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizeoSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_prizeo",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_prizeo)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem "},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_prizeo))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.getCategoryTitle(_vm.lang_prizeo))+" "+_vm._s(_vm.$t("categories")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('prizeo-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_prizeo,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('prizeo-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_prizeo,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('prizeo-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(692);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ad2b90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(2064);
function injectStyle (ssrContext) {
  __webpack_require__(2063)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11ad2b90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ad2b90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_prizeo))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_prizeo)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_prizeo !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_prizeo)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_prizeo)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(693);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9b4493c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(2070);
function injectStyle (ssrContext) {
  __webpack_require__(2066)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9b4493c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(694);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a0b9ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(2069);
function injectStyle (ssrContext) {
  __webpack_require__(2068)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a0b9ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns mobizone"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(76)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_prizeo)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
        23,
        2,
        14,
        17,
        0,
        19,
        10,
        34,
        7,
        50,
        23,
        43,
        38,
        50,
        36,
        34,
        46,
        19,
        31,
        17
      ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_prizeo([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_prizeo([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_prizeo([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(709);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d0b2c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2073);
function injectStyle (ssrContext) {
  __webpack_require__(2072)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17d0b2c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d0b2c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.isAoc === true)?_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.consent_gateway($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("subscribe_messsage")))]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("subscribe")))])])])]):_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_prizeo === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_prizeo !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(710);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_641980df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(2076);
function injectStyle (ssrContext) {
  __webpack_require__(2075)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-641980df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_641980df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("contact_us")))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t("subject")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('select',{attrs:{"id":"select"}},[_c('option',[_vm._v(_vm._s(_vm.$t("select_subject")))]),_vm._v(" "),_c('option',{attrs:{"value":"technical"}},[_vm._v(_vm._s(_vm.$t("app_issue")))]),_vm._v(" "),_c('option',{attrs:{"value":"content"}},[_vm._v(_vm._s(_vm.$t("content")))]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v(_vm._s(_vm.$t("subscription")))])]),_vm._v(" "),_c('span',{staticClass:"arrow__upper"})])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t("message")))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('let_us')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(711);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449164f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(2079);
function injectStyle (ssrContext) {
  __webpack_require__(2078)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-449164f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449164f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(712);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2969b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(2082);
function injectStyle (ssrContext) {
  __webpack_require__(2081)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f2969b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2969b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(713);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b103d826_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2085);
function injectStyle (ssrContext) {
  __webpack_require__(2084)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b103d826"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b103d826_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_prizeo == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_prizeo == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_prizeo == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_prizeo == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_prizeo == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_prizeo == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Application.jpg": 2087,
	"./Game.jpg": 2088,
	"./Music.jpg": 2089,
	"./Video.jpg": 2090,
	"./Wallpaper.jpg": 2091,
	"./Yummy Recipe.jpg": 2092,
	"./Yummy-Recipe.jpg": 2093
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2086;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Application.38f2fdc.jpg";

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Game.59bcd11.jpg";

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Music.d470ef0.jpg";

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Video.b89c4e0.jpg";

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wallpaper.e1a9ce6.jpg";

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy Recipe.a9fdf92.jpg";

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy-Recipe.a5c0378.jpg";

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(715);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bfb42c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2103);
function injectStyle (ssrContext) {
  __webpack_require__(2095)
  __webpack_require__(2096)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58bfb42c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bfb42c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(716);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7446f25c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2099);
function injectStyle (ssrContext) {
  __webpack_require__(2098)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7446f25c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7446f25c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index))])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(717);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfa84fea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2102);
function injectStyle (ssrContext) {
  __webpack_require__(2101)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfa84fea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfa84fea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_prizeo),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_prizeo)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.auth_prizeo === 'loggedin' ? '/home' : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(2104)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.auth_prizeo === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_prizeo === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.auth_prizeo === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(687)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_prizeo)}})])])]),_vm._v(" "),(_vm.auth_prizeo === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_prizeo)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpicks")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(_vm._s(_vm.$t("popular")))])],1),_vm._v(" "),(_vm.auth_prizeo === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.country_prizeo == 'iq')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_prizeo(_vm.is_unsub_prizeo)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/prizeo-logo.efe081c.png";

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(718);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705817cd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(2107);
function injectStyle (ssrContext) {
  __webpack_require__(2106)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-705817cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705817cd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_prizeo(_vm.is_unsub_prizeo)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizeo",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_Prizeo",attrs:{"id":"appBg1"}},[_c('div',{staticClass:"mask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fun2win_vue__ = __webpack_require__(719);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44fd203f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fun2win_vue__ = __webpack_require__(2156);
function injectStyle (ssrContext) {
  __webpack_require__(2110)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fun2win_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44fd203f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fun2win_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(720);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725c9ee3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(2113);
function injectStyle (ssrContext) {
  __webpack_require__(2112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-725c9ee3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725c9ee3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.subcategory),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_f2w,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_f2w !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_f2w)]))]):_vm._e(),_vm._v(" "),(_vm.lang_f2w === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.subcategory } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.main.hotpicks[hot.subcategory]),function(game){return _c('div',{key:game.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[(game.subcategory === hot.subcategory)?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: game.content_id } }}},[(game.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":game.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_f2w !== 'english')?_c('span',[(game[("cont_name_" + _vm.lang_f2w)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game[("cont_name_" + _vm.lang_f2w)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(game["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#21d0e3","inactive-color":"#151515","active-color":"#21d0e3","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(game.rating)}})],1)])])],1):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(721);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38df330a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(2119);
function injectStyle (ssrContext) {
  __webpack_require__(2115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38df330a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38df330a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(722);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228b9d15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(2118);
function injectStyle (ssrContext) {
  __webpack_require__(2117)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228b9d15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_f2w)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_f2w([_vm.details.content_detail, _vm.details.content_type])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_f2w([_vm.details.raw_file_url, _vm.details.content_type])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(723);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771569ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(2122);
function injectStyle (ssrContext) {
  __webpack_require__(2121)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-771569ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771569ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello"))+", Alan Smith!")])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('full_name'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v("Alan Smith")])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v("25471111111")])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_email'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v("test@test.com")])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v("01 April 2018")])])]),_vm._v(" "),_c('div',{staticClass:"btnContainer "},[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(2123)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(724);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2ff0d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(2126);
function injectStyle (ssrContext) {
  __webpack_require__(2125)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d2ff0d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2ff0d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_f2w))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_f2w)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.content_id }
                  }}},[(dat.content_type === 'application/x-zip-compressed')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(2127)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_f2w !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_f2w)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_f2w)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":3,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(725);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2434c6b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(2130);
function injectStyle (ssrContext) {
  __webpack_require__(2129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2434c6b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2434c6b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_f2w,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_f2w)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_f2w !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_f2w)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_f2w)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":3,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(726);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7c73fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(2133);
function injectStyle (ssrContext) {
  __webpack_require__(2132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f7c73fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7c73fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_f2w,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_f2w),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_f2w !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_f2w)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_f2w)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":3,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(727);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa96934_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2136);
function injectStyle (ssrContext) {
  __webpack_require__(2135)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7aa96934"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa96934_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"13","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_f2w === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_f2w !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(733);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efa8031_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(2139);
function injectStyle (ssrContext) {
  __webpack_require__(2138)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6efa8031"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efa8031_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#21d0e3","show-rating":false,"border-width":2,"border-color":"#21d0e3","rounded-corners":false,"inactive-color":"#151515","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(734);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca1e6b5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2142);
function injectStyle (ssrContext) {
  __webpack_require__(2141)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca1e6b5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca1e6b5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_f2w == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_f2w == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_f2w == 'greek')?_c('span',[_c('privacy-greek')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;
var currentDate = new Date();

function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      browse: {
        category: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("fun2win")) {
      this.getBrowse();
      this.getHotPicks();
    }
  },

  methods: {
    getHotPicks: function getHotPicks() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allGameData, subcateg, allDataGame, live, local, subgame, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, subcate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = "";
                subCate = [];
                allGameData = [];
                subcateg = [];
                allDataGame = [];
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";

                //get subcategory under game

                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=1&domain=" + host);

              case 9:
                subgame = _context.sent;


                subcateg = subgame.data.data;
                subcateg.map(function (item) {
                  if (item.subcategory_translate != null) {
                    var trans = JSON.parse(item.subcategory_translate);
                    var trans_len = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(trans);
                    if (trans != null) {
                      for (var i = 0; i < trans_len; i++) {
                        item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
                      }
                    }
                    subCate.push(item);
                  }
                });

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 10;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 19:
                if (!(i < subgame.data.data.length)) {
                  _context.next = 32;
                  break;
                }

                _context.next = 22;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subgame.data.data[i].subcategory + "&limit=50&offset=0&domain=" + host);

              case 22:
                allDataGame = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataGame.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataGame.data.data.slice(0, 6);
                subcate = subgame.data.data[i].subcategory;

                allGameData[subcate] = new Array();
                allGameData[subcate] = data_slice;

              case 29:
                i++;
                _context.next = 19;
                break;

              case 32:

                isload = true;

                _this.main.hotpicks = allGameData;
                _this.main.subcategory = subCate.slice(0, 3);
                _this.main.isLoad = isload;

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";
      //game as default
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=0&domain=" + host).then(function (res) {
        var data = res.data.data;

        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == "games4all.vip") {
                  item.icon = icon[key]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          var trans_len = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(trans).length;
          var trans_arr = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(trans);
          if (trans != null) {
            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });

        _this2.browse.category = item_temp;
      });
    }
  }
}));

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(735);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3178a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2153);
function injectStyle (ssrContext) {
  __webpack_require__(2145)
  __webpack_require__(2146)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e3178a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3178a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(736);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2528fc46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2149);
function injectStyle (ssrContext) {
  __webpack_require__(2148)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2528fc46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch games",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(737);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd0785e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2152);
function injectStyle (ssrContext) {
  __webpack_require__(2151)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fd0785e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd0785e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_f2w),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[(_vm.lang_f2w !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_f2w)] !== '')?_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_f2w)]))]):_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_f2w)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation ",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":"/home"}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(2154)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[_c('Search'),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[_c('Notification')],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/profile"}},[_c('img',{attrs:{"src":__webpack_require__(2155)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello"))+", Alan Smith!")])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_f2w)}})])])]),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v("\n              "+_vm._s(_vm.$t("home"))+"\n              ")])],1),_vm._v(" "),_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"navLinks__item ",on:{"click":function($event){return _vm.getclick()}}},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_f2w)]))])])],1)}),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1),_vm._v(" "),(_vm.authentication_f2w === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[_c('a',{staticClass:"login_btn",staticStyle:{"text-decoration":"none"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):_vm._e()],2)]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fun2win-logo.d546651.png";

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fun2win",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_fun2win",attrs:{"id":"appBg"}},[_c('div',{staticClass:"orangeMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cutemobi_vue__ = __webpack_require__(738);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d99263_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cutemobi_vue__ = __webpack_require__(2254);
function injectStyle (ssrContext) {
  __webpack_require__(2158)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cutemobi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d99263_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cutemobi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(739);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea9e11a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(2161);
function injectStyle (ssrContext) {
  __webpack_require__(2160)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ea9e11a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea9e11a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_cm,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n            "),(_vm.lang_cm !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_cm)]))]):_vm._e(),_vm._v(" "),(_vm.lang_cm === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[(hot.category !== 'Video')?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.id } }}},[(data.content_type === 'application/x-zip-compressed' && data.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cm !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: data.id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cm !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1)]):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(740);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c457da5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(2164);
function injectStyle (ssrContext) {
  __webpack_require__(2163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c457da5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c457da5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("allCategories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-6 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_cm)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(741);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e92117c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(2167);
function injectStyle (ssrContext) {
  __webpack_require__(2166)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e92117c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e92117c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello"))+" Isabella ")])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_cm))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_cm))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_cm))])])]),_vm._v(" "),(_vm.auth_cm === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_cm != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white"},on:{"click":function($event){return _vm.logout_cm(_vm.is_unsub_cm)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_cm(_vm.is_unsub_cm)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(742)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(743);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edc2648a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(2170);
function injectStyle (ssrContext) {
  __webpack_require__(2169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-edc2648a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edc2648a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_cm,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all_hotpick"))+" "+_vm._s(_vm.getCategoryTranslate(_vm.$route.query.q, _vm.lang_cm)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: hot.id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cm !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: hot.id }
                  }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cm !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(744);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc7592b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(2173);
function injectStyle (ssrContext) {
  __webpack_require__(2172)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cc7592b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc7592b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_cm,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all_popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.pagePopular_cm),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cm !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(745);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3508a053_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(2179);
function injectStyle (ssrContext) {
  __webpack_require__(2175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3508a053"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3508a053_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CutemobiSlider_vue__ = __webpack_require__(746);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea0eb8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CutemobiSlider_vue__ = __webpack_require__(2178);
function injectStyle (ssrContext) {
  __webpack_require__(2177)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CutemobiSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea0eb8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CutemobiSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cutemobi"},[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_cm",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_cm)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cm !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{ name: 'DetailPage', params: { id: hot.id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cm !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cm !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem "},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cm !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lang_cm != 'greek')?_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_cm))+"\n  ")]):_c('h1',{staticClass:"main_title white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_cm))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[(_vm.lang_cm != 'greek')?_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("category"))+" - "+_vm._s(_vm.getCategoryTitle(_vm.lang_cm)))])]):_c('h2',{staticClass:"main_title md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("category"))+" - "+_vm._s(_vm.getCategoryTitle(_vm.lang_cm)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('cutemobi-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_cm,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('cutemobi-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_cm,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('cutemobi-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(747);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dce861_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(2182);
function injectStyle (ssrContext) {
  __webpack_require__(2181)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15dce861"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dce861_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_cm))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_cm)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cm !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cm !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_cm)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_cm)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(748);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240e424a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(2188);
function injectStyle (ssrContext) {
  __webpack_require__(2184)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240e424a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(749);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08199645_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(2187);
function injectStyle (ssrContext) {
  __webpack_require__(2186)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08199645_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns cutemobi"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(77)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_cm)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
        23,
        2,
        14,
        17,
        0,
        19,
        10,
        34,
        7,
        50,
        23,
        43,
        38,
        50,
        36,
        34,
        46,
        19,
        31,
        17
      ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_cm([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_cm([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_cm([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(764);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628c622f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2191);
function injectStyle (ssrContext) {
  __webpack_require__(2190)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-628c622f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628c622f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[(_vm.gcid_cm == '303')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"10","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_cm === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_cm !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(765);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fefe52aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(2198);
function injectStyle (ssrContext) {
  __webpack_require__(2193)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fefe52aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fefe52aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254a6b30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashGreek_vue__ = __webpack_require__(2195);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254a6b30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΠΙΚΟΙΝΩΝΗΣΤΕ ΜΑΖΙ ΜΑΣ ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("CUTEMOBI")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΔΙΑΓΡΑΦΗ ΑΠΟ ΤΗΝ CUTEMOBI")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην περίπτωση που επιθυμείτε τη διαγραφή σας από κάποια υπηρεσία της MOBIVAS, μπορείτε να\n                        ακολουθήσετε μία από τις παρακάτω διαδικασίες:\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(ι.) Να αποστείλετε την λέξη STOP CUTE στον κωδικό 54006 ή στο 54124 με κόστος απλού τυπικού\nμηνύματος που διαφοροποιείται με βάση τον πάροχο κινητής τηλεφωνίας, που έχετε επιλέξει")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στη συνέχεια, θα λάβετε άμεσα δωρεάν μήνυμα από το 54303 το οποίο θα επιβεβαιώνει την διαγραφή\nσας από την υπηρεσία/ες. Ο συγκεκριμένος κωδικός 54303 χρησιμοποιείται μόνο για την αποστολή\nδωρεάν ενημερωτικών μηνυμάτων από την υπηρεσία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(ii.) Να καλέσετε στο 2111881795 (απλή χρέωση από οποιοδήποτε σταθερό τηλέφωνο):")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("-Επιλέγοντας (1) και αφού ακολουθήσετε τις ηχογραφημένες οδηγίες διαγράφεστε από την Υπηρεσία.(24ωρη Εξυπηρέτηση)")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("-Επιλέγοντας (2) θα εξυπηρετηθείτε από έναν αντιπρόσωπό μας, προκειμένου να γίνει η διαγραφή σας\n(Ώρες Εξυπηρέτησης: 10π.μ. ως 6μ.μ)")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI, στην Ελλάδα υποστηρίζεται από την MOBIVAS Μονοπρόσωπη ΙΚΕ μέσω των\n5ψηφίων κωδικών της και της τεχνικής υποδομής της.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορείτε επίσης να επικοινωνήσετε και μέσω email στο support@mobivas.gr")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66daca0d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashEnglish_vue__ = __webpack_require__(2197);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66daca0d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGRPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("UNSUBSCRIBE FROM "),_c('span',{staticClass:"redtext"},[_vm._v("FUNPLUS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you wish to unsubscribe from any PAYDASH service, you may follow one of the following procedures:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(i.) Send the word "),_c('span',{staticClass:"redtext"},[_vm._v("STOP CUTE")]),_vm._v(" to the code "),_c('span',{staticClass:"redtext"},[_vm._v("54006 or 54124")]),_vm._v(" with a standard text message charge, which may vary depending on your mobile phone operator. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You will, subsequently, receive a free message from 54303, which will confirm the termination of your subscription from the service(s). This specific code 54303 is only used to deliver free informative messages by the service.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(ii.) Call at 2111881788 (standard charge from any landline): ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("- By choosing option (1) and after you follow the recorded instructions, you unsubscribe from the service (24hour Customer Support ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("- By choosing option (2) one of our agents will assist you, in order to complete the termination of your subscription (Customer Support: 10 am to 6pm) ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Service "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI ")]),_vm._v(" in Greece is supported by PAYDASH Single Person PC via its 5 digit codes and technical connection.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You can also contact us via email to c.support@paydash.gr ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),(_vm.country_code_cm == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('contact-paydash-greek')],1):_c('span',[_c('contact')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(766);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b72d9d42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(2201);
function injectStyle (ssrContext) {
  __webpack_require__(2200)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b72d9d42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b72d9d42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(767);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8a17668_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(2204);
function injectStyle (ssrContext) {
  __webpack_require__(2203)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8a17668"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8a17668_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(768);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f60fcf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2213);
function injectStyle (ssrContext) {
  __webpack_require__(2206)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f60fcf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f60fcf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4606de70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashGreek_vue__ = __webpack_require__(2209);
function injectStyle (ssrContext) {
  __webpack_require__(2208)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4606de70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. ΣΚΟΠΟΣ ΤΗΣ ΠΟΛΙΤΙΚΗΣ ΑΠΟΡΡΗΤΟΥ ΚΑΙ ΠΕΔΙΟ ΕΦΑΡΜΟΓΗΣ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η ανώνυμη εταιρεία με την επωνυμία Puretech Global Limited εδρεύει επί του Χονγκ Κονγκ (Unit\n2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,Mongkok, Kowloon) Εφεξής, στην\nπαρούσα θα καλείται χάριν συντομίας, η «Εταιρεία».")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην παρούσα Πολιτική Απορρήτου περιγράφονται ο τρόπος συλλογής και επεξεργασίας των\nπροσωπικών δεδομένων που λαμβάνουμε, μέσω διαδικτύου ή με άλλους τρόπους και οι πρακτικές\nαπορρήτου της Εταιρείας, η οποία δεσμεύεται να προστατεύει και να επεξεργάζεται νόμιμα τα\nπροσωπικά δεδομένα, σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων της ΕΕ 679/2016\n(ΓΚΠΔ) και τους εφαρμόσιμους αυτού Νόμους. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η εταιρεία απευθύνεται σε ενήλικο κοινό. Δεν συλλέγουμε προσωπικές πληροφορίες από κανένα\nπρόσωπο, το οποίο γνωρίζουμε ότι είναι κάτω των 18 ετών χωρίς την προηγούμενη επαληθεύσιμη\nσυγκατάθεση του ασκούντος την γονική μέριμνα. Ο ασκών τη γονική μέριμνα έχει το δικαίωμα,\nύστερα από αίτημά του, να ενημερωθεί για τις πληροφορίες που δόθηκαν από τον ανήλικο και/ή\nνα ζητήσει την διαγραφή τους. Εάν αντιληφθούμε ότι ένα άτομο που υποβάλλει τα προσωπικά του\nδεδομένα είναι μικρότερο των 18 ετών θα προβούμε στη διαγραφή τους το συντομότερο δυνατό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η παρούσα Πολιτική Απορρήτου ενσωματώνεται και υπόκειται στους ‘’ Γενικούς Όρους &\nΠροϋποθέσεις’’ στην ιστοσελίδα της Εταιρείας. Η Εταιρεία διεξάγει τις δραστηριότητές της μέσω\nτου ιστότοπου https://www.puretechglobal.com/")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. ΟΡΙΣΜΟΙ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα προσωπικά δεδομένα είναι πληροφορίες που μπορούν να σχετίζονται με ένα άτομο – φυσικό\nπρόσωπο. Τα δεδομένα θεωρούνται προσωπικά εάν ταυτοποιείται το πρόσωπο το οποίο αφορούν. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κατάρτιση προφίλ είναι μια συλλογή δεδομένων που επιτρέπει την εκτίμηση των χαρακτηριστικών\nενός ατόμου και συνεπώς σημαντικών πτυχών της προσωπικότητάς του.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το υποκείμενο δεδομένων είναι φυσικό πρόσωπο στο οποίο αφορούν τα προσωπικά δεδομένα.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η επεξεργασία δεδομένων είναι οποιαδήποτε δραστηριότητα που περιλαμβάνει προσωπικά\nδεδομένα, ανεξάρτητα από τα μέσα και τη διαδικασία που εφαρμόζεται, π.χ. η συλλογή,\nαποθήκευση, χρήση, αναθεώρηση, αποκάλυψη, αρχειοθέτηση, προβολή και καταστροφή\nπροσωπικών δεδομένων.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ως διαβίβαση νοείται η πρόσβαση στα προσωπικά δεδομένα, για παράδειγμα επιτρέποντας\nπρόσβαση, μετάδοση ή δημοσίευση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο υπεύθυνος επεξεργασίας είναι το νομικό πρόσωπο που αποφασίζει για το σκοπό, το περιεχόμενο\nκαι τη διαδικασία επεξεργασίας δεδομένων προσωπικού χαρακτήρα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο εκτελών την επεξεργασία είναι ένα φυσικό ή νομικό πρόσωπο που επεξεργάζεται δεδομένα\nπροσωπικού χαρακτήρα σύμφωνα με τις οδηγίες του υπεύθυνου επεξεργασίας δεδομένων.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. ΣΚΟΠΟΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα προσωπικά δεδομένα υποβάλλονται σε επεξεργασία μόνο για τον σκοπό που υποδεικνύεται\nκατά τη στιγμή της συλλογής, ή για το σκοπό που προβλέπεται από το νόμο. Οι πληροφορίες που\nσυλλέγουμε, τα προσωπικά δεδομένα, μας βοηθούν να δημιουργήσουμε ή να βελτιώσουμε τη\nσχέση μας μαζί σας και να εξατομικεύουμε και να βελτιώνουμε διαρκώς την εμπειρία σας με την\nΕταιρεία μας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η επεξεργασία των προσωπικών δεδομένων γίνεται νόμιμα κα καλόπιστα και τα δεδομένα που\nσυλλέγονται ή αποθηκεύονται είναι απαραίτητα για την εκπλήρωση του σκοπού της επεξεργασίας\nτους, η οποία η Εταιρεία διασφαλίζει ότι είναι νόμιμη και συνεπής με το σκοπό για τον οποίο\nσυλλέχθηκαν.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. ΕΙΔΗ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΣΥΛΛΕΓΟΝΤΑΙ ΚΑΙ ΤΡΟΠΟΙ ΣΥΛΛΟΓΗΣ ΤΟΥΣ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΠΟΙΑ ΠΡΟΣΩΠΙΚΑ ΔΕΔΟΜΕΝΑ ΣΥΛΛΕΓΟΥΜΕ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το είδος προσωπικών δεδομένων που μπορεί να συλλεχθούν συμπεριλαμβάνει το πλήρες\nονοματεπώνυμό σας, την ηλεκτρονική σας διεύθυνση, πληροφορίες χρέωσης ή αριθμό κινητού\nτηλεφώνου και παρόμοια δεδομένα, όπως αυτά μπορεί να ζητηθούν ανά διαστήματα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Συλλέγουμε τα προσωπικά σας δεδομένα είτε επειδή εσείς μας τα παρέχετε, είτε με αυτόματα\nμέσα. Πιο συγκεκριμένα: ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Α. ΠΛΗΡΟΦΟΡΙΕΣ ΠΟΥ ΜΑΣ ΠΑΡΕΧΕΤΕ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Συλλέγουμε προσωπικά δεδομένα από εσάς όταν υποβάλλετε με δική σας πρωτοβουλία\nπληροφορίες σε εμάς και συγκεκριμένα, όταν:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"mobitxt"},[_vm._v("πραγματοποιείτε εγγραφή στον ιστότοπό μας για λήψη ψυχαγωγικού περιεχομένου κινητών\nτηλεφώνων, όπως αστρολογικές προβλέψεις, ήχους ειδοποιήσεων, παιχνίδια, φωτογραφίες,\nειδήσεις και άλλα αντικείμενα,")]),_vm._v(" "),_c('li',{staticClass:"mobitxt"},[_vm._v("πραγματοποιείτε σύνδεση επιλέγοντας τις λήψεις αρχείων της Εταιρείας χωρίς εγγραφή στην\nτοποθεσία https://www.puretechglobal.com/, όπως για Μεμονωμένες Λήψεις ή Συνδρομές\nμέσω SMS χρησιμοποιώντας το κινητό σας τηλέφωνο,")]),_vm._v(" "),_c('li',{staticClass:"mobitxt"},[_vm._v("δηλώνετε συμμετοχή σε δραστηριότητες όπως κληρώσεις λαχνών, διαγωνισμούς, παιχνίδια,\nέρευνες, φόρουμ, ")]),_vm._v(" "),_c('li',{staticClass:"mobitxt"},[_vm._v("υποβάλλετε απόψεις, ιδέες, ή προτάσεις σε εμάς ή μέσω συνομιλιών μας,")]),_vm._v(" "),_c('li',{staticClass:"mobitxt"},[_vm._v("μας τα μεταφέρουν αξιόπιστα τρίτα μέρη με τα οποία συνεργαζόμαστε για την επίτευξη του\nσκοπού για τον οποίο υποβάλλατε τα προσωπικά σας δεδομένα καθώς και από δημόσιες\nβάσεις δεδομένων.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Β. ΠΛΗΡΟΦΟΡΙΕΣ ΠΟΥ ΣΥΛΛΕΓΟΥΜΕ ΜΕ ΑΥΤΟΜΑΤΑ ΜΕΣΑ - COOKIES")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα cookies είναι πληροφορίες οι οποίες τοποθετούνται αυτόματα σε προκαθορισμένο φάκελο στον\nυπολογιστή σας κάθε φορά που μπαίνετε σε συγκεκριμένες ιστοσελίδες. Τα cookies συμβάλλουν\nστο να διακρίνουν μοναδικά τον υπολογιστή σας στον διακομιστή. Μας επιτρέπουν να συλλέγουμε\nπληροφορίες σε σχέση με τον διακομιστή ώστε να σας βοηθήσουμε να κινηθείτε καλύτερα στο\nδιαδίκτυο, καθώς και για να μπορέσουμε να αναλύσουμε την ιστοσελίδα και να ελέγξουμε την\nλειτουργία της. Η Εταιρεία χρησιμοποιεί cookies για να αναγνωρίσει το πρόγραμμα περιήγησής σας\nστο διαδίκτυο, να προσδιορίσει εάν έχετε εγκαταστήσει το λογισμικό ενεργοποίησης που \nαπαιτείται για πρόσβαση σε συγκεκριμένο υλικό στις τοποθεσίες μας στο διαδίκτυο, να\nπροσδιορίσει το συνολικό αριθμό επισκεπτών και να σας αναγνωρίσει όταν επιστρέψετε στον\nιστότοπο της Εταιρείας. Πληροφορίες σχετικά με τις δραστηριότητές σας στον ιστότοπό μας και\nάλλα μη προσωπικά δεδομένα σας, μπορεί επίσης να χρησιμοποιηθούν, για τον περιορισμό των\nηλεκτρονικών διαφημίσεων που συναντάτε, σε εκείνες που πιστεύουμε πως είναι σύμφωνες με τα\nενδιαφέροντά σας. Τα cookies μπορούν να αποθηκεύσουν τον κωδικό πρόσβασής σας για εύκολη\nσύνδεση σε μια τοποθεσία, την οποία έχετε προηγουμένως επισκεφθεί ή μπορούν να\nαποθηκεύσουν τις προτιμήσεις σας για να σας οδηγήσουν σε μια προσαρμοσμένη σε αυτές\nιστοσελίδα.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα cookies και άλλα μέσα αναγνώρισης δεν συλλέγουν αναγνωρίσιμες πληροφορίες για το άτομό\nσας αυτόματα. Μόνο στην περίπτωση που εθελοντικά υποβάλλετε αναγνωρίσιμη πληροφορία,\nόπως αίτηση εγγραφής ή αποστολή ηλεκτρονικού μηνύματος. Τότε τα αυτόματα μέσα θα\nχρησιμοποιηθούν για να δώσουν περαιτέρω πληροφορίες σχετικά με την χρήση που κάνετε στις\nιστοσελίδες και/ή τα διαδραστικά (Interactive) ηλεκτρονικά μηνύματα με απώτερο σκοπό την\nαύξηση της χρησιμότητάς τους για εσάς.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα περισσότερα προγράμματα περιήγησης (browsers) είναι προγραμματισμένα να δέχονται\ncookies, παρόλα αυτά μπορείτε να ρυθμίσετε το δικό σας πρόγραμμα περιήγησης έτσι ώστε να\nαρνείται την λήψη αυτών ή να σας ειδοποιεί κάθε φορά που λαμβάνετε ένα cookie. Επισημαίνουμε\nότι ορισμένα μέρη της ιστοσελίδας μας μπορεί να μην λειτουργήσουν σωστά σε περίπτωση που\nέχετε απορρίψει τα cookies, με αποτέλεσμα να μην έχετε πρόσβαση σε ορισμένες δυνατότητες.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Είναι πιθανό να εμφανίζονται διαφημίσεις τρίτων στην διαδικτυακή τοποθεσία της Εταιρείας, οι\nοποίες μπορεί, επίσης, να περιέχουν cookies που ορίζονται από τον διαφημιστή ή τον\nδιαφημιζόμενο, τα οποία η εταιρεία μας δεν ελέγχει. Συνεπώς, θα πρέπει να ελέγξετε την πολιτική\nαπορρήτου του διαφημιστή ή διαφημιζόμενου, προκειμένου να διαπιστώσετε εάν κάνει χρήση\ncookies και με ποιον τρόπο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ενδέχεται να χρησιμοποιήσουμε cookies και παρόμοια εργαλεία για να συσχετίσουμε τη χρήση του\nιστότοπού μας από εσάς με προσωπικά δεδομένα που λαμβάνονται από εσάς ή ένα αξιόπιστο τρίτο\nμέρος, συνεργάτη μας. Για παράδειγμα, εάν μας έχετε ζητήσει να σας στείλουμε πληροφορίες\nσχετικά με μελλοντικά προϊόντα ή προωθητικές ενέργειές μας, cookies ή/και ιστορικό περιήγησης\nστο διαδίκτυο σχετικά με τις δραστηριότητές σας στον ιστότοπό μας μπορεί να μας επιτρέψουν να\nπεριορίσουμε το υλικό που σας παρέχουμε σε αυτό που θεωρούμε ότι θα βρείτε ενδιαφέρον, με\nβάση τις προηγούμενες ηλεκτρονικές σας δραστηριότητες και προτιμήσεις. Ωστόσο, εάν η εταιρεία\nεπιθυμεί να συνδυάσει τα προσωπικά σας δεδομένα και cookies ή πληροφορίες ιστορικού\nπεριήγησης στο διαδίκτυο με αυτόν τον τρόπο, θα λάβουμε τη ρητή συγκατάθεσή σας. \n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επιπλέον, οι τεχνικές υπηρεσίες και άλλες υπηρεσίες της Εταιρείας ή συνεργάτες μας μπορεί να\nσυλλέγουν πληροφορίες σχετικά με τους επισκέπτες της ιστοσελίδας της Εταιρείας αυτόματα με\nσκοπό την συντήρηση, τη βελτίωση, ασφάλεια και άλλες νόμιμες αιτίες. Τέτοιες πληροφορίες\nμπορεί να περιλαμβάνουν τη διεύθυνση IP επισκεπτών, τον τύπο προγράμματος περιήγησης, την\nημερομηνία, την ώρα και τη διάρκεια της επίσκεψης και συγκεκριμένες σελίδες που\nεπισκεφθήκατε. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. ΠΡΑΚΤΙΚΕΣ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΣΧΕΤΙΚΑ ΜΕ ΤΗ ΣΥΛΛΟΓΗ ΤΩΝ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΚΑΙ ΠΑΡΟΧΗ\nΕΝΗΜΕΡΩΣΗΣ ΤΩΝ ΥΠΟΚΕΙΜΕΝΩΝ\n")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διασφαλίζει ότι, όταν της παρέχετε προσωπικά δεδομένα σας, έχετε ενημερωθεί σχετικά\nμε το ποιος συλλέγει τις πληροφορίες, τον τρόπο και τον σκοπό συλλογής αυτών, καθώς και με το \nείδος της χρήσης των πληροφοριών αυτών από την Εταιρεία. Όταν παρέχετε τα προσωπικά\nδεδομένα σας, η Εταιρεία θα σας ειδοποιεί σχετικά με τις επιλογές σας αναφορικά με τη χρήση των\nπροσωπικών δεδομένων σας, συμπεριλαμβανομένης ενδεχόμενης κοινής χρήσης αυτών από εμάς\nμε τρίτες εταιρείες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην παρούσα Πολιτική περιγράφονται τα είδη των άλλων εταιρειών που μπορεί να επιθυμούν\nαποστολή πληροφοριών προς εσάς σχετικά με τα προϊόντα και υπηρεσίες τους και επομένως\nεπιθυμούν να μοιραστούν τα προσωπικά δεδομένα σας, με την προϋπόθεση πως έχετε δώσει στην\nΕταιρεία την ρητή σας συγκατάθεση για να το πράξει.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην περίπτωση που τα προσωπικά δεδομένα των υποκειμένων συλλέγονται χειροκίνητα ή με\nτρόπο μη συνδεόμενο με το διαδίκτυο, όπως μέσω ταχυδρομικής κάρτας ή φόρμας συνδρομής, η\nαναλυτική ειδοποίηση δεν είναι εφικτή, και προκειμένου η Εταιρεία να λάβει τη ρητή συγκατάθεση\nτων υποκειμένων εφαρμόζεται η αποστολή μίας σύντομης ειδοποίησης που τους περιγράφει τον\nτρόπο λήψης του πλήρους κειμένου της παρούσας Πολιτικής και άλλων σχετικών πληροφοριών\nαπό εμάς. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο ιστότοπος της Εταιρείας μπορεί να περιέχει σύνδεσμο που οδηγεί στους ιστότοπους άλλων\nεταιρειών. Ορισμένες από αυτές τις τοποθεσίες τρίτων μπορεί να φέρουν λογότυπο της Εταιρείας\nμας ακόμη και αν δεν τους διαχειριζόμαστε και δεν εξαρτώνται από εμάς.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στον ιστότοπο της Εταιρείας ενδέχεται να εμφανίζονται διαφημίσεις άλλων εταιρειών. Η Εταιρεία\nδεν φέρει ευθύνη για τις πρακτικές τρίτων μερών ή για τις πολιτικές απορρήτου τρίτων μερών ή\nτοπικών διαφημιστικών εταιρειών στο Internet, στων οποίων την ιστοσελίδα μπορείτε να\nμεταφερθείτε μέσω συνδέσμου που εμφανίζεται στον ιστότοπο της Εταιρείας μας. Όταν\nαπομακρυνθείτε από την τοποθεσία της Εταιρείας μέσω ενός τέτοιου συνδέσμου ή με κλικ σε μια\nδιαφήμιση, θα πρέπει να ελέγξετε την ισχύουσα πολιτική απορρήτου του τρίτου μέρους ή\nτοποθεσίας διαφημιστή, ώστε να προσδιορίσετε τον τρόπο που θα χειριστούν οποιαδήποτε\nπροσωπικά δεδομένα συλλέξουν από εσάς. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο ιστότοπος της Εταιρείας μπορεί, επίσης, να συνδέεται με τοποθεσίες που λειτουργούν από\nσχετιζόμενες εταιρείες με την Εταιρεία μας, όπως εταιρείες που είναι μέλη του Ομίλου της\nΕταιρείας. Αν και τα μέλη του Ομίλου της Εταιρείας τηρούν τους κανόνες του Ομίλου, τα\nυποκείμενα των προσωπικών δεδομένων που επισκέπτονται αυτές τις σχετιζόμενες με εμάς\nτοποθεσίες θα πρέπει να ανατρέχουν στις ξεχωριστές πολιτικές απορρήτου και πρακτικές τους, οι\nοποίες ενδέχεται να διαφέρουν σε ορισμένα θέματα από την παρούσα Πολιτική. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. ΧΡΗΣΗ/ΕΠΕΞΕΡΓΑΣΙΑ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΑΠΟ ΤΗΝ ΕΤΑΙΡΕΙΑ ΚΑΙ ΔΙΑΒΙΒΑΣΗ ΣΕ ΤΡΙΤΑ\nΜΕΡΗ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία θα χρησιμοποιήσει τα προσωπικά δεδομένα που της παρέχετε με τρόπο που συμφωνεί\nμε την παρούσα Πολιτική και αποκλειστικά και μόνο για τους σκοπούς για τους οποίους\nυποβλήθηκαν και δεν θα τα διαβιβάσει σε τρίτα μέρη που δεν σχετίζονται και συνεργάζονται με\nαυτή, εκτός εάν λάβει την ρητή συγκατάθεσή σας. Εάν η Εταιρεία λάβει προσωπικά δεδομένα από\nένα τρίτο μέρος, όπως έναν συνεργάτη, η χρήση των πληροφοριών από την Εταιρεία θα διέπεται\nαπό την παρούσα Πολιτική. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί να χρησιμοποιήσει τα προσωπικά δεδομένα που της χορηγήσατε κατά την\nεγγραφή σας για να σας στείλει σημαντικές πληροφορίες και ενημερώσεις σχετικά με τον\nλογαριασμό σας και τις υπηρεσίες που ζητήσατε να σας παρέχει. Επιπλέον, όταν η Εταιρεία\nσυλλέγει προσωπικά δεδομένα από το ίδιο το υποκείμενο κατά την υποβολή αιτήματός του για ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("λήψη αρχείων και υπηρεσιών από την Εταιρεία, η Εταιρεία θα επεξεργαστεί το αίτημα συνδρομής\nή παροχής υπηρεσίας προς το υποκείμενο, συμπεριλαμβανομένης της επεξεργασίας εκπλήρωσης\nπαραγγελίας και πληρωμής, εάν υπάρχει. Στις περιπτώσεις αυτές, η Εταιρεία δεν θα μοιραστεί τα\nστοιχεία με τρίτα μέρη, εκτός από εκείνα που η Εταιρεία χρησιμοποιεί για την εκτέλεση εργασιών\n(όπως εκπλήρωση παραγγελίας και επεξεργασία πληρωμής), απαραίτητα για την ολοκλήρωση\nαγορών που πραγματοποιεί το υποκείμενο των δεδομένων και συνδρομών που αιτείται μέσω του\nhttps://www.puretechglobal.com/")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τρίτος, εκτελών την επεξεργασία για λογαριασμό της Εταιρείας, π.χ. ένας εργολάβος ή πάροχος\nυπηρεσιών, πρέπει να συμφωνήσει συμβατικά για την επεξεργασία προσωπικών δεδομένων\nσύμφωνα με την παρούσα πολιτική. Οι όροι αυτής της πολιτικής συμπεριλαμβάνονται στις σχετικές\nσυμβάσεις.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δεδομένα προσωπικού χαρακτήρα αποκαλύπτονται σε τρίτους μόνον εφόσον είναι απαραίτητο\nή εφόσον το υποκείμενο χορηγήσει τη ρητή συγκατάθεσή του. Τα δεδομένα προσωπικού\nχαρακτήρα πρέπει να παρέχονται ανωνύμως, εφόσον κρίνεται σκόπιμο.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί επίσης, να κάνει χρήση των προσωπικών δεδομένων στο σύνολό τους, ανώνυμα,\nγια ερευνητικούς σκοπούς.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επίσης, μια συνεργαζόμενη εταιρεία μπορεί να προσφέρει λήψεις δεδομένων και αρχείων στα\nυποκείμενα για λογαριασμό της Εταιρείας, συλλέγοντας προσωπικά δεδομένα εκ μέρους της\nΕταιρείας, όταν τα υποκείμενα πραγματοποιούν εγγραφή στην τοποθεσία gr.cutemobi.vip/264p2\nή συνδέονται για μεμονωμένες λήψεις αρχείων και υπηρεσιών μέσω του κινητού τηλεφώνου τους.\nΗ συνεργαζόμενη εταιρεία παρέχει σε εμάς τα προσωπικά δεδομένα που χρειάζεται για να σας\nπροσφέρει λήψεις πληροφοριών και αρχείων της εταιρείας και άλλες υπηρεσίες που έχετε αιτηθεί.\nΗ συνεργάτης εταιρεία της ΕΤΑΙΡΕΙΑΣ παρέχει επίσης στον πάροχο κινητής τηλεφωνίας σας τις\nπληροφορίες που χρειάζεται για να σας χρεώσει για τις λήψεις πληροφοριών και αρχείων και για\nάλλες υπηρεσίες που αγοράσατε.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί να μοιραστεί τα προσωπικά δεδομένα σας με εταιρείες που σχετίζονται και\nσυνεργάζονται μαζί της ή αποτελούν μέρος του Ομίλου της Εταιρείας για την επίτευξη του σκοπού\nτης επεξεργασίας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κάθε υπάλληλος της Εταιρείας εκπαιδεύεται σε θέματα προστασίας δεδομένων και ασφάλειας\nδεδομένων. Οι υπάλληλοι, αντιπρόσωποι και συνεργάτες της Εταιρείας πρέπει να έχουν ένα νόμιμο\nλόγο για την απόκτηση πρόσβασης στα προσωπικά δεδομένα σας. Η Εταιρεία ενδέχεται να\nμοιραστεί τα προσωπικά δεδομένα σας με εξωτερικούς συνεργάτες ή αντιπροσώπους που την\nβοηθούν να διαχειριστεί τις πληροφοριακές δραστηριότητές της (π.χ. διαχείριση κλήρωσης λαχνών,\nεκπλήρωση παραγγελιών, στατιστικές αναλύσεις) αλλά μπορούν να χρησιμοποιήσουν τα\nπροσωπικά δεδομένα σας μόνο για να παρέχουν στην Εταιρεία συγκεκριμένη υπηρεσία και όχι για\nοποιονδήποτε άλλο σκοπό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία μπορεί να συμβληθεί με τρίτες εταιρείες που κατέχουν την τεχνολογία που επιτρέπει\nστην Εταιρεία να προσαρμόσει τα διαφημιστικά και μάρκετινγκ μηνύματα που λαμβάνετε στις\nτοποθεσίες της Εταιρείας στο διαδίκτυο. Τα μη προσωπικά δεδομένα σας και το ιστορικό\nπεριήγησης στο διαδίκτυο σχετικά με τις δραστηριότητές σας στις τοποθεσίες αυτές μπορεί να\nμοιράζονται με αυτές τις εταιρείες, έτσι ώστε αυτή η προσαρμογή να μπορεί να επιτευχθεί. Αυτές\nοι εταιρείες δεν θα μοιραστούν τις πληροφορίες σας με οποιοδήποτε τρίτο μέρος, ούτε θα τις\nχρησιμοποιήσουν για οποιονδήποτε άλλο σκοπό. Ενδέχεται όμως να γίνει χρήση, ανώνυμα, του \nιστορικού περιήγησης και άλλων δημογραφικών πληροφοριών αποκλειστικά για διαφημιστικούςστατιστικούς σκοπούς από την Εταιρεία ή τους επιχειρηματικούς συνεργάτες της.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. ΔΙΑΣΥΝΟΡΙΑΚΗ ΑΠΟΚΑΛΥΨΗ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δεδομένα προσωπικού χαρακτήρα αποκαλύπτονται στο εξωτερικό μόνο εάν ο αλλοδαπός νόμος\nπροβλέπει επαρκές επίπεδο προστασίας των δεδομένων. Σε περίπτωση που ο αλλοδαπός νόμος\nδεν παρέχει επαρκές επίπεδο προστασίας δεδομένων, τα δεδομένα προσωπικού χαρακτήρα\nμπορούν να μεταφερθούν σε αυτή τη χώρα μόνον εάν το πρόσωπο στο οποίο αναφέρονται τα\nδεδομένα έχει συναινέσει ρητά στη μεταφορά ή εάν η προστασία δεδομένων προβλέπεται από την\nκατάλληλη συμφωνία περί μεταφοράς δεδομένων.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. ΑΠΟΚΑΛΥΨΗ ΤΩΝ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορεί να υπάρχουν περιπτώσεις που η Εταιρεία θα αποκαλύψει προσωπικά δεδομένα χωρίς να\nσας προσφέρει επιλογή, ώστε να προστατεύσει τα νόμιμα δικαιώματά της, άλλων εταιρειών εντός\nτου Ομίλου της Εταιρείας ή των υπαλλήλων, αντιπροσώπων και συνεργατών της, για προστασία\nτης ασφάλειας των επισκεπτών του ιστότοπού της, για προστασία έναντι απάτης ή για λόγους\nδιαχείρισης κινδύνου, δημόσιας τάξης και ασφάλειας, εθνικού συμφέροντος ή για συμμόρφωση με\nτις διατάξεις της νομοθεσίας ή τις νόμιμες διαδικασίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. ΜΕΤΑΒΙΒΑΣΗ ΕΤΑΙΡΕΙΑΣ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην περίπτωση που η Εταιρεία πωλήσει μέρος ή όλη την επιχείρησή της ή πραγματοποιήσει μια\nπώληση ή μεταφορά περιουσιακών στοιχείων ή εμπλακεί γενικότερα σε μια συγχώνευση ή\nμεταφορά επιχείρησης, η Εταιρεία μπορεί να μεταφέρει τα προσωπικά δεδομένα σας σε ένα τρίτο\nμέρος ως τμήμα αυτής της συναλλαγής. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. ΑΠΟΘΗΚΕΥΣΗ ΚΑΙ ΔΙΑΤΗΡΗΣΗ ΔΕΔΟΜΕΝΩΝ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δεδομένα προσωπικού χαρακτήρα αποθηκεύονται για όσο χρόνο απαιτείται για την εκπλήρωση\nτου σκοπού για τον οποίο συλλέχθηκαν και για όσο χρόνο απαιτείται από το νόμο. Τα στοιχεία της\nαποθήκευσης δεδομένων και των περιόδων διατήρησης καθορίζονται στην Πολιτική Διατήρησης\nΔεδομένων της Εταιρείας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. ΑΣΦΑΛΕΙΑ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία λαμβάνει όλα τα ενδεικνυόμενα από την σύγχρονη τεχνολογία, οργανωτικά και φυσικά\nμέτρα για την διαφύλαξη των προσωπικών δεδομένων που βρίσκονται στην κατοχή της έναντι\nαπώλειας, κλοπής και μη εξουσιοδοτημένης χρήσης, αποκάλυψης ή τροποποίησης με στόχο την\nεξασφάλιση της ακεραιότητας, της εμπιστευτικότητας και της διαθεσιμότητάς τους. Επιπλέον, η\nΕταιρεία χρησιμοποιεί εύλογες μεθόδους για να βεβαιωθεί πως τα προσωπικά δεδομένα είναι\nακριβή, ενημερωμένα και κατάλληλα συμπληρωμένα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. ΔΙΚΑΙΩΜΑΤΑ ΤΩΝ ΥΠΟΚΕΙΜΕΝΩΝ ΤΩΝ ΔΕΔΟΜΕΝΩΝ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κάθε υποκείμενο δεδομένων έχει τα ακόλουθα δικαιώματα σύμφωνα με το ΓΚΠΔ τα οποία η\nεταιρεία σέβεται και προστατεύει: ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("α) Το δικαίωμα ενημέρωσης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("β) Το δικαίωμα πρόσβασης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("γ) Το δικαίωμα διόρθωσης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ε) Το δικαίωμα περιορισμού της επεξεργασίας,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("στ) Το δικαίωμα στη φορητότητα δεδομένων,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ζ) Το δικαίωμα αντίρρησης,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("η) Δικαιώματα σχετικά με την αυτοματοποιημένη λήψη αποφάσεων και τη δημιουργία προφίλ.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Εάν ζητήσετε από την Εταιρεία να διακόψει την χρήση των προσωπικών δεδομένων σας, η Εταιρεία\nθα ικανοποιήσει αυτό το αίτημα, διατηρώντας μόνο τις πληροφορίες που είναι απαραίτητες για τη\nσυμμόρφωση με την ισχύουσα εθνική νομοθεσία.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μπορείτε να επικοινωνήσετε με την Εταιρεία για να ασκήσετε τα δικαιώματά σας και η Εταιρεία\nθα ανταποκριθεί σε εύλογο χρονικό διάστημα, όχι σε περισσότερο από 30 ημέρες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. ΤΡΟΠΟΠΟΙΗΣΗ ΟΡΩΝ ΤΗΣ ΠΟΛΙΤΙΚΗΣ ΑΠΟΡΡΗΤΟΥ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι παραπάνω όροι αποτελούν την πλήρη συμφωνία με την Εταιρεία, η οποία διατηρεί το δικαίωμα\nνα τροποποιεί ή να ανανεώνει ή να διαγράφει όλους τους όρους του παρόντος, χωρίς καμία\nπροειδοποίηση. Η τροποποίηση ή ανανέωση θα ισχύει από την στιγμή που θα ενημερωθεί σχετικά\nτο παρόν κείμενο για οποιαδήποτε αλλαγή. Επομένως, θα πρέπει να την εξετάζετε τακτικά ώστε να\nείστε ενήμεροι σχετικά με τις πλέον πρόσφατες πολιτικές και πρακτικές της Εταιρείας. Εάν η\nΕταιρεία αλλάξει ουσιωδώς τις πρακτικές της αναφορικά με τη συλλογή ή χρήση των προσωπικών\nδεδομένων σας, τα προσωπικά δεδομένα σας θα συνεχίσουν να διέπονται από την Πολιτική κάτω\nαπό την οποία έγινε η συλλογή τους, εκτός αν σας έχει παρασχεθεί σχετική ειδοποίηση και δεν\nπαρουσιάσατε καμία ένσταση έναντι της αλλαγής.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("14. ΤΡΟΠΟΙ ΕΠΙΚΟΙΝΩΝΙΑΣ ΓΙΑ ΤΗΝ ΕΠΙΛΥΣΗ ΘΕΜΑΤΩΝ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ\nΚΑΙ ΓΙΑ ΤΗΝ ΑΣΚΗΣΗ ΔΙΚΑΙΩΜΑΤΩΝ ΤΩΝ ΥΠΟΚΕΙΜΕΝΩΝ ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Για την άσκηση των δικαιωμάτων σας, όπως για την επίλυση θεμάτων απορρήτου, για θέματα\nσχετικά με τη συλλογή και επεξεργασία των προσωπικών δεδομένων σας από την Εταιρεία, για να\nαναθεωρήσετε, διορθώσετε ή διαγράψετε τα προσωπικά δεδομένα σας ή για να διακόψετε κάθε\nμελλοντική επικοινωνία μαζί μας μπορείτε να επικοινωνείτε με την εταιρεία μας στην ηλεκτρονική\nδιεύθυνση support@mobivas.gr ,με την εξυπηρέτηση πελατών τηλ. 2111881795 ή με επιστολή που\nαποστέλλετε στην έδρα της Εταιρείαςπου βρίσκονται στην Unit 2104, 21/F., Mongkok Commercial\nCentre, 16 Argyle Street, Mongkok, Kowloon, Χόνγκ Κόνγκ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3022e04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashEnglish_vue__ = __webpack_require__(2212);
function injectStyle (ssrContext) {
  __webpack_require__(2211)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3022e04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. PRIVACY POLICY PURPOSE AND SCOPE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The company under corporate name "),_c('span',{staticClass:"redtext"},[_vm._v("Puretech Global Limited")]),_vm._v(", has its head offices in "),_c('span',{staticClass:"redtext"},[_vm._v("Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,Mongkok, Kowloon, Hong Kong ")]),_vm._v("Hereinafter referred to as “Company”.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The present Privacy Policy describes the means for the collection and processing of the personal data that the Company receives, via the internet or otherwise, and the Company’s privacy practices. The Company commits to protect and process the personal data in a lawful manner, in accordance with the General Data Protection Regulation (EU) 2016/679 (GDPR) and the laws implementing it.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company is addressed to adults. The Company does not collect personal data for any person, known to the Company to be aged under 18 years, without the prior verifiable consent of the holder of parental responsibility over the child, who has the right to be informed regarding the information provided by the minor and/or to request its erasure. If Company becomes aware that the person who is submitting his/her personal data is under 18 years old, the Company shall erase said data as soon as possible.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The present Privacy Policy is incorporated and is subject to the General Terms and Conditions, which can be found at the Company's website. The Company conducts its business activities via its website "),_c('a',{attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v(" https://www.puretechglobal.com/")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. DEFINITIONS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Personal data means any information relating to an individual – natural person. The data are deemed personal if the person concerned can be identified. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Profiling means the collection of data, which facilitates the evaluation of a person’s characteristics and, consequently, significant aspects of his/her personality. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Data subject is the natural person to whom the personal data relate to. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Data processing means any activity involving personal data, irrespective of the means and the procedure applied, e.g., collection, recording, use, revision, disclosure, organization, projection and destruction of personal data. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Transmission means the access to personal data, for example by allowing access, broadcast or publication.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Controller means the legal entity that determines the purpose, the scope and the procedure of the processing of personal data.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Processor means a natural person or legal entity, which processes personal data following the controller’s instructions. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. PROCESSING PURPOSE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Personal data is processed only for the purpose determined at the time of the collection or for the purpose provided by law. The information collected, i.e. the personal data, enable us to establish or improve our relationship with you and to personalize and constantly enhance your experience with our Company. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The processing of the personal data is conducted in a lawful manner and in good faith and the data collected or stored are necessary, in order to fulfil the processing purpose; the Company ensures that said processing is lawful and consistent with the purpose that the data was collected for.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. CATEGORIES OF COLLECTED DATA AND MEANS OF COLLECTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("WHICH PERSONAL DATA WE COLLECTN")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The types of personal data that may be collected include your full name, your email address, billing information or mobile telephone number and related data, as may be requested for time to time.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("We collect your personal data either because you provide them to us or via automated means. More specifically:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("A. INFORMATION PROVIDED BY YOU")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("We collect personal data from you when you submit information to us, on your own initiative and, more specifically, when you:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('ul',{staticClass:"mobitxt"},[_c('li',[_vm._v("subscribe to our website, in order to receive recreational content for mobile phones, for example star sign predictions, notification sounds, games, pictures, news etc")]),_vm._v(" "),_c('li',[_vm._v("use the Company’s download links, without subscribing to "),_c('a',{attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v(" https://www.puretechglobal.com/")]),_vm._v(" for example for individual downloads or subscription via SMS through your mobile phone, ")]),_vm._v(" "),_c('li',[_vm._v("participate in activities, such as sweepstakes, competitions, games, surveys, fora,")]),_vm._v(" "),_c('li',[_vm._v("express your views, ideas or suggestions to us or through our communications,")]),_vm._v(" "),_c('li',[_vm._v("•\tthe personal data are delivered to us by reliable third parties that we cooperate with, in order to fulfil the purpose that you submitted your personal data for, as well as through public databases.")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("B. INFORMATION COLLECTED VIA AUTOMATED MEANS - COOKIES")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies are information, which is automatically placed in a predetermined file in your computer each time you visit specific websites. Cookies contribute to uniquely identify your computer to the server. They allow us to collect information relating to the server, in order to help you browse the internet better and to evaluate our website and test its function. The Company uses cookies to identify how you browse the internet, to determine whether you have downloaded the activation software, which is required in order to access specific material in our websites, to determine the total number of visitors and to identify you when you use the Company’s website again. Information pertaining to your activities in our website and other non-personal data may also be used, in order to limit the online advertisements to those we believe meet your interests. Cookies may save your access code, in order to provide easy access to a website that you have previously used or may save your preferences, in order to redirect you to a website adjusted to said preferences.   ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Cookies and other identifying means do not collect information that may be used to identify you automatically, unless you voluntarily submit such information, for example via a subscription request or by sending an email. In this event, the automated means will be used to deliver additional information regarding your use of the websites and/or the interactive emails, in order to render them more useful for you.    ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Most browsers are programmed to accept cookies. Nevertheless, you may adjust your browser’s settings to reject downloading them or to notify you each time you receive a cookie. Please be informed that some pages of our website may not function properly, if you reject cookies, and as a result you may not have access to specific applications.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Third party advertisements may appear in the Company’s website, which may also contain cookies; said cookies are determined by the advertiser or the advertised entity and the Company does not control them. Therefore, you should refer to the advertiser’s or the advertised entity’s privacy policy, in order to ascertain if they use cookies and how.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("We may use cookies and other similar means to associate your use of our website with personal data received by you or a by reliable third party, our associate. For example, if you have requested information in regard to future products or promotional activities of our Company, cookies and/or your browsing history in regard to your activities in our website, may allow us to limit the provided material to what we believe you may find interesting, based on your previous online activities and preferences. However, if the Company wishes to associate your personal data and cookies or information regarding your browsing history in the above manner, we will request your express consent. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Moreover, the technical department or other departments of our Company or our associates may automatically collect information regarding the visitors of the Company’s website for maintenance, improvement, security and other legitimately acceptable reasons. Such information may include the IP address of visitors, the browser type, the date, time and duration of the visit and specific pages that you have visited.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. COMPANY PRACTICES REGARDING PERSONAL DATA COLLECTION AND NOTICES TO THE SUBJECTS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company ensures that, when you provide personal data, you have been informed in regard to who collects the information, the means and the purpose of their collection, as well as the type of use of said information by the Company. When you provide your personal data, the Company will notify you about your options regarding their use, including any potential joint use of the data by the Company and third parties.   ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("This Privacy Policy describes the types of other companies that may wish to send you notifications about their products and services and, therefore, wish to share your personal data, under the condition that you have explicitly consented to the above.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("In the event that the subjects’ personal data are collected manually or by means not related to the internet, for example via a postal card or subscription form, a detailed notice is not possible and, in order for the Company to obtain the subjects’ express consent, the Company sends a brief notice, whereby it describes how the subjects may receive our entire Privacy Policy and other related information from us. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company’s website may contain a link to other companies’ websites. Some of these websites may have our Company’s logo, even if they are not operated by or depended on the Company. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company’s website may also have advertisements from other companies. The Company is not responsible for the practices of third parties or for the privacy policies of third parties or local advertising companies on the internet, where you may be redirected via a link that appears on the Company’s website. When redirected from the Company’s website via such link or by clicking on an advertisement, you should refer to the applicable privacy policy of the third party or the advertiser’s website to assess how they will handle any personal data collected from you. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company’s website may also be linked to websites operated by the Company’s affiliates, for example companies that are members of the Company’s Group. Although members of the Company Group abide by the rules of the Group, the subjects of the personal data should refer to the separate privacy policies and practices, which may differ in certain aspects from this Privacy Policy. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. USE/ PROCESSING OF PERSONAL DATA BY THE COMPANY AND TRANSFER TO THIRD PARTIES")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company will use the personal data that you provide according to this Privacy Policy and exclusively for the purposes that you provided them for and will not transfer them to any third parties that are not related or associated with it, unless you have provided your express consent.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If the Company receives personal data from a third party, such as a business partner, such information will be used by us in accordance with this Privacy Policy. \nThe Company may use the personal data that you provided during your registration, in order to send important information and notices regarding your account and the requested services. Furthermore, when the Company collects personal data from the subject itself, when the latter requested to receive files or services from the Company, the Company will process the request for assistance or service, including processing the completion of the order and the payment, if any. In these occasions, the Company will not share the data with third parties, with the exception of those that the Company uses to conduct its business (for example, the completion of the order and the payment processing), required to conclude purchases that are made by the subject and subscriptions that it has requested via "),_c('a',{staticClass:"redtext",attrs:{"href":"https://www.puretechglobal.com/"}},[_vm._v("https://www.puretechglobal.com/")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Any third party that undertakes the processing on behalf of the Company, for example a contractor or a service provider, is required to contractually agree to the processing of the personal data in accordance with this Privacy Policy. The terms of this Policy are included in the pertinent agreements.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The personal data are revealed to third parties only if necessary or if the subject expressly consents to it. The personal data should be provided anonymously, if deemed appropriate.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may, also, use all the personal data, in an anonymously, for research purposes.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Moreover, a Company ’s associate may offer the subjects downloads of data and files, by collecting personal data on behalf of the Company, when the subjects register at "),_c('span',{staticClass:"redtext"},[_vm._v("gr.funplus.world/264p2")]),_vm._v(" or log in for individual downloads of files and services via their mobile phone. The Company’s associate shares with the Company the personal data required, in order to offer you information and file downloads and other services you have requested. The Company’s associate also provides to your mobile phone operator the information required, in order to charge you for the information and file downloads and other services that you have purchased. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may share your personal data with companies that are associated or cooperating with it or belong to its Group of Companies, in order to fulfil the processing purpose.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("All Company’s employees are trained in personal data and data security issues. The employees, officers and associates of the Company should have legitimate reason, in order to access your personal data. The Company may share your personal data with outsource associates or agents, who assist us in managing our informational activities (for example managing sweepstakes’ tickets, completion of orders, statistical analyses), but can only use your personal data, in order to provide to the Company a specific service and not for any other purpose. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may enter into agreements with other companies that own the technology, which allows the Company to adjust the advertising and marketing messages you receive on the Company’s websites. Non-personal data and your browsing history data about your activities on these websites may be shared with these companies, in order to achieve this adjustment. These companies will not share your information with any third party nor use it for any other purpose. It is, nonetheless, possible for the browsing history and other demographic information to be used, anonymously, exclusively for advertising-statistical purposes by the Company or its business associates. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. CROSS-BOARDER PERSONAL DATA DISCLOSURE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The personal data are disclosed to a third country, only if the legislation of said country provides for sufficient protection of the data. If the legislation of the third country does not provide for sufficient protection of the data, the personal data may only be transferred to this country, if the subject has expressly consented to their transfer or if the data protection is provided for by an appropriate agreement regarding the transfer of data.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. PERSONAL DATA DISCLOSURE")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company may disclose personal data without offering you a choice, in order to protect its legitimate rights, the rights of other companies that belong to its Group of Companies or the rights of its employees, officers or associates, to safeguard the security of its website visitors, to be protected against fraud or for reasons relating to danger management, public order and security, public interest or in order to comply with the law or the legal procedures. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. COMPANY TRANSFER")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("In the event the Company transfers, in whole or in part, its business or sells or transfers assets or, in general, engages in a merger or transfer of its business, it may transfer your personal data to a third party as part of this transaction. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. DATA STORAGE AND RETENTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The personal data are stored for as long as it is required for the fulfilment of the purpose that they were collected for and for as long as it is required by law. The information relating to the storage of the personal data and the period of their retention are determined in the Data Retention Policy of the Company. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. SECURITY")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Company takes all measures indicated by modern technology, organizational and physical, in order to safeguard the personal data in its possession against loss, theft and unauthorized use, disclosure or modification, so as to ensure their integrity, confidentiality and availability. Furthermore, the Company applies reasonable methods to ensure that the personal data are accurate, updated and properly completed. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. DATA SUBJECTS’ RIGHTS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("All data subjects have the following rights, pursuant to GDPR, which the Company respects and protects:")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(a) right to be informed,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(b) right to access,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(c) right to rectification,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(d) right to erasure,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(e) right to restriction of processing,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(f) right to data portability,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(g) right to object,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("(h) rights relating to the automated decision-making and profiling.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you request the Company to discontinue the use of your personal data, the Company shall satisfy your request and shall maintain only the information necessary to comply with the national legislation. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You may contact the Company, in order to exercise your rights, and the Company shall respond in a timely manner, not exceeding 30 days. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. AMENDMENT OF THE PRIVACY POLICY PROVISIONS ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The above provisions represent the entire agreement with the Company, which has the right to amend or update or remove all provisions herein, without any notice. The amendment or update will be effective upon relevant modification of this document. Therefore, you should regularly refer to this Policy, in order to be informed about the Company’s latest policies and practices. If the Company materially changes its practices in regard to the collection and use of your personal data, said data will continue to be subject to the Policy that was applicable during their collection, unless you have been accordingly notified and did not object to said change. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("14. MEANS OF COMMUNICATION FOR THE RESOLUTION OF PERSONAL DATA ISSUES AND THE EXERCISE OF THE SUBJECTS’ RIGHTS")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("In order to exercise your rights, for example resolve a privacy issue, for issues relating to the collection and processing of your personal data by the Company, in order to revise, rectify or erase your personal data or to discontinue any future communication with us, you may contact the Company via the email address c.support@paydash.gr, by calling the customer service at 2111881788 or by sending a letter to the Company’s head offices at "),_c('span',{staticClass:"redtext"},[_vm._v("Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,\n                           Mongkok, Kowloon, Hong Kong")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.country_code_cm == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('privacy-paydash-greek')],1):_c('span',[(_vm.lang_cm == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_cm == 'malay')?_c('span'):(_vm.lang_cm == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_cm == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_cm == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_cm == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.lang_cm == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_cm == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_cm == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__(769);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d06f248_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__(2221);
function injectStyle (ssrContext) {
  __webpack_require__(2215)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d06f248"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d06f248_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4427be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashEnglish_vue__ = __webpack_require__(2217);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4427be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Five Digit short code: "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ABOUT YOUR SUBSCRIPTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI ")]),_vm._v(" offers recreational services, consisting of downloading content for adults.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Upon valid subscription and payment, you may download certain files in compatible mobile phones and compatible devices via  "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" .")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The members of "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" receive their personal link each week, which they may use to download different adult content such as videos and images.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v("is a weekly subscription. You will receive 3 to 12 chargeable messages (upon receipt), with a charge of 2,08€  or 0.52 each, per week, total charge of 6,24€ per week. "),_c('a',{attrs:{"href":"http://paydash.gr/pinakas-ypp/"}},[_vm._v(" Final SMS Price ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The weekly charge is received automatically via your mobile phone bill.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You should be aged 18 and over, in order to use one of the  "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" and have permission from the person that pays the mobile phone bill.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("COMMUNICATION ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Service "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" in Greece is supported by PAYDASH Single Person PC via its 5 digit codes and technical connection.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("For any queries regarding your subscription, please contact the customer service at 2111881788 or contact us via the email address c.support@paydash.gr. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you wish to discontinue your subscription to this service, you may send a text message from your mobile phone with the word "),_c('span',{staticClass:"redtext"},[_vm._v("STOP CUTE")]),_vm._v(" to the five-digit short code "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")]),_vm._v("  to which you were subscribed.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The text message that is sent by the subscriber to the 5digit code "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")]),_vm._v(", in order to discontinue the subscription, bears a standard charge, which may vary depending on the mobile phone operator. The confirmation regarding the termination of the subscription is sent to the subscriber, free of charge, via the code 54303")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ec58bd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashGreek_vue__ = __webpack_require__(2220);
function injectStyle (ssrContext) {
  __webpack_require__(2219)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ec58bd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqGRPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("CUTEMOBI")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Πενταψήφιος Κωδικός: 54006/54124")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΣΧΕΤΙΚΑ ΜΕ ΤΗ ΣΥΝΔΡΟΜΗ ΣΑΣ ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η CUTEMOBI παρέχει ψυχαγωγικές υπηρεσίες που συνίστανται στην λήψη περιεχομένου για ενήλικες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μετά από έγκυρη εγγραφή και πληρωμή, μπορείτε να λάβετε ορισμένα αρχεία σε συμβατά κινητά\nτηλέφωνα και συμβατές συσκευές μέσω της CUTEMOBI.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα μέλη της CUTEMOBI λαμβάνουν τον προσωπικό τους σύνδεσμο κάθε εβδομάδα, με τον οποίο\nμπορούν να κάνουν λήψη διαφορετικού περιεχομένου για ενήλικες όπως εικόνες και βίντεο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το CUTEMOBI είναι μια εβδομαδιαία συνδρομή. Θα λαμβάνετε τρία (3) έως δώδεκα (12) κατά την\nλήψη χρεώσιμα μηνύματα αξίας 2,08€ ή 0,52€ έκαστο εβδομαδιαίως, συνολική χρέωση: 6,24€ ανά\nεβδομάδα."),_c('a',{attrs:{"href":"http://paydash.gr/pinakas-ypp/"}},[_vm._v(" Τελική Τιμή Μηνύματος ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η εβδομαδιαία χρέωση λαμβάνεται αυτόματα μέσω του λογαριασμού του τηλεφώνου σας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Για να χρησιμοποιήσετε μία από τις υπηρεσίες CUTEMOBI, πρέπει να είστε 18 ετών και άνω και να\nέχετε την άδεια του ατόμου που πληρώνει τον λογαριασμό του κινητού τηλεφώνου. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΠΙΚΟΙΝΩΝΙΑ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI, στην Ελλάδα υποστηρίζεται από την MOBIVAS Μονοπρόσωπη ΙΚΕ μέσω των\n5ψηφίων κωδικών της και της τεχνικής υποδομής της.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Για όλες τις ερωτήσεις αναφορικά με τη συνδρομή σας, επικοινωνήστε με το τμήμα εξυπηρέτησης πελατών μας στο τηλ. 2111881788 ή επικοινωνήστε στην ηλεκτρονική διεύθυνση c.support@paydash.gr ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Εάν επιθυμείτε να διακόψετε τη συνδρομή σας από αυτήν την υπηρεσία, στείλτε μήνυμα από το κινητό\nσας με την λέξη STOP CUTE στον κωδικό πενταψήφιο αριθμό 54006/54124 όπου είχατε εγγραφεί")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Το μήνυμα διαγραφής που αποστέλλει ο συνδρομητής στον πενταψήφιο κωδικό 54006/54124 έχει\nκόστος απλού τυπικού μηνύματος, που διαφοροποιείται ανά πάροχο κινητής τηλεφωνίας. Η\nεπιβεβαίωση διαγραφής αποστέλλεται στον συνδρομητή δωρεάν από τον κωδικό 54303")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('faq'))+"\n    \n  ")]),_vm._v(" "),(_vm.country_code_cm == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('faq-paydash-greek')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(770);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a7a4b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(2230);
function injectStyle (ssrContext) {
  __webpack_require__(2223)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11a7a4b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a7a4b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60cd53af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRPaydashEnglish_vue__ = __webpack_require__(2225);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60cd53af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRPaydashEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Five Digit short code: "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ABOUT YOUR SUBSCRIPTION")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI ")]),_vm._v(" offers recreational services, consisting of downloading content for adults.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Upon valid subscription and payment, you may download certain files in compatible mobile phones and compatible devices via  "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" .")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The members of "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" receive their personal link each week, which they may use to download different adult content such as videos and images.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v("is a weekly subscription. You will receive 3 to 12 chargeable messages (upon receipt), with a charge of 2,08€  or 0.52 each, per week, total charge of 6,24€ per week. "),_c('a',{attrs:{"href":"http://paydash.gr/pinakas-ypp/"}},[_vm._v(" Final SMS Price ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The weekly charge is received automatically via your mobile phone bill.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("You should be aged 18 and over, in order to use one of the  "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" and have permission from the person that pays the mobile phone bill.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("COMMUNICATION ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The Service "),_c('span',{staticClass:"redtext"},[_vm._v("CUTEMOBI")]),_vm._v(" in Greece is supported by PAYDASH Single Person PC via its 5 digit codes and technical connection.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("For any queries regarding your subscription, please contact the customer service at 2111881788 or contact us via the email address c.support@paydash.gr. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("If you wish to discontinue your subscription to this service, you may send a text message from your mobile phone with the word "),_c('span',{staticClass:"redtext"},[_vm._v("STOP CUTE")]),_vm._v(" to the five-digit short code "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")]),_vm._v("  to which you were subscribed.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("The text message that is sent by the subscriber to the 5digit code "),_c('span',{staticClass:"redtext"},[_vm._v("54006/54124")]),_vm._v(", in order to discontinue the subscription, bears a standard charge, which may vary depending on the mobile phone operator. The confirmation regarding the termination of the subscription is sent to the subscriber, free of charge, via the code 54303")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1652bdbb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRPaydashGreek_vue__ = __webpack_require__(2227);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1652bdbb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRPaydashGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Γενικοί Όροι και Προϋποθέσεις")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Τελευταία τροποποίηση: 23/11/2020")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Γενικά")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Puretech Global Limited (εφεξής καλούμενη χάριν συντομίας η «Εταιρεία»), έχει την επίσημη έδρα\nτης στο Χόνγκ Κονγκ ( Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Mongkok, Kowloon) όπου είναι εγγεγραμμένη στο Εμπορικό Επιμελητήριο με αριθμό 2291075 ,\nhttps://www.puretechglobal.com/ cs@puretechglobal.com")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι ακόλουθοι Όροι και Προϋποθέσεις διέπουν τη χρήση των Υπηρεσιών που παρέχει η Εταιρεία και\nαποτυπώνουν την πλήρη συμφωνία μεταξύ της Εταιρείας και του προσώπου που γίνεται συνδρομητής\nτων υπηρεσιών της Εταιρείας (εφεξής καλούμενου χάριν συντομίας ο «Τελικός Χρήστης» ή «Πελάτης»).\nΕπιπλέον όροι και προϋποθέσεις που έχουν αναρτηθεί στην ιστοσελίδα της Εταιρεία ρητώς\nενσωματώνονται στους παρόντες Όρους και Προϋποθέσεις δια του παρόντος (εφεξής καλούμενοι από\nκοινού χάριν συντομίας οι «Όροι»). ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία δύναται, κατά την απόλυτη διακριτική της ευχέρεια, να τροποποιήσει τους Όρους\nοποτεδήποτε, προκειμένου, επί παραδείγματι, να εναρμονιστούν με νομοθετικές αλλαγές ή αλλαγές\nσχετικές με τις υπηρεσίες της. Αυτές οι αλλαγές ή τροποποιήσεις τίθενται άμεσα σε ισχύ έναντι όλων\nτων Πελατών μετά την ανάρτηση των τροποποιημένων Όρων στην ιστοσελίδα της Εταιρεία. Εάν ο\nΤελικός Χρήστης διαφωνεί με τους τροποποιημένους Όρους, οφείλει να διακόψει τη χρήση των\nυπηρεσιών της Εταιρείας. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις υπηρεσίες της Εταιρείας, ο Τελικός Χρήστης αποδέχεται τη συμμόρφωσή του με\nτους Όρους. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Υπηρεσίες")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι υπηρεσίες της Εταιρείας ενδεικτικά περιλαμβάνουν τις ψηφιακές και άλλες υπηρεσίες, τις οποίες η\nΕταιρεία προσφέρει διαδικτυακά μέσω του παρόχου υπηρεσίων κινητής τηλεφωνίας του Τελικού\nΧρήστη (εφεξής καλούμενου χάριν συντομίας ο «Πάροχος»), όπως, επί παραδείγματι, γραπτά\nμηνύματα, αρχεία ήχου και/ή εικόνας, παιχνίδια και/ή άλλες συναφείς υπηρεσίες (εφεξής καλούμενες\nχάριν συντομίας οι «Υπηρεσίες Περιεχομένου»). Οι ανωτέρω Υπηρεσίες Περιεχομένου προσφέρονται\nαπό το δίκτυο των Παρόχων μέσω Short Message Services (‘SMS’), General Packet Radio Services\n(‘GPRS’) και/ή Third Generation Services (‘3G’) ή οποιουδήποτε άλλου τρόπου. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην Ελλάδα η υπηρεσία CUTEMOBI παρέχεται μέσω της τεχνικής υποδομής και των 5ψηφίων κωδικών\nτης MOBIVAS Μονοπρόσωπη ΙΚΕ, Λεωφόρος Κηφισίας 166Α, Μαρούσι, Αθήνα ΤΚ 15126 Τηλέφωνο\nΕξυπηρέτησης Πελατών: 2111881795 support@mobivas.gr\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διαρκώς αλλάζει και βελτιώνει τις Υπηρεσίες της. Κατά συνέπεια, ενδέχεται να προσθέσει ή\nνα αφαιρέσει λειτουργίες ή χαρακτηριστικά και να αναστείλει ή να διακόψει τελείως μία Υπηρεσία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Δικαιώματα και Υποχρεώσεις του Τελικού Χρήστη")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρήστης - σημαίνει ενήλικο άτομο, που χρησιμοποιεί την Υπηρεσία σύμφωνα με τους Όρους και\nΠροϋποθέσεις. Ατομα με περιορισμένη νομική ικανότητα μπορούν να χρησιμοποιούν την Υπηρεσία\nυπό τον όρο ότι ένας νόμιμος εκπρόσωπος αυτού του ατόμου συναινεί σε αυτήν τη χρήση και άτομα\nχωρίς νομική ικανότητα - υπό τον όρο ότι ο νόμιμος εκπρόσωπός τους ενεργεί για λογαριασμό τους.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στον Τελικό Χρήστη χορηγείται η άδεια να λαμβάνει, αποθηκεύει και να προβάλλει τις Υπηρεσίες\nΠεριεχομένου της Εταιρείας. Η ως άνω άδεια είναι προσωποπαγής, μη αποκλειστική, δεν δύναται να\nεκχωρηθεί και χορηγείται με αποκλειστικό σκοπό να διευκολύνει τον Τελικό Χρήστη κατά την χρήση και\nαπόλαυση των προνομίων των Υπηρεσιών, όπως αυτές παρέχονται από την Εταιρεία και κατά τρόπο\nπου επιτρέπουν οι Όροι. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κατά την χρήση των Υπηρεσιών, ο Τελικός Χρήστης ενδέχεται να λαμβάνει ανακοινώσεις υπηρεσιών,\nδιαχειριστικά μηνύματα και άλλες πληροφορίες και έχει το δικαίωμα να επιλέξει να εξαιρεθεί από\nαυτές τις επικοινωνίες.  \n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης οφείλει να συμμορφώνεται με τις πολιτικές της Εταιρείας σε σχέση με τις Υπηρεσίες\nκαι να τις χρησιμοποιεί κατά σύννομο τρόπο.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης οφείλει να απόσχει από οποιαδήποτε κακή χρήση των Υπηρεσιών, επί\nπαραδείγματι, να προσπαθεί να έχει πρόσβαση σε αυτές κατά τρόπο αντίθετο προς τις οδηγίες της\nΕταιρείας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Χρήση των Υπηρεσιών δεν παρέχει στον Τελικό Χρήστη την άδεια να αντιγράφει, αναπαράγει,\nτροποποιεί, να δημιουργεί παράγωγα έργα (όπως αυτά που προκύπτουν από μεταφράσεις,\nπροσαρμογές ή άλλες αλλαγές), να επικοινωνεί, να δημοσιεύει, να εκτελεί δημόσια, μεταβιβάζει,\nπωλεί, μισθώνει, διανέμει και, γενικά, να εμπορεύεται, ή να χρησιμοποιεί με οποιονδήποτε άλλο μη\nεξουσιοδοτημένο τρόπο τις Υπηρεσίες Περιεχομένου ή μέρος αυτών, εκτός εάν η Εταιρεία ρητώς\nσυναινεί σε αυτή τη χρήση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Χρεώσεις")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις Υπηρεσίες της Εταιρείας, ο Πελάτης αποδέχεται τις χρεώσεις της Εταιρείας, όπως\nαυτές αναφέρονται στην ιστοσελίδα της. Οι Χρεώσεις ενδέχεται να ποικίλλουν ανάλογα με τις\nπαρεχόμενες Υπηρεσίες, ήτοι (α) συνδρομή στις Υπηρεσίες Περιεχομένου, (β) δωρεάν μονάδες για\nλήψη αρχείων («Υπηρεσία Club») και (γ) μεμονωμένες παραγγελίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι Χρεώσεις για σταθερές συνδρομές θα τιμολογούνται μέσω του λογαριασμού του Παρόχου του\nΠελάτη. Οι Χρεώσεις για προπληρωμένες συνδρομές θα αφαιρούνται από το πιστωτικό υπόλοιπο του\nΠελάτη. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός χρήστης διά του παρόντος παραχωρεί ρητώς την άδειά του για χρέωση και δεσμεύεται για\nτην πλήρη αποπληρωμή των Χρεώσεων, συμφωνόντας για την άμεση εκτέλεση της Υπηρεσίας και τη\nλήψη ψηφιακού περιεχομένου πριν από το τέλος της περιόδου των 14 ημερών για υπαναχώρηση από\nτη συμφωνία, με συνέπεια την απώλεια του δικαιώματος αυτού")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Όλες οι Χρεώσεις καταβάλλονται εις το ακέραιο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα γραπτά μηνύματα που αποστέλλονται μέσω του πενταψήφιου κωδικού 54303 (PIN, μήνυμα\nκαλωσορίσματος, μηνιαία ενημέρωση, δεκαπενθήμερη ενημέρωση,επιβεβαίωση διαγραφής) είναι\nδωρεάν και ο Τελικός Χρήστης δεν δύναται να αποστείλει γραπτό μήνυμα στον ανωτέρω κωδικό. Η\nΕταιρεία καταγράφει τον αριθμό κινητού τηλεφώνου του Τελικού Χρήστη στο ηλεκτρονικό της\nσύστημα. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διατηρεί το δικαίωμα να τροποποιεί μονομερώς τις Χρεώσεις της, οι οποίες ισχύουν μετά\nτην ανάρτησή τους στην ιστοσελίδα της {COMPANY SITE}. Οι τροποποιήσεις των Χρεώσεων θα\nεπικοινωνούνται στους υπάρχοντες Πελάτες μέσω γραπτού μηνύματος μία εβδομάδα πριν την\nτροποποίηση. Οι τροποποιημένες Χρεώσεις θα ισχύουν για τους νέους Πελάτες ή για Πελάτες που είναι\nήδη εγγεγραμμένοι τη στιγμή της τροποποίησης, εάν συνεχίζουν να χρησιμοποιούν τις Υπηρεσίες της\nΕταιρεία μετά την προαναφερθείσα ενημέρωση.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI δεν σχετίζεται, χορηγείται, υποστηρίζεται ή είναι αντικείμενο διαχείρισης από\nκανένα από τα προϊόντα που παρουσιάζονται και καμμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα\nσημεία εξυπηρέτησης, τα λογότυπα (συμπεριλαμβανομένων, χωρίς περιορισμό, των εμπορικών\nονομάτων προϊόντων και εμπορικών εταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI δεν σχετίζεται, χορηγείται, υποστηρίζεται ή είναι αντικείμενο διαχείρισης από\nκανένα από τα προϊόντα που παρουσιάζονται και καμμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα\nσημεία εξυπηρέτησης, τα λογότυπα (συμπεριλαμβανομένων, χωρίς περιορισμό, των εμπορικών\nονομάτων προϊόντων και εμπορικών εταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("H χρέωση της συνδρομητικής υπηρεσίας ανέρχεται σε 2,08 € ανά SMS (3SMS/εβδομάδα=12 SMS τον\nμήνα) ή 0,52€ ανά SMS (έως 12SMS/εβδομάδα=48 SMS τον μήνα) (συμπεριλαμβανομένου ΦΠΑ), που\nθα λαμβάνεται από τον 5ψήφιο κωδικό 54006 και 54124 αντίστοιχα ."),_c('a',{attrs:{"href":"https://mobivas.gr/table.html"}},[_vm._v(" Τελική Τιμή Μηνύματος ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Όλα τα γραπτά μηνύματα, που αποστέλλονται από τον Πελάτη, θα χρεώνονται σε αυτόν μέσω του\nΠαρόχου του, σύμφωνα με τις τυπικές χρεώσεις. Οι εν λόγω χρεώσεις ενδέχεται να διαφέρουν ανά\nΠάροχο\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός χρήστης διά του παρόντος παραχωρεί ρητώς την άδειά του για χρέωση και δεσμεύεται για\nτην πλήρη αποπληρωμή των Χρεώσεων., συμφωνόντας για την άμεση εκτέλεση της Υπηρεσίας και τη\nλήψη ψηφιακού περιεχομένου πριν από το τέλος της περιόδου των 14 ημερών για υπαναχώρηση από\nτη συμφωνία, με συνέπεια την απώλεια του δικαιώματος αυτου\n\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Εγγυήσεις και Δηλώσεις Αποποίησης")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία παρέχει τις Υπηρεσίες της χρησιμοποιώντας ένα εμπορικά εύλογο επίπεδο δεξιότητας και\nπροσοχής. Εντούτοις, η Εταιρεία δεν αναλαμβάνει συγκεκριμένες δεσμεύσεις σχετικά με τις Υπηρεσίες,\nόπως, επί παραδείγματι, σχετικά με το περιεχόμενο στις Υπηρεσίες, τις συγκεκριμένες λειτουργίες των\nΥπηρεσιών ή την αξιοπιστία, διαθεσιμότητα ή τη δυνατότητά τους να ικανοποιήσουν τις ανάγκες του\nΤελικού Χρήστη. Η Εταιρεία παρέχει τις Υπηρεσίες της “ως έχουν”.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επιπλέον, διευκρινίζεται ότι η πρόσβαση του Τελικού Χρήστη στις Υπηρεσίες ενδέχεται, ανά πάσα\nστιγμή, να διακοπεί ή να δυσχερανθεί εξ αιτίας παραγόντων, οι οποίοι εκφεύγουν του ελέγχου, που\nευλόγως αναμένεται να ασκεί η Εταιρεία, περιλαμβανομένων, ενδεικτικά, τεχνικών προβλημάτων στο\nδίκτυο του Παρόχου. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Ευθύνη")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία δεν ευθύνεται για τυχόν ζημίες που μπορεί να υποστεί ο Τελικός Χρήστης σε σχέση με τις")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Υπηρεσίες. Σε κάθε περίπτωση, για οποιαδήποτε απαίτηση σχετική με τους Όρους,\nσυμπεριλαμβανομένων τυχόν σιωπηρών εγγυήσεων, η συνολική ευθύνη της Εταιρεία περιορίζεται στο\nποσό που ο Τελικός Χρήστης κατέβαλε στην Εταιρεία για τις Υπηρεσίες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Περαιτέρω, ο Τελικός Χρήστης δεν δικαιούται να αξιώσει μείωση των Χρεώσεων ή επιστροφή\nχρημάτων για Χρεώσεις που έχουν ήδη καταβληθεί, σε περίπτωση διακοπής της χρήσης των\nΥπηρεσιών. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. Αποζημίωση ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης αναλαμβάνει την υποχρέωση να μην υποστεί βλάβη η Εταιρεία και να αποζημιώσει\nτην Εταιρεία και τους εκπροσώπους, εργαζομένους και συνεργάτες της για οποιαδήποτε απαίτηση,\nαγωγή ή διαδικασία που σχετίζεται με τη χρήση των Υπηρεσιών ή με παράβαση των Όρων,\nπεριλαμβανομένης οποιασδήποτε υποχρέωσης αποζημίωσης ή δαπάνης που πηγάζει από απαιτήσεις,\nβλάβη, ζημία, δικαστικές αποφάσεις, δικαστικά έξοδα και δικηγορικές αμοιβές. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. Καταγγελία")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης δύναται να διακόψει οποτεδήποτε τη χρήση των Υπηρεσιών.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία έχει δικαίωμα άμεσης καταγγελίας ή περιορισμού της πρόσβασης του Τελικού Χρήστη στις\nΥπηρεσίες, με ή χωρίς προηγούμενη ειδοποίηση, για οποιονδήποτε από τους ακόλουθους λόγους: (α)\nλόγω παράβασης των παρόντων Όρων, (β) κατόπιν σχετικού αιτήματος των δικαστικών ή άλλων\nκρατικών αρχών, (γ) λόγω διακοπής ή ουσιώδους τροποποίησης των Υπηρεσιών (ή μέρους αυτών), (δ)\nλόγω απρόβλεπτων τεχνικών θεμάτων ή προβλημάτων ή θεμάτων ασφαλείας, (ε) εξ αιτίας απατηλών ή\nπαρανόμων δραστηριοτήτων του Τελικού Χρήστη, (στ) λόγω μη καταβολής ή καθυστερήσεων στις\nκαταβολές των Χρεώσεων που οφείλονται από τον Τελικό Χρήστη σε σχέση με τις Υπηρεσίες, (ζ)\nκατόπιν σχετικού αιτήματος του Παρόχου του Τελικού Χρήστη.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η καταγγελία ή ο περιορισμός της πρόσβασης θα πραγματοποιείται κατά την απόλυτη διακριτική\nευχέρεια της Εταιρεία και η τελευταία δεν θα ευθύνεται έναντι του Τελικού Χρήστη ή οποιουδήποτε\nτρίτου για την καταγγελία ή τον περιορισμό πρόσβασης στις Υπηρεσίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μετά την καταγγελία, ο Τελικός Χρήστης δεν θα έχει πρόσβαση στις Υπηρεσίες, ανεξαρτήτως του εάν\nέχει καταβάλει τις σχετικές Χρεώσεις για αυτές τις Υπηρεσίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. Πνευματική Ιδιοκτησία ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δικαιώματα Πνευματικής Ιδιοκτησίας, όπως εμπορικά σήματα, εμπορικές επωνυμίες, δικαιώματα\nπνευματικής ιδιοκτησίας, δικαιώματα βάσης δεδομένων, κατοχυρωμένα σχέδια, διπλώματα\nευρεσιτεχνίας και οποιαδήποτε άλλα παρόμοια")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("δικαιώματα που προστατεύονται σε οποιαδήποτε χώρα, καθώς και εκκρεμείς αιτήσεις κατοχύρωσης,\nπου σχετίζονται με τις Υπηρεσίες της Εταιρεία και/ή την ιστοσελίδα της παραμένουν πάντα στην\nκυριότητα της Εταιρεία δικαιώματα που προστατεύονται σε οποιαδήποτε χώρα, καθώς και εκκρεμείς αιτήσεις κατοχύρωσης,\nπου σχετίζονται με τις Υπηρεσίες της Εταιρεία και/ή την ιστοσελίδα της παραμένουν πάντα στην\nκυριότητα της Εταιρεία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η υπηρεσία δεν σχετίζεται, χορηγείται ή υποστηρίζεται από κανένα από τα προϊόντα που\nπαρουσιάζονται και καμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα σημεία εξυπηρέτησης, τα logos\n(συμπεριλαμβανομένων, χωρίς περιορισμό, των χαρακτηριστικών ονομάτων προϊόντων και εμπορικών\nεταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών και προστατεύονται από την αντίστοιχη\nνομοθεσία .")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. Επεξεργασία Δεδομένων")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία συλλέγει και χρησιμοποιεί συγκεκριμένα προσωπικά δεδομένα σχετικά με τον Τελικό\nΧρήστη για εμπορικούς σκοπούς. Η Εταιρεία θα χρησιμοποιεί τα δεδομένα αυτά, με τον τρόπο που\nπεριγράφεται στην Πολιτική Απορρήτου της, αντίγραφο της οποίας υπάρχει στην ιστοσελίδα της\nΕταιρεία, και σύμφωνα με την νομοθεσία περί προστασίας προσωπικών δεδομένων (Γενικός\nΚανονισμός για την Προστασία Δεδομένων (EE) 2016/679 (GDPR)). ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Σε σχέση με τη λειτουργία της Υπηρεσίας, η Εταιρεία διατηρεί στις βάσεις δεδομένων της τον αριθμό\nτου κινητού τηλεφώνου από το οποίο έχει ενεργοποιηθεί υπηρεσία , όπως απαιτείται από τις σχετικές\nνομοθετικές διατάξεις, ιδίως για μια περίοδο που επιτρέπει λαμβάνοντας υπόψη τα παράπονα που\nυποβλήθηκαν ή άλλες αξιώσεις σχετικά με την Υπηρεσία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα στοιχεία των χρηστών θα υποβάλλονται σε επεξεργασία εντός του πεδίου εφαρμογής και για τον\nαναγκαίο σκοπό για την παροχή της Υπηρεσίας (επίσης με σκοπό την εξέταση καταγγελιών) και μετά\nτην ολοκλήρωση της Υπηρεσίας, τα δεδομένα των χρηστών θα αφαιρεθούν, εκτός εάν απαιτείται το\nαντίθετο .Η αποθήκευση ορισμένων δεδομένων για χρονικό διάστημα μεγαλύτερο από την παροχή της\nΥπηρεσίας προκύπτει από τις διατάξεις του νόμου. Η παροχή δεδομένων είναι εθελοντική και γίνεται\nμε τη συναίνεση του χρήστη . Οι χρήστες έχουν, μεταξύ άλλων, το δικαίωμα προβολής, διόρθωσης και\nεπίσης απαίτησης διαγραφής των προσωπικών τους δεδομένων. Ο Χρήστης μπορεί ζητήσει τη\nδιαγραφή ή διόρθωση των προσωπικών του δεδομένων")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις Υπηρεσίες της Εταιρείας, ο Τελικός Χρήστης συναινεί στην προαναφερθείσα\nεπεξεργασία, διατηρώντας το δικαίωμα να εναντιωθεί σε αυτή την επεξεργασία αποστέλλοντας\nμήνυμα ηλεκτρονικού ταχυδρομείου στη διεύθυνση support@mobivas.gr\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. Εκχώρηση")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης δεν δύναται να εκχωρήσει ή να μεταβιβάσει οποιοδήποτε από τα δικαιώματα ή τις\nυποχρεώσεις του, που πηγάζουν από τους Όρους.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία έχει δικαίωμα να εκχωρήσει, εν όλω ή εν μέρει, τα δικαιώματα ή τις υποχρεώσεις της, που\nπηγάζουν από τους Όρους χωρίς περιορισμό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. Διάφορα")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αυθυπαρξία εκάστου όρου. Εάν οποιαδήποτε διάταξη των Όρων κριθεί άκυρη ή μη εφαρμόσιμη, δεν\nθα επηρεάσει οποιαδήποτε άλλη διάταξη, και όλες οι λοιπές διατάξεις θα εξακολουθήσουν να ισχύουν\nκαι να παράγουν όλα τα αποτελέσματά τους.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ανοχή. Η ανοχή, καθυστέρηση ή επιείκεια εκ μέρους της MOBIVAS κατά την εφαρμογή οποιωνδήποτε\nδιατάξεων των Όρων δεν θα προκαλέσει ζημία ή θα επηρεάσει τα δικαιώματά της και τα δικαιώματα\nαποζημίωσης, ούτε οποιαδήποτε παραίτηση αναφορικά με κάποια παράβαση θα ερμηνευθεί ως\nπαραίτηση για επόμενη παράβαση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αγγλική Γλώσσα. Σε περίπτωση διάστασης μεταξύ του Αγγλικού και του Ελληνικού κειμένου των Όρων,\nθα υπερισχύει το Αγγλικό κείμενο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. Εφαρμοστέο Δίκαιο και Δικαιοδοσία")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι Όροι θα διέπονται από το Ελληνικό Δίκαιο και οποιαδήποτε διαφορά ανακύψει σχετικά με την\nερμηνεία και/ή την εφαρμογή και/ή την καταγγελία τους θα παραπέμπεται στα Δικαστήρια των\nΑθηνών, τα οποία θα αποφασίζουν επ’ αυτής έχοντας αποκλειστική αρμοδιότητα.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΥΠΗΡΕΣΙΑ ΕΝΗΛΙΚΩΝ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI είναι αποκλειστικά διαθέσιμη σε Τελικούς Χρήστες ηλικίας 18 ετών και άνω.\nΣυνεπώς, οι Τελικοί Χρήστες που δηλώνουν ότι είναι ανήλικοι δεν θα δύνανται να εγγραφούν στην\nΥπηρεσία αυτή και η Εταιρεία δεν θα επεξεργάζεται τα προσωπικά τους δεδομένα. Με την εγγραφή\nτους στην Υπηρεσία, οι Τελικοί Χρήστες δηλώνουν ότι είναι 18 ετών και άνω. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα μηνύματα αυτής της Υπηρεσίας λαμβάνονται μέσω του πενταψήφιου κωδικού 54006 ή του 54124")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι εβδομαδιαίες Χρεώσεις για τη συνδρομή σε αυτή την Υπηρεσία ανέρχονται σε 2,08 € ανά ληφθέν\nγραπτό μήνυμα ή σε 0,52 € ανά ληφθέν γραπτό μήνυμα, ήτοι συνολική εβδομαδιαία Χρέωση 6,24 €\n(συμπεριλαμβανομένου Φ.Π.Α.) "),_c('a',{attrs:{"href":"https://mobivas.gr/table.html"}},[_vm._v(" Τελική Τιμή Μηνύματος ")]),_vm._v(". Τα γραπτά μηνύματα που αποστέλλονται\nμέσω του πενταψήφιου κωδικού 54303 (κωδικός επιβεβαίωσης, μήνυμα καλωσορίσματος, μηνιαία\nενημέρωση κλπ.) είναι δωρεάν. Η Χρέωση για το γραπτό μήνυμα, που αποστέλλεται από τον Τελικό\nΧρήστη στον πενταψήφιο κωδικό 54006 ή από τον 54124 προκειμένου να ακυρώσει τη συνδρομή του,\nποικίλλει ανάλογα με τον Πάροχο του Τελικού Χρήστη.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Δεν είναι δυνατή η αναγνώριση μηνύματος που αποστέλλεται από τον Τελικό Χρήστη στον\nσυγκεκριμένο κωδικό. ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8258eb90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRMobivasGreek_vue__ = __webpack_require__(2229);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8258eb90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsGRMobivasGreek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΕΛΛΗΝΙΚΟ ΚΕΙΜΕΝΟ")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Γενικοί Όροι και Προϋποθέσεις")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("Τελευταία τροποποίηση: 23/11/2020")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1.Γενικά")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Puretech Global Limited (εφεξής καλούμενη χάριν συντομίας η «Εταιρεία»), έχει την επίσημη έδρα της στο Χόνγκ Κονγκ ( Unit 2104, 21/F., Mongkok Commercial Centre, 16 Argyle Street,")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Mongkok, Kowloon) όπου είναι εγγεγραμμένη στο Εμπορικό Επιμελητήριο με αριθμό 2291075 ,\nhttps://www.puretechglobal.com/ cs@puretechglobal.com")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι ακόλουθοι Όροι και Προϋποθέσεις διέπουν τη χρήση των Υπηρεσιών που παρέχει η Εταιρεία και αποτυπώνουν την πλήρη συμφωνία μεταξύ της Εταιρείας και του προσώπου που γίνεται συνδρομητής των υπηρεσιών της Εταιρείας (εφεξής καλούμενου χάριν συντομίας ο «Τελικός Χρήστης» ή «Πελάτης»).\nΕπιπλέον όροι και προϋποθέσεις που έχουν αναρτηθεί στην ιστοσελίδα της Εταιρεία ρητώς\nενσωματώνονται στους παρόντες Όρους και Προϋποθέσεις δια του παρόντος (εφεξής καλούμενοι από κοινού χάριν συντομίας οι «Όροι»).\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία δύναται, κατά την απόλυτη διακριτική της ευχέρεια, να τροποποιήσει τους Όρους\nοποτεδήποτε, προκειμένου, επί παραδείγματι, να εναρμονιστούν με νομοθετικές αλλαγές ή αλλαγές σχετικές με τις υπηρεσίες της. Αυτές οι αλλαγές ή τροποποιήσεις τίθενται άμεσα σε ισχύ έναντι όλων των Πελατών μετά την ανάρτηση των τροποποιημένων Όρων στην ιστοσελίδα της Εταιρεία. Εάν ο Τελικός Χρήστης διαφωνεί με τους τροποποιημένους Όρους, οφείλει να διακόψει τη χρήση των\nυπηρεσιών της Εταιρείας.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις υπηρεσίες της Εταιρείας, ο Τελικός Χρήστης αποδέχεται τη συμμόρφωσή του με τους Όρους.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2.Υπηρεσίες")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι υπηρεσίες της Εταιρείας ενδεικτικά περιλαμβάνουν τις ψηφιακές και άλλες υπηρεσίες, τις οποίες η Εταιρεία προσφέρει διαδικτυακά μέσω του παρόχου υπηρεσίων κινητής τηλεφωνίας του Τελικού Χρήστη (εφεξής καλούμενου χάριν συντομίας ο «Πάροχος»), όπως, επί παραδείγματι, γραπτά\nμηνύματα, αρχεία ήχου και/ή εικόνας, παιχνίδια και/ή άλλες συναφείς υπηρεσίες (εφεξής καλούμενες χάριν συντομίας οι «Υπηρεσίες Περιεχομένου»). Οι ανωτέρω Υπηρεσίες Περιεχομένου προσφέρονται από το δίκτυο των Παρόχων μέσω Short Message Services (‘SMS’), General Packet Radio Services\n(‘GPRS’) και/ή Third Generation Services (‘3G’) ή οποιουδήποτε άλλου τρόπου.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στην Ελλάδα η υπηρεσία CUTEMOBI παρέχεται μέσω της τεχνικής υποδομής και των 5ψηφίων κωδικών της MOBIVAS Μονοπρόσωπη ΙΚΕ, Λεωφόρος Κηφισίας 166Α, Μαρούσι, Αθήνα ΤΚ 15126 Τηλέφωνο\nΕξυπηρέτησης Πελατών: 2111881795 support@mobivas.gr.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διαρκώς αλλάζει και βελτιώνει τις Υπηρεσίες της. Κατά συνέπεια, ενδέχεται να προσθέσει ή να αφαιρέσει λειτουργίες ή χαρακτηριστικά και να αναστείλει ή να διακόψει τελείως μία Υπηρεσία.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3.Δικαιώματα και Υποχρεώσεις του Τελικού Χρήστη")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρήστης - σημαίνει ενήλικο άτομο, που χρησιμοποιεί την Υπηρεσία σύμφωνα με τους Όρους και\nΠροϋποθέσεις. Ατομα με περιορισμένη νομική ικανότητα μπορούν να χρησιμοποιούν την Υπηρεσία υπό τον όρο ότι ένας νόμιμος εκπρόσωπος αυτού του ατόμου συναινεί σε αυτήν τη χρήση και άτομα χωρίς νομική ικανότητα - υπό τον όρο ότι ο νόμιμος εκπρόσωπός τους ενεργεί για λογαριασμό τους.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Στον Τελικό Χρήστη χορηγείται η άδεια να λαμβάνει, αποθηκεύει και να προβάλλει τις Υπηρεσίες\nΠεριεχομένου της Εταιρείας. Η ως άνω άδεια είναι προσωποπαγής, μη αποκλειστική, δεν δύναται να\nεκχωρηθεί και χορηγείται με αποκλειστικό σκοπό να διευκολύνει τον Τελικό Χρήστη κατά την χρήση και απόλαυση των προνομίων των Υπηρεσιών, όπως αυτές παρέχονται από την Εταιρεία και κατά τρόπο\nπου επιτρέπουν οι Όροι.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Κατά την χρήση των Υπηρεσιών, ο Τελικός Χρήστης ενδέχεται να λαμβάνει ανακοινώσεις υπηρεσιών, διαχειριστικά μηνύματα και άλλες πληροφορίες και έχει το δικαίωμα να επιλέξει να εξαιρεθεί από αυτές τις επικοινωνίες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης οφείλει να συμμορφώνεται με τις πολιτικές της Εταιρείας σε σχέση με τις Υπηρεσίες και να τις χρησιμοποιεί κατά σύννομο τρόπο.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης οφείλει να απόσχει από οποιαδήποτε κακή χρήση των Υπηρεσιών, επί\nπαραδείγματι, να προσπαθεί να έχει πρόσβαση σε αυτές κατά τρόπο αντίθετο προς τις οδηγίες της Εταιρείας.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Χρήση των Υπηρεσιών δεν παρέχει στον Τελικό Χρήστη την άδεια να αντιγράφει, αναπαράγει, τροποποιεί, να δημιουργεί παράγωγα έργα (όπως αυτά που προκύπτουν από μεταφράσεις,\nπροσαρμογές ή άλλες αλλαγές), να επικοινωνεί, να δημοσιεύει, να εκτελεί δημόσια, μεταβιβάζει,\nπωλεί, μισθώνει, διανέμει και, γενικά, να εμπορεύεται, ή να χρησιμοποιεί με οποιονδήποτε άλλο μη εξουσιοδοτημένο τρόπο τις Υπηρεσίες Περιεχομένου ή μέρος αυτών, εκτός εάν η Εταιρεία ρητώς\nσυναινεί σε αυτή τη χρήση.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4.Χρεώσεις")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις Υπηρεσίες της Εταιρείας, ο Πελάτης αποδέχεται τις χρεώσεις της Εταιρείας, όπως αυτές αναφέρονται στην ιστοσελίδα της. Οι Χρεώσεις ενδέχεται να ποικίλλουν ανάλογα με τις\nπαρεχόμενες Υπηρεσίες, ήτοι (α) συνδρομή στις Υπηρεσίες Περιεχομένου, (β) δωρεάν μονάδες για λήψη αρχείων («Υπηρεσία Club») και (γ) μεμονωμένες παραγγελίες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι Χρεώσεις για σταθερές συνδρομές θα τιμολογούνται μέσω του λογαριασμού του Παρόχου του\nΠελάτη. Οι Χρεώσεις για προπληρωμένες συνδρομές θα αφαιρούνται από το πιστωτικό υπόλοιπο του Πελάτη.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός χρήστης διά του παρόντος παραχωρεί ρητώς την άδειά του για χρέωση και δεσμεύεται για την πλήρη αποπληρωμή των Χρεώσεων, συμφωνόντας για την άμεση εκτέλεση της Υπηρεσίας και τη λήψη ψηφιακού περιεχομένου πριν από το τέλος της περιόδου των 14 ημερών για υπαναχώρηση από τη συμφωνία, με συνέπεια την απώλεια του δικαιώματος αυτού")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Όλες οι Χρεώσεις καταβάλλονται εις το ακέραιο.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα γραπτά μηνύματα που αποστέλλονται μέσω του πενταψήφιου κωδικού 54303 (PIN, μήνυμα\nκαλωσορίσματος, μηνιαία ενημέρωση, δεκαπενθήμερη ενημέρωση,επιβεβαίωση διαγραφής) είναι δωρεάν και ο Τελικός Χρήστης δεν δύναται να αποστείλει γραπτό μήνυμα στον ανωτέρω κωδικό. Η Εταιρεία καταγράφει τον αριθμό κινητού τηλεφώνου του Τελικού Χρήστη στο ηλεκτρονικό της\nσύστημα\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία διατηρεί το δικαίωμα να τροποποιεί μονομερώς τις Χρεώσεις της, οι οποίες ισχύουν μετά την ανάρτησή τους στην ιστοσελίδα της {COMPANY SITE}. Οι τροποποιήσεις των Χρεώσεων θα\nεπικοινωνούνται στους υπάρχοντες Πελάτες μέσω γραπτού μηνύματος μία εβδομάδα πριν την\nτροποποίηση. Οι τροποποιημένες Χρεώσεις θα ισχύουν για τους νέους Πελάτες ή για Πελάτες που είναι ήδη εγγεγραμμένοι τη στιγμή της τροποποίησης, εάν συνεχίζουν να χρησιμοποιούν τις Υπηρεσίες της Εταιρεία μετά την προαναφερθείσα ενημέρωση\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI δεν σχετίζεται, χορηγείται, υποστηρίζεται ή είναι αντικείμενο διαχείρισης από κανένα από τα προϊόντα που παρουσιάζονται και καμμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα σημεία εξυπηρέτησης, τα λογότυπα (συμπεριλαμβανομένων, χωρίς περιορισμό, των εμπορικών ονομάτων προϊόντων και εμπορικών εταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI δεν σχετίζεται, χορηγείται, υποστηρίζεται ή είναι αντικείμενο διαχείρισης από\nκανένα από τα προϊόντα που παρουσιάζονται και καμμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα\nσημεία εξυπηρέτησης, τα λογότυπα (συμπεριλαμβανομένων, χωρίς περιορισμό, των εμπορικών\nονομάτων προϊόντων και εμπορικών εταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("H χρέωση της συνδρομητικής υπηρεσίας ανέρχεται σε 2,08 € ανά SMS (3SMS/εβδομάδα=12 SMS τον\nμήνα) ή 0,52€ ανά SMS (έως 12SMS/εβδομάδα=48 SMS τον μήνα) (συμπεριλαμβανομένου ΦΠΑ), που\nθα λαμβάνεται από τον 5ψήφιο κωδικό 54006 και 54124 αντίστοιχα ."),_c('a',{attrs:{"href":"https://mobivas.gr/table.html"}},[_vm._v(" Τελική Τιμή Μηνύματος ")])])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Όλα τα γραπτά μηνύματα, που αποστέλλονται από τον Πελάτη, θα χρεώνονται σε αυτόν μέσω του\nΠαρόχου του, σύμφωνα με τις τυπικές χρεώσεις. Οι εν λόγω χρεώσεις ενδέχεται να διαφέρουν ανά\nΠάροχο\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός χρήστης διά του παρόντος παραχωρεί ρητώς την άδειά του για χρέωση και δεσμεύεται για\nτην πλήρη αποπληρωμή των Χρεώσεων., συμφωνόντας για την άμεση εκτέλεση της Υπηρεσίας και τη\nλήψη ψηφιακού περιεχομένου πριν από το τέλος της περιόδου των 14 ημερών για υπαναχώρηση από\nτη συμφωνία, με συνέπεια την απώλεια του δικαιώματος αυτου\n\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Εγγυήσεις και Δηλώσεις Αποποίησης")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία παρέχει τις Υπηρεσίες της χρησιμοποιώντας ένα εμπορικά εύλογο επίπεδο δεξιότητας και\nπροσοχής. Εντούτοις, η Εταιρεία δεν αναλαμβάνει συγκεκριμένες δεσμεύσεις σχετικά με τις Υπηρεσίες,\nόπως, επί παραδείγματι, σχετικά με το περιεχόμενο στις Υπηρεσίες, τις συγκεκριμένες λειτουργίες των\nΥπηρεσιών ή την αξιοπιστία, διαθεσιμότητα ή τη δυνατότητά τους να ικανοποιήσουν τις ανάγκες του\nΤελικού Χρήστη. Η Εταιρεία παρέχει τις Υπηρεσίες της “ως έχουν”.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Επιπλέον, διευκρινίζεται ότι η πρόσβαση του Τελικού Χρήστη στις Υπηρεσίες ενδέχεται, ανά πάσα\nστιγμή, να διακοπεί ή να δυσχερανθεί εξ αιτίας παραγόντων, οι οποίοι εκφεύγουν του ελέγχου, που\nευλόγως αναμένεται να ασκεί η Εταιρεία, περιλαμβανομένων, ενδεικτικά, τεχνικών προβλημάτων στο\nδίκτυο του Παρόχου. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Ευθύνη")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία δεν ευθύνεται για τυχόν ζημίες που μπορεί να υποστεί ο Τελικός Χρήστης σε σχέση με τις")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Υπηρεσίες. Σε κάθε περίπτωση, για οποιαδήποτε απαίτηση σχετική με τους Όρους,\nσυμπεριλαμβανομένων τυχόν σιωπηρών εγγυήσεων, η συνολική ευθύνη της Εταιρεία περιορίζεται στο\nποσό που ο Τελικός Χρήστης κατέβαλε στην Εταιρεία για τις Υπηρεσίες.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Περαιτέρω, ο Τελικός Χρήστης δεν δικαιούται να αξιώσει μείωση των Χρεώσεων ή επιστροφή\nχρημάτων για Χρεώσεις που έχουν ήδη καταβληθεί, σε περίπτωση διακοπής της χρήσης των\nΥπηρεσιών. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("7. Αποζημίωση ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης αναλαμβάνει την υποχρέωση να μην υποστεί βλάβη η Εταιρεία και να αποζημιώσει\nτην Εταιρεία και τους εκπροσώπους, εργαζομένους και συνεργάτες της για οποιαδήποτε απαίτηση,\nαγωγή ή διαδικασία που σχετίζεται με τη χρήση των Υπηρεσιών ή με παράβαση των Όρων,\nπεριλαμβανομένης οποιασδήποτε υποχρέωσης αποζημίωσης ή δαπάνης που πηγάζει από απαιτήσεις,\nβλάβη, ζημία, δικαστικές αποφάσεις, δικαστικά έξοδα και δικηγορικές αμοιβές. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("8. Καταγγελία")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης δύναται να διακόψει οποτεδήποτε τη χρήση των Υπηρεσιών.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία έχει δικαίωμα άμεσης καταγγελίας ή περιορισμού της πρόσβασης του Τελικού Χρήστη στις\nΥπηρεσίες, με ή χωρίς προηγούμενη ειδοποίηση, για οποιονδήποτε από τους ακόλουθους λόγους: (α)\nλόγω παράβασης των παρόντων Όρων, (β) κατόπιν σχετικού αιτήματος των δικαστικών ή άλλων\nκρατικών αρχών, (γ) λόγω διακοπής ή ουσιώδους τροποποίησης των Υπηρεσιών (ή μέρους αυτών), (δ)\nλόγω απρόβλεπτων τεχνικών θεμάτων ή προβλημάτων ή θεμάτων ασφαλείας, (ε) εξ αιτίας απατηλών ή\nπαρανόμων δραστηριοτήτων του Τελικού Χρήστη, (στ) λόγω μη καταβολής ή καθυστερήσεων στις\nκαταβολές των Χρεώσεων που οφείλονται από τον Τελικό Χρήστη σε σχέση με τις Υπηρεσίες, (ζ)\nκατόπιν σχετικού αιτήματος του Παρόχου του Τελικού Χρήστη.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η καταγγελία ή ο περιορισμός της πρόσβασης θα πραγματοποιείται κατά την απόλυτη διακριτική\nευχέρεια της Εταιρεία και η τελευταία δεν θα ευθύνεται έναντι του Τελικού Χρήστη ή οποιουδήποτε\nτρίτου για την καταγγελία ή τον περιορισμό πρόσβασης στις Υπηρεσίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Μετά την καταγγελία, ο Τελικός Χρήστης δεν θα έχει πρόσβαση στις Υπηρεσίες, ανεξαρτήτως του εάν\nέχει καταβάλει τις σχετικές Χρεώσεις για αυτές τις Υπηρεσίες. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("9. Πνευματική Ιδιοκτησία ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα δικαιώματα Πνευματικής Ιδιοκτησίας, όπως εμπορικά σήματα, εμπορικές επωνυμίες, δικαιώματα\nπνευματικής ιδιοκτησίας, δικαιώματα βάσης δεδομένων, κατοχυρωμένα σχέδια, διπλώματα\nευρεσιτεχνίας και οποιαδήποτε άλλα παρόμοια")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("δικαιώματα που προστατεύονται σε οποιαδήποτε χώρα, καθώς και εκκρεμείς αιτήσεις κατοχύρωσης,\nπου σχετίζονται με τις Υπηρεσίες της Εταιρεία και/ή την ιστοσελίδα της παραμένουν πάντα στην\nκυριότητα της Εταιρεία δικαιώματα που προστατεύονται σε οποιαδήποτε χώρα, καθώς και εκκρεμείς αιτήσεις κατοχύρωσης,\nπου σχετίζονται με τις Υπηρεσίες της Εταιρεία και/ή την ιστοσελίδα της παραμένουν πάντα στην\nκυριότητα της Εταιρεία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η υπηρεσία δεν σχετίζεται, χορηγείται ή υποστηρίζεται από κανένα από τα προϊόντα που\nπαρουσιάζονται και καμία εμπορική εταιρεία. Τα εμπορικά σήματα, τα σημεία εξυπηρέτησης, τα logos\n(συμπεριλαμβανομένων, χωρίς περιορισμό, των χαρακτηριστικών ονομάτων προϊόντων και εμπορικών\nεταιρειών) είναι ιδιοκτησία των αντίστοιχων εταιρειών και προστατεύονται από την αντίστοιχη\nνομοθεσία .")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("10. Επεξεργασία Δεδομένων")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία συλλέγει και χρησιμοποιεί συγκεκριμένα προσωπικά δεδομένα σχετικά με τον Τελικό\nΧρήστη για εμπορικούς σκοπούς. Η Εταιρεία θα χρησιμοποιεί τα δεδομένα αυτά, με τον τρόπο που\nπεριγράφεται στην Πολιτική Απορρήτου της, αντίγραφο της οποίας υπάρχει στην ιστοσελίδα της\nΕταιρεία, και σύμφωνα με την νομοθεσία περί προστασίας προσωπικών δεδομένων (Γενικός\nΚανονισμός για την Προστασία Δεδομένων (EE) 2016/679 (GDPR)). ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Σε σχέση με τη λειτουργία της Υπηρεσίας, η Εταιρεία διατηρεί στις βάσεις δεδομένων της τον αριθμό\nτου κινητού τηλεφώνου από το οποίο έχει ενεργοποιηθεί υπηρεσία , όπως απαιτείται από τις σχετικές\nνομοθετικές διατάξεις, ιδίως για μια περίοδο που επιτρέπει λαμβάνοντας υπόψη τα παράπονα που\nυποβλήθηκαν ή άλλες αξιώσεις σχετικά με την Υπηρεσία. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα στοιχεία των χρηστών θα υποβάλλονται σε επεξεργασία εντός του πεδίου εφαρμογής και για τον\nαναγκαίο σκοπό για την παροχή της Υπηρεσίας (επίσης με σκοπό την εξέταση καταγγελιών) και μετά\nτην ολοκλήρωση της Υπηρεσίας, τα δεδομένα των χρηστών θα αφαιρεθούν, εκτός εάν απαιτείται το\nαντίθετο .Η αποθήκευση ορισμένων δεδομένων για χρονικό διάστημα μεγαλύτερο από την παροχή της\nΥπηρεσίας προκύπτει από τις διατάξεις του νόμου. Η παροχή δεδομένων είναι εθελοντική και γίνεται\nμε τη συναίνεση του χρήστη . Οι χρήστες έχουν, μεταξύ άλλων, το δικαίωμα προβολής, διόρθωσης και\nεπίσης απαίτησης διαγραφής των προσωπικών τους δεδομένων. Ο Χρήστης μπορεί ζητήσει τη\nδιαγραφή ή διόρθωση των προσωπικών του δεδομένων")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Χρησιμοποιώντας τις Υπηρεσίες της Εταιρείας, ο Τελικός Χρήστης συναινεί στην προαναφερθείσα\nεπεξεργασία, διατηρώντας το δικαίωμα να εναντιωθεί σε αυτή την επεξεργασία αποστέλλοντας\nμήνυμα ηλεκτρονικού ταχυδρομείου στη διεύθυνση support@mobivas.gr\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("11. Εκχώρηση")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ο Τελικός Χρήστης δεν δύναται να εκχωρήσει ή να μεταβιβάσει οποιοδήποτε από τα δικαιώματα ή τις\nυποχρεώσεις του, που πηγάζουν από τους Όρους.  ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Εταιρεία έχει δικαίωμα να εκχωρήσει, εν όλω ή εν μέρει, τα δικαιώματα ή τις υποχρεώσεις της, που\nπηγάζουν από τους Όρους χωρίς περιορισμό. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("12. Διάφορα")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αυθυπαρξία εκάστου όρου. Εάν οποιαδήποτε διάταξη των Όρων κριθεί άκυρη ή μη εφαρμόσιμη, δεν\nθα επηρεάσει οποιαδήποτε άλλη διάταξη, και όλες οι λοιπές διατάξεις θα εξακολουθήσουν να ισχύουν\nκαι να παράγουν όλα τα αποτελέσματά τους.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Ανοχή. Η ανοχή, καθυστέρηση ή επιείκεια εκ μέρους της MOBIVAS κατά την εφαρμογή οποιωνδήποτε\nδιατάξεων των Όρων δεν θα προκαλέσει ζημία ή θα επηρεάσει τα δικαιώματά της και τα δικαιώματα\nαποζημίωσης, ούτε οποιαδήποτε παραίτηση αναφορικά με κάποια παράβαση θα ερμηνευθεί ως\nπαραίτηση για επόμενη παράβαση. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Αγγλική Γλώσσα. Σε περίπτωση διάστασης μεταξύ του Αγγλικού και του Ελληνικού κειμένου των Όρων,\nθα υπερισχύει το Αγγλικό κείμενο. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("13. Εφαρμοστέο Δίκαιο και Δικαιοδοσία")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι Όροι θα διέπονται από το Ελληνικό Δίκαιο και οποιαδήποτε διαφορά ανακύψει σχετικά με την\nερμηνεία και/ή την εφαρμογή και/ή την καταγγελία τους θα παραπέμπεται στα Δικαστήρια των\nΑθηνών, τα οποία θα αποφασίζουν επ’ αυτής έχοντας αποκλειστική αρμοδιότητα.\n")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("ΥΠΗΡΕΣΙΑ ΕΝΗΛΙΚΩΝ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"})]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Η Υπηρεσία CUTEMOBI είναι αποκλειστικά διαθέσιμη σε Τελικούς Χρήστες ηλικίας 18 ετών και άνω.\nΣυνεπώς, οι Τελικοί Χρήστες που δηλώνουν ότι είναι ανήλικοι δεν θα δύνανται να εγγραφούν στην\nΥπηρεσία αυτή και η Εταιρεία δεν θα επεξεργάζεται τα προσωπικά τους δεδομένα. Με την εγγραφή\nτους στην Υπηρεσία, οι Τελικοί Χρήστες δηλώνουν ότι είναι 18 ετών και άνω. ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Τα μηνύματα αυτής της Υπηρεσίας λαμβάνονται μέσω του πενταψήφιου κωδικού 54006 ή του 54124")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Οι εβδομαδιαίες Χρεώσεις για τη συνδρομή σε αυτή την Υπηρεσία ανέρχονται σε 2,08 € ανά ληφθέν\nγραπτό μήνυμα ή σε 0,52 € ανά ληφθέν γραπτό μήνυμα, ήτοι συνολική εβδομαδιαία Χρέωση 6,24 €\n(συμπεριλαμβανομένου Φ.Π.Α.) "),_c('a',{attrs:{"href":"https://mobivas.gr/table.html"}},[_vm._v(" Τελική Τιμή Μηνύματος ")]),_vm._v(". Τα γραπτά μηνύματα που αποστέλλονται\nμέσω του πενταψήφιου κωδικού 54303 (κωδικός επιβεβαίωσης, μήνυμα καλωσορίσματος, μηνιαία\nενημέρωση κλπ.) είναι δωρεάν. Η Χρέωση για το γραπτό μήνυμα, που αποστέλλεται από τον Τελικό\nΧρήστη στον πενταψήφιο κωδικό 54006 ή από τον 54124 προκειμένου να ακυρώσει τη συνδρομή του,\nποικίλλει ανάλογα με τον Πάροχο του Τελικού Χρήστη.")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("Δεν είναι δυνατή η αναγνώριση μηνύματος που αποστέλλεται από τον Τελικό Χρήστη στον\nσυγκεκριμένο κωδικό. ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('t&c'))+"\n    \n  ")]),_vm._v(" "),(_vm.country_code_cm == 'greece' && _vm.gateway_code =='paydash')?_c('span',[_c('terms-paydash-greek')],1):_vm._e(),_vm._v(" "),(_vm.country_code_cm == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('terms-mobivas-greek')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Application.jpg": 2232,
	"./Game.jpg": 2233,
	"./Music.jpg": 2234,
	"./Video.jpg": 2235,
	"./Wallpaper.jpg": 2236,
	"./Yummy Recipe.jpg": 2237,
	"./Yummy-Recipe.jpg": 2238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2231;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Application.38f2fdc.jpg";

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Game.59bcd11.jpg";

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Music.d470ef0.jpg";

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Video.b89c4e0.jpg";

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wallpaper.e1a9ce6.jpg";

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy Recipe.a9fdf92.jpg";

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Yummy-Recipe.a5c0378.jpg";

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(772);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9686ce76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2248);
function injectStyle (ssrContext) {
  __webpack_require__(2240)
  __webpack_require__(2241)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9686ce76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9686ce76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(773);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d737c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2244);
function injectStyle (ssrContext) {
  __webpack_require__(2243)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23d737c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d737c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index))])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f7f660_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2247);
function injectStyle (ssrContext) {
  __webpack_require__(2246)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83f7f660"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f7f660_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_cm),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_cm)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.auth_cm === 'loggedin' ? '/home' : '/login'}},[(_vm.country_code_cm === 'greece' && _vm.gateway_code ==='paydash')?_c('div',[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(2249)}})])]):_c('div',[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(2250)}})])])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.auth_cm === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_cm === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.auth_cm === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(742)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_cm)}})])])]),_vm._v(" "),(_vm.auth_cm === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_cm)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpicks")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(_vm._s(_vm.$t("popular")))])],1),_vm._v(" "),(_vm.auth_cm === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.country_cm == 'iq')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):_c('div',[(_vm.country_code_cm != 'greece' && _vm.gateway_code !='paydash')?_c('span',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_cm(_vm.is_unsub_cm)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_vm._e()])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[(_vm.country_code_cm === 'greece')?_c('span',[(_vm.gateway_code === 'mobivas' || _vm.gateway_code ==='paydash')?_c('span',[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-bell icon"}),_vm._v("\n                  "+_vm._s(_vm.$t("t&c"))+"\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/contact"}},[_c('span',{staticClass:"flaticon-phone icon"}),_vm._v("\n                    "+_vm._s(_vm.$t("contact_us"))+"\n                    ")])],1)]):_vm._e(),_vm._v(" "),(_vm.gateway_code ==='paydash')?_c('span',[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/faq"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v("\n                "+_vm._s(_vm.$t("faq"))+"\n              ")])],1)]):_vm._e(),_vm._v(" "),(_vm.gateway_code ==='mobivas')?_c('span',[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1)]):_vm._e()]):_c('span',[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1)])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"})]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cutemobi18-logo.57ae9eb.png";

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cutemobi-logo.4625cdd.png";

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(775);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b382b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(2253);
function injectStyle (ssrContext) {
  __webpack_require__(2252)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34b382b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b382b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_cm(_vm.is_unsub_cm)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cutemobi",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_cutemobi",attrs:{"id":"appBg1"}},[_c('div',{staticClass:"pinkMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cutehub_vue__ = __webpack_require__(776);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3152c2b9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cutehub_vue__ = __webpack_require__(2335);
function injectStyle (ssrContext) {
  __webpack_require__(2256)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cutehub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3152c2b9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cutehub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(777);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c07ddbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(2259);
function injectStyle (ssrContext) {
  __webpack_require__(2258)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c07ddbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c07ddbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_cutehub,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n            "),(_vm.lang_cutehub !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_cutehub)]))]):_vm._e(),_vm._v(" "),(_vm.lang_cutehub === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[(hot.category !== 'Video')?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.id } }}},[(data.content_type === 'application/x-zip-compressed' && data.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: data.id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1)]):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(778);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c00d1af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(2262);
function injectStyle (ssrContext) {
  __webpack_require__(2261)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c00d1af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c00d1af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("allCategories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-6 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_cutehub)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(779);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b487bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(2265);
function injectStyle (ssrContext) {
  __webpack_require__(2264)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28b487bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b487bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello"))+" Jacqueline")])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_cutehub))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_cutehub))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_cutehub))])])]),_vm._v(" "),(_vm.auth_cutehub === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_cutehub != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white"},on:{"click":function($event){return _vm.logout_cutehub(_vm.is_unsub_cutehub)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):(_vm.countryCode === 'fi' && _vm.gateway_code_cutehub === 'nth')?_c('div'):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_cutehub(_vm.is_unsub_cutehub)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(780)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(781);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c92c8f64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(2268);
function injectStyle (ssrContext) {
  __webpack_require__(2267)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c92c8f64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c92c8f64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_cutehub,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getCategoryTranslate(_vm.$route.query.q, _vm.lang_cutehub)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[(_vm.$route.query.q === 'Video')?_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{name: 'DetailPage', params: { id: hot.id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffc838","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])])],1):_c('div',[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: hot.id }
                  }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(782);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46581054_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(2271);
function injectStyle (ssrContext) {
  __webpack_require__(2270)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46581054"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46581054_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_cutehub,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.pagePopular_cutehub),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(783);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_483aefb0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(2277);
function injectStyle (ssrContext) {
  __webpack_require__(2273)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-483aefb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_483aefb0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CutehubSlider_vue__ = __webpack_require__(784);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ca68c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CutehubSlider_vue__ = __webpack_require__(2276);
function injectStyle (ssrContext) {
  __webpack_require__(2275)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CutehubSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ca68c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CutehubSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_cutehub",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_cutehub)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{ name: 'DetailPage', params: { id: hot.id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-4 col-md-3 col-lg-2 col-sm-3 mobiColItem "},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_cutehub))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.getCategoryTitle(_vm.lang_cutehub))+" "+_vm._s(_vm.$t("categories")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('cutehub-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.HotPickIcon_cutehub,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('cutehub-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.PopularIcon_cutehub,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('cutehub-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(785);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a49c3b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(2280);
function injectStyle (ssrContext) {
  __webpack_require__(2279)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01a49c3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a49c3b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_cutehub))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_cutehub)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_cutehub !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_cutehub)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_cutehub)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#fff","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(786);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414ba2e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(2287);
function injectStyle (ssrContext) {
  __webpack_require__(2282)
  __webpack_require__(2283)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-414ba2e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414ba2e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(787);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787b7fea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(2286);
function injectStyle (ssrContext) {
  __webpack_require__(2285)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787b7fea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns cutehub"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(78)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[(_vm.auth_cutehub == 'loggedin')?_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])]):_vm._e(),_vm._v(" "),(_vm.auth_cutehub == 'guest' || _vm.auth_cutehub == '')?_c('div',{staticClass:"dummyPlayer"},[_c('div',{staticClass:"playBtn",attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""},on:{"click":function($event){return _vm.subContent_cutehub([_vm.details.file_url, _vm.details.category])}}},[_c('span',{attrs:{"data-v-3e4079a0":"","data-v-238dec4a":""}})]),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.cover_img,"alt":""}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_cutehub)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":2,"border-color":"#ffc838","rounded-corners":false,"inactive-color":"transparent","star-points":[
        23,
        2,
        14,
        17,
        0,
        19,
        10,
        34,
        7,
        50,
        23,
        43,
        38,
        50,
        36,
        34,
        46,
        19,
        31,
        17
      ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openLightBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_cutehub([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_cutehub([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subContent_cutehub([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(802);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_904e0e8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2290);
function injectStyle (ssrContext) {
  __webpack_require__(2289)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-904e0e8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_904e0e8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_cutehub === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_cutehub !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(803);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78411384_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(2293);
function injectStyle (ssrContext) {
  __webpack_require__(2292)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78411384"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78411384_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("contact_us")))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t("subject")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('select',{attrs:{"id":"select"}},[_c('option',[_vm._v(_vm._s(_vm.$t("select_subject")))]),_vm._v(" "),_c('option',{attrs:{"value":"technical"}},[_vm._v(_vm._s(_vm.$t("app_issue")))]),_vm._v(" "),_c('option',{attrs:{"value":"content"}},[_vm._v(_vm._s(_vm.$t("content")))]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v(_vm._s(_vm.$t("subscription")))])]),_vm._v(" "),_c('span',{staticClass:"arrow__upper"})])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t("message")))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('let_us')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(804);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8507e628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(2296);
function injectStyle (ssrContext) {
  __webpack_require__(2295)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8507e628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8507e628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f3e652c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(2299);
function injectStyle (ssrContext) {
  __webpack_require__(2298)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f3e652c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f3e652c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(806);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114cba10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2302);
function injectStyle (ssrContext) {
  __webpack_require__(2301)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114cba10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114cba10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_cutehub == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_cutehub == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_cutehub == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_cutehub == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_cutehub == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_cutehub == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.lang_cutehub == 'slovakia')?_c('span',[_c('privacy-slovakian')],1):(_vm.country_cutehub == 'sk' && _vm.lang_cutehub == 'english')?_c('span',[_c('privacy-skenglish')],1):(_vm.lang_cutehub == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_cutehub == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_cutehub == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cfc938a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(2314);
function injectStyle (ssrContext) {
  __webpack_require__(2304)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cfc938a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cfc938a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495adbd6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSKSlovak_vue__ = __webpack_require__(2307);
function injectStyle (ssrContext) {
  __webpack_require__(2306)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495adbd6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSKSlovak_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("SLOVENSKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmienky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy upravené: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použiteľnosť")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Termíny a podmienky uvedené nižšie (Všeobecné podmienky) sa\n            vzťahujú na Slovenskú verziu jednorazovej platenej služby Cutehub\n            Premium (Puretech Global Sdn Bhd a /alebo Služba) ponúkanú on -\n            line cez internet od Puretech Global Sdn Bhd (ďalej len Puretech\n            Global Sdn Bhd ). Koncový užívateľ požaduje službu Cutehub z\n            Puretech Global Sdn Bhd .\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Všeobecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Cutehub poskytuje najlepšie sexy tapety a videá exkluzívne pre váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrdenie / Registrácia")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Na vstup do služby Cutehub musí Koncový používateľ zadať svoje\n            mobilné telefónne číslo a /alebo niektoré ďalšie údaje a /alebo\n            informácie prostredníctvom propagačnej webovej stránky (Vstupné\n            Stránky) prevádzkovanej Puretech Global Sdn Bhd -om. Potom Koncový\n            užívateľ dostane SMS vo svojom mobilnom zariadení, s Osobným\n            Identifikačným Číslom (PIN kód), alebo tzv ponukovú správu s\n            informáciami o službe. Zadaním obdržaného PIN kódu na vstupnej\n            stránke a /alebo zaslaním potvrdzovacej správy a /alebo používaním\n            služby Koncový užívateľ uznáva a potvrdzuje, že prečítal Všeobecné\n            obchodné podmienky, je oprávneným držiteľom mobilného účtu za\n            telefón, alebo má súhlas platiteľa telefóneho účtu používať túto\n            službu. Koncový užívateľ dostane potvrdzujúcu SMS správu o\n            úspešnej aktivácii Cutehub služby, spôsobe, frekvencii a nákladov\n            na prevzatie Služby, rovnako ako presné detaily odhlásenia.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a Poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Cutehub je platená služba ktorá stojí 3 SMS x 1.60 EUR / týždeň\n            Poplatok bude účtovaný na mobilný telefónny účet, alebo\n            predplatené mobilné číslo.Spôsob nabíjania je Premium MT SMSkami\n            odoslanými na Koncového užívateľa na základe jeho žiadosti o\n            službu Cutehub. Táto správa bude obsahovať prihlasovacie údaje k\n            službe Cutehub. Poplatky sú vyberané podľa Prevádzkovateľov\n            Mobilných Sietí. Poplatky sú odpísané proti účtu Koncového\n            užívateľa Prevádzkovateľom, v prípade predplantnej SIM sa poplatky\n            odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ týmto\n            výslovne udeľuje jeho alebo jej oprávnenie pre nabíjanie, a\n            zaväzuje sa na zaplatenie v plnej výške za poplatky, ktoré vznikli\n            v dôsledku upísania a / alebo používania služby Cutehub. Ak nie\n            ste osoba zodpovedná za zaplatenie mobilného účtu, prosím,\n            získajte povolenie od platiteľa mobilu pred prihlásením a /alebo\n            používaním služby Cutehub. Svojím podpisom a /alebo účasťou na\n            službe, Puretech Global Sdn Bhd predpokladá, že Koncový užívateľ\n            získal potrebné povolenie, súhlas alebo schválenie od platiteľa\n            mobilného účtu, opatrovníka alebo rodičov. Všetky SMS správy\n            zaslané Koncovým používateľom budú účtované mobilným operátorom\n            Koncového užívateľa štandardnou tarifou. Tieto tarify sa môžu\n            líšiť podľa operátora. Prosím, pre viac nformácií o uložených\n            poplatkoch kontaktujte svojho GSM operátora.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznícky servis je k dispozícii v pracovných dňoch od 09:00 do\n            17:00 Kontakt: +421 313215999 alebo cutehub.sk@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševné vlastníctvo")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu môžete použiť na svoje osobné nekomerčné použitie. Termín\n            Cutehub a všetky ostatné ochranné známky, servisné značky a /alebo\n            obchodné názvy používané Cutehub-om na Službe z času na čas\n            (Ochranné Známky), sú ochrannými známkami, servisnými značkami a\n            /alebo obchodnými názvami Puretech Global Sdn Bhd - u alebo jednej\n            z jeho spoločností v skupine alebo udeľovateľov jej licencie, a\n            tieto subjekty si vyhradzujú všetky práva na Ochranné Známky.\n            Okrem toho, ďalší obsah Služby, vrátane, ale nie výhradne, Hry,\n            obrázy, obrázky, grafika, fotografie, animácie, videá, hudba, zvuk\n            a text patria Cutehub- u, alebo jednému z jeho spoločností a\n            /alebo licenčných skupín, a sú chránené autorskými právami a\n            /alebo inými právami duševného vlastníctva. Beriete týmto na\n            vedomie, že pri používaní Služby nezískate žiadne práva na\n            ochranné známky, alebo Obsah Služby, než ako je uvedené v tejto\n            Dohode. Najmä za žiadnych okolností nemôžete skopírovať ľubovoľný\n            Obsah Služby (vrátane a bez obmedzenia trivia otázky, odpovede,\n            alebo hry), alebo využívať dolovanie dát, roboty, škrabanie\n            obrazovky, alebo podobné zhromažďovanie údajov a extrakčné\n            nástroje na Službe. Zodpovednosť Použitie Cutehub- u a /alebo web\n            stránky Cutehub prebieha na vlastné riziko koncového užívateľa.\n            Koncový užívateľ musí poskytnúť všetko- kompatibilný mobilný\n            telefón, hardvér, alebo iné zariadenia a softvér, a zabezpečiť,\n            aby boli v prevádzkyschopnom stave a vhodné na služby Cutehub.\n            Cutehub nemôže zaručiť, že služby Cutehub spĺňajú požiadavky\n            koncového užívateľa, a že stiahnutie, príjem a /alebo prezeranie\n            služieb Cutehub bude bez prerušenia, alebo chýb. Ak kedykoľvek\n            Koncový užívateľ nie je schopný používať bez prerušenia službu\n            Puretech Global Sdn Bhd , v žiadnom prípade to nevedie k nároku na\n            zníženie poplatkov za Cutehub služby, k akékoľvek právo na\n            vrátenie platieb dopredu zaplatených. Akékoľvek použitie služieb\n            Cutehub je podľa vlastného uváženia a rizika koncového užívateľa,\n            a že za žiadny ale nie obmedzene, za infekcie, alebo kontaminácie,\n            alebo straty dát, alebo poškodenie(ia) hardvéru a /alebo softvéru\n            koncových užívateľov, vyplývajúcich z prístupu k webovým stránkam,\n            alebo využívania služieb Cutehub -u, alebo stiahnutých Cutehub\n            služieb, vrátane hardvéru a softvéru vyžadovaného na pripojenie k\n            službám Cutehub . Je zodpovednosťou koncových užívateľov, aby\n            prijali potrebné opatrenia, aby sa zabránilo možnému poškodeniu\n            tohto druhu. V prípade, že Cutehub je z akéhokoľvek dôvodu povinný\n            nahradiť koncovému užívateľovi priame, alebo následné škody\n            akéhokoľvek druhu, takáto náhrada v žiadnom prípade nesmie\n            prekročiť hodnotu faktúry za služby Cutehub , platených koncovým\n            užívateľom pre údajné poškodenia. Obsah Webovej stránky bol\n            zostavený s najväčšou starostlivosťou. Avšak, Cutehub nemôže\n            poskytnúť žiadnu záruku, pokiaľ ide o povahu, presnosť alebo obsah\n            týchto informácií. Cutehub nenesie zodpovednosť za akékoľvek\n            chyby, opomenutia, nepresnosti, nedorozumenia, oneskorenie, alebo\n            nečitateľné objednávky, alebo oznámenia na základe používania\n            Internetu, alebo príslušného informačného miesta. Záverečné\n            ustanovenia Akékoľvek spory týkajúce sa plnenia týchto Obchodných\n            podmienok budú riešené príslušnými všeobecnými súdmi. Puretech\n            Global Sdn Bhd si vyhradzuje právo čas od času zmeniť tieto\n            podmienky. Zmeny budú oznámené koncovým užívateľom vyvesením na\n            portáli Cutehub.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961efe92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCZCzech_vue__ = __webpack_require__(2310);
function injectStyle (ssrContext) {
  __webpack_require__(2309)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961efe92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCZCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ČESKÝ TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Všeobecné podmínky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Naposledy změněno: 13/08/2021")]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Použitelnost")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou\n            verzi Jednorázové placené prémiové služby Cutehub (Puretech Global\n            Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu\n            od společnosti Puretech Global Sdn Bhd (dále jen jako Puretech\n            Global Sdn Bhd). Koncový uživatel požaduje službu Cutehub od\n            společnosti Puretech Global Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. Obecné")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Cutehub poskytuje nejlepší sexy tapety a videa výhradně pro váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("3. Potvrdenie / Registrácia")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Aby koncový uživatel získal přístup k Cutehub, musí zadat číslo\n            svého mobilního telefonu a / nebo určitá další data a / nebo\n            informace prostřednictvím propagační webové stránky (Landing Page)\n            provozované společností Puretech Global Sdn Bhd. Poté koncový\n            uživatel obdrží na svůj mobilní telefon SMS , s osobním\n            identifikačním číslem (PIN kód) nebo takzvanou nabídkovou zprávou\n            s informacemi o službě. Koncový uživatel zadáním přijatého PIN\n            kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a /\n            nebo používáním služby potvrzuje a potvrzuje, že si přečetl\n            Všeobecné podmínky, je autorizovaným majitelem účtu mobilního\n            telefonu nebo má souhlas plátce telefonního účtu s využitím této\n            služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné\n            aktivaci služby Cutehub, způsobu, frekvenci a nákladech na stažení\n            Služby a také přesné údaje o odhlášení.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Náklady a poplatky")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Cutehub je placená služba, která stojí 3 SMS x 1,60 EUR / týden\n            Poplatek bude účtován na účet za mobilní telefon nebo na\n            předplacené mobilní číslo. Způsob účtování je Premium MT SMS\n            zasílaná Koncovému uživateli na základě jeho požadavku na službu\n            Cutehub. Tato zpráva bude obsahovat vaše přihlašovací údaje do\n            Cutehub. Poplatky se vybírají podle provozovatelů mobilních sítí.\n            Poplatky jsou odepsány na účet Koncového uživatele Provozovatelem;\n            v případě SIM s předplatným jsou poplatky odečteny z kreditu\n            Koncového uživatele. Koncový uživatel tímto výslovně uděluje své\n            oprávnění účtovat poplatky a zavazuje se zaplatit v plné výši\n            poplatky vzniklé v důsledku předplatného a / nebo používání služby\n            Cutehub. Pokud nejste osobou odpovědnou za placení účtů za mobilní\n            zařízení, před přihlášením a / nebo použitím aplikace Cutehub si\n            vyžádejte povolení od svého mobilního plátce. Podpisem a / nebo\n            účastí ve službě Puretech Global Sdn Bhd předpokládá, že koncový\n            uživatel získal potřebné povolení, souhlas nebo schválení od\n            plátce mobilního účtu, opatrovníka nebo rodičů. Všechny SMS zprávy\n            zasílané koncovým uživatelem budou mobilním operátorem koncového\n            uživatele účtovány za standardní tarif. Tyto sazby se mohou u\n            jednotlivých operátorů lišit. Další informace o poplatcích vám\n            poskytne váš mobilní operátor GSM.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Pomoc a podpora")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00\n            Kontakt: +421 313215999 nebo cutehub.cz@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Duševní vlastnictví")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu můžete používat pro osobní, nekomerční použití. Pojem\n            Cutehub a všechny ostatní ochranné známky, servisní značky a /\n            nebo obchodní názvy, které čas od času používá Cutehub ve službě\n            (ochranné známky), jsou ochranné známky, servisní značky a / nebo\n            obchodní názvy společnosti Puretech Global Sdn Bhd nebo jedné z\n            jejích společností v skupina nebo její poskytovatelé licencí a\n            tyto subjekty si vyhrazují veškerá práva k ochranným známkám.\n            Kromě toho další obsah Služeb, mimo jiné včetně her, obrázků,\n            obrázků, grafik, fotografií, animací, videí, hudby, zvuku a textu,\n            patří společnosti Cutehub nebo jedné z jejích společností a / nebo\n            licencovaných skupin a jsou chráněny autorským právem a / nebo\n            jinými právy duševního vlastnictví. Berete na vědomí, že\n            používáním Služby nezískáte žádná práva na ochrannou známku ani\n            Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných\n            okolností nesmíte za žádných okolností kopírovat jakýkoli obsah\n            služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo\n            her), ani ve službě používat dolování dat, roboty, škrábance na\n            obrazovce nebo podobné nástroje pro sběr a extrakci dat.\n            Odpovědnost Používání webu Cutehub a / nebo webu Cutehub je na\n            vlastní riziko koncového uživatele. Koncový uživatel musí\n            poskytnout kompatibilní mobilní telefon, hardware nebo jiné\n            vybavení a software a zajistit, aby byly v provozuschopném stavu a\n            vhodné pro služby Cutehub. Cutehub nemůže zaručit, že služby\n            Cutehub splňují požadavky koncového uživatele a že stahování,\n            příjem a / nebo prohlížení služeb Cutehub bude nepřerušované nebo\n            bez chyb. Pokud koncový uživatel kdykoli nemůže bez přerušení\n            používat službu Puretech Global Sdn Bhd, v žádném případě to\n            nezakládá právo na snížení poplatků za službu Cutehub, jakékoli\n            právo na vrácení předplacených plateb. Jakékoli použití Služeb\n            Cutehub je na uvážení a riziku koncového uživatele, a to za,\n            nikoli však výhradně, infekci nebo kontaminaci, ztrátu dat nebo\n            poškození hardwaru a / nebo softwaru koncového uživatele z\n            přístupu na Web, nebo používat Služby Cutehub nebo stažené Služby\n            Cutehub, včetně hardwaru a softwaru potřebného k připojení ke\n            Službám Cutehub. Je odpovědností koncových uživatelů, aby přijali\n            nezbytná opatření, která zabrání možnému poškození tohoto druhu. V\n            případě, že je Cutehub z jakéhokoli důvodu povinen odškodnit\n            koncového uživatele za přímé nebo následné škody jakéhokoli druhu,\n            nesmí taková náhrada v žádném případě překročit hodnotu faktury za\n            služby Cutehub zaplacené koncovým uživatelem za údajné škody.\n            Obsah webových stránek byl sestaven s největší péčí. Společnost\n            Cutehub však nemůže poskytnout žádnou záruku, pokud jde o povahu,\n            přesnost nebo obsah těchto informací. Cutehub neodpovídá za žádné\n            chyby, opomenutí, nepřesnosti, nedorozumění, zpoždění nebo\n            nečitelné objednávky nebo oznámení založená na používání internetu\n            nebo příslušného informačního bodu. Závěrečná ustanovení Veškeré\n            spory týkající se plnění těchto Obchodních podmínek budou řešit\n            příslušné obecné soudy. Puretech Global Sdn Bhd si vyhrazuje právo\n            čas od času tyto podmínky změnit. Změny budou koncovým uživatelům\n            oznámeny zveřejněním na portálu Cutehub.\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(808);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_029ee886_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(2313);
function injectStyle (ssrContext) {
  __webpack_require__(2312)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_029ee886_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('p',{staticClass:"mobitxt"},[_vm._v("ENGLISH TEXT")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("General conditions")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("Last modified: 13/08/2021")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Customer service is available on working days from 09:00 to 17:00\n            Contact: +421 313215999 or cutehub."+_vm._s(_vm.country)+"@silverlines.info\n          ")])]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("1. Applicability")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            The terms and conditions below (General Terms and Conditions)\n            apply to the English version of the One-Time Paid Cutehub Premium\n            Service (Puretech Global Sdn Bhd and / or the Service) offered\n            online via the Internet from Puretech Global Sdn Bhd (hereinafter\n            referred to as Puretech Global Sdn Bhd). The end user requests the\n            Cutehub service from Puretech Global Sdn Bhd.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("2. General")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Cutehub provides the best sexy wallpapers and videos exclusively\n            for your mobile.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("\n            3. Confirmation / Registration\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            To access Cutehub, the End User must enter their mobile phone\n            number and / or certain other data and / or information through a\n            promotional website (Landing Page) operated by Puretech Global Sdn\n            Bhd. Then the End User will receive an SMS on his mobile device,\n            with a Personal Identification Number (PIN code), or a so-called\n            offer message with information about the service. By entering the\n            received PIN code on the landing page and / or sending a\n            confirmation message and / or using the service, the End User\n            acknowledges and confirms that he has read the General Terms and\n            Conditions, is an authorized mobile phone account holder or has\n            the consent of the telephone account payer to use this service.\n            The end user will receive a confirmation SMS message about the\n            successful activation of the Cutehub service, the method,\n            frequency and costs of downloading the Service, as well as the\n            exact details of the logout.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("4. Costs and Fees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Cutehub is a paid service that costs 3 SMS x 1.60 EUR / week The\n            fee will be charged to a mobile phone bill or a prepaid mobile\n            number. The method of charging is Premium MT SMS sent to the End\n            User based on his request for the Cutehub service. This message\n            will include your Cutehub login. Fees are collected according to\n            Mobile Network Operators. Fees are written off against the End\n            User's account by the Operator; in the case of a pre-subscription\n            SIM, the fees are deducted from the End User's credit. The End\n            User hereby expressly grants his or her authorization to charge,\n            and undertakes to pay in full for the fees incurred as a result of\n            subscribing to and / or using the Cutehub Service. If you are not\n            the person responsible for paying your mobile bill, please get\n            permission from your mobile payer before signing in and / or using\n            Cutehub. By signing and / or participating in the Service,\n            Puretech Global Sdn Bhd assumes that the End User has obtained the\n            necessary permission, consent or approval from the mobile account\n            payer, guardian or parents. All SMS messages sent by the End User\n            will be charged by the End User's mobile operator at a standard\n            tariff. These rates may vary by operator. Please contact your GSM\n            operator for more information on charges.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("5. Help And Support")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_vm._v("6. Intellectual Property")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p',{staticClass:"mobitxt"},[_vm._v("\n            You may use the Service for your personal, non-commercial use. The\n            term Cutehub and all other trademarks, service marks and / or\n            trade names used by Cutehub on the Service from time to time\n            (Trademarks) are trademarks, service marks and / or trade names of\n            Puretech Global Sdn Bhd or one of its companies in the group or\n            its licensors, and these entities reserve all rights to the\n            Trademarks. In addition, other content of the Services, including,\n            but not limited to, Games, images, pictures, graphics,\n            photographs, animations, videos, music, sound and text belong to\n            Cutehub or one of its companies and / or licensed groups, and are\n            protected by copyright and / or other intellectual property\n            rights. You acknowledge that, through your use of the Service, you\n            will not acquire any trademark rights or Content of the Service\n            other than as set forth in this Agreement. In particular, under no\n            circumstances may you copy any Content of the Service (including,\n            without limitation, trivia questions, answers, or games), or use\n            data mining, robots, screen scratches, or similar data collection\n            and extraction tools on the Service. Liability Use of the Cutehub\n            and / or the Cutehub website is at the end user's own risk. The\n            end user must provide a compatible mobile phone, hardware, or\n            other equipment and software, and ensure that they are in working\n            order and suitable for Cutehub services. Cutehub cannot guarantee\n            that the Cutehub Services meet the requirements of the end user\n            and that the download, receipt and / or viewing of the Cutehub\n            Services will be uninterrupted or error free. If at any time the\n            End User is unable to use the Puretech Global Sdn Bhd service\n            without interruption, this in no way leads to the right to a\n            reduction in fees for the Cutehub service, to any right to a\n            refund of prepaid payments. Any use of the Cutehub Services is at\n            the end user's discretion and risk, and that for no, but not\n            limited to, infection, or contamination, or loss of data, or\n            damage (s) to end-user hardware and / or software resulting from\n            access to the Website , or use the Cutehub Services, or downloaded\n            Cutehub Services, including the hardware and software required to\n            connect to the Cutehub Services. It is the responsibility of\n            end-users to take the necessary measures to prevent possible\n            damage to this species. In the event that Cutehub is obliged for\n            any reason to compensate the end user for direct or consequential\n            damages of any kind, such compensation may in no case exceed the\n            value of the invoice for Cutehub services paid by the end user for\n            the alleged damages. The content of the Website has been compiled\n            with the greatest care. However, Cutehub cannot provide any\n            guarantee as to the nature, accuracy or content of this\n            information. Cutehub is not responsible for any errors, omissions,\n            inaccuracies, misunderstandings, delays, or illegible orders, or\n            notices based on the use of the Internet or the relevant\n            information point. Final Provisions Any disputes concerning the\n            fulfillment of these Business Conditions will be resolved by the\n            competent general courts. Puretech Global Sdn Bhd reserves the\n            right to change these terms from time to time. Changes will be\n            announced to end users by posting on the Cutehub portal.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("terms"))+"\n  ")]),_vm._v(" "),(_vm.lang_cutehub == 'slovakia')?_c('span',[_c('terms-sk-slovak')],1):(_vm.lang_cutehub == 'czech')?_c('span',[_c('terms-cz-czech')],1):_c('span',[_c('terms-english',{attrs:{"country":_vm.country_cutehub}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Application.jpg": 2316,
	"./Game.jpg": 2317,
	"./Music.jpg": 2318,
	"./Video.jpg": 2319,
	"./Wallpaper.jpg": 2320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2315;

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Application.38f2fdc.jpg";

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Game.59bcd11.jpg";

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Music.d470ef0.jpg";

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Video.70ffa39.jpg";

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wallpaper.0d37f3f.jpg";

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(810);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46fcc4d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2330);
function injectStyle (ssrContext) {
  __webpack_require__(2322)
  __webpack_require__(2323)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46fcc4d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46fcc4d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b35b71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2326);
function injectStyle (ssrContext) {
  __webpack_require__(2325)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57b35b71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b35b71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index))])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_416aea61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2329);
function injectStyle (ssrContext) {
  __webpack_require__(2328)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-416aea61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_416aea61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_cutehub),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_cutehub)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.auth_cutehub == 'loggedin' || _vm.auth_cutehub == 'guest' ? '/home' : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(2331)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.auth_cutehub === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.auth_cutehub === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.auth_cutehub === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(780)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_cutehub)}})])])]),_vm._v(" "),(_vm.auth_cutehub === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_cutehub)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link ",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpicks")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link ",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(_vm._s(_vm.$t("popular")))])],1),_vm._v(" "),(_vm.auth_cutehub === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.country_cutehub == 'iq')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},attrs:{"data-toggle":"modal","data-target":"#exampleModalCenter"}},[_vm._v("\n                "+_vm._s(_vm.$t("unsubscribe"))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.country_cutehub === 'fi' && _vm.gateway_code_cutehub === 'nth')?_c('div'):_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},on:{"click":function($event){return _vm.logout_cutehub(_vm.is_unsub_cutehub)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2331 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__ = __webpack_require__(813);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076af2b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__ = __webpack_require__(2334);
function injectStyle (ssrContext) {
  __webpack_require__(2333)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-076af2b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076af2b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"exampleModalCenter","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered custom",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_vm._v(_vm._s(_vm.$t('modal_title')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n            "+_vm._s(_vm.$t('unsub_confirmation'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('a',{staticClass:"btn  btn-danger",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){return _vm.logout_cutehub(_vm.is_unsub_cutehub)}}},[_vm._v(_vm._s(_vm.$t('yes')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cutehub",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('UnsubModal'),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_cutehub",attrs:{"id":"appBg1"}},[_c('div',{staticClass:"cutehubMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Apps4all_vue__ = __webpack_require__(814);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17ac64d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Apps4all_vue__ = __webpack_require__(2403);
function injectStyle (ssrContext) {
  __webpack_require__(2337)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Apps4all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17ac64d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Apps4all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(815);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3cc0e86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(2340);
function injectStyle (ssrContext) {
  __webpack_require__(2339)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3cc0e86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3cc0e86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.category),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_a4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_a4all !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_a4all)]))]):_vm._e(),_vm._v(" "),(_vm.lang_a4all === 'english')?_c('span',[_vm._v(_vm._s(hot.category))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.category } }}},[_vm._v(_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getAllData()[hot.category]),function(data){return _c('div',{key:data.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem",class:_vm.getAllData()[hot.category]['class']},[(data.parent_category === hot.category)?_c('div',[_c('router-link',{staticClass:"mobiApp",attrs:{"to":{name: 'DetailPage', params: { id: data.content_id } }}},[(data.content_type == 'application/x-zip-compressed' && data.parent_category == 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":data.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(data[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(data["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#ffe000","inactive-color":"#00923d","active-color":"#ffe000","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(data.rating)}})],1)])])],1):_vm._e()])}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(816);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865d6b1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(2343);
function injectStyle (ssrContext) {
  __webpack_require__(2342)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-865d6b1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865d6b1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("allCategories")))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.$props.browse.category),function(cat){return _c('router-link',{key:cat.key,staticClass:"col-12 col-md-4 col",attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('div',{staticClass:"thumbCol"},[_c('div',{staticClass:"thumbCol__cover"},[_c('img',{attrs:{"src":cat.coverImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"thumbCol__wrap"},[_c('span',{class:cat.icon}),_vm._v(" "),_c('div',[_c('h2',{staticClass:"thumbCol__label"},[_vm._v(_vm._s(cat[("title_" + _vm.lang_a4all)].toUpperCase()))])])])])])}),1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(817);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_652c31f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(2346);
function injectStyle (ssrContext) {
  __webpack_require__(2345)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-652c31f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_652c31f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello"))+"!")])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content userProfile"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_a4all))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_a4all))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_a4all))])])]),_vm._v(" "),(_vm.authentication_a4all === 'loggedin')?_c('div',{staticClass:"btnContainer "},[(_vm.is_unsub_a4all != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":""},on:{"click":function($event){return _vm.logout_a4all(_vm.is_unsub_a4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):(_vm.countryCode === 'fi')?_c('div'):_c('div',[_c('a',{staticClass:"mobiBtn",attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_a4all(_vm.is_unsub_a4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(818)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(819);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75a5a80e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(2349);
function injectStyle (ssrContext) {
  __webpack_require__(2348)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75a5a80e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75a5a80e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_a4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_a4all)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiApp ",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[(hot.content_type === 'application/x-zip-compressed' && hot.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":3,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(820);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66333c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(2352);
function injectStyle (ssrContext) {
  __webpack_require__(2351)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66333c6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66333c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_a4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_a4all),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":3,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(821);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3dddac4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(2358);
function injectStyle (ssrContext) {
  __webpack_require__(2354)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3dddac4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3dddac4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Apps4allSlider_vue__ = __webpack_require__(822);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ff3b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Apps4allSlider_vue__ = __webpack_require__(2357);
function injectStyle (ssrContext) {
  __webpack_require__(2356)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Apps4allSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ff3b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Apps4allSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_a4all",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color1"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_a4all)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":2,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":3,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":2,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem "},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(62)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":3,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.getCategoryTitle(_vm.lang_a4all))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.getCategoryTitle(_vm.lang_a4all))+" "+_vm._s(_vm.$t("categories")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.subCategory === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.subCategory === true)?_c('div',{staticClass:"mobislider"},[_c('a4all-slider',{ref:"childComponent",attrs:{"sliderData":_vm.subcategory,"cat":_vm.cat.sub,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotPick_a4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.hotpicks === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.hotpicks === true)?_c('div',{staticClass:"sliderWrap"},[_c('a4all-slider',{ref:"hotPickComponent",attrs:{"hotpick":_vm.hotpicks,"cat":_vm.cat.hot,"category":_vm.category}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_a4all,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.isLoaded.popular === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoaded.popular === true)?_c('div',{staticClass:"sliderWrap"},[_c('a4all-slider',{ref:"popularComponent",attrs:{"popular":_vm.popular,"cat":_vm.cat.pop,"category":_vm.category}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(823);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b533c8ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(2361);
function injectStyle (ssrContext) {
  __webpack_require__(2360)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b533c8ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b533c8ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.lang_a4all))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[(_vm.isLoaded === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.lang_a4all)))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[(_vm.category === 'video')?_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
                    name: 'DetailPage',
                    params: { id: hot.id }
                    }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#00923d","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-3 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.id }
                  }}},[(dat.content_type === 'application/x-zip-compressed' && dat.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(2362)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffc838","show-rating":false,"border-width":3,"border-color":"#feb801","rounded-corners":false,"inactive-color":"#00923d","star-points":[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(824);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0131bbe8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(2368);
function injectStyle (ssrContext) {
  __webpack_require__(2364)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0131bbe8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(825);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0301a068_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(2367);
function injectStyle (ssrContext) {
  __webpack_require__(2366)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0301a068"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0301a068_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_a4all)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":2,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[(_vm.details.category === 'Wallpaper')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_a4all([_vm.details.file_url, _vm.details.category, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])]):_vm._e(),_vm._v(" "),(_vm.details.category !== 'Wallpaper')?_c('div',[(_vm.details.content_type === 'application/url')?_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_a4all([_vm.details.content_detail, _vm.details.content_type, _vm.id])}}},[_c('span',[_vm._v(_vm._s(_vm.$t("play")))])])]):_c('div',[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_a4all([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(840);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa3f8d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2371);
function injectStyle (ssrContext) {
  __webpack_require__(2370)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faa3f8d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa3f8d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v("\n            "+_vm._s(_vm.$t("confirmation"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_a4all === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_a4all !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(841);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535decbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(2374);
function injectStyle (ssrContext) {
  __webpack_require__(2373)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-535decbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535decbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle md text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t("contact_us")))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t("subject")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('select',{attrs:{"id":"select"}},[_c('option',[_vm._v(_vm._s(_vm.$t("select_subject")))]),_vm._v(" "),_c('option',{attrs:{"value":"technical"}},[_vm._v(_vm._s(_vm.$t("app_issue")))]),_vm._v(" "),_c('option',{attrs:{"value":"content"}},[_vm._v(_vm._s(_vm.$t("content")))]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v(_vm._s(_vm.$t("subscription")))])]),_vm._v(" "),_c('span',{staticClass:"arrow__upper"})])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t("message")))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('let_us')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(842);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fdd9a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(2377);
function injectStyle (ssrContext) {
  __webpack_require__(2376)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61fdd9a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fdd9a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(843);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf6c918_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2380);
function injectStyle (ssrContext) {
  __webpack_require__(2379)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf6c918_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_a4all == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_a4all == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_a4all == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_a4all == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_a4all == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_a4all == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):(_vm.lang_a4all == 'swedish')?_c('span',[_c('privacy-swedish')],1):(_vm.lang_a4all == 'finnish')?_c('span',[_c('privacy-finnish')],1):(_vm.lang_a4all == 'romanian')?_c('span',[_c('privacy-romanian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(844);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b26dbf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(2389);
function injectStyle (ssrContext) {
  __webpack_require__(2382)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b26dbf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__ = __webpack_require__(845);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43bcff90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__ = __webpack_require__(2384);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEnglish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43bcff90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEnglish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Help and support")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Customer service is available on working days from 09:00 to 17:00\n            Contact: +421 313215999 or apps4all."+_vm._s(_vm.countryCode)+"@silverlines.info\n          ")])]),_vm._v(" "),_vm._m(4)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Conditions and Requirements\n          ")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Applicability")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            The terms and conditions below (General Terms and Conditions)\n            apply to the English version of the one-time paid service APPS4ALL\n            Premium (Puretech Global Sdn Bhd and / or the Service) offered\n            online via the Internet from Puretech Global Sdn Bhd (hereinafter\n            referred to as Puretech Global Sdn Bhd). End User Requires\n            APPS4ALL Puretech Global Sdn Bhd.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Generally")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            APPS4ALL provides the best sexy wallpapers and videos exclusively\n            for your mobile.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("\n            Confirmation / Registration\n          ")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            To access the APPS4ALL service, the End User must enter their\n            mobile telephone number and / or some other data and / or\n            information through a promotional website (Landing Page) operated\n            by Puretech Global Sdn Bhd. Then the End User will receive an SMS\n            on his mobile device, with a Personal Identification Number (PIN\n            code), or a so-called offer message with information about the\n            service. By entering the received PIN code on the landing page and\n            / or sending a confirmation message and / or using the service,\n            the End User acknowledges and confirms that he has read the\n            General Terms and Conditions, is an authorized mobile phone\n            account holder or has the consent of the telephone account payer\n            to use this service. The end user will receive a confirmation SMS\n            message about the successful activation of the APPS4ALL service,\n            the method, frequency and costs of taking over the Service, as\n            well as the exact details of the logout.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Costs and Fees")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            APPS4ALL is a paid service that costs 3 SMS x 1.60 EUR / week The\n            fee will be charged to a mobile phone account or a prepaid mobile\n            number. The method of charging is Premium MT SMS sent to the End\n            User based on his request for the APPS4ALL service. This message\n            will contain the APPS4ALL service credentials. Fees are collected\n            according to Mobile Network Operators. Fees are written off\n            against the End User's account by the Operator; in the case of a\n            pre-subscription SIM, the fees are deducted from the End User's\n            credit. The End User hereby expressly grants his or her\n            authorization to charge, and undertakes to pay in full for the\n            fees incurred as a result of subscribing to and / or using the\n            APPS4ALL Service. If you are not the person responsible for paying\n            your mobile bill, please obtain permission from your mobile payer\n            before signing in and / or using APPS4ALL. By signing and / or\n            participating in the Service, Puretech Global Sdn Bhd assumes that\n            the End User has obtained the necessary permission, consent or\n            approval from the mobile account payer, guardian or parents. All\n            SMS messages sent by the End User will be charged by the End\n            User's mobile operator at a standard tariff. These rates may vary\n            by operator. Please contact your GSM operator for more information\n            on charges.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Intellectual Property")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            You may use the Service for your personal, non-commercial use. The\n            term Miximo and all other trademarks, service marks and / or trade\n            names used by Miximo on the Service from time to time (Trademarks)\n            are trademarks, service marks and / or trade names of Puretech\n            Global Sdn Bhd or one of its companies in the group or its\n            licensors, and these entities reserve all rights to the\n            Trademarks. In addition, other content services, including, but\n            not limited to, Games, images, pictures, graphics, photographs,\n            animations, videos, music, sound and text belong to APPS4ALL or\n            one of its companies and / or licensed groups, and are protected\n            by copyright and / or other intellectual property rights. You\n            acknowledge that, through your use of the Service, you will not\n            acquire any trademark rights or Content of the Service other than\n            as set forth in this Agreement. In particular, under no\n            circumstances may you copy any Content of the Service (including,\n            without limitation, trivia questions, answers, or games), or use\n            data mining, robots, screen scratches, or similar data collection\n            and extraction tools on the Service. Liability Use of APPS4ALL and\n            / or the APPS4ALL website is at the end user's own risk. The end\n            user must provide an all-compatible mobile phone, hardware, or\n            other equipment and software, and ensure that they are operational\n            and suitable for APPS4ALL services. APPS4ALL cannot guarantee that\n            APPS4ALL services meet the requirements of the end user and that\n            downloading, receiving and / or viewing APPS4ALL services will be\n            uninterrupted or error free. If at any time the End User is unable\n            to use the Puretech Global Sdn Bhd service without interruption,\n            this shall in no way lead to the right to a reduction in fees for\n            APPS4ALL services, to any right to a refund of prepaid payments.\n            Any use of the APPS4ALL Services is at the end user's discretion\n            and risk, and that for no, but not limited to, infections, or\n            contamination, or loss of data, or damage (s) to end-user hardware\n            and / or software resulting from access to the Website. , or use\n            of APPS4ALL Services, or downloaded APPS4ALL Services, including\n            hardware and software required to connect to APPS4ALL Services. It\n            is the responsibility of end-users to take the necessary measures\n            to prevent possible damage to this species. In the event that\n            APPS4ALL is obliged for any reason to compensate the end user for\n            direct or consequential damages of any kind, such compensation may\n            in no case exceed the value of the invoice for APPS4ALL services\n            paid by the end user for the alleged damages. The content of the\n            Website has been compiled with the greatest care. However,\n            APPS4ALL cannot provide any guarantee as to the nature, accuracy\n            or content of this information. APPS4ALL shall not be liable for\n            any errors, omissions, inaccuracies, misunderstandings, delays, or\n            illegible orders, or notices based on the use of the Internet or\n            the relevant information point. Final Provisions Any disputes\n            concerning the fulfillment of these Business Conditions will be\n            resolved by the competent general courts. Puretech Global Sdn Bhd\n            reserves the right to change these terms from time to time.\n            Changes will be announced to end users by posting on the APPS4ALL\n            portal.\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSlovakia_vue__ = __webpack_require__(846);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6187321d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovakia_vue__ = __webpack_require__(2386);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSlovakia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6187321d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSlovakia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("podmienky a požiadavky")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Použiteľnosť")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Termíny a podmienky uvedené nižšie (Všeobecné podmienky) sa\n            vzťahujú na Slovenskú verziu jednorazovej platenej služby APPS4ALL\n            Premium (Puretech Global Sdn Bhd a /alebo Služba) ponúkanú on -\n            line cez internet od Puretech Global Sdn Bhd (ďalej len Puretech\n            Global Sdn Bhd). Koncový užívateľ požaduje službu APPS4ALL\n            Puretech Global Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Všeobecné")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            APPS4ALL poskytuje najlepšie sexy tapety a videá exkluzívne pre\n            váš mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Potvrdenie / Registrácia")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Na vstup do služby APPS4ALL musí Koncový používateľ zadať svoje\n            mobilné telefónne číslo a /alebo niektoré ďalšie údaje a /alebo\n            informácie prostredníctvom propagačnej webovej stránky (Vstupné\n            Stránky) prevádzkovanej Puretech Global Sdn Bhd -om. Potom Koncový\n            užívateľ dostane SMS vo svojom mobilnom zariadení, s Osobným\n            Identifikačným Číslom (PIN kód), alebo tzv ponukovú správu s\n            informáciami o službe. Zadaním obdržaného PIN kódu na vstupnej\n            stránke a /alebo zaslaním potvrdzovacej správy a /alebo používaním\n            služby Koncový užívateľ uznáva a potvrdzuje, že prečítal Všeobecné\n            obchodné podmienky, je oprávneným držiteľom mobilného účtu za\n            telefón, alebo má súhlas platiteľa telefóneho účtu používať túto\n            službu. Koncový užívateľ dostane potvrdzujúcu SMS správu o\n            úspešnej aktivácii APPS4ALL služby, spôsobe, frekvencii a nákladov\n            na prevzatie Služby, rovnako ako presné detaily odhlásenia.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Náklady a Poplatky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            APPS4ALL je platená služba ktorá stojí 3 SMS x 1.60 EUR / týždeň\n            Poplatok bude účtovaný na mobilný telefónny účet, alebo\n            predplatené mobilné číslo.Spôsob nabíjania je Premium MT SMSkami\n            odoslanými na Koncového užívateľa na základe jeho žiadosti o\n            službu APPS4ALL. Táto správa bude obsahovať prihlasovacie údaje k\n            službe APPS4ALL. Poplatky sú vyberané podľa Prevádzkovateľov\n            Mobilných Sietí. Poplatky sú odpísané proti účtu Koncového\n            užívateľa Prevádzkovateľom, v prípade predplantnej SIM sa poplatky\n            odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ týmto\n            výslovne udeľuje jeho alebo jej oprávnenie pre nabíjanie, a\n            zaväzuje sa na zaplatenie v plnej výške za poplatky, ktoré vznikli\n            v dôsledku upísania a / alebo používania služby APPS4ALL. Ak nie\n            ste osoba zodpovedná za zaplatenie mobilného účtu, prosím,\n            získajte povolenie od platiteľa mobilu pred prihlásením a /alebo\n            používaním služby APPS4ALL. Svojím podpisom a /alebo účasťou na\n            službe, Puretech Global Sdn Bhd predpokladá, že Koncový užívateľ\n            získal potrebné povolenie, súhlas alebo schválenie od platiteľa\n            mobilného účtu, opatrovníka alebo rodičov. Všetky SMS správy\n            zaslané Koncovým používateľom budú účtované mobilným operátorom\n            Koncového užívateľa štandardnou tarifou. Tieto tarify sa môžu\n            líšiť podľa operátora. Prosím, pre viac nformácií o uložených\n            poplatkoch kontaktujte svojho GSM operátora.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Pomoc a podpora")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznícky servis je k dispozícii v pracovných dňoch od 09:00 do\n            17:00 Kontakt: +421 313215999 alebo apps4all.sk@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Duševné vlastníctvo")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu môžete použiť na svoje osobné nekomerčné použitie. Termín\n            APPS4ALL a všetky ostatné ochranné známky, servisné značky a\n            /alebo obchodné názvy používané APPS4ALL-om na Službe z času na\n            čas (Ochranné Známky), sú ochrannými známkami, servisnými značkami\n            a /alebo obchodnými názvami Puretech Global Sdn Bhd - u alebo\n            jednej z jeho spoločností v skupine alebo udeľovateľov jej\n            licencie, a tieto subjekty si vyhradzujú všetky práva na Ochranné\n            Známky. Okrem toho, ďalší obsah Služby, vrátane, ale nie výhradne,\n            Hry, obrázy, obrázky, grafika, fotografie, animácie, videá, hudba,\n            zvuk a text patria APPS4ALL - u, alebo jednému z jeho spoločností\n            a /alebo licenčných skupín, a sú chránené autorskými právami a\n            /alebo inými právami duševného vlastníctva. Beriete týmto na\n            vedomie, že pri používaní Služby nezískate žiadne práva na\n            ochranné známky, alebo Obsah Služby, než ako je uvedené v tejto\n            Dohode. Najmä za žiadnych okolností nemôžete skopírovať ľubovoľný\n            Obsah Služby (vrátane a bez obmedzenia trivia otázky, odpovede,\n            alebo hry), alebo využívať dolovanie dát, roboty, škrabanie\n            obrazovky, alebo podobné zhromažďovanie údajov a extrakčné\n            nástroje na Službe. Zodpovednosť Použitie APPS4ALL - u a /alebo\n            web stránky APPS4ALL prebieha na vlastné riziko koncového\n            užívateľa. Koncový užívateľ musí poskytnúť všetko- kompatibilný\n            mobilný telefón, hardvér, alebo iné zariadenia a softvér, a\n            zabezpečiť, aby boli v prevádzkyschopnom stave a vhodné na služby\n            APPS4ALL. APPS4ALL nemôže zaručiť, že služby APPS4ALL spĺňajú\n            požiadavky koncového užívateľa, a že stiahnutie, príjem a /alebo\n            prezeranie služieb APPS4ALL bude bez prerušenia, alebo chýb. Ak\n            kedykoľvek Koncový užívateľ nie je schopný používať bez prerušenia\n            službu Puretech Global Sdn Bhd, v žiadnom prípade to nevedie k\n            nároku na zníženie poplatkov za APPS4ALL služby, k akékoľvek právo\n            na vrátenie platieb dopredu zaplatených. Akékoľvek použitie\n            služieb APPS4ALL je podľa vlastného uváženia a rizika koncového\n            užívateľa, a že za žiadny ale nie obmedzene, za infekcie, alebo\n            kontaminácie, alebo straty dát, alebo poškodenie(ia) hardvéru a\n            /alebo softvéru koncových užívateľov, vyplývajúcich z prístupu k\n            webovým stránkam, alebo využívania služieb APPS4ALL -u, alebo\n            stiahnutých APPS4ALL služieb, vrátane hardvéru a softvéru\n            vyžadovaného na pripojenie k službám APPS4ALL. Je zodpovednosťou\n            koncových užívateľov, aby prijali potrebné opatrenia, aby sa\n            zabránilo možnému poškodeniu tohto druhu. V prípade, že APPS4ALL\n            je z akéhokoľvek dôvodu povinný nahradiť koncovému užívateľovi\n            priame, alebo následné škody akéhokoľvek druhu, takáto náhrada v\n            žiadnom prípade nesmie prekročiť hodnotu faktúry za služby\n            APPS4ALL, platených koncovým užívateľom pre údajné poškodenia.\n            Obsah Webovej stránky bol zostavený s najväčšou starostlivosťou.\n            Avšak, APPS4ALL nemôže poskytnúť žiadnu záruku, pokiaľ ide o\n            povahu, presnosť alebo obsah týchto informácií. APPS4ALL nenesie\n            zodpovednosť za akékoľvek chyby, opomenutia, nepresnosti,\n            nedorozumenia, oneskorenie, alebo nečitateľné objednávky, alebo\n            oznámenia na základe používania Internetu, alebo príslušného\n            informačného miesta. Záverečné ustanovenia Akékoľvek spory\n            týkajúce sa plnenia týchto Obchodných podmienok budú riešené\n            príslušnými všeobecnými súdmi. Puretech Global Sdn Bhd si\n            vyhradzuje právo čas od času zmeniť tieto podmienky. Zmeny budú\n            oznámené koncovým užívateľom vyvesením na portáli APPS4ALL.\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__ = __webpack_require__(847);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0343d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__ = __webpack_require__(2388);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsCzech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0343d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsCzech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"policy_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiFaq"},[_c('h3',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Podmínky a požadavky")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Použitelnost")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou\n            verzi jednorázově placené služby APPS4ALL Premium (Puretech Global\n            Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu\n            od společnosti Puretech Global Sdn Bhd (dále jen jako Puretech\n            Global Sdn Bhd). Koncový uživatel vyžaduje APPS4ALL Puretech\n            Global Sdn Bhd.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Obvykle")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            APPS4ALL poskytuje nejlepší sexy tapety a videa výhradně pro váš\n            mobil.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Potvrzení / registrace")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Pro přístup ke službě APPS4ALL musí koncový uživatel zadat své\n            mobilní telefonní číslo a / nebo některá další data a / nebo\n            informace prostřednictvím propagační webové stránky (úvodní\n            stránky) provozované společností Puretech Global Sdn Bhd. Poté\n            koncový uživatel obdrží na svůj server SMS mobilní zařízení, s\n            osobním identifikačním číslem (PIN kód), nebo takzvanou nabídkovou\n            zprávou s informacemi o službě. Koncový uživatel zadáním přijatého\n            PIN kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a\n            / nebo používáním služby potvrzuje a potvrzuje, že si přečetl\n            Všeobecné podmínky, je autorizovaným majitelem účtu mobilního\n            telefonu nebo má souhlas plátce telefonního účtu s využitím této\n            služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné\n            aktivaci služby APPS4ALL, způsobu, frekvenci a nákladech na\n            převzetí Služby a také přesné údaje o odhlášení.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Náklady a poplatky")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            APPS4ALL je placená služba, která stojí 3 SMS x 1,60 EUR / týden\n            Poplatek bude účtován na účet mobilního telefonu nebo na\n            předplacené mobilní číslo. Způsob účtování je Premium MT SMS\n            zasílaná Koncovému uživateli na základě jeho požadavku na službu\n            APPS4ALL. Tato zpráva bude obsahovat pověření služby APPS4ALL.\n            Poplatky se vybírají podle provozovatelů mobilních sítí. Poplatky\n            jsou odepsány na účet Koncového uživatele Provozovatelem; v\n            případě SIM s předplatným jsou poplatky odečteny z kreditu\n            Koncového uživatele. Koncový uživatel tímto výslovně uděluje své\n            oprávnění účtovat poplatky a zavazuje se zaplatit v plné výši\n            poplatky vzniklé v důsledku předplatného a / nebo používání služby\n            APPS4ALL. Pokud nejste osobou odpovědnou za placení vašeho účtu za\n            mobilní telefon, před přihlášením a / nebo použitím APPS4ALL si\n            prosím vyžádejte povolení od svého mobilního plátce. Podpisem a /\n            nebo účastí ve službě Puretech Global Sdn Bhd předpokládá, že\n            koncový uživatel získal potřebné povolení, souhlas nebo schválení\n            od plátce mobilního účtu, opatrovníka nebo rodičů. Všechny SMS\n            zprávy zasílané koncovým uživatelem budou mobilním operátorem\n            koncového uživatele účtovány za standardní tarif. Tyto sazby se\n            mohou u jednotlivých operátorů lišit. Další informace o poplatcích\n            vám poskytne váš mobilní operátor GSM.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Pomoc a podpora")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00\n            Kontakt: +421 313215999 nebo apps4all.cz@silverlines.info\n          ")])]),_vm._v(" "),_c('div',{staticClass:"mobiFaq"},[_c('h2',{staticClass:"mobiTitle sm privacy_color"},[_vm._v("Duševní vlastnictví")]),_vm._v(" "),_c('p',{staticClass:"mobitxt"},[_vm._v("\n            Službu můžete používat pro osobní, nekomerční použití. Pojem\n            Miximo a všechny ostatní ochranné známky, servisní značky a / nebo\n            obchodní názvy používané Miximo ve Službě čas od času (ochranné\n            známky) jsou ochranné známky, servisní značky a / nebo obchodní\n            názvy společnosti Puretech Global Sdn Bhd nebo jedné z jejích\n            společností v skupina nebo její poskytovatelé licencí a tyto\n            subjekty si vyhrazují veškerá práva k ochranným známkám. Kromě\n            toho patří další služby obsahu, mezi které patří mimo jiné hry,\n            obrázky, obrázky, grafika, fotografie, animace, videa, hudba, zvuk\n            a text, společnosti APPS4ALL nebo jedné z jejích společností a /\n            nebo licencovaných skupin a jsou chráněny podle autorských práv a\n            / nebo jiných práv duševního vlastnictví. Berete na vědomí, že\n            používáním Služby nezískáte žádná práva na ochrannou známku ani\n            Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných\n            okolností nesmíte za žádných okolností kopírovat jakýkoli obsah\n            služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo\n            her), ani ve službě používat dolování dat, roboty, škrábance na\n            obrazovce nebo podobné nástroje pro sběr a extrakci dat.\n            Odpovědnost Použití APPS4ALL a / nebo webových stránek APPS4ALL je\n            na vlastní riziko koncového uživatele. Koncový uživatel musí\n            poskytnout plně kompatibilní mobilní telefon, hardware nebo jiné\n            vybavení a software a zajistit, aby byly funkční a vhodné pro\n            služby APPS4ALL. APPS4ALL nemůže zaručit, že služby APPS4ALL\n            splňují požadavky koncového uživatele a že stahování, přijímání a\n            / nebo prohlížení služeb APPS4ALL bude nepřerušované nebo bez\n            chyb. Pokud koncový uživatel kdykoli nemůže bez přerušení používat\n            službu Puretech Global Sdn Bhd, nebude to v žádném případě vést k\n            právu na snížení poplatků za služby APPS4ALL, k jakémukoli právu\n            na vrácení předplacených plateb. Jakékoli použití Služeb APPS4ALL\n            je na uvážení a riziku koncového uživatele, a to za, nikoli však\n            výhradně, infekce, kontaminace nebo ztráta dat nebo poškození\n            hardwaru a / nebo softwaru koncového uživatele z přístupu na Web.\n            , nebo používání Služeb APPS4ALL, nebo stažených Služeb APPS4ALL,\n            včetně hardwaru a softwaru nutného pro připojení ke Službám\n            APPS4ALL. Je odpovědností koncových uživatelů, aby přijali\n            nezbytná opatření, která zabrání možnému poškození tohoto druhu. V\n            případě, že je společnost APPS4ALL z jakéhokoli důvodu povinna\n            nahradit koncovému uživateli přímé nebo následné škody jakéhokoli\n            druhu, nesmí taková náhrada v žádném případě překročit hodnotu\n            faktury za služby APPS4ALL, kterou koncový uživatel zaplatil za\n            údajné škody. Obsah webových stránek byl sestaven s největší péčí.\n            APPS4ALL však nemůže poskytnout žádnou záruku, pokud jde o povahu,\n            přesnost nebo obsah těchto informací. APPS4ALL nenese odpovědnost\n            za chyby, opomenutí, nepřesnosti, nedorozumění, zpoždění nebo\n            nečitelné objednávky nebo oznámení založená na používání internetu\n            nebo příslušného informačního bodu. Závěrečná ustanovení Veškeré\n            spory týkající se plnění těchto Obchodních podmínek budou řešit\n            příslušné obecné soudy. Puretech Global Sdn Bhd si vyhrazuje právo\n            čas od času tyto podmínky změnit. Změny budou koncovým uživatelům\n            oznámeny zveřejněním na portálu APPS4ALL.\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("terms"))+"\n  ")]),_vm._v(" "),(_vm.lang_a4all == 'slovakia')?_c('span',[_c('terms-slovakia')],1):_vm._e(),_vm._v(" "),(_vm.lang_a4all == 'czech')?_c('span',[_c('terms-czech')],1):_c('span',[_c('terms-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(848);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03196a54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(2392);
function injectStyle (ssrContext) {
  __webpack_require__(2391)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03196a54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03196a54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[(_vm.app4all_res_sub == '')?_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")]):_c('h1',[_vm._v("\n            "+_vm._s(_vm.app4all_res_sub)+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(850);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c328b0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2402);
function injectStyle (ssrContext) {
  __webpack_require__(2394)
  __webpack_require__(2395)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c328b0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c328b0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(851);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60a15396_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2398);
function injectStyle (ssrContext) {
  __webpack_require__(2397)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60a15396_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Apps ..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(852);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59de9b2f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2401);
function injectStyle (ssrContext) {
  __webpack_require__(2400)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59de9b2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59de9b2f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_a4all),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item.content_name))]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_a4all)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[(_vm.authentication_a4all === 'loggedin')?_c('router-link',{attrs:{"to":_vm.authentication_a4all === 'loggedin' ? '/home' : ''}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(853)}})])]):_c('a',{staticClass:"navbar-brand"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(853)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.authentication_a4all === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.authentication_a4all === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.authentication_a4all === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(818)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_a4all)}})])])]),_vm._v(" "),(_vm.authentication_a4all === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$t("home")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":"/browse"}},[_vm._v(_vm._s(_vm.$t("browse")))]),_vm._v(" "),_c('ul',{staticClass:"subNavLinks"},_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"subNavLinks__item"},[_c('router-link',{attrs:{"to":{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_a4all)]))])])],1)}),0)],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(_vm._s(_vm.$t("hotpicks")))])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_c('span',[_vm._v(_vm._s(_vm.$t("popular")))])])],1)]):_vm._e(),_vm._v(" "),(_vm.authentication_a4all === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[(_vm.is_unsub_a4all != '0')?_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},on:{"click":function($event){return _vm.logout_a4all(_vm.is_unsub_a4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])]):_c('div',[(_vm.countryCode !== 'fi')?_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","color":"white","text-align":"center"},attrs:{"href":"/logout"},on:{"click":function($event){return _vm.logout_a4all(_vm.is_unsub_a4all)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/feedback"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("feedback")))])])],1),_vm._v(" "),(_vm.countryCode === 'sk' || _vm.countryCode === 'cz')?_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/terms"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1):_vm._e()])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apps4all",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_apps4all",attrs:{"id":"appBg"}},[_c('div',{staticClass:"apps4allMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Playmix_vue__ = __webpack_require__(854);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fa4f242_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Playmix_vue__ = __webpack_require__(2448);
function injectStyle (ssrContext) {
  __webpack_require__(2405)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Playmix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fa4f242_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Playmix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(855);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819649c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(2408);
function injectStyle (ssrContext) {
  __webpack_require__(2407)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-819649c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819649c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("main_title"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[(_vm.$props.main.isLoad === false)?_c('div',[_c('div',{staticClass:"spinnerC"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e(),_vm._v(" "),(_vm.$props.main.isLoad === true)?_c('div',_vm._l((_vm.$props.main.subcategory),function(hot){return _c('div',{key:hot.key,staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotpick_playmix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("hotpicks"))+" - \n              "),(_vm.lang_playmix !== 'english')?_c('span',[_vm._v(_vm._s(hot[("title_" + _vm.lang_playmix)]))]):_vm._e(),_vm._v(" "),(_vm.lang_playmix === 'english')?_c('span',[_vm._v(_vm._s(hot.subcategory))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:" link right"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":{path: 'hotpicks', query: { q: hot.subcategory } }}},[_vm._v(" "+_vm._s(_vm.$t("view_more"))+" >")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{ref:"hotPicksCarousel",refInFor:true,staticClass:"row mobislider"},_vm._l((_vm.$props.main.hotpicks[hot.subcategory]),function(hot){return _c('div',{key:hot.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiVideoExpand"},[(hot.subcategory === hot.subcategory)?_c('router-link',{staticClass:"mobiVideo",attrs:{"to":{name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn",attrs:{"data-v-238dec4a":""}},[_c('span',{attrs:{"data-v-238dec4a":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_playmix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_playmix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_playmix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])]):_vm._e()],1)}),0)])])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__ = __webpack_require__(856);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f80bcea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__ = __webpack_require__(2414);
function injectStyle (ssrContext) {
  __webpack_require__(2410)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f80bcea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f80bcea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__ = __webpack_require__(857);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2293b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__ = __webpack_require__(2413);
function injectStyle (ssrContext) {
  __webpack_require__(2412)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b2293b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2293b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lightbox"}},[_c('img',{attrs:{"src":_vm.imgsource,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lightbox__btns"},[_c('a',{staticClass:"button prev",attrs:{"href":"#"},on:{"click":_vm.back}},[_c('span',{staticClass:"icon flaticon-left-arrow"})]),_vm._v(" "),_c('a',{staticClass:"button next",attrs:{"href":"#"},on:{"click":_vm.next}},[_c('span',{staticClass:"icon flaticon-right-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__overlay",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetail"},[(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"contentDetail__header"},[(_vm.details.content_type !== 'video/mp4')?_c('div',[_c('div',{staticClass:"contentDetail__icon"},[(_vm.details.content_type === 'application/x-zip-compressed' && _vm.details.category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":__webpack_require__(16)}})]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.details.thumbnail_url,"alt":""}})])]):(_vm.details.content_type === 'video/mp4')?_c('div',[_c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"poster":_vm.details.cover_img,"id":"vidPlayer","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.details.file_url,"type":"video/mp4"}})])])]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mobiTitle lg",attrs:{"id":"cont_name"}},[_vm._v(_vm._s(_vm.getLanguage(_vm.lang_playmix)))]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":24,"read-only":true,"increment":0.01,"active-color":"#fa183d","show-rating":false,"border-width":2,"border-color":"#fa183d","rounded-corners":false,"inactive-color":"transparent","star-points":[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ],"rating":Number(_vm.details.rating)}})],1),_vm._v(" "),_c('div',{staticClass:"contentDetail__info"},[(_vm.isLoad === true)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t("category"))+": "),_c('span',{attrs:{"id":"category"}})]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("platform"))+": "),_c('span',{attrs:{"id":"platform"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('p',{staticClass:"mobitxt",attrs:{"id":"description"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentDetails__screens"},[_c('ul',_vm._l((_vm.details.screenshot),function(sc){return _c('li',{key:sc.key,on:{"click":function($event){return _vm.openBox(sc)}}},[_c('img',{attrs:{"src":sc.url,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobiBtnContainer"},[_c('button',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.subscribeContent_playmix([_vm.details.raw_file_url, _vm.details.content_type, _vm.id])}}},[(_vm.details.content_type === 'application/x-zip-compressed')?_c('span',[_vm._v(_vm._s(_vm.$t("play")))]):_c('span',[_vm._v(_vm._s(_vm.$t("download")))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentCover",style:({ backgroundImage: 'url(' + _vm.contentCoverImg + ')' })}),_vm._v(" "),(_vm.lightBoxToggle)?_c('custom-lightbox',{attrs:{"close":_vm.closeBox,"next":_vm.nextPic,"back":_vm.prevPic,"imgsource":_vm.lightBoxCurrentPic}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(872);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea8e0b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(2417);
function injectStyle (ssrContext) {
  __webpack_require__(2416)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ea8e0b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea8e0b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profileImg"},[_c('div',{staticClass:"userAccount"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("hello")))])])])]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"userProfile"},[_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('registered_num'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.msisdn_playmix))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('subscription_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.subscription_date_playmix))])]),_vm._v(" "),_c('div',{staticClass:"inputWrap"},[_c('label',{staticClass:"inputWrap__label text_color",attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('next_renew_date'))+":")]),_vm._v(" "),_c('h2',{staticClass:"mobiTitle md text_color"},[_vm._v(_vm._s(_vm.renew_date_playmix))])])]),_vm._v(" "),(_vm.authentication_playmix === 'loggedin')?_c('div',{staticClass:"btnContainer "},[_c('div',[_c('a',{staticClass:"mobiBtn",on:{"click":function($event){return _vm.logout_playmix(_vm.is_unsub_playmix)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userAccount__image"},[_c('img',{staticClass:"user_img",attrs:{"src":__webpack_require__(873)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__ = __webpack_require__(874);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d11040e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__ = __webpack_require__(2420);
function injectStyle (ssrContext) {
  __webpack_require__(2419)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d11040e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d11040e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subcategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n      "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_playmix))+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.params.subcategory, _vm.lang_playmix)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat){return _c('div',{key:dat.key,staticClass:"col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: dat.content_id }
                  }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":dat.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_playmix !== 'english')?_c('span',[(dat[("cont_name_" + _vm.lang_playmix)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat[("cont_name_" + _vm.lang_playmix)]))]):_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color"},[_vm._v(_vm._s(dat["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#feb801","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(dat.rating)}})],1)])])],1)}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__ = __webpack_require__(875);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b794d0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__ = __webpack_require__(2423);
function injectStyle (ssrContext) {
  __webpack_require__(2422)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b794d0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotPicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b794d0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotPicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("hotpicks"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconHotpick_playmix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("hotpicks"))+" "+_vm._s(_vm.getSubCategory(_vm.$route.query.q, _vm.lang_playmix)))])])]),_vm._v(" "),(_vm.isLoad === false)?_c('div',[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e(),_vm._v(" "),(_vm.isLoad === true)?_c('div',[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.getHotPicks()),function(hot){return _c('div',{key:hot.key,class:hot.class},[_c('div',[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{ name: 'DetailPage', params: { id: hot.content_id } }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_playmix !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_playmix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_playmix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#ffc000","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(hot.rating)}})],1)])],1)])}),0)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__ = __webpack_require__(876);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a803c7d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__ = __webpack_require__(2426);
function injectStyle (ssrContext) {
  __webpack_require__(2425)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a803c7d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a803c7d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("popular"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__header"},[_c('h2',{staticClass:"mobiTitle md"},[_c('img',{staticClass:"mobiIcon",attrs:{"src":_vm.IconPopular_playmix,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text_color"},[_vm._v(_vm._s(_vm.$t("all"))+" "+_vm._s(_vm.$t("popular")))])])]),_vm._v(" "),_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.PopularPage_playmix),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo mobiVideo--mrgn",attrs:{"to":{
                  name: 'DetailPage',
                  params: { id: pop.content_id }
                  }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_playmix !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_playmix)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_playmix)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"show-rating":false,"border-width":2,"border-color":"#ffc000","inactive-color":"transparent","active-color":"#ffb902","rounded-corners":false,"star-points":[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],"rating":Number(pop.rating)}})],1)])])],1)}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__ = __webpack_require__(877);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a2c4be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__ = __webpack_require__(2429);
function injectStyle (ssrContext) {
  __webpack_require__(2428)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18a2c4be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unsubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a2c4be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unsubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(878);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3384b21a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2432);
function injectStyle (ssrContext) {
  __webpack_require__(2431)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3384b21a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3384b21a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.isAoc === true)?_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.consent_gateway($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("subscribe_messsage")))]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("subscribe")))])])])]):_c('div',{staticClass:"section__content center login"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"std__subtile"},[_vm._v(_vm._s(_vm.$t("login_title")))]),_vm._v(" "),_c('h2',{staticClass:"std__subtile md"},[_vm._v(_vm._s(_vm.$t("confirmation")))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"mobiForElm__input",attrs:{"type":"tel","maxlength":"14","placeholder":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])]),_vm._v(" "),(_vm.showStatusAlert)?_c('div',{staticClass:"alert alert-danger col-md-3",attrs:{"role":"alert"}},[(_vm.lang_playmix === 'english')?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.lang_playmix !== 'english')?_c('span',[_vm._v(_vm._s(_vm.statusTran))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.showMsisdnAlert)?_c('div',{staticClass:"alert alert-danger col-md-5",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.$t("valid_number"))+"\n            "),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close","title":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(879);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c547af6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(2435);
function injectStyle (ssrContext) {
  __webpack_require__(2434)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c547af6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c547af6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('privacy'))+"\n  ")]),_vm._v(" "),(_vm.lang_playmix == 'arabic')?_c('span',[_c('privacy-arabic')],1):(_vm.lang_playmix == 'malay')?_c('span',[_c('privacy-malay')],1):(_vm.lang_playmix == 'greek')?_c('span',[_c('privacy-greek')],1):(_vm.lang_playmix == 'czech')?_c('span',[_c('privacy-czech')],1):(_vm.lang_playmix == 'bulgarian')?_c('span',[_c('privacy-bulgarian')],1):(_vm.lang_playmix == 'norwegian')?_c('span',[_c('privacy-norwegian')],1):_c('span',[_c('privacy-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var host = window.location.host;
var lang = localStorage.getItem("lang_playmix");
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  data: function data() {
    return {
      ar: {
        arLanguage: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false,
        dataLoaded: false
      },
      browse: {
        category: []
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created: function created() {
    if (host.includes("playmix")) {
      this.getBrowse();
    }
  },

  methods: {
    getHotPicks: function getHotPicks(subcate) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isload, subCate, allplaymixData, subcateg, allDataplaymix, dataLoaded, live, local, oneHourInMs, currentTimeInMs, timeInHour, numberForToday, DigitNumber, i, divide, data_slice, _subcate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isload = "";
                subCate = [];
                allplaymixData = [];
                subcateg = [];
                allDataplaymix = [];
                dataLoaded = false;
                live = "http://cook.grabmobi.com/";
                local = "http://[::1]/PuretechGlobalContentPortal";

                //get subcategory under game
                // let subplaymix = await axios.get(
                //   `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=2&limit=4&offset=0&domain=${host}`
                // );

                //get subcategory from getBrowse()

                subcateg = subcate;

                //get random number
                oneHourInMs = 3600000;
                currentTimeInMs = new Date().getTime(); // UTC time

                timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
                numberForToday = timeInHour % 12;
                // zero-filling of numbers less than four digits might be optional for you
                // zero-filled value will be a string to maintain its leading 0s

                DigitNumber = numberForToday.toString();

                while (DigitNumber.length < 2) {
                  DigitNumber = 0 + Number(DigitNumber);
                }

                i = 0;

              case 16:
                if (!(i < subcateg.length)) {
                  _context.next = 29;
                  break;
                }

                _context.next = 19;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + subcateg[i].subcategory + "&limit=50&offset=0&domain=" + host + "&lang=" + lang);

              case 19:
                allDataplaymix = _context.sent;
                divide = DigitNumber % 2;

                if (divide == 0) {
                  allDataplaymix.data.data.sort(function (a, b) {
                    //to sort random
                    return Math.random() - 0.5;
                  });
                } else {
                  allDataplaymix.data.data.sort(function (a, b) {
                    //to sort random
                    return 0.5 - Math.random();
                  });
                }

                data_slice = allDataplaymix.data.data.slice(0, 6);
                _subcate = subcateg[i].subcategory;

                allplaymixData[_subcate] = new Array();
                allplaymixData[_subcate] = data_slice;

              case 26:
                i++;
                _context.next = 16;
                break;

              case 29:

                isload = true;
                dataLoaded = true;
                _this.main.hotpicks = allplaymixData;
                subcate.length >= 4 ? _this.main.subcategory = subcateg.slice(1, 4) : _this.main.subcategory = subcateg;
                _this.main.isLoad = isload;
                _this.main.dataLoaded = dataLoaded;

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBrowse: function getBrowse() {
      var _this2 = this;

      var live = "http://cook.grabmobi.com";
      var local = "http://[::1]/PuretechGlobalContentPortal";

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=3&limit=100&offset=0&domain=" + host + "&lang=" + lang).then(function (res) {
        var data = res.data.data;
        var temp = [];
        data.map(function (item) {
          item.title_english = item.subcategory;
          item.route = item.title_english.toLowerCase();
          var trans = JSON.parse(item.subcategory_translate);
          if (trans != null) {
            var trans_len = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans).length;
            var trans_arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(trans);

            for (var i = 0; i < trans_len; i++) {
              item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
            }
          }

          var icon = JSON.parse(item.subcategory_icon);
          if (icon != null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(icon)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (key == host) {
                  item.icon = icon[key]["class"];
                } else {
                  item.icon = icon["mobiflix.vip"]["class"];
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          temp.push(item);
        });

        var item_temp = temp.map(function (v) {
          delete v.category_translate;
          delete v.category_translate;
          delete v.category_icon;
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v;
        });
        _this2.getHotPicks(item_temp);
        _this2.browse.category = item_temp;
      });
    }
  }
}));

/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(880);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f18dd252_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(2446);
function injectStyle (ssrContext) {
  __webpack_require__(2438)
  __webpack_require__(2439)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f18dd252"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f18dd252_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(881);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e877d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(2442);
function injectStyle (ssrContext) {
  __webpack_require__(2441)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e877d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobiSearch games",attrs:{"id":"autocomplete"}},[_c('div',{staticClass:"mobiSearch__wrap",attrs:{"id":"mobiSearchWrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_input),expression:"search_input"}],staticClass:"mobiSearch__input",attrs:{"data-autocomplete":"","placeholder":_vm.$t('search'),"aria-label":"Search for Games, Apps, etc..."},domProps:{"value":(_vm.search_input)},on:{"keyup":function($event){return _vm.search(_vm.search_input)},"input":function($event){if($event.target.composing){ return; }_vm.search_input=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"mobiAutocomplete games",attrs:{"id":"auto_result"}},[_vm._l((_vm.result_search),function(post,index){return _c('router-link',{key:index,staticClass:"mobiAutocomplete__resultItem",attrs:{"to":{
                   name: 'DetailPage',
                   params: { id: post.id }
               }},domProps:{"innerHTML":_vm._s(_vm.icon_bold[index])}},[_vm._v(_vm._s(index)+" "),_c('span')])}),_vm._v(" "),_c('p',{staticClass:"autocomplete-result-list",attrs:{"id":"searchSuggestion"}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"searchBtn"}},[_c('span',{staticClass:"icon mobiSearch__icon",attrs:{"id":"sear"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(882);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2106e81f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2445);
function injectStyle (ssrContext) {
  __webpack_require__(2444)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2106e81f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2106e81f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationComp"},[_c('div',{staticClass:"notificationComp__head"},[_c('h1',{staticClass:"mobiTitle md"},[_vm._v(_vm._s(_vm.$t("notification")))])]),_vm._v(" "),_c('ul',_vm._l((_vm.notification_playmix),function(item){return _c('li',{key:item.key},[_c('router-link',{staticClass:"notificationComp__wrap",attrs:{"to":{name: 'DetailPage',params: { id: item.id }}}},[_c('div',{staticClass:"notificationComp__img"},[_c('img',{attrs:{"src":item.thumbnail_url}})]),_vm._v(" "),_c('div',{staticClass:"notificationComp__content"},[(_vm.lang_playmix !== 'english')?_c('span',[(item[("cont_name_" + _vm.lang_playmix)] !== '')?_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item[("cont_name_" + _vm.lang_playmix)]))]):_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]):_c('span',[_c('h2',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(item["cont_name_english"]))])]),_vm._v(" "),_c('p',{staticClass:"mobilabel"},[_vm._v(_vm._s(item[("titleSub_" + _vm.lang_playmix)]))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navigation ",attrs:{"id":"navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation_center",attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":_vm.authentication_playmix === 'loggedin' ? '/home' : '/login'}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(2447)}})])])],1),_vm._v(" "),_c('div',{staticClass:"navigation__right"},[_c('div',{staticClass:"panelWrap"},[(_vm.authentication_playmix === 'loggedin')?_c('Search'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon flaticon-bell",attrs:{"id":"notificationIcon"}})],1)]),_vm._v(" "),_c('div',{staticClass:"navigation__notificationWrap",attrs:{"id":"notification","data-att":""}},[(_vm.authentication_playmix === 'loggedin')?_c('Notification'):_vm._e()],1)]),_vm._v(" "),_c('nav',{staticClass:"siteNavMobile gamesOnly"},[_c('div',{staticClass:"siteNavMobile__wraper"},[_c('div',[_c('div',{staticClass:"userAccount"},[_c('div',{staticClass:"userAccount__image"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":_vm.authentication_playmix === 'loggedin' ? '/profile' : ''}},[_c('img',{attrs:{"src":__webpack_require__(873)}}),_vm._v(" "),_c('span',{staticClass:"icon flaticon-pencil-edit-button"})])],1),_vm._v(" "),_c('div',{staticClass:"userAccount__name"},[_c('p',[_vm._v(_vm._s(_vm.$t("hello")))])])]),_vm._v(" "),_c('ul',{staticClass:"navLinks"},[_c('li',[_c('div',{staticClass:"translationBtns"},[_c('div',{staticClass:"btnContainer left inline"},[_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"lang2"},domProps:{"innerHTML":_vm._s(_vm.langButton_playmix)}})])])]),_vm._v(" "),(_vm.authentication_playmix === 'loggedin')?_c('div',[_c('li',{staticClass:"navLinks__item"},[_c('router-link',{staticClass:"browse_link",attrs:{"to":"/home"}},[_vm._v("\n                "+_vm._s(_vm.$t("home"))+"\n                ")])],1),_vm._v(" "),_vm._l((_vm.$props.browse.category),function(cat){return _c('li',{key:cat.key,staticClass:"navLinks__item "},[_c('router-link',{staticClass:"browse_link ",attrs:{"to":{name: 'Subcategory', params: { subcategory: cat.route }}}},[_c('span',{staticClass:"icon",class:cat.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(cat[("title_" + _vm.lang_playmix)]))])])],1)}),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/hotpicks"}},[_c('span',{staticClass:"flaticon-flame icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("hotpicks")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item sm"},[_c('router-link',{staticClass:"browse_link text_color",staticStyle:{"text-decoration":"none"},attrs:{"to":"/popular"}},[_c('span',{staticClass:"flaticon-graph icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("popular")))])])],1)],2):_vm._e(),_vm._v(" "),(_vm.authentication_playmix === 'loggedin')?_c('li',{staticClass:"navLinks__item sm"},[_c('div',[_c('a',{staticClass:"mobiBtn",staticStyle:{"text-decoration":"none","text-align":"center"},on:{"click":function($event){return _vm.logout_playmix(_vm.is_unsub_playmix)}}},[_vm._v(_vm._s(_vm.$t("unsubscribe")))])])]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"navLinks footer"},[_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/privacy"}},[_c('span',{staticClass:"flaticon-padlock icon"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t("privacy")))])])],1),_vm._v(" "),_c('li',{staticClass:"navLinks__item xs"},[_c('router-link',{staticClass:"browse_link text_color",attrs:{"to":"/"}},[_c('span',{staticClass:"flaticon-information-button icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("terms")))])])],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_left"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"dashboardMenu"}},[_c('span')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobiBtn sm ",attrs:{"id":"lang1","lang":"english"}},[_c('img',{attrs:{"lang":"english","src":"https://i.imgur.com/oi8qUPx.png"}}),_vm._v(" "),_c('span',{attrs:{"lang":"english"}},[_vm._v("English")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeNav"},[_c('div',{staticClass:"menuIcon",attrs:{"id":"navMobileClose"}},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Playmix-logo.20b4186.png";

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playmix",attrs:{"id":"id"}},[_c('Navigation',{attrs:{"browse":_vm.browse}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contentPanel",attrs:{"id":"contentPanel"}},[_c('transition',{attrs:{"name":"fade","appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{attrs:{"main":_vm.main,"browse":_vm.browse}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"backdrop",attrs:{"id":"backdrop"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appBg_Playmix",attrs:{"id":"appBg"}},[_c('div',{staticClass:"playmixMask"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50242d83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__(2450);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50242d83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Hello World! I'm alive")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2452);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 415,
	"./bulgarian.json": 416,
	"./czech.json": 417,
	"./denmark.json": 418,
	"./english.json": 419,
	"./finnish.json": 420,
	"./greek.json": 421,
	"./indonesian.json": 422,
	"./malay.json": 423,
	"./norwegian.json": 424,
	"./romanian.json": 425,
	"./slovakia.json": 426,
	"./swedish.json": 427,
	"./thai.json": 428
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2452;

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2454);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 347,
	"./bulgarian.json": 348,
	"./czech.json": 349,
	"./denmark.json": 350,
	"./english.json": 351,
	"./finnish.json": 352,
	"./greek.json": 353,
	"./malay.json": 354,
	"./norwegian.json": 355,
	"./romanian.json": 356,
	"./slovakia.json": 357,
	"./swedish.json": 358,
	"./thai.json": 359
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2454;

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2456);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 452,
	"./bulgarian.json": 453,
	"./czech.json": 454,
	"./denmark.json": 455,
	"./english.json": 456,
	"./finnish.json": 457,
	"./greek.json": 458,
	"./indonesian.json": 459,
	"./malay.json": 460,
	"./norwegian.json": 461,
	"./romanian.json": 462,
	"./slovakia.json": 463,
	"./swedish.json": 464
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2456;

/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2458);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 480,
	"./bulgarian.json": 481,
	"./czech.json": 482,
	"./denmark.json": 483,
	"./english.json": 484,
	"./finnish.json": 485,
	"./greek.json": 486,
	"./indonesian.json": 487,
	"./malay.json": 488,
	"./norwegian.json": 489,
	"./romanian.json": 490,
	"./slovakia.json": 491,
	"./swedish.json": 492,
	"./thai.json": 493
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2458;

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2460);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 522,
	"./bulgarian.json": 523,
	"./czech.json": 524,
	"./denmark.json": 525,
	"./english.json": 526,
	"./finnish.json": 527,
	"./greek.json": 528,
	"./indonesian.json": 529,
	"./malay.json": 530,
	"./norwegian.json": 531,
	"./romanian.json": 532,
	"./slovakia.json": 533,
	"./swedish.json": 534
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2460;

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2462);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 549,
	"./bulgarian.json": 550,
	"./czech.json": 551,
	"./denmark.json": 552,
	"./english.json": 553,
	"./finnish.json": 554,
	"./greek.json": 555,
	"./indonesian.json": 556,
	"./malay.json": 557,
	"./norwegian.json": 558,
	"./romanian.json": 559,
	"./slovakia.json": 560,
	"./swedish.json": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2462;

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2464);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 582,
	"./bulgarian.json": 583,
	"./czech.json": 584,
	"./denmark.json": 585,
	"./english.json": 586,
	"./finnish.json": 587,
	"./greek.json": 588,
	"./indonesian.json": 589,
	"./malay.json": 590,
	"./norwegian.json": 591,
	"./romanian.json": 592,
	"./slovakia.json": 593,
	"./swedish.json": 594
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2464;

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2466);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 613,
	"./bulgarian.json": 614,
	"./czech.json": 615,
	"./denmark.json": 616,
	"./english.json": 617,
	"./finnish.json": 618,
	"./greek.json": 619,
	"./indonesian.json": 620,
	"./malay.json": 621,
	"./norwegian.json": 622,
	"./romanian.json": 623,
	"./slovakia.json": 624,
	"./swedish.json": 625,
	"./thai.json": 626
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2466;

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2468);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: "english",
  fallbackLocale: "english",
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 652,
	"./bulgarian.json": 653,
	"./czech.json": 654,
	"./denmark.json": 655,
	"./english.json": 656,
	"./finnish.json": 657,
	"./greek.json": 658,
	"./indonesian.json": 659,
	"./malay.json": 660,
	"./norwegian.json": 661,
	"./romanian.json": 662,
	"./slovakia.json": 663,
	"./swedish.json": 664,
	"./thai.json": 665
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2470);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 695,
	"./bulgarian.json": 696,
	"./czech.json": 697,
	"./denmark.json": 698,
	"./english.json": 699,
	"./finnish.json": 700,
	"./greek.json": 701,
	"./indonesian.json": 702,
	"./malay.json": 703,
	"./norwegian.json": 704,
	"./romanian.json": 705,
	"./slovakia.json": 706,
	"./swedish.json": 707,
	"./thai.json": 708
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2470;

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2472);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 728,
	"./english.json": 729,
	"./greek.json": 730,
	"./indonesian.json": 731,
	"./malay.json": 732
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2472;

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2474);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 750,
	"./bulgarian.json": 751,
	"./czech.json": 752,
	"./denmark.json": 753,
	"./english.json": 754,
	"./finnish.json": 755,
	"./greek.json": 756,
	"./indonesian.json": 757,
	"./malay.json": 758,
	"./norwegian.json": 759,
	"./romanian.json": 760,
	"./slovakia.json": 761,
	"./swedish.json": 762,
	"./thai.json": 763
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2474;

/***/ }),
/* 2475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2476);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 788,
	"./bulgarian.json": 789,
	"./czech.json": 790,
	"./denmark.json": 791,
	"./english.json": 792,
	"./finnish.json": 793,
	"./greek.json": 794,
	"./indonesian.json": 795,
	"./malay.json": 796,
	"./norwegian.json": 797,
	"./romanian.json": 798,
	"./slovakia.json": 799,
	"./swedish.json": 800,
	"./thai.json": 801
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2476;

/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2478);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 826,
	"./bulgarian.json": 827,
	"./czech.json": 828,
	"./denmark.json": 829,
	"./english.json": 830,
	"./finnish.json": 831,
	"./greek.json": 832,
	"./indonesian.json": 833,
	"./malay.json": 834,
	"./norwegian.json": 835,
	"./romanian.json": 836,
	"./slovakia.json": 837,
	"./swedish.json": 838,
	"./thai.json": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2478;

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(39);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(2480);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'english',
  fallbackLocale: 'english',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arabic.json": 858,
	"./bulgarian.json": 859,
	"./czech.json": 860,
	"./denmark.json": 861,
	"./english.json": 862,
	"./finnish.json": 863,
	"./greek.json": 864,
	"./indonesian.json": 865,
	"./malay.json": 866,
	"./norwegian.json": 867,
	"./romanian.json": 868,
	"./slovakia.json": 869,
	"./swedish.json": 870,
	"./thai.json": 871
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2480;

/***/ }),
/* 2481 */,
/* 2482 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_mobizone_store__ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_mobiscope_store__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_games4all_store__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_mobiflix_store__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_miximo_store__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_gameknight_store__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_gameonz_store__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_funplus_store__ = __webpack_require__(2496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_gamebox_store__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_prizeo_store__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_fun2win_store__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_cutemobi_store__ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_cutehub_store__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_apps4all_store__ = __webpack_require__(2514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_playmix_store__ = __webpack_require__(2517);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    // namespaced: '',
    mobizoneStore: __WEBPACK_IMPORTED_MODULE_3__modules_mobizone_store__["a" /* default */],
    mobiscopeStore: __WEBPACK_IMPORTED_MODULE_4__modules_mobiscope_store__["a" /* default */],
    games4allStore: __WEBPACK_IMPORTED_MODULE_5__modules_games4all_store__["a" /* default */],
    mobiflixStore: __WEBPACK_IMPORTED_MODULE_6__modules_mobiflix_store__["a" /* default */],
    miximoStore: __WEBPACK_IMPORTED_MODULE_7__modules_miximo_store__["a" /* default */],
    gameknightStore: __WEBPACK_IMPORTED_MODULE_8__modules_gameknight_store__["a" /* default */],
    gameonzStore: __WEBPACK_IMPORTED_MODULE_9__modules_gameonz_store__["a" /* default */],
    funplusStore: __WEBPACK_IMPORTED_MODULE_10__modules_funplus_store__["a" /* default */],
    gameboxStore: __WEBPACK_IMPORTED_MODULE_11__modules_gamebox_store__["a" /* default */],
    prizeoStore: __WEBPACK_IMPORTED_MODULE_12__modules_prizeo_store__["a" /* default */],
    fun2winStore: __WEBPACK_IMPORTED_MODULE_13__modules_fun2win_store__["a" /* default */],
    cutemobiStore: __WEBPACK_IMPORTED_MODULE_14__modules_cutemobi_store__["a" /* default */],
    cutehubStore: __WEBPACK_IMPORTED_MODULE_15__modules_cutehub_store__["a" /* default */],
    apps4allStore: __WEBPACK_IMPORTED_MODULE_16__modules_apps4all_store__["a" /* default */],
    playmixStore: __WEBPACK_IMPORTED_MODULE_17__modules_playmix_store__["a" /* default */]
  },
  state: {},
  actions: {},
  mutations: {}
}));

/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_mobizone__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);












var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_mobiz");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_mobiz: {},
  //auth
  auth_mobiz: "",
  //hotpicks.vue
  pageHP_mobiz: {},
  //popular.vue
  pagePop_mobiz: {},
  //notification.vue
  notification_mobiz: {},
  //icon
  hotpickIcon_mobiz: __webpack_require__(2485),
  popularIcon_mobiz: __webpack_require__(2486),
  langButton_mobiz: "",
  country_mobiz: parts[0],
  host_mobiz: host,
  lang_mobiz: localStorage.getItem("lang_mobiz"),
  // lang_mobiz: brwlang,
  langcode_mobiz: "",
  type: "browse",
  gcid_mobiz: gcid,
  hpisLoad_mobiz: false,
  renew_date_mobiz: "",
  subscription_date_mobiz: "",
  status_mobiz: "",
  msisdn_mobiz: "",
  country_code: "",
  gateway_code: "",
  is_unsub: "0"
};

var getters = {
  langButton_mobiz: function langButton_mobiz(state) {
    return state.langButton_mobiz;
  },
  lang_mobiz: function lang_mobiz(state) {
    return state.lang_mobiz;
  },
  gcid_mobiz: function gcid_mobiz(state) {
    return state.gcid_mobiz;
  },
  country_mobiz: function country_mobiz(state) {
    return state.country_mobiz;
  },
  allSubcategory_mobiz: function allSubcategory_mobiz(state) {
    return state.allsubcategory_mobiz;
  },
  pageHotPicks_mobiz: function pageHotPicks_mobiz(state) {
    return state.pageHP_mobiz;
  },
  pagePopular_mobiz: function pagePopular_mobiz(state) {
    return state.pagePop_mobiz;
  },
  HotPickIcon_mobiz: function HotPickIcon_mobiz(state) {
    return state.hotpickIcon_mobiz;
  },
  PopularIcon_mobiz: function PopularIcon_mobiz(state) {
    return state.popularIcon_mobiz;
  },
  notification_mobiz: function notification_mobiz(state) {
    return state.notification_mobiz;
  },
  host_mobiz: function host_mobiz(state) {
    return state.host_mobiz;
  },
  auth_mobiz: function auth_mobiz(state) {
    return state.auth_mobiz;
  },
  hpisLoad_mobiz: function hpisLoad_mobiz(state) {
    return state.hpisLoad_mobiz;
  },
  renew_date_mobiz: function renew_date_mobiz(state) {
    return state.renew_date_mobiz;
  },
  subscription_date_mobiz: function subscription_date_mobiz(state) {
    return state.subscription_date_mobiz;
  },
  msisdn_mobiz: function msisdn_mobiz(state) {
    return state.msisdn_mobiz;
  },
  country_code: function country_code(state) {
    return state.country_code;
  },
  gateway_code: function gateway_code(state) {
    return state.gateway_code;
  },
  is_unsub_mobiz: function is_unsub_mobiz(state) {
    return state.is_unsub;
  },
  status_mobiz: function status_mobiz(state) {
    return state.status_mobiz;
  },
  langcode_mobiz: function langcode_mobiz(state) {
    return state.langcode_mobiz;
  }
};

var actions = {
  fetchLocale_mobiz: function fetchLocale_mobiz(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var lang_code, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lang_code = '';
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 4;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                  lang_code = value.lang_code;
                }
                // else {
                //   //english
                //   lang = lang;
                //   lang_code = 'en';
                // }
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 12:
              _context.prev = 12;
              _context.prev = 13;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 15:
              _context.prev = 15;

              if (!_didIteratorError) {
                _context.next = 18;
                break;
              }

              throw _iteratorError;

            case 18:
              return _context.finish(15);

            case 19:
              return _context.finish(12);

            case 20:
              commit("setLanguageCode", lang_code);
              commit("setLanguage", lang);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 8, 12, 20], [13,, 15, 19]]);
    }))();
  },
  fetchTranslateButton_mobiz: function fetchTranslateButton_mobiz(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_mobiz: function fetchAllSubcategory_mobiz(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPageHotPicks_mobiz: function fetchPageHotPicks_mobiz(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              // console.log(response.data.data);

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPagePopular_mobiz: function fetchPagePopular_mobiz(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 4:
              response = _context5.sent;


              response.data.data.sort(function (a, b) {
                return (
                  // a.content_name.localeCompare(b.content_name),
                  b.rating - a.rating
                );
              });

              commit("setPagePopular", response.data.data);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchToken_mobiz: function fetchToken_mobiz(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_mobiz");
              userProfile = localStorage.getItem("userProfile_mobiz");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join("/");

              if (path == "") {
                path = "/home";
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_mobiz", auth);
                // console.log(check)
                auth = auth.toLowerCase();
                letterNumber = "^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$";

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 19;
                break;
              }

              localStorage.setItem("userToken_mobiz", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 24;
              break;

            case 19:
              _context6.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userToken_mobiz", data.code);
                localStorage.setItem("userProfile_mobiz", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context6.next = 27;
              break;

            case 26:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getDomain_mobiz: function getDomain_mobiz(_ref11, host) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context7.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != "0") commit("setGatewayID", dom[0].gateway_id);
              } else {
                domain = "0";
              }
              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkToken_mobiz: function checkToken_mobiz(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subContent_mobiz: function subContent_mobiz(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userToken_mobiz");
              lang = localStorage.getItem("lang_mobiz");
              alert_pop = "";
              alert_lang = __webpack_require__(153)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;
              if (token != null) {
                if (file[1] != "application/x-zip-compressed") {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_mobiz,
                    product: 'mobizone',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_mobiz,
                    product: 'mobizone',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  login_mobiz: function login_mobiz(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchNotification_mobiz: function fetchNotification_mobiz(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, date, w, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              _context11.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=" + host);

            case 6:
              res = _context11.sent;
              data = res.data.data;
              noti = data.map(function (noti) {
                noti.titleSub_english = noti.subcategory;
                if (noti.subcategory_translate != null) {
                  var sub_trans = JSON.parse(noti.subcategory_translate);
                  if (sub_trans != null) {
                    var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                    if (sub_trans != null || sub_icon != null) {
                      for (var i = 0; i < trans_len; i++) {
                        noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                      }
                    }
                  }
                }
                return noti;
              });

              // if(w == 0){
              //   //name ascending
              //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
              // }else{
              //   //name descending
              //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
              // }

              // notify = noti.slice(0,5);

              commit("setNotification", noti);

            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_mobiz: function logout_mobiz(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_mobiz");
                localStorage.removeItem("userToken_mobiz");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              if (!(is_unsub != "0")) {
                _context12.next = 12;
                break;
              }

              token = localStorage.getItem("userToken_mobiz");
              _context12.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_code + "/" + state.gateway_code + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_mobiz));

            case 5:
              responses = _context12.sent;
              response = JSON.parse(responses.data.contents);

              removeStorage();
              __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.country_mobiz == "iq") {
                  __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Unsubscription" }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }
              }
              _context12.next = 14;
              break;

            case 12:
              removeStorage();
              if (state.country_mobiz == "iq") {
                __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
                __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Unsubscription" }).catch(function (err) {});
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_mobizone__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 14:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

var mutations = {
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_mobiz = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_mobiz = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_mobiz = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_mobiz = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_mobiz = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_mobiz = response;
  },
  setLanguageCode: function setLanguageCode(state, response) {
    return state.langcode_mobiz = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_mobiz = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    // format date to dd-mm-yyy
    var subscription_date = new Date(response.subscription_date);

    var dateTimeFormat = new Intl.DateTimeFormat("en", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });

    var _dateTimeFormat$forma = dateTimeFormat.formatToParts(subscription_date),
        _dateTimeFormat$forma2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_dateTimeFormat$forma, 5),
        month = _dateTimeFormat$forma2[0].value,
        day = _dateTimeFormat$forma2[2].value,
        year = _dateTimeFormat$forma2[4].value;

    var sub_date = day + "-" + month + "-" + year;

    var renew_date = '';
    if (response.next_renew_date != '' && response.next_renew_date != '0000-00-00') {
      var next_renew_date = new Date(response.next_renew_date);
      var dateTimeFormat1 = new Intl.DateTimeFormat("en", {
        year1: "numeric",
        month1: "2-digit",
        day1: "2-digit"
      });

      var _dateTimeFormat1$form = dateTimeFormat1.formatToParts(next_renew_date),
          _dateTimeFormat1$form2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_dateTimeFormat1$form, 5),
          month1 = _dateTimeFormat1$form2[0].value,
          day1 = _dateTimeFormat1$form2[2].value,
          year1 = _dateTimeFormat1$form2[4].value;

      renew_date = day1 + "-" + month1 + "-" + year1;
    } else {
      renew_date = response.next_renew_date;
    }

    return state.status_mobiz = response.status, state.renew_date_mobiz = renew_date, state.subscription_date_mobiz = sub_date, state.msisdn_mobiz = response.msisdn, state.country_code = response.country_code, state.gateway_code = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_mobiz = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2485 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTY5LjQsNDc5LjRjNC43LDIuNSw5LjYtMi45LDYuOC03LjRjLTE1LjYtMjQuMy0zMC4zLTY1LjEtNi44LTExNy42YzM5LjItODcuNiw2My4xLTEzMyw2My4xLTEzMw0KCQkJczEyLjcsNTMsNDcuMSwxMDAuMWMzMy4xLDQ1LjMsNTEuMiwxMDIuMywyMiwxNDkuOGMtMi43LDQuNSwyLjEsOS43LDYuOCw3LjNjMzYuMi0xOC41LDc2LjctNTUuNiw4MS4zLTEyOS40DQoJCQljMS43LTIyLjYtMC44LTU0LjEtMTMuNS05NGMtMTYuMy01MC41LTM2LjMtNzQuMS00Ny44LTg0LjJjLTMuNS0zLTguOC0wLjMtOC42LDQuMmMzLjQsNTQuNS0xNy4xLDY4LjMtMjguOCwzNy4yDQoJCQljLTQuNy0xMi41LTcuNC0zNC03LjQtNjAuMmMwLTQzLjctMTIuNy04OC42LTQwLjYtMTI1LjFjLTcuMy05LjUtMTUuOC0xOC40LTI1LjUtMjUuOWMtMy41LTIuNy04LjYsMC04LjMsNC41DQoJCQljMi4xLDI5LjYsMC4yLDExNC40LTc0LjIsMjE1LjhjLTY3LjUsOTQtNDEuMywxNjYuMi0zMi4xLDE4NS43QzEyMC41LDQ0NC41LDE0NS4zLDQ2Ni41LDE2OS40LDQ3OS40eiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 2486 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json__);









// import { response } from "express";
var proxyurl = "https://corsanywhere.herokuapp.com/";
var host = window.location.host;
var parts = host.split(".");
var lang = window.navigator.userLanguage || window.navigator.language;
var brlanguage = lang.substring(0, 2);
var brwlang = localStorage.getItem("language");

if (brlanguage == 'ms') {
  brwlang = 'malay';
} else if (brlanguage == 'ar') {
  brwlang = 'arabic';
} else if (brlanguage == 'el') {
  brwlang = 'greek';
} else if (brlanguage == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (brlanguage == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (brlanguage == 'id') {
  brwlang = 'indonesian';
} else if (brlanguage == 'th') {
  brwlang = 'thai';
} else if (brlanguage == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (brlanguage == 'ro' || parts[0] == 'ro') {
  brwlang = 'romanian';
} else if (brlanguage == 'en') {
  brwlang = 'english';
}
var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "https://corsanywhere.herokuapp.com/",
  countryCode: parts[0],
  langButton: "",
  language: brwlang,
  // language: sessionStorage.getItem("language"),
  src: "en",
  ar: "ar",
  gr: "el", //greek
  ms: "ms",
  translateCode: "",
  gcid_mobis: gcid,
  auth_mobis: '',
  secondLang: '',
  host_mobiscope: host,
  subscription_date_mobis: '',
  msisdn_mobis: '',

  country_name_mobis: '',
  gateway_mobis: '',
  is_unsub: '0'
};

var getters = {
  gcid_mobis: function gcid_mobis(state) {
    return state.gcid_mobis;
  },
  langButton: function langButton(state) {
    return state.langButton;
  },
  countryCode: function countryCode(state) {
    return state.countryCode;
  },
  language: function language(state) {
    return state.language;
  },
  translateCode: function translateCode(state) {
    return state.translateCode;
  },
  src: function src(state) {
    return state.src;
  },
  ar: function ar(state) {
    return state.ar;
  },
  gr: function gr(state) {
    return state.gr;
  },
  ms: function ms(state) {
    return state.ms;
  },
  auth_mobis: function auth_mobis(state) {
    return state.auth_mobis;
  },
  secondLang: function secondLang(state) {
    return state.secondLang;
  },
  host_mobiscope: function host_mobiscope(state) {
    return state.host_mobiscope;
  },
  subscription_date_mobis: function subscription_date_mobis(state) {
    return state.subscription_date_mobis;
  },
  msisdn_mobis: function msisdn_mobis(state) {
    return state.msisdn_mobis;
  },

  country_name_mobis: function country_name_mobis(state) {
    return state.country_name_mobis;
  },
  gateway_mobis: function gateway_mobis(state) {
    return state.gateway_mobis;
  },
  is_unsub_mobis: function is_unsub_mobis(state) {
    return state.is_unsub;
  }

};

var actions = {
  fetchLang: function fetchLang(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('setLanguage', lang);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchTransButton: function fetchTransButton(_ref2, country) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var style_flag, style_button, style_span, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              style_flag = "width: 21px; margin-right: 5px;";
              style_button = "background: none; border: none;";
              style_span = "font-weight: 600; font-size: 1.1rem; vertical-align: middle; color: white; text-transform: uppercase";
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 6;


              for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref3 = _step.value;
                _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                key = _ref4[0];
                value = _ref4[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"lang2 \" style=\"" + style_button + "\">\n          <img lang=\"" + value.language + "\" class=\"flag\" style=\"" + style_flag + "\" src=\"" + value.flag_rec + "\" />\n          <span lang=\"" + value.language + "\" style=\"" + style_span + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](6);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 14:
              _context2.prev = 14;
              _context2.prev = 15;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 17:
              _context2.prev = 17;

              if (!_didIteratorError) {
                _context2.next = 20;
                break;
              }

              throw _iteratorError;

            case 20:
              return _context2.finish(17);

            case 21:
              return _context2.finish(14);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[6, 10, 14, 22], [15,, 17, 21]]);
    }))();
  },
  fetchTranslateCode: function fetchTranslateCode(_ref5, country) {
    var _this3 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var transCode, secondLang, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref6, _ref7, key, value;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              transCode = void 0, secondLang = "";
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context3.prev = 4;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_8__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref6 = _step2.value;
                _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);
                key = _ref7[0];
                value = _ref7[1];

                if (key == country) {
                  secondLang = value.language;
                  transCode = value.lang_code;
                }
              }
              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](4);
              _didIteratorError2 = true;
              _iteratorError2 = _context3.t0;

            case 12:
              _context3.prev = 12;
              _context3.prev = 13;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 15:
              _context3.prev = 15;

              if (!_didIteratorError2) {
                _context3.next = 18;
                break;
              }

              throw _iteratorError2;

            case 18:
              return _context3.finish(15);

            case 19:
              return _context3.finish(12);

            case 20:
              commit('setSecondLang', secondLang);
              commit('setTranslateCode', transCode);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[4, 8, 12, 20], [13,, 15, 19]]);
    }))();
  },
  fetchToken_mobis: function fetchToken_mobis(_ref8, id) {
    var _this4 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var auth, check, token, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              auth = "";
              check = "";
              token = sessionStorage.getItem("tokenID");

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_mobiz", auth);
                // console.log(check)
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context4.next = 24;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context4.next = 11;
                break;
              }

              if (data.code == 'mobis80') {
                sessionStorage.setItem("tokenID", data.code);

                commit("setAuth", "guest");
              } else {
                sessionStorage.setItem("tokenID", data.code);

                commit("setAuth", "loggedin");
              }

              // EventBus.$emit("logged-in", "loggedin");
              _context4.next = 22;
              break;

            case 11:
              if (!(data.code == 'mobis80')) {
                _context4.next = 17;
                break;
              }

              sessionStorage.setItem("tokenID", data.code);
              commit("setAuth", "guest");
              __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__["a" /* default */].push({ name: "Horoscope" }).catch(function (err) {});
              _context4.next = 22;
              break;

            case 17:
              _context4.next = 19;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("" + proxyurl + ("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 19:
              responses = _context4.sent;

              // var response = JSON.parse(responses.data.contents);
              response = responses.data;


              if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert("Token is " + response.status);
                }
                __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "active") {
                localStorage.setItem("userTokenID_mobis", data.code);
                sessionStorage.setItem("tokenID", data.code);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                localStorage.setItem("mobis_msisdn", response.msisdn);
                localStorage.setItem("mobis_country_code", response.country_code);
                localStorage.setItem("mobis_gateway_code", response.gateway_code);
                __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__["a" /* default */].push({ name: "Horoscope" }).catch(function (err) {});
              }

            case 22:
              _context4.next = 25;
              break;

            case 24:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  login_mobis: function login_mobis(_ref9, loginAuth) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  guest_mobis: function guest_mobis(_ref10) {
    var _this6 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (state.auth_mobis == 'guest') {
                commit("setAuth", "");
                sessionStorage.removeItem("tokenID");
                __WEBPACK_IMPORTED_MODULE_7__router_mobiscope_js__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  logout_mobis: function logout_mobis(_ref11, is_unsub) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var token, mobi_msisdn, mobis_country_code, mobis_gateway_code, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              removeStorage = function removeStorage() {

                localStorage.removeItem("tokenID");
                localStorage.removeItem("userProfile_mobis");
                localStorage.removeItem("userTokenID_mobis");
                localStorage.removeItem("mobis_msisdn");
                localStorage.removeItem("mobis_country_code");
                localStorage.removeItem("mobis_gateway_code");
              };

              if (is_unsub != '0') {
                token = localStorage.getItem("userTokenID_mobis");
                mobi_msisdn = localStorage.getItem("mobis_msisdn");
                mobis_country_code = localStorage.getItem("mobis_country_code");
                mobis_gateway_code = localStorage.getItem("mobis_gateway_code");

                __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get("" + proxyurl + ("http://api.puretechglobal.net/gateway_request/" + mobis_country_code + "/" + mobis_gateway_code + "/unsub.php?code=" + token + "&msisdn=" + mobi_msisdn)).then(function (resp) {
                  location.reload();
                  // alert(is_unsub);
                });

                sessionStorage.removeItem("tokenID");
                removeStorage();
              } else {
                removeStorage();
              }

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getDomain_mobis: function getDomain_mobis(_ref12, host) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context8.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }

              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
};

var mutations = {
  setLanguage: function setLanguage(state, response) {
    return state.language = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton = response;
  },
  setTranslateCode: function setTranslateCode(state, response) {
    return state.translateCode = response;
  },
  setSecondLang: function setSecondLang(state, response) {
    return state.secondLang = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_mobis = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.subscription_date_mobis = response.subscription_date, state.msisdn_mobis = response.msisdn, state.country_name_mobis = response.country_code, state.gateway_mobis = response.gateway_code;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_games4all__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_g4all");

if (language == 'ms') {
    brwlang = 'malay';
} else if (language == 'ar') {
    brwlang = 'arabic';
} else if (language == 'el') {
    brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
    brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
    brwlang = 'norwegian';
} else if (language == 'id') {
    brwlang = 'indonesian';
} else if (language == 'th') {
    brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
    brwlang = 'czech';
} else if (language == 'en') {
    brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
    gcid = parts[1];
} else {
    gcid = '';
}

var state = {
    live: "http://cook.grabmobi.com",
    local: "http://[::1]/PuretechGlobalContentPortal",
    proxyurl: "http://api.allorigins.win/get?url=",
    //auth
    langButton_g4all: "",
    country_g4all: parts[0],
    // lang_g4all: localStorage.getItem("lang_g4all"),
    lang_g4all: brwlang,
    authentication_g4all: "",
    IconHotpick_g4all: __webpack_require__(220),
    IconPopular_g4all: __webpack_require__(221),
    //notification.vue
    notification_g4all: {},
    HotPicksPage_g4all: {},
    PopularPage_g4all: {},
    host_g4all: host,
    gcid_g4all: gcid,
    renew_date_g4all: '',
    subscription_date_g4all: '',
    msisdn_g4all: '',
    country_name_g4all: '',
    gateway_g4all: '',
    is_unsub: '0'
};

var getters = {
    gcid_g4all: function gcid_g4all(state) {
        return state.gcid_g4all;
    },
    allSubGame_g4all: function allSubGame_g4all(state) {
        return state.subCate_g4all;
    },
    allStoreGameData_g4all: function allStoreGameData_g4all(state) {
        return state.allGameData_g4all;
    },
    IconHotPick_g4all: function IconHotPick_g4all(state) {
        return state.IconHotpick_g4all;
    },
    IconPopular_g4all: function IconPopular_g4all(state) {
        return state.IconPopular_g4all;
    },
    notification_g4all: function notification_g4all(state) {
        return state.notification_g4all;
    },
    authentication_g4all: function authentication_g4all(state) {
        return state.authentication_g4all;
    },
    HotPicksPage_g4all: function HotPicksPage_g4all(state) {
        return state.HotPicksPage_g4all;
    },
    PopularPage_g4all: function PopularPage_g4all(state) {
        return state.PopularPage_g4all;
    },
    langButton_g4all: function langButton_g4all(state) {
        return state.langButton_g4all;
    },
    lang_g4all: function lang_g4all(state) {
        return state.lang_g4all;
    },
    country_g4all: function country_g4all(state) {
        return state.country_g4all;
    },
    host_g4all: function host_g4all(state) {
        return state.host_g4all;
    },
    renew_date_g4all: function renew_date_g4all(state) {
        return state.renew_date_g4all;
    },
    subscription_date_g4all: function subscription_date_g4all(state) {
        return state.subscription_date_g4all;
    },
    msisdn_g4all: function msisdn_g4all(state) {
        return state.msisdn_g4all;
    },
    country_name_g4all: function country_name_g4all(state) {
        return state.country_name_g4all;
    },
    gateway_g4all: function gateway_g4all(state) {
        return state.gateway_g4all;
    },
    is_unsub_g4all: function is_unsub_g4all(state) {
        return state.is_unsub;
    },
    hpisLoad_g4all: function hpisLoad_g4all(state) {
        return state.hpisLoad_g4all;
    }
};

var actions = {
    fetchLanguage_g4all: function fetchLanguage_g4all(_ref, lang) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 3;

                            for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                _ref2 = _step.value;
                                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                                key = _ref3[0];
                                value = _ref3[1];

                                if (lang == value.language) {
                                    lang = value.language;
                                } else {
                                    //english
                                    lang = lang;
                                }
                            }

                            _context.next = 11;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](3);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                        case 11:
                            _context.prev = 11;
                            _context.prev = 12;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 14:
                            _context.prev = 14;

                            if (!_didIteratorError) {
                                _context.next = 17;
                                break;
                            }

                            throw _iteratorError;

                        case 17:
                            return _context.finish(14);

                        case 18:
                            return _context.finish(11);

                        case 19:
                            commit("setLanguage", lang);

                        case 20:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
        }))();
    },
    fetchLanguageButton_g4all: function fetchLanguageButton_g4all(_ref4, country) {
        var _this2 = this;

        var commit = _ref4.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 3;

                            for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                _ref5 = _step2.value;
                                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                                key = _ref6[0];
                                value = _ref6[1];

                                if (country == key) {
                                    button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n              <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n              <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n              </button>";


                                    commit("setButton", button);
                                }
                            }
                            _context2.next = 11;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](3);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t0;

                        case 11:
                            _context2.prev = 11;
                            _context2.prev = 12;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 14:
                            _context2.prev = 14;

                            if (!_didIteratorError2) {
                                _context2.next = 17;
                                break;
                            }

                            throw _iteratorError2;

                        case 17:
                            return _context2.finish(14);

                        case 18:
                            return _context2.finish(11);

                        case 19:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
        }))();
    },
    fetchHotPicks_g4all: function fetchHotPicks_g4all(_ref7, file) {
        var _this3 = this;

        var commit = _ref7.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var data, limit, response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            data = file[0];
                            limit = 0;


                            if (file[1] != undefined) {
                                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
                            } else {
                                //default
                                limit = 200;
                            }

                            response = [];

                            if (!(data == undefined)) {
                                _context3.next = 10;
                                break;
                            }

                            _context3.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host);

                        case 7:
                            response = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 10:
                            _context3.next = 12;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

                        case 12:
                            response = _context3.sent;

                        case 13:

                            response.data.data.sort(function (a, b) {
                                return a.cont_name_english.localeCompare(b.cont_name_english);
                            });

                            commit("setPageHotPicks", response.data.data);

                        case 15:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    fetchPopular_g4all: function fetchPopular_g4all(_ref8, e) {
        var _this4 = this;

        var commit = _ref8.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var limit, url, response, data;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            limit = 0;


                            if (e != undefined) {
                                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                            } else {
                                //default
                                limit = 200;
                            }

                            url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=" + limit + "&offset=0&domain=" + host;
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

                        case 5:
                            response = _context4.sent;
                            data = response.data.data;


                            data.sort(function (a, b) {
                                //to sort random
                                return b.rating - a.rating;
                            });
                            commit("setPagePopular", data);

                        case 9:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    getDomain_g4all: function getDomain_g4all(_ref9, host) {
        var _this5 = this;

        var commit = _ref9.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var response, dom, domain;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

                        case 2:
                            response = _context5.sent;
                            dom = response.data.data;

                            dom = dom.filter(function (item) {
                                return item.domain == host;
                            });

                            domain = "";


                            if (dom != "") {
                                domain = dom[0].is_unsub;

                                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
                            } else {
                                domain = '0';
                            }

                            commit("setUnsubButton", domain);

                        case 8:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    fetchTokenID_g4all: function fetchTokenID_g4all(_ref10, id) {
        var _this6 = this;

        var commit = _ref10.commit,
            dispatch = _ref10.dispatch;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            auth = "";
                            check = "";
                            token = localStorage.getItem("userTokenID_g4all");
                            userProfile = localStorage.getItem("userProfile_g4all");
                            str = window.location.pathname;
                            path = str.split("/");

                            path.pop();
                            path = path.join('/');

                            if (path == '') {
                                path = '/home';
                            }

                            if (token != null) {
                                //checking if have token
                                auth = token;
                            } else {
                                //checking if have param id
                                auth = id;
                            }

                            if (auth != undefined) {
                                //to check if token has numbers and letters
                                // check = dispatch("checkTokenID_g4all", auth);
                                auth = auth.toLowerCase();
                                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                                if (auth.match(letterNumber)) {
                                    check = true;
                                } else {
                                    check = false;
                                }
                            } else {
                                __WEBPACK_IMPORTED_MODULE_8__router_games4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                            }

                            if (!(check == true)) {
                                _context6.next = 26;
                                break;
                            }

                            //if check is true
                            data = {
                                code: auth,
                                verbose: "1"
                            };

                            if (!(token != null)) {
                                _context6.next = 19;
                                break;
                            }

                            localStorage.setItem("userTokenID_g4all", data.code);
                            commit("setUserProfile", JSON.parse(userProfile));
                            commit("setAuth", "loggedin");
                            // EventBus.$emit("logged-in", "loggedin");
                            _context6.next = 24;
                            break;

                        case 19:
                            _context6.next = 21;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

                        case 21:
                            responses = _context6.sent;
                            response = JSON.parse(responses.data.contents);

                            if (response.status == "active") {
                                localStorage.setItem("userTokenID_g4all", data.code);
                                localStorage.setItem("userProfile_g4all", responses.data.contents);
                                commit("setUserProfile", response);
                                commit("setAuth", "loggedin");
                                __WEBPACK_IMPORTED_MODULE_8__router_games4all__["a" /* default */].push({ path: path }).catch(function (err) {});
                                // location.reload();
                            } else if (response.status == "inactive") {
                                if (data.code != undefined) {
                                    alert(response.status.toUpperCase());
                                }
                                __WEBPACK_IMPORTED_MODULE_8__router_games4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                            }

                        case 24:
                            _context6.next = 27;
                            break;

                        case 26:
                            //if check is false
                            __WEBPACK_IMPORTED_MODULE_8__router_games4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

                        case 27:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    checkTokenID_g4all: function checkTokenID_g4all(_ref11, auth) {
        var _this7 = this;

        var commit = _ref11.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
            var letterNumber;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            letterNumber = /^[0-9a-zA-Z]+$/;

                            if (!auth.match(letterNumber)) {
                                _context7.next = 5;
                                break;
                            }

                            return _context7.abrupt("return", true);

                        case 5:
                            return _context7.abrupt("return", false);

                        case 6:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    },
    subscribeContent_g4all: function subscribeContent_g4all(_ref12, file) {
        var _this8 = this;

        var commit = _ref12.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
            var token, lang, alert_pop, alert_lang;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            token = localStorage.getItem("userTokenID_g4all");
                            lang = localStorage.getItem("lang_g4all");
                            alert_pop = "";
                            alert_lang = __webpack_require__(95)("./" + lang + ".json");

                            alert_pop = alert_lang.not_subs;

                            if (token != null) {
                                if (file[1] != 'application/x-zip-compressed') {
                                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                                        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                                        country: state.country_g4all,
                                        product: 'games4all',
                                        content_id: file[2],
                                        type: "download"
                                    });
                                    window.location.href = file[0];
                                    // window.open(file[0], "download");
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                                        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                                        country: state.country_g4all,
                                        product: 'games4all',
                                        content_id: file[2],
                                        type: "play"
                                    });

                                    window.open(file[0], "_blank");
                                }
                            } else {
                                alert(alert_pop);

                                setTimeout(function () {
                                    __WEBPACK_IMPORTED_MODULE_8__router_games4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                                }, 1000);
                            }

                        case 6:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    },
    login_g4all: function login_g4all(_ref13, loginAuth) {
        var _this9 = this;

        var commit = _ref13.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            commit("setAuth", loginAuth);

                        case 1:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    },
    fetchNotification_g4all: function fetchNotification_g4all(_ref14) {
        var _this10 = this;

        var commit = _ref14.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
            var notify, date, w, url, res, data, noti;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            notify = [];
                            date = currentDate.getUTCDate();
                            w = week % 2;


                            if (w != 0) {
                                date = date + 10;
                            }

                            url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=5&offset=" + date + "&domain=" + host;
                            _context10.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

                        case 7:
                            res = _context10.sent;
                            data = res.data.data.slice(0, 5);
                            noti = data.map(function (noti) {
                                var sub_trans = JSON.parse(noti.subcategory_translate);
                                // console.log(noti.created_time)
                                var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                                var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                                noti.titleSub_english = noti.subcategory;
                                if (sub_trans != null || sub_icon != null) {
                                    for (var i = 0; i < trans_len; i++) {
                                        noti['titleSub_' + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                                    }
                                }

                                return noti;
                            });


                            if (w == 0) {
                                //name ascending
                                noti.sort(function (a, b) {
                                    return a.cont_name_english.localeCompare(b.cont_name_english);
                                });
                            } else {
                                //name descending
                                noti.sort(function (a, b) {
                                    return b.cont_name_english.localeCompare(a.cont_name_english);
                                });
                            }

                            notify = noti.slice(0, 5);

                            commit("setNotification", notify);

                        case 13:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    },
    logout_g4all: function logout_g4all(_ref15, is_unsub) {
        var _this11 = this;

        var commit = _ref15.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
            var token, responses, response, removeStorage;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            removeStorage = function removeStorage() {
                                localStorage.removeItem("userProfile_g4all");
                                localStorage.removeItem("userTokenID_g4all");
                                localStorage.removeItem("logged-in");
                            };

                            if (!(is_unsub != '0')) {
                                _context11.next = 12;
                                break;
                            }

                            token = localStorage.getItem("userTokenID_g4all");
                            _context11.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_g4all + "/" + state.gateway_g4all + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_g4all));

                        case 5:
                            responses = _context11.sent;

                            removeStorage();
                            response = JSON.parse(responses.data.contents);

                            if (responses.data.contents == 'success' || response.status == 'success') {
                                location.reload();
                            }
                            setTimeout(function () {
                                location.reload();
                            }, 0);
                            _context11.next = 13;
                            break;

                        case 12:
                            removeStorage();

                        case 13:
                        case "end":
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    }
};

var mutations = {
    setNotification: function setNotification(state, response) {
        return state.notification_g4all = response;
    },
    setAuth: function setAuth(state, response) {
        return state.authentication_g4all = response;
    },
    setPageHotPicks: function setPageHotPicks(state, response) {
        return state.HotPicksPage_g4all = response;
    },
    setPagePopular: function setPagePopular(state, response) {
        return state.PopularPage_g4all = response;
    },
    setButton: function setButton(state, response) {
        return state.langButton_g4all = response;
    },
    setLanguage: function setLanguage(state, response) {
        return state.lang_g4all = response;
    },
    setUserProfile: function setUserProfile(state, response) {
        return state.renew_date_g4all = response.next_renew_date, state.subscription_date_g4all = response.subscription_date, state.msisdn_g4all = response.msisdn, state.country_name_g4all = response.country_code, state.gateway_g4all = response.gateway_code;
    },
    setGatewayID: function setGatewayID(state, response) {
        return state.gcid_g4all = response;
    },
    setUnsubButton: function setUnsubButton(state, response) {
        return state.is_unsub = response;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fs__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fs__);











var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_Mobif");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //auth
  langButton_Mobif: "",
  country_Mobif: parts[0],
  lang_Mobif: localStorage.getItem("lang_Mobif"),
  // lang_Mobif: brwlang,
  authentication_Mobif: "",
  IconHotpick_Mobif: __webpack_require__(220),
  IconPopular_Mobif: __webpack_require__(221),
  homeSliderContentLoaded: false,
  //notification.vue
  notification_Mobif: {},
  HotPicksPage_Mobif: {},
  HotPicksPageLoad_Mobif: false,
  PopularPage_Mobif: {},
  subCate_Mobif: {},
  allData_Mobif: {},
  host_Mobif: host,
  gcid_Mobif: gcid,
  renew_date_Mobif: '',
  subscription_date_Mobif: '',
  msisdn_Mobif: '',
  country_name_Mobif: '',
  gateway_Mobif: '',
  is_unsub: '0',
  hpisLoad_Mobif: false,
  mobiflix_res_sub: ''
};

var getters = {
  subCate_Mobif: function subCate_Mobif(state) {
    return state.subCate_Mobif;
  },
  allData_Mobif: function allData_Mobif(state) {
    return state.allData_Mobif;
  },
  IconHotpick_Mobif: function IconHotpick_Mobif(state) {
    return state.IconHotpick_Mobif;
  },
  IconPopular_Mobif: function IconPopular_Mobif(state) {
    return state.IconPopular_Mobif;
  },
  notification_Mobif: function notification_Mobif(state) {
    return state.notification_Mobif;
  },
  authentication_Mobif: function authentication_Mobif(state) {
    return state.authentication_Mobif;
  },
  HotPicksPage_Mobif: function HotPicksPage_Mobif(state) {
    return state.HotPicksPage_Mobif;
  },
  HotPicksPageLoad_Mobif: function HotPicksPageLoad_Mobif(state) {
    return state.HotPicksPageLoad_Mobif;
  },
  PopularPage_Mobif: function PopularPage_Mobif(state) {
    return state.PopularPage_Mobif;
  },
  langButton_Mobif: function langButton_Mobif(state) {
    return state.langButton_Mobif;
  },
  lang_Mobif: function lang_Mobif(state) {
    return state.lang_Mobif;
  },
  country_Mobif: function country_Mobif(state) {
    return state.country_Mobif;
  },
  host_Mobif: function host_Mobif(state) {
    return state.host_Mobif;
  },
  homeSliderContentLoaded: function homeSliderContentLoaded(state) {
    return state.homeSliderContentLoaded;
  },
  hpisLoad_Mobif: function hpisLoad_Mobif(state) {
    return state.hpisLoad_Mobif;
  },
  gcid_Mobif: function gcid_Mobif(state) {
    return state.gcid_Mobif;
  },
  renew_date_Mobif: function renew_date_Mobif(state) {
    return state.renew_date_Mobif;
  },
  subscription_date_Mobif: function subscription_date_Mobif(state) {
    return state.subscription_date_Mobif;
  },
  msisdn_Mobif: function msisdn_Mobif(state) {
    return state.msisdn_Mobif;
  },
  country_name_Mobif: function country_name_Mobif(state) {
    return state.country_name_Mobif;
  },
  gateway_Mobif: function gateway_Mobif(state) {
    return state.gateway_Mobif;
  },
  is_unsub_Mobif: function is_unsub_Mobif(state) {
    return state.is_unsub;
  },
  mobiflix_res_sub: function mobiflix_res_sub(state) {
    return state.mobiflix_res_sub;
  }
};

var actions = {
  fetchLang_Mobif: function fetchLang_Mobif(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchLangButton_Mobif: function fetchLangButton_Mobif(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchPageHotPicks_Mobif: function fetchPageHotPicks_Mobif(_ref7, file) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data, limit, response, load, hotpick;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              state.HotPicksPageLoad_Mobif = false;
              state.HotPicksPage_Mobif = {};

              response = [];

              if (!(data == undefined)) {
                _context3.next = 12;
                break;
              }

              _context3.next = 9;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=video&limit=" + limit + "&offset=0&domain=" + host);

            case 9:
              response = _context3.sent;
              _context3.next = 15;
              break;

            case 12:
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 14:
              response = _context3.sent;

            case 15:
              load = true;

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              hotpick = response.data.data;

              commit("setPageHotPicks", { hotpick: hotpick, load: load });

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPagePopular_Mobif: function fetchPagePopular_Mobif(_ref8, e) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var limit, url, response, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              url = state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=video&limit=" + limit + "&offset=0&domain=" + host;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 5:
              response = _context4.sent;
              data = response.data.data;


              data.sort(function (a, b) {
                //to sort random
                return b.rating - a.rating;
              });

              commit("setPagePopular", data);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDomain_Mobif: function getDomain_Mobif(_ref9, host) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context5.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }

              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchTokenID_Mobif: function fetchTokenID_Mobif(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userTokenID_Mobif");
              userProfile = localStorage.getItem("userProfile_Mobif");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkTokenID_Mobif", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 30;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 17;
                break;
              }

              if (data.code == 'mobif80') {
                localStorage.setItem("userTokenID_Mobif", data.code);
                commit("setAuth", "guest");
              } else {
                localStorage.setItem("userTokenID_Mobif", data.code);
                commit("setUserProfile", JSON.parse(userProfile));
                commit("setAuth", "loggedin");
              }
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 28;
              break;

            case 17:
              if (!(data.code == 'mobif80')) {
                _context6.next = 23;
                break;
              }

              localStorage.setItem("userTokenID_Mobif", data.code);
              commit("setAuth", "guest");
              __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ path: path }).catch(function (err) {});
              _context6.next = 28;
              break;

            case 23:
              _context6.next = 25;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 25:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userTokenID_Mobif", data.code);
                localStorage.setItem("userProfile_Mobif", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 28:
              _context6.next = 31;
              break;

            case 30:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 31:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  checkTokenID_Mobif: function checkTokenID_Mobif(_ref11, auth) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return", true);

            case 5:
              return _context7.abrupt("return", false);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  subscribeContent_Mobif: function subscribeContent_Mobif(_ref12, file) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              token = localStorage.getItem("userTokenID_Mobif");
              lang = localStorage.getItem("lang_Mobif");
              alert_pop = "";
              alert_lang = __webpack_require__(121)("./" + lang + ".json");


              alert_pop = alert_lang.not_subs;
              console.log(file);
              if (state.authentication_Mobif == 'guest') {
                commit("setAuth", "");
                localStorage.removeItem("userTokenID_Mobif");
                __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              } else {
                if (token != null) {
                  if (file[1] != "application/x-zip-compressed") {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                      token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                      country: state.country_Mobif,
                      product: 'mobiflix',
                      content_id: file[2],
                      type: "download"
                    });
                    window.location.href = file[0];
                    // window.open(file[0], "download");
                  } else {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                      token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                      country: state.country_Mobif,
                      product: 'mobiflix',
                      content_id: file[2],
                      type: "play"
                    });

                    window.open(file[0], "_blank");
                  }
                } else {
                  alert(alert_pop);

                  setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                  }, 1000);
                }
              }

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  loginMobif: function loginMobif(_ref13, loginAuth) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  fetchNotification_Mobif: function fetchNotification_Mobif(_ref14) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var notify, date, w, url, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=&limit=10&offset=" + date + "&domain=" + host;
              _context10.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 7:
              res = _context10.sent;
              data = res.data.data.slice(0, 5);
              noti = data.map(function (noti) {
                var sub_trans = JSON.parse(noti.subcategory_translate);

                if (sub_trans != null) {
                  // console.log(noti.created_time)
                  var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                  var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                  noti.titleSub_english = noti.subcategory;
                  if (sub_trans != null || sub_icon != null) {
                    for (var i = 0; i < trans_len; i++) {
                      noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                    }
                  }
                }

                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.cont_name_english.localeCompare(b.cont_name_english);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.cont_name_english.localeCompare(a.cont_name_english);
                });
              }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  logout_Mobif: function logout_Mobif(_ref15, is_unsub) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var token, _lang, responses, response, removeStorage;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_Mobif");
                localStorage.removeItem("userTokenID_Mobif");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              $("#exampleModalCenter").modal("hide");

              if (!(is_unsub != '0')) {
                _context11.next = 13;
                break;
              }

              token = localStorage.getItem("userTokenID_Mobif");
              _lang = localStorage.getItem("lang_Mobif");
              _context11.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_Mobif + "/" + state.gateway_Mobif + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_Mobif));

            case 7:
              responses = _context11.sent;

              removeStorage();
              response = JSON.parse(responses.data.contents);


              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.gateway_Mobif == 'mondiamedia') {
                  __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              } else if (response.status == 'fail') {
                if (state.gateway_Mobif == 'mondiamedia' && state.gcid_Mobif == '339') {

                  if (_lang == 'arabic') {
                    state.mobiflix_res_sub = response.ar_error_message;
                  } else {
                    state.mobiflix_res_sub = response.en_error_message;
                  }

                  __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                }
              } else {

                __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
              }
              _context11.next = 15;
              break;

            case 13:
              removeStorage();
              __WEBPACK_IMPORTED_MODULE_8__router_mobiflix__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});

            case 15:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }
};

var mutations = {
  setNotification: function setNotification(state, response) {
    return state.notification_Mobif = response;
  },
  setAuth: function setAuth(state, response) {
    return state.authentication_Mobif = response;
  },
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.HotPicksPage_Mobif = response.hotpick, state.HotPicksPageLoad_Mobif = response.load;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.PopularPage_Mobif = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_Mobif = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_Mobif = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_Mobif = response.next_renew_date, state.subscription_date_Mobif = response.subscription_date, state.msisdn_Mobif = response.msisdn, state.country_name_Mobif = response.country_code, state.gateway_Mobif = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_Mobif = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }

};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_gameknight__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();
var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_Gkn");

if (language == 'ms') {
    brwlang = 'malay';
} else if (language == 'ar') {
    brwlang = 'arabic';
} else if (language == 'el') {
    brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
    brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
    brwlang = 'norwegian';
} else if (language == 'id') {
    brwlang = 'indonesian';
} else if (language == 'th') {
    brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
    brwlang = 'czech';
} else if (language == 'en') {
    brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
    gcid = parts[1];
} else {
    gcid = '';
}

var state = {
    live: "http://cook.grabmobi.com",
    local: "http://[::1]/PuretechGlobalContentPortal",
    proxyurl: "http://api.allorigins.win/get?url=",
    //auth
    langButton_Gkn: "",
    country_Gkn: parts[0],
    // lang_Gkn: localStorage.getItem("lang_Gkn"),
    lang_Gkn: brwlang,
    authentication_Gkn: "",
    Icon_hotpick_Gkn: __webpack_require__(2491),
    Icon_popular_Gkn: __webpack_require__(2492),
    //notification.vue
    notification_Gkn: {},
    HotPicksPage_Gkn: {},
    PopularPage_Gkn: {},
    host_Gkn: host,
    gcid_Gkn: gcid,
    renew_date_Gkn: '',
    subscription_date_Gkn: '',
    msisdn_Gkn: '',
    country_name_Gkn: '',
    gateway_Gkn: '',
    is_unsub: '0',
    subcategory_id_Gkn: ''
};

var getters = {
    gcid_Gkn: function gcid_Gkn(state) {
        return state.gcid_Gkn;
    },
    IconHotPick_Gkn: function IconHotPick_Gkn(state) {
        return state.Icon_hotpick_Gkn;
    },
    IconPopular_Gkn: function IconPopular_Gkn(state) {
        return state.Icon_popular_Gkn;
    },
    notification_Gkn: function notification_Gkn(state) {
        return state.notification_Gkn;
    },
    authentication_Gkn: function authentication_Gkn(state) {
        return state.authentication_Gkn;
    },
    HotPicksPage_Gkn: function HotPicksPage_Gkn(state) {
        return state.HotPicksPage_Gkn;
    },
    PopularPage_Gkn: function PopularPage_Gkn(state) {
        return state.PopularPage_Gkn;
    },
    langButton_Gkn: function langButton_Gkn(state) {
        return state.langButton_Gkn;
    },
    lang_Gkn: function lang_Gkn(state) {
        return state.lang_Gkn;
    },
    country_Gkn: function country_Gkn(state) {
        return state.country_Gkn;
    },
    host_Gkn: function host_Gkn(state) {
        return state.host_Gkn;
    },
    renew_date_Gkn: function renew_date_Gkn(state) {
        return state.renew_date_Gkn;
    },
    subscription_date_Gkn: function subscription_date_Gkn(state) {
        return state.subscription_date_Gkn;
    },
    msisdn_Gkn: function msisdn_Gkn(state) {
        return state.msisdn_Gkn;
    },
    country_name_Gkn: function country_name_Gkn(state) {
        return state.country_name_Gkn;
    },
    gateway_Gkn: function gateway_Gkn(state) {
        return state.gateway_Gkn;
    },
    is_unsub_Gkn: function is_unsub_Gkn(state) {
        return state.is_unsub;
    },
    subcategory_id_Gkn: function subcategory_id_Gkn(state) {
        return state.subcategory_id_Gkn;
    }
};

var actions = {
    fetchLanguage_Gkn: function fetchLanguage_Gkn(_ref, lang) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 3;

                            for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                _ref2 = _step.value;
                                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                                key = _ref3[0];
                                value = _ref3[1];

                                if (lang == value.language) {
                                    lang = value.language;
                                } else {
                                    //english
                                    lang = lang;
                                }
                            }

                            _context.next = 11;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](3);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                        case 11:
                            _context.prev = 11;
                            _context.prev = 12;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 14:
                            _context.prev = 14;

                            if (!_didIteratorError) {
                                _context.next = 17;
                                break;
                            }

                            throw _iteratorError;

                        case 17:
                            return _context.finish(14);

                        case 18:
                            return _context.finish(11);

                        case 19:
                            commit("setLanguage", lang);

                        case 20:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
        }))();
    },
    fetchLanguageButton_Gkn: function fetchLanguageButton_Gkn(_ref4, country) {
        var _this2 = this;

        var commit = _ref4.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 3;

                            for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                _ref5 = _step2.value;
                                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                                key = _ref6[0];
                                value = _ref6[1];

                                if (country == key) {
                                    button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n              <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n              <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n              </button>";


                                    commit("setButton", button);
                                }
                            }
                            _context2.next = 11;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](3);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t0;

                        case 11:
                            _context2.prev = 11;
                            _context2.prev = 12;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 14:
                            _context2.prev = 14;

                            if (!_didIteratorError2) {
                                _context2.next = 17;
                                break;
                            }

                            throw _iteratorError2;

                        case 17:
                            return _context2.finish(14);

                        case 18:
                            return _context2.finish(11);

                        case 19:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
        }))();
    },
    fetchHotPicksGame_Gkn: function fetchHotPicksGame_Gkn(_ref7, file) {
        var _this3 = this;

        var commit = _ref7.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var data, limit, response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            data = file[0];
                            limit = 0;


                            if (file[1] != undefined) {
                                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
                            } else {
                                //default
                                limit = 200;
                            }

                            response = [];

                            if (!(data == undefined)) {
                                _context3.next = 10;
                                break;
                            }

                            _context3.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host);

                        case 7:
                            response = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 10:
                            _context3.next = 12;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

                        case 12:
                            response = _context3.sent;

                        case 13:

                            response.data.data.sort(function (a, b) {
                                return a.cont_name_english.localeCompare(b.cont_name_english);
                            });

                            commit("setPageHotPicks", response.data.data);

                        case 15:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    fetchPopularGame_Gkn: function fetchPopularGame_Gkn(_ref8, e) {
        var _this4 = this;

        var commit = _ref8.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var limit, url, response, data;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            limit = 0;


                            if (e != undefined) {
                                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
                            } else {
                                //default
                                limit = 200;
                            }

                            url = state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host;
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

                        case 5:
                            response = _context4.sent;
                            data = response.data.data;


                            data.sort(function (a, b) {
                                //to sort random
                                return b.rating - a.rating;
                            });
                            commit("setPagePopular", data);

                        case 9:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    getDomain_Gkn: function getDomain_Gkn(_ref9, host) {
        var _this5 = this;

        var commit = _ref9.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var response, dom, domain;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

                        case 2:
                            response = _context5.sent;
                            dom = response.data.data;

                            dom = dom.filter(function (item) {
                                return item.domain == host;
                            });

                            domain = "";


                            if (dom != "") {
                                domain = dom[0].is_unsub;

                                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
                            } else {
                                domain = '0';
                            }

                            commit("setUnsubButton", domain);

                        case 8:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    fetchTokenID_Gkn: function fetchTokenID_Gkn(_ref10, id) {
        var _this6 = this;

        var commit = _ref10.commit,
            dispatch = _ref10.dispatch;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            auth = "";
                            check = "";
                            token = localStorage.getItem("userTokenID_Gkn");
                            userProfile = localStorage.getItem("userProfile_Gkn");
                            str = window.location.pathname;
                            path = str.split("/");

                            path.pop();
                            path = path.join('/');

                            if (path == '') {
                                path = '/home';
                            }

                            if (token != null) {
                                //checking if have token
                                auth = token;
                            } else {
                                //checking if have param id
                                auth = id;
                            }

                            if (auth != undefined) {
                                //to check if token has numbers and letters
                                // check = dispatch("checkTokenID_Gkn", auth);
                                auth = auth.toLowerCase();
                                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                                if (auth.match(letterNumber)) {
                                    check = true;
                                } else {
                                    check = false;
                                }
                            } else {
                                __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                            }

                            if (!(check == true)) {
                                _context6.next = 30;
                                break;
                            }

                            //if check is true
                            data = {
                                code: auth,
                                verbose: "1"
                            };

                            if (!(token != null)) {
                                _context6.next = 17;
                                break;
                            }

                            if (data.code == 'gkn80') {
                                localStorage.setItem("userTokenID_Gkn", data.code);
                                commit("setAuth", "guest");
                            } else {
                                localStorage.setItem("userTokenID_Gkn", data.code);
                                commit("setUserProfile", JSON.parse(userProfile));
                                commit("setAuth", "loggedin");
                            }
                            // EventBus.$emit("logged-in", "loggedin");
                            _context6.next = 28;
                            break;

                        case 17:
                            if (!(data.code == 'gkn80')) {
                                _context6.next = 23;
                                break;
                            }

                            localStorage.setItem("userTokenID_Gkn", data.code);
                            commit("setAuth", "guest");
                            __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ path: path }).catch(function (err) {});
                            _context6.next = 28;
                            break;

                        case 23:
                            _context6.next = 25;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

                        case 25:
                            responses = _context6.sent;
                            response = JSON.parse(responses.data.contents);

                            if (response.status == "active") {
                                localStorage.setItem("userTokenID_Gkn", data.code);
                                localStorage.setItem("userProfile_Gkn", responses.data.contents);
                                commit("setUserProfile", response);
                                commit("setAuth", "loggedin");
                                __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ path: path }).catch(function (err) {});
                                // location.reload();
                            } else if (response.status == "inactive") {
                                if (data.code != undefined) {
                                    alert(response.status.toUpperCase());
                                }
                                __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                            }

                        case 28:
                            _context6.next = 31;
                            break;

                        case 30:
                            //if check is false
                            __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

                        case 31:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    checkTokenID_Gkn: function checkTokenID_Gkn(_ref11, auth) {
        var _this7 = this;

        var commit = _ref11.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
            var letterNumber;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            letterNumber = /^[0-9a-zA-Z]+$/;

                            if (!auth.match(letterNumber)) {
                                _context7.next = 5;
                                break;
                            }

                            return _context7.abrupt("return", true);

                        case 5:
                            return _context7.abrupt("return", false);

                        case 6:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    },
    subscribeContent_Gkn: function subscribeContent_Gkn(_ref12, file) {
        var _this8 = this;

        var commit = _ref12.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
            var token, lang, alert_pop, alert_lang;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            token = localStorage.getItem("userTokenID_Gkn");
                            lang = localStorage.getItem("lang_Gkn");
                            alert_pop = "";
                            alert_lang = __webpack_require__(156)("./" + lang + ".json");

                            alert_pop = alert_lang.not_subs;
                            if (state.authentication_Gkn == 'guest') {
                                commit("setAuth", "");
                                localStorage.removeItem("userTokenID_Gkn");
                                __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                            } else {
                                if (token != null) {
                                    if (file[1] != 'application/x-zip-compressed') {
                                        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                                            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                                            country: state.country_Gkn,
                                            product: 'gameknight',
                                            content_id: file[2],
                                            type: "download"
                                        });
                                        window.location.href = file[0];
                                        // window.open(file[0], "download");
                                    } else {
                                        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                                            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                                            country: state.country_Gkn,
                                            product: 'gameknight',
                                            content_id: file[2],
                                            type: "play"
                                        });

                                        window.open(file[0], "_blank");
                                    }
                                } else {
                                    alert(alert_pop);

                                    setTimeout(function () {
                                        __WEBPACK_IMPORTED_MODULE_8__router_gameknight__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                                    }, 1000);
                                }
                            }

                        case 6:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    },
    login_Gkn: function login_Gkn(_ref13, loginAuth) {
        var _this9 = this;

        var commit = _ref13.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            commit("setAuth", loginAuth);

                        case 1:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    },
    fetchGameNotification_Gkn: function fetchGameNotification_Gkn(_ref14) {
        var _this10 = this;

        var commit = _ref14.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
            var notify, date, w, url, res, data, noti;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            notify = [];
                            date = currentDate.getUTCDate();
                            w = week % 2;


                            if (w != 0) {
                                date = date + 10;
                            }

                            url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=10&offset=" + date + "&domain=" + host;
                            _context10.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

                        case 7:
                            res = _context10.sent;
                            data = res.data.data.slice(0, 5);
                            noti = data.map(function (noti) {
                                var sub_trans = JSON.parse(noti.subcategory_translate);
                                // console.log(noti.created_time)
                                var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                                var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                                noti.titleSub_english = noti.subcategory;
                                if (sub_trans != null || sub_icon != null) {
                                    for (var i = 0; i < trans_len; i++) {
                                        noti['titleSub_' + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                                    }
                                }

                                return noti;
                            });


                            if (w == 0) {
                                //name ascending
                                noti.sort(function (a, b) {
                                    return a.cont_name_english.localeCompare(b.cont_name_english);
                                });
                            } else {
                                //name descending
                                noti.sort(function (a, b) {
                                    return b.cont_name_english.localeCompare(a.cont_name_english);
                                });
                            }

                            notify = noti.slice(0, 5);

                            commit("setNotification", notify);

                        case 13:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    },
    logout_Gkn: function logout_Gkn(_ref15, is_unsub) {
        var _this11 = this;

        var commit = _ref15.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
            var token, responses, response, removeStorage;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            removeStorage = function removeStorage() {
                                localStorage.removeItem("userProfile_Gkn");
                                localStorage.removeItem("userTokenID_Gkn");
                                localStorage.removeItem("logged-in");
                            };

                            if (!(is_unsub != '0')) {
                                _context11.next = 13;
                                break;
                            }

                            token = localStorage.getItem("userTokenID_Gkn");
                            _context11.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_Gkn + "/" + state.gateway_Gkn + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_Gkn));

                        case 5:
                            responses = _context11.sent;

                            removeStorage();
                            console.log(response);
                            response = JSON.parse(responses.data.contents);

                            if (responses.data.contents == 'success' || response.status == 'success') {
                                location.reload();
                            }
                            setTimeout(function () {
                                location.reload();
                            }, 0);
                            _context11.next = 14;
                            break;

                        case 13:
                            removeStorage();

                        case 14:
                        case "end":
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    },
    getSubCategory_Gkn: function getSubCategory_Gkn(_ref16, subcategory) {
        var _this12 = this;

        var commit = _ref16.commit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            commit('setSubcategory', subcategory);

                        case 1:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    }
};

var mutations = {
    setNotification: function setNotification(state, response) {
        return state.notification_Gkn = response;
    },
    setAuth: function setAuth(state, response) {
        return state.authentication_Gkn = response;
    },
    setPageHotPicks: function setPageHotPicks(state, response) {
        return state.HotPicksPage_Gkn = response;
    },
    setPagePopular: function setPagePopular(state, response) {
        return state.PopularPage_Gkn = response;
    },
    setButton: function setButton(state, response) {
        return state.langButton_Gkn = response;
    },
    setLanguage: function setLanguage(state, response) {
        return state.lang_Gkn = response;
    },
    setUserProfile: function setUserProfile(state, response) {
        return state.renew_date_Gkn = response.next_renew_date, state.subscription_date_Gkn = response.subscription_date, state.msisdn_Gkn = response.msisdn, state.country_name_Gkn = response.country_code, state.gateway_Gkn = response.gateway_code;
    },
    setGatewayID: function setGatewayID(state, response) {
        return state.gcid_Gkn = response;
    },
    setUnsubButton: function setUnsubButton(state, response) {
        return state.is_unsub = response;
    },
    setSubcategory: function setSubcategory(state, response) {
        return state.subcategory_id_Gkn = response;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA2MTEuOTk5IDYxMS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMS45OTkgNjExLjk5OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+DQoJPHBhdGggZD0iTTIxNi4wMiw2MTEuMTk1YzUuOTc4LDMuMTc4LDEyLjI4NC0zLjcwNCw4LjYyNC05LjRjLTE5Ljg2Ni0zMC45MTktMzguNjc4LTgyLjk0Ny04LjcwNi0xNDkuOTUyICAgYzQ5Ljk4Mi0xMTEuNzM3LDgwLjM5Ni0xNjkuNjA5LDgwLjM5Ni0xNjkuNjA5czE2LjE3Nyw2Ny41MzYsNjAuMDI5LDEyNy41ODVjNDIuMjA1LDU3Ljc5Myw2NS4zMDYsMTMwLjQ3OCwyOC4wNjQsMTkxLjAyOSAgIGMtMy40OTUsNS42ODMsMi42NjgsMTIuMzg4LDguNjA3LDkuMzQ5YzQ2LjEtMjMuNTgyLDk3LjgwNi03MC44ODUsMTAzLjY0LTE2NS4wMTdjMi4xNTEtMjguNzY0LTEuMDc1LTY5LjAzNC0xNy4yMDYtMTE5Ljg1MSAgIGMtMjAuNzQxLTY0LjQwNi00Ni4yMzktOTQuNDU5LTYwLjk5Mi0xMDcuMzY1Yy00LjQxMy0zLjg2MS0xMS4yNzYtMC40MzktMTAuOTE0LDUuNDEzYzQuMjk5LDY5LjQ5NC0yMS44NDUsODcuMTI5LTM2LjcyNiw0Ny4zODYgICBjLTUuOTQzLTE1Ljg3NC05LjQwOS00My4zMy05LjQwOS03Ni43NjZjMC01NS42NjUtMTYuMTUtMTEyLjk2Ny01MS43NTUtMTU5LjUzMWMtOS4yNTktMTIuMTA5LTIwLjA5My0yMy40MjQtMzIuNTIzLTMzLjA3MyAgIGMtNC41LTMuNDk0LTExLjAyMywwLjAxOC0xMC42MTEsNS43YzIuNzM0LDM3LjczNiwwLjI1NywxNDUuODg1LTk0LjYyNCwyNzUuMDg5Yy04Ni4wMjksMTE5Ljg1MS01Mi42OTMsMjExLjg5Ni00MC44NjQsMjM2LjgyNiAgIEMxNTMuNjY2LDU2Ni43NjcsMTg1LjIxMiw1OTQuODE0LDIxNi4wMiw2MTEuMTk1eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iIzhBMzJFNiIvPg0KPC9nPjwvZz4gPC9zdmc+DQo="

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgaGVpZ2h0PSI1MTJweCIgdmlld0JveD0iMCAtMTA2IDUxMi4wMDAxOSA1MTIiIHdpZHRoPSI1MTJweCI+PGc+PHBhdGggZD0ibTQ5Ny4zMjgxMjUgNy42Nzk2ODhjLTEwLjM5MDYyNS03Ljk0NTMxMy0yNC4yODEyNS05Ljg3MTA5NC0zNi40MjE4NzUtNS4wODk4NDRsLTEyMi40ODA0NjkgMzkuMzk4NDM3Yy0uNDAyMzQzLjEyODkwNy0uNzk2ODc1LjI3MzQzOC0xLjE4MzU5My40Mzc1LTEyLjI5Mjk2OSA1LjEwOTM3NS0yMSAxNi40OTIxODgtMjIuNzIyNjU3IDI5LjY5OTIxOS0xLjcxODc1IDEzLjIwMzEyNSAzLjc4NTE1NyAyNi40MzM1OTQgMTQuMzYzMjgxIDM0LjUyNzM0NGw5LjYwMTU2MyA3LjM0Mzc1LTM0LjQyMTg3NSAzNS44ODY3MTgtOTguNDM3NS0xMDguMjg1MTU2Yy0xMS42Nzk2ODgtMTMuNzkyOTY4LTI4LjczODI4MS0yMS40NzY1NjItNDYuODk0NTMxLTIxLjA1NDY4Ny0xOC4yMjY1NjMuNDMzNTkzLTM1LjAwMzkwNyA5LjAxMTcxOS00Ni4wODU5MzggMjMuNjAxNTYybC0xMDAuNTAzOTA2IDEzMy45MTQwNjNjLTkuNjI1IDEyLjY3NTc4MS0xMy43MzgyODEgMjguMzQzNzUtMTEuNTgyMDMxIDQ0LjExMzI4MSAyLjE2MDE1NiAxNS43NzM0MzcgMTAuMzI4MTI1IDI5Ljc1NzgxMyAyMy4wMDc4MTIgMzkuMzgyODEzIDEwLjc1IDguMTY3OTY4IDIzLjQwNjI1IDEyLjEwOTM3NCAzNS45NjQ4NDQgMTIuMTA5Mzc0IDE4LjAxMTcxOSAwIDM1LjgyNDIxOS04LjExMzI4MSA0Ny41MzEyNS0yMy41MzEyNS4wMjczNDQtLjAzMTI1LjA1MDc4MS0uMDY2NDA2LjA3ODEyNS0uMTAxNTYybDU1Ljg4NjcxOS03NC45MDIzNDQgOTQuNDcyNjU2IDEwMy43MTg3NWMxMS4xNjc5NjkgMTMuMTgzNTk0IDI3LjQ2NDg0NCAyMC44NTU0NjkgNDQuODI0MjE5IDIxLjA2MjVoLjY0MDYyNWMxNy4wNjY0MDYgMCAzMy4zMjAzMTItNy4zMjQyMTggNDQuNjI1LTIwLjEwMTU2Mmw4Ni4wNjI1LTkzLjAwNzgxMyAxNC42NjQwNjIgMTEuMjE4NzVjNi4wMzkwNjMgNC42MTcxODggMTMuMjQ2MDk0IDcuMjYxNzE5IDIwLjgzOTg0NCA3LjY0MDYyNSA1LjUxNTYyNS4yODEyNSAxMS4xMzY3MTktLjY5NTMxMiAxNi4yNDIxODgtMi44MjAzMTIgMTIuMjkyOTY4LTUuMTEzMjgyIDIxLTE2LjQ5MjE4OCAyMi43MTg3NS0yOS42OTkyMTkuMDY2NDA2LS41MTE3MTkuMTA1NDY4LTEuMDI3MzQ0LjEyMTA5My0xLjU0Njg3NWwzLjU1NDY4OC0xMzAuMjU3ODEyYzEuMzcxMDkzLTEyLjkxMDE1Ny00LjExNzE4OC0yNS43MzgyODItMTQuNDY0ODQ0LTMzLjY1NjI1em0wIDAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiIGZpbGw9IiNDQjAwRkQiLz48L2c+IDwvc3ZnPg0K"

/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_gameonz__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);

var brwlang = localStorage.getItem("lang_gonz");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //auth
  langButton_gonz: "",
  country_gonz: parts[0],
  // lang_gonz: localStorage.getItem("lang_gonz"),
  lang_gonz: brwlang,
  authentication_gonz: "",
  IconHotpick_gonz: __webpack_require__(2494),
  IconPopular_gonz: __webpack_require__(2495),
  //notification.vue
  notification_gonz: {},
  HotPicksPage_gonz: {},
  PopularPage_gonz: {},
  host_gonz: host,
  gcid_gonz: gcid,
  renew_date_gonz: '',
  subscription_date_gonz: '',
  msisdn_gonz: '',
  country_name_gonz: '',
  gateway_gonz: '',
  is_unsub: '0',
  mondia_res_sub: ''
  // number_of_week: week
};

var getters = {
  gcid_gonz: function gcid_gonz(state) {
    return state.gcid_gonz;
  },
  IconHotPick_gonz: function IconHotPick_gonz(state) {
    return state.IconHotpick_gonz;
  },
  IconPopular_gonz: function IconPopular_gonz(state) {
    return state.IconPopular_gonz;
  },
  notification_gonz: function notification_gonz(state) {
    return state.notification_gonz;
  },
  authentication_gonz: function authentication_gonz(state) {
    return state.authentication_gonz;
  },
  HotPicksPage_gonz: function HotPicksPage_gonz(state) {
    return state.HotPicksPage_gonz;
  },
  PopularPage_gonz: function PopularPage_gonz(state) {
    return state.PopularPage_gonz;
  },
  langButton_gonz: function langButton_gonz(state) {
    return state.langButton_gonz;
  },
  lang_gonz: function lang_gonz(state) {
    return state.lang_gonz;
  },
  country_gonz: function country_gonz(state) {
    return state.country_gonz;
  },
  host_gonz: function host_gonz(state) {
    return state.host_gonz;
  },
  renew_date_gonz: function renew_date_gonz(state) {
    return state.renew_date_gonz;
  },
  subscription_date_gonz: function subscription_date_gonz(state) {
    return state.subscription_date_gonz;
  },
  msisdn_gonz: function msisdn_gonz(state) {
    return state.msisdn_gonz;
  },
  country_name_gonz: function country_name_gonz(state) {
    return state.country_name_gonz;
  },
  gateway_gonz: function gateway_gonz(state) {
    return state.gateway_gonz;
  },
  is_unsub_gonz: function is_unsub_gonz(state) {
    return state.is_unsub;
  },
  mondia_res_sub: function mondia_res_sub(state) {
    return state.mondia_res_sub;
  }
  // number_of_week: state => state.number_of_week
};

var actions = {
  fetchLanguage_gonz: function fetchLanguage_gonz(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchLanguageButton_gonz: function fetchLanguageButton_gonz(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchHotPicks_gonz: function fetchHotPicks_gonz(_ref7, file) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context3.sent;
              _context3.next = 13;
              break;

            case 10:
              _context3.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context3.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPopular_gonz: function fetchPopular_gonz(_ref8, e) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var limit, url, response, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=" + limit + "&offset=0&domain=" + host;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 5:
              response = _context4.sent;
              data = response.data.data;


              data.sort(function (a, b) {
                //to sort random
                return b.rating - a.rating;
              });
              commit("setPagePopular", data);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDomain_gonz: function getDomain_gonz(_ref9, host) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context5.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }

              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchTokenID_gonz: function fetchTokenID_gonz(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userTokenID_gonz");
              userProfile = localStorage.getItem("userProfile_gonz");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkTokenID_gonz", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 19;
                break;
              }

              localStorage.setItem("userTokenID_gonz", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 24;
              break;

            case 19:
              _context6.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userTokenID_gonz", data.code);
                localStorage.setItem("userProfile_gonz", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");

                __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context6.next = 27;
              break;

            case 26:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  checkTokenID_gonz: function checkTokenID_gonz(_ref11, auth) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return", true);

            case 5:
              return _context7.abrupt("return", false);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  subscribeContent_gonz: function subscribeContent_gonz(_ref12, file) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              token = localStorage.getItem("userTokenID_gonz");
              lang = localStorage.getItem("lang_gonz");
              alert_pop = "";
              alert_lang = __webpack_require__(217)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != "application/x-zip-compressed") {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_gonz,
                    product: 'gameonz',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_gonz,
                    product: 'gameonz',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  login_gonz: function login_gonz(_ref13, loginAuth) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  fetchNotification_gonz: function fetchNotification_gonz(_ref14) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var notify, date, w, url, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=5&offset=" + date + "&domain=" + host;
              _context10.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 7:
              res = _context10.sent;
              data = res.data.data.slice(0, 5);
              noti = data.map(function (noti) {
                var sub_trans = JSON.parse(noti.subcategory_translate);
                // console.log(noti.created_time)
                var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                noti.titleSub_english = noti.subcategory;
                if (sub_trans != null || sub_icon != null) {
                  for (var i = 0; i < trans_len; i++) {
                    noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                  }
                }

                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.cont_name_english.localeCompare(b.cont_name_english);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.cont_name_english.localeCompare(a.cont_name_english);
                });
              }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  logout_gonz: function logout_gonz(_ref15, is_unsub) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var token, lang, _token, responses, response, removeStorage;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_gonz");
                localStorage.removeItem("userTokenID_gonz");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              $("#exampleModalCenter").modal("hide");
              token = localStorage.getItem("userTokenID_gonz");
              lang = localStorage.getItem("lang_gonz");

              if (!(is_unsub != '0')) {
                _context11.next = 13;
                break;
              }

              _token = localStorage.getItem("userTokenID_gonz");
              _context11.next = 8;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_gonz + "/" + state.gateway_gonz + "/unsub.php?code=" + _token + "&msisdn=" + state.msisdn_gonz));

            case 8:
              responses = _context11.sent;
              response = JSON.parse(responses.data.contents);


              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.gateway_gonz == 'mondiamedia') {
                  if (response.url) {
                    window.location.href = response.url;
                  } else {
                    __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                  }
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
                setTimeout(function () {
                  location.reload();
                }, 5000);
              } else if (response.status == 'fail') {
                if (state.gateway_gonz == 'mondiamedia' && state.gcid_gonz == '339') {

                  if (lang == 'arabic') {
                    state.mondia_res_sub = response.ar_error_message;
                  } else {
                    state.mondia_res_sub = response.en_error_message;
                  }
                  __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                setTimeout(function () {
                  location.reload();
                }, 0);
              }
              _context11.next = 15;
              break;

            case 13:
              removeStorage();
              __WEBPACK_IMPORTED_MODULE_8__router_gameonz__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});

            case 15:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }
};

var mutations = {
  setNotification: function setNotification(state, response) {
    return state.notification_gonz = response;
  },
  setAuth: function setAuth(state, response) {
    return state.authentication_gonz = response;
  },
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.HotPicksPage_gonz = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.PopularPage_gonz = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_gonz = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_gonz = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_gonz = response.next_renew_date, state.subscription_date_gonz = response.subscription_date, state.msisdn_gonz = response.msisdn, state.country_name_gonz = response.country_code, state.gateway_gonz = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_gonz = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA2MTEuOTk5IDYxMS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMS45OTkgNjExLjk5OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCIgY2xhc3M9IiI+PGc+PGc+DQoJPHBhdGggZD0iTTIxNi4wMiw2MTEuMTk1YzUuOTc4LDMuMTc4LDEyLjI4NC0zLjcwNCw4LjYyNC05LjRjLTE5Ljg2Ni0zMC45MTktMzguNjc4LTgyLjk0Ny04LjcwNi0xNDkuOTUyICAgYzQ5Ljk4Mi0xMTEuNzM3LDgwLjM5Ni0xNjkuNjA5LDgwLjM5Ni0xNjkuNjA5czE2LjE3Nyw2Ny41MzYsNjAuMDI5LDEyNy41ODVjNDIuMjA1LDU3Ljc5Myw2NS4zMDYsMTMwLjQ3OCwyOC4wNjQsMTkxLjAyOSAgIGMtMy40OTUsNS42ODMsMi42NjgsMTIuMzg4LDguNjA3LDkuMzQ5YzQ2LjEtMjMuNTgyLDk3LjgwNi03MC44ODUsMTAzLjY0LTE2NS4wMTdjMi4xNTEtMjguNzY0LTEuMDc1LTY5LjAzNC0xNy4yMDYtMTE5Ljg1MSAgIGMtMjAuNzQxLTY0LjQwNi00Ni4yMzktOTQuNDU5LTYwLjk5Mi0xMDcuMzY1Yy00LjQxMy0zLjg2MS0xMS4yNzYtMC40MzktMTAuOTE0LDUuNDEzYzQuMjk5LDY5LjQ5NC0yMS44NDUsODcuMTI5LTM2LjcyNiw0Ny4zODYgICBjLTUuOTQzLTE1Ljg3NC05LjQwOS00My4zMy05LjQwOS03Ni43NjZjMC01NS42NjUtMTYuMTUtMTEyLjk2Ny01MS43NTUtMTU5LjUzMWMtOS4yNTktMTIuMTA5LTIwLjA5My0yMy40MjQtMzIuNTIzLTMzLjA3MyAgIGMtNC41LTMuNDk0LTExLjAyMywwLjAxOC0xMC42MTEsNS43YzIuNzM0LDM3LjczNiwwLjI1NywxNDUuODg1LTk0LjYyNCwyNzUuMDg5Yy04Ni4wMjksMTE5Ljg1MS01Mi42OTMsMjExLjg5Ni00MC44NjQsMjM2LjgyNiAgIEMxNTMuNjY2LDU2Ni43NjcsMTg1LjIxMiw1OTQuODE0LDIxNi4wMiw2MTEuMTk1eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0ZDQUMwMSIvPg0KPC9nPjwvZz4gPC9zdmc+DQo="

/***/ }),
/* 2495 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_funplus__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();
var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_fplus");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el' || parts[0] == 'gr') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}
//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_fplus: {},
  //auth
  auth_fplus: "",
  //hotpicks.vue
  pageHP_fplus: {},
  //popular.vue
  pagePop_fplus: {},
  //notification.vue
  notification_fplus: {},
  //icon
  hotpickIcon_fplus: __webpack_require__(2497),
  popularIcon_fplus: __webpack_require__(2498),
  langButton_fplus: "",
  country_fplus: parts[0],
  host_fplus: host,
  lang_fplus: localStorage.getItem("lang_fplus"),
  // lang_fplus: brwlang,
  type: "browse",
  gcid_fplus: gcid,
  hpisLoad_fplus: false,
  renew_date_fplus: '',
  subscription_date_fplus: '',
  msisdn_fplus: '',
  country_name_fplus: '',
  gateway_fplus: '',
  is_unsub: '0'
};

var getters = {
  langButton_fplus: function langButton_fplus(state) {
    return state.langButton_fplus;
  },
  lang_fplus: function lang_fplus(state) {
    return state.lang_fplus;
  },
  gcid_fplus: function gcid_fplus(state) {
    return state.gcid_fplus;
  },
  host_fplus: function host_fplus(state) {
    return state.host_fplus;
  },
  country_fplus: function country_fplus(state) {
    return state.country_fplus;
  },
  allSubcategory_fplus: function allSubcategory_fplus(state) {
    return state.allsubcategory_fplus;
  },
  allHotPicksCategory_fplus: function allHotPicksCategory_fplus(state) {
    return state.hotpicksCategory_fplus;
  },
  allHotPicksData_fplus: function allHotPicksData_fplus(state) {
    return state.hotpicksData_fplus;
  },
  pageHotPicks_fplus: function pageHotPicks_fplus(state) {
    return state.pageHP_fplus;
  },
  pagePopular_fplus: function pagePopular_fplus(state) {
    return state.pagePop_fplus;
  },
  HotPickIcon_fplus: function HotPickIcon_fplus(state) {
    return state.hotpickIcon_fplus;
  },
  PopularIcon_fplus: function PopularIcon_fplus(state) {
    return state.popularIcon_fplus;
  },
  notification_fplus: function notification_fplus(state) {
    return state.notification_fplus;
  },
  auth_fplus: function auth_fplus(state) {
    return state.auth_fplus;
  },
  hpisLoad_fplus: function hpisLoad_fplus(state) {
    return state.hpisLoad_fplus;
  },
  renew_date_fplus: function renew_date_fplus(state) {
    return state.renew_date_fplus;
  },
  subscription_date_fplus: function subscription_date_fplus(state) {
    return state.subscription_date_fplus;
  },
  msisdn_fplus: function msisdn_fplus(state) {
    return state.msisdn_fplus;
  },
  country_name_fplus: function country_name_fplus(state) {
    return state.country_name_fplus;
  },
  gateway_fplus: function gateway_fplus(state) {
    return state.gateway_fplus;
  },
  is_unsub_fplus: function is_unsub_fplus(state) {
    return state.is_unsub;
  }
};

var actions = {
  fetchLocale_fplus: function fetchLocale_fplus(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchTranslateButton_fplus: function fetchTranslateButton_fplus(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_fplus: function fetchAllSubcategory_fplus(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPageHotPicks_fplus: function fetchPageHotPicks_fplus(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              // console.log(response.data.data);

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPagePopular_fplus: function fetchPagePopular_fplus(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 4:
              response = _context5.sent;


              response.data.data.sort(function (a, b) {
                return (
                  // a.content_name.localeCompare(b.content_name),
                  b.rating - a.rating
                );
              });

              commit("setPagePopular", response.data.data);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchToken_fplus: function fetchToken_fplus(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_fplus");
              userProfile = localStorage.getItem("userProfile_fplus");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_fplus", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 30;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 17;
                break;
              }

              if (data.code == 'fplus80') {
                localStorage.setItem("userToken_fplus", data.code);
                commit("setAuth", "guest");
              } else {
                localStorage.setItem("userToken_fplus", data.code);
                commit("setUserProfile", JSON.parse(userProfile));
                commit("setAuth", "loggedin");
              }
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 28;
              break;

            case 17:
              if (!(data.code == 'fplus80')) {
                _context6.next = 23;
                break;
              }

              localStorage.setItem("userToken_fplus", data.code);
              commit("setAuth", "guest");
              __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ path: path }).catch(function (err) {});
              _context6.next = 28;
              break;

            case 23:
              _context6.next = 25;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 25:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);


              if (response.status == "active") {
                localStorage.setItem("userToken_fplus", data.code);
                localStorage.setItem("userProfile_fplus", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ path: path }).catch(function (err) {});
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 28:
              _context6.next = 31;
              break;

            case 30:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 31:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getDomain_fplus: function getDomain_fplus(_ref11, host) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context7.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {

                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }
              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkToken_fplus: function checkToken_fplus(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subContent_fplus: function subContent_fplus(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userToken_fplus");
              lang = localStorage.getItem("lang_fplus");
              alert_pop = "";
              alert_lang = __webpack_require__(158)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (state.auth_fplus == 'guest') {
                commit("setAuth", "");
                localStorage.removeItem("userToken_fplus");
                __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              } else {
                if (token != null) {
                  if (file[1] != "application/x-zip-compressed") {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                      token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                      country: state.country_fplus,
                      product: 'funplus',
                      content_id: file[2],
                      type: "download"
                    });
                    window.location.href = file[0];
                    // window.open(file[0], "_blank");
                  } else {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                      token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                      country: state.country_fplus,
                      product: 'funplus',
                      content_id: file[2],
                      type: "play"
                    });

                    window.open(file[0], "_blank");
                  }
                } else {
                  alert(alert_pop);
                  setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                  }, 1000);
                }
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  login_fplus: function login_fplus(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchNotification_fplus: function fetchNotification_fplus(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, date, w, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              _context11.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=" + host);

            case 6:
              res = _context11.sent;
              data = res.data.data;
              noti = data.map(function (noti) {
                noti.titleSub_english = noti.subcategory;
                if (noti.subcategory_translate != null) {
                  var sub_trans = JSON.parse(noti.subcategory_translate);
                  if (sub_trans != null) {
                    var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                    if (sub_trans != null || sub_icon != null) {
                      for (var i = 0; i < trans_len; i++) {
                        noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                      }
                    }
                  }
                }
                return noti;
              });

              // if(w == 0){
              //   //name ascending
              //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
              // }else{
              //   //name descending
              //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
              // }

              // notify = noti.slice(0,5);

              commit("setNotification", noti);

            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_fplus: function logout_fplus(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_fplus");
                localStorage.removeItem("userToken_fplus");
                localStorage.removeItem("logged-in");
              };

              $("#exampleModalCenter").modal("hide");

              if (!(is_unsub != '0')) {
                _context12.next = 12;
                break;
              }

              token = localStorage.getItem("userToken_fplus");
              _context12.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_fplus + "/" + state.gateway_fplus + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_fplus));

            case 6:
              responses = _context12.sent;

              removeStorage();
              response = JSON.parse(responses.data.contents);

              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.gcid_fplus == '208' || state.gcid_fplus == '225' || state.gcid_fplus == '226' || state.gcid_fplus == '278') {
                  __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_funplus__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              } else {
                setTimeout(function () {
                  location.reload();
                }, 0);
              }

              _context12.next = 13;
              break;

            case 12:
              removeStorage();

            case 13:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

var mutations = {
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_fplus = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_fplus = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_fplus = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_fplus = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_fplus = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_fplus = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_fplus = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_fplus = response.next_renew_date, state.subscription_date_fplus = response.subscription_date, state.msisdn_fplus = response.msisdn, state.country_name_fplus = response.country_code, state.gateway_fplus = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_fplus = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA2MTEuOTk5IDYxMS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMS45OTkgNjExLjk5OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCIgY2xhc3M9IiI+PGc+PGc+DQoJPHBhdGggZD0iTTIxNi4wMiw2MTEuMTk1YzUuOTc4LDMuMTc4LDEyLjI4NC0zLjcwNCw4LjYyNC05LjRjLTE5Ljg2Ni0zMC45MTktMzguNjc4LTgyLjk0Ny04LjcwNi0xNDkuOTUyICAgYzQ5Ljk4Mi0xMTEuNzM3LDgwLjM5Ni0xNjkuNjA5LDgwLjM5Ni0xNjkuNjA5czE2LjE3Nyw2Ny41MzYsNjAuMDI5LDEyNy41ODVjNDIuMjA1LDU3Ljc5Myw2NS4zMDYsMTMwLjQ3OCwyOC4wNjQsMTkxLjAyOSAgIGMtMy40OTUsNS42ODMsMi42NjgsMTIuMzg4LDguNjA3LDkuMzQ5YzQ2LjEtMjMuNTgyLDk3LjgwNi03MC44ODUsMTAzLjY0LTE2NS4wMTdjMi4xNTEtMjguNzY0LTEuMDc1LTY5LjAzNC0xNy4yMDYtMTE5Ljg1MSAgIGMtMjAuNzQxLTY0LjQwNi00Ni4yMzktOTQuNDU5LTYwLjk5Mi0xMDcuMzY1Yy00LjQxMy0zLjg2MS0xMS4yNzYtMC40MzktMTAuOTE0LDUuNDEzYzQuMjk5LDY5LjQ5NC0yMS44NDUsODcuMTI5LTM2LjcyNiw0Ny4zODYgICBjLTUuOTQzLTE1Ljg3NC05LjQwOS00My4zMy05LjQwOS03Ni43NjZjMC01NS42NjUtMTYuMTUtMTEyLjk2Ny01MS43NTUtMTU5LjUzMWMtOS4yNTktMTIuMTA5LTIwLjA5My0yMy40MjQtMzIuNTIzLTMzLjA3MyAgIGMtNC41LTMuNDk0LTExLjAyMywwLjAxOC0xMC42MTEsNS43YzIuNzM0LDM3LjczNiwwLjI1NywxNDUuODg1LTk0LjYyNCwyNzUuMDg5Yy04Ni4wMjksMTE5Ljg1MS01Mi42OTMsMjExLjg5Ni00MC44NjQsMjM2LjgyNiAgIEMxNTMuNjY2LDU2Ni43NjcsMTg1LjIxMiw1OTQuODE0LDIxNi4wMiw2MTEuMTk1eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iIzc0MzFEMyIvPg0KPC9nPjwvZz4gPC9zdmc+DQo="

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_gamebox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);












var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();
var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_gamebox");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

var namespaced = true;
var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_gamebox: {},
  //auth
  auth_gamebox: "",
  //main.vue
  hotpicksCategory_gamebox: {},
  hotpicksData_gamebox: {},
  popular_gamebox: {},
  //hotpicks.vue
  pageHP_gamebox: {},
  //popular.vue
  pagePop_gamebox: {},
  //notification.vue
  notification_gamebox: {},
  main_cover_gamebox: {},
  //icon
  hotpickIcon_gamebox: __webpack_require__(2500),
  popularIcon_gamebox: __webpack_require__(2501),
  langButton_gamebox: "",
  country_gamebox: parts[0],
  host_gamebox: host,
  // lang_gamebox: localStorage.getItem("lang_gamebox"),
  lang_gamebox: brwlang,
  type: "browse",
  gcid_gamebox: gcid,
  hpisLoad_gamebox: false,
  renew_date_gamebox: "",
  subscription_date_gamebox: "",
  msisdn_gamebox: "",
  country_name_gamebox: "",
  gateway_gamebox: "",
  is_unsub: "0"
};

var getters = {
  langButton_gamebox: function langButton_gamebox(state) {
    return state.langButton_gamebox;
  },
  lang_gamebox: function lang_gamebox(state) {
    return state.lang_gamebox;
  },
  gcid_gamebox: function gcid_gamebox(state) {
    return state.gcid_gamebox;
  },
  country_gamebox: function country_gamebox(state) {
    return state.country_gamebox;
  },
  pageHotPicks_gamebox: function pageHotPicks_gamebox(state) {
    return state.pageHP_gamebox;
  },
  pagePopular_gamebox: function pagePopular_gamebox(state) {
    return state.pagePop_gamebox;
  },
  HotPickIcon_gamebox: function HotPickIcon_gamebox(state) {
    return state.hotpickIcon_gamebox;
  },
  PopularIcon_gamebox: function PopularIcon_gamebox(state) {
    return state.popularIcon_gamebox;
  },
  notification_gamebox: function notification_gamebox(state) {
    return state.notification_gamebox;
  },
  main_cover_gamebox: function main_cover_gamebox(state) {
    return state.main_cover_gamebox;
  },
  host_gamebox: function host_gamebox(state) {
    return state.host_gamebox;
  },
  auth_gamebox: function auth_gamebox(state) {
    return state.auth_gamebox;
  },
  hpisLoad_gamebox: function hpisLoad_gamebox(state) {
    return state.hpisLoad_gamebox;
  },
  renew_date_gamebox: function renew_date_gamebox(state) {
    return state.renew_date_gamebox;
  },
  subscription_date_gamebox: function subscription_date_gamebox(state) {
    return state.subscription_date_gamebox;
  },
  msisdn_gamebox: function msisdn_gamebox(state) {
    return state.msisdn_gamebox;
  },
  country_name_gamebox: function country_name_gamebox(state) {
    return state.country_name_gamebox;
  },
  gateway_gamebox: function gateway_gamebox(state) {
    return state.gateway_gamebox;
  },
  is_unsub_gamebox: function is_unsub_gamebox(state) {
    return state.is_unsub;
  }
};

var actions = {
  fetchLocale_gamebox: function fetchLocale_gamebox(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchTranslateButton_gamebox: function fetchTranslateButton_gamebox(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<span lang=\"" + value.language + "\" >\n        <img class=\"flag\" lang=\"" + value.language + "\" src=\"" + value.flag_squareCurved + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </span>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_gamebox: function fetchAllSubcategory_gamebox(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPageHotPicks_gamebox: function fetchPageHotPicks_gamebox(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPagePopular_gamebox: function fetchPagePopular_gamebox(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, url, response, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              url = state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host;
              _context5.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 5:
              response = _context5.sent;
              data = response.data.data;


              data.sort(function (a, b) {
                //to sort random
                return b.rating - a.rating;
              });
              commit("setPagePopular", data);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getDomain_gamebox: function getDomain_gamebox(_ref10, host) {
    var _this6 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context6.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != "0") commit("setGatewayID", dom[0].gateway_id);
              } else {
                domain = "0";
              }

              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  fetchToken_gamebox: function fetchToken_gamebox(_ref11, id) {
    var _this7 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_gamebox");
              userProfile = localStorage.getItem("userProfile_gamebox");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join("/");

              if (path == "") {
                path = "/home";
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_gamebox", auth);
                // console.log(check)
                auth = auth.toLowerCase();
                letterNumber = "^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$";

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                if (path != '/detail') {
                  __WEBPACK_IMPORTED_MODULE_8__router_gamebox__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }
              }

              if (!(check == true)) {
                _context7.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context7.next = 19;
                break;
              }

              localStorage.setItem("userToken_gamebox", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context7.next = 24;
              break;

            case 19:
              _context7.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context7.sent;
              response = JSON.parse(responses.data.contents);


              if (response.status == "active") {
                localStorage.setItem("userToken_gamebox", data.code);
                localStorage.setItem("userProfile_gamebox", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");

                __WEBPACK_IMPORTED_MODULE_8__router_gamebox__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_gamebox__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context7.next = 27;
              break;

            case 26:
              //if check is false
              if (path != '/detail') {
                __WEBPACK_IMPORTED_MODULE_8__router_gamebox__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 27:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkToken_gamebox: function checkToken_gamebox(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subContent_gamebox: function subContent_gamebox(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userToken_gamebox");
              lang = localStorage.getItem("lang_gamebox");
              alert_pop = "";
              alert_lang = __webpack_require__(124)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != "application/x-zip-compressed") {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_gamebox,
                    product: 'gamebox',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_gamebox,
                    product: 'gamebox',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#contentModal").modal("hide");
                  __WEBPACK_IMPORTED_MODULE_8__router_gamebox__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  login_gamebox: function login_gamebox(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchNotification_gamebox: function fetchNotification_gamebox(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, main_cover, date, w, url, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              main_cover = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=10&offset=" + date + "&domain=" + host;
              _context11.next = 8;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 8:
              res = _context11.sent;
              data = res.data.data.slice(0, 10);
              noti = data.map(function (noti) {
                var sub_trans = JSON.parse(noti.subcategory_translate);
                // console.log(noti.created_time)
                var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                noti.titleSub_english = noti.subcategory;
                if (sub_trans != null || sub_icon != null) {
                  for (var i = 0; i < trans_len; i++) {
                    noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                  }
                }

                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.cont_name_english.localeCompare(b.cont_name_english);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.cont_name_english.localeCompare(a.cont_name_english);
                });
              }
              notify = noti.slice(0, 5);
              // main_cover = noti.slice(0, 5);
              noti.length > 5 ? main_cover = noti.slice(6, 9) : main_cover = noti.slice(0, 5);

              commit("setNotification", { notify: notify, main_cover: main_cover });

            case 15:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_gamebox: function logout_gamebox(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_gamebox");
                localStorage.removeItem("userToken_gamebox");
                localStorage.removeItem("logged-in");
              };

              if (!(is_unsub != "0")) {
                _context12.next = 13;
                break;
              }

              token = localStorage.getItem("userToken_gamebox");
              _context12.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_gamebox + "/" + state.gateway_gamebox + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_gamebox));

            case 5:
              responses = _context12.sent;

              removeStorage();
              console.log(response);
              response = JSON.parse(responses.data.contents);

              if (responses.data.contents == 'success' || response.status == 'success') {
                location.reload();
              }
              setTimeout(function () {
                location.reload();
              }, 0);
              _context12.next = 14;
              break;

            case 13:
              removeStorage();

            case 14:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

var mutations = {
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_gamebox = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_gamebox = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_gamebox = response.notify, state.main_cover_gamebox = response.main_cover;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_gamebox = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_gamebox = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_gamebox = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_gamebox = response.next_renew_date, state.subscription_date_gamebox = response.subscription_date, state.msisdn_gamebox = response.msisdn, state.country_name_gamebox = response.country_code, state.gateway_gamebox = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_gamebox = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // namespaced,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTY5LjQsNDc5LjRjNC43LDIuNSw5LjYtMi45LDYuOC03LjRjLTE1LjYtMjQuMy0zMC4zLTY1LjEtNi44LTExNy42YzM5LjItODcuNiw2My4xLTEzMyw2My4xLTEzMw0KCQkJczEyLjcsNTMsNDcuMSwxMDAuMWMzMy4xLDQ1LjMsNTEuMiwxMDIuMywyMiwxNDkuOGMtMi43LDQuNSwyLjEsOS43LDYuOCw3LjNjMzYuMi0xOC41LDc2LjctNTUuNiw4MS4zLTEyOS40DQoJCQljMS43LTIyLjYtMC44LTU0LjEtMTMuNS05NGMtMTYuMy01MC41LTM2LjMtNzQuMS00Ny44LTg0LjJjLTMuNS0zLTguOC0wLjMtOC42LDQuMmMzLjQsNTQuNS0xNy4xLDY4LjMtMjguOCwzNy4yDQoJCQljLTQuNy0xMi41LTcuNC0zNC03LjQtNjAuMmMwLTQzLjctMTIuNy04OC42LTQwLjYtMTI1LjFjLTcuMy05LjUtMTUuOC0xOC40LTI1LjUtMjUuOWMtMy41LTIuNy04LjYsMC04LjMsNC41DQoJCQljMi4xLDI5LjYsMC4yLDExNC40LTc0LjIsMjE1LjhjLTY3LjUsOTQtNDEuMywxNjYuMi0zMi4xLDE4NS43QzEyMC41LDQ0NC41LDE0NS4zLDQ2Ni41LDE2OS40LDQ3OS40eiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_prizeo__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);












var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_prizeo");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_prizeo: {},
  //auth
  auth_prizeo: "",
  //hotpicks.vue
  pageHP_prizeo: {},
  //popular.vue
  pagePop_prizeo: {},
  //notification.vue
  notification_prizeo: {},
  //icon
  hotpickIcon_prizeo: __webpack_require__(2503),
  popularIcon_prizeo: __webpack_require__(2504),
  langButton_prizeo: "",
  country_prizeo: parts[0],
  host_prizeo: host,
  // lang_prizeo: localStorage.getItem("lang_prizeo"),
  lang_prizeo: brwlang,
  type: 'browse',
  gcid_prizeo: gcid,
  hpisLoad_prizeo: false,
  renew_date_prizeo: '',
  subscription_date_prizeo: '',
  msisdn_prizeo: '',
  country_name_prizeo: '',
  gateway_prizeo: '',
  is_unsub: '0'
};

var getters = {
  langButton_prizeo: function langButton_prizeo(state) {
    return state.langButton_prizeo;
  },
  lang_prizeo: function lang_prizeo(state) {
    return state.lang_prizeo;
  },
  gcid_prizeo: function gcid_prizeo(state) {
    return state.gcid_prizeo;
  },
  country_prizeo: function country_prizeo(state) {
    return state.country_prizeo;
  },
  allSubcategory_prizeo: function allSubcategory_prizeo(state) {
    return state.allsubcategory_prizeo;
  },
  pageHotPicks_prizeo: function pageHotPicks_prizeo(state) {
    return state.pageHP_prizeo;
  },
  pagePopular_prizeo: function pagePopular_prizeo(state) {
    return state.pagePop_prizeo;
  },
  HotPickIcon_prizeo: function HotPickIcon_prizeo(state) {
    return state.hotpickIcon_prizeo;
  },
  PopularIcon_prizeo: function PopularIcon_prizeo(state) {
    return state.popularIcon_prizeo;
  },
  notification_prizeo: function notification_prizeo(state) {
    return state.notification_prizeo;
  },
  host_prizeo: function host_prizeo(state) {
    return state.host_prizeo;
  },
  auth_prizeo: function auth_prizeo(state) {
    return state.auth_prizeo;
  },
  hpisLoad_prizeo: function hpisLoad_prizeo(state) {
    return state.hpisLoad_prizeo;
  },
  renew_date_prizeo: function renew_date_prizeo(state) {
    return state.renew_date_prizeo;
  },
  subscription_date_prizeo: function subscription_date_prizeo(state) {
    return state.subscription_date_prizeo;
  },
  msisdn_prizeo: function msisdn_prizeo(state) {
    return state.msisdn_prizeo;
  },
  country_name_prizeo: function country_name_prizeo(state) {
    return state.country_name_prizeo;
  },
  gateway_prizeo: function gateway_prizeo(state) {
    return state.gateway_prizeo;
  },
  is_unsub_prizeo: function is_unsub_prizeo(state) {
    return state.is_unsub;
  }
};

var actions = {
  fetchLocale_prizeo: function fetchLocale_prizeo(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchTranslateButton_prizeo: function fetchTranslateButton_prizeo(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_prizeo: function fetchAllSubcategory_prizeo(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchHotPicks_prizeo: function fetchHotPicks_prizeo(_ref8) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var w, browseCat, browseCategory, allDataContent, allData, allcontent, browse, isload;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // let month = currentDate.getUTCMonth();
              w = week % 2;
              browseCat = [];
              browseCategory = [];
              allDataContent = [];
              allData = [];
              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=&limit=400&offset=0&domain=" + host);

            case 7:
              allcontent = _context4.sent;


              if (w == 0) {
                allcontent.data.data.sort(function (a, b) {
                  return a.content_name.localeCompare(b.content_name);
                });
              } else {
                allcontent.data.data.sort(function (a, b) {
                  return b.content_name.localeCompare(a.content_name);
                });
              }

              _context4.next = 11;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=" + host);

            case 11:
              browse = _context4.sent;


              allDataContent = allcontent.data.data;
              browseCat = browse.data.data;

              isload = '';

              browseCat.map(function (item) {
                var trans = JSON.parse(item.category_translate);
                if (trans != null) {
                  var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans).length;
                  var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trans);
                  for (var i = 0; i < trans_len; i++) {
                    item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
                  }
                }
                browseCategory.push(item);

                var count = 0;
                var category = item.category;
                allData[category] = new Array();
                allDataContent.map(function (item2) {
                  if (item2.category == item.category) {
                    if (count < 6) {
                      allData[category].push(item2);
                      count++;
                    }
                    isload = true;
                  }
                });
              });

              commit("setHotPicks", { browseCategory: browseCategory, allData: allData, isload: isload });

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPopular_prizeo: function fetchPopular_prizeo(_ref9) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=&limit=10&offset=10&domain=" + host);

            case 2:
              response = _context5.sent;


              response.data.data.sort(function (a, b) {
                //to sort random
                return 0.5 - Math.random();
              });

              commit("setPopular", response.data.data);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchPageHotPicks_prizeo: function fetchPageHotPicks_prizeo(_ref10, file) {
    var _this6 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context6.next = 10;
                break;
              }

              _context6.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context6.sent;
              _context6.next = 13;
              break;

            case 10:
              _context6.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context6.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              // console.log(response.data.data);

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  fetchPagePopular_prizeo: function fetchPagePopular_prizeo(_ref11, e) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 4:
              response = _context7.sent;


              response.data.data.sort(function (a, b) {
                return (
                  // a.content_name.localeCompare(b.content_name),
                  b.rating - a.rating
                );
              });

              commit("setPagePopular", response.data.data);

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  fetchToken_prizeo: function fetchToken_prizeo(_ref12, id) {
    var _this8 = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_prizeo");
              userProfile = localStorage.getItem("userProfile_prizeo");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_prizeo", auth);
                // console.log(check)
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context8.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context8.next = 19;
                break;
              }

              localStorage.setItem("userToken_prizeo", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context8.next = 24;
              break;

            case 19:
              _context8.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context8.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userToken_prizeo", data.code);
                localStorage.setItem("userProfile_prizeo", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context8.next = 27;
              break;

            case 26:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 27:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getDomain_prizeo: function getDomain_prizeo(_ref13, host) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context9.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }
              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  checkToken_prizeo: function checkToken_prizeo(_ref14, auth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;

              if (!auth.match(letterNumber)) {
                _context10.next = 5;
                break;
              }

              return _context10.abrupt("return", true);

            case 5:
              return _context10.abrupt("return", false);

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  subContent_prizeo: function subContent_prizeo(_ref15, file) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              token = localStorage.getItem("userToken_prizeo");
              lang = localStorage.getItem("lang_prizeo");
              alert_pop = "";
              alert_lang = __webpack_require__(160)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != 'application/x-zip-compressed') {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_prizeo,
                    product: 'prizeo',
                    content_id: file[2],
                    type: "download"
                  });

                  window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_prizeo,
                    product: 'prizeo',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  login_prizeo: function login_prizeo(_ref16, loginAuth) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  fetchNotification_prizeo: function fetchNotification_prizeo(_ref17) {
    var _this13 = this;

    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var notify, date, w, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              _context13.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=" + host);

            case 6:
              res = _context13.sent;
              data = res.data.data;
              noti = data.map(function (noti) {
                noti.titleSub_english = noti.subcategory;
                if (noti.subcategory_translate != null) {
                  var sub_trans = JSON.parse(noti.subcategory_translate);
                  if (sub_trans != null) {
                    var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                    if (sub_trans != null || sub_icon != null) {
                      for (var i = 0; i < trans_len; i++) {
                        noti['titleSub_' + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                      }
                    }
                  }
                }
                return noti;
              });

              // if(w == 0){
              //   //name ascending
              //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
              // }else{
              //   //name descending
              //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
              // }

              // notify = noti.slice(0,5);

              commit("setNotification", noti);

            case 10:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  logout_prizeo: function logout_prizeo(_ref18, is_unsub) {
    var _this14 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_prizeo");
                localStorage.removeItem("userToken_prizeo");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              if (!(is_unsub != '0')) {
                _context14.next = 12;
                break;
              }

              token = localStorage.getItem("userToken_prizeo");
              _context14.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_prizeo + "/" + state.gateway_prizeo + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_prizeo));

            case 5:
              responses = _context14.sent;

              removeStorage();
              __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
              response = JSON.parse(responses.data.contents);

              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.country_prizeo == 'iq' || state.gcid_prizeo == '289' || state.gcid_prizeo == '290' || state.gcid_prizeo == '291' || state.gcid_prizeo == '308') {
                  __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              }
              _context14.next = 14;
              break;

            case 12:
              removeStorage();
              if (state.country_prizeo == 'iq' || state.gcid_prizeo == '289' || state.gcid_prizeo == '290' || state.gcid_prizeo == '291') {
                __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
                __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_prizeo__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
              }

            case 14:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  }
};

var mutations = {
  setHotPicks: function setHotPicks(state, response) {
    return state.hotpicksCategory_prizeo = response.browseCategory, state.hotpicksData_prizeo = response.allData, state.hpisLoad_prizeo = response.isload;
  },
  setPopular: function setPopular(state, response) {
    return state.popular_prizeo = response;
  },
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_prizeo = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_prizeo = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_prizeo = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_prizeo = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_prizeo = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_prizeo = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_prizeo = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_prizeo = response.next_renew_date, state.subscription_date_prizeo = response.subscription_date, state.msisdn_prizeo = response.msisdn, state.country_name_prizeo = response.country_code, state.gateway_prizeo = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_prizeo = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTY5LjQsNDc5LjRjNC43LDIuNSw5LjYtMi45LDYuOC03LjRjLTE1LjYtMjQuMy0zMC4zLTY1LjEtNi44LTExNy42YzM5LjItODcuNiw2My4xLTEzMyw2My4xLTEzMw0KCQkJczEyLjcsNTMsNDcuMSwxMDAuMWMzMy4xLDQ1LjMsNTEuMiwxMDIuMywyMiwxNDkuOGMtMi43LDQuNSwyLjEsOS43LDYuOCw3LjNjMzYuMi0xOC41LDc2LjctNTUuNiw4MS4zLTEyOS40DQoJCQljMS43LTIyLjYtMC44LTU0LjEtMTMuNS05NGMtMTYuMy01MC41LTM2LjMtNzQuMS00Ny44LTg0LjJjLTMuNS0zLTguOC0wLjMtOC42LDQuMmMzLjQsNTQuNS0xNy4xLDY4LjMtMjguOCwzNy4yDQoJCQljLTQuNy0xMi41LTcuNC0zNC03LjQtNjAuMmMwLTQzLjctMTIuNy04OC42LTQwLjYtMTI1LjFjLTcuMy05LjUtMTUuOC0xOC40LTI1LjUtMjUuOWMtMy41LTIuNy04LjYsMC04LjMsNC41DQoJCQljMi4xLDI5LjYsMC4yLDExNC40LTc0LjIsMjE1LjhjLTY3LjUsOTQtNDEuMywxNjYuMi0zMi4xLDE4NS43QzEyMC41LDQ0NC41LDE0NS4zLDQ2Ni41LDE2OS40LDQ3OS40eiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_fun2win__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

var state = {
  //auth
  langButton_f2w: "",
  country_f2w: parts[0],
  lang_f2w: localStorage.getItem("lang_f2w"),
  authentication_f2w: "",
  IconHotpick_f2w: __webpack_require__(2506),
  IconPopular_f2w: __webpack_require__(2507),
  //notification.vue
  notification_f2w: {},
  HotPicksPage_f2w: {},
  PopularPage_f2w: {},
  host_f2w: host,
  gcid_f2w: gcid
  // number_of_week: week
};

var getters = {
  gcid_f2w: function gcid_f2w(state) {
    return state.gcid_f2w;
  },
  IconHotPick_f2w: function IconHotPick_f2w(state) {
    return state.IconHotpick_f2w;
  },
  IconPopular_f2w: function IconPopular_f2w(state) {
    return state.IconPopular_f2w;
  },
  notification_f2w: function notification_f2w(state) {
    return state.notification_f2w;
  },
  authentication_f2w: function authentication_f2w(state) {
    return state.authentication_f2w;
  },
  HotPicksPage_f2w: function HotPicksPage_f2w(state) {
    return state.HotPicksPage_f2w;
  },
  PopularPage_f2w: function PopularPage_f2w(state) {
    return state.PopularPage_f2w;
  },
  langButton_f2w: function langButton_f2w(state) {
    return state.langButton_f2w;
  },
  lang_f2w: function lang_f2w(state) {
    return state.lang_f2w;
  },
  country_f2w: function country_f2w(state) {
    return state.country_f2w;
  },
  host_f2w: function host_f2w(state) {
    return state.host_f2w;
  }
  // number_of_week: state => state.number_of_week
};

var actions = {
  fetchLanguage_f2w: function fetchLanguage_f2w(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchLanguageButton_f2w: function fetchLanguageButton_f2w(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchHotPicks_f2w: function fetchHotPicks_f2w(_ref7, file) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data, limit, response, live, local;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];
              live = "http://cook.grabmobi.com/";
              local = "http://[::1]/PuretechGlobalContentPortal";

              if (!(data == undefined)) {
                _context3.next = 12;
                break;
              }

              _context3.next = 9;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=" + limit + "&offset=0&domain=" + host);

            case 9:
              response = _context3.sent;
              _context3.next = 15;
              break;

            case 12:
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 14:
              response = _context3.sent;

            case 15:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              commit("setPageHotPicks", response.data.data);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPopular_f2w: function fetchPopular_f2w(_ref8, e) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var limit, live, local, response, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=" + limit + "&offset=0&domain=" + host;
              local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=" + limit + "&offset=0&domain=" + host;
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live);

            case 6:
              response = _context4.sent;
              data = response.data.data;


              data.sort(function (a, b) {
                //to sort random
                return b.rating - a.rating;
              });
              commit("setPagePopular", data);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchTokenID_f2w: function fetchTokenID_f2w(_ref9, id) {
    var _this5 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var auth, check, proxyurl, token, letterNumber, data, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              auth = "";
              check = "";
              proxyurl = "https://cors-anywhere.herokuapp.com/";
              token = localStorage.getItem("userTokenID_f2w");

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkTokenID_f2w", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                // fun2win.push({ name: "Login" }).catch(err => {});
              }

              if (!(check == true)) {
                _context5.next = 19;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context5.next = 13;
                break;
              }

              localStorage.setItem("userTokenID_f2w", data.code);
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context5.next = 17;
              break;

            case 13:
              _context5.next = 15;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(proxyurl + "http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose);

            case 15:
              response = _context5.sent;


              if (response.data.status == "active") {
                localStorage.setItem("userTokenID_f2w", data.code);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_fun2win__["a" /* default */].push({ name: "Home" }).catch(function (err) {});
                // location.reload();
              } else if (response.data.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.data.status.toUpperCase());
                }
                // fun2win.push({ name: "Login" }).catch(err => {});
              }

            case 17:
              _context5.next = 19;
              break;

            case 19:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  checkTokenID_f2w: function checkTokenID_f2w(_ref10, auth) {
    var _this6 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context6.next = 5;
                break;
              }

              return _context6.abrupt("return", true);

            case 5:
              return _context6.abrupt("return", false);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  subscribeContent_f2w: function subscribeContent_f2w(_ref11, file) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              token = localStorage.getItem("userTokenID_f2w");
              lang = localStorage.getItem("lang_f2w");
              alert_pop = "";
              alert_lang = __webpack_require__(218)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != "application/x-zip-compressed") {
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_fun2win__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  login_f2w: function login_f2w(_ref12, loginAuth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  fetchNotification_f2w: function fetchNotification_f2w(_ref13) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var notify, date, w, live, local, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              live = "http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=5&offset=" + date + "&domain=" + host;
              local = "http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=10&offset=0&domain=" + host;
              _context9.next = 8;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(live);

            case 8:
              res = _context9.sent;
              data = res.data.data.slice(0, 5);
              noti = data.map(function (noti) {
                var sub_trans = JSON.parse(noti.subcategory_translate);
                // console.log(noti.created_time)
                var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                noti.titleSub_english = noti.subcategory;
                if (sub_trans != null || sub_icon != null) {
                  for (var i = 0; i < trans_len; i++) {
                    noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                  }
                }

                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.cont_name_english.localeCompare(b.cont_name_english);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.cont_name_english.localeCompare(a.cont_name_english);
                });
              }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  }
};

var mutations = {
  setNotification: function setNotification(state, response) {
    return state.notification_f2w = response;
  },
  setAuth: function setAuth(state, response) {
    return state.authentication_f2w = response;
  },
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.HotPicksPage_f2w = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.PopularPage_f2w = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_f2w = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_f2w = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA2MTEuOTk5IDYxMS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMS45OTkgNjExLjk5OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCIgY2xhc3M9IiI+PGc+PGc+DQoJPHBhdGggZD0iTTIxNi4wMiw2MTEuMTk1YzUuOTc4LDMuMTc4LDEyLjI4NC0zLjcwNCw4LjYyNC05LjRjLTE5Ljg2Ni0zMC45MTktMzguNjc4LTgyLjk0Ny04LjcwNi0xNDkuOTUyICAgYzQ5Ljk4Mi0xMTEuNzM3LDgwLjM5Ni0xNjkuNjA5LDgwLjM5Ni0xNjkuNjA5czE2LjE3Nyw2Ny41MzYsNjAuMDI5LDEyNy41ODVjNDIuMjA1LDU3Ljc5Myw2NS4zMDYsMTMwLjQ3OCwyOC4wNjQsMTkxLjAyOSAgIGMtMy40OTUsNS42ODMsMi42NjgsMTIuMzg4LDguNjA3LDkuMzQ5YzQ2LjEtMjMuNTgyLDk3LjgwNi03MC44ODUsMTAzLjY0LTE2NS4wMTdjMi4xNTEtMjguNzY0LTEuMDc1LTY5LjAzNC0xNy4yMDYtMTE5Ljg1MSAgIGMtMjAuNzQxLTY0LjQwNi00Ni4yMzktOTQuNDU5LTYwLjk5Mi0xMDcuMzY1Yy00LjQxMy0zLjg2MS0xMS4yNzYtMC40MzktMTAuOTE0LDUuNDEzYzQuMjk5LDY5LjQ5NC0yMS44NDUsODcuMTI5LTM2LjcyNiw0Ny4zODYgICBjLTUuOTQzLTE1Ljg3NC05LjQwOS00My4zMy05LjQwOS03Ni43NjZjMC01NS42NjUtMTYuMTUtMTEyLjk2Ny01MS43NTUtMTU5LjUzMWMtOS4yNTktMTIuMTA5LTIwLjA5My0yMy40MjQtMzIuNTIzLTMzLjA3MyAgIGMtNC41LTMuNDk0LTExLjAyMywwLjAxOC0xMC42MTEsNS43YzIuNzM0LDM3LjczNiwwLjI1NywxNDUuODg1LTk0LjYyNCwyNzUuMDg5Yy04Ni4wMjksMTE5Ljg1MS01Mi42OTMsMjExLjg5Ni00MC44NjQsMjM2LjgyNiAgIEMxNTMuNjY2LDU2Ni43NjcsMTg1LjIxMiw1OTQuODE0LDIxNi4wMiw2MTEuMTk1eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0ZDQUMwMSIvPg0KPC9nPjwvZz4gPC9zdmc+DQo="

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);












var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();
var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_cm");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el' || parts[0] == 'gr') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_cm: {},
  //auth
  auth_cm: "",
  //main.vue
  //hotpicks.vue
  pageHP_cm: {},
  //popular.vue
  pagePop_cm: {},
  //notification.vue
  notification_cm: {},
  //icon
  hotpickIcon_cm: __webpack_require__(2509),
  popularIcon_cm: __webpack_require__(2510),
  langButton_cm: "",
  country_cm: parts[0],
  host_cm: host,
  // lang_cm: localStorage.getItem("lang_cm"),
  lang_cm: brwlang,
  type: 'browse',
  gcid_cm: gcid,
  hpisLoad_cm: false,
  renew_date_cm: '',
  subscription_date_cm: '',
  msisdn_cm: '',
  country_code_cm: '',
  gateway_code_cm: '',
  is_unsub: '0'
};

var getters = {
  langButton_cm: function langButton_cm(state) {
    return state.langButton_cm;
  },
  lang_cm: function lang_cm(state) {
    return state.lang_cm;
  },
  gcid_cm: function gcid_cm(state) {
    return state.gcid_cm;
  },
  country_cm: function country_cm(state) {
    return state.country_cm;
  },
  allSubcategory_cm: function allSubcategory_cm(state) {
    return state.allsubcategory_cm;
  },
  pageHotPicks_cm: function pageHotPicks_cm(state) {
    return state.pageHP_cm;
  },
  pagePopular_cm: function pagePopular_cm(state) {
    return state.pagePop_cm;
  },
  HotPickIcon_cm: function HotPickIcon_cm(state) {
    return state.hotpickIcon_cm;
  },
  PopularIcon_cm: function PopularIcon_cm(state) {
    return state.popularIcon_cm;
  },
  notification_cm: function notification_cm(state) {
    return state.notification_cm;
  },
  host_cm: function host_cm(state) {
    return state.host_cm;
  },
  auth_cm: function auth_cm(state) {
    return state.auth_cm;
  },
  hpisLoad_cm: function hpisLoad_cm(state) {
    return state.hpisLoad_cm;
  },
  renew_date_cm: function renew_date_cm(state) {
    return state.renew_date_cm;
  },
  subscription_date_cm: function subscription_date_cm(state) {
    return state.subscription_date_cm;
  },
  msisdn_cm: function msisdn_cm(state) {
    return state.msisdn_cm;
  },
  country_code_cm: function country_code_cm(state) {
    return state.country_code_cm;
  },
  gateway_code_cm: function gateway_code_cm(state) {
    return state.gateway_code_cm;
  },
  is_unsub_cm: function is_unsub_cm(state) {
    return state.is_unsub;
  }
};

var actions = {
  fetchLocale_cm: function fetchLocale_cm(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchTranslateButton_cm: function fetchTranslateButton_cm(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_cm: function fetchAllSubcategory_cm(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPageHotPicks_cm: function fetchPageHotPicks_cm(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              // console.log(response.data.data);

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPagePopular_cm: function fetchPagePopular_cm(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 4:
              response = _context5.sent;


              response.data.data.sort(function (a, b) {
                return (
                  // a.content_name.localeCompare(b.content_name),
                  b.rating - a.rating
                );
              });

              commit("setPagePopular", response.data.data);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchToken_cm: function fetchToken_cm(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_cm");
              userProfile = localStorage.getItem("userProfile_cm");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_cm", auth);
                // console.log(check)
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 19;
                break;
              }

              localStorage.setItem("userToken_cm", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 24;
              break;

            case 19:
              _context6.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userToken_cm", data.code);
                localStorage.setItem("userProfile_cm", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context6.next = 27;
              break;

            case 26:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getDomain_cm: function getDomain_cm(_ref11, host) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context7.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }
              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkToken_cm: function checkToken_cm(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subContent_cm: function subContent_cm(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userToken_cm");
              lang = localStorage.getItem("lang_cm");
              alert_pop = "";
              alert_lang = __webpack_require__(162)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != 'application/x-zip-compressed') {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_cm,
                    product: 'cutemobi',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_cm,
                    product: 'cutemobi',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  login_cm: function login_cm(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchNotification_cm: function fetchNotification_cm(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, date, w, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              _context11.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=" + host);

            case 6:
              res = _context11.sent;
              data = res.data.data;
              noti = data.map(function (noti) {
                noti.titleSub_english = noti.subcategory;
                if (noti.subcategory_translate != null) {
                  var sub_trans = JSON.parse(noti.subcategory_translate);
                  if (sub_trans != null) {
                    var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                    if (sub_trans != null || sub_icon != null) {
                      for (var i = 0; i < trans_len; i++) {
                        noti['titleSub_' + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                      }
                    }
                  }
                }
                return noti;
              });

              // if(w == 0){
              //   //name ascending
              //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
              // }else{
              //   //name descending
              //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
              // }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_cm: function logout_cm(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_cm");
                localStorage.removeItem("userToken_cm");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              if (!(is_unsub != '0')) {
                _context12.next = 13;
                break;
              }

              token = localStorage.getItem("userToken_cm");
              _context12.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_code_cm + "/" + state.gateway_code_cm + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_cm));

            case 5:
              responses = _context12.sent;

              removeStorage();
              console.log(responses.data);
              response = JSON.parse(responses.data.contents);

              __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.country_cm == 'iq') {
                  __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              }
              _context12.next = 15;
              break;

            case 13:
              removeStorage();
              if (state.country_cm == 'iq') {
                __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
                __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_cutemobi__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
              }

            case 15:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

var mutations = {
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_cm = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_cm = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_cm = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_cm = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_cm = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_cm = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_cm = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_cm = response.next_renew_date, state.subscription_date_cm = response.subscription_date, state.msisdn_cm = response.msisdn, state.country_code_cm = response.country_code, state.gateway_code_cm = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_cm = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2509 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkYzODQ5O30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE2OS40LDQ3OS40YzQuNywyLjUsOS42LTIuOSw2LjgtNy40Yy0xNS42LTI0LjMtMzAuMy02NS4xLTYuOC0xMTcuNmMzOS4yLTg3LjYsNjMuMS0xMzMsNjMuMS0xMzMNCgkJCXMxMi43LDUzLDQ3LjEsMTAwLjFjMzMuMSw0NS4zLDUxLjIsMTAyLjMsMjIsMTQ5LjhjLTIuNyw0LjUsMi4xLDkuNyw2LjgsNy4zYzM2LjItMTguNSw3Ni43LTU1LjYsODEuMy0xMjkuNA0KCQkJYzEuNy0yMi42LTAuOC01NC4xLTEzLjUtOTRjLTE2LjMtNTAuNS0zNi4zLTc0LjEtNDcuOC04NC4yYy0zLjUtMy04LjgtMC4zLTguNiw0LjJjMy40LDU0LjUtMTcuMSw2OC4zLTI4LjgsMzcuMg0KCQkJYy00LjctMTIuNS03LjQtMzQtNy40LTYwLjJjMC00My43LTEyLjctODguNi00MC42LTEyNS4xYy03LjMtOS41LTE1LjgtMTguNC0yNS41LTI1LjljLTMuNS0yLjctOC42LDAtOC4zLDQuNQ0KCQkJYzIuMSwyOS42LDAuMiwxMTQuNC03NC4yLDIxNS44Yy02Ny41LDk0LTQxLjMsMTY2LjItMzIuMSwxODUuN0MxMjAuNSw0NDQuNSwxNDUuMyw0NjYuNSwxNjkuNCw0NzkuNHoiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2510 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRTdGRjA1O30NCgkuc3Qxe2ZpbGw6I0ZGMDAwMDt9DQoJLnN0MntmaWxsOiM1NDU0NTQ7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik00NDUuNyw5MWgtMTQ3Yy0xOSwwLTM0LjMsMTUuNC0zNC4zLDM0LjNjMCwxOSwxNS40LDM0LjMsMzQuMywzNC4zaDY0LjJMMjE2LjIsMzA2LjJsLTc5LjctNzkuNw0KCQljLTEzLjQtMTMuNC0zNS4xLTEzLjQtNDguNSwwbC03OCw3OGMtMTMuNCwxMy40LTEzLjQsMzUuMSwwLDQ4LjVjMTMuNCwxMy40LDM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzkNCgkJYzYuNCw2LjQsMTUuMiwxMC4xLDI0LjMsMTAuMWM5LjEsMCwxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjMNCgkJdi0xNDdDNDgwLDEwNi4zLDQ2NC42LDkxLDQ0NS43LDkxeiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_cutehub__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);












var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);

var brwlang = localStorage.getItem("lang_cutehub");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //allsubcategory
  allsubcategory_cutehub: {},
  //auth
  auth_cutehub: "",
  //main.vue
  //hotpicks.vue
  pageHP_cutehub: {},
  //popular.vue
  pagePop_cutehub: {},
  //notification.vue
  notification_cutehub: {},
  //icon
  hotpickIcon_cutehub: __webpack_require__(2512),
  popularIcon_cutehub: __webpack_require__(2513),
  langButton_cutehub: "",
  country_cutehub: parts[0],
  host_cutehub: host,
  // lang_cutehub: localStorage.getItem("lang_cutehub"),
  lang_cutehub: brwlang,
  type: 'browse',
  gcid_cutehub: gcid,
  hpisLoad_cutehub: false,
  renew_date_cutehub: '',
  subscription_date_cutehub: '',
  msisdn_cutehub: '',
  country_code_cutehub: '',
  gateway_code_cutehub: '',
  is_unsub: '0'
};

var getters = {
  langButton_cutehub: function langButton_cutehub(state) {
    return state.langButton_cutehub;
  },
  lang_cutehub: function lang_cutehub(state) {
    return state.lang_cutehub;
  },
  gcid_cutehub: function gcid_cutehub(state) {
    return state.gcid_cutehub;
  },
  country_cutehub: function country_cutehub(state) {
    return state.country_cutehub;
  },
  allSubcategory_cutehub: function allSubcategory_cutehub(state) {
    return state.allsubcategory_cutehub;
  },
  pageHotPicks_cutehub: function pageHotPicks_cutehub(state) {
    return state.pageHP_cutehub;
  },
  pagePopular_cutehub: function pagePopular_cutehub(state) {
    return state.pagePop_cutehub;
  },
  HotPickIcon_cutehub: function HotPickIcon_cutehub(state) {
    return state.hotpickIcon_cutehub;
  },
  PopularIcon_cutehub: function PopularIcon_cutehub(state) {
    return state.popularIcon_cutehub;
  },
  notification_cutehub: function notification_cutehub(state) {
    return state.notification_cutehub;
  },
  host_cutehub: function host_cutehub(state) {
    return state.host_cutehub;
  },
  auth_cutehub: function auth_cutehub(state) {
    return state.auth_cutehub;
  },
  hpisLoad_cutehub: function hpisLoad_cutehub(state) {
    return state.hpisLoad_cutehub;
  },
  renew_date_cutehub: function renew_date_cutehub(state) {
    return state.renew_date_cutehub;
  },
  subscription_date_cutehub: function subscription_date_cutehub(state) {
    return state.subscription_date_cutehub;
  },
  msisdn_cutehub: function msisdn_cutehub(state) {
    return state.msisdn_cutehub;
  },
  country_code_cutehub: function country_code_cutehub(state) {
    return state.country_code_cutehub;
  },
  gateway_code_cutehub: function gateway_code_cutehub(state) {
    return state.gateway_code_cutehub;
  },
  is_unsub_cutehub: function is_unsub_cutehub(state) {
    return state.is_unsub;
  }
};

var actions = {
  fetchLocale_cutehub: function fetchLocale_cutehub(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchTranslateButton_cutehub: function fetchTranslateButton_cutehub(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_cutehub: function fetchAllSubcategory_cutehub(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;


              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPageHotPicks_cutehub: function fetchPageHotPicks_cutehub(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              // console.log(response.data.data);

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPagePopular_cutehub: function fetchPagePopular_cutehub(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 4:
              response = _context5.sent;


              response.data.data.sort(function (a, b) {
                return (
                  // a.content_name.localeCompare(b.content_name),
                  b.rating - a.rating
                );
              });

              commit("setPagePopular", response.data.data);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchToken_cutehub: function fetchToken_cutehub(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userToken_cutehub");
              userProfile = localStorage.getItem("userProfile_cutehub");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkToken_cutehub", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 29;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 17;
                break;
              }

              if (data.code == 'chub80') {
                localStorage.setItem("userToken_cutehub", data.code);
                commit("setAuth", "guest");
              } else {
                localStorage.setItem("userToken_cutehub", data.code);
                commit("setUserProfile", JSON.parse(userProfile));
                commit("setAuth", "loggedin");
              }
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 27;
              break;

            case 17:
              if (!(data.code == 'chub80')) {
                _context6.next = 22;
                break;
              }

              localStorage.setItem("userToken_cutehub", data.code);
              commit("setAuth", "guest");
              _context6.next = 27;
              break;

            case 22:
              _context6.next = 24;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 24:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);


              if (response.status == "active") {
                localStorage.setItem("userToken_cutehub", data.code);
                localStorage.setItem("userProfile_cutehub", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 27:
              _context6.next = 30;
              break;

            case 29:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 30:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getDomain_cutehub: function getDomain_cutehub(_ref11, host) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context7.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }
              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkToken_cutehub: function checkToken_cutehub(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subContent_cutehub: function subContent_cutehub(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userToken_cutehub");
              lang = localStorage.getItem("lang_cutehub");
              alert_pop = "";
              alert_lang = __webpack_require__(163)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;
              if (state.auth_cutehub == 'guest') {
                commit("setAuth", "");
                localStorage.removeItem("userToken_cutehub");
                __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              } else {
                if (token != null) {
                  if (file[1] != 'application/x-zip-compressed') {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                      token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                      country: state.country_cutehub,
                      product: 'cutehub',
                      content_id: file[2],
                      type: "download"
                    });
                    window.location.href = file[0];
                    // window.open(file[0], "download");
                  } else {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                      token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                      country: state.country_cutehub,
                      product: 'cutehub',
                      content_id: file[2],
                      type: "play"
                    });

                    window.open(file[0], "_blank");
                  }
                } else {
                  alert(alert_pop);

                  setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                  }, 1000);
                }
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  login_cutehub: function login_cutehub(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchNotification_cutehub: function fetchNotification_cutehub(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, date, w, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              _context11.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/cutemobi_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=" + host);

            case 6:
              res = _context11.sent;
              data = res.data.data;
              noti = data.map(function (noti) {
                noti.titleSub_english = noti.subcategory;
                if (noti.subcategory_translate != null) {
                  var sub_trans = JSON.parse(noti.subcategory_translate);
                  if (sub_trans != null) {
                    var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                    var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                    if (sub_trans != null || sub_icon != null) {
                      for (var i = 0; i < trans_len; i++) {
                        noti['titleSub_' + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                      }
                    }
                  }
                }
                return noti;
              });

              // if(w == 0){
              //   //name ascending
              //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
              // }else{
              //   //name descending
              //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
              // }

              notify = noti.slice(5, 10);

              commit("setNotification", notify);

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_cutehub: function logout_cutehub(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_cutehub");
                localStorage.removeItem("userToken_cutehub");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              if (!(is_unsub != '0')) {
                _context12.next = 13;
                break;
              }

              token = localStorage.getItem("userToken_cutehub");
              _context12.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_code_cutehub + "/" + state.gateway_code_cutehub + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_cutehub));

            case 5:
              responses = _context12.sent;

              removeStorage();
              response = JSON.parse(responses.data.contents);

              console.log(responses.data);
              __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.country_cutehub == 'iq') {
                  __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              }
              _context12.next = 15;
              break;

            case 13:
              removeStorage();
              if (state.country_cutehub == 'iq') {
                __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#exampleModalCenter").modal("hide");
                __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_cutehub__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
              }

            case 15:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

var mutations = {
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.pageHP_cutehub = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.pagePop_cutehub = response;
  },
  setNotification: function setNotification(state, response) {
    return state.notification_cutehub = response;
  },
  setAuth: function setAuth(state, response) {
    return state.auth_cutehub = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_cutehub = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_cutehub = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_cutehub = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_cutehub = response.next_renew_date, state.subscription_date_cutehub = response.subscription_date, state.msisdn_cutehub = response.msisdn, state.country_code_cutehub = response.country_code, state.gateway_code_cutehub = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_cutehub = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2512 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRUQyMTVFO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE2OS40LDQ3OS40YzQuNywyLjUsOS42LTIuOSw2LjgtNy40Yy0xNS42LTI0LjMtMzAuMy02NS4xLTYuOC0xMTcuNmMzOS4yLTg3LjYsNjMuMS0xMzMsNjMuMS0xMzMNCgkJCXMxMi43LDUzLDQ3LjEsMTAwLjFjMzMuMSw0NS4zLDUxLjIsMTAyLjMsMjIsMTQ5LjhjLTIuNyw0LjUsMi4xLDkuNyw2LjgsNy4zYzM2LjItMTguNSw3Ni43LTU1LjYsODEuMy0xMjkuNA0KCQkJYzEuNy0yMi42LTAuOC01NC4xLTEzLjUtOTRjLTE2LjMtNTAuNS0zNi4zLTc0LjEtNDcuOC04NC4yYy0zLjUtMy04LjgtMC4zLTguNiw0LjJjMy40LDU0LjUtMTcuMSw2OC4zLTI4LjgsMzcuMg0KCQkJYy00LjctMTIuNS03LjQtMzQtNy40LTYwLjJjMC00My43LTEyLjctODguNi00MC42LTEyNS4xYy03LjMtOS41LTE1LjgtMTguNC0yNS41LTI1LjljLTMuNS0yLjctOC42LDAtOC4zLDQuNQ0KCQkJYzIuMSwyOS42LDAuMiwxMTQuNC03NC4yLDIxNS44Yy02Ny41LDk0LTQxLjMsMTY2LjItMzIuMSwxODUuN0MxMjAuNSw0NDQuNSwxNDUuMyw0NjYuNSwxNjkuNCw0NzkuNHoiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2513 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0ODAgNDgwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODAgNDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRUQyMTVFO30NCjwvc3R5bGU+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDQ1LjcsOTFoLTE0N2MtMTksMC0zNC4zLDE1LjQtMzQuMywzNC4zYzAsMTksMTUuNCwzNC4zLDM0LjMsMzQuM2g2NC4yTDIxNi4yLDMwNi4ybC03OS43LTc5LjcNCgkJYy0xMy40LTEzLjQtMzUuMS0xMy40LTQ4LjUsMGwtNzgsNzhjLTEzLjQsMTMuNC0xMy40LDM1LjEsMCw0OC41czM1LjEsMTMuNCw0OC41LDBsNTMuNy01My43TDE5MiwzNzljNi40LDYuNCwxNS4yLDEwLjEsMjQuMywxMC4xDQoJCXMxNy44LTMuNiwyNC4zLTEwLjFsMTcwLjktMTcwLjl2NjQuMmMwLDE4LjksMTUuNCwzNC4zLDM0LjMsMzQuM2MxOSwwLDM0LjMtMTUuNCwzNC4zLTM0LjN2LTE0N0M0ODAsMTA2LjMsNDY0LjYsOTEsNDQ1LjcsOTF6Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_apps4all__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);










var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);

var brwlang = localStorage.getItem("lang_a4all");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //auth
  langButton_a4all: "",
  country_a4all: parts[0],
  // lang_a4all: localStorage.getItem("lang_a4all"),
  lang_a4all: brwlang,
  authentication_a4all: "",
  Icon_hotpick_a4all: __webpack_require__(2515),
  Icon_popular_a4all: __webpack_require__(2516),
  //notification.vue
  notification_a4all: {},
  HotPicksPage_a4all: {},
  PopularPage_a4all: {},
  allsubcategory_a4all: {},
  host_a4all: host,
  gcid_a4all: gcid,
  renew_date_a4all: "",
  subscription_date_a4all: "",
  msisdn_a4all: "",
  country_name_a4all: "",
  gateway_a4all: "",
  is_unsub: "0",
  subcategory_id_a4all: "",
  app4all_res_sub: ''
};

var getters = {
  gcid_a4all: function gcid_a4all(state) {
    return state.gcid_a4all;
  },
  IconHotPick_a4all: function IconHotPick_a4all(state) {
    return state.Icon_hotpick_a4all;
  },
  IconPopular_a4all: function IconPopular_a4all(state) {
    return state.Icon_popular_a4all;
  },
  notification_a4all: function notification_a4all(state) {
    return state.notification_a4all;
  },
  authentication_a4all: function authentication_a4all(state) {
    return state.authentication_a4all;
  },
  HotPicksPage_a4all: function HotPicksPage_a4all(state) {
    return state.HotPicksPage_a4all;
  },
  PopularPage_a4all: function PopularPage_a4all(state) {
    return state.PopularPage_a4all;
  },
  langButton_a4all: function langButton_a4all(state) {
    return state.langButton_a4all;
  },
  allSubcategory_a4all: function allSubcategory_a4all(state) {
    return state.allsubcategory_a4all;
  },
  lang_a4all: function lang_a4all(state) {
    return state.lang_a4all;
  },
  country_a4all: function country_a4all(state) {
    return state.country_a4all;
  },
  host_a4all: function host_a4all(state) {
    return state.host_a4all;
  },
  renew_date_a4all: function renew_date_a4all(state) {
    return state.renew_date_a4all;
  },
  subscription_date_a4all: function subscription_date_a4all(state) {
    return state.subscription_date_a4all;
  },
  msisdn_a4all: function msisdn_a4all(state) {
    return state.msisdn_a4all;
  },
  country_name_a4all: function country_name_a4all(state) {
    return state.country_name_a4all;
  },
  gateway_a4all: function gateway_a4all(state) {
    return state.gateway_a4all;
  },
  is_unsub_a4all: function is_unsub_a4all(state) {
    return state.is_unsub;
  },
  subcategory_id_a4all: function subcategory_id_a4all(state) {
    return state.subcategory_id_a4all;
  },
  app4all_res_sub: function app4all_res_sub(state) {
    return state.app4all_res_sub;
  }
};

var actions = {
  fetchLanguage_a4all: function fetchLanguage_a4all(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchLanguageButton_a4all: function fetchLanguageButton_a4all(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  // <img lang="${value.language}" src="${value.flag_rec}" />
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n              \n              <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n              </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchAllSubcategory_a4all: function fetchAllSubcategory_a4all(_ref7, subcategory) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var subcateg;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=" + subcategory + "&limit=1&offset=0&domain=" + host);

            case 2:
              subcateg = _context3.sent;

              commit("setAllSubcategory", subcateg.data.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchHotPicksApp_a4all: function fetchHotPicksApp_a4all(_ref8, file) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data, limit, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              response = [];

              if (!(data == undefined)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/app4all_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=" + limit + "&offset=0&domain=" + host);

            case 7:
              response = _context4.sent;
              _context4.next = 13;
              break;

            case 10:
              _context4.next = 12;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/app4all_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 12:
              response = _context4.sent;

            case 13:

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              commit("setPageHotPicks", response.data.data);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchPopularApp_a4all: function fetchPopularApp_a4all(_ref9, e) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var limit, url, response, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              url = state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=application&limit=" + limit + "&offset=0&domain=" + host;
              _context5.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 5:
              response = _context5.sent;
              data = response.data.data;


              data.sort(function (a, b) {
                //to sort random
                return b.rating - a.rating;
              });
              commit("setPagePopular", data);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getDomain_a4all: function getDomain_a4all(_ref10, host) {
    var _this6 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context6.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != "0") commit("setGatewayID", dom[0].gateway_id);
              } else {
                domain = "0";
              }

              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  fetchTokenID_a4all: function fetchTokenID_a4all(_ref11, id) {
    var _this7 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userTokenID_a4all");
              userProfile = localStorage.getItem("userProfile_a4all");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join("/");

              if (path == "") {
                path = "/home";
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkTokenID_a4all", auth);
                auth = auth.toLowerCase();
                letterNumber = "^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$";

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context7.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context7.next = 19;
                break;
              }

              localStorage.setItem("userTokenID_a4all", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context7.next = 24;
              break;

            case 19:
              _context7.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context7.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userTokenID_a4all", data.code);
                localStorage.setItem("userProfile_a4all", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context7.next = 27;
              break;

            case 26:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 27:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  checkTokenID_a4all: function checkTokenID_a4all(_ref12, auth) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", true);

            case 5:
              return _context8.abrupt("return", false);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  subscribeContent_a4all: function subscribeContent_a4all(_ref13, file) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              token = localStorage.getItem("userTokenID_a4all");
              lang = localStorage.getItem("lang_a4all");
              alert_pop = "";
              alert_lang = __webpack_require__(164)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != "application/x-zip-compressed") {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_a4all,
                    product: 'apps4all',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_a4all,
                    product: 'apps4all',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  login_a4all: function login_a4all(_ref14, loginAuth) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fetchAppNotification_a4all: function fetchAppNotification_a4all(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var notify, date, w, url, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=application&subcategory=&limit=10&offset=" + date + "&domain=" + host;
              _context11.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 7:
              res = _context11.sent;
              data = res.data.data.slice(0, 5);
              noti = data.map(function (noti) {
                var sub_trans = JSON.parse(noti.subcategory_translate);
                // console.log(noti.created_time)
                var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                noti.titleSub_english = noti.subcategory;
                if (sub_trans != null || sub_icon != null) {
                  for (var i = 0; i < trans_len; i++) {
                    noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                  }
                }

                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.cont_name_english.localeCompare(b.cont_name_english);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.cont_name_english.localeCompare(a.cont_name_english);
                });
              }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 13:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  logout_a4all: function logout_a4all(_ref16, is_unsub) {
    var _this12 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var token, _lang, responses, response, removeStorage;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_a4all");
                localStorage.removeItem("userTokenID_a4all");
                localStorage.removeItem("logged-in");
              };

              if (!(is_unsub != "0")) {
                _context12.next = 11;
                break;
              }

              token = localStorage.getItem("userTokenID_a4all");
              _lang = localStorage.getItem("lang_a4all");
              _context12.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_a4all + "/" + state.gateway_a4all + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_a4all));

            case 6:
              responses = _context12.sent;
              response = JSON.parse(responses.data.contents);


              if (responses.data.contents == "success" || response.status == 'success') {

                if (state.gateway_a4all == 'mondiamedia') {
                  __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              } else if (response.status == 'fail') {
                if (state.gateway_a4all == 'mondiamedia' && state.gcid_a4all == '339') {

                  if (_lang == 'arabic') {
                    state.app4all_res_sub = response.ar_error_message;
                  } else {
                    state.app4all_res_sub = response.en_error_message;
                  }
                  __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
              }

              _context12.next = 13;
              break;

            case 11:
              removeStorage();
              __WEBPACK_IMPORTED_MODULE_8__router_apps4all__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});

            case 13:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  getSubCategory_a4all: function getSubCategory_a4all(_ref17, subcategory) {
    var _this13 = this;

    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit("setSubcategory", subcategory);

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  }
};

var mutations = {
  setNotification: function setNotification(state, response) {
    return state.notification_a4all = response;
  },
  setAuth: function setAuth(state, response) {
    return state.authentication_a4all = response;
  },
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.HotPicksPage_a4all = response;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.PopularPage_a4all = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_a4all = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_a4all = response;
  },
  setAllSubcategory: function setAllSubcategory(state, response) {
    return state.allsubcategory_a4all = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_a4all = response.next_renew_date, state.subscription_date_a4all = response.subscription_date, state.msisdn_a4all = response.msisdn, state.country_name_a4all = response.country_code, state.gateway_a4all = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_a4all = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  },
  setSubcategory: function setSubcategory(state, response) {
    return state.subcategory_id_a4all = response;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRjAzMUM7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTgwLjcsNTExLjNjNSwyLjcsMTAuMy0zLjEsNy4yLTcuOWMtMTYuNi0yNS45LTMyLjQtNjkuNC03LjMtMTI1LjVjNDEuOC05My41LDY3LjMtMTQxLjksNjcuMy0xNDEuOQ0KCQkJczEzLjUsNTYuNSw1MC4yLDEwNi43YzM1LjMsNDguMyw1NC42LDEwOS4yLDIzLjUsMTU5LjhjLTIuOSw0LjgsMi4yLDEwLjQsNy4yLDcuOGMzOC42LTE5LjcsODEuOC01OS4zLDg2LjctMTM4LjENCgkJCWMxLjgtMjQuMS0wLjktNTcuOC0xNC40LTEwMC4zYy0xNy40LTUzLjktMzguNy03OS01MS04OS44Yy0zLjctMy4yLTkuNC0wLjQtOS4xLDQuNWMzLjYsNTguMS0xOC4zLDcyLjktMzAuNywzOS42DQoJCQljLTUtMTMuMy03LjktMzYuMi03LjktNjQuMmMwLTQ2LjYtMTMuNS05NC41LTQzLjMtMTMzLjVjLTcuNy0xMC4xLTE2LjgtMTkuNi0yNy4yLTI3LjdjLTMuOC0yLjktOS4yLDAtOC45LDQuOA0KCQkJYzIuMywzMS42LDAuMiwxMjItNzkuMiwyMzAuMUM3MS44LDMzNiw5OS43LDQxMywxMDkuNiw0MzMuOEMxMjguNiw0NzQuMiwxNTQuOSw0OTcuNiwxODAuNyw1MTEuM3oiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkYwMzFDO30NCjwvc3R5bGU+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDk3LjMsMTEzLjdjLTEwLjQtNy45LTI0LjMtOS45LTM2LjQtNS4xTDMzOC40LDE0OGMtMC40LDAuMS0wLjgsMC4zLTEuMiwwLjRjLTEyLjMsNS4xLTIxLDE2LjUtMjIuNywyOS43DQoJCXMzLjgsMjYuNCwxNC40LDM0LjVsOS42LDcuM2wtMzQuNCwzNS45bC05OC40LTEwOC4zQzE5NCwxMzMuNywxNzcsMTI2LDE1OC44LDEyNi40cy0zNSw5LTQ2LjEsMjMuNkwxMi4xLDI4NC4xDQoJCWMtOS42LDEyLjctMTMuNywyOC4zLTExLjYsNDQuMWMyLjIsMTUuOCwxMC4zLDI5LjgsMjMsMzkuNGMxMC44LDguMiwyMy40LDEyLjEsMzYsMTIuMWMxOCwwLDM1LjgtOC4xLDQ3LjUtMjMuNWwwLjEtMC4xbDU1LjktNzQuOQ0KCQlsOTQuNSwxMDMuN2MxMS4yLDEzLjIsMjcuNSwyMC45LDQ0LjgsMjEuMWgwLjZjMTcuMSwwLDMzLjMtNy4zLDQ0LjYtMjAuMWw4Ni4xLTkzbDE0LjcsMTEuMmM2LDQuNiwxMy4yLDcuMywyMC44LDcuNg0KCQljNS41LDAuMywxMS4xLTAuNywxNi4yLTIuOGMxMi4zLTUuMSwyMS0xNi41LDIyLjctMjkuN2MwLjEtMC41LDAuMS0xLDAuMS0xLjVsMy42LTEzMC4zQzUxMy4yLDEzNC40LDUwNy43LDEyMS42LDQ5Ny4zLDExMy43eiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_playmix__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fs__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fs__);











var host = window.location.host;
var parts = host.split(".");
var currentDate = new Date();

var lang = window.navigator.userLanguage || window.navigator.language;
var language = lang.substring(0, 2);
var brwlang = localStorage.getItem("lang_playmix");

if (language == 'ms') {
  brwlang = 'malay';
} else if (language == 'ar') {
  brwlang = 'arabic';
} else if (language == 'el') {
  brwlang = 'greek';
} else if (language == 'bg' || parts[0] == 'bg') {
  brwlang = 'bulgarian';
} else if (language == 'no' || parts[0] == 'no') {
  brwlang = 'norwegian';
} else if (language == 'id') {
  brwlang = 'indonesian';
} else if (language == 'th') {
  brwlang = 'thai';
} else if (language == 'cs' || parts[0] == 'cz') {
  brwlang = 'czech';
} else if (language == 'en') {
  brwlang = 'english';
}

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

var res = Number(parts[1]);
var type = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(res);
var gcid = '';

if (type == true) {
  gcid = parts[1];
} else {
  gcid = '';
}

var state = {
  live: "http://cook.grabmobi.com",
  local: "http://[::1]/PuretechGlobalContentPortal",
  proxyurl: "http://api.allorigins.win/get?url=",
  //auth
  langButton_playmix: "",
  country_playmix: parts[0],
  // lang_playmix: brwlang,
  lang_playmix: localStorage.getItem("lang_playmix"),
  authentication_playmix: "",
  IconHotpick_playmix: __webpack_require__(220),
  IconPopular_playmix: __webpack_require__(221),
  homeSliderContentPlaymix: false,
  //notification.vue
  notification_playmix: {},
  HotPicksPage_playmix: {},
  HotPicksPageLoad_playmix: false,
  PopularPage_playmix: {},
  subCate_playmix: {},
  allData_playmix: {},
  host_playmix: host,
  gcid_playmix: gcid,
  renew_date_playmix: '',
  subscription_date_playmix: '',
  msisdn_playmix: '',
  country_name_playmix: '',
  gateway_playmix: '',
  is_unsub: '0',
  hpisLoad_playmix: false
};

var getters = {
  subCate_playmix: function subCate_playmix(state) {
    return state.subCate_playmix;
  },
  allData_playmix: function allData_playmix(state) {
    return state.allData_playmix;
  },
  IconHotpick_playmix: function IconHotpick_playmix(state) {
    return state.IconHotpick_playmix;
  },
  IconPopular_playmix: function IconPopular_playmix(state) {
    return state.IconPopular_playmix;
  },
  notification_playmix: function notification_playmix(state) {
    return state.notification_playmix;
  },
  authentication_playmix: function authentication_playmix(state) {
    return state.authentication_playmix;
  },
  HotPicksPage_playmix: function HotPicksPage_playmix(state) {
    return state.HotPicksPage_playmix;
  },
  HotPicksPageLoad_playmix: function HotPicksPageLoad_playmix(state) {
    return state.HotPicksPageLoad_playmix;
  },
  PopularPage_playmix: function PopularPage_playmix(state) {
    return state.PopularPage_playmix;
  },
  langButton_playmix: function langButton_playmix(state) {
    return state.langButton_playmix;
  },
  lang_playmix: function lang_playmix(state) {
    return state.lang_playmix;
  },
  country_playmix: function country_playmix(state) {
    return state.country_playmix;
  },
  host_playmix: function host_playmix(state) {
    return state.host_playmix;
  },
  homeSliderContentPlaymix: function homeSliderContentPlaymix(state) {
    return state.homeSliderContentPlaymix;
  },
  hpisLoad_playmix: function hpisLoad_playmix(state) {
    return state.hpisLoad_playmix;
  },
  gcid_playmix: function gcid_playmix(state) {
    return state.gcid_playmix;
  },
  renew_date_playmix: function renew_date_playmix(state) {
    return state.renew_date_playmix;
  },
  subscription_date_playmix: function subscription_date_playmix(state) {
    return state.subscription_date_playmix;
  },
  msisdn_playmix: function msisdn_playmix(state) {
    return state.msisdn_playmix;
  },
  country_name_playmix: function country_name_playmix(state) {
    return state.country_name_playmix;
  },
  gateway_playmix: function gateway_playmix(state) {
    return state.gateway_playmix;
  },
  is_unsub_playmix: function is_unsub_playmix(state) {
    return state.is_unsub;
  }
};

var actions = {
  fetchLang_playmix: function fetchLang_playmix(_ref, lang) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];

                if (lang == value.language) {
                  lang = value.language;
                } else {
                  //english
                  lang = lang;
                }
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 11:
              _context.prev = 11;
              _context.prev = 12;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 14:
              _context.prev = 14;

              if (!_didIteratorError) {
                _context.next = 17;
                break;
              }

              throw _iteratorError;

            case 17:
              return _context.finish(14);

            case 18:
              return _context.finish(11);

            case 19:
              commit("setLanguage", lang);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchLangButton_playmix: function fetchLangButton_playmix(_ref4, country) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, key, value, button;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 3;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_9__locales_country_list_json___default.a)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _ref5 = _step2.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                key = _ref6[0];
                value = _ref6[1];

                if (country == key) {
                  button = "<button id=\"lang2\" lang=\"" + value.language + "\" class=\"mobiBtn sm\">\n        <img lang=\"" + value.language + "\" src=\"" + value.flag_rec + "\" />\n        <span lang=\"" + value.language + "\">" + value.button_text + "</span>\n        </button>";


                  commit("setButton", button);
                }
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 11:
              _context2.prev = 11;
              _context2.prev = 12;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 14:
              _context2.prev = 14;

              if (!_didIteratorError2) {
                _context2.next = 17;
                break;
              }

              throw _iteratorError2;

            case 17:
              return _context2.finish(14);

            case 18:
              return _context2.finish(11);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 7, 11, 19], [12,, 14, 18]]);
    }))();
  },
  fetchPageHotPicks_playmix: function fetchPageHotPicks_playmix(_ref7, file) {
    var _this3 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data, limit, response, load, hotpick;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = file[0];
              limit = 0;


              if (file[1] != undefined) {
                limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              state.HotPicksPageLoad_playmix = false;
              state.HotPicksPage_playmix = {};

              response = [];

              if (!(data == undefined)) {
                _context3.next = 12;
                break;
              }

              _context3.next = 9;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=video&limit=" + limit + "&offset=0&domain=" + host);

            case 9:
              response = _context3.sent;
              _context3.next = 15;
              break;

            case 12:
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=" + data + "&limit=" + limit + "&offset=0&domain=" + host);

            case 14:
              response = _context3.sent;

            case 15:
              load = true;

              response.data.data.sort(function (a, b) {
                return a.cont_name_english.localeCompare(b.cont_name_english);
              });

              hotpick = response.data.data;

              commit("setPageHotPicks", { hotpick: hotpick, load: load });

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fetchPagePopular_playmix: function fetchPagePopular_playmix(_ref8, e) {
    var _this4 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var limit, url, response, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              limit = 0;


              if (e != undefined) {
                limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
              } else {
                //default
                limit = 200;
              }

              url = state.live + "/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=video&limit=" + limit + "&offset=0&domain=" + host;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 5:
              response = _context4.sent;
              data = response.data.data;


              data.sort(function (a, b) {
                //to sort random
                return b.rating - a.rating;
              });

              commit("setPagePopular", data);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDomain_playmix: function getDomain_playmix(_ref9, host) {
    var _this5 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response, dom, domain;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(state.live + "/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6");

            case 2:
              response = _context5.sent;
              dom = response.data.data;

              dom = dom.filter(function (item) {
                return item.domain == host;
              });

              domain = "";


              if (dom != "") {
                domain = dom[0].is_unsub;

                if (dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id);
              } else {
                domain = '0';
              }

              commit("setUnsubButton", domain);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  fetchTokenID_playmix: function fetchTokenID_playmix(_ref10, id) {
    var _this6 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var auth, check, token, userProfile, str, path, letterNumber, data, responses, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              auth = "";
              check = "";
              token = localStorage.getItem("userTokenID_playmix");
              userProfile = localStorage.getItem("userProfile_playmix");
              str = window.location.pathname;
              path = str.split("/");

              path.pop();
              path = path.join('/');

              if (path == '') {
                path = '/home';
              }

              if (token != null) {
                //checking if have token
                auth = token;
              } else {
                //checking if have param id
                auth = id;
              }

              if (auth != undefined) {
                //to check if token has numbers and letters
                // check = dispatch("checkTokenID_playmix", auth);
                auth = auth.toLowerCase();
                letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';

                if (auth.match(letterNumber)) {
                  check = true;
                } else {
                  check = false;
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

              if (!(check == true)) {
                _context6.next = 26;
                break;
              }

              //if check is true
              data = {
                code: auth,
                verbose: "1"
              };

              if (!(token != null)) {
                _context6.next = 19;
                break;
              }

              localStorage.setItem("userTokenID_playmix", data.code);
              commit("setUserProfile", JSON.parse(userProfile));
              commit("setAuth", "loggedin");
              // EventBus.$emit("logged-in", "loggedin");
              _context6.next = 24;
              break;

            case 19:
              _context6.next = 21;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://gateway.puretechglobal.net/gateway_request/api/sub/?code=" + data.code + "&verbose=" + data.verbose));

            case 21:
              responses = _context6.sent;
              response = JSON.parse(responses.data.contents);

              if (response.status == "active") {
                localStorage.setItem("userTokenID_playmix", data.code);
                localStorage.setItem("userProfile_playmix", responses.data.contents);
                commit("setUserProfile", response);
                commit("setAuth", "loggedin");
                __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ path: path }).catch(function (err) {});
                // location.reload();
              } else if (response.status == "inactive") {
                if (data.code != undefined) {
                  alert(response.status.toUpperCase());
                }
                __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
              }

            case 24:
              _context6.next = 27;
              break;

            case 26:
              //if check is false
              __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  checkTokenID_playmix: function checkTokenID_playmix(_ref11, auth) {
    var _this7 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var letterNumber;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              letterNumber = /^[0-9a-zA-Z]+$/;

              if (!auth.match(letterNumber)) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return", true);

            case 5:
              return _context7.abrupt("return", false);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  subscribeContent_playmix: function subscribeContent_playmix(_ref12, file) {
    var _this8 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var token, lang, alert_pop, alert_lang;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              token = localStorage.getItem("userTokenID_playmix");
              lang = localStorage.getItem("lang_playmix");
              alert_pop = "";
              alert_lang = __webpack_require__(219)("./" + lang + ".json");

              alert_pop = alert_lang.not_subs;

              if (token != null) {
                if (file[1] != "application/x-zip-compressed") {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_playmix,
                    product: 'playmix',
                    content_id: file[2],
                    type: "download"
                  });
                  window.location.href = file[0];
                  // window.open(file[0], "download");
                } else {
                  __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(state.live + "/api/newcontents_statistic", {
                    token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                    country: state.country_playmix,
                    product: 'playmix',
                    content_id: file[2],
                    type: "play"
                  });

                  window.open(file[0], "_blank");
                }
              } else {
                alert(alert_pop);

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: "Login" }).catch(function (err) {});
                }, 1000);
              }

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  login_playmix: function login_playmix(_ref13, loginAuth) {
    var _this9 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit("setAuth", loginAuth);

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  fetchNotification_playmix: function fetchNotification_playmix(_ref14) {
    var _this10 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var notify, date, w, url, res, data, noti;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              notify = [];
              date = currentDate.getUTCDate();
              w = week % 2;


              if (w != 0) {
                date = date + 10;
              }

              url = state.live + "/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=&limit=10&offset=" + date + "&domain=" + host;
              _context10.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url);

            case 7:
              res = _context10.sent;
              data = res.data.data.slice(0, 5);
              noti = data.map(function (noti) {
                var sub_trans = JSON.parse(noti.subcategory_translate);

                if (sub_trans != null) {
                  // console.log(noti.created_time)
                  var trans_len = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans).length;
                  var trans_arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sub_trans);

                  noti.titleSub_english = noti.subcategory;
                  if (sub_trans != null || sub_icon != null) {
                    for (var i = 0; i < trans_len; i++) {
                      noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
                    }
                  }
                }

                return noti;
              });


              if (w == 0) {
                //name ascending
                noti.sort(function (a, b) {
                  return a.cont_name_english.localeCompare(b.cont_name_english);
                });
              } else {
                //name descending
                noti.sort(function (a, b) {
                  return b.cont_name_english.localeCompare(a.cont_name_english);
                });
              }

              notify = noti.slice(0, 5);

              commit("setNotification", notify);

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  logout_playmix: function logout_playmix(_ref15, is_unsub) {
    var _this11 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var token, responses, response, removeStorage;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              removeStorage = function removeStorage() {
                localStorage.removeItem("userProfile_playmix");
                localStorage.removeItem("userTokenID_playmix");
                localStorage.removeItem("logged-in");
                commit("setAuth", "");
              };

              if (!(is_unsub != '0')) {
                _context11.next = 11;
                break;
              }

              token = localStorage.getItem("userTokenID_playmix");
              _context11.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("" + state.proxyurl + encodeURIComponent("http://api.puretechglobal.net/gateway_request/" + state.country_name_playmix + "/" + state.gateway_playmix + "/unsub.php?code=" + token + "&msisdn=" + state.msisdn_playmix));

            case 5:
              responses = _context11.sent;

              removeStorage();
              response = JSON.parse(responses.data.contents);

              if (responses.data.contents == 'success' || response.status == 'success') {
                if (state.gateway_playmix == 'mondiamedia') {
                  __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: 'Unsubscription' }).catch(function (err) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});
                }
              }
              _context11.next = 13;
              break;

            case 11:
              removeStorage();
              __WEBPACK_IMPORTED_MODULE_8__router_playmix__["a" /* default */].push({ name: 'Login' }).catch(function (err) {});

            case 13:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }
};

var mutations = {
  setNotification: function setNotification(state, response) {
    return state.notification_playmix = response;
  },
  setAuth: function setAuth(state, response) {
    return state.authentication_playmix = response;
  },
  setPageHotPicks: function setPageHotPicks(state, response) {
    return state.HotPicksPage_playmix = response.hotpick, state.HotPicksPageLoad_playmix = response.load;
  },
  setPagePopular: function setPagePopular(state, response) {
    return state.PopularPage_playmix = response;
  },
  setButton: function setButton(state, response) {
    return state.langButton_playmix = response;
  },
  setLanguage: function setLanguage(state, response) {
    return state.lang_playmix = response;
  },
  setUserProfile: function setUserProfile(state, response) {
    return state.renew_date_playmix = response.next_renew_date, state.subscription_date_playmix = response.subscription_date, state.msisdn_playmix = response.msisdn, state.country_name_playmix = response.country_code, state.gateway_playmix = response.gateway_code;
  },
  setGatewayID: function setGatewayID(state, response) {
    return state.gcid_playmix = response;
  },
  setUnsubButton: function setUnsubButton(state, response) {
    return state.is_unsub = response;
  }

};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA8CAYAAADWibxkAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjkyOThEODE2NTlFNDExRUE4RTYwQ0Q1QjFFOTgyNjBEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjkyOThEODE3NTlFNDExRUE4RTYwQ0Q1QjFFOTgyNjBEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OTI5OEQ4MTQ1OUU0MTFFQThFNjBDRDVCMUU5ODI2MEQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OTI5OEQ4MTU1OUU0MTFFQThFNjBDRDVCMUU5ODI2MEQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5PP55YAAALl0lEQVR42tRbCXRU1Rn+ZiY7mcQsRNCABBBEgbJINFAgslhqaqWUyogQCxJxQVsQeuppsXJE8aDFWhZpOSCbO3JaRWUNEpFalaMim5GUHQyQSCYZJmSZv997bxInmTcz72UmCv859+Qx7737/v+7/34vwGVC1wBJjwI/i+ScDocDUZcLAH8BHvFeborkvNbLQfj+QIffAn9yAvWRnjsiAFwPJMQAltYC4ElgNiePSwEyLjkAhgHXTaBt1reS8L8Gev0cuEe5HgRkR19KAFwNJL4OLN0KHCYA0hoATAPo+xCjXHcGbhyqKtwlQApy24A1tMsjca2k/tlApzrARWSlYRQBr0fKcSlRoMVz/RG4m+o/YRew92IEV78NYOsLpCrX9wITbfQvvvcHA3euBB6z/Jir3xvIdANnlRXZDPw7knPT0cUeA9YNp+fn392+q+87VgHzmoNAcK5I95qLUQ0ISYTf6vsh5fojqmEDI2eB/UkRNIFOQFoN1b6E36D6VwQCQBnUhHkNiYziHJcCk5MjDcCNXAna+oIMVTuBKXT8zRmhOdwVseyMCxlM6OaDIfJu5T06x65bgFVmfYARlUxTPvQp8A69cMwh4IPmTHClnDOB30QCgH8y7JsBgNpS2pE5wnxmiuRxc8QBSAPs5cAJ5WOHiTD/1gRi5gVgejgxlp4vmiZ1wAwAyqC5bKoATm4z6Y/MRAHx2me+19x0icn6gplq7qI+a58M9DTjHMYAt9GJXWdWa6iZt9IPXVXTglQ54rXAHOBvV9JU5hIPF5kyGh+pabYnmPKG823OcUX0jw0Ao0bmahYu44Df19JcjL73OPDw1WrdE1bJnBprUiarAd1XtNhmZtJbCQDDU/pYYLiR5++g4Ex550YA/HZtaXoRBYBBNYYPxZvkRQVsNPDAYNUdBC11Oy7T0ts24QKQSCvopJYoEQSgOxkzk1z4EtUx7U3gFaa2yXr3B9B/vQe8z1XrEiELjOptslgKCYBHYz6upRzRIea8D7xLYTv6/n4fkFsIFGZEuLrjd35qCjEDjiU9XGdJEAZ9AOxcAjxNxxjDrK3vQGA8AmlWR2KVmwv06UP4if9FllsHDxIuQrZ3b9Bvce5c2pLVpa5dcDIUMxmXJplNTFo8evQQeeklkfPnRZdqa0XWrxfp3TvYPHXD1XotND3gcISOmq8C838Q4WfMEHE6xRApz02ZEnCuncDa2NBhd2yRwzEy6EMKPPuYX4dkPiFBpH9/kTFjRMaNE8nLE7nhBpHY2NCCR0WJrFwpLaKZMwPOy4RsYpCMsz/V/+xfHY7gzrcra6Eab92vO9q2FZk7V+TQIX/m6upEiotFliwRycnxfzcxUSQ3V6SwUMKiSZN0eaPXOHujTkhkqLSdBj47CRyd6nAE922/YygPKPzQoSIlJcaY9HhEiopEFi4UWb5cuz56VCJCbrdIdrYujzuA1c0zuAeAPOUeS+eNdwarBpUXv+RDusIPGSJSVSWtRfX794h7WoG4pz8o9SXFoV/Yt0/EbtcDwXMPo4KvXJ+xYlTuvUxwfqEAQB2wXKeThbGkG6orfLt2IsePt5rwnhPHpLJbhrC8VUdV3yzxnDsb+sXnntPVgvPAoVu8OUiB1mxRy/nXgIW3N2jAfGDcMJ+EJEpD6i1dAFaskNakmldXSoUV4kznSOOIgtRu3vA9QBXlUl+soxU1NQHDYxVwpAhY4evPCMAztzf0Az4BylcCy9K9tT7Tj8z+ehuRvXoB+fmB7aaGrsfjCSuTs3bpBouSd7o5LnDYrbB20MqJusKNcGX3geumnrhwxzDI2VKfkEXW58wJ1Gm+hjXJpGgtqdPt+2UqqCxVu93AU8xUdVd/0SJ9taWKugscUtWrs7hGZovnu7KwtODiomdpBh2k6vpOUrNmmfZjtVuqBlyraoQzRTOP6idmNXMe9SIDBhjKOxo0oKGRkMIJnbzhvAlo+7Ge+icliZw6pe+0jpSI8woyFsvRBlL/5e7wbaGqUhOoUfXPS2WXFHHaNfNQzMQ9dbz/e6tWGQVgXqMJUGkt9Vrzwv48FambagXNaMgQoH17fbXtmAVr926a86jjfCePa72EivPktqKFOySJ8BQfgGffHq0dn5SM6LsmQSo5bxn/nRyN6PGT/d8bzSK8XTsjX4jx3ei4mtZb6UWnXgkfRtVfXZ3yMnGNyhFnAuVNgrhy+4grb7BUXtteXINuUO+bIiZR7hn3cbWtHDap/sODmjZw1Ly2SqrnzJa6T3cFfr+gwIgG/KPRBJgQ99EVumFYLCK7m6m1+wLjdIG4hvRTw5YzwybOVK/3TuSI9/61NfXihuQv2ibOaGhmlayZVt2uIuMTbNhgBICXb284IdJDbawG2d25kgVt165NW2VnSlH70jLNW8d4Y6fV2z+O1nJRi3KdHAVLarop7af9a8WszTufsvVcacKUcnLo2OjZysqCPWVvbIgwAfhJ0AmzsoCkpCY/WdpmwHpNR1VQLXW0NBbZlpQUxM2fh/j1b6PNri9g65dtrp82eBhsI25WbV3K+e9bB8E2KNfEBkMq0LdvqKcsjQ2RTLXzFYQ6dPD/LT4Bcc8uQf3Xh2Dr3ZMx+Qzc947XVi7KhpiHHtVicwvIkmhH/JubULf+DXVnMvpXd6pO0VxraACwdasxAOpCNSSvukp/pUbmcXjVtvQ0GafhV7p5fQ6erz6H1eTKN+HOnoToe6aEsYUdsidysdEEaGpBjUVtS4ViOCUNljTFAypo0PNdcOFHpS5dQjVDKxoB2AlsDx6TDXSsY2IQt3Qt4l5ciIQdH5uz2dYgxXEnJAS8zSz7jDSYAAufD6gPZ2LDPIVlyxmijkuCFK2109FfuKB7+yvgRK2iAYuACRuBwqDCV1b+sMzXMCk9cQL48EPgo4+0rrBZokYiPvB+zjHgG0X9o54B3j4AnH8BWGlTywIdcjpbR1Bldb79lsXqEeDrr7XWd3ExcPgwcOrU98Ar7fHly4F+/Uw0/KMCAsBAVf0Fv9ZDeYw4OxcDGyh8PkF4R3cPQGEyHFIAVAQqKdEEPEDIv/kGOHoUOH2a7FQHf/8Lsjt8OAt2Jl5jxxr7Zh1jm9ute4ucFP+POuaX/FDh1uqmjgMHtrCiqxKZNk0kM1PEZotM+3z27CZVYkAqY/2Rmqo7x3rgeUVevxMiecwI+UCt30uKAC3pAebnhytwdX2zc4LqGDlS6zgHo+3btRpGZ96J6oEyHQCURkyxzhkgdfX27jUn/HvvmRHUVUoDoRfY9i/gxaeAR1jojroZuJacdqPhbPd7Jz1dZPFirf2uR6NG6X6LhfruZO/ute4ZITrFR3SZXLPGuPAVFSJdu4rOYaoK+pz9DEEbXgYWPA4U3A0MpS1mpRD/QIkzw1P8FnoAXb6Ulvgrr2gqf/GiyJ49Ig5HQLCn+5xo0wXgNpYRuqXx5MnGAbj//ibv7gHeHQPc3I1JdZLJwxa+29hPA1M5X5WucBkZIp07aztNAYSny92R5OPkdQFox/yJPvu43wRZWSLV1aGFX7euyXtMNr67qdnWeDj0SwbDQ8B/zPoThr7yoc2KPl0AlBLpY+AN3Ym2bAku/MGDImlpTd6ZBzwU6fSByUrsUuAxmlS5QQCc+erJnaYU8Jzgk4G2xEePDiz8uXN+fXmq/qa4VvyPFEy6O28GFnN1vwskPJ36jrwAh68CAsB8q71H6xL7T6q3k1taKjJ4cJPnlN3XHPV8ResT+e0wG7h/B/DqLmAXx8Z1wPwJwAh7kAUICIDipf7rcyDabzt71iyRTz7RQuPq1SLdu+t529G4xCnoUdk7gOygjdKG/EDn9xXAn3EZUFAAFL15G1ho1ttuApZYcHlQyMPSSgLC2LnNqPDM4hZe2YpO7wcHwHtKxF7IUjmE8OV/Bx7GZUaGAGjonDKOjiAQa8tYLlDgc4wS37Jq//wtprQjQ3WVL2EA/i/AAHw+81oB3VSjAAAAAElFTkSuQmCC"

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2523 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2526 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/prizeo-favicon.952b53e.png";

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fun2win-favicon.88f001d.png";

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Apps4all-favicon.27be6f4.png";

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })
],[883]);


// WEBPACK FOOTER //
// static/js/app.3a85601d5c6907cc80d5.js